// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/react-datepicker/dist/react-datepicker.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/react-resizable/css/styles.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/react-grid-layout/css/styles.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/good-times-rg.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/good-times-rg.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/Lato-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/FiraCode-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../medias/steel.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/src/medias/checked-square.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../medias/shield_green.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../medias/personal-hub-hangar-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../medias/personal-hub-blueprint-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../medias/personal-hub-blueprint-reputation-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../medias/shield_grey.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3Csvg viewBox=%270 0 16 16%27 fill=%27$light-grey%27 stroke=%27white%27 strokeWidth=%273%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpolyline points=%273,8 6,11 13,4%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../medias/close.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../medias/icon-label.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../medias/uee-banner-shaped.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../medias/pirate-banner-shaped.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../medias/sc-icon-door.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../medias/archive.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../images/icons/user.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../images/icons/pencil-fill.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../images/icons/trash3.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../images/icons/plus.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.glass-card, .glass-card2, .member-profile-card-popover {
  position: relative;
  backdrop-filter: blur(6px) saturate(33%);
  -webkit-backdrop-filter: blur(4px) saturate(33%);
  background-color: #23497748;
  border-radius: 10px;
  border: 1px solid rgba(51, 102, 126, 0.329);
  box-shadow: 3px 2px inset rgba(51, 102, 126, 0.229); }

* {
  user-select: none; }

body.allow-text-selection,
body.allow-text-selection * {
  user-select: text; }

body {
  background-attachment: fixed;
  margin: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 15px); }
  body::-webkit-scrollbar {
    width: 0px; }
  body::-webkit-scrollbar-track {
    background: #dfdfdf; }
  body::-webkit-scrollbar-thumb {
    background: #b8b8b8;
    border-radius: 4px; }
  body::-webkit-scrollbar-thumb:hover {
    background: #9e2222; }

.display-none {
  display: none; }

/* Shared segmented sub-tabs (admin, calendar event, …) */
.ui-subtabs {
  display: inline-flex;
  align-items: stretch;
  gap: 0;
  margin-top: 0.15rem;
  padding: 3px;
  border-radius: 999px;
  background: rgba(12, 38, 55, 0.92);
  border: 1px solid rgba(90, 195, 255, 0.22);
  max-width: 100%; }
  .ui-subtabs--wrap {
    flex-wrap: wrap;
    gap: 0.3rem;
    margin: 0.15rem 0 0.85rem; }

.ui-subtabs__btn {
  appearance: none;
  border: 0;
  margin: 0;
  cursor: pointer;
  background: transparent;
  color: #b8b8b8;
  font-family: inherit;
  font-size: 0.82rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  line-height: 1.2;
  padding: 0.45rem 0.95rem;
  border-radius: 999px;
  white-space: nowrap;
  transition: color 0.15s ease, background-color 0.15s ease; }
  .ui-subtabs__btn:hover {
    color: #dfdfdf;
    background: rgba(30, 48, 66, 0.55); }
  .ui-subtabs__btn:focus-visible {
    outline: 2px solid rgba(90, 195, 255, 0.65);
    outline-offset: 1px; }

.ui-subtabs__btn--active {
  color: #ffffff;
  background: #3a78b4; }
  .ui-subtabs__btn--active:hover {
    color: #ffffff;
    background: #3a78b4; }

.ui-subtabs__btn:disabled,
.ui-subtabs__btn--disabled {
  opacity: 0.42;
  cursor: not-allowed;
  color: #384858;
  background: transparent; }
  .ui-subtabs__btn:disabled:hover,
  .ui-subtabs__btn--disabled:hover {
    color: #384858;
    background: transparent; }

.ui-subtabs__btn--active:disabled,
.ui-subtabs__btn--active.ui-subtabs__btn--disabled {
  opacity: 0.55;
  color: rgba(255, 255, 255, 0.7);
  background: rgba(58, 120, 180, 0.45); }
  .ui-subtabs__btn--active:disabled:hover,
  .ui-subtabs__btn--active.ui-subtabs__btn--disabled:hover {
    color: rgba(255, 255, 255, 0.7);
    background: rgba(58, 120, 180, 0.45); }

/* Shared chips (admin + member profile card, etc.) */
.chips-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 10px;
  margin: 6px 0; }

.chip {
  display: inline-flex;
  align-items: center;
  border-radius: 10px;
  font-weight: 500;
  line-height: 1;
  transition: background-color 0.2s ease;
  font-size: medium;
  padding: 4px 8px 4px 8px; }
  .chip.chip-group {
    color: #b8b8b8;
    border: 2px solid #9b602a;
    background-color: transparent; }
    .chip.chip-group:hover {
      color: #dfdfdf;
      background-color: #6e441c; }
  .chip.chip-role {
    color: #b8b8b8;
    border: 2px solid #5ac3ff;
    background-color: transparent; }
    .chip.chip-role:hover {
      color: #dfdfdf;
      background-color: #00304d; }
  .chip .chip-remove {
    position: relative;
    cursor: pointer;
    font-weight: bold;
    background: #491212;
    color: #b8b8b8;
    border: 1px solid #491212;
    border-radius: 50%;
    width: 15px;
    height: 15px;
    text-align: center;
    align-content: center;
    font-size: 14px;
    margin: 0px 3px 0px 7px;
    line-height: 1;
    transition: color 0.2s ease; }
    .chip .chip-remove:hover {
      color: white; }

.warning-message {
  display: flex;
  color: #0c2637;
  background-color: #ffa600;
  padding: 5px 28px;
  margin: auto;
  border-radius: 6px; }

.root-error-boundary {
  color: red;
  padding: 20px; }

.maintenance-container {
  text-align: center;
  margin-top: 20%; }
  .maintenance-container .maintenance {
    position: relative;
    display: inline-block;
    padding: 20px 90px 20px 20px;
    background-color: #0c2637;
    color: #b8b8b8;
    text-decoration: none;
    border: 4px solid #b8b8b8;
    font-weight: bold;
    font-size: 1.5em;
    line-height: 1.4;
    text-align: left; }
    .maintenance-container .maintenance:before, .maintenance-container .maintenance:after {
      content: "";
      position: absolute;
      z-index: -1; }
    .maintenance-container .maintenance:before {
      top: 10px;
      left: 10px;
      width: 100%;
      height: 100%;
      background-color: #491212;
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1); }
    .maintenance-container .maintenance:after {
      bottom: 10px;
      right: 11px;
      width: 100%;
      height: 100%;
      background-color: #491212;
      box-shadow: 0 -5px 10px rgba(0, 0, 0, 0.1); }
    .maintenance-container .maintenance .svg-container {
      position: absolute;
      top: 24px;
      right: 10px;
      width: 55px;
      height: 52px;
      background-color: #b8b8b8;
      border: 2px solid #491212;
      display: flex;
      align-items: center;
      justify-content: center; }
      .maintenance-container .maintenance .svg-container svg {
        width: 40px;
        height: 40px; }

.emojis-images {
  height: 20px;
  width: auto; }

.colorPicker-logo-container {
  display: flex;
  flex-direction: row; }

.colorPicker-container {
  display: flex;
  flex-direction: column;
  gap: 10px; }
  .colorPicker-container.ribbons {
    flex-direction: row; }

.icon-container {
  width: 65px;
  height: 30px;
  overflow: hidden;
  position: relative;
  margin-bottom: 27px; }
  .icon-container .icon-image {
    width: 100%;
    height: 61px;
    object-fit: contain;
    position: relative;
    top: 0; }

.icon-rsi:hover .icon-image {
  top: -30px; }

.icon-discord:hover .icon-image,
.icon-kofi:hover .icon-image {
  top: -33px; }

.glass-card::after {
  content: "";
  position: absolute;
  top: 5px;
  /* Adjust the top value to match your design */
  bottom: 5px;
  /* Adjust the bottom value to match your design */
  left: 7px;
  right: 7px;
  border-left: 3px solid #2a3847;
  border-right: 3px solid #2a3847;
  border-radius: 5px;
  /* Adjust the radius to match the inner corners */
  pointer-events: none;
  /* Ensure the pseudo-element does not interfere with interactions */
  z-index: 1;
  /* Ensure the pseudo-element is below the content */ }

.glass-card .glass-card-content {
  position: relative;
  z-index: 2;
  /* Ensure the content is above the pseudo-element */ }

.content-container {
  width: 100%;
  position: relative;
  flex-grow: 1;
  margin-top: 54px;
  margin-left: auto;
  margin-right: auto; }
  .content-container.isLoggedIn {
    margin-top: 45px; }

.App {
  display: flex;
  flex-direction: column;
  min-height: 100vh; }

.custom-h1,
.custom-h2 {
  text-align: center;
  text-transform: uppercase;
  margin-top: 35px;
  margin-bottom: 30px;
  color: #dfdfdf; }

.custom-h3 {
  text-align: left;
  text-transform: uppercase;
  margin-top: 35px;
  margin-bottom: 30px;
  color: #b8b8b8; }

.p {
  font-size: 1rem;
  color: #dfdfdf; }

p {
  margin: 0; }

.main-content {
  padding-top: 70px; }

.no-margin {
  margin: 5px; }

.myCheckbox .form-check-input,
.discord-checkbox .form-check-input {
  position: absolute;
  opacity: 0;
  z-index: -1; }

.myCheckbox .form-check-label::before,
.discord-checkbox .form-check-label::before {
  content: "";
  display: inline-block;
  position: relative;
  width: 1rem;
  height: 1rem;
  margin-right: 0.5rem;
  border: 1px solid #0c2637;
  background: #dfdfdf;
  vertical-align: middle; }

.myCheckbox .form-check-input:checked ~ .form-check-label::after,
.discord-checkbox .form-check-input:checked ~ .form-check-label::after {
  content: "";
  position: absolute;
  width: 0.3rem;
  height: 0.6rem;
  border: solid #dfdfdf;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  top: 0.2rem;
  left: 0.35rem; }

.myCheckbox .form-check-input:checked ~ .form-check-label::before {
  background: #9e2222; }

.discord-checkbox .form-check-input:checked ~ .form-check-label::before {
  background: #5865f2;
  border-color: #5865f2; }

.input-field {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  /* Pour espacer les champs entre eux */ }

.input-field p.home-file {
  margin-right: 15px;
  /* Espace entre le label et le champ */
  margin-left: 10px;
  margin-top: 0px;
  min-width: 110px;
  /* Largeur minimale pour les labels */
  text-align: left;
  /* Alignement à droite du texte */ }

.input-field input,
.input-field textarea {
  flex: 1;
  /* Prend tout l'espace restant */ }

.btn-style1 {
  position: relative;
  cursor: pointer;
  font-size: 0.65em;
  font-weight: 800;
  text-transform: uppercase;
  color: #491212;
  padding: 0.4rem 0.8rem;
  border-radius: 6px;
  border: 1px solid #2a3847;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-color: rgba(0, 51, 128, 0.18);
  background-blend-mode: multiply;
  background-size: auto;
  box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.45);
  transition: all 0.15s ease-in-out; }
  .btn-style1:hover {
    color: #9e2222;
    background-color: rgba(0, 51, 128, 0.08);
    box-shadow: 0 0 6px 2px rgba(255, 0, 0, 0.2); }
  .btn-style1:active {
    transform: translateY(1px);
    box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.6); }
  .btn-style1[disabled] {
    background-image: none;
    background-color: #555;
    color: gray;
    box-shadow: none;
    cursor: default; }

.btn-style1.delete {
  border: 2px solid #491212; }
  .btn-style1.delete:hover {
    border: 2px solid #9e2222; }

.btn-style1.delete.red {
  background-color: #491212;
  color: #dfdfdf; }
  .btn-style1.delete.red:hover {
    background-color: #9e2222; }

.btn-style1.red {
  background-color: #491212;
  color: #dfdfdf; }
  .btn-style1.red:hover {
    background-color: #9e2222; }

.btn-style1.green {
  background-color: #75cf78;
  color: #dfdfdf; }
  .btn-style1.green:hover {
    background-color: #09a309; }

.btn-style1.blue {
  background-color: #163447;
  color: #dfdfdf; }
  .btn-style1.blue:hover {
    background-color: #204b66;
    border: 1px solid #3a78b4; }

.btn-style1.cancel:hover {
  border: 2px solid #2a3847; }

.btn-style1.confirm:hover {
  border: 2px solid #2e5999; }

.status-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
  margin-left: 5px;
  margin-right: 10px; }
  .status-indicator.active {
    background-color: #26bb26; }
  .status-indicator.inactive {
    background-color: #d12323; }

.button-group.admin.table .btn-style1.active {
  background-color: #ffffff;
  box-shadow: 0px 0px 5px 2px #465561ee;
  color: #9e2222; }

.button-group.admin.table.ranks {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px; }
  .button-group.admin.table.ranks .btn-style1 {
    margin: 0px;
    height: 30px; }
  .button-group.admin.table.ranks .first {
    width: 134px;
    border-radius: 6px 0 0 6px; }
  .button-group.admin.table.ranks .middle {
    width: 134px;
    border-radius: 0; }
  .button-group.admin.table.ranks .last {
    border-radius: 0 6px 6px 0; }

.button-group.admin.table.templates {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 15px auto 16px auto; }
  .button-group.admin.table.templates .btn-style1 {
    margin: 0px;
    height: 30px;
    width: 120px; }
  .button-group.admin.table.templates .first {
    border-radius: 6px 0 0 6px; }
  .button-group.admin.table.templates .middle {
    border-radius: 0; }
  .button-group.admin.table.templates .last {
    border-radius: 0 6px 6px 0; }

.button-group.admin.table.emojis {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0px; }
  .button-group.admin.table.emojis .btn-style1 {
    margin: 0;
    height: 30px;
    line-height: 1em;
    min-width: 155px; }
  .button-group.admin.table.emojis.line1 .first {
    border-radius: 6px 0 0 0; }
  .button-group.admin.table.emojis.line1 .middle {
    border-radius: 0; }
  .button-group.admin.table.emojis.line1 .last {
    border-radius: 0 6px 0 0; }
  .button-group.admin.table.emojis.line2 .first {
    border-radius: 0 0 0 6px; }
  .button-group.admin.table.emojis.line2 .middle {
    border-radius: 0; }
  .button-group.admin.table.emojis.line2 .last {
    border-radius: 0 0 6px 0; }

.button-group.admin.table.academy {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px; }
  .button-group.admin.table.academy .btn-style1 {
    margin: 0px;
    height: 30px; }
  .button-group.admin.table.academy .first {
    width: 150px;
    border-radius: 6px 0 0 6px; }
  .button-group.admin.table.academy .middle {
    width: 150px;
    border-radius: 0; }
  .button-group.admin.table.academy .last {
    width: 150px;
    border-radius: 0 6px 6px 0; }

.select-default {
  color: gray;
  /* Couleur différente pour la valeur par défaut */ }

.btn-style2 {
  position: relative;
  cursor: pointer;
  background-color: #164e89;
  background-blend-mode: multiply;
  /* Utiliser le mode de mélange pour mélanger les couleurs */
  font-size: 0.65em;
  font-weight: 800;
  text-transform: uppercase;
  color: #dfdfdf;
  height: max-content;
  padding: 0.4rem 0.8rem 0.4rem 0.8rem;
  vertical-align: top;
  margin: 5px 10px 5px auto;
  border: 1px solid #491212;
  border-radius: 10px; }
  .btn-style2.left {
    margin-left: 20px;
    margin-right: 10px; }
  .btn-style2:hover {
    background-color: #2769af;
    color: white;
    text-decoration: none; }
  .btn-style2:active {
    box-shadow: 0px 0px 5px 2px #2f3031ee; }
  .btn-style2[disabled] {
    cursor: default;
    background-image: none;
    background-color: #585d66;
    color: gray;
    box-shadow: none; }
    .btn-style2[disabled]:hover {
      background-color: none; }
    .btn-style2[disabled]:active {
      box-shadow: none; }

.error-spacer {
  height: 25px;
  opacity: 0; }

.message-error {
  margin-top: 5px;
  color: #d12323;
  height: 20px;
  opacity: 1; }

.margin-small-spacer {
  margin-top: 3vh; }

.margin-medium-spacer {
  margin-top: 7vh; }

.margin-large-spacer {
  margin-top: 12vh; }

.margin-top-spacer {
  margin-top: 40px; }

.margin-top-spacer-60 {
  margin-top: 60px; }

.margin-bottom-spacer {
  margin-bottom: 40px; }

.margin-bottom-spacer-60 {
  margin-bottom: 60px; }

.toggle {
  display: block;
  position: relative;
  width: 50px;
  height: 10px;
  bottom: 4px;
  color: #491212;
  text-transform: uppercase;
  font-weight: bolder; }
  .toggle input:not(.toggle-switch-field__input) {
    display: none; }
  .toggle input.toggle-switch-field__input {
    display: block; }
  .toggle .structure.division {
    transform: translateX(0px) translateY(5px); }
  .toggle.mfa {
    bottom: 10px; }
  .toggle.join-operation, .toggle.use-mumble {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: auto;
    bottom: 0;
    position: relative;
    text-transform: none;
    font-size: 14px;
    color: #dfdfdf;
    margin-bottom: 4px;
    margin-top: 3px;
    transform: translateX(0px) translateY(0px); }
    .toggle.join-operation .toggle-label, .toggle.use-mumble .toggle-label {
      font-weight: normal;
      font-size: 0.9rem;
      display: flex;
      width: auto;
      margin-right: 10px;
      flex: 1 1 auto; }
    .toggle.join-operation .toggle-switch, .toggle.use-mumble .toggle-switch {
      position: relative;
      top: auto;
      left: auto;
      right: 20px;
      bottom: auto;
      margin-left: auto; }
  .toggle.max-attendees-cap {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    height: auto;
    bottom: 0;
    position: relative;
    text-transform: none;
    font-size: 14px;
    color: #dfdfdf;
    margin-bottom: 4px;
    margin-top: 3px;
    transform: translateX(0px) translateY(0px); }
    .toggle.max-attendees-cap .toggle-switch {
      position: relative;
      top: auto;
      left: auto;
      right: 20px;
      bottom: auto;
      margin-left: auto; }
  .toggle.tentative {
    font-size: small;
    text-transform: none; }
    .toggle.tentative .toggle-label {
      position: relative;
      margin-left: 50px;
      top: 3px; }
    .toggle.tentative.active {
      color: #b8a500; }
    .toggle.tentative.inactive {
      color: #2a3847; }
  .toggle.collaboration-toggle {
    margin-left: 15px; }
  .toggle .toggle-label {
    margin-right: 10px;
    font-size: small; }

.toggle-switch-field {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  vertical-align: middle; }

.toggle-switch-field--disabled {
  cursor: not-allowed;
  opacity: 0.45;
  pointer-events: none; }

.toggle-switch-field__input {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
  opacity: 0; }

.toggle-switch {
  position: relative;
  display: inline-block;
  flex-shrink: 0;
  width: 30px;
  height: 13px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.14);
  transition: background 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease; }

.toggle-switch__thumb {
  position: absolute;
  top: 1px;
  left: 1px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);
  transition: transform 0.18s ease, background 0.18s ease; }

.toggle-switch-field--on .toggle-switch,
.toggle-switch-field__input:checked ~ .toggle-switch {
  background: rgba(46, 204, 113, 0.28);
  border-color: rgba(46, 204, 113, 0.45);
  box-shadow: 0 0 0 1px rgba(46, 204, 113, 0.12); }

.toggle-switch-field--on .toggle-switch__thumb,
.toggle-switch-field__input:checked ~ .toggle-switch .toggle-switch__thumb {
  transform: translateX(17px);
  background: #eefcf3; }

.toggle-switch-field__input:focus-visible ~ .toggle-switch {
  outline: 2px solid rgba(58, 120, 180, 0.85);
  outline-offset: 2px; }

.switch {
  position: relative;
  width: 50px;
  height: 20px; }
  .switch input {
    display: none; }
  .switch .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-color: #b8b8b8;
    background-blend-mode: multiply;
    transition: .4s;
    border-radius: 34px; }
    .switch .slider:before {
      position: absolute;
      content: "";
      height: 17px;
      width: 17px;
      left: 4px;
      bottom: 2px;
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
      transition: .4s;
      border-radius: 50%; }
  .switch input:checked + .slider {
    background-color: rgba(116, 5, 5, 0.8); }
    .switch input:checked + .slider:before {
      transform: translateX(26px); }
  .switch input:focus + .slider {
    box-shadow: 0 0 1px #491212; }

.tooltip,
.tooltip1 {
  width: fit-content;
  z-index: 2000;
  border: 1px solid #491212;
  box-shadow: 0 2px 10px rgba(101, 121, 133, 0.123); }

.tooltip {
  color: #dfdfdf;
  background-color: #1c2d38;
  border-radius: 8px;
  padding: 10px; }

.tooltip1 {
  color: #0c2637;
  font-weight: 700;
  background-color: #b8b8b8;
  border-radius: 6px;
  padding: 3px 10px; }

.delete-media {
  width: 24px;
  fill: none;
  stroke: #b8b8b8;
  margin-right: 10px;
  align-items: center;
  transform: translate(-2px, 1px); }
  .delete-media:hover {
    cursor: pointer;
    stroke: #491212;
    fill: #b8b8b8; }

.structure-logo {
  width: 28px;
  transform: translate(140px, -10px); }

.rank-logo {
  width: 28px;
  transform: translate(130px, -15px); }

.allied-logo {
  width: 28px;
  transform: translate(-35px, 5px); }

.add-picture-allied {
  position: relative;
  transform: translate(-35px, 5px); }
  .add-picture-allied path {
    width: 24px;
    fill: #2a3847;
    stroke: #b8b8b8; }
    .add-picture-allied path:hover {
      fill: #b8b8b8;
      stroke: #491212; }
  .add-picture-allied path:first-child {
    opacity: 0.8; }

.logo-size.extrasmall,
.insigna-size.extrasmall {
  width: auto;
  height: 21px;
  padding-left: 4px;
  padding-right: 4px; }

.logo-size.small,
.insigna-size.small {
  width: auto;
  height: 28px;
  padding-left: 7px;
  padding-right: 7px; }

.logo-size.medium,
.insigna-size.medium {
  width: auto;
  height: 100px;
  padding-left: 12px;
  padding-right: 12px; }

.logo-size.large,
.insigna-size.large {
  width: auto;
  height: 170px;
  padding-left: 20px;
  padding-right: 20px; }

.logo-size img,
.insigna-size img {
  width: 100%;
  height: auto;
  display: block; }

.add-picture-structure {
  position: relative;
  transform: translate(140px, -10px); }
  .add-picture-structure path {
    width: 24px;
    fill: #2a3847;
    stroke: #b8b8b8; }
    .add-picture-structure path:hover {
      fill: #b8b8b8;
      stroke: #491212; }
  .add-picture-structure path:first-child {
    opacity: 0.8; }

.add-picture-rank {
  position: relative;
  transform: translate(135px, -15px); }
  .add-picture-rank path {
    width: 24px;
    fill: #2a3847;
    stroke: #b8b8b8; }
    .add-picture-rank path:hover {
      fill: #b8b8b8;
      stroke: #491212; }
  .add-picture-rank path:first-child {
    opacity: 0.8; }

.input:disabled:disabled {
  cursor: default;
  color: #1c2d38;
  border-color: rgba(118, 118, 118, 0.3); }

.input.parent.dropdown:disabled:disabled {
  cursor: default;
  background-color: #b8b8b8;
  color: #1c2d38;
  border-color: rgba(118, 118, 118, 0.3); }

/* /src/styles/tools/syncfusion.scss */
.emoji-picker-wrapper {
  position: sticky;
  top: 75px;
  /* Ajustez en fonction de la hauteur de la barre d'outils */
  transform: translateX(-268px);
  width: fit-content;
  z-index: 100; }
  .emoji-picker-wrapper.calendar {
    position: fixed; }

.emoji-picker-wrapper.hidden {
  display: none; }

.emoji-picker-wrapper.visible {
  border-radius: 6px;
  top: 190px;
  transform: translateX(-250px);
  display: block; }

.emoji-picker-container {
  position: relative;
  border-radius: 6px;
  top: 25px;
  width: 200px;
  height: 600px;
  display: flex;
  flex-direction: column;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);
  background-color: #3d4955;
  z-index: 1050; }
  .emoji-picker-container .tabs {
    padding: 5px;
    background-color: #1c2d38;
    width: 190px;
    height: 110px;
    border-bottom: 1px solid #b8b8b8;
    border-radius: 6px 6px 0px 0px; }
    .emoji-picker-container .tabs .emojis-category {
      margin: 10px 4px 0px 4px;
      width: 30px;
      color: #b8b8b8;
      background-color: transparent;
      border-color: transparent;
      z-index: 1000; }
      .emoji-picker-container .tabs .emojis-category:hover {
        color: #ffffff; }
    .emoji-picker-container .tabs .emoji-searchBox {
      width: calc(100% - 30px);
      height: 22px; }
  .emoji-picker-container .emojis {
    padding: 13px;
    overflow-y: auto;
    flex-grow: 1;
    border-radius: 0px 0px 0px 6px; }
    .emoji-picker-container .emojis::-webkit-scrollbar {
      width: 8px; }
    .emoji-picker-container .emojis::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px; }
    .emoji-picker-container .emojis::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .emoji-picker-container .emojis::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
    .emoji-picker-container .emojis .emoji-img {
      width: 22px;
      margin: 5px;
      cursor: pointer; }
    .emoji-picker-container .emojis hr {
      border-color: #1c2d38; }

.line {
  display: flex;
  flex-direction: row;
  align-items: baseline; }

.limited {
  max-height: 45px;
  overflow: hidden; }
  .limited::-webkit-scrollbar {
    width: 6px; }
  .limited::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .limited::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .limited::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }

.flagged {
  border: 1px solid #d12323 !important;
  background-color: rgba(73, 18, 18, 0.22) !important;
  color: #ffffff !important; }

.hold-confirm-btn {
  position: relative;
  overflow: hidden;
  user-select: none;
  min-height: 36px;
  padding: 0 16px;
  border: 1px solid rgba(73, 18, 18, 0.85);
  border-radius: 6px;
  color: #dfdfdf;
  background: rgba(73, 18, 18, 0.32);
  cursor: pointer;
  font-weight: 600; }

.hold-confirm-btn:hover:not(:disabled) {
  border-color: #d12323;
  background: rgba(73, 18, 18, 0.48); }

.hold-confirm-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed; }

.hold-confirm-btn__progress {
  position: absolute;
  inset: 0 auto 0 0;
  width: 0;
  pointer-events: none;
  background: rgba(126, 30, 30, 0.85); }

.hold-confirm-btn__label {
  position: relative;
  z-index: 1;
  color: inherit; }

.hold-confirm-btn.is-holding .hold-confirm-btn__progress {
  animation: holdConfirmProgress var(--hold-confirm-ms, 5s) linear forwards; }

.hold-confirm-btn:not(.is-holding) .hold-confirm-btn__progress {
  animation: none;
  width: 0; }

@keyframes holdConfirmProgress {
  from {
    width: 0; }
  to {
    width: 100%; } }

@media (max-width: 1023px) {
  .content-container {
    transform: translate(0, 27px); }
  .message-error {
    display: flex;
    position: relative;
    margin-left: auto;
    margin-right: auto;
    margin-top: 5px;
    color: #d12323;
    height: 20px;
    opacity: 1; } }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.cookie-banner {
  position: sticky;
  top: 0;
  width: 100%;
  background-color: green;
  color: black;
  padding: 5px 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10; }

.cookie-message {
  margin: 0 5px 0 0;
  display: inline;
  color: black;
  font-size: 14px; }

.cookie-link {
  color: black;
  text-decoration: underline;
  background-color: transparent;
  border: none;
  margin-left: -2px;
  margin-right: -4px;
  cursor: pointer; }
  .cookie-link:hover {
    color: #491212; }

.cookie-button {
  margin-left: 5px;
  padding: 5px 10px;
  background-color: white;
  border: none;
  color: black;
  cursor: pointer; }

.cookie.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; }

.cookie.modal-content {
  background-color: #0c2637;
  padding: 20px;
  border-radius: 5px;
  width: 80%;
  height: 50vh;
  max-width: 900px;
  text-align: left;
  overflow-y: auto; }
  .cookie.modal-content::-webkit-scrollbar {
    width: 6px; }
  .cookie.modal-content::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .cookie.modal-content::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .cookie.modal-content::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }
  @media (max-width: 1023px) {
    .cookie.modal-content {
      height: 82vh;
      overflow-y: auto; }
      .cookie.modal-content::-webkit-scrollbar {
        width: 6px; }
      .cookie.modal-content::-webkit-scrollbar-track {
        background: #2e3842;
        border-radius: 4px;
        padding-right: 1px; }
      .cookie.modal-content::-webkit-scrollbar-thumb {
        background-color: #491212;
        border-radius: 4px; }
        .cookie.modal-content::-webkit-scrollbar-thumb:hover {
          background-color: #200808; } }
  @media (max-width: 1023px) and (orientation: landscape) {
    .cookie.modal-content {
      height: 72vh; } }

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  cursor: pointer; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.background-hexagon-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -4;
  background: #293e55; }

.center-gradient {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 2000px;
  height: 100%;
  background: linear-gradient(to right, transparent 0%, #0b202da6 30%, #0b202da6 70%, transparent 100%);
  z-index: -3; }

.red-lightning {
  position: absolute;
  background: #e7191949;
  z-index: -2;
  transition: top 1.5s, left 1.5s, width 0.5s, height 0.5s; }
  .red-lightning.horizontal {
    width: 200px;
    height: 26px; }
  .red-lightning.vertical {
    width: 26px;
    height: 200px; }

.background-hexagon-row {
  display: flex;
  background-color: transparent; }
  .background-hexagon-row.even {
    margin-left: 50px; }
  .background-hexagon-row.odd {
    margin-left: 0;
    transform: translateY(-15px); }

.background-hexagon {
  background-color: #0c2637;
  margin: 1px;
  width: 50px;
  height: 57.5px;
  clip-path: polygon(0% 25%, 0% 75%, 50% 100%, 100% 75%, 100% 25%, 50% 0%);
  z-index: -2; }

.background-hexagon-row.even .background-hexagon {
  margin-top: -28.75px; }

/* /utils/LaserHit.css */
.laser-hit {
  position: absolute;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: transparent;
  border: 10px solid #74adc4;
  opacity: 1;
  z-index: -2;
  transform-origin: center;
  animation: expandAndFade 0.8s forwards; }

.fading {
  opacity: 0; }

@keyframes expandAndFade {
  0% {
    transform: scale(0.5);
    opacity: 1; }
  100% {
    transform: scale(15);
    opacity: 0; } }

.top-0p {
  top: 0%; }

.left-0p {
  left: 0%; }

.top-1p {
  top: 1%; }

.left-1p {
  left: 1%; }

.top-2p {
  top: 2%; }

.left-2p {
  left: 2%; }

.top-3p {
  top: 3%; }

.left-3p {
  left: 3%; }

.top-4p {
  top: 4%; }

.left-4p {
  left: 4%; }

.top-5p {
  top: 5%; }

.left-5p {
  left: 5%; }

.top-6p {
  top: 6%; }

.left-6p {
  left: 6%; }

.top-7p {
  top: 7%; }

.left-7p {
  left: 7%; }

.top-8p {
  top: 8%; }

.left-8p {
  left: 8%; }

.top-9p {
  top: 9%; }

.left-9p {
  left: 9%; }

.top-10p {
  top: 10%; }

.left-10p {
  left: 10%; }

.top-11p {
  top: 11%; }

.left-11p {
  left: 11%; }

.top-12p {
  top: 12%; }

.left-12p {
  left: 12%; }

.top-13p {
  top: 13%; }

.left-13p {
  left: 13%; }

.top-14p {
  top: 14%; }

.left-14p {
  left: 14%; }

.top-15p {
  top: 15%; }

.left-15p {
  left: 15%; }

.top-16p {
  top: 16%; }

.left-16p {
  left: 16%; }

.top-17p {
  top: 17%; }

.left-17p {
  left: 17%; }

.top-18p {
  top: 18%; }

.left-18p {
  left: 18%; }

.top-19p {
  top: 19%; }

.left-19p {
  left: 19%; }

.top-20p {
  top: 20%; }

.left-20p {
  left: 20%; }

.top-21p {
  top: 21%; }

.left-21p {
  left: 21%; }

.top-22p {
  top: 22%; }

.left-22p {
  left: 22%; }

.top-23p {
  top: 23%; }

.left-23p {
  left: 23%; }

.top-24p {
  top: 24%; }

.left-24p {
  left: 24%; }

.top-25p {
  top: 25%; }

.left-25p {
  left: 25%; }

.top-26p {
  top: 26%; }

.left-26p {
  left: 26%; }

.top-27p {
  top: 27%; }

.left-27p {
  left: 27%; }

.top-28p {
  top: 28%; }

.left-28p {
  left: 28%; }

.top-29p {
  top: 29%; }

.left-29p {
  left: 29%; }

.top-30p {
  top: 30%; }

.left-30p {
  left: 30%; }

.top-31p {
  top: 31%; }

.left-31p {
  left: 31%; }

.top-32p {
  top: 32%; }

.left-32p {
  left: 32%; }

.top-33p {
  top: 33%; }

.left-33p {
  left: 33%; }

.top-34p {
  top: 34%; }

.left-34p {
  left: 34%; }

.top-35p {
  top: 35%; }

.left-35p {
  left: 35%; }

.top-36p {
  top: 36%; }

.left-36p {
  left: 36%; }

.top-37p {
  top: 37%; }

.left-37p {
  left: 37%; }

.top-38p {
  top: 38%; }

.left-38p {
  left: 38%; }

.top-39p {
  top: 39%; }

.left-39p {
  left: 39%; }

.top-40p {
  top: 40%; }

.left-40p {
  left: 40%; }

.top-41p {
  top: 41%; }

.left-41p {
  left: 41%; }

.top-42p {
  top: 42%; }

.left-42p {
  left: 42%; }

.top-43p {
  top: 43%; }

.left-43p {
  left: 43%; }

.top-44p {
  top: 44%; }

.left-44p {
  left: 44%; }

.top-45p {
  top: 45%; }

.left-45p {
  left: 45%; }

.top-46p {
  top: 46%; }

.left-46p {
  left: 46%; }

.top-47p {
  top: 47%; }

.left-47p {
  left: 47%; }

.top-48p {
  top: 48%; }

.left-48p {
  left: 48%; }

.top-49p {
  top: 49%; }

.left-49p {
  left: 49%; }

.top-50p {
  top: 50%; }

.left-50p {
  left: 50%; }

.top-51p {
  top: 51%; }

.left-51p {
  left: 51%; }

.top-52p {
  top: 52%; }

.left-52p {
  left: 52%; }

.top-53p {
  top: 53%; }

.left-53p {
  left: 53%; }

.top-54p {
  top: 54%; }

.left-54p {
  left: 54%; }

.top-55p {
  top: 55%; }

.left-55p {
  left: 55%; }

.top-56p {
  top: 56%; }

.left-56p {
  left: 56%; }

.top-57p {
  top: 57%; }

.left-57p {
  left: 57%; }

.top-58p {
  top: 58%; }

.left-58p {
  left: 58%; }

.top-59p {
  top: 59%; }

.left-59p {
  left: 59%; }

.top-60p {
  top: 60%; }

.left-60p {
  left: 60%; }

.top-61p {
  top: 61%; }

.left-61p {
  left: 61%; }

.top-62p {
  top: 62%; }

.left-62p {
  left: 62%; }

.top-63p {
  top: 63%; }

.left-63p {
  left: 63%; }

.top-64p {
  top: 64%; }

.left-64p {
  left: 64%; }

.top-65p {
  top: 65%; }

.left-65p {
  left: 65%; }

.top-66p {
  top: 66%; }

.left-66p {
  left: 66%; }

.top-67p {
  top: 67%; }

.left-67p {
  left: 67%; }

.top-68p {
  top: 68%; }

.left-68p {
  left: 68%; }

.top-69p {
  top: 69%; }

.left-69p {
  left: 69%; }

.top-70p {
  top: 70%; }

.left-70p {
  left: 70%; }

.top-71p {
  top: 71%; }

.left-71p {
  left: 71%; }

.top-72p {
  top: 72%; }

.left-72p {
  left: 72%; }

.top-73p {
  top: 73%; }

.left-73p {
  left: 73%; }

.top-74p {
  top: 74%; }

.left-74p {
  left: 74%; }

.top-75p {
  top: 75%; }

.left-75p {
  left: 75%; }

.top-76p {
  top: 76%; }

.left-76p {
  left: 76%; }

.top-77p {
  top: 77%; }

.left-77p {
  left: 77%; }

.top-78p {
  top: 78%; }

.left-78p {
  left: 78%; }

.top-79p {
  top: 79%; }

.left-79p {
  left: 79%; }

.top-80p {
  top: 80%; }

.left-80p {
  left: 80%; }

.top-81p {
  top: 81%; }

.left-81p {
  left: 81%; }

.top-82p {
  top: 82%; }

.left-82p {
  left: 82%; }

.top-83p {
  top: 83%; }

.left-83p {
  left: 83%; }

.top-84p {
  top: 84%; }

.left-84p {
  left: 84%; }

.top-85p {
  top: 85%; }

.left-85p {
  left: 85%; }

.top-86p {
  top: 86%; }

.left-86p {
  left: 86%; }

.top-87p {
  top: 87%; }

.left-87p {
  left: 87%; }

.top-88p {
  top: 88%; }

.left-88p {
  left: 88%; }

.top-89p {
  top: 89%; }

.left-89p {
  left: 89%; }

.top-90p {
  top: 90%; }

.left-90p {
  left: 90%; }

.top-91p {
  top: 91%; }

.left-91p {
  left: 91%; }

.top-92p {
  top: 92%; }

.left-92p {
  left: 92%; }

.top-93p {
  top: 93%; }

.left-93p {
  left: 93%; }

.top-94p {
  top: 94%; }

.left-94p {
  left: 94%; }

.top-95p {
  top: 95%; }

.left-95p {
  left: 95%; }

.top-96p {
  top: 96%; }

.left-96p {
  left: 96%; }

.top-97p {
  top: 97%; }

.left-97p {
  left: 97%; }

.top-98p {
  top: 98%; }

.left-98p {
  left: 98%; }

.top-99p {
  top: 99%; }

.left-99p {
  left: 99%; }

.top-100p {
  top: 100%; }

.left-100p {
  left: 100%; }

/* Media query pour les écrans de taille inférieure ou égale à 600px */
@media (max-width: 1023px) {
  .laser-hit {
    width: 10px;
    height: 10px;
    border: 4px solid #74adc4; }
  @keyframes expandAndFade {
    0% {
      transform: scale(0.5);
      opacity: 1; }
    100% {
      transform: scale(15);
      /* Agrandir jusqu'à atteindre environ 83.3px */
      opacity: 0; } } }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.tree-wrapper.permissions {
  margin: 10px 15px;
  border: 1px solid #491212;
  border-bottom: 4px solid #491212;
  border-radius: 8px;
  background-color: #0c2637;
  box-shadow: 4px 5px 2px #4b050547; }
  .tree-wrapper.permissions .tree-header {
    display: flex;
    padding: 6px 12px;
    font-weight: bold;
    font-size: small;
    text-transform: uppercase;
    color: #b8b8b8;
    background: linear-gradient(to top, #491212, #5e2f2fd3, #491212), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    border-bottom: 2px solid #2a3847; }
    .tree-wrapper.permissions .tree-header .tree-item-column.handle-column {
      width: 25px; }
    .tree-wrapper.permissions .tree-header .tree-item-column.name-column {
      width: 50%;
      padding-left: 0px; }
    .tree-wrapper.permissions .tree-header .tree-item-column.action-column {
      width: 13%;
      flex: 1; }
    .tree-wrapper.permissions .tree-header .tree-item-column.route-column {
      width: 13%;
      flex: 1; }
  .tree-wrapper.permissions .tree-body {
    max-height: 30vh;
    padding: 0px;
    overflow: auto; }
    .tree-wrapper.permissions .tree-body::-webkit-scrollbar {
      width: 6px; }
    .tree-wrapper.permissions .tree-body::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .tree-wrapper.permissions .tree-body::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .tree-wrapper.permissions .tree-body::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
    .tree-wrapper.permissions .tree-body .sortable-tree-item {
      position: relative;
      display: flex;
      min-height: 45px;
      align-items: center;
      cursor: grab;
      transition: background-color 0.2s ease; }
      .tree-wrapper.permissions .tree-body .sortable-tree-item.even-row {
        background-color: #1c2d38; }
      .tree-wrapper.permissions .tree-body .sortable-tree-item.odd-row {
        background-color: #0c2637; }
      .tree-wrapper.permissions .tree-body .sortable-tree-item.dragging {
        z-index: 50;
        position: relative;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.7); }
      .tree-wrapper.permissions .tree-body .sortable-tree-item.disabled {
        opacity: 0.4; }
      .tree-wrapper.permissions .tree-body .sortable-tree-item .tree-item-column {
        display: flex;
        align-items: center; }
        .tree-wrapper.permissions .tree-body .sortable-tree-item .tree-item-column.handle-column {
          width: 20px;
          padding: 0 10px; }
        .tree-wrapper.permissions .tree-body .sortable-tree-item .tree-item-column.name-column {
          display: flex;
          flex-direction: column;
          font-size: small;
          width: 49%; }
        .tree-wrapper.permissions .tree-body .sortable-tree-item .tree-item-column.action-column {
          width: 8%;
          flex: 1;
          justify-content: center; }
          .tree-wrapper.permissions .tree-body .sortable-tree-item .tree-item-column.action-column .permission-checkbox {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            border: 1px solid #b8b8b8;
            appearance: none;
            background-color: transparent;
            cursor: pointer;
            position: relative; }
            .tree-wrapper.permissions .tree-body .sortable-tree-item .tree-item-column.action-column .permission-checkbox:checked {
              background-color: #75cf78;
              border-color: #3f7c42; }
              .tree-wrapper.permissions .tree-body .sortable-tree-item .tree-item-column.action-column .permission-checkbox:checked::after {
                content: "";
                position: absolute;
                top: 3px;
                left: 6px;
                width: 4px;
                height: 8px;
                border: solid #dfdfdf;
                border-width: 0 2px 2px 0;
                transform: rotate(45deg); }
        .tree-wrapper.permissions .tree-body .sortable-tree-item .tree-item-column .tree-item-name {
          font-weight: bold;
          color: #dfdfdf;
          margin-right: auto; }
          .tree-wrapper.permissions .tree-body .sortable-tree-item .tree-item-column .tree-item-name.depth-0 {
            margin-left: 0px; }
          .tree-wrapper.permissions .tree-body .sortable-tree-item .tree-item-column .tree-item-name.depth-1 {
            margin-left: 20px; }
          .tree-wrapper.permissions .tree-body .sortable-tree-item .tree-item-column .tree-item-name.depth-2 {
            margin-left: 40px; }
          .tree-wrapper.permissions .tree-body .sortable-tree-item .tree-item-column .tree-item-name.depth-3 {
            margin-left: 60px; }
          .tree-wrapper.permissions .tree-body .sortable-tree-item .tree-item-column .tree-item-name.depth-4 {
            margin-left: 80px; }
          .tree-wrapper.permissions .tree-body .sortable-tree-item .tree-item-column .tree-item-name.depth-5 {
            margin-left: 100px; }
        .tree-wrapper.permissions .tree-body .sortable-tree-item .tree-item-column .tree-item-desc {
          color: #b8b8b8;
          font-size: small;
          margin-right: auto; }
      .tree-wrapper.permissions .tree-body .sortable-tree-item.selected {
        background-color: #3d4955c2; }
      .tree-wrapper.permissions .tree-body .sortable-tree-item.drop-on-hover {
        z-index: 1; }
    .tree-wrapper.permissions .tree-body .drop-between-zone {
      height: 3px;
      position: relative;
      pointer-events: auto;
      display: block;
      z-index: 2; }
      .tree-wrapper.permissions .tree-body .drop-between-zone.drop-between-hover {
        outline: 2px dashed #2a3847; }
        .tree-wrapper.permissions .tree-body .drop-between-zone.drop-between-hover::after {
          content: "";
          position: absolute;
          top: 3px;
          left: 0;
          right: 0;
          height: 2px; }

.route-column {
  width: 5%;
  display: flex;
  justify-content: center;
  align-items: center; }
  .route-column .route-check {
    width: 16px;
    height: 16px;
    mask: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat center;
    -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat center;
    mask-size: contain;
    -webkit-mask-size: contain;
    background-color: #2a3847;
    display: inline-block; }
  .route-column .route-present {
    background-color: #75cf78; }
  .route-column .route-absent {
    background-color: #2a3847;
    opacity: 0.4; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
@keyframes roster-hidden-rf-flicker {
  0%,
  100% {
    opacity: 0.86;
    text-shadow: 0 0 3px rgba(120, 200, 255, 0.35), 1px 0 0 rgba(255, 60, 60, 0.2); }
  33% {
    opacity: 1;
    text-shadow: 0 0 6px rgba(180, 220, 255, 0.45), -1px 0 0 rgba(60, 255, 200, 0.15); }
  66% {
    opacity: 0.9;
    text-shadow: 0 0 2px rgba(100, 160, 255, 0.3), 0.5px 0 0 rgba(255, 120, 80, 0.18); } }

@keyframes roster-hidden-rf-scan {
  0% {
    transform: translateY(-4px);
    opacity: 0.35; }
  50% {
    opacity: 0.55; }
  100% {
    transform: translateY(4px);
    opacity: 0.35; } }

@keyframes roster-hidden-rf-hlines-vibrate {
  0%,
  100% {
    transform: translate(0, 0); }
  20% {
    transform: translate(0.9px, -0.5px); }
  40% {
    transform: translate(-0.7px, 0.6px); }
  60% {
    transform: translate(0.5px, 0.4px); }
  80% {
    transform: translate(-0.5px, -0.4px); } }

@keyframes roster-hidden-rf-hlines-drift {
  0% {
    background-position: 0 0, 0 0; }
  100% {
    background-position: 0 9px, 3px 0; } }

@keyframes roster-redacted-rf-flicker {
  0%,
  100% {
    opacity: 0.88;
    text-shadow: 0 0 4px rgba(158, 34, 34, 0.55), 1px 0 0 rgba(255, 200, 160, 0.22); }
  33% {
    opacity: 1;
    text-shadow: 0 0 8px rgba(158, 34, 34, 0.65), -1px 0 0 rgba(255, 120, 100, 0.35); }
  66% {
    opacity: 0.92;
    text-shadow: 0 0 3px rgba(255, 160, 140, 0.45), 0.5px 0 0 rgba(158, 34, 34, 0.4); } }

.roster-page-loading {
  display: flex;
  justify-content: center;
  padding: 2.5rem 0; }

.table-base.roster.roster--page-fetching .table-body-scroll {
  opacity: 0.55;
  pointer-events: none; }

.table-base.roster.roster--page-fetching .roster-table-footer {
  opacity: 0.55;
  pointer-events: none; }

.table-base.roster .roster-file .member-moniker.roster-moniker--hidden-interference,
.table-base.roster .roster-file .member-moniker.roster-moniker--hidden-interference--red {
  display: inline-block;
  position: relative;
  isolation: isolate;
  min-width: 4.25rem;
  padding: 0.1em 0.15em;
  font-family: ui-monospace, 'Cascadia Mono', 'Segoe UI Mono', monospace;
  font-size: 1.2rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: rgba(195, 208, 220, 0.82);
  animation: roster-hidden-rf-flicker 0.18s steps(2, end) infinite; }
  .table-base.roster .roster-file .member-moniker.roster-moniker--hidden-interference .roster-moniker__hidden-label,
  .table-base.roster .roster-file .member-moniker.roster-moniker--hidden-interference--red .roster-moniker__hidden-label {
    position: relative;
    z-index: 3; }
  .table-base.roster .roster-file .member-moniker.roster-moniker--hidden-interference::before,
  .table-base.roster .roster-file .member-moniker.roster-moniker--hidden-interference--red::before {
    content: '';
    position: absolute;
    inset: -5px -4px;
    z-index: 0;
    pointer-events: none;
    border-radius: 1px;
    opacity: 0.88;
    background-image: repeating-linear-gradient(180deg, rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 2px, rgba(140, 210, 255, 0.42) 2px, rgba(140, 210, 255, 0.42) 3px, rgba(0, 0, 0, 0) 3px, rgba(0, 0, 0, 0) 6px, rgba(255, 255, 255, 0.12) 6px, rgba(255, 255, 255, 0.12) 7px, rgba(0, 0, 0, 0) 7px, rgba(0, 0, 0, 0) 10px), repeating-linear-gradient(180deg, rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 4px, rgba(60, 100, 140, 0.35) 4px, rgba(60, 100, 140, 0.35) 5px, rgba(0, 0, 0, 0) 5px, rgba(0, 0, 0, 0) 11px);
    background-size: 100% 10px, 100% 11px;
    animation: roster-hidden-rf-hlines-vibrate 0.11s steps(2, end) infinite, roster-hidden-rf-hlines-drift 1.4s linear infinite;
    mix-blend-mode: soft-light; }
  .table-base.roster .roster-file .member-moniker.roster-moniker--hidden-interference::after,
  .table-base.roster .roster-file .member-moniker.roster-moniker--hidden-interference--red::after {
    content: '';
    position: absolute;
    inset: -4px -3px;
    z-index: 1;
    pointer-events: none;
    background: repeating-linear-gradient(180deg, transparent 0, transparent 1px, rgba(0, 0, 0, 0.22) 1px, rgba(0, 0, 0, 0.22) 2px);
    opacity: 0.62;
    mix-blend-mode: multiply;
    animation: roster-hidden-rf-hlines-vibrate 0.14s steps(3, end) infinite reverse, roster-hidden-rf-scan 2.2s linear infinite; }
  @media (prefers-reduced-motion: reduce) {
    .table-base.roster .roster-file .member-moniker.roster-moniker--hidden-interference,
    .table-base.roster .roster-file .member-moniker.roster-moniker--hidden-interference--red {
      animation: none; }
      .table-base.roster .roster-file .member-moniker.roster-moniker--hidden-interference::before, .table-base.roster .roster-file .member-moniker.roster-moniker--hidden-interference::after,
      .table-base.roster .roster-file .member-moniker.roster-moniker--hidden-interference--red::before,
      .table-base.roster .roster-file .member-moniker.roster-moniker--hidden-interference--red::after {
        animation: none;
        opacity: 0.45; } }

.table-base.roster .roster-file .member-moniker.roster-moniker--hidden-interference--red {
  color: rgba(233, 153, 153, 0.9);
  animation: roster-redacted-rf-flicker 0.18s steps(2, end) infinite; }
  .table-base.roster .roster-file .member-moniker.roster-moniker--hidden-interference--red::before {
    opacity: 0.92;
    background-image: repeating-linear-gradient(180deg, rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 2px, rgba(158, 34, 34, 0.48) 2px, rgba(158, 34, 34, 0.48) 3px, rgba(0, 0, 0, 0) 3px, rgba(0, 0, 0, 0) 6px, rgba(255, 200, 200, 0.14) 6px, rgba(255, 200, 200, 0.14) 7px, rgba(0, 0, 0, 0) 7px, rgba(0, 0, 0, 0) 10px), repeating-linear-gradient(180deg, rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 4px, rgba(124, 27, 27, 0.4) 4px, rgba(124, 27, 27, 0.4) 5px, rgba(0, 0, 0, 0) 5px, rgba(0, 0, 0, 0) 11px);
    mix-blend-mode: soft-light; }
  .table-base.roster .roster-file .member-moniker.roster-moniker--hidden-interference--red::after {
    background: repeating-linear-gradient(180deg, transparent 0, transparent 1px, rgba(158, 34, 34, 0.28) 1px, rgba(158, 34, 34, 0.28) 2px);
    opacity: 0.68;
    mix-blend-mode: multiply; }
  @media (prefers-reduced-motion: reduce) {
    .table-base.roster .roster-file .member-moniker.roster-moniker--hidden-interference--red {
      animation: none; }
      .table-base.roster .roster-file .member-moniker.roster-moniker--hidden-interference--red::before, .table-base.roster .roster-file .member-moniker.roster-moniker--hidden-interference--red::after {
        animation: none;
        opacity: 0.5; } }

.table-base.roster .roster-file {
  position: absolute;
  top: 3px;
  right: 0;
  width: 67%;
  height: calc(100vh - 365px);
  background: rgba(23, 39, 56, 0.8);
  border-radius: 5px 10px 10px 5px;
  backdrop-filter: blur(10px);
  transform: translate3d(100%, 0, 0);
  transition: transform 0.6s cubic-bezier(0.22, 1, 0.36, 1);
  will-change: transform;
  backface-visibility: hidden;
  overflow: hidden;
  color: #dfdfdf; }
  .table-base.roster .roster-file.visible {
    transform: translate3d(0, 0, 0); }
  .table-base.roster .roster-file .roster-file-header,
  .table-base.roster .roster-file .roster-file-content {
    opacity: 0;
    transform: translateX(40px); }
  .table-base.roster .roster-file.visible .roster-file-header,
  .table-base.roster .roster-file.visible .roster-file-content {
    opacity: 1;
    transform: translateX(0); }
  .table-base.roster .roster-file .roster-file-header {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 7px 0px 14px;
    margin: 0px;
    color: #dfdfdf;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    border-bottom: none;
    height: 35px;
    z-index: 30;
    isolation: isolate; }
    .table-base.roster .roster-file .roster-file-header::before {
      content: '';
      position: absolute;
      inset: 0;
      clip-path: polygon(0% 0%, 100% 0%, 100% 70%, 35% 70%, 30% 100%, 0% 100%);
      pointer-events: none;
      z-index: -1;
      background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center; }
    .table-base.roster .roster-file .roster-file-header::after {
      content: '';
      position: absolute;
      inset: 0;
      transform: translateY(5px);
      clip-path: polygon(0% 0%, 100% 0%, 100% 70%, 35% 70%, 30% 100%, 0% 100%);
      pointer-events: none;
      z-index: -2;
      background: #350404;
      filter: drop-shadow(0 2px 0 rgba(0, 0, 0, 0.65)) drop-shadow(0 0 10px rgba(58, 120, 180, 0.18)); }
    .table-base.roster .roster-file .roster-file-header h2 {
      font-size: 0.8rem;
      margin: 0;
      color: #dfdfdf; }
    .table-base.roster .roster-file .roster-file-header h2.roster-file-header-title {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      flex: 1;
      min-width: 0;
      margin-right: 8px; }
    .table-base.roster .roster-file .roster-file-header .roster-file-header-rank-icon {
      flex-shrink: 0;
      height: 30px;
      width: 40px;
      object-fit: contain;
      filter: drop-shadow(0 -1px 0 rgba(255, 255, 255, 0.38)) drop-shadow(0 1px 0 rgba(0, 0, 0, 0.42)) drop-shadow(0 2px 4px rgba(0, 0, 0, 0.45)) drop-shadow(0 4px 10px rgba(0, 0, 0, 0.28)) drop-shadow(0 0 14px rgba(58, 120, 180, 0.22));
      transform: translateZ(0); }
    .table-base.roster .roster-file .roster-file-header .roster-file-header-avatar {
      flex-shrink: 0;
      width: 34px;
      height: 34px;
      border-radius: 10px;
      object-fit: cover;
      border: 1px solid rgba(58, 120, 180, 0.28);
      background: rgba(0, 0, 0, 0.18);
      filter: drop-shadow(0 1px 0 rgba(0, 0, 0, 0.42)) drop-shadow(0 2px 6px rgba(0, 0, 0, 0.35)) drop-shadow(0 0 12px rgba(58, 120, 180, 0.18));
      transform: translateZ(0); }
    .table-base.roster .roster-file .roster-file-header .roster-file-header-avatar--empty {
      display: inline-block;
      opacity: 0.55; }
    .table-base.roster .roster-file .roster-file-header .roster-file-header-text {
      display: flex;
      flex-direction: column;
      min-width: 0;
      gap: 1px; }
    .table-base.roster .roster-file .roster-file-header .roster-file-header-rank-name {
      font-size: 1rem;
      font-weight: 700;
      letter-spacing: 0.03em;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 260px; }
    .table-base.roster .roster-file .roster-file-header .roster-file-header-discord {
      font-size: 1.05rem;
      min-width: 0;
      max-width: 260px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap; }
    .table-base.roster .roster-file .roster-file-header .close-btn {
      position: relative;
      background: none;
      border: none;
      color: #dfdfdf;
      font-size: 0.7rem;
      padding: 0 3px;
      border-radius: 3px;
      bottom: 7px;
      flex-shrink: 0;
      cursor: pointer; }
      .table-base.roster .roster-file .roster-file-header .close-btn:hover {
        color: #151c24;
        background-color: #dfdfdf; }
  .table-base.roster .roster-file .roster-file-content p {
    margin: 8px 0;
    font-size: 0.95rem; }

.roster-file {
  position: fixed;
  top: 0;
  right: -460px;
  width: 460px;
  height: 100vh;
  background: linear-gradient(160deg, #151c24, #0c2637 70%);
  border-left: 1px solid rgba(58, 120, 180, 0.25);
  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.55);
  z-index: 60;
  transition: right 0.4s cubic-bezier(0.4, 0, 0.2, 1); }
  .roster-file.visible {
    right: 0; }
  .roster-file .roster-file-header {
    min-height: 52px;
    padding: 18px 18px 30px 18px;
    margin: -16px -14px 0 -14px;
    color: #dfdfdf;
    display: flex;
    align-items: center;
    justify-content: space-between; }
    .roster-file .roster-file-header h2 {
      margin: 0;
      font-size: 14px;
      letter-spacing: 2px;
      text-transform: uppercase;
      color: #dfdfdf; }
    .roster-file .roster-file-header .close-btn {
      background: rgba(58, 120, 180, 0.15);
      border: 1px solid rgba(58, 120, 180, 0.4);
      border-radius: 6px;
      width: 28px;
      height: 28px;
      color: #dfdfdf;
      font-size: 16px;
      cursor: pointer;
      transition: all 0.2s ease; }
      .roster-file .roster-file-header .close-btn:hover {
        background: rgba(58, 120, 180, 0.3);
        color: #fff; }
  .roster-file .roster-file-content {
    height: calc(100vh - 64px);
    overflow: hidden;
    padding: 22px; }
    .roster-file .roster-file-content h2.member-moniker {
      margin: 0;
      font-size: 26px;
      font-weight: 600;
      color: #fff;
      letter-spacing: 0.5px;
      text-shadow: 0 0 12px rgba(58, 120, 180, 0.35); }
    .roster-file .roster-file-content .member-handle {
      font-size: 12px;
      color: #b8b8b8;
      margin-bottom: 10px;
      opacity: 0.75; }
    .roster-file .roster-file-content .member-rank-line {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 18px; }
    .roster-file .roster-file-content .member-rank-icon {
      max-height: 20px;
      max-width: 40px;
      object-fit: contain; }
    .roster-file .roster-file-content .member-rank-text {
      font-size: 14px;
      color: #dfdfdf;
      font-weight: 500; }
    .roster-file .roster-file-content p {
      margin: 4px 0;
      font-size: 13px;
      color: #dfdfdf; }
      .roster-file .roster-file-content p strong {
        color: #3a78b4;
        font-weight: 500; }
    .roster-file .roster-file-content hr {
      border: none;
      border-top: 1px solid rgba(58, 120, 180, 0.3);
      margin: 20px 0; }
    .roster-file .roster-file-content h3 {
      font-size: 12px;
      letter-spacing: 2px;
      text-transform: uppercase;
      margin: 18px 0 10px;
      color: #5ac3ff; }
    .roster-file .roster-file-content .training-line {
      position: relative;
      display: flex;
      gap: 10px;
      align-items: flex-start;
      background: linear-gradient(145deg, #1e3042, #172738);
      border: 1px solid rgba(58, 120, 180, 0.35);
      border-radius: 10px;
      padding: 12px 14px;
      margin-bottom: 14px;
      overflow: hidden; }
      .roster-file .roster-file-content .training-line .basic-icon {
        flex-shrink: 0;
        width: 22px;
        height: 22px;
        margin-top: 2px;
        object-fit: contain;
        opacity: 0.9; }
      .roster-file .roster-file-content .training-line .training-line__body {
        flex: 1;
        min-width: 0; }
      .roster-file .roster-file-content .training-line::before {
        content: '';
        position: absolute;
        inset: 0;
        background: linear-gradient(120deg, transparent, rgba(58, 120, 180, 0.12), transparent);
        opacity: 0;
        transition: opacity 0.3s ease; }
      .roster-file .roster-file-content .training-line:hover::before {
        opacity: 1; }
      .roster-file .roster-file-content .training-line strong {
        display: block;
        font-size: 14px;
        color: #fff;
        margin-bottom: 4px; }
      .roster-file .roster-file-content .training-line .training-meta {
        display: flex;
        gap: 14px;
        flex-wrap: wrap;
        font-size: 11px;
        color: #b8b8b8; }

.roster-file-content.roster-file-content--new {
  padding: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0; }

.roster-file-top {
  position: sticky;
  top: 0;
  z-index: 2;
  flex: 0 0 auto;
  background: #172738; }

.roster-file-top__close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 6;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  border: 1px solid rgba(58, 120, 180, 0.42);
  border-radius: 0;
  background: rgba(23, 39, 56, 0.82);
  color: rgba(223, 223, 223, 0.92);
  font-size: 11px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease; }
  .roster-file-top__close:hover {
    background: rgba(58, 120, 180, 0.28);
    border-color: rgba(58, 120, 180, 0.62);
    color: #ffffff; }

.roster-file-summary-hero__customize {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 7;
  margin: 0;
  padding: 0.28rem 0.55rem;
  border: 1px solid rgba(199, 132, 69, 0.85);
  border-radius: 5px 0;
  background: linear-gradient(145deg, rgba(155, 96, 42, 0.92) 0%, rgba(110, 68, 28, 0.95) 100%);
  color: #d8b493;
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  cursor: pointer;
  opacity: 0;
  pointer-events: none;
  box-shadow: 0 0 0 1px rgba(66, 38, 12, 0.55), 0 0 12px rgba(199, 132, 69, 0.35), inset 0 1px 0 rgba(216, 180, 147, 0.28);
  text-shadow: 0 1px 1px rgba(66, 38, 12, 0.65);
  transition: opacity 0.16s ease, background 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease; }
  .roster-file-summary-hero__customize:hover, .roster-file-summary-hero__customize:focus-visible {
    border-color: #d8b493;
    background: linear-gradient(145deg, rgba(199, 132, 69, 0.98) 0%, rgba(155, 96, 42, 0.95) 100%);
    color: #ffffff;
    box-shadow: 0 0 0 1px rgba(155, 96, 42, 0.45), 0 0 16px rgba(199, 132, 69, 0.5), inset 0 1px 0 rgba(216, 180, 147, 0.4); }

.roster-file-summary-hero:hover .roster-file-summary-hero__customize,
.roster-file-summary-hero:focus-within .roster-file-summary-hero__customize {
  opacity: 1;
  pointer-events: auto; }

.roster-profile-theme-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  background: rgba(12, 38, 55, 0.7); }

.roster-profile-theme-modal {
  width: min(100%, 56rem);
  max-height: min(92vh, 48rem);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 14px;
  border: 1px solid rgba(58, 120, 180, 0.35);
  background: #172738;
  box-shadow: 0 20px 48px rgba(12, 38, 55, 0.5); }

.roster-profile-theme-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.85rem 1rem;
  border-bottom: 1px solid rgba(223, 223, 223, 0.12); }

.roster-profile-theme-modal__title {
  margin: 0;
  font-size: 0.92rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #dfdfdf; }

.roster-profile-theme-modal__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.7rem;
  height: 1.7rem;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(58, 120, 180, 0.42);
  background: rgba(12, 38, 55, 0.45);
  color: rgba(223, 223, 223, 0.92);
  font-size: 0.85rem;
  cursor: pointer; }
  .roster-profile-theme-modal__close:hover, .roster-profile-theme-modal__close:focus-visible {
    background: rgba(58, 120, 180, 0.28);
    color: #ffffff; }

.roster-profile-theme-modal__body {
  overflow: auto;
  padding: 1rem; }

.roster-profile-theme-modal__card {
  margin: 0; }

.roster-file-summary-hero {
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(58, 120, 180, 0.35);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 4px 14px rgba(0, 0, 0, 0.28); }
  .roster-file-summary-hero::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 42%;
    height: 100%;
    z-index: 1;
    clip-path: polygon(0 22px, 22px 0, calc(100% - 22px) 0, 100% 50%, calc(100% - 22px) 100%, 22px 100%, 0 calc(100% - 22px));
    background: linear-gradient(135deg, transparent calc(50% - 0.5px), rgba(58, 120, 180, 0.72) 50%, transparent calc(50% + 0.5px)) 0 0 / 22px 22px no-repeat, linear-gradient(315deg, transparent calc(50% - 0.5px), rgba(58, 120, 180, 0.62) 50%, transparent calc(50% + 0.5px)) 0 calc(100% - 22px) / 22px 22px no-repeat, linear-gradient(rgba(58, 120, 180, 0.72), rgba(58, 120, 180, 0.72)) 22px 0/14px 1px no-repeat, linear-gradient(rgba(58, 120, 180, 0.72), rgba(58, 120, 180, 0.72)) 0 22px / 1px 14px no-repeat, linear-gradient(rgba(58, 120, 180, 0.62), rgba(58, 120, 180, 0.62)) 0 calc(100% - 1px)/14px 1px no-repeat, linear-gradient(rgba(58, 120, 180, 0.62), rgba(58, 120, 180, 0.62)) 0 calc(100% - 14px)/1px 14px no-repeat, linear-gradient(90deg, rgba(58, 120, 180, 0.82) 0, rgba(58, 120, 180, 0.82) 7px, transparent 7px, transparent 10px, rgba(58, 120, 180, 0.82) 10px, rgba(58, 120, 180, 0.82) 17px, transparent 17px, transparent 20px, rgba(58, 120, 180, 0.82) 20px, rgba(58, 120, 180, 0.82) 27px, transparent 27px) calc(100% - 50px) 22%/30px 3px no-repeat, linear-gradient(90deg, rgba(58, 120, 180, 0) 0%, rgba(58, 120, 180, 0.45) 20%, rgba(58, 120, 180, 0.72) 50%, rgba(58, 120, 180, 0.45) 80%, rgba(58, 120, 180, 0) 100%) 10px calc(100% - 21px)/calc(100% - 34px) 2px no-repeat, linear-gradient(115deg, rgba(58, 120, 180, 0.28) 0%, rgba(58, 120, 180, 0.42) 50%, rgba(58, 120, 180, 0.22) 100%) 10px calc(100% - 10px)/5px 9px no-repeat, linear-gradient(115deg, rgba(58, 120, 180, 0.28) 0%, rgba(58, 120, 180, 0.42) 50%, rgba(58, 120, 180, 0.22) 100%) 19px calc(100% - 10px)/5px 9px no-repeat, linear-gradient(115deg, rgba(58, 120, 180, 0.28) 0%, rgba(58, 120, 180, 0.42) 50%, rgba(58, 120, 180, 0.22) 100%) 28px calc(100% - 10px)/5px 9px no-repeat, linear-gradient(115deg, rgba(58, 120, 180, 0.2) 0%, rgba(58, 120, 180, 0.34) 45%, rgba(58, 120, 180, 0.18) 100%) 38px calc(100% - 10px)/30px 9px no-repeat, linear-gradient(135deg, rgba(255, 255, 255, 0.09) 0%, rgba(255, 255, 255, 0.02) 24%, transparent 48%) 0 0/100% 100% no-repeat, linear-gradient(180deg, rgba(58, 120, 180, 0.1) 0%, transparent 16%, transparent 84%, rgba(58, 120, 180, 0.07) 100%) 0 0/100% 100% no-repeat, rgba(23, 39, 56, 0.48);
    background-repeat: no-repeat;
    box-shadow: inset 0 0 0 1px rgba(58, 120, 180, 0.32), inset 0 1px 0 rgba(255, 255, 255, 0.12), inset 1px 0 0 rgba(58, 120, 180, 0.22), 2px 0 14px rgba(0, 0, 0, 0.28);
    pointer-events: none; }
  .roster-file-summary-hero::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 22%;
    height: 100%;
    z-index: 1;
    clip-path: polygon(0 70%, 25px 0, 100% 0, 100% calc(100% - 22px), calc(100% - 22px) 100%, 0px 100%);
    background: linear-gradient(rgba(58, 120, 180, 0.55), rgba(58, 120, 180, 0.55)) calc(100% - 1px) 0/1px 12px no-repeat, linear-gradient(rgba(58, 120, 180, 0.55), rgba(58, 120, 180, 0.55)) calc(100% - 12px) 0/12px 1px no-repeat, linear-gradient(rgba(58, 120, 180, 0.55), rgba(58, 120, 180, 0.55)) 0 50%/1px 12px no-repeat, linear-gradient(225deg, rgba(255, 255, 255, 0.07) 0%, transparent 34%), linear-gradient(180deg, rgba(58, 120, 180, 0.08) 0%, transparent 18%, transparent 82%, rgba(58, 120, 180, 0.06) 100%), rgba(23, 39, 56, 0.42);
    background-repeat: no-repeat;
    box-shadow: inset 0 0 0 1px rgba(58, 120, 180, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1), inset -1px 0 0 rgba(58, 120, 180, 0.22), -2px 0 14px rgba(0, 0, 0, 0.28);
    pointer-events: none; }

.roster-file-summary-hero__intel {
  position: absolute;
  top: 0;
  right: 0;
  width: 22%;
  height: 100%;
  z-index: 2;
  pointer-events: none; }

.roster-file-identity {
  position: relative;
  height: -webkit-fill-available;
  display: grid;
  align-content: center;
  gap: 8px;
  min-width: 0;
  padding: 14px 12px 12px 18px;
  clip-path: polygon(0 70%, 25px 0, 100% 0, 100% calc(100% - 22px), calc(100% - 22px) 100%, 0px 100%);
  box-shadow: inset 0 0 0 1px rgba(58, 120, 180, 0.35);
  pointer-events: none; }
  .roster-file-identity::before {
    content: '';
    position: absolute;
    top: -1px;
    left: 183px;
    width: 22px;
    height: 22px;
    border-top: 1px solid rgba(58, 120, 180, 0.72);
    border-left: 1px solid rgba(58, 120, 180, 0.72);
    box-shadow: 0 0 5px rgba(58, 120, 180, 0.35), inset 1px 1px 0 rgba(255, 255, 255, 0.1);
    pointer-events: none; }
  .roster-file-identity::after {
    content: '';
    position: absolute;
    right: 0;
    bottom: 0;
    width: 22px;
    height: 22px;
    clip-path: polygon(100% 0, 100% 100%, 0 100%);
    border-right: 1px solid rgba(58, 120, 180, 0.72);
    border-bottom: 1px solid rgba(58, 120, 180, 0.72);
    background: linear-gradient(-45deg, transparent calc(50% - 0.5px), rgba(58, 120, 180, 0.78) 50%, transparent calc(50% + 0.5px));
    box-shadow: 0 0 6px rgba(58, 120, 180, 0.38), inset -1px -1px 0 rgba(255, 255, 255, 0.08);
    pointer-events: none; }

.roster-file-summary-hero__banner {
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none; }
  .roster-file-summary-hero__banner::before {
    content: '';
    position: absolute;
    height: 12px;
    inset: 0;
    z-index: 1;
    background: repeating-linear-gradient(-52deg, rgba(58, 120, 180, 0.24) 0, rgba(23, 39, 56, 0.24) 4px, transparent 8px, transparent 9px);
    mask-image: linear-gradient(90deg, transparent 0%, rgba(0, 0, 0, 0.92) 14%, rgba(0, 0, 0, 0.92) 86%, transparent 100%);
    opacity: 0.9; }

.roster-file-summary-hero__banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center right;
  filter: saturate(0.9) brightness(0.68); }

.roster-file-summary-hero__theme-media {
  z-index: 1; }

.roster-file-summary-hero__donor-space {
  position: absolute;
  inset: 0;
  z-index: 2;
  overflow: hidden;
  isolation: isolate;
  background-color: rgba(23, 39, 56, 0.92); }
  .roster-file-summary-hero__donor-space--plain {
    background-color: transparent; }
    .roster-file-summary-hero__donor-space--plain::before, .roster-file-summary-hero__donor-space--plain::after {
      content: none;
      display: none; }
  .roster-file-summary-hero__donor-space::before {
    content: "";
    position: absolute;
    inset: -12%;
    z-index: 0;
    pointer-events: none;
    will-change: transform;
    background-image: radial-gradient(ellipse 58% 28% at 22% 76%, rgba(22, 58, 95, 0.72) 0%, transparent 72%), radial-gradient(ellipse 54% 26% at 44% 54%, rgba(58, 120, 180, 0.58) 0%, transparent 74%), radial-gradient(ellipse 50% 24% at 66% 32%, rgba(22, 58, 95, 0.68) 0%, transparent 72%), radial-gradient(ellipse 34% 18% at 16% 82%, rgba(90, 195, 255, 0.5) 0%, transparent 68%), radial-gradient(ellipse 32% 20% at 32% 64%, rgba(90, 195, 255, 0.58) 0%, transparent 70%), radial-gradient(ellipse 36% 16% at 50% 46%, rgba(90, 195, 255, 0.42) 0%, transparent 68%), radial-gradient(ellipse 30% 18% at 62% 38%, rgba(58, 120, 180, 0.52) 0%, transparent 70%), radial-gradient(ellipse 28% 14% at 78% 24%, rgba(90, 195, 255, 0.46) 0%, transparent 68%), radial-gradient(ellipse 12% 8% at 30% 68%, rgba(90, 195, 255, 0.7) 0%, transparent 72%), radial-gradient(ellipse 10% 7% at 48% 48%, rgba(255, 255, 255, 0.28) 0%, transparent 70%), radial-gradient(ellipse 11% 7% at 60% 34%, rgba(90, 195, 255, 0.55) 0%, transparent 72%), radial-gradient(ellipse 20% 24% at 40% 50%, rgba(58, 120, 180, 0.36) 0%, transparent 75%), radial-gradient(ellipse 18% 22% at 56% 58%, rgba(22, 58, 95, 0.42) 0%, transparent 78%), radial-gradient(ellipse 22% 14% at 72% 42%, rgba(90, 195, 255, 0.34) 0%, transparent 75%); }
  .roster-file-summary-hero__donor-space::after {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 1;
    pointer-events: none;
    background-image: radial-gradient(1px 1px at 5% 80%, rgba(255, 255, 255, 0.4), transparent), radial-gradient(1px 1px at 7% 76%, rgba(255, 255, 255, 0.55), transparent), radial-gradient(1px 1px at 8% 82%, rgba(90, 195, 255, 0.45), transparent), radial-gradient(1.5px 1.5px at 10% 74%, rgba(255, 255, 255, 0.85), transparent), radial-gradient(1px 1px at 11% 79%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1px 1px at 13% 72%, rgba(90, 195, 255, 0.5), transparent), radial-gradient(1px 1px at 14% 77%, rgba(255, 255, 255, 0.6), transparent), radial-gradient(1px 1px at 16% 70%, rgba(255, 255, 255, 0.4), transparent), radial-gradient(2px 2px at 17% 75%, rgba(90, 195, 255, 0.9), transparent), radial-gradient(1px 1px at 18% 68%, rgba(255, 255, 255, 0.5), transparent), radial-gradient(1px 1px at 19% 78%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 21% 66%, rgba(58, 120, 180, 0.55), transparent), radial-gradient(1.5px 1.5px at 22% 71%, rgba(255, 255, 255, 0.85), transparent), radial-gradient(1px 1px at 23% 64%, rgba(255, 255, 255, 0.45), transparent), radial-gradient(1px 1px at 25% 69%, rgba(255, 255, 255, 0.7), transparent), radial-gradient(1px 1px at 26% 74%, rgba(90, 195, 255, 0.4), transparent), radial-gradient(1px 1px at 27% 62%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1px 1px at 29% 67%, rgba(255, 255, 255, 0.6), transparent), radial-gradient(1.5px 1.5px at 30% 61%, rgba(90, 195, 255, 0.8), transparent), radial-gradient(1px 1px at 31% 72%, rgba(255, 255, 255, 0.4), transparent), radial-gradient(1px 1px at 32% 59%, rgba(255, 255, 255, 0.55), transparent), radial-gradient(1px 1px at 34% 65%, rgba(255, 255, 255, 0.75), transparent), radial-gradient(1px 1px at 35% 57%, rgba(90, 195, 255, 0.5), transparent), radial-gradient(1px 1px at 36% 63%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(2px 2px at 38% 56%, rgba(255, 255, 255, 0.95), transparent), radial-gradient(1px 1px at 39% 61%, rgba(90, 195, 255, 0.5), transparent), radial-gradient(1px 1px at 40% 53%, rgba(255, 255, 255, 0.45), transparent), radial-gradient(1px 1px at 41% 58%, rgba(255, 255, 255, 0.7), transparent), radial-gradient(1.5px 1.5px at 43% 52%, rgba(58, 120, 180, 0.8), transparent), radial-gradient(1px 1px at 44% 57%, rgba(255, 255, 255, 0.4), transparent), radial-gradient(1px 1px at 45% 50%, rgba(255, 255, 255, 0.6), transparent), radial-gradient(1px 1px at 46% 55%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1px 1px at 47% 48%, rgba(90, 195, 255, 0.55), transparent), radial-gradient(1px 1px at 49% 53%, rgba(255, 255, 255, 0.65), transparent), radial-gradient(1.5px 1.5px at 50% 47%, rgba(255, 255, 255, 0.9), transparent), radial-gradient(1px 1px at 51% 52%, rgba(255, 255, 255, 0.4), transparent), radial-gradient(1px 1px at 52% 45%, rgba(90, 195, 255, 0.6), transparent), radial-gradient(1px 1px at 53% 50%, rgba(255, 255, 255, 0.5), transparent), radial-gradient(1px 1px at 55% 43%, rgba(255, 255, 255, 0.75), transparent), radial-gradient(2px 2px at 56% 48%, rgba(90, 195, 255, 0.85), transparent), radial-gradient(1px 1px at 57% 41%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1px 1px at 58% 46%, rgba(90, 195, 255, 0.55), transparent), radial-gradient(1px 1px at 59% 39%, rgba(255, 255, 255, 0.5), transparent), radial-gradient(1.5px 1.5px at 61% 44%, rgba(255, 255, 255, 0.85), transparent), radial-gradient(1px 1px at 62% 38%, rgba(255, 255, 255, 0.4), transparent), radial-gradient(1px 1px at 63% 42%, rgba(58, 120, 180, 0.55), transparent), radial-gradient(1px 1px at 64% 36%, rgba(255, 255, 255, 0.65), transparent), radial-gradient(1px 1px at 66% 40%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1px 1px at 67% 34%, rgba(90, 195, 255, 0.5), transparent), radial-gradient(1.5px 1.5px at 68% 39%, rgba(90, 195, 255, 0.8), transparent), radial-gradient(1px 1px at 70% 32%, rgba(255, 255, 255, 0.55), transparent), radial-gradient(1px 1px at 71% 37%, rgba(255, 255, 255, 0.4), transparent), radial-gradient(1px 1px at 72% 30%, rgba(255, 255, 255, 0.7), transparent), radial-gradient(1px 1px at 73% 35%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(2px 2px at 75% 28%, rgba(255, 255, 255, 0.9), transparent), radial-gradient(1px 1px at 76% 33%, rgba(90, 195, 255, 0.5), transparent), radial-gradient(1px 1px at 77% 26%, rgba(255, 255, 255, 0.45), transparent), radial-gradient(1px 1px at 79% 31%, rgba(90, 195, 255, 0.55), transparent), radial-gradient(1.5px 1.5px at 80% 24%, rgba(58, 120, 180, 0.8), transparent), radial-gradient(1px 1px at 81% 29%, rgba(255, 255, 255, 0.4), transparent), radial-gradient(1px 1px at 82% 22%, rgba(255, 255, 255, 0.65), transparent), radial-gradient(1px 1px at 84% 27%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1px 1px at 85% 20%, rgba(90, 195, 255, 0.55), transparent), radial-gradient(1px 1px at 86% 25%, rgba(255, 255, 255, 0.5), transparent), radial-gradient(1.5px 1.5px at 88% 19%, rgba(255, 255, 255, 0.85), transparent), radial-gradient(1px 1px at 89% 23%, rgba(255, 255, 255, 0.4), transparent), radial-gradient(1px 1px at 91% 17%, rgba(90, 195, 255, 0.5), transparent), radial-gradient(1px 1px at 92% 21%, rgba(255, 255, 255, 0.6), transparent), radial-gradient(1px 1px at 94% 15%, rgba(255, 255, 255, 0.45), transparent), radial-gradient(1px 1px at 96% 18%, rgba(58, 120, 180, 0.5), transparent), radial-gradient(1px 1px at 6% 78%, rgba(255, 255, 255, 0.45), transparent), radial-gradient(1px 1px at 9% 73%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1px 1px at 12% 76%, rgba(90, 195, 255, 0.45), transparent), radial-gradient(1px 1px at 15% 69%, rgba(255, 255, 255, 0.5), transparent), radial-gradient(1.5px 1.5px at 20% 73%, rgba(255, 255, 255, 0.75), transparent), radial-gradient(1px 1px at 24% 67%, rgba(90, 195, 255, 0.45), transparent), radial-gradient(1px 1px at 28% 70%, rgba(255, 255, 255, 0.4), transparent), radial-gradient(1px 1px at 33% 62%, rgba(255, 255, 255, 0.55), transparent), radial-gradient(1px 1px at 37% 58%, rgba(58, 120, 180, 0.45), transparent), radial-gradient(1px 1px at 42% 55%, rgba(255, 255, 255, 0.5), transparent), radial-gradient(1.5px 1.5px at 48% 49%, rgba(90, 195, 255, 0.7), transparent), radial-gradient(1px 1px at 54% 46%, rgba(255, 255, 255, 0.45), transparent), radial-gradient(1px 1px at 60% 41%, rgba(255, 255, 255, 0.55), transparent), radial-gradient(1px 1px at 65% 37%, rgba(90, 195, 255, 0.4), transparent), radial-gradient(1px 1px at 69% 35%, rgba(255, 255, 255, 0.5), transparent), radial-gradient(1.5px 1.5px at 74% 29%, rgba(255, 255, 255, 0.8), transparent), radial-gradient(1px 1px at 78% 27%, rgba(90, 195, 255, 0.45), transparent), radial-gradient(1px 1px at 83% 23%, rgba(255, 255, 255, 0.4), transparent), radial-gradient(1px 1px at 87% 21%, rgba(255, 255, 255, 0.55), transparent), radial-gradient(1px 1px at 95% 16%, rgba(90, 195, 255, 0.45), transparent), radial-gradient(1px 1px at 6% 84%, rgba(255, 255, 255, 0.22), transparent), radial-gradient(1px 1px at 10% 70%, rgba(255, 255, 255, 0.25), transparent), radial-gradient(1px 1px at 12% 78%, rgba(255, 255, 255, 0.22), transparent), radial-gradient(1px 1px at 15% 81%, rgba(255, 255, 255, 0.2), transparent), radial-gradient(1px 1px at 18% 64%, rgba(255, 255, 255, 0.25), transparent), radial-gradient(1px 1px at 20% 72%, rgba(255, 255, 255, 0.25), transparent), radial-gradient(1px 1px at 22% 78%, rgba(255, 255, 255, 0.2), transparent), radial-gradient(1px 1px at 25% 63%, rgba(255, 255, 255, 0.28), transparent), radial-gradient(1px 1px at 28% 66%, rgba(255, 255, 255, 0.2), transparent), radial-gradient(1px 1px at 31% 56%, rgba(255, 255, 255, 0.25), transparent), radial-gradient(1px 1px at 34% 70%, rgba(255, 255, 255, 0.22), transparent), radial-gradient(1px 1px at 37% 59%, rgba(255, 255, 255, 0.28), transparent), radial-gradient(1px 1px at 40% 62%, rgba(255, 255, 255, 0.2), transparent), radial-gradient(1px 1px at 43% 48%, rgba(255, 255, 255, 0.25), transparent), radial-gradient(1px 1px at 46% 60%, rgba(255, 255, 255, 0.22), transparent), radial-gradient(1px 1px at 48% 51%, rgba(255, 255, 255, 0.22), transparent), radial-gradient(1px 1px at 51% 42%, rgba(255, 255, 255, 0.25), transparent), radial-gradient(1px 1px at 54% 45%, rgba(255, 255, 255, 0.25), transparent), radial-gradient(1px 1px at 57% 52%, rgba(255, 255, 255, 0.2), transparent), radial-gradient(1px 1px at 60% 36%, rgba(255, 255, 255, 0.28), transparent), radial-gradient(1px 1px at 63% 47%, rgba(255, 255, 255, 0.22), transparent), radial-gradient(1px 1px at 65% 38%, rgba(255, 255, 255, 0.2), transparent), radial-gradient(1px 1px at 68% 43%, rgba(255, 255, 255, 0.25), transparent), radial-gradient(1px 1px at 71% 27%, rgba(255, 255, 255, 0.22), transparent), radial-gradient(1px 1px at 74% 31%, rgba(255, 255, 255, 0.28), transparent), radial-gradient(1px 1px at 77% 36%, rgba(255, 255, 255, 0.2), transparent), radial-gradient(1px 1px at 80% 19%, rgba(255, 255, 255, 0.25), transparent), radial-gradient(1px 1px at 83% 25%, rgba(255, 255, 255, 0.22), transparent), radial-gradient(1px 1px at 86% 30%, rgba(255, 255, 255, 0.2), transparent), radial-gradient(1px 1px at 89% 14%, rgba(255, 255, 255, 0.25), transparent), radial-gradient(1px 1px at 93% 18%, rgba(255, 255, 255, 0.25), transparent), radial-gradient(1px 1px at 97% 22%, rgba(255, 255, 255, 0.2), transparent), radial-gradient(1px 1px at 2% 14%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1px 1px at 4% 22%, rgba(255, 255, 255, 0.4), transparent), radial-gradient(1px 1px at 5% 32%, rgba(90, 195, 255, 0.35), transparent), radial-gradient(1px 1px at 7% 10%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 9% 38%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1.5px 1.5px at 11% 20%, rgba(255, 255, 255, 0.55), transparent), radial-gradient(1px 1px at 13% 44%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1.5px 1.5px at 14% 28%, rgba(90, 195, 255, 0.55), transparent), radial-gradient(1px 1px at 16% 8%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1px 1px at 18% 42%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1px 1px at 21% 14%, rgba(58, 120, 180, 0.35), transparent), radial-gradient(1px 1px at 24% 18%, rgba(90, 195, 255, 0.4), transparent), radial-gradient(1px 1px at 26% 30%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 29% 34%, rgba(255, 255, 255, 0.45), transparent), radial-gradient(1px 1px at 31% 12%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1px 1px at 33% 24%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 36% 8%, rgba(90, 195, 255, 0.4), transparent), radial-gradient(1px 1px at 39% 20%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1.5px 1.5px at 42% 16%, rgba(255, 255, 255, 0.6), transparent), radial-gradient(1px 1px at 45% 6%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 47% 28%, rgba(58, 120, 180, 0.4), transparent), radial-gradient(1px 1px at 50% 18%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1px 1px at 53% 12%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1px 1px at 56% 8%, rgba(90, 195, 255, 0.35), transparent), radial-gradient(1px 1px at 58% 22%, rgba(255, 255, 255, 0.4), transparent), radial-gradient(1px 1px at 61% 6%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 64% 14%, rgba(90, 195, 255, 0.35), transparent), radial-gradient(1px 1px at 67% 10%, rgba(255, 255, 255, 0.4), transparent), radial-gradient(1.5px 1.5px at 69% 20%, rgba(90, 195, 255, 0.5), transparent), radial-gradient(1px 1px at 73% 6%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1px 1px at 76% 14%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 78% 10%, rgba(255, 255, 255, 0.4), transparent), radial-gradient(1px 1px at 82% 4%, rgba(58, 120, 180, 0.35), transparent), radial-gradient(1px 1px at 85% 12%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 87% 8%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 91% 4%, rgba(90, 195, 255, 0.35), transparent), radial-gradient(1px 1px at 94% 10%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 98% 6%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1px 1px at 3% 46%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 6% 58%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1px 1px at 10% 52%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 15% 48%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 19% 56%, rgba(90, 195, 255, 0.3), transparent), radial-gradient(1px 1px at 23% 44%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1px 1px at 26% 42%, rgba(90, 195, 255, 0.35), transparent), radial-gradient(1px 1px at 30% 48%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 35% 38%, rgba(255, 255, 255, 0.4), transparent), radial-gradient(1px 1px at 40% 34%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 44% 32%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 49% 36%, rgba(90, 195, 255, 0.35), transparent), radial-gradient(1.5px 1.5px at 60% 58%, rgba(255, 255, 255, 0.55), transparent), radial-gradient(1px 1px at 63% 54%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 66% 64%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 70% 52%, rgba(90, 195, 255, 0.4), transparent), radial-gradient(1px 1px at 74% 58%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 77% 60%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1px 1px at 81% 48%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1px 1px at 85% 54%, rgba(90, 195, 255, 0.3), transparent), radial-gradient(1px 1px at 90% 42%, rgba(90, 195, 255, 0.4), transparent), radial-gradient(1px 1px at 93% 50%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 97% 56%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1px 1px at 2% 72%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 5% 86%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1px 1px at 8% 92%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1px 1px at 12% 84%, rgba(90, 195, 255, 0.3), transparent), radial-gradient(1px 1px at 16% 88%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 20% 94%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1.5px 1.5px at 25% 90%, rgba(58, 120, 180, 0.5), transparent), radial-gradient(1px 1px at 28% 86%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 34% 84%, rgba(255, 255, 255, 0.4), transparent), radial-gradient(1px 1px at 38% 94%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 43% 92%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 48% 72%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 48% 88%, rgba(90, 195, 255, 0.35), transparent), radial-gradient(1px 1px at 52% 86%, rgba(90, 195, 255, 0.35), transparent), radial-gradient(1px 1px at 55% 68%, rgba(90, 195, 255, 0.35), transparent), radial-gradient(1px 1px at 55% 94%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 61% 90%, rgba(255, 255, 255, 0.4), transparent), radial-gradient(1px 1px at 65% 78%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 68% 92%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1.5px 1.5px at 72% 84%, rgba(90, 195, 255, 0.55), transparent), radial-gradient(1px 1px at 76% 76%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 79% 94%, rgba(90, 195, 255, 0.3), transparent), radial-gradient(1px 1px at 83% 88%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1px 1px at 88% 74%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 92% 80%, rgba(255, 255, 255, 0.3), transparent), radial-gradient(1px 1px at 96% 90%, rgba(58, 120, 180, 0.35), transparent); }
  .roster-file-summary-hero__donor-space .roster-file-summary-hero__banner-overlay {
    z-index: 0;
    background: linear-gradient(90deg, rgba(23, 39, 56, 0.55) 0%, rgba(23, 39, 56, 0.28) 36%, rgba(23, 39, 56, 0.12) 62%, rgba(23, 39, 56, 0.04) 100%), linear-gradient(180deg, rgba(23, 39, 56, 0.06) 0%, rgba(23, 39, 56, 0.28) 100%); }
  .roster-file-summary-hero__donor-space .member-profile-card-popover__shooting-star {
    position: absolute;
    top: var(--mp-star-top, 8%);
    left: var(--mp-star-left, 10%);
    z-index: 2;
    width: 110px;
    height: 2px;
    border-radius: 1px;
    pointer-events: none;
    opacity: 0;
    background: linear-gradient(90deg, transparent 0%, rgba(90, 195, 255, 0.7) 58%, white 100%);
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.55);
    transform-origin: left center;
    will-change: transform, opacity; }
    .roster-file-summary-hero__donor-space .member-profile-card-popover__shooting-star.is-flying {
      animation: roster-file-shooting-star var(--mp-star-duration, 0.65s) ease-out forwards; }
    .roster-file-summary-hero__donor-space .member-profile-card-popover__shooting-star--t1 {
      --mp-star-top: 4%;
      --mp-star-left: 3%;
      --mp-star-dx: 420px;
      --mp-star-dy: 180px;
      --mp-star-angle: 23deg;
      --mp-star-duration: 0.68s; }
    .roster-file-summary-hero__donor-space .member-profile-card-popover__shooting-star--t2 {
      --mp-star-top: 20%;
      --mp-star-left: 12%;
      --mp-star-dx: 400px;
      --mp-star-dy: 200px;
      --mp-star-angle: 27deg;
      --mp-star-duration: 0.72s; }
    .roster-file-summary-hero__donor-space .member-profile-card-popover__shooting-star--t3 {
      --mp-star-top: 6%;
      --mp-star-left: 34%;
      --mp-star-dx: 360px;
      --mp-star-dy: 190px;
      --mp-star-angle: 28deg;
      --mp-star-duration: 0.62s; }
    .roster-file-summary-hero__donor-space .member-profile-card-popover__shooting-star--t4 {
      --mp-star-top: 16%;
      --mp-star-left: 46%;
      --mp-star-dx: 340px;
      --mp-star-dy: 170px;
      --mp-star-angle: 27deg;
      --mp-star-duration: 0.7s; }
    .roster-file-summary-hero__donor-space .member-profile-card-popover__shooting-star--t5 {
      --mp-star-top: 2%;
      --mp-star-left: 52%;
      --mp-star-dx: 320px;
      --mp-star-dy: 210px;
      --mp-star-angle: 33deg;
      --mp-star-duration: 0.6s; }
    .roster-file-summary-hero__donor-space .member-profile-card-popover__shooting-star--t6 {
      --mp-star-top: 10%;
      --mp-star-left: 62%;
      --mp-star-dx: 280px;
      --mp-star-dy: 180px;
      --mp-star-angle: 33deg;
      --mp-star-duration: 0.65s; }
    .roster-file-summary-hero__donor-space .member-profile-card-popover__shooting-star--t7 {
      --mp-star-top: 22%;
      --mp-star-left: 70%;
      --mp-star-dx: 250px;
      --mp-star-dy: 160px;
      --mp-star-angle: 33deg;
      --mp-star-duration: 0.58s; }
    .roster-file-summary-hero__donor-space .member-profile-card-popover__shooting-star--t8 {
      --mp-star-top: 8%;
      --mp-star-left: 78%;
      --mp-star-dx: 220px;
      --mp-star-dy: 150px;
      --mp-star-angle: 34deg;
      --mp-star-duration: 0.55s; }
  .roster-file-summary-hero__donor-space--premium::before {
    animation: roster-file-nebula-morph-a 28.8s ease-in-out infinite; }
  .roster-file-summary-hero__donor-space--premium .roster-file-summary-hero__nebula-morph {
    position: absolute;
    inset: -14%;
    z-index: 0;
    pointer-events: none;
    will-change: transform, opacity;
    background-image: radial-gradient(ellipse 46% 30% at 28% 64%, rgba(90, 195, 255, 0.55) 0%, transparent 70%), radial-gradient(ellipse 42% 24% at 56% 36%, rgba(90, 195, 255, 0.45) 0%, transparent 72%), radial-gradient(ellipse 38% 28% at 70% 50%, rgba(58, 120, 180, 0.48) 0%, transparent 68%), radial-gradient(ellipse 34% 20% at 42% 26%, rgba(22, 58, 95, 0.5) 0%, transparent 74%), radial-gradient(ellipse 28% 34% at 18% 50%, rgba(58, 120, 180, 0.36) 0%, transparent 75%), radial-gradient(ellipse 24% 18% at 84% 20%, rgba(90, 195, 255, 0.42) 0%, transparent 70%);
    animation: roster-file-nebula-morph-b 36.9s ease-in-out infinite; }

@keyframes roster-file-shooting-star {
  0% {
    opacity: 0;
    transform: translate(0, 0) rotate(var(--mp-star-angle, 38deg)); }
  12% {
    opacity: 1; }
  70% {
    opacity: 1; }
  100% {
    opacity: 0;
    transform: translate(var(--mp-star-dx, 140px), var(--mp-star-dy, 100px)) rotate(var(--mp-star-angle, 38deg)); } }

@keyframes roster-file-nebula-morph-a {
  0%,
  100% {
    transform: translate3d(0, 0, 0) scale(1, 1) skew(0deg, 0deg); }
  18% {
    transform: translate3d(1.44%, -2.64%, 0) scale(1.084, 0.916) skew(1.32deg, -0.48deg); }
  36% {
    transform: translate3d(-2.88%, -0.72%, 0) scale(0.916, 1.108) skew(-1.08deg, 0.84deg); }
  54% {
    transform: translate3d(-0.96%, 3.12%, 0) scale(1.06, 0.928) skew(0.6deg, 1.08deg); }
  72% {
    transform: translate3d(2.64%, 1.32%, 0) scale(0.94, 1.084) skew(-1.2deg, -0.6deg); }
  88% {
    transform: translate3d(0.72%, -1.68%, 0) scale(1.036, 0.964) skew(0.48deg, 0.36deg); } }

@keyframes roster-file-nebula-morph-b {
  0%,
  100% {
    transform: translate3d(0, 0, 0) scale(1.012, 0.988) skew(0deg, 0deg);
    opacity: 0.28; }
  22% {
    transform: translate3d(-3.36%, 2.16%, 0) scale(0.88, 1.144) skew(-1.44deg, 0.72deg);
    opacity: 0.78; }
  44% {
    transform: translate3d(2.88%, 3.36%, 0) scale(1.144, 0.856) skew(1.08deg, -0.96deg);
    opacity: 0.4; }
  66% {
    transform: translate3d(1.44%, -3.12%, 0) scale(0.928, 1.12) skew(-0.6deg, 1.2deg);
    opacity: 0.82; }
  84% {
    transform: translate3d(-1.92%, -0.96%, 0) scale(1.072, 0.928) skew(0.84deg, -0.36deg);
    opacity: 0.36; } }

@media (prefers-reduced-motion: reduce) {
  .roster-file-summary-hero__donor-space--premium::before,
  .roster-file-summary-hero__donor-space--premium .roster-file-summary-hero__nebula-morph {
    animation: none; }
  .roster-file-summary-hero__donor-space .member-profile-card-popover__shooting-star {
    display: none; } }

.roster-file-summary-hero__banner-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(23, 39, 56, 0.82) 0%, rgba(23, 39, 56, 0.58) 32%, rgba(23, 39, 56, 0.32) 58%, rgba(23, 39, 56, 0.14) 100%), linear-gradient(180deg, rgba(23, 39, 56, 0.12) 0%, rgba(23, 39, 56, 0.52) 100%); }

.roster-file-summary {
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(0, 0.95fr);
  gap: 0;
  padding: 14px calc(22% + 6px) 12px 8px;
  background: transparent;
  position: relative;
  z-index: 2;
  overflow: visible; }

.roster-file-summary--no-org {
  grid-template-columns: minmax(0, 1fr); }

.roster-file-summary-hero:has(.roster-file-summary--no-org)::before {
  width: 58%; }

.roster-file-summary__primary {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  padding: 12px 20px 12px 10px; }

.roster-file-summary__avatar-stack {
  position: relative;
  width: 80px;
  height: 100px;
  flex-shrink: 0; }

.roster-file-summary__avatar-discord {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: auto;
  height: 75px;
  border-radius: 50%;
  object-fit: cover;
  z-index: 1;
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.55)); }

.roster-file-summary__avatar-ring {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 75px;
  height: 75px;
  border-radius: 50%;
  border: 3px solid #5ac3ff;
  box-sizing: border-box;
  z-index: 2;
  pointer-events: none; }

.roster-file-summary__avatar-halo {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 79px;
  height: 79px;
  border-radius: 50%;
  z-index: 0;
  pointer-events: none; }

.roster-file-summary__rank {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  min-width: 0; }

.roster-file-summary__rank-img {
  height: 65px;
  object-fit: contain;
  filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.95)) drop-shadow(0 1px 2px rgba(0, 0, 0, 0.55));
  transform: translateZ(0); }

.roster-file .roster-file-summary__rank-img {
  filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.75)) drop-shadow(0 3px 5px rgba(0, 0, 0, 0.75)); }

.roster-file-summary__rank-img--empty {
  border-radius: 14px;
  border: 1px solid rgba(58, 120, 180, 0.18);
  background: rgba(0, 0, 0, 0.1); }

.roster-file-summary__org {
  display: grid;
  align-content: center;
  gap: 8px;
  min-width: 0;
  flex: 1 1 auto; }

.roster-file-summary__moniker-row {
  display: flex;
  align-items: center;
  min-width: 0; }

.roster-file-summary__donor-gem {
  position: absolute;
  z-index: 3;
  left: calc(42% - 44px);
  top: 22%;
  width: 20px;
  height: 20px;
  transform: translateY(-50%);
  overflow: visible;
  pointer-events: auto; }
  .roster-file-summary__donor-gem .donor-gem-badge__wrap {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 20px;
    height: 20px;
    transform: translate(-50%, -50%); }
  .roster-file-summary__donor-gem .donor-gem-badge__wrap--premium::before {
    inset: -6px; }
  .roster-file-summary__donor-gem .donor-gem-badge__gem {
    width: 20px;
    height: 20px; }
  .roster-file-summary__donor-gem .donor-gem-badge__tooltip {
    left: 50%;
    right: auto;
    transform: translate(-50%, -2px); }
  .roster-file-summary__donor-gem .donor-gem-badge__wrap:hover .donor-gem-badge__tooltip,
  .roster-file-summary__donor-gem .donor-gem-badge__wrap:focus-within .donor-gem-badge__tooltip {
    transform: translate(-50%, 0); }

.roster-file-summary-hero:has(.roster-file-summary--no-org) .roster-file-summary__donor-gem {
  left: calc(58% - 44px); }

.roster-file-summary__moniker {
  margin: 0;
  flex: 1 1 auto;
  min-width: 0;
  font-family: 'GoodTimes', 'Lato', sans-serif;
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #ffffff;
  line-height: 1.15;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%; }

.roster-file-summary__rank-name-wrap {
  position: relative;
  display: inline-block;
  max-width: 100%;
  min-width: 0;
  cursor: default; }
  .roster-file-summary__rank-name-wrap:hover .roster-file-summary__rank-paygrade-tooltip, .roster-file-summary__rank-name-wrap:focus-within .roster-file-summary__rank-paygrade-tooltip {
    opacity: 1;
    visibility: visible;
    transform: translateY(0); }

.roster-file-summary__rank-name {
  font-size: 0.71rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(90, 195, 255, 0.95);
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%; }
  .roster-file-summary__rank-name.roster-file-summary__rank-name--split {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.08em;
    line-height: 1.18;
    text-align: left;
    white-space: normal;
    overflow: visible;
    text-overflow: unset; }

.roster-file-summary__rank-name__line1 {
  font-size: inherit; }

.roster-file-summary__rank-name__line2 {
  font-size: 0.86em;
  opacity: 0.92;
  letter-spacing: 0.02em; }

.roster-file-summary__rank-paygrade-tooltip {
  position: absolute;
  left: 0;
  top: calc(100% + 6px);
  z-index: 4;
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  min-width: 52px;
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid #3a78b4;
  background: #1e3042;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  line-height: 1.2;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-2px);
  transition: opacity 0.15s ease, visibility 0.15s ease, transform 0.15s ease;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.45), 0 0 0 1px rgba(0, 0, 0, 0.18); }

.roster-file-summary__rank-paygrade-tooltip__label {
  color: rgba(184, 184, 184, 0.76); }

.roster-file-summary__rank-paygrade-tooltip__value {
  color: rgba(223, 223, 223, 0.95); }

.roster-file-summary__meta-line {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  font-size: 10px;
  font-weight: 650;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  line-height: 1.2;
  min-width: 0; }

.roster-file-summary__meta-part {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  min-width: 0; }

.roster-file-summary__meta-sep {
  color: rgba(184, 184, 184, 0.55);
  flex-shrink: 0; }

.roster-file-summary__meta-assignment {
  color: #5ac3ff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.roster-file-summary__field-label {
  margin-right: 6px;
  font-size: 0.6rem;
  font-weight: 750;
  color: rgba(184, 184, 184, 0.76);
  letter-spacing: 0.04em; }

.roster-file-summary__field-value {
  color: rgba(184, 184, 184, 0.76); }

.roster-file-summary__org-details {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  align-self: stretch;
  margin: 6px 4px;
  padding: 12px 8px 16px 8px;
  min-width: 0; }
  .roster-file-summary__org-details::before {
    content: '';
    position: absolute;
    top: -5;
    left: 18px;
    right: 18px;
    height: 1px;
    background: linear-gradient(90deg, transparent 0%, rgba(58, 120, 180, 0.55) 50%, transparent 100%);
    pointer-events: none; }
  .roster-file-summary__org-details::after {
    content: '';
    position: absolute;
    left: -10px;
    right: -10px;
    bottom: -17px;
    height: 18px;
    background: repeating-linear-gradient(-52deg, rgba(58, 120, 180, 0.24) 0, rgba(58, 120, 180, 0.24) 3px, transparent 3px, transparent 10px);
    mask-image: linear-gradient(90deg, transparent 0%, rgba(0, 0, 0, 0.92) 14%, rgba(0, 0, 0, 0.92) 86%, transparent 100%);
    opacity: 0.85;
    pointer-events: none; }

.roster-file-structure-strip {
  position: relative;
  z-index: 1;
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: space-evenly;
  gap: 0;
  width: 100%;
  min-width: 0; }

.roster-file-structure-strip--empty {
  width: 100%;
  font-size: 12px;
  text-align: center;
  color: rgba(223, 223, 223, 0.88); }

.roster-file-structure-strip__item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 1 auto;
  min-width: 0;
  max-width: 7rem;
  gap: 4px; }

.roster-file-structure-strip__surface {
  box-sizing: border-box;
  width: 3.25rem;
  height: 4.5rem;
  min-width: 5rem;
  min-height: 3.25rem;
  max-width: 6rem;
  max-height: 5.25rem;
  margin: 0;
  padding: 0.2rem;
  border-radius: 6px;
  border: 1px solid rgba(120, 165, 200, 0.55);
  color: #dfdfdf;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: box-shadow 0.15s ease; }

.roster-file-structure-strip__surface--neutral {
  background: rgba(0, 48, 77, 0.55);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.22); }

.roster-file-structure-strip__logo {
  display: block;
  width: auto;
  max-width: 3.35rem;
  max-height: 3.15rem;
  object-fit: contain; }

.roster-file-structure-strip__logo--placeholder {
  display: block;
  width: 2rem;
  height: 1.85rem;
  flex-shrink: 0;
  opacity: 0;
  pointer-events: none; }

.roster-file-structure-strip__label {
  width: 100%;
  max-width: 5.25rem;
  font-size: 9px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0.02em;
  text-align: center;
  color: rgba(223, 223, 223, 0.9);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical; }

.roster-file-org-line {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0; }

.roster-file-section-edit,
.roster-file-section-confirm {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid rgba(58, 120, 180, 0.35);
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.2);
  color: rgba(223, 223, 223, 0.92);
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease; }
  .roster-file-section-edit:hover:not(:disabled),
  .roster-file-section-confirm:hover:not(:disabled) {
    background: rgba(58, 120, 180, 0.18);
    border-color: rgba(58, 120, 180, 0.55); }
  .roster-file-section-edit:disabled,
  .roster-file-section-confirm:disabled {
    opacity: 0.45;
    cursor: not-allowed; }

.roster-file-section-picker {
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
  flex: 1; }

.roster-file-org-block__lines .roster-file-section-picker {
  display: grid;
  grid-template-columns: 1fr auto;
  column-gap: 8px;
  row-gap: 8px;
  align-items: start; }

.roster-file-org-block__lines .roster-file-section-select {
  grid-column: 1;
  max-width: none; }

.roster-file-org-block__lines .roster-file-section-select__btn {
  width: 100%;
  min-width: 220px; }

.roster-file-org-block__lines .roster-file-section-confirm {
  grid-column: 2;
  grid-row: 1 / span 2;
  align-self: center; }

.roster-file-org-block__lines .roster-file-section-picker__error {
  grid-column: 1 / -1; }

.roster-file-section-select {
  position: relative;
  flex: 0 1 auto;
  min-width: 0;
  max-width: 260px; }

.roster-file-section-select__btn {
  width: 140px;
  height: 30px;
  padding: 0 8px;
  border-radius: 6px;
  border: 1px solid rgba(58, 120, 180, 0.35);
  background: rgba(0, 0, 0, 0.25);
  color: rgba(223, 223, 223, 0.92);
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease; }
  .roster-file-section-select__btn:hover:not(:disabled) {
    background: rgba(0, 0, 0, 0.32);
    border-color: rgba(58, 120, 180, 0.5); }
  .roster-file-section-select__btn:disabled {
    opacity: 0.55;
    cursor: not-allowed; }

.roster-file-section-select__btn-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.roster-file-section-select__caret {
  flex-shrink: 0;
  color: rgba(223, 223, 223, 0.72);
  font-size: 12px;
  line-height: 1; }

.roster-file-section-select__menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  width: 100%;
  max-height: 240px;
  overflow-x: hidden;
  overflow-y: auto;
  border-radius: 10px;
  border: 1px solid rgba(58, 120, 180, 0.28);
  background: rgba(8, 14, 20, 0.96);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.6);
  z-index: 2000; }
  .roster-file-section-select__menu::-webkit-scrollbar {
    width: 6px; }
  .roster-file-section-select__menu::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .roster-file-section-select__menu::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .roster-file-section-select__menu::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }

.roster-file-section-select__option {
  display: block;
  width: auto;
  text-align: left;
  padding: 8px 10px;
  background: transparent;
  border: 0;
  color: rgba(223, 223, 223, 0.9);
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%; }
  .roster-file-section-select__option:hover {
    background: rgba(58, 120, 180, 0.14); }
  .roster-file-section-select__option.is-selected {
    background: rgba(58, 120, 180, 0.22);
    color: rgba(223, 223, 223, 0.96);
    width: stretch; }

.roster-file-section-select__empty {
  padding: 10px;
  font-size: 12px;
  color: rgba(223, 223, 223, 0.7); }

.roster-file-section-picker__loading {
  font-size: 14px;
  color: rgba(223, 223, 223, 0.75); }

.roster-file-section-picker__error {
  flex-basis: 100%;
  font-size: 11px;
  color: rgba(219, 86, 86, 0.92);
  line-height: 1.3; }

.roster-file-section-picker__error--inline {
  flex-basis: auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 240px;
  margin-left: 2px; }

.roster-file-section-notice {
  margin: 0 16px 12px;
  padding: 10px 12px;
  font-size: 12px;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.88);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  background: rgba(12, 38, 55, 0.25); }

.roster-file-org-logo {
  width: 45px;
  object-fit: contain;
  opacity: 0.95;
  flex-shrink: 0;
  box-sizing: border-box; }
  .roster-file-org-logo--placeholder {
    display: inline-block;
    flex-shrink: 0;
    opacity: 0;
    pointer-events: none; }

.roster-file-org-block {
  display: grid;
  grid-template-columns: 50px 1fr;
  column-gap: 10px;
  min-width: 0; }

.roster-file-org-block__lines {
  display: grid;
  align-content: start;
  gap: 6px;
  min-width: 0; }

.roster-file-org-logo--tall {
  height: 50px;
  align-self: start; }

.roster-file-org-logo--tall.roster-file-org-logo--placeholder {
  height: 50px; }

.roster-file-org-name {
  font-size: 15px;
  color: rgba(223, 223, 223, 0.88);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.roster-file-identity__accent-bar {
  position: absolute;
  left: 8px;
  right: 28px;
  bottom: 7px;
  height: 10px;
  z-index: 1;
  pointer-events: none;
  background: repeating-linear-gradient(-52deg, rgba(58, 120, 180, 0.24) 0, rgba(58, 120, 180, 0.24) 3px, transparent 3px, transparent 10px);
  mask-image: linear-gradient(90deg, transparent 0%, rgba(0, 0, 0, 0.9) 16%, rgba(0, 0, 0, 0.9) 70%, transparent 100%);
  opacity: 0.88; }

.roster-file-identity__text {
  position: relative;
  z-index: 1;
  display: grid;
  font-size: 10px;
  gap: 6px;
  min-width: 0;
  width: 100%;
  pointer-events: auto; }

.roster-file-identity__avatar {
  width: 46px;
  height: 46px;
  border-radius: 10px;
  object-fit: cover;
  border: 1px solid rgba(58, 120, 180, 0.22);
  background: rgba(0, 0, 0, 0.18);
  flex-shrink: 0; }

.roster-file-identity__avatar--empty {
  background: rgba(255, 255, 255, 0.06); }

.roster-file-identity__row {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 8px;
  align-items: center;
  min-width: 0; }

.roster-file-identity__label {
  font-size: 11px;
  font-weight: 750;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(90, 195, 255, 0.68);
  white-space: nowrap; }
  .roster-file-identity__label--icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    flex-shrink: 0; }
    .roster-file-identity__label--icon img {
      display: block;
      width: 22px;
      height: 22px;
      object-fit: contain;
      opacity: 0.92; }

.roster-file-identity__icon-spacer {
  display: block;
  width: 28px;
  height: 18px;
  flex-shrink: 0; }

.roster-file-identity__value {
  font-size: 13px;
  color: rgba(223, 223, 223, 0.9);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 260px; }

.roster-file-assignment {
  font-size: 12px;
  color: rgba(223, 223, 223, 0.88);
  text-align: right;
  max-width: 320px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-top: 2px; }

.roster-file-assignment--left {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(90, 195, 255, 0.86);
  line-height: 1.1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  text-align: left; }

.roster-file-tabs {
  position: relative;
  display: flex;
  gap: 8px;
  border-bottom: none;
  padding: 10px 16px 12px 16px; }
  .roster-file-tabs::before {
    content: '';
    position: absolute;
    left: 10px;
    right: 10px;
    bottom: 0;
    height: 13px;
    z-index: 0;
    clip-path: polygon(5% 0, 95% 0, 100% 100%, 0 100%);
    background: rgba(23, 39, 56, 0.78);
    border-top: 1px solid rgba(58, 120, 180, 0.38);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.07), 0 2px 8px rgba(0, 0, 0, 0.22);
    pointer-events: none; }
  .roster-file-tabs::after {
    content: '';
    position: absolute;
    right: 5px;
    bottom: 9px;
    width: 50px;
    height: 5px;
    z-index: 0;
    pointer-events: none;
    background: linear-gradient(90deg, rgba(58, 120, 180, 0.62) 0, rgba(58, 120, 180, 0.62) 13px, transparent 13px, transparent 17px, rgba(58, 120, 180, 0.62) 17px, rgba(58, 120, 180, 0.62) 30px, transparent 30px, transparent 34px, rgba(58, 120, 180, 0.62) 34px, rgba(58, 120, 180, 0.62) 47px, transparent 47px);
    filter: drop-shadow(0 0 4px rgba(58, 120, 180, 0.75)); }

.roster-file-tab {
  position: relative;
  z-index: 1;
  border: 1px solid rgba(58, 120, 180, 0.25);
  border-bottom: none;
  background: #172738;
  color: rgba(223, 223, 223, 0.85);
  padding: 5px 20px;
  border-radius: 6px 6px 0 0;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease; }
  .roster-file-tab:hover {
    background: #133b53;
    border-color: rgba(58, 120, 180, 0.4);
    color: #dfdfdf; }
  .roster-file-tab.is-active {
    background: #133b53;
    border-color: rgba(58, 120, 180, 0.55);
    color: #dfdfdf; }
    .roster-file-tab.is-active::after {
      content: '';
      position: absolute;
      left: 10px;
      right: 10px;
      bottom: -2px;
      height: 2px;
      border-radius: 999px;
      background: linear-gradient(90deg, rgba(58, 120, 180, 0) 0%, rgba(58, 120, 180, 0.95) 35%, rgba(255, 255, 255, 0.75) 50%, rgba(58, 120, 180, 0.95) 65%, rgba(58, 120, 180, 0) 100%);
      box-shadow: 0 0 8px rgba(58, 120, 180, 0.65), 0 0 16px rgba(58, 120, 180, 0.35); }

.roster-file-loading,
.roster-file-error {
  padding: 18px 16px; }

.roster-file-error {
  color: rgba(158, 34, 34, 0.92); }

.roster-file-view {
  padding: 16px;
  flex: 1 1 auto;
  min-height: 0; }

.roster-file-view--statistics {
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none; }

.roster-file-view--statistics::-webkit-scrollbar {
  width: 0;
  height: 0; }

.roster-file-view--history {
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow: hidden; }

.roster-file-view--ribbons {
  padding: 0;
  overflow: hidden; }

.roster-file-ribbons-toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px; }

.roster-file-ribbons-toolbar__btn {
  border: 1px solid rgba(58, 120, 180, 0.28);
  background: rgba(0, 0, 0, 0.18);
  color: rgba(223, 223, 223, 0.92);
  border-radius: 10px;
  padding: 8px 10px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 650;
  letter-spacing: 0.02em;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease; }
  .roster-file-ribbons-toolbar__btn:hover {
    background: rgba(58, 120, 180, 0.14);
    border-color: rgba(58, 120, 180, 0.55);
    color: rgba(223, 223, 223, 0.98); }

.roster-file-ribbons-scroll {
  padding: 5px 16px 16px;
  height: 100%;
  max-height: none;
  overflow-x: hidden;
  overflow-y: auto; }
  .roster-file-ribbons-scroll::-webkit-scrollbar {
    width: 6px; }
  .roster-file-ribbons-scroll::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .roster-file-ribbons-scroll::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .roster-file-ribbons-scroll::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }

.roster-file-ribbons-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 30px; }

.roster-file-ribbon-card {
  border: 1px solid rgba(58, 120, 180, 0.18);
  background: rgba(0, 0, 0, 0.14);
  border-radius: 14px;
  padding: 10px;
  position: relative; }

.roster-file-ribbon-card--locked .ribbon-details {
  opacity: 0.3; }

.roster-file-ribbon-progress {
  margin-bottom: 6px; }

.roster-file-ribbon-progress__bar-wrap {
  position: relative;
  width: 100%;
  min-width: 0; }

.roster-file-ribbon-progress__track {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 2px;
  width: 100%;
  border: 1px solid rgba(58, 120, 180, 0.22);
  border-radius: 4px;
  padding: 2px;
  min-width: 0;
  min-height: 12px; }

.roster-file-ribbon-progress__track--empty .roster-file-ribbon-progress__segment {
  opacity: 0.85; }

.roster-file-ribbon-progress__segment {
  flex: 1 1 0;
  min-width: 3px;
  border-radius: 0;
  background: rgba(0, 0, 0, 0.22);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
  transition: background 0.18s ease, border-color 0.18s ease; }
  .roster-file-ribbon-progress__segment:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px; }
  .roster-file-ribbon-progress__segment:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px; }
  .roster-file-ribbon-progress__segment.is-filled {
    background: rgba(0, 72, 114, 0.62);
    border-color: rgba(58, 120, 180, 0.35);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06); }

.roster-file-ribbon-progress__track--complete .roster-file-ribbon-progress__segment.is-filled {
  background: rgba(63, 124, 66, 0.72);
  border-color: rgba(63, 124, 66, 0.45); }

.roster-file-ribbon-progress__label {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -42%);
  z-index: 1;
  pointer-events: none;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 650;
  color: rgba(223, 223, 223, 0.96);
  font-variant-numeric: tabular-nums;
  line-height: 1.15;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px); }

.roster-file-ribbon-handle {
  position: absolute;
  left: 8px;
  bottom: 8px;
  z-index: 3; }

.roster-file-ribbon-handle__btn {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  border: 1px solid rgba(58, 120, 180, 0.38);
  background: rgba(0, 0, 0, 0.35);
  color: rgba(223, 223, 223, 0.92);
  font-size: 12px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease; }
  .roster-file-ribbon-handle__btn:hover {
    background: rgba(58, 120, 180, 0.16);
    border-color: rgba(58, 120, 180, 0.55); }

.roster-file-ribbon-handle__tooltip {
  position: absolute;
  left: 0;
  bottom: 24px;
  min-width: 200px;
  max-width: 280px;
  padding: 10px 10px;
  border-radius: 10px;
  border: 1px solid rgba(58, 120, 180, 0.28);
  background: rgba(8, 14, 20, 0.92);
  color: rgba(223, 223, 223, 0.92);
  font-size: 12px;
  line-height: 1.35;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.55), 0 0 0 1px rgba(0, 0, 0, 0.22);
  white-space: pre-wrap; }

.roster-file-ribbon-card .ribbon-details {
  transform: scale(0.95);
  transform-origin: top center; }

.roster-file-ribbon-info {
  position: absolute;
  right: 8px;
  bottom: 8px;
  z-index: 2; }

.roster-file-ribbon-info__btn {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  border: 1px solid rgba(58, 120, 180, 0.38);
  background: rgba(0, 0, 0, 0.35);
  color: rgba(223, 223, 223, 0.92);
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease; }
  .roster-file-ribbon-info__btn:hover {
    background: rgba(58, 120, 180, 0.16);
    border-color: rgba(58, 120, 180, 0.55); }

.roster-file-ribbon-info__tooltip {
  position: absolute;
  right: 0;
  bottom: 24px;
  min-width: 200px;
  max-width: 280px;
  padding: 10px 10px;
  border-radius: 10px;
  border: 1px solid rgba(58, 120, 180, 0.28);
  background: rgba(8, 14, 20, 0.92);
  color: rgba(223, 223, 223, 0.92);
  font-size: 12px;
  line-height: 1.35;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.55), 0 0 0 1px rgba(0, 0, 0, 0.22);
  white-space: pre-wrap; }

.roster-file-ribbon-name {
  margin-top: 8px;
  font-size: 12px;
  color: rgba(223, 223, 223, 0.88);
  text-align: center;
  line-height: 1.15; }

.roster-file-placeholder {
  padding: 16px;
  border: 1px dashed rgba(58, 120, 180, 0.25);
  border-radius: 12px;
  color: rgba(223, 223, 223, 0.75); }

.roster-file-stat-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px; }

.roster-file-stat-card {
  border: 1px solid rgba(58, 120, 180, 0.18);
  background: rgba(0, 0, 0, 0.14);
  border-radius: 14px;
  padding: 14px; }

.roster-file-stat-title {
  font-size: 12px;
  font-weight: 650;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: rgba(223, 223, 223, 0.9);
  margin-bottom: 10px; }

.roster-file-stat-lines {
  display: grid;
  gap: 8px; }

.roster-file-stat-line {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  font-size: 12px;
  color: rgba(223, 223, 223, 0.82); }

.roster-file-trainings {
  margin-top: 16px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px; }
  .roster-file-trainings .roster-file-basic-icons {
    margin-bottom: 12px; }
  .roster-file-trainings .basic-icons {
    display: flex;
    gap: 8px;
    align-items: center; }
    .roster-file-trainings .basic-icons .basic-icon {
      width: 22px;
      height: 22px;
      object-fit: contain; }
    .roster-file-trainings .basic-icons .basic-icon.certified {
      opacity: 0.9; }
    .roster-file-trainings .basic-icons .basic-icon.required {
      opacity: 0.25; }

.roster-file-stat-charts {
  margin-top: 14px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px; }

.roster-file-stat-charts--solo {
  grid-template-columns: 1fr; }

.roster-file-stat-card--chart {
  display: grid;
  grid-template-rows: auto 1fr;
  gap: 10px; }

.roster-file-stat-card--chart-wide {
  grid-column: 1 / -1; }

.roster-file-chart {
  position: relative;
  width: 100%;
  min-height: 0; }

.roster-file-chart--line {
  height: 240px; }

.roster-file-chart--bars {
  height: 520px; }

.roster-file-stat-card__scroll {
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  padding-right: 6px;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.35) rgba(0, 0, 0, 0.12); }

.roster-file-stat-card__scroll--bars {
  max-height: 260px; }

.roster-file-stat-card__scroll::-webkit-scrollbar {
  width: 6px; }

.roster-file-stat-card__scroll::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.12);
  border-radius: 999px; }

.roster-file-stat-card__scroll::-webkit-scrollbar-thumb {
  background: rgba(58, 120, 180, 0.3);
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.08); }

.roster-file-stat-card__scroll::-webkit-scrollbar-thumb:hover {
  background: rgba(58, 120, 180, 0.42); }

@media (max-width: 720px) {
  .roster-file-trainings,
  .roster-file-stat-charts {
    grid-template-columns: 1fr; }
  .roster-file-stat-card--chart-wide {
    grid-column: auto; } }

.roster-file-section-title {
  font-size: 12px;
  font-weight: 650;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: rgba(223, 223, 223, 0.9);
  margin-bottom: 10px; }

.roster-file-history-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding-right: 2px; }
  .roster-file-history-scroll::-webkit-scrollbar {
    width: 6px; }
  .roster-file-history-scroll::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .roster-file-history-scroll::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .roster-file-history-scroll::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }

.roster-file-history {
  display: grid;
  gap: 10px; }

.roster-file-history-row {
  display: grid;
  grid-template-columns: 110px 1fr auto;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid rgba(58, 120, 180, 0.16);
  background: rgba(0, 0, 0, 0.12);
  border-radius: 12px; }

.roster-file-history-row__date {
  font-family: ui-monospace, "Cascadia Mono", "Segoe UI Mono", monospace;
  font-size: 12px;
  color: rgba(223, 223, 223, 0.82); }

.roster-file-history-row__link {
  appearance: none;
  border: none;
  background: none;
  padding: 0;
  text-align: left;
  cursor: pointer;
  color: rgba(58, 120, 180, 0.92);
  font-size: 13px;
  font-weight: 650;
  text-decoration: underline;
  text-decoration-color: rgba(58, 120, 180, 0.35);
  text-underline-offset: 3px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }
  .roster-file-history-row__link:hover {
    color: #dfdfdf;
    text-decoration-color: rgba(223, 223, 223, 0.55); }

.roster-file-history-row__meta {
  font-size: 12px;
  color: rgba(223, 223, 223, 0.72);
  white-space: nowrap; }

.roster-file-history-row.is-redacted {
  border-style: dashed;
  opacity: 0.78; }

.roster-file-history-row__redacted {
  font-family: ui-monospace, "Cascadia Mono", "Segoe UI Mono", monospace;
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.72);
  user-select: none; }

.calendar-event-modal.calendar-event-modal--roster-file .roster-file-top--event-modal,
.calendar-event-modal.calendar-event-modal--card-top .roster-file-top--event-modal {
  position: relative;
  z-index: 2;
  flex: 0 0 auto; }

.calendar-event-modal.calendar-event-modal--roster-file .roster-file-header--event-modal,
.calendar-event-modal.calendar-event-modal--card-top .roster-file-header--event-modal {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  padding: 4px 7px 6px 14px;
  margin: 0;
  height: auto;
  min-height: 38px;
  color: #dfdfdf;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: none;
  z-index: 30;
  isolation: isolate; }
  .calendar-event-modal.calendar-event-modal--roster-file .roster-file-header--event-modal::before,
  .calendar-event-modal.calendar-event-modal--card-top .roster-file-header--event-modal::before {
    content: '';
    position: absolute;
    inset: 0;
    clip-path: polygon(0% 0%, 100% 0%, 100% 70%, 35% 70%, 30% 100%, 0% 100%);
    pointer-events: none;
    z-index: -1;
    background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center; }
  .calendar-event-modal.calendar-event-modal--roster-file .roster-file-header--event-modal::after,
  .calendar-event-modal.calendar-event-modal--card-top .roster-file-header--event-modal::after {
    content: '';
    position: absolute;
    inset: 0;
    transform: translateY(5px);
    clip-path: polygon(0% 0%, 100% 0%, 100% 70%, 35% 70%, 30% 100%, 0% 100%);
    pointer-events: none;
    z-index: -2;
    background: #350404;
    filter: drop-shadow(0 2px 0 rgba(0, 0, 0, 0.65)) drop-shadow(0 0 10px rgba(58, 120, 180, 0.18)); }
  .calendar-event-modal.calendar-event-modal--roster-file .roster-file-header--event-modal h2,
  .calendar-event-modal.calendar-event-modal--card-top .roster-file-header--event-modal h2 {
    font-size: 0.8rem;
    margin: 0;
    color: #dfdfdf; }
  .calendar-event-modal.calendar-event-modal--roster-file .roster-file-header--event-modal .roster-file-header__main,
  .calendar-event-modal.calendar-event-modal--card-top .roster-file-header--event-modal .roster-file-header__main {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
    padding-bottom: 1px; }
  .calendar-event-modal.calendar-event-modal--roster-file .roster-file-header--event-modal h2.roster-file-header-title,
  .calendar-event-modal.calendar-event-modal--card-top .roster-file-header--event-modal h2.roster-file-header-title {
    display: flex;
    align-items: center;
    width: 100%;
    min-width: 0;
    margin: 5px 0 0 0; }
  .calendar-event-modal.calendar-event-modal--roster-file .roster-file-header--event-modal .calendar-event-header-status,
  .calendar-event-modal.calendar-event-modal--card-top .roster-file-header--event-modal .calendar-event-header-status {
    flex-shrink: 0;
    line-height: 1; }
    .calendar-event-modal.calendar-event-modal--roster-file .roster-file-header--event-modal .calendar-event-header-status:empty,
    .calendar-event-modal.calendar-event-modal--card-top .roster-file-header--event-modal .calendar-event-header-status:empty {
      display: none; }
    .calendar-event-modal.calendar-event-modal--roster-file .roster-file-header--event-modal .calendar-event-header-status .calendar-event.status,
    .calendar-event-modal.calendar-event-modal--card-top .roster-file-header--event-modal .calendar-event-header-status .calendar-event.status {
      margin: 0; }
  .calendar-event-modal.calendar-event-modal--roster-file .roster-file-header--event-modal .roster-file-header-rank-name,
  .calendar-event-modal.calendar-event-modal--card-top .roster-file-header--event-modal .roster-file-header-rank-name {
    font-size: 1rem;
    font-weight: 700;
    letter-spacing: 0.03em;
    overflow: hidden;
    min-width: 0;
    max-width: 305px;
    flex: 1; }
  .calendar-event-modal.calendar-event-modal--roster-file .roster-file-header--event-modal .roster-file-header__tail,
  .calendar-event-modal.calendar-event-modal--card-top .roster-file-header--event-modal .roster-file-header__tail {
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    bottom: 6px;
    flex-shrink: 0;
    align-self: center; }
    .calendar-event-modal.calendar-event-modal--roster-file .roster-file-header--event-modal .roster-file-header__tail a.roster-file-tab,
    .calendar-event-modal.calendar-event-modal--card-top .roster-file-header--event-modal .roster-file-header__tail a.roster-file-tab {
      text-decoration: none;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 5px 10px;
      font-size: 11px;
      border-radius: 8px;
      color: rgba(223, 223, 223, 0.85); }
      .calendar-event-modal.calendar-event-modal--roster-file .roster-file-header--event-modal .roster-file-header__tail a.roster-file-tab:visited,
      .calendar-event-modal.calendar-event-modal--card-top .roster-file-header--event-modal .roster-file-header__tail a.roster-file-tab:visited {
        color: rgba(223, 223, 223, 0.85); }
    .calendar-event-modal.calendar-event-modal--roster-file .roster-file-header--event-modal .roster-file-header__tail .calendar-event-header-toolbar,
    .calendar-event-modal.calendar-event-modal--card-top .roster-file-header--event-modal .roster-file-header__tail .calendar-event-header-toolbar {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: flex-end;
      gap: 8px;
      min-width: 0;
      max-width: 100%; }
      .calendar-event-modal.calendar-event-modal--roster-file .roster-file-header--event-modal .roster-file-header__tail .calendar-event-header-toolbar .edit-mode,
      .calendar-event-modal.calendar-event-modal--card-top .roster-file-header--event-modal .roster-file-header__tail .calendar-event-header-toolbar .edit-mode {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px;
        margin: 0; }
      .calendar-event-modal.calendar-event-modal--roster-file .roster-file-header--event-modal .roster-file-header__tail .calendar-event-header-toolbar .btn-style1,
      .calendar-event-modal.calendar-event-modal--card-top .roster-file-header--event-modal .roster-file-header__tail .calendar-event-header-toolbar .btn-style1 {
        font-size: 11px;
        padding: 5px 10px; }
  .calendar-event-modal.calendar-event-modal--roster-file .roster-file-header--event-modal .close-btn,
  .calendar-event-modal.calendar-event-modal--card-top .roster-file-header--event-modal .close-btn {
    position: relative;
    background: none;
    border: none;
    color: #dfdfdf;
    font-size: 0.7rem;
    padding: 0 3px;
    border-radius: 3px;
    bottom: 0;
    flex-shrink: 0;
    cursor: pointer; }
    .calendar-event-modal.calendar-event-modal--roster-file .roster-file-header--event-modal .close-btn:hover,
    .calendar-event-modal.calendar-event-modal--card-top .roster-file-header--event-modal .close-btn:hover {
      color: #151c24;
      background-color: #dfdfdf; }

.calendar-event-modal.calendar-event-modal--roster-file .calendar-event-card-banner,
.calendar-event-modal.calendar-event-modal--card-top .calendar-event-card-banner {
  height: 200px;
  margin-top: -16px;
  padding-top: 16px;
  border: 1px solid rgba(58, 120, 180, 0.32);
  border-bottom: none;
  border-radius: 8px 8px 0 0;
  position: relative;
  overflow: hidden;
  background: #163447;
  z-index: 20; }
  .calendar-event-modal.calendar-event-modal--roster-file .calendar-event-card-banner::after,
  .calendar-event-modal.calendar-event-modal--card-top .calendar-event-card-banner::after {
    content: '';
    position: absolute;
    left: 12px;
    right: 12px;
    bottom: -3px;
    height: 3px;
    border-radius: 50%;
    pointer-events: none;
    z-index: 1;
    background: linear-gradient(90deg, rgba(58, 120, 180, 0) 0%, rgba(58, 120, 180, 0.58) 25%, rgba(255, 255, 255, 0.4) 50%, rgba(58, 120, 180, 0.58) 75%, rgba(58, 120, 180, 0) 100%);
    box-shadow: 0 0 10px rgba(58, 120, 180, 0.32), 0 0 20px rgba(58, 120, 180, 0.2);
    opacity: 0.95; }

.calendar-event-modal.calendar-event-modal--roster-file .calendar-event-card-banner__img,
.calendar-event-modal.calendar-event-modal--card-top .calendar-event-card-banner__img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.9;
  z-index: 0; }

.private-pages .filter-container.roster {
  width: 100%;
  max-width: 100%;
  margin-top: 0.3rem;
  margin-bottom: 0.75rem;
  box-sizing: border-box; }

.roster-toolbar {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.55rem;
  width: 100%;
  box-sizing: border-box; }

.roster-toolbar-card {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0;
  padding: 0.7rem 0.8rem;
  border-radius: 10px;
  border: 1px solid rgba(52, 90, 120, 0.45);
  background: linear-gradient(180deg, #1e3042, #172738);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35) inset, 0 2px 14px rgba(0, 0, 0, 0.25);
  box-sizing: border-box; }
  .roster-toolbar-card--search {
    flex: 1 1 14rem;
    min-width: 0;
    max-width: 100%; }
  .roster-toolbar-card--stat-tile {
    flex: 0 0 auto;
    flex-shrink: 0;
    gap: 0.4rem;
    padding: 0.7rem 0.8rem; }

.roster-toolbar-card__search {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  min-width: 0;
  gap: 0.4rem;
  padding: 0 0.5rem;
  margin: 0;
  min-height: 1.65rem;
  border-radius: 7px;
  border: 1px solid rgba(58, 140, 200, 0.45);
  background: #1c2d38;
  box-shadow: 0 0 0 1px rgba(40, 120, 200, 0.08); }
  .roster-toolbar-card__search:focus-within {
    border-color: rgba(90, 170, 240, 0.65);
    box-shadow: 0 0 0 1px rgba(40, 140, 220, 0.2), 0 0 12px rgba(40, 120, 200, 0.15); }

.roster-toolbar-card__search-glyph {
  flex-shrink: 0;
  color: #679cce; }

.roster-toolbar-card__input {
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  padding: 0.12rem 0.1rem;
  font-size: 0.8rem;
  line-height: 1.25;
  color: #dfdfdf; }
  .roster-toolbar-card__input::-webkit-search-cancel-button {
    display: none; }
  .roster-toolbar-card__input::placeholder {
    color: rgba(155, 170, 186, 0.75); }

.roster-toolbar-card__clear {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 22px;
  height: 22px;
  border-radius: 5px;
  border: 1px solid rgba(120, 140, 160, 0.35);
  background: rgba(0, 0, 0, 0.25);
  color: #b8b8b8;
  font-size: 0.72rem;
  line-height: 1;
  cursor: pointer; }
  .roster-toolbar-card__clear:hover {
    background: rgba(255, 255, 255, 0.08);
    color: #ffffff; }

.roster-toolbar-card__vsep {
  align-self: stretch;
  width: 1px;
  min-height: 1.45rem;
  margin: auto 0.2rem;
  background: rgba(70, 100, 128, 0.45); }
  .roster-toolbar-card > .roster-toolbar-card__vsep:last-child {
    display: none; }
  @media screen and (max-width: 900px) {
    .roster-toolbar-card--search > .roster-toolbar-card__vsep {
      display: none; } }

.roster-toolbar-card__reset {
  display: inline-flex;
  align-items: center;
  gap: 0.32rem;
  flex-shrink: 0;
  margin: 0 0 0 0.1rem;
  padding: 0.28rem 0.5rem;
  border: none;
  border-radius: 6px;
  background: transparent;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #6096cc;
  cursor: pointer; }
  .roster-toolbar-card__reset:hover {
    color: #86b0d8;
    background: rgba(40, 100, 160, 0.12); }

.roster-toolbar-card__reset-glyph {
  flex-shrink: 0; }

.roster-toolbar-card__stat-icon {
  flex-shrink: 0;
  color: #679cce;
  width: 25px;
  height: 22px; }

/* Logo org (même source que le header) — 25×25, teinte bleue comme la tuile Certified */
.roster-toolbar-card__org-logo {
  display: block;
  flex-shrink: 0;
  width: 25px;
  height: 18px;
  object-fit: contain;
  filter: sepia(0.35) hue-rotate(165deg) saturate(1.45) brightness(1.06) drop-shadow(0 0 3px rgba(80, 170, 240, 0.45)); }
  .roster-toolbar-card--stat-tile:hover .roster-toolbar-card__org-logo {
    filter: sepia(0.38) hue-rotate(165deg) saturate(1.55) brightness(1.1) drop-shadow(0 0 6px rgba(120, 200, 255, 0.55)); }

/* Même asset que \`.certification-icon.certified\` (react-table.scss), format compact + teinte bleue */
.roster-toolbar-card__cert-icon {
  display: inline-block;
  flex-shrink: 0;
  width: 25px;
  height: 25px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  opacity: 1;
  filter: hue-rotate(105deg) saturate(1.3) brightness(1.07) drop-shadow(0 0 3px rgba(80, 170, 240, 0.5)); }
  .roster-toolbar-card--stat-tile:hover .roster-toolbar-card__cert-icon {
    filter: hue-rotate(105deg) saturate(1.45) brightness(1.12) drop-shadow(0 0 6px rgba(120, 200, 255, 0.65)); }

.roster-toolbar-card__stat-text {
  display: flex;
  flex-direction: column;
  gap: 0.06rem;
  min-width: 0; }

.roster-toolbar-card__stat-label {
  font-size: 0.54rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #747b81;
  white-space: nowrap; }

.roster-toolbar-card__stat-value {
  font-size: 0.98rem;
  font-weight: 800;
  color: #ffffff;
  line-height: 1.1; }

.roster-toolbar-card--action {
  cursor: pointer;
  gap: 0.45rem;
  color: #dfdfdf;
  font: inherit;
  appearance: none; }
  .roster-toolbar-card--action:hover, .roster-toolbar-card--action:focus-visible {
    border-color: rgba(90, 170, 240, 0.55);
    box-shadow: 0 0 0 1px rgba(40, 140, 220, 0.18) inset, 0 2px 14px rgba(0, 0, 0, 0.3); }

.roster-toolbar-card__action-icon {
  flex-shrink: 0;
  color: #6096cc; }

.roster-toolbar-card__action-label {
  font-size: 0.72rem;
  font-weight: 800;
  line-height: 1.7rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #dfdfdf;
  white-space: nowrap; }

.roster-empty-search-row .roster-empty-search {
  padding: 2rem 1rem;
  text-align: center;
  color: #6B7684;
  font-size: 0.95rem; }

.org-positions-browse-overlay {
  position: fixed;
  inset: 0;
  z-index: 12000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  background: rgba(21, 28, 36, 0.72);
  box-sizing: border-box; }

.org-positions-browse-modal {
  position: relative;
  display: flex;
  flex-direction: column;
  width: min(72rem, 100%);
  height: min(45rem, 92vh);
  overflow: hidden;
  border-radius: 10px;
  border: 1px solid rgba(58, 120, 180, 0.55);
  background-color: #172738;
  background: linear-gradient(180deg, rgba(0, 48, 77, 0.72), rgba(21, 28, 36, 0.42)), rgba(0, 48, 77, 0.55);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35), 0 12px 28px rgba(0, 0, 0, 0.35); }

.org-positions-browse-modal__browse {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden; }

.org-positions-browse-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  flex-shrink: 0;
  padding: 0.95rem 1.15rem 0.9rem;
  border-bottom: 1px solid rgba(58, 120, 180, 0.4);
  background: rgba(21, 28, 36, 0.28); }

.org-positions-browse-modal__heading {
  min-width: 0; }

.org-positions-browse-modal__title-row {
  display: flex;
  align-items: center;
  gap: 0.55rem; }

.org-positions-browse-modal__accent {
  flex-shrink: 0;
  width: 0.22rem;
  height: 1.15rem;
  border-radius: 2px;
  background: #c78445;
  box-shadow: 0 0 10px rgba(199, 132, 69, 0.35); }

.org-positions-browse-modal__title {
  margin: 0;
  font-size: 1rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #dfdfdf; }

.org-positions-browse-modal__subtitle {
  margin: 0.35rem 0 0;
  font-size: 0.78rem;
  line-height: 1.35;
  color: #747b81; }

.org-positions-browse-modal__close {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  padding: 0;
  border: 1px solid rgba(58, 120, 180, 0.45);
  border-radius: 8px;
  background: rgba(28, 45, 56, 0.65);
  color: #b8b8b8;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease; }
  .org-positions-browse-modal__close:hover, .org-positions-browse-modal__close:focus-visible {
    color: #dfdfdf;
    border-color: rgba(90, 195, 255, 0.65);
    background: #384858; }

.org-positions-browse-modal__body {
  display: grid;
  grid-template-columns: minmax(15rem, 18.5rem) minmax(0, 1fr);
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden; }

.org-positions-browse-sidebar {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  border-right: 1px solid rgba(58, 120, 180, 0.35);
  background: rgba(21, 28, 36, 0.28);
  min-height: 0;
  overflow: auto; }
  .org-positions-browse-sidebar::-webkit-scrollbar {
    width: 6px; }
  .org-positions-browse-sidebar::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .org-positions-browse-sidebar::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .org-positions-browse-sidebar::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }

.org-positions-browse__search {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  min-height: 2.15rem;
  padding: 0 0.65rem;
  border-radius: 8px;
  border: 1px solid rgba(58, 120, 180, 0.45);
  background: #1c2d38;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25) inset; }
  .org-positions-browse__search:focus-within {
    border-color: rgba(90, 195, 255, 0.65); }

.org-positions-browse__search-glyph {
  flex-shrink: 0;
  color: #679cce; }

.org-positions-browse__search-input {
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  color: #dfdfdf;
  font-size: 0.82rem; }
  .org-positions-browse__search-input::-webkit-search-cancel-button {
    display: none; }
  .org-positions-browse__search-input::placeholder {
    color: rgba(155, 170, 186, 0.75); }

.org-positions-browse-nav {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 0.45rem; }

.org-positions-browse-nav__label,
.org-positions-browse-legend__label {
  margin: 0;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #747b81; }

.org-positions-browse-nav__list,
.org-positions-browse-legend__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.3rem; }

.org-positions-browse-nav__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  width: 100%;
  padding: 0.55rem 0.65rem;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: #b8b8b8;
  font-size: 0.82rem;
  cursor: pointer;
  text-align: left;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease; }
  .org-positions-browse-nav__item:hover, .org-positions-browse-nav__item:focus-visible {
    background: rgba(58, 120, 180, 0.14);
    color: #dfdfdf;
    border-color: rgba(58, 120, 180, 0.35); }
  .org-positions-browse-nav__item.is-active {
    background: radial-gradient(circle at center, #004872 0%, #00304d 100%), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    border-color: rgba(90, 195, 255, 0.45);
    color: #dfdfdf;
    box-shadow: inset 0 0 0 1px #004872; }

.org-positions-browse-nav__item-count {
  font-size: 0.72rem;
  font-weight: 700;
  color: #747b81; }
  .is-active .org-positions-browse-nav__item-count {
    color: #c78445; }

.org-positions-browse-legend {
  margin-top: auto;
  padding-top: 0.75rem;
  border-top: 1px solid rgba(58, 120, 180, 0.3); }

.org-positions-browse-legend__list {
  margin-top: 0.45rem;
  gap: 0.4rem; }
  .org-positions-browse-legend__list li {
    display: flex;
    align-items: center;
    gap: 0.45rem;
    font-size: 0.78rem;
    color: #b8b8b8; }

.org-positions-browse-legend__swatch {
  width: 0.7rem;
  height: 0.7rem;
  border-radius: 3px;
  flex-shrink: 0; }
  .org-positions-browse-legend__swatch--division {
    background: #5ac3ff; }
  .org-positions-browse-legend__swatch--branch {
    background: #7958c3; }
  .org-positions-browse-legend__swatch--section {
    background: #75cf78; }
  .org-positions-browse-legend__swatch--special {
    background: #c78445; }

.org-positions-browse-main {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0; }

.org-positions-browse-main__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.85rem 1.15rem 0.75rem;
  border-bottom: 1px solid rgba(58, 120, 180, 0.3);
  background: rgba(21, 28, 36, 0.18); }

.org-positions-browse-main__heading {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0; }

.org-positions-browse-main__title {
  margin: 0;
  font-size: 0.82rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #dfdfdf; }

.org-positions-browse-main__count {
  font-size: 0.75rem;
  color: #747b81; }

.org-positions-browse-open-toggle {
  display: inline-flex;
  flex-shrink: 0;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #747b81;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);
  background: #1c2d38; }

.org-positions-browse-open-toggle__btn {
  min-width: 4.5rem;
  padding: 6px 14px;
  margin: 0;
  border: none;
  background: transparent;
  color: #b8b8b8;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease; }
  .org-positions-browse-open-toggle__btn:not(:last-child) {
    border-right: 1px solid #384858; }
  .org-positions-browse-open-toggle__btn:not(.is-active):hover, .org-positions-browse-open-toggle__btn:not(.is-active):focus-visible {
    background: #384858;
    color: #dfdfdf; }
  .org-positions-browse-open-toggle__btn.is-active {
    background: radial-gradient(circle at center, #004872 0%, #00304d 100%), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    color: #dfdfdf;
    box-shadow: inset 0 0 0 1px #004872; }

.org-positions-browse-main__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  padding: 0.9rem 1.15rem 1rem;
  margin-right: 0px;
  padding-right: 2px;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.35) rgba(0, 0, 0, 0.12); }
  .org-positions-browse-main__body::-webkit-scrollbar {
    width: 6px; }
  .org-positions-browse-main__body::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.12);
    border-radius: 999px; }
  .org-positions-browse-main__body::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.3);
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.08); }
  .org-positions-browse-main__body::-webkit-scrollbar-thumb:hover {
    background: rgba(58, 120, 180, 0.42); }

.org-positions-browse-main__loading,
.org-positions-browse-main__empty,
.org-positions-browse-main__error {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 10rem;
  margin: 0;
  color: #747b81;
  text-align: center; }

.org-positions-browse-main__error {
  color: #d8b493; }

.org-positions-browse-section + .org-positions-browse-section {
  margin-top: 1.25rem; }

.org-positions-browse-section__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.65rem; }

.org-positions-browse-section__title {
  margin: 0;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #747b81; }

.org-positions-browse-section__view-all {
  border: none;
  background: transparent;
  color: #5ac3ff;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  padding: 0; }
  .org-positions-browse-section__view-all:hover, .org-positions-browse-section__view-all:focus-visible {
    color: #83d2ff;
    text-decoration: underline; }

.org-positions-browse-section__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(11.5rem, 1fr));
  gap: 0.75rem; }

.org-positions-browse-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
  min-height: 12.5rem;
  padding: 0.95rem 0.75rem 0.7rem;
  border-radius: 10px;
  border: 1px solid rgba(58, 120, 180, 0.4);
  background: linear-gradient(180deg, rgba(0, 48, 77, 0.55), rgba(21, 28, 36, 0.35)), rgba(23, 39, 56, 0.92);
  color: #dfdfdf;
  cursor: pointer;
  text-align: center;
  transition: transform 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease; }
  .org-positions-browse-card:hover, .org-positions-browse-card:focus-visible {
    transform: translateY(-1px);
    border-color: rgba(90, 195, 255, 0.55); }
  .org-positions-browse-card--special {
    border-color: rgba(199, 132, 69, 0.5);
    box-shadow: inset 0 -2px 0 rgba(199, 132, 69, 0.8); }
  .org-positions-browse-card--no-logo {
    justify-content: flex-start; }
  .org-positions-browse-card--neutral {
    box-shadow: inset 0 -2px 0 rgba(58, 120, 180, 0.55); }

.org-positions-browse-card__logo-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4.4rem;
  height: 4.4rem;
  margin-bottom: 0.15rem;
  flex-shrink: 0; }

.org-positions-browse-card__logo {
  width: 4.2rem;
  height: 4.2rem;
  object-fit: contain;
  border-radius: 8px; }
  .org-positions-browse-card__logo--placeholder {
    display: block;
    background: rgba(56, 72, 88, 0.55);
    border: 1px dashed rgba(184, 184, 184, 0.35); }

.org-positions-browse-card__title {
  margin: 0;
  font-size: 0.88rem;
  font-weight: 800;
  line-height: 1.25;
  color: #ffffff;
  flex-shrink: 0; }

.org-positions-browse-card__meta {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
  min-height: 1.35rem;
  width: 100%; }
  .org-positions-browse-card__meta .roster-assignment-cell__segment--user-assignments {
    color: #5ac3ff;
    font-size: 0.74rem;
    font-weight: 600;
    line-height: 1.25; }

.org-positions-browse-card__commander {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.15rem;
  width: 100%;
  min-width: 0; }

.org-positions-browse-card__moniker-row {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  max-width: 100%;
  min-width: 0; }

.org-positions-browse-card__moniker {
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1.2;
  color: #dfdfdf;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.org-positions-browse-card__rank-icon {
  flex-shrink: 0;
  width: auto;
  height: 0.95rem;
  object-fit: contain; }

.org-positions-browse-card__open-chip {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  padding: 0.4rem 0.65rem;
  border-radius: 999px;
  border: 1px solid #75cf78;
  background: rgba(63, 124, 66, 0.35);
  color: #c2f0c3;
  width: fit-content;
  max-width: 100%;
  box-sizing: border-box; }

@media (max-width: 860px) {
  .org-positions-browse-modal {
    height: min(52rem, 94vh); }
  .org-positions-browse-modal__body {
    grid-template-columns: 1fr;
    grid-template-rows: auto minmax(0, 1fr); }
  .org-positions-browse-sidebar {
    border-right: none;
    border-bottom: 1px solid rgba(58, 120, 180, 0.35);
    max-height: 40%; }
  .org-positions-browse-main__toolbar {
    flex-wrap: wrap; } }

.org-positions-browse-detail-shell,
.org-positions-browse-apply-shell {
  position: absolute;
  inset: 0;
  z-index: 4;
  display: flex;
  flex-direction: column;
  transform: translateX(100%);
  opacity: 0;
  pointer-events: none;
  transition: transform 0.28s ease, opacity 0.22s ease;
  background: linear-gradient(180deg, rgba(0, 48, 77, 0.88), rgba(21, 28, 36, 0.94)), #172738; }
  .org-positions-browse-detail-shell.is-open,
  .org-positions-browse-apply-shell.is-open {
    transform: translateX(0);
    opacity: 1;
    pointer-events: auto; }

.org-positions-browse-apply-shell {
  z-index: 5; }

.org-positions-browse-detail {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0; }

.org-positions-browse-detail__nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-shrink: 0;
  padding: 0.85rem 1.15rem;
  border-bottom: 1px solid rgba(58, 120, 180, 0.35);
  background: rgba(21, 28, 36, 0.3); }

.org-positions-browse-detail__back {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.45rem 0.85rem 0.45rem 0.65rem;
  border: 1px solid rgba(58, 120, 180, 0.5);
  border-radius: 8px;
  background: rgba(28, 45, 56, 0.75);
  color: #dfdfdf;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  cursor: pointer;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.25);
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease; }
  .org-positions-browse-detail__back:hover, .org-positions-browse-detail__back:focus-visible {
    color: #ffffff;
    border-color: rgba(90, 195, 255, 0.7);
    background: rgba(56, 72, 88, 0.95);
    box-shadow: 0 0 0 1px rgba(58, 120, 180, 0.2); }
  .org-positions-browse-detail__back:active {
    background: rgba(0, 48, 77, 0.65); }

.org-positions-browse-detail__back-icon {
  flex-shrink: 0; }

.org-positions-browse-detail__close {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  padding: 0;
  border: 1px solid rgba(58, 120, 180, 0.45);
  border-radius: 8px;
  background: rgba(28, 45, 56, 0.65);
  color: #b8b8b8;
  cursor: pointer; }
  .org-positions-browse-detail__close:hover, .org-positions-browse-detail__close:focus-visible {
    color: #dfdfdf;
    border-color: rgba(90, 195, 255, 0.65);
    background: #384858; }

.org-positions-browse-detail__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  padding: 1rem 1.15rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem; }

.org-positions-browse-detail__hero {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  flex-shrink: 0;
  padding: 1rem;
  border-radius: 12px;
  border: 1px solid rgba(58, 120, 180, 0.4);
  background: linear-gradient(135deg, rgba(58, 120, 180, 0.28), rgba(0, 48, 77, 0.55) 45%, rgba(21, 28, 36, 0.7)), rgba(23, 39, 56, 0.9); }

.org-positions-browse-detail--special .org-positions-browse-detail__hero {
  border-color: rgba(199, 132, 69, 0.45);
  background: linear-gradient(135deg, rgba(121, 88, 195, 0.32), rgba(70, 54, 133, 0.45) 40%, rgba(0, 48, 77, 0.7)), rgba(23, 39, 56, 0.92); }

.org-positions-browse-detail__hero-main {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 0.85rem;
  align-items: center; }

.org-positions-browse-detail__logo {
  width: 4.75rem;
  height: 4.75rem;
  object-fit: contain; }
  .org-positions-browse-detail__logo--letter {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 1.8rem;
    font-weight: 800;
    color: #ffffff;
    background: linear-gradient(160deg, rgba(121, 88, 195, 0.55), rgba(70, 54, 133, 0.85));
    border-color: rgba(121, 88, 195, 0.5); }

.org-positions-browse-detail__hero-copy {
  min-width: 0; }

.org-positions-browse-detail__title-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.55rem; }

.org-positions-browse-detail__title {
  margin: 0;
  font-size: 1.45rem;
  font-weight: 800;
  color: #ffffff;
  line-height: 1.15; }

.org-positions-browse-detail__badge {
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  border: 1px solid rgba(90, 195, 255, 0.45);
  background: rgba(58, 120, 180, 0.25);
  color: #5ac3ff; }
  .org-positions-browse-detail__badge--special {
    border-color: rgba(199, 132, 69, 0.55);
    background: rgba(199, 132, 69, 0.18);
    color: #d8b493; }
  .org-positions-browse-detail__badge--division {
    border-color: rgba(90, 195, 255, 0.55);
    color: #5ac3ff; }
  .org-positions-browse-detail__badge--branch {
    border-color: rgba(121, 88, 195, 0.55);
    background: rgba(121, 88, 195, 0.18);
    color: #9a80e3; }
  .org-positions-browse-detail__badge--section {
    border-color: rgba(117, 207, 120, 0.55);
    background: rgba(117, 207, 120, 0.14);
    color: #c2f0c3; }

.org-positions-browse-detail__tagline {
  margin: 0.45rem 0 0;
  font-size: 0.88rem;
  line-height: 1.4;
  color: #b8b8b8; }

.org-positions-browse-detail__meta {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.55rem; }

.org-positions-browse-detail__meta-card {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  min-width: 0;
  padding: 0.65rem 0.7rem;
  border-radius: 10px;
  border: 1px solid rgba(58, 120, 180, 0.35);
  background: rgba(21, 28, 36, 0.45); }
  .org-positions-browse-detail__meta-card--open {
    gap: 0.45rem;
    align-items: center; }
    .org-positions-browse-detail__meta-card--open .org-positions-browse-detail__meta-label {
      align-self: flex-start; }
    .org-positions-browse-detail__meta-card--open .org-positions-browse-card__open-chip {
      align-self: center; }
  .org-positions-browse-detail__meta-card--commander {
    gap: 0.45rem;
    align-items: flex-start; }
    .org-positions-browse-detail__meta-card--commander .org-positions-browse-detail__commander-identity {
      align-self: flex-start;
      width: fit-content;
      max-width: 100%;
      flex: 0 0 auto; }

.org-positions-browse-detail__meta-label {
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #747b81; }

.org-positions-browse-detail__meta-value {
  font-size: 0.88rem;
  font-weight: 700;
  color: #dfdfdf;
  line-height: 1.25; }

.org-positions-browse-detail__commander-identity {
  display: inline-flex;
  width: fit-content;
  max-width: 100%;
  min-width: 0;
  flex: 0 0 auto; }
  .org-positions-browse-detail__commander-identity.user-discord-rank--profile-chip {
    width: fit-content;
    max-width: 100%;
    color: #dfdfdf;
    border-color: rgba(58, 120, 180, 0.45);
    background: rgba(28, 45, 56, 0.85); }
    .org-positions-browse-detail__commander-identity.user-discord-rank--profile-chip .user-discord-rank__name {
      color: #afa991;
      padding: 0;
      flex: 0 1 auto; }
    .org-positions-browse-detail__commander-identity.user-discord-rank--profile-chip:not([data-chip-bg]):hover, .org-positions-browse-detail__commander-identity.user-discord-rank--profile-chip:not([data-chip-bg]).user-discord-rank--profile-chip-open {
      color: #ffffff;
      border-color: rgba(90, 195, 255, 0.55);
      background-color: #384858; }
    .org-positions-browse-detail__commander-identity.user-discord-rank--profile-chip[data-chip-bg]::after {
      opacity: 0.18; }
    .org-positions-browse-detail__commander-identity.user-discord-rank--profile-chip[data-chip-bg]:hover .user-discord-rank__name, .org-positions-browse-detail__commander-identity.user-discord-rank--profile-chip[data-chip-bg].user-discord-rank--profile-chip-open .user-discord-rank__name {
      color: #ffffff; }
    .org-positions-browse-detail__commander-identity.user-discord-rank--profile-chip[data-chip-bg]:hover::after, .org-positions-browse-detail__commander-identity.user-discord-rank--profile-chip[data-chip-bg].user-discord-rank--profile-chip-open::after {
      opacity: 0.28; }
  .org-positions-browse-detail__commander-identity--footer {
    width: fit-content;
    max-width: 100%; }

.org-positions-browse-detail__footer-commander-body {
  display: flex;
  justify-content: flex-start; }

.org-positions-browse-detail__section {
  padding: 0.85rem 0.95rem;
  border-radius: 12px;
  border: 1px solid rgba(58, 120, 180, 0.32);
  background: rgba(21, 28, 36, 0.32); }
  .org-positions-browse-detail__section--description {
    flex-shrink: 0; }
  .org-positions-browse-detail__section--list {
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
    padding: 0.85rem 0.95rem 0; }

.org-positions-browse-detail__section-title {
  margin: 0;
  padding: 0 0 0.55rem;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #dfdfdf;
  flex-shrink: 0; }

.org-positions-browse-detail__description {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.55;
  color: #b8b8b8;
  white-space: pre-wrap; }

.org-positions-browse-detail__empty {
  margin: 0;
  padding-bottom: 0.85rem;
  font-size: 0.85rem;
  color: #747b81; }

.org-positions-browse-detail__split {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.75rem;
  flex: 1 1 auto;
  min-height: 0;
  align-items: stretch; }

.org-positions-browse-detail__list-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0 0.2rem 0.85rem 0;
  margin-right: 0px;
  padding-right: 2px;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.35) rgba(0, 0, 0, 0.12); }
  .org-positions-browse-detail__list-scroll::-webkit-scrollbar {
    width: 6px; }
  .org-positions-browse-detail__list-scroll::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.12);
    border-radius: 999px; }
  .org-positions-browse-detail__list-scroll::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.3);
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.08); }
  .org-positions-browse-detail__list-scroll::-webkit-scrollbar-thumb:hover {
    background: rgba(58, 120, 180, 0.42); }

.org-positions-browse-detail__list {
  margin: 0;
  padding: 0 0 0.35rem;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.45rem; }
  .org-positions-browse-detail__list li {
    position: relative;
    padding-left: 1.5rem;
    font-size: 0.86rem;
    line-height: 1.4;
    color: #b8b8b8; }
  .org-positions-browse-detail__list--bullets li::before {
    content: '';
    position: absolute;
    left: 0.15rem;
    top: 0.45rem;
    width: 0.4rem;
    height: 0.4rem;
    border-radius: 50%;
    background: #5ac3ff; }
  .org-positions-browse-detail__list--checks li::before {
    content: '✓';
    position: absolute;
    left: 0;
    top: 0.05rem;
    width: 0.9rem;
    height: 0.9rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    font-size: 0.62rem;
    font-weight: 800;
    line-height: 1;
    color: #ffffff;
    background: rgba(58, 120, 180, 0.55);
    border: 1px solid rgba(90, 195, 255, 0.55); }
  .org-positions-browse-detail--special .org-positions-browse-detail__list--checks li::before {
    background: rgba(121, 88, 195, 0.55);
    border-color: rgba(121, 88, 195, 0.7); }
  .org-positions-browse-detail--special .org-positions-browse-detail__list--bullets li::before {
    background: #7958c3; }

.org-positions-browse-detail__cta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-shrink: 0;
  margin: 0 1.15rem 1rem;
  padding: 0.95rem 1rem;
  border-radius: 12px;
  border: 1px solid rgba(58, 120, 180, 0.4);
  background: rgba(0, 48, 77, 0.45); }

.org-positions-browse-detail__cta-title {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
  color: #dfdfdf; }

.org-positions-browse-detail__cta-sub {
  margin: 0.2rem 0 0;
  font-size: 0.8rem;
  color: #747b81; }

.org-positions-browse-detail__cta-btn {
  flex-shrink: 0;
  border: none;
  border-radius: 10px;
  padding: 0.7rem 1rem;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #ffffff;
  background: linear-gradient(90deg, #7958c3, #463685);
  cursor: not-allowed;
  opacity: 0.55; }
  .org-positions-browse-detail__cta-btn.is-unlocked:not(:disabled) {
    cursor: pointer;
    opacity: 1; }
    .org-positions-browse-detail__cta-btn.is-unlocked:not(:disabled):hover {
      filter: brightness(1.08); }
    .org-positions-browse-detail__cta-btn.is-unlocked:not(:disabled):focus-visible {
      outline: 2px solid rgba(58, 120, 180, 0.7);
      outline-offset: 2px; }

.org-position-apply-panel .org-positions-browse-detail__body {
  overflow: auto;
  margin-right: 0px;
  padding-right: 2px;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.35) rgba(0, 0, 0, 0.12); }
  .org-position-apply-panel .org-positions-browse-detail__body::-webkit-scrollbar {
    width: 6px; }
  .org-position-apply-panel .org-positions-browse-detail__body::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.12);
    border-radius: 999px; }
  .org-position-apply-panel .org-positions-browse-detail__body::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.3);
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.08); }
  .org-position-apply-panel .org-positions-browse-detail__body::-webkit-scrollbar-thumb:hover {
    background: rgba(58, 120, 180, 0.42); }

.org-position-apply-panel__body {
  gap: 0.95rem; }

.org-position-apply-panel__heading {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  flex-shrink: 0; }

.org-position-apply-panel__eyebrow {
  margin: 0;
  font-size: 0.68rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.55); }

.org-position-apply-panel__title-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem; }

.org-position-apply-panel__title {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 800;
  line-height: 1.15;
  color: #ffffff; }

.org-position-apply-panel__badge {
  display: inline-flex;
  align-items: center;
  padding: 0.22rem 0.6rem;
  border-radius: 999px;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  border: 1px solid rgba(90, 195, 255, 0.45);
  background: rgba(58, 120, 180, 0.22);
  color: #5ac3ff; }
  .org-position-apply-panel__badge--special {
    border-color: rgba(199, 132, 69, 0.55);
    background: rgba(199, 132, 69, 0.18);
    color: #d8b493; }
  .org-position-apply-panel__badge--division {
    border-color: rgba(90, 195, 255, 0.55);
    color: #5ac3ff; }
  .org-position-apply-panel__badge--branch {
    border-color: rgba(121, 88, 195, 0.55);
    background: rgba(121, 88, 195, 0.18);
    color: #9a80e3; }
  .org-position-apply-panel__badge--section {
    border-color: rgba(117, 207, 120, 0.55);
    background: rgba(117, 207, 120, 0.14);
    color: #c2f0c3; }

.org-position-apply-panel__status {
  display: inline-flex;
  align-items: center;
  padding: 0.22rem 0.6rem;
  border-radius: 999px;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase; }
  .org-position-apply-panel__status--pending {
    border: 1px solid rgba(199, 132, 69, 0.55);
    background: rgba(199, 132, 69, 0.18);
    color: #d8b493; }
  .org-position-apply-panel__status--approved {
    border: 1px solid rgba(117, 207, 120, 0.55);
    background: rgba(117, 207, 120, 0.14);
    color: #c2f0c3; }
  .org-position-apply-panel__status--rejected {
    border: 1px solid rgba(209, 35, 35, 0.55);
    background: rgba(73, 18, 18, 0.35);
    color: #dfdfdf; }

.org-position-apply-panel__application-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem; }

.org-position-apply-panel__edit-btn {
  padding: 0.35rem 0.75rem;
  border: 1px solid rgba(90, 195, 255, 0.55);
  border-radius: 8px;
  background: rgba(28, 45, 56, 0.55);
  color: #5ac3ff;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  cursor: pointer; }
  .org-position-apply-panel__edit-btn:hover, .org-position-apply-panel__edit-btn:focus-visible {
    background: rgba(58, 120, 180, 0.35);
    color: #ffffff; }

.org-position-apply-panel__loading {
  margin: 0;
  font-size: 0.84rem;
  color: rgba(223, 223, 223, 0.62); }

.org-position-apply-panel__resolve-note {
  margin: 0;
  padding: 0.65rem 0.75rem;
  border-radius: 8px;
  border: 1px solid rgba(58, 120, 180, 0.35);
  background: rgba(0, 48, 77, 0.35);
  color: rgba(223, 223, 223, 0.82);
  font-size: 0.84rem;
  line-height: 1.45; }

.org-position-apply-panel__leadership {
  display: grid;
  grid-template-columns: auto minmax(0, 1.35fr) minmax(0, 1.65fr);
  gap: 0.85rem 1rem;
  align-items: center;
  flex-shrink: 0;
  padding: 0.95rem 1rem;
  border-radius: 12px;
  border: 1px solid rgba(58, 120, 180, 0.38);
  background: linear-gradient(135deg, rgba(58, 120, 180, 0.16), rgba(0, 48, 77, 0.42) 55%, rgba(21, 28, 36, 0.72)), rgba(23, 39, 56, 0.88); }

.org-position-apply-panel__emblem {
  width: 4rem;
  height: 4rem;
  padding: 0.6rem;
  object-fit: contain;
  border-radius: 50%;
  box-shadow: 0 0 0 1px rgba(90, 195, 255, 0.35), 0 0 18px rgba(90, 195, 255, 0.22); }
  .org-position-apply-panel__emblem--letter {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 1.65rem;
    font-weight: 800;
    color: #ffffff;
    background: linear-gradient(160deg, rgba(90, 195, 255, 0.45), rgba(58, 120, 180, 0.85));
    border: 1px solid rgba(90, 195, 255, 0.45); }

.org-position-apply-panel__leadership-copy {
  min-width: 0; }

.org-position-apply-panel__intro {
  margin: 0;
  font-size: 0.86rem;
  line-height: 1.55;
  color: rgba(223, 223, 223, 0.84); }
  .org-position-apply-panel__intro--default {
    display: flex;
    flex-direction: column;
    gap: 0.45rem; }
  .org-position-apply-panel__intro-kicker {
    margin: 0;
    font-size: 0.72rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #5ac3ff; }
  .org-position-apply-panel__intro-text {
    margin: 0;
    font-size: 0.86rem;
    line-height: 1.55;
    color: rgba(223, 223, 223, 0.84); }
  .org-position-apply-panel__intro.lexical-rendered-content h1,
  .org-position-apply-panel__intro.lexical-rendered-content h2,
  .org-position-apply-panel__intro.lexical-rendered-content h3,
  .org-position-apply-panel__intro.lexical-rendered-content h4,
  .org-position-apply-panel__intro.lexical-rendered-content strong {
    margin: 0 0 0.45rem;
    font-size: 0.72rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #5ac3ff; }
  .org-position-apply-panel__intro.lexical-rendered-content p {
    margin: 0 0 0.45rem; }
    .org-position-apply-panel__intro.lexical-rendered-content p:last-child {
      margin-bottom: 0; }

.org-position-apply-panel__pillars {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.55rem;
  margin: 0;
  padding: 0;
  list-style: none; }

.org-position-apply-panel__pillar {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
  text-align: center;
  min-width: 0; }

.org-position-apply-panel__pillar-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.35rem;
  height: 2.35rem;
  border-radius: 10px;
  border: 1px solid rgba(90, 195, 255, 0.35);
  background: rgba(0, 48, 77, 0.45);
  color: #5ac3ff; }

.org-position-apply-panel__pillar-title {
  font-size: 0.58rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.88);
  line-height: 1.25; }

.org-position-apply-panel__pillar-sub {
  font-size: 0.62rem;
  line-height: 1.35;
  color: rgba(223, 223, 223, 0.55); }

.org-position-apply-panel__form {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  flex: 1 1 auto;
  min-height: 0; }

.org-position-apply-panel__grid {
  display: grid;
  grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.8fr);
  gap: 0.85rem;
  align-items: stretch;
  min-height: 0; }

.org-position-apply-panel__tips {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  padding: 0.85rem 0.95rem 1.1rem;
  border-radius: 12px;
  border: 1px solid rgba(58, 120, 180, 0.28);
  background: rgba(21, 28, 36, 0.35);
  overflow: hidden; }

.org-position-apply-panel__tips-title {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  margin: 0;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #dfdfdf; }

.org-position-apply-panel__tips-icon {
  flex-shrink: 0;
  color: #5ac3ff; }

.org-position-apply-panel__tips-list {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  margin: 0;
  padding: 0;
  list-style: none; }

.org-position-apply-panel__tips-item {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: 0.82rem;
  line-height: 1.45;
  color: rgba(223, 223, 223, 0.78); }

.org-position-apply-panel__tips-check {
  flex-shrink: 0;
  margin-top: 0.15rem;
  color: #5ac3ff; }

.org-position-apply-panel__application {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  min-width: 0; }

.org-position-apply-panel__application-title {
  margin: 0;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.62); }

.org-position-apply-panel__field {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0; }

.org-position-apply-panel__textarea-frame {
  position: relative;
  flex: 1 1 auto;
  min-height: 14rem;
  padding: 0.15rem;
  border: 1px solid rgba(58, 120, 180, 0.42);
  border-radius: 10px;
  background: rgba(0, 48, 77, 0.35);
  box-shadow: inset 0 0 24px rgba(0, 48, 77, 0.35); }

.org-position-apply__motivation {
  width: stretch;
  min-height: 13rem;
  padding: 0.85rem 0.95rem 2rem;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #dfdfdf;
  font-family: inherit;
  font-size: 0.88rem;
  line-height: 1.55;
  resize: vertical; }
  .org-position-apply__motivation:read-only {
    cursor: default;
    opacity: 0.92; }
  .org-position-apply__motivation::placeholder {
    color: rgba(223, 223, 223, 0.42); }
  .org-position-apply__motivation:focus {
    outline: none; }

.org-position-apply-panel__counter {
  position: absolute;
  right: 0.85rem;
  bottom: 0.55rem;
  font-size: 0.72rem;
  color: rgba(223, 223, 223, 0.48);
  pointer-events: none; }

.org-position-apply-panel__hint {
  margin: 0;
  padding: 0.65rem 0.75rem;
  border-radius: 8px;
  border: 1px solid rgba(117, 207, 120, 0.35);
  background: rgba(63, 124, 66, 0.28);
  color: #dfdfdf;
  font-size: 0.84rem; }

.org-position-apply-panel__error {
  margin: 0;
  padding: 0.65rem 0.75rem;
  border-radius: 8px;
  border: 1px solid rgba(209, 35, 35, 0.45);
  background: rgba(73, 18, 18, 0.35);
  color: #dfdfdf;
  font-size: 0.84rem; }

.org-position-apply-panel__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.85rem;
  flex-wrap: wrap;
  padding-top: 0.15rem; }

.org-position-apply-panel__privacy {
  display: inline-flex;
  align-items: flex-start;
  gap: 0.45rem;
  margin: 0;
  max-width: 26rem;
  font-size: 0.78rem;
  line-height: 1.45;
  color: rgba(223, 223, 223, 0.62); }

.org-position-apply-panel__privacy-icon {
  flex-shrink: 0;
  margin-top: 0.1rem;
  color: rgba(90, 195, 255, 0.75); }

.org-position-apply-panel__privacy-highlight {
  color: #5ac3ff;
  font-weight: 700; }

.org-position-apply-panel__actions {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  flex-wrap: wrap;
  margin-left: auto; }

.org-position-apply-panel__cancel {
  padding: 0.62rem 1rem;
  border: 1px solid rgba(209, 35, 35, 0.45);
  border-radius: 8px;
  background: rgba(28, 45, 56, 0.55);
  color: rgba(223, 223, 223, 0.88);
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease; }
  .org-position-apply-panel__cancel:hover, .org-position-apply-panel__cancel:focus-visible {
    color: #ffffff;
    border-color: rgba(209, 35, 35, 0.75);
    background: rgba(73, 18, 18, 0.45); }

.org-position-apply-panel__submit {
  display: inline-flex;
  align-items: stretch;
  padding: 0;
  border: 1px solid rgba(90, 195, 255, 0.55);
  border-radius: 8px;
  background: linear-gradient(180deg, rgba(90, 195, 255, 0.95), rgba(58, 120, 180, 0.95));
  color: #ffffff;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  cursor: pointer;
  overflow: hidden;
  transition: filter 0.15s ease, opacity 0.15s ease; }
  .org-position-apply-panel__submit:hover:not(:disabled), .org-position-apply-panel__submit:focus-visible:not(:disabled) {
    filter: brightness(1.08); }
  .org-position-apply-panel__submit:disabled {
    opacity: 0.45;
    cursor: not-allowed; }

.org-position-apply-panel__submit-label {
  display: inline-flex;
  align-items: center;
  padding: 0.62rem 0.95rem; }

.org-position-apply-panel__submit-chevron {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.75rem;
  border-left: 1px solid rgba(255, 255, 255, 0.28); }

.org-positions-browse-detail__footer-commander {
  flex-shrink: 0;
  margin: 0 1.15rem 1rem;
  padding: 0.9rem 1rem;
  border-radius: 12px;
  border: 1px solid rgba(58, 120, 180, 0.35);
  background: rgba(21, 28, 36, 0.4); }
  .org-positions-browse-detail__footer-commander .org-positions-browse-detail__commander-identity {
    width: fit-content;
    max-width: 100%;
    flex: 0 0 auto; }

.org-positions-browse-detail__footer-commander-label {
  display: block;
  margin-bottom: 0.55rem;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #747b81; }

@media (max-width: 860px) {
  .org-positions-browse-detail__hero-main {
    grid-template-columns: auto minmax(0, 1fr); }
  .org-positions-browse-detail__meta,
  .org-positions-browse-detail__split {
    grid-template-columns: 1fr; }
  .org-positions-browse-detail__split {
    overflow: auto;
    margin-right: 0px;
    padding-right: 2px;
    scrollbar-width: thin;
    scrollbar-color: rgba(58, 120, 180, 0.35) rgba(0, 0, 0, 0.12); }
    .org-positions-browse-detail__split::-webkit-scrollbar {
      width: 6px; }
    .org-positions-browse-detail__split::-webkit-scrollbar-track {
      background: rgba(0, 0, 0, 0.12);
      border-radius: 999px; }
    .org-positions-browse-detail__split::-webkit-scrollbar-thumb {
      background: rgba(58, 120, 180, 0.3);
      border-radius: 999px;
      border: 1px solid rgba(255, 255, 255, 0.08); }
    .org-positions-browse-detail__split::-webkit-scrollbar-thumb:hover {
      background: rgba(58, 120, 180, 0.42); }
  .org-positions-browse-detail__section--list {
    min-height: 10rem;
    max-height: 14rem; }
  .org-positions-browse-detail__cta {
    flex-direction: column;
    align-items: stretch; }
  .org-position-apply-panel__leadership {
    grid-template-columns: auto minmax(0, 1fr); }
  .org-position-apply-panel__pillars {
    grid-column: 1 / -1;
    grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .org-position-apply-panel__grid {
    grid-template-columns: 1fr; }
  .org-position-apply-panel__footer {
    flex-direction: column;
    align-items: stretch; }
  .org-position-apply-panel__actions {
    width: 100%;
    justify-content: stretch; }
  .org-position-apply-panel__cancel,
  .org-position-apply-panel__submit {
    flex: 1 1 auto;
    justify-content: center; } }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.member-dashboard {
  margin-top: 65px; }
  .member-dashboard.member-dashboard--with-rail {
    margin-top: 50px; }

.member-dashboard--with-rail {
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-height: 0;
  height: auto;
  max-height: 100%;
  margin-top: 0;
  padding-left: calc(72px + 0.65rem);
  overflow: hidden;
  overscroll-behavior: contain;
  scrollbar-width: none; }

.member-dashboard__panel {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  min-height: 0;
  box-sizing: border-box;
  overflow: hidden; }

.member-dashboard__panel:not(.member-dashboard__panel--hangar) {
  overflow-y: auto;
  margin-top: 10px;
  scrollbar-width: none;
  max-height: calc(100vh - 225px); }

.member-dashboard__panel--hangar {
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  max-height: calc(100vh - 210px);
  overflow: hidden; }

.personal-hub-section {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  min-width: 0; }

.personal-hub-section--inactive {
  display: none; }

.member-dashboard--page-fetching {
  opacity: 1; }

.personal-hub-rail {
  position: fixed;
  top: 100px;
  left: max(0.75rem, calc((100vw - 1460px) / 2));
  width: 72px;
  padding: 0.35rem 0;
  box-sizing: border-box;
  z-index: 25; }

.personal-hub-rail__list {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.65rem;
  margin: 0;
  padding: 0;
  list-style: none; }

.personal-hub-rail__item-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  overflow: visible; }

.personal-hub-rail__btn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 50%;
  color: rgba(223, 223, 223, 0.72);
  background: rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 0 1px rgba(58, 120, 180, 0.72);
  cursor: pointer;
  transition: border-radius 0.2s ease, background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease; }
  .personal-hub-rail__btn:hover {
    border-radius: 12px;
    color: #dfdfdf;
    background: rgba(58, 120, 180, 0.38);
    box-shadow: 0 0 0 1px rgba(58, 120, 180, 0.45); }
  .personal-hub-rail__btn:focus-visible {
    outline: 2px solid rgba(58, 120, 180, 0.75);
    outline-offset: 2px; }

.personal-hub-rail__tooltip {
  position: absolute;
  left: calc(100% + 14px);
  top: 50%;
  z-index: 40;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  max-width: min(240px, calc(100vw - 120px));
  padding: 0.5rem 0.7rem;
  border-radius: 8px;
  background: #25537c;
  color: #ffffff;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0.01em;
  white-space: nowrap;
  box-shadow: 3px 3px 10px rgba(21, 28, 36, 0.65);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translateY(-50%) scale(0.96);
  transition: opacity 0.12s ease, transform 0.12s ease, visibility 0s linear 0.12s; }
  .personal-hub-rail__tooltip::before {
    content: '';
    position: absolute;
    left: -5px;
    top: 50%;
    width: 0;
    height: 0;
    transform: translateY(-50%);
    border-style: solid;
    border-width: 5px 6px 5px 0;
    border-color: transparent #336a8c transparent transparent; }

.personal-hub-rail__tooltip--locked {
  align-items: flex-start;
  white-space: normal;
  width: 200px;
  text-align: left; }

.personal-hub-rail__tooltip-copy {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0; }

.personal-hub-rail__tooltip-lock-msg {
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.25;
  white-space: normal;
  color: #c78445; }

.personal-hub-rail__tooltip-icon {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center; }

.personal-hub-rail__tooltip-icon-svg {
  display: block; }

.personal-hub-rail__tooltip-label {
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis; }

.personal-hub-rail__btn:hover .personal-hub-rail__tooltip,
.personal-hub-rail__btn:focus-visible .personal-hub-rail__tooltip {
  opacity: 1;
  visibility: visible;
  transform: translateY(-50%) scale(1);
  transition: opacity 0.14s ease 0.42s, transform 0.14s ease 0.42s, visibility 0s linear 0.42s; }

.personal-hub-rail__btn--active {
  border-radius: 12px;
  color: #dfdfdf;
  background: rgba(58, 120, 180, 0.55);
  box-shadow: 0 0 0 1px rgba(90, 195, 255, 0.35); }

.personal-hub-rail__btn--locked {
  cursor: not-allowed;
  color: rgba(223, 223, 223, 0.34);
  background: rgba(0, 0, 0, 0.12);
  box-shadow: 0 0 0 1px rgba(56, 72, 88, 0.55); }
  .personal-hub-rail__btn--locked:hover, .personal-hub-rail__btn--locked:focus-visible {
    border-radius: 50%;
    color: rgba(223, 223, 223, 0.34);
    background: rgba(0, 0, 0, 0.12);
    box-shadow: 0 0 0 1px rgba(56, 72, 88, 0.55); }

.personal-hub-rail__icon {
  display: block;
  flex-shrink: 0; }

.personal-hub-rail__btn--dashboard > .personal-hub-rail__icon {
  width: 26px;
  height: 26px; }

.personal-hub-rail__btn--dashboard .personal-hub-rail__tooltip-icon,
.personal-hub-rail__btn--dashboard .personal-hub-rail__tooltip-icon-svg {
  width: 1.125rem;
  height: 1.125rem; }

.personal-hub-rail__btn--hangar > .personal-hub-rail__icon {
  width: 28px;
  height: 28px; }

.personal-hub-rail__btn--hangar .personal-hub-rail__tooltip-icon,
.personal-hub-rail__btn--hangar .personal-hub-rail__tooltip-icon-svg {
  width: 1.125rem;
  height: 1.125rem; }

.personal-hub-rail__btn--factions-reputations > .personal-hub-rail__icon {
  width: 40px;
  height: 40px; }

.personal-hub-rail__btn--factions-reputations .personal-hub-rail__tooltip-icon,
.personal-hub-rail__btn--factions-reputations .personal-hub-rail__tooltip-icon-svg {
  width: 1.5rem;
  height: 1.5rem; }

.personal-hub-rail__btn--blueprints > .personal-hub-rail__icon {
  width: 40px;
  height: 40px; }

.personal-hub-rail__btn--blueprints .personal-hub-rail__tooltip-icon,
.personal-hub-rail__btn--blueprints .personal-hub-rail__tooltip-icon-svg {
  width: 1.5rem;
  height: 1.5rem; }

.personal-hub-rail__hangar-icon {
  display: block;
  flex-shrink: 0;
  background-color: currentColor;
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  -webkit-mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center; }

.personal-hub-rail__blueprint-icon {
  display: block;
  flex-shrink: 0;
  background-color: currentColor;
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  -webkit-mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center; }

.personal-hub-rail__factions-reputations-icon {
  display: block;
  flex-shrink: 0;
  background-color: currentColor;
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  -webkit-mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center; }

.member-dashboard__layout-root {
  width: stretch;
  max-width: stretch; }

.member-dashboard__layout-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
  margin-bottom: 1rem; }

.member-dashboard__layout-hint-card {
  flex: 1 1 auto;
  min-width: 0;
  max-width: max-content;
  box-sizing: border-box;
  padding: 0.75rem 1rem;
  border: 1px solid rgba(58, 120, 180, 0.35);
  border-radius: 10px;
  background: linear-gradient(180deg, rgba(0, 48, 77, 0.55), rgba(21, 28, 36, 0.32)), rgba(0, 48, 77, 0.45);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.28); }

.member-dashboard__layout-hint-text {
  margin: 0;
  font-family: "Lato", sans-serif;
  font-size: 0.85rem;
  line-height: 1.45;
  color: rgba(223, 223, 223, 0.88); }

.member-dashboard__layout-reset-btn {
  flex: 0 0 auto;
  border: 1px solid rgba(58, 120, 180, 0.45);
  border-radius: 10px;
  padding: 0.65rem 1rem;
  font-family: "Lato", sans-serif;
  font-size: 0.82rem;
  font-weight: 650;
  letter-spacing: 0.02em;
  color: rgba(223, 223, 223, 0.92);
  background: rgba(0, 0, 0, 0.22);
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease; }
  .member-dashboard__layout-reset-btn:hover {
    background: rgba(58, 120, 180, 0.14);
    border-color: rgba(58, 120, 180, 0.55);
    color: rgba(223, 223, 223, 0.98); }
  .member-dashboard__layout-reset-btn:focus-visible {
    outline: 2px solid rgba(58, 120, 180, 0.65);
    outline-offset: 2px; }

.member-dashboard__grid {
  width: 100%;
  max-width: 100%;
  position: relative; }

.member-dashboard__grid-layout {
  width: 100%; }

.member-dashboard__grid-item {
  box-sizing: border-box; }

.member-dashboard__grid-item-body {
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden; }
  .member-dashboard__grid-item-body > .member-dashboard__hero,
  .member-dashboard__grid-item-body > .member-dashboard__panel-card,
  .member-dashboard__grid-item-body > .member-dashboard__gameloop-card {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    box-sizing: border-box;
    overflow: hidden; }

.member-dashboard__panel-card-head {
  flex-shrink: 0; }

.member-dashboard__panel-card-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  margin-right: -10px;
  padding-right: 10px;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.35) rgba(0, 0, 0, 0.12); }
  .member-dashboard__panel-card-body::-webkit-scrollbar {
    width: 6px; }
  .member-dashboard__panel-card-body::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.12);
    border-radius: 999px; }
  .member-dashboard__panel-card-body::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.3);
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.08); }
  .member-dashboard__panel-card-body::-webkit-scrollbar-thumb:hover {
    background: rgba(58, 120, 180, 0.42); }

.member-dashboard__grid-item-body--expanded {
  overflow: hidden;
  height: 100%;
  min-height: 0; }
  .member-dashboard__grid-item-body--expanded > .member-dashboard__gameloop-card {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    height: auto;
    min-height: 100%;
    max-height: none;
    overflow: visible; }
  .member-dashboard__grid-item-body--expanded .member-dashboard__structure-block {
    flex: 0 0 auto;
    width: 100%;
    min-height: 0; }
  .member-dashboard__grid-item-body--expanded .member-dashboard__structure-block-body {
    overflow: visible;
    flex: 0 0 auto;
    min-height: 0;
    max-height: none;
    margin-right: 0;
    padding-right: 0; }
  .member-dashboard__grid-item-body--expanded .member-dashboard__gameloop-tags-section {
    flex: 0 0 auto;
    width: 100%;
    min-height: 0; }
  .member-dashboard__grid-item-body--expanded .member-dashboard__panel-card-body,
  .member-dashboard__grid-item-body--expanded .member-dashboard__gameloop-tags-body {
    overflow: visible;
    flex: 0 0 auto;
    min-height: 0;
    max-height: none;
    margin-right: 0;
    padding-right: 0; }

.member-dashboard__grid-item--expanded {
  z-index: 2;
  overflow: hidden; }

.member-dashboard__grid .react-grid-item {
  z-index: 0;
  transition: box-shadow 0.2s ease; }
  .member-dashboard__grid .react-grid-item.react-draggable-dragging {
    z-index: 10; }
  .member-dashboard__grid .react-grid-item.resizing {
    z-index: 10; }

.member-dashboard__grid .react-grid-placeholder {
  background: rgba(58, 120, 180, 0.18) !important;
  border: 1px dashed rgba(58, 120, 180, 0.55) !important;
  border-radius: 12px !important;
  opacity: 0.85 !important; }

.member-dashboard__grid .react-grid-item > .react-resizable-handle {
  z-index: 5;
  opacity: 0.45;
  transition: opacity 0.2s ease; }
  .member-dashboard__grid .react-grid-item > .react-resizable-handle::after {
    border-right: 2px solid rgba(58, 120, 180, 0.85) !important;
    border-bottom: 2px solid rgba(58, 120, 180, 0.85) !important; }

.member-dashboard__grid .react-grid-item:hover > .react-resizable-handle,
.member-dashboard__grid .react-grid-item.resizing > .react-resizable-handle {
  opacity: 1; }

.member-dashboard__top {
  display: grid;
  grid-template-columns: minmax(620px, 720px) auto;
  gap: 1rem;
  align-items: start;
  justify-content: start;
  max-width: 100%; }

.member-dashboard__aside-cluster {
  grid-column: 2;
  grid-row: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 1rem;
  min-width: 0; }

.member-dashboard__aside-bottom-row {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  width: 100%;
  min-width: 0; }

.member-dashboard__aside-bottom-row > .member-dashboard__rank-history-card,
.member-dashboard__aside-bottom-row > .member-dashboard__history-card {
  box-sizing: border-box;
  flex: 1 1 0;
  width: 50%;
  max-width: 50%;
  min-width: 0; }

.member-dashboard__main-column {
  grid-column: 1;
  grid-row: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 1rem;
  min-width: 0; }

.member-dashboard__hero {
  position: relative;
  align-self: start;
  width: 100%;
  min-width: 0;
  height: auto;
  box-sizing: border-box;
  background: linear-gradient(180deg, rgba(0, 48, 77, 0.72), rgba(21, 28, 36, 0.42)), rgba(0, 48, 77, 0.55);
  border: 1px solid rgba(58, 120, 180, 0.55);
  border-radius: 12px;
  padding: 1rem 1rem;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35), 0 12px 28px rgba(0, 0, 0, 0.35); }

.member-dashboard__donor-chip {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 3;
  gap: 7px;
  padding: 5px 11px 5px 8px;
  border-radius: 10px;
  border: 1px solid transparent; }
  .member-dashboard__donor-chip .donor-gem-badge__wrap {
    width: 16px;
    height: 16px; }
  .member-dashboard__donor-chip .donor-gem-badge__gem {
    width: 16px;
    height: 16px; }
  .member-dashboard__donor-chip .donor-gem-badge__label {
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.02em;
    line-height: 1.2; }
  .member-dashboard__donor-chip:has(.donor-gem-badge__wrap--one-time) {
    border-color: rgba(58, 120, 180, 0.35);
    background: rgba(58, 120, 180, 0.12);
    color: #3a78b4; }
    .member-dashboard__donor-chip:has(.donor-gem-badge__wrap--one-time) .donor-gem-badge__label {
      color: #3a78b4; }
  .member-dashboard__donor-chip:has(.donor-gem-badge__wrap--subscriber) {
    border-color: rgba(121, 88, 195, 0.35);
    background: rgba(121, 88, 195, 0.12);
    color: #7958c3; }
    .member-dashboard__donor-chip:has(.donor-gem-badge__wrap--subscriber) .donor-gem-badge__label {
      color: #7958c3; }
  .member-dashboard__donor-chip:has(.donor-gem-badge__wrap--premium) {
    border-color: rgba(232, 197, 71, 0.4);
    background: rgba(232, 197, 71, 0.12);
    color: #e8c547; }
    .member-dashboard__donor-chip:has(.donor-gem-badge__wrap--premium) .donor-gem-badge__label {
      color: #f5df8a; }
  .member-dashboard__donor-chip:has(.donor-gem-badge__wrap--inactive) {
    border-color: rgba(116, 123, 129, 0.35);
    background: rgba(116, 123, 129, 0.1);
    color: #747b81; }
    .member-dashboard__donor-chip:has(.donor-gem-badge__wrap--inactive) .donor-gem-badge__label {
      color: #747b81; }

.member-dashboard__hero-inner {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 1rem;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden; }

.member-dashboard__identity {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  flex: 0 0 25%;
  min-width: 0;
  flex-shrink: 0; }

.member-dashboard__avatar-stack {
  position: relative;
  width: 120px;
  height: 120px;
  flex-shrink: 0;
  margin-bottom: 0.75rem; }

.member-dashboard__avatar-discord {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: auto;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
  z-index: 1; }

.member-dashboard__avatar-frame {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 120px;
  height: 120px;
  object-fit: contain;
  z-index: 2;
  pointer-events: none; }

.member-dashboard__avatar-ring {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 3px solid #5ac3ff;
  box-sizing: border-box;
  z-index: 2;
  pointer-events: none; }

.member-dashboard__avatar-halo {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 105px;
  height: 105px;
  border-radius: 50%;
  z-index: 0;
  pointer-events: none; }

.member-dashboard__avatar-color-picker {
  position: absolute;
  right: -25px;
  top: 0px;
  z-index: 4; }

.member-dashboard__avatar-color-picker__trigger {
  position: relative;
  display: inline-flex;
  align-items: center; }
  .member-dashboard__avatar-color-picker__trigger .color-picker-container {
    margin: 0; }
  .member-dashboard__avatar-color-picker__trigger .color-picker-flex {
    margin: 0; }
  .member-dashboard__avatar-color-picker__trigger .colorPicker {
    width: 17px;
    height: 17px;
    min-width: 17px;
    min-height: 17px;
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.85);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.45);
    cursor: pointer; }
  .member-dashboard__avatar-color-picker__trigger:hover .member-dashboard__avatar-color-picker__tooltip, .member-dashboard__avatar-color-picker__trigger:focus-within .member-dashboard__avatar-color-picker__tooltip {
    opacity: 1;
    visibility: visible;
    transform: translateY(-40%); }

.member-dashboard__avatar-color-picker__tooltip {
  position: absolute;
  left: calc(100% + 8px);
  top: 50%;
  transform: translateY(calc(-50% - 2px));
  z-index: 6;
  padding: 5px 9px;
  border-radius: 8px;
  border: 1px solid #3a78b4;
  background: #1e3042;
  font-family: 'Lato', sans-serif;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  line-height: 1.2;
  white-space: nowrap;
  pointer-events: none;
  color: rgba(223, 223, 223, 0.95);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.15s ease, visibility 0.15s ease, transform 0.15s ease;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.45), 0 0 0 1px rgba(0, 0, 0, 0.18); }

.member-dashboard__moniker {
  font-family: 'GoodTimes', 'Lato', sans-serif;
  font-size: 0.9rem;
  font-weight: 700;
  color: #ffffff;
  line-height: 1.25;
  margin: 0 0 0.35rem;
  word-break: break-word; }

.member-dashboard__subline {
  margin: 0.15rem 0 0;
  font-size: 0.8rem;
  color: rgba(223, 223, 223, 0.88);
  line-height: 1.35; }

.member-dashboard__subline-label {
  display: block;
  font-size: 0.62rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #747b81;
  margin-bottom: 0.1rem; }

.member-dashboard__subline-value {
  color: rgba(90, 195, 255, 0.95);
  word-break: break-word; }

.member-dashboard__assignment {
  margin: 0.35rem 0 0;
  font-size: 0.95rem;
  line-height: 1.3;
  color: #5ac3ff;
  font-style: italic; }

.member-dashboard__divider {
  width: 1px;
  flex-shrink: 0;
  background: linear-gradient(180deg, transparent 0%, rgba(58, 120, 180, 0.55) 15%, rgba(58, 120, 180, 0.55) 85%, transparent 100%); }

.member-dashboard__meta {
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  margin-right: -10px;
  padding-right: 10px;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.35) rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  gap: 0.85rem; }
  .member-dashboard__meta::-webkit-scrollbar {
    width: 6px; }
  .member-dashboard__meta::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.12);
    border-radius: 999px; }
  .member-dashboard__meta::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.3);
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.08); }
  .member-dashboard__meta::-webkit-scrollbar-thumb:hover {
    background: rgba(58, 120, 180, 0.42); }

.member-dashboard__rank-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem; }

.member-dashboard__rank-icon-slot {
  flex-shrink: 0;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center; }

.member-dashboard__rank-icon {
  max-width: auto;
  max-height: 60px;
  width: auto;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.45)); }

.member-dashboard__rank-icon--empty {
  width: 48px;
  height: 56px;
  border: 1px dashed rgba(58, 120, 180, 0.35);
  border-radius: 4px; }

.member-dashboard__rank-text {
  flex: 1;
  min-width: 0; }

.member-dashboard__rank-eyebrow {
  font-size: 0.62rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #747b81;
  margin: 0 0 0.2rem; }

.member-dashboard__rank-name {
  font-size: 1.05rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 0.15rem;
  line-height: 1.2;
  word-break: break-word; }

.member-dashboard__pay-grade {
  margin: 0;
  font-size: 0.78rem;
  color: rgba(223, 223, 223, 0.85); }

.member-dashboard__org-sep {
  height: 1px;
  width: 100%;
  background: linear-gradient(90deg, transparent, rgba(58, 120, 180, 0.4) 10%, rgba(58, 120, 180, 0.4) 90%, transparent); }

.member-dashboard__org-row {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
  flex-wrap: nowrap;
  gap: 0;
  width: 100%; }

.member-dashboard__org-segment {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  flex: 1 1 0;
  min-width: 0;
  gap: 0.5rem;
  padding: 0 0.25rem; }

.member-dashboard__org-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-height: 44px; }

.member-dashboard__org-vrule {
  flex-shrink: 0;
  width: 1px;
  align-self: stretch;
  min-height: 3rem;
  margin: 0 0.15rem;
  background: linear-gradient(180deg, transparent 0%, rgba(117, 207, 120, 0.2) 12%, rgba(90, 160, 92, 0.55) 50%, rgba(117, 207, 120, 0.2) 88%, transparent 100%); }

.member-dashboard__org-icon {
  width: 55px;
  height: 55px;
  object-fit: contain;
  flex-shrink: 0;
  border-radius: 3px; }

.member-dashboard__org-icon--placeholder {
  display: block;
  width: 55px;
  height: 55px;
  box-sizing: border-box;
  border-radius: 3px; }

.member-dashboard__org-text {
  min-width: 0;
  width: 100%; }

.member-dashboard__org-label {
  display: block;
  font-size: 0.58rem;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #747b81;
  margin-bottom: 0.08rem; }

.member-dashboard__org-value {
  font-size: 0.82rem;
  color: #ffffff;
  word-break: break-word; }

.member-dashboard__org-segment--token .member-dashboard__org-label {
  margin-bottom: 0.2rem; }

.member-dashboard__org-value--token {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.15rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  line-height: 1.2; }

.member-dashboard__org-segment--token-no-icon {
  justify-content: center;
  align-self: center;
  gap: 0.35rem; }

.member-dashboard__org-segment--token-no-icon .member-dashboard__org-label {
  margin-bottom: 0.25rem;
  font-size: 0.62rem; }

.member-dashboard__org-segment--token-no-icon .member-dashboard__org-value--token {
  font-size: 1.85rem;
  font-weight: 800;
  line-height: 1; }

.member-dashboard__state {
  margin-top: 0.75rem;
  font-size: 0.85rem;
  color: #b8b8b8; }

.member-dashboard__state--error {
  color: #c78445; }

.member-dashboard__panel-card {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding: 1rem 1.1rem;
  border: 1px solid rgba(58, 120, 180, 0.45);
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(0, 48, 77, 0.72), rgba(21, 28, 36, 0.42)), rgba(0, 48, 77, 0.55);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35), 0 12px 28px rgba(0, 0, 0, 0.35); }

.member-dashboard__panel-title {
  margin: 0 0 15px;
  font-family: "GoodTimes", "Lato", sans-serif;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.88); }

.member-dashboard__activity-card-head,
.member-dashboard__events-card-head {
  display: grid;
  grid-template-columns: 1fr auto;
  column-gap: 0.75rem;
  align-items: center;
  margin-bottom: 15px; }
  .member-dashboard__activity-card-head .member-dashboard__panel-title,
  .member-dashboard__events-card-head .member-dashboard__panel-title {
    margin: 0; }
  .member-dashboard__activity-card-head .member-dashboard__chart-toolbar,
  .member-dashboard__events-card-head .member-dashboard__chart-toolbar {
    margin: 0; }

.member-dashboard__ribbons-card-head {
  display: grid;
  grid-template-columns: 1fr auto;
  column-gap: 0.75rem;
  align-items: center;
  margin-bottom: 12px; }
  .member-dashboard__ribbons-card-head .member-dashboard__panel-title {
    margin: 0; }
  .member-dashboard__ribbons-card-head .member-dashboard__ribbons-toolbar {
    margin: 0; }

.member-dashboard__panel-placeholder {
  margin: 0;
  font-size: 0.85rem;
  color: rgba(223, 223, 223, 0.75); }

.member-dashboard__chart-subtitle {
  margin: -8px 0 12px;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.62); }

.member-dashboard__chart-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  margin: 0; }

.member-dashboard__chart-toolbar-label {
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.62); }

.member-dashboard__chart-year-select {
  min-width: 5.5rem;
  padding: 0.35rem 0.65rem;
  border: 1px solid rgba(58, 120, 180, 0.45);
  border-radius: 8px;
  font-family: inherit;
  font-size: 0.82rem;
  color: #dfdfdf;
  background: rgba(0, 48, 77, 0.65);
  cursor: pointer; }
  .member-dashboard__chart-year-select:disabled {
    opacity: 0.55;
    cursor: not-allowed; }
  .member-dashboard__chart-year-select:focus-visible {
    outline: 2px solid rgba(58, 120, 180, 0.65);
    outline-offset: 2px; }

.member-dashboard__chart {
  position: relative;
  width: 100%;
  min-height: 0; }

.member-dashboard__chart--line {
  min-height: 0; }

.member-dashboard__activity-card > .member-dashboard__panel-card-body {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden; }

.member-dashboard__activity-card .member-dashboard__chart--line {
  flex: 1 1 auto;
  min-height: 8rem;
  height: 100%; }

.member-dashboard__events-bars {
  box-sizing: border-box;
  overflow: visible; }

.member-dashboard__events-bars-list {
  margin: 0;
  padding: 0;
  list-style: none; }

.member-dashboard__events-bar-row {
  display: grid;
  grid-template-columns: minmax(0, 30%) 1fr 1.75rem;
  align-items: center;
  gap: 0.5rem;
  height: 17px;
  margin: 0 0 10px;
  padding: 0; }
  .member-dashboard__events-bar-row:last-child {
    margin-bottom: 0; }

.member-dashboard__events-bar-label {
  overflow: hidden;
  font-family: "Lato", sans-serif;
  font-size: 12px;
  line-height: 15px;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: rgba(223, 223, 223, 0.88); }

.member-dashboard__events-bar-count {
  font-family: "Lato", sans-serif;
  font-size: 11px;
  line-height: 15px;
  text-align: right;
  color: rgba(223, 223, 223, 0.72); }

.member-dashboard__events-bar-meter {
  display: block;
  width: 100%;
  height: 15px;
  margin: 0;
  border: none;
  border-radius: 2px;
  background: rgba(0, 0, 0, 0.12);
  appearance: none; }

.member-dashboard__events-bar-meter::-webkit-meter-bar {
  height: 15px;
  border: none;
  border-radius: 2px;
  background: rgba(0, 0, 0, 0.12); }

.member-dashboard__events-bar-meter::-webkit-meter-optimum-value {
  height: 15px;
  border: 1px solid rgba(58, 120, 180, 0.85);
  border-radius: 2px;
  background: rgba(58, 120, 180, 0.55);
  box-sizing: border-box; }

.member-dashboard__events-bar-meter::-moz-meter-bar {
  height: 15px;
  border: none;
  border-radius: 2px;
  background: rgba(0, 0, 0, 0.12); }

.member-dashboard__events-bar-meter::-moz-meter-optimum::-moz-meter-bar {
  height: 15px;
  border-radius: 2px;
  background: rgba(58, 120, 180, 0.55);
  border: 1px solid rgba(58, 120, 180, 0.85);
  box-sizing: border-box; }

.member-dashboard__events-bars-axis {
  margin: 8px 0 0;
  padding: 0 1.75rem 0 38%;
  font-family: "Lato", sans-serif;
  font-size: 11px;
  text-align: center;
  color: rgba(223, 223, 223, 0.62); }

.member-dashboard__rank-timeline-viewport {
  overflow: visible; }

.member-dashboard__rank-timeline {
  margin: 0;
  padding: 0;
  list-style: none; }

.member-dashboard__rank-timeline-item {
  display: grid;
  grid-template-columns: 1.1rem 1fr;
  gap: 0.65rem;
  padding-bottom: 0.85rem; }
  .member-dashboard__rank-timeline-item--last {
    padding-bottom: 0; }
  .member-dashboard__rank-timeline-item--upcoming {
    margin-bottom: 15px; }
    .member-dashboard__rank-timeline-item--upcoming .member-dashboard__rank-timeline-content {
      display: block; }

.member-dashboard__rank-timeline-rail {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100%; }

.member-dashboard__rank-timeline-dot {
  flex-shrink: 0;
  width: 0.55rem;
  height: 0.55rem;
  margin-top: 0.45rem;
  border-radius: 50%;
  background: rgba(58, 120, 180, 0.9);
  box-shadow: 0 0 0 2px rgba(58, 120, 180, 0.25); }

.member-dashboard__rank-timeline-line {
  flex: 1 1 auto;
  width: 2px;
  min-height: 2rem;
  margin-bottom: -20px;
  border-radius: 999px;
  background: rgba(58, 120, 180, 0.35); }

.member-dashboard__rank-timeline-line--dashed {
  background: none;
  width: 0;
  border-left: 2px dashed rgba(223, 223, 223, 0.38);
  border-radius: 0; }

.member-dashboard__rank-timeline-content {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  min-width: 0; }

.member-dashboard__rank-timeline-icon-slot {
  flex-shrink: 0;
  width: 2rem;
  height: 2rem; }

.member-dashboard__rank-timeline-icon {
  display: block;
  width: 2rem;
  height: 2rem;
  object-fit: contain; }

.member-dashboard__rank-timeline-icon--empty {
  display: block;
  width: 2rem;
  height: 2rem;
  border-radius: 4px;
  background: rgba(58, 120, 180, 0.15); }

.member-dashboard__rank-timeline-text {
  min-width: 0;
  padding-top: 0.1rem; }

.member-dashboard__rank-timeline-rank {
  margin: 0;
  font-family: "Lato", sans-serif;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.35;
  color: #dfdfdf; }

.member-dashboard__rank-timeline-rank--chip {
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border: 1px solid rgba(158, 34, 34, 0.05);
  border-radius: 8px;
  background: rgba(22, 52, 71, 0.05); }

.member-dashboard__rank-timeline-rank--rank-tinted[data-chip-bg] {
  position: relative;
  isolation: isolate;
  background: transparent;
  color: #dfdfdf; }
  .member-dashboard__rank-timeline-rank--rank-tinted[data-chip-bg]::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    z-index: 0;
    pointer-events: none;
    opacity: 0.1; }

.member-dashboard__rank-timeline-date {
  margin: 0.2rem 0 0;
  font-family: "Lato", sans-serif;
  font-size: 11px;
  line-height: 1.35;
  color: rgba(223, 223, 223, 0.62); }

.member-dashboard__rank-timeline-date-since {
  color: #5ac3ff;
  font-style: italic; }

.member-dashboard__rank-timeline-item--current .member-dashboard__rank-timeline-dot {
  width: 0.65rem;
  height: 0.65rem;
  background: #5ac3ff;
  box-shadow: 0 0 0 2px rgba(90, 195, 255, 0.35), 0 0 10px rgba(90, 195, 255, 0.45); }

.member-dashboard__rank-timeline-source {
  color: rgba(223, 223, 223, 0.5); }

.member-dashboard__rank-timeline-item--upcoming .member-dashboard__rank-timeline-dot {
  background: rgba(223, 223, 223, 0.28);
  box-shadow: none; }

.member-dashboard__rank-timeline-item--upcoming .member-dashboard__rank-timeline-icon,
.member-dashboard__rank-timeline-item--upcoming .member-dashboard__rank-timeline-icon--empty {
  opacity: 0.8;
  filter: grayscale(0.5); }

.member-dashboard__rank-timeline-rank--upcoming {
  margin: 0;
  color: rgba(223, 223, 223, 0.7);
  font-weight: 500; }

.member-dashboard__rank-upcoming-frame {
  box-sizing: border-box;
  width: 100%;
  padding: 0.55rem 0.65rem;
  border: 1px solid rgba(58, 120, 180, 0.4);
  border-radius: 10px;
  background: rgba(0, 48, 77, 0.35); }

.member-dashboard__rank-upcoming-frame__title {
  margin: 0 0 0.45rem;
  font-family: "GoodTimes", "Lato", sans-serif;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.72); }

.member-dashboard__rank-upcoming-frame__body {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  min-width: 0; }

.member-dashboard__rank-upcoming-frame__body .member-dashboard__rank-timeline-text {
  flex: 1;
  min-width: 0;
  padding-top: 0; }

.member-dashboard__rank-upcoming-courses {
  margin-top: 0.55rem;
  width: 100%; }

.member-dashboard__rank-upcoming-courses__title {
  margin: 0 0 0.35rem;
  font-family: "Lato", sans-serif;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.72); }

.member-dashboard__rank-upcoming-courses-list {
  margin: 0;
  padding: 0;
  list-style: none; }
  .member-dashboard__rank-upcoming-courses-list li {
    margin: 0.2rem 0 0;
    font-family: "Lato", sans-serif;
    font-size: 11px;
    line-height: 1.35;
    color: rgba(223, 223, 223, 0.88); }
    .member-dashboard__rank-upcoming-courses-list li:first-child {
      margin-top: 0; }

.member-dashboard__rank-upcoming-courses-item--met {
  color: rgba(223, 223, 223, 0.28); }

.member-dashboard__rank-upcoming-token-bars {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.4rem;
  margin-top: 0.55rem;
  width: 100%; }

.member-dashboard__rank-token-bar {
  width: 100%;
  min-width: 0; }

.member-dashboard__rank-token-bar__track {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 1.2rem;
  border-radius: 999px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.42);
  border: 1px solid rgba(223, 223, 223, 0.12);
  cursor: default;
  transition: opacity 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease; }

.member-dashboard__rank-token-bar__fill {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: calc(var(--fill-pct, 0) * 1%);
  border-radius: inherit;
  transition: width 0.25s ease; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="0"] {
    --fill-pct: 0; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="1"] {
    --fill-pct: 1; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="2"] {
    --fill-pct: 2; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="3"] {
    --fill-pct: 3; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="4"] {
    --fill-pct: 4; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="5"] {
    --fill-pct: 5; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="6"] {
    --fill-pct: 6; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="7"] {
    --fill-pct: 7; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="8"] {
    --fill-pct: 8; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="9"] {
    --fill-pct: 9; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="10"] {
    --fill-pct: 10; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="11"] {
    --fill-pct: 11; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="12"] {
    --fill-pct: 12; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="13"] {
    --fill-pct: 13; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="14"] {
    --fill-pct: 14; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="15"] {
    --fill-pct: 15; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="16"] {
    --fill-pct: 16; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="17"] {
    --fill-pct: 17; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="18"] {
    --fill-pct: 18; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="19"] {
    --fill-pct: 19; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="20"] {
    --fill-pct: 20; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="21"] {
    --fill-pct: 21; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="22"] {
    --fill-pct: 22; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="23"] {
    --fill-pct: 23; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="24"] {
    --fill-pct: 24; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="25"] {
    --fill-pct: 25; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="26"] {
    --fill-pct: 26; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="27"] {
    --fill-pct: 27; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="28"] {
    --fill-pct: 28; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="29"] {
    --fill-pct: 29; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="30"] {
    --fill-pct: 30; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="31"] {
    --fill-pct: 31; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="32"] {
    --fill-pct: 32; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="33"] {
    --fill-pct: 33; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="34"] {
    --fill-pct: 34; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="35"] {
    --fill-pct: 35; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="36"] {
    --fill-pct: 36; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="37"] {
    --fill-pct: 37; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="38"] {
    --fill-pct: 38; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="39"] {
    --fill-pct: 39; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="40"] {
    --fill-pct: 40; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="41"] {
    --fill-pct: 41; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="42"] {
    --fill-pct: 42; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="43"] {
    --fill-pct: 43; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="44"] {
    --fill-pct: 44; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="45"] {
    --fill-pct: 45; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="46"] {
    --fill-pct: 46; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="47"] {
    --fill-pct: 47; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="48"] {
    --fill-pct: 48; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="49"] {
    --fill-pct: 49; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="50"] {
    --fill-pct: 50; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="51"] {
    --fill-pct: 51; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="52"] {
    --fill-pct: 52; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="53"] {
    --fill-pct: 53; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="54"] {
    --fill-pct: 54; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="55"] {
    --fill-pct: 55; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="56"] {
    --fill-pct: 56; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="57"] {
    --fill-pct: 57; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="58"] {
    --fill-pct: 58; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="59"] {
    --fill-pct: 59; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="60"] {
    --fill-pct: 60; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="61"] {
    --fill-pct: 61; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="62"] {
    --fill-pct: 62; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="63"] {
    --fill-pct: 63; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="64"] {
    --fill-pct: 64; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="65"] {
    --fill-pct: 65; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="66"] {
    --fill-pct: 66; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="67"] {
    --fill-pct: 67; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="68"] {
    --fill-pct: 68; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="69"] {
    --fill-pct: 69; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="70"] {
    --fill-pct: 70; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="71"] {
    --fill-pct: 71; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="72"] {
    --fill-pct: 72; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="73"] {
    --fill-pct: 73; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="74"] {
    --fill-pct: 74; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="75"] {
    --fill-pct: 75; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="76"] {
    --fill-pct: 76; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="77"] {
    --fill-pct: 77; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="78"] {
    --fill-pct: 78; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="79"] {
    --fill-pct: 79; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="80"] {
    --fill-pct: 80; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="81"] {
    --fill-pct: 81; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="82"] {
    --fill-pct: 82; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="83"] {
    --fill-pct: 83; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="84"] {
    --fill-pct: 84; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="85"] {
    --fill-pct: 85; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="86"] {
    --fill-pct: 86; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="87"] {
    --fill-pct: 87; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="88"] {
    --fill-pct: 88; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="89"] {
    --fill-pct: 89; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="90"] {
    --fill-pct: 90; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="91"] {
    --fill-pct: 91; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="92"] {
    --fill-pct: 92; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="93"] {
    --fill-pct: 93; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="94"] {
    --fill-pct: 94; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="95"] {
    --fill-pct: 95; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="96"] {
    --fill-pct: 96; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="97"] {
    --fill-pct: 97; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="98"] {
    --fill-pct: 98; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="99"] {
    --fill-pct: 99; }
  .member-dashboard__rank-token-bar__fill[data-fill-pct="100"] {
    --fill-pct: 100; }

.member-dashboard__rank-token-bar__label {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  height: 100%;
  padding: 0 0.5rem;
  text-align: center;
  white-space: nowrap;
  pointer-events: none; }

.member-dashboard__rank-token-bar__counts {
  font-family: "Lato", sans-serif;
  font-size: 0.62rem;
  font-weight: 700;
  line-height: 1.1;
  letter-spacing: 0.02em;
  color: #ffffff;
  text-shadow: 0 0 6px rgba(0, 0, 0, 0.85), 0 1px 2px rgba(0, 0, 0, 0.9); }

.member-dashboard__rank-token-bar__type {
  font-family: "Lato", sans-serif;
  font-size: 0.62rem;
  font-weight: 600;
  line-height: 1.1;
  letter-spacing: 0.03em;
  text-transform: lowercase;
  color: rgba(223, 223, 223, 0.92);
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.8), 0 1px 2px rgba(0, 0, 0, 0.85); }

.member-dashboard__rank-token-bar--mission:not(.member-dashboard__rank-token-bar--complete) .member-dashboard__rank-token-bar__track {
  border-color: rgba(223, 223, 223, 0.14);
  box-shadow: none;
  background: rgba(0, 0, 0, 0.5); }

.member-dashboard__rank-token-bar--mission:not(.member-dashboard__rank-token-bar--complete) .member-dashboard__rank-token-bar__fill {
  background: linear-gradient(90deg, rgba(155, 96, 42, 0.42), rgba(199, 132, 69, 0.32)); }

.member-dashboard__rank-token-bar--total:not(.member-dashboard__rank-token-bar--complete) .member-dashboard__rank-token-bar__track {
  border-color: rgba(90, 195, 255, 0.28);
  box-shadow: none;
  background: rgba(22, 52, 71, 0.85); }

.member-dashboard__rank-token-bar--total:not(.member-dashboard__rank-token-bar--complete) .member-dashboard__rank-token-bar__fill {
  background: linear-gradient(90deg, rgba(58, 120, 180, 0.95), rgba(90, 195, 255, 0.78)); }

.member-dashboard__rank-token-bar--mission.member-dashboard__rank-token-bar--complete .member-dashboard__rank-token-bar__track {
  border-color: rgba(199, 132, 69, 0.38);
  box-shadow: 0 0 6px rgba(199, 132, 69, 0.32), 0 0 12px rgba(155, 96, 42, 0.2); }

.member-dashboard__rank-token-bar--mission.member-dashboard__rank-token-bar--complete .member-dashboard__rank-token-bar__fill {
  width: 100%;
  background: linear-gradient(90deg, #9b602a, #c78445); }

.member-dashboard__rank-token-bar--total.member-dashboard__rank-token-bar--complete .member-dashboard__rank-token-bar__track {
  border-color: rgba(90, 195, 255, 0.38);
  box-shadow: 0 0 6px rgba(90, 195, 255, 0.32), 0 0 12px rgba(58, 120, 180, 0.22); }

.member-dashboard__rank-token-bar--total.member-dashboard__rank-token-bar--complete .member-dashboard__rank-token-bar__fill {
  width: 100%;
  background: linear-gradient(90deg, #004872, #5ac3ff); }

.member-dashboard__rank-token-bar--time:not(.member-dashboard__rank-token-bar--complete) .member-dashboard__rank-token-bar__track {
  border-color: rgba(121, 88, 195, 0.28);
  box-shadow: none;
  background: rgba(35, 30, 69, 0.55); }

.member-dashboard__rank-token-bar--time:not(.member-dashboard__rank-token-bar--complete) .member-dashboard__rank-token-bar__fill {
  background: linear-gradient(90deg, rgba(70, 54, 133, 0.9), rgba(121, 88, 195, 0.72)); }

.member-dashboard__rank-token-bar--time.member-dashboard__rank-token-bar--complete .member-dashboard__rank-token-bar__track {
  border-color: rgba(121, 88, 195, 0.38);
  box-shadow: 0 0 6px rgba(121, 88, 195, 0.3), 0 0 12px rgba(154, 128, 227, 0.18); }

.member-dashboard__rank-token-bar--time.member-dashboard__rank-token-bar--complete .member-dashboard__rank-token-bar__fill {
  width: 100%;
  background: linear-gradient(90deg, #463685, #7958c3); }

.member-dashboard__rank-upcoming-head {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  min-width: 0; }

.member-dashboard__rank-upcoming-info {
  position: relative;
  flex-shrink: 0;
  margin-left: auto; }

.member-dashboard__rank-upcoming-info__btn {
  width: 16px;
  height: 16px;
  padding: 0;
  border-radius: 999px;
  border: 1px solid rgba(58, 120, 180, 0.38);
  background: rgba(0, 0, 0, 0.35);
  color: rgba(223, 223, 223, 0.88);
  font-family: "Lato", sans-serif;
  font-size: 10px;
  font-weight: 700;
  font-style: italic;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease; }
  .member-dashboard__rank-upcoming-info__btn:hover {
    background: rgba(58, 120, 180, 0.16);
    border-color: rgba(58, 120, 180, 0.55); }

.member-dashboard__rank-upcoming-info__tooltip {
  position: absolute;
  right: 0;
  top: calc(100% + 6px);
  z-index: 6;
  min-width: 200px;
  max-width: 260px;
  padding: 0.55rem 0.65rem;
  border-radius: 10px;
  border: 1px solid rgba(58, 120, 180, 0.28);
  background: rgba(8, 14, 20, 0.94);
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.55), 0 0 0 1px rgba(0, 0, 0, 0.22); }

.member-dashboard__rank-timeline-requirements {
  margin: 0;
  padding: 0;
  list-style: none; }
  .member-dashboard__rank-timeline-requirements li {
    margin: 0.2rem 0 0;
    font-family: "Lato", sans-serif;
    font-size: 10px;
    line-height: 1.4;
    color: rgba(223, 223, 223, 0.75); }
    .member-dashboard__rank-timeline-requirements li:first-child {
      margin-top: 0; }

.member-dashboard__rank-timeline-requirements-item--met {
  color: rgba(223, 223, 223, 0.28); }

.member-dashboard__rank-history-footnote {
  margin: 0.85rem 0 0;
  padding-top: 0.75rem;
  border-top: 1px solid rgba(58, 120, 180, 0.2);
  font-family: "Lato", sans-serif;
  font-size: 0.82rem;
  line-height: 1.45;
  color: #c78445; }

.member-dashboard__chart-scroll {
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  margin-right: -10px;
  padding-right: 10px;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.35) rgba(0, 0, 0, 0.12); }
  .member-dashboard__chart-scroll::-webkit-scrollbar {
    width: 6px; }
  .member-dashboard__chart-scroll::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.12);
    border-radius: 999px; }
  .member-dashboard__chart-scroll::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.3);
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.08); }
  .member-dashboard__chart-scroll::-webkit-scrollbar-thumb:hover {
    background: rgba(58, 120, 180, 0.42); }

.member-dashboard__trainings-card-head {
  display: grid;
  grid-template-columns: 1fr auto;
  column-gap: 0.75rem;
  align-items: center;
  margin-bottom: 15px; }
  .member-dashboard__trainings-card-head .member-dashboard__panel-title {
    margin: 0; }

.member-dashboard__trainings-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0.5rem; }

.member-dashboard__trainings-filter-btn {
  border: 1px solid rgba(58, 120, 180, 0.28);
  background: rgba(0, 0, 0, 0.18);
  color: rgba(223, 223, 223, 0.92);
  border-radius: 10px;
  padding: 8px 10px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 650;
  letter-spacing: 0.02em;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease; }
  .member-dashboard__trainings-filter-btn:hover {
    background: rgba(58, 120, 180, 0.14);
    border-color: rgba(58, 120, 180, 0.55);
    color: rgba(223, 223, 223, 0.98); }
  .member-dashboard__trainings-filter-btn--active {
    background: rgba(58, 120, 180, 0.22);
    border-color: rgba(58, 120, 180, 0.65);
    color: rgba(223, 223, 223, 0.98); }

.member-dashboard__trainings {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px; }

.member-dashboard__trainings--single-col {
  grid-template-columns: 1fr; }

.member-dashboard__trainings-card--stacked .member-dashboard__trainings {
  grid-template-columns: 1fr; }

.member-dashboard__trainings-heading {
  margin: 0 0 10px;
  font-size: 0.72rem;
  font-weight: 650;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.9); }

.member-dashboard__training-line {
  position: relative;
  display: flex;
  gap: 10px;
  align-items: flex-start;
  margin-bottom: 14px;
  padding: 12px 14px;
  overflow: hidden;
  border: 1px solid rgba(58, 120, 180, 0.35);
  border-radius: 10px;
  background: linear-gradient(145deg, #1e3042, #172738); }
  .member-dashboard__training-line .basic-icon {
    flex-shrink: 0;
    width: 22px;
    height: 22px;
    margin-top: 2px;
    object-fit: contain;
    opacity: 0.85; }
  .member-dashboard__training-line .basic-icon.certified {
    opacity: 0.9; }
  .member-dashboard__training-line strong {
    display: block;
    margin-bottom: 4px;
    font-size: 0.88rem;
    color: #5ac3ff; }

.member-dashboard__training-line-body {
  flex: 1;
  min-width: 0; }

.member-dashboard__training-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  font-size: 0.7rem;
  color: #b8b8b8; }

@media (max-width: 720px) {
  .member-dashboard__trainings {
    grid-template-columns: 1fr; } }

.member-dashboard__gameloop-card {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  margin-top: 0;
  padding: 1rem 1.1rem;
  border: 1px solid rgba(58, 120, 180, 0.45);
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(0, 48, 77, 0.72), rgba(21, 28, 36, 0.42)), rgba(0, 48, 77, 0.55);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35), 0 12px 28px rgba(0, 0, 0, 0.35); }

.member-dashboard__gameloop-card--expanded {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  height: auto;
  min-height: 100%;
  max-height: none;
  overflow: visible; }
  .member-dashboard__gameloop-card--expanded .member-dashboard__structure-block,
  .member-dashboard__gameloop-card--expanded .member-dashboard__gameloop-tags-section {
    flex: 0 0 auto;
    width: 100%;
    min-height: 0; }
  .member-dashboard__gameloop-card--expanded .member-dashboard__structure-block-body,
  .member-dashboard__gameloop-card--expanded .member-dashboard__gameloop-tags-body {
    flex: 0 0 auto;
    min-height: 0;
    max-height: none;
    overflow: visible; }

.member-dashboard__structure-block {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  min-height: 0; }

.member-dashboard__structure-block-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  margin-right: -10px;
  padding-right: 10px;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.35) rgba(0, 0, 0, 0.12); }
  .member-dashboard__structure-block-body::-webkit-scrollbar {
    width: 6px; }
  .member-dashboard__structure-block-body::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.12);
    border-radius: 999px; }
  .member-dashboard__structure-block-body::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.3);
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.08); }
  .member-dashboard__structure-block-body::-webkit-scrollbar-thumb:hover {
    background: rgba(58, 120, 180, 0.42); }

.member-dashboard__structure-head {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-shrink: 0;
  margin-bottom: 15px; }

.member-dashboard__structure-title {
  margin: 0;
  flex: 1;
  min-width: 0;
  font-family: "GoodTimes", "Lato", sans-serif;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.88); }

.member-dashboard__structure-head .member-dashboard__gameloop-actions {
  flex-shrink: 0;
  gap: 0.5rem; }

.member-dashboard__structure-pending-toggle {
  box-sizing: border-box;
  margin: 0;
  padding: 0.35rem 0.65rem;
  border: 1px solid rgba(90, 195, 255, 0.35);
  border-radius: 4px;
  background: transparent;
  color: #5ac3ff;
  font-size: 0.72rem;
  font-weight: 600;
  line-height: 1.25;
  white-space: nowrap;
  cursor: pointer; }

.member-dashboard__structure-pending-toggle:hover {
  border-color: rgba(90, 195, 255, 0.6);
  color: #c2f0c3; }

.member-dashboard__assignment-warning {
  margin: 0.5rem 0 0;
  padding: 0.55rem 0.7rem;
  border-radius: 6px;
  border-left: 3px solid #c78445;
  background: rgba(12, 38, 55, 0.45); }

.member-dashboard__assignment-warning-text {
  margin: 0 0 0.5rem;
  font-size: 0.8rem;
  color: rgba(223, 223, 223, 0.95); }

.member-dashboard__assignment-current-label {
  display: block;
  margin-bottom: 0.35rem;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #c78445; }

.member-dashboard__assignment-current-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.45rem; }

.member-dashboard__assignment-current-item {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem 0.65rem;
  align-items: baseline;
  font-size: 0.82rem;
  color: rgba(223, 223, 223, 0.92); }

.member-dashboard__assignment-current-name {
  font-weight: 700;
  color: #c2f0c3; }

.member-dashboard__assignment-current-division {
  color: rgba(184, 184, 184, 0.95); }

.member-dashboard__assignment-current-role {
  font-size: 0.75rem;
  color: rgba(90, 195, 255, 0.95); }

.member-dashboard__assignment-current-period {
  font-size: 0.72rem;
  color: rgba(184, 184, 184, 0.85); }

.member-dashboard__structure-comment {
  margin-top: 0.85rem; }

.member-dashboard__structure-comment-label {
  display: block;
  margin-bottom: 0.25rem;
  font-size: 0.8rem;
  font-weight: 700;
  color: #dfdfdf; }

.member-dashboard__structure-comment-hint {
  margin: 0 0 0.45rem;
  font-size: 0.75rem;
  color: rgba(184, 184, 184, 0.95); }

.member-dashboard__structure-comment-textarea {
  width: 100%;
  box-sizing: border-box;
  padding: 0.5rem 0.65rem;
  border-radius: 6px;
  border: 1px solid rgba(116, 123, 129, 0.5);
  background: rgba(12, 38, 55, 0.65);
  color: #dfdfdf;
  font-family: inherit;
  font-size: 0.82rem;
  resize: vertical;
  min-height: 4.5rem; }

.member-dashboard__structure-request-note {
  margin: 0.5rem 0 0;
  padding: 0.55rem 0.7rem;
  border-radius: 6px;
  border-left: 3px solid #5ac3ff;
  background: rgba(12, 38, 55, 0.4);
  font-size: 0.82rem;
  color: rgba(223, 223, 223, 0.9); }

.member-dashboard__structure-request-note-label {
  display: block;
  margin-bottom: 0.25rem;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #5ac3ff; }

.member-dashboard__structure-resolve-note {
  margin: 0.5rem 0 0;
  padding: 0.55rem 0.7rem;
  border-radius: 6px;
  background: rgba(12, 38, 55, 0.4); }

.member-dashboard__structure-resolve-note--approved {
  border-left: 3px solid #75cf78; }

.member-dashboard__structure-resolve-note--dismissed {
  border-left: 3px solid #c78445; }

.member-dashboard__structure-resolve-note-label {
  margin: 0 0 0.35rem;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase; }

.member-dashboard__structure-resolve-note--approved .member-dashboard__structure-resolve-note-label {
  color: #75cf78; }

.member-dashboard__structure-resolve-note--dismissed .member-dashboard__structure-resolve-note-label {
  color: #c78445; }

.member-dashboard__structure-resolve-note-body {
  margin: 0 0 0.5rem;
  font-size: 0.82rem;
  color: rgba(223, 223, 223, 0.9); }

.member-dashboard__structure-resolve-note-dismiss {
  padding: 0.25rem 0.55rem;
  border-radius: 4px;
  border: 1px solid rgba(116, 123, 129, 0.45);
  background: transparent;
  color: #b8b8b8;
  font-size: 0.75rem;
  cursor: pointer; }

.member-dashboard__structure-resolve-note-dismiss:hover {
  color: #dfdfdf;
  border-color: rgba(184, 184, 184, 0.55); }

.member-dashboard__structure-pending-toggle--active {
  border-color: rgba(117, 207, 120, 0.5);
  color: #c2f0c3;
  background: rgba(117, 207, 120, 0.08); }

.member-dashboard__structure-strip--pending-preview {
  opacity: 0.95; }

.member-dashboard__gameloop-card .member-dashboard__structure-strip {
  width: 100%;
  min-width: 0; }

.member-dashboard__structure-editor.members-onboarding-structure {
  width: 100%;
  min-width: 0; }

.member-dashboard__structure-editor .members-onboarding-structure__cards {
  gap: 1.25rem;
  padding: 0.25rem 0; }

.member-dashboard__structure-editor__card-item {
  display: flex;
  flex: 1 1 calc((100% - 1.25rem) / 2);
  max-width: 11.5rem;
  min-width: 9rem; }

.member-dashboard__structure-editor .members-onboarding-structure__card--locked {
  cursor: not-allowed;
  opacity: 0.78; }
  .member-dashboard__structure-editor .members-onboarding-structure__card--locked:hover, .member-dashboard__structure-editor .members-onboarding-structure__card--locked:focus-visible {
    border-color: rgba(120, 165, 200, 0.7);
    background: rgba(8, 14, 22, 0.7);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.28);
    transform: none; }

.member-dashboard__structure-editor .members-onboarding-structure__card-lock-msg {
  margin: 0;
  font-size: 0.8rem;
  line-height: 1.4;
  text-align: center;
  color: #d8b493; }

.member-dashboard__structure-editor .members-onboarding-structure__breadcrumb {
  flex-wrap: wrap;
  gap: 0.35rem 0.5rem; }

.member-dashboard__structure-editor .members-onboarding-structure__footerDock {
  margin-top: 0.75rem; }

.member-dashboard__structure-editor .members-onboarding-structure__tip {
  display: none; }

.member-dashboard__structure-editor .members-onboarding-structure__validate-wrap .members-onboarding-structure__cta {
  display: none; }

.member-dashboard__structure-editor .members-onboarding-structure__membership-grid {
  gap: 0.5rem 0.6rem;
  padding: 0.1rem 0; }

.member-dashboard__structure-editor .members-onboarding-structure__membership-card {
  min-height: 2.5rem;
  padding: 0.45rem 0.85rem; }

.member-dashboard__structure-editor .members-onboarding-structure__membership-label {
  font-size: 0.82rem;
  letter-spacing: 0.06em; }

.member-dashboard__structure-editor .members-onboarding-structure__membership-heading {
  font-size: 0.84rem;
  padding: 0.45rem 0.5rem; }

.member-dashboard__structure-membership-recap {
  margin: 0.65rem 0 0;
  padding: 0.55rem 0.75rem;
  border-radius: 8px;
  border: 1px solid rgba(58, 120, 180, 0.35);
  background: rgba(0, 48, 77, 0.35);
  font-size: 0.88rem;
  font-weight: 700;
  color: #dfdfdf;
  text-align: center; }

.member-dashboard__structure-membership-recap-label {
  display: block;
  margin-bottom: 0.2rem;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(116, 123, 129, 0.95); }

.member-dashboard__gameloop-card .member-dashboard__structure-strip--loading {
  min-height: 13.25rem;
  border-radius: 10px;
  border: 1px solid rgba(58, 120, 180, 0.35);
  background: rgba(0, 48, 77, 0.35); }

.member-dashboard__structure-recap {
  width: 100%;
  min-width: 0; }

.member-dashboard__gameloop-card .member-dashboard__structure-recap__strip {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: stretch;
  justify-content: center;
  gap: 1.85rem;
  width: 100%;
  min-width: 0; }

.member-dashboard__gameloop-card .member-dashboard__structure-recap__card-item {
  display: flex;
  flex: 1 1 9.25rem;
  min-width: 0;
  max-width: 11.5rem;
  min-height: 7rem;
  justify-content: flex-end; }

.member-dashboard__structure-recap__card-surface {
  box-sizing: border-box;
  width: 100%;
  max-width: 11.5rem;
  margin-left: auto;
  margin-right: auto;
  min-height: 7rem;
  padding: 0.75rem 0.6rem 0.85rem;
  border-radius: 10px;
  border: 1px solid rgba(120, 165, 200, 0.7);
  color: #dfdfdf;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  transition: box-shadow 0.15s ease; }

.member-dashboard__structure-recap__card-surface--neutral {
  background: rgba(8, 14, 22, 0.72);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.28); }

.member-dashboard__structure-recap__card-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.38rem;
  flex: 1 1 auto;
  min-width: 0; }

.member-dashboard__structure-recap__card-logo {
  flex-shrink: 0;
  width: 4.5rem;
  height: 4.2rem;
  object-fit: contain;
  display: block; }

.member-dashboard__structure-recap__card-headings {
  min-width: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
  text-align: center; }

.member-dashboard__structure-recap__card-eyebrow {
  width: 100%;
  text-align: center;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(116, 123, 129, 0.95); }

.member-dashboard__structure-recap__card-title {
  font-size: 0.88rem;
  font-weight: 800;
  line-height: 1.25;
  color: #dfdfdf;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden; }

.member-dashboard__structure-recap__card-subtitle {
  font-size: 0.74rem;
  font-weight: 700;
  color: rgba(116, 123, 129, 0.95);
  word-break: break-word; }

.member-dashboard__gameloop-tags-section {
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-height: 0;
  padding-top: 15px;
  border-top: 1px solid rgba(58, 120, 180, 0.22); }

.member-dashboard__gameloop-tags-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  margin-right: -10px;
  padding-right: 10px;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.35) rgba(0, 0, 0, 0.12); }
  .member-dashboard__gameloop-tags-body::-webkit-scrollbar {
    width: 6px; }
  .member-dashboard__gameloop-tags-body::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.12);
    border-radius: 999px; }
  .member-dashboard__gameloop-tags-body::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.3);
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.08); }
  .member-dashboard__gameloop-tags-body::-webkit-scrollbar-thumb:hover {
    background: rgba(58, 120, 180, 0.42); }

.member-dashboard__gameloop-card-head {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-shrink: 0;
  margin-bottom: 15px; }

.member-dashboard__gameloop-heading {
  flex: 1;
  min-width: 0; }

.member-dashboard__gameloop-heading--editing {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem 1rem;
  flex-wrap: wrap; }

.member-dashboard__gameloop-heading--editing .member-dashboard__gameloop-title {
  flex-shrink: 0; }

.member-dashboard__gameloop-title {
  margin: 0;
  font-family: "GoodTimes", "Lato", sans-serif;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.88); }

.member-dashboard__gameloop-actions {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end; }

.member-dashboard__gameloop-icon-btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(58, 120, 180, 0.5);
  border-radius: 6px;
  background: rgba(30, 48, 66, 0.62);
  color: rgba(90, 195, 255, 0.95);
  cursor: pointer; }

.member-dashboard__gameloop-icon-btn:hover {
  border-color: rgba(117, 207, 120, 0.45);
  color: #c2f0c3; }

.member-dashboard__gameloop-validate {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2rem;
  min-height: 2rem;
  margin: 0;
  padding: 0 0.35rem;
  border: 1px solid rgba(90, 160, 92, 0.55);
  border-radius: 6px;
  background: rgba(42, 95, 45, 0.55);
  color: rgba(194, 240, 195, 0.98);
  cursor: pointer; }

.member-dashboard__gameloop-validate:hover:not(:disabled) {
  border-color: rgba(117, 207, 120, 0.75);
  background: rgba(63, 124, 66, 0.72); }

.member-dashboard__gameloop-validate--disabled {
  opacity: 0.45;
  cursor: default; }

.member-dashboard__gameloop-icon {
  display: block; }

.member-dashboard__gameloop-icon--check {
  margin-top: 1px; }

.member-dashboard__gameloop-msg {
  margin: 0.65rem 0 0;
  font-size: 0.8rem;
  color: rgba(223, 223, 223, 0.9); }

.member-dashboard__gameloop-msg--error {
  color: #c78445; }

.member-dashboard__gameloop-msg--info {
  color: #c78445; }

.member-dashboard__gameloop-loading {
  margin: 0.6rem 0 0;
  font-size: 0.82rem;
  color: rgba(223, 223, 223, 0.8); }

.member-dashboard__gameloop-chips {
  display: flex;
  flex-flow: row wrap;
  gap: 0.45rem;
  margin: 0.85rem 0 0;
  padding: 0;
  list-style: none; }

.member-dashboard__gameloop-chip-li {
  list-style: none;
  margin: 0; }

.member-dashboard__gameloop-chip {
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  min-height: 1.65rem;
  padding: 0.22rem 0.62rem;
  border-radius: 999px;
  border: 1px solid rgba(58, 120, 180, 0.4);
  background: rgba(23, 39, 56, 0.72);
  font-size: 0.74rem;
  line-height: 1.25;
  color: rgba(255, 255, 255, 0.96); }

.member-dashboard__gameloop-chip--inactive {
  border-style: dashed;
  opacity: 0.7; }

.member-dashboard__gameloop-chip--picked-readonly {
  border: 1px solid #3a78b4;
  background: rgba(19, 59, 83, 0.95); }

.member-dashboard__gameloop-chip--toggle {
  font-family: inherit;
  cursor: pointer; }

.member-dashboard__gameloop-chip--toggle:hover:not(:disabled) {
  border-color: rgba(90, 195, 255, 0.55); }

.member-dashboard__gameloop-chip--selected {
  border-color: rgba(117, 207, 120, 0.7);
  background: rgba(63, 124, 66, 0.52); }

.member-dashboard__gameloop-chip--locked {
  cursor: default; }

.member-dashboard__gameloop-count {
  margin: 0;
  font-size: 0.72rem;
  color: #747b81; }

.member-dashboard__gameloop-count--head {
  margin-left: auto;
  text-align: right;
  flex-shrink: 0; }

.member-dashboard__gameloop-empty {
  margin: 0.85rem 0 0;
  font-size: 0.8rem;
  color: rgba(223, 223, 223, 0.75); }

@media (max-width: 900px) {
  .member-dashboard__top {
    grid-template-columns: 1fr; }
  .member-dashboard__main-column {
    grid-column: 1;
    grid-row: auto;
    width: 100%; }
  .member-dashboard__aside-cluster {
    grid-column: 1;
    grid-row: auto;
    flex-direction: column;
    width: 100%; }
  .member-dashboard__aside-bottom-row {
    flex-direction: column; }
  .member-dashboard__aside-bottom-row > .member-dashboard__rank-history-card,
  .member-dashboard__aside-bottom-row > .member-dashboard__history-card {
    width: 100%;
    max-width: 100%; }
  .member-dashboard__gameloop-card .member-dashboard__structure-recap__strip {
    flex-wrap: wrap;
    justify-content: center; }
  .member-dashboard__hero-inner {
    flex-direction: column;
    align-items: stretch; }
  .member-dashboard__identity {
    flex: none;
    width: 100%; }
  .member-dashboard__divider {
    width: 100%;
    height: 1px;
    min-height: 1px;
    background: linear-gradient(90deg, transparent 0%, rgba(58, 120, 180, 0.55) 15%, rgba(58, 120, 180, 0.55) 85%, transparent 100%); } }

.member-dashboard__ribbons-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0.5rem; }

.member-dashboard__ribbons-toolbar__btn {
  border: 1px solid rgba(58, 120, 180, 0.28);
  background: rgba(0, 0, 0, 0.18);
  color: rgba(223, 223, 223, 0.92);
  border-radius: 10px;
  padding: 8px 10px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 650;
  letter-spacing: 0.02em;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease; }
  .member-dashboard__ribbons-toolbar__btn:hover {
    background: rgba(58, 120, 180, 0.14);
    border-color: rgba(58, 120, 180, 0.55);
    color: rgba(223, 223, 223, 0.98); }

.member-dashboard__ribbons-grid {
  display: grid;
  gap: 14px; }

.member-dashboard__ribbons-grid--cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr)); }

.member-dashboard__ribbons-grid--cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr)); }

.member-dashboard__ribbons-grid--cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr)); }

.member-dashboard__ribbons-grid--cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr)); }

.member-dashboard__ribbon-card {
  border: 1px solid rgba(58, 120, 180, 0.18);
  background: rgba(0, 0, 0, 0.14);
  border-radius: 14px;
  padding: 10px;
  position: relative; }
  .member-dashboard__ribbon-card .ribbon-details {
    transform: scale(0.95);
    transform-origin: top center; }

.member-dashboard__ribbon-card--locked .ribbon-details {
  opacity: 0.3; }

.member-dashboard__ribbon-progress {
  margin-bottom: 6px; }

.member-dashboard__ribbon-progress__bar-wrap {
  position: relative;
  width: 100%;
  min-width: 0; }

.member-dashboard__ribbon-progress__track {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 2px;
  width: 100%;
  border: 1px solid rgba(58, 120, 180, 0.22);
  border-radius: 4px;
  padding: 2px;
  min-width: 0;
  min-height: 12px; }

.member-dashboard__ribbon-progress__track--empty .member-dashboard__ribbon-progress__segment {
  opacity: 0.85; }

.member-dashboard__ribbon-progress__segment {
  flex: 1 1 0;
  min-width: 3px;
  border-radius: 0;
  background: rgba(0, 0, 0, 0.22);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
  transition: background 0.18s ease, border-color 0.18s ease; }
  .member-dashboard__ribbon-progress__segment:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px; }
  .member-dashboard__ribbon-progress__segment:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px; }
  .member-dashboard__ribbon-progress__segment.is-filled {
    background: rgba(0, 72, 114, 0.62);
    border-color: rgba(58, 120, 180, 0.35);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06); }

.member-dashboard__ribbon-progress__track--complete .member-dashboard__ribbon-progress__segment.is-filled {
  background: rgba(63, 124, 66, 0.72);
  border-color: rgba(63, 124, 66, 0.45); }

.member-dashboard__ribbon-progress__label {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -42%);
  z-index: 1;
  pointer-events: none;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 650;
  color: rgba(223, 223, 223, 0.96);
  font-variant-numeric: tabular-nums;
  line-height: 1.15;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px); }

.member-dashboard__ribbon-handle {
  position: absolute;
  left: 8px;
  bottom: 8px;
  z-index: 3; }

.member-dashboard__ribbon-handle__btn,
.member-dashboard__ribbon-info__btn {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  border: 1px solid rgba(58, 120, 180, 0.38);
  background: rgba(0, 0, 0, 0.35);
  color: rgba(223, 223, 223, 0.92);
  font-size: 12px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease; }
  .member-dashboard__ribbon-handle__btn:hover,
  .member-dashboard__ribbon-info__btn:hover {
    background: rgba(58, 120, 180, 0.16);
    border-color: rgba(58, 120, 180, 0.55); }

.member-dashboard__ribbon-info__btn {
  font-weight: 700; }

.member-dashboard__ribbon-handle__tooltip,
.member-dashboard__ribbon-info__tooltip {
  position: absolute;
  min-width: 200px;
  max-width: 280px;
  width: 280px;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid rgba(58, 120, 180, 0.28);
  background: rgba(8, 14, 20, 0.92);
  color: rgba(223, 223, 223, 0.92);
  font-size: 12px;
  line-height: 1.35;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.55), 0 0 0 1px rgba(0, 0, 0, 0.22);
  white-space: pre-wrap;
  box-sizing: border-box; }
  .member-dashboard__ribbon-handle__tooltip.is-portaled,
  .member-dashboard__ribbon-info__tooltip.is-portaled {
    right: auto;
    bottom: auto;
    left: auto;
    top: auto; }

.member-dashboard__ribbon-handle__tooltip {
  left: 0;
  bottom: 24px; }

.member-dashboard__ribbon-info {
  position: absolute;
  right: 8px;
  bottom: 8px;
  z-index: 2; }

.member-dashboard__ribbon-info__tooltip {
  right: 0;
  bottom: 24px; }

.member-dashboard__ribbon-name {
  margin-top: 8px;
  font-size: 12px;
  color: rgba(223, 223, 223, 0.88);
  text-align: center;
  line-height: 1.15; }

.member-dashboard__panel-placeholder--error {
  color: #c78445; }

.member-dashboard__history-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding-right: 2px;
  margin-right: -10px;
  padding-right: 10px;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.35) rgba(0, 0, 0, 0.12); }
  .member-dashboard__history-scroll::-webkit-scrollbar {
    width: 6px; }
  .member-dashboard__history-scroll::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.12);
    border-radius: 999px; }
  .member-dashboard__history-scroll::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.3);
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.08); }
  .member-dashboard__history-scroll::-webkit-scrollbar-thumb:hover {
    background: rgba(58, 120, 180, 0.42); }

.member-dashboard__history {
  display: grid;
  gap: 10px; }

.member-dashboard__history-row {
  display: grid;
  grid-template-columns: 96px minmax(0, 1fr) auto auto minmax(64px, max-content);
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid rgba(58, 120, 180, 0.16);
  background: rgba(0, 0, 0, 0.12);
  border-radius: 12px; }

.member-dashboard__history-row--expanded {
  align-items: start; }

.member-dashboard__history-row__date {
  font-family: ui-monospace, "Cascadia Mono", "Segoe UI Mono", monospace;
  font-size: 12px;
  color: rgba(223, 223, 223, 0.82); }

.member-dashboard__history-row__link {
  appearance: none;
  border: none;
  background: none;
  padding: 0;
  text-align: left;
  cursor: pointer;
  color: rgba(58, 120, 180, 0.92);
  font-size: 13px;
  font-weight: 650;
  text-decoration: underline;
  text-decoration-color: rgba(58, 120, 180, 0.35);
  text-underline-offset: 3px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }
  .member-dashboard__history-row__link:hover {
    color: #dfdfdf;
    text-decoration-color: rgba(223, 223, 223, 0.55); }

.member-dashboard__history-row__income {
  font-family: ui-monospace, "Cascadia Mono", "Segoe UI Mono", monospace;
  font-size: 12px;
  color: rgba(223, 223, 223, 0.88);
  white-space: nowrap;
  text-align: right; }

.member-dashboard__history-row__loot {
  display: flex;
  justify-content: flex-end;
  min-width: 52px; }

.member-dashboard__history-row__handle {
  justify-self: end;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 11px;
  color: rgba(223, 223, 223, 0.68);
  text-align: right; }

.member-dashboard__history-loot-chip {
  appearance: none;
  border: 1px solid rgba(58, 120, 180, 0.45);
  background: rgba(58, 120, 180, 0.12);
  border-radius: 999px;
  padding: 2px 10px;
  font-size: 11px;
  font-weight: 650;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(58, 120, 180, 0.92);
  cursor: pointer; }
  .member-dashboard__history-loot-chip:hover {
    background: rgba(58, 120, 180, 0.22);
    color: #dfdfdf; }

.member-dashboard__history-loot-chip--active {
  background: rgba(58, 120, 180, 0.28);
  border-color: rgba(58, 120, 180, 0.72);
  color: #dfdfdf; }

.member-dashboard__history-loot-details {
  grid-column: 1 / -1;
  margin: 0;
  padding: 8px 10px 2px;
  list-style: none;
  border-top: 1px solid rgba(58, 120, 180, 0.14);
  display: grid;
  gap: 6px; }

.member-dashboard__history-loot-item {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  font-size: 12px;
  color: rgba(223, 223, 223, 0.82); }

.member-dashboard__history-loot-item__label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.member-dashboard__history-loot-item__qty {
  flex-shrink: 0;
  font-family: ui-monospace, "Cascadia Mono", "Segoe UI Mono", monospace;
  color: rgba(223, 223, 223, 0.68); }

.member-dashboard__history-row--redacted {
  border-style: dashed;
  opacity: 0.78; }

.member-dashboard__history-row__redacted {
  font-family: ui-monospace, "Cascadia Mono", "Segoe UI Mono", monospace;
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.72);
  user-select: none; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.personal-hub-section--promo-host {
  position: relative; }

.mobile-webapp-promo {
  position: absolute;
  inset: 0;
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: rgba(21, 28, 36, 0.72);
  backdrop-filter: blur(6px); }

.mobile-webapp-promo__dialog {
  position: relative;
  width: min(100%, 420px);
  padding: 2rem 1.75rem 1.5rem;
  border-radius: 14px;
  border: 1px solid rgba(58, 120, 180, 0.45);
  background: linear-gradient(165deg, rgba(22, 52, 71, 0.98) 0%, rgba(21, 28, 36, 0.96) 100%);
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.45), 0 0 0 1px rgba(223, 223, 223, 0.06) inset;
  text-align: center; }

.mobile-webapp-promo__close {
  position: absolute;
  top: 0.65rem;
  right: 0.75rem;
  width: 2rem;
  height: 2rem;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 50%;
  color: rgba(223, 223, 223, 0.85);
  background: transparent;
  font-size: 1.35rem;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease; }
  .mobile-webapp-promo__close:hover {
    color: #ffffff;
    background: rgba(223, 223, 223, 0.12); }
  .mobile-webapp-promo__close:focus-visible {
    outline: 2px solid rgba(58, 120, 180, 0.75);
    outline-offset: 2px; }

.mobile-webapp-promo__icon-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 4.5rem;
  height: 4.5rem;
  margin: 0 auto 1.25rem;
  border-radius: 50%;
  background: rgba(58, 120, 180, 0.18);
  box-shadow: 0 0 0 1px rgba(58, 120, 180, 0.35); }

.mobile-webapp-promo__icon {
  font-size: 1.75rem;
  color: #dfdfdf; }

.mobile-webapp-promo__icon--phone {
  position: relative;
  z-index: 1; }

.mobile-webapp-promo__icon--qr {
  position: absolute;
  right: 0.55rem;
  bottom: 0.45rem;
  z-index: 2;
  font-size: 1.15rem;
  padding: 0.2rem;
  border-radius: 6px;
  color: #ffffff;
  background: rgba(58, 120, 180, 0.85); }

.mobile-webapp-promo__title {
  margin: 0 0 0.75rem;
  color: #ffffff;
  font-size: 1.15rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase; }

.mobile-webapp-promo__message {
  margin: 0 0 1.5rem;
  color: rgba(223, 223, 223, 0.92);
  font-size: 0.95rem;
  line-height: 1.55; }

.mobile-webapp-promo__actions {
  display: flex;
  flex-direction: column;
  gap: 0.65rem; }

.mobile-webapp-promo__cta,
.mobile-webapp-promo__dismiss {
  width: 100%; }

@media (max-width: 480px) {
  .mobile-webapp-promo {
    padding: 1rem; }
  .mobile-webapp-promo__dialog {
    padding: 1.75rem 1.25rem 1.25rem; } }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.table-base.emojis table colgroup col.col-imageUrl {
  width: 65px; }

.table-base.emojis table colgroup col.col-fullName {
  width: 400px; }

.table-base.emojis table colgroup col.col-shortName {
  width: 240px; }

.table-base.emojis table colgroup col.col-category {
  width: 140px; }

.table-base.emojis table colgroup col.col-status {
  width: 70px; }

.table-base.carousel table colgroup col.col-title {
  width: 190px; }

.table-base.carousel table colgroup col.col-subtitle {
  width: 200px; }

.table-base.carousel table colgroup col.col-mediaType {
  width: 100px; }

.table-base.carousel table colgroup col.col-size {
  width: 80px; }

.table-base.carousel table colgroup col.col-action {
  width: 80px; }

.table-base.orgs-whitelist table colgroup col.col-logo {
  width: 90px; }

.table-base.orgs-whitelist table colgroup col.col-orgName {
  width: 160px; }

.table-base.orgs-whitelist table colgroup col.col-orgSid {
  width: 100px; }

.table-base.orgs-whitelist table colgroup col.col-whitelisted {
  width: 75px; }

.table-base.orgs-whitelist table colgroup col.col-blacklisted {
  width: 75px; }

.table-base.orgs-whitelist table colgroup col.col-commentEdit {
  width: 280px; }

.table-base.orgs-whitelist table colgroup col.col-commentSave {
  width: 92px; }

.table-base.public-pages .table-body-wrapper {
  max-height: 170px; }

.table-base.emojis .table-body-wrapper {
  max-height: 40vh; }

.table-base.carousel .table-body-wrapper {
  max-height: 180px; }

.table-base.permissions .table-body-wrapper {
  max-height: 40vh; }

.table-base.templates .table-body-wrapper {
  max-height: 400px; }

.table-base.subtypes .table-body-wrapper {
  max-height: 207px; }

.table-base.ribbons .table-body-wrapper {
  max-height: 40vh; }

.table-base.organization-logs .table-body-wrapper {
  max-height: 50vh; }

.table-base.organization-applications .table-body-wrapper {
  max-height: 200px; }

.table-base.orgs-whitelist .table-body-wrapper {
  max-height: 55vh; }

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%; }

.header-label {
  flex: 1 1 auto; }

.sort-indicator {
  color: #fff;
  font-size: 0.9rem;
  margin-left: 0.25rem; }

.table-base {
  border: 1px solid #491212;
  border-radius: 8px;
  overflow: hidden;
  color: #dfdfdf;
  margin: 10px 0px;
  box-shadow: 4px 5px 2px #4b050547; }
  .table-base table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed; }
  .table-base th[class^="header-"], .table-base td[class^="cell-"] {
    text-align: left;
    text-overflow: ellipsis;
    padding: 0 12px; }
  .table-base th.header-imageUrl, .table-base td.cell-imageUrl,
  .table-base th.header-qtyRequirement, .table-base td.cell-qtyRequirement,
  .table-base th.header-status, .table-base td.cell-status,
  .table-base th.header-action, .table-base td.cell-action {
    text-align: center; }
    .table-base th.header-imageUrl.cell-action, .table-base td.cell-imageUrl.cell-action,
    .table-base th.header-qtyRequirement.cell-action, .table-base td.cell-qtyRequirement.cell-action,
    .table-base th.header-status.cell-action, .table-base td.cell-status.cell-action,
    .table-base th.header-action.cell-action, .table-base td.cell-action.cell-action {
      text-align: left; }
  .table-base th.header-size, .table-base td.cell-size {
    text-align: right; }
  .table-base thead {
    display: table-header-group;
    background-size: cover;
    color: #b8b8b8;
    text-transform: uppercase;
    border-bottom: 2px solid #2a3847;
    background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center; }
  .table-base thead th {
    height: 30px;
    font-size: 0.75em;
    font-weight: 600;
    position: relative;
    border-right: none; }
    .table-base thead th:not(:last-child)::after {
      content: '';
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
      height: 65%;
      background-color: #2a3847; }
  .table-base .table-body-wrapper {
    max-height: calc(100vh - 400px);
    overflow-y: auto;
    overflow-x: hidden;
    border-bottom: 4px solid #491212;
    box-shadow: 4px 5px 2px #4b050547; }
    .table-base .table-body-wrapper::-webkit-scrollbar {
      width: 6px; }
    .table-base .table-body-wrapper::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .table-base .table-body-wrapper::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .table-base .table-body-wrapper::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
  .table-base tbody tr {
    height: 45px;
    color: #b8b8b8;
    font-size: 0.9em; }
    .table-base tbody tr:nth-child(odd) {
      background: #1e3042; }
    .table-base tbody tr:nth-child(even) {
      background: #172738; }
    .table-base tbody tr:hover {
      background: rgba(37, 64, 85, 0.9);
      border-radius: 3px; }
    .table-base tbody tr.unread-row {
      color: white; }
  .table-base:not(.roster) tbody tr.selected-row {
    background: rgba(24, 47, 67, 0.9);
    box-shadow: inset 0 0 10px rgba(61, 150, 177, 0.4);
    transition: background 0.25s ease, box-shadow 0.25s ease;
    border-radius: 3px; }
  .table-base .arrow,
  .table-base .delete-media,
  .table-base svg.icon,
  .table-base .action-cell-container svg {
    max-height: 20px;
    fill: none;
    cursor: pointer; }
    .table-base .arrow:hover,
    .table-base .delete-media:hover,
    .table-base svg.icon:hover,
    .table-base .action-cell-container svg:hover {
      stroke: #491212; }
  .table-base.emojis table colgroup col.col-imageUrl {
    width: 65px; }
  .table-base.emojis table colgroup col.col-fullName {
    width: 400px; }
  .table-base.emojis table colgroup col.col-shortName {
    width: 240px; }
  .table-base.emojis table colgroup col.col-category {
    width: 140px; }
  .table-base.emojis table colgroup col.col-status {
    width: 70px; }
  .table-base.carousel table colgroup col.col-handle {
    width: 30px;
    cursor: grab; }
  .table-base.carousel table colgroup col.col-title {
    width: 145px; }
  .table-base.carousel table colgroup col.col-subtitle {
    width: 220px; }
  .table-base.carousel table colgroup col.col-mediaType {
    width: 93px; }
  .table-base.carousel table colgroup col.col-size {
    width: 93px; }
  .table-base.carousel table colgroup col.col-action {
    width: 30px; }
  .table-base.modules colgroup col.col-moduleName {
    width: auto; }
  .table-base.modules colgroup col.col-trainingLevel {
    width: 110px; }
  .table-base.modules colgroup col.col-theme {
    width: 110px; }
  .table-base.modules colgroup col.col-moduleVersion {
    width: 80px; }
  .table-base.modules colgroup col.col-document {
    width: 60px; }
  .table-base.modules colgroup col.col-qcm {
    width: 60px; }
  .table-base.modules colgroup col.col-simple {
    width: 70px; }
  .table-base.modules colgroup col.col-standard {
    width: 70px; }
  .table-base.modules colgroup col.col-complex {
    width: 70px; }
  .table-base.modules colgroup col.col-expert {
    width: 70px; }
  .table-base.modules colgroup col.col-trainings {
    width: 190px; }
  .table-base.modules colgroup col.col-checklist {
    width: 95px; }
  .table-base.modules colgroup col.col-assign {
    width: 50px; }
  .table-base.roster {
    position: relative;
    overflow: hidden;
    margin: 5px 0px 10px;
    border: none;
    box-shadow: none; }
    .table-base.roster .table-header {
      border-collapse: separate;
      border-spacing: 0;
      margin-bottom: 3px;
      width: 100%;
      filter: drop-shadow(0 3px 6px rgba(0, 0, 0, 0.5)) drop-shadow(0 6px 14px rgba(0, 0, 0, 0.35)); }
      .table-base.roster .table-header thead {
        border-bottom: none;
        height: 45px;
        background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center; }
      .table-base.roster .table-header thead tr th:first-child {
        border-radius: 10px 0 0 10px; }
      .table-base.roster .table-header thead th {
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.16), inset 0 -1px 0 rgba(0, 0, 0, 0.18); }
    .table-base.roster .roster-table-footer {
      height: 10px;
      margin-top: 10px;
      width: 100%;
      border-radius: 10px;
      background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.16), inset 0 -1px 0 rgba(0, 0, 0, 0.18);
      filter: drop-shadow(0 3px 6px rgba(0, 0, 0, 0.5)) drop-shadow(0 6px 14px rgba(0, 0, 0, 0.35)); }
      .table-base.roster .roster-table-footer--pagination {
        height: auto;
        min-height: 36px;
        padding: 5px 8px 5px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: left; }
    .table-base.roster .roster-table-footer__pagination {
      margin-left: 100px;
      min-width: 0; }
    .table-base.roster .roster-pagination {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 2px;
      min-width: 0; }
    .table-base.roster .roster-pagination__edge,
    .table-base.roster .roster-pagination__step {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 5px 6px;
      border: none;
      border-radius: 6px;
      background: transparent;
      color: #dfdfdf;
      cursor: pointer; }
      .table-base.roster .roster-pagination__edge:disabled,
      .table-base.roster .roster-pagination__step:disabled {
        opacity: 0.32;
        cursor: default; }
      .table-base.roster .roster-pagination__edge:not(:disabled):hover,
      .table-base.roster .roster-pagination__step:not(:disabled):hover {
        background: rgba(255, 255, 255, 0.07); }
    .table-base.roster .roster-pagination__glyph {
      display: block; }
    .table-base.roster .roster-pagination__pages {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 2px;
      margin: 0 2px;
      min-width: 0;
      flex-wrap: wrap;
      justify-content: center; }
    .table-base.roster .roster-pagination__page {
      min-width: 1.85rem;
      padding: 4px 7px;
      border: 1px solid transparent;
      border-radius: 6px;
      background: transparent;
      color: inherit;
      font-size: 0.8rem;
      cursor: pointer;
      line-height: 1.2; }
      .table-base.roster .roster-pagination__page:hover {
        background: rgba(255, 255, 255, 0.06); }
      .table-base.roster .roster-pagination__page--active {
        border-color: rgba(61, 150, 177, 0.5);
        background: rgba(61, 150, 177, 0.12);
        box-shadow: 0 0 0 1px rgba(61, 150, 177, 0.22); }
    .table-base.roster .roster-pagination__ellipsis {
      padding: 0 5px;
      opacity: 0.55;
      user-select: none;
      font-size: 0.85rem; }
      .table-base.roster .roster-pagination__ellipsis--more {
        opacity: 0.85;
        color: #dfdfdf;
        letter-spacing: 0.08em;
        font-weight: 600; }
    .table-base.roster thead th {
      cursor: default;
      user-select: none; }
    .table-base.roster .table-header tr::after {
      content: '';
      display: table-cell;
      width: 0px;
      border-radius: 0 10px 10px 0;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.16), inset 0 -1px 0 rgba(0, 0, 0, 0.18); }
    .table-base.roster colgroup col.col-rosterRankIcon {
      width: 55px; }
    .table-base.roster colgroup col.col-rosterRank {
      width: 170px; }
    .table-base.roster colgroup col.col-rosterMoniker {
      width: 293px; }
    .table-base.roster colgroup col.col-division {
      width: 77px; }
    .table-base.roster colgroup col.col-branch {
      width: 77px; }
    .table-base.roster colgroup col.col-section {
      width: 77px; }
    .table-base.roster colgroup col.col-basic {
      width: 80px; }
    .table-base.roster colgroup col.col-missionToken {
      width: 68px; }
    .table-base.roster colgroup col.col-eventToken {
      width: 68px; }
    .table-base.roster colgroup col.col-totalToken {
      width: 80px; }
    .table-base.roster colgroup col.col-affiliation {
      width: 88px; }
    .table-base.roster colgroup col.col-visibility {
      width: 75px; }
    .table-base.roster colgroup col.col-certification {
      width: 50px; }
    .table-base.roster .roster-rank-icon-img {
      display: block;
      margin: 0 auto;
      max-height: 27px;
      max-width: 40px;
      width: auto;
      height: auto;
      object-fit: contain;
      transform: translateZ(0);
      backface-visibility: hidden; }
    .table-base.roster .roster-rank-name {
      font-size: 0.75rem;
      text-transform: uppercase; }
    .table-base.roster .roster-rank-name--split {
      display: inline-flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 0.08em;
      line-height: 1.18;
      text-align: left; }
    .table-base.roster .roster-rank-name__line1 {
      font-size: inherit; }
    .table-base.roster .roster-rank-name__line2 {
      font-size: 0.86em;
      opacity: 0.92;
      letter-spacing: 0.02em; }
    .table-base.roster td.cell-rosterRank,
    .table-base.roster th.header-rosterRank {
      padding-top: 0px;
      padding-bottom: 0px; }
    .table-base.roster .roster-token-lock {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: rgba(180, 188, 196, 0.75); }
    .table-base.roster .roster-token-lock__svg {
      width: 14px;
      height: 14px;
      display: block; }
    .table-base.roster td.cell-missionToken,
    .table-base.roster td.cell-eventToken,
    .table-base.roster td.cell-totalToken {
      text-align: center; }
    .table-base.roster .rank-placeholder,
    .table-base.roster .rank-icon-placeholder {
      display: inline-block;
      min-width: 0.5rem;
      opacity: 0.35; }
    .table-base.roster td.cell-rosterMoniker,
    .table-base.roster th.header-rosterMoniker {
      text-align: left; }
    .table-base.roster td.cell-rosterMoniker {
      position: relative;
      overflow: visible; }
    .table-base.roster .roster-moniker-cell {
      position: relative;
      width: 100%;
      min-width: 0;
      overflow: visible; }
      .table-base.roster .roster-moniker-cell:has(.roster-moniker__donor-gem) {
        padding-right: 24px; }
      .table-base.roster .roster-moniker-cell > .roster-moniker__donor-gem {
        position: absolute;
        right: 25px;
        top: 10px;
        margin-left: 0; }
      .table-base.roster .roster-moniker-cell:has(.roster-moniker-stack--no-assignment) > .roster-moniker__donor-gem,
      .table-base.roster .roster-moniker-cell:not(:has(.roster-moniker-stack)) > .roster-moniker__donor-gem {
        top: 50%;
        margin-top: calc(-0.9rem * 1.15 / 2); }
    .table-base.roster tbody.content tr.roster-row:not(.roster-row-secondary-outer) td.cell-rosterMoniker:has(.roster-moniker-stack--no-assignment) {
      padding: 0 10px;
      vertical-align: middle; }
    .table-base.roster .roster-moniker-stack {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 0.18rem;
      width: 100%;
      min-width: 0;
      text-align: left;
      line-height: 1.25; }
    .table-base.roster .roster-moniker-stack__line--name {
      width: 100%;
      min-width: 0; }
    .table-base.roster .roster-moniker__donor-gem {
      flex: 0 0 18px;
      width: 18px;
      height: calc(0.9rem * 1.15);
      position: relative;
      overflow: visible; }
      .table-base.roster .roster-moniker__donor-gem .donor-gem-badge__wrap {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 18px;
        height: 18px;
        transform: translate(-50%, -50%); }
      .table-base.roster .roster-moniker__donor-gem .donor-gem-badge__wrap--premium::before {
        inset: -5px;
        opacity: 0;
        animation: none; }
      .table-base.roster .roster-moniker__donor-gem .donor-gem-badge__gem {
        width: 18px;
        height: 18px; }
      .table-base.roster .roster-moniker__donor-gem .donor-gem-badge__tooltip {
        left: auto;
        right: 22px;
        top: 8px;
        height: 10px;
        z-index: 20;
        transform: translateY(2px); }
      .table-base.roster .roster-moniker__donor-gem .donor-gem-badge__wrap:hover .donor-gem-badge__tooltip,
      .table-base.roster .roster-moniker__donor-gem .donor-gem-badge__wrap:focus-within .donor-gem-badge__tooltip {
        transform: translateY(0); }
      .table-base.roster .roster-moniker__donor-gem .donor-gem-badge__wrap--premium:hover::before,
      .table-base.roster .roster-moniker__donor-gem .donor-gem-badge__wrap--premium:focus-within::before {
        opacity: 1;
        animation: donor-gem-badge-aura 1.4s ease-in-out infinite; }
    .table-base.roster .roster-moniker-stack__name-text {
      display: inline-block;
      font-weight: 700;
      font-size: 0.90rem;
      color: #b8b8b8; }
    .table-base.roster .roster-assignment-cell {
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 0.35em;
      max-width: 100%;
      margin: 0 auto;
      text-align: center;
      line-height: 1.22;
      font-size: 0.88rem;
      white-space: normal;
      overflow-wrap: break-word;
      word-break: break-word; }
    .table-base.roster .roster-assignment-cell--stacked {
      display: block;
      margin: 0;
      max-width: 100%;
      text-align: left;
      font-size: 0.78rem;
      line-height: 1.35;
      white-space: normal;
      overflow-wrap: break-word;
      word-break: break-word; }
      .table-base.roster .roster-assignment-cell--stacked.roster-assignment-cell--legacy {
        width: 100%;
        color: #b8b8b8; }
    .table-base.roster .roster-assignment-cell__segment--user-assignments {
      color: #5ac3ff; }
    .table-base.roster .roster-assignment-cell__segment--user-org-divisions {
      color: #5ac3ff; }
    .table-base.roster .roster-assignment-cell--legacy {
      display: block;
      width: 100%;
      text-align: left; }
    .table-base.roster .roster-assignment-cell__block {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.12em; }
    .table-base.roster .roster-assignment-cell__block + .roster-assignment-cell__block {
      margin-top: 0.35em;
      padding-top: 0.35em;
      border-top: 1px solid rgba(255, 255, 255, 0.1); }
    .table-base.roster .roster-org-cell {
      display: flex;
      width: 100%;
      max-width: 100%;
      min-width: 0;
      box-sizing: border-box;
      justify-content: center;
      white-space: normal;
      overflow-wrap: break-word;
      word-break: break-word;
      line-height: 1.28;
      font-size: 0.88rem; }
    .table-base.roster .roster-org-cell--image {
      display: flex;
      align-items: center;
      justify-content: center;
      white-space: normal; }
    .table-base.roster .roster-org-cell__img {
      display: block;
      max-width: 100%;
      max-height: 30px;
      width: auto;
      height: auto;
      object-fit: contain;
      transform: translateZ(0); }
    .table-base.roster .visibility-label {
      display: flex;
      justify-self: center;
      justify-content: center;
      align-items: center;
      width: fit-content;
      min-width: 45px;
      padding: 4px 8px;
      border-radius: 6px;
      border: 1px solid transparent;
      font-size: 0.75rem;
      font-weight: 500;
      line-height: 1;
      transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease, color 0.2s ease; }
      .table-base.roster .visibility-label.Visible {
        color: rgba(90, 195, 255, 0.65);
        background: linear-gradient(180deg, #163447 0%, #00304d 100%);
        border-color: rgba(90, 195, 255, 0.65);
        box-shadow: inset 0 0 10px rgba(0, 180, 255, 0.08), 0 0 10px rgba(0, 180, 255, 0.18); }
        .table-base.roster .visibility-label.Visible:hover {
          box-shadow: inset 0 0 12px rgba(0, 200, 255, 0.12), 0 0 14px rgba(0, 200, 255, 0.28); }
      .table-base.roster .visibility-label.Hidden, .table-base.roster .visibility-label.Redacted {
        color: #ff8a8a;
        background: linear-gradient(180deg, rgba(60, 15, 15, 0.95) 0%, rgba(30, 8, 8, 0.95) 100%);
        border-color: rgba(255, 70, 70, 0.35);
        box-shadow: inset 0 0 10px rgba(255, 0, 0, 0.05), 0 0 10px rgba(255, 40, 40, 0.15); }
        .table-base.roster .visibility-label.Hidden:hover, .table-base.roster .visibility-label.Redacted:hover {
          border-color: rgba(255, 110, 110, 0.65);
          box-shadow: inset 0 0 12px rgba(255, 0, 0, 0.08), 0 0 14px rgba(255, 60, 60, 0.25); }
      .table-base.roster .visibility-label.Unknown {
        color: #a0b4c8;
        background: rgba(80, 100, 120, 0.12);
        border-color: rgba(160, 180, 200, 0.18);
        box-shadow: none; }
    .table-base.roster .basic-dots {
      display: flex;
      gap: 10px;
      justify-content: center; }
    .table-base.roster .basic-dot {
      width: 14px;
      height: 14px;
      border-radius: 50%;
      border: 2px solid #9b602a;
      box-sizing: border-box; }
      .table-base.roster .basic-dot.done {
        background: #5aa05c;
        border: 2px solid #5aa05c; }
      .table-base.roster .basic-dot.missing {
        background: transparent;
        opacity: 0.4; }
    .table-base.roster .basic-icons {
      display: flex;
      gap: 6px;
      justify-content: center;
      align-items: center; }
    .table-base.roster .basic-icon {
      width: 18px;
      height: 18px;
      object-fit: contain;
      transition: opacity 0.2s ease;
      transform: translateZ(0);
      backface-visibility: hidden; }
    .table-base.roster .basic-icon.certified {
      opacity: 0.8; }
    .table-base.roster .basic-icon.required {
      opacity: 0.2; }
    .table-base.roster .basic-icon.certified {
      opacity: 0.8;
      background-image: none !important;
      animation: none !important;
      filter: none !important; }
    .table-base.roster .basic-icon.certified:hover {
      animation: none !important;
      filter: none !important; }
    .table-base.roster .table-body-scroll {
      position: relative;
      background: transparent;
      height: calc(100vh - 420px);
      overflow-x: hidden;
      overflow-y: auto;
      display: block;
      scrollbar-width: none; }
      .table-base.roster .table-body-scroll > table {
        position: relative;
        z-index: 1; }
    .table-base.roster .roster-affiliation-connectors {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
      pointer-events: none;
      overflow: visible; }
      .table-base.roster .roster-affiliation-connectors path {
        fill: none;
        stroke: #dfdfdf;
        stroke-width: 1.5;
        stroke-linecap: round;
        stroke-linejoin: round; }

@keyframes roster-child-deploy {
  from {
    opacity: 1;
    transform: translateY(-6px); }
  to {
    opacity: 1;
    transform: translateY(0); } }

@keyframes roster-collapse-ghost-fade {
  0%,
  59.375% {
    opacity: 1; }
  100% {
    opacity: 0; } }
    .table-base.roster .roster-collapse-ghost {
      position: absolute;
      top: var(--ghost-top, 0);
      left: var(--ghost-left, 0);
      width: var(--ghost-width, 0);
      height: var(--ghost-height, 0);
      z-index: 0;
      pointer-events: none;
      border-radius: 8px;
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.12), inset 0 -1px 0 rgba(0, 0, 0, 0.2);
      background: rgba(30, 48, 66, 0.92);
      animation: roster-collapse-ghost-fade var(--roster-collapse-total-ms, 640ms) cubic-bezier(0.22, 1, 0.36, 1) forwards; }
      @media (prefers-reduced-motion: reduce) {
        .table-base.roster .roster-collapse-ghost {
          animation: none;
          opacity: 0; } }
    .table-base.roster .roster-master-expand-hit {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      z-index: 2;
      width: 28px;
      margin: 0;
      padding: 0;
      border: none;
      border-radius: 0;
      background: transparent;
      cursor: pointer; }
      .table-base.roster .roster-master-expand-hit:hover {
        background: rgba(223, 223, 223, 0.08); }
      .table-base.roster .roster-master-expand-hit:focus-visible {
        outline: 1px solid rgba(223, 223, 223, 0.6);
        outline-offset: 1px; }
    .table-base.roster tbody.content tr.roster-row--has-children:not(.roster-row-secondary-outer) > td.cell-rosterRankIcon {
      position: relative;
      padding-left: 12px; }
      .table-base.roster tbody.content tr.roster-row--has-children:not(.roster-row-secondary-outer) > td.cell-rosterRankIcon::before {
        content: '';
        position: absolute;
        left: 8px;
        top: 50%;
        transform: translateY(-50%);
        width: 0;
        height: 0;
        border-top: 4px solid transparent;
        border-bottom: 4px solid transparent;
        border-left: 6px solid #dfdfdf;
        pointer-events: none;
        z-index: 1;
        transition: transform 0.2s ease; }
    .table-base.roster tbody.content tr.roster-row--has-children.roster-row--children-expanded:not(.roster-row-secondary-outer) > td.cell-rosterRankIcon::before {
      transform: translateY(-50%) rotate(90deg); }
    .table-base.roster .table-body-scroll table {
      position: relative;
      z-index: 0;
      width: 100%;
      border-collapse: separate;
      border-spacing: 0 10px; }
    .table-base.roster tbody.content tr.roster-row:not(.roster-row-secondary-outer) {
      cursor: pointer;
      transition: background 0.2s ease, box-shadow 0.25s ease, filter 0.2s ease;
      border-radius: 8px;
      overflow: hidden;
      filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.45)); }
      .table-base.roster tbody.content tr.roster-row:not(.roster-row-secondary-outer):has(.roster-moniker__donor-gem .donor-gem-badge__wrap:hover), .table-base.roster tbody.content tr.roster-row:not(.roster-row-secondary-outer):has(.roster-moniker__donor-gem .donor-gem-badge__wrap:focus-within) {
        overflow: visible;
        position: relative;
        z-index: 6; }
      .table-base.roster tbody.content tr.roster-row:not(.roster-row-secondary-outer) td {
        background: transparent;
        box-shadow: none; }
      .table-base.roster tbody.content tr.roster-row:not(.roster-row-secondary-outer):nth-child(odd) {
        background: #032e48;
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.14), inset 0 -1px 0 rgba(0, 0, 0, 0.2); }
      .table-base.roster tbody.content tr.roster-row:not(.roster-row-secondary-outer):nth-child(even) {
        background: #062a40;
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.14), inset 0 -1px 0 rgba(0, 0, 0, 0.2); }
      .table-base.roster tbody.content tr.roster-row:not(.roster-row-secondary-outer):hover:not(.selected-row) {
        background: rgba(37, 64, 85, 0.8);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.16), inset 0 -1px 0 rgba(0, 0, 0, 0.18);
        filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.55)); }
      .table-base.roster tbody.content tr.roster-row:not(.roster-row-secondary-outer).selected-row {
        background: #203f5acc;
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), inset 0 -1px 0 rgba(0, 0, 0, 0.18), inset 0 0 10px rgba(61, 150, 177, 0.4);
        filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.5)) drop-shadow(0 0 12px rgba(61, 150, 177, 0.15));
        transition: background 0.25s ease, box-shadow 0.25s ease; }
      .table-base.roster tbody.content tr.roster-row:not(.roster-row-secondary-outer).selected-row:hover {
        background: #254055cc;
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.12), inset 0 -1px 0 rgba(0, 0, 0, 0.16), inset 0 0 10px rgba(61, 150, 177, 0.4);
        filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.55)) drop-shadow(0 0 14px rgba(61, 150, 177, 0.22)); }
      .table-base.roster tbody.content tr.roster-row:not(.roster-row-secondary-outer).roster-row--current-user:nth-child(odd) {
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.14), inset 0 -1px 0 rgba(0, 0, 0, 0.2), inset 0 0 0 2px rgba(61, 150, 177, 0.44), inset 0 0 28px rgba(61, 150, 177, 0.24); }
      .table-base.roster tbody.content tr.roster-row:not(.roster-row-secondary-outer).roster-row--current-user:nth-child(even) {
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.14), inset 0 -1px 0 rgba(0, 0, 0, 0.2), inset 0 0 0 2px rgba(61, 150, 177, 0.44), inset 0 0 28px rgba(61, 150, 177, 0.24); }
      .table-base.roster tbody.content tr.roster-row:not(.roster-row-secondary-outer).roster-row--current-user:hover:not(.selected-row) {
        background: linear-gradient(165deg, rgba(95, 175, 205, 0.14) 0%, rgba(61, 150, 177, 0.08) 50%, rgba(35, 75, 105, 0.12) 100%), #254055;
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.16), inset 0 -1px 0 rgba(0, 0, 0, 0.18), inset 0 0 0 2px rgba(100, 200, 230, 0.5), inset 0 0 32px rgba(61, 150, 177, 0.18);
        filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.55)); }
      .table-base.roster tbody.content tr.roster-row:not(.roster-row-secondary-outer).roster-row--current-user.selected-row {
        background: linear-gradient(165deg, rgba(95, 175, 205, 0.13) 0%, rgba(61, 150, 177, 0.07) 50%, rgba(35, 75, 105, 0.11) 100%), #182f43;
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), inset 0 -1px 0 rgba(0, 0, 0, 0.18), inset 0 0 0 2px rgba(61, 150, 177, 0.5), inset 0 0 22px rgba(61, 150, 177, 0.55);
        filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.5)) drop-shadow(0 0 12px rgba(61, 150, 177, 0.18)); }
      .table-base.roster tbody.content tr.roster-row:not(.roster-row-secondary-outer).roster-row--current-user.selected-row:hover {
        background: linear-gradient(165deg, rgba(95, 175, 205, 0.14) 0%, rgba(61, 150, 177, 0.08) 50%, rgba(35, 75, 105, 0.12) 100%), rgba(37, 64, 85, 0.8);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.12), inset 0 -1px 0 rgba(0, 0, 0, 0.16), inset 0 0 0 2px rgba(100, 200, 230, 0.52), inset 0 0 22px rgba(61, 150, 177, 0.58);
        filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.55)) drop-shadow(0 0 14px rgba(61, 150, 177, 0.22)); }
    .table-base.roster tbody.content tr.roster-row-secondary-outer {
      height: auto;
      min-height: 0;
      cursor: pointer;
      background: transparent;
      box-shadow: none;
      filter: none;
      animation: roster-child-deploy 0.38s cubic-bezier(0.22, 1, 0.36, 1); }
      .table-base.roster tbody.content tr.roster-row-secondary-outer:hover {
        filter: none;
        background: transparent;
        box-shadow: none; }
      .table-base.roster tbody.content tr.roster-row-secondary-outer.selected-row {
        filter: none;
        background: transparent;
        box-shadow: none; }
    .table-base.roster .cell-roster-secondary-row {
      padding: 0;
      border: none !important;
      background: transparent !important;
      box-shadow: none !important;
      border-radius: 0 !important;
      overflow: visible;
      vertical-align: top;
      text-align: right; }
    .table-base.roster .roster-secondary-row-90 {
      display: inline-block;
      width: 96.4%;
      max-width: 96.4%;
      min-width: 0;
      margin-top: -10px;
      margin-bottom: -10px;
      text-align: left;
      vertical-align: top;
      border-radius: 8px;
      overflow: hidden; }
    .table-base.roster .roster-secondary-inner-table {
      width: 100%;
      border-collapse: separate;
      border-spacing: 0;
      table-layout: fixed; }
    .table-base.roster .roster-secondary-inner-table colgroup col.col-rosterRankIcon,
    .table-base.roster .roster-secondary-inner-table colgroup col.col-rosterRank {
      width: 0;
      min-width: 0; }
    .table-base.roster .roster-secondary-inner-table colgroup col.col-rosterMoniker {
      width: calc(485px);
      min-width: 0; }
    .table-base.roster .roster-secondary-inner-table tbody tr.roster-row-secondary-inner {
      cursor: pointer;
      transition: background 0.2s ease, box-shadow 0.25s ease, filter 0.2s ease;
      border-radius: 8px;
      overflow: hidden;
      filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.45));
      background: rgba(0, 0, 0, 0.14);
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.14), inset 0 -1px 0 rgba(0, 0, 0, 0.2); }
      .table-base.roster .roster-secondary-inner-table tbody tr.roster-row-secondary-inner:has(.roster-moniker__donor-gem .donor-gem-badge__wrap:hover), .table-base.roster .roster-secondary-inner-table tbody tr.roster-row-secondary-inner:has(.roster-moniker__donor-gem .donor-gem-badge__wrap:focus-within) {
        overflow: visible;
        position: relative;
        z-index: 6; }
      .table-base.roster .roster-secondary-inner-table tbody tr.roster-row-secondary-inner td {
        background: transparent;
        box-shadow: none; }
      .table-base.roster .roster-secondary-inner-table tbody tr.roster-row-secondary-inner:hover:not(.selected-row) {
        background: rgba(37, 64, 85, 0.8);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.16), inset 0 -1px 0 rgba(0, 0, 0, 0.18);
        filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.55)); }
      .table-base.roster .roster-secondary-inner-table tbody tr.roster-row-secondary-inner.selected-row {
        background: rgba(24, 47, 67, 0.8);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), inset 0 -1px 0 rgba(0, 0, 0, 0.18), inset 0 0 10px rgba(61, 150, 177, 0.4);
        filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.5)) drop-shadow(0 0 12px rgba(61, 150, 177, 0.15));
        transition: background 0.25s ease, box-shadow 0.25s ease; }
      .table-base.roster .roster-secondary-inner-table tbody tr.roster-row-secondary-inner.selected-row:hover {
        background: rgba(37, 64, 85, 0.8);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.12), inset 0 -1px 0 rgba(0, 0, 0, 0.16), inset 0 0 10px rgba(61, 150, 177, 0.4);
        filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.55)) drop-shadow(0 0 14px rgba(61, 150, 177, 0.22)); }
      .table-base.roster .roster-secondary-inner-table tbody tr.roster-row-secondary-inner.roster-row--current-user {
        background: linear-gradient(165deg, rgba(95, 175, 205, 0.14) 0%, rgba(61, 150, 177, 0.07) 50%, rgba(35, 75, 105, 0.11) 100%), rgba(0, 0, 0, 0.14);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.14), inset 0 -1px 0 rgba(0, 0, 0, 0.2), inset 0 0 0 2px rgba(61, 150, 177, 0.44), inset 0 0 28px rgba(61, 150, 177, 0.14); }
      .table-base.roster .roster-secondary-inner-table tbody tr.roster-row-secondary-inner.roster-row--current-user:hover:not(.selected-row) {
        background: linear-gradient(165deg, rgba(95, 175, 205, 0.16) 0%, rgba(61, 150, 177, 0.09) 50%, rgba(35, 75, 105, 0.13) 100%), rgba(37, 64, 85, 0.8);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.16), inset 0 -1px 0 rgba(0, 0, 0, 0.18), inset 0 0 0 2px rgba(100, 200, 230, 0.5), inset 0 0 32px rgba(61, 150, 177, 0.18);
        filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.55)); }
      .table-base.roster .roster-secondary-inner-table tbody tr.roster-row-secondary-inner.roster-row--current-user.selected-row {
        background: linear-gradient(165deg, rgba(95, 175, 205, 0.15) 0%, rgba(61, 150, 177, 0.08) 50%, rgba(35, 75, 105, 0.12) 100%), rgba(24, 47, 67, 0.8);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), inset 0 -1px 0 rgba(0, 0, 0, 0.18), inset 0 0 0 2px rgba(61, 150, 177, 0.5), inset 0 0 22px rgba(61, 150, 177, 0.55);
        filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.5)) drop-shadow(0 0 12px rgba(61, 150, 177, 0.15)); }
      .table-base.roster .roster-secondary-inner-table tbody tr.roster-row-secondary-inner.roster-row--current-user.selected-row:hover {
        background: linear-gradient(165deg, rgba(95, 175, 205, 0.16) 0%, rgba(61, 150, 177, 0.09) 50%, rgba(35, 75, 105, 0.13) 100%), rgba(37, 64, 85, 0.8);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.12), inset 0 -1px 0 rgba(0, 0, 0, 0.16), inset 0 0 0 2px rgba(100, 200, 230, 0.52), inset 0 0 22px rgba(61, 150, 177, 0.58);
        filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.55)) drop-shadow(0 0 14px rgba(61, 150, 177, 0.22)); }
    .table-base.roster tbody.content tr.roster-row.roster-row--moniker-interference {
      position: relative; }
      .table-base.roster tbody.content tr.roster-row.roster-row--moniker-interference::before {
        content: '';
        position: absolute;
        inset: 0;
        z-index: 1;
        pointer-events: none;
        border-radius: 8px;
        width: 100%;
        height: auto;
        max-width: none;
        margin: 0;
        padding: 0;
        opacity: 0.55;
        background-image: repeating-linear-gradient(180deg, rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 2px, rgba(140, 210, 255, 0.42) 2px, rgba(140, 210, 255, 0.42) 3px, rgba(0, 0, 0, 0) 3px, rgba(0, 0, 0, 0) 6px, rgba(255, 255, 255, 0.12) 6px, rgba(255, 255, 255, 0.12) 7px, rgba(0, 0, 0, 0) 7px, rgba(0, 0, 0, 0) 10px), repeating-linear-gradient(180deg, rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 4px, rgba(60, 100, 140, 0.35) 4px, rgba(60, 100, 140, 0.35) 5px, rgba(0, 0, 0, 0) 5px, rgba(0, 0, 0, 0) 11px);
        background-size: 100% 10px, 100% 11px;
        animation: roster-hidden-rf-hlines-vibrate 0.11s steps(2, end) infinite, roster-hidden-rf-hlines-drift 1.4s linear infinite; }
      .table-base.roster tbody.content tr.roster-row.roster-row--moniker-interference::after {
        content: '';
        position: absolute;
        inset: 0;
        z-index: 2;
        pointer-events: none;
        border-radius: 8px;
        width: 100%;
        height: auto;
        max-width: none;
        margin: 0;
        padding: 0;
        background: repeating-linear-gradient(180deg, transparent 0, transparent 1px, rgba(0, 0, 0, 0.22) 1px, rgba(0, 0, 0, 0.22) 2px);
        opacity: 0.45;
        animation: roster-hidden-rf-hlines-vibrate 0.14s steps(3, end) infinite reverse, roster-hidden-rf-scan 2.2s linear infinite; }
      @media (prefers-reduced-motion: reduce) {
        .table-base.roster tbody.content tr.roster-row.roster-row--moniker-interference::before, .table-base.roster tbody.content tr.roster-row.roster-row--moniker-interference::after {
          animation: none;
          opacity: 0.35; } }
    .table-base.roster tbody.content tr.roster-row.roster-row--moniker-interference-red::before {
      opacity: 0.6;
      background-image: repeating-linear-gradient(180deg, rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 2px, rgba(158, 34, 34, 0.48) 2px, rgba(158, 34, 34, 0.48) 3px, rgba(0, 0, 0, 0) 3px, rgba(0, 0, 0, 0) 6px, rgba(255, 200, 200, 0.14) 6px, rgba(255, 200, 200, 0.14) 7px, rgba(0, 0, 0, 0) 7px, rgba(0, 0, 0, 0) 10px), repeating-linear-gradient(180deg, rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 4px, rgba(124, 27, 27, 0.4) 4px, rgba(124, 27, 27, 0.4) 5px, rgba(0, 0, 0, 0) 5px, rgba(0, 0, 0, 0) 11px); }
    .table-base.roster tbody.content tr.roster-row.roster-row--moniker-interference-red::after {
      background: repeating-linear-gradient(180deg, transparent 0, transparent 1px, rgba(158, 34, 34, 0.28) 1px, rgba(158, 34, 34, 0.28) 2px);
      opacity: 0.5; }
    @media (prefers-reduced-motion: reduce) {
      .table-base.roster tbody.content tr.roster-row.roster-row--moniker-interference-red::before, .table-base.roster tbody.content tr.roster-row.roster-row--moniker-interference-red::after {
        animation: none;
        opacity: 0.4; } }
    .table-base.roster .roster-moniker--masked-label {
      display: inline-block;
      position: relative;
      min-width: 4.25rem;
      padding: 0.1em 0.15em;
      font-family: ui-monospace, 'Cascadia Mono', 'Segoe UI Mono', monospace;
      font-size: 0.88em;
      letter-spacing: 0.14em;
      text-transform: uppercase;
      color: rgba(195, 208, 220, 0.82);
      animation: roster-hidden-rf-flicker 0.18s steps(2, end) infinite; }
      @media (prefers-reduced-motion: reduce) {
        .table-base.roster .roster-moniker--masked-label {
          animation: none; } }
    .table-base.roster tbody.content tr.roster-row.roster-row--moniker-interference-red .roster-moniker--masked-label {
      color: rgba(233, 153, 153, 0.9);
      animation: roster-redacted-rf-flicker 0.18s steps(2, end) infinite; }
      @media (prefers-reduced-motion: reduce) {
        .table-base.roster tbody.content tr.roster-row.roster-row--moniker-interference-red .roster-moniker--masked-label {
          animation: none; } }
    .table-base.roster .roster-moniker--secondary-affiliation.roster-moniker--masked-label {
      display: inline-block;
      position: relative;
      padding-left: 0.65rem;
      border-left: 1px solid rgba(58, 120, 180, 0.45);
      margin-left: 0.12rem;
      color: rgba(195, 208, 220, 0.82);
      font-size: 0.88em; }
    .table-base.roster tbody.content tr.roster-row.roster-row--moniker-interference-red .roster-moniker--secondary-affiliation.roster-moniker--masked-label {
      border-left-color: rgba(158, 34, 34, 0.65);
      color: rgba(233, 153, 153, 0.9); }
    .table-base.roster .roster-moniker--secondary-affiliation:not(.roster-moniker--masked-label) {
      display: inline-block;
      padding-left: 0.65rem;
      position: relative;
      font-size: 0.92em;
      color: rgba(230, 234, 240, 0.9); }
      .table-base.roster .roster-moniker--secondary-affiliation:not(.roster-moniker--masked-label)::before {
        content: '';
        position: absolute;
        left: 0.15rem;
        top: 0.28em;
        bottom: 0.28em;
        width: 1px;
        border-radius: 0.5px;
        background: rgba(58, 120, 180, 0.45); }
    .table-base.roster tbody.content tr.roster-row.roster-row--masked {
      cursor: default; }
    .table-base.roster tbody.content tr.roster-row.roster-row--masked:hover {
      background: inherit;
      box-shadow: none;
      filter: none; }
    .table-base.roster .roster-masked-cell {
      display: inline-block;
      width: 100%;
      user-select: none; }
  .table-base.training-references colgroup col.col-accessorKey {
    width: auto; }
  .table-base.training-references colgroup col.col-version {
    width: 75px; }
  .table-base.training-references colgroup col.col-theme {
    width: 110px; }
  .table-base.training-references colgroup col.col-trainingLevel {
    width: 110px; }
  .table-base.training-references colgroup col.col-actions {
    width: 60px; }
  .table-base.equivalences-rules colgroup col.col-eventTemplate, .table-base.equivalences-items colgroup col.col-eventTemplate {
    width: auto; }
  .table-base.equivalences-rules colgroup col.col-templateId, .table-base.equivalences-items colgroup col.col-templateId {
    width: 100px; }
  .table-base.equivalences-rules colgroup col.col-priority, .table-base.equivalences-items colgroup col.col-priority {
    width: 35px; }
  .table-base.equivalences-rules colgroup col.col-validFrom, .table-base.equivalences-items colgroup col.col-validFrom {
    width: 80px; }
  .table-base.equivalences-rules colgroup col.col-validTo, .table-base.equivalences-items colgroup col.col-validTo {
    width: 80px; }
  .table-base.equivalences-rules colgroup col.col-actions, .table-base.equivalences-items colgroup col.col-actions {
    width: 50px; }
  .table-base.equivalences-rules td, .table-base.equivalences-items td {
    font-size: 13px; }
  .table-base.equivalences-requirements colgroup col.col-code {
    width: auto; }
  .table-base.equivalences-requirements colgroup col.col-label {
    width: auto; }
  .table-base.equivalences-requirements colgroup col.col-theme {
    width: 170px; }
  .table-base.equivalences-requirements colgroup col.col-trainingLevel {
    width: 150px; }
  .table-base.equivalences-requirements td {
    font-size: 13px; }
  .table-base.groups .table-body-wrapper, .table-base.roles .table-body-wrapper {
    max-height: 250px; }
  .table-base.carousel th.header-action {
    font-size: 0;
    line-height: 0;
    padding: 0; }
  .table-base.carousel .action-cell-container {
    display: flex;
    align-items: center; }
  .table-base.carousel .delete-media {
    display: none; }
  .table-base.carousel tr.selected-row .delete-media {
    display: inline-block;
    max-height: 20px;
    transform: translateX(-10px); }
  .table-base.carousel .delete-container {
    display: flex;
    align-items: center;
    margin-left: auto; }
  .table-base.carousel .cell-handle {
    width: 30px;
    padding: 0 6px;
    text-align: center;
    cursor: grab;
    user-select: none;
    align-content: center; }
    .table-base.carousel .cell-handle .drag-handle {
      display: inline-block;
      font-size: 1.2em;
      line-height: 1; }
  .table-base.carousel tr[data-sensor-context="active"] .cell-handle {
    cursor: grabbing; }
  .table-base.permissions table colgroup col.col-handle {
    width: 20px; }
  .table-base.permissions table colgroup col.col-displayName {
    width: 150px; }
  .table-base.permissions table colgroup col.col-resourceKey {
    width: 100px; }
  .table-base.permissions table colgroup col.col-description {
    width: 250px; }
  .table-base.permissions table .cell-handle {
    cursor: grab; }
  .table-base.discord-channels table colgroup col.col-name {
    width: 200px; }
  .table-base.discord-channels table colgroup col.col-channelType {
    width: 80px; }
  .table-base.discord-channels table colgroup col.col-channelId {
    width: 150px; }
  .table-base.templates th.header-eventName {
    vertical-align: middle; }
    .table-base.templates th.header-eventName .header-content {
      align-items: center; }
    .table-base.templates th.header-eventName .template-event-name-header {
      flex: 1 1 auto;
      min-width: 0;
      width: 100%;
      display: flex;
      align-items: center; }
    .table-base.templates th.header-eventName .template-event-name-search {
      width: 100%;
      font-size: 11px;
      padding: 2px 6px;
      min-height: 0;
      height: 22px;
      line-height: 1.2;
      box-sizing: border-box;
      border-radius: 6px; }
  .table-base.templates table colgroup col.col-eventName {
    width: 220px; }
  .table-base.templates table colgroup col.col-type {
    width: 70px; }
  .table-base.templates table colgroup col.col-subtype {
    width: 120px; }
  .table-base.templates table colgroup col.col-orgDivisions {
    width: 150px; }
  .table-base.templates table colgroup col.col-equivalentTraining {
    width: 110px; }
  .table-base.templates table colgroup col.col-ribbon {
    width: 130px; }
  .table-base.templates table colgroup col.col-templateStatus {
    width: 60px; }
  .table-base.types {
    width: 240px; }
    .table-base.types table colgroup col.col-type {
      width: 110px; }
    .table-base.types table colgroup col.col-found {
      width: 55px; }
    .table-base.types .cell-found .status-indicator {
      width: 16px;
      height: 16px; }
  .table-base.subtypes {
    width: 250px; }
    .table-base.subtypes table colgroup col.col-subType {
      width: 150px; }
    .table-base.subtypes table colgroup col.col-status {
      width: 100px; }
    .table-base.subtypes .cell-status .status-indicator {
      width: 16px;
      height: 16px; }
    .table-base.subtypes .table-body-wrapper {
      max-height: 170px; }
  .table-base.ranks table colgroup col.col-payGrade {
    width: 48px; }
  .table-base.ranks table colgroup col.col-rankName {
    width: auto; }
  .table-base.ranks table colgroup col.col-rankImageUrl {
    width: 60px; }
  .table-base.ranks table colgroup col.col-globalTokens {
    width: 70px; }
  .table-base.ranks table colgroup col.col-missionTokens {
    width: 70px; }
  .table-base.ranks table colgroup col.col-timeOnPreviousRank {
    width: 70px; }
  .table-base.ranks table colgroup col.col-certificationIds {
    width: 210px; }
  .table-base.ranks table colgroup col.col-courseIds,
  .table-base.ranks table colgroup col.col-grantAccess {
    width: 12rem; }
  .table-base.ranks table colgroup col.col-lockStatus {
    width: 55px; }
  .table-base.ranks table colgroup col.col-memberCount {
    width: 100px; }
  .table-base.ranks table colgroup col.col-statusRanks {
    width: 80px; }
  .table-base.ranks table colgroup col.col-secGroupId {
    width: 200px; }
  .table-base.ranks table .cell-secGroupId .rank-sec-group-dropdown {
    width: 100%;
    max-width: 190px; }
  .table-base.ranks table .cell-rankImageUrl img {
    max-width: 20px;
    display: block;
    margin: 0 auto; }
  .table-base.ranks.ranks-requirements-table tbody tr {
    height: auto;
    min-height: 45px; }
  .table-base.ranks.ranks-requirements-table tbody td {
    vertical-align: top;
    padding-top: 8px;
    padding-bottom: 8px;
    overflow: visible; }
  .table-base.ranks.ranks-requirements-table td.cell-certificationIds,
  .table-base.ranks.ranks-requirements-table td.cell-courseIds,
  .table-base.ranks.ranks-requirements-table td.cell-grantAccess {
    vertical-align: top;
    overflow: hidden;
    max-width: 0; }
  .table-base.ranks.ranks-requirements-table .certificationsSelect {
    min-width: 0;
    width: 100%;
    max-width: 100%; }
    .table-base.ranks.ranks-requirements-table .certificationsSelect .hierarchy-select-container {
      width: 100%;
      max-width: 100%;
      min-width: 0; }
  .table-base.ribbons table colgroup col.col-ribbonName {
    width: 140px; }
  .table-base.ribbons table colgroup col.col-ribbon {
    width: 100px; }
  .table-base.ribbons table colgroup col.col-description {
    width: 300px; }
  .table-base.ribbons table colgroup col.col-qtyRequirement {
    width: 55px; }
  .table-base.ribbons table colgroup col.col-status {
    width: 45px; }
  .table-base.organization-logs {
    width: min-content; }
    .table-base.organization-logs table {
      width: -webkit-fill-available; }
      .table-base.organization-logs table colgroup col.col-logTimestamp {
        width: 190px; }
      .table-base.organization-logs table colgroup col.col-handle {
        width: 170px; }
      .table-base.organization-logs table colgroup col.col-action {
        width: 270px;
        text-align: left; }
      .table-base.organization-logs table colgroup col.col-targetHandle {
        width: 170px; }
  .table-base.organization-applications {
    width: 400px; }
    .table-base.organization-applications thead th.applications-table-header-strip {
      height: auto;
      min-height: 34px;
      padding: 8px 12px;
      vertical-align: middle;
      text-transform: none;
      font-weight: normal; }
    .table-base.organization-applications .applications-table-toolbar {
      display: flex;
      align-items: center;
      gap: 8px;
      min-width: 0; }
    .table-base.organization-applications .applications-table-search {
      flex: 1;
      min-width: 0;
      padding: 0.25rem 0.4rem;
      font-size: 0.9rem;
      border: 1px solid #ddd;
      border-radius: 4px; }
    .table-base.organization-applications .table-body-wrapper {
      min-height: 200px; }
    .table-base.organization-applications table colgroup col.col-sentDate {
      width: 85px; }
    .table-base.organization-applications table colgroup col.col-handle {
      width: 115px; }
  .table-base col.col-subtitle {
    width: 200px; }
  .table-base col.col-mediaType {
    width: 100px; }
  .table-base col.col-size {
    width: 80px; }
  .table-base col.col-action {
    width: 80px; }
  .table-base.handles {
    width: 700px; }
    .table-base.handles table colgroup col.col-handle {
      width: 200px; }
    .table-base.handles table colgroup col.col-moniker {
      width: 150px; }
    .table-base.handles table colgroup col.col-rsi {
      width: 50px; }
    .table-base.handles table colgroup col.col-membership {
      width: 120px; }
    .table-base.handles table colgroup col.col-master {
      width: 80px; }
    .table-base.handles table colgroup col.col-certification {
      width: 50px; }
    .table-base.handles .table-body-wrapper td.cell-certified .status-cell img,
    .table-base.handles .table-body-wrapper td.cell-handleStatus .status-cell img {
      max-width: 50px;
      max-height: 30px;
      display: block;
      margin: 0 auto; }
    .table-base.handles .table-body-wrapper td.cell-membership .membership-label {
      display: flex;
      color: black;
      font-size: 0.75rem;
      width: fit-content;
      justify-self: center;
      padding: 3px 8px;
      border-radius: 4px; }
      .table-base.handles .table-body-wrapper td.cell-membership .membership-label.membership-main {
        background-color: #d0ebff;
        color: #004085; }
      .table-base.handles .table-body-wrapper td.cell-membership .membership-label.membership-exclusive {
        background-color: #26aa5d;
        box-shadow: 0 0 8px rgba(30, 160, 73, 0.8); }
        .table-base.handles .table-body-wrapper td.cell-membership .membership-label.membership-exclusive:hover {
          border: 1px solid #a7ffa7; }
      .table-base.handles .table-body-wrapper td.cell-membership .membership-label.membership-affiliate {
        color: black;
        background-color: #b38b0a;
        box-shadow: 0 0 8px rgba(197, 169, 46, 0.8); }
        .table-base.handles .table-body-wrapper td.cell-membership .membership-label.membership-affiliate:hover {
          border: 1px solid #dfc05b; }
      .table-base.handles .table-body-wrapper td.cell-membership .membership-label.membership-none {
        background-color: #eee;
        color: #666; }
    .table-base.handles th.header-master,
    .table-base.handles td.cell-master {
      text-align: center !important; }
    .table-base.handles td.cell-master .master-flag {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      color: #d4af37; }
  .table-base.allies table colgroup col.col-createdAt {
    width: 180px; }
  .table-base.allies table colgroup col.col-orgName {
    width: 200px; }
  .table-base.allies table colgroup col.col-orgLogo {
    width: 60px; }
  .table-base.allies table colgroup col.col-rsiLink {
    width: 50px; }
  .table-base.allies table colgroup col.col-discordLink {
    width: 50px; }
  .table-base.allies table colgroup col.col-guildedLink {
    width: 50px; }
  .table-base.allies table colgroup col.col-websiteLink {
    width: 50px; }
  .table-base.allies table colgroup col.col-statusAllied {
    width: 50px; }
  .table-base.allies table td.cell-orgLogo img,
  .table-base.allies table td.cell-statusAllied {
    max-height: 20px;
    max-width: 20px;
    display: block;
    margin: 0 auto; }
  .table-base.public-pages {
    width: 65%; }
    .table-base.public-pages table colgroup col.col-createdAt {
      width: 110px; }
    .table-base.public-pages table colgroup col.col-versionNumber {
      width: 75px; }
    .table-base.public-pages table colgroup col.col-status {
      width: 75px; }
    .table-base.public-pages table colgroup col.col-lastEditorName {
      width: 250px; }
  .table-base.mcq-versions-table col.col-updatedAt {
    width: 160px; }
  .table-base.mcq-versions-table col.col-version {
    width: 75px; }
  .table-base.mcq-versions-table col.col-statusCode {
    width: 100px; }
  .table-base.mcq-versions-table col.col-author {
    width: 222px; }
  .table-base.mcq-versions-table .table-body-wrapper {
    max-height: 170px;
    min-height: 150px; }
    .table-base.mcq-versions-table .table-body-wrapper .live-version-row {
      text-transform: uppercase;
      font-weight: bold;
      height: 30px;
      border: 2px solid transparent;
      background: linear-gradient(to top, #9b602a, #6e441c, #9b602a);
      cursor: pointer; }
      .table-base.mcq-versions-table .table-body-wrapper .live-version-row.selected {
        background: linear-gradient(to top, #2a5f2d, #2a5f2d, #3f7c42, #2a5f2d, #2a5f2d);
        color: #dfdfdf; }
      .table-base.mcq-versions-table .table-body-wrapper .live-version-row td {
        text-align: center; }
    .table-base.mcq-versions-table .table-body-wrapper .version-row.selected {
      background: #2a3847;
      color: #dfdfdf; }
  .table-base.checklist-versions-table col.col-updatedAt {
    width: 160px; }
  .table-base.checklist-versions-table col.col-version {
    width: 75px; }
  .table-base.checklist-versions-table col.col-statusCode {
    width: 100px; }
  .table-base.checklist-versions-table col.col-author {
    width: 222px; }
  .table-base.checklist-versions-table .table-body-wrapper {
    max-height: 170px;
    min-height: 150px; }
    .table-base.checklist-versions-table .table-body-wrapper .live-version-row {
      text-transform: uppercase;
      font-weight: bold;
      height: 30px;
      border: 2px solid transparent;
      background: linear-gradient(to top, #9b602a, #6e441c, #9b602a);
      cursor: pointer; }
      .table-base.checklist-versions-table .table-body-wrapper .live-version-row.selected {
        background: linear-gradient(to top, #2a5f2d, #2a5f2d, #3f7c42, #2a5f2d, #2a5f2d);
        color: #dfdfdf; }
      .table-base.checklist-versions-table .table-body-wrapper .live-version-row td {
        text-align: center; }
    .table-base.checklist-versions-table .table-body-wrapper .version-row.selected {
      background: #2a3847;
      color: #dfdfdf; }
  .table-base.themes-panel col.col-themeName {
    width: 250px; }
  .table-base.themes-panel col.col-found {
    width: 100px; }
  .table-base.themes-panel .table-body-wrapper {
    max-height: 135px; }
  .table-base.training-levels col.col-levelName {
    width: 250px; }
  .table-base.training-levels col.col-found {
    width: 100px; }
  .table-base.training-levels .table-body-wrapper {
    max-height: 135px; }

.role-checkbox {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #b8b8b8;
  appearance: none;
  background-color: transparent;
  cursor: pointer;
  position: relative; }
  .role-checkbox:checked {
    background-color: #75cf78;
    border-color: #3f7c42; }
    .role-checkbox:checked::after {
      content: "";
      position: absolute;
      top: 3px;
      left: 6px;
      width: 4px;
      height: 8px;
      border: solid #dfdfdf;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg); }

.table-body-wrapper {
  position: relative;
  overflow: visible; }

.academy-admin-page .ts-panel--ranks-requirements {
  overflow: visible; }

.handle-cell {
  position: relative;
  display: inline-flex;
  align-items: center; }
  .handle-cell .tooltip-wrapper {
    position: relative;
    display: inline-block; }
  .handle-cell .warning-icon {
    margin-left: 4px;
    cursor: pointer;
    display: inline-block;
    vertical-align: middle; }

.floating-warning-tooltip.global {
  position: fixed;
  z-index: 9999;
  background: #0c2637;
  color: #dfdfdf;
  border: 1px solid #dfdfdf;
  border-radius: 4px;
  padding: 6px 8px;
  font-size: 12px;
  white-space: nowrap;
  pointer-events: none;
  opacity: 1; }

.warning-icon {
  display: inline-block;
  margin-left: 4px;
  cursor: pointer;
  vertical-align: middle; }

.status-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%; }

.status-green {
  background-color: #4fad81;
  box-shadow: 0 0 8px rgba(79, 202, 134, 0.8); }

.status-red {
  background-color: #e74c3c; }

.status-blue {
  background-color: #3498db; }

.status-orange {
  background-color: #ffa600;
  box-shadow: 0 0 8px rgba(255, 202, 104, 0.8); }

.status-grey {
  background-color: #7f8c8d; }

.cell-missionToken {
  text-align-last: center; }

.cell-eventToken {
  text-align-last: center; }

.cell-totalToken {
  text-align-last: center; }

.affiliation {
  display: flex;
  font-size: 0.7rem;
  font-weight: 600;
  width: fit-content;
  justify-self: center;
  padding: 3px 8px;
  border-radius: 4px;
  border: 1px solid transparent;
  letter-spacing: 0.02em; }
  .affiliation.exclusive {
    color: #42260c;
    background: linear-gradient(105deg, transparent 38%, rgba(255, 255, 255, 0.4) 50%, transparent 62%), linear-gradient(155deg, #ebd8c7 0%, #f0d060 14%, #ce945d 32%, #b4a663 48%, #c37935 62%, #dab53f 78%, #e6ceb8 100%);
    border-color: #d5a374;
    box-shadow: 0 0 8px rgba(212, 175, 55, 0.75), inset 0 1px 0 rgba(255, 255, 255, 0.45), inset 0 -1px 1px rgba(110, 68, 28, 0.16);
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.25); }
    .affiliation.exclusive:hover {
      border-color: #e3c9b1;
      box-shadow: 0 0 12px rgba(255, 215, 80, 0.9), inset 0 1px 0 rgba(255, 255, 255, 0.5), inset 0 -1px 1px rgba(110, 68, 28, 0.2); }
  .affiliation.affiliated {
    color: #151c24;
    background: linear-gradient(105deg, transparent 38%, rgba(255, 255, 255, 0.5) 50%, transparent 62%), linear-gradient(155deg, #ffffff 0%, #dfdfdf 16%, #cccccc 34%, #e9e9e9 50%, #949a9f 68%, #c7c7c7 84%, #dfdfdf 100%);
    border-color: #c7c7c7;
    box-shadow: 0 0 8px rgba(184, 184, 184, 0.7), inset 0 1px 0 rgba(255, 255, 255, 0.55), inset 0 -1px 1px rgba(56, 72, 88, 0.12);
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.4); }
    .affiliation.affiliated:hover {
      border-color: #ffffff;
      box-shadow: 0 0 12px rgba(223, 223, 223, 0.95), inset 0 1px 0 rgba(255, 255, 255, 0.65), inset 0 -1px 1px rgba(56, 72, 88, 0.15); }
  .affiliation.outsider {
    color: #747b81;
    background: linear-gradient(155deg, #394c61 0%, #384858 50%, #222e3a 100%);
    border-color: #384858;
    box-shadow: 0 0 6px rgba(42, 56, 71, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.08);
    text-shadow: none;
    font-style: italic; }
    .affiliation.outsider:hover {
      border-color: #485c71;
      box-shadow: 0 0 8px rgba(56, 72, 88, 0.55), inset 0 1px 0 rgba(255, 255, 255, 0.12); }

.certification-icon {
  display: inline-block;
  width: 30px;
  height: 30px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center; }

.certified {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  opacity: 1; }
  .certified:hover {
    filter: drop-shadow(0 0 10px rgba(0, 255, 170, 0.9)) drop-shadow(0 0 20px rgba(0, 255, 170, 0.6));
    animation: certified-glow-hover 2.5s ease-in-out infinite; }
  .certified.formerly-certified {
    opacity: 0.4;
    filter: grayscale(0.75); }
    .certified.formerly-certified:hover {
      filter: grayscale(0.35) drop-shadow(0 0 6px rgba(0, 255, 170, 0.35));
      animation: none; }

.uncertified {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  opacity: 0.2; }

/* Glow léger par défaut */
@keyframes certified-glow {
  0%, 100% {
    filter: drop-shadow(0 0 4px rgba(0, 255, 170, 0.25)) drop-shadow(0 0 10px rgba(0, 255, 170, 0.15)); }
  50% {
    filter: drop-shadow(0 0 8px rgba(0, 255, 170, 0.4)) drop-shadow(0 0 14px rgba(0, 255, 170, 0.3)); } }

/* Glow plus intense au survol */
@keyframes certified-glow-hover {
  0%, 100% {
    filter: drop-shadow(0 0 8px rgba(0, 255, 170, 0.6)) drop-shadow(0 0 18px rgba(0, 255, 170, 0.4)); }
  50% {
    filter: drop-shadow(0 0 14px #00ffaa) drop-shadow(0 0 26px rgba(0, 255, 170, 0.9)); } }

.table-base.orgs-whitelist th.header-logo,
.table-base.orgs-whitelist td.cell-logo,
.table-base.orgs-whitelist th.header-whitelisted,
.table-base.orgs-whitelist td.cell-whitelisted,
.table-base.orgs-whitelist th.header-blacklisted,
.table-base.orgs-whitelist td.cell-blacklisted {
  text-align: center;
  vertical-align: middle; }

.table-base.orgs-whitelist th.header-commentEdit,
.table-base.orgs-whitelist td.cell-commentEdit {
  text-align: left;
  vertical-align: top; }

.table-base.orgs-whitelist th.header-commentSave,
.table-base.orgs-whitelist td.cell-commentSave {
  text-align: center;
  vertical-align: middle; }

.table-base.orgs-whitelist table col.col-logo {
  max-width: 90px; }

.table-base.orgs-whitelist table col.col-orgSid {
  max-width: 100px; }

.table-base.orgs-whitelist table col.col-whitelisted,
.table-base.orgs-whitelist table col.col-blacklisted {
  max-width: 75px; }

.table-base.orgs-whitelist .orgs-comment-edit-textarea {
  width: 100%;
  max-width: none;
  min-height: 4.5rem;
  box-sizing: border-box;
  resize: vertical;
  font-size: 0.9rem; }

.table-base.orgs-whitelist .orgs-comment-save-btn {
  white-space: nowrap; }

.table-base.orgs-whitelist td.cell-whitelisted .toggle.orgs-whitelist-toggle,
.table-base.orgs-whitelist td.cell-blacklisted .toggle.orgs-whitelist-toggle {
  min-width: 0; }

.table-base.orgs-whitelist td.cell-whitelisted .orgs-whitelist-toggle-switch.toggle-switch,
.table-base.orgs-whitelist td.cell-blacklisted .orgs-whitelist-toggle-switch.toggle-switch {
  width: 26px; }

.table-base.orgs-whitelist td.cell-whitelisted .orgs-whitelist-toggle-switch.toggle-switch .toggle-switch__thumb,
.table-base.orgs-whitelist td.cell-blacklisted .orgs-whitelist-toggle-switch.toggle-switch .toggle-switch__thumb {
  height: 12px;
  width: 12px; }

.table-base.orgs-whitelist td.cell-whitelisted .toggle.orgs-whitelist-toggle input:checked ~ .orgs-whitelist-toggle-switch .toggle-switch__thumb,
.table-base.orgs-whitelist td.cell-blacklisted .toggle.orgs-whitelist-toggle input:checked ~ .orgs-whitelist-toggle-switch .toggle-switch__thumb {
  transform: translateX(14px); }

.table-base.orgs-whitelist .orgs-whitelist-no-logo {
  color: #2a3847; }

.table-base.orgs-whitelist .orgs-whitelist-logo {
  display: block;
  object-fit: contain;
  margin-left: auto;
  margin-right: auto;
  width: auto;
  height: auto; }

.table-base.orgs-whitelist .orgs-whitelist-logo--small {
  max-width: 40px;
  max-height: 40px; }

.table-base.orgs-whitelist .orgs-whitelist-logo--medium {
  max-width: 64px;
  max-height: 64px; }

.table-base.orgs-whitelist .orgs-whitelist-logo--large {
  max-width: 88px;
  max-height: 88px; }

.table-base.orgs-whitelist .toggle.orgs-whitelist-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  min-width: 36px;
  height: auto;
  min-height: 22px;
  margin: 0 auto;
  position: relative;
  bottom: 0;
  text-transform: none;
  font-weight: normal;
  cursor: pointer; }

.table-base.orgs-whitelist .orgs-whitelist-toggle-switch.toggle-switch {
  position: relative;
  top: auto;
  left: auto;
  right: auto;
  bottom: auto;
  width: 32px;
  height: 8px;
  margin: 0;
  cursor: pointer; }

.table-base.orgs-whitelist .orgs-whitelist-toggle-switch.toggle-switch .toggle-switch__thumb {
  height: 13px;
  width: 13px;
  top: -2px; }

.table-base.orgs-whitelist .toggle.orgs-whitelist-toggle input:checked ~ .orgs-whitelist-toggle-switch .toggle-switch__thumb {
  transform: translateX(18px); }

.table-base.orgs-whitelist .toggle.orgs-whitelist-toggle input:disabled + .orgs-whitelist-toggle-switch {
  opacity: 0.5;
  cursor: wait; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.desktop-view {
  display: flex;
  flex-direction: row;
  height: 250px;
  margin-bottom: 30px;
  border-bottom: 3px solid #2a3847; }
  .desktop-view .division-description-logo {
    display: flex;
    flex-direction: column;
    position: fixed;
    float: left;
    width: 280px;
    height: 250px; }
    .desktop-view .division-description-logo .division-title {
      position: relative;
      width: 100%;
      text-transform: uppercase;
      margin: 15px auto 0px auto;
      text-align: center; }
    .desktop-view .division-description-logo .division-logo {
      position: relative;
      width: 120px;
      height: auto;
      margin: 0px auto 0 auto;
      top: 12%; }
    .desktop-view .division-description-logo::after {
      content: '';
      position: absolute;
      top: 55px;
      right: 0;
      height: calc(100% - 90px);
      width: 3px;
      background-color: #2a3847; }
  .desktop-view .division-description-content .division-description {
    position: relative;
    overflow-y: auto;
    max-height: 150px;
    padding: 5px 10px 5px 0px;
    margin-top: 50px;
    text-align: justify;
    padding-left: 300px; }
    .desktop-view .division-description-content .division-description::-webkit-scrollbar {
      width: 6px; }
    .desktop-view .division-description-content .division-description::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .desktop-view .division-description-content .division-description::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .desktop-view .division-description-content .division-description::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }

.tree-node {
  display: flex;
  flex-direction: row;
  font-size: 0.75rem;
  border-radius: 8px;
  margin: 5px;
  padding: 8px;
  box-shadow: rgba(52, 55, 58, 0.4) 0px -5px 8px 0px inset;
  cursor: pointer; }
  .tree-node.tree-node--executive-root {
    display: block;
    width: calc(100% - 10px);
    margin: 5px;
    padding: 0;
    border: none;
    box-shadow: none; }
    .tree-node.tree-node--executive-root.selected {
      outline: none; }
    .tree-node.tree-node--executive-root .executive-root-banner {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      box-sizing: border-box; }
    .tree-node.tree-node--executive-root .executive-root-stars {
      display: flex;
      justify-content: center;
      align-items: flex-end;
      gap: 0.5rem;
      margin-bottom: 0.25rem; }
    .tree-node.tree-node--executive-root .executive-root-star {
      color: #c8aa6e;
      font-size: 0.5rem;
      line-height: 1; }
    .tree-node.tree-node--executive-root .executive-root-star--mid {
      transform: translateY(-2px);
      font-size: 0.62rem; }
    .tree-node.tree-node--executive-root .executive-root-title-row {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 1rem;
      width: 100%;
      max-width: 28rem;
      margin: 0 auto; }
    .tree-node.tree-node--executive-root .executive-root-line {
      flex: 1;
      height: 1px;
      background-color: #c8aa6e;
      min-width: 2rem;
      max-width: 10rem;
      opacity: 0.95; }
    .tree-node.tree-node--executive-root .executive-root-title {
      margin: 0;
      padding: 0 0.25rem;
      text-align: center;
      text-transform: uppercase;
      font-family: inherit;
      font-size: clamp(1rem, 2vw, 1.35rem);
      font-weight: 700;
      letter-spacing: 0.12em;
      color: #ffffff;
      line-height: 1.2; }
    .tree-node.tree-node--executive-root .executive-root-sub {
      margin: 0.65rem auto 0.15rem;
      max-width: 32rem;
      padding: 0 0.5rem;
      text-align: center;
      font-size: clamp(0.72rem, 1.5vw, 0.88rem);
      font-style: italic;
      color: #f0e6d2; }
    .tree-node.tree-node--executive-root .executive-root-frame-line {
      display: block;
      width: 100%;
      height: 40px;
      margin: 0; }
  .tree-node.with-image {
    border-width: 2px;
    border-style: solid; }
    .tree-node.with-image .division-image {
      width: 32px;
      height: auto;
      max-height: 32px;
      object-fit: contain; }
    .tree-node.with-image .image-container {
      width: 32px;
      height: 32px; }
      .tree-node.with-image .image-container .division-image {
        width: 32px;
        height: auto;
        object-fit: contain; }
    .tree-node.with-image .division-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100%;
      padding: 0px 5px 0px 5px; }
      .tree-node.with-image .division-content .division-name {
        font-weight: bolder;
        text-transform: uppercase; }
  .tree-node.without-image {
    border-width: 2px;
    border-style: solid; }
    .tree-node.without-image .division-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      padding: 0px 5px 0px 5px; }
      .tree-node.without-image .division-content .division-name {
        font-weight: bolder;
        text-transform: uppercase; }
  .tree-node:not(.tree-node--executive-root):hover {
    border: 2px solid #dfdfdf !important;
    box-shadow: rgba(4, 175, 255, 0.829) 0px 10px 20px -20px; }

/* Niveau « Divisions » : enfants directs de l’exécutif (parent sans parent). */
.tree-node.tree-node--org-division {
  min-height: 56px;
  padding: 10px 12px;
  font-size: 0.8rem; }
  .tree-node.tree-node--org-division.with-image .division-image {
    width: 48px;
    max-height: 48px; }
  .tree-node.tree-node--org-division.with-image .image-container {
    width: 48px;
    height: 48px; }
    .tree-node.tree-node--org-division.with-image .image-container .division-image {
      width: 48px;
      max-height: 48px; }

/* Niveau « Branches » : sous une division — logos 50×50 px. */
.tree-node.tree-node--org-branch.with-image .division-image {
  width: 50px;
  height: 50px;
  max-height: 50px; }

.tree-node.tree-node--org-branch.with-image .image-container {
  width: 50px;
  height: 50px; }
  .tree-node.tree-node--org-branch.with-image .image-container .division-image {
    width: 50px;
    height: 50px;
    max-height: 50px; }

.tree-children {
  display: flex;
  flex-direction: row;
  align-items: flex-start; }
  .tree-children .tree-column .division-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start; }
    .tree-children .tree-column .division-content .division-name {
      text-align: left; }

.tree-branch {
  display: block;
  width: -webkit-fill-available; }

.tree-column {
  display: flex;
  flex-direction: column;
  width: 100%; }

.redacted {
  position: relative;
  overflow: hidden;
  /* Pour éviter que le brouillage déborde des nœuds */ }

.redacted::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(39, 20, 20, 0.6); }

.redacted::after {
  content: 'REDACTED';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.8em;
  /* Taille du texte "REDACTED" */
  white-space: nowrap;
  opacity: 0;
  /* Masqué par défaut */
  animation: none; }

.redacted:hover::after {
  opacity: 1;
  /* Visible au survol */
  color: red;
  animation: textNoise 0.02s infinite;
  /* Effet statique sur le texte */ }

@keyframes textNoise {
  0%, 100% {
    clip-path: inset(0 0 50% 0); }
  10% {
    clip-path: inset(10% 0 40% 0); }
  20% {
    clip-path: inset(20% 0 30% 0); }
  30% {
    clip-path: inset(30% 0 20% 0); }
  40% {
    clip-path: inset(40% 0 10% 0); }
  50% {
    clip-path: inset(50% 0 0 0); }
  60% {
    clip-path: inset(60% 0 50% 0); }
  70% {
    clip-path: inset(70% 0 40% 0); }
  80% {
    clip-path: inset(80% 0 30% 0); }
  90% {
    clip-path: inset(90% 0 20% 0); } }

.division-diagram-hint {
  padding: 10px;
  font-style: italic; }

.charts-types {
  width: 100%;
  height: 90%; }

.charts-renderChart {
  position: relative;
  width: 100%;
  height: 100%; }

@media (max-width: 1350px) {
  .mobile-view {
    display: flex;
    flex-direction: column;
    height: 250px;
    margin-bottom: 15px;
    padding-bottom: 40px;
    border-bottom: 3px solid #2a3847; }
    .mobile-view .division-description-logo {
      display: flex;
      flex-direction: row;
      position: relative;
      width: 100%;
      height: auto;
      margin-bottom: 15px; }
      .mobile-view .division-description-logo .division-logo {
        position: relative;
        float: left;
        width: 22px;
        height: 22px;
        margin: 0px auto 0 auto; }
      .mobile-view .division-description-logo .division-title {
        position: relative;
        width: 100%;
        text-transform: uppercase;
        margin: 0px 10px 0px 10px;
        text-align: left; }
    .mobile-view .division-description-content .division-description {
      overflow-y: auto;
      max-height: 200px;
      padding: 5px 10px 5px 5px;
      margin-bottom: 15px;
      margin-top: 10px;
      text-align: justify; }
      .mobile-view .division-description-content .division-description::-webkit-scrollbar {
        width: 6px; }
      .mobile-view .division-description-content .division-description::-webkit-scrollbar-track {
        background: #2e3842;
        border-radius: 4px;
        padding-right: 1px; }
      .mobile-view .division-description-content .division-description::-webkit-scrollbar-thumb {
        background-color: #491212;
        border-radius: 4px; }
        .mobile-view .division-description-content .division-description::-webkit-scrollbar-thumb:hover {
          background-color: #200808; }
  .public-container {
    width: 90%; }
  .tree-branch {
    width: 98%;
    transition: max-width 0.3s ease-out; }
    .tree-branch.expanded {
      max-width: 100%; }
      .tree-branch.expanded .tree-node.with-image {
        width: -webkit-fill-available;
        visibility: visible;
        font-size: calc(0.6rem + 0.4vw); }
        .tree-branch.expanded .tree-node.with-image .division-image {
          width: 18px !important;
          height: 18px !important;
          margin-bottom: 10px; }
        .tree-branch.expanded .tree-node.with-image.tree-node--org-division .division-image,
        .tree-branch.expanded .tree-node.with-image.tree-node--org-division .image-container .division-image {
          width: 30px !important;
          height: 30px !important;
          max-height: 30px !important; }
        .tree-branch.expanded .tree-node.with-image.tree-node--org-division .image-container {
          width: 30px !important;
          height: 30px !important; }
        .tree-branch.expanded .tree-node.with-image.tree-node--org-division {
          min-height: 48px;
          padding: 8px 10px; }
        .tree-branch.expanded .tree-node.with-image.tree-node--org-branch .division-image,
        .tree-branch.expanded .tree-node.with-image.tree-node--org-branch .image-container .division-image {
          width: 50px !important;
          height: 50px !important;
          max-height: 50px !important; }
        .tree-branch.expanded .tree-node.with-image.tree-node--org-branch .image-container {
          width: 50px !important;
          height: 50px !important; }
        .tree-branch.expanded .tree-node.with-image .division-content {
          font-size: calc(0.6rem + 0.4vw);
          overflow: hidden;
          width: fit-content;
          transition: opacity 0.3s ease-in;
          opacity: 1; }
          .tree-branch.expanded .tree-node.with-image .division-content .division-image {
            overflow: hidden; }
      .tree-branch.expanded .tree-node.without-image {
        visibility: visible;
        font-size: calc(0.7rem + 0.4vw); }
        .tree-branch.expanded .tree-node.without-image .division-content {
          font-size: calc(0.6rem + 0.4vw);
          overflow: hidden;
          transition: opacity 0.3s ease-in;
          opacity: 1; }
          .tree-branch.expanded .tree-node.without-image .division-content .division-image {
            overflow: hidden; }
    .tree-branch.reduced {
      max-width: 8%;
      visibility: visible;
      transition: max-width 0.3s ease-out; }
      .tree-branch.reduced .tree-node.without-image {
        visibility: visible;
        font-size: calc(0.7rem + 0.4vw);
        height: 15px; }
        .tree-branch.reduced .tree-node.without-image .division-content {
          visibility: hidden;
          overflow: hidden;
          font-size: calc(0.6rem + 0.4vw);
          transition: opacity 0s ease-out;
          opacity: 0; }
          .tree-branch.reduced .tree-node.without-image .division-content .division-image {
            visibility: hidden;
            overflow: hidden;
            padding: 0px; }
      .tree-branch.reduced .tree-node.with-image {
        max-height: 24px;
        padding: 5px 0px 5px 0px;
        font-size: calc(0.7rem + 0.4vw);
        visibility: visible;
        position: relative; }
        .tree-branch.reduced .tree-node.with-image .image-container {
          width: 0px !important;
          height: 0px !important;
          overflow: hidden;
          padding: 0px; }
          .tree-branch.reduced .tree-node.with-image .image-container .division-image {
            visibility: hidden;
            width: 0px !important;
            height: 0px !important;
            margin-bottom: 5px;
            overflow: hidden;
            padding: 0px; }
        .tree-branch.reduced .tree-node.with-image .division-content {
          visibility: hidden;
          overflow: hidden;
          font-size: calc(0.7rem + 0.4vw);
          padding: 0px;
          transition: opacity 0s ease-out;
          opacity: 0; }
          .tree-branch.reduced .tree-node.with-image .division-content .division-image {
            visibility: hidden;
            overflow: hidden;
            padding: 0px; }
        .tree-branch.reduced .tree-node.with-image::after {
          content: '⮟';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          animation: bounce 0.5s infinite alternate; }
  @keyframes bounce {
    0% {
      transform: translate(-50%, -50%); }
    100% {
      transform: translate(-50%, calc(-50% - 6px)); } }
      .tree-branch.reduced .tree-children {
        visibility: hidden;
        overflow: hidden; }
        .tree-branch.reduced .tree-children .tree-node.with-image {
          visibility: hidden;
          overflow: hidden;
          padding: 0px; }
        .tree-branch.reduced .tree-children .tree-node.without-image {
          visibility: hidden;
          overflow: hidden; }
  .tree-node.with-image .image-container {
    width: 18px;
    height: 18px; }
  .tree-node.tree-node--org-division.with-image .image-container {
    width: 30px;
    height: 30px; }
  .tree-node.tree-node--org-branch.with-image .image-container {
    width: 50px;
    height: 50px; }
  .division-description-container {
    height: calc(50vh - 200px); } }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
/* Shared 3-position access toggle (create event menu + event card controls) */
.create-event-access-toggle {
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #384858; }

.create-event-access-toggle__mode {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
  padding: 6px 10px;
  margin: 0;
  border: none;
  background: #2a3847;
  color: #dfdfdf;
  cursor: pointer;
  text-align: center;
  min-width: 0;
  transition: background 0.15s ease, box-shadow 0.15s ease, color 0.15s ease; }
  .create-event-access-toggle__mode:not(:last-child) {
    border-right: 1px solid #384858; }
  .create-event-access-toggle__mode:not(:disabled):hover {
    background: #384858; }
  .create-event-access-toggle__mode:disabled, .create-event-access-toggle__mode.create-event-access-toggle__mode--locked {
    opacity: 0.4;
    cursor: not-allowed; }
  .create-event-access-toggle__mode:not(.create-event-access-toggle__mode--active) .create-event-access-toggle__label {
    opacity: 0.8; }

.create-event-access-toggle__mode--active {
  background: #1c2d38;
  box-shadow: inset 0 0 0 1px #9e2222; }
  .create-event-access-toggle__mode--active .create-event-access-toggle__label {
    color: #dfdfdf;
    opacity: 1; }

.create-event-access-toggle__mode--first.create-event-access-toggle__mode--active {
  border-radius: 8px 0 0 8px; }

.create-event-access-toggle__mode--middle.create-event-access-toggle__mode--active {
  border-radius: 0; }

.create-event-access-toggle__mode--last.create-event-access-toggle__mode--active {
  border-radius: 0 8px 8px 0; }

.create-event-access-toggle__label {
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  white-space: nowrap; }

.modal {
  position: fixed;
  z-index: 1050;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.6);
  overflow-y: auto;
  /* Chrome, Edge, Safari */
  /* Firefox */
  scrollbar-width: none;
  /* IE / old Edge */
  -ms-overflow-style: none; }
  .modal::-webkit-scrollbar {
    width: 0;
    height: 0; }
  .modal .modal-content {
    position: relative;
    background-color: #163447;
    margin: 4vh 0%;
    padding: 0px;
    border: 1px solid #491212;
    width: max-content;
    justify-self: center;
    min-height: inherit;
    height: max-content; }
    .modal .modal-content.calendar-template-confirm {
      height: 140px; }
    .modal .modal-content.create-event {
      padding: 0px; }
    .modal .modal-content.create-event-template {
      padding: 0px; }
    .modal .modal-content.lexical-save-modal {
      padding: 0px; }
    .modal .modal-content.courses-modules-details {
      width: 900px;
      height: 75vh; }
    .modal .modal-content .modal-body .account-deletion {
      height: 50px; }
      .modal .modal-content .modal-body .account-deletion .header.account-deletion {
        color: #dfdfdf;
        padding: 10px;
        margin-top: 0;
        background-color: #491212;
        border-bottom: 3px solid #dfdfdf;
        margin-bottom: 5px;
        border-radius: 6px 6px 0px 0px; }
      .modal .modal-content .modal-body .account-deletion .content.account-deletion {
        padding: 10px; }
      .modal .modal-content .modal-body .account-deletion .footer.account-deletion {
        padding: 10px;
        margin-top: 0;
        margin-bottom: 10px;
        border-radius: 0px 0px 6px 6px; }
  .modal .close {
    color: #dfdfdf;
    float: right;
    font-size: 1.2rem;
    font-weight: bold;
    cursor: pointer; }
    .modal .close:hover, .modal .close:focus {
      color: #0c2637;
      text-decoration: none; }

.recurrence-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 1050;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.6); }
  .recurrence-modal .modal-header {
    color: #dfdfdf;
    padding: 10px;
    margin-top: 0;
    border-bottom: 3px solid #dfdfdf;
    margin-bottom: 5px;
    border-radius: 6px 6px 0px 0px; }
    .recurrence-modal .modal-header .recurrence-h3 {
      padding: 0;
      margin: 0; }
  .recurrence-modal .input-first {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 10px auto 10px auto; }
  .recurrence-modal .modal-dialog {
    max-width: 280px;
    margin: auto; }
  .recurrence-modal .modal-content {
    display: flex;
    flex-direction: column;
    gap: 10px;
    background-color: #2a3847;
    max-width: 350px;
    border: 1px solid #491212;
    border-radius: 10px; }
  .recurrence-modal .recurrence-content {
    background-color: #2a3847;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 3px; }
    .recurrence-modal .recurrence-content .input {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      margin-bottom: 5px; }
      .recurrence-modal .recurrence-content .input label {
        text-align: left;
        flex-grow: 1; }
      .recurrence-modal .recurrence-content .input .input, .recurrence-modal .recurrence-content .input .react-select__control {
        max-width: 175px !important;
        min-width: 175px !important;
        min-height: 16px !important;
        height: 20px !important; }
      .recurrence-modal .recurrence-content .input .field-input {
        max-width: 50px;
        min-width: 50px;
        padding: 2px 8px 2px 8px;
        border-radius: 6px; }
        .recurrence-modal .recurrence-content .input .field-input.date {
          max-width: 70px;
          min-width: 70px;
          padding: 2px 8px 2px 8px;
          border-radius: 6px; }
    .recurrence-modal .recurrence-content .intelligible-text {
      margin-left: 0px;
      margin-right: auto; }
  .recurrence-modal .modal-footer {
    display: flex;
    gap: 10px;
    padding: 15px; }
    .recurrence-modal .modal-footer .btn-style1 {
      margin-left: 0px; }

.calendar-template-modal .modal-dialog {
  margin: auto;
  width: 1080px; }

.calendar-template-modal .calendar-template-input.form-control, .calendar-template-modal .calendar-template-dropdown.form-control {
  width: 232px;
  padding: 2px; }

.calendar-template-modal .modal-footer {
  display: flex;
  justify-content: flex-start; }

.calendar-template-modal .modal-content {
  background-color: #2a3847;
  width: 1200px;
  height: 85%;
  margin-top: 100px;
  border: 1px solid #491212; }

.calendar-template-modal .modal-header {
  color: #dfdfdf; }
  .calendar-template-modal .modal-header .modal-title {
    font-size: 1.5rem;
    color: #dfdfdf; }
  .calendar-template-modal .modal-header .btn-close {
    color: #dfdfdf; }
    .calendar-template-modal .modal-header .btn-close:hover, .calendar-template-modal .modal-header .btn-close:focus {
      color: #0c2637; }

.calendar-template-modal .modal-body {
  padding: 20px; }
  .calendar-template-modal .modal-body .form-control {
    position: relative;
    border-width: 0px;
    width: -webkit-fill-available;
    height: 16px;
    padding: 10px 5px;
    border-radius: 4px;
    color: #0c2637; }

.account-deletion .modal-content {
  background-color: #1c2d38; }
  .account-deletion .modal-content .modal-header {
    font-weight: bolder;
    color: #dfdfdf; }
  .account-deletion .modal-content .modal-body {
    color: #b8b8b8; }
    .account-deletion .modal-content .modal-body .link {
      font-weight: bold;
      color: #d12323;
      text-decoration: none; }
  .account-deletion .modal-content .modal-footer {
    text-align: center;
    display: block; }
    .account-deletion .modal-content .modal-footer button {
      display: inline-block;
      margin: 0 5px; }

.modal-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #0c2637;
  color: #dfdfdf;
  border-radius: 10px;
  width: 550px;
  height: 325px;
  position: relative;
  outline: none;
  z-index: 100;
  border-radius: 10px; }
  .modal-content .mfa-h3 {
    text-transform: uppercase;
    text-align: center;
    margin: 10px;
    color: #dfdfdf;
    font-size: 1.3rem; }
  .modal-content .mfa-radio-buttons {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 15px;
    gap: 15px;
    height: 20px; }
  .modal-content .modal-content-type {
    display: flex;
    flex-direction: row; }
    .modal-content .modal-content-type .modal-left {
      display: flex;
      flex-direction: column;
      background-color: #b8b8b8;
      align-items: center;
      width: 250px;
      min-height: 200px;
      padding: 15px 25px;
      border-radius: 0px 0px 0px 10px; }
      .modal-content .modal-content-type .modal-left .mfa-qr-code {
        padding: 5px;
        margin: 0px; }
    .modal-content .modal-content-type .modal-right {
      flex: 1;
      background-color: #2a3847;
      width: 250px;
      min-height: 200px;
      border-radius: 0px 0px 10px 0px; }
      .modal-content .modal-content-type .modal-right .mfa-bullet-points {
        color: #dfdfdf;
        padding: 10px 10px 10px 0px; }
        .modal-content .modal-content-type .modal-right .mfa-bullet-points li {
          margin-bottom: 20px; }
      .modal-content .modal-content-type .modal-right .mobile {
        display: none; }

.modal-content-codes {
  flex-direction: column;
  justify-content: space-between;
  background: #dfdfdf;
  border-radius: 10px;
  max-width: 100%;
  width: 250px;
  height: 250px;
  padding: 30px;
  position: relative;
  outline: none; }

.modal-overlay {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(19, 29, 37, 0.7);
  align-items: center;
  justify-content: center;
  z-index: 200; }

.modal-handle-left {
  display: flex;
  background-color: #2a3847;
  flex-direction: column;
  align-items: center;
  width: 50%;
  padding-right: 20px;
  border-radius: 10px 0px 0px 10px; }

.modal-handle-right {
  flex: 1;
  background-color: #1c2d38;
  width: 50%;
  padding-left: 20px;
  border-radius: 0px 10px 10px 0px; }
  .modal-handle-right .handle-bullet-points {
    color: #dfdfdf;
    padding: 15px; }
  .modal-handle-right .mobile {
    display: none; }

.modal.create-event-template {
  display: contents;
  flex-direction: column;
  position: relative;
  background-color: #2a3847;
  padding: 0;
  border-radius: 8px;
  overflow-y: auto; }
  .modal.create-event-template::-webkit-scrollbar {
    width: 6px; }
  .modal.create-event-template::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .modal.create-event-template::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .modal.create-event-template::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }
  .modal.create-event-template .header.create-event-template {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 3px solid #b8b8b8;
    background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center; }
    .modal.create-event-template .header.create-event-template .calendar-h3 {
      text-align: left;
      text-transform: uppercase;
      margin-left: 20px;
      margin-top: 5px;
      margin-bottom: 5px;
      color: #dfdfdf; }
    .modal.create-event-template .header.create-event-template .icon {
      display: flex;
      height: 18px;
      overflow: hidden;
      margin-left: auto;
      margin-right: 10px; }
      .modal.create-event-template .header.create-event-template .icon .close-event-button {
        position: relative;
        height: 40px;
        object-fit: contain;
        overflow: hidden;
        cursor: pointer; }
        .modal.create-event-template .header.create-event-template .icon .close-event-button:hover {
          top: -21px; }
  .modal.create-event-template .footer.create-event-template {
    display: flex;
    margin-top: 10px;
    margin-left: 20px;
    margin-bottom: 10px; }

.modal.create-event {
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: #163447;
  padding: 0;
  border: 1px solid #491212;
  border-radius: 8px;
  overflow-x: hidden;
  overflow-y: auto; }
  .modal.create-event::-webkit-scrollbar {
    width: 6px; }
  .modal.create-event::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .modal.create-event::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .modal.create-event::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }
  .modal.create-event .header.create-event {
    display: flex;
    justify-content: space-between;
    color: #dfdfdf;
    text-transform: uppercase;
    font-weight: bold;
    align-items: center;
    padding: 5px 10px;
    border-bottom: 2px solid #2a3847;
    border-radius: 8px 8px 0px 0px;
    background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___}); }
    .modal.create-event .header.create-event .calendar-h3 {
      text-align: left;
      text-transform: uppercase;
      margin-left: 20px;
      margin-top: 5px;
      margin-bottom: 5px;
      color: #dfdfdf; }
  .modal.create-event .menu {
    display: flex;
    background-color: #0c2637;
    gap: 30px;
    padding: 10px 20px 10px 35px;
    border: 1px solid #b8b8b8;
    border-radius: 8px;
    margin: 10px 0px 10px; }
    .modal.create-event .menu .recurrence {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: flex-end; }
      .modal.create-event .menu .recurrence .btn-style1 {
        padding: 0.2rem 0.8rem 0.25rem 0.8rem; }
      .modal.create-event .menu .recurrence .recurrence-text {
        font-size: 14px;
        margin-left: 5px;
        margin-bottom: 6px;
        color: #dfdfdf; }
    .modal.create-event .menu .create-event-access-toggle {
      align-self: center; }
    .modal.create-event .menu .template-selector {
      display: grid;
      font-weight: bold;
      gap: 5px;
      margin-left: auto;
      margin-right: 20px; }
  .modal.create-event .create-event-content-subtabs {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    min-width: 0; }
    .modal.create-event .create-event-content-subtabs .ui-subtabs {
      align-self: center;
      margin-top: 0; }
  .modal.create-event .create-event-content-subtabs__panels {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box; }
  .modal.create-event .create-event-content-subtabs__panel.display-none {
    display: none !important; }
  .modal.create-event .create-event-content-subtabs__panel {
    background: transparent;
    border: 0;
    border-radius: 0;
    padding: 0;
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    height: 56vh;
    max-height: 56vh;
    overflow-x: hidden;
    overflow-y: auto; }
    .modal.create-event .create-event-content-subtabs__panel::-webkit-scrollbar {
      width: 6px; }
    .modal.create-event .create-event-content-subtabs__panel::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .modal.create-event .create-event-content-subtabs__panel::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .modal.create-event .create-event-content-subtabs__panel::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
    .modal.create-event .create-event-content-subtabs__panel .management-container.create-event {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      box-sizing: border-box;
      margin-bottom: 10px; }
      .modal.create-event .create-event-content-subtabs__panel .management-container.create-event:last-child {
        margin-bottom: 0; }
    .modal.create-event .create-event-content-subtabs__panel .management-container.objectives-bloc,
    .modal.create-event .create-event-content-subtabs__panel .event-description {
      width: 100%;
      margin: 0;
      max-width: 100%;
      box-sizing: border-box; }
    .modal.create-event .create-event-content-subtabs__panel .management-container.create-event.banner .discord {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      box-sizing: border-box; }
      .modal.create-event .create-event-content-subtabs__panel .management-container.create-event.banner .discord .discord-banner {
        width: min(500px, 100%);
        margin-left: auto;
        margin-right: auto; }
        .modal.create-event .create-event-content-subtabs__panel .management-container.create-event.banner .discord .discord-banner .dropzone {
          width: 100%;
          max-width: 500px; }
      .modal.create-event .create-event-content-subtabs__panel .management-container.create-event.banner .discord .discord-description {
        width: min(540px, 100%);
        max-width: 100%;
        min-width: 0; }
    .modal.create-event .create-event-content-subtabs__panel .management-container.create-event.setting .inputs.create-event {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      box-sizing: border-box;
      grid-template-columns: repeat(5, minmax(0, 1fr)); }
      .modal.create-event .create-event-content-subtabs__panel .management-container.create-event.setting .inputs.create-event .inputs-column {
        width: auto;
        min-width: 0; }
        .modal.create-event .create-event-content-subtabs__panel .management-container.create-event.setting .inputs.create-event .inputs-column.width, .modal.create-event .create-event-content-subtabs__panel .management-container.create-event.setting .inputs.create-event .inputs-column.rewards {
          width: auto; }
  .modal.create-event .create-event-content-subtabs__panel--banner-settings:not(.display-none) {
    display: flex;
    flex-direction: column;
    gap: 12px; }
    .modal.create-event .create-event-content-subtabs__panel--banner-settings:not(.display-none) .management-container.create-event.banner {
      flex: 0 0 auto; }
    .modal.create-event .create-event-content-subtabs__panel--banner-settings:not(.display-none) .management-container.create-event.setting {
      flex: 1 1 auto;
      min-height: 18rem;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      padding: 0.55rem 0.45rem 0.75rem; }
      .modal.create-event .create-event-content-subtabs__panel--banner-settings:not(.display-none) .management-container.create-event.setting .inputs.create-event {
        flex: 1 1 auto;
        margin-top: 0.35rem;
        margin-bottom: 0.25rem;
        align-content: start;
        row-gap: 0.85rem; }
  .modal.create-event .footer.create-event {
    display: flex;
    margin-top: 20px;
    margin-left: 20px;
    margin-bottom: 20px; }

.modal.create-handle {
  background-color: rgba(0, 0, 0, 0.6); }
  .modal.create-handle .create-handle {
    width: 600px; }
    .modal.create-handle .create-handle .create-handle.header {
      border-bottom: 3px solid #b8b8b8;
      border-radius: 8px 8px 0px 0px;
      background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center; }
      .modal.create-handle .create-handle .create-handle.header .handle-h3 {
        text-align: left;
        text-transform: uppercase;
        margin: 0;
        padding: 5px 20px;
        color: #dfdfdf; }
    .modal.create-handle .create-handle .create-handle.content {
      display: flex;
      flex-direction: row;
      width: 100%;
      height: 245px; }
      .modal.create-handle .create-handle .create-handle.content .create-handle.column {
        display: flex;
        flex-direction: column;
        padding: 1em;
        background-color: #1c2d38;
        width: 40%; }
        .modal.create-handle .create-handle .create-handle.content .create-handle.column.bullet-points {
          justify-content: center;
          color: #dfdfdf;
          padding: 15px;
          background-color: #0c2637;
          width: 60%; }
          .modal.create-handle .create-handle .create-handle.content .create-handle.column.bullet-points ul {
            list-style-type: disc;
            padding-left: 20px; }
          .modal.create-handle .create-handle .create-handle.content .create-handle.column.bullet-points ol {
            list-style-type: decimal;
            padding-left: 20px; }
          .modal.create-handle .create-handle .create-handle.content .create-handle.column.bullet-points li {
            margin-top: 20px;
            margin-bottom: 20px; }
          .modal.create-handle .create-handle .create-handle.content .create-handle.column.bullet-points a {
            color: white;
            text-decoration: none; }
            .modal.create-handle .create-handle .create-handle.content .create-handle.column.bullet-points a:hover {
              color: #d12323; }

.modal-content-handle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: #0c2637;
  color: #dfdfdf;
  border-radius: 10px;
  width: 550px;
  height: 325px;
  position: relative;
  outline: none;
  z-index: 100;
  border-radius: 10px; }
  .modal-content-handle .mfa-h3 {
    text-transform: uppercase;
    text-align: center;
    margin: 10px;
    color: #dfdfdf;
    font-size: 1.3rem; }
  .modal-content-handle .mfa-radio-buttons {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 15px;
    gap: 15px;
    height: 20px; }
  .modal-content-handle .modal-content-type {
    display: flex;
    flex-direction: row; }
    .modal-content-handle .modal-content-type .modal-left {
      display: flex;
      flex-direction: column;
      background-color: #b8b8b8;
      align-items: center;
      width: 250px;
      min-height: 200px;
      padding: 15px 25px;
      border-radius: 0px 0px 0px 10px; }
      .modal-content-handle .modal-content-type .modal-left .mfa-qr-code {
        padding: 5px;
        margin: 0px; }
    .modal-content-handle .modal-content-type .modal-right {
      flex: 1;
      background-color: #2a3847;
      width: 250px;
      min-height: 200px;
      border-radius: 0px 0px 10px 0px; }
      .modal-content-handle .modal-content-type .modal-right .mfa-bullet-points {
        color: #dfdfdf;
        padding: 10px 10px 10px 0px; }
        .modal-content-handle .modal-content-type .modal-right .mfa-bullet-points li {
          margin-bottom: 20px; }
      .modal-content-handle .modal-content-type .modal-right .mobile {
        display: none; }

.modal.allied-deletion {
  background: #1c2d38;
  color: #dfdfdf;
  padding: 20px;
  border-radius: 4px;
  max-width: 500px;
  width: 30%;
  height: 120px;
  top: 35%;
  left: 37vw;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.3); }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.react-select__control,
.react-select-input__control,
.react-select-menu__control {
  background-color: #dfdfdf;
  border: 1px solid #491212;
  font-size: 12px !important;
  box-shadow: none;
  flex-wrap: nowrap !important; }

.react-select__control {
  min-width: 250px !important;
  min-height: 22px !important;
  height: 22px !important; }

.react-select-input__control {
  min-width: 175px !important;
  min-height: 22px !important;
  height: 22px !important;
  padding: 0px 3px !important; }

.react-select-input-comms__control {
  min-width: 190px !important;
  min-height: 22px !important;
  height: 22px !important;
  padding: 0px 3px !important; }

.react-select-menu__control {
  min-width: 190px !important;
  min-height: 22px !important;
  height: 22px !important; }

.react-select__value-container,
.react-select-input__value-container,
.react-select-menu__value-container {
  padding: 2px 2px !important; }

.react-select__menu,
.react-select-input__menu,
.react-select-menu__menu {
  color: #0c2637;
  font-size: 12px;
  z-index: 99999 !important; }

.react-select__menu-portal,
.react-select-input__menu-portal,
.react-select-menu__menu-portal {
  z-index: 99999 !important; }

.react-select__option,
.react-select-input__option,
.react-select-menu__option {
  background-color: #dfdfdf;
  color: #0c2637;
  padding: 4px 12px !important; }
  .react-select__option.react-select__option--is-selected, .react-select__option.react-select-input__option--is-selected, .react-select__option.react-select-menu__option--is-selected,
  .react-select-input__option.react-select__option--is-selected,
  .react-select-input__option.react-select-input__option--is-selected,
  .react-select-input__option.react-select-menu__option--is-selected,
  .react-select-menu__option.react-select__option--is-selected,
  .react-select-menu__option.react-select-input__option--is-selected,
  .react-select-menu__option.react-select-menu__option--is-selected {
    background-color: #b8b8b8;
    color: #0c2637; }
  .react-select__option:hover,
  .react-select-input__option:hover,
  .react-select-menu__option:hover {
    background-color: #b8b8b8;
    color: #1c2d38; }

.react-select__placeholder,
.react-select__single-value,
.react-select-input__placeholder,
.react-select-input__single-value,
.react-select-menu__placeholder,
.react-select-menu__single-value {
  color: #0c2637;
  font-size: 12px !important; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.hierarchy-select-container .react-dropdown-tree-select {
  font-family: "Lato", sans-serif; }
  .hierarchy-select-container .react-dropdown-tree-select .dropdown {
    position: relative;
    display: block; }
    .hierarchy-select-container .react-dropdown-tree-select .dropdown .dropdown-trigger {
      display: block;
      width: 172px;
      height: 38px;
      padding: 3px 5px;
      color: #0c2637;
      border-radius: 4px;
      background-color: white;
      overflow-x: hidden;
      cursor: pointer; }
      .hierarchy-select-container .react-dropdown-tree-select .dropdown .dropdown-trigger::-webkit-scrollbar {
        width: 6px; }
      .hierarchy-select-container .react-dropdown-tree-select .dropdown .dropdown-trigger::-webkit-scrollbar-track {
        background: #2e3842;
        border-radius: 4px;
        padding-right: 1px; }
      .hierarchy-select-container .react-dropdown-tree-select .dropdown .dropdown-trigger::-webkit-scrollbar-thumb {
        background-color: #491212;
        border-radius: 4px; }
        .hierarchy-select-container .react-dropdown-tree-select .dropdown .dropdown-trigger::-webkit-scrollbar-thumb:hover {
          background-color: #200808; }
      .hierarchy-select-container .react-dropdown-tree-select .dropdown .dropdown-trigger.arrow.bottom::after {
        content: "▼";
        position: absolute;
        top: 80%;
        right: 0.5rem;
        transform: translateY(-50%);
        pointer-events: none; }
    .hierarchy-select-container .react-dropdown-tree-select .dropdown .dropdown-content {
      position: absolute;
      top: 100%;
      left: 0;
      margin-top: 2px;
      box-sizing: border-box;
      max-height: 180px;
      overflow-y: auto;
      width: 190px;
      background-color: white;
      border: 1px solid #491212;
      border-radius: 4px;
      box-shadow: 0 5px 8px rgba(0, 0, 0, 0.15);
      z-index: 99999; }
      .hierarchy-select-container .react-dropdown-tree-select .dropdown .dropdown-content::-webkit-scrollbar {
        width: 6px; }
      .hierarchy-select-container .react-dropdown-tree-select .dropdown .dropdown-content::-webkit-scrollbar-track {
        background: #2e3842;
        border-radius: 4px;
        padding-right: 1px; }
      .hierarchy-select-container .react-dropdown-tree-select .dropdown .dropdown-content::-webkit-scrollbar-thumb {
        background-color: #491212;
        border-radius: 4px; }
        .hierarchy-select-container .react-dropdown-tree-select .dropdown .dropdown-content::-webkit-scrollbar-thumb:hover {
          background-color: #200808; }
      .hierarchy-select-container .react-dropdown-tree-select .dropdown .dropdown-content ul {
        color: #0c2637;
        padding: 0 10px 10px;
        overflow-x: hidden; }
        .hierarchy-select-container .react-dropdown-tree-select .dropdown .dropdown-content ul::-webkit-scrollbar {
          width: 6px; }
        .hierarchy-select-container .react-dropdown-tree-select .dropdown .dropdown-content ul::-webkit-scrollbar-track {
          background: #2e3842;
          border-radius: 4px;
          padding-right: 1px; }
        .hierarchy-select-container .react-dropdown-tree-select .dropdown .dropdown-content ul::-webkit-scrollbar-thumb {
          background-color: #491212;
          border-radius: 4px; }
          .hierarchy-select-container .react-dropdown-tree-select .dropdown .dropdown-content ul::-webkit-scrollbar-thumb:hover {
            background-color: #200808; }
        .hierarchy-select-container .react-dropdown-tree-select .dropdown .dropdown-content ul.infinite-scroll-component {
          overflow-x: hidden; }
    .hierarchy-select-container .react-dropdown-tree-select .dropdown .tag-list {
      display: flex;
      flex-direction: column;
      list-style: none;
      width: 170px;
      margin: 0;
      padding: 0;
      gap: 3px; }
      .hierarchy-select-container .react-dropdown-tree-select .dropdown .tag-list .tag-item {
        width: 160px; }
        .hierarchy-select-container .react-dropdown-tree-select .dropdown .tag-list .tag-item .tag {
          display: inline-flex;
          align-items: center;
          width: -webkit-fill-available;
          font-size: 14px;
          padding: 1px 4px;
          background-color: #dfdfdf;
          color: #0c2637;
          border-radius: 4px; }
          .hierarchy-select-container .react-dropdown-tree-select .dropdown .tag-list .tag-item .tag .tag-remove {
            background: none;
            border: none;
            margin-left: auto;
            margin-right: 0.25rem;
            color: #491212;
            cursor: pointer; }
      .hierarchy-select-container .react-dropdown-tree-select .dropdown .tag-list .search {
        display: none; }
    .hierarchy-select-container .react-dropdown-tree-select .dropdown .rst__dropdown {
      position: absolute;
      top: 100%;
      left: 0;
      width: 100%;
      max-height: 300px;
      overflow: auto;
      border: 1px solid #491212;
      background-color: white;
      border-radius: 4px;
      z-index: 1000;
      margin-top: 0.25rem; }
      .hierarchy-select-container .react-dropdown-tree-select .dropdown .rst__dropdown .rst__list {
        list-style: none;
        margin: 0;
        padding: 0; }
        .hierarchy-select-container .react-dropdown-tree-select .dropdown .rst__dropdown .rst__list .rst__list-item {
          padding: 0.5rem;
          display: flex;
          align-items: center;
          cursor: pointer; }
          .hierarchy-select-container .react-dropdown-tree-select .dropdown .rst__dropdown .rst__list .rst__list-item:hover {
            background-color: #2a3847; }
          .hierarchy-select-container .react-dropdown-tree-select .dropdown .rst__dropdown .rst__list .rst__list-item .rst__checkbox {
            margin-right: 0.5rem; }
          .hierarchy-select-container .react-dropdown-tree-select .dropdown .rst__dropdown .rst__list .rst__list-item .rst__node-label {
            flex: 1; }

.hierarchy-select-container .node[role="treeitem"][aria-level="1"] {
  padding-left: 0 !important; }

.hierarchy-select-container .node[role="treeitem"][aria-level="2"] {
  padding-left: 20px !important; }

.hierarchy-select-container .node[role="treeitem"][aria-level="3"] {
  padding-left: 40px !important; }

.hierarchy-select-container .node[role="treeitem"][aria-level="4"] {
  padding-left: 60px !important; }

.hierarchy-select-container .node[role="treeitem"][aria-level="5"] {
  padding-left: 80px !important; }

.hierarchy-select-container .node[role="treeitem"][aria-level="6"] {
  padding-left: 100px !important; }

.hierarchy-select-container.certifications-tree-select {
  width: 100%;
  min-width: 0; }

.certifications-select-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 2.1rem;
  padding: 0.45rem 1.75rem 0.45rem 0.65rem;
  box-sizing: border-box;
  overflow: hidden;
  color: #dfdfdf;
  border: 1px solid rgba(58, 120, 180, 0.45);
  border-radius: 8px;
  background: rgba(0, 48, 77, 0.65);
  font-family: inherit;
  font-size: 0.84rem;
  text-align: left;
  cursor: pointer;
  position: relative;
  background-image: linear-gradient(45deg, transparent 50%, rgba(223, 223, 223, 0.75) 50%), linear-gradient(135deg, rgba(223, 223, 223, 0.75) 50%, transparent 50%);
  background-position: calc(100% - 16px) calc(50% - 2px), calc(100% - 11px) calc(50% - 2px);
  background-size: 5px 5px, 5px 5px;
  background-repeat: no-repeat; }
  .certifications-select-trigger:disabled {
    cursor: not-allowed;
    opacity: 0.55; }
  .certifications-select-trigger__tags {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 0.25rem;
    flex: 1;
    min-width: 0;
    overflow: hidden; }
  .certifications-select-trigger__placeholder {
    color: rgba(223, 223, 223, 0.45);
    line-height: 1.35;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; }
  .certifications-select-trigger__summary {
    display: block;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #dfdfdf;
    line-height: 1.35; }
  .certifications-select-trigger__tag {
    display: inline-flex;
    align-items: center;
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;
    font-size: 0.78rem;
    padding: 0.1rem 0.35rem;
    background: rgba(58, 120, 180, 0.22);
    color: #dfdfdf;
    border: 1px solid rgba(58, 120, 180, 0.35);
    border-radius: 6px; }
  .certifications-select-trigger__tag-label {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; }
  .certifications-select-trigger__tag-remove {
    background: none;
    border: none;
    margin-left: 0.2rem;
    color: rgba(223, 223, 223, 0.75);
    cursor: pointer;
    padding: 0;
    line-height: 1; }
    .certifications-select-trigger__tag-remove:hover {
      color: #aa9e74; }
  .certifications-select-trigger__arrow {
    display: none; }

.certifications-select-panel {
  box-sizing: border-box;
  background: rgba(21, 28, 36, 0.98);
  border: 1px solid rgba(58, 120, 180, 0.35);
  border-radius: 8px;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.35);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  color: #dfdfdf;
  font-family: inherit; }
  .certifications-select-panel__search {
    width: 100%;
    box-sizing: border-box;
    border: none;
    border-bottom: 1px solid rgba(58, 120, 180, 0.28);
    outline: none;
    padding: 0.5rem 0.65rem;
    font-family: inherit;
    font-size: 0.84rem;
    color: #dfdfdf;
    background: rgba(0, 48, 77, 0.55); }
    .certifications-select-panel__search::placeholder {
      color: rgba(223, 223, 223, 0.45); }
  .certifications-select-panel__list {
    list-style: none;
    margin: 0;
    padding: 0 0 0.35rem;
    overflow-y: auto; }
    .certifications-select-panel__list::-webkit-scrollbar {
      width: 6px; }
    .certifications-select-panel__list::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .certifications-select-panel__list::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .certifications-select-panel__list::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
  .certifications-select-panel__empty {
    padding: 0.55rem 0.65rem;
    color: rgba(223, 223, 223, 0.55);
    font-size: 0.84rem; }
  .certifications-select-panel__option {
    padding: 0; }
  .certifications-select-panel__option-label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.45rem 0.65rem;
    cursor: pointer;
    font-size: 0.84rem; }
    .certifications-select-panel__option-label:hover {
      background: rgba(58, 120, 180, 0.18); }
    .certifications-select-panel__option-label input[type="checkbox"] {
      margin: 0;
      flex-shrink: 0;
      accent-color: #3a78b4; }
    .certifications-select-panel__option-label span {
      flex: 1;
      min-width: 0; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.ql-container {
  box-sizing: border-box;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 13px;
  height: 100%;
  margin: 0px;
  position: relative; }

.ql-container.ql-disabled .ql-tooltip {
  visibility: hidden; }

.ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {
  pointer-events: none; }

.ql-clipboard {
  left: -100000px;
  height: 1px;
  overflow-y: hidden;
  position: absolute;
  top: 50%; }

.ql-clipboard p {
  margin: 0;
  padding: 0; }

.ql-editor {
  box-sizing: border-box;
  line-height: 1.42;
  height: 100%;
  outline: none;
  overflow-y: auto;
  padding: 12px 15px;
  tab-size: 4;
  -moz-tab-size: 4;
  text-align: left;
  white-space: pre-wrap;
  word-wrap: break-word; }

.ql-editor > * {
  cursor: text; }

.ql-editor p,
.ql-editor ol,
.ql-editor ul,
.ql-editor pre,
.ql-editor blockquote,
.ql-editor h1,
.ql-editor h2,
.ql-editor h3,
.ql-editor h4,
.ql-editor h5,
.ql-editor h6 {
  margin: 0;
  padding: 0;
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  font-size: 14px; }

.ql-editor ol,
.ql-editor ul {
  padding-left: 1.5em; }

.ql-editor ol > li,
.ql-editor ul > li {
  list-style-type: none; }

.ql-editor ul > li::before {
  content: '\\2022'; }

.ql-editor ul[data-checked=true],
.ql-editor ul[data-checked=false] {
  pointer-events: none; }

.ql-editor ul[data-checked=true] > li *,
.ql-editor ul[data-checked=false] > li * {
  pointer-events: all; }

.ql-editor ul[data-checked=true] > li::before,
.ql-editor ul[data-checked=false] > li::before {
  color: #777;
  cursor: pointer;
  pointer-events: all; }

.ql-editor ul[data-checked=true] > li::before {
  content: '\\2611'; }

.ql-editor ul[data-checked=false] > li::before {
  content: '\\2610'; }

.ql-editor li::before {
  display: inline-block;
  white-space: nowrap;
  width: 1.2em; }

.ql-editor li:not(.ql-direction-rtl)::before {
  margin-left: -1.5em;
  margin-right: 0.3em;
  text-align: right; }

.ql-editor li.ql-direction-rtl::before {
  margin-left: 0.3em;
  margin-right: -1.5em; }

.ql-editor ol li:not(.ql-direction-rtl),
.ql-editor ul li:not(.ql-direction-rtl) {
  padding-left: 1.5em; }

.ql-editor ol li.ql-direction-rtl,
.ql-editor ul li.ql-direction-rtl {
  padding-right: 1.5em; }

.ql-editor ol li {
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  counter-increment: list-0; }

.ql-editor ol li:is([data-list='bullet'])::before {
  font-weight: bold;
  content: "•"; }

.ql-editor ol li:before {
  content: counter(list-0, decimal) ". "; }

.ql-editor ol li.ql-indent-1 {
  counter-increment: list-1; }

.ql-editor ol li.ql-indent-1:before {
  content: counter(list-1, lower-alpha) ". "; }

.ql-editor ol li.ql-indent-1 {
  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9; }

.ql-editor ol li.ql-indent-2 {
  counter-increment: list-2; }

.ql-editor ol li.ql-indent-2:before {
  content: counter(list-2, lower-roman) ". "; }

.ql-editor ol li.ql-indent-2 {
  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9; }

.ql-editor ol li.ql-indent-3 {
  counter-increment: list-3; }

.ql-editor ol li.ql-indent-3:before {
  content: counter(list-3, decimal) ". "; }

.ql-editor ol li.ql-indent-3 {
  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9; }

.ql-editor ol li.ql-indent-4 {
  counter-increment: list-4; }

.ql-editor ol li.ql-indent-4:before {
  content: counter(list-4, lower-alpha) ". "; }

.ql-editor ol li.ql-indent-4 {
  counter-reset: list-5 list-6 list-7 list-8 list-9; }

.ql-editor ol li.ql-indent-5 {
  counter-increment: list-5; }

.ql-editor ol li.ql-indent-5:before {
  content: counter(list-5, lower-roman) ". "; }

.ql-editor ol li.ql-indent-5 {
  counter-reset: list-6 list-7 list-8 list-9; }

.ql-editor ol li.ql-indent-6 {
  counter-increment: list-6; }

.ql-editor ol li.ql-indent-6:before {
  content: counter(list-6, decimal) ". "; }

.ql-editor ol li.ql-indent-6 {
  counter-reset: list-7 list-8 list-9; }

.ql-editor ol li.ql-indent-7 {
  counter-increment: list-7; }

.ql-editor ol li.ql-indent-7:before {
  content: counter(list-7, lower-alpha) ". "; }

.ql-editor ol li.ql-indent-7 {
  counter-reset: list-8 list-9; }

.ql-editor ol li.ql-indent-8 {
  counter-increment: list-8; }

.ql-editor ol li.ql-indent-8:before {
  content: counter(list-8, lower-roman) ". "; }

.ql-editor ol li.ql-indent-8 {
  counter-reset: list-9; }

.ql-editor ol li.ql-indent-9 {
  counter-increment: list-9; }

.ql-editor ol li.ql-indent-9:before {
  content: counter(list-9, decimal) ". "; }

.ql-editor .ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 3em; }

.ql-editor li.ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 4.5em; }

.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 3em; }

.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 4.5em; }

.ql-editor .ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 6em; }

.ql-editor li.ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 7.5em; }

.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 6em; }

.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 7.5em; }

.ql-editor .ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 9em; }

.ql-editor li.ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 10.5em; }

.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 9em; }

.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 10.5em; }

.ql-editor .ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 12em; }

.ql-editor li.ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 13.5em; }

.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 12em; }

.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 13.5em; }

.ql-editor .ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 15em; }

.ql-editor li.ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 16.5em; }

.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 15em; }

.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 16.5em; }

.ql-editor .ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 18em; }

.ql-editor li.ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 19.5em; }

.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 18em; }

.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 19.5em; }

.ql-editor .ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 21em; }

.ql-editor li.ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 22.5em; }

.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 21em; }

.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 22.5em; }

.ql-editor .ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 24em; }

.ql-editor li.ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 25.5em; }

.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 24em; }

.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 25.5em; }

.ql-editor .ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 27em; }

.ql-editor li.ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 28.5em; }

.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 27em; }

.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 28.5em; }

.ql-editor .ql-video {
  display: block;
  max-width: 100%; }

.ql-editor .ql-video.ql-align-center {
  margin: 0 auto; }

.ql-editor .ql-video.ql-align-right {
  margin: 0 0 0 auto; }

.ql-editor .ql-bg-black {
  background-color: #000; }

.ql-editor .ql-bg-red {
  background-color: #e60000; }

.ql-editor .ql-bg-orange {
  background-color: #f90; }

.ql-editor .ql-bg-yellow {
  background-color: #ff0; }

.ql-editor .ql-bg-green {
  background-color: #008a00; }

.ql-editor .ql-bg-blue {
  background-color: #75dfff; }

.ql-editor .ql-bg-purple {
  background-color: #93f; }

.ql-editor .ql-color-white {
  color: #fff; }

.ql-editor .ql-color-red {
  color: #e60000; }

.ql-editor .ql-color-orange {
  color: #f90; }

.ql-editor .ql-color-yellow {
  color: #ff0; }

.ql-editor .ql-color-green {
  color: #008a00; }

.ql-editor .ql-color-blue {
  color: #75dfff; }

.ql-editor .ql-color-purple {
  color: #93f; }

.ql-editor .ql-font-serif {
  font-family: Georgia, Times New Roman, serif; }

.ql-editor .ql-font-monospace {
  font-family: Monaco, Courier New, monospace; }

.ql-editor .ql-size-small {
  font-size: 0.75em; }

.ql-editor .ql-size-large {
  font-size: 1.5em; }

.ql-editor .ql-size-huge {
  font-size: 2.5em; }

.ql-editor .ql-direction-rtl {
  direction: rtl;
  text-align: inherit; }

.ql-editor .ql-align-center {
  text-align: center; }

.ql-editor .ql-align-justify {
  text-align: justify; }

.ql-editor .ql-align-right {
  text-align: right; }

.ql-editor.ql-blank::before {
  color: rgba(0, 0, 0, 0.6);
  content: attr(data-placeholder);
  font-style: italic;
  left: 15px;
  pointer-events: none;
  position: absolute;
  right: 15px; }

.ql-snow.ql-toolbar:after,
.ql-snow .ql-toolbar:after {
  clear: both;
  content: '';
  display: table; }

.ql-snow.ql-toolbar button,
.ql-snow .ql-toolbar button {
  background: none;
  border: none;
  cursor: pointer;
  display: inline-block;
  float: left;
  height: 24px;
  padding: 3px 5px;
  width: 28px; }

.ql-snow.ql-toolbar button svg,
.ql-snow .ql-toolbar button svg {
  float: left;
  height: 100%; }

.ql-snow.ql-toolbar button:active:hover,
.ql-snow .ql-toolbar button:active:hover {
  outline: none; }

.ql-snow.ql-toolbar input.ql-image[type=file],
.ql-snow .ql-toolbar input.ql-image[type=file] {
  display: none; }

.ql-snow.ql-toolbar button:hover,
.ql-snow .ql-toolbar button:hover,
.ql-snow.ql-toolbar button:focus,
.ql-snow .ql-toolbar button:focus,
.ql-snow.ql-toolbar button.ql-active,
.ql-snow .ql-toolbar button.ql-active,
.ql-snow.ql-toolbar .ql-picker-label:hover,
.ql-snow .ql-toolbar .ql-picker-label:hover,
.ql-snow.ql-toolbar .ql-picker-label.ql-active,
.ql-snow .ql-toolbar .ql-picker-label.ql-active,
.ql-snow.ql-toolbar .ql-picker-item:hover,
.ql-snow .ql-toolbar .ql-picker-item:hover,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected {
  color: #75dfff; }

.ql-snow.ql-toolbar button:hover .ql-fill,
.ql-snow .ql-toolbar button:hover .ql-fill,
.ql-snow.ql-toolbar button:focus .ql-fill,
.ql-snow .ql-toolbar button:focus .ql-fill,
.ql-snow.ql-toolbar button.ql-active .ql-fill,
.ql-snow .ql-toolbar button.ql-active .ql-fill,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,
.ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,
.ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill,
.ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,
.ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,
.ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,
.ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {
  fill: #75dfff; }

.ql-snow.ql-toolbar button:hover .ql-stroke,
.ql-snow .ql-toolbar button:hover .ql-stroke,
.ql-snow.ql-toolbar button:focus .ql-stroke,
.ql-snow .ql-toolbar button:focus .ql-stroke,
.ql-snow.ql-toolbar button.ql-active .ql-stroke,
.ql-snow .ql-toolbar button.ql-active .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
.ql-snow.ql-toolbar button:hover .ql-stroke-miter,
.ql-snow .ql-toolbar button:hover .ql-stroke-miter,
.ql-snow.ql-toolbar button:focus .ql-stroke-miter,
.ql-snow .ql-toolbar button:focus .ql-stroke-miter,
.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,
.ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {
  stroke: #75dfff; }

@media (pointer: coarse) {
  .ql-snow.ql-toolbar button:hover:not(.ql-active),
  .ql-snow .ql-toolbar button:hover:not(.ql-active) {
    color: #444; }
  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,
  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,
  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,
  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {
    fill: #444; }
  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,
  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,
  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,
  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {
    stroke: #444; } }

.ql-snow {
  box-sizing: border-box; }

.ql-snow * {
  box-sizing: border-box; }
  .ql-snow *::-webkit-scrollbar {
    width: 6px; }
  .ql-snow *::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .ql-snow *::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .ql-snow *::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }

.ql-snow .ql-hidden {
  display: none; }

.ql-snow .ql-out-bottom,
.ql-snow .ql-out-top {
  visibility: hidden; }

.ql-snow .ql-tooltip {
  position: absolute;
  transform: translateY(10px); }

.ql-snow .ql-tooltip a {
  cursor: pointer;
  text-decoration: none; }

.ql-snow .ql-tooltip.ql-flip {
  transform: translateY(-10px); }

.ql-snow .ql-formats {
  display: inline-block;
  vertical-align: middle; }

.ql-snow .ql-formats:after {
  clear: both;
  content: '';
  display: table; }

.ql-snow .ql-stroke {
  fill: none;
  stroke: #dfdfdf;
  strokeLinecap: round;
  strokeLinejoin: round;
  strokeWidth: 2; }

.ql-snow .ql-stroke-miter {
  fill: none;
  stroke: #dfdfdf;
  stroke-miterlimit: 10;
  strokeWidth: 2; }

.ql-snow .ql-fill,
.ql-snow .ql-stroke.ql-fill {
  fill: #dfdfdf; }

.ql-snow .ql-empty {
  fill: none; }

.ql-snow .ql-even {
  fill-rule: evenodd; }

.ql-snow .ql-thin,
.ql-snow .ql-stroke.ql-thin {
  strokeWidth: 1; }

.ql-snow .ql-transparent {
  opacity: 0.4; }

.ql-snow .ql-direction svg:last-child {
  display: none; }

.ql-snow .ql-direction.ql-active svg:last-child {
  display: inline; }

.ql-snow .ql-direction.ql-active svg:first-child {
  display: none; }

.ql-snow .ql-editor h1 {
  font-size: 2em; }

.ql-snow .ql-editor h2 {
  font-size: 1.5em; }

.ql-snow .ql-editor h3 {
  font-size: 1.17em; }

.ql-snow .ql-editor h4 {
  font-size: 1em; }

.ql-snow .ql-editor h5 {
  font-size: 0.83em; }

.ql-snow .ql-editor h6 {
  font-size: 0.67em; }

.ql-snow .ql-editor a {
  text-decoration: underline; }

.ql-snow .ql-editor blockquote {
  border-left: 4px solid #ccc;
  margin-bottom: 5px;
  margin-top: 5px;
  padding-left: 16px; }

.ql-snow .ql-editor code,
.ql-snow .ql-editor pre {
  background-color: #f0f0f0;
  border-radius: 3px; }

.ql-snow .ql-editor pre {
  white-space: pre-wrap;
  margin-bottom: 5px;
  margin-top: 5px;
  padding: 5px 10px; }

.ql-snow .ql-editor code {
  font-size: 85%;
  padding: 2px 4px; }

.ql-snow .ql-editor pre.ql-syntax {
  background-color: #23241f;
  color: #45c1ff;
  overflow: visible; }

.ql-snow .ql-editor img {
  max-width: 100%; }

.ql-snow .ql-picker {
  color: #dfdfdf;
  display: inline-block;
  float: left;
  font-size: 14px;
  font-weight: 500;
  height: 24px;
  position: relative;
  vertical-align: middle; }

.ql-snow .ql-picker-label {
  cursor: pointer;
  display: inline-block;
  height: 100%;
  padding-left: 8px;
  padding-right: 2px;
  position: relative;
  width: 100%; }

.ql-snow .ql-picker-label::before {
  display: inline-block;
  line-height: 22px; }

.ql-snow .ql-picker-options {
  background-color: #592727;
  display: none;
  min-width: 100%;
  padding: 4px 8px;
  position: absolute;
  white-space: nowrap; }

.ql-snow .ql-picker-options .ql-picker-item {
  cursor: pointer;
  display: block;
  padding-bottom: 5px;
  padding-top: 5px; }

.ql-snow .ql-picker.ql-expanded .ql-picker-label {
  color: #ccc;
  z-index: 2; }

.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {
  fill: #ccc; }

.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {
  stroke: #ccc; }

.ql-snow .ql-picker.ql-expanded .ql-picker-options {
  display: block;
  margin-top: -1px;
  top: 100%;
  z-index: 1; }

.ql-snow .ql-color-picker,
.ql-snow .ql-icon-picker {
  width: 28px; }

.ql-snow .ql-color-picker .ql-picker-label,
.ql-snow .ql-icon-picker .ql-picker-label {
  padding: 2px 4px; }

.ql-snow .ql-color-picker .ql-picker-label svg,
.ql-snow .ql-icon-picker .ql-picker-label svg {
  right: 4px; }

.ql-snow .ql-icon-picker .ql-picker-options {
  padding: 4px 0px; }

.ql-snow .ql-icon-picker .ql-picker-item {
  height: 24px;
  width: 24px;
  padding: 2px 4px; }

.ql-snow .ql-color-picker .ql-picker-options {
  padding: 3px 5px;
  width: 152px; }

.ql-snow .ql-color-picker .ql-picker-item {
  border: 1px solid transparent;
  float: left;
  height: 16px;
  margin: 2px;
  padding: 0px;
  width: 16px; }

.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
  position: absolute;
  margin-top: -9px;
  right: 0;
  top: 50%;
  width: 18px; }

.ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before,
.ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before,
.ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before {
  content: attr(data-label); }

.ql-snow .ql-picker.ql-header {
  width: 98px; }

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: 'Normal'; }

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: 'Heading 1'; }

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: 'Heading 2'; }

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: 'Heading 3'; }

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: 'Heading 4'; }

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: 'Heading 5'; }

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: 'Heading 6'; }

.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  font-size: 2em; }

.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  font-size: 1.5em; }

.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  font-size: 1.17em; }

.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  font-size: 1em; }

.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  font-size: 0.83em; }

.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  font-size: 0.67em; }

.ql-snow .ql-picker.ql-font {
  width: 108px; }

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: 'Sans Serif'; }

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
  content: 'Serif'; }

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
  content: 'Monospace'; }

.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
  font-family: Georgia, Times New Roman, serif; }

.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
  font-family: Monaco, Courier New, monospace; }

.ql-snow .ql-picker.ql-size {
  width: 98px; }

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: 'Normal'; }

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
  content: 'Small'; }

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
  content: 'Large'; }

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
  content: 'Huge'; }

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
  font-size: 10px; }

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
  font-size: 18px; }

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
  font-size: 32px; }

.ql-snow .ql-color-picker.ql-background .ql-picker-item {
  background-color: #fff; }

.ql-snow .ql-color-picker.ql-color .ql-picker-item {
  background-color: #000; }

.ql-toolbar.ql-snow {
  border: 1px solid #4b0505f5;
  box-sizing: border-box;
  font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
  padding: 3px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px; }

.ql-toolbar.ql-snow .ql-formats {
  margin-right: 15px; }

.ql-toolbar.ql-snow .ql-picker-label {
  border: 1px solid transparent; }

.ql-toolbar.ql-snow .ql-picker-options {
  border: 1px solid transparent;
  box-shadow: rgba(0, 0, 0, 0.2) 0 2px 8px; }

.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {
  border-color: #491212; }

.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {
  border-color: #491212; }

.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,
.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {
  border-color: #000; }

.ql-toolbar.ql-snow + .ql-container.ql-snow {
  border-top: 0px;
  background-color: #1c2d38; }

.ql-snow .ql-tooltip {
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0px 0px 5px #ddd;
  color: #444;
  padding: 5px 12px;
  white-space: nowrap; }

.ql-snow .ql-tooltip::before {
  content: "Visit URL:";
  line-height: 26px;
  margin-right: 8px; }

.ql-snow .ql-tooltip input[type=text] {
  display: none;
  border: 1px solid #ccc;
  font-size: 13px;
  height: 26px;
  margin: 0px;
  padding: 3px 5px;
  width: 170px; }

.ql-snow .ql-tooltip a.ql-preview {
  display: inline-block;
  max-width: 200px;
  overflow-x: hidden;
  text-overflow: ellipsis;
  vertical-align: top; }

.ql-snow .ql-tooltip a.ql-action::after {
  border-right: 1px solid #ccc;
  content: 'Edit';
  margin-left: 16px;
  padding-right: 8px; }

.ql-snow .ql-tooltip a.ql-remove::before {
  content: 'Remove';
  margin-left: 8px; }

.ql-snow .ql-tooltip a {
  line-height: 26px; }

.ql-snow .ql-tooltip.ql-editing a.ql-preview,
.ql-snow .ql-tooltip.ql-editing a.ql-remove {
  display: none; }

.ql-snow .ql-tooltip.ql-editing input[type=text] {
  display: inline-block; }

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: 'Save';
  padding-right: 0px; }

.ql-snow .ql-tooltip[data-mode=link]::before {
  content: "Enter link:"; }

.ql-snow .ql-tooltip[data-mode=formula]::before {
  content: "Enter formula:"; }

.ql-snow .ql-tooltip[data-mode=video]::before {
  content: "Enter video:"; }

.ql-snow a {
  color: #75dfff; }

.ql-container.ql-snow {
  border: 1px solid #491212;
  border-radius: 0 0 10px 10px; }

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="lato"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="lato"]::before {
  content: 'Lato'; }

.ql-font-lato {
  font-family: 'Lato', sans-serif; }

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="goodtimes"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="goodtimes"]::before {
  content: 'GoodTimes'; }

.ql-font-goodtimes {
  font-family: 'GoodTimes', sans-serif; }

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="firacode"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="firacode"]::before {
  content: 'FiraCode'; }

.ql-font-firacode {
  font-family: 'FiraCode', sans-serif; }

.ql-editor .uppercase {
  text-transform: uppercase; }

.uppercase {
  text-transform: uppercase; }

.ql-container .qlbt-selection-line.qlbt-selection-line-left::before {
  position: absolute;
  left: -2px;
  top: -2px;
  content: '';
  width: 5px;
  height: 5px;
  background-color: #75dfff;
  border-radius: 5px; }

.ql-container .qlbt-selection-line.qlbt-selection-line-right::before {
  position: absolute;
  right: -2px;
  bottom: -3px;
  content: '';
  width: 5px;
  height: 5px;
  background-color: #75dfff;
  border-radius: 5px; }

.quill-better-table-wrapper {
  overflow-x: auto; }

table.quill-better-table {
  table-layout: fixed;
  border-collapse: collapse; }

table.quill-better-table td {
  border: 1px solid #dfdfdf;
  padding: 2px 5px; }

.qlbt-operation-menu {
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  font-size: 14px;
  z-index: 100;
  overflow: hidden; }

.qlbt-operation-menu .qlbt-operation-menu-dividing {
  height: 1px;
  background-color: #efefef; }

.qlbt-operation-menu .qlbt-operation-menu-subtitle {
  color: #999;
  font-size: 14px;
  padding: 5px 16px; }

.qlbt-operation-menu .qlbt-operation-color-picker {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 0 16px 10px;
  background-color: #fff;
  overflow: hidden; }

.qlbt-operation-menu .qlbt-operation-color-picker .qlbt-operation-color-picker-item {
  width: 20px;
  height: 20px;
  border: 1px solid #595959;
  margin-right: 5px;
  margin-bottom: 5px;
  cursor: pointer; }

.qlbt-operation-menu .qlbt-operation-menu-item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  background-color: #fff;
  cursor: pointer;
  color: #595959;
  overflow: hidden;
  text-overflow: ellipsis; }

.qlbt-operation-menu .qlbt-operation-menu-item:hover {
  background-color: #efefef; }

.qlbt-operation-menu .qlbt-operation-menu-item .qlbt-operation-menu-icon {
  margin-right: 8px;
  height: 20px;
  width: 20px;
  font-size: 0; }

.qlbt-col-tool {
  position: absolute;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
  z-index: 99;
  height: 16px; }

.qlbt-col-tool .qlbt-col-tool-cell {
  position: relative;
  background-color: #fff;
  border-top: 1px solid #000;
  border-right: 1px solid #000;
  border-bottom: 1px solid #000; }

.qlbt-col-tool .qlbt-col-tool-cell:first-child {
  border-left: 1px solid #000; }

.qlbt-col-tool .qlbt-col-tool-cell-holder {
  position: absolute;
  right: -1px;
  top: 0;
  bottom: 0;
  z-index: 3;
  width: 1px;
  background-color: transparent;
  cursor: ew-resize; }

.qlbt-col-tool .qlbt-col-tool-cell-holder:hover {
  background-color: #75dfff; }

.qlbt-col-tool .qlbt-col-tool-cell-holder::before {
  content: "";
  position: absolute;
  top: 0;
  left: -6px;
  display: block;
  width: 8px;
  height: 100%; }

.qlbt-col-tool .qlbt-col-tool-cell-holder::after {
  content: "";
  position: absolute;
  top: 0;
  right: -6px;
  display: block;
  width: 8px;
  height: 100%; }

.ql-icon-insert-table {
  width: 16px;
  height: 16px;
  fill: #dfdfdf;
  stroke: #dfdfdf; }

.ql-icon-insert-table:hover {
  fill: #75dfff;
  stroke: #75dfff; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.lexical-header1, .lexical-header2, .lexical-header3, .lexical-header4 {
  color: white;
  text-transform: uppercase;
  font-family: GoodTimes; }

.lexical-header5, .lexical-header6 {
  color: white;
  font-weight: bold;
  text-transform: uppercase;
  margin: 10px 0px 7px 0px;
  font-family: Lato; }

.lexical-container {
  position: relative;
  display: grid; }

/* Lexical @lexical/react CollaborationPlugin portals remote cursors here.
   Default target is document.body with z-index ~5 — hidden under Bootstrap modals (~1050). */
.lexical-collab-cursors-host {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: visible;
  z-index: 50; }

.lexical-editor {
  position: relative;
  overflow: visible; }

.editor-content {
  user-select: text;
  white-space: pre-wrap;
  word-break: break-word; }

.lexical-document-footer {
  padding: 10px 15px; }

.font-lato,
.font-Lato {
  font-family: 'Lato', sans-serif; }

.font-goodtimes,
.font-GoodTimes {
  font-family: 'GoodTimes', sans-serif; }

.lexical-parameters {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin: 5px 15px; }

.collaboration-status {
  margin: 0px 10px 0px 15px;
  color: #dfdfdf; }

.status-indicators {
  display: flex;
  flex-direction: row;
  align-items: center; }

.editor-container {
  position: relative;
  /* anchor for portaled CommentPlugin UI inside this node */
  overflow: visible;
  /* AddCommentBox sits slightly past the right outer edge */
  display: grid;
  border: 1px solid #491212;
  border-radius: 5px;
  border-bottom: 4px solid #491212;
  background: #0c2637;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  margin: 0;
  box-shadow: 4px 5px 2px #4b050547; }

.editor-input {
  position: relative;
  min-height: 175px;
  max-height: calc(100vh - 620px);
  outline: none;
  padding: 18px;
  overflow-y: auto; }
  .editor-input::-webkit-scrollbar {
    width: 6px; }
  .editor-input::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .editor-input::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .editor-input::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }
  .editor-input.lexical-link-url-popup-open {
    pointer-events: none !important; }

.editor-input,
.editor-input * {
  -webkit-user-select: text !important;
  /* Safari/Chrome */
  -moz-user-select: text !important;
  /* Firefox */
  -ms-user-select: text !important;
  /* IE10+ */
  user-select: text !important;
  /* Standard */ }

.editor-placeholder {
  display: none;
  color: #dfdfdf;
  padding: 10px 18px; }

.editor-paragraph {
  line-height: 1.45em;
  margin-bottom: 5px; }

.editor-bold {
  font-weight: bolder; }

.editor-italic {
  font-style: italic; }

.editor-underline {
  text-decoration: underline; }

.editor-strikethrough {
  text-decoration: line-through; }

.text-uppercase {
  text-transform: uppercase; }

.text-lowercase {
  text-transform: lowercase; }

.text-capitalize {
  text-transform: capitalize; }

.lexical-header1 {
  font-size: 30px;
  font-weight: lighter;
  margin-block-start: 0em; }

.lexical-header2 {
  font-size: 26px;
  font-weight: normal; }

.lexical-header3 {
  font-size: 24px;
  font-weight: normal;
  margin: 15px 0px 10px 0px; }

.lexical-header4 {
  font-size: 18px;
  font-weight: normal;
  margin: 15px 0px 10px 0px; }

.lexical-header5 {
  font-size: 16px; }

.lexical-header6 {
  font-size: 14px; }

.lexical-paragraph {
  font-size: 16px;
  margin-top: 5px;
  font-family: Lato; }

.editor-paragraph a {
  color: #84b4f3;
  text-decoration: none;
  cursor: pointer; }

.editor-paragraph a:hover {
  color: #588dd3;
  text-decoration: underline; }

.editor-paragraph a:visited {
  color: #a746e4; }

.editor-paragraph a:active,
.editor-paragraph a:focus {
  color: white;
  outline: none;
  box-shadow: 0 0 0 2px rgba(26, 115, 232, 0.5); }

.lexical-editor a {
  color: white;
  text-decoration: none;
  cursor: pointer; }

.lexical-editor a:hover {
  color: #74aaf1;
  text-decoration: underline; }

.lexical-editor a:visited {
  color: #a746e4; }

.lexical-editor a:active,
.lexical-editor a:focus {
  color: white;
  outline: none;
  box-shadow: 0 0 0 2px rgba(26, 115, 232, 0.5); }

.editor-image-wrapper {
  display: grid;
  position: relative; }

.editor-align-left.editor-image-wrapper {
  width: 100%;
  justify-items: start; }

.editor-align-center.editor-image-wrapper {
  width: 100%;
  justify-items: center; }

.editor-align-right.editor-image-wrapper {
  width: 100%;
  justify-items: end; }

.editor-align-left,
.editor-align-center,
.editor-align-right,
.editor-align-justify {
  text-align: inherit; }

.editor-align-left {
  text-align: left; }

.editor-align-center {
  text-align: center; }

.editor-align-right {
  text-align: right; }

.editor-align-justify {
  text-align: justify; }

.toolbar {
  display: flex;
  position: sticky !important;
  height: 22px;
  gap: 5px;
  padding: 5px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  border-bottom: 2px solid #2a3847;
  z-index: 100;
  background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center; }
  .toolbar .toolbar-button {
    background-color: #00000033;
    padding: 3px 5px;
    color: #b8b8b8;
    font-size: small;
    border: none;
    border-radius: 6px;
    height: 22px;
    cursor: pointer; }
    .toolbar .toolbar-button:hover {
      background-color: #00000050;
      color: #dfdfdf;
      filter: brightness(0) invert(80%); }
    .toolbar .toolbar-button.lexical-fontsize {
      width: 127px; }
    .toolbar .toolbar-button.alignement {
      width: 127px; }
    .toolbar .toolbar-button.insert {
      width: 93px; }
    .toolbar .toolbar-button.toc {
      position: relative;
      align-items: center;
      place-self: center;
      height: 21px; }
    .toolbar .toolbar-button.emojis {
      position: relative;
      background: none; }
    .toolbar .toolbar-button.comments {
      position: relative;
      align-items: center;
      place-self: center;
      height: 20px; }
      .toolbar .toolbar-button.comments.has-unread-mention:hover {
        filter: none; }
    .toolbar .toolbar-button.fontsize {
      display: flex;
      align-items: center;
      place-self: center;
      height: 17px; }
      .toolbar .toolbar-button.fontsize .fontsize-button {
        background: none;
        border: none;
        padding: 0 6px;
        color: #b8b8b8;
        cursor: pointer; }
        .toolbar .toolbar-button.fontsize .fontsize-button:hover {
          color: #dfdfdf; }
      .toolbar .toolbar-button.fontsize .fontsize-label {
        width: 20px;
        color: #b8b8b8;
        background: transparent;
        font-size: small;
        border: none;
        cursor: text; }
        .toolbar .toolbar-button.fontsize .fontsize-label:hover {
          color: #b8b8b8; }
      .toolbar .toolbar-button.fontsize:hover .fontsize-label {
        background: transparent; }
    .toolbar .toolbar-button:hover {
      filter: brightness(0) invert(80%); }
  .toolbar .buttons-set-right {
    display: flex;
    position: relative;
    margin-left: auto;
    margin-right: 3px;
    gap: 3px; }
  .toolbar .toolbar-button svg {
    width: 21px;
    transform: translateY(-2px);
    flex-shrink: 0; }

.toolbar .divider {
  width: 1px;
  background-color: #2a3847; }

.editor-input u {
  text-decoration: underline; }

.editor-input s {
  text-decoration: line-through; }

.toolbar button.active {
  font-weight: bold;
  filter: brightness(0) invert(70%); }
  .toolbar button.active:hover {
    filter: brightness(0) invert(70%); }

.toolbar button img {
  width: auto;
  height: 18px;
  filter: brightness(0) invert(70%);
  transition: filter 0.1s ease-in-out; }
  .toolbar button img:hover {
    filter: brightness(0) invert(100%); }

.font-size-dropdown {
  padding: 5px;
  font-size: 14px; }

.dropdown {
  position: relative;
  display: inline-block; }
  .dropdown .lexical-chevrondown {
    margin-right: 5px;
    margin-left: auto; }

.dropdown-toggle {
  display: flex;
  align-items: center;
  color: #b8b8b8; }
  .dropdown-toggle.font-selection {
    width: 115px; }

.dropdown-toggle:hover {
  color: white;
  height: 20px; }

.toolbar button img,
.dropdown-content .dropdown-icon {
  width: auto;
  height: 14px;
  margin-right: 5px;
  margin-left: 4px;
  filter: brightness(0) invert(70%);
  /* Gris clair */
  transition: filter 0.1s ease-in-out; }

.dropdown-content .dropdown-item:hover .dropdown-icon {
  filter: brightness(0) invert(100%);
  /* Blanc */ }

/* Le menu sera affiché uniquement via le rendu conditionnel dans le JS */
.dropdown-content {
  position: absolute;
  display: flex;
  flex-direction: column;
  padding: 2px;
  background-color: #0c2637;
  color: #b8b8b8;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  z-index: 100;
  width: 220px;
  max-height: 200px;
  top: 120%;
  left: 0;
  border: 1px solid #491212;
  border-radius: 6px 6px 6px 6px;
  overflow-y: auto; }
  .dropdown-content::-webkit-scrollbar {
    width: 6px; }
  .dropdown-content::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .dropdown-content::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .dropdown-content::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 6px 8px;
  cursor: pointer;
  transition: background-color 0.2s; }

.dropdown-item:hover {
  background-color: #1c2d38; }

.dropdown-icon {
  margin-right: 10px;
  width: 16px;
  height: 16px; }

.dropdown-label {
  flex-grow: 1;
  color: #b8b8b8;
  font-size: 14px;
  margin-right: 10px;
  width: max-content; }

.dropdown-shortcut {
  font-size: 12px;
  color: #888; }

.link-input-container {
  position: absolute;
  display: flex;
  align-items: center;
  background: #0c2637;
  border: 1px solid #491212;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
  z-index: 10060;
  pointer-events: auto; }

/* Anchored inside \`.editor-container\` (same modal stacking context as the editor). */
.link-input-container.link-input-container-portaled {
  position: absolute;
  top: var(--link-portal-top, 0);
  left: var(--link-portal-left, 0);
  z-index: 500; }

.link-input-container input {
  background: #b8b8b8;
  border: 1px solid #1c2d38;
  padding: 4px;
  margin-right: 5px;
  width: 200px;
  border-radius: 3px; }

.link-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px; }

.link-button img {
  background: transparent;
  width: 16px;
  height: 16px;
  filter: brightness(0) invert(40%); }

.link-button:hover img {
  filter: brightness(0.8) invert(70%); }

/* ✅ Corrige l'affichage des bullets pour les sous-listes */
.editor-input ul,
.editor-input ol {
  color: #b8b8b8;
  padding-left: 20px;
  /* Maintient une indentation correcte */
  margin-left: 0;
  line-height: 1.35em;
  list-style-position: outside;
  /* Assure l'alignement des bullets */ }
  .editor-input ul li,
  .editor-input ol li {
    margin-bottom: 5px; }

/* ✅ Applique les bons styles de bullets pour chaque niveau */
.editor-input ul {
  list-style-type: disc;
  /* Premier niveau: • */ }

.editor-input ul ul {
  list-style-type: circle;
  /* Deuxième niveau: ◦ */ }

.editor-input ul ul ul {
  list-style-type: square;
  /* Troisième niveau: ▪️ */ }

/* ✅ Corrige les listes ordonnées */
.editor-input ol {
  list-style-type: decimal;
  /* Premier niveau: 1, 2, 3 */ }

.editor-input ol ol {
  list-style-type: lower-alpha;
  /* Deuxième niveau: a, b, c */ }

.editor-input ol ol ol {
  list-style-type: lower-roman;
  /* Troisième niveau: i, ii, iii */ }

/* ✅ Empêche l'affichage des bullets en trop sur la première ligne indentée */
.editor-input li:has(> ul),
.editor-input li:has(> ol) {
  list-style-type: none;
  /* Supprime le bullet si l'élément contient une sous-liste */ }

/* View mode: nested list markers only (HTML is normalized on publish) */
.lexical-rendered-content ul {
  list-style-type: disc; }

.lexical-rendered-content ul ul {
  list-style-type: circle; }

.lexical-rendered-content ul ul ul {
  list-style-type: square; }

.lexical-rendered-content ol {
  list-style-type: decimal;
  padding-left: 20px;
  margin-left: 0; }

.lexical-rendered-content ol ol {
  list-style-type: lower-alpha; }

.lexical-rendered-content ol ol ol {
  list-style-type: lower-roman; }

/* ✅ Corrige l'affichage des checkbox dans les listes (éditeur uniquement) */
.editor-input li[role="checkbox"] {
  list-style: none;
  margin-left: -20px !important;
  padding-left: 0;
  margin-left: 0; }

.editor-input li[role="checkbox"]::before {
  content: "";
  display: inline-block;
  position: relative;
  top: 3px;
  width: 12px;
  height: 12px;
  border: 2px solid #b8b8b8;
  border-radius: 4px;
  margin-right: 8px;
  cursor: pointer; }

/* ✅ Affiche une coche quand la checkbox est cochée */
.editor-input li[role="checkbox"][aria-checked="true"]::before {
  position: relative;
  top: 3px;
  background-color: #491212;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 10px 10px; }

.editor-input blockquote {
  padding: 5px;
  position: relative;
  margin: 0;
  margin-left: 0;
  padding-left: 10px;
  border-left: 5px solid #2a3847; }

.editor-input blockquote ::before,
.editor-input.framed ::after {
  content: "";
  position: absolute;
  width: 20px;
  height: 20px;
  border: none; }

.editor-input blockquote ::before {
  top: -10px;
  left: -10px;
  width: 50%;
  height: 50%;
  border-radius: 6px 0 0 0;
  border-right: none;
  border-bottom: none; }

.editor-input blockquote ::after {
  bottom: -10px;
  right: -10px;
  width: 50%;
  height: 50%;
  border-radius: 6px 0;
  border-left: none;
  border-top: none; }

.editor-input.framed {
  font-family: "Goodtimes";
  font-weight: normal;
  line-height: 20px;
  text-align: inherit;
  user-select: none;
  color: white;
  background: transparent;
  padding: 15px;
  position: relative;
  margin: 10px 0;
  margin-left: 0;
  padding-left: 5px; }

.editor-input.framed ::before,
.editor-input.framed ::after {
  content: "";
  position: absolute;
  width: 20px;
  height: 20px;
  border: none; }

.editor-input.framed ::before {
  top: -10px;
  left: -10px;
  border-top: 3px solid #2a3847;
  border-left: 3px solid #2a3847;
  width: 50%;
  height: 50%;
  border-radius: 6px 0 0 0;
  border-right: none;
  border-bottom: none; }

.editor-input.framed ::after {
  bottom: -10px;
  right: -10px;
  border-bottom: 3px solid #2a3847;
  border-right: 3px solid #2a3847;
  border-left: none;
  width: 50%;
  height: 50%;
  border-radius: 6px 0;
  border-left: none;
  border-top: none; }

.horizontal-rule {
  border: none;
  border-top: 2px solid #b8b8b8;
  /* ✅ Apparence propre */
  margin: 16px 0;
  width: 100%; }

/* ✅ Style du popup */
.column-popup {
  position: absolute;
  top: 100%;
  left: 0;
  background: #0c2637;
  border: 1px solid #ccc;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  padding: 10px;
  z-index: 100;
  width: 210px;
  border: 1px solid #491212;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px; }

/* ✅ Titre du popup */
.column-popup h4 {
  font-size: 14px;
  margin-bottom: 8px;
  color: #dfdfdf;
  text-align: center; }

/* ✅ Style des boutons */
.column-popup button {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  background: #1c2d38;
  border: none;
  color: #dfdfdf;
  cursor: pointer;
  font-size: 14px;
  border-radius: 4px;
  transition: background 0.2s ease-in-out; }

/* ✅ Effet au survol */
.column-popup button:hover {
  border: 1px solid #9e2222;
  filter: none; }

/* ✅ Bouton d'annulation */
.column-popup button:last-child {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-color: #491212;
  background-blend-mode: multiply;
  color: #dfdfdf;
  font-weight: bold; }

.column-popup button:last-child:hover {
  background-color: #9e2222;
  color: white;
  filter: none; }

/* ===================================== */
/* ✅ Styles de base pour Column Layout" */
/* ===================================== */
.lexical-column-layout {
  width: 100%;
  border-collapse: separate;
  border-spacing: 20px 0px;
  table-layout: fixed;
  /* ✅ Force la répartition des tailles */
  background: transparent !important;
  /* ✅ Fond transparent */
  border: none !important;
  /* ✅ Aucune bordure */ }

/* ✅ Style des cellules (colonnes) */
.lexical-column-layout td {
  vertical-align: top;
  padding: 10px;
  border: none !important;
  /* ✅ Pas de bordure pour les cellules */
  position: relative;
  /* ✅ Permet de positionner le trait */ }

/* ✅ Ajoute le trait vertical entre les colonnes */
.lexical-column-layout td:not(:last-child)::after {
  content: "";
  position: absolute;
  top: 0;
  right: -10px;
  /* ✅ Positionne au centre du gap (spacing de 20px) */
  width: 2px;
  /* ✅ Épaisseur du trait */
  height: 100%;
  background-color: #2a3847;
  /* ✅ Couleur du trait */ }

/* ============================== */
/* ✅ Styles de base pour tables */
/* ============================== */
.PlaygroundEditorTheme__table {
  width: auto;
  border-collapse: collapse;
  border-spacing: 0;
  margin: 10px 0;
  table-layout: fixed; }
  .PlaygroundEditorTheme__table th,
  .PlaygroundEditorTheme__table .PlaygroundEditorTheme__tableCell {
    border: 1px solid #b8b8b8;
    padding: 8px;
    text-align: left;
    background: transparent;
    word-break: break-word; }
  .PlaygroundEditorTheme__table th {
    background: red;
    font-weight: bold; }
  .PlaygroundEditorTheme__table col {
    width: auto; }
  .PlaygroundEditorTheme__table.CustomTableNode__alignLeft {
    margin-left: 0;
    margin-right: auto; }
  .PlaygroundEditorTheme__table.CustomTableNode__alignCenter {
    margin-left: auto;
    margin-right: auto; }
  .PlaygroundEditorTheme__table.CustomTableNode__alignRight {
    margin-left: auto;
    margin-right: 0; }
  .PlaygroundEditorTheme__table.CustomTableNode__alignJustify {
    margin-left: auto;
    margin-right: auto;
    width: 100%; }
  .PlaygroundEditorTheme__table.tableSelected {
    box-shadow: 0 0 0 2px #3b82f6 inset; }

.PlaygroundEditorTheme__tableCell {
  border: 1px solid #b8b8b8;
  padding: 4px; }

.PlaygroundEditorTheme__tableCellSelected {
  outline: 2px solid #3b82f6;
  /* blue-500 */
  outline-offset: -2px;
  background-color: rgba(59, 130, 246, 0.1);
  /* light blue background */ }

.PlaygroundEditorTheme__tableSelection {
  box-shadow: 0 0 0 2px #3b82f6 inset; }

.TableCellResizer__handle {
  position: fixed;
  z-index: 10000;
  background-color: transparent; }

.TableCellResizer__handle--right {
  cursor: col-resize; }

.TableCellResizer__handle--right.TableCellResizer__handle--hovered {
  background-image: linear-gradient(90deg, transparent 6px, rgba(90, 195, 255, 0.95) 6px, rgba(90, 195, 255, 0.95) 8px, transparent 8px); }

.TableCellResizer__handle--bottom {
  cursor: row-resize; }

.TableCellResizer__handle--dragging {
  cursor: col-resize; }

.TableCellResizer__guide, .TableCellResizer__hover-guide {
  position: fixed;
  z-index: 10001;
  pointer-events: none;
  background-color: rgba(90, 195, 255, 0.85); }

/* ==================================== */
/* ✅ Style pour l'insertion de tableau */
/* ==================================== */
.table-popup {
  position: absolute;
  background: #0c2637;
  width: max-content;
  padding: 10px;
  border: 1px solid #491212;
  border-radius: 6px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  z-index: 2000;
  transform: translate(0px, 5px); }

.table-popup h4 {
  margin: 0 0 10px;
  font-size: 14px; }

.table-popup label {
  display: flex;
  margin-bottom: 5px; }

.table-popup input {
  display: flex;
  width: 50px;
  margin-left: auto;
  margin-right: 5px; }

.table-popup button {
  margin-top: 10px;
  padding: 5px 10px;
  cursor: pointer;
  border: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-color: rgba(0, 51, 128, 0.2);
  background-blend-mode: multiply;
  color: #491212;
  border-radius: 3px; }

.table-popup button:hover {
  background-color: rgba(0, 51, 128, 0);
  color: #9e2222;
  text-decoration: none;
  filter: none; }

.table-popup button:last-child {
  background-color: #491212;
  color: #dfdfdf; }

.table-popup button:last-child:hover {
  border: none;
  color: white; }

/* Menu contextuel des cellules */
.table-action-button {
  position: absolute;
  background: #b8b8b8;
  border: none;
  height: 18px;
  width: 18px;
  padding: 3px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 10002;
  transition: opacity 0.2s;
  opacity: 0.7; }

.table-action-button:hover {
  opacity: 1; }

.table-context-menu {
  position: absolute;
  background: #0c2637;
  border: 1px solid #491212;
  padding: 7px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  z-index: 10002; }

.table-context-menu button {
  display: block;
  width: 100%;
  padding: 6px;
  border: none;
  color: #b8b8b8;
  background: #0c2637;
  text-align: left;
  cursor: pointer; }

.table-context-menu button:hover {
  color: #dfdfdf;
  background: #2a3847; }

/* Boutons pour ajouter une ligne ou une colonne */
.PlaygroundEditorTheme__tableAddRows,
.PlaygroundEditorTheme__tableAddColumns {
  position: absolute;
  background: #007bff;
  border: none;
  width: 20px;
  height: 20px;
  cursor: pointer;
  z-index: 1000; }

.PlaygroundEditorTheme__tableAddRows {
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%); }

.PlaygroundEditorTheme__tableAddColumns {
  right: -10px;
  top: 50%;
  transform: translateY(-50%); }

.table-hover-actions {
  position: absolute;
  z-index: 1000;
  pointer-events: auto; }

/* Boutons pour ajouter une ligne ou une colonne */
.table-hover-add-row,
.table-hover-add-column {
  background: #0c2637;
  border: none;
  color: #dfdfdf;
  height: 25px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5%;
  border: 1px solid #2a3847;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); }

.table-hover-add-row {
  width: 100%;
  /* Ajuste à la largeur du tableau */ }

.table-hover-add-column {
  writing-mode: vertical-lr;
  height: 100%;
  /* Ajuste à la hauteur du tableau */
  top: 20px; }

.table-hover-add-row {
  transform: translate(-50%, 0); }

.table-hover-add-column {
  transform: translate(0, -50%); }

/* ✅ La poignée de bloc (à gauche du texte) */
.draggable-block-menu {
  position: absolute;
  z-index: 1;
  opacity: var(--draggable-opacity, 0);
  left: var(--draggable-left, -10000px);
  top: var(--draggable-top, -10000px);
  pointer-events: auto;
  cursor: grab;
  transition: opacity 0.2s; }

.draggable-block-icon {
  display: block;
  opacity: 0.6;
  transition: opacity 0.2s; }

.draggable-block-menu:hover .draggable-block-icon {
  opacity: 1; }

.draggable-block-target-line {
  position: absolute;
  height: 4px;
  background-color: #2a3847;
  border-radius: 2px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s; }

.table-color-picker-wrapper {
  background: #0c2637;
  border: 1px solid #491212;
  border-radius: 6px;
  padding: 12px;
  transform: translate(45px, -18px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  width: 185px;
  z-index: 10002; }

/* ===================================== */
/* ✅ Style pour l'insertion de mention */
/* ===================================== */
/* LexicalTypeaheadMenuPlugin mounts popovers here — must clear Bootstrap modals (~1050). */
#typeahead-menu {
  z-index: 9999; }

/*  wrapper for the dropdown */
.typeahead-popover.mentions-menu {
  position: absolute;
  background: #0c2637;
  border: 1px solid #491212;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-height: 240px;
  /*  limit height */
  overflow-y: auto;
  /*  scroll if too tall */
  padding: 4px 0;
  /*  vertical padding */
  z-index: 9999; }

/*  remove default list styles */
.typeahead-popover.mentions-menu ul {
  list-style: none;
  margin: 0;
  padding: 0; }

/*  each mention row */
.typeahead-popover.mentions-menu li.item {
  display: flex;
  align-items: center;
  padding: 6px 12px;
  cursor: pointer;
  transition: background-color 0.2s ease; }

/*  hover and selected states */
.typeahead-popover.mentions-menu li.item:hover,
.typeahead-popover.mentions-menu li.item.selected {
  background-color: #2a3847; }

/*  avatar sizing */
.mention-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-right: 8px; }

.lexical-mention-group-badge {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #faa61a;
  margin-right: 8px;
  flex-shrink: 0; }

/*  username text */
.mentions-menu .text {
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; }

#typeahead-menu .typeahead-popover.mentions-menu {
  min-width: 200px !important; }

.typeahead-popover.mentions-menu.loot-menu {
  min-width: 240px; }
  .typeahead-popover.mentions-menu.loot-menu::-webkit-scrollbar {
    width: 6px; }
  .typeahead-popover.mentions-menu.loot-menu::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .typeahead-popover.mentions-menu.loot-menu::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .typeahead-popover.mentions-menu.loot-menu::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }
  .typeahead-popover.mentions-menu.loot-menu li.item.loot-item {
    align-items: flex-start; }
    .typeahead-popover.mentions-menu.loot-menu li.item.loot-item .loot-dd-col {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 2px;
      line-height: 1.25;
      min-width: 0; }
    .typeahead-popover.mentions-menu.loot-menu li.item.loot-item .benefits-loot-dd-label {
      font-size: 13px;
      color: rgba(255, 255, 255, 0.92);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 100%; }
    .typeahead-popover.mentions-menu.loot-menu li.item.loot-item .benefits-loot-dd-meta {
      font-size: 11px;
      color: rgba(255, 255, 255, 0.55);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 100%; }

.editor-input .lexical-sc-item-chip-decorator .sc-item-chip,
.lexical-sc-item-chip-root .lexical-sc-item-chip-decorator .sc-item-chip {
  vertical-align: middle;
  margin: 0 3px; }

.mention {
  background-color: rgba(3, 97, 149, 0.6);
  border-radius: 5px;
  padding: 4px 6px 4px 6px;
  margin-left: 5px; }
  .mention::before {
    content: "@";
    margin-right: 0.1em; }
  .mention:hover {
    background-color: rgba(38, 133, 184, 0.6); }
  .mention.mention--group {
    background-color: rgba(250, 166, 26, 0.25); }
    .mention.mention--group:hover {
      background-color: rgba(250, 166, 26, 0.35); }

/* =============================== */
/* ✅ Style pour Table of content */
/* =============================== */
.table-of-contents .heading2 {
  margin-left: 10px; }

.table-of-contents .heading3 {
  margin-left: 20px; }

.selected-heading {
  color: #3578e5;
  position: relative; }

.selected-heading-wrapper::before {
  content: ' ';
  position: absolute;
  display: inline-block;
  left: -30px;
  top: 4px;
  z-index: 10;
  height: 4px;
  width: 4px;
  background-color: #3578e5;
  border: solid 4px white;
  border-radius: 50%; }

.normal-heading {
  cursor: pointer;
  line-height: 20px;
  font-size: 16px; }

.lexical-side-panels {
  position: absolute !important;
  height: 0; }
  .lexical-side-panels .toc-container,
  .lexical-side-panels .emoji-container {
    position: sticky !important;
    height: 0; }

.emoji-container.emoji-offset {
  position: fixed !important;
  height: 0;
  transform: translateY(-1835px); }
  .emoji-container.emoji-offset .lexical-emoji-picker .emoji-grid {
    overflow: auto;
    height: 100px; }

.toc-container.toc-offset {
  position: fixed !important;
  height: 0; }
  .toc-container.toc-offset .table-of-contents .content .headings {
    min-height: 135px;
    max-height: 135px; }

.table-of-contents {
  position: absolute;
  color: #b8b8b8;
  background: #1c2d38;
  width: 250px;
  transform: translatex(-260px);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-radius: 10px;
  border: 1px solid #491212;
  border-bottom: 4px solid #491212;
  z-index: 1;
  box-shadow: 4px 5px 2px #4b050547; }
  .table-of-contents .header {
    background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    width: 100%;
    height: 34px;
    border-radius: 0px;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #2a3847; }
    .table-of-contents .header .header-title {
      text-transform: uppercase;
      font-size: 13px;
      width: 100%;
      color: #b8b8b8;
      margin-left: 5px;
      font-weight: bold; }
    .table-of-contents .header .content {
      font-size: 14px;
      width: 100%;
      color: #b8b8b8;
      margin-left: 5px;
      font-weight: bold; }
  .table-of-contents .options {
    height: 60px;
    background: #0c2637;
    border-bottom: 1px solid #491212;
    display: flex;
    margin-bottom: 0px;
    flex-direction: column;
    justify-content: space-evenly; }
    .table-of-contents .options .option-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0;
      margin: 5px 0px 0px 20px;
      width: 100%; }
      .table-of-contents .options .option-row .toggle-switch {
        color: #b8b8b8;
        justify-self: right;
        transform: translateX(-25px); }
      .table-of-contents .options .option-row span {
        color: #b8b8b8; }
      .table-of-contents .options .option-row input[type="checkbox"] {
        margin-right: 5px; }

.first-heading {
  color: black;
  font-weight: bold;
  cursor: pointer; }

.table-of-contents .headings {
  background-color: #163447;
  list-style: none;
  margin: 0;
  padding: 10px;
  height: calc(100% - 25px);
  max-height: none;
  overflow: auto; }
  .table-of-contents .headings::-webkit-scrollbar {
    width: 6px; }
  .table-of-contents .headings::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .table-of-contents .headings::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .table-of-contents .headings::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }
  .table-of-contents .headings .toc-h1 {
    color: white;
    font-size: 20px;
    font-weight: bolder;
    text-transform: uppercase;
    margin-bottom: 15px;
    font-family: GoodTimes; }
  .table-of-contents .headings .toc-h2 {
    font-size: 16px;
    font-weight: bolder;
    color: #dfdfdf;
    text-transform: capitalize;
    margin-top: -15px;
    margin-bottom: 15px;
    font-family: Lato; }
  .table-of-contents .headings .toc-h3 {
    font-size: 16px;
    font-weight: bolder;
    color: #dfdfdf;
    text-transform: uppercase;
    margin-top: 15px;
    margin-left: 0px;
    font-family: Lato;
    cursor: pointer; }
  .table-of-contents .headings .toc-h4 {
    font-size: 14px;
    font-weight: bold;
    color: #dfdfdf;
    text-transform: uppercase;
    margin-top: 5px;
    margin-left: 15px;
    margin-bottom: 5px;
    font-family: Lato;
    cursor: pointer; }
  .table-of-contents .headings .toc-h5 {
    font-size: 14px;
    font-weight: 300;
    color: #b8b8b8;
    text-transform: capitalize;
    margin-top: 5px;
    margin-left: 30px;
    margin-bottom: 5px;
    font-family: Lato;
    cursor: pointer; }
  .table-of-contents .headings .toc-h6 {
    font-size: 14px;
    font-weight: 100;
    color: #b8b8b8;
    text-transform: capitalize;
    margin-top: 5px;
    margin-left: 45px;
    margin-bottom: 5px;
    font-family: Lato;
    cursor: pointer; }

.with-heading-number::before {
  content: attr(data-heading-numbering) " ";
  font-weight: bold;
  margin-right: 0.2rem; }

/* Let .table-of-contents .headings keep @include scrollbar-styles (visible thumb). */
.headings::before {
  display: none; }

.normal-heading-wrapper {
  margin-left: 32px;
  position: relative; }

.image-align-left {
  display: flex !important;
  justify-content: left; }

.image-align-center {
  display: flex !important;
  justify-content: center; }

.image-align-right {
  display: flex !important;
  justify-content: right; }

.insert-image-dialog {
  position: fixed;
  display: flex;
  flex-direction: column;
  transform: translate(-65%, 3%);
  z-index: 1000;
  background-color: #0c2637;
  border: 1px solid #491212;
  border-radius: 6px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  padding: 10px;
  max-width: 420px;
  width: 100%; }
  .insert-image-dialog .insert-image-dialog__input {
    padding: 5px;
    color: #dfdfdf;
    background-color: #2a3847;
    border: 1px solid #b8b8b8;
    border-radius: 4px;
    font-size: 14px; }
  .insert-image-dialog .insert-image-dialog__field {
    display: flex;
    flex-direction: column;
    gap: 7px; }
  .insert-image-dialog .insert-image-dialog__dropzone {
    border: 2px dashed #b8b8b8;
    background-color: #2a3847;
    padding: 15px;
    margin: 0px 15px 5px;
    text-align: center;
    color: #dfdfdf;
    font-size: 14px;
    border-radius: 6px; }
  .insert-image-dialog .insert-image-dialog__toggle {
    display: flex;
    align-items: center;
    gap: 8px; }
  .insert-image-dialog .insert-image-dialog__actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px; }
    .insert-image-dialog .insert-image-dialog__actions .insert-image-dialog__btn {
      padding: 6px 12px;
      font-size: 14px;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      background-color: #007bff;
      color: white; }
      .insert-image-dialog .insert-image-dialog__actions .insert-image-dialog__btn:disabled {
        background-color: #ccc;
        cursor: not-allowed; }

.insert-video-dialog {
  position: fixed;
  display: flex;
  flex-direction: column;
  transform: translate(-65%, 3%);
  z-index: 1000;
  background-color: #0c2637;
  border: 1px solid #491212;
  border-radius: 6px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  padding: 10px;
  max-width: 420px;
  width: 100%;
  gap: 10px; }
  .insert-video-dialog .insert-video-dialog__input {
    padding: 5px;
    color: #dfdfdf;
    background-color: #2a3847;
    border: 1px solid #b8b8b8;
    border-radius: 4px;
    font-size: 14px; }
  .insert-video-dialog .insert-video-dialog__field {
    display: flex;
    flex-direction: column;
    gap: 7px; }
  .insert-video-dialog .insert-video-dialog__dropzone {
    border: 2px dashed #b8b8b8;
    background-color: #2a3847;
    padding: 20px;
    margin: 5px 20px;
    text-align: center;
    color: #dfdfdf;
    font-size: 14px;
    border-radius: 6px; }
  .insert-video-dialog .insert-video-dialog__toggle {
    display: flex;
    align-items: center;
    gap: 8px; }
  .insert-video-dialog .insert-video-dialog__actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px; }
    .insert-video-dialog .insert-video-dialog__actions .insert-video-dialog__btn {
      padding: 6px 12px;
      font-size: 14px;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      background-color: #007bff;
      color: white; }
      .insert-video-dialog .insert-video-dialog__actions .insert-video-dialog__btn:disabled {
        background-color: #ccc;
        cursor: not-allowed; }

img.focused {
  outline: 2px solid #2a3847;
  outline-offset: 2px; }

[data-lexical-decorator] {
  display: grid;
  vertical-align: top;
  line-height: 0;
  margin: 15px 0; }
  [data-lexical-decorator] > .image-container,
  [data-lexical-decorator] > figure.inline-left > .image-container,
  [data-lexical-decorator] > figure.inline-right > .image-container {
    position: relative;
    display: inline-block; }
    [data-lexical-decorator] > .image-container > div[draggable],
    [data-lexical-decorator] > figure.inline-left > .image-container > div[draggable],
    [data-lexical-decorator] > figure.inline-right > .image-container > div[draggable] {
      display: inline-block; }
    [data-lexical-decorator] > .image-container .image-resizer,
    [data-lexical-decorator] > figure.inline-left > .image-container .image-resizer,
    [data-lexical-decorator] > figure.inline-right > .image-container .image-resizer {
      position: absolute;
      width: 8px;
      height: 8px;
      background: #9e2222;
      border: 1px solid #2a3847;
      box-sizing: border-box;
      z-index: 10;
      pointer-events: all; }
    [data-lexical-decorator] > .image-container .image-resizer-n,
    [data-lexical-decorator] > figure.inline-left > .image-container .image-resizer-n,
    [data-lexical-decorator] > figure.inline-right > .image-container .image-resizer-n {
      top: -4px;
      left: 50%;
      transform: translateX(-50%);
      cursor: n-resize; }
    [data-lexical-decorator] > .image-container .image-resizer-s,
    [data-lexical-decorator] > figure.inline-left > .image-container .image-resizer-s,
    [data-lexical-decorator] > figure.inline-right > .image-container .image-resizer-s {
      bottom: -4px;
      left: 50%;
      transform: translateX(-50%);
      cursor: s-resize; }
    [data-lexical-decorator] > .image-container .image-resizer-w,
    [data-lexical-decorator] > figure.inline-left > .image-container .image-resizer-w,
    [data-lexical-decorator] > figure.inline-right > .image-container .image-resizer-w {
      left: -4px;
      top: 50%;
      transform: translateY(-50%);
      cursor: w-resize; }
    [data-lexical-decorator] > .image-container .image-resizer-e,
    [data-lexical-decorator] > figure.inline-left > .image-container .image-resizer-e,
    [data-lexical-decorator] > figure.inline-right > .image-container .image-resizer-e {
      right: -4px;
      top: 50%;
      transform: translateY(-50%);
      cursor: e-resize; }
    [data-lexical-decorator] > .image-container .image-resizer-nw,
    [data-lexical-decorator] > figure.inline-left > .image-container .image-resizer-nw,
    [data-lexical-decorator] > figure.inline-right > .image-container .image-resizer-nw {
      left: -4px;
      top: -4px;
      cursor: nw-resize; }
    [data-lexical-decorator] > .image-container .image-resizer-ne,
    [data-lexical-decorator] > figure.inline-left > .image-container .image-resizer-ne,
    [data-lexical-decorator] > figure.inline-right > .image-container .image-resizer-ne {
      right: -4px;
      top: -4px;
      cursor: ne-resize; }
    [data-lexical-decorator] > .image-container .image-resizer-sw,
    [data-lexical-decorator] > figure.inline-left > .image-container .image-resizer-sw,
    [data-lexical-decorator] > figure.inline-right > .image-container .image-resizer-sw {
      left: -4px;
      bottom: -4px;
      cursor: sw-resize; }
    [data-lexical-decorator] > .image-container .image-resizer-se,
    [data-lexical-decorator] > figure.inline-left > .image-container .image-resizer-se,
    [data-lexical-decorator] > figure.inline-right > .image-container .image-resizer-se {
      right: -4px;
      bottom: -4px;
      cursor: se-resize; }
    [data-lexical-decorator] > .image-container .image-caption-button,
    [data-lexical-decorator] > figure.inline-left > .image-container .image-caption-button,
    [data-lexical-decorator] > figure.inline-right > .image-container .image-caption-button {
      position: absolute;
      bottom: -15px;
      left: 50%;
      width: max-content;
      transform: translateX(-50%);
      margin: 0;
      pointer-events: all;
      z-index: 15;
      padding: 2px 6px;
      font-size: 0.65rem;
      border-radius: 4px;
      cursor: pointer; }
  [data-lexical-decorator] .image-caption-button {
    position: static;
    display: inline-block;
    margin: 4px auto 0;
    pointer-events: all;
    z-index: 15;
    padding: 2px 6px;
    font-size: 0.65rem;
    border-radius: 4px;
    cursor: pointer; }
  [data-lexical-decorator] .image-caption-placeholder {
    position: static;
    display: block;
    width: 100%;
    max-width: 100%;
    margin: 4px auto 0;
    pointer-events: all;
    z-index: 20;
    text-align: center;
    white-space: pre-wrap;
    word-break: break-word; }
  [data-lexical-decorator] .image-caption-input {
    display: block;
    position: relative;
    width: 100%;
    min-width: 125px;
    min-height: 1.5em;
    text-align: center;
    white-space: pre-wrap;
    word-break: break-word;
    margin: auto;
    padding: 6px;
    background: #2a3847;
    border: none;
    border-radius: 6px;
    color: #dfdfdf;
    line-height: 1.4em;
    resize: none;
    z-index: 9999; }
    [data-lexical-decorator] .image-caption-input .editor-paragraph {
      color: white; }
  [data-lexical-decorator] .image-container,
  [data-lexical-decorator] .image-caption-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: auto;
    margin-left: auto; }
    [data-lexical-decorator] .image-container.align-left,
    [data-lexical-decorator] .image-caption-container.align-left {
      margin: 0 auto 0 0; }
    [data-lexical-decorator] .image-container.align-center,
    [data-lexical-decorator] .image-caption-container.align-center {
      margin: 0 auto; }
    [data-lexical-decorator] .image-container.align-right,
    [data-lexical-decorator] .image-caption-container.align-right {
      margin: 0 0 0 auto; }
  [data-lexical-decorator] .image-caption-placeholder {
    position: relative;
    color: #b8b8b8;
    line-height: 1.4em;
    text-align: center;
    bottom: 35px;
    padding: 4px;
    border-radius: 4px;
    margin-bottom: -40px; }

.image-caption {
  font-size: large;
  color: #b8b8b8;
  padding: 5px;
  place-self: center;
  border: 1px solid #2a3847;
  border-radius: 8px; }

.editor-content [data-lexical-decorator] {
  display: inline; }

.lexical-decorator.inline-node {
  display: inline; }

/* emoji-inline needs its own box */
.lexical-decorator.emoji-node {
  display: inline-block;
  margin: 0px 2px; }

/* float à gauche, texte à droite */
.inline-left {
  float: left;
  margin: 0 1em 1em 0; }
  .inline-left.emoji {
    margin: 0; }

/* float à droite, texte à gauche */
.inline-right {
  float: right;
  margin: 0 0 1em 1em; }

/* légende sous l’image */
.inline-left figcaption,
.inline-right figcaption {
  display: block;
  text-align: center;
  margin-top: 0.5em;
  font-size: 0.9em;
  color: #666; }

/*  ensure the dialog select matches the inputs */
.insert-image-dialog__field select.insert-image-dialog__input {
  width: 100%;
  padding: 0.5em;
  border: 1px solid #ccc;
  border-radius: 4px; }

/*  you can tweak the dialog layout if needed */
.insert-image-dialog {
  max-width: 400px; }

.insert-image-dialog__field {
  margin-bottom: 1em; }

/* 3) Après chaque paragraphe, on vide le float pour éviter de contaminer le suivant */
.editor-content p::after {
  content: "";
  display: table;
  clear: both; }

.lexical-emoji-picker {
  position: absolute;
  color: #b8b8b8;
  background: #1c2d38;
  width: 250px;
  transform: translateX(-260px);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-radius: 10px;
  border: 1px solid #491212;
  border-bottom: 4px solid #491212;
  z-index: 1;
  box-shadow: 4px 5px 2px #4b050547; }
  .lexical-emoji-picker .emoji-header {
    background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    width: 100%;
    height: 34px;
    border-radius: 0px;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    display: flex;
    align-items: center;
    border-bottom: 2px solid #2a3847; }
    .lexical-emoji-picker .emoji-header .header-title {
      text-transform: uppercase;
      font-size: 0.85em;
      width: 100%;
      color: #b8b8b8;
      margin-left: 5px;
      font-weight: bold; }
  .lexical-emoji-picker .emoji-categories {
    display: flex;
    flex-wrap: wrap;
    height: fit-content;
    gap: 0 8px;
    padding-top: 10px;
    justify-content: center;
    background: #0c2637;
    border-bottom: 1px solid #491212; }
    .lexical-emoji-picker .emoji-categories .emoji-tab {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 4px 6px;
      border: none;
      background: none;
      cursor: pointer;
      border-radius: 4px;
      transition: background 0.2s; }
      .lexical-emoji-picker .emoji-categories .emoji-tab:hover {
        background: #2a3847; }
      .lexical-emoji-picker .emoji-categories .emoji-tab.active {
        background: #2a3847; }
      .lexical-emoji-picker .emoji-categories .emoji-tab .emoji-tab-icon {
        display: inline-block;
        width: 20px;
        height: 20px;
        color: #b8b8b8;
        transition: color 0.2s; }
        .lexical-emoji-picker .emoji-categories .emoji-tab .emoji-tab-icon svg {
          fill: #b8b8b8;
          width: 19px;
          height: 19px;
          transition: fill 0.2s; }
    .lexical-emoji-picker .emoji-categories .emoji-panel-search {
      margin: 10px 0; }
      .lexical-emoji-picker .emoji-categories .emoji-panel-search .emoji-search-input {
        padding: 6px 10px;
        border-radius: 6px; }
  .lexical-emoji-picker .emoji-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(32px, 1fr));
    gap: 2px;
    padding: 8px;
    max-height: max-content;
    background: #1c2d38;
    overflow-y: auto; }
    .lexical-emoji-picker .emoji-grid::-webkit-scrollbar {
      width: 6px; }
    .lexical-emoji-picker .emoji-grid::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .lexical-emoji-picker .emoji-grid::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .lexical-emoji-picker .emoji-grid::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
    .lexical-emoji-picker .emoji-grid .emoji-button {
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      background: none;
      font-size: 20px;
      cursor: pointer;
      border-radius: 4px;
      transition: background 0.2s; }
      .lexical-emoji-picker .emoji-grid .emoji-button:hover {
        background: #2a3847; }
      .lexical-emoji-picker .emoji-grid .emoji-button .emoji-img {
        width: 20px;
        height: 20px;
        object-fit: contain;
        display: block; }

.typeahead-popover.emoji-menu {
  position: absolute;
  z-index: 9999;
  max-height: 240px;
  background: #0c2637;
  border: 1px solid #491212;
  border-radius: 6px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 4px;
  padding: 4px 0; }
  .typeahead-popover.emoji-menu ul {
    list-style: none;
    margin: 0;
    padding: 0;
    max-height: 200px;
    border-radius: 6px;
    overflow-y: auto; }
    .typeahead-popover.emoji-menu ul::-webkit-scrollbar {
      width: 6px; }
    .typeahead-popover.emoji-menu ul::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .typeahead-popover.emoji-menu ul::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .typeahead-popover.emoji-menu ul::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
  .typeahead-popover.emoji-menu li {
    display: flex;
    align-items: center;
    padding: 0.5rem 1rem;
    cursor: pointer;
    transition: background 0.2s; }
    .typeahead-popover.emoji-menu li.selected, .typeahead-popover.emoji-menu li:hover {
      background: #2a3847; }
    .typeahead-popover.emoji-menu li .emoji-img {
      width: 1.2em;
      height: 1.2em;
      margin-right: 0.5rem; }
    .typeahead-popover.emoji-menu li .text {
      display: flex;
      flex-wrap: wrap;
      flex: 1;
      font-size: 0.9rem;
      color: #dfdfdf;
      width: 180px; }

.editor-content figure.emoji {
  float: none !important;
  display: inline-block;
  margin: 0 .25em; }
  .editor-content figure.emoji .image-container > div:nth-child(2) {
    display: none !important; }

.emoji-inner {
  height: 20px; }
  .emoji-inner img {
    height: 20px; }

.youtube-container.selected iframe {
  outline: 4px solid #2a3847; }

.youtube-container {
  display: flex; }
  .youtube-container.youtube-align-left {
    justify-content: flex-start; }
  .youtube-container.youtube-align-center {
    justify-content: center; }
  .youtube-container.youtube-align-right {
    justify-content: flex-end; }

.emoji-node .emoji-inner {
  display: inline-block;
  width: 1em;
  height: 1em;
  vertical-align: middle; }
  .emoji-node .emoji-inner img {
    height: 17px; }
  .emoji-node .emoji-inner img.draggable {
    cursor: default; }
  .emoji-node .emoji-inner img.focused {
    outline: none;
    outline-offset: 2px; }
  .emoji-node .emoji-inner .image-caption-button {
    display: none; }

.CommentPlugin_AddCommentBox {
  position: absolute;
  /* relative to .editor-container */
  right: -10px;
  /* a few px to the right of the editor’s outer (right) border */
  left: auto;
  width: 15px;
  height: 40px;
  padding: 5px 2px;
  /* bubble padding */
  border-radius: 15%;
  /* perfect circle */
  border: 3px solid #5ac3ff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  color: #000;
  background: linear-gradient(45deg, #5f5f5f 5%, #9c9b9b 10%, #949494 30%, #696969 60%, #949494 70%, #9c9b9b 80%, #5f5f5f 95%);
  z-index: 10;
  transform: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center; }
  .CommentPlugin_AddCommentBox:hover {
    background: linear-gradient(45deg, #5f5f5f 5%, #808080 10%, #7a7a7a 30%, #696969 60%, #7a7a7a 70%, #808080 80%, #5f5f5f 95%); }
  .CommentPlugin_AddCommentBox img {
    position: relative;
    vertical-align: -15px;
    width: 12px;
    left: 2px;
    filter: brightness(0) invert(80%); }

/*  show when plugin inserts the box into the DOM */
.CommentPlugin_AddCommentBox[data-visible="true"] {
  display: block; }

.PlaygroundEditorTheme__paragraph {
  position: relative;
  align-content: center;
  min-height: 2em;
  width: 170px;
  padding: 5px 10px;
  z-index: 1000; }

.CommentPlugin_CommentsWrapper {
  position: absolute;
  transform: translateX(265px);
  right: 0;
  top: 0;
  z-index: 20000; }

.CommentPlugin_CommentsPanel_DeletedComment {
  color: #b8b8b8;
  text-decoration: dashed;
  margin-bottom: 10px; }

.CommentPlugin_CommentsPanel {
  position: relative;
  width: 257px;
  color: #dfdfdf;
  background-color: #1c2d38;
  border: 1px solid #491212;
  border-bottom: 4px solid #491212;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  z-index: 1000; }
  .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_Heading {
    display: flex;
    background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    width: 100%;
    height: 34px;
    font-size: 13px;
    font-weight: bold;
    border-radius: 0px;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    text-transform: uppercase;
    width: 100%;
    color: #b8b8b8;
    align-items: center;
    padding: 0 10px;
    border-bottom: 2px solid #2a3847; }
  .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List {
    display: flex;
    flex-direction: column;
    font-size: 15px;
    font-weight: normal;
    padding: 10px 0px 0px 10px;
    max-height: fit-content;
    overflow: scroll;
    list-style-type: none; }
    .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List::-webkit-scrollbar {
      width: 6px; }
    .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
    .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List .CommentPlugin_CommentsPanel_List_Thread {
      background-color: #1c2d38;
      border-radius: 8px 8px 0px 0;
      width: fit-content; }
      .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List .CommentPlugin_CommentsPanel_List_Thread.active .CommentPlugin_CommentsPanel_List_Thread_QuoteBox {
        border: 1px solid #6a4900;
        border-bottom: none;
        border-radius: 8px 8px 0px 0;
        background: #6a4900; }
      .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List .CommentPlugin_CommentsPanel_List_Thread.active .CommentPlugin_CommentsPanel_List_Thread_Comments {
        padding-inline-start: 0px;
        background: #163447; }
        .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List .CommentPlugin_CommentsPanel_List_Thread.active .CommentPlugin_CommentsPanel_List_Thread_Comments .CommentPlugin_CommentsPanel_List_Comment {
          border-top: 4px solid #6a4900;
          border-left: 5px solid #6a4900;
          border-right: 2px solid #6a4900; }
          .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List .CommentPlugin_CommentsPanel_List_Thread.active .CommentPlugin_CommentsPanel_List_Thread_Comments .CommentPlugin_CommentsPanel_List_Comment.main-comment {
            background: #1c2d38; }
      .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List .CommentPlugin_CommentsPanel_List_Thread.active .CommentPlugin_CommentsPanel_List_Thread_Editor {
        border-top: none; }
        .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List .CommentPlugin_CommentsPanel_List_Thread.active .CommentPlugin_CommentsPanel_List_Thread_Editor .CommentPlugin_CommentInputBox_EditorContainer {
          bottom: 5px;
          border-top: 4px solid #6a4900;
          border: 5px solid #6a4900;
          border-right: 2px solid #6a4900;
          border-top: none;
          border-radius: 0 0 6px 6px; }
      .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List .CommentPlugin_CommentsPanel_List_Thread.comment_not_found .CommentPlugin_CommentsPanel_List_Thread_QuoteBox {
        border: 1px solid #491212;
        background: #491212; }
      .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List .CommentPlugin_CommentsPanel_List_Thread.comment_not_found .CommentPlugin_CommentsPanel_List_Thread_Comments {
        background: #163447;
        padding-inline-start: 0px; }
        .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List .CommentPlugin_CommentsPanel_List_Thread.comment_not_found .CommentPlugin_CommentsPanel_List_Thread_Comments .CommentPlugin_CommentsPanel_List_Comment {
          border-left: 5px solid #491212;
          border-right: 2px solid #491212; }
      .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List .CommentPlugin_CommentsPanel_List_Thread.comment_not_found .CommentPlugin_CommentsPanel_List_Thread_Editor .CommentPlugin_CommentInputBox_EditorContainer {
        border: 5px solid #491212;
        border-right: 2px solid #491212;
        border-top: none; }
      .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List .CommentPlugin_CommentsPanel_List_Thread .CommentPlugin_CommentsPanel_List_Thread_QuoteBox {
        display: flex;
        color: #dfdfdf;
        background: #0c2637;
        border: 1px solid #0c2637;
        border-bottom: none;
        border-radius: 8px 8px 0px 0;
        padding: 5px 0px;
        width: 224px; }
        .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List .CommentPlugin_CommentsPanel_List_Thread .CommentPlugin_CommentsPanel_List_Thread_QuoteBox .CommentPlugin_CommentsPanel_List_Thread_Quote {
          font-weight: bold;
          margin-block-start: 3px;
          margin-block-end: 0px;
          margin-inline-start: 10px;
          margin-inline-end: 10px; }
        .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List .CommentPlugin_CommentsPanel_List_Thread .CommentPlugin_CommentsPanel_List_Thread_QuoteBox .CommentPlugin_CommentsPanel_List_DeleteButton {
          opacity: 0.2;
          position: relative;
          background: none;
          align-self: flex-start;
          bottom: 0px;
          margin: 0px 0px 0 auto;
          filter: brightness(0) invert(80%);
          border: none;
          cursor: pointer; }
          .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List .CommentPlugin_CommentsPanel_List_Thread .CommentPlugin_CommentsPanel_List_Thread_QuoteBox .CommentPlugin_CommentsPanel_List_DeleteButton:hover {
            opacity: 1; }
      .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List .CommentPlugin_CommentsPanel_List_Thread.CommentPlugin_CommentsPanel_List_Thread_Quote {
        margin-block-start: 0px;
        margin-block-end: 0px;
        margin-inline-start: 10px;
        margin-inline-end: 0px; }
      .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List .CommentPlugin_CommentsPanel_List_Thread .CommentPlugin_CommentsPanel_List_Thread_Comments {
        display: flex;
        background: #163447;
        flex-direction: column;
        padding-inline-start: 0px;
        list-style-type: none;
        width: 226px; }
        .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List .CommentPlugin_CommentsPanel_List_Thread .CommentPlugin_CommentsPanel_List_Thread_Comments .CommentPlugin_CommentsPanel_List_Comment {
          display: flex;
          flex-direction: column;
          border-top: 4px solid #0c2637;
          border-left: 5px solid #0c2637;
          border-right: 2px solid #0c2637;
          padding: 6px; }
          .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List .CommentPlugin_CommentsPanel_List_Thread .CommentPlugin_CommentsPanel_List_Thread_Comments .CommentPlugin_CommentsPanel_List_Comment p {
            color: #dfdfdf; }
            .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List .CommentPlugin_CommentsPanel_List_Thread .CommentPlugin_CommentsPanel_List_Thread_Comments .CommentPlugin_CommentsPanel_List_Comment p span {
              user-select: text !important; }
          .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List .CommentPlugin_CommentsPanel_List_Thread .CommentPlugin_CommentsPanel_List_Thread_Comments .CommentPlugin_CommentsPanel_List_Comment.main-comment {
            background: #1c2d38; }
          .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List .CommentPlugin_CommentsPanel_List_Thread .CommentPlugin_CommentsPanel_List_Thread_Comments .CommentPlugin_CommentsPanel_List_Comment .CommentPlugin_CommentsPanel_DeletedComment {
            color: #491212;
            text-decoration: dashed;
            margin-bottom: 10px; }
        .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List .CommentPlugin_CommentsPanel_List_Thread .CommentPlugin_CommentsPanel_List_Thread_Comments .CommentPlugin_CommentsPanel_List_DeleteButton {
          opacity: 0.2;
          position: relative;
          background: none;
          align-self: flex-start;
          bottom: 15px;
          margin: 0px 0px 0 auto;
          filter: brightness(0) invert(80%);
          border: none;
          cursor: pointer; }
          .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List .CommentPlugin_CommentsPanel_List_Thread .CommentPlugin_CommentsPanel_List_Thread_Comments .CommentPlugin_CommentsPanel_List_DeleteButton:hover {
            opacity: 1; }
      .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List .CommentPlugin_CommentsPanel_List_Thread .CommentPlugin_CommentsPanel_List_Thread_Editor {
        display: flex;
        flex-direction: row;
        margin-bottom: -15px; }
        .CommentPlugin_CommentsPanel .CommentPlugin_CommentsPanel_List .CommentPlugin_CommentsPanel_List_Thread .CommentPlugin_CommentsPanel_List_Thread_Editor .CommentPlugin_CommentsPanel_SendButton {
          position: relative;
          background: none;
          margin: auto;
          filter: brightness(0) invert(80%);
          transform: translate(187px, -43px);
          border: none;
          cursor: pointer;
          z-index: 2000; }

.CommentPlugin_CommentInputBox_EditorContainer {
  background: #163447;
  border: 5px solid #0c2637;
  border-right: 2px solid #0c2637;
  border-top: none;
  border-radius: 0 0 6px 6px;
  position: relative;
  bottom: 5px;
  width: 219px; }
  .CommentPlugin_CommentInputBox_EditorContainer .CommentPlugin_CommentsPanel_Editor {
    background: #1c2d38;
    border: 1px solid #b8b8b8;
    border-radius: 6px;
    line-height: 1.5em;
    max-height: fit-content;
    margin: 5px;
    z-index: 500; }
  .CommentPlugin_CommentInputBox_EditorContainer .ContentEditable__placeholder {
    position: relative;
    height: 0px;
    left: 15px;
    bottom: 35px;
    z-index: 10; }

.CommentPlugin_CommentsPanel_List_Details {
  display: flex;
  flex-direction: column; }
  .CommentPlugin_CommentsPanel_List_Details .CommentPlugin_CommentsPanel_List_Comment_Author {
    color: #dfdfdf;
    font-weight: bold; }

.lexical_comments_modal__overlay {
  position: fixed;
  left: 50%;
  top: 50%;
  height: 200px;
  /* Above Bootstrap modals (~1055) so comment input is visible when editor is in a dialog */
  z-index: 10600; }
  .lexical_comments_modal__overlay .Modal__modal {
    border: 1px solid #491212;
    border-bottom: 4px solid #491212;
    background: #2a3847;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px; }
    .lexical_comments_modal__overlay .Modal__modal .Modal__title {
      display: flex;
      background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      height: 34px;
      font-size: 13px;
      font-weight: bold;
      border-radius: 0px;
      border-top-right-radius: 10px;
      border-top-left-radius: 10px;
      text-transform: uppercase;
      color: #b8b8b8;
      align-items: center;
      padding: 0 10px;
      border-bottom: 2px solid #2a3847; }
    .lexical_comments_modal__overlay .Modal__modal .Modal__content {
      display: table;
      margin: auto;
      color: #dfdfdf;
      background: #2a3847;
      padding: 7px; }
      .lexical_comments_modal__overlay .Modal__modal .Modal__content .CommentPlugin_SideModal {
        margin: auto; }
        .lexical_comments_modal__overlay .Modal__modal .Modal__content .CommentPlugin_SideModal .CommentPlugin_CommentInputBox_EditorContainer {
          border: 1px solid #b8b8b8;
          border-radius: 6px;
          min-height: min-content;
          max-height: max-content; }
        .lexical_comments_modal__overlay .Modal__modal .Modal__content .CommentPlugin_SideModal .CommentPlugin_CommentInputBox_Buttons {
          text-align: center;
          margin: 10px auto 5px auto; }
      .lexical_comments_modal__overlay .Modal__modal .Modal__content .override-deletion {
        background-color: #9e2222;
        color: #dfdfdf;
        text-transform: uppercase;
        font-weight: bold; }

.PlaygroundEditorTheme__ltr mark {
  color: #b8b8b8;
  background-color: #6a480062 !important; }
  .PlaygroundEditorTheme__ltr mark.selected {
    color: #dfdfdf;
    background-color: #6a4900 !important; }

mark.PlaygroundEditorTheme__ltr {
  color: #b8b8b8;
  background-color: #6a480062; }
  mark.PlaygroundEditorTheme__ltr.selected {
    color: #dfdfdf;
    background-color: #6a4900; }

mark.PlaygroundEditorTheme__ltr {
  background-color: #6a480062; }

mark.PlaygroundEditorTheme__ltr.selected {
  background-color: #6a4900; }

.CommentPlugin_CommentsPanel_header {
  font-size: 14px;
  /*  header font size */
  font-weight: bold;
  /*  bold title */
  margin-bottom: 8px;
  /*  space below header */ }

.CommentPlugin_CommentList {
  list-style: none;
  /*  remove default bullets */
  margin: 0;
  padding: 0; }

.CommentPlugin_CommentItem {
  display: flex;
  /*  flex layout */
  align-items: flex-start;
  margin-bottom: 12px;
  /*  space between comments */ }

.CommentPlugin_CommentAvatar {
  width: 32px;
  /*  avatar size */
  height: 32px;
  border-radius: 50%;
  /*  circular avatar */
  background-color: #eee;
  /*  placeholder background */
  margin-right: 8px;
  /*  space to text */ }

.CommentPlugin_CommentContent {
  flex: 1;
  /*  take remaining space */ }

.CommentPlugin_CommentAuthor {
  font-size: 12px;
  /*  author name size */
  font-weight: 600;
  /*  slightly bold */
  margin-bottom: 4px;
  /*  space below name */ }

.CommentPlugin_CommentText {
  font-size: 14px;
  /*  comment text size */
  line-height: 1.4; }

/* icône creuse (outline) */
.comment-icon-outline {
  fill: none;
  stroke: currentColor; }

/* icône pleine en vert */
.comment-icon-filled {
  fill: #22c55e;
  /* ou toute autre couleur verte */
  stroke: none; }
  .comment-icon-filled:hover {
    fill: #00ff5e; }

/* facultatif : si vous voulez changer la couleur de l’outline */
.comments .comment-icon-outline {
  stroke: currentColor;
  /* hérite de la couleur du parent */ }

.modal-content.lexical-save-modal .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(to top, #491212, #5e2f2fd3, #491212);
  padding: 5px 0px 5px 10px;
  color: #dfdfdf;
  font-size: medium;
  font-weight: bold;
  text-transform: uppercase;
  border-bottom: 3px solid #b8b8b8;
  border-radius: 8px 8px 0px 0px; }
  .modal-content.lexical-save-modal .header .lexical-save-modal-h3 {
    margin: 0;
    font-size: small; }
  .modal-content.lexical-save-modal .header .icon {
    display: flex;
    height: 18px;
    overflow: hidden;
    margin-left: auto;
    margin-right: 0; }
    .modal-content.lexical-save-modal .header .icon .close-event-button {
      position: relative;
      height: 40px;
      margin-right: 10px;
      object-fit: contain;
      overflow: hidden;
      cursor: pointer; }
      .modal-content.lexical-save-modal .header .icon .close-event-button:hover {
        top: -21px; }

.modal-content.lexical-save-modal .content {
  padding: 15px;
  width: auto;
  background: #163447;
  align-content: center; }
  .modal-content.lexical-save-modal .content .lexical-save-mode-toggle {
    display: flex;
    justify-content: center;
    gap: 10px;
    position: relative;
    margin: 5px; }
  .modal-content.lexical-save-modal .content .lexical-save-live-section {
    position: relative; }
    .modal-content.lexical-save-modal .content .lexical-save-live-section .version-description {
      width: 430px;
      text-align: justify;
      padding: 10px 0; }
    .modal-content.lexical-save-modal .content .lexical-save-live-section .lexical-save-modal-button {
      position: relative;
      display: flex;
      margin: auto; }
  .modal-content.lexical-save-modal .content .lexical-save-review-section .lexical-save-description,
  .modal-content.lexical-save-modal .content .lexical-save-live-section .lexical-save-description {
    width: 430px;
    text-align: justify;
    padding: 10px 0; }
  .modal-content.lexical-save-modal .content .lexical-save-review-section .lexical-save-fieldset,
  .modal-content.lexical-save-modal .content .lexical-save-live-section .lexical-save-fieldset {
    display: flex;
    justify-content: center;
    gap: 10px; }

/* 1) Pour centrer au milieu de l’écran, vous pouvez faire : 
.lexical-save-dialog {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh; 
}
  */
/* 2) Si vous préférez centrer le .modal-content via position+transform : 
.lexical-save-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
 */
.lexical-versioning-bar {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  gap: 12px;
  width: 100%;
  margin: 5px 0;
  padding: 10px;
  box-sizing: border-box;
  background: #172738;
  border: 1px solid #491212;
  border-radius: 8px;
  color: #dfdfdf;
  font-family: 'Lato', sans-serif; }

.lexical-versioning-bar--loading {
  align-items: center;
  min-height: 36px; }

.lexical-versioning-bar__loading-text {
  font-size: 12px;
  color: #b8b8b8; }

.lexical-versioning-bar__main {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  flex: 1;
  min-width: 0;
  gap: 0; }

.lexical-versioning-bar__toggle {
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #384858; }

.lexical-versioning-bar__mode {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 4px 10px;
  margin: 0;
  border: none;
  background: #2a3847;
  color: #dfdfdf;
  cursor: pointer;
  text-align: left;
  min-width: 0;
  transition: background 0.15s ease, border-color 0.15s ease; }
  .lexical-versioning-bar__mode:disabled {
    opacity: 0.45;
    cursor: not-allowed; }
  .lexical-versioning-bar__mode:not(:disabled):hover {
    background: #384858; }

.lexical-versioning-bar__mode--live {
  border-right: 1px solid #384858; }

.lexical-versioning-bar__mode--live.lexical-versioning-bar__mode--active {
  background: #1c2d38;
  border-radius: 6px;
  box-shadow: inset 0 0 0 1px #5aa05c; }
  .lexical-versioning-bar__mode--live.lexical-versioning-bar__mode--active .lexical-versioning-bar__mode-title {
    color: #5aa05c; }

.lexical-versioning-bar__mode--archive.lexical-versioning-bar__mode--active {
  background: #1c2d38;
  border-radius: 6px;
  box-shadow: inset 0 0 0 1px #9b602a; }
  .lexical-versioning-bar__mode--archive.lexical-versioning-bar__mode--active .lexical-versioning-bar__mode-title {
    color: #9b602a; }

.lexical-versioning-bar__mode-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 22px;
  height: 22px; }

.lexical-versioning-bar__svg-icon {
  width: 18px;
  height: 18px;
  color: #b8b8b8; }

.lexical-versioning-bar__svg-icon--collab {
  color: #5aa05c; }

.lexical-versioning-bar__mode--archive.lexical-versioning-bar__mode--active .lexical-versioning-bar__svg-icon {
  color: #9b602a; }

.lexical-versioning-bar__mode--live.lexical-versioning-bar__mode--active .lexical-versioning-bar__svg-icon {
  color: #5aa05c; }

.lexical-versioning-bar__switch {
  display: block;
  width: 30px;
  height: 17px;
  border-radius: 9px;
  background: #384858;
  position: relative; }
  .lexical-versioning-bar__switch::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #b8b8b8;
    transition: transform 0.15s ease, background 0.15s ease; }

.lexical-versioning-bar__switch--on {
  background: #3f7c42; }
  .lexical-versioning-bar__switch--on::after {
    transform: translateX(13px);
    background: #c2f0c3; }

.lexical-versioning-bar__mode-title {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  min-width: 0;
  line-height: 1.2; }

.lexical-versioning-bar__divider {
  width: 1px;
  align-self: stretch;
  margin: 2px 10px;
  background: #384858;
  flex-shrink: 0; }

.lexical-versioning-bar__dropdown-wrap {
  position: relative;
  flex: 1 1 0%;
  min-width: 120px;
  max-width: 100%; }

.lexical-versioning-bar__dropdown-trigger {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: 100%;
  min-height: 0;
  padding: 4px 10px;
  box-sizing: border-box;
  border: 1px solid #384858;
  border-radius: 6px;
  background: #2a3847;
  color: #dfdfdf;
  cursor: pointer;
  text-align: left;
  font-size: 12px; }
  .lexical-versioning-bar__dropdown-trigger:disabled {
    opacity: 0.5;
    cursor: not-allowed; }
  .lexical-versioning-bar__dropdown-trigger:not(:disabled):hover {
    border-color: #747b81;
    background: #384858; }

.lexical-versioning-bar__dropdown-calendar {
  width: 17px;
  height: 17px;
  flex-shrink: 0;
  color: #b8b8b8; }

.lexical-versioning-bar__dropdown-label {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  overflow: hidden; }

.lexical-versioning-bar__version-line {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  min-width: 0; }

.lexical-versioning-bar__version-line--compact .lexical-versioning-bar__version-sep {
  margin-left: 15px;
  margin-right: 15px; }

.lexical-versioning-bar__version-date {
  flex: 1 1 5%;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.lexical-versioning-bar__version-semver {
  flex: 0 0 auto;
  white-space: nowrap;
  padding: 0 2px; }

.lexical-versioning-bar__version-author {
  flex: 1 1 30%;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.lexical-versioning-bar__version-sep {
  flex: 0 0 auto;
  width: 1px;
  align-self: stretch;
  min-height: 16px;
  margin-left: 16px;
  margin-right: 16px;
  background: #747b81;
  opacity: 0.85; }

.lexical-versioning-bar__dropdown-chevron {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  color: #b8b8b8; }

.lexical-versioning-bar__dropdown-panel {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 4px);
  z-index: 100000;
  max-height: 280px;
  overflow-y: auto;
  padding: 6px 0;
  background: #1c2d38;
  border: 1px solid #384858;
  border-radius: 6px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35); }
  .lexical-versioning-bar__dropdown-panel::-webkit-scrollbar {
    width: 6px; }
  .lexical-versioning-bar__dropdown-panel::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .lexical-versioning-bar__dropdown-panel::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .lexical-versioning-bar__dropdown-panel::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }

.lexical-versioning-bar__dropdown-option {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 14px;
  margin: 0;
  border: none;
  background: transparent;
  color: #dfdfdf;
  font-size: 13px;
  text-align: left;
  cursor: pointer; }
  .lexical-versioning-bar__dropdown-option:hover {
    background: #2a3847; }

.lexical-versioning-bar__dropdown-option--selected {
  color: #c78445; }
  .lexical-versioning-bar__dropdown-option--selected:hover {
    background: #2a3847; }
  .lexical-versioning-bar__dropdown-option--selected .lexical-versioning-bar__version-sep {
    background: currentColor;
    opacity: 0.35; }

.lexical-versioning-bar__option-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  background: #747b81; }

.lexical-versioning-bar__option-dot--selected {
  background: #c78445; }

.lexical-versioning-bar__option-label {
  display: flex;
  flex: 1;
  min-width: 0;
  align-items: center;
  line-height: 1.35; }

.lexical-versioning-bar__dropdown-more {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: stretch;
  margin: 4px 8px 0;
  padding: 10px 8px;
  box-sizing: border-box;
  border: none;
  border-top: 1px solid #384858;
  background: transparent;
  color: #b8b8b8;
  font-size: 12px;
  cursor: pointer;
  text-align: left; }
  .lexical-versioning-bar__dropdown-more:hover {
    color: #d8b493; }

.lexical-versioning-bar__dropdown-more-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: inherit; }

.lexical-emoji {
  display: inline-block;
  float: none;
  padding: 1px;
  vertical-align: bottom; }
  .lexical-emoji img {
    height: 20px;
    width: auto;
    vertical-align: bottom; }

/*  make inline wrapper float and give some margin */
.lexical-inline-left {
  float: left;
  margin: 0 3em 0 0; }

.lexical-inline-right {
  float: right;
  margin: 0 0 0 3em; }

/*  ensure the wrapper takes only the width of the image */
.lexical-inline-left,
.lexical-inline-right {
  display: inline-block; }

/*  images should be responsive within their wrapper */
.lexical-inline-left img,
.lexical-inline-right img {
  max-width: 100%;
  height: auto; }

/*  clear floats after paragraphs if needed */
.editor-paragraph::after {
  content: "";
  display: block;
  clear: both; }

.lexical-image-left {
  float: left;
  margin: 0 1em 1em 0; }

.lexical-image-right {
  float: right;
  margin: 0 0 1em 1em; }

.lexical-image-center {
  text-align: center;
  margin: 1em 0; }

.lexical-image-left img,
.lexical-image-right img {
  max-width: 100%;
  height: auto; }

.lexical-image-center img {
  display: inline-block;
  max-width: 100%;
  height: auto; }

.lexical-image-left a,
.lexical-image-right a,
.lexical-image-center a,
.lexical-inline-left a,
.lexical-inline-right a {
  display: inline-block;
  max-width: 100%;
  text-decoration: none;
  color: inherit; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.chat-mention-input-wrapper {
  position: relative;
  width: 100%;
  border: 1px solid #004872;
  background: #2a3847;
  border-radius: 6px; }
  .chat-mention-input-wrapper .message-input {
    background: #163447;
    width: 100%;
    padding: 8px;
    font-size: 14px;
    box-sizing: border-box; }
    .chat-mention-input-wrapper .message-input:focus {
      outline: none;
      box-shadow: none; }
    .chat-mention-input-wrapper .message-input:focus-visible {
      border: none; }
  .chat-mention-input-wrapper .mention-dropdown {
    position: absolute;
    margin: 0;
    padding: 0;
    list-style: none;
    background: #163447;
    border: 1px solid #004872;
    border-radius: 4px;
    box-sizing: border-box;
    min-width: 0;
    max-height: 200px;
    overflow-y: auto;
    z-index: 9999; }
    .chat-mention-input-wrapper .mention-dropdown .dropdown-item {
      display: flex;
      align-items: center;
      padding: 4px 8px;
      cursor: pointer; }
      .chat-mention-input-wrapper .mention-dropdown .dropdown-item.selected {
        background-color: #00304d; }
      .chat-mention-input-wrapper .mention-dropdown .dropdown-item .mention-avatar {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-right: 8px; }
      .chat-mention-input-wrapper .mention-dropdown .dropdown-item .mention-dropdown__profile-chip {
        margin-right: 8px;
        flex-shrink: 1;
        min-width: 0;
        max-width: 100%; }
        .chat-mention-input-wrapper .mention-dropdown .dropdown-item .mention-dropdown__profile-chip .user-discord-rank__avatar {
          width: 20px;
          height: 20px; }
        .chat-mention-input-wrapper .mention-dropdown .dropdown-item .mention-dropdown__profile-chip .user-discord-rank__rank-icon {
          display: none; }
        .chat-mention-input-wrapper .mention-dropdown .dropdown-item .mention-dropdown__profile-chip .user-discord-rank__name {
          font-size: 14px; }
      .chat-mention-input-wrapper .mention-dropdown .dropdown-item .mention-name {
        font-size: 14px; }
      .chat-mention-input-wrapper .mention-dropdown .dropdown-item.dropdown-item--game {
        align-items: flex-start; }
        .chat-mention-input-wrapper .mention-dropdown .dropdown-item.dropdown-item--game .chat-game-entity-suggest-thumb {
          width: 36px;
          height: 36px;
          border-radius: 4px;
          object-fit: cover;
          margin-right: 8px;
          flex-shrink: 0; }
          .chat-mention-input-wrapper .mention-dropdown .dropdown-item.dropdown-item--game .chat-game-entity-suggest-thumb--empty {
            display: inline-block;
            background: #1e3042; }
        .chat-mention-input-wrapper .mention-dropdown .dropdown-item.dropdown-item--game .mention-name {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 2px;
          line-height: 1.2; }
        .chat-mention-input-wrapper .mention-dropdown .dropdown-item.dropdown-item--game .chat-game-entity-suggest-label {
          font-weight: 600; }
        .chat-mention-input-wrapper .mention-dropdown .dropdown-item.dropdown-item--game .chat-game-entity-suggest-sub {
          font-size: 11px;
          color: #b5bac1; }
      .chat-mention-input-wrapper .mention-dropdown .dropdown-item.dropdown-item--loot {
        align-items: flex-start; }
        .chat-mention-input-wrapper .mention-dropdown .dropdown-item.dropdown-item--loot .mention-name {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 2px;
          line-height: 1.25;
          min-width: 0; }
        .chat-mention-input-wrapper .mention-dropdown .dropdown-item.dropdown-item--loot .benefits-loot-dd-label {
          font-size: 13px;
          color: rgba(255, 255, 255, 0.92);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 100%; }
        .chat-mention-input-wrapper .mention-dropdown .dropdown-item.dropdown-item--loot .benefits-loot-dd-meta {
          font-size: 11px;
          color: rgba(255, 255, 255, 0.55);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 100%; }
      .chat-mention-input-wrapper .mention-dropdown .dropdown-item.dropdown-item--group {
        gap: 8px; }
        .chat-mention-input-wrapper .mention-dropdown .dropdown-item.dropdown-item--group .mention-dropdown__group-badge {
          font-size: 10px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.04em;
          color: #faa61a;
          flex-shrink: 0; }
        .chat-mention-input-wrapper .mention-dropdown .dropdown-item.dropdown-item--group .mention-dropdown__group-name {
          font-size: 14px;
          font-weight: 600;
          color: #dcddde; }

/* Pour ChatRoom */
.chat-container {
  margin: 10px 0 0 0; }
  .chat-container .chat-unified-frame {
    display: flex;
    flex-direction: column;
    width: 100%;
    border-radius: 10px;
    border: 1px solid #491212;
    border-bottom: 4px solid #491212;
    box-shadow: 4px 5px 2px #4b050547;
    overflow: hidden; }
  .chat-container .chat-unified-header {
    display: flex;
    justify-content: space-between;
    color: #dfdfdf;
    text-transform: uppercase;
    font-weight: bold;
    align-items: center;
    padding: 5px 10px;
    border-bottom: 2px solid #2a3847;
    border-radius: 8px 8px 0px 0px;
    background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    border-radius: 8px 8px 0 0;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 3px 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.25); }
    .chat-container .chat-unified-header .room-name {
      margin: 0;
      font-size: small;
      text-transform: uppercase;
      color: #b8b8b8; }
    .chat-container .chat-unified-header .chat-unified-online-toggle {
      flex-shrink: 0;
      margin: 0;
      padding: 2px 10px;
      font-size: small;
      text-transform: uppercase;
      color: #b8b8b8;
      background: rgba(0, 0, 0, 0.25);
      border: 1px solid rgba(255, 255, 255, 0.12);
      border-radius: 4px;
      cursor: pointer;
      font-family: inherit; }
      .chat-container .chat-unified-header .chat-unified-online-toggle:hover {
        background: rgba(0, 0, 0, 0.4);
        border-color: rgba(255, 255, 255, 0.2); }
  .chat-container .chat-unified-body {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    min-height: 380px;
    max-height: 440px;
    background: #172738; }
  .chat-container .chat-unified-body--single {
    max-height: none; }
    .chat-container .chat-unified-body--single .chat-wrapper {
      flex: 1;
      width: 100%; }
  .chat-container .chat-wrapper {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
    min-height: 0; }
    .chat-container .chat-wrapper.chat-wrapper--with-thread-panel {
      position: relative; }
    .chat-container .chat-wrapper.hidden {
      display: none; }
    .chat-container .chat-wrapper .messages-list {
      flex: 1;
      min-height: 0;
      overflow-y: auto;
      padding: 8px; }
      .chat-container .chat-wrapper .messages-list::-webkit-scrollbar {
        width: 6px; }
      .chat-container .chat-wrapper .messages-list::-webkit-scrollbar-track {
        background: #2e3842;
        border-radius: 4px;
        padding-right: 1px; }
      .chat-container .chat-wrapper .messages-list::-webkit-scrollbar-thumb {
        background-color: #491212;
        border-radius: 4px; }
        .chat-container .chat-wrapper .messages-list::-webkit-scrollbar-thumb:hover {
          background-color: #200808; }
    .chat-container .chat-wrapper .message-item {
      padding: 8px 6px 8px 5px; }
      .chat-container .chat-wrapper .message-item .message-header {
        display: flex;
        align-items: center;
        margin-bottom: 4px;
        gap: 10px;
        min-width: 0; }
        .chat-container .chat-wrapper .message-item .message-header .message-header__identity {
          flex: 0 1 auto;
          min-width: 0; }
          .chat-container .chat-wrapper .message-item .message-header .message-header__identity .user-discord-rank__name {
            color: #afa991;
            font-size: 14px;
            font-weight: bold; }
        .chat-container .chat-wrapper .message-item .message-header .message-meta {
          display: flex;
          flex-shrink: 0;
          gap: 8px;
          font-size: 12px;
          color: #dfdfdf; }
          .chat-container .chat-wrapper .message-item .message-header .message-meta .timestamp {
            color: #747b81; }
        .chat-container .chat-wrapper .message-item .message-header .message-edit-button {
          color: #b8b8b8;
          font-size: 10px;
          text-transform: uppercase;
          background-color: #00304d;
          padding: 2px 6px;
          border: 1px solid #004872;
          border-radius: 6px;
          margin: 0px 10px 0px auto;
          cursor: pointer; }
          .chat-container .chat-wrapper .message-item .message-header .message-edit-button:hover {
            border: 1px solid #3a78b4;
            color: #dfdfdf; }
      .chat-container .chat-wrapper .message-item .message-content {
        padding-left: 32px;
        font-size: 14px;
        line-height: calc(1em + 8px); }
        .chat-container .chat-wrapper .message-item .message-content .mention--group {
          color: #faa61a;
          font-weight: 600; }
        .chat-container .chat-wrapper .message-item .message-content .chat-image {
          display: block;
          max-height: 15vh;
          max-width: 900px;
          object-fit: cover;
          border: 1px solid #384858;
          border-radius: 4px;
          margin: 0px auto 10px auto;
          opacity: 0.8; }
        .chat-container .chat-wrapper .message-item .message-content .message-edit-block .message-input {
          max-height: 300px;
          overflow-y: auto;
          display: block;
          overflow: hidden; }
          .chat-container .chat-wrapper .message-item .message-content .message-edit-block .message-input .image-row {
            display: inline-flex;
            flex-wrap: wrap;
            width: -webkit-fill-available;
            border-bottom: 2px solid #b8b8b8;
            margin-bottom: 8px; }
            .chat-container .chat-wrapper .message-item .message-content .message-edit-block .message-input .image-row .image-wrapper {
              padding: 2px 15px 2px 2px;
              border: 1px solid #491212;
              background: #163447;
              border-radius: 4px;
              width: 88px;
              height: 65px;
              margin: 6px 4px;
              text-align: center;
              writing-mode: vertical-lr;
              overflow: hidden; }
            .chat-container .chat-wrapper .message-item .message-content .message-edit-block .message-input .image-row img.pending-image,
            .chat-container .chat-wrapper .message-item .message-content .message-edit-block .message-input .image-row .pending-image {
              width: 100%;
              max-height: 60px;
              object-position: center;
              overflow-y: hidden;
              object-fit: cover;
              cursor: default; }
        .chat-container .chat-wrapper .message-item .message-content .message-edit-block img {
          max-width: 200px;
          max-height: 150px;
          object-fit: contain;
          display: block;
          margin: 0; }
        .chat-container .chat-wrapper .message-item .message-content .message-edit-block .message-edit-actions {
          margin-top: 8px; }
          .chat-container .chat-wrapper .message-item .message-content .message-edit-block .message-edit-actions .message-edit-save,
          .chat-container .chat-wrapper .message-item .message-content .message-edit-block .message-edit-actions .message-edit-cancel {
            color: #b8b8b8;
            font-size: 10px;
            text-transform: uppercase;
            background-color: #00304d;
            padding: 2px 6px;
            border: 1px solid #004872;
            border-radius: 6px;
            margin: 0px 10px 0px auto;
            cursor: pointer; }
            .chat-container .chat-wrapper .message-item .message-content .message-edit-block .message-edit-actions .message-edit-save:hover,
            .chat-container .chat-wrapper .message-item .message-content .message-edit-block .message-edit-actions .message-edit-cancel:hover {
              border: 1px solid #3a78b4;
              color: #dfdfdf; }
        .chat-container .chat-wrapper .message-item .message-content .message-deleted {
          font-style: italic;
          color: #d12323; }
      .chat-container .chat-wrapper .message-item .message-content--thread-grid {
        padding-left: 0; }
      .chat-container .chat-wrapper .message-item .message-item-thread-grid {
        display: grid;
        grid-template-columns: 32px minmax(0, 1fr);
        grid-template-rows: auto auto;
        column-gap: 0;
        row-gap: 6px; }
      .chat-container .chat-wrapper .message-item .message-item-thread-grid__rail-stem-zone {
        grid-column: 1;
        grid-row: 1;
        width: 32px;
        min-width: 32px;
        position: relative;
        overflow: visible;
        pointer-events: none; }
      .chat-container .chat-wrapper .message-item .message-item-thread-grid__rail-stem-upper {
        position: absolute;
        left: 11px;
        top: -5px;
        bottom: -6px;
        width: 0;
        border-left: 2px solid rgba(255, 255, 255, 0.28); }
      .chat-container .chat-wrapper .message-item .message-item-thread-grid__rail-elbow-zone {
        grid-column: 1;
        grid-row: 2;
        width: 32px;
        min-width: 32px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        align-self: stretch;
        min-height: 0;
        pointer-events: none; }
      .chat-container .chat-wrapper .message-item .message-item-thread-grid__rail-lower-stem {
        flex: 1 1 0;
        min-height: 0;
        width: 0;
        margin-left: 12px;
        border-left: 1px solid rgba(255, 255, 255, 0.28); }
      .chat-container .chat-wrapper .message-item .message-item-thread-grid__rail-elbow {
        flex: 0 0 auto;
        align-self: flex-start;
        margin-left: 11px;
        transform: translateY(-7px);
        box-sizing: border-box;
        width: 21px;
        height: 14px;
        border-left: 2px solid rgba(255, 255, 255, 0.28);
        border-bottom: 2px solid rgba(255, 255, 255, 0.28);
        border-bottom-left-radius: 10px; }
      .chat-container .chat-wrapper .message-item .message-item-thread-grid__rail-lower-balance {
        flex: 1 1 0;
        min-height: 0; }
      .chat-container .chat-wrapper .message-item .message-thread-channel-row--thread-grid {
        grid-column: 2;
        grid-row: 2;
        display: flex;
        align-items: center;
        gap: 2px;
        width: max-content;
        background: #1c2d38;
        border: 1px solid #384858;
        padding: 2px 4px;
        border-radius: 6px; }
        .chat-container .chat-wrapper .message-item .message-thread-channel-row--thread-grid:hover {
          background: #133b53;
          border: 1px solid #384858; }
      .chat-container .chat-wrapper .message-item .message-thread-channel-summary--thread-grid {
        flex: 1;
        min-width: 0;
        margin-left: 0;
        margin-top: 0; }
      .chat-container .chat-wrapper .message-item .thread-strip-menu {
        flex-shrink: 0;
        position: relative;
        background: transparent;
        padding: 2px 4px;
        border-radius: 6px; }
      .chat-container .chat-wrapper .message-item .thread-strip-menu__trigger {
        padding: 2px 4px;
        line-height: 1; }
      .chat-container .chat-wrapper .message-item .hover-menu--thread-strip {
        top: calc(100% + 4px);
        right: 0;
        left: auto; }
      .chat-container .chat-wrapper .message-item:hover {
        background: #163447;
        border-radius: 6px; }
    .chat-container .chat-wrapper .message-item.editing {
      background: #0c2637;
      border-radius: 6px;
      border-left: 2px solid #9b602a; }
    .chat-container .chat-wrapper .input-container {
      display: flex;
      padding: 8px; }
      .chat-container .chat-wrapper .input-container .message-input {
        flex: 1; }
      .chat-container .chat-wrapper .input-container button {
        margin-left: 8px;
        padding: 8px 12px;
        font-size: 18px; }
  .chat-container .chat-users-panel {
    width: 220px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    color: #dfdfdf;
    border-left: 1px solid #2a3847;
    font-size: 14px;
    min-height: 0;
    overflow: hidden; }
    .chat-container .chat-users-panel.chat-users-panel--closed {
      width: 0;
      flex-shrink: 0;
      padding: 0;
      pointer-events: none; }
      .chat-container .chat-users-panel.chat-users-panel--closed .chat-users-list {
        visibility: hidden; }
    .chat-container .chat-users-panel .chat-users-list {
      flex: 1;
      min-height: 0;
      overflow-y: auto;
      padding: 10px;
      list-style: none;
      margin: 0; }
      .chat-container .chat-users-panel .chat-users-list::-webkit-scrollbar {
        width: 6px; }
      .chat-container .chat-users-panel .chat-users-list::-webkit-scrollbar-track {
        background: #2e3842;
        border-radius: 4px;
        padding-right: 1px; }
      .chat-container .chat-users-panel .chat-users-list::-webkit-scrollbar-thumb {
        background-color: #491212;
        border-radius: 4px; }
        .chat-container .chat-users-panel .chat-users-list::-webkit-scrollbar-thumb:hover {
          background-color: #200808; }
      .chat-container .chat-users-panel .chat-users-list .chat-user-item {
        display: flex;
        align-items: center;
        gap: 8px;
        width: -webkit-fill-available;
        padding: 5px 8px;
        border-radius: 6px; }
        .chat-container .chat-users-panel .chat-users-list .chat-user-item .chat-user-item__identity {
          flex: 1;
          min-width: 0; }
          .chat-container .chat-users-panel .chat-users-list .chat-user-item .chat-user-item__identity .user-discord-rank__name {
            color: #afa991;
            padding: 5px;
            border: 1px solid transparent; }

.chat-mention-input-wrapper .image-row {
  display: inline-flex;
  flex-wrap: wrap;
  width: -webkit-fill-available;
  border-bottom: 2px solid #b8b8b8; }
  .chat-mention-input-wrapper .image-row .image-wrapper {
    padding: 2px 15px 2px 2px;
    border: 1px solid #491212;
    background: #163447;
    border-radius: 4px;
    width: 88px;
    height: 65px;
    margin: 4px;
    text-align: center;
    writing-mode: vertical-lr;
    overflow: hidden; }
  .chat-mention-input-wrapper .image-row img.pending-image {
    width: 100px;
    max-height: 60px;
    object-position: center;
    object-position: center;
    overflow-y: hidden;
    object-fit: cover;
    cursor: default; }

.remove-icon {
  position: relative;
  transform: translate(-18px, -5px);
  width: 20px;
  height: 20px;
  cursor: pointer;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: no-repeat;
  background-size: 20px 40px;
  background-position: 0 0; }

.remove-icon:hover {
  background-position: 0 -16px; }

.message-input:empty:before {
  content: attr(data-placeholder);
  color: #999;
  pointer-events: none;
  display: block; }

.chat-resume-marker .chat-resume-marker__label {
  display: flex;
  position: relative;
  background: #9e2222;
  color: #dfdfdf;
  text-transform: uppercase;
  width: fit-content;
  margin: 0px 0px 0px auto;
  padding: 1px 8px;
  border-radius: 6px 6px 0px 0px;
  font-size: 10px;
  font-weight: 600; }

.chat-resume-marker .chat-resume-marker__line {
  width: 100%;
  height: 1px;
  background: #9e2222;
  margin-bottom: 10px; }

.chat-image-modal-overlay {
  position: fixed;
  z-index: 9999;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center; }

.chat-image-modal-content {
  border: 1px solid #b8b8b8;
  max-width: 90%;
  max-height: 90%; }

.chat-image-modal-img {
  max-width: 100%;
  max-height: 80vh;
  border-radius: 4px;
  cursor: pointer; }

.chat-mention-input-wrapper {
  position: relative; }
  .chat-mention-input-wrapper .chat-voice-live-bar {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 10px;
    border-bottom: 1px solid #004872;
    background: rgba(237, 66, 69, 0.12); }
  .chat-mention-input-wrapper .chat-voice-live-bar__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #ed4245;
    flex-shrink: 0;
    animation: chat-voice-live-dot-pulse 1s ease-in-out infinite; }
  .chat-mention-input-wrapper .chat-voice-live-bar__label {
    flex-shrink: 0;
    font-size: 12px;
    font-weight: 600;
    color: #ed4245;
    text-transform: uppercase;
    letter-spacing: 0.04em; }
  .chat-mention-input-wrapper .chat-voice-live-wave {
    display: flex;
    flex: 1;
    align-items: flex-end;
    justify-content: space-between;
    gap: 2px;
    min-width: 0;
    height: 26px;
    padding: 0 4px; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar {
    flex: 1;
    max-width: 5px;
    min-width: 2px;
    border-radius: 2px;
    background: #5865f2;
    height: 35%;
    transform-origin: center bottom;
    animation: chat-voice-live-bar-swing 0.75s ease-in-out infinite alternate; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(1) {
    animation-delay: 0s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(2) {
    animation-delay: 0.035s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(3) {
    animation-delay: 0.07s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(4) {
    animation-delay: 0.105s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(5) {
    animation-delay: 0.14s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(6) {
    animation-delay: 0.175s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(7) {
    animation-delay: 0.21s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(8) {
    animation-delay: 0.245s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(9) {
    animation-delay: 0.28s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(10) {
    animation-delay: 0.315s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(11) {
    animation-delay: 0.35s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(12) {
    animation-delay: 0.385s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(13) {
    animation-delay: 0.42s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(14) {
    animation-delay: 0.455s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(15) {
    animation-delay: 0.49s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(16) {
    animation-delay: 0.525s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(17) {
    animation-delay: 0.56s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(18) {
    animation-delay: 0.595s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(19) {
    animation-delay: 0.63s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(20) {
    animation-delay: 0.665s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(21) {
    animation-delay: 0.7s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(22) {
    animation-delay: 0.735s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(23) {
    animation-delay: 0.77s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(24) {
    animation-delay: 0.805s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(25) {
    animation-delay: 0.84s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(26) {
    animation-delay: 0.875s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(27) {
    animation-delay: 0.91s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(28) {
    animation-delay: 0.945s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(29) {
    animation-delay: 0.98s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(30) {
    animation-delay: 1.015s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(31) {
    animation-delay: 1.05s; }
  .chat-mention-input-wrapper .chat-voice-live-wave__bar:nth-child(32) {
    animation-delay: 1.085s; }
  .chat-mention-input-wrapper .chat-voice-live-bar__time {
    flex-shrink: 0;
    font-size: 12px;
    font-variant-numeric: tabular-nums;
    color: #f2f3f5;
    min-width: 38px;
    text-align: right; }
  .chat-mention-input-wrapper .message-input-container {
    position: relative;
    display: flex;
    align-items: center;
    gap: 4px; }
    .chat-mention-input-wrapper .message-input-container .message-input {
      flex: 1;
      min-width: 0;
      width: auto;
      padding-right: 4px; }
    .chat-mention-input-wrapper .message-input-container .chat-voice-mic-btn {
      flex-shrink: 0;
      background: transparent;
      border: none;
      cursor: pointer;
      font-size: 15px;
      line-height: 1;
      padding: 4px 6px;
      opacity: 0.75;
      border-radius: 4px; }
      .chat-mention-input-wrapper .message-input-container .chat-voice-mic-btn:hover:not(:disabled) {
        opacity: 1;
        background: rgba(255, 255, 255, 0.06); }
      .chat-mention-input-wrapper .message-input-container .chat-voice-mic-btn:disabled {
        opacity: 0.35;
        cursor: not-allowed; }
      .chat-mention-input-wrapper .message-input-container .chat-voice-mic-btn--recording {
        opacity: 1;
        animation: chat-voice-mic-pulse 1.2s ease-in-out infinite; }
    .chat-mention-input-wrapper .message-input-container .emoji-toggle {
      position: static;
      right: auto;
      flex-shrink: 0;
      background: transparent;
      border: none;
      cursor: pointer;
      font-size: 16px;
      filter: grayscale(100%) brightness(1);
      opacity: 0.6;
      transition: opacity 0.15s ease;
      padding: 4px 4px 4px 2px; }
      .chat-mention-input-wrapper .message-input-container .emoji-toggle:hover {
        filter: none;
        opacity: 1; }
  .chat-mention-input-wrapper .chat-voice-draft-row {
    padding: 6px 8px;
    border-bottom: 1px solid #004872;
    background: rgba(0, 0, 0, 0.12); }
  .chat-mention-input-wrapper .chat-voice-draft-wrapper + .chat-voice-draft-wrapper {
    margin-top: 6px; }
  .chat-mention-input-wrapper .chat-voice-attachment.chat-voice--pending {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 6px 10px;
    border-radius: 8px;
    background: #2b2d31;
    border: 1px solid #1e1f22;
    max-width: 100%;
    box-sizing: border-box; }
  .chat-mention-input-wrapper .chat-voice-draft-remove {
    flex-shrink: 0;
    width: 22px;
    height: 22px;
    border: none;
    border-radius: 50%;
    background: #4e5058;
    color: #f2f3f5;
    cursor: pointer;
    font-size: 14px;
    line-height: 1;
    padding: 0; }
    .chat-mention-input-wrapper .chat-voice-draft-remove:hover {
      background: #5c5e66; }
  .chat-mention-input-wrapper .chat-voice-draft-preview {
    display: flex;
    align-items: center;
    gap: 6px;
    flex: 1;
    min-width: 0; }
  .chat-mention-input-wrapper .chat-voice-draft-label {
    font-size: 12px;
    color: #b5bac1;
    font-variant-numeric: tabular-nums; }
  .chat-mention-input-wrapper .chat-voice-fallback-text {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0; }

@keyframes chat-voice-mic-pulse {
  0%,
  100% {
    filter: brightness(1); }
  50% {
    filter: brightness(1.35) drop-shadow(0 0 4px rgba(237, 66, 69, 0.55)); } }

@keyframes chat-voice-live-bar-swing {
  from {
    transform: scaleY(0.25);
    opacity: 0.55; }
  to {
    transform: scaleY(1);
    opacity: 1; } }

@keyframes chat-voice-live-dot-pulse {
  0%,
  100% {
    opacity: 1;
    box-shadow: 0 0 0 0 rgba(237, 66, 69, 0.5); }
  50% {
    opacity: 0.85;
    box-shadow: 0 0 0 7px rgba(237, 66, 69, 0); } }

.emoji-picker-popover {
  position: absolute;
  bottom: 100%;
  right: 0;
  margin-bottom: 6px;
  z-index: 9999; }

.emoji-picker {
  width: 280px;
  height: 220px;
  background: #163447;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #491212;
  border-bottom: 4px solid #491212;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.5); }
  .emoji-picker .emoji-header {
    padding: 6px;
    display: flex;
    justify-content: space-between;
    color: #dfdfdf;
    text-transform: uppercase;
    font-weight: bold;
    align-items: center;
    padding: 5px 10px;
    border-bottom: 2px solid #2a3847;
    border-radius: 8px 8px 0px 0px;
    background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___}); }
    .emoji-picker .emoji-header .emoji-search {
      width: -webkit-fill-available;
      padding: 5px 6px;
      background: #0c2637;
      border: none;
      color: #dfdfdf;
      border-radius: 4px;
      font-size: 12px; }
      .emoji-picker .emoji-header .emoji-search::placeholder {
        color: #b8b8b8; }
  .emoji-picker .emoji-scroll {
    flex: 1;
    overflow-y: auto;
    padding: 6px; }
    .emoji-picker .emoji-scroll::-webkit-scrollbar {
      width: 6px; }
    .emoji-picker .emoji-scroll::-webkit-scrollbar-thumb {
      background: #1a1b1e;
      border-radius: 3px; }
  .emoji-picker .emoji-category {
    margin-bottom: 5px; }
    .emoji-picker .emoji-category .emoji-category-title {
      font-size: 11px;
      color: #b8b8b8;
      margin: 4px 4px 6px;
      text-transform: uppercase;
      letter-spacing: 0.3px; }
    .emoji-picker .emoji-category .emoji-grid {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      gap: 1px; }
      .emoji-picker .emoji-category .emoji-grid .emoji-item {
        font-size: 18px;
        padding: 5px;
        border-radius: 4px;
        cursor: pointer;
        background: transparent;
        border: none;
        transition: background 0.1s ease; }
        .emoji-picker .emoji-category .emoji-grid .emoji-item:hover {
          background: #00304d; }

.message-item {
  position: relative; }

.message-hover-actions {
  position: absolute;
  background: #163447;
  top: -10px;
  right: 10px;
  display: flex;
  gap: 6px;
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 3px 6px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s ease;
  z-index: 10;
  box-shadow: 0 4px 2px rgba(0, 0, 0, 0.1); }
  .message-hover-actions:hover {
    opacity: 1;
    border: 1px solid #133b53; }

.message-item:hover .message-hover-actions {
  opacity: 1;
  pointer-events: auto; }

.message-thread-channel-summary {
  display: block;
  margin-top: 6px;
  margin-left: 32px;
  font-size: 12px;
  font-family: inherit;
  text-align: left;
  color: #b5bac1;
  border: none;
  background: transparent;
  border-radius: 6px;
  width: fit-content;
  max-width: 100%;
  box-sizing: border-box;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease; }
  .message-thread-channel-summary:disabled {
    cursor: not-allowed;
    opacity: 0.65; }

.chat-thread-slide-overlay {
  position: absolute;
  inset: 0;
  z-index: 40;
  border-radius: inherit;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.4);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.28s ease; }
  .chat-thread-slide-overlay.chat-thread-slide-overlay--visible {
    opacity: 1;
    pointer-events: auto; }

.chat-thread-slide-panel {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  min-height: 0;
  width: 100%;
  max-width: 600px;
  background-color: #1e3042;
  border-left: 1px solid #491212;
  box-shadow: -10px 0 28px rgba(0, 0, 0, 0.35);
  transform: translateX(100%);
  transition: transform 0.32s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 41; }
  .chat-thread-slide-panel.chat-thread-slide-panel--open {
    transform: translateX(0); }
  .chat-thread-slide-panel .messages-list {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    padding: 8px;
    background-color: #1e3042; }
    .chat-thread-slide-panel .messages-list::-webkit-scrollbar {
      width: 6px; }
    .chat-thread-slide-panel .messages-list::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .chat-thread-slide-panel .messages-list::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .chat-thread-slide-panel .messages-list::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
  .chat-thread-slide-panel .input-container {
    display: flex;
    padding: 8px;
    background-color: #1e3042;
    border-top: 1px solid rgba(255, 255, 255, 0.08); }
    .chat-thread-slide-panel .input-container .message-input {
      flex: 1; }
    .chat-thread-slide-panel .input-container button {
      margin-left: 8px;
      padding: 8px 12px;
      font-size: 18px; }

.chat-thread-slide-header {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  padding: 3px 10px;
  display: flex;
  justify-content: space-between;
  color: #dfdfdf;
  text-transform: uppercase;
  font-weight: bold;
  align-items: center;
  padding: 5px 10px;
  border-bottom: 2px solid #2a3847;
  border-radius: 8px 8px 0px 0px;
  background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  border-bottom: 1px solid rgba(0, 0, 0, 0.25); }

.chat-thread-slide-back {
  flex-shrink: 0;
  padding: 1px 10px;
  font-size: 12px;
  color: #b8b8b8;
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  cursor: pointer; }
  .chat-thread-slide-back:hover {
    background: rgba(0, 0, 0, 0.4);
    border-color: rgba(255, 255, 255, 0.2); }

.chat-thread-slide-title {
  margin: 0;
  flex: 1;
  min-width: 0;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: #b8b8b8;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.chat-thread-slide-title-row {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 6px; }

.chat-thread-slide-title-input {
  flex: 1;
  min-width: 0;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: #b8b8b8;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 4px;
  padding: 4px 8px; }

.chat-thread-slide-title-edit {
  flex-shrink: 0;
  padding: 2px 8px;
  font-size: 12px;
  line-height: 1;
  color: #b8b8b8;
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 4px;
  cursor: pointer; }
  .chat-thread-slide-title-edit:hover {
    background: rgba(0, 0, 0, 0.45);
    border-color: rgba(255, 255, 255, 0.2); }

.chat-thread-slide-title-save,
.chat-thread-slide-title-cancel {
  flex-shrink: 0;
  padding: 3px 8px;
  font-size: 11px;
  font-weight: 600;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.12); }

.chat-thread-slide-title-save {
  color: #fff;
  background: rgba(40, 120, 60, 0.55); }
  .chat-thread-slide-title-save:hover:not(:disabled) {
    background: rgba(40, 120, 60, 0.75); }
  .chat-thread-slide-title-save:disabled {
    opacity: 0.45;
    cursor: not-allowed; }

.chat-thread-slide-title-cancel {
  color: #b8b8b8;
  background: rgba(0, 0, 0, 0.25); }
  .chat-thread-slide-title-cancel:hover:not(:disabled) {
    background: rgba(0, 0, 0, 0.45); }
  .chat-thread-slide-title-cancel:disabled {
    opacity: 0.45;
    cursor: not-allowed; }

.hover-btn {
  background: transparent;
  border: none;
  font-size: medium;
  color: white;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 4px;
  filter: grayscale(100%) brightness(0.8);
  transition: all 0.15s ease; }

.hover-btn:hover {
  filter: grayscale(100%) brightness(1);
  scale: 1.2; }

.reply-block {
  display: flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  background: #172738;
  border-left: 3px solid #3a78b4;
  padding: 4px 8px;
  margin-bottom: 6px;
  border-radius: 4px; }

.reply-text {
  font-size: 12px;
  color: #b5bac1;
  margin-right: 20px; }

.reply-close {
  cursor: pointer;
  color: #888; }

.reply-close:hover {
  color: white; }

.reply-separator {
  height: 6px; }

.reply-mention {
  font-weight: 600; }

.message-reply {
  display: block;
  font-size: 12px;
  color: #b5bac1;
  margin-bottom: 4px; }

.reply-author {
  font-weight: 600;
  color: #ffffff;
  margin-right: 4px; }

.reply-label {
  margin-right: 4px; }

.reply-render {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  line-height: 17px;
  opacity: 0.7; }

.message-content {
  flex-direction: column; }
  .message-content .sc-item-chip {
    padding: 3px 6px 2px;
    vertical-align: middle;
    margin: 0 3px; }

.chat-voice-message {
  display: flex;
  width: fit-content;
  max-width: min(400px, 100%);
  flex-direction: row;
  align-items: center;
  gap: 10px;
  margin: 6px 0;
  min-width: 240px;
  padding: 6px 12px 6px 8px;
  border-radius: 999px;
  background: #004872;
  border: 1px solid #3a78b4;
  box-sizing: border-box; }
  .chat-voice-message__audio {
    display: none; }
  .chat-voice-message__play {
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: none;
    background: #5865f2;
    color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    transition: background 0.15s ease, transform 0.1s ease; }
    .chat-voice-message__play:hover {
      background: #4752c4; }
    .chat-voice-message__play:active {
      transform: scale(0.96); }
  .chat-voice-message__play-icon {
    width: 0;
    height: 0;
    margin-left: 3px;
    border-style: solid;
    border-width: 7px 0 7px 11px;
    border-color: transparent transparent transparent #fff; }
  .chat-voice-message__pause-icon {
    display: flex;
    gap: 3px;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px; }
    .chat-voice-message__pause-icon::before, .chat-voice-message__pause-icon::after {
      content: "";
      display: block;
      width: 3px;
      height: 12px;
      border-radius: 1px;
      background: #fff; }
  .chat-voice-message__wave-wrap {
    flex: 1;
    min-width: 0;
    height: 30px;
    display: flex;
    align-items: center; }
  .chat-voice-message__svg {
    width: 100%;
    height: 100%;
    display: block;
    overflow: visible; }
    .chat-voice-message__svg--loading .chat-voice-message__peak {
      animation: chat-voice-peak-pulse 0.9s ease-in-out infinite alternate; }
  .chat-voice-message__peak--track {
    fill: #5c5f6a; }
  .chat-voice-message__peak--played {
    fill: #b5bac1; }
  .chat-voice-message__time {
    flex-shrink: 0;
    font-size: 12px;
    font-weight: 500;
    color: #dbdee1;
    font-variant-numeric: tabular-nums;
    min-width: 36px;
    text-align: right; }
  .chat-voice-message__rate {
    flex-shrink: 0;
    font-size: 11px;
    font-weight: 600;
    color: #dbdee1;
    background: #2b2d31;
    border: 1px solid #3f4147;
    border-radius: 999px;
    padding: 4px 8px;
    cursor: pointer;
    line-height: 1; }
    .chat-voice-message__rate:hover {
      background: #383a40; }

@keyframes chat-voice-peak-pulse {
  from {
    opacity: 0.45; }
  to {
    opacity: 1; } }

.reply-preview {
  font-style: italic; }

.message-body {
  display: block; }
  .message-body .sc-item-chip {
    padding: 3px 6px 2px;
    vertical-align: middle;
    margin: 0 3px; }

.chat-mention-input-wrapper .message-input .sc-item-chip.chat-sc-loot-chip {
  vertical-align: middle;
  margin: 0 3px; }

.chat-game-entity {
  cursor: help;
  background-color: rgba(90, 120, 60, 0.45);
  border-radius: 2px;
  padding: 1px 3px; }
  .chat-game-entity:hover {
    background-color: rgba(110, 150, 75, 0.55); }

.chat-game-tooltip {
  position: fixed;
  z-index: 20050;
  display: flex;
  flex-direction: row;
  gap: 10px;
  max-width: 320px;
  padding: 10px;
  background: #163447;
  border: 1px solid #004872;
  border-radius: 6px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.45);
  pointer-events: auto; }

.chat-game-tooltip__img {
  width: 88px;
  height: 56px;
  object-fit: cover;
  border-radius: 4px;
  flex-shrink: 0;
  background: #1e3042; }
  .chat-game-tooltip__img--placeholder {
    display: block; }

.chat-game-tooltip__body {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px; }

.chat-game-tooltip__title {
  font-size: 14px;
  font-weight: 600;
  color: #5ac3ff; }

.chat-game-tooltip__line {
  font-size: 12px;
  color: #dfdfdf; }

.scroll-lock {
  overflow: hidden; }

.message-reactions {
  display: flex;
  gap: 6px;
  margin-top: 4px; }
  .message-reactions .reaction-item {
    display: flex;
    align-items: center;
    gap: 4px;
    background: #00304d;
    padding: 2px 6px;
    border-radius: 12px;
    font-size: 18px;
    color: #b8b8b8;
    cursor: pointer; }
    .message-reactions .reaction-item .reaction-emoji {
      font-size: 18px; }
    .message-reactions .reaction-item .reaction-count {
      font-size: 12px; }

.hover-btn--top-emoji {
  background: transparent;
  font-size: 16px;
  filter: none; }

.hover-btn--top-emoji:hover {
  transform: scale(1.2);
  filter: none; }

.hover-menu-wrapper {
  position: relative; }

.hover-menu {
  position: absolute;
  top: 28px;
  right: 0;
  min-width: 180px;
  background: #163447;
  border: 1px solid #491212;
  border-radius: 6px;
  padding: 4px 0;
  z-index: 999;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column; }

.hover-menu-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
  font-size: 13px;
  color: #dfdfdf;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: background 0.12s ease; }
  .hover-menu-item .label {
    pointer-events: none; }
  .hover-menu-item .icon {
    font-size: 14px;
    opacity: 0.7;
    pointer-events: none; }
  .hover-menu-item:hover {
    background: #00304d; }
    .hover-menu-item:hover .icon {
      opacity: 1; }

.hover-menu-item--danger {
  color: #dfdfdf; }
  .hover-menu-item--danger .icon {
    color: #dfdfdf;
    font-size: 16px;
    opacity: 0.9; }
  .hover-menu-item--danger:hover {
    background: #491212; }

.chat-youtube-card {
  border-left: 4px solid #7e1e1e;
  background: #0c2637;
  padding: 10px;
  border-radius: 6px;
  margin-top: 6px;
  max-width: 480px; }

.youtube-meta {
  margin-bottom: 8px; }

.youtube-platform {
  font-size: 11px;
  color: #b5bac1;
  margin-bottom: 10px; }

.youtube-title {
  font-size: 14px;
  font-weight: 600;
  color: #5ac3ff;
  margin-bottom: 10px;
  cursor: pointer; }
  .youtube-title:hover {
    text-decoration: underline; }

.youtube-channel {
  font-size: 12px;
  color: #dfdfdf;
  margin-bottom: 20px; }

.chat-youtube {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  border-radius: 4px;
  overflow: hidden;
  background: #0c2637;
  margin-bottom: 8px; }

.chat-youtube iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  margin-bottom: 2px; }

.chat-link-preview {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 10px;
  margin-top: 8px;
  max-width: 480px;
  padding: 10px;
  border-radius: 6px;
  border-left: 4px solid #3a78b4;
  background: #0c2637;
  text-decoration: none;
  color: inherit;
  overflow: hidden; }
  .chat-link-preview:hover {
    background: #103248; }

.chat-link-preview--loading {
  pointer-events: none;
  min-height: 72px; }

.chat-link-preview__skeleton {
  width: 100%;
  min-height: 72px;
  border-radius: 4px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.04) 0%, rgba(255, 255, 255, 0.09) 50%, rgba(255, 255, 255, 0.04) 100%);
  background-size: 200% 100%;
  animation: chat-link-preview-shimmer 1.2s ease-in-out infinite; }

@keyframes chat-link-preview-shimmer {
  0% {
    background-position: 200% 0; }
  100% {
    background-position: -200% 0; } }

.chat-link-preview--fallback {
  border-left-color: #dfdfdf; }

.chat-link-preview__open {
  font-size: 13px;
  color: #5ac3ff;
  word-break: break-all; }

.chat-link-preview__img-wrap {
  flex: 0 0 120px;
  width: 120px;
  min-height: 68px;
  border-radius: 4px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.35); }

.chat-link-preview__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block; }

.chat-link-preview__body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px; }

.chat-link-preview__site {
  font-size: 11px;
  color: #b8b8b8;
  text-transform: uppercase;
  letter-spacing: 0.03em; }

.chat-link-preview__title {
  font-size: 14px;
  font-weight: 600;
  color: #5ac3ff;
  line-height: 1.3; }

.chat-link-preview__desc {
  font-size: 12px;
  color: #dfdfdf;
  line-height: 1.35;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden; }

.chat-calendar-embed {
  display: block;
  max-width: 480px;
  margin-top: 8px;
  border-radius: 8px;
  overflow: hidden;
  background: #172738;
  border: 1px solid #00304d;
  text-decoration: none;
  color: #dcddde;
  text-align: left; }
  .chat-calendar-embed:hover {
    border-color: #1a1c1f;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35); }

.chat-calendar-embed--loading {
  pointer-events: none;
  min-height: 120px; }

.chat-calendar-embed__skeleton {
  width: 100%;
  min-height: 120px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.04) 0%, rgba(255, 255, 255, 0.08) 50%, rgba(255, 255, 255, 0.04) 100%);
  background-size: 200% 100%;
  animation: chat-link-preview-shimmer 1.2s ease-in-out infinite; }

.chat-calendar-embed--fallback {
  padding: 10px 12px;
  font-size: 13px;
  color: #5ac3ff; }

.chat-calendar-embed__banner-wrap {
  width: 100%;
  max-height: 140px;
  overflow: hidden;
  background: #202225; }

.chat-calendar-embed__banner {
  display: block;
  width: 100%;
  height: auto;
  max-height: 140px;
  object-fit: cover; }

.chat-calendar-embed__inner {
  display: flex;
  flex-direction: row;
  align-items: stretch; }

.chat-calendar-embed__accent {
  width: 4px;
  flex-shrink: 0;
  background: #5865f2; }

.chat-calendar-embed__content {
  flex: 1;
  min-width: 0;
  padding: 10px 12px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px; }

.chat-calendar-embed__provider {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #b9bbbe;
  letter-spacing: 0.04em; }

.chat-calendar-embed__title {
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  line-height: 1.25; }

.chat-calendar-embed__status {
  display: inline-block;
  align-self: flex-start;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 2px 8px;
  border-radius: 4px; }

.chat-calendar-embed__status--scheduled {
  background: rgba(87, 242, 135, 0.15);
  color: #57f287; }

.chat-calendar-embed__status--cancelled {
  background: rgba(237, 66, 69, 0.2);
  color: #ed4245; }

.chat-calendar-embed__status--live {
  background: rgba(250, 166, 26, 0.2);
  color: #faa61a; }

.chat-calendar-embed__status--concluded {
  background: rgba(185, 187, 190, 0.18);
  color: #949ba4; }

.chat-calendar-embed__status--tentative {
  background: rgba(184, 165, 0, 0.22);
  color: #e6d14a; }

.chat-calendar-embed__meta {
  font-size: 12px;
  color: #b9bbbe; }

.chat-calendar-embed__location {
  font-size: 12px;
  color: #b9bbbe; }

.chat-calendar-embed__attendees {
  font-size: 12px;
  color: #dcddde; }

.chat-calendar-embed__limit {
  font-size: 11px;
  color: #72767d; }

.chat-calendar-embed__allies {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
  margin-top: 4px; }

.chat-calendar-embed__ally {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #dcddde; }

.chat-calendar-embed__ally-logo {
  width: 22px;
  height: 22px;
  border-radius: 4px;
  object-fit: cover;
  background: #202225; }
  .chat-calendar-embed__ally-logo--empty {
    display: inline-block; }

.chat-calendar-embed__desc {
  font-size: 12px;
  color: #b9bbbe;
  line-height: 1.4;
  white-space: pre-line;
  max-height: 7em;
  overflow: hidden; }

.chat-calendar-embed__cancel-reason {
  font-size: 12px;
  color: #ed4245;
  font-style: italic; }

.user-discord-rank {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
  vertical-align: middle;
  /* Whole identity (avatar + name + rank) as one chip; opens profile card */
  /* Rank colors (data-*): border + ::after on hover/open; colors via rankChipCspStyles.js */ }
  .user-discord-rank .user-discord-rank__avatar {
    flex-shrink: 0;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    object-fit: cover; }
    .user-discord-rank .user-discord-rank__avatar.user-discord-rank__avatar--placeholder {
      background: #747b81;
      opacity: 0.35;
      display: inline-block; }
  .user-discord-rank .user-discord-rank__name {
    color: inherit;
    min-width: 0;
    white-space: nowrap;
    text-decoration: none;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: default; }
  .user-discord-rank .user-discord-rank__rank-icon {
    flex-shrink: 0;
    width: auto;
    height: 20px;
    object-fit: contain; }
  .user-discord-rank.user-discord-rank--compact {
    gap: 6px; }
    .user-discord-rank.user-discord-rank--compact .user-discord-rank__avatar {
      width: 24px;
      height: 24px; }
    .user-discord-rank.user-discord-rank--compact .user-discord-rank__rank-icon {
      width: 18px;
      height: 18px; }
  .user-discord-rank.user-discord-rank--no-avatar {
    gap: 6px; }
  .user-discord-rank.user-discord-rank--profile-chip {
    padding: 2px 8px 2px 4px;
    margin: 0;
    border: 1px solid transparent;
    border-radius: 10px;
    background: transparent;
    cursor: pointer;
    font: inherit;
    color: inherit;
    text-align: left;
    box-sizing: border-box;
    max-width: 100%;
    /* Default (no rank color in data) */ }
    .user-discord-rank.user-discord-rank--profile-chip .user-discord-rank__name {
      cursor: pointer; }
    .user-discord-rank.user-discord-rank--profile-chip:not([data-chip-bg]):hover, .user-discord-rank.user-discord-rank--profile-chip:not([data-chip-bg]).user-discord-rank--profile-chip-open {
      color: #dfdfdf;
      border-color: #2a3847;
      background-color: #384858; }
  .user-discord-rank.user-discord-rank--profile-chip[data-chip-bg] {
    position: relative;
    isolation: isolate;
    transition: border-color 0.15s ease, color 0.15s ease; }
    .user-discord-rank.user-discord-rank--profile-chip[data-chip-bg]::after {
      content: "";
      position: absolute;
      inset: 0;
      border-radius: inherit;
      z-index: 0;
      pointer-events: none;
      opacity: 0;
      transition: opacity 0.15s ease; }
    .user-discord-rank.user-discord-rank--profile-chip[data-chip-bg]:hover[data-chip-fg], .user-discord-rank.user-discord-rank--profile-chip[data-chip-bg].user-discord-rank--profile-chip-open[data-chip-fg] {
      color: #ffffff !important; }
    .user-discord-rank.user-discord-rank--profile-chip[data-chip-bg]:hover::after, .user-discord-rank.user-discord-rank--profile-chip[data-chip-bg].user-discord-rank--profile-chip-open::after {
      opacity: 0.22; }
    .user-discord-rank.user-discord-rank--profile-chip[data-chip-bg] > * {
      position: relative;
      z-index: 1; }
  .user-discord-rank.user-discord-rank--profile-chip-avatar-only {
    padding: 1px;
    border-radius: 50%; }
    .user-discord-rank.user-discord-rank--profile-chip-avatar-only .user-discord-rank__avatar,
    .user-discord-rank.user-discord-rank--profile-chip-avatar-only .user-discord-rank__avatar--placeholder {
      display: block; }

.donor-heart-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0; }

.donor-heart-badge__wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  cursor: default;
  border: none;
  padding: 0;
  background: transparent;
  font: inherit;
  color: inherit; }
  .donor-heart-badge__wrap--clickable {
    cursor: pointer; }
  .donor-heart-badge__wrap:hover .donor-heart-badge__tooltip, .donor-heart-badge__wrap:focus-within .donor-heart-badge__tooltip {
    opacity: 1;
    visibility: visible;
    transform: translateY(0); }

.donor-heart-badge__wrap--premium::before {
  content: "";
  position: absolute;
  inset: -4px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(209, 35, 35, 0.55) 0%, rgba(209, 35, 35, 0.18) 45%, rgba(209, 35, 35, 0) 72%);
  animation: donor-heart-badge-aura 1s ease-in-out infinite;
  pointer-events: none; }

.donor-heart-badge__heart {
  position: relative;
  z-index: 1;
  width: 12px;
  height: 12px;
  color: #d12323;
  transform-origin: center center; }

.donor-heart-badge__heart--subscriber {
  animation: donor-heart-badge-heartbeat 1s ease-in-out infinite; }

.donor-heart-badge__label {
  font-size: 11px;
  font-weight: 500;
  color: #747b81; }

.donor-heart-badge__tooltip {
  position: absolute;
  left: 0;
  top: calc(100% + 6px);
  z-index: 4;
  display: inline-flex;
  align-items: baseline;
  min-width: 52px;
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid #3a78b4;
  background: #1e3042;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  line-height: 1.2;
  white-space: nowrap;
  pointer-events: none;
  color: rgba(223, 223, 223, 0.95);
  opacity: 0;
  visibility: hidden;
  transform: translateY(-2px);
  transition: opacity 0.15s ease, visibility 0.15s ease, transform 0.15s ease;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.45), 0 0 0 1px rgba(0, 0, 0, 0.18); }

@keyframes donor-heart-badge-heartbeat {
  0%,
  52%,
  100% {
    transform: scale(1); }
  12% {
    transform: scale(1.28); }
  24% {
    transform: scale(1); }
  36% {
    transform: scale(1.14); } }

@keyframes donor-heart-badge-aura {
  0%,
  52%,
  100% {
    opacity: 0.45;
    transform: scale(0.92); }
  12% {
    opacity: 0.95;
    transform: scale(1.18); }
  24% {
    opacity: 0.5;
    transform: scale(0.96); }
  36% {
    opacity: 0.8;
    transform: scale(1.08); } }

.donor-gem-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0; }

.donor-gem-badge--fade-0 {
  --donor-gem-opacity: 0; }

.donor-gem-badge--fade-1 {
  --donor-gem-opacity: 0.1; }

.donor-gem-badge--fade-2 {
  --donor-gem-opacity: 0.2; }

.donor-gem-badge--fade-3 {
  --donor-gem-opacity: 0.3; }

.donor-gem-badge--fade-4 {
  --donor-gem-opacity: 0.4; }

.donor-gem-badge--fade-5 {
  --donor-gem-opacity: 0.5; }

.donor-gem-badge--fade-6 {
  --donor-gem-opacity: 0.6; }

.donor-gem-badge--fade-7 {
  --donor-gem-opacity: 0.7; }

.donor-gem-badge--fade-8 {
  --donor-gem-opacity: 0.8; }

.donor-gem-badge--fade-9 {
  --donor-gem-opacity: 0.9; }

.donor-gem-badge--fade-10 {
  --donor-gem-opacity: 1; }

.donor-gem-badge__wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  cursor: default;
  border: none;
  padding: 0;
  background: transparent;
  font: inherit;
  color: inherit;
  opacity: var(--donor-gem-opacity, 1); }
  .donor-gem-badge__wrap--clickable {
    cursor: pointer; }
  .donor-gem-badge__wrap:hover .donor-gem-badge__tooltip, .donor-gem-badge__wrap:focus-within .donor-gem-badge__tooltip {
    opacity: 1;
    visibility: visible;
    transform: translateY(0); }

.donor-gem-badge__wrap--one-time {
  color: #3a78b4; }

.donor-gem-badge__wrap--subscriber {
  color: #7958c3; }

.donor-gem-badge__wrap--premium {
  color: #e8c547; }

.donor-gem-badge__wrap--premium::before {
  content: "";
  position: absolute;
  inset: -4px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(232, 197, 71, 0.55) 0%, rgba(232, 197, 71, 0.18) 45%, rgba(232, 197, 71, 0) 72%);
  pointer-events: none; }

.donor-gem-badge__wrap--inactive .donor-gem-badge__gem {
  filter: none; }

.donor-gem-badge__gem {
  position: relative;
  z-index: 1;
  width: 12px;
  height: 12px;
  transform-origin: center center; }

.donor-gem-badge__gem--one-time {
  filter: drop-shadow(0 0 2px rgba(58, 120, 180, 0.45)); }

.donor-gem-badge__gem--subscriber {
  filter: drop-shadow(0 0 2px rgba(121, 88, 195, 0.45)); }

.donor-gem-badge__gem--premium {
  filter: drop-shadow(0 0 3px rgba(232, 197, 71, 0.55)); }

.donor-gem-badge__gem--inactive {
  filter: none; }

.donor-gem-badge__label {
  font-size: 11px;
  font-weight: 500;
  color: #747b81; }

.donor-gem-badge__tooltip {
  position: absolute;
  left: 0;
  top: calc(100% + 6px);
  z-index: 4;
  display: inline-flex;
  align-items: baseline;
  min-width: 52px;
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid #3a78b4;
  background: #1e3042;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  line-height: 1.2;
  white-space: nowrap;
  pointer-events: none;
  color: rgba(223, 223, 223, 0.95);
  opacity: 0;
  visibility: hidden;
  transform: translateY(-2px);
  transition: opacity 0.15s ease, visibility 0.15s ease, transform 0.15s ease;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.45), 0 0 0 1px rgba(0, 0, 0, 0.18); }

.donor-gem-badge__wrap:hover .donor-gem-badge__gem--subscriber,
.donor-gem-badge__wrap:focus-within .donor-gem-badge__gem--subscriber {
  animation: donor-gem-badge-pulse 1.4s ease-in-out infinite; }

.donor-gem-badge__wrap:hover .donor-gem-badge__gem--premium,
.donor-gem-badge__wrap:focus-within .donor-gem-badge__gem--premium {
  animation: donor-gem-badge-shimmer 1.6s ease-in-out infinite; }

.donor-gem-badge__wrap--premium:hover::before,
.donor-gem-badge__wrap--premium:focus-within::before {
  opacity: 1;
  animation: donor-gem-badge-aura 1.4s ease-in-out infinite; }

@media (prefers-reduced-motion: reduce) {
  .donor-gem-badge__gem,
  .donor-gem-badge__wrap--premium::before {
    animation: none !important; } }

@keyframes donor-gem-badge-pulse {
  0%,
  100% {
    transform: scale(1); }
  50% {
    transform: scale(1.12); } }

@keyframes donor-gem-badge-shimmer {
  0%,
  100% {
    transform: scale(1) rotate(0deg);
    filter: drop-shadow(0 0 3px rgba(232, 197, 71, 0.55)); }
  50% {
    transform: scale(1.1) rotate(6deg);
    filter: drop-shadow(0 0 5px rgba(245, 223, 138, 0.85)); } }

@keyframes donor-gem-badge-aura {
  0%,
  100% {
    opacity: 0.45;
    transform: scale(0.92); }
  50% {
    opacity: 0.95;
    transform: scale(1.16); } }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.hangar-filters--horizontal .hangar-filters__search,
.member-academy-header__search {
  flex: 0 1 50%;
  min-width: 12rem;
  max-width: 50%; }

.hub-toolbar-search.roster-toolbar-card--search {
  width: 100%;
  max-width: 100%; }

.member-profile-card-popover-shell {
  pointer-events: auto; }

.member-profile-card-popover {
  width: 280px;
  max-width: calc(100vw - 16px);
  overflow: hidden;
  background-color: #0c254487;
  box-shadow: 3px 2px inset rgba(51, 102, 126, 0.229), 0 8px 24px rgba(0, 0, 0, 0.45); }
  .member-profile-card-popover::after {
    content: "";
    position: absolute;
    top: 5px;
    bottom: 5px;
    left: 7px;
    right: 7px;
    border-left: 3px solid #2a3847;
    border-right: 3px solid #2a3847;
    border-radius: 5px;
    pointer-events: none;
    z-index: 1; }
  .member-profile-card-popover .member-profile-card {
    position: relative;
    z-index: 2; }

.member-profile-card-popover--theme-fx {
  isolation: isolate; }
  .member-profile-card-popover--theme-fx .member-profile-card-popover__theme-media {
    z-index: 1; }

.member-profile-card-popover--donor {
  isolation: isolate;
  background-color: #091b3187; }
  .member-profile-card-popover--donor .member-profile-card-popover__theme-media {
    z-index: 1; }
  .member-profile-card-popover--donor::before {
    content: "";
    position: absolute;
    inset: -10%;
    z-index: 0;
    pointer-events: none;
    border-radius: inherit;
    opacity: 1;
    will-change: transform;
    background-image: radial-gradient(ellipse 52% 22% at 24% 74%, rgba(22, 58, 95, 0.45) 0%, transparent 72%), radial-gradient(ellipse 48% 20% at 46% 52%, rgba(58, 120, 180, 0.38) 0%, transparent 74%), radial-gradient(ellipse 44% 18% at 68% 30%, rgba(22, 58, 95, 0.42) 0%, transparent 72%), radial-gradient(ellipse 28% 14% at 18% 80%, rgba(90, 195, 255, 0.32) 0%, transparent 68%), radial-gradient(ellipse 26% 16% at 34% 62%, rgba(90, 195, 255, 0.4) 0%, transparent 70%), radial-gradient(ellipse 30% 13% at 52% 44%, rgba(90, 195, 255, 0.28) 0%, transparent 68%), radial-gradient(ellipse 24% 15% at 64% 36%, rgba(58, 120, 180, 0.34) 0%, transparent 70%), radial-gradient(ellipse 22% 12% at 78% 22%, rgba(90, 195, 255, 0.28) 0%, transparent 68%), radial-gradient(ellipse 9% 6% at 31% 66%, rgba(90, 195, 255, 0.48) 0%, transparent 72%), radial-gradient(ellipse 7% 5% at 49% 47%, rgba(255, 255, 255, 0.18) 0%, transparent 70%), radial-gradient(ellipse 8% 5% at 61% 33%, rgba(90, 195, 255, 0.38) 0%, transparent 72%), radial-gradient(ellipse 16% 20% at 40% 48%, rgba(58, 120, 180, 0.22) 0%, transparent 75%), radial-gradient(ellipse 14% 18% at 58% 56%, rgba(22, 58, 95, 0.26) 0%, transparent 78%), radial-gradient(ellipse 18% 10% at 72% 40%, rgba(90, 195, 255, 0.2) 0%, transparent 75%), radial-gradient(1px 1px at 14% 82%, rgba(255, 255, 255, 0.75), transparent), radial-gradient(1px 1px at 18% 76%, rgba(255, 255, 255, 0.45), transparent), radial-gradient(1.5px 1.5px at 22% 70%, rgba(255, 255, 255, 0.85), transparent), radial-gradient(1px 1px at 26% 78%, rgba(255, 255, 255, 0.4), transparent), radial-gradient(1px 1px at 28% 64%, rgba(255, 255, 255, 0.7), transparent), radial-gradient(1px 1px at 32% 68%, rgba(255, 255, 255, 0.5), transparent), radial-gradient(1.5px 1.5px at 36% 58%, rgba(255, 255, 255, 0.8), transparent), radial-gradient(1px 1px at 38% 62%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1px 1px at 42% 52%, rgba(255, 255, 255, 0.65), transparent), radial-gradient(1px 1px at 44% 56%, rgba(255, 255, 255, 0.45), transparent), radial-gradient(1.5px 1.5px at 48% 46%, rgba(255, 255, 255, 0.9), transparent), radial-gradient(1px 1px at 50% 50%, rgba(255, 255, 255, 0.4), transparent), radial-gradient(1px 1px at 54% 40%, rgba(255, 255, 255, 0.7), transparent), radial-gradient(1px 1px at 56% 44%, rgba(255, 255, 255, 0.5), transparent), radial-gradient(1px 1px at 58% 36%, rgba(255, 255, 255, 0.6), transparent), radial-gradient(1.5px 1.5px at 62% 34%, rgba(255, 255, 255, 0.85), transparent), radial-gradient(1px 1px at 64% 38%, rgba(255, 255, 255, 0.4), transparent), radial-gradient(1px 1px at 68% 28%, rgba(255, 255, 255, 0.75), transparent), radial-gradient(1px 1px at 70% 32%, rgba(255, 255, 255, 0.45), transparent), radial-gradient(1px 1px at 74% 22%, rgba(255, 255, 255, 0.65), transparent), radial-gradient(1.5px 1.5px at 76% 26%, rgba(255, 255, 255, 0.8), transparent), radial-gradient(1px 1px at 80% 18%, rgba(255, 255, 255, 0.55), transparent), radial-gradient(1px 1px at 82% 24%, rgba(255, 255, 255, 0.4), transparent), radial-gradient(1px 1px at 86% 14%, rgba(255, 255, 255, 0.7), transparent), radial-gradient(1px 1px at 88% 20%, rgba(255, 255, 255, 0.5), transparent), radial-gradient(1px 1px at 20% 86%, rgba(255, 255, 255, 0.55), transparent), radial-gradient(1px 1px at 34% 72%, rgba(255, 255, 255, 0.6), transparent), radial-gradient(1px 1px at 46% 54%, rgba(255, 255, 255, 0.45), transparent), radial-gradient(1px 1px at 60% 42%, rgba(255, 255, 255, 0.7), transparent), radial-gradient(1px 1px at 72% 30%, rgba(255, 255, 255, 0.5), transparent), radial-gradient(1px 1px at 84% 16%, rgba(255, 255, 255, 0.65), transparent), radial-gradient(1px 1px at 24% 60%, rgba(255, 255, 255, 0.4), transparent), radial-gradient(1px 1px at 40% 48%, rgba(255, 255, 255, 0.55), transparent), radial-gradient(1px 1px at 52% 36%, rgba(255, 255, 255, 0.75), transparent), radial-gradient(1px 1px at 66% 24%, rgba(255, 255, 255, 0.45), transparent), radial-gradient(1px 1px at 78% 12%, rgba(255, 255, 255, 0.6), transparent), radial-gradient(1px 1px at 30% 54%, rgba(255, 255, 255, 0.5), transparent), radial-gradient(1px 1px at 58% 48%, rgba(255, 255, 255, 0.35), transparent), radial-gradient(1px 1px at 16% 68%, rgba(255, 255, 255, 0.55), transparent), radial-gradient(1px 1px at 90% 22%, rgba(255, 255, 255, 0.5), transparent); }
  .member-profile-card-popover--donor .member-profile-card-popover__shooting-star {
    position: absolute;
    top: var(--mp-star-top, 8%);
    left: var(--mp-star-left, 10%);
    z-index: 1;
    width: 72px;
    height: 1.5px;
    border-radius: 1px;
    pointer-events: none;
    opacity: 0;
    background: linear-gradient(90deg, transparent 0%, rgba(90, 195, 255, 0.55) 58%, rgba(255, 255, 255, 0.95) 100%);
    box-shadow: 0 0 6px rgba(255, 255, 255, 0.35);
    transform-origin: left center;
    will-change: transform, opacity; }
    .member-profile-card-popover--donor .member-profile-card-popover__shooting-star.is-flying {
      animation: member-profile-shooting-star var(--mp-star-duration, 0.65s) ease-out forwards; }
    .member-profile-card-popover--donor .member-profile-card-popover__shooting-star--t1 {
      --mp-star-top: 6%;
      --mp-star-left: 8%;
      --mp-star-angle: 32deg;
      --mp-star-dx: 150px;
      --mp-star-dy: 95px;
      --mp-star-duration: 0.62s; }
    .member-profile-card-popover--donor .member-profile-card-popover__shooting-star--t2 {
      --mp-star-top: 14%;
      --mp-star-left: 22%;
      --mp-star-angle: 40deg;
      --mp-star-dx: 130px;
      --mp-star-dy: 110px;
      --mp-star-duration: 0.7s; }
    .member-profile-card-popover--donor .member-profile-card-popover__shooting-star--t3 {
      --mp-star-top: 4%;
      --mp-star-left: 36%;
      --mp-star-angle: 48deg;
      --mp-star-dx: 110px;
      --mp-star-dy: 125px;
      --mp-star-duration: 0.58s; }
    .member-profile-card-popover--donor .member-profile-card-popover__shooting-star--t4 {
      --mp-star-top: 22%;
      --mp-star-left: 4%;
      --mp-star-angle: 28deg;
      --mp-star-dx: 160px;
      --mp-star-dy: 85px;
      --mp-star-duration: 0.75s; }
    .member-profile-card-popover--donor .member-profile-card-popover__shooting-star--t5 {
      --mp-star-top: 10%;
      --mp-star-left: 48%;
      --mp-star-angle: 44deg;
      --mp-star-dx: 100px;
      --mp-star-dy: 100px;
      --mp-star-duration: 0.6s; }
    .member-profile-card-popover--donor .member-profile-card-popover__shooting-star--t6 {
      --mp-star-top: 28%;
      --mp-star-left: 16%;
      --mp-star-angle: 36deg;
      --mp-star-dx: 140px;
      --mp-star-dy: 105px;
      --mp-star-duration: 0.68s; }
    .member-profile-card-popover--donor .member-profile-card-popover__shooting-star--t7 {
      --mp-star-top: 2%;
      --mp-star-left: 18%;
      --mp-star-angle: 38deg;
      --mp-star-dx: 145px;
      --mp-star-dy: 115px;
      --mp-star-duration: 0.72s; }
    .member-profile-card-popover--donor .member-profile-card-popover__shooting-star--t8 {
      --mp-star-top: 18%;
      --mp-star-left: 30%;
      --mp-star-angle: 50deg;
      --mp-star-dx: 95px;
      --mp-star-dy: 130px;
      --mp-star-duration: 0.55s; }

@keyframes member-profile-shooting-star {
  0% {
    opacity: 0;
    transform: translate(0, 0) rotate(var(--mp-star-angle, 38deg)); }
  10% {
    opacity: 1; }
  70% {
    opacity: 0.85; }
  100% {
    opacity: 0;
    transform: translate(var(--mp-star-dx, 140px), var(--mp-star-dy, 100px)) rotate(var(--mp-star-angle, 38deg)); } }
  @media (prefers-reduced-motion: reduce) {
    .member-profile-card-popover--donor .member-profile-card-popover__shooting-star {
      display: none; } }
  .member-profile-card-popover--donor .member-profile-card__handle {
    color: rgba(184, 184, 184, 0.78); }

.member-profile-card-popover--donor-premium::before {
  animation: member-profile-nebula-morph-a 28.8s ease-in-out infinite; }

.member-profile-card-popover--donor-premium .member-profile-card-popover__nebula-morph {
  position: absolute;
  inset: -14%;
  z-index: 0;
  pointer-events: none;
  border-radius: inherit;
  will-change: transform, opacity;
  background-image: radial-gradient(ellipse 40% 26% at 30% 62%, rgba(90, 195, 255, 0.34) 0%, transparent 70%), radial-gradient(ellipse 36% 20% at 58% 38%, rgba(90, 195, 255, 0.28) 0%, transparent 72%), radial-gradient(ellipse 32% 24% at 72% 48%, rgba(58, 120, 180, 0.3) 0%, transparent 68%), radial-gradient(ellipse 28% 16% at 44% 28%, rgba(22, 58, 95, 0.32) 0%, transparent 74%), radial-gradient(ellipse 22% 30% at 20% 48%, rgba(58, 120, 180, 0.2) 0%, transparent 75%), radial-gradient(ellipse 18% 14% at 82% 22%, rgba(90, 195, 255, 0.26) 0%, transparent 70%);
  animation: member-profile-nebula-morph-b 36.9s ease-in-out infinite; }

@keyframes member-profile-nebula-morph-a {
  0%,
  100% {
    transform: translate3d(0, 0, 0) scale(1, 1) skew(0deg, 0deg); }
  18% {
    transform: translate3d(1.44%, -2.64%, 0) scale(1.084, 0.916) skew(1.32deg, -0.48deg); }
  36% {
    transform: translate3d(-2.88%, -0.72%, 0) scale(0.916, 1.108) skew(-1.08deg, 0.84deg); }
  54% {
    transform: translate3d(-0.96%, 3.12%, 0) scale(1.06, 0.928) skew(0.6deg, 1.08deg); }
  72% {
    transform: translate3d(2.64%, 1.32%, 0) scale(0.94, 1.084) skew(-1.2deg, -0.6deg); }
  88% {
    transform: translate3d(0.72%, -1.68%, 0) scale(1.036, 0.964) skew(0.48deg, 0.36deg); } }

@keyframes member-profile-nebula-morph-b {
  0%,
  100% {
    transform: translate3d(0, 0, 0) scale(1.012, 0.988) skew(0deg, 0deg);
    opacity: 0.18; }
  22% {
    transform: translate3d(-3.36%, 2.16%, 0) scale(0.88, 1.144) skew(-1.44deg, 0.72deg);
    opacity: 0.62; }
  44% {
    transform: translate3d(2.88%, 3.36%, 0) scale(1.144, 0.856) skew(1.08deg, -0.96deg);
    opacity: 0.3; }
  66% {
    transform: translate3d(1.44%, -3.12%, 0) scale(0.928, 1.12) skew(-0.6deg, 1.2deg);
    opacity: 0.66; }
  84% {
    transform: translate3d(-1.92%, -0.96%, 0) scale(1.072, 0.928) skew(0.84deg, -0.36deg);
    opacity: 0.26; } }

@media (prefers-reduced-motion: reduce) {
  .member-profile-card-popover--donor-premium::before,
  .member-profile-card-popover--donor-premium .member-profile-card-popover__nebula-morph {
    animation: none; }
  .member-profile-card-popover--donor-premium .member-profile-card-popover__nebula-morph {
    opacity: 0.25; } }

.member-profile-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 17px 14px;
  color: #b8b8b8;
  font-size: 13px; }

.member-profile-card__hero {
  display: flex;
  align-items: center;
  gap: 12px; }

.member-profile-card__avatar-stack {
  position: relative;
  width: 56px;
  height: 56px;
  flex-shrink: 0; }

.member-profile-card__hero-avatar {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 56px;
  height: 56px;
  border-radius: 50%;
  object-fit: cover;
  z-index: 1; }
  .member-profile-card__hero-avatar.member-profile-card__hero-avatar--placeholder {
    display: block;
    background: #747b81;
    opacity: 0.35; }

.member-profile-card__avatar-ring {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 2px solid #5ac3ff;
  box-sizing: border-box;
  z-index: 2;
  pointer-events: none; }

.member-profile-card__avatar-halo {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  border-radius: 50%;
  z-index: 0;
  pointer-events: none; }

.member-profile-card__hero-text {
  min-width: 0;
  flex: 1 1 auto; }

.member-profile-card__org-icon {
  width: 40px;
  height: 40px;
  object-fit: contain;
  flex-shrink: 0;
  margin-left: auto;
  align-self: center; }

.member-profile-card__discord-name {
  font-weight: 600;
  font-size: 15px;
  color: #ffffff;
  line-height: 1.25;
  word-break: break-word; }

.member-profile-card__handle {
  margin-top: 2px;
  color: #747b81;
  font-size: 12px; }

.member-profile-card__donor {
  margin-top: 6px;
  gap: 6px;
  padding: 3px 8px 3px 6px;
  border-radius: 8px;
  border: 1px solid transparent; }
  .member-profile-card__donor:has(.donor-gem-badge__wrap--one-time) {
    border-color: rgba(58, 120, 180, 0.35);
    background: rgba(58, 120, 180, 0.12);
    color: #3a78b4; }
    .member-profile-card__donor:has(.donor-gem-badge__wrap--one-time) .donor-gem-badge__label {
      color: #3a78b4; }
  .member-profile-card__donor:has(.donor-gem-badge__wrap--subscriber) {
    border-color: rgba(121, 88, 195, 0.35);
    background: rgba(121, 88, 195, 0.12);
    color: #7958c3; }
    .member-profile-card__donor:has(.donor-gem-badge__wrap--subscriber) .donor-gem-badge__label {
      color: #7958c3; }
  .member-profile-card__donor:has(.donor-gem-badge__wrap--premium) {
    border-color: rgba(232, 197, 71, 0.4);
    background: rgba(232, 197, 71, 0.12);
    color: #e8c547; }
    .member-profile-card__donor:has(.donor-gem-badge__wrap--premium) .donor-gem-badge__label {
      color: #f5df8a; }
  .member-profile-card__donor:has(.donor-gem-badge__wrap--inactive) {
    border-color: rgba(116, 123, 129, 0.35);
    background: rgba(116, 123, 129, 0.1);
    color: #747b81; }
    .member-profile-card__donor:has(.donor-gem-badge__wrap--inactive) .donor-gem-badge__label {
      color: #747b81; }
  .member-profile-card__donor .donor-gem-badge__label {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.02em;
    line-height: 1.2; }
  .member-profile-card__donor .donor-gem-badge__wrap {
    z-index: 1; }
  .member-profile-card__donor .donor-gem-badge__tooltip {
    top: auto;
    bottom: calc(100% + 6px);
    transform: translateY(2px); }
  .member-profile-card__donor .donor-gem-badge__wrap:hover .donor-gem-badge__tooltip,
  .member-profile-card__donor .donor-gem-badge__wrap:focus-within .donor-gem-badge__tooltip {
    transform: translateY(0); }

.member-profile-card__status {
  font-size: 12px;
  color: #747b81; }
  .member-profile-card__status.member-profile-card__status--error {
    color: #d12323; }

.member-profile-card__body {
  display: flex;
  flex-direction: column;
  gap: 8px; }

.member-profile-card__line {
  margin: 0;
  word-break: break-word;
  line-height: 1.35;
  font-size: medium; }
  .member-profile-card__line.member-profile-card__line--accent {
    color: #5ac3ff; }

.member-profile-card__groups {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center; }

.member-profile-card__rank {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  flex-wrap: nowrap; }

.member-profile-card__rank-label {
  min-width: 0;
  flex: 1 1 auto;
  line-height: 1.35;
  font-size: medium;
  font-weight: 500; }
  .member-profile-card__rank-label.member-profile-card__rank-label--unranked {
    font-weight: 400;
    color: #747b81; }

.member-profile-card__pay-grade-chip {
  margin-left: auto;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  padding: 2px 7px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1.2;
  color: #5ac3ff;
  border: 1px solid rgba(90, 195, 255, 0.4);
  background: rgba(58, 120, 180, 0.14); }

.member-profile-card__rank-img {
  width: auto;
  height: 22px;
  object-fit: contain;
  flex-shrink: 0; }

.member-profile-card__super-admin {
  align-self: flex-end;
  display: inline-flex;
  align-items: center;
  margin-top: 8px;
  padding: 2px 7px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1.2;
  color: #dfdfdf;
  border: 1px solid rgba(158, 34, 34, 0.45);
  background: rgba(73, 18, 18, 0.45); }

.perk-theme-frame-halo {
  position: absolute;
  inset: 0;
  z-index: 12;
  pointer-events: none;
  border-radius: inherit; }

.perk-theme-frame-halo--spiral {
  z-index: 13;
  overflow: hidden; }

.perk-theme-frame-halo--frost {
  z-index: 13;
  overflow: hidden; }

.perk-theme-frame-halo__canvas {
  display: block;
  width: 100%;
  height: 100%;
  pointer-events: none; }

.perk-theme-underlay {
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  pointer-events: none; }

.perk-theme-underlay__layer {
  position: absolute;
  inset: 0;
  pointer-events: none; }

.perk-theme-underlay__layer--starfield {
  z-index: 0; }

.perk-theme-underlay__starfield-canvas {
  display: block;
  width: 100%;
  height: 100%;
  pointer-events: none; }

.perk-theme-overlay {
  position: absolute;
  inset: 0;
  z-index: 4;
  overflow: hidden;
  pointer-events: none; }

.roster-file-summary-hero__donor-space .perk-theme-overlay {
  z-index: 4; }

.member-profile-card-popover .perk-theme-overlay {
  z-index: 1; }

.perk-theme-overlay__layer {
  position: absolute;
  inset: 0;
  pointer-events: none; }

.perk-theme-overlay__rain-row {
  position: absolute;
  inset: 0;
  overflow: hidden; }
  .perk-theme-overlay__rain-row--back {
    opacity: 0.55;
    z-index: 0; }
  .perk-theme-overlay__rain-row--front {
    opacity: 0.85;
    z-index: 1; }

.perk-theme-overlay__rain-drop {
  position: absolute;
  bottom: 100%;
  width: 6px;
  height: 48px;
  pointer-events: none;
  animation-name: perk-theme-rain-drop;
  animation-timing-function: linear;
  animation-iteration-count: infinite; }

.perk-theme-overlay__rain-stem {
  display: block;
  width: 1px;
  height: 70%;
  margin-left: 2px;
  border-radius: 0;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.38));
  box-shadow: none;
  animation-name: perk-theme-rain-stem;
  animation-timing-function: linear;
  animation-iteration-count: infinite; }

.perk-theme-overlay__rain-row--back .perk-theme-overlay__rain-stem {
  width: 1px;
  height: 55%;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.22)); }

.perk-theme-overlay__rain-drop--front-0 {
  left: 0%;
  bottom: 100%;
  height: 34px;
  animation-delay: 0ms;
  animation-duration: 480ms; }
  .perk-theme-overlay__rain-drop--front-0 .perk-theme-overlay__rain-stem {
    animation-delay: 0ms;
    animation-duration: 480ms; }

.perk-theme-overlay__rain-drop--front-1 {
  left: 8%;
  bottom: 101%;
  height: 39px;
  animation-delay: 78ms;
  animation-duration: 493ms; }
  .perk-theme-overlay__rain-drop--front-1 .perk-theme-overlay__rain-stem {
    animation-delay: 78ms;
    animation-duration: 493ms; }

.perk-theme-overlay__rain-drop--front-2 {
  left: 16%;
  bottom: 102%;
  height: 44px;
  animation-delay: 71ms;
  animation-duration: 506ms; }
  .perk-theme-overlay__rain-drop--front-2 .perk-theme-overlay__rain-stem {
    animation-delay: 71ms;
    animation-duration: 506ms; }

.perk-theme-overlay__rain-drop--front-3 {
  left: 17%;
  bottom: 103%;
  height: 49px;
  animation-delay: 149ms;
  animation-duration: 519ms; }
  .perk-theme-overlay__rain-drop--front-3 .perk-theme-overlay__rain-stem {
    animation-delay: 149ms;
    animation-duration: 519ms; }

.perk-theme-overlay__rain-drop--front-4 {
  left: 25%;
  bottom: 104%;
  height: 54px;
  animation-delay: 142ms;
  animation-duration: 532ms; }
  .perk-theme-overlay__rain-drop--front-4 .perk-theme-overlay__rain-stem {
    animation-delay: 142ms;
    animation-duration: 532ms; }

.perk-theme-overlay__rain-drop--front-5 {
  left: 26%;
  bottom: 105%;
  height: 59px;
  animation-delay: 135ms;
  animation-duration: 545ms; }
  .perk-theme-overlay__rain-drop--front-5 .perk-theme-overlay__rain-stem {
    animation-delay: 135ms;
    animation-duration: 545ms; }

.perk-theme-overlay__rain-drop--front-6 {
  left: 34%;
  bottom: 100%;
  height: 34px;
  animation-delay: 213ms;
  animation-duration: 558ms; }
  .perk-theme-overlay__rain-drop--front-6 .perk-theme-overlay__rain-stem {
    animation-delay: 213ms;
    animation-duration: 558ms; }

.perk-theme-overlay__rain-drop--front-7 {
  left: 35%;
  bottom: 101%;
  height: 39px;
  animation-delay: 206ms;
  animation-duration: 571ms; }
  .perk-theme-overlay__rain-drop--front-7 .perk-theme-overlay__rain-stem {
    animation-delay: 206ms;
    animation-duration: 571ms; }

.perk-theme-overlay__rain-drop--front-8 {
  left: 43%;
  bottom: 102%;
  height: 44px;
  animation-delay: 199ms;
  animation-duration: 584ms; }
  .perk-theme-overlay__rain-drop--front-8 .perk-theme-overlay__rain-stem {
    animation-delay: 199ms;
    animation-duration: 584ms; }

.perk-theme-overlay__rain-drop--front-9 {
  left: 51%;
  bottom: 103%;
  height: 49px;
  animation-delay: 277ms;
  animation-duration: 597ms; }
  .perk-theme-overlay__rain-drop--front-9 .perk-theme-overlay__rain-stem {
    animation-delay: 277ms;
    animation-duration: 597ms; }

.perk-theme-overlay__rain-drop--front-10 {
  left: 52%;
  bottom: 104%;
  height: 54px;
  animation-delay: 270ms;
  animation-duration: 610ms; }
  .perk-theme-overlay__rain-drop--front-10 .perk-theme-overlay__rain-stem {
    animation-delay: 270ms;
    animation-duration: 610ms; }

.perk-theme-overlay__rain-drop--front-11 {
  left: 60%;
  bottom: 105%;
  height: 59px;
  animation-delay: 263ms;
  animation-duration: 623ms; }
  .perk-theme-overlay__rain-drop--front-11 .perk-theme-overlay__rain-stem {
    animation-delay: 263ms;
    animation-duration: 623ms; }

.perk-theme-overlay__rain-drop--front-12 {
  left: 61%;
  bottom: 100%;
  height: 34px;
  animation-delay: 341ms;
  animation-duration: 636ms; }
  .perk-theme-overlay__rain-drop--front-12 .perk-theme-overlay__rain-stem {
    animation-delay: 341ms;
    animation-duration: 636ms; }

.perk-theme-overlay__rain-drop--front-13 {
  left: 69%;
  bottom: 101%;
  height: 39px;
  animation-delay: 334ms;
  animation-duration: 649ms; }
  .perk-theme-overlay__rain-drop--front-13 .perk-theme-overlay__rain-stem {
    animation-delay: 334ms;
    animation-duration: 649ms; }

.perk-theme-overlay__rain-drop--front-14 {
  left: 70%;
  bottom: 102%;
  height: 44px;
  animation-delay: 327ms;
  animation-duration: 662ms; }
  .perk-theme-overlay__rain-drop--front-14 .perk-theme-overlay__rain-stem {
    animation-delay: 327ms;
    animation-duration: 662ms; }

.perk-theme-overlay__rain-drop--front-15 {
  left: 78%;
  bottom: 103%;
  height: 49px;
  animation-delay: 405ms;
  animation-duration: 675ms; }
  .perk-theme-overlay__rain-drop--front-15 .perk-theme-overlay__rain-stem {
    animation-delay: 405ms;
    animation-duration: 675ms; }

.perk-theme-overlay__rain-drop--front-16 {
  left: 86%;
  bottom: 104%;
  height: 54px;
  animation-delay: 398ms;
  animation-duration: 688ms; }
  .perk-theme-overlay__rain-drop--front-16 .perk-theme-overlay__rain-stem {
    animation-delay: 398ms;
    animation-duration: 688ms; }

.perk-theme-overlay__rain-drop--front-17 {
  left: 87%;
  bottom: 105%;
  height: 59px;
  animation-delay: 391ms;
  animation-duration: 701ms; }
  .perk-theme-overlay__rain-drop--front-17 .perk-theme-overlay__rain-stem {
    animation-delay: 391ms;
    animation-duration: 701ms; }

.perk-theme-overlay__rain-drop--front-18 {
  left: 95%;
  bottom: 100%;
  height: 34px;
  animation-delay: 469ms;
  animation-duration: 714ms; }
  .perk-theme-overlay__rain-drop--front-18 .perk-theme-overlay__rain-stem {
    animation-delay: 469ms;
    animation-duration: 714ms; }

.perk-theme-overlay__rain-drop--front-19 {
  left: 96%;
  bottom: 101%;
  height: 39px;
  animation-delay: 462ms;
  animation-duration: 727ms; }
  .perk-theme-overlay__rain-drop--front-19 .perk-theme-overlay__rain-stem {
    animation-delay: 462ms;
    animation-duration: 727ms; }

.perk-theme-overlay__rain-drop--front-20 {
  left: 4%;
  bottom: 102%;
  height: 44px;
  animation-delay: 540ms;
  animation-duration: 480ms; }
  .perk-theme-overlay__rain-drop--front-20 .perk-theme-overlay__rain-stem {
    animation-delay: 540ms;
    animation-duration: 480ms; }

.perk-theme-overlay__rain-drop--front-21 {
  left: 5%;
  bottom: 103%;
  height: 49px;
  animation-delay: 533ms;
  animation-duration: 493ms; }
  .perk-theme-overlay__rain-drop--front-21 .perk-theme-overlay__rain-stem {
    animation-delay: 533ms;
    animation-duration: 493ms; }

.perk-theme-overlay__rain-drop--front-22 {
  left: 13%;
  bottom: 104%;
  height: 54px;
  animation-delay: 526ms;
  animation-duration: 506ms; }
  .perk-theme-overlay__rain-drop--front-22 .perk-theme-overlay__rain-stem {
    animation-delay: 526ms;
    animation-duration: 506ms; }

.perk-theme-overlay__rain-drop--front-23 {
  left: 21%;
  bottom: 105%;
  height: 59px;
  animation-delay: 604ms;
  animation-duration: 519ms; }
  .perk-theme-overlay__rain-drop--front-23 .perk-theme-overlay__rain-stem {
    animation-delay: 604ms;
    animation-duration: 519ms; }

.perk-theme-overlay__rain-drop--front-24 {
  left: 22%;
  bottom: 100%;
  height: 34px;
  animation-delay: 597ms;
  animation-duration: 532ms; }
  .perk-theme-overlay__rain-drop--front-24 .perk-theme-overlay__rain-stem {
    animation-delay: 597ms;
    animation-duration: 532ms; }

.perk-theme-overlay__rain-drop--front-25 {
  left: 30%;
  bottom: 101%;
  height: 39px;
  animation-delay: 590ms;
  animation-duration: 545ms; }
  .perk-theme-overlay__rain-drop--front-25 .perk-theme-overlay__rain-stem {
    animation-delay: 590ms;
    animation-duration: 545ms; }

.perk-theme-overlay__rain-drop--front-26 {
  left: 31%;
  bottom: 102%;
  height: 44px;
  animation-delay: 668ms;
  animation-duration: 558ms; }
  .perk-theme-overlay__rain-drop--front-26 .perk-theme-overlay__rain-stem {
    animation-delay: 668ms;
    animation-duration: 558ms; }

.perk-theme-overlay__rain-drop--front-27 {
  left: 39%;
  bottom: 103%;
  height: 49px;
  animation-delay: 661ms;
  animation-duration: 571ms; }
  .perk-theme-overlay__rain-drop--front-27 .perk-theme-overlay__rain-stem {
    animation-delay: 661ms;
    animation-duration: 571ms; }

.perk-theme-overlay__rain-drop--front-28 {
  left: 40%;
  bottom: 104%;
  height: 54px;
  animation-delay: 654ms;
  animation-duration: 584ms; }
  .perk-theme-overlay__rain-drop--front-28 .perk-theme-overlay__rain-stem {
    animation-delay: 654ms;
    animation-duration: 584ms; }

.perk-theme-overlay__rain-drop--front-29 {
  left: 48%;
  bottom: 105%;
  height: 59px;
  animation-delay: 732ms;
  animation-duration: 597ms; }
  .perk-theme-overlay__rain-drop--front-29 .perk-theme-overlay__rain-stem {
    animation-delay: 732ms;
    animation-duration: 597ms; }

.perk-theme-overlay__rain-drop--front-30 {
  left: 56%;
  bottom: 100%;
  height: 34px;
  animation-delay: 725ms;
  animation-duration: 610ms; }
  .perk-theme-overlay__rain-drop--front-30 .perk-theme-overlay__rain-stem {
    animation-delay: 725ms;
    animation-duration: 610ms; }

.perk-theme-overlay__rain-drop--front-31 {
  left: 57%;
  bottom: 101%;
  height: 39px;
  animation-delay: 718ms;
  animation-duration: 623ms; }
  .perk-theme-overlay__rain-drop--front-31 .perk-theme-overlay__rain-stem {
    animation-delay: 718ms;
    animation-duration: 623ms; }

.perk-theme-overlay__rain-drop--front-32 {
  left: 65%;
  bottom: 102%;
  height: 44px;
  animation-delay: 796ms;
  animation-duration: 636ms; }
  .perk-theme-overlay__rain-drop--front-32 .perk-theme-overlay__rain-stem {
    animation-delay: 796ms;
    animation-duration: 636ms; }

.perk-theme-overlay__rain-drop--front-33 {
  left: 66%;
  bottom: 103%;
  height: 49px;
  animation-delay: 789ms;
  animation-duration: 649ms; }
  .perk-theme-overlay__rain-drop--front-33 .perk-theme-overlay__rain-stem {
    animation-delay: 789ms;
    animation-duration: 649ms; }

.perk-theme-overlay__rain-drop--front-34 {
  left: 74%;
  bottom: 104%;
  height: 54px;
  animation-delay: 782ms;
  animation-duration: 662ms; }
  .perk-theme-overlay__rain-drop--front-34 .perk-theme-overlay__rain-stem {
    animation-delay: 782ms;
    animation-duration: 662ms; }

.perk-theme-overlay__rain-drop--front-35 {
  left: 75%;
  bottom: 105%;
  height: 59px;
  animation-delay: 860ms;
  animation-duration: 675ms; }
  .perk-theme-overlay__rain-drop--front-35 .perk-theme-overlay__rain-stem {
    animation-delay: 860ms;
    animation-duration: 675ms; }

.perk-theme-overlay__rain-drop--front-36 {
  left: 83%;
  bottom: 100%;
  height: 34px;
  animation-delay: 853ms;
  animation-duration: 688ms; }
  .perk-theme-overlay__rain-drop--front-36 .perk-theme-overlay__rain-stem {
    animation-delay: 853ms;
    animation-duration: 688ms; }

.perk-theme-overlay__rain-drop--front-37 {
  left: 91%;
  bottom: 101%;
  height: 39px;
  animation-delay: 931ms;
  animation-duration: 701ms; }
  .perk-theme-overlay__rain-drop--front-37 .perk-theme-overlay__rain-stem {
    animation-delay: 931ms;
    animation-duration: 701ms; }

.perk-theme-overlay__rain-drop--front-38 {
  left: 92%;
  bottom: 102%;
  height: 44px;
  animation-delay: 924ms;
  animation-duration: 714ms; }
  .perk-theme-overlay__rain-drop--front-38 .perk-theme-overlay__rain-stem {
    animation-delay: 924ms;
    animation-duration: 714ms; }

.perk-theme-overlay__rain-drop--front-39 {
  left: 0%;
  bottom: 103%;
  height: 49px;
  animation-delay: 917ms;
  animation-duration: 727ms; }
  .perk-theme-overlay__rain-drop--front-39 .perk-theme-overlay__rain-stem {
    animation-delay: 917ms;
    animation-duration: 727ms; }

.perk-theme-overlay__rain-drop--front-40 {
  left: 1%;
  bottom: 104%;
  height: 54px;
  animation-delay: 995ms;
  animation-duration: 480ms; }
  .perk-theme-overlay__rain-drop--front-40 .perk-theme-overlay__rain-stem {
    animation-delay: 995ms;
    animation-duration: 480ms; }

.perk-theme-overlay__rain-drop--front-41 {
  left: 9%;
  bottom: 105%;
  height: 59px;
  animation-delay: 988ms;
  animation-duration: 493ms; }
  .perk-theme-overlay__rain-drop--front-41 .perk-theme-overlay__rain-stem {
    animation-delay: 988ms;
    animation-duration: 493ms; }

.perk-theme-overlay__rain-drop--front-42 {
  left: 10%;
  bottom: 100%;
  height: 34px;
  animation-delay: 981ms;
  animation-duration: 506ms; }
  .perk-theme-overlay__rain-drop--front-42 .perk-theme-overlay__rain-stem {
    animation-delay: 981ms;
    animation-duration: 506ms; }

.perk-theme-overlay__rain-drop--front-43 {
  left: 18%;
  bottom: 101%;
  height: 39px;
  animation-delay: 59ms;
  animation-duration: 519ms; }
  .perk-theme-overlay__rain-drop--front-43 .perk-theme-overlay__rain-stem {
    animation-delay: 59ms;
    animation-duration: 519ms; }

.perk-theme-overlay__rain-drop--front-44 {
  left: 26%;
  bottom: 102%;
  height: 44px;
  animation-delay: 52ms;
  animation-duration: 532ms; }
  .perk-theme-overlay__rain-drop--front-44 .perk-theme-overlay__rain-stem {
    animation-delay: 52ms;
    animation-duration: 532ms; }

.perk-theme-overlay__rain-drop--front-45 {
  left: 27%;
  bottom: 103%;
  height: 49px;
  animation-delay: 45ms;
  animation-duration: 545ms; }
  .perk-theme-overlay__rain-drop--front-45 .perk-theme-overlay__rain-stem {
    animation-delay: 45ms;
    animation-duration: 545ms; }

.perk-theme-overlay__rain-drop--front-46 {
  left: 35%;
  bottom: 104%;
  height: 54px;
  animation-delay: 123ms;
  animation-duration: 558ms; }
  .perk-theme-overlay__rain-drop--front-46 .perk-theme-overlay__rain-stem {
    animation-delay: 123ms;
    animation-duration: 558ms; }

.perk-theme-overlay__rain-drop--front-47 {
  left: 36%;
  bottom: 105%;
  height: 59px;
  animation-delay: 116ms;
  animation-duration: 571ms; }
  .perk-theme-overlay__rain-drop--front-47 .perk-theme-overlay__rain-stem {
    animation-delay: 116ms;
    animation-duration: 571ms; }

.perk-theme-overlay__rain-drop--front-48 {
  left: 44%;
  bottom: 100%;
  height: 34px;
  animation-delay: 109ms;
  animation-duration: 584ms; }
  .perk-theme-overlay__rain-drop--front-48 .perk-theme-overlay__rain-stem {
    animation-delay: 109ms;
    animation-duration: 584ms; }

.perk-theme-overlay__rain-drop--front-49 {
  left: 45%;
  bottom: 101%;
  height: 39px;
  animation-delay: 187ms;
  animation-duration: 597ms; }
  .perk-theme-overlay__rain-drop--front-49 .perk-theme-overlay__rain-stem {
    animation-delay: 187ms;
    animation-duration: 597ms; }

.perk-theme-overlay__rain-drop--front-50 {
  left: 53%;
  bottom: 102%;
  height: 44px;
  animation-delay: 180ms;
  animation-duration: 610ms; }
  .perk-theme-overlay__rain-drop--front-50 .perk-theme-overlay__rain-stem {
    animation-delay: 180ms;
    animation-duration: 610ms; }

.perk-theme-overlay__rain-drop--front-51 {
  left: 61%;
  bottom: 103%;
  height: 49px;
  animation-delay: 173ms;
  animation-duration: 623ms; }
  .perk-theme-overlay__rain-drop--front-51 .perk-theme-overlay__rain-stem {
    animation-delay: 173ms;
    animation-duration: 623ms; }

.perk-theme-overlay__rain-drop--front-52 {
  left: 62%;
  bottom: 104%;
  height: 54px;
  animation-delay: 251ms;
  animation-duration: 636ms; }
  .perk-theme-overlay__rain-drop--front-52 .perk-theme-overlay__rain-stem {
    animation-delay: 251ms;
    animation-duration: 636ms; }

.perk-theme-overlay__rain-drop--front-53 {
  left: 70%;
  bottom: 105%;
  height: 59px;
  animation-delay: 244ms;
  animation-duration: 649ms; }
  .perk-theme-overlay__rain-drop--front-53 .perk-theme-overlay__rain-stem {
    animation-delay: 244ms;
    animation-duration: 649ms; }

.perk-theme-overlay__rain-drop--front-54 {
  left: 71%;
  bottom: 100%;
  height: 34px;
  animation-delay: 322ms;
  animation-duration: 662ms; }
  .perk-theme-overlay__rain-drop--front-54 .perk-theme-overlay__rain-stem {
    animation-delay: 322ms;
    animation-duration: 662ms; }

.perk-theme-overlay__rain-drop--front-55 {
  left: 79%;
  bottom: 101%;
  height: 39px;
  animation-delay: 315ms;
  animation-duration: 675ms; }
  .perk-theme-overlay__rain-drop--front-55 .perk-theme-overlay__rain-stem {
    animation-delay: 315ms;
    animation-duration: 675ms; }

.perk-theme-overlay__rain-drop--front-56 {
  left: 80%;
  bottom: 102%;
  height: 44px;
  animation-delay: 308ms;
  animation-duration: 688ms; }
  .perk-theme-overlay__rain-drop--front-56 .perk-theme-overlay__rain-stem {
    animation-delay: 308ms;
    animation-duration: 688ms; }

.perk-theme-overlay__rain-drop--front-57 {
  left: 88%;
  bottom: 103%;
  height: 49px;
  animation-delay: 386ms;
  animation-duration: 701ms; }
  .perk-theme-overlay__rain-drop--front-57 .perk-theme-overlay__rain-stem {
    animation-delay: 386ms;
    animation-duration: 701ms; }

.perk-theme-overlay__rain-drop--front-58 {
  left: 96%;
  bottom: 104%;
  height: 54px;
  animation-delay: 379ms;
  animation-duration: 714ms; }
  .perk-theme-overlay__rain-drop--front-58 .perk-theme-overlay__rain-stem {
    animation-delay: 379ms;
    animation-duration: 714ms; }

.perk-theme-overlay__rain-drop--front-59 {
  left: 97%;
  bottom: 105%;
  height: 59px;
  animation-delay: 372ms;
  animation-duration: 727ms; }
  .perk-theme-overlay__rain-drop--front-59 .perk-theme-overlay__rain-stem {
    animation-delay: 372ms;
    animation-duration: 727ms; }

.perk-theme-overlay__rain-drop--front-60 {
  left: 5%;
  bottom: 100%;
  height: 34px;
  animation-delay: 450ms;
  animation-duration: 480ms; }
  .perk-theme-overlay__rain-drop--front-60 .perk-theme-overlay__rain-stem {
    animation-delay: 450ms;
    animation-duration: 480ms; }

.perk-theme-overlay__rain-drop--front-61 {
  left: 6%;
  bottom: 101%;
  height: 39px;
  animation-delay: 443ms;
  animation-duration: 493ms; }
  .perk-theme-overlay__rain-drop--front-61 .perk-theme-overlay__rain-stem {
    animation-delay: 443ms;
    animation-duration: 493ms; }

.perk-theme-overlay__rain-drop--front-62 {
  left: 14%;
  bottom: 102%;
  height: 44px;
  animation-delay: 436ms;
  animation-duration: 506ms; }
  .perk-theme-overlay__rain-drop--front-62 .perk-theme-overlay__rain-stem {
    animation-delay: 436ms;
    animation-duration: 506ms; }

.perk-theme-overlay__rain-drop--front-63 {
  left: 15%;
  bottom: 103%;
  height: 49px;
  animation-delay: 514ms;
  animation-duration: 519ms; }
  .perk-theme-overlay__rain-drop--front-63 .perk-theme-overlay__rain-stem {
    animation-delay: 514ms;
    animation-duration: 519ms; }

.perk-theme-overlay__rain-drop--front-64 {
  left: 23%;
  bottom: 104%;
  height: 54px;
  animation-delay: 507ms;
  animation-duration: 532ms; }
  .perk-theme-overlay__rain-drop--front-64 .perk-theme-overlay__rain-stem {
    animation-delay: 507ms;
    animation-duration: 532ms; }

.perk-theme-overlay__rain-drop--front-65 {
  left: 31%;
  bottom: 105%;
  height: 59px;
  animation-delay: 500ms;
  animation-duration: 545ms; }
  .perk-theme-overlay__rain-drop--front-65 .perk-theme-overlay__rain-stem {
    animation-delay: 500ms;
    animation-duration: 545ms; }

.perk-theme-overlay__rain-drop--front-66 {
  left: 32%;
  bottom: 100%;
  height: 34px;
  animation-delay: 578ms;
  animation-duration: 558ms; }
  .perk-theme-overlay__rain-drop--front-66 .perk-theme-overlay__rain-stem {
    animation-delay: 578ms;
    animation-duration: 558ms; }

.perk-theme-overlay__rain-drop--front-67 {
  left: 40%;
  bottom: 101%;
  height: 39px;
  animation-delay: 571ms;
  animation-duration: 571ms; }
  .perk-theme-overlay__rain-drop--front-67 .perk-theme-overlay__rain-stem {
    animation-delay: 571ms;
    animation-duration: 571ms; }

.perk-theme-overlay__rain-drop--front-68 {
  left: 41%;
  bottom: 102%;
  height: 44px;
  animation-delay: 564ms;
  animation-duration: 584ms; }
  .perk-theme-overlay__rain-drop--front-68 .perk-theme-overlay__rain-stem {
    animation-delay: 564ms;
    animation-duration: 584ms; }

.perk-theme-overlay__rain-drop--front-69 {
  left: 49%;
  bottom: 103%;
  height: 49px;
  animation-delay: 642ms;
  animation-duration: 597ms; }
  .perk-theme-overlay__rain-drop--front-69 .perk-theme-overlay__rain-stem {
    animation-delay: 642ms;
    animation-duration: 597ms; }

.perk-theme-overlay__rain-drop--front-70 {
  left: 50%;
  bottom: 104%;
  height: 54px;
  animation-delay: 635ms;
  animation-duration: 610ms; }
  .perk-theme-overlay__rain-drop--front-70 .perk-theme-overlay__rain-stem {
    animation-delay: 635ms;
    animation-duration: 610ms; }

.perk-theme-overlay__rain-drop--front-71 {
  left: 58%;
  bottom: 105%;
  height: 59px;
  animation-delay: 713ms;
  animation-duration: 623ms; }
  .perk-theme-overlay__rain-drop--front-71 .perk-theme-overlay__rain-stem {
    animation-delay: 713ms;
    animation-duration: 623ms; }

.perk-theme-overlay__rain-drop--front-72 {
  left: 66%;
  bottom: 100%;
  height: 34px;
  animation-delay: 706ms;
  animation-duration: 636ms; }
  .perk-theme-overlay__rain-drop--front-72 .perk-theme-overlay__rain-stem {
    animation-delay: 706ms;
    animation-duration: 636ms; }

.perk-theme-overlay__rain-drop--front-73 {
  left: 67%;
  bottom: 101%;
  height: 39px;
  animation-delay: 699ms;
  animation-duration: 649ms; }
  .perk-theme-overlay__rain-drop--front-73 .perk-theme-overlay__rain-stem {
    animation-delay: 699ms;
    animation-duration: 649ms; }

.perk-theme-overlay__rain-drop--front-74 {
  left: 75%;
  bottom: 102%;
  height: 44px;
  animation-delay: 777ms;
  animation-duration: 662ms; }
  .perk-theme-overlay__rain-drop--front-74 .perk-theme-overlay__rain-stem {
    animation-delay: 777ms;
    animation-duration: 662ms; }

.perk-theme-overlay__rain-drop--front-75 {
  left: 76%;
  bottom: 103%;
  height: 49px;
  animation-delay: 770ms;
  animation-duration: 675ms; }
  .perk-theme-overlay__rain-drop--front-75 .perk-theme-overlay__rain-stem {
    animation-delay: 770ms;
    animation-duration: 675ms; }

.perk-theme-overlay__rain-drop--front-76 {
  left: 84%;
  bottom: 104%;
  height: 54px;
  animation-delay: 763ms;
  animation-duration: 688ms; }
  .perk-theme-overlay__rain-drop--front-76 .perk-theme-overlay__rain-stem {
    animation-delay: 763ms;
    animation-duration: 688ms; }

.perk-theme-overlay__rain-drop--front-77 {
  left: 85%;
  bottom: 105%;
  height: 59px;
  animation-delay: 841ms;
  animation-duration: 701ms; }
  .perk-theme-overlay__rain-drop--front-77 .perk-theme-overlay__rain-stem {
    animation-delay: 841ms;
    animation-duration: 701ms; }

.perk-theme-overlay__rain-drop--front-78 {
  left: 93%;
  bottom: 100%;
  height: 34px;
  animation-delay: 834ms;
  animation-duration: 714ms; }
  .perk-theme-overlay__rain-drop--front-78 .perk-theme-overlay__rain-stem {
    animation-delay: 834ms;
    animation-duration: 714ms; }

.perk-theme-overlay__rain-drop--front-79 {
  left: 1%;
  bottom: 101%;
  height: 39px;
  animation-delay: 827ms;
  animation-duration: 727ms; }
  .perk-theme-overlay__rain-drop--front-79 .perk-theme-overlay__rain-stem {
    animation-delay: 827ms;
    animation-duration: 727ms; }

.perk-theme-overlay__rain-drop--front-80 {
  left: 2%;
  bottom: 102%;
  height: 44px;
  animation-delay: 905ms;
  animation-duration: 480ms; }
  .perk-theme-overlay__rain-drop--front-80 .perk-theme-overlay__rain-stem {
    animation-delay: 905ms;
    animation-duration: 480ms; }

.perk-theme-overlay__rain-drop--front-81 {
  left: 10%;
  bottom: 103%;
  height: 49px;
  animation-delay: 898ms;
  animation-duration: 493ms; }
  .perk-theme-overlay__rain-drop--front-81 .perk-theme-overlay__rain-stem {
    animation-delay: 898ms;
    animation-duration: 493ms; }

.perk-theme-overlay__rain-drop--front-82 {
  left: 11%;
  bottom: 104%;
  height: 54px;
  animation-delay: 891ms;
  animation-duration: 506ms; }
  .perk-theme-overlay__rain-drop--front-82 .perk-theme-overlay__rain-stem {
    animation-delay: 891ms;
    animation-duration: 506ms; }

.perk-theme-overlay__rain-drop--front-83 {
  left: 19%;
  bottom: 105%;
  height: 59px;
  animation-delay: 969ms;
  animation-duration: 519ms; }
  .perk-theme-overlay__rain-drop--front-83 .perk-theme-overlay__rain-stem {
    animation-delay: 969ms;
    animation-duration: 519ms; }

.perk-theme-overlay__rain-drop--front-84 {
  left: 20%;
  bottom: 100%;
  height: 34px;
  animation-delay: 962ms;
  animation-duration: 532ms; }
  .perk-theme-overlay__rain-drop--front-84 .perk-theme-overlay__rain-stem {
    animation-delay: 962ms;
    animation-duration: 532ms; }

.perk-theme-overlay__rain-drop--front-85 {
  left: 28%;
  bottom: 101%;
  height: 39px;
  animation-delay: 955ms;
  animation-duration: 545ms; }
  .perk-theme-overlay__rain-drop--front-85 .perk-theme-overlay__rain-stem {
    animation-delay: 955ms;
    animation-duration: 545ms; }

.perk-theme-overlay__rain-drop--front-86 {
  left: 36%;
  bottom: 102%;
  height: 44px;
  animation-delay: 33ms;
  animation-duration: 558ms; }
  .perk-theme-overlay__rain-drop--front-86 .perk-theme-overlay__rain-stem {
    animation-delay: 33ms;
    animation-duration: 558ms; }

.perk-theme-overlay__rain-drop--front-87 {
  left: 37%;
  bottom: 103%;
  height: 49px;
  animation-delay: 26ms;
  animation-duration: 571ms; }
  .perk-theme-overlay__rain-drop--front-87 .perk-theme-overlay__rain-stem {
    animation-delay: 26ms;
    animation-duration: 571ms; }

.perk-theme-overlay__rain-drop--front-88 {
  left: 45%;
  bottom: 104%;
  height: 54px;
  animation-delay: 104ms;
  animation-duration: 584ms; }
  .perk-theme-overlay__rain-drop--front-88 .perk-theme-overlay__rain-stem {
    animation-delay: 104ms;
    animation-duration: 584ms; }

.perk-theme-overlay__rain-drop--front-89 {
  left: 46%;
  bottom: 105%;
  height: 59px;
  animation-delay: 97ms;
  animation-duration: 597ms; }
  .perk-theme-overlay__rain-drop--front-89 .perk-theme-overlay__rain-stem {
    animation-delay: 97ms;
    animation-duration: 597ms; }

.perk-theme-overlay__rain-drop--front-90 {
  left: 54%;
  bottom: 100%;
  height: 34px;
  animation-delay: 90ms;
  animation-duration: 610ms; }
  .perk-theme-overlay__rain-drop--front-90 .perk-theme-overlay__rain-stem {
    animation-delay: 90ms;
    animation-duration: 610ms; }

.perk-theme-overlay__rain-drop--front-91 {
  left: 55%;
  bottom: 101%;
  height: 39px;
  animation-delay: 168ms;
  animation-duration: 623ms; }
  .perk-theme-overlay__rain-drop--front-91 .perk-theme-overlay__rain-stem {
    animation-delay: 168ms;
    animation-duration: 623ms; }

.perk-theme-overlay__rain-drop--front-92 {
  left: 63%;
  bottom: 102%;
  height: 44px;
  animation-delay: 161ms;
  animation-duration: 636ms; }
  .perk-theme-overlay__rain-drop--front-92 .perk-theme-overlay__rain-stem {
    animation-delay: 161ms;
    animation-duration: 636ms; }

.perk-theme-overlay__rain-drop--front-93 {
  left: 71%;
  bottom: 103%;
  height: 49px;
  animation-delay: 154ms;
  animation-duration: 649ms; }
  .perk-theme-overlay__rain-drop--front-93 .perk-theme-overlay__rain-stem {
    animation-delay: 154ms;
    animation-duration: 649ms; }

.perk-theme-overlay__rain-drop--front-94 {
  left: 72%;
  bottom: 104%;
  height: 54px;
  animation-delay: 232ms;
  animation-duration: 662ms; }
  .perk-theme-overlay__rain-drop--front-94 .perk-theme-overlay__rain-stem {
    animation-delay: 232ms;
    animation-duration: 662ms; }

.perk-theme-overlay__rain-drop--front-95 {
  left: 80%;
  bottom: 105%;
  height: 59px;
  animation-delay: 225ms;
  animation-duration: 675ms; }
  .perk-theme-overlay__rain-drop--front-95 .perk-theme-overlay__rain-stem {
    animation-delay: 225ms;
    animation-duration: 675ms; }

.perk-theme-overlay__rain-drop--front-96 {
  left: 81%;
  bottom: 100%;
  height: 34px;
  animation-delay: 218ms;
  animation-duration: 688ms; }
  .perk-theme-overlay__rain-drop--front-96 .perk-theme-overlay__rain-stem {
    animation-delay: 218ms;
    animation-duration: 688ms; }

.perk-theme-overlay__rain-drop--front-97 {
  left: 89%;
  bottom: 101%;
  height: 39px;
  animation-delay: 296ms;
  animation-duration: 701ms; }
  .perk-theme-overlay__rain-drop--front-97 .perk-theme-overlay__rain-stem {
    animation-delay: 296ms;
    animation-duration: 701ms; }

.perk-theme-overlay__rain-drop--front-98 {
  left: 90%;
  bottom: 102%;
  height: 44px;
  animation-delay: 289ms;
  animation-duration: 714ms; }
  .perk-theme-overlay__rain-drop--front-98 .perk-theme-overlay__rain-stem {
    animation-delay: 289ms;
    animation-duration: 714ms; }

.perk-theme-overlay__rain-drop--front-99 {
  left: 98%;
  bottom: 103%;
  height: 49px;
  animation-delay: 282ms;
  animation-duration: 727ms; }
  .perk-theme-overlay__rain-drop--front-99 .perk-theme-overlay__rain-stem {
    animation-delay: 282ms;
    animation-duration: 727ms; }

.perk-theme-overlay__rain-drop--front-100 {
  left: 6%;
  bottom: 104%;
  height: 54px;
  animation-delay: 360ms;
  animation-duration: 480ms; }
  .perk-theme-overlay__rain-drop--front-100 .perk-theme-overlay__rain-stem {
    animation-delay: 360ms;
    animation-duration: 480ms; }

.perk-theme-overlay__rain-drop--front-101 {
  left: 7%;
  bottom: 105%;
  height: 59px;
  animation-delay: 353ms;
  animation-duration: 493ms; }
  .perk-theme-overlay__rain-drop--front-101 .perk-theme-overlay__rain-stem {
    animation-delay: 353ms;
    animation-duration: 493ms; }

.perk-theme-overlay__rain-drop--front-102 {
  left: 15%;
  bottom: 100%;
  height: 34px;
  animation-delay: 346ms;
  animation-duration: 506ms; }
  .perk-theme-overlay__rain-drop--front-102 .perk-theme-overlay__rain-stem {
    animation-delay: 346ms;
    animation-duration: 506ms; }

.perk-theme-overlay__rain-drop--front-103 {
  left: 16%;
  bottom: 101%;
  height: 39px;
  animation-delay: 424ms;
  animation-duration: 519ms; }
  .perk-theme-overlay__rain-drop--front-103 .perk-theme-overlay__rain-stem {
    animation-delay: 424ms;
    animation-duration: 519ms; }

.perk-theme-overlay__rain-drop--front-104 {
  left: 24%;
  bottom: 102%;
  height: 44px;
  animation-delay: 417ms;
  animation-duration: 532ms; }
  .perk-theme-overlay__rain-drop--front-104 .perk-theme-overlay__rain-stem {
    animation-delay: 417ms;
    animation-duration: 532ms; }

.perk-theme-overlay__rain-drop--front-105 {
  left: 25%;
  bottom: 103%;
  height: 49px;
  animation-delay: 495ms;
  animation-duration: 545ms; }
  .perk-theme-overlay__rain-drop--front-105 .perk-theme-overlay__rain-stem {
    animation-delay: 495ms;
    animation-duration: 545ms; }

.perk-theme-overlay__rain-drop--front-106 {
  left: 33%;
  bottom: 104%;
  height: 54px;
  animation-delay: 488ms;
  animation-duration: 558ms; }
  .perk-theme-overlay__rain-drop--front-106 .perk-theme-overlay__rain-stem {
    animation-delay: 488ms;
    animation-duration: 558ms; }

.perk-theme-overlay__rain-drop--front-107 {
  left: 41%;
  bottom: 105%;
  height: 59px;
  animation-delay: 481ms;
  animation-duration: 571ms; }
  .perk-theme-overlay__rain-drop--front-107 .perk-theme-overlay__rain-stem {
    animation-delay: 481ms;
    animation-duration: 571ms; }

.perk-theme-overlay__rain-drop--front-108 {
  left: 42%;
  bottom: 100%;
  height: 34px;
  animation-delay: 559ms;
  animation-duration: 584ms; }
  .perk-theme-overlay__rain-drop--front-108 .perk-theme-overlay__rain-stem {
    animation-delay: 559ms;
    animation-duration: 584ms; }

.perk-theme-overlay__rain-drop--front-109 {
  left: 50%;
  bottom: 101%;
  height: 39px;
  animation-delay: 552ms;
  animation-duration: 597ms; }
  .perk-theme-overlay__rain-drop--front-109 .perk-theme-overlay__rain-stem {
    animation-delay: 552ms;
    animation-duration: 597ms; }

.perk-theme-overlay__rain-drop--back-0 {
  left: 1%;
  bottom: 101%;
  height: 26px;
  animation-delay: 40ms;
  animation-duration: 560ms; }
  .perk-theme-overlay__rain-drop--back-0 .perk-theme-overlay__rain-stem {
    animation-delay: 40ms;
    animation-duration: 560ms; }

.perk-theme-overlay__rain-drop--back-1 {
  left: 9%;
  bottom: 102%;
  height: 30px;
  animation-delay: 67ms;
  animation-duration: 577ms; }
  .perk-theme-overlay__rain-drop--back-1 .perk-theme-overlay__rain-stem {
    animation-delay: 67ms;
    animation-duration: 577ms; }

.perk-theme-overlay__rain-drop--back-2 {
  left: 17%;
  bottom: 103%;
  height: 34px;
  animation-delay: 94ms;
  animation-duration: 594ms; }
  .perk-theme-overlay__rain-drop--back-2 .perk-theme-overlay__rain-stem {
    animation-delay: 94ms;
    animation-duration: 594ms; }

.perk-theme-overlay__rain-drop--back-3 {
  left: 25%;
  bottom: 104%;
  height: 38px;
  animation-delay: 121ms;
  animation-duration: 611ms; }
  .perk-theme-overlay__rain-drop--back-3 .perk-theme-overlay__rain-stem {
    animation-delay: 121ms;
    animation-duration: 611ms; }

.perk-theme-overlay__rain-drop--back-4 {
  left: 33%;
  bottom: 105%;
  height: 42px;
  animation-delay: 148ms;
  animation-duration: 628ms; }
  .perk-theme-overlay__rain-drop--back-4 .perk-theme-overlay__rain-stem {
    animation-delay: 148ms;
    animation-duration: 628ms; }

.perk-theme-overlay__rain-drop--back-5 {
  left: 36%;
  bottom: 101%;
  height: 26px;
  animation-delay: 175ms;
  animation-duration: 645ms; }
  .perk-theme-overlay__rain-drop--back-5 .perk-theme-overlay__rain-stem {
    animation-delay: 175ms;
    animation-duration: 645ms; }

.perk-theme-overlay__rain-drop--back-6 {
  left: 44%;
  bottom: 102%;
  height: 30px;
  animation-delay: 202ms;
  animation-duration: 662ms; }
  .perk-theme-overlay__rain-drop--back-6 .perk-theme-overlay__rain-stem {
    animation-delay: 202ms;
    animation-duration: 662ms; }

.perk-theme-overlay__rain-drop--back-7 {
  left: 52%;
  bottom: 103%;
  height: 34px;
  animation-delay: 229ms;
  animation-duration: 679ms; }
  .perk-theme-overlay__rain-drop--back-7 .perk-theme-overlay__rain-stem {
    animation-delay: 229ms;
    animation-duration: 679ms; }

.perk-theme-overlay__rain-drop--back-8 {
  left: 60%;
  bottom: 104%;
  height: 38px;
  animation-delay: 256ms;
  animation-duration: 696ms; }
  .perk-theme-overlay__rain-drop--back-8 .perk-theme-overlay__rain-stem {
    animation-delay: 256ms;
    animation-duration: 696ms; }

.perk-theme-overlay__rain-drop--back-9 {
  left: 68%;
  bottom: 105%;
  height: 42px;
  animation-delay: 283ms;
  animation-duration: 713ms; }
  .perk-theme-overlay__rain-drop--back-9 .perk-theme-overlay__rain-stem {
    animation-delay: 283ms;
    animation-duration: 713ms; }

.perk-theme-overlay__rain-drop--back-10 {
  left: 71%;
  bottom: 101%;
  height: 26px;
  animation-delay: 310ms;
  animation-duration: 730ms; }
  .perk-theme-overlay__rain-drop--back-10 .perk-theme-overlay__rain-stem {
    animation-delay: 310ms;
    animation-duration: 730ms; }

.perk-theme-overlay__rain-drop--back-11 {
  left: 79%;
  bottom: 102%;
  height: 30px;
  animation-delay: 337ms;
  animation-duration: 747ms; }
  .perk-theme-overlay__rain-drop--back-11 .perk-theme-overlay__rain-stem {
    animation-delay: 337ms;
    animation-duration: 747ms; }

.perk-theme-overlay__rain-drop--back-12 {
  left: 87%;
  bottom: 103%;
  height: 34px;
  animation-delay: 364ms;
  animation-duration: 764ms; }
  .perk-theme-overlay__rain-drop--back-12 .perk-theme-overlay__rain-stem {
    animation-delay: 364ms;
    animation-duration: 764ms; }

.perk-theme-overlay__rain-drop--back-13 {
  left: 95%;
  bottom: 104%;
  height: 38px;
  animation-delay: 391ms;
  animation-duration: 781ms; }
  .perk-theme-overlay__rain-drop--back-13 .perk-theme-overlay__rain-stem {
    animation-delay: 391ms;
    animation-duration: 781ms; }

.perk-theme-overlay__rain-drop--back-14 {
  left: 3%;
  bottom: 105%;
  height: 42px;
  animation-delay: 418ms;
  animation-duration: 798ms; }
  .perk-theme-overlay__rain-drop--back-14 .perk-theme-overlay__rain-stem {
    animation-delay: 418ms;
    animation-duration: 798ms; }

.perk-theme-overlay__rain-drop--back-15 {
  left: 6%;
  bottom: 101%;
  height: 26px;
  animation-delay: 445ms;
  animation-duration: 815ms; }
  .perk-theme-overlay__rain-drop--back-15 .perk-theme-overlay__rain-stem {
    animation-delay: 445ms;
    animation-duration: 815ms; }

.perk-theme-overlay__rain-drop--back-16 {
  left: 14%;
  bottom: 102%;
  height: 30px;
  animation-delay: 472ms;
  animation-duration: 832ms; }
  .perk-theme-overlay__rain-drop--back-16 .perk-theme-overlay__rain-stem {
    animation-delay: 472ms;
    animation-duration: 832ms; }

.perk-theme-overlay__rain-drop--back-17 {
  left: 22%;
  bottom: 103%;
  height: 34px;
  animation-delay: 499ms;
  animation-duration: 849ms; }
  .perk-theme-overlay__rain-drop--back-17 .perk-theme-overlay__rain-stem {
    animation-delay: 499ms;
    animation-duration: 849ms; }

.perk-theme-overlay__rain-drop--back-18 {
  left: 30%;
  bottom: 104%;
  height: 38px;
  animation-delay: 526ms;
  animation-duration: 566ms; }
  .perk-theme-overlay__rain-drop--back-18 .perk-theme-overlay__rain-stem {
    animation-delay: 526ms;
    animation-duration: 566ms; }

.perk-theme-overlay__rain-drop--back-19 {
  left: 38%;
  bottom: 105%;
  height: 42px;
  animation-delay: 553ms;
  animation-duration: 583ms; }
  .perk-theme-overlay__rain-drop--back-19 .perk-theme-overlay__rain-stem {
    animation-delay: 553ms;
    animation-duration: 583ms; }

.perk-theme-overlay__rain-drop--back-20 {
  left: 41%;
  bottom: 101%;
  height: 26px;
  animation-delay: 580ms;
  animation-duration: 600ms; }
  .perk-theme-overlay__rain-drop--back-20 .perk-theme-overlay__rain-stem {
    animation-delay: 580ms;
    animation-duration: 600ms; }

.perk-theme-overlay__rain-drop--back-21 {
  left: 49%;
  bottom: 102%;
  height: 30px;
  animation-delay: 607ms;
  animation-duration: 617ms; }
  .perk-theme-overlay__rain-drop--back-21 .perk-theme-overlay__rain-stem {
    animation-delay: 607ms;
    animation-duration: 617ms; }

.perk-theme-overlay__rain-drop--back-22 {
  left: 57%;
  bottom: 103%;
  height: 34px;
  animation-delay: 634ms;
  animation-duration: 634ms; }
  .perk-theme-overlay__rain-drop--back-22 .perk-theme-overlay__rain-stem {
    animation-delay: 634ms;
    animation-duration: 634ms; }

.perk-theme-overlay__rain-drop--back-23 {
  left: 65%;
  bottom: 104%;
  height: 38px;
  animation-delay: 661ms;
  animation-duration: 651ms; }
  .perk-theme-overlay__rain-drop--back-23 .perk-theme-overlay__rain-stem {
    animation-delay: 661ms;
    animation-duration: 651ms; }

.perk-theme-overlay__rain-drop--back-24 {
  left: 73%;
  bottom: 105%;
  height: 42px;
  animation-delay: 688ms;
  animation-duration: 668ms; }
  .perk-theme-overlay__rain-drop--back-24 .perk-theme-overlay__rain-stem {
    animation-delay: 688ms;
    animation-duration: 668ms; }

.perk-theme-overlay__rain-drop--back-25 {
  left: 76%;
  bottom: 101%;
  height: 26px;
  animation-delay: 715ms;
  animation-duration: 685ms; }
  .perk-theme-overlay__rain-drop--back-25 .perk-theme-overlay__rain-stem {
    animation-delay: 715ms;
    animation-duration: 685ms; }

.perk-theme-overlay__rain-drop--back-26 {
  left: 84%;
  bottom: 102%;
  height: 30px;
  animation-delay: 742ms;
  animation-duration: 702ms; }
  .perk-theme-overlay__rain-drop--back-26 .perk-theme-overlay__rain-stem {
    animation-delay: 742ms;
    animation-duration: 702ms; }

.perk-theme-overlay__rain-drop--back-27 {
  left: 92%;
  bottom: 103%;
  height: 34px;
  animation-delay: 769ms;
  animation-duration: 719ms; }
  .perk-theme-overlay__rain-drop--back-27 .perk-theme-overlay__rain-stem {
    animation-delay: 769ms;
    animation-duration: 719ms; }

.perk-theme-overlay__rain-drop--back-28 {
  left: 0%;
  bottom: 104%;
  height: 38px;
  animation-delay: 796ms;
  animation-duration: 736ms; }
  .perk-theme-overlay__rain-drop--back-28 .perk-theme-overlay__rain-stem {
    animation-delay: 796ms;
    animation-duration: 736ms; }

.perk-theme-overlay__rain-drop--back-29 {
  left: 8%;
  bottom: 105%;
  height: 42px;
  animation-delay: 823ms;
  animation-duration: 753ms; }
  .perk-theme-overlay__rain-drop--back-29 .perk-theme-overlay__rain-stem {
    animation-delay: 823ms;
    animation-duration: 753ms; }

.perk-theme-overlay__rain-drop--back-30 {
  left: 11%;
  bottom: 101%;
  height: 26px;
  animation-delay: 850ms;
  animation-duration: 770ms; }
  .perk-theme-overlay__rain-drop--back-30 .perk-theme-overlay__rain-stem {
    animation-delay: 850ms;
    animation-duration: 770ms; }

.perk-theme-overlay__rain-drop--back-31 {
  left: 19%;
  bottom: 102%;
  height: 30px;
  animation-delay: 877ms;
  animation-duration: 787ms; }
  .perk-theme-overlay__rain-drop--back-31 .perk-theme-overlay__rain-stem {
    animation-delay: 877ms;
    animation-duration: 787ms; }

.perk-theme-overlay__rain-drop--back-32 {
  left: 27%;
  bottom: 103%;
  height: 34px;
  animation-delay: 904ms;
  animation-duration: 804ms; }
  .perk-theme-overlay__rain-drop--back-32 .perk-theme-overlay__rain-stem {
    animation-delay: 904ms;
    animation-duration: 804ms; }

.perk-theme-overlay__rain-drop--back-33 {
  left: 35%;
  bottom: 104%;
  height: 38px;
  animation-delay: 931ms;
  animation-duration: 821ms; }
  .perk-theme-overlay__rain-drop--back-33 .perk-theme-overlay__rain-stem {
    animation-delay: 931ms;
    animation-duration: 821ms; }

.perk-theme-overlay__rain-drop--back-34 {
  left: 43%;
  bottom: 105%;
  height: 42px;
  animation-delay: 958ms;
  animation-duration: 838ms; }
  .perk-theme-overlay__rain-drop--back-34 .perk-theme-overlay__rain-stem {
    animation-delay: 958ms;
    animation-duration: 838ms; }

.perk-theme-overlay__rain-drop--back-35 {
  left: 46%;
  bottom: 101%;
  height: 26px;
  animation-delay: 985ms;
  animation-duration: 855ms; }
  .perk-theme-overlay__rain-drop--back-35 .perk-theme-overlay__rain-stem {
    animation-delay: 985ms;
    animation-duration: 855ms; }

.perk-theme-overlay__rain-drop--back-36 {
  left: 54%;
  bottom: 102%;
  height: 30px;
  animation-delay: 1012ms;
  animation-duration: 572ms; }
  .perk-theme-overlay__rain-drop--back-36 .perk-theme-overlay__rain-stem {
    animation-delay: 1012ms;
    animation-duration: 572ms; }

.perk-theme-overlay__rain-drop--back-37 {
  left: 62%;
  bottom: 103%;
  height: 34px;
  animation-delay: 1039ms;
  animation-duration: 589ms; }
  .perk-theme-overlay__rain-drop--back-37 .perk-theme-overlay__rain-stem {
    animation-delay: 1039ms;
    animation-duration: 589ms; }

.perk-theme-overlay__rain-drop--back-38 {
  left: 70%;
  bottom: 104%;
  height: 38px;
  animation-delay: 1066ms;
  animation-duration: 606ms; }
  .perk-theme-overlay__rain-drop--back-38 .perk-theme-overlay__rain-stem {
    animation-delay: 1066ms;
    animation-duration: 606ms; }

.perk-theme-overlay__rain-drop--back-39 {
  left: 78%;
  bottom: 105%;
  height: 42px;
  animation-delay: 1093ms;
  animation-duration: 623ms; }
  .perk-theme-overlay__rain-drop--back-39 .perk-theme-overlay__rain-stem {
    animation-delay: 1093ms;
    animation-duration: 623ms; }

.perk-theme-overlay__rain-drop--back-40 {
  left: 81%;
  bottom: 101%;
  height: 26px;
  animation-delay: 20ms;
  animation-duration: 640ms; }
  .perk-theme-overlay__rain-drop--back-40 .perk-theme-overlay__rain-stem {
    animation-delay: 20ms;
    animation-duration: 640ms; }

.perk-theme-overlay__rain-drop--back-41 {
  left: 89%;
  bottom: 102%;
  height: 30px;
  animation-delay: 47ms;
  animation-duration: 657ms; }
  .perk-theme-overlay__rain-drop--back-41 .perk-theme-overlay__rain-stem {
    animation-delay: 47ms;
    animation-duration: 657ms; }

.perk-theme-overlay__rain-drop--back-42 {
  left: 97%;
  bottom: 103%;
  height: 34px;
  animation-delay: 74ms;
  animation-duration: 674ms; }
  .perk-theme-overlay__rain-drop--back-42 .perk-theme-overlay__rain-stem {
    animation-delay: 74ms;
    animation-duration: 674ms; }

.perk-theme-overlay__rain-drop--back-43 {
  left: 5%;
  bottom: 104%;
  height: 38px;
  animation-delay: 101ms;
  animation-duration: 691ms; }
  .perk-theme-overlay__rain-drop--back-43 .perk-theme-overlay__rain-stem {
    animation-delay: 101ms;
    animation-duration: 691ms; }

.perk-theme-overlay__rain-drop--back-44 {
  left: 13%;
  bottom: 105%;
  height: 42px;
  animation-delay: 128ms;
  animation-duration: 708ms; }
  .perk-theme-overlay__rain-drop--back-44 .perk-theme-overlay__rain-stem {
    animation-delay: 128ms;
    animation-duration: 708ms; }

.perk-theme-overlay__rain-drop--back-45 {
  left: 16%;
  bottom: 101%;
  height: 26px;
  animation-delay: 155ms;
  animation-duration: 725ms; }
  .perk-theme-overlay__rain-drop--back-45 .perk-theme-overlay__rain-stem {
    animation-delay: 155ms;
    animation-duration: 725ms; }

.perk-theme-overlay__rain-drop--back-46 {
  left: 24%;
  bottom: 102%;
  height: 30px;
  animation-delay: 182ms;
  animation-duration: 742ms; }
  .perk-theme-overlay__rain-drop--back-46 .perk-theme-overlay__rain-stem {
    animation-delay: 182ms;
    animation-duration: 742ms; }

.perk-theme-overlay__rain-drop--back-47 {
  left: 32%;
  bottom: 103%;
  height: 34px;
  animation-delay: 209ms;
  animation-duration: 759ms; }
  .perk-theme-overlay__rain-drop--back-47 .perk-theme-overlay__rain-stem {
    animation-delay: 209ms;
    animation-duration: 759ms; }

.perk-theme-overlay__rain-drop--back-48 {
  left: 40%;
  bottom: 104%;
  height: 38px;
  animation-delay: 236ms;
  animation-duration: 776ms; }
  .perk-theme-overlay__rain-drop--back-48 .perk-theme-overlay__rain-stem {
    animation-delay: 236ms;
    animation-duration: 776ms; }

.perk-theme-overlay__rain-drop--back-49 {
  left: 48%;
  bottom: 105%;
  height: 42px;
  animation-delay: 263ms;
  animation-duration: 793ms; }
  .perk-theme-overlay__rain-drop--back-49 .perk-theme-overlay__rain-stem {
    animation-delay: 263ms;
    animation-duration: 793ms; }

.perk-theme-overlay__rain-drop--back-50 {
  left: 51%;
  bottom: 101%;
  height: 26px;
  animation-delay: 290ms;
  animation-duration: 810ms; }
  .perk-theme-overlay__rain-drop--back-50 .perk-theme-overlay__rain-stem {
    animation-delay: 290ms;
    animation-duration: 810ms; }

.perk-theme-overlay__rain-drop--back-51 {
  left: 59%;
  bottom: 102%;
  height: 30px;
  animation-delay: 317ms;
  animation-duration: 827ms; }
  .perk-theme-overlay__rain-drop--back-51 .perk-theme-overlay__rain-stem {
    animation-delay: 317ms;
    animation-duration: 827ms; }

.perk-theme-overlay__rain-drop--back-52 {
  left: 67%;
  bottom: 103%;
  height: 34px;
  animation-delay: 344ms;
  animation-duration: 844ms; }
  .perk-theme-overlay__rain-drop--back-52 .perk-theme-overlay__rain-stem {
    animation-delay: 344ms;
    animation-duration: 844ms; }

.perk-theme-overlay__rain-drop--back-53 {
  left: 75%;
  bottom: 104%;
  height: 38px;
  animation-delay: 371ms;
  animation-duration: 561ms; }
  .perk-theme-overlay__rain-drop--back-53 .perk-theme-overlay__rain-stem {
    animation-delay: 371ms;
    animation-duration: 561ms; }

.perk-theme-overlay__rain-drop--back-54 {
  left: 83%;
  bottom: 105%;
  height: 42px;
  animation-delay: 398ms;
  animation-duration: 578ms; }
  .perk-theme-overlay__rain-drop--back-54 .perk-theme-overlay__rain-stem {
    animation-delay: 398ms;
    animation-duration: 578ms; }

.perk-theme-overlay__rain-drop--back-55 {
  left: 86%;
  bottom: 101%;
  height: 26px;
  animation-delay: 425ms;
  animation-duration: 595ms; }
  .perk-theme-overlay__rain-drop--back-55 .perk-theme-overlay__rain-stem {
    animation-delay: 425ms;
    animation-duration: 595ms; }

.perk-theme-overlay__rain-drop--back-56 {
  left: 94%;
  bottom: 102%;
  height: 30px;
  animation-delay: 452ms;
  animation-duration: 612ms; }
  .perk-theme-overlay__rain-drop--back-56 .perk-theme-overlay__rain-stem {
    animation-delay: 452ms;
    animation-duration: 612ms; }

.perk-theme-overlay__rain-drop--back-57 {
  left: 2%;
  bottom: 103%;
  height: 34px;
  animation-delay: 479ms;
  animation-duration: 629ms; }
  .perk-theme-overlay__rain-drop--back-57 .perk-theme-overlay__rain-stem {
    animation-delay: 479ms;
    animation-duration: 629ms; }

.perk-theme-overlay__rain-drop--back-58 {
  left: 10%;
  bottom: 104%;
  height: 38px;
  animation-delay: 506ms;
  animation-duration: 646ms; }
  .perk-theme-overlay__rain-drop--back-58 .perk-theme-overlay__rain-stem {
    animation-delay: 506ms;
    animation-duration: 646ms; }

.perk-theme-overlay__rain-drop--back-59 {
  left: 18%;
  bottom: 105%;
  height: 42px;
  animation-delay: 533ms;
  animation-duration: 663ms; }
  .perk-theme-overlay__rain-drop--back-59 .perk-theme-overlay__rain-stem {
    animation-delay: 533ms;
    animation-duration: 663ms; }

.perk-theme-overlay__rain-drop--back-60 {
  left: 21%;
  bottom: 101%;
  height: 26px;
  animation-delay: 560ms;
  animation-duration: 680ms; }
  .perk-theme-overlay__rain-drop--back-60 .perk-theme-overlay__rain-stem {
    animation-delay: 560ms;
    animation-duration: 680ms; }

.perk-theme-overlay__rain-drop--back-61 {
  left: 29%;
  bottom: 102%;
  height: 30px;
  animation-delay: 587ms;
  animation-duration: 697ms; }
  .perk-theme-overlay__rain-drop--back-61 .perk-theme-overlay__rain-stem {
    animation-delay: 587ms;
    animation-duration: 697ms; }

.perk-theme-overlay__rain-drop--back-62 {
  left: 37%;
  bottom: 103%;
  height: 34px;
  animation-delay: 614ms;
  animation-duration: 714ms; }
  .perk-theme-overlay__rain-drop--back-62 .perk-theme-overlay__rain-stem {
    animation-delay: 614ms;
    animation-duration: 714ms; }

.perk-theme-overlay__rain-drop--back-63 {
  left: 45%;
  bottom: 104%;
  height: 38px;
  animation-delay: 641ms;
  animation-duration: 731ms; }
  .perk-theme-overlay__rain-drop--back-63 .perk-theme-overlay__rain-stem {
    animation-delay: 641ms;
    animation-duration: 731ms; }

.perk-theme-overlay__rain-drop--back-64 {
  left: 53%;
  bottom: 105%;
  height: 42px;
  animation-delay: 668ms;
  animation-duration: 748ms; }
  .perk-theme-overlay__rain-drop--back-64 .perk-theme-overlay__rain-stem {
    animation-delay: 668ms;
    animation-duration: 748ms; }

.perk-theme-overlay__rain-drop--back-65 {
  left: 56%;
  bottom: 101%;
  height: 26px;
  animation-delay: 695ms;
  animation-duration: 765ms; }
  .perk-theme-overlay__rain-drop--back-65 .perk-theme-overlay__rain-stem {
    animation-delay: 695ms;
    animation-duration: 765ms; }

.perk-theme-overlay__rain-drop--back-66 {
  left: 64%;
  bottom: 102%;
  height: 30px;
  animation-delay: 722ms;
  animation-duration: 782ms; }
  .perk-theme-overlay__rain-drop--back-66 .perk-theme-overlay__rain-stem {
    animation-delay: 722ms;
    animation-duration: 782ms; }

.perk-theme-overlay__rain-drop--back-67 {
  left: 72%;
  bottom: 103%;
  height: 34px;
  animation-delay: 749ms;
  animation-duration: 799ms; }
  .perk-theme-overlay__rain-drop--back-67 .perk-theme-overlay__rain-stem {
    animation-delay: 749ms;
    animation-duration: 799ms; }

.perk-theme-overlay__rain-drop--back-68 {
  left: 80%;
  bottom: 104%;
  height: 38px;
  animation-delay: 776ms;
  animation-duration: 816ms; }
  .perk-theme-overlay__rain-drop--back-68 .perk-theme-overlay__rain-stem {
    animation-delay: 776ms;
    animation-duration: 816ms; }

.perk-theme-overlay__rain-drop--back-69 {
  left: 88%;
  bottom: 105%;
  height: 42px;
  animation-delay: 803ms;
  animation-duration: 833ms; }
  .perk-theme-overlay__rain-drop--back-69 .perk-theme-overlay__rain-stem {
    animation-delay: 803ms;
    animation-duration: 833ms; }

.perk-theme-overlay__rain-drop--back-70 {
  left: 91%;
  bottom: 101%;
  height: 26px;
  animation-delay: 830ms;
  animation-duration: 850ms; }
  .perk-theme-overlay__rain-drop--back-70 .perk-theme-overlay__rain-stem {
    animation-delay: 830ms;
    animation-duration: 850ms; }

.perk-theme-overlay__rain-drop--back-71 {
  left: 99%;
  bottom: 102%;
  height: 30px;
  animation-delay: 857ms;
  animation-duration: 567ms; }
  .perk-theme-overlay__rain-drop--back-71 .perk-theme-overlay__rain-stem {
    animation-delay: 857ms;
    animation-duration: 567ms; }

.perk-theme-overlay__rain-drop--back-72 {
  left: 7%;
  bottom: 103%;
  height: 34px;
  animation-delay: 884ms;
  animation-duration: 584ms; }
  .perk-theme-overlay__rain-drop--back-72 .perk-theme-overlay__rain-stem {
    animation-delay: 884ms;
    animation-duration: 584ms; }

.perk-theme-overlay__rain-drop--back-73 {
  left: 15%;
  bottom: 104%;
  height: 38px;
  animation-delay: 911ms;
  animation-duration: 601ms; }
  .perk-theme-overlay__rain-drop--back-73 .perk-theme-overlay__rain-stem {
    animation-delay: 911ms;
    animation-duration: 601ms; }

.perk-theme-overlay__rain-drop--back-74 {
  left: 23%;
  bottom: 105%;
  height: 42px;
  animation-delay: 938ms;
  animation-duration: 618ms; }
  .perk-theme-overlay__rain-drop--back-74 .perk-theme-overlay__rain-stem {
    animation-delay: 938ms;
    animation-duration: 618ms; }

@keyframes perk-theme-rain-drop {
  0% {
    transform: translateY(0); }
  75% {
    transform: translateY(110vh); }
  100% {
    transform: translateY(110vh); } }

@keyframes perk-theme-rain-stem {
  0%,
  65% {
    opacity: 1; }
  75%,
  100% {
    opacity: 0; } }

.perk-theme-overlay__layer--glass-webgl {
  z-index: 2; }

.perk-theme-overlay__layer--heat-webgl {
  z-index: 2; }

.perk-theme-overlay__layer--rain {
  z-index: 3; }

.perk-theme-overlay__layer--snow {
  z-index: 4;
  overflow: hidden; }

.perk-theme-overlay__snow-canvas {
  display: block;
  width: 100%;
  height: 100%;
  pointer-events: none; }

.perk-theme-overlay__glass-canvas {
  display: block;
  width: 100%;
  height: 100%;
  pointer-events: none;
  background: transparent;
  opacity: 0; }
  .perk-theme-overlay__glass-canvas.is-ready {
    opacity: 1; }

.perk-theme-overlay__heat-canvas {
  display: block;
  width: 100%;
  height: 100%;
  pointer-events: none;
  background: transparent;
  opacity: 0; }
  .perk-theme-overlay__heat-canvas.is-ready {
    opacity: 1; }

.perk-theme-overlay__heat-video-src {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none; }

.perk-theme-overlay__layer--lightning {
  top: 0;
  bottom: auto;
  z-index: 3;
  overflow: hidden; }

.perk-theme-overlay__layer--lightning-h25 {
  height: 25%; }

.perk-theme-overlay__layer--lightning-h30 {
  height: 30%; }

.perk-theme-overlay__layer--lightning-h35 {
  height: 35%; }

.perk-theme-overlay__layer--lightning-h40 {
  height: 40%; }

.perk-theme-overlay__layer--lightning-h45 {
  height: 45%; }

.perk-theme-overlay__layer--lightning-h50 {
  height: 50%; }

.perk-theme-overlay__layer--lightning-h55 {
  height: 55%; }

.perk-theme-overlay__layer--lightning-h60 {
  height: 60%; }

.perk-theme-overlay__layer--lightning-h65 {
  height: 65%; }

.perk-theme-overlay__layer--lightning-h70 {
  height: 70%; }

.perk-theme-overlay__layer--lightning-h75 {
  height: 75%; }

.perk-theme-overlay__layer--lightning-h80 {
  height: 80%; }

.perk-theme-overlay__layer--lightning-h85 {
  height: 85%; }

.perk-theme-overlay__layer--lightning-h90 {
  height: 90%; }

.perk-theme-overlay__layer--lightning-h95 {
  height: 95%; }

.perk-theme-overlay__layer--lightning-h100 {
  height: 100%; }

.perk-theme-overlay__lightning-canvas {
  display: block;
  width: 100%;
  height: 100%;
  pointer-events: none; }

.perk-theme-overlay__layer--nebula {
  z-index: 2;
  overflow: hidden;
  opacity: 0.72; }

.perk-theme-overlay__layer--nebula-q0 {
  opacity: 0.38; }

.perk-theme-overlay__layer--nebula-q10 {
  opacity: 0.435; }

.perk-theme-overlay__layer--nebula-q20 {
  opacity: 0.49; }

.perk-theme-overlay__layer--nebula-q30 {
  opacity: 0.545; }

.perk-theme-overlay__layer--nebula-q40 {
  opacity: 0.6; }

.perk-theme-overlay__layer--nebula-q50 {
  opacity: 0.655; }

.perk-theme-overlay__layer--nebula-q60 {
  opacity: 0.71; }

.perk-theme-overlay__layer--nebula-q70 {
  opacity: 0.765; }

.perk-theme-overlay__layer--nebula-q80 {
  opacity: 0.82; }

.perk-theme-overlay__layer--nebula-q90 {
  opacity: 0.875; }

.perk-theme-overlay__layer--nebula-q100 {
  opacity: 0.93; }

.perk-theme-overlay__nebula-stage {
  position: absolute;
  inset: -18%;
  perspective: 620px;
  perspective-origin: 50% 46%;
  transform-style: preserve-3d;
  transform: rotate(0deg); }

.perk-theme-overlay__layer--nebula-i0 .perk-theme-overlay__nebula-stage {
  transform: rotate(-40deg); }

.perk-theme-overlay__layer--nebula-i10 .perk-theme-overlay__nebula-stage {
  transform: rotate(-32deg); }

.perk-theme-overlay__layer--nebula-i20 .perk-theme-overlay__nebula-stage {
  transform: rotate(-24deg); }

.perk-theme-overlay__layer--nebula-i30 .perk-theme-overlay__nebula-stage {
  transform: rotate(-16deg); }

.perk-theme-overlay__layer--nebula-i40 .perk-theme-overlay__nebula-stage {
  transform: rotate(-8deg); }

.perk-theme-overlay__layer--nebula-i50 .perk-theme-overlay__nebula-stage {
  transform: rotate(0deg); }

.perk-theme-overlay__layer--nebula-i60 .perk-theme-overlay__nebula-stage {
  transform: rotate(8deg); }

.perk-theme-overlay__layer--nebula-i70 .perk-theme-overlay__nebula-stage {
  transform: rotate(16deg); }

.perk-theme-overlay__layer--nebula-i80 .perk-theme-overlay__nebula-stage {
  transform: rotate(24deg); }

.perk-theme-overlay__layer--nebula-i90 .perk-theme-overlay__nebula-stage {
  transform: rotate(32deg); }

.perk-theme-overlay__layer--nebula-i100 .perk-theme-overlay__nebula-stage {
  transform: rotate(40deg); }

.perk-theme-overlay__nebula-world {
  position: absolute;
  left: 50%;
  top: 48%;
  width: 1px;
  height: 1px;
  transform-style: preserve-3d;
  transform: translate(-50%, -50%) rotateX(-10deg) rotateY(0deg);
  animation: none; }

.perk-theme-overlay__nebula-puff {
  position: absolute;
  left: 0;
  top: 0;
  width: 210px;
  height: 150px;
  margin: -75px 0 0 -105px;
  border-radius: 50%;
  transform-style: preserve-3d;
  pointer-events: none;
  background: radial-gradient(ellipse 52% 44% at 42% 46%, rgba(210, 235, 240, 0.42) 0%, transparent 68%), radial-gradient(ellipse 58% 50% at 58% 54%, rgba(70, 150, 155, 0.38) 0%, transparent 72%), radial-gradient(ellipse 70% 60% at 50% 50%, rgba(28, 55, 58, 0.22) 0%, transparent 78%);
  mix-blend-mode: screen;
  filter: blur(0.35px);
  opacity: 0.55;
  animation: none; }

.perk-theme-overlay__nebula-puff-tint--0 {
  background: radial-gradient(ellipse 48% 40% at 45% 42%, rgba(120, 230, 255, 0.5) 0%, transparent 62%), radial-gradient(ellipse 62% 52% at 55% 58%, rgba(40, 130, 150, 0.36) 0%, transparent 74%), radial-gradient(ellipse 78% 68% at 50% 50%, rgba(20, 45, 55, 0.18) 0%, transparent 80%); }

.perk-theme-overlay__nebula-puff-tint--1 {
  background: radial-gradient(ellipse 50% 42% at 40% 48%, rgba(90, 190, 175, 0.42) 0%, transparent 66%), radial-gradient(ellipse 64% 54% at 60% 52%, rgba(45, 110, 105, 0.34) 0%, transparent 74%), radial-gradient(ellipse 80% 70% at 50% 50%, rgba(18, 40, 38, 0.16) 0%, transparent 82%); }

.perk-theme-overlay__nebula-puff-tint--2 {
  background: radial-gradient(ellipse 46% 38% at 48% 44%, rgba(230, 210, 165, 0.36) 0%, transparent 60%), radial-gradient(ellipse 60% 50% at 52% 56%, rgba(150, 125, 80, 0.3) 0%, transparent 72%), radial-gradient(ellipse 76% 66% at 50% 50%, rgba(40, 38, 28, 0.14) 0%, transparent 80%); }

.perk-theme-overlay__nebula-puff-tint--3 {
  background: radial-gradient(ellipse 44% 36% at 50% 40%, rgba(200, 245, 250, 0.38) 0%, transparent 58%), radial-gradient(ellipse 58% 48% at 46% 55%, rgba(55, 140, 155, 0.32) 0%, transparent 70%), radial-gradient(ellipse 74% 64% at 50% 50%, rgba(22, 48, 52, 0.15) 0%, transparent 80%); }

.perk-theme-overlay__nebula-puff-tint--4 {
  background: radial-gradient(ellipse 52% 44% at 38% 50%, rgba(160, 200, 175, 0.34) 0%, transparent 64%), radial-gradient(ellipse 66% 56% at 62% 48%, rgba(70, 95, 80, 0.28) 0%, transparent 74%), radial-gradient(ellipse 82% 72% at 50% 50%, rgba(25, 40, 35, 0.14) 0%, transparent 82%); }

.perk-theme-overlay__nebula-puff-tint--5 {
  background: radial-gradient(ellipse 48% 40% at 55% 46%, rgba(210, 185, 130, 0.32) 0%, transparent 62%), radial-gradient(ellipse 62% 52% at 42% 56%, rgba(95, 150, 145, 0.3) 0%, transparent 72%), radial-gradient(ellipse 78% 68% at 50% 50%, rgba(30, 42, 40, 0.14) 0%, transparent 80%); }

.perk-theme-overlay__nebula-puff--0 {
  width: 180px;
  height: 120px;
  margin-left: -90px;
  margin-top: -60px;
  transform: rotateY(0deg) translateX(28px) translateZ(-172px) rotateY(0deg) rotateX(-6deg) scale(0.52);
  opacity: 0.38;
  animation-delay: 0s; }

.perk-theme-overlay__nebula-puff--1 {
  width: 202px;
  height: 136px;
  margin-left: -101px;
  margin-top: -68px;
  transform: rotateY(127deg) translateX(34px) translateZ(-132px) rotateY(-127deg) rotateX(-4.5deg) scale(0.61);
  opacity: 0.44;
  animation-delay: -0.37s; }

.perk-theme-overlay__nebula-puff--2 {
  width: 224px;
  height: 152px;
  margin-left: -112px;
  margin-top: -76px;
  transform: rotateY(254deg) translateX(40px) translateZ(-92px) rotateY(-254deg) rotateX(-3deg) scale(0.7);
  opacity: 0.5;
  animation-delay: -0.74s; }

.perk-theme-overlay__nebula-puff--3 {
  width: 246px;
  height: 168px;
  margin-left: -123px;
  margin-top: -84px;
  transform: rotateY(49deg) translateX(64px) translateZ(-88px) rotateY(-49deg) rotateX(-1.5deg) scale(0.83);
  opacity: 0.56;
  animation-delay: -1.11s; }

.perk-theme-overlay__nebula-puff--4 {
  width: 268px;
  height: 184px;
  margin-left: -134px;
  margin-top: -92px;
  transform: rotateY(176deg) translateX(70px) translateZ(-48px) rotateY(-176deg) rotateX(0deg) scale(0.92);
  opacity: 0.62;
  animation-delay: -1.48s; }

.perk-theme-overlay__nebula-puff--5 {
  width: 290px;
  height: 120px;
  margin-left: -145px;
  margin-top: -60px;
  transform: rotateY(303deg) translateX(46px) translateZ(-8px) rotateY(-303deg) rotateX(1.5deg) scale(1.01);
  opacity: 0.38;
  animation-delay: -1.85s; }

.perk-theme-overlay__nebula-puff--6 {
  width: 180px;
  height: 136px;
  margin-left: -90px;
  margin-top: -68px;
  transform: rotateY(98deg) translateX(70px) translateZ(-4px) rotateY(-98deg) rotateX(3deg) scale(1.14);
  opacity: 0.44;
  animation-delay: -2.22s; }

.perk-theme-overlay__nebula-puff--7 {
  width: 202px;
  height: 152px;
  margin-left: -101px;
  margin-top: -76px;
  transform: rotateY(225deg) translateX(76px) translateZ(36px) rotateY(-225deg) rotateX(4.5deg) scale(0.6);
  opacity: 0.5;
  animation-delay: -2.59s; }

.perk-theme-overlay__nebula-puff--8 {
  width: 224px;
  height: 168px;
  margin-left: -112px;
  margin-top: -84px;
  transform: rotateY(352deg) translateX(82px) translateZ(76px) rotateY(-352deg) rotateX(6deg) scale(0.69);
  opacity: 0.56;
  animation-delay: -2.96s; }

.perk-theme-overlay__nebula-puff--9 {
  width: 246px;
  height: 184px;
  margin-left: -123px;
  margin-top: -92px;
  transform: rotateY(147deg) translateX(106px) translateZ(80px) rotateY(-147deg) rotateX(-6deg) scale(0.82);
  opacity: 0.62;
  animation-delay: -3.33s; }

.perk-theme-overlay__nebula-puff--10 {
  width: 268px;
  height: 120px;
  margin-left: -134px;
  margin-top: -60px;
  transform: rotateY(274deg) translateX(82px) translateZ(120px) rotateY(-274deg) rotateX(-4.5deg) scale(0.91);
  opacity: 0.38;
  animation-delay: -3.7s; }

.perk-theme-overlay__nebula-puff--11 {
  width: 290px;
  height: 136px;
  margin-left: -145px;
  margin-top: -68px;
  transform: rotateY(401deg) translateX(88px) translateZ(-148px) rotateY(-401deg) rotateX(-3deg) scale(1);
  opacity: 0.44;
  animation-delay: -4.07s; }

.perk-theme-overlay__nebula-puff--12 {
  width: 180px;
  height: 152px;
  margin-left: -90px;
  margin-top: -76px;
  transform: rotateY(196deg) translateX(112px) translateZ(-144px) rotateY(-196deg) rotateX(-1.5deg) scale(0.97);
  opacity: 0.5;
  animation-delay: -4.44s; }

.perk-theme-overlay__nebula-puff--13 {
  width: 202px;
  height: 168px;
  margin-left: -101px;
  margin-top: -84px;
  transform: rotateY(323deg) translateX(118px) translateZ(-104px) rotateY(-323deg) rotateX(0deg) scale(1.06);
  opacity: 0.56;
  animation-delay: -4.81s; }

.perk-theme-overlay__nebula-puff--14 {
  width: 224px;
  height: 184px;
  margin-left: -112px;
  margin-top: -92px;
  transform: rotateY(450deg) translateX(124px) translateZ(-64px) rotateY(-450deg) rotateX(1.5deg) scale(0.52);
  opacity: 0.62;
  animation-delay: -5.18s; }

.perk-theme-overlay__nebula-puff--15 {
  width: 246px;
  height: 120px;
  margin-left: -123px;
  margin-top: -60px;
  transform: rotateY(245deg) translateX(118px) translateZ(-60px) rotateY(-245deg) rotateX(3deg) scale(0.65);
  opacity: 0.38;
  animation-delay: -5.55s; }

.perk-theme-overlay__nebula-puff--16 {
  width: 268px;
  height: 136px;
  margin-left: -134px;
  margin-top: -68px;
  transform: rotateY(372deg) translateX(124px) translateZ(-20px) rotateY(-372deg) rotateX(4.5deg) scale(0.74);
  opacity: 0.44;
  animation-delay: -5.92s; }

.perk-theme-overlay__nebula-puff--17 {
  width: 290px;
  height: 152px;
  margin-left: -145px;
  margin-top: -76px;
  transform: rotateY(499deg) translateX(130px) translateZ(20px) rotateY(-499deg) rotateX(6deg) scale(0.83);
  opacity: 0.5;
  animation-delay: -6.29s; }

.perk-theme-overlay__nebula-puff--18 {
  width: 180px;
  height: 168px;
  margin-left: -90px;
  margin-top: -84px;
  transform: rotateY(294deg) translateX(154px) translateZ(24px) rotateY(-294deg) rotateX(-6deg) scale(0.96);
  opacity: 0.56;
  animation-delay: -6.66s; }

.perk-theme-overlay__nebula-puff--19 {
  width: 202px;
  height: 184px;
  margin-left: -101px;
  margin-top: -92px;
  transform: rotateY(421deg) translateX(160px) translateZ(64px) rotateY(-421deg) rotateX(-4.5deg) scale(1.05);
  opacity: 0.62;
  animation-delay: -7.03s; }

.perk-theme-overlay__nebula-puff--20 {
  width: 224px;
  height: 120px;
  margin-left: -112px;
  margin-top: -60px;
  transform: rotateY(548deg) translateX(136px) translateZ(104px) rotateY(-548deg) rotateX(-3deg) scale(1.14);
  opacity: 0.38;
  animation-delay: -7.4s; }

.perk-theme-overlay__nebula-puff--21 {
  width: 246px;
  height: 136px;
  margin-left: -123px;
  margin-top: -68px;
  transform: rotateY(343deg) translateX(160px) translateZ(108px) rotateY(-343deg) rotateX(-1.5deg) scale(0.64);
  opacity: 0.44;
  animation-delay: -7.77s; }

.perk-theme-overlay__nebula-puff--22 {
  width: 268px;
  height: 152px;
  margin-left: -134px;
  margin-top: -76px;
  transform: rotateY(470deg) translateX(166px) translateZ(-160px) rotateY(-470deg) rotateX(0deg) scale(0.73);
  opacity: 0.5;
  animation-delay: -8.14s; }

.perk-theme-overlay__nebula-puff--23 {
  width: 290px;
  height: 168px;
  margin-left: -145px;
  margin-top: -84px;
  transform: rotateY(597deg) translateX(172px) translateZ(-120px) rotateY(-597deg) rotateX(1.5deg) scale(0.82);
  opacity: 0.56;
  animation-delay: -8.51s; }

.perk-theme-overlay__nebula-puff--24 {
  width: 180px;
  height: 184px;
  margin-left: -90px;
  margin-top: -92px;
  transform: rotateY(392deg) translateX(196px) translateZ(-116px) rotateY(-392deg) rotateX(3deg) scale(0.79);
  opacity: 0.62;
  animation-delay: -8.88s; }

.perk-theme-overlay__nebula-puff--25 {
  width: 202px;
  height: 120px;
  margin-left: -101px;
  margin-top: -60px;
  transform: rotateY(519deg) translateX(172px) translateZ(-76px) rotateY(-519deg) rotateX(4.5deg) scale(0.88);
  opacity: 0.38;
  animation-delay: -9.25s; }

.perk-theme-overlay__nebula-puff--26 {
  width: 224px;
  height: 136px;
  margin-left: -112px;
  margin-top: -68px;
  transform: rotateY(646deg) translateX(178px) translateZ(-36px) rotateY(-646deg) rotateX(6deg) scale(0.97);
  opacity: 0.44;
  animation-delay: -9.62s; }

.perk-theme-overlay__nebula-puff--27 {
  width: 246px;
  height: 152px;
  margin-left: -123px;
  margin-top: -76px;
  transform: rotateY(441deg) translateX(202px) translateZ(-32px) rotateY(-441deg) rotateX(-6deg) scale(1.1);
  opacity: 0.5;
  animation-delay: -9.99s; }

.perk-theme-overlay__nebula-puff--28 {
  width: 268px;
  height: 168px;
  margin-left: -134px;
  margin-top: -84px;
  transform: rotateY(568deg) translateX(208px) translateZ(8px) rotateY(-568deg) rotateX(-4.5deg) scale(0.56);
  opacity: 0.56;
  animation-delay: -10.36s; }

.perk-theme-overlay__nebula-puff--29 {
  width: 290px;
  height: 184px;
  margin-left: -145px;
  margin-top: -92px;
  transform: rotateY(695deg) translateX(214px) translateZ(48px) rotateY(-695deg) rotateX(-3deg) scale(0.65);
  opacity: 0.62;
  animation-delay: -10.73s; }

.perk-theme-overlay__nebula-puff--30 {
  width: 180px;
  height: 120px;
  margin-left: -90px;
  margin-top: -60px;
  transform: rotateY(490deg) translateX(208px) translateZ(52px) rotateY(-490deg) rotateX(-1.5deg) scale(0.78);
  opacity: 0.38;
  animation-delay: -11.1s; }

.perk-theme-overlay__nebula-puff--31 {
  width: 202px;
  height: 136px;
  margin-left: -101px;
  margin-top: -68px;
  transform: rotateY(617deg) translateX(214px) translateZ(92px) rotateY(-617deg) rotateX(0deg) scale(0.87);
  opacity: 0.44;
  animation-delay: -11.47s; }

.perk-theme-overlay__nebula-puff--32 {
  width: 224px;
  height: 152px;
  margin-left: -112px;
  margin-top: -76px;
  transform: rotateY(744deg) translateX(220px) translateZ(132px) rotateY(-744deg) rotateX(1.5deg) scale(0.96);
  opacity: 0.5;
  animation-delay: -11.84s; }

.perk-theme-overlay__nebula-puff--33 {
  width: 246px;
  height: 168px;
  margin-left: -123px;
  margin-top: -84px;
  transform: rotateY(539deg) translateX(244px) translateZ(-172px) rotateY(-539deg) rotateX(3deg) scale(1.09);
  opacity: 0.56;
  animation-delay: -12.21s; }

.perk-theme-overlay__nebula-puff--34 {
  width: 268px;
  height: 184px;
  margin-left: -134px;
  margin-top: -92px;
  transform: rotateY(666deg) translateX(250px) translateZ(-132px) rotateY(-666deg) rotateX(4.5deg) scale(1.18);
  opacity: 0.62;
  animation-delay: -12.58s; }

.perk-theme-overlay__nebula-puff--35 {
  width: 290px;
  height: 120px;
  margin-left: -145px;
  margin-top: -60px;
  transform: rotateY(793deg) translateX(226px) translateZ(-92px) rotateY(-793deg) rotateX(6deg) scale(0.64);
  opacity: 0.38;
  animation-delay: -12.95s; }

.perk-theme-overlay__nebula-puff--36 {
  width: 180px;
  height: 136px;
  margin-left: -90px;
  margin-top: -68px;
  transform: rotateY(588deg) translateX(250px) translateZ(-88px) rotateY(-588deg) rotateX(-6deg) scale(0.61);
  opacity: 0.44;
  animation-delay: -13.32s; }

.perk-theme-overlay__nebula-puff--37 {
  width: 202px;
  height: 152px;
  margin-left: -101px;
  margin-top: -76px;
  transform: rotateY(715deg) translateX(256px) translateZ(-48px) rotateY(-715deg) rotateX(-4.5deg) scale(0.7);
  opacity: 0.5;
  animation-delay: -13.69s; }

.perk-theme-overlay__nebula-puff--38 {
  width: 224px;
  height: 168px;
  margin-left: -112px;
  margin-top: -84px;
  transform: rotateY(842deg) translateX(262px) translateZ(-8px) rotateY(-842deg) rotateX(-3deg) scale(0.79);
  opacity: 0.56;
  animation-delay: -14.06s; }

.perk-theme-overlay__nebula-puff--39 {
  width: 246px;
  height: 184px;
  margin-left: -123px;
  margin-top: -92px;
  transform: rotateY(637deg) translateX(286px) translateZ(-4px) rotateY(-637deg) rotateX(-1.5deg) scale(0.92);
  opacity: 0.62;
  animation-delay: -14.43s; }

.perk-theme-overlay__nebula-puff--40 {
  width: 268px;
  height: 120px;
  margin-left: -134px;
  margin-top: -60px;
  transform: rotateY(764deg) translateX(262px) translateZ(36px) rotateY(-764deg) rotateX(0deg) scale(1.01);
  opacity: 0.38;
  animation-delay: -14.8s; }

.perk-theme-overlay__nebula-puff--41 {
  width: 290px;
  height: 136px;
  margin-left: -145px;
  margin-top: -68px;
  transform: rotateY(891deg) translateX(268px) translateZ(76px) rotateY(-891deg) rotateX(1.5deg) scale(1.1);
  opacity: 0.44;
  animation-delay: -15.17s; }

@keyframes perk-theme-nebula-breathe {
  0%,
  100% {
    filter: blur(0.35px) brightness(0.96); }
  50% {
    filter: blur(0.55px) brightness(1.08); } }

@keyframes perk-theme-nebula-breathe-aurora {
  0%,
  100% {
    filter: blur(0.3px) brightness(0.9) saturate(0.95); }
  33% {
    filter: blur(0.7px) brightness(1.18) saturate(1.15); }
  66% {
    filter: blur(0.45px) brightness(1.05) saturate(1.05); } }

@keyframes perk-theme-nebula-aurora-10 {
  0%,
  100% {
    transform: translate(-50%, -50%) rotateX(-9.75deg) rotateY(-5.8deg) rotateZ(-0.38deg); }
  20% {
    transform: translate(-50%, calc(-50% - 0.75%)) rotateX(-8.35deg) rotateY(2.03deg) rotateZ(0.57deg); }
  45% {
    transform: translate(-50%, -50%) rotateX(-13.05deg) rotateY(5.8deg) rotateZ(-0.285deg); }
  70% {
    transform: translate(-50%, calc(-50% + 0.525%)) rotateX(-6.8deg) rotateY(-2.61deg) rotateZ(0.95deg); } }

.perk-theme-overlay__layer--nebula-m10 .perk-theme-overlay__nebula-world {
  animation: perk-theme-nebula-aurora-10 52.4s ease-in-out infinite; }

.perk-theme-overlay__layer--nebula-m10 .perk-theme-overlay__nebula-puff {
  animation: perk-theme-nebula-breathe 13.3s ease-in-out infinite; }

@keyframes perk-theme-nebula-aurora-20 {
  0%,
  100% {
    transform: translate(-50%, -50%) rotateX(-10.125deg) rotateY(-8.6deg) rotateZ(-0.6deg); }
  20% {
    transform: translate(-50%, calc(-50% - 1.1%)) rotateX(-7.525deg) rotateY(3.01deg) rotateZ(0.9deg); }
  45% {
    transform: translate(-50%, -50%) rotateX(-13.575deg) rotateY(8.6deg) rotateZ(-0.45deg); }
  70% {
    transform: translate(-50%, calc(-50% + 0.77%)) rotateX(-6.2deg) rotateY(-3.87deg) rotateZ(1.5deg); } }

.perk-theme-overlay__layer--nebula-m20 .perk-theme-overlay__nebula-world {
  animation: perk-theme-nebula-aurora-20 48.8s ease-in-out infinite; }

.perk-theme-overlay__layer--nebula-m20 .perk-theme-overlay__nebula-puff {
  animation: perk-theme-nebula-breathe 12.6s ease-in-out infinite; }

@keyframes perk-theme-nebula-aurora-30 {
  0%,
  100% {
    transform: translate(-50%, -50%) rotateX(-10.5deg) rotateY(-11.4deg) rotateZ(-0.82deg); }
  20% {
    transform: translate(-50%, calc(-50% - 1.45%)) rotateX(-6.7deg) rotateY(3.99deg) rotateZ(1.23deg); }
  45% {
    transform: translate(-50%, -50%) rotateX(-14.1deg) rotateY(11.4deg) rotateZ(-0.615deg); }
  70% {
    transform: translate(-50%, calc(-50% + 1.015%)) rotateX(-5.6deg) rotateY(-5.13deg) rotateZ(2.05deg); } }

.perk-theme-overlay__layer--nebula-m30 .perk-theme-overlay__nebula-world {
  animation: perk-theme-nebula-aurora-30 45.2s ease-in-out infinite; }

.perk-theme-overlay__layer--nebula-m30 .perk-theme-overlay__nebula-puff {
  animation: perk-theme-nebula-breathe 11.9s ease-in-out infinite; }

@keyframes perk-theme-nebula-aurora-40 {
  0%,
  100% {
    transform: translate(-50%, -50%) rotateX(-10.875deg) rotateY(-14.2deg) rotateZ(-1.04deg); }
  20% {
    transform: translate(-50%, calc(-50% - 1.8%)) rotateX(-5.875deg) rotateY(4.97deg) rotateZ(1.56deg); }
  45% {
    transform: translate(-50%, -50%) rotateX(-14.625deg) rotateY(14.2deg) rotateZ(-0.78deg); }
  70% {
    transform: translate(-50%, calc(-50% + 1.26%)) rotateX(-5deg) rotateY(-6.39deg) rotateZ(2.6deg); } }

.perk-theme-overlay__layer--nebula-m40 .perk-theme-overlay__nebula-world {
  animation: perk-theme-nebula-aurora-40 41.6s ease-in-out infinite; }

.perk-theme-overlay__layer--nebula-m40 .perk-theme-overlay__nebula-puff {
  animation: perk-theme-nebula-breathe 11.2s ease-in-out infinite; }

@keyframes perk-theme-nebula-aurora-50 {
  0%,
  100% {
    transform: translate(-50%, -50%) rotateX(-11.25deg) rotateY(-17deg) rotateZ(-1.26deg); }
  20% {
    transform: translate(-50%, calc(-50% - 2.15%)) rotateX(-5.05deg) rotateY(5.95deg) rotateZ(1.89deg); }
  45% {
    transform: translate(-50%, -50%) rotateX(-15.15deg) rotateY(17deg) rotateZ(-0.945deg); }
  70% {
    transform: translate(-50%, calc(-50% + 1.505%)) rotateX(-4.4deg) rotateY(-7.65deg) rotateZ(3.15deg); } }

.perk-theme-overlay__layer--nebula-m50 .perk-theme-overlay__nebula-world {
  animation: perk-theme-nebula-aurora-50 38s ease-in-out infinite; }

.perk-theme-overlay__layer--nebula-m50 .perk-theme-overlay__nebula-puff {
  animation: perk-theme-nebula-breathe 10.5s ease-in-out infinite; }

@keyframes perk-theme-nebula-aurora-60 {
  0%,
  100% {
    transform: translate(-50%, -50%) rotateX(-11.625deg) rotateY(-19.8deg) rotateZ(-1.48deg); }
  20% {
    transform: translate(-50%, calc(-50% - 2.5%)) rotateX(-4.225deg) rotateY(6.93deg) rotateZ(2.22deg); }
  45% {
    transform: translate(-50%, -50%) rotateX(-15.675deg) rotateY(19.8deg) rotateZ(-1.11deg); }
  70% {
    transform: translate(-50%, calc(-50% + 1.75%)) rotateX(-3.8deg) rotateY(-8.91deg) rotateZ(3.7deg); } }

.perk-theme-overlay__layer--nebula-m60 .perk-theme-overlay__nebula-world {
  animation: perk-theme-nebula-aurora-60 34.4s ease-in-out infinite; }

.perk-theme-overlay__layer--nebula-m60 .perk-theme-overlay__nebula-puff {
  animation: perk-theme-nebula-breathe 9.8s ease-in-out infinite; }

@keyframes perk-theme-nebula-aurora-70 {
  0%,
  100% {
    transform: translate(-50%, -50%) rotateX(-12deg) rotateY(-22.6deg) rotateZ(-1.7deg); }
  20% {
    transform: translate(-50%, calc(-50% - 2.85%)) rotateX(-3.4deg) rotateY(7.91deg) rotateZ(2.55deg); }
  45% {
    transform: translate(-50%, -50%) rotateX(-16.2deg) rotateY(22.6deg) rotateZ(-1.275deg); }
  70% {
    transform: translate(-50%, calc(-50% + 1.995%)) rotateX(-3.2deg) rotateY(-10.17deg) rotateZ(4.25deg); } }

.perk-theme-overlay__layer--nebula-m70 .perk-theme-overlay__nebula-world {
  animation: perk-theme-nebula-aurora-70 30.8s ease-in-out infinite; }

.perk-theme-overlay__layer--nebula-m70 .perk-theme-overlay__nebula-puff {
  animation: perk-theme-nebula-breathe-aurora 9.1s ease-in-out infinite; }

@keyframes perk-theme-nebula-aurora-80 {
  0%,
  100% {
    transform: translate(-50%, -50%) rotateX(-12.375deg) rotateY(-25.4deg) rotateZ(-1.92deg); }
  20% {
    transform: translate(-50%, calc(-50% - 3.2%)) rotateX(-2.575deg) rotateY(8.89deg) rotateZ(2.88deg); }
  45% {
    transform: translate(-50%, -50%) rotateX(-16.725deg) rotateY(25.4deg) rotateZ(-1.44deg); }
  70% {
    transform: translate(-50%, calc(-50% + 2.24%)) rotateX(-2.6deg) rotateY(-11.43deg) rotateZ(4.8deg); } }

.perk-theme-overlay__layer--nebula-m80 .perk-theme-overlay__nebula-world {
  animation: perk-theme-nebula-aurora-80 27.2s ease-in-out infinite; }

.perk-theme-overlay__layer--nebula-m80 .perk-theme-overlay__nebula-puff {
  animation: perk-theme-nebula-breathe-aurora 8.4s ease-in-out infinite; }

@keyframes perk-theme-nebula-aurora-90 {
  0%,
  100% {
    transform: translate(-50%, -50%) rotateX(-12.75deg) rotateY(-28.2deg) rotateZ(-2.14deg); }
  20% {
    transform: translate(-50%, calc(-50% - 3.55%)) rotateX(-1.75deg) rotateY(9.87deg) rotateZ(3.21deg); }
  45% {
    transform: translate(-50%, -50%) rotateX(-17.25deg) rotateY(28.2deg) rotateZ(-1.605deg); }
  70% {
    transform: translate(-50%, calc(-50% + 2.485%)) rotateX(-2deg) rotateY(-12.69deg) rotateZ(5.35deg); } }

.perk-theme-overlay__layer--nebula-m90 .perk-theme-overlay__nebula-world {
  animation: perk-theme-nebula-aurora-90 23.6s ease-in-out infinite; }

.perk-theme-overlay__layer--nebula-m90 .perk-theme-overlay__nebula-puff {
  animation: perk-theme-nebula-breathe-aurora 7.7s ease-in-out infinite; }

@keyframes perk-theme-nebula-aurora-100 {
  0%,
  100% {
    transform: translate(-50%, -50%) rotateX(-13.125deg) rotateY(-31deg) rotateZ(-2.36deg); }
  20% {
    transform: translate(-50%, calc(-50% - 3.9%)) rotateX(-0.925deg) rotateY(10.85deg) rotateZ(3.54deg); }
  45% {
    transform: translate(-50%, -50%) rotateX(-17.775deg) rotateY(31deg) rotateZ(-1.77deg); }
  70% {
    transform: translate(-50%, calc(-50% + 2.73%)) rotateX(-1.4deg) rotateY(-13.95deg) rotateZ(5.9deg); } }

.perk-theme-overlay__layer--nebula-m100 .perk-theme-overlay__nebula-world {
  animation: perk-theme-nebula-aurora-100 20s ease-in-out infinite; }

.perk-theme-overlay__layer--nebula-m100 .perk-theme-overlay__nebula-puff {
  animation: perk-theme-nebula-breathe-aurora 7s ease-in-out infinite; }

@media (prefers-reduced-motion: reduce) {
  .perk-theme-overlay__rain-drop,
  .perk-theme-overlay__rain-stem {
    animation: none !important;
    opacity: 0; }
  .perk-theme-overlay__lightning-canvas,
  .perk-theme-overlay__glass-canvas,
  .perk-theme-overlay__heat-canvas,
  .perk-theme-overlay__snow-canvas,
  .perk-theme-frame-halo--frost .perk-theme-frame-halo__canvas,
  .perk-theme-frame-halo--spiral .perk-theme-frame-halo__canvas {
    display: none; }
  .perk-theme-overlay__nebula-world,
  .perk-theme-overlay__nebula-puff {
    animation: none !important; } }

/* /src/style/publicToc.scss */
@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.public-toc-panel {
  position: fixed;
  transform: translateX(-560px);
  place-self: center;
  z-index: 30;
  overflow: hidden;
  margin-top: -18px;
  align-self: flex-start;
  margin-bottom: auto; }

/* ENTRY ANIMATION */
.public-toc-panel-inner {
  width: 314px;
  padding: 16px;
  animation: public-toc-slide-in 0.3s ease-out forwards; }

/* EXIT ANIMATION — MUST OVERRIDE ALL PREVIOUS ANIMATIONS */
.public-toc-panel-inner.closing {
  animation: public-toc-slide-out 0.3s ease-in forwards !important; }

@keyframes public-toc-slide-in {
  from {
    transform: translateX(280px); }
  to {
    transform: translateX(0); } }

@keyframes public-toc-slide-out {
  from {
    transform: translateX(0); }
  to {
    transform: translateX(280px); } }

.public-container {
  transition: transform 0.3s ease; }

.public-container-shifted {
  transform: translateX(160px); }

.public-toc-header {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  color: white;
  font-family: 'Lato', sans-serif;
  font-size: 1em;
  font-weight: bolder;
  text-transform: uppercase;
  margin-bottom: 15px;
  border-bottom: 2px solid #b8b8b8; }

.public-toc-content {
  max-height: calc(86vh - 190px);
  overflow: auto; }
  .public-toc-content::-webkit-scrollbar {
    width: 6px; }
  .public-toc-content::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .public-toc-content::-webkit-scrollbar-thumb {
    background-color: #355167;
    border-radius: 4px; }
    .public-toc-content::-webkit-scrollbar-thumb:hover {
      background-color: #243745; }

.public-toc-list {
  cursor: pointer;
  margin: 4px 0;
  padding: 15px; }

.public-toc-list li {
  cursor: pointer;
  margin: 4px 0; }

.public-toc-l3 {
  margin-left: 10px; }

.public-toc-l4 {
  margin-left: 20px; }

.public-toc-button-container {
  display: flex;
  position: relative;
  width: 0px;
  left: -5px;
  top: 20px;
  overflow: visible;
  cursor: pointer; }

.public-toc-button {
  padding: 8px 14px;
  cursor: pointer; }

.public-toc-icon {
  width: 22px;
  height: 22px;
  opacity: 0.8; }

.public-toc-icon:hover {
  opacity: 1; }

/* rotation si ouvert, optionnel */
.toc-open {
  transform: rotate(180deg); }

.public-toc-list {
  list-style: none; }
  .public-toc-list .toc-h1 {
    color: white;
    font-size: 20px;
    font-weight: bolder;
    text-transform: uppercase;
    margin-bottom: 25px;
    font-family: GoodTimes; }
  .public-toc-list .toc-h2 {
    font-size: 16px;
    font-weight: bolder;
    color: #dfdfdf;
    text-transform: capitalize;
    margin-top: -15px;
    margin-bottom: 20px;
    font-family: Lato; }
  .public-toc-list .toc-h3 {
    font-size: 16px;
    font-weight: bolder;
    color: #dfdfdf;
    text-transform: uppercase;
    margin-top: 15px;
    margin-left: 0px;
    font-family: Lato;
    cursor: pointer; }
  .public-toc-list .toc-h4 {
    font-size: 14px;
    font-weight: bold;
    color: #b8b8b8;
    text-transform: uppercase;
    margin-top: 5px;
    margin-left: 15px;
    margin-bottom: 5px;
    font-family: Lato;
    cursor: pointer; }
  .public-toc-list .toc-h5 {
    font-size: 14px;
    font-weight: 300;
    color: #b8b8b8;
    text-transform: capitalize;
    margin-top: 5px;
    margin-left: 30px;
    margin-bottom: 5px;
    font-family: Lato;
    cursor: pointer; }
  .public-toc-list .toc-h6 {
    font-size: 14px;
    font-weight: 100;
    color: #b8b8b8;
    text-transform: capitalize;
    margin-top: 5px;
    margin-left: 45px;
    margin-bottom: 5px;
    font-family: Lato;
    cursor: pointer; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.inputs {
  width: 100%; }
  .inputs.permissions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: min-content;
    gap: 10px;
    height: 170px; }
  .inputs.create-event {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    width: fit-content;
    padding: 0 10px 5px 10px;
    gap: 10px;
    margin-top: 10px; }
    .inputs.create-event .inputs-column {
      display: flex;
      flex-direction: column;
      width: 200px;
      gap: 5px; }
      .inputs.create-event .inputs-column.width {
        width: 230px; }
      .inputs.create-event .inputs-column .input {
        display: flex;
        margin-bottom: 5px;
        font-size: 14px; }
        .inputs.create-event .inputs-column .input.lock .input-wrapper .react-select__control,
        .inputs.create-event .inputs-column .input.lock .input-wrapper .react-select-input__control,
        .inputs.create-event .inputs-column .input.lock .input-wrapper .react-select-menu__control {
          background-color: #b8b8b8; }
        .inputs.create-event .inputs-column .input.lock .input-wrapper .field-input {
          background-color: #b8b8b8;
          color: #dfdfdf;
          cursor: not-allowed;
          opacity: 1; }
        .inputs.create-event .inputs-column .input .input-wrapper {
          display: flex;
          align-items: center;
          flex-direction: row; }
        .inputs.create-event .inputs-column .input .required-empty,
        .inputs.create-event .inputs-column .input .required-filled {
          border: 1px solid transparent;
          border-radius: 4px; }
        .inputs.create-event .inputs-column .input .required-empty {
          border-color: #d12323; }
        .inputs.create-event .inputs-column .input .required-empty .field-input,
        .inputs.create-event .inputs-column .input .required-filled .field-input {
          border: 1px solid transparent; }
        .inputs.create-event .inputs-column .input .required-empty .react-select-input__control,
        .inputs.create-event .inputs-column .input .required-filled .react-select-input__control {
          border: 1px solid transparent !important; }
        .inputs.create-event .inputs-column .input .required-empty .react-select-input__control {
          border-color: #d12323 !important; }
        .inputs.create-event .inputs-column .input .organization-share-label {
          position: relative;
          margin: 0 10px;
          color: #dfdfdf;
          font-size: 1em;
          font-weight: bolder;
          top: 3px; }
        .inputs.create-event .inputs-column .input.ribbon-rewards {
          border: none; }
        .inputs.create-event .inputs-column .input .field-input {
          width: 160px;
          font-size: 12px;
          padding: 3px 5px 3px 5px;
          border: 1px solid transparent;
          border-radius: 4px; }
          .inputs.create-event .inputs-column .input .field-input.manual-value {
            padding: 3px 5px 3px 5px;
            font-size: 12px;
            width: 180px;
            color: #dfdfdf;
            text-transform: uppercase;
            background-color: #2a3847;
            border: 1px solid transparent;
            border-radius: 4px; }
          .inputs.create-event .inputs-column .input .field-input.participant-limit {
            width: 100px; }
          .inputs.create-event .inputs-column .input .field-input.organization-share {
            width: 36px; }
        .inputs.create-event .inputs-column .input .field-value {
          padding: 3px 5px 3px 5px;
          font-size: 12px;
          width: 165px;
          color: #dfdfdf;
          text-transform: uppercase;
          border: 1px solid #dfdfdf;
          border-radius: 4px; }
        .inputs.create-event .inputs-column .input.allied {
          color: #0c2637;
          background-color: #dfdfdf;
          border: 1px solid #0c2637;
          border-radius: 4px;
          font-size: 14px;
          height: 150px;
          width: 175px;
          overflow-y: auto; }
          .inputs.create-event .inputs-column .input.allied::-webkit-scrollbar {
            width: 6px; }
          .inputs.create-event .inputs-column .input.allied::-webkit-scrollbar-track {
            background: #2e3842;
            border-radius: 4px;
            padding-right: 1px; }
          .inputs.create-event .inputs-column .input.allied::-webkit-scrollbar-thumb {
            background-color: #491212;
            border-radius: 4px; }
            .inputs.create-event .inputs-column .input.allied::-webkit-scrollbar-thumb:hover {
              background-color: #200808; }
          .inputs.create-event .inputs-column .input.allied.disabled {
            opacity: 0.5; }
          .inputs.create-event .inputs-column .input.allied .allied-list {
            padding: 5px; }
            .inputs.create-event .inputs-column .input.allied .allied-list::-webkit-scrollbar {
              width: 6px; }
            .inputs.create-event .inputs-column .input.allied .allied-list::-webkit-scrollbar-track {
              background: #2e3842;
              border-radius: 4px;
              padding-right: 1px; }
            .inputs.create-event .inputs-column .input.allied .allied-list::-webkit-scrollbar-thumb {
              background-color: #491212;
              border-radius: 4px; }
              .inputs.create-event .inputs-column .input.allied .allied-list::-webkit-scrollbar-thumb:hover {
                background-color: #200808; }
      .inputs.create-event .inputs-column.allied {
        color: #0c2637;
        background-color: #dfdfdf;
        border: 1px solid #0c2637;
        border-radius: 4px;
        margin-left: 5px;
        font-size: 14px;
        height: 170px;
        overflow-y: auto; }
        .inputs.create-event .inputs-column.allied::-webkit-scrollbar {
          width: 6px; }
        .inputs.create-event .inputs-column.allied::-webkit-scrollbar-track {
          background: #2e3842;
          border-radius: 4px;
          padding-right: 1px; }
        .inputs.create-event .inputs-column.allied::-webkit-scrollbar-thumb {
          background-color: #491212;
          border-radius: 4px; }
          .inputs.create-event .inputs-column.allied::-webkit-scrollbar-thumb:hover {
            background-color: #200808; }
        .inputs.create-event .inputs-column.allied .allied-list {
          padding: 5px; }
          .inputs.create-event .inputs-column.allied .allied-list::-webkit-scrollbar {
            width: 6px; }
          .inputs.create-event .inputs-column.allied .allied-list::-webkit-scrollbar-track {
            background: #2e3842;
            border-radius: 4px;
            padding-right: 1px; }
          .inputs.create-event .inputs-column.allied .allied-list::-webkit-scrollbar-thumb {
            background-color: #491212;
            border-radius: 4px; }
            .inputs.create-event .inputs-column.allied .allied-list::-webkit-scrollbar-thumb:hover {
              background-color: #200808; }
      .inputs.create-event .inputs-column.rewards {
        width: 300px;
        height: min-content; }
  .inputs .input-field .input.ribbons {
    border-radius: 4px; }
    .inputs .input-field .input.ribbons.ribbonName {
      width: 100%; }
    .inputs .input-field .input.ribbons.description {
      width: 100%;
      height: 100px;
      resize: none; }

/* Create event: max attendees number + cap toggle on one row */
.inputs.create-event .inputs-column.create-event-location-short .input-wrapper,
.inputs.create-event .inputs-column .create-event-location-short .input-wrapper,
.inputs.create-event .create-event-meeting-point.create-event-location-short .input-wrapper {
  width: 100%; }

.inputs.create-event .inputs-column.create-event-location-short .react-select-input__control,
.inputs.create-event .inputs-column .create-event-location-short .react-select-input__control,
.inputs.create-event .create-event-meeting-point.create-event-location-short .react-select-input__control {
  min-height: 28px;
  width: 190px; }

.inputs.create-event .inputs-column.create-event-location-short .react-select-input__value-container,
.inputs.create-event .inputs-column .create-event-location-short .react-select-input__value-container,
.inputs.create-event .create-event-meeting-point.create-event-location-short .react-select-input__value-container {
  padding: 0 6px;
  font-size: 12px; }

.inputs.create-event .inputs-column.create-event-location-short .react-select-input__placeholder,
.inputs.create-event .inputs-column.create-event-location-short .react-select-input__single-value,
.inputs.create-event .inputs-column.create-event-location-short .react-select-input__input-container,
.inputs.create-event .inputs-column .create-event-location-short .react-select-input__placeholder,
.inputs.create-event .inputs-column .create-event-location-short .react-select-input__single-value,
.inputs.create-event .inputs-column .create-event-location-short .react-select-input__input-container,
.inputs.create-event .create-event-meeting-point.create-event-location-short .react-select-input__placeholder,
.inputs.create-event .create-event-meeting-point.create-event-location-short .react-select-input__single-value,
.inputs.create-event .create-event-meeting-point.create-event-location-short .react-select-input__input-container {
  font-size: 12px; }

.inputs.create-event .inputs-column.create-event-location-short .react-select-input__indicators,
.inputs.create-event .inputs-column .create-event-location-short .react-select-input__indicators,
.inputs.create-event .create-event-meeting-point.create-event-location-short .react-select-input__indicators {
  height: 28px; }

.inputs.create-event .inputs-column.create-event-location-short .create-event-location-short__label,
.inputs.create-event .inputs-column .create-event-location-short .create-event-location-short__label,
.inputs.create-event .create-event-meeting-point.create-event-location-short .create-event-location-short__label {
  padding-left: 5px; }

.inputs.create-event .inputs-column.create-event-location-short .create-event-location-short__error,
.inputs.create-event .inputs-column .create-event-location-short .create-event-location-short__error,
.inputs.create-event .create-event-meeting-point.create-event-location-short .create-event-location-short__error {
  color: #d12323;
  font-size: 11px;
  line-height: 1.2; }

.inputs.create-event .inputs-column.create-event-location-short .create-event-location-short__solar,
.inputs.create-event .inputs-column .create-event-location-short .create-event-location-short__solar,
.inputs.create-event .create-event-meeting-point.create-event-location-short .create-event-location-short__solar {
  color: #dfdfdf;
  font-size: 11px;
  line-height: 1.25; }

.inputs.create-event .inputs-column .input.max-attendees-row {
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: nowrap; }
  .inputs.create-event .inputs-column .input.max-attendees-row .max-attendees-row__field {
    flex: 1 1 auto;
    min-width: 0; }
  .inputs.create-event .inputs-column .input.max-attendees-row .max-attendees-row__toggle.toggle.max-attendees-cap {
    flex: 0 0 auto;
    width: auto;
    margin-bottom: 0;
    margin-top: 0;
    justify-content: flex-end; }

/* Create event: Discord vs Mumble (segmented control, Lexical-style) */
.inputs.create-event .inputs-column .input.create-event-voice-row {
  width: 100%;
  margin-bottom: 30px; }

.inputs.create-event .inputs-column .create-event-voice-toggle {
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  width: 172px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #384858; }

.inputs.create-event .inputs-column .create-event-voice-toggle__mode {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 5px;
  flex: 1 1 50%;
  padding: 6px 8px;
  margin: 0;
  border: none;
  background: #2a3847;
  color: #dfdfdf;
  cursor: pointer;
  text-align: center;
  min-width: 0;
  transition: background 0.15s ease, box-shadow 0.15s ease, color 0.15s ease; }
  .inputs.create-event .inputs-column .create-event-voice-toggle__mode:disabled {
    opacity: 0.45;
    cursor: not-allowed; }
  .inputs.create-event .inputs-column .create-event-voice-toggle__mode:not(:disabled):hover {
    background: #384858; }
  .inputs.create-event .inputs-column .create-event-voice-toggle__mode:not(.create-event-voice-toggle__mode--active):not(:disabled) .create-event-voice-toggle__brand-img {
    opacity: 0.55; }
  .inputs.create-event .inputs-column .create-event-voice-toggle__mode:not(.create-event-voice-toggle__mode--active):not(:disabled) .create-event-voice-toggle__label {
    opacity: 0.8; }

.inputs.create-event .inputs-column .create-event-voice-toggle__mode--discord {
  border-right: 1px solid #384858; }

.inputs.create-event .inputs-column .create-event-voice-toggle__mode--discord.create-event-voice-toggle__mode--active {
  background: #1c2d38;
  box-shadow: inset 0 0 0 1px #5865f2;
  border-radius: 8px 0px 0px 8px; }
  .inputs.create-event .inputs-column .create-event-voice-toggle__mode--discord.create-event-voice-toggle__mode--active .create-event-voice-toggle__label {
    color: #949cf8; }
  .inputs.create-event .inputs-column .create-event-voice-toggle__mode--discord.create-event-voice-toggle__mode--active .create-event-voice-toggle__brand-img {
    opacity: 1; }

.inputs.create-event .inputs-column .create-event-voice-toggle__mode--mumble.create-event-voice-toggle__mode--active {
  background: #1c2d38;
  box-shadow: inset 0 0 0 1px #5aa05c;
  border-radius: 0px 8px 0px 0px; }
  .inputs.create-event .inputs-column .create-event-voice-toggle__mode--mumble.create-event-voice-toggle__mode--active .create-event-voice-toggle__label {
    color: #5aa05c; }
  .inputs.create-event .inputs-column .create-event-voice-toggle__mode--mumble.create-event-voice-toggle__mode--active .create-event-voice-toggle__brand-img {
    opacity: 1; }

.inputs.create-event .inputs-column .create-event-voice-toggle__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 22px;
  height: 22px; }

.inputs.create-event .inputs-column .create-event-voice-toggle__brand-img {
  display: block;
  width: 18px;
  height: 18px;
  object-fit: contain; }

.inputs.create-event .inputs-column .create-event-voice-toggle__brand-img--mumble {
  filter: brightness(1.15); }

.inputs.create-event .inputs-column .create-event-voice-toggle__label {
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  white-space: nowrap; }

.input-comms {
  width: 50px; }

.field-input {
  display: flex;
  padding: 3px 5px 3px 5px;
  border-radius: 4px; }

.time-limit {
  display: flex;
  flex-direction: row;
  margin-left: 18px; }

.input-row {
  display: flex;
  flex-direction: row;
  justify-content: left;
  margin-right: 18px;
  margin-left: 18px;
  align-items: center; }
  .input-row.themes {
    gap: 15px;
    margin-left: 2px;
    margin-right: 5px; }
  .input-row.training-levels {
    gap: 15px;
    margin-left: 2px;
    margin-right: 5px; }
  .input-row.create-questions {
    gap: 15px;
    margin-left: 0px;
    margin-right: 0px; }
  .input-row.time-inputs.label {
    margin-right: 2px; }
  .input-row .input.time-input {
    width: 40px;
    margin-right: 2px; }
  .input-row .input.question-input {
    width: 100%;
    height: auto;
    min-height: 100px;
    /* Minimum height pour éviter d'être trop petit */
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #ccc;
    font-size: 16px;
    /* Taille de texte lisible */
    line-height: 1.5;
    /* Espacement pour le confort */
    resize: vertical;
    /* Permet le redimensionnement vertical */
    overflow-wrap: break-word;
    /* Assure le découpage des mots longs */
    white-space: pre-wrap;
    /* Respecte les retours à la ligne */
    box-sizing: border-box;
    /* Assure que padding/border n'affectent pas la taille */ }
  .input-row.event-type-subtypes {
    align-items: normal;
    margin-right: 10px;
    margin-left: 0px; }

.inputs-column {
  display: flex;
  flex-direction: column; }
  .inputs-column .inputs-row {
    display: flex;
    flex-direction: row;
    gap: 15px; }
  .inputs-column.permissions {
    margin-right: 0px;
    margin-left: auto;
    justify-content: center; }
  .inputs-column .input {
    display: flex;
    margin-bottom: 5px;
    font-size: 12px;
    padding: 3px 5px 3px 5px;
    border-radius: 5px; }
    .inputs-column .input.permissions {
      width: 300px; }
    .inputs-column .input.event-type, .inputs-column .input.event-subtype {
      height: 20px; }
  .inputs-column.themes {
    width: 275px; }
    .inputs-column.themes .inputs-row {
      width: 244px;
      margin-left: 10px; }
  .inputs-column.subtypes {
    margin-right: 10px;
    width: 450px; }
  .inputs-column.trainings {
    margin-right: 10px; }
  .inputs-column.trainings-selection {
    width: 100%;
    margin-top: 35px; }
  .inputs-column.lower-part {
    margin: auto 0px 10px 0px; }

.permissions .field-input,
.roles .field-input,
.groups .field-input {
  display: flex;
  width: 300px;
  margin-top: 5px;
  padding: 3px 5px 3px 5px;
  border-radius: 4px; }
  .permissions .field-input .description,
  .roles .field-input .description,
  .groups .field-input .description {
    width: 300px;
    height: 32px;
    border-radius: 4px; }
  .permissions .field-input.short,
  .roles .field-input.short,
  .groups .field-input.short {
    width: 55px; }

.management-container.objectives-bloc {
  background-color: #172738;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 10px;
  margin-left: auto;
  margin-right: auto;
  padding: 0;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box; }
  .management-container.objectives-bloc .create-event-objectives-layout {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 100%;
    margin: 10px 0;
    margin-left: 0;
    margin-right: 0;
    box-sizing: border-box; }
    .management-container.objectives-bloc .create-event-objectives-layout .create-event-objectives-editor-row {
      display: flex;
      gap: 10px;
      padding: 0 10px 10px;
      align-items: stretch; }
      .management-container.objectives-bloc .create-event-objectives-layout .create-event-objectives-editor-row .create-event-objectives-list-panel {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 10px 0 0;
        gap: 10px;
        flex: 0 0 260px;
        padding-top: 10px; }
        .management-container.objectives-bloc .create-event-objectives-layout .create-event-objectives-editor-row .create-event-objectives-list-panel .create-event-objectives-middle-column {
          flex: 1 1 auto;
          min-width: 240px;
          max-width: 260px;
          padding: 0;
          display: flex;
          flex-direction: column;
          gap: 10px; }
          .management-container.objectives-bloc .create-event-objectives-layout .create-event-objectives-editor-row .create-event-objectives-list-panel .create-event-objectives-middle-column .create-event-objectives-field {
            margin-bottom: 0;
            padding: 5px 10px;
            padding-right: 26px;
            border: 1px solid #b8b8b8;
            border-radius: 8px; }
          .management-container.objectives-bloc .create-event-objectives-layout .create-event-objectives-editor-row .create-event-objectives-list-panel .create-event-objectives-middle-column .create-event-objectives-toggle {
            padding-right: 25px;
            display: flex;
            width: 100%;
            height: auto;
            bottom: 0;
            transform: none; }
            .management-container.objectives-bloc .create-event-objectives-layout .create-event-objectives-editor-row .create-event-objectives-list-panel .create-event-objectives-middle-column .create-event-objectives-toggle .toggle-label {
              flex: 1 1 auto;
              margin-right: 10px; }
            .management-container.objectives-bloc .create-event-objectives-layout .create-event-objectives-editor-row .create-event-objectives-list-panel .create-event-objectives-middle-column .create-event-objectives-toggle .toggle-switch {
              position: relative;
              height: 13px;
              left: auto;
              right: auto;
              margin-left: auto; }
          .management-container.objectives-bloc .create-event-objectives-layout .create-event-objectives-editor-row .create-event-objectives-list-panel .create-event-objectives-middle-column .create-event-objectives-toggle .toggle-label {
            color: #b8b8b8;
            display: block;
            text-transform: none;
            font-weight: normal;
            font-size: 15px;
            margin-left: 10px; }
          .management-container.objectives-bloc .create-event-objectives-layout .create-event-objectives-editor-row .create-event-objectives-list-panel .create-event-objectives-middle-column .create-event-objectives-list-container {
            border: 1px solid #b8b8b8;
            border-radius: 8px;
            padding: 8px;
            background-color: rgba(0, 0, 0, 0.15);
            width: 100%;
            box-sizing: border-box; }
            .management-container.objectives-bloc .create-event-objectives-layout .create-event-objectives-editor-row .create-event-objectives-list-panel .create-event-objectives-middle-column .create-event-objectives-list-container.disabled {
              opacity: 0.6; }
              .management-container.objectives-bloc .create-event-objectives-layout .create-event-objectives-editor-row .create-event-objectives-list-panel .create-event-objectives-middle-column .create-event-objectives-list-container.disabled .create-event-objectives-scroll {
                height: auto; }
            .management-container.objectives-bloc .create-event-objectives-layout .create-event-objectives-editor-row .create-event-objectives-list-panel .create-event-objectives-middle-column .create-event-objectives-list-container .create-event-objectives-scroll {
              height: 233px;
              overflow-y: auto;
              padding-right: 6px;
              display: flex;
              flex-direction: column;
              gap: 10px; }
              .management-container.objectives-bloc .create-event-objectives-layout .create-event-objectives-editor-row .create-event-objectives-list-panel .create-event-objectives-middle-column .create-event-objectives-list-container .create-event-objectives-scroll::-webkit-scrollbar {
                width: 6px; }
              .management-container.objectives-bloc .create-event-objectives-layout .create-event-objectives-editor-row .create-event-objectives-list-panel .create-event-objectives-middle-column .create-event-objectives-list-container .create-event-objectives-scroll::-webkit-scrollbar-track {
                background: #2e3842;
                border-radius: 4px;
                padding-right: 1px; }
              .management-container.objectives-bloc .create-event-objectives-layout .create-event-objectives-editor-row .create-event-objectives-list-panel .create-event-objectives-middle-column .create-event-objectives-list-container .create-event-objectives-scroll::-webkit-scrollbar-thumb {
                background-color: #491212;
                border-radius: 4px; }
                .management-container.objectives-bloc .create-event-objectives-layout .create-event-objectives-editor-row .create-event-objectives-list-panel .create-event-objectives-middle-column .create-event-objectives-list-container .create-event-objectives-scroll::-webkit-scrollbar-thumb:hover {
                  background-color: #200808; }
            .management-container.objectives-bloc .create-event-objectives-layout .create-event-objectives-editor-row .create-event-objectives-list-panel .create-event-objectives-middle-column .create-event-objectives-list-container .create-event-objectives-row {
              display: grid;
              grid-template-columns: 28px 1fr auto;
              gap: 6px;
              padding: 5px 2px;
              align-items: center;
              position: relative;
              cursor: pointer; }
              .management-container.objectives-bloc .create-event-objectives-layout .create-event-objectives-editor-row .create-event-objectives-list-panel .create-event-objectives-middle-column .create-event-objectives-list-container .create-event-objectives-row.is-selected {
                border-radius: 6px;
                background-color: #133b53; }
            .management-container.objectives-bloc .create-event-objectives-layout .create-event-objectives-editor-row .create-event-objectives-list-panel .create-event-objectives-middle-column .create-event-objectives-list-container .create-event-objectives-order {
              font-size: 0.85em;
              color: #dfdfdf;
              opacity: 0.75;
              text-align: right;
              user-select: none;
              cursor: grab; }
              .management-container.objectives-bloc .create-event-objectives-layout .create-event-objectives-editor-row .create-event-objectives-list-panel .create-event-objectives-middle-column .create-event-objectives-list-container .create-event-objectives-order.is-disabled {
                opacity: 0.25;
                cursor: default; }
            .management-container.objectives-bloc .create-event-objectives-layout .create-event-objectives-editor-row .create-event-objectives-list-panel .create-event-objectives-middle-column .create-event-objectives-list-container .create-event-objectives-input {
              width: 100%;
              box-sizing: border-box; }
            .management-container.objectives-bloc .create-event-objectives-layout .create-event-objectives-editor-row .create-event-objectives-list-panel .create-event-objectives-middle-column .create-event-objectives-list-container .toggle.critical {
              height: 11px;
              display: flex;
              align-items: center;
              top: 0px;
              gap: 6px; }
      .management-container.objectives-bloc .create-event-objectives-layout .create-event-objectives-editor-row .create-event-objectives-lexical-panel {
        flex: 1 1 auto;
        min-width: 0;
        padding-top: 5px;
        margin-top: 30px; }
        .management-container.objectives-bloc .create-event-objectives-layout .create-event-objectives-editor-row .create-event-objectives-lexical-panel .create-event-objectives-lexical-empty {
          border: 1px dashed #b8b8b8;
          border-radius: 8px;
          padding: 12px;
          margin-top: 3px;
          color: #dfdfdf;
          opacity: 0.85; }
  .management-container.objectives-bloc .create-event-objectives-lexical-panel--locked {
    pointer-events: none;
    opacity: 0.65; }
  .management-container.objectives-bloc .event-edit-objectives-layout {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 100%;
    margin: 10px 0;
    margin-left: 0;
    margin-right: 0;
    box-sizing: border-box; }
    .management-container.objectives-bloc .event-edit-objectives-layout .event-edit-objectives-editor-row {
      display: flex;
      gap: 10px;
      padding: 0 10px 10px;
      align-items: stretch; }
      .management-container.objectives-bloc .event-edit-objectives-layout .event-edit-objectives-editor-row .event-edit-objectives-list-panel {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 10px 0 0;
        gap: 10px;
        flex: 0 0 260px;
        padding-top: 10px; }
        .management-container.objectives-bloc .event-edit-objectives-layout .event-edit-objectives-editor-row .event-edit-objectives-list-panel .event-edit-objectives-middle-column {
          flex: 1 1 auto;
          min-width: 240px;
          max-width: 260px;
          padding: 0;
          display: flex;
          flex-direction: column;
          gap: 10px; }
          .management-container.objectives-bloc .event-edit-objectives-layout .event-edit-objectives-editor-row .event-edit-objectives-list-panel .event-edit-objectives-middle-column .event-edit-objectives-field {
            margin-bottom: 0;
            padding: 5px 10px;
            width: 92%;
            border: 1px solid rgba(58, 120, 180, 0.28);
            border-radius: 8px; }
          .management-container.objectives-bloc .event-edit-objectives-layout .event-edit-objectives-editor-row .event-edit-objectives-list-panel .event-edit-objectives-middle-column .event-edit-objectives-toggle {
            display: flex;
            width: 100%;
            height: auto;
            bottom: 0;
            transform: none; }
            .management-container.objectives-bloc .event-edit-objectives-layout .event-edit-objectives-editor-row .event-edit-objectives-list-panel .event-edit-objectives-middle-column .event-edit-objectives-toggle .toggle-label {
              flex: 1 1 auto;
              margin-right: 10px; }
            .management-container.objectives-bloc .event-edit-objectives-layout .event-edit-objectives-editor-row .event-edit-objectives-list-panel .event-edit-objectives-middle-column .event-edit-objectives-toggle .toggle-switch {
              position: relative;
              height: 13px;
              left: auto;
              right: auto;
              margin-left: auto; }
          .management-container.objectives-bloc .event-edit-objectives-layout .event-edit-objectives-editor-row .event-edit-objectives-list-panel .event-edit-objectives-middle-column .event-edit-objectives-toggle .toggle-label {
            color: #b8b8b8;
            display: block;
            text-transform: none;
            font-weight: normal;
            font-size: 15px;
            margin-left: 10px; }
          .management-container.objectives-bloc .event-edit-objectives-layout .event-edit-objectives-editor-row .event-edit-objectives-list-panel .event-edit-objectives-middle-column .event-edit-objectives-list-container {
            border: 1px solid rgba(58, 120, 180, 0.28);
            border-radius: 8px;
            padding: 8px;
            background-color: rgba(0, 0, 0, 0.15);
            width: 100%;
            box-sizing: border-box; }
            .management-container.objectives-bloc .event-edit-objectives-layout .event-edit-objectives-editor-row .event-edit-objectives-list-panel .event-edit-objectives-middle-column .event-edit-objectives-list-container.disabled {
              opacity: 0.6; }
              .management-container.objectives-bloc .event-edit-objectives-layout .event-edit-objectives-editor-row .event-edit-objectives-list-panel .event-edit-objectives-middle-column .event-edit-objectives-list-container.disabled .event-edit-objectives-scroll {
                height: auto; }
            .management-container.objectives-bloc .event-edit-objectives-layout .event-edit-objectives-editor-row .event-edit-objectives-list-panel .event-edit-objectives-middle-column .event-edit-objectives-list-container .event-edit-objectives-scroll {
              height: 233px;
              overflow-y: auto;
              padding-right: 6px;
              display: flex;
              flex-direction: column;
              gap: 10px; }
              .management-container.objectives-bloc .event-edit-objectives-layout .event-edit-objectives-editor-row .event-edit-objectives-list-panel .event-edit-objectives-middle-column .event-edit-objectives-list-container .event-edit-objectives-scroll::-webkit-scrollbar {
                width: 6px; }
              .management-container.objectives-bloc .event-edit-objectives-layout .event-edit-objectives-editor-row .event-edit-objectives-list-panel .event-edit-objectives-middle-column .event-edit-objectives-list-container .event-edit-objectives-scroll::-webkit-scrollbar-track {
                background: #2e3842;
                border-radius: 4px;
                padding-right: 1px; }
              .management-container.objectives-bloc .event-edit-objectives-layout .event-edit-objectives-editor-row .event-edit-objectives-list-panel .event-edit-objectives-middle-column .event-edit-objectives-list-container .event-edit-objectives-scroll::-webkit-scrollbar-thumb {
                background-color: #491212;
                border-radius: 4px; }
                .management-container.objectives-bloc .event-edit-objectives-layout .event-edit-objectives-editor-row .event-edit-objectives-list-panel .event-edit-objectives-middle-column .event-edit-objectives-list-container .event-edit-objectives-scroll::-webkit-scrollbar-thumb:hover {
                  background-color: #200808; }
            .management-container.objectives-bloc .event-edit-objectives-layout .event-edit-objectives-editor-row .event-edit-objectives-list-panel .event-edit-objectives-middle-column .event-edit-objectives-list-container .event-edit-objectives-row {
              display: grid;
              grid-template-columns: 28px 1fr auto;
              gap: 6px;
              padding: 5px 2px;
              align-items: center;
              position: relative;
              cursor: pointer; }
              .management-container.objectives-bloc .event-edit-objectives-layout .event-edit-objectives-editor-row .event-edit-objectives-list-panel .event-edit-objectives-middle-column .event-edit-objectives-list-container .event-edit-objectives-row.is-selected {
                border-radius: 6px;
                background-color: #133b53; }
            .management-container.objectives-bloc .event-edit-objectives-layout .event-edit-objectives-editor-row .event-edit-objectives-list-panel .event-edit-objectives-middle-column .event-edit-objectives-list-container .event-edit-objectives-order {
              font-size: 0.85em;
              color: #dfdfdf;
              opacity: 0.75;
              text-align: right;
              user-select: none;
              cursor: grab; }
              .management-container.objectives-bloc .event-edit-objectives-layout .event-edit-objectives-editor-row .event-edit-objectives-list-panel .event-edit-objectives-middle-column .event-edit-objectives-list-container .event-edit-objectives-order.is-disabled {
                opacity: 0.25;
                cursor: default; }
            .management-container.objectives-bloc .event-edit-objectives-layout .event-edit-objectives-editor-row .event-edit-objectives-list-panel .event-edit-objectives-middle-column .event-edit-objectives-list-container .event-edit-objectives-input {
              width: 100%;
              box-sizing: border-box; }
            .management-container.objectives-bloc .event-edit-objectives-layout .event-edit-objectives-editor-row .event-edit-objectives-list-panel .event-edit-objectives-middle-column .event-edit-objectives-list-container .toggle.critical {
              height: 11px;
              display: flex;
              align-items: center;
              top: 0px;
              gap: 6px; }
      .management-container.objectives-bloc .event-edit-objectives-layout .event-edit-objectives-editor-row .event-edit-objectives-lexical-panel {
        flex: 1 1 auto;
        min-width: 0;
        padding-top: 5px;
        margin-top: 43px; }
        .management-container.objectives-bloc .event-edit-objectives-layout .event-edit-objectives-editor-row .event-edit-objectives-lexical-panel .event-edit-objectives-lexical-empty {
          border: 1px dashed #b8b8b8;
          border-radius: 8px;
          padding: 12px;
          margin-top: 3px;
          color: #dfdfdf;
          opacity: 0.85; }
  .management-container.objectives-bloc .event-edit-objectives-lexical-panel--locked {
    pointer-events: none;
    opacity: 0.65; }

.tokenInput::-webkit-inner-spin-button,
.tokenInput::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0; }

/* Pour Firefox */
.tokenInput[type='number'] {
  width: -webkit-fill-available; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
@keyframes rotate-background {
  0% {
    background-position: 0% 50%; }
  100% {
    background-position: 100% 50%; } }

.rank-type-description {
  padding: 0px 20px 20px 20px;
  margin-bottom: 20px; }

.ranks-tab .ranks-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(275px, 1fr));
  row-gap: 10px;
  column-gap: 0px;
  width: 90%;
  margin: 0px auto 70px auto;
  padding-right: 60px; }
  .ranks-tab .ranks-container .rank-container {
    background-color: #bebebd;
    padding: 10px;
    height: 58px;
    width: 350px;
    box-shadow: rgba(57, 56, 49, 0.8) 1px 2px 2px 1px inset;
    clip-path: polygon(8% 0%, 92% 0%, 99% 50%, 92% 100%, 8% 100%, 1% 50%); }
    .ranks-tab .ranks-container .rank-container.O-10:hover, .ranks-tab .ranks-container .rank-container.O-9:hover, .ranks-tab .ranks-container .rank-container.O-8:hover, .ranks-tab .ranks-container .rank-container.O-7:hover, .ranks-tab .ranks-container .rank-container.O-6:hover, .ranks-tab .ranks-container .rank-container.O-5:hover {
      background-size: 200% 200% !important;
      animation: rotate-background 2s linear infinite !important; }
    .ranks-tab .ranks-container .rank-container .rank-content {
      display: flex;
      height: 65px;
      align-items: flex-start;
      justify-content: left;
      clip-path: polygon(6% 0%, 94% 0%, 100% 50%, 94% 100%, 6% 100%, 0% 50%);
      transform: translate(0px, -3px);
      box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.4), inset 0 -1px 3px rgba(255, 255, 255, 0.2); }
      .ranks-tab .ranks-container .rank-container .rank-content.O-10:hover, .ranks-tab .ranks-container .rank-container .rank-content.O-9:hover, .ranks-tab .ranks-container .rank-container .rank-content.O-8:hover, .ranks-tab .ranks-container .rank-container .rank-content.O-7:hover, .ranks-tab .ranks-container .rank-container .rank-content.O-6:hover, .ranks-tab .ranks-container .rank-container .rank-content.O-5:hover {
        animation: rotate-background 8s linear infinite !important;
        background-size: 101% 99% !important; }
      .ranks-tab .ranks-container .rank-container .rank-content .rank-image {
        margin-top: 7px;
        margin-left: 28px;
        width: auto;
        height: 50px;
        margin-right: 10px;
        filter: drop-shadow(2px 2px 1px #2e1e0e77); }
      .ranks-tab .ranks-container .rank-container .rank-content .rank-name {
        text-shadow: 1px 1px 1px #4e4d4b5d;
        color: #575151 !important;
        align-self: center;
        max-width: 56%;
        text-transform: uppercase;
        font-size: 0.85rem;
        font-weight: bold; }
      .ranks-tab .ranks-container .rank-container .rank-content.O-10, .ranks-tab .ranks-container .rank-container .rank-content.O-9, .ranks-tab .ranks-container .rank-container .rank-content.O-8, .ranks-tab .ranks-container .rank-container .rank-content.O-7, .ranks-tab .ranks-container .rank-container .rank-content.O-6, .ranks-tab .ranks-container .rank-container .rank-content.O-5 {
        background: linear-gradient(-72deg, #dedede, #ffffff 10%, #dedede 12%, #ffffff 16%, #dedede 20%, #ffffff 24%, #a1a1a1 27%, #dedede 36%, #c5c5c5 45%, #ffffff 60%, #dedede 72%, #ffffff 80%, #dedede 84%, #a1a1a1); }
      .ranks-tab .ranks-container .rank-container .rank-content.O-4, .ranks-tab .ranks-container .rank-container .rank-content.O-3, .ranks-tab .ranks-container .rank-container .rank-content.O-2, .ranks-tab .ranks-container .rank-container .rank-content.O-1, .ranks-tab .ranks-container .rank-container .rank-content.O-C {
        background: linear-gradient(-72deg, #bebebe, #d6d5d5 10%, #979797 12%, #d6d5d5 16%, #979797 20%, #d6d5d5 24%, #8b8b8b 27%, #979797 36%, #c5c5c5 45%, #d6d5d5 60%, #979797 72%, #c4c4c4 80%, #979797 84%, #a1a1a1); }
      .ranks-tab .ranks-container .rank-container .rank-content.W-1, .ranks-tab .ranks-container .rank-container .rank-content.W-2, .ranks-tab .ranks-container .rank-container .rank-content.W-3, .ranks-tab .ranks-container .rank-container .rank-content.W-4 {
        background: linear-gradient(-72deg, #dedede, #ffffff 10%, #dedede 12%, #ffffff 16%, #dedede 20%, #ffffff 24%, #a1a1a1 27%, #dedede 36%, #c5c5c5 45%, #ffffff 60%, #dedede 72%, #ffffff 80%, #dedede 84%, #a1a1a1); }
      .ranks-tab .ranks-container .rank-container .rank-content.E-10, .ranks-tab .ranks-container .rank-container .rank-content.E-9, .ranks-tab .ranks-container .rank-container .rank-content.E-8, .ranks-tab .ranks-container .rank-container .rank-content.E-7 {
        background: linear-gradient(-72deg, #dedede, #ffffff 10%, #dedede 12%, #ffffff 16%, #dedede 20%, #ffffff 24%, #a1a1a1 27%, #dedede 36%, #c5c5c5 45%, #ffffff 60%, #dedede 72%, #ffffff 80%, #dedede 84%, #a1a1a1); }
      .ranks-tab .ranks-container .rank-container .rank-content.E-6, .ranks-tab .ranks-container .rank-container .rank-content.E-5, .ranks-tab .ranks-container .rank-container .rank-content.E-4, .ranks-tab .ranks-container .rank-container .rank-content.E-3, .ranks-tab .ranks-container .rank-container .rank-content.E-2, .ranks-tab .ranks-container .rank-container .rank-content.E-1 {
        background: linear-gradient(-72deg, #bebebe, #d6d5d5 10%, #979797 12%, #d6d5d5 16%, #979797 20%, #d6d5d5 24%, #8b8b8b 27%, #979797 36%, #c5c5c5 45%, #d6d5d5 60%, #979797 72%, #c4c4c4 80%, #979797 84%, #a1a1a1); }
      .ranks-tab .ranks-container .rank-container .rank-content.A-6, .ranks-tab .ranks-container .rank-container .rank-content.A-5, .ranks-tab .ranks-container .rank-container .rank-content.A-4, .ranks-tab .ranks-container .rank-container .rank-content.A-3, .ranks-tab .ranks-container .rank-container .rank-content.A-2, .ranks-tab .ranks-container .rank-container .rank-content.A-1 {
        background: linear-gradient(-72deg, #bebebe, #d6d5d5 10%, #979797 12%, #d6d5d5 16%, #979797 20%, #d6d5d5 24%, #8b8b8b 27%, #979797 36%, #c5c5c5 45%, #d6d5d5 60%, #979797 72%, #c4c4c4 80%, #979797 84%, #a1a1a1); }

.rank-image-placeholder {
  width: 57px;
  /* Utilisez les mêmes dimensions que .rank-image */
  height: auto;
  /* Ou une hauteur fixe si nécessaire */
  background-color: transparent;
  /* Ou une couleur d'arrière-plan si vous préférez */
  margin-left: 28px;
  margin-right: 10px;
  filter: drop-shadow(2px 2px 1px #2e1e0e77); }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.selected-ribbon {
  display: flex;
  width: 350px;
  text-align: center;
  margin-left: 5px;
  margin-right: auto; }
  .selected-ribbon.calendar {
    width: 215px;
    margin-top: 15px;
    margin-left: 0px;
    margin-right: 0px; }

.admin-block-container.create-event-template {
  display: flex;
  flex-direction: column;
  width: initial;
  margin: 10px; }
  .admin-block-container.create-event-template .inputs-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 10px 0 0;
    gap: 10px; }
    .admin-block-container.create-event-template .inputs-container .left-column {
      display: flex;
      flex-direction: column;
      flex: 1 1 0;
      padding-left: 10px;
      gap: 10px; }
      .admin-block-container.create-event-template .inputs-container .left-column .input-field {
        margin-bottom: 0; }
    .admin-block-container.create-event-template .inputs-container .input-field.required-empty input,
    .admin-block-container.create-event-template .inputs-container .input-field.required-empty textarea,
    .admin-block-container.create-event-template .inputs-container .input-field.required-empty select {
      border: 1px solid #9e2222;
      box-sizing: border-box; }
    .admin-block-container.create-event-template .inputs-container .input-field.required-filled input,
    .admin-block-container.create-event-template .inputs-container .input-field.required-filled textarea,
    .admin-block-container.create-event-template .inputs-container .input-field.required-filled select {
      border: 1px solid transparent;
      box-sizing: border-box;
      width: 175px; }
    .admin-block-container.create-event-template .inputs-container .input-field.required-empty .react-select-input__control {
      border: 1px solid #9e2222 !important;
      box-sizing: border-box; }
    .admin-block-container.create-event-template .inputs-container .input-field.required-filled .react-select-input__control {
      border: 1px solid transparent !important;
      box-sizing: border-box; }
    .admin-block-container.create-event-template .inputs-container .right-column {
      flex: 1 1 0;
      padding-right: 10px; }
    .admin-block-container.create-event-template .inputs-container .middle-column {
      flex: 0 0 220px;
      padding: 0 10px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      min-width: 200px;
      max-width: 240px; }
      .admin-block-container.create-event-template .inputs-container .middle-column .toggle.objectives {
        padding-right: 25px;
        display: flex;
        width: 100%;
        height: auto;
        bottom: 0;
        transform: none; }
        .admin-block-container.create-event-template .inputs-container .middle-column .toggle.objectives .toggle-label {
          flex: 1 1 auto;
          margin-right: 10px; }
        .admin-block-container.create-event-template .inputs-container .middle-column .toggle.objectives .toggle-switch {
          position: relative;
          height: 13px;
          left: auto;
          right: auto;
          margin-left: auto; }
      .admin-block-container.create-event-template .inputs-container .middle-column .toggle.objectives .toggle-label {
        color: #b8b8b8;
        display: block;
        text-transform: none;
        font-weight: normal;
        font-size: 15px;
        margin-left: 10px; }
    .admin-block-container.create-event-template .inputs-container .objectives-container {
      border: 1px solid #b8b8b8;
      border-radius: 8px;
      padding: 8px;
      background-color: rgba(0, 0, 0, 0.15);
      width: 100%;
      box-sizing: border-box; }
      .admin-block-container.create-event-template .inputs-container .objectives-container.disabled {
        opacity: 0.6; }
      .admin-block-container.create-event-template .inputs-container .objectives-container .objectives-scroll {
        height: 257px;
        overflow-y: auto;
        padding-right: 6px;
        display: flex;
        flex-direction: column;
        gap: 10px; }
        .admin-block-container.create-event-template .inputs-container .objectives-container .objectives-scroll::-webkit-scrollbar {
          width: 6px; }
        .admin-block-container.create-event-template .inputs-container .objectives-container .objectives-scroll::-webkit-scrollbar-track {
          background: #2e3842;
          border-radius: 4px;
          padding-right: 1px; }
        .admin-block-container.create-event-template .inputs-container .objectives-container .objectives-scroll::-webkit-scrollbar-thumb {
          background-color: #491212;
          border-radius: 4px; }
          .admin-block-container.create-event-template .inputs-container .objectives-container .objectives-scroll::-webkit-scrollbar-thumb:hover {
            background-color: #200808; }
      .admin-block-container.create-event-template .inputs-container .objectives-container .objective-row {
        display: grid;
        grid-template-columns: 28px 1fr auto;
        gap: 6px;
        padding: 5px 2px;
        align-items: center;
        position: relative; }
      .admin-block-container.create-event-template .inputs-container .objectives-container .objective-order {
        font-size: 0.85em;
        color: #dfdfdf;
        opacity: 0.75;
        text-align: right;
        user-select: none;
        cursor: grab; }
        .admin-block-container.create-event-template .inputs-container .objectives-container .objective-order.is-disabled {
          opacity: 0.25;
          cursor: default; }
      .admin-block-container.create-event-template .inputs-container .objectives-container .objective-input {
        width: 100%;
        box-sizing: border-box; }
      .admin-block-container.create-event-template .inputs-container .objectives-container .toggle.critical {
        height: 11px;
        display: flex;
        align-items: center;
        top: 0px;
        gap: 6px; }
    .admin-block-container.create-event-template .inputs-container .input-field {
      width: 357px; }
      .admin-block-container.create-event-template .inputs-container .input-field.event-template {
        width: 326px; }
    .admin-block-container.create-event-template .inputs-container .middle-column .input-field {
      width: 100%; }
    .admin-block-container.create-event-template .inputs-container .left-column .input-field,
    .admin-block-container.create-event-template .inputs-container .right-column .input-field {
      width: 310px; }
    .admin-block-container.create-event-template .inputs-container .right-column .input-field {
      display: flex;
      flex-direction: column; }
    .admin-block-container.create-event-template .inputs-container .left-column > .input-field > .toggle.training {
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 11px; }
    .admin-block-container.create-event-template .inputs-container .left-column > .input-field > .toggle.training .toggle-label {
      color: #b8b8b8;
      display: block;
      text-transform: none;
      font-weight: normal;
      font-size: 15px;
      margin-left: 10px; }
    .admin-block-container.create-event-template .inputs-container .left-column > .input-field > .toggle.training .toggle-switch {
      margin-left: auto;
      top: 3px; }
  .admin-block-container.create-event-template.objectives-only .objectives-editor-row {
    display: flex;
    gap: 10px;
    padding: 0 10px 10px;
    align-items: stretch; }
  .admin-block-container.create-event-template.objectives-only .inputs-container.objectives-only.objectives-list-panel {
    justify-content: flex-start;
    flex: 0 0 260px;
    padding-top: 10px; }
  .admin-block-container.create-event-template.objectives-only .inputs-container.objectives-only.objectives-list-panel .middle-column {
    flex: 1 1 auto;
    min-width: 240px;
    max-width: 260px;
    padding: 0; }
  .admin-block-container.create-event-template.objectives-only .inputs-container.objectives-only.objectives-list-panel .objectives-container {
    width: 100%; }
  .admin-block-container.create-event-template.objectives-only .objectives-lexical-panel {
    flex: 1 1 auto;
    min-width: 0;
    padding-top: 5px; }
  .admin-block-container.create-event-template.objectives-only .objective-row {
    cursor: pointer; }
    .admin-block-container.create-event-template.objectives-only .objective-row.is-selected {
      border-radius: 6px;
      background-color: #133b53; }
  .admin-block-container.create-event-template.objectives-only .objectives-lexical-empty {
    border: 1px dashed #b8b8b8;
    border-radius: 8px;
    padding: 12px;
    color: #dfdfdf;
    opacity: 0.85; }
  .admin-block-container.create-event-template .discord {
    display: flex;
    width: 100%; }
    .admin-block-container.create-event-template .discord .discord-banner {
      position: relative;
      margin: 0px 0px 30px 0px;
      width: 500px;
      min-width: 500px;
      height: 200px; }
      .admin-block-container.create-event-template .discord .discord-banner:before {
        content: "";
        display: block; }
      .admin-block-container.create-event-template .discord .discord-banner .dropzone {
        position: relative;
        width: auto;
        height: 100%;
        border: 2px dashed #b8b8b8;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: grab;
        background-color: #2a3847; }
        .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          object-fit: cover;
          transform-origin: top left;
          cursor: grab;
          user-select: none;
          transform: translateX(var(--translate-x, 0px)) translateY(var(--translate-y, 0px)) scale(var(--scale, 1)); }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1500 {
            --translate-x: -1500px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1499 {
            --translate-x: -1499px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1498 {
            --translate-x: -1498px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1497 {
            --translate-x: -1497px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1496 {
            --translate-x: -1496px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1495 {
            --translate-x: -1495px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1494 {
            --translate-x: -1494px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1493 {
            --translate-x: -1493px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1492 {
            --translate-x: -1492px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1491 {
            --translate-x: -1491px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1490 {
            --translate-x: -1490px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1489 {
            --translate-x: -1489px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1488 {
            --translate-x: -1488px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1487 {
            --translate-x: -1487px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1486 {
            --translate-x: -1486px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1485 {
            --translate-x: -1485px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1484 {
            --translate-x: -1484px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1483 {
            --translate-x: -1483px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1482 {
            --translate-x: -1482px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1481 {
            --translate-x: -1481px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1480 {
            --translate-x: -1480px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1479 {
            --translate-x: -1479px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1478 {
            --translate-x: -1478px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1477 {
            --translate-x: -1477px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1476 {
            --translate-x: -1476px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1475 {
            --translate-x: -1475px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1474 {
            --translate-x: -1474px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1473 {
            --translate-x: -1473px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1472 {
            --translate-x: -1472px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1471 {
            --translate-x: -1471px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1470 {
            --translate-x: -1470px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1469 {
            --translate-x: -1469px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1468 {
            --translate-x: -1468px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1467 {
            --translate-x: -1467px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1466 {
            --translate-x: -1466px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1465 {
            --translate-x: -1465px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1464 {
            --translate-x: -1464px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1463 {
            --translate-x: -1463px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1462 {
            --translate-x: -1462px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1461 {
            --translate-x: -1461px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1460 {
            --translate-x: -1460px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1459 {
            --translate-x: -1459px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1458 {
            --translate-x: -1458px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1457 {
            --translate-x: -1457px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1456 {
            --translate-x: -1456px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1455 {
            --translate-x: -1455px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1454 {
            --translate-x: -1454px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1453 {
            --translate-x: -1453px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1452 {
            --translate-x: -1452px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1451 {
            --translate-x: -1451px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1450 {
            --translate-x: -1450px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1449 {
            --translate-x: -1449px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1448 {
            --translate-x: -1448px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1447 {
            --translate-x: -1447px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1446 {
            --translate-x: -1446px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1445 {
            --translate-x: -1445px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1444 {
            --translate-x: -1444px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1443 {
            --translate-x: -1443px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1442 {
            --translate-x: -1442px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1441 {
            --translate-x: -1441px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1440 {
            --translate-x: -1440px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1439 {
            --translate-x: -1439px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1438 {
            --translate-x: -1438px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1437 {
            --translate-x: -1437px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1436 {
            --translate-x: -1436px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1435 {
            --translate-x: -1435px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1434 {
            --translate-x: -1434px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1433 {
            --translate-x: -1433px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1432 {
            --translate-x: -1432px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1431 {
            --translate-x: -1431px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1430 {
            --translate-x: -1430px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1429 {
            --translate-x: -1429px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1428 {
            --translate-x: -1428px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1427 {
            --translate-x: -1427px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1426 {
            --translate-x: -1426px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1425 {
            --translate-x: -1425px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1424 {
            --translate-x: -1424px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1423 {
            --translate-x: -1423px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1422 {
            --translate-x: -1422px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1421 {
            --translate-x: -1421px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1420 {
            --translate-x: -1420px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1419 {
            --translate-x: -1419px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1418 {
            --translate-x: -1418px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1417 {
            --translate-x: -1417px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1416 {
            --translate-x: -1416px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1415 {
            --translate-x: -1415px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1414 {
            --translate-x: -1414px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1413 {
            --translate-x: -1413px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1412 {
            --translate-x: -1412px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1411 {
            --translate-x: -1411px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1410 {
            --translate-x: -1410px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1409 {
            --translate-x: -1409px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1408 {
            --translate-x: -1408px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1407 {
            --translate-x: -1407px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1406 {
            --translate-x: -1406px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1405 {
            --translate-x: -1405px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1404 {
            --translate-x: -1404px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1403 {
            --translate-x: -1403px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1402 {
            --translate-x: -1402px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1401 {
            --translate-x: -1401px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1400 {
            --translate-x: -1400px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1399 {
            --translate-x: -1399px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1398 {
            --translate-x: -1398px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1397 {
            --translate-x: -1397px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1396 {
            --translate-x: -1396px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1395 {
            --translate-x: -1395px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1394 {
            --translate-x: -1394px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1393 {
            --translate-x: -1393px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1392 {
            --translate-x: -1392px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1391 {
            --translate-x: -1391px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1390 {
            --translate-x: -1390px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1389 {
            --translate-x: -1389px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1388 {
            --translate-x: -1388px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1387 {
            --translate-x: -1387px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1386 {
            --translate-x: -1386px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1385 {
            --translate-x: -1385px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1384 {
            --translate-x: -1384px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1383 {
            --translate-x: -1383px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1382 {
            --translate-x: -1382px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1381 {
            --translate-x: -1381px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1380 {
            --translate-x: -1380px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1379 {
            --translate-x: -1379px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1378 {
            --translate-x: -1378px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1377 {
            --translate-x: -1377px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1376 {
            --translate-x: -1376px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1375 {
            --translate-x: -1375px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1374 {
            --translate-x: -1374px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1373 {
            --translate-x: -1373px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1372 {
            --translate-x: -1372px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1371 {
            --translate-x: -1371px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1370 {
            --translate-x: -1370px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1369 {
            --translate-x: -1369px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1368 {
            --translate-x: -1368px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1367 {
            --translate-x: -1367px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1366 {
            --translate-x: -1366px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1365 {
            --translate-x: -1365px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1364 {
            --translate-x: -1364px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1363 {
            --translate-x: -1363px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1362 {
            --translate-x: -1362px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1361 {
            --translate-x: -1361px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1360 {
            --translate-x: -1360px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1359 {
            --translate-x: -1359px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1358 {
            --translate-x: -1358px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1357 {
            --translate-x: -1357px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1356 {
            --translate-x: -1356px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1355 {
            --translate-x: -1355px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1354 {
            --translate-x: -1354px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1353 {
            --translate-x: -1353px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1352 {
            --translate-x: -1352px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1351 {
            --translate-x: -1351px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1350 {
            --translate-x: -1350px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1349 {
            --translate-x: -1349px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1348 {
            --translate-x: -1348px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1347 {
            --translate-x: -1347px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1346 {
            --translate-x: -1346px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1345 {
            --translate-x: -1345px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1344 {
            --translate-x: -1344px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1343 {
            --translate-x: -1343px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1342 {
            --translate-x: -1342px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1341 {
            --translate-x: -1341px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1340 {
            --translate-x: -1340px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1339 {
            --translate-x: -1339px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1338 {
            --translate-x: -1338px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1337 {
            --translate-x: -1337px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1336 {
            --translate-x: -1336px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1335 {
            --translate-x: -1335px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1334 {
            --translate-x: -1334px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1333 {
            --translate-x: -1333px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1332 {
            --translate-x: -1332px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1331 {
            --translate-x: -1331px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1330 {
            --translate-x: -1330px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1329 {
            --translate-x: -1329px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1328 {
            --translate-x: -1328px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1327 {
            --translate-x: -1327px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1326 {
            --translate-x: -1326px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1325 {
            --translate-x: -1325px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1324 {
            --translate-x: -1324px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1323 {
            --translate-x: -1323px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1322 {
            --translate-x: -1322px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1321 {
            --translate-x: -1321px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1320 {
            --translate-x: -1320px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1319 {
            --translate-x: -1319px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1318 {
            --translate-x: -1318px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1317 {
            --translate-x: -1317px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1316 {
            --translate-x: -1316px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1315 {
            --translate-x: -1315px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1314 {
            --translate-x: -1314px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1313 {
            --translate-x: -1313px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1312 {
            --translate-x: -1312px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1311 {
            --translate-x: -1311px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1310 {
            --translate-x: -1310px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1309 {
            --translate-x: -1309px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1308 {
            --translate-x: -1308px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1307 {
            --translate-x: -1307px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1306 {
            --translate-x: -1306px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1305 {
            --translate-x: -1305px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1304 {
            --translate-x: -1304px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1303 {
            --translate-x: -1303px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1302 {
            --translate-x: -1302px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1301 {
            --translate-x: -1301px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1300 {
            --translate-x: -1300px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1299 {
            --translate-x: -1299px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1298 {
            --translate-x: -1298px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1297 {
            --translate-x: -1297px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1296 {
            --translate-x: -1296px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1295 {
            --translate-x: -1295px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1294 {
            --translate-x: -1294px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1293 {
            --translate-x: -1293px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1292 {
            --translate-x: -1292px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1291 {
            --translate-x: -1291px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1290 {
            --translate-x: -1290px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1289 {
            --translate-x: -1289px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1288 {
            --translate-x: -1288px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1287 {
            --translate-x: -1287px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1286 {
            --translate-x: -1286px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1285 {
            --translate-x: -1285px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1284 {
            --translate-x: -1284px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1283 {
            --translate-x: -1283px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1282 {
            --translate-x: -1282px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1281 {
            --translate-x: -1281px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1280 {
            --translate-x: -1280px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1279 {
            --translate-x: -1279px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1278 {
            --translate-x: -1278px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1277 {
            --translate-x: -1277px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1276 {
            --translate-x: -1276px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1275 {
            --translate-x: -1275px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1274 {
            --translate-x: -1274px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1273 {
            --translate-x: -1273px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1272 {
            --translate-x: -1272px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1271 {
            --translate-x: -1271px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1270 {
            --translate-x: -1270px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1269 {
            --translate-x: -1269px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1268 {
            --translate-x: -1268px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1267 {
            --translate-x: -1267px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1266 {
            --translate-x: -1266px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1265 {
            --translate-x: -1265px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1264 {
            --translate-x: -1264px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1263 {
            --translate-x: -1263px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1262 {
            --translate-x: -1262px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1261 {
            --translate-x: -1261px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1260 {
            --translate-x: -1260px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1259 {
            --translate-x: -1259px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1258 {
            --translate-x: -1258px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1257 {
            --translate-x: -1257px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1256 {
            --translate-x: -1256px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1255 {
            --translate-x: -1255px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1254 {
            --translate-x: -1254px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1253 {
            --translate-x: -1253px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1252 {
            --translate-x: -1252px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1251 {
            --translate-x: -1251px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1250 {
            --translate-x: -1250px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1249 {
            --translate-x: -1249px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1248 {
            --translate-x: -1248px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1247 {
            --translate-x: -1247px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1246 {
            --translate-x: -1246px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1245 {
            --translate-x: -1245px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1244 {
            --translate-x: -1244px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1243 {
            --translate-x: -1243px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1242 {
            --translate-x: -1242px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1241 {
            --translate-x: -1241px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1240 {
            --translate-x: -1240px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1239 {
            --translate-x: -1239px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1238 {
            --translate-x: -1238px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1237 {
            --translate-x: -1237px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1236 {
            --translate-x: -1236px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1235 {
            --translate-x: -1235px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1234 {
            --translate-x: -1234px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1233 {
            --translate-x: -1233px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1232 {
            --translate-x: -1232px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1231 {
            --translate-x: -1231px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1230 {
            --translate-x: -1230px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1229 {
            --translate-x: -1229px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1228 {
            --translate-x: -1228px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1227 {
            --translate-x: -1227px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1226 {
            --translate-x: -1226px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1225 {
            --translate-x: -1225px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1224 {
            --translate-x: -1224px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1223 {
            --translate-x: -1223px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1222 {
            --translate-x: -1222px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1221 {
            --translate-x: -1221px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1220 {
            --translate-x: -1220px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1219 {
            --translate-x: -1219px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1218 {
            --translate-x: -1218px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1217 {
            --translate-x: -1217px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1216 {
            --translate-x: -1216px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1215 {
            --translate-x: -1215px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1214 {
            --translate-x: -1214px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1213 {
            --translate-x: -1213px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1212 {
            --translate-x: -1212px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1211 {
            --translate-x: -1211px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1210 {
            --translate-x: -1210px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1209 {
            --translate-x: -1209px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1208 {
            --translate-x: -1208px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1207 {
            --translate-x: -1207px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1206 {
            --translate-x: -1206px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1205 {
            --translate-x: -1205px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1204 {
            --translate-x: -1204px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1203 {
            --translate-x: -1203px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1202 {
            --translate-x: -1202px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1201 {
            --translate-x: -1201px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1200 {
            --translate-x: -1200px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1199 {
            --translate-x: -1199px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1198 {
            --translate-x: -1198px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1197 {
            --translate-x: -1197px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1196 {
            --translate-x: -1196px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1195 {
            --translate-x: -1195px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1194 {
            --translate-x: -1194px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1193 {
            --translate-x: -1193px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1192 {
            --translate-x: -1192px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1191 {
            --translate-x: -1191px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1190 {
            --translate-x: -1190px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1189 {
            --translate-x: -1189px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1188 {
            --translate-x: -1188px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1187 {
            --translate-x: -1187px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1186 {
            --translate-x: -1186px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1185 {
            --translate-x: -1185px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1184 {
            --translate-x: -1184px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1183 {
            --translate-x: -1183px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1182 {
            --translate-x: -1182px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1181 {
            --translate-x: -1181px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1180 {
            --translate-x: -1180px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1179 {
            --translate-x: -1179px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1178 {
            --translate-x: -1178px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1177 {
            --translate-x: -1177px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1176 {
            --translate-x: -1176px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1175 {
            --translate-x: -1175px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1174 {
            --translate-x: -1174px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1173 {
            --translate-x: -1173px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1172 {
            --translate-x: -1172px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1171 {
            --translate-x: -1171px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1170 {
            --translate-x: -1170px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1169 {
            --translate-x: -1169px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1168 {
            --translate-x: -1168px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1167 {
            --translate-x: -1167px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1166 {
            --translate-x: -1166px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1165 {
            --translate-x: -1165px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1164 {
            --translate-x: -1164px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1163 {
            --translate-x: -1163px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1162 {
            --translate-x: -1162px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1161 {
            --translate-x: -1161px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1160 {
            --translate-x: -1160px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1159 {
            --translate-x: -1159px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1158 {
            --translate-x: -1158px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1157 {
            --translate-x: -1157px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1156 {
            --translate-x: -1156px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1155 {
            --translate-x: -1155px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1154 {
            --translate-x: -1154px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1153 {
            --translate-x: -1153px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1152 {
            --translate-x: -1152px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1151 {
            --translate-x: -1151px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1150 {
            --translate-x: -1150px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1149 {
            --translate-x: -1149px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1148 {
            --translate-x: -1148px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1147 {
            --translate-x: -1147px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1146 {
            --translate-x: -1146px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1145 {
            --translate-x: -1145px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1144 {
            --translate-x: -1144px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1143 {
            --translate-x: -1143px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1142 {
            --translate-x: -1142px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1141 {
            --translate-x: -1141px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1140 {
            --translate-x: -1140px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1139 {
            --translate-x: -1139px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1138 {
            --translate-x: -1138px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1137 {
            --translate-x: -1137px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1136 {
            --translate-x: -1136px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1135 {
            --translate-x: -1135px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1134 {
            --translate-x: -1134px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1133 {
            --translate-x: -1133px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1132 {
            --translate-x: -1132px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1131 {
            --translate-x: -1131px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1130 {
            --translate-x: -1130px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1129 {
            --translate-x: -1129px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1128 {
            --translate-x: -1128px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1127 {
            --translate-x: -1127px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1126 {
            --translate-x: -1126px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1125 {
            --translate-x: -1125px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1124 {
            --translate-x: -1124px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1123 {
            --translate-x: -1123px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1122 {
            --translate-x: -1122px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1121 {
            --translate-x: -1121px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1120 {
            --translate-x: -1120px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1119 {
            --translate-x: -1119px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1118 {
            --translate-x: -1118px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1117 {
            --translate-x: -1117px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1116 {
            --translate-x: -1116px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1115 {
            --translate-x: -1115px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1114 {
            --translate-x: -1114px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1113 {
            --translate-x: -1113px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1112 {
            --translate-x: -1112px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1111 {
            --translate-x: -1111px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1110 {
            --translate-x: -1110px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1109 {
            --translate-x: -1109px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1108 {
            --translate-x: -1108px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1107 {
            --translate-x: -1107px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1106 {
            --translate-x: -1106px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1105 {
            --translate-x: -1105px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1104 {
            --translate-x: -1104px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1103 {
            --translate-x: -1103px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1102 {
            --translate-x: -1102px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1101 {
            --translate-x: -1101px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1100 {
            --translate-x: -1100px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1099 {
            --translate-x: -1099px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1098 {
            --translate-x: -1098px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1097 {
            --translate-x: -1097px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1096 {
            --translate-x: -1096px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1095 {
            --translate-x: -1095px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1094 {
            --translate-x: -1094px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1093 {
            --translate-x: -1093px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1092 {
            --translate-x: -1092px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1091 {
            --translate-x: -1091px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1090 {
            --translate-x: -1090px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1089 {
            --translate-x: -1089px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1088 {
            --translate-x: -1088px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1087 {
            --translate-x: -1087px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1086 {
            --translate-x: -1086px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1085 {
            --translate-x: -1085px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1084 {
            --translate-x: -1084px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1083 {
            --translate-x: -1083px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1082 {
            --translate-x: -1082px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1081 {
            --translate-x: -1081px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1080 {
            --translate-x: -1080px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1079 {
            --translate-x: -1079px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1078 {
            --translate-x: -1078px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1077 {
            --translate-x: -1077px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1076 {
            --translate-x: -1076px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1075 {
            --translate-x: -1075px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1074 {
            --translate-x: -1074px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1073 {
            --translate-x: -1073px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1072 {
            --translate-x: -1072px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1071 {
            --translate-x: -1071px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1070 {
            --translate-x: -1070px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1069 {
            --translate-x: -1069px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1068 {
            --translate-x: -1068px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1067 {
            --translate-x: -1067px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1066 {
            --translate-x: -1066px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1065 {
            --translate-x: -1065px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1064 {
            --translate-x: -1064px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1063 {
            --translate-x: -1063px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1062 {
            --translate-x: -1062px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1061 {
            --translate-x: -1061px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1060 {
            --translate-x: -1060px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1059 {
            --translate-x: -1059px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1058 {
            --translate-x: -1058px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1057 {
            --translate-x: -1057px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1056 {
            --translate-x: -1056px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1055 {
            --translate-x: -1055px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1054 {
            --translate-x: -1054px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1053 {
            --translate-x: -1053px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1052 {
            --translate-x: -1052px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1051 {
            --translate-x: -1051px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1050 {
            --translate-x: -1050px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1049 {
            --translate-x: -1049px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1048 {
            --translate-x: -1048px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1047 {
            --translate-x: -1047px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1046 {
            --translate-x: -1046px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1045 {
            --translate-x: -1045px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1044 {
            --translate-x: -1044px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1043 {
            --translate-x: -1043px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1042 {
            --translate-x: -1042px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1041 {
            --translate-x: -1041px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1040 {
            --translate-x: -1040px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1039 {
            --translate-x: -1039px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1038 {
            --translate-x: -1038px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1037 {
            --translate-x: -1037px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1036 {
            --translate-x: -1036px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1035 {
            --translate-x: -1035px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1034 {
            --translate-x: -1034px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1033 {
            --translate-x: -1033px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1032 {
            --translate-x: -1032px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1031 {
            --translate-x: -1031px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1030 {
            --translate-x: -1030px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1029 {
            --translate-x: -1029px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1028 {
            --translate-x: -1028px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1027 {
            --translate-x: -1027px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1026 {
            --translate-x: -1026px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1025 {
            --translate-x: -1025px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1024 {
            --translate-x: -1024px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1023 {
            --translate-x: -1023px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1022 {
            --translate-x: -1022px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1021 {
            --translate-x: -1021px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1020 {
            --translate-x: -1020px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1019 {
            --translate-x: -1019px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1018 {
            --translate-x: -1018px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1017 {
            --translate-x: -1017px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1016 {
            --translate-x: -1016px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1015 {
            --translate-x: -1015px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1014 {
            --translate-x: -1014px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1013 {
            --translate-x: -1013px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1012 {
            --translate-x: -1012px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1011 {
            --translate-x: -1011px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1010 {
            --translate-x: -1010px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1009 {
            --translate-x: -1009px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1008 {
            --translate-x: -1008px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1007 {
            --translate-x: -1007px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1006 {
            --translate-x: -1006px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1005 {
            --translate-x: -1005px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1004 {
            --translate-x: -1004px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1003 {
            --translate-x: -1003px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1002 {
            --translate-x: -1002px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1001 {
            --translate-x: -1001px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1000 {
            --translate-x: -1000px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--999 {
            --translate-x: -999px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--998 {
            --translate-x: -998px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--997 {
            --translate-x: -997px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--996 {
            --translate-x: -996px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--995 {
            --translate-x: -995px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--994 {
            --translate-x: -994px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--993 {
            --translate-x: -993px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--992 {
            --translate-x: -992px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--991 {
            --translate-x: -991px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--990 {
            --translate-x: -990px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--989 {
            --translate-x: -989px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--988 {
            --translate-x: -988px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--987 {
            --translate-x: -987px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--986 {
            --translate-x: -986px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--985 {
            --translate-x: -985px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--984 {
            --translate-x: -984px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--983 {
            --translate-x: -983px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--982 {
            --translate-x: -982px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--981 {
            --translate-x: -981px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--980 {
            --translate-x: -980px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--979 {
            --translate-x: -979px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--978 {
            --translate-x: -978px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--977 {
            --translate-x: -977px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--976 {
            --translate-x: -976px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--975 {
            --translate-x: -975px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--974 {
            --translate-x: -974px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--973 {
            --translate-x: -973px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--972 {
            --translate-x: -972px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--971 {
            --translate-x: -971px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--970 {
            --translate-x: -970px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--969 {
            --translate-x: -969px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--968 {
            --translate-x: -968px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--967 {
            --translate-x: -967px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--966 {
            --translate-x: -966px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--965 {
            --translate-x: -965px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--964 {
            --translate-x: -964px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--963 {
            --translate-x: -963px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--962 {
            --translate-x: -962px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--961 {
            --translate-x: -961px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--960 {
            --translate-x: -960px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--959 {
            --translate-x: -959px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--958 {
            --translate-x: -958px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--957 {
            --translate-x: -957px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--956 {
            --translate-x: -956px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--955 {
            --translate-x: -955px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--954 {
            --translate-x: -954px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--953 {
            --translate-x: -953px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--952 {
            --translate-x: -952px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--951 {
            --translate-x: -951px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--950 {
            --translate-x: -950px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--949 {
            --translate-x: -949px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--948 {
            --translate-x: -948px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--947 {
            --translate-x: -947px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--946 {
            --translate-x: -946px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--945 {
            --translate-x: -945px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--944 {
            --translate-x: -944px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--943 {
            --translate-x: -943px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--942 {
            --translate-x: -942px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--941 {
            --translate-x: -941px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--940 {
            --translate-x: -940px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--939 {
            --translate-x: -939px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--938 {
            --translate-x: -938px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--937 {
            --translate-x: -937px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--936 {
            --translate-x: -936px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--935 {
            --translate-x: -935px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--934 {
            --translate-x: -934px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--933 {
            --translate-x: -933px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--932 {
            --translate-x: -932px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--931 {
            --translate-x: -931px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--930 {
            --translate-x: -930px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--929 {
            --translate-x: -929px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--928 {
            --translate-x: -928px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--927 {
            --translate-x: -927px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--926 {
            --translate-x: -926px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--925 {
            --translate-x: -925px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--924 {
            --translate-x: -924px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--923 {
            --translate-x: -923px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--922 {
            --translate-x: -922px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--921 {
            --translate-x: -921px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--920 {
            --translate-x: -920px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--919 {
            --translate-x: -919px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--918 {
            --translate-x: -918px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--917 {
            --translate-x: -917px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--916 {
            --translate-x: -916px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--915 {
            --translate-x: -915px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--914 {
            --translate-x: -914px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--913 {
            --translate-x: -913px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--912 {
            --translate-x: -912px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--911 {
            --translate-x: -911px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--910 {
            --translate-x: -910px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--909 {
            --translate-x: -909px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--908 {
            --translate-x: -908px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--907 {
            --translate-x: -907px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--906 {
            --translate-x: -906px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--905 {
            --translate-x: -905px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--904 {
            --translate-x: -904px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--903 {
            --translate-x: -903px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--902 {
            --translate-x: -902px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--901 {
            --translate-x: -901px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--900 {
            --translate-x: -900px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--899 {
            --translate-x: -899px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--898 {
            --translate-x: -898px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--897 {
            --translate-x: -897px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--896 {
            --translate-x: -896px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--895 {
            --translate-x: -895px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--894 {
            --translate-x: -894px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--893 {
            --translate-x: -893px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--892 {
            --translate-x: -892px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--891 {
            --translate-x: -891px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--890 {
            --translate-x: -890px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--889 {
            --translate-x: -889px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--888 {
            --translate-x: -888px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--887 {
            --translate-x: -887px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--886 {
            --translate-x: -886px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--885 {
            --translate-x: -885px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--884 {
            --translate-x: -884px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--883 {
            --translate-x: -883px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--882 {
            --translate-x: -882px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--881 {
            --translate-x: -881px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--880 {
            --translate-x: -880px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--879 {
            --translate-x: -879px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--878 {
            --translate-x: -878px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--877 {
            --translate-x: -877px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--876 {
            --translate-x: -876px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--875 {
            --translate-x: -875px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--874 {
            --translate-x: -874px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--873 {
            --translate-x: -873px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--872 {
            --translate-x: -872px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--871 {
            --translate-x: -871px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--870 {
            --translate-x: -870px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--869 {
            --translate-x: -869px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--868 {
            --translate-x: -868px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--867 {
            --translate-x: -867px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--866 {
            --translate-x: -866px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--865 {
            --translate-x: -865px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--864 {
            --translate-x: -864px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--863 {
            --translate-x: -863px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--862 {
            --translate-x: -862px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--861 {
            --translate-x: -861px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--860 {
            --translate-x: -860px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--859 {
            --translate-x: -859px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--858 {
            --translate-x: -858px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--857 {
            --translate-x: -857px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--856 {
            --translate-x: -856px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--855 {
            --translate-x: -855px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--854 {
            --translate-x: -854px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--853 {
            --translate-x: -853px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--852 {
            --translate-x: -852px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--851 {
            --translate-x: -851px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--850 {
            --translate-x: -850px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--849 {
            --translate-x: -849px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--848 {
            --translate-x: -848px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--847 {
            --translate-x: -847px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--846 {
            --translate-x: -846px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--845 {
            --translate-x: -845px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--844 {
            --translate-x: -844px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--843 {
            --translate-x: -843px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--842 {
            --translate-x: -842px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--841 {
            --translate-x: -841px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--840 {
            --translate-x: -840px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--839 {
            --translate-x: -839px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--838 {
            --translate-x: -838px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--837 {
            --translate-x: -837px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--836 {
            --translate-x: -836px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--835 {
            --translate-x: -835px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--834 {
            --translate-x: -834px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--833 {
            --translate-x: -833px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--832 {
            --translate-x: -832px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--831 {
            --translate-x: -831px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--830 {
            --translate-x: -830px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--829 {
            --translate-x: -829px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--828 {
            --translate-x: -828px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--827 {
            --translate-x: -827px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--826 {
            --translate-x: -826px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--825 {
            --translate-x: -825px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--824 {
            --translate-x: -824px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--823 {
            --translate-x: -823px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--822 {
            --translate-x: -822px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--821 {
            --translate-x: -821px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--820 {
            --translate-x: -820px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--819 {
            --translate-x: -819px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--818 {
            --translate-x: -818px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--817 {
            --translate-x: -817px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--816 {
            --translate-x: -816px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--815 {
            --translate-x: -815px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--814 {
            --translate-x: -814px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--813 {
            --translate-x: -813px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--812 {
            --translate-x: -812px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--811 {
            --translate-x: -811px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--810 {
            --translate-x: -810px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--809 {
            --translate-x: -809px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--808 {
            --translate-x: -808px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--807 {
            --translate-x: -807px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--806 {
            --translate-x: -806px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--805 {
            --translate-x: -805px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--804 {
            --translate-x: -804px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--803 {
            --translate-x: -803px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--802 {
            --translate-x: -802px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--801 {
            --translate-x: -801px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--800 {
            --translate-x: -800px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--799 {
            --translate-x: -799px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--798 {
            --translate-x: -798px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--797 {
            --translate-x: -797px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--796 {
            --translate-x: -796px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--795 {
            --translate-x: -795px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--794 {
            --translate-x: -794px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--793 {
            --translate-x: -793px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--792 {
            --translate-x: -792px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--791 {
            --translate-x: -791px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--790 {
            --translate-x: -790px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--789 {
            --translate-x: -789px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--788 {
            --translate-x: -788px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--787 {
            --translate-x: -787px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--786 {
            --translate-x: -786px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--785 {
            --translate-x: -785px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--784 {
            --translate-x: -784px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--783 {
            --translate-x: -783px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--782 {
            --translate-x: -782px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--781 {
            --translate-x: -781px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--780 {
            --translate-x: -780px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--779 {
            --translate-x: -779px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--778 {
            --translate-x: -778px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--777 {
            --translate-x: -777px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--776 {
            --translate-x: -776px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--775 {
            --translate-x: -775px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--774 {
            --translate-x: -774px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--773 {
            --translate-x: -773px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--772 {
            --translate-x: -772px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--771 {
            --translate-x: -771px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--770 {
            --translate-x: -770px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--769 {
            --translate-x: -769px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--768 {
            --translate-x: -768px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--767 {
            --translate-x: -767px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--766 {
            --translate-x: -766px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--765 {
            --translate-x: -765px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--764 {
            --translate-x: -764px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--763 {
            --translate-x: -763px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--762 {
            --translate-x: -762px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--761 {
            --translate-x: -761px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--760 {
            --translate-x: -760px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--759 {
            --translate-x: -759px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--758 {
            --translate-x: -758px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--757 {
            --translate-x: -757px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--756 {
            --translate-x: -756px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--755 {
            --translate-x: -755px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--754 {
            --translate-x: -754px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--753 {
            --translate-x: -753px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--752 {
            --translate-x: -752px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--751 {
            --translate-x: -751px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--750 {
            --translate-x: -750px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--749 {
            --translate-x: -749px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--748 {
            --translate-x: -748px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--747 {
            --translate-x: -747px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--746 {
            --translate-x: -746px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--745 {
            --translate-x: -745px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--744 {
            --translate-x: -744px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--743 {
            --translate-x: -743px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--742 {
            --translate-x: -742px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--741 {
            --translate-x: -741px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--740 {
            --translate-x: -740px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--739 {
            --translate-x: -739px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--738 {
            --translate-x: -738px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--737 {
            --translate-x: -737px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--736 {
            --translate-x: -736px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--735 {
            --translate-x: -735px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--734 {
            --translate-x: -734px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--733 {
            --translate-x: -733px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--732 {
            --translate-x: -732px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--731 {
            --translate-x: -731px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--730 {
            --translate-x: -730px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--729 {
            --translate-x: -729px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--728 {
            --translate-x: -728px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--727 {
            --translate-x: -727px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--726 {
            --translate-x: -726px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--725 {
            --translate-x: -725px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--724 {
            --translate-x: -724px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--723 {
            --translate-x: -723px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--722 {
            --translate-x: -722px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--721 {
            --translate-x: -721px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--720 {
            --translate-x: -720px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--719 {
            --translate-x: -719px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--718 {
            --translate-x: -718px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--717 {
            --translate-x: -717px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--716 {
            --translate-x: -716px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--715 {
            --translate-x: -715px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--714 {
            --translate-x: -714px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--713 {
            --translate-x: -713px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--712 {
            --translate-x: -712px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--711 {
            --translate-x: -711px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--710 {
            --translate-x: -710px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--709 {
            --translate-x: -709px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--708 {
            --translate-x: -708px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--707 {
            --translate-x: -707px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--706 {
            --translate-x: -706px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--705 {
            --translate-x: -705px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--704 {
            --translate-x: -704px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--703 {
            --translate-x: -703px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--702 {
            --translate-x: -702px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--701 {
            --translate-x: -701px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--700 {
            --translate-x: -700px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--699 {
            --translate-x: -699px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--698 {
            --translate-x: -698px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--697 {
            --translate-x: -697px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--696 {
            --translate-x: -696px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--695 {
            --translate-x: -695px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--694 {
            --translate-x: -694px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--693 {
            --translate-x: -693px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--692 {
            --translate-x: -692px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--691 {
            --translate-x: -691px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--690 {
            --translate-x: -690px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--689 {
            --translate-x: -689px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--688 {
            --translate-x: -688px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--687 {
            --translate-x: -687px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--686 {
            --translate-x: -686px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--685 {
            --translate-x: -685px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--684 {
            --translate-x: -684px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--683 {
            --translate-x: -683px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--682 {
            --translate-x: -682px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--681 {
            --translate-x: -681px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--680 {
            --translate-x: -680px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--679 {
            --translate-x: -679px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--678 {
            --translate-x: -678px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--677 {
            --translate-x: -677px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--676 {
            --translate-x: -676px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--675 {
            --translate-x: -675px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--674 {
            --translate-x: -674px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--673 {
            --translate-x: -673px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--672 {
            --translate-x: -672px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--671 {
            --translate-x: -671px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--670 {
            --translate-x: -670px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--669 {
            --translate-x: -669px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--668 {
            --translate-x: -668px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--667 {
            --translate-x: -667px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--666 {
            --translate-x: -666px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--665 {
            --translate-x: -665px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--664 {
            --translate-x: -664px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--663 {
            --translate-x: -663px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--662 {
            --translate-x: -662px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--661 {
            --translate-x: -661px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--660 {
            --translate-x: -660px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--659 {
            --translate-x: -659px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--658 {
            --translate-x: -658px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--657 {
            --translate-x: -657px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--656 {
            --translate-x: -656px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--655 {
            --translate-x: -655px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--654 {
            --translate-x: -654px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--653 {
            --translate-x: -653px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--652 {
            --translate-x: -652px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--651 {
            --translate-x: -651px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--650 {
            --translate-x: -650px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--649 {
            --translate-x: -649px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--648 {
            --translate-x: -648px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--647 {
            --translate-x: -647px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--646 {
            --translate-x: -646px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--645 {
            --translate-x: -645px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--644 {
            --translate-x: -644px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--643 {
            --translate-x: -643px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--642 {
            --translate-x: -642px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--641 {
            --translate-x: -641px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--640 {
            --translate-x: -640px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--639 {
            --translate-x: -639px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--638 {
            --translate-x: -638px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--637 {
            --translate-x: -637px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--636 {
            --translate-x: -636px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--635 {
            --translate-x: -635px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--634 {
            --translate-x: -634px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--633 {
            --translate-x: -633px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--632 {
            --translate-x: -632px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--631 {
            --translate-x: -631px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--630 {
            --translate-x: -630px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--629 {
            --translate-x: -629px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--628 {
            --translate-x: -628px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--627 {
            --translate-x: -627px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--626 {
            --translate-x: -626px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--625 {
            --translate-x: -625px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--624 {
            --translate-x: -624px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--623 {
            --translate-x: -623px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--622 {
            --translate-x: -622px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--621 {
            --translate-x: -621px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--620 {
            --translate-x: -620px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--619 {
            --translate-x: -619px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--618 {
            --translate-x: -618px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--617 {
            --translate-x: -617px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--616 {
            --translate-x: -616px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--615 {
            --translate-x: -615px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--614 {
            --translate-x: -614px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--613 {
            --translate-x: -613px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--612 {
            --translate-x: -612px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--611 {
            --translate-x: -611px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--610 {
            --translate-x: -610px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--609 {
            --translate-x: -609px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--608 {
            --translate-x: -608px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--607 {
            --translate-x: -607px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--606 {
            --translate-x: -606px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--605 {
            --translate-x: -605px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--604 {
            --translate-x: -604px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--603 {
            --translate-x: -603px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--602 {
            --translate-x: -602px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--601 {
            --translate-x: -601px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--600 {
            --translate-x: -600px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--599 {
            --translate-x: -599px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--598 {
            --translate-x: -598px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--597 {
            --translate-x: -597px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--596 {
            --translate-x: -596px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--595 {
            --translate-x: -595px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--594 {
            --translate-x: -594px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--593 {
            --translate-x: -593px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--592 {
            --translate-x: -592px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--591 {
            --translate-x: -591px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--590 {
            --translate-x: -590px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--589 {
            --translate-x: -589px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--588 {
            --translate-x: -588px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--587 {
            --translate-x: -587px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--586 {
            --translate-x: -586px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--585 {
            --translate-x: -585px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--584 {
            --translate-x: -584px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--583 {
            --translate-x: -583px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--582 {
            --translate-x: -582px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--581 {
            --translate-x: -581px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--580 {
            --translate-x: -580px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--579 {
            --translate-x: -579px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--578 {
            --translate-x: -578px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--577 {
            --translate-x: -577px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--576 {
            --translate-x: -576px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--575 {
            --translate-x: -575px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--574 {
            --translate-x: -574px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--573 {
            --translate-x: -573px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--572 {
            --translate-x: -572px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--571 {
            --translate-x: -571px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--570 {
            --translate-x: -570px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--569 {
            --translate-x: -569px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--568 {
            --translate-x: -568px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--567 {
            --translate-x: -567px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--566 {
            --translate-x: -566px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--565 {
            --translate-x: -565px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--564 {
            --translate-x: -564px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--563 {
            --translate-x: -563px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--562 {
            --translate-x: -562px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--561 {
            --translate-x: -561px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--560 {
            --translate-x: -560px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--559 {
            --translate-x: -559px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--558 {
            --translate-x: -558px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--557 {
            --translate-x: -557px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--556 {
            --translate-x: -556px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--555 {
            --translate-x: -555px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--554 {
            --translate-x: -554px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--553 {
            --translate-x: -553px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--552 {
            --translate-x: -552px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--551 {
            --translate-x: -551px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--550 {
            --translate-x: -550px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--549 {
            --translate-x: -549px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--548 {
            --translate-x: -548px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--547 {
            --translate-x: -547px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--546 {
            --translate-x: -546px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--545 {
            --translate-x: -545px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--544 {
            --translate-x: -544px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--543 {
            --translate-x: -543px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--542 {
            --translate-x: -542px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--541 {
            --translate-x: -541px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--540 {
            --translate-x: -540px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--539 {
            --translate-x: -539px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--538 {
            --translate-x: -538px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--537 {
            --translate-x: -537px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--536 {
            --translate-x: -536px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--535 {
            --translate-x: -535px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--534 {
            --translate-x: -534px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--533 {
            --translate-x: -533px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--532 {
            --translate-x: -532px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--531 {
            --translate-x: -531px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--530 {
            --translate-x: -530px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--529 {
            --translate-x: -529px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--528 {
            --translate-x: -528px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--527 {
            --translate-x: -527px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--526 {
            --translate-x: -526px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--525 {
            --translate-x: -525px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--524 {
            --translate-x: -524px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--523 {
            --translate-x: -523px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--522 {
            --translate-x: -522px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--521 {
            --translate-x: -521px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--520 {
            --translate-x: -520px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--519 {
            --translate-x: -519px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--518 {
            --translate-x: -518px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--517 {
            --translate-x: -517px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--516 {
            --translate-x: -516px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--515 {
            --translate-x: -515px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--514 {
            --translate-x: -514px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--513 {
            --translate-x: -513px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--512 {
            --translate-x: -512px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--511 {
            --translate-x: -511px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--510 {
            --translate-x: -510px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--509 {
            --translate-x: -509px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--508 {
            --translate-x: -508px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--507 {
            --translate-x: -507px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--506 {
            --translate-x: -506px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--505 {
            --translate-x: -505px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--504 {
            --translate-x: -504px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--503 {
            --translate-x: -503px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--502 {
            --translate-x: -502px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--501 {
            --translate-x: -501px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--500 {
            --translate-x: -500px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--499 {
            --translate-x: -499px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--498 {
            --translate-x: -498px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--497 {
            --translate-x: -497px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--496 {
            --translate-x: -496px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--495 {
            --translate-x: -495px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--494 {
            --translate-x: -494px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--493 {
            --translate-x: -493px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--492 {
            --translate-x: -492px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--491 {
            --translate-x: -491px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--490 {
            --translate-x: -490px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--489 {
            --translate-x: -489px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--488 {
            --translate-x: -488px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--487 {
            --translate-x: -487px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--486 {
            --translate-x: -486px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--485 {
            --translate-x: -485px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--484 {
            --translate-x: -484px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--483 {
            --translate-x: -483px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--482 {
            --translate-x: -482px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--481 {
            --translate-x: -481px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--480 {
            --translate-x: -480px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--479 {
            --translate-x: -479px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--478 {
            --translate-x: -478px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--477 {
            --translate-x: -477px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--476 {
            --translate-x: -476px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--475 {
            --translate-x: -475px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--474 {
            --translate-x: -474px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--473 {
            --translate-x: -473px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--472 {
            --translate-x: -472px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--471 {
            --translate-x: -471px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--470 {
            --translate-x: -470px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--469 {
            --translate-x: -469px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--468 {
            --translate-x: -468px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--467 {
            --translate-x: -467px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--466 {
            --translate-x: -466px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--465 {
            --translate-x: -465px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--464 {
            --translate-x: -464px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--463 {
            --translate-x: -463px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--462 {
            --translate-x: -462px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--461 {
            --translate-x: -461px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--460 {
            --translate-x: -460px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--459 {
            --translate-x: -459px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--458 {
            --translate-x: -458px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--457 {
            --translate-x: -457px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--456 {
            --translate-x: -456px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--455 {
            --translate-x: -455px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--454 {
            --translate-x: -454px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--453 {
            --translate-x: -453px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--452 {
            --translate-x: -452px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--451 {
            --translate-x: -451px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--450 {
            --translate-x: -450px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--449 {
            --translate-x: -449px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--448 {
            --translate-x: -448px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--447 {
            --translate-x: -447px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--446 {
            --translate-x: -446px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--445 {
            --translate-x: -445px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--444 {
            --translate-x: -444px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--443 {
            --translate-x: -443px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--442 {
            --translate-x: -442px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--441 {
            --translate-x: -441px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--440 {
            --translate-x: -440px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--439 {
            --translate-x: -439px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--438 {
            --translate-x: -438px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--437 {
            --translate-x: -437px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--436 {
            --translate-x: -436px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--435 {
            --translate-x: -435px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--434 {
            --translate-x: -434px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--433 {
            --translate-x: -433px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--432 {
            --translate-x: -432px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--431 {
            --translate-x: -431px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--430 {
            --translate-x: -430px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--429 {
            --translate-x: -429px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--428 {
            --translate-x: -428px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--427 {
            --translate-x: -427px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--426 {
            --translate-x: -426px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--425 {
            --translate-x: -425px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--424 {
            --translate-x: -424px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--423 {
            --translate-x: -423px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--422 {
            --translate-x: -422px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--421 {
            --translate-x: -421px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--420 {
            --translate-x: -420px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--419 {
            --translate-x: -419px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--418 {
            --translate-x: -418px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--417 {
            --translate-x: -417px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--416 {
            --translate-x: -416px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--415 {
            --translate-x: -415px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--414 {
            --translate-x: -414px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--413 {
            --translate-x: -413px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--412 {
            --translate-x: -412px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--411 {
            --translate-x: -411px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--410 {
            --translate-x: -410px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--409 {
            --translate-x: -409px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--408 {
            --translate-x: -408px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--407 {
            --translate-x: -407px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--406 {
            --translate-x: -406px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--405 {
            --translate-x: -405px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--404 {
            --translate-x: -404px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--403 {
            --translate-x: -403px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--402 {
            --translate-x: -402px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--401 {
            --translate-x: -401px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--400 {
            --translate-x: -400px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--399 {
            --translate-x: -399px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--398 {
            --translate-x: -398px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--397 {
            --translate-x: -397px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--396 {
            --translate-x: -396px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--395 {
            --translate-x: -395px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--394 {
            --translate-x: -394px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--393 {
            --translate-x: -393px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--392 {
            --translate-x: -392px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--391 {
            --translate-x: -391px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--390 {
            --translate-x: -390px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--389 {
            --translate-x: -389px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--388 {
            --translate-x: -388px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--387 {
            --translate-x: -387px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--386 {
            --translate-x: -386px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--385 {
            --translate-x: -385px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--384 {
            --translate-x: -384px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--383 {
            --translate-x: -383px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--382 {
            --translate-x: -382px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--381 {
            --translate-x: -381px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--380 {
            --translate-x: -380px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--379 {
            --translate-x: -379px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--378 {
            --translate-x: -378px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--377 {
            --translate-x: -377px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--376 {
            --translate-x: -376px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--375 {
            --translate-x: -375px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--374 {
            --translate-x: -374px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--373 {
            --translate-x: -373px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--372 {
            --translate-x: -372px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--371 {
            --translate-x: -371px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--370 {
            --translate-x: -370px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--369 {
            --translate-x: -369px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--368 {
            --translate-x: -368px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--367 {
            --translate-x: -367px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--366 {
            --translate-x: -366px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--365 {
            --translate-x: -365px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--364 {
            --translate-x: -364px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--363 {
            --translate-x: -363px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--362 {
            --translate-x: -362px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--361 {
            --translate-x: -361px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--360 {
            --translate-x: -360px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--359 {
            --translate-x: -359px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--358 {
            --translate-x: -358px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--357 {
            --translate-x: -357px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--356 {
            --translate-x: -356px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--355 {
            --translate-x: -355px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--354 {
            --translate-x: -354px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--353 {
            --translate-x: -353px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--352 {
            --translate-x: -352px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--351 {
            --translate-x: -351px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--350 {
            --translate-x: -350px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--349 {
            --translate-x: -349px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--348 {
            --translate-x: -348px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--347 {
            --translate-x: -347px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--346 {
            --translate-x: -346px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--345 {
            --translate-x: -345px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--344 {
            --translate-x: -344px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--343 {
            --translate-x: -343px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--342 {
            --translate-x: -342px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--341 {
            --translate-x: -341px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--340 {
            --translate-x: -340px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--339 {
            --translate-x: -339px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--338 {
            --translate-x: -338px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--337 {
            --translate-x: -337px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--336 {
            --translate-x: -336px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--335 {
            --translate-x: -335px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--334 {
            --translate-x: -334px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--333 {
            --translate-x: -333px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--332 {
            --translate-x: -332px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--331 {
            --translate-x: -331px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--330 {
            --translate-x: -330px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--329 {
            --translate-x: -329px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--328 {
            --translate-x: -328px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--327 {
            --translate-x: -327px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--326 {
            --translate-x: -326px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--325 {
            --translate-x: -325px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--324 {
            --translate-x: -324px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--323 {
            --translate-x: -323px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--322 {
            --translate-x: -322px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--321 {
            --translate-x: -321px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--320 {
            --translate-x: -320px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--319 {
            --translate-x: -319px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--318 {
            --translate-x: -318px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--317 {
            --translate-x: -317px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--316 {
            --translate-x: -316px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--315 {
            --translate-x: -315px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--314 {
            --translate-x: -314px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--313 {
            --translate-x: -313px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--312 {
            --translate-x: -312px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--311 {
            --translate-x: -311px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--310 {
            --translate-x: -310px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--309 {
            --translate-x: -309px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--308 {
            --translate-x: -308px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--307 {
            --translate-x: -307px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--306 {
            --translate-x: -306px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--305 {
            --translate-x: -305px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--304 {
            --translate-x: -304px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--303 {
            --translate-x: -303px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--302 {
            --translate-x: -302px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--301 {
            --translate-x: -301px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--300 {
            --translate-x: -300px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--299 {
            --translate-x: -299px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--298 {
            --translate-x: -298px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--297 {
            --translate-x: -297px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--296 {
            --translate-x: -296px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--295 {
            --translate-x: -295px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--294 {
            --translate-x: -294px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--293 {
            --translate-x: -293px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--292 {
            --translate-x: -292px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--291 {
            --translate-x: -291px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--290 {
            --translate-x: -290px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--289 {
            --translate-x: -289px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--288 {
            --translate-x: -288px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--287 {
            --translate-x: -287px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--286 {
            --translate-x: -286px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--285 {
            --translate-x: -285px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--284 {
            --translate-x: -284px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--283 {
            --translate-x: -283px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--282 {
            --translate-x: -282px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--281 {
            --translate-x: -281px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--280 {
            --translate-x: -280px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--279 {
            --translate-x: -279px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--278 {
            --translate-x: -278px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--277 {
            --translate-x: -277px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--276 {
            --translate-x: -276px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--275 {
            --translate-x: -275px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--274 {
            --translate-x: -274px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--273 {
            --translate-x: -273px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--272 {
            --translate-x: -272px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--271 {
            --translate-x: -271px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--270 {
            --translate-x: -270px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--269 {
            --translate-x: -269px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--268 {
            --translate-x: -268px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--267 {
            --translate-x: -267px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--266 {
            --translate-x: -266px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--265 {
            --translate-x: -265px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--264 {
            --translate-x: -264px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--263 {
            --translate-x: -263px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--262 {
            --translate-x: -262px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--261 {
            --translate-x: -261px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--260 {
            --translate-x: -260px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--259 {
            --translate-x: -259px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--258 {
            --translate-x: -258px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--257 {
            --translate-x: -257px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--256 {
            --translate-x: -256px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--255 {
            --translate-x: -255px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--254 {
            --translate-x: -254px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--253 {
            --translate-x: -253px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--252 {
            --translate-x: -252px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--251 {
            --translate-x: -251px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--250 {
            --translate-x: -250px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--249 {
            --translate-x: -249px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--248 {
            --translate-x: -248px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--247 {
            --translate-x: -247px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--246 {
            --translate-x: -246px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--245 {
            --translate-x: -245px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--244 {
            --translate-x: -244px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--243 {
            --translate-x: -243px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--242 {
            --translate-x: -242px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--241 {
            --translate-x: -241px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--240 {
            --translate-x: -240px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--239 {
            --translate-x: -239px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--238 {
            --translate-x: -238px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--237 {
            --translate-x: -237px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--236 {
            --translate-x: -236px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--235 {
            --translate-x: -235px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--234 {
            --translate-x: -234px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--233 {
            --translate-x: -233px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--232 {
            --translate-x: -232px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--231 {
            --translate-x: -231px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--230 {
            --translate-x: -230px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--229 {
            --translate-x: -229px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--228 {
            --translate-x: -228px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--227 {
            --translate-x: -227px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--226 {
            --translate-x: -226px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--225 {
            --translate-x: -225px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--224 {
            --translate-x: -224px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--223 {
            --translate-x: -223px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--222 {
            --translate-x: -222px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--221 {
            --translate-x: -221px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--220 {
            --translate-x: -220px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--219 {
            --translate-x: -219px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--218 {
            --translate-x: -218px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--217 {
            --translate-x: -217px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--216 {
            --translate-x: -216px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--215 {
            --translate-x: -215px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--214 {
            --translate-x: -214px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--213 {
            --translate-x: -213px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--212 {
            --translate-x: -212px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--211 {
            --translate-x: -211px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--210 {
            --translate-x: -210px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--209 {
            --translate-x: -209px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--208 {
            --translate-x: -208px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--207 {
            --translate-x: -207px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--206 {
            --translate-x: -206px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--205 {
            --translate-x: -205px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--204 {
            --translate-x: -204px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--203 {
            --translate-x: -203px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--202 {
            --translate-x: -202px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--201 {
            --translate-x: -201px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--200 {
            --translate-x: -200px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--199 {
            --translate-x: -199px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--198 {
            --translate-x: -198px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--197 {
            --translate-x: -197px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--196 {
            --translate-x: -196px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--195 {
            --translate-x: -195px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--194 {
            --translate-x: -194px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--193 {
            --translate-x: -193px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--192 {
            --translate-x: -192px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--191 {
            --translate-x: -191px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--190 {
            --translate-x: -190px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--189 {
            --translate-x: -189px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--188 {
            --translate-x: -188px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--187 {
            --translate-x: -187px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--186 {
            --translate-x: -186px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--185 {
            --translate-x: -185px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--184 {
            --translate-x: -184px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--183 {
            --translate-x: -183px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--182 {
            --translate-x: -182px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--181 {
            --translate-x: -181px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--180 {
            --translate-x: -180px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--179 {
            --translate-x: -179px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--178 {
            --translate-x: -178px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--177 {
            --translate-x: -177px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--176 {
            --translate-x: -176px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--175 {
            --translate-x: -175px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--174 {
            --translate-x: -174px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--173 {
            --translate-x: -173px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--172 {
            --translate-x: -172px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--171 {
            --translate-x: -171px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--170 {
            --translate-x: -170px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--169 {
            --translate-x: -169px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--168 {
            --translate-x: -168px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--167 {
            --translate-x: -167px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--166 {
            --translate-x: -166px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--165 {
            --translate-x: -165px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--164 {
            --translate-x: -164px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--163 {
            --translate-x: -163px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--162 {
            --translate-x: -162px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--161 {
            --translate-x: -161px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--160 {
            --translate-x: -160px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--159 {
            --translate-x: -159px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--158 {
            --translate-x: -158px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--157 {
            --translate-x: -157px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--156 {
            --translate-x: -156px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--155 {
            --translate-x: -155px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--154 {
            --translate-x: -154px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--153 {
            --translate-x: -153px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--152 {
            --translate-x: -152px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--151 {
            --translate-x: -151px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--150 {
            --translate-x: -150px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--149 {
            --translate-x: -149px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--148 {
            --translate-x: -148px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--147 {
            --translate-x: -147px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--146 {
            --translate-x: -146px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--145 {
            --translate-x: -145px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--144 {
            --translate-x: -144px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--143 {
            --translate-x: -143px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--142 {
            --translate-x: -142px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--141 {
            --translate-x: -141px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--140 {
            --translate-x: -140px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--139 {
            --translate-x: -139px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--138 {
            --translate-x: -138px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--137 {
            --translate-x: -137px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--136 {
            --translate-x: -136px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--135 {
            --translate-x: -135px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--134 {
            --translate-x: -134px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--133 {
            --translate-x: -133px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--132 {
            --translate-x: -132px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--131 {
            --translate-x: -131px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--130 {
            --translate-x: -130px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--129 {
            --translate-x: -129px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--128 {
            --translate-x: -128px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--127 {
            --translate-x: -127px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--126 {
            --translate-x: -126px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--125 {
            --translate-x: -125px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--124 {
            --translate-x: -124px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--123 {
            --translate-x: -123px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--122 {
            --translate-x: -122px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--121 {
            --translate-x: -121px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--120 {
            --translate-x: -120px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--119 {
            --translate-x: -119px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--118 {
            --translate-x: -118px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--117 {
            --translate-x: -117px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--116 {
            --translate-x: -116px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--115 {
            --translate-x: -115px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--114 {
            --translate-x: -114px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--113 {
            --translate-x: -113px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--112 {
            --translate-x: -112px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--111 {
            --translate-x: -111px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--110 {
            --translate-x: -110px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--109 {
            --translate-x: -109px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--108 {
            --translate-x: -108px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--107 {
            --translate-x: -107px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--106 {
            --translate-x: -106px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--105 {
            --translate-x: -105px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--104 {
            --translate-x: -104px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--103 {
            --translate-x: -103px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--102 {
            --translate-x: -102px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--101 {
            --translate-x: -101px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--100 {
            --translate-x: -100px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--99 {
            --translate-x: -99px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--98 {
            --translate-x: -98px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--97 {
            --translate-x: -97px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--96 {
            --translate-x: -96px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--95 {
            --translate-x: -95px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--94 {
            --translate-x: -94px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--93 {
            --translate-x: -93px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--92 {
            --translate-x: -92px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--91 {
            --translate-x: -91px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--90 {
            --translate-x: -90px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--89 {
            --translate-x: -89px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--88 {
            --translate-x: -88px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--87 {
            --translate-x: -87px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--86 {
            --translate-x: -86px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--85 {
            --translate-x: -85px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--84 {
            --translate-x: -84px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--83 {
            --translate-x: -83px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--82 {
            --translate-x: -82px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--81 {
            --translate-x: -81px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--80 {
            --translate-x: -80px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--79 {
            --translate-x: -79px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--78 {
            --translate-x: -78px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--77 {
            --translate-x: -77px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--76 {
            --translate-x: -76px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--75 {
            --translate-x: -75px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--74 {
            --translate-x: -74px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--73 {
            --translate-x: -73px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--72 {
            --translate-x: -72px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--71 {
            --translate-x: -71px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--70 {
            --translate-x: -70px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--69 {
            --translate-x: -69px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--68 {
            --translate-x: -68px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--67 {
            --translate-x: -67px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--66 {
            --translate-x: -66px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--65 {
            --translate-x: -65px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--64 {
            --translate-x: -64px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--63 {
            --translate-x: -63px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--62 {
            --translate-x: -62px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--61 {
            --translate-x: -61px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--60 {
            --translate-x: -60px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--59 {
            --translate-x: -59px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--58 {
            --translate-x: -58px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--57 {
            --translate-x: -57px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--56 {
            --translate-x: -56px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--55 {
            --translate-x: -55px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--54 {
            --translate-x: -54px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--53 {
            --translate-x: -53px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--52 {
            --translate-x: -52px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--51 {
            --translate-x: -51px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--50 {
            --translate-x: -50px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--49 {
            --translate-x: -49px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--48 {
            --translate-x: -48px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--47 {
            --translate-x: -47px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--46 {
            --translate-x: -46px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--45 {
            --translate-x: -45px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--44 {
            --translate-x: -44px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--43 {
            --translate-x: -43px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--42 {
            --translate-x: -42px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--41 {
            --translate-x: -41px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--40 {
            --translate-x: -40px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--39 {
            --translate-x: -39px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--38 {
            --translate-x: -38px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--37 {
            --translate-x: -37px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--36 {
            --translate-x: -36px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--35 {
            --translate-x: -35px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--34 {
            --translate-x: -34px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--33 {
            --translate-x: -33px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--32 {
            --translate-x: -32px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--31 {
            --translate-x: -31px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--30 {
            --translate-x: -30px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--29 {
            --translate-x: -29px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--28 {
            --translate-x: -28px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--27 {
            --translate-x: -27px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--26 {
            --translate-x: -26px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--25 {
            --translate-x: -25px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--24 {
            --translate-x: -24px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--23 {
            --translate-x: -23px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--22 {
            --translate-x: -22px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--21 {
            --translate-x: -21px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--20 {
            --translate-x: -20px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--19 {
            --translate-x: -19px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--18 {
            --translate-x: -18px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--17 {
            --translate-x: -17px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--16 {
            --translate-x: -16px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--15 {
            --translate-x: -15px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--14 {
            --translate-x: -14px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--13 {
            --translate-x: -13px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--12 {
            --translate-x: -12px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--11 {
            --translate-x: -11px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--10 {
            --translate-x: -10px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--9 {
            --translate-x: -9px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--8 {
            --translate-x: -8px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--7 {
            --translate-x: -7px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--6 {
            --translate-x: -6px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--5 {
            --translate-x: -5px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--4 {
            --translate-x: -4px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--3 {
            --translate-x: -3px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--2 {
            --translate-x: -2px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x--1 {
            --translate-x: -1px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-0 {
            --translate-x: 0px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-1 {
            --translate-x: 1px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-2 {
            --translate-x: 2px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-3 {
            --translate-x: 3px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-4 {
            --translate-x: 4px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-5 {
            --translate-x: 5px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-6 {
            --translate-x: 6px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-7 {
            --translate-x: 7px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-8 {
            --translate-x: 8px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-9 {
            --translate-x: 9px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-10 {
            --translate-x: 10px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-11 {
            --translate-x: 11px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-12 {
            --translate-x: 12px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-13 {
            --translate-x: 13px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-14 {
            --translate-x: 14px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-15 {
            --translate-x: 15px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-16 {
            --translate-x: 16px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-17 {
            --translate-x: 17px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-18 {
            --translate-x: 18px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-19 {
            --translate-x: 19px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-20 {
            --translate-x: 20px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-21 {
            --translate-x: 21px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-22 {
            --translate-x: 22px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-23 {
            --translate-x: 23px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-24 {
            --translate-x: 24px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-25 {
            --translate-x: 25px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-26 {
            --translate-x: 26px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-27 {
            --translate-x: 27px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-28 {
            --translate-x: 28px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-29 {
            --translate-x: 29px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-30 {
            --translate-x: 30px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-31 {
            --translate-x: 31px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-32 {
            --translate-x: 32px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-33 {
            --translate-x: 33px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-34 {
            --translate-x: 34px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-35 {
            --translate-x: 35px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-36 {
            --translate-x: 36px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-37 {
            --translate-x: 37px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-38 {
            --translate-x: 38px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-39 {
            --translate-x: 39px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-40 {
            --translate-x: 40px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-41 {
            --translate-x: 41px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-42 {
            --translate-x: 42px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-43 {
            --translate-x: 43px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-44 {
            --translate-x: 44px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-45 {
            --translate-x: 45px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-46 {
            --translate-x: 46px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-47 {
            --translate-x: 47px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-48 {
            --translate-x: 48px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-49 {
            --translate-x: 49px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-x-50 {
            --translate-x: 50px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--800 {
            --translate-y: -800px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--799 {
            --translate-y: -799px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--798 {
            --translate-y: -798px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--797 {
            --translate-y: -797px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--796 {
            --translate-y: -796px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--795 {
            --translate-y: -795px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--794 {
            --translate-y: -794px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--793 {
            --translate-y: -793px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--792 {
            --translate-y: -792px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--791 {
            --translate-y: -791px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--790 {
            --translate-y: -790px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--789 {
            --translate-y: -789px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--788 {
            --translate-y: -788px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--787 {
            --translate-y: -787px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--786 {
            --translate-y: -786px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--785 {
            --translate-y: -785px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--784 {
            --translate-y: -784px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--783 {
            --translate-y: -783px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--782 {
            --translate-y: -782px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--781 {
            --translate-y: -781px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--780 {
            --translate-y: -780px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--779 {
            --translate-y: -779px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--778 {
            --translate-y: -778px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--777 {
            --translate-y: -777px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--776 {
            --translate-y: -776px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--775 {
            --translate-y: -775px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--774 {
            --translate-y: -774px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--773 {
            --translate-y: -773px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--772 {
            --translate-y: -772px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--771 {
            --translate-y: -771px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--770 {
            --translate-y: -770px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--769 {
            --translate-y: -769px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--768 {
            --translate-y: -768px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--767 {
            --translate-y: -767px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--766 {
            --translate-y: -766px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--765 {
            --translate-y: -765px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--764 {
            --translate-y: -764px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--763 {
            --translate-y: -763px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--762 {
            --translate-y: -762px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--761 {
            --translate-y: -761px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--760 {
            --translate-y: -760px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--759 {
            --translate-y: -759px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--758 {
            --translate-y: -758px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--757 {
            --translate-y: -757px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--756 {
            --translate-y: -756px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--755 {
            --translate-y: -755px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--754 {
            --translate-y: -754px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--753 {
            --translate-y: -753px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--752 {
            --translate-y: -752px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--751 {
            --translate-y: -751px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--750 {
            --translate-y: -750px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--749 {
            --translate-y: -749px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--748 {
            --translate-y: -748px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--747 {
            --translate-y: -747px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--746 {
            --translate-y: -746px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--745 {
            --translate-y: -745px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--744 {
            --translate-y: -744px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--743 {
            --translate-y: -743px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--742 {
            --translate-y: -742px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--741 {
            --translate-y: -741px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--740 {
            --translate-y: -740px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--739 {
            --translate-y: -739px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--738 {
            --translate-y: -738px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--737 {
            --translate-y: -737px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--736 {
            --translate-y: -736px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--735 {
            --translate-y: -735px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--734 {
            --translate-y: -734px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--733 {
            --translate-y: -733px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--732 {
            --translate-y: -732px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--731 {
            --translate-y: -731px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--730 {
            --translate-y: -730px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--729 {
            --translate-y: -729px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--728 {
            --translate-y: -728px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--727 {
            --translate-y: -727px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--726 {
            --translate-y: -726px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--725 {
            --translate-y: -725px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--724 {
            --translate-y: -724px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--723 {
            --translate-y: -723px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--722 {
            --translate-y: -722px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--721 {
            --translate-y: -721px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--720 {
            --translate-y: -720px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--719 {
            --translate-y: -719px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--718 {
            --translate-y: -718px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--717 {
            --translate-y: -717px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--716 {
            --translate-y: -716px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--715 {
            --translate-y: -715px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--714 {
            --translate-y: -714px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--713 {
            --translate-y: -713px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--712 {
            --translate-y: -712px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--711 {
            --translate-y: -711px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--710 {
            --translate-y: -710px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--709 {
            --translate-y: -709px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--708 {
            --translate-y: -708px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--707 {
            --translate-y: -707px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--706 {
            --translate-y: -706px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--705 {
            --translate-y: -705px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--704 {
            --translate-y: -704px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--703 {
            --translate-y: -703px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--702 {
            --translate-y: -702px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--701 {
            --translate-y: -701px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--700 {
            --translate-y: -700px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--699 {
            --translate-y: -699px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--698 {
            --translate-y: -698px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--697 {
            --translate-y: -697px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--696 {
            --translate-y: -696px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--695 {
            --translate-y: -695px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--694 {
            --translate-y: -694px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--693 {
            --translate-y: -693px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--692 {
            --translate-y: -692px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--691 {
            --translate-y: -691px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--690 {
            --translate-y: -690px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--689 {
            --translate-y: -689px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--688 {
            --translate-y: -688px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--687 {
            --translate-y: -687px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--686 {
            --translate-y: -686px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--685 {
            --translate-y: -685px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--684 {
            --translate-y: -684px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--683 {
            --translate-y: -683px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--682 {
            --translate-y: -682px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--681 {
            --translate-y: -681px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--680 {
            --translate-y: -680px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--679 {
            --translate-y: -679px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--678 {
            --translate-y: -678px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--677 {
            --translate-y: -677px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--676 {
            --translate-y: -676px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--675 {
            --translate-y: -675px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--674 {
            --translate-y: -674px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--673 {
            --translate-y: -673px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--672 {
            --translate-y: -672px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--671 {
            --translate-y: -671px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--670 {
            --translate-y: -670px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--669 {
            --translate-y: -669px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--668 {
            --translate-y: -668px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--667 {
            --translate-y: -667px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--666 {
            --translate-y: -666px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--665 {
            --translate-y: -665px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--664 {
            --translate-y: -664px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--663 {
            --translate-y: -663px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--662 {
            --translate-y: -662px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--661 {
            --translate-y: -661px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--660 {
            --translate-y: -660px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--659 {
            --translate-y: -659px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--658 {
            --translate-y: -658px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--657 {
            --translate-y: -657px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--656 {
            --translate-y: -656px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--655 {
            --translate-y: -655px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--654 {
            --translate-y: -654px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--653 {
            --translate-y: -653px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--652 {
            --translate-y: -652px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--651 {
            --translate-y: -651px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--650 {
            --translate-y: -650px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--649 {
            --translate-y: -649px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--648 {
            --translate-y: -648px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--647 {
            --translate-y: -647px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--646 {
            --translate-y: -646px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--645 {
            --translate-y: -645px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--644 {
            --translate-y: -644px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--643 {
            --translate-y: -643px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--642 {
            --translate-y: -642px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--641 {
            --translate-y: -641px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--640 {
            --translate-y: -640px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--639 {
            --translate-y: -639px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--638 {
            --translate-y: -638px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--637 {
            --translate-y: -637px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--636 {
            --translate-y: -636px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--635 {
            --translate-y: -635px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--634 {
            --translate-y: -634px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--633 {
            --translate-y: -633px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--632 {
            --translate-y: -632px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--631 {
            --translate-y: -631px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--630 {
            --translate-y: -630px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--629 {
            --translate-y: -629px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--628 {
            --translate-y: -628px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--627 {
            --translate-y: -627px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--626 {
            --translate-y: -626px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--625 {
            --translate-y: -625px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--624 {
            --translate-y: -624px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--623 {
            --translate-y: -623px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--622 {
            --translate-y: -622px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--621 {
            --translate-y: -621px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--620 {
            --translate-y: -620px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--619 {
            --translate-y: -619px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--618 {
            --translate-y: -618px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--617 {
            --translate-y: -617px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--616 {
            --translate-y: -616px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--615 {
            --translate-y: -615px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--614 {
            --translate-y: -614px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--613 {
            --translate-y: -613px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--612 {
            --translate-y: -612px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--611 {
            --translate-y: -611px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--610 {
            --translate-y: -610px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--609 {
            --translate-y: -609px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--608 {
            --translate-y: -608px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--607 {
            --translate-y: -607px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--606 {
            --translate-y: -606px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--605 {
            --translate-y: -605px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--604 {
            --translate-y: -604px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--603 {
            --translate-y: -603px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--602 {
            --translate-y: -602px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--601 {
            --translate-y: -601px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--600 {
            --translate-y: -600px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--599 {
            --translate-y: -599px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--598 {
            --translate-y: -598px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--597 {
            --translate-y: -597px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--596 {
            --translate-y: -596px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--595 {
            --translate-y: -595px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--594 {
            --translate-y: -594px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--593 {
            --translate-y: -593px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--592 {
            --translate-y: -592px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--591 {
            --translate-y: -591px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--590 {
            --translate-y: -590px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--589 {
            --translate-y: -589px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--588 {
            --translate-y: -588px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--587 {
            --translate-y: -587px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--586 {
            --translate-y: -586px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--585 {
            --translate-y: -585px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--584 {
            --translate-y: -584px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--583 {
            --translate-y: -583px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--582 {
            --translate-y: -582px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--581 {
            --translate-y: -581px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--580 {
            --translate-y: -580px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--579 {
            --translate-y: -579px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--578 {
            --translate-y: -578px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--577 {
            --translate-y: -577px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--576 {
            --translate-y: -576px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--575 {
            --translate-y: -575px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--574 {
            --translate-y: -574px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--573 {
            --translate-y: -573px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--572 {
            --translate-y: -572px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--571 {
            --translate-y: -571px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--570 {
            --translate-y: -570px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--569 {
            --translate-y: -569px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--568 {
            --translate-y: -568px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--567 {
            --translate-y: -567px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--566 {
            --translate-y: -566px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--565 {
            --translate-y: -565px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--564 {
            --translate-y: -564px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--563 {
            --translate-y: -563px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--562 {
            --translate-y: -562px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--561 {
            --translate-y: -561px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--560 {
            --translate-y: -560px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--559 {
            --translate-y: -559px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--558 {
            --translate-y: -558px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--557 {
            --translate-y: -557px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--556 {
            --translate-y: -556px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--555 {
            --translate-y: -555px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--554 {
            --translate-y: -554px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--553 {
            --translate-y: -553px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--552 {
            --translate-y: -552px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--551 {
            --translate-y: -551px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--550 {
            --translate-y: -550px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--549 {
            --translate-y: -549px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--548 {
            --translate-y: -548px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--547 {
            --translate-y: -547px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--546 {
            --translate-y: -546px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--545 {
            --translate-y: -545px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--544 {
            --translate-y: -544px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--543 {
            --translate-y: -543px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--542 {
            --translate-y: -542px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--541 {
            --translate-y: -541px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--540 {
            --translate-y: -540px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--539 {
            --translate-y: -539px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--538 {
            --translate-y: -538px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--537 {
            --translate-y: -537px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--536 {
            --translate-y: -536px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--535 {
            --translate-y: -535px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--534 {
            --translate-y: -534px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--533 {
            --translate-y: -533px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--532 {
            --translate-y: -532px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--531 {
            --translate-y: -531px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--530 {
            --translate-y: -530px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--529 {
            --translate-y: -529px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--528 {
            --translate-y: -528px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--527 {
            --translate-y: -527px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--526 {
            --translate-y: -526px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--525 {
            --translate-y: -525px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--524 {
            --translate-y: -524px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--523 {
            --translate-y: -523px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--522 {
            --translate-y: -522px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--521 {
            --translate-y: -521px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--520 {
            --translate-y: -520px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--519 {
            --translate-y: -519px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--518 {
            --translate-y: -518px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--517 {
            --translate-y: -517px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--516 {
            --translate-y: -516px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--515 {
            --translate-y: -515px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--514 {
            --translate-y: -514px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--513 {
            --translate-y: -513px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--512 {
            --translate-y: -512px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--511 {
            --translate-y: -511px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--510 {
            --translate-y: -510px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--509 {
            --translate-y: -509px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--508 {
            --translate-y: -508px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--507 {
            --translate-y: -507px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--506 {
            --translate-y: -506px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--505 {
            --translate-y: -505px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--504 {
            --translate-y: -504px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--503 {
            --translate-y: -503px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--502 {
            --translate-y: -502px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--501 {
            --translate-y: -501px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--500 {
            --translate-y: -500px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--499 {
            --translate-y: -499px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--498 {
            --translate-y: -498px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--497 {
            --translate-y: -497px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--496 {
            --translate-y: -496px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--495 {
            --translate-y: -495px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--494 {
            --translate-y: -494px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--493 {
            --translate-y: -493px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--492 {
            --translate-y: -492px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--491 {
            --translate-y: -491px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--490 {
            --translate-y: -490px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--489 {
            --translate-y: -489px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--488 {
            --translate-y: -488px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--487 {
            --translate-y: -487px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--486 {
            --translate-y: -486px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--485 {
            --translate-y: -485px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--484 {
            --translate-y: -484px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--483 {
            --translate-y: -483px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--482 {
            --translate-y: -482px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--481 {
            --translate-y: -481px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--480 {
            --translate-y: -480px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--479 {
            --translate-y: -479px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--478 {
            --translate-y: -478px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--477 {
            --translate-y: -477px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--476 {
            --translate-y: -476px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--475 {
            --translate-y: -475px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--474 {
            --translate-y: -474px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--473 {
            --translate-y: -473px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--472 {
            --translate-y: -472px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--471 {
            --translate-y: -471px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--470 {
            --translate-y: -470px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--469 {
            --translate-y: -469px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--468 {
            --translate-y: -468px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--467 {
            --translate-y: -467px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--466 {
            --translate-y: -466px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--465 {
            --translate-y: -465px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--464 {
            --translate-y: -464px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--463 {
            --translate-y: -463px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--462 {
            --translate-y: -462px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--461 {
            --translate-y: -461px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--460 {
            --translate-y: -460px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--459 {
            --translate-y: -459px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--458 {
            --translate-y: -458px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--457 {
            --translate-y: -457px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--456 {
            --translate-y: -456px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--455 {
            --translate-y: -455px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--454 {
            --translate-y: -454px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--453 {
            --translate-y: -453px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--452 {
            --translate-y: -452px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--451 {
            --translate-y: -451px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--450 {
            --translate-y: -450px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--449 {
            --translate-y: -449px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--448 {
            --translate-y: -448px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--447 {
            --translate-y: -447px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--446 {
            --translate-y: -446px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--445 {
            --translate-y: -445px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--444 {
            --translate-y: -444px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--443 {
            --translate-y: -443px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--442 {
            --translate-y: -442px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--441 {
            --translate-y: -441px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--440 {
            --translate-y: -440px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--439 {
            --translate-y: -439px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--438 {
            --translate-y: -438px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--437 {
            --translate-y: -437px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--436 {
            --translate-y: -436px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--435 {
            --translate-y: -435px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--434 {
            --translate-y: -434px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--433 {
            --translate-y: -433px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--432 {
            --translate-y: -432px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--431 {
            --translate-y: -431px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--430 {
            --translate-y: -430px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--429 {
            --translate-y: -429px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--428 {
            --translate-y: -428px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--427 {
            --translate-y: -427px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--426 {
            --translate-y: -426px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--425 {
            --translate-y: -425px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--424 {
            --translate-y: -424px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--423 {
            --translate-y: -423px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--422 {
            --translate-y: -422px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--421 {
            --translate-y: -421px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--420 {
            --translate-y: -420px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--419 {
            --translate-y: -419px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--418 {
            --translate-y: -418px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--417 {
            --translate-y: -417px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--416 {
            --translate-y: -416px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--415 {
            --translate-y: -415px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--414 {
            --translate-y: -414px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--413 {
            --translate-y: -413px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--412 {
            --translate-y: -412px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--411 {
            --translate-y: -411px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--410 {
            --translate-y: -410px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--409 {
            --translate-y: -409px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--408 {
            --translate-y: -408px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--407 {
            --translate-y: -407px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--406 {
            --translate-y: -406px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--405 {
            --translate-y: -405px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--404 {
            --translate-y: -404px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--403 {
            --translate-y: -403px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--402 {
            --translate-y: -402px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--401 {
            --translate-y: -401px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--400 {
            --translate-y: -400px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--399 {
            --translate-y: -399px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--398 {
            --translate-y: -398px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--397 {
            --translate-y: -397px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--396 {
            --translate-y: -396px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--395 {
            --translate-y: -395px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--394 {
            --translate-y: -394px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--393 {
            --translate-y: -393px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--392 {
            --translate-y: -392px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--391 {
            --translate-y: -391px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--390 {
            --translate-y: -390px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--389 {
            --translate-y: -389px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--388 {
            --translate-y: -388px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--387 {
            --translate-y: -387px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--386 {
            --translate-y: -386px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--385 {
            --translate-y: -385px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--384 {
            --translate-y: -384px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--383 {
            --translate-y: -383px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--382 {
            --translate-y: -382px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--381 {
            --translate-y: -381px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--380 {
            --translate-y: -380px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--379 {
            --translate-y: -379px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--378 {
            --translate-y: -378px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--377 {
            --translate-y: -377px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--376 {
            --translate-y: -376px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--375 {
            --translate-y: -375px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--374 {
            --translate-y: -374px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--373 {
            --translate-y: -373px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--372 {
            --translate-y: -372px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--371 {
            --translate-y: -371px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--370 {
            --translate-y: -370px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--369 {
            --translate-y: -369px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--368 {
            --translate-y: -368px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--367 {
            --translate-y: -367px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--366 {
            --translate-y: -366px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--365 {
            --translate-y: -365px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--364 {
            --translate-y: -364px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--363 {
            --translate-y: -363px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--362 {
            --translate-y: -362px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--361 {
            --translate-y: -361px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--360 {
            --translate-y: -360px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--359 {
            --translate-y: -359px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--358 {
            --translate-y: -358px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--357 {
            --translate-y: -357px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--356 {
            --translate-y: -356px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--355 {
            --translate-y: -355px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--354 {
            --translate-y: -354px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--353 {
            --translate-y: -353px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--352 {
            --translate-y: -352px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--351 {
            --translate-y: -351px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--350 {
            --translate-y: -350px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--349 {
            --translate-y: -349px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--348 {
            --translate-y: -348px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--347 {
            --translate-y: -347px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--346 {
            --translate-y: -346px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--345 {
            --translate-y: -345px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--344 {
            --translate-y: -344px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--343 {
            --translate-y: -343px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--342 {
            --translate-y: -342px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--341 {
            --translate-y: -341px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--340 {
            --translate-y: -340px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--339 {
            --translate-y: -339px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--338 {
            --translate-y: -338px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--337 {
            --translate-y: -337px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--336 {
            --translate-y: -336px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--335 {
            --translate-y: -335px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--334 {
            --translate-y: -334px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--333 {
            --translate-y: -333px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--332 {
            --translate-y: -332px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--331 {
            --translate-y: -331px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--330 {
            --translate-y: -330px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--329 {
            --translate-y: -329px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--328 {
            --translate-y: -328px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--327 {
            --translate-y: -327px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--326 {
            --translate-y: -326px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--325 {
            --translate-y: -325px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--324 {
            --translate-y: -324px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--323 {
            --translate-y: -323px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--322 {
            --translate-y: -322px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--321 {
            --translate-y: -321px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--320 {
            --translate-y: -320px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--319 {
            --translate-y: -319px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--318 {
            --translate-y: -318px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--317 {
            --translate-y: -317px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--316 {
            --translate-y: -316px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--315 {
            --translate-y: -315px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--314 {
            --translate-y: -314px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--313 {
            --translate-y: -313px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--312 {
            --translate-y: -312px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--311 {
            --translate-y: -311px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--310 {
            --translate-y: -310px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--309 {
            --translate-y: -309px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--308 {
            --translate-y: -308px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--307 {
            --translate-y: -307px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--306 {
            --translate-y: -306px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--305 {
            --translate-y: -305px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--304 {
            --translate-y: -304px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--303 {
            --translate-y: -303px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--302 {
            --translate-y: -302px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--301 {
            --translate-y: -301px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--300 {
            --translate-y: -300px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--299 {
            --translate-y: -299px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--298 {
            --translate-y: -298px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--297 {
            --translate-y: -297px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--296 {
            --translate-y: -296px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--295 {
            --translate-y: -295px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--294 {
            --translate-y: -294px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--293 {
            --translate-y: -293px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--292 {
            --translate-y: -292px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--291 {
            --translate-y: -291px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--290 {
            --translate-y: -290px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--289 {
            --translate-y: -289px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--288 {
            --translate-y: -288px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--287 {
            --translate-y: -287px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--286 {
            --translate-y: -286px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--285 {
            --translate-y: -285px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--284 {
            --translate-y: -284px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--283 {
            --translate-y: -283px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--282 {
            --translate-y: -282px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--281 {
            --translate-y: -281px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--280 {
            --translate-y: -280px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--279 {
            --translate-y: -279px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--278 {
            --translate-y: -278px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--277 {
            --translate-y: -277px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--276 {
            --translate-y: -276px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--275 {
            --translate-y: -275px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--274 {
            --translate-y: -274px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--273 {
            --translate-y: -273px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--272 {
            --translate-y: -272px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--271 {
            --translate-y: -271px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--270 {
            --translate-y: -270px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--269 {
            --translate-y: -269px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--268 {
            --translate-y: -268px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--267 {
            --translate-y: -267px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--266 {
            --translate-y: -266px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--265 {
            --translate-y: -265px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--264 {
            --translate-y: -264px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--263 {
            --translate-y: -263px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--262 {
            --translate-y: -262px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--261 {
            --translate-y: -261px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--260 {
            --translate-y: -260px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--259 {
            --translate-y: -259px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--258 {
            --translate-y: -258px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--257 {
            --translate-y: -257px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--256 {
            --translate-y: -256px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--255 {
            --translate-y: -255px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--254 {
            --translate-y: -254px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--253 {
            --translate-y: -253px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--252 {
            --translate-y: -252px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--251 {
            --translate-y: -251px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--250 {
            --translate-y: -250px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--249 {
            --translate-y: -249px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--248 {
            --translate-y: -248px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--247 {
            --translate-y: -247px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--246 {
            --translate-y: -246px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--245 {
            --translate-y: -245px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--244 {
            --translate-y: -244px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--243 {
            --translate-y: -243px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--242 {
            --translate-y: -242px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--241 {
            --translate-y: -241px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--240 {
            --translate-y: -240px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--239 {
            --translate-y: -239px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--238 {
            --translate-y: -238px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--237 {
            --translate-y: -237px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--236 {
            --translate-y: -236px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--235 {
            --translate-y: -235px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--234 {
            --translate-y: -234px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--233 {
            --translate-y: -233px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--232 {
            --translate-y: -232px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--231 {
            --translate-y: -231px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--230 {
            --translate-y: -230px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--229 {
            --translate-y: -229px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--228 {
            --translate-y: -228px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--227 {
            --translate-y: -227px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--226 {
            --translate-y: -226px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--225 {
            --translate-y: -225px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--224 {
            --translate-y: -224px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--223 {
            --translate-y: -223px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--222 {
            --translate-y: -222px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--221 {
            --translate-y: -221px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--220 {
            --translate-y: -220px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--219 {
            --translate-y: -219px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--218 {
            --translate-y: -218px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--217 {
            --translate-y: -217px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--216 {
            --translate-y: -216px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--215 {
            --translate-y: -215px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--214 {
            --translate-y: -214px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--213 {
            --translate-y: -213px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--212 {
            --translate-y: -212px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--211 {
            --translate-y: -211px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--210 {
            --translate-y: -210px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--209 {
            --translate-y: -209px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--208 {
            --translate-y: -208px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--207 {
            --translate-y: -207px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--206 {
            --translate-y: -206px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--205 {
            --translate-y: -205px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--204 {
            --translate-y: -204px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--203 {
            --translate-y: -203px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--202 {
            --translate-y: -202px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--201 {
            --translate-y: -201px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--200 {
            --translate-y: -200px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--199 {
            --translate-y: -199px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--198 {
            --translate-y: -198px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--197 {
            --translate-y: -197px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--196 {
            --translate-y: -196px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--195 {
            --translate-y: -195px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--194 {
            --translate-y: -194px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--193 {
            --translate-y: -193px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--192 {
            --translate-y: -192px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--191 {
            --translate-y: -191px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--190 {
            --translate-y: -190px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--189 {
            --translate-y: -189px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--188 {
            --translate-y: -188px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--187 {
            --translate-y: -187px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--186 {
            --translate-y: -186px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--185 {
            --translate-y: -185px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--184 {
            --translate-y: -184px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--183 {
            --translate-y: -183px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--182 {
            --translate-y: -182px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--181 {
            --translate-y: -181px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--180 {
            --translate-y: -180px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--179 {
            --translate-y: -179px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--178 {
            --translate-y: -178px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--177 {
            --translate-y: -177px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--176 {
            --translate-y: -176px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--175 {
            --translate-y: -175px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--174 {
            --translate-y: -174px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--173 {
            --translate-y: -173px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--172 {
            --translate-y: -172px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--171 {
            --translate-y: -171px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--170 {
            --translate-y: -170px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--169 {
            --translate-y: -169px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--168 {
            --translate-y: -168px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--167 {
            --translate-y: -167px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--166 {
            --translate-y: -166px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--165 {
            --translate-y: -165px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--164 {
            --translate-y: -164px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--163 {
            --translate-y: -163px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--162 {
            --translate-y: -162px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--161 {
            --translate-y: -161px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--160 {
            --translate-y: -160px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--159 {
            --translate-y: -159px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--158 {
            --translate-y: -158px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--157 {
            --translate-y: -157px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--156 {
            --translate-y: -156px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--155 {
            --translate-y: -155px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--154 {
            --translate-y: -154px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--153 {
            --translate-y: -153px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--152 {
            --translate-y: -152px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--151 {
            --translate-y: -151px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--150 {
            --translate-y: -150px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--149 {
            --translate-y: -149px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--148 {
            --translate-y: -148px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--147 {
            --translate-y: -147px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--146 {
            --translate-y: -146px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--145 {
            --translate-y: -145px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--144 {
            --translate-y: -144px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--143 {
            --translate-y: -143px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--142 {
            --translate-y: -142px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--141 {
            --translate-y: -141px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--140 {
            --translate-y: -140px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--139 {
            --translate-y: -139px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--138 {
            --translate-y: -138px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--137 {
            --translate-y: -137px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--136 {
            --translate-y: -136px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--135 {
            --translate-y: -135px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--134 {
            --translate-y: -134px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--133 {
            --translate-y: -133px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--132 {
            --translate-y: -132px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--131 {
            --translate-y: -131px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--130 {
            --translate-y: -130px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--129 {
            --translate-y: -129px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--128 {
            --translate-y: -128px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--127 {
            --translate-y: -127px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--126 {
            --translate-y: -126px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--125 {
            --translate-y: -125px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--124 {
            --translate-y: -124px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--123 {
            --translate-y: -123px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--122 {
            --translate-y: -122px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--121 {
            --translate-y: -121px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--120 {
            --translate-y: -120px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--119 {
            --translate-y: -119px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--118 {
            --translate-y: -118px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--117 {
            --translate-y: -117px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--116 {
            --translate-y: -116px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--115 {
            --translate-y: -115px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--114 {
            --translate-y: -114px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--113 {
            --translate-y: -113px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--112 {
            --translate-y: -112px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--111 {
            --translate-y: -111px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--110 {
            --translate-y: -110px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--109 {
            --translate-y: -109px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--108 {
            --translate-y: -108px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--107 {
            --translate-y: -107px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--106 {
            --translate-y: -106px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--105 {
            --translate-y: -105px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--104 {
            --translate-y: -104px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--103 {
            --translate-y: -103px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--102 {
            --translate-y: -102px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--101 {
            --translate-y: -101px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--100 {
            --translate-y: -100px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--99 {
            --translate-y: -99px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--98 {
            --translate-y: -98px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--97 {
            --translate-y: -97px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--96 {
            --translate-y: -96px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--95 {
            --translate-y: -95px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--94 {
            --translate-y: -94px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--93 {
            --translate-y: -93px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--92 {
            --translate-y: -92px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--91 {
            --translate-y: -91px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--90 {
            --translate-y: -90px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--89 {
            --translate-y: -89px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--88 {
            --translate-y: -88px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--87 {
            --translate-y: -87px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--86 {
            --translate-y: -86px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--85 {
            --translate-y: -85px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--84 {
            --translate-y: -84px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--83 {
            --translate-y: -83px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--82 {
            --translate-y: -82px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--81 {
            --translate-y: -81px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--80 {
            --translate-y: -80px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--79 {
            --translate-y: -79px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--78 {
            --translate-y: -78px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--77 {
            --translate-y: -77px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--76 {
            --translate-y: -76px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--75 {
            --translate-y: -75px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--74 {
            --translate-y: -74px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--73 {
            --translate-y: -73px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--72 {
            --translate-y: -72px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--71 {
            --translate-y: -71px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--70 {
            --translate-y: -70px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--69 {
            --translate-y: -69px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--68 {
            --translate-y: -68px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--67 {
            --translate-y: -67px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--66 {
            --translate-y: -66px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--65 {
            --translate-y: -65px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--64 {
            --translate-y: -64px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--63 {
            --translate-y: -63px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--62 {
            --translate-y: -62px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--61 {
            --translate-y: -61px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--60 {
            --translate-y: -60px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--59 {
            --translate-y: -59px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--58 {
            --translate-y: -58px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--57 {
            --translate-y: -57px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--56 {
            --translate-y: -56px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--55 {
            --translate-y: -55px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--54 {
            --translate-y: -54px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--53 {
            --translate-y: -53px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--52 {
            --translate-y: -52px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--51 {
            --translate-y: -51px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--50 {
            --translate-y: -50px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--49 {
            --translate-y: -49px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--48 {
            --translate-y: -48px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--47 {
            --translate-y: -47px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--46 {
            --translate-y: -46px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--45 {
            --translate-y: -45px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--44 {
            --translate-y: -44px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--43 {
            --translate-y: -43px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--42 {
            --translate-y: -42px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--41 {
            --translate-y: -41px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--40 {
            --translate-y: -40px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--39 {
            --translate-y: -39px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--38 {
            --translate-y: -38px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--37 {
            --translate-y: -37px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--36 {
            --translate-y: -36px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--35 {
            --translate-y: -35px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--34 {
            --translate-y: -34px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--33 {
            --translate-y: -33px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--32 {
            --translate-y: -32px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--31 {
            --translate-y: -31px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--30 {
            --translate-y: -30px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--29 {
            --translate-y: -29px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--28 {
            --translate-y: -28px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--27 {
            --translate-y: -27px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--26 {
            --translate-y: -26px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--25 {
            --translate-y: -25px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--24 {
            --translate-y: -24px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--23 {
            --translate-y: -23px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--22 {
            --translate-y: -22px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--21 {
            --translate-y: -21px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--20 {
            --translate-y: -20px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--19 {
            --translate-y: -19px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--18 {
            --translate-y: -18px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--17 {
            --translate-y: -17px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--16 {
            --translate-y: -16px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--15 {
            --translate-y: -15px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--14 {
            --translate-y: -14px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--13 {
            --translate-y: -13px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--12 {
            --translate-y: -12px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--11 {
            --translate-y: -11px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--10 {
            --translate-y: -10px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--9 {
            --translate-y: -9px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--8 {
            --translate-y: -8px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--7 {
            --translate-y: -7px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--6 {
            --translate-y: -6px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--5 {
            --translate-y: -5px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--4 {
            --translate-y: -4px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--3 {
            --translate-y: -3px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--2 {
            --translate-y: -2px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y--1 {
            --translate-y: -1px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-0 {
            --translate-y: 0px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-1 {
            --translate-y: 1px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-2 {
            --translate-y: 2px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-3 {
            --translate-y: 3px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-4 {
            --translate-y: 4px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-5 {
            --translate-y: 5px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-6 {
            --translate-y: 6px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-7 {
            --translate-y: 7px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-8 {
            --translate-y: 8px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-9 {
            --translate-y: 9px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-10 {
            --translate-y: 10px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-11 {
            --translate-y: 11px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-12 {
            --translate-y: 12px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-13 {
            --translate-y: 13px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-14 {
            --translate-y: 14px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-15 {
            --translate-y: 15px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-16 {
            --translate-y: 16px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-17 {
            --translate-y: 17px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-18 {
            --translate-y: 18px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-19 {
            --translate-y: 19px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-20 {
            --translate-y: 20px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-21 {
            --translate-y: 21px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-22 {
            --translate-y: 22px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-23 {
            --translate-y: 23px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-24 {
            --translate-y: 24px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-25 {
            --translate-y: 25px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-26 {
            --translate-y: 26px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-27 {
            --translate-y: 27px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-28 {
            --translate-y: 28px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-29 {
            --translate-y: 29px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-30 {
            --translate-y: 30px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-31 {
            --translate-y: 31px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-32 {
            --translate-y: 32px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-33 {
            --translate-y: 33px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-34 {
            --translate-y: 34px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-35 {
            --translate-y: 35px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-36 {
            --translate-y: 36px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-37 {
            --translate-y: 37px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-38 {
            --translate-y: 38px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-39 {
            --translate-y: 39px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-40 {
            --translate-y: 40px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-41 {
            --translate-y: 41px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-42 {
            --translate-y: 42px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-43 {
            --translate-y: 43px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-44 {
            --translate-y: 44px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-45 {
            --translate-y: 45px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-46 {
            --translate-y: 46px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-47 {
            --translate-y: 47px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-48 {
            --translate-y: 48px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-49 {
            --translate-y: 49px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.translate-y-50 {
            --translate-y: 50px; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-50 {
            --scale: 0.5; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-51 {
            --scale: 0.51; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-52 {
            --scale: 0.52; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-53 {
            --scale: 0.53; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-54 {
            --scale: 0.54; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-55 {
            --scale: 0.55; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-56 {
            --scale: 0.56; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-57 {
            --scale: 0.57; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-58 {
            --scale: 0.58; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-59 {
            --scale: 0.59; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-60 {
            --scale: 0.6; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-61 {
            --scale: 0.61; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-62 {
            --scale: 0.62; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-63 {
            --scale: 0.63; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-64 {
            --scale: 0.64; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-65 {
            --scale: 0.65; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-66 {
            --scale: 0.66; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-67 {
            --scale: 0.67; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-68 {
            --scale: 0.68; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-69 {
            --scale: 0.69; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-70 {
            --scale: 0.7; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-71 {
            --scale: 0.71; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-72 {
            --scale: 0.72; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-73 {
            --scale: 0.73; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-74 {
            --scale: 0.74; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-75 {
            --scale: 0.75; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-76 {
            --scale: 0.76; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-77 {
            --scale: 0.77; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-78 {
            --scale: 0.78; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-79 {
            --scale: 0.79; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-80 {
            --scale: 0.8; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-81 {
            --scale: 0.81; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-82 {
            --scale: 0.82; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-83 {
            --scale: 0.83; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-84 {
            --scale: 0.84; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-85 {
            --scale: 0.85; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-86 {
            --scale: 0.86; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-87 {
            --scale: 0.87; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-88 {
            --scale: 0.88; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-89 {
            --scale: 0.89; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-90 {
            --scale: 0.9; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-91 {
            --scale: 0.91; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-92 {
            --scale: 0.92; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-93 {
            --scale: 0.93; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-94 {
            --scale: 0.94; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-95 {
            --scale: 0.95; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-96 {
            --scale: 0.96; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-97 {
            --scale: 0.97; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-98 {
            --scale: 0.98; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-99 {
            --scale: 0.99; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-100 {
            --scale: 1; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-101 {
            --scale: 1.01; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-102 {
            --scale: 1.02; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-103 {
            --scale: 1.03; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-104 {
            --scale: 1.04; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-105 {
            --scale: 1.05; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-106 {
            --scale: 1.06; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-107 {
            --scale: 1.07; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-108 {
            --scale: 1.08; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-109 {
            --scale: 1.09; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-110 {
            --scale: 1.1; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-111 {
            --scale: 1.11; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-112 {
            --scale: 1.12; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-113 {
            --scale: 1.13; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-114 {
            --scale: 1.14; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-115 {
            --scale: 1.15; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-116 {
            --scale: 1.16; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-117 {
            --scale: 1.17; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-118 {
            --scale: 1.18; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-119 {
            --scale: 1.19; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-120 {
            --scale: 1.2; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-121 {
            --scale: 1.21; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-122 {
            --scale: 1.22; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-123 {
            --scale: 1.23; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-124 {
            --scale: 1.24; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-125 {
            --scale: 1.25; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-126 {
            --scale: 1.26; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-127 {
            --scale: 1.27; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-128 {
            --scale: 1.28; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-129 {
            --scale: 1.29; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-130 {
            --scale: 1.3; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-131 {
            --scale: 1.31; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-132 {
            --scale: 1.32; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-133 {
            --scale: 1.33; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-134 {
            --scale: 1.34; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-135 {
            --scale: 1.35; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-136 {
            --scale: 1.36; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-137 {
            --scale: 1.37; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-138 {
            --scale: 1.38; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-139 {
            --scale: 1.39; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-140 {
            --scale: 1.4; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-141 {
            --scale: 1.41; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-142 {
            --scale: 1.42; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-143 {
            --scale: 1.43; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-144 {
            --scale: 1.44; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-145 {
            --scale: 1.45; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-146 {
            --scale: 1.46; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-147 {
            --scale: 1.47; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-148 {
            --scale: 1.48; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-149 {
            --scale: 1.49; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-150 {
            --scale: 1.5; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-151 {
            --scale: 1.51; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-152 {
            --scale: 1.52; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-153 {
            --scale: 1.53; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-154 {
            --scale: 1.54; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-155 {
            --scale: 1.55; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-156 {
            --scale: 1.56; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-157 {
            --scale: 1.57; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-158 {
            --scale: 1.58; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-159 {
            --scale: 1.59; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-160 {
            --scale: 1.6; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-161 {
            --scale: 1.61; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-162 {
            --scale: 1.62; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-163 {
            --scale: 1.63; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-164 {
            --scale: 1.64; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-165 {
            --scale: 1.65; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-166 {
            --scale: 1.66; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-167 {
            --scale: 1.67; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-168 {
            --scale: 1.68; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-169 {
            --scale: 1.69; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-170 {
            --scale: 1.7; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-171 {
            --scale: 1.71; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-172 {
            --scale: 1.72; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-173 {
            --scale: 1.73; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-174 {
            --scale: 1.74; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-175 {
            --scale: 1.75; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-176 {
            --scale: 1.76; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-177 {
            --scale: 1.77; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-178 {
            --scale: 1.78; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-179 {
            --scale: 1.79; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-180 {
            --scale: 1.8; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-181 {
            --scale: 1.81; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-182 {
            --scale: 1.82; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-183 {
            --scale: 1.83; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-184 {
            --scale: 1.84; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-185 {
            --scale: 1.85; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-186 {
            --scale: 1.86; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-187 {
            --scale: 1.87; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-188 {
            --scale: 1.88; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-189 {
            --scale: 1.89; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-190 {
            --scale: 1.9; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-191 {
            --scale: 1.91; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-192 {
            --scale: 1.92; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-193 {
            --scale: 1.93; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-194 {
            --scale: 1.94; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-195 {
            --scale: 1.95; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-196 {
            --scale: 1.96; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-197 {
            --scale: 1.97; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-198 {
            --scale: 1.98; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-199 {
            --scale: 1.99; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-200 {
            --scale: 2; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-201 {
            --scale: 2.01; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-202 {
            --scale: 2.02; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-203 {
            --scale: 2.03; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-204 {
            --scale: 2.04; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-205 {
            --scale: 2.05; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-206 {
            --scale: 2.06; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-207 {
            --scale: 2.07; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-208 {
            --scale: 2.08; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-209 {
            --scale: 2.09; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-210 {
            --scale: 2.1; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-211 {
            --scale: 2.11; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-212 {
            --scale: 2.12; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-213 {
            --scale: 2.13; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-214 {
            --scale: 2.14; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-215 {
            --scale: 2.15; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-216 {
            --scale: 2.16; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-217 {
            --scale: 2.17; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-218 {
            --scale: 2.18; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-219 {
            --scale: 2.19; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-220 {
            --scale: 2.2; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-221 {
            --scale: 2.21; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-222 {
            --scale: 2.22; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-223 {
            --scale: 2.23; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-224 {
            --scale: 2.24; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-225 {
            --scale: 2.25; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-226 {
            --scale: 2.26; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-227 {
            --scale: 2.27; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-228 {
            --scale: 2.28; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-229 {
            --scale: 2.29; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-230 {
            --scale: 2.3; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-231 {
            --scale: 2.31; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-232 {
            --scale: 2.32; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-233 {
            --scale: 2.33; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-234 {
            --scale: 2.34; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-235 {
            --scale: 2.35; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-236 {
            --scale: 2.36; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-237 {
            --scale: 2.37; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-238 {
            --scale: 2.38; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-239 {
            --scale: 2.39; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-240 {
            --scale: 2.4; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-241 {
            --scale: 2.41; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-242 {
            --scale: 2.42; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-243 {
            --scale: 2.43; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-244 {
            --scale: 2.44; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-245 {
            --scale: 2.45; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-246 {
            --scale: 2.46; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-247 {
            --scale: 2.47; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-248 {
            --scale: 2.48; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-249 {
            --scale: 2.49; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-250 {
            --scale: 2.5; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-251 {
            --scale: 2.51; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-252 {
            --scale: 2.52; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-253 {
            --scale: 2.53; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-254 {
            --scale: 2.54; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-255 {
            --scale: 2.55; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-256 {
            --scale: 2.56; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-257 {
            --scale: 2.57; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-258 {
            --scale: 2.58; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-259 {
            --scale: 2.59; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-260 {
            --scale: 2.6; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-261 {
            --scale: 2.61; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-262 {
            --scale: 2.62; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-263 {
            --scale: 2.63; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-264 {
            --scale: 2.64; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-265 {
            --scale: 2.65; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-266 {
            --scale: 2.66; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-267 {
            --scale: 2.67; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-268 {
            --scale: 2.68; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-269 {
            --scale: 2.69; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-270 {
            --scale: 2.7; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-271 {
            --scale: 2.71; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-272 {
            --scale: 2.72; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-273 {
            --scale: 2.73; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-274 {
            --scale: 2.74; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-275 {
            --scale: 2.75; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-276 {
            --scale: 2.76; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-277 {
            --scale: 2.77; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-278 {
            --scale: 2.78; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-279 {
            --scale: 2.79; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-280 {
            --scale: 2.8; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-281 {
            --scale: 2.81; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-282 {
            --scale: 2.82; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-283 {
            --scale: 2.83; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-284 {
            --scale: 2.84; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-285 {
            --scale: 2.85; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-286 {
            --scale: 2.86; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-287 {
            --scale: 2.87; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-288 {
            --scale: 2.88; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-289 {
            --scale: 2.89; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-290 {
            --scale: 2.9; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-291 {
            --scale: 2.91; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-292 {
            --scale: 2.92; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-293 {
            --scale: 2.93; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-294 {
            --scale: 2.94; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-295 {
            --scale: 2.95; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-296 {
            --scale: 2.96; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-297 {
            --scale: 2.97; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-298 {
            --scale: 2.98; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-299 {
            --scale: 2.99; }
          .admin-block-container.create-event-template .discord .discord-banner .dropzone .image-preview.scale-300 {
            --scale: 3; }
        .admin-block-container.create-event-template .discord .discord-banner .dropzone.is-dragging {
          cursor: grabbing; }
      .admin-block-container.create-event-template .discord .discord-banner .zoom-slider {
        display: flex;
        width: 325px;
        margin: 8px auto 0px auto; }
    .admin-block-container.create-event-template .discord .discord-description {
      display: flex;
      width: -webkit-fill-available; }
      .admin-block-container.create-event-template .discord .discord-description .input-field {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 0 10px 0 20px; }
        .admin-block-container.create-event-template .discord .discord-description .input-field .home-file, .admin-block-container.create-event-template .discord .discord-description .input-field .character-counter {
          margin: 5px auto 5px 3px; }
  .admin-block-container.create-event-template .objectives-benefits-row {
    display: flex;
    gap: 10px;
    width: 100%;
    align-items: stretch;
    padding: 0 10px 10px; }
  .admin-block-container.create-event-template .template-objectives-preview,
  .admin-block-container.create-event-template .benefits-block {
    flex: 1 1 0;
    min-width: 0;
    background-color: #0c2637;
    border: 1px solid #b8b8b8;
    border-radius: 8px;
    padding: 10px; }
  .admin-block-container.create-event-template .template-objectives-preview {
    height: 150px;
    display: flex;
    flex-direction: column; }
    .admin-block-container.create-event-template .template-objectives-preview .template-objectives-preview-list {
      margin-top: 8px;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      gap: 5px; }
      .admin-block-container.create-event-template .template-objectives-preview .template-objectives-preview-list::-webkit-scrollbar {
        width: 6px; }
      .admin-block-container.create-event-template .template-objectives-preview .template-objectives-preview-list::-webkit-scrollbar-track {
        background: #2e3842;
        border-radius: 4px;
        padding-right: 1px; }
      .admin-block-container.create-event-template .template-objectives-preview .template-objectives-preview-list::-webkit-scrollbar-thumb {
        background-color: #491212;
        border-radius: 4px; }
        .admin-block-container.create-event-template .template-objectives-preview .template-objectives-preview-list::-webkit-scrollbar-thumb:hover {
          background-color: #200808; }
    .admin-block-container.create-event-template .template-objectives-preview .template-objectives-preview-row {
      display: grid;
      grid-template-columns: 24px 1fr 10px;
      gap: 6px;
      align-items: center; }
    .admin-block-container.create-event-template .template-objectives-preview .template-objectives-preview-order {
      text-align: right;
      opacity: 0.75; }
    .admin-block-container.create-event-template .template-objectives-preview .template-objectives-preview-critical {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #9e2222;
      justify-self: end; }

.mde-header {
  flex-shrink: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  border-bottom: 1px solid #c8ccd0;
  border-radius: 2px 2px 0 0;
  color: #dfdfdf;
  background: #0c2637;
  border: 1px solid #491212;
  border-radius: 6px 6px 0 0; }

.mde-header .mde-tabs {
  display: flex;
  flex-direction: row;
  color: #dfdfdf; }

.mde-header .mde-tabs button.selected {
  border: 1px solid #c8ccd0;
  color: #dfdfdf; }

.mde-header .mde-tabs button:first-child {
  color: #dfdfdf;
  margin-left: 6px; }

.mde-header .mde-tabs button {
  border-radius: 2px;
  margin: 6px 3px;
  color: #dfdfdf;
  background-color: transparent;
  border: 1px solid transparent;
  cursor: pointer; }

.react-mde * {
  box-sizing: border-box; }

.react-mde {
  border-radius: 6px;
  width: 100%; }

.mde-header ul.mde-header-group {
  margin: 0;
  padding: 10px;
  list-style: none;
  display: flex;
  flex-wrap: nowrap; }

.mde-header ul.mde-header-group li.mde-header-item {
  display: inline-block;
  position: relative;
  margin: 0 4px; }

.mde-header ul.mde-header-group li.mde-header-item button {
  text-align: left;
  cursor: pointer;
  height: 22px;
  padding: 4px;
  margin: 0;
  border: none;
  background: none;
  color: #dfdfdf; }

.mde-header .svg-icon {
  width: 1em;
  height: 1em;
  display: inline-block;
  font-size: inherit;
  overflow: visible;
  vertical-align: -.125em; }

.react-mde .mde-textarea-wrapper, .react-mde-tabbed-layout .mde-textarea-wrapper {
  color: green;
  position: relative; }
  .react-mde .mde-textarea-wrapper .mde-text, .react-mde-tabbed-layout .mde-textarea-wrapper .mde-text {
    color: #dfdfdf;
    background: #1c2d38;
    width: 100%;
    height: 130px !important;
    font-family: 'Lato';
    font-size: 1em;
    border: 1px solid #491212 !important;
    border-radius: 0px 0px 6px 6px; }
    .react-mde .mde-textarea-wrapper .mde-text::-webkit-scrollbar, .react-mde-tabbed-layout .mde-textarea-wrapper .mde-text::-webkit-scrollbar {
      width: 6px; }
    .react-mde .mde-textarea-wrapper .mde-text::-webkit-scrollbar-track, .react-mde-tabbed-layout .mde-textarea-wrapper .mde-text::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .react-mde .mde-textarea-wrapper .mde-text::-webkit-scrollbar-thumb, .react-mde-tabbed-layout .mde-textarea-wrapper .mde-text::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .react-mde .mde-textarea-wrapper .mde-text::-webkit-scrollbar-thumb:hover, .react-mde-tabbed-layout .mde-textarea-wrapper .mde-text::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
    .react-mde .mde-textarea-wrapper .mde-text:focus-visible, .react-mde-tabbed-layout .mde-textarea-wrapper .mde-text:focus-visible {
      outline: #491212; }
  .react-mde .mde-textarea-wrapper textarea, .react-mde-tabbed-layout .mde-textarea-wrapper textarea {
    resize: none;
    padding: 10px; }

.react-mde .invisible {
  display: none; }

.mde-preview {
  height: 130px !important;
  min-height: 130px !important;
  color: #dfdfdf;
  background: #1c2d38;
  border: 1px solid #491212 !important;
  border-radius: 0px 0px 6px 6px;
  margin-bottom: 5px;
  overflow: auto; }
  .mde-preview::-webkit-scrollbar {
    width: 6px; }
  .mde-preview::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .mde-preview::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .mde-preview::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }

.mde-preview .mde-preview-content {
  position: relative;
  padding: 0px 10px;
  bottom: 5px; }
  .mde-preview .mde-preview-content .p {
    margin-top: 0; }

/* Compte à rebours claim lock — aligné sur \`.benefits-uec-input-shell\` : une coque, bandeau libellé (type « UEC »), heure en zone sombre (type champ). */
.benefits-countdown-digital {
  box-sizing: border-box; }

.benefits-countdown-digital--claim-lock {
  display: inline-flex;
  margin-top: 0;
  min-width: 0;
  max-width: 100%; }

.benefits-countdown-digital__shell {
  display: flex;
  align-items: stretch;
  flex: 1 1 auto;
  min-width: 0;
  max-width: 100%;
  width: 100%;
  background: #0c2637;
  border: 1px solid #384858;
  border-radius: 6px;
  overflow: hidden; }

/* Bandeau libellé : mêmes tons que \`.benefits-block .benefits-uec-input-unit\` */
.benefits-countdown-digital__label {
  display: flex;
  align-items: center;
  flex: 0 1 auto;
  min-width: 0;
  max-width: 55%;
  padding: 5px 10px;
  margin: 0;
  background: rgba(56, 72, 88, 0.25);
  border-right: 1px solid rgba(56, 72, 88, 0.6);
  color: #dfdfdf;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1.2;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none; }

/* Heure : zone principale sombre — équivalent visuel du montant UEC mais fond \`\$grey\` (pas \`\$light-panel-blue\`) */
.benefits-countdown-digital__time {
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  width: 85px;
  padding: 5px 10px;
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  font-family: "GoodTimes";
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.03em;
  line-height: 1.2;
  color: #dfdfdf;
  background: #133b53;
  border: 0;
  text-align: left; }

.benefits-countdown-digital--steady .benefits-countdown-digital__shell {
  border-color: #384858; }

.benefits-countdown-digital--warning .benefits-countdown-digital__shell {
  border-color: #c78445; }

.benefits-countdown-digital--warning .benefits-countdown-digital__label {
  color: #d8b493; }

.benefits-countdown-digital--warning .benefits-countdown-digital__time {
  color: #d8b493;
  background: #133b53; }

.benefits-countdown-digital--critical .benefits-countdown-digital__shell {
  border-color: #d12323; }

.benefits-countdown-digital--critical .benefits-countdown-digital__label {
  color: #dfdfdf; }

.benefits-countdown-digital--critical .benefits-countdown-digital__time {
  color: #ffffff;
  background: #133b53; }

.benefits-countdown-digital--locked .benefits-countdown-digital__shell--locked {
  justify-content: center;
  padding: 5px 12px;
  border-color: #7e1e1e; }

.benefits-countdown-digital__locked-label {
  display: block;
  width: 100%;
  text-align: center;
  color: #dfdfdf;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  line-height: 1.2;
  text-transform: uppercase;
  user-select: none; }

.benefits-countdown-digital__amount {
  font-size: 0.8rem;
  font-weight: 600; }

.calendar-event-benefits-countdown {
  margin-top: 0.35rem;
  margin-bottom: 0.25rem; }

.header-with-toggle .report-event-benefits-countdown {
  width: 100%; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.event-planner {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
  gap: 1rem;
  min-height: 500px; }

.event-planner__workspace,
.event-planner__vehicles {
  min-width: 0;
  padding: 1rem 1.1rem;
  border: 1px solid rgba(58, 120, 180, 0.45);
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(0, 48, 77, 0.82), rgba(21, 28, 36, 0.55)), rgba(0, 48, 77, 0.65);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.22); }

.event-planner__panel-header,
.event-planner__table-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem; }
  .event-planner__panel-header h3,
  .event-planner__table-heading h3 {
    margin: 0;
    color: #dfdfdf;
    font-size: 0.95rem;
    font-weight: 600;
    line-height: 1.35; }

.event-planner__panel-header {
  margin-bottom: 0.85rem;
  padding-bottom: 0.85rem;
  border-bottom: 1px solid rgba(58, 120, 180, 0.28); }

.event-planner__eyebrow {
  margin: 0 0 0.25rem;
  color: rgba(223, 223, 223, 0.55);
  font-size: 0.68rem;
  letter-spacing: 0.08em;
  text-transform: uppercase; }

.event-planner__vehicle-count,
.event-planner__position-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 1.65rem;
  padding: 0.15rem 0.55rem;
  border: 1px solid rgba(58, 120, 180, 0.35);
  border-radius: 999px;
  color: #5ac3ff;
  background: rgba(58, 120, 180, 0.16);
  font-family: 'FiraCode', monospace;
  font-size: 0.72rem;
  white-space: nowrap; }

.event-planner__toolbar {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-bottom: 0.75rem;
  padding: 0.7rem;
  border: 1px solid rgba(58, 120, 180, 0.35);
  border-radius: 10px;
  background: rgba(0, 48, 77, 0.52); }

.event-planner__vehicle-size-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem; }

.event-planner__vehicle-size-filter {
  padding: 0.28rem 0.55rem;
  border: 1px solid rgba(58, 120, 180, 0.28);
  border-radius: 999px;
  color: rgba(223, 223, 223, 0.82);
  background: rgba(23, 39, 56, 0.72);
  font-family: inherit;
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: capitalize;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease; }
  .event-planner__vehicle-size-filter:hover {
    border-color: rgba(90, 195, 255, 0.42);
    color: #ffffff;
    background: rgba(22, 52, 71, 0.72); }
  .event-planner__vehicle-size-filter.is-active {
    border-color: rgba(90, 195, 255, 0.55);
    color: #5ac3ff;
    background: rgba(0, 72, 114, 0.42); }

.event-planner__in-concept-toggle {
  justify-content: space-between;
  width: 100%;
  margin-top: 0.15rem;
  padding-top: 0.45rem;
  border-top: 1px solid rgba(58, 120, 180, 0.22); }
  .event-planner__in-concept-toggle .toggle-label {
    color: rgba(223, 223, 223, 0.82);
    font-size: 0.72rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: capitalize; }

.event-planner__vehicle-search,
.event-planner__add-position-row input,
.event-planner__edit-position-input {
  width: 100%;
  padding: 0.45rem 0.65rem;
  border: 1px solid rgba(58, 120, 180, 0.45);
  border-radius: 8px;
  outline: none;
  color: #dfdfdf;
  background: rgba(0, 48, 77, 0.65);
  font-family: inherit;
  font-size: 0.84rem; }
  .event-planner__vehicle-search:focus,
  .event-planner__add-position-row input:focus,
  .event-planner__edit-position-input:focus {
    border-color: rgba(90, 195, 255, 0.75);
    box-shadow: 0 0 0 2px rgba(58, 120, 180, 0.14); }

.event-planner__vehicle-list {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  max-height: calc(100vh - 800px);
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.5) rgba(0, 48, 77, 0.45); }
  .event-planner__vehicle-list::-webkit-scrollbar {
    width: 4px; }
  .event-planner__vehicle-list::-webkit-scrollbar-track {
    background: rgba(0, 48, 77, 0.45);
    border-radius: 999px; }
  .event-planner__vehicle-list::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.48);
    border-radius: 999px; }

.event-planner__special-list {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin-bottom: 0.85rem;
  padding-bottom: 0.85rem;
  border-bottom: 1px solid rgba(58, 120, 180, 0.28); }

.event-planner__special {
  min-height: 2.65rem; }

.event-planner__vehicle {
  position: relative;
  width: 100%;
  padding: 0.65rem 0.75rem;
  border: 1px solid rgba(58, 120, 180, 0.2);
  border-radius: 8px;
  color: rgba(223, 223, 223, 0.82);
  background: rgba(0, 48, 77, 0.42);
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease; }
  .event-planner__vehicle:hover {
    border-color: rgba(58, 120, 180, 0.5);
    background: rgba(58, 120, 180, 0.1);
    color: #dfdfdf; }
  .event-planner__vehicle.is-selected {
    padding-left: 0.9rem;
    border-color: rgba(58, 120, 180, 0.7);
    background: rgba(58, 120, 180, 0.18);
    color: #ffffff;
    box-shadow: inset 3px 0 0 rgba(58, 120, 180, 0.85); }

.event-planner__vehicle-main {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.65rem; }

.event-planner__vehicle-name {
  min-width: 0;
  overflow: hidden;
  color: inherit;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap; }

.event-planner__vehicle-focus {
  display: block;
  margin-top: 0.25rem;
  overflow: hidden;
  color: rgba(223, 223, 223, 0.55);
  font-size: 0.72rem;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap; }

.event-planner__prod-state {
  flex-shrink: 0;
  padding: 0.14rem 0.42rem;
  border: 1px solid;
  border-radius: 999px;
  font-size: 0.62rem;
  font-weight: 600;
  letter-spacing: 0.035em;
  line-height: 1.25;
  text-transform: uppercase;
  white-space: nowrap; }
  .event-planner__prod-state.is-flight-ready {
    border-color: rgba(117, 207, 120, 0.42);
    color: #c2f0c3;
    background: rgba(90, 160, 92, 0.18); }
  .event-planner__prod-state.is-other {
    border-color: rgba(199, 132, 69, 0.48);
    color: #d8b493;
    background: rgba(155, 96, 42, 0.2); }

.event-planner__message,
.event-planner__empty-state p {
  margin: 0;
  color: rgba(223, 223, 223, 0.55);
  font-size: 0.85rem;
  text-align: center; }

.event-planner__empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 250px;
  border: 1px dashed rgba(58, 120, 180, 0.35);
  border-radius: 12px;
  background: rgba(0, 48, 77, 0.25); }

.event-planner__team-names-table {
  margin-top: 0.25rem;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(58, 120, 180, 0.28); }

.event-planner__positions-table {
  margin-top: 0.25rem; }

.event-planner__save-row--compact {
  margin-top: 0.65rem; }

.event-planner__table-heading {
  margin-bottom: 0.75rem; }

.event-planner__table-wrap {
  max-height: calc(100vh - 725px);
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.5) rgba(0, 48, 77, 0.45);
  border: 1px solid rgba(58, 120, 180, 0.28);
  border-radius: 12px;
  background: rgba(0, 48, 77, 0.38); }
  .event-planner__table-wrap::-webkit-scrollbar {
    width: 4px; }
  .event-planner__table-wrap::-webkit-scrollbar-track {
    background: rgba(0, 48, 77, 0.45);
    border-radius: 999px; }
  .event-planner__table-wrap::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.48);
    border-radius: 999px; }
  .event-planner__table-wrap table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    font-size: 0.82rem; }
  .event-planner__table-wrap col.col-drag {
    width: 48px; }
  .event-planner__table-wrap col.col-number {
    width: 52px; }
  .event-planner__table-wrap col.col-command {
    width: 44px; }
  .event-planner__table-wrap col.col-actions {
    width: 88px; }
  .event-planner__table-wrap col.col-swappable {
    width: 108px; }
  .event-planner__table-wrap th,
  .event-planner__table-wrap td {
    padding: 0.65rem 0.75rem;
    border-bottom: 1px solid rgba(56, 72, 88, 0.65);
    color: #dfdfdf;
    text-align: left;
    vertical-align: middle; }
  .event-planner__table-wrap th {
    position: sticky;
    top: 0;
    z-index: 2;
    color: rgba(223, 223, 223, 0.62);
    background: rgba(21, 28, 36, 0.95);
    font-size: 0.68rem;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase; }
  .event-planner__table-wrap th.header-number,
  .event-planner__table-wrap td.cell-number,
  .event-planner__table-wrap th.header-drag,
  .event-planner__table-wrap td.cell-drag,
  .event-planner__table-wrap th.header-command,
  .event-planner__table-wrap td.cell-command,
  .event-planner__table-wrap th.header-actions,
  .event-planner__table-wrap td.cell-actions,
  .event-planner__table-wrap th.header-swappable,
  .event-planner__table-wrap td.cell-swappable {
    text-align: center; }
  .event-planner__table-wrap tbody tr {
    background: transparent;
    transition: background 0.15s ease; }
    .event-planner__table-wrap tbody tr:hover {
      background: rgba(58, 120, 180, 0.08); }
    .event-planner__table-wrap tbody tr:last-child td {
      border-bottom: 0; }
    .event-planner__table-wrap tbody tr.is-dragging {
      position: relative;
      z-index: 2;
      opacity: 0.82;
      background: rgba(58, 120, 180, 0.18);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3); }

.event-planner__drag-handle {
  width: 1.75rem;
  height: 1.75rem;
  padding: 0;
  border: 1px solid rgba(58, 120, 180, 0.3);
  border-radius: 6px;
  color: rgba(223, 223, 223, 0.72);
  background: rgba(21, 28, 36, 0.45);
  font-size: 1.1rem;
  line-height: 1;
  cursor: grab;
  touch-action: none; }
  .event-planner__drag-handle:hover {
    border-color: rgba(58, 120, 180, 0.65);
    color: #5ac3ff;
    background: rgba(58, 120, 180, 0.14); }
  .event-planner__drag-handle:active {
    cursor: grabbing; }

.event-planner__edit-position {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  padding: 0;
  border: 1px solid rgba(58, 120, 180, 0.3);
  border-radius: 6px;
  color: rgba(223, 223, 223, 0.72);
  background: rgba(21, 28, 36, 0.45);
  font-size: 0.95rem;
  line-height: 1;
  cursor: pointer; }
  .event-planner__edit-position:hover {
    border-color: rgba(58, 120, 180, 0.65);
    color: #5ac3ff;
    background: rgba(58, 120, 180, 0.14); }
  .event-planner__edit-position:disabled {
    opacity: 0.5;
    cursor: default; }

.event-planner__row-actions {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem; }

.event-planner__row-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  padding: 0;
  border: 1px solid rgba(58, 120, 180, 0.3);
  border-radius: 6px;
  color: rgba(223, 223, 223, 0.72);
  background: rgba(21, 28, 36, 0.45);
  font-size: 0.95rem;
  line-height: 1;
  cursor: pointer; }
  .event-planner__row-action:hover:not(:disabled) {
    border-color: rgba(58, 120, 180, 0.65);
    color: #5ac3ff;
    background: rgba(58, 120, 180, 0.14); }
  .event-planner__row-action:disabled {
    opacity: 0.5;
    cursor: default; }

.event-planner__row-action--delete:hover:not(:disabled) {
  border-color: rgba(209, 35, 35, 0.55);
  color: #d12323;
  background: rgba(209, 35, 35, 0.12); }

.event-planner__delete-media {
  width: 1rem;
  height: 1rem;
  margin: 0;
  transform: none; }

.event-planner__command-position-toggle {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  padding: 0;
  border: 1px solid rgba(58, 120, 180, 0.22);
  border-radius: 6px;
  background: rgba(21, 28, 36, 0.45);
  color: rgba(223, 223, 223, 0.62);
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease; }
  .event-planner__command-position-toggle:hover:not(:disabled), .event-planner__command-position-toggle:focus-visible:not(:disabled) {
    border-color: rgba(170, 158, 116, 0.55);
    color: #aa9e74; }
  .event-planner__command-position-toggle.is-active {
    border-color: rgba(170, 158, 116, 0.65);
    background: rgba(66, 38, 12, 0.35);
    color: #aa9e74; }
  .event-planner__command-position-toggle:disabled {
    opacity: 0.5;
    cursor: default; }

.event-planner__command-position-toggle-icon {
  width: 0.82rem;
  height: 0.82rem; }

.event-planner__swappable-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto; }

.event-planner__edit-position-input {
  box-sizing: border-box; }

.event-planner__add-position-row {
  background: rgba(58, 120, 180, 0.04) !important; }
  .event-planner__add-position-row td {
    position: sticky;
    bottom: 0;
    z-index: 2;
    background: rgba(0, 48, 77, 0.92);
    border-top: 1px solid rgba(56, 72, 88, 0.65); }
  .event-planner__add-position-row input {
    box-sizing: border-box; }

.event-planner__save-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem 1rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(58, 120, 180, 0.28); }

.event-planner__save-message {
  margin: 0;
  color: #5ac3ff;
  font-size: 0.82rem; }

.event-planner__save-message--error {
  color: #d12323; }

.event-planner__save-hint {
  margin: 0;
  color: rgba(223, 223, 223, 0.55);
  font-size: 0.78rem; }

@media (max-width: 800px) {
  .event-planner {
    grid-template-columns: 1fr; }
  .event-planner__vehicles {
    order: -1; } }

.event-planner-view {
  --event-planner-position-column-width: 280px;
  --event-planner-team-max-width: 300px;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  min-height: 500px;
  padding: 0.7rem 0.85rem;
  color: #dfdfdf;
  background: linear-gradient(180deg, rgba(12, 38, 55, 0.98), rgba(23, 39, 56, 0.92)), #0c2637; }
  .event-planner-view--readonly .event-planner-view__drag-hint {
    display: none; }

.event-planner-view__header {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding-bottom: 0.65rem;
  border-bottom: 1px solid rgba(58, 120, 180, 0.32); }

.event-planner-view__header-main-row {
  display: grid;
  grid-template-columns: 300px minmax(0, 1fr) auto;
  align-items: start;
  gap: 0.85rem 1rem; }

.event-planner-view__header-info {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  width: 300px;
  max-width: 300px;
  min-width: 0; }
  .event-planner-view__header-info h2 {
    margin: 0;
    min-width: 0;
    overflow: hidden;
    color: #ffffff;
    font-size: 1.15rem;
    font-weight: 600;
    line-height: 1.35;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap; }

.event-planner-view__header-toolbar {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.4rem;
  min-width: 0; }

.event-planner-view__header-toolbar-main {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  min-width: 0; }

.event-planner-view__header-toolbar-stats {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem; }

.event-planner-view__header-stat-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.32rem;
  padding: 0.26rem 0.58rem;
  border: 1px solid rgba(58, 120, 180, 0.34);
  border-radius: 999px;
  background: rgba(23, 39, 56, 0.78);
  color: #747b81;
  font-size: 0.7rem;
  line-height: 1.2;
  white-space: nowrap; }

.event-planner-view__header-stat-chip-icon {
  flex-shrink: 0;
  width: 0.75rem;
  height: 0.75rem;
  color: #5ac3ff; }

.event-planner-view__header-stat-chip-label {
  color: inherit; }

.event-planner-view__header-stat-chip--filled {
  border-color: rgba(90, 195, 255, 0.38);
  background: rgba(0, 72, 114, 0.32);
  color: #dfdfdf; }

.event-planner-view__header-stat-chip--open {
  border-color: rgba(116, 123, 129, 0.28);
  background: rgba(12, 38, 55, 0.55);
  color: #747b81; }

.event-planner-view__header-stat-chip--assigned {
  border-color: rgba(117, 207, 120, 0.38);
  background: rgba(117, 207, 120, 0.1);
  color: #75cf78; }
  .event-planner-view__header-stat-chip--assigned .event-planner-view__header-stat-chip-icon {
    color: #75cf78; }

.event-planner-view__header-search {
  flex: 0 1 300px;
  width: 100%;
  max-width: 400px;
  min-width: 0;
  margin-bottom: 0; }

.event-planner-view__fleet-assignment-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.35rem;
  margin-bottom: 0.45rem; }

.event-planner-view__bulk-expand-toggle {
  display: inline-flex;
  flex-shrink: 0;
  align-items: stretch;
  margin-left: auto;
  padding: 0.14rem;
  border: 1px solid rgba(58, 120, 180, 0.42);
  border-radius: 9px;
  background: rgba(0, 48, 77, 0.62);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
  gap: 0.14rem; }

.event-planner-view__bulk-expand-toggle-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.32rem;
  padding: 0.3rem 0.55rem;
  border: 0;
  border-radius: 7px;
  color: #747b81;
  background: transparent;
  font-size: 0.68rem;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  transition: background 160ms ease, color 160ms ease, box-shadow 160ms ease; }
  .event-planner-view__bulk-expand-toggle-btn:hover:not(.is-active) {
    color: #dfdfdf;
    background: rgba(255, 255, 255, 0.06); }
  .event-planner-view__bulk-expand-toggle-btn.is-active {
    color: #ffffff;
    background: rgba(0, 72, 114, 0.72);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.28), inset 0 1px 0 rgba(255, 255, 255, 0.1); }

.event-planner-view__bulk-expand-toggle-icon {
  display: block;
  width: 12px;
  height: 12px;
  object-fit: contain;
  opacity: 0.95; }

@media (max-width: 1100px) {
  .event-planner-view__bulk-expand-toggle-label {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0; } }

.event-planner-view__header-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem; }
  .event-planner-view__header-title-row h2 {
    margin: 0;
    min-width: 0;
    flex: 1;
    overflow: hidden;
    color: #ffffff;
    font-size: 1.15rem;
    font-weight: 600;
    line-height: 1.35;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap; }

.event-planner-view__header-actions-column {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.35rem; }

.event-planner-view__header-actions {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 0.4rem; }

.event-planner-view__header-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.38rem;
  margin: 0;
  padding: 0.42rem 0.78rem;
  border: 1px solid rgba(58, 120, 180, 0.42);
  border-radius: 8px;
  background: rgba(23, 39, 56, 0.72);
  color: #dfdfdf;
  font-family: inherit;
  font-size: 0.72rem;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
  transition: background 160ms ease, border-color 160ms ease, color 160ms ease, box-shadow 160ms ease; }
  .event-planner-view__header-action-btn:hover:not(:disabled) {
    border-color: rgba(90, 195, 255, 0.55);
    background: rgba(22, 52, 71, 0.88);
    color: #ffffff; }
  .event-planner-view__header-action-btn:active:not(:disabled) {
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.28); }
  .event-planner-view__header-action-btn:disabled {
    opacity: 0.55;
    cursor: not-allowed; }

.event-planner-view__header-action-btn--publish {
  border-color: rgba(90, 195, 255, 0.48);
  background: rgba(0, 72, 114, 0.58);
  color: #ffffff; }
  .event-planner-view__header-action-btn--publish:hover:not(:disabled) {
    border-color: rgba(90, 195, 255, 0.72);
    background: rgba(0, 72, 114, 0.78);
    color: #ffffff; }
  .event-planner-view__header-action-btn--publish.is-published {
    border-color: rgba(117, 207, 120, 0.58);
    background: rgba(117, 207, 120, 0.14);
    color: #75cf78; }
    .event-planner-view__header-action-btn--publish.is-published:hover:not(:disabled) {
      border-color: #75cf78;
      background: rgba(117, 207, 120, 0.22);
      color: #75cf78; }

.event-planner-view__header-action-btn--back {
  background: rgba(0, 48, 77, 0.55); }

.event-planner-view__header-action-btn-icon {
  flex-shrink: 0;
  width: 0.9rem;
  height: 0.9rem; }

.event-planner-view__header-close-btn {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(58, 120, 180, 0.28);
  border-radius: 8px;
  color: #747b81;
  background: rgba(23, 39, 56, 0.45);
  font-family: inherit;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1;
  cursor: pointer;
  transition: background 160ms ease, border-color 160ms ease, color 160ms ease; }
  .event-planner-view__header-close-btn:hover {
    border-color: rgba(90, 195, 255, 0.45);
    background: rgba(22, 52, 71, 0.75);
    color: #ffffff; }
  .event-planner-view__header-close-btn:active {
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.28); }

.event-planner-view__team-tags {
  position: relative;
  align-self: flex-end; }

.event-planner-view__team-tags-toggle {
  border-color: rgba(58, 120, 180, 0.38);
  background: rgba(23, 39, 56, 0.62); }
  .event-planner-view__team-tags-toggle:hover:not(:disabled) {
    border-color: rgba(90, 195, 255, 0.55);
    background: rgba(22, 52, 71, 0.82); }

.event-planner-view__team-tags-toggle-icon {
  flex-shrink: 0;
  width: 0.82rem;
  height: 0.82rem;
  color: #5ac3ff; }

.event-planner-view__team-tags-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.1rem;
  padding: 0.05rem 0.32rem;
  border-radius: 999px;
  background: rgba(90, 195, 255, 0.2);
  color: #dfdfdf;
  font-size: 0.62rem;
  font-weight: 700;
  line-height: 1.2; }

.event-planner-view__team-tags-panel {
  position: absolute;
  top: calc(100% + 0.35rem);
  right: 0;
  z-index: 60;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  width: min(22rem, calc(100vw - 2rem));
  padding: 0.85rem;
  border: 1px solid rgba(58, 120, 180, 0.45);
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(22, 52, 71, 0.98), rgba(23, 39, 56, 0.98));
  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.48); }

.event-planner-view__team-tags-panel-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem; }

.event-planner-view__team-tags-eyebrow {
  margin: 0 0 0.15rem;
  color: #5ac3ff;
  font-size: 0.62rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase; }

.event-planner-view__team-tags-title {
  margin: 0;
  color: #ffffff;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.25; }

.event-planner-view__team-tags-panel-count {
  flex-shrink: 0;
  padding: 0.2rem 0.5rem;
  border-radius: 999px;
  border: 1px solid rgba(58, 120, 180, 0.35);
  background: rgba(23, 39, 56, 0.72);
  color: #747b81;
  font-size: 0.64rem;
  white-space: nowrap; }

.event-planner-view__team-tags-hint {
  margin: 0;
  color: #747b81;
  font-size: 0.68rem;
  line-height: 1.45; }

.event-planner-view__team-tags-list {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  max-height: 14rem;
  margin: 0;
  padding: 0;
  overflow: auto;
  list-style: none;
  margin-right: -10px;
  padding-right: 10px;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.35) rgba(0, 0, 0, 0.12); }
  .event-planner-view__team-tags-list::-webkit-scrollbar {
    width: 6px; }
  .event-planner-view__team-tags-list::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.12);
    border-radius: 999px; }
  .event-planner-view__team-tags-list::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.3);
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.08); }
  .event-planner-view__team-tags-list::-webkit-scrollbar-thumb:hover {
    background: rgba(58, 120, 180, 0.42); }

.event-planner-view__team-tags-empty {
  padding: 0.55rem 0.65rem;
  border: 1px dashed rgba(58, 120, 180, 0.28);
  border-radius: 8px;
  color: #747b81;
  font-size: 0.72rem;
  text-align: center; }

.event-planner-view__team-tags-item {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.2rem;
  border-radius: 8px;
  background: rgba(23, 39, 56, 0.55);
  border: 1px solid rgba(58, 120, 180, 0.22); }

.event-planner-view__team-tags-label {
  flex: 1;
  min-width: 0;
  margin: 0;
  padding: 0.35rem 0.45rem;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #dfdfdf;
  font-family: inherit;
  font-size: 0.74rem;
  font-weight: 500;
  line-height: 1.3;
  text-align: left;
  cursor: pointer;
  transition: background 160ms ease, color 160ms ease; }
  .event-planner-view__team-tags-label:hover:not(:disabled) {
    background: rgba(0, 72, 114, 0.22);
    color: #ffffff; }
  .event-planner-view__team-tags-label:disabled {
    cursor: default; }

.event-planner-view__team-tag-input {
  flex: 1;
  min-width: 0;
  margin: 0;
  padding: 0.35rem 0.45rem;
  border: 1px solid rgba(90, 195, 255, 0.45);
  border-radius: 6px;
  background: rgba(12, 38, 55, 0.55);
  color: #ffffff;
  font-family: inherit;
  font-size: 0.74rem;
  line-height: 1.3; }
  .event-planner-view__team-tag-input:focus {
    outline: none;
    border-color: rgba(90, 195, 255, 0.72);
    box-shadow: 0 0 0 2px rgba(90, 195, 255, 0.18); }

.event-planner-view__team-tags-delete {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 1.6rem;
  height: 1.6rem;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(158, 34, 34, 0.28);
  border-radius: 6px;
  background: rgba(158, 34, 34, 0.08);
  color: #d12323;
  font-family: inherit;
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
  transition: background 160ms ease, border-color 160ms ease, color 160ms ease; }
  .event-planner-view__team-tags-delete:hover:not(:disabled) {
    border-color: rgba(158, 34, 34, 0.55);
    background: rgba(158, 34, 34, 0.18);
    color: #ffffff; }
  .event-planner-view__team-tags-delete:disabled {
    opacity: 0.45;
    cursor: not-allowed; }

.event-planner-view__team-tags-add-row {
  display: flex;
  align-items: center;
  gap: 0.4rem; }

.event-planner-view__team-tags-add-btn {
  flex-shrink: 0;
  margin: 0;
  padding: 0.38rem 0.72rem;
  border: 1px solid rgba(90, 195, 255, 0.45);
  border-radius: 8px;
  background: rgba(0, 72, 114, 0.42);
  color: #ffffff;
  font-family: inherit;
  font-size: 0.7rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 160ms ease, border-color 160ms ease; }
  .event-planner-view__team-tags-add-btn:hover:not(:disabled) {
    border-color: rgba(90, 195, 255, 0.72);
    background: rgba(0, 72, 114, 0.62); }
  .event-planner-view__team-tags-add-btn:disabled {
    opacity: 0.45;
    cursor: not-allowed; }

.event-planner-view__team-tags-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.45rem;
  padding-top: 0.15rem;
  border-top: 1px solid rgba(58, 120, 180, 0.22); }

.event-planner-view__team-tags-save-btn {
  margin: 0;
  padding: 0.4rem 0.85rem;
  border: 1px solid rgba(117, 207, 120, 0.45);
  border-radius: 8px;
  background: rgba(117, 207, 120, 0.14);
  color: #75cf78;
  font-family: inherit;
  font-size: 0.7rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 160ms ease, border-color 160ms ease, color 160ms ease; }
  .event-planner-view__team-tags-save-btn:hover:not(:disabled) {
    border-color: #75cf78;
    background: rgba(117, 207, 120, 0.24);
    color: #ffffff; }
  .event-planner-view__team-tags-save-btn:disabled {
    opacity: 0.45;
    cursor: not-allowed; }

.event-planner-view__team-tags-status {
  margin: 0;
  color: #75cf78;
  font-size: 0.68rem; }

.event-planner-view__team-tags-status--error {
  color: #d12323; }

.event-planner-view__anchor-tag-menu {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end; }

.event-planner-view__anchor-tag-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  margin: 0;
  padding: 0.18rem 0.34rem;
  border: 1px solid rgba(58, 120, 180, 0.32);
  border-radius: 6px;
  background: rgba(23, 39, 56, 0.55);
  color: #5ac3ff;
  font-family: inherit;
  font-size: 0.58rem;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  transition: background 160ms ease, border-color 160ms ease, color 160ms ease, box-shadow 160ms ease; }
  .event-planner-view__anchor-tag-toggle:hover {
    border-color: rgba(90, 195, 255, 0.55);
    background: rgba(0, 72, 114, 0.28);
    color: #ffffff; }
  .event-planner-view__anchor-tag-toggle.is-active {
    border-color: rgba(199, 132, 69, 0.72);
    background: rgba(155, 96, 42, 0.28);
    color: #aa9e74;
    box-shadow: 0 0 0 1px rgba(199, 132, 69, 0.18); }
    .event-planner-view__anchor-tag-toggle.is-active .event-planner-view__anchor-tag-toggle-icon {
      color: #c78445; }
    .event-planner-view__anchor-tag-toggle.is-active:hover {
      border-color: #c78445;
      background: rgba(110, 68, 28, 0.42);
      color: #d8b493;
      box-shadow: 0 0 0 1px rgba(199, 132, 69, 0.28); }

.event-planner-view__anchor-tag-menu.is-open .event-planner-view__anchor-tag-toggle.is-active {
  border-color: #c78445;
  background: rgba(110, 68, 28, 0.5);
  color: #d8b493; }

.event-planner-view__anchor-tag-toggle-icon {
  width: 0.72rem;
  height: 0.72rem; }

.event-planner-view__anchor-tag-toggle-label {
  letter-spacing: 0.02em;
  text-transform: uppercase; }

.event-planner-view__anchor-tag-picker {
  position: absolute;
  top: calc(100% + 0.25rem);
  right: 0;
  z-index: 40;
  min-width: 9.5rem;
  max-width: 14rem;
  max-height: 11rem;
  margin: 0;
  padding: 0.28rem;
  overflow: auto;
  list-style: none;
  border-radius: 8px;
  border: 1px solid rgba(58, 120, 180, 0.45);
  background: linear-gradient(180deg, rgba(22, 52, 71, 0.98), rgba(23, 39, 56, 0.98));
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.42);
  margin-right: -10px;
  padding-right: 10px;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.35) rgba(0, 0, 0, 0.12); }
  .event-planner-view__anchor-tag-picker::-webkit-scrollbar {
    width: 6px; }
  .event-planner-view__anchor-tag-picker::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.12);
    border-radius: 999px; }
  .event-planner-view__anchor-tag-picker::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.3);
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.08); }
  .event-planner-view__anchor-tag-picker::-webkit-scrollbar-thumb:hover {
    background: rgba(58, 120, 180, 0.42); }

.event-planner-view__anchor-tag-picker-divider {
  height: 1px;
  margin: 0.22rem 0.35rem;
  background: rgba(58, 120, 180, 0.28); }

.event-planner-view__anchor-tag-picker-empty {
  padding: 0.45rem 0.5rem;
  color: #747b81;
  font-size: 0.64rem;
  line-height: 1.35; }

.event-planner-view__anchor-tag-picker-option {
  display: flex;
  align-items: center;
  gap: 0.38rem;
  width: 100%;
  margin: 0;
  padding: 0.38rem 0.45rem;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #dfdfdf;
  font-family: inherit;
  font-size: 0.68rem;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: background 160ms ease, border-color 160ms ease, color 160ms ease, box-shadow 160ms ease; }
  .event-planner-view__anchor-tag-picker-option:hover:not(:disabled) {
    background: rgba(0, 72, 114, 0.28);
    color: #ffffff; }
  .event-planner-view__anchor-tag-picker-option:disabled {
    cursor: default; }

.event-planner-view__anchor-tag-picker-option-indicator {
  flex-shrink: 0;
  width: 0.48rem;
  height: 0.48rem;
  border: 1px solid rgba(116, 123, 129, 0.45);
  border-radius: 999px;
  background: transparent;
  transition: background 160ms ease, border-color 160ms ease, box-shadow 160ms ease; }

.event-planner-view__anchor-tag-picker-option-label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.event-planner-view__anchor-tag-picker-option--active {
  border: 1px solid rgba(199, 132, 69, 0.42);
  background: linear-gradient(90deg, rgba(110, 68, 28, 0.42), rgba(155, 96, 42, 0.18));
  color: #d8b493;
  box-shadow: inset 0 1px 0 rgba(170, 158, 116, 0.12); }
  .event-planner-view__anchor-tag-picker-option--active .event-planner-view__anchor-tag-picker-option-indicator {
    border-color: #c78445;
    background: radial-gradient(circle at center, #c78445 0%, #9b602a 72%);
    box-shadow: 0 0 0 2px rgba(199, 132, 69, 0.18); }
  .event-planner-view__anchor-tag-picker-option--active:hover:not(:disabled) {
    border-color: rgba(199, 132, 69, 0.72);
    background: linear-gradient(90deg, rgba(110, 68, 28, 0.55), rgba(155, 96, 42, 0.28));
    color: #aa9e74; }

.event-planner-view__anchor-tag-menu--fighter-vehicle {
  margin-left: auto; }

.event-planner-view__header-date {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0;
  color: #747b81;
  font-size: 0.84rem;
  text-align: left; }

.event-planner-view__header-date-icon {
  flex-shrink: 0;
  width: 0.95rem;
  height: 0.95rem;
  color: #5ac3ff; }

.is-planner-dimmed {
  opacity: 0.34;
  filter: blur(1.4px);
  transition: opacity 0.18s ease, filter 0.18s ease, border-color 0.15s ease, box-shadow 0.15s ease; }

.event-planner-view__participant-chip.is-missing-vehicle {
  opacity: 0.48;
  filter: grayscale(0.7);
  transition: opacity 0.18s ease, filter 0.18s ease; }

.event-planner-view__team.is-planner-highlighted,
.event-planner-view__variant-group.is-planner-highlighted,
.event-planner-view__convoy-group.is-planner-highlighted,
.event-planner-view__convoy-vehicle.is-planner-highlighted,
.event-planner-view__ground-vehicle-standalone.is-planner-highlighted {
  border-color: #c78445 !important;
  box-shadow: 0 0 0 2px rgba(199, 132, 69, 0.5) !important; }

.event-planner-view__special-group.is-planner-highlighted {
  border-color: #c78445 !important;
  box-shadow: 0 0 0 2px rgba(199, 132, 69, 0.5) !important;
  background: rgba(199, 132, 69, 0.12) !important; }

.event-planner-view__officers {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 0.45rem; }

.event-planner-view__officer {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: stretch;
  padding: 0.25rem 0.4rem;
  border: 1px solid rgba(58, 120, 180, 0.38);
  border-radius: 8px;
  background: rgba(30, 48, 66, 0.72); }

.event-planner-view__officer-label {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  color: #747b81;
  font-size: 0.64rem;
  letter-spacing: 0.06em;
  text-transform: uppercase; }

.event-planner-view__officer-label-icon {
  width: 0.72rem;
  height: 0.72rem;
  color: #5ac3ff; }

.event-planner-view__status {
  margin: 1.75rem 0;
  text-align: center;
  color: #b8b8b8; }

.event-planner-view__status--error {
  color: #d8b493; }

.event-planner-view__layout {
  display: grid;
  grid-template-columns: 240px minmax(0, 1fr) 300px;
  gap: 0.65rem;
  min-height: 520px; }

.event-planner-view__sidebar,
.event-planner-view__panel {
  min-width: 0;
  padding: 0.65rem 0.75rem;
  border: 1px solid rgba(58, 120, 180, 0.38);
  border-radius: 10px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2); }

.event-planner-view__panel {
  background: linear-gradient(180deg, rgba(30, 48, 66, 0.94), rgba(23, 39, 56, 0.82)), rgba(0, 48, 77, 0.65); }

.event-planner-view__sidebar {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  max-height: calc(100vh - 260px);
  overflow: hidden;
  background: linear-gradient(180deg, rgba(22, 52, 71, 0.88), rgba(23, 39, 56, 0.92)), rgba(0, 48, 77, 0.65); }

.event-planner-view__panel-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.65rem;
  margin-bottom: 0.45rem;
  padding-bottom: 0.45rem;
  border-bottom: 1px solid rgba(58, 120, 180, 0.24); }
  .event-planner-view__panel-header h3 {
    margin: 0;
    color: #ffffff;
    font-size: 0.9rem;
    font-weight: 600; }

.event-planner-view__panel-header-end {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.45rem; }

.event-planner-view__panel-header-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem; }

.event-planner-view__bulk-expand-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.22rem 0.45rem;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(0, 0, 0, 0.25);
  color: #dfdfdf;
  font-size: 0.68rem;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  transition: background 160ms ease, border-color 160ms ease, color 160ms ease; }
  .event-planner-view__bulk-expand-btn:hover {
    background: rgba(0, 0, 0, 0.38);
    border-color: #b8b8b8;
    color: #ffffff; }

.event-planner-view__bulk-expand-btn-icon {
  display: block;
  width: 12px;
  height: 12px;
  object-fit: contain;
  opacity: 0.95; }

.event-planner-view__panel-heading,
.event-planner-view__panel-header-title {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  min-width: 0; }

.event-planner-view__panel-icon {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 1.65rem;
  height: 1.65rem;
  border: 1px solid rgba(90, 195, 255, 0.28);
  border-radius: 7px;
  color: #5ac3ff;
  background: rgba(0, 72, 114, 0.28); }
  .event-planner-view__panel-icon svg {
    width: 0.95rem;
    height: 0.95rem; }

.event-planner-view__panel-header--roster .event-planner-view__panel-header-row {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.45rem;
  width: 100%; }

.event-planner-view__panel-header--roster .event-planner-view__panel-header-title h3 {
  min-width: 0; }

.event-planner-view__panel-header--roster .event-planner-view__officers {
  flex-shrink: 0;
  margin-left: 0; }

.event-planner-view__search-field {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.45rem;
  padding: 0.28rem 0.45rem;
  border: 1px solid rgba(58, 120, 180, 0.38);
  border-radius: 8px;
  background: rgba(0, 48, 77, 0.55);
  transition: border-color 0.15s ease, box-shadow 0.15s ease; }
  .event-planner-view__search-field:focus-within {
    border-color: rgba(90, 195, 255, 0.65);
    box-shadow: 0 0 0 2px rgba(58, 120, 180, 0.12); }

.event-planner-view__participant-search {
  flex-shrink: 0; }

.event-planner-view__search-icon {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  color: #747b81; }
  .event-planner-view__search-icon svg {
    width: 0.9rem;
    height: 0.9rem; }

.event-planner-view__search-input {
  width: 100%;
  min-width: 0;
  padding: 0;
  border: 0;
  outline: none;
  color: #dfdfdf;
  background: transparent;
  font-family: inherit;
  font-size: 0.8rem; }
  .event-planner-view__search-input::placeholder {
    color: rgba(116, 123, 129, 0.85); }

.event-planner-view__deployment-stats {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.45rem 0.75rem;
  margin-bottom: 0.45rem;
  padding: 0.35rem 0.45rem;
  border: 1px solid rgba(58, 120, 180, 0.22);
  border-radius: 8px;
  background: rgba(23, 39, 56, 0.45); }

.event-planner-view__deployment-stat {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  color: #747b81;
  font-size: 0.72rem;
  white-space: nowrap; }

.event-planner-view__deployment-stat-icon {
  width: 0.78rem;
  height: 0.78rem;
  color: #5ac3ff; }

.event-planner-view__eyebrow {
  margin: 0 0 0.25rem;
  color: #747b81;
  font-size: 0.68rem;
  letter-spacing: 0.08em;
  text-transform: uppercase; }

.event-planner-view__count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 1.65rem;
  padding: 0.15rem 0.55rem;
  border: 1px solid rgba(90, 195, 255, 0.28);
  border-radius: 999px;
  color: #5ac3ff;
  background: rgba(0, 72, 114, 0.42);
  font-family: 'FiraCode', monospace;
  font-size: 0.72rem;
  white-space: nowrap; }

.event-planner-view__special-list {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  padding-bottom: 0.55rem;
  border-bottom: 1px solid rgba(58, 120, 180, 0.24); }

.event-planner-view__special-group,
.event-planner-view__vehicle-item {
  display: flex;
  align-items: flex-start;
  gap: 0.45rem;
  width: 100%;
  padding: 0.45rem 0.55rem;
  border: 1px solid rgba(58, 120, 180, 0.24);
  border-radius: 8px;
  color: #dfdfdf;
  background: rgba(23, 39, 56, 0.72);
  text-align: left;
  cursor: grab;
  touch-action: none;
  user-select: none;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease; }
  .event-planner-view__special-group:hover:not(:disabled),
  .event-planner-view__vehicle-item:hover:not(:disabled) {
    border-color: rgba(90, 195, 255, 0.42);
    background: rgba(22, 52, 71, 0.82);
    color: #ffffff; }
  .event-planner-view__special-group:active:not(:disabled),
  .event-planner-view__vehicle-item:active:not(:disabled) {
    cursor: grabbing; }
  .event-planner-view__special-group:disabled, .event-planner-view__special-group.is-unavailable,
  .event-planner-view__vehicle-item:disabled,
  .event-planner-view__vehicle-item.is-unavailable {
    opacity: 0.42;
    cursor: not-allowed; }
  .event-planner-view__special-group.is-dragging,
  .event-planner-view__vehicle-item.is-dragging {
    opacity: 0; }
  .event-planner-view__special-group.is-planner-highlighted,
  .event-planner-view__vehicle-item.is-planner-highlighted {
    border-color: #c78445 !important;
    box-shadow: 0 0 0 2px rgba(199, 132, 69, 0.5) !important;
    background: rgba(199, 132, 69, 0.12) !important; }
  .event-planner-view__special-group.is-planner-highlighted:hover:not(:disabled),
  .event-planner-view__vehicle-item.is-planner-highlighted:hover:not(:disabled) {
    border-color: #c78445 !important;
    box-shadow: 0 0 0 2px rgba(199, 132, 69, 0.62) !important; }

.event-planner-view__participant-chip {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  background: rgba(223, 223, 223, 0.07);
  border: 2px solid transparent;
  border-radius: 10px;
  padding: 1px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease; }
  .event-planner-view__participant-chip.is-planner-highlighted {
    border-color: #c78445;
    box-shadow: 0 0 0 1px rgba(199, 132, 69, 0.45); }
  .event-planner-view__participant-chip--overlay {
    width: auto;
    min-width: 12rem;
    background: rgba(23, 39, 56, 0.96); }

.event-planner-view__participant-meta {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.32rem;
  min-width: 0;
  padding: 0 0.35rem 0.28rem; }

.event-planner-view__participant-section {
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  max-width: 100%;
  min-height: 1.35rem;
  padding: 0.08rem 0.45rem;
  border: 1px solid rgba(90, 195, 255, 0.28);
  border-radius: 999px;
  color: #5ac3ff;
  background: rgba(0, 72, 114, 0.32);
  font-size: 0.68rem;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; }

.event-planner-view__participant-guest {
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  max-width: 100%;
  min-height: 1.15rem;
  padding: 0rem 0.55rem;
  border: 1px solid rgba(199, 132, 69, 0.55);
  border-radius: 999px;
  color: #d8b493;
  background: rgba(155, 96, 42, 0.42);
  font-size: 0.58rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  line-height: 1.25;
  text-transform: uppercase;
  white-space: nowrap; }

.event-planner-view__participant-tags-trigger {
  position: relative;
  flex-shrink: 0;
  margin: 0px 0px 0px auto; }

.event-planner-view__participant-tags-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.35rem;
  height: 1.35rem;
  padding: 0;
  border: 1px solid rgba(90, 195, 255, 0.28);
  border-radius: 6px;
  color: #5ac3ff;
  background: rgba(0, 72, 114, 0.22);
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease; }
  .event-planner-view__participant-tags-btn:hover, .event-planner-view__participant-tags-btn.is-open {
    border-color: rgba(90, 195, 255, 0.5);
    background: rgba(0, 72, 114, 0.38);
    color: #dfdfdf; }

.event-planner-view__participant-tags-btn-icon {
  width: 0.72rem;
  height: 0.72rem; }

.event-planner-view__participant-tags-tooltip {
  position: absolute;
  left: 50%;
  bottom: calc(100% + 6px);
  z-index: 12;
  min-width: 7.5rem;
  max-width: 14rem;
  padding: 0.38rem 0.42rem;
  border: 1px solid rgba(58, 120, 180, 0.45);
  border-radius: 8px;
  background: rgba(30, 48, 66, 0.98);
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.45), 0 0 0 1px rgba(0, 0, 0, 0.18);
  transform: translateX(-50%); }

.event-planner-view__participant-tags-tooltip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.28rem;
  margin: 0;
  padding: 0;
  list-style: none; }

.event-planner-view__participant-tags-tooltip-item {
  margin: 0;
  list-style: none; }

.event-planner-view__participant-tag {
  display: inline-flex;
  align-items: center;
  min-height: 1.3rem;
  padding: 0.08rem 0.42rem;
  border: 1px solid rgba(58, 120, 180, 0.4);
  border-radius: 999px;
  color: rgba(223, 223, 223, 0.96);
  background: rgba(23, 39, 56, 0.72);
  font-size: 0.66rem;
  line-height: 1.25; }

.event-planner-view__participant-tag--inactive {
  border-style: dashed;
  opacity: 0.65; }

.event-planner-view__item-icon {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 1.45rem;
  height: 1.45rem;
  border-radius: 6px;
  color: #5ac3ff;
  background: rgba(0, 72, 114, 0.28); }
  .event-planner-view__item-icon svg {
    width: 0.85rem;
    height: 0.85rem; }

.event-planner-view__special-group-label {
  flex: 1;
  min-width: 0;
  font-weight: 600; }

.event-planner-view__drag-hint {
  flex-shrink: 0;
  width: 0.72rem;
  height: 0.72rem;
  margin-left: auto;
  color: rgba(116, 123, 129, 0.75); }

.event-planner-view__vehicle-item-body {
  flex: 1;
  min-width: 0; }

.event-planner-view__vehicle-item-leading {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 1.45rem;
  height: 1.45rem;
  margin-top: 0.05rem;
  border-radius: 6px;
  color: #5ac3ff;
  background: rgba(0, 72, 114, 0.28); }
  .event-planner-view__vehicle-item-leading svg {
    width: 0.85rem;
    height: 0.85rem; }

.event-planner-view__drag-overlay {
  cursor: grabbing;
  pointer-events: none;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35); }

.event-planner-view__vehicle-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem; }

.event-planner-view__vehicle-name {
  min-width: 0;
  overflow: hidden;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap; }

.event-planner-view__vehicle-group {
  display: flex;
  flex-direction: column;
  gap: 0.28rem;
  padding: 0.4rem 0.45rem;
  border: 1px solid rgba(58, 120, 180, 0.24);
  border-radius: 8px;
  background: rgba(23, 39, 56, 0.55); }
  .event-planner-view__vehicle-group.is-planner-highlighted {
    border-color: #c78445 !important;
    box-shadow: 0 0 0 2px rgba(199, 132, 69, 0.5) !important;
    background: rgba(199, 132, 69, 0.12) !important; }

.event-planner-view__vehicle-group-header {
  display: flex;
  align-items: center;
  gap: 0.45rem; }

.event-planner-view__vehicle-instances {
  display: flex;
  flex-direction: column;
  gap: 0.22rem;
  padding-left: 1.9rem; }

.event-planner-view__vehicle-instance {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  width: 100%;
  padding: 0.32rem 0.45rem;
  border: 1px solid rgba(58, 120, 180, 0.2);
  border-radius: 6px;
  color: #dfdfdf;
  background: rgba(23, 39, 56, 0.82);
  text-align: left;
  cursor: grab;
  touch-action: none;
  user-select: none;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease; }
  .event-planner-view__vehicle-instance:hover {
    border-color: rgba(90, 195, 255, 0.42);
    background: rgba(22, 52, 71, 0.82);
    color: #ffffff; }
  .event-planner-view__vehicle-instance:active {
    cursor: grabbing; }
  .event-planner-view__vehicle-instance.is-dragging {
    opacity: 0; }
  .event-planner-view__vehicle-instance.is-planner-highlighted {
    border-color: #c78445 !important;
    box-shadow: 0 0 0 2px rgba(199, 132, 69, 0.5) !important;
    background: rgba(199, 132, 69, 0.12) !important; }

.event-planner-view__vehicle-instance-label {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  font-size: 0.74rem;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap; }

.event-planner-view__vehicle-owners {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  margin-top: 0.35rem;
  color: #747b81;
  font-size: 0.72rem; }

.event-planner-view__vehicle-toolbar {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-bottom: 0.45rem; }

.event-planner-view__vehicle-search-field {
  margin-bottom: 0; }

.event-planner-view__vehicle-size-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem; }

.event-planner-view__vehicle-size-filter {
  padding: 0.28rem 0.55rem;
  border: 1px solid rgba(58, 120, 180, 0.28);
  border-radius: 999px;
  color: rgba(223, 223, 223, 0.82);
  background: rgba(23, 39, 56, 0.72);
  font-family: inherit;
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: capitalize;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease; }
  .event-planner-view__vehicle-size-filter:hover {
    border-color: rgba(90, 195, 255, 0.42);
    color: #ffffff;
    background: rgba(22, 52, 71, 0.72); }
  .event-planner-view__vehicle-size-filter.is-active {
    border-color: rgba(90, 195, 255, 0.55);
    color: #5ac3ff;
    background: rgba(0, 72, 114, 0.42); }

.event-planner-view__vehicle-list {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  border-radius: 8px;
  transition: border-color 0.15s ease, background-color 0.15s ease;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.5) rgba(0, 48, 77, 0.45); }
  .event-planner-view__vehicle-list::-webkit-scrollbar {
    width: 4px; }
  .event-planner-view__vehicle-list::-webkit-scrollbar-track {
    background: rgba(0, 48, 77, 0.45);
    border-radius: 999px; }
  .event-planner-view__vehicle-list::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.48);
    border-radius: 999px; }
  .event-planner-view__vehicle-list.is-over {
    outline: 1px dashed rgba(90, 195, 255, 0.45);
    background: rgba(22, 52, 71, 0.22); }

.event-planner-view__participant-pool {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  max-height: calc(100vh - 260px);
  background: linear-gradient(180deg, rgba(19, 59, 83, 0.58), rgba(30, 48, 66, 0.78)), rgba(0, 48, 77, 0.65);
  transition: border-color 0.15s ease, background-color 0.15s ease; }
  .event-planner-view__participant-pool.is-over {
    border-color: rgba(90, 195, 255, 0.55);
    background: linear-gradient(180deg, rgba(22, 52, 71, 0.72), rgba(30, 48, 66, 0.82)), rgba(0, 48, 77, 0.65); }

.event-planner-view__participant-list .user-discord-rank--draggable,
.event-planner-view__position .user-discord-rank--draggable {
  cursor: grab;
  touch-action: none;
  user-select: none; }
  .event-planner-view__participant-list .user-discord-rank--draggable:active,
  .event-planner-view__position .user-discord-rank--draggable:active {
    cursor: grabbing; }
  .event-planner-view__participant-list .user-discord-rank--draggable.is-dragging,
  .event-planner-view__position .user-discord-rank--draggable.is-dragging {
    opacity: 0; }

.event-planner-view__participant-list {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.5) rgba(0, 48, 77, 0.45); }
  .event-planner-view__participant-list::-webkit-scrollbar {
    width: 4px; }
  .event-planner-view__participant-list::-webkit-scrollbar-track {
    background: rgba(0, 48, 77, 0.45);
    border-radius: 999px; }
  .event-planner-view__participant-list::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.48);
    border-radius: 999px; }
  .event-planner-view__participant-list .user-discord-rank--draggable {
    min-width: 0;
    max-width: 100%; }
  .event-planner-view__participant-list p {
    margin: 0;
    color: #747b81;
    font-size: 0.85rem; }

.event-planner-view__fleet {
  min-height: 430px;
  min-width: 0;
  max-height: calc(100vh - 258px);
  background: linear-gradient(180deg, rgba(30, 48, 66, 0.88), rgba(23, 39, 56, 0.72)), rgba(0, 48, 77, 0.65);
  transition: border-color 0.15s ease, background-color 0.15s ease;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.5) rgba(0, 48, 77, 0.45); }
  .event-planner-view__fleet::-webkit-scrollbar {
    width: 4px; }
  .event-planner-view__fleet::-webkit-scrollbar-track {
    background: rgba(0, 48, 77, 0.45);
    border-radius: 999px; }
  .event-planner-view__fleet::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.48);
    border-radius: 999px; }
  .event-planner-view__fleet.is-over {
    border-color: rgba(90, 195, 255, 0.55);
    background: linear-gradient(180deg, rgba(22, 52, 71, 0.68), rgba(30, 48, 66, 0.78)), rgba(0, 48, 77, 0.65); }

.event-planner-view__fleet-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  min-height: 260px;
  padding: 0.65rem;
  color: #747b81;
  border: 1px dashed rgba(58, 120, 180, 0.32);
  border-radius: 10px;
  background: rgba(23, 39, 56, 0.45);
  font-size: 0.82rem;
  text-align: center; }
  .event-planner-view__fleet-empty p {
    margin: 0; }

.event-planner-view__fleet-empty-icon {
  width: 1.25rem;
  height: 1.25rem;
  color: #5ac3ff; }

.event-planner-view__team-grid {
  --event-planner-card-gap: 4.5rem;
  container-type: inline-size;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: var(--event-planner-card-gap);
  width: 100%;
  min-width: 0; }

.event-planner-view__fleet-canvas {
  position: relative;
  min-width: 0; }

.event-planner-view__card-links-layer {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: visible; }

.event-planner-view__card-links {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: visible; }
  .event-planner-view__card-links--visual {
    z-index: 1; }
  .event-planner-view__card-links--interactive {
    z-index: 3;
    pointer-events: none; }

.event-planner-view__card-link-path-hit {
  fill: none;
  stroke: transparent;
  stroke-width: 16;
  stroke-linecap: round;
  stroke-linejoin: round;
  pointer-events: stroke;
  cursor: pointer; }
  .event-planner-view__card-link-path-hit.is-selected {
    stroke: rgba(90, 195, 255, 0.12); }

.event-planner-view__card-link-path {
  fill: none;
  stroke: rgba(90, 195, 255, 0.88);
  stroke-width: 3;
  stroke-dasharray: 8 5;
  stroke-linecap: round;
  stroke-linejoin: round;
  pointer-events: none; }
  .event-planner-view__card-link-path.is-highlighted, .event-planner-view__card-link-path.is-selected {
    stroke: rgba(170, 158, 116, 0.98);
    stroke-width: 3;
    stroke-dasharray: none; }

.event-planner-view__card-link-arrow {
  fill: rgba(90, 195, 255, 0.88);
  stroke: none;
  pointer-events: none; }
  .event-planner-view__card-link-arrow.is-highlighted, .event-planner-view__card-link-arrow.is-selected {
    fill: rgba(170, 158, 116, 0.98); }

.event-planner-view__card-link-attach {
  fill: rgba(23, 39, 56, 0.95);
  stroke: rgba(90, 195, 255, 0.9);
  stroke-width: 2;
  pointer-events: none; }
  .event-planner-view__card-link-attach.is-highlighted {
    fill: rgba(22, 52, 71, 0.95);
    stroke: rgba(170, 158, 116, 0.95);
    stroke-width: 2.5; }

.event-planner-view__card-link-delete-wrap {
  pointer-events: auto; }

.event-planner-view__card-link-delete {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.35rem;
  height: 1.35rem;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(216, 180, 147, 0.85);
  border-radius: 999px;
  background: rgba(23, 39, 56, 0.96);
  color: #d8b493;
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35); }
  .event-planner-view__card-link-delete span {
    display: block;
    margin-top: -0.08rem; }
  .event-planner-view__card-link-delete:hover {
    border-color: rgba(170, 158, 116, 0.95);
    color: #aa9e74;
    background: rgba(22, 52, 71, 0.98); }

.event-planner-view__card-link-handles {
  position: absolute;
  inset: 0;
  z-index: 3;
  pointer-events: none; }

.event-planner-view__card-link-handle-zone {
  --event-planner-card-link-handle-zone-size: 30px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--event-planner-card-link-handle-zone-size);
  height: var(--event-planner-card-link-handle-zone-size);
  pointer-events: auto; }
  .event-planner-view__card-link-handle-zone--top {
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%); }
  .event-planner-view__card-link-handle-zone--bottom {
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 50%); }
  .event-planner-view__card-link-handle-zone--left {
    left: 0;
    top: 50%;
    transform: translate(-50%, -50%); }
  .event-planner-view__card-link-handle-zone--right {
    right: 0;
    top: 50%;
    transform: translate(50%, -50%); }
  .event-planner-view__card-link-handle-zone:hover .event-planner-view__card-link-handle,
  .event-planner-view__card-link-handle-zone:focus-within .event-planner-view__card-link-handle {
    opacity: 1;
    visibility: visible; }
  .event-planner-view__card-link-handle-zone:hover .event-planner-view__card-link-handle.is-selected,
  .event-planner-view__card-link-handle-zone:focus-within .event-planner-view__card-link-handle.is-selected {
    border-color: rgba(170, 158, 116, 0.95);
    background: rgba(90, 195, 255, 0.35);
    box-shadow: 0 0 0 2px rgba(170, 158, 116, 0.18); }

.event-planner-view__card-link-handle {
  flex-shrink: 0;
  width: 0.82rem;
  height: 0.82rem;
  padding: 0;
  border: 1.5px solid rgba(90, 195, 255, 0.85);
  border-radius: 999px;
  background: rgba(23, 39, 56, 0.35);
  cursor: grab;
  touch-action: none;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.14s ease, visibility 0.14s ease, border-color 0.14s ease, background-color 0.14s ease; }
  .event-planner-view__card-link-handle:hover {
    border-color: rgba(170, 158, 116, 0.95);
    background: rgba(22, 52, 71, 0.55); }
  .event-planner-view__card-link-handle.is-dragging {
    opacity: 0.45;
    visibility: visible;
    cursor: grabbing; }

.event-planner-view__team.is-card-link-selected,
.event-planner-view__variant-group.is-card-link-selected,
.event-planner-view__convoy-group.is-card-link-selected,
.event-planner-view__convoy-vehicle.is-card-link-selected,
.event-planner-view__ground-vehicle-standalone.is-card-link-selected {
  box-shadow: 0 0 0 1px rgba(170, 158, 116, 0.45); }

.event-planner-view__team-grid-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, var(--event-planner-position-column-width));
  justify-content: center;
  align-items: start;
  gap: var(--event-planner-card-gap);
  min-width: 0;
  position: relative;
  z-index: 2; }
  .event-planner-view__team-grid-row > .event-planner-view__team.is-expanded {
    grid-column: span var(--team-position-columns, 1); }
  .event-planner-view__team-grid-row > .event-planner-view__variant-group.is-expanded {
    grid-column: span var(--variant-team-count, 1); }
  .event-planner-view__team-grid-row > .event-planner-view__convoy-group.is-expanded {
    grid-column: span var(--convoy-vehicle-count, 1); }

.event-planner-view__variant-group {
  --variant-team-count: 1;
  grid-column: span var(--variant-team-count);
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  min-width: 0;
  padding: 0.55rem;
  border-radius: 12px;
  position: relative;
  z-index: 2;
  transition: border-color 0.15s ease, background-color 0.15s ease, filter 0.15s ease; }
  .event-planner-view__variant-group:not([class*="mo-structure-card-bg-"]) {
    border: 1px solid rgba(90, 195, 255, 0.28);
    background: rgba(23, 39, 56, 0.42); }
  .event-planner-view__variant-group[class*="mo-structure-card-bg-"] {
    border-width: 1px;
    border-style: solid; }
  .event-planner-view__variant-group.is-collapsed .event-planner-view__variant-group-header,
  .event-planner-view__variant-group.is-collapsed .event-planner-view__variant-group-commander {
    padding-bottom: 0;
    border-bottom: 0; }
  .event-planner-view__variant-group.is-over:not([class*="mo-structure-card-bg-"]) {
    border-color: rgba(90, 195, 255, 0.55);
    background: rgba(22, 52, 71, 0.72); }
  .event-planner-view__variant-group.is-over[class*="mo-structure-card-bg-"] {
    filter: brightness(1.06); }
  .event-planner-view__variant-group.is-expanded {
    box-sizing: border-box;
    width: fit-content;
    max-width: 100%;
    justify-self: center; }

.event-planner-view__variant-group-kind {
  flex-shrink: 0;
  padding: 0.08rem 0.35rem;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: rgba(0, 0, 0, 0.22);
  color: #dfdfdf;
  font-size: 0.62rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase; }

.event-planner-view__variant-group-commander {
  padding-bottom: 0.45rem;
  border-bottom: 1px solid rgba(56, 72, 88, 0.45); }

.event-planner-view__position--group-leader {
  margin: 0; }

.event-planner-view__position--group-leader-readonly .event-planner-view__position-empty {
  color: #384858;
  font-style: italic; }

.event-planner-view__variant-group-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.45rem;
  padding-bottom: 0.45rem;
  border-bottom: 1px solid rgba(56, 72, 88, 0.45); }

.event-planner-view__variant-group-title,
.event-planner-view__convoy-group-title,
.event-planner-view__group-title {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem;
  min-width: 0;
  flex: 1; }

.event-planner-view__group-heading {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  min-width: 0;
  flex: 1 1 auto; }
  .event-planner-view__group-heading strong {
    overflow: hidden;
    color: #ffffff;
    text-overflow: ellipsis;
    white-space: nowrap; }

.event-planner-view__variant-group.is-collapsed .event-planner-view__group-title,
.event-planner-view__convoy-group.is-collapsed .event-planner-view__group-title {
  flex-direction: column;
  align-items: flex-start;
  width: 100%; }

.event-planner-view__variant-group.is-collapsed .event-planner-view__group-heading,
.event-planner-view__convoy-group.is-collapsed .event-planner-view__group-heading {
  width: 100%; }
  .event-planner-view__variant-group.is-collapsed .event-planner-view__group-heading strong,
  .event-planner-view__convoy-group.is-collapsed .event-planner-view__group-heading strong {
    white-space: normal;
    overflow: visible;
    text-overflow: unset; }

.event-planner-view__variant-group-teams {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  align-content: center;
  gap: 1rem;
  width: max-content;
  max-width: 100%;
  max-width: 100cqw;
  min-width: 0;
  box-sizing: border-box;
  align-self: center;
  margin-bottom: 10px; }
  .event-planner-view__variant-group-teams > .event-planner-view__team {
    flex: 0 0 var(--event-planner-position-column-width);
    box-sizing: border-box;
    max-width: var(--event-planner-team-max-width, 300px);
    min-width: var(--event-planner-position-column-width);
    width: var(--event-planner-position-column-width); }
    .event-planner-view__variant-group-teams > .event-planner-view__team.is-expanded {
      flex: 0 0 auto;
      width: calc( var(--team-position-columns, 1) * var(--event-planner-position-column-width) + (var(--team-position-columns, 1) - 1) * var(--event-planner-card-gap, 3rem));
      min-width: calc( var(--team-position-columns, 1) * var(--event-planner-position-column-width) + (var(--team-position-columns, 1) - 1) * var(--event-planner-card-gap, 3rem)); }

.event-planner-view__team--nested {
  min-width: var(--event-planner-position-column-width, 280px);
  max-width: var(--event-planner-team-max-width, 300px);
  width: var(--event-planner-position-column-width, 280px);
  border-color: rgba(58, 120, 180, 0.24);
  background: rgba(30, 48, 66, 0.72); }

.event-planner-view__team {
  min-width: var(--event-planner-position-column-width, 280px);
  max-width: var(--event-planner-team-max-width, 300px);
  width: var(--event-planner-position-column-width, 280px);
  padding: 0.55rem;
  box-sizing: border-box;
  position: relative;
  z-index: 2;
  border-radius: 8px;
  transition: border-color 0.15s ease, background-color 0.15s ease, filter 0.15s ease; }
  .event-planner-view__team.is-expanded {
    max-width: none;
    min-width: 0;
    width: auto; }
  .event-planner-view__team:not([class*="mo-structure-card-bg-"]) {
    border: 1px solid rgba(58, 120, 180, 0.38);
    background: rgba(30, 48, 66, 0.38); }
  .event-planner-view__team[class*="mo-structure-card-bg-"] {
    border-width: 1px;
    border-style: solid; }
  .event-planner-view__team.is-over:not([class*="mo-structure-card-bg-"]) {
    border-color: rgba(90, 195, 255, 0.55);
    background: rgba(22, 52, 71, 0.72); }
  .event-planner-view__team.is-over[class*="mo-structure-card-bg-"] {
    filter: brightness(1.06); }
  .event-planner-view__team--command-ship {
    position: relative;
    isolation: isolate; }
    .event-planner-view__team--command-ship:not([class*="mo-structure-card-bg-"]), .event-planner-view__team--command-ship[class*="mo-structure-card-bg-"] {
      border-color: transparent; }
    .event-planner-view__team--command-ship::before {
      content: "";
      position: absolute;
      inset: 0;
      border-radius: inherit;
      padding: 1.5px;
      background: linear-gradient(128deg, rgba(170, 158, 116, 0.95) 0%, rgba(199, 132, 69, 0.92) 16%, rgba(170, 158, 116, 0.78) 34%, rgba(255, 255, 255, 0.72) 47%, rgba(170, 158, 116, 0.88) 55%, rgba(199, 132, 69, 0.9) 76%, rgba(170, 158, 116, 0.96) 100%);
      -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
      mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      pointer-events: none;
      z-index: 2; }
    .event-planner-view__team--command-ship::after {
      content: "";
      position: absolute;
      inset: -2px;
      border-radius: inherit;
      box-shadow: 0 0 14px rgba(199, 132, 69, 0.38), 0 0 22px rgba(170, 158, 116, 0.22), inset 0 1px 0 rgba(255, 255, 255, 0.14);
      pointer-events: none;
      z-index: 0; }
    .event-planner-view__team--command-ship.is-over::after {
      box-shadow: 0 0 18px rgba(199, 132, 69, 0.5), 0 0 30px rgba(170, 158, 116, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.18); }

.event-planner-view__team-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.45rem;
  padding-bottom: 0.45rem;
  border-bottom: 1px solid rgba(56, 72, 88, 0.65); }
  .event-planner-view__team-header > .event-planner-view__team-title {
    display: flex;
    align-items: flex-start;
    gap: 0.35rem;
    min-width: 0; }
  .event-planner-view__team-header .event-planner-view__team-icon {
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 1.35rem;
    height: 1.35rem;
    border-radius: 6px;
    color: #5ac3ff;
    background: rgba(0, 72, 114, 0.28); }
    .event-planner-view__team-header .event-planner-view__team-icon svg {
      width: 0.78rem;
      height: 0.78rem; }
  .event-planner-view__team-header strong {
    overflow: hidden;
    color: #ffffff;
    text-overflow: ellipsis;
    white-space: nowrap; }
  .event-planner-view__team-header .event-planner-view__team-stats-card {
    flex-shrink: 0; }
  .event-planner-view__team-header--ship {
    flex-direction: column;
    align-items: stretch;
    gap: 0.4rem; }
    .event-planner-view__team-header--ship > .event-planner-view__team-title {
      width: 100%;
      align-items: center; }
    .event-planner-view__team-header--ship .event-planner-view__team-header-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0.45rem;
      width: 100%;
      min-width: 0; }
    .event-planner-view__team-header--ship .event-planner-view__team-header-status {
      display: inline-flex;
      align-items: center;
      gap: 0.28rem;
      min-width: 0; }
    .event-planner-view__team-header--ship .event-planner-view__team-header-actions {
      flex-shrink: 0;
      margin-left: auto; }

.event-planner-view__team-stats-card {
  display: inline-flex;
  align-items: center;
  gap: 0.28rem;
  flex-shrink: 0; }

.event-planner-view__team-stats-with-note {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  flex-shrink: 0; }

.event-planner-view__team-stats {
  display: inline-flex;
  align-items: center;
  gap: 0.28rem;
  flex-shrink: 0;
  padding: 0.18rem 0.42rem;
  border-radius: 6px;
  background: #172738;
  font-size: 0.72rem;
  font-weight: 600;
  white-space: nowrap; }
  .event-planner-view__team-stats--empty .event-planner-view__team-stats-value {
    color: #9e2222; }
  .event-planner-view__team-stats--partial .event-planner-view__team-stats-value {
    color: #d8b493; }
  .event-planner-view__team-stats--full .event-planner-view__team-stats-value {
    color: #75cf78; }

.event-planner-view__team-stats-prefix {
  font-weight: 500;
  color: #b8b8b8; }

.event-planner-view__team-stats-value {
  font-weight: 600; }

.event-planner-view__fighter-ship-dot {
  flex-shrink: 0;
  width: 7px;
  height: 7px;
  border-radius: 50%; }
  .event-planner-view__fighter-ship-dot--empty {
    background-color: #9e2222; }
  .event-planner-view__fighter-ship-dot--partial {
    background-color: #c78445; }
  .event-planner-view__fighter-ship-dot--full {
    background-color: #75cf78; }

.event-planner-view__command-note-trigger {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  margin-left: 5px;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  padding: 0;
  border: 1px solid rgba(184, 184, 184, 0.45);
  border-radius: 5px;
  background: rgba(23, 39, 56, 0.85);
  color: #dfdfdf;
  cursor: pointer;
  transition: color 0.15s ease, border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease; }
  .event-planner-view__command-note-trigger:hover, .event-planner-view__command-note-trigger.is-active {
    color: #dfdfdf;
    border-color: #491212;
    background: #172738;
    box-shadow: 0 0 0 1px rgba(73, 18, 18, 0.35); }
  .event-planner-view__command-note-trigger.has-content {
    color: #ffc084;
    border-color: rgba(255, 192, 132, 0.75);
    background: #172738;
    box-shadow: 0 0 0 1px rgba(199, 132, 69, 0.25); }
  .event-planner-view__command-note-trigger.has-content.is-active, .event-planner-view__command-note-trigger.has-content:hover {
    color: #ffc084;
    border-color: rgba(255, 192, 132, 0.75);
    box-shadow: 0 0 0 1px rgba(199, 132, 69, 0.45); }

.event-planner-view__command-note-trigger-icon {
  width: 0.95rem;
  height: 0.95rem; }

.event-planner-view__command-note-tooltip {
  position: fixed;
  z-index: 10100;
  top: var(--tooltip-y, 0);
  left: var(--tooltip-x, 0); }

.event-planner-view__command-note-tooltip-loading {
  width: 420px;
  max-width: calc(100vw - 1rem);
  margin: 0;
  padding: 0.65rem 0.75rem;
  color: #b8b8b8;
  font-size: 0.75rem;
  background-color: #2a3847;
  border: 1px solid #491212;
  border-radius: 6px; }

.event-planner-view__command-note-tooltip-hint {
  margin: 0 0 0.5rem;
  padding: 0.45rem 0.55rem;
  color: #b8b8b8;
  font-size: 0.72rem;
  line-height: 1.35;
  background-color: rgba(28, 45, 56, 0.9);
  border: 1px solid rgba(155, 96, 42, 0.45);
  border-radius: 4px; }

.event-planner-view__command-note-editor {
  position: relative;
  width: 420px;
  max-width: calc(100vw - 1rem);
  background-color: #2a3847;
  border: 1px solid #491212;
  border-bottom: 4px solid #491212;
  border-radius: 6px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  overflow: hidden; }
  .event-planner-view__command-note-editor .lexical-versioning-bar {
    display: none !important; }
  .event-planner-view__command-note-editor .lexical-side-panels {
    display: none; }
  .event-planner-view__command-note-editor .lexical-container .editor-container {
    border: 0;
    background: #2a3847; }
    .event-planner-view__command-note-editor .lexical-container .editor-container .editor-input {
      min-height: 115px;
      background: #1c2d38;
      margin: 5px 6px 54px 5px;
      border: 1px solid #491212;
      border-radius: 6px; }

.event-planner-view__command-note-actions {
  position: absolute;
  right: 0.55rem;
  bottom: 0.45rem;
  z-index: 2; }

.event-planner-view__command-note-save {
  min-width: 6.5rem; }

.event-planner-view__team-header-actions {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 0.35rem; }

.event-planner-view__team-header-controls {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  gap: 0.2rem; }

.event-planner-view__command-ship-toggle {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  padding: 0;
  border: 1px solid rgba(90, 195, 255, 0.22);
  border-radius: 6px;
  background: rgba(12, 38, 55, 0.85);
  color: #747b81;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease; }
  .event-planner-view__command-ship-toggle:hover, .event-planner-view__command-ship-toggle:focus-visible {
    border-color: rgba(170, 158, 116, 0.55);
    color: #aa9e74; }
  .event-planner-view__command-ship-toggle.is-active {
    border-color: rgba(170, 158, 116, 0.65);
    background: rgba(66, 38, 12, 0.35);
    color: #aa9e74; }

.event-planner-view__command-ship-toggle-icon {
  width: 0.82rem;
  height: 0.82rem; }

.event-planner-view__section-picker {
  position: relative; }

.event-planner-view__section-picker-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.28rem;
  max-width: 8.5rem;
  padding: 0.2rem 0.4rem;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(0, 0, 0, 0.25);
  color: #dfdfdf;
  font-size: 0.64rem;
  line-height: 1.2;
  cursor: pointer;
  transition: background 160ms ease, border-color 160ms ease, color 160ms ease; }
  .event-planner-view__section-picker-toggle:hover,
  .event-planner-view__section-picker.is-open .event-planner-view__section-picker-toggle {
    background: rgba(0, 0, 0, 0.38);
    border-color: #b8b8b8;
    color: #ffffff; }

.event-planner-view__section-picker-toggle-icon {
  flex-shrink: 0;
  width: 0.85rem;
  height: 0.85rem; }

.event-planner-view__section-picker-toggle-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.event-planner-view__section-picker-menu {
  position: absolute;
  top: calc(100% + 0.25rem);
  right: 0;
  z-index: 30;
  min-width: 11rem;
  max-width: 16rem;
  max-height: 14rem;
  margin: 0;
  padding: 0.28rem;
  overflow: auto;
  list-style: none;
  border-radius: 8px;
  border: 1px solid rgba(58, 120, 180, 0.45);
  background: linear-gradient(180deg, rgba(22, 52, 71, 0.98), rgba(23, 39, 56, 0.98));
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.45); }

.event-planner-view__section-picker-option {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  width: 100%;
  padding: 0.35rem 0.4rem;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #dfdfdf;
  font-size: 0.72rem;
  text-align: left;
  cursor: pointer;
  transition: background 140ms ease, color 140ms ease; }
  .event-planner-view__section-picker-option:hover, .event-planner-view__section-picker-option.is-selected {
    background: rgba(0, 72, 114, 0.28);
    color: #ffffff; }

.event-planner-view__section-picker-swatch {
  flex-shrink: 0;
  width: 0.85rem;
  height: 0.85rem;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.22); }
  .event-planner-view__section-picker-swatch:not([class*="mo-structure-card-bg-"]) {
    background: rgba(56, 72, 88, 0.65); }

.event-planner-view__section-picker-option-label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.event-planner-view__expand-toggle {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  margin: 0;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: background 160ms ease, border-color 160ms ease; }
  .event-planner-view__expand-toggle:hover {
    background: rgba(0, 0, 0, 0.38);
    border-color: #b8b8b8; }

.event-planner-view__expand-toggle-icon {
  display: block;
  width: 14px;
  height: 14px;
  object-fit: contain;
  opacity: 0.95; }

.event-planner-view__team-remove {
  padding: 0;
  color: #b8b8b8;
  background: transparent;
  border: 0;
  font-size: 1.35rem;
  line-height: 1;
  cursor: pointer; }
  .event-planner-view__team-remove:hover {
    color: #dfdfdf; }

.event-planner-view__positions {
  --event-planner-positions-gap: 0.35rem;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--event-planner-positions-gap);
  padding-top: 0.45rem;
  margin-bottom: 6px;
  min-width: 0;
  min-height: 0;
  width: 100%;
  box-sizing: border-box; }
  .event-planner-view__positions--collapsed {
    padding-top: 0.35rem; }

.event-planner-view__positions-measure {
  position: absolute;
  top: 0;
  left: -9999px;
  width: var(--event-planner-position-column-width, 280px);
  visibility: hidden;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  gap: var(--event-planner-positions-gap); }
  .event-planner-view__positions-measure .event-planner-view__position {
    width: 100%;
    box-sizing: border-box; }

.event-planner-view__positions-columns {
  display: grid;
  grid-template-columns: repeat(var(--team-position-columns, 1), minmax(0, 1fr));
  gap: var(--event-planner-positions-gap);
  width: 100%;
  min-width: 0;
  box-sizing: border-box; }

.event-planner-view__positions-column {
  display: flex;
  flex-direction: column;
  gap: var(--event-planner-positions-gap);
  min-width: 0; }

.event-planner-view__team.is-expanded .event-planner-view__position {
  width: 100%;
  min-width: 0;
  box-sizing: border-box; }

.event-planner-view__team.is-collapsed .event-planner-view__team-header {
  padding-bottom: 0;
  border-bottom: 0; }

.event-planner-view__position {
  display: flex;
  flex-direction: column;
  gap: 0.28rem;
  padding: 0.4rem;
  border: 1px dashed rgba(116, 123, 129, 0.35);
  border-radius: 7px;
  background: rgba(23, 39, 56, 0.62);
  transition: border-color 0.15s ease, background-color 0.15s ease; }
  .event-planner-view__position.is-over {
    border-color: rgba(90, 195, 255, 0.48);
    background: rgba(22, 52, 71, 0.58); }

.event-planner-view__position-label {
  flex: 1;
  min-width: 0;
  color: #8bd5ff;
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase; }
  .event-planner-view__position-label.event-planner-view__position-label--command {
    color: #ffc084; }

.event-planner-view__position-label-row {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  width: 100%; }

.event-planner-view__position-label-actions {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  flex-shrink: 0;
  margin-left: auto; }

.event-planner-view__leader-rating-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer; }
  .event-planner-view__leader-rating-toggle.is-disabled {
    cursor: not-allowed;
    opacity: 0.55; }

.event-planner-view__leader-rating-toggle-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;
  pointer-events: none; }

.event-planner-view__leader-rating-toggle-box {
  display: inline-block;
  width: 0.82rem;
  height: 0.82rem;
  border: 1px solid rgba(90, 195, 255, 0.45);
  border-radius: 0.18rem;
  background: rgba(22, 52, 71, 0.55);
  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease; }

.event-planner-view__leader-rating-toggle-input:checked + .event-planner-view__leader-rating-toggle-box {
  border-color: rgba(155, 96, 42, 0.85);
  background: rgba(155, 96, 42, 0.35);
  box-shadow: inset 0 0 0 1px rgba(155, 96, 42, 0.55); }

.event-planner-view__leader-rating-toggle-input:focus-visible + .event-planner-view__leader-rating-toggle-box {
  outline: 1px solid rgba(90, 195, 255, 0.75);
  outline-offset: 1px; }

.event-planner-view__position-swap-btn {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 1.35rem;
  height: 1.35rem;
  padding: 0;
  border: 1px solid rgba(90, 195, 255, 0.28);
  border-radius: 0.25rem;
  background: rgba(22, 52, 71, 0.45);
  color: #5ac3ff;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease; }
  .event-planner-view__position-swap-btn:hover, .event-planner-view__position-swap-btn:focus-visible {
    border-color: rgba(90, 195, 255, 0.55);
    background: rgba(22, 52, 71, 0.72);
    color: #dfdfdf; }

.event-planner-view__position-swap-btn-icon {
  width: 0.72rem;
  height: 0.72rem; }

.event-planner-view__position-swap-select {
  width: 100%;
  max-width: 100%;
  padding: 0.12rem 0.3rem;
  border: 1px solid rgba(90, 195, 255, 0.35);
  border-radius: 0.25rem;
  background: rgba(22, 52, 71, 0.85);
  color: #dfdfdf;
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase; }

.event-planner-view__team-title-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
  margin-left: auto;
  min-width: 0;
  max-width: 48%;
  gap: 0.14rem; }
  .event-planner-view__team-title-meta .event-planner-view__team-owner {
    margin-left: 0;
    padding-left: 0;
    max-width: 100%;
    text-align: right; }

.event-planner-view__command-ship-tag {
  display: inline-flex;
  align-items: center;
  padding: 0.28rem 0.38rem;
  border: 1px solid rgba(170, 158, 116, 0.55);
  border-radius: 999px;
  background: rgba(66, 38, 12, 0.35);
  color: #aa9e74;
  font-size: 0.58rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  line-height: 1.3;
  text-transform: uppercase;
  white-space: nowrap; }

.event-planner-view__team-owner {
  flex-shrink: 0;
  margin-left: auto;
  padding-left: 0.45rem;
  overflow: hidden;
  color: #747b81;
  font-size: 0.72rem;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap; }

.event-planner-view__vehicle-display-title {
  display: flex;
  flex-direction: column;
  gap: 0.08rem;
  min-width: 0; }
  .event-planner-view__vehicle-display-title > strong {
    overflow: hidden;
    color: #ffffff;
    font-weight: 700;
    text-overflow: ellipsis;
    white-space: nowrap; }

.event-planner-view__vehicle-display-custom-name {
  overflow: hidden;
  color: #b8b8b8;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  line-height: 1.15;
  min-height: 0.83rem;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap; }
  .event-planner-view__vehicle-display-custom-name.is-placeholder {
    visibility: hidden; }

.event-planner-view__position-vehicle-chip {
  display: inline-flex;
  align-items: flex-start;
  gap: 0.28rem;
  max-width: auto;
  width: auto;
  margin-top: 0.2rem;
  padding: 0.14rem 0.5rem;
  border: 1px solid rgba(90, 195, 255, 0.32);
  border-radius: 999px;
  background: #0c2637;
  color: #dfdfdf;
  font-size: 0.68rem;
  font-weight: 600;
  line-height: 1.2;
  cursor: grab;
  touch-action: none;
  user-select: none;
  transition: border-color 0.15s ease, background-color 0.15s ease, opacity 0.15s ease; }
  .event-planner-view__position-vehicle-chip .event-planner-view__vehicle-display-title > strong {
    font-size: inherit;
    font-weight: 600; }
  .event-planner-view__position-vehicle-chip .event-planner-view__vehicle-display-custom-name {
    font-size: 0.62rem; }
  .event-planner-view__position-vehicle-chip .event-planner-view__vehicle-display-title {
    flex: 1;
    min-width: 0; }
  .event-planner-view__position-vehicle-chip .event-planner-view__team-owner {
    align-self: center;
    font-size: 0.62rem;
    padding-left: 0.35rem; }
  .event-planner-view__position-vehicle-chip:hover {
    border-color: rgba(90, 195, 255, 0.5);
    background: rgba(12, 38, 55, 0.92); }
  .event-planner-view__position-vehicle-chip.is-dragging {
    opacity: 0.4; }
  .event-planner-view__position-vehicle-chip--overlay {
    cursor: grabbing;
    box-shadow: 0 8px 18px rgba(21, 28, 36, 0.65); }

.event-planner-view__position-vehicle-chip-icon {
  flex-shrink: 0;
  width: 0.75rem;
  height: 0.75rem;
  color: #5ac3ff; }

.event-planner-view__position-vehicle-chip-label {
  min-width: 0; }

.event-planner-view__position-order {
  margin-right: 0.2rem;
  color: #747b81; }

.event-planner-view__position-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  flex: 1;
  min-height: 2.1rem;
  color: #747b81;
  font-size: 0.68rem;
  text-align: center; }

.event-planner-view__position-empty-icon {
  width: 0.85rem;
  height: 0.85rem;
  color: rgba(90, 195, 255, 0.75); }

.event-planner-view__no-positions {
  margin: 0;
  padding: 0.75rem 0;
  color: #747b81;
  font-size: 0.82rem;
  text-align: center; }

@media (max-width: 1000px) {
  .event-planner-view {
    overflow-x: auto; }
  .event-planner-view__layout {
    grid-template-columns: 220px minmax(700px, 1fr) 260px;
    min-width: 1220px; }
  .event-planner-view__variant-group {
    grid-column: 1 / -1; } }

@media (max-width: 800px) {
  .event-planner-view__header-main-row {
    grid-template-columns: 1fr;
    align-items: stretch; }
  .event-planner-view__header-main-row {
    grid-template-columns: 1fr; }
  .event-planner-view__header-info {
    width: auto;
    max-width: 300px; }
  .event-planner-view__header-toolbar-main {
    flex-wrap: wrap; }
  .event-planner-view__header-search {
    flex: 1 1 100%;
    max-width: none; }
  .event-planner-view__bulk-expand-toggle {
    align-self: flex-end; }
  .event-planner-view__header-actions {
    justify-content: flex-end; }
  .event-planner-view__header-actions-column {
    align-items: stretch; }
  .event-planner-view__team-tags {
    align-self: flex-end; }
  .event-planner-view__team-tags-panel {
    right: 0;
    left: auto;
    width: min(22rem, calc(100vw - 1.5rem)); }
  .event-planner-view__layout {
    grid-template-columns: 1fr;
    min-width: 0; }
  .event-planner-view__participant-pool {
    max-height: none; }
  .event-planner-view__sidebar {
    order: -1;
    max-height: none; }
  .event-planner-view__variant-group {
    grid-column: 1 / -1; } }

.calendar-event-modal.calendar-event-modal--planner .modal-dialog {
  width: 95vw;
  max-width: 95vw;
  margin-left: auto;
  margin-right: auto; }

.calendar-event-modal.calendar-event-modal--planner .modal-dialog .modal-content.event-planner-modal-content {
  width: 95vw;
  max-width: 95vw;
  min-width: 0;
  height: auto;
  min-height: 0;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box; }

.calendar-event-modal.calendar-event-modal--planner .modal-body {
  padding: 0; }

.event-planner-view__fighter-vehicle-column {
  display: flex;
  flex-direction: column;
  gap: 0.55rem; }
  .event-planner-view__fighter-vehicle-column--collapsed {
    padding-top: 0.35rem; }

.event-planner-view__variant-group-teams--fighters > .event-planner-view__team--fighter-section {
  flex: 0 0 var(--event-planner-position-column-width, 280px);
  width: var(--event-planner-position-column-width, 280px);
  min-width: var(--event-planner-position-column-width, 280px);
  max-width: var(--event-planner-team-max-width, 300px); }

.event-planner-view__team--fighter-section {
  min-width: var(--event-planner-position-column-width, 280px);
  max-width: var(--event-planner-team-max-width, 300px);
  width: 100%;
  box-sizing: border-box; }
  .event-planner-view__team--fighter-section.is-collapsed .event-planner-view__team-header {
    padding-bottom: 0;
    border-bottom: 0; }
  .event-planner-view__team--fighter-section .event-planner-view__team-header {
    margin-bottom: 0.35rem; }
  .event-planner-view__team--fighter-section .event-planner-view__team-title {
    flex-wrap: wrap;
    align-items: center;
    gap: 0.35rem; }

.event-planner-view__fighter-vehicle-slot {
  padding: 0.45rem 0.5rem;
  border: 1px solid rgba(56, 72, 88, 0.55);
  border-radius: 8px;
  background: rgba(12, 38, 55, 0.55); }
  .event-planner-view__fighter-vehicle-slot.is-over {
    border-color: rgba(90, 195, 255, 0.65);
    background: rgba(0, 72, 114, 0.12); }
  .event-planner-view__fighter-vehicle-slot--leader {
    border-color: rgba(199, 132, 69, 0.45); }
  .event-planner-view__fighter-vehicle-slot.has-orphaned-crew {
    border-color: rgba(209, 35, 35, 0.85);
    box-shadow: 0 0 0 1px rgba(209, 35, 35, 0.35);
    background: rgba(73, 18, 18, 0.28); }
    .event-planner-view__fighter-vehicle-slot.has-orphaned-crew.is-over {
      border-color: rgba(209, 35, 35, 0.95);
      background: rgba(73, 18, 18, 0.38); }
    .event-planner-view__fighter-vehicle-slot.has-orphaned-crew .event-planner-view__fighter-vehicle-empty {
      border-color: rgba(209, 35, 35, 0.7);
      color: rgba(184, 184, 184, 0.85);
      background: rgba(126, 30, 30, 0.22); }

.event-planner-view__fighter-vehicle-slot-header {
  margin-bottom: 0.3rem; }

.event-planner-view__fighter-vehicle-slot-role {
  color: #b8b8b8;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase; }
  .event-planner-view__fighter-vehicle-slot-role--leader {
    color: #c78445; }

.event-planner-view__fighter-vehicle-header {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  margin-bottom: 0.35rem;
  padding: 0.25rem 0.35rem;
  border: 1px solid rgba(90, 195, 255, 0.28);
  border-radius: 6px;
  background: rgba(22, 52, 71, 0.35);
  cursor: grab;
  min-width: 0; }
  .event-planner-view__fighter-vehicle-header.is-dragging {
    opacity: 0.45; }
  .event-planner-view__fighter-vehicle-header .event-planner-view__team-owner {
    flex-shrink: 1;
    min-width: 0;
    max-width: 42%;
    margin-left: auto;
    font-size: 0.62rem;
    text-align: right; }

.event-planner-view__fighter-vehicle-header-icon {
  flex-shrink: 0;
  width: 0.75rem;
  height: 0.75rem;
  color: #5ac3ff; }
  .event-planner-view__fighter-vehicle-header-icon svg {
    display: block;
    width: 100%;
    height: 100%; }

.event-planner-view__fighter-vehicle-header-name {
  display: flex;
  flex-direction: column;
  gap: 0.08rem;
  font-size: 0.78rem;
  min-width: 0;
  flex: 1; }

.event-planner-view__fighter-vehicle-empty {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.35rem 0.45rem;
  border: 1px dashed rgba(56, 72, 88, 0.75);
  border-radius: 6px;
  color: #747b81;
  font-size: 0.72rem; }

.event-planner-view__fighter-crew-slots,
.event-planner-view__vehicle-crew-slots {
  display: flex;
  flex-direction: column;
  gap: 0.35rem; }

.event-planner-view__fighter-crew-slot,
.event-planner-view__vehicle-crew-slot {
  padding: 0.3rem 0.35rem;
  border: 1px solid rgba(56, 72, 88, 0.4);
  border-radius: 6px; }
  .event-planner-view__fighter-crew-slot.is-over,
  .event-planner-view__vehicle-crew-slot.is-over {
    border-color: rgba(90, 195, 255, 0.55); }
  .event-planner-view__fighter-crew-slot--leader,
  .event-planner-view__vehicle-crew-slot--leader {
    border-color: rgba(199, 132, 69, 0.35); }

.event-planner-view__convoy-group .event-planner-view__convoy-vehicle {
  border: 1px solid rgba(93, 117, 106, 0.58);
  background: rgba(50, 63, 57, 0.9) !important; }

.event-planner-view__convoy-group .event-planner-view__vehicle-crew-slot,
.event-planner-view__convoy-vehicle .event-planner-view__vehicle-crew-slot {
  padding: 0.35rem 0.4rem;
  border: 1px dashed rgba(138, 168, 153, 0.62);
  border-radius: 7px;
  background: rgba(40, 49, 45, 0.96);
  transition: border-color 0.15s ease, background-color 0.15s ease; }
  .event-planner-view__convoy-group .event-planner-view__vehicle-crew-slot.is-over,
  .event-planner-view__convoy-vehicle .event-planner-view__vehicle-crew-slot.is-over {
    border-color: rgba(117, 207, 120, 0.55);
    background: rgba(50, 63, 57, 0.95); }
  .event-planner-view__convoy-group .event-planner-view__vehicle-crew-slot--leader,
  .event-planner-view__convoy-vehicle .event-planner-view__vehicle-crew-slot--leader {
    border-color: rgba(199, 132, 69, 0.45); }

.event-planner-view__convoy-group .event-planner-view__vehicle-crew-slot-label,
.event-planner-view__convoy-vehicle .event-planner-view__vehicle-crew-slot-label {
  color: #9bc4b0;
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase; }
  .event-planner-view__convoy-group .event-planner-view__vehicle-crew-slot-label--leader,
  .event-planner-view__convoy-vehicle .event-planner-view__vehicle-crew-slot-label--leader {
    color: #c78445; }

.event-planner-view__convoy-group .event-planner-view__position-empty--compact,
.event-planner-view__convoy-vehicle .event-planner-view__position-empty--compact {
  border: 1px dashed rgba(138, 168, 153, 0.35);
  border-radius: 6px;
  background: rgba(12, 38, 55, 0.35); }

.event-planner-view__fighter-crew-slot-label-row {
  margin-bottom: 0.2rem; }
  .event-planner-view__fighter-crew-slot-label-row .event-planner-view__fighter-crew-slot-label {
    display: inline;
    margin-bottom: 0;
    flex: 1;
    min-width: 0; }

.event-planner-view__position--group-leader .event-planner-view__position-label-row {
  margin-bottom: 0.35rem; }

.event-planner-view__fighter-crew-slot-label,
.event-planner-view__vehicle-crew-slot-label {
  display: block;
  margin-bottom: 0.2rem;
  color: #747b81;
  font-size: 0.68rem;
  font-weight: 600; }
  .event-planner-view__fighter-crew-slot-label--leader,
  .event-planner-view__vehicle-crew-slot-label--leader {
    color: #c78445; }

.event-planner-view__position-empty--compact {
  padding: 0.2rem 0.25rem;
  font-size: 0.68rem; }

.event-planner-view__convoy-group {
  --convoy-vehicle-count: 1;
  grid-column: span var(--convoy-vehicle-count);
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  width: 100%;
  min-width: 0;
  padding: 0.55rem;
  box-sizing: border-box;
  position: relative;
  z-index: 2; }
  .event-planner-view__convoy-group.is-expanded {
    box-sizing: border-box;
    width: fit-content;
    min-width: calc( var(--convoy-vehicle-count) * var(--event-planner-position-column-width) + var(--convoy-insert-zone-count, 0) * 0.9rem + ( var(--convoy-vehicle-count) + var(--convoy-insert-zone-count, 0) - 1 ) * 0.55rem + 1.1rem);
    max-width: 100cqw;
    justify-self: center; }
  .event-planner-view__convoy-group.event-planner-view__ground-theme, .event-planner-view__convoy-group[class*="mo-structure-card-bg-"] {
    border-radius: 12px;
    transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease; }
    .event-planner-view__convoy-group.event-planner-view__ground-theme:not([class*="mo-structure-card-bg-"]), .event-planner-view__convoy-group[class*="mo-structure-card-bg-"]:not([class*="mo-structure-card-bg-"]) {
      border: 1px solid rgba(111, 149, 133, 0.68);
      background: linear-gradient(145deg, rgba(46, 66, 59, 0.96), rgba(58, 82, 73, 0.92));
      box-shadow: 0 8px 22px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(74, 99, 88, 0.22), 0 0 18px rgba(117, 207, 120, 0.22), inset 0 1px 0 rgba(138, 168, 153, 0.14); }
    .event-planner-view__convoy-group.event-planner-view__ground-theme[class*="mo-structure-card-bg-"], .event-planner-view__convoy-group[class*="mo-structure-card-bg-"][class*="mo-structure-card-bg-"] {
      border-width: 1px;
      border-style: solid;
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.26), 0 0 14px rgba(74, 99, 88, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.06); }
  .event-planner-view__convoy-group.is-collapsed .event-planner-view__convoy-group-header {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: 0; }

.event-planner-view__ground-theme:not([class*="mo-structure-card-bg-"]) {
  border-color: rgba(111, 149, 133, 0.68) !important;
  background: linear-gradient(145deg, rgba(46, 66, 59, 0.96), rgba(58, 82, 73, 0.92)) !important; }

.event-planner-view__convoy-group-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.45rem;
  margin-bottom: 0;
  padding-bottom: 0.45rem;
  border-bottom: 1px solid rgba(74, 99, 88, 0.52); }

.event-planner-view__ground-vehicle-standalone .event-planner-view__convoy-vehicle-header {
  margin-bottom: 0;
  padding-bottom: 0.45rem;
  border-bottom: 1px solid rgba(74, 99, 88, 0.52); }

.event-planner-view__convoy-vehicle-header-stats {
  margin-left: auto; }

.event-planner-view__convoy-commander {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding: 0.35rem 0.45rem;
  border: 1px solid rgba(199, 132, 69, 0.35);
  border-radius: 6px;
  background: rgba(199, 132, 69, 0.08); }
  .event-planner-view__convoy-commander--empty {
    color: #747b81;
    font-size: 0.72rem; }

.event-planner-view__convoy-commander-label {
  color: #c78445;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase; }

.event-planner-view__convoy-vehicle-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  align-items: stretch;
  gap: 0.55rem;
  align-self: center;
  width: max-content;
  max-width: 100%;
  max-width: 100cqw;
  min-width: 0; }
  .event-planner-view__convoy-vehicle-row > .event-planner-view__convoy-vehicle {
    flex: 0 0 var(--event-planner-position-column-width, 280px);
    width: var(--event-planner-position-column-width, 280px);
    min-width: var(--event-planner-position-column-width, 280px);
    max-width: var(--event-planner-position-column-width, 280px);
    box-sizing: border-box; }

.event-planner-view__convoy-vehicle {
  box-sizing: border-box;
  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease; }
  .event-planner-view__convoy-vehicle:not(.event-planner-view__ground-vehicle-standalone) {
    padding: 0.45rem;
    border-radius: 8px; }
    .event-planner-view__convoy-vehicle:not(.event-planner-view__ground-vehicle-standalone):not([class*="mo-structure-card-bg-"]):not(.event-planner-view__ground-theme) {
      border: 1px solid rgba(93, 117, 106, 0.5);
      background: rgba(50, 63, 57, 0.88); }
  .event-planner-view__convoy-vehicle.event-planner-view__ground-vehicle-standalone.event-planner-view__ground-theme, .event-planner-view__convoy-vehicle.event-planner-view__ground-vehicle-standalone[class*="mo-structure-card-bg-"] {
    border-radius: 12px;
    transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
    padding: 0.55rem; }
    .event-planner-view__convoy-vehicle.event-planner-view__ground-vehicle-standalone.event-planner-view__ground-theme:not([class*="mo-structure-card-bg-"]), .event-planner-view__convoy-vehicle.event-planner-view__ground-vehicle-standalone[class*="mo-structure-card-bg-"]:not([class*="mo-structure-card-bg-"]) {
      border: 1px solid rgba(111, 149, 133, 0.68);
      background: linear-gradient(145deg, rgba(46, 66, 59, 0.96), rgba(58, 82, 73, 0.92));
      box-shadow: 0 8px 22px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(74, 99, 88, 0.22), 0 0 18px rgba(117, 207, 120, 0.22), inset 0 1px 0 rgba(138, 168, 153, 0.14); }
    .event-planner-view__convoy-vehicle.event-planner-view__ground-vehicle-standalone.event-planner-view__ground-theme[class*="mo-structure-card-bg-"], .event-planner-view__convoy-vehicle.event-planner-view__ground-vehicle-standalone[class*="mo-structure-card-bg-"][class*="mo-structure-card-bg-"] {
      border-width: 1px;
      border-style: solid;
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.26), 0 0 14px rgba(74, 99, 88, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.06); }
  .event-planner-view__convoy-vehicle.is-over:not(.event-planner-view__ground-vehicle-standalone) {
    border-color: rgba(138, 168, 153, 0.72);
    background: rgba(50, 63, 57, 0.98);
    box-shadow: 0 0 0 1px rgba(117, 207, 120, 0.45); }
  .event-planner-view__convoy-vehicle.event-planner-view__ground-vehicle-standalone.is-over {
    filter: brightness(1.04); }
  .event-planner-view__convoy-vehicle.is-dragging {
    opacity: 0.45; }

.event-planner-view__convoy-vehicle-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem;
  margin-bottom: 0.35rem;
  cursor: default; }
  .event-planner-view__convoy-vehicle-header.is-dragging {
    opacity: 0.45;
    cursor: grabbing; }
  .event-planner-view__convoy-vehicle-header:has(.event-planner-view__drag-hint) {
    cursor: grab; }

.event-planner-view__convoy-vehicle-title {
  display: flex;
  flex-direction: column;
  gap: 0.08rem;
  min-width: 0;
  flex: 1; }

.event-planner-view__convoy-insert-zone {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  min-height: 1.6rem;
  padding: 0.2rem 0.35rem;
  border: 1px dashed rgba(56, 72, 88, 0.65);
  border-radius: 6px;
  color: #747b81;
  font-size: 0.66rem; }
  .event-planner-view__convoy-insert-zone.is-over {
    border-color: rgba(90, 195, 255, 0.65);
    color: #dfdfdf;
    background: rgba(0, 72, 114, 0.1); }

.event-planner-view__convoy-vehicle-row .event-planner-view__convoy-insert-zone {
  flex: 0 0 0.9rem;
  align-self: stretch;
  flex-direction: column;
  border: 1px solid darkolivegreen;
  min-width: 0.9rem;
  min-height: 5rem;
  padding: 0.25rem 0.1rem;
  font-size: 0; }
  .event-planner-view__convoy-vehicle-row .event-planner-view__convoy-insert-zone .event-planner-view__drag-hint {
    width: 0.85rem;
    height: 0.85rem;
    flex-shrink: 0; }
  .event-planner-view__convoy-vehicle-row .event-planner-view__convoy-insert-zone > span {
    display: none; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.event-assignment-view {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  min-height: 60vh;
  max-height: 85vh;
  overflow: hidden;
  box-sizing: border-box;
  color: #dfdfdf;
  background: radial-gradient(ellipse 120% 80% at 50% -20%, rgba(58, 120, 180, 0.14), transparent 55%), linear-gradient(180deg, rgba(0, 48, 77, 0.94), rgba(21, 28, 36, 0.72)); }
  .event-assignment-view.event-planner-view {
    overflow-x: hidden; }
    .event-assignment-view.event-planner-view .event-planner-view__header {
      flex-shrink: 0;
      min-width: 0;
      border-bottom: 1px solid rgba(58, 120, 180, 0.2);
      background: rgba(0, 48, 77, 0.55); }

.event-assignment-view__workspace {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(260px, 320px);
  grid-template-rows: minmax(0, 1fr) auto;
  grid-template-areas: "main sidebar" "legend legend";
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow: hidden; }

.event-assignment-view__main {
  grid-area: main;
  min-width: 0;
  min-height: 0;
  overflow-x: clip;
  overflow-y: auto;
  padding: 1rem 1.25rem 1.25rem;
  margin-right: -10px;
  padding-right: 10px;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.35) rgba(0, 0, 0, 0.12); }
  .event-assignment-view__main::-webkit-scrollbar {
    width: 6px; }
  .event-assignment-view__main::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.12);
    border-radius: 999px; }
  .event-assignment-view__main::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.3);
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.08); }
  .event-assignment-view__main::-webkit-scrollbar-thumb:hover {
    background: rgba(58, 120, 180, 0.42); }

.event-assignment-view__legend {
  grid-area: legend;
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.85rem 1.5rem;
  padding: 0.6rem 1rem 0.8rem;
  border-top: 1px solid rgba(58, 120, 180, 0.18);
  background: rgba(0, 48, 77, 0.45);
  font-size: 0.72rem;
  color: rgba(223, 223, 223, 0.58); }

.event-assignment-view__legend-item {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem; }
  .event-assignment-view__legend-item::before {
    content: "";
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    flex-shrink: 0; }

.event-assignment-view__legend-item--own::before {
  background: #5ac3ff;
  box-shadow: 0 0 8px rgba(90, 195, 255, 0.55); }

.event-assignment-view__legend-item--related::before {
  background: #75cf78;
  box-shadow: 0 0 6px rgba(117, 207, 120, 0.4); }

.event-assignment-view__legend-item--other::before {
  background: rgba(116, 123, 129, 0.7); }

.event-assignment-view__status {
  padding: 2rem 1.5rem;
  text-align: center;
  color: rgba(223, 223, 223, 0.65); }

.event-assignment-view__status--error {
  color: #d12323; }

.event-assignment-view__alert {
  margin: 1.5rem;
  padding: 1rem 1.25rem;
  border: 1px solid rgba(199, 132, 69, 0.55);
  border-radius: 8px;
  background: rgba(110, 68, 28, 0.35);
  color: #dfdfdf; }

.assignment-view-board {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 3.5rem;
  width: 100%;
  min-width: 0; }

.assignment-view-board-canvas {
  position: relative;
  width: 100%;
  min-width: 0;
  overflow: hidden;
  --event-planner-card-gap: 3.5rem; }

.assignment-view-board-canvas .event-planner-view__card-links-layer {
  overflow: visible;
  z-index: 2;
  pointer-events: none; }

.assignment-view-board-canvas .event-planner-view__card-links--visual {
  z-index: 2; }

.assignment-view-board-canvas .event-planner-view__card-links--interactive {
  pointer-events: none; }

.assignment-view-board-canvas .event-planner-view__card-link-path {
  fill: none;
  stroke: rgba(90, 195, 255, 0.82);
  stroke-width: 2;
  stroke-dasharray: none;
  transition: stroke 120ms ease, stroke-width 120ms ease; }

.assignment-view-board-canvas .event-planner-view__card-link-path.is-highlighted {
  stroke: rgba(90, 195, 255, 0.92);
  stroke-width: 2.25; }

.assignment-view-board-canvas .event-planner-view__card-link-path.is-selected {
  stroke: rgba(170, 158, 116, 0.98);
  stroke-width: 3.25;
  filter: drop-shadow(0 0 4px rgba(170, 158, 116, 0.45)); }

.assignment-view-board-canvas .event-planner-view__card-link-arrow {
  fill: rgba(90, 195, 255, 0.82);
  transition: fill 120ms ease; }

.assignment-view-board-canvas .event-planner-view__card-link-arrow.is-highlighted {
  fill: rgba(90, 195, 255, 0.92); }

.assignment-view-board-canvas .event-planner-view__card-link-arrow.is-selected {
  fill: rgba(170, 158, 116, 0.98);
  filter: drop-shadow(0 0 3px rgba(170, 158, 116, 0.4)); }

.assignment-view-board-canvas .event-planner-view__card-link-attach.is-highlighted,
.assignment-view-board-canvas .event-planner-view__card-link-attach.is-selected {
  fill: rgba(22, 52, 71, 0.95);
  stroke: rgba(170, 158, 116, 0.95);
  stroke-width: 2.5; }

.assignment-view-board-canvas .event-planner-view__card-link-path-hit {
  pointer-events: none; }

.assignment-view-card,
.assignment-view-nested-team {
  position: relative;
  z-index: 1; }

.assignment-view-board__ancestors {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
  gap: 3.5rem;
  width: 100%; }

.assignment-view-board--catalog {
  gap: calc(3.5rem + 0.35rem); }

.assignment-view-board__catalog-section {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.55rem;
  width: 100%; }

.assignment-view-board__catalog-section-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 330px));
  justify-content: center;
  gap: 3.5rem;
  width: 100%;
  min-width: 0; }

.assignment-view-inline-peer-row,
.assignment-view-standalone-ship-row,
.assignment-view-fighter-flight-row,
.assignment-view-infantry-peer-row,
.assignment-view-convoy-peer-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: flex-start;
  gap: 3rem;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  --event-planner-card-gap: 3rem; }
  .assignment-view-inline-peer-row > .assignment-view-card--team,
  .assignment-view-standalone-ship-row > .assignment-view-card--team,
  .assignment-view-fighter-flight-row > .assignment-view-card--team,
  .assignment-view-infantry-peer-row > .assignment-view-card--team,
  .assignment-view-convoy-peer-row > .assignment-view-card--team {
    flex: 0 0 330px;
    width: 330px;
    min-width: 330px;
    max-width: 330px; }
  .assignment-view-inline-peer-row > .assignment-view-card--group,
  .assignment-view-standalone-ship-row > .assignment-view-card--group,
  .assignment-view-fighter-flight-row > .assignment-view-card--group,
  .assignment-view-infantry-peer-row > .assignment-view-card--group,
  .assignment-view-convoy-peer-row > .assignment-view-card--group {
    flex: 0 1 auto;
    width: max-content;
    min-width: 0;
    max-width: 100%; }

.assignment-view-board__standalone-ships,
.assignment-view-board__fighter-flights,
.assignment-view-board__infantry-peers,
.assignment-view-board__convoy-peers,
.assignment-view-board__inline-peer-row {
  width: 100%;
  min-width: 0; }

.assignment-view-board__standalone-ships .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--size-focus, .assignment-view-board__standalone-ships .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--size-peer, .assignment-view-board__standalone-ships .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--size-chain, .assignment-view-board__standalone-ships .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--layout-tree, .assignment-view-board__standalone-ships .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--layout-focus, .assignment-view-board__standalone-ships .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--layout-periphery, .assignment-view-board__standalone-ships .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--layout-catalog, .assignment-view-board__standalone-ships .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--width-ancestor, .assignment-view-board__standalone-ships .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--command-ship,
.assignment-view-board__standalone-ships .assignment-view-standalone-ship-row > .assignment-view-card--team.assignment-view-card--size-focus,
.assignment-view-board__standalone-ships .assignment-view-standalone-ship-row > .assignment-view-card--team.assignment-view-card--size-peer,
.assignment-view-board__standalone-ships .assignment-view-standalone-ship-row > .assignment-view-card--team.assignment-view-card--size-chain,
.assignment-view-board__standalone-ships .assignment-view-standalone-ship-row > .assignment-view-card--team.assignment-view-card--layout-tree,
.assignment-view-board__standalone-ships .assignment-view-standalone-ship-row > .assignment-view-card--team.assignment-view-card--layout-focus,
.assignment-view-board__standalone-ships .assignment-view-standalone-ship-row > .assignment-view-card--team.assignment-view-card--layout-periphery,
.assignment-view-board__standalone-ships .assignment-view-standalone-ship-row > .assignment-view-card--team.assignment-view-card--layout-catalog,
.assignment-view-board__standalone-ships .assignment-view-standalone-ship-row > .assignment-view-card--team.assignment-view-card--width-ancestor,
.assignment-view-board__standalone-ships .assignment-view-standalone-ship-row > .assignment-view-card--team.assignment-view-card--command-ship {
  flex: 0 0 330px;
  width: 100%;
  max-width: 330px; }

.assignment-view-board__fighter-flights .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--size-focus, .assignment-view-board__fighter-flights .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--size-peer, .assignment-view-board__fighter-flights .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--size-chain, .assignment-view-board__fighter-flights .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--layout-tree, .assignment-view-board__fighter-flights .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--layout-focus, .assignment-view-board__fighter-flights .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--layout-periphery, .assignment-view-board__fighter-flights .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--layout-catalog, .assignment-view-board__fighter-flights .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--width-ancestor, .assignment-view-board__fighter-flights .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--family-fighters,
.assignment-view-board__fighter-flights .assignment-view-fighter-flight-row > .assignment-view-card--team.assignment-view-card--size-focus,
.assignment-view-board__fighter-flights .assignment-view-fighter-flight-row > .assignment-view-card--team.assignment-view-card--size-peer,
.assignment-view-board__fighter-flights .assignment-view-fighter-flight-row > .assignment-view-card--team.assignment-view-card--size-chain,
.assignment-view-board__fighter-flights .assignment-view-fighter-flight-row > .assignment-view-card--team.assignment-view-card--layout-tree,
.assignment-view-board__fighter-flights .assignment-view-fighter-flight-row > .assignment-view-card--team.assignment-view-card--layout-focus,
.assignment-view-board__fighter-flights .assignment-view-fighter-flight-row > .assignment-view-card--team.assignment-view-card--layout-periphery,
.assignment-view-board__fighter-flights .assignment-view-fighter-flight-row > .assignment-view-card--team.assignment-view-card--layout-catalog,
.assignment-view-board__fighter-flights .assignment-view-fighter-flight-row > .assignment-view-card--team.assignment-view-card--width-ancestor,
.assignment-view-board__fighter-flights .assignment-view-fighter-flight-row > .assignment-view-card--team.assignment-view-card--family-fighters {
  flex: 0 0 330px;
  width: 330px;
  min-width: 330px;
  max-width: 330px; }

.assignment-view-board__infantry-peers .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--size-focus, .assignment-view-board__infantry-peers .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--size-peer, .assignment-view-board__infantry-peers .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--size-chain, .assignment-view-board__infantry-peers .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--layout-tree, .assignment-view-board__infantry-peers .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--layout-focus, .assignment-view-board__infantry-peers .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--layout-periphery, .assignment-view-board__infantry-peers .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--layout-catalog, .assignment-view-board__infantry-peers .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--width-ancestor, .assignment-view-board__infantry-peers .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--family-infantry,
.assignment-view-board__infantry-peers .assignment-view-infantry-peer-row > .assignment-view-card--team.assignment-view-card--size-focus,
.assignment-view-board__infantry-peers .assignment-view-infantry-peer-row > .assignment-view-card--team.assignment-view-card--size-peer,
.assignment-view-board__infantry-peers .assignment-view-infantry-peer-row > .assignment-view-card--team.assignment-view-card--size-chain,
.assignment-view-board__infantry-peers .assignment-view-infantry-peer-row > .assignment-view-card--team.assignment-view-card--layout-tree,
.assignment-view-board__infantry-peers .assignment-view-infantry-peer-row > .assignment-view-card--team.assignment-view-card--layout-focus,
.assignment-view-board__infantry-peers .assignment-view-infantry-peer-row > .assignment-view-card--team.assignment-view-card--layout-periphery,
.assignment-view-board__infantry-peers .assignment-view-infantry-peer-row > .assignment-view-card--team.assignment-view-card--layout-catalog,
.assignment-view-board__infantry-peers .assignment-view-infantry-peer-row > .assignment-view-card--team.assignment-view-card--width-ancestor,
.assignment-view-board__infantry-peers .assignment-view-infantry-peer-row > .assignment-view-card--team.assignment-view-card--family-infantry {
  flex: 0 0 330px;
  width: 330px;
  min-width: 330px;
  max-width: 330px; }

.assignment-view-board__convoy-peers .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--size-focus, .assignment-view-board__convoy-peers .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--size-peer, .assignment-view-board__convoy-peers .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--size-chain, .assignment-view-board__convoy-peers .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--layout-tree, .assignment-view-board__convoy-peers .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--layout-focus, .assignment-view-board__convoy-peers .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--layout-periphery, .assignment-view-board__convoy-peers .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--layout-catalog, .assignment-view-board__convoy-peers .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--width-ancestor, .assignment-view-board__convoy-peers .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--family-convoy,
.assignment-view-board__convoy-peers .assignment-view-convoy-peer-row > .assignment-view-card--team.assignment-view-card--size-focus,
.assignment-view-board__convoy-peers .assignment-view-convoy-peer-row > .assignment-view-card--team.assignment-view-card--size-peer,
.assignment-view-board__convoy-peers .assignment-view-convoy-peer-row > .assignment-view-card--team.assignment-view-card--size-chain,
.assignment-view-board__convoy-peers .assignment-view-convoy-peer-row > .assignment-view-card--team.assignment-view-card--layout-tree,
.assignment-view-board__convoy-peers .assignment-view-convoy-peer-row > .assignment-view-card--team.assignment-view-card--layout-focus,
.assignment-view-board__convoy-peers .assignment-view-convoy-peer-row > .assignment-view-card--team.assignment-view-card--layout-periphery,
.assignment-view-board__convoy-peers .assignment-view-convoy-peer-row > .assignment-view-card--team.assignment-view-card--layout-catalog,
.assignment-view-board__convoy-peers .assignment-view-convoy-peer-row > .assignment-view-card--team.assignment-view-card--width-ancestor,
.assignment-view-board__convoy-peers .assignment-view-convoy-peer-row > .assignment-view-card--team.assignment-view-card--family-convoy {
  flex: 0 0 330px;
  width: 330px;
  min-width: 330px;
  max-width: 330px; }

.assignment-view-board__catalog-section--commandShip .assignment-view-board__catalog-section-grid,
.assignment-view-board__catalog-section--ships .assignment-view-board__catalog-section-grid,
.assignment-view-board__catalog-section--squadrons .assignment-view-board__catalog-section-grid,
.assignment-view-board__catalog-section--infantry .assignment-view-board__catalog-section-grid,
.assignment-view-board__catalog-section--groundVehicles .assignment-view-board__catalog-section-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: flex-start;
  gap: 3rem;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  --event-planner-card-gap: 3rem; }
  .assignment-view-board__catalog-section--commandShip .assignment-view-board__catalog-section-grid > .assignment-view-card--team,
  .assignment-view-board__catalog-section--ships .assignment-view-board__catalog-section-grid > .assignment-view-card--team,
  .assignment-view-board__catalog-section--squadrons .assignment-view-board__catalog-section-grid > .assignment-view-card--team,
  .assignment-view-board__catalog-section--infantry .assignment-view-board__catalog-section-grid > .assignment-view-card--team,
  .assignment-view-board__catalog-section--groundVehicles .assignment-view-board__catalog-section-grid > .assignment-view-card--team {
    flex: 0 0 330px;
    width: 330px;
    min-width: 330px;
    max-width: 330px; }
  .assignment-view-board__catalog-section--commandShip .assignment-view-board__catalog-section-grid > .assignment-view-card--group,
  .assignment-view-board__catalog-section--ships .assignment-view-board__catalog-section-grid > .assignment-view-card--group,
  .assignment-view-board__catalog-section--squadrons .assignment-view-board__catalog-section-grid > .assignment-view-card--group,
  .assignment-view-board__catalog-section--infantry .assignment-view-board__catalog-section-grid > .assignment-view-card--group,
  .assignment-view-board__catalog-section--groundVehicles .assignment-view-board__catalog-section-grid > .assignment-view-card--group {
    flex: 0 1 auto;
    width: max-content;
    min-width: 0;
    max-width: 100%; }

.assignment-view-board__ancestors--standalone-ships {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: flex-start;
  gap: 3rem;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  --event-planner-card-gap: 3rem; }
  .assignment-view-board__ancestors--standalone-ships > .assignment-view-card--team {
    flex: 0 0 330px;
    width: 330px;
    min-width: 330px;
    max-width: 330px; }
  .assignment-view-board__ancestors--standalone-ships > .assignment-view-card--group {
    flex: 0 1 auto;
    width: max-content;
    min-width: 0;
    max-width: 100%; }

.assignment-view-tree__siblings.assignment-view-inline-peer-row,
.assignment-view-tree__siblings.assignment-view-standalone-ship-row,
.assignment-view-tree__siblings.assignment-view-fighter-flight-row,
.assignment-view-tree__siblings.assignment-view-infantry-peer-row,
.assignment-view-tree__siblings.assignment-view-convoy-peer-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: flex-start;
  gap: 3rem;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  --event-planner-card-gap: 3rem; }
  .assignment-view-tree__siblings.assignment-view-inline-peer-row > .assignment-view-card--team,
  .assignment-view-tree__siblings.assignment-view-standalone-ship-row > .assignment-view-card--team,
  .assignment-view-tree__siblings.assignment-view-fighter-flight-row > .assignment-view-card--team,
  .assignment-view-tree__siblings.assignment-view-infantry-peer-row > .assignment-view-card--team,
  .assignment-view-tree__siblings.assignment-view-convoy-peer-row > .assignment-view-card--team {
    flex: 0 0 330px;
    width: 330px;
    min-width: 330px;
    max-width: 330px; }
  .assignment-view-tree__siblings.assignment-view-inline-peer-row > .assignment-view-card--group,
  .assignment-view-tree__siblings.assignment-view-standalone-ship-row > .assignment-view-card--group,
  .assignment-view-tree__siblings.assignment-view-fighter-flight-row > .assignment-view-card--group,
  .assignment-view-tree__siblings.assignment-view-infantry-peer-row > .assignment-view-card--group,
  .assignment-view-tree__siblings.assignment-view-convoy-peer-row > .assignment-view-card--group {
    flex: 0 1 auto;
    width: max-content;
    min-width: 0;
    max-width: 100%; }

.assignment-view-board__periphery-grid.assignment-view-inline-peer-row,
.assignment-view-board__periphery-grid.assignment-view-standalone-ship-row,
.assignment-view-board__periphery-grid.assignment-view-fighter-flight-row,
.assignment-view-board__periphery-grid.assignment-view-infantry-peer-row,
.assignment-view-board__periphery-grid.assignment-view-convoy-peer-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: flex-start;
  gap: 3rem;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  --event-planner-card-gap: 3rem; }
  .assignment-view-board__periphery-grid.assignment-view-inline-peer-row > .assignment-view-card--team,
  .assignment-view-board__periphery-grid.assignment-view-standalone-ship-row > .assignment-view-card--team,
  .assignment-view-board__periphery-grid.assignment-view-fighter-flight-row > .assignment-view-card--team,
  .assignment-view-board__periphery-grid.assignment-view-infantry-peer-row > .assignment-view-card--team,
  .assignment-view-board__periphery-grid.assignment-view-convoy-peer-row > .assignment-view-card--team {
    flex: 0 0 330px;
    width: 330px;
    min-width: 330px;
    max-width: 330px; }
  .assignment-view-board__periphery-grid.assignment-view-inline-peer-row > .assignment-view-card--group,
  .assignment-view-board__periphery-grid.assignment-view-standalone-ship-row > .assignment-view-card--group,
  .assignment-view-board__periphery-grid.assignment-view-fighter-flight-row > .assignment-view-card--group,
  .assignment-view-board__periphery-grid.assignment-view-infantry-peer-row > .assignment-view-card--group,
  .assignment-view-board__periphery-grid.assignment-view-convoy-peer-row > .assignment-view-card--group {
    flex: 0 1 auto;
    width: max-content;
    min-width: 0;
    max-width: 100%; }

.assignment-view-board__family-grid.assignment-view-inline-peer-row,
.assignment-view-board__family-grid.assignment-view-standalone-ship-row,
.assignment-view-board__family-grid.assignment-view-fighter-flight-row,
.assignment-view-board__family-grid.assignment-view-infantry-peer-row,
.assignment-view-board__family-grid.assignment-view-convoy-peer-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: flex-start;
  gap: 3rem;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  --event-planner-card-gap: 3rem; }
  .assignment-view-board__family-grid.assignment-view-inline-peer-row > .assignment-view-card--team,
  .assignment-view-board__family-grid.assignment-view-standalone-ship-row > .assignment-view-card--team,
  .assignment-view-board__family-grid.assignment-view-fighter-flight-row > .assignment-view-card--team,
  .assignment-view-board__family-grid.assignment-view-infantry-peer-row > .assignment-view-card--team,
  .assignment-view-board__family-grid.assignment-view-convoy-peer-row > .assignment-view-card--team {
    flex: 0 0 330px;
    width: 330px;
    min-width: 330px;
    max-width: 330px; }
  .assignment-view-board__family-grid.assignment-view-inline-peer-row > .assignment-view-card--group,
  .assignment-view-board__family-grid.assignment-view-standalone-ship-row > .assignment-view-card--group,
  .assignment-view-board__family-grid.assignment-view-fighter-flight-row > .assignment-view-card--group,
  .assignment-view-board__family-grid.assignment-view-infantry-peer-row > .assignment-view-card--group,
  .assignment-view-board__family-grid.assignment-view-convoy-peer-row > .assignment-view-card--group {
    flex: 0 1 auto;
    width: max-content;
    min-width: 0;
    max-width: 100%; }

.assignment-view-card--layout-catalog,
.assignment-view-card--size-catalog {
  width: 100%;
  min-width: 0;
  box-sizing: border-box; }
  .assignment-view-card--layout-catalog.assignment-view-card--team,
  .assignment-view-card--size-catalog.assignment-view-card--team {
    max-width: 330px; }
  .assignment-view-card--layout-catalog.assignment-view-card--group,
  .assignment-view-card--size-catalog.assignment-view-card--group {
    width: max-content;
    max-width: 100%; }

.assignment-view-board--catalog .assignment-view-card--group {
  width: max-content;
  max-width: 100%;
  min-width: 0; }
  .assignment-view-board--catalog .assignment-view-card--group:has(.assignment-view-card__nested-grid--multi-team), .assignment-view-board--catalog .assignment-view-card--group:has(.assignment-view-card__nested-grid--convoy-vehicles), .assignment-view-board--catalog .assignment-view-card--group:has(.assignment-view-card__nested-grid--fighter-sections), .assignment-view-board--catalog .assignment-view-card--group:has(.assignment-view-card__nested-grid--infantry-teams) {
    width: max-content;
    max-width: 100%;
    min-width: 0; }

.assignment-view-board__filiation-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3.5rem;
  width: 100%;
  min-width: 0; }

.assignment-view-board__parent-chain {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3.5rem;
  width: 100%; }

.assignment-view-board__main-row {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 3.5rem;
  width: 100%;
  min-width: 0; }

.assignment-view-board__focus {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-width: 0; }

.assignment-view-board__periphery {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  min-width: 0;
  align-self: start;
  box-sizing: border-box; }

.assignment-view-board__family-peers {
  display: flex;
  flex-direction: column;
  gap: 3.5rem;
  width: 100%;
  min-width: 0; }

.assignment-view-board__family-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 300px));
  justify-content: center;
  align-items: stretch;
  width: 100%;
  min-width: 0;
  gap: 1rem; }

.assignment-view-board__main-row:has(.assignment-view-board__filiation-column):has(.assignment-view-board__family-peers) .assignment-view-board__family-peers .assignment-view-board__family-grid {
  justify-content: flex-end;
  padding-inline-start: 1.5rem; }

.assignment-view-board__periphery-grid {
  width: 100%;
  min-width: 0;
  gap: 1rem; }

.assignment-view-board--has-periphery {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, min(300px, 100%));
  align-items: start;
  gap: 1.25rem;
  width: 100%;
  min-width: 0; }

.assignment-view-board--has-periphery .assignment-view-board__primary-stack {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 3.5rem;
  width: 100%;
  min-width: 0;
  grid-column: 1;
  grid-row: 1; }

.assignment-view-board--has-periphery > .assignment-view-board__periphery {
  grid-column: 2;
  grid-row: 1;
  justify-self: end;
  align-self: start;
  width: 100%;
  max-width: 300px;
  padding-top: 0;
  margin-top: 0;
  border-top: none;
  border-left: 1px dashed rgba(58, 120, 180, 0.22);
  padding-left: 0.65rem; }

.assignment-view-board--has-periphery .assignment-view-board__periphery-grid {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  min-width: 0; }

.assignment-view-board--has-periphery .assignment-view-board__periphery-grid > .assignment-view-card--team,
.assignment-view-board--has-periphery .assignment-view-board__periphery-grid.assignment-view-inline-peer-row > .assignment-view-card--team,
.assignment-view-board--has-periphery .assignment-view-board__periphery-grid.assignment-view-standalone-ship-row > .assignment-view-card--team,
.assignment-view-board--has-periphery .assignment-view-board__periphery-grid.assignment-view-fighter-flight-row > .assignment-view-card--team,
.assignment-view-board--has-periphery .assignment-view-board__periphery-grid.assignment-view-infantry-peer-row > .assignment-view-card--team,
.assignment-view-board--has-periphery .assignment-view-board__periphery-grid.assignment-view-convoy-peer-row > .assignment-view-card--team {
  flex: 0 0 auto;
  width: 100%;
  min-width: 0;
  max-width: 100%; }

.assignment-view-board--has-periphery .assignment-view-board__periphery-grid > .assignment-view-card--group,
.assignment-view-board--has-periphery .assignment-view-board__periphery-grid.assignment-view-inline-peer-row > .assignment-view-card--group,
.assignment-view-board--has-periphery .assignment-view-board__periphery-grid.assignment-view-standalone-ship-row > .assignment-view-card--group,
.assignment-view-board--has-periphery .assignment-view-board__periphery-grid.assignment-view-fighter-flight-row > .assignment-view-card--group,
.assignment-view-board--has-periphery .assignment-view-board__periphery-grid.assignment-view-infantry-peer-row > .assignment-view-card--group,
.assignment-view-board--has-periphery .assignment-view-board__periphery-grid.assignment-view-convoy-peer-row > .assignment-view-card--group {
  width: 100%;
  max-width: 100%;
  min-width: 0; }

.assignment-view-board--has-periphery .assignment-view-board__periphery .assignment-view-card--team,
.assignment-view-board--has-periphery .assignment-view-board__periphery .assignment-view-card--team.assignment-view-card--layout-periphery,
.assignment-view-board--has-periphery .assignment-view-board__periphery .assignment-view-card--team.assignment-view-card--size-peer {
  width: 100%;
  min-width: 0;
  max-width: 100%; }

.assignment-view-board--has-periphery .assignment-view-board__periphery .assignment-view-card--group,
.assignment-view-board--has-periphery .assignment-view-board__periphery .assignment-view-card--group.assignment-view-card--layout-periphery,
.assignment-view-board--has-periphery .assignment-view-board__periphery .assignment-view-card--group.assignment-view-card--size-peer {
  width: 100%;
  max-width: 100%;
  min-width: 0; }

.assignment-view-tree {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 1rem;
  width: 100%; }

.assignment-view-tree__main {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%; }

.assignment-view-tree__branch {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%; }

.assignment-view-tree__branch--wide {
  width: 100%;
  max-width: none; }

.assignment-view-tree__children {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%; }

.assignment-view-tree__connector {
  width: 2px;
  height: 1rem;
  margin: 0 auto;
  background: rgba(223, 223, 223, 0.22); }

.assignment-view-tree__siblings {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 300px));
  gap: 0.85rem;
  width: 100%;
  padding-top: 0.5rem; }

.assignment-view-card {
  width: auto;
  max-width: 100%;
  border-radius: 14px;
  overflow: hidden;
  background: rgba(21, 28, 36, 0.42);
  border: 1px solid rgba(58, 120, 180, 0.28);
  box-shadow: 0 10px 28px rgba(0, 48, 77, 0.28);
  transition: border-color 0.2s ease, box-shadow 0.2s ease; }

.assignment-view-card--group {
  overflow: hidden;
  width: max-content;
  max-width: 100%;
  box-sizing: border-box; }
  .assignment-view-card--group:has(.assignment-view-card__nested-grid--multi-team), .assignment-view-card--group:has(.assignment-view-card__nested-grid--convoy-vehicles), .assignment-view-card--group:has(.assignment-view-card__nested-grid--fighter-sections), .assignment-view-card--group:has(.assignment-view-card__nested-grid--infantry-teams) {
    width: max-content;
    max-width: 100%;
    min-width: 0; }
  .assignment-view-card--group .assignment-view-card__header {
    border-radius: 14px 14px 0 0;
    overflow: hidden; }
  .assignment-view-card--group .assignment-view-card__body {
    border-radius: 0 0 14px 14px; }

.assignment-view-card--team {
  width: 100%;
  min-width: 0;
  max-width: 330px;
  box-sizing: border-box; }
  .assignment-view-card--team.assignment-view-card--layout-tree, .assignment-view-card--team.assignment-view-card--layout-focus, .assignment-view-card--team.assignment-view-card--layout-parent, .assignment-view-card--team.assignment-view-card--layout-periphery, .assignment-view-card--team.assignment-view-card--layout-catalog, .assignment-view-card--team.assignment-view-card--size-focus, .assignment-view-card--team.assignment-view-card--size-chain, .assignment-view-card--team.assignment-view-card--size-peer, .assignment-view-card--team.assignment-view-card--size-catalog {
    width: 100%;
    min-width: 0;
    max-width: 330px; }

.assignment-view-card--layout-tree,
.assignment-view-card--layout-focus,
.assignment-view-card--size-focus {
  width: 86%;
  max-width: 52rem; }
  .assignment-view-card--layout-tree.assignment-view-card--group,
  .assignment-view-card--layout-focus.assignment-view-card--group,
  .assignment-view-card--size-focus.assignment-view-card--group {
    width: max-content;
    max-width: 100%; }

.assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--size-focus, .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--layout-tree, .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--layout-focus, .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--width-ancestor, .assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--command-ship,
.assignment-view-standalone-ship-row > .assignment-view-card--team.assignment-view-card--size-focus,
.assignment-view-standalone-ship-row > .assignment-view-card--team.assignment-view-card--layout-tree,
.assignment-view-standalone-ship-row > .assignment-view-card--team.assignment-view-card--layout-focus,
.assignment-view-standalone-ship-row > .assignment-view-card--team.assignment-view-card--width-ancestor,
.assignment-view-standalone-ship-row > .assignment-view-card--team.assignment-view-card--command-ship,
.assignment-view-board__periphery-grid.assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--size-focus,
.assignment-view-board__periphery-grid.assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--layout-tree,
.assignment-view-board__periphery-grid.assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--layout-focus,
.assignment-view-board__periphery-grid.assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--width-ancestor,
.assignment-view-board__periphery-grid.assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--command-ship,
.assignment-view-board__periphery-grid.assignment-view-standalone-ship-row > .assignment-view-card--team.assignment-view-card--size-focus,
.assignment-view-board__periphery-grid.assignment-view-standalone-ship-row > .assignment-view-card--team.assignment-view-card--layout-tree,
.assignment-view-board__periphery-grid.assignment-view-standalone-ship-row > .assignment-view-card--team.assignment-view-card--layout-focus,
.assignment-view-board__periphery-grid.assignment-view-standalone-ship-row > .assignment-view-card--team.assignment-view-card--width-ancestor,
.assignment-view-board__periphery-grid.assignment-view-standalone-ship-row > .assignment-view-card--team.assignment-view-card--command-ship,
.assignment-view-tree__siblings.assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--size-focus,
.assignment-view-tree__siblings.assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--layout-tree,
.assignment-view-tree__siblings.assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--layout-focus,
.assignment-view-tree__siblings.assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--width-ancestor,
.assignment-view-tree__siblings.assignment-view-inline-peer-row > .assignment-view-card--team.assignment-view-card--command-ship,
.assignment-view-tree__siblings.assignment-view-standalone-ship-row > .assignment-view-card--team.assignment-view-card--size-focus,
.assignment-view-tree__siblings.assignment-view-standalone-ship-row > .assignment-view-card--team.assignment-view-card--layout-tree,
.assignment-view-tree__siblings.assignment-view-standalone-ship-row > .assignment-view-card--team.assignment-view-card--layout-focus,
.assignment-view-tree__siblings.assignment-view-standalone-ship-row > .assignment-view-card--team.assignment-view-card--width-ancestor,
.assignment-view-tree__siblings.assignment-view-standalone-ship-row > .assignment-view-card--team.assignment-view-card--command-ship {
  flex: 0 0 100%;
  width: 100%;
  max-width: 330px; }

.assignment-view-card--layout-ancestor,
.assignment-view-card--size-chain.assignment-view-card--chain-ancestor {
  flex: 0 1 676px;
  width: 100%;
  max-width: min(946px, 100%);
  min-width: min(608px, 100%); }
  .assignment-view-card--layout-ancestor .assignment-view-card__header-inner,
  .assignment-view-card--size-chain.assignment-view-card--chain-ancestor .assignment-view-card__header-inner {
    padding: 1.35rem 1.3rem;
    min-height: 4.85rem; }
  .assignment-view-card--layout-ancestor .assignment-view-card__header--with-image,
  .assignment-view-card--size-chain.assignment-view-card--chain-ancestor .assignment-view-card__header--with-image {
    min-height: 148px; }
    .assignment-view-card--layout-ancestor .assignment-view-card__header--with-image .assignment-view-card__header-inner,
    .assignment-view-card--size-chain.assignment-view-card--chain-ancestor .assignment-view-card__header--with-image .assignment-view-card__header-inner {
      min-height: 148px; }
  .assignment-view-card--layout-ancestor .assignment-view-card__heading h4,
  .assignment-view-card--size-chain.assignment-view-card--chain-ancestor .assignment-view-card__heading h4 {
    font-size: 1.25rem; }
  .assignment-view-card--layout-ancestor .assignment-view-card__command-chip,
  .assignment-view-card--size-chain.assignment-view-card--chain-ancestor .assignment-view-card__command-chip {
    font-size: 0.68rem;
    padding: 0.28rem 0.68rem; }
  .assignment-view-card--layout-ancestor .assignment-view-card__body--compact,
  .assignment-view-card--size-chain.assignment-view-card--chain-ancestor .assignment-view-card__body--compact {
    padding: 0.72rem 1rem 0.9rem; }
  .assignment-view-card--layout-ancestor .assignment-view-commander-row,
  .assignment-view-card--size-chain.assignment-view-card--chain-ancestor .assignment-view-commander-row {
    padding: 0.58rem 0.72rem;
    gap: 0.42rem; }

.assignment-view-card--width-ancestor {
  flex: 0 1 676px;
  width: 100%;
  max-width: min(946px, 100%);
  min-width: min(608px, 100%); }

.assignment-view-card--team.assignment-view-card--width-ancestor {
  width: 100%;
  min-width: 0;
  max-width: min(330px, 100%);
  min-height: fit-content; }

.assignment-view-card--group.assignment-view-card--width-ancestor {
  width: max-content;
  max-width: 100%;
  min-width: 0;
  min-height: fit-content; }

.assignment-view-card--layout-parent,
.assignment-view-card--size-chain.assignment-view-card--chain-parent {
  width: 86%;
  max-width: 52rem; }
  .assignment-view-card--layout-parent.assignment-view-card--group,
  .assignment-view-card--size-chain.assignment-view-card--chain-parent.assignment-view-card--group {
    width: 100%;
    max-width: 100%; }
  .assignment-view-card--layout-parent .assignment-view-card__header-inner,
  .assignment-view-card--size-chain.assignment-view-card--chain-parent .assignment-view-card__header-inner {
    padding: 1rem 1.15rem;
    min-height: 4rem; }
  .assignment-view-card--layout-parent .assignment-view-card__header--with-image,
  .assignment-view-card--size-chain.assignment-view-card--chain-parent .assignment-view-card__header--with-image {
    min-height: 120px; }
    .assignment-view-card--layout-parent .assignment-view-card__header--with-image .assignment-view-card__header-inner,
    .assignment-view-card--size-chain.assignment-view-card--chain-parent .assignment-view-card__header--with-image .assignment-view-card__header-inner {
      min-height: 120px; }
  .assignment-view-card--layout-parent .assignment-view-card__heading h4,
  .assignment-view-card--size-chain.assignment-view-card--chain-parent .assignment-view-card__heading h4 {
    font-size: 1.05rem; }
  .assignment-view-card--layout-parent .assignment-view-card__body--compact,
  .assignment-view-card--size-chain.assignment-view-card--chain-parent .assignment-view-card__body--compact {
    padding: 0.65rem 0.9rem 0.8rem; }
  .assignment-view-card--layout-parent .assignment-view-commander-row,
  .assignment-view-card--size-chain.assignment-view-card--chain-parent .assignment-view-commander-row {
    padding: 0.5rem 0.65rem;
    gap: 0.38rem; }

.assignment-view-card--layout-periphery,
.assignment-view-card--size-peer {
  width: 100%; }

.assignment-view-card--group.assignment-view-card--size-peer:has(.assignment-view-card__nested-grid--multi-team), .assignment-view-card--group.assignment-view-card--size-peer:has(.assignment-view-card__nested-grid--convoy-vehicles), .assignment-view-card--group.assignment-view-card--size-peer:has(.assignment-view-card__nested-grid--fighter-sections), .assignment-view-card--group.assignment-view-card--size-peer:has(.assignment-view-card__nested-grid--infantry-teams),
.assignment-view-card--group.assignment-view-card--layout-periphery:has(.assignment-view-card__nested-grid--multi-team),
.assignment-view-card--group.assignment-view-card--layout-periphery:has(.assignment-view-card__nested-grid--convoy-vehicles),
.assignment-view-card--group.assignment-view-card--layout-periphery:has(.assignment-view-card__nested-grid--fighter-sections),
.assignment-view-card--group.assignment-view-card--layout-periphery:has(.assignment-view-card__nested-grid--infantry-teams) {
  width: max-content;
  max-width: 100%;
  min-width: 0; }

.assignment-view-card--size-chain {
  width: 86%;
  max-width: 52rem; }
  .assignment-view-card--size-chain.assignment-view-card--group {
    width: 100%;
    max-width: 100%; }

.assignment-view-card--own {
  border-color: rgba(90, 195, 255, 0.68);
  box-shadow: 0 0 0 1px rgba(90, 195, 255, 0.22), 0 0 24px rgba(90, 195, 255, 0.12), 0 12px 32px rgba(0, 48, 77, 0.35); }

.assignment-view-card--related {
  border-color: rgba(117, 207, 120, 0.42); }

.assignment-view-card--other {
  border-color: rgba(116, 123, 129, 0.22);
  opacity: 0.92; }

.assignment-view-card--family-capital .assignment-view-card__header:not([class*="mo-structure-card-bg-"]) {
  background: linear-gradient(135deg, rgba(66, 38, 12, 0.55), rgba(110, 68, 28, 0.35));
  border-bottom-color: rgba(170, 158, 116, 0.35); }

.assignment-view-card--family-infantry .assignment-view-card__header:not([class*="mo-structure-card-bg-"]) {
  background: linear-gradient(135deg, rgba(63, 124, 66, 0.55), rgba(42, 95, 45, 0.32));
  border-bottom-color: rgba(117, 207, 120, 0.28); }

.assignment-view-card--family-convoy {
  border-color: rgba(111, 149, 133, 0.68); }
  .assignment-view-card--family-convoy .assignment-view-card__header:not([class*="mo-structure-card-bg-"]):not(
  .assignment-view-card__header--ground-theme) {
    background: transparent;
    border-bottom-color: rgba(74, 99, 88, 0.52); }

.assignment-view-card__header--ground-theme:not([class*="mo-structure-card-bg-"]) {
  background: linear-gradient(145deg, rgba(46, 66, 59, 0.96), rgba(58, 82, 73, 0.92)) !important;
  border-bottom-color: rgba(74, 99, 88, 0.52) !important;
  box-shadow: inset 0 1px 0 rgba(138, 168, 153, 0.14); }

.assignment-view-card--family-fighters .assignment-view-card__header:not([class*="mo-structure-card-bg-"]),
.assignment-view-card--family-ship .assignment-view-card__header:not([class*="mo-structure-card-bg-"]) {
  background: linear-gradient(135deg, rgba(58, 120, 180, 0.38), rgba(21, 28, 36, 0.55));
  border-bottom-color: rgba(223, 223, 223, 0.12); }

.assignment-view-card__header {
  padding: 0;
  border-bottom: 1px solid rgba(58, 120, 180, 0.2);
  background: rgba(21, 28, 36, 0.35); }
  .assignment-view-card__header[class*="mo-structure-card-bg-"] {
    border-bottom-color: rgba(223, 223, 223, 0.12);
    box-shadow: none; }

.assignment-view-card__header-inner {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding: 0.6rem 0.8rem; }

.assignment-view-card__header--with-image {
  position: relative;
  min-height: 88px;
  padding: 0;
  border-bottom-color: rgba(223, 223, 223, 0.14);
  background-color: var(--assignment-view-section-c1, #151c24);
  overflow: hidden; }
  .assignment-view-card__header--with-image::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 40%;
    z-index: 0;
    background-image: var(--assignment-view-header-bg);
    background-size: cover;
    background-position: center right;
    background-repeat: no-repeat; }
  .assignment-view-card__header--with-image::before {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 1;
    background: linear-gradient(90deg, var(--assignment-view-section-c1, #151c24) 0%, var(--assignment-view-section-c1, #151c24) 34%, color-mix(in srgb, var(--assignment-view-section-c2, #151c24) 96%, transparent) 42%, color-mix(in srgb, var(--assignment-view-section-c2, #151c24) 72%, transparent) 52%, color-mix(in srgb, var(--assignment-view-section-c1, #151c24) 28%, transparent) 66%, transparent 78%);
    pointer-events: none; }
  .assignment-view-card__header--with-image[class*="mo-structure-card-bg-"] {
    background-color: transparent; }
  .assignment-view-card__header--with-image .assignment-view-card__header-inner {
    position: relative;
    z-index: 2;
    min-height: 88px; }
  .assignment-view-card__header--with-image .assignment-view-card__header-main {
    max-width: calc(100% - 4.25rem); }

.assignment-view-card--family-capital .assignment-view-card__header--with-image:not([class*="mo-structure-card-bg-"]) {
  border-bottom-color: rgba(223, 223, 223, 0.14); }

.assignment-view-card__header-main {
  display: flex;
  align-items: flex-start;
  gap: 0.7rem;
  flex: 1 1 auto;
  min-width: 0;
  max-width: calc(100% - 4.25rem); }

.assignment-view-card__heading {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  min-width: 0; }
  .assignment-view-card__heading h4 {
    margin: 0;
    font-size: 1.08rem;
    font-weight: 700;
    color: #dfdfdf;
    line-height: 1.2;
    letter-spacing: 0.01em;
    overflow-wrap: anywhere; }

.assignment-view-card__header-vehicle {
  font-size: 0.72rem;
  font-weight: 600;
  color: rgba(223, 223, 223, 0.72);
  line-height: 1.25;
  letter-spacing: 0.04em; }

.assignment-view-card__kind {
  font-size: 0.64rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.55); }

.assignment-view-card__command-chip, .assignment-view-role-path__command-chip {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  border-radius: 999px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #d8b493;
  background: rgba(66, 38, 12, 0.82);
  border: 1px solid rgba(199, 132, 69, 0.78);
  box-shadow: 0 0 0 1px rgba(155, 96, 42, 0.22), 0 2px 8px rgba(66, 38, 12, 0.35); }

.assignment-view-card__command-chip {
  padding: 0.24rem 0.64rem;
  font-size: 0.64rem; }

.assignment-view-card__meta {
  margin: 0;
  font-size: 0.74rem;
  color: rgba(223, 223, 223, 0.58); }

.assignment-view-card__body {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  padding: 0.65rem 0.8rem 0.8rem;
  background: rgba(0, 48, 77, 0.28); }

.assignment-view-card__body--summary,
.assignment-view-card__body--compact {
  padding: 0.65rem 0.85rem 0.8rem;
  gap: 0.45rem; }

.assignment-view-card--group .assignment-view-card__body--summary:has(.assignment-view-card__nested-grid),
.assignment-view-card--group .assignment-view-card__body--compact:has(.assignment-view-card__nested-grid) {
  gap: 1rem; }

.assignment-view-card--group .assignment-view-card__body {
  gap: 1rem;
  min-width: 0;
  overflow: hidden; }

.assignment-view-card--group .assignment-view-card__nested-grid {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 1rem;
  width: max-content;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box; }
  .assignment-view-card--group .assignment-view-card__nested-grid .assignment-view-nested-team {
    flex: 0 0 330px;
    width: 330px;
    min-width: 0;
    max-width: 100%; }

.assignment-view-card__nested-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 330px));
  gap: 1rem;
  width: 100%;
  min-width: 0; }

.assignment-view-card__nested-grid--multi-team,
.assignment-view-card__nested-grid--fighter-sections,
.assignment-view-card__nested-grid--infantry-teams,
.assignment-view-card__nested-grid--convoy-vehicles {
  max-width: min(100%, calc( 2 * 330px + 1rem)); }

.assignment-view-card__nested-grid--multi-team .assignment-view-nested-team,
.assignment-view-card__nested-grid--fighter-sections .assignment-view-nested-team,
.assignment-view-card__nested-grid--convoy-vehicles .assignment-view-nested-team {
  min-height: 100%; }

.assignment-view-stats {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  margin-left: auto;
  padding: 0.22rem 0.55rem;
  border-radius: 999px;
  background: rgba(0, 48, 77, 0.85);
  border: 1px solid rgba(90, 195, 255, 0.48);
  font-size: 0.78rem;
  font-weight: 700;
  color: #5ac3ff;
  letter-spacing: 0.02em;
  white-space: nowrap; }

.assignment-view-card.is-planner-highlighted,
.assignment-view-nested-team.is-planner-highlighted {
  border-color: #c78445 !important;
  box-shadow: 0 0 0 2px rgba(199, 132, 69, 0.5) !important; }

.assignment-view-position-row.is-planner-highlighted,
.assignment-view-commander-row.is-planner-highlighted {
  border-color: rgba(199, 132, 69, 0.72);
  box-shadow: inset 0 0 0 1px rgba(199, 132, 69, 0.45); }

.assignment-view-card.is-planner-dimmed,
.assignment-view-nested-team.is-planner-dimmed {
  opacity: 0.34;
  filter: blur(1.4px);
  transition: opacity 0.18s ease, filter 0.18s ease, border-color 0.15s ease, box-shadow 0.15s ease; }

.assignment-view-card--selectable,
.assignment-view-nested-team--selectable {
  cursor: pointer; }

.assignment-view-board-canvas.is-filiation-focus-active .event-planner-view__card-link-path:not(.is-highlighted),
.assignment-view-board-canvas.is-filiation-focus-active .event-planner-view__card-link-arrow:not(.is-highlighted) {
  opacity: 0.22; }

.assignment-view-commander-row {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.35rem;
  padding: 0.45rem 0.55rem;
  border-radius: 10px;
  background: rgba(21, 28, 36, 0.35);
  border: 1px solid rgba(58, 120, 180, 0.14); }

.assignment-view-commander-row__label {
  font-size: 0.64rem;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.48); }

.assignment-view-nested-team {
  min-width: 0;
  max-width: 330px;
  width: 100%;
  box-sizing: border-box;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(58, 120, 180, 0.22);
  background: rgba(21, 28, 36, 0.38); }

.assignment-view-nested-team--own {
  border-color: rgba(90, 195, 255, 0.45);
  box-shadow: inset 0 0 0 1px rgba(90, 195, 255, 0.12); }

.assignment-view-nested-team--related {
  border-color: rgba(117, 207, 120, 0.3); }

.assignment-view-nested-team__header {
  padding: 0.55rem 0.75rem;
  border-bottom: 1px solid rgba(223, 223, 223, 0.08);
  background: rgba(0, 48, 77, 0.35); }
  .assignment-view-nested-team__header[class*="mo-structure-card-bg-"] {
    box-shadow: none; }
  .assignment-view-nested-team__header h5 {
    margin: 0;
    font-size: 0.9rem;
    font-weight: 700;
    color: #dfdfdf; }

.assignment-view-nested-team__header--with-image {
  position: relative;
  min-height: 65px;
  padding: 0;
  border-bottom-color: rgba(223, 223, 223, 0.14);
  background-color: var(--assignment-view-section-c1, #151c24);
  overflow: hidden; }
  .assignment-view-nested-team__header--with-image::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 40%;
    z-index: 0;
    background-image: var(--assignment-view-header-bg);
    background-size: cover;
    background-position: center right;
    background-repeat: no-repeat; }
  .assignment-view-nested-team__header--with-image::before {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 1;
    background: linear-gradient(90deg, var(--assignment-view-section-c1, #151c24) 0%, var(--assignment-view-section-c1, #151c24) 34%, color-mix(in srgb, var(--assignment-view-section-c2, #151c24) 96%, transparent) 42%, color-mix(in srgb, var(--assignment-view-section-c2, #151c24) 72%, transparent) 52%, color-mix(in srgb, var(--assignment-view-section-c1, #151c24) 28%, transparent) 66%, transparent 78%);
    pointer-events: none; }
  .assignment-view-nested-team__header--with-image[class*="mo-structure-card-bg-"] {
    background-color: transparent; }
  .assignment-view-nested-team__header--with-image h5 {
    color: #dfdfdf; }
  .assignment-view-nested-team__header--with-image .assignment-view-nested-team__header-content {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 0.22rem;
    max-width: 48%;
    padding: 0.55rem 0.75rem; }
  .assignment-view-nested-team__header--with-image .assignment-view-nested-team__header-vehicle {
    font-size: 0.68rem;
    font-weight: 600;
    color: rgba(223, 223, 223, 0.72);
    line-height: 1.25; }

.assignment-view-nested-team__body {
  padding: 0.55rem 0.65rem 0.7rem; }

.assignment-view-nested-team--ground-vehicle {
  min-height: 100%; }
  .assignment-view-nested-team--ground-vehicle .assignment-view-nested-team__body {
    padding-top: 0.45rem; }

.assignment-view-member-line {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.2rem;
  min-width: 0; }
  .assignment-view-member-line .user-discord-rank--compact {
    gap: 0.35rem; }

.assignment-view-member-line__identity {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.35rem;
  min-width: 0;
  max-width: 100%; }

.assignment-view-member-line__you-badge {
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  padding: 0.12rem 0.4rem;
  border-radius: 999px;
  background: rgba(90, 195, 255, 0.2);
  border: 1px solid rgba(90, 195, 255, 0.45);
  color: #5ac3ff; }

.assignment-view-member-line__guest-badge {
  display: inline-flex;
  align-items: center;
  min-height: 1.2rem;
  padding: 0.08rem 0.42rem;
  border: 1px solid rgba(199, 132, 69, 0.55);
  border-radius: 999px;
  color: #d8b493;
  background: rgba(155, 96, 42, 0.42);
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  line-height: 1.25;
  text-transform: lowercase;
  white-space: nowrap; }

.assignment-view-team-body__positions {
  display: flex;
  flex-direction: column;
  gap: 0.3rem; }

.assignment-view-team-body__expand-row {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.35rem; }

.assignment-view-team-body__fighter-slot {
  padding: 0.55rem 0;
  border-top: 1px solid rgba(58, 120, 180, 0.12); }
  .assignment-view-team-body__fighter-slot:first-child {
    border-top: none;
    padding-top: 0; }

.assignment-view-team-body__fighter-slot-ship {
  margin: 0 0 0.35rem;
  font-size: 0.76rem;
  font-weight: 600;
  color: rgba(223, 223, 223, 0.65); }

.assignment-view-position-row {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.35rem;
  padding: 0.35rem 0.45rem;
  border-radius: 8px;
  background: rgba(0, 48, 77, 0.22); }

.assignment-view-position-row--viewer {
  background: rgba(58, 120, 180, 0.16);
  outline: 1px solid rgba(90, 195, 255, 0.3); }

.assignment-view-position-row__member {
  min-width: 0;
  width: 100%; }

.assignment-view-position-row__leading {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  min-width: 0; }

.assignment-view-position-row__ship {
  font-size: 0.68rem;
  font-weight: 600;
  color: rgba(223, 223, 223, 0.55);
  line-height: 1.2; }

.assignment-view-position-row__role {
  font-size: 0.64rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.46); }

.assignment-view-position-row__empty {
  font-size: 0.8rem;
  color: rgba(223, 223, 223, 0.42);
  font-style: italic; }

.assignment-view-vehicle-thumb {
  display: block;
  width: auto;
  max-width: 100%;
  height: auto;
  object-fit: contain;
  object-position: left center; }
  .assignment-view-vehicle-thumb--inline {
    max-height: 28px;
    margin-bottom: 0.1rem; }
  .assignment-view-vehicle-thumb--hero {
    max-height: 72px;
    max-width: 90%;
    margin: 0 auto;
    opacity: 0.92; }

.assignment-view-sidebar {
  grid-area: sidebar;
  min-width: 0;
  min-height: 0;
  overflow-x: clip;
  overflow-y: auto;
  padding: 1rem 1rem 1.15rem;
  border-left: 1px solid rgba(58, 120, 180, 0.2);
  background: rgba(0, 48, 77, 0.5);
  display: flex;
  flex-direction: column;
  gap: 1.15rem; }

.assignment-view-sidebar__section-header h3 {
  margin: 0;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.5); }

.assignment-view-sidebar__section--role,
.assignment-view-sidebar__section--notes,
.assignment-view-sidebar__section--loadout,
.assignment-view-sidebar__section--owned-vehicles {
  border: 1px solid rgba(58, 120, 180, 0.25);
  border-radius: 12px;
  background: rgba(21, 28, 36, 0.45);
  padding: 0.7rem 0.8rem;
  display: flex;
  flex-direction: column;
  gap: 0.45rem; }

.assignment-view-sidebar__notes {
  display: flex;
  flex-direction: column;
  gap: 0.5rem; }

.assignment-view-sidebar__section--notes .assignment-view-sidebar__note {
  border: 1px solid rgba(58, 120, 180, 0.18);
  border-radius: 8px;
  background: rgba(0, 48, 77, 0.42);
  padding: 0.6rem 0.7rem; }

.assignment-view-sidebar__note-header {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin-bottom: 0.45rem; }
  .assignment-view-sidebar__note-header h4 {
    margin: 0;
    font-size: 0.86rem;
    font-weight: 600;
    color: #dfdfdf; }

.assignment-view-sidebar__note-icon {
  width: 0.95rem;
  height: 0.95rem;
  opacity: 0.7; }

.assignment-view-sidebar__note-body {
  font-size: 0.84rem;
  line-height: 1.45;
  color: rgba(223, 223, 223, 0.86); }

.assignment-view-sidebar__viewer-card {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 0.7rem 0.8rem;
  border-radius: 12px;
  border: 1px solid rgba(90, 195, 255, 0.28);
  background: rgba(58, 120, 180, 0.1); }

.assignment-view-sidebar__viewer-role {
  margin: 0;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: rgba(90, 195, 255, 0.88); }

.assignment-view-sidebar__owned-vehicles {
  display: flex;
  flex-direction: column;
  gap: 0.45rem; }

.assignment-view-sidebar__loadout-card {
  border: 1px solid rgba(58, 120, 180, 0.18);
  border-radius: 8px;
  background: rgba(0, 48, 77, 0.42);
  padding: 0.55rem 0.65rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem; }

.assignment-view-sidebar__loadout-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.35rem; }

.assignment-view-sidebar__loadout-team {
  font-size: 0.78rem;
  font-weight: 700;
  color: #dfdfdf; }

.assignment-view-sidebar__loadout-position {
  font-size: 0.66rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(90, 195, 255, 0.82); }

.assignment-view-sidebar__owned-vehicle {
  border: 1px solid rgba(58, 120, 180, 0.18);
  border-radius: 8px;
  background: rgba(0, 48, 77, 0.42);
  padding: 0.55rem 0.65rem;
  display: flex;
  flex-direction: column;
  gap: 0.2rem; }

.assignment-view-sidebar__owned-vehicle-operator {
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.28rem;
  font-size: 0.78rem;
  margin-top: 0.2rem;
  line-height: 1.3;
  color: rgba(223, 223, 223, 0.82); }

.assignment-view-sidebar__owned-vehicle-role {
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: capitalize;
  color: rgba(90, 195, 255, 0.88); }

.assignment-view-sidebar__owned-vehicle-separator {
  color: rgba(223, 223, 223, 0.45); }

.assignment-view-sidebar__owned-vehicle-moniker {
  font-weight: 600;
  color: #dfdfdf; }

.assignment-view-sidebar__owned-vehicle-self-tag {
  display: inline-flex;
  align-items: center;
  padding: 0.1rem 0.38rem;
  border-radius: 999px;
  border: 1px solid rgba(90, 195, 255, 0.35);
  background: rgba(58, 120, 180, 0.16);
  font-size: 0.58rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(90, 195, 255, 0.92); }

.assignment-view-sidebar__owned-vehicle-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.28rem;
  list-style: none;
  margin: 0.35rem 0 0;
  padding: 0; }

.assignment-view-sidebar__owned-vehicle-tag {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  padding: 0.12rem 0.42rem;
  border-radius: 999px;
  border: 1px solid rgba(199, 132, 69, 0.42);
  background: linear-gradient(90deg, rgba(110, 68, 28, 0.42), rgba(155, 96, 42, 0.18));
  font-size: 0.58rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #d8b493;
  box-shadow: inset 0 1px 0 rgba(170, 158, 116, 0.12);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.assignment-view-role-path {
  list-style: none;
  margin: 0;
  padding: 0; }

.assignment-view-role-path__step {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  padding: 0.6rem 0;
  position: relative; }
  .assignment-view-role-path__step:not(:last-child)::after {
    content: "";
    position: absolute;
    left: 0.95rem;
    top: 2.35rem;
    bottom: 0;
    width: 0;
    border-left: 2px dashed rgba(58, 120, 180, 0.38); }

.assignment-view-role-path__marker {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.9rem;
  height: 1.9rem;
  border-radius: 10px;
  border: 1px solid rgba(90, 195, 255, 0.35);
  background: rgba(21, 28, 36, 0.65);
  flex-shrink: 0; }

.assignment-view-role-path__marker-icon {
  width: 1rem;
  height: 1rem;
  opacity: 0.85; }

.assignment-view-role-path__content {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  min-width: 0;
  padding-top: 0.1rem; }

.assignment-view-role-path__relation {
  font-size: 0.62rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.45); }

.assignment-view-role-path__label-block {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  min-width: 0; }

.assignment-view-role-path__kind {
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.55); }

.assignment-view-role-path__command-chip {
  padding: 0.18rem 0.52rem;
  font-size: 0.6rem; }

.assignment-view-role-path__label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #dfdfdf;
  line-height: 1.2;
  overflow-wrap: anywhere; }

.assignment-view-role-path__position {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: capitalize;
  color: rgba(90, 195, 255, 0.88);
  line-height: 1.25;
  overflow-wrap: anywhere; }

.assignment-view-role-path__vehicle-name {
  font-size: 0.72rem;
  font-weight: 600;
  color: rgba(223, 223, 223, 0.72);
  line-height: 1.25;
  letter-spacing: 0.04em;
  overflow-wrap: anywhere; }

.assignment-view-role-path__stats {
  font-size: 0.74rem;
  font-weight: 600;
  color: rgba(90, 195, 255, 0.82); }

@media (max-width: 960px) {
  .event-assignment-view__workspace {
    grid-template-columns: 1fr;
    grid-template-areas: "main" "sidebar" "legend"; }
  .assignment-view-sidebar {
    border-left: none;
    border-top: 1px solid rgba(58, 120, 180, 0.2); } }

@media (max-width: 900px) {
  .assignment-view-card__nested-grid--multi-team,
  .assignment-view-card__nested-grid--fighter-sections,
  .assignment-view-card__nested-grid--infantry-teams,
  .assignment-view-card__nested-grid--convoy-vehicles {
    width: 100%;
    max-width: 100%; }
    .assignment-view-card__nested-grid--multi-team .assignment-view-nested-team,
    .assignment-view-card__nested-grid--fighter-sections .assignment-view-nested-team,
    .assignment-view-card__nested-grid--infantry-teams .assignment-view-nested-team,
    .assignment-view-card__nested-grid--convoy-vehicles .assignment-view-nested-team {
      flex: 1 1 100%;
      width: 100%;
      max-width: 100%; } }

@media (max-width: 640px) {
  .assignment-view-card--team {
    min-width: 0;
    max-width: 100%; }
    .assignment-view-card--team.assignment-view-card--layout-tree, .assignment-view-card--team.assignment-view-card--layout-focus, .assignment-view-card--team.assignment-view-card--layout-parent, .assignment-view-card--team.assignment-view-card--layout-periphery, .assignment-view-card--team.assignment-view-card--size-focus, .assignment-view-card--team.assignment-view-card--size-chain, .assignment-view-card--team.assignment-view-card--size-peer {
      min-width: 0;
      max-width: 100%; }
  .assignment-view-inline-peer-row > .assignment-view-card--team,
  .assignment-view-standalone-ship-row > .assignment-view-card--team,
  .assignment-view-board__standalone-ships .assignment-view-inline-peer-row > .assignment-view-card--team,
  .assignment-view-board__standalone-ships .assignment-view-standalone-ship-row > .assignment-view-card--team {
    flex: 0 0 330px;
    width: 330px;
    min-width: 330px;
    max-width: 330px; }
  .assignment-view-inline-peer-row > .assignment-view-card--team,
  .assignment-view-fighter-flight-row > .assignment-view-card--team,
  .assignment-view-board__fighter-flights .assignment-view-inline-peer-row > .assignment-view-card--team,
  .assignment-view-board__fighter-flights .assignment-view-fighter-flight-row > .assignment-view-card--team {
    flex: 0 0 330px;
    width: 330px;
    min-width: 330px;
    max-width: 330px; }
  .assignment-view-inline-peer-row,
  .assignment-view-standalone-ship-row,
  .assignment-view-fighter-flight-row,
  .assignment-view-infantry-peer-row,
  .assignment-view-convoy-peer-row {
    overflow-x: auto;
    justify-content: flex-start;
    padding-bottom: 0.25rem; }
  .assignment-view-inline-peer-row > .assignment-view-card--team,
  .assignment-view-infantry-peer-row > .assignment-view-card--team,
  .assignment-view-board__infantry-peers .assignment-view-inline-peer-row > .assignment-view-card--team,
  .assignment-view-board__infantry-peers .assignment-view-infantry-peer-row > .assignment-view-card--team {
    flex: 0 0 330px;
    width: 330px;
    min-width: 330px;
    max-width: 330px; }
  .assignment-view-inline-peer-row > .assignment-view-card--team,
  .assignment-view-convoy-peer-row > .assignment-view-card--team,
  .assignment-view-board__convoy-peers .assignment-view-inline-peer-row > .assignment-view-card--team,
  .assignment-view-board__convoy-peers .assignment-view-convoy-peer-row > .assignment-view-card--team {
    flex: 0 0 330px;
    width: 330px;
    min-width: 330px;
    max-width: 330px; }
  .assignment-view-nested-team {
    min-width: 0;
    max-width: 100%; }
  .assignment-view-card--layout-tree,
  .assignment-view-card--layout-focus,
  .assignment-view-card--size-focus,
  .assignment-view-card--group.assignment-view-card--layout-tree,
  .assignment-view-card--group.assignment-view-card--size-focus,
  .assignment-view-card--command-ship.assignment-view-card--layout-tree,
  .assignment-view-card--command-ship.assignment-view-card--size-focus {
    max-width: 100%; }
  .assignment-view-commander-row,
  .assignment-view-position-row {
    gap: 0.3rem; }
  .assignment-view-tree__siblings {
    flex-direction: column;
    align-items: center; }
    .assignment-view-tree__siblings::before {
      display: none; }
    .assignment-view-tree__siblings > .assignment-view-tree__branch::before {
      display: none; } }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.ribbons-edition {
  position: relative;
  display: flex;
  flex-direction: row; }
  .ribbons-edition .ribbon-viual-editor {
    display: flex;
    flex-direction: column;
    width: 108%;
    margin: 0px 20px 0px 20px;
    align-items: center; }

.link-chain {
  height: 25px;
  margin: 0; }

.ribbon-overlay-container {
  position: relative;
  display: inline-block; }
  .ribbon-overlay-container.table {
    width: 100%;
    margin: 10px auto 5px auto; }
  .ribbon-overlay-container .ribbon-image {
    display: block;
    width: 100%;
    height: auto; }
  .ribbon-overlay-container .color-rect {
    position: absolute;
    top: 17%;
    height: 64%;
    border-radius: 10%;
    box-shadow: none;
    transition: background-color 0.3s ease, box-shadow 0.3s ease;
    width: var(--rect-width, 9.8%);
    background-color: var(--rect-color, transparent); }
    .ribbon-overlay-container .color-rect[data-color] {
      background-color: attr(data-color color, initial); }
    .ribbon-overlay-container .color-rect.color-selected {
      box-shadow: 0 8px 13px rgba(0, 0, 0, 0.5), inset 0 2px 4px rgba(255, 255, 255, 0.3), inset 0 -3px 2px rgba(0, 0, 0, 0.5);
      background-image: linear-gradient(145deg, rgba(255, 255, 255, 0.4), rgba(0, 0, 0, 0.2)), repeating-linear-gradient(45deg, transparent, transparent 2px, rgba(255, 255, 255, 0.07) 2px, rgba(255, 255, 255, 0.07) 3px);
      background-blend-mode: overlay, overlay; }
      .ribbon-overlay-container .color-rect.color-selected:first-child {
        border-radius: 10% 0 0 10%; }
      .ribbon-overlay-container .color-rect.color-selected:last-child {
        border-radius: 10%; }
    .ribbon-overlay-container .color-rect.first-linked {
      border-radius: 10% 0 0 10%; }
    .ribbon-overlay-container .color-rect.last-linked {
      border-radius: 0 10% 10% 0; }
    .ribbon-overlay-container .color-rect.middle-linked {
      border-radius: 0; }
    .ribbon-overlay-container .color-rect .add-image-icon {
      position: absolute;
      top: 5%;
      right: 5%;
      width: 20px;
      height: 20px;
      z-index: 300;
      cursor: pointer; }
    .ribbon-overlay-container .color-rect .group-image {
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      max-height: 90%;
      max-width: 90%;
      transform: translate(-50%, -50%);
      object-fit: contain;
      filter: drop-shadow(0 2px 1px rgba(0, 0, 0, 0.7));
      z-index: 100; }
  .ribbon-overlay-container .width-1 {
    width: 0.1%; }
  .ribbon-overlay-container .width-2 {
    width: 0.2%; }
  .ribbon-overlay-container .width-3 {
    width: 0.3%; }
  .ribbon-overlay-container .width-4 {
    width: 0.4%; }
  .ribbon-overlay-container .width-5 {
    width: 0.5%; }
  .ribbon-overlay-container .width-6 {
    width: 0.6%; }
  .ribbon-overlay-container .width-7 {
    width: 0.7%; }
  .ribbon-overlay-container .width-8 {
    width: 0.8%; }
  .ribbon-overlay-container .width-9 {
    width: 0.9%; }
  .ribbon-overlay-container .width-10 {
    width: 1%; }
  .ribbon-overlay-container .width-11 {
    width: 1.1%; }
  .ribbon-overlay-container .width-12 {
    width: 1.2%; }
  .ribbon-overlay-container .width-13 {
    width: 1.3%; }
  .ribbon-overlay-container .width-14 {
    width: 1.4%; }
  .ribbon-overlay-container .width-15 {
    width: 1.5%; }
  .ribbon-overlay-container .width-16 {
    width: 1.6%; }
  .ribbon-overlay-container .width-17 {
    width: 1.7%; }
  .ribbon-overlay-container .width-18 {
    width: 1.8%; }
  .ribbon-overlay-container .width-19 {
    width: 1.9%; }
  .ribbon-overlay-container .width-20 {
    width: 2%; }
  .ribbon-overlay-container .width-21 {
    width: 2.1%; }
  .ribbon-overlay-container .width-22 {
    width: 2.2%; }
  .ribbon-overlay-container .width-23 {
    width: 2.3%; }
  .ribbon-overlay-container .width-24 {
    width: 2.4%; }
  .ribbon-overlay-container .width-25 {
    width: 2.5%; }
  .ribbon-overlay-container .width-26 {
    width: 2.6%; }
  .ribbon-overlay-container .width-27 {
    width: 2.7%; }
  .ribbon-overlay-container .width-28 {
    width: 2.8%; }
  .ribbon-overlay-container .width-29 {
    width: 2.9%; }
  .ribbon-overlay-container .width-30 {
    width: 3%; }
  .ribbon-overlay-container .width-31 {
    width: 3.1%; }
  .ribbon-overlay-container .width-32 {
    width: 3.2%; }
  .ribbon-overlay-container .width-33 {
    width: 3.3%; }
  .ribbon-overlay-container .width-34 {
    width: 3.4%; }
  .ribbon-overlay-container .width-35 {
    width: 3.5%; }
  .ribbon-overlay-container .width-36 {
    width: 3.6%; }
  .ribbon-overlay-container .width-37 {
    width: 3.7%; }
  .ribbon-overlay-container .width-38 {
    width: 3.8%; }
  .ribbon-overlay-container .width-39 {
    width: 3.9%; }
  .ribbon-overlay-container .width-40 {
    width: 4%; }
  .ribbon-overlay-container .width-41 {
    width: 4.1%; }
  .ribbon-overlay-container .width-42 {
    width: 4.2%; }
  .ribbon-overlay-container .width-43 {
    width: 4.3%; }
  .ribbon-overlay-container .width-44 {
    width: 4.4%; }
  .ribbon-overlay-container .width-45 {
    width: 4.5%; }
  .ribbon-overlay-container .width-46 {
    width: 4.6%; }
  .ribbon-overlay-container .width-47 {
    width: 4.7%; }
  .ribbon-overlay-container .width-48 {
    width: 4.8%; }
  .ribbon-overlay-container .width-49 {
    width: 4.9%; }
  .ribbon-overlay-container .width-50 {
    width: 5%; }
  .ribbon-overlay-container .width-51 {
    width: 5.1%; }
  .ribbon-overlay-container .width-52 {
    width: 5.2%; }
  .ribbon-overlay-container .width-53 {
    width: 5.3%; }
  .ribbon-overlay-container .width-54 {
    width: 5.4%; }
  .ribbon-overlay-container .width-55 {
    width: 5.5%; }
  .ribbon-overlay-container .width-56 {
    width: 5.6%; }
  .ribbon-overlay-container .width-57 {
    width: 5.7%; }
  .ribbon-overlay-container .width-58 {
    width: 5.8%; }
  .ribbon-overlay-container .width-59 {
    width: 5.9%; }
  .ribbon-overlay-container .width-60 {
    width: 6%; }
  .ribbon-overlay-container .width-61 {
    width: 6.1%; }
  .ribbon-overlay-container .width-62 {
    width: 6.2%; }
  .ribbon-overlay-container .width-63 {
    width: 6.3%; }
  .ribbon-overlay-container .width-64 {
    width: 6.4%; }
  .ribbon-overlay-container .width-65 {
    width: 6.5%; }
  .ribbon-overlay-container .width-66 {
    width: 6.6%; }
  .ribbon-overlay-container .width-67 {
    width: 6.7%; }
  .ribbon-overlay-container .width-68 {
    width: 6.8%; }
  .ribbon-overlay-container .width-69 {
    width: 6.9%; }
  .ribbon-overlay-container .width-70 {
    width: 7%; }
  .ribbon-overlay-container .width-71 {
    width: 7.1%; }
  .ribbon-overlay-container .width-72 {
    width: 7.2%; }
  .ribbon-overlay-container .width-73 {
    width: 7.3%; }
  .ribbon-overlay-container .width-74 {
    width: 7.4%; }
  .ribbon-overlay-container .width-75 {
    width: 7.5%; }
  .ribbon-overlay-container .width-76 {
    width: 7.6%; }
  .ribbon-overlay-container .width-77 {
    width: 7.7%; }
  .ribbon-overlay-container .width-78 {
    width: 7.8%; }
  .ribbon-overlay-container .width-79 {
    width: 7.9%; }
  .ribbon-overlay-container .width-80 {
    width: 8%; }
  .ribbon-overlay-container .width-81 {
    width: 8.1%; }
  .ribbon-overlay-container .width-82 {
    width: 8.2%; }
  .ribbon-overlay-container .width-83 {
    width: 8.3%; }
  .ribbon-overlay-container .width-84 {
    width: 8.4%; }
  .ribbon-overlay-container .width-85 {
    width: 8.5%; }
  .ribbon-overlay-container .width-86 {
    width: 8.6%; }
  .ribbon-overlay-container .width-87 {
    width: 8.7%; }
  .ribbon-overlay-container .width-88 {
    width: 8.8%; }
  .ribbon-overlay-container .width-89 {
    width: 8.9%; }
  .ribbon-overlay-container .width-90 {
    width: 9%; }
  .ribbon-overlay-container .width-91 {
    width: 9.1%; }
  .ribbon-overlay-container .width-92 {
    width: 9.2%; }
  .ribbon-overlay-container .width-93 {
    width: 9.3%; }
  .ribbon-overlay-container .width-94 {
    width: 9.4%; }
  .ribbon-overlay-container .width-95 {
    width: 9.5%; }
  .ribbon-overlay-container .width-96 {
    width: 9.6%; }
  .ribbon-overlay-container .width-97 {
    width: 9.7%; }
  .ribbon-overlay-container .width-98 {
    width: 9.8%; }
  .ribbon-overlay-container .width-99 {
    width: 9.9%; }
  .ribbon-overlay-container .width-100 {
    width: 10%; }
  .ribbon-overlay-container .width-101 {
    width: 10.1%; }
  .ribbon-overlay-container .width-102 {
    width: 10.2%; }
  .ribbon-overlay-container .width-103 {
    width: 10.3%; }
  .ribbon-overlay-container .width-104 {
    width: 10.4%; }
  .ribbon-overlay-container .width-105 {
    width: 10.5%; }
  .ribbon-overlay-container .width-106 {
    width: 10.6%; }
  .ribbon-overlay-container .width-107 {
    width: 10.7%; }
  .ribbon-overlay-container .width-108 {
    width: 10.8%; }
  .ribbon-overlay-container .width-109 {
    width: 10.9%; }
  .ribbon-overlay-container .width-110 {
    width: 11%; }
  .ribbon-overlay-container .width-111 {
    width: 11.1%; }
  .ribbon-overlay-container .width-112 {
    width: 11.2%; }
  .ribbon-overlay-container .width-113 {
    width: 11.3%; }
  .ribbon-overlay-container .width-114 {
    width: 11.4%; }
  .ribbon-overlay-container .width-115 {
    width: 11.5%; }
  .ribbon-overlay-container .width-116 {
    width: 11.6%; }
  .ribbon-overlay-container .width-117 {
    width: 11.7%; }
  .ribbon-overlay-container .width-118 {
    width: 11.8%; }
  .ribbon-overlay-container .width-119 {
    width: 11.9%; }
  .ribbon-overlay-container .width-120 {
    width: 12%; }
  .ribbon-overlay-container .width-121 {
    width: 12.1%; }
  .ribbon-overlay-container .width-122 {
    width: 12.2%; }
  .ribbon-overlay-container .width-123 {
    width: 12.3%; }
  .ribbon-overlay-container .width-124 {
    width: 12.4%; }
  .ribbon-overlay-container .width-125 {
    width: 12.5%; }
  .ribbon-overlay-container .width-126 {
    width: 12.6%; }
  .ribbon-overlay-container .width-127 {
    width: 12.7%; }
  .ribbon-overlay-container .width-128 {
    width: 12.8%; }
  .ribbon-overlay-container .width-129 {
    width: 12.9%; }
  .ribbon-overlay-container .width-130 {
    width: 13%; }
  .ribbon-overlay-container .width-131 {
    width: 13.1%; }
  .ribbon-overlay-container .width-132 {
    width: 13.2%; }
  .ribbon-overlay-container .width-133 {
    width: 13.3%; }
  .ribbon-overlay-container .width-134 {
    width: 13.4%; }
  .ribbon-overlay-container .width-135 {
    width: 13.5%; }
  .ribbon-overlay-container .width-136 {
    width: 13.6%; }
  .ribbon-overlay-container .width-137 {
    width: 13.7%; }
  .ribbon-overlay-container .width-138 {
    width: 13.8%; }
  .ribbon-overlay-container .width-139 {
    width: 13.9%; }
  .ribbon-overlay-container .width-140 {
    width: 14%; }
  .ribbon-overlay-container .width-141 {
    width: 14.1%; }
  .ribbon-overlay-container .width-142 {
    width: 14.2%; }
  .ribbon-overlay-container .width-143 {
    width: 14.3%; }
  .ribbon-overlay-container .width-144 {
    width: 14.4%; }
  .ribbon-overlay-container .width-145 {
    width: 14.5%; }
  .ribbon-overlay-container .width-146 {
    width: 14.6%; }
  .ribbon-overlay-container .width-147 {
    width: 14.7%; }
  .ribbon-overlay-container .width-148 {
    width: 14.8%; }
  .ribbon-overlay-container .width-149 {
    width: 14.9%; }
  .ribbon-overlay-container .width-150 {
    width: 15%; }
  .ribbon-overlay-container .width-151 {
    width: 15.1%; }
  .ribbon-overlay-container .width-152 {
    width: 15.2%; }
  .ribbon-overlay-container .width-153 {
    width: 15.3%; }
  .ribbon-overlay-container .width-154 {
    width: 15.4%; }
  .ribbon-overlay-container .width-155 {
    width: 15.5%; }
  .ribbon-overlay-container .width-156 {
    width: 15.6%; }
  .ribbon-overlay-container .width-157 {
    width: 15.7%; }
  .ribbon-overlay-container .width-158 {
    width: 15.8%; }
  .ribbon-overlay-container .width-159 {
    width: 15.9%; }
  .ribbon-overlay-container .width-160 {
    width: 16%; }
  .ribbon-overlay-container .width-161 {
    width: 16.1%; }
  .ribbon-overlay-container .width-162 {
    width: 16.2%; }
  .ribbon-overlay-container .width-163 {
    width: 16.3%; }
  .ribbon-overlay-container .width-164 {
    width: 16.4%; }
  .ribbon-overlay-container .width-165 {
    width: 16.5%; }
  .ribbon-overlay-container .width-166 {
    width: 16.6%; }
  .ribbon-overlay-container .width-167 {
    width: 16.7%; }
  .ribbon-overlay-container .width-168 {
    width: 16.8%; }
  .ribbon-overlay-container .width-169 {
    width: 16.9%; }
  .ribbon-overlay-container .width-170 {
    width: 17%; }
  .ribbon-overlay-container .width-171 {
    width: 17.1%; }
  .ribbon-overlay-container .width-172 {
    width: 17.2%; }
  .ribbon-overlay-container .width-173 {
    width: 17.3%; }
  .ribbon-overlay-container .width-174 {
    width: 17.4%; }
  .ribbon-overlay-container .width-175 {
    width: 17.5%; }
  .ribbon-overlay-container .width-176 {
    width: 17.6%; }
  .ribbon-overlay-container .width-177 {
    width: 17.7%; }
  .ribbon-overlay-container .width-178 {
    width: 17.8%; }
  .ribbon-overlay-container .width-179 {
    width: 17.9%; }
  .ribbon-overlay-container .width-180 {
    width: 18%; }
  .ribbon-overlay-container .width-181 {
    width: 18.1%; }
  .ribbon-overlay-container .width-182 {
    width: 18.2%; }
  .ribbon-overlay-container .width-183 {
    width: 18.3%; }
  .ribbon-overlay-container .width-184 {
    width: 18.4%; }
  .ribbon-overlay-container .width-185 {
    width: 18.5%; }
  .ribbon-overlay-container .width-186 {
    width: 18.6%; }
  .ribbon-overlay-container .width-187 {
    width: 18.7%; }
  .ribbon-overlay-container .width-188 {
    width: 18.8%; }
  .ribbon-overlay-container .width-189 {
    width: 18.9%; }
  .ribbon-overlay-container .width-190 {
    width: 19%; }
  .ribbon-overlay-container .width-191 {
    width: 19.1%; }
  .ribbon-overlay-container .width-192 {
    width: 19.2%; }
  .ribbon-overlay-container .width-193 {
    width: 19.3%; }
  .ribbon-overlay-container .width-194 {
    width: 19.4%; }
  .ribbon-overlay-container .width-195 {
    width: 19.5%; }
  .ribbon-overlay-container .width-196 {
    width: 19.6%; }
  .ribbon-overlay-container .width-197 {
    width: 19.7%; }
  .ribbon-overlay-container .width-198 {
    width: 19.8%; }
  .ribbon-overlay-container .width-199 {
    width: 19.9%; }
  .ribbon-overlay-container .width-200 {
    width: 20%; }
  .ribbon-overlay-container .width-201 {
    width: 20.1%; }
  .ribbon-overlay-container .width-202 {
    width: 20.2%; }
  .ribbon-overlay-container .width-203 {
    width: 20.3%; }
  .ribbon-overlay-container .width-204 {
    width: 20.4%; }
  .ribbon-overlay-container .width-205 {
    width: 20.5%; }
  .ribbon-overlay-container .width-206 {
    width: 20.6%; }
  .ribbon-overlay-container .width-207 {
    width: 20.7%; }
  .ribbon-overlay-container .width-208 {
    width: 20.8%; }
  .ribbon-overlay-container .width-209 {
    width: 20.9%; }
  .ribbon-overlay-container .width-210 {
    width: 21%; }
  .ribbon-overlay-container .rect-1 {
    left: 6%;
    z-index: 200; }
  .ribbon-overlay-container .rect-2 {
    left: 17.125%;
    z-index: 190; }
  .ribbon-overlay-container .rect-3 {
    left: 28.25%;
    z-index: 180; }
  .ribbon-overlay-container .rect-4 {
    left: 39.375%;
    z-index: 170; }
  .ribbon-overlay-container .rect-5 {
    left: 50.5%;
    z-index: 160; }
  .ribbon-overlay-container .rect-6 {
    left: 61.625%;
    z-index: 150; }
  .ribbon-overlay-container .rect-7 {
    left: 72.75%;
    z-index: 140; }
  .ribbon-overlay-container .rect-8 {
    left: 83.875%;
    z-index: 130; }

.colorPicker-container-horizontal {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: -10px;
  margin-left: 0px;
  width: 81%; }

.colorPicker-container-horizontal .colorPicker {
  margin-left: calc((100% - 8 * 10.125%) / 16);
  margin-right: calc((100% - 8 * 10.125%) / 16); }

.link-chain {
  height: 25px;
  margin: 0 8px; }

.link-chain.rotated {
  position: relative;
  transform: rotate(90deg);
  bottom: 3px; }

.link-symbol {
  position: relative;
  font-size: 1.5em;
  bottom: 7px;
  cursor: pointer; }
  .link-symbol.disable {
    color: #b8b8b8; }
  .link-symbol.enable {
    color: #9e2222; }

.ribbon-viual-editor.hidden {
  visibility: hidden; }

.clear-icon {
  position: relative;
  height: 30px;
  cursor: pointer; }

.statusRibbons {
  text-align: center;
  /* Centre le contenu du texte ou autre contenu de la cellule */ }

.ribbons-qty-input {
  width: 100%;
  max-width: 44px;
  text-align: center;
  box-sizing: border-box; }

.default-btn.ribbons {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.colorPicker {
  border: 1px solid #9c99a3;
  cursor: pointer;
  width: 20px;
  height: 20px;
  border-radius: 50%; }

.colorPicker:not(:last-child) {
  margin-right: 1px; }

.color-picker-tooltip {
  position: relative;
  z-Index: 100;
  transform: translate(-30%, 60%); }

.color-picker-flex .colorPicker {
  border-radius: 50%; }
  .color-picker-flex .colorPicker.border-left {
    border-radius: 12px 0 0 12px; }
  .color-picker-flex .colorPicker.middle {
    border-radius: 0; }
  .color-picker-flex .colorPicker.border-right {
    border-radius: 0 12px 12px 0; }

.color-picker-container {
  display: flex;
  flex-direction: row !important;
  align-items: center;
  margin-bottom: 0px; }
  .color-picker-container .color-picker-flex {
    display: flex; }

.color-picker-container label {
  margin-right: 10px;
  width: 110px; }

/* Masquer spécifiquement les champs R, G, B et A */
.color-picker-container .flexbox-fix > div:nth-child(2),
.color-picker-container .flexbox-fix > div:nth-child(3),
.color-picker-container .flexbox-fix > div:nth-child(4),
.color-picker-container .flexbox-fix > div:nth-child(5) {
  display: none !important; }

.color-picker-wrapper {
  position: absolute;
  background: #0c2637;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  padding: 10px;
  width: 185px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  transform: translate(0px, 8px);
  border: 1px solid #491212; }

/* ✅ Zone d'entrée Hex */
.color-picker-hex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px; }

.color-picker-hex label {
  font-size: 14px;
  color: #b8b8b8;
  font-weight: 600; }

.color-picker-hex input {
  width: 80px;
  padding: 3px;
  border: 1px solid #491212;
  border-radius: 4px;
  text-align: center;
  font-size: 14px; }

/* ✅ Grille de couleurs pré-sélectionnées */
.color-picker-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 6px;
  margin-bottom: 8px; }

.color-picker-grid button {
  width: 18px;
  height: 18px;
  border: 1px solid #2a3847;
  border-radius: 50%;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease; }
  .color-picker-grid button.preset-transparent {
    border: 1px solid white; }

.color-picker-grid button:hover {
  transform: scale(1.05);
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3); }

.color-picker-grid button.active {
  border: 2px solid black; }

/* ✅ Palette de couleurs (saturation box) */
.color-picker-saturation {
  position: relative;
  width: 100%;
  height: 120px;
  border-radius: 2px;
  cursor: crosshair;
  margin-bottom: 10px; }

.color-picker-saturation-hue {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 2px;
  pointer-events: none;
  /* Empêche l'interaction avec ce div */ }

.color-picker-saturation-brightness {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 2px;
  pointer-events: none;
  /* Empêche l'interaction avec ce div */ }

.color-picker-saturation_cursor {
  position: absolute;
  width: 7px;
  height: 7px;
  border: 1px solid white;
  border-radius: 50%;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
  transform: translate(-50%, -50%); }

/* ✅ Barre de teinte (hue slider) */
.color-picker-hue {
  position: relative;
  width: 100%;
  height: 14px;
  background: linear-gradient(to right, red, orange, yellow, green, cyan, blue, purple, red);
  border-radius: 4px;
  cursor: pointer; }

.color-picker-hue_cursor {
  position: absolute;
  width: 14px;
  height: 14px;
  border: 2px solid white;
  border-radius: 50%;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
  transform: translate(-50%, -13%); }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.sc-item-chip {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  border-radius: 6px;
  font-size: 11px;
  line-height: 1.2;
  color: #ffffff;
  background: #0B1016;
  border: 1px solid #9D7BFF;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
  position: relative;
  box-sizing: border-box; }
  .sc-item-chip--removable {
    gap: 5px; }
  .sc-item-chip--locked .sc-item-chip__unit-qty-value,
  .sc-item-chip--locked .sc-item-chip__unit-quality-value {
    background: transparent; }
  .sc-item-chip .sc-item-chip__trigger {
    display: inline-flex;
    align-items: center;
    min-width: 0;
    flex: 1 1 auto;
    gap: 6px;
    margin: 0 6px;
    padding: 5px 6px 5px;
    border: 0;
    background: transparent;
    color: inherit;
    font: inherit;
    line-height: inherit;
    cursor: default;
    text-align: left;
    flex-wrap: wrap;
    row-gap: 2px; }
    .sc-item-chip .sc-item-chip__trigger:disabled {
      opacity: 0.55;
      cursor: not-allowed; }
    .sc-item-chip .sc-item-chip__trigger .sc-item-chip__label {
      flex: 1 1 auto;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 100%;
      text-transform: capitalize; }
  .sc-item-chip__trailing {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center; }
  .sc-item-chip__meta-sep {
    flex: 0 0 auto;
    opacity: 0.65;
    font-weight: 700; }
  .sc-item-chip__unit {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    gap: 1px;
    padding: 1px 4px;
    border-radius: 4px;
    background: #0b1016;
    color: rgba(255, 255, 255, 0.92);
    font-weight: 700;
    letter-spacing: 0.01em;
    user-select: none;
    cursor: text; }
  .sc-item-chip__unit.is-editing {
    background: rgba(255, 255, 255, 0.38); }
  .sc-item-chip__unit-edit {
    display: inline-flex;
    align-items: center;
    gap: 4px; }
  .sc-item-chip__unit-kind-text {
    opacity: 0.9;
    font-weight: 700; }
  .sc-item-chip__unit-qty-input, .sc-item-chip__unit-quality-input {
    width: auto;
    min-width: 0;
    padding: 0;
    margin: 0;
    border: 0;
    background: transparent;
    color: inherit;
    font: inherit;
    line-height: inherit;
    outline: none;
    box-sizing: content-box; }
  .sc-item-chip__unit-qty-input {
    text-align: left; }
  .sc-item-chip__unit-qty-input--active, .sc-item-chip__unit-quality-input--active {
    field-sizing: content; }
  .sc-item-chip__unit-quality-input {
    text-align: left; }
  .sc-item-chip__unit-qty-value, .sc-item-chip__unit-quality-value {
    flex: 0 0 auto;
    display: inline;
    padding: 0 6px;
    margin: 0;
    border: 0;
    border-radius: 2px;
    background: rgba(255, 255, 255, 0.2);
    color: #dfdfdf;
    font: inherit;
    line-height: inherit;
    font-weight: 700; }
  .sc-item-chip__unit-qty-value--editable, .sc-item-chip__unit-quality-value--editable {
    cursor: text;
    text-decoration: underline dotted rgba(255, 255, 255, 0.35);
    text-underline-offset: 2px; }
    .sc-item-chip__unit-qty-value--editable:hover, .sc-item-chip__unit-quality-value--editable:hover {
      text-decoration-color: rgba(255, 255, 255, 0.65); }
  .sc-item-chip__unit-quality-sep {
    opacity: 0.8;
    font-weight: 700; }
  .sc-item-chip__unit-quality-q {
    opacity: 0.9;
    font-weight: 700; }
  .sc-item-chip__remove {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 21px;
    margin: 0;
    padding: 0;
    border: 0;
    border-radius: 0px;
    background: #4731a2;
    color: rgba(255, 255, 255, 0.88);
    cursor: pointer;
    line-height: 1; }
  .sc-item-chip__remove:hover {
    background: #4d37a8;
    color: #ffffff; }
  .sc-item-chip__remove-icon {
    font-size: 14px;
    font-weight: 700;
    line-height: 1; }
  .sc-item-chip__card {
    position: absolute;
    min-width: 240px;
    max-width: 360px;
    padding: 0;
    overflow: hidden;
    border-radius: 8px;
    color: #E2E8F0;
    background: #0B1016;
    border: 1px solid #26303C;
    z-index: 200000;
    text-align: left;
    white-space: normal;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.2), 0 12px 40px rgba(0, 0, 0, 0.45), 0 0 28px rgba(106, 76, 255, 0.25); }
    .sc-item-chip__card--portal {
      position: fixed; }
    .sc-item-chip__card--fps {
      min-width: 300px;
      max-width: 440px; }
    .sc-item-chip__card--blueprint {
      min-width: 300px;
      max-width: 440px; }
    .sc-item-chip__card--ship {
      min-width: 300px;
      max-width: 350px;
      padding: 0; }
  .sc-item-chip__card-title {
    margin: 0;
    padding: 6px 12px 6px;
    background: #6A4CFF;
    color: #E2E8F0;
    border-bottom: 1px solid #9D7BFF;
    font-weight: 700;
    font-size: 11px;
    text-transform: uppercase; }
  .sc-item-chip__card-content {
    padding: 10px 12px 12px; }
  .sc-item-chip__card-muted {
    color: #6B7684; }
  .sc-item-chip__card-error {
    color: #c78445; }

.sc-item-chip__bp {
  min-width: 0; }

.sc-item-chip__bp-subtitle {
  font-size: 11px;
  text-transform: uppercase;
  color: #A3B1C6;
  margin: 0 0 8px 0;
  line-height: 1.35; }

.sc-item-chip__bp-grid {
  margin: 0 0 8px 0; }

.sc-item-chip__bp-section {
  margin-top: 8px; }

.sc-item-chip__bp-ingredients {
  margin: 4px 0 0 0;
  padding: 0 0 0 1.1em;
  list-style: disc;
  color: #E2E8F0;
  font-size: 12px;
  line-height: 1.45; }

.sc-item-chip__bp-ingredients-item {
  margin: 0 0 2px 0;
  word-break: break-word; }

.sc-item-chip__bp-ingredients-item:last-child {
  margin-bottom: 0; }

.sc-item-chip__bp-text {
  font-size: 12px;
  line-height: 1.4;
  color: #E2E8F0;
  word-break: break-word; }

.sc-item-chip__bp-craftable {
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px solid #26303C; }

.sc-item-chip__bp-craftable .sc-item-chip__bp-craftable-grid,
.sc-item-chip__bp-craftable-title + .sc-item-chip__bp-craftable-grid {
  margin-top: 4px; }

.sc-item-chip__bp-craftable-title {
  font-size: 12px;
  font-weight: 600;
  color: #E2E8F0;
  margin: 2px 0 4px 0;
  word-break: break-word; }

.sc-item-chip__fps-subtitle,
.sc-item-chip__ship-subtitle {
  font-size: 11px;
  text-transform: uppercase;
  color: #E2E8F0;
  margin: 8px 0 4px 0;
  line-height: 1.35; }

.sc-item-chip__card--ship .sc-item-chip__fps-more-panel--open {
  max-height: 880px; }

.sc-item-chip__ship-kpi {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px 10px;
  margin: 0 0 10px 0; }

.sc-item-chip__ship-size-line {
  font-size: 11px;
  font-weight: 600;
  margin: 0 0 10px 0;
  color: #E2E8F0; }

.sc-item-chip__ship-weaponry {
  margin: 0 0 10px 0; }

.sc-item-chip__ship-section-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #A3B1C6;
  margin: 0 0 4px 0; }

.sc-item-chip__fps-more-panel-inner .sc-item-chip__ship-section-label {
  color: #6A4CFF; }

.sc-item-chip__ship-section-label--spaced {
  margin-top: 10px; }

.sc-item-chip__ship-flight-base {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px 10px;
  margin: 0 0 6px 0; }

.sc-item-chip__ship-more-inner {
  padding-bottom: 4px; }

.sc-item-chip__ship-more-tabs {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin: 8px 0 10px 0; }

.sc-item-chip__ship-more-tab {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
  padding: 5px 10px;
  border-radius: 6px;
  border: 1px solid #26303C;
  background: #121A22;
  cursor: pointer;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #A3B1C6;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; }

.sc-item-chip__ship-more-tab:hover {
  background: #1A2430;
  color: #E2E8F0; }

.sc-item-chip__ship-more-tab.is-active {
  border-color: #6A4CFF;
  box-shadow: 0 0 0 3px rgba(106, 76, 255, 0.25);
  color: #E2E8F0; }

.sc-item-chip__ship-more-tabpanel {
  padding-top: 2px; }

.sc-item-chip__ship-dim,
.sc-item-chip__ship-mass {
  font-size: 11px;
  line-height: 1.35;
  margin: 0 0 4px 0;
  color: #A3B1C6; }

.sc-item-chip__ship-perf-grid {
  margin-top: 4px; }

.sc-item-chip__ship-line {
  font-size: 12px;
  line-height: 1.35;
  margin: 6px 0 0 0;
  color: #E2E8F0; }

.sc-item-chip__ship-insurance {
  font-size: 11px;
  margin: 8px 0 0 0;
  line-height: 1.35;
  color: #6B7684; }

.sc-item-chip__ship-components {
  margin-top: 4px; }

.sc-item-chip__ship-components-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px 10px;
  margin-top: 4px; }

.sc-item-chip__ship-comp-cell {
  min-width: 0;
  padding: 6px 6px;
  border-radius: 6px;
  border: 1px solid #26303C;
  background: #121A22; }

.sc-item-chip__ship-comp-label {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #A3B1C6;
  margin-bottom: 3px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.sc-item-chip__ship-comp-value {
  font-size: 11px;
  font-weight: 600;
  line-height: 1.25;
  word-break: break-word;
  color: #E2E8F0; }

.sc-item-chip__fps-hero {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 10px;
  margin: 4px 0 10px 0; }
  .sc-item-chip__fps-hero--triple {
    grid-template-columns: repeat(3, minmax(0, 1fr)); }

.sc-item-chip__fps-highlight {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px 10px;
  margin: 0 0 8px 0; }

.sc-item-chip__fps-kpi-grade-class-size {
  margin: 4px 0 10px 0; }

.sc-item-chip__fps-armor-foot {
  font-size: 10px;
  line-height: 1.35;
  margin: 0 0 6px 0;
  word-break: break-word; }

.sc-item-chip__vi .sc-item-chip__fps-stat-value {
  white-space: normal;
  word-break: break-word; }

.sc-item-chip__vi .sc-item-chip__fps-more-panel--open {
  max-height: 260px; }

.sc-item-chip__vi-uses-inner {
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 0; }

.sc-item-chip__vi-uses-list-scroll {
  max-height: 160px;
  overflow-y: auto;
  padding-right: 4px;
  min-height: 0; }
  .sc-item-chip__vi-uses-list-scroll::-webkit-scrollbar {
    width: 6px; }
  .sc-item-chip__vi-uses-list-scroll::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .sc-item-chip__vi-uses-list-scroll::-webkit-scrollbar-thumb {
    background-color: #6A4CFF;
    border-radius: 4px; }
    .sc-item-chip__vi-uses-list-scroll::-webkit-scrollbar-thumb:hover {
      background-color: #9D7BFF; }

.sc-item-chip__vi-uses-search-wrap {
  margin: 0 0 6px 0; }

.sc-item-chip__vi-uses-search-label {
  display: block;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #A3B1C6;
  margin: 0 0 4px 0; }

.sc-item-chip__vi-uses-search {
  display: block;
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  padding: 6px 8px;
  border-radius: 6px;
  border: 1px solid #26303C;
  background: #121A22;
  color: #E2E8F0;
  font-size: 12px;
  line-height: 1.3; }
  .sc-item-chip__vi-uses-search::placeholder {
    color: #6B7684; }
  .sc-item-chip__vi-uses-search:focus {
    outline: none;
    border-color: #6A4CFF;
    box-shadow: 0 0 0 2px rgba(106, 76, 255, 0.25); }

.sc-item-chip__vi-uses-filter-hint {
  font-size: 10px;
  color: #A3B1C6;
  margin: 0 0 6px 0; }

.sc-item-chip__vi-uses-empty {
  margin: 0;
  padding: 4px 0 2px 0;
  font-size: 12px;
  line-height: 1.35;
  color: #6B7684; }

.sc-item-chip__vi-uses-list {
  list-style: none;
  margin: 0;
  padding: 0; }

.sc-item-chip__vi-uses-item {
  padding: 6px 0;
  border-bottom: 1px solid #26303C; }
  .sc-item-chip__vi-uses-item:last-child {
    border-bottom: none;
    padding-bottom: 0; }

.sc-item-chip__vi-uses-title {
  font-size: 12px;
  font-weight: 600;
  line-height: 1.25;
  color: #E2E8F0;
  word-break: break-word; }

.sc-item-chip__vi-uses-meta {
  font-size: 10px;
  line-height: 1.3;
  margin-top: 3px;
  color: #6B7684;
  word-break: break-word; }

.sc-item-chip__fps-more-row {
  border-top: 1px solid #26303C;
  margin: 10px 0 0 0;
  padding-top: 8px; }

.sc-item-chip__fps-more-toggle {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 4px 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #6A4CFF;
  text-align: left;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase; }

.sc-item-chip__fps-more-toggle:hover {
  color: #9D7BFF; }

.sc-item-chip__fps-more-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 15px;
  border-radius: 4px;
  border: 1px solid #26303C;
  background: #121A22;
  color: #E2E8F0;
  font-weight: 800;
  line-height: 1;
  flex: 0 0 auto; }

.sc-item-chip__fps-more-label {
  flex: 1 1 auto;
  min-width: 0; }

.sc-item-chip__fps-more-panel {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.28s ease; }

.sc-item-chip__fps-more-panel--open {
  max-height: 520px; }

.sc-item-chip__fps-more-panel-inner {
  padding: 6px 0 2px 0; }

.sc-item-chip__fps-more-panel-inner .sc-item-chip__fps-grid {
  margin: 0; }

.sc-item-chip__fps-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px 10px;
  margin: 6px 0 10px 0; }

.sc-item-chip__fps-stat-label {
  font-size: 10px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  margin-bottom: 2px;
  color: #A3B1C6; }

.sc-item-chip__fps-stat-value {
  font-size: 12px;
  font-weight: 600;
  color: #E2E8F0;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.sc-item-chip__card-desc--preline {
  white-space: pre-line;
  max-height: 220px; }

.sc-item-chip__card-subtitle {
  font-size: 11px;
  color: #A3B1C6;
  margin-bottom: 6px; }

.sc-item-chip__card-meta {
  font-size: 11px;
  color: #A3B1C6;
  margin-bottom: 6px; }

.sc-item-chip__card-desc {
  font-size: 12px;
  line-height: 1.35;
  max-height: 140px;
  padding-right: 5px;
  margin-right: 5px;
  overflow: auto;
  color: #E2E8F0; }
  .sc-item-chip__card-desc::-webkit-scrollbar {
    width: 6px; }
  .sc-item-chip__card-desc::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .sc-item-chip__card-desc::-webkit-scrollbar-thumb {
    background-color: #6A4CFF;
    border-radius: 4px; }
    .sc-item-chip__card-desc::-webkit-scrollbar-thumb:hover {
      background-color: #9D7BFF; }

.sc-item-chip__character-mention-desc {
  margin-top: 8px; }

.sc-item-chip__card-muted {
  color: #6B7684; }

.sc-item-chip__card-error {
  color: #c78445; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.rbc-calendar {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 100%;
  width: 1460px;
  margin-right: auto;
  margin-left: auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch; }
  .rbc-calendar .rbc-toolbar-label {
    color: #dfdfdf;
    font-weight: bold; }

/* Roster preview + main calendar detailed view: shared card shell (header/banner + panel chrome) */
.rbc-month-view {
  min-height: 66.7vh;
  min-height: calc(100vh - 370px);
  border: none;
  border-radius: 8px;
  /* visible pour que le zoom des cellules soit aussi vertical (pas seulement horizontal) */
  overflow: visible;
  /*
     * Bandeau jours : continu (pas de gap), même esprit roster.
     * Arrondi global = lundi à gauche / dimanche à droite (locale Lundi = premier jour).
     */
  /* Bord type .roster-file-ribbon-card — fond par défaut .rbc-day-bg (#23374bcc) */ }
  .rbc-month-view > .rbc-row.rbc-month-header {
    margin-bottom: 15px;
    flex-shrink: 0;
    gap: 0;
    height: 45px;
    border-radius: 10px;
    overflow: hidden;
    filter: drop-shadow(0 3px 6px rgba(0, 0, 0, 0.5)) drop-shadow(0 6px 14px rgba(0, 0, 0, 0.35));
    background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center; }
    .rbc-month-view > .rbc-row.rbc-month-header .rbc-header {
      flex: 1 1 0;
      min-width: 0;
      height: 100%;
      display: flex;
      align-items: center;
      padding: 0 12px;
      margin: 0;
      border: none;
      border-radius: 0;
      color: #b8b8b8;
      text-transform: uppercase;
      font-size: 0.75em;
      font-weight: 600;
      cursor: default;
      user-select: none;
      text-align: left;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      position: relative;
      background: none;
      background-image: none;
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.16), inset 0 -1px 0 rgba(0, 0, 0, 0.18); }
      .rbc-month-view > .rbc-row.rbc-month-header .rbc-header:not(:last-child)::after {
        content: '';
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 1px;
        height: 65%;
        background-color: #2a3847; }
      .rbc-month-view > .rbc-row.rbc-month-header .rbc-header .header-content {
        width: 100%;
        min-width: 0;
        text-align: center; }
      .rbc-month-view > .rbc-row.rbc-month-header .rbc-header .header-label {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap; }
      .rbc-month-view > .rbc-row.rbc-month-header .rbc-header a,
      .rbc-month-view > .rbc-row.rbc-month-header .rbc-header a:active,
      .rbc-month-view > .rbc-row.rbc-month-header .rbc-header a:visited {
        color: inherit; }
  .rbc-month-view > .rbc-month-row + .rbc-month-row {
    border-top: none;
    margin-top: 10px; }
  .rbc-month-view .rbc-month-row > .rbc-row-bg {
    gap: 10px;
    overflow: visible; }
  .rbc-month-view .rbc-month-row .rbc-row-content {
    display: grid;
    overflow: visible;
    gap: 3px; }
  .rbc-month-view .rbc-month-row .rbc-row-content > .rbc-row {
    gap: 10px; }
  .rbc-month-view .rbc-day-bg + .rbc-day-bg {
    border-left: none; }
  .rbc-month-view .rbc-day-bg:not(.rbc-off-range-bg) {
    border: 1px solid rgba(58, 120, 180, 0.18);
    border-radius: 14px;
    min-width: 0; }

.rbc-month-row {
  position: relative;
  overflow: visible; }

/* Comme react-big-calendar.css : au-dessus des .rbc-day-bg (hover + ::after) pour cliquer les events */
.rbc-row-content {
  position: relative;
  z-index: 4; }

.rbc-day-bg + .rbc-day-bg {
  border-left: 1px solid #b8b8b8; }

.rbc-month-row + .rbc-month-row {
  border-top: 1px solid #b8b8b8; }

.rbc-day-bg {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1 0 0%;
  flex: 1 0 0%;
  background-color: #23374bcc;
  position: relative;
  transform: scale(1, 1);
  transform-origin: center center;
  transition: transform 0.18s ease;
  z-index: 0;
  overflow-y: auto;
  overflow-x: hidden; }
  .rbc-day-bg:hover {
    /* Axe X et Y explicites (~+8 px / dimension sur ~160px de côté) ; < .rbc-row-content (4) */
    transform: scale(1.03, 1.03);
    z-index: 1; }
    .rbc-day-bg:hover::after {
      content: "";
      position: absolute;
      top: 0px;
      left: 0px;
      right: 0px;
      bottom: 0px;
      border-radius: 14px;
      background-color: #324f6da9;
      pointer-events: none; }
  .rbc-day-bg .create-event {
    display: none;
    justify-content: end;
    padding-top: 2px;
    padding-right: 7px;
    font-size: 1.3rem;
    position: absolute;
    top: 0;
    right: 0; }
  .rbc-day-bg:hover .create-event {
    display: flex; }
  .rbc-day-bg.rbc-today::after {
    content: "";
    position: absolute;
    background-color: #446a92a8;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    pointer-events: none; }
  .rbc-day-bg.rbc-off-range-bg {
    background-color: #27333f80; }

.rbc-today {
  background-color: transparent; }

.rbc-label {
  color: #b8b8b8; }

.rbc-calendar *,
.rbc-calendar *:before,
.rbc-calendar *:after {
  -webkit-box-sizing: inherit;
  box-sizing: inherit;
  overflow-y: hidden;
  overflow-x: hidden; }

/* Plus spécifique que .rbc-calendar * — sinon overflow-y:hidden coupe le scale() en hauteur */
.rbc-ellipsis, .rbc-show-more, .rbc-row-segment .rbc-event-content, .rbc-event-label {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.calendar-toolbar-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px; }
  .calendar-toolbar-container .rbc-toolbar {
    display: flex;
    align-items: center; }
    .calendar-toolbar-container .rbc-toolbar.left {
      justify-content: flex-start; }
    .calendar-toolbar-container .rbc-toolbar.right {
      justify-content: flex-end; }
    .calendar-toolbar-container .rbc-toolbar .btn-style1 {
      margin: 0 1px;
      height: 30px;
      width: 40px;
      color: #491212;
      background: none;
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
      border-color: #adadad;
      background-color: rgba(0, 51, 128, 0.2); }
      .calendar-toolbar-container .rbc-toolbar .btn-style1:hover {
        background-color: rgba(0, 51, 128, 0);
        color: #9e2222;
        text-decoration: none; }
      .calendar-toolbar-container .rbc-toolbar .btn-style1:active {
        box-shadow: 0px 0px 5px 2px #2f3031ee; }
      .calendar-toolbar-container .rbc-toolbar .btn-style1.first {
        width: 80px;
        border-radius: 6px 0 0 6px; }
      .calendar-toolbar-container .rbc-toolbar .btn-style1.middle {
        width: 80px;
        border-radius: 0; }
      .calendar-toolbar-container .rbc-toolbar .btn-style1.last {
        width: 80px;
        border-radius: 0 6px 6px 0; }
      .calendar-toolbar-container .rbc-toolbar .btn-style1.active {
        background-color: #ffffff;
        box-shadow: 0px 0px 5px 2px #465561ee;
        color: #9e2222; }

.rbc-header {
  align-content: center;
  padding: 3px 3px;
  border-bottom: 1px solid #b8b8b8;
  color: #b8b8b8; }

.rbc-header + .rbc-header {
  border-left: 1px solid transparent; }

/* La rangée mois (rbc-row + rbc-month-header) est stylée dans .rbc-month-view */
.rbc-time-header-cell,
.rbc-month-header:not(.rbc-row) {
  background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 30px; }

.rbc-event, .rbc-day-slot {
  position: relative;
  border: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: none;
  box-shadow: none;
  margin: 0 auto 0 auto;
  padding: 3px 0px;
  background-color: #133b53;
  border-radius: 5px;
  color: #dfdfdf;
  font-size: 0.85rem;
  cursor: pointer;
  max-width: 96%;
  text-align: left;
  border: 1px solid #3a78b4; }
  .rbc-event.rbc-background-event, .rbc-day-slot.rbc-background-event {
    background-color: #491212; }
  .rbc-event.rbc-time-column, .rbc-day-slot.rbc-time-column {
    background-color: #2a3847; }
    .rbc-event.rbc-time-column.rbc-today, .rbc-day-slot.rbc-time-column.rbc-today {
      background-color: #405468; }
      .rbc-event.rbc-time-column.rbc-today.rbc-time-slot, .rbc-day-slot.rbc-time-column.rbc-today.rbc-time-slot {
        background-color: #b8b8b8; }
  .rbc-event .position0, .rbc-day-slot .position0 {
    width: 100% !important;
    left: 7px !important; }
  .rbc-event .position1, .rbc-day-slot .position1 {
    width: 50% !important;
    left: 7px !important; }
  .rbc-event .position2, .rbc-day-slot .position2 {
    width: 50% !important;
    left: 50% !important; }
  .rbc-event.position3, .rbc-day-slot.position3 {
    width: 33.33% !important;
    left: 7px !important; }
  .rbc-event.position4, .rbc-day-slot.position4 {
    width: 33.33% !important;
    left: 33.33 !important; }
  .rbc-event.position5, .rbc-day-slot.position5 {
    width: 33.33% !important;
    left: 66.66% !important; }
  .rbc-event:hover, .rbc-day-slot:hover {
    border: 1px solid #5ac3ff;
    color: white; }

.rbc-timeslot-group {
  border-bottom: 1px solid #b8b8b8;
  min-height: 40px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap; }

.rbc-day-slot .rbc-time-slot {
  border-top: 1px solid #2a3847; }

.rbc-date-cell {
  display: flex;
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0px;
  flex: 1 1 0;
  min-width: 0;
  padding: 5px 7px 2px 7px;
  text-align: left;
  justify-content: space-between;
  align-items: center; }
  .rbc-date-cell .rbc-button-link {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center; }
  .rbc-date-cell.passed {
    color: grey; }
  .rbc-date-cell.future {
    color: #dfdfdf; }
  .rbc-date-cell.rbc-current {
    color: white; }

.date-time-selector {
  display: flex;
  flex-direction: row;
  color: #dfdfdf;
  gap: 5px; }

.menu .date-time-selector {
  display: flex;
  flex-direction: column;
  color: #dfdfdf;
  gap: 0px; }

.date-time-selector .react-datepicker__input-container input {
  background-color: #dfdfdf;
  border: 1px solid #491212;
  border-radius: 4px;
  box-shadow: none;
  min-height: 15px;
  height: 15px;
  width: 125px;
  padding: 3px 5px;
  font-size: 12px; }

.date-time-selector label {
  margin-bottom: 5px;
  font-weight: bold; }

.react-datepicker {
  font-size: 0.75rem !important;
  border: 2px solid #9e2222 !important;
  background-color: #2a3847 !important; }
  .react-datepicker::-webkit-scrollbar {
    width: 6px; }
  .react-datepicker::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .react-datepicker::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .react-datepicker::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }

.react-datepicker__triangle {
  transform: rotate(180deg) translate(50px, -1px) !important; }

.react-datepicker__header {
  background-color: #1c2d38 !important;
  color: #dfdfdf !important; }

.react-datepicker__current-month, .react-datepicker-time__header, .react-datepicker-year-header {
  color: #dfdfdf !important; }

h2.react-datepicker__current-month {
  color: #dfdfdf !important; }

.react-datepicker__day-name, .react-datepicker__day, .react-datepicker__time-name {
  color: #dfdfdf !important; }

.react-datepicker__month-container {
  background-color: #2a3847 !important; }

.react-datepicker__time-container .react-datepicker__time {
  background: #2a3847 !important; }

.react-datepicker-popper {
  z-index: 30000;
  line-height: 0;
  left: 85px !important; }

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list::-webkit-scrollbar {
  width: 6px; }

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list::-webkit-scrollbar-track {
  background: #2e3842;
  border-radius: 4px;
  padding-right: 1px; }

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list::-webkit-scrollbar-thumb {
  background-color: #491212;
  border-radius: 4px; }
  .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list::-webkit-scrollbar-thumb:hover {
    background-color: #200808; }

.recurrence-selector {
  display: grid;
  font-weight: bold;
  gap: 5px;
  margin-top: 0px; }

.ribbon-space {
  position: relative;
  width: 100%;
  height: auto; }
  .ribbon-space .ribbon-image {
    width: 100%;
    height: auto;
    display: block; }

.rbc-row-segment {
  width: 14.5%; }

/* Vue "month" : Limite la largeur à 50% et ajuste la position */
.rbc-month-view .rbc-event {
  position: relative;
  padding-left: 5px; }
  .rbc-month-view .rbc-event.canceled {
    border: 1px solid #9e2222;
    color: #b8b8b8;
    text-decoration-line: line-through;
    background-color: #0c2637;
    text-decoration-thickness: 2px;
    text-decoration-color: #9e2222; }
  .rbc-month-view .rbc-event.concluded {
    color: #b8b8b8; }
  .rbc-month-view .rbc-event.scheduled {
    border: 1px solid #239323;
    color: #dfdfdf; }
    .rbc-month-view .rbc-event.scheduled:hover {
      border: 1px solid #75cf78; }
  .rbc-month-view .rbc-event.live {
    border: 1px solid #8b590d;
    color: #dfdfdf; }
  .rbc-month-view .rbc-event.tentative {
    border: 1px solid #b8a500;
    color: #dfdfdf; }

/* Current-user RSVP marker — top-right of .rbc-event chips */
.rbc-event.rsvp-signup,
.rbc-event.rsvp-decline {
  overflow: visible; }

.rbc-event.rsvp-signup::after,
.rbc-event.rsvp-decline::after {
  content: '';
  position: absolute;
  top: -1px;
  right: -2px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.45);
  pointer-events: none;
  z-index: 2; }

.rbc-event.rsvp-signup::after {
  background-color: #75cf78; }

.rbc-event.rsvp-decline::after {
  background-color: #d12323; }

/* Vue "week" et "day" : Assure le bon positionnement */
.rbc-time-view .rbc-event {
  width: 100%;
  /* Occupe toute la largeur */
  position: absolute;
  /* Assure le positionnement correct en fonction du temps */ }

.rbc-current-time-indicator {
  z-index: 1;
  background-color: #9e2222;
  height: 2px; }

.rbc-day-slot .rbc-event, .rbc-day-slot .rbc-background-event {
  padding: 5px;
  border: 1px solid #b8b8b8; }
  .rbc-day-slot .rbc-event:hover, .rbc-day-slot .rbc-background-event:hover {
    background-color: #2d3a47;
    border: 1px solid #dfdfdf; }

.rbc-event.rbc-selected, .rbc-day-slot .rbc-selected.rbc-background-event {
  background-color: #0c2637;
  color: white; }

.rbc-event:focus, .rbc-day-slot .rbc-background-event:focus {
  outline: 3px auto #b8b8b8; }

.rbc-date-cell.rbc-now .rbc-button-link {
  padding: 2px 5px;
  background-color: #491212;
  border-radius: 3px; }

/* Cacher le bouton "+" par défaut */
.create-event {
  color: transparent; }

/* Afficher le bouton "+" lorsqu'on survole la cellule de date */
.rbc-date-cell:hover .create-event {
  font-weight: bolder;
  color: #dfdfdf;
  padding-left: 10px;
  padding-right: 5px;
  cursor: pointer; }

.management-container {
  background-color: #0c2637;
  padding: 10px 15px;
  border: 1px solid #b8b8b8;
  border-radius: 5px;
  box-shadow: inset -2px -2px 3px rgba(70, 69, 69, 0.2); }
  .management-container.create-event, .management-container.create-event-template {
    display: flex;
    flex-direction: column;
    padding: 0.2rem;
    width: initial;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 15px; }
    .management-container.create-event .content, .management-container.create-event-template .content {
      margin: 10px; }
    .management-container.create-event .discord, .management-container.create-event-template .discord {
      display: flex;
      width: 100%;
      height: 250px; }
      .management-container.create-event .discord .discord-banner, .management-container.create-event-template .discord .discord-banner {
        position: relative;
        margin: 20px auto;
        width: 500px;
        height: 200px; }
        .management-container.create-event .discord .discord-banner:before, .management-container.create-event-template .discord .discord-banner:before {
          content: "";
          display: block; }
        .management-container.create-event .discord .discord-banner .dropzone, .management-container.create-event-template .discord .discord-banner .dropzone {
          position: relative;
          width: 500px;
          height: 200px;
          border: 2px dashed #b8b8b8;
          overflow: hidden;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: grab;
          background-color: #2a3847; }
          .management-container.create-event .discord .discord-banner .dropzone.is-dragging, .management-container.create-event-template .discord .discord-banner .dropzone.is-dragging {
            cursor: grabbing; }
          .management-container.create-event .discord .discord-banner .dropzone.locked, .management-container.create-event-template .discord .discord-banner .dropzone.locked {
            pointer-events: none;
            background-color: #3d5167; }
        .management-container.create-event .discord .discord-banner .image-preview, .management-container.create-event-template .discord .discord-banner .image-preview {
          position: absolute;
          top: 0;
          left: 0;
          height: auto;
          width: 100%;
          object-fit: cover;
          transform-origin: top left;
          user-select: none;
          transform: translateX(var(--translate-x, 0px)) translateY(var(--translate-y, 0px)) scale(var(--scale, 1)); }
          .management-container.create-event .discord .discord-banner .image-preview.draggable, .management-container.create-event-template .discord .discord-banner .image-preview.draggable {
            cursor: grab; }
          .management-container.create-event .discord .discord-banner .image-preview.locked, .management-container.create-event-template .discord .discord-banner .image-preview.locked {
            cursor: default; }
          .management-container.create-event .discord .discord-banner .image-preview.is-dragging, .management-container.create-event-template .discord .discord-banner .image-preview.is-dragging {
            cursor: grabbing; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1500, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1500 {
            --translate-x: -1500px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1499, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1499 {
            --translate-x: -1499px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1498, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1498 {
            --translate-x: -1498px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1497, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1497 {
            --translate-x: -1497px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1496, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1496 {
            --translate-x: -1496px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1495, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1495 {
            --translate-x: -1495px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1494, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1494 {
            --translate-x: -1494px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1493, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1493 {
            --translate-x: -1493px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1492, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1492 {
            --translate-x: -1492px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1491, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1491 {
            --translate-x: -1491px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1490, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1490 {
            --translate-x: -1490px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1489, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1489 {
            --translate-x: -1489px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1488, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1488 {
            --translate-x: -1488px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1487, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1487 {
            --translate-x: -1487px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1486, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1486 {
            --translate-x: -1486px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1485, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1485 {
            --translate-x: -1485px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1484, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1484 {
            --translate-x: -1484px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1483, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1483 {
            --translate-x: -1483px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1482, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1482 {
            --translate-x: -1482px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1481, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1481 {
            --translate-x: -1481px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1480, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1480 {
            --translate-x: -1480px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1479, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1479 {
            --translate-x: -1479px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1478, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1478 {
            --translate-x: -1478px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1477, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1477 {
            --translate-x: -1477px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1476, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1476 {
            --translate-x: -1476px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1475, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1475 {
            --translate-x: -1475px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1474, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1474 {
            --translate-x: -1474px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1473, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1473 {
            --translate-x: -1473px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1472, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1472 {
            --translate-x: -1472px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1471, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1471 {
            --translate-x: -1471px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1470, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1470 {
            --translate-x: -1470px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1469, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1469 {
            --translate-x: -1469px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1468, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1468 {
            --translate-x: -1468px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1467, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1467 {
            --translate-x: -1467px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1466, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1466 {
            --translate-x: -1466px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1465, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1465 {
            --translate-x: -1465px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1464, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1464 {
            --translate-x: -1464px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1463, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1463 {
            --translate-x: -1463px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1462, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1462 {
            --translate-x: -1462px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1461, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1461 {
            --translate-x: -1461px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1460, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1460 {
            --translate-x: -1460px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1459, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1459 {
            --translate-x: -1459px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1458, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1458 {
            --translate-x: -1458px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1457, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1457 {
            --translate-x: -1457px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1456, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1456 {
            --translate-x: -1456px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1455, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1455 {
            --translate-x: -1455px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1454, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1454 {
            --translate-x: -1454px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1453, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1453 {
            --translate-x: -1453px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1452, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1452 {
            --translate-x: -1452px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1451, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1451 {
            --translate-x: -1451px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1450, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1450 {
            --translate-x: -1450px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1449, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1449 {
            --translate-x: -1449px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1448, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1448 {
            --translate-x: -1448px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1447, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1447 {
            --translate-x: -1447px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1446, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1446 {
            --translate-x: -1446px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1445, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1445 {
            --translate-x: -1445px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1444, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1444 {
            --translate-x: -1444px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1443, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1443 {
            --translate-x: -1443px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1442, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1442 {
            --translate-x: -1442px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1441, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1441 {
            --translate-x: -1441px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1440, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1440 {
            --translate-x: -1440px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1439, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1439 {
            --translate-x: -1439px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1438, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1438 {
            --translate-x: -1438px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1437, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1437 {
            --translate-x: -1437px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1436, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1436 {
            --translate-x: -1436px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1435, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1435 {
            --translate-x: -1435px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1434, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1434 {
            --translate-x: -1434px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1433, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1433 {
            --translate-x: -1433px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1432, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1432 {
            --translate-x: -1432px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1431, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1431 {
            --translate-x: -1431px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1430, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1430 {
            --translate-x: -1430px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1429, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1429 {
            --translate-x: -1429px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1428, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1428 {
            --translate-x: -1428px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1427, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1427 {
            --translate-x: -1427px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1426, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1426 {
            --translate-x: -1426px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1425, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1425 {
            --translate-x: -1425px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1424, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1424 {
            --translate-x: -1424px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1423, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1423 {
            --translate-x: -1423px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1422, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1422 {
            --translate-x: -1422px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1421, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1421 {
            --translate-x: -1421px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1420, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1420 {
            --translate-x: -1420px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1419, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1419 {
            --translate-x: -1419px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1418, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1418 {
            --translate-x: -1418px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1417, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1417 {
            --translate-x: -1417px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1416, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1416 {
            --translate-x: -1416px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1415, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1415 {
            --translate-x: -1415px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1414, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1414 {
            --translate-x: -1414px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1413, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1413 {
            --translate-x: -1413px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1412, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1412 {
            --translate-x: -1412px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1411, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1411 {
            --translate-x: -1411px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1410, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1410 {
            --translate-x: -1410px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1409, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1409 {
            --translate-x: -1409px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1408, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1408 {
            --translate-x: -1408px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1407, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1407 {
            --translate-x: -1407px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1406, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1406 {
            --translate-x: -1406px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1405, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1405 {
            --translate-x: -1405px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1404, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1404 {
            --translate-x: -1404px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1403, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1403 {
            --translate-x: -1403px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1402, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1402 {
            --translate-x: -1402px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1401, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1401 {
            --translate-x: -1401px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1400, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1400 {
            --translate-x: -1400px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1399, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1399 {
            --translate-x: -1399px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1398, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1398 {
            --translate-x: -1398px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1397, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1397 {
            --translate-x: -1397px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1396, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1396 {
            --translate-x: -1396px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1395, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1395 {
            --translate-x: -1395px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1394, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1394 {
            --translate-x: -1394px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1393, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1393 {
            --translate-x: -1393px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1392, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1392 {
            --translate-x: -1392px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1391, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1391 {
            --translate-x: -1391px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1390, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1390 {
            --translate-x: -1390px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1389, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1389 {
            --translate-x: -1389px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1388, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1388 {
            --translate-x: -1388px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1387, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1387 {
            --translate-x: -1387px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1386, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1386 {
            --translate-x: -1386px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1385, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1385 {
            --translate-x: -1385px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1384, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1384 {
            --translate-x: -1384px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1383, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1383 {
            --translate-x: -1383px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1382, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1382 {
            --translate-x: -1382px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1381, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1381 {
            --translate-x: -1381px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1380, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1380 {
            --translate-x: -1380px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1379, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1379 {
            --translate-x: -1379px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1378, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1378 {
            --translate-x: -1378px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1377, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1377 {
            --translate-x: -1377px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1376, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1376 {
            --translate-x: -1376px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1375, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1375 {
            --translate-x: -1375px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1374, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1374 {
            --translate-x: -1374px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1373, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1373 {
            --translate-x: -1373px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1372, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1372 {
            --translate-x: -1372px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1371, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1371 {
            --translate-x: -1371px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1370, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1370 {
            --translate-x: -1370px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1369, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1369 {
            --translate-x: -1369px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1368, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1368 {
            --translate-x: -1368px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1367, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1367 {
            --translate-x: -1367px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1366, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1366 {
            --translate-x: -1366px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1365, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1365 {
            --translate-x: -1365px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1364, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1364 {
            --translate-x: -1364px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1363, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1363 {
            --translate-x: -1363px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1362, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1362 {
            --translate-x: -1362px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1361, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1361 {
            --translate-x: -1361px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1360, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1360 {
            --translate-x: -1360px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1359, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1359 {
            --translate-x: -1359px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1358, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1358 {
            --translate-x: -1358px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1357, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1357 {
            --translate-x: -1357px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1356, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1356 {
            --translate-x: -1356px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1355, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1355 {
            --translate-x: -1355px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1354, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1354 {
            --translate-x: -1354px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1353, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1353 {
            --translate-x: -1353px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1352, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1352 {
            --translate-x: -1352px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1351, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1351 {
            --translate-x: -1351px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1350, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1350 {
            --translate-x: -1350px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1349, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1349 {
            --translate-x: -1349px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1348, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1348 {
            --translate-x: -1348px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1347, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1347 {
            --translate-x: -1347px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1346, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1346 {
            --translate-x: -1346px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1345, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1345 {
            --translate-x: -1345px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1344, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1344 {
            --translate-x: -1344px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1343, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1343 {
            --translate-x: -1343px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1342, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1342 {
            --translate-x: -1342px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1341, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1341 {
            --translate-x: -1341px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1340, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1340 {
            --translate-x: -1340px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1339, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1339 {
            --translate-x: -1339px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1338, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1338 {
            --translate-x: -1338px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1337, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1337 {
            --translate-x: -1337px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1336, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1336 {
            --translate-x: -1336px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1335, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1335 {
            --translate-x: -1335px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1334, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1334 {
            --translate-x: -1334px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1333, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1333 {
            --translate-x: -1333px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1332, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1332 {
            --translate-x: -1332px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1331, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1331 {
            --translate-x: -1331px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1330, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1330 {
            --translate-x: -1330px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1329, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1329 {
            --translate-x: -1329px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1328, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1328 {
            --translate-x: -1328px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1327, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1327 {
            --translate-x: -1327px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1326, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1326 {
            --translate-x: -1326px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1325, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1325 {
            --translate-x: -1325px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1324, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1324 {
            --translate-x: -1324px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1323, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1323 {
            --translate-x: -1323px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1322, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1322 {
            --translate-x: -1322px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1321, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1321 {
            --translate-x: -1321px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1320, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1320 {
            --translate-x: -1320px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1319, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1319 {
            --translate-x: -1319px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1318, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1318 {
            --translate-x: -1318px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1317, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1317 {
            --translate-x: -1317px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1316, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1316 {
            --translate-x: -1316px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1315, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1315 {
            --translate-x: -1315px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1314, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1314 {
            --translate-x: -1314px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1313, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1313 {
            --translate-x: -1313px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1312, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1312 {
            --translate-x: -1312px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1311, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1311 {
            --translate-x: -1311px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1310, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1310 {
            --translate-x: -1310px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1309, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1309 {
            --translate-x: -1309px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1308, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1308 {
            --translate-x: -1308px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1307, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1307 {
            --translate-x: -1307px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1306, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1306 {
            --translate-x: -1306px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1305, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1305 {
            --translate-x: -1305px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1304, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1304 {
            --translate-x: -1304px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1303, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1303 {
            --translate-x: -1303px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1302, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1302 {
            --translate-x: -1302px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1301, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1301 {
            --translate-x: -1301px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1300, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1300 {
            --translate-x: -1300px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1299, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1299 {
            --translate-x: -1299px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1298, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1298 {
            --translate-x: -1298px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1297, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1297 {
            --translate-x: -1297px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1296, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1296 {
            --translate-x: -1296px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1295, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1295 {
            --translate-x: -1295px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1294, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1294 {
            --translate-x: -1294px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1293, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1293 {
            --translate-x: -1293px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1292, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1292 {
            --translate-x: -1292px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1291, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1291 {
            --translate-x: -1291px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1290, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1290 {
            --translate-x: -1290px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1289, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1289 {
            --translate-x: -1289px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1288, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1288 {
            --translate-x: -1288px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1287, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1287 {
            --translate-x: -1287px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1286, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1286 {
            --translate-x: -1286px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1285, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1285 {
            --translate-x: -1285px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1284, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1284 {
            --translate-x: -1284px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1283, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1283 {
            --translate-x: -1283px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1282, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1282 {
            --translate-x: -1282px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1281, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1281 {
            --translate-x: -1281px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1280, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1280 {
            --translate-x: -1280px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1279, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1279 {
            --translate-x: -1279px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1278, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1278 {
            --translate-x: -1278px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1277, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1277 {
            --translate-x: -1277px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1276, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1276 {
            --translate-x: -1276px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1275, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1275 {
            --translate-x: -1275px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1274, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1274 {
            --translate-x: -1274px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1273, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1273 {
            --translate-x: -1273px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1272, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1272 {
            --translate-x: -1272px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1271, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1271 {
            --translate-x: -1271px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1270, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1270 {
            --translate-x: -1270px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1269, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1269 {
            --translate-x: -1269px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1268, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1268 {
            --translate-x: -1268px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1267, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1267 {
            --translate-x: -1267px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1266, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1266 {
            --translate-x: -1266px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1265, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1265 {
            --translate-x: -1265px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1264, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1264 {
            --translate-x: -1264px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1263, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1263 {
            --translate-x: -1263px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1262, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1262 {
            --translate-x: -1262px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1261, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1261 {
            --translate-x: -1261px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1260, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1260 {
            --translate-x: -1260px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1259, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1259 {
            --translate-x: -1259px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1258, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1258 {
            --translate-x: -1258px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1257, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1257 {
            --translate-x: -1257px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1256, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1256 {
            --translate-x: -1256px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1255, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1255 {
            --translate-x: -1255px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1254, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1254 {
            --translate-x: -1254px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1253, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1253 {
            --translate-x: -1253px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1252, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1252 {
            --translate-x: -1252px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1251, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1251 {
            --translate-x: -1251px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1250, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1250 {
            --translate-x: -1250px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1249, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1249 {
            --translate-x: -1249px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1248, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1248 {
            --translate-x: -1248px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1247, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1247 {
            --translate-x: -1247px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1246, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1246 {
            --translate-x: -1246px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1245, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1245 {
            --translate-x: -1245px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1244, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1244 {
            --translate-x: -1244px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1243, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1243 {
            --translate-x: -1243px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1242, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1242 {
            --translate-x: -1242px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1241, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1241 {
            --translate-x: -1241px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1240, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1240 {
            --translate-x: -1240px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1239, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1239 {
            --translate-x: -1239px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1238, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1238 {
            --translate-x: -1238px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1237, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1237 {
            --translate-x: -1237px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1236, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1236 {
            --translate-x: -1236px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1235, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1235 {
            --translate-x: -1235px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1234, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1234 {
            --translate-x: -1234px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1233, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1233 {
            --translate-x: -1233px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1232, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1232 {
            --translate-x: -1232px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1231, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1231 {
            --translate-x: -1231px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1230, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1230 {
            --translate-x: -1230px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1229, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1229 {
            --translate-x: -1229px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1228, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1228 {
            --translate-x: -1228px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1227, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1227 {
            --translate-x: -1227px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1226, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1226 {
            --translate-x: -1226px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1225, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1225 {
            --translate-x: -1225px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1224, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1224 {
            --translate-x: -1224px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1223, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1223 {
            --translate-x: -1223px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1222, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1222 {
            --translate-x: -1222px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1221, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1221 {
            --translate-x: -1221px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1220, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1220 {
            --translate-x: -1220px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1219, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1219 {
            --translate-x: -1219px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1218, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1218 {
            --translate-x: -1218px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1217, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1217 {
            --translate-x: -1217px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1216, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1216 {
            --translate-x: -1216px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1215, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1215 {
            --translate-x: -1215px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1214, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1214 {
            --translate-x: -1214px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1213, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1213 {
            --translate-x: -1213px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1212, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1212 {
            --translate-x: -1212px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1211, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1211 {
            --translate-x: -1211px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1210, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1210 {
            --translate-x: -1210px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1209, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1209 {
            --translate-x: -1209px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1208, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1208 {
            --translate-x: -1208px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1207, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1207 {
            --translate-x: -1207px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1206, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1206 {
            --translate-x: -1206px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1205, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1205 {
            --translate-x: -1205px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1204, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1204 {
            --translate-x: -1204px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1203, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1203 {
            --translate-x: -1203px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1202, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1202 {
            --translate-x: -1202px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1201, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1201 {
            --translate-x: -1201px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1200, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1200 {
            --translate-x: -1200px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1199, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1199 {
            --translate-x: -1199px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1198, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1198 {
            --translate-x: -1198px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1197, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1197 {
            --translate-x: -1197px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1196, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1196 {
            --translate-x: -1196px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1195, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1195 {
            --translate-x: -1195px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1194, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1194 {
            --translate-x: -1194px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1193, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1193 {
            --translate-x: -1193px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1192, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1192 {
            --translate-x: -1192px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1191, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1191 {
            --translate-x: -1191px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1190, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1190 {
            --translate-x: -1190px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1189, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1189 {
            --translate-x: -1189px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1188, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1188 {
            --translate-x: -1188px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1187, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1187 {
            --translate-x: -1187px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1186, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1186 {
            --translate-x: -1186px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1185, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1185 {
            --translate-x: -1185px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1184, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1184 {
            --translate-x: -1184px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1183, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1183 {
            --translate-x: -1183px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1182, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1182 {
            --translate-x: -1182px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1181, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1181 {
            --translate-x: -1181px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1180, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1180 {
            --translate-x: -1180px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1179, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1179 {
            --translate-x: -1179px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1178, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1178 {
            --translate-x: -1178px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1177, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1177 {
            --translate-x: -1177px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1176, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1176 {
            --translate-x: -1176px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1175, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1175 {
            --translate-x: -1175px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1174, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1174 {
            --translate-x: -1174px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1173, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1173 {
            --translate-x: -1173px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1172, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1172 {
            --translate-x: -1172px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1171, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1171 {
            --translate-x: -1171px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1170, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1170 {
            --translate-x: -1170px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1169, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1169 {
            --translate-x: -1169px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1168, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1168 {
            --translate-x: -1168px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1167, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1167 {
            --translate-x: -1167px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1166, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1166 {
            --translate-x: -1166px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1165, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1165 {
            --translate-x: -1165px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1164, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1164 {
            --translate-x: -1164px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1163, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1163 {
            --translate-x: -1163px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1162, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1162 {
            --translate-x: -1162px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1161, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1161 {
            --translate-x: -1161px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1160, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1160 {
            --translate-x: -1160px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1159, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1159 {
            --translate-x: -1159px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1158, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1158 {
            --translate-x: -1158px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1157, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1157 {
            --translate-x: -1157px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1156, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1156 {
            --translate-x: -1156px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1155, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1155 {
            --translate-x: -1155px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1154, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1154 {
            --translate-x: -1154px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1153, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1153 {
            --translate-x: -1153px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1152, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1152 {
            --translate-x: -1152px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1151, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1151 {
            --translate-x: -1151px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1150, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1150 {
            --translate-x: -1150px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1149, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1149 {
            --translate-x: -1149px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1148, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1148 {
            --translate-x: -1148px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1147, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1147 {
            --translate-x: -1147px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1146, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1146 {
            --translate-x: -1146px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1145, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1145 {
            --translate-x: -1145px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1144, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1144 {
            --translate-x: -1144px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1143, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1143 {
            --translate-x: -1143px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1142, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1142 {
            --translate-x: -1142px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1141, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1141 {
            --translate-x: -1141px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1140, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1140 {
            --translate-x: -1140px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1139, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1139 {
            --translate-x: -1139px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1138, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1138 {
            --translate-x: -1138px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1137, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1137 {
            --translate-x: -1137px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1136, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1136 {
            --translate-x: -1136px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1135, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1135 {
            --translate-x: -1135px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1134, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1134 {
            --translate-x: -1134px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1133, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1133 {
            --translate-x: -1133px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1132, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1132 {
            --translate-x: -1132px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1131, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1131 {
            --translate-x: -1131px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1130, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1130 {
            --translate-x: -1130px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1129, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1129 {
            --translate-x: -1129px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1128, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1128 {
            --translate-x: -1128px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1127, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1127 {
            --translate-x: -1127px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1126, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1126 {
            --translate-x: -1126px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1125, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1125 {
            --translate-x: -1125px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1124, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1124 {
            --translate-x: -1124px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1123, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1123 {
            --translate-x: -1123px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1122, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1122 {
            --translate-x: -1122px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1121, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1121 {
            --translate-x: -1121px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1120, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1120 {
            --translate-x: -1120px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1119, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1119 {
            --translate-x: -1119px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1118, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1118 {
            --translate-x: -1118px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1117, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1117 {
            --translate-x: -1117px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1116, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1116 {
            --translate-x: -1116px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1115, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1115 {
            --translate-x: -1115px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1114, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1114 {
            --translate-x: -1114px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1113, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1113 {
            --translate-x: -1113px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1112, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1112 {
            --translate-x: -1112px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1111, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1111 {
            --translate-x: -1111px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1110, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1110 {
            --translate-x: -1110px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1109, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1109 {
            --translate-x: -1109px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1108, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1108 {
            --translate-x: -1108px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1107, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1107 {
            --translate-x: -1107px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1106, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1106 {
            --translate-x: -1106px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1105, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1105 {
            --translate-x: -1105px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1104, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1104 {
            --translate-x: -1104px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1103, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1103 {
            --translate-x: -1103px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1102, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1102 {
            --translate-x: -1102px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1101, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1101 {
            --translate-x: -1101px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1100, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1100 {
            --translate-x: -1100px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1099, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1099 {
            --translate-x: -1099px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1098, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1098 {
            --translate-x: -1098px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1097, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1097 {
            --translate-x: -1097px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1096, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1096 {
            --translate-x: -1096px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1095, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1095 {
            --translate-x: -1095px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1094, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1094 {
            --translate-x: -1094px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1093, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1093 {
            --translate-x: -1093px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1092, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1092 {
            --translate-x: -1092px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1091, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1091 {
            --translate-x: -1091px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1090, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1090 {
            --translate-x: -1090px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1089, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1089 {
            --translate-x: -1089px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1088, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1088 {
            --translate-x: -1088px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1087, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1087 {
            --translate-x: -1087px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1086, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1086 {
            --translate-x: -1086px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1085, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1085 {
            --translate-x: -1085px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1084, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1084 {
            --translate-x: -1084px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1083, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1083 {
            --translate-x: -1083px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1082, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1082 {
            --translate-x: -1082px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1081, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1081 {
            --translate-x: -1081px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1080, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1080 {
            --translate-x: -1080px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1079, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1079 {
            --translate-x: -1079px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1078, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1078 {
            --translate-x: -1078px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1077, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1077 {
            --translate-x: -1077px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1076, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1076 {
            --translate-x: -1076px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1075, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1075 {
            --translate-x: -1075px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1074, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1074 {
            --translate-x: -1074px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1073, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1073 {
            --translate-x: -1073px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1072, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1072 {
            --translate-x: -1072px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1071, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1071 {
            --translate-x: -1071px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1070, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1070 {
            --translate-x: -1070px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1069, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1069 {
            --translate-x: -1069px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1068, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1068 {
            --translate-x: -1068px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1067, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1067 {
            --translate-x: -1067px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1066, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1066 {
            --translate-x: -1066px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1065, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1065 {
            --translate-x: -1065px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1064, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1064 {
            --translate-x: -1064px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1063, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1063 {
            --translate-x: -1063px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1062, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1062 {
            --translate-x: -1062px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1061, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1061 {
            --translate-x: -1061px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1060, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1060 {
            --translate-x: -1060px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1059, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1059 {
            --translate-x: -1059px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1058, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1058 {
            --translate-x: -1058px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1057, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1057 {
            --translate-x: -1057px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1056, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1056 {
            --translate-x: -1056px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1055, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1055 {
            --translate-x: -1055px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1054, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1054 {
            --translate-x: -1054px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1053, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1053 {
            --translate-x: -1053px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1052, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1052 {
            --translate-x: -1052px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1051, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1051 {
            --translate-x: -1051px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1050, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1050 {
            --translate-x: -1050px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1049, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1049 {
            --translate-x: -1049px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1048, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1048 {
            --translate-x: -1048px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1047, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1047 {
            --translate-x: -1047px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1046, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1046 {
            --translate-x: -1046px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1045, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1045 {
            --translate-x: -1045px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1044, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1044 {
            --translate-x: -1044px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1043, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1043 {
            --translate-x: -1043px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1042, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1042 {
            --translate-x: -1042px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1041, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1041 {
            --translate-x: -1041px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1040, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1040 {
            --translate-x: -1040px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1039, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1039 {
            --translate-x: -1039px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1038, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1038 {
            --translate-x: -1038px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1037, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1037 {
            --translate-x: -1037px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1036, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1036 {
            --translate-x: -1036px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1035, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1035 {
            --translate-x: -1035px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1034, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1034 {
            --translate-x: -1034px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1033, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1033 {
            --translate-x: -1033px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1032, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1032 {
            --translate-x: -1032px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1031, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1031 {
            --translate-x: -1031px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1030, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1030 {
            --translate-x: -1030px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1029, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1029 {
            --translate-x: -1029px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1028, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1028 {
            --translate-x: -1028px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1027, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1027 {
            --translate-x: -1027px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1026, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1026 {
            --translate-x: -1026px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1025, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1025 {
            --translate-x: -1025px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1024, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1024 {
            --translate-x: -1024px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1023, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1023 {
            --translate-x: -1023px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1022, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1022 {
            --translate-x: -1022px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1021, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1021 {
            --translate-x: -1021px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1020, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1020 {
            --translate-x: -1020px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1019, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1019 {
            --translate-x: -1019px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1018, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1018 {
            --translate-x: -1018px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1017, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1017 {
            --translate-x: -1017px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1016, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1016 {
            --translate-x: -1016px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1015, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1015 {
            --translate-x: -1015px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1014, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1014 {
            --translate-x: -1014px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1013, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1013 {
            --translate-x: -1013px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1012, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1012 {
            --translate-x: -1012px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1011, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1011 {
            --translate-x: -1011px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1010, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1010 {
            --translate-x: -1010px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1009, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1009 {
            --translate-x: -1009px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1008, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1008 {
            --translate-x: -1008px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1007, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1007 {
            --translate-x: -1007px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1006, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1006 {
            --translate-x: -1006px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1005, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1005 {
            --translate-x: -1005px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1004, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1004 {
            --translate-x: -1004px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1003, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1003 {
            --translate-x: -1003px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1002, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1002 {
            --translate-x: -1002px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1001, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1001 {
            --translate-x: -1001px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1000, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1000 {
            --translate-x: -1000px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--999, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--999 {
            --translate-x: -999px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--998, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--998 {
            --translate-x: -998px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--997, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--997 {
            --translate-x: -997px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--996, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--996 {
            --translate-x: -996px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--995, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--995 {
            --translate-x: -995px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--994, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--994 {
            --translate-x: -994px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--993, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--993 {
            --translate-x: -993px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--992, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--992 {
            --translate-x: -992px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--991, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--991 {
            --translate-x: -991px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--990, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--990 {
            --translate-x: -990px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--989, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--989 {
            --translate-x: -989px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--988, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--988 {
            --translate-x: -988px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--987, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--987 {
            --translate-x: -987px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--986, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--986 {
            --translate-x: -986px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--985, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--985 {
            --translate-x: -985px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--984, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--984 {
            --translate-x: -984px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--983, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--983 {
            --translate-x: -983px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--982, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--982 {
            --translate-x: -982px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--981, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--981 {
            --translate-x: -981px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--980, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--980 {
            --translate-x: -980px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--979, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--979 {
            --translate-x: -979px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--978, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--978 {
            --translate-x: -978px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--977, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--977 {
            --translate-x: -977px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--976, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--976 {
            --translate-x: -976px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--975, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--975 {
            --translate-x: -975px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--974, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--974 {
            --translate-x: -974px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--973, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--973 {
            --translate-x: -973px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--972, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--972 {
            --translate-x: -972px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--971, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--971 {
            --translate-x: -971px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--970, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--970 {
            --translate-x: -970px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--969, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--969 {
            --translate-x: -969px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--968, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--968 {
            --translate-x: -968px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--967, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--967 {
            --translate-x: -967px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--966, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--966 {
            --translate-x: -966px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--965, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--965 {
            --translate-x: -965px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--964, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--964 {
            --translate-x: -964px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--963, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--963 {
            --translate-x: -963px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--962, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--962 {
            --translate-x: -962px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--961, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--961 {
            --translate-x: -961px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--960, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--960 {
            --translate-x: -960px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--959, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--959 {
            --translate-x: -959px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--958, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--958 {
            --translate-x: -958px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--957, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--957 {
            --translate-x: -957px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--956, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--956 {
            --translate-x: -956px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--955, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--955 {
            --translate-x: -955px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--954, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--954 {
            --translate-x: -954px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--953, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--953 {
            --translate-x: -953px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--952, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--952 {
            --translate-x: -952px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--951, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--951 {
            --translate-x: -951px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--950, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--950 {
            --translate-x: -950px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--949, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--949 {
            --translate-x: -949px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--948, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--948 {
            --translate-x: -948px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--947, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--947 {
            --translate-x: -947px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--946, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--946 {
            --translate-x: -946px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--945, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--945 {
            --translate-x: -945px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--944, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--944 {
            --translate-x: -944px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--943, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--943 {
            --translate-x: -943px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--942, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--942 {
            --translate-x: -942px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--941, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--941 {
            --translate-x: -941px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--940, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--940 {
            --translate-x: -940px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--939, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--939 {
            --translate-x: -939px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--938, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--938 {
            --translate-x: -938px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--937, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--937 {
            --translate-x: -937px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--936, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--936 {
            --translate-x: -936px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--935, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--935 {
            --translate-x: -935px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--934, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--934 {
            --translate-x: -934px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--933, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--933 {
            --translate-x: -933px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--932, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--932 {
            --translate-x: -932px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--931, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--931 {
            --translate-x: -931px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--930, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--930 {
            --translate-x: -930px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--929, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--929 {
            --translate-x: -929px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--928, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--928 {
            --translate-x: -928px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--927, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--927 {
            --translate-x: -927px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--926, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--926 {
            --translate-x: -926px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--925, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--925 {
            --translate-x: -925px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--924, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--924 {
            --translate-x: -924px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--923, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--923 {
            --translate-x: -923px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--922, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--922 {
            --translate-x: -922px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--921, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--921 {
            --translate-x: -921px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--920, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--920 {
            --translate-x: -920px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--919, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--919 {
            --translate-x: -919px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--918, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--918 {
            --translate-x: -918px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--917, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--917 {
            --translate-x: -917px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--916, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--916 {
            --translate-x: -916px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--915, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--915 {
            --translate-x: -915px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--914, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--914 {
            --translate-x: -914px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--913, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--913 {
            --translate-x: -913px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--912, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--912 {
            --translate-x: -912px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--911, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--911 {
            --translate-x: -911px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--910, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--910 {
            --translate-x: -910px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--909, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--909 {
            --translate-x: -909px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--908, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--908 {
            --translate-x: -908px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--907, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--907 {
            --translate-x: -907px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--906, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--906 {
            --translate-x: -906px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--905, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--905 {
            --translate-x: -905px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--904, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--904 {
            --translate-x: -904px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--903, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--903 {
            --translate-x: -903px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--902, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--902 {
            --translate-x: -902px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--901, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--901 {
            --translate-x: -901px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--900, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--900 {
            --translate-x: -900px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--899, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--899 {
            --translate-x: -899px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--898, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--898 {
            --translate-x: -898px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--897, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--897 {
            --translate-x: -897px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--896, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--896 {
            --translate-x: -896px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--895, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--895 {
            --translate-x: -895px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--894, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--894 {
            --translate-x: -894px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--893, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--893 {
            --translate-x: -893px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--892, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--892 {
            --translate-x: -892px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--891, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--891 {
            --translate-x: -891px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--890, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--890 {
            --translate-x: -890px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--889, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--889 {
            --translate-x: -889px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--888, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--888 {
            --translate-x: -888px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--887, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--887 {
            --translate-x: -887px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--886, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--886 {
            --translate-x: -886px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--885, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--885 {
            --translate-x: -885px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--884, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--884 {
            --translate-x: -884px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--883, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--883 {
            --translate-x: -883px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--882, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--882 {
            --translate-x: -882px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--881, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--881 {
            --translate-x: -881px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--880, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--880 {
            --translate-x: -880px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--879, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--879 {
            --translate-x: -879px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--878, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--878 {
            --translate-x: -878px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--877, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--877 {
            --translate-x: -877px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--876, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--876 {
            --translate-x: -876px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--875, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--875 {
            --translate-x: -875px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--874, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--874 {
            --translate-x: -874px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--873, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--873 {
            --translate-x: -873px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--872, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--872 {
            --translate-x: -872px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--871, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--871 {
            --translate-x: -871px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--870, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--870 {
            --translate-x: -870px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--869, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--869 {
            --translate-x: -869px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--868, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--868 {
            --translate-x: -868px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--867, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--867 {
            --translate-x: -867px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--866, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--866 {
            --translate-x: -866px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--865, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--865 {
            --translate-x: -865px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--864, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--864 {
            --translate-x: -864px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--863, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--863 {
            --translate-x: -863px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--862, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--862 {
            --translate-x: -862px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--861, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--861 {
            --translate-x: -861px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--860, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--860 {
            --translate-x: -860px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--859, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--859 {
            --translate-x: -859px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--858, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--858 {
            --translate-x: -858px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--857, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--857 {
            --translate-x: -857px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--856, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--856 {
            --translate-x: -856px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--855, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--855 {
            --translate-x: -855px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--854, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--854 {
            --translate-x: -854px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--853, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--853 {
            --translate-x: -853px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--852, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--852 {
            --translate-x: -852px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--851, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--851 {
            --translate-x: -851px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--850, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--850 {
            --translate-x: -850px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--849, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--849 {
            --translate-x: -849px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--848, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--848 {
            --translate-x: -848px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--847, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--847 {
            --translate-x: -847px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--846, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--846 {
            --translate-x: -846px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--845, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--845 {
            --translate-x: -845px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--844, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--844 {
            --translate-x: -844px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--843, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--843 {
            --translate-x: -843px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--842, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--842 {
            --translate-x: -842px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--841, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--841 {
            --translate-x: -841px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--840, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--840 {
            --translate-x: -840px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--839, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--839 {
            --translate-x: -839px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--838, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--838 {
            --translate-x: -838px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--837, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--837 {
            --translate-x: -837px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--836, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--836 {
            --translate-x: -836px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--835, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--835 {
            --translate-x: -835px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--834, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--834 {
            --translate-x: -834px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--833, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--833 {
            --translate-x: -833px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--832, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--832 {
            --translate-x: -832px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--831, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--831 {
            --translate-x: -831px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--830, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--830 {
            --translate-x: -830px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--829, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--829 {
            --translate-x: -829px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--828, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--828 {
            --translate-x: -828px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--827, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--827 {
            --translate-x: -827px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--826, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--826 {
            --translate-x: -826px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--825, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--825 {
            --translate-x: -825px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--824, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--824 {
            --translate-x: -824px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--823, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--823 {
            --translate-x: -823px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--822, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--822 {
            --translate-x: -822px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--821, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--821 {
            --translate-x: -821px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--820, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--820 {
            --translate-x: -820px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--819, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--819 {
            --translate-x: -819px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--818, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--818 {
            --translate-x: -818px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--817, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--817 {
            --translate-x: -817px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--816, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--816 {
            --translate-x: -816px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--815, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--815 {
            --translate-x: -815px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--814, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--814 {
            --translate-x: -814px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--813, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--813 {
            --translate-x: -813px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--812, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--812 {
            --translate-x: -812px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--811, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--811 {
            --translate-x: -811px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--810, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--810 {
            --translate-x: -810px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--809, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--809 {
            --translate-x: -809px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--808, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--808 {
            --translate-x: -808px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--807, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--807 {
            --translate-x: -807px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--806, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--806 {
            --translate-x: -806px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--805, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--805 {
            --translate-x: -805px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--804, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--804 {
            --translate-x: -804px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--803, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--803 {
            --translate-x: -803px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--802, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--802 {
            --translate-x: -802px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--801, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--801 {
            --translate-x: -801px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--800, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--800 {
            --translate-x: -800px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--799, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--799 {
            --translate-x: -799px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--798, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--798 {
            --translate-x: -798px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--797, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--797 {
            --translate-x: -797px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--796, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--796 {
            --translate-x: -796px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--795, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--795 {
            --translate-x: -795px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--794, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--794 {
            --translate-x: -794px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--793, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--793 {
            --translate-x: -793px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--792, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--792 {
            --translate-x: -792px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--791, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--791 {
            --translate-x: -791px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--790, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--790 {
            --translate-x: -790px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--789, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--789 {
            --translate-x: -789px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--788, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--788 {
            --translate-x: -788px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--787, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--787 {
            --translate-x: -787px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--786, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--786 {
            --translate-x: -786px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--785, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--785 {
            --translate-x: -785px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--784, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--784 {
            --translate-x: -784px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--783, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--783 {
            --translate-x: -783px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--782, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--782 {
            --translate-x: -782px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--781, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--781 {
            --translate-x: -781px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--780, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--780 {
            --translate-x: -780px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--779, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--779 {
            --translate-x: -779px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--778, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--778 {
            --translate-x: -778px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--777, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--777 {
            --translate-x: -777px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--776, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--776 {
            --translate-x: -776px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--775, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--775 {
            --translate-x: -775px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--774, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--774 {
            --translate-x: -774px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--773, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--773 {
            --translate-x: -773px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--772, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--772 {
            --translate-x: -772px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--771, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--771 {
            --translate-x: -771px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--770, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--770 {
            --translate-x: -770px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--769, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--769 {
            --translate-x: -769px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--768, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--768 {
            --translate-x: -768px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--767, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--767 {
            --translate-x: -767px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--766, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--766 {
            --translate-x: -766px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--765, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--765 {
            --translate-x: -765px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--764, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--764 {
            --translate-x: -764px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--763, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--763 {
            --translate-x: -763px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--762, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--762 {
            --translate-x: -762px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--761, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--761 {
            --translate-x: -761px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--760, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--760 {
            --translate-x: -760px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--759, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--759 {
            --translate-x: -759px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--758, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--758 {
            --translate-x: -758px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--757, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--757 {
            --translate-x: -757px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--756, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--756 {
            --translate-x: -756px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--755, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--755 {
            --translate-x: -755px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--754, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--754 {
            --translate-x: -754px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--753, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--753 {
            --translate-x: -753px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--752, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--752 {
            --translate-x: -752px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--751, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--751 {
            --translate-x: -751px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--750, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--750 {
            --translate-x: -750px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--749, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--749 {
            --translate-x: -749px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--748, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--748 {
            --translate-x: -748px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--747, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--747 {
            --translate-x: -747px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--746, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--746 {
            --translate-x: -746px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--745, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--745 {
            --translate-x: -745px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--744, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--744 {
            --translate-x: -744px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--743, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--743 {
            --translate-x: -743px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--742, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--742 {
            --translate-x: -742px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--741, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--741 {
            --translate-x: -741px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--740, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--740 {
            --translate-x: -740px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--739, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--739 {
            --translate-x: -739px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--738, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--738 {
            --translate-x: -738px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--737, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--737 {
            --translate-x: -737px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--736, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--736 {
            --translate-x: -736px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--735, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--735 {
            --translate-x: -735px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--734, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--734 {
            --translate-x: -734px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--733, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--733 {
            --translate-x: -733px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--732, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--732 {
            --translate-x: -732px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--731, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--731 {
            --translate-x: -731px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--730, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--730 {
            --translate-x: -730px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--729, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--729 {
            --translate-x: -729px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--728, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--728 {
            --translate-x: -728px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--727, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--727 {
            --translate-x: -727px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--726, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--726 {
            --translate-x: -726px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--725, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--725 {
            --translate-x: -725px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--724, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--724 {
            --translate-x: -724px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--723, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--723 {
            --translate-x: -723px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--722, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--722 {
            --translate-x: -722px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--721, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--721 {
            --translate-x: -721px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--720, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--720 {
            --translate-x: -720px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--719, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--719 {
            --translate-x: -719px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--718, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--718 {
            --translate-x: -718px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--717, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--717 {
            --translate-x: -717px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--716, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--716 {
            --translate-x: -716px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--715, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--715 {
            --translate-x: -715px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--714, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--714 {
            --translate-x: -714px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--713, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--713 {
            --translate-x: -713px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--712, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--712 {
            --translate-x: -712px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--711, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--711 {
            --translate-x: -711px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--710, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--710 {
            --translate-x: -710px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--709, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--709 {
            --translate-x: -709px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--708, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--708 {
            --translate-x: -708px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--707, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--707 {
            --translate-x: -707px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--706, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--706 {
            --translate-x: -706px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--705, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--705 {
            --translate-x: -705px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--704, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--704 {
            --translate-x: -704px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--703, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--703 {
            --translate-x: -703px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--702, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--702 {
            --translate-x: -702px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--701, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--701 {
            --translate-x: -701px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--700, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--700 {
            --translate-x: -700px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--699, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--699 {
            --translate-x: -699px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--698, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--698 {
            --translate-x: -698px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--697, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--697 {
            --translate-x: -697px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--696, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--696 {
            --translate-x: -696px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--695, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--695 {
            --translate-x: -695px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--694, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--694 {
            --translate-x: -694px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--693, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--693 {
            --translate-x: -693px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--692, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--692 {
            --translate-x: -692px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--691, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--691 {
            --translate-x: -691px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--690, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--690 {
            --translate-x: -690px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--689, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--689 {
            --translate-x: -689px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--688, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--688 {
            --translate-x: -688px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--687, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--687 {
            --translate-x: -687px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--686, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--686 {
            --translate-x: -686px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--685, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--685 {
            --translate-x: -685px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--684, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--684 {
            --translate-x: -684px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--683, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--683 {
            --translate-x: -683px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--682, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--682 {
            --translate-x: -682px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--681, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--681 {
            --translate-x: -681px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--680, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--680 {
            --translate-x: -680px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--679, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--679 {
            --translate-x: -679px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--678, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--678 {
            --translate-x: -678px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--677, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--677 {
            --translate-x: -677px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--676, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--676 {
            --translate-x: -676px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--675, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--675 {
            --translate-x: -675px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--674, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--674 {
            --translate-x: -674px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--673, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--673 {
            --translate-x: -673px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--672, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--672 {
            --translate-x: -672px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--671, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--671 {
            --translate-x: -671px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--670, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--670 {
            --translate-x: -670px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--669, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--669 {
            --translate-x: -669px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--668, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--668 {
            --translate-x: -668px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--667, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--667 {
            --translate-x: -667px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--666, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--666 {
            --translate-x: -666px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--665, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--665 {
            --translate-x: -665px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--664, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--664 {
            --translate-x: -664px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--663, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--663 {
            --translate-x: -663px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--662, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--662 {
            --translate-x: -662px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--661, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--661 {
            --translate-x: -661px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--660, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--660 {
            --translate-x: -660px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--659, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--659 {
            --translate-x: -659px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--658, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--658 {
            --translate-x: -658px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--657, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--657 {
            --translate-x: -657px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--656, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--656 {
            --translate-x: -656px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--655, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--655 {
            --translate-x: -655px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--654, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--654 {
            --translate-x: -654px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--653, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--653 {
            --translate-x: -653px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--652, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--652 {
            --translate-x: -652px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--651, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--651 {
            --translate-x: -651px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--650, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--650 {
            --translate-x: -650px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--649, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--649 {
            --translate-x: -649px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--648, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--648 {
            --translate-x: -648px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--647, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--647 {
            --translate-x: -647px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--646, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--646 {
            --translate-x: -646px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--645, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--645 {
            --translate-x: -645px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--644, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--644 {
            --translate-x: -644px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--643, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--643 {
            --translate-x: -643px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--642, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--642 {
            --translate-x: -642px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--641, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--641 {
            --translate-x: -641px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--640, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--640 {
            --translate-x: -640px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--639, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--639 {
            --translate-x: -639px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--638, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--638 {
            --translate-x: -638px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--637, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--637 {
            --translate-x: -637px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--636, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--636 {
            --translate-x: -636px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--635, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--635 {
            --translate-x: -635px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--634, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--634 {
            --translate-x: -634px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--633, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--633 {
            --translate-x: -633px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--632, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--632 {
            --translate-x: -632px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--631, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--631 {
            --translate-x: -631px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--630, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--630 {
            --translate-x: -630px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--629, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--629 {
            --translate-x: -629px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--628, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--628 {
            --translate-x: -628px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--627, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--627 {
            --translate-x: -627px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--626, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--626 {
            --translate-x: -626px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--625, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--625 {
            --translate-x: -625px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--624, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--624 {
            --translate-x: -624px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--623, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--623 {
            --translate-x: -623px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--622, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--622 {
            --translate-x: -622px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--621, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--621 {
            --translate-x: -621px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--620, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--620 {
            --translate-x: -620px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--619, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--619 {
            --translate-x: -619px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--618, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--618 {
            --translate-x: -618px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--617, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--617 {
            --translate-x: -617px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--616, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--616 {
            --translate-x: -616px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--615, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--615 {
            --translate-x: -615px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--614, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--614 {
            --translate-x: -614px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--613, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--613 {
            --translate-x: -613px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--612, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--612 {
            --translate-x: -612px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--611, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--611 {
            --translate-x: -611px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--610, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--610 {
            --translate-x: -610px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--609, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--609 {
            --translate-x: -609px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--608, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--608 {
            --translate-x: -608px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--607, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--607 {
            --translate-x: -607px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--606, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--606 {
            --translate-x: -606px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--605, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--605 {
            --translate-x: -605px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--604, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--604 {
            --translate-x: -604px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--603, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--603 {
            --translate-x: -603px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--602, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--602 {
            --translate-x: -602px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--601, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--601 {
            --translate-x: -601px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--600, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--600 {
            --translate-x: -600px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--599, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--599 {
            --translate-x: -599px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--598, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--598 {
            --translate-x: -598px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--597, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--597 {
            --translate-x: -597px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--596, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--596 {
            --translate-x: -596px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--595, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--595 {
            --translate-x: -595px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--594, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--594 {
            --translate-x: -594px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--593, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--593 {
            --translate-x: -593px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--592, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--592 {
            --translate-x: -592px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--591, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--591 {
            --translate-x: -591px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--590, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--590 {
            --translate-x: -590px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--589, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--589 {
            --translate-x: -589px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--588, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--588 {
            --translate-x: -588px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--587, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--587 {
            --translate-x: -587px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--586, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--586 {
            --translate-x: -586px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--585, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--585 {
            --translate-x: -585px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--584, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--584 {
            --translate-x: -584px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--583, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--583 {
            --translate-x: -583px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--582, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--582 {
            --translate-x: -582px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--581, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--581 {
            --translate-x: -581px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--580, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--580 {
            --translate-x: -580px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--579, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--579 {
            --translate-x: -579px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--578, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--578 {
            --translate-x: -578px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--577, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--577 {
            --translate-x: -577px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--576, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--576 {
            --translate-x: -576px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--575, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--575 {
            --translate-x: -575px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--574, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--574 {
            --translate-x: -574px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--573, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--573 {
            --translate-x: -573px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--572, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--572 {
            --translate-x: -572px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--571, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--571 {
            --translate-x: -571px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--570, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--570 {
            --translate-x: -570px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--569, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--569 {
            --translate-x: -569px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--568, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--568 {
            --translate-x: -568px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--567, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--567 {
            --translate-x: -567px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--566, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--566 {
            --translate-x: -566px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--565, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--565 {
            --translate-x: -565px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--564, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--564 {
            --translate-x: -564px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--563, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--563 {
            --translate-x: -563px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--562, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--562 {
            --translate-x: -562px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--561, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--561 {
            --translate-x: -561px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--560, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--560 {
            --translate-x: -560px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--559, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--559 {
            --translate-x: -559px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--558, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--558 {
            --translate-x: -558px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--557, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--557 {
            --translate-x: -557px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--556, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--556 {
            --translate-x: -556px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--555, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--555 {
            --translate-x: -555px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--554, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--554 {
            --translate-x: -554px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--553, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--553 {
            --translate-x: -553px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--552, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--552 {
            --translate-x: -552px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--551, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--551 {
            --translate-x: -551px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--550, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--550 {
            --translate-x: -550px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--549, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--549 {
            --translate-x: -549px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--548, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--548 {
            --translate-x: -548px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--547, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--547 {
            --translate-x: -547px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--546, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--546 {
            --translate-x: -546px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--545, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--545 {
            --translate-x: -545px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--544, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--544 {
            --translate-x: -544px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--543, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--543 {
            --translate-x: -543px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--542, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--542 {
            --translate-x: -542px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--541, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--541 {
            --translate-x: -541px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--540, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--540 {
            --translate-x: -540px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--539, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--539 {
            --translate-x: -539px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--538, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--538 {
            --translate-x: -538px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--537, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--537 {
            --translate-x: -537px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--536, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--536 {
            --translate-x: -536px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--535, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--535 {
            --translate-x: -535px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--534, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--534 {
            --translate-x: -534px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--533, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--533 {
            --translate-x: -533px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--532, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--532 {
            --translate-x: -532px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--531, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--531 {
            --translate-x: -531px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--530, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--530 {
            --translate-x: -530px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--529, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--529 {
            --translate-x: -529px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--528, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--528 {
            --translate-x: -528px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--527, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--527 {
            --translate-x: -527px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--526, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--526 {
            --translate-x: -526px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--525, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--525 {
            --translate-x: -525px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--524, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--524 {
            --translate-x: -524px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--523, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--523 {
            --translate-x: -523px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--522, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--522 {
            --translate-x: -522px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--521, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--521 {
            --translate-x: -521px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--520, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--520 {
            --translate-x: -520px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--519, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--519 {
            --translate-x: -519px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--518, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--518 {
            --translate-x: -518px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--517, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--517 {
            --translate-x: -517px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--516, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--516 {
            --translate-x: -516px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--515, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--515 {
            --translate-x: -515px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--514, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--514 {
            --translate-x: -514px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--513, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--513 {
            --translate-x: -513px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--512, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--512 {
            --translate-x: -512px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--511, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--511 {
            --translate-x: -511px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--510, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--510 {
            --translate-x: -510px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--509, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--509 {
            --translate-x: -509px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--508, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--508 {
            --translate-x: -508px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--507, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--507 {
            --translate-x: -507px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--506, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--506 {
            --translate-x: -506px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--505, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--505 {
            --translate-x: -505px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--504, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--504 {
            --translate-x: -504px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--503, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--503 {
            --translate-x: -503px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--502, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--502 {
            --translate-x: -502px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--501, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--501 {
            --translate-x: -501px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--500, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--500 {
            --translate-x: -500px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--499, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--499 {
            --translate-x: -499px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--498, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--498 {
            --translate-x: -498px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--497, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--497 {
            --translate-x: -497px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--496, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--496 {
            --translate-x: -496px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--495, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--495 {
            --translate-x: -495px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--494, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--494 {
            --translate-x: -494px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--493, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--493 {
            --translate-x: -493px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--492, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--492 {
            --translate-x: -492px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--491, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--491 {
            --translate-x: -491px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--490, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--490 {
            --translate-x: -490px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--489, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--489 {
            --translate-x: -489px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--488, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--488 {
            --translate-x: -488px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--487, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--487 {
            --translate-x: -487px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--486, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--486 {
            --translate-x: -486px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--485, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--485 {
            --translate-x: -485px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--484, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--484 {
            --translate-x: -484px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--483, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--483 {
            --translate-x: -483px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--482, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--482 {
            --translate-x: -482px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--481, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--481 {
            --translate-x: -481px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--480, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--480 {
            --translate-x: -480px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--479, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--479 {
            --translate-x: -479px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--478, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--478 {
            --translate-x: -478px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--477, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--477 {
            --translate-x: -477px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--476, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--476 {
            --translate-x: -476px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--475, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--475 {
            --translate-x: -475px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--474, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--474 {
            --translate-x: -474px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--473, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--473 {
            --translate-x: -473px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--472, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--472 {
            --translate-x: -472px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--471, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--471 {
            --translate-x: -471px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--470, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--470 {
            --translate-x: -470px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--469, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--469 {
            --translate-x: -469px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--468, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--468 {
            --translate-x: -468px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--467, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--467 {
            --translate-x: -467px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--466, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--466 {
            --translate-x: -466px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--465, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--465 {
            --translate-x: -465px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--464, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--464 {
            --translate-x: -464px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--463, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--463 {
            --translate-x: -463px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--462, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--462 {
            --translate-x: -462px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--461, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--461 {
            --translate-x: -461px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--460, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--460 {
            --translate-x: -460px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--459, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--459 {
            --translate-x: -459px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--458, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--458 {
            --translate-x: -458px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--457, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--457 {
            --translate-x: -457px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--456, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--456 {
            --translate-x: -456px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--455, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--455 {
            --translate-x: -455px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--454, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--454 {
            --translate-x: -454px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--453, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--453 {
            --translate-x: -453px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--452, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--452 {
            --translate-x: -452px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--451, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--451 {
            --translate-x: -451px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--450, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--450 {
            --translate-x: -450px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--449, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--449 {
            --translate-x: -449px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--448, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--448 {
            --translate-x: -448px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--447, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--447 {
            --translate-x: -447px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--446, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--446 {
            --translate-x: -446px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--445, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--445 {
            --translate-x: -445px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--444, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--444 {
            --translate-x: -444px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--443, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--443 {
            --translate-x: -443px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--442, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--442 {
            --translate-x: -442px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--441, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--441 {
            --translate-x: -441px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--440, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--440 {
            --translate-x: -440px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--439, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--439 {
            --translate-x: -439px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--438, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--438 {
            --translate-x: -438px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--437, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--437 {
            --translate-x: -437px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--436, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--436 {
            --translate-x: -436px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--435, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--435 {
            --translate-x: -435px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--434, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--434 {
            --translate-x: -434px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--433, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--433 {
            --translate-x: -433px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--432, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--432 {
            --translate-x: -432px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--431, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--431 {
            --translate-x: -431px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--430, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--430 {
            --translate-x: -430px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--429, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--429 {
            --translate-x: -429px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--428, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--428 {
            --translate-x: -428px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--427, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--427 {
            --translate-x: -427px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--426, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--426 {
            --translate-x: -426px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--425, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--425 {
            --translate-x: -425px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--424, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--424 {
            --translate-x: -424px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--423, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--423 {
            --translate-x: -423px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--422, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--422 {
            --translate-x: -422px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--421, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--421 {
            --translate-x: -421px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--420, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--420 {
            --translate-x: -420px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--419, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--419 {
            --translate-x: -419px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--418, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--418 {
            --translate-x: -418px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--417, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--417 {
            --translate-x: -417px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--416, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--416 {
            --translate-x: -416px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--415, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--415 {
            --translate-x: -415px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--414, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--414 {
            --translate-x: -414px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--413, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--413 {
            --translate-x: -413px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--412, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--412 {
            --translate-x: -412px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--411, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--411 {
            --translate-x: -411px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--410, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--410 {
            --translate-x: -410px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--409, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--409 {
            --translate-x: -409px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--408, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--408 {
            --translate-x: -408px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--407, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--407 {
            --translate-x: -407px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--406, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--406 {
            --translate-x: -406px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--405, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--405 {
            --translate-x: -405px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--404, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--404 {
            --translate-x: -404px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--403, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--403 {
            --translate-x: -403px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--402, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--402 {
            --translate-x: -402px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--401, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--401 {
            --translate-x: -401px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--400, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--400 {
            --translate-x: -400px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--399, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--399 {
            --translate-x: -399px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--398, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--398 {
            --translate-x: -398px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--397, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--397 {
            --translate-x: -397px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--396, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--396 {
            --translate-x: -396px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--395, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--395 {
            --translate-x: -395px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--394, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--394 {
            --translate-x: -394px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--393, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--393 {
            --translate-x: -393px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--392, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--392 {
            --translate-x: -392px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--391, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--391 {
            --translate-x: -391px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--390, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--390 {
            --translate-x: -390px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--389, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--389 {
            --translate-x: -389px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--388, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--388 {
            --translate-x: -388px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--387, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--387 {
            --translate-x: -387px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--386, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--386 {
            --translate-x: -386px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--385, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--385 {
            --translate-x: -385px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--384, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--384 {
            --translate-x: -384px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--383, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--383 {
            --translate-x: -383px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--382, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--382 {
            --translate-x: -382px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--381, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--381 {
            --translate-x: -381px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--380, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--380 {
            --translate-x: -380px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--379, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--379 {
            --translate-x: -379px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--378, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--378 {
            --translate-x: -378px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--377, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--377 {
            --translate-x: -377px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--376, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--376 {
            --translate-x: -376px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--375, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--375 {
            --translate-x: -375px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--374, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--374 {
            --translate-x: -374px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--373, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--373 {
            --translate-x: -373px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--372, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--372 {
            --translate-x: -372px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--371, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--371 {
            --translate-x: -371px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--370, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--370 {
            --translate-x: -370px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--369, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--369 {
            --translate-x: -369px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--368, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--368 {
            --translate-x: -368px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--367, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--367 {
            --translate-x: -367px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--366, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--366 {
            --translate-x: -366px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--365, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--365 {
            --translate-x: -365px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--364, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--364 {
            --translate-x: -364px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--363, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--363 {
            --translate-x: -363px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--362, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--362 {
            --translate-x: -362px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--361, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--361 {
            --translate-x: -361px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--360, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--360 {
            --translate-x: -360px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--359, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--359 {
            --translate-x: -359px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--358, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--358 {
            --translate-x: -358px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--357, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--357 {
            --translate-x: -357px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--356, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--356 {
            --translate-x: -356px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--355, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--355 {
            --translate-x: -355px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--354, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--354 {
            --translate-x: -354px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--353, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--353 {
            --translate-x: -353px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--352, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--352 {
            --translate-x: -352px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--351, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--351 {
            --translate-x: -351px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--350, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--350 {
            --translate-x: -350px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--349, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--349 {
            --translate-x: -349px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--348, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--348 {
            --translate-x: -348px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--347, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--347 {
            --translate-x: -347px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--346, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--346 {
            --translate-x: -346px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--345, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--345 {
            --translate-x: -345px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--344, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--344 {
            --translate-x: -344px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--343, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--343 {
            --translate-x: -343px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--342, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--342 {
            --translate-x: -342px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--341, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--341 {
            --translate-x: -341px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--340, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--340 {
            --translate-x: -340px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--339, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--339 {
            --translate-x: -339px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--338, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--338 {
            --translate-x: -338px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--337, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--337 {
            --translate-x: -337px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--336, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--336 {
            --translate-x: -336px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--335, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--335 {
            --translate-x: -335px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--334, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--334 {
            --translate-x: -334px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--333, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--333 {
            --translate-x: -333px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--332, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--332 {
            --translate-x: -332px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--331, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--331 {
            --translate-x: -331px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--330, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--330 {
            --translate-x: -330px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--329, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--329 {
            --translate-x: -329px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--328, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--328 {
            --translate-x: -328px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--327, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--327 {
            --translate-x: -327px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--326, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--326 {
            --translate-x: -326px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--325, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--325 {
            --translate-x: -325px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--324, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--324 {
            --translate-x: -324px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--323, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--323 {
            --translate-x: -323px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--322, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--322 {
            --translate-x: -322px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--321, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--321 {
            --translate-x: -321px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--320, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--320 {
            --translate-x: -320px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--319, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--319 {
            --translate-x: -319px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--318, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--318 {
            --translate-x: -318px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--317, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--317 {
            --translate-x: -317px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--316, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--316 {
            --translate-x: -316px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--315, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--315 {
            --translate-x: -315px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--314, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--314 {
            --translate-x: -314px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--313, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--313 {
            --translate-x: -313px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--312, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--312 {
            --translate-x: -312px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--311, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--311 {
            --translate-x: -311px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--310, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--310 {
            --translate-x: -310px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--309, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--309 {
            --translate-x: -309px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--308, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--308 {
            --translate-x: -308px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--307, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--307 {
            --translate-x: -307px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--306, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--306 {
            --translate-x: -306px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--305, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--305 {
            --translate-x: -305px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--304, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--304 {
            --translate-x: -304px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--303, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--303 {
            --translate-x: -303px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--302, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--302 {
            --translate-x: -302px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--301, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--301 {
            --translate-x: -301px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--300, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--300 {
            --translate-x: -300px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--299, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--299 {
            --translate-x: -299px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--298, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--298 {
            --translate-x: -298px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--297, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--297 {
            --translate-x: -297px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--296, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--296 {
            --translate-x: -296px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--295, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--295 {
            --translate-x: -295px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--294, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--294 {
            --translate-x: -294px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--293, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--293 {
            --translate-x: -293px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--292, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--292 {
            --translate-x: -292px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--291, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--291 {
            --translate-x: -291px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--290, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--290 {
            --translate-x: -290px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--289, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--289 {
            --translate-x: -289px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--288, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--288 {
            --translate-x: -288px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--287, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--287 {
            --translate-x: -287px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--286, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--286 {
            --translate-x: -286px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--285, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--285 {
            --translate-x: -285px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--284, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--284 {
            --translate-x: -284px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--283, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--283 {
            --translate-x: -283px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--282, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--282 {
            --translate-x: -282px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--281, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--281 {
            --translate-x: -281px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--280, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--280 {
            --translate-x: -280px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--279, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--279 {
            --translate-x: -279px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--278, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--278 {
            --translate-x: -278px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--277, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--277 {
            --translate-x: -277px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--276, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--276 {
            --translate-x: -276px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--275, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--275 {
            --translate-x: -275px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--274, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--274 {
            --translate-x: -274px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--273, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--273 {
            --translate-x: -273px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--272, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--272 {
            --translate-x: -272px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--271, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--271 {
            --translate-x: -271px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--270, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--270 {
            --translate-x: -270px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--269, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--269 {
            --translate-x: -269px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--268, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--268 {
            --translate-x: -268px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--267, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--267 {
            --translate-x: -267px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--266, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--266 {
            --translate-x: -266px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--265, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--265 {
            --translate-x: -265px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--264, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--264 {
            --translate-x: -264px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--263, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--263 {
            --translate-x: -263px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--262, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--262 {
            --translate-x: -262px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--261, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--261 {
            --translate-x: -261px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--260, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--260 {
            --translate-x: -260px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--259, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--259 {
            --translate-x: -259px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--258, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--258 {
            --translate-x: -258px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--257, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--257 {
            --translate-x: -257px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--256, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--256 {
            --translate-x: -256px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--255, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--255 {
            --translate-x: -255px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--254, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--254 {
            --translate-x: -254px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--253, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--253 {
            --translate-x: -253px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--252, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--252 {
            --translate-x: -252px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--251, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--251 {
            --translate-x: -251px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--250, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--250 {
            --translate-x: -250px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--249, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--249 {
            --translate-x: -249px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--248, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--248 {
            --translate-x: -248px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--247, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--247 {
            --translate-x: -247px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--246, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--246 {
            --translate-x: -246px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--245, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--245 {
            --translate-x: -245px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--244, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--244 {
            --translate-x: -244px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--243, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--243 {
            --translate-x: -243px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--242, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--242 {
            --translate-x: -242px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--241, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--241 {
            --translate-x: -241px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--240, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--240 {
            --translate-x: -240px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--239, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--239 {
            --translate-x: -239px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--238, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--238 {
            --translate-x: -238px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--237, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--237 {
            --translate-x: -237px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--236, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--236 {
            --translate-x: -236px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--235, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--235 {
            --translate-x: -235px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--234, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--234 {
            --translate-x: -234px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--233, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--233 {
            --translate-x: -233px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--232, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--232 {
            --translate-x: -232px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--231, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--231 {
            --translate-x: -231px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--230, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--230 {
            --translate-x: -230px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--229, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--229 {
            --translate-x: -229px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--228, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--228 {
            --translate-x: -228px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--227, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--227 {
            --translate-x: -227px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--226, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--226 {
            --translate-x: -226px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--225, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--225 {
            --translate-x: -225px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--224, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--224 {
            --translate-x: -224px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--223, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--223 {
            --translate-x: -223px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--222, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--222 {
            --translate-x: -222px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--221, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--221 {
            --translate-x: -221px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--220, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--220 {
            --translate-x: -220px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--219, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--219 {
            --translate-x: -219px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--218, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--218 {
            --translate-x: -218px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--217, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--217 {
            --translate-x: -217px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--216, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--216 {
            --translate-x: -216px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--215, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--215 {
            --translate-x: -215px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--214, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--214 {
            --translate-x: -214px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--213, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--213 {
            --translate-x: -213px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--212, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--212 {
            --translate-x: -212px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--211, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--211 {
            --translate-x: -211px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--210, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--210 {
            --translate-x: -210px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--209, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--209 {
            --translate-x: -209px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--208, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--208 {
            --translate-x: -208px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--207, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--207 {
            --translate-x: -207px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--206, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--206 {
            --translate-x: -206px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--205, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--205 {
            --translate-x: -205px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--204, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--204 {
            --translate-x: -204px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--203, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--203 {
            --translate-x: -203px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--202, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--202 {
            --translate-x: -202px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--201, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--201 {
            --translate-x: -201px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--200, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--200 {
            --translate-x: -200px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--199, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--199 {
            --translate-x: -199px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--198, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--198 {
            --translate-x: -198px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--197, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--197 {
            --translate-x: -197px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--196, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--196 {
            --translate-x: -196px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--195, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--195 {
            --translate-x: -195px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--194, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--194 {
            --translate-x: -194px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--193, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--193 {
            --translate-x: -193px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--192, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--192 {
            --translate-x: -192px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--191, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--191 {
            --translate-x: -191px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--190, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--190 {
            --translate-x: -190px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--189, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--189 {
            --translate-x: -189px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--188, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--188 {
            --translate-x: -188px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--187, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--187 {
            --translate-x: -187px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--186, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--186 {
            --translate-x: -186px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--185, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--185 {
            --translate-x: -185px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--184, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--184 {
            --translate-x: -184px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--183, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--183 {
            --translate-x: -183px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--182, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--182 {
            --translate-x: -182px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--181, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--181 {
            --translate-x: -181px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--180, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--180 {
            --translate-x: -180px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--179, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--179 {
            --translate-x: -179px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--178, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--178 {
            --translate-x: -178px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--177, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--177 {
            --translate-x: -177px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--176, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--176 {
            --translate-x: -176px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--175, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--175 {
            --translate-x: -175px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--174, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--174 {
            --translate-x: -174px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--173, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--173 {
            --translate-x: -173px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--172, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--172 {
            --translate-x: -172px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--171, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--171 {
            --translate-x: -171px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--170, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--170 {
            --translate-x: -170px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--169, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--169 {
            --translate-x: -169px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--168, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--168 {
            --translate-x: -168px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--167, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--167 {
            --translate-x: -167px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--166, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--166 {
            --translate-x: -166px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--165, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--165 {
            --translate-x: -165px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--164, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--164 {
            --translate-x: -164px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--163, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--163 {
            --translate-x: -163px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--162, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--162 {
            --translate-x: -162px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--161, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--161 {
            --translate-x: -161px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--160, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--160 {
            --translate-x: -160px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--159, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--159 {
            --translate-x: -159px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--158, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--158 {
            --translate-x: -158px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--157, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--157 {
            --translate-x: -157px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--156, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--156 {
            --translate-x: -156px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--155, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--155 {
            --translate-x: -155px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--154, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--154 {
            --translate-x: -154px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--153, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--153 {
            --translate-x: -153px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--152, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--152 {
            --translate-x: -152px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--151, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--151 {
            --translate-x: -151px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--150, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--150 {
            --translate-x: -150px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--149, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--149 {
            --translate-x: -149px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--148, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--148 {
            --translate-x: -148px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--147, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--147 {
            --translate-x: -147px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--146, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--146 {
            --translate-x: -146px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--145, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--145 {
            --translate-x: -145px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--144, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--144 {
            --translate-x: -144px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--143, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--143 {
            --translate-x: -143px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--142, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--142 {
            --translate-x: -142px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--141, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--141 {
            --translate-x: -141px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--140, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--140 {
            --translate-x: -140px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--139, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--139 {
            --translate-x: -139px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--138, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--138 {
            --translate-x: -138px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--137, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--137 {
            --translate-x: -137px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--136, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--136 {
            --translate-x: -136px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--135, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--135 {
            --translate-x: -135px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--134, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--134 {
            --translate-x: -134px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--133, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--133 {
            --translate-x: -133px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--132, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--132 {
            --translate-x: -132px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--131, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--131 {
            --translate-x: -131px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--130, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--130 {
            --translate-x: -130px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--129, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--129 {
            --translate-x: -129px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--128, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--128 {
            --translate-x: -128px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--127, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--127 {
            --translate-x: -127px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--126, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--126 {
            --translate-x: -126px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--125, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--125 {
            --translate-x: -125px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--124, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--124 {
            --translate-x: -124px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--123, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--123 {
            --translate-x: -123px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--122, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--122 {
            --translate-x: -122px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--121, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--121 {
            --translate-x: -121px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--120, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--120 {
            --translate-x: -120px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--119, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--119 {
            --translate-x: -119px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--118, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--118 {
            --translate-x: -118px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--117, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--117 {
            --translate-x: -117px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--116, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--116 {
            --translate-x: -116px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--115, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--115 {
            --translate-x: -115px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--114, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--114 {
            --translate-x: -114px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--113, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--113 {
            --translate-x: -113px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--112, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--112 {
            --translate-x: -112px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--111, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--111 {
            --translate-x: -111px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--110, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--110 {
            --translate-x: -110px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--109, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--109 {
            --translate-x: -109px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--108, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--108 {
            --translate-x: -108px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--107, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--107 {
            --translate-x: -107px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--106, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--106 {
            --translate-x: -106px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--105, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--105 {
            --translate-x: -105px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--104, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--104 {
            --translate-x: -104px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--103, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--103 {
            --translate-x: -103px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--102, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--102 {
            --translate-x: -102px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--101, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--101 {
            --translate-x: -101px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--100, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--100 {
            --translate-x: -100px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--99, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--99 {
            --translate-x: -99px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--98, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--98 {
            --translate-x: -98px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--97, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--97 {
            --translate-x: -97px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--96, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--96 {
            --translate-x: -96px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--95, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--95 {
            --translate-x: -95px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--94, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--94 {
            --translate-x: -94px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--93, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--93 {
            --translate-x: -93px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--92, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--92 {
            --translate-x: -92px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--91, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--91 {
            --translate-x: -91px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--90, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--90 {
            --translate-x: -90px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--89, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--89 {
            --translate-x: -89px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--88, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--88 {
            --translate-x: -88px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--87, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--87 {
            --translate-x: -87px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--86, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--86 {
            --translate-x: -86px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--85, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--85 {
            --translate-x: -85px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--84, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--84 {
            --translate-x: -84px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--83, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--83 {
            --translate-x: -83px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--82, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--82 {
            --translate-x: -82px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--81, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--81 {
            --translate-x: -81px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--80, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--80 {
            --translate-x: -80px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--79, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--79 {
            --translate-x: -79px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--78, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--78 {
            --translate-x: -78px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--77, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--77 {
            --translate-x: -77px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--76, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--76 {
            --translate-x: -76px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--75, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--75 {
            --translate-x: -75px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--74, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--74 {
            --translate-x: -74px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--73, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--73 {
            --translate-x: -73px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--72, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--72 {
            --translate-x: -72px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--71, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--71 {
            --translate-x: -71px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--70, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--70 {
            --translate-x: -70px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--69, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--69 {
            --translate-x: -69px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--68, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--68 {
            --translate-x: -68px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--67, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--67 {
            --translate-x: -67px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--66, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--66 {
            --translate-x: -66px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--65, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--65 {
            --translate-x: -65px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--64, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--64 {
            --translate-x: -64px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--63, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--63 {
            --translate-x: -63px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--62, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--62 {
            --translate-x: -62px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--61, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--61 {
            --translate-x: -61px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--60, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--60 {
            --translate-x: -60px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--59, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--59 {
            --translate-x: -59px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--58, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--58 {
            --translate-x: -58px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--57, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--57 {
            --translate-x: -57px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--56, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--56 {
            --translate-x: -56px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--55, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--55 {
            --translate-x: -55px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--54, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--54 {
            --translate-x: -54px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--53, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--53 {
            --translate-x: -53px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--52, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--52 {
            --translate-x: -52px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--51, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--51 {
            --translate-x: -51px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--50, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--50 {
            --translate-x: -50px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--49, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--49 {
            --translate-x: -49px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--48, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--48 {
            --translate-x: -48px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--47, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--47 {
            --translate-x: -47px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--46, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--46 {
            --translate-x: -46px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--45, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--45 {
            --translate-x: -45px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--44, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--44 {
            --translate-x: -44px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--43, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--43 {
            --translate-x: -43px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--42, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--42 {
            --translate-x: -42px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--41, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--41 {
            --translate-x: -41px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--40, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--40 {
            --translate-x: -40px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--39, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--39 {
            --translate-x: -39px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--38, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--38 {
            --translate-x: -38px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--37, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--37 {
            --translate-x: -37px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--36, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--36 {
            --translate-x: -36px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--35, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--35 {
            --translate-x: -35px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--34, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--34 {
            --translate-x: -34px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--33, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--33 {
            --translate-x: -33px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--32, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--32 {
            --translate-x: -32px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--31, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--31 {
            --translate-x: -31px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--30, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--30 {
            --translate-x: -30px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--29, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--29 {
            --translate-x: -29px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--28, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--28 {
            --translate-x: -28px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--27, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--27 {
            --translate-x: -27px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--26, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--26 {
            --translate-x: -26px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--25, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--25 {
            --translate-x: -25px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--24, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--24 {
            --translate-x: -24px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--23, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--23 {
            --translate-x: -23px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--22, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--22 {
            --translate-x: -22px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--21, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--21 {
            --translate-x: -21px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--20, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--20 {
            --translate-x: -20px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--19, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--19 {
            --translate-x: -19px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--18, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--18 {
            --translate-x: -18px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--17, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--17 {
            --translate-x: -17px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--16, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--16 {
            --translate-x: -16px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--15, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--15 {
            --translate-x: -15px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--14, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--14 {
            --translate-x: -14px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--13, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--13 {
            --translate-x: -13px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--12, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--12 {
            --translate-x: -12px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--11, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--11 {
            --translate-x: -11px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--10, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--10 {
            --translate-x: -10px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--9, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--9 {
            --translate-x: -9px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--8, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--8 {
            --translate-x: -8px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--7, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--7 {
            --translate-x: -7px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--6, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--6 {
            --translate-x: -6px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--5, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--5 {
            --translate-x: -5px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--4, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--4 {
            --translate-x: -4px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--3, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--3 {
            --translate-x: -3px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--2, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--2 {
            --translate-x: -2px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x--1, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x--1 {
            --translate-x: -1px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-0, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-0 {
            --translate-x: 0px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-1, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-1 {
            --translate-x: 1px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-2, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-2 {
            --translate-x: 2px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-3, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-3 {
            --translate-x: 3px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-4, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-4 {
            --translate-x: 4px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-5, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-5 {
            --translate-x: 5px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-6, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-6 {
            --translate-x: 6px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-7, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-7 {
            --translate-x: 7px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-8, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-8 {
            --translate-x: 8px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-9, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-9 {
            --translate-x: 9px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-10, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-10 {
            --translate-x: 10px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-11, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-11 {
            --translate-x: 11px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-12, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-12 {
            --translate-x: 12px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-13, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-13 {
            --translate-x: 13px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-14, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-14 {
            --translate-x: 14px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-15, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-15 {
            --translate-x: 15px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-16, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-16 {
            --translate-x: 16px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-17, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-17 {
            --translate-x: 17px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-18, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-18 {
            --translate-x: 18px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-19, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-19 {
            --translate-x: 19px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-20, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-20 {
            --translate-x: 20px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-21, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-21 {
            --translate-x: 21px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-22, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-22 {
            --translate-x: 22px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-23, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-23 {
            --translate-x: 23px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-24, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-24 {
            --translate-x: 24px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-25, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-25 {
            --translate-x: 25px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-26, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-26 {
            --translate-x: 26px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-27, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-27 {
            --translate-x: 27px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-28, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-28 {
            --translate-x: 28px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-29, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-29 {
            --translate-x: 29px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-30, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-30 {
            --translate-x: 30px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-31, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-31 {
            --translate-x: 31px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-32, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-32 {
            --translate-x: 32px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-33, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-33 {
            --translate-x: 33px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-34, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-34 {
            --translate-x: 34px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-35, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-35 {
            --translate-x: 35px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-36, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-36 {
            --translate-x: 36px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-37, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-37 {
            --translate-x: 37px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-38, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-38 {
            --translate-x: 38px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-39, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-39 {
            --translate-x: 39px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-40, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-40 {
            --translate-x: 40px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-41, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-41 {
            --translate-x: 41px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-42, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-42 {
            --translate-x: 42px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-43, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-43 {
            --translate-x: 43px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-44, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-44 {
            --translate-x: 44px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-45, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-45 {
            --translate-x: 45px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-46, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-46 {
            --translate-x: 46px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-47, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-47 {
            --translate-x: 47px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-48, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-48 {
            --translate-x: 48px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-49, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-49 {
            --translate-x: 49px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-x-50, .management-container.create-event-template .discord .discord-banner .image-preview.translate-x-50 {
            --translate-x: 50px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--800, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--800 {
            --translate-y: -800px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--799, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--799 {
            --translate-y: -799px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--798, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--798 {
            --translate-y: -798px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--797, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--797 {
            --translate-y: -797px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--796, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--796 {
            --translate-y: -796px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--795, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--795 {
            --translate-y: -795px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--794, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--794 {
            --translate-y: -794px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--793, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--793 {
            --translate-y: -793px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--792, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--792 {
            --translate-y: -792px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--791, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--791 {
            --translate-y: -791px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--790, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--790 {
            --translate-y: -790px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--789, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--789 {
            --translate-y: -789px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--788, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--788 {
            --translate-y: -788px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--787, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--787 {
            --translate-y: -787px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--786, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--786 {
            --translate-y: -786px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--785, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--785 {
            --translate-y: -785px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--784, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--784 {
            --translate-y: -784px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--783, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--783 {
            --translate-y: -783px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--782, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--782 {
            --translate-y: -782px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--781, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--781 {
            --translate-y: -781px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--780, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--780 {
            --translate-y: -780px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--779, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--779 {
            --translate-y: -779px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--778, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--778 {
            --translate-y: -778px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--777, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--777 {
            --translate-y: -777px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--776, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--776 {
            --translate-y: -776px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--775, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--775 {
            --translate-y: -775px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--774, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--774 {
            --translate-y: -774px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--773, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--773 {
            --translate-y: -773px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--772, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--772 {
            --translate-y: -772px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--771, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--771 {
            --translate-y: -771px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--770, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--770 {
            --translate-y: -770px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--769, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--769 {
            --translate-y: -769px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--768, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--768 {
            --translate-y: -768px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--767, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--767 {
            --translate-y: -767px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--766, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--766 {
            --translate-y: -766px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--765, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--765 {
            --translate-y: -765px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--764, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--764 {
            --translate-y: -764px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--763, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--763 {
            --translate-y: -763px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--762, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--762 {
            --translate-y: -762px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--761, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--761 {
            --translate-y: -761px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--760, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--760 {
            --translate-y: -760px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--759, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--759 {
            --translate-y: -759px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--758, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--758 {
            --translate-y: -758px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--757, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--757 {
            --translate-y: -757px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--756, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--756 {
            --translate-y: -756px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--755, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--755 {
            --translate-y: -755px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--754, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--754 {
            --translate-y: -754px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--753, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--753 {
            --translate-y: -753px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--752, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--752 {
            --translate-y: -752px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--751, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--751 {
            --translate-y: -751px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--750, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--750 {
            --translate-y: -750px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--749, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--749 {
            --translate-y: -749px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--748, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--748 {
            --translate-y: -748px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--747, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--747 {
            --translate-y: -747px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--746, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--746 {
            --translate-y: -746px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--745, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--745 {
            --translate-y: -745px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--744, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--744 {
            --translate-y: -744px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--743, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--743 {
            --translate-y: -743px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--742, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--742 {
            --translate-y: -742px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--741, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--741 {
            --translate-y: -741px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--740, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--740 {
            --translate-y: -740px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--739, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--739 {
            --translate-y: -739px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--738, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--738 {
            --translate-y: -738px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--737, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--737 {
            --translate-y: -737px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--736, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--736 {
            --translate-y: -736px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--735, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--735 {
            --translate-y: -735px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--734, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--734 {
            --translate-y: -734px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--733, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--733 {
            --translate-y: -733px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--732, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--732 {
            --translate-y: -732px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--731, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--731 {
            --translate-y: -731px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--730, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--730 {
            --translate-y: -730px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--729, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--729 {
            --translate-y: -729px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--728, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--728 {
            --translate-y: -728px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--727, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--727 {
            --translate-y: -727px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--726, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--726 {
            --translate-y: -726px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--725, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--725 {
            --translate-y: -725px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--724, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--724 {
            --translate-y: -724px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--723, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--723 {
            --translate-y: -723px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--722, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--722 {
            --translate-y: -722px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--721, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--721 {
            --translate-y: -721px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--720, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--720 {
            --translate-y: -720px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--719, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--719 {
            --translate-y: -719px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--718, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--718 {
            --translate-y: -718px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--717, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--717 {
            --translate-y: -717px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--716, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--716 {
            --translate-y: -716px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--715, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--715 {
            --translate-y: -715px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--714, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--714 {
            --translate-y: -714px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--713, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--713 {
            --translate-y: -713px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--712, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--712 {
            --translate-y: -712px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--711, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--711 {
            --translate-y: -711px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--710, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--710 {
            --translate-y: -710px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--709, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--709 {
            --translate-y: -709px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--708, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--708 {
            --translate-y: -708px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--707, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--707 {
            --translate-y: -707px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--706, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--706 {
            --translate-y: -706px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--705, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--705 {
            --translate-y: -705px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--704, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--704 {
            --translate-y: -704px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--703, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--703 {
            --translate-y: -703px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--702, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--702 {
            --translate-y: -702px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--701, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--701 {
            --translate-y: -701px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--700, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--700 {
            --translate-y: -700px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--699, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--699 {
            --translate-y: -699px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--698, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--698 {
            --translate-y: -698px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--697, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--697 {
            --translate-y: -697px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--696, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--696 {
            --translate-y: -696px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--695, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--695 {
            --translate-y: -695px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--694, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--694 {
            --translate-y: -694px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--693, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--693 {
            --translate-y: -693px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--692, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--692 {
            --translate-y: -692px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--691, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--691 {
            --translate-y: -691px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--690, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--690 {
            --translate-y: -690px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--689, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--689 {
            --translate-y: -689px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--688, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--688 {
            --translate-y: -688px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--687, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--687 {
            --translate-y: -687px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--686, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--686 {
            --translate-y: -686px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--685, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--685 {
            --translate-y: -685px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--684, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--684 {
            --translate-y: -684px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--683, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--683 {
            --translate-y: -683px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--682, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--682 {
            --translate-y: -682px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--681, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--681 {
            --translate-y: -681px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--680, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--680 {
            --translate-y: -680px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--679, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--679 {
            --translate-y: -679px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--678, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--678 {
            --translate-y: -678px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--677, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--677 {
            --translate-y: -677px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--676, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--676 {
            --translate-y: -676px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--675, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--675 {
            --translate-y: -675px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--674, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--674 {
            --translate-y: -674px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--673, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--673 {
            --translate-y: -673px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--672, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--672 {
            --translate-y: -672px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--671, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--671 {
            --translate-y: -671px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--670, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--670 {
            --translate-y: -670px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--669, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--669 {
            --translate-y: -669px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--668, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--668 {
            --translate-y: -668px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--667, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--667 {
            --translate-y: -667px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--666, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--666 {
            --translate-y: -666px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--665, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--665 {
            --translate-y: -665px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--664, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--664 {
            --translate-y: -664px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--663, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--663 {
            --translate-y: -663px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--662, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--662 {
            --translate-y: -662px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--661, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--661 {
            --translate-y: -661px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--660, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--660 {
            --translate-y: -660px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--659, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--659 {
            --translate-y: -659px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--658, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--658 {
            --translate-y: -658px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--657, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--657 {
            --translate-y: -657px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--656, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--656 {
            --translate-y: -656px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--655, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--655 {
            --translate-y: -655px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--654, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--654 {
            --translate-y: -654px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--653, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--653 {
            --translate-y: -653px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--652, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--652 {
            --translate-y: -652px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--651, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--651 {
            --translate-y: -651px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--650, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--650 {
            --translate-y: -650px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--649, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--649 {
            --translate-y: -649px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--648, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--648 {
            --translate-y: -648px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--647, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--647 {
            --translate-y: -647px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--646, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--646 {
            --translate-y: -646px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--645, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--645 {
            --translate-y: -645px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--644, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--644 {
            --translate-y: -644px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--643, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--643 {
            --translate-y: -643px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--642, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--642 {
            --translate-y: -642px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--641, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--641 {
            --translate-y: -641px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--640, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--640 {
            --translate-y: -640px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--639, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--639 {
            --translate-y: -639px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--638, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--638 {
            --translate-y: -638px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--637, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--637 {
            --translate-y: -637px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--636, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--636 {
            --translate-y: -636px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--635, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--635 {
            --translate-y: -635px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--634, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--634 {
            --translate-y: -634px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--633, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--633 {
            --translate-y: -633px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--632, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--632 {
            --translate-y: -632px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--631, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--631 {
            --translate-y: -631px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--630, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--630 {
            --translate-y: -630px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--629, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--629 {
            --translate-y: -629px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--628, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--628 {
            --translate-y: -628px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--627, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--627 {
            --translate-y: -627px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--626, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--626 {
            --translate-y: -626px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--625, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--625 {
            --translate-y: -625px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--624, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--624 {
            --translate-y: -624px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--623, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--623 {
            --translate-y: -623px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--622, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--622 {
            --translate-y: -622px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--621, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--621 {
            --translate-y: -621px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--620, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--620 {
            --translate-y: -620px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--619, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--619 {
            --translate-y: -619px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--618, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--618 {
            --translate-y: -618px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--617, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--617 {
            --translate-y: -617px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--616, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--616 {
            --translate-y: -616px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--615, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--615 {
            --translate-y: -615px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--614, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--614 {
            --translate-y: -614px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--613, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--613 {
            --translate-y: -613px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--612, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--612 {
            --translate-y: -612px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--611, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--611 {
            --translate-y: -611px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--610, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--610 {
            --translate-y: -610px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--609, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--609 {
            --translate-y: -609px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--608, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--608 {
            --translate-y: -608px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--607, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--607 {
            --translate-y: -607px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--606, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--606 {
            --translate-y: -606px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--605, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--605 {
            --translate-y: -605px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--604, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--604 {
            --translate-y: -604px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--603, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--603 {
            --translate-y: -603px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--602, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--602 {
            --translate-y: -602px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--601, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--601 {
            --translate-y: -601px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--600, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--600 {
            --translate-y: -600px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--599, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--599 {
            --translate-y: -599px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--598, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--598 {
            --translate-y: -598px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--597, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--597 {
            --translate-y: -597px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--596, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--596 {
            --translate-y: -596px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--595, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--595 {
            --translate-y: -595px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--594, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--594 {
            --translate-y: -594px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--593, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--593 {
            --translate-y: -593px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--592, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--592 {
            --translate-y: -592px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--591, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--591 {
            --translate-y: -591px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--590, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--590 {
            --translate-y: -590px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--589, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--589 {
            --translate-y: -589px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--588, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--588 {
            --translate-y: -588px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--587, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--587 {
            --translate-y: -587px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--586, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--586 {
            --translate-y: -586px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--585, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--585 {
            --translate-y: -585px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--584, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--584 {
            --translate-y: -584px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--583, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--583 {
            --translate-y: -583px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--582, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--582 {
            --translate-y: -582px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--581, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--581 {
            --translate-y: -581px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--580, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--580 {
            --translate-y: -580px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--579, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--579 {
            --translate-y: -579px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--578, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--578 {
            --translate-y: -578px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--577, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--577 {
            --translate-y: -577px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--576, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--576 {
            --translate-y: -576px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--575, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--575 {
            --translate-y: -575px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--574, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--574 {
            --translate-y: -574px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--573, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--573 {
            --translate-y: -573px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--572, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--572 {
            --translate-y: -572px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--571, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--571 {
            --translate-y: -571px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--570, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--570 {
            --translate-y: -570px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--569, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--569 {
            --translate-y: -569px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--568, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--568 {
            --translate-y: -568px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--567, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--567 {
            --translate-y: -567px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--566, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--566 {
            --translate-y: -566px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--565, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--565 {
            --translate-y: -565px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--564, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--564 {
            --translate-y: -564px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--563, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--563 {
            --translate-y: -563px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--562, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--562 {
            --translate-y: -562px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--561, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--561 {
            --translate-y: -561px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--560, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--560 {
            --translate-y: -560px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--559, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--559 {
            --translate-y: -559px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--558, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--558 {
            --translate-y: -558px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--557, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--557 {
            --translate-y: -557px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--556, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--556 {
            --translate-y: -556px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--555, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--555 {
            --translate-y: -555px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--554, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--554 {
            --translate-y: -554px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--553, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--553 {
            --translate-y: -553px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--552, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--552 {
            --translate-y: -552px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--551, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--551 {
            --translate-y: -551px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--550, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--550 {
            --translate-y: -550px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--549, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--549 {
            --translate-y: -549px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--548, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--548 {
            --translate-y: -548px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--547, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--547 {
            --translate-y: -547px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--546, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--546 {
            --translate-y: -546px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--545, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--545 {
            --translate-y: -545px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--544, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--544 {
            --translate-y: -544px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--543, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--543 {
            --translate-y: -543px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--542, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--542 {
            --translate-y: -542px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--541, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--541 {
            --translate-y: -541px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--540, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--540 {
            --translate-y: -540px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--539, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--539 {
            --translate-y: -539px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--538, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--538 {
            --translate-y: -538px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--537, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--537 {
            --translate-y: -537px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--536, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--536 {
            --translate-y: -536px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--535, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--535 {
            --translate-y: -535px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--534, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--534 {
            --translate-y: -534px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--533, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--533 {
            --translate-y: -533px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--532, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--532 {
            --translate-y: -532px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--531, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--531 {
            --translate-y: -531px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--530, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--530 {
            --translate-y: -530px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--529, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--529 {
            --translate-y: -529px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--528, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--528 {
            --translate-y: -528px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--527, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--527 {
            --translate-y: -527px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--526, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--526 {
            --translate-y: -526px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--525, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--525 {
            --translate-y: -525px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--524, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--524 {
            --translate-y: -524px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--523, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--523 {
            --translate-y: -523px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--522, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--522 {
            --translate-y: -522px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--521, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--521 {
            --translate-y: -521px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--520, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--520 {
            --translate-y: -520px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--519, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--519 {
            --translate-y: -519px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--518, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--518 {
            --translate-y: -518px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--517, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--517 {
            --translate-y: -517px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--516, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--516 {
            --translate-y: -516px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--515, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--515 {
            --translate-y: -515px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--514, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--514 {
            --translate-y: -514px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--513, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--513 {
            --translate-y: -513px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--512, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--512 {
            --translate-y: -512px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--511, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--511 {
            --translate-y: -511px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--510, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--510 {
            --translate-y: -510px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--509, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--509 {
            --translate-y: -509px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--508, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--508 {
            --translate-y: -508px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--507, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--507 {
            --translate-y: -507px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--506, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--506 {
            --translate-y: -506px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--505, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--505 {
            --translate-y: -505px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--504, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--504 {
            --translate-y: -504px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--503, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--503 {
            --translate-y: -503px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--502, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--502 {
            --translate-y: -502px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--501, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--501 {
            --translate-y: -501px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--500, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--500 {
            --translate-y: -500px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--499, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--499 {
            --translate-y: -499px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--498, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--498 {
            --translate-y: -498px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--497, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--497 {
            --translate-y: -497px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--496, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--496 {
            --translate-y: -496px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--495, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--495 {
            --translate-y: -495px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--494, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--494 {
            --translate-y: -494px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--493, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--493 {
            --translate-y: -493px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--492, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--492 {
            --translate-y: -492px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--491, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--491 {
            --translate-y: -491px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--490, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--490 {
            --translate-y: -490px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--489, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--489 {
            --translate-y: -489px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--488, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--488 {
            --translate-y: -488px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--487, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--487 {
            --translate-y: -487px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--486, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--486 {
            --translate-y: -486px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--485, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--485 {
            --translate-y: -485px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--484, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--484 {
            --translate-y: -484px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--483, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--483 {
            --translate-y: -483px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--482, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--482 {
            --translate-y: -482px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--481, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--481 {
            --translate-y: -481px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--480, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--480 {
            --translate-y: -480px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--479, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--479 {
            --translate-y: -479px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--478, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--478 {
            --translate-y: -478px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--477, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--477 {
            --translate-y: -477px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--476, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--476 {
            --translate-y: -476px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--475, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--475 {
            --translate-y: -475px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--474, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--474 {
            --translate-y: -474px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--473, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--473 {
            --translate-y: -473px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--472, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--472 {
            --translate-y: -472px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--471, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--471 {
            --translate-y: -471px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--470, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--470 {
            --translate-y: -470px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--469, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--469 {
            --translate-y: -469px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--468, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--468 {
            --translate-y: -468px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--467, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--467 {
            --translate-y: -467px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--466, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--466 {
            --translate-y: -466px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--465, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--465 {
            --translate-y: -465px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--464, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--464 {
            --translate-y: -464px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--463, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--463 {
            --translate-y: -463px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--462, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--462 {
            --translate-y: -462px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--461, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--461 {
            --translate-y: -461px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--460, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--460 {
            --translate-y: -460px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--459, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--459 {
            --translate-y: -459px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--458, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--458 {
            --translate-y: -458px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--457, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--457 {
            --translate-y: -457px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--456, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--456 {
            --translate-y: -456px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--455, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--455 {
            --translate-y: -455px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--454, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--454 {
            --translate-y: -454px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--453, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--453 {
            --translate-y: -453px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--452, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--452 {
            --translate-y: -452px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--451, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--451 {
            --translate-y: -451px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--450, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--450 {
            --translate-y: -450px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--449, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--449 {
            --translate-y: -449px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--448, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--448 {
            --translate-y: -448px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--447, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--447 {
            --translate-y: -447px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--446, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--446 {
            --translate-y: -446px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--445, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--445 {
            --translate-y: -445px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--444, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--444 {
            --translate-y: -444px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--443, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--443 {
            --translate-y: -443px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--442, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--442 {
            --translate-y: -442px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--441, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--441 {
            --translate-y: -441px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--440, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--440 {
            --translate-y: -440px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--439, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--439 {
            --translate-y: -439px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--438, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--438 {
            --translate-y: -438px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--437, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--437 {
            --translate-y: -437px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--436, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--436 {
            --translate-y: -436px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--435, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--435 {
            --translate-y: -435px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--434, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--434 {
            --translate-y: -434px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--433, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--433 {
            --translate-y: -433px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--432, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--432 {
            --translate-y: -432px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--431, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--431 {
            --translate-y: -431px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--430, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--430 {
            --translate-y: -430px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--429, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--429 {
            --translate-y: -429px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--428, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--428 {
            --translate-y: -428px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--427, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--427 {
            --translate-y: -427px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--426, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--426 {
            --translate-y: -426px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--425, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--425 {
            --translate-y: -425px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--424, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--424 {
            --translate-y: -424px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--423, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--423 {
            --translate-y: -423px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--422, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--422 {
            --translate-y: -422px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--421, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--421 {
            --translate-y: -421px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--420, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--420 {
            --translate-y: -420px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--419, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--419 {
            --translate-y: -419px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--418, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--418 {
            --translate-y: -418px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--417, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--417 {
            --translate-y: -417px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--416, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--416 {
            --translate-y: -416px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--415, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--415 {
            --translate-y: -415px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--414, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--414 {
            --translate-y: -414px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--413, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--413 {
            --translate-y: -413px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--412, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--412 {
            --translate-y: -412px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--411, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--411 {
            --translate-y: -411px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--410, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--410 {
            --translate-y: -410px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--409, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--409 {
            --translate-y: -409px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--408, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--408 {
            --translate-y: -408px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--407, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--407 {
            --translate-y: -407px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--406, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--406 {
            --translate-y: -406px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--405, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--405 {
            --translate-y: -405px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--404, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--404 {
            --translate-y: -404px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--403, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--403 {
            --translate-y: -403px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--402, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--402 {
            --translate-y: -402px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--401, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--401 {
            --translate-y: -401px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--400, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--400 {
            --translate-y: -400px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--399, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--399 {
            --translate-y: -399px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--398, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--398 {
            --translate-y: -398px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--397, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--397 {
            --translate-y: -397px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--396, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--396 {
            --translate-y: -396px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--395, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--395 {
            --translate-y: -395px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--394, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--394 {
            --translate-y: -394px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--393, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--393 {
            --translate-y: -393px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--392, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--392 {
            --translate-y: -392px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--391, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--391 {
            --translate-y: -391px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--390, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--390 {
            --translate-y: -390px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--389, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--389 {
            --translate-y: -389px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--388, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--388 {
            --translate-y: -388px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--387, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--387 {
            --translate-y: -387px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--386, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--386 {
            --translate-y: -386px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--385, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--385 {
            --translate-y: -385px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--384, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--384 {
            --translate-y: -384px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--383, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--383 {
            --translate-y: -383px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--382, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--382 {
            --translate-y: -382px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--381, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--381 {
            --translate-y: -381px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--380, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--380 {
            --translate-y: -380px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--379, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--379 {
            --translate-y: -379px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--378, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--378 {
            --translate-y: -378px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--377, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--377 {
            --translate-y: -377px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--376, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--376 {
            --translate-y: -376px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--375, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--375 {
            --translate-y: -375px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--374, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--374 {
            --translate-y: -374px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--373, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--373 {
            --translate-y: -373px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--372, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--372 {
            --translate-y: -372px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--371, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--371 {
            --translate-y: -371px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--370, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--370 {
            --translate-y: -370px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--369, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--369 {
            --translate-y: -369px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--368, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--368 {
            --translate-y: -368px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--367, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--367 {
            --translate-y: -367px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--366, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--366 {
            --translate-y: -366px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--365, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--365 {
            --translate-y: -365px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--364, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--364 {
            --translate-y: -364px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--363, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--363 {
            --translate-y: -363px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--362, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--362 {
            --translate-y: -362px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--361, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--361 {
            --translate-y: -361px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--360, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--360 {
            --translate-y: -360px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--359, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--359 {
            --translate-y: -359px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--358, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--358 {
            --translate-y: -358px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--357, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--357 {
            --translate-y: -357px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--356, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--356 {
            --translate-y: -356px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--355, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--355 {
            --translate-y: -355px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--354, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--354 {
            --translate-y: -354px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--353, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--353 {
            --translate-y: -353px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--352, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--352 {
            --translate-y: -352px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--351, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--351 {
            --translate-y: -351px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--350, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--350 {
            --translate-y: -350px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--349, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--349 {
            --translate-y: -349px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--348, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--348 {
            --translate-y: -348px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--347, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--347 {
            --translate-y: -347px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--346, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--346 {
            --translate-y: -346px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--345, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--345 {
            --translate-y: -345px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--344, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--344 {
            --translate-y: -344px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--343, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--343 {
            --translate-y: -343px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--342, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--342 {
            --translate-y: -342px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--341, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--341 {
            --translate-y: -341px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--340, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--340 {
            --translate-y: -340px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--339, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--339 {
            --translate-y: -339px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--338, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--338 {
            --translate-y: -338px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--337, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--337 {
            --translate-y: -337px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--336, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--336 {
            --translate-y: -336px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--335, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--335 {
            --translate-y: -335px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--334, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--334 {
            --translate-y: -334px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--333, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--333 {
            --translate-y: -333px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--332, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--332 {
            --translate-y: -332px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--331, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--331 {
            --translate-y: -331px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--330, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--330 {
            --translate-y: -330px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--329, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--329 {
            --translate-y: -329px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--328, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--328 {
            --translate-y: -328px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--327, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--327 {
            --translate-y: -327px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--326, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--326 {
            --translate-y: -326px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--325, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--325 {
            --translate-y: -325px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--324, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--324 {
            --translate-y: -324px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--323, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--323 {
            --translate-y: -323px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--322, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--322 {
            --translate-y: -322px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--321, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--321 {
            --translate-y: -321px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--320, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--320 {
            --translate-y: -320px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--319, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--319 {
            --translate-y: -319px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--318, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--318 {
            --translate-y: -318px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--317, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--317 {
            --translate-y: -317px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--316, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--316 {
            --translate-y: -316px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--315, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--315 {
            --translate-y: -315px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--314, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--314 {
            --translate-y: -314px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--313, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--313 {
            --translate-y: -313px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--312, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--312 {
            --translate-y: -312px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--311, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--311 {
            --translate-y: -311px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--310, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--310 {
            --translate-y: -310px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--309, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--309 {
            --translate-y: -309px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--308, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--308 {
            --translate-y: -308px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--307, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--307 {
            --translate-y: -307px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--306, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--306 {
            --translate-y: -306px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--305, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--305 {
            --translate-y: -305px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--304, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--304 {
            --translate-y: -304px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--303, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--303 {
            --translate-y: -303px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--302, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--302 {
            --translate-y: -302px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--301, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--301 {
            --translate-y: -301px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--300, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--300 {
            --translate-y: -300px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--299, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--299 {
            --translate-y: -299px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--298, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--298 {
            --translate-y: -298px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--297, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--297 {
            --translate-y: -297px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--296, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--296 {
            --translate-y: -296px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--295, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--295 {
            --translate-y: -295px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--294, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--294 {
            --translate-y: -294px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--293, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--293 {
            --translate-y: -293px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--292, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--292 {
            --translate-y: -292px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--291, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--291 {
            --translate-y: -291px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--290, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--290 {
            --translate-y: -290px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--289, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--289 {
            --translate-y: -289px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--288, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--288 {
            --translate-y: -288px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--287, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--287 {
            --translate-y: -287px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--286, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--286 {
            --translate-y: -286px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--285, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--285 {
            --translate-y: -285px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--284, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--284 {
            --translate-y: -284px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--283, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--283 {
            --translate-y: -283px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--282, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--282 {
            --translate-y: -282px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--281, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--281 {
            --translate-y: -281px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--280, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--280 {
            --translate-y: -280px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--279, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--279 {
            --translate-y: -279px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--278, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--278 {
            --translate-y: -278px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--277, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--277 {
            --translate-y: -277px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--276, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--276 {
            --translate-y: -276px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--275, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--275 {
            --translate-y: -275px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--274, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--274 {
            --translate-y: -274px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--273, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--273 {
            --translate-y: -273px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--272, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--272 {
            --translate-y: -272px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--271, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--271 {
            --translate-y: -271px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--270, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--270 {
            --translate-y: -270px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--269, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--269 {
            --translate-y: -269px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--268, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--268 {
            --translate-y: -268px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--267, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--267 {
            --translate-y: -267px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--266, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--266 {
            --translate-y: -266px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--265, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--265 {
            --translate-y: -265px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--264, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--264 {
            --translate-y: -264px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--263, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--263 {
            --translate-y: -263px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--262, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--262 {
            --translate-y: -262px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--261, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--261 {
            --translate-y: -261px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--260, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--260 {
            --translate-y: -260px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--259, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--259 {
            --translate-y: -259px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--258, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--258 {
            --translate-y: -258px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--257, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--257 {
            --translate-y: -257px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--256, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--256 {
            --translate-y: -256px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--255, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--255 {
            --translate-y: -255px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--254, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--254 {
            --translate-y: -254px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--253, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--253 {
            --translate-y: -253px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--252, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--252 {
            --translate-y: -252px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--251, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--251 {
            --translate-y: -251px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--250, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--250 {
            --translate-y: -250px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--249, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--249 {
            --translate-y: -249px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--248, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--248 {
            --translate-y: -248px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--247, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--247 {
            --translate-y: -247px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--246, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--246 {
            --translate-y: -246px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--245, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--245 {
            --translate-y: -245px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--244, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--244 {
            --translate-y: -244px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--243, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--243 {
            --translate-y: -243px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--242, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--242 {
            --translate-y: -242px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--241, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--241 {
            --translate-y: -241px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--240, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--240 {
            --translate-y: -240px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--239, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--239 {
            --translate-y: -239px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--238, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--238 {
            --translate-y: -238px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--237, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--237 {
            --translate-y: -237px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--236, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--236 {
            --translate-y: -236px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--235, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--235 {
            --translate-y: -235px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--234, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--234 {
            --translate-y: -234px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--233, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--233 {
            --translate-y: -233px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--232, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--232 {
            --translate-y: -232px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--231, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--231 {
            --translate-y: -231px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--230, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--230 {
            --translate-y: -230px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--229, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--229 {
            --translate-y: -229px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--228, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--228 {
            --translate-y: -228px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--227, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--227 {
            --translate-y: -227px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--226, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--226 {
            --translate-y: -226px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--225, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--225 {
            --translate-y: -225px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--224, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--224 {
            --translate-y: -224px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--223, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--223 {
            --translate-y: -223px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--222, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--222 {
            --translate-y: -222px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--221, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--221 {
            --translate-y: -221px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--220, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--220 {
            --translate-y: -220px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--219, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--219 {
            --translate-y: -219px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--218, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--218 {
            --translate-y: -218px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--217, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--217 {
            --translate-y: -217px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--216, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--216 {
            --translate-y: -216px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--215, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--215 {
            --translate-y: -215px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--214, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--214 {
            --translate-y: -214px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--213, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--213 {
            --translate-y: -213px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--212, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--212 {
            --translate-y: -212px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--211, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--211 {
            --translate-y: -211px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--210, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--210 {
            --translate-y: -210px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--209, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--209 {
            --translate-y: -209px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--208, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--208 {
            --translate-y: -208px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--207, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--207 {
            --translate-y: -207px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--206, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--206 {
            --translate-y: -206px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--205, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--205 {
            --translate-y: -205px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--204, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--204 {
            --translate-y: -204px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--203, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--203 {
            --translate-y: -203px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--202, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--202 {
            --translate-y: -202px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--201, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--201 {
            --translate-y: -201px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--200, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--200 {
            --translate-y: -200px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--199, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--199 {
            --translate-y: -199px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--198, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--198 {
            --translate-y: -198px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--197, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--197 {
            --translate-y: -197px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--196, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--196 {
            --translate-y: -196px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--195, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--195 {
            --translate-y: -195px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--194, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--194 {
            --translate-y: -194px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--193, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--193 {
            --translate-y: -193px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--192, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--192 {
            --translate-y: -192px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--191, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--191 {
            --translate-y: -191px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--190, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--190 {
            --translate-y: -190px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--189, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--189 {
            --translate-y: -189px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--188, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--188 {
            --translate-y: -188px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--187, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--187 {
            --translate-y: -187px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--186, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--186 {
            --translate-y: -186px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--185, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--185 {
            --translate-y: -185px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--184, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--184 {
            --translate-y: -184px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--183, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--183 {
            --translate-y: -183px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--182, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--182 {
            --translate-y: -182px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--181, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--181 {
            --translate-y: -181px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--180, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--180 {
            --translate-y: -180px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--179, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--179 {
            --translate-y: -179px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--178, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--178 {
            --translate-y: -178px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--177, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--177 {
            --translate-y: -177px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--176, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--176 {
            --translate-y: -176px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--175, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--175 {
            --translate-y: -175px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--174, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--174 {
            --translate-y: -174px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--173, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--173 {
            --translate-y: -173px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--172, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--172 {
            --translate-y: -172px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--171, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--171 {
            --translate-y: -171px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--170, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--170 {
            --translate-y: -170px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--169, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--169 {
            --translate-y: -169px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--168, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--168 {
            --translate-y: -168px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--167, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--167 {
            --translate-y: -167px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--166, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--166 {
            --translate-y: -166px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--165, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--165 {
            --translate-y: -165px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--164, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--164 {
            --translate-y: -164px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--163, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--163 {
            --translate-y: -163px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--162, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--162 {
            --translate-y: -162px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--161, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--161 {
            --translate-y: -161px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--160, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--160 {
            --translate-y: -160px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--159, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--159 {
            --translate-y: -159px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--158, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--158 {
            --translate-y: -158px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--157, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--157 {
            --translate-y: -157px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--156, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--156 {
            --translate-y: -156px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--155, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--155 {
            --translate-y: -155px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--154, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--154 {
            --translate-y: -154px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--153, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--153 {
            --translate-y: -153px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--152, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--152 {
            --translate-y: -152px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--151, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--151 {
            --translate-y: -151px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--150, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--150 {
            --translate-y: -150px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--149, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--149 {
            --translate-y: -149px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--148, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--148 {
            --translate-y: -148px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--147, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--147 {
            --translate-y: -147px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--146, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--146 {
            --translate-y: -146px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--145, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--145 {
            --translate-y: -145px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--144, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--144 {
            --translate-y: -144px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--143, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--143 {
            --translate-y: -143px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--142, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--142 {
            --translate-y: -142px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--141, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--141 {
            --translate-y: -141px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--140, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--140 {
            --translate-y: -140px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--139, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--139 {
            --translate-y: -139px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--138, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--138 {
            --translate-y: -138px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--137, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--137 {
            --translate-y: -137px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--136, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--136 {
            --translate-y: -136px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--135, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--135 {
            --translate-y: -135px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--134, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--134 {
            --translate-y: -134px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--133, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--133 {
            --translate-y: -133px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--132, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--132 {
            --translate-y: -132px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--131, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--131 {
            --translate-y: -131px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--130, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--130 {
            --translate-y: -130px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--129, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--129 {
            --translate-y: -129px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--128, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--128 {
            --translate-y: -128px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--127, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--127 {
            --translate-y: -127px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--126, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--126 {
            --translate-y: -126px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--125, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--125 {
            --translate-y: -125px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--124, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--124 {
            --translate-y: -124px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--123, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--123 {
            --translate-y: -123px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--122, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--122 {
            --translate-y: -122px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--121, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--121 {
            --translate-y: -121px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--120, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--120 {
            --translate-y: -120px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--119, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--119 {
            --translate-y: -119px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--118, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--118 {
            --translate-y: -118px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--117, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--117 {
            --translate-y: -117px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--116, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--116 {
            --translate-y: -116px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--115, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--115 {
            --translate-y: -115px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--114, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--114 {
            --translate-y: -114px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--113, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--113 {
            --translate-y: -113px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--112, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--112 {
            --translate-y: -112px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--111, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--111 {
            --translate-y: -111px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--110, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--110 {
            --translate-y: -110px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--109, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--109 {
            --translate-y: -109px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--108, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--108 {
            --translate-y: -108px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--107, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--107 {
            --translate-y: -107px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--106, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--106 {
            --translate-y: -106px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--105, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--105 {
            --translate-y: -105px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--104, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--104 {
            --translate-y: -104px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--103, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--103 {
            --translate-y: -103px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--102, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--102 {
            --translate-y: -102px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--101, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--101 {
            --translate-y: -101px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--100, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--100 {
            --translate-y: -100px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--99, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--99 {
            --translate-y: -99px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--98, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--98 {
            --translate-y: -98px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--97, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--97 {
            --translate-y: -97px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--96, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--96 {
            --translate-y: -96px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--95, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--95 {
            --translate-y: -95px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--94, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--94 {
            --translate-y: -94px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--93, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--93 {
            --translate-y: -93px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--92, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--92 {
            --translate-y: -92px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--91, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--91 {
            --translate-y: -91px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--90, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--90 {
            --translate-y: -90px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--89, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--89 {
            --translate-y: -89px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--88, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--88 {
            --translate-y: -88px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--87, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--87 {
            --translate-y: -87px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--86, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--86 {
            --translate-y: -86px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--85, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--85 {
            --translate-y: -85px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--84, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--84 {
            --translate-y: -84px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--83, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--83 {
            --translate-y: -83px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--82, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--82 {
            --translate-y: -82px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--81, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--81 {
            --translate-y: -81px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--80, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--80 {
            --translate-y: -80px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--79, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--79 {
            --translate-y: -79px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--78, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--78 {
            --translate-y: -78px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--77, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--77 {
            --translate-y: -77px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--76, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--76 {
            --translate-y: -76px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--75, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--75 {
            --translate-y: -75px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--74, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--74 {
            --translate-y: -74px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--73, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--73 {
            --translate-y: -73px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--72, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--72 {
            --translate-y: -72px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--71, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--71 {
            --translate-y: -71px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--70, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--70 {
            --translate-y: -70px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--69, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--69 {
            --translate-y: -69px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--68, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--68 {
            --translate-y: -68px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--67, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--67 {
            --translate-y: -67px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--66, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--66 {
            --translate-y: -66px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--65, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--65 {
            --translate-y: -65px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--64, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--64 {
            --translate-y: -64px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--63, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--63 {
            --translate-y: -63px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--62, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--62 {
            --translate-y: -62px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--61, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--61 {
            --translate-y: -61px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--60, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--60 {
            --translate-y: -60px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--59, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--59 {
            --translate-y: -59px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--58, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--58 {
            --translate-y: -58px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--57, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--57 {
            --translate-y: -57px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--56, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--56 {
            --translate-y: -56px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--55, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--55 {
            --translate-y: -55px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--54, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--54 {
            --translate-y: -54px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--53, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--53 {
            --translate-y: -53px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--52, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--52 {
            --translate-y: -52px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--51, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--51 {
            --translate-y: -51px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--50, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--50 {
            --translate-y: -50px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--49, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--49 {
            --translate-y: -49px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--48, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--48 {
            --translate-y: -48px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--47, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--47 {
            --translate-y: -47px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--46, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--46 {
            --translate-y: -46px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--45, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--45 {
            --translate-y: -45px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--44, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--44 {
            --translate-y: -44px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--43, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--43 {
            --translate-y: -43px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--42, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--42 {
            --translate-y: -42px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--41, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--41 {
            --translate-y: -41px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--40, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--40 {
            --translate-y: -40px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--39, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--39 {
            --translate-y: -39px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--38, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--38 {
            --translate-y: -38px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--37, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--37 {
            --translate-y: -37px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--36, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--36 {
            --translate-y: -36px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--35, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--35 {
            --translate-y: -35px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--34, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--34 {
            --translate-y: -34px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--33, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--33 {
            --translate-y: -33px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--32, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--32 {
            --translate-y: -32px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--31, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--31 {
            --translate-y: -31px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--30, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--30 {
            --translate-y: -30px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--29, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--29 {
            --translate-y: -29px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--28, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--28 {
            --translate-y: -28px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--27, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--27 {
            --translate-y: -27px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--26, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--26 {
            --translate-y: -26px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--25, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--25 {
            --translate-y: -25px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--24, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--24 {
            --translate-y: -24px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--23, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--23 {
            --translate-y: -23px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--22, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--22 {
            --translate-y: -22px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--21, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--21 {
            --translate-y: -21px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--20, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--20 {
            --translate-y: -20px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--19, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--19 {
            --translate-y: -19px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--18, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--18 {
            --translate-y: -18px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--17, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--17 {
            --translate-y: -17px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--16, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--16 {
            --translate-y: -16px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--15, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--15 {
            --translate-y: -15px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--14, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--14 {
            --translate-y: -14px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--13, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--13 {
            --translate-y: -13px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--12, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--12 {
            --translate-y: -12px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--11, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--11 {
            --translate-y: -11px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--10, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--10 {
            --translate-y: -10px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--9, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--9 {
            --translate-y: -9px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--8, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--8 {
            --translate-y: -8px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--7, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--7 {
            --translate-y: -7px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--6, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--6 {
            --translate-y: -6px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--5, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--5 {
            --translate-y: -5px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--4, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--4 {
            --translate-y: -4px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--3, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--3 {
            --translate-y: -3px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--2, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--2 {
            --translate-y: -2px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y--1, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y--1 {
            --translate-y: -1px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-0, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-0 {
            --translate-y: 0px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-1, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-1 {
            --translate-y: 1px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-2, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-2 {
            --translate-y: 2px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-3, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-3 {
            --translate-y: 3px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-4, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-4 {
            --translate-y: 4px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-5, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-5 {
            --translate-y: 5px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-6, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-6 {
            --translate-y: 6px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-7, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-7 {
            --translate-y: 7px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-8, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-8 {
            --translate-y: 8px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-9, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-9 {
            --translate-y: 9px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-10, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-10 {
            --translate-y: 10px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-11, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-11 {
            --translate-y: 11px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-12, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-12 {
            --translate-y: 12px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-13, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-13 {
            --translate-y: 13px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-14, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-14 {
            --translate-y: 14px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-15, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-15 {
            --translate-y: 15px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-16, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-16 {
            --translate-y: 16px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-17, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-17 {
            --translate-y: 17px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-18, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-18 {
            --translate-y: 18px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-19, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-19 {
            --translate-y: 19px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-20, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-20 {
            --translate-y: 20px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-21, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-21 {
            --translate-y: 21px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-22, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-22 {
            --translate-y: 22px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-23, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-23 {
            --translate-y: 23px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-24, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-24 {
            --translate-y: 24px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-25, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-25 {
            --translate-y: 25px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-26, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-26 {
            --translate-y: 26px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-27, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-27 {
            --translate-y: 27px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-28, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-28 {
            --translate-y: 28px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-29, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-29 {
            --translate-y: 29px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-30, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-30 {
            --translate-y: 30px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-31, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-31 {
            --translate-y: 31px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-32, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-32 {
            --translate-y: 32px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-33, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-33 {
            --translate-y: 33px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-34, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-34 {
            --translate-y: 34px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-35, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-35 {
            --translate-y: 35px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-36, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-36 {
            --translate-y: 36px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-37, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-37 {
            --translate-y: 37px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-38, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-38 {
            --translate-y: 38px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-39, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-39 {
            --translate-y: 39px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-40, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-40 {
            --translate-y: 40px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-41, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-41 {
            --translate-y: 41px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-42, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-42 {
            --translate-y: 42px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-43, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-43 {
            --translate-y: 43px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-44, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-44 {
            --translate-y: 44px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-45, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-45 {
            --translate-y: 45px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-46, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-46 {
            --translate-y: 46px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-47, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-47 {
            --translate-y: 47px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-48, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-48 {
            --translate-y: 48px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-49, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-49 {
            --translate-y: 49px; }
          .management-container.create-event .discord .discord-banner .image-preview.translate-y-50, .management-container.create-event-template .discord .discord-banner .image-preview.translate-y-50 {
            --translate-y: 50px; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-50, .management-container.create-event-template .discord .discord-banner .image-preview.scale-50 {
            --scale: 0.5; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-51, .management-container.create-event-template .discord .discord-banner .image-preview.scale-51 {
            --scale: 0.51; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-52, .management-container.create-event-template .discord .discord-banner .image-preview.scale-52 {
            --scale: 0.52; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-53, .management-container.create-event-template .discord .discord-banner .image-preview.scale-53 {
            --scale: 0.53; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-54, .management-container.create-event-template .discord .discord-banner .image-preview.scale-54 {
            --scale: 0.54; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-55, .management-container.create-event-template .discord .discord-banner .image-preview.scale-55 {
            --scale: 0.55; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-56, .management-container.create-event-template .discord .discord-banner .image-preview.scale-56 {
            --scale: 0.56; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-57, .management-container.create-event-template .discord .discord-banner .image-preview.scale-57 {
            --scale: 0.57; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-58, .management-container.create-event-template .discord .discord-banner .image-preview.scale-58 {
            --scale: 0.58; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-59, .management-container.create-event-template .discord .discord-banner .image-preview.scale-59 {
            --scale: 0.59; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-60, .management-container.create-event-template .discord .discord-banner .image-preview.scale-60 {
            --scale: 0.6; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-61, .management-container.create-event-template .discord .discord-banner .image-preview.scale-61 {
            --scale: 0.61; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-62, .management-container.create-event-template .discord .discord-banner .image-preview.scale-62 {
            --scale: 0.62; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-63, .management-container.create-event-template .discord .discord-banner .image-preview.scale-63 {
            --scale: 0.63; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-64, .management-container.create-event-template .discord .discord-banner .image-preview.scale-64 {
            --scale: 0.64; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-65, .management-container.create-event-template .discord .discord-banner .image-preview.scale-65 {
            --scale: 0.65; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-66, .management-container.create-event-template .discord .discord-banner .image-preview.scale-66 {
            --scale: 0.66; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-67, .management-container.create-event-template .discord .discord-banner .image-preview.scale-67 {
            --scale: 0.67; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-68, .management-container.create-event-template .discord .discord-banner .image-preview.scale-68 {
            --scale: 0.68; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-69, .management-container.create-event-template .discord .discord-banner .image-preview.scale-69 {
            --scale: 0.69; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-70, .management-container.create-event-template .discord .discord-banner .image-preview.scale-70 {
            --scale: 0.7; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-71, .management-container.create-event-template .discord .discord-banner .image-preview.scale-71 {
            --scale: 0.71; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-72, .management-container.create-event-template .discord .discord-banner .image-preview.scale-72 {
            --scale: 0.72; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-73, .management-container.create-event-template .discord .discord-banner .image-preview.scale-73 {
            --scale: 0.73; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-74, .management-container.create-event-template .discord .discord-banner .image-preview.scale-74 {
            --scale: 0.74; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-75, .management-container.create-event-template .discord .discord-banner .image-preview.scale-75 {
            --scale: 0.75; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-76, .management-container.create-event-template .discord .discord-banner .image-preview.scale-76 {
            --scale: 0.76; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-77, .management-container.create-event-template .discord .discord-banner .image-preview.scale-77 {
            --scale: 0.77; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-78, .management-container.create-event-template .discord .discord-banner .image-preview.scale-78 {
            --scale: 0.78; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-79, .management-container.create-event-template .discord .discord-banner .image-preview.scale-79 {
            --scale: 0.79; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-80, .management-container.create-event-template .discord .discord-banner .image-preview.scale-80 {
            --scale: 0.8; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-81, .management-container.create-event-template .discord .discord-banner .image-preview.scale-81 {
            --scale: 0.81; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-82, .management-container.create-event-template .discord .discord-banner .image-preview.scale-82 {
            --scale: 0.82; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-83, .management-container.create-event-template .discord .discord-banner .image-preview.scale-83 {
            --scale: 0.83; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-84, .management-container.create-event-template .discord .discord-banner .image-preview.scale-84 {
            --scale: 0.84; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-85, .management-container.create-event-template .discord .discord-banner .image-preview.scale-85 {
            --scale: 0.85; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-86, .management-container.create-event-template .discord .discord-banner .image-preview.scale-86 {
            --scale: 0.86; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-87, .management-container.create-event-template .discord .discord-banner .image-preview.scale-87 {
            --scale: 0.87; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-88, .management-container.create-event-template .discord .discord-banner .image-preview.scale-88 {
            --scale: 0.88; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-89, .management-container.create-event-template .discord .discord-banner .image-preview.scale-89 {
            --scale: 0.89; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-90, .management-container.create-event-template .discord .discord-banner .image-preview.scale-90 {
            --scale: 0.9; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-91, .management-container.create-event-template .discord .discord-banner .image-preview.scale-91 {
            --scale: 0.91; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-92, .management-container.create-event-template .discord .discord-banner .image-preview.scale-92 {
            --scale: 0.92; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-93, .management-container.create-event-template .discord .discord-banner .image-preview.scale-93 {
            --scale: 0.93; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-94, .management-container.create-event-template .discord .discord-banner .image-preview.scale-94 {
            --scale: 0.94; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-95, .management-container.create-event-template .discord .discord-banner .image-preview.scale-95 {
            --scale: 0.95; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-96, .management-container.create-event-template .discord .discord-banner .image-preview.scale-96 {
            --scale: 0.96; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-97, .management-container.create-event-template .discord .discord-banner .image-preview.scale-97 {
            --scale: 0.97; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-98, .management-container.create-event-template .discord .discord-banner .image-preview.scale-98 {
            --scale: 0.98; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-99, .management-container.create-event-template .discord .discord-banner .image-preview.scale-99 {
            --scale: 0.99; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-100, .management-container.create-event-template .discord .discord-banner .image-preview.scale-100 {
            --scale: 1; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-101, .management-container.create-event-template .discord .discord-banner .image-preview.scale-101 {
            --scale: 1.01; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-102, .management-container.create-event-template .discord .discord-banner .image-preview.scale-102 {
            --scale: 1.02; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-103, .management-container.create-event-template .discord .discord-banner .image-preview.scale-103 {
            --scale: 1.03; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-104, .management-container.create-event-template .discord .discord-banner .image-preview.scale-104 {
            --scale: 1.04; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-105, .management-container.create-event-template .discord .discord-banner .image-preview.scale-105 {
            --scale: 1.05; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-106, .management-container.create-event-template .discord .discord-banner .image-preview.scale-106 {
            --scale: 1.06; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-107, .management-container.create-event-template .discord .discord-banner .image-preview.scale-107 {
            --scale: 1.07; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-108, .management-container.create-event-template .discord .discord-banner .image-preview.scale-108 {
            --scale: 1.08; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-109, .management-container.create-event-template .discord .discord-banner .image-preview.scale-109 {
            --scale: 1.09; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-110, .management-container.create-event-template .discord .discord-banner .image-preview.scale-110 {
            --scale: 1.1; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-111, .management-container.create-event-template .discord .discord-banner .image-preview.scale-111 {
            --scale: 1.11; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-112, .management-container.create-event-template .discord .discord-banner .image-preview.scale-112 {
            --scale: 1.12; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-113, .management-container.create-event-template .discord .discord-banner .image-preview.scale-113 {
            --scale: 1.13; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-114, .management-container.create-event-template .discord .discord-banner .image-preview.scale-114 {
            --scale: 1.14; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-115, .management-container.create-event-template .discord .discord-banner .image-preview.scale-115 {
            --scale: 1.15; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-116, .management-container.create-event-template .discord .discord-banner .image-preview.scale-116 {
            --scale: 1.16; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-117, .management-container.create-event-template .discord .discord-banner .image-preview.scale-117 {
            --scale: 1.17; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-118, .management-container.create-event-template .discord .discord-banner .image-preview.scale-118 {
            --scale: 1.18; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-119, .management-container.create-event-template .discord .discord-banner .image-preview.scale-119 {
            --scale: 1.19; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-120, .management-container.create-event-template .discord .discord-banner .image-preview.scale-120 {
            --scale: 1.2; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-121, .management-container.create-event-template .discord .discord-banner .image-preview.scale-121 {
            --scale: 1.21; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-122, .management-container.create-event-template .discord .discord-banner .image-preview.scale-122 {
            --scale: 1.22; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-123, .management-container.create-event-template .discord .discord-banner .image-preview.scale-123 {
            --scale: 1.23; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-124, .management-container.create-event-template .discord .discord-banner .image-preview.scale-124 {
            --scale: 1.24; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-125, .management-container.create-event-template .discord .discord-banner .image-preview.scale-125 {
            --scale: 1.25; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-126, .management-container.create-event-template .discord .discord-banner .image-preview.scale-126 {
            --scale: 1.26; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-127, .management-container.create-event-template .discord .discord-banner .image-preview.scale-127 {
            --scale: 1.27; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-128, .management-container.create-event-template .discord .discord-banner .image-preview.scale-128 {
            --scale: 1.28; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-129, .management-container.create-event-template .discord .discord-banner .image-preview.scale-129 {
            --scale: 1.29; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-130, .management-container.create-event-template .discord .discord-banner .image-preview.scale-130 {
            --scale: 1.3; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-131, .management-container.create-event-template .discord .discord-banner .image-preview.scale-131 {
            --scale: 1.31; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-132, .management-container.create-event-template .discord .discord-banner .image-preview.scale-132 {
            --scale: 1.32; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-133, .management-container.create-event-template .discord .discord-banner .image-preview.scale-133 {
            --scale: 1.33; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-134, .management-container.create-event-template .discord .discord-banner .image-preview.scale-134 {
            --scale: 1.34; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-135, .management-container.create-event-template .discord .discord-banner .image-preview.scale-135 {
            --scale: 1.35; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-136, .management-container.create-event-template .discord .discord-banner .image-preview.scale-136 {
            --scale: 1.36; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-137, .management-container.create-event-template .discord .discord-banner .image-preview.scale-137 {
            --scale: 1.37; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-138, .management-container.create-event-template .discord .discord-banner .image-preview.scale-138 {
            --scale: 1.38; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-139, .management-container.create-event-template .discord .discord-banner .image-preview.scale-139 {
            --scale: 1.39; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-140, .management-container.create-event-template .discord .discord-banner .image-preview.scale-140 {
            --scale: 1.4; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-141, .management-container.create-event-template .discord .discord-banner .image-preview.scale-141 {
            --scale: 1.41; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-142, .management-container.create-event-template .discord .discord-banner .image-preview.scale-142 {
            --scale: 1.42; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-143, .management-container.create-event-template .discord .discord-banner .image-preview.scale-143 {
            --scale: 1.43; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-144, .management-container.create-event-template .discord .discord-banner .image-preview.scale-144 {
            --scale: 1.44; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-145, .management-container.create-event-template .discord .discord-banner .image-preview.scale-145 {
            --scale: 1.45; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-146, .management-container.create-event-template .discord .discord-banner .image-preview.scale-146 {
            --scale: 1.46; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-147, .management-container.create-event-template .discord .discord-banner .image-preview.scale-147 {
            --scale: 1.47; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-148, .management-container.create-event-template .discord .discord-banner .image-preview.scale-148 {
            --scale: 1.48; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-149, .management-container.create-event-template .discord .discord-banner .image-preview.scale-149 {
            --scale: 1.49; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-150, .management-container.create-event-template .discord .discord-banner .image-preview.scale-150 {
            --scale: 1.5; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-151, .management-container.create-event-template .discord .discord-banner .image-preview.scale-151 {
            --scale: 1.51; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-152, .management-container.create-event-template .discord .discord-banner .image-preview.scale-152 {
            --scale: 1.52; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-153, .management-container.create-event-template .discord .discord-banner .image-preview.scale-153 {
            --scale: 1.53; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-154, .management-container.create-event-template .discord .discord-banner .image-preview.scale-154 {
            --scale: 1.54; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-155, .management-container.create-event-template .discord .discord-banner .image-preview.scale-155 {
            --scale: 1.55; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-156, .management-container.create-event-template .discord .discord-banner .image-preview.scale-156 {
            --scale: 1.56; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-157, .management-container.create-event-template .discord .discord-banner .image-preview.scale-157 {
            --scale: 1.57; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-158, .management-container.create-event-template .discord .discord-banner .image-preview.scale-158 {
            --scale: 1.58; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-159, .management-container.create-event-template .discord .discord-banner .image-preview.scale-159 {
            --scale: 1.59; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-160, .management-container.create-event-template .discord .discord-banner .image-preview.scale-160 {
            --scale: 1.6; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-161, .management-container.create-event-template .discord .discord-banner .image-preview.scale-161 {
            --scale: 1.61; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-162, .management-container.create-event-template .discord .discord-banner .image-preview.scale-162 {
            --scale: 1.62; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-163, .management-container.create-event-template .discord .discord-banner .image-preview.scale-163 {
            --scale: 1.63; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-164, .management-container.create-event-template .discord .discord-banner .image-preview.scale-164 {
            --scale: 1.64; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-165, .management-container.create-event-template .discord .discord-banner .image-preview.scale-165 {
            --scale: 1.65; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-166, .management-container.create-event-template .discord .discord-banner .image-preview.scale-166 {
            --scale: 1.66; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-167, .management-container.create-event-template .discord .discord-banner .image-preview.scale-167 {
            --scale: 1.67; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-168, .management-container.create-event-template .discord .discord-banner .image-preview.scale-168 {
            --scale: 1.68; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-169, .management-container.create-event-template .discord .discord-banner .image-preview.scale-169 {
            --scale: 1.69; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-170, .management-container.create-event-template .discord .discord-banner .image-preview.scale-170 {
            --scale: 1.7; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-171, .management-container.create-event-template .discord .discord-banner .image-preview.scale-171 {
            --scale: 1.71; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-172, .management-container.create-event-template .discord .discord-banner .image-preview.scale-172 {
            --scale: 1.72; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-173, .management-container.create-event-template .discord .discord-banner .image-preview.scale-173 {
            --scale: 1.73; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-174, .management-container.create-event-template .discord .discord-banner .image-preview.scale-174 {
            --scale: 1.74; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-175, .management-container.create-event-template .discord .discord-banner .image-preview.scale-175 {
            --scale: 1.75; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-176, .management-container.create-event-template .discord .discord-banner .image-preview.scale-176 {
            --scale: 1.76; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-177, .management-container.create-event-template .discord .discord-banner .image-preview.scale-177 {
            --scale: 1.77; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-178, .management-container.create-event-template .discord .discord-banner .image-preview.scale-178 {
            --scale: 1.78; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-179, .management-container.create-event-template .discord .discord-banner .image-preview.scale-179 {
            --scale: 1.79; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-180, .management-container.create-event-template .discord .discord-banner .image-preview.scale-180 {
            --scale: 1.8; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-181, .management-container.create-event-template .discord .discord-banner .image-preview.scale-181 {
            --scale: 1.81; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-182, .management-container.create-event-template .discord .discord-banner .image-preview.scale-182 {
            --scale: 1.82; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-183, .management-container.create-event-template .discord .discord-banner .image-preview.scale-183 {
            --scale: 1.83; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-184, .management-container.create-event-template .discord .discord-banner .image-preview.scale-184 {
            --scale: 1.84; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-185, .management-container.create-event-template .discord .discord-banner .image-preview.scale-185 {
            --scale: 1.85; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-186, .management-container.create-event-template .discord .discord-banner .image-preview.scale-186 {
            --scale: 1.86; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-187, .management-container.create-event-template .discord .discord-banner .image-preview.scale-187 {
            --scale: 1.87; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-188, .management-container.create-event-template .discord .discord-banner .image-preview.scale-188 {
            --scale: 1.88; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-189, .management-container.create-event-template .discord .discord-banner .image-preview.scale-189 {
            --scale: 1.89; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-190, .management-container.create-event-template .discord .discord-banner .image-preview.scale-190 {
            --scale: 1.9; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-191, .management-container.create-event-template .discord .discord-banner .image-preview.scale-191 {
            --scale: 1.91; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-192, .management-container.create-event-template .discord .discord-banner .image-preview.scale-192 {
            --scale: 1.92; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-193, .management-container.create-event-template .discord .discord-banner .image-preview.scale-193 {
            --scale: 1.93; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-194, .management-container.create-event-template .discord .discord-banner .image-preview.scale-194 {
            --scale: 1.94; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-195, .management-container.create-event-template .discord .discord-banner .image-preview.scale-195 {
            --scale: 1.95; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-196, .management-container.create-event-template .discord .discord-banner .image-preview.scale-196 {
            --scale: 1.96; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-197, .management-container.create-event-template .discord .discord-banner .image-preview.scale-197 {
            --scale: 1.97; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-198, .management-container.create-event-template .discord .discord-banner .image-preview.scale-198 {
            --scale: 1.98; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-199, .management-container.create-event-template .discord .discord-banner .image-preview.scale-199 {
            --scale: 1.99; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-200, .management-container.create-event-template .discord .discord-banner .image-preview.scale-200 {
            --scale: 2; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-201, .management-container.create-event-template .discord .discord-banner .image-preview.scale-201 {
            --scale: 2.01; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-202, .management-container.create-event-template .discord .discord-banner .image-preview.scale-202 {
            --scale: 2.02; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-203, .management-container.create-event-template .discord .discord-banner .image-preview.scale-203 {
            --scale: 2.03; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-204, .management-container.create-event-template .discord .discord-banner .image-preview.scale-204 {
            --scale: 2.04; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-205, .management-container.create-event-template .discord .discord-banner .image-preview.scale-205 {
            --scale: 2.05; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-206, .management-container.create-event-template .discord .discord-banner .image-preview.scale-206 {
            --scale: 2.06; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-207, .management-container.create-event-template .discord .discord-banner .image-preview.scale-207 {
            --scale: 2.07; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-208, .management-container.create-event-template .discord .discord-banner .image-preview.scale-208 {
            --scale: 2.08; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-209, .management-container.create-event-template .discord .discord-banner .image-preview.scale-209 {
            --scale: 2.09; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-210, .management-container.create-event-template .discord .discord-banner .image-preview.scale-210 {
            --scale: 2.1; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-211, .management-container.create-event-template .discord .discord-banner .image-preview.scale-211 {
            --scale: 2.11; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-212, .management-container.create-event-template .discord .discord-banner .image-preview.scale-212 {
            --scale: 2.12; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-213, .management-container.create-event-template .discord .discord-banner .image-preview.scale-213 {
            --scale: 2.13; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-214, .management-container.create-event-template .discord .discord-banner .image-preview.scale-214 {
            --scale: 2.14; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-215, .management-container.create-event-template .discord .discord-banner .image-preview.scale-215 {
            --scale: 2.15; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-216, .management-container.create-event-template .discord .discord-banner .image-preview.scale-216 {
            --scale: 2.16; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-217, .management-container.create-event-template .discord .discord-banner .image-preview.scale-217 {
            --scale: 2.17; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-218, .management-container.create-event-template .discord .discord-banner .image-preview.scale-218 {
            --scale: 2.18; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-219, .management-container.create-event-template .discord .discord-banner .image-preview.scale-219 {
            --scale: 2.19; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-220, .management-container.create-event-template .discord .discord-banner .image-preview.scale-220 {
            --scale: 2.2; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-221, .management-container.create-event-template .discord .discord-banner .image-preview.scale-221 {
            --scale: 2.21; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-222, .management-container.create-event-template .discord .discord-banner .image-preview.scale-222 {
            --scale: 2.22; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-223, .management-container.create-event-template .discord .discord-banner .image-preview.scale-223 {
            --scale: 2.23; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-224, .management-container.create-event-template .discord .discord-banner .image-preview.scale-224 {
            --scale: 2.24; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-225, .management-container.create-event-template .discord .discord-banner .image-preview.scale-225 {
            --scale: 2.25; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-226, .management-container.create-event-template .discord .discord-banner .image-preview.scale-226 {
            --scale: 2.26; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-227, .management-container.create-event-template .discord .discord-banner .image-preview.scale-227 {
            --scale: 2.27; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-228, .management-container.create-event-template .discord .discord-banner .image-preview.scale-228 {
            --scale: 2.28; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-229, .management-container.create-event-template .discord .discord-banner .image-preview.scale-229 {
            --scale: 2.29; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-230, .management-container.create-event-template .discord .discord-banner .image-preview.scale-230 {
            --scale: 2.3; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-231, .management-container.create-event-template .discord .discord-banner .image-preview.scale-231 {
            --scale: 2.31; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-232, .management-container.create-event-template .discord .discord-banner .image-preview.scale-232 {
            --scale: 2.32; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-233, .management-container.create-event-template .discord .discord-banner .image-preview.scale-233 {
            --scale: 2.33; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-234, .management-container.create-event-template .discord .discord-banner .image-preview.scale-234 {
            --scale: 2.34; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-235, .management-container.create-event-template .discord .discord-banner .image-preview.scale-235 {
            --scale: 2.35; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-236, .management-container.create-event-template .discord .discord-banner .image-preview.scale-236 {
            --scale: 2.36; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-237, .management-container.create-event-template .discord .discord-banner .image-preview.scale-237 {
            --scale: 2.37; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-238, .management-container.create-event-template .discord .discord-banner .image-preview.scale-238 {
            --scale: 2.38; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-239, .management-container.create-event-template .discord .discord-banner .image-preview.scale-239 {
            --scale: 2.39; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-240, .management-container.create-event-template .discord .discord-banner .image-preview.scale-240 {
            --scale: 2.4; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-241, .management-container.create-event-template .discord .discord-banner .image-preview.scale-241 {
            --scale: 2.41; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-242, .management-container.create-event-template .discord .discord-banner .image-preview.scale-242 {
            --scale: 2.42; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-243, .management-container.create-event-template .discord .discord-banner .image-preview.scale-243 {
            --scale: 2.43; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-244, .management-container.create-event-template .discord .discord-banner .image-preview.scale-244 {
            --scale: 2.44; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-245, .management-container.create-event-template .discord .discord-banner .image-preview.scale-245 {
            --scale: 2.45; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-246, .management-container.create-event-template .discord .discord-banner .image-preview.scale-246 {
            --scale: 2.46; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-247, .management-container.create-event-template .discord .discord-banner .image-preview.scale-247 {
            --scale: 2.47; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-248, .management-container.create-event-template .discord .discord-banner .image-preview.scale-248 {
            --scale: 2.48; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-249, .management-container.create-event-template .discord .discord-banner .image-preview.scale-249 {
            --scale: 2.49; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-250, .management-container.create-event-template .discord .discord-banner .image-preview.scale-250 {
            --scale: 2.5; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-251, .management-container.create-event-template .discord .discord-banner .image-preview.scale-251 {
            --scale: 2.51; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-252, .management-container.create-event-template .discord .discord-banner .image-preview.scale-252 {
            --scale: 2.52; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-253, .management-container.create-event-template .discord .discord-banner .image-preview.scale-253 {
            --scale: 2.53; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-254, .management-container.create-event-template .discord .discord-banner .image-preview.scale-254 {
            --scale: 2.54; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-255, .management-container.create-event-template .discord .discord-banner .image-preview.scale-255 {
            --scale: 2.55; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-256, .management-container.create-event-template .discord .discord-banner .image-preview.scale-256 {
            --scale: 2.56; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-257, .management-container.create-event-template .discord .discord-banner .image-preview.scale-257 {
            --scale: 2.57; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-258, .management-container.create-event-template .discord .discord-banner .image-preview.scale-258 {
            --scale: 2.58; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-259, .management-container.create-event-template .discord .discord-banner .image-preview.scale-259 {
            --scale: 2.59; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-260, .management-container.create-event-template .discord .discord-banner .image-preview.scale-260 {
            --scale: 2.6; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-261, .management-container.create-event-template .discord .discord-banner .image-preview.scale-261 {
            --scale: 2.61; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-262, .management-container.create-event-template .discord .discord-banner .image-preview.scale-262 {
            --scale: 2.62; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-263, .management-container.create-event-template .discord .discord-banner .image-preview.scale-263 {
            --scale: 2.63; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-264, .management-container.create-event-template .discord .discord-banner .image-preview.scale-264 {
            --scale: 2.64; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-265, .management-container.create-event-template .discord .discord-banner .image-preview.scale-265 {
            --scale: 2.65; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-266, .management-container.create-event-template .discord .discord-banner .image-preview.scale-266 {
            --scale: 2.66; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-267, .management-container.create-event-template .discord .discord-banner .image-preview.scale-267 {
            --scale: 2.67; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-268, .management-container.create-event-template .discord .discord-banner .image-preview.scale-268 {
            --scale: 2.68; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-269, .management-container.create-event-template .discord .discord-banner .image-preview.scale-269 {
            --scale: 2.69; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-270, .management-container.create-event-template .discord .discord-banner .image-preview.scale-270 {
            --scale: 2.7; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-271, .management-container.create-event-template .discord .discord-banner .image-preview.scale-271 {
            --scale: 2.71; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-272, .management-container.create-event-template .discord .discord-banner .image-preview.scale-272 {
            --scale: 2.72; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-273, .management-container.create-event-template .discord .discord-banner .image-preview.scale-273 {
            --scale: 2.73; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-274, .management-container.create-event-template .discord .discord-banner .image-preview.scale-274 {
            --scale: 2.74; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-275, .management-container.create-event-template .discord .discord-banner .image-preview.scale-275 {
            --scale: 2.75; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-276, .management-container.create-event-template .discord .discord-banner .image-preview.scale-276 {
            --scale: 2.76; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-277, .management-container.create-event-template .discord .discord-banner .image-preview.scale-277 {
            --scale: 2.77; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-278, .management-container.create-event-template .discord .discord-banner .image-preview.scale-278 {
            --scale: 2.78; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-279, .management-container.create-event-template .discord .discord-banner .image-preview.scale-279 {
            --scale: 2.79; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-280, .management-container.create-event-template .discord .discord-banner .image-preview.scale-280 {
            --scale: 2.8; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-281, .management-container.create-event-template .discord .discord-banner .image-preview.scale-281 {
            --scale: 2.81; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-282, .management-container.create-event-template .discord .discord-banner .image-preview.scale-282 {
            --scale: 2.82; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-283, .management-container.create-event-template .discord .discord-banner .image-preview.scale-283 {
            --scale: 2.83; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-284, .management-container.create-event-template .discord .discord-banner .image-preview.scale-284 {
            --scale: 2.84; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-285, .management-container.create-event-template .discord .discord-banner .image-preview.scale-285 {
            --scale: 2.85; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-286, .management-container.create-event-template .discord .discord-banner .image-preview.scale-286 {
            --scale: 2.86; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-287, .management-container.create-event-template .discord .discord-banner .image-preview.scale-287 {
            --scale: 2.87; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-288, .management-container.create-event-template .discord .discord-banner .image-preview.scale-288 {
            --scale: 2.88; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-289, .management-container.create-event-template .discord .discord-banner .image-preview.scale-289 {
            --scale: 2.89; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-290, .management-container.create-event-template .discord .discord-banner .image-preview.scale-290 {
            --scale: 2.9; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-291, .management-container.create-event-template .discord .discord-banner .image-preview.scale-291 {
            --scale: 2.91; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-292, .management-container.create-event-template .discord .discord-banner .image-preview.scale-292 {
            --scale: 2.92; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-293, .management-container.create-event-template .discord .discord-banner .image-preview.scale-293 {
            --scale: 2.93; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-294, .management-container.create-event-template .discord .discord-banner .image-preview.scale-294 {
            --scale: 2.94; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-295, .management-container.create-event-template .discord .discord-banner .image-preview.scale-295 {
            --scale: 2.95; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-296, .management-container.create-event-template .discord .discord-banner .image-preview.scale-296 {
            --scale: 2.96; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-297, .management-container.create-event-template .discord .discord-banner .image-preview.scale-297 {
            --scale: 2.97; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-298, .management-container.create-event-template .discord .discord-banner .image-preview.scale-298 {
            --scale: 2.98; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-299, .management-container.create-event-template .discord .discord-banner .image-preview.scale-299 {
            --scale: 2.99; }
          .management-container.create-event .discord .discord-banner .image-preview.scale-300, .management-container.create-event-template .discord .discord-banner .image-preview.scale-300 {
            --scale: 3; }
        .management-container.create-event .discord .discord-banner .zoom-slider, .management-container.create-event-template .discord .discord-banner .zoom-slider {
          display: flex;
          width: 325px;
          margin: 8px auto 0px auto; }
      .management-container.create-event .discord .discord-description, .management-container.create-event-template .discord .discord-description {
        display: flex;
        max-width: 540px;
        width: 540px; }
        .management-container.create-event .discord .discord-description .input-field, .management-container.create-event-template .discord .discord-description .input-field {
          display: flex;
          flex-direction: column;
          width: 100%;
          padding: 0 10px 0 20px; }
          .management-container.create-event .discord .discord-description .input-field .field-value, .management-container.create-event-template .discord .discord-description .input-field .field-value {
            color: #dfdfdf; }
          .management-container.create-event .discord .discord-description .input-field .home-file, .management-container.create-event .discord .discord-description .input-field .character-counter, .management-container.create-event-template .discord .discord-description .input-field .home-file, .management-container.create-event-template .discord .discord-description .input-field .character-counter {
            margin: 5px auto 5px 3px;
            color: #dfdfdf; }

.calendar-tooltip {
  position: absolute;
  background-color: #1c2d38;
  border-radius: 8px;
  width: max-content;
  min-width: 200px;
  height: 275px;
  border: 1px solid #491212;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  cursor: pointer; }
  .calendar-tooltip[data-top] {
    --tooltip-top: attr(data-top px); }
  .calendar-tooltip.status {
    position: relative;
    width: 100%;
    height: auto;
    padding: 5px 0px;
    border-radius: 5px;
    text-align: center;
    font-weight: bold;
    margin: 4px -3px 5px -3px;
    border: 2px solid #0c2637;
    box-shadow: 0px 0px 5px 2px #292a2bed; }
    .calendar-tooltip.status.canceled {
      background-color: #491212;
      color: #dfdfdf; }
    .calendar-tooltip.status.scheduled {
      background-color: #3f7c42;
      color: #dfdfdf; }
    .calendar-tooltip.status.live {
      background-color: #6e441c;
      color: #dfdfdf; }
    .calendar-tooltip.status.concluded {
      background-color: #2a3847;
      color: #b8b8b8; }
    .calendar-tooltip.status.tentative {
      background-color: #c78445;
      color: #dfdfdf; }
  .calendar-tooltip .tooltip-header {
    display: flex;
    justify-content: space-between;
    color: #dfdfdf;
    text-transform: uppercase;
    font-weight: bold;
    align-items: center;
    padding: 5px 10px;
    border-bottom: 2px solid #2a3847;
    border-radius: 8px 8px 0px 0px;
    background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    border-bottom: 2px solid #b8b8b8; }
    .calendar-tooltip .tooltip-header .tooltip-h3 {
      font-size: small;
      margin: 0;
      padding-right: 10px;
      color: #dfdfdf;
      text-transform: uppercase; }
    .calendar-tooltip .tooltip-header .link-chain-icon {
      width: 20px;
      height: 20px;
      margin-right: 10px;
      cursor: pointer; }
    .calendar-tooltip .tooltip-header .close-button {
      background: none;
      border: none;
      font-size: 16px;
      cursor: pointer; }
  .calendar-tooltip .tooltip-content {
    padding: 0 10px;
    margin-top: 5px;
    border-radius: 0 0 8px 8px;
    height: 190px; }
    .calendar-tooltip .tooltip-content p {
      margin: 5px 0; }
      .calendar-tooltip .tooltip-content p strong {
        font-weight: bold; }
  .calendar-tooltip .tooltip-footer {
    padding: 5px 10px; }
    .calendar-tooltip .tooltip-footer .btn-style1 {
      width: -webkit-fill-available;
      font-size: smaller;
      margin: 0 auto; }

/* ------------------------ */
/* Conteneur des événements */
/* ------------------------ */
.rbc-events-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(48%, 1fr));
  grid-auto-rows: auto;
  grid-gap: 2px; }

.rbc-show-more {
  width: 100%; }

.rbc-show-more:hover, .rbc-show-more:focus {
  color: #491212;
  width: 100%; }

.calendar-event-modal .modal-dialog .modal-content {
  width: 1200px;
  max-width: 1200px; }

.calendar-event-modal:not(.calendar-event-modal--card-top):not(.calendar-event-modal--roster-file) .modal-dialog {
  width: min(1100px, 94vw);
  max-width: min(1100px, 94vw);
  width: 1200px;
  max-width: 1200px;
  margin: 1.25rem auto; }

.calendar-event-modal:not(.calendar-event-modal--card-top):not(.calendar-event-modal--roster-file) .modal-dialog .modal-content {
  width: 100%;
  box-sizing: border-box;
  min-width: min(960px, 100%);
  max-width: 100%; }

.header.calendar-event, .header.create-event {
  display: flex;
  justify-content: space-between;
  color: #dfdfdf;
  text-transform: uppercase;
  font-weight: bold;
  align-items: center;
  padding: 5px 10px;
  border-bottom: 2px solid #2a3847;
  border-radius: 8px 8px 0px 0px;
  background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___}); }
  .header.calendar-event .calendar-event-h3, .header.create-event .calendar-event-h3 {
    margin: 0;
    font-size: small; }
  .header.calendar-event .icon, .header.create-event .icon {
    display: flex;
    height: 18px;
    overflow: hidden;
    margin-left: auto;
    margin-right: 0; }
    .header.calendar-event .icon .close-event-button, .header.create-event .icon .close-event-button {
      position: relative;
      height: 40px;
      object-fit: contain;
      overflow: hidden;
      cursor: pointer; }
      .header.calendar-event .icon .close-event-button:hover, .header.create-event .icon .close-event-button:hover {
        top: -21px; }

.calendar-event.discord-banner {
  display: flex;
  align-items: center;
  width: auto;
  max-height: 300px;
  object-fit: cover;
  border: 1px solid;
  border-bottom: none;
  border-color: #b8b8b8;
  border-radius: 8px 8px 0px 0px;
  background-color: #151c24;
  overflow: hidden; }
  .calendar-event.discord-banner .discord-banner-image {
    width: 100%; }

.calendar-event .locked {
  pointer-events: none;
  opacity: 0.6; }

.calendar-event .locked-text {
  opacity: 0.6;
  font-style: italic; }

.locked {
  opacity: 0.6;
  pointer-events: none;
  cursor: not-allowed; }

.calendar-event.time {
  display: flex;
  gap: 12px;
  min-height: 175px;
  border: 1px solid;
  border-top: none;
  border-color: #b8b8b8;
  border-radius: 0px 0px 8px 8px;
  background-color: #172738; }
  .calendar-event.time .column {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    padding: 10px;
    box-sizing: border-box; }
    .calendar-event.time .column:first-child {
      min-width: 0;
      flex-grow: 1; }
    .calendar-event.time .column:last-child {
      flex-basis: 350px;
      flex-shrink: 0; }
    .calendar-event.time .column .calendar-icon {
      width: auto;
      height: 15px;
      margin-right: 10px;
      vertical-align: middle; }
    .calendar-event.time .column .recurrence-item {
      display: flex;
      align-items: flex-start; }
      .calendar-event.time .column .recurrence-item .calendar-icon {
        width: auto;
        height: 15px;
        margin-right: 10px; }
      .calendar-event.time .column .recurrence-item p {
        margin: 0; }
  .calendar-event.time .star-citizen-location-column {
    flex: 0 0 250px;
    min-width: 240px;
    max-width: 250px;
    width: 250px; }
  .calendar-event.time .star-citizen-location-item {
    align-items: flex-start; }
  .calendar-event.time .star-citizen-location-icon {
    flex: 0 0 auto;
    filter: brightness(0) saturate(100%) invert(96%) sepia(0%) saturate(3%) hue-rotate(180deg) brightness(92%) contrast(92%); }
  .calendar-event.time .star-citizen-location-title {
    display: flex;
    align-items: center; }
    .calendar-event.time .star-citizen-location-title p {
      font-weight: 700; }
  .calendar-event.time .star-citizen-location-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding-left: 24px;
    min-width: 0; }
    .calendar-event.time .star-citizen-location-content p {
      color: #b8b8b8; }
  .calendar-event.time .star-citizen-location-details {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0; }
    .calendar-event.time .star-citizen-location-details p {
      margin: 0;
      color: #b8b8b8;
      font-size: 15px;
      line-height: 1.3;
      overflow-wrap: anywhere; }
    .calendar-event.time .star-citizen-location-details .star-citizen-location-title {
      color: #dfdfdf; }
      .calendar-event.time .star-citizen-location-details .star-citizen-location-title p {
        color: #dfdfdf; }
    .calendar-event.time .star-citizen-location-details .star-citizen-location-content p {
      color: #b8b8b8; }
  .calendar-event.time .star-citizen-solar-details {
    margin-top: 6px; }
  .calendar-event.time .star-citizen-location-editor {
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
    min-width: 0; }
    .calendar-event.time .star-citizen-location-editor .react-select-input__control {
      min-height: 30px !important;
      height: auto !important;
      width: 100%;
      min-width: 0 !important;
      max-width: 100%;
      background-color: #1e3042;
      border-color: rgba(184, 184, 184, 0.45); }
    .calendar-event.time .star-citizen-location-editor .react-select-input__value-container {
      min-height: 28px;
      padding: 0 6px; }
    .calendar-event.time .star-citizen-location-editor .react-select-input__single-value,
    .calendar-event.time .star-citizen-location-editor .react-select-input__placeholder,
    .calendar-event.time .star-citizen-location-editor .react-select-input__input-container,
    .calendar-event.time .star-citizen-location-editor .react-select-input__input {
      color: #dfdfdf !important;
      font-size: 12px; }
    .calendar-event.time .star-citizen-location-editor .react-select-input__placeholder {
      color: rgba(184, 184, 184, 0.9) !important; }
    .calendar-event.time .star-citizen-location-editor .react-select-input__indicator {
      color: #b8b8b8; }
    .calendar-event.time .star-citizen-location-editor p {
      margin: 0;
      color: #dfdfdf;
      font-size: 12px;
      line-height: 1.3; }
  .calendar-event.time .meeting-point-label {
    margin: 0;
    color: #dfdfdf;
    font-size: 15px;
    font-weight: 700; }
  .calendar-event.time .meeting-point-row {
    display: flex;
    align-items: center;
    gap: 0px;
    min-width: 0; }
    .calendar-event.time .meeting-point-row .location-item {
      min-width: 0; }

.calendar-event-report.header {
  display: flex;
  justify-content: space-between;
  color: #dfdfdf;
  text-transform: uppercase;
  font-weight: bold;
  align-items: center;
  padding: 5px 10px;
  border-bottom: 2px solid #2a3847;
  border-radius: 8px 8px 0px 0px;
  background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___}); }
  .calendar-event-report.header .calendar-event-h3 {
    margin: 0;
    font-size: small; }
  .calendar-event-report.header .icon {
    display: flex;
    height: 18px;
    overflow: hidden;
    margin-left: auto;
    margin-right: 0; }
    .calendar-event-report.header .icon .close-event-button {
      position: relative;
      height: 40px;
      object-fit: contain;
      overflow: hidden;
      cursor: pointer; }
      .calendar-event-report.header .icon .close-event-button:hover {
        top: -21px; }

.calendar-event-report.content {
  display: flex;
  flex-direction: column;
  background: #163447;
  padding: 15px;
  gap: 10px;
  overflow: hidden;
  /* Slot compact à droite du total UEC : même ligne que l’input ; remplace Org Share quand le timer est actif */
  /* Expanded: keep validate/save on the right without overlapping mission contract toggle. */
  /* Benefits-only: label + switch alignment (do not use \`.join-operation\` here). */
  /* Replié : champ UEC + org share / countdown strictement sur une même ligne (pas de wrap). */
  /* colgroup: narrower identity; mini payout-toggle; loot stays 60% */
  /* Loot chip : toggle (report éditable) ou pastilles ✓ vert / ✕ gris (vue événement / report lecture seule) */ }
  .calendar-event-report.content .report-event-details-row {
    display: flex;
    align-items: stretch;
    gap: 10px;
    min-width: 0; }
  .calendar-event-report.content .report-online-panel {
    width: 220px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    height: 175px;
    min-height: 0;
    overflow: hidden;
    color: #dfdfdf;
    border: 1px solid #b8b8b8;
    border-radius: 8px;
    background: #0c2637; }
    .calendar-event-report.content .report-online-panel .report-online-panel__title {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 10px 10px 6px 10px;
      border-bottom: 1px solid #2a3847;
      user-select: none; }
      .calendar-event-report.content .report-online-panel .report-online-panel__title strong {
        font-size: 0.95em;
        letter-spacing: 0.5px; }
    .calendar-event-report.content .report-online-panel .chat-users-list {
      display: flex;
      flex-direction: column;
      gap: 6px;
      flex: 1;
      min-height: 0;
      overflow-y: auto;
      padding: 10px;
      list-style: none;
      margin: 0; }
      .calendar-event-report.content .report-online-panel .chat-users-list::-webkit-scrollbar {
        width: 6px; }
      .calendar-event-report.content .report-online-panel .chat-users-list::-webkit-scrollbar-track {
        background: #2e3842;
        border-radius: 4px;
        padding-right: 1px; }
      .calendar-event-report.content .report-online-panel .chat-users-list::-webkit-scrollbar-thumb {
        background-color: #491212;
        border-radius: 4px; }
        .calendar-event-report.content .report-online-panel .chat-users-list::-webkit-scrollbar-thumb:hover {
          background-color: #200808; }
      .calendar-event-report.content .report-online-panel .chat-users-list .chat-user-item {
        display: flex;
        align-items: center;
        gap: 8px;
        width: -webkit-fill-available;
        border-radius: 6px; }
        .calendar-event-report.content .report-online-panel .chat-users-list .chat-user-item .chat-user-item__identity {
          flex: 1;
          min-width: 0; }
          .calendar-event-report.content .report-online-panel .chat-users-list .chat-user-item .chat-user-item__identity .user-discord-rank__name {
            color: #afa991;
            padding: 5px;
            border: 1px solid transparent; }
    .calendar-event-report.content .report-online-panel .report-online-panel__empty {
      padding: 6px 8px;
      opacity: 0.75;
      font-style: italic; }
  .calendar-event-report.content .objectives-benefits-row {
    display: flex;
    gap: 10px;
    width: 100%;
    align-items: stretch; }
    .calendar-event-report.content .objectives-benefits-row > .inputs-column.objectives,
    .calendar-event-report.content .objectives-benefits-row > .benefits-block {
      flex: 1 1 0;
      min-width: 0; }
  .calendar-event-report.content .objectives-benefits-row .inputs-column.objectives {
    background-color: #0c2637;
    border: 1px solid #dfdfdf;
    border-radius: 8px;
    padding: 10px; }
    .calendar-event-report.content .objectives-benefits-row .inputs-column.objectives .input {
      margin-bottom: 0; }
    .calendar-event-report.content .objectives-benefits-row .inputs-column.objectives .input.objectives-block {
      display: flex;
      flex-direction: column;
      border: 1px solid #dfdfdf;
      margin-top: 8px;
      border-radius: 4px;
      padding: 6px;
      gap: 6px;
      width: 100%;
      box-sizing: border-box; }
      .calendar-event-report.content .objectives-benefits-row .inputs-column.objectives .input.objectives-block.disabled {
        opacity: 0.5; }
      .calendar-event-report.content .objectives-benefits-row .inputs-column.objectives .input.objectives-block .objectives-scroll {
        height: 142px;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        gap: 5px;
        padding-right: 6px; }
        .calendar-event-report.content .objectives-benefits-row .inputs-column.objectives .input.objectives-block .objectives-scroll::-webkit-scrollbar {
          width: 6px; }
        .calendar-event-report.content .objectives-benefits-row .inputs-column.objectives .input.objectives-block .objectives-scroll::-webkit-scrollbar-track {
          background: #2e3842;
          border-radius: 4px;
          padding-right: 1px; }
        .calendar-event-report.content .objectives-benefits-row .inputs-column.objectives .input.objectives-block .objectives-scroll::-webkit-scrollbar-thumb {
          background-color: #491212;
          border-radius: 4px; }
          .calendar-event-report.content .objectives-benefits-row .inputs-column.objectives .input.objectives-block .objectives-scroll::-webkit-scrollbar-thumb:hover {
            background-color: #200808; }
      .calendar-event-report.content .objectives-benefits-row .inputs-column.objectives .input.objectives-block .objective-row {
        position: relative;
        display: grid;
        grid-template-columns: 18px auto 45px;
        gap: 6px;
        align-items: center; }
      .calendar-event-report.content .objectives-benefits-row .inputs-column.objectives .input.objectives-block .objective-order {
        font-size: 0.85em;
        color: #dfdfdf;
        opacity: 0.75;
        text-align: right;
        user-select: none;
        cursor: grab; }
        .calendar-event-report.content .objectives-benefits-row .inputs-column.objectives .input.objectives-block .objective-order.is-disabled {
          opacity: 0.25;
          cursor: default; }
      .calendar-event-report.content .objectives-benefits-row .inputs-column.objectives .input.objectives-block .objective-input {
        width: 100%;
        box-sizing: border-box; }
      .calendar-event-report.content .objectives-benefits-row .inputs-column.objectives .input.objectives-block .toggle.critical {
        height: 11px;
        display: flex;
        align-items: center;
        gap: 6px; }
  .calendar-event-report.content .benefits-block {
    background-color: #0c2637;
    border: 1px solid #b8b8b8;
    border-radius: 8px;
    padding: 10px;
    margin: 0;
    height: 260px;
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 1;
    transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease; }
    .calendar-event-report.content .benefits-block .benefits-block-header {
      margin-bottom: 6px;
      text-transform: uppercase;
      font-size: 0.85em;
      opacity: 0.9;
      display: flex;
      align-items: center;
      gap: 8px; }
    .calendar-event-report.content .benefits-block .benefits-block-body {
      flex: 1 1 auto;
      min-height: 0; }
  .calendar-event-report.content .report-benefits-expansion-shell {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 10px; }
  .calendar-event-report.content .calendar-event-report__benefits-save-reminder {
    flex: 1 1 auto;
    margin: 0;
    padding: 0.55rem 0.75rem;
    border-radius: 6px;
    border: 1px solid rgba(199, 132, 69, 0.55);
    background: rgba(199, 132, 69, 0.12);
    color: #dfdfdf;
    font-size: 0.82rem;
    line-height: 1.4; }
  .calendar-event-report.content.footer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px; }
    .calendar-event-report.content.footer .calendar-event-report__save-reminder-active {
      box-shadow: 0 0 0 2px rgba(199, 132, 69, 0.45); }
  .calendar-event-report.content .report-benefits-expansion-shell.is-expanded .report-benefits-expansion-participants,
  .calendar-event-report.content .report-benefits-expansion-shell.is-expanded .report-benefits-expansion-objectives,
  .calendar-event-report.content .report-benefits-expansion-shell.is-expanded .report-benefits-expansion-row {
    opacity: 0;
    pointer-events: none;
    user-select: none; }
  .calendar-event-report.content .report-benefits-expansion-shell.is-expanded .report-benefits-expansion-row {
    position: relative; }
  .calendar-event-report.content .report-benefits-expansion-row {
    display: flex;
    gap: 10px;
    width: 100%;
    align-items: stretch; }
    .calendar-event-report.content .report-benefits-expansion-row > .report-benefits-expansion-objectives,
    .calendar-event-report.content .report-benefits-expansion-row > .report-section-shell--benefits,
    .calendar-event-report.content .report-benefits-expansion-row > .report-benefits-expansion-benefits-placeholder {
      flex: 1 1 0;
      min-width: 0; }
  .calendar-event-report.content .report-benefits-expansion-overlay {
    position: absolute;
    inset: 0;
    z-index: 5;
    pointer-events: none;
    opacity: 0;
    transform: scale(0.985);
    transition: opacity 180ms ease, transform 180ms ease;
    width: 100%;
    height: 100%; }
  .calendar-event-report.content .report-benefits-expansion-shell.is-expanded-benefits .report-benefits-expansion-overlay,
  .calendar-event-report.content .report-benefits-expansion-shell.is-expanded-objectives .report-benefits-expansion-overlay,
  .calendar-event-report.content .report-benefits-expansion-shell.is-expanded-auction .report-benefits-expansion-overlay {
    opacity: 1;
    transform: scale(1);
    pointer-events: auto; }
  .calendar-event-report.content .report-benefits-expansion-overlay.is-closing {
    opacity: 0;
    transform: scale(0.985);
    pointer-events: none; }
  .calendar-event-report.content .report-benefits-expansion-overlay .benefits-block {
    height: 100%;
    max-height: 100%;
    box-sizing: border-box;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.45); }
  .calendar-event-report.content .report-section-shell {
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-radius: 8px;
    transition: border-color 160ms ease, box-shadow 160ms ease; }
  .calendar-event-report.content .report-section-shell--dirty {
    border-color: rgba(155, 96, 42, 0.95);
    box-shadow: 0 0 0 2px rgba(155, 96, 42, 0.25); }
  .calendar-event-report.content .report-section-shell--saved {
    border-color: rgba(90, 160, 92, 0.95);
    box-shadow: 0 0 0 2px rgba(90, 160, 92, 0.18); }
  .calendar-event-report.content .report-benefits-expansion-benefits-placeholder {
    flex: 1 1 0;
    min-width: 0; }
  .calendar-event-report.content .report-benefits-expansion-objectives {
    flex: 1 1 0;
    min-width: 0;
    display: flex; }
  .calendar-event-report.content .report-benefits-expansion-objectives-placeholder {
    height: 200px; }
  .calendar-event-report.content .benefits-block .benefits-uec {
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: 15px;
    min-height: 0; }
  .calendar-event-report.content .benefits-block .benefits-uec-top {
    display: flex;
    gap: 12px;
    align-items: flex-start; }
  .calendar-event-report.content .benefits-block .benefits-uec-loot-distributed-badge {
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    align-self: end;
    gap: 2px;
    padding: 8px 10px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: rgba(0, 0, 0, 0.18);
    min-width: 56px;
    user-select: none; }
  .calendar-event-report.content .benefits-block .benefits-uec-loot-distributed-badge__label {
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    opacity: 0.75;
    line-height: 1.1;
    white-space: nowrap; }
  .calendar-event-report.content .benefits-block .benefits-uec-loot-distributed-badge__value {
    font-size: 1.05rem;
    font-weight: 700;
    line-height: 1;
    color: rgba(255, 255, 255, 0.92); }
  .calendar-event-report.content .benefits-block .benefits-uec-top-left-cluster,
  .calendar-event-report.content .benefits-block .benefits-uec-top-left,
  .calendar-event-report.content .benefits-block .benefits-uec-top-right {
    min-width: 0; }
  .calendar-event-report.content .benefits-block .benefits-uec-top-left-cluster {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 12px;
    flex: 1 1 auto;
    width: 100%; }
  .calendar-event-report.content .benefits-block .benefits-uec-top-left-cluster .benefits-uec-top-left {
    flex: 0 1 auto;
    max-width: min(100%, 400px); }
  .calendar-event-report.content .benefits-block .benefits-uec-top-left-cluster .benefits-uec-mission-contract-wrap {
    flex: 0 0 auto;
    align-self: flex-end;
    min-width: 0; }
  .calendar-event-report.content .benefits-block .benefits-uec-top-left-cluster .benefits-uec-mission-contract-toggle.toggle {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    width: auto;
    min-width: 0;
    max-width: 100%;
    height: auto;
    bottom: 0;
    position: relative;
    margin: 0;
    text-transform: none;
    font-size: 14px;
    color: #dfdfdf; }
    .calendar-event-report.content .benefits-block .benefits-uec-top-left-cluster .benefits-uec-mission-contract-toggle.toggle .toggle-label {
      position: static;
      display: inline-flex;
      align-items: center;
      flex: 0 1 auto;
      margin: 0;
      width: auto;
      font-weight: normal;
      font-size: 0.85rem; }
    .calendar-event-report.content .benefits-block .benefits-uec-top-left-cluster .benefits-uec-mission-contract-toggle.toggle .toggle-switch {
      position: relative;
      top: auto;
      left: auto;
      right: auto;
      bottom: auto;
      margin: 0;
      flex-shrink: 0; }
  .calendar-event-report.content .benefits-block .benefits-uec-top-left-cluster .benefits-uec-payout-lock-wrap {
    margin-left: inherit; }
  .calendar-event-report.content .benefits-block .benefits-uec-top-right {
    flex: 0 0 auto;
    /* Visually line up the loot field with the UEC \`field-input\` row (not the label). */
    align-self: flex-end; }
  .calendar-event-report.content .benefits-block .benefits-uec-top-left-cluster:only-child {
    width: 100%; }
  .calendar-event-report.content .benefits-block .benefits-uec-top-left {
    display: flex;
    flex-direction: column;
    gap: 6px; }
  .calendar-event-report.content .benefits-block .benefits-uec-payout-lock-wrap {
    flex: 0 0 auto;
    position: relative;
    align-self: flex-end;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    max-width: none;
    min-width: 0; }
  .calendar-event-report.content .benefits-block .benefits-uec-payout-lock-wrap .benefits-uec-benefits-countdown--payout-slot,
  .calendar-event-report.content .benefits-block .benefits-uec-payout-lock-wrap .benefits-countdown-digital {
    max-width: min(100%, 22rem);
    min-width: 0; }
  .calendar-event-report.content .benefits-block .benefits-uec-total-with-share .benefits-uec-benefits-countdown--compact-slot,
  .calendar-event-report.content .benefits-block .benefits-uec-total-with-share .benefits-uec-benefits-countdown--compact-slot.benefits-countdown-digital {
    flex: 1 1 auto;
    min-width: 0;
    max-width: 100%;
    margin-top: 0; }
  .calendar-event-report.content .benefits-block:not(.benefits-block--expanded) .benefits-uec-top-left-cluster .benefits-uec-payout-lock-wrap {
    margin-left: inherit; }
  .calendar-event-report.content .benefits-block.benefits-block--expanded .benefits-uec-top-left-cluster .benefits-uec-payout-lock-wrap {
    margin-left: inherit; }
  .calendar-event-report.content .benefits-block.benefits-block--expanded .benefits-uec-top-left-cluster .benefits-uec-validate-total-btn,
  .calendar-event-report.content .benefits-block.benefits-block--expanded .benefits-uec-top-left-cluster .benefits-uec-save-benefits-btn {
    white-space: nowrap; }
  .calendar-event-report.content .benefits-block .benefits-uec-payout-lock-wrap .toggle.benefits-uec-payout-lock-toggle-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    width: auto;
    min-width: 0;
    max-width: 100%;
    height: auto;
    bottom: 0;
    position: relative;
    margin: 0;
    text-transform: none;
    font-size: 14px;
    color: #dfdfdf; }
    .calendar-event-report.content .benefits-block .benefits-uec-payout-lock-wrap .toggle.benefits-uec-payout-lock-toggle-row .toggle-label {
      position: static;
      display: inline-flex;
      align-items: center;
      flex: 0 1 auto;
      margin: 0;
      width: auto;
      font-weight: normal;
      font-size: 0.85rem; }
    .calendar-event-report.content .benefits-block .benefits-uec-payout-lock-wrap .toggle.benefits-uec-payout-lock-toggle-row .toggle-switch {
      position: relative;
      top: auto;
      left: auto;
      right: auto;
      bottom: auto;
      margin: 0;
      flex-shrink: 0; }
  .calendar-event-report.content .benefits-block .benefits-uec-row {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 6px; }
  .calendar-event-report.content .benefits-block .benefits-uec-label {
    font-size: 0.85em;
    opacity: 0.9;
    text-transform: uppercase;
    white-space: nowrap; }
  .calendar-event-report.content .benefits-block .benefits-uec-label-sub {
    font-size: 0.85em;
    opacity: 0.85;
    text-transform: capitalize; }
  .calendar-event-report.content .benefits-block .benefits-uec-total-with-share {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 8px;
    min-width: 0; }
  .calendar-event-report.content .benefits-block:not(.benefits-block--expanded) .benefits-uec-total-with-share {
    flex-wrap: nowrap;
    align-items: center; }
  .calendar-event-report.content .benefits-block:not(.benefits-block--expanded) .benefits-uec-total-with-share .benefits-uec-input-shell {
    flex-shrink: 0; }
  .calendar-event-report.content .benefits-block .benefits-uec-org-share-compact {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    flex: 0 1 auto;
    min-width: 0;
    max-width: 100%; }
  .calendar-event-report.content .benefits-block .benefits-uec-org-share-compact__label {
    font-size: 0.72rem;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.55);
    letter-spacing: 0.02em;
    white-space: nowrap; }
  .calendar-event-report.content .benefits-block .benefits-uec-org-share-compact__amount {
    font-size: 0.8rem;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.82);
    white-space: nowrap; }
  .calendar-event-report.content .benefits-block .benefits-uec-input-shell {
    display: flex;
    align-items: stretch;
    width: 200px;
    background: #0c2637;
    border: 1px solid #384858;
    border-radius: 6px;
    overflow: hidden; }
  .calendar-event-report.content .benefits-block .benefits-uec-input-shell.locked {
    opacity: 0.7; }
  .calendar-event-report.content .benefits-block .benefits-uec-input {
    color: #dfdfdf;
    font-size: 15px;
    font-weight: 600;
    flex: 1 1 auto;
    background: #133b53;
    border: 0;
    padding: 5px 10px;
    text-align: left;
    min-width: 0; }
  .calendar-event-report.content .benefits-block .benefits-uec-input.locked {
    cursor: not-allowed; }
  .calendar-event-report.content .benefits-block .benefits-uec-input:focus {
    outline: none; }
  .calendar-event-report.content .benefits-block .benefits-uec-input-unit {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    padding: 5px 10px;
    background: rgba(56, 72, 88, 0.25);
    border-left: 1px solid rgba(56, 72, 88, 0.6);
    color: #dfdfdf;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.02em;
    min-width: 45px;
    user-select: none; }
  .calendar-event-report.content .benefits-block .benefits-uec-hint {
    font-size: 0.9em;
    opacity: 0.85; }
  .calendar-event-report.content .benefits-block .benefits-uec-hint.locked {
    opacity: 0.65; }
  .calendar-event-report.content .benefits-block:not(.benefits-block--expanded) .benefits-org-bank {
    display: none; }
  .calendar-event-report.content .benefits-block:not(.benefits-block--expanded) .benefits-uec-top-right {
    display: none; }
  .calendar-event-report.content .benefits-block:not(.benefits-block--expanded) .benefits-uec-participants-header-left {
    grid-template-columns: minmax(0, 1fr) minmax(88px, 180px) minmax(56px, 72px); }
  .calendar-event-report.content .benefits-block:not(.benefits-block--expanded) .benefits-uec-participants-header-cell:nth-child(4) {
    display: none; }
  .calendar-event-report.content .benefits-block .benefits-org-bank {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #384858;
    border-radius: 6px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    min-width: 0;
    cursor: pointer; }
  .calendar-event-report.content .benefits-block .benefits-org-bank.is-active {
    background: rgba(58, 120, 180, 0.16);
    box-shadow: 0 0 0 2px rgba(58, 120, 180, 0.18); }
  .calendar-event-report.content .benefits-block .benefits-org-bank-start {
    display: flex;
    flex-direction: row;
    align-items: center;
    align-self: start;
    gap: 10px;
    padding: 5px;
    min-width: 0;
    flex: 0 1 auto; }
  .calendar-event-report.content .benefits-block .benefits-org-bank-logo {
    flex: 0 0 auto;
    line-height: 0;
    background: #133b53;
    padding: 5px;
    border: 1px solid #384858;
    border-radius: 6px; }
  .calendar-event-report.content .benefits-block .benefits-org-bank-logo__img {
    display: block;
    width: 28px;
    height: auto;
    max-height: 32px;
    max-width: 36px;
    object-fit: contain;
    filter: grayscale(1) contrast(1.08) brightness(1.05);
    opacity: 0.65; }
  .calendar-event-report.content .benefits-block .benefits-org-bank-left {
    flex: 0 1 auto;
    position: relative;
    z-index: 0;
    display: flex;
    flex-direction: column;
    align-self: start;
    gap: 4px;
    min-width: 0; }
  .calendar-event-report.content .benefits-block .benefits-org-bank-title {
    font-size: 0.8em;
    opacity: 0.9;
    text-transform: uppercase;
    white-space: nowrap; }
  .calendar-event-report.content .benefits-block .benefits-org-bank-title-sub {
    font-size: 0.85em;
    opacity: 0.85;
    text-transform: capitalize; }
  .calendar-event-report.content .benefits-block .benefits-org-bank-amount {
    font-size: 15px;
    font-weight: 600;
    color: #dfdfdf;
    white-space: nowrap; }
  .calendar-event-report.content .benefits-block .benefits-org-bank-right {
    flex: 1 1 0;
    position: relative;
    background: #0c2637;
    border-radius: 8px;
    z-index: 0;
    display: flex;
    justify-content: flex-start;
    min-width: 0; }
  .calendar-event-report.content .benefits-block .benefits-org-bank-loot-placeholder {
    border: 1px dashed rgba(56, 72, 88, 0.8);
    border-radius: 6px;
    padding: 8px 10px;
    min-height: 30px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    opacity: 0.8;
    position: relative;
    z-index: 1;
    overflow: hidden; }
  .calendar-event-report.content .benefits-block .benefits-org-bank-loot-placeholder.is-empty {
    justify-content: center; }
  .calendar-event-report.content .benefits-block .benefits-org-bank-loot-placeholder .benefits-loot-chips,
  .calendar-event-report.content .benefits-block .benefits-org-bank-loot-drop .benefits-loot-chips {
    position: relative;
    z-index: 2; }
  .calendar-event-report.content .benefits-block .benefits-org-bank-loot-drop {
    width: 100%; }
  .calendar-event-report.content .benefits-block .benefits-org-bank.is-dnd-over {
    box-shadow: inset 0 0 0 2px rgba(58, 120, 180, 0.55);
    background: rgba(58, 120, 180, 0.08); }
  .calendar-event-report.content .benefits-block .benefits-org-bank-loot-drop.is-dnd-over {
    box-shadow: inset 0 0 0 2px rgba(58, 120, 180, 0.55);
    background: rgba(58, 120, 180, 0.1); }
  .calendar-event-report.content .benefits-block .benefits-uec-participant.is-dnd-over {
    box-shadow: inset 0 0 0 1px rgba(58, 120, 180, 0.45); }
  .calendar-event-report.content .benefits-block .benefits-uec-summary {
    display: flex;
    flex-direction: column;
    gap: 4px; }
  .calendar-event-report.content .benefits-block .benefits-uec-participants {
    display: flex;
    flex-direction: column;
    gap: 0;
    min-height: 0;
    flex: 1 1 auto; }
  .calendar-event-report.content .benefits-block .benefits-uec-participants-header {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    gap: 12px;
    min-width: 0;
    padding: 8px 10px;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 6px 6px 0 0; }
  .calendar-event-report.content .benefits-block .benefits-uec-participants-header-left {
    flex: 1 1 auto;
    min-width: 0;
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(96px, 200px) 44px minmax(0, 1fr);
    gap: 10px;
    align-items: center;
    padding: 0; }
  .calendar-event-report.content .benefits-block .benefits-uec-participants-header-cell {
    font-size: 0.7em;
    font-weight: 600;
    letter-spacing: 0.04em;
    opacity: 0.9;
    text-transform: uppercase;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; }
  .calendar-event-report.content .benefits-block .benefits-uec-participants-header-cell:nth-child(2) {
    text-align: right; }
  .calendar-event-report.content .benefits-block .benefits-uec-participants-list {
    overflow: auto;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-top: 0;
    border-radius: 0 0 6px 6px;
    padding: 6px 10px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-height: 0;
    background: rgba(0, 0, 0, 0.12); }
    .calendar-event-report.content .benefits-block .benefits-uec-participants-list::-webkit-scrollbar {
      width: 6px; }
    .calendar-event-report.content .benefits-block .benefits-uec-participants-list::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .calendar-event-report.content .benefits-block .benefits-uec-participants-list::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .calendar-event-report.content .benefits-block .benefits-uec-participants-list::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
  .calendar-event-report.content .benefits-block .benefits-uec-participants-list:not(.benefits-uec-participants-list--table) > .benefits-uec-participant {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    cursor: pointer; }
  .calendar-event-report.content .benefits-block .benefits-uec-participants-list:not(.benefits-uec-participants-list--table) > .benefits-uec-participant.is-expanded {
    align-items: flex-start; }
  .calendar-event-report.content .benefits-block .benefits-uec-participant.is-active {
    background: rgba(58, 120, 180, 0.16);
    border-radius: 6px; }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-list--table {
    display: block;
    gap: 0;
    padding: 0;
    overflow: auto;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 6px;
    min-height: 0;
    background: rgba(0, 0, 0, 0.12); }
    .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-list--table::-webkit-scrollbar {
      width: 6px; }
    .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-list--table::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-list--table::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-list--table::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-table tbody tr.benefits-uec-participant {
    display: table-row; }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed; }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-col--identity {
    width: 19%; }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-col--payout {
    width: 14%; }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-col--payoutToggle {
    width: 7%; }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-table--uec-transfer .benefits-uec-participants-col--identity {
    width: 17%; }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-table--uec-transfer .benefits-uec-participants-col--payout {
    width: 12%; }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-table--uec-transfer .benefits-uec-participants-col--payoutToggle {
    width: 6%; }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-col--uecTransfer {
    width: 7%; }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-col--loot {
    width: 60%; }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-table--uec-transfer .benefits-uec-participants-col--loot {
    width: 58%; }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-table thead tr {
    background: rgba(255, 255, 255, 0.04); }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-th {
    padding: 8px 10px;
    text-align: left;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
    font-weight: 600; }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-th--payout {
    text-align: right; }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-th--payoutToggle {
    text-align: center;
    padding-left: 4px;
    padding-right: 4px; }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-table tbody tr.benefits-uec-participant td {
    padding: 8px 10px;
    vertical-align: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08); }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-table tbody tr.benefits-uec-participant:last-child td {
    border-bottom: 0; }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-td--payout {
    text-align: right; }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-td--payoutToggle {
    text-align: center;
    vertical-align: middle;
    padding-left: 4px;
    padding-right: 4px; }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-th--uecTransfer {
    text-align: center;
    padding-left: 4px;
    padding-right: 4px;
    font-size: 11px;
    line-height: 1.2; }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-td--uecTransfer {
    text-align: center;
    vertical-align: middle;
    padding-left: 4px;
    padding-right: 4px; }
  .calendar-event-report.content .benefits-uec-transfer-dash {
    color: rgba(255, 255, 255, 0.3);
    font-weight: 600; }
  .calendar-event-report.content .benefits-loot-chip-row {
    display: inline-flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    gap: 6px;
    max-width: 100%;
    min-width: 0;
    padding-right: 0px; }
  .calendar-event-report.content .benefits-loot-chip-row__chip {
    min-width: 0;
    flex: 1 1 auto; }
  .calendar-event-report.content .benefits-loot-chip-row__toggle {
    flex-shrink: 0; }
  .calendar-event-report.content .benefits-loot-chip-row .sc-item-chip__trailing .toggle-switch-field {
    flex-shrink: 0; }
  .calendar-event-report.content .benefits-loot-chip-row__status {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    font-size: 11px;
    font-weight: 700;
    line-height: 1;
    user-select: none; }
  .calendar-event-report.content .benefits-loot-chip-row__status--not-given {
    color: rgba(255, 255, 255, 0.42);
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.12); }
  .calendar-event-report.content .benefits-loot-chip-row__status--given {
    color: #5aa05c; }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-td--identity,
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-td--loot {
    min-width: 0; }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participants-td--loot {
    min-height: 44px;
    height: 100%; }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participant-loots {
    min-width: 0;
    width: 100%;
    padding-top: 2px; }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participant-loots--empty {
    min-height: 0; }
  .calendar-event-report.content .benefits-block:not(.benefits-block--expanded) .benefits-uec-participant-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(88px, 180px) 44px;
    gap: 10px;
    align-items: center;
    width: 100%;
    min-width: 0; }
  .calendar-event-report.content .benefits-block:not(.benefits-block--expanded) .benefits-uec-participant-cell--payoutToggle {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 0; }
  .calendar-event-report.content .benefits-block:not(.benefits-block--expanded) .benefits-uec-participant-cell--identity {
    min-width: 0; }
  .calendar-event-report.content .benefits-block:not(.benefits-block--expanded) .benefits-uec-participant-cell--payout {
    justify-self: end;
    text-align: right;
    align-self: center; }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participant-identity {
    min-width: 0; }
  .calendar-event-report.content .benefits-block--expanded .benefits-uec-participant-identity .user-discord-rank__name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%; }
  .calendar-event-report.content .benefits-block .benefits-uec-participant-cell.benefits-uec-participant-right {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    gap: 8px;
    flex: 0 0 auto; }
  .calendar-event-report.content .benefits-block .benefits-loot-actions {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    gap: 8px;
    min-width: 0; }
  .calendar-event-report.content .benefits-block .benefits-loot-mention-wrap {
    position: relative;
    flex: 1 1 auto;
    min-width: 0;
    max-width: 320px;
    width: 100%; }
  .calendar-event-report.content .benefits-block .benefits-loot-mention-input-shell {
    display: flex;
    align-items: stretch;
    width: 100%;
    background: #0c2637;
    border: 1px solid #384858;
    border-radius: 6px;
    overflow: hidden; }
  .calendar-event-report.content .benefits-block .benefits-loot-mention-input-shell.locked {
    opacity: 0.7; }
  .calendar-event-report.content .benefits-block .benefits-loot-mention-input-shell .benefits-loot-search-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    padding: 0 10px 0 10px;
    color: #dfdfdf;
    background: #172738; }
  .calendar-event-report.content .benefits-block .benefits-loot-mention-input-shell:focus-within .benefits-loot-search-icon {
    color: rgba(255, 255, 255, 0.62); }
  .calendar-event-report.content .benefits-block .benefits-loot-mention-input-shell .benefits-loot-search-icon__svg {
    display: block;
    width: 16px;
    height: 16px; }
  .calendar-event-report.content .benefits-block .benefits-loot-mention-input-shell .benefits-loot-search-input {
    width: 100%;
    box-sizing: border-box;
    flex: 1 1 auto;
    min-width: 0;
    background: #133b53;
    border: 0;
    border-radius: 0;
    padding: 7px 10px 7px 7px;
    color: #dfdfdf;
    font-size: 15px;
    font-weight: 600;
    text-align: left; }
  .calendar-event-report.content .benefits-block .benefits-loot-mention-input-shell .benefits-loot-search-input:focus {
    outline: none; }
  .calendar-event-report.content .benefits-block .benefits-loot-search-hint {
    margin-top: 4px;
    font-size: 11px;
    opacity: 0.75; }
  .calendar-event-report.content .benefits-block .benefits-loot-mention-wrap .mention-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    margin: 4px 0 0 0;
    padding: 0;
    list-style: none;
    background: rgba(12, 38, 55, 0.98);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 6px;
    max-height: 220px;
    overflow-y: auto;
    z-index: 10050; }
    .calendar-event-report.content .benefits-block .benefits-loot-mention-wrap .mention-dropdown::-webkit-scrollbar {
      width: 6px; }
    .calendar-event-report.content .benefits-block .benefits-loot-mention-wrap .mention-dropdown::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .calendar-event-report.content .benefits-block .benefits-loot-mention-wrap .mention-dropdown::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .calendar-event-report.content .benefits-block .benefits-loot-mention-wrap .mention-dropdown::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
  .calendar-event-report.content .benefits-block .benefits-loot-mention-wrap .mention-dropdown .dropdown-item {
    display: flex;
    align-items: flex-start;
    padding: 6px 10px;
    cursor: pointer;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06); }
    .calendar-event-report.content .benefits-block .benefits-loot-mention-wrap .mention-dropdown .dropdown-item:last-child {
      border-bottom: none; }
    .calendar-event-report.content .benefits-block .benefits-loot-mention-wrap .mention-dropdown .dropdown-item.selected {
      background-color: rgba(58, 120, 180, 0.22); }
    .calendar-event-report.content .benefits-block .benefits-loot-mention-wrap .mention-dropdown .dropdown-item:hover {
      background-color: rgba(255, 255, 255, 0.06); }
    .calendar-event-report.content .benefits-block .benefits-loot-mention-wrap .mention-dropdown .dropdown-item .mention-name {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 2px;
      line-height: 1.25;
      min-width: 0; }
    .calendar-event-report.content .benefits-block .benefits-loot-mention-wrap .mention-dropdown .dropdown-item .benefits-loot-dd-label {
      font-size: 13px;
      color: rgba(255, 255, 255, 0.92);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 100%; }
    .calendar-event-report.content .benefits-block .benefits-loot-mention-wrap .mention-dropdown .dropdown-item .benefits-loot-dd-meta {
      font-size: 11px;
      color: rgba(255, 255, 255, 0.55);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 100%; }
  .calendar-event-report.content .benefits-block .benefits-loot-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    align-items: center;
    min-width: 0; }
  .calendar-event-report.content .benefits-block .benefits-loot-chip-dnd {
    display: inline-flex;
    flex-direction: row;
    align-items: stretch;
    min-width: 0;
    vertical-align: top; }
  .calendar-event-report.content .benefits-block .benefits-loot-chip-dnd__surface {
    display: inline-flex;
    flex-direction: row;
    align-items: stretch;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
    border: 1px solid #9D7BFF;
    border-radius: 6px;
    background: #0B1016;
    overflow: hidden; }
  .calendar-event-report.content .benefits-block .benefits-loot-chip-dnd--overlay {
    cursor: grabbing; }
  .calendar-event-report.content .benefits-block .benefits-loot-chip-dnd.is-benefits-dragging {
    opacity: 0; }
  .calendar-event-report.content .benefits-block .benefits-loot-chip-dnd__handle {
    flex: 0 0 auto;
    width: 21px;
    min-width: 21px;
    margin: 0;
    padding: 0px 3px 0px 7px;
    border: 0;
    border-right: 1px solid rgba(255, 255, 255, 0.1);
    align-self: stretch;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: grab;
    color: rgba(255, 255, 255, 0.45);
    background: linear-gradient(90deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.05) 100%); }
  .calendar-event-report.content .benefits-block .benefits-loot-chip-dnd--overlay .benefits-loot-chip-dnd__handle {
    cursor: grabbing; }
  .calendar-event-report.content .benefits-block .benefits-loot-chip-dnd__handle::before {
    content: "";
    display: block;
    width: 4px;
    height: 12px;
    border-left: 1px solid currentColor;
    border-right: 1px solid currentColor;
    background: linear-gradient(180deg, currentColor, currentColor) center/1px 100% no-repeat; }
  .calendar-event-report.content .benefits-block .benefits-loot-chip-dnd__handle:hover,
  .calendar-event-report.content .benefits-block .benefits-loot-chip-dnd__handle:focus-visible {
    color: rgba(255, 255, 255, 0.75);
    background: linear-gradient(90deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.05) 100%); }
  .calendar-event-report.content .benefits-block .benefits-loot-chip-dnd__handle:active {
    cursor: grabbing; }
  .calendar-event-report.content .benefits-block .benefits-loot-chip-dnd__chip {
    min-width: 0;
    flex: 1 1 auto;
    display: flex;
    align-items: stretch; }
  .calendar-event-report.content .benefits-block .benefits-loot-chip-dnd__chip .benefits-loot-chip-row .sc-item-chip {
    border: 0;
    border-radius: 0;
    background: transparent;
    max-width: 100%; }
  .calendar-event-report.content .benefits-block .benefits-loot-chip-dnd__chip .sc-item-chip__trigger {
    flex-wrap: wrap;
    row-gap: 2px; }
  .calendar-event-report.content .benefits-block .benefits-uec-participant-left {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    flex: 1 1 auto; }
  .calendar-event-report.content .benefits-block .benefits-uec-participant-share {
    white-space: nowrap;
    opacity: 0.95; }
  .calendar-event-report.content .header-with-toggle {
    display: flex; }
    .calendar-event-report.content .header-with-toggle .h2-custom {
      text-transform: uppercase;
      margin-block-start: 0.3em;
      margin-block-end: 0em;
      margin-left: 10px; }
    .calendar-event-report.content .header-with-toggle .input-field.toggle-inline {
      display: flex;
      margin: auto 10px auto auto;
      align-items: center; }
      .calendar-event-report.content .header-with-toggle .input-field.toggle-inline .toggle-label {
        text-transform: uppercase;
        font-size: 0.8em;
        font-weight: 600;
        position: relative;
        top: 7px;
        margin-right: 10px; }
  .calendar-event-report.content .event-details.time {
    display: flex;
    gap: 20px;
    height: 175px;
    width: 100%;
    border: 1px solid;
    border-color: #b8b8b8;
    border-radius: 8px;
    background-color: #0c2637; }
    .calendar-event-report.content .event-details.time .column {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      padding: 10px;
      box-sizing: border-box; }
      .calendar-event-report.content .event-details.time .column:first-child {
        min-width: 0;
        flex-grow: 1; }
      .calendar-event-report.content .event-details.time .column:last-child {
        flex-basis: 350px;
        flex-shrink: 0; }
      .calendar-event-report.content .event-details.time .column .calendar-icon {
        width: auto;
        height: 15px;
        margin-right: 10px;
        vertical-align: middle; }
      .calendar-event-report.content .event-details.time .column .recurrence-item {
        display: flex;
        align-items: flex-start; }
        .calendar-event-report.content .event-details.time .column .recurrence-item .calendar-icon {
          width: auto;
          height: 15px;
          margin-right: 10px; }
        .calendar-event-report.content .event-details.time .column .recurrence-item p {
          margin: 0; }
  .calendar-event-report.content .conditional-bloc.row {
    display: flex;
    gap: 10px;
    width: 100%; }
    .calendar-event-report.content .conditional-bloc.row .joined-operation {
      background-color: #1c2d38;
      border: 1px solid #b8b8b8;
      border-radius: 6px;
      min-width: 49%;
      width: 100%; }
      .calendar-event-report.content .conditional-bloc.row .joined-operation .joined-operation-header {
        display: flex;
        flex-direction: row;
        color: #dfdfdf; }
        .calendar-event-report.content .conditional-bloc.row .joined-operation .joined-operation-header .calendar-icon {
          position: relative;
          width: auto;
          height: 18px;
          margin-right: 8px;
          margin-left: 10px;
          vertical-align: middle;
          top: 15px; }
        .calendar-event-report.content .conditional-bloc.row .joined-operation .joined-operation-header .joined {
          color: #dfdfdf; }
      .calendar-event-report.content .conditional-bloc.row .joined-operation .alliance-list {
        max-height: 85px;
        padding: 5px 0px 10px;
        overflow: auto; }
        .calendar-event-report.content .conditional-bloc.row .joined-operation .alliance-list::-webkit-scrollbar {
          width: 6px; }
        .calendar-event-report.content .conditional-bloc.row .joined-operation .alliance-list::-webkit-scrollbar-track {
          background: #2e3842;
          border-radius: 4px;
          padding-right: 1px; }
        .calendar-event-report.content .conditional-bloc.row .joined-operation .alliance-list::-webkit-scrollbar-thumb {
          background-color: #491212;
          border-radius: 4px; }
          .calendar-event-report.content .conditional-bloc.row .joined-operation .alliance-list::-webkit-scrollbar-thumb:hover {
            background-color: #200808; }
        .calendar-event-report.content .conditional-bloc.row .joined-operation .alliance-list .participant-item {
          display: flex;
          align-items: center;
          margin: 3px 0px 3px 0px; }
          .calendar-event-report.content .conditional-bloc.row .joined-operation .alliance-list .participant-item .participant-logo {
            position: relative;
            height: 20px;
            width: auto;
            margin: 0px 10px 0px 35px; }
          .calendar-event-report.content .conditional-bloc.row .joined-operation .alliance-list .participant-item .alliance-name {
            margin-top: 0; }
    .calendar-event-report.content .conditional-bloc.row .operation-incomes {
      background-color: #1c2d38;
      border: 1px solid #b8b8b8;
      border-radius: 6px;
      min-width: 49%;
      width: 100%; }
      .calendar-event-report.content .conditional-bloc.row .operation-incomes .operation-incomes-header {
        display: flex;
        flex-direction: row;
        color: #dfdfdf; }
        .calendar-event-report.content .conditional-bloc.row .operation-incomes .operation-incomes-header .calendar-icon {
          position: relative;
          width: auto;
          height: 18px;
          margin-right: 8px;
          margin-left: 10px;
          top: 15px; }
        .calendar-event-report.content .conditional-bloc.row .operation-incomes .operation-incomes-header .incomes {
          color: #dfdfdf; }
      .calendar-event-report.content .conditional-bloc.row .operation-incomes .incomes-details {
        max-height: 85px;
        padding: 10px 35px 10px; }
        .calendar-event-report.content .conditional-bloc.row .operation-incomes .incomes-details .income-input-wrapper {
          position: relative;
          display: inline-block; }
          .calendar-event-report.content .conditional-bloc.row .operation-incomes .incomes-details .income-input-wrapper .income-input {
            padding-right: 25px; }
          .calendar-event-report.content .conditional-bloc.row .operation-incomes .incomes-details .income-input-wrapper .uec-icon-input {
            position: absolute;
            right: 5px;
            top: 50%;
            transform: translateY(-50%);
            width: 15px;
            height: 15px; }
        .calendar-event-report.content .conditional-bloc.row .operation-incomes .incomes-details .income-percentage {
          margin-top: 0px;
          padding: 7px 0px 0px; }
        .calendar-event-report.content .conditional-bloc.row .operation-incomes .incomes-details .uec-icon-percentage {
          position: relative;
          width: 15px;
          height: 15px;
          margin-left: 5px;
          top: 2px; }
  .calendar-event-report.content .participants {
    background: #0c2637;
    border: 1px solid #b8b8b8;
    border-radius: 6px; }
    .calendar-event-report.content .participants .participant-count {
      display: flex;
      flex-direction: row; }
      .calendar-event-report.content .participants .participant-count .css-b62m3t-container {
        margin-left: auto; }
      .calendar-event-report.content .participants .participant-count .react-select-input__control {
        margin-top: 15px;
        margin-right: 10px;
        margin-left: auto; }
      .calendar-event-report.content .participants .participant-count .count {
        color: #dfdfdf;
        position: relative;
        top: 17px; }
      .calendar-event-report.content .participants .participant-count .participant-select-container {
        display: flex;
        flex-direction: row;
        margin-left: auto;
        margin-right: 10px; }
        .calendar-event-report.content .participants .participant-count .participant-select-container .add-participant-button {
          position: relative;
          top: 15px; }
          .calendar-event-report.content .participants .participant-count .participant-select-container .add-participant-button .add-icon {
            height: 20px;
            width: auto; }
      .calendar-event-report.content .participants .participant-count .calendar-icon {
        position: relative;
        width: auto;
        height: 18px;
        margin-right: 8px;
        margin-left: 10px;
        vertical-align: middle;
        top: 15px; }
    .calendar-event-report.content .participants .participants-list {
      display: grid;
      padding: 1em;
      grid-template-columns: repeat(auto-fit, minmax(205px, 0fr));
      place-content: start;
      overflow-y: auto;
      height: 160px; }
      .calendar-event-report.content .participants .participants-list::-webkit-scrollbar {
        width: 6px; }
      .calendar-event-report.content .participants .participants-list::-webkit-scrollbar-track {
        background: #2e3842;
        border-radius: 4px;
        padding-right: 1px; }
      .calendar-event-report.content .participants .participants-list::-webkit-scrollbar-thumb {
        background-color: #491212;
        border-radius: 4px; }
        .calendar-event-report.content .participants .participants-list::-webkit-scrollbar-thumb:hover {
          background-color: #200808; }
      .calendar-event-report.content .participants .participants-list .participant-item {
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        position: relative;
        padding: 0 0.5em;
        cursor: pointer; }
        .calendar-event-report.content .participants .participants-list .participant-item.deselected {
          opacity: 0.55; }
          .calendar-event-report.content .participants .participants-list .participant-item.deselected .scrollable-label {
            text-decoration: line-through;
            text-decoration-thickness: 2px;
            text-decoration-color: rgba(223, 223, 223, 0.75); }
        .calendar-event-report.content .participants .participants-list .participant-item:hover {
          color: white;
          cursor: pointer; }
        .calendar-event-report.content .participants .participants-list .participant-item .discord-avatar {
          width: 20px;
          height: 20px;
          margin-right: 10px;
          border-radius: 50%; }
        .calendar-event-report.content .participants .participants-list .participant-item .scrollable-label {
          display: inline-block;
          max-width: 110px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          position: relative; }
          .calendar-event-report.content .participants .participants-list .participant-item .scrollable-label.scroll:hover {
            max-width: 110px;
            overflow: hidden;
            text-overflow: unset;
            animation: scrollText 5s linear infinite; }

@keyframes scrollText {
  0% {
    transform: translateX(0); }
  100% {
    transform: translateX(-100%); } }
        .calendar-event-report.content .participants .participants-list .participant-item .ribbons-icon {
          height: 40px;
          object-fit: contain;
          margin-right: 0px;
          position: relative;
          margin-left: auto;
          top: -8px;
          clip-path: inset(50% 0 0 0); }
          .calendar-event-report.content .participants .participants-list .participant-item .ribbons-icon:hover {
            top: 12px;
            clip-path: inset(0 0 50% 0); }
          .calendar-event-report.content .participants .participants-list .participant-item .ribbons-icon.disabled {
            pointer-events: none;
            cursor: not-allowed;
            opacity: 0.5; }
          .calendar-event-report.content .participants .participants-list .participant-item .ribbons-icon.has-ribbons {
            top: 12px;
            clip-path: inset(0 0 50% 0); }
        .calendar-event-report.content .participants .participants-list .participant-item.deselected {
          color: #d12323;
          opacity: 0.5;
          text-decoration: line-through; }
          .calendar-event-report.content .participants .participants-list .participant-item.deselected .discord-avatar {
            width: auto;
            height: 18px;
            border: 1px solid #d12323; }
          .calendar-event-report.content .participants .participants-list .participant-item.deselected .ribbons-icon {
            pointer-events: none;
            cursor: not-allowed;
            opacity: 0.5; }
        .calendar-event-report.content .participants .participants-list .participant-item.added {
          color: #008000;
          opacity: 1; }
        .calendar-event-report.content .participants .participants-list .participant-item::after {
          content: "";
          position: absolute;
          right: 0;
          top: 0;
          height: 100%;
          width: 1px;
          background: #b8b8b8; }
      .calendar-event-report.content .participants .participants-list .participant-item:nth-child(5n)::after {
        display: none; }

.calendar-event-report.footer {
  background-color: #163447;
  padding: 15px;
  border-radius: 0px 0px 8px 8px; }
  .calendar-event-report.footer .btn-style1 + .btn-style1 {
    margin-left: 20px; }

.benefits-block .benefits-block-header {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.55rem; }

.benefits-block .benefits-block-manage-auction-btn {
  margin-left: auto; }

.benefits-block .benefits-block-header:has(.benefits-block-expand-toggle) .benefits-block-manage-auction-btn {
  margin-right: 1.75rem; }

.benefits-block .benefits-block-header-box-icon {
  width: 18px;
  height: 18px;
  object-fit: contain;
  flex-shrink: 0;
  opacity: 0.92; }

.benefits-block .benefits-block-expand-toggle {
  position: absolute;
  top: -5px;
  right: -2px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  margin: 0;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: background 160ms ease, border-color 160ms ease, transform 160ms ease; }

.benefits-block .benefits-block-expand-toggle:hover {
  background: rgba(0, 0, 0, 0.38);
  border-color: #b8b8b8; }

.benefits-block .benefits-block-expand-toggle__icon {
  display: block;
  width: 14px;
  height: 14px;
  object-fit: contain;
  opacity: 0.95; }

.benefits-block .benefits-uec-payout-header {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  width: 100%;
  min-width: 0; }

.benefits-block .benefits-uec-payout-header__title {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-width: 0; }

.benefits-block .benefits-uec-payout-header__lock-wrap {
  display: inline-flex;
  flex-shrink: 0;
  color: rgba(255, 255, 255, 0.88); }

.benefits-block .benefits-uec-payout-header__lock-icon {
  display: block;
  width: 14px;
  height: 14px;
  object-fit: contain; }

.benefits-block--payment-completed .benefits-uec-participants-th--payout,
.benefits-block--payment-completed .benefits-uec-participants-td--payout,
.benefits-block--payment-completed .benefits-uec-participants-header-cell--payout-label,
.benefits-block--payment-completed .benefits-uec-participant-cell--payout {
  opacity: 0.7; }

.benefits-block .benefits-uec-claimed-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.25em;
  font-size: 1.05em;
  line-height: 1;
  font-weight: 600; }

.benefits-block .benefits-uec-claimed-mark--report-yes {
  color: #75cf78; }

.benefits-block .benefits-uec-claimed-mark--report-no {
  color: #d12323; }

.benefits-block .benefits-uec-claimed-mark--calendar-yes {
  color: #384858; }

.benefits-block .benefits-uec-claimed-mark--calendar-no {
  color: rgba(56, 72, 88, 0.72); }

.benefits-block .benefits-uec-claimed-mark--uec-sent-yes {
  color: #75cf78;
  font-size: 1.15em; }

.benefits-block .benefits-uec-claimed-mark--auto-yes,
.benefits-block .benefits-uec-transfer-mark--auto-yes {
  color: #75cf78;
  font-size: 1.15em;
  font-weight: 600; }

.benefits-block .benefits-uec-payout-header__label {
  text-transform: inherit;
  letter-spacing: inherit; }

.benefits-block .benefits-uec-payout-help {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  z-index: 30; }

.benefits-block .benefits-uec-payout-help__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  margin: 0;
  border: 1px solid rgba(255, 255, 255, 0.42);
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.28);
  color: rgba(255, 255, 255, 0.88);
  cursor: pointer;
  line-height: 1; }

.benefits-block .benefits-uec-payout-help__btn:hover,
.benefits-block .benefits-uec-payout-help__btn:focus-visible {
  border-color: rgba(255, 255, 255, 0.72);
  color: #fff;
  outline: none; }

.benefits-block .benefits-uec-payout-help__i {
  font-size: 0.62rem;
  font-weight: 700;
  font-style: italic;
  transform: translateY(0.5px); }

.benefits-block .benefits-uec-participants-header-cell--payoutToggle {
  min-width: 36px;
  text-align: center; }

.benefits-block .benefits-uec-payout-toggle--mini.field-input.toggle {
  display: inline-flex;
  width: auto;
  min-width: 0;
  max-width: 100%;
  justify-content: center;
  align-items: center;
  position: relative;
  bottom: 0;
  margin: 0; }
  .benefits-block .benefits-uec-payout-toggle--mini.field-input.toggle .toggle-switch {
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    margin-left: 0; }

.benefits-block .benefits-uec-participants-header-cell--payout-label {
  overflow: visible;
  white-space: normal; }

.benefits-block--expanded .benefits-uec-participants-th--payout {
  overflow: visible; }

.benefits-uec-payout-help__tip--portal {
  position: fixed;
  z-index: 10100;
  box-sizing: border-box;
  margin: 0;
  width: max-content;
  max-width: 260px;
  padding: 8px 10px;
  border-radius: 6px;
  font-size: 0.72rem;
  font-weight: 500;
  line-height: 1.35;
  text-align: left;
  text-transform: none;
  letter-spacing: normal;
  color: #dfdfdf;
  background: rgba(20, 26, 32, 0.98);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.5);
  pointer-events: auto; }

.content.calendar-event .objectives-benefits-row {
  display: flex;
  gap: 10px;
  width: 100%;
  align-items: stretch; }
  .content.calendar-event .objectives-benefits-row > .event-objectives-view,
  .content.calendar-event .objectives-benefits-row > .benefits-block {
    flex: 1 1 0;
    min-width: 0; }
  .content.calendar-event .objectives-benefits-row .benefits-block:not(.benefits-block--event-modal-readonly) {
    background-color: #0c2637;
    border: 1px solid #dfdfdf;
    border-radius: 8px;
    padding: 10px;
    display: flex;
    flex-direction: column; }
    .content.calendar-event .objectives-benefits-row .benefits-block:not(.benefits-block--event-modal-readonly) .benefits-block-header {
      display: flex;
      align-items: center;
      gap: 8px;
      text-transform: uppercase;
      font-size: 0.85em;
      opacity: 0.9;
      margin-bottom: 10px; }
    .content.calendar-event .objectives-benefits-row .benefits-block:not(.benefits-block--event-modal-readonly) .benefits-block-body {
      padding: 10px 10px 10px 20px;
      flex: 1 1 auto; }
    .content.calendar-event .objectives-benefits-row .benefits-block:not(.benefits-block--event-modal-readonly) .benefits-line {
      opacity: 0.85;
      font-size: 0.9em; }

.content.calendar-event .calendar-event-benefits-expansion-shell {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%; }
  .content.calendar-event .calendar-event-benefits-expansion-shell.is-expanded {
    min-height: clamp(340px, 40vh, 720px); }
    .content.calendar-event .calendar-event-benefits-expansion-shell.is-expanded .calendar-event-benefits-expansion-row {
      opacity: 0;
      pointer-events: none;
      user-select: none;
      position: relative; }

.content.calendar-event .calendar-event-benefits-expansion-row {
  display: flex;
  gap: 10px;
  width: 100%;
  align-items: stretch; }
  .content.calendar-event .calendar-event-benefits-expansion-row > .calendar-event-benefits-expansion-objectives,
  .content.calendar-event .calendar-event-benefits-expansion-row > .calendar-event-benefits-expansion-slot-benefits {
    flex: 1 1 0;
    min-width: 0; }

.content.calendar-event .calendar-event-benefits-expansion-objectives {
  flex: 1 1 0;
  min-width: 0;
  display: flex; }

.content.calendar-event .calendar-event-benefits-expansion-objectives > .objectives-report-block.objectives-report-block--in-calendar-event {
  flex: 1 1 0;
  min-width: 0; }

.content.calendar-event .calendar-event-benefits-expansion-slot-benefits {
  flex: 1 1 0;
  min-width: 0;
  display: flex; }

.content.calendar-event .calendar-event-benefits-expansion-placeholder {
  flex: 1 1 0;
  min-width: 0;
  min-height: 260px;
  box-sizing: border-box; }

.content.calendar-event .calendar-event-benefits-expansion-overlay {
  position: absolute;
  inset: 0;
  z-index: 5;
  pointer-events: none;
  opacity: 0;
  transform: scale(0.985);
  transition: opacity 180ms ease, transform 180ms ease;
  width: 100%;
  height: 100%; }

.content.calendar-event .calendar-event-benefits-expansion-shell.is-expanded-benefits .calendar-event-benefits-expansion-overlay,
.content.calendar-event .calendar-event-benefits-expansion-shell.is-expanded-objectives .calendar-event-benefits-expansion-overlay,
.content.calendar-event .calendar-event-benefits-expansion-shell.is-expanded-auction .calendar-event-benefits-expansion-overlay {
  opacity: 1;
  transform: scale(1);
  pointer-events: auto; }

.content.calendar-event .calendar-event-benefits-expansion-overlay .objectives-report-block.objectives-report-block--in-calendar-event {
  height: 100%;
  max-height: 100%;
  box-sizing: border-box;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.45); }

.block-icon {
  width: 18px;
  height: 18px;
  object-fit: contain;
  flex: 0 0 auto; }

.occurrence-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
  gap: 5px; }
  .occurrence-item .event-time {
    display: flex;
    flex-direction: row;
    margin: 5px 0; }
    .occurrence-item .event-time .calendar-icon {
      width: auto;
      height: 18px;
      margin-right: 8px;
      vertical-align: middle; }
    .occurrence-item .event-time .dates-time {
      display: flex;
      flex-direction: column;
      gap: 0px; }
    .occurrence-item .event-time .date-time-selector .react-datepicker__input-container input {
      display: flex;
      flex-direction: column;
      width: 125px;
      margin: 0px 0; }
    .occurrence-item .event-time p {
      margin: 3px 0; }
  .occurrence-item .event-link {
    display: flex;
    flex-direction: row;
    margin: 0;
    cursor: pointer;
    align-items: center;
    transition: color 0.2s ease; }
    .occurrence-item .event-link .link-chain-icon {
      height: 15px;
      width: auto;
      margin-right: 10px;
      transition: transform 0.2s ease, filter 0.2s ease; }
    .occurrence-item .event-link .link-chain-icon--copied {
      filter: brightness(0) saturate(100%) invert(62%) sepia(18%) saturate(864%) hue-rotate(82deg) brightness(95%);
      transform: scale(1.08); }
    .occurrence-item .event-link .link-text {
      margin: 0px;
      cursor: pointer; }
      .occurrence-item .event-link .link-text:hover {
        color: white; }
    .occurrence-item .event-link--copied .link-text strong {
      color: #5aa05c; }

.recurrence-item .react-datepicker-wrapper .react-datepicker__input-container input {
  width: 70px; }

.discord-tooltip {
  color: red;
  background: #2a3847;
  padding: 3px;
  border: 1px solid #9e2222;
  border-radius: 6px; }

.tooltip-item {
  display: flex;
  position: relative;
  bottom: 0px;
  height: 25px; }
  .tooltip-item .calendar-icon {
    position: relative;
    width: auto;
    height: 16px;
    margin-right: 6px;
    top: 5px; }
  .tooltip-item p {
    margin-top: auto; }

.tooltip1 {
  font-size: 0.8em; }

.calendar-event.type {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 5px; }
  .calendar-event.type .type-item {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 8px;
    margin-left: 5px; }
    .calendar-event.type .type-item .type-item__icon {
      flex: 0 0 auto;
      width: auto;
      height: 16px;
      margin-top: 2px; }
    .calendar-event.type .type-item .type-item__content {
      display: flex;
      flex-direction: column;
      gap: 5px;
      min-width: 0; }
    .calendar-event.type .type-item .type-subtype {
      display: flex;
      flex-direction: row;
      gap: 5px; }
    .calendar-event.type .type-item .division-section {
      display: flex;
      flex-direction: row;
      gap: 5px; }
      .calendar-event.type .type-item .division-section .combined-arms-tooltip {
        font-style: oblique;
        position: relative;
        cursor: help; }
        .calendar-event.type .type-item .division-section .combined-arms-tooltip:hover .tooltip-content {
          display: block; }
        .calendar-event.type .type-item .division-section .combined-arms-tooltip .tooltip-content {
          display: none;
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          background-color: #1c2d38;
          border: 1px solid #491212;
          border-radius: 6px;
          padding: 10px;
          z-index: 1000;
          width: 300px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.6);
          white-space: nowrap; }
          .calendar-event.type .type-item .division-section .combined-arms-tooltip .tooltip-content .combined-arms-tooltip-title {
            color: white;
            font-weight: bolder;
            text-transform: uppercase;
            font-size: 0.8em;
            margin-bottom: 5px; }
          .calendar-event.type .type-item .division-section .combined-arms-tooltip .tooltip-content .division-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 3px 0; }
            .calendar-event.type .type-item .division-section .combined-arms-tooltip .tooltip-content .division-row .branch-column,
            .calendar-event.type .type-item .division-section .combined-arms-tooltip .tooltip-content .division-row .section-column {
              flex: 1;
              text-align: left; }
            .calendar-event.type .type-item .division-section .combined-arms-tooltip .tooltip-content .division-row .divisions-separator {
              width: 1%;
              text-align: center;
              padding: 0 5px;
              white-space: nowrap; }
      .calendar-event.type .type-item .division-section p {
        margin: 3px 0; }
  .calendar-event.type .org-share {
    display: flex;
    flex-direction: row; }
    .calendar-event.type .org-share .org-share-information {
      margin: 3px 0; }
    .calendar-event.type .org-share .uec {
      position: relative;
      width: 15px;
      top: 4px; }
  .calendar-event.type .voice-info {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 8px;
    margin-left: 5px; }
    .calendar-event.type .voice-info .voice-info__icon {
      flex: 0 0 auto;
      width: auto;
      height: 16px;
      margin-top: 2px; }
    .calendar-event.type .voice-info .voice-channel {
      display: flex;
      flex-direction: column;
      gap: 5px;
      min-width: 0; }
      .calendar-event.type .voice-info .voice-channel p {
        margin: 3px 0; }
      .calendar-event.type .voice-info .voice-channel .react-select-input__control {
        min-height: 28px;
        min-width: 0 !important;
        max-width: 100%; }
  .calendar-event.type .location-item {
    display: flex;
    justify-content: flex-start;
    margin-left: 5px;
    color: #b8b8b8; }
    .calendar-event.type .location-item .field-input {
      padding: 3px 5px 3px 5px; }
    .calendar-event.type .location-item .calendar-icon {
      width: auto;
      height: 15px;
      margin-right: 10px; }
    .calendar-event.type .location-item p {
      margin: 0; }
  .calendar-event.type .clearance-item {
    display: flex;
    justify-content: flex-start;
    height: 25px;
    align-items: center;
    margin-top: 0px; }
    .calendar-event.type .clearance-item .field-input {
      padding: 3px 5px 3px 5px; }
    .calendar-event.type .clearance-item .calendar-icon {
      width: auto;
      height: 15px;
      margin-right: 10px; }
    .calendar-event.type .clearance-item p {
      margin: 0; }

.calendar-event.title {
  display: flex;
  align-items: center;
  margin-right: 0px;
  margin-left: auto;
  margin-bottom: 10px;
  gap: 5px; }
  .calendar-event.title .title {
    font-weight: bold;
    text-transform: uppercase;
    margin: 5px 10px; }
  .calendar-event.title .edit-mode {
    display: flex;
    gap: 10px;
    margin-right: 0px;
    margin-left: auto; }

.calendar-event.status {
  width: max-content;
  min-width: 80px;
  height: max-content;
  padding: 5px 5px;
  border-radius: 5px;
  text-align: center;
  font-weight: bold;
  font-size: 0.7em;
  text-transform: uppercase;
  margin: 0px 20px 5px 20px;
  border: 2px solid #0c2637;
  box-shadow: 0px 0px 5px 2px #292a2bed;
  transition: all 0.3s ease; }
  .calendar-event.status.canceled {
    background-color: #9e2222;
    color: #b8b8b8; }
  .calendar-event.status.tentative {
    background-color: #b8a500;
    color: #2a3847; }
  .calendar-event.status.scheduled {
    background-color: #166316;
    color: #dfdfdf; }
  .calendar-event.status.live {
    background-color: #8b590d;
    color: #dfdfdf; }
  .calendar-event.status.live-button {
    background-color: #8b590d;
    color: #dfdfdf;
    border: 2px solid #8b590d;
    transition: all 0.3s ease;
    cursor: pointer; }
    .calendar-event.status.live-button:hover {
      background-color: #5c3b09;
      color: #b8b8b8;
      transform: scale(1.1); }
  .calendar-event.status.concluded {
    background-color: #2a3847;
    color: #b8b8b8; }

.delete-event-modal .modal-content .header, .confirm-conclude-modal .modal-content .header {
  display: flex;
  justify-content: space-between;
  color: #dfdfdf;
  text-transform: uppercase;
  font-weight: bold;
  align-items: center;
  padding: 5px 10px;
  border-bottom: 2px solid #2a3847;
  border-radius: 8px 8px 0px 0px;
  background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___}); }

.delete-event-modal .modal-content .content, .confirm-conclude-modal .modal-content .content {
  background-color: #27333f;
  padding: 15px; }
  .delete-event-modal .modal-content .content .field-input, .confirm-conclude-modal .modal-content .content .field-input {
    height: 30px;
    max-width: -webkit-fill-available;
    min-width: -webkit-fill-available; }

.delete-event-modal .modal-content .footer, .confirm-conclude-modal .modal-content .footer {
  display: flex;
  justify-content: flex-end;
  background-color: #0c2637;
  padding: 10px;
  border-radius: 0 0 8px 8px;
  gap: 10px; }
  .delete-event-modal .modal-content .footer .btn-style1, .confirm-conclude-modal .modal-content .footer .btn-style1 {
    margin: 0; }

.content.calendar-event {
  background-color: #163447;
  padding: 0 15px; }
  .content.calendar-event .calendar-event-accordion {
    padding: 10px;
    background-color: #0c2637;
    border: 1px solid #b8b8b8;
    border-radius: 8px; }
  .content.calendar-event .calendar-event-accordion-section {
    border-top: 1px solid rgba(255, 255, 255, 0.08); }
    .content.calendar-event .calendar-event-accordion-section:first-child {
      border-top: none; }
  .content.calendar-event .calendar-event-accordion-toggle {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 10px 8px;
    background: transparent;
    border: none;
    color: inherit;
    cursor: pointer; }
    .content.calendar-event .calendar-event-accordion-toggle:hover {
      background-color: rgba(255, 255, 255, 0.04); }
    .content.calendar-event .calendar-event-accordion-toggle .calendar-event-accordion-toggle-left {
      display: inline-flex;
      align-items: center;
      gap: 10px;
      min-width: 0; }
    .content.calendar-event .calendar-event-accordion-toggle .calendar-icon {
      width: auto;
      height: 15px; }
  .content.calendar-event .calendar-event-accordion-caret {
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 8px solid rgba(255, 255, 255, 0.7);
    transition: transform 180ms ease;
    flex: 0 0 auto; }
  .content.calendar-event .calendar-event-accordion-toggle.is-open .calendar-event-accordion-caret {
    transform: rotate(180deg); }
  .content.calendar-event .calendar-event-accordion-panel .event-report-content,
  .content.calendar-event .calendar-event-accordion-panel .description-content {
    padding: 0px 25px; }
  .content.calendar-event .calendar-event-accordion-panel .event-report-content {
    max-height: 500px;
    overflow: auto; }
    .content.calendar-event .calendar-event-accordion-panel .event-report-content::-webkit-scrollbar {
      width: 6px; }
    .content.calendar-event .calendar-event-accordion-panel .event-report-content::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .content.calendar-event .calendar-event-accordion-panel .event-report-content::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .content.calendar-event .calendar-event-accordion-panel .event-report-content::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
  .content.calendar-event .calendar-event-accordion-panel-anim {
    overflow: hidden;
    max-height: 0;
    opacity: 0;
    transition: max-height 220ms ease, opacity 180ms ease; }
    .content.calendar-event .calendar-event-accordion-panel-anim.is-open {
      max-height: calc(100vh - 600px);
      opacity: 1;
      overflow-y: scroll; }
      .content.calendar-event .calendar-event-accordion-panel-anim.is-open::-webkit-scrollbar {
        width: 6px; }
      .content.calendar-event .calendar-event-accordion-panel-anim.is-open::-webkit-scrollbar-track {
        background: #2e3842;
        border-radius: 4px;
        padding-right: 1px; }
      .content.calendar-event .calendar-event-accordion-panel-anim.is-open::-webkit-scrollbar-thumb {
        background-color: #491212;
        border-radius: 4px; }
        .content.calendar-event .calendar-event-accordion-panel-anim.is-open::-webkit-scrollbar-thumb:hover {
          background-color: #200808; }
  .content.calendar-event .description {
    margin-top: 10px;
    padding: 10px;
    background-color: #0c2637;
    border: 1px solid #b8b8b8;
    border-radius: 8px; }
    .content.calendar-event .description .description-header {
      display: flex;
      align-items: center;
      /* Assure l'alignement vertical de l'icône et du texte */ }
      .content.calendar-event .description .description-header .calendar-icon {
        width: auto;
        height: 15px;
        margin-right: 10px;
        /* Espace entre l'icône et le texte */ }
      .content.calendar-event .description .description-header .description-title {
        margin: 0;
        /* Pour éviter un espace supplémentaire sous le titre */ }
    .content.calendar-event .description .description-content {
      padding: 0px 25px; }
      .content.calendar-event .description .description-content .editor-paragraph span,
      .content.calendar-event .description .description-content .lexical-header1 span,
      .content.calendar-event .description .description-content .lexical-header2 span,
      .content.calendar-event .description .description-content .lexical-header3 span,
      .content.calendar-event .description .description-content .lexical-header4 span,
      .content.calendar-event .description .description-content .lexical-header5 span,
      .content.calendar-event .description .description-content .lexical-header6 span,
      .content.calendar-event .description .description-content li span {
        white-space: pre-wrap; }
      .content.calendar-event .description .description-content div:empty {
        display: none; }
  .content.calendar-event .participants {
    display: flex;
    flex-direction: row;
    height: 115px;
    padding: 10px;
    background-color: #0c2637;
    border: 1px solid #b8b8b8;
    border-radius: 8px; }
    .content.calendar-event .participants .calendar-icon {
      width: auto;
      height: 18px;
      margin-right: 10px;
      margin-top: 5px; }
    .content.calendar-event .participants .players {
      display: flex;
      flex-direction: row;
      align-items: stretch;
      min-width: 0;
      gap: 12px;
      flex-grow: 1; }
      .content.calendar-event .participants .players .players-body {
        display: flex;
        flex-direction: column;
        min-width: 0;
        gap: 5px;
        flex: 1 1 auto; }
        .content.calendar-event .participants .players .players-body .players-body__officers-row {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          gap: 12px;
          min-width: 0; }
          .content.calendar-event .participants .players .players-body .players-body__officers-row .officers {
            flex: 1 1 auto;
            min-width: 0; }
          .content.calendar-event .participants .players .players-body .players-body__officers-row .event-auction-open-button {
            flex: 0 0 auto;
            margin-top: 5px;
            white-space: nowrap; }
      .content.calendar-event .participants .players .officers {
        display: flex;
        flex-direction: column;
        min-width: 0;
        flex-grow: 0; }
        .content.calendar-event .participants .players .officers p {
          margin: 5px 0; }
        .content.calendar-event .participants .players .officers .officers-line {
          display: grid;
          grid-template-columns: 170px minmax(0, 1fr);
          align-items: center;
          column-gap: 10px;
          row-gap: 6px; }
          .content.calendar-event .participants .players .officers .officers-line .officers-line__identity {
            width: fit-content; }
          .content.calendar-event .participants .players .officers .officers-line strong {
            white-space: nowrap; }
          .content.calendar-event .participants .players .officers .officers-line .react-select-input__control,
          .content.calendar-event .participants .players .officers .officers-line .react-select__control,
          .content.calendar-event .participants .players .officers .officers-line .react-select-menu__control {
            width: max-content; }
      .content.calendar-event .participants .players .max-attendees {
        display: grid;
        grid-template-columns: 170px minmax(0, 1fr);
        align-items: center;
        column-gap: 10px;
        margin: 0; }
        .content.calendar-event .participants .players .max-attendees .participantLimit {
          margin: 0;
          white-space: nowrap; }
        .content.calendar-event .participants .players .max-attendees .field-input.participant-limit {
          position: relative;
          padding: 2px 5px 2px 5px;
          bottom: 5px;
          width: 100%;
          max-width: 80px; }
      .content.calendar-event .participants .players .participants-list {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 22px;
        width: 100%; }
        .content.calendar-event .participants .players .participants-list .participants-count {
          position: relative;
          margin: 0px 10px 0 0; }
        .content.calendar-event .participants .players .participants-list .participant-item {
          position: relative;
          margin: 0; }
          .content.calendar-event .participants .players .participants-list .participant-item .participant-avatar {
            border-radius: 50%;
            width: 22px;
            height: 22px;
            margin-right: -5px;
            background-color: #0c2637;
            border: 1px solid #b8b8b8; }
          .content.calendar-event .participants .players .participants-list .participant-item .participant-item__identity.user-discord-rank--profile-chip .user-discord-rank__avatar,
          .content.calendar-event .participants .players .participants-list .participant-item .participant-item__identity.user-discord-rank--profile-chip .user-discord-rank__avatar--placeholder {
            border-radius: 50%;
            width: 22px;
            height: 22px;
            background-color: #0c2637;
            border: 1px solid #b8b8b8; }
      .content.calendar-event .participants .players .participants-side-column {
        display: flex;
        flex-direction: row;
        align-items: stretch;
        align-self: stretch;
        gap: 10px;
        flex: 0 0 auto;
        width: auto;
        min-width: 0; }
      .content.calendar-event .participants .players .participants-side-column__assignments {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        align-self: flex-start;
        flex: 0 0 168px;
        width: 168px;
        min-width: 168px; }
      .content.calendar-event .participants .players .participants-side-column__signup {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        align-self: stretch;
        gap: 8px;
        flex: 0 0 240px;
        width: 240px;
        min-width: 220px; }
      .content.calendar-event .participants .players .event-planner-actions {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 6px;
        width: 100%; }
      .content.calendar-event .participants .players .event-planner-open-button {
        margin: 0;
        padding: 6px 10px;
        line-height: 1.2;
        width: 100%;
        box-sizing: border-box;
        white-space: nowrap;
        text-align: center; }
        .content.calendar-event .participants .players .event-planner-open-button.locked {
          opacity: 0.55;
          cursor: not-allowed; }
        .content.calendar-event .participants .players .event-planner-open-button.event-planner-open-button--modern {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-height: 28px;
          border: 1px solid rgba(58, 120, 180, 0.42);
          border-radius: 8px;
          background: rgba(23, 39, 56, 0.72);
          color: #dfdfdf;
          font-family: inherit;
          font-size: 0.72rem;
          font-weight: 600;
          text-transform: none;
          letter-spacing: 0.01em;
          box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
          transition: background 160ms ease, border-color 160ms ease, color 160ms ease; }
          .content.calendar-event .participants .players .event-planner-open-button.event-planner-open-button--modern:hover:not(:disabled):not(.locked) {
            border-color: rgba(90, 195, 255, 0.55);
            background: rgba(22, 52, 71, 0.88);
            color: #ffffff; }
          .content.calendar-event .participants .players .event-planner-open-button.event-planner-open-button--modern:disabled, .content.calendar-event .participants .players .event-planner-open-button.event-planner-open-button--modern.locked {
            opacity: 0.55;
            cursor: not-allowed; }
      .content.calendar-event .participants .players .event-signup-select-container.participant-select-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 6px;
        width: 100%;
        margin: 0; }
        .content.calendar-event .participants .players .event-signup-select-container.participant-select-container .react-select-input__control,
        .content.calendar-event .participants .players .event-signup-select-container.participant-select-container .css-b62m3t-container {
          min-width: 0;
          flex: 1 1 auto; }
        .content.calendar-event .participants .players .event-signup-select-container.participant-select-container .add-participant-button {
          position: relative;
          top: 0;
          flex: 0 0 auto;
          cursor: pointer;
          line-height: 0; }
          .content.calendar-event .participants .players .event-signup-select-container.participant-select-container .add-participant-button.locked {
            opacity: 0.45;
            cursor: not-allowed; }
          .content.calendar-event .participants .players .event-signup-select-container.participant-select-container .add-participant-button .add-icon {
            height: 20px;
            width: auto;
            display: block; }
      .content.calendar-event .participants .players .event-guest-signup-button-container.special-add-button-container {
        position: relative;
        right: 0;
        bottom: 0;
        height: auto;
        margin-top: auto;
        width: 100%;
        display: flex;
        justify-content: flex-end; }
        .content.calendar-event .participants .players .event-guest-signup-button-container.special-add-button-container .special-add-button {
          margin-left: auto; }
    .content.calendar-event .participants .joined-operation {
      display: flex;
      flex-direction: column;
      flex-basis: 325px;
      flex-shrink: 0; }
      .content.calendar-event .participants .joined-operation .calendar-icon {
        width: auto;
        height: 18px;
        margin-right: 10px;
        margin-top: 5px; }
      .content.calendar-event .participants .joined-operation .edit-allies {
        height: 85px;
        padding: 5px;
        background-color: #1e3042;
        border: 1px solid rgba(58, 120, 180, 0.28);
        border-radius: 6px;
        overflow: auto;
        margin-top: 5px; }
        .content.calendar-event .participants .joined-operation .edit-allies::-webkit-scrollbar {
          width: 6px; }
        .content.calendar-event .participants .joined-operation .edit-allies::-webkit-scrollbar-track {
          background: #2e3842;
          border-radius: 4px;
          padding-right: 1px; }
        .content.calendar-event .participants .joined-operation .edit-allies::-webkit-scrollbar-thumb {
          background-color: #491212;
          border-radius: 4px; }
          .content.calendar-event .participants .joined-operation .edit-allies::-webkit-scrollbar-thumb:hover {
            background-color: #200808; }
      .content.calendar-event .participants .joined-operation .alliance-list {
        max-height: 85px;
        border-radius: 6px;
        overflow: auto;
        margin-top: 5px; }
        .content.calendar-event .participants .joined-operation .alliance-list::-webkit-scrollbar {
          width: 6px; }
        .content.calendar-event .participants .joined-operation .alliance-list::-webkit-scrollbar-track {
          background: #2e3842;
          border-radius: 4px;
          padding-right: 1px; }
        .content.calendar-event .participants .joined-operation .alliance-list::-webkit-scrollbar-thumb {
          background-color: #491212;
          border-radius: 4px; }
          .content.calendar-event .participants .joined-operation .alliance-list::-webkit-scrollbar-thumb:hover {
            background-color: #200808; }
      .content.calendar-event .participants .joined-operation .participant-item {
        display: flex;
        align-items: center;
        margin: 3px 0px 3px 0px; }
        .content.calendar-event .participants .joined-operation .participant-item .participant-logo {
          height: 20px;
          width: auto;
          margin-right: 10px; }
        .content.calendar-event .participants .joined-operation .participant-item p {
          margin: 0; }
  .content.calendar-event .rewards {
    position: relative;
    text-align: center;
    display: flex;
    flex-direction: column;
    background-color: #0c2637;
    border: 1px solid #b8b8b8;
    border-radius: 8px; }
    .content.calendar-event .rewards .rewards-header {
      display: flex;
      align-items: center;
      margin: 10px 12px 6px; }
      .content.calendar-event .rewards .rewards-header .calendar-icon {
        width: auto;
        height: 18px;
        margin-right: 10px;
        /* Espace entre l'icône et le texte */ }
      .content.calendar-event .rewards .rewards-header .rewards-title {
        margin: 0;
        text-transform: uppercase;
        letter-spacing: 0.08em;
        font-size: 0.95rem;
        font-weight: 700; }
    .content.calendar-event .rewards .calendar-rewards-pair {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: stretch;
      justify-content: center;
      gap: 14px;
      margin: 6px 12px 14px;
      box-sizing: border-box; }
    .content.calendar-event .rewards .calendar-rewards-pair--token-only {
      justify-content: flex-start; }
    .content.calendar-event .rewards .calendar-rewards-pair--token-only .calendar-rewards-pair__token {
      flex: 1 1 100%;
      width: 100%;
      max-width: 100%;
      min-width: 0; }
    .content.calendar-event .rewards .calendar-rewards-pair--token-only .calendar-rewards-token-card {
      width: 100%; }
    .content.calendar-event .rewards .calendar-rewards-pair__ribbon {
      flex: 1 1 320px;
      min-width: min(100%, 260px);
      max-width: 100%; }
    .content.calendar-event .rewards .calendar-rewards-pair__token {
      flex: 0 0 auto;
      display: flex;
      align-items: center; }
    .content.calendar-event .rewards .calendar-rewards-token-card {
      margin: 0;
      padding: 14px 18px;
      border: 1px solid rgba(58, 120, 180, 0.28);
      border-radius: 12px;
      background-color: #1e3042;
      box-sizing: border-box;
      height: 100%;
      min-height: 0;
      display: flex;
      align-items: center;
      justify-content: center; }
    .content.calendar-event .rewards .calendar-rewards-token-card__inner {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 16px; }
    .content.calendar-event .rewards .calendar-rewards-token-card__icon {
      width: auto;
      height: 52px;
      flex-shrink: 0;
      display: block; }
    .content.calendar-event .rewards .calendar-rewards-token-card__text {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 10px; }
    .content.calendar-event .rewards .calendar-rewards-token-card__qty {
      font-size: 2rem;
      font-weight: 800;
      line-height: 1;
      color: rgba(223, 223, 223, 0.98); }
    .content.calendar-event .rewards .calendar-rewards-token-card__kind {
      font-size: 0.72rem;
      font-weight: 650;
      text-transform: uppercase;
      letter-spacing: 0.12em;
      color: rgba(223, 223, 223, 0.62); }
    .content.calendar-event .rewards .calendar-rewards-ribbon-card {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      justify-content: left;
      gap: 35px;
      margin: 0;
      padding: 18px 16px;
      border: 1px solid rgba(58, 120, 180, 0.28);
      border-radius: 12px;
      background-color: #1e3042;
      box-sizing: border-box;
      text-align: left; }
    .content.calendar-event .rewards .calendar-rewards-ribbon-card--no-progress {
      gap: 22px; }
    .content.calendar-event .rewards .calendar-rewards-ribbon-card__progress {
      flex: 0 0 auto; }
    .content.calendar-event .rewards .calendar-rewards-ribbon-card__ribbon {
      flex: 0 0 auto;
      min-width: 0;
      display: flex;
      justify-content: center; }
    .content.calendar-event .rewards .calendar-rewards-ribbon-card__ribbon-shell {
      width: auto;
      max-width: 300px;
      margin: 0 auto; }
    .content.calendar-event .rewards .calendar-rewards-ribbon-card__ribbon-shell .selected-ribbon-container.ribbon-utils {
      width: 100%;
      margin: 0 auto; }
    .content.calendar-event .rewards .calendar-rewards-ribbon-card__ribbon-shell .ribbon-details {
      transform: none;
      transform-origin: center; }
    .content.calendar-event .rewards .calendar-rewards-ribbon-card__info {
      flex: 0 1 auto;
      max-width: 400px;
      min-width: 0; }
    .content.calendar-event .rewards .calendar-rewards-ribbon-card__title {
      margin: 0 0 10px;
      text-transform: uppercase;
      font-weight: 800;
      font-size: 1rem;
      letter-spacing: 0.04em;
      line-height: 1.25;
      color: rgba(223, 223, 223, 0.96); }
    .content.calendar-event .rewards .calendar-rewards-ribbon-card__desc {
      margin: 0;
      font-size: 0.82rem;
      line-height: 1.45;
      color: rgba(223, 223, 223, 0.62); }
    .content.calendar-event .rewards .calendar-rewards-ring {
      position: relative;
      width: 92px;
      height: 92px;
      flex-shrink: 0; }
    .content.calendar-event .rewards .calendar-rewards-ring__svg {
      display: block;
      width: 92px;
      height: 92px; }
    .content.calendar-event .rewards .calendar-rewards-ring__track {
      stroke: rgba(223, 223, 223, 0.12); }
    .content.calendar-event .rewards .calendar-rewards-ring__arc {
      stroke: #3a78b4;
      filter: drop-shadow(0 0 2px rgba(75, 151, 227, 0.45)) drop-shadow(0 0 4px rgba(58, 120, 180, 0.25)); }
    .content.calendar-event .rewards .calendar-rewards-ring__center {
      position: absolute;
      inset: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 8px;
      pointer-events: none; }
    .content.calendar-event .rewards .calendar-rewards-ring__fraction {
      font-size: 0.82rem;
      font-weight: 800;
      line-height: 1.15;
      color: rgba(223, 223, 223, 0.98); }
    .content.calendar-event .rewards .calendar-rewards-ring__caption {
      margin-top: 2px;
      font-size: 0.52rem;
      font-weight: 650;
      text-transform: uppercase;
      letter-spacing: 0.07em;
      color: rgba(223, 223, 223, 0.5);
      text-align: center;
      max-width: 68px;
      line-height: 1.25; }
    @media (max-width: 640px) {
      .content.calendar-event .rewards .calendar-rewards-pair {
        flex-direction: column;
        align-items: stretch; }
      .content.calendar-event .rewards .calendar-rewards-pair__ribbon {
        flex: 1 1 auto; }
      .content.calendar-event .rewards .calendar-rewards-pair__token {
        justify-content: center; }
      .content.calendar-event .rewards .calendar-rewards-ribbon-card {
        flex-direction: column;
        align-items: center; }
      .content.calendar-event .rewards .calendar-rewards-ribbon-card__progress {
        display: flex;
        justify-content: center; }
      .content.calendar-event .rewards .calendar-rewards-ribbon-card__info {
        flex: 0 1 auto;
        max-width: 100%;
        text-align: center; } }

.selected-ribbon-container {
  margin: 10px auto 5px auto; }
  .selected-ribbon-container.display-event {
    width: 300px; }
  .selected-ribbon-container.event-template {
    width: 250px; }

.footer.calendar-event {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #163447;
  padding: 10px 0;
  border-radius: 0 0 8px 8px;
  margin: auto;
  width: 100%; }
  .footer.calendar-event .btn-style1 {
    width: 200px;
    font-size: medium;
    margin: 0 auto; }

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {
  height: 10px;
  padding: 5px 10px;
  white-space: nowrap; }

/* Bandeau bas type roster (voir react-table.scss .table-base.roster .roster-table-footer) */
.table-base.roster.calendar-page-table-shell {
  overflow: visible; }
  .table-base.roster.calendar-page-table-shell .roster-table-footer.calendar-page-footer {
    /* Même largeur que .rbc-calendar (header / grille) */
    width: 1460px;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
    min-height: 36px;
    padding: 5px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box; }
    .table-base.roster.calendar-page-table-shell .roster-table-footer.calendar-page-footer .timezone-display {
      margin-top: 0;
      margin-bottom: 0;
      width: 100%; }
      .table-base.roster.calendar-page-table-shell .roster-table-footer.calendar-page-footer .timezone-display p {
        margin: 0;
        text-align: center;
        color: #b8b8b8;
        font-size: 0.9em; }

.timezone-display {
  display: flex;
  position: relative;
  margin-top: 10px;
  margin-bottom: auto;
  justify-content: center; }

.ribbon-tooltip {
  display: flex;
  flex-direction: column;
  position: fixed;
  background-color: #2a3847;
  border: 1px solid #491212;
  border-right: 0;
  border-bottom: 4px solid #491212;
  border-radius: 6px 0px 0px 6px;
  z-index: 1000;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  top: var(--tooltip-y, 0);
  left: var(--tooltip-x, 0); }
  .ribbon-tooltip[data-tooltip-x] {
    --tooltip-x: attr(data-tooltip-x px); }
  .ribbon-tooltip[data-tooltip-y] {
    --tooltip-y: attr(data-tooltip-y px); }
  .ribbon-tooltip .ribbon-header {
    display: flex;
    flex-direction: row;
    height: 30px;
    border-bottom: 2px solid #163447;
    border-radius: 6px 0px 0px 0px;
    overflow: hidden;
    background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center; }
    .ribbon-tooltip .ribbon-header .icon {
      position: relative;
      height: 30px;
      overflow: hidden;
      top: 5px; }
      .ribbon-tooltip .ribbon-header .icon .ribbon-icon {
        position: relative;
        height: 40px;
        width: auto;
        margin-left: 5px;
        overflow-x: hidden;
        bottom: 20px; }
    .ribbon-tooltip .ribbon-header .custom-h3 {
      color: #dfdfdf;
      font-size: smaller;
      font-weight: 600;
      margin: 1px;
      padding: 5px; }
  .ribbon-tooltip .ribbon-content {
    display: flex;
    flex-direction: column; }
    .ribbon-tooltip .ribbon-content .ribbon-list {
      background: #1c2d38;
      width: max-content;
      max-width: 205px;
      height: 130px;
      padding: 10px;
      margin: 7px 5px;
      border: 1px solid #491212;
      border-radius: 6px;
      overflow-x: hidden; }
      .ribbon-tooltip .ribbon-content .ribbon-list::-webkit-scrollbar {
        width: 6px; }
      .ribbon-tooltip .ribbon-content .ribbon-list::-webkit-scrollbar-track {
        background: #2e3842;
        border-radius: 4px;
        padding-right: 1px; }
      .ribbon-tooltip .ribbon-content .ribbon-list::-webkit-scrollbar-thumb {
        background-color: #491212;
        border-radius: 4px; }
        .ribbon-tooltip .ribbon-content .ribbon-list::-webkit-scrollbar-thumb:hover {
          background-color: #200808; }
      .ribbon-tooltip .ribbon-content .ribbon-list label {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        max-width: 180px;
        word-break: break-word;
        line-height: 1.2; }
      .ribbon-tooltip .ribbon-content .ribbon-list input[type="checkbox"] {
        margin-top: 3px; }
    .ribbon-tooltip .ribbon-content .ribbon-name {
      color: #b8b8b8; }
      .ribbon-tooltip .ribbon-content .ribbon-name.selected {
        color: #75cf78; }
    .ribbon-tooltip .ribbon-content .ribbon-comment-actions {
      margin: 8px 20px; }
    .ribbon-tooltip .ribbon-content .ribbon-comment-editor {
      position: absolute;
      width: max-content;
      top: -9px;
      left: 230px;
      margin: 7px 5px  0px  0px; }
      .ribbon-tooltip .ribbon-content .ribbon-comment-editor .mde-textarea-wrapper .mde-text {
        height: 110px !important; }
      .ribbon-tooltip .ribbon-content .ribbon-comment-editor .mde-preview {
        min-height: 110px !important;
        max-height: 110px !important;
        height: 110px !important; }
      .ribbon-tooltip .ribbon-content .ribbon-comment-editor .lexical-container .editor-container {
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
        border-left: 0px;
        background: #2a3847; }
        .ribbon-tooltip .ribbon-content .ribbon-comment-editor .lexical-container .editor-container .toolbar {
          border-top-left-radius: 0px; }
        .ribbon-tooltip .ribbon-content .ribbon-comment-editor .lexical-container .editor-container .editor-input {
          min-height: 115px;
          background: #1c2d38;
          margin: 5px 6px 54px 5px;
          border: 1px solid #491212;
          border-radius: 6px; }

.special-add-button-container {
  position: relative;
  height: 50px;
  right: 10px;
  bottom: 10px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end; }

.special-add-button {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: width 0.3s ease-in-out, height 0.3s ease-in-out;
  width: 75px;
  height: 25px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-color: rgba(0, 51, 128, 0.2);
  background-blend-mode: multiply;
  border-radius: 20px;
  overflow: hidden;
  color: #491212;
  text-transform: uppercase;
  font-size: 0.65em;
  font-weight: 800;
  padding-left: 8px;
  box-sizing: border-box;
  box-shadow: 0px 0px 5px 2px #2f30315e; }
  .special-add-button:hover {
    background-color: rgba(0, 51, 128, 0);
    color: #9e2222;
    text-decoration: none;
    height: 50px;
    width: 227px;
    box-shadow: 0px 0px 5px 2px #2f30315e; }
  .special-add-button.expanded {
    width: 227px;
    height: 50px;
    background-color: rgba(0, 51, 128, 0);
    box-shadow: 0px 0px 5px 2px #2f30315e;
    border: 1px solid #9e2222; }
  .special-add-button:active {
    box-shadow: 0px 0px 5px 2px #2f3031ee; }
  .special-add-button .button-label {
    flex-shrink: 0;
    white-space: nowrap;
    margin-right: 10px;
    padding: 2px 2px 0px 3px; }
  .special-add-button .add-input {
    border: none;
    outline: none;
    padding: 1px 10px;
    flex-grow: 1;
    opacity: 0;
    max-height: 0;
    transition: opacity 0.3s ease-in-out, max-height 0.3s ease-in-out; }
    .special-add-button .add-input.handle-input {
      border-radius: 12px 12px 0px 0px; }
    .special-add-button .add-input.discord-id-input {
      border-radius: 0px 0px 12px 12px; }
    .special-add-button .add-input.visible {
      margin-top: 1px;
      margin-bottom: 1px;
      opacity: 1;
      max-height: 50px;
      box-shadow: 0px 0px 4px 2px #2f303169; }
  .special-add-button .add-icon-wrapper {
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    width: 26px;
    height: 26px;
    color: #491212;
    top: 1px;
    right: 2px;
    flex-shrink: 0;
    margin-left: auto; }
  .special-add-button .plus-icon {
    font-size: 22px; }

.event-debrief .input-field .react-mde .mde-textarea-wrapper .mde-text, .event-debrief .input-field .react-mde-tabbed-layout .mde-textarea-wrapper .mde-text {
  height: 300px !important; }

.event-debrief .input-field .react-mde .mde-preview, .event-debrief .input-field .react-mde-tabbed-layout .mde-preview {
  height: 300px !important; }

.content .react-mde .mde-textarea-wrapper .mde-text, .content .react-mde-tabbed-layout .mde-textarea-wrapper .mde-text, .calendar-debrief-default .react-mde .mde-textarea-wrapper .mde-text, .calendar-debrief-default .react-mde-tabbed-layout .mde-textarea-wrapper .mde-text {
  height: 300px !important; }

.content .react-mde .mde-preview, .content .react-mde-tabbed-layout .mde-preview, .calendar-debrief-default .react-mde .mde-preview, .calendar-debrief-default .react-mde-tabbed-layout .mde-preview {
  height: 300px !important; }

.token-reward {
  display: flex;
  align-items: center;
  margin: auto;
  gap: 10px; }

.token-image {
  width: auto;
  height: 45px; }

.token-label {
  font-weight: bold;
  font-size: 1rem;
  color: #dfdfdf; }

.objectives-benefits-row .inputs-column.objectives {
  width: -webkit-fill-available;
  background-color: #0c2637;
  border: 1px solid #dfdfdf;
  border-radius: 8px;
  padding: 10px; }
  .objectives-benefits-row .inputs-column.objectives .input {
    margin-bottom: 0; }

.objectives {
  width: 285px; }
  .objectives .toggle.objectives {
    display: flex;
    width: 100%;
    height: auto;
    bottom: 0;
    transform: none;
    justify-content: space-between;
    position: relative;
    text-transform: none;
    font-size: 14px;
    font-weight: normal;
    color: #dfdfdf; }
    .objectives .toggle.objectives .toggle-label {
      flex: 1 1 auto;
      margin-right: 10px; }
    .objectives .toggle.objectives .toggle-switch {
      position: relative;
      height: 13px;
      left: auto;
      right: auto;
      margin-left: auto; }
    .objectives .toggle.objectives .toggle-label {
      font-weight: normal;
      font-size: 0.9rem;
      display: flex; }

.objectives-block {
  display: flex;
  flex-direction: column;
  border: 1px solid #dfdfdf;
  margin-top: 8px;
  border-radius: 4px;
  padding: 6px;
  gap: 6px;
  width: 280px;
  box-sizing: border-box; }
  .objectives-block.disabled {
    opacity: 0.5; }
  .objectives-block .objectives-scroll {
    height: 142px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding-right: 6px; }
    .objectives-block .objectives-scroll::-webkit-scrollbar {
      width: 6px; }
    .objectives-block .objectives-scroll::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .objectives-block .objectives-scroll::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .objectives-block .objectives-scroll::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
  .objectives-block .objective-row {
    position: relative;
    display: grid;
    grid-template-columns: 18px auto 45px;
    gap: 6px;
    align-items: center; }
  .objectives-block .objective-order {
    font-size: 0.85em;
    color: #dfdfdf;
    opacity: 0.75;
    text-align: right;
    user-select: none;
    cursor: grab; }
    .objectives-block .objective-order.is-disabled {
      opacity: 0.25;
      cursor: default; }
  .objectives-block .objective-input {
    width: 100%;
    box-sizing: border-box; }
  .objectives-block .toggle.critical {
    height: 11px;
    display: flex;
    align-items: center;
    gap: 6px; }

.calendar-event-modal.calendar-event-modal--roster-file .modal-dialog {
  max-width: min(900px, 94vw);
  width: min(900px, 94vw);
  margin: 1.25rem auto; }

.calendar-event-modal.calendar-event-modal--roster-file .modal-dialog .modal-content {
  min-width: 0;
  max-width: 100%; }

.calendar-event-modal.calendar-event-modal--roster-file .modal-content,
.calendar-event-modal.calendar-event-modal--card-top .modal-content {
  background: linear-gradient(165deg, rgba(30, 48, 66, 0.97), rgba(23, 39, 56, 0.99));
  border: 1px solid #491212;
  border-bottom: 4px solid #491212;
  border-radius: 12px;
  margin: 100px auto;
  overflow: hidden;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35), 0 22px 50px rgba(0, 0, 0, 0.55); }

.calendar-event-modal.calendar-event-modal--roster-file .modal-body,
.calendar-event-modal.calendar-event-modal--card-top .modal-body {
  padding: 0;
  background: transparent; }

.calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main,
.calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main {
  background: #1e3042;
  padding: 10px 12px 14px;
  border-radius: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-sizing: border-box; }
  .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-card-main-controls,
  .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-card-main-controls {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    box-sizing: border-box; }
    .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-card-main-controls .create-event-access-toggle,
    .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-card-main-controls .create-event-access-toggle {
      margin-left: auto;
      margin-right: 8px; }
    .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-card-main-controls .calendar-event-access-chip,
    .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-card-main-controls .calendar-event-access-chip {
      margin-left: auto;
      margin-right: 8px;
      display: inline-flex;
      align-items: center;
      padding: 4px 10px;
      border-radius: 999px;
      border: 1px solid rgba(58, 120, 180, 0.35);
      background: rgba(23, 39, 56, 0.85);
      color: #dfdfdf;
      font-size: 0.72rem;
      font-weight: 600;
      letter-spacing: 0.02em;
      line-height: 1.2;
      text-transform: lowercase;
      white-space: nowrap; }
    .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-card-main-controls .calendar-event-access-chip--public,
    .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-card-main-controls .calendar-event-access-chip--public {
      border-color: rgba(90, 160, 92, 0.45);
      color: #75cf78; }
    .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-card-main-controls .calendar-event-access-chip--private,
    .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-card-main-controls .calendar-event-access-chip--private {
      border-color: rgba(58, 120, 180, 0.4);
      color: #dfdfdf; }
    .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-card-main-controls .calendar-event-access-chip--invite-only,
    .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-card-main-controls .calendar-event-access-chip--invite-only {
      border-color: rgba(155, 96, 42, 0.5);
      color: #c78445; }
  .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-header-status,
  .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-header-status {
    flex-shrink: 0;
    line-height: 1; }
    .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-header-status:empty,
    .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-header-status:empty {
      display: none; }
    .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-header-status .calendar-event.status,
    .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-header-status .calendar-event.status {
      margin: 0; }
    .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-header-status .calendar-event-header-status-group,
    .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-header-status .calendar-event-header-status-group {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 6px; }
      .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-header-status .calendar-event-header-status-group .calendar-event.status,
      .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-header-status .calendar-event-header-status-group .calendar-event.status {
        margin: 0; }
      .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-header-status .calendar-event-header-status-group .calendar-event-tentative-toggle,
      .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-header-status .calendar-event-header-status-group .calendar-event-tentative-toggle {
        margin: 5px 25px 5px;
        font-size: 11px; }
        .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-header-status .calendar-event-header-status-group .calendar-event-tentative-toggle .toggle-label,
        .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-header-status .calendar-event-header-status-group .calendar-event-tentative-toggle .toggle-label {
          margin-left: 0;
          top: 0; }
  .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-header-toolbar,
  .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-header-toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    min-width: 0;
    max-width: 100%; }
    .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-header-toolbar .edit-mode,
    .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-header-toolbar .edit-mode {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 8px;
      margin: 0; }
    .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-header-toolbar .btn-style1,
    .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-header-toolbar .btn-style1 {
      font-size: 11px;
      padding: 5px 10px; }

.calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event.time,
.calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event.time {
  border: 1px solid rgba(58, 120, 180, 0.28);
  border-radius: 10px;
  padding: 10px;
  min-height: auto;
  box-sizing: border-box; }
  .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event.time .column,
  .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event.time .column {
    border-color: rgba(58, 120, 180, 0.18); }

.calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .selected-ribbon-container,
.calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .selected-ribbon-container {
  width: 250px;
  max-width: 100%;
  margin: 0 auto;
  box-sizing: border-box; }
  .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .selected-ribbon-container.display-event,
  .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .selected-ribbon-container.display-event {
    width: 250px; }

.calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .participants,
.calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .participants {
  background: #172738;
  height: auto;
  border: 1px solid rgba(58, 120, 180, 0.28);
  border-radius: 10px;
  padding: 10px;
  box-sizing: border-box;
  position: relative; }
  .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .participants .players,
  .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .participants .players {
    position: relative;
    padding-bottom: 0;
    min-width: 0; }

.calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .joined-operation--standalone-card,
.calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .joined-operation--standalone-card {
  display: flex;
  flex-direction: column;
  flex-basis: auto;
  flex-shrink: 1;
  width: 100%;
  margin-top: 10px;
  background: #172738;
  height: auto;
  border: 1px solid rgba(58, 120, 180, 0.28);
  border-radius: 10px;
  padding: 10px;
  box-sizing: border-box; }
  .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .joined-operation--standalone-card .joined-operation-header,
  .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .joined-operation--standalone-card .joined-operation-header {
    margin: 0 0 6px; }
    .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .joined-operation--standalone-card .joined-operation-header label,
    .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .joined-operation--standalone-card .joined-operation-header label {
      margin: 0;
      color: rgba(255, 255, 255, 0.92); }
  .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .joined-operation--standalone-card .alliance-list,
  .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .joined-operation--standalone-card .alliance-list {
    max-height: none;
    margin-top: 0; }
  .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .joined-operation--standalone-card .edit-allies,
  .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .joined-operation--standalone-card .edit-allies {
    display: flex;
    flex-direction: column;
    gap: 4px;
    max-height: 140px;
    padding: 6px 8px;
    background-color: #1e3042;
    border: 1px solid rgba(58, 120, 180, 0.28);
    border-radius: 6px;
    overflow: auto;
    margin-top: 0; }
    .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .joined-operation--standalone-card .edit-allies::-webkit-scrollbar,
    .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .joined-operation--standalone-card .edit-allies::-webkit-scrollbar {
      width: 6px; }
    .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .joined-operation--standalone-card .edit-allies::-webkit-scrollbar-track,
    .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .joined-operation--standalone-card .edit-allies::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .joined-operation--standalone-card .edit-allies::-webkit-scrollbar-thumb,
    .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .joined-operation--standalone-card .edit-allies::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .joined-operation--standalone-card .edit-allies::-webkit-scrollbar-thumb:hover,
      .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .joined-operation--standalone-card .edit-allies::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
    .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .joined-operation--standalone-card .edit-allies .ally-checkbox,
    .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .joined-operation--standalone-card .edit-allies .ally-checkbox {
      display: flex;
      align-items: center;
      gap: 8px;
      color: #dfdfdf; }
      .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .joined-operation--standalone-card .edit-allies .ally-checkbox label,
      .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .joined-operation--standalone-card .edit-allies .ally-checkbox label {
        margin: 0;
        font-weight: normal;
        cursor: pointer; }
      .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .joined-operation--standalone-card .edit-allies .ally-checkbox input[type="checkbox"],
      .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .joined-operation--standalone-card .edit-allies .ally-checkbox input[type="checkbox"] {
        cursor: pointer; }

.calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-accordion,
.calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-accordion {
  background: #172738;
  border: 1px solid rgba(58, 120, 180, 0.28);
  border-radius: 10px;
  padding: 10px;
  box-sizing: border-box; }

.calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs,
.calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  box-sizing: border-box; }
  .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs .ui-subtabs,
  .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs .ui-subtabs {
    align-self: center;
    margin-top: 0; }

.calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panels,
.calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panels {
  width: 100%;
  box-sizing: border-box; }

.calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panel--surface,
.calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panel--surface {
  background: #172738;
  border: 1px solid rgba(58, 120, 180, 0.28);
  border-radius: 10px;
  padding: 10px;
  box-sizing: border-box;
  height: 50vh;
  max-height: 50vh;
  overflow: auto; }
  .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panel--surface::-webkit-scrollbar,
  .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panel--surface::-webkit-scrollbar {
    width: 6px; }
  .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panel--surface::-webkit-scrollbar-track,
  .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panel--surface::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panel--surface::-webkit-scrollbar-thumb,
  .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panel--surface::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panel--surface::-webkit-scrollbar-thumb:hover,
    .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panel--surface::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }
  .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panel--surface .event-report-content,
  .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panel--surface .description-content,
  .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panel--surface .event-report-content,
  .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panel--surface .description-content {
    padding: 0 12px;
    max-height: none; }

.calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panels > .objectives-benefits-row,
.calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panels > .objectives-benefits-row {
  height: 50vh;
  max-height: 50vh;
  min-height: 0;
  align-items: stretch; }
  .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panels > .objectives-benefits-row > .event-objectives-view,
  .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panels > .objectives-benefits-row > .objectives-report-block,
  .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panels > .objectives-benefits-row > .benefits-block,
  .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panels > .objectives-benefits-row > .event-objectives-view,
  .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panels > .objectives-benefits-row > .objectives-report-block,
  .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panels > .objectives-benefits-row > .benefits-block {
    height: 100%;
    max-height: 100%;
    min-height: 0;
    box-sizing: border-box; }
  .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panels > .objectives-benefits-row > .event-objectives-view,
  .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panels > .objectives-benefits-row > .event-objectives-view {
    display: flex;
    flex-direction: column; }
    .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panels > .objectives-benefits-row > .event-objectives-view .event-objectives-view-list,
    .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panels > .objectives-benefits-row > .event-objectives-view .event-objectives-view-list {
      flex: 1 1 auto;
      min-height: 0;
      max-height: none; }
  .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panels > .objectives-benefits-row > .objectives-report-block .objectives-report-list,
  .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panels > .objectives-benefits-row > .objectives-report-block .objectives-report-list {
    flex: 1 1 auto;
    min-height: 0;
    max-height: none; }
  .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panels > .objectives-benefits-row > .benefits-block.benefits-block--event-modal-readonly,
  .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panels > .objectives-benefits-row > .benefits-block.benefits-block--event-modal-readonly {
    height: 100%;
    max-height: 100%; }

.calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event.calendar-event-debrief-room,
.calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event.calendar-event-debrief-room {
  margin: 0;
  box-sizing: border-box;
  height: 50vh;
  max-height: 50vh; }

.calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-debrief-room-frame,
.calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-debrief-room-frame {
  background: #1e3042;
  border: 1px solid rgba(58, 120, 180, 0.28);
  border-radius: 10px;
  padding: 10px;
  box-sizing: border-box; }

.calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-debrief-room-heading,
.calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-debrief-room-heading {
  margin: 0 0 10px 0;
  font-size: 1rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.92); }

.calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-debrief-room .chat-container,
.calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-debrief-room .chat-container {
  height: 100%; }
  .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-debrief-room .chat-container .chat-unified-frame,
  .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-debrief-room .chat-container .chat-unified-frame {
    min-height: 100%;
    height: 100%;
    display: flex;
    flex-direction: column; }
  .calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event-debrief-room .chat-container .chat-unified-body,
  .calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event-debrief-room .chat-container .chat-unified-body {
    flex: 1;
    min-height: 0;
    max-height: none; }

.calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .calendar-event.rewards,
.calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .calendar-event.rewards {
  width: 100%;
  background: #172738;
  border: 1px solid rgba(58, 120, 180, 0.28);
  border-radius: 10px;
  padding: 10px;
  box-sizing: border-box; }

.calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .objectives-benefits-row .event-objectives-view,
.calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .objectives-benefits-row .benefits-block:not(.benefits-block--event-modal-readonly),
.calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .objectives-benefits-row .event-objectives-view,
.calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .objectives-benefits-row .benefits-block:not(.benefits-block--event-modal-readonly) {
  background: #172738;
  border: 1px solid rgba(58, 120, 180, 0.28);
  border-radius: 10px; }

.calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .objectives-benefits-row .benefits-block-header-box-icon,
.calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .objectives-benefits-row .benefits-block-header-box-icon {
  width: 18px;
  height: 18px;
  object-fit: contain;
  flex-shrink: 0;
  opacity: 0.92; }

.calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .objectives-benefits-row .event-objectives-view-header .calendar-icon.block-icon,
.calendar-event-modal.calendar-event-modal--roster-file .content.calendar-event.calendar-event-card-main .objectives-benefits-row .objectives-report-header .calendar-icon.block-icon,
.calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .objectives-benefits-row .event-objectives-view-header .calendar-icon.block-icon,
.calendar-event-modal.calendar-event-modal--card-top .content.calendar-event.calendar-event-card-main .objectives-benefits-row .objectives-report-header .calendar-icon.block-icon {
  width: 18px;
  height: 18px;
  object-fit: contain;
  flex: 0 0 auto;
  margin-right: 0; }

.calendar-event-modal.calendar-event-modal--roster-file .footer.calendar-event,
.calendar-event-modal.calendar-event-modal--card-top .footer.calendar-event {
  background: linear-gradient(180deg, rgba(23, 39, 56, 0.9), rgba(30, 48, 66, 0.85));
  border-top: 1px solid rgba(58, 120, 180, 0.22);
  border-radius: 0 0 11px 11px;
  padding: 12px 0; }

.benefits-loot-move-popover-backdrop {
  position: fixed;
  inset: 0;
  z-index: 10100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.45); }

.benefits-loot-move-popover {
  width: 100%;
  max-width: 320px;
  padding: 16px 18px;
  border-radius: 10px;
  border: 1px solid rgba(56, 72, 88, 0.85);
  background: #0c2637;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.45);
  color: #dfdfdf; }

.benefits-loot-move-popover__title {
  margin: 0 0 4px;
  font-size: 14px;
  font-weight: 600; }

.benefits-loot-move-popover__target {
  margin: 0 0 14px;
  font-size: 12px;
  opacity: 0.85; }

.benefits-loot-move-popover__stepper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 10px; }

.benefits-loot-move-popover__stepper-btn {
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid rgba(56, 72, 88, 0.9);
  background: rgba(255, 255, 255, 0.06);
  color: #ffffff;
  font-size: 18px;
  line-height: 1;
  cursor: pointer; }
  .benefits-loot-move-popover__stepper-btn:disabled {
    opacity: 0.35;
    cursor: not-allowed; }
  .benefits-loot-move-popover__stepper-btn:hover:not(:disabled), .benefits-loot-move-popover__stepper-btn:focus-visible:not(:disabled) {
    border-color: rgba(58, 120, 180, 0.75);
    background: rgba(58, 120, 180, 0.14); }

.benefits-loot-move-popover__qty-field {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  min-width: 88px;
  justify-content: center; }

.benefits-loot-move-popover__qty-input {
  width: 4ch;
  min-width: 3ch;
  padding: 6px 8px;
  border-radius: 6px;
  border: 1px solid rgba(56, 72, 88, 0.85);
  background: rgba(0, 0, 0, 0.25);
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  text-align: center; }

.benefits-loot-move-popover__qty-max {
  font-size: 12px;
  opacity: 0.75; }

.benefits-loot-move-popover__shortcuts {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 8px; }

.benefits-loot-move-popover__shortcut-link {
  border: 0;
  padding: 0;
  background: transparent;
  color: rgba(58, 120, 180, 0.95);
  font-size: 12px;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer; }
  .benefits-loot-move-popover__shortcut-link:hover, .benefits-loot-move-popover__shortcut-link:focus-visible {
    color: #508cc7; }

.benefits-loot-move-popover__hint {
  margin: 0 0 14px;
  font-size: 11px;
  opacity: 0.65;
  text-align: center; }

.benefits-loot-move-popover__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px; }

.benefits-loot-move-popover__btn {
  min-width: 72px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid rgba(56, 72, 88, 0.85);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer; }

.benefits-loot-move-popover__btn--ghost {
  background: transparent;
  color: #dfdfdf; }

.benefits-loot-move-popover__btn--primary {
  background: rgba(58, 120, 180, 0.22);
  border-color: rgba(58, 120, 180, 0.65);
  color: #ffffff; }
  .benefits-loot-move-popover__btn--primary:disabled {
    opacity: 0.45;
    cursor: not-allowed; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
/*
 * Benefits UEC layout for the calendar EVENT modal — duplicated from bigCalendar.scss
 * (rules that lived under ".calendar-event-report.content … .benefits-block …" only).
 * Loaded globally via styles.scss → bigCalendar.scss (no component-level SCSS import).
 */
.content.calendar-event .benefits-block.benefits-block--event-modal-readonly {
  background: #172738;
  border: 1px solid rgba(58, 120, 180, 0.28);
  border-radius: 8px;
  padding: 10px;
  margin: 0;
  height: 100%;
  min-height: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
  /* Benefits-only: label + switch alignment (do not use \`.join-operation\` here). */
  /* colgroup: narrower identity; mini payout-toggle; loot stays 60% */ }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-block-header-box-icon {
    width: 18px;
    height: 18px;
    object-fit: contain;
    flex-shrink: 0;
    opacity: 0.92; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-block-header {
    margin-bottom: 6px;
    text-transform: uppercase;
    font-size: 0.85em;
    opacity: 0.9;
    display: flex;
    align-items: center;
    gap: 8px; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-block-body {
    flex: 1 1 auto;
    min-height: 0;
    overflow: auto; }
    .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-block-body::-webkit-scrollbar {
      width: 6px; }
    .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-block-body::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-block-body::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-block-body::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec {
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: 15px;
    min-height: 0; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-top {
    display: flex;
    gap: 12px;
    align-items: flex-start; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-loot-distributed-badge {
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    align-self: end;
    gap: 2px;
    padding: 8px 10px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: rgba(0, 0, 0, 0.18);
    min-width: 56px;
    user-select: none; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-loot-distributed-badge__label {
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    opacity: 0.75;
    line-height: 1.1;
    white-space: nowrap; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-loot-distributed-badge__value {
    font-size: 1.05rem;
    font-weight: 700;
    line-height: 1;
    color: rgba(255, 255, 255, 0.92); }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-top-left-cluster,
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-top-left,
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-top-right {
    min-width: 0; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-top-left-cluster {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    flex: 1 1 auto; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-top-left-cluster .benefits-uec-top-left {
    flex: 0 1 auto; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-top-right {
    flex: 0 0 auto;
    /* Visually line up the loot field with the UEC \`field-input\` row (not the label). */
    align-self: flex-end; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-top-left-cluster:only-child {
    width: 100%; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-top-left {
    display: flex;
    flex-direction: column;
    gap: 6px; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-payout-lock-wrap {
    flex: 0 0 auto;
    position: relative;
    top: 10px;
    align-self: center;
    max-width: 15rem; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly:not(.benefits-block--expanded) .benefits-uec-top-left-cluster .benefits-uec-payout-lock-wrap {
    margin-left: auto; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-payout-lock-wrap .toggle.benefits-uec-payout-lock-toggle-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    width: auto;
    min-width: 0;
    max-width: 100%;
    height: auto;
    bottom: 0;
    position: relative;
    margin: 0;
    text-transform: none;
    font-size: 14px;
    color: #dfdfdf; }
    .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-payout-lock-wrap .toggle.benefits-uec-payout-lock-toggle-row .toggle-label {
      position: static;
      display: inline-flex;
      align-items: center;
      flex: 0 1 auto;
      margin: 0;
      width: auto;
      font-weight: normal;
      font-size: 0.85rem; }
    .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-payout-lock-wrap .toggle.benefits-uec-payout-lock-toggle-row .toggle-switch {
      position: relative;
      top: auto;
      left: auto;
      right: auto;
      bottom: auto;
      margin: 0;
      flex-shrink: 0; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-row {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 6px; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-label {
    font-size: 0.85em;
    opacity: 0.9;
    text-transform: uppercase;
    white-space: nowrap; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-label-sub {
    font-size: 0.85em;
    opacity: 0.85;
    text-transform: capitalize; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-total-with-share {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    gap: 8px;
    min-width: 0; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-org-share-compact {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    flex: 0 1 auto;
    min-width: 0;
    max-width: 100%; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-org-share-compact__label {
    font-size: 0.72rem;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.55);
    letter-spacing: 0.02em;
    white-space: nowrap; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-org-share-compact__amount {
    font-size: 0.8rem;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.82);
    white-space: nowrap; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-input-shell {
    display: flex;
    align-items: stretch;
    width: 200px;
    background: #0c2637;
    border: 1px solid #384858;
    border-radius: 6px;
    overflow: hidden; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-input-shell.locked {
    opacity: 0.7; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-input {
    color: #dfdfdf;
    font-size: 15px;
    font-weight: 600;
    flex: 1 1 auto;
    background: #133b53;
    border: 0;
    padding: 5px 10px;
    text-align: left;
    min-width: 0; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-input.locked {
    cursor: not-allowed; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-input:focus {
    outline: none; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-input-unit {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    padding: 5px 10px;
    background: rgba(56, 72, 88, 0.25);
    border-left: 1px solid rgba(56, 72, 88, 0.6);
    color: #dfdfdf;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.02em;
    min-width: 45px;
    user-select: none; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-hint {
    font-size: 0.9em;
    opacity: 0.85; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-hint.locked {
    opacity: 0.65; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly:not(.benefits-block--expanded) .benefits-org-bank {
    display: none; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly:not(.benefits-block--expanded) .benefits-uec-top-right {
    display: none; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly:not(.benefits-block--expanded) .benefits-uec-participants-header-left {
    grid-template-columns: minmax(0, 1fr) minmax(88px, 180px) minmax(56px, 72px); }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly:not(.benefits-block--expanded) .benefits-uec-participants-header-cell:nth-child(4) {
    display: none; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-org-bank {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #384858;
    border-radius: 6px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    min-width: 0;
    cursor: pointer; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-org-bank.is-active {
    background: rgba(58, 120, 180, 0.16);
    box-shadow: 0 0 0 2px rgba(58, 120, 180, 0.18); }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-org-bank-start {
    display: flex;
    flex-direction: row;
    align-items: center;
    align-self: start;
    gap: 10px;
    padding: 5px;
    min-width: 0;
    flex: 0 1 auto; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-org-bank-logo {
    flex: 0 0 auto;
    line-height: 0;
    background: #133b53;
    padding: 5px;
    border: 1px solid #384858;
    border-radius: 6px; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-org-bank-logo__img {
    display: block;
    width: 28px;
    height: auto;
    max-height: 32px;
    max-width: 36px;
    object-fit: contain;
    filter: grayscale(1) contrast(1.08) brightness(1.05);
    opacity: 0.65; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-org-bank-left {
    flex: 0 1 auto;
    position: relative;
    z-index: 0;
    display: flex;
    flex-direction: column;
    align-self: start;
    gap: 4px;
    min-width: 0; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-org-bank-title {
    font-size: 0.8em;
    opacity: 0.9;
    text-transform: uppercase;
    white-space: nowrap; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-org-bank-title-sub {
    font-size: 0.85em;
    opacity: 0.85;
    text-transform: capitalize; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-org-bank-amount {
    font-size: 15px;
    font-weight: 600;
    color: #dfdfdf;
    white-space: nowrap; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-org-bank-right {
    flex: 1 1 0;
    position: relative;
    background: #0c2637;
    border-radius: 8px;
    z-index: 0;
    display: flex;
    justify-content: flex-start;
    min-width: 0; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-org-bank-loot-placeholder {
    border: 1px dashed rgba(56, 72, 88, 0.8);
    border-radius: 6px;
    padding: 8px 10px;
    min-height: 30px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    opacity: 0.8;
    position: relative;
    z-index: 1;
    overflow: hidden; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-org-bank-loot-placeholder.is-empty {
    justify-content: center; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-org-bank-loot-placeholder .benefits-loot-chips,
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-org-bank-loot-drop .benefits-loot-chips {
    position: relative;
    z-index: 2; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-org-bank-loot-drop {
    width: 100%; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-org-bank.is-dnd-over {
    box-shadow: inset 0 0 0 2px rgba(58, 120, 180, 0.55);
    background: rgba(58, 120, 180, 0.08); }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-org-bank-loot-drop.is-dnd-over {
    box-shadow: inset 0 0 0 2px rgba(58, 120, 180, 0.55);
    background: rgba(58, 120, 180, 0.1); }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-participant.is-dnd-over {
    box-shadow: inset 0 0 0 1px rgba(58, 120, 180, 0.45); }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-summary {
    display: flex;
    flex-direction: column;
    gap: 4px; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-participants {
    display: flex;
    flex-direction: column;
    gap: 0;
    min-height: 0;
    flex: 1 1 auto; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-participants-header {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    gap: 12px;
    min-width: 0;
    padding: 8px 10px;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 6px 6px 0 0; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-participants-header-left {
    flex: 1 1 auto;
    min-width: 0;
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(96px, 200px) 44px minmax(0, 1fr);
    gap: 10px;
    align-items: center;
    padding: 0; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-participants-header-cell {
    font-size: 0.7em;
    font-weight: 600;
    letter-spacing: 0.04em;
    opacity: 0.9;
    text-transform: uppercase;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-participants-header-cell:nth-child(2) {
    text-align: right; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-participants-list {
    overflow: auto;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-top: 0;
    border-radius: 0 0 6px 6px;
    padding: 6px 10px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-height: 0;
    background: rgba(0, 0, 0, 0.12); }
    .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-participants-list::-webkit-scrollbar {
      width: 6px; }
    .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-participants-list::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-participants-list::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-participants-list::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-participants-list:not(.benefits-uec-participants-list--table) > .benefits-uec-participant {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    cursor: pointer; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-participants-list:not(.benefits-uec-participants-list--table) > .benefits-uec-participant.is-expanded {
    align-items: flex-start; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-participant.is-active {
    background: rgba(58, 120, 180, 0.16);
    border-radius: 6px; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly.benefits-block--expanded .benefits-uec-participants-list--table {
    display: block;
    gap: 0;
    padding: 0;
    overflow: auto;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 6px;
    min-height: 0;
    background: rgba(0, 0, 0, 0.12); }
    .content.calendar-event .benefits-block.benefits-block--event-modal-readonly.benefits-block--expanded .benefits-uec-participants-list--table::-webkit-scrollbar {
      width: 6px; }
    .content.calendar-event .benefits-block.benefits-block--event-modal-readonly.benefits-block--expanded .benefits-uec-participants-list--table::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .content.calendar-event .benefits-block.benefits-block--event-modal-readonly.benefits-block--expanded .benefits-uec-participants-list--table::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .content.calendar-event .benefits-block.benefits-block--event-modal-readonly.benefits-block--expanded .benefits-uec-participants-list--table::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly.benefits-block--expanded .benefits-uec-participants-table tbody tr.benefits-uec-participant {
    display: table-row; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly.benefits-block--expanded .benefits-uec-participants-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly.benefits-block--expanded .benefits-uec-participants-col--identity {
    width: 19%; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly.benefits-block--expanded .benefits-uec-participants-col--payout {
    width: 14%; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly.benefits-block--expanded .benefits-uec-participants-col--payoutToggle {
    width: 7%; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly.benefits-block--expanded .benefits-uec-participants-col--loot {
    width: 60%; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly.benefits-block--expanded .benefits-uec-participants-table thead tr {
    background: rgba(255, 255, 255, 0.04); }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly.benefits-block--expanded .benefits-uec-participants-th {
    padding: 8px 10px;
    text-align: left;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
    font-weight: 600; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly.benefits-block--expanded .benefits-uec-participants-th--payout {
    text-align: right; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly.benefits-block--expanded .benefits-uec-participants-th--payoutToggle {
    text-align: center;
    padding-left: 4px;
    padding-right: 4px; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly.benefits-block--expanded .benefits-uec-participants-table tbody tr.benefits-uec-participant td {
    padding: 8px 10px;
    vertical-align: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08); }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly.benefits-block--expanded .benefits-uec-participants-table tbody tr.benefits-uec-participant:last-child td {
    border-bottom: 0; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly.benefits-block--expanded .benefits-uec-participants-td--payout {
    text-align: right; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly.benefits-block--expanded .benefits-uec-participants-td--payoutToggle {
    text-align: center;
    vertical-align: middle;
    padding-left: 4px;
    padding-right: 4px; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly.benefits-block--expanded .benefits-uec-participants-td--identity,
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly.benefits-block--expanded .benefits-uec-participants-td--loot {
    min-width: 0; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly.benefits-block--expanded .benefits-uec-participants-td--loot {
    min-height: 44px;
    height: 100%; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly.benefits-block--expanded .benefits-uec-participant-loots {
    min-width: 0;
    width: 100%;
    padding-top: 2px; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly.benefits-block--expanded .benefits-uec-participant-loots--empty {
    min-height: 0; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly:not(.benefits-block--expanded) .benefits-uec-participant-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(88px, 180px) 44px;
    gap: 10px;
    align-items: center;
    width: 100%;
    min-width: 0; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly:not(.benefits-block--expanded) .benefits-uec-participant-cell--payoutToggle {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 0; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly:not(.benefits-block--expanded) .benefits-uec-participant-cell--identity {
    min-width: 0; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly:not(.benefits-block--expanded) .benefits-uec-participant-cell--payout {
    justify-self: end;
    text-align: right;
    align-self: center; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly.benefits-block--expanded .benefits-uec-participant-identity {
    min-width: 0; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly.benefits-block--expanded .benefits-uec-participant-identity .user-discord-rank__name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-participant-cell.benefits-uec-participant-right {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    gap: 8px;
    flex: 0 0 auto; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-actions {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    gap: 8px;
    min-width: 0; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-mention-wrap {
    position: relative;
    flex: 1 1 auto;
    min-width: 0;
    max-width: 320px;
    width: 100%; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-mention-input-shell {
    display: flex;
    align-items: stretch;
    width: 100%;
    background: #0c2637;
    border: 1px solid #384858;
    border-radius: 6px;
    overflow: hidden; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-mention-input-shell.locked {
    opacity: 0.7; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-mention-input-shell .benefits-loot-search-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    padding: 0 10px 0 10px;
    color: #dfdfdf;
    background: #172738; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-mention-input-shell:focus-within .benefits-loot-search-icon {
    color: rgba(255, 255, 255, 0.62); }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-mention-input-shell .benefits-loot-search-icon__svg {
    display: block;
    width: 16px;
    height: 16px; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-mention-input-shell .benefits-loot-search-input {
    width: 100%;
    box-sizing: border-box;
    flex: 1 1 auto;
    min-width: 0;
    background: #133b53;
    border: 0;
    border-radius: 0;
    padding: 7px 10px 7px 7px;
    color: #dfdfdf;
    font-size: 15px;
    font-weight: 600;
    text-align: left; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-mention-input-shell .benefits-loot-search-input:focus {
    outline: none; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-search-hint {
    margin-top: 4px;
    font-size: 11px;
    opacity: 0.75; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-mention-wrap .mention-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    margin: 4px 0 0 0;
    padding: 0;
    list-style: none;
    background: rgba(12, 38, 55, 0.98);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 6px;
    max-height: 220px;
    overflow-y: auto;
    z-index: 10050; }
    .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-mention-wrap .mention-dropdown::-webkit-scrollbar {
      width: 6px; }
    .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-mention-wrap .mention-dropdown::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-mention-wrap .mention-dropdown::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-mention-wrap .mention-dropdown::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-mention-wrap .mention-dropdown .dropdown-item {
    display: flex;
    align-items: flex-start;
    padding: 6px 10px;
    cursor: pointer;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06); }
    .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-mention-wrap .mention-dropdown .dropdown-item:last-child {
      border-bottom: none; }
    .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-mention-wrap .mention-dropdown .dropdown-item.selected {
      background-color: rgba(58, 120, 180, 0.22); }
    .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-mention-wrap .mention-dropdown .dropdown-item:hover {
      background-color: rgba(255, 255, 255, 0.06); }
    .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-mention-wrap .mention-dropdown .dropdown-item .mention-name {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 2px;
      line-height: 1.25;
      min-width: 0; }
    .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-mention-wrap .mention-dropdown .dropdown-item .benefits-loot-dd-label {
      font-size: 13px;
      color: rgba(255, 255, 255, 0.92);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 100%; }
    .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-mention-wrap .mention-dropdown .dropdown-item .benefits-loot-dd-meta {
      font-size: 11px;
      color: rgba(255, 255, 255, 0.55);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 100%; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    align-items: center;
    min-width: 0; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-chip-dnd {
    display: inline-flex;
    flex-direction: row;
    align-items: stretch;
    min-width: 0;
    vertical-align: top; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-chip-dnd__surface {
    display: inline-flex;
    flex-direction: row;
    align-items: stretch;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
    border: 1px solid #9D7BFF;
    border-radius: 6px;
    background: #0B1016;
    overflow: hidden; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-chip-dnd--overlay {
    cursor: grabbing; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-chip-dnd.is-benefits-dragging {
    opacity: 0; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-chip-dnd__handle {
    flex: 0 0 auto;
    width: 15px;
    min-width: 20px;
    margin: 0;
    padding: 5px;
    border: 0;
    border-right: 1px solid rgba(255, 255, 255, 0.1);
    align-self: stretch;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: grab;
    color: rgba(255, 255, 255, 0.45);
    background: linear-gradient(90deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.05) 100%); }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-chip-dnd--overlay .benefits-loot-chip-dnd__handle {
    cursor: grabbing; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-chip-dnd__handle::before {
    content: "";
    display: block;
    width: 4px;
    height: 12px;
    border-left: 1px solid currentColor;
    border-right: 1px solid currentColor;
    background: linear-gradient(180deg, currentColor, currentColor) center/1px 100% no-repeat; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-chip-dnd__handle:hover,
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-chip-dnd__handle:focus-visible {
    color: rgba(255, 255, 255, 0.75);
    background: linear-gradient(90deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.05) 100%); }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-chip-dnd__handle:active {
    cursor: grabbing; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-chip-dnd__chip {
    min-width: 0;
    flex: 1 1 auto;
    display: flex;
    align-items: stretch; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-loot-chip-dnd__chip .sc-item-chip {
    border: 0;
    border-radius: 0;
    background: transparent;
    max-width: 100%; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-participant-left {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    flex: 1 1 auto; }
  .content.calendar-event .benefits-block.benefits-block--event-modal-readonly .benefits-uec-participant-share {
    white-space: nowrap;
    opacity: 0.95; }

/* Flex slot sizing + expanded overlay footprint (incl. roster card shell parity) */
.content.calendar-event .objectives-benefits-row > .benefits-block.benefits-block--event-modal-readonly,
.content.calendar-event.calendar-event-card-main .objectives-benefits-row > .benefits-block.benefits-block--event-modal-readonly,
.content.calendar-event .calendar-event-benefits-expansion-slot-benefits .benefits-block.benefits-block--event-modal-readonly,
.content.calendar-event.calendar-event-card-main .calendar-event-benefits-expansion-slot-benefits .benefits-block.benefits-block--event-modal-readonly {
  flex: 1 1 0;
  min-width: 0;
  min-height: 260px; }

.content.calendar-event .calendar-event-benefits-expansion-overlay .benefits-block.benefits-block--event-modal-readonly,
.content.calendar-event.calendar-event-card-main .calendar-event-benefits-expansion-overlay .benefits-block.benefits-block--event-modal-readonly {
  height: 100%;
  max-height: 100%;
  min-height: 0;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.45); }

.benefits-loot-move-popover-backdrop {
  position: fixed;
  inset: 0;
  z-index: 10100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.45); }

.benefits-loot-move-popover {
  width: 100%;
  max-width: 320px;
  padding: 16px 18px;
  border-radius: 10px;
  border: 1px solid rgba(56, 72, 88, 0.85);
  background: #0c2637;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.45);
  color: #dfdfdf; }

.benefits-loot-move-popover__title {
  margin: 0 0 4px;
  font-size: 14px;
  font-weight: 600; }

.benefits-loot-move-popover__target {
  margin: 0 0 14px;
  font-size: 12px;
  opacity: 0.85; }

.benefits-loot-move-popover__stepper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 10px; }

.benefits-loot-move-popover__stepper-btn {
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid rgba(56, 72, 88, 0.9);
  background: rgba(255, 255, 255, 0.06);
  color: #ffffff;
  font-size: 18px;
  line-height: 1;
  cursor: pointer; }
  .benefits-loot-move-popover__stepper-btn:disabled {
    opacity: 0.35;
    cursor: not-allowed; }
  .benefits-loot-move-popover__stepper-btn:hover:not(:disabled), .benefits-loot-move-popover__stepper-btn:focus-visible:not(:disabled) {
    border-color: rgba(58, 120, 180, 0.75);
    background: rgba(58, 120, 180, 0.14); }

.benefits-loot-move-popover__qty-field {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  min-width: 88px;
  justify-content: center; }

.benefits-loot-move-popover__qty-input {
  width: 4ch;
  min-width: 3ch;
  padding: 6px 8px;
  border-radius: 6px;
  border: 1px solid rgba(56, 72, 88, 0.85);
  background: rgba(0, 0, 0, 0.25);
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  text-align: center; }

.benefits-loot-move-popover__qty-max {
  font-size: 12px;
  opacity: 0.75; }

.benefits-loot-move-popover__shortcuts {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 8px; }

.benefits-loot-move-popover__shortcut-link {
  border: 0;
  padding: 0;
  background: transparent;
  color: rgba(58, 120, 180, 0.95);
  font-size: 12px;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer; }
  .benefits-loot-move-popover__shortcut-link:hover, .benefits-loot-move-popover__shortcut-link:focus-visible {
    color: #508cc7; }

.benefits-loot-move-popover__hint {
  margin: 0 0 14px;
  font-size: 11px;
  opacity: 0.65;
  text-align: center; }

.benefits-loot-move-popover__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px; }

.benefits-loot-move-popover__btn {
  min-width: 72px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid rgba(56, 72, 88, 0.85);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer; }

.benefits-loot-move-popover__btn--ghost {
  background: transparent;
  color: #dfdfdf; }

.benefits-loot-move-popover__btn--primary {
  background: rgba(58, 120, 180, 0.22);
  border-color: rgba(58, 120, 180, 0.65);
  color: #ffffff; }
  .benefits-loot-move-popover__btn--primary:disabled {
    opacity: 0.45;
    cursor: not-allowed; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.event-objectives-view {
  background-color: #0c2637;
  border: 1px solid rgba(58, 120, 180, 0.28);
  border-radius: 8px;
  padding: 10px;
  margin-top: 0;
  box-sizing: border-box; }
  .event-objectives-view .event-objectives-view-header {
    position: relative;
    text-transform: uppercase;
    font-size: 0.85em;
    opacity: 0.9;
    margin-bottom: 6px;
    display: flex;
    align-items: center;
    gap: 8px; }
  .event-objectives-view .objectives-block-expand-toggle {
    margin-left: auto;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    padding: 0;
    margin-right: 0;
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    background: rgba(0, 0, 0, 0.25);
    cursor: pointer;
    transition: background 160ms ease, border-color 160ms ease, transform 160ms ease; }
  .event-objectives-view .objectives-block-expand-toggle:hover {
    background: rgba(0, 0, 0, 0.38);
    border-color: #b8b8b8; }
  .event-objectives-view .objectives-block-expand-toggle__icon {
    display: block;
    width: 14px;
    height: 14px;
    object-fit: contain;
    opacity: 0.95; }
  .event-objectives-view .event-objectives-view-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 10px 20px 10px 20px;
    max-height: 220px;
    overflow: auto; }
    .event-objectives-view .event-objectives-view-list::-webkit-scrollbar {
      width: 6px; }
    .event-objectives-view .event-objectives-view-list::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .event-objectives-view .event-objectives-view-list::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .event-objectives-view .event-objectives-view-list::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
  .event-objectives-view.event-objectives-view--expanded .event-objectives-view-list {
    max-height: 400px;
    overflow: auto; }
  .event-objectives-view.event-objectives-view--expanded .event-objectives-view-text {
    white-space: normal;
    overflow: visible;
    text-overflow: unset; }
  .event-objectives-view.event-objectives-view--expanded .event-objectives-view-row {
    align-items: start; }
  .event-objectives-view .event-objectives-view-title-run {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    min-width: 0; }
  .event-objectives-view .event-objectives-view-title-run .event-objectives-view-text {
    min-width: 270px; }
  .event-objectives-view .event-objectives-view-critical-chip {
    flex-shrink: 0;
    font-size: 0.56rem;
    font-weight: 600;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    padding: 4px 10px 2px 10px;
    margin-left: 2px;
    border: 1px solid #9e2222;
    border-radius: 4px;
    color: #dfdfdf;
    background: linear-gradient(155deg, #491212 0%, #9e2222 45%, #491212 100%);
    line-height: 1.25;
    user-select: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4), 0 0 12px rgba(158, 34, 34, 0.28), inset 0 1px 0 rgba(255, 255, 255, 0.1);
    text-shadow: 0 0 10px rgba(223, 223, 223, 0.35); }
  .event-objectives-view .event-objectives-view-row {
    display: grid;
    grid-template-columns: 12px 28px 1fr auto;
    align-items: center;
    gap: 5px;
    padding: 6px 8px;
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.08); }
  .event-objectives-view .event-objectives-view-row.is-upcoming {
    grid-template-columns: 0px 35px 1fr; }
  .event-objectives-view .event-objectives-view-row.event-objectives-view-row--with-description-html {
    align-items: start; }
  .event-objectives-view:not(.event-objectives-view--expanded) .event-objectives-view-row {
    position: relative;
    overflow: hidden; }
    .event-objectives-view:not(.event-objectives-view--expanded) .event-objectives-view-row::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 5px;
      border-radius: 6px 0 0 6px;
      background: transparent;
      pointer-events: none; }
    .event-objectives-view:not(.event-objectives-view--expanded) .event-objectives-view-row.event-objectives-view-row--critical-accent::before {
      background: #9e2222; }
  .event-objectives-view .event-objectives-view-html {
    grid-column: 1 / -1;
    padding-left: 45px;
    font-size: 0.9em;
    opacity: 0.9;
    margin-bottom: 10px; }
    .event-objectives-view .event-objectives-view-html p {
      margin: 0; }
    .event-objectives-view .event-objectives-view-html p + p {
      margin-top: 6px; }
  .event-objectives-view .event-objectives-view-dot {
    width: 10px;
    height: 10px;
    border-radius: 999px;
    border: 2px solid rgba(255, 255, 255, 0.35);
    background: transparent; }
    .event-objectives-view .event-objectives-view-dot.status-unset {
      border-color: #9e2222;
      background: transparent; }
    .event-objectives-view .event-objectives-view-dot.status-0 {
      background: #b8b8b8;
      border-color: rgba(255, 255, 255, 0.9); }
    .event-objectives-view .event-objectives-view-dot.status-1 {
      background: #9e2222;
      border-color: rgba(255, 255, 255, 0.9); }
    .event-objectives-view .event-objectives-view-dot.status-2 {
      background: #9b602a;
      border-color: rgba(255, 255, 255, 0.9); }
    .event-objectives-view .event-objectives-view-dot.status-3 {
      background: #5aa05c;
      border-color: rgba(255, 255, 255, 0.9); }
    .event-objectives-view .event-objectives-view-dot.status-upcoming {
      border-color: rgba(255, 255, 255, 0.35);
      background: transparent; }
  .event-objectives-view .event-objectives-view-text {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; }
  .event-objectives-view .event-objectives-view-number {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    min-height: 1.5rem;
    padding: 2px 10px;
    box-sizing: border-box;
    font-size: 0.75em;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0.02em;
    user-select: none;
    color: #dfdfdf;
    border: 1px solid #133b53;
    border-radius: 5px;
    background: #172738;
    opacity: 0.8; }
  .event-objectives-view .event-objectives-view-critical {
    width: 5px;
    text-align: center;
    user-select: none; }
    .event-objectives-view .event-objectives-view-critical.is-critical {
      color: #9e2222; }
  .event-objectives-view .event-objectives-view-status {
    text-transform: uppercase;
    font-size: 0.72em;
    opacity: 0.75;
    letter-spacing: 0.02em;
    user-select: none; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.calendar-event-report.content .objectives-benefits-row > .objectives-report-block:not(.objectives-report-block--in-calendar-event) {
  flex: 1 1 0;
  min-width: 0; }

.content.calendar-event .objectives-benefits-row > .objectives-report-block.objectives-report-block--in-calendar-event {
  flex: 1 1 0;
  min-width: 0; }

.report-benefits-expansion-overlay .objectives-report-block:not(.objectives-report-block--in-calendar-event) {
  height: 100%;
  max-height: 100%;
  box-sizing: border-box;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.45); }

.report-benefits-expansion-objectives > .objectives-report-block:not(.objectives-report-block--in-calendar-event),
.report-benefits-expansion-objectives > .report-benefits-expansion-objectives-placeholder {
  flex: 1 1 0;
  min-width: 0; }

.objectives-report-block:not(.objectives-report-block--in-calendar-event) {
  background-color: #0c2637;
  border: 1px solid #b8b8b8;
  border-radius: 8px;
  padding: 10px;
  margin: 0;
  height: 260px;
  display: flex;
  flex-direction: column;
  /* Keeps the critical chip flush after the title text (not pushed to the far edge). */ }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event).objectives-report-block--readonly .objective-status-options {
    pointer-events: none; }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event).objectives-report-block--incomplete {
    border-color: #9e2222; }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objectives-report-header {
    margin-bottom: 6px;
    text-transform: uppercase;
    font-size: 0.85em;
    opacity: 0.9;
    display: flex;
    align-items: center;
    gap: 8px; }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objectives-report-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex: 1 1 auto;
    min-height: 0;
    overflow: auto; }
    .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objectives-report-list::-webkit-scrollbar {
      width: 6px; }
    .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objectives-report-list::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objectives-report-list::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objectives-report-list::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objectives-report-row {
    display: grid;
    grid-template-columns: auto auto minmax(0, 1fr) auto;
    column-gap: 10px;
    row-gap: 0;
    align-items: center;
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 6px;
    margin-right: 8px;
    padding: 6px 0px 6px; }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objectives-report-row--with-description-html {
    align-items: start; }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objectives-report-critical {
    grid-column: 1;
    grid-row: 1;
    width: 5px;
    text-align: center;
    user-select: none; }
    .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objectives-report-critical.is-critical {
      color: #9e2222; }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objectives-report-number {
    grid-column: 2;
    grid-row: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 1.5rem;
    min-height: 1.5rem;
    padding: 2px 10px;
    box-sizing: border-box;
    font-size: 0.75em;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0.02em;
    user-select: none;
    color: rgba(255, 255, 255, 0.9);
    border: 1px solid rgba(255, 255, 255, 0.22);
    border-radius: 5px;
    background: #133b53;
    opacity: 0.8; }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objectives-report-title-cell {
    grid-column: 3;
    grid-row: 1;
    min-width: 0; }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objectives-report-title-run {
    display: inline-flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
    max-width: 100%; }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objectives-report-title-run .objectives-report-text {
    flex: 0 1 auto;
    min-width: 270px;
    max-width: 100%;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    text-overflow: ellipsis; }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objectives-report-critical-chip {
    flex-shrink: 0;
    font-size: 0.56rem;
    font-weight: 600;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    padding: 4px 10px 2px 10px;
    margin-left: 2px;
    border: 1px solid #9e2222;
    border-radius: 4px;
    color: #dfdfdf;
    background: linear-gradient(155deg, #491212 0%, #9e2222 45%, #491212 100%);
    line-height: 1.25;
    user-select: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4), 0 0 12px rgba(158, 34, 34, 0.28), inset 0 1px 0 rgba(255, 255, 255, 0.1);
    text-shadow: 0 0 10px rgba(223, 223, 223, 0.35); }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objectives-report-actions {
    grid-column: 4;
    grid-row: 1;
    display: inline-flex;
    gap: 6px; }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event).objectives-report-block--expanded .objectives-report-row {
    align-items: start; }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objectives-report-html {
    grid-column: 3;
    grid-row: 2;
    min-width: 0;
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    white-space: normal;
    overflow-wrap: anywhere; }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objective-status {
    display: grid;
    grid-template-rows: 22px 14px;
    grid-template-columns: 1fr;
    gap: 4px;
    align-items: center;
    justify-items: center;
    width: 270px;
    position: relative; }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objective-status-track {
    position: relative;
    width: 270px;
    height: 22px; }
    .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objective-status-track::before {
      content: "";
      position: absolute;
      left: calc(100% / 8);
      right: calc(100% / 8);
      top: 50%;
      height: 2px;
      transform: translateY(-50%);
      background: rgba(255, 255, 255, 0.18);
      border-radius: 999px; }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objective-status-dot {
    position: relative;
    width: 12px;
    height: 12px;
    border-radius: 999px;
    border: 2px solid rgba(255, 255, 255, 0.35);
    background: #0c2637;
    padding: 0;
    justify-self: center; }
    .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objective-status-dot:hover {
      border-color: rgba(255, 255, 255, 0.6); }
    .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objective-status-dot.is-active {
      border-color: rgba(255, 255, 255, 0.9);
      background: rgba(255, 255, 255, 0.85); }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objective-status.is-unset .objective-status-track::before {
    background: rgba(158, 34, 34, 0.35); }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objective-status.is-unset .objective-status-dot {
    border-color: #9e2222;
    background: transparent; }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objective-status.is-unset .objective-status-option:hover .objective-status-dot {
    border-color: rgba(158, 34, 34, 0.9); }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objective-status.is-set .objective-status-track::before {
    background: rgba(255, 255, 255, 0.18); }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objective-status.is-set .objective-status-dot.is-active {
    border-color: rgba(255, 255, 255, 0.9); }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objective-status.is-set .objective-status-option:nth-child(1) .objective-status-dot.is-active {
    background: #b8b8b8; }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objective-status.is-set .objective-status-option:nth-child(2) .objective-status-dot.is-active {
    background: #9e2222; }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objective-status.is-set .objective-status-option:nth-child(3) .objective-status-dot.is-active {
    background: #9b602a; }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objective-status.is-set .objective-status-option:nth-child(4) .objective-status-dot.is-active {
    background: #5aa05c; }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objective-status-options {
    position: absolute;
    width: 270px;
    top: 0;
    left: 0;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: 22px 14px;
    gap: 4px; }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objective-status-option {
    display: grid;
    grid-template-rows: 22px 14px;
    align-items: center;
    justify-items: center;
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    min-width: 0; }
    .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objective-status-option:hover .objective-status-dot {
      border-color: rgba(255, 255, 255, 0.6); }
  .objectives-report-block:not(.objectives-report-block--in-calendar-event) .objective-status-label {
    color: #dfdfdf;
    text-align: center;
    font-size: 0.72em;
    text-transform: uppercase;
    opacity: 0.75;
    letter-spacing: 0.02em;
    user-select: none;
    line-height: 14px; }

.objectives-report-block.objectives-report-block--in-calendar-event {
  background-color: #172738;
  border: 1px solid rgba(58, 120, 180, 0.28);
  border-radius: 8px;
  padding: 10px;
  margin: 0;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  /* Keeps the critical chip flush after the title text (not pushed to the far edge). */
  /* Chips (vue calendrier verrouillée) — mêmes couleurs pleines que \`.objective-status-option:nth-child(n) .objective-status-dot.is-active\` */
  /* Track 4 statuts : utilisé si le bloc n’est pas en lecture seule modal calendrier (sinon chips ci-dessus). */ }
  .objectives-report-block.objectives-report-block--in-calendar-event.objectives-report-block--readonly .objective-status-options {
    pointer-events: none; }
  .objectives-report-block.objectives-report-block--in-calendar-event.objectives-report-block--incomplete {
    border-color: #9e2222; }
  .objectives-report-block.objectives-report-block--in-calendar-event .objectives-report-header {
    margin-bottom: 6px;
    text-transform: uppercase;
    font-size: 0.85em;
    opacity: 0.9;
    display: flex;
    align-items: center;
    gap: 8px; }
  .objectives-report-block.objectives-report-block--in-calendar-event .objectives-report-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex: 1 1 auto;
    min-height: 0;
    overflow: auto; }
    .objectives-report-block.objectives-report-block--in-calendar-event .objectives-report-list::-webkit-scrollbar {
      width: 6px; }
    .objectives-report-block.objectives-report-block--in-calendar-event .objectives-report-list::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .objectives-report-block.objectives-report-block--in-calendar-event .objectives-report-list::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .objectives-report-block.objectives-report-block--in-calendar-event .objectives-report-list::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
  .objectives-report-block.objectives-report-block--in-calendar-event .objectives-report-row {
    display: grid;
    grid-template-columns: auto auto minmax(0, 1fr) auto;
    column-gap: 10px;
    row-gap: 0;
    align-items: center;
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 6px;
    padding: 6px 0px 6px;
    margin-right: 8px; }
  .objectives-report-block.objectives-report-block--in-calendar-event .objectives-report-row--with-description-html {
    align-items: start; }
  .objectives-report-block.objectives-report-block--in-calendar-event .objectives-report-critical {
    grid-column: 1;
    grid-row: 1;
    width: 5px;
    text-align: center;
    user-select: none; }
    .objectives-report-block.objectives-report-block--in-calendar-event .objectives-report-critical.is-critical {
      color: #9e2222; }
  .objectives-report-block.objectives-report-block--in-calendar-event .objectives-report-number {
    grid-column: 2;
    grid-row: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 1.5rem;
    min-height: 1.5rem;
    padding: 2px 10px;
    box-sizing: border-box;
    font-size: 0.75em;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0.02em;
    user-select: none;
    color: rgba(255, 255, 255, 0.9);
    border: 1px solid rgba(58, 120, 180, 0.45);
    border-radius: 5px;
    background: #1e3042; }
  .objectives-report-block.objectives-report-block--in-calendar-event .objectives-report-title-cell {
    grid-column: 3;
    grid-row: 1;
    min-width: 0; }
  .objectives-report-block.objectives-report-block--in-calendar-event .objectives-report-title-run {
    display: inline-flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
    max-width: 100%; }
  .objectives-report-block.objectives-report-block--in-calendar-event .objectives-report-title-run .objectives-report-text {
    flex: 0 1 auto;
    min-width: 270px;
    max-width: 100%;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    text-overflow: ellipsis; }
  .objectives-report-block.objectives-report-block--in-calendar-event .objectives-report-critical-chip {
    flex-shrink: 0;
    font-size: 0.56rem;
    font-weight: 600;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    padding: 4px 10px 2px 10px;
    margin-left: 2px;
    border: 1px solid #9e2222;
    border-radius: 4px;
    color: #dfdfdf;
    background: linear-gradient(155deg, #491212 0%, #9e2222 45%, #491212 100%);
    line-height: 1.25;
    user-select: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4), 0 0 12px rgba(158, 34, 34, 0.28), inset 0 1px 0 rgba(255, 255, 255, 0.1);
    text-shadow: 0 0 10px rgba(223, 223, 223, 0.35); }
  .objectives-report-block.objectives-report-block--in-calendar-event .objectives-report-actions {
    grid-column: 4;
    grid-row: 1;
    display: inline-flex;
    gap: 6px;
    align-items: center;
    justify-content: flex-end;
    min-width: 0;
    margin-right: 10px;
    opacity: 0.8; }
  .objectives-report-block.objectives-report-block--in-calendar-event .objectives-report-status-chip {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 5px 5px 3px 5px;
    border-radius: 10px;
    font-size: 0.68rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    line-height: 1.2;
    white-space: nowrap;
    border: 1px solid transparent;
    box-sizing: border-box;
    width: 80px;
    overflow: hidden;
    text-overflow: ellipsis; }
  .objectives-report-block.objectives-report-block--in-calendar-event .objectives-report-status-chip--ignored {
    background: #384858;
    border-color: #747b81;
    color: #b8b8b8; }
  .objectives-report-block.objectives-report-block--in-calendar-event .objectives-report-status-chip--failed {
    background: #7e1e1e;
    border-color: #d12323;
    color: #ffffff; }
  .objectives-report-block.objectives-report-block--in-calendar-event .objectives-report-status-chip--partial {
    background: #9b602a;
    border-color: #d8b493;
    color: #ffffff; }
  .objectives-report-block.objectives-report-block--in-calendar-event .objectives-report-status-chip--success {
    background: #3f7c42;
    border-color: #75cf78;
    color: #ffffff; }
  .objectives-report-block.objectives-report-block--in-calendar-event .objectives-report-status-chip--unset {
    background: transparent;
    border-color: #d12323;
    border-style: dashed;
    color: #dfdfdf; }
  .objectives-report-block.objectives-report-block--in-calendar-event.objectives-report-block--expanded .objectives-report-row {
    align-items: start; }
  .objectives-report-block.objectives-report-block--in-calendar-event .objectives-report-html {
    grid-column: 3;
    grid-row: 2;
    min-width: 0;
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    white-space: normal;
    overflow-wrap: anywhere; }
  .objectives-report-block.objectives-report-block--in-calendar-event .objective-status {
    display: grid;
    grid-template-rows: 22px 14px;
    grid-template-columns: 1fr;
    gap: 4px;
    align-items: center;
    justify-items: center;
    width: 270px;
    position: relative; }
  .objectives-report-block.objectives-report-block--in-calendar-event .objective-status-track {
    position: relative;
    width: 270px;
    height: 22px; }
    .objectives-report-block.objectives-report-block--in-calendar-event .objective-status-track::before {
      content: "";
      position: absolute;
      left: calc(100% / 8);
      right: calc(100% / 8);
      top: 50%;
      height: 2px;
      transform: translateY(-50%);
      background: rgba(255, 255, 255, 0.18);
      border-radius: 999px; }
  .objectives-report-block.objectives-report-block--in-calendar-event .objective-status-dot {
    position: relative;
    width: 12px;
    height: 12px;
    border-radius: 999px;
    border: 2px solid rgba(255, 255, 255, 0.35);
    background: #0c2637;
    padding: 0;
    justify-self: center; }
    .objectives-report-block.objectives-report-block--in-calendar-event .objective-status-dot:hover {
      border-color: rgba(255, 255, 255, 0.6); }
    .objectives-report-block.objectives-report-block--in-calendar-event .objective-status-dot.is-active {
      border-color: rgba(255, 255, 255, 0.9);
      background: rgba(255, 255, 255, 0.85); }
  .objectives-report-block.objectives-report-block--in-calendar-event .objective-status.is-unset .objective-status-track::before {
    background: rgba(158, 34, 34, 0.35); }
  .objectives-report-block.objectives-report-block--in-calendar-event .objective-status.is-unset .objective-status-dot {
    border-color: #9e2222;
    background: transparent; }
  .objectives-report-block.objectives-report-block--in-calendar-event .objective-status.is-unset .objective-status-option:hover .objective-status-dot {
    border-color: rgba(158, 34, 34, 0.9); }
  .objectives-report-block.objectives-report-block--in-calendar-event .objective-status.is-set .objective-status-track::before {
    background: rgba(255, 255, 255, 0.18); }
  .objectives-report-block.objectives-report-block--in-calendar-event .objective-status.is-set .objective-status-dot.is-active {
    border-color: rgba(255, 255, 255, 0.9); }
  .objectives-report-block.objectives-report-block--in-calendar-event .objective-status.is-set .objective-status-option:nth-child(1) .objective-status-dot.is-active {
    background: #b8b8b8; }
  .objectives-report-block.objectives-report-block--in-calendar-event .objective-status.is-set .objective-status-option:nth-child(2) .objective-status-dot.is-active {
    background: #9e2222; }
  .objectives-report-block.objectives-report-block--in-calendar-event .objective-status.is-set .objective-status-option:nth-child(3) .objective-status-dot.is-active {
    background: #9b602a; }
  .objectives-report-block.objectives-report-block--in-calendar-event .objective-status.is-set .objective-status-option:nth-child(4) .objective-status-dot.is-active {
    background: #5aa05c; }
  .objectives-report-block.objectives-report-block--in-calendar-event .objective-status-options {
    position: absolute;
    width: 270px;
    top: 0;
    left: 0;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: 22px 14px;
    gap: 4px; }
  .objectives-report-block.objectives-report-block--in-calendar-event .objective-status-option {
    display: grid;
    grid-template-rows: 22px 14px;
    align-items: center;
    justify-items: center;
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    min-width: 0; }
    .objectives-report-block.objectives-report-block--in-calendar-event .objective-status-option:hover .objective-status-dot {
      border-color: rgba(255, 255, 255, 0.6); }
  .objectives-report-block.objectives-report-block--in-calendar-event .objective-status-label {
    color: #dfdfdf;
    text-align: center;
    font-size: 0.72em;
    text-transform: uppercase;
    opacity: 0.75;
    letter-spacing: 0.02em;
    user-select: none;
    line-height: 14px; }

.objectives-report-block:not(.objectives-report-block--expanded) .objectives-report-row {
  position: relative;
  overflow: hidden; }
  .objectives-report-block:not(.objectives-report-block--expanded) .objectives-report-row::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 5px;
    border-radius: 6px 0 0 6px;
    background: transparent;
    pointer-events: none; }
  .objectives-report-block:not(.objectives-report-block--expanded) .objectives-report-row.objectives-report-row--critical-accent::before {
    background: #9e2222; }

.objectives-report-block:not(.objectives-report-block--in-calendar-event) .objectives-report-header {
  position: relative; }

.objectives-report-block:not(.objectives-report-block--in-calendar-event) .objectives-block-expand-toggle {
  position: absolute;
  top: -5px;
  right: -2px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  margin: 0;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: background 160ms ease, border-color 160ms ease, transform 160ms ease; }

.objectives-report-block:not(.objectives-report-block--in-calendar-event) .objectives-block-expand-toggle:hover {
  background: rgba(0, 0, 0, 0.38);
  border-color: #b8b8b8; }

.objectives-report-block:not(.objectives-report-block--in-calendar-event) .objectives-block-expand-toggle__icon {
  display: block;
  width: 14px;
  height: 14px;
  object-fit: contain;
  opacity: 0.95; }

.objectives-report-block.objectives-report-block--in-calendar-event .objectives-report-header {
  position: relative; }

.objectives-report-block.objectives-report-block--in-calendar-event .objectives-block-expand-toggle {
  position: absolute;
  top: -5px;
  right: -2px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  margin: 0;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: background 160ms ease, border-color 160ms ease, transform 160ms ease; }

.objectives-report-block.objectives-report-block--in-calendar-event .objectives-block-expand-toggle:hover {
  background: rgba(0, 0, 0, 0.38);
  border-color: #b8b8b8; }

.objectives-report-block.objectives-report-block--in-calendar-event .objectives-block-expand-toggle__icon {
  display: block;
  width: 14px;
  height: 14px;
  object-fit: contain;
  opacity: 0.95; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.team-leader-evaluation-overlay {
  position: fixed;
  inset: 0;
  z-index: 1070;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  background: radial-gradient(circle at top, rgba(90, 195, 255, 0.12), transparent 42%), rgba(12, 38, 55, 0.82);
  backdrop-filter: blur(4px); }

.team-leader-evaluation-overlay__panel {
  width: 100%;
  max-width: 34rem;
  padding: 1.5rem 1.55rem 1.35rem;
  border: 1px solid rgba(90, 195, 255, 0.28);
  border-radius: 0.9rem;
  background: linear-gradient(180deg, rgba(30, 48, 66, 0.96) 0%, rgba(23, 39, 56, 0.98) 100%);
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.42), inset 0 1px 0 rgba(90, 195, 255, 0.12); }

.team-leader-evaluation-overlay__header {
  margin-bottom: 1.15rem;
  text-align: center; }

.team-leader-evaluation-overlay__title {
  margin: 0;
  color: #dfdfdf;
  font-size: 1.08rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase; }

.team-leader-evaluation-overlay__eyebrow {
  margin: 0.35rem 0 0;
  color: rgba(90, 195, 255, 0.88);
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase; }

.team-leader-evaluation-overlay__leader-card {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
  padding: 0.85rem 1rem;
  border: 1px solid rgba(90, 195, 255, 0.18);
  border-radius: 0.65rem;
  background: linear-gradient(135deg, rgba(12, 38, 55, 0.55), rgba(22, 52, 71, 0.42));
  box-shadow: inset 0 1px 0 rgba(90, 195, 255, 0.08); }

.team-leader-evaluation-overlay__leader-identity {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem; }

.team-leader-evaluation-overlay__leader-rank-icon {
  width: 2rem;
  height: 2rem;
  object-fit: contain;
  flex-shrink: 0;
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.35)); }

.team-leader-evaluation-overlay__leader-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.12rem; }

.team-leader-evaluation-overlay__leader-rank-label {
  color: #dfdfdf;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  line-height: 1.2; }

.team-leader-evaluation-overlay__leader-name {
  color: #f5df8a;
  font-size: 0.98rem;
  font-weight: 700;
  line-height: 1.2; }

.team-leader-evaluation-overlay__intro {
  margin: 0 0 0.85rem;
  color: #b8b8b8;
  font-size: 0.88rem;
  line-height: 1.6;
  text-align: center; }
  .team-leader-evaluation-overlay__intro--confirm {
    margin-bottom: 1rem;
    padding: 0.9rem 1rem;
    border: 1px solid rgba(90, 195, 255, 0.18);
    border-radius: 0.65rem;
    background: rgba(12, 38, 55, 0.34);
    text-align: left; }

.team-leader-evaluation-overlay__intro-text {
  margin: 0; }
  .team-leader-evaluation-overlay__intro-text + .team-leader-evaluation-overlay__intro-text {
    margin-top: 0.65rem; }

.team-leader-evaluation-overlay__privacy-notice {
  margin-bottom: 1.15rem;
  padding: 0.72rem 0.85rem;
  border-left: 3px solid rgba(90, 195, 255, 0.75);
  border-radius: 0.45rem;
  background: rgba(12, 38, 55, 0.38);
  color: rgba(223, 223, 223, 0.92);
  font-size: 0.82rem;
  line-height: 1.55; }

.team-leader-evaluation-overlay__section {
  margin-bottom: 1rem; }

.team-leader-evaluation-overlay__section-label,
.team-leader-evaluation-overlay__comment-label,
.team-leader-evaluation-overlay__summary-label {
  display: block;
  margin: 0 0 0.5rem;
  color: rgba(116, 123, 129, 0.95);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase; }

.team-leader-evaluation-stars {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem; }
  .team-leader-evaluation-stars--readonly {
    margin-bottom: 0.35rem; }

.team-leader-evaluation-stars-readonly {
  margin: 0 0 0.35rem;
  color: #747b81;
  font-size: 0.88rem;
  font-style: italic;
  text-align: center; }
  .team-leader-evaluation-stars-readonly--empty {
    padding: 0.15rem 0; }

.team-leader-evaluation-stars__star {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.35rem;
  height: 3.35rem;
  padding: 0;
  border: none;
  border-radius: 999px;
  background: rgba(12, 38, 55, 0.42);
  color: rgba(116, 123, 129, 0.72);
  font-size: 2rem;
  line-height: 1;
  cursor: pointer;
  transition: color 0.18s ease, background-color 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease; }
  .team-leader-evaluation-stars__star.is-active, .team-leader-evaluation-stars__star--filled {
    background: rgba(184, 148, 46, 0.22);
    color: #f5df8a;
    box-shadow: 0 0 0 1px rgba(232, 197, 71, 0.35), 0 8px 18px rgba(232, 197, 71, 0.16); }
  .team-leader-evaluation-stars__star.is-preview {
    background: rgba(184, 148, 46, 0.16);
    color: rgba(245, 223, 138, 0.92);
    box-shadow: 0 0 0 1px rgba(232, 197, 71, 0.28), 0 6px 14px rgba(232, 197, 71, 0.12); }
  .team-leader-evaluation-stars__star--filled {
    cursor: default; }
  .team-leader-evaluation-stars__star:not(:disabled):hover {
    transform: translateY(-2px) scale(1.03);
    color: rgba(245, 223, 138, 0.88); }
  .team-leader-evaluation-stars__star:disabled {
    opacity: 0.55;
    cursor: not-allowed; }

.team-leader-evaluation-overlay__comment-input {
  width: stretch;
  min-height: 6rem;
  padding: 0.72rem 0.82rem;
  border: 1px solid rgba(90, 195, 255, 0.22);
  border-radius: 0.55rem;
  background: rgba(12, 38, 55, 0.58);
  color: #dfdfdf;
  font: inherit;
  line-height: 1.5;
  resize: vertical;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease; }
  .team-leader-evaluation-overlay__comment-input::placeholder {
    color: rgba(116, 123, 129, 0.82); }
  .team-leader-evaluation-overlay__comment-input:focus {
    outline: none;
    border-color: rgba(90, 195, 255, 0.55);
    background: rgba(12, 38, 55, 0.72);
    box-shadow: 0 0 0 3px rgba(90, 195, 255, 0.12); }

.team-leader-evaluation-overlay__summary {
  margin-bottom: 1rem;
  padding: 1rem 1.05rem;
  border: 1px solid rgba(90, 195, 255, 0.18);
  border-radius: 0.65rem;
  background: rgba(12, 38, 55, 0.38); }

.team-leader-evaluation-overlay__summary-rating {
  margin: 0 0 0.95rem;
  color: #f5df8a;
  font-size: 0.84rem;
  font-weight: 600;
  text-align: center; }

.team-leader-evaluation-overlay__summary-comment {
  margin: 0;
  padding: 0.72rem 0.8rem;
  border-radius: 0.45rem;
  background: rgba(12, 38, 55, 0.45);
  color: #dfdfdf;
  font-size: 0.86rem;
  line-height: 1.55;
  white-space: pre-wrap;
  word-break: break-word; }
  .team-leader-evaluation-overlay__summary-comment--empty {
    background: transparent;
    color: #747b81;
    font-style: italic;
    padding-left: 0;
    padding-right: 0; }

.team-leader-evaluation-overlay__error {
  margin: 0 0 0.75rem;
  padding: 0.55rem 0.7rem;
  border-radius: 0.45rem;
  background: rgba(209, 35, 35, 0.12);
  color: #df3e3e;
  font-size: 0.82rem;
  text-align: center; }

.team-leader-evaluation-overlay__footer {
  display: flex;
  gap: 0.75rem;
  margin-top: 0.35rem; }
  .team-leader-evaluation-overlay__footer--center {
    justify-content: center; }
  .team-leader-evaluation-overlay__footer--confirm {
    justify-content: space-between; }

.team-leader-evaluation-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 8rem;
  padding: 0.72rem 1.25rem;
  border: 1px solid transparent;
  border-radius: 999px;
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease, background 0.18s ease, opacity 0.18s ease; }
  .team-leader-evaluation-btn:not(:disabled):active {
    transform: translateY(1px); }
  .team-leader-evaluation-btn:disabled {
    opacity: 1;
    cursor: not-allowed; }
  .team-leader-evaluation-btn--primary:not(:disabled) {
    border-color: rgba(90, 195, 255, 0.55);
    color: #ffffff;
    background: linear-gradient(135deg, #5891c9 0%, #3a78b4 52%, #004268 100%);
    box-shadow: 0 10px 24px rgba(0, 72, 114, 0.28); }
    .team-leader-evaluation-btn--primary:not(:disabled):hover {
      box-shadow: 0 14px 28px rgba(0, 72, 114, 0.36); }
  .team-leader-evaluation-btn--primary:disabled {
    border-color: rgba(116, 123, 129, 0.22);
    color: rgba(116, 123, 129, 0.88);
    background: rgba(12, 38, 55, 0.72);
    box-shadow: none; }
  .team-leader-evaluation-btn--secondary:not(:disabled) {
    border-color: rgba(116, 123, 129, 0.28);
    color: #dfdfdf;
    background: rgba(12, 38, 55, 0.55); }
    .team-leader-evaluation-btn--secondary:not(:disabled):hover {
      border-color: rgba(90, 195, 255, 0.42);
      background: rgba(21, 28, 36, 0.88); }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.hangar-page {
  padding: 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 100px);
  max-height: calc(100vh - 100px);
  overflow: hidden; }

.hangar-page--personal-hub {
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  max-height: 100%;
  padding: 12px 16px 0 0;
  overflow: hidden; }

/* ---------------- filters ---------------- */
.hangar-filters {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0.35rem 0.5rem;
  margin-top: 0;
  margin-bottom: 0;
  border-radius: 8px;
  box-sizing: border-box;
  width: 100%; }
  .hangar-filters .filter-container .user-filter .input {
    width: 100%; }
  .hangar-filters .hangar-toggles {
    display: flex;
    gap: 12px;
    flex-wrap: wrap; }
    .hangar-filters .hangar-toggles .toggle {
      position: relative;
      display: flex;
      align-items: center;
      width: max-content;
      padding-left: 45px;
      min-height: 26px;
      cursor: pointer; }
      .hangar-filters .hangar-toggles .toggle input {
        display: none; }
      .hangar-filters .hangar-toggles .toggle .toggle-switch {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%); }
      .hangar-filters .hangar-toggles .toggle .toggle-label {
        font-size: 14px;
        color: #b8b8b8;
        white-space: nowrap;
        line-height: 1; }

.hangar-filters--horizontal {
  flex-shrink: 0;
  z-index: 1;
  isolation: isolate;
  background-color: #172738;
  background: linear-gradient(180deg, rgba(0, 48, 77, 0.72), rgba(21, 28, 36, 0.42)), rgba(0, 48, 77, 0.55);
  border: 1px solid rgba(58, 120, 180, 0.55);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35), 0 12px 28px rgba(0, 0, 0, 0.35); }
  .hangar-filters--horizontal .hangar-filters__top {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.85rem 1.25rem;
    margin-top: 5px; }
  .hangar-filters--horizontal.hangar-filters--with-help {
    position: relative;
    padding-right: 2.25rem;
    padding-left: 1.1rem;
    overflow: visible;
    z-index: 1;
    isolation: auto; }
  .hangar-filters--horizontal .hangar-filters__help-anchor {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    z-index: 11; }
  .hangar-filters--horizontal .hangar-filters__help-anchor .accounting-help-trigger {
    position: static; }
  .hangar-filters--horizontal .hangar-filters__help-popover {
    top: 1.75rem;
    right: 0;
    z-index: 12; }
  .hangar-filters--horizontal .hangar-header {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 0 0 auto; }
  .hangar-filters--horizontal .hangar-filters__handles {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 0.5rem;
    margin: 0; }
  .hangar-filters--horizontal .hangar-filters__handle-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    padding: 0;
    margin: 0;
    border: 2px solid rgba(58, 120, 180, 0.35);
    border-radius: 50%;
    background: rgba(21, 28, 36, 0.95);
    cursor: pointer;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
    transition: border-color 0.15s ease, box-shadow 0.15s ease; }
    .hangar-filters--horizontal .hangar-filters__handle-btn:hover {
      border-color: rgba(90, 195, 255, 0.65); }
    .hangar-filters--horizontal .hangar-filters__handle-btn:focus-visible {
      outline: 2px solid rgba(58, 120, 180, 0.75);
      outline-offset: 2px; }
  .hangar-filters--horizontal .hangar-filters__handle-btn--active {
    border-color: #c78445;
    box-shadow: 0 0 0 1px rgba(199, 132, 69, 0.45), 0 4px 12px rgba(0, 0, 0, 0.4); }
  .hangar-filters--horizontal .hangar-filters__handle-btn--master.hangar-filters__handle-btn--active {
    border-color: #c78445; }
  .hangar-filters--horizontal .hangar-filters__handle-avatar {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    border-radius: 50%; }
  .hangar-filters--horizontal .hangar-filters__toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 1rem 1.5rem;
    width: 100%; }
  .hangar-filters--horizontal .hangar-filters__group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    flex: 0 1 auto;
    min-width: 0; }
  .hangar-filters--horizontal .hangar-filters__group--ingame {
    position: relative;
    flex: 0 0 220px;
    margin-left: auto;
    min-width: 200px;
    align-items: stretch;
    bottom: 10px; }
  .hangar-filters--horizontal .hangar-filters__pill-row {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    align-items: center; }
  .hangar-filters--horizontal .hangar-filters__group--bulk {
    position: relative;
    flex: 0 0 auto;
    align-self: center;
    justify-content: center;
    flex-direction: column;
    gap: 8px;
    padding-top: 0.15rem;
    bottom: 8px; }
  .hangar-filters--horizontal .hangar-filters__bulk-toggle,
  .hangar-filters--horizontal .hangar-filters__view-toggle {
    display: inline-flex;
    flex-shrink: 0;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid #747b81;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);
    background: #1c2d38; }
  .hangar-filters--horizontal .hangar-filters__bulk-toggle-btn {
    min-width: 52px;
    padding: 6px 14px;
    margin: 0;
    border: none;
    background: transparent;
    color: #b8b8b8;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease; }
    .hangar-filters--horizontal .hangar-filters__bulk-toggle-btn:not(:last-child) {
      border-right: 1px solid #384858; }
    .hangar-filters--horizontal .hangar-filters__bulk-toggle-btn:disabled {
      opacity: 0.42;
      cursor: not-allowed; }
    .hangar-filters--horizontal .hangar-filters__bulk-toggle-btn:not(:disabled):not(.hangar-filters__bulk-toggle-btn--active):hover {
      background: #384858;
      color: #dfdfdf; }
    .hangar-filters--horizontal .hangar-filters__bulk-toggle-btn--active {
      background: radial-gradient(circle at center, #004872 0%, #00304d 100%), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      color: #dfdfdf;
      box-shadow: inset 0 0 0 1px #004872; }

.hangar-header-title {
  font-size: 1.1rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #dfdfdf;
  white-space: nowrap;
  margin: 0; }

.hangar-header-lines {
  position: relative;
  width: 20px;
  height: 27px;
  flex-shrink: 0; }

.hangar-header-lines span {
  position: absolute;
  width: 22px;
  height: 3px;
  background: #c78445;
  transform: rotate(-65deg);
  transform-origin: left center; }

.hangar-header-lines span:first-child {
  top: 20px;
  left: 12px; }

.hangar-header-lines span:last-child {
  top: 20px; }

.hangar-handle-switch {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 0px;
  margin-top: -20px; }

.hangar-handle-switch .handle-btn {
  width: 100%;
  padding: 6px 10px;
  background: #151c24;
  border: 1px solid #2b2b2b;
  border-radius: 8px;
  color: #747b81;
  font-weight: 600;
  letter-spacing: .5px;
  text-align: left;
  cursor: pointer;
  transition: background .15s ease, border-color .15s ease, color .15s ease;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3); }

.hangar-handle-switch .handle-btn:hover {
  background: #1d1d1d;
  border-color: #3a3a3a;
  color: #dfdfdf; }

.hangar-handle-switch .handle-btn.active {
  background: linear-gradient(90deg, #2f1b00, #5c3200);
  border-color: #c27a17;
  color: #ffd28a;
  box-shadow: inset 0 0 0 1px rgba(255, 210, 138, 0.35); }

.hangar-handle-switch .handle-btn.active::before {
  content: "▶";
  margin-right: 8px;
  color: #ffd28a;
  font-size: 11px; }

.hangar-filter-pills {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-wrap: wrap; }

.filter-pill {
  padding: 6px 12px;
  font-size: 13px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);
  border: 1px solid transparent;
  color: #dfdfdf; }
  .filter-pill.ships, .filter-pill.sizes, .filter-pill.items, .filter-pill.item-types, .filter-pill.lawful, .filter-pill.members-panel {
    padding: 6px 12px;
    font-size: 13px;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3); }
    .filter-pill.ships.active, .filter-pill.sizes.active, .filter-pill.items.active, .filter-pill.item-types.active, .filter-pill.lawful.active, .filter-pill.members-panel.active {
      background: radial-gradient(circle at center, #004872 0%, #00304d 100%), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      border: 1px solid #004872;
      color: #dfdfdf; }
    .filter-pill.ships.inactive, .filter-pill.sizes.inactive, .filter-pill.items.inactive, .filter-pill.item-types.inactive, .filter-pill.lawful.inactive, .filter-pill.members-panel.inactive {
      background: radial-gradient(circle at center, #2a3847 0%, #1c2d38 100%), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      border: 1px solid #747b81;
      color: #b8b8b8; }
    .filter-pill.ships.locked, .filter-pill.ships:disabled, .filter-pill.sizes.locked, .filter-pill.sizes:disabled, .filter-pill.items.locked, .filter-pill.items:disabled, .filter-pill.item-types.locked, .filter-pill.item-types:disabled, .filter-pill.lawful.locked, .filter-pill.lawful:disabled, .filter-pill.members-panel.locked, .filter-pill.members-panel:disabled {
      opacity: 0.42;
      cursor: not-allowed;
      box-shadow: none; }
    .filter-pill.ships.locked:hover, .filter-pill.ships:disabled:hover, .filter-pill.sizes.locked:hover, .filter-pill.sizes:disabled:hover, .filter-pill.items.locked:hover, .filter-pill.items:disabled:hover, .filter-pill.item-types.locked:hover, .filter-pill.item-types:disabled:hover, .filter-pill.lawful.locked:hover, .filter-pill.lawful:disabled:hover, .filter-pill.members-panel.locked:hover, .filter-pill.members-panel:disabled:hover {
      border-color: #747b81; }
    .filter-pill.ships:hover:not(:disabled):not(.locked), .filter-pill.sizes:hover:not(:disabled):not(.locked), .filter-pill.items:hover:not(:disabled):not(.locked), .filter-pill.item-types:hover:not(:disabled):not(.locked), .filter-pill.lawful:hover:not(:disabled):not(.locked), .filter-pill.members-panel:hover:not(:disabled):not(.locked) {
      border: 1px solid #5ac3ff; }

/* ---------- INGAME REACT-SELECT ---------- */
.ingame-select {
  font-size: 13px; }

/* Input */
.ingame-select__control {
  background-color: #dfdfdf !important;
  border: 1px solid #2c6d91;
  min-height: 34px;
  font-size: 13px;
  box-shadow: none; }

.ingame-select__control--is-focused {
  border-color: #3b7fa6;
  box-shadow: none; }

/* Value & placeholder */
.ingame-select__single-value,
.ingame-select__placeholder,
.ingame-select__input-container {
  color: #cdefff;
  font-size: 13px; }

/* Dropdown */
.ingame-select__menu {
  background: #05141b;
  border: 1px solid #2c6d91;
  font-size: 13px;
  z-index: 200; }

/* Options */
.ingame-select__option {
  background: transparent;
  color: #cdefff;
  font-size: 13px;
  cursor: pointer; }

.ingame-select__option--is-focused {
  background: #0f2f3f; }

.ingame-select__option--is-selected {
  background: #1b5874; }

/* Dropdown arrow */
.ingame-select__indicator {
  color: #7fb6d6; }

.ingame-select__indicator:hover {
  color: #cdefff; }

.ingame-select-block {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  width: 100%; }

/* Validate button */
.ingame-validate-btn {
  width: 100%;
  padding: 6px;
  font-size: 13px;
  background: #0d3c54;
  border: 1px solid #2c6d91;
  color: #cdefff;
  border-radius: 4px;
  cursor: pointer; }

.ingame-validate-btn:hover {
  background: #15546f;
  border-color: #3b7fa6; }

.ingame-validate-btn:disabled {
  opacity: .4;
  cursor: not-allowed; }

/* ---------------- content ---------------- */
.hangar-layout {
  display: flex;
  flex-direction: column;
  gap: 0;
  align-items: stretch;
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden; }

.hangar-content {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-left: 0;
  width: 100%;
  min-width: 0;
  min-height: 0;
  flex: 1 1 auto;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 1rem 0 1.5rem;
  position: relative;
  z-index: 0;
  scrollbar-width: none; }

/* English comment: empty state — wide horizontal call-to-action */
.hangar-empty-card {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  align-self: center;
  width: 100%;
  max-width: 920px;
  min-height: 112px;
  margin-top: 18px;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid rgba(58, 120, 180, 0.28);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.22), inset 0 1px 0 rgba(255, 255, 255, 0.04);
  backdrop-filter: blur(8px) saturate(120%);
  -webkit-backdrop-filter: blur(8px) saturate(120%);
  background: linear-gradient(105deg, rgba(30, 52, 72, 0.72) 0%, rgba(22, 40, 58, 0.55) 45%, rgba(18, 35, 52, 0.65) 100%); }

.hangar-empty-card__accent {
  flex: 0 0 5px;
  background: linear-gradient(180deg, #3a78b4 0%, #004872 42%, #00304d 100%);
  box-shadow: 2px 0 12px rgba(58, 120, 180, 0.25); }

.hangar-empty-card__body {
  flex: 1;
  padding: 22px 26px 22px 22px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px; }

.hangar-empty-card__title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: #dfdfdf; }

.hangar-empty-card__text {
  margin: 0;
  font-size: 15px;
  line-height: 1.55;
  color: #b8b8b8;
  max-width: 52em; }

.hangar-empty-card__note {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: #747b81;
  max-width: 52em; }

.hangar-empty-card__link {
  color: #3a78b4;
  text-decoration: none;
  font-weight: 600;
  border-bottom: 1px solid rgba(58, 120, 180, 0.35);
  transition: color 0.15s ease, border-color 0.15s ease; }
  .hangar-empty-card__link:hover {
    color: #5ac3ff;
    border-bottom-color: rgba(0, 117, 185, 0.55); }
  .hangar-empty-card__link:focus-visible {
    outline: 2px solid #3a78b4;
    outline-offset: 2px;
    border-bottom-color: transparent; }

.hangar-empty-card__actions {
  margin-top: 4px; }

.hangar-empty-card__cta {
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  color: #dfdfdf;
  background: rgba(58, 120, 180, 0.22);
  border: 1px solid rgba(58, 120, 180, 0.45);
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease; }
  .hangar-empty-card__cta:hover {
    color: #ffffff;
    background: rgba(58, 120, 180, 0.35);
    border-color: rgba(0, 117, 185, 0.55); }
  .hangar-empty-card__cta:focus-visible {
    outline: 2px solid #3a78b4;
    outline-offset: 2px; }

.vehicle-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 16px; }

.vehicle-list {
  display: flex;
  flex-direction: column;
  gap: 8px; }

.vehicle-list-row {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(6px) saturate(33%);
  -webkit-backdrop-filter: blur(4px) saturate(33%);
  background-color: #23497748;
  border: 1px solid rgba(51, 102, 126, 0.329);
  transition: border-color 0.15s ease; }
  .vehicle-list-row:hover, .vehicle-list-row--expanded {
    border-color: #004872; }
  .vehicle-list-row.loaner {
    border-left: 4px solid #9b602a; }

.vehicle-list-row__header {
  display: grid;
  grid-template-columns: 64px minmax(120px, 1.4fr) minmax(100px, 1.2fr) minmax(90px, 1fr) auto max-content;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 8px 12px;
  border: 0;
  background: linear-gradient(180deg, rgba(0, 48, 77, 0.72), rgba(21, 28, 36, 0.42)), rgba(0, 48, 77, 0.55);
  color: inherit;
  text-align: left;
  cursor: pointer; }

.vehicle-list-row__thumb {
  width: 64px;
  height: 40px;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
  background: rgba(21, 28, 36, 0.45);
  border: 1px solid rgba(51, 102, 126, 0.45); }
  .vehicle-list-row__thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    pointer-events: none; }

.vehicle-list-row__thumb-placeholder {
  display: block;
  width: 100%;
  height: 100%; }

.vehicle-list-row__title {
  margin: 0;
  min-width: 0; }
  .vehicle-list-row__title .loaner-source {
    font-size: 12px;
    color: #b8b8b8;
    margin-top: 2px; }

.vehicle-list-row__label {
  min-width: 0; }
  .vehicle-list-row__label .ship-label-row {
    display: flex;
    align-items: center;
    min-height: 18px; }
  .vehicle-list-row__label .ship-label-trigger,
  .vehicle-list-row__label .ship-label-editor {
    display: inline-flex;
    align-items: center;
    gap: 0;
    padding: 0;
    margin: 0;
    border: 0;
    background: transparent;
    font: inherit;
    text-align: left;
    max-width: 100%; }
  .vehicle-list-row__label .ship-label-trigger--editable {
    cursor: pointer; }
  .vehicle-list-row__label .ship-label-trigger--readonly {
    cursor: default;
    pointer-events: none; }
  .vehicle-list-row__label .ship-label-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
    line-height: 1.2;
    text-transform: uppercase;
    font-size: 14px; }
  .vehicle-list-row__label .ship-label-text--placeholder {
    color: #747b81;
    text-transform: none; }
  .vehicle-list-row__label .ship-label-row--rsi .ship-label-trigger,
  .vehicle-list-row__label .ship-label-row--rsi .ship-label-editor,
  .vehicle-list-row__label .ship-label-row--rsi .ship-label-text,
  .vehicle-list-row__label .ship-label-row--rsi .ship-label-input {
    color: #5ac3ff; }
  .vehicle-list-row__label .ship-label-row--rsi .ship-label-icon {
    background-color: #5ac3ff; }
  .vehicle-list-row__label .ship-label-row--user .ship-label-trigger,
  .vehicle-list-row__label .ship-label-row--user .ship-label-editor,
  .vehicle-list-row__label .ship-label-row--user .ship-label-text,
  .vehicle-list-row__label .ship-label-row--user .ship-label-input {
    color: #dfdfdf; }
  .vehicle-list-row__label .ship-label-row--user .ship-label-icon {
    background-color: #dfdfdf; }
  .vehicle-list-row__label .ship-label-row--empty .ship-label-trigger,
  .vehicle-list-row__label .ship-label-row--empty .ship-label-editor,
  .vehicle-list-row__label .ship-label-row--empty .ship-label-text,
  .vehicle-list-row__label .ship-label-row--empty .ship-label-input {
    color: #747b81; }
  .vehicle-list-row__label .ship-label-row--empty .ship-label-icon {
    background-color: #747b81; }
  .vehicle-list-row__label .ship-label-icon {
    position: relative;
    display: inline-block;
    flex: 0 0 12px;
    width: 12px;
    height: 12px;
    margin-right: 7px;
    top: 1px;
    background-color: #747b81;
    mask: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) no-repeat center/contain;
    -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) no-repeat center/contain; }
  .vehicle-list-row__label .ship-label-input {
    width: 120px;
    max-width: 100%;
    padding: 0 4px;
    border: 1px solid currentColor;
    border-radius: 4px;
    background: rgba(21, 28, 36, 0.35);
    font-size: 13px;
    line-height: 1.2;
    text-transform: uppercase; }
    .vehicle-list-row__label .ship-label-input:focus {
      outline: none;
      border-color: #c78445; }
    .vehicle-list-row__label .ship-label-input--error {
      border-color: #9e2222; }
  .vehicle-list-row__label .ship-label-error {
    flex: 1 1 100%;
    margin-top: 4px;
    font-size: 12px;
    line-height: 1.2;
    color: #9e2222;
    text-transform: none; }

.vehicle-list-row__label-empty {
  color: #747b81;
  font-size: 14px; }

.vehicle-list-row__manufacturer {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.vehicle-list-row__prod {
  width: max-content;
  max-width: 100%;
  justify-self: end; }
  .vehicle-list-row__prod .prod-state {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: max-content;
    min-width: unset;
    max-width: none;
    padding: 4px 10px;
    border: 1px solid rgba(51, 102, 126, 0.55);
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: 0.03em;
    text-align: center;
    text-transform: uppercase;
    background: rgba(21, 28, 36, 0.45);
    color: #dfdfdf; }
    .vehicle-list-row__prod .prod-state.flight-ready {
      background: #2a5f2d;
      border-color: #5aa05c;
      color: #c2f0c3;
      padding: 4px 10px; }
    .vehicle-list-row__prod .prod-state.in-concept {
      background: #6e441c;
      border-color: #9b602a;
      color: #d8b493;
      padding: 4px 10px; }
    .vehicle-list-row__prod .prod-state.in-production {
      background: rgba(58, 120, 180, 0.22);
      border-color: #5ac3ff;
      color: #5ac3ff; }

.vehicle-list-row__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0; }

.vehicle-list-row__remove-slot {
  flex: 0 0 54px;
  display: flex;
  align-items: center;
  justify-content: center; }

.vehicle-list-row__remove-placeholder {
  display: block;
  width: 54px;
  height: 20px; }

.vehicle-list-row__chevron {
  width: 10px;
  height: 10px;
  border-right: 2px solid #b8b8b8;
  border-bottom: 2px solid #b8b8b8;
  transform: rotate(45deg);
  transition: transform 0.2s ease;
  margin-right: 4px; }

.vehicle-list-row--expanded .vehicle-list-row__chevron {
  transform: rotate(-135deg);
  margin-top: 4px; }

.vehicle-list-row__accordion {
  padding: 8px 12px 10px;
  background: rgba(21, 28, 36, 0.35);
  border-top: 1px solid rgba(51, 102, 126, 0.35); }

.vehicle-overlay-panel--compact .overlay-content {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  grid-template-rows: auto auto;
  gap: 6px 14px;
  width: 100%; }

.vehicle-overlay-panel--compact .overlay-left,
.vehicle-overlay-panel--compact .overlay-right {
  display: contents;
  padding: 0; }

.vehicle-overlay-panel--compact .spec-line {
  gap: 4px;
  min-width: 0; }

.vehicle-overlay-panel--compact .spec-label {
  font-size: 11px; }

.vehicle-overlay-panel--compact .spec-value {
  font-size: 12px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.vehicle-overlay-panel--compact .vehicle-overlay-panel__extras {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 8px; }

.vehicle-overlay-panel--compact .vehicle-skins {
  position: static;
  top: auto;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 6px; }

.vehicle-overlay-panel--compact .vehicle-insurances {
  margin: 0;
  padding: 2px 8px;
  font-size: 12px; }

.vehicle-overlay-panel--compact .vehicle-rsi-link {
  margin-top: 8px;
  border-radius: 6px; }

.package-card .vehicle-list {
  margin-bottom: 16px; }

/* ---------------- vehicle card ---------------- */
.standalone-section {
  border-radius: 8px;
  padding: 16px 10px 8px 10px;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(6px) saturate(33%);
  -webkit-backdrop-filter: blur(4px) saturate(33%);
  background-color: #21374fe0;
  border: 1px solid rgba(51, 102, 126, 0.329); }
  .standalone-section .standalone-title {
    margin: 0 0 12px 0;
    font-size: 16px;
    font-weight: 600;
    color: #dfdfdf; }

.vehicle-card {
  position: relative;
  height: 290px;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(6px) saturate(33%);
  -webkit-backdrop-filter: blur(4px) saturate(33%);
  background-color: #23497748;
  border: 1px solid rgba(51, 102, 126, 0.329); }
  .vehicle-card:hover {
    border: 1px solid #004872; }

/* English comment: background image */
.vehicle-bg {
  position: absolute;
  inset: 0;
  overflow: hidden; }

.vehicle-bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transition: transform 0.4s ease;
  pointer-events: none; }

/* English comment: default visible content */
.vehicle-front {
  position: relative;
  z-index: 1;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 8px; }

/* ---------------- text tweaks ---------------- */
.vehicle-header {
  display: flex;
  position: relative;
  justify-content: space-between;
  gap: 8px; }

.vehicle-title {
  margin: 0 0 6px 0;
  font-size: 16px;
  font-weight: 600;
  color: #dfdfdf; }
  .vehicle-title .custom-name, .vehicle-title .loaner-source, .vehicle-title .ship-label-row {
    font-size: 14px;
    height: 0px;
    padding: 5px 0px 0px 0px; }
  .vehicle-title .loaner-source {
    color: #b8b8b8; }
  .vehicle-title .ship-label-row {
    display: flex;
    align-items: center;
    min-height: 18px;
    height: auto; }
  .vehicle-title .ship-label-trigger,
  .vehicle-title .ship-label-editor {
    display: inline-flex;
    align-items: center;
    gap: 0;
    padding: 0;
    margin: 0;
    border: 0;
    background: transparent;
    font: inherit;
    text-align: left; }
  .vehicle-title .ship-label-trigger--editable {
    cursor: pointer; }
  .vehicle-title .ship-label-trigger--readonly {
    cursor: default;
    pointer-events: none; }
  .vehicle-title .ship-label-text {
    line-height: 1.2;
    text-transform: uppercase; }
  .vehicle-title .ship-label-text--placeholder {
    color: #747b81;
    text-transform: none; }
  .vehicle-title .ship-label-row--rsi .ship-label-trigger,
  .vehicle-title .ship-label-row--rsi .ship-label-editor,
  .vehicle-title .ship-label-row--rsi .ship-label-text,
  .vehicle-title .ship-label-row--rsi .ship-label-input {
    color: #5ac3ff; }
  .vehicle-title .ship-label-row--rsi .ship-label-icon {
    background-color: #5ac3ff; }
  .vehicle-title .ship-label-row--user .ship-label-trigger,
  .vehicle-title .ship-label-row--user .ship-label-editor,
  .vehicle-title .ship-label-row--user .ship-label-text,
  .vehicle-title .ship-label-row--user .ship-label-input {
    color: #dfdfdf; }
  .vehicle-title .ship-label-row--user .ship-label-icon {
    background-color: #dfdfdf; }
  .vehicle-title .ship-label-row--empty .ship-label-trigger,
  .vehicle-title .ship-label-row--empty .ship-label-editor,
  .vehicle-title .ship-label-row--empty .ship-label-text,
  .vehicle-title .ship-label-row--empty .ship-label-input {
    color: #747b81; }
  .vehicle-title .ship-label-row--empty .ship-label-icon {
    background-color: #747b81; }
  .vehicle-title .ship-label-icon {
    position: relative;
    display: inline-block;
    flex: 0 0 12px;
    width: 12px;
    height: 12px;
    margin-right: 7px;
    top: 1px;
    background-color: #747b81;
    mask: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) no-repeat center/contain;
    -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) no-repeat center/contain; }
  .vehicle-title .ship-label-editor {
    position: relative;
    flex-wrap: wrap; }
  .vehicle-title .ship-label-error {
    flex: 1 1 100%;
    margin-top: 4px;
    font-size: 12px;
    line-height: 1.2;
    color: #9e2222;
    text-transform: none; }
  .vehicle-title .ship-label-input {
    width: 140px;
    max-width: 100%;
    padding: 0 4px;
    border: 1px solid currentColor;
    border-radius: 4px;
    background: rgba(21, 28, 36, 0.35);
    font-size: 14px;
    line-height: 1.2;
    text-transform: uppercase; }
    .vehicle-title .ship-label-input::placeholder {
      color: #747b81;
      opacity: 1;
      text-transform: none; }
    .vehicle-title .ship-label-input:focus {
      outline: none;
      border-color: #c78445; }
    .vehicle-title .ship-label-input--error {
      border-color: #9e2222; }

.vehicle-header-right {
  position: absolute;
  top: 15px;
  right: 10px;
  display: flex;
  align-items: center;
  gap: 8px; }

.manual-remove-btn {
  position: relative;
  flex-shrink: 0;
  text-transform: uppercase;
  color: #dfdfdf;
  font-size: 10px;
  border: 1px solid #7e1e1e;
  border-radius: 6px;
  bottom: 1px;
  background: radial-gradient(circle at center, #7e1e1e 0%, #491212 100%), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer; }
  .manual-remove-btn:hover:not(:disabled) {
    border: 1px solid #d12323; }
  .manual-remove-btn:disabled {
    opacity: 0.45;
    cursor: not-allowed; }

.vehicle-manufacturer {
  font-size: 14px;
  color: #b8b8b8;
  opacity: 0.85;
  pointer-events: none; }

.vehicle-meta {
  display: flex; }

.focus {
  font-size: 13px;
  font-weight: bold;
  padding: 3px 0px;
  color: #dfdfdf; }

.size {
  font-size: 13px;
  font-weight: bold;
  padding: 3px 0px;
  color: #dfdfdf; }

/* ---------------- package card ---------------- */
.package-card {
  border-radius: 8px;
  padding: 16px 10px 8px 10px;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(6px) saturate(33%);
  -webkit-backdrop-filter: blur(4px) saturate(33%);
  background-color: #21374fe0;
  border: 1px solid rgba(51, 102, 126, 0.329);
  border-left: 6px solid #004872; }

.package-title {
  margin: 0 0 12px 0;
  font-size: 16px;
  font-weight: 600;
  color: #dfdfdf; }

.package-vehicles {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  margin-bottom: 16px;
  gap: 16px; }

.package-items {
  margin-top: 12px; }
  .package-items h4 {
    margin: 0 0 6px 0;
    font-size: 14px;
    color: #b8b8b8; }
  .package-items ul {
    margin: 0;
    padding-left: 18px; }
    .package-items ul li {
      font-size: 13px;
      color: #b8b8b8;
      line-height: 1.4; }

/* ---------------- Loaners card ---------------- */
.loaner-section {
  border: 1px solid rgba(51, 102, 126, 0.329);
  border-left: 5px solid #9b602a;
  border-radius: 8px;
  padding: 16px 10px 8px 10px;
  background-color: #21374fe0;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(6px) saturate(33%);
  -webkit-backdrop-filter: blur(4px) saturate(33%); }
  .loaner-section .standalone-title {
    margin: 0 0 12px 0;
    font-size: 20px;
    font-weight: 600;
    color: #dfdfdf; }

/* ---------------- misc ---------------- */
.no-permission,
.error {
  color: #ff5f5f; }

.shaped-header {
  background: linear-gradient(180deg, rgba(0, 48, 77, 0.72), rgba(21, 28, 36, 0.42)), rgba(0, 48, 77, 0.55);
  padding: 10px 10px 15px 10px;
  margin: -16px -14px 0px -14px;
  color: #dfdfdf;
  /* English comment: asymmetric sci-fi header shape */
  clip-path: polygon(0% 0%, 100% 0%, 100% 70%, 69% 70%, 60% 100%, 0% 100%); }

.vehicle-overlay {
  position: absolute;
  height: 245px;
  inset: 0;
  z-index: 2;
  background: linear-gradient(180deg, rgba(0, 48, 77, 0.72), rgba(21, 28, 36, 0.42)), rgba(0, 48, 77, 0.55);
  clip-path: polygon(0% 8%, 60% 8%, 70% 0%, 100% 0%, 100% 100%, 0% 100%);
  transform: translateY(110%);
  transition: transform 0.4s ease;
  display: flex;
  flex-direction: column; }

.vehicle-card:hover .vehicle-bg {
  transform: scale(1.1);
  transition: transform 0.4s ease; }

.vehicle-card:hover .vehicle-overlay {
  transform: translateY(20%); }

/* English comment: main grid respecting the clipped top */
.overlay-content {
  position: relative;
  display: grid;
  width: 100%;
  grid-template-columns: minmax(0, 3fr) minmax(140px, 1fr);
  grid-template-rows: auto 1fr;
  gap: 10px 45px;
  flex: 1; }

/* English comment: production state aligned in high-right area */
.overlay-prod {
  grid-column: 2;
  justify-self: end; }

.prod-state {
  display: grid;
  font-size: 12px;
  padding: 3px 0px 3px 16px;
  width: 145px;
  text-align: center; }
  .prod-state.flight-ready {
    background: #2a5f2d;
    color: #c2f0c3;
    text-align: right;
    padding-right: 30px; }
  .prod-state.in-concept {
    background: #6e441c;
    color: #d8b493;
    text-align: right;
    padding-right: 30px; }

/* English comment: left placeholder column */
.overlay-left {
  grid-column: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
  color: #b8b8b8;
  padding: 10px; }

/* English comment: right real specs column */
.overlay-right {
  grid-column: 2;
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
  color: #b8b8b8;
  padding: 10px; }

.spec-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 6px; }

/* English comment: left part (label) */
.spec-label {
  font-weight: 600;
  color: #b8b8b8;
  font-size: 12px;
  align-self: start;
  white-space: nowrap; }

/* English comment: right part (value) */
.spec-value {
  font-weight: 600;
  color: #dfdfdf;
  text-align: right; }

.vehicle-skins {
  position: relative;
  padding: 5px 10px;
  top: 25px;
  font-size: 13px;
  color: #b8b8b8; }

.vehicle-insurances {
  padding: 3px 8px 3px 8px;
  margin-left: auto;
  margin-right: 10px;
  margin-bottom: 5px;
  font-size: 13px;
  color: #b8b8b8;
  font-weight: bold;
  width: fit-content;
  background: #2a5f2d;
  border-radius: 6px; }

/* English comment: bottom RSI banner */
.vehicle-rsi-link {
  display: block;
  background: #27577e;
  text-align: center;
  padding: 6px;
  font-size: 13px;
  color: #dfdfdf;
  text-decoration: none;
  cursor: pointer; }
  .vehicle-rsi-link:hover {
    text-decoration: none; }

/* ---------- ITEM CARD ---------- */
/* ---------- ITEMS ---------- */
.items-section {
  margin-top: 3rem;
  padding: 16px; }
  .items-section .standalone-title {
    margin: 0 0 12px 0;
    font-size: 20px;
    font-weight: 600;
    color: #dfdfdf; }

.item-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 1rem; }

.item-list {
  display: flex;
  flex-direction: column;
  gap: 8px; }

.item-list-row {
  display: grid;
  grid-template-columns: 64px minmax(140px, 2fr) minmax(48px, auto) max-content;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  border-radius: 8px;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(6px) saturate(33%);
  -webkit-backdrop-filter: blur(6px) saturate(33%);
  background-color: #23497748;
  border: 1px solid rgba(51, 102, 126, 0.329);
  transition: border-color 0.15s ease; }
  .item-list-row:hover {
    border-color: #004872; }

.item-list-row__thumb {
  width: 64px;
  height: 40px;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
  background: rgba(21, 28, 36, 0.45);
  border: 1px solid rgba(51, 102, 126, 0.45); }
  .item-list-row__thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    pointer-events: none; }

.item-list-row__thumb-placeholder {
  display: block;
  width: 100%;
  height: 100%; }

.item-list-row__name {
  min-width: 0;
  margin: 0;
  -webkit-line-clamp: 2; }

.item-list-row__quantity {
  min-width: 48px;
  text-align: center; }

.item-list-row__type {
  width: max-content;
  max-width: 100%;
  justify-self: end; }

.item-type-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  max-width: 100%;
  padding: 4px 10px;
  border: 1px solid rgba(51, 102, 126, 0.55);
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: 0.03em;
  text-align: center;
  text-transform: uppercase;
  background: #2a5f2d;
  border-color: #5aa05c;
  color: #dfdfdf; }

.item-list-row.type-fps-equipment .item-type-chip {
  background: rgba(155, 96, 42, 0.22);
  border-color: #9b602a;
  color: #d8b493; }

.item-list-row.type-skin .item-type-chip {
  background: rgba(90, 195, 255, 0.2);
  border-color: #5ac3ff;
  color: #dfdfdf; }

.item-list-row.type-component .item-type-chip {
  background: rgba(58, 120, 180, 0.22);
  border-color: #3a78b4;
  color: #5ac3ff; }

.item-list-row.type-insurance .item-type-chip {
  background: #2a5f2d;
  border-color: #5aa05c;
  color: #c2f0c3; }

.item-list-row.type-upgrade .item-type-chip {
  background: rgba(56, 72, 88, 0.35);
  border-color: #747b81;
  color: #dfdfdf; }

.package-items .item-list {
  margin-top: 0; }

/* ---------- ITEM CARD ---------- */
.item-card {
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: flex-start;
  min-height: 90px;
  max-height: 179px;
  border: 2px solid #004872;
  border-radius: 8px;
  transition: border-color 0.15s ease, background 0.15s ease;
  backdrop-filter: blur(6px) saturate(33%);
  -webkit-backdrop-filter: blur(4px) saturate(33%);
  border: 1px solid rgba(51, 102, 126, 0.329);
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3); }
  .item-card:hover {
    background: linear-gradient(180deg, rgba(0, 48, 77, 0.72), rgba(21, 28, 36, 0.42)), rgba(0, 48, 77, 0.55);
    border-color: #004872; }

/* ---------- HEADER ---------- */
.item-card-header {
  display: flex;
  padding: 10px 10px 5px 10px;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.5rem;
  margin-bottom: 0px;
  background: linear-gradient(180deg, rgba(0, 48, 77, 0.72), rgba(21, 28, 36, 0.42)), rgba(0, 48, 77, 0.55);
  border-radius: 8px 8px 0px 0px;
  /* English comment: force consistent header height */
  min-height: calc(1.2em * 2); }

.item-name {
  font-size: 0.9rem;
  font-weight: 500;
  line-height: 1.2;
  color: #dfdfdf;
  /* English comment: limit title to 2 lines */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden; }

.item-quantity {
  font-size: 0.75rem;
  color: #dfdfdf;
  white-space: nowrap; }

/* ---------- IMAGE ---------- */
.item-image-frame {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin: 0;
  border-radius: 0px 0px 8px 8px; }

.item-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  pointer-events: none;
  user-select: none; }

.item-card:hover .item-image {
  transform: scale(1.1);
  transition: transform 0.4s ease; }

/* ---------- FOOTER ---------- */
.item-card-footer {
  position: absolute;
  bottom: 0px;
  right: 0;
  padding: 0;
  display: flex;
  justify-content: flex-end;
  pointer-events: none;
  background: #2a5f2d;
  border-radius: 0px 0px 8px 0px;
  /* English comment: angled cut on the left side */
  clip-path: polygon(30px 0%, 100% 0%, 100% 100%, 0% 100%, 0% 90%); }

.item-type {
  display: inline-block;
  padding: 4px 20px 4px 40px;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #dfdfdf; }

/* ----------------------------------- */
/* ---------- PACKAGE ITEMS ---------- */
.package-items {
  margin-top: 1rem; }
  .package-items h4 {
    margin-bottom: 0.5rem;
    font-size: 0.85rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #cfcfcf; }
  .package-items .item-grid {
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)); }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.personal-hub-factions-reputations {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  max-width: 100%;
  padding: 0 0 0.5rem;
  box-sizing: border-box;
  overflow: visible; }

.factions-reputations-header-card__intro {
  margin: 0;
  color: #b8b8b8;
  line-height: 1.5;
  font-size: 0.92rem; }

.factions-reputations-header-card .hangar-filters__toolbar {
  align-items: center; }

.factions-reputations-header-card .hangar-filters__group--lawful {
  flex: 0 0 auto; }

.factions-reputations-header-card .hangar-filters__group--members-panel {
  flex: 0 0 auto;
  margin-left: auto; }

.factions-reputations-header-card .factions-reputations-factions-card__members-toggle {
  white-space: nowrap; }

.factions-reputations-header-card.hangar-filters--with-help {
  position: relative;
  padding-right: 2.25rem;
  padding-left: 1.1rem;
  padding-bottom: 1rem;
  overflow: visible;
  z-index: 1;
  isolation: auto; }

.factions-reputations-header-card .hangar-filters__help-anchor {
  z-index: 11; }

.factions-reputations-header-card .hangar-filters__help-popover {
  z-index: 12; }

.factions-reputations-factions-card {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-height: 520px;
  background: none;
  border: none;
  box-shadow: none;
  padding: 0;
  overflow: visible;
  isolation: auto; }
  .factions-reputations-factions-card.hangar-filters--horizontal {
    background: none;
    border: none;
    box-shadow: none;
    isolation: auto; }
  .factions-reputations-factions-card__layout {
    display: grid;
    grid-template-columns: minmax(280px, 320px) minmax(0, 1fr);
    gap: 0.5rem;
    min-height: 0;
    flex: 1 1 auto;
    overflow: visible;
    padding: 2px 4px 7px;
    box-sizing: border-box; }
  .factions-reputations-factions-card__detail-region {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    gap: 0;
    min-width: 0;
    min-height: 0; }
    .factions-reputations-factions-card__detail-region--members-open {
      gap: 0.45rem; }
  .factions-reputations-factions-card__detail-region .factions-reputations-factions-card__detail {
    margin-right: 0; }
  .factions-reputations-factions-card__detail {
    flex: 1 1 auto;
    min-width: 0;
    min-height: 0;
    border: 1px solid rgba(58, 120, 180, 0.35);
    border-radius: 12px;
    background: linear-gradient(180deg, rgba(0, 48, 77, 0.72), rgba(21, 28, 36, 0.42)), rgba(0, 48, 77, 0.55);
    padding: 0;
    overflow: auto;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35), 0 10px 14px rgba(0, 0, 0, 0.35);
    transition: flex-basis 0.28s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.2s ease, box-shadow 0.2s ease; }
    .factions-reputations-factions-card__detail--member-view {
      border: 1px solid #9b602a;
      box-shadow: 0 0 0 1px rgba(199, 132, 69, 0.55); }
  .factions-reputations-factions-card__detail-region--members-open .factions-reputations-factions-card__detail {
    flex: 1 1 0; }
  .factions-reputations-factions-card__detail-empty {
    margin: 0;
    color: #b8b8b8; }
  .factions-reputations-factions-card__state {
    margin: 0;
    color: #b8b8b8; }
    .factions-reputations-factions-card__state--error {
      color: #d12323; }
  .factions-reputations-factions-card__banner {
    margin: 0 0 0.65rem;
    padding: 0.55rem 0.75rem;
    border: 1px solid rgba(209, 35, 35, 0.45);
    border-radius: 8px;
    background: rgba(209, 35, 35, 0.12);
    color: #d12323; }
    .factions-reputations-factions-card__banner--error {
      color: #d12323; }

.factions-reputations-faction-list {
  display: flex;
  flex-direction: column;
  min-height: 0;
  border: 1px solid rgba(58, 120, 180, 0.35);
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(0, 48, 77, 0.72), rgba(21, 28, 36, 0.42)), rgba(0, 48, 77, 0.55);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35), 0 12px 28px rgba(0, 0, 0, 0.35);
  overflow: visible; }
  .factions-reputations-faction-list__header {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    padding: 0.75rem 0.85rem;
    border-bottom: 1px solid rgba(58, 120, 180, 0.25);
    position: relative;
    z-index: 4;
    overflow: visible;
    border-radius: 12px 12px 0 0; }
    .factions-reputations-faction-list__header .factions-reputations-help-row {
      align-items: center; }
    .factions-reputations-faction-list__header .help-info-bubble__popover {
      left: 0;
      right: auto;
      width: min(18rem, calc(100vw - 2.5rem)); }
  .factions-reputations-faction-list__title {
    margin: 0;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.82); }
  .factions-reputations-faction-list__section-separator {
    margin: 0.9rem 0.35rem;
    border: 0;
    border-top: 1px solid rgba(58, 120, 180, 0.38); }
  .factions-reputations-faction-list__scroll {
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
    padding: 0.55rem;
    overflow: auto;
    max-height: 62vh;
    max-height: calc(100vh - 445px);
    margin-bottom: 10px;
    border-radius: 0 0 12px 12px;
    margin-right: 0px;
    padding-right: 2px;
    scrollbar-width: thin;
    scrollbar-color: rgba(58, 120, 180, 0.35) rgba(0, 0, 0, 0.12); }
    .factions-reputations-faction-list__scroll::-webkit-scrollbar {
      width: 6px; }
    .factions-reputations-faction-list__scroll::-webkit-scrollbar-track {
      background: rgba(0, 0, 0, 0.12);
      border-radius: 999px; }
    .factions-reputations-faction-list__scroll::-webkit-scrollbar-thumb {
      background: rgba(58, 120, 180, 0.3);
      border-radius: 999px;
      border: 1px solid rgba(255, 255, 255, 0.08); }
    .factions-reputations-faction-list__scroll::-webkit-scrollbar-thumb:hover {
      background: rgba(58, 120, 180, 0.42); }
  .factions-reputations-faction-list__empty {
    margin: 0.75rem 0.35rem;
    color: #b8b8b8;
    font-size: 0.9rem; }

.factions-reputations-faction-item {
  display: flex;
  align-items: stretch;
  gap: 0.35rem; }
  .factions-reputations-faction-item--selected .factions-reputations-faction-item__main {
    border-color: rgba(90, 195, 255, 0.85);
    box-shadow: 0 0 0 1px rgba(90, 195, 255, 0.35);
    background: rgba(58, 120, 180, 0.28); }
  .factions-reputations-faction-item--selected .factions-reputations-faction-item__main--member-reputation {
    border-color: #c78445;
    box-shadow: 0 0 0 1px rgba(199, 132, 69, 0.35); }
  .factions-reputations-faction-item--zero-progress .factions-reputations-faction-item__main {
    background: rgba(21, 28, 36, 0.62);
    border-color: rgba(58, 120, 180, 0.16); }
    .factions-reputations-faction-item--zero-progress .factions-reputations-faction-item__main:hover {
      background: rgba(21, 28, 36, 0.72);
      border-color: rgba(58, 120, 180, 0.24); }
  .factions-reputations-faction-item--zero-progress .factions-reputations-faction-item__main--member-reputation,
  .factions-reputations-faction-item--zero-progress.factions-reputations-faction-item--selected .factions-reputations-faction-item__main--member-reputation {
    border-color: #c78445;
    box-shadow: 0 0 0 1px rgba(199, 132, 69, 0.35); }
    .factions-reputations-faction-item--zero-progress .factions-reputations-faction-item__main--member-reputation:hover,
    .factions-reputations-faction-item--zero-progress.factions-reputations-faction-item--selected .factions-reputations-faction-item__main--member-reputation:hover {
      border-color: #c78445; }
  .factions-reputations-faction-item--zero-progress.factions-reputations-faction-item--selected .factions-reputations-faction-item__main {
    background: rgba(58, 120, 180, 0.22);
    border-color: rgba(90, 195, 255, 0.65); }
  .factions-reputations-faction-item__main {
    flex: 1 1 auto;
    display: grid;
    grid-template-columns: 42px minmax(0, 1fr);
    gap: 0.65rem;
    align-items: start;
    min-width: 0;
    padding: 0.55rem 0.65rem;
    border: 1px solid rgba(58, 120, 180, 0.28);
    border-radius: 8px;
    background: rgba(23, 39, 56, 0.55);
    color: inherit;
    text-align: left;
    cursor: pointer;
    transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease; }
    .factions-reputations-faction-item__main:hover {
      border-color: rgba(90, 195, 255, 0.55);
      background: rgba(58, 120, 180, 0.22); }
    .factions-reputations-faction-item__main:focus-visible {
      outline: 2px solid rgba(58, 120, 180, 0.75);
      outline-offset: 2px; }
    .factions-reputations-faction-item__main--member-reputation {
      border-color: #c78445; }
      .factions-reputations-faction-item__main--member-reputation:hover {
        border-color: #c78445; }
  .factions-reputations-faction-item__body {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    min-width: 0; }
  .factions-reputations-faction-item__copy {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    min-width: 0; }
  .factions-reputations-faction-item__name {
    font-size: 0.92rem;
    font-weight: 700;
    color: #dfdfdf;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; }
  .factions-reputations-faction-item__meter-wrap {
    display: flex;
    align-items: center;
    gap: 0.45rem;
    width: 100%; }
  .factions-reputations-faction-item__meter {
    flex: 1 1 auto;
    height: 6px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.08);
    overflow: hidden; }
  .factions-reputations-faction-item__meter-fill {
    display: block;
    height: 100%;
    width: calc(var(--factions-reputations-meter, 0) * 1%);
    border-radius: inherit;
    background: linear-gradient(90deg, #52575b, #747b81); }
    .factions-reputations-faction-item__meter-fill--hostile {
      background: linear-gradient(90deg, #491212, #d12323); }
    .factions-reputations-faction-item__meter-fill--not-eligible {
      background: linear-gradient(90deg, #551414, #7e1e1e); }
    .factions-reputations-faction-item__meter-fill--unselected {
      background: linear-gradient(90deg, #28343f, #384858); }
    .factions-reputations-faction-item__meter-fill--neutral {
      background: linear-gradient(90deg, #c78445, #d8b493); }
    .factions-reputations-faction-item__meter-fill--friendly {
      background: linear-gradient(90deg, #75cf78, #c2f0c3); }
    .factions-reputations-faction-item__meter-fill--trusted {
      background: linear-gradient(90deg, #5aa05c, #75cf78); }
    .factions-reputations-faction-item__meter-fill--renown {
      background: linear-gradient(90deg, #7958c3, #9a80e3); }
    .factions-reputations-faction-item__meter-fill--legendary {
      background: linear-gradient(90deg, #463685, #7958c3); }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="0"] {
      --factions-reputations-meter: 0; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="1"] {
      --factions-reputations-meter: 1; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="2"] {
      --factions-reputations-meter: 2; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="3"] {
      --factions-reputations-meter: 3; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="4"] {
      --factions-reputations-meter: 4; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="5"] {
      --factions-reputations-meter: 5; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="6"] {
      --factions-reputations-meter: 6; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="7"] {
      --factions-reputations-meter: 7; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="8"] {
      --factions-reputations-meter: 8; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="9"] {
      --factions-reputations-meter: 9; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="10"] {
      --factions-reputations-meter: 10; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="11"] {
      --factions-reputations-meter: 11; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="12"] {
      --factions-reputations-meter: 12; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="13"] {
      --factions-reputations-meter: 13; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="14"] {
      --factions-reputations-meter: 14; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="15"] {
      --factions-reputations-meter: 15; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="16"] {
      --factions-reputations-meter: 16; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="17"] {
      --factions-reputations-meter: 17; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="18"] {
      --factions-reputations-meter: 18; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="19"] {
      --factions-reputations-meter: 19; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="20"] {
      --factions-reputations-meter: 20; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="21"] {
      --factions-reputations-meter: 21; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="22"] {
      --factions-reputations-meter: 22; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="23"] {
      --factions-reputations-meter: 23; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="24"] {
      --factions-reputations-meter: 24; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="25"] {
      --factions-reputations-meter: 25; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="26"] {
      --factions-reputations-meter: 26; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="27"] {
      --factions-reputations-meter: 27; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="28"] {
      --factions-reputations-meter: 28; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="29"] {
      --factions-reputations-meter: 29; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="30"] {
      --factions-reputations-meter: 30; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="31"] {
      --factions-reputations-meter: 31; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="32"] {
      --factions-reputations-meter: 32; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="33"] {
      --factions-reputations-meter: 33; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="34"] {
      --factions-reputations-meter: 34; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="35"] {
      --factions-reputations-meter: 35; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="36"] {
      --factions-reputations-meter: 36; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="37"] {
      --factions-reputations-meter: 37; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="38"] {
      --factions-reputations-meter: 38; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="39"] {
      --factions-reputations-meter: 39; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="40"] {
      --factions-reputations-meter: 40; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="41"] {
      --factions-reputations-meter: 41; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="42"] {
      --factions-reputations-meter: 42; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="43"] {
      --factions-reputations-meter: 43; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="44"] {
      --factions-reputations-meter: 44; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="45"] {
      --factions-reputations-meter: 45; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="46"] {
      --factions-reputations-meter: 46; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="47"] {
      --factions-reputations-meter: 47; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="48"] {
      --factions-reputations-meter: 48; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="49"] {
      --factions-reputations-meter: 49; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="50"] {
      --factions-reputations-meter: 50; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="51"] {
      --factions-reputations-meter: 51; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="52"] {
      --factions-reputations-meter: 52; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="53"] {
      --factions-reputations-meter: 53; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="54"] {
      --factions-reputations-meter: 54; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="55"] {
      --factions-reputations-meter: 55; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="56"] {
      --factions-reputations-meter: 56; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="57"] {
      --factions-reputations-meter: 57; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="58"] {
      --factions-reputations-meter: 58; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="59"] {
      --factions-reputations-meter: 59; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="60"] {
      --factions-reputations-meter: 60; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="61"] {
      --factions-reputations-meter: 61; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="62"] {
      --factions-reputations-meter: 62; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="63"] {
      --factions-reputations-meter: 63; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="64"] {
      --factions-reputations-meter: 64; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="65"] {
      --factions-reputations-meter: 65; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="66"] {
      --factions-reputations-meter: 66; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="67"] {
      --factions-reputations-meter: 67; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="68"] {
      --factions-reputations-meter: 68; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="69"] {
      --factions-reputations-meter: 69; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="70"] {
      --factions-reputations-meter: 70; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="71"] {
      --factions-reputations-meter: 71; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="72"] {
      --factions-reputations-meter: 72; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="73"] {
      --factions-reputations-meter: 73; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="74"] {
      --factions-reputations-meter: 74; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="75"] {
      --factions-reputations-meter: 75; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="76"] {
      --factions-reputations-meter: 76; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="77"] {
      --factions-reputations-meter: 77; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="78"] {
      --factions-reputations-meter: 78; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="79"] {
      --factions-reputations-meter: 79; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="80"] {
      --factions-reputations-meter: 80; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="81"] {
      --factions-reputations-meter: 81; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="82"] {
      --factions-reputations-meter: 82; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="83"] {
      --factions-reputations-meter: 83; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="84"] {
      --factions-reputations-meter: 84; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="85"] {
      --factions-reputations-meter: 85; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="86"] {
      --factions-reputations-meter: 86; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="87"] {
      --factions-reputations-meter: 87; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="88"] {
      --factions-reputations-meter: 88; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="89"] {
      --factions-reputations-meter: 89; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="90"] {
      --factions-reputations-meter: 90; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="91"] {
      --factions-reputations-meter: 91; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="92"] {
      --factions-reputations-meter: 92; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="93"] {
      --factions-reputations-meter: 93; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="94"] {
      --factions-reputations-meter: 94; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="95"] {
      --factions-reputations-meter: 95; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="96"] {
      --factions-reputations-meter: 96; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="97"] {
      --factions-reputations-meter: 97; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="98"] {
      --factions-reputations-meter: 98; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="99"] {
      --factions-reputations-meter: 99; }
    .factions-reputations-faction-item__meter-fill[data-meter-pct="100"] {
      --factions-reputations-meter: 100; }
  .factions-reputations-faction-item__percent {
    font-size: 0.72rem;
    font-weight: 700;
    color: rgba(223, 223, 223, 0.82); }
  .factions-reputations-faction-item__favorite {
    flex: 0 0 34px;
    width: fit-content;
    padding: 0.2rem 0.85rem;
    border: 1px solid rgba(58, 120, 180, 0.28);
    border-radius: 8px;
    background: rgba(0, 48, 77, 0.35);
    color: rgba(223, 223, 223, 0.55);
    font-size: 0.95rem;
    line-height: 1;
    cursor: pointer;
    transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease; }
    .factions-reputations-faction-item__favorite:hover:not(:disabled) {
      color: #d8b493;
      border-color: rgba(199, 132, 69, 0.55); }
    .factions-reputations-faction-item__favorite--active {
      color: #c78445;
      border-color: rgba(199, 132, 69, 0.65);
      background: rgba(199, 132, 69, 0.12); }
    .factions-reputations-faction-item__favorite:disabled {
      cursor: not-allowed;
      opacity: 0.55; }

.factions-reputations-faction-logo {
  width: 38px;
  height: 38px;
  padding: 5px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  border: 1px solid rgba(58, 120, 180, 0.35);
  background: rgba(21, 28, 36, 0.85); }
  .factions-reputations-faction-logo--fallback {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.95rem;
    font-weight: 700;
    color: #dfdfdf; }

.factions-reputations-faction-detail {
  display: flex;
  flex-direction: column;
  gap: 0.85rem; }
  .factions-reputations-faction-detail__header {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 110px;
    padding: 0;
    border: 1px solid rgba(58, 120, 180, 0.25);
    border-radius: 10px;
    overflow: hidden; }
    .factions-reputations-faction-detail__header--lawful::before, .factions-reputations-faction-detail__header--unlawful::before {
      content: '';
      position: absolute;
      inset: 0;
      z-index: 0;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      pointer-events: none; }
    .factions-reputations-faction-detail__header--lawful::after, .factions-reputations-faction-detail__header--unlawful::after {
      content: '';
      position: absolute;
      inset: 0;
      z-index: 1;
      background: linear-gradient(180deg, rgba(21, 28, 36, 0.52) 0%, rgba(21, 28, 36, 0.62) 100%);
      pointer-events: none; }
    .factions-reputations-faction-detail__header--lawful::before {
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___}); }
    .factions-reputations-faction-detail__header--unlawful::before {
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___}); }
  .factions-reputations-faction-detail__hero {
    position: relative;
    z-index: 2;
    display: grid;
    grid-template-columns: 90px minmax(0, 1fr) auto;
    gap: 0.85rem;
    padding: 0.65rem 1rem;
    align-items: center; }
  .factions-reputations-faction-detail__logo {
    width: 75px;
    height: 75px; }
  .factions-reputations-faction-detail__name-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.8rem; }
  .factions-reputations-faction-detail__name {
    margin: 0;
    font-size: 1.35rem;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #dfdfdf; }
  .factions-reputations-faction-detail__member-chip {
    display: inline-flex;
    align-items: center;
    padding: 0.3rem 0.6rem;
    border: 1px solid #c78445;
    border-radius: 8px;
    background: rgba(110, 68, 28, 0.72);
    color: #d8b493;
    font-size: 0.8rem;
    font-weight: 700;
    letter-spacing: 0.03em;
    line-height: 1.25;
    white-space: nowrap; }
  .factions-reputations-faction-detail__category {
    margin: 0.25rem 0 0;
    color: #5ac3ff;
    font-size: 0.88rem; }
  .factions-reputations-faction-detail__favorite {
    position: relative;
    bottom: 15px;
    min-width: 38px;
    height: 30px;
    border: 1px solid rgba(58, 120, 180, 0.35);
    border-radius: 8px;
    background: rgba(0, 48, 77, 0.35);
    color: rgba(223, 223, 223, 0.55);
    font-size: 1.1rem;
    cursor: pointer; }
    .factions-reputations-faction-detail__favorite--active {
      color: #d8b493;
      font-size: 0.95rem;
      border-color: rgba(199, 132, 69, 0.65);
      background: rgba(110, 68, 28, 0.55); }
    .factions-reputations-faction-detail__favorite:disabled {
      cursor: not-allowed;
      opacity: 0.55; }
  .factions-reputations-faction-detail__level {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    width: fit-content;
    max-width: calc(100% - 2rem);
    margin: 0 1rem 0.85rem;
    padding: 0.55rem 0.75rem;
    border: 1px solid rgba(116, 123, 129, 0.45);
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(21, 28, 36, 0.28);
    border-color: rgba(116, 123, 129, 0.45);
    background: linear-gradient(145deg, rgba(56, 72, 88, 0.94), rgba(116, 123, 129, 0.82)); }
    .factions-reputations-faction-detail__level .factions-reputations-faction-detail__level-scope-title {
      color: #ffffff; }
    .factions-reputations-faction-detail__level .factions-reputations-faction-detail__level-grade-label {
      color: rgba(255, 255, 255, 0.88); }
    .factions-reputations-faction-detail__level .factions-reputations-faction-detail__level-icon--empty {
      border-color: rgba(255, 255, 255, 0.35);
      background: rgba(255, 255, 255, 0.12); }
    .factions-reputations-faction-detail__level--hostile {
      border-color: rgba(209, 35, 35, 0.58);
      background: linear-gradient(145deg, rgba(53, 4, 4, 0.96), rgba(73, 18, 18, 0.9)); }
      .factions-reputations-faction-detail__level--hostile .factions-reputations-faction-detail__level-scope-title {
        color: #ffffff; }
      .factions-reputations-faction-detail__level--hostile .factions-reputations-faction-detail__level-grade-label {
        color: rgba(255, 255, 255, 0.88); }
      .factions-reputations-faction-detail__level--hostile .factions-reputations-faction-detail__level-icon--empty {
        border-color: rgba(255, 255, 255, 0.35);
        background: rgba(255, 255, 255, 0.12); }
    .factions-reputations-faction-detail__level--not-eligible {
      border-color: rgba(126, 30, 30, 0.58);
      background: linear-gradient(145deg, rgba(73, 18, 18, 0.94), rgba(126, 30, 30, 0.88)); }
      .factions-reputations-faction-detail__level--not-eligible .factions-reputations-faction-detail__level-scope-title {
        color: #ffffff; }
      .factions-reputations-faction-detail__level--not-eligible .factions-reputations-faction-detail__level-grade-label {
        color: rgba(255, 255, 255, 0.88); }
      .factions-reputations-faction-detail__level--not-eligible .factions-reputations-faction-detail__level-icon--empty {
        border-color: rgba(255, 255, 255, 0.35);
        background: rgba(255, 255, 255, 0.12); }
    .factions-reputations-faction-detail__level--unselected {
      border-color: rgba(116, 123, 129, 0.45);
      background: linear-gradient(145deg, rgba(56, 72, 88, 0.94), rgba(116, 123, 129, 0.82)); }
      .factions-reputations-faction-detail__level--unselected .factions-reputations-faction-detail__level-scope-title {
        color: #ffffff; }
      .factions-reputations-faction-detail__level--unselected .factions-reputations-faction-detail__level-grade-label {
        color: rgba(255, 255, 255, 0.88); }
      .factions-reputations-faction-detail__level--unselected .factions-reputations-faction-detail__level-icon--empty {
        border-color: rgba(255, 255, 255, 0.35);
        background: rgba(255, 255, 255, 0.12); }
    .factions-reputations-faction-detail__level--neutral {
      border-color: rgba(199, 132, 69, 0.62);
      background: linear-gradient(145deg, rgba(155, 96, 42, 0.9), rgba(199, 132, 69, 0.84)); }
      .factions-reputations-faction-detail__level--neutral .factions-reputations-faction-detail__level-scope-title {
        color: #ffffff; }
      .factions-reputations-faction-detail__level--neutral .factions-reputations-faction-detail__level-grade-label {
        color: rgba(223, 223, 223, 0.95); }
      .factions-reputations-faction-detail__level--neutral .factions-reputations-faction-detail__level-icon--empty {
        border-color: rgba(255, 255, 255, 0.35);
        background: rgba(255, 255, 255, 0.12); }
    .factions-reputations-faction-detail__level--friendly {
      border-color: rgba(117, 207, 120, 0.62);
      background: linear-gradient(145deg, rgba(90, 160, 92, 0.88), rgba(194, 240, 195, 0.92)); }
      .factions-reputations-faction-detail__level--friendly .factions-reputations-faction-detail__level-scope-title {
        color: #0c2637; }
      .factions-reputations-faction-detail__level--friendly .factions-reputations-faction-detail__level-grade-label {
        color: rgba(21, 28, 36, 0.92); }
      .factions-reputations-faction-detail__level--friendly .factions-reputations-faction-detail__level-icon--empty {
        border-color: rgba(12, 38, 55, 0.35);
        background: rgba(12, 38, 55, 0.12); }
    .factions-reputations-faction-detail__level--trusted {
      border-color: rgba(117, 207, 120, 0.62);
      background: linear-gradient(145deg, rgba(63, 124, 66, 0.92), rgba(117, 207, 120, 0.86)); }
      .factions-reputations-faction-detail__level--trusted .factions-reputations-faction-detail__level-scope-title {
        color: #ffffff; }
      .factions-reputations-faction-detail__level--trusted .factions-reputations-faction-detail__level-grade-label {
        color: rgba(255, 255, 255, 0.88); }
      .factions-reputations-faction-detail__level--trusted .factions-reputations-faction-detail__level-icon--empty {
        border-color: rgba(255, 255, 255, 0.35);
        background: rgba(255, 255, 255, 0.12); }
    .factions-reputations-faction-detail__level--renown {
      border-color: rgba(154, 128, 227, 0.62);
      background: linear-gradient(145deg, rgba(70, 54, 133, 0.92), rgba(154, 128, 227, 0.86)); }
      .factions-reputations-faction-detail__level--renown .factions-reputations-faction-detail__level-scope-title {
        color: #ffffff; }
      .factions-reputations-faction-detail__level--renown .factions-reputations-faction-detail__level-grade-label {
        color: rgba(255, 255, 255, 0.88); }
      .factions-reputations-faction-detail__level--renown .factions-reputations-faction-detail__level-icon--empty {
        border-color: rgba(255, 255, 255, 0.35);
        background: rgba(255, 255, 255, 0.12); }
    .factions-reputations-faction-detail__level--legendary {
      border-color: rgba(121, 88, 195, 0.65);
      background: linear-gradient(145deg, rgba(35, 30, 69, 0.94), rgba(121, 88, 195, 0.88)); }
      .factions-reputations-faction-detail__level--legendary .factions-reputations-faction-detail__level-scope-title {
        color: #ffffff; }
      .factions-reputations-faction-detail__level--legendary .factions-reputations-faction-detail__level-grade-label {
        color: rgba(255, 255, 255, 0.88); }
      .factions-reputations-faction-detail__level--legendary .factions-reputations-faction-detail__level-icon--empty {
        border-color: rgba(255, 255, 255, 0.35);
        background: rgba(255, 255, 255, 0.12); }
  .factions-reputations-faction-detail__level-row {
    display: flex;
    align-items: center;
    gap: 0.45rem;
    min-width: 0; }
    .factions-reputations-faction-detail__level-row--scope {
      gap: 0.5rem; }
    .factions-reputations-faction-detail__level-row--grade {
      padding-left: 0.1rem; }
  .factions-reputations-faction-detail__level-icon {
    flex-shrink: 0;
    object-fit: contain; }
    .factions-reputations-faction-detail__level-icon--scope {
      width: 1.35rem;
      height: 1.35rem;
      border-radius: 999px;
      padding: 0.15rem;
      background: rgba(255, 255, 255, 0.1); }
    .factions-reputations-faction-detail__level-icon--grade {
      width: 1.05rem;
      height: 1.05rem;
      border-radius: 4px; }
    .factions-reputations-faction-detail__level-icon--empty {
      display: inline-block;
      box-sizing: border-box;
      border: 1px dashed rgba(255, 255, 255, 0.28);
      background: rgba(255, 255, 255, 0.08); }
  .factions-reputations-faction-detail__level-scope-title {
    font-size: 0.82rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    line-height: 1.25;
    overflow-wrap: anywhere; }
  .factions-reputations-faction-detail__level-grade-label {
    font-size: 0.72rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    line-height: 1.25;
    overflow-wrap: anywhere; }
  .factions-reputations-faction-detail__notes-label {
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.82); }
  .factions-reputations-faction-detail__notes {
    width: 100%;
    min-height: 45px;
    padding: 0.65rem 0.75rem;
    border: 1px solid rgba(58, 120, 180, 0.35);
    border-radius: 8px;
    background: rgba(0, 48, 77, 0.45);
    color: #dfdfdf;
    font: inherit;
    resize: vertical;
    box-sizing: border-box; }
    .factions-reputations-faction-detail__notes::placeholder {
      color: rgba(184, 184, 184, 0.75); }
    .factions-reputations-faction-detail__notes:disabled {
      opacity: 0.65;
      cursor: not-allowed; }
  .factions-reputations-faction-detail__updated {
    margin: 0;
    font-size: 0.78rem;
    color: rgba(184, 184, 184, 0.9); }
  .factions-reputations-faction-detail__notes-wrap {
    display: flex;
    flex-direction: column;
    padding: 0 1rem;
    gap: 0.65rem; }
  .factions-reputations-faction-detail__updated-wrap {
    padding: 0 0.65rem 0.65rem; }

.factions-reputations-grade-stepper {
  display: flex;
  flex-direction: column;
  padding: 0 1rem;
  gap: 0.75rem; }
  .factions-reputations-grade-stepper__label {
    margin: 0;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.82); }
  .factions-reputations-grade-stepper__empty {
    margin: 0;
    color: #b8b8b8;
    font-size: 0.85rem; }
  .factions-reputations-grade-stepper__columns {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(15.3rem, max-content));
    gap: 0.85rem;
    align-items: start; }
    .factions-reputations-grade-stepper__columns--carousel {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: stretch;
      justify-content: flex-start;
      width: max-content; }
  .factions-reputations-grade-stepper__columns-carousel {
    display: flex;
    align-items: stretch;
    gap: 0.4rem;
    min-width: 0; }
  .factions-reputations-grade-stepper__columns-viewport {
    flex: 1 1 auto;
    min-width: 0;
    align-self: stretch;
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    overscroll-behavior-x: contain;
    scrollbar-width: none;
    -ms-overflow-style: none;
    touch-action: pan-y; }
    .factions-reputations-grade-stepper__columns-viewport::-webkit-scrollbar {
      display: none; }
    .factions-reputations-grade-stepper__columns-viewport--scrollable {
      cursor: grab; }
    .factions-reputations-grade-stepper__columns-viewport--dragging {
      cursor: grabbing;
      user-select: none;
      scroll-behavior: auto; }
      .factions-reputations-grade-stepper__columns-viewport--dragging * {
        cursor: grabbing;
        user-select: none; }
  .factions-reputations-grade-stepper__columns-nav {
    flex: 0 0 1.5rem;
    align-self: stretch;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.5rem;
    min-height: 0;
    height: auto;
    padding: 0;
    border: 1px solid rgba(58, 120, 180, 0.35);
    border-radius: 8px;
    background: rgba(23, 39, 56, 0.45);
    box-shadow: 0 0 0 1px rgba(90, 195, 255, 0.08);
    cursor: pointer;
    transition: opacity 0.15s ease, border-color 0.15s ease, background-color 0.15s ease; }
    .factions-reputations-grade-stepper__columns-nav:enabled:hover {
      border-color: rgba(90, 195, 255, 0.55);
      background: rgba(58, 120, 180, 0.22); }
    .factions-reputations-grade-stepper__columns-nav:focus-visible {
      outline: 2px solid rgba(58, 120, 180, 0.75);
      outline-offset: 2px; }
    .factions-reputations-grade-stepper__columns-nav:disabled, .factions-reputations-grade-stepper__columns-nav--disabled {
      opacity: 0.28;
      cursor: default; }
  .factions-reputations-grade-stepper__columns-nav-icon {
    display: block;
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent; }
  .factions-reputations-grade-stepper__columns-nav--prev .factions-reputations-grade-stepper__columns-nav-icon {
    border-right: 7px solid #5ac3ff; }
  .factions-reputations-grade-stepper__columns-nav--next .factions-reputations-grade-stepper__columns-nav-icon {
    border-left: 7px solid #5ac3ff; }
  .factions-reputations-grade-stepper__column {
    display: flex;
    flex-direction: column;
    gap: 0.55rem;
    min-width: 0;
    height: -webkit-fill-available;
    padding: 0.65rem 0.55rem 0.75rem;
    border: 1px solid rgba(58, 120, 180, 0.22);
    border-radius: 10px;
    background: rgba(23, 39, 56, 0.58);
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
    box-shadow: 0 0 0 1px rgba(90, 195, 255, 0.12); }
    .factions-reputations-grade-stepper__columns--carousel .factions-reputations-grade-stepper__column {
      flex: 0 0 15.5rem;
      width: 15.5rem;
      max-width: 15.5rem; }
    .factions-reputations-grade-stepper__column--active {
      border-color: rgba(90, 195, 255, 0.25);
      box-shadow: 0 0 0 1px rgba(90, 195, 255, 0.32); }
  .factions-reputations-grade-stepper__column-body {
    flex: 1 1 auto;
    min-height: 46px;
    max-height: calc(100vh - 850px);
    overflow-y: auto;
    /* Chrome, Edge, Safari */
    /* Firefox */
    scrollbar-width: none;
    /* IE / old Edge */
    -ms-overflow-style: none; }
    .factions-reputations-grade-stepper__column-body::-webkit-scrollbar {
      width: 0;
      height: 0; }
  .factions-reputations-grade-stepper__column-head {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.35rem;
    width: 100%;
    padding: 0;
    border: 0;
    background: transparent;
    text-align: center;
    cursor: pointer;
    color: inherit; }
    .factions-reputations-grade-stepper__column-head:focus-visible {
      outline: 2px solid rgba(58, 120, 180, 0.75);
      outline-offset: 2px;
      border-radius: 6px; }
  .factions-reputations-grade-stepper__scope-icon {
    display: block;
    background: rgba(58, 120, 180, 0.35);
    border-radius: 999px;
    width: 1.3rem;
    height: 1.3rem;
    padding: 0.25rem;
    object-fit: contain; }
    .factions-reputations-grade-stepper__scope-icon--empty {
      flex-shrink: 0;
      background: transparent;
      border: none;
      box-shadow: none; }
  .factions-reputations-grade-stepper__scope-title {
    margin: 0;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: rgba(90, 195, 255, 0.9); }
  .factions-reputations-grade-stepper__timeline {
    margin: 0;
    padding: 0;
    list-style: none; }
  .factions-reputations-grade-stepper__timeline-item {
    display: grid;
    grid-template-columns: 1.1rem 1fr;
    gap: 0.55rem;
    padding-bottom: 0.65rem; }
    .factions-reputations-grade-stepper__timeline-item--last {
      padding-bottom: 0; }
    .factions-reputations-grade-stepper__timeline-item--selected .factions-reputations-grade-stepper__rail-dot {
      background: rgba(90, 195, 255, 0.95);
      box-shadow: 0 0 0 2px rgba(90, 195, 255, 0.35); }
  .factions-reputations-grade-stepper__rail {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 100%; }
  .factions-reputations-grade-stepper__rail-dot {
    flex-shrink: 0;
    width: 0.55rem;
    height: 0.55rem;
    margin-top: 0.65rem;
    border-radius: 50%;
    background: rgba(58, 120, 180, 0.85);
    box-shadow: 0 0 0 2px rgba(58, 120, 180, 0.22); }
  .factions-reputations-grade-stepper__rail-line {
    flex: 1 1 auto;
    width: 2px;
    min-height: 1.5rem;
    margin-top: 0.15rem;
    border-radius: 999px;
    background: rgba(58, 120, 180, 0.35); }
  .factions-reputations-grade-stepper__step {
    display: flex;
    align-items: flex-start;
    gap: 0.45rem;
    width: 100%;
    padding: 0.25rem 0.35rem;
    border: 1px solid transparent;
    border-radius: 8px;
    background: transparent;
    color: #b8b8b8;
    font-size: 0.76rem;
    text-align: left;
    cursor: pointer; }
    .factions-reputations-grade-stepper__step--selected {
      border-color: rgba(90, 195, 255, 0.55);
      background: rgba(58, 120, 180, 0.22);
      color: #dfdfdf;
      box-shadow: 0 0 0 1px rgba(90, 195, 255, 0.18); }
    .factions-reputations-grade-stepper__step--hostile.factions-reputations-grade-stepper__step--selected {
      border-color: rgba(209, 35, 35, 0.65);
      background: rgba(209, 35, 35, 0.14); }
    .factions-reputations-grade-stepper__step--not-eligible.factions-reputations-grade-stepper__step--selected {
      border-color: rgba(126, 30, 30, 0.65);
      background: rgba(126, 30, 30, 0.14); }
    .factions-reputations-grade-stepper__step--legendary.factions-reputations-grade-stepper__step--selected {
      border-color: rgba(199, 132, 69, 0.65);
      background: rgba(199, 132, 69, 0.12); }
    .factions-reputations-grade-stepper__step:disabled {
      cursor: not-allowed;
      opacity: 0.6; }
  .factions-reputations-grade-stepper__icon {
    flex-shrink: 0;
    width: 2.5rem;
    height: 2.5rem;
    object-fit: contain; }
    .factions-reputations-grade-stepper__icon--empty {
      border-radius: 4px;
      background: rgba(58, 120, 180, 0.15); }
  .factions-reputations-grade-stepper__name {
    min-width: 0;
    align-self: center;
    line-height: 1.25; }
  .factions-reputations-grade-stepper__progress {
    flex-shrink: 0; }
  .factions-reputations-grade-stepper__progress-track {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 1.15rem;
    border-radius: 999px;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.35);
    border: 1px solid rgba(19, 59, 83, 0.95); }
  .factions-reputations-grade-stepper__progress-fill {
    position: absolute;
    left: 0;
    bottom: 3px;
    height: 0.75rem;
    width: calc(var(--fill-pct, 0) * 1%);
    border-radius: inherit;
    background: linear-gradient(90deg, #52575b, #747b81);
    transition: width 0.25s ease; }
    .factions-reputations-grade-stepper__progress-fill--hostile {
      background: linear-gradient(90deg, #491212, #d12323); }
    .factions-reputations-grade-stepper__progress-fill--not-eligible {
      background: linear-gradient(90deg, #551414, #7e1e1e); }
    .factions-reputations-grade-stepper__progress-fill--unselected {
      background: linear-gradient(90deg, #28343f, #384858); }
    .factions-reputations-grade-stepper__progress-fill--neutral {
      background: linear-gradient(90deg, #c78445, #d8b493); }
    .factions-reputations-grade-stepper__progress-fill--friendly {
      background: linear-gradient(90deg, #75cf78, #c2f0c3); }
    .factions-reputations-grade-stepper__progress-fill--trusted {
      background: linear-gradient(90deg, #5aa05c, #75cf78); }
    .factions-reputations-grade-stepper__progress-fill--renown {
      background: linear-gradient(90deg, #7958c3, #9a80e3); }
    .factions-reputations-grade-stepper__progress-fill--legendary {
      background: linear-gradient(90deg, #463685, #7958c3); }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="0"] {
      --fill-pct: 0; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="1"] {
      --fill-pct: 1; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="2"] {
      --fill-pct: 2; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="3"] {
      --fill-pct: 3; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="4"] {
      --fill-pct: 4; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="5"] {
      --fill-pct: 5; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="6"] {
      --fill-pct: 6; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="7"] {
      --fill-pct: 7; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="8"] {
      --fill-pct: 8; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="9"] {
      --fill-pct: 9; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="10"] {
      --fill-pct: 10; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="11"] {
      --fill-pct: 11; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="12"] {
      --fill-pct: 12; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="13"] {
      --fill-pct: 13; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="14"] {
      --fill-pct: 14; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="15"] {
      --fill-pct: 15; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="16"] {
      --fill-pct: 16; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="17"] {
      --fill-pct: 17; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="18"] {
      --fill-pct: 18; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="19"] {
      --fill-pct: 19; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="20"] {
      --fill-pct: 20; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="21"] {
      --fill-pct: 21; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="22"] {
      --fill-pct: 22; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="23"] {
      --fill-pct: 23; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="24"] {
      --fill-pct: 24; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="25"] {
      --fill-pct: 25; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="26"] {
      --fill-pct: 26; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="27"] {
      --fill-pct: 27; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="28"] {
      --fill-pct: 28; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="29"] {
      --fill-pct: 29; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="30"] {
      --fill-pct: 30; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="31"] {
      --fill-pct: 31; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="32"] {
      --fill-pct: 32; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="33"] {
      --fill-pct: 33; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="34"] {
      --fill-pct: 34; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="35"] {
      --fill-pct: 35; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="36"] {
      --fill-pct: 36; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="37"] {
      --fill-pct: 37; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="38"] {
      --fill-pct: 38; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="39"] {
      --fill-pct: 39; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="40"] {
      --fill-pct: 40; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="41"] {
      --fill-pct: 41; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="42"] {
      --fill-pct: 42; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="43"] {
      --fill-pct: 43; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="44"] {
      --fill-pct: 44; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="45"] {
      --fill-pct: 45; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="46"] {
      --fill-pct: 46; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="47"] {
      --fill-pct: 47; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="48"] {
      --fill-pct: 48; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="49"] {
      --fill-pct: 49; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="50"] {
      --fill-pct: 50; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="51"] {
      --fill-pct: 51; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="52"] {
      --fill-pct: 52; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="53"] {
      --fill-pct: 53; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="54"] {
      --fill-pct: 54; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="55"] {
      --fill-pct: 55; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="56"] {
      --fill-pct: 56; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="57"] {
      --fill-pct: 57; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="58"] {
      --fill-pct: 58; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="59"] {
      --fill-pct: 59; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="60"] {
      --fill-pct: 60; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="61"] {
      --fill-pct: 61; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="62"] {
      --fill-pct: 62; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="63"] {
      --fill-pct: 63; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="64"] {
      --fill-pct: 64; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="65"] {
      --fill-pct: 65; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="66"] {
      --fill-pct: 66; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="67"] {
      --fill-pct: 67; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="68"] {
      --fill-pct: 68; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="69"] {
      --fill-pct: 69; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="70"] {
      --fill-pct: 70; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="71"] {
      --fill-pct: 71; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="72"] {
      --fill-pct: 72; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="73"] {
      --fill-pct: 73; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="74"] {
      --fill-pct: 74; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="75"] {
      --fill-pct: 75; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="76"] {
      --fill-pct: 76; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="77"] {
      --fill-pct: 77; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="78"] {
      --fill-pct: 78; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="79"] {
      --fill-pct: 79; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="80"] {
      --fill-pct: 80; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="81"] {
      --fill-pct: 81; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="82"] {
      --fill-pct: 82; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="83"] {
      --fill-pct: 83; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="84"] {
      --fill-pct: 84; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="85"] {
      --fill-pct: 85; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="86"] {
      --fill-pct: 86; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="87"] {
      --fill-pct: 87; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="88"] {
      --fill-pct: 88; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="89"] {
      --fill-pct: 89; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="90"] {
      --fill-pct: 90; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="91"] {
      --fill-pct: 91; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="92"] {
      --fill-pct: 92; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="93"] {
      --fill-pct: 93; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="94"] {
      --fill-pct: 94; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="95"] {
      --fill-pct: 95; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="96"] {
      --fill-pct: 96; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="97"] {
      --fill-pct: 97; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="98"] {
      --fill-pct: 98; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="99"] {
      --fill-pct: 99; }
    .factions-reputations-grade-stepper__progress-fill[data-fill-pct="100"] {
      --fill-pct: 100; }
  .factions-reputations-grade-stepper__progress-label {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    font-size: 0.68rem;
    font-weight: 700;
    color: #dfdfdf;
    pointer-events: none; }

.factions-reputations-faction-members-panel {
  flex: 0 0 0;
  width: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  color: #dfdfdf;
  border: 1px solid transparent;
  border-radius: 10px;
  background: rgba(12, 38, 55, 0.96);
  overflow: visible;
  opacity: 0;
  pointer-events: none;
  transition: flex-basis 0.28s cubic-bezier(0.4, 0, 0.2, 1), width 0.28s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s ease, border-color 0.2s ease; }
  .factions-reputations-faction-members-panel--open {
    flex: 0 0 220px;
    width: 220px;
    opacity: 1;
    pointer-events: auto;
    border-color: rgba(58, 120, 180, 0.35);
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35), 0 12px 28px rgba(0, 0, 0, 0.35);
    z-index: 3; }
  .factions-reputations-faction-members-panel__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    flex-shrink: 0;
    padding: 0.65rem 0.75rem 0.45rem;
    border-bottom: 1px solid rgba(58, 120, 180, 0.25);
    user-select: none;
    position: relative;
    z-index: 4;
    overflow: visible;
    border-radius: 10px 10px 0 0; }
    .factions-reputations-faction-members-panel__title .factions-reputations-help-row {
      flex: 1 1 auto;
      min-width: 0;
      align-items: center; }
    .factions-reputations-faction-members-panel__title .help-info-bubble__popover {
      left: auto;
      right: 0;
      width: min(18rem, calc(100vw - 2.5rem)); }
    .factions-reputations-faction-members-panel__title strong {
      font-size: 0.78rem;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      color: rgba(223, 223, 223, 0.9); }
  .factions-reputations-faction-members-panel__count {
    min-width: 1.35rem;
    padding: 0.1rem 0.35rem;
    border-radius: 999px;
    font-size: 0.68rem;
    font-weight: 700;
    text-align: center;
    color: #dfdfdf;
    background: rgba(58, 120, 180, 0.25); }
  .factions-reputations-faction-members-panel__state {
    margin: 0;
    padding: 0.65rem 0.75rem;
    font-size: 0.82rem;
    color: #b8b8b8; }
    .factions-reputations-faction-members-panel__state--error {
      color: #d12323; }
  .factions-reputations-faction-members-panel__empty {
    margin: 0;
    padding: 0.65rem 0.75rem;
    font-size: 0.82rem;
    font-style: italic;
    color: rgba(184, 184, 184, 0.85); }
  .factions-reputations-faction-members-panel__list {
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 10px;
    list-style: none;
    margin: 0;
    border-radius: 0 0 10px 10px; }
    .factions-reputations-faction-members-panel__list::-webkit-scrollbar {
      width: 6px; }
    .factions-reputations-faction-members-panel__list::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .factions-reputations-faction-members-panel__list::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .factions-reputations-faction-members-panel__list::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
  .factions-reputations-faction-members-panel__item {
    margin: 0;
    padding: 0; }
  .factions-reputations-faction-members-panel__member-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 5px 8px;
    border: 1px solid transparent;
    border-radius: 6px;
    background: transparent;
    cursor: pointer;
    text-align: left;
    color: inherit; }
    .factions-reputations-faction-members-panel__member-btn:hover {
      background: rgba(58, 120, 180, 0.12);
      border-color: rgba(58, 120, 180, 0.25); }
    .factions-reputations-faction-members-panel__member-btn:focus-visible {
      outline: 2px solid rgba(58, 120, 180, 0.75);
      outline-offset: 1px; }
    .factions-reputations-faction-members-panel__member-btn--faction-match {
      border-color: #c78445; }
      .factions-reputations-faction-members-panel__member-btn--faction-match:hover {
        border-color: #c78445; }
    .factions-reputations-faction-members-panel__member-btn--selected {
      background: rgba(199, 132, 69, 0.14);
      border-color: rgba(199, 132, 69, 0.55); }
  .factions-reputations-faction-members-panel__member-avatar {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    object-fit: cover; }
    .factions-reputations-faction-members-panel__member-avatar--placeholder {
      display: inline-block;
      background: #747b81;
      opacity: 0.35; }
  .factions-reputations-faction-members-panel__member-name {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #afa991;
    font-size: 0.88rem; }
  .factions-reputations-faction-members-panel__member-rank {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    object-fit: contain; }
  .factions-reputations-faction-members-panel__member-percent {
    flex-shrink: 0;
    font-size: 0.72rem;
    font-weight: 700;
    color: rgba(223, 223, 223, 0.82); }

@media (max-width: 980px) {
  .personal-hub-factions-reputations {
    max-width: 100%; }
  .factions-reputations-factions-card__layout {
    grid-template-columns: 1fr; }
  .factions-reputations-factions-card__detail-region {
    flex-direction: column; }
    .factions-reputations-factions-card__detail-region--members-open {
      gap: 0.45rem; }
  .factions-reputations-faction-members-panel--open {
    flex: 1 1 auto;
    width: 100%;
    max-height: 240px; }
  .factions-reputations-faction-list__scroll {
    max-height: 280px; } }

.factions-reputations-help-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.45rem;
  min-width: 0; }
  .factions-reputations-help-row .factions-reputations-grade-stepper__label,
  .factions-reputations-help-row .factions-reputations-faction-detail__notes-label,
  .factions-reputations-help-row .factions-reputations-faction-list__title {
    flex: 1 1 auto;
    min-width: 0; }

.factions-reputations-affinity-meter {
  flex: 1 1 auto;
  width: 100%;
  min-width: 0; }
  .factions-reputations-affinity-meter__track {
    position: relative;
    display: block;
    height: 8px;
    border-radius: 999px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.06); }
  .factions-reputations-affinity-meter__half {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 50%; }
    .factions-reputations-affinity-meter__half--negative {
      left: 0;
      background: linear-gradient(90deg, rgba(73, 18, 18, 0.35), rgba(209, 35, 35, 0.12)); }
    .factions-reputations-affinity-meter__half--positive {
      right: 0;
      background: linear-gradient(90deg, rgba(117, 207, 120, 0.12), rgba(90, 160, 92, 0.35)); }
  .factions-reputations-affinity-meter__center {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    width: 1px;
    transform: translateX(-50%);
    background: rgba(223, 223, 223, 0.55);
    z-index: 2; }
  .factions-reputations-affinity-meter__fill {
    position: absolute;
    top: 1px;
    bottom: 1px;
    z-index: 1;
    border-radius: 999px; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='0'] {
      --factions-reputations-affinity-extent: 0; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='1'] {
      --factions-reputations-affinity-extent: 1; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='2'] {
      --factions-reputations-affinity-extent: 2; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='3'] {
      --factions-reputations-affinity-extent: 3; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='4'] {
      --factions-reputations-affinity-extent: 4; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='5'] {
      --factions-reputations-affinity-extent: 5; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='6'] {
      --factions-reputations-affinity-extent: 6; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='7'] {
      --factions-reputations-affinity-extent: 7; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='8'] {
      --factions-reputations-affinity-extent: 8; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='9'] {
      --factions-reputations-affinity-extent: 9; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='10'] {
      --factions-reputations-affinity-extent: 10; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='11'] {
      --factions-reputations-affinity-extent: 11; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='12'] {
      --factions-reputations-affinity-extent: 12; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='13'] {
      --factions-reputations-affinity-extent: 13; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='14'] {
      --factions-reputations-affinity-extent: 14; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='15'] {
      --factions-reputations-affinity-extent: 15; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='16'] {
      --factions-reputations-affinity-extent: 16; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='17'] {
      --factions-reputations-affinity-extent: 17; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='18'] {
      --factions-reputations-affinity-extent: 18; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='19'] {
      --factions-reputations-affinity-extent: 19; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='20'] {
      --factions-reputations-affinity-extent: 20; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='21'] {
      --factions-reputations-affinity-extent: 21; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='22'] {
      --factions-reputations-affinity-extent: 22; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='23'] {
      --factions-reputations-affinity-extent: 23; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='24'] {
      --factions-reputations-affinity-extent: 24; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='25'] {
      --factions-reputations-affinity-extent: 25; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='26'] {
      --factions-reputations-affinity-extent: 26; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='27'] {
      --factions-reputations-affinity-extent: 27; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='28'] {
      --factions-reputations-affinity-extent: 28; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='29'] {
      --factions-reputations-affinity-extent: 29; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='30'] {
      --factions-reputations-affinity-extent: 30; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='31'] {
      --factions-reputations-affinity-extent: 31; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='32'] {
      --factions-reputations-affinity-extent: 32; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='33'] {
      --factions-reputations-affinity-extent: 33; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='34'] {
      --factions-reputations-affinity-extent: 34; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='35'] {
      --factions-reputations-affinity-extent: 35; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='36'] {
      --factions-reputations-affinity-extent: 36; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='37'] {
      --factions-reputations-affinity-extent: 37; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='38'] {
      --factions-reputations-affinity-extent: 38; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='39'] {
      --factions-reputations-affinity-extent: 39; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='40'] {
      --factions-reputations-affinity-extent: 40; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='41'] {
      --factions-reputations-affinity-extent: 41; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='42'] {
      --factions-reputations-affinity-extent: 42; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='43'] {
      --factions-reputations-affinity-extent: 43; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='44'] {
      --factions-reputations-affinity-extent: 44; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='45'] {
      --factions-reputations-affinity-extent: 45; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='46'] {
      --factions-reputations-affinity-extent: 46; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='47'] {
      --factions-reputations-affinity-extent: 47; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='48'] {
      --factions-reputations-affinity-extent: 48; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='49'] {
      --factions-reputations-affinity-extent: 49; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='50'] {
      --factions-reputations-affinity-extent: 50; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='51'] {
      --factions-reputations-affinity-extent: 51; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='52'] {
      --factions-reputations-affinity-extent: 52; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='53'] {
      --factions-reputations-affinity-extent: 53; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='54'] {
      --factions-reputations-affinity-extent: 54; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='55'] {
      --factions-reputations-affinity-extent: 55; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='56'] {
      --factions-reputations-affinity-extent: 56; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='57'] {
      --factions-reputations-affinity-extent: 57; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='58'] {
      --factions-reputations-affinity-extent: 58; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='59'] {
      --factions-reputations-affinity-extent: 59; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='60'] {
      --factions-reputations-affinity-extent: 60; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='61'] {
      --factions-reputations-affinity-extent: 61; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='62'] {
      --factions-reputations-affinity-extent: 62; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='63'] {
      --factions-reputations-affinity-extent: 63; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='64'] {
      --factions-reputations-affinity-extent: 64; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='65'] {
      --factions-reputations-affinity-extent: 65; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='66'] {
      --factions-reputations-affinity-extent: 66; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='67'] {
      --factions-reputations-affinity-extent: 67; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='68'] {
      --factions-reputations-affinity-extent: 68; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='69'] {
      --factions-reputations-affinity-extent: 69; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='70'] {
      --factions-reputations-affinity-extent: 70; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='71'] {
      --factions-reputations-affinity-extent: 71; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='72'] {
      --factions-reputations-affinity-extent: 72; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='73'] {
      --factions-reputations-affinity-extent: 73; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='74'] {
      --factions-reputations-affinity-extent: 74; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='75'] {
      --factions-reputations-affinity-extent: 75; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='76'] {
      --factions-reputations-affinity-extent: 76; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='77'] {
      --factions-reputations-affinity-extent: 77; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='78'] {
      --factions-reputations-affinity-extent: 78; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='79'] {
      --factions-reputations-affinity-extent: 79; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='80'] {
      --factions-reputations-affinity-extent: 80; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='81'] {
      --factions-reputations-affinity-extent: 81; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='82'] {
      --factions-reputations-affinity-extent: 82; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='83'] {
      --factions-reputations-affinity-extent: 83; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='84'] {
      --factions-reputations-affinity-extent: 84; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='85'] {
      --factions-reputations-affinity-extent: 85; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='86'] {
      --factions-reputations-affinity-extent: 86; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='87'] {
      --factions-reputations-affinity-extent: 87; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='88'] {
      --factions-reputations-affinity-extent: 88; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='89'] {
      --factions-reputations-affinity-extent: 89; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='90'] {
      --factions-reputations-affinity-extent: 90; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='91'] {
      --factions-reputations-affinity-extent: 91; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='92'] {
      --factions-reputations-affinity-extent: 92; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='93'] {
      --factions-reputations-affinity-extent: 93; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='94'] {
      --factions-reputations-affinity-extent: 94; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='95'] {
      --factions-reputations-affinity-extent: 95; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='96'] {
      --factions-reputations-affinity-extent: 96; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='97'] {
      --factions-reputations-affinity-extent: 97; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='98'] {
      --factions-reputations-affinity-extent: 98; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='99'] {
      --factions-reputations-affinity-extent: 99; }
    .factions-reputations-affinity-meter__fill[data-affinity-extent='100'] {
      --factions-reputations-affinity-extent: 100; }
    .factions-reputations-affinity-meter__fill--negative {
      right: 50%;
      width: calc(var(--factions-reputations-affinity-extent, 0) * 1% / 2);
      background: linear-gradient(90deg, #491212, #d12323); }
    .factions-reputations-affinity-meter__fill--positive {
      left: 50%;
      width: calc(var(--factions-reputations-affinity-extent, 0) * 1% / 2);
      background: linear-gradient(90deg, #75cf78, #5aa05c); }
    .factions-reputations-affinity-meter__fill--neutral {
      display: none; }
  .factions-reputations-affinity-meter__marker {
    position: absolute;
    top: 50%;
    left: calc(var(--factions-reputations-affinity-pos, 50) * 1%);
    z-index: 3;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #dfdfdf;
    border: 1px solid rgba(21, 28, 36, 0.9);
    transform: translate(-50%, -50%); }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='0'] {
      --factions-reputations-affinity-pos: 0; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='1'] {
      --factions-reputations-affinity-pos: 1; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='2'] {
      --factions-reputations-affinity-pos: 2; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='3'] {
      --factions-reputations-affinity-pos: 3; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='4'] {
      --factions-reputations-affinity-pos: 4; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='5'] {
      --factions-reputations-affinity-pos: 5; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='6'] {
      --factions-reputations-affinity-pos: 6; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='7'] {
      --factions-reputations-affinity-pos: 7; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='8'] {
      --factions-reputations-affinity-pos: 8; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='9'] {
      --factions-reputations-affinity-pos: 9; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='10'] {
      --factions-reputations-affinity-pos: 10; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='11'] {
      --factions-reputations-affinity-pos: 11; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='12'] {
      --factions-reputations-affinity-pos: 12; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='13'] {
      --factions-reputations-affinity-pos: 13; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='14'] {
      --factions-reputations-affinity-pos: 14; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='15'] {
      --factions-reputations-affinity-pos: 15; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='16'] {
      --factions-reputations-affinity-pos: 16; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='17'] {
      --factions-reputations-affinity-pos: 17; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='18'] {
      --factions-reputations-affinity-pos: 18; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='19'] {
      --factions-reputations-affinity-pos: 19; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='20'] {
      --factions-reputations-affinity-pos: 20; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='21'] {
      --factions-reputations-affinity-pos: 21; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='22'] {
      --factions-reputations-affinity-pos: 22; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='23'] {
      --factions-reputations-affinity-pos: 23; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='24'] {
      --factions-reputations-affinity-pos: 24; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='25'] {
      --factions-reputations-affinity-pos: 25; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='26'] {
      --factions-reputations-affinity-pos: 26; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='27'] {
      --factions-reputations-affinity-pos: 27; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='28'] {
      --factions-reputations-affinity-pos: 28; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='29'] {
      --factions-reputations-affinity-pos: 29; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='30'] {
      --factions-reputations-affinity-pos: 30; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='31'] {
      --factions-reputations-affinity-pos: 31; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='32'] {
      --factions-reputations-affinity-pos: 32; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='33'] {
      --factions-reputations-affinity-pos: 33; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='34'] {
      --factions-reputations-affinity-pos: 34; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='35'] {
      --factions-reputations-affinity-pos: 35; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='36'] {
      --factions-reputations-affinity-pos: 36; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='37'] {
      --factions-reputations-affinity-pos: 37; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='38'] {
      --factions-reputations-affinity-pos: 38; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='39'] {
      --factions-reputations-affinity-pos: 39; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='40'] {
      --factions-reputations-affinity-pos: 40; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='41'] {
      --factions-reputations-affinity-pos: 41; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='42'] {
      --factions-reputations-affinity-pos: 42; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='43'] {
      --factions-reputations-affinity-pos: 43; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='44'] {
      --factions-reputations-affinity-pos: 44; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='45'] {
      --factions-reputations-affinity-pos: 45; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='46'] {
      --factions-reputations-affinity-pos: 46; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='47'] {
      --factions-reputations-affinity-pos: 47; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='48'] {
      --factions-reputations-affinity-pos: 48; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='49'] {
      --factions-reputations-affinity-pos: 49; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='50'] {
      --factions-reputations-affinity-pos: 50; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='51'] {
      --factions-reputations-affinity-pos: 51; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='52'] {
      --factions-reputations-affinity-pos: 52; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='53'] {
      --factions-reputations-affinity-pos: 53; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='54'] {
      --factions-reputations-affinity-pos: 54; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='55'] {
      --factions-reputations-affinity-pos: 55; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='56'] {
      --factions-reputations-affinity-pos: 56; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='57'] {
      --factions-reputations-affinity-pos: 57; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='58'] {
      --factions-reputations-affinity-pos: 58; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='59'] {
      --factions-reputations-affinity-pos: 59; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='60'] {
      --factions-reputations-affinity-pos: 60; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='61'] {
      --factions-reputations-affinity-pos: 61; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='62'] {
      --factions-reputations-affinity-pos: 62; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='63'] {
      --factions-reputations-affinity-pos: 63; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='64'] {
      --factions-reputations-affinity-pos: 64; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='65'] {
      --factions-reputations-affinity-pos: 65; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='66'] {
      --factions-reputations-affinity-pos: 66; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='67'] {
      --factions-reputations-affinity-pos: 67; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='68'] {
      --factions-reputations-affinity-pos: 68; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='69'] {
      --factions-reputations-affinity-pos: 69; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='70'] {
      --factions-reputations-affinity-pos: 70; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='71'] {
      --factions-reputations-affinity-pos: 71; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='72'] {
      --factions-reputations-affinity-pos: 72; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='73'] {
      --factions-reputations-affinity-pos: 73; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='74'] {
      --factions-reputations-affinity-pos: 74; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='75'] {
      --factions-reputations-affinity-pos: 75; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='76'] {
      --factions-reputations-affinity-pos: 76; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='77'] {
      --factions-reputations-affinity-pos: 77; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='78'] {
      --factions-reputations-affinity-pos: 78; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='79'] {
      --factions-reputations-affinity-pos: 79; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='80'] {
      --factions-reputations-affinity-pos: 80; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='81'] {
      --factions-reputations-affinity-pos: 81; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='82'] {
      --factions-reputations-affinity-pos: 82; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='83'] {
      --factions-reputations-affinity-pos: 83; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='84'] {
      --factions-reputations-affinity-pos: 84; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='85'] {
      --factions-reputations-affinity-pos: 85; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='86'] {
      --factions-reputations-affinity-pos: 86; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='87'] {
      --factions-reputations-affinity-pos: 87; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='88'] {
      --factions-reputations-affinity-pos: 88; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='89'] {
      --factions-reputations-affinity-pos: 89; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='90'] {
      --factions-reputations-affinity-pos: 90; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='91'] {
      --factions-reputations-affinity-pos: 91; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='92'] {
      --factions-reputations-affinity-pos: 92; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='93'] {
      --factions-reputations-affinity-pos: 93; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='94'] {
      --factions-reputations-affinity-pos: 94; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='95'] {
      --factions-reputations-affinity-pos: 95; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='96'] {
      --factions-reputations-affinity-pos: 96; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='97'] {
      --factions-reputations-affinity-pos: 97; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='98'] {
      --factions-reputations-affinity-pos: 98; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='99'] {
      --factions-reputations-affinity-pos: 99; }
    .factions-reputations-affinity-meter__marker[data-affinity-pos='100'] {
      --factions-reputations-affinity-pos: 100; }

.factions-reputations-affinity-bar {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  margin: 0.85rem 1rem 0;
  padding: 0.65rem 0.8rem;
  border: 1px solid rgba(58, 120, 180, 0.22);
  border-radius: 10px;
  background: rgba(0, 48, 77, 0.28); }
  .factions-reputations-affinity-bar__header {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 0.75rem;
    min-width: 0; }
  .factions-reputations-affinity-bar__title-row {
    display: flex;
    align-items: center;
    gap: 0.45rem;
    min-width: 0; }
  .factions-reputations-affinity-bar__icon {
    width: 1.1rem;
    height: 1.1rem;
    object-fit: contain;
    flex: 0 0 auto; }
  .factions-reputations-affinity-bar__title {
    margin: 0;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.92); }
  .factions-reputations-affinity-bar__standing-label {
    margin: 0;
    font-size: 0.78rem;
    font-weight: 600;
    text-align: right;
    color: rgba(184, 184, 184, 0.92); }
    .factions-reputations-affinity-bar__standing-label--hostile {
      color: #d12323; }
    .factions-reputations-affinity-bar__standing-label--neutral {
      color: #c78445; }
    .factions-reputations-affinity-bar__standing-label--friendly, .factions-reputations-affinity-bar__standing-label--trusted {
      color: #75cf78; }
    .factions-reputations-affinity-bar__standing-label--legendary, .factions-reputations-affinity-bar__standing-label--renown {
      color: #d8b493; }
    .factions-reputations-affinity-bar__standing-label--unselected {
      color: #384858; }
  .factions-reputations-affinity-bar__limit {
    margin: 0;
    font-size: 0.72rem;
    color: rgba(199, 132, 69, 0.9); }
  .factions-reputations-affinity-bar--dragging {
    user-select: none; }
    .factions-reputations-affinity-bar--dragging .factions-reputations-affinity-bar__standings {
      pointer-events: none; }
  .factions-reputations-affinity-bar__track {
    position: relative;
    height: 15px;
    border-radius: 8px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.06); }
  .factions-reputations-affinity-bar__half {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 50%;
    pointer-events: none; }
    .factions-reputations-affinity-bar__half--negative {
      left: 0;
      background: linear-gradient(90deg, rgba(73, 18, 18, 0.42), rgba(209, 35, 35, 0.1)); }
    .factions-reputations-affinity-bar__half--positive {
      right: 0;
      background: linear-gradient(90deg, rgba(117, 207, 120, 0.1), rgba(90, 160, 92, 0.42)); }
  .factions-reputations-affinity-bar__center {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    z-index: 2;
    width: 2px;
    transform: translateX(-50%);
    background: rgba(223, 223, 223, 0.65);
    pointer-events: none; }
  .factions-reputations-affinity-bar__fill {
    position: absolute;
    top: 4px;
    bottom: 4px;
    z-index: 1;
    border-radius: 6px;
    pointer-events: none; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='0'] {
      --factions-reputations-affinity-extent: 0; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='1'] {
      --factions-reputations-affinity-extent: 1; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='2'] {
      --factions-reputations-affinity-extent: 2; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='3'] {
      --factions-reputations-affinity-extent: 3; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='4'] {
      --factions-reputations-affinity-extent: 4; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='5'] {
      --factions-reputations-affinity-extent: 5; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='6'] {
      --factions-reputations-affinity-extent: 6; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='7'] {
      --factions-reputations-affinity-extent: 7; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='8'] {
      --factions-reputations-affinity-extent: 8; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='9'] {
      --factions-reputations-affinity-extent: 9; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='10'] {
      --factions-reputations-affinity-extent: 10; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='11'] {
      --factions-reputations-affinity-extent: 11; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='12'] {
      --factions-reputations-affinity-extent: 12; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='13'] {
      --factions-reputations-affinity-extent: 13; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='14'] {
      --factions-reputations-affinity-extent: 14; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='15'] {
      --factions-reputations-affinity-extent: 15; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='16'] {
      --factions-reputations-affinity-extent: 16; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='17'] {
      --factions-reputations-affinity-extent: 17; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='18'] {
      --factions-reputations-affinity-extent: 18; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='19'] {
      --factions-reputations-affinity-extent: 19; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='20'] {
      --factions-reputations-affinity-extent: 20; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='21'] {
      --factions-reputations-affinity-extent: 21; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='22'] {
      --factions-reputations-affinity-extent: 22; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='23'] {
      --factions-reputations-affinity-extent: 23; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='24'] {
      --factions-reputations-affinity-extent: 24; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='25'] {
      --factions-reputations-affinity-extent: 25; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='26'] {
      --factions-reputations-affinity-extent: 26; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='27'] {
      --factions-reputations-affinity-extent: 27; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='28'] {
      --factions-reputations-affinity-extent: 28; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='29'] {
      --factions-reputations-affinity-extent: 29; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='30'] {
      --factions-reputations-affinity-extent: 30; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='31'] {
      --factions-reputations-affinity-extent: 31; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='32'] {
      --factions-reputations-affinity-extent: 32; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='33'] {
      --factions-reputations-affinity-extent: 33; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='34'] {
      --factions-reputations-affinity-extent: 34; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='35'] {
      --factions-reputations-affinity-extent: 35; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='36'] {
      --factions-reputations-affinity-extent: 36; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='37'] {
      --factions-reputations-affinity-extent: 37; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='38'] {
      --factions-reputations-affinity-extent: 38; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='39'] {
      --factions-reputations-affinity-extent: 39; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='40'] {
      --factions-reputations-affinity-extent: 40; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='41'] {
      --factions-reputations-affinity-extent: 41; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='42'] {
      --factions-reputations-affinity-extent: 42; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='43'] {
      --factions-reputations-affinity-extent: 43; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='44'] {
      --factions-reputations-affinity-extent: 44; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='45'] {
      --factions-reputations-affinity-extent: 45; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='46'] {
      --factions-reputations-affinity-extent: 46; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='47'] {
      --factions-reputations-affinity-extent: 47; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='48'] {
      --factions-reputations-affinity-extent: 48; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='49'] {
      --factions-reputations-affinity-extent: 49; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='50'] {
      --factions-reputations-affinity-extent: 50; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='51'] {
      --factions-reputations-affinity-extent: 51; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='52'] {
      --factions-reputations-affinity-extent: 52; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='53'] {
      --factions-reputations-affinity-extent: 53; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='54'] {
      --factions-reputations-affinity-extent: 54; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='55'] {
      --factions-reputations-affinity-extent: 55; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='56'] {
      --factions-reputations-affinity-extent: 56; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='57'] {
      --factions-reputations-affinity-extent: 57; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='58'] {
      --factions-reputations-affinity-extent: 58; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='59'] {
      --factions-reputations-affinity-extent: 59; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='60'] {
      --factions-reputations-affinity-extent: 60; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='61'] {
      --factions-reputations-affinity-extent: 61; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='62'] {
      --factions-reputations-affinity-extent: 62; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='63'] {
      --factions-reputations-affinity-extent: 63; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='64'] {
      --factions-reputations-affinity-extent: 64; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='65'] {
      --factions-reputations-affinity-extent: 65; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='66'] {
      --factions-reputations-affinity-extent: 66; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='67'] {
      --factions-reputations-affinity-extent: 67; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='68'] {
      --factions-reputations-affinity-extent: 68; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='69'] {
      --factions-reputations-affinity-extent: 69; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='70'] {
      --factions-reputations-affinity-extent: 70; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='71'] {
      --factions-reputations-affinity-extent: 71; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='72'] {
      --factions-reputations-affinity-extent: 72; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='73'] {
      --factions-reputations-affinity-extent: 73; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='74'] {
      --factions-reputations-affinity-extent: 74; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='75'] {
      --factions-reputations-affinity-extent: 75; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='76'] {
      --factions-reputations-affinity-extent: 76; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='77'] {
      --factions-reputations-affinity-extent: 77; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='78'] {
      --factions-reputations-affinity-extent: 78; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='79'] {
      --factions-reputations-affinity-extent: 79; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='80'] {
      --factions-reputations-affinity-extent: 80; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='81'] {
      --factions-reputations-affinity-extent: 81; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='82'] {
      --factions-reputations-affinity-extent: 82; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='83'] {
      --factions-reputations-affinity-extent: 83; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='84'] {
      --factions-reputations-affinity-extent: 84; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='85'] {
      --factions-reputations-affinity-extent: 85; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='86'] {
      --factions-reputations-affinity-extent: 86; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='87'] {
      --factions-reputations-affinity-extent: 87; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='88'] {
      --factions-reputations-affinity-extent: 88; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='89'] {
      --factions-reputations-affinity-extent: 89; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='90'] {
      --factions-reputations-affinity-extent: 90; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='91'] {
      --factions-reputations-affinity-extent: 91; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='92'] {
      --factions-reputations-affinity-extent: 92; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='93'] {
      --factions-reputations-affinity-extent: 93; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='94'] {
      --factions-reputations-affinity-extent: 94; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='95'] {
      --factions-reputations-affinity-extent: 95; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='96'] {
      --factions-reputations-affinity-extent: 96; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='97'] {
      --factions-reputations-affinity-extent: 97; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='98'] {
      --factions-reputations-affinity-extent: 98; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='99'] {
      --factions-reputations-affinity-extent: 99; }
    .factions-reputations-affinity-bar__fill[data-affinity-extent='100'] {
      --factions-reputations-affinity-extent: 100; }
    .factions-reputations-affinity-bar__fill--negative {
      right: 50%;
      width: calc(var(--factions-reputations-affinity-extent, 0) * 1% / 2);
      background: linear-gradient(90deg, #491212, #d12323);
      box-shadow: 0 0 10px rgba(209, 35, 35, 0.35); }
    .factions-reputations-affinity-bar__fill--positive {
      left: 50%;
      width: calc(var(--factions-reputations-affinity-extent, 0) * 1% / 2);
      background: linear-gradient(90deg, #75cf78, #5aa05c);
      box-shadow: 0 0 10px rgba(117, 207, 120, 0.35); }
    .factions-reputations-affinity-bar__fill--neutral {
      display: none; }
  .factions-reputations-affinity-bar__standings {
    position: absolute;
    inset: 0;
    z-index: 4; }
  .factions-reputations-affinity-bar__standing {
    position: absolute;
    top: 0;
    bottom: 0;
    left: calc(var(--factions-reputations-affinity-pos, 50) * 1%);
    z-index: 4;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 0.85rem;
    padding: 0;
    border: 0;
    background: transparent;
    transform: translateX(-50%);
    pointer-events: none; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='0'] {
      --factions-reputations-affinity-pos: 0; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='1'] {
      --factions-reputations-affinity-pos: 1; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='2'] {
      --factions-reputations-affinity-pos: 2; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='3'] {
      --factions-reputations-affinity-pos: 3; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='4'] {
      --factions-reputations-affinity-pos: 4; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='5'] {
      --factions-reputations-affinity-pos: 5; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='6'] {
      --factions-reputations-affinity-pos: 6; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='7'] {
      --factions-reputations-affinity-pos: 7; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='8'] {
      --factions-reputations-affinity-pos: 8; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='9'] {
      --factions-reputations-affinity-pos: 9; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='10'] {
      --factions-reputations-affinity-pos: 10; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='11'] {
      --factions-reputations-affinity-pos: 11; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='12'] {
      --factions-reputations-affinity-pos: 12; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='13'] {
      --factions-reputations-affinity-pos: 13; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='14'] {
      --factions-reputations-affinity-pos: 14; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='15'] {
      --factions-reputations-affinity-pos: 15; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='16'] {
      --factions-reputations-affinity-pos: 16; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='17'] {
      --factions-reputations-affinity-pos: 17; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='18'] {
      --factions-reputations-affinity-pos: 18; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='19'] {
      --factions-reputations-affinity-pos: 19; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='20'] {
      --factions-reputations-affinity-pos: 20; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='21'] {
      --factions-reputations-affinity-pos: 21; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='22'] {
      --factions-reputations-affinity-pos: 22; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='23'] {
      --factions-reputations-affinity-pos: 23; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='24'] {
      --factions-reputations-affinity-pos: 24; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='25'] {
      --factions-reputations-affinity-pos: 25; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='26'] {
      --factions-reputations-affinity-pos: 26; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='27'] {
      --factions-reputations-affinity-pos: 27; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='28'] {
      --factions-reputations-affinity-pos: 28; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='29'] {
      --factions-reputations-affinity-pos: 29; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='30'] {
      --factions-reputations-affinity-pos: 30; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='31'] {
      --factions-reputations-affinity-pos: 31; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='32'] {
      --factions-reputations-affinity-pos: 32; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='33'] {
      --factions-reputations-affinity-pos: 33; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='34'] {
      --factions-reputations-affinity-pos: 34; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='35'] {
      --factions-reputations-affinity-pos: 35; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='36'] {
      --factions-reputations-affinity-pos: 36; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='37'] {
      --factions-reputations-affinity-pos: 37; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='38'] {
      --factions-reputations-affinity-pos: 38; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='39'] {
      --factions-reputations-affinity-pos: 39; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='40'] {
      --factions-reputations-affinity-pos: 40; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='41'] {
      --factions-reputations-affinity-pos: 41; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='42'] {
      --factions-reputations-affinity-pos: 42; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='43'] {
      --factions-reputations-affinity-pos: 43; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='44'] {
      --factions-reputations-affinity-pos: 44; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='45'] {
      --factions-reputations-affinity-pos: 45; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='46'] {
      --factions-reputations-affinity-pos: 46; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='47'] {
      --factions-reputations-affinity-pos: 47; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='48'] {
      --factions-reputations-affinity-pos: 48; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='49'] {
      --factions-reputations-affinity-pos: 49; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='50'] {
      --factions-reputations-affinity-pos: 50; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='51'] {
      --factions-reputations-affinity-pos: 51; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='52'] {
      --factions-reputations-affinity-pos: 52; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='53'] {
      --factions-reputations-affinity-pos: 53; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='54'] {
      --factions-reputations-affinity-pos: 54; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='55'] {
      --factions-reputations-affinity-pos: 55; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='56'] {
      --factions-reputations-affinity-pos: 56; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='57'] {
      --factions-reputations-affinity-pos: 57; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='58'] {
      --factions-reputations-affinity-pos: 58; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='59'] {
      --factions-reputations-affinity-pos: 59; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='60'] {
      --factions-reputations-affinity-pos: 60; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='61'] {
      --factions-reputations-affinity-pos: 61; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='62'] {
      --factions-reputations-affinity-pos: 62; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='63'] {
      --factions-reputations-affinity-pos: 63; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='64'] {
      --factions-reputations-affinity-pos: 64; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='65'] {
      --factions-reputations-affinity-pos: 65; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='66'] {
      --factions-reputations-affinity-pos: 66; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='67'] {
      --factions-reputations-affinity-pos: 67; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='68'] {
      --factions-reputations-affinity-pos: 68; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='69'] {
      --factions-reputations-affinity-pos: 69; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='70'] {
      --factions-reputations-affinity-pos: 70; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='71'] {
      --factions-reputations-affinity-pos: 71; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='72'] {
      --factions-reputations-affinity-pos: 72; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='73'] {
      --factions-reputations-affinity-pos: 73; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='74'] {
      --factions-reputations-affinity-pos: 74; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='75'] {
      --factions-reputations-affinity-pos: 75; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='76'] {
      --factions-reputations-affinity-pos: 76; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='77'] {
      --factions-reputations-affinity-pos: 77; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='78'] {
      --factions-reputations-affinity-pos: 78; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='79'] {
      --factions-reputations-affinity-pos: 79; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='80'] {
      --factions-reputations-affinity-pos: 80; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='81'] {
      --factions-reputations-affinity-pos: 81; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='82'] {
      --factions-reputations-affinity-pos: 82; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='83'] {
      --factions-reputations-affinity-pos: 83; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='84'] {
      --factions-reputations-affinity-pos: 84; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='85'] {
      --factions-reputations-affinity-pos: 85; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='86'] {
      --factions-reputations-affinity-pos: 86; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='87'] {
      --factions-reputations-affinity-pos: 87; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='88'] {
      --factions-reputations-affinity-pos: 88; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='89'] {
      --factions-reputations-affinity-pos: 89; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='90'] {
      --factions-reputations-affinity-pos: 90; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='91'] {
      --factions-reputations-affinity-pos: 91; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='92'] {
      --factions-reputations-affinity-pos: 92; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='93'] {
      --factions-reputations-affinity-pos: 93; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='94'] {
      --factions-reputations-affinity-pos: 94; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='95'] {
      --factions-reputations-affinity-pos: 95; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='96'] {
      --factions-reputations-affinity-pos: 96; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='97'] {
      --factions-reputations-affinity-pos: 97; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='98'] {
      --factions-reputations-affinity-pos: 98; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='99'] {
      --factions-reputations-affinity-pos: 99; }
    .factions-reputations-affinity-bar__standing[data-affinity-pos='100'] {
      --factions-reputations-affinity-pos: 100; }
    .factions-reputations-affinity-bar__standing--selected .factions-reputations-affinity-bar__standing-tick {
      background: #dfdfdf;
      transform: scaleY(1.35);
      box-shadow: 0 0 0 1px rgba(58, 120, 180, 0.55); }
  .factions-reputations-affinity-bar__standing-tick {
    display: block;
    width: 2px;
    height: 55%;
    border-radius: 1px;
    background: rgba(223, 223, 223, 0.28);
    transition: background 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .factions-reputations-affinity-bar__marker {
    position: absolute;
    top: 50%;
    left: calc(var(--factions-reputations-affinity-pos, 50) * 1%);
    z-index: 6;
    width: 10px;
    height: 10px;
    padding: 0;
    border-radius: 50%;
    background: #dfdfdf;
    border: 2px solid rgba(21, 28, 36, 0.95);
    box-shadow: 0 0 0 1px rgba(58, 120, 180, 0.45);
    transform: translate(-50%, -50%);
    pointer-events: none; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='0'] {
      --factions-reputations-affinity-pos: 0; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='1'] {
      --factions-reputations-affinity-pos: 1; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='2'] {
      --factions-reputations-affinity-pos: 2; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='3'] {
      --factions-reputations-affinity-pos: 3; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='4'] {
      --factions-reputations-affinity-pos: 4; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='5'] {
      --factions-reputations-affinity-pos: 5; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='6'] {
      --factions-reputations-affinity-pos: 6; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='7'] {
      --factions-reputations-affinity-pos: 7; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='8'] {
      --factions-reputations-affinity-pos: 8; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='9'] {
      --factions-reputations-affinity-pos: 9; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='10'] {
      --factions-reputations-affinity-pos: 10; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='11'] {
      --factions-reputations-affinity-pos: 11; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='12'] {
      --factions-reputations-affinity-pos: 12; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='13'] {
      --factions-reputations-affinity-pos: 13; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='14'] {
      --factions-reputations-affinity-pos: 14; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='15'] {
      --factions-reputations-affinity-pos: 15; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='16'] {
      --factions-reputations-affinity-pos: 16; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='17'] {
      --factions-reputations-affinity-pos: 17; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='18'] {
      --factions-reputations-affinity-pos: 18; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='19'] {
      --factions-reputations-affinity-pos: 19; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='20'] {
      --factions-reputations-affinity-pos: 20; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='21'] {
      --factions-reputations-affinity-pos: 21; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='22'] {
      --factions-reputations-affinity-pos: 22; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='23'] {
      --factions-reputations-affinity-pos: 23; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='24'] {
      --factions-reputations-affinity-pos: 24; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='25'] {
      --factions-reputations-affinity-pos: 25; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='26'] {
      --factions-reputations-affinity-pos: 26; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='27'] {
      --factions-reputations-affinity-pos: 27; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='28'] {
      --factions-reputations-affinity-pos: 28; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='29'] {
      --factions-reputations-affinity-pos: 29; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='30'] {
      --factions-reputations-affinity-pos: 30; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='31'] {
      --factions-reputations-affinity-pos: 31; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='32'] {
      --factions-reputations-affinity-pos: 32; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='33'] {
      --factions-reputations-affinity-pos: 33; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='34'] {
      --factions-reputations-affinity-pos: 34; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='35'] {
      --factions-reputations-affinity-pos: 35; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='36'] {
      --factions-reputations-affinity-pos: 36; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='37'] {
      --factions-reputations-affinity-pos: 37; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='38'] {
      --factions-reputations-affinity-pos: 38; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='39'] {
      --factions-reputations-affinity-pos: 39; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='40'] {
      --factions-reputations-affinity-pos: 40; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='41'] {
      --factions-reputations-affinity-pos: 41; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='42'] {
      --factions-reputations-affinity-pos: 42; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='43'] {
      --factions-reputations-affinity-pos: 43; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='44'] {
      --factions-reputations-affinity-pos: 44; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='45'] {
      --factions-reputations-affinity-pos: 45; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='46'] {
      --factions-reputations-affinity-pos: 46; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='47'] {
      --factions-reputations-affinity-pos: 47; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='48'] {
      --factions-reputations-affinity-pos: 48; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='49'] {
      --factions-reputations-affinity-pos: 49; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='50'] {
      --factions-reputations-affinity-pos: 50; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='51'] {
      --factions-reputations-affinity-pos: 51; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='52'] {
      --factions-reputations-affinity-pos: 52; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='53'] {
      --factions-reputations-affinity-pos: 53; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='54'] {
      --factions-reputations-affinity-pos: 54; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='55'] {
      --factions-reputations-affinity-pos: 55; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='56'] {
      --factions-reputations-affinity-pos: 56; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='57'] {
      --factions-reputations-affinity-pos: 57; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='58'] {
      --factions-reputations-affinity-pos: 58; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='59'] {
      --factions-reputations-affinity-pos: 59; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='60'] {
      --factions-reputations-affinity-pos: 60; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='61'] {
      --factions-reputations-affinity-pos: 61; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='62'] {
      --factions-reputations-affinity-pos: 62; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='63'] {
      --factions-reputations-affinity-pos: 63; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='64'] {
      --factions-reputations-affinity-pos: 64; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='65'] {
      --factions-reputations-affinity-pos: 65; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='66'] {
      --factions-reputations-affinity-pos: 66; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='67'] {
      --factions-reputations-affinity-pos: 67; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='68'] {
      --factions-reputations-affinity-pos: 68; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='69'] {
      --factions-reputations-affinity-pos: 69; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='70'] {
      --factions-reputations-affinity-pos: 70; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='71'] {
      --factions-reputations-affinity-pos: 71; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='72'] {
      --factions-reputations-affinity-pos: 72; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='73'] {
      --factions-reputations-affinity-pos: 73; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='74'] {
      --factions-reputations-affinity-pos: 74; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='75'] {
      --factions-reputations-affinity-pos: 75; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='76'] {
      --factions-reputations-affinity-pos: 76; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='77'] {
      --factions-reputations-affinity-pos: 77; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='78'] {
      --factions-reputations-affinity-pos: 78; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='79'] {
      --factions-reputations-affinity-pos: 79; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='80'] {
      --factions-reputations-affinity-pos: 80; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='81'] {
      --factions-reputations-affinity-pos: 81; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='82'] {
      --factions-reputations-affinity-pos: 82; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='83'] {
      --factions-reputations-affinity-pos: 83; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='84'] {
      --factions-reputations-affinity-pos: 84; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='85'] {
      --factions-reputations-affinity-pos: 85; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='86'] {
      --factions-reputations-affinity-pos: 86; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='87'] {
      --factions-reputations-affinity-pos: 87; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='88'] {
      --factions-reputations-affinity-pos: 88; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='89'] {
      --factions-reputations-affinity-pos: 89; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='90'] {
      --factions-reputations-affinity-pos: 90; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='91'] {
      --factions-reputations-affinity-pos: 91; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='92'] {
      --factions-reputations-affinity-pos: 92; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='93'] {
      --factions-reputations-affinity-pos: 93; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='94'] {
      --factions-reputations-affinity-pos: 94; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='95'] {
      --factions-reputations-affinity-pos: 95; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='96'] {
      --factions-reputations-affinity-pos: 96; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='97'] {
      --factions-reputations-affinity-pos: 97; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='98'] {
      --factions-reputations-affinity-pos: 98; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='99'] {
      --factions-reputations-affinity-pos: 99; }
    .factions-reputations-affinity-bar__marker[data-affinity-pos='100'] {
      --factions-reputations-affinity-pos: 100; }
    .factions-reputations-affinity-bar__marker--draggable {
      pointer-events: auto;
      cursor: grab;
      touch-action: none; }
      .factions-reputations-affinity-bar__marker--draggable::before {
        content: '';
        position: absolute;
        inset: -10px; }
      .factions-reputations-affinity-bar__marker--draggable:disabled {
        cursor: default;
        pointer-events: none; }
      .factions-reputations-affinity-bar__marker--draggable:focus-visible {
        outline: 2px solid rgba(90, 195, 255, 0.85);
        outline-offset: 2px; }
    .factions-reputations-affinity-bar__marker--dragging {
      cursor: grabbing;
      transform: translate(-50%, -50%) scale(1.25);
      box-shadow: 0 0 0 2px rgba(90, 195, 255, 0.55), 0 0 12px rgba(90, 195, 255, 0.35);
      transition: transform 0.12s ease, box-shadow 0.12s ease; }
  .factions-reputations-affinity-bar__scale {
    display: flex;
    justify-content: space-between;
    font-size: 0.68rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    color: rgba(184, 184, 184, 0.72); }

.factions-reputations-grade-stepper--careers-empty .factions-reputations-grade-stepper__empty {
  margin: 0.35rem 0 0;
  color: rgba(184, 184, 184, 0.78);
  font-size: 0.82rem; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.personal-hub-blueprints {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  gap: 1rem;
  padding: 0 0rem 1.5rem; }

.personal-hub-blueprints-header {
  padding-bottom: 1rem;
  position: relative; }
  .personal-hub-blueprints-header .hangar-filters__top {
    position: relative;
    padding-right: 7rem; }
  .personal-hub-blueprints-header .hangar-filters__toolbar {
    align-items: center; }
  .personal-hub-blueprints-header .hangar-filters__group--members-panel {
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    align-items: stretch;
    gap: 0.4rem;
    margin-left: auto; }
  .personal-hub-blueprints-header.hangar-filters--with-help {
    overflow: visible;
    z-index: 1;
    isolation: auto; }
  .personal-hub-blueprints-header .hangar-filters__help-anchor {
    z-index: 11; }
  .personal-hub-blueprints-header .hangar-filters__help-popover {
    z-index: 12; }
  .personal-hub-blueprints-header__version {
    position: absolute;
    top: 0.5rem;
    right: 0.75rem;
    margin-left: 0;
    font-size: 0.74rem;
    color: rgba(223, 223, 223, 0.62);
    white-space: nowrap; }
  .personal-hub-blueprints-header.hangar-filters--with-help .personal-hub-blueprints-header__version {
    right: 2.75rem; }
  .personal-hub-blueprints-header .personal-hub-blueprints-card__my-blueprints-toggle,
  .personal-hub-blueprints-header .personal-hub-blueprints-card__members-toggle {
    white-space: nowrap; }

.personal-hub-blueprints-card {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex: 1 1 auto;
  min-height: 520px;
  background: none;
  border: none;
  box-shadow: none;
  padding: 0;
  overflow: visible;
  isolation: auto; }
  .personal-hub-blueprints-card.hangar-filters--horizontal {
    background: none;
    border: none;
    box-shadow: none;
    isolation: auto; }
  .personal-hub-blueprints-card__layout {
    display: grid;
    grid-template-columns: minmax(280px, 320px) minmax(0, 1fr);
    gap: 0.5rem;
    min-height: 0;
    flex: 1 1 auto;
    overflow: visible;
    padding: 2px 4px 12px;
    box-sizing: border-box; }
  .personal-hub-blueprints-card__detail-region {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    gap: 0;
    min-width: 0;
    min-height: 0; }
    .personal-hub-blueprints-card__detail-region--members-open {
      gap: 0.45rem; }
  .personal-hub-blueprints-card__detail {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-width: 0;
    min-height: 0;
    height: calc(100vh - 395px);
    max-height: calc(100vh - 395px);
    border: 1px solid rgba(58, 120, 180, 0.35);
    border-radius: 12px;
    background: linear-gradient(180deg, rgba(0, 48, 77, 0.72), rgba(21, 28, 36, 0.42)), rgba(0, 48, 77, 0.55);
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35), 0 10px 14px rgba(0, 0, 0, 0.35);
    padding: 1rem;
    overflow: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(58, 120, 180, 0.45) rgba(21, 28, 36, 0.35); }
    .personal-hub-blueprints-card__detail::-webkit-scrollbar {
      width: 8px; }
    .personal-hub-blueprints-card__detail::-webkit-scrollbar-track {
      background: rgba(21, 28, 36, 0.35);
      border-radius: 999px; }
    .personal-hub-blueprints-card__detail::-webkit-scrollbar-thumb {
      background: rgba(58, 120, 180, 0.45);
      border-radius: 999px; }
    .personal-hub-blueprints-card__detail--member-view {
      border-color: #c78445;
      box-shadow: 0 0 0 1px rgba(199, 132, 69, 0.55), 0 10px 14px rgba(0, 0, 0, 0.35); }
  .personal-hub-blueprints-card__detail-empty {
    margin: 0;
    color: rgba(223, 223, 223, 0.72);
    font-size: 0.95rem; }
  .personal-hub-blueprints-card__state {
    margin: 0;
    color: #b8b8b8; }
    .personal-hub-blueprints-card__state--error {
      color: #d12323; }

.personal-hub-blueprint-list {
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(58, 120, 180, 0.35);
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(0, 48, 77, 0.72), rgba(21, 28, 36, 0.42)), rgba(0, 48, 77, 0.55);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35), 0 12px 28px rgba(0, 0, 0, 0.35);
  overflow: visible; }
  .personal-hub-blueprint-list__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.75rem 0.85rem;
    border-bottom: 1px solid rgba(58, 120, 180, 0.25);
    border-radius: 12px 12px 0 0; }
  .personal-hub-blueprint-list__title {
    margin: 0;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.82); }
  .personal-hub-blueprint-list__count {
    font-size: 0.72rem;
    color: rgba(223, 223, 223, 0.55);
    white-space: nowrap; }
  .personal-hub-blueprint-list__section-separator {
    margin: 0.9rem 0.35rem;
    border: 0;
    border-top: 1px solid rgba(58, 120, 180, 0.38); }
  .personal-hub-blueprint-list__scroll {
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
    padding: 0.55rem 0.3rem 0.55rem 0.55rem;
    overflow: auto;
    max-height: calc(100vh - 430px);
    margin-bottom: 10px;
    border-radius: 0 0 12px 12px;
    scrollbar-width: thin;
    scrollbar-color: rgba(58, 120, 180, 0.45) rgba(21, 28, 36, 0.35); }
    .personal-hub-blueprint-list__scroll::-webkit-scrollbar {
      width: 8px; }
    .personal-hub-blueprint-list__scroll::-webkit-scrollbar-track {
      background: rgba(21, 28, 36, 0.35);
      border-radius: 999px; }
    .personal-hub-blueprint-list__scroll::-webkit-scrollbar-thumb {
      background: rgba(58, 120, 180, 0.45);
      border-radius: 999px; }
  .personal-hub-blueprint-list__empty {
    margin: 0.75rem 0.35rem;
    color: #b8b8b8;
    font-size: 0.9rem; }
  .personal-hub-blueprint-list__loading {
    margin: 0.35rem 0.35rem 0.75rem;
    color: rgba(223, 223, 223, 0.62);
    font-size: 0.78rem;
    font-style: italic; }

.personal-hub-blueprint-logo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 8px;
  background: rgba(58, 120, 180, 0.28);
  border: 1px solid rgba(58, 120, 180, 0.35);
  color: #dfdfdf;
  font-size: 0.95rem;
  font-weight: 700;
  flex-shrink: 0;
  object-fit: contain;
  padding: 4px;
  box-sizing: border-box; }
  .personal-hub-blueprint-logo--fallback {
    text-transform: uppercase; }

.personal-hub-blueprint-item {
  display: flex;
  align-items: stretch;
  gap: 0.35rem; }
  .personal-hub-blueprint-item--selected .personal-hub-blueprint-item__main {
    border-color: rgba(90, 195, 255, 0.85);
    box-shadow: 0 0 0 1px rgba(90, 195, 255, 0.35);
    background: rgba(58, 120, 180, 0.28); }
  .personal-hub-blueprint-item--selected .personal-hub-blueprint-item__main--member-owned {
    border-color: #c78445;
    box-shadow: 0 0 0 1px rgba(199, 132, 69, 0.35); }
  .personal-hub-blueprint-item--owned .personal-hub-blueprint-item__main {
    border-color: rgba(117, 207, 120, 0.45); }
  .personal-hub-blueprint-item--owned .personal-hub-blueprint-item__main--member-owned {
    border-color: #c78445; }
    .personal-hub-blueprint-item--owned .personal-hub-blueprint-item__main--member-owned:hover {
      border-color: #c78445; }
  .personal-hub-blueprint-item--not-owned .personal-hub-blueprint-item__main {
    background: rgba(23, 39, 56, 0.55);
    border-color: rgba(58, 120, 180, 0.28); }
  .personal-hub-blueprint-item__main {
    flex: 1 1 auto;
    display: grid;
    grid-template-columns: 42px minmax(0, 1fr);
    gap: 0.65rem;
    align-items: start;
    min-width: 0;
    padding: 0.55rem 0.65rem;
    border: 1px solid rgba(58, 120, 180, 0.28);
    border-radius: 8px;
    background: rgba(23, 39, 56, 0.55);
    color: inherit;
    text-align: left;
    cursor: pointer;
    transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease; }
    .personal-hub-blueprint-item__main:hover {
      border-color: rgba(90, 195, 255, 0.55);
      background: rgba(58, 120, 180, 0.22); }
    .personal-hub-blueprint-item__main:focus-visible {
      outline: 2px solid rgba(58, 120, 180, 0.75);
      outline-offset: 2px; }
    .personal-hub-blueprint-item__main--member-owned {
      border-color: #c78445; }
      .personal-hub-blueprint-item__main--member-owned:hover {
        border-color: #c78445; }
  .personal-hub-blueprint-item__body {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    min-width: 0; }
  .personal-hub-blueprint-item__copy {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    min-width: 0; }
  .personal-hub-blueprint-item__name {
    font-size: 0.92rem;
    font-weight: 700;
    color: #dfdfdf;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; }
  .personal-hub-blueprint-item__meta {
    display: flex;
    flex-wrap: wrap;
    gap: 0.35rem 0.55rem;
    font-size: 0.74rem;
    color: rgba(184, 184, 184, 0.92); }
  .personal-hub-blueprint-item__category {
    font-weight: 700;
    color: rgba(223, 223, 223, 0.72); }
  .personal-hub-blueprint-item__crafted {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; }
  .personal-hub-blueprint-item__favorite {
    flex: 0 0 34px;
    width: 34px;
    border: 1px solid rgba(58, 120, 180, 0.28);
    border-radius: 8px;
    background: rgba(0, 48, 77, 0.35);
    color: rgba(223, 223, 223, 0.55);
    font-size: 1rem;
    line-height: 1;
    cursor: pointer;
    transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease; }
    .personal-hub-blueprint-item__favorite:hover:not(:disabled) {
      color: #d8b493;
      border-color: rgba(199, 132, 69, 0.55); }
    .personal-hub-blueprint-item__favorite--active {
      color: #c78445;
      border-color: rgba(199, 132, 69, 0.65);
      background: rgba(199, 132, 69, 0.12); }
    .personal-hub-blueprint-item__favorite:disabled {
      cursor: not-allowed;
      opacity: 0.45; }

.personal-hub-blueprint-detail {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-height: 0; }
  .personal-hub-blueprint-detail--has-model {
    flex: 1 1 auto;
    min-height: 100%; }
    .personal-hub-blueprint-detail--has-model .personal-hub-blueprint-detail__hero,
    .personal-hub-blueprint-detail--has-model .personal-hub-blueprint-crafting,
    .personal-hub-blueprint-detail--has-model .personal-hub-blueprint-detail__notes-wrap {
      flex-shrink: 0; }
    .personal-hub-blueprint-detail--has-model .personal-hub-blueprint-detail__overview {
      flex: 1 1 auto;
      min-height: 0;
      align-items: stretch; }
  .personal-hub-blueprint-detail__hero {
    display: grid;
    grid-template-columns: 56px minmax(0, 1fr) auto;
    gap: 0.85rem;
    align-items: center;
    flex-shrink: 0; }
  .personal-hub-blueprint-detail__logo {
    width: 56px;
    height: 56px;
    font-size: 1.1rem; }
  .personal-hub-blueprint-detail__title {
    margin: 0;
    font-size: 1.15rem;
    color: #dfdfdf; }
  .personal-hub-blueprint-detail__subtitle {
    margin: 0.25rem 0 0;
    color: rgba(223, 223, 223, 0.72);
    font-size: 0.85rem; }
  .personal-hub-blueprint-detail__actions {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.45rem;
    flex-shrink: 0; }
  .personal-hub-blueprint-detail__favorite {
    flex: 0 0 34px;
    width: fit-content;
    height: 30px;
    padding: 0.2rem 0.85rem;
    border: 1px solid rgba(58, 120, 180, 0.28);
    border-radius: 8px;
    background: rgba(0, 48, 77, 0.35);
    color: rgba(223, 223, 223, 0.55);
    font-size: 0.95rem;
    text-align: left;
    line-height: 1;
    cursor: pointer;
    transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease; }
    .personal-hub-blueprint-detail__favorite--active {
      color: #c78445;
      border-color: rgba(199, 132, 69, 0.65);
      background: rgba(199, 132, 69, 0.12); }
    .personal-hub-blueprint-detail__favorite:hover:not(:disabled) {
      color: #d8b493;
      border-color: rgba(199, 132, 69, 0.55); }
    .personal-hub-blueprint-detail__favorite:disabled {
      cursor: not-allowed;
      opacity: 0.55; }
  .personal-hub-blueprint-detail__owned-btn {
    width: fit-content;
    min-height: 2rem;
    white-space: nowrap;
    padding: 0.3rem 0.95rem;
    border: 1px solid rgba(58, 120, 180, 0.5);
    border-radius: 8px;
    background: rgba(23, 39, 56, 0.88);
    color: #dfdfdf;
    font-size: 0.92rem;
    font-weight: 600;
    text-align: center;
    cursor: pointer;
    transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease; }
    .personal-hub-blueprint-detail__owned-btn--active {
      border-color: rgba(117, 207, 120, 0.75);
      background: rgba(117, 207, 120, 0.22);
      box-shadow: 0 0 0 1px rgba(117, 207, 120, 0.25); }
    .personal-hub-blueprint-detail__owned-btn:hover:not(:disabled) {
      border-color: rgba(90, 195, 255, 0.6);
      background: rgba(58, 120, 180, 0.28); }
    .personal-hub-blueprint-detail__owned-btn:disabled {
      cursor: not-allowed;
      opacity: 0.45; }
  .personal-hub-blueprint-detail__fields {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(14rem, 1fr));
    gap: 0.75rem 1rem;
    margin: 0; }
    .personal-hub-blueprint-detail__fields--beside-model {
      flex: 1 1 auto;
      display: flex;
      flex-direction: column;
      gap: 0.75rem;
      min-width: 0;
      align-self: center; }
  .personal-hub-blueprint-detail__overview {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem; }
  .personal-hub-blueprint-detail__model-aside {
    display: flex;
    flex-direction: column;
    flex: 0 0 70%;
    width: 70%;
    max-width: 70%;
    min-height: 0;
    margin-left: auto;
    align-self: stretch; }
    .personal-hub-blueprint-detail__model-aside.personal-hub-blueprint-detail__model-unavailable {
      align-self: stretch; }
    .personal-hub-blueprint-detail__model-aside .personal-hub-blueprint-model-viewer {
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
      min-height: 7rem;
      height: 100%;
      max-height: none; }
      .personal-hub-blueprint-detail__model-aside .personal-hub-blueprint-model-viewer .personal-hub-blueprint-model-viewer__stack,
      .personal-hub-blueprint-detail__model-aside .personal-hub-blueprint-model-viewer .personal-hub-blueprint-model-viewer__layer {
        flex: 1 1 auto;
        height: 100%;
        max-height: 100%;
        min-height: 0; }
    .personal-hub-blueprint-detail__model-aside .personal-hub-blueprint-model,
    .personal-hub-blueprint-detail__model-aside .personal-hub-blueprint-model__stats-panel {
      flex: 1 1 auto;
      height: 100%;
      max-height: 100%;
      min-height: 0; }
    .personal-hub-blueprint-detail__model-aside .personal-hub-blueprint-model {
      display: flex;
      flex-direction: column;
      min-height: 0; }
    .personal-hub-blueprint-detail__model-aside .personal-hub-blueprint-model__canvas {
      flex: 1 1 auto;
      height: 100%;
      min-height: 0; }
  .personal-hub-blueprint-detail__field {
    margin: 0;
    min-width: 0; }
  .personal-hub-blueprint-detail__field-label {
    margin: 0 0 0.2rem;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.55); }
  .personal-hub-blueprint-detail__field-value {
    margin: 0;
    color: rgba(223, 223, 223, 0.92);
    font-size: 0.88rem;
    line-height: 1.45;
    word-break: break-word; }
  .personal-hub-blueprint-detail__crafting-title {
    margin: 0 0 0.5rem;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.72); }
  .personal-hub-blueprint-detail__crafting-list {
    margin: 0;
    padding-left: 1.1rem;
    color: rgba(223, 223, 223, 0.88);
    font-size: 0.85rem;
    line-height: 1.5; }
  .personal-hub-blueprint-detail__notes-wrap {
    display: flex;
    flex-direction: column;
    gap: 0.65rem; }
  .personal-hub-blueprint-detail__notes-label {
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.82); }
  .personal-hub-blueprint-detail__notes {
    width: 100%;
    min-height: 45px;
    padding: 0.65rem 0.75rem;
    border: 1px solid rgba(58, 120, 180, 0.35);
    border-radius: 8px;
    background: rgba(0, 48, 77, 0.45);
    color: #dfdfdf;
    font: inherit;
    resize: vertical;
    box-sizing: border-box; }
    .personal-hub-blueprint-detail__notes::placeholder {
      color: rgba(184, 184, 184, 0.75); }
    .personal-hub-blueprint-detail__notes:disabled {
      opacity: 0.65;
      cursor: not-allowed; }
  .personal-hub-blueprint-detail__model-section {
    display: flex;
    flex-direction: column;
    gap: 0.55rem; }
  .personal-hub-blueprint-detail__model-title {
    margin: 0;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.72); }
  .personal-hub-blueprint-detail__model-unavailable {
    margin: 0;
    padding: 0.75rem 0.85rem;
    border: 1px dashed rgba(58, 120, 180, 0.35);
    border-radius: 10px;
    color: rgba(223, 223, 223, 0.62);
    font-size: 0.82rem;
    line-height: 1.45; }

.personal-hub-blueprint-crafting {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 0.85fr);
  gap: 0.75rem; }
  .personal-hub-blueprint-crafting--missions-only {
    grid-template-columns: minmax(0, 1fr);
    max-width: 22rem; }
  .personal-hub-blueprint-crafting__panel {
    display: flex;
    flex-direction: column;
    gap: 0.55rem;
    min-width: 0;
    padding: 0.85rem 0.3rem 0.85rem 0.85rem;
    border: 1px solid rgba(58, 120, 180, 0.35);
    border-radius: 10px;
    background: rgba(23, 39, 56, 0.55);
    position: relative;
    overflow: visible; }
  .personal-hub-blueprint-crafting__panel--ingredients .personal-hub-blueprints-help-row {
    align-items: center; }
  .personal-hub-blueprint-crafting__panel--ingredients .help-info-bubble__popover {
    left: auto;
    right: 0;
    width: min(18rem, calc(100vw - 2.5rem)); }
  .personal-hub-blueprint-crafting__panel-title {
    margin: 0;
    font-size: 0.70rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.72); }
  .personal-hub-blueprint-crafting__ingredient-list, .personal-hub-blueprint-crafting__stat-list {
    display: flex;
    flex-direction: column;
    gap: 0.65rem;
    margin: 0;
    padding: 0;
    list-style: none;
    max-height: calc(100vh - 807px);
    overflow-y: auto;
    margin-right: 0px;
    padding-right: 2px;
    scrollbar-width: thin;
    scrollbar-color: rgba(58, 120, 180, 0.35) rgba(0, 0, 0, 0.12); }
    .personal-hub-blueprint-crafting__ingredient-list::-webkit-scrollbar, .personal-hub-blueprint-crafting__stat-list::-webkit-scrollbar {
      width: 6px; }
    .personal-hub-blueprint-crafting__ingredient-list::-webkit-scrollbar-track, .personal-hub-blueprint-crafting__stat-list::-webkit-scrollbar-track {
      background: rgba(0, 0, 0, 0.12);
      border-radius: 999px; }
    .personal-hub-blueprint-crafting__ingredient-list::-webkit-scrollbar-thumb, .personal-hub-blueprint-crafting__stat-list::-webkit-scrollbar-thumb {
      background: rgba(58, 120, 180, 0.3);
      border-radius: 999px;
      border: 1px solid rgba(255, 255, 255, 0.08); }
    .personal-hub-blueprint-crafting__ingredient-list::-webkit-scrollbar-thumb:hover, .personal-hub-blueprint-crafting__stat-list::-webkit-scrollbar-thumb:hover {
      background: rgba(58, 120, 180, 0.42); }
  .personal-hub-blueprint-crafting__ingredient {
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
    padding: 0.3rem 0.7rem;
    border: 1px solid rgba(58, 120, 180, 0.22);
    border-radius: 8px;
    background: rgba(0, 48, 77, 0.35); }
  .personal-hub-blueprint-crafting__ingredient-copy {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 0.35rem 0.65rem;
    min-width: 0; }
  .personal-hub-blueprint-crafting__ingredient-controls {
    display: flex;
    align-items: center;
    gap: 0.65rem; }
  .personal-hub-blueprint-crafting__ingredient-title-row {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 0.35rem 0.5rem;
    min-width: 0;
    flex: 1 1 auto; }
  .personal-hub-blueprint-crafting__ingredient-slot {
    flex-shrink: 0;
    font-size: 0.68rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.55);
    white-space: nowrap; }
  .personal-hub-blueprint-crafting__ingredient-name {
    font-size: 0.88rem;
    font-weight: 700;
    color: #dfdfdf;
    word-break: break-word; }
  .personal-hub-blueprint-crafting__ingredient-qty {
    font-size: 0.76rem;
    color: rgba(184, 184, 184, 0.92);
    white-space: nowrap; }
  .personal-hub-blueprint-crafting__quality-value {
    position: relative;
    bottom: 0.2rem;
    flex-shrink: 0;
    width: 3.4rem;
    padding: 0.15rem 0.35rem;
    border-radius: 999px;
    border: 1px solid rgba(58, 120, 180, 0.35);
    background: rgba(0, 48, 77, 0.55);
    color: #dfdfdf;
    font-size: 0.78rem;
    font-weight: 700;
    text-align: center;
    font-variant-numeric: tabular-nums; }
    .personal-hub-blueprint-crafting__quality-value--below-default {
      color: #747b81;
      border-color: rgba(116, 123, 129, 0.45); }
    .personal-hub-blueprint-crafting__quality-value--tier-orange {
      color: #d8b493;
      border-color: rgba(216, 180, 147, 0.45); }
    .personal-hub-blueprint-crafting__quality-value--tier-green {
      color: #c2f0c3;
      border-color: rgba(194, 240, 195, 0.45); }
    .personal-hub-blueprint-crafting__quality-value--tier-blue {
      color: #5ac3ff;
      border-color: rgba(90, 195, 255, 0.55); }
    .personal-hub-blueprint-crafting__quality-value--tier-purple {
      color: #9a80e3;
      border-color: rgba(154, 128, 227, 0.55); }
    .personal-hub-blueprint-crafting__quality-value:focus-visible {
      outline: 2px solid rgba(58, 120, 180, 0.75);
      outline-offset: 2px; }
  .personal-hub-blueprint-crafting__slider-label {
    display: block;
    flex: 1 1 auto;
    min-width: 0; }
  .personal-hub-blueprint-crafting__slider {
    width: 100%;
    margin: 0;
    accent-color: #5ac3ff;
    cursor: pointer; }
    .personal-hub-blueprint-crafting__slider--below-default {
      accent-color: #747b81; }
    .personal-hub-blueprint-crafting__slider--tier-orange {
      accent-color: #d8b493; }
    .personal-hub-blueprint-crafting__slider--tier-green {
      accent-color: #c2f0c3; }
    .personal-hub-blueprint-crafting__slider--tier-blue {
      accent-color: #5ac3ff; }
    .personal-hub-blueprint-crafting__slider--tier-purple {
      accent-color: #9a80e3; }
  .personal-hub-blueprint-crafting__stat-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.55rem 0.65rem;
    border: 1px solid rgba(58, 120, 180, 0.22);
    border-radius: 8px;
    background: rgba(0, 48, 77, 0.35); }
  .personal-hub-blueprint-crafting__stat-name {
    font-size: 0.86rem;
    color: rgba(223, 223, 223, 0.92);
    line-height: 1.35; }
  .personal-hub-blueprint-crafting__stat-impact-wrap {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.12rem;
    flex-shrink: 0;
    text-align: right; }
  .personal-hub-blueprint-crafting__stat-impact {
    font-size: 0.86rem;
    font-weight: 700;
    font-variant-numeric: tabular-nums; }
    .personal-hub-blueprint-crafting__stat-impact--below-default {
      color: #747b81; }
    .personal-hub-blueprint-crafting__stat-impact--tier-orange {
      color: #d8b493; }
    .personal-hub-blueprint-crafting__stat-impact--tier-green {
      color: #c2f0c3; }
    .personal-hub-blueprint-crafting__stat-impact--tier-blue {
      color: #5ac3ff; }
    .personal-hub-blueprint-crafting__stat-impact--tier-purple {
      color: #9a80e3; }
  .personal-hub-blueprint-crafting__stat-detail {
    font-size: 0.76rem;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    color: #5ac3ff;
    line-height: 1.2; }
    .personal-hub-blueprint-crafting__stat-detail--solo {
      font-size: 0.86rem; }
  .personal-hub-blueprint-crafting__stat-empty {
    margin: 0;
    color: rgba(223, 223, 223, 0.62);
    font-size: 0.82rem;
    line-height: 1.45; }
  .personal-hub-blueprint-crafting__mission-list {
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 920px);
    gap: 0.55rem;
    margin: 0;
    padding: 0;
    list-style: none;
    overflow-y: auto;
    margin-right: 0px;
    padding-right: 2px;
    scrollbar-width: thin;
    scrollbar-color: rgba(58, 120, 180, 0.35) rgba(0, 0, 0, 0.12); }
    .personal-hub-blueprint-crafting__mission-list::-webkit-scrollbar {
      width: 6px; }
    .personal-hub-blueprint-crafting__mission-list::-webkit-scrollbar-track {
      background: rgba(0, 0, 0, 0.12);
      border-radius: 999px; }
    .personal-hub-blueprint-crafting__mission-list::-webkit-scrollbar-thumb {
      background: rgba(58, 120, 180, 0.3);
      border-radius: 999px;
      border: 1px solid rgba(255, 255, 255, 0.08); }
    .personal-hub-blueprint-crafting__mission-list::-webkit-scrollbar-thumb:hover {
      background: rgba(58, 120, 180, 0.42); }
  .personal-hub-blueprint-crafting__mission-item {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    padding: 0.55rem 0.6rem;
    border: 1px solid rgba(58, 120, 180, 0.22);
    border-radius: 8px;
    background: rgba(0, 48, 77, 0.35); }
  .personal-hub-blueprint-crafting__mission-name {
    font-size: 0.86rem;
    font-weight: 600;
    color: #dfdfdf;
    line-height: 1.35;
    word-break: break-word; }
  .personal-hub-blueprint-crafting__mission-faction {
    font-size: 0.78rem;
    font-weight: 600;
    color: #5ac3ff;
    line-height: 1.3;
    word-break: break-word; }
    .personal-hub-blueprint-crafting__mission-faction--link {
      align-self: flex-start;
      margin: 0;
      padding: 0;
      border: 0;
      background: transparent;
      font: inherit;
      font-size: 0.78rem;
      text-align: left;
      cursor: pointer;
      text-decoration: none; }
      .personal-hub-blueprint-crafting__mission-faction--link:hover, .personal-hub-blueprint-crafting__mission-faction--link:focus-visible {
        color: #dfdfdf;
        text-decoration-color: rgba(223, 223, 223, 0.65); }
      .personal-hub-blueprint-crafting__mission-faction--link:focus-visible {
        outline: 2px solid rgba(58, 120, 180, 0.55);
        outline-offset: 2px; }
  .personal-hub-blueprint-crafting__mission-empty {
    margin: 0;
    font-size: 0.82rem;
    color: rgba(223, 223, 223, 0.55);
    line-height: 1.45; }

.personal-hub-blueprint-model-viewer {
  position: relative;
  width: 100%; }
  .personal-hub-blueprint-model-viewer__stack {
    position: relative;
    width: 100%;
    height: 100%; }
  .personal-hub-blueprint-model-viewer__layer {
    width: 100%;
    height: 100%;
    min-height: 0; }
    .personal-hub-blueprint-model-viewer__layer--hidden {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      visibility: hidden;
      pointer-events: none;
      opacity: 0;
      z-index: 0;
      overflow: hidden; }
  .personal-hub-blueprint-model-viewer .personal-hub-blueprint-model__view-toggle {
    position: absolute;
    top: 0.55rem;
    left: 0.55rem;
    z-index: 4;
    margin: 0;
    padding: 0.3rem 0.65rem;
    border-radius: 999px;
    border: 1px solid rgba(58, 120, 180, 0.45);
    background: rgba(0, 48, 77, 0.72);
    color: #dfdfdf;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    cursor: pointer; }
    .personal-hub-blueprint-model-viewer .personal-hub-blueprint-model__view-toggle:hover {
      border-color: rgba(90, 195, 255, 0.55);
      color: #5ac3ff; }
    .personal-hub-blueprint-model-viewer .personal-hub-blueprint-model__view-toggle--stats {
      border-color: rgba(90, 195, 255, 0.55);
      color: #5ac3ff; }
  .personal-hub-blueprint-model-viewer .personal-hub-blueprint-model__stats-panel {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    box-sizing: border-box;
    overflow: hidden;
    padding: 2.5rem 0.4rem 0.35rem;
    border: 1px solid rgba(58, 120, 180, 0.35);
    border-radius: 10px;
    background: rgba(23, 39, 56, 0.72); }
  .personal-hub-blueprint-model-viewer .personal-hub-blueprint-model__stats-heading {
    flex-shrink: 0;
    margin: 0;
    padding: 0 0.1rem;
    font-size: 0.62rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.6);
    line-height: 1.2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; }
  .personal-hub-blueprint-model-viewer .personal-hub-blueprint-model__stat-list {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 0;
    flex: 1 1 auto;
    min-height: 0;
    margin: 0;
    overflow: hidden auto;
    align-content: start;
    border: 1px solid rgba(58, 120, 180, 0.22);
    border-radius: 6px;
    background: rgba(0, 48, 77, 0.28);
    scrollbar-width: thin;
    scrollbar-color: rgba(58, 120, 180, 0.45) rgba(21, 28, 36, 0.35); }
    .personal-hub-blueprint-model-viewer .personal-hub-blueprint-model__stat-list::-webkit-scrollbar {
      width: 8px; }
    .personal-hub-blueprint-model-viewer .personal-hub-blueprint-model__stat-list::-webkit-scrollbar-track {
      background: rgba(21, 28, 36, 0.35);
      border-radius: 999px; }
    .personal-hub-blueprint-model-viewer .personal-hub-blueprint-model__stat-list::-webkit-scrollbar-thumb {
      background: rgba(58, 120, 180, 0.45);
      border-radius: 999px; }
  .personal-hub-blueprint-model-viewer .personal-hub-blueprint-model__stat-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: baseline;
    gap: 0.2rem 0.3rem;
    min-width: 0;
    padding: 0.4rem 0.4rem;
    border-right: 1px solid rgba(58, 120, 180, 0.14);
    border-bottom: 1px solid rgba(58, 120, 180, 0.14); }
    .personal-hub-blueprint-model-viewer .personal-hub-blueprint-model__stat-row:nth-child(2n) {
      border-right: none; }
  .personal-hub-blueprint-model-viewer .personal-hub-blueprint-model__stat-label {
    margin: 0;
    font-size: 0.58rem;
    font-weight: 700;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.5);
    line-height: 1.15; }
  .personal-hub-blueprint-model-viewer .personal-hub-blueprint-model__stat-value {
    margin: 0;
    font-size: 0.72rem;
    font-weight: 600;
    color: #5ac3ff;
    line-height: 1.15;
    text-align: right;
    font-variant-numeric: tabular-nums;
    white-space: nowrap; }
    .personal-hub-blueprint-model-viewer .personal-hub-blueprint-model__stat-value--below-default {
      color: #747b81; }
    .personal-hub-blueprint-model-viewer .personal-hub-blueprint-model__stat-value--tier-orange {
      color: #d8b493; }
    .personal-hub-blueprint-model-viewer .personal-hub-blueprint-model__stat-value--tier-green {
      color: #c2f0c3; }
    .personal-hub-blueprint-model-viewer .personal-hub-blueprint-model__stat-value--tier-blue {
      color: #5ac3ff; }
    .personal-hub-blueprint-model-viewer .personal-hub-blueprint-model__stat-value--tier-purple {
      color: #9a80e3; }
  .personal-hub-blueprint-model-viewer .personal-hub-blueprint-model__stats-empty {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 0.35rem 0.4rem;
    font-size: 0.72rem;
    color: rgba(223, 223, 223, 0.55);
    line-height: 1.35;
    text-align: center; }

.personal-hub-blueprint-model {
  position: relative;
  border: 1px solid rgba(58, 120, 180, 0.35);
  border-radius: 10px;
  overflow: hidden;
  min-height: 280px; }
  .personal-hub-blueprint-model--bg-default {
    background: radial-gradient(circle at 50% 35%, rgba(58, 120, 180, 0.18), transparent 62%), rgba(23, 39, 56, 0.72); }
  .personal-hub-blueprint-model--bg-pale {
    background: radial-gradient(circle at 50% 35%, rgba(90, 195, 255, 0.14), transparent 65%), linear-gradient(180deg, rgba(90, 195, 255, 0.08), rgba(23, 39, 56, 0.42)); }
  .personal-hub-blueprint-model--bg-studio {
    background: #5a626c; }
  .personal-hub-blueprint-model__bg-pickers {
    position: absolute;
    top: 0.55rem;
    right: 0.55rem;
    z-index: 3;
    display: flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.25rem;
    border-radius: 999px;
    background: rgba(0, 48, 77, 0.55);
    border: 1px solid rgba(58, 120, 180, 0.35);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28); }
  .personal-hub-blueprint-model__bg-picker {
    width: 22px;
    height: 22px;
    margin: 0;
    padding: 0;
    border: 2px solid rgba(223, 223, 223, 0.45);
    border-radius: 50%;
    cursor: pointer;
    transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease; }
    .personal-hub-blueprint-model__bg-picker:hover {
      border-color: rgba(90, 195, 255, 0.75);
      transform: scale(1.06); }
    .personal-hub-blueprint-model__bg-picker:focus-visible {
      outline: 2px solid rgba(58, 120, 180, 0.75);
      outline-offset: 2px; }
    .personal-hub-blueprint-model__bg-picker--default {
      background: radial-gradient(circle at 50% 35%, rgba(58, 120, 180, 0.22), transparent 62%), rgba(23, 39, 56, 0.9); }
    .personal-hub-blueprint-model__bg-picker--pale {
      background: radial-gradient(circle at 50% 35%, rgba(90, 195, 255, 0.35), transparent 65%), rgba(90, 195, 255, 0.12); }
    .personal-hub-blueprint-model__bg-picker--active {
      border-color: #c78445;
      box-shadow: 0 0 0 1px rgba(199, 132, 69, 0.45); }
  .personal-hub-blueprint-model__proxy-debug {
    min-width: 58px;
    height: 22px;
    padding: 0 0.45rem;
    border: 1px solid rgba(223, 223, 223, 0.5);
    border-radius: 999px;
    background: rgba(23, 39, 56, 0.9);
    color: rgba(223, 223, 223, 0.8);
    font-size: 0.62rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    cursor: pointer; }
    .personal-hub-blueprint-model__proxy-debug:hover, .personal-hub-blueprint-model__proxy-debug.is-active {
      border-color: #c78445;
      color: #c78445;
      box-shadow: 0 0 0 1px rgba(199, 132, 69, 0.35); }
    .personal-hub-blueprint-model__proxy-debug:focus-visible {
      outline: 2px solid rgba(58, 120, 180, 0.75);
      outline-offset: 2px; }
  .personal-hub-blueprint-model__canvas {
    width: 100%;
    height: 320px;
    min-height: 280px; }
    .personal-hub-blueprint-model__canvas canvas {
      display: block;
      width: 100%;
      height: 100%; }
  .personal-hub-blueprint-model__status {
    position: absolute;
    left: 0.75rem;
    bottom: 0.65rem;
    margin: 0;
    padding: 0.25rem 0.55rem;
    border-radius: 999px;
    background: rgba(0, 48, 77, 0.78);
    border: 1px solid rgba(58, 120, 180, 0.35);
    color: rgba(223, 223, 223, 0.88);
    font-size: 0.78rem;
    pointer-events: none; }
    .personal-hub-blueprint-model__status--error {
      color: #d12323;
      border-color: rgba(209, 35, 35, 0.45); }

.personal-hub-blueprint-members-panel {
  flex: 0 0 0;
  width: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  color: #dfdfdf;
  border: 1px solid transparent;
  border-radius: 10px;
  background: rgba(12, 38, 55, 0.96);
  overflow: visible;
  opacity: 0;
  pointer-events: none;
  transition: flex-basis 0.28s cubic-bezier(0.4, 0, 0.2, 1), width 0.28s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s ease, border-color 0.2s ease; }
  .personal-hub-blueprint-members-panel--open {
    flex: 0 0 220px;
    width: 220px;
    opacity: 1;
    pointer-events: auto;
    border-color: rgba(58, 120, 180, 0.35);
    z-index: 3; }
  .personal-hub-blueprint-members-panel__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    flex-shrink: 0;
    padding: 0.65rem 0.75rem 0.45rem;
    border-bottom: 1px solid rgba(58, 120, 180, 0.25);
    user-select: none;
    border-radius: 10px 10px 0 0;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.72);
    position: relative;
    z-index: 4;
    overflow: visible; }
    .personal-hub-blueprint-members-panel__title .personal-hub-blueprints-help-row {
      flex: 1 1 auto;
      min-width: 0;
      align-items: center; }
    .personal-hub-blueprint-members-panel__title .help-info-bubble__popover {
      left: auto;
      right: 0;
      width: min(18rem, calc(100vw - 2.5rem)); }
    .personal-hub-blueprint-members-panel__title strong {
      font-size: 0.78rem;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      color: rgba(223, 223, 223, 0.9); }
  .personal-hub-blueprint-members-panel__count {
    font-size: 0.72rem;
    color: rgba(223, 223, 223, 0.55); }
  .personal-hub-blueprint-members-panel__state, .personal-hub-blueprint-members-panel__empty {
    margin: 0;
    padding: 0.65rem 0.75rem;
    color: rgba(223, 223, 223, 0.72);
    font-size: 0.82rem;
    line-height: 1.45; }
  .personal-hub-blueprint-members-panel__state--error {
    color: #d12323; }
  .personal-hub-blueprint-members-panel__list {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
    margin: 0;
    padding: 0.35rem 0.45rem 0.55rem;
    list-style: none;
    overflow: auto;
    max-height: calc(100vh - 520px);
    scrollbar-width: thin;
    scrollbar-color: rgba(58, 120, 180, 0.45) rgba(21, 28, 36, 0.35); }
    .personal-hub-blueprint-members-panel__list::-webkit-scrollbar {
      width: 8px; }
    .personal-hub-blueprint-members-panel__list::-webkit-scrollbar-track {
      background: rgba(21, 28, 36, 0.35);
      border-radius: 999px; }
    .personal-hub-blueprint-members-panel__list::-webkit-scrollbar-thumb {
      background: rgba(58, 120, 180, 0.45);
      border-radius: 999px; }
  .personal-hub-blueprint-members-panel__item {
    margin: 0;
    padding: 0; }
  .personal-hub-blueprint-members-panel__member-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 5px 8px;
    border: 1px solid transparent;
    border-radius: 6px;
    background: transparent;
    cursor: pointer;
    text-align: left;
    color: inherit; }
    .personal-hub-blueprint-members-panel__member-btn:hover {
      background: rgba(58, 120, 180, 0.12);
      border-color: rgba(58, 120, 180, 0.25); }
    .personal-hub-blueprint-members-panel__member-btn:focus-visible {
      outline: 2px solid rgba(58, 120, 180, 0.75);
      outline-offset: 1px; }
    .personal-hub-blueprint-members-panel__member-btn--blueprint-match {
      border-color: #c78445; }
      .personal-hub-blueprint-members-panel__member-btn--blueprint-match:hover {
        border-color: #c78445; }
    .personal-hub-blueprint-members-panel__member-btn--selected {
      background: rgba(199, 132, 69, 0.14);
      border-color: rgba(199, 132, 69, 0.55); }
  .personal-hub-blueprint-members-panel__member-avatar {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    object-fit: cover; }
    .personal-hub-blueprint-members-panel__member-avatar--placeholder {
      display: inline-block;
      background: #747b81;
      opacity: 0.35; }
  .personal-hub-blueprint-members-panel__member-name {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #afa991;
    font-size: 0.88rem; }
  .personal-hub-blueprint-members-panel__member-rank {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    object-fit: contain; }
  .personal-hub-blueprint-members-panel__member-count {
    flex-shrink: 0;
    font-size: 0.72rem;
    font-weight: 700;
    color: rgba(223, 223, 223, 0.72);
    font-variant-numeric: tabular-nums; }

.personal-hub-blueprints-help-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.45rem;
  min-width: 0; }
  .personal-hub-blueprints-help-row .personal-hub-blueprint-crafting__panel-title {
    flex: 1 1 auto;
    min-width: 0; }

@media (max-width: 980px) {
  .personal-hub-blueprints-card__layout {
    grid-template-columns: 1fr; }
  .personal-hub-blueprints-card__detail {
    height: auto;
    max-height: none; }
  .personal-hub-blueprint-list__scroll {
    max-height: 280px; }
  .personal-hub-blueprint-crafting {
    grid-template-columns: 1fr; }
  .personal-hub-blueprint-detail--has-model {
    min-height: 0; }
    .personal-hub-blueprint-detail--has-model .personal-hub-blueprint-detail__overview {
      flex: none; }
  .personal-hub-blueprint-detail__overview {
    flex-direction: column; }
  .personal-hub-blueprint-detail__model-aside {
    flex: 1 1 auto;
    width: 100%;
    max-width: 100%;
    margin-left: 0; }
    .personal-hub-blueprint-detail__model-aside .personal-hub-blueprint-model-viewer {
      min-height: 12rem;
      max-height: min(50vh, calc(100vh - 395px)); } }

/* src/styles/LoadingSpinner.css */
@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
  /* Prend toute la hauteur de la fenêtre */
  width: 100%;
  /* Prend toute la largeur de la fenêtre */
  top: 200px; }

.loader {
  position: relative;
  width: 100px;
  height: 100px; }

.loader:before, .loader:after {
  content: '';
  border-radius: 50%;
  position: absolute;
  inset: 0;
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.3) inset; }

.loader:after {
  box-shadow: 0 2px 0 #9e2222 inset;
  animation: rotate 2s linear infinite; }

@keyframes rotate {
  0% {
    transform: rotate(0); }
  100% {
    transform: rotate(360deg); } }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.input-icon-wrapper {
  position: relative; }

.readonly-input {
  padding-right: 24px;
  /* Make space for the icon */ }

.copy-icon {
  position: absolute;
  right: 5px;
  top: 50%;
  width: 15px;
  transform: translateY(-50%);
  cursor: pointer; }

.icon-disabled {
  opacity: 0.5;
  pointer-events: none; }

.handles .scrollable-content {
  height: 130px;
  overflow-y: auto;
  /* Pour les navigateurs WebKit (Safari, Chrome, etc.) */ }
  .handles .scrollable-content::-webkit-scrollbar {
    width: 6px; }
  .handles .scrollable-content::-webkit-scrollbar-track {
    background: #dfdfdf; }
  .handles .scrollable-content::-webkit-scrollbar-thumb {
    background: #b8b8b8;
    border-radius: 4px; }
  .handles .scrollable-content::-webkit-scrollbar-thumb:hover {
    background: #9e2222; }

.handles .handle-row {
  display: flex;
  background: #2a3847;
  font-size: 1rem;
  height: 25px;
  color: #dfdfdf;
  border-radius: 6px;
  margin-top: 10px; }
  .handles .handle-row.theader {
    background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    text-transform: uppercase;
    font-size: 15px;
    padding-bottom: 1px;
    color: #dfdfdf;
    box-shadow: inset -2px -2px 3px rgba(0, 0, 0, 0.5); }
  .handles .handle-row.handle-status {
    margin-left: 10px; }

.handles .handle-cell {
  display: flex;
  flex: 1 1 25%;
  padding: 5px 8px 4px 10px;
  text-align: left;
  align-items: center;
  position: relative; }
  .handles .handle-cell:not(:last-child)::after {
    content: "";
    position: absolute;
    right: 0;
    top: 10%;
    bottom: 10%;
    width: 1px;
    background-color: #2a3847; }
  .handles .handle-cell.handle-cell--small {
    flex: 0.22;
    margin: 0; }
  .handles .handle-cell.handle-cell--medium {
    flex: 0.5; }
  .handles .handle-cell.handle-cell--large {
    flex: 0.7; }

.handle {
  margin: 5px 0; }

.handle-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  gap: 25px;
  align-items: center;
  margin-left: auto; }

.status-icon {
  width: auto;
  max-height: 16px; }

.edit-icon {
  cursor: pointer;
  fill: #b8b8b8;
  width: auto;
  height: 14px;
  margin-left: 10px; }
  .edit-icon:hover {
    fill: #9e2222; }

.trash-icon {
  cursor: pointer;
  fill: #b8b8b8;
  width: auto;
  height: 16px;
  margin-left: 10px; }
  .trash-icon:hover {
    fill: #9e2222; }

.input-handle {
  margin-top: 10px;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: 10px; }
  .input-handle .readonly-input,
  .input-handle .handle-field {
    padding: 5px; }
  .input-handle .handle-lockfield {
    background: #93a8c1;
    padding: 5px; }

.handle-generate-token,
.btn-style-handle {
  display: flex;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-top: 10px;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: 10px; }

.accounts-container {
  display: flex; }

.handle-confirm-message {
  margin-top: 10px;
  padding: 8px 12px;
  border-radius: 4px;
  font-weight: 600;
  text-align: center;
  letter-spacing: 0.02em; }
  .handle-confirm-message.success {
    background: rgba(0, 200, 80, 0.15);
    border: 1px solid #75cf78;
    color: #75cf78; }
  .handle-confirm-message.error {
    background: rgba(220, 40, 40, 0.15);
    border: 1px solid #9e2222;
    color: #9e2222; }

.discord-account {
  display: flex;
  position: relative;
  align-items: center;
  height: max-content;
  width: max-content;
  min-width: 200px;
  padding: 0;
  padding-right: 20px;
  margin-top: 35px;
  margin-left: 30px;
  border-radius: 8px;
  cursor: pointer; }
  .discord-account .icon-container {
    width: 50px;
    height: 30px;
    overflow: hidden;
    position: relative;
    margin-bottom: 5px; }
    .discord-account .icon-container .icon-image {
      top: 4px;
      width: 25px;
      height: auto; }
      .discord-account .icon-container .icon-image.linked {
        object-fit: cover;
        border-radius: 50%;
        overflow: hidden;
        border: 1px solid #1c2d38; }
      .discord-account .icon-container .icon-image.unlinked {
        top: 6px;
        width: 27px;
        height: auto;
        overflow: hidden;
        border-radius: unset; }
  .discord-account .discord-label {
    display: flex;
    width: 100px;
    text-align: left; }
  .discord-account .refresh-icon {
    display: none;
    position: absolute;
    right: 12px;
    bottom: 7px;
    width: auto;
    height: 23px;
    vertical-align: middle;
    transition: transform 1s ease-in-out; }
  .discord-account:hover .refresh-icon {
    display: inline-block;
    animation: rotate-icon 2s infinite linear;
    cursor: pointer; }

@keyframes rotate-icon {
  0% {
    transform: rotate(0deg); }
  25% {
    transform: rotate(180deg); }
  50% {
    transform: rotate(180deg); }
  75% {
    transform: rotate(360deg); }
  100% {
    transform: rotate(360deg); } }

.discord-account:hover {
  color: white;
  background-color: #5865F2; }

.extension-token {
  background-color: #b8b8b8;
  vertical-align: top;
  padding: 5px 25px 5px 5px;
  width: 280px;
  height: 100px;
  word-wrap: break-word;
  resize: none; }

.textarea-container {
  display: flex;
  position: relative;
  margin-top: 20px;
  gap: 15px; }

.copy-key-icon {
  display: flex;
  position: relative;
  padding: 10px 0;
  align-self: start;
  right: 35px;
  width: 15px;
  cursor: pointer; }

.btn-download-extension {
  display: flex;
  align-items: center;
  width: 450px;
  gap: 12px;
  right: 15px;
  margin: auto;
  padding: 10px 14px;
  border: 2px solid #1c2d38;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.2s ease, background-color 0.2s ease; }
  .btn-download-extension:hover {
    border: 2px solid rgba(62, 125, 155, 0.329);
    box-shadow: 3px 2px inset rgba(67, 134, 165, 0.229); }
  .btn-download-extension-icon {
    width: auto;
    height: 80px;
    flex-shrink: 0; }
  .btn-download-extension-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 1.2;
    margin: 5px 5px auto 5px; }
  .btn-download-extension-title {
    font-size: 16px;
    font-weight: 600;
    color: #dfdfdf; }
  .btn-download-extension-subtitle {
    margin-top: 7px;
    font-size: 14px;
    color: #b8b8b8;
    opacity: 0.85; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.e-richtexteditor {
  width: initial !important;
  margin: 10px 15px; }

.e-richtexteditor .e-toolbar-wrapper {
  position: sticky !important;
  top: 90px !important;
  overflow: visible;
  max-height: 87px;
  z-index: 1001 !important; }
  .e-richtexteditor .e-toolbar-wrapper.shortBloc {
    max-height: 45px !important; }

.e-toolbar {
  background-image: linear-gradient(to bottom, #491212, #0c2637, #0c2637, #1c2d38, #2a3847, #1c2d38, #0c2637, #491212);
  border: 1px none rgba(0, 0, 0, 0.12);
  box-shadow: none;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px; }

.e-richtexteditor .e-toolbar-wrapper .e-rte-toolbar:not(.e-rte-tb-float) {
  border-bottom: 1px solid #2a3847; }

.e-control.withemojipicker, .e-richtexteditor.withemojipicker {
  bottom: 600px; }

.e-toolbar .e-toolbar-item .e-tbar-btn {
  background: transparent;
  box-shadow: none;
  color: #b8b8b8;
  border: none; }
  .e-toolbar .e-toolbar-item .e-tbar-btn:hover {
    color: #dfdfdf; }

.e-dropdown-popup {
  background: #2a3847;
  color: #b8b8b8;
  border-radius: 6px; }

.e-toolbar .e-toolbar-item .e-tbar-btn:active {
  color: #dfdfdf;
  border-color: #bdbdbd;
  color: #dfdfdf; }

.e-richtexteditor .e-rte-toolbar .e-toolbar-item .e-dropdown-btn.e-active {
  background: rgba(0, 0, 0, 0.12);
  color: #dfdfdf;
  border-color: inherit; }

.e-richtexteditor .e-rte-toolbar .e-toolbar-item .e-dropdown-btn.e-active .e-icons, .e-richtexteditor .e-rte-toolbar .e-toolbar-item .e-dropdown-btn.e-active .e-rte-dropdown-btn-text {
  color: #dfdfdf; }

.e-dropdown-popup ul .e-item.e-active {
  background: #2a3847;
  color: #dfdfdf; }

.e-richtexteditor .e-rte-toolbar .e-toolbar-item .e-icons {
  color: #b8b8b8 !important; }
  .e-richtexteditor .e-rte-toolbar .e-toolbar-item .e-icons:hover {
    color: #dfdfdf; }

.e-richtexteditor .e-rte-toolbar .e-toolbar-item.e-active .e-tbar-btn .e-icons, .e-richtexteditor .e-rte-toolbar .e-toolbar-item.e-active .e-tbar-btn:focus .e-icons {
  color: #dfdfdf; }

.e-toolbar .e-toolbar-item .e-tbar-btn:hover .e-icons {
  color: #dfdfdf; }

.e-toolbar .e-toolbar-item.e-separator {
  border: solid #2a3847;
  border-width: 0 2px 0 0; }

.e-richtexteditor .e-rte-toolbar .e-toolbar-item.e-overlay .e-tbar-btn .e-icons {
  color: #dfdfdf; }

.e-toolbar .e-toolbar-item.e-overlay {
  background: #0000002e;
  opacity: 0.5;
  color: rgba(0, 0, 0, 0.26); }

.e-toolbar .e-toolbar-items {
  background: transparent; }

.e-richtexteditor .e-rte-content, .e-richtexteditor .e-source-content {
  background: #1c2d38 !important;
  border-left: 1px solid #491212;
  border-right: 1px solid #491212;
  border-bottom: 1px solid #491212;
  color: #dfdfdf;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  z-index: 1000 !important; }

.e-richtexteditor .e-rte-content .e-content, .e-richtexteditor .e-source-content .e-content {
  font-size: 15px;
  line-height: 20px;
  color: #dfdfdf; }

.org-rank-rte .e-richtexteditor .e-rte-content .e-content, .org-rank-rte .e-richtexteditor .e-source-content .e-content,
.org-welcome-rte .e-richtexteditor .e-rte-content .e-content,
.org-welcome-rte .e-richtexteditor .e-source-content .e-content {
  height: 155px;
  color: #dfdfdf; }

.org-event-rte .e-richtexteditor .e-rte-content .e-content, .org-event-rte .e-richtexteditor .e-source-content .e-content,
.org-welcome-rte .e-richtexteditor .e-rte-content .e-content,
.org-welcome-rte .e-richtexteditor .e-source-content .e-content {
  height: 450px;
  color: #dfdfdf; }

.org-create-event-rte .e-richtexteditor .e-rte-content .e-content, .org-create-event-rte .e-richtexteditor .e-source-content .e-content {
  height: 350px;
  color: #dfdfdf; }

.e-rte-image.e-imginline, .e-rte-audio.e-audio-inline, .e-rte-video.e-video-inline {
  padding-left: 3px;
  padding-right: 3px; }

.e-rte-image.e-imgcenter, .e-rte-video.e-video-center {
  cursor: pointer;
  display: block;
  float: none;
  margin: 5px auto;
  max-width: 100%;
  position: relative; }
  @media (max-width: 1023px) {
    .e-rte-image.e-imgcenter, .e-rte-video.e-video-center {
      width: 95% !important; } }
  @media (max-width: 1023px) and (orientation: landscape) {
    .e-rte-image.e-imgcenter, .e-rte-video.e-video-center {
      width: 95% !important; } }

.e-rte-anchor {
  color: #d12323;
  text-decoration: none; }
  .e-rte-anchor :hover {
    text-decoration: underline; }

/* Styles pour le contenu de la modal */
.e-rte-image-custom-modal-content {
  display: flex;
  position: absolute;
  background: #0c2637;
  justify-content: center;
  align-items: center;
  padding: 20px;
  max-width: 100%;
  max-height: 100%;
  border: 3px solid #b8b8b8;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); }

/* Styles pour l'overlay */
.e-rte-image-custom-modal-overlay {
  background: rgba(9, 37, 56, 0.75);
  display: flex;
  justify-content: center;
  align-items: center; }

/* Conteneur pour le contenu de la modal */
.modal-content-wrapper {
  max-width: 95vh;
  max-height: 85vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  overflow: hidden; }

/* Styles pour l'image */
.modal-image {
  max-width: -webkit-fill-available;
  max-height: 100%;
  object-fit: contain;
  display: block; }

.public-rte-content-container {
  max-width: 930px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 0.5rem;
  margin-left: auto;
  margin-right: auto;
  border: none;
  border-radius: 6px; }

.rte-content-container {
  display: grid;
  width: 98%;
  max-width: 1000px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 0.5rem;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid #9c99a3;
  border-radius: 6px; }

.status-radio-buttons {
  display: flex;
  gap: 20px;
  margin-left: 20px;
  margin-top: 10px;
  margin-bottom: 5px;
  font-size: 0.9rem; }

.status-radio-buttons label {
  color: #b8b8b8;
  cursor: pointer; }

.status-radio-buttons label.selected {
  color: whitesmoke; }

.rte-menu-btn {
  position: relative;
  margin-left: 20px;
  z-index: 10; }

.e-rte-img-caption .e-img-wrap {
  display: inline-block;
  margin: auto;
  padding: 0;
  width: 100%; }

.e-rte-image.e-imgright, .e-rte-video.e-video-right {
  float: right;
  margin: 0 auto;
  margin-left: 5px;
  text-align: right; }

.e-rte-image.e-imginline, .e-rte-audio.e-audio-inline, .e-rte-video.e-video-inline {
  margin-left: 5px;
  margin-right: 5px;
  display: inline-block;
  max-width: 100%;
  padding: 1px;
  vertical-align: bottom; }

.e-rte-image.e-imgleft, .e-rte-video.e-video-left {
  float: left;
  margin: 0 auto;
  margin-right: 5px;
  text-align: left; }

.e-rte-image.e-imginline, .e-rte-audio.e-audio-inline, .e-rte-video.e-video-inline {
  margin-left: 5px;
  margin-right: 5px;
  display: inline-block;
  max-width: 100%;
  padding: 1px;
  vertical-align: bottom; }

.e-rte-image.e-imgbreak, .e-rte-audio.e-audio-break, .e-rte-video.e-video-break {
  border: 0;
  cursor: pointer;
  display: block;
  float: none;
  max-width: 100%;
  padding: 1px;
  position: relative; }

.public-container img {
  text-align: center; }

.e-rte-image, .e-rte-audio, .e-rte-video {
  border: 0;
  cursor: pointer;
  display: block;
  float: none;
  margin: auto;
  max-width: 100% !important;
  position: relative; }

.ReactModal__Overlay.ReactModal__Overlay--after-open {
  z-index: 15;
  background-color: rgba(78, 75, 75, 0.5) !important; }

.e-richtexteditor .e-toolbar-wrapper.e-rte-tb-float, .e-richtexteditor .e-toolbar-container.e-rte-tb-float {
  position: sticky !important;
  top: 90px !important;
  overflow: visible;
  max-height: 87px;
  z-index: 1001 !important; }
  .e-richtexteditor .e-toolbar-wrapper.e-rte-tb-float.shortBloc, .e-richtexteditor .e-toolbar-container.e-rte-tb-float.shortBloc {
    max-height: 45px !important; }

.e-richtexteditor .e-toolbar-wrapper.e-rte-tb-float .e-rte-toolbar {
  border-top: 1px solid rgba(0, 0, 0, 0.12); }

.e-richtexteditor .e-rte-toolbar .e-toolbar-multirow {
  margin-left: 7px;
  margin-right: 7px; }

.e-toolbar .e-toolbar-items.e-toolbar-multirow .e-toolbar-item:not(.e-separator) {
  margin: 0; }

.e-toolbar .e-toolbar-item:not(.e-separator):not(.e-spacer) {
  height: inherit;
  min-width: 34px;
  padding: 3.5px; }

.e-toolbar .e-toolbar-item {
  -ms-flex-line-pack: center;
  align-content: center;
  -ms-flex-align: center;
  align-items: center;
  cursor: pointer;
  display: -ms-inline-flexbox;
  display: inline-flex;
  min-height: 42px;
  vertical-align: middle;
  width: auto;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto; }

.e-richtexteditor .e-toolbar .e-toolbar-item .e-tbar-btn, .e-richtexteditor .e-toolbar.e-extended-toolbar .e-toolbar-extended.e-toolbar-pop .e-toolbar-item .e-tbar-btn {
  font-size: 14px; }

.e-toolbar .e-toolbar-item .e-tbar-btn {
  box-shadow: none;
  border: none; }

.e-toolbar .e-toolbar-item .e-tbar-btn {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  vertical-align: middle;
  -ms-flex-pack: center;
  justify-content: center;
  margin: 4px 0;
  min-height: 0;
  min-width: 0;
  padding: 0 1.5px;
  border-radius: 2px;
  line-height: 25px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  overflow: hidden;
  text-align: center;
  text-decoration: none;
  text-transform: none; }

.e-toolbar .e-toolbar-item > * {
  text-overflow: ellipsis; }

.e-btn.e-icon-btn, .e-css.e-btn.e-icon-btn {
  padding: 6px 7px 4px; }

.e-control, .e-control [class^=e-], .e-control [class*=" e-"] {
  box-sizing: border-box; }
  .e-control::-webkit-scrollbar, .e-control [class^=e-]::-webkit-scrollbar, .e-control [class*=" e-"]::-webkit-scrollbar {
    width: 6px; }
  .e-control::-webkit-scrollbar-track, .e-control [class^=e-]::-webkit-scrollbar-track, .e-control [class*=" e-"]::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .e-control::-webkit-scrollbar-thumb, .e-control [class^=e-]::-webkit-scrollbar-thumb, .e-control [class*=" e-"]::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .e-control::-webkit-scrollbar-thumb:hover, .e-control [class^=e-]::-webkit-scrollbar-thumb:hover, .e-control [class*=" e-"]::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }

.e-btn, .e-css.e-btn {
  -webkit-tap-highlight-color: transparent;
  background: #fafafa;
  border-color: transparent;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  color: rgba(0, 0, 0, 0.87);
  transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1); }

.e-btn, .e-css.e-btn {
  -webkit-font-smoothing: antialiased;
  border: 1px solid;
  border-radius: 2px;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block;
  font-family: "Lato", "Verdana", "sans-serif", "-apple-system", "BlinkMacSystemFont";
  font-size: 14px;
  font-weight: 500;
  -ms-flex-pack: center;
  justify-content: center;
  line-height: 1.143em;
  outline: none;
  padding: 6px 12px 4px;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  vertical-align: middle;
  white-space: nowrap; }

.e-control, .e-css {
  font-family: "Lato", "Verdana", "sans-serif", "-apple-system", "BlinkMacSystemFont";
  font-size: 12px;
  font-weight: normal; }

.e-richtexteditor.e-disabled {
  pointer-events: none; }

.e-disabled {
  background-image: none;
  cursor: default;
  filter: alpha(Opacity=35);
  opacity: 0.35; }

.e-richtexteditor .e-rte-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn .e-order-list.e-icons, .e-richtexteditor .e-rte-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn .e-unorder-list.e-icons, .e-richtexteditor .e-rte-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn .e-icons.e-btn-icon:not(.e-caret), .e-richtexteditor .e-rte-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn .e-order-list.e-icons, .e-richtexteditor .e-rte-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn .e-unorder-list.e-icons, .e-richtexteditor .e-rte-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn .e-icons.e-btn-icon:not(.e-caret), .e-richtexteditor .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn .e-order-list.e-icons, .e-richtexteditor .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn .e-unorder-list.e-icons, .e-richtexteditor .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn .e-icons.e-btn-icon:not(.e-caret), .e-richtexteditor .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn .e-order-list.e-icons, .e-richtexteditor .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn .e-unorder-list.e-icons, .e-richtexteditor .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn .e-icons.e-btn-icon:not(.e-caret) {
  font-size: 14px; }

.e-toolbar .e-toolbar-item .e-tbar-btn .e-icons.e-btn-icon {
  margin: 0;
  min-width: 24px;
  width: auto;
  font-size: 14px;
  line-height: 25px; }

.e-icons {
  font-family: "e-icons";
  /* font-style: normal; */
  font-variant: normal;
  font-weight: normal;
  line-height: 1;
  text-transform: none; }

.e-dropdown-btn .e-caret, .e-dropdown-btn.e-btn .e-caret {
  font-size: 8px; }

.e-dropdown-btn .e-btn-icon, .e-dropdown-btn.e-btn .e-btn-icon {
  font-size: 14px; }

.e-dropdown-btn, .e-dropdown-btn.e-btn {
  box-shadow: none;
  text-transform: none;
  white-space: normal; }

.e-dropdown-btn .e-caret::before, .e-dropdown-btn.e-btn .e-caret::before {
  content: "\\e969"; }

.e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-items .e-toolbar-item .e-rte-fontcolor-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-items .e-toolbar-item .e-rte-backgroundcolor-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-items .e-toolbar-item .e-rte-numberformatlist-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-items .e-toolbar-item .e-rte-bulletformatlist-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar .e-toolbar-items .e-toolbar-item .e-rte-fontcolor-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar .e-toolbar-items .e-toolbar-item .e-rte-backgroundcolor-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar .e-toolbar-items .e-toolbar-item .e-rte-numberformatlist-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar .e-toolbar-items .e-toolbar-item .e-rte-bulletformatlist-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-rte-fontcolor-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-rte-backgroundcolor-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-rte-numberformatlist-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-rte-bulletformatlist-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar .e-toolbar-extended .e-toolbar-item .e-rte-fontcolor-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar .e-toolbar-extended .e-toolbar-item .e-rte-backgroundcolor-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar .e-toolbar-extended .e-toolbar-item .e-rte-numberformatlist-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar .e-toolbar-extended .e-toolbar-item .e-rte-bulletformatlist-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-pack: center;
  justify-content: center;
  line-height: 25px;
  min-width: 18px;
  text-align: center;
  width: 18px; }

.e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-items .e-toolbar-item .e-dropdown-btn.e-tbar-btn .e-icons.e-btn-icon.e-caret, .e-rte-toolbar.e-toolbar .e-toolbar-items .e-toolbar-item .e-dropdown-btn.e-tbar-btn .e-icons.e-btn-icon.e-caret, .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-dropdown-btn.e-tbar-btn .e-icons.e-btn-icon.e-caret, .e-rte-toolbar.e-toolbar .e-toolbar-extended .e-toolbar-item .e-dropdown-btn.e-tbar-btn .e-icons.e-btn-icon.e-caret {
  font-size: 12px; }

.e-dropdown-popup {
  background: #2a3847;
  color: #b8b8b8; }

.e-dropdown-popup ul .e-item {
  cursor: pointer;
  display: -ms-flexbox;
  display: flex;
  height: 36px;
  line-height: 36px;
  padding: 0 16px; }

.e-dropdown-popup ul {
  border: none;
  border-radius: 0;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  font-size: 14px;
  font-weight: normal;
  list-style-image: none;
  list-style-position: outside;
  list-style-type: none;
  margin: 0;
  min-width: 120px;
  overflow: hidden;
  padding: 8px 0;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: nowrap; }

.e-dropdown-popup ul .e-item:hover {
  background: #e0e0e0;
  color: rgba(0, 0, 0, 0.87); }

.e-toolbar .e-toolbar-items.e-toolbar-multirow {
  margin-bottom: 1px;
  margin-left: 18px;
  margin-right: 18px;
  white-space: normal;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap; }

.e-toolbar .e-toolbar-items {
  border-radius: 0 0 0 0;
  display: -ms-inline-flexbox;
  display: inline-flex;
  height: 100%;
  vertical-align: middle;
  -ms-flex-align: center;
  align-items: center; }

.e-toolbar {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  border: 1px none rgba(0, 0, 0, 0.12);
  box-shadow: none; }

.e-toolbar {
  border-radius: 0;
  display: block;
  height: 42px;
  min-height: 42px;
  position: relative;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: nowrap;
  overflow: hidden; }

.e-richtexteditor {
  color: #333;
  display: block;
  position: relative; }

.e-toolbar .e-toolbar-item.e-separator {
  margin: 7.5px 3px;
  min-height: 27px;
  min-width: 1px;
  height: calc(100% - 15px); }

.e-toolbar {
  border-radius: 0;
  display: block;
  height: 42px;
  min-height: 42px;
  position: relative;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: nowrap;
  overflow: hidden; }

.e-richtexteditor .e-rte-hidden {
  display: none; }

.e-richtexteditor {
  color: #333;
  display: block;
  position: relative; }

.rte-emoji {
  width: 19px;
  height: 19px;
  padding: 0;
  margin: 0;
  bottom: 3px; }

.emojis-category svg {
  fill: #b8b8b8;
  width: 19px;
  height: 19px;
  top: 1px;
  bottom: 1px; }
  .emojis-category svg:hover {
    fill: white; }

.emoji-picker-searchbox {
  margin: 5px;
  padding: 2px 5px 2px 5px; }

.e-rte-quick-popup .e-rte-quick-toolbar {
  background: #0c2637 !important;
  border: 3px solid #491212 !important;
  min-height: 42px  !important;
  border-radius: 6px  !important; }

.e-rte-quick-popup .e-rte-quick-toolbar .e-toolbar-items {
  background: #0c2637 !important; }

.e-rte-quick-popup .e-rte-quick-toolbar .e-toolbar-items .e-tbar-btn {
  background: #0c2637 !important; }

.e-rte-quick-popup .e-rte-quick-toolbar .e-toolbar-items .e-icons {
  color: #dfdfdf !important; }

.modal.publish-check {
  position: fixed;
  z-index: 1050;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.75);
  /* Modal toggle — sizes loosely aligned with \`\$toggle-*\` in variables.scss (wider for RTE modal). */ }
  .modal.publish-check .modal-content.publish-check {
    display: block;
    position: relative;
    background-color: #0c2637;
    height: 190px;
    margin: 20% auto;
    padding: 20px;
    border-radius: 5px;
    width: 80%;
    max-width: 600px;
    border: 1px solid #2a3847; }
    .modal.publish-check .modal-content.publish-check p.publish-check {
      margin-top: 30px;
      color: #dfdfdf;
      font-family: 'Arial', sans-serif;
      font-size: 18px;
      text-align: center; }
    .modal.publish-check .modal-content.publish-check label {
      display: block;
      margin-top: 10px;
      color: #dfdfdf;
      text-align: center; }
      .modal.publish-check .modal-content.publish-check label input[type="checkbox"] {
        margin-right: 10px; }
    .modal.publish-check .modal-content.publish-check .modal.btns-publish-check {
      display: flex;
      position: relative;
      flex-direction: row;
      justify-content: center;
      height: fit-content;
      width: 100%;
      margin-top: 20px;
      background-color: transparent; }
      .modal.publish-check .modal-content.publish-check .modal.btns-publish-check button.btn-style1 {
        margin: 0 10px;
        padding: 10px 20px;
        height: fit-content;
        border: none;
        border-radius: 5px;
        cursor: pointer; }
  .modal.publish-check .switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 25px;
    margin-left: 10px; }
    .modal.publish-check .switch input {
      opacity: 0;
      width: 0;
      height: 0; }
    .modal.publish-check .switch .slider {
      position: absolute;
      cursor: pointer;
      top: 5px;
      left: 0;
      right: 5px;
      bottom: -5px;
      background-color: #ccc;
      transition: .4s;
      border-radius: 34px; }
      .modal.publish-check .switch .slider:before {
        position: absolute;
        content: "";
        height: 20px;
        width: 20px;
        left: 4px;
        bottom: 3px;
        background-color: white;
        transition: .4s;
        border-radius: 50%; }
    .modal.publish-check .switch input:checked + .slider {
      background-color: #9e2222; }
    .modal.publish-check .switch input:focus + .slider {
      box-shadow: 0 0 1px #2196F3; }
    .modal.publish-check .switch input:checked + .slider:before {
      transform: translateX(26px); }

@media (max-width: 1023px) {
  .rte-emoji.e-rte-image.e-imginline {
    width: 17px !important;
    height: 17px !important;
    padding: 0 !important;
    margin: 0 !important; }
  .e-rte-image.e-imgright.e-imginline, .e-rte-image.e-imgleft.e-imginline {
    max-width: 100%;
    /* Limite la largeur maximum sans forcer la largeur à 100% */
    height: auto; }
  /* Adapter les autres images, audios, et vidéos à la largeur du conteneur */
  .e-rte-image.e-imginline, .e-rte-audio.e-audio-inline, .e-rte-video.e-video-inline {
    width: 100% !important;
    /* Force la largeur à 100% du conteneur */
    height: auto !important;
    /* Ajuste la hauteur automatiquement pour maintenir le ratio */
    bottom: 3px; }
  .e-rte-image.e-imgleft, .e-rte-video.e-video-left {
    float: left;
    margin: 0 auto;
    margin-right: 5px;
    text-align: left;
    width: 100% !important;
    /* Force la largeur à 100% du conteneur */
    height: auto !important;
    /* Ajuste la hauteur automatiquement pour maintenir le ratio */ } }

ul {
  list-style-type: disc;
  /* style pour les listes non ordonnées */
  margin: 0;
  color: #b1b1b1; }

ol {
  list-style-type: decimal;
  /* style pour les listes ordonnées */
  margin: 0;
  color: #b1b1b1; }

p {
  margin-bottom: 0;
  color: #b1b1b1; }

.e-richtexteditor .e-rte-content .e-content blockquote, .e-richtexteditor .e-source-content .e-content blockquote {
  margin: 10px 0;
  color: #b1b1b1;
  padding: 15px;
  position: relative; }
  .e-richtexteditor .e-rte-content .e-content blockquote::before, .e-richtexteditor .e-rte-content .e-content blockquote::after, .e-richtexteditor .e-source-content .e-content blockquote::before, .e-richtexteditor .e-source-content .e-content blockquote::after {
    content: "";
    position: absolute;
    border: 3px solid #2a3847;
    border-radius: 6px 0; }
  .e-richtexteditor .e-rte-content .e-content blockquote::before, .e-richtexteditor .e-source-content .e-content blockquote::before {
    top: -3px;
    left: -3px;
    width: 50%;
    height: 50%;
    border-right: none;
    border-bottom: none; }
  .e-richtexteditor .e-rte-content .e-content blockquote::after, .e-richtexteditor .e-source-content .e-content blockquote::after {
    bottom: -3px;
    right: -3px;
    width: 50%;
    height: 50%;
    border-left: none;
    border-top: none; }

.e-richtexteditor .e-rte-content .e-content pre,
.e-richtexteditor .e-source-content .e-content pre {
  background-color: #0c2637 !important;
  border-left: 5px solid #491212 !important;
  border: none;
  border-radius: 6px;
  color: #b1b1b1 !important;
  font-size: inherit;
  line-height: inherit;
  margin: 0 0 10px;
  overflow: visible;
  padding: 15px !important;
  white-space: pre-wrap;
  word-break: inherit;
  word-wrap: break-word;
  position: relative;
  font-family: 'Input', monospace !important; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
/*  -------------------------------------------------------------  */
/* HEADER BAR */
.header-root {
  position: relative;
  z-index: 5;
  width: 100%; }
  .header-root--user-tooltip-open {
    z-index: 70; }

.header-bar {
  position: fixed;
  display: flex;
  justify-content: center;
  width: 100%;
  background: linear-gradient(rgba(1, 39, 77, 0.876), rgba(1, 6, 8, 0.8)), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  background-size: cover;
  border-bottom: 4px solid rgba(0, 0, 0, 0);
  border-image-source: var(--nav-background-image);
  border-image-slice: 1;
  border-image-repeat: repeat;
  transition: top 0.4s;
  z-index: 4; }
  .header-bar .header-container {
    display: flex;
    align-items: center;
    width: 100%;
    z-index: 4;
    width: 1500px; }
    .header-bar .header-container .header {
      width: 350px;
      display: flex;
      align-items: center;
      transform: translate(-50px, 27px);
      z-index: 5; }
      .header-bar .header-container .header .logo {
        width: auto;
        z-index: 5;
        transform: translate(90px, 3px); }
        .header-bar .header-container .header .logo img {
          width: 45px;
          height: auto; }
      .header-bar .header-container .header .brand {
        margin-left: 10px;
        background: linear-gradient(to right, #d10505, #96989b, #96989b, #d10505);
        font-size: 1.5rem;
        font-family: 'GoodTimes', sans-serif;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-size: 200% 200%;
        animation: text-gradient-animation 7s infinite linear;
        z-index: 5;
        transform: translate(90px, 0px); }
      .header-bar .header-container .header .brand span:first-child {
        margin-right: 7px;
        /* Ajustez l'espacement entre 'PALLAS' et 'INVICTUS' */ }
    .header-bar .header-container .menu {
      position: relative;
      flex-grow: 1;
      display: flex;
      justify-content: flex-start;
      padding-left: 85px;
      top: 6px; }
    .header-bar .header-container .underheader-container {
      position: absolute;
      left: 5px;
      width: 400px;
      height: 60px;
      background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
      /* image */
      background-repeat: no-repeat;
      background-size: cover;
      clip-path: polygon(5% 0%, 95% 0%, 100% 50%, 100% 50%, 95% 100%, 5% 100%, 0% 50%, 0% 50%);
      /* Forme du polygone */
      box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.5);
      /* Ombre pour le style */
      z-index: 1;
      transform: translate(50px, 0px);
      /* Positionnement précis */ }
    .header-bar .header-container .underheader-polygon {
      position: relative;
      bottom: -4px;
      /* Ajustez ces valeurs selon vos besoins */
      left: 5px;
      width: 390px;
      height: 52px;
      background: linear-gradient(rgba(9, 40, 84, 0.8), rgba(1, 6, 8, 0.8)), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
      clip-path: polygon(4.6% 0%, 95.4% 0%, 100% 50%, 100% 50%, 95.4% 100%, 4.6% 100%, 0% 50%, 0% 50%);
      z-index: 1; }

@keyframes text-gradient-animation {
  0% {
    background-position: 200% 0%; }
  100% {
    background-position: 0% 200%; } }

/*  -------------------------------------------------------------  */
/* NAVBAR */
.nav-link {
  font-family: 'GoodTimes', sans-serif;
  font-size: 0.9rem;
  color: #b8b8b8;
  margin-right: 40px;
  white-space: nowrap;
  text-transform: uppercase;
  text-decoration: none;
  transform: translate(0px, 0px); }
  .nav-link:last-child {
    margin-right: 0px; }
  .nav-link:hover, .nav-link:active {
    color: #dfdfdf;
    text-decoration: none; }

.nav-link-active {
  color: #dfdfdf; }

.menu .icons {
  display: flex;
  height: 20px;
  overflow: hidden;
  margin-left: auto;
  margin-right: 0; }

/* Specific styles for RSI icon */
.menu .icons .header-rsi-icon {
  height: 41px;
  object-fit: contain;
  margin-right: 20px;
  position: relative;
  top: 0px;
  opacity: 0.4; }

.menu .icons .header-rsi-icon:hover {
  top: -21px;
  opacity: 1; }

/* Specific styles for Discord icon */
.menu .icons .header-discord-icon {
  height: 40px;
  object-fit: contain;
  margin-right: 20px;
  position: relative;
  top: 0px;
  opacity: 0.4; }

.menu .icons .header-discord-icon:hover {
  top: -21px;
  opacity: 1; }

/*  -------------------------------------------------------------  */
/* LOGIN */
.login-btn {
  display: block;
  position: relative;
  font-size: 1rem;
  text-transform: none;
  text-decoration: none;
  margin-left: auto;
  margin-right: 30px;
  align-items: center;
  white-space: nowrap; }
  .login-btn.logged-out {
    font-family: 'GoodTimes', sans-serif; }
  .login-btn .link-login {
    color: #9e2222;
    text-decoration: none; }
    .login-btn .link-login:hover, .login-btn .link-login:active {
      color: #d12323;
      text-decoration: none; }
  .login-btn .new-version-update {
    position: absolute;
    right: -30px;
    background: transparent;
    border: none;
    cursor: pointer; }
    .login-btn .new-version-update .reload-icon {
      height: 15px; }
    .login-btn .new-version-update::after {
      content: attr(data-tooltip);
      position: absolute;
      top: 20px;
      right: 0;
      margin-bottom: 8px;
      padding: 4px 8px;
      white-space: nowrap;
      font-size: 0.875rem;
      color: #19c619;
      background: #163447;
      border-radius: 4px;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.2s ease-in-out; }
    .login-btn .new-version-update:hover::after {
      opacity: 1; }

.user-avatar-mobile {
  display: none;
  width: 20px;
  height: 20px;
  border-radius: 50%; }

.login-btn__user-chip-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  bottom: 5px; }
  .login-btn__user-chip-wrap--view-as {
    gap: 0.65rem; }

.login-btn__view-as-label {
  font-style: italic;
  color: #5ac3ff;
  font-size: 1rem;
  line-height: 1;
  white-space: nowrap; }

.user-chip {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 3px 8px;
  border: 1px solid rgba(158, 34, 34, 0.05);
  border-radius: 12px;
  background: rgba(22, 52, 71, 0.05);
  /* Rank tint on outer header chip only (not nested profile-chip); colors via rankChipCspStyles.js */ }
  .user-chip.user-chip--rank-tinted[data-chip-bg] {
    position: relative;
    isolation: isolate;
    background: transparent; }
    .user-chip.user-chip--rank-tinted[data-chip-bg]::after {
      content: "";
      position: absolute;
      inset: 0;
      border-radius: inherit;
      z-index: 0;
      pointer-events: none;
      opacity: 0.1; }
    .user-chip.user-chip--rank-tinted[data-chip-bg] > * {
      position: relative;
      z-index: 1; }

.alt-account-warning {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0; }
  .alt-account-warning__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.15rem;
    height: 1.15rem;
    padding: 0;
    border: 0;
    background: transparent;
    color: #d8b493;
    font-size: 1rem;
    line-height: 1;
    cursor: pointer;
    filter: drop-shadow(0 0 6px rgba(216, 180, 147, 0.45));
    outline: none; }
    .alt-account-warning__icon:focus-visible {
      box-shadow: 0 0 0 2px rgba(216, 180, 147, 0.55);
      border-radius: 2px; }
  .alt-account-warning--header {
    margin-right: 6px; }

.alt-account-secondary-notice {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 360px;
  margin-left: 4px;
  padding: 4px 12px 4px 10px;
  border-radius: 6px;
  border: 1px solid rgba(216, 180, 147, 0.75);
  background: linear-gradient(135deg, rgba(66, 38, 12, 0.92) 0%, rgba(23, 39, 56, 0.95) 100%);
  box-shadow: 0 0 0 1px rgba(216, 180, 147, 0.15) inset, 0 0 14px rgba(216, 180, 147, 0.22); }
  .alt-account-secondary-notice__icon {
    flex-shrink: 0;
    color: #d8b493;
    font-size: 0.95rem;
    line-height: 1;
    filter: drop-shadow(0 0 5px rgba(216, 180, 147, 0.4)); }
  .alt-account-secondary-notice__text {
    font-family: 'Lato', sans-serif;
    font-size: 0.72rem;
    line-height: 1.25;
    font-weight: 600;
    letter-spacing: 0.02em;
    color: #dfdfdf;
    text-transform: none;
    white-space: normal; }

.alt-account-warning__tooltip {
  position: fixed;
  transform: translateX(-100%);
  z-index: 100000;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 220px;
  max-width: 280px;
  padding: 10px 12px 10px 10px;
  border-radius: 8px;
  background: linear-gradient(135deg, rgba(12, 38, 55, 0.98) 0%, rgba(23, 39, 56, 0.98) 100%);
  border: 1px solid rgba(216, 180, 147, 0.55);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.55), 0 0 0 1px rgba(216, 180, 147, 0.12) inset, 0 0 18px rgba(216, 180, 147, 0.18);
  pointer-events: none;
  white-space: normal; }
  .alt-account-warning__tooltip::after {
    content: "";
    position: absolute;
    right: -6px;
    top: 11px;
    width: 12px;
    height: 12px;
    transform: rotate(45deg);
    background: rgba(23, 39, 56, 0.98);
    border-right: 1px solid rgba(216, 180, 147, 0.45);
    border-top: 1px solid rgba(216, 180, 147, 0.45); }
  .alt-account-warning__tooltip-accent {
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    border-radius: 8px 0 0 8px;
    background: linear-gradient(180deg, rgba(216, 180, 147, 0.95) 0%, rgba(199, 132, 69, 0.75) 100%); }
  .alt-account-warning__tooltip-icon {
    position: relative;
    z-index: 1;
    flex-shrink: 0;
    color: #d8b493;
    font-size: 1rem;
    line-height: 1.2;
    margin-top: 1px;
    margin-left: 6px;
    filter: drop-shadow(0 0 6px rgba(216, 180, 147, 0.35)); }
  .alt-account-warning__tooltip-text {
    position: relative;
    z-index: 1;
    margin: 0;
    padding-right: 4px;
    font-family: 'Lato', sans-serif;
    font-size: 0.82rem;
    line-height: 1.35;
    color: #dfdfdf;
    letter-spacing: 0.01em; }

.user-chip__chevron {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  line-height: 1;
  font-size: 1.4rem;
  bottom: 6px;
  color: inherit;
  transition: none; }
  .user-chip__chevron.is-open {
    transform: rotate(180deg);
    bottom: -6px; }

/*  -------------------------------------------------------------  */
/* TOOLTIP */
.email {
  cursor: pointer;
  font-weight: bold;
  color: #9e2222; }
  .email:hover {
    color: #d12323; }
  .email.user-chip--rank-tinted {
    color: #dfdfdf; }
    .email.user-chip--rank-tinted:hover {
      color: #dfdfdf; }
    .email.user-chip--rank-tinted .header-user-identity .user-discord-rank__name {
      color: #dfdfdf; }
    .email.user-chip--rank-tinted .user-chip__chevron {
      color: #dfdfdf; }
  .email .header-user-identity {
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
    min-width: 0;
    max-width: min(42vw, 280px);
    gap: 10px;
    /* Plain identity row inside header chip — no nested profile-chip button */ }
    .email .header-user-identity.user-discord-rank--profile-chip {
      padding: 0;
      margin: 0;
      border: none;
      border-radius: 0;
      background: transparent;
      cursor: inherit; }
      .email .header-user-identity.user-discord-rank--profile-chip::after {
        display: none; }
    .email .header-user-identity .user-discord-rank__name {
      color: inherit;
      font-weight: bold;
      font-size: 0.9rem; }
    .email .header-user-identity .user-discord-rank__rank-icon {
      flex-shrink: 0; }

.user-avatar {
  display: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 10px; }

.email-text {
  display: inline;
  text-transform: initial; }

.user-tooltip {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 100%;
  right: 0;
  transform: translateY(5px);
  background-color: #032c45;
  box-shadow: 3px 3px 10px rgba(21, 28, 36, 0.65);
  width: 220px;
  gap: 0;
  padding: 6px 0;
  z-index: 100;
  border: 1px solid rgba(158, 34, 34, 0.12);
  border-radius: 8px; }
  .user-tooltip::before, .user-tooltip::after {
    content: "";
    position: absolute;
    top: 0;
    right: 28px;
    width: 0;
    height: 0;
    border-style: solid;
    pointer-events: none; }
  .user-tooltip::before {
    transform: translateY(-100%);
    border-width: 0 7px 7px 7px;
    border-color: transparent transparent rgba(158, 34, 34, 0.12) transparent; }
  .user-tooltip::after {
    transform: translateY(calc(-100% + 1px));
    border-width: 0 6px 6px 6px;
    border-color: transparent transparent #1e3042 transparent; }

.tooltip-link {
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: 'GoodTimes', sans-serif;
  font-size: 0.75rem;
  color: #747b81;
  text-transform: none;
  text-decoration: none;
  padding: 11px 14px;
  margin-bottom: 2px;
  border-left: 2px solid transparent;
  transition: color 0.15s ease, background 0.15s ease, border-color 0.15s ease; }
  .tooltip-link:not(:first-child) {
    border-top: 1px solid rgba(223, 223, 223, 0.08); }
  .tooltip-link__icon {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    color: inherit; }
    .tooltip-link__icon--hangar {
      display: inline-block;
      background-color: currentColor;
      mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
      mask-size: contain;
      mask-repeat: no-repeat;
      mask-position: center;
      -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
      -webkit-mask-size: contain;
      -webkit-mask-repeat: no-repeat;
      -webkit-mask-position: center; }
  .tooltip-link__label {
    min-width: 0;
    line-height: 1.2; }
  .tooltip-link:hover {
    color: #ffffff;
    border-left-color: #5ac3ff;
    background: linear-gradient(90deg, rgba(90, 195, 255, 0.2) 0%, rgba(90, 195, 255, 0.08) 42%, transparent 78%);
    box-shadow: inset 0 0 0 1px rgba(90, 195, 255, 0.12); }
  .tooltip-link.admin {
    color: #c78445; }
    .tooltip-link.admin .tooltip-link__icon {
      color: #d8b493;
      filter: drop-shadow(0 0 3px rgba(199, 132, 69, 0.35)); }
    .tooltip-link.admin:hover {
      color: #d8b493;
      border-left-color: rgba(216, 180, 147, 0.85);
      background: linear-gradient(90deg, rgba(199, 132, 69, 0.22) 0%, rgba(199, 132, 69, 0.08) 45%, transparent 78%);
      box-shadow: inset 0 0 0 1px rgba(199, 132, 69, 0.14); }
  .tooltip-link.view-as-reset {
    cursor: pointer;
    border-top: 0;
    border-right: 0;
    border-bottom: 0;
    border-left: 2px solid transparent;
    background-color: #c78445;
    color: #d12323;
    text-align: left;
    width: 100%; }
    .tooltip-link.view-as-reset:not(:first-child) {
      border-top: none; }
    .tooltip-link.view-as-reset:hover {
      color: #d12323;
      border-left-color: #5ac3ff;
      background: linear-gradient(90deg, rgba(90, 195, 255, 0.2) 0%, rgba(199, 132, 69, 0.95) 38%, rgba(199, 132, 69, 0.85) 100%); }
  .tooltip-link.logout {
    cursor: pointer; }
    .tooltip-link.logout:hover {
      color: #ffffff;
      border-left-color: #d12323;
      background: linear-gradient(90deg, rgba(209, 35, 35, 0.24) 0%, rgba(209, 35, 35, 0.09) 42%, transparent 78%);
      box-shadow: inset 0 0 0 1px rgba(209, 35, 35, 0.14); }
  .tooltip-link--loading {
    padding: 11px 14px;
    color: #747b81; }

/*  -------------------------------------------------------------  */
/* SECONDARY NAVBAR */
.secondary-nav-container {
  display: contents; }

.secondary-nav-bar {
  position: absolute;
  transform: translate(0px, 54px);
  width: 100%;
  z-index: 3; }

.secondary-menu {
  background: linear-gradient(to right, #522323d3, #4b0505, #4b0505, #4b0505, #522323d3), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  border-bottom: 2px solid #5b1212;
  height: 37px; }

.secondary-menu-content {
  display: flex;
  position: relative;
  align-items: center;
  margin: auto;
  top: 4px;
  width: 1500px; }

.secondary-menu-inner {
  flex-grow: 1;
  display: flex;
  align-items: center;
  padding-left: 415px;
  gap: 14px; }

.secondary-nav-utilities {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-left: 0;
  margin-right: 20px;
  flex: 1 1 auto;
  justify-content: flex-end;
  min-width: 0; }

.secondary-nav-funding {
  position: relative;
  display: flex;
  align-items: center;
  flex-shrink: 0; }

.secondary-nav-funding__trigger {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  padding: 0 0.65rem;
  height: 24px;
  border: 1px solid rgba(116, 123, 129, 0.35);
  border-radius: 999px;
  background: rgba(12, 38, 55, 0.5);
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease; }
  .secondary-nav-funding__trigger:hover {
    border-color: rgba(90, 195, 255, 0.45);
    background: rgba(12, 38, 55, 0.68); }

.secondary-nav-funding__label {
  font-family: 'GoodTimes', sans-serif;
  font-size: 0.62rem;
  font-weight: 400;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.86);
  white-space: nowrap; }

.secondary-nav-funding__bar-track {
  display: block;
  width: 4.5rem;
  height: 0.38rem;
  border: 1px solid rgba(116, 123, 129, 0.28);
  border-radius: 999px;
  overflow: hidden;
  background: rgba(12, 38, 55, 0.65);
  pointer-events: none; }

.secondary-nav-funding__bar-track--complete {
  border-color: rgba(117, 207, 120, 0.45); }

.secondary-nav-funding__bar-fill {
  display: block;
  height: 100%;
  width: var(--funding-pct, 0%);
  border-radius: inherit;
  background: linear-gradient(90deg, rgba(58, 120, 180, 0.95), rgba(90, 195, 255, 0.95));
  transition: width 0.65s cubic-bezier(0.22, 1, 0.36, 1);
  will-change: width; }

.secondary-nav-funding__bar-fill--complete {
  background: linear-gradient(90deg, rgba(63, 124, 66, 0.9), rgba(117, 207, 120, 0.95)); }

.secondary-nav-funding__bar-fill--pulse {
  animation: secondary-nav-funding-bar-pulse 0.85s ease-out; }

@keyframes secondary-nav-funding-bar-pulse {
  0% {
    filter: brightness(1);
    box-shadow: none; }
  40% {
    filter: brightness(1.35);
    box-shadow: 0 0 10px rgba(90, 195, 255, 0.55); }
  100% {
    filter: brightness(1);
    box-shadow: none; } }

.secondary-nav-funding__tooltip {
  position: absolute;
  right: 0;
  top: calc(100% + 0.5rem);
  width: 20rem;
  max-width: calc(100vw - 2rem);
  z-index: 1000;
  padding: 0.55rem;
  border: 1px solid rgba(116, 123, 129, 0.4);
  border-radius: 14px;
  background: #163447de;
  box-shadow: 0 10px 28px rgba(21, 28, 36, 0.55); }

.secondary-nav-funding__tooltip-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.45rem;
  padding: 0 0.15rem 0.1rem; }

.secondary-nav-funding__details-link {
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #5ac3ff;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 0.18em; }
  .secondary-nav-funding__details-link:hover {
    color: #dfdfdf; }

.header-bar.isLoggedIn {
  height: 100px;
  /* double de la hauteur initiale */
  height: 90px; }

.nav2-link {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  height: 24px;
  min-width: 96px;
  font-family: 'GoodTimes', sans-serif;
  font-size: 0.7rem;
  line-height: 1;
  color: rgba(223, 223, 223, 0.72);
  text-transform: uppercase;
  text-decoration: none;
  padding: 0 20px;
  border: 0;
  background: transparent;
  transition: color 0.15s ease, filter 0.15s ease; }
  .nav2-link::before, .nav2-link::after {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none; }
  .nav2-link::before {
    z-index: 0;
    clip-path: polygon(14px 0, 100% 0, calc(100% - 14px) 100%, 0 100%);
    background: rgba(158, 34, 34, 0.34); }
  .nav2-link::after {
    z-index: 0;
    clip-path: polygon(calc(14px + 1px) 1px, calc(100% - 1px) 1px, calc(100% - 14px - 1px) calc(100% - 1px), 1px calc(100% - 1px));
    background: rgba(53, 4, 4, 0.5); }
  .nav2-link__label {
    position: relative;
    z-index: 1;
    display: inline-block;
    line-height: 1; }
  .nav2-link:hover:not(.is-active), .nav2-link:active:not(.is-active) {
    color: #dfdfdf;
    text-decoration: none; }
    .nav2-link:hover:not(.is-active)::before, .nav2-link:active:not(.is-active)::before {
      background: rgba(158, 34, 34, 0.42); }
  .nav2-link.is-active {
    color: #ffffff;
    filter: drop-shadow(0 0 6px rgba(209, 35, 35, 0.38));
    text-decoration: none; }
    .nav2-link.is-active::before {
      background: rgba(126, 30, 30, 0.92); }
    .nav2-link.is-active::after {
      background: radial-gradient(ellipse 95% 85% at 50% 42%, rgba(255, 255, 255, 0.22) 0%, rgba(126, 30, 30, 0.88) 24%, rgba(73, 18, 18, 0.82) 58%, rgba(53, 4, 4, 0.86) 100%), linear-gradient(180deg, rgba(126, 30, 30, 0.72) 0%, rgba(73, 18, 18, 0.78) 48%, rgba(73, 18, 18, 0.68) 100%);
      box-shadow: inset 0 1px 0 rgba(223, 223, 223, 0.22), inset 0 -1px 0 rgba(223, 223, 223, 0.14); }

/*Footer*/
.main-footer {
  display: flex;
  justify-content: center;
  width: 100%;
  min-height: 110px;
  bottom: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  z-index: 2; }
  .main-footer::before {
    content: '';
    position: absolute;
    top: 4px;
    left: 0;
    width: 100%;
    height: calc(100% - 4px);
    background: linear-gradient(rgba(1, 39, 77, 0.876), rgba(1, 6, 8, 0.8)), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-repeat: no-repeat;
    background-size: cover;
    z-index: 1;
    pointer-events: none; }
  .main-footer .footer-content {
    position: relative;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 28px;
    width: 100%;
    max-width: 1250px;
    padding: 12px 40px;
    box-sizing: border-box; }
  .main-footer .footer-brand {
    display: flex;
    align-items: center;
    gap: 18px;
    flex: 1 1 0;
    min-width: 0; }
  .main-footer .footer-brand__logo {
    width: auto;
    height: 85px;
    flex-shrink: 0;
    object-fit: contain;
    opacity: 0.85; }
  .main-footer .footer-brand__text {
    text-align: left; }
  .main-footer .footer-brand__tagline,
  .main-footer .footer-brand__since {
    margin: 0;
    color: #b8b8b8;
    font-size: 0.95rem;
    line-height: 1.35; }
  .main-footer .footer-brand__since {
    margin-top: 2px; }
  .main-footer .footer-divider {
    flex-shrink: 0;
    align-self: stretch;
    width: 1px;
    min-height: 72px;
    background: rgba(184, 184, 184, 0.28); }
  .main-footer .footer-legal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    flex: 1.4 1 0;
    min-width: 0; }
  .main-footer .footer-legal__nav {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 8px 28px; }
  .main-footer .footer-legal__link {
    color: #b8b8b8;
    font-size: 0.9rem;
    text-decoration: none;
    white-space: nowrap; }
    .main-footer .footer-legal__link:hover {
      color: #ffffff; }
  .main-footer .footer-legal__copyright {
    margin: 0;
    color: #ffffff;
    font-size: 0.95rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    white-space: nowrap; }
  .main-footer .footer-social {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    flex: 1 1 0;
    min-width: 0; }
  .main-footer .footer-social__row {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    max-width: 280px;
    padding: 0;
    border: none;
    background: transparent;
    color: #b8b8b8;
    font: inherit;
    font-size: 0.88rem;
    line-height: 1.2;
    text-align: left;
    text-decoration: none;
    cursor: pointer; }
    .main-footer .footer-social__row:hover {
      color: #ffffff; }
  .main-footer .footer-social__row--donate:hover .footer-social__heart {
    color: #df3e3e; }
  .main-footer .footer-social__row--donate--locked,
  .main-footer .footer-social__row--donate:disabled {
    cursor: not-allowed;
    opacity: 0.42; }
    .main-footer .footer-social__row--donate--locked:hover,
    .main-footer .footer-social__row--donate:disabled:hover {
      color: #b8b8b8; }
    .main-footer .footer-social__row--donate--locked .footer-social__heart,
    .main-footer .footer-social__row--donate:disabled .footer-social__heart {
      animation: none;
      color: rgba(255, 255, 255, 0.55); }
  .main-footer .footer-social .icon-container {
    flex-shrink: 0;
    width: 90px;
    height: 30px;
    overflow: hidden;
    position: relative;
    margin-bottom: 0; }
    .main-footer .footer-social .icon-container .icon-image {
      width: 100%;
      height: 30px;
      object-fit: contain;
      position: relative;
      top: 0; }
  .main-footer .footer-social .icon-rsi {
    height: 15px;
    width: 45px; }
  .main-footer .footer-social .icon-discord {
    height: 15px;
    width: 45px; }
  .main-footer .footer-social__row:hover .icon-rsi .icon-image,
  .main-footer .footer-social__row:hover .icon-discord .icon-image {
    top: -16px; }
  .main-footer .footer-social__icon--donate {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 45px;
    height: 18px; }
  .main-footer .footer-social__heart {
    width: 16px;
    height: 16px;
    color: #ffffff;
    transform-origin: center center;
    animation: donor-heart-badge-heartbeat 1s ease-in-out infinite; }
    .main-footer .footer-social__heart :hover {
      color: #d12323; }
  .main-footer .footer-social__label {
    flex: 1 1 auto;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; }
  .main-footer .footer-social__external {
    flex-shrink: 0;
    width: 12px;
    height: 12px;
    opacity: 0.75; }
  @media (max-width: 960px) {
    .main-footer .footer-content {
      flex-wrap: wrap;
      justify-content: center;
      gap: 20px 24px;
      padding: 20px 24px; }
    .main-footer .footer-brand,
    .main-footer .footer-legal,
    .main-footer .footer-social {
      flex: 1 1 100%;
      justify-content: center; }
    .main-footer .footer-brand {
      justify-content: center; }
    .main-footer .footer-brand__text {
      text-align: left; }
    .main-footer .footer-divider {
      display: none; }
    .main-footer .footer-social {
      align-items: center; }
    .main-footer .footer-social__row {
      max-width: 260px; } }
  @media (max-width: 560px) {
    .main-footer .footer-legal__nav {
      flex-direction: column;
      gap: 8px; }
    .main-footer .footer-brand__logo {
      width: 72px;
      height: 72px; } }
  .main-footer .vertical-center {
    display: inline-block;
    vertical-align: bottom; }
  @media (orientation: portrait) {
    .main-footer {
      position: relative; } }
  @media (max-width: 1050px) {
    .main-footer {
      position: relative; } }
  @media (max-width: 1050px) and (orientation: landscape) {
    .main-footer {
      position: relative; } }

.vertical-center {
  height: 100%; }

/*  -------------------------------------------------------------  */
/*  -------------------------------------------------------------  */
/*                      MOBILE & TABLETS                           */
/*                     Below 1024px large                          */
/*  -------------------------------------------------------------  */
/*  -------------------------------------------------------------  */
@media (max-width: 1023px) {
  /* HEADER BAR */
  .header-bar {
    flex-direction: column;
    z-index: 2; }
    .header-bar .header-container {
      display: flex;
      flex-direction: column; }
      .header-bar .header-container .header {
        order: 1;
        height: 60px;
        width: 100%;
        margin-left: 30px;
        transform: translate(-94px, 0px); }
      .header-bar .header-container .menu {
        order: 2;
        max-height: 30px;
        width: 100%;
        padding-left: 25px;
        gap: 0px;
        transition: max-height 0.5s ease-in-out,  opacity 0.5s ease-in-out;
        transition: 0.5s; }
        .header-bar .header-container .menu.hide-menu {
          max-height: 0; }
      .header-bar .header-container .underheader-container {
        display: none; }
  /* NAV LINK */
  .nav-link {
    padding-bottom: 15px;
    margin-right: 5vw;
    font-size: 0.7rem; }
  /* AVATAR */
  .user-avatar {
    display: none; }
  .user-avatar-mobile {
    display: inline-block;
    padding-bottom: 7px; }
  .login-btn.logged-in {
    margin-right: 25px;
    height: 30px; }
  .login-btn.logged-out {
    margin-right: 20px;
    height: 20px; }
  .icon {
    fill: #9e2222;
    margin-left: auto;
    margin-right: 10px; }
    .icon.logout {
      height: 20px; }
    .icon.login {
      height: 17px; }
  /* SECONDARY NAVBAR */
  .secondary-menu-inner {
    margin-left: 0px;
    /* Ajustez cette valeur selon vos besoins */
    padding-left: 0px; }
  .secondary-nav-container {
    display: flex;
    overflow: hidden;
    z-index: 1; }
  .secondary-nav-bar {
    transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
    transform: translateY(40px);
    opacity: 1; }
    .secondary-nav-bar.show {
      transform: translateY(3px);
      opacity: 1; }
    .secondary-nav-bar.hide {
      transform: translateY(10px);
      opacity: 0; } }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
/* ===================== */
/*    NOTIFICATION BELL   */
/* ===================== */
.notification-bell {
  display: flex;
  position: relative;
  margin-left: 0;
  margin-right: 0;
  /* BUTTON */ }
  .notification-bell .notification-button {
    background: none;
    border: none;
    cursor: pointer;
    color: #2a3847; }
    .notification-bell .notification-button.unread {
      color: #4ad44a; }
    .notification-bell .notification-button .notification-icon path {
      fill: currentColor; }

/* ===================== */
/*     DROPDOWN PANEL     */
/* ===================== */
.notification-tooltip {
  position: absolute;
  right: 0;
  top: 35px;
  min-width: 270px;
  width: 270px;
  background: #1e3042;
  border: 1px solid #491212;
  border-bottom: 4px solid #491212;
  border-radius: 8px;
  padding: 0;
  overflow: hidden;
  z-index: 1000;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  /* HEADER */
  /* CONTENT SECTION */
  /* NOTIFICATION ITEM */
  /* EMPTY TEXT */
  /* ARCHIVE SECTION */ }
  .notification-tooltip .notification-header {
    display: flex;
    justify-content: space-between;
    color: #dfdfdf;
    text-transform: uppercase;
    font-weight: bold;
    align-items: center;
    padding: 5px 10px;
    border-bottom: 2px solid #2a3847;
    border-radius: 8px 8px 0px 0px;
    background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    padding: 7px 10px;
    height: 13px;
    border-bottom: 2px solid #2a3847;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    display: flex;
    align-items: center; }
    .notification-tooltip .notification-header .header-title {
      flex: 1;
      text-transform: uppercase;
      font-size: 0.9em;
      color: #b8b8b8;
      font-weight: bold;
      padding-left: 8px; }
  .notification-tooltip .notification-section {
    display: flex;
    flex-direction: column;
    background: #1e3042;
    padding: 10px 5px;
    gap: 5px;
    max-height: 300px;
    overflow: auto; }
    .notification-tooltip .notification-section::-webkit-scrollbar {
      width: 6px; }
    .notification-tooltip .notification-section::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .notification-tooltip .notification-section::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .notification-tooltip .notification-section::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
  .notification-tooltip .notif-item {
    display: flex;
    background: #163447;
    margin: 4px 6px;
    padding: 6px 10px;
    border: 1px solid #004872;
    border-radius: 8px;
    transition: transform 0.3s ease, opacity 0.3s ease;
    cursor: pointer; }
    .notification-tooltip .notif-item.slide-out {
      transform: translateX(120%);
      opacity: 0; }
    .notification-tooltip .notif-item.unread {
      border-left: 3px solid #4ad44a; }
      .notification-tooltip .notif-item.unread:hover {
        background: #004872;
        border: 1px solid #3a78b4;
        border-left: 3px solid #4ad44a; }
    .notification-tooltip .notif-item.read {
      opacity: 0.9; }
      .notification-tooltip .notif-item.read:hover {
        background: #004872;
        border: 1px solid #3a78b4; }
    .notification-tooltip .notif-item.archived {
      opacity: 0.6; }
    .notification-tooltip .notif-item a {
      color: #b8b8b8;
      text-decoration: none;
      display: block; }
    .notification-tooltip .notif-item .notif-message {
      width: 90%; }
    .notification-tooltip .notif-item .notif-archive-wrapper {
      position: relative;
      display: inline-block;
      margin-left: auto; }
      .notification-tooltip .notif-item .notif-archive-wrapper .notif-archive-icon {
        width: 20px;
        height: 20px;
        margin-left: auto;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
        background-repeat: no-repeat;
        background-size: 100% 200%;
        background-position: 0 100%;
        cursor: pointer;
        display: inline-block; }
        .notification-tooltip .notif-item .notif-archive-wrapper .notif-archive-icon:hover {
          background-position: 0 0%; }
      .notification-tooltip .notif-item .notif-archive-wrapper .notif-archive-tooltip {
        position: absolute;
        bottom: 0px;
        transform: translateX(-50%);
        background: #491212;
        color: #dfdfdf;
        padding: 4px 8px;
        border-radius: 6px;
        font-size: 11px;
        white-space: nowrap;
        visibility: hidden;
        opacity: 0;
        pointer-events: none; }
      .notification-tooltip .notif-item .notif-archive-wrapper:hover .notif-archive-tooltip {
        visibility: visible;
        opacity: 1; }
  .notification-tooltip .notification-empty {
    padding: 10px;
    text-align: center;
    color: #dfdfdf;
    cursor: default; }
  .notification-tooltip .archive-toggle {
    padding: 5px 10px; }
    .notification-tooltip .archive-toggle .archive-button {
      background: #151c24;
      border: 1px solid #2a3847;
      color: #dfdfdf;
      padding: 3px 10px;
      border-radius: 6px;
      cursor: pointer; }
      .notification-tooltip .archive-toggle .archive-button:hover {
        border-color: #dfdfdf; }
  .notification-tooltip .archive-panel {
    border-top: 2px solid #2a3847;
    background: #2a3847;
    padding: 10px; }
    .notification-tooltip .archive-panel .archive-search {
      width: -webkit-fill-available;
      padding: 5px;
      background: #151c24;
      border: 1px solid #2a3847;
      border-radius: 6px;
      color: #dfdfdf; }
      .notification-tooltip .archive-panel .archive-search::placeholder {
        color: #b8b8b8; }
    .notification-tooltip .archive-panel .archive-content-wrapper {
      max-height: 300px;
      overflow: auto; }
      .notification-tooltip .archive-panel .archive-content-wrapper::-webkit-scrollbar {
        width: 6px; }
      .notification-tooltip .archive-panel .archive-content-wrapper::-webkit-scrollbar-track {
        background: #2e3842;
        border-radius: 4px;
        padding-right: 1px; }
      .notification-tooltip .archive-panel .archive-content-wrapper::-webkit-scrollbar-thumb {
        background-color: #491212;
        border-radius: 4px; }
        .notification-tooltip .archive-panel .archive-content-wrapper::-webkit-scrollbar-thumb:hover {
          background-color: #200808; }

/* ===================== */
/*  GLOBAL ITEM SPACING   */
/* ===================== */
.notification-tooltip > div {
  font-size: 0.875rem;
  color: #b8b8b8; }

.notification-tooltip > div + div {
  border-top: 1px solid #2a3847; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.public-container {
  display: flex;
  width: 1050px;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  padding-left: 25px;
  padding-right: 25px;
  padding-top: 25px;
  margin-bottom: 25px;
  border-radius: 8px;
  z-index: 1; }

@media (min-width: 1351px) {
  .public-container:has(.divisions-tab-root) {
    max-width: 1280px;
    width: 100%; } }

.rte-content-container {
  background-color: #163447;
  margin-left: auto;
  margin-right: auto; }

/*story.css */
.custom-public {
  text-align: justify;
  color: #dfdfdf; }

.public-container h1 {
  text-align: center; }

.public-container h2,
.public-container h3 {
  color: #dfdfdf; }

.public-container img {
  text-align: center; }

.public-container p {
  margin-bottom: 0;
  color: #dfdfdf; }

.public-container blockquote {
  margin: 10px 0;
  color: #dfdfdf;
  padding: 15px;
  position: relative; }
  .public-container blockquote::before, .public-container blockquote::after {
    content: "";
    position: absolute;
    border: 3px solid #2a3847;
    border-radius: 6px 0; }
  .public-container blockquote::before {
    top: -3px;
    left: -3px;
    width: 50%;
    height: 50%;
    border-right: none;
    border-bottom: none; }
  .public-container blockquote::after {
    bottom: -3px;
    right: -3px;
    width: 50%;
    height: 50%;
    border-left: none;
    border-top: none; }

.public-container pre {
  background-color: #0c2637 !important;
  border-left: 5px solid #491212 !important;
  border: 1px solid #491212;
  border-radius: 0px;
  color: #b1b1b1 !important;
  font-size: inherit;
  line-height: inherit;
  margin: 0 0 10px;
  overflow: visible;
  padding: 20px !important;
  white-space: pre-wrap;
  word-break: inherit;
  word-wrap: break-word;
  position: relative;
  font-family: 'Input', monospace !important; }

.title-container {
  display: flex;
  justify-content: center;
  padding: 0 15px;
  height: auto;
  transform: translateY(3px);
  gap: 50px; }

.trapezoid-border2, .trapezoid-border3, .trapezoid-border4, .trapezoid-border5 {
  display: inline-block;
  width: 200px;
  height: 33px;
  padding: 0;
  backdrop-filter: blur(3px) saturate(33%);
  -webkit-backdrop-filter: blur(4px) saturate(33%);
  clip-path: polygon(38px 0, 161px 0, 203px 37px, -5px 37px); }

.trapezoid-title, .trapezoid-title2 {
  display: inline-block;
  width: 200px;
  height: 33px;
  text-align: center;
  margin-top: 3px;
  padding: 0;
  clip-path: polygon(40px 0, 160px 0, 198px 33px, 2px 33px);
  cursor: pointer;
  z-index: 5;
  text-transform: uppercase;
  font-family: 'GoodTimes', sans-serif;
  transition: all 0.3s ease; }

.trapezoid-title {
  background: linear-gradient(#567392, #1c252f);
  color: #dfdfdf;
  font-size: 17px;
  align-content: center; }

.trapezoid-title2 {
  background: linear-gradient(#567392, #1c252f);
  color: #dfdfdf;
  font-size: 17px;
  align-content: center; }

.trapezoid-border2 {
  background-color: rgba(51, 102, 126, 0.329);
  border-bottom: 0px solid #0c2637; }
  .trapezoid-border2 .trapezoid-title {
    background: linear-gradient(#03294a, #274256);
    color: #b8b8b8; }

.trapezoid-border3 {
  background-color: rgba(51, 91, 126, 0.329);
  border-bottom: 3px solid rgba(1, 1, 2, 0.329); }
  .trapezoid-border3 .trapezoid-title {
    width: 195px;
    margin-top: 3px;
    background: linear-gradient(#1c2d38, rgba(20, 40, 49, 0.329));
    color: #2a3847;
    clip-path: polygon(40px 0, 160px 0, 198px 33px, 2px 33px); }
  .trapezoid-border3.active {
    border-bottom: 3px solid #1c2d38;
    background-color: rgba(173, 221, 243, 0.329); }
    .trapezoid-border3.active .trapezoid-title {
      background: linear-gradient(#03294a, #274256);
      color: #b8b8b8; }

@keyframes rotate-background {
  0% {
    background-position: 0% 50%; }
  100% {
    background-position: 100% 50%; } }

.trapezoid-border4 {
  background: linear-gradient(to right, #bf943fa8, #fcf6baab, #b38728a8, #fbf5b7ab, #aa761ca8);
  background-size: 200% 200%;
  border-bottom: 3px solid rgba(1, 1, 2, 0.329);
  animation: rotate-background 2s linear infinite; }
  .trapezoid-border4 .trapezoid-title {
    background: linear-gradient(#1c2d38, rgba(20, 40, 49, 0.329));
    color: #2a3847; }
  .trapezoid-border4.active {
    background: linear-gradient(to right, #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C);
    background-size: 200% 200%;
    animation: rotate-background 2s linear infinite; }
    .trapezoid-border4.active .trapezoid-title {
      background: linear-gradient(#03294a, #274256);
      color: #a88f58; }

.trapezoid-border5 {
  background-color: rgba(51, 102, 126, 0.329);
  border-bottom: 0px solid #0c2637; }
  .trapezoid-border5 .trapezoid-title {
    background: linear-gradient(#03294a, #274256);
    color: #b8b8b8; }

#backgroundCanvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block; }

.unauthorized {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  position: relative;
  color: #dfdfdf; }
  .unauthorized .unauthorized-canvas {
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: -1; }
  .unauthorized .links-container {
    display: flex;
    justify-content: center;
    margin-top: 20px; }
    .unauthorized .links-container .lost {
      background-color: #2a3847;
      color: #dfdfdf;
      padding: 10px 20px;
      margin: 0 10px;
      border: 1px solid #b8b8b8;
      border-radius: 8px;
      text-decoration: none;
      text-transform: uppercase;
      width: 150px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); }
      .unauthorized .links-container .lost:hover {
        border: 1px solid #491212;
        background-color: #1c2d38; }

.division-description {
  white-space: pre-wrap; }

.division-description-container {
  height: 220px;
  padding-bottom: 20px;
  overflow-y: auto;
  scrollbar-width: 8px; }

/* Styles pour la barre de défilement sur Chrome, Edge, etc. */
.division-description-container::-webkit-scrollbar {
  width: 8px;
  /* Largeur de la scrollbar */ }

.division-description-container::-webkit-scrollbar-thumb {
  background-color: #491212;
  /* Couleur de la partie déplaçable de la scrollbar */
  border-radius: 10px;
  /* Arrondir les angles */ }

.division-description-container::-webkit-scrollbar-track {
  background: #2a3847;
  /* Couleur de fond de la track de la scrollbar */ }

.organization-structure {
  margin-bottom: 30px; }

.ranks-tab {
  padding: 0px 50px 20px 50px; }

.divisions-tab {
  padding: 0px 10px 20px 10px; }

@media (max-width: 1350px) {
  .public-container {
    display: flex;
    margin-bottom: 55px;
    padding-left: clamp(12px, 1.5%, 20px);
    padding-right: clamp(12px, 1.5%, 20px);
    width: 100%;
    max-width: 1350px; }
  .custom-public {
    text-align: justify;
    color: #dfdfdf; }
  .ranks-tab {
    padding: 0px 10px 20px 10px; }
  .divisions-tab {
    padding: 0px 10px 20px 10px; }
  .rank-type-description {
    text-align: justify; } }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.error {
  color: red;
  font-size: 0.8em;
  margin-top: 5px; }

.private-pages {
  height: 100%;
  margin-top: 60px;
  margin-right: auto;
  margin-left: auto;
  max-width: 1460px; }
  .private-pages.private-pages--personal-hub {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    margin-top: 0;
    overflow: hidden;
    overscroll-behavior: none; }
  .private-pages.hangar-page {
    max-width: 1500px;
    margin-left: 30px; }

.private-container {
  display: flex;
  position: relative;
  justify-content: center;
  margin: auto;
  margin-top: 20px;
  padding: 15px;
  border: 1px solid #491212;
  border-top: 4px solid #491212;
  border-bottom: 4px solid #491212;
  box-shadow: 4px 5px 2px #4b050547;
  border-radius: 8px;
  z-index: 1;
  overflow-wrap: normal;
  background-color: #172738;
  height: 500px;
  overflow-y: auto;
  width: auto; }
  .private-container::-webkit-scrollbar {
    width: 6px; }
  .private-container::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .private-container::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .private-container::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }

.custom-private {
  text-align: justify;
  color: #dfdfdf; }

.private-container h1 {
  text-align: center; }

.private-container h2,
.private-container h3 {
  color: #dfdfdf; }

.private-container img {
  text-align: center; }

.private-container p {
  margin-bottom: 0;
  color: #dfdfdf; }

.private-container blockquote {
  margin: 10px 0;
  color: #dfdfdf;
  padding: 15px;
  position: relative; }
  .private-container blockquote::before, .private-container blockquote::after {
    content: "";
    position: absolute;
    border: 3px solid #2a3847;
    border-radius: 6px 0; }
  .private-container blockquote::before {
    top: -3px;
    left: -3px;
    width: 50%;
    height: 50%;
    border-right: none;
    border-bottom: none; }
  .private-container blockquote::after {
    bottom: -3px;
    right: -3px;
    width: 50%;
    height: 50%;
    border-left: none;
    border-top: none; }

.private-container pre {
  background-color: #172738;
  border-left: 5px solid #491212;
  border: 1px solid #491212;
  border-radius: 0px;
  color: #dfdfdf !important;
  font-size: inherit;
  line-height: inherit;
  margin: 0 0 10px;
  overflow: visible;
  padding: 20px !important;
  white-space: pre-wrap;
  word-break: inherit;
  word-wrap: break-word;
  position: relative;
  font-family: 'Input', monospace !important; }

.extension-setup-steps {
  margin: 15px 0 30px 0;
  padding: 16px 20px;
  border-radius: 6px;
  background: #172738;
  border: 1px solid #491212;
  border-bottom: 4px solid #491212;
  box-shadow: 4px 5px 2px #4b050547; }

.extension-setup-list {
  margin: 0;
  padding-left: 22px;
  list-style: decimal; }
  .extension-setup-list li {
    margin: 6px 0;
    font-size: 14px;
    color: #dfdfdf;
    line-height: 1.4; }

/* ---------------------------------------------------------------------------
 * Onboarding container — duplication volontaire des règles \`.private-container\`
 * ci-dessus, sous un sélecteur dédié \`.onboarding-private-container\`.
 * Objectif : pouvoir faire diverger le rendu des steps Lexical de l'onboarding
 * sans toucher au design des pages privées classiques.
 * À l'instant T les deux blocs sont identiques ; les divergences de design
 * doivent être appliquées UNIQUEMENT ici.
 * ------------------------------------------------------------------------- */
.onboarding-private-container {
  display: flex;
  position: relative;
  justify-content: center;
  margin: auto;
  margin-top: 20px;
  padding: 15px;
  border-radius: 8px;
  z-index: 1;
  overflow-wrap: normal;
  height: calc(100vh - 555px);
  min-height: calc(100vh - 555px);
  overflow-y: auto;
  width: auto; }
  .onboarding-private-container::-webkit-scrollbar {
    width: 6px; }
  .onboarding-private-container::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .onboarding-private-container::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .onboarding-private-container::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }

.onboarding-private-container h1 {
  text-align: center; }

.onboarding-private-container h2,
.onboarding-private-container h3 {
  color: #dfdfdf; }

.onboarding-private-container img {
  text-align: center; }

.onboarding-private-container p {
  margin-bottom: 0;
  color: #dfdfdf; }

.onboarding-private-container blockquote {
  margin: 10px 0;
  color: #dfdfdf;
  padding: 15px;
  position: relative; }
  .onboarding-private-container blockquote::before, .onboarding-private-container blockquote::after {
    content: "";
    position: absolute;
    border: 3px solid #2a3847;
    border-radius: 6px 0; }
  .onboarding-private-container blockquote::before {
    top: -3px;
    left: -3px;
    width: 50%;
    height: 50%;
    border-right: none;
    border-bottom: none; }
  .onboarding-private-container blockquote::after {
    bottom: -3px;
    right: -3px;
    width: 50%;
    height: 50%;
    border-left: none;
    border-top: none; }

.onboarding-private-container pre {
  background-color: #172738;
  border-left: 5px solid #491212;
  border: 1px solid #491212;
  border-radius: 0px;
  color: #dfdfdf !important;
  font-size: inherit;
  line-height: inherit;
  margin: 0 0 10px;
  overflow: visible;
  padding: 20px !important;
  white-space: pre-wrap;
  word-break: inherit;
  word-wrap: break-word;
  position: relative;
  font-family: 'Input', monospace !important; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
/*confirm.scss and activation.scss */
.custom-confirm {
  text-align: center;
  text-align: justify;
  color: #dfdfdf; }

.confirm-container {
  background: #1c2d38;
  margin-left: auto;
  margin-right: auto;
  padding-left: 25px;
  padding-right: 25px;
  padding-top: 12px;
  padding-bottom: 25px;
  margin-top: 100px;
  border: 2px solid #0c2637;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  width: 100%;
  max-width: 1350px; }

p {
  margin-bottom: 0; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
/*Login and Register*/
.login-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 20vh;
  height: auto; }

.login-card {
  position: relative;
  backdrop-filter: blur(6px) saturate(33%);
  -webkit-backdrop-filter: blur(4px) saturate(33%);
  background-color: #25405748;
  color: #dfdfdf;
  width: 400px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: height 0.6s ease-in-out;
  border: 1px solid rgba(51, 102, 126, 0.329);
  box-shadow: 3px 2px inset rgba(51, 102, 126, 0.229);
  border-radius: 6px; }

.login-card--login {
  height: auto; }

.login-card--mfa {
  height: 460px; }

.login-card--register {
  height: 400px; }

.login-card--reset {
  height: 235px; }

.login-card--login-discord {
  height: auto; }

.login-card--discord-mfa {
  height: 310px; }

.login-card--identity-check {
  height: 245px;
  width: 340px; }

.login-tab-container {
  display: flex;
  justify-content: space-between;
  width: 100%; }

.identity-check-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  height: inherit;
  margin-top: 20vh; }

.email-section.identity-check {
  display: flex;
  align-items: center;
  width: 270px;
  height: 45px;
  padding: 5px;
  color: #491212;
  text-transform: lowercase;
  font-size: 1rem;
  font-weight: bold;
  margin: 1rem 0;
  border-radius: 6px;
  cursor: default;
  border-style: unset; }
  .email-section.identity-check .email-info {
    display: flex;
    font-size: 0.85em;
    align-items: center; }
    .email-section.identity-check .email-info .email-icon {
      width: 30px;
      object-fit: contain;
      margin-left: 16px;
      margin-right: 16px;
      display: inline-block; }

.login-tab {
  background-color: #0c2637;
  width: 33.33%;
  font-size: 1.2rem;
  padding: 10px 0;
  text-align: center;
  color: #b8b8b8;
  text-decoration: none;
  text-align: center;
  transition: width 300ms ease-in-out; }
  .login-tab:hover {
    cursor: pointer;
    color: #dfdfdf;
    text-decoration: underline; }
  .login-tab.active {
    background-color: #1c2d38;
    color: white;
    cursor: pointer; }
  .login-tab.locked {
    color: #2a3847;
    pointer-events: none;
    cursor: none; }

.login-tab-discord {
  background-color: #1c2d38;
  width: 100%;
  font-size: 1.2rem;
  padding: 10px 0;
  text-align: center;
  color: #b8b8b8;
  text-decoration: none;
  text-align: center;
  transition: width 300ms ease-in-out; }
  .login-tab-discord.identity-check {
    text-transform: uppercase;
    font-size: 1rem;
    font-weight: bold; }

/* Specific styles for Discord icon */
.btn-style1.handle-check {
  display: flex;
  align-items: center;
  width: 270px;
  height: 45px;
  padding: 5px;
  color: #dfdfdf;
  /* Assure-toi que cette couleur est définie pour voir l'effet au survol */
  background-color: #2b518b;
  /* Couleur de fond initiale */
  background-image: none;
  text-transform: uppercase;
  font-size: 0.8rem;
  font-weight: bold;
  margin: 1rem 0;
  border-radius: 6px;
  border-style: unset;
  cursor: pointer; }
  .btn-style1.handle-check:hover {
    background-color: #3d68a8;
    /* Changement de couleur au survol */
    color: white;
    font-weight: bolder; }
  .btn-style1.handle-check .rsi-icon {
    width: 40px;
    object-fit: contain;
    margin-left: 10px;
    margin-right: 15px;
    display: inline-block;
    /* Rendre l'icône inline */ }

.login-access-denied {
  width: 400px;
  max-width: 100%;
  margin-top: 12px;
  padding: 10px 14px;
  box-sizing: border-box;
  text-align: center;
  color: #d12323;
  font-size: 0.9rem;
  line-height: 1.45;
  white-space: pre-line; }

.lock-banner {
  background-color: #6e441c;
  /* Rouge clair pour indiquer une restriction */
  color: #dfdfdf;
  font-size: 0.9rem;
  text-transform: uppercase;
  width: -webkit-fill-available;
  padding: 3px 14px;
  text-align: center;
  border-radius: 0px;
  margin-bottom: -24px; }

.fade-field {
  opacity: 0;
  transition: opacity 0.4s;
  animation: fadein 0.4s forwards;
  animation-delay: 0.6s; }

@keyframes fadein {
  to {
    opacity: 1; } }

.form-container {
  margin-top: 2.5rem;
  width: 90%;
  height: 100%;
  margin-bottom: 1rem; }

.custom-field {
  width: calc(100% - 30px);
  margin: 0 15px;
  margin-bottom: 30px; }
  .custom-field .remember-me {
    position: relative; }
  .custom-field .form-control {
    width: 100%;
    padding: 15px;
    box-sizing: border-box; }
  .custom-field .mfa-field {
    display: flex;
    width: 65%;
    margin: auto;
    margin-bottom: 20px;
    padding: 15px;
    font-size: 1.1rem;
    letter-spacing: 10px;
    text-align: center;
    border: 3px solid #d12323;
    outline: none;
    box-sizing: border-box;
    max-height: 0;
    opacity: 0;
    overflow: hidden;
    animation: fadeIn 0.6s forwards;
    transition: max-height 0.3s ease-out, opacity 0.7s ease-out; }
  .custom-field .mfa-field.show {
    max-height: 100px;
    /* Ou la hauteur nécessaire */
    opacity: 1; }
  .custom-field .form-check {
    position: absolute;
    box-sizing: border-box; }
    .custom-field .form-check.with-mfa {
      position: relative;
      top: 0px; }

.btn-slide-down {
  bottom: 95px; }

.custom-button {
  background-color: #491212;
  width: calc(100% - 30px);
  height: 50px;
  margin: 0px 15px 00px;
  padding-top: .8rem;
  padding-bottom: .8rem;
  font-size: 1.2rem;
  color: #dfdfdf;
  position: relative; }

@keyframes slideIn {
  0% {
    transform: translateY(-5px);
    opacity: 0; }
  100% {
    transform: translateY(0);
    opacity: 1; } }

@keyframes fadeIn {
  from {
    opacity: 0; }
  to {
    opacity: 1; } }

.login-alternative {
  margin-top: 20px; }

.discord-alternative {
  opacity: 0;
  transition: opacity 300ms ease-in;
  animation: fadeIn 300ms ease-in forwards 300ms; }

.login-button {
  opacity: 0;
  transform: translateY(-50px);
  animation-name: slideIn;
  animation-duration: 0.5s;
  animation-delay: 0.35s;
  animation-fill-mode: forwards;
  cursor: pointer; }

.register-button {
  opacity: 0;
  transform: translateY(-50px);
  animation-name: slideIn;
  animation-duration: 0.5s;
  animation-delay: 0.35s;
  animation-fill-mode: forwards;
  cursor: pointer; }

.transition-button {
  opacity: 0;
  transform: translateY(-20px);
  transition: all 0.5s ease-out; }

.transition-button.show {
  opacity: 1;
  transform: translateY(0); }

.password-field {
  opacity: 0;
  transform: translateY(-5px);
  animation-name: slideIn;
  animation-duration: 0.5s;
  animation-delay: 0.3s;
  animation-fill-mode: forwards; }

.toggle-password-icon {
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 25px;
  transform: translateY(-50%);
  height: 17px; }

.password-input-container {
  position: relative; }

.remember-me {
  position: relative;
  margin-top: 5px;
  height: 5px;
  opacity: 0;
  transform: translateY(-5px);
  animation-name: slideIn;
  animation-duration: 0.5s;
  animation-delay: 0.3s;
  animation-fill-mode: forwards; }
  .remember-me.discord {
    height: 0px;
    margin: 10px 0px;
    margin-left: 70px; }

.error-message {
  display: block;
  height: 5px;
  margin-top: 5px;
  min-height: 5px;
  color: #db5757; }

.message {
  position: absolute;
  top: 135px;
  text-align: center;
  color: #db5757; }

.discord-login {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  position: relative;
  align-content: center;
  align-items: center;
  height: max-content;
  top: 0px; }
  .discord-login.identity-check {
    margin-top: 0px; }
    .discord-login.identity-check .icon-container {
      display: flex;
      width: 30px;
      height: auto;
      overflow: hidden;
      position: relative;
      top: 3px;
      margin-left: 15px;
      margin-right: 10px; }
      .discord-login.identity-check .icon-container .icon-image {
        top: 0px;
        width: 30px;
        height: auto;
        overflow: hidden;
        border-radius: 50%; }
    .discord-login.identity-check.discord-mfa {
      margin-top: 20px;
      margin-bottom: 20px; }
  .discord-login .discord-button {
    display: flex;
    position: relative;
    align-items: center;
    height: max-content;
    width: 270px;
    height: 45px;
    padding: 5px;
    color: #dfdfdf;
    background-image: none;
    background-color: #4752c4;
    border-radius: 6px;
    cursor: pointer;
    border-style: unset; }
    .discord-login .discord-button:hover {
      background-color: #5865F2;
      color: white; }
    .discord-login .discord-button.discord-mfa {
      cursor: default; }
      .discord-login .discord-button.discord-mfa:hover {
        background-color: #5865F2;
        color: white;
        box-shadow: none; }
  .discord-login .icon-container {
    width: 50px;
    height: 30px;
    overflow: hidden;
    position: relative;
    margin-bottom: 5px; }
    .discord-login .icon-container .icon-image {
      top: 4px;
      width: 25px;
      height: auto;
      top: 6px;
      width: 27px;
      height: auto;
      overflow: hidden;
      border-radius: unset; }
  .discord-login .discord-label {
    text-transform: none;
    font-size: 0.8rem;
    font-weight: bold;
    margin-left: 10px;
    margin-bottom: 0px; }

.discord-alternative {
  display: flex;
  margin: auto;
  justify-content: center;
  color: #b8b8b8;
  text-decoration: none;
  cursor: pointer; }
  .discord-alternative:hover {
    color: white; }

@media (max-width: 1023px) {
  .login-container {
    background-color: #0c2637;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh; }
  .login-card {
    position: absolute;
    margin-top: 90px;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    padding: 15px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 0px; }
  .login-access-denied {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 32px;
    width: auto;
    margin-top: 0;
    padding: 12px 20px; }
  .lock-banner {
    position: absolute;
    background-color: #491212;
    /* Rouge clair pour indiquer une restriction */
    color: #dfdfdf;
    font-size: 0.95rem;
    text-transform: uppercase;
    width: calc(100vw - 12px);
    padding: 6px;
    text-align: center;
    border-radius: 0;
    margin-bottom: 0px;
    /* Espacement avant les onglets */
    top: 13px;
    left: 0; }
  .login-tab {
    font-size: 1.2rem; }
  .custom-button {
    background-color: #9e2222;
    width: calc(100% - 30px);
    height: 50px;
    margin: 0 15px 20px;
    padding-top: .8rem;
    padding-bottom: .8rem;
    font-size: 1.2rem;
    color: #dfdfdf;
    top: 40px;
    position: relative;
    bottom: auto;
    left: 0%;
    transform: translateX(-50%); }
  .no-scroll {
    overflow: hidden; } }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.identity-hub {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 940px;
  margin: 0 auto;
  padding: 10vh 1.25rem 3rem;
  box-sizing: border-box; }
  .identity-hub--loading {
    justify-content: center;
    min-height: 40vh; }
  .identity-hub--view-as .identity-hub-row__actions button,
  .identity-hub--view-as .identity-hub-btn-rsi-connect,
  .identity-hub--view-as .identity-hub-rsi-hide,
  .identity-hub--view-as .identity-hub-rsi-btn-primary,
  .identity-hub--view-as .identity-hub-rsi-copy-hit {
    pointer-events: none;
    opacity: 0.55; }

.identity-hub__view-as-banner,
.identity-hub__view-as-gcu-hint {
  width: 100%;
  margin: 0 0 1rem;
  padding: 0.65rem 1rem;
  border-radius: 8px;
  font-size: 0.9rem;
  line-height: 1.4;
  text-align: center;
  box-sizing: border-box; }

.identity-hub__view-as-banner {
  color: #ffffff;
  background: rgba(0, 72, 114, 0.35);
  border: 1px solid rgba(223, 223, 223, 0.25); }

.identity-hub__view-as-gcu-hint {
  color: #dca9a9;
  background: rgba(158, 34, 34, 0.12);
  border: 1px solid rgba(158, 34, 34, 0.35); }

.identity-hub__header {
  text-align: center;
  margin-bottom: 1.75rem; }

.identity-hub__title {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #ffffff; }

.identity-hub__title-rule {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  margin: 0.85rem auto 0.65rem;
  max-width: 320px; }

.identity-hub__title-rule-line {
  flex: 1;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(58, 140, 200, 0.65) 20%, rgba(74, 160, 230, 0.9) 50%, rgba(58, 140, 200, 0.65) 80%, transparent); }

.identity-hub__title-rule-diamond {
  width: 7px;
  height: 7px;
  flex-shrink: 0;
  background: #6096cc;
  transform: rotate(45deg);
  box-shadow: 0 0 10px rgba(74, 160, 230, 0.55); }

.identity-hub__subtitle {
  margin: 0;
  font-size: 0.92rem;
  color: #b8b8b8; }

.identity-hub-card {
  position: relative;
  width: 100%;
  max-width: 900px;
  background: linear-gradient(165deg, rgba(22, 40, 55, 0.92), rgba(12, 26, 40, 0.96));
  border: 1px solid rgba(58, 120, 180, 0.5);
  border-radius: 10px;
  box-shadow: 0 0 24px rgba(20, 60, 100, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.04);
  padding: 0;
  overflow: visible; }

.identity-hub-card--rsi-open {
  border-color: rgba(74, 150, 220, 0.55);
  box-shadow: 0 0 32px rgba(30, 100, 180, 0.22), inset 0 1px 0 rgba(255, 255, 255, 0.04); }

.identity-hub-card__inner {
  position: relative;
  z-index: 0; }

.identity-hub-row {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 1rem 1.25rem;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid rgba(42, 58, 72, 0.85); }
  .identity-hub-row:last-child {
    border-bottom: none; }
  .identity-hub-row.identity-hub-row--dual {
    grid-template-columns: auto minmax(0, 1fr); }

.identity-hub-row__icon-wrap {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 1px solid rgba(255, 255, 255, 0.08); }
  .identity-hub-row__icon-wrap img {
    display: block;
    width: 26px;
    height: auto; }

.identity-hub-row__icon-wrap--email {
  background: radial-gradient(circle at 30% 25%, rgba(40, 90, 130, 0.9), #0c2637);
  border-color: rgba(0, 120, 185, 0.35); }
  .identity-hub-row__icon-wrap--email svg {
    width: 26px;
    height: 26px;
    color: #5ac3ff; }

.identity-hub-row__icon-wrap--discord {
  background: #5865f2;
  border-color: rgba(255, 255, 255, 0.18); }
  .identity-hub-row__icon-wrap--discord .identity-hub-row__icon-discord-linked {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    object-fit: cover; }
  .identity-hub-row__icon-wrap--discord img:not(.identity-hub-row__icon-discord-linked) {
    width: 35px;
    height: auto; }

.identity-hub-row__icon-wrap--rsi {
  background: radial-gradient(circle at 30% 20%, rgba(35, 70, 120, 0.95), #0c2637);
  border-color: rgba(74, 120, 180, 0.35); }
  .identity-hub-row__icon-wrap--rsi img {
    width: 44px; }

.identity-hub-row__body {
  min-width: 0; }

.identity-hub-row__label {
  display: block;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  margin-bottom: 0.35rem; }
  .identity-hub-row__label.identity-hub-row__label--email {
    color: #6fa1d1; }
  .identity-hub-row__label.identity-hub-row__label--discord {
    color: #aab3ff; }
  .identity-hub-row__label.identity-hub-row__label--rsi {
    color: #6fa1d1; }

.identity-hub-row__value {
  display: block;
  font-size: 1rem;
  font-weight: 600;
  color: #ffffff;
  word-break: break-word; }

.identity-hub-row__status {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  margin-top: 0.4rem;
  font-size: 0.82rem; }
  .identity-hub-row__status svg {
    flex-shrink: 0; }
  .identity-hub-row__status.identity-hub-row__status--success {
    color: #75cf78; }
    .identity-hub-row__status.identity-hub-row__status--success svg {
      color: #75cf78; }
  .identity-hub-row__status.identity-hub-row__status--muted {
    margin-top: 0.35rem;
    color: #747b81; }

.identity-hub-row__hint {
  display: block;
  margin-top: 0.28rem;
  font-size: 0.77rem;
  line-height: 1.35;
  color: #747b81; }

.identity-hub-row__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  flex-shrink: 0; }

.identity-hub-btn-outline {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 0.55rem 0.95rem;
  border-radius: 6px;
  font-size: 0.74rem;
  font-weight: 700;
  cursor: pointer;
  border: 1px solid transparent;
  background: transparent;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;
  white-space: nowrap; }
  .identity-hub-btn-outline:disabled {
    opacity: 0.45;
    cursor: not-allowed; }
  .identity-hub-btn-outline svg {
    flex-shrink: 0;
    width: 15px;
    height: 15px;
    color: inherit; }

.identity-hub-btn-outline--muted {
  color: #dfdfdf;
  border-color: rgba(118, 128, 140, 0.65);
  background: rgba(8, 20, 32, 0.45); }
  .identity-hub-btn-outline--muted:hover:not(:disabled) {
    border-color: rgba(160, 170, 185, 0.75);
    background: rgba(20, 40, 56, 0.55); }

.identity-hub-btn-outline--discord {
  color: #c9ceff;
  border-color: rgba(88, 101, 242, 0.85); }
  .identity-hub-btn-outline--discord:hover:not(:disabled) {
    background: rgba(88, 101, 242, 0.12);
    border-color: #727cf5;
    color: #ffffff; }
    .identity-hub-btn-outline--discord:hover:not(:disabled) img {
      opacity: 1; }
  .identity-hub-btn-outline--discord img.identity-hub-discord-mini {
    height: 17px;
    width: auto; }

.identity-hub-btn-rsi-connect {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.48rem;
  padding: 0.55rem 1.05rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  cursor: pointer;
  border: 1px solid rgba(74, 130, 200, 0.55);
  color: #ffffff;
  background: linear-gradient(145deg, #2f6aae 0%, #214a82 42%, #18365f 100%);
  box-shadow: 0 2px 12px rgba(20, 50, 90, 0.35);
  transition: transform 0.12s ease, box-shadow 0.15s ease, filter 0.15s ease; }
  .identity-hub-btn-rsi-connect:hover:not(:disabled) {
    filter: brightness(1.06);
    box-shadow: 0 4px 16px rgba(30, 80, 140, 0.45); }
  .identity-hub-btn-rsi-connect:active:not(:disabled) {
    transform: translateY(1px); }

.identity-hub-btn-rsi-connect__arrow {
  font-weight: 800; }

.identity-hub-rsi-section {
  border-top: 1px solid rgba(42, 58, 72, 0.85); }
  .identity-hub-rsi-section.identity-hub-rsi-section--open .identity-hub-rsi-head {
    border-bottom: 1px solid rgba(42, 58, 72, 0.85); }

.identity-hub-rsi-head {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 1rem 1.25rem;
  padding: 1.25rem 1.5rem; }

.identity-hub-rsi-hide {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #77a6d3;
  transition: color 0.15s ease; }
  .identity-hub-rsi-hide:hover {
    color: #ffffff; }
  .identity-hub-rsi-hide svg {
    flex-shrink: 0;
    width: 14px;
    height: 14px;
    color: inherit;
    transform: translateY(-1px); }

.identity-hub-rsi-expand {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.42s cubic-bezier(0.33, 1, 0.68, 1); }

.identity-hub-rsi-expand--open {
  grid-template-rows: 1fr; }

.identity-hub-rsi-expand__measure {
  min-height: 0;
  overflow: hidden; }

.identity-hub-rsi-expand__surface {
  padding: 1rem 1.5rem 1.5rem; }
  @media screen and (min-width: 541px) {
    .identity-hub-rsi-expand__surface {
      padding-bottom: 1.75rem; } }

.identity-hub-rsi-wizard {
  display: flex;
  flex-direction: column;
  gap: 0.15rem; }

.identity-hub-rsi-wizard__heading-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  align-items: flex-end;
  margin-bottom: 0.35rem; }
  @media screen and (max-width: 720px) {
    .identity-hub-rsi-wizard__heading-row {
      grid-template-columns: 1fr;
      gap: 0.5rem;
      margin-bottom: 0.5rem; } }

.identity-hub-rsi-wizard__pair-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  align-items: stretch; }
  @media screen and (max-width: 720px) {
    .identity-hub-rsi-wizard__pair-row {
      grid-template-columns: 1fr;
      gap: 1.25rem; } }

.identity-hub-rsi-wizard__pair-row:last-of-type .identity-hub-rsi-step__rail-after {
  display: none; }

.identity-hub-rsi-wizard__legend {
  color: #747b81;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.17em;
  text-transform: uppercase;
  margin: 0;
  padding-left: 50px; }
  .identity-hub-rsi-wizard__legend.identity-hub-rsi-wizard__legend--muted {
    color: #747b81;
    font-weight: 700;
    letter-spacing: 0.08em; }
  @media screen and (max-width: 720px) {
    .identity-hub-rsi-wizard__legend {
      padding-left: 0; } }

.identity-hub-rsi-step {
  display: grid;
  grid-template-columns: 38px 1fr;
  gap: 0.65rem 0.95rem;
  position: relative;
  padding-bottom: 1.35rem; }
  .identity-hub-rsi-step__rail-after {
    position: absolute;
    left: 18px;
    top: 40px;
    bottom: -2px;
    width: 0;
    border-left: 2px dashed rgba(90, 110, 128, 0.55);
    pointer-events: none; }
  .identity-hub-rsi-step--accent .identity-hub-rsi-step__rail-after {
    border-left-color: rgba(64, 160, 255, 0.45);
    box-shadow: -1px 0 12px rgba(40, 140, 255, 0.12); }

.identity-hub-rsi-step__bullet {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.78rem;
  font-weight: 800;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  border: 2px solid rgba(255, 255, 255, 0.1);
  background: rgba(18, 32, 44, 0.95);
  color: #747b81;
  transition: border-color 0.2s ease, background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease; }

.identity-hub-rsi-step--accent .identity-hub-rsi-step__bullet {
  border-color: rgba(90, 190, 255, 0.85);
  background: linear-gradient(145deg, rgba(30, 90, 150, 0.95), rgba(18, 55, 100, 0.98));
  color: #ffffff;
  box-shadow: 0 0 16px rgba(40, 150, 255, 0.28), inset 0 1px 0 rgba(255, 255, 255, 0.12); }

.identity-hub-rsi-step__body {
  min-width: 0;
  padding-top: 0.12rem; }

.identity-hub-rsi-step__title {
  margin: 0 0 0.55rem;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #747b81;
  transition: color 0.2s ease; }

.identity-hub-rsi-step--accent .identity-hub-rsi-step__title {
  color: #9dbfe0; }

.identity-hub-rsi-step__icon-glyph {
  width: 18px;
  height: 18px;
  color: inherit; }
  .identity-hub-rsi-step__icon-glyph.identity-hub-rsi-step__icon-glyph--lg {
    width: 20px;
    height: 20px; }

.identity-hub-rsi-step__bullet.identity-hub-guide-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0; }

.identity-hub-rsi-guide-link {
  color: #96badd;
  text-decoration: underline;
  transition: color 0.15s ease; }
  .identity-hub-rsi-guide-link:hover {
    color: #ffffff; }

.identity-hub-rsi-step__guide-text {
  margin: 0;
  font-size: 0.78rem;
  line-height: 1.45;
  color: #747b81;
  transition: color 0.2s ease; }

.identity-hub-rsi-step--accent .identity-hub-rsi-step__guide-text {
  color: #dfdfdf; }

.identity-hub-rsi-input-shell {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.52rem 0.72rem;
  border-radius: 7px;
  border: 1px solid rgba(70, 100, 128, 0.45);
  background: rgba(6, 12, 20, 0.65);
  transition: border-color 0.2s ease, box-shadow 0.2s ease; }
  .identity-hub-rsi-input-shell svg {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    color: rgba(140, 160, 182, 0.75);
    transition: color 0.2s ease; }
  .identity-hub-rsi-input-shell.identity-hub-rsi-input-shell--inactive {
    opacity: 0.55;
    pointer-events: none; }

.identity-hub-rsi-step--accent .identity-hub-rsi-input-shell:not(.identity-hub-rsi-input-shell--inactive) {
  border-color: rgba(74, 150, 220, 0.45);
  box-shadow: 0 0 0 1px rgba(40, 120, 200, 0.12); }
  .identity-hub-rsi-step--accent .identity-hub-rsi-input-shell:not(.identity-hub-rsi-input-shell--inactive) svg {
    color: #86b0d8; }

.identity-hub-rsi-textfield {
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-size: 0.87rem;
  color: #ffffff; }
  .identity-hub-rsi-textfield::placeholder {
    color: rgba(150, 160, 175, 0.75); }
  .identity-hub-rsi-textfield.identity-hub-rsi-textfield--readonly {
    cursor: default;
    font-family: 'FiraCode', monospace;
    font-size: 0.78rem; }

.identity-hub-rsi-btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  width: 100%;
  padding: 0.55rem 1rem;
  border-radius: 7px;
  font-size: 0.73rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  cursor: pointer;
  border: 1px solid transparent;
  color: rgba(230, 235, 240, 0.38);
  background: rgba(32, 48, 64, 0.55);
  transition: color 0.2s ease, background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease; }
  .identity-hub-rsi-btn-primary svg {
    width: 16px;
    height: 16px;
    color: inherit; }
  .identity-hub-rsi-btn-primary:disabled {
    opacity: 0.5;
    cursor: not-allowed; }
  .identity-hub-rsi-btn-primary.identity-hub-rsi-btn-primary--raised:not(:disabled) {
    border-color: rgba(72, 150, 220, 0.55);
    color: #ffffff;
    background: linear-gradient(145deg, #2e7ec9 0%, #245a9a 42%, #1a4270 100%);
    box-shadow: 0 2px 16px rgba(25, 80, 150, 0.35); }
    .identity-hub-rsi-btn-primary.identity-hub-rsi-btn-primary--raised:not(:disabled):hover {
      filter: brightness(1.05);
      box-shadow: 0 4px 20px rgba(30, 100, 180, 0.4); }
  .identity-hub-rsi-btn-primary.identity-hub-rsi-btn-primary--ghost:not(:disabled):hover {
    background: rgba(40, 60, 80, 0.65); }

.identity-hub-rsi-token-row {
  position: relative; }

.identity-hub-rsi-copy-hit {
  position: absolute;
  right: 0.55rem;
  top: 50%;
  transform: translateY(-50%);
  padding: 0;
  border: none;
  background: none;
  cursor: pointer; }
  .identity-hub-rsi-copy-hit.identity-hub-rsi-copy-hit--inactive {
    pointer-events: none;
    opacity: 0.4;
    cursor: not-allowed; }
  .identity-hub-rsi-copy-hit img {
    display: block;
    width: 20px;
    height: 20px; }

.identity-hub-rsi-msg {
  margin-top: 0.65rem;
  font-size: 0.8rem; }
  .identity-hub-rsi-msg.identity-hub-rsi-msg--timer {
    color: rgba(155, 170, 190, 0.85); }
  .identity-hub-rsi-msg.identity-hub-rsi-msg--success {
    color: #75cf78; }
  .identity-hub-rsi-msg.identity-hub-rsi-msg--error {
    color: #d12323; }
  .identity-hub-rsi-msg.identity-hub-rsi-msg--warning {
    color: #c78445; }

.identity-hub-guide-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px; }
  .identity-hub-guide-icon svg {
    display: block;
    width: 22px;
    height: 22px;
    color: #747b81;
    transition: color 0.2s ease; }

.identity-hub-rsi-step--accent .identity-hub-guide-icon svg {
  color: #96badd; }

.identity-hub-footer {
  display: flex;
  align-items: flex-start;
  align-items: center;
  gap: 0.95rem;
  margin-top: 1.85rem;
  max-width: 520px;
  padding: 0 0.5rem;
  box-sizing: border-box; }

.identity-hub-footer__icon {
  flex-shrink: 0;
  margin-top: 2px; }
  .identity-hub-footer__icon svg {
    display: block;
    width: 28px;
    height: 28px;
    color: #679cce;
    filter: drop-shadow(0 0 10px rgba(58, 120, 190, 0.35)); }

.identity-hub-footer__copy {
  font-size: 0.82rem;
  line-height: 1.55;
  color: #747b81; }

@media screen and (max-width: 540px) {
  .identity-hub {
    padding-top: 8vh; }
  .identity-hub-row {
    grid-template-columns: auto minmax(0, 1fr);
    grid-template-areas: 'icon body' 'actions actions';
    gap: 0.75rem 1rem;
    padding: 1.1rem 1.05rem; }
    .identity-hub-row .identity-hub-row__icon-wrap {
      grid-area: icon; }
    .identity-hub-row .identity-hub-row__body {
      grid-area: body; }
    .identity-hub-row .identity-hub-row__actions {
      grid-area: actions;
      justify-self: end;
      width: auto;
      max-width: 100%;
      flex-wrap: wrap;
      justify-content: flex-end; }
  .identity-hub-row__hint {
    max-width: 100%; }
  .identity-hub-rsi-head {
    grid-template-columns: auto minmax(0, 1fr);
    grid-template-areas: 'icon body' 'actions actions';
    gap: 0.75rem 1rem;
    padding: 1.1rem 1.05rem; }
    .identity-hub-rsi-head .identity-hub-row__icon-wrap {
      grid-area: icon; }
    .identity-hub-rsi-head .identity-hub-row__body {
      grid-area: body; }
    .identity-hub-rsi-head .identity-hub-row__actions,
    .identity-hub-rsi-head .identity-hub-rsi-head__tail {
      grid-area: actions;
      justify-self: end; }
  .identity-hub-rsi-step {
    grid-template-columns: 36px minmax(0, 1fr); }
  .identity-hub-rsi-step__rail-after {
    left: 17px; }
  .identity-hub-rsi-wizard__legend {
    padding-left: 0; }
  .identity-hub-rsi-wizard__heading-row {
    gap: 0.5rem; } }

.identity-hub-membership-notice {
  margin: 1.1rem;
  padding: 1.1rem 1.25rem;
  border-radius: 10px;
  border: 1px solid rgba(223, 223, 223, 0.22);
  background: rgba(22, 52, 71, 0.55);
  text-align: left; }
  .identity-hub-membership-notice--info {
    border-color: rgba(0, 72, 114, 0.45);
    background: rgba(0, 72, 114, 0.18); }
  .identity-hub-membership-notice--pending {
    border-color: rgba(117, 207, 120, 0.35);
    background: rgba(22, 52, 71, 0.65); }
  .identity-hub-membership-notice--blocked {
    border-color: rgba(209, 35, 35, 0.4);
    background: rgba(209, 35, 35, 0.1); }

.identity-hub-membership-notice__title {
  margin: 0 0 0.55rem;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #ffffff; }

.identity-hub-membership-notice__body {
  margin: 0;
  font-size: 0.88rem;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.88); }

.identity-hub-membership-notice__cta {
  display: inline-block;
  margin-top: 0.9rem;
  padding: 0.45rem 0.85rem;
  border-radius: 6px;
  border: 1px solid rgba(223, 223, 223, 0.35);
  background: rgba(0, 72, 114, 0.35);
  color: #ffffff;
  font-size: 0.82rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-decoration: none;
  text-transform: uppercase; }
  .identity-hub-membership-notice__cta:hover, .identity-hub-membership-notice__cta:focus-visible {
    background: rgba(0, 72, 114, 0.55);
    color: #ffffff;
    text-decoration: none; }

.identity-hub-membership-notice__guest-hint {
  margin: 0.85rem 0 0;
  font-size: 0.84rem;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.78); }

.identity-hub-guest-access {
  margin: 1rem;
  padding: 1.1rem 1.25rem;
  border-radius: 10px;
  border: 1px solid rgba(223, 223, 223, 0.22);
  background: rgba(22, 52, 71, 0.45);
  text-align: left; }

.identity-hub-guest-access__title {
  margin: 0 0 0.55rem;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #ffffff; }

.identity-hub-guest-access__status {
  margin: 0 0 0.75rem;
  font-size: 0.88rem;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.88); }
  .identity-hub-guest-access__status--pending strong {
    color: #75cf78; }
  .identity-hub-guest-access__status--rejected {
    color: rgba(209, 35, 35, 0.95); }

.identity-hub-guest-access__btn {
  display: inline-block;
  padding: 0.5rem 0.95rem;
  border-radius: 6px;
  border: 1px solid rgba(223, 223, 223, 0.35);
  background: rgba(0, 72, 114, 0.4);
  color: #ffffff;
  font-size: 0.82rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  cursor: pointer; }
  .identity-hub-guest-access__btn:hover:not(:disabled), .identity-hub-guest-access__btn:focus-visible:not(:disabled) {
    background: rgba(0, 72, 114, 0.6); }
  .identity-hub-guest-access__btn:disabled {
    opacity: 0.55;
    cursor: not-allowed; }

.guest-access-nav-wrapper {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  position: relative;
  z-index: 30001; }

.guest-access-chip-portal {
  position: fixed;
  top: 59px;
  left: 50%;
  transform: translateX(-50%);
  width: 1400px;
  max-width: 100vw;
  display: flex;
  justify-content: flex-end;
  padding-right: 312px;
  box-sizing: border-box;
  z-index: 30002; }

.guest-access-nav-trigger {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0 0.72rem;
  width: auto;
  height: 28px;
  z-index: 30001;
  border-radius: 999px;
  border: 1px solid #d8b493;
  background: #9b602a;
  color: #ffffff;
  cursor: pointer;
  user-select: none;
  box-shadow: 0 0 0 2px rgba(216, 180, 147, 0.12), 0 10px 26px rgba(66, 38, 12, 0.22);
  transition: background 0.15s ease, color 0.15s ease, transform 0.15s ease; }
  .guest-access-nav-trigger:hover, .guest-access-nav-trigger:focus-visible {
    background: #c78445; }
  .guest-access-nav-trigger--tilt {
    animation: guest-access-chip-tilt 10s linear infinite;
    will-change: transform; }

.guest-access-nav-trigger__icon {
  display: block;
  pointer-events: none; }

.guest-access-nav-trigger__label {
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  line-height: 1;
  text-transform: uppercase; }

@keyframes guest-access-chip-tilt {
  0%,
  84%,
  100% {
    transform: translateX(0); }
  85% {
    transform: translateX(0) rotate(0deg); }
  86% {
    transform: translateX(8px) rotate(2deg); }
  87% {
    transform: translateX(-8px) rotate(-2deg); }
  88% {
    transform: translateX(8px) rotate(2deg); }
  89% {
    transform: translateX(-6px) rotate(-1.5deg); }
  90% {
    transform: translateX(6px) rotate(1.5deg); }
  91% {
    transform: translateX(-3px) rotate(-0.8deg); }
  92% {
    transform: translateX(0) rotate(0deg); } }

.guest-access-nav-trigger__badge {
  position: absolute;
  top: -4px;
  right: -6px;
  min-width: 1rem;
  height: 1rem;
  padding: 0 0.22rem;
  border-radius: 999px;
  background: #d12323;
  color: #ffffff;
  font-size: 0.55rem;
  font-weight: 700;
  line-height: 1rem;
  text-align: center;
  pointer-events: none; }

.guest-access-popup-overlay {
  position: fixed;
  inset: 0;
  z-index: 30000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 4.5rem 1rem 1.5rem;
  background: rgba(28, 45, 56, 0.72); }

.guest-access-popup {
  width: min(560px, 100%);
  max-height: min(70vh, 640px);
  overflow: auto;
  border-radius: 14px;
  border: 1px solid rgba(216, 180, 147, 0.35);
  background: linear-gradient(180deg, rgba(66, 38, 12, 0.45) 0%, #163447 120px);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25), 0 22px 56px rgba(0, 0, 0, 0.5); }

.guest-access-popup__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.15rem 0.95rem;
  border-bottom: 1px solid rgba(216, 180, 147, 0.22); }

.guest-access-popup__header-text {
  min-width: 0; }

.guest-access-popup__eyebrow {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin: 0 0 0.2rem;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(216, 180, 147, 0.92); }

.guest-access-popup__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.15rem;
  height: 1.15rem;
  padding: 0 0.35rem;
  border-radius: 999px;
  background: rgba(155, 96, 42, 0.85);
  color: #ffffff;
  font-size: 0.62rem;
  letter-spacing: 0.02em; }

.guest-access-popup__title {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #ffffff;
  line-height: 1.2; }

.guest-access-popup__minimize {
  flex-shrink: 0;
  margin: 0;
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  border: 1px solid rgba(216, 180, 147, 0.4);
  background: rgba(66, 38, 12, 0.55);
  color: rgba(255, 255, 255, 0.92);
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease; }
  .guest-access-popup__minimize:hover, .guest-access-popup__minimize:focus-visible {
    background: rgba(155, 96, 42, 0.45);
    border-color: rgba(199, 132, 69, 0.55);
    color: #ffffff; }

.guest-access-popup__empty {
  margin: 0;
  padding: 1.25rem 1.1rem;
  color: rgba(255, 255, 255, 0.75);
  font-size: 0.88rem; }

.guest-access-popup__list {
  list-style: none;
  margin: 0;
  padding: 0.5rem 0; }

.guest-access-popup__item {
  padding: 0.9rem 1.15rem;
  border-bottom: 1px solid rgba(223, 223, 223, 0.1); }
  .guest-access-popup__item:last-child {
    border-bottom: none; }

.guest-access-popup__item-layout {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.85rem 1rem; }

.guest-access-popup__item-main {
  flex: 1 1 auto;
  min-width: 0; }

.guest-access-popup__identity {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem 0.55rem; }

.guest-access-popup__handle {
  font-weight: 700;
  color: #ffffff; }

.guest-access-popup__discord {
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.85rem; }

.guest-access-popup__refusal-badge {
  min-width: 1.15rem;
  height: 1.15rem;
  padding: 0 0.28rem;
  border-radius: 999px;
  background: rgba(209, 35, 35, 0.9);
  color: #ffffff;
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1.15rem;
  text-align: center; }

.guest-access-popup__meta {
  margin: 0.3rem 0 0;
  font-size: 0.76rem;
  line-height: 1.35;
  color: rgba(255, 255, 255, 0.52); }

.guest-access-popup__decision {
  display: flex;
  flex-shrink: 0;
  border-radius: 999px;
  overflow: hidden;
  border: 1px solid rgba(223, 223, 223, 0.28);
  background: rgba(12, 38, 55, 0.65);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06); }

.guest-access-popup__decision-btn {
  margin: 0;
  padding: 0.42rem 0.85rem;
  border: none;
  background: transparent;
  color: rgba(255, 255, 255, 0.78);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease; }
  .guest-access-popup__decision-btn:not(:last-child) {
    border-right: 1px solid rgba(223, 223, 223, 0.22); }
  .guest-access-popup__decision-btn:disabled {
    opacity: 0.45;
    cursor: not-allowed; }
  .guest-access-popup__decision-btn--grant:not(:disabled):hover, .guest-access-popup__decision-btn--grant:not(:disabled):focus-visible {
    background: rgba(117, 207, 120, 0.32);
    color: #ffffff;
    box-shadow: inset 0 0 0 1px rgba(117, 207, 120, 0.45); }
  .guest-access-popup__decision-btn--reject:not(:disabled):hover, .guest-access-popup__decision-btn--reject:not(:disabled):focus-visible {
    background: rgba(209, 35, 35, 0.28);
    color: #ffffff;
    box-shadow: inset 0 0 0 1px rgba(209, 35, 35, 0.42); }
  .guest-access-popup__decision-btn--grant:not(:disabled):active {
    background: rgba(117, 207, 120, 0.45); }
  .guest-access-popup__decision-btn--reject:not(:disabled):active {
    background: rgba(209, 35, 35, 0.4); }

.calendar-signup-intro-overlay {
  position: fixed;
  inset: 0;
  z-index: 30100;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 4.5rem 1rem 1.5rem;
  background: rgba(28, 45, 56, 0.78); }

.calendar-signup-intro {
  width: 100%;
  max-width: 520px;
  max-height: min(78vh, 720px);
  overflow: auto;
  border-radius: 16px;
  border: 1px solid rgba(90, 195, 255, 0.35);
  background: linear-gradient(180deg, rgba(58, 120, 180, 0.28) 0%, #163447 110px);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.28), 0 24px 64px rgba(0, 0, 0, 0.55); }
  .calendar-signup-intro::-webkit-scrollbar {
    width: 6px; }
  .calendar-signup-intro::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .calendar-signup-intro::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .calendar-signup-intro::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }

.calendar-signup-intro__header {
  padding: 1.15rem 1.25rem 0.85rem;
  border-bottom: 1px solid rgba(223, 223, 223, 0.14); }

.calendar-signup-intro__eyebrow {
  margin: 0 0 0.25rem;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(90, 195, 255, 0.95); }

.calendar-signup-intro__title {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  color: #ffffff;
  line-height: 1.2; }

.calendar-signup-intro__lead {
  margin: 0.55rem 0 0;
  font-size: 0.9rem;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.78); }

.calendar-signup-intro__steps {
  list-style: none;
  margin: 0;
  padding: 0.75rem 1.25rem 0.35rem;
  display: flex;
  flex-direction: column;
  gap: 0.85rem; }

.calendar-signup-intro__step {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem; }

.calendar-signup-intro__step-index {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.7rem;
  height: 1.7rem;
  border-radius: 999px;
  background: rgba(90, 195, 255, 0.22);
  border: 1px solid rgba(90, 195, 255, 0.45);
  color: #ffffff;
  font-size: 0.78rem;
  font-weight: 800;
  line-height: 1; }

.calendar-signup-intro__step-body {
  flex: 1 1 auto;
  min-width: 0; }

.calendar-signup-intro__step-title {
  margin: 0.15rem 0 0.25rem;
  font-size: 0.92rem;
  font-weight: 700;
  color: #ffffff; }

.calendar-signup-intro__step-text {
  margin: 0;
  font-size: 0.84rem;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.72); }

.calendar-signup-intro__demo {
  position: relative;
  margin-top: 0.75rem;
  padding: 0.85rem 0.9rem 0.7rem;
  border-radius: 12px;
  border: 1px dashed rgba(117, 207, 120, 0.45);
  background: rgba(12, 38, 55, 0.55);
  transition: border-color 0.2s ease, box-shadow 0.2s ease; }
  .calendar-signup-intro__demo--pulse {
    border-style: solid;
    border-color: rgba(117, 207, 120, 0.7);
    box-shadow: 0 0 0 3px rgba(117, 207, 120, 0.18); }

.calendar-signup-intro__demo-badge {
  position: absolute;
  top: -0.55rem;
  right: 0.75rem;
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  background: rgba(58, 120, 180, 0.95);
  color: #ffffff;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase; }

.calendar-signup-intro__demo-footer {
  display: flex;
  justify-content: center;
  padding: 0.35rem 0 0.15rem; }

.calendar-signup-intro__demo-btn {
  cursor: pointer; }

.calendar-signup-intro__demo-hint {
  margin: 0.55rem 0 0;
  text-align: center;
  font-size: 0.78rem;
  line-height: 1.35;
  color: rgba(117, 207, 120, 0.95); }
  .calendar-signup-intro__demo-hint--muted {
    color: rgba(255, 255, 255, 0.5); }

.calendar-signup-intro__footer {
  padding: 0.85rem 1.25rem 1.2rem;
  border-top: 1px solid rgba(223, 223, 223, 0.12);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.55rem; }

.calendar-signup-intro__cta {
  margin: 0;
  padding: 0.7rem 1rem;
  border-radius: 10px;
  border: 1px solid rgba(90, 195, 255, 0.5);
  background: rgba(90, 195, 255, 0.28);
  color: #ffffff;
  font-size: 0.88rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease; }
  .calendar-signup-intro__cta:hover, .calendar-signup-intro__cta:focus-visible {
    background: rgba(90, 195, 255, 0.4);
    border-color: rgba(90, 195, 255, 0.7); }

.calendar-signup-intro__footnote {
  margin: 0;
  text-align: center;
  font-size: 0.72rem;
  line-height: 1.35;
  color: rgba(255, 255, 255, 0.48); }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.sr-only {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important; }

.onboarding-landing-page {
  display: flex;
  flex-direction: column;
  gap: 14px; }

.onboarding-lp-stack {
  display: flex;
  flex-direction: column;
  gap: 14px; }

.onboarding-lp-card {
  background: #1e3042;
  border: 1px solid #1c2d38;
  border-radius: 10px;
  padding: 14px; }

.onboarding-lp-cardTitle {
  margin: 0 0 10px 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: #dfdfdf; }

.onboarding-lp-fieldGrid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px; }

.onboarding-lp-brandRow {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px; }
  @media (max-width: 900px) {
    .onboarding-lp-brandRow {
      grid-template-columns: 1fr; } }

.onboarding-lp-inputGroup {
  display: flex;
  align-items: stretch;
  width: 100%;
  border: 1px solid #1c2d38;
  border-radius: 8px;
  background: #172738;
  overflow: visible; }

.onboarding-lp-inputGroup .onboarding-lp-input {
  flex: 1 1 auto;
  width: 100%;
  border: 0;
  border-radius: 8px 0 0 8px;
  background: transparent; }

.onboarding-lp-inputGroup .onboarding-lp-colorPicker {
  flex: 0 0 auto;
  display: flex;
  align-items: stretch;
  justify-content: center;
  border-left: 1px solid #1c2d38;
  position: relative;
  z-index: 2;
  overflow: visible; }

.onboarding-lp-inputGroup .color-picker-container {
  display: flex;
  align-items: stretch;
  position: relative;
  overflow: visible; }

.onboarding-lp-inputGroup .color-picker-flex {
  display: flex;
  align-items: stretch; }

.onboarding-lp-inputGroup .colorPicker {
  width: 40px;
  height: 100%;
  border: 0;
  border-radius: 0 8px 8px 0;
  cursor: pointer; }

.onboarding-lp-inputGroup .colorPicker:disabled {
  cursor: not-allowed;
  opacity: 0.6; }

.onboarding-lp-inputWithPicker {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
  align-items: center; }

.onboarding-lp-colorPicker {
  display: flex;
  align-items: center;
  justify-content: center; }

.onboarding-lp-label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 0.85rem;
  color: #b8b8b8; }

.onboarding-lp-input,
.onboarding-lp-textarea {
  width: auto;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #1c2d38;
  background: #172738;
  color: #dfdfdf; }

.onboarding-lp-textarea {
  min-height: 120px;
  resize: vertical; }

.onboarding-lp-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 12px; }

.onboarding-lp-btn {
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid #1c2d38;
  background: #1c2d38;
  color: #dfdfdf;
  cursor: pointer; }
  .onboarding-lp-btn:hover:not(:disabled) {
    background: #2a3847; }
  .onboarding-lp-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed; }

.onboarding-lp-btnSecondary {
  background: transparent;
  border-color: #1c2d38; }
  .onboarding-lp-btnSecondary:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.06); }

.onboarding-lp-mediaPicker {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px; }

.onboarding-lp-dropRow {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
  align-items: center; }

.onboarding-lp-fileName {
  font-size: 0.85rem;
  color: #b8b8b8;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.onboarding-lp-previewWrap {
  border-radius: 10px;
  border: 1px solid #1c2d38;
  background: rgba(0, 0, 0, 0.25);
  overflow: hidden; }

.onboarding-lp-previewRatio {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9; }

.onboarding-lp-previewSvg,
.onboarding-lp-previewVideo {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%; }

.onboarding-lp-previewHint {
  margin: 8px 0 0 0;
  font-size: 0.82rem;
  color: #b8b8b8;
  line-height: 1.35; }

.onboarding-lp-progress {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 10px;
  margin-top: 10px; }

.onboarding-lp-bar {
  height: 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  overflow: hidden;
  border: 1px solid #1c2d38; }

.onboarding-lp-barFill {
  height: 100%;
  background: #004872;
  width: 0%; }
  .onboarding-lp-barFill.p25 {
    width: 25%; }
  .onboarding-lp-barFill.p50 {
    width: 50%; }
  .onboarding-lp-barFill.p75 {
    width: 75%; }
  .onboarding-lp-barFill.p100 {
    width: 100%; }

.onboarding-lp-message {
  font-size: 0.82rem;
  color: #b8b8b8; }

.onboarding-lp-emptyPreview {
  padding: 12px; }

.onboarding-ending {
  display: flex;
  flex-direction: column;
  gap: 14px; }

.onboarding-ending-threshold {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px; }

.onboarding-ending-threshold__label {
  font-size: 0.88rem;
  color: #b8b8b8;
  white-space: nowrap; }

.onboarding-ending-threshold__stepper {
  display: inline-flex;
  align-items: stretch;
  border: 1px solid #1c2d38;
  border-radius: 8px;
  overflow: hidden;
  background: #172738; }

.onboarding-ending-threshold__stepBtn {
  min-width: 40px;
  padding: 8px 10px;
  border: 0;
  border-right: 1px solid #1c2d38;
  background: #1c2d38;
  color: #dfdfdf;
  cursor: pointer;
  font-size: 1rem;
  line-height: 1; }
  .onboarding-ending-threshold__stepBtn:last-of-type {
    border-right: 0;
    border-left: 1px solid #1c2d38; }
  .onboarding-ending-threshold__stepBtn:hover:not(:disabled) {
    background: #2a3847; }
  .onboarding-ending-threshold__stepBtn:disabled {
    opacity: 0.6;
    cursor: not-allowed; }

.onboarding-ending-threshold__input {
  width: 3.2rem;
  padding: 8px 6px;
  border: 0;
  background: #172738;
  color: #dfdfdf;
  text-align: center;
  font-size: 0.95rem;
  font-variant-numeric: tabular-nums; }
  .onboarding-ending-threshold__input:disabled {
    opacity: 0.6;
    cursor: not-allowed; }

.onboarding-ending-contentTabs {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 2px;
  margin-bottom: 12px;
  border-bottom: 2px solid #1c2d38; }
  .onboarding-ending-contentTabs button {
    border: 0;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 8px 12px;
    min-width: 90px;
    color: #b8b8b8;
    background-color: #0c2637;
    cursor: pointer;
    font-size: 0.88rem; }
    .onboarding-ending-contentTabs button:hover {
      background-color: #2a3847; }
  .onboarding-ending-contentTabs .is-active {
    background-color: #2a3847;
    color: #dfdfdf;
    border-bottom: 2px solid #2a3847;
    margin-bottom: -2px; }

.onboarding-oe {
  display: flex;
  flex-direction: column;
  gap: 14px; }

.onboarding-oe-loadHint {
  font-size: 0.85rem;
  color: #b8b8b8;
  margin: 0 0 10px 0; }

.onboarding-oe-carouselRow {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 958px;
  max-width: 958px; }

.onboarding-oe-carouselViewport {
  flex: 1;
  min-width: 0;
  height: 90px;
  min-height: 90px;
  max-height: 90px;
  overflow-x: auto;
  overflow-y: hidden;
  overscroll-behavior-x: contain;
  padding: 0;
  box-sizing: border-box; }
  .onboarding-oe-carouselViewport::-webkit-scrollbar {
    height: 6px; }
  .onboarding-oe-carouselViewport::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px; }
  .onboarding-oe-carouselViewport::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .onboarding-oe-carouselViewport::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }

.onboarding-oe-carouselTrack {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 12px;
  box-sizing: border-box;
  height: calc( 90px - 5px - 6px);
  min-height: calc( 90px - 5px - 6px);
  max-height: calc( 90px - 5px - 6px);
  width: max-content;
  padding: 0 2px;
  margin-bottom: 5px; }

.onboarding-oe-carouselArrow {
  flex: 0 0 25px;
  width: 25px;
  align-self: flex-start;
  margin: 0;
  padding: 0;
  border-radius: 8px;
  border: 1px solid #1c2d38;
  background: rgba(0, 0, 0, 0.22);
  color: #dfdfdf;
  font-size: 1.45rem;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  display: grid;
  place-items: center;
  height: calc( 90px - 5px - 6px);
  min-height: calc( 90px - 5px - 6px);
  max-height: calc( 90px - 5px - 6px);
  box-sizing: border-box; }
  .onboarding-oe-carouselArrow:hover:not(:disabled) {
    border-color: rgba(223, 223, 223, 0.35);
    background: rgba(0, 72, 114, 0.12);
    color: #dfdfdf; }
  .onboarding-oe-carouselArrow:disabled {
    opacity: 0.32;
    cursor: default; }

.onboarding-oe-carouselAdd {
  flex: 0 0 100px;
  width: 100px;
  max-width: 100px;
  height: calc( 90px - 5px - 6px);
  min-height: calc( 90px - 5px - 6px);
  max-height: calc( 90px - 5px - 6px);
  align-self: flex-start;
  box-sizing: border-box; }

.onboarding-oe-sortableWrap {
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  box-sizing: border-box;
  height: calc( 90px - 5px - 6px);
  min-height: calc( 90px - 5px - 6px);
  max-height: calc( 90px - 5px - 6px);
  min-width: 248px;
  max-width: 312px; }

.onboarding-oe-cardGrip {
  flex: 0 0 30px;
  margin: 0;
  padding: 0;
  border-radius: 12px 0 0 12px;
  border: 1px solid #1c2d38;
  border-right: none;
  background: rgba(0, 0, 0, 0.35);
  color: #b8b8b8;
  cursor: grab;
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1;
  display: grid;
  place-items: center; }
  .onboarding-oe-cardGrip::before {
    content: '⋮\\A⋮';
    white-space: pre;
    line-height: 0.9;
    text-align: center; }
  .onboarding-oe-cardGrip:disabled {
    opacity: 0.45;
    cursor: not-allowed; }
  .onboarding-oe-cardGrip:hover:not(:disabled) {
    background: rgba(0, 72, 114, 0.15);
    color: #dfdfdf; }
  .onboarding-oe-cardGrip:active:not(:disabled) {
    cursor: grabbing; }

.onboarding-oe-sortableWrap:has(.onboarding-oe-card.is-active) .onboarding-oe-cardGrip {
  border-top: 1px solid rgba(58, 120, 180, 0.75);
  border-left: 1px solid rgba(58, 120, 180, 0.75);
  border-bottom: 1px solid rgba(58, 120, 180, 0.75); }

.onboarding-oe-sortableWrap .onboarding-oe-card {
  flex: 1 1 auto;
  align-self: stretch;
  min-width: 0;
  max-width: none;
  border-radius: 0 12px 12px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box; }

.onboarding-oe-card {
  flex: 0 0 auto;
  min-width: auto;
  max-width: 280px;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid transparent;
  border-top: 1px solid rgba(223, 223, 223, 0.25);
  border-right: 1px solid rgba(223, 223, 223, 0.25);
  border-bottom: 1px solid rgba(223, 223, 223, 0.25);
  background: #1e3042;
  color: #dfdfdf;
  text-align: left;
  cursor: pointer; }
  .onboarding-oe-card:hover:not(:disabled) {
    border: 1px solid transparent;
    border-top: 1px solid rgba(223, 223, 223, 0.45);
    border-right: 1px solid rgba(223, 223, 223, 0.45);
    border-bottom: 1px solid rgba(223, 223, 223, 0.45); }
  .onboarding-oe-card:disabled {
    opacity: 0.6;
    cursor: not-allowed; }
  .onboarding-oe-card.is-active {
    border: 1px solid transparent;
    border-top: 1px solid rgba(58, 120, 180, 0.9);
    border-right: 1px solid rgba(58, 120, 180, 0.9);
    border-bottom: 1px solid rgba(58, 120, 180, 0.9);
    box-shadow: 0 0 0 2px rgba(58, 120, 180, 0.25); }
  .onboarding-oe-card.is-disabled {
    opacity: 0.45; }

.onboarding-oe-cardTitle {
  font-size: 0.95rem;
  font-weight: 700;
  margin: 0 0 6px 0; }

.onboarding-oe-cardMeta {
  font-size: 0.82rem;
  color: #b8b8b8; }

.onboarding-oe-cardAdd {
  border: 1px dashed rgba(223, 223, 223, 0.25);
  display: grid;
  place-items: center;
  text-align: center;
  background: rgba(0, 0, 0, 0.18); }
  .onboarding-oe-cardAdd:hover:not(:disabled) {
    border: 1px dashed rgba(223, 223, 223, 0.45); }

.onboarding-oe-addPlus {
  font-size: 1.6rem;
  font-weight: 800;
  line-height: 1; }

.onboarding-oe-addLabel {
  font-size: 0.85rem;
  color: #b8b8b8;
  margin-top: 6px; }

.onboarding-oe-body {
  display: grid;
  grid-template-columns: 220px 1fr;
  gap: 14px;
  align-items: start; }
  @media (max-width: 980px) {
    .onboarding-oe-body {
      grid-template-columns: 1fr; } }

.onboarding-oe-menu {
  display: flex;
  flex-direction: column;
  gap: 6px; }

.onboarding-oe-menuItem {
  width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid transparent;
  background: rgba(0, 0, 0, 0.18);
  color: #dfdfdf;
  font-size: 0.88rem;
  font-weight: 600;
  text-align: left;
  cursor: pointer; }
  .onboarding-oe-menuItem:hover {
    border-color: rgba(223, 223, 223, 0.2); }
  .onboarding-oe-menuItem.is-active {
    border-color: rgba(0, 72, 114, 0.75);
    background: rgba(0, 72, 114, 0.12); }
  .onboarding-oe-menuItem:disabled {
    opacity: 0.55;
    cursor: not-allowed; }
    .onboarding-oe-menuItem:disabled:hover {
      border-color: transparent; }

.onboarding-oe-menu,
.onboarding-oe-content {
  background: #1e3042;
  border: 1px solid #1c2d38;
  border-radius: 12px;
  padding: 14px; }

.onboarding-oe-menuTitle {
  font-size: 0.9rem;
  font-weight: 700;
  color: #dfdfdf;
  margin: 0 0 10px 0; }

.onboarding-oe-editorBlock {
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-top: 10px; }

.onboarding-oe-sectionLabel {
  font-size: 0.9rem;
  font-weight: 700;
  color: #dfdfdf;
  margin: 14px 0 10px 0; }

.onboarding-oe-label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 10px;
  font-size: 0.85rem;
  color: #b8b8b8; }

.onboarding-oe-input,
.onboarding-oe-textarea {
  width: auto;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #1c2d38;
  background: #172738;
  color: #dfdfdf; }

.onboarding-oe-textarea {
  min-height: 90px;
  resize: vertical; }

.onboarding-oe-toggleRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 0;
  border-top: 1px solid rgba(28, 45, 56, 0.8);
  border-bottom: 1px solid rgba(28, 45, 56, 0.8);
  margin: 8px 0 12px 0; }

.onboarding-oe-toggleText {
  flex: 1;
  min-width: 0; }

.onboarding-oe-toggleLabel {
  font-size: 0.85rem;
  font-weight: 700;
  color: #dfdfdf; }

.onboarding-oe-toggleHint {
  font-size: 0.8rem;
  color: #b8b8b8;
  margin-top: 2px; }

.onboarding-oe-switch {
  position: relative;
  width: 44px;
  height: 26px;
  display: inline-flex; }

.onboarding-oe-switch input {
  opacity: 0;
  width: 0;
  height: 0; }

.onboarding-oe-slider {
  position: absolute;
  inset: 0;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid #1c2d38;
  transition: background 160ms ease, border-color 160ms ease; }

.onboarding-oe-slider:before {
  content: '';
  position: absolute;
  height: 20px;
  width: 20px;
  left: 3px;
  top: 2px;
  border-radius: 999px;
  background: #dfdfdf;
  transition: transform 160ms ease; }

.onboarding-oe-switch input:checked + .onboarding-oe-slider {
  background: rgba(0, 72, 114, 0.35);
  border-color: rgba(0, 72, 114, 0.6); }

.onboarding-oe-switch input:checked + .onboarding-oe-slider:before {
  transform: translateX(18px); }

.onboarding-oe-typeGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px; }

.onboarding-oe-typeCard {
  padding: 10px 10px;
  border-radius: 10px;
  border: 1px solid #1c2d38;
  background: rgba(0, 0, 0, 0.18);
  color: #dfdfdf;
  cursor: pointer;
  text-align: left; }
  .onboarding-oe-typeCard:hover:not(:disabled) {
    border-color: rgba(223, 223, 223, 0.35); }
  .onboarding-oe-typeCard:disabled {
    opacity: 0.6;
    cursor: not-allowed; }
  .onboarding-oe-typeCard.is-active {
    border-color: rgba(0, 72, 114, 0.9);
    box-shadow: 0 0 0 2px rgba(0, 72, 114, 0.25); }

.onboarding-oe-generalActions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid rgba(28, 45, 56, 0.8); }

.onboarding-oe-unsavedHint {
  font-size: 0.82rem;
  color: #b8b8b8;
  max-width: 42ch;
  line-height: 1.35; }

.onboarding-oe-savedHint {
  font-size: 0.82rem;
  color: rgba(90, 160, 92, 0.95);
  line-height: 1.35; }

.onboarding-oe-generalActionsLeft {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0; }

.onboarding-oe-contentTitleRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin: 0 0 8px 0; }

.onboarding-oe-contentTitle {
  font-size: 0.95rem;
  font-weight: 800;
  margin: 0 0 8px 0;
  color: #dfdfdf; }

.onboarding-oe-contentTitle--inRow {
  margin-bottom: 0;
  flex: 1;
  min-width: 0; }

.onboarding-oe-minimumDwell {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding-right: 20px;
  margin-left: auto; }

.onboarding-oe-minimumDwell-pill {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 6px 12px 6px 8px;
  border-radius: 999px;
  border: 1px solid rgba(0, 72, 114, 0.95);
  background: transparent; }

.onboarding-oe-minimumDwell-clock {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #004872;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center; }

.onboarding-oe-minimumDwell-clockSvg {
  width: 14px;
  height: 14px;
  display: block; }

.onboarding-oe-minimumDwell-pillLabel {
  font-size: 0.875rem;
  font-weight: 600;
  color: #9eb9c9;
  white-space: nowrap;
  letter-spacing: 0.01em; }

.onboarding-oe-switch.onboarding-oe-switch--dwellPill {
  position: relative;
  width: 42px;
  height: 24px;
  flex-shrink: 0; }

.onboarding-oe-switch.onboarding-oe-switch--dwellPill input {
  opacity: 0;
  width: 0;
  height: 0; }

.onboarding-oe-slider.onboarding-oe-slider--dwellPill {
  position: absolute;
  inset: 0;
  border-radius: 999px;
  background: rgba(0, 72, 114, 0.35);
  border: 1px solid rgba(0, 72, 114, 0.65);
  transition: background 160ms ease, border-color 160ms ease; }

.onboarding-oe-slider.onboarding-oe-slider--dwellPill:before {
  content: '';
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  top: 2px;
  border-radius: 999px;
  background: #fff;
  transition: transform 160ms ease; }

.onboarding-oe-switch.onboarding-oe-switch--dwellPill input:checked + .onboarding-oe-slider--dwellPill {
  background: #004872;
  border-color: #004872; }

.onboarding-oe-switch.onboarding-oe-switch--dwellPill input:checked + .onboarding-oe-slider--dwellPill:before {
  transform: translateX(16px); }

.onboarding-oe-switch.onboarding-oe-switch--dwellPill input:focus-visible + .onboarding-oe-slider--dwellPill {
  outline: 2px solid rgba(0, 72, 114, 0.85);
  outline-offset: 2px; }

.onboarding-oe-minimumDwell-timeGroup {
  display: inline-flex;
  align-items: center;
  gap: 6px; }

.onboarding-oe-dwellTimeInput {
  box-sizing: border-box;
  width: 3.35rem;
  min-width: 0;
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid rgba(0, 72, 114, 0.75);
  background: rgba(0, 0, 0, 0.28);
  color: #dfdfdf;
  font-size: 0.95rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  text-align: center;
  line-height: 1.2; }
  .onboarding-oe-dwellTimeInput:focus {
    outline: none;
    border-color: #004872;
    box-shadow: 0 0 0 1px rgba(0, 72, 114, 0.45); }
  .onboarding-oe-dwellTimeInput:disabled {
    opacity: 0.55;
    cursor: not-allowed; }

.onboarding-oe-dwellTimeInput.onboarding-oe-dwellTimeInput--minutes {
  width: 4.1rem; }

.onboarding-oe-minimumDwellSep {
  font-size: 1.05rem;
  font-weight: 700;
  color: #dfdfdf;
  align-self: center;
  padding: 0 2px;
  user-select: none; }

.onboarding-oe-contentHint {
  font-size: 0.82rem;
  color: #b8b8b8;
  margin: 0 0 12px 0; }

.onboarding-oe-contentBox {
  padding: 12px;
  border-radius: 10px;
  border: 1px solid #1c2d38;
  background: rgba(0, 0, 0, 0.16);
  color: #dfdfdf;
  font-size: 0.85rem;
  display: grid;
  gap: 6px; }

.onboarding-oe-contentPanel {
  margin-top: 10px; }

.onboarding-oe-structureLoading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 120px;
  padding: 16px; }

.onboarding-oe-structureDiagram {
  overflow-x: auto;
  max-width: 100%;
  padding: 8px 0; }

.onboarding-oe-structurePanel {
  display: flex;
  flex-direction: column;
  gap: 16px; }

.onboarding-oe-structureTags {
  display: flex;
  flex-direction: column;
  gap: 10px; }

.onboarding-oe-tagChips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  min-height: 30px; }

.onboarding-oe-tagChip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
  padding: 6px 8px 6px 10px;
  border: 1px solid rgba(223, 223, 223, 0.18);
  border-radius: 999px;
  background: rgba(28, 45, 56, 0.72);
  color: #dfdfdf;
  font-size: 0.82rem; }

.onboarding-oe-tagChipText {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.onboarding-oe-tagChipRemove {
  display: inline-grid;
  place-items: center;
  width: 18px;
  height: 18px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  color: #dfdfdf;
  cursor: pointer;
  line-height: 1; }
  .onboarding-oe-tagChipRemove:hover:not(:disabled) {
    background: rgba(209, 35, 35, 0.82); }
  .onboarding-oe-tagChipRemove:disabled {
    opacity: 0.55;
    cursor: not-allowed; }

.onboarding-oe-structureActions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px; }

.onboarding-oe-placeholder {
  padding: 16px;
  border-radius: 10px;
  border: 1px dashed #1c2d38;
  color: #b8b8b8;
  font-size: 0.88rem; }

.onboarding-oe-sourcePanel {
  display: flex;
  flex-direction: column;
  gap: 10px; }

.onboarding-oe-sourceActions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px; }

.onboarding-oe-select {
  width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #1c2d38;
  background: #172738;
  color: #dfdfdf; }

.onboarding-oe-listError {
  margin: 0;
  font-size: 0.82rem;
  color: #d12323; }

.onboarding-oe-lexicalRoot {
  margin-top: 6px; }

.onboarding-oe-lexicalFooter {
  margin-top: 12px; }

.onboarding-oe-mediaPanel {
  display: flex;
  flex-direction: column;
  gap: 12px; }

.onboarding-oe-mediaHint {
  margin: 0;
  font-size: 0.82rem;
  color: #b8b8b8;
  line-height: 1.45; }

.onboarding-oe-mediaHint--sub {
  font-size: 0.78rem;
  opacity: 0.92; }

.onboarding-oe-mediaRow {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap; }

.onboarding-oe-fileName {
  font-size: 0.85rem;
  color: #b8b8b8;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex: 1; }

.onboarding-oe-mediaPreviewWrap {
  border-radius: 10px;
  border: 1px solid #1c2d38;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.2); }

.onboarding-oe-mediaPreviewRatio {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9; }

.onboarding-oe-mediaPreviewImg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; }

.onboarding-oe-mediaPreviewVideo {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000; }

.onboarding-oe-mediaPreviewEmpty {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  font-size: 0.85rem;
  color: #b8b8b8; }

.onboarding-oe-mediaGallery-strip {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 8px;
  align-items: flex-start;
  overflow-x: auto;
  padding: 2px 0 10px;
  margin-bottom: 2px; }

.onboarding-oe-mediaGallery-thumb {
  position: relative;
  flex: 0 0 auto;
  width: 72px;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 4px;
  padding: 4px;
  border-radius: 8px;
  border: 1px solid transparent;
  background: rgba(0, 0, 0, 0.15); }
  .onboarding-oe-mediaGallery-thumb.is-active {
    border-color: rgba(90, 170, 240, 0.7);
    background: rgba(40, 100, 160, 0.22); }

.onboarding-oe-mediaGallery-dragHandle {
  flex: 0 0 14px;
  width: 14px;
  min-width: 14px;
  border: none;
  border-radius: 4px;
  background: rgba(58, 110, 150, 0.35);
  color: #dfdfdf;
  font-size: 10px;
  line-height: 1;
  cursor: grab;
  padding: 2px 0;
  align-self: stretch; }
  .onboarding-oe-mediaGallery-dragHandle:disabled {
    opacity: 0.35;
    cursor: not-allowed; }
  .onboarding-oe-mediaGallery-dragHandle:active:not(:disabled) {
    cursor: grabbing; }

.onboarding-oe-mediaGallery-thumbFrame {
  position: relative;
  flex: 1;
  min-width: 0; }

.onboarding-oe-mediaGallery-thumbSelect {
  display: block;
  width: 100%;
  padding: 0;
  border: none;
  border-radius: 6px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.35);
  cursor: pointer; }
  .onboarding-oe-mediaGallery-thumbSelect:disabled {
    opacity: 0.5;
    cursor: default; }

.onboarding-oe-mediaGallery-thumbImg {
  display: block;
  width: 100%;
  height: 48px;
  object-fit: cover; }

.onboarding-oe-mediaGallery-thumbDelete {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 22px;
  height: 22px;
  border: none;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.55);
  color: #dfdfdf;
  font-size: 15px;
  line-height: 1;
  cursor: pointer;
  display: grid;
  place-items: center; }
  .onboarding-oe-mediaGallery-thumbDelete:hover:not(:disabled) {
    background: rgba(120, 40, 40, 0.75); }
  .onboarding-oe-mediaGallery-thumbDelete:disabled {
    opacity: 0.35;
    cursor: not-allowed; }

.onboarding-oe-mediaPreviewWrap--galleryMain {
  margin-top: 0; }

.onboarding-oe-mediaPreviewRatio--galleryMain {
  position: relative; }

.onboarding-oe-mediaMainDelete {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.55);
  color: #dfdfdf;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  display: grid;
  place-items: center; }
  .onboarding-oe-mediaMainDelete:hover:not(:disabled) {
    background: rgba(120, 40, 40, 0.82); }
  .onboarding-oe-mediaMainDelete:disabled {
    opacity: 0.35;
    cursor: not-allowed; }

.onboarding-oe-mediaActions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px; }

.onboarding-oe-mediaMsg {
  margin: 0;
  font-size: 0.82rem;
  color: #b8b8b8; }

.onboarding-oe-mediaMsg--warn {
  color: #e8a854; }

.onboarding-oe-btn {
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid #1c2d38;
  background: #1c2d38;
  color: #dfdfdf;
  cursor: pointer; }
  .onboarding-oe-btn:hover:not(:disabled) {
    background: #2a3847; }
  .onboarding-oe-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed; }

.onboarding-oe-btnSecondary {
  background: transparent;
  border-color: #1c2d38; }
  .onboarding-oe-btnSecondary:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.06); }

.members-onboarding-welcome {
  box-sizing: border-box;
  width: 100%;
  margin-top: 110px;
  max-width: 1460px;
  margin-left: auto;
  margin-right: auto; }

.members-onboarding-welcome__hero {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  min-height: min(68vh, 720px);
  padding: 2rem 1.35rem 2.5rem;
  box-sizing: border-box;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  isolation: isolate;
  background-color: #172738;
  border: 1px solid rgba(52, 90, 120, 0.4);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06), 0 8px 28px rgba(0, 0, 0, 0.35); }
  .members-onboarding-welcome__hero:not(.members-onboarding-welcome__hero--has-media) {
    background-image: linear-gradient(105deg, rgba(21, 28, 36, 0.94) 0%, rgba(23, 39, 56, 0.72) 42%, rgba(30, 48, 66, 0.4) 100%);
    background-size: cover;
    background-position: center; }
  @media screen and (min-width: 900px) {
    .members-onboarding-welcome__hero {
      min-height: min(72vh, 780px);
      padding: 2.5rem 2.25rem 3rem; } }

.members-onboarding-welcome__media-layer {
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  transform: translateZ(0);
  --mob-focal-x: 50%;
  --mob-focal-y: 50%; }

.members-onboarding-welcome__media-el {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: var(--mob-focal-x) var(--mob-focal-y); }

.members-onboarding-welcome__media-el--video {
  pointer-events: none; }

/* Dégradé lisibilité : moitié gauche assombrie, droite quasi transparente (média visible).
   translateZ sur le scrim garde l’overlay au-dessus des <video> dans certains navigateurs. */
.members-onboarding-welcome__scrim {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  width: 100%;
  height: 100%;
  transform: translateZ(0);
  background: linear-gradient(90deg, rgba(21, 28, 36, 0.99) 0%, rgba(21, 28, 36, 0.82) 28%, rgba(23, 39, 56, 0.38) 38%, rgba(23, 39, 56, 0.06) 45%, rgba(0, 0, 0, 0) 50%, transparent 100%); }

.members-onboarding-welcome__hero--has-media .members-onboarding-welcome__scrim {
  background: linear-gradient(90deg, rgba(2, 6, 12, 0.99) 0%, rgba(6, 12, 20, 0.91) 32%, rgba(10, 18, 28, 0.48) 46%, rgba(12, 22, 34, 0.08) 49.5%, rgba(12, 22, 34, 0) 51%, transparent 55%, transparent 100%); }

.members-onboarding-welcome__hero-inner {
  position: relative;
  z-index: 2;
  max-width: 36rem;
  text-align: left; }

.members-onboarding-welcome__loading,
.members-onboarding-welcome__error {
  margin: 0 0 0.75rem;
  font-size: 0.88rem; }

.members-onboarding-welcome__error {
  color: #d12323; }

.members-onboarding-welcome__eyebrow {
  margin: 0 0 0.35rem;
  font-size: 0.9rem;
  font-weight: 800;
  letter-spacing: 0.28em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.85); }

.members-onboarding-welcome__title {
  margin: 0 0 0.75rem;
  padding: 0;
  font-family: 'GoodTimes', 'Lato', sans-serif;
  font-size: clamp(1.65rem, 4.5vw, 2.35rem);
  font-weight: 700;
  line-height: 1.12;
  letter-spacing: 0.06em;
  text-transform: uppercase; }

.members-onboarding-welcome__title-stack {
  display: inline; }

.members-onboarding-welcome__brand-a {
  color: var(--mob-brand-a, #dfdfdf); }

.members-onboarding-welcome__brand-b {
  color: var(--mob-brand-b, #dfdfdf); }

.members-onboarding-welcome__brand-spacer {
  white-space: pre; }

.members-onboarding-welcome__tagline {
  margin: 0 0 1rem;
  font-size: 1rem;
  font-weight: 600;
  color: rgba(184, 184, 184, 0.98); }

.members-onboarding-welcome__lead {
  margin: 0 0 1.65rem;
  font-size: 0.95rem;
  line-height: 1.55;
  color: rgba(223, 223, 223, 0.88);
  max-width: 34rem;
  white-space: pre-line; }

/* Bouton type bandeau sci‑fi : coin biseauté à droite (couleurs du thème, pas celles du mock image) */
.members-onboarding-welcome__cta {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.65rem 1.35rem 0.65rem 1.25rem;
  border: none;
  cursor: pointer;
  font-family: inherit;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #ffffff;
  background: linear-gradient(180deg, #dc2d2d, #8d1e1e);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.35), 0 6px 20px rgba(0, 0, 0, 0.35);
  clip-path: polygon(0 0, calc(100% - 18px) 0, 100% 50%, calc(100% - 18px) 100%, 0 100%);
  transition: filter 0.15s ease, box-shadow 0.15s ease; }
  .members-onboarding-welcome__cta:hover {
    filter: brightness(1.08);
    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.35), 0 8px 26px rgba(0, 0, 0, 0.45); }
  .members-onboarding-welcome__cta:focus-visible {
    outline: 2px solid rgba(58, 120, 180, 0.85);
    outline-offset: 3px; }

.members-onboarding-welcome__cta-label {
  position: relative;
  top: 0.04em; }

.members-onboarding-welcome__cta-arrow {
  font-size: 1.05em;
  font-weight: 700;
  opacity: 0.95; }

.members-onboarding-hero {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  background: linear-gradient(165deg, rgba(30, 48, 66, 0.7) 0%, rgba(23, 39, 56, 0.9) 100%), rgba(23, 39, 56, 0.95);
  border: 2px solid rgba(90, 195, 255, 0.25);
  border-radius: 10px;
  padding: 0.9rem 1rem 1rem;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.28) inset, 0 10px 26px rgba(0, 0, 0, 0.32); }

.members-onboarding-hero__inner {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 0.85rem; }

.members-onboarding-hero__identity {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex: 0 0 26%;
  min-width: 0; }

.members-onboarding-hero__avatar-stack {
  position: relative;
  width: 108px;
  height: 108px;
  flex-shrink: 0;
  margin-bottom: 0; }

.members-onboarding-hero__avatar-discord {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: auto;
  height: 88px;
  border-radius: 50%;
  object-fit: cover;
  z-index: 1; }

.members-onboarding-hero__avatar-frame {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 108px;
  height: 108px;
  object-fit: contain;
  z-index: 2;
  pointer-events: none; }

.members-onboarding-hero__assignment {
  margin: 0.3rem 0 0;
  font-size: 0.88rem;
  line-height: 1.3;
  color: #5ac3ff;
  font-style: italic; }

.members-onboarding-hero__divider {
  width: 1px;
  flex-shrink: 0;
  background: linear-gradient(180deg, transparent 0%, rgba(58, 120, 180, 0.5) 14%, rgba(58, 120, 180, 0.5) 86%, transparent 100%); }

.members-onboarding-hero__meta {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem; }

.members-onboarding-hero__rank-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.65rem; }

.members-onboarding-hero__rank-icon-slot {
  flex-shrink: 0;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center; }

.members-onboarding-hero__rank-icon {
  max-width: auto;
  max-height: 52px;
  width: auto;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.4)); }

.members-onboarding-hero__rank-icon--empty {
  width: 42px;
  height: 50px;
  border: 1px dashed rgba(58, 120, 180, 0.35);
  border-radius: 4px; }

.members-onboarding-hero__rank-text {
  flex: 1;
  min-width: 0; }

.members-onboarding-hero__rank-name {
  font-size: 0.98rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 0.12rem;
  line-height: 1.2;
  word-break: break-word; }

.members-onboarding-hero__pay-grade {
  margin: 0;
  font-size: 0.74rem;
  color: rgba(223, 223, 223, 0.85); }

.members-onboarding-ending {
  box-sizing: border-box;
  width: 100%;
  margin-top: 110px;
  max-width: 1460px;
  margin-left: auto;
  margin-right: auto; }

.members-onboarding-ending__stage {
  position: relative;
  isolation: isolate;
  overflow: hidden;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  min-height: min(68vh, 720px);
  padding: 2rem 1.35rem 2.5rem;
  box-sizing: border-box;
  background-color: #151c24;
  border: 1px solid rgba(52, 90, 120, 0.55);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.45) inset, 0 12px 40px rgba(0, 0, 0, 0.45); }
  .members-onboarding-ending__stage:not(.members-onboarding-ending__stage--has-media) {
    background-image: radial-gradient(120% 90% at 50% 100%, rgba(30, 48, 66, 0.55) 0%, rgba(23, 39, 56, 0.92) 45%, #151c24 100%); }

.members-onboarding-ending__media-layer {
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  transform: translateZ(0);
  --mob-focal-x: 50%;
  --mob-focal-y: 50%; }

.members-onboarding-ending__media-el {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: var(--mob-focal-x) var(--mob-focal-y); }

.members-onboarding-ending__media-el--video {
  pointer-events: none; }

/* Bottom-heavy vignette + top fade + bande gauche assombrie (50% → 0 au centre horizontal) */
.members-onboarding-ending__scrim {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  width: 100%;
  height: 100%;
  transform: translateZ(0);
  background: linear-gradient(90deg, black 0%, rgba(0, 0, 0, 0) 50%), linear-gradient(180deg, rgba(2, 8, 16, 0.88) 0%, rgba(4, 12, 22, 0.35) 28%, transparent 52%), radial-gradient(120% 75% at 50% 100%, rgba(0, 0, 0, 0.72) 0%, rgba(0, 0, 0, 0.38) 42%, rgba(0, 0, 0, 0) 72%); }

.members-onboarding-ending__dashboardDock {
  position: absolute;
  z-index: 2;
  /* Moins de marge à gauche sur étroits : évite de tout tasser dans la zone vidéo (sans breakpoint) */
  left: clamp(0.75rem, 12vw, 11rem);
  right: 0;
  top: 0;
  bottom: 0;
  padding: 2rem 2rem 2rem 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  height: 100%;
  pointer-events: none;
  width: auto;
  min-width: 0; }

.members-onboarding-ending__heroRow {
  /* 1fr = espace restant à gauche ; hero aligné à droite de cette zone ; events en colonne auto */
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-rows: 1fr auto;
  align-items: start;
  gap: 1rem;
  width: 100%;
  height: 100%;
  max-width: 100%;
  min-width: 0;
  pointer-events: auto; }

.members-onboarding-ending__heroStack {
  box-sizing: border-box;
  pointer-events: auto;
  justify-self: end;
  grid-column: 1;
  grid-row: 1;
  /* Remplir la 1re colonne du grid jusqu’au plafond (sinon width:auto = contenu seul, max-width ne sert à rien) */
  width: 100%;
  max-width: min(590px, 100%);
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem; }

.members-onboarding-ending__websiteCard {
  width: 100%;
  max-width: min(590px, 100%);
  min-width: 0;
  box-sizing: border-box;
  pointer-events: auto;
  z-index: 3;
  grid-column: 1;
  grid-row: 2;
  justify-self: end;
  align-self: end;
  display: flex;
  flex-direction: column;
  gap: 1rem; }

/* Même largeur que le bouton (colonne websiteCard) */
.members-onboarding-ending__websiteTextCard {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding: 0.95rem 1rem;
  border-radius: 10px;
  border: 2px solid rgba(90, 195, 255, 0.25);
  background: linear-gradient(165deg, rgba(30, 48, 66, 0.35) 0%, rgba(0, 48, 77, 0.5) 100%), rgba(23, 39, 56, 0.78);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.22) inset, 0 8px 22px rgba(0, 0, 0, 0.28);
  display: flex;
  flex-direction: column;
  gap: 0.65rem; }

.members-onboarding-ending__websiteText {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.45;
  color: rgba(223, 223, 223, 0.92);
  white-space: pre-line; }

.members-onboarding-ending__officerRows {
  display: flex;
  flex-direction: column;
  gap: 0.5rem; }

.members-onboarding-ending__officerRow {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 0.85rem; }

.members-onboarding-ending__officerChip {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 0.35rem;
  min-width: 0; }

.members-onboarding-ending__officerRankIcon {
  width: auto;
  max-height: 1.35rem;
  height: 1.35rem;
  object-fit: contain;
  flex-shrink: 0; }

.members-onboarding-ending__officerRankIcon--empty {
  display: inline-block;
  width: 1.1rem;
  height: 1.1rem;
  box-sizing: border-box;
  border: 1px dashed rgba(223, 223, 223, 0.25);
  border-radius: 3px; }

.members-onboarding-ending__officerName {
  font-size: 0.86rem;
  font-weight: 700;
  line-height: 1.3;
  color: #ffffff;
  white-space: nowrap; }

.members-onboarding-ending__websiteButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  padding: 0.9rem 1rem;
  border-radius: 10px;
  cursor: pointer;
  font-family: inherit;
  text-decoration: none;
  text-transform: uppercase;
  color: #dca9a9;
  font-weight: 800;
  font-size: 1rem;
  line-height: 1.2;
  border: 1px solid #9e2222;
  background: linear-gradient(180deg, #49121285 0%, #9e222275 50%, #49121285 100%);
  transition: transform 0.1s ease, filter 0.15s ease; }
  .members-onboarding-ending__websiteButton:hover {
    filter: brightness(1.05); }
  .members-onboarding-ending__websiteButton:active {
    transform: translateY(1px); }
  .members-onboarding-ending__websiteButton:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(223, 223, 223, 0.18); }

/* Bloc unique : en-tête + mini-cards événements */
.members-onboarding-ending-events {
  box-sizing: border-box;
  width: min(22rem, 100%);
  max-width: 22rem;
  min-width: 0;
  max-height: 367px;
  grid-column: 2;
  grid-row: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden; }

.members-onboarding-ending-events__status,
.members-onboarding-ending-events__empty {
  margin: 0;
  padding: 0.35rem 0.25rem;
  font-size: 0.82rem;
  line-height: 1.4;
  color: rgba(223, 223, 223, 0.88); }

.members-onboarding-ending-events__stack {
  display: flex;
  flex-direction: column;
  gap: 0.72rem;
  min-height: 0;
  flex: 1 1 auto;
  overflow-y: auto; }
  .members-onboarding-ending-events__stack::-webkit-scrollbar {
    width: 6px; }
  .members-onboarding-ending-events__stack::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .members-onboarding-ending-events__stack::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .members-onboarding-ending-events__stack::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }

.members-onboarding-ending-events__card {
  box-sizing: border-box;
  border-radius: 8px;
  border: 2px solid rgba(90, 195, 255, 0.25);
  background: #172738;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.18) inset; }

.members-onboarding-ending-events__card--heading {
  padding: 0.5rem 0.65rem;
  text-align: center;
  background: linear-gradient(160deg, #133b53, #172738); }

.members-onboarding-ending-events__card--event {
  padding: 0.55rem 0.65rem; }

.members-onboarding-ending-events__heading {
  margin: 0;
  font-size: 0.8rem;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.95); }

.members-onboarding-ending-events__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.72rem; }

.members-onboarding-ending-events__item {
  margin: 0;
  padding: 0; }

.members-onboarding-ending-events__row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 0.65rem;
  min-width: 0; }

.members-onboarding-ending-events__banner {
  width: 50px;
  height: 50px;
  flex-shrink: 0;
  border-radius: 8px;
  object-fit: cover;
  background: rgba(0, 0, 0, 0.2); }

.members-onboarding-ending-events__banner--placeholder {
  display: block;
  box-sizing: border-box;
  border: 1px dashed rgba(223, 223, 223, 0.22);
  background: rgba(0, 0, 0, 0.15); }

.members-onboarding-ending-events__text {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.15rem; }

.members-onboarding-ending-events__name {
  margin: 0;
  font-size: 0.86rem;
  font-weight: 700;
  line-height: 1.25;
  color: #ffffff;
  word-break: break-word; }

.members-onboarding-ending-events__datetime {
  margin: 0;
  font-size: 0.76rem;
  line-height: 1.3;
  color: rgba(116, 123, 129, 0.95); }

.members-onboarding-ending-structure {
  width: 100%;
  min-width: 0; }

.members-onboarding-ending-structure__strip {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: stretch;
  gap: 1.15rem;
  width: 100%;
  min-width: 0; }

/* Same grid idea as \`.members-onboarding-structure__card-item\`, scaled down */
.members-onboarding-ending-structure__card-item {
  display: flex;
  flex: 1 1 9.25rem;
  min-width: 0;
  max-width: 12.5rem;
  justify-content: flex-end; }

/* Outer surface: receives the same dynamic theme classes as structure selection cards */
.members-onboarding-ending-structure__cardSurface {
  box-sizing: border-box;
  width: 100%;
  max-width: 12.5rem;
  margin-left: auto;
  margin-right: auto;
  min-height: 5.25rem;
  padding: 0.75rem 0.6rem 0.85rem;
  border-radius: 10px;
  border: 1px solid rgba(120, 165, 200, 0.7);
  color: #dfdfdf;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  transition: box-shadow 0.15s ease; }

.members-onboarding-ending-structure__cardSurface--neutral {
  background: rgba(8, 14, 22, 0.72);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.28); }

/* Compact “structure card” body: column layout + smaller logo/titles (no CTA row) */
.members-onboarding-ending-structure__cardHeader--recap.members-onboarding-structure__card-header {
  gap: 0.38rem;
  flex: 1 1 auto; }

.members-onboarding-ending-structure__cardHeader--recap .members-onboarding-structure__card-logo {
  width: 6.75rem;
  height: 7.35rem; }

.members-onboarding-ending-structure__cardHeader--recap .members-onboarding-structure__card-headings {
  gap: 0.12rem; }

.members-onboarding-ending-structure__cardHeader--recap .members-onboarding-structure__breadcrumb-eyebrow {
  width: 100%;
  text-align: center; }

.members-onboarding-ending-structure__cardHeader--recap .members-onboarding-structure__card-title {
  font-size: 0.88rem;
  font-weight: 800;
  -webkit-line-clamp: 3;
  line-clamp: 3; }

.members-onboarding-ending-structure__cardHeader--recap .members-onboarding-structure__card-subtitle {
  font-size: 0.74rem;
  font-weight: 700; }

.members-onboarding-ending__stage--has-media .members-onboarding-ending__scrim {
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 60%), linear-gradient(180deg, rgba(2, 6, 14, 0.82) 0%, rgba(6, 14, 24, 0.22) 36%, transparent 58%), radial-gradient(115% 80% at 50% 102%, rgba(0, 0, 0, 0.78) 0%, rgba(0, 0, 0, 0.28) 48%, rgba(0, 0, 0, 0) 74%); }

.members-onboarding-ending__inner {
  position: absolute;
  z-index: 3;
  left: 0;
  top: 2rem;
  width: min(33%, 30rem);
  max-width: calc(33% - 0.5rem);
  padding-left: 1.35rem;
  padding-right: 0.5rem;
  box-sizing: border-box;
  margin: 0;
  text-align: left; }

.members-onboarding-ending__copy {
  display: flex;
  flex-direction: column;
  gap: 0.55rem; }

.members-onboarding-ending__welcoming {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.35;
  color: rgba(184, 184, 184, 0.95); }

.members-onboarding-ending__headline {
  margin: 0;
  margin-bottom: 1rem;
  font-family: 'GoodTimes', 'Lato', sans-serif;
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 1.1;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #dfdfdf; }

.members-onboarding-ending__subline {
  margin: 0;
  font-size: 1.3rem;
  font-weight: 600;
  line-height: 1.35;
  color: rgba(58, 120, 180, 0.98); }

.members-onboarding-ending__lead {
  margin: 0;
  font-size: 1rem;
  line-height: 1.5;
  color: rgba(223, 223, 223, 0.9);
  white-space: pre-line; }

.members-onboarding-ending__orgLogo {
  display: block;
  width: 100%;
  max-width: 140px;
  height: auto;
  margin: 0 0 1.25rem; }

.members-onboarding-ending__status {
  margin: 0 0 0.75rem;
  font-size: 0.88rem;
  color: rgba(223, 223, 223, 0.92); }

.members-onboarding-ending__status--error {
  color: #d12323; }

.members-onboarding {
  box-sizing: border-box; }

.members-onboarding__shell {
  margin-top: 5rem;
  margin-bottom: 2rem;
  padding: 1.25rem 1.35rem 1.5rem;
  border-radius: 10px;
  border: 1px solid rgba(52, 90, 120, 0.45);
  background: linear-gradient(180deg, #1e3042, #172738);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35) inset, 0 2px 14px rgba(0, 0, 0, 0.25); }

.members-onboarding__header {
  margin-bottom: 1.25rem;
  text-align: center; }

.members-onboarding__title {
  margin: 0 0 0.35rem;
  font-size: 1.35rem;
  font-weight: 800;
  text-transform: uppercase;
  color: #dfdfdf;
  letter-spacing: 0.04em; }

.members-onboarding__subtitle {
  margin: 0;
  font-size: 0.95rem;
  color: #b8b8b8;
  line-height: 1.45; }

.members-onboarding__steps {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.65rem; }

.members-onboarding__step {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem 1rem;
  padding: 0.85rem 1rem;
  border-radius: 8px;
  border: 1px solid rgba(58, 110, 150, 0.45);
  background: rgba(0, 0, 0, 0.12); }
  .members-onboarding__step--done {
    border-color: rgba(61, 150, 177, 0.55);
    box-shadow: inset 0 0 0 1px rgba(61, 150, 177, 0.12); }

.members-onboarding__step-body {
  flex: 1 1 12rem;
  min-width: 0; }

.members-onboarding__step-label {
  display: block;
  font-size: 0.82rem;
  font-weight: 700;
  color: #b8b8b8;
  margin-bottom: 0.25rem; }

.members-onboarding__step-desc {
  margin: 0;
  font-size: 0.78rem;
  color: rgba(116, 123, 129, 0.95);
  line-height: 1.4; }

.members-onboarding__step-action {
  flex-shrink: 0;
  padding: 0.4rem 0.75rem;
  border-radius: 6px;
  border: 1px solid rgba(90, 170, 240, 0.45);
  background: rgba(40, 100, 160, 0.18);
  color: #77a6d3;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  cursor: pointer; }
  .members-onboarding__step-action:hover {
    background: rgba(40, 100, 160, 0.28);
    color: #96badd; }
  .members-onboarding__step-action[aria-pressed='true'] {
    border-color: rgba(61, 150, 177, 0.65);
    background: rgba(61, 150, 177, 0.15);
    color: #dfdfdf; }

.members-onboarding__footer {
  margin-top: 1.35rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem; }

.members-onboarding__continue {
  padding: 0.55rem 1.35rem;
  border-radius: 8px;
  border: none;
  font-size: 0.88rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  cursor: pointer;
  background: linear-gradient(180deg, #508cc7, #33699d);
  color: #ffffff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35); }
  .members-onboarding__continue:disabled {
    opacity: 0.38;
    cursor: not-allowed;
    box-shadow: none; }
  .members-onboarding__continue:not(:disabled):hover {
    filter: brightness(1.06); }

.members-onboarding__hint {
  margin: 0;
  font-size: 0.76rem;
  color: #747b81; }

.members-onboarding__load-hint {
  margin: 0 0 1rem;
  text-align: center;
  font-size: 0.85rem;
  color: #747b81; }

.members-onboarding__error {
  margin: 0 0 1rem;
  text-align: center;
  font-size: 0.85rem;
  color: #d12323; }

.members-onboarding__steps-layout {
  display: grid;
  grid-template-columns: minmax(0, 300px) 1fr;
  gap: 1.5rem;
  align-items: start;
  /* Panneau principal aligné en hauteur sur la colonne nav quand la vidéo de fond est active,
     pour pouvoir ancrer tags + validation en bas du panneau. */ }
  .members-onboarding__steps-layout:has(.members-onboarding__steps-main--structureDock) {
    align-items: stretch; }
  @media (max-width: 800px) {
    .members-onboarding__steps-layout {
      grid-template-columns: 1fr; } }

.members-onboarding__steps-nav {
  position: sticky;
  top: 0.5rem;
  max-width: 300px;
  width: 100%; }
  @media (max-width: 800px) {
    .members-onboarding__steps-nav {
      max-width: none; } }

.members-onboarding__steps-nav-panel {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
  padding: 0;
  padding-right: 5px;
  border-radius: 14px;
  border: 1px solid #133b53;
  background: #172738;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04), 0 4px 24px rgba(0, 0, 0, 0.22);
  /* Tall panel so the progress card sits at the bottom (uses margin-top: auto). */
  min-height: calc(100vh - 473px); }
  @media (max-width: 800px) {
    .members-onboarding__steps-nav-panel {
      min-height: 0; } }

.members-onboarding__steps-nav-btn-disc--active .members-onboarding__steps-nav-discWrap {
  filter: drop-shadow(0 0 3px rgba(77, 171, 247, 0.95)) drop-shadow(0 0 10px rgba(77, 171, 247, 0.55)); }

/* Étapes validées : halo vert sur chaque disque (assorti à la bordure verte du bouton),
   sélectionnée ou non. Déclaré après le halo bleu pour qu’il l’emporte si l’étape est aussi active. */
.members-onboarding__steps-nav-btn--done .members-onboarding__steps-nav-discWrap {
  filter: drop-shadow(0 0 3px rgba(90, 160, 92, 0.95)) drop-shadow(0 0 10px rgba(90, 160, 92, 0.55)); }

/* Première étape incomplète (déverrouillée) : halo orange sur le disque, sélectionnée ou non.
   Spécificité > halo bleu pour qu’il reste visible si cette étape est aussi active. */
.members-onboarding__steps-nav-btn--next:not(.members-onboarding__steps-nav-btn--done) .members-onboarding__steps-nav-discWrap {
  filter: drop-shadow(0 0 3px rgba(155, 96, 42, 0.95)) drop-shadow(0 0 10px rgba(155, 96, 42, 0.55)); }

.members-onboarding__steps-nav-list {
  position: relative;
  max-height: calc(100vh - 605px);
  margin: 0;
  margin-top: 5px;
  padding: 10px 10px 15px 40px;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0;
  overflow-y: auto; }
  .members-onboarding__steps-nav-list::-webkit-scrollbar {
    width: 6px; }
  .members-onboarding__steps-nav-list::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .members-onboarding__steps-nav-list::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .members-onboarding__steps-nav-list::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }
  .members-onboarding__steps-nav-list::before {
    content: '';
    position: absolute;
    left: 1.5rem;
    top: calc(2.65rem / 2);
    bottom: calc(2.65rem / 2);
    width: 3px;
    margin-left: 1px;
    border-radius: 1px;
    background: rgba(72, 82, 96, 0.65);
    z-index: 0;
    pointer-events: none; }

.members-onboarding__steps-nav-item {
  position: relative;
  z-index: 1;
  min-width: 0;
  /* gap: on flex is unreliable in some stacks; margin always separates rows */ }
  .members-onboarding__steps-nav-item + .members-onboarding__steps-nav-item {
    margin-top: 25px; }

.members-onboarding__steps-nav-discWrap {
  position: relative;
  z-index: 1;
  width: 3.65rem;
  height: 3.65rem;
  flex-shrink: 0; }

.members-onboarding__steps-nav-discSvg {
  display: block;
  width: 100%;
  height: 100%;
  /* r=18 dans viewBox 36 : le disque plein va au bord ; strokeWidth 2 déborde légèrement.
     overflow: visible évite que la moitié extérieure du tracé soit rognée. */
  overflow: visible; }

.members-onboarding__steps-nav-discBg {
  /* Couleur opaque calée sur le rendu effectif du panneau (rgba(5,10,18,0.55) au-dessus de
     linear-gradient(\$panel-blue, \$dark-panel-blue)) afin de masquer le trait vertical sous le disque. */
  fill: #0f1a26; }

.members-onboarding__steps-nav-discTrack {
  stroke: rgba(110, 125, 145, 0.55); }

.members-onboarding__steps-nav-discProgress {
  stroke: #4dabf7; }

.members-onboarding__steps-nav-discLabel {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.78rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.02em;
  color: rgba(116, 123, 129, 0.98);
  pointer-events: none; }

.members-onboarding__steps-nav-discLabel--active {
  color: rgba(223, 223, 223, 0.98); }

.members-onboarding__steps-nav-discLabel--locked {
  opacity: 0.48; }

.members-onboarding__steps-nav-btn-disc {
  flex-shrink: 0;
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Colonne disque : hauteur suit le bouton ; fond capsule masque les segments horizontaux
     de bordure au-dessus / au-dessous du cercle. */
  width: 3.65rem;
  min-height: 3.65rem;
  /* Le centre du disque tombe pile sur l'axe vertical (1.5rem). Le bouton commence à 1.5rem
     du bord de la liste, padding-left: 0.5rem ; il faut donc reculer de (0.5rem + 1.325rem). */
  margin-left: -2.2rem;
  margin-right: 0;
  position: relative;
  z-index: 2; }
  .members-onboarding__steps-nav-btn-disc::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: -1px;
    bottom: -1px;
    z-index: 0;
    border-radius: 999px;
    /* Même teinte que .members-onboarding__steps-nav-discBg — recouvre la bordure 1px du bouton. */
    background: #0f1a26;
    pointer-events: none; }

.members-onboarding__steps-nav-btn {
  width: 100%;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.85rem;
  overflow: visible;
  /* Pas de padding vertical : la hauteur est dictée par le disque (= min-height). */
  padding: 0 0.78rem 0 0.5rem;
  min-height: 2.65rem;
  border-radius: 0px 10px 10px 0px;
  border: 1px solid rgba(72, 105, 135, 0.38);
  background: rgba(12, 18, 28, 0.92);
  color: rgba(116, 123, 129, 0.95);
  font-size: 0.8rem;
  font-weight: 700;
  text-align: left;
  cursor: pointer;
  box-shadow: none;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;
  /* Étape qui vient d'être déverrouillée (déverrouillée, pas encore validée) : bordure orange. */
  /* Cas particulier : étape déverrouillée ET sélectionnée — la bordure orange l'emporte
     sur la bordure neutre de --active, le background/color de --active sont conservés. */
  /* Étape validée : bordure verte. */
  /* Étape validée ET sélectionnée : on garde le bord vert (le bg/color viennent de --active). */ }
  .members-onboarding__steps-nav-btn:hover {
    border-color: rgba(100, 155, 205, 0.42);
    background: rgba(18, 35, 52, 0.72);
    color: rgba(184, 184, 184, 0.98); }
  .members-onboarding__steps-nav-btn--active {
    border-color: rgba(72, 105, 135, 0.38);
    background: rgba(14, 22, 34, 0.94);
    color: #ffffff; }
    .members-onboarding__steps-nav-btn--active:hover {
      border-color: rgba(100, 155, 205, 0.38);
      background: rgba(18, 28, 42, 0.94);
      color: #ffffff; }
  .members-onboarding__steps-nav-btn--next:not(.members-onboarding__steps-nav-btn--done):not(.members-onboarding__steps-nav-btn--active) {
    border-color: #9b602a;
    background: rgba(16, 26, 38, 0.88); }
    .members-onboarding__steps-nav-btn--next:not(.members-onboarding__steps-nav-btn--done):not(.members-onboarding__steps-nav-btn--active):hover {
      border-color: #c97e39;
      background: rgba(22, 38, 54, 0.85); }
  .members-onboarding__steps-nav-btn--next.members-onboarding__steps-nav-btn--active:not(.members-onboarding__steps-nav-btn--done) {
    border-color: #9b602a; }
    .members-onboarding__steps-nav-btn--next.members-onboarding__steps-nav-btn--active:not(.members-onboarding__steps-nav-btn--done):hover {
      border-color: #c97e39; }
  .members-onboarding__steps-nav-btn--done:not(.members-onboarding__steps-nav-btn--active) {
    border-color: #5aa05c;
    background: rgba(11, 18, 26, 0.88);
    opacity: 0.92; }
    .members-onboarding__steps-nav-btn--done:not(.members-onboarding__steps-nav-btn--active):hover {
      border-color: #80b781;
      background: rgba(18, 30, 44, 0.82); }
  .members-onboarding__steps-nav-btn--done.members-onboarding__steps-nav-btn--active {
    border-color: #5aa05c; }
    .members-onboarding__steps-nav-btn--done.members-onboarding__steps-nav-btn--active:hover {
      border-color: #80b781; }

.members-onboarding__steps-nav-label {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.members-onboarding__steps-nav-btn--active .members-onboarding__steps-nav-label {
  font-weight: 800; }

.members-onboarding__steps-nav-trailing {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.38rem;
  min-width: 0; }

.members-onboarding__steps-nav-clock {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.12rem;
  height: 1.12rem;
  border-radius: 999px;
  background: rgba(77, 171, 247, 0.22);
  color: rgba(223, 223, 223, 0.96); }

.members-onboarding__steps-nav-clockSvg {
  width: 0.66rem;
  height: 0.66rem;
  display: block; }

.members-onboarding__steps-nav-badge {
  font-variant-numeric: tabular-nums;
  font-size: 0.74rem;
  font-weight: 800;
  color: rgba(223, 223, 223, 0.98); }

.members-onboarding__steps-nav-check {
  flex-shrink: 0;
  font-size: 0.85rem;
  font-weight: 800;
  line-height: 1;
  color: rgba(90, 160, 92, 0.98); }

.members-onboarding__steps-progressCard {
  /* Toujours collé en bas du panneau, peu importe le nombre d'étapes. */
  margin-top: auto;
  padding: 0.85rem 0.95rem;
  border-radius: 10px;
  border: 1px solid rgba(58, 95, 125, 0.45);
  background: rgba(8, 14, 22, 0.65); }

.members-onboarding__steps-progressCard-eyebrow {
  margin: 0 0 0.35rem;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: none;
  color: rgba(116, 123, 129, 0.95); }

.members-onboarding__steps-progressCard-count {
  margin: 0 0 0.65rem;
  font-size: 0.95rem;
  font-weight: 800;
  color: rgba(223, 223, 223, 0.98); }

.members-onboarding__steps-progress-meter {
  display: block;
  width: 100%;
  height: 8px;
  appearance: none;
  border: none;
  border-radius: 6px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.35); }
  .members-onboarding__steps-progress-meter::-webkit-progress-bar {
    border-radius: 6px;
    background: rgba(40, 48, 58, 0.9); }
  .members-onboarding__steps-progress-meter::-webkit-progress-value {
    border-radius: 6px;
    background: linear-gradient(90deg, #508cc7, #4dabf7); }
  .members-onboarding__steps-progress-meter::-moz-progress-bar {
    border-radius: 6px;
    background: linear-gradient(90deg, #508cc7, #4dabf7); }

.members-onboarding__steps-main {
  position: relative;
  min-width: 0;
  height: stretch;
  border-radius: 14px;
  border: 1px solid #133b53;
  background: #172738;
  padding: 1rem 1.05rem 1.1rem; }

/* Step « structure » : le panneau remplit la colonne pour ancrer tip/tags/CTA en bas
   (indépendamment de la présence d’une vidéo HLS — sans ça \`--videoBg\` seul ne s’appliquait pas). */
.members-onboarding__steps-main--structureDock {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-self: stretch;
  min-height: calc(100vh - 506px); }

.members-onboarding__steps-main--videoBg {
  overflow: hidden; }

.members-onboarding__steps-main--structureDock .members-onboarding__steps-main-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0; }

/* Grille 1fr / auto : la rangée du bas suit le bord inférieur du panneau dès que la hauteur est connue. */
.members-onboarding__steps-main--structureDock .members-onboarding-steps__structure-wrap.members-onboarding-structure {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-rows: minmax(0, 1fr) auto;
  grid-template-columns: minmax(0, 1fr);
  gap: 0.5rem;
  align-content: stretch; }

.members-onboarding__steps-main--structureDock .members-onboarding-structure__topStack {
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0.5rem; }

/* Membership step : le fil d’Ariane + titre en haut, tuiles centrées verticalement. */
.members-onboarding__steps-main--structureDock .members-onboarding-structure__membership-picker {
  flex: 1;
  min-height: 0; }

.members-onboarding__steps-main--structureDock .members-onboarding-structure__membership-grid {
  flex: 1;
  align-content: center;
  align-items: center; }

.members-onboarding__steps-main--structureDock .members-onboarding-structure__footerDock {
  align-self: stretch; }

.members-onboarding__steps-main-videoBg {
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
  border-radius: inherit; }

.members-onboarding__steps-main-video {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.5; }

.members-onboarding__steps-main-header {
  margin-bottom: 0.85rem; }

.members-onboarding__steps-main-title {
  margin: 0 0 0.35rem;
  font-size: 1.05rem;
  font-weight: 800;
  color: #dfdfdf; }

.members-onboarding__steps-main-desc {
  margin: 0;
  font-size: 0.82rem;
  color: rgba(116, 123, 129, 0.98);
  line-height: 1.45; }

.members-onboarding__steps-main-body {
  position: relative;
  z-index: 2;
  min-width: 0; }

.members-onboarding__steps-main-footer {
  margin-top: 1rem;
  padding-top: 0.85rem;
  border-top: 1px solid rgba(58, 110, 150, 0.35); }

.members-onboarding__step-action--wide {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0.55rem 1rem;
  font-size: 0.78rem; }

.members-onboarding-steps__empty {
  margin: 0;
  font-size: 0.85rem;
  color: #747b81;
  line-height: 1.45; }

.members-onboarding-steps__empty--media {
  padding: 1rem 0; }

/* Wrapper du <PrivateLexicalPage> dans l'onboarding (steps « new » et « existing »).
   Volontairement décorrélé de \`.private-pages\` pour pouvoir styler le rendu
   spécifiquement dans le contexte d'onboarding sans hériter du layout des pages privées. */
.members-onboarding-steps__doc {
  margin-top: 0.25rem; }

.members-onboarding-steps__structure-wrap {
  margin-top: 0.25rem; }

/* ---------------------------------------------------------------------------
 * Step "structure" — selection séquentielle Division → Branch → Section.
 * Conventions :
 * - On n'utilise PAS les couleurs métier (elementColor1/2, elementBorderColor,
 *   elementTextColor) du modèle OrgDivisions : le step a son propre design
 *   neutre, harmonisé avec le reste de l'onboarding.
 * - Les cards reprennent l'image (divisionImageUrl) et les textes
 *   (divisionFullName, elementDetails, divisionDescription).
 * ------------------------------------------------------------------------- */
.members-onboarding-structure {
  display: flex;
  flex-direction: column;
  gap: 0.5rem; }

.members-onboarding-structure__topStack {
  display: flex;
  flex-direction: column;
  gap: 0.5rem; }

.members-onboarding-structure__footerDock {
  display: flex;
  flex-direction: column;
  gap: 0.5rem; }

.members-onboarding-structure__bottomDock {
  display: flex;
  flex-direction: column;
  gap: 0.5rem; }

.members-onboarding-structure__breadcrumb {
  list-style: none;
  margin: 0;
  padding: 0.45rem 0.6rem;
  display: flex;
  align-items: stretch;
  flex-wrap: wrap;
  gap: 0.35rem 0.55rem;
  border-radius: 10px;
  border: 1px solid rgba(58, 110, 150, 0.35);
  background: rgba(8, 14, 22, 0.55); }

.members-onboarding-structure__breadcrumb-item {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem; }

.members-onboarding-structure__breadcrumb-btn {
  /* Layout horizontal "mini-card" : logo à gauche, eyebrow + label empilés à
     droite. Reprend l'esthétique des cards principales en compact. Pour les
     items dont la DB a renseigné elementColor1/2, \`getStructureBreadcrumbBgClass\`
     injecte par-dessus un override (gradient + bordure thémée + lueur de hover). */
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  padding: 0.35rem 0.65rem 0.35rem 0.4rem;
  border-radius: 9px;
  border: 1px solid rgba(120, 165, 200, 0.6);
  background: rgba(14, 22, 34, 0.94);
  color: #dfdfdf;
  font-family: inherit;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease, transform 0.12s ease, box-shadow 0.15s ease; }
  .members-onboarding-structure__breadcrumb-btn:hover, .members-onboarding-structure__breadcrumb-btn:focus-visible {
    border-color: rgba(58, 120, 180, 0.85);
    background: rgba(18, 28, 42, 0.94);
    outline: none;
    transform: translateY(-1px); }

.members-onboarding-structure__breadcrumb-logo {
  /* Logo flotte sans cadre (cohérent avec la card principale). Taille
     volontairement bornée pour rester "breadcrumb" et pas reproduire la
     card pleine. */
  flex-shrink: 0;
  width: 2.4rem;
  height: 2.4rem;
  object-fit: contain;
  display: block; }

/* Pas de règle pour \`.members-onboarding-structure__breadcrumb-logo--placeholder\` :
   le modifier est un simple marqueur sémantique ; le span garde le sizing
   du logo de base et reste invisible, ce qui aligne les items entre eux
   même quand certaines divisions n'ont pas de logo. */
.members-onboarding-structure__breadcrumb-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.05rem;
  min-width: 0; }

.members-onboarding-structure__breadcrumb-eyebrow {
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(116, 123, 129, 0.95); }

.members-onboarding-structure__breadcrumb-label {
  font-size: 0.85rem;
  font-weight: 700;
  color: #dfdfdf;
  /* Cap visuel + ellipsis : un divisionFullName long ne fait pas exploser
     le breadcrumb. Le \`title\` du bouton (JSX) restitue le nom complet au
     survol. */
  white-space: nowrap;
  max-width: 12rem;
  overflow: hidden;
  text-overflow: ellipsis; }

.members-onboarding-structure__breadcrumb-sep {
  font-size: 1rem;
  color: rgba(116, 123, 129, 0.7);
  align-self: center;
  user-select: none; }

.members-onboarding-structure__level-heading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  width: 100%;
  margin: 0.25rem 0 0;
  box-sizing: border-box;
  font-size: 0.92rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  text-align: center;
  color: rgba(223, 223, 223, 0.98);
  padding: 0.55rem 0rem;
  border-radius: 10px;
  border: 1px solid rgba(58, 110, 150, 0.35);
  background: rgba(8, 14, 22, 0.55); }

.members-onboarding-structure__cards {
  list-style: none;
  /* Espace vertical net autour du bloc de grille (en plus du \`gap\` du parent). */
  margin: auto 0;
  /* Léger padding : laisse respirer le fond autour de la grille. */
  padding: 0.4rem 0.65rem;
  /* Règle de mise en page :
     - max 3 cards par rangée (borne par la formule de flex-basis ci-dessous)
     - cards plafonnées à ~15rem de large : sur conteneur large elles ne
       s'étirent plus, le reste de la rangée est vide et centré
     - plus de 3 cards : on enchaîne les rangées, dernière rangée centrée
     - conteneur étroit (mobile / panneau resserré) : min-width déclenche le
       flex-wrap, on passe à moins de cards par rangée. */
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4.75rem; }

/* ---------------------------------------------------------------------------
   Tip rassurant juste sous la grille de cards
   ---------------------------------------------------------------------------
   Bannière info avec ampoule + titre + texte secondaire ; le mot "change" est
   accentué via \`__tip-accent\`. Rendu seulement aux niveaux de sélection (pas
   au validate level) — voir la condition côté JSX.
   --------------------------------------------------------------------------- */
.members-onboarding-structure__tip {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  margin-top: 0.5rem;
  padding: 0.85rem 1rem;
  border-radius: 10px;
  border: 1px solid rgba(58, 110, 150, 0.35);
  background: rgba(8, 14, 22, 0.55); }

.members-onboarding-structure__tip-icon {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.65rem;
  height: 1.65rem;
  /* \`currentColor\` du svg hérite de cette teinte → un seul endroit à modifier
     pour ajuster la couleur de l'icône. */
  color: rgba(116, 123, 129, 0.85); }

.members-onboarding-structure__tip-body {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0; }

.members-onboarding-structure__tip-title {
  margin: 0;
  font-size: 0.92rem;
  font-weight: 700;
  line-height: 1.35;
  color: #dfdfdf; }

.members-onboarding-structure__tip-text {
  margin: 0;
  font-size: 0.86rem;
  line-height: 1.4;
  color: rgba(116, 123, 129, 0.92); }

.members-onboarding-structure__tip-accent {
  /* Emphase visuelle sur "change" — pas un vrai lien (pas de href / nav).
     Si le besoin évolue, remplacer par <a> ou <button> avec ce même className. */
  color: #3a78b4;
  font-weight: 700; }

.members-onboarding-structure__card-item {
  display: flex;
  /* Flex-basis = 1/3 du conteneur (moins les 2 gaps), ce qui borne à
     3 cards par rangée. \`max-width\` cap visuellement la largeur d'une card
     pour qu'elle reste compacte même quand le conteneur est plus large que
     3 × max-width (le surplus devient de l'espace centré par justify-content). */
  flex: 1 1 calc((100% - 5.5rem) / 3);
  max-width: 15rem;
  min-width: 12rem; }

/* Membership titles — compact text tiles (no logo / no org card CTA). */
.members-onboarding-structure__membership-picker {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.85rem; }

.members-onboarding-structure__membership-hint {
  width: 100%;
  margin: 0;
  font-size: 0.84rem;
  line-height: 1.4;
  text-align: center;
  color: rgba(116, 123, 129, 0.95); }

.members-onboarding-structure__membership-heading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0.25rem 0 0;
  box-sizing: border-box;
  font-size: 0.92rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  text-align: center;
  color: rgba(223, 223, 223, 0.98);
  padding: 0.55rem 0rem;
  border-radius: 10px;
  border: 1px solid rgba(58, 110, 150, 0.35);
  background: rgba(8, 14, 22, 0.55); }

.members-onboarding-structure__membership-grid {
  list-style: none;
  margin: auto 0;
  padding: 0.15rem 0.35rem;
  width: stretch;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  gap: 0.65rem 0.75rem; }

.members-onboarding-structure__membership-item {
  display: flex;
  flex: 0 1 auto;
  min-width: 0;
  max-width: 100%; }

.members-onboarding-structure__membership-card {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 2.75rem;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  border: 1px solid rgba(120, 165, 200, 0.55);
  background: rgba(8, 14, 22, 0.72);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.22);
  color: #dfdfdf;
  font-family: inherit;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease, transform 0.12s ease; }
  .members-onboarding-structure__membership-card:hover, .members-onboarding-structure__membership-card:focus-visible {
    border-color: rgba(58, 120, 180, 0.85);
    background: rgba(14, 22, 34, 0.88);
    outline: none;
    transform: translateY(-1px);
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.32); }
  .members-onboarding-structure__membership-card:active {
    transform: translateY(0); }
  .members-onboarding-structure__membership-card--selected {
    border-color: rgba(117, 207, 120, 0.95);
    background: rgba(22, 44, 14, 0.92);
    box-shadow: 0 0 0 1px rgba(117, 207, 120, 0.4), 0 4px 14px rgba(0, 0, 0, 0.28); }

.members-onboarding-structure__membership-label {
  font-size: 0.88rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  line-height: 1.2;
  text-align: center;
  word-break: break-word; }

.members-onboarding-structure__membership-empty {
  width: 100%;
  margin: 0;
  padding: 0.65rem 0.85rem;
  font-size: 0.88rem;
  line-height: 1.45;
  text-align: center;
  color: rgba(116, 123, 129, 0.95);
  border-radius: 10px;
  border: 1px solid rgba(58, 110, 150, 0.35);
  background: rgba(8, 14, 22, 0.55); }

.members-onboarding-structure__card {
  display: flex;
  flex-direction: column;
  /* space-between : header collé en haut, CTA collé en bas — le vide central
     absorbe les différences de hauteur de contenu entre cards d'une rangée. */
  justify-content: space-between;
  gap: 0.85rem;
  width: 100%;
  min-width: 0;
  /* Hauteur unifiée : logo + titre/sous-titre + CTA + paddings.
     Garde une grille visuelle stable même si certaines cards ont moins de
     contenu textuel. */
  min-height: 15rem;
  padding: 1rem 0.9rem 0.9rem;
  border-radius: 10px;
  /* Bord neutre par défaut, volontairement plus lumineux (opacité 0.7) qu'un
     liseré discret pour que la card ressorte du fond sombre. Les cards
     thématisées (gradient depuis la DB) écrasent border-color + box-shadow
     via la règle dynamique injectée par \`getStructureCardBgClass\`. */
  border: 1px solid rgba(120, 165, 200, 0.7);
  background: rgba(8, 14, 22, 0.7);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.28);
  color: #dfdfdf;
  text-align: left;
  font-family: inherit;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, transform 0.12s ease, box-shadow 0.15s ease; }
  .members-onboarding-structure__card:hover, .members-onboarding-structure__card:focus-visible {
    border-color: rgba(58, 120, 180, 0.85);
    background: rgba(14, 22, 34, 0.85);
    outline: none;
    box-shadow: 0 6px 22px rgba(0, 0, 0, 0.4);
    transform: translateY(-1px); }
  .members-onboarding-structure__card:active {
    transform: translateY(0); }

.members-onboarding-structure__card-header {
  /* Layout vertical : logo en haut centré, puis titres dessous. */
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.55rem;
  min-width: 0; }

.members-onboarding-structure__card-logo {
  /* Pas de cadre (background / border / border-radius) : le logo flotte
     directement sur le gradient de la card. \`object-fit: contain\` garantit
     que les logos non carrés ne se déforment pas. */
  flex-shrink: 0;
  min-width: 4rem;
  min-height: 4rem;
  max-width: 5rem;
  max-height: 5rem;
  object-fit: contain;
  display: block; }

/* Pas de règle pour \`.members-onboarding-structure__card-logo--placeholder\` :
   le modifier sert uniquement de marqueur sémantique en JSX. Le span hérite
   du sizing de \`.members-onboarding-structure__card-logo\` et reste visuellement
   invisible (pas de background / border) — ça réserve l'emplacement du logo
   pour aligner les titres entre cards avec/sans logo dans une même rangée. */
.members-onboarding-structure__card-headings {
  min-width: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  text-align: center; }

.members-onboarding-structure__card-title {
  /* Titre principal mis en avant : plus gros, jusqu'à 2 lignes maxi avant
     troncature avec ellipsis (line-clamp WebKit, supporté Chrome/FF/Safari). */
  font-size: 1.05rem;
  font-weight: 800;
  line-height: 1.25;
  color: #dfdfdf;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden; }

.members-onboarding-structure__card-subtitle {
  font-size: 0.82rem;
  font-weight: 700;
  color: rgba(116, 123, 129, 0.95);
  word-break: break-word; }

.members-onboarding-structure__card-cta {
  /* CTA visuel en bas de chaque card. Toujours rendu comme un <span> (et non
     un <button>) car la card elle-même est déjà un <button> cliquable — nest
     button-in-button est interdit en HTML. C'est purement de l'affordance
     visuelle, le clic est géré par le <button> parent.

     Affiche deux labels enfants (\`__card-cta-default\` / \`__card-cta-hover\`) :
     un seul est visible à la fois, le swap se fait en CSS pur sur l'état
     \`:hover\` / \`:focus-visible\` du bouton parent (.__card). Aucun state React
     impliqué.

     Couleurs fallback neutres pour les cards sans elementColor1/2 en DB ;
     pour les cards thématisées, \`getStructureCardBgClass\` injecte un
     override (border-color + color) via une règle CSS dynamique. */
  display: block;
  margin-top: auto;
  padding: 0.45rem 0.75rem;
  border-radius: 8px;
  border: 1px solid rgba(116, 123, 129, 0.65);
  background: transparent;
  color: #dfdfdf;
  text-align: center;
  font-family: inherit;
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 1.2; }

.members-onboarding-structure__card-cta-default {
  display: inline; }

.members-onboarding-structure__card-cta-hover {
  display: none; }

/* Swap des labels au survol / focus clavier de la card parente. On scope sur
   \`.__card\` (pas sur \`.__card-cta\`) pour que le toggle suive l'état du
   bouton entier, pas seulement celui du span — sinon survoler le texte ferait
   clignoter le swap quand le pointer entre/sort de la zone du span. */
.members-onboarding-structure__card:hover .members-onboarding-structure__card-cta-default, .members-onboarding-structure__card:focus-visible .members-onboarding-structure__card-cta-default {
  display: none; }

.members-onboarding-structure__card:hover .members-onboarding-structure__card-cta-hover, .members-onboarding-structure__card:focus-visible .members-onboarding-structure__card-cta-hover {
  display: inline; }

/* ---------------------------------------------------------------------------
   Tags du step "structure" — sélection multi-chip
   ---------------------------------------------------------------------------
   Sélecteur de tags affiché en bas du step (sous le fil d'Ariane, la grille
   de cards et l'éventuel CTA de validation), toujours visible quel que soit
   le niveau de navigation. Le composant React enforce la fourchette
   [STRUCTURE_TAGS_MIN, STRUCTURE_TAGS_MAX] : au max atteint, les chips
   non-sélectionnées passent à l'état \`--locked\` (DOM \`disabled\`).
   --------------------------------------------------------------------------- */
.members-onboarding-structure__tags-wrap {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  padding: 0.95rem 1rem 0.85rem;
  margin-top: 0.35rem;
  border-radius: 10px;
  border: 1px solid rgba(58, 110, 150, 0.35);
  background: rgba(8, 14, 22, 0.55); }

.members-onboarding-structure__tags-help {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.45;
  color: rgba(116, 123, 129, 0.98); }

.members-onboarding-structure__tags {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem 0.5rem; }

.members-onboarding-structure__tag-item {
  display: flex; }

.members-onboarding-structure__tag {
  /* Chip pill cliquable. Le state "--selected" passe sur du remplissage
     accent ; "--locked" baisse l'opacité et coupe le pointer pour signaler
     que la limite max est atteinte. */
  display: inline-flex;
  align-items: center;
  padding: 0.35rem 0.78rem;
  border-radius: 999px;
  border: 1px solid rgba(58, 110, 150, 0.5);
  background: rgba(0, 0, 0, 0.3);
  color: rgba(223, 223, 223, 0.92);
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease; }
  .members-onboarding-structure__tag:hover:not(:disabled), .members-onboarding-structure__tag:focus-visible:not(:disabled) {
    border-color: rgba(58, 120, 180, 0.75);
    background: rgba(14, 22, 34, 0.85);
    outline: none;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.28); }
  .members-onboarding-structure__tag--selected, .members-onboarding-structure__tag--selected:hover, .members-onboarding-structure__tag--selected:focus-visible {
    border-color: #3a78b4;
    background: rgba(58, 120, 180, 0.22);
    color: #dfdfdf;
    box-shadow: 0 0 0 1px rgba(58, 120, 180, 0.45); }
  .members-onboarding-structure__tag--locked, .members-onboarding-structure__tag:disabled {
    cursor: not-allowed;
    opacity: 0.4;
    box-shadow: none; }

.members-onboarding-structure__tags-count {
  margin: 0;
  font-size: 0.78rem;
  color: rgba(116, 123, 129, 0.9); }

.members-onboarding-structure__validate-wrap {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  padding: 0.95rem 1rem;
  border-radius: 10px;
  border: 1px solid rgba(58, 110, 150, 0.35);
  background: rgba(8, 14, 22, 0.55); }

.members-onboarding-structure__validate-help {
  margin: 0;
  font-size: 0.85rem;
  line-height: 1.45;
  color: rgba(116, 123, 129, 0.98); }

.members-onboarding-structure__cta {
  align-self: flex-start;
  padding: 0.6rem 1.4rem;
  border-radius: 8px;
  border: none;
  font-family: inherit;
  font-size: 0.88rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  color: #ffffff;
  background: linear-gradient(180deg, #508cc7, #33699d);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
  cursor: pointer;
  transition: filter 0.15s ease, box-shadow 0.15s ease, transform 0.12s ease; }
  .members-onboarding-structure__cta:hover:not(:disabled), .members-onboarding-structure__cta:focus-visible:not(:disabled) {
    filter: brightness(1.08);
    outline: none; }
  .members-onboarding-structure__cta:active:not(:disabled) {
    transform: translateY(1px); }
  .members-onboarding-structure__cta:disabled {
    opacity: 0.45;
    cursor: not-allowed;
    box-shadow: none; }

.members-onboarding-steps__error {
  margin: 0;
  font-size: 0.85rem;
  color: rgba(233, 134, 134, 0.95); }

.members-onboarding-steps__media-pagination {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.35rem 0.65rem;
  width: auto;
  padding: 0.65rem 0.85rem;
  border-radius: 10px;
  border: 1px solid rgba(58, 110, 150, 0.38);
  background: rgba(0, 0, 0, 0.22); }

.members-onboarding-steps__media-pageArrow {
  min-width: 2rem;
  height: 2rem;
  padding: 0 0.45rem;
  border-radius: 6px;
  border: 1px solid rgba(58, 110, 150, 0.45);
  background: rgba(40, 100, 160, 0.2);
  color: #dfdfdf;
  font-size: 0.95rem;
  font-weight: 800;
  line-height: 1;
  cursor: pointer; }
  .members-onboarding-steps__media-pageArrow:hover:not(:disabled) {
    background: rgba(40, 100, 160, 0.35); }
  .members-onboarding-steps__media-pageArrow:disabled {
    opacity: 0.35;
    cursor: not-allowed; }

.members-onboarding-steps__media-pageNums {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.35rem; }

.members-onboarding-steps__media-pageNum {
  min-width: 1.85rem;
  height: 1.85rem;
  padding: 0 0.35rem;
  border-radius: 6px;
  border: 1px solid rgba(58, 110, 150, 0.35);
  background: rgba(0, 0, 0, 0.2);
  color: #747b81;
  font-size: 0.82rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  cursor: pointer; }
  .members-onboarding-steps__media-pageNum.is-active {
    border-color: rgba(90, 170, 240, 0.75);
    color: #dfdfdf;
    background: rgba(40, 100, 160, 0.35); }
  .members-onboarding-steps__media-pageNum.is-viewed:not(.is-active) {
    color: rgba(223, 223, 223, 0.88); }
  .members-onboarding-steps__media-pageNum:disabled {
    opacity: 0.45;
    cursor: default; }

.members-onboarding-steps__media-galleryHint {
  margin: 0.55rem 0 0;
  font-size: 0.8rem;
  line-height: 1.45;
  text-align: center;
  color: rgba(116, 123, 129, 0.98); }

.members-onboarding-steps__media-layer {
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
  border: 1px solid rgba(58, 110, 150, 0.35);
  background: rgba(0, 0, 0, 0.25);
  line-height: 0; }

.members-onboarding-steps__media-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%; }

.members-onboarding-steps__media-video-wrap {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  border-radius: 8px;
  border: 1px solid rgba(58, 110, 150, 0.35);
  background: rgba(0, 0, 0, 0.25); }

.members-onboarding-steps__media-video {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: var(--mob-step-focal-x, 50%) var(--mob-step-focal-y, 50%); }

/* Lexical “read to end” sentinel (PrivateLexicalPage) */
.private-rte-read-stack {
  display: flex;
  flex-direction: column;
  width: 100%; }

.private-rte-read-sentinel {
  flex-shrink: 0;
  width: 100%;
  height: 4px;
  margin-top: 0.35rem;
  pointer-events: none; }

.private-rte-read-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem 1rem;
  align-items: baseline;
  margin-bottom: 0.65rem;
  padding: 0.45rem 0.55rem;
  border-radius: 8px;
  border: 1px solid rgba(58, 110, 150, 0.4);
  background: rgba(0, 0, 0, 0.14);
  font-size: 0.78rem;
  color: rgba(116, 123, 129, 0.98);
  line-height: 1.35; }

.private-rte-read-meta-item {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.25rem; }

.private-rte-read-meta-value {
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  color: #dfdfdf; }

.private-rte-read-meta-ok {
  color: #6096cc;
  font-weight: 700; }

.members-onboarding__steps-nav-btn--locked {
  cursor: not-allowed;
  /* Bordure atténuée pour signaler le verrouillage.
     IMPORTANT : on n'utilise plus \`opacity\` sur le bouton entier — sinon le fond opaque du
     disque (.members-onboarding__steps-nav-discBg) descendait sous 100 %, et le trait
     vertical de fond apparaissait à travers le disque. */
  border-color: rgba(72, 105, 135, 0.18);
  /* On atténue uniquement les éléments textuels du bouton ; le disque garde son fond
     opaque qui masque le trait. La pastille « 01 » est de son côté déjà dimmée par
     \`.members-onboarding__steps-nav-discLabel--locked\`. */ }
  .members-onboarding__steps-nav-btn--locked .members-onboarding__steps-nav-label,
  .members-onboarding__steps-nav-btn--locked .members-onboarding__steps-nav-trailing {
    opacity: 0.55; }
  .members-onboarding__steps-nav-btn--locked:hover {
    border-color: rgba(58, 110, 150, 0.32);
    background: rgba(0, 0, 0, 0.14); }

.members-onboarding__steps-nav-btn:disabled {
  pointer-events: none; }

.members-onboarding-steps__structure-note {
  margin: 0 0 0.75rem;
  font-size: 0.8rem;
  color: rgba(116, 123, 129, 0.95);
  line-height: 1.45; }

.members-onboarding-steps__media-image-block {
  display: flex;
  flex-direction: column;
  gap: 0.65rem; }

.members-onboarding-steps__media-locked-hint,
.members-onboarding-steps__video-locked-hint {
  margin: 0;
  font-size: 0.78rem;
  color: #747b81; }

.members-onboarding-steps__image-timer {
  display: flex;
  align-items: center;
  gap: 0.65rem; }

.members-onboarding-steps__image-timer-svg {
  width: 52px;
  height: 52px;
  flex-shrink: 0; }

.members-onboarding-steps__image-timer-track {
  fill: none;
  stroke: rgba(58, 110, 150, 0.35);
  stroke-width: 6; }

.members-onboarding-steps__image-timer-fill {
  fill: none;
  stroke: #4887c4;
  stroke-width: 6;
  stroke-linecap: round;
  transform-origin: 44px 44px; }

.members-onboarding-steps__image-timer-count {
  font-size: 1.1rem;
  font-weight: 800;
  color: #dfdfdf;
  min-width: 1.5rem;
  text-align: center; }

.members-onboarding-steps__image-timer-hint {
  font-size: 0.75rem;
  color: #747b81; }

.members-onboarding-steps__restricted-video {
  display: flex;
  flex-direction: column;
  gap: 0.65rem; }

.members-onboarding-steps__video-controlBar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem 1rem;
  padding: 0.65rem 0.85rem;
  border-radius: 10px;
  border: 1px solid rgba(58, 110, 150, 0.38);
  background: rgba(0, 0, 0, 0.22); }

.members-onboarding-steps__video-controlBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 3rem;
  min-height: 3rem;
  padding: 0.35rem;
  border-radius: 10px;
  border: 1px solid rgba(90, 170, 240, 0.5);
  background: rgba(40, 100, 160, 0.22);
  color: #7eabd6;
  cursor: pointer;
  line-height: 0; }
  .members-onboarding-steps__video-controlBtn:hover:not(:disabled) {
    background: rgba(40, 100, 160, 0.34);
    border-color: rgba(110, 190, 255, 0.55); }
  .members-onboarding-steps__video-controlBtn:disabled {
    opacity: 0.45;
    cursor: not-allowed; }

.members-onboarding-steps__video-controlBtn--playPause {
  width: 2.15rem;
  height: 2.15rem; }

.members-onboarding-steps__video-iconSvg {
  width: 1.65rem;
  height: 1.65rem;
  display: block; }

.members-onboarding-steps__video-iconSvg--rewind {
  width: 2.15rem;
  height: 2.15rem; }

.members-onboarding-steps__video-time {
  font-size: 0.78rem;
  color: #b8b8b8;
  font-variant-numeric: tabular-nums; }

.members-onboarding-steps__video-hint {
  margin: 0;
  font-size: 0.75rem;
  color: #747b81;
  line-height: 1.4; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.division-media {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 14px;
  padding: 14px;
  background: #1e3042;
  border: 1px solid #1c2d38;
  border-radius: 10px; }

.division-media__title {
  margin: 0 0 4px 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: #dfdfdf; }

.division-media__hint {
  margin: 0;
  font-size: 0.8rem;
  color: #b8b8b8;
  line-height: 1.35; }

.division-media__hint--warning {
  color: #ffa600; }

.division-media__picker {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px; }

.division-media__dropRow {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
  align-items: center; }

.division-media__fileName {
  font-size: 0.85rem;
  color: #b8b8b8;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.division-media__previewWrap {
  border-radius: 10px;
  border: 1px solid #1c2d38;
  background: rgba(0, 0, 0, 0.25);
  overflow: hidden; }

.division-media__previewRatio {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9; }

.division-media__previewVideo {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%; }

.division-media__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 12px;
  font-size: 0.85rem;
  color: #b8b8b8;
  text-align: center; }

.division-media__progress {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 10px;
  margin-top: 4px; }

.division-media__bar {
  height: 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  overflow: hidden;
  border: 1px solid #1c2d38; }

.division-media__barFill {
  height: 100%;
  background: #004872;
  width: 0%; }
  .division-media__barFill.p25 {
    width: 25%; }
  .division-media__barFill.p50 {
    width: 50%; }
  .division-media__barFill.p75 {
    width: 75%; }
  .division-media__barFill.p100 {
    width: 100%; }

.division-media__message {
  font-size: 0.82rem;
  color: #b8b8b8; }

.division-media__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 6px; }

.division-media__btn {
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid #1c2d38;
  background: #1c2d38;
  color: #dfdfdf;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 600; }
  .division-media__btn:hover:not(:disabled) {
    background: #2a3847; }
  .division-media__btn:disabled {
    opacity: 0.6;
    cursor: not-allowed; }

.division-media__btn--secondary {
  background: transparent;
  border-color: #1c2d38; }
  .division-media__btn--secondary:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.06); }

.division-media__btn--danger {
  background: #491212;
  border-color: #491212; }
  .division-media__btn--danger:hover:not(:disabled) {
    background: #d12323;
    border-color: #d12323; }

.division-media__fileInput {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important; }

.division-media-trigger-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
  margin-bottom: 8px; }

.modal.division-media-modal {
  position: fixed;
  background: #1e3042;
  color: #dfdfdf;
  padding: 18px 20px 20px 20px;
  border: 1px solid #1c2d38;
  border-radius: 10px;
  max-width: 720px;
  width: 90%;
  max-height: 85vh;
  height: max-content;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow-y: auto;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.55);
  outline: none; }

.division-media-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #1c2d38; }

.division-media-modal__title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #dfdfdf; }

.division-media-modal__close {
  background: transparent;
  border: 0;
  color: #b8b8b8;
  font-size: 1.2rem;
  line-height: 1;
  cursor: pointer;
  padding: 4px 10px;
  border-radius: 4px; }
  .division-media-modal__close:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.06);
    color: #dfdfdf; }
  .division-media-modal__close:disabled {
    opacity: 0.5;
    cursor: not-allowed; }

/* settings.scss*/
@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.settings-h2 {
  color: #b8b8b8;
  text-transform: uppercase;
  margin-top: 20px;
  margin-bottom: 0px; }

.settings-h3 {
  color: #dfdfdf;
  text-transform: uppercase;
  margin-top: 15px;
  margin-bottom: 10px; }

.user-settings-content {
  flex-grow: 1;
  color: #dfdfdf;
  padding: 0 20px;
  width: 100%; }

.user-settings-container {
  display: flex;
  flex-direction: column;
  width: 100%; }

.user-settings-page {
  width: 100%;
  max-width: 1350px;
  margin: 30px auto; }

.settings-container {
  display: flex;
  flex-direction: row;
  /* Les éléments enfants seront alignés horizontalement */ }

.user-settings-content-wrapper {
  display: flex;
  margin-left: 10px;
  margin-bottom: 30px;
  padding-bottom: 30px;
  width: calc(100% - 225px);
  height: auto;
  top: 40px;
  gap: 20px;
  border-radius: 0px 10px 10px 10px;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);
  flex-grow: 1; }

.user-settings-section, .user-admin-section {
  position: relative;
  color: #dfdfdf;
  width: 100%;
  text-transform: uppercase;
  font-size: 0.9rem;
  border-bottom: 2px solid #b8b8b8; }
  .user-settings-section::before, .user-admin-section::before {
    content: "";
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 130px;
    height: 4px;
    background-color: #b8b8b8; }

.user-settings-section {
  margin: 10px 0; }

.last-line {
  margin-bottom: 40px; }

.selection-style, .timezone-selection,
.language-selection, .newsletter-selection {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  padding: 20px 0;
  width: 100%;
  border-bottom: 1px solid #2a3847; }
  .selection-style label, .timezone-selection label, .language-selection label, .newsletter-selection label {
    color: #dfdfdf;
    width: 150px;
    margin-right: 10px; }
  .selection-style select, .timezone-selection select, .language-selection select, .newsletter-selection select, .selection-style .toggle-container, .timezone-selection .toggle-container, .language-selection .toggle-container, .newsletter-selection .toggle-container {
    margin-right: auto;
    margin-left: 50px; }

/* settingmenu.scss (la sidebar) */
@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.user-settings-sidebar {
  flex-shrink: 0; }

.sidebar-menu {
  position: sticky;
  top: 115px;
  width: 200px;
  height: fit-content;
  min-width: 200px;
  overflow-y: auto;
  padding: 20px 10px 20px 10px;
  margin-left: 10px;
  border-radius: 10px 0px 0px 10px;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3); }

.user-settings-sidebar {
  flex-shrink: 0;
  /* Pour éviter que la sidebar rétrécisse */ }

.sidebar-menu a {
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 10px 10px;
  border-left: 8px solid #2a3847;
  font-size: 0.9rem;
  color: #b8b8b8;
  text-decoration: none;
  margin-bottom: 5px;
  align-items: center;
  transition: background-color 0.3s; }
  .sidebar-menu a .desktop-link-unread-circle {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: 12px;
    height: 12px;
    min-width: 12px;
    min-height: 12px;
    box-sizing: border-box;
    border-radius: 50%;
    border: 1px solid #5ac3ff;
    background: transparent;
    flex-shrink: 0;
    pointer-events: none; }

.sidebar-menu a:hover,
.sidebar-menu a:active,
.sidebar-menu a:focus,
.sidebar-menu a.selected {
  background: linear-gradient(90deg, rgba(60, 70, 83, 0) 0%, rgba(71, 94, 113, 0.233) 75%);
  border-left: 8px solid #491212;
  border-right: 2px solid #491212;
  color: #dfdfdf; }

.lock-icon {
  margin-left: auto;
  width: 14px;
  height: 14px;
  color: #d12323; }

.desktop-links {
  display: block; }

.mobile-links {
  display: none; }

.securitPasswordCheck-title {
  color: #dfdfdf;
  text-transform: uppercase;
  padding-bottom: 10px; }

.securitPasswordCheck-granted {
  color: #1f9729;
  font-size: 2rem;
  text-transform: uppercase;
  padding: 10px; }

.password-check-modal {
  display: flex;
  flex-direction: column;
  background-color: #1c2d38;
  width: 100%;
  padding-top: 15px;
  padding-bottom: 30px;
  align-items: center;
  margin-right: auto;
  margin-left: auto;
  border-top: 2px solid #9e2222;
  border-bottom: 2px solid #9e2222; }

.securitPasswordCheck-input {
  display: flex;
  padding: 5px 10px 5px 10px;
  margin-right: auto;
  margin-left: auto; }

.securitPasswordCheck-btn {
  display: flex;
  background-color: #9e2222;
  text-transform: uppercase;
  color: #dfdfdf;
  width: 100%;
  margin-top: 15px;
  margin-right: auto;
  margin-left: auto;
  align-items: center;
  text-align: center;
  padding: 10px;
  border: none;
  border-radius: 5px 5px 5px 5px; }

.securitPasswordCheck-error-message {
  display: flex;
  color: #d12323;
  text-transform: uppercase;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  align-items: center;
  text-align: center;
  margin-top: 10px; }

@media (max-width: 1023px) {
  .desktop-links {
    display: none; }
  .mobile-links {
    display: block; }
  .mobile-accordion {
    background-color: #1c2d38;
    color: #dfdfdf;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-left: auto;
    margin-right: auto;
    padding: 10px 20px 10px 20px;
    border-radius: 10px; }
  .user-settings-content-wrapper {
    display: none; }
  .sidebar-menu {
    background-color: transparent;
    position: relative;
    width: 92%;
    margin-left: 10px;
    margin-right: 10px;
    height: auto;
    box-shadow: none;
    border: 0; }
  .sidebar-menu a:hover {
    border-left: none;
    border-right: none; }
  .sidebar-menu, .mobile-accordion {
    display: block;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 10px;
    padding-right: 10px;
    padding-bottom: 10px;
    padding-left: 10px;
    width: 95%; }
  .mobile-header {
    display: flex;
    justify-content: space-between;
    align-items: center; }
  .header-content {
    display: flex;
    align-items: center; }
  .lock-icon {
    margin-left: 15px;
    width: 14px;
    height: 14px; }
  .accordion-triangle {
    margin-left: 5px; } }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.user-info {
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  background-color: #1c2d38;
  font-size: 0.9rem;
  padding: 5px 0px 15px 0px;
  margin: 20px 20px 10px 0px;
  color: #dfdfdf;
  width: 100%;
  border: 1px solid #b8b8b8;
  border-radius: 6px;
  box-shadow: inset -2px -2px 3px rgba(70, 69, 69, 0.2); }
  .user-info .user-info-left,
  .user-info .user-info-right {
    display: grid;
    flex: 1;
    padding: 0 10px;
    gap: 10px; }

.user-info span {
  color: #b8b8b8;
  font-weight: bold;
  margin-right: 10px; }

.timezone-selection,
.language-selection {
  justify-content: flex-start; }
  .timezone-selection select,
  .language-selection select {
    background-color: #dfdfdf;
    padding: 10px 20px 5px 5px;
    text-align: left;
    border-radius: 4px; }
  .timezone-selection .css-13cymwt-control,
  .language-selection .css-13cymwt-control {
    background-color: #dfdfdf;
    height: 35px;
    min-height: auto;
    font-size: 16px;
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 1px;
    padding-bottom: 1px; }
    .timezone-selection .css-13cymwt-control .css-13cymwt-control:hover,
    .timezone-selection .css-13cymwt-control .css-13cymwt-control:focus,
    .timezone-selection .css-13cymwt-control .css-13cymwt-control:active,
    .timezone-selection .css-13cymwt-control .css-13cymwt-control:target,
    .language-selection .css-13cymwt-control .css-13cymwt-control:hover,
    .language-selection .css-13cymwt-control .css-13cymwt-control:focus,
    .language-selection .css-13cymwt-control .css-13cymwt-control:active,
    .language-selection .css-13cymwt-control .css-13cymwt-control:target {
      font-size: 1rem; }
    .timezone-selection .css-13cymwt-control .css-qbdosj-Input input,
    .language-selection .css-13cymwt-control .css-qbdosj-Input input {
      font-size: 1rem; }
  .timezone-selection .css-1u9des2-indicatorSeparator,
  .language-selection .css-1u9des2-indicatorSeparator {
    background-color: #2a3847; }
  .timezone-selection .css-1xc3v61-indicatorContainer,
  .language-selection .css-1xc3v61-indicatorContainer {
    display: flex;
    transition: color 150ms;
    font-size: 1rem;
    color: #2a3847;
    padding: 8px; }
    .timezone-selection .css-1xc3v61-indicatorContainer .css-1xc3v61-indicatorContainer:hover,
    .language-selection .css-1xc3v61-indicatorContainer .css-1xc3v61-indicatorContainer:hover {
      font-size: 1rem;
      color: #1c2d38; }
  .timezone-selection .css-b62m3t-container,
  .language-selection .css-b62m3t-container {
    bottom: 3px;
    margin-left: 50px;
    position: relative;
    height: 35px;
    box-sizing: border-box;
    width: 250px; }
  .timezone-selection .css-1fdsijx-ValueContainer,
  .language-selection .css-1fdsijx-ValueContainer {
    align-items: center;
    display: grid;
    flex: 1;
    flex-wrap: wrap;
    position: relative;
    overflow: hidden;
    padding: 2px 8px;
    box-sizing: border-box; }

.newsletter-selection .label-container {
  width: 150px;
  margin-right: 10px; }

@media (max-width: 1023px) {
  .avatar-wrapper {
    position: relative;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    overflow: visible;
    margin-left: auto;
    margin-right: 0;
    padding-bottom: 0px;
    box-shadow: none;
    border-left: none;
    border-right: none; }
  .avatar-section {
    flex-direction: row;
    align-items: center;
    gap: 10px; }
  .avatar-wrapper {
    width: 65px;
    height: auto;
    margin-left: 5px;
    margin-right: 0;
    padding-bottom: 0px;
    box-shadow: none; }
  .avatar-icon-wrapper {
    display: none; }
  .avatar-btn {
    display: none; }
  .toggle-container {
    position: relative;
    bottom: 30px;
    left: 120px;
    width: calc(100% - 20px);
    margin-right: 0; }
  .selection-style, .timezone-selection,
  .language-selection, .newsletter-selection {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    padding: 10px 0;
    width: 100%;
    border-bottom: 0px; }
    .selection-style label, .timezone-selection label, .language-selection label, .newsletter-selection label {
      color: #dfdfdf;
      margin-bottom: 10px;
      margin-right: 10px; }
    .selection-style select, .timezone-selection select, .language-selection select, .newsletter-selection select, .selection-style .toggle-container, .timezone-selection .toggle-container, .language-selection .toggle-container, .newsletter-selection .toggle-container {
      position: relative;
      width: calc(100% - 20px);
      margin-right: auto;
      margin-left: auto; }
  .mobil-links {
    background-color: #1c2d38;
    display: block;
    position: fixed;
    overflow-y: auto;
    padding: 0px;
    border-radius: 10px; }
  .settings-h2 {
    visibility: hidden;
    height: 0px; }
  .mobile-upload-btn {
    display: inline-block;
    padding: 8px 16px;
    background-color: #9e2222;
    color: white;
    border-radius: 4px;
    cursor: pointer;
    text-align: center;
    transition: background-color 0.3s; }
    .mobile-upload-btn:hover {
      background-color: #741919; }
  .newsletter-selection {
    flex-direction: column; }
  .newsletter-selection .btn-style1 {
    margin-top: -30px; }
  .newsletter-selection .toggle .toggle-switch {
    height: 23px;
    width: 55px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0; }
  .newsletter-selection .label-container {
    width: 150px;
    margin-right: 10px;
    margin-bottom: 10px; }
  .user-info {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    background-color: #3a4250;
    font-size: 1rem;
    padding-top: 5px;
    padding-bottom: 15px;
    padding-left: 15px;
    padding-right: 15px;
    margin-top: 15px;
    color: #b9cfec;
    margin-left: 10px;
    border: 1px solid #775823;
    border-radius: 6px;
    box-shadow: inset -2px -2px 3px rgba(0, 0, 0, 0.2); }
    .user-info .user-info-left,
    .user-info .user-info-right {
      flex: 1;
      padding: 0 10px; } }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.security-page {
  gap: 0.35rem; }
  .security-page .settings-h2 {
    color: rgba(255, 255, 255, 0.96);
    margin-bottom: 0.35rem; }
  .security-page input,
  .security-page textarea {
    user-select: text; }
  .security-page .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0; }

.security-page .user-settings-section.security-page__section-heading {
  border-bottom-color: rgba(255, 255, 255, 0.2); }
  .security-page .user-settings-section.security-page__section-heading::before {
    background-color: rgba(255, 255, 255, 0.92);
    height: 3px; }
  .security-page .user-settings-section.security-page__section-heading::after {
    content: '';
    display: block;
    margin-top: 8px;
    height: 1px;
    width: 100%;
    background: rgba(255, 255, 255, 0.12); }

.security-page .settings-h3 {
  color: rgba(255, 255, 255, 0.95); }

.security-credentials,
.security-mfa,
.security-sessions,
.security-mobile-login {
  width: 100%; }

.security-card-form {
  width: 100%;
  margin-bottom: 0.75rem; }

.security-card {
  display: grid;
  grid-template-columns: minmax(0, 280px) minmax(10rem, 1fr) auto;
  align-items: center;
  gap: 1.15rem 1.5rem;
  width: 100%;
  box-sizing: border-box;
  padding: 1.15rem 1.35rem;
  margin-bottom: 0.65rem;
  border-radius: 12px;
  background: rgba(18, 32, 48, 0.72);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.22); }

.security-card__lead {
  display: flex;
  align-items: flex-start;
  gap: 0.9rem;
  min-width: 0; }

.security-card__lead--backup {
  align-items: center; }

.security-card__icon-wrap {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.04); }

.security-card__icon {
  font-size: 1.25rem;
  color: rgba(255, 255, 255, 0.88); }

.security-card__copy {
  min-width: 0; }

.security-card__title {
  margin: 0 0 0.2rem;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.95); }

.security-card__subtitle {
  margin: 0;
  font-size: 0.85rem;
  line-height: 1.35;
  color: rgba(223, 223, 223, 0.82); }

.security-card__fields {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem; }

.security-card__fields--password {
  position: relative;
  gap: 0.65rem; }

.security-card__password-bundle {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 0.65rem; }

.security-card__password-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.55rem;
  min-width: 0;
  flex: 1 1 12rem; }

.security-card__input {
  flex: 1 1 8.5rem;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
  padding: 0.55rem 0.75rem;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(223, 223, 223, 0.94);
  color: #1c2d38;
  font-size: 0.9rem;
  outline: none; }
  .security-card__input::placeholder {
    color: rgba(28, 45, 56, 0.45); }
  .security-card__input:focus {
    border-color: rgba(58, 120, 180, 0.65);
    box-shadow: 0 0 0 2px rgba(58, 120, 180, 0.2); }

.security-card__input--email {
  flex: 1 1 100%;
  max-width: 22rem; }

.security-card__info-btn {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  padding: 0;
  border-radius: 50%;
  border: 1px solid rgba(158, 34, 34, 0.55);
  background: rgba(158, 34, 34, 0.12);
  color: #d12323;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s ease, border-color 0.15s ease; }
  .security-card__info-btn:hover, .security-card__info-btn:focus-visible {
    background: rgba(158, 34, 34, 0.22);
    border-color: rgba(209, 35, 35, 0.75);
    outline: none; }

.security-card__info-glyph {
  font-size: 0.75rem;
  font-weight: 800;
  font-style: italic;
  line-height: 1; }

.security-card__tooltip {
  flex: 1 1 100%;
  margin: 0;
  padding: 0.65rem 0.75rem;
  border-radius: 8px;
  font-size: 0.82rem;
  line-height: 1.4;
  color: #dfdfdf;
  background: rgba(73, 18, 18, 0.92);
  border: 1px solid rgba(255, 255, 255, 0.12); }

.security-card__cta {
  justify-self: end;
  display: flex;
  align-items: center; }

.security-card__cta--toggle {
  transform: scale(1.35);
  transform-origin: center right; }

.security-card__mfa-center {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem; }

.security-card__mfa-status,
.security-card__mfa-prompt {
  margin: 0;
  font-size: 0.88rem;
  line-height: 1.35;
  color: rgba(223, 223, 223, 0.9); }

.security-card__mfa-prompt {
  color: rgba(255, 255, 255, 0.88);
  font-weight: 600; }

.security-card__backup-text {
  margin: 0;
  font-size: 0.88rem;
  line-height: 1.4;
  color: rgba(223, 223, 223, 0.9); }

.security-card__alert {
  margin: 0.35rem 0 0;
  padding: 0.5rem 0.65rem;
  border-radius: 8px;
  font-size: 0.85rem;
  color: #dfdfdf;
  background: rgba(73, 18, 18, 0.45);
  border: 1px solid rgba(209, 35, 35, 0.35); }

.security-card__alert-spacer {
  min-height: 0.25rem; }

.btn-security-submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border-radius: 10px !important;
  padding: 0.5rem 1rem !important;
  font-size: 0.68rem !important; }

.security-card--backup {
  grid-template-columns: 1fr auto; }
  .security-card--backup .security-card__lead--backup {
    flex: 1 1 auto; }

.security-page__danger {
  margin-top: 1.5rem; }
  .security-page__danger .account-deletion__disclaimer {
    margin-bottom: 1rem; }

.security-card--sessions {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0;
  grid-template-columns: none; }

.security-card--mobile-login {
  grid-template-columns: minmax(0, 280px) minmax(0, 1fr) auto; }

.security-mobile-login__content {
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.55rem; }

.security-mobile-login__qr-wrap {
  padding: 0.6rem;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 10px;
  border: 1px solid rgba(58, 120, 180, 0.25); }

.security-mobile-login__code-wrap {
  padding: 0.85rem 1rem;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px; }

.security-mobile-login__code {
  color: #ffffff;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 0.08em; }

.security-mobile-login__meta {
  margin: 0;
  font-size: 0.82rem;
  color: rgba(223, 223, 223, 0.85); }

.security-card--sessions-header {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 1rem 1.25rem;
  width: 100%; }

.security-sessions__list {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-right: 10px;
  max-height: calc(100vh - 820px);
  overflow-y: auto; }
  .security-sessions__list::-webkit-scrollbar {
    width: 6px; }
  .security-sessions__list::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .security-sessions__list::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .security-sessions__list::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }

.security-sessions__separator {
  height: 1px;
  width: 100%;
  background: rgba(255, 255, 255, 0.12); }
  .security-sessions__separator--header {
    margin-top: 0.35rem; }

.security-sessions__item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem 1.25rem;
  padding: 0.85rem 0; }

.security-sessions__item--current .security-sessions__device-title {
  color: rgba(255, 255, 255, 0.98); }

.security-sessions__item-actions {
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  padding-top: 0.1rem; }

.security-sessions__status {
  margin: 0.5rem 0 0;
  font-size: 0.88rem;
  color: rgba(223, 223, 223, 0.85); }

.security-sessions__device-main {
  min-width: 0; }

.security-sessions__device-title-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 0.75rem;
  margin-bottom: 0.35rem; }

.security-sessions__device-title {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.96); }

.security-sessions__badge {
  display: inline-flex;
  align-items: center;
  padding: 0.15rem 0.55rem;
  border-radius: 999px;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.95);
  background: rgba(155, 96, 42, 0.7);
  border: 1px solid #c78445; }

.security-sessions__meta {
  margin: 0 0 0.25rem;
  font-size: 0.84rem;
  line-height: 1.35;
  color: rgba(223, 223, 223, 0.82); }

.security-sessions__rename {
  margin-top: 0.65rem; }

.security-sessions__rename-form {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center; }

.security-sessions__rename-input {
  flex: 1 1 12rem;
  max-width: 18rem; }

.security-sessions__rename-link {
  padding: 0;
  border: 0;
  background: transparent;
  color: rgba(58, 120, 180, 0.95);
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px; }
  .security-sessions__rename-link:hover, .security-sessions__rename-link:focus-visible {
    color: rgba(255, 255, 255, 0.95);
    outline: none; }

.security-sessions__rename-cancel {
  background: rgba(28, 45, 56, 0.55) !important; }

.mfa-code-field {
  padding: 5px;
  font-size: 1.2rem;
  margin-top: 10px;
  letter-spacing: 10px;
  width: 165px;
  text-align: center;
  border: 1px solid #b8b8b8;
  outline: none; }

.mfa-code-field::placeholder {
  color: transparent;
  text-shadow: 0 0 0 #000; }

.mfa-code-field:focus::placeholder {
  color: #aaa; }

.btn-style1.mfa {
  width: 177px;
  margin: 15px auto 0 auto; }

.btn-style1.mfa-red {
  background-color: #9e2222;
  color: #dfdfdf;
  width: 177px;
  margin: 15px auto 0 auto; }
  .btn-style1.mfa-red:hover {
    background-color: #d12323; }

.mfa-code-number {
  display: none; }

@media (max-width: 1023px) {
  .security-card {
    grid-template-columns: 1fr;
    align-items: stretch;
    padding: 1rem 1.1rem; }
  .security-card__lead {
    align-items: center; }
  .security-card__cta {
    justify-self: stretch; }
  .security-card__cta--toggle {
    justify-self: end;
    transform: scale(1.2); }
  .btn-security-submit {
    width: 100%;
    justify-content: center; }
  .security-sessions__item {
    flex-direction: column;
    align-items: stretch; }
  .security-card--sessions-header {
    grid-template-columns: 1fr; }
  .security-card--mobile-login {
    grid-template-columns: 1fr; }
  .security-card--sessions-header .security-card__cta {
    justify-self: stretch; }
  .security-sessions__item-actions {
    width: 100%;
    padding-top: 0.35rem; }
    .security-sessions__item-actions .btn-style1.delete.red {
      width: 100%;
      justify-content: center; }
  .security-card__input--email {
    max-width: none; }
  .modal-content-codes {
    z-index: 300; }
  .mfa-modal img {
    display: none; }
  .mfa-code-number {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center; }
    .mfa-code-number .mfa-secret-label {
      color: #0c2637;
      margin-bottom: 10px;
      text-transform: uppercase; }
    .mfa-code-number .mfa-copy-code {
      background-color: #d12323;
      color: #dfdfdf;
      width: auto;
      height: 30px;
      margin-top: 15px;
      margin-bottom: 20px;
      padding: 5px;
      border-color: transparent;
      border-radius: 5px 5px 5px 5px; }
  .modal-left {
    background-color: #dfdfdf;
    width: 100%;
    padding: 10px;
    border-radius: 10px 10px 0 0; }
  .modal-right {
    background-color: #2a3847;
    width: 100%;
    padding: 10px;
    border-radius: 0 0 10px 10px; }
    .modal-right .mfa-bullet-points {
      color: #dfdfdf; }
    .modal-right .desktop {
      display: none; }
    .modal-right .mobile {
      display: block; } }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.tools-page {
  gap: 0.75rem; }
  .tools-page input,
  .tools-page textarea {
    user-select: text; }
  .tools-page .settings-h2 {
    color: rgba(255, 255, 255, 0.96);
    margin-bottom: 0.35rem; }
  .tools-page .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0; }

.tools-page .user-settings-section.tools-page__section-heading {
  border-bottom-color: rgba(255, 255, 255, 0.2); }
  .tools-page .user-settings-section.tools-page__section-heading::before {
    background-color: rgba(255, 255, 255, 0.92);
    height: 3px; }
  .tools-page .user-settings-section.tools-page__section-heading::after {
    content: '';
    display: block;
    margin-top: 8px;
    height: 1px;
    width: 100%;
    background: rgba(255, 255, 255, 0.12); }

.tools-page .settings-h3 {
  color: rgba(255, 255, 255, 0.95); }

.tools-alerts {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  width: 100%;
  margin-bottom: 0.35rem; }

.tools-alert {
  margin: 0;
  padding: 0.65rem 1rem;
  border-radius: 10px;
  font-size: 0.88rem;
  font-weight: 600;
  line-height: 1.35; }

.tools-alert--warning {
  color: rgba(45, 30, 5, 0.95);
  background: rgba(255, 193, 80, 0.92);
  border: 1px solid rgba(180, 100, 0, 0.35); }

.tools-section-stack {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%; }

.tools-card {
  display: grid;
  grid-template-columns: minmax(0, 280px) minmax(8rem, 1fr) auto;
  align-items: center;
  gap: 1.15rem 1.35rem;
  width: 100%;
  box-sizing: border-box;
  padding: 1.15rem 1.35rem;
  border-radius: 12px;
  background: rgba(18, 32, 48, 0.72);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.22); }

.tools-card__lead {
  display: flex;
  align-items: flex-start;
  gap: 0.9rem;
  min-width: 0; }

.tools-card__icon-wrap {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.04);
  overflow: hidden; }

.tools-card__icon-wrap--discord {
  padding: 8px; }
  .tools-card__icon-wrap--discord img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain; }

.tools-card__discord-avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%; }

.tools-card__icon {
  font-size: 1.25rem;
  color: rgba(255, 255, 255, 0.88); }

.tools-card__copy {
  min-width: 0; }

.tools-card__title {
  margin: 0 0 0.2rem;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.95); }

.tools-card__subtitle {
  margin: 0;
  font-size: 0.85rem;
  line-height: 1.35;
  color: rgba(223, 223, 223, 0.82); }

.tools-card__status {
  min-width: 0; }

.tools-card__status-name {
  margin: 0 0 0.15rem;
  font-size: 0.92rem;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.94);
  word-break: break-word; }

.tools-card__status-muted {
  margin: 0;
  font-size: 0.84rem;
  line-height: 1.35;
  color: rgba(223, 223, 223, 0.78); }

.tools-card__cta {
  justify-self: end;
  display: flex;
  align-items: center; }

.btn-tools-submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border-radius: 10px !important;
  padding: 0.5rem 1rem !important;
  font-size: 0.68rem !important; }

.tools-card--wide {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 1rem; }
  .tools-card--wide .tools-card__stretch {
    width: 100%;
    min-width: 0;
    /* Table + toolbar from Handles.jsx */ }
    .tools-card--wide .tools-card__stretch .new-handle {
      margin-top: 0.85rem; }
  .tools-card--wide.tools-card--extension {
    /* PrivateLexical + steps + textarea row */
    /* Darken textarea slightly to match cards */ }
    .tools-card--wide.tools-card--extension .extension-setup-steps h3 {
      color: rgba(255, 255, 255, 0.93);
      font-size: 0.92rem;
      text-transform: uppercase;
      letter-spacing: 0.04em; }
    .tools-card--wide.tools-card--extension .extension-setup-list {
      color: rgba(223, 223, 223, 0.88);
      line-height: 1.45;
      padding-left: 1.2rem; }
    .tools-card--wide.tools-card--extension .extension-token {
      background-color: rgba(223, 223, 223, 0.92);
      color: #1c2d38;
      border-radius: 8px;
      border: 1px solid rgba(255, 255, 255, 0.14); }

.tools-card__lead-inline {
  display: flex;
  align-items: flex-start;
  gap: 0.9rem;
  flex-wrap: wrap; }

@media (max-width: 1023px) {
  .tools-card {
    grid-template-columns: 1fr;
    align-items: stretch; }
  .tools-card__cta {
    justify-self: stretch; }
    .tools-card__cta .btn-tools-submit {
      width: 100%; } }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.account-page {
  gap: 0.75rem; }
  .account-page input,
  .account-page textarea {
    user-select: text; }
  .account-page .settings-h2 {
    color: rgba(255, 255, 255, 0.96);
    margin-bottom: 0.35rem; }
  .account-page .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0; }

.account-page .user-settings-section.account-page__section-heading {
  margin-top: 0.65rem;
  border-bottom-color: rgba(255, 255, 255, 0.2); }
  .account-page .user-settings-section.account-page__section-heading::before {
    background-color: rgba(255, 255, 255, 0.92);
    height: 3px; }
  .account-page .user-settings-section.account-page__section-heading::after {
    content: '';
    display: block;
    margin-top: 8px;
    height: 1px;
    width: 100%;
    background: rgba(255, 255, 255, 0.12); }

.account-page .settings-h3 {
  color: rgba(255, 255, 255, 0.95); }

.account-stack {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%; }

.account-card {
  box-sizing: border-box;
  width: 100%;
  padding: 1.15rem 1.35rem;
  border-radius: 12px;
  background: rgba(18, 32, 48, 0.72);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.22); }

.account-card__lead {
  display: flex;
  align-items: flex-start;
  gap: 0.9rem;
  min-width: 0; }

.account-card__icon-wrap {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.04); }

.account-card__icon {
  font-size: 1.25rem;
  color: rgba(255, 255, 255, 0.88); }

.account-card__copy {
  min-width: 0; }

.account-card__title {
  margin: 0 0 0.2rem;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.95); }

.account-card__subtitle {
  margin: 0;
  font-size: 0.85rem;
  line-height: 1.35;
  color: rgba(223, 223, 223, 0.82); }

.account-card--summary {
  display: flex;
  flex-direction: column;
  gap: 1.1rem; }

.account-card__metrics dl {
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.85rem; }

.account-metric {
  display: grid;
  grid-template-columns: minmax(7.5rem, 11rem) 1fr;
  gap: 0.35rem 1rem;
  align-items: baseline; }

.account-metric__label {
  margin: 0;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: rgba(184, 184, 184, 0.92); }

.account-metric__value {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.35;
  color: rgba(255, 255, 255, 0.93);
  word-break: break-word; }

.account-card--control {
  display: flex;
  flex-direction: column;
  gap: 1rem; }

.account-card__control-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1rem; }

.account-card__control {
  flex: 1 1 16rem;
  min-width: 0;
  max-width: 28rem; }
  .account-card__control:last-child:first-child {
    max-width: 100%; }

.account-page .acct-rs__control {
  min-height: 38px;
  border-radius: 8px !important;
  border: 1px solid rgba(255, 255, 255, 0.24) !important;
  background-color: rgba(223, 223, 223, 0.94) !important;
  box-shadow: none !important;
  cursor: pointer; }

.account-page .acct-rs__control:hover {
  border-color: rgba(58, 120, 180, 0.45) !important; }

.account-page .acct-rs__single-value {
  color: #1c2d38;
  font-size: 0.9rem; }

.account-page .acct-rs__placeholder {
  color: rgba(28, 45, 56, 0.45);
  font-size: 0.88rem; }

.account-page .acct-rs__indicator-separator {
  background-color: #2a3847 !important; }

.account-page .acct-rs__dropdown-indicator {
  color: #2a3847 !important;
  padding: 6px !important; }

.account-page .acct-rs__dropdown-indicator:hover {
  color: #1c2d38 !important; }

.account-page .acct-rs__menu {
  z-index: 20;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(28, 45, 60, 0.98);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35); }

.account-page .acct-rs__menu-list {
  padding: 4px; }

.account-page .acct-rs__option {
  color: rgba(223, 223, 223, 0.95);
  font-size: 0.88rem;
  border-radius: 6px;
  cursor: pointer; }

.account-page .acct-rs__option--is-focused {
  background: rgba(58, 120, 180, 0.22) !important; }

.account-page .acct-rs__option--is-selected {
  background: rgba(58, 120, 180, 0.42) !important;
  color: #ffffff; }

.account-page .acct-rs__input-container {
  color: #1c2d38; }

.account-page .acct-rs__input {
  color: #1c2d38 !important; }

.account-card--profile-theme {
  display: flex;
  flex-direction: column;
  gap: 0.85rem; }

.account-profile-theme__error {
  margin: 0;
  color: #9e2222;
  font-size: 0.9rem; }

.account-profile-theme__status {
  margin: 0;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9rem; }

.account-profile-theme__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 0.75rem;
  max-height: 17.5rem;
  overflow-x: hidden;
  overflow-y: auto;
  margin-right: -10px;
  padding-right: 10px;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.35) rgba(0, 0, 0, 0.12); }
  .account-profile-theme__grid::-webkit-scrollbar {
    width: 6px; }
  .account-profile-theme__grid::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.12);
    border-radius: 999px; }
  .account-profile-theme__grid::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.3);
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.08); }
  .account-profile-theme__grid::-webkit-scrollbar-thumb:hover {
    background: rgba(58, 120, 180, 0.42); }

.account-profile-theme__option {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.35rem;
  padding: 0.75rem;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(8, 18, 30, 0.55);
  color: #ffffff;
  cursor: pointer;
  text-align: left; }

.account-profile-theme__option:hover:not(:disabled) {
  border-color: rgba(255, 255, 255, 0.28); }

.account-profile-theme__option.is-preview {
  border-color: rgba(90, 195, 255, 0.85);
  box-shadow: 0 0 0 1px rgba(90, 195, 255, 0.45); }

.account-profile-theme__option.is-locked .account-profile-theme__swatch {
  filter: saturate(0.72) brightness(0.88); }

.account-profile-theme__option:disabled {
  opacity: 0.65;
  cursor: wait; }

.account-profile-theme__badge {
  position: absolute;
  right: 0.45rem;
  bottom: 0.45rem;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.45rem;
  height: 1.45rem;
  border-radius: 999px;
  font-size: 0.95rem;
  line-height: 1;
  pointer-events: none;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.45); }

.account-profile-theme__badge--applied {
  color: #5aa05c;
  background: rgba(8, 18, 30, 0.88); }

.account-profile-theme__badge--locked {
  color: #e8c547;
  background: rgba(8, 18, 30, 0.88); }

.account-profile-theme__option.is-applied.is-locked .account-profile-theme__badge--locked {
  right: 2rem; }

.account-profile-theme__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem 1rem; }

.account-profile-theme__apply {
  appearance: none;
  border: 1px solid rgba(90, 160, 92, 0.55);
  background: rgba(90, 160, 92, 0.18);
  color: #ffffff;
  border-radius: 8px;
  padding: 0.55rem 1.1rem;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer; }

.account-profile-theme__apply:hover:not(:disabled) {
  background: rgba(90, 160, 92, 0.28);
  border-color: rgba(90, 160, 92, 0.8); }

.account-profile-theme__apply:disabled {
  opacity: 0.45;
  cursor: not-allowed; }

.account-profile-theme__hint {
  margin: 0;
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.55); }

.account-profile-theme__swatch {
  position: relative;
  display: block;
  width: 100%;
  height: 72px;
  border-radius: 8px;
  overflow: hidden;
  isolation: isolate;
  background: linear-gradient(135deg, #1c2d38, #384858);
  pointer-events: none; }

.account-profile-theme__swatch--none {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.02)); }

.account-profile-theme__swatch--live {
  background: rgba(6, 12, 20, 0.95); }

.account-profile-theme__swatch--legacy-space {
  background: radial-gradient(circle at 30% 40%, #225891, #163a5f 70%); }

.account-profile-theme__swatch-media,
.account-profile-theme__swatch .perk-theme-media {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 1; }

.account-profile-theme__swatch .perk-theme-media__img,
.account-profile-theme__swatch .perk-theme-media__video {
  width: 100%;
  height: 100%;
  object-fit: cover; }

.account-profile-theme__swatch .perk-theme-frame-halo {
  position: absolute;
  inset: 0;
  z-index: 4;
  pointer-events: none; }

.account-profile-theme__swatch .perk-theme-underlay {
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none; }

.account-profile-theme__swatch .perk-theme-overlay,
.account-profile-theme__swatch .member-profile-card-popover__shooting-star,
.account-profile-theme__swatch-nebula-morph {
  position: absolute;
  inset: 0;
  z-index: 3;
  pointer-events: none; }

.account-profile-theme__swatch-nebula-morph {
  background: radial-gradient(ellipse at 40% 35%, rgba(255, 255, 255, 0.18), transparent 55%), radial-gradient(ellipse at 70% 65%, rgba(232, 197, 71, 0.22), transparent 50%);
  animation: account-profile-theme-swatch-morph 6s ease-in-out infinite alternate; }

@keyframes account-profile-theme-swatch-morph {
  from {
    opacity: 0.55;
    transform: scale(1); }
  to {
    opacity: 0.9;
    transform: scale(1.08); } }

.account-profile-theme__option-name {
  font-size: 0.92rem;
  font-weight: 600; }

.account-profile-theme__option-meta {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.55); }

.account-profile-theme__live-preview {
  margin-top: 0.35rem;
  padding: 0.75rem; }

.account-profile-theme__live-preview .profile-themes-preview__card-shell {
  width: 100%;
  max-width: 280px; }

@media (max-width: 1023px) {
  .account-metric {
    grid-template-columns: 1fr; }
  .account-card__control {
    max-width: none;
    width: 100%;
    flex-basis: 100%; }
  .account-card__control-row {
    align-items: stretch;
    flex-direction: column; }
  .account-profile-theme__live-preview .profile-themes-preview__stack--row {
    grid-template-columns: 1fr; }
  .account-profile-theme__live-preview .profile-themes-preview__card-shell {
    max-width: none; } }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.admin-h2 {
  color: #b8b8b8;
  text-transform: uppercase;
  margin-top: 15px;
  margin-bottom: 0px; }

.admin-h3 {
  color: #dfdfdf;
  text-transform: uppercase;
  margin-top: 10px;
  margin-bottom: 5px;
  margin-left: 0px; }

.admin-h4 {
  color: #dfdfdf;
  text-transform: uppercase;
  font-size: 0.9rem;
  margin-left: 15px; }

.user-admin-content {
  flex-grow: 1;
  padding: 0 10px;
  width: 100%;
  max-width: 100%;
  min-width: 0; }

.user-admin-page {
  margin: 20px auto;
  width: 1460px;
  max-width: 100%;
  transform: translateX(-20px); }
  .user-admin-page:has(.admin-layout--lexical) {
    width: 1250px;
    transform: translateX(-125px); }

.admin-container {
  margin-top: 70px;
  display: flex;
  flex-direction: row;
  /* Les éléments enfants seront alignés horizontalement */
  max-width: 100%;
  min-width: 0; }

.user-admin-content-wrapper {
  display: flex;
  margin-left: 10px;
  width: auto;
  max-width: 100%;
  min-width: 0;
  height: auto;
  gap: 20px;
  border-radius: 0px 10px 10px 10px;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);
  flex-grow: 1; }

.user-settings-section, .user-admin-section {
  position: relative;
  color: #dfdfdf;
  width: 100%;
  text-transform: uppercase;
  font-size: 0.9rem;
  border-bottom: 2px solid #b8b8b8; }
  .user-settings-section::before, .user-admin-section::before {
    content: "";
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 130px;
    height: 4px;
    background-color: #b8b8b8; }

.user-admin-section {
  margin: 5px 0px 10px 0; }

.selection-style, .timezone-selection,
.language-selection, .newsletter-selection {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 20px 0;
  width: 100%;
  border-bottom: none; }
  .selection-style label, .timezone-selection label, .language-selection label, .newsletter-selection label {
    color: #dfdfdf;
    width: 150px;
    margin-right: 10px; }
  .selection-style select, .timezone-selection select, .language-selection select, .newsletter-selection select, .selection-style .toggle-container, .timezone-selection .toggle-container, .language-selection .toggle-container, .newsletter-selection .toggle-container {
    margin-right: auto;
    margin-left: 50px;
    margin-bottom: 0px; }

.disabled-container {
  opacity: 0.3;
  pointer-events: none; }

.admin-header {
  display: flex;
  align-items: center;
  justify-content: space-between; }

.server-status-widget {
  position: absolute;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto;
  grid-column-gap: 16px;
  grid-row-gap: 6px;
  background: #1c2d38;
  color: #b8b8b8;
  border: 1px solid #b8b8b8;
  border-radius: 6px;
  font-size: 0.85rem;
  padding: 6px 10px;
  top: 10px;
  right: 10px; }

.server-status-widget span {
  white-space: nowrap; }

.server-status-widget .danger {
  color: #d12323; }

.gear-loadout-page {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: hidden;
  /* Children (carousel) must not inflate the admin page past \$full-width. */
  contain: inline-size; }

.gear-loadout-layout {
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  gap: 16px;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin-top: 16px;
  /*
   * Avant: builder 37% (1 col) / viewer 63%.
   * 2 cols slots à −40% chacune → 2 × (37% × 0.6) ≈ 44% builder ; viewer un peu réduit.
   */ }
  .gear-loadout-layout > .admin-block-container {
    box-sizing: border-box;
    min-width: 0;
    padding: 12px;
    border: 1px solid #163447;
    border-radius: 8px;
    background: #151c24;
    box-shadow: none; }
  .gear-loadout-layout .gear-loadout-builder-block {
    flex: 0 0 calc(44% - 8px);
    width: calc(44% - 8px);
    max-width: calc(44% - 8px); }
  .gear-loadout-layout .gear-loadout-mannequin-block {
    flex: 1 1 calc(56% - 8px);
    width: auto;
    max-width: calc(56% - 8px);
    min-width: 0; }
  @media (max-width: 1100px) {
    .gear-loadout-layout {
      flex-wrap: wrap; }
      .gear-loadout-layout .gear-loadout-builder-block,
      .gear-loadout-layout .gear-loadout-mannequin-block {
        flex: 1 1 100%;
        width: 100%;
        max-width: 100%; } }

.gear-loadout-setups-bar {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  contain: inline-size;
  padding: 12px;
  border: 1px solid #163447;
  border-radius: 8px;
  background: #151c24;
  box-shadow: none; }

.gear-loadout-mannequin {
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 2px; }
  .gear-loadout-mannequin .field-label {
    color: #747b81;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase; }
  .gear-loadout-mannequin__header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 10px; }
  .gear-loadout-mannequin__sex {
    display: inline-flex;
    align-items: center;
    gap: 6px; }
  .gear-loadout-mannequin__sex-btn {
    margin: 0;
    padding: 6px 12px;
    border: 1px solid #384858;
    border-radius: 6px;
    background: #0c2637;
    color: #b8b8b8;
    font-size: 0.8rem;
    font-weight: 600;
    text-transform: uppercase;
    cursor: pointer; }
  .gear-loadout-mannequin__sex-btn--active {
    border-color: #3a78b4;
    background: #172738;
    color: #dfdfdf; }
  .gear-loadout-mannequin__poses {
    display: flex;
    flex-direction: column;
    gap: 8px; }
  .gear-loadout-mannequin__pose-list {
    display: flex;
    flex-wrap: wrap;
    gap: 6px; }
  .gear-loadout-mannequin__pose-btn {
    margin: 0;
    padding: 6px 10px;
    border: 1px solid #384858;
    border-radius: 6px;
    background: #0c2637;
    color: #b8b8b8;
    font-size: 0.78rem;
    font-weight: 600;
    cursor: pointer; }
  .gear-loadout-mannequin__pose-btn--active {
    border-color: #3a78b4;
    background: #172738;
    color: #dfdfdf; }
  .gear-loadout-mannequin__pose-btn--pending, .gear-loadout-mannequin__stance-btn--pending {
    opacity: 0.45;
    cursor: default; }
  .gear-loadout-mannequin__chf {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
    margin-top: 4px; }
  .gear-loadout-mannequin__chf-kicker {
    color: #747b81;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase; }
  .gear-loadout-mannequin__chf-label {
    position: relative;
    display: inline-flex;
    align-items: center;
    margin: 0;
    cursor: pointer; }
  .gear-loadout-mannequin__chf-btn {
    display: inline-flex;
    align-items: center;
    padding: 6px 10px;
    border: 1px solid #384858;
    border-radius: 6px;
    background: #0c2637;
    color: #b8b8b8;
    font-size: 0.75rem;
    font-weight: 600; }
  .gear-loadout-mannequin__chf-input {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0; }
  .gear-loadout-mannequin__chf-name {
    color: #747b81;
    font-size: 0.75rem; }
  .gear-loadout-mannequin__appearance {
    display: flex;
    flex-direction: column;
    gap: 8px; }
  .gear-loadout-mannequin__appear-row {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 8px;
    width: 100%; }
  .gear-loadout-mannequin__appear-k {
    flex: 0 0 6.6rem;
    min-width: 6.6rem;
    color: #b8b8b8;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase; }
  .gear-loadout-mannequin__appear-track {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px; }
  .gear-loadout-mannequin__skin-slider {
    width: 100%;
    margin: 0;
    accent-color: #b8b8b8;
    cursor: pointer; }
  .gear-loadout-mannequin__hair-count {
    flex: 0 0 3.6rem;
    min-width: 3.6rem;
    color: #b8b8b8;
    font-size: 0.75rem;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    text-align: right; }
  .gear-loadout-mannequin__appear-name {
    color: #384858;
    font-size: 0.68rem;
    font-weight: 500;
    line-height: 1.2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; }
  .gear-loadout-mannequin__appear-debug {
    margin-top: 4px;
    color: #384858;
    font-size: 0.72rem; }
    .gear-loadout-mannequin__appear-debug summary {
      cursor: pointer;
      font-weight: 600;
      text-transform: uppercase;
      color: #b8b8b8; }
  .gear-loadout-mannequin__hair-layer {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: #b8b8b8;
    font-size: 0.72rem;
    font-weight: 600;
    text-transform: uppercase;
    cursor: pointer; }
  .gear-loadout-mannequin__appear-hint {
    margin: 0 0 0 2.6rem;
    color: #384858;
    font-size: 0.7rem; }
  .gear-loadout-mannequin__dye-block {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #384858; }
  .gear-loadout-mannequin__dye-title {
    color: #b8b8b8;
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: uppercase; }
  .gear-loadout-mannequin__dye-color-track {
    flex-direction: row;
    align-items: center;
    gap: 8px; }
  .gear-loadout-mannequin__dye-color {
    width: 2rem;
    height: 1.4rem;
    padding: 0;
    border: 1px solid #384858;
    border-radius: 4px;
    background: #0c2637;
    cursor: pointer; }
  .gear-loadout-mannequin__dye-flags {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px; }
  .gear-loadout-mannequin__beard-prims {
    display: flex;
    flex-direction: column;
    gap: 6px; }
  .gear-loadout-mannequin__beard-prims-empty {
    margin: 0;
    color: #384858;
    font-size: 0.7rem; }
  .gear-loadout-mannequin__beard-prim {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    margin: 0;
    color: #b8b8b8;
    font-size: 0.68rem;
    font-weight: 500;
    line-height: 1.35;
    cursor: pointer; }
    .gear-loadout-mannequin__beard-prim span {
      font-family: Consolas, "Courier New", monospace; }
  .gear-loadout-mannequin__hair-select {
    min-width: 12rem;
    max-width: 100%;
    margin: 0;
    padding: 6px 8px;
    border: 1px solid #384858;
    border-radius: 6px;
    background: #0c2637;
    color: #b8b8b8;
    font-size: 0.78rem;
    font-weight: 600;
    cursor: pointer; }
  .gear-loadout-mannequin__stance {
    display: flex;
    flex-direction: column;
    gap: 6px; }
  .gear-loadout-mannequin__stance-list {
    display: inline-flex;
    align-items: center;
    gap: 6px; }
  .gear-loadout-mannequin__stance-btn {
    margin: 0;
    padding: 6px 12px;
    border: 1px solid #384858;
    border-radius: 6px;
    background: #0c2637;
    color: #b8b8b8;
    font-size: 0.8rem;
    font-weight: 600;
    text-transform: uppercase;
    cursor: pointer; }
  .gear-loadout-mannequin__stance-btn--active {
    border-color: #3a78b4;
    background: #172738;
    color: #dfdfdf; }
  .gear-loadout-mannequin__pose-note {
    margin: 0;
    color: #384858;
    font-size: 0.75rem;
    line-height: 1.35; }
  .gear-loadout-mannequin__debug {
    display: none;
    position: absolute;
    left: 0.55rem;
    bottom: 0.55rem;
    z-index: 4;
    flex-direction: column;
    align-items: stretch;
    gap: 0.35rem;
    max-width: min(26rem, 78%);
    max-height: calc(100% - 1.1rem);
    overflow: hidden;
    pointer-events: auto; }
  .gear-loadout-mannequin__debug-toggle {
    margin: 0;
    padding: 0.15rem 0.5rem;
    border: 1px solid rgba(56, 72, 88, 0.7);
    border-radius: 6px;
    background: rgba(0, 48, 77, 0.55);
    color: rgba(223, 223, 223, 0.55);
    font-size: 0.68rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    cursor: pointer;
    flex: 0 0 auto;
    align-self: flex-start; }
  .gear-loadout-mannequin__debug--open .gear-loadout-mannequin__debug-toggle {
    border-color: #3a78b4; }
  .gear-loadout-mannequin__debug-body {
    margin: 0;
    max-height: 8rem;
    overflow: auto;
    padding: 0.4rem 0.55rem;
    border: 1px solid #384858;
    border-radius: 6px;
    background: rgba(0, 48, 77, 0.88);
    color: #dfdfdf;
    font-size: 0.68rem;
    line-height: 1.35;
    font-family: Consolas, "Courier New", monospace;
    white-space: pre-wrap;
    flex: 0 0 auto; }
  .gear-loadout-mannequin__debug-stack {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    max-width: 100%;
    min-height: 0;
    flex: 1 1 auto;
    overflow-x: hidden;
    overflow-y: auto; }
  .gear-loadout-mannequin__debug-prims {
    max-height: none;
    overflow: visible;
    padding: 0.4rem 0.55rem;
    border: 1px solid #384858;
    border-radius: 6px;
    background: rgba(0, 48, 77, 0.88);
    flex: 0 0 auto; }
  .gear-loadout-mannequin__debug-prims-title {
    margin: 0 0 0.35rem;
    color: #b8b8b8;
    font-size: 0.68rem;
    font-weight: 700;
    text-transform: uppercase; }
  .gear-loadout-mannequin__debug-prim {
    display: flex;
    align-items: flex-start;
    gap: 0.4rem;
    margin: 0 0 0.35rem;
    color: #dfdfdf;
    font-size: 0.68rem;
    line-height: 1.3;
    cursor: pointer; }
  .gear-loadout-mannequin__debug-skin-note {
    margin: 0.2rem 0 0;
    color: #b8b8b8;
    font-size: 0.64rem;
    line-height: 1.3; }
  .gear-loadout-mannequin__debug-seam {
    margin: 0.35rem 0 0;
    max-height: 16rem;
    overflow: auto;
    padding: 0.35rem 0.4rem;
    border: 1px solid #384858;
    border-radius: 4px;
    background: #0c2637;
    color: #dfdfdf;
    font-size: 0.62rem;
    line-height: 1.35;
    font-family: Consolas, "Courier New", monospace;
    white-space: pre-wrap; }
  .gear-loadout-mannequin__viewer {
    position: relative;
    flex: 1 1 auto;
    width: 100%;
    min-height: 620px;
    height: calc(100vh - 260px);
    max-height: 840px;
    overflow: hidden;
    border-radius: 8px; }
    .gear-loadout-mannequin__viewer .personal-hub-blueprint-model {
      min-height: 620px;
      height: 100%;
      border-color: rgba(58, 120, 180, 0.22);
      border-radius: 8px; }
    .gear-loadout-mannequin__viewer .personal-hub-blueprint-model--bg-default {
      background: radial-gradient(ellipse 24% 58% at 50% 0%, rgba(90, 195, 255, 0.14), transparent 72%), radial-gradient(circle at 50% 48%, transparent 32%, rgba(0, 0, 0, 0.46) 100%), linear-gradient(180deg, #0c1a28 0%, #071018 100%); }
    .gear-loadout-mannequin__viewer .personal-hub-blueprint-model::after {
      content: "";
      position: absolute;
      inset: 0;
      pointer-events: none;
      z-index: 2;
      box-shadow: inset 0 0 88px rgba(0, 0, 0, 0.46); }
    .gear-loadout-mannequin__viewer::before {
      content: "";
      position: absolute;
      left: 50%;
      top: 0;
      z-index: 2;
      width: 22%;
      height: 82%;
      transform: translateX(-50%);
      pointer-events: none;
      background: linear-gradient(180deg, rgba(90, 195, 255, 0.34) 0%, rgba(90, 195, 255, 0.16) 16%, rgba(58, 120, 180, 0.09) 46%, rgba(90, 195, 255, 0.04) 76%, transparent 100%);
      mask-image: linear-gradient(90deg, transparent 0%, #000 38%, #000 62%, transparent 100%);
      -webkit-mask-image: linear-gradient(90deg, transparent 0%, #000 38%, #000 62%, transparent 100%);
      mix-blend-mode: screen; }
    .gear-loadout-mannequin__viewer .personal-hub-blueprint-model__canvas {
      width: 100%;
      height: 100%;
      min-height: 620px; }
  .gear-loadout-mannequin__viewer-loading {
    position: absolute;
    inset: 0;
    z-index: 4;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.46); }
    .gear-loadout-mannequin__viewer-loading .spinner-container {
      height: auto;
      width: auto;
      top: auto; }
  .gear-loadout-mannequin__status {
    margin: 0;
    color: #b8b8b8;
    font-size: 0.9rem; }
  .gear-loadout-mannequin__status--error {
    color: #d12323; }
  .gear-loadout-mannequin__meta {
    margin: 0;
    color: rgba(56, 72, 88, 0.55);
    font-size: 0.64rem;
    line-height: 1.35;
    word-break: break-all; }

.gear-loadout-panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 0;
  overflow: hidden; }
  .gear-loadout-panel .field-label {
    color: #747b81;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase; }

.gear-loadout-setups {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  /* Scrollport: fixed to parent width. Inner list may be wider. */ }
  .gear-loadout-setups__toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 12px 16px;
    max-width: 100%;
    min-width: 0; }
  .gear-loadout-setups__toolbar-main {
    display: flex;
    align-items: center;
    gap: 10px; }
  .gear-loadout-setups__name-wrap {
    display: flex;
    flex: 1 1 220px;
    flex-direction: column;
    gap: 4px;
    min-width: 180px;
    max-width: 320px; }
  .gear-loadout-setups__carousel {
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    overflow-x: auto;
    overflow-y: hidden;
    overscroll-behavior-x: contain; }
    .gear-loadout-setups__carousel::-webkit-scrollbar {
      width: 6px; }
    .gear-loadout-setups__carousel::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .gear-loadout-setups__carousel::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .gear-loadout-setups__carousel::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
  .gear-loadout-setups__list {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: stretch;
    gap: 8px;
    box-sizing: border-box;
    width: max-content;
    max-width: none;
    min-width: 0;
    max-height: none;
    margin: 0;
    padding: 4px 2px 8px;
    overflow: visible;
    list-style: none; }
  .gear-loadout-setups__item {
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    gap: 6px;
    width: 200px;
    max-width: 200px;
    margin: 0;
    padding: 6px 8px;
    border: 1px solid #163447;
    border-radius: 8px;
    background: #0c2637;
    color: #b8b8b8; }
  .gear-loadout-setups__item--active {
    border-color: rgba(90, 195, 255, 0.75);
    background: rgba(23, 39, 56, 0.9);
    color: #dfdfdf; }
  .gear-loadout-setups__item--dragging {
    opacity: 0.85;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.45);
    z-index: 2; }
  .gear-loadout-setups__drag {
    flex: 0 0 auto;
    margin: 0;
    padding: 2px 4px;
    border: 0;
    border-radius: 4px;
    background: transparent;
    color: #747b81;
    font-size: 0.7rem;
    letter-spacing: -0.08em;
    line-height: 1;
    cursor: grab; }
  .gear-loadout-setups__drag:active {
    cursor: grabbing; }
  .gear-loadout-setups__drag:disabled {
    opacity: 0.4;
    cursor: default; }
  .gear-loadout-setups__item-main {
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    gap: 8px;
    min-width: 0;
    margin: 0;
    padding: 2px 0;
    border: 0;
    background: transparent;
    color: inherit;
    text-align: left;
    cursor: pointer; }
  .gear-loadout-setups__thumb {
    flex: 0 0 36px;
    width: 36px;
    height: 36px;
    border-radius: 5px;
    border: 1px solid #163447;
    background: #172738; }
    .gear-loadout-setups__thumb::after {
      content: "";
      display: block;
      width: 100%;
      height: 100%;
      background: #747b81;
      mask-repeat: no-repeat;
      mask-position: center;
      mask-size: 16px 16px;
      -webkit-mask-repeat: no-repeat;
      -webkit-mask-position: center;
      -webkit-mask-size: 16px 16px;
      mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
      -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___}); }
  .gear-loadout-setups__item-text {
    display: flex;
    flex: 1 1 auto;
    min-width: 0;
    flex-direction: column;
    gap: 1px; }
  .gear-loadout-setups__item-name {
    overflow: hidden;
    color: inherit;
    font-size: 0.8rem;
    font-weight: 600;
    text-overflow: ellipsis;
    white-space: nowrap; }
  .gear-loadout-setups__item-sub {
    color: #747b81;
    font-size: 0.68rem; }
  .gear-loadout-setups__item-tools {
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    gap: 2px; }
  .gear-loadout-setups__icon-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    margin: 0;
    padding: 0;
    border: 0;
    border-radius: 4px;
    background: transparent;
    cursor: pointer; }
  .gear-loadout-setups__icon-btn:hover, .gear-loadout-setups__icon-btn:focus-visible {
    background: rgba(58, 120, 180, 0.22); }
  .gear-loadout-setups__icon-btn--danger:hover, .gear-loadout-setups__icon-btn--danger:focus-visible {
    background: rgba(209, 35, 35, 0.18); }
  .gear-loadout-setups__icon-btn:disabled {
    opacity: 0.45;
    cursor: default; }
  .gear-loadout-setups__icon {
    display: block;
    width: 14px;
    height: 14px;
    background: #b8b8b8;
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    -webkit-mask-size: contain; }
  .gear-loadout-setups__icon--edit {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
    -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___}); }
  .gear-loadout-setups__icon--trash {
    background: #d12323;
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
    -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___}); }
  .gear-loadout-setups__icon--plus {
    width: 12px;
    height: 12px;
    background: #5ac3ff;
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
    -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___}); }
  .gear-loadout-setups__new {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    width: auto;
    margin: 0;
    padding: 7px 12px;
    border: 1px solid #5ac3ff;
    border-radius: 6px;
    background: transparent;
    color: #5ac3ff;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    cursor: pointer; }
  .gear-loadout-setups__new:disabled {
    opacity: 0.45;
    cursor: default; }
  .gear-loadout-setups__empty {
    margin: 0;
    color: #747b81;
    font-size: 0.75rem; }
  .gear-loadout-setups__item--skeleton {
    pointer-events: none;
    min-height: 48px; }
  .gear-loadout-setups__skeleton-bar {
    display: block;
    height: 10px;
    border-radius: 4px;
    background: #384858;
    animation: gear-loadout-setups-pulse 1.1s ease-in-out infinite; }
  .gear-loadout-setups__skeleton-bar--name {
    width: 58%;
    height: 12px; }
  .gear-loadout-setups__skeleton-bar--sub {
    width: 34%;
    height: 8px;
    margin-top: 6px;
    opacity: 0.7; }
  .gear-loadout-setups__name {
    width: 100%;
    max-width: none;
    box-sizing: border-box;
    appearance: none;
    padding: 8px 10px;
    border: 1px solid #163447;
    border-radius: 6px;
    background: #0c2637;
    color: #dfdfdf;
    font-size: 0.85rem;
    color-scheme: dark; }
  .gear-loadout-setups__name:focus {
    outline: none;
    border-color: #3a78b4; }
  .gear-loadout-setups__name:disabled {
    opacity: 0.55; }
  .gear-loadout-setups__status {
    margin: 0;
    color: #747b81;
    font-size: 0.75rem;
    flex: 1 1 100%; }

@keyframes gear-loadout-setups-pulse {
  0%,
  100% {
    opacity: 0.4; }
  50% {
    opacity: 0.85; } }

.gear-loadout-confirm {
  position: fixed;
  inset: 0;
  z-index: 20000;
  display: grid;
  place-items: center;
  background: rgba(0, 0, 0, 0.6); }

.gear-loadout-confirm__card {
  width: min(92vw, 440px);
  padding: 20px;
  border: 1px solid #384858;
  border-radius: 10px;
  background: #1c2d38;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4); }

.gear-loadout-confirm__title {
  margin: 0 0 10px;
  color: #dfdfdf;
  font-size: 1rem;
  font-weight: 700; }

.gear-loadout-confirm__message {
  margin: 0;
  color: #b8b8b8;
  font-size: 0.9rem;
  line-height: 1.4; }

.gear-loadout-confirm__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 18px; }

.gear-loadout-confirm__btn {
  margin: 0;
  padding: 8px 14px;
  border: 1px solid #384858;
  border-radius: 6px;
  background: transparent;
  color: #dfdfdf;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  cursor: pointer; }

.gear-loadout-confirm__btn--confirm {
  border-color: #3a78b4; }

.gear-loadout-confirm__btn--danger {
  border-color: #d12323;
  color: #d12323; }

.gear-loadout-confirm__btn:disabled {
  opacity: 0.45;
  cursor: default; }

.gear-loadout-slots {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 100%;
  min-width: 0; }
  .gear-loadout-slots__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px; }
  .gear-loadout-slots__count {
    color: #747b81;
    font-size: 0.68rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase; }
  .gear-loadout-slots__grid {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 8px;
    align-items: start;
    width: 100%;
    max-width: 100%;
    min-width: 0; }
  .gear-loadout-slots__col {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
    max-width: 100%;
    padding: 8px;
    border: 1px solid rgba(90, 195, 255, 0.35);
    border-radius: 8px;
    background: rgba(12, 38, 55, 0.45); }
  .gear-loadout-slots__col-title {
    margin: 0;
    color: #dfdfdf;
    font-size: 0.64rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase; }
  .gear-loadout-slots__list {
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin: 0;
    padding: 0;
    list-style: none;
    min-width: 0; }
  .gear-loadout-slots__row {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    min-width: 0; }
  @media (max-width: 700px) {
    .gear-loadout-slots__grid {
      grid-template-columns: minmax(0, 1fr); } }

.gear-loadout-slot {
  position: relative;
  display: flex;
  align-items: stretch;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin: 0;
  border: 1px solid rgba(90, 195, 255, 0.45);
  border-radius: 7px;
  background: rgba(12, 38, 55, 0.85);
  color: #b8b8b8; }
  .gear-loadout-slot--empty {
    border-style: solid;
    border-color: rgba(90, 195, 255, 0.38);
    background: rgba(12, 38, 55, 0.55); }
  .gear-loadout-slot--filled {
    background: rgba(23, 39, 56, 0.55); }
  .gear-loadout-slot--active {
    border-color: rgba(90, 195, 255, 0.85);
    background: rgba(23, 39, 56, 0.78);
    box-shadow: 0 0 0 1px rgba(90, 195, 255, 0.18); }
  .gear-loadout-slot--locked {
    border-color: rgba(56, 72, 88, 0.75);
    background: rgba(12, 38, 55, 0.4); }
  .gear-loadout-slot__qty {
    display: flex;
    align-items: center;
    gap: 2px;
    flex: 0 0 auto;
    margin: 0 2px 0 0;
    padding: 0 2px;
    color: #747b81;
    font-size: 0.66rem;
    font-weight: 700; }
  .gear-loadout-slot__qty-label {
    opacity: 0.7; }
  .gear-loadout-slot__qty-input {
    width: 2rem;
    margin: 0;
    padding: 1px 2px;
    border: 1px solid #163447;
    border-radius: 4px;
    background: #0c2637;
    color: #b8b8b8;
    font: inherit;
    font-size: 0.68rem;
    text-align: center; }
  .gear-loadout-slot__qty-max {
    opacity: 0.65;
    font-size: 0.62rem; }
  .gear-loadout-slot__hit {
    position: relative;
    display: flex;
    align-items: center;
    gap: 0;
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    margin: 0;
    padding: 6px 32px 6px 8px;
    border: 0;
    background: transparent;
    color: inherit;
    text-align: left;
    cursor: pointer; }
  .gear-loadout-slot--filled .gear-loadout-slot__hit {
    padding-right: 52px; }
  .gear-loadout-slot__hit:disabled {
    cursor: not-allowed; }
  .gear-loadout-slot--locked .gear-loadout-slot__kind,
  .gear-loadout-slot--locked .gear-loadout-slot__name {
    color: #384858; }
  .gear-loadout-slot__cat {
    display: flex;
    flex: 0 0 22px;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    color: #dfdfdf; }
  .gear-loadout-slot--filled .gear-loadout-slot__cat {
    color: #5ac3ff; }
  .gear-loadout-slot__rule {
    flex: 0 0 auto;
    width: 1px;
    height: 22px;
    margin: 0 7px;
    background: rgba(90, 195, 255, 0.35); }
  .gear-loadout-slot__cat-svg {
    display: block;
    width: 16px;
    height: 16px;
    fill: none;
    stroke: currentColor;
    stroke-width: 1.5;
    stroke-linecap: round;
    stroke-linejoin: round; }
  .gear-loadout-slot__thumb {
    flex: 0 0 18px;
    width: 18px;
    height: 18px;
    object-fit: cover;
    border-radius: 3px;
    border: 1px solid #163447; }
  .gear-loadout-slot__meta {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    gap: 0;
    min-width: 0;
    overflow: hidden; }
  .gear-loadout-slot__kind {
    overflow: hidden;
    color: #dfdfdf;
    font-size: 0.62rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    text-overflow: ellipsis;
    white-space: nowrap; }
  .gear-loadout-slot__name-row {
    display: flex;
    align-items: center;
    gap: 4px;
    min-width: 0;
    overflow: hidden; }
  .gear-loadout-slot__name {
    overflow: hidden;
    color: rgba(90, 195, 255, 0.85);
    font-size: 0.64rem;
    font-weight: 500;
    text-overflow: ellipsis;
    white-space: nowrap; }
  .gear-loadout-slot__req {
    color: #5aa05c;
    font-size: 0.58rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase; }
  .gear-loadout-slot__req--locked {
    color: #384858; }
  .gear-loadout-slot__mark {
    position: absolute;
    top: 50%;
    right: 8px;
    z-index: 1;
    display: flex;
    flex: 0 0 20px;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    margin: 0;
    transform: translateY(-50%);
    border: 1px solid rgba(90, 195, 255, 0.7);
    border-radius: 50%;
    color: #dfdfdf;
    font-size: 0.85rem;
    font-weight: 500;
    line-height: 1; }
  .gear-loadout-slot__mark--filled {
    border-color: #5aa05c;
    color: #5aa05c; }
  .gear-loadout-slot__mark--locked {
    border-color: #384858;
    color: #384858; }
  .gear-loadout-slot__lock-svg {
    display: block;
    width: 11px;
    height: 11px;
    fill: none;
    stroke: currentColor;
    stroke-width: 1.8;
    stroke-linecap: round;
    stroke-linejoin: round; }
  .gear-loadout-slot__clear {
    position: absolute;
    top: 50%;
    right: 32px;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    margin: 0;
    padding: 0;
    transform: translateY(-50%);
    border: 0;
    border-radius: 4px;
    background: transparent;
    color: #747b81;
    font-size: 0.9rem;
    line-height: 1;
    cursor: pointer; }
  .gear-loadout-slot__clear:hover, .gear-loadout-slot__clear:focus-visible {
    color: #d12323;
    background: rgba(209, 35, 35, 0.12); }

.gear-loadout-builder-actions {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 6px;
  padding-top: 2px;
  width: 100%;
  max-width: 100%;
  min-width: 0; }
  .gear-loadout-builder-actions__btn {
    flex: 1 1 0;
    min-width: 0;
    width: auto;
    margin: 0;
    padding: 8px 8px;
    border: 1px solid #5ac3ff;
    border-radius: 7px;
    background: transparent;
    color: #5ac3ff;
    font-size: 0.68rem;
    font-weight: 700;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    cursor: pointer; }
  .gear-loadout-builder-actions__btn--danger {
    padding: 8px 8px;
    border-color: #d12323;
    color: #d12323;
    font-size: 0.68rem; }
  .gear-loadout-builder-actions__btn:disabled {
    opacity: 0.45;
    cursor: default; }

.gear-loadout-slot-picker {
  position: fixed;
  inset: 0;
  z-index: 20000;
  display: grid;
  place-items: center;
  background: rgba(0, 0, 0, 0.6); }

.gear-loadout-slot-picker__card {
  width: min(92vw, 480px);
  padding: 16px;
  border: 1px solid #163447;
  border-radius: 8px;
  background: #1c2d38;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4); }

.gear-loadout-slot-picker__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 12px; }

.gear-loadout-slot-picker__title {
  margin: 0;
  color: #dfdfdf;
  font-size: 0.92rem;
  font-weight: 700; }

.gear-loadout-slot-picker__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: #b8b8b8;
  font-size: 1.2rem;
  line-height: 1;
  cursor: pointer; }

.gear-loadout-slot-picker__equipped {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
  padding: 7px 8px;
  border: 1px solid #163447;
  border-radius: 6px;
  background: #0c2637; }

.gear-loadout-slot-picker__equipped-name {
  overflow: hidden;
  color: #dfdfdf;
  font-size: 0.78rem;
  text-overflow: ellipsis;
  white-space: nowrap; }

.gear-loadout-slot-picker__unequip {
  flex: 0 0 auto;
  margin: 0;
  padding: 4px 8px;
  border: 1px solid #d12323;
  border-radius: 5px;
  background: transparent;
  color: #d12323;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  cursor: pointer; }

.gear-loadout-slot-picker .benefits-loot-actions {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%; }

.gear-loadout-slot-picker .benefits-loot-mention-wrap {
  position: relative;
  width: 100%; }

.gear-loadout-slot-picker .benefits-loot-mention-input-shell {
  display: flex;
  align-items: stretch;
  width: 100%;
  background: #0c2637;
  border: 1px solid #163447;
  border-radius: 6px;
  overflow: hidden; }

.gear-loadout-slot-picker .benefits-loot-mention-input-shell .benefits-loot-search-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  padding: 0 10px;
  color: #b8b8b8;
  background: #172738; }

.gear-loadout-slot-picker .benefits-loot-mention-input-shell .benefits-loot-search-icon__svg {
  display: block;
  width: 16px;
  height: 16px; }

.gear-loadout-slot-picker .benefits-loot-mention-input-shell .benefits-loot-search-input {
  width: 100%;
  box-sizing: border-box;
  flex: 1 1 auto;
  min-width: 0;
  appearance: none;
  background: #0c2637;
  border: 0;
  border-radius: 0;
  padding: 8px 10px 8px 4px;
  color: #dfdfdf;
  font-size: 0.85rem;
  font-weight: 600;
  text-align: left;
  color-scheme: dark; }

.gear-loadout-slot-picker .benefits-loot-mention-input-shell .benefits-loot-search-input:focus {
  outline: none; }

.gear-loadout-slot-picker .benefits-loot-search-hint {
  margin-top: 4px;
  color: #747b81;
  font-size: 0.72rem; }

.gear-loadout-slot-picker .benefits-loot-mention-wrap .mention-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10050;
  max-height: 240px;
  margin: 4px 0 0;
  padding: 0;
  overflow-y: auto;
  list-style: none;
  background: rgba(12, 38, 55, 0.98);
  border: 1px solid #163447;
  border-radius: 6px;
  box-shadow: 0 14px 24px rgba(0, 0, 0, 0.28); }
  .gear-loadout-slot-picker .benefits-loot-mention-wrap .mention-dropdown::-webkit-scrollbar {
    width: 6px; }
  .gear-loadout-slot-picker .benefits-loot-mention-wrap .mention-dropdown::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .gear-loadout-slot-picker .benefits-loot-mention-wrap .mention-dropdown::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .gear-loadout-slot-picker .benefits-loot-mention-wrap .mention-dropdown::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }

.gear-loadout-slot-picker .benefits-loot-mention-wrap .mention-dropdown .dropdown-item {
  display: flex;
  align-items: flex-start;
  padding: 6px 10px;
  cursor: pointer;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06); }
  .gear-loadout-slot-picker .benefits-loot-mention-wrap .mention-dropdown .dropdown-item:last-child {
    border-bottom: none; }
  .gear-loadout-slot-picker .benefits-loot-mention-wrap .mention-dropdown .dropdown-item.selected {
    background-color: rgba(58, 120, 180, 0.22); }
  .gear-loadout-slot-picker .benefits-loot-mention-wrap .mention-dropdown .dropdown-item:hover {
    background-color: rgba(255, 255, 255, 0.06); }
  .gear-loadout-slot-picker .benefits-loot-mention-wrap .mention-dropdown .dropdown-item .mention-name {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    min-width: 0;
    line-height: 1.25; }
  .gear-loadout-slot-picker .benefits-loot-mention-wrap .mention-dropdown .dropdown-item .benefits-loot-dd-label {
    max-width: 100%;
    overflow: hidden;
    color: rgba(255, 255, 255, 0.92);
    font-size: 13px;
    text-overflow: ellipsis;
    white-space: nowrap; }
  .gear-loadout-slot-picker .benefits-loot-mention-wrap .mention-dropdown .dropdown-item .benefits-loot-dd-meta {
    max-width: 100%;
    overflow: hidden;
    color: rgba(255, 255, 255, 0.55);
    font-size: 11px;
    text-overflow: ellipsis;
    white-space: nowrap; }

.sc-location-selector {
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%; }
  .sc-location-selector .field-input {
    width: 100%;
    max-width: 520px; }

.sc-location-selector__field {
  display: flex;
  flex-direction: column;
  gap: 6px; }

.sc-location-selector__groups {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 14px;
  width: 100%; }

.sc-location-selector__group,
.sc-location-selector__pois {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0; }

.sc-location-selector__group-title {
  margin: 0;
  color: rgba(255, 255, 255, 0.88);
  font-size: 14px;
  font-weight: 700; }

.sc-location-selector__option-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 320px;
  overflow-y: auto;
  padding-right: 4px; }
  .sc-location-selector__option-list::-webkit-scrollbar {
    width: 6px; }
  .sc-location-selector__option-list::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .sc-location-selector__option-list::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .sc-location-selector__option-list::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }

.sc-location-selector__option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  min-height: 38px;
  padding: 8px 10px;
  color: rgba(255, 255, 255, 0.9);
  text-align: left;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.09);
  border-radius: 6px;
  cursor: pointer; }
  .sc-location-selector__option:hover:not(:disabled), .sc-location-selector__option.selected {
    background: rgba(58, 120, 180, 0.2);
    border-color: rgba(58, 120, 180, 0.55); }
  .sc-location-selector__option:disabled {
    cursor: not-allowed;
    opacity: 0.6; }

.sc-location-selector__option-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.sc-location-selector__option-type {
  flex: 0 0 auto;
  color: rgba(255, 255, 255, 0.56);
  font-size: 12px; }

.sc-location-selector__status {
  color: rgba(255, 255, 255, 0.62);
  font-size: 13px; }

.sc-location-selector__status--error {
  color: #ff8c8c; }

.sc-location-selector__selected {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  color: rgba(255, 255, 255, 0.84);
  font-size: 13px; }

.sc-location-selector__selected-label {
  color: rgba(255, 255, 255, 0.56); }

.sc-location-selector__solar-panel {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-width: 640px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.09);
  border-radius: 6px; }

.sc-location-selector__solar-title {
  margin: 0;
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  font-weight: 700; }

.sc-location-selector__solar-grid {
  display: grid;
  grid-template-columns: minmax(130px, 0.45fr) minmax(0, 1fr);
  gap: 8px 14px;
  margin: 0; }
  .sc-location-selector__solar-grid dt,
  .sc-location-selector__solar-grid dd {
    min-width: 0;
    margin: 0;
    font-size: 13px;
    line-height: 1.35; }
  .sc-location-selector__solar-grid dt {
    color: rgba(255, 255, 255, 0.56); }
  .sc-location-selector__solar-grid dd {
    color: rgba(255, 255, 255, 0.88);
    overflow-wrap: anywhere; }

.org-credits-page {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 1.5rem; }
  .org-credits-page .ts-page-header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem; }
  .org-credits-page .org-credits-admin-hint {
    margin: 0 0 0.75rem;
    font-size: 0.85rem;
    opacity: 0.75;
    max-width: 52rem; }
  .org-credits-page .org-credits-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 12px 28px;
    flex: 1 1 auto; }
  .org-credits-page .ts-toolbar.ts-toolbar--compact {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem 1rem; }
  .org-credits-page .org-credits-image-actions {
    display: flex;
    align-items: center;
    gap: 0.65rem;
    margin-left: auto;
    flex: 0 0 auto; }
  .org-credits-page .org-credits-image-thumb {
    width: 35px;
    height: 35px;
    padding: 5px;
    object-fit: cover;
    border-radius: 8px;
    flex: 0 0 auto; }
  .org-credits-page .org-credits-image-input {
    display: none; }
  .org-credits-page .org-credits-meta-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 160px; }
  .org-credits-page .org-credits-meta-label {
    color: rgba(223, 223, 223, 0.62);
    font-size: 0.72rem;
    letter-spacing: 0.08em;
    text-transform: uppercase; }
  .org-credits-page .org-credits-meta-value {
    color: #dfdfdf;
    font-size: 0.9rem;
    font-weight: 600; }
  .org-credits-page .org-credits-status {
    margin: 0 0 0.75rem;
    color: #b8b8b8;
    font-size: 0.9rem; }
  .org-credits-page .org-credits-status--error {
    color: #d12323; }
  .org-credits-page .org-credits-count {
    font-variant-numeric: tabular-nums;
    white-space: nowrap; }
  .org-credits-page .cell-source {
    max-width: 0;
    overflow: hidden; }
  .org-credits-page .org-credits-source {
    color: rgba(223, 223, 223, 0.72);
    font-size: 0.8rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; }
  .org-credits-page .org-credits-credit-input {
    width: 100%;
    max-width: 8rem; }
  .org-credits-page .org-credits-preview-btn {
    white-space: nowrap;
    padding: 0.3rem 0.65rem;
    font-size: 0.78rem; }
  .org-credits-page .org-credits-empty {
    color: #b8b8b8;
    text-align: center;
    padding: 1rem 0.75rem; }
  .org-credits-page .ts-table-scroll--org-credits {
    max-height: calc(100vh - 775px); }
  .org-credits-page .accounting-table--org-credits-head col.col-category,
  .org-credits-page .accounting-table--org-credits-body col.col-category {
    width: 16%; }
  .org-credits-page .accounting-table--org-credits-head col.col-size,
  .org-credits-page .accounting-table--org-credits-body col.col-size {
    width: 7%; }
  .org-credits-page .accounting-table--org-credits-head col.col-itemCount,
  .org-credits-page .accounting-table--org-credits-body col.col-itemCount {
    width: 9%; }
  .org-credits-page .accounting-table--org-credits-head col.col-source,
  .org-credits-page .accounting-table--org-credits-body col.col-source {
    width: 36%; }
  .org-credits-page .accounting-table--org-credits-head col.col-preview,
  .org-credits-page .accounting-table--org-credits-body col.col-preview {
    width: 12%; }
  .org-credits-page .accounting-table--org-credits-head col.col-creditValue,
  .org-credits-page .accounting-table--org-credits-body col.col-creditValue {
    width: 20%; }
  .org-credits-page .cell-itemCount,
  .org-credits-page th.header-itemCount {
    text-align: right; }
  .org-credits-page .cell-preview,
  .org-credits-page th.header-preview {
    text-align: center;
    vertical-align: middle; }
  .org-credits-page .cell-creditValue,
  .org-credits-page th.header-creditValue {
    text-align: left; }
  .org-credits-page .org-credits-auction-admin {
    margin-top: 1.25rem; }
  .org-credits-page .org-credits-admin-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    margin-bottom: 0.85rem;
    align-items: flex-end; }
  .org-credits-page .org-credits-admin-field {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    min-width: 9rem; }
    .org-credits-page .org-credits-admin-field span {
      font-size: 0.75rem;
      color: #b8b8b8;
      text-transform: uppercase;
      letter-spacing: 0.04em; }
  .org-credits-page .org-credits-admin-field--wide {
    width: 100%;
    margin-bottom: 0.85rem; }
  .org-credits-page .org-credits-admin-subtitle {
    margin: 1.1rem 0 0.55rem;
    font-size: 0.85rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #dfdfdf; }
  .org-credits-page .org-credits-admin-list {
    margin: 0 0 0.75rem;
    padding-left: 1.1rem;
    color: #b8b8b8; }

.org-credits-preview-modal-overlay {
  display: flex;
  position: fixed;
  inset: 0;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  background: rgba(12, 38, 55, 0.72);
  z-index: 220; }

.org-credits-preview-modal {
  display: flex;
  flex-direction: column;
  width: min(920px, 100%);
  max-height: min(82vh, 860px);
  border-radius: 14px;
  border: 1px solid rgba(58, 120, 180, 0.45);
  background: linear-gradient(135deg, rgba(0, 48, 77, 0.96), rgba(21, 28, 36, 0.9)), #00304d;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.4);
  overflow: hidden;
  color: #dfdfdf; }

.org-credits-preview-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.95rem 1.1rem;
  border-bottom: 1px solid rgba(58, 120, 180, 0.28); }

.org-credits-preview-modal__title {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #dfdfdf; }

.org-credits-preview-modal__close {
  border: 0;
  background: transparent;
  color: #b8b8b8;
  font-size: 1.4rem;
  line-height: 1;
  cursor: pointer;
  padding: 0.15rem 0.4rem; }
  .org-credits-preview-modal__close:hover {
    color: #dfdfdf; }

.org-credits-preview-modal__body {
  flex: 1 1 auto;
  min-height: 0;
  padding: 0.9rem 1.1rem;
  overflow: hidden; }

.org-credits-preview-modal__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.85rem 1.1rem;
  border-top: 1px solid rgba(58, 120, 180, 0.28); }

.org-credits-preview-modal__count {
  color: #b8b8b8;
  font-size: 0.82rem; }

.org-credits-preview-table-wrap .ts-table-scroll--org-credits-preview {
  max-height: min(52vh, 520px); }

.org-credits-preview-table-wrap .accounting-table {
  color: #dfdfdf; }
  .org-credits-preview-table-wrap .accounting-table th {
    color: rgba(223, 223, 223, 0.62); }
  .org-credits-preview-table-wrap .accounting-table td {
    color: #dfdfdf; }

.org-credits-preview-table-wrap .accounting-table--org-credits-preview-head col.col-name,
.org-credits-preview-table-wrap .accounting-table--org-credits-preview-body col.col-name {
  width: 48%; }

.org-credits-preview-table-wrap .accounting-table--org-credits-preview-head col.col-type,
.org-credits-preview-table-wrap .accounting-table--org-credits-preview-body col.col-type {
  width: 36%; }

.org-credits-preview-table-wrap .accounting-table--org-credits-preview-head col.col-size,
.org-credits-preview-table-wrap .accounting-table--org-credits-preview-body col.col-size {
  width: 16%; }

.org-credits-preview-table-wrap .org-credits-empty {
  color: #b8b8b8; }

.org-credits-preview-table-wrap .org-credits-status {
  color: #b8b8b8; }

.org-credits-preview-table-wrap .org-credits-status--error {
  color: #d12323; }

.cc-shell {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%; }

.cc-nav,
.cc-subnav,
.cc-sex {
  display: flex;
  flex-wrap: wrap;
  gap: 6px; }

.cc-nav__btn,
.cc-subnav__btn,
.cc-sex__btn {
  margin: 0;
  padding: 6px 10px;
  border: 1px solid #384858;
  border-radius: 6px;
  background: #0c2637;
  color: #b8b8b8;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer; }

.cc-nav__btn--on,
.cc-subnav__btn--on,
.cc-sex__btn--on {
  border-color: #3a78b4;
  background: #172738;
  color: #dfdfdf; }

.cc-panel {
  display: flex;
  flex-direction: column;
  gap: 8px; }

.cc-field {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 8px;
  width: 100%; }

.cc-field--check {
  justify-content: flex-start; }

.cc-field__k {
  flex: 0 0 7.2rem;
  min-width: 7.2rem;
  color: #b8b8b8;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase; }

.cc-field__range,
.cc-field__select,
.cc-field__color {
  flex: 1 1 auto;
  min-width: 0; }

.cc-field__v {
  flex: 0 0 4.4rem;
  color: #747b81;
  font-size: 0.72rem;
  text-align: right; }

.cc-note {
  margin: 0;
  color: #747b81;
  font-size: 0.75rem; }

.cc-note--err {
  color: #d12323; }

.cc-kv {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0; }
  .cc-kv div {
    display: flex;
    gap: 8px; }
  .cc-kv dt {
    flex: 0 0 7.2rem;
    color: #b8b8b8;
    font-size: 0.72rem;
    text-transform: uppercase; }
  .cc-kv dd {
    margin: 0;
    color: #dfdfdf;
    font-size: 0.78rem; }

.cc-dna-parts {
  margin: 0;
  padding-left: 1.1rem;
  color: #b8b8b8;
  font-size: 0.75rem; }

.cc-dye-grad__track {
  position: relative;
  height: 10px;
  border-radius: 6px;
  background: #384858; }

.cc-dye-grad__handle {
  position: absolute;
  top: -3px;
  width: 8px;
  height: 16px;
  border-radius: 2px;
  background: #3a78b4; }

.cc-dye-grad__handle--dead {
  opacity: 0.35; }

.cc-dye-grad__handle--dead:first-of-type {
  left: 18%; }

.cc-dye-grad__handle--dead:last-of-type {
  left: 62%; }

.cc-import,
.cc-export {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 6px 10px;
  border: 1px solid #384858;
  border-radius: 6px;
  background: #0c2637;
  color: #b8b8b8;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase; }

.cc-export:disabled {
  opacity: 0.4;
  cursor: not-allowed; }

.cc-import input {
  color: #b8b8b8; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.admin-dashboard-toolbar, .admin-statistic-menu {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.25rem;
  padding: 0.9rem 1rem;
  background: linear-gradient(180deg, rgba(0, 48, 77, 0.72), rgba(21, 28, 36, 0.42)), rgba(0, 48, 77, 0.55);
  border: 1px solid rgba(58, 120, 180, 0.45);
  border-radius: 12px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35), 0 10px 24px rgba(0, 0, 0, 0.28); }

.admin-dashboard-toolbar__controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem 1.5rem; }

.admin-dashboard-toolbar__hint {
  margin: 0;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.55); }

.admin-dashboard-toolbar__dates, .date-picker-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem 1.25rem; }

.admin-dashboard-toolbar__date-field, .input-date {
  display: flex;
  align-items: center;
  gap: 0.5rem; }
  .admin-dashboard-toolbar__date-field label, .input-date label {
    margin: 0;
    font-size: 0.72rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.62);
    white-space: nowrap; }
  .admin-dashboard-toolbar__date-field .react-datepicker-wrapper, .input-date .react-datepicker-wrapper {
    width: auto; }
  .admin-dashboard-toolbar__date-field input, .input-date input {
    min-width: 8.5rem;
    padding: 0.4rem 0.65rem;
    border: 1px solid rgba(58, 120, 180, 0.45);
    border-radius: 8px;
    font-family: inherit;
    font-size: 0.82rem;
    color: #dfdfdf;
    background: rgba(0, 48, 77, 0.65); }
    .admin-dashboard-toolbar__date-field input:focus-visible, .input-date input:focus-visible {
      outline: 2px solid rgba(58, 120, 180, 0.65);
      outline-offset: 2px; }

.admin-dashboard-toolbar__save {
  flex-shrink: 0; }

.admin-chart-grid, .chart-grid-container {
  width: 100%;
  position: relative;
  overflow: visible; }

.admin-chart-grid__layout {
  width: 100%; }

.admin-chart-grid .react-grid-item, .chart-grid-container .react-grid-item {
  z-index: 0;
  transition: box-shadow 0.2s ease; }
  .admin-chart-grid .react-grid-item.react-draggable-dragging, .chart-grid-container .react-grid-item.react-draggable-dragging {
    z-index: 10; }
    .admin-chart-grid .react-grid-item.react-draggable-dragging .admin-chart-card, .chart-grid-container .react-grid-item.react-draggable-dragging .admin-chart-card, .admin-chart-grid .react-grid-item.react-draggable-dragging .graph, .chart-grid-container .react-grid-item.react-draggable-dragging .graph {
      border-color: rgba(90, 195, 255, 0.75);
      box-shadow: 0 0 0 1px rgba(90, 195, 255, 0.35), 0 16px 36px rgba(0, 0, 0, 0.45); }
  .admin-chart-grid .react-grid-item.resizing .admin-chart-card, .chart-grid-container .react-grid-item.resizing .admin-chart-card, .admin-chart-grid .react-grid-item.resizing .graph, .chart-grid-container .react-grid-item.resizing .graph {
    border-color: rgba(58, 120, 180, 0.75); }

.admin-chart-grid .react-grid-placeholder, .chart-grid-container .react-grid-placeholder {
  background: rgba(58, 120, 180, 0.18) !important;
  border: 1px dashed rgba(58, 120, 180, 0.55) !important;
  border-radius: 12px !important;
  opacity: 0.85 !important; }

.admin-chart-grid .react-grid-item > .react-resizable-handle, .chart-grid-container .react-grid-item > .react-resizable-handle {
  z-index: 5;
  opacity: 0.45;
  transition: opacity 0.2s ease; }
  .admin-chart-grid .react-grid-item > .react-resizable-handle::after, .chart-grid-container .react-grid-item > .react-resizable-handle::after {
    border-right: 2px solid rgba(58, 120, 180, 0.85) !important;
    border-bottom: 2px solid rgba(58, 120, 180, 0.85) !important; }

.admin-chart-grid .react-grid-item:hover > .react-resizable-handle, .chart-grid-container .react-grid-item:hover > .react-resizable-handle,
.admin-chart-grid .react-grid-item.resizing > .react-resizable-handle,
.chart-grid-container .react-grid-item.resizing > .react-resizable-handle {
  opacity: 1; }

.admin-chart-card, .graph {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  overflow: visible;
  background: linear-gradient(180deg, rgba(0, 48, 77, 0.78), rgba(21, 28, 36, 0.48)), rgba(30, 48, 66, 0.72);
  border: 1px solid rgba(58, 120, 180, 0.4);
  border-radius: 12px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.3), 0 8px 22px rgba(0, 0, 0, 0.26);
  transition: border-color 0.2s ease, box-shadow 0.2s ease; }
  .admin-chart-card:hover, .graph:hover {
    border-color: rgba(58, 120, 180, 0.58); }

.admin-chart-card__header, .chart-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.85rem 1rem 0.7rem;
  border-bottom: 1px solid rgba(58, 120, 180, 0.22);
  cursor: grab; }
  .admin-chart-card__header:active, .chart-header:active {
    cursor: grabbing; }

.admin-chart-card__heading {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0; }

.admin-chart-card__title, .custom-charts {
  margin: 0;
  font-size: 0.82rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.92); }

.admin-chart-card__hint {
  font-size: 0.62rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.42); }

.admin-chart-card__toolbar, .graph-selector {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  flex-shrink: 0;
  margin-right: 0.75rem; }

.admin-chart-card__select-label {
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.55); }

.admin-chart-card__select {
  min-width: 7.5rem;
  padding: 0.35rem 0.65rem;
  border: 1px solid rgba(58, 120, 180, 0.45);
  border-radius: 8px;
  font-family: inherit;
  font-size: 0.78rem;
  color: #dfdfdf;
  background: rgba(0, 48, 77, 0.65);
  cursor: pointer; }
  .admin-chart-card__select:disabled {
    opacity: 0.55;
    cursor: not-allowed; }
  .admin-chart-card__select:focus-visible {
    outline: 2px solid rgba(58, 120, 180, 0.65);
    outline-offset: 2px; }

.admin-chart-card__body {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: 0.35rem 0.75rem 0.85rem; }

.admin-chart-render, .render-chart, .charts-renderChart {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 220px; }

.admin-chart-render__canvas {
  width: 100%;
  height: 100%;
  min-height: 220px; }

.admin-chart-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  width: 100%;
  height: 100%;
  min-height: 220px;
  border: 1px dashed rgba(58, 120, 180, 0.28);
  border-radius: 10px;
  background: rgba(0, 48, 77, 0.25); }

.admin-chart-empty__label {
  font-size: 0.82rem;
  font-weight: 600;
  color: rgba(223, 223, 223, 0.75); }

.admin-chart-empty__hint {
  font-size: 0.72rem;
  color: rgba(223, 223, 223, 0.48); }

.charts-types {
  width: 100%;
  height: 100%;
  min-height: 220px; }

@media (max-width: 1023px) {
  .admin-dashboard-toolbar, .admin-statistic-menu {
    flex-direction: column;
    align-items: stretch; }
  .admin-dashboard-toolbar__controls {
    flex-direction: column;
    align-items: stretch; }
  .admin-chart-card__header, .chart-header {
    flex-direction: column;
    align-items: stretch; }
  .admin-chart-card__toolbar, .graph-selector {
    margin-right: 0;
    justify-content: flex-end; } }

.admin-dashboard-activity .admin-activity-range,
.admin-dashboard-org-events .admin-activity-range,
.admin-dashboard-recruitment .admin-activity-range {
  display: inline-flex;
  align-items: stretch;
  padding: 3px;
  border-radius: 999px;
  border: 1px solid rgba(58, 120, 180, 0.45);
  background: rgba(0, 48, 77, 0.55);
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.22); }

.admin-dashboard-activity .admin-activity-range__btn,
.admin-dashboard-org-events .admin-activity-range__btn,
.admin-dashboard-recruitment .admin-activity-range__btn {
  min-width: 3.25rem;
  margin: 0;
  padding: 0.4rem 0.85rem;
  border: none;
  border-radius: 999px;
  background: transparent;
  color: rgba(223, 223, 223, 0.62);
  font-family: inherit;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease; }
  .admin-dashboard-activity .admin-activity-range__btn:hover:not(.is-active),
  .admin-dashboard-org-events .admin-activity-range__btn:hover:not(.is-active),
  .admin-dashboard-recruitment .admin-activity-range__btn:hover:not(.is-active) {
    color: #dfdfdf;
    background: rgba(56, 72, 88, 0.35); }
  .admin-dashboard-activity .admin-activity-range__btn.is-active,
  .admin-dashboard-org-events .admin-activity-range__btn.is-active,
  .admin-dashboard-recruitment .admin-activity-range__btn.is-active {
    color: #dfdfdf;
    background: linear-gradient(180deg, rgba(58, 120, 180, 0.55), rgba(0, 48, 77, 0.85));
    box-shadow: 0 0 0 1px rgba(58, 120, 180, 0.35); }

.admin-dashboard-activity .admin-activity-count,
.admin-dashboard-org-events .admin-activity-count,
.admin-dashboard-recruitment .admin-activity-count {
  margin: 0;
  font-size: 0.78rem;
  font-weight: 600;
  color: rgba(223, 223, 223, 0.62);
  white-space: nowrap; }

.admin-dashboard-activity .admin-activity-error,
.admin-dashboard-org-events .admin-activity-error,
.admin-dashboard-recruitment .admin-activity-error {
  margin: 0 0 1rem;
  color: #9e2222;
  font-size: 0.85rem; }

.admin-dashboard-activity .admin-activity-stats,
.admin-dashboard-recruitment .admin-activity-stats {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.45rem;
  min-width: 0; }

.admin-dashboard-activity .admin-activity-missing,
.admin-dashboard-recruitment .admin-activity-missing {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.4rem;
  margin: 0;
  padding: 0;
  list-style: none; }

.admin-dashboard-activity .admin-activity-missing__item,
.admin-dashboard-recruitment .admin-activity-missing__item {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.28rem 0.55rem;
  border-radius: 999px;
  border: 1px solid rgba(209, 35, 35, 0.35);
  background: rgba(73, 18, 18, 0.35); }

.admin-dashboard-activity .admin-activity-missing__label,
.admin-dashboard-recruitment .admin-activity-missing__label {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.72); }

.admin-dashboard-activity .admin-activity-missing__value,
.admin-dashboard-recruitment .admin-activity-missing__value {
  font-size: 0.72rem;
  font-weight: 700;
  color: #d12323;
  white-space: nowrap; }

.admin-dashboard-activity .admin-activity-table-wrap,
.admin-dashboard-recruitment .admin-activity-table-wrap {
  margin-top: 0.25rem;
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid rgba(58, 120, 180, 0.28);
  background: rgba(0, 48, 77, 0.38); }
  .admin-dashboard-activity .admin-activity-table-wrap .accounting-table,
  .admin-dashboard-recruitment .admin-activity-table-wrap .accounting-table {
    margin-bottom: 0;
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse; }
  .admin-dashboard-activity .admin-activity-table-wrap col.col-rank,
  .admin-dashboard-recruitment .admin-activity-table-wrap col.col-rank {
    width: 11rem; }
  .admin-dashboard-activity .admin-activity-table-wrap col.col-handle,
  .admin-dashboard-recruitment .admin-activity-table-wrap col.col-handle {
    width: auto; }
  .admin-dashboard-activity .admin-activity-table-wrap col.col-eventCount,
  .admin-dashboard-recruitment .admin-activity-table-wrap col.col-eventCount {
    width: 5.5rem; }
  .admin-dashboard-activity .admin-activity-table-wrap col.col-lastEventAt,
  .admin-dashboard-recruitment .admin-activity-table-wrap col.col-lastEventAt {
    width: 8.5rem; }
  .admin-dashboard-activity .admin-activity-table-wrap col.col-training,
  .admin-dashboard-recruitment .admin-activity-table-wrap col.col-training {
    width: 7.5rem; }
  .admin-dashboard-activity .admin-activity-table-wrap > .accounting-table thead,
  .admin-dashboard-recruitment .admin-activity-table-wrap > .accounting-table thead {
    display: table-header-group;
    background-size: cover;
    color: #b8b8b8;
    text-transform: uppercase;
    border-bottom: 2px solid #2a3847;
    background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center; }
  .admin-dashboard-activity .admin-activity-table-wrap > .accounting-table thead th,
  .admin-dashboard-recruitment .admin-activity-table-wrap > .accounting-table thead th {
    position: relative;
    top: auto;
    z-index: auto;
    height: 30px;
    padding: 0 12px;
    font-size: 0.75em;
    font-weight: 600;
    letter-spacing: normal;
    line-height: 30px;
    color: #b8b8b8;
    background: transparent;
    border-bottom: none;
    border-right: none;
    vertical-align: middle;
    text-align: left;
    white-space: nowrap; }
    .admin-dashboard-activity .admin-activity-table-wrap > .accounting-table thead th:not(:last-child)::after,
    .admin-dashboard-recruitment .admin-activity-table-wrap > .accounting-table thead th:not(:last-child)::after {
      content: '';
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
      height: 65%;
      background-color: #2a3847; }

.admin-dashboard-activity .admin-activity-table-scroll,
.admin-dashboard-recruitment .admin-activity-table-scroll {
  display: block;
  max-height: calc(100vh - 725px);
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.5) rgba(0, 48, 77, 0.45); }
  .admin-dashboard-activity .admin-activity-table-scroll::-webkit-scrollbar,
  .admin-dashboard-recruitment .admin-activity-table-scroll::-webkit-scrollbar {
    width: 4px; }
  .admin-dashboard-activity .admin-activity-table-scroll::-webkit-scrollbar-track,
  .admin-dashboard-recruitment .admin-activity-table-scroll::-webkit-scrollbar-track {
    background: rgba(0, 48, 77, 0.45);
    border-radius: 999px; }
  .admin-dashboard-activity .admin-activity-table-scroll::-webkit-scrollbar-thumb,
  .admin-dashboard-recruitment .admin-activity-table-scroll::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.48);
    border-radius: 999px; }
    .admin-dashboard-activity .admin-activity-table-scroll::-webkit-scrollbar-thumb:hover,
    .admin-dashboard-recruitment .admin-activity-table-scroll::-webkit-scrollbar-thumb:hover {
      background: rgba(58, 120, 180, 0.65); }
  .admin-dashboard-activity .admin-activity-table-scroll .accounting-table thead,
  .admin-dashboard-recruitment .admin-activity-table-scroll .accounting-table thead {
    display: none; }

.admin-dashboard-activity .admin-activity-table td,
.admin-dashboard-recruitment .admin-activity-table td {
  padding: 0.65rem 0.85rem;
  vertical-align: middle;
  font-size: 0.85rem;
  color: #dfdfdf;
  border-bottom: 1px solid rgba(56, 72, 88, 0.35); }

.admin-dashboard-activity .admin-activity-table tbody tr:last-child td,
.admin-dashboard-recruitment .admin-activity-table tbody tr:last-child td {
  border-bottom: none; }

.admin-dashboard-activity .admin-activity-table .header-eventCount,
.admin-dashboard-activity .admin-activity-table .cell-eventCount,
.admin-dashboard-activity .admin-activity-table .header-training,
.admin-dashboard-activity .admin-activity-table .cell-training,
.admin-dashboard-recruitment .admin-activity-table .header-eventCount,
.admin-dashboard-recruitment .admin-activity-table .cell-eventCount,
.admin-dashboard-recruitment .admin-activity-table .header-training,
.admin-dashboard-recruitment .admin-activity-table .cell-training {
  text-align: center; }

.admin-dashboard-activity .admin-activity-table .header-lastEventAt,
.admin-dashboard-activity .admin-activity-table .cell-lastEventAt,
.admin-dashboard-recruitment .admin-activity-table .header-lastEventAt,
.admin-dashboard-recruitment .admin-activity-table .cell-lastEventAt {
  white-space: nowrap; }

.admin-dashboard-activity .admin-activity-table .accounting-table__empty,
.admin-dashboard-recruitment .admin-activity-table .accounting-table__empty {
  text-align: center;
  padding: 2rem 1rem;
  color: rgba(223, 223, 223, 0.55); }

.admin-dashboard-activity .admin-activity-handle,
.admin-dashboard-recruitment .admin-activity-handle {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0; }

.admin-dashboard-activity .admin-activity-handle__primary,
.admin-dashboard-recruitment .admin-activity-handle__primary {
  font-weight: 600; }

.admin-dashboard-activity .admin-activity-handle__secondary,
.admin-dashboard-recruitment .admin-activity-handle__secondary {
  font-size: 0.72rem;
  color: rgba(223, 223, 223, 0.55); }

.admin-dashboard-activity .admin-activity-rank,
.admin-dashboard-recruitment .admin-activity-rank {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  min-width: 0; }

.admin-dashboard-activity .admin-activity-rank__icon,
.admin-dashboard-recruitment .admin-activity-rank__icon {
  width: 1.35rem;
  height: 1.35rem;
  object-fit: contain;
  flex-shrink: 0; }

.admin-dashboard-activity .admin-activity-rank__placeholder,
.admin-dashboard-recruitment .admin-activity-rank__placeholder {
  display: inline-block;
  width: 1.35rem;
  height: 1.35rem;
  flex-shrink: 0;
  border-radius: 3px;
  background: rgba(223, 223, 223, 0.12); }

.admin-dashboard-activity .admin-activity-rank__label,
.admin-dashboard-recruitment .admin-activity-rank__label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.8rem; }

.admin-dashboard-activity .ts-status,
.admin-dashboard-recruitment .ts-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 0.55rem;
  height: 0.55rem;
  border-radius: 50%; }
  .admin-dashboard-activity .ts-status.is-active,
  .admin-dashboard-recruitment .ts-status.is-active {
    background: #75cf78;
    box-shadow: 0 0 0 3px rgba(117, 207, 120, 0.18); }
  .admin-dashboard-activity .ts-status.is-inactive,
  .admin-dashboard-recruitment .ts-status.is-inactive {
    background: rgba(223, 223, 223, 0.28);
    box-shadow: none; }

.admin-dashboard-org-events .admin-org-events-summary,
.admin-dashboard-recruitment .admin-org-events-summary {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.4rem; }

.admin-dashboard-org-events .admin-org-events-summary__chip,
.admin-dashboard-recruitment .admin-org-events-summary__chip {
  display: inline-flex;
  align-items: center;
  padding: 0.28rem 0.55rem;
  border-radius: 999px;
  border: 1px solid rgba(58, 120, 180, 0.35);
  background: rgba(0, 48, 77, 0.55);
  font-size: 0.72rem;
  font-weight: 700;
  color: rgba(223, 223, 223, 0.78);
  white-space: nowrap; }
  .admin-dashboard-org-events .admin-org-events-summary__chip--accent,
  .admin-dashboard-recruitment .admin-org-events-summary__chip--accent {
    border-color: rgba(117, 207, 120, 0.4);
    color: #75cf78; }

.admin-dashboard-org-events .admin-org-events-empty {
  margin: 0.5rem 0 0;
  padding: 2rem 1rem;
  text-align: center;
  border-radius: 12px;
  border: 1px solid rgba(58, 120, 180, 0.28);
  background: rgba(0, 48, 77, 0.35);
  color: rgba(223, 223, 223, 0.55);
  font-size: 0.85rem; }

.admin-dashboard-org-events .admin-org-events-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  margin-top: 0.35rem; }

.admin-dashboard-org-events .admin-org-events-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  border-radius: 12px;
  border: 1px solid rgba(58, 120, 180, 0.28);
  background: linear-gradient(180deg, rgba(0, 48, 77, 0.72), rgba(21, 28, 36, 0.42)), rgba(0, 48, 77, 0.55);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.28), 0 10px 22px rgba(0, 0, 0, 0.22);
  overflow: hidden; }
  .admin-dashboard-org-events .admin-org-events-card--tall {
    grid-column: 1 / -1; }

.admin-dashboard-org-events .admin-org-events-card__header {
  padding: 0.85rem 1rem 0.65rem;
  border-bottom: 1px solid rgba(58, 120, 180, 0.22); }

.admin-dashboard-org-events .admin-org-events-card__heading {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0; }

.admin-dashboard-org-events .admin-org-events-card__title {
  margin: 0;
  font-size: 0.82rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.92); }

.admin-dashboard-org-events .admin-org-events-card__hint {
  margin: 0;
  font-size: 0.62rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.42); }

.admin-dashboard-org-events .admin-org-events-card__body {
  flex: 1;
  min-height: 260px;
  padding: 0.75rem 0.85rem 0.95rem; }

.admin-dashboard-org-events .admin-org-events-card--tall .admin-org-events-card__body {
  min-height: 300px; }

@media (max-width: 1023px) {
  .admin-dashboard-org-events .admin-org-events-grid {
    grid-template-columns: 1fr; }
  .admin-dashboard-org-events .admin-org-events-card--tall {
    grid-column: auto; } }

.admin-dashboard-recruitment .admin-recruitment-table-wrap col.col-kind {
  width: 8.5rem; }

.admin-dashboard-recruitment .admin-recruitment-table-wrap col.col-handle {
  width: auto; }

.admin-dashboard-recruitment .admin-recruitment-table-wrap col.col-guestConversion {
  width: 12.5rem; }

.admin-dashboard-recruitment .admin-recruitment-table-wrap col.col-joinedAt {
  width: 8.5rem; }

.admin-dashboard-recruitment .admin-recruitment-table-wrap col.col-eventParticipationCount {
  width: 5.5rem; }

.admin-dashboard-recruitment .admin-recruitment-table-wrap col.col-onboarding {
  width: 7rem; }

.admin-dashboard-recruitment .header-eventParticipationCount,
.admin-dashboard-recruitment .cell-eventParticipationCount,
.admin-dashboard-recruitment .header-onboarding,
.admin-dashboard-recruitment .cell-onboarding,
.admin-dashboard-recruitment .header-guestConversion,
.admin-dashboard-recruitment .cell-guestConversion {
  text-align: center; }

.admin-dashboard-recruitment .admin-recruitment-kind {
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.5rem;
  border-radius: 999px;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  white-space: nowrap; }
  .admin-dashboard-recruitment .admin-recruitment-kind--newcomer {
    border: 1px solid rgba(117, 207, 120, 0.4);
    background: rgba(117, 207, 120, 0.12);
    color: #75cf78; }
  .admin-dashboard-recruitment .admin-recruitment-kind--potential {
    border: 1px solid rgba(58, 120, 180, 0.4);
    background: rgba(58, 120, 180, 0.12);
    color: rgba(223, 223, 223, 0.85); }

.admin-dashboard-recruitment .admin-recruitment-guest-conversion-empty {
  color: rgba(223, 223, 223, 0.4); }

.admin-dashboard-recruitment .admin-recruitment-guest-conversion {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  max-width: 100%;
  padding: 0.22rem 0.55rem;
  border-radius: 999px;
  border: 1px solid rgba(155, 96, 42, 0.45);
  background: linear-gradient(90deg, rgba(58, 120, 180, 0.18) 0%, rgba(155, 96, 42, 0.16) 55%, rgba(117, 207, 120, 0.14) 100%);
  white-space: nowrap; }

.admin-dashboard-recruitment .admin-recruitment-guest-conversion__from,
.admin-dashboard-recruitment .admin-recruitment-guest-conversion__to {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase; }

.admin-dashboard-recruitment .admin-recruitment-guest-conversion__from {
  color: rgba(223, 223, 223, 0.78); }

.admin-dashboard-recruitment .admin-recruitment-guest-conversion__to {
  color: #75cf78; }

.admin-dashboard-recruitment .admin-recruitment-guest-conversion__arrow {
  position: relative;
  flex: 0 0 1.1rem;
  width: 1.1rem;
  height: 2px;
  border-radius: 1px;
  background: linear-gradient(90deg, rgba(58, 120, 180, 0.55), rgba(117, 207, 120, 0.9)); }
  .admin-dashboard-recruitment .admin-recruitment-guest-conversion__arrow::after {
    content: '';
    position: absolute;
    top: 50%;
    right: -1px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 3.5px 0 3.5px 5px;
    border-color: transparent transparent transparent rgba(117, 207, 120, 0.95);
    transform: translateY(-50%); }

.admin-dashboard-recruitment .admin-recruitment-onboarding {
  color: rgba(223, 223, 223, 0.4); }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.accounting-page .accounting-tab-content {
  margin-top: 0.75rem; }

.accounting-tab-placeholder-wrap {
  padding: 2rem 1.25rem;
  border-radius: 14px;
  border: 1px dashed rgba(58, 120, 180, 0.35);
  background: rgba(0, 48, 77, 0.35);
  text-align: center; }

.accounting-tab-placeholder__title {
  margin: 0 0 0.5rem;
  font-size: 1.1rem;
  font-weight: 600;
  color: #dfdfdf; }

.accounting-tab-placeholder__hint {
  margin: 0;
  font-size: 0.9rem;
  color: rgba(223, 223, 223, 0.62); }

.accounting-hero {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) minmax(280px, 1.4fr);
  gap: 1rem;
  margin-bottom: 1rem;
  padding: 1.1rem 1.25rem;
  border-radius: 14px;
  border: 1px solid rgba(58, 120, 180, 0.45);
  background: linear-gradient(135deg, rgba(0, 48, 77, 0.88), rgba(21, 28, 36, 0.55)), rgba(0, 48, 77, 0.65);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.28); }

.accounting-hero__eyebrow {
  margin: 0 0 0.35rem;
  font-size: 0.72rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.62); }

.accounting-hero__balance {
  margin: 0;
  font-family: 'FiraCode', monospace;
  font-size: clamp(1.6rem, 3vw, 2.35rem);
  font-weight: 700;
  color: #c2f0c3; }
  .accounting-hero__balance.is-negative {
    color: #d12323; }

.accounting-hero__warning {
  margin: 0.35rem 0 0;
  font-size: 0.78rem;
  color: #75cf78; }

.accounting-stats-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(120px, 1fr));
  gap: 0.65rem; }

.accounting-stat-card {
  padding: 0.75rem 0.85rem;
  border-radius: 10px;
  border: 1px solid rgba(58, 120, 180, 0.28);
  background: rgba(0, 48, 77, 0.45); }

.accounting-stat-card__label {
  display: block;
  margin-bottom: 0.25rem;
  font-size: 0.68rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.58); }

.accounting-stat-card__value {
  font-family: 'FiraCode', monospace;
  font-size: 0.95rem;
  color: #dfdfdf; }
  .accounting-stat-card__value.is-in {
    color: #75cf78; }
  .accounting-stat-card__value.is-out {
    color: #d12323; }

.accounting-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.85rem 1rem;
  margin-bottom: 0.85rem;
  padding: 0.85rem 1rem;
  border-radius: 12px;
  border: 1px solid rgba(58, 120, 180, 0.35);
  background: rgba(0, 48, 77, 0.52); }

.accounting-toolbar__dates {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1rem; }

.accounting-toolbar__date-field {
  display: flex;
  align-items: center;
  gap: 0.45rem; }
  .accounting-toolbar__date-field span {
    font-size: 0.72rem;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.62);
    white-space: nowrap; }
  .accounting-toolbar__date-field .react-datepicker-wrapper {
    width: auto; }

.accounting-date-input {
  min-width: 8.5rem;
  padding: 0.4rem 0.65rem;
  border: 1px solid rgba(58, 120, 180, 0.45);
  border-radius: 8px;
  font-family: inherit;
  font-size: 0.82rem;
  color: #dfdfdf;
  background: rgba(0, 48, 77, 0.65); }

.accounting-toolbar__filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem; }
  .accounting-toolbar__filters select {
    min-width: 9rem;
    padding: 0.4rem 0.65rem;
    border: 1px solid rgba(58, 120, 180, 0.45);
    border-radius: 8px;
    font-size: 0.82rem;
    color: #dfdfdf;
    background: rgba(0, 48, 77, 0.65); }

.accounting-toolbar__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-left: auto; }

.accounting-help-frame {
  position: relative; }
  .accounting-help-frame--has-help {
    padding-right: 0; }
  .accounting-help-frame--modal.accounting-help-frame--has-help {
    position: relative;
    display: block; }

.accounting-toolbar--with-help,
.accounting-modal__header--with-help {
  position: relative; }

.accounting-toolbar--with-help {
  padding-right: 2.25rem; }

.accounting-help-trigger {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  z-index: 4;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1rem;
  height: 1rem;
  padding: 0;
  border: 1px solid rgba(90, 195, 255, 0.45);
  border-radius: 50%;
  background: radial-gradient(circle at 30% 25%, rgba(90, 195, 255, 0.35), rgba(58, 120, 180, 0.18)), rgba(0, 48, 77, 0.88);
  color: #5ac3ff;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.24);
  transition: border-color 0.15s ease, box-shadow 0.15s ease; }
  .accounting-help-trigger:hover, .accounting-help-trigger.is-open {
    border-color: rgba(90, 195, 255, 0.75);
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.32); }
  .accounting-help-trigger:focus-visible {
    outline: 2px solid rgba(90, 195, 255, 0.65);
    outline-offset: 2px; }

.accounting-help-trigger__icon {
  font-family: Georgia, 'Times New Roman', serif;
  font-size: 0.62rem;
  font-weight: 700;
  font-style: italic;
  line-height: 1; }

.accounting-help-trigger--inline {
  position: static;
  width: 0.875rem;
  height: 0.875rem;
  flex-shrink: 0; }

.help-info-bubble--inline {
  position: relative;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  flex-shrink: 0;
  z-index: 5; }

.help-info-bubble__popover {
  top: calc(100% + 0.35rem);
  right: auto;
  left: 0;
  width: min(20rem, calc(100vw - 2.5rem));
  z-index: 8; }

.help-info-bubble--align-end .help-info-bubble__popover {
  left: auto;
  right: 0; }

.accounting-toolbar--with-help .accounting-help-popover {
  top: 1.75rem;
  right: 0.5rem; }

.accounting-modal__header--with-help .accounting-help-trigger {
  top: 0;
  right: 2.35rem; }

.accounting-modal__header--with-help .accounting-help-popover {
  top: 1.85rem;
  right: 0; }

.accounting-help-popover {
  position: absolute;
  top: 1.75rem;
  right: 0.5rem;
  z-index: 6;
  width: min(22.5rem, calc(100vw - 2.5rem));
  padding: 0.85rem 0.95rem 0.95rem;
  border-radius: 12px;
  border: 1px solid rgba(90, 195, 255, 0.35);
  background: linear-gradient(160deg, rgba(0, 48, 77, 0.97), rgba(21, 28, 36, 0.92)), rgba(0, 48, 77, 0.95);
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.42), 0 0 0 1px rgba(58, 120, 180, 0.12) inset;
  overflow: hidden; }
  .accounting-help-popover--portal {
    position: fixed;
    top: 0;
    left: 0;
    right: auto;
    z-index: 10100; }

.accounting-help-popover__accent {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, rgba(58, 120, 180, 0.2), rgba(90, 195, 255, 0.85), rgba(58, 120, 180, 0.2)); }

.accounting-help-popover__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.65rem;
  margin-bottom: 0.55rem; }

.accounting-help-popover__title {
  margin: 0;
  font-size: 0.88rem;
  font-weight: 600;
  color: #dfdfdf;
  line-height: 1.35; }

.accounting-help-popover__close {
  flex-shrink: 0;
  width: 1.35rem;
  height: 1.35rem;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: rgba(223, 223, 223, 0.08);
  color: rgba(223, 223, 223, 0.72);
  font-size: 1rem;
  line-height: 1;
  cursor: pointer; }
  .accounting-help-popover__close:hover {
    background: rgba(90, 195, 255, 0.16);
    color: #dfdfdf; }

.accounting-help-popover__summary {
  margin: 0 0 0.65rem;
  font-size: 0.8rem;
  line-height: 1.5;
  color: rgba(223, 223, 223, 0.82); }

.accounting-help-popover__steps {
  margin: 0 0 0.65rem;
  padding-left: 1.1rem;
  font-size: 0.78rem;
  line-height: 1.45;
  color: rgba(223, 223, 223, 0.78); }
  .accounting-help-popover__steps li + li {
    margin-top: 0.35rem; }
  .accounting-help-popover__steps li::marker {
    color: #5ac3ff; }

.accounting-help-popover__note {
  margin: 0;
  padding: 0.55rem 0.65rem;
  border-radius: 8px;
  border-left: 3px solid rgba(90, 195, 255, 0.55);
  background: rgba(58, 120, 180, 0.12);
  font-size: 0.74rem;
  line-height: 1.45;
  color: rgba(223, 223, 223, 0.72); }

.accounting-orgbank__section,
.accounting-members__filters-section,
.accounting-contracts__filters-section {
  margin-bottom: 0.85rem; }

.accounting-orgbank-layout {
  display: flex;
  flex-direction: column;
  gap: 1rem; }

.accounting-orgbank-layout__table {
  min-width: 0; }

.accounting-orgbank-scroll {
  display: block;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.5) rgba(0, 48, 77, 0.45); }
  .accounting-orgbank-scroll::-webkit-scrollbar {
    width: 4px; }
  .accounting-orgbank-scroll::-webkit-scrollbar-track {
    background: rgba(0, 48, 77, 0.45);
    border-radius: 999px; }
  .accounting-orgbank-scroll::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.48);
    border-radius: 999px; }
    .accounting-orgbank-scroll::-webkit-scrollbar-thumb:hover {
      background: rgba(58, 120, 180, 0.65); }

.accounting-table-wrap--orgbank-ledger {
  padding: 0;
  overflow: hidden; }
  .accounting-table-wrap--orgbank-ledger .accounting-table--orgbank-ledger-head {
    margin-bottom: 0; }
  .accounting-table-wrap--orgbank-ledger .accounting-table--orgbank-ledger-body thead {
    display: none; }

.accounting-table--orgbank-ledger-head,
.accounting-table--orgbank-ledger-body {
  table-layout: fixed;
  width: 100%; }

.accounting-toolbar__filters--orgbank {
  flex: 1;
  min-width: 0; }

.accounting-scope-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem; }

.accounting-scope-chip {
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  border: 1px solid rgba(58, 120, 180, 0.35);
  background: rgba(21, 28, 36, 0.45);
  color: rgba(223, 223, 223, 0.82);
  font-size: 0.78rem;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease; }
  .accounting-scope-chip.is-active {
    border-color: rgba(58, 120, 180, 0.85);
    background: rgba(58, 120, 180, 0.22);
    color: #ffffff; }

.accounting-active-filter {
  margin: 0 0 0.65rem;
  font-size: 0.8rem;
  color: rgba(223, 223, 223, 0.72); }
  .accounting-active-filter strong {
    color: #dfdfdf; }

.accounting-audit-intro {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 0.75rem; }
  .accounting-audit-intro p {
    margin: 0;
    font-size: 0.85rem;
    color: rgba(223, 223, 223, 0.72); }

.accounting-audit-intro__count {
  font-size: 0.75rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.55); }

.accounting-audit-kpi {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.65rem;
  margin-bottom: 0.85rem; }
  .accounting-audit-kpi--members {
    grid-template-columns: repeat(4, minmax(0, 1fr)); }

.accounting-audit-filters {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  margin-bottom: 0.75rem; }

.accounting-audit-filters__selects {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem; }

.accounting-audit-filters__row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
  align-items: flex-end; }

.accounting-field--compact {
  min-width: 9rem; }

.accounting-field--grow {
  flex: 1 1 14rem; }

.accounting-text-input,
.accounting-select {
  width: 100%;
  padding: 0.45rem 0.65rem;
  border: 1px solid rgba(58, 120, 180, 0.45);
  border-radius: 8px;
  font-family: inherit;
  font-size: 0.84rem;
  color: #dfdfdf;
  background: rgba(0, 48, 77, 0.65); }

.accounting-audit-load-more {
  display: flex;
  justify-content: center;
  padding: 0.75rem 0 0.25rem; }

.accounting-org-inventory .accounting-hero--inventory .accounting-hero__balance {
  color: #5ac3ff; }

.accounting-org-inventory .accounting-hero--inventory .accounting-hero__warning {
  color: rgba(223, 223, 223, 0.62); }

.accounting-org-inventory__section {
  margin-bottom: 1.25rem; }
  .accounting-org-inventory__section--movements {
    margin-bottom: 0; }

.accounting-org-inventory__section-title {
  margin: 0 0 0.75rem;
  font-size: 0.82rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.62); }

.accounting-toolbar--compact {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem; }

.accounting-toolbar__checkbox {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.78rem;
  color: rgba(223, 223, 223, 0.78);
  white-space: nowrap; }
  .accounting-toolbar__checkbox input {
    accent-color: #3a78b4; }

.accounting-org-inventory__filter-tag {
  font-size: 0.78rem;
  color: rgba(223, 223, 223, 0.72);
  padding: 0.35rem 0.65rem;
  border-radius: 999px;
  border: 1px solid rgba(58, 120, 180, 0.35);
  background: rgba(58, 120, 180, 0.12); }

.accounting-table__mono {
  font-family: 'FiraCode', monospace;
  font-size: 0.78rem; }

.accounting-org-inventory-scroll {
  display: block;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.5) rgba(0, 48, 77, 0.45); }
  .accounting-org-inventory-scroll::-webkit-scrollbar {
    width: 4px; }
  .accounting-org-inventory-scroll::-webkit-scrollbar-track {
    background: rgba(0, 48, 77, 0.45);
    border-radius: 999px; }
  .accounting-org-inventory-scroll::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.48);
    border-radius: 999px; }
    .accounting-org-inventory-scroll::-webkit-scrollbar-thumb:hover {
      background: rgba(58, 120, 180, 0.65); }

.accounting-table-wrap--inventory-stock,
.accounting-table-wrap--inventory-movements {
  padding: 0;
  overflow: hidden; }

.accounting-table-wrap--inventory-stock .accounting-table--inventory-stock-body thead {
  display: none; }

.accounting-table-wrap--inventory-movements .accounting-table--inventory-movements-head {
  margin-bottom: 0; }

.accounting-table-wrap--inventory-movements .accounting-table--inventory-movements-body thead {
  display: none; }

.accounting-table--inventory-stock-body,
.accounting-table--inventory-movements-head,
.accounting-table--inventory-movements-body {
  table-layout: fixed;
  width: 100%; }

.accounting-table-wrap--inventory-stock .accounting-table th:nth-child(1),
.accounting-table-wrap--inventory-stock .accounting-table td:nth-child(1) {
  width: 34%; }

.accounting-table-wrap--inventory-stock .accounting-table th:nth-child(2),
.accounting-table-wrap--inventory-stock .accounting-table td:nth-child(2) {
  width: 22%; }

.accounting-table-wrap--inventory-stock .accounting-table th:nth-child(3),
.accounting-table-wrap--inventory-stock .accounting-table td:nth-child(3) {
  width: 16%; }

.accounting-table-wrap--inventory-stock .accounting-table th:nth-child(4),
.accounting-table-wrap--inventory-stock .accounting-table td:nth-child(4) {
  width: 10%; }

.accounting-table-wrap--inventory-stock .accounting-table th:nth-child(5),
.accounting-table-wrap--inventory-stock .accounting-table td:nth-child(5) {
  width: 18%; }

.accounting-table-wrap--inventory-movements .accounting-table th:nth-child(1),
.accounting-table-wrap--inventory-movements .accounting-table td:nth-child(1) {
  width: 105px; }

.accounting-table-wrap--inventory-movements .accounting-table th:nth-child(2),
.accounting-table-wrap--inventory-movements .accounting-table td:nth-child(2) {
  width: 70px; }

.accounting-table-wrap--inventory-movements .accounting-table th:nth-child(3),
.accounting-table-wrap--inventory-movements .accounting-table td:nth-child(3) {
  width: 70px; }

.accounting-table-wrap--inventory-movements .accounting-table th:nth-child(4),
.accounting-table-wrap--inventory-movements .accounting-table td:nth-child(4) {
  width: 100px; }

.accounting-table-wrap--inventory-movements .accounting-table th:nth-child(5),
.accounting-table-wrap--inventory-movements .accounting-table td:nth-child(5) {
  width: 140px; }

.accounting-table-wrap--inventory-movements .accounting-table th:nth-child(6),
.accounting-table-wrap--inventory-movements .accounting-table td:nth-child(6) {
  width: 120px; }

.accounting-table-wrap--inventory-movements .accounting-table th:nth-child(7),
.accounting-table-wrap--inventory-movements .accounting-table td:nth-child(7) {
  width: auto; }

.accounting-org-inventory-layout {
  display: flex;
  flex-direction: column;
  gap: 1rem; }

.accounting-org-inventory-layout__table {
  min-width: 0; }

.accounting-org-inventory-item {
  border-radius: 12px;
  border: 1px solid rgba(58, 120, 180, 0.45);
  background: linear-gradient(180deg, rgba(0, 48, 77, 0.82), rgba(21, 28, 36, 0.55)), rgba(0, 48, 77, 0.65);
  padding: 1rem 1.1rem;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.22); }
  .accounting-org-inventory-item--empty {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 5rem; }

.accounting-org-inventory-item__placeholder {
  margin: 0;
  text-align: center;
  font-size: 0.85rem;
  color: rgba(223, 223, 223, 0.55); }

.accounting-org-inventory-item__hero {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 1rem 1.5rem;
  align-items: start; }

.accounting-org-inventory-item__badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  margin-bottom: 0.45rem; }

.accounting-org-inventory-item__title {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: #dfdfdf;
  line-height: 1.35; }

.accounting-org-inventory-item__code {
  margin: 0.25rem 0 0;
  font-family: 'FiraCode', monospace;
  font-size: 0.78rem;
  color: rgba(223, 223, 223, 0.62); }

.accounting-org-inventory-item__side {
  text-align: right;
  white-space: nowrap; }

.accounting-org-inventory-item__qty {
  margin: 0;
  font-family: 'FiraCode', monospace;
  font-size: 1.5rem;
  font-weight: 700;
  color: #5ac3ff; }

.accounting-org-inventory-item__qty-label {
  margin: 0.1rem 0 0;
  font-size: 0.72rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.55); }

.accounting-org-inventory-item__updated {
  margin: 0.35rem 0 0;
  font-size: 0.76rem;
  color: rgba(223, 223, 223, 0.58); }

.accounting-org-inventory-item__actions {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid rgba(58, 120, 180, 0.28); }

.accounting-members .accounting-hero--members .accounting-hero__balance {
  color: #c2f0c3; }

.accounting-members .accounting-hero--members .accounting-hero__warning {
  color: rgba(223, 223, 223, 0.62); }

.accounting-members-panel {
  margin-bottom: 1rem;
  border-radius: 12px;
  border: 1px solid rgba(58, 120, 180, 0.45);
  background: linear-gradient(180deg, rgba(0, 48, 77, 0.82), rgba(21, 28, 36, 0.55)), rgba(0, 48, 77, 0.65);
  padding: 1rem 1.1rem;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.22); }
  .accounting-members-panel--empty {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 5rem; }

.accounting-members-panel__placeholder {
  margin: 0;
  text-align: center;
  font-size: 0.85rem;
  color: rgba(223, 223, 223, 0.55); }
  .accounting-members-panel__placeholder--warn {
    color: rgba(199, 132, 69, 0.88); }

.accounting-members-panel__hero {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 1rem 1.5rem;
  align-items: start; }

.accounting-members-panel__badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  margin-bottom: 0.45rem; }

.accounting-members-panel__title {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: #dfdfdf;
  line-height: 1.35; }

.accounting-members-panel__sub {
  margin: 0.2rem 0 0;
  font-size: 0.78rem;
  color: rgba(223, 223, 223, 0.62); }

.accounting-members-panel__stats {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 1.25rem;
  justify-content: flex-end; }

.accounting-members-panel__stat {
  text-align: right;
  min-width: 5.5rem; }

.accounting-members-panel__stat-value {
  margin: 0;
  font-family: 'FiraCode', monospace;
  font-size: 1.1rem;
  font-weight: 700;
  color: #dfdfdf; }
  .accounting-members-panel__stat-value.is-in {
    color: #75cf78; }
  .accounting-members-panel__stat-value.is-out {
    color: #d12323; }

.accounting-members-panel__stat-label {
  margin: 0.12rem 0 0;
  font-size: 0.68rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.55); }

.accounting-members-panel__actions {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid rgba(58, 120, 180, 0.28); }

.accounting-toolbar__filters--members {
  align-items: flex-end; }

.accounting-member-combobox {
  position: relative;
  flex: 1 1 16rem;
  min-width: 14rem; }

.accounting-member-combobox__label {
  display: block;
  margin-bottom: 0.3rem;
  font-size: 0.72rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.62); }

.accounting-member-combobox__control {
  position: relative;
  display: flex;
  align-items: center; }

.accounting-member-combobox__input {
  width: 100%;
  padding-right: 2rem; }

.accounting-member-combobox__clear {
  position: absolute;
  right: 0.35rem;
  width: 1.5rem;
  height: 1.5rem;
  border: none;
  border-radius: 999px;
  background: transparent;
  color: rgba(223, 223, 223, 0.62);
  font-size: 1.1rem;
  line-height: 1;
  cursor: pointer; }
  .accounting-member-combobox__clear:hover {
    color: #dfdfdf;
    background: rgba(58, 120, 180, 0.15); }

.accounting-member-combobox__list {
  position: absolute;
  z-index: 20;
  top: calc(100% + 0.25rem);
  left: 0;
  right: 0;
  max-height: 240px;
  overflow-y: auto;
  margin: 0;
  padding: 0.35rem 0;
  list-style: none;
  border-radius: 10px;
  border: 1px solid rgba(58, 120, 180, 0.45);
  background: rgba(0, 48, 77, 0.96);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.35);
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.5) rgba(0, 48, 77, 0.45); }
  .accounting-member-combobox__list::-webkit-scrollbar {
    width: 4px; }
  .accounting-member-combobox__list::-webkit-scrollbar-track {
    background: rgba(0, 48, 77, 0.45);
    border-radius: 999px; }
  .accounting-member-combobox__list::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.48);
    border-radius: 999px; }
    .accounting-member-combobox__list::-webkit-scrollbar-thumb:hover {
      background: rgba(58, 120, 180, 0.65); }

.accounting-member-combobox__option {
  display: block;
  width: 100%;
  padding: 0.5rem 0.85rem;
  border: none;
  background: transparent;
  color: #dfdfdf;
  font-size: 0.82rem;
  text-align: left;
  cursor: pointer; }
  .accounting-member-combobox__option:hover, .accounting-member-combobox__option[aria-selected="true"] {
    background: rgba(58, 120, 180, 0.18); }

.accounting-member-combobox__option-label {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.accounting-member-combobox__empty {
  padding: 0.55rem 0.85rem;
  font-size: 0.8rem;
  color: rgba(223, 223, 223, 0.55); }
  .accounting-member-combobox__empty--warn {
    color: rgba(199, 132, 69, 0.88); }

.accounting-members-layout {
  display: flex;
  flex-direction: column;
  gap: 1rem; }

.accounting-members-layout__table {
  min-width: 0; }

.accounting-members-scroll {
  display: block;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.5) rgba(0, 48, 77, 0.45); }
  .accounting-members-scroll::-webkit-scrollbar {
    width: 4px; }
  .accounting-members-scroll::-webkit-scrollbar-track {
    background: rgba(0, 48, 77, 0.45);
    border-radius: 999px; }
  .accounting-members-scroll::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.48);
    border-radius: 999px; }
    .accounting-members-scroll::-webkit-scrollbar-thumb:hover {
      background: rgba(58, 120, 180, 0.65); }

.accounting-members-blueprints {
  margin-bottom: 1rem; }

.accounting-members-blueprints__title {
  margin: 0;
  font-size: 0.88rem;
  font-weight: 600;
  color: #dfdfdf; }

.accounting-members-blueprints__count {
  font-size: 0.75rem;
  color: rgba(223, 223, 223, 0.62);
  white-space: nowrap; }

.accounting-members-blueprints-scroll {
  display: block;
  max-height: 280px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.5) rgba(0, 48, 77, 0.45); }
  .accounting-members-blueprints-scroll::-webkit-scrollbar {
    width: 4px; }
  .accounting-members-blueprints-scroll::-webkit-scrollbar-track {
    background: rgba(0, 48, 77, 0.45);
    border-radius: 999px; }
  .accounting-members-blueprints-scroll::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.48);
    border-radius: 999px; }
    .accounting-members-blueprints-scroll::-webkit-scrollbar-thumb:hover {
      background: rgba(58, 120, 180, 0.65); }

.accounting-table-wrap--members-blueprints {
  padding: 0;
  overflow: hidden; }
  .accounting-table-wrap--members-blueprints .accounting-table--members-blueprints {
    margin-bottom: 0; }
  .accounting-table-wrap--members-blueprints .accounting-table--members-blueprints-body thead {
    display: none; }
  .accounting-table-wrap--members-blueprints .accounting-table th:nth-child(1),
  .accounting-table-wrap--members-blueprints .accounting-table td:nth-child(1) {
    width: 28%; }
  .accounting-table-wrap--members-blueprints .accounting-table th:nth-child(2),
  .accounting-table-wrap--members-blueprints .accounting-table td:nth-child(2) {
    width: 16%; }
  .accounting-table-wrap--members-blueprints .accounting-table th:nth-child(3),
  .accounting-table-wrap--members-blueprints .accounting-table td:nth-child(3) {
    width: 14%; }
  .accounting-table-wrap--members-blueprints .accounting-table th:nth-child(4),
  .accounting-table-wrap--members-blueprints .accounting-table td:nth-child(4) {
    width: 28%; }
  .accounting-table-wrap--members-blueprints .accounting-table th:nth-child(5),
  .accounting-table-wrap--members-blueprints .accounting-table td:nth-child(5) {
    width: 14%; }

.accounting-table--members-blueprints,
.accounting-table--members-blueprints-body {
  table-layout: fixed;
  width: 100%; }

.accounting-table-wrap--members-ledger {
  padding: 0;
  overflow: hidden; }
  .accounting-table-wrap--members-ledger .accounting-table--members-ledger-head {
    margin-bottom: 0; }
  .accounting-table-wrap--members-ledger .accounting-table--members-ledger-body thead {
    display: none; }

.accounting-table--members-ledger-head,
.accounting-table--members-ledger-body {
  table-layout: fixed;
  width: 100%; }

.accounting-contracts .accounting-audit-kpi--contracts {
  grid-template-columns: repeat(4, minmax(0, 1fr)); }

.accounting-contracts-panel {
  margin-bottom: 1rem;
  border-radius: 12px;
  border: 1px solid rgba(58, 120, 180, 0.45);
  background: linear-gradient(180deg, rgba(0, 48, 77, 0.82), rgba(21, 28, 36, 0.55)), rgba(0, 48, 77, 0.65);
  padding: 1rem 1.1rem;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.22); }
  .accounting-contracts-panel--empty {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 5rem; }

.accounting-contracts-panel__placeholder {
  margin: 0;
  text-align: center;
  font-size: 0.85rem;
  color: rgba(223, 223, 223, 0.55); }

.accounting-contracts-panel__empty {
  margin: 0;
  font-size: 0.82rem;
  color: rgba(223, 223, 223, 0.55); }

.accounting-contracts-panel__hero {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 1rem 1.5rem;
  align-items: start; }

.accounting-contracts-panel__badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  margin-bottom: 0.45rem; }

.accounting-contracts-panel__title {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: #dfdfdf;
  line-height: 1.35; }

.accounting-contracts-panel__sub {
  margin: 0.2rem 0 0;
  font-size: 0.78rem;
  color: rgba(223, 223, 223, 0.62); }

.accounting-contracts-panel__stats {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 1.25rem;
  justify-content: flex-end; }

.accounting-contracts-panel__stat {
  text-align: right;
  min-width: 5.5rem; }

.accounting-contracts-panel__stat-value {
  margin: 0;
  font-family: 'FiraCode', monospace;
  font-size: 1.1rem;
  font-weight: 700;
  color: #dfdfdf; }
  .accounting-contracts-panel__stat-value.is-in {
    color: #c2f0c3; }
  .accounting-contracts-panel__stat-value.is-out {
    color: #c78445; }

.accounting-contracts-panel__stat-label {
  margin: 0.15rem 0 0;
  font-size: 0.72rem;
  color: rgba(223, 223, 223, 0.58); }

.accounting-contracts-panel__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.45rem 1.25rem;
  margin-top: 0.85rem;
  padding-top: 0.85rem;
  border-top: 1px solid rgba(58, 120, 180, 0.28); }

.accounting-contracts-panel__row {
  display: flex;
  flex-direction: column;
  gap: 0.15rem; }

.accounting-contracts-panel__row-label {
  font-size: 0.72rem;
  color: rgba(223, 223, 223, 0.58); }

.accounting-contracts-panel__row-value {
  font-size: 0.82rem;
  color: #dfdfdf; }

.accounting-contracts-panel__comment {
  margin: 0.75rem 0 0;
  font-size: 0.8rem;
  color: rgba(223, 223, 223, 0.72);
  line-height: 1.45; }

.accounting-contracts-panel__actions {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid rgba(58, 120, 180, 0.28); }

.accounting-btn--compact {
  padding: 0.25rem 0.55rem;
  font-size: 0.74rem; }

.accounting-contracts-panel__section-title {
  margin: 1rem 0 0.55rem;
  font-size: 0.82rem;
  font-weight: 600;
  color: rgba(223, 223, 223, 0.88); }

.accounting-contracts-layout {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem; }

.accounting-contracts-layout__table {
  min-width: 0; }

.accounting-contracts-scroll {
  display: block;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.5) rgba(0, 48, 77, 0.45); }
  .accounting-contracts-scroll::-webkit-scrollbar {
    width: 4px; }
  .accounting-contracts-scroll::-webkit-scrollbar-track {
    background: rgba(0, 48, 77, 0.45);
    border-radius: 999px; }
  .accounting-contracts-scroll::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.48);
    border-radius: 999px; }
    .accounting-contracts-scroll::-webkit-scrollbar-thumb:hover {
      background: rgba(58, 120, 180, 0.65); }

.accounting-table-wrap--contracts-list,
.accounting-table-wrap--contracts-ledger {
  padding: 0;
  overflow: hidden;
  margin-top: 1rem; }
  .accounting-table-wrap--contracts-list .accounting-table--contracts-list-head,
  .accounting-table-wrap--contracts-list .accounting-table--contracts-ledger-head,
  .accounting-table-wrap--contracts-ledger .accounting-table--contracts-list-head,
  .accounting-table-wrap--contracts-ledger .accounting-table--contracts-ledger-head {
    margin-bottom: 0; }
  .accounting-table-wrap--contracts-list .accounting-table--contracts-list-body thead,
  .accounting-table-wrap--contracts-list .accounting-table--contracts-ledger-body thead,
  .accounting-table-wrap--contracts-ledger .accounting-table--contracts-list-body thead,
  .accounting-table-wrap--contracts-ledger .accounting-table--contracts-ledger-body thead {
    display: none; }

.accounting-table--contracts-list-head,
.accounting-table--contracts-list-body,
.accounting-table--contracts-ledger-head,
.accounting-table--contracts-ledger-body {
  table-layout: fixed;
  width: 100%; }

.accounting-table-wrap--contracts-installments {
  margin-top: 0.35rem; }

.accounting-pill--status-late,
.accounting-pill--status-defaulted {
  background: rgba(199, 132, 69, 0.18);
  color: #c78445; }

.accounting-pill--status-active,
.accounting-pill--status-paid {
  background: rgba(194, 240, 195, 0.14);
  color: #c2f0c3; }

.accounting-pill--status-draft,
.accounting-pill--status-scheduled {
  background: rgba(58, 120, 180, 0.16);
  color: #5ac3ff; }

.accounting-pill--status-cancelled,
.accounting-pill--status-closed,
.accounting-pill--status-completed {
  background: rgba(223, 223, 223, 0.12);
  color: rgba(223, 223, 223, 0.72); }

.accounting-pill--status-partially_paid {
  background: rgba(216, 180, 147, 0.16);
  color: #d8b493; }

.accounting-table-wrap--members-ledger .accounting-table th:nth-child(1),
.accounting-table-wrap--members-ledger .accounting-table td:nth-child(1) {
  width: 105px; }

.accounting-table-wrap--members-ledger .accounting-table th:nth-child(2),
.accounting-table-wrap--members-ledger .accounting-table td:nth-child(2) {
  width: 100px; }

.accounting-table-wrap--members-ledger .accounting-table th:nth-child(3),
.accounting-table-wrap--members-ledger .accounting-table td:nth-child(3) {
  width: 70px; }

.accounting-table-wrap--members-ledger .accounting-table th:nth-child(4),
.accounting-table-wrap--members-ledger .accounting-table td:nth-child(4) {
  width: 140px; }

.accounting-table-wrap--members-ledger .accounting-table th:nth-child(5),
.accounting-table-wrap--members-ledger .accounting-table td:nth-child(5) {
  width: 140px; }

.accounting-table-wrap--members-ledger .accounting-table th:nth-child(6),
.accounting-table-wrap--members-ledger .accounting-table td:nth-child(6) {
  width: 120px; }

.accounting-table-wrap--members-ledger .accounting-table th:nth-child(7),
.accounting-table-wrap--members-ledger .accounting-table td:nth-child(7) {
  width: auto; }

.accounting-ledger-tag {
  display: inline-block;
  padding: 0.15rem 0.45rem;
  border-radius: 6px;
  font-size: 0.68rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.78);
  border: 1px solid rgba(56, 72, 88, 0.55);
  background: rgba(21, 28, 36, 0.45); }

.accounting-audit-detail__reversal-flag {
  margin: 0 0 0.65rem;
  padding: 0.4rem 0.55rem;
  border-radius: 8px;
  font-size: 0.78rem;
  color: #d12323;
  border: 1px solid rgba(209, 35, 35, 0.35);
  background: rgba(158, 34, 34, 0.12); }

.accounting-table--selectable tbody tr.is-reversed {
  opacity: 0.72; }

.accounting-kind-badge--benefits {
  border-color: rgba(117, 207, 120, 0.4);
  background: rgba(90, 160, 92, 0.15); }

.accounting-kind-badge--donation {
  border-color: rgba(58, 120, 180, 0.45);
  background: rgba(58, 120, 180, 0.12); }

.accounting-kind-badge--sale,
.accounting-kind-badge--purchase,
.accounting-kind-badge--commerce {
  border-color: rgba(184, 184, 184, 0.4);
  background: rgba(56, 72, 88, 0.25); }

.accounting-kind-badge--credit,
.accounting-kind-badge--loan,
.accounting-kind-badge--rental {
  border-color: rgba(58, 120, 180, 0.5);
  background: rgba(58, 120, 180, 0.16); }

.accounting-kind-badge--manual {
  border-color: rgba(184, 184, 184, 0.35); }

.accounting-kind-badge--inventory {
  border-color: rgba(117, 207, 120, 0.35);
  background: rgba(90, 160, 92, 0.1); }

.accounting-kind-badge--correction {
  border-color: rgba(209, 35, 35, 0.45);
  background: rgba(158, 34, 34, 0.14); }

.accounting-kind-badge--other {
  border-color: rgba(56, 72, 88, 0.45); }

.accounting-audit-layout {
  display: flex;
  flex-direction: column;
  gap: 1rem; }

.accounting-audit-split {
  display: contents; }

.accounting-audit-split__table {
  min-width: 0; }
  .accounting-audit-split__table .accounting-table-wrap--audit {
    padding: 0;
    overflow: hidden; }
  .accounting-audit-split__table .accounting-table--audit {
    table-layout: fixed;
    width: 100%; }
  .accounting-audit-split__table .accounting-table--audit-head {
    margin-bottom: 0; }
    .accounting-audit-split__table .accounting-table--audit-head tbody {
      display: none; }
  .accounting-audit-split__table .accounting-table--audit-body thead {
    display: none; }
  .accounting-audit-split__table .accounting-audit-tbody-scroll {
    display: block;
    max-height: 400px;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
    scrollbar-color: rgba(58, 120, 180, 0.5) rgba(0, 48, 77, 0.45); }
    .accounting-audit-split__table .accounting-audit-tbody-scroll::-webkit-scrollbar {
      width: 4px; }
    .accounting-audit-split__table .accounting-audit-tbody-scroll::-webkit-scrollbar-track {
      background: rgba(0, 48, 77, 0.45);
      border-radius: 999px; }
    .accounting-audit-split__table .accounting-audit-tbody-scroll::-webkit-scrollbar-thumb {
      background: rgba(58, 120, 180, 0.48);
      border-radius: 999px; }
      .accounting-audit-split__table .accounting-audit-tbody-scroll::-webkit-scrollbar-thumb:hover {
        background: rgba(58, 120, 180, 0.65); }
  .accounting-audit-split__table .accounting-audit-col--date {
    width: 105px; }
  .accounting-audit-split__table .accounting-audit-col--origin {
    width: 100px; }
  .accounting-audit-split__table .accounting-audit-col--ledger {
    width: 135px; }
  .accounting-audit-split__table .accounting-audit-col--direction {
    width: 70px; }
  .accounting-audit-split__table .accounting-audit-col--amount {
    width: 140px; }
  .accounting-audit-split__table .accounting-audit-col--treasury {
    width: 85px; }
  .accounting-audit-split__table .accounting-audit-col--label {
    width: auto; }
  .accounting-audit-split__table .accounting-table--audit th,
  .accounting-audit-split__table .accounting-table--audit td {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; }

.accounting-table--selectable tbody tr {
  cursor: pointer; }
  .accounting-table--selectable tbody tr.is-selected {
    background: rgba(58, 120, 180, 0.18);
    box-shadow: inset 3px 0 0 rgba(58, 120, 180, 0.85); }
  .accounting-table--selectable tbody tr:focus-visible {
    outline: 2px solid rgba(58, 120, 180, 0.65);
    outline-offset: -2px; }

.accounting-table__label-cell {
  max-width: 12rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.accounting-audit-split__table .accounting-table__label-cell {
  max-width: none; }

.accounting-audit-detail {
  border-radius: 12px;
  border: 1px solid rgba(58, 120, 180, 0.45);
  background: linear-gradient(180deg, rgba(0, 48, 77, 0.82), rgba(21, 28, 36, 0.55)), rgba(0, 48, 77, 0.65);
  padding: 1rem 1.1rem;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.22); }
  .accounting-audit-detail--horizontal {
    overflow: visible;
    max-height: none; }
  .accounting-audit-detail--empty {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 5.5rem; }

.accounting-audit-detail__placeholder {
  margin: 0;
  text-align: center;
  font-size: 0.85rem;
  color: rgba(223, 223, 223, 0.55);
  padding: 2rem 1rem; }

.accounting-audit-detail__header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.45rem; }

.accounting-audit-detail__hero {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 1rem 1.5rem;
  align-items: start;
  margin-bottom: 0.85rem;
  padding-bottom: 0.85rem;
  border-bottom: 1px solid rgba(58, 120, 180, 0.28); }

.accounting-audit-detail__hero-main {
  min-width: 0; }

.accounting-audit-detail__hero-side {
  text-align: right;
  flex-shrink: 0;
  white-space: nowrap; }

.accounting-audit-detail__reversal-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #d12323;
  border: 1px solid rgba(209, 35, 35, 0.35);
  background: rgba(158, 34, 34, 0.12); }

.accounting-audit-detail__cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 0.65rem; }

.accounting-audit-detail-card {
  padding: 0.65rem 0.75rem;
  border-radius: 8px;
  border: 1px solid rgba(58, 120, 180, 0.25);
  background: rgba(0, 48, 77, 0.42);
  min-width: 0; }

.accounting-audit-detail-card__title {
  margin: 0 0 0.45rem;
  font-size: 0.68rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.55); }

.accounting-audit-detail-card__body .accounting-detail-row {
  grid-template-columns: minmax(72px, 42%) 1fr;
  gap: 0.35rem 0.5rem;
  padding: 0.25rem 0;
  font-size: 0.76rem; }

.accounting-audit-detail-card__body .accounting-audit-detail__note {
  margin: 0;
  font-size: 0.78rem;
  line-height: 1.45;
  color: rgba(223, 223, 223, 0.78); }

.accounting-audit-detail__title {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: #dfdfdf;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  line-height: 1.35; }

.accounting-audit-detail__amount {
  margin: 0;
  font-family: 'FiraCode', monospace;
  font-size: 1.2rem;
  font-weight: 700; }
  .accounting-audit-detail__amount.is-in {
    color: #75cf78; }
  .accounting-audit-detail__amount.is-out {
    color: #d12323; }

.accounting-audit-detail__date {
  margin: 0.15rem 0 0;
  font-size: 0.78rem;
  color: rgba(223, 223, 223, 0.62); }

.accounting-audit-detail__summary {
  margin: 0.45rem 0 0;
  padding: 0;
  border: none;
  background: transparent;
  font-size: 0.82rem;
  line-height: 1.5;
  color: rgba(223, 223, 223, 0.82); }

.accounting-audit-detail__note {
  margin: 0;
  font-size: 0.82rem;
  line-height: 1.45;
  color: rgba(223, 223, 223, 0.78); }

.accounting-audit-detail__section {
  margin-bottom: 1rem; }
  .accounting-audit-detail__section:last-child {
    margin-bottom: 0; }

.accounting-audit-detail__section-title {
  margin: 0 0 0.5rem;
  font-size: 0.68rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.55); }

.accounting-detail-row {
  display: grid;
  grid-template-columns: minmax(100px, 38%) 1fr;
  gap: 0.5rem 0.75rem;
  padding: 0.35rem 0;
  border-bottom: 1px solid rgba(56, 72, 88, 0.35);
  font-size: 0.8rem; }
  .accounting-detail-row:last-child {
    border-bottom: none; }

.accounting-detail-row__label {
  color: rgba(223, 223, 223, 0.58); }

.accounting-detail-row__value {
  color: #dfdfdf;
  word-break: break-word; }
  .accounting-detail-row__value.is-mono {
    font-family: 'FiraCode', monospace;
    font-size: 0.76rem; }

.accounting-audit-detail__metadata {
  margin: 0;
  padding: 0.65rem 0.75rem;
  border-radius: 8px;
  border: 1px solid rgba(58, 120, 180, 0.28);
  background: rgba(0, 48, 77, 0.55);
  font-family: 'FiraCode', monospace;
  font-size: 0.72rem;
  line-height: 1.45;
  color: rgba(223, 223, 223, 0.88);
  overflow-x: auto;
  white-space: pre-wrap;
  word-break: break-word; }

.accounting-kind-badge--event {
  border-color: rgba(117, 207, 120, 0.4);
  background: rgba(90, 160, 92, 0.15); }

.accounting-kind-badge--org_treasury {
  border-color: rgba(58, 120, 180, 0.55);
  background: rgba(58, 120, 180, 0.2); }

.accounting-kind-badge--member {
  border-color: rgba(184, 184, 184, 0.35); }

.accounting-table-wrap {
  overflow: auto;
  border-radius: 12px;
  border: 1px solid rgba(58, 120, 180, 0.28);
  background: rgba(0, 48, 77, 0.38); }

.accounting-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.82rem; }
  .accounting-table th,
  .accounting-table td {
    padding: 0.65rem 0.75rem;
    text-align: left;
    border-bottom: 1px solid rgba(56, 72, 88, 0.65);
    vertical-align: top; }
  .accounting-table th {
    position: sticky;
    top: 0;
    z-index: 1;
    font-size: 0.68rem;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.62);
    background: rgba(21, 28, 36, 0.95); }
  .accounting-table tbody tr:hover {
    background: rgba(58, 120, 180, 0.08); }
  .accounting-table .is-in {
    color: #75cf78; }
  .accounting-table .is-out {
    color: #d12323; }

.accounting-table__empty {
  text-align: center;
  padding: 2rem 1rem;
  color: rgba(223, 223, 223, 0.55); }

.accounting-table__event {
  display: inline-block;
  max-width: 14rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; }

.accounting-table__comment {
  max-width: 16rem;
  color: rgba(223, 223, 223, 0.78); }

.accounting-pill {
  display: inline-flex;
  align-items: center;
  padding: 0.15rem 0.55rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase; }
  .accounting-pill--in {
    color: #c2f0c3;
    background: rgba(90, 160, 92, 0.22);
    border: 1px solid rgba(117, 207, 120, 0.35); }
  .accounting-pill--out {
    color: #d12323;
    background: rgba(158, 34, 34, 0.22);
    border: 1px solid rgba(209, 35, 35, 0.35); }
  .accounting-pill--treasury {
    color: #75cf78;
    background: rgba(90, 160, 92, 0.18); }
  .accounting-pill--muted {
    color: rgba(223, 223, 223, 0.65);
    background: rgba(56, 72, 88, 0.35); }

.accounting-kind-badge {
  display: inline-block;
  padding: 0.2rem 0.5rem;
  border-radius: 6px;
  font-size: 0.72rem;
  background: rgba(58, 120, 180, 0.18);
  border: 1px solid rgba(58, 120, 180, 0.35);
  color: #dfdfdf; }

.accounting-btn {
  padding: 0.45rem 0.9rem;
  border-radius: 8px;
  border: 1px solid transparent;
  font-size: 0.82rem;
  cursor: pointer; }
  .accounting-btn--primary {
    color: #ffffff;
    background: linear-gradient(180deg, rgba(58, 120, 180, 0.95), rgba(0, 48, 77, 0.95));
    border-color: rgba(58, 120, 180, 0.75); }
  .accounting-btn--ghost {
    color: #dfdfdf;
    background: rgba(21, 28, 36, 0.45);
    border-color: rgba(58, 120, 180, 0.35); }
  .accounting-btn:disabled {
    opacity: 0.55;
    cursor: not-allowed; }

.accounting-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(0, 0, 0, 0.55); }

.accounting-modal {
  width: min(560px, 100%);
  max-height: 90vh;
  overflow: auto;
  padding: 1rem 1.1rem 1.1rem;
  border-radius: 14px;
  border: 1px solid rgba(58, 120, 180, 0.45); }

.accounting-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.85rem; }

.accounting-modal__title {
  margin: 0;
  font-size: 1rem;
  color: #dfdfdf;
  text-transform: uppercase;
  letter-spacing: 0.04em; }

.accounting-modal__close {
  width: 2rem;
  height: 2rem;
  border: none;
  border-radius: 8px;
  background: rgba(56, 72, 88, 0.45);
  color: #dfdfdf;
  font-size: 1.25rem;
  line-height: 1;
  cursor: pointer; }

.accounting-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem; }

.accounting-field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem; }
  .accounting-field span {
    font-size: 0.72rem;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.62); }
  .accounting-field input,
  .accounting-field select,
  .accounting-field textarea {
    width: -webkit-fill-available;
    padding: 0.45rem 0.65rem;
    border: 1px solid rgba(58, 120, 180, 0.45);
    border-radius: 8px;
    font-family: inherit;
    font-size: 0.84rem;
    color: #dfdfdf;
    background: rgba(0, 48, 77, 0.65); }
  .accounting-field--wide {
    grid-column: 1 / -1; }

.accounting-form-error {
  margin: 0.65rem 0 0;
  color: #d12323;
  font-size: 0.82rem; }

.accounting-modal__actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1rem; }

@media (max-width: 900px) {
  .accounting-hero {
    grid-template-columns: 1fr; }
  .accounting-audit-kpi {
    grid-template-columns: 1fr; }
  .accounting-audit-kpi--members {
    grid-template-columns: 1fr 1fr; }
  .accounting-audit-layout {
    gap: 0.85rem; }
  .accounting-audit-detail__hero {
    grid-template-columns: 1fr; }
  .accounting-audit-detail__hero-side {
    text-align: left; }
  .accounting-audit-detail__cards {
    grid-template-columns: 1fr; }
  .accounting-org-inventory-item__hero {
    grid-template-columns: 1fr; }
  .accounting-org-inventory-item__side {
    text-align: left; }
  .accounting-members-panel__hero {
    grid-template-columns: 1fr; }
  .accounting-members-panel__stats {
    justify-content: flex-start; }
  .accounting-members-panel__stat {
    text-align: left; }
  .accounting-contracts-panel__hero {
    grid-template-columns: 1fr; }
  .accounting-contracts-panel__stats {
    justify-content: flex-start; }
  .accounting-contracts-panel__stat {
    text-align: left; }
  .accounting-contracts-panel__grid {
    grid-template-columns: 1fr; }
  .accounting-form-grid {
    grid-template-columns: 1fr; }
  .accounting-field--wide {
    grid-column: auto; } }

.accounting-category-resets {
  display: flex;
  flex-direction: column;
  gap: 1rem; }

.accounting-category-resets__stats {
  margin-bottom: 0; }

.accounting-category-resets__overview {
  margin-bottom: 0; }

.accounting-category-resets__overview-toolbar {
  min-height: 1.75rem;
  margin-bottom: 0.65rem;
  padding-bottom: 0;
  border-bottom: none; }

.accounting-category-resets__toolbar-eyebrow {
  font-size: 0.72rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.62); }

.accounting-category-resets__panel-header.accounting-toolbar,
.accounting-category-resets__detail-header.accounting-toolbar {
  align-items: flex-start;
  margin-bottom: 0.85rem;
  padding-bottom: 0;
  border-bottom: none; }

.accounting-category-resets__detail-header.accounting-toolbar {
  flex-wrap: wrap;
  gap: 0.75rem; }

.accounting-category-resets__detail-heading {
  flex: 1 1 12rem;
  min-width: 0; }

.accounting-category-resets__detail-header .accounting-toolbar__actions {
  margin-left: auto; }

.accounting-category-resets__layout {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);
  gap: 1rem; }

.accounting-category-resets__list-panel,
.accounting-category-resets__detail-panel {
  padding: 1rem 1.1rem;
  min-width: 0; }

.accounting-category-resets__panel-header,
.accounting-category-resets__detail-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.85rem; }

.accounting-category-resets__panel-title {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: #dfdfdf; }

.accounting-category-resets__detail-meta {
  margin: 0.35rem 0 0; }

.accounting-category-resets__muted {
  margin: 0;
  font-size: 0.85rem;
  color: rgba(223, 223, 223, 0.62); }

.accounting-category-resets__table tbody tr {
  cursor: pointer; }

.accounting-category-resets__table tbody tr.is-selected {
  background: rgba(58, 120, 180, 0.14); }

.accounting-category-resets__category-label {
  font-size: 0.84rem;
  color: #dfdfdf; }

.accounting-category-resets__category-key {
  margin-top: 0.15rem;
  font-size: 0.72rem;
  color: rgba(223, 223, 223, 0.55);
  font-family: 'FiraCode', monospace; }

.accounting-category-resets__row-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem; }

.accounting-category-resets__breakdown {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.65rem 1rem;
  margin-top: 1rem;
  padding-top: 0.85rem;
  border-top: 1px solid rgba(58, 120, 180, 0.28); }

.accounting-category-resets__breakdown-item {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  font-size: 0.78rem;
  color: rgba(223, 223, 223, 0.68); }
  .accounting-category-resets__breakdown-item strong {
    font-size: 0.88rem;
    color: #dfdfdf; }

.accounting-category-resets__item-kinds {
  margin-top: 1rem;
  padding-top: 0.85rem;
  border-top: 1px solid rgba(58, 120, 180, 0.28); }

.accounting-category-resets__item-kinds-title {
  margin: 0 0 0.55rem;
  font-size: 0.82rem;
  font-weight: 600;
  color: rgba(223, 223, 223, 0.88); }

.accounting-category-resets__item-kinds-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem; }

@media (max-width: 960px) {
  .accounting-category-resets__layout {
    grid-template-columns: 1fr; } }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.error {
  color: red;
  font-size: 0.8em;
  margin-top: 5px; }

.input.admin.container {
  display: flex;
  gap: 10px;
  background: none;
  border: none;
  margin: 0;
  padding: 0; }

.filter-container {
  width: 350px; }
  .filter-container .user-filter .input {
    width: 100%; }
  .filter-container.organization-logs .user-filter .input {
    width: 350px; }

.input.admin {
  background-color: #163447;
  padding: 0px 10px 20px 10px;
  border: 1px solid #b8b8b8;
  border-radius: 8px;
  margin: 0 10px; }
  .input.admin.roles {
    width: 50%;
    height: 290px; }
  .input.admin.groups {
    width: 50%;
    height: 330px; }
  .input.admin.resources {
    width: 50%;
    height: 290px; }
    .input.admin.resources .buttons.manage-resources {
      gap: 10px; }
  .input.admin .create-role,
  .input.admin .create-group {
    display: flex;
    flex-direction: column;
    width: 100%; }
    .input.admin .create-role .label-role,
    .input.admin .create-role .label-group,
    .input.admin .create-group .label-role,
    .input.admin .create-group .label-group {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 10px; }
      .input.admin .create-role .label-role label,
      .input.admin .create-role .label-group label,
      .input.admin .create-group .label-role label,
      .input.admin .create-group .label-group label {
        display: flex;
        align-items: center;
        width: 100%;
        margin-right: 10px;
        font-weight: bold; }
        .input.admin .create-role .label-role label span,
        .input.admin .create-role .label-group label span,
        .input.admin .create-group .label-role label span,
        .input.admin .create-group .label-group label span {
          width: 150px;
          font-weight: bold; }
        .input.admin .create-role .label-role label input, .input.admin .create-role .label-role label textarea,
        .input.admin .create-role .label-group label input,
        .input.admin .create-role .label-group label textarea,
        .input.admin .create-group .label-role label input,
        .input.admin .create-group .label-role label textarea,
        .input.admin .create-group .label-group label input,
        .input.admin .create-group .label-group label textarea {
          flex-grow: 1;
          max-width: 300px;
          padding: 4px; }
      .input.admin .create-role .label-role .error,
      .input.admin .create-role .label-group .error,
      .input.admin .create-group .label-role .error,
      .input.admin .create-group .label-group .error {
        color: red;
        font-size: 0.8em;
        margin-top: 5px;
        width: 100%; }
    .input.admin .create-role .btn-style1.left,
    .input.admin .create-group .btn-style1.left {
      margin-right: auto;
      margin-left: 0px; }

.input.admin.discord-bot {
  display: flex;
  flex-direction: column; }
  .input.admin.discord-bot .admin-section h4 {
    margin-bottom: 10px; }
  .input.admin.discord-bot .admin-section .permission-list {
    height: 150px;
    overflow-y: auto;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); }
  .input.admin.discord-bot .admin-section .permission-list li {
    margin: 0px 10px; }

.input.admin.filter {
  display: flex;
  gap: 10px;
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  width: 100%; }

.role-permission,
.group-role {
  width: 30%;
  min-width: 150px;
  padding: 0.3rem;
  display: flex;
  align-items: center;
  height: 100%;
  margin-right: 1rem; }

.permissions-list,
.roles-list {
  background-color: #163447;
  padding: 20px 20px 20px 20px;
  border: 1px solid #b8b8b8;
  border-radius: 8px;
  margin: 0 10px; }
  .permissions-list .admin-panel,
  .roles-list .admin-panel {
    text-transform: uppercase; }
  .permissions-list .menu,
  .roles-list .menu {
    font-size: 1.05rem;
    margin-top: 30px;
    margin-left: 20px;
    text-transform: uppercase;
    padding-top: 10px; }
  .permissions-list .tab,
  .roles-list .tab {
    color: #c5ccd1;
    font-weight: normal;
    font-size: 1.0rem;
    margin-top: 10px;
    margin-left: 20px;
    text-transform: none;
    padding-top: 10px; }
  .permissions-list .permission,
  .permissions-list .role,
  .roles-list .permission,
  .roles-list .role {
    font-weight: bold;
    margin-left: 20px;
    margin-top: 10px; }
    .permissions-list .permission .description,
    .permissions-list .role .description,
    .roles-list .permission .description,
    .roles-list .role .description {
      margin-left: 0px; }
  .permissions-list .role-selection,
  .permissions-list .group-selection,
  .roles-list .role-selection,
  .roles-list .group-selection {
    display: flex;
    align-items: center;
    justify-content: space-between; }
    .permissions-list .role-selection .dropdown,
    .permissions-list .group-selection .dropdown,
    .roles-list .role-selection .dropdown,
    .roles-list .group-selection .dropdown {
      display: flex;
      align-items: center; }
    .permissions-list .role-selection .selected.role-description, .permissions-list .role-selection .selected.group-description,
    .permissions-list .group-selection .selected.role-description,
    .permissions-list .group-selection .selected.group-description,
    .roles-list .role-selection .selected.role-description,
    .roles-list .role-selection .selected.group-description,
    .roles-list .group-selection .selected.role-description,
    .roles-list .group-selection .selected.group-description {
      margin-left: 1rem;
      transform: translateY(-7px); }
    .permissions-list .role-selection .save-permission,
    .permissions-list .group-selection .save-permission,
    .roles-list .role-selection .save-permission,
    .roles-list .group-selection .save-permission {
      margin-left: auto;
      align-self: center;
      height: 100%; }

.gris {
  opacity: 0.4;
  /* Diminue l'opacité pour un effet grisé */
  pointer-events: none;
  /* Empêche toute interaction avec l'élément */
  color: #dfdfdf;
  /* Change la couleur du texte pour un gris clair */ }

.permission.description,
.role.description {
  font-size: 0.95rem;
  color: #b8b8b8;
  text-transform: none;
  padding: 0px 0px 10px 0px;
  margin-top: 0px;
  border-bottom: 1px solid #2a3847; }

.permission.toggle,
.role.toggle {
  margin-top: 0px;
  margin-left: auto; }

.separator {
  border-bottom: 1px solid #b8b8b8;
  margin: 10px 0px 15px 0px; }

.user-filter {
  margin: 10px 10px 10px auto; }
  .user-filter.organization-logs {
    margin-left: 15px; }
  .user-filter.organization-applications {
    margin: 5px 0px 5px 0px; }
  .user-filter input {
    width: 460px;
    padding: 0.3rem;
    margin-left: 0px;
    font-size: 1rem;
    border: 1px solid #ddd;
    border-radius: 4px; }

.action-filter.organization-logs {
  display: flex;
  margin-left: 20px;
  gap: 20px;
  width: max-content; }

.users-list .user-item {
  display: flex;
  flex-direction: column;
  background-color: #1c2d38;
  margin: 10px;
  border: 1px solid #b8b8b8;
  border-radius: 8px;
  padding: 10px 15px;
  cursor: pointer; }
  .users-list .user-item.user-groups {
    max-height: 500px;
    /* Adjust this value based on your content */ }
  .users-list .user-item.expanded {
    background-color: #163447;
    max-height: 500px;
    /* Adjust this value based on your content */ }
  .users-list .user-item.unconfirmed {
    border-color: orange; }
  .users-list .user-item.deleted {
    border-color: #d12323; }
  .users-list .user-item .site-admin.email {
    color: #b8b8b8;
    font-size: 1rem;
    margin: 10px;
    transition: color 0.2s ease-in 0s; }
    .users-list .user-item .site-admin.email.selected {
      color: #dfdfdf;
      font-weight: bold;
      transition: color 0s ease-in 0s; }
  .users-list .user-item .user-groups {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.4s ease-in-out;
    margin-left: 10px;
    align-items: center; }
    .users-list .user-item .user-groups.expanded {
      max-height: 500px;
      /* Adjust according to your needs */ }
    .users-list .user-item .user-groups .container {
      margin: 10px 0px; }
    .users-list .user-item .user-groups .add-group .add-group.dropdown {
      width: 250px;
      margin-right: 10px;
      padding: 3px 5px;
      cursor: pointer; }
    .users-list .user-item .user-groups .user-group-item {
      display: flex;
      flex-wrap: nowrap;
      list-style-type: none;
      align-items: center; }
      .users-list .user-item .user-groups .user-group-item .group-name {
        width: 250px;
        margin-right: 10px; }
    .users-list .user-item .user-groups .btn-style1 {
      margin-left: 10px; }

.users-list .user-email.deleted {
  color: #d12323; }

.user-header {
  display: flex;
  justify-content: space-between;
  align-items: center; }
  .user-header .account-created {
    font-size: 0.9em;
    color: #888;
    margin-left: auto; }

.user-details {
  padding: 15px 10px 15px 10px;
  background-color: #2a3847;
  border-radius: 8px; }
  .user-details .user-details-header {
    display: flex; }
    .user-details .user-details-header.user-details-header .user-email {
      border: 2px solid #b8b8b8;
      margin: 0px 0px 5px 0px;
      border-radius: 20px;
      padding: 4px 10px; }
    .user-details .user-details-header.user-details-header .user-add-assignment-inline {
      margin: 0px 10px 0px auto; }
      .user-details .user-details-header.user-details-header .user-add-assignment-inline .assignment-dropdown {
        border-radius: 8px;
        padding: 5px;
        margin-right: 15px; }
  .user-details .user-details-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 10px; }
  .user-details .user-details-actions__feedback {
    flex: 1 1 100%;
    font-size: 0.9rem;
    color: #b8b8b8;
    text-align: right; }
  .user-details .user-details-actions__verify {
    min-height: 34px; }

.table-message-container {
  display: flex;
  margin: 0px; }

.message-container {
  width: 550px;
  height: fit-content;
  margin-top: 10px;
  margin-left: 10px;
  background-color: #0c2637;
  border: 1px solid #491212;
  border-bottom: 4px solid #491212;
  border-radius: 8px;
  box-shadow: 4px 5px 2px #4b050547; }
  .message-container .application-header {
    display: flex;
    justify-content: space-between;
    color: #dfdfdf;
    text-transform: uppercase;
    font-weight: bold;
    align-items: center;
    padding: 5px 10px;
    border-bottom: 2px solid #2a3847;
    border-radius: 8px 8px 0px 0px;
    background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___}); }
    .message-container .application-header .application-title {
      font-size: small;
      text-transform: uppercase;
      color: #b8b8b8;
      margin-block-start: 0em;
      margin-block-end: 0em; }
  .message-container .application-content {
    overflow-wrap: anywhere;
    padding: 10px;
    background-color: #1e3042;
    height: 199px;
    overflow-y: auto;
    width: auto; }
    .message-container .application-content::-webkit-scrollbar {
      width: 6px; }
    .message-container .application-content::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .message-container .application-content::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .message-container .application-content::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
  .message-container .application-footer {
    background: #1c2d38;
    height: 20px; }
    .message-container .application-footer .vote-button {
      background: #0c2637;
      border: 1px solid #2a3847;
      border-radius: 8px;
      margin: 5px;
      cursor: pointer;
      display: inline-flex;
      align-items: center; }
      .message-container .application-footer .vote-button .vote-count {
        color: #b8b8b8;
        margin: 0 0.35rem;
        font-weight: bold; }
      .message-container .application-footer .vote-button.upvote {
        position: absolute;
        transform: translate(10px, 5px); }
        .message-container .application-footer .vote-button.upvote .thumbs-up-icon {
          width: 17px;
          margin: 0px 5px 0px 0px;
          padding: 4px; }
        .message-container .application-footer .vote-button.upvote.voted {
          background: #163447;
          border: 1px solid #dfdfdf; }
      .message-container .application-footer .vote-button.downvote {
        position: absolute;
        transform: translate(80px, 5px); }
        .message-container .application-footer .vote-button.downvote .thumbs-down-icon {
          width: 17px;
          margin: 0px 5px 0px 0px;
          padding: 4px; }
        .message-container .application-footer .vote-button.downvote.voted {
          background: #163447;
          border: 1px solid #dfdfdf; }
      .message-container .application-footer .vote-button:hover {
        border: 1px solid #b8b8b8; }

.application-process {
  display: flex;
  flex-direction: row;
  height: 50px;
  gap: 5px; }
  .application-process input[type="checkbox"] {
    /* hide visual element */
    opacity: 0;
    width: 0;
    height: 0;
    margin: 0;
    pointer-events: none;
    position: absolute; }
  .application-process .vote-section {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 130px; }
    .application-process .vote-section .vote-button {
      display: inline-flex;
      width: 60px;
      height: 40px;
      color: #b8b8b8;
      background: #163447;
      border: 1px solid #747b81;
      border-radius: 8px;
      padding: 5px;
      margin: 5px;
      align-items: center;
      cursor: pointer; }
      .application-process .vote-section .vote-button .vote-icon {
        display: inline-flex;
        height: 20px;
        padding: 5px;
        align-items: center;
        cursor: pointer; }
      .application-process .vote-section .vote-button .vote-count {
        margin: 0 0.35rem;
        font-weight: bold; }
      .application-process .vote-section .vote-button:hover {
        border: 1px solid #dfdfdf; }
  .application-process .background-check {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 10px;
    width: 110px;
    /* ============================================================
        CHECKED FIELD COLORS
        Each type has its own highlight when .checked is present
        ============================================================ */ }
    .application-process .background-check .field {
      position: relative;
      display: flex;
      align-items: center;
      font-size: 14px;
      height: 35px;
      background: #163447;
      padding: 3px 12px 3px 8px;
      border-radius: 6px;
      flex: none;
      cursor: pointer;
      clip-path: polygon(0% 0%, 88% 0%, 100% 50%, 88% 100%, 0% 100%);
      transition: background-color 0.25s ease, border-color 0.25s ease;
      /* ---- SELECT ---- */
      /* ---- LABEL ---- */ }
      .application-process .background-check .field:hover {
        border-color: #dfdfdf; }
      .application-process .background-check .field select {
        padding: 0px 10px;
        background: transparent;
        border: none;
        text-align-last: center;
        text-transform: capitalize;
        color: #dfdfdf;
        height: 24px;
        line-height: 24px;
        border-radius: 6px;
        appearance: none;
        cursor: pointer; }
        .application-process .background-check .field select:focus-visible {
          border: none; }
      .application-process .background-check .field select:invalid {
        color: #dfdfdf;
        opacity: 0.7; }
      .application-process .background-check .field label {
        color: #b8b8b8;
        padding: 3px 0px 3px 14px;
        cursor: pointer; }
    .application-process .background-check .field.age {
      left: 0px;
      z-index: 30;
      width: 120px; }
      .application-process .background-check .field.age select:focus-visible {
        border: none; }
      .application-process .background-check .field.age select option {
        background: #163447; }
    .application-process .background-check .field.spectrum {
      left: -20px;
      z-index: 25;
      justify-content: center;
      width: 120px; }
      .application-process .background-check .field.spectrum select:focus-visible {
        border: none; }
      .application-process .background-check .field.spectrum select option {
        background: #163447; }
    .application-process .background-check .field.rsi {
      left: -40px;
      z-index: 20;
      justify-content: center;
      width: 110px; }
    .application-process .background-check .field.discord {
      left: -60px;
      z-index: 15;
      justify-content: center;
      width: 110px; }
    .application-process .background-check .field.admission {
      left: -80px;
      z-index: 10;
      justify-content: center;
      width: 110px; }
    .application-process .background-check .field.age.checked {
      background-color: #42260c;
      left: 0px;
      z-index: 30; }
      .application-process .background-check .field.age.checked select {
        max-height: 60px;
        overflow-y: auto; }
        .application-process .background-check .field.age.checked select option {
          background: #42260c; }
    .application-process .background-check .field.spectrum.checked {
      background-color: #6e441c;
      left: -20px;
      z-index: 25; }
      .application-process .background-check .field.spectrum.checked select option {
        background: #6e441c; }
    .application-process .background-check .field.rsi.checked {
      background-color: #9b602a;
      left: -40px;
      z-index: 20; }
      .application-process .background-check .field.rsi.checked.declined {
        background-color: #9e2222; }
        .application-process .background-check .field.rsi.checked.declined select {
          color: #dfdfdf; }
    .application-process .background-check .field.discord.checked {
      background-color: #c78445;
      color: #0c2637;
      left: -60px;
      z-index: 15;
      width: 110px; }
      .application-process .background-check .field.discord.checked label {
        color: #0c2637; }
    .application-process .background-check .field.admission.checked {
      background-color: #d8b493;
      left: -80px;
      justify-content: center;
      z-index: 10;
      width: 110px; }
      .application-process .background-check .field.admission.checked label {
        color: #0c2637; }
    .application-process .background-check .rsi-link {
      display: inline-flex;
      position: relative;
      left: -70px;
      width: 0px;
      height: 25px;
      opacity: 0.7;
      cursor: pointer; }
      .application-process .background-check .rsi-link:hover {
        opacity: 1; }
    .application-process .background-check .field-2 {
      position: relative;
      display: flex;
      align-items: center;
      font-size: 14px;
      height: 40px;
      background: #163447;
      padding: 3px 12px 3px 8px;
      border: 1px solid #004872;
      border-radius: 6px;
      flex: none; }
      .application-process .background-check .field-2:hover {
        background-color: #491212;
        color: #dfdfdf;
        border: 1px solid #9e2222;
        cursor: pointer; }
    .application-process .background-check .field-2.canceled.checked {
      background-color: #9e2222; }
  .application-process .field-updated {
    position: relative;
    overflow: visible; }
  .application-process .field-updated::after {
    content: "";
    position: absolute;
    inset: -4px;
    border-radius: 6px;
    pointer-events: none; }

@keyframes glowFlash {
  0% {
    box-shadow: 0 0 0px 0px rgba(255, 240, 120, 0.9);
    opacity: 1; }
  40% {
    box-shadow: 0 0 8px 4px rgba(255, 240, 120, 0.8);
    opacity: 1; }
  100% {
    box-shadow: 0 0 0px 0px rgba(255, 240, 120, 0);
    opacity: 0; } }

.clickable-row {
  cursor: pointer; }

.clickable-row:hover {
  background-color: #f1f1f1; }

.questions-fields-container {
  display: flex;
  flex-direction: column;
  gap: 10px; }

/* 🔹 Chips: see main.scss (.chip, .chips-container) */
/* 🔹 Confirmation modal (style minimal) */
.remove-confirm-modal {
  position: fixed;
  inset: 0;
  /* top/right/bottom/left: 0 */
  z-index: 20000;
  /* above everything else */
  background: rgba(0, 0, 0, 0.6);
  /* Center the dialog regardless of page scroll */
  display: grid;
  place-items: center;
  /* Prevent background from scrolling while open (optional) */
  overscroll-behavior: contain; }

/* Dialog card */
.remove-confirm-modal .modal-content {
  height: 150px;
  width: min(92vw, 480px);
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4); }

/* Actions row */
.remove-confirm-modal .modal-actions {
  margin-top: 16px;
  display: flex;
  justify-content: center;
  gap: 10px; }

/* Optional: lock body scroll when modal is open */
body.modal-open {
  overflow: hidden; }

.handle-cell {
  position: relative;
  display: flex;
  align-items: center;
  gap: 5px; }
  .handle-cell .warning-icon {
    display: "inline-block";
    position: relative;
    vertical-align: middle;
    cursor: pointer;
    font-size: 14px;
    color: #d67f00;
    margin-left: auto;
    margin-right: 5px; }
    .handle-cell .warning-icon .warning-tooltip {
      visibility: hidden;
      opacity: 0;
      position: "fixed";
      width: max-content;
      height: max-content;
      background-color: #0c2637;
      color: #dfdfdf;
      border: 1px solid #b8b8b8;
      border-radius: 4px;
      padding: 8px 10px;
      white-space: nowrap;
      z-index: 999999;
      transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;
      overflow: visible !important; }
      .handle-cell .warning-icon .warning-tooltip .tooltip-title {
        font-weight: bold;
        margin-bottom: 5px;
        white-space: normal; }
      .handle-cell .warning-icon .warning-tooltip .tooltip-list {
        margin: 0;
        padding-left: 16px;
        text-align: left;
        white-space: normal; }
        .handle-cell .warning-icon .warning-tooltip .tooltip-list li {
          list-style-type: disc; }
    .handle-cell .warning-icon:hover .warning-tooltip {
      visibility: visible;
      opacity: 1;
      top: -40px;
      left: 94px; }

.floating-warning-tooltip {
  background: #0c2637;
  color: #dfdfdf;
  border: 1px solid #b8b8b8;
  border-radius: 4px;
  padding: 8px 10px;
  z-index: 99999;
  white-space: nowrap;
  pointer-events: none;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5); }
  .floating-warning-tooltip.global {
    position: fixed;
    transform: translateX(-50%) translateY(-95%);
    z-index: 9999;
    border-radius: 6px;
    padding: 6px 8px;
    font-size: 13px;
    opacity: 1; }

.tooltip-title {
  font-weight: bold;
  margin-bottom: 5px; }

.tooltip-list {
  margin: 0;
  padding-left: 16px;
  text-align: left;
  white-space: normal; }
  .tooltip-list li {
    list-style-type: disc; }

.mark-all-read-btn {
  font-size: 10px;
  line-height: 14px;
  padding: 0 6px;
  height: 26px;
  flex-shrink: 0;
  opacity: 0.7;
  border-radius: 3px;
  cursor: pointer;
  border: 1px solid #ccc;
  background: #f5f5f5; }
  .mark-all-read-btn:hover {
    opacity: 1; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.groups-roles-tab {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 0; }
  .groups-roles-tab__intro {
    margin: 0;
    font-size: 0.85rem;
    line-height: 1.45;
    color: rgba(223, 223, 223, 0.85); }
  .groups-roles-tab__layout {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1rem;
    align-items: start; }
    @media (max-width: 1100px) {
      .groups-roles-tab__layout {
        grid-template-columns: 1fr; } }
  .groups-roles-tab__block {
    min-width: 0;
    margin: 0; }
  .groups-roles-tab .admin-block-header {
    margin-bottom: 0.75rem; }
    .groups-roles-tab .admin-block-header .admin-h4 {
      margin: 0 0 0.35rem; }
    .groups-roles-tab .admin-block-header .hint {
      margin: 0; }
  .groups-roles-tab__selected-pill {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 0.35rem 0.65rem;
    margin-top: 0.5rem;
    padding: 0.5rem 0.75rem;
    border-radius: 8px;
    border: 1px solid rgba(117, 207, 120, 0.28);
    background: rgba(42, 95, 45, 0.22); }
  .groups-roles-tab__selected-label {
    font-size: 0.68rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #75cf78; }
  .groups-roles-tab__selected-name {
    font-size: 0.9rem;
    font-weight: 700;
    color: #c2f0c3; }
  .groups-roles-tab__toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.65rem;
    margin-bottom: 0.75rem; }
  .groups-roles-tab__search {
    flex: 1 1 180px;
    min-width: 140px;
    max-width: 280px;
    padding: 0.45rem 0.65rem;
    border: 1px solid rgba(90, 195, 255, 0.35);
    border-radius: 6px;
    background: rgba(12, 38, 55, 0.65);
    color: #dfdfdf;
    font-size: 0.85rem; }
    .groups-roles-tab__search::placeholder {
      color: rgba(184, 184, 184, 0.85); }
    .groups-roles-tab__search:focus {
      outline: none;
      border-color: rgba(90, 195, 255, 0.55);
      box-shadow: 0 0 0 2px rgba(58, 120, 180, 0.25); }
  .groups-roles-tab__section {
    min-width: 0; }
  .groups-roles-tab__empty {
    margin: 0;
    padding: 0.75rem 0.5rem;
    font-size: 0.85rem;
    font-style: italic;
    color: rgba(184, 184, 184, 0.9); }
  .groups-roles-tab .admin-actions {
    margin-top: 0.85rem;
    padding-top: 0.25rem; }
  .groups-roles-tab .table-base.simple-editor-table {
    margin: 0;
    border-color: rgba(116, 123, 129, 0.35);
    box-shadow: 0 6px 18px rgba(21, 28, 36, 0.28); }
    .groups-roles-tab .table-base.simple-editor-table .table-body-scroll {
      max-height: min(420px, 48vh);
      overflow-y: auto;
      border-bottom-width: 2px; }
    .groups-roles-tab .table-base.simple-editor-table tbody.content tr.table-row {
      cursor: pointer; }
    .groups-roles-tab .table-base.simple-editor-table td.cell-assign {
      text-align: center; }
  .groups-roles-tab .role-checkbox:disabled {
    opacity: 0.45;
    cursor: not-allowed; }

.table-base.simple-editor-table.simple-editor-table--groups col.col-groups-name {
  width: 24%; }

.table-base.simple-editor-table.simple-editor-table--groups col.col-groups-description {
  width: 46%; }

.table-base.simple-editor-table.simple-editor-table--groups col.col-groups-mentionable {
  width: 10%; }

.table-base.simple-editor-table.simple-editor-table--groups col.col-groups-actions {
  width: 14%; }

.table-base.simple-editor-table.simple-editor-table--group-roles col.col-group-roles-name {
  width: 30%; }

.table-base.simple-editor-table.simple-editor-table--group-roles col.col-group-roles-description {
  width: 54%; }

.table-base.simple-editor-table.simple-editor-table--group-roles col.col-group-roles-assign {
  width: 10%; }

.groups-roles-modal .form-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.85rem; }

.groups-roles-modal .input-field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem; }

.groups-roles-modal .input-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: #b8b8b8; }

.groups-roles-modal .input-text {
  width: 100%;
  padding: 0.45rem 0.65rem;
  border: 1px solid rgba(116, 123, 129, 0.45);
  border-radius: 6px;
  background: rgba(12, 38, 55, 0.55);
  color: #dfdfdf;
  font-size: 0.85rem; }
  .groups-roles-modal .input-text:disabled {
    opacity: 0.65;
    cursor: not-allowed; }

.groups-roles-modal__mentionable {
  flex-direction: row;
  align-items: center;
  gap: 0.5rem; }
  .groups-roles-modal__mentionable .input-label {
    margin: 0;
    cursor: pointer;
    font-weight: normal;
    color: #dfdfdf; }

.groups-roles-modal__mentionable-input {
  width: auto;
  flex-shrink: 0; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.admin-toggle {
  display: flex;
  align-items: start;
  justify-content: space-between;
  border-bottom: 1px solid #2a3847; }

.toggle-info {
  flex: 1;
  padding: 10px 0 10px 0; }

.toggle-control {
  flex: 0 1 auto;
  margin-top: 30px; }

.toggle-description {
  font-size: 0.9em;
  color: #b8b8b8; }

.user-admin-container {
  display: flex;
  flex-direction: column;
  gap: 0px;
  /* Site Admin: wrap upward — primary row stays bottom (next to content); overflow rows stack above */ }
  .user-admin-container .admin-tabs {
    display: flex;
    flex-direction: row;
    margin-top: 20px;
    margin-bottom: 0px;
    border-bottom: 2px solid #1c2d38; }
    .user-admin-container .admin-tabs button {
      position: relative;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      padding: 5px 10px 5px 10px;
      color: #b8b8b8;
      margin-right: 2px;
      min-width: 90px;
      background-color: #0c2637;
      cursor: pointer; }
      .user-admin-container .admin-tabs button:hover {
        background-color: #2a3847; }
      .user-admin-container .admin-tabs button .desktop-link-unread-circle {
        display: inline-block;
        margin-left: 0.45rem;
        vertical-align: middle;
        width: 10px;
        height: 10px;
        min-width: 10px;
        min-height: 10px;
        box-sizing: border-box;
        border-radius: 50%;
        border: 1px solid #5ac3ff;
        background: transparent;
        pointer-events: none; }
    .user-admin-container .admin-tabs .active {
      background-color: #2a3847;
      color: #dfdfdf;
      border-bottom: 2px solid #2a3847; }
  .user-admin-container .admin-tabs.site-admin-tabs {
    flex-direction: row;
    flex-wrap: wrap-reverse;
    align-items: flex-end;
    gap: 2px; }
    .user-admin-container .admin-tabs.site-admin-tabs button {
      margin-right: 0;
      white-space: nowrap;
      flex-shrink: 0; }
  .user-admin-container .admin-content-container {
    display: flex;
    flex-direction: column;
    gap: 10px; }

.publicpages-content-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 5px; }

.admin-tab-content {
  background-color: #2a3847;
  padding: 10px 10px 10px 10px;
  color: #dfdfdf;
  width: calc(100% - 21px);
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px; }

.handle-ownership-tab .handle-ownership-hint,
.handle-ownership-tab .handle-ownership-empty,
.handle-ownership-tab .handle-ownership-userline {
  font-size: 0.9em;
  color: #b8b8b8;
  margin: 0 0 12px 0;
  max-width: 640px; }

.handle-ownership-tab .handle-ownership-label {
  display: block;
  margin: 12px 0 6px;
  font-size: 0.85em;
  color: #dfdfdf; }

.handle-ownership-tab .handle-ownership-select-wrap {
  max-width: 420px; }

.handle-ownership-tab .handle-ownership-input {
  display: block;
  min-width: 220px;
  max-width: 420px;
  padding: 8px 10px;
  border: 1px solid #1c2d38;
  border-radius: 6px;
  background-color: #0c2637;
  color: #dfdfdf; }

.handle-ownership-tab .handle-ownership-datepicker {
  max-width: 420px; }
  .handle-ownership-tab .handle-ownership-datepicker .react-datepicker-wrapper,
  .handle-ownership-tab .handle-ownership-datepicker .react-datepicker__input-container {
    display: block;
    width: 100%; }
  .handle-ownership-tab .handle-ownership-datepicker .react-datepicker__input-container .handle-ownership-input {
    width: 100%; }

.handle-ownership-tab .handle-ownership-section-title {
  margin: 20px 0 8px;
  color: #dfdfdf; }

.handle-ownership-tab .handle-ownership-table {
  width: 100%;
  max-width: 920px;
  border-collapse: collapse;
  margin-bottom: 12px;
  font-size: 0.85em; }
  .handle-ownership-tab .handle-ownership-table th,
  .handle-ownership-tab .handle-ownership-table td {
    padding: 6px 8px;
    border-bottom: 1px solid #1c2d38;
    text-align: left;
    color: #dfdfdf; }
  .handle-ownership-tab .handle-ownership-table th {
    color: #b8b8b8; }

.handle-ownership-tab .handle-ownership-form {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #1c2d38;
  max-width: 520px; }

.handle-ownership-tab .handle-ownership-status {
  margin: 8px 0;
  padding: 10px 12px;
  font-size: 0.9em;
  color: #dfdfdf;
  background-color: #163447;
  border: 1px solid #004872;
  border-radius: 6px; }

.handle-ownership-tab .handle-ownership-submit {
  margin-top: 14px;
  padding: 8px 14px;
  border-radius: 6px;
  border: 1px solid #1c2d38;
  background-color: #1c2d38;
  color: #dfdfdf;
  cursor: pointer; }
  .handle-ownership-tab .handle-ownership-submit:hover:not(:disabled) {
    background-color: #2a3847; }
  .handle-ownership-tab .handle-ownership-submit:disabled {
    opacity: 0.6;
    cursor: not-allowed; }

.rank-calculation-tab .rank-calculation-hint {
  font-size: 0.9em;
  color: #b8b8b8;
  margin: 0 0 12px 0;
  max-width: 520px; }

.rank-calculation-tab .rank-calculation-form {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 10px;
  margin-bottom: 12px; }

.rank-calculation-tab .rank-calculation-label {
  flex: 0 0 100%;
  font-size: 0.85em;
  color: #dfdfdf; }

.rank-calculation-tab .rank-calculation-select-wrap {
  flex: 1 1 280px;
  min-width: 260px;
  max-width: 420px; }

.rank-calculation-tab .rank-calculation-input {
  min-width: 220px;
  padding: 8px 10px;
  border: 1px solid #1c2d38;
  border-radius: 6px;
  background-color: #0c2637;
  color: #dfdfdf; }

.rank-calculation-tab .rank-calculation-submit {
  padding: 8px 14px;
  border-radius: 6px;
  border: 1px solid #1c2d38;
  background-color: #1c2d38;
  color: #dfdfdf;
  cursor: pointer; }
  .rank-calculation-tab .rank-calculation-submit:hover:not(:disabled) {
    background-color: #2a3847; }
  .rank-calculation-tab .rank-calculation-submit:disabled {
    opacity: 0.6;
    cursor: not-allowed; }

.rank-calculation-tab .rank-calculation-status {
  margin: 0 0 12px 0;
  max-width: 520px;
  padding: 10px 12px;
  font-size: 0.9em;
  line-height: 1.45;
  color: #dfdfdf;
  background-color: #163447;
  border: 1px solid #004872;
  border-radius: 6px; }

.rank-calculation-tab .rank-calculation-batch-section {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #1c2d38;
  max-width: 640px; }

.rank-calculation-tab .rank-calculation-batch-title {
  margin: 0 0 8px 0;
  font-size: 1rem;
  font-weight: 600;
  color: #dfdfdf; }

.rank-calculation-tab .rank-calculation-batch-warning {
  font-size: 0.9em;
  color: #b8b8b8;
  margin: 0 0 12px 0;
  line-height: 1.45; }

.rank-calculation-tab .rank-calculation-submit--danger {
  border-color: #491212;
  background-color: #491212;
  color: #dfdfdf; }
  .rank-calculation-tab .rank-calculation-submit--danger:hover:not(:disabled) {
    background-color: #d12323;
    border-color: #d12323; }

.rank-calculation-tab .rank-calculation-result {
  margin: 0;
  padding: 12px;
  max-height: 420px;
  overflow: auto;
  font-size: 0.8rem;
  border-radius: 6px;
  background-color: #0c2637;
  border: 1px solid #1c2d38; }

.sc-data-viewer-tab .sc-data-viewer-hint {
  font-size: 0.9em;
  color: #b8b8b8;
  margin: 0 0 16px 0;
  max-width: 560px;
  line-height: 1.45; }

.sc-data-viewer-tab .sc-data-viewer-form {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 520px;
  margin-bottom: 12px; }

.sc-data-viewer-tab .sc-data-viewer-label {
  font-size: 0.85em;
  color: #dfdfdf; }

.sc-data-viewer-tab .sc-data-viewer-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px; }

.sc-data-viewer-tab .sc-data-viewer-input {
  flex: 1 1 200px;
  min-width: 180px;
  max-width: 280px;
  padding: 8px 10px;
  border: 1px solid #1c2d38;
  border-radius: 6px;
  background-color: #0c2637;
  color: #dfdfdf;
  text-transform: uppercase;
  letter-spacing: 0.04em; }

.sc-data-viewer-tab .sc-data-viewer-submit {
  padding: 8px 14px;
  border-radius: 6px;
  border: 1px solid #1c2d38;
  background-color: #1c2d38;
  color: #dfdfdf;
  cursor: pointer; }
  .sc-data-viewer-tab .sc-data-viewer-submit:hover:not(:disabled) {
    background-color: #2a3847; }
  .sc-data-viewer-tab .sc-data-viewer-submit:disabled {
    opacity: 0.6;
    cursor: not-allowed; }

.sc-data-viewer-tab .sc-data-viewer-success {
  margin: 8px 0 0 0;
  font-size: 0.9em;
  color: #dfdfdf;
  max-width: 560px; }

.sc-data-viewer-tab .sc-data-viewer-error {
  margin: 8px 0 0 0;
  font-size: 0.9em;
  color: #d12323;
  max-width: 560px; }

.split-container.row {
  display: flex;
  flex-direction: row;
  gap: 10px; }

.admin-block-container {
  padding: 10px 15px;
  min-height: 150px;
  background-color: #163447;
  border: 1px solid #b8b8b8;
  border-radius: 5px;
  box-shadow: inset -2px -2px 3px rgba(70, 69, 69, 0.2); }
  .admin-block-container.full-width {
    width: calc(100% - 20px); }
  .admin-block-container.rte {
    height: 240px;
    padding-bottom: 20px; }
  .admin-block-container.ranks-input {
    display: flex;
    height: 275px;
    padding-bottom: 20px; }
  .admin-block-container.flex {
    display: flex;
    justify-content: space-between;
    /* Assure une répartition égale de l'espace */
    align-items: start;
    /* Aligner les éléments au début */
    gap: 20px; }
  .admin-block-container.flex-divisions {
    display: flex;
    justify-content: flex-start;
    /* Assure une répartition égale de l'espace */
    align-items: start;
    /* Aligner les éléments au début */ }
  .admin-block-container.structure.diagram {
    background: #163447; }
  .admin-block-container.event-template {
    padding: 0.2rem;
    margin-top: 15px; }
  .admin-block-container.permissions {
    height: 215px; }
  .admin-block-container.token-chart.preview {
    border: 1px solid #d12323; }
  .admin-block-container.trainings {
    display: flex;
    flex-direction: column;
    width: 45%;
    height: 240px;
    background: #1c2d38;
    padding: 0;
    margin-left: 10px;
    border: 1px solid #491212;
    border-bottom: 4px solid #491212;
    border-radius: 10px; }
    .admin-block-container.trainings .selected-row-info {
      display: grid;
      padding: 8px; }
    .admin-block-container.trainings .validate-button-container {
      margin: auto 0px 10px 10px; }
  .admin-block-container.trainings-selection {
    justify-content: space-between;
    width: 430px;
    background: #2a3847;
    margin-top: 55px;
    border: none; }
  .admin-block-container.dark-background {
    background: #163447; }

.logo-input-file {
  display: none; }

.training-equivalence.header {
  font-size: small;
  font-weight: lighter;
  text-transform: uppercase;
  text-align: left;
  height: 30px;
  padding: 0 5px;
  background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-bottom: 2px solid #2a3847;
  border-radius: 10px 10px 0px 0px; }
  .training-equivalence.header .training-equivalence-title {
    position: relative;
    top: 7px;
    color: #dfdfdf; }

.create-theme .admin-h4 {
  margin-left: 10px; }

.input-row.academy-question .mde-textarea-wrapper .mde-text {
  height: 60px !important; }

.input-row.academy-question .mde-preview {
  min-height: 60px !important;
  max-height: 60px !important;
  height: 60px !important; }

.admin-management, .structure-management {
  width: 100%; }
  .admin-management.tab-home, .structure-management.tab-home {
    width: 40%; }
  .admin-management .input-field, .structure-management .input-field {
    display: flex;
    align-items: center;
    border-radius: 4px; }
    .admin-management .input-field .home-file, .structure-management .input-field .home-file {
      display: flex;
      position: relative;
      align-items: center;
      justify-content: start;
      margin-left: 20px;
      margin-right: 0%;
      width: 28%;
      bottom: 0px; }
    .admin-management .input-field .media-file, .structure-management .input-field .media-file {
      display: none; }
    .admin-management .input-field .input-title,
    .admin-management .input-field .input-subtitle,
    .admin-management .input-field .input-file, .structure-management .input-field .input-title,
    .structure-management .input-field .input-subtitle,
    .structure-management .input-field .input-file {
      min-width: 200px;
      border-radius: 4px; }
    .admin-management .input-field .rank-type, .structure-management .input-field .rank-type {
      bottom: 5px; }
    .admin-management .input-field.divisionDescription, .structure-management .input-field.divisionDescription {
      display: flex;
      flex-direction: column;
      width: auto;
      align-items: flex-start;
      height: 150px; }
      .admin-management .input-field.divisionDescription .home-file, .structure-management .input-field.divisionDescription .home-file {
        margin-left: 0; }
    .admin-management .input-field.org-division-member-stats, .structure-management .input-field.org-division-member-stats {
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 12px;
      padding: 10px 12px;
      border: 1px solid #2a3847;
      border-radius: 6px;
      background: rgba(28, 45, 56, 0.35); }
      .admin-management .input-field.org-division-member-stats .home-file, .structure-management .input-field.org-division-member-stats .home-file {
        width: 100%;
        margin-left: 0;
        margin-bottom: 4px; }
      .admin-management .input-field.org-division-member-stats__count, .structure-management .input-field.org-division-member-stats__count {
        font-size: 1.25rem;
        font-weight: 600;
        color: #dfdfdf;
        margin-bottom: 8px; }
      .admin-management .input-field.org-division-member-stats__hint, .structure-management .input-field.org-division-member-stats__hint {
        font-size: 0.85rem;
        color: #b8b8b8;
        margin-bottom: 12px; }
      .admin-management .input-field.org-division-member-stats__warning, .structure-management .input-field.org-division-member-stats__warning {
        color: #d12323;
        font-size: 0.9rem;
        margin-bottom: 0; }
  .admin-management.allies, .structure-management.allies {
    display: flex; }

.allied-input {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column; }
  .allied-input.left {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    width: 100%; }
  .allied-input.right {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    width: 100%; }
    .allied-input.right .logo-wrapper.allies {
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start; }
    .allied-input.right .orglogo-section {
      flex-wrap: wrap;
      align-content: flex-start;
      flex-direction: column; }
      .allied-input.right .orglogo-section .add-logo {
        display: none; }
      .allied-input.right .orglogo-section .logo-icon-wrapper {
        flex-wrap: wrap;
        align-content: flex-start;
        flex-direction: row; }

.logo-section .logo-wrapper {
  margin-top: 0px;
  padding-right: 0px;
  margin-left: 50px; }

.logo-section .add-rank-image {
  display: none; }

.logo-section.ranks {
  margin-left: 50px;
  margin-right: 50px; }

.logo-section .add-section-logo {
  display: none; }

.rank-preview {
  position: relative;
  transform: translate(20px, 10px);
  max-width: 432px;
  min-width: 320px; }

.structure-management {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 35px;
  padding: 20px; }

.rank-management {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  margin-top: 35px;
  padding: 20px; }

.input.structure.elementName, .input.structure.elementDetails {
  width: 300px;
  height: 65px;
  margin-bottom: 10px;
  resize: none;
  border-radius: 4px; }

.input.structure.abreviation {
  width: 55px;
  text-transform: uppercase;
  bottom: 10px;
  border-radius: 4px; }

.input.structure.dropdown {
  width: 305px;
  height: 22px;
  border-radius: 4px; }

.input.structure.divisionDescription {
  display: flex;
  width: 100%;
  margin: 10px 0 10px 0;
  resize: none;
  border-radius: 4px; }
  .input.structure.divisionDescription::-webkit-scrollbar {
    width: 6px; }
  .input.structure.divisionDescription::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .input.structure.divisionDescription::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .input.structure.divisionDescription::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }

.input.structure .create-event {
  color: red; }

.input.ranks.paygrade {
  width: 50px;
  margin-bottom: 0px;
  resize: none;
  border-radius: 4px; }

.input.ranks.abreviation {
  width: 75px;
  margin-bottom: 0px;
  margin-left: 0px;
  resize: none;
  border-radius: 4px; }

.input.ranks.rankName {
  width: 250px;
  margin-bottom: 0px;
  resize: none;
  border-radius: 4px; }

.input.ranks.dropdown {
  width: 258px;
  margin-bottom: 10px;
  resize: none;
  border-radius: 4px; }

.input.allie {
  width: 250px;
  border-radius: 4px; }

.home-file.ranks.rankType {
  position: relative;
  font-size: 0.9rem;
  text-transform: uppercase;
  width: max-content;
  margin-left: 0px;
  bottom: 0px; }

.home-file.ranks.abreviation {
  position: relative;
  font-size: 1rem;
  width: 50px;
  margin-left: 28px;
  margin-right: -23px;
  bottom: 0px; }

.home-file.ranks.status {
  position: relative;
  font-size: 1rem;
  width: 50px;
  margin-left: 20px;
  bottom: 5px; }

.default-btn.allies {
  margin: 10px 0px 10px 20px; }

.default-btn.event-template {
  margin: 10px 10px 10px 20px; }

.default-btn .newmedia {
  position: relative;
  min-width: 120px;
  margin: 15px 0px 20px 18px;
  top: 0px; }
  .default-btn .newmedia .hometab-save:hover {
    background-color: #c6c6c6; }
  .default-btn .newmedia .cancel:hover {
    border: 1px solid #2a3847; }
  .default-btn .newmedia .delete:hover {
    border: 3px solid #d12323;
    background-color: #741919; }

.homepage-management {
  justify-content: start;
  border: 1px solid #9c99a3;
  padding: 0.5rem;
  border-radius: 4px;
  box-shadow: inset -2px -2px 3px rgba(70, 69, 69, 0.2); }
  .homepage-management .toggle .toggle-switch {
    position: relative;
    display: flex;
    background-color: #E0E0E0;
    align-items: center;
    justify-content: space-between;
    margin-left: 20px;
    padding: 0 5px;
    height: 25px;
    width: 140px; }
    .homepage-management .toggle .toggle-switch:before {
      content: '';
      position: absolute;
      width: 70px;
      height: 20px;
      bottom: 3px;
      border-radius: 10px;
      transition: transform 0.3s;
      box-shadow: 0px 0px 4px 3px rgba(0, 0, 0, 0.404); }
    .homepage-management .toggle .toggle-switch span {
      position: absolute;
      width: 70px;
      text-align: center;
      font-size: 0.65em;
      font-weight: 800;
      text-transform: uppercase;
      transition: opacity 0.2s, left 0.2s; }
      .homepage-management .toggle .toggle-switch span.text {
        opacity: 1;
        left: 2px; }
      .homepage-management .toggle .toggle-switch span.media {
        opacity: 0;
        left: 77px; }
    .homepage-management .toggle .toggle-switch.active span.text {
      opacity: 0; }
    .homepage-management .toggle .toggle-switch.active span.media {
      opacity: 1; }
  .homepage-management .toggle input:checked + .toggle-switch:before {
    transform: translateX(74px); }

.toggle-container {
  width: 100%; }

.lastEditBy {
  position: absolute;
  top: 30px;
  left: 20px; }

.allies-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center; }

.ally-item {
  position: relative;
  flex: 1 1 calc(50% - 20px);
  max-width: calc(50% - 20px);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  border: 1px solid #2a3847;
  border-radius: 8px;
  background-color: #1c2d38;
  box-sizing: border-box;
  height: 300px;
  overflow: hidden;
  transition: all 0.3s ease; }
  .ally-item::after {
    content: "";
    position: absolute;
    top: 5px;
    /* Adjust the top value to match your design */
    bottom: 5px;
    /* Adjust the bottom value to match your design */
    left: 5px;
    right: 5px;
    border-left: 3px solid #2a3847;
    border-right: 3px solid #2a3847;
    border-radius: 5px;
    /* Adjust the radius to match the inner corners */
    pointer-events: none;
    /* Ensure the pseudo-element does not interfere with interactions */
    z-index: 1;
    /* Ensure the pseudo-element is below the content */ }
  .ally-item .ally-content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 280px;
    padding: 0 20px;
    transition: transform 0.3s ease; }
    .ally-item .ally-content .ally-logo {
      margin-right: 10px;
      transition: width 0.3s ease; }
      .ally-item .ally-content .ally-logo img {
        width: 200px;
        height: auto;
        transition: width 0.3s ease; }
    .ally-item .ally-content .ally-details {
      text-align: left; }
      .ally-item .ally-content .ally-details h3 {
        margin: 0;
        font-size: 1.2em;
        transition: all 0.3s ease; }
  .ally-item .ally-description-icons {
    position: absolute;
    bottom: -100%;
    left: 0;
    right: 0;
    margin-left: 8px;
    margin-right: 8px;
    margin-bottom: 5px;
    height: 200px;
    background: #0c2637;
    padding: 10px 5px 10px 10px;
    transition: bottom 0.3s ease;
    border-top: none;
    border-bottom: 2px solid #2a3847;
    border-radius: 5px; }
    .ally-item .ally-description-icons .ally-description {
      position: relative;
      height: 160px;
      /* Adjust this value based on your design */
      overflow-y: auto;
      z-index: 2;
      padding-bottom: 5px; }
      .ally-item .ally-description-icons .ally-description::-webkit-scrollbar {
        width: 6px; }
      .ally-item .ally-description-icons .ally-description::-webkit-scrollbar-track {
        background: #2e3842;
        border-radius: 4px;
        padding-right: 1px; }
      .ally-item .ally-description-icons .ally-description::-webkit-scrollbar-thumb {
        background-color: #491212;
        border-radius: 4px; }
        .ally-item .ally-description-icons .ally-description::-webkit-scrollbar-thumb:hover {
          background-color: #200808; }
    .ally-item .ally-description-icons .ally-icons {
      display: flex;
      margin-left: 12px;
      gap: 30px;
      align-items: center;
      padding-top: 12px;
      cursor: pointer; }
      .ally-item .ally-description-icons .ally-icons .ally-icon {
        width: 50px;
        object-fit: cover;
        object-position: top; }
      .ally-item .ally-description-icons .ally-icons .rsi-icon {
        width: 39px;
        height: 16px; }
      .ally-item .ally-description-icons .ally-icons .discord-icon {
        width: 27px;
        height: 20px; }
      .ally-item .ally-description-icons .ally-icons .guilded-icon {
        width: 22px;
        height: 23px; }
      .ally-item .ally-description-icons .ally-icons .website-icon {
        width: 28px;
        height: 28px; }
  .ally-item:hover .ally-description-icons {
    bottom: 0; }
  .ally-item:hover .ally-content {
    align-items: flex-start;
    transform: translateY(10px); }
  .ally-item:hover .ally-content .ally-logo img {
    width: 50px; }
  .ally-item:hover .ally-details {
    display: flex;
    height: 50px;
    align-items: center;
    justify-content: center; }
  .ally-item .icon:hover {
    object-position: bottom; }

.calendar-debrief-default .content.calendar-debrief-default {
  padding: 0 18px; }

.calendar-debrief-default .footer.calendar-debrief-default {
  padding: 10px 20px; }

@media (max-width: 1023px) {
  .ally-item {
    flex: 1 1 100%;
    max-width: 100%; }
  .ally-description-icons .ally-icons {
    justify-content: flex-start;
    margin-left: 10px !important; }
  .ally-icons {
    display: flex;
    margin-left: 15px;
    gap: 20px;
    align-items: center;
    padding-top: 8px;
    cursor: pointer; }
    .ally-icons .ally-icon {
      width: 50px;
      object-fit: cover;
      object-position: top; }
    .ally-icons .rsi-icon {
      width: 47px !important;
      height: 20px !important; }
    .ally-icons .discord-icon {
      width: 30px;
      height: 20px; }
    .ally-icons .guilded-icon {
      width: 22px;
      height: 24px; }
    .ally-icons .website-icon {
      width: 30px;
      height: 30px; } }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.org-members-mgmt-general-dashboard {
  width: 100%;
  min-width: 0; }

.org-members-mgmt-general-dashboard__layout-root {
  width: 100%;
  max-width: 100%; }

.org-members-mgmt-general-dashboard__grid {
  width: 100%;
  min-width: 0;
  position: relative; }

.org-members-mgmt-general-dashboard__grid-layout {
  min-height: 12rem;
  width: 100%; }

.org-members-mgmt-general-dashboard__layout-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
  margin-bottom: 0.85rem; }

.org-members-mgmt-general-dashboard__layout-hint {
  flex: 1 1 auto;
  min-width: 0;
  max-width: max-content;
  box-sizing: border-box;
  padding: 0.65rem 0.85rem;
  border: 1px solid rgba(90, 195, 255, 0.28);
  border-radius: 8px;
  background: rgba(12, 38, 55, 0.45); }

.org-members-mgmt-general-dashboard__layout-hint-text {
  margin: 0;
  font-size: 0.8rem;
  line-height: 1.45;
  color: rgba(223, 223, 223, 0.82); }

.org-members-mgmt-general-dashboard__layout-reset-btn {
  flex: 0 0 auto;
  margin: 0;
  padding: 0.55rem 0.9rem;
  border: 1px solid rgba(90, 195, 255, 0.45);
  border-radius: 8px;
  background: rgba(23, 39, 56, 0.55);
  color: #dfdfdf;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer; }

.org-members-mgmt-general-dashboard__layout-reset-btn:hover {
  border-color: rgba(90, 195, 255, 0.65);
  background: rgba(30, 48, 66, 0.72); }

.org-members-mgmt-general-dashboard__grid-item {
  box-sizing: border-box; }

.org-members-mgmt-general-dashboard__grid-item-body {
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden; }
  .org-members-mgmt-general-dashboard__grid-item-body > .member-dashboard__hero,
  .org-members-mgmt-general-dashboard__grid-item-body > .member-dashboard__panel-card,
  .org-members-mgmt-general-dashboard__grid-item-body > .org-members-mgmt-general-dashboard__card {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    box-sizing: border-box;
    overflow: hidden; }

.org-members-mgmt-general-dashboard__grid .react-grid-item {
  z-index: 0;
  transition: box-shadow 0.2s ease; }
  .org-members-mgmt-general-dashboard__grid .react-grid-item.react-draggable-dragging {
    z-index: 10; }
  .org-members-mgmt-general-dashboard__grid .react-grid-item.resizing {
    z-index: 10; }

.org-members-mgmt-general-dashboard__grid .react-grid-placeholder {
  background: rgba(58, 120, 180, 0.18) !important;
  border: 1px dashed rgba(58, 120, 180, 0.55) !important;
  border-radius: 12px !important;
  opacity: 0.85 !important; }

.org-members-mgmt-general-dashboard__grid .react-grid-item > .react-resizable-handle {
  z-index: 5;
  opacity: 0.45;
  transition: opacity 0.2s ease; }
  .org-members-mgmt-general-dashboard__grid .react-grid-item > .react-resizable-handle::after {
    border-right: 2px solid rgba(58, 120, 180, 0.85) !important;
    border-bottom: 2px solid rgba(58, 120, 180, 0.85) !important; }

.org-members-mgmt-general-dashboard__grid .react-grid-item:hover > .react-resizable-handle,
.org-members-mgmt-general-dashboard__grid .react-grid-item.resizing > .react-resizable-handle {
  opacity: 1; }

.org-members-mgmt-general-dashboard__grid-item {
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: 100%; }

.org-members-mgmt-general-dashboard__grid-item-body {
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  height: 100%; }

.org-members-mgmt-general-dashboard__card {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  box-sizing: border-box;
  border-radius: 10px;
  border: 1px solid rgba(90, 195, 255, 0.22);
  background: linear-gradient(160deg, rgba(30, 48, 66, 0.95) 0%, rgba(23, 39, 56, 0.9) 100%);
  box-shadow: 0 6px 20px rgba(21, 28, 36, 0.28);
  overflow: hidden; }

.org-members-mgmt-general-dashboard__card-head {
  flex: 0 0 auto;
  padding: 0.75rem 1rem 0.5rem;
  border-bottom: 1px solid rgba(116, 123, 129, 0.22); }

.org-members-mgmt-general-dashboard__card-title {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  color: #dfdfdf; }

.org-members-mgmt-general-dashboard__card-body {
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
  padding: 0.85rem 1rem 1rem;
  overflow-x: hidden;
  overflow-y: auto;
  margin-right: -10px;
  padding-right: 10px;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.35) rgba(0, 0, 0, 0.12); }
  .org-members-mgmt-general-dashboard__card-body::-webkit-scrollbar {
    width: 6px; }
  .org-members-mgmt-general-dashboard__card-body::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.12);
    border-radius: 999px; }
  .org-members-mgmt-general-dashboard__card-body::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.3);
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.08); }
  .org-members-mgmt-general-dashboard__card-body::-webkit-scrollbar-thumb:hover {
    background: rgba(58, 120, 180, 0.42); }

.org-members-mgmt-general-dashboard__placeholder {
  margin: 0;
  font-size: 0.82rem;
  color: rgba(184, 184, 184, 0.95); }

.org-members-mgmt-general-dashboard__membership-recap {
  margin: 0.85rem 0 0;
  font-size: 0.82rem;
  color: rgba(223, 223, 223, 0.92); }

.org-members-mgmt-general-dashboard__membership-recap-label {
  display: block;
  margin-bottom: 0.25rem;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #5ac3ff; }

.org-members-mgmt-general-dashboard__state {
  margin: 0.85rem 0 0;
  font-size: 0.82rem;
  color: rgba(184, 184, 184, 0.95); }

.org-members-mgmt-general-dashboard__state--error {
  color: #c78445; }

.org-members-mgmt-general-dashboard .member-dashboard__hero,
.org-members-mgmt-general-dashboard .member-dashboard__panel-card {
  height: 100%;
  min-height: 0;
  box-sizing: border-box; }

.org-members-mgmt-general-dashboard .member-dashboard__panel-card-body {
  overflow: auto;
  margin-right: -10px;
  padding-right: 10px;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.35) rgba(0, 0, 0, 0.12); }
  .org-members-mgmt-general-dashboard .member-dashboard__panel-card-body::-webkit-scrollbar {
    width: 6px; }
  .org-members-mgmt-general-dashboard .member-dashboard__panel-card-body::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.12);
    border-radius: 999px; }
  .org-members-mgmt-general-dashboard .member-dashboard__panel-card-body::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.3);
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.08); }
  .org-members-mgmt-general-dashboard .member-dashboard__panel-card-body::-webkit-scrollbar-thumb:hover {
    background: rgba(58, 120, 180, 0.42); }

.org-members-mgmt-general-dashboard__assignment-card .org-members-mgmt-general-dashboard__card-body {
  box-sizing: border-box;
  max-width: 100%;
  min-width: 0;
  overflow-x: hidden;
  margin-right: 0;
  padding-right: 1rem; }
  .org-members-mgmt-general-dashboard__assignment-card .org-members-mgmt-general-dashboard__card-body .org-members-mgmt-general-dashboard__assignment-structure {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    overflow: hidden; }
  .org-members-mgmt-general-dashboard__assignment-card .org-members-mgmt-general-dashboard__card-body .org-members-mgmt-general-dashboard__structure-strip {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
    overflow: hidden; }
    .org-members-mgmt-general-dashboard__assignment-card .org-members-mgmt-general-dashboard__card-body .org-members-mgmt-general-dashboard__structure-strip .members-onboarding-ending-structure__strip {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
      align-items: stretch;
      width: 100%;
      max-width: 100%;
      min-width: 0;
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      gap: 1rem; }
    .org-members-mgmt-general-dashboard__assignment-card .org-members-mgmt-general-dashboard__card-body .org-members-mgmt-general-dashboard__structure-strip .members-onboarding-ending-structure__card-item {
      display: flex;
      width: 100%;
      min-width: 0;
      max-width: 100%;
      min-height: 9.25rem;
      align-items: stretch;
      justify-content: flex-start; }
    .org-members-mgmt-general-dashboard__assignment-card .org-members-mgmt-general-dashboard__card-body .org-members-mgmt-general-dashboard__structure-strip .members-onboarding-ending-structure__cardSurface {
      box-sizing: border-box;
      flex: 1 1 auto;
      width: 100%;
      max-width: 100%;
      min-width: 0;
      min-height: 9.25rem;
      margin-left: 0;
      margin-right: 0;
      padding: 0.5rem 0.4rem 0.55rem;
      border-radius: 8px; }
    .org-members-mgmt-general-dashboard__assignment-card .org-members-mgmt-general-dashboard__card-body .org-members-mgmt-general-dashboard__structure-strip .members-onboarding-ending-structure__cardHeader--recap.members-onboarding-structure__card-header {
      gap: 0.28rem;
      align-items: center; }
    .org-members-mgmt-general-dashboard__assignment-card .org-members-mgmt-general-dashboard__card-body .org-members-mgmt-general-dashboard__structure-strip .members-onboarding-ending-structure__cardHeader--recap .members-onboarding-structure__card-logo {
      width: 4.35rem;
      height: 4.75rem;
      max-width: 100%; }
    .org-members-mgmt-general-dashboard__assignment-card .org-members-mgmt-general-dashboard__card-body .org-members-mgmt-general-dashboard__structure-strip .members-onboarding-ending-structure__cardHeader--recap .members-onboarding-structure__card-headings {
      gap: 0.08rem;
      width: 100%;
      min-width: 0; }
    .org-members-mgmt-general-dashboard__assignment-card .org-members-mgmt-general-dashboard__card-body .org-members-mgmt-general-dashboard__structure-strip .members-onboarding-ending-structure__cardHeader--recap .members-onboarding-structure__breadcrumb-eyebrow {
      font-size: 0.6rem; }
    .org-members-mgmt-general-dashboard__assignment-card .org-members-mgmt-general-dashboard__card-body .org-members-mgmt-general-dashboard__structure-strip .members-onboarding-ending-structure__cardHeader--recap .members-onboarding-structure__card-title {
      overflow: hidden;
      font-size: 0.76rem;
      font-weight: 800;
      -webkit-line-clamp: 3;
      line-clamp: 3; }
    .org-members-mgmt-general-dashboard__assignment-card .org-members-mgmt-general-dashboard__card-body .org-members-mgmt-general-dashboard__structure-strip .members-onboarding-ending-structure__cardHeader--recap .members-onboarding-structure__card-subtitle {
      font-size: 0.66rem;
      font-weight: 700; }

.org-members-mgmt-general-dashboard__assignment-card .org-members-mgmt-general-dashboard__interest-tags {
  margin-top: 1rem;
  padding-top: 0.85rem;
  border-top: 1px solid rgba(90, 195, 255, 0.22); }

.org-members-mgmt-general-dashboard__assignment-card .org-members-mgmt-general-dashboard__interest-tags-title {
  margin: 0 0 0.65rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.88); }

.org-members-mgmt-general-dashboard__assignment-card .org-members-mgmt-general-dashboard__interest-tags-error {
  margin: 0 0 0.5rem;
  font-size: 0.82rem;
  color: #c78445; }

.org-members-mgmt-general-dashboard__assignment-card .org-members-mgmt-general-dashboard__interest-tags-list {
  display: flex;
  flex-flow: row wrap;
  gap: 0.45rem;
  margin: 0;
  padding: 0;
  list-style: none; }

.org-members-mgmt-general-dashboard__assignment-card .org-members-mgmt-general-dashboard__interest-tags-item {
  list-style: none;
  margin: 0; }

.org-members-mgmt-general-dashboard__assignment-card .org-members-mgmt-general-dashboard__interest-tag {
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  min-height: 1.65rem;
  padding: 0.22rem 0.62rem;
  border-radius: 999px;
  border: 1px solid #3a78b4;
  background: rgba(19, 59, 83, 0.95);
  font-size: 0.74rem;
  line-height: 1.25;
  color: rgba(255, 255, 255, 0.96); }

.org-members-mgmt-general-dashboard__ribbons-card .member-dashboard__panel-card-body {
  overflow: auto;
  margin-right: -10px;
  padding-right: 10px;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.35) rgba(0, 0, 0, 0.12); }
  .org-members-mgmt-general-dashboard__ribbons-card .member-dashboard__panel-card-body::-webkit-scrollbar {
    width: 6px; }
  .org-members-mgmt-general-dashboard__ribbons-card .member-dashboard__panel-card-body::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.12);
    border-radius: 999px; }
  .org-members-mgmt-general-dashboard__ribbons-card .member-dashboard__panel-card-body::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.3);
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.08); }
  .org-members-mgmt-general-dashboard__ribbons-card .member-dashboard__panel-card-body::-webkit-scrollbar-thumb:hover {
    background: rgba(58, 120, 180, 0.42); }

.org-members-mgmt-general-dashboard__ribbons-card .member-dashboard__ribbons-toolbar,
.org-members-mgmt-general-dashboard__ribbons-card .member-dashboard__ribbons-grid {
  min-width: 0; }

@media (max-width: 900px) {
  .org-members-mgmt-general-dashboard__grid-layout {
    height: auto !important; }
  .org-members-mgmt-general-dashboard__grid-item {
    position: relative !important;
    transform: none !important;
    width: 100% !important;
    margin-bottom: 0.75rem; } }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.org-members-mgmt-player-activity-dashboard {
  width: 100%;
  min-width: 0; }

.org-members-mgmt-player-activity-dashboard__layout-root {
  width: 100%;
  max-width: 100%; }

.org-members-mgmt-player-activity-dashboard__grid {
  width: 100%;
  min-width: 0;
  position: relative; }

.org-members-mgmt-player-activity-dashboard__grid-layout {
  min-height: 12rem;
  width: 100%; }

.org-members-mgmt-player-activity-dashboard__layout-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
  margin-bottom: 0.85rem; }

.org-members-mgmt-player-activity-dashboard__layout-hint {
  flex: 1 1 auto;
  min-width: 0;
  max-width: max-content;
  box-sizing: border-box;
  padding: 0.65rem 0.85rem;
  border: 1px solid rgba(90, 195, 255, 0.28);
  border-radius: 8px;
  background: rgba(12, 38, 55, 0.45); }

.org-members-mgmt-player-activity-dashboard__layout-hint-text {
  margin: 0;
  font-size: 0.8rem;
  line-height: 1.45;
  color: rgba(223, 223, 223, 0.82); }

.org-members-mgmt-player-activity-dashboard__layout-reset-btn {
  flex: 0 0 auto;
  margin: 0;
  padding: 0.55rem 0.9rem;
  border: 1px solid rgba(90, 195, 255, 0.45);
  border-radius: 8px;
  background: rgba(23, 39, 56, 0.55);
  color: #dfdfdf;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer; }

.org-members-mgmt-player-activity-dashboard__layout-reset-btn:hover {
  border-color: rgba(90, 195, 255, 0.65);
  background: rgba(30, 48, 66, 0.72); }

.org-members-mgmt-player-activity-dashboard__grid-item {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-width: 0;
  height: 100%; }

.org-members-mgmt-player-activity-dashboard__grid-item-body {
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  min-height: 0;
  min-width: 0;
  overflow: hidden; }
  .org-members-mgmt-player-activity-dashboard__grid-item-body > .member-dashboard__panel-card {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    box-sizing: border-box;
    overflow: hidden; }

.org-members-mgmt-player-activity-dashboard__grid .react-grid-item {
  z-index: 0;
  transition: box-shadow 0.2s ease; }
  .org-members-mgmt-player-activity-dashboard__grid .react-grid-item.react-draggable-dragging {
    z-index: 10; }
  .org-members-mgmt-player-activity-dashboard__grid .react-grid-item.resizing {
    z-index: 10; }

.org-members-mgmt-player-activity-dashboard__grid .react-grid-placeholder {
  background: rgba(58, 120, 180, 0.18) !important;
  border: 1px dashed rgba(58, 120, 180, 0.55) !important;
  border-radius: 12px !important;
  opacity: 0.85 !important; }

.org-members-mgmt-player-activity-dashboard__grid .react-grid-item > .react-resizable-handle {
  z-index: 5;
  opacity: 0.45;
  transition: opacity 0.2s ease; }
  .org-members-mgmt-player-activity-dashboard__grid .react-grid-item > .react-resizable-handle::after {
    border-right: 2px solid rgba(58, 120, 180, 0.85) !important;
    border-bottom: 2px solid rgba(58, 120, 180, 0.85) !important; }

.org-members-mgmt-player-activity-dashboard__grid .react-grid-item:hover > .react-resizable-handle,
.org-members-mgmt-player-activity-dashboard__grid .react-grid-item.resizing > .react-resizable-handle {
  opacity: 1; }

.org-members-mgmt-player-activity-dashboard__state {
  margin: 0.85rem 0 0;
  font-size: 0.82rem;
  color: rgba(184, 184, 184, 0.95); }

.org-members-mgmt-player-activity-dashboard__state--error {
  color: #c78445; }

.org-members-mgmt-player-activity-dashboard .member-dashboard__panel-card {
  height: 100%;
  min-height: 0;
  box-sizing: border-box; }

.org-members-mgmt-player-activity-dashboard .member-dashboard__panel-card-body {
  overflow: auto;
  margin-right: -10px;
  padding-right: 10px;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.35) rgba(0, 0, 0, 0.12); }
  .org-members-mgmt-player-activity-dashboard .member-dashboard__panel-card-body::-webkit-scrollbar {
    width: 6px; }
  .org-members-mgmt-player-activity-dashboard .member-dashboard__panel-card-body::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.12);
    border-radius: 999px; }
  .org-members-mgmt-player-activity-dashboard .member-dashboard__panel-card-body::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.3);
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.08); }
  .org-members-mgmt-player-activity-dashboard .member-dashboard__panel-card-body::-webkit-scrollbar-thumb:hover {
    background: rgba(58, 120, 180, 0.42); }

@media (max-width: 900px) {
  .org-members-mgmt-player-activity-dashboard__grid-layout {
    height: auto !important; }
  .org-members-mgmt-player-activity-dashboard__grid-item {
    position: relative !important;
    transform: none !important;
    width: 100% !important;
    margin-bottom: 0.75rem; } }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.org-members-mgmt-player-hangar {
  width: 100%;
  min-width: 0; }

.org-members-mgmt-player-hangar__header {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin-bottom: 1rem; }

.org-members-mgmt-player-hangar__header-lines {
  display: flex;
  flex-direction: column;
  gap: 0.2rem; }
  .org-members-mgmt-player-hangar__header-lines span {
    display: block;
    height: 2px;
    border-radius: 999px;
    background: rgba(58, 120, 180, 0.55); }
    .org-members-mgmt-player-hangar__header-lines span:first-child {
      width: 2.5rem; }
    .org-members-mgmt-player-hangar__header-lines span:last-child {
      width: 4.5rem;
      opacity: 0.55; }

.org-members-mgmt-player-hangar__title {
  margin: 0;
  font-size: 1.05rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #dfdfdf; }

.org-members-mgmt-player-hangar__subtitle {
  margin: 0;
  font-size: 0.84rem;
  color: rgba(184, 184, 184, 0.95); }
  .org-members-mgmt-player-hangar__subtitle strong {
    color: #dfdfdf;
    font-weight: 600; }

.org-members-mgmt-player-hangar__state {
  margin: 0.75rem 0 0;
  font-size: 0.82rem;
  color: rgba(184, 184, 184, 0.95); }

.org-members-mgmt-player-hangar__state--error {
  color: #c78445; }

.org-members-mgmt-player-hangar__handle-switch {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.85rem; }

.org-members-mgmt-player-hangar__handle-btn {
  margin: 0;
  padding: 0.45rem 0.75rem;
  border: 1px solid rgba(90, 195, 255, 0.35);
  border-radius: 999px;
  background: rgba(23, 39, 56, 0.55);
  color: #dfdfdf;
  font-size: 0.78rem;
  cursor: pointer; }

.org-members-mgmt-player-hangar__handle-btn--active {
  border-color: rgba(58, 120, 180, 0.75);
  background: rgba(30, 48, 66, 0.85); }

.org-members-mgmt-player-hangar__toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem; }

.org-members-mgmt-player-hangar__search {
  min-width: 14rem;
  flex: 1 1 14rem;
  max-width: 22rem;
  padding: 0.45rem 0.65rem;
  border: 1px solid rgba(90, 195, 255, 0.35);
  border-radius: 8px;
  background: rgba(12, 38, 55, 0.45);
  color: #dfdfdf;
  font-size: 0.82rem; }

.org-members-mgmt-player-hangar__filter-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem; }

.org-members-mgmt-player-hangar__filter-pill {
  margin: 0;
  padding: 0.4rem 0.7rem;
  border: 1px solid rgba(90, 195, 255, 0.35);
  border-radius: 999px;
  background: rgba(12, 38, 55, 0.35);
  color: rgba(184, 184, 184, 0.9);
  font-size: 0.76rem;
  cursor: pointer; }

.org-members-mgmt-player-hangar__filter-pill--active {
  border-color: rgba(58, 120, 180, 0.7);
  background: rgba(30, 48, 66, 0.72);
  color: #dfdfdf; }

.org-members-mgmt-player-hangar__empty-card {
  padding: 1rem 1.1rem;
  border: 1px solid rgba(90, 195, 255, 0.28);
  border-radius: 10px;
  background: rgba(12, 38, 55, 0.35); }

.org-members-mgmt-player-hangar__empty-title {
  margin: 0 0 0.35rem;
  font-size: 0.92rem;
  color: #dfdfdf; }

.org-members-mgmt-player-hangar__empty-text {
  margin: 0;
  font-size: 0.82rem;
  color: rgba(184, 184, 184, 0.92); }

.org-members-mgmt-player-hangar__sections {
  display: flex;
  flex-direction: column;
  gap: 1.1rem; }

.org-members-mgmt-player-hangar__section {
  min-width: 0; }

.org-members-mgmt-player-hangar__section--package {
  padding: 0.85rem;
  border: 1px solid rgba(90, 195, 255, 0.22);
  border-radius: 10px;
  background: rgba(23, 39, 56, 0.35); }

.org-members-mgmt-player-hangar__section-title {
  margin: 0 0 0.65rem;
  font-size: 0.88rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.92); }

.org-members-mgmt-player-hangar__empty-section {
  margin: 0;
  font-size: 0.8rem;
  color: rgba(184, 184, 184, 0.88); }

.org-members-mgmt-player-hangar__table-wrap {
  width: 100%;
  overflow-x: auto; }

.org-members-mgmt-player-hangar__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.82rem; }

.org-members-mgmt-player-hangar__table-caption {
  caption-side: top;
  text-align: left;
  padding-bottom: 0.45rem;
  color: rgba(184, 184, 184, 0.9); }

.org-members-mgmt-player-hangar__table th,
.org-members-mgmt-player-hangar__table td {
  padding: 0.55rem 0.65rem;
  border-bottom: 1px solid rgba(90, 195, 255, 0.18);
  text-align: left;
  vertical-align: middle; }

.org-members-mgmt-player-hangar__table th {
  font-size: 0.74rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: rgba(184, 184, 184, 0.88);
  background: rgba(12, 38, 55, 0.35); }

.org-members-mgmt-player-hangar__table tbody tr:hover {
  background: rgba(30, 48, 66, 0.18); }

.org-members-mgmt-player-hangar__prod-state {
  display: inline-block;
  padding: 0.15rem 0.45rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  background: rgba(184, 184, 184, 0.15);
  color: #dfdfdf; }

.org-members-mgmt-player-hangar__prod-state--flight-ready {
  background: rgba(90, 160, 92, 0.22);
  color: #75cf78; }

.org-members-mgmt-player-hangar__prod-state--in-concept {
  background: rgba(199, 132, 69, 0.18);
  color: #c78445; }

.org-members-mgmt-player-hangar__prod-state--in-production {
  background: rgba(58, 120, 180, 0.2);
  color: #5ac3ff; }

.org-members-mgmt-player-hangar__prod-state--unknown {
  color: rgba(184, 184, 184, 0.85); }

.org-members-mgmt {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  width: 100%;
  min-width: 0; }

.org-members-mgmt__selection {
  padding: 1rem 1.15rem;
  border-radius: 10px;
  border: 1px solid rgba(90, 195, 255, 0.22);
  background: linear-gradient(145deg, rgba(30, 48, 66, 0.92) 0%, rgba(23, 39, 56, 0.88) 100%);
  box-shadow: 0 8px 24px rgba(21, 28, 36, 0.35); }

.org-members-mgmt__selection-head {
  margin-bottom: 0.85rem; }

.org-members-mgmt__selection-title {
  margin: 0 0 0.35rem;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #dfdfdf; }

.org-members-mgmt__selection-hint {
  margin: 0;
  font-size: 0.82rem;
  line-height: 1.45;
  color: rgba(223, 223, 223, 0.78); }

.org-members-mgmt__select-label {
  display: block;
  margin-bottom: 0.4rem;
  font-size: 0.78rem;
  font-weight: 600;
  color: #b8b8b8; }

.org-members-mgmt__select-wrap {
  max-width: 32rem; }
  .org-members-mgmt__select-wrap .org-members-mgmt__select {
    width: 100%; }
  .org-members-mgmt__select-wrap .react-select-input__control {
    min-height: 38px !important;
    height: auto !important;
    border-color: rgba(90, 195, 255, 0.35) !important;
    background-color: rgba(12, 38, 55, 0.65) !important;
    color: #dfdfdf; }
  .org-members-mgmt__select-wrap .react-select-input__single-value,
  .org-members-mgmt__select-wrap .react-select-input__input-container {
    color: #dfdfdf !important; }
  .org-members-mgmt__select-wrap .react-select-input__placeholder {
    color: rgba(184, 184, 184, 0.9) !important; }

.org-members-mgmt__selected-card {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.35rem 0.75rem;
  margin-top: 0.9rem;
  padding: 0.65rem 0.85rem;
  border-radius: 8px;
  border: 1px solid rgba(117, 207, 120, 0.28);
  background: rgba(42, 95, 45, 0.22); }

.org-members-mgmt__selected-label {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #75cf78; }

.org-members-mgmt__selected-handle {
  font-size: 0.95rem;
  font-weight: 700;
  color: #c2f0c3; }

.org-members-mgmt__selected-moniker {
  font-size: 0.85rem;
  color: rgba(223, 223, 223, 0.88); }

.org-members-mgmt__selected-meta {
  width: 100%;
  font-size: 0.72rem;
  color: rgba(184, 184, 184, 0.95); }

.org-members-mgmt__msg--error {
  color: #c78445;
  font-size: 0.82rem; }

.org-members-mgmt__workspace {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  min-height: 12rem; }

.org-members-mgmt__workspace--locked {
  opacity: 0.92; }

.org-members-mgmt__workspace-title {
  margin: 0;
  font-size: 0.88rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #b8b8b8; }

.org-members-mgmt__workspace-hint {
  margin: 0;
  padding: 0.65rem 0.85rem;
  border-radius: 8px;
  border: 1px dashed rgba(116, 123, 129, 0.45);
  background: rgba(12, 38, 55, 0.35);
  font-size: 0.82rem;
  color: rgba(223, 223, 223, 0.75); }

.org-members-mgmt__subtabs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  padding-bottom: 0.35rem;
  border-bottom: 1px solid rgba(116, 123, 129, 0.35); }

.org-members-mgmt__subtab-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  margin: 0;
  padding: 0.45rem 0.85rem;
  border: 1px solid transparent;
  border-radius: 8px 8px 0 0;
  background: rgba(12, 38, 55, 0.55);
  color: rgba(223, 223, 223, 0.72);
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease; }

.org-members-mgmt__subtab-btn:hover:not(:disabled) {
  background: rgba(42, 56, 71, 0.85);
  color: #dfdfdf; }

.org-members-mgmt__subtab-btn--active {
  border-color: rgba(90, 195, 255, 0.4);
  border-bottom-color: transparent;
  background: #2a3847;
  color: #dfdfdf; }

.org-members-mgmt__subtab-btn--locked,
.org-members-mgmt__subtab-btn:disabled {
  cursor: not-allowed;
  opacity: 0.55;
  color: rgba(184, 184, 184, 0.65); }

.org-members-mgmt__subtab-lock {
  display: inline-flex;
  opacity: 0.85; }

.org-members-mgmt__subtab-content {
  flex: 1;
  min-height: 8rem;
  padding: 1rem 1.1rem;
  border-radius: 0 8px 8px 8px;
  background: rgba(42, 56, 71, 0.55);
  border: 1px solid rgba(116, 123, 129, 0.25); }

.org-members-mgmt__workspace--locked .org-members-mgmt__subtab-content {
  min-height: 4rem;
  background: rgba(12, 38, 55, 0.25); }

.org-members-mgmt__subtab-panel {
  min-width: 0; }

.org-members-mgmt__subtab-lead {
  margin: 0 0 0.75rem;
  font-size: 0.88rem;
  line-height: 1.5;
  color: rgba(223, 223, 223, 0.92); }
  .org-members-mgmt__subtab-lead strong {
    color: #5ac3ff;
    font-weight: 700; }

.org-members-mgmt__placeholder {
  margin: 0;
  font-size: 0.82rem;
  color: rgba(184, 184, 184, 0.9); }

.org-requests {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 0; }

.org-requests__intro {
  margin: 0 0 0.75rem;
  font-size: 0.85rem;
  line-height: 1.45;
  color: rgba(223, 223, 223, 0.85); }

.org-requests__filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem; }

.org-requests__toolbar-row {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 0.85rem;
  flex-wrap: wrap; }

.org-requests__course-select-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.35rem;
  margin-left: auto;
  min-width: 14rem; }

.org-requests__course-select-head {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.55rem;
  width: 100%; }

.org-requests__course-label {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.62); }

.org-requests__course-lock {
  margin: 0;
  padding: 0.2rem 0.55rem;
  border: 1px solid rgba(116, 123, 129, 0.45);
  border-radius: 999px;
  background: rgba(12, 38, 55, 0.55);
  color: rgba(223, 223, 223, 0.78);
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer; }
  .org-requests__course-lock--locked {
    border-color: rgba(199, 132, 69, 0.55);
    background: rgba(199, 132, 69, 0.18);
    color: #d8b493; }
  .org-requests__course-lock:not(.org-requests__course-lock--locked) {
    border-color: rgba(117, 207, 120, 0.45);
    background: rgba(117, 207, 120, 0.14);
    color: #c2f0c3; }

.org-requests__course-select {
  min-width: 16rem;
  max-width: 22rem;
  padding: 0.45rem 0.7rem;
  border: 1px solid rgba(58, 120, 180, 0.45);
  border-radius: 8px;
  background: rgba(28, 45, 56, 0.75);
  color: #dfdfdf;
  font-size: 0.82rem; }
  .org-requests__course-select:disabled {
    opacity: 0.55;
    cursor: not-allowed; }

.org-requests__filter {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0;
  padding: 0.4rem 0.75rem;
  border: 1px solid rgba(116, 123, 129, 0.45);
  border-radius: 999px;
  background: rgba(12, 38, 55, 0.5);
  color: rgba(223, 223, 223, 0.8);
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer; }

.org-requests__filter--active {
  border-color: rgba(90, 195, 255, 0.55);
  background: rgba(58, 120, 180, 0.35);
  color: #dfdfdf; }

.org-requests__filter-count {
  min-width: 1.25rem;
  padding: 0.05rem 0.35rem;
  border-radius: 999px;
  background: rgba(90, 195, 255, 0.25);
  font-size: 0.7rem;
  text-align: center; }

.org-requests__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem; }

.org-requests__list-item {
  margin: 0;
  padding: 0; }

.org-requests__card {
  padding: 1rem 1.15rem;
  border-radius: 10px;
  border: 1px solid rgba(116, 123, 129, 0.35);
  background: linear-gradient(160deg, rgba(30, 48, 66, 0.95) 0%, rgba(23, 39, 56, 0.9) 100%);
  box-shadow: 0 6px 20px rgba(21, 28, 36, 0.3); }

.org-requests__card--pending {
  border-color: rgba(90, 195, 255, 0.45); }

.org-requests__card--collapsed .org-requests__card-body {
  display: none; }

.org-requests__card-head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 0.5rem; }

.org-requests__card--collapsed .org-requests__card-head {
  margin-bottom: 0; }

.org-requests__card-head--collapsible {
  cursor: pointer;
  user-select: none; }

.org-requests__card-head--collapsible:hover .org-requests__card-handle {
  color: #75cf78; }

.org-requests__card-chevron {
  flex: 0 0 auto;
  margin-left: auto;
  font-size: 0.85rem;
  color: rgba(184, 184, 184, 0.9);
  line-height: 1.4; }

.org-requests__card-handle {
  font-size: 1rem;
  font-weight: 700;
  color: #c2f0c3; }

.org-requests__card-moniker {
  display: block;
  font-size: 0.82rem;
  color: rgba(223, 223, 223, 0.8); }

.org-requests__status {
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em; }

.org-requests__status--pending {
  background: rgba(90, 195, 255, 0.22);
  color: #5ac3ff; }

.org-requests__status--approved {
  background: rgba(117, 207, 120, 0.2);
  color: #75cf78; }

.org-requests__status--dismissed {
  background: rgba(199, 132, 69, 0.2);
  color: #c78445; }

.org-requests__meta {
  margin: 0 0 0.35rem;
  font-size: 0.78rem;
  color: rgba(184, 184, 184, 0.95); }

.org-requests__resolve-note {
  margin: 0.5rem 0 0;
  padding: 0.55rem 0.7rem;
  border-radius: 6px;
  background: rgba(12, 38, 55, 0.4);
  font-size: 0.82rem;
  color: rgba(223, 223, 223, 0.9); }

.org-requests__resolve-note--approved {
  border-left: 3px solid #75cf78; }

.org-requests__resolve-note--dismissed {
  border-left: 3px solid #c78445; }

.org-requests__resolve-note-label {
  display: block;
  margin-bottom: 0.25rem;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase; }

.org-requests__resolve-note--approved .org-requests__resolve-note-label {
  color: #75cf78; }

.org-requests__resolve-note--dismissed .org-requests__resolve-note-label {
  color: #c78445; }

.org-requests__member-note {
  margin: 0.5rem 0 0;
  padding: 0.55rem 0.7rem;
  border-radius: 6px;
  border-left: 3px solid #5ac3ff;
  background: rgba(12, 38, 55, 0.4);
  font-size: 0.82rem;
  color: rgba(223, 223, 223, 0.9); }

.org-requests__member-note-label {
  display: block;
  margin-bottom: 0.25rem;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #5ac3ff; }

.org-requests__assignment-badge {
  flex: 0 0 auto;
  padding: 0.2rem 0.5rem;
  border-radius: 999px;
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: rgba(199, 132, 69, 0.2);
  color: #c78445; }

.org-requests__assignment-warning {
  margin: 0.5rem 0 0;
  padding: 0.55rem 0.7rem;
  border-radius: 6px;
  border-left: 3px solid #c78445;
  background: rgba(12, 38, 55, 0.45); }

.org-requests__assignment-warning-text {
  margin: 0 0 0.5rem;
  font-size: 0.8rem;
  color: rgba(223, 223, 223, 0.95); }

.org-requests__assignment-current-label {
  display: block;
  margin-bottom: 0.35rem;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #c78445; }

.org-requests__assignment-current-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.45rem; }

.org-requests__assignment-current-item {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem 0.65rem;
  align-items: baseline;
  font-size: 0.82rem;
  color: rgba(223, 223, 223, 0.92); }

.org-requests__assignment-current-name {
  font-weight: 700;
  color: #c2f0c3; }

.org-requests__assignment-current-division {
  color: rgba(184, 184, 184, 0.95); }

.org-requests__assignment-current-role {
  font-size: 0.75rem;
  color: rgba(90, 195, 255, 0.95); }

.org-requests__assignment-current-period {
  font-size: 0.72rem;
  color: rgba(184, 184, 184, 0.85); }

.org-requests__compare {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 0.75rem;
  align-items: start;
  margin-top: 0.85rem; }

@media (max-width: 720px) {
  .org-requests__compare {
    grid-template-columns: 1fr; }
  .org-requests__arrow {
    text-align: center;
    transform: rotate(90deg); } }

.org-requests__arrow {
  padding-top: 1.5rem;
  font-size: 1.25rem;
  color: #5ac3ff; }

.org-requests__structure-block {
  min-width: 0;
  padding: 0.65rem 0.75rem;
  border-radius: 8px;
  background: rgba(12, 38, 55, 0.35);
  border: 1px solid rgba(116, 123, 129, 0.25); }

.org-requests__structure-title {
  margin: 0 0 0.45rem;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #b8b8b8; }

.org-requests__structure-levels {
  list-style: none;
  margin: 0 0 0.5rem;
  padding: 0; }

.org-requests__level {
  display: flex;
  gap: 0.35rem;
  font-size: 0.8rem;
  line-height: 1.4; }

.org-requests__level-key {
  flex-shrink: 0;
  color: rgba(184, 184, 184, 0.9);
  min-width: 4.5rem; }

.org-requests__level-val {
  color: #dfdfdf;
  font-weight: 600; }

.org-requests__tags {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem; }

.org-requests__tag {
  padding: 0.15rem 0.45rem;
  border-radius: 4px;
  background: rgba(58, 120, 180, 0.35);
  font-size: 0.72rem;
  color: #dfdfdf; }

.org-requests__tags-empty {
  margin: 0;
  font-size: 0.75rem;
  color: rgba(184, 184, 184, 0.85); }

.org-requests__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 0.5rem;
  margin-top: 1rem;
  padding-top: 0.85rem;
  border-top: 1px solid rgba(116, 123, 129, 0.3); }

.org-requests__btn {
  margin: 0;
  padding: 0.45rem 0.9rem;
  border-radius: 6px;
  border: 1px solid transparent;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer; }

.org-requests__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed; }

.org-requests__btn--approve {
  border-color: rgba(117, 207, 120, 0.5);
  background: rgba(63, 124, 66, 0.55);
  color: #c2f0c3; }

.org-requests__btn--dismiss-toggle {
  border-color: rgba(199, 132, 69, 0.45);
  background: transparent;
  color: #c78445; }

.org-requests__btn--dismiss-submit {
  border-color: rgba(199, 132, 69, 0.55);
  background: rgba(126, 30, 30, 0.45);
  color: #dfdfdf; }

.org-requests__dismiss-form {
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-top: 0.35rem;
  padding: 0.75rem;
  border-radius: 8px;
  background: rgba(12, 38, 55, 0.45);
  border: 1px solid rgba(199, 132, 69, 0.25); }

.org-requests__dismiss-label {
  font-size: 0.8rem;
  font-weight: 700;
  color: #dfdfdf; }

.org-requests__dismiss-hint {
  margin: 0;
  font-size: 0.75rem;
  color: rgba(184, 184, 184, 0.95); }

.org-requests__dismiss-textarea {
  width: 100%;
  box-sizing: border-box;
  padding: 0.5rem 0.65rem;
  border-radius: 6px;
  border: 1px solid rgba(116, 123, 129, 0.5);
  background: rgba(12, 38, 55, 0.65);
  color: #dfdfdf;
  font-family: inherit;
  font-size: 0.82rem;
  resize: vertical;
  min-height: 4.5rem; }

.org-requests__resolve-form {
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-top: 0.35rem;
  padding: 0.75rem;
  border-radius: 8px;
  background: rgba(12, 38, 55, 0.45);
  border: 1px solid rgba(116, 123, 129, 0.3); }

.org-requests__resolve-label {
  font-size: 0.8rem;
  font-weight: 700;
  color: #dfdfdf; }

.org-requests__resolve-hint {
  margin: 0;
  font-size: 0.75rem;
  color: rgba(184, 184, 184, 0.95); }

.org-requests__resolve-textarea {
  width: 100%;
  box-sizing: border-box;
  padding: 0.5rem 0.65rem;
  border-radius: 6px;
  border: 1px solid rgba(116, 123, 129, 0.5);
  background: rgba(12, 38, 55, 0.65);
  color: #dfdfdf;
  font-family: inherit;
  font-size: 0.82rem;
  resize: vertical;
  min-height: 4.5rem; }

.org-requests__btn--approve-toggle {
  border-color: rgba(117, 207, 120, 0.45);
  color: #75cf78; }

.org-requests__btn--approve-submit {
  align-self: flex-start;
  border-color: rgba(117, 207, 120, 0.55);
  background: rgba(117, 207, 120, 0.12);
  color: #75cf78; }

.org-requests__msg--error,
.org-requests__loading,
.org-requests__empty {
  margin: 0;
  font-size: 0.85rem; }

.org-requests__msg--error {
  color: #c78445; }

.org-requests__loading,
.org-requests__empty {
  color: rgba(184, 184, 184, 0.9); }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.donate-panel-admin {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 0; }

.donate-panel-admin__intro {
  margin: 0;
  font-size: 0.85rem;
  line-height: 1.45;
  color: rgba(223, 223, 223, 0.85); }

.donate-panel-admin__loading,
.donate-panel-admin__hint {
  margin: 0;
  font-size: 0.85rem;
  color: rgba(184, 184, 184, 0.9); }

.donate-panel-admin__msg {
  margin: 0;
  font-size: 0.85rem; }

.donate-panel-admin__msg--error {
  color: #5ac3ff; }

.donate-panel-admin__layout {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(280px, 0.8fr);
  gap: 1.25rem;
  align-items: start; }

.donate-panel-admin__form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 0; }

.donate-panel-admin__card {
  padding: 1rem 1.15rem;
  border-radius: 10px;
  border: 1px solid rgba(116, 123, 129, 0.35);
  background: linear-gradient(160deg, rgba(30, 48, 66, 0.95) 0%, rgba(23, 39, 56, 0.9) 100%);
  box-shadow: 0 6px 20px rgba(21, 28, 36, 0.3); }

.donate-panel-admin__card-title {
  margin: 0 0 0.75rem;
  font-size: 0.9rem;
  font-weight: 700;
  color: #dfdfdf;
  text-transform: uppercase;
  letter-spacing: 0.04em; }

.donate-panel-admin__textarea {
  width: stretch;
  min-height: 120px;
  padding: 0.65rem 0.75rem;
  border: 1px solid rgba(116, 123, 129, 0.45);
  border-radius: 8px;
  background: rgba(12, 38, 55, 0.55);
  color: #dfdfdf;
  font-size: 0.85rem;
  line-height: 1.45;
  resize: vertical; }

.donate-panel-admin__textarea--short {
  min-height: 72px; }

.donate-panel-admin__banner-preview {
  margin-bottom: 0.75rem; }

.donate-panel-admin__banner-img {
  display: block;
  max-width: 100%;
  max-height: 220px;
  margin: 0 auto;
  border-radius: 8px; }

.donate-panel-admin__banner-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem; }

.donate-panel-admin__file-input {
  display: none; }

.donate-panel-admin__file-name {
  font-size: 0.78rem;
  color: rgba(184, 184, 184, 0.95); }

.donate-panel-admin__btn {
  margin: 0;
  padding: 0.45rem 0.85rem;
  border: 1px solid rgba(116, 123, 129, 0.45);
  border-radius: 999px;
  background: rgba(12, 38, 55, 0.5);
  color: rgba(223, 223, 223, 0.9);
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer; }

.donate-panel-admin__btn--primary {
  border-color: rgba(90, 195, 255, 0.55);
  background: rgba(58, 120, 180, 0.35); }

.donate-panel-admin__btn--danger {
  border-color: rgba(90, 195, 255, 0.45);
  background: rgba(73, 18, 18, 0.35); }

.donate-panel-admin__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed; }

.donate-panel-admin__table-wrap {
  overflow-x: auto; }

.donate-panel-admin__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.82rem; }

.donate-panel-admin__table th,
.donate-panel-admin__table td {
  padding: 0.45rem 0.5rem;
  border-bottom: 1px solid rgba(116, 123, 129, 0.25);
  vertical-align: middle; }

.donate-panel-admin__table th {
  color: #dfdfdf;
  text-align: left;
  font-weight: 700; }

.donate-panel-admin__table-row--ghost .donate-panel-admin__input {
  opacity: 0.75; }

.donate-panel-admin__input {
  width: 100%;
  padding: 0.4rem 0.55rem;
  border: 1px solid rgba(116, 123, 129, 0.35);
  border-radius: 6px;
  background: rgba(12, 38, 55, 0.45);
  color: #dfdfdf;
  font-size: 0.82rem; }

.donate-panel-admin__table-actions-col {
  width: 2rem;
  text-align: center; }

.donate-panel-admin__row-remove {
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  color: rgba(90, 195, 255, 0.9);
  font-size: 1.1rem;
  line-height: 1;
  cursor: pointer; }

.donate-panel-admin__save-row {
  display: flex;
  justify-content: flex-end; }

.donate-panel-admin__preview {
  position: sticky;
  top: 7rem; }

.donate-panel-admin__preview-frame {
  padding: 1rem;
  border-radius: 10px;
  border: 1px solid rgba(116, 123, 129, 0.35);
  background: rgba(22, 52, 71, 0.95); }

.donate-panel-content {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  min-width: 0; }

.donate-panel-content__banner {
  text-align: center; }

.donate-panel-content__banner-img {
  display: block;
  max-width: 100%;
  max-height: 220px;
  margin: 0 auto;
  border-radius: 8px; }

.donate-panel-content__intro-p {
  margin: 0;
  font-size: 1rem;
  line-height: 1.5;
  color: #dfdfdf; }

.donate-panel-content__table-wrap {
  overflow-x: auto; }

.donate-panel-content__table {
  width: 100%;
  border-collapse: collapse;
  color: #dfdfdf;
  font-size: 1rem; }

.donate-panel-content__table th,
.donate-panel-content__table td {
  padding: 0.45rem 0.55rem;
  border: 1px solid rgba(116, 123, 129, 0.25);
  text-align: left; }

.donate-panel-content__table th {
  background: rgba(73, 18, 18, 0.75);
  color: #dfdfdf;
  font-weight: 700; }

.donate-panel-content__footer {
  margin: 0;
  font-size: 1.2rem;
  line-height: 1.45;
  color: #dfdfdf;
  font-style: italic; }

.kofi-subscriber-status {
  padding: 0.75rem 0.85rem;
  margin-bottom: 0.75rem;
  border-radius: 10px;
  border: 1px solid rgba(117, 207, 120, 0.4);
  background: rgba(23, 39, 56, 0.9); }

.kofi-subscriber-status__title {
  margin: 0 0 0.35rem;
  font-size: 0.82rem;
  font-weight: 700;
  color: #75cf78;
  text-transform: uppercase;
  letter-spacing: 0.03em; }

.kofi-subscriber-status__text {
  margin: 0 0 0.55rem;
  font-size: 0.78rem;
  line-height: 1.45;
  color: rgba(223, 223, 223, 0.92); }
  .kofi-subscriber-status__text strong {
    color: #dfdfdf;
    font-weight: 700; }

.kofi-subscriber-status__link {
  display: inline-block;
  font-size: 0.76rem;
  font-weight: 600;
  color: #5ac3ff;
  text-decoration: underline;
  text-underline-offset: 0.12em; }
  .kofi-subscriber-status__link:hover, .kofi-subscriber-status__link:focus-visible {
    color: #dfdfdf; }

.kofi-support-overview {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 0.75rem; }

.kofi-support-overview__status-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.65rem; }

.kofi-support-overview__card,
.kofi-support-overview__choice {
  padding: 0.75rem 0.85rem;
  border-radius: 10px;
  border: 1px solid rgba(117, 207, 120, 0.35);
  background: rgba(23, 39, 56, 0.92); }

.kofi-support-overview__choice {
  border-color: rgba(90, 195, 255, 0.35); }

.kofi-support-overview__card-header {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin-bottom: 0.55rem; }

.kofi-support-overview__change {
  margin-left: auto;
  border: 1px solid rgba(90, 195, 255, 0.55);
  border-radius: 999px;
  padding: 0.18rem 0.65rem;
  background: rgba(90, 195, 255, 0.12);
  color: #5ac3ff;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  cursor: pointer; }
  .kofi-support-overview__change:hover, .kofi-support-overview__change:focus-visible {
    background: rgba(90, 195, 255, 0.2); }

.kofi-support-overview__card-icon,
.kofi-support-overview__footnote-icon {
  display: inline-flex;
  width: 1.1rem;
  height: 1.1rem;
  color: #75cf78; }

.kofi-support-overview__svg {
  width: 100%;
  height: 100%; }

.kofi-support-overview__card-title,
.kofi-support-overview__rewards-title {
  margin: 0;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #75cf78; }

.kofi-support-overview__rewards-title {
  color: #5ac3ff; }

.kofi-support-overview__card-line {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  margin: 0 0 0.3rem;
  font-size: 0.78rem;
  color: rgba(223, 223, 223, 0.9); }
  .kofi-support-overview__card-line strong {
    color: #dfdfdf; }

.kofi-support-overview__accent {
  color: #75cf78 !important; }

.kofi-support-overview__dot {
  width: 0.45rem;
  height: 0.45rem;
  border-radius: 50%;
  background: #5ac3ff; }

.kofi-support-overview__card-empty {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin: 0;
  min-height: 2.4rem;
  font-size: 0.78rem;
  color: rgba(223, 223, 223, 0.88); }

.kofi-support-overview__dash {
  color: rgba(223, 223, 223, 0.55); }

.kofi-support-overview__link {
  font-size: 0.76rem;
  font-weight: 600;
  color: #5ac3ff;
  text-decoration: underline;
  text-underline-offset: 0.12em; }

.kofi-support-overview__choice-text,
.kofi-support-overview__choice-option {
  margin: 0 0 0.45rem;
  font-size: 0.78rem;
  color: rgba(223, 223, 223, 0.9); }

.kofi-support-overview__choice-list {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-bottom: 0.55rem; }

.kofi-support-overview__choice-option {
  display: flex;
  align-items: center;
  gap: 0.4rem; }

.kofi-support-overview__rewards-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.55rem; }

.kofi-support-overview__next-reward {
  position: relative;
  align-self: flex-start; }

.kofi-support-overview__next-reward-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0;
  padding: 0.38rem 0.75rem;
  border: 1px solid rgba(90, 195, 255, 0.45);
  border-radius: 999px;
  background: rgba(23, 39, 56, 0.92);
  color: #5ac3ff;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  transition: background 0.18s ease, border-color 0.18s ease, color 0.18s ease; }
  .kofi-support-overview__next-reward-chip:hover, .kofi-support-overview__next-reward-chip:focus-visible {
    border-color: rgba(90, 195, 255, 0.7);
    color: #dfdfdf; }
  .kofi-support-overview__next-reward-chip--open {
    border-color: rgba(90, 195, 255, 0.8);
    background: rgba(30, 48, 66, 0.75);
    color: #dfdfdf; }

.kofi-support-overview__next-reward-chip-icon {
  display: inline-flex;
  width: 0.95rem;
  height: 0.95rem;
  color: inherit; }

.kofi-support-overview__next-reward-tooltip {
  position: absolute;
  top: calc(100% + 0.45rem);
  left: 0;
  z-index: 20;
  width: min(100vw - 2rem, 22rem);
  padding: 0.75rem 0.85rem;
  border-radius: 10px;
  border: 1px solid rgba(90, 195, 255, 0.35);
  background: rgba(23, 39, 56, 0.98);
  box-shadow: 0 10px 28px rgba(12, 38, 55, 0.45); }
  .kofi-support-overview__next-reward-tooltip .kofi-support-overview__reward {
    grid-template-columns: 1.4rem 1fr;
    grid-template-areas: "icon title" "icon req" "icon desc"; }
  .kofi-support-overview__next-reward-tooltip .kofi-support-overview__perk-icon {
    grid-area: icon; }
  .kofi-support-overview__next-reward-tooltip .kofi-support-overview__reward-main {
    grid-area: title; }
  .kofi-support-overview__next-reward-tooltip .kofi-support-overview__reward-req {
    grid-area: req;
    text-align: left; }
  .kofi-support-overview__next-reward-tooltip .kofi-support-overview__reward-desc {
    grid-area: desc; }

.kofi-support-overview__reward {
  display: grid;
  grid-template-columns: 1.6rem minmax(0, 1.15fr) minmax(0, 0.75fr) minmax(0, 1.35fr);
  gap: 0.55rem;
  align-items: center; }

.kofi-support-overview__perk-icon {
  display: inline-flex;
  width: 1.35rem;
  height: 1.35rem;
  align-items: center;
  justify-content: center; }
  .kofi-support-overview__perk-icon .donor-gem-badge__gem,
  .kofi-support-overview__perk-icon .kofi-support-overview__svg {
    width: 1.25rem;
    height: 1.25rem; }
  .kofi-support-overview__perk-icon--blue {
    color: #5ac3ff; }
  .kofi-support-overview__perk-icon--purple {
    color: #9a80e3; }
  .kofi-support-overview__perk-icon--gold {
    color: #e8c547; }

.kofi-support-overview__reward-title {
  margin: 0;
  font-size: 0.78rem;
  font-weight: 700;
  color: #dfdfdf; }

.kofi-support-overview__reward-tier {
  margin: 0.1rem 0 0;
  font-size: 0.72rem;
  font-weight: 600; }
  .kofi-support-overview__reward-tier--supporter {
    color: #5ac3ff; }
  .kofi-support-overview__reward-tier--patron {
    color: #9a80e3; }
  .kofi-support-overview__reward-tier--benefactor {
    color: #e8c547; }

.kofi-support-overview__reward-req {
  margin: 0;
  font-size: 0.72rem;
  color: rgba(223, 223, 223, 0.78);
  text-align: right; }

.kofi-support-overview__reward-desc {
  margin: 0;
  font-size: 0.72rem;
  color: rgba(223, 223, 223, 0.72); }

.kofi-support-overview__footnote {
  display: flex;
  align-items: flex-start;
  gap: 0.4rem;
  margin: 0.7rem 0 0;
  font-size: 0.7rem;
  line-height: 1.4;
  color: rgba(223, 223, 223, 0.65); }

.kofi-support-overview__footnote-icon {
  color: rgba(223, 223, 223, 0.65);
  flex: 0 0 auto;
  margin-top: 0.1rem; }

@media (max-width: 720px) {
  .kofi-support-overview__status-grid {
    grid-template-columns: 1fr; }
  .kofi-support-overview__reward {
    grid-template-columns: 1.4rem 1fr;
    grid-template-areas: "icon title" "icon req" "icon desc"; }
  .kofi-support-overview__perk-icon {
    grid-area: icon; }
  .kofi-support-overview__reward-main {
    grid-area: title; }
  .kofi-support-overview__reward-req {
    grid-area: req;
    text-align: left; }
  .kofi-support-overview__reward-desc {
    grid-area: desc; } }

.kofi-donation-link {
  padding: 0.75rem 0.85rem;
  margin-bottom: 0.65rem;
  border-radius: 10px;
  border: 1px solid rgba(90, 195, 255, 0.35);
  background: rgba(23, 39, 56, 0.85); }

.kofi-donation-link-stack {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 0.65rem; }

.kofi-donation-link-stack .kofi-donation-link {
  margin-bottom: 0; }

.kofi-modal__themes-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0 0 0.85rem;
  border: 1px solid rgba(90, 195, 255, 0.5);
  border-radius: 999px;
  padding: 0.45rem 0.85rem;
  background: rgba(90, 195, 255, 0.12);
  color: #5ac3ff;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  cursor: pointer; }
  .kofi-modal__themes-btn:hover, .kofi-modal__themes-btn:focus-visible {
    background: rgba(90, 195, 255, 0.2); }

.kofi-donation-link__intro {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  padding: 0.75rem 0.85rem;
  border-radius: 10px;
  border: 1px solid rgba(90, 195, 255, 0.35);
  background: rgba(23, 39, 56, 0.85); }

.donate-panel-member__perks-intro {
  margin: 0 0 0.85rem; }

.kofi-donation-link__intro-p {
  margin: 0;
  font-size: 0.82rem;
  line-height: 1.45;
  color: rgba(223, 223, 223, 0.9);
  white-space: pre-wrap; }

.kofi-donation-link__intro-p:last-child {
  margin-bottom: 0; }

.kofi-donation-link--guest {
  border-color: rgba(116, 123, 129, 0.35); }

.kofi-donation-link__title {
  margin: 0 0 0.35rem;
  font-size: 0.82rem;
  font-weight: 700;
  color: #5ac3ff;
  text-transform: uppercase;
  letter-spacing: 0.03em; }

.kofi-donation-link__text {
  margin: 0 0 0.5rem;
  font-size: 0.78rem;
  line-height: 1.45;
  color: rgba(223, 223, 223, 0.88); }

.kofi-donation-link__msg--error {
  margin: 0;
  font-size: 0.78rem;
  color: #5ac3ff; }

.kofi-donation-link__code-row {
  display: grid;
  align-items: center;
  width: -webkit-fill-available;
  min-height: 2rem;
  padding: 0.35rem 0.55rem;
  border-radius: 6px;
  background: rgba(12, 38, 55, 0.65); }

.kofi-donation-link__code {
  grid-area: 1 / 1;
  width: 100%;
  text-align: center;
  color: #75cf78;
  font-size: 0.85rem;
  letter-spacing: 0.06em; }

.kofi-donation-link__copy {
  grid-area: 1 / 1;
  justify-self: end;
  margin: 0;
  padding: 0.35rem 0.65rem;
  border: 1px solid rgba(90, 195, 255, 0.45);
  border-radius: 999px;
  background: rgba(58, 120, 180, 0.35);
  color: #dfdfdf;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer; }

.kofi-donation-link__copy:disabled {
  opacity: 0.55;
  cursor: not-allowed; }

.donate-panel-member {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 0; }

.donate-panel-member__banner {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  margin-bottom: 0.25rem; }

.donate-panel-member__banner-img {
  display: block;
  width: 100%;
  max-height: 220px;
  object-fit: cover;
  border-radius: 10px; }

.donate-panel-member__intro {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  margin-bottom: 20px; }

.donate-panel-member__banner .donate-panel-member__intro {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 0.55rem;
  width: min(62%, 26rem);
  max-width: 100%;
  margin: 0;
  padding: 1rem 1.15rem;
  text-align: left; }

.donate-panel-member__intro-p {
  margin: 0;
  font-size: 0.84rem;
  line-height: 1.55;
  color: rgba(223, 223, 223, 0.88); }

.donate-panel-member__banner .donate-panel-member__intro-p {
  font-size: 0.98rem;
  font-weight: 700;
  line-height: 1.45;
  color: #ffffff;
  text-shadow: 0 1px 2px rgba(12, 38, 55, 0.55); }

.donate-panel-member__funding {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1.35rem;
  padding: 0.85rem 0.95rem 0.95rem;
  border: 1px solid rgba(116, 123, 129, 0.3);
  border-radius: 14px;
  background: linear-gradient(145deg, rgba(30, 48, 66, 0.55) 0%, rgba(12, 38, 55, 0.42) 55%, rgba(23, 39, 56, 0.5) 100%);
  box-shadow: 0 8px 24px rgba(21, 28, 36, 0.22), inset 0 1px 0 rgba(223, 223, 223, 0.06); }

.donate-panel-member__funding-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  gap: 0.75rem;
  min-width: 0; }

.donate-panel-member__funding-tabs {
  display: inline-flex;
  flex-shrink: 0;
  gap: 0.15rem;
  padding: 0.2rem;
  border: 1px solid rgba(116, 123, 129, 0.28);
  border-radius: 999px;
  background: rgba(12, 38, 55, 0.5); }

.donate-panel-member__funding-tab {
  margin: 0;
  padding: 0.38rem 0.9rem;
  border: none;
  border-radius: 999px;
  background: transparent;
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(184, 184, 184, 0.88);
  cursor: pointer;
  transition: background 0.22s ease, color 0.22s ease, box-shadow 0.22s ease; }
  .donate-panel-member__funding-tab:hover {
    color: #dfdfdf; }
  .donate-panel-member__funding-tab.is-active {
    background: linear-gradient(135deg, rgba(58, 120, 180, 0.92), rgba(90, 195, 255, 0.78));
    color: #dfdfdf;
    box-shadow: 0 2px 12px rgba(90, 195, 255, 0.28); }

.donate-panel-member__funding-panel {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  min-width: 0; }

.donate-panel-member__funding-percent {
  flex-shrink: 0;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  border: 1px solid rgba(90, 195, 255, 0.35);
  background: rgba(58, 120, 180, 0.28);
  font-size: 0.72rem;
  font-weight: 700;
  color: #5ac3ff; }

.donate-panel-member__funding-track-wrap {
  width: 100%;
  min-width: 0; }

.donate-panel-member__funding-bar {
  display: block;
  width: 100%;
  height: 0.72rem;
  margin: 0;
  border: 1px solid rgba(116, 123, 129, 0.28);
  border-radius: 999px;
  overflow: hidden;
  appearance: none;
  background: rgba(12, 38, 55, 0.55);
  box-shadow: inset 0 1px 3px rgba(21, 28, 36, 0.35); }
  .donate-panel-member__funding-bar::-webkit-progress-bar {
    border-radius: 999px;
    background: transparent; }
  .donate-panel-member__funding-bar::-webkit-progress-value {
    border-radius: 999px;
    background: linear-gradient(90deg, rgba(58, 120, 180, 0.95), rgba(90, 195, 255, 0.95));
    box-shadow: 0 0 12px rgba(90, 195, 255, 0.35);
    transition: width 0.35s ease; }
  .donate-panel-member__funding-bar::-moz-progress-bar {
    border-radius: 999px;
    background: linear-gradient(90deg, rgba(58, 120, 180, 0.95), rgba(90, 195, 255, 0.95));
    box-shadow: 0 0 12px rgba(90, 195, 255, 0.35); }

.donate-panel-member__funding-bar--complete {
  border-color: rgba(117, 207, 120, 0.45); }
  .donate-panel-member__funding-bar--complete::-webkit-progress-value {
    background: linear-gradient(90deg, rgba(63, 124, 66, 0.9), rgba(117, 207, 120, 0.95));
    box-shadow: 0 0 14px rgba(117, 207, 120, 0.35); }
  .donate-panel-member__funding-bar--complete::-moz-progress-bar {
    background: linear-gradient(90deg, rgba(63, 124, 66, 0.9), rgba(117, 207, 120, 0.95));
    box-shadow: 0 0 14px rgba(117, 207, 120, 0.35); }

.donate-panel-member__funding-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.65rem; }

.donate-panel-member__funding-stat {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0; }

.donate-panel-member__funding-stat--target {
  text-align: right; }

.donate-panel-member__funding-stat-label {
  font-size: 0.62rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(184, 184, 184, 0.85); }

.donate-panel-member__funding-stat-value {
  font-size: 0.9rem;
  font-weight: 700;
  color: #dfdfdf;
  white-space: nowrap; }

.donate-panel-member__funding-stat-value--raised {
  color: #5ac3ff; }

.donate-panel-member__funding--popover {
  margin-bottom: 0;
  border: 1px solid rgba(116, 123, 129, 0.28);
  background: #1e3042ad;
  box-shadow: none; }
  .donate-panel-member__funding--popover .donate-panel-member__funding-toolbar {
    flex-wrap: nowrap; }
  .donate-panel-member__funding--popover .donate-panel-member__funding-tab {
    padding: 0.34rem 0.72rem; }

.donate-panel-member__section-title {
  display: flex;
  align-items: center;
  gap: 0rem;
  justify-self: start;
  margin: 0 15px 20px;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.92); }

.donate-panel-member__section-lines {
  position: relative;
  width: 45px;
  height: 27px;
  flex-shrink: 0; }

.donate-panel-member__section-lines span {
  position: absolute;
  width: 22px;
  height: 3px;
  background: #5ac3ff;
  transform: rotate(-65deg);
  transform-origin: left center; }

.donate-panel-member__section-lines span:first-child {
  top: 20px;
  left: 12px; }

.donate-panel-member__section-lines span:last-child {
  top: 20px; }

.donate-panel-member__table-shell {
  overflow: hidden;
  border: 1px solid rgba(116, 123, 129, 0.28);
  border-radius: 12px;
  background: rgba(12, 38, 55, 0.35); }

.donate-panel-member__table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed; }

.donate-panel-member__table thead th:first-child,
.donate-panel-member__table tbody td:first-child {
  text-align: left;
  width: 34%; }

.donate-panel-member__table thead th:nth-child(2),
.donate-panel-member__table tbody td:nth-child(2) {
  text-align: left;
  width: 42%; }

.donate-panel-member__table thead th:last-child,
.donate-panel-member__table tbody td:last-child {
  width: 24%; }

.donate-panel-member__table thead th {
  padding: 0.55rem 0.7rem;
  border-bottom: 1px solid rgba(116, 123, 129, 0.22);
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  text-align: left;
  color: #5ac3ff; }

.donate-panel-member__table thead th:last-child {
  text-align: right; }

.donate-panel-member__table tbody td {
  padding: 0.62rem 0.7rem;
  border-bottom: 1px solid rgba(116, 123, 129, 0.16);
  font-size: 0.78rem;
  line-height: 1.35;
  color: rgba(223, 223, 223, 0.9);
  vertical-align: middle;
  text-align: left; }

.donate-panel-member__table tbody tr:last-child td {
  border-bottom: none; }

.donate-panel-member__cost-center {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.45rem;
  width: 100%;
  min-width: 0;
  text-align: left; }

.donate-panel-member__icon {
  display: inline-flex;
  flex-shrink: 0;
  width: 1.15rem;
  height: 1.15rem;
  color: #5ac3ff; }

.donate-panel-member__icon svg {
  width: 100%;
  height: 100%; }

.donate-panel-member__amount {
  text-align: right !important;
  font-weight: 600;
  color: #dfdfdf;
  white-space: nowrap; }

.donate-panel-member__total {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 0.65rem;
  margin-top: 20px;
  padding: 0.7rem 0.85rem;
  border: 1px solid rgba(116, 123, 129, 0.28);
  border-radius: 12px;
  background: rgba(12, 38, 55, 0.35); }

.donate-panel-member__total-hex {
  display: inline-flex;
  width: 2rem;
  height: 2rem;
  color: #5ac3ff; }

.donate-panel-member__total-hex svg {
  width: 100%;
  height: 100%; }

.donate-panel-member__total-label {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.88); }

.donate-panel-member__total-value {
  font-size: 0.82rem;
  color: rgba(223, 223, 223, 0.85);
  white-space: nowrap; }

.donate-panel-member__total-value strong {
  font-size: 1rem;
  font-weight: 700;
  color: #5ac3ff; }

.donate-panel-member__total-suffix {
  font-size: 0.78rem;
  color: rgba(223, 223, 223, 0.75); }

.donate-panel-member__footer {
  display: flex;
  align-items: flex-start;
  gap: 0.45rem;
  margin: 10px 0;
  font-size: 1rem;
  line-height: 1.45;
  font-style: italic;
  color: rgba(184, 184, 184, 0.92); }

.donate-panel-member__footer-star {
  display: inline-flex;
  flex-shrink: 0;
  width: 1.1rem;
  height: 1.1rem;
  margin-top: 0.12rem;
  color: #5ac3ff; }

.donate-panel-member__footer-star svg {
  width: 100%;
  height: 100%; }

.donate-panel-admin__select {
  cursor: pointer; }

.donate-panel-admin__drag-col {
  width: 2rem;
  text-align: center;
  vertical-align: middle; }

.donate-panel-admin__drag-handle {
  margin: 0;
  padding: 0.15rem 0.35rem;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: rgba(184, 184, 184, 0.95);
  font-size: 1rem;
  line-height: 1;
  cursor: grab;
  user-select: none; }

.donate-panel-admin__drag-handle:disabled {
  opacity: 0.45;
  cursor: not-allowed; }

.donate-panel-admin__table-row--dragging {
  position: relative;
  z-index: 2;
  opacity: 0.92;
  background: rgba(12, 38, 55, 0.55); }

.donator-perks-member {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  color: #dfdfdf; }

.donator-perks-member__intro,
.donator-perks-member__tier {
  display: flex;
  flex-direction: column;
  gap: 0.45rem; }

.donator-perks-member__tier-title {
  margin: 0;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #5ac3ff; }

.donator-perks-member__text {
  margin: 0;
  font-size: 0.85rem;
  line-height: 1.45;
  color: rgba(223, 223, 223, 0.92);
  white-space: pre-wrap; }

.donator-perks-member__list {
  margin: 0.25rem 0 0;
  padding-left: 1.1rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem; }

.donator-perks-member__perk-title {
  display: block;
  font-size: 0.84rem;
  color: #dfdfdf; }

.donator-perks-member__perk-desc {
  display: block;
  margin-top: 0.15rem;
  font-size: 0.78rem;
  line-height: 1.4;
  color: rgba(184, 184, 184, 0.95); }

@media (max-width: 960px) {
  .donate-panel-admin__layout {
    grid-template-columns: 1fr; }
  .donate-panel-admin__preview {
    position: static; } }

.kofi-modal-overlay {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000000; }

.kofi-modal-content {
  background: #163447;
  max-width: 1050px;
  width: 90%;
  border-radius: 8px;
  position: relative;
  max-height: 90vh;
  overflow-y: auto; }
  .kofi-modal-content .kofi-modal-header {
    display: flex;
    flex-direction: row;
    height: 35px;
    background: linear-gradient(to top, #491212, #5e2f2fd3, #491212); }
    .kofi-modal-content .kofi-modal-header .kofi-modal-h3 {
      margin: 0;
      font-size: medium;
      color: white;
      text-transform: uppercase;
      padding: 8px 15px; }
    .kofi-modal-content .kofi-modal-header .kofi-close-button {
      position: relative;
      color: white;
      padding: 0 8px;
      margin-left: auto;
      margin-right: 0;
      top: 0;
      font-size: 20px;
      background: transparent;
      border: none;
      cursor: pointer; }
  .kofi-modal-content .kofi-modal-body {
    display: flex;
    flex-direction: row;
    gap: 24px;
    padding: 15px;
    align-items: flex-start;
    justify-content: space-between; }
  .kofi-modal-content .donate-panel-modal-content {
    flex: 1;
    max-width: 100%;
    overflow-wrap: break-word;
    margin: 0;
    padding: 0; }
  .kofi-modal-content .donate-panel-modal-content__loading {
    margin: 0;
    font-size: 0.85rem;
    color: rgba(223, 223, 223, 0.85); }
  .kofi-modal-content .kofi-widget-column {
    flex-shrink: 0;
    width: 400px;
    max-width: 100%; }
  @media (max-width: 768px) {
    .kofi-modal-content .kofi-modal-body {
      flex-direction: column; }
    .kofi-modal-content .kofi-widget-column {
      width: 100%; }
    .kofi-modal-content .ko-fi-panel,
    .kofi-modal-content .ko-fi-panel-wrap {
      width: 100%; } }

.ko-fi-panel {
  border: none;
  padding: 4px;
  margin-top: 0;
  background: transparent;
  width: 400px;
  height: 585px;
  border-radius: 15px; }

.ko-fi-panel-wrap {
  width: 400px;
  max-width: 100%; }

.ko-fi-panel__loading {
  margin: 0;
  padding: 1.25rem 0.85rem;
  font-size: 0.82rem;
  color: rgba(223, 223, 223, 0.78); }

.ko-fi-panel--unavailable {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.65rem;
  box-sizing: border-box;
  padding: 1.25rem 1rem;
  border: 1px solid rgba(155, 96, 42, 0.45);
  background: rgba(23, 39, 56, 0.92); }

.ko-fi-panel__down-title {
  margin: 0;
  font-size: 0.88rem;
  font-weight: 700;
  color: #9b602a;
  letter-spacing: 0.02em; }

.ko-fi-panel__down-text {
  margin: 0;
  font-size: 0.8rem;
  line-height: 1.45;
  color: rgba(223, 223, 223, 0.9); }

.ko-fi-panel__down-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem;
  margin-top: 0.25rem; }

.ko-fi-panel__down-retry {
  border: 1px solid rgba(90, 195, 255, 0.5);
  border-radius: 999px;
  padding: 0.35rem 0.75rem;
  background: rgba(90, 195, 255, 0.12);
  color: #5ac3ff;
  font-size: 0.74rem;
  font-weight: 700;
  cursor: pointer; }
  .ko-fi-panel__down-retry:hover, .ko-fi-panel__down-retry:focus-visible {
    background: rgba(90, 195, 255, 0.2); }

.ko-fi-panel__down-link {
  font-size: 0.76rem;
  font-weight: 600;
  color: #5ac3ff;
  text-decoration: underline;
  text-underline-offset: 0.12em; }

.kofi-donation-link + .ko-fi-panel-wrap {
  margin-top: 2rem; }

.kofi-modal__themes-btn + .ko-fi-panel-wrap {
  margin-top: 0.85rem; }

.support-choice-popup-overlay {
  position: fixed;
  inset: 0;
  z-index: 12000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  background: rgba(12, 38, 55, 0.68); }

.support-choice-popup {
  width: min(100%, 34rem); }

.support-choice-popup__shell {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.15rem 1.2rem 1.2rem;
  border-radius: 16px;
  border: 1px solid rgba(90, 195, 255, 0.28);
  background: linear-gradient(160deg, rgba(30, 48, 66, 0.96) 0%, rgba(23, 39, 56, 0.98) 55%, rgba(12, 38, 55, 0.96) 100%);
  box-shadow: 0 20px 48px rgba(12, 38, 55, 0.5), inset 0 1px 0 rgba(223, 223, 223, 0.06); }

.support-choice-popup__close {
  position: absolute;
  top: 0.65rem;
  right: 0.75rem;
  z-index: 2;
  width: 1.8rem;
  height: 1.8rem;
  border: none;
  border-radius: 999px;
  background: rgba(223, 223, 223, 0.08);
  color: #dfdfdf;
  font-size: 1.25rem;
  line-height: 1;
  cursor: pointer; }
  .support-choice-popup__close:hover, .support-choice-popup__close:focus-visible {
    background: rgba(223, 223, 223, 0.16); }

.support-choice-popup__header {
  display: flex;
  flex-direction: column;
  gap: 0.4rem; }

.support-choice-popup__eyebrow {
  margin: 0;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #5ac3ff; }

.support-choice-popup__title {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  line-height: 1.25;
  color: #dfdfdf; }

.support-choice-popup__lead {
  margin: 0;
  font-size: 0.82rem;
  line-height: 1.5;
  color: rgba(223, 223, 223, 0.78); }

.support-choice-popup__status-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.65rem; }

.support-choice-popup__stat {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 0;
  padding: 0.75rem 0.8rem;
  border-radius: 12px;
  border: 1px solid rgba(117, 207, 120, 0.28);
  background: rgba(12, 38, 55, 0.38); }

.support-choice-popup__stat-header {
  display: flex;
  align-items: center;
  gap: 0.4rem; }

.support-choice-popup__stat-icon {
  display: inline-flex;
  width: 1rem;
  height: 1rem;
  color: #75cf78; }

.support-choice-popup__icon-svg {
  width: 100%;
  height: 100%; }

.support-choice-popup__stat-title {
  margin: 0;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #75cf78; }

.support-choice-popup__stat-value {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
  color: #dfdfdf; }
  .support-choice-popup__stat-value--muted {
    color: rgba(223, 223, 223, 0.7);
    font-weight: 600; }

.support-choice-popup__stat-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.35rem;
  margin: 0;
  font-size: 0.72rem;
  line-height: 1.35;
  color: rgba(223, 223, 223, 0.72); }
  .support-choice-popup__stat-meta strong {
    color: #75cf78;
    font-weight: 700; }

.support-choice-popup__choice {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding-top: 0.15rem;
  border-top: 1px solid rgba(223, 223, 223, 0.1); }

.support-choice-popup__choice-head {
  display: flex;
  flex-direction: column;
  gap: 0.25rem; }

.support-choice-popup__choice-title {
  margin: 0;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #5ac3ff; }

.support-choice-popup__choice-note {
  margin: 0;
  font-size: 0.76rem;
  line-height: 1.4;
  color: rgba(223, 223, 223, 0.72); }

.support-choice-popup__themes-btn {
  align-self: flex-start;
  margin-top: 0.35rem;
  border: 1px solid rgba(90, 195, 255, 0.5);
  border-radius: 999px;
  padding: 0.28rem 0.75rem;
  background: rgba(90, 195, 255, 0.12);
  color: #5ac3ff;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  cursor: pointer; }
  .support-choice-popup__themes-btn:hover, .support-choice-popup__themes-btn:focus-visible {
    background: rgba(90, 195, 255, 0.2); }

.support-choice-popup__options {
  display: flex;
  flex-direction: column;
  gap: 0.5rem; }

.support-choice-popup__option {
  display: flex;
  align-items: flex-start;
  gap: 0.7rem;
  margin: 0;
  padding: 0.75rem 0.85rem;
  border-radius: 12px;
  border: 1px solid rgba(116, 123, 129, 0.28);
  background: rgba(12, 38, 55, 0.32);
  cursor: pointer;
  transition: border-color 0.18s ease, background 0.18s ease, box-shadow 0.18s ease; }
  .support-choice-popup__option:hover {
    border-color: rgba(90, 195, 255, 0.45);
    background: rgba(30, 48, 66, 0.55); }
  .support-choice-popup__option--selected {
    border-color: rgba(90, 195, 255, 0.7);
    background: rgba(30, 48, 66, 0.72);
    box-shadow: inset 0 0 0 1px rgba(90, 195, 255, 0.18); }
  .support-choice-popup__option--locked {
    opacity: 0.55;
    cursor: not-allowed; }
    .support-choice-popup__option--locked:hover {
      border-color: rgba(116, 123, 129, 0.28);
      background: rgba(12, 38, 55, 0.32); }
  .support-choice-popup__option--current {
    border-color: rgba(117, 207, 120, 0.45); }
  .support-choice-popup__option--blue.support-choice-popup__option--selected {
    border-color: rgba(90, 195, 255, 0.72); }
  .support-choice-popup__option--purple.support-choice-popup__option--selected {
    border-color: rgba(154, 128, 227, 0.72);
    box-shadow: inset 0 0 0 1px rgba(154, 128, 227, 0.16); }
  .support-choice-popup__option--gold.support-choice-popup__option--selected {
    border-color: rgba(232, 197, 71, 0.72);
    box-shadow: inset 0 0 0 1px rgba(232, 197, 71, 0.16); }

.support-choice-popup__option-input {
  flex: 0 0 auto;
  margin: 0.2rem 0 0;
  accent-color: #5ac3ff; }

.support-choice-popup__option--purple .support-choice-popup__option-input {
  accent-color: #9a80e3; }

.support-choice-popup__option--gold .support-choice-popup__option-input {
  accent-color: #e8c547; }

.support-choice-popup__option-main {
  display: flex;
  flex-direction: column;
  gap: 0.28rem;
  min-width: 0;
  flex: 1; }

.support-choice-popup__option-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem; }

.support-choice-popup__option-identity {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  min-width: 0; }

.support-choice-popup__option-gem {
  flex: 0 0 auto;
  width: 1.15rem;
  height: 1.15rem;
  color: #5ac3ff; }

.support-choice-popup__option--blue .support-choice-popup__option-gem {
  color: #5ac3ff;
  filter: drop-shadow(0 0 2px rgba(90, 195, 255, 0.45)); }

.support-choice-popup__option--purple .support-choice-popup__option-gem {
  color: #9a80e3;
  filter: drop-shadow(0 0 2px rgba(154, 128, 227, 0.45)); }

.support-choice-popup__option--gold .support-choice-popup__option-gem {
  color: #e8c547;
  filter: drop-shadow(0 0 3px rgba(232, 197, 71, 0.55)); }

.support-choice-popup__option-name {
  font-size: 0.88rem;
  font-weight: 700;
  color: #dfdfdf; }

.support-choice-popup__option--blue .support-choice-popup__option-name {
  color: #5ac3ff; }

.support-choice-popup__option--purple .support-choice-popup__option-name {
  color: #9a80e3; }

.support-choice-popup__option--gold .support-choice-popup__option-name {
  color: #e8c547; }

.support-choice-popup__option-duration {
  flex: 0 0 auto;
  max-width: 55%;
  padding: 0.22rem 0.55rem;
  border-radius: 999px;
  border: 1px solid rgba(223, 223, 223, 0.16);
  background: rgba(12, 38, 55, 0.45);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: none;
  text-align: right;
  line-height: 1.25;
  color: rgba(223, 223, 223, 0.9);
  white-space: normal; }

.support-choice-popup__option-benefits {
  list-style: none;
  margin: 0.15rem 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.22rem; }

.support-choice-popup__option-benefit {
  display: flex;
  align-items: flex-start;
  gap: 0.4rem;
  margin: 0;
  font-size: 0.76rem;
  line-height: 1.4;
  color: rgba(223, 223, 223, 0.8); }

.support-choice-popup__option-check {
  flex: 0 0 auto;
  margin-top: 0.05rem;
  color: #75cf78;
  font-weight: 700; }

.support-choice-popup__option-lock {
  margin: 0.35rem 0 0;
  font-size: 0.72rem;
  line-height: 1.35;
  color: rgba(155, 96, 42, 0.95); }

.support-choice-popup__error {
  margin: 0;
  font-size: 0.78rem;
  color: #9e2222; }

.support-choice-popup__confirm {
  margin: 0.15rem 0 0;
  padding: 0.7rem 1rem;
  border: 1px solid rgba(90, 195, 255, 0.55);
  border-radius: 10px;
  background: linear-gradient(180deg, rgba(90, 195, 255, 0.28) 0%, rgba(90, 195, 255, 0.14) 100%);
  color: #dfdfdf;
  font-size: 0.84rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: background 0.18s ease, border-color 0.18s ease, opacity 0.18s ease; }
  .support-choice-popup__confirm:hover:not(:disabled), .support-choice-popup__confirm:focus-visible:not(:disabled) {
    border-color: rgba(90, 195, 255, 0.85);
    background: linear-gradient(180deg, rgba(90, 195, 255, 0.38) 0%, rgba(90, 195, 255, 0.2) 100%); }
  .support-choice-popup__confirm:disabled {
    opacity: 0.55;
    cursor: not-allowed; }

@media (max-width: 560px) {
  .support-choice-popup__status-grid {
    grid-template-columns: 1fr; }
  .support-choice-popup__option-top {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.35rem; } }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.perk-theme-media {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 1; }
  .perk-theme-media--cover .perk-theme-media__img,
  .perk-theme-media--cover .perk-theme-media__video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center; }
  .perk-theme-media__darken {
    position: absolute;
    inset: 0;
    z-index: 2;
    pointer-events: none;
    background: #000000; }
    .perk-theme-media__darken.darken-0 {
      opacity: 0; }
    .perk-theme-media__darken.darken-1 {
      opacity: 0.01; }
    .perk-theme-media__darken.darken-2 {
      opacity: 0.02; }
    .perk-theme-media__darken.darken-3 {
      opacity: 0.03; }
    .perk-theme-media__darken.darken-4 {
      opacity: 0.04; }
    .perk-theme-media__darken.darken-5 {
      opacity: 0.05; }
    .perk-theme-media__darken.darken-6 {
      opacity: 0.06; }
    .perk-theme-media__darken.darken-7 {
      opacity: 0.07; }
    .perk-theme-media__darken.darken-8 {
      opacity: 0.08; }
    .perk-theme-media__darken.darken-9 {
      opacity: 0.09; }
    .perk-theme-media__darken.darken-10 {
      opacity: 0.1; }
    .perk-theme-media__darken.darken-11 {
      opacity: 0.11; }
    .perk-theme-media__darken.darken-12 {
      opacity: 0.12; }
    .perk-theme-media__darken.darken-13 {
      opacity: 0.13; }
    .perk-theme-media__darken.darken-14 {
      opacity: 0.14; }
    .perk-theme-media__darken.darken-15 {
      opacity: 0.15; }
    .perk-theme-media__darken.darken-16 {
      opacity: 0.16; }
    .perk-theme-media__darken.darken-17 {
      opacity: 0.17; }
    .perk-theme-media__darken.darken-18 {
      opacity: 0.18; }
    .perk-theme-media__darken.darken-19 {
      opacity: 0.19; }
    .perk-theme-media__darken.darken-20 {
      opacity: 0.2; }
    .perk-theme-media__darken.darken-21 {
      opacity: 0.21; }
    .perk-theme-media__darken.darken-22 {
      opacity: 0.22; }
    .perk-theme-media__darken.darken-23 {
      opacity: 0.23; }
    .perk-theme-media__darken.darken-24 {
      opacity: 0.24; }
    .perk-theme-media__darken.darken-25 {
      opacity: 0.25; }
    .perk-theme-media__darken.darken-26 {
      opacity: 0.26; }
    .perk-theme-media__darken.darken-27 {
      opacity: 0.27; }
    .perk-theme-media__darken.darken-28 {
      opacity: 0.28; }
    .perk-theme-media__darken.darken-29 {
      opacity: 0.29; }
    .perk-theme-media__darken.darken-30 {
      opacity: 0.3; }
    .perk-theme-media__darken.darken-31 {
      opacity: 0.31; }
    .perk-theme-media__darken.darken-32 {
      opacity: 0.32; }
    .perk-theme-media__darken.darken-33 {
      opacity: 0.33; }
    .perk-theme-media__darken.darken-34 {
      opacity: 0.34; }
    .perk-theme-media__darken.darken-35 {
      opacity: 0.35; }
    .perk-theme-media__darken.darken-36 {
      opacity: 0.36; }
    .perk-theme-media__darken.darken-37 {
      opacity: 0.37; }
    .perk-theme-media__darken.darken-38 {
      opacity: 0.38; }
    .perk-theme-media__darken.darken-39 {
      opacity: 0.39; }
    .perk-theme-media__darken.darken-40 {
      opacity: 0.4; }
    .perk-theme-media__darken.darken-41 {
      opacity: 0.41; }
    .perk-theme-media__darken.darken-42 {
      opacity: 0.42; }
    .perk-theme-media__darken.darken-43 {
      opacity: 0.43; }
    .perk-theme-media__darken.darken-44 {
      opacity: 0.44; }
    .perk-theme-media__darken.darken-45 {
      opacity: 0.45; }
    .perk-theme-media__darken.darken-46 {
      opacity: 0.46; }
    .perk-theme-media__darken.darken-47 {
      opacity: 0.47; }
    .perk-theme-media__darken.darken-48 {
      opacity: 0.48; }
    .perk-theme-media__darken.darken-49 {
      opacity: 0.49; }
    .perk-theme-media__darken.darken-50 {
      opacity: 0.5; }
    .perk-theme-media__darken.darken-51 {
      opacity: 0.51; }
    .perk-theme-media__darken.darken-52 {
      opacity: 0.52; }
    .perk-theme-media__darken.darken-53 {
      opacity: 0.53; }
    .perk-theme-media__darken.darken-54 {
      opacity: 0.54; }
    .perk-theme-media__darken.darken-55 {
      opacity: 0.55; }
    .perk-theme-media__darken.darken-56 {
      opacity: 0.56; }
    .perk-theme-media__darken.darken-57 {
      opacity: 0.57; }
    .perk-theme-media__darken.darken-58 {
      opacity: 0.58; }
    .perk-theme-media__darken.darken-59 {
      opacity: 0.59; }
    .perk-theme-media__darken.darken-60 {
      opacity: 0.6; }
    .perk-theme-media__darken.darken-61 {
      opacity: 0.61; }
    .perk-theme-media__darken.darken-62 {
      opacity: 0.62; }
    .perk-theme-media__darken.darken-63 {
      opacity: 0.63; }
    .perk-theme-media__darken.darken-64 {
      opacity: 0.64; }
    .perk-theme-media__darken.darken-65 {
      opacity: 0.65; }
    .perk-theme-media__darken.darken-66 {
      opacity: 0.66; }
    .perk-theme-media__darken.darken-67 {
      opacity: 0.67; }
    .perk-theme-media__darken.darken-68 {
      opacity: 0.68; }
    .perk-theme-media__darken.darken-69 {
      opacity: 0.69; }
    .perk-theme-media__darken.darken-70 {
      opacity: 0.7; }
    .perk-theme-media__darken.darken-71 {
      opacity: 0.71; }
    .perk-theme-media__darken.darken-72 {
      opacity: 0.72; }
    .perk-theme-media__darken.darken-73 {
      opacity: 0.73; }
    .perk-theme-media__darken.darken-74 {
      opacity: 0.74; }
    .perk-theme-media__darken.darken-75 {
      opacity: 0.75; }
    .perk-theme-media__darken.darken-76 {
      opacity: 0.76; }
    .perk-theme-media__darken.darken-77 {
      opacity: 0.77; }
    .perk-theme-media__darken.darken-78 {
      opacity: 0.78; }
    .perk-theme-media__darken.darken-79 {
      opacity: 0.79; }
    .perk-theme-media__darken.darken-80 {
      opacity: 0.8; }
    .perk-theme-media__darken.darken-81 {
      opacity: 0.81; }
    .perk-theme-media__darken.darken-82 {
      opacity: 0.82; }
    .perk-theme-media__darken.darken-83 {
      opacity: 0.83; }
    .perk-theme-media__darken.darken-84 {
      opacity: 0.84; }
    .perk-theme-media__darken.darken-85 {
      opacity: 0.85; }
    .perk-theme-media__darken.darken-86 {
      opacity: 0.86; }
    .perk-theme-media__darken.darken-87 {
      opacity: 0.87; }
    .perk-theme-media__darken.darken-88 {
      opacity: 0.88; }
    .perk-theme-media__darken.darken-89 {
      opacity: 0.89; }
    .perk-theme-media__darken.darken-90 {
      opacity: 0.9; }
    .perk-theme-media__darken.darken-91 {
      opacity: 0.91; }
    .perk-theme-media__darken.darken-92 {
      opacity: 0.92; }
    .perk-theme-media__darken.darken-93 {
      opacity: 0.93; }
    .perk-theme-media__darken.darken-94 {
      opacity: 0.94; }
    .perk-theme-media__darken.darken-95 {
      opacity: 0.95; }
    .perk-theme-media__darken.darken-96 {
      opacity: 0.96; }
    .perk-theme-media__darken.darken-97 {
      opacity: 0.97; }
    .perk-theme-media__darken.darken-98 {
      opacity: 0.98; }
    .perk-theme-media__darken.darken-99 {
      opacity: 0.99; }
    .perk-theme-media__darken.darken-100 {
      opacity: 1; }

.profile-themes-admin {
  display: flex;
  flex-direction: column;
  gap: 1rem; }

.profile-themes-admin__header {
  display: flex;
  flex-direction: column;
  gap: 0.35rem; }

.profile-themes-admin__title {
  margin: 0;
  color: rgba(255, 255, 255, 0.95); }

.profile-themes-admin__hint,
.profile-themes-admin__status {
  margin: 0;
  color: rgba(255, 255, 255, 0.65);
  font-size: 0.9rem; }

.profile-themes-admin__error {
  margin: 0;
  color: #9e2222; }

.profile-themes-admin__layout {
  display: grid;
  grid-template-columns: minmax(280px, 0.95fr) minmax(360px, 1.25fr);
  gap: 1rem;
  align-items: start; }

.profile-themes-admin__list,
.profile-themes-admin__editor {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  padding: 1rem;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(12, 22, 34, 0.55); }

.profile-themes-admin__list-toolbar,
.profile-themes-admin__editor-head,
.profile-themes-admin__list-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem; }

.profile-themes-admin__subtitle {
  margin: 0;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.95rem;
  text-transform: uppercase;
  letter-spacing: 0.04em; }

.profile-themes-admin__cards {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.65rem; }

.profile-themes-admin__card-wrap {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 0.35rem;
  position: relative; }

.profile-themes-admin__card {
  display: grid;
  grid-template-columns: 72px 1fr;
  gap: 0.75rem;
  width: 100%;
  padding: 0.7rem;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(8, 16, 26, 0.72);
  color: #ffffff;
  text-align: left;
  cursor: pointer; }

.profile-themes-admin__card.is-active {
  border-color: rgba(90, 195, 255, 0.8);
  box-shadow: 0 0 0 1px rgba(90, 195, 255, 0.35); }

.profile-themes-admin__card-thumb {
  width: 72px;
  height: 48px;
  border-radius: 8px;
  overflow: hidden;
  background: linear-gradient(135deg, #1c2d38, #384858); }
  .profile-themes-admin__card-thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover; }
  .profile-themes-admin__card-thumb--nebula {
    background: radial-gradient(circle at 30% 40%, #225891, #163a5f 70%); }
  .profile-themes-admin__card-thumb--shooting-stars, .profile-themes-admin__card-thumb--shooting-star-premium {
    background: radial-gradient(circle at 70% 20%, rgba(255, 255, 255, 0.55) 0 1px, transparent 2px), radial-gradient(circle at 30% 40%, #1e4e80, #163a5f 72%); }

.profile-themes-admin__card-body {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem; }

.profile-themes-admin__card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem; }

.profile-themes-admin__card-name {
  font-weight: 650; }

.profile-themes-admin__card-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem; }

.profile-themes-admin__chip {
  font-size: 0.72rem;
  padding: 0.15rem 0.4rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.7); }
  .profile-themes-admin__chip.is-default {
    color: #f5df8a;
    background: rgba(232, 197, 71, 0.18); }

.profile-themes-admin__badge {
  font-size: 0.72rem;
  padding: 0.15rem 0.45rem;
  border-radius: 999px; }
  .profile-themes-admin__badge.is-on {
    color: #b4d5b5;
    background: rgba(90, 160, 92, 0.25); }
  .profile-themes-admin__badge.is-off {
    color: rgba(255, 255, 255, 0.65);
    background: rgba(255, 255, 255, 0.08); }

.profile-themes-admin__icon-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.05);
  color: #ffffff;
  cursor: pointer; }

.profile-themes-admin__filter,
.profile-themes-admin__card-menu {
  position: relative; }

.profile-themes-admin__menu {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  z-index: 5;
  min-width: 180px;
  padding: 0.4rem;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(10, 18, 28, 0.98);
  display: flex;
  flex-direction: column;
  gap: 0.25rem; }
  .profile-themes-admin__menu button,
  .profile-themes-admin__menu select {
    width: 100%;
    text-align: left;
    border: 0;
    background: transparent;
    color: #ffffff;
    padding: 0.45rem 0.55rem;
    border-radius: 6px;
    cursor: pointer; }
  .profile-themes-admin__menu button:hover {
    background: rgba(255, 255, 255, 0.08); }
  .profile-themes-admin__menu button.is-danger {
    color: #d74545; }

.profile-themes-admin__menu-field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  color: rgba(255, 255, 255, 0.75);
  font-size: 0.8rem;
  padding: 0.35rem; }

.profile-themes-admin__create-dashed {
  border: 1px dashed rgba(255, 255, 255, 0.28);
  border-radius: 10px;
  background: transparent;
  color: rgba(255, 255, 255, 0.8);
  padding: 0.85rem;
  cursor: pointer; }

.profile-themes-admin__fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem; }

.profile-themes-admin__field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.85rem; }
  .profile-themes-admin__field--full {
    grid-column: 1 / -1; }

.profile-themes-admin__field-hint {
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.75rem;
  line-height: 1.35; }

.profile-themes-admin__overlays {
  grid-column: 1 / -1;
  margin: 0;
  padding: 0;
  border: 0;
  min-inline-size: 0; }
  .profile-themes-admin__overlays legend {
    padding: 0;
    margin-bottom: 0.35rem;
    color: rgba(255, 255, 255, 0.8);
    font-size: 0.85rem; }

.profile-themes-admin__overlays-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.85rem;
  margin-bottom: 0.65rem;
  overflow: visible;
  position: relative;
  z-index: 5; }

.profile-themes-admin__overlays-copy {
  min-width: 0;
  flex: 1; }

.profile-themes-admin__overlays-hint {
  margin: 0;
  color: rgba(255, 255, 255, 0.55);
  font-size: 0.78rem;
  line-height: 1.35; }

.profile-themes-admin__halo-color {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  position: relative;
  z-index: 6;
  overflow: visible; }
  .profile-themes-admin__halo-color .color-picker-container {
    position: relative;
    margin: 0;
    flex-direction: column !important;
    align-items: flex-end; }
  .profile-themes-admin__halo-color .color-picker-tooltip {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    left: auto;
    transform: none;
    z-index: 10050; }
  .profile-themes-admin__halo-color .color-picker-wrapper {
    position: relative;
    transform: none;
    right: 0; }

.profile-themes-admin__halo-color-label {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase; }

.profile-themes-admin__fx-params--halo {
  overflow: visible; }

.profile-themes-admin__fx-tabs {
  display: flex;
  flex-direction: column;
  gap: 0.65rem; }

.profile-themes-admin__fx-tablist {
  display: flex;
  gap: 0.35rem;
  padding: 0.2rem;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(8, 16, 26, 0.45); }

.profile-themes-admin__fx-tab {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: rgba(255, 255, 255, 0.7);
  padding: 0.45rem 0.55rem;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease; }
  .profile-themes-admin__fx-tab.is-active {
    border-color: rgba(90, 195, 255, 0.7);
    background: rgba(90, 195, 255, 0.14);
    color: rgba(255, 255, 255, 0.95); }

.profile-themes-admin__fx-tab-count {
  min-width: 1.15rem;
  padding: 0.05rem 0.35rem;
  border-radius: 999px;
  background: rgba(58, 120, 180, 0.28);
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.68rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  line-height: 1.2; }

.profile-themes-admin__fx-panel {
  min-width: 0; }

.profile-themes-admin__fx-empty {
  margin: 0;
  padding: 0.85rem 0.9rem;
  border-radius: 10px;
  border: 1px dashed rgba(255, 255, 255, 0.14);
  background: rgba(8, 16, 26, 0.28);
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.8rem;
  line-height: 1.4; }

.profile-themes-admin__fx-stack {
  display: flex;
  flex-direction: column;
  gap: 0.55rem; }

.profile-themes-admin__fx-card {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  padding: 0.7rem 0.8rem;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(8, 16, 26, 0.4);
  transition: border-color 0.15s ease, background 0.15s ease; }
  .profile-themes-admin__fx-card.is-active {
    border-color: rgba(58, 120, 180, 0.35);
    background: rgba(58, 120, 180, 0.08); }
  .profile-themes-admin__fx-card.is-disabled {
    opacity: 0.55; }

.profile-themes-admin__fx-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem; }

.profile-themes-admin__fx-card-copy {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0; }

.profile-themes-admin__fx-card-title {
  color: rgba(255, 255, 255, 0.92);
  font-size: 0.88rem;
  font-weight: 600; }

.profile-themes-admin__fx-card-note {
  color: rgba(255, 255, 255, 0.45);
  font-size: 0.72rem;
  line-height: 1.3; }

.profile-themes-admin__fx-toggle {
  flex-shrink: 0; }

.profile-themes-admin__fx-params {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  padding-top: 0.15rem; }

.profile-themes-admin__hslider {
  display: flex;
  flex-direction: column;
  gap: 0.3rem; }
  .profile-themes-admin__hslider.is-locked {
    opacity: 0.55; }

.profile-themes-admin__hslider-meta {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.75rem; }

.profile-themes-admin__hslider-value {
  font-variant-numeric: tabular-nums;
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.72rem; }

.profile-themes-admin__hslider-input {
  width: 100%;
  height: 1.1rem;
  margin: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
  accent-color: #3a78b4; }
  .profile-themes-admin__hslider-input:disabled {
    opacity: 0.45;
    cursor: not-allowed; }

.profile-themes-admin__input,
.profile-themes-admin__textarea,
.profile-themes-admin__select {
  width: 100%;
  box-sizing: border-box;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.95);
  color: #1c2d38;
  padding: 0.45rem 0.55rem; }

.profile-themes-admin__check,
.profile-themes-admin__switch {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.9rem; }

.profile-themes-admin__order {
  display: flex;
  align-items: flex-end;
  gap: 1rem; }

.profile-themes-admin__save {
  width: 100%; }

.profile-themes-admin__media-tabs {
  display: flex;
  flex-direction: column;
  gap: 0.65rem; }

.profile-themes-admin__media-tablist {
  display: flex;
  gap: 0.35rem;
  padding: 0.2rem;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(8, 16, 26, 0.45); }

.profile-themes-admin__media-tab {
  flex: 1;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: rgba(255, 255, 255, 0.7);
  padding: 0.45rem 0.7rem;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease; }
  .profile-themes-admin__media-tab.is-active {
    border-color: rgba(90, 195, 255, 0.7);
    background: rgba(90, 195, 255, 0.14);
    color: rgba(255, 255, 255, 0.95); }

.profile-themes-admin__media-panel {
  min-width: 0; }

.profile-themes-media-slot {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  padding: 0.85rem;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(8, 16, 26, 0.45); }

.profile-themes-media-slot__head {
  display: flex;
  justify-content: space-between;
  align-items: center; }

.profile-themes-media-slot__title {
  margin: 0;
  color: rgba(255, 255, 255, 0.92); }

.profile-themes-media-slot__ratio {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.55); }

.profile-themes-media-slot__kinds {
  display: flex;
  gap: 0.35rem; }

.profile-themes-media-slot__kind {
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: transparent;
  color: rgba(255, 255, 255, 0.8);
  padding: 0.3rem 0.7rem;
  cursor: pointer; }
  .profile-themes-media-slot__kind.is-active {
    border-color: rgba(90, 195, 255, 0.75);
    background: rgba(90, 195, 255, 0.15); }

.profile-themes-media-slot__dropzone {
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
  border: 1px dashed rgba(255, 255, 255, 0.25);
  background: rgba(42, 56, 71, 0.55);
  cursor: grab;
  user-select: none; }
  .profile-themes-media-slot__dropzone--banner {
    aspect-ratio: 977 / 150; }
  .profile-themes-media-slot__dropzone--card {
    aspect-ratio: 1 / 1;
    max-width: 280px; }
  .profile-themes-media-slot__dropzone.is-dragging, .profile-themes-media-slot__dropzone.is-editing {
    border-color: rgba(90, 195, 255, 0.55); }
  .profile-themes-media-slot__dropzone.is-disabled {
    cursor: default;
    opacity: 0.7; }

.profile-themes-media-slot__crop-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  max-width: none;
  object-fit: cover;
  transform-origin: top left;
  user-select: none;
  cursor: grab;
  pointer-events: auto;
  transform: translateX(var(--translate-x, 0px)) translateY(var(--translate-y, 0px)) scale(var(--scale, 1)); }
  .profile-themes-media-slot__crop-img.is-dragging {
    cursor: grabbing; }
  .profile-themes-media-slot__crop-img.translate-x--1500 {
    --translate-x: -1500px; }
  .profile-themes-media-slot__crop-img.translate-x--1499 {
    --translate-x: -1499px; }
  .profile-themes-media-slot__crop-img.translate-x--1498 {
    --translate-x: -1498px; }
  .profile-themes-media-slot__crop-img.translate-x--1497 {
    --translate-x: -1497px; }
  .profile-themes-media-slot__crop-img.translate-x--1496 {
    --translate-x: -1496px; }
  .profile-themes-media-slot__crop-img.translate-x--1495 {
    --translate-x: -1495px; }
  .profile-themes-media-slot__crop-img.translate-x--1494 {
    --translate-x: -1494px; }
  .profile-themes-media-slot__crop-img.translate-x--1493 {
    --translate-x: -1493px; }
  .profile-themes-media-slot__crop-img.translate-x--1492 {
    --translate-x: -1492px; }
  .profile-themes-media-slot__crop-img.translate-x--1491 {
    --translate-x: -1491px; }
  .profile-themes-media-slot__crop-img.translate-x--1490 {
    --translate-x: -1490px; }
  .profile-themes-media-slot__crop-img.translate-x--1489 {
    --translate-x: -1489px; }
  .profile-themes-media-slot__crop-img.translate-x--1488 {
    --translate-x: -1488px; }
  .profile-themes-media-slot__crop-img.translate-x--1487 {
    --translate-x: -1487px; }
  .profile-themes-media-slot__crop-img.translate-x--1486 {
    --translate-x: -1486px; }
  .profile-themes-media-slot__crop-img.translate-x--1485 {
    --translate-x: -1485px; }
  .profile-themes-media-slot__crop-img.translate-x--1484 {
    --translate-x: -1484px; }
  .profile-themes-media-slot__crop-img.translate-x--1483 {
    --translate-x: -1483px; }
  .profile-themes-media-slot__crop-img.translate-x--1482 {
    --translate-x: -1482px; }
  .profile-themes-media-slot__crop-img.translate-x--1481 {
    --translate-x: -1481px; }
  .profile-themes-media-slot__crop-img.translate-x--1480 {
    --translate-x: -1480px; }
  .profile-themes-media-slot__crop-img.translate-x--1479 {
    --translate-x: -1479px; }
  .profile-themes-media-slot__crop-img.translate-x--1478 {
    --translate-x: -1478px; }
  .profile-themes-media-slot__crop-img.translate-x--1477 {
    --translate-x: -1477px; }
  .profile-themes-media-slot__crop-img.translate-x--1476 {
    --translate-x: -1476px; }
  .profile-themes-media-slot__crop-img.translate-x--1475 {
    --translate-x: -1475px; }
  .profile-themes-media-slot__crop-img.translate-x--1474 {
    --translate-x: -1474px; }
  .profile-themes-media-slot__crop-img.translate-x--1473 {
    --translate-x: -1473px; }
  .profile-themes-media-slot__crop-img.translate-x--1472 {
    --translate-x: -1472px; }
  .profile-themes-media-slot__crop-img.translate-x--1471 {
    --translate-x: -1471px; }
  .profile-themes-media-slot__crop-img.translate-x--1470 {
    --translate-x: -1470px; }
  .profile-themes-media-slot__crop-img.translate-x--1469 {
    --translate-x: -1469px; }
  .profile-themes-media-slot__crop-img.translate-x--1468 {
    --translate-x: -1468px; }
  .profile-themes-media-slot__crop-img.translate-x--1467 {
    --translate-x: -1467px; }
  .profile-themes-media-slot__crop-img.translate-x--1466 {
    --translate-x: -1466px; }
  .profile-themes-media-slot__crop-img.translate-x--1465 {
    --translate-x: -1465px; }
  .profile-themes-media-slot__crop-img.translate-x--1464 {
    --translate-x: -1464px; }
  .profile-themes-media-slot__crop-img.translate-x--1463 {
    --translate-x: -1463px; }
  .profile-themes-media-slot__crop-img.translate-x--1462 {
    --translate-x: -1462px; }
  .profile-themes-media-slot__crop-img.translate-x--1461 {
    --translate-x: -1461px; }
  .profile-themes-media-slot__crop-img.translate-x--1460 {
    --translate-x: -1460px; }
  .profile-themes-media-slot__crop-img.translate-x--1459 {
    --translate-x: -1459px; }
  .profile-themes-media-slot__crop-img.translate-x--1458 {
    --translate-x: -1458px; }
  .profile-themes-media-slot__crop-img.translate-x--1457 {
    --translate-x: -1457px; }
  .profile-themes-media-slot__crop-img.translate-x--1456 {
    --translate-x: -1456px; }
  .profile-themes-media-slot__crop-img.translate-x--1455 {
    --translate-x: -1455px; }
  .profile-themes-media-slot__crop-img.translate-x--1454 {
    --translate-x: -1454px; }
  .profile-themes-media-slot__crop-img.translate-x--1453 {
    --translate-x: -1453px; }
  .profile-themes-media-slot__crop-img.translate-x--1452 {
    --translate-x: -1452px; }
  .profile-themes-media-slot__crop-img.translate-x--1451 {
    --translate-x: -1451px; }
  .profile-themes-media-slot__crop-img.translate-x--1450 {
    --translate-x: -1450px; }
  .profile-themes-media-slot__crop-img.translate-x--1449 {
    --translate-x: -1449px; }
  .profile-themes-media-slot__crop-img.translate-x--1448 {
    --translate-x: -1448px; }
  .profile-themes-media-slot__crop-img.translate-x--1447 {
    --translate-x: -1447px; }
  .profile-themes-media-slot__crop-img.translate-x--1446 {
    --translate-x: -1446px; }
  .profile-themes-media-slot__crop-img.translate-x--1445 {
    --translate-x: -1445px; }
  .profile-themes-media-slot__crop-img.translate-x--1444 {
    --translate-x: -1444px; }
  .profile-themes-media-slot__crop-img.translate-x--1443 {
    --translate-x: -1443px; }
  .profile-themes-media-slot__crop-img.translate-x--1442 {
    --translate-x: -1442px; }
  .profile-themes-media-slot__crop-img.translate-x--1441 {
    --translate-x: -1441px; }
  .profile-themes-media-slot__crop-img.translate-x--1440 {
    --translate-x: -1440px; }
  .profile-themes-media-slot__crop-img.translate-x--1439 {
    --translate-x: -1439px; }
  .profile-themes-media-slot__crop-img.translate-x--1438 {
    --translate-x: -1438px; }
  .profile-themes-media-slot__crop-img.translate-x--1437 {
    --translate-x: -1437px; }
  .profile-themes-media-slot__crop-img.translate-x--1436 {
    --translate-x: -1436px; }
  .profile-themes-media-slot__crop-img.translate-x--1435 {
    --translate-x: -1435px; }
  .profile-themes-media-slot__crop-img.translate-x--1434 {
    --translate-x: -1434px; }
  .profile-themes-media-slot__crop-img.translate-x--1433 {
    --translate-x: -1433px; }
  .profile-themes-media-slot__crop-img.translate-x--1432 {
    --translate-x: -1432px; }
  .profile-themes-media-slot__crop-img.translate-x--1431 {
    --translate-x: -1431px; }
  .profile-themes-media-slot__crop-img.translate-x--1430 {
    --translate-x: -1430px; }
  .profile-themes-media-slot__crop-img.translate-x--1429 {
    --translate-x: -1429px; }
  .profile-themes-media-slot__crop-img.translate-x--1428 {
    --translate-x: -1428px; }
  .profile-themes-media-slot__crop-img.translate-x--1427 {
    --translate-x: -1427px; }
  .profile-themes-media-slot__crop-img.translate-x--1426 {
    --translate-x: -1426px; }
  .profile-themes-media-slot__crop-img.translate-x--1425 {
    --translate-x: -1425px; }
  .profile-themes-media-slot__crop-img.translate-x--1424 {
    --translate-x: -1424px; }
  .profile-themes-media-slot__crop-img.translate-x--1423 {
    --translate-x: -1423px; }
  .profile-themes-media-slot__crop-img.translate-x--1422 {
    --translate-x: -1422px; }
  .profile-themes-media-slot__crop-img.translate-x--1421 {
    --translate-x: -1421px; }
  .profile-themes-media-slot__crop-img.translate-x--1420 {
    --translate-x: -1420px; }
  .profile-themes-media-slot__crop-img.translate-x--1419 {
    --translate-x: -1419px; }
  .profile-themes-media-slot__crop-img.translate-x--1418 {
    --translate-x: -1418px; }
  .profile-themes-media-slot__crop-img.translate-x--1417 {
    --translate-x: -1417px; }
  .profile-themes-media-slot__crop-img.translate-x--1416 {
    --translate-x: -1416px; }
  .profile-themes-media-slot__crop-img.translate-x--1415 {
    --translate-x: -1415px; }
  .profile-themes-media-slot__crop-img.translate-x--1414 {
    --translate-x: -1414px; }
  .profile-themes-media-slot__crop-img.translate-x--1413 {
    --translate-x: -1413px; }
  .profile-themes-media-slot__crop-img.translate-x--1412 {
    --translate-x: -1412px; }
  .profile-themes-media-slot__crop-img.translate-x--1411 {
    --translate-x: -1411px; }
  .profile-themes-media-slot__crop-img.translate-x--1410 {
    --translate-x: -1410px; }
  .profile-themes-media-slot__crop-img.translate-x--1409 {
    --translate-x: -1409px; }
  .profile-themes-media-slot__crop-img.translate-x--1408 {
    --translate-x: -1408px; }
  .profile-themes-media-slot__crop-img.translate-x--1407 {
    --translate-x: -1407px; }
  .profile-themes-media-slot__crop-img.translate-x--1406 {
    --translate-x: -1406px; }
  .profile-themes-media-slot__crop-img.translate-x--1405 {
    --translate-x: -1405px; }
  .profile-themes-media-slot__crop-img.translate-x--1404 {
    --translate-x: -1404px; }
  .profile-themes-media-slot__crop-img.translate-x--1403 {
    --translate-x: -1403px; }
  .profile-themes-media-slot__crop-img.translate-x--1402 {
    --translate-x: -1402px; }
  .profile-themes-media-slot__crop-img.translate-x--1401 {
    --translate-x: -1401px; }
  .profile-themes-media-slot__crop-img.translate-x--1400 {
    --translate-x: -1400px; }
  .profile-themes-media-slot__crop-img.translate-x--1399 {
    --translate-x: -1399px; }
  .profile-themes-media-slot__crop-img.translate-x--1398 {
    --translate-x: -1398px; }
  .profile-themes-media-slot__crop-img.translate-x--1397 {
    --translate-x: -1397px; }
  .profile-themes-media-slot__crop-img.translate-x--1396 {
    --translate-x: -1396px; }
  .profile-themes-media-slot__crop-img.translate-x--1395 {
    --translate-x: -1395px; }
  .profile-themes-media-slot__crop-img.translate-x--1394 {
    --translate-x: -1394px; }
  .profile-themes-media-slot__crop-img.translate-x--1393 {
    --translate-x: -1393px; }
  .profile-themes-media-slot__crop-img.translate-x--1392 {
    --translate-x: -1392px; }
  .profile-themes-media-slot__crop-img.translate-x--1391 {
    --translate-x: -1391px; }
  .profile-themes-media-slot__crop-img.translate-x--1390 {
    --translate-x: -1390px; }
  .profile-themes-media-slot__crop-img.translate-x--1389 {
    --translate-x: -1389px; }
  .profile-themes-media-slot__crop-img.translate-x--1388 {
    --translate-x: -1388px; }
  .profile-themes-media-slot__crop-img.translate-x--1387 {
    --translate-x: -1387px; }
  .profile-themes-media-slot__crop-img.translate-x--1386 {
    --translate-x: -1386px; }
  .profile-themes-media-slot__crop-img.translate-x--1385 {
    --translate-x: -1385px; }
  .profile-themes-media-slot__crop-img.translate-x--1384 {
    --translate-x: -1384px; }
  .profile-themes-media-slot__crop-img.translate-x--1383 {
    --translate-x: -1383px; }
  .profile-themes-media-slot__crop-img.translate-x--1382 {
    --translate-x: -1382px; }
  .profile-themes-media-slot__crop-img.translate-x--1381 {
    --translate-x: -1381px; }
  .profile-themes-media-slot__crop-img.translate-x--1380 {
    --translate-x: -1380px; }
  .profile-themes-media-slot__crop-img.translate-x--1379 {
    --translate-x: -1379px; }
  .profile-themes-media-slot__crop-img.translate-x--1378 {
    --translate-x: -1378px; }
  .profile-themes-media-slot__crop-img.translate-x--1377 {
    --translate-x: -1377px; }
  .profile-themes-media-slot__crop-img.translate-x--1376 {
    --translate-x: -1376px; }
  .profile-themes-media-slot__crop-img.translate-x--1375 {
    --translate-x: -1375px; }
  .profile-themes-media-slot__crop-img.translate-x--1374 {
    --translate-x: -1374px; }
  .profile-themes-media-slot__crop-img.translate-x--1373 {
    --translate-x: -1373px; }
  .profile-themes-media-slot__crop-img.translate-x--1372 {
    --translate-x: -1372px; }
  .profile-themes-media-slot__crop-img.translate-x--1371 {
    --translate-x: -1371px; }
  .profile-themes-media-slot__crop-img.translate-x--1370 {
    --translate-x: -1370px; }
  .profile-themes-media-slot__crop-img.translate-x--1369 {
    --translate-x: -1369px; }
  .profile-themes-media-slot__crop-img.translate-x--1368 {
    --translate-x: -1368px; }
  .profile-themes-media-slot__crop-img.translate-x--1367 {
    --translate-x: -1367px; }
  .profile-themes-media-slot__crop-img.translate-x--1366 {
    --translate-x: -1366px; }
  .profile-themes-media-slot__crop-img.translate-x--1365 {
    --translate-x: -1365px; }
  .profile-themes-media-slot__crop-img.translate-x--1364 {
    --translate-x: -1364px; }
  .profile-themes-media-slot__crop-img.translate-x--1363 {
    --translate-x: -1363px; }
  .profile-themes-media-slot__crop-img.translate-x--1362 {
    --translate-x: -1362px; }
  .profile-themes-media-slot__crop-img.translate-x--1361 {
    --translate-x: -1361px; }
  .profile-themes-media-slot__crop-img.translate-x--1360 {
    --translate-x: -1360px; }
  .profile-themes-media-slot__crop-img.translate-x--1359 {
    --translate-x: -1359px; }
  .profile-themes-media-slot__crop-img.translate-x--1358 {
    --translate-x: -1358px; }
  .profile-themes-media-slot__crop-img.translate-x--1357 {
    --translate-x: -1357px; }
  .profile-themes-media-slot__crop-img.translate-x--1356 {
    --translate-x: -1356px; }
  .profile-themes-media-slot__crop-img.translate-x--1355 {
    --translate-x: -1355px; }
  .profile-themes-media-slot__crop-img.translate-x--1354 {
    --translate-x: -1354px; }
  .profile-themes-media-slot__crop-img.translate-x--1353 {
    --translate-x: -1353px; }
  .profile-themes-media-slot__crop-img.translate-x--1352 {
    --translate-x: -1352px; }
  .profile-themes-media-slot__crop-img.translate-x--1351 {
    --translate-x: -1351px; }
  .profile-themes-media-slot__crop-img.translate-x--1350 {
    --translate-x: -1350px; }
  .profile-themes-media-slot__crop-img.translate-x--1349 {
    --translate-x: -1349px; }
  .profile-themes-media-slot__crop-img.translate-x--1348 {
    --translate-x: -1348px; }
  .profile-themes-media-slot__crop-img.translate-x--1347 {
    --translate-x: -1347px; }
  .profile-themes-media-slot__crop-img.translate-x--1346 {
    --translate-x: -1346px; }
  .profile-themes-media-slot__crop-img.translate-x--1345 {
    --translate-x: -1345px; }
  .profile-themes-media-slot__crop-img.translate-x--1344 {
    --translate-x: -1344px; }
  .profile-themes-media-slot__crop-img.translate-x--1343 {
    --translate-x: -1343px; }
  .profile-themes-media-slot__crop-img.translate-x--1342 {
    --translate-x: -1342px; }
  .profile-themes-media-slot__crop-img.translate-x--1341 {
    --translate-x: -1341px; }
  .profile-themes-media-slot__crop-img.translate-x--1340 {
    --translate-x: -1340px; }
  .profile-themes-media-slot__crop-img.translate-x--1339 {
    --translate-x: -1339px; }
  .profile-themes-media-slot__crop-img.translate-x--1338 {
    --translate-x: -1338px; }
  .profile-themes-media-slot__crop-img.translate-x--1337 {
    --translate-x: -1337px; }
  .profile-themes-media-slot__crop-img.translate-x--1336 {
    --translate-x: -1336px; }
  .profile-themes-media-slot__crop-img.translate-x--1335 {
    --translate-x: -1335px; }
  .profile-themes-media-slot__crop-img.translate-x--1334 {
    --translate-x: -1334px; }
  .profile-themes-media-slot__crop-img.translate-x--1333 {
    --translate-x: -1333px; }
  .profile-themes-media-slot__crop-img.translate-x--1332 {
    --translate-x: -1332px; }
  .profile-themes-media-slot__crop-img.translate-x--1331 {
    --translate-x: -1331px; }
  .profile-themes-media-slot__crop-img.translate-x--1330 {
    --translate-x: -1330px; }
  .profile-themes-media-slot__crop-img.translate-x--1329 {
    --translate-x: -1329px; }
  .profile-themes-media-slot__crop-img.translate-x--1328 {
    --translate-x: -1328px; }
  .profile-themes-media-slot__crop-img.translate-x--1327 {
    --translate-x: -1327px; }
  .profile-themes-media-slot__crop-img.translate-x--1326 {
    --translate-x: -1326px; }
  .profile-themes-media-slot__crop-img.translate-x--1325 {
    --translate-x: -1325px; }
  .profile-themes-media-slot__crop-img.translate-x--1324 {
    --translate-x: -1324px; }
  .profile-themes-media-slot__crop-img.translate-x--1323 {
    --translate-x: -1323px; }
  .profile-themes-media-slot__crop-img.translate-x--1322 {
    --translate-x: -1322px; }
  .profile-themes-media-slot__crop-img.translate-x--1321 {
    --translate-x: -1321px; }
  .profile-themes-media-slot__crop-img.translate-x--1320 {
    --translate-x: -1320px; }
  .profile-themes-media-slot__crop-img.translate-x--1319 {
    --translate-x: -1319px; }
  .profile-themes-media-slot__crop-img.translate-x--1318 {
    --translate-x: -1318px; }
  .profile-themes-media-slot__crop-img.translate-x--1317 {
    --translate-x: -1317px; }
  .profile-themes-media-slot__crop-img.translate-x--1316 {
    --translate-x: -1316px; }
  .profile-themes-media-slot__crop-img.translate-x--1315 {
    --translate-x: -1315px; }
  .profile-themes-media-slot__crop-img.translate-x--1314 {
    --translate-x: -1314px; }
  .profile-themes-media-slot__crop-img.translate-x--1313 {
    --translate-x: -1313px; }
  .profile-themes-media-slot__crop-img.translate-x--1312 {
    --translate-x: -1312px; }
  .profile-themes-media-slot__crop-img.translate-x--1311 {
    --translate-x: -1311px; }
  .profile-themes-media-slot__crop-img.translate-x--1310 {
    --translate-x: -1310px; }
  .profile-themes-media-slot__crop-img.translate-x--1309 {
    --translate-x: -1309px; }
  .profile-themes-media-slot__crop-img.translate-x--1308 {
    --translate-x: -1308px; }
  .profile-themes-media-slot__crop-img.translate-x--1307 {
    --translate-x: -1307px; }
  .profile-themes-media-slot__crop-img.translate-x--1306 {
    --translate-x: -1306px; }
  .profile-themes-media-slot__crop-img.translate-x--1305 {
    --translate-x: -1305px; }
  .profile-themes-media-slot__crop-img.translate-x--1304 {
    --translate-x: -1304px; }
  .profile-themes-media-slot__crop-img.translate-x--1303 {
    --translate-x: -1303px; }
  .profile-themes-media-slot__crop-img.translate-x--1302 {
    --translate-x: -1302px; }
  .profile-themes-media-slot__crop-img.translate-x--1301 {
    --translate-x: -1301px; }
  .profile-themes-media-slot__crop-img.translate-x--1300 {
    --translate-x: -1300px; }
  .profile-themes-media-slot__crop-img.translate-x--1299 {
    --translate-x: -1299px; }
  .profile-themes-media-slot__crop-img.translate-x--1298 {
    --translate-x: -1298px; }
  .profile-themes-media-slot__crop-img.translate-x--1297 {
    --translate-x: -1297px; }
  .profile-themes-media-slot__crop-img.translate-x--1296 {
    --translate-x: -1296px; }
  .profile-themes-media-slot__crop-img.translate-x--1295 {
    --translate-x: -1295px; }
  .profile-themes-media-slot__crop-img.translate-x--1294 {
    --translate-x: -1294px; }
  .profile-themes-media-slot__crop-img.translate-x--1293 {
    --translate-x: -1293px; }
  .profile-themes-media-slot__crop-img.translate-x--1292 {
    --translate-x: -1292px; }
  .profile-themes-media-slot__crop-img.translate-x--1291 {
    --translate-x: -1291px; }
  .profile-themes-media-slot__crop-img.translate-x--1290 {
    --translate-x: -1290px; }
  .profile-themes-media-slot__crop-img.translate-x--1289 {
    --translate-x: -1289px; }
  .profile-themes-media-slot__crop-img.translate-x--1288 {
    --translate-x: -1288px; }
  .profile-themes-media-slot__crop-img.translate-x--1287 {
    --translate-x: -1287px; }
  .profile-themes-media-slot__crop-img.translate-x--1286 {
    --translate-x: -1286px; }
  .profile-themes-media-slot__crop-img.translate-x--1285 {
    --translate-x: -1285px; }
  .profile-themes-media-slot__crop-img.translate-x--1284 {
    --translate-x: -1284px; }
  .profile-themes-media-slot__crop-img.translate-x--1283 {
    --translate-x: -1283px; }
  .profile-themes-media-slot__crop-img.translate-x--1282 {
    --translate-x: -1282px; }
  .profile-themes-media-slot__crop-img.translate-x--1281 {
    --translate-x: -1281px; }
  .profile-themes-media-slot__crop-img.translate-x--1280 {
    --translate-x: -1280px; }
  .profile-themes-media-slot__crop-img.translate-x--1279 {
    --translate-x: -1279px; }
  .profile-themes-media-slot__crop-img.translate-x--1278 {
    --translate-x: -1278px; }
  .profile-themes-media-slot__crop-img.translate-x--1277 {
    --translate-x: -1277px; }
  .profile-themes-media-slot__crop-img.translate-x--1276 {
    --translate-x: -1276px; }
  .profile-themes-media-slot__crop-img.translate-x--1275 {
    --translate-x: -1275px; }
  .profile-themes-media-slot__crop-img.translate-x--1274 {
    --translate-x: -1274px; }
  .profile-themes-media-slot__crop-img.translate-x--1273 {
    --translate-x: -1273px; }
  .profile-themes-media-slot__crop-img.translate-x--1272 {
    --translate-x: -1272px; }
  .profile-themes-media-slot__crop-img.translate-x--1271 {
    --translate-x: -1271px; }
  .profile-themes-media-slot__crop-img.translate-x--1270 {
    --translate-x: -1270px; }
  .profile-themes-media-slot__crop-img.translate-x--1269 {
    --translate-x: -1269px; }
  .profile-themes-media-slot__crop-img.translate-x--1268 {
    --translate-x: -1268px; }
  .profile-themes-media-slot__crop-img.translate-x--1267 {
    --translate-x: -1267px; }
  .profile-themes-media-slot__crop-img.translate-x--1266 {
    --translate-x: -1266px; }
  .profile-themes-media-slot__crop-img.translate-x--1265 {
    --translate-x: -1265px; }
  .profile-themes-media-slot__crop-img.translate-x--1264 {
    --translate-x: -1264px; }
  .profile-themes-media-slot__crop-img.translate-x--1263 {
    --translate-x: -1263px; }
  .profile-themes-media-slot__crop-img.translate-x--1262 {
    --translate-x: -1262px; }
  .profile-themes-media-slot__crop-img.translate-x--1261 {
    --translate-x: -1261px; }
  .profile-themes-media-slot__crop-img.translate-x--1260 {
    --translate-x: -1260px; }
  .profile-themes-media-slot__crop-img.translate-x--1259 {
    --translate-x: -1259px; }
  .profile-themes-media-slot__crop-img.translate-x--1258 {
    --translate-x: -1258px; }
  .profile-themes-media-slot__crop-img.translate-x--1257 {
    --translate-x: -1257px; }
  .profile-themes-media-slot__crop-img.translate-x--1256 {
    --translate-x: -1256px; }
  .profile-themes-media-slot__crop-img.translate-x--1255 {
    --translate-x: -1255px; }
  .profile-themes-media-slot__crop-img.translate-x--1254 {
    --translate-x: -1254px; }
  .profile-themes-media-slot__crop-img.translate-x--1253 {
    --translate-x: -1253px; }
  .profile-themes-media-slot__crop-img.translate-x--1252 {
    --translate-x: -1252px; }
  .profile-themes-media-slot__crop-img.translate-x--1251 {
    --translate-x: -1251px; }
  .profile-themes-media-slot__crop-img.translate-x--1250 {
    --translate-x: -1250px; }
  .profile-themes-media-slot__crop-img.translate-x--1249 {
    --translate-x: -1249px; }
  .profile-themes-media-slot__crop-img.translate-x--1248 {
    --translate-x: -1248px; }
  .profile-themes-media-slot__crop-img.translate-x--1247 {
    --translate-x: -1247px; }
  .profile-themes-media-slot__crop-img.translate-x--1246 {
    --translate-x: -1246px; }
  .profile-themes-media-slot__crop-img.translate-x--1245 {
    --translate-x: -1245px; }
  .profile-themes-media-slot__crop-img.translate-x--1244 {
    --translate-x: -1244px; }
  .profile-themes-media-slot__crop-img.translate-x--1243 {
    --translate-x: -1243px; }
  .profile-themes-media-slot__crop-img.translate-x--1242 {
    --translate-x: -1242px; }
  .profile-themes-media-slot__crop-img.translate-x--1241 {
    --translate-x: -1241px; }
  .profile-themes-media-slot__crop-img.translate-x--1240 {
    --translate-x: -1240px; }
  .profile-themes-media-slot__crop-img.translate-x--1239 {
    --translate-x: -1239px; }
  .profile-themes-media-slot__crop-img.translate-x--1238 {
    --translate-x: -1238px; }
  .profile-themes-media-slot__crop-img.translate-x--1237 {
    --translate-x: -1237px; }
  .profile-themes-media-slot__crop-img.translate-x--1236 {
    --translate-x: -1236px; }
  .profile-themes-media-slot__crop-img.translate-x--1235 {
    --translate-x: -1235px; }
  .profile-themes-media-slot__crop-img.translate-x--1234 {
    --translate-x: -1234px; }
  .profile-themes-media-slot__crop-img.translate-x--1233 {
    --translate-x: -1233px; }
  .profile-themes-media-slot__crop-img.translate-x--1232 {
    --translate-x: -1232px; }
  .profile-themes-media-slot__crop-img.translate-x--1231 {
    --translate-x: -1231px; }
  .profile-themes-media-slot__crop-img.translate-x--1230 {
    --translate-x: -1230px; }
  .profile-themes-media-slot__crop-img.translate-x--1229 {
    --translate-x: -1229px; }
  .profile-themes-media-slot__crop-img.translate-x--1228 {
    --translate-x: -1228px; }
  .profile-themes-media-slot__crop-img.translate-x--1227 {
    --translate-x: -1227px; }
  .profile-themes-media-slot__crop-img.translate-x--1226 {
    --translate-x: -1226px; }
  .profile-themes-media-slot__crop-img.translate-x--1225 {
    --translate-x: -1225px; }
  .profile-themes-media-slot__crop-img.translate-x--1224 {
    --translate-x: -1224px; }
  .profile-themes-media-slot__crop-img.translate-x--1223 {
    --translate-x: -1223px; }
  .profile-themes-media-slot__crop-img.translate-x--1222 {
    --translate-x: -1222px; }
  .profile-themes-media-slot__crop-img.translate-x--1221 {
    --translate-x: -1221px; }
  .profile-themes-media-slot__crop-img.translate-x--1220 {
    --translate-x: -1220px; }
  .profile-themes-media-slot__crop-img.translate-x--1219 {
    --translate-x: -1219px; }
  .profile-themes-media-slot__crop-img.translate-x--1218 {
    --translate-x: -1218px; }
  .profile-themes-media-slot__crop-img.translate-x--1217 {
    --translate-x: -1217px; }
  .profile-themes-media-slot__crop-img.translate-x--1216 {
    --translate-x: -1216px; }
  .profile-themes-media-slot__crop-img.translate-x--1215 {
    --translate-x: -1215px; }
  .profile-themes-media-slot__crop-img.translate-x--1214 {
    --translate-x: -1214px; }
  .profile-themes-media-slot__crop-img.translate-x--1213 {
    --translate-x: -1213px; }
  .profile-themes-media-slot__crop-img.translate-x--1212 {
    --translate-x: -1212px; }
  .profile-themes-media-slot__crop-img.translate-x--1211 {
    --translate-x: -1211px; }
  .profile-themes-media-slot__crop-img.translate-x--1210 {
    --translate-x: -1210px; }
  .profile-themes-media-slot__crop-img.translate-x--1209 {
    --translate-x: -1209px; }
  .profile-themes-media-slot__crop-img.translate-x--1208 {
    --translate-x: -1208px; }
  .profile-themes-media-slot__crop-img.translate-x--1207 {
    --translate-x: -1207px; }
  .profile-themes-media-slot__crop-img.translate-x--1206 {
    --translate-x: -1206px; }
  .profile-themes-media-slot__crop-img.translate-x--1205 {
    --translate-x: -1205px; }
  .profile-themes-media-slot__crop-img.translate-x--1204 {
    --translate-x: -1204px; }
  .profile-themes-media-slot__crop-img.translate-x--1203 {
    --translate-x: -1203px; }
  .profile-themes-media-slot__crop-img.translate-x--1202 {
    --translate-x: -1202px; }
  .profile-themes-media-slot__crop-img.translate-x--1201 {
    --translate-x: -1201px; }
  .profile-themes-media-slot__crop-img.translate-x--1200 {
    --translate-x: -1200px; }
  .profile-themes-media-slot__crop-img.translate-x--1199 {
    --translate-x: -1199px; }
  .profile-themes-media-slot__crop-img.translate-x--1198 {
    --translate-x: -1198px; }
  .profile-themes-media-slot__crop-img.translate-x--1197 {
    --translate-x: -1197px; }
  .profile-themes-media-slot__crop-img.translate-x--1196 {
    --translate-x: -1196px; }
  .profile-themes-media-slot__crop-img.translate-x--1195 {
    --translate-x: -1195px; }
  .profile-themes-media-slot__crop-img.translate-x--1194 {
    --translate-x: -1194px; }
  .profile-themes-media-slot__crop-img.translate-x--1193 {
    --translate-x: -1193px; }
  .profile-themes-media-slot__crop-img.translate-x--1192 {
    --translate-x: -1192px; }
  .profile-themes-media-slot__crop-img.translate-x--1191 {
    --translate-x: -1191px; }
  .profile-themes-media-slot__crop-img.translate-x--1190 {
    --translate-x: -1190px; }
  .profile-themes-media-slot__crop-img.translate-x--1189 {
    --translate-x: -1189px; }
  .profile-themes-media-slot__crop-img.translate-x--1188 {
    --translate-x: -1188px; }
  .profile-themes-media-slot__crop-img.translate-x--1187 {
    --translate-x: -1187px; }
  .profile-themes-media-slot__crop-img.translate-x--1186 {
    --translate-x: -1186px; }
  .profile-themes-media-slot__crop-img.translate-x--1185 {
    --translate-x: -1185px; }
  .profile-themes-media-slot__crop-img.translate-x--1184 {
    --translate-x: -1184px; }
  .profile-themes-media-slot__crop-img.translate-x--1183 {
    --translate-x: -1183px; }
  .profile-themes-media-slot__crop-img.translate-x--1182 {
    --translate-x: -1182px; }
  .profile-themes-media-slot__crop-img.translate-x--1181 {
    --translate-x: -1181px; }
  .profile-themes-media-slot__crop-img.translate-x--1180 {
    --translate-x: -1180px; }
  .profile-themes-media-slot__crop-img.translate-x--1179 {
    --translate-x: -1179px; }
  .profile-themes-media-slot__crop-img.translate-x--1178 {
    --translate-x: -1178px; }
  .profile-themes-media-slot__crop-img.translate-x--1177 {
    --translate-x: -1177px; }
  .profile-themes-media-slot__crop-img.translate-x--1176 {
    --translate-x: -1176px; }
  .profile-themes-media-slot__crop-img.translate-x--1175 {
    --translate-x: -1175px; }
  .profile-themes-media-slot__crop-img.translate-x--1174 {
    --translate-x: -1174px; }
  .profile-themes-media-slot__crop-img.translate-x--1173 {
    --translate-x: -1173px; }
  .profile-themes-media-slot__crop-img.translate-x--1172 {
    --translate-x: -1172px; }
  .profile-themes-media-slot__crop-img.translate-x--1171 {
    --translate-x: -1171px; }
  .profile-themes-media-slot__crop-img.translate-x--1170 {
    --translate-x: -1170px; }
  .profile-themes-media-slot__crop-img.translate-x--1169 {
    --translate-x: -1169px; }
  .profile-themes-media-slot__crop-img.translate-x--1168 {
    --translate-x: -1168px; }
  .profile-themes-media-slot__crop-img.translate-x--1167 {
    --translate-x: -1167px; }
  .profile-themes-media-slot__crop-img.translate-x--1166 {
    --translate-x: -1166px; }
  .profile-themes-media-slot__crop-img.translate-x--1165 {
    --translate-x: -1165px; }
  .profile-themes-media-slot__crop-img.translate-x--1164 {
    --translate-x: -1164px; }
  .profile-themes-media-slot__crop-img.translate-x--1163 {
    --translate-x: -1163px; }
  .profile-themes-media-slot__crop-img.translate-x--1162 {
    --translate-x: -1162px; }
  .profile-themes-media-slot__crop-img.translate-x--1161 {
    --translate-x: -1161px; }
  .profile-themes-media-slot__crop-img.translate-x--1160 {
    --translate-x: -1160px; }
  .profile-themes-media-slot__crop-img.translate-x--1159 {
    --translate-x: -1159px; }
  .profile-themes-media-slot__crop-img.translate-x--1158 {
    --translate-x: -1158px; }
  .profile-themes-media-slot__crop-img.translate-x--1157 {
    --translate-x: -1157px; }
  .profile-themes-media-slot__crop-img.translate-x--1156 {
    --translate-x: -1156px; }
  .profile-themes-media-slot__crop-img.translate-x--1155 {
    --translate-x: -1155px; }
  .profile-themes-media-slot__crop-img.translate-x--1154 {
    --translate-x: -1154px; }
  .profile-themes-media-slot__crop-img.translate-x--1153 {
    --translate-x: -1153px; }
  .profile-themes-media-slot__crop-img.translate-x--1152 {
    --translate-x: -1152px; }
  .profile-themes-media-slot__crop-img.translate-x--1151 {
    --translate-x: -1151px; }
  .profile-themes-media-slot__crop-img.translate-x--1150 {
    --translate-x: -1150px; }
  .profile-themes-media-slot__crop-img.translate-x--1149 {
    --translate-x: -1149px; }
  .profile-themes-media-slot__crop-img.translate-x--1148 {
    --translate-x: -1148px; }
  .profile-themes-media-slot__crop-img.translate-x--1147 {
    --translate-x: -1147px; }
  .profile-themes-media-slot__crop-img.translate-x--1146 {
    --translate-x: -1146px; }
  .profile-themes-media-slot__crop-img.translate-x--1145 {
    --translate-x: -1145px; }
  .profile-themes-media-slot__crop-img.translate-x--1144 {
    --translate-x: -1144px; }
  .profile-themes-media-slot__crop-img.translate-x--1143 {
    --translate-x: -1143px; }
  .profile-themes-media-slot__crop-img.translate-x--1142 {
    --translate-x: -1142px; }
  .profile-themes-media-slot__crop-img.translate-x--1141 {
    --translate-x: -1141px; }
  .profile-themes-media-slot__crop-img.translate-x--1140 {
    --translate-x: -1140px; }
  .profile-themes-media-slot__crop-img.translate-x--1139 {
    --translate-x: -1139px; }
  .profile-themes-media-slot__crop-img.translate-x--1138 {
    --translate-x: -1138px; }
  .profile-themes-media-slot__crop-img.translate-x--1137 {
    --translate-x: -1137px; }
  .profile-themes-media-slot__crop-img.translate-x--1136 {
    --translate-x: -1136px; }
  .profile-themes-media-slot__crop-img.translate-x--1135 {
    --translate-x: -1135px; }
  .profile-themes-media-slot__crop-img.translate-x--1134 {
    --translate-x: -1134px; }
  .profile-themes-media-slot__crop-img.translate-x--1133 {
    --translate-x: -1133px; }
  .profile-themes-media-slot__crop-img.translate-x--1132 {
    --translate-x: -1132px; }
  .profile-themes-media-slot__crop-img.translate-x--1131 {
    --translate-x: -1131px; }
  .profile-themes-media-slot__crop-img.translate-x--1130 {
    --translate-x: -1130px; }
  .profile-themes-media-slot__crop-img.translate-x--1129 {
    --translate-x: -1129px; }
  .profile-themes-media-slot__crop-img.translate-x--1128 {
    --translate-x: -1128px; }
  .profile-themes-media-slot__crop-img.translate-x--1127 {
    --translate-x: -1127px; }
  .profile-themes-media-slot__crop-img.translate-x--1126 {
    --translate-x: -1126px; }
  .profile-themes-media-slot__crop-img.translate-x--1125 {
    --translate-x: -1125px; }
  .profile-themes-media-slot__crop-img.translate-x--1124 {
    --translate-x: -1124px; }
  .profile-themes-media-slot__crop-img.translate-x--1123 {
    --translate-x: -1123px; }
  .profile-themes-media-slot__crop-img.translate-x--1122 {
    --translate-x: -1122px; }
  .profile-themes-media-slot__crop-img.translate-x--1121 {
    --translate-x: -1121px; }
  .profile-themes-media-slot__crop-img.translate-x--1120 {
    --translate-x: -1120px; }
  .profile-themes-media-slot__crop-img.translate-x--1119 {
    --translate-x: -1119px; }
  .profile-themes-media-slot__crop-img.translate-x--1118 {
    --translate-x: -1118px; }
  .profile-themes-media-slot__crop-img.translate-x--1117 {
    --translate-x: -1117px; }
  .profile-themes-media-slot__crop-img.translate-x--1116 {
    --translate-x: -1116px; }
  .profile-themes-media-slot__crop-img.translate-x--1115 {
    --translate-x: -1115px; }
  .profile-themes-media-slot__crop-img.translate-x--1114 {
    --translate-x: -1114px; }
  .profile-themes-media-slot__crop-img.translate-x--1113 {
    --translate-x: -1113px; }
  .profile-themes-media-slot__crop-img.translate-x--1112 {
    --translate-x: -1112px; }
  .profile-themes-media-slot__crop-img.translate-x--1111 {
    --translate-x: -1111px; }
  .profile-themes-media-slot__crop-img.translate-x--1110 {
    --translate-x: -1110px; }
  .profile-themes-media-slot__crop-img.translate-x--1109 {
    --translate-x: -1109px; }
  .profile-themes-media-slot__crop-img.translate-x--1108 {
    --translate-x: -1108px; }
  .profile-themes-media-slot__crop-img.translate-x--1107 {
    --translate-x: -1107px; }
  .profile-themes-media-slot__crop-img.translate-x--1106 {
    --translate-x: -1106px; }
  .profile-themes-media-slot__crop-img.translate-x--1105 {
    --translate-x: -1105px; }
  .profile-themes-media-slot__crop-img.translate-x--1104 {
    --translate-x: -1104px; }
  .profile-themes-media-slot__crop-img.translate-x--1103 {
    --translate-x: -1103px; }
  .profile-themes-media-slot__crop-img.translate-x--1102 {
    --translate-x: -1102px; }
  .profile-themes-media-slot__crop-img.translate-x--1101 {
    --translate-x: -1101px; }
  .profile-themes-media-slot__crop-img.translate-x--1100 {
    --translate-x: -1100px; }
  .profile-themes-media-slot__crop-img.translate-x--1099 {
    --translate-x: -1099px; }
  .profile-themes-media-slot__crop-img.translate-x--1098 {
    --translate-x: -1098px; }
  .profile-themes-media-slot__crop-img.translate-x--1097 {
    --translate-x: -1097px; }
  .profile-themes-media-slot__crop-img.translate-x--1096 {
    --translate-x: -1096px; }
  .profile-themes-media-slot__crop-img.translate-x--1095 {
    --translate-x: -1095px; }
  .profile-themes-media-slot__crop-img.translate-x--1094 {
    --translate-x: -1094px; }
  .profile-themes-media-slot__crop-img.translate-x--1093 {
    --translate-x: -1093px; }
  .profile-themes-media-slot__crop-img.translate-x--1092 {
    --translate-x: -1092px; }
  .profile-themes-media-slot__crop-img.translate-x--1091 {
    --translate-x: -1091px; }
  .profile-themes-media-slot__crop-img.translate-x--1090 {
    --translate-x: -1090px; }
  .profile-themes-media-slot__crop-img.translate-x--1089 {
    --translate-x: -1089px; }
  .profile-themes-media-slot__crop-img.translate-x--1088 {
    --translate-x: -1088px; }
  .profile-themes-media-slot__crop-img.translate-x--1087 {
    --translate-x: -1087px; }
  .profile-themes-media-slot__crop-img.translate-x--1086 {
    --translate-x: -1086px; }
  .profile-themes-media-slot__crop-img.translate-x--1085 {
    --translate-x: -1085px; }
  .profile-themes-media-slot__crop-img.translate-x--1084 {
    --translate-x: -1084px; }
  .profile-themes-media-slot__crop-img.translate-x--1083 {
    --translate-x: -1083px; }
  .profile-themes-media-slot__crop-img.translate-x--1082 {
    --translate-x: -1082px; }
  .profile-themes-media-slot__crop-img.translate-x--1081 {
    --translate-x: -1081px; }
  .profile-themes-media-slot__crop-img.translate-x--1080 {
    --translate-x: -1080px; }
  .profile-themes-media-slot__crop-img.translate-x--1079 {
    --translate-x: -1079px; }
  .profile-themes-media-slot__crop-img.translate-x--1078 {
    --translate-x: -1078px; }
  .profile-themes-media-slot__crop-img.translate-x--1077 {
    --translate-x: -1077px; }
  .profile-themes-media-slot__crop-img.translate-x--1076 {
    --translate-x: -1076px; }
  .profile-themes-media-slot__crop-img.translate-x--1075 {
    --translate-x: -1075px; }
  .profile-themes-media-slot__crop-img.translate-x--1074 {
    --translate-x: -1074px; }
  .profile-themes-media-slot__crop-img.translate-x--1073 {
    --translate-x: -1073px; }
  .profile-themes-media-slot__crop-img.translate-x--1072 {
    --translate-x: -1072px; }
  .profile-themes-media-slot__crop-img.translate-x--1071 {
    --translate-x: -1071px; }
  .profile-themes-media-slot__crop-img.translate-x--1070 {
    --translate-x: -1070px; }
  .profile-themes-media-slot__crop-img.translate-x--1069 {
    --translate-x: -1069px; }
  .profile-themes-media-slot__crop-img.translate-x--1068 {
    --translate-x: -1068px; }
  .profile-themes-media-slot__crop-img.translate-x--1067 {
    --translate-x: -1067px; }
  .profile-themes-media-slot__crop-img.translate-x--1066 {
    --translate-x: -1066px; }
  .profile-themes-media-slot__crop-img.translate-x--1065 {
    --translate-x: -1065px; }
  .profile-themes-media-slot__crop-img.translate-x--1064 {
    --translate-x: -1064px; }
  .profile-themes-media-slot__crop-img.translate-x--1063 {
    --translate-x: -1063px; }
  .profile-themes-media-slot__crop-img.translate-x--1062 {
    --translate-x: -1062px; }
  .profile-themes-media-slot__crop-img.translate-x--1061 {
    --translate-x: -1061px; }
  .profile-themes-media-slot__crop-img.translate-x--1060 {
    --translate-x: -1060px; }
  .profile-themes-media-slot__crop-img.translate-x--1059 {
    --translate-x: -1059px; }
  .profile-themes-media-slot__crop-img.translate-x--1058 {
    --translate-x: -1058px; }
  .profile-themes-media-slot__crop-img.translate-x--1057 {
    --translate-x: -1057px; }
  .profile-themes-media-slot__crop-img.translate-x--1056 {
    --translate-x: -1056px; }
  .profile-themes-media-slot__crop-img.translate-x--1055 {
    --translate-x: -1055px; }
  .profile-themes-media-slot__crop-img.translate-x--1054 {
    --translate-x: -1054px; }
  .profile-themes-media-slot__crop-img.translate-x--1053 {
    --translate-x: -1053px; }
  .profile-themes-media-slot__crop-img.translate-x--1052 {
    --translate-x: -1052px; }
  .profile-themes-media-slot__crop-img.translate-x--1051 {
    --translate-x: -1051px; }
  .profile-themes-media-slot__crop-img.translate-x--1050 {
    --translate-x: -1050px; }
  .profile-themes-media-slot__crop-img.translate-x--1049 {
    --translate-x: -1049px; }
  .profile-themes-media-slot__crop-img.translate-x--1048 {
    --translate-x: -1048px; }
  .profile-themes-media-slot__crop-img.translate-x--1047 {
    --translate-x: -1047px; }
  .profile-themes-media-slot__crop-img.translate-x--1046 {
    --translate-x: -1046px; }
  .profile-themes-media-slot__crop-img.translate-x--1045 {
    --translate-x: -1045px; }
  .profile-themes-media-slot__crop-img.translate-x--1044 {
    --translate-x: -1044px; }
  .profile-themes-media-slot__crop-img.translate-x--1043 {
    --translate-x: -1043px; }
  .profile-themes-media-slot__crop-img.translate-x--1042 {
    --translate-x: -1042px; }
  .profile-themes-media-slot__crop-img.translate-x--1041 {
    --translate-x: -1041px; }
  .profile-themes-media-slot__crop-img.translate-x--1040 {
    --translate-x: -1040px; }
  .profile-themes-media-slot__crop-img.translate-x--1039 {
    --translate-x: -1039px; }
  .profile-themes-media-slot__crop-img.translate-x--1038 {
    --translate-x: -1038px; }
  .profile-themes-media-slot__crop-img.translate-x--1037 {
    --translate-x: -1037px; }
  .profile-themes-media-slot__crop-img.translate-x--1036 {
    --translate-x: -1036px; }
  .profile-themes-media-slot__crop-img.translate-x--1035 {
    --translate-x: -1035px; }
  .profile-themes-media-slot__crop-img.translate-x--1034 {
    --translate-x: -1034px; }
  .profile-themes-media-slot__crop-img.translate-x--1033 {
    --translate-x: -1033px; }
  .profile-themes-media-slot__crop-img.translate-x--1032 {
    --translate-x: -1032px; }
  .profile-themes-media-slot__crop-img.translate-x--1031 {
    --translate-x: -1031px; }
  .profile-themes-media-slot__crop-img.translate-x--1030 {
    --translate-x: -1030px; }
  .profile-themes-media-slot__crop-img.translate-x--1029 {
    --translate-x: -1029px; }
  .profile-themes-media-slot__crop-img.translate-x--1028 {
    --translate-x: -1028px; }
  .profile-themes-media-slot__crop-img.translate-x--1027 {
    --translate-x: -1027px; }
  .profile-themes-media-slot__crop-img.translate-x--1026 {
    --translate-x: -1026px; }
  .profile-themes-media-slot__crop-img.translate-x--1025 {
    --translate-x: -1025px; }
  .profile-themes-media-slot__crop-img.translate-x--1024 {
    --translate-x: -1024px; }
  .profile-themes-media-slot__crop-img.translate-x--1023 {
    --translate-x: -1023px; }
  .profile-themes-media-slot__crop-img.translate-x--1022 {
    --translate-x: -1022px; }
  .profile-themes-media-slot__crop-img.translate-x--1021 {
    --translate-x: -1021px; }
  .profile-themes-media-slot__crop-img.translate-x--1020 {
    --translate-x: -1020px; }
  .profile-themes-media-slot__crop-img.translate-x--1019 {
    --translate-x: -1019px; }
  .profile-themes-media-slot__crop-img.translate-x--1018 {
    --translate-x: -1018px; }
  .profile-themes-media-slot__crop-img.translate-x--1017 {
    --translate-x: -1017px; }
  .profile-themes-media-slot__crop-img.translate-x--1016 {
    --translate-x: -1016px; }
  .profile-themes-media-slot__crop-img.translate-x--1015 {
    --translate-x: -1015px; }
  .profile-themes-media-slot__crop-img.translate-x--1014 {
    --translate-x: -1014px; }
  .profile-themes-media-slot__crop-img.translate-x--1013 {
    --translate-x: -1013px; }
  .profile-themes-media-slot__crop-img.translate-x--1012 {
    --translate-x: -1012px; }
  .profile-themes-media-slot__crop-img.translate-x--1011 {
    --translate-x: -1011px; }
  .profile-themes-media-slot__crop-img.translate-x--1010 {
    --translate-x: -1010px; }
  .profile-themes-media-slot__crop-img.translate-x--1009 {
    --translate-x: -1009px; }
  .profile-themes-media-slot__crop-img.translate-x--1008 {
    --translate-x: -1008px; }
  .profile-themes-media-slot__crop-img.translate-x--1007 {
    --translate-x: -1007px; }
  .profile-themes-media-slot__crop-img.translate-x--1006 {
    --translate-x: -1006px; }
  .profile-themes-media-slot__crop-img.translate-x--1005 {
    --translate-x: -1005px; }
  .profile-themes-media-slot__crop-img.translate-x--1004 {
    --translate-x: -1004px; }
  .profile-themes-media-slot__crop-img.translate-x--1003 {
    --translate-x: -1003px; }
  .profile-themes-media-slot__crop-img.translate-x--1002 {
    --translate-x: -1002px; }
  .profile-themes-media-slot__crop-img.translate-x--1001 {
    --translate-x: -1001px; }
  .profile-themes-media-slot__crop-img.translate-x--1000 {
    --translate-x: -1000px; }
  .profile-themes-media-slot__crop-img.translate-x--999 {
    --translate-x: -999px; }
  .profile-themes-media-slot__crop-img.translate-x--998 {
    --translate-x: -998px; }
  .profile-themes-media-slot__crop-img.translate-x--997 {
    --translate-x: -997px; }
  .profile-themes-media-slot__crop-img.translate-x--996 {
    --translate-x: -996px; }
  .profile-themes-media-slot__crop-img.translate-x--995 {
    --translate-x: -995px; }
  .profile-themes-media-slot__crop-img.translate-x--994 {
    --translate-x: -994px; }
  .profile-themes-media-slot__crop-img.translate-x--993 {
    --translate-x: -993px; }
  .profile-themes-media-slot__crop-img.translate-x--992 {
    --translate-x: -992px; }
  .profile-themes-media-slot__crop-img.translate-x--991 {
    --translate-x: -991px; }
  .profile-themes-media-slot__crop-img.translate-x--990 {
    --translate-x: -990px; }
  .profile-themes-media-slot__crop-img.translate-x--989 {
    --translate-x: -989px; }
  .profile-themes-media-slot__crop-img.translate-x--988 {
    --translate-x: -988px; }
  .profile-themes-media-slot__crop-img.translate-x--987 {
    --translate-x: -987px; }
  .profile-themes-media-slot__crop-img.translate-x--986 {
    --translate-x: -986px; }
  .profile-themes-media-slot__crop-img.translate-x--985 {
    --translate-x: -985px; }
  .profile-themes-media-slot__crop-img.translate-x--984 {
    --translate-x: -984px; }
  .profile-themes-media-slot__crop-img.translate-x--983 {
    --translate-x: -983px; }
  .profile-themes-media-slot__crop-img.translate-x--982 {
    --translate-x: -982px; }
  .profile-themes-media-slot__crop-img.translate-x--981 {
    --translate-x: -981px; }
  .profile-themes-media-slot__crop-img.translate-x--980 {
    --translate-x: -980px; }
  .profile-themes-media-slot__crop-img.translate-x--979 {
    --translate-x: -979px; }
  .profile-themes-media-slot__crop-img.translate-x--978 {
    --translate-x: -978px; }
  .profile-themes-media-slot__crop-img.translate-x--977 {
    --translate-x: -977px; }
  .profile-themes-media-slot__crop-img.translate-x--976 {
    --translate-x: -976px; }
  .profile-themes-media-slot__crop-img.translate-x--975 {
    --translate-x: -975px; }
  .profile-themes-media-slot__crop-img.translate-x--974 {
    --translate-x: -974px; }
  .profile-themes-media-slot__crop-img.translate-x--973 {
    --translate-x: -973px; }
  .profile-themes-media-slot__crop-img.translate-x--972 {
    --translate-x: -972px; }
  .profile-themes-media-slot__crop-img.translate-x--971 {
    --translate-x: -971px; }
  .profile-themes-media-slot__crop-img.translate-x--970 {
    --translate-x: -970px; }
  .profile-themes-media-slot__crop-img.translate-x--969 {
    --translate-x: -969px; }
  .profile-themes-media-slot__crop-img.translate-x--968 {
    --translate-x: -968px; }
  .profile-themes-media-slot__crop-img.translate-x--967 {
    --translate-x: -967px; }
  .profile-themes-media-slot__crop-img.translate-x--966 {
    --translate-x: -966px; }
  .profile-themes-media-slot__crop-img.translate-x--965 {
    --translate-x: -965px; }
  .profile-themes-media-slot__crop-img.translate-x--964 {
    --translate-x: -964px; }
  .profile-themes-media-slot__crop-img.translate-x--963 {
    --translate-x: -963px; }
  .profile-themes-media-slot__crop-img.translate-x--962 {
    --translate-x: -962px; }
  .profile-themes-media-slot__crop-img.translate-x--961 {
    --translate-x: -961px; }
  .profile-themes-media-slot__crop-img.translate-x--960 {
    --translate-x: -960px; }
  .profile-themes-media-slot__crop-img.translate-x--959 {
    --translate-x: -959px; }
  .profile-themes-media-slot__crop-img.translate-x--958 {
    --translate-x: -958px; }
  .profile-themes-media-slot__crop-img.translate-x--957 {
    --translate-x: -957px; }
  .profile-themes-media-slot__crop-img.translate-x--956 {
    --translate-x: -956px; }
  .profile-themes-media-slot__crop-img.translate-x--955 {
    --translate-x: -955px; }
  .profile-themes-media-slot__crop-img.translate-x--954 {
    --translate-x: -954px; }
  .profile-themes-media-slot__crop-img.translate-x--953 {
    --translate-x: -953px; }
  .profile-themes-media-slot__crop-img.translate-x--952 {
    --translate-x: -952px; }
  .profile-themes-media-slot__crop-img.translate-x--951 {
    --translate-x: -951px; }
  .profile-themes-media-slot__crop-img.translate-x--950 {
    --translate-x: -950px; }
  .profile-themes-media-slot__crop-img.translate-x--949 {
    --translate-x: -949px; }
  .profile-themes-media-slot__crop-img.translate-x--948 {
    --translate-x: -948px; }
  .profile-themes-media-slot__crop-img.translate-x--947 {
    --translate-x: -947px; }
  .profile-themes-media-slot__crop-img.translate-x--946 {
    --translate-x: -946px; }
  .profile-themes-media-slot__crop-img.translate-x--945 {
    --translate-x: -945px; }
  .profile-themes-media-slot__crop-img.translate-x--944 {
    --translate-x: -944px; }
  .profile-themes-media-slot__crop-img.translate-x--943 {
    --translate-x: -943px; }
  .profile-themes-media-slot__crop-img.translate-x--942 {
    --translate-x: -942px; }
  .profile-themes-media-slot__crop-img.translate-x--941 {
    --translate-x: -941px; }
  .profile-themes-media-slot__crop-img.translate-x--940 {
    --translate-x: -940px; }
  .profile-themes-media-slot__crop-img.translate-x--939 {
    --translate-x: -939px; }
  .profile-themes-media-slot__crop-img.translate-x--938 {
    --translate-x: -938px; }
  .profile-themes-media-slot__crop-img.translate-x--937 {
    --translate-x: -937px; }
  .profile-themes-media-slot__crop-img.translate-x--936 {
    --translate-x: -936px; }
  .profile-themes-media-slot__crop-img.translate-x--935 {
    --translate-x: -935px; }
  .profile-themes-media-slot__crop-img.translate-x--934 {
    --translate-x: -934px; }
  .profile-themes-media-slot__crop-img.translate-x--933 {
    --translate-x: -933px; }
  .profile-themes-media-slot__crop-img.translate-x--932 {
    --translate-x: -932px; }
  .profile-themes-media-slot__crop-img.translate-x--931 {
    --translate-x: -931px; }
  .profile-themes-media-slot__crop-img.translate-x--930 {
    --translate-x: -930px; }
  .profile-themes-media-slot__crop-img.translate-x--929 {
    --translate-x: -929px; }
  .profile-themes-media-slot__crop-img.translate-x--928 {
    --translate-x: -928px; }
  .profile-themes-media-slot__crop-img.translate-x--927 {
    --translate-x: -927px; }
  .profile-themes-media-slot__crop-img.translate-x--926 {
    --translate-x: -926px; }
  .profile-themes-media-slot__crop-img.translate-x--925 {
    --translate-x: -925px; }
  .profile-themes-media-slot__crop-img.translate-x--924 {
    --translate-x: -924px; }
  .profile-themes-media-slot__crop-img.translate-x--923 {
    --translate-x: -923px; }
  .profile-themes-media-slot__crop-img.translate-x--922 {
    --translate-x: -922px; }
  .profile-themes-media-slot__crop-img.translate-x--921 {
    --translate-x: -921px; }
  .profile-themes-media-slot__crop-img.translate-x--920 {
    --translate-x: -920px; }
  .profile-themes-media-slot__crop-img.translate-x--919 {
    --translate-x: -919px; }
  .profile-themes-media-slot__crop-img.translate-x--918 {
    --translate-x: -918px; }
  .profile-themes-media-slot__crop-img.translate-x--917 {
    --translate-x: -917px; }
  .profile-themes-media-slot__crop-img.translate-x--916 {
    --translate-x: -916px; }
  .profile-themes-media-slot__crop-img.translate-x--915 {
    --translate-x: -915px; }
  .profile-themes-media-slot__crop-img.translate-x--914 {
    --translate-x: -914px; }
  .profile-themes-media-slot__crop-img.translate-x--913 {
    --translate-x: -913px; }
  .profile-themes-media-slot__crop-img.translate-x--912 {
    --translate-x: -912px; }
  .profile-themes-media-slot__crop-img.translate-x--911 {
    --translate-x: -911px; }
  .profile-themes-media-slot__crop-img.translate-x--910 {
    --translate-x: -910px; }
  .profile-themes-media-slot__crop-img.translate-x--909 {
    --translate-x: -909px; }
  .profile-themes-media-slot__crop-img.translate-x--908 {
    --translate-x: -908px; }
  .profile-themes-media-slot__crop-img.translate-x--907 {
    --translate-x: -907px; }
  .profile-themes-media-slot__crop-img.translate-x--906 {
    --translate-x: -906px; }
  .profile-themes-media-slot__crop-img.translate-x--905 {
    --translate-x: -905px; }
  .profile-themes-media-slot__crop-img.translate-x--904 {
    --translate-x: -904px; }
  .profile-themes-media-slot__crop-img.translate-x--903 {
    --translate-x: -903px; }
  .profile-themes-media-slot__crop-img.translate-x--902 {
    --translate-x: -902px; }
  .profile-themes-media-slot__crop-img.translate-x--901 {
    --translate-x: -901px; }
  .profile-themes-media-slot__crop-img.translate-x--900 {
    --translate-x: -900px; }
  .profile-themes-media-slot__crop-img.translate-x--899 {
    --translate-x: -899px; }
  .profile-themes-media-slot__crop-img.translate-x--898 {
    --translate-x: -898px; }
  .profile-themes-media-slot__crop-img.translate-x--897 {
    --translate-x: -897px; }
  .profile-themes-media-slot__crop-img.translate-x--896 {
    --translate-x: -896px; }
  .profile-themes-media-slot__crop-img.translate-x--895 {
    --translate-x: -895px; }
  .profile-themes-media-slot__crop-img.translate-x--894 {
    --translate-x: -894px; }
  .profile-themes-media-slot__crop-img.translate-x--893 {
    --translate-x: -893px; }
  .profile-themes-media-slot__crop-img.translate-x--892 {
    --translate-x: -892px; }
  .profile-themes-media-slot__crop-img.translate-x--891 {
    --translate-x: -891px; }
  .profile-themes-media-slot__crop-img.translate-x--890 {
    --translate-x: -890px; }
  .profile-themes-media-slot__crop-img.translate-x--889 {
    --translate-x: -889px; }
  .profile-themes-media-slot__crop-img.translate-x--888 {
    --translate-x: -888px; }
  .profile-themes-media-slot__crop-img.translate-x--887 {
    --translate-x: -887px; }
  .profile-themes-media-slot__crop-img.translate-x--886 {
    --translate-x: -886px; }
  .profile-themes-media-slot__crop-img.translate-x--885 {
    --translate-x: -885px; }
  .profile-themes-media-slot__crop-img.translate-x--884 {
    --translate-x: -884px; }
  .profile-themes-media-slot__crop-img.translate-x--883 {
    --translate-x: -883px; }
  .profile-themes-media-slot__crop-img.translate-x--882 {
    --translate-x: -882px; }
  .profile-themes-media-slot__crop-img.translate-x--881 {
    --translate-x: -881px; }
  .profile-themes-media-slot__crop-img.translate-x--880 {
    --translate-x: -880px; }
  .profile-themes-media-slot__crop-img.translate-x--879 {
    --translate-x: -879px; }
  .profile-themes-media-slot__crop-img.translate-x--878 {
    --translate-x: -878px; }
  .profile-themes-media-slot__crop-img.translate-x--877 {
    --translate-x: -877px; }
  .profile-themes-media-slot__crop-img.translate-x--876 {
    --translate-x: -876px; }
  .profile-themes-media-slot__crop-img.translate-x--875 {
    --translate-x: -875px; }
  .profile-themes-media-slot__crop-img.translate-x--874 {
    --translate-x: -874px; }
  .profile-themes-media-slot__crop-img.translate-x--873 {
    --translate-x: -873px; }
  .profile-themes-media-slot__crop-img.translate-x--872 {
    --translate-x: -872px; }
  .profile-themes-media-slot__crop-img.translate-x--871 {
    --translate-x: -871px; }
  .profile-themes-media-slot__crop-img.translate-x--870 {
    --translate-x: -870px; }
  .profile-themes-media-slot__crop-img.translate-x--869 {
    --translate-x: -869px; }
  .profile-themes-media-slot__crop-img.translate-x--868 {
    --translate-x: -868px; }
  .profile-themes-media-slot__crop-img.translate-x--867 {
    --translate-x: -867px; }
  .profile-themes-media-slot__crop-img.translate-x--866 {
    --translate-x: -866px; }
  .profile-themes-media-slot__crop-img.translate-x--865 {
    --translate-x: -865px; }
  .profile-themes-media-slot__crop-img.translate-x--864 {
    --translate-x: -864px; }
  .profile-themes-media-slot__crop-img.translate-x--863 {
    --translate-x: -863px; }
  .profile-themes-media-slot__crop-img.translate-x--862 {
    --translate-x: -862px; }
  .profile-themes-media-slot__crop-img.translate-x--861 {
    --translate-x: -861px; }
  .profile-themes-media-slot__crop-img.translate-x--860 {
    --translate-x: -860px; }
  .profile-themes-media-slot__crop-img.translate-x--859 {
    --translate-x: -859px; }
  .profile-themes-media-slot__crop-img.translate-x--858 {
    --translate-x: -858px; }
  .profile-themes-media-slot__crop-img.translate-x--857 {
    --translate-x: -857px; }
  .profile-themes-media-slot__crop-img.translate-x--856 {
    --translate-x: -856px; }
  .profile-themes-media-slot__crop-img.translate-x--855 {
    --translate-x: -855px; }
  .profile-themes-media-slot__crop-img.translate-x--854 {
    --translate-x: -854px; }
  .profile-themes-media-slot__crop-img.translate-x--853 {
    --translate-x: -853px; }
  .profile-themes-media-slot__crop-img.translate-x--852 {
    --translate-x: -852px; }
  .profile-themes-media-slot__crop-img.translate-x--851 {
    --translate-x: -851px; }
  .profile-themes-media-slot__crop-img.translate-x--850 {
    --translate-x: -850px; }
  .profile-themes-media-slot__crop-img.translate-x--849 {
    --translate-x: -849px; }
  .profile-themes-media-slot__crop-img.translate-x--848 {
    --translate-x: -848px; }
  .profile-themes-media-slot__crop-img.translate-x--847 {
    --translate-x: -847px; }
  .profile-themes-media-slot__crop-img.translate-x--846 {
    --translate-x: -846px; }
  .profile-themes-media-slot__crop-img.translate-x--845 {
    --translate-x: -845px; }
  .profile-themes-media-slot__crop-img.translate-x--844 {
    --translate-x: -844px; }
  .profile-themes-media-slot__crop-img.translate-x--843 {
    --translate-x: -843px; }
  .profile-themes-media-slot__crop-img.translate-x--842 {
    --translate-x: -842px; }
  .profile-themes-media-slot__crop-img.translate-x--841 {
    --translate-x: -841px; }
  .profile-themes-media-slot__crop-img.translate-x--840 {
    --translate-x: -840px; }
  .profile-themes-media-slot__crop-img.translate-x--839 {
    --translate-x: -839px; }
  .profile-themes-media-slot__crop-img.translate-x--838 {
    --translate-x: -838px; }
  .profile-themes-media-slot__crop-img.translate-x--837 {
    --translate-x: -837px; }
  .profile-themes-media-slot__crop-img.translate-x--836 {
    --translate-x: -836px; }
  .profile-themes-media-slot__crop-img.translate-x--835 {
    --translate-x: -835px; }
  .profile-themes-media-slot__crop-img.translate-x--834 {
    --translate-x: -834px; }
  .profile-themes-media-slot__crop-img.translate-x--833 {
    --translate-x: -833px; }
  .profile-themes-media-slot__crop-img.translate-x--832 {
    --translate-x: -832px; }
  .profile-themes-media-slot__crop-img.translate-x--831 {
    --translate-x: -831px; }
  .profile-themes-media-slot__crop-img.translate-x--830 {
    --translate-x: -830px; }
  .profile-themes-media-slot__crop-img.translate-x--829 {
    --translate-x: -829px; }
  .profile-themes-media-slot__crop-img.translate-x--828 {
    --translate-x: -828px; }
  .profile-themes-media-slot__crop-img.translate-x--827 {
    --translate-x: -827px; }
  .profile-themes-media-slot__crop-img.translate-x--826 {
    --translate-x: -826px; }
  .profile-themes-media-slot__crop-img.translate-x--825 {
    --translate-x: -825px; }
  .profile-themes-media-slot__crop-img.translate-x--824 {
    --translate-x: -824px; }
  .profile-themes-media-slot__crop-img.translate-x--823 {
    --translate-x: -823px; }
  .profile-themes-media-slot__crop-img.translate-x--822 {
    --translate-x: -822px; }
  .profile-themes-media-slot__crop-img.translate-x--821 {
    --translate-x: -821px; }
  .profile-themes-media-slot__crop-img.translate-x--820 {
    --translate-x: -820px; }
  .profile-themes-media-slot__crop-img.translate-x--819 {
    --translate-x: -819px; }
  .profile-themes-media-slot__crop-img.translate-x--818 {
    --translate-x: -818px; }
  .profile-themes-media-slot__crop-img.translate-x--817 {
    --translate-x: -817px; }
  .profile-themes-media-slot__crop-img.translate-x--816 {
    --translate-x: -816px; }
  .profile-themes-media-slot__crop-img.translate-x--815 {
    --translate-x: -815px; }
  .profile-themes-media-slot__crop-img.translate-x--814 {
    --translate-x: -814px; }
  .profile-themes-media-slot__crop-img.translate-x--813 {
    --translate-x: -813px; }
  .profile-themes-media-slot__crop-img.translate-x--812 {
    --translate-x: -812px; }
  .profile-themes-media-slot__crop-img.translate-x--811 {
    --translate-x: -811px; }
  .profile-themes-media-slot__crop-img.translate-x--810 {
    --translate-x: -810px; }
  .profile-themes-media-slot__crop-img.translate-x--809 {
    --translate-x: -809px; }
  .profile-themes-media-slot__crop-img.translate-x--808 {
    --translate-x: -808px; }
  .profile-themes-media-slot__crop-img.translate-x--807 {
    --translate-x: -807px; }
  .profile-themes-media-slot__crop-img.translate-x--806 {
    --translate-x: -806px; }
  .profile-themes-media-slot__crop-img.translate-x--805 {
    --translate-x: -805px; }
  .profile-themes-media-slot__crop-img.translate-x--804 {
    --translate-x: -804px; }
  .profile-themes-media-slot__crop-img.translate-x--803 {
    --translate-x: -803px; }
  .profile-themes-media-slot__crop-img.translate-x--802 {
    --translate-x: -802px; }
  .profile-themes-media-slot__crop-img.translate-x--801 {
    --translate-x: -801px; }
  .profile-themes-media-slot__crop-img.translate-x--800 {
    --translate-x: -800px; }
  .profile-themes-media-slot__crop-img.translate-x--799 {
    --translate-x: -799px; }
  .profile-themes-media-slot__crop-img.translate-x--798 {
    --translate-x: -798px; }
  .profile-themes-media-slot__crop-img.translate-x--797 {
    --translate-x: -797px; }
  .profile-themes-media-slot__crop-img.translate-x--796 {
    --translate-x: -796px; }
  .profile-themes-media-slot__crop-img.translate-x--795 {
    --translate-x: -795px; }
  .profile-themes-media-slot__crop-img.translate-x--794 {
    --translate-x: -794px; }
  .profile-themes-media-slot__crop-img.translate-x--793 {
    --translate-x: -793px; }
  .profile-themes-media-slot__crop-img.translate-x--792 {
    --translate-x: -792px; }
  .profile-themes-media-slot__crop-img.translate-x--791 {
    --translate-x: -791px; }
  .profile-themes-media-slot__crop-img.translate-x--790 {
    --translate-x: -790px; }
  .profile-themes-media-slot__crop-img.translate-x--789 {
    --translate-x: -789px; }
  .profile-themes-media-slot__crop-img.translate-x--788 {
    --translate-x: -788px; }
  .profile-themes-media-slot__crop-img.translate-x--787 {
    --translate-x: -787px; }
  .profile-themes-media-slot__crop-img.translate-x--786 {
    --translate-x: -786px; }
  .profile-themes-media-slot__crop-img.translate-x--785 {
    --translate-x: -785px; }
  .profile-themes-media-slot__crop-img.translate-x--784 {
    --translate-x: -784px; }
  .profile-themes-media-slot__crop-img.translate-x--783 {
    --translate-x: -783px; }
  .profile-themes-media-slot__crop-img.translate-x--782 {
    --translate-x: -782px; }
  .profile-themes-media-slot__crop-img.translate-x--781 {
    --translate-x: -781px; }
  .profile-themes-media-slot__crop-img.translate-x--780 {
    --translate-x: -780px; }
  .profile-themes-media-slot__crop-img.translate-x--779 {
    --translate-x: -779px; }
  .profile-themes-media-slot__crop-img.translate-x--778 {
    --translate-x: -778px; }
  .profile-themes-media-slot__crop-img.translate-x--777 {
    --translate-x: -777px; }
  .profile-themes-media-slot__crop-img.translate-x--776 {
    --translate-x: -776px; }
  .profile-themes-media-slot__crop-img.translate-x--775 {
    --translate-x: -775px; }
  .profile-themes-media-slot__crop-img.translate-x--774 {
    --translate-x: -774px; }
  .profile-themes-media-slot__crop-img.translate-x--773 {
    --translate-x: -773px; }
  .profile-themes-media-slot__crop-img.translate-x--772 {
    --translate-x: -772px; }
  .profile-themes-media-slot__crop-img.translate-x--771 {
    --translate-x: -771px; }
  .profile-themes-media-slot__crop-img.translate-x--770 {
    --translate-x: -770px; }
  .profile-themes-media-slot__crop-img.translate-x--769 {
    --translate-x: -769px; }
  .profile-themes-media-slot__crop-img.translate-x--768 {
    --translate-x: -768px; }
  .profile-themes-media-slot__crop-img.translate-x--767 {
    --translate-x: -767px; }
  .profile-themes-media-slot__crop-img.translate-x--766 {
    --translate-x: -766px; }
  .profile-themes-media-slot__crop-img.translate-x--765 {
    --translate-x: -765px; }
  .profile-themes-media-slot__crop-img.translate-x--764 {
    --translate-x: -764px; }
  .profile-themes-media-slot__crop-img.translate-x--763 {
    --translate-x: -763px; }
  .profile-themes-media-slot__crop-img.translate-x--762 {
    --translate-x: -762px; }
  .profile-themes-media-slot__crop-img.translate-x--761 {
    --translate-x: -761px; }
  .profile-themes-media-slot__crop-img.translate-x--760 {
    --translate-x: -760px; }
  .profile-themes-media-slot__crop-img.translate-x--759 {
    --translate-x: -759px; }
  .profile-themes-media-slot__crop-img.translate-x--758 {
    --translate-x: -758px; }
  .profile-themes-media-slot__crop-img.translate-x--757 {
    --translate-x: -757px; }
  .profile-themes-media-slot__crop-img.translate-x--756 {
    --translate-x: -756px; }
  .profile-themes-media-slot__crop-img.translate-x--755 {
    --translate-x: -755px; }
  .profile-themes-media-slot__crop-img.translate-x--754 {
    --translate-x: -754px; }
  .profile-themes-media-slot__crop-img.translate-x--753 {
    --translate-x: -753px; }
  .profile-themes-media-slot__crop-img.translate-x--752 {
    --translate-x: -752px; }
  .profile-themes-media-slot__crop-img.translate-x--751 {
    --translate-x: -751px; }
  .profile-themes-media-slot__crop-img.translate-x--750 {
    --translate-x: -750px; }
  .profile-themes-media-slot__crop-img.translate-x--749 {
    --translate-x: -749px; }
  .profile-themes-media-slot__crop-img.translate-x--748 {
    --translate-x: -748px; }
  .profile-themes-media-slot__crop-img.translate-x--747 {
    --translate-x: -747px; }
  .profile-themes-media-slot__crop-img.translate-x--746 {
    --translate-x: -746px; }
  .profile-themes-media-slot__crop-img.translate-x--745 {
    --translate-x: -745px; }
  .profile-themes-media-slot__crop-img.translate-x--744 {
    --translate-x: -744px; }
  .profile-themes-media-slot__crop-img.translate-x--743 {
    --translate-x: -743px; }
  .profile-themes-media-slot__crop-img.translate-x--742 {
    --translate-x: -742px; }
  .profile-themes-media-slot__crop-img.translate-x--741 {
    --translate-x: -741px; }
  .profile-themes-media-slot__crop-img.translate-x--740 {
    --translate-x: -740px; }
  .profile-themes-media-slot__crop-img.translate-x--739 {
    --translate-x: -739px; }
  .profile-themes-media-slot__crop-img.translate-x--738 {
    --translate-x: -738px; }
  .profile-themes-media-slot__crop-img.translate-x--737 {
    --translate-x: -737px; }
  .profile-themes-media-slot__crop-img.translate-x--736 {
    --translate-x: -736px; }
  .profile-themes-media-slot__crop-img.translate-x--735 {
    --translate-x: -735px; }
  .profile-themes-media-slot__crop-img.translate-x--734 {
    --translate-x: -734px; }
  .profile-themes-media-slot__crop-img.translate-x--733 {
    --translate-x: -733px; }
  .profile-themes-media-slot__crop-img.translate-x--732 {
    --translate-x: -732px; }
  .profile-themes-media-slot__crop-img.translate-x--731 {
    --translate-x: -731px; }
  .profile-themes-media-slot__crop-img.translate-x--730 {
    --translate-x: -730px; }
  .profile-themes-media-slot__crop-img.translate-x--729 {
    --translate-x: -729px; }
  .profile-themes-media-slot__crop-img.translate-x--728 {
    --translate-x: -728px; }
  .profile-themes-media-slot__crop-img.translate-x--727 {
    --translate-x: -727px; }
  .profile-themes-media-slot__crop-img.translate-x--726 {
    --translate-x: -726px; }
  .profile-themes-media-slot__crop-img.translate-x--725 {
    --translate-x: -725px; }
  .profile-themes-media-slot__crop-img.translate-x--724 {
    --translate-x: -724px; }
  .profile-themes-media-slot__crop-img.translate-x--723 {
    --translate-x: -723px; }
  .profile-themes-media-slot__crop-img.translate-x--722 {
    --translate-x: -722px; }
  .profile-themes-media-slot__crop-img.translate-x--721 {
    --translate-x: -721px; }
  .profile-themes-media-slot__crop-img.translate-x--720 {
    --translate-x: -720px; }
  .profile-themes-media-slot__crop-img.translate-x--719 {
    --translate-x: -719px; }
  .profile-themes-media-slot__crop-img.translate-x--718 {
    --translate-x: -718px; }
  .profile-themes-media-slot__crop-img.translate-x--717 {
    --translate-x: -717px; }
  .profile-themes-media-slot__crop-img.translate-x--716 {
    --translate-x: -716px; }
  .profile-themes-media-slot__crop-img.translate-x--715 {
    --translate-x: -715px; }
  .profile-themes-media-slot__crop-img.translate-x--714 {
    --translate-x: -714px; }
  .profile-themes-media-slot__crop-img.translate-x--713 {
    --translate-x: -713px; }
  .profile-themes-media-slot__crop-img.translate-x--712 {
    --translate-x: -712px; }
  .profile-themes-media-slot__crop-img.translate-x--711 {
    --translate-x: -711px; }
  .profile-themes-media-slot__crop-img.translate-x--710 {
    --translate-x: -710px; }
  .profile-themes-media-slot__crop-img.translate-x--709 {
    --translate-x: -709px; }
  .profile-themes-media-slot__crop-img.translate-x--708 {
    --translate-x: -708px; }
  .profile-themes-media-slot__crop-img.translate-x--707 {
    --translate-x: -707px; }
  .profile-themes-media-slot__crop-img.translate-x--706 {
    --translate-x: -706px; }
  .profile-themes-media-slot__crop-img.translate-x--705 {
    --translate-x: -705px; }
  .profile-themes-media-slot__crop-img.translate-x--704 {
    --translate-x: -704px; }
  .profile-themes-media-slot__crop-img.translate-x--703 {
    --translate-x: -703px; }
  .profile-themes-media-slot__crop-img.translate-x--702 {
    --translate-x: -702px; }
  .profile-themes-media-slot__crop-img.translate-x--701 {
    --translate-x: -701px; }
  .profile-themes-media-slot__crop-img.translate-x--700 {
    --translate-x: -700px; }
  .profile-themes-media-slot__crop-img.translate-x--699 {
    --translate-x: -699px; }
  .profile-themes-media-slot__crop-img.translate-x--698 {
    --translate-x: -698px; }
  .profile-themes-media-slot__crop-img.translate-x--697 {
    --translate-x: -697px; }
  .profile-themes-media-slot__crop-img.translate-x--696 {
    --translate-x: -696px; }
  .profile-themes-media-slot__crop-img.translate-x--695 {
    --translate-x: -695px; }
  .profile-themes-media-slot__crop-img.translate-x--694 {
    --translate-x: -694px; }
  .profile-themes-media-slot__crop-img.translate-x--693 {
    --translate-x: -693px; }
  .profile-themes-media-slot__crop-img.translate-x--692 {
    --translate-x: -692px; }
  .profile-themes-media-slot__crop-img.translate-x--691 {
    --translate-x: -691px; }
  .profile-themes-media-slot__crop-img.translate-x--690 {
    --translate-x: -690px; }
  .profile-themes-media-slot__crop-img.translate-x--689 {
    --translate-x: -689px; }
  .profile-themes-media-slot__crop-img.translate-x--688 {
    --translate-x: -688px; }
  .profile-themes-media-slot__crop-img.translate-x--687 {
    --translate-x: -687px; }
  .profile-themes-media-slot__crop-img.translate-x--686 {
    --translate-x: -686px; }
  .profile-themes-media-slot__crop-img.translate-x--685 {
    --translate-x: -685px; }
  .profile-themes-media-slot__crop-img.translate-x--684 {
    --translate-x: -684px; }
  .profile-themes-media-slot__crop-img.translate-x--683 {
    --translate-x: -683px; }
  .profile-themes-media-slot__crop-img.translate-x--682 {
    --translate-x: -682px; }
  .profile-themes-media-slot__crop-img.translate-x--681 {
    --translate-x: -681px; }
  .profile-themes-media-slot__crop-img.translate-x--680 {
    --translate-x: -680px; }
  .profile-themes-media-slot__crop-img.translate-x--679 {
    --translate-x: -679px; }
  .profile-themes-media-slot__crop-img.translate-x--678 {
    --translate-x: -678px; }
  .profile-themes-media-slot__crop-img.translate-x--677 {
    --translate-x: -677px; }
  .profile-themes-media-slot__crop-img.translate-x--676 {
    --translate-x: -676px; }
  .profile-themes-media-slot__crop-img.translate-x--675 {
    --translate-x: -675px; }
  .profile-themes-media-slot__crop-img.translate-x--674 {
    --translate-x: -674px; }
  .profile-themes-media-slot__crop-img.translate-x--673 {
    --translate-x: -673px; }
  .profile-themes-media-slot__crop-img.translate-x--672 {
    --translate-x: -672px; }
  .profile-themes-media-slot__crop-img.translate-x--671 {
    --translate-x: -671px; }
  .profile-themes-media-slot__crop-img.translate-x--670 {
    --translate-x: -670px; }
  .profile-themes-media-slot__crop-img.translate-x--669 {
    --translate-x: -669px; }
  .profile-themes-media-slot__crop-img.translate-x--668 {
    --translate-x: -668px; }
  .profile-themes-media-slot__crop-img.translate-x--667 {
    --translate-x: -667px; }
  .profile-themes-media-slot__crop-img.translate-x--666 {
    --translate-x: -666px; }
  .profile-themes-media-slot__crop-img.translate-x--665 {
    --translate-x: -665px; }
  .profile-themes-media-slot__crop-img.translate-x--664 {
    --translate-x: -664px; }
  .profile-themes-media-slot__crop-img.translate-x--663 {
    --translate-x: -663px; }
  .profile-themes-media-slot__crop-img.translate-x--662 {
    --translate-x: -662px; }
  .profile-themes-media-slot__crop-img.translate-x--661 {
    --translate-x: -661px; }
  .profile-themes-media-slot__crop-img.translate-x--660 {
    --translate-x: -660px; }
  .profile-themes-media-slot__crop-img.translate-x--659 {
    --translate-x: -659px; }
  .profile-themes-media-slot__crop-img.translate-x--658 {
    --translate-x: -658px; }
  .profile-themes-media-slot__crop-img.translate-x--657 {
    --translate-x: -657px; }
  .profile-themes-media-slot__crop-img.translate-x--656 {
    --translate-x: -656px; }
  .profile-themes-media-slot__crop-img.translate-x--655 {
    --translate-x: -655px; }
  .profile-themes-media-slot__crop-img.translate-x--654 {
    --translate-x: -654px; }
  .profile-themes-media-slot__crop-img.translate-x--653 {
    --translate-x: -653px; }
  .profile-themes-media-slot__crop-img.translate-x--652 {
    --translate-x: -652px; }
  .profile-themes-media-slot__crop-img.translate-x--651 {
    --translate-x: -651px; }
  .profile-themes-media-slot__crop-img.translate-x--650 {
    --translate-x: -650px; }
  .profile-themes-media-slot__crop-img.translate-x--649 {
    --translate-x: -649px; }
  .profile-themes-media-slot__crop-img.translate-x--648 {
    --translate-x: -648px; }
  .profile-themes-media-slot__crop-img.translate-x--647 {
    --translate-x: -647px; }
  .profile-themes-media-slot__crop-img.translate-x--646 {
    --translate-x: -646px; }
  .profile-themes-media-slot__crop-img.translate-x--645 {
    --translate-x: -645px; }
  .profile-themes-media-slot__crop-img.translate-x--644 {
    --translate-x: -644px; }
  .profile-themes-media-slot__crop-img.translate-x--643 {
    --translate-x: -643px; }
  .profile-themes-media-slot__crop-img.translate-x--642 {
    --translate-x: -642px; }
  .profile-themes-media-slot__crop-img.translate-x--641 {
    --translate-x: -641px; }
  .profile-themes-media-slot__crop-img.translate-x--640 {
    --translate-x: -640px; }
  .profile-themes-media-slot__crop-img.translate-x--639 {
    --translate-x: -639px; }
  .profile-themes-media-slot__crop-img.translate-x--638 {
    --translate-x: -638px; }
  .profile-themes-media-slot__crop-img.translate-x--637 {
    --translate-x: -637px; }
  .profile-themes-media-slot__crop-img.translate-x--636 {
    --translate-x: -636px; }
  .profile-themes-media-slot__crop-img.translate-x--635 {
    --translate-x: -635px; }
  .profile-themes-media-slot__crop-img.translate-x--634 {
    --translate-x: -634px; }
  .profile-themes-media-slot__crop-img.translate-x--633 {
    --translate-x: -633px; }
  .profile-themes-media-slot__crop-img.translate-x--632 {
    --translate-x: -632px; }
  .profile-themes-media-slot__crop-img.translate-x--631 {
    --translate-x: -631px; }
  .profile-themes-media-slot__crop-img.translate-x--630 {
    --translate-x: -630px; }
  .profile-themes-media-slot__crop-img.translate-x--629 {
    --translate-x: -629px; }
  .profile-themes-media-slot__crop-img.translate-x--628 {
    --translate-x: -628px; }
  .profile-themes-media-slot__crop-img.translate-x--627 {
    --translate-x: -627px; }
  .profile-themes-media-slot__crop-img.translate-x--626 {
    --translate-x: -626px; }
  .profile-themes-media-slot__crop-img.translate-x--625 {
    --translate-x: -625px; }
  .profile-themes-media-slot__crop-img.translate-x--624 {
    --translate-x: -624px; }
  .profile-themes-media-slot__crop-img.translate-x--623 {
    --translate-x: -623px; }
  .profile-themes-media-slot__crop-img.translate-x--622 {
    --translate-x: -622px; }
  .profile-themes-media-slot__crop-img.translate-x--621 {
    --translate-x: -621px; }
  .profile-themes-media-slot__crop-img.translate-x--620 {
    --translate-x: -620px; }
  .profile-themes-media-slot__crop-img.translate-x--619 {
    --translate-x: -619px; }
  .profile-themes-media-slot__crop-img.translate-x--618 {
    --translate-x: -618px; }
  .profile-themes-media-slot__crop-img.translate-x--617 {
    --translate-x: -617px; }
  .profile-themes-media-slot__crop-img.translate-x--616 {
    --translate-x: -616px; }
  .profile-themes-media-slot__crop-img.translate-x--615 {
    --translate-x: -615px; }
  .profile-themes-media-slot__crop-img.translate-x--614 {
    --translate-x: -614px; }
  .profile-themes-media-slot__crop-img.translate-x--613 {
    --translate-x: -613px; }
  .profile-themes-media-slot__crop-img.translate-x--612 {
    --translate-x: -612px; }
  .profile-themes-media-slot__crop-img.translate-x--611 {
    --translate-x: -611px; }
  .profile-themes-media-slot__crop-img.translate-x--610 {
    --translate-x: -610px; }
  .profile-themes-media-slot__crop-img.translate-x--609 {
    --translate-x: -609px; }
  .profile-themes-media-slot__crop-img.translate-x--608 {
    --translate-x: -608px; }
  .profile-themes-media-slot__crop-img.translate-x--607 {
    --translate-x: -607px; }
  .profile-themes-media-slot__crop-img.translate-x--606 {
    --translate-x: -606px; }
  .profile-themes-media-slot__crop-img.translate-x--605 {
    --translate-x: -605px; }
  .profile-themes-media-slot__crop-img.translate-x--604 {
    --translate-x: -604px; }
  .profile-themes-media-slot__crop-img.translate-x--603 {
    --translate-x: -603px; }
  .profile-themes-media-slot__crop-img.translate-x--602 {
    --translate-x: -602px; }
  .profile-themes-media-slot__crop-img.translate-x--601 {
    --translate-x: -601px; }
  .profile-themes-media-slot__crop-img.translate-x--600 {
    --translate-x: -600px; }
  .profile-themes-media-slot__crop-img.translate-x--599 {
    --translate-x: -599px; }
  .profile-themes-media-slot__crop-img.translate-x--598 {
    --translate-x: -598px; }
  .profile-themes-media-slot__crop-img.translate-x--597 {
    --translate-x: -597px; }
  .profile-themes-media-slot__crop-img.translate-x--596 {
    --translate-x: -596px; }
  .profile-themes-media-slot__crop-img.translate-x--595 {
    --translate-x: -595px; }
  .profile-themes-media-slot__crop-img.translate-x--594 {
    --translate-x: -594px; }
  .profile-themes-media-slot__crop-img.translate-x--593 {
    --translate-x: -593px; }
  .profile-themes-media-slot__crop-img.translate-x--592 {
    --translate-x: -592px; }
  .profile-themes-media-slot__crop-img.translate-x--591 {
    --translate-x: -591px; }
  .profile-themes-media-slot__crop-img.translate-x--590 {
    --translate-x: -590px; }
  .profile-themes-media-slot__crop-img.translate-x--589 {
    --translate-x: -589px; }
  .profile-themes-media-slot__crop-img.translate-x--588 {
    --translate-x: -588px; }
  .profile-themes-media-slot__crop-img.translate-x--587 {
    --translate-x: -587px; }
  .profile-themes-media-slot__crop-img.translate-x--586 {
    --translate-x: -586px; }
  .profile-themes-media-slot__crop-img.translate-x--585 {
    --translate-x: -585px; }
  .profile-themes-media-slot__crop-img.translate-x--584 {
    --translate-x: -584px; }
  .profile-themes-media-slot__crop-img.translate-x--583 {
    --translate-x: -583px; }
  .profile-themes-media-slot__crop-img.translate-x--582 {
    --translate-x: -582px; }
  .profile-themes-media-slot__crop-img.translate-x--581 {
    --translate-x: -581px; }
  .profile-themes-media-slot__crop-img.translate-x--580 {
    --translate-x: -580px; }
  .profile-themes-media-slot__crop-img.translate-x--579 {
    --translate-x: -579px; }
  .profile-themes-media-slot__crop-img.translate-x--578 {
    --translate-x: -578px; }
  .profile-themes-media-slot__crop-img.translate-x--577 {
    --translate-x: -577px; }
  .profile-themes-media-slot__crop-img.translate-x--576 {
    --translate-x: -576px; }
  .profile-themes-media-slot__crop-img.translate-x--575 {
    --translate-x: -575px; }
  .profile-themes-media-slot__crop-img.translate-x--574 {
    --translate-x: -574px; }
  .profile-themes-media-slot__crop-img.translate-x--573 {
    --translate-x: -573px; }
  .profile-themes-media-slot__crop-img.translate-x--572 {
    --translate-x: -572px; }
  .profile-themes-media-slot__crop-img.translate-x--571 {
    --translate-x: -571px; }
  .profile-themes-media-slot__crop-img.translate-x--570 {
    --translate-x: -570px; }
  .profile-themes-media-slot__crop-img.translate-x--569 {
    --translate-x: -569px; }
  .profile-themes-media-slot__crop-img.translate-x--568 {
    --translate-x: -568px; }
  .profile-themes-media-slot__crop-img.translate-x--567 {
    --translate-x: -567px; }
  .profile-themes-media-slot__crop-img.translate-x--566 {
    --translate-x: -566px; }
  .profile-themes-media-slot__crop-img.translate-x--565 {
    --translate-x: -565px; }
  .profile-themes-media-slot__crop-img.translate-x--564 {
    --translate-x: -564px; }
  .profile-themes-media-slot__crop-img.translate-x--563 {
    --translate-x: -563px; }
  .profile-themes-media-slot__crop-img.translate-x--562 {
    --translate-x: -562px; }
  .profile-themes-media-slot__crop-img.translate-x--561 {
    --translate-x: -561px; }
  .profile-themes-media-slot__crop-img.translate-x--560 {
    --translate-x: -560px; }
  .profile-themes-media-slot__crop-img.translate-x--559 {
    --translate-x: -559px; }
  .profile-themes-media-slot__crop-img.translate-x--558 {
    --translate-x: -558px; }
  .profile-themes-media-slot__crop-img.translate-x--557 {
    --translate-x: -557px; }
  .profile-themes-media-slot__crop-img.translate-x--556 {
    --translate-x: -556px; }
  .profile-themes-media-slot__crop-img.translate-x--555 {
    --translate-x: -555px; }
  .profile-themes-media-slot__crop-img.translate-x--554 {
    --translate-x: -554px; }
  .profile-themes-media-slot__crop-img.translate-x--553 {
    --translate-x: -553px; }
  .profile-themes-media-slot__crop-img.translate-x--552 {
    --translate-x: -552px; }
  .profile-themes-media-slot__crop-img.translate-x--551 {
    --translate-x: -551px; }
  .profile-themes-media-slot__crop-img.translate-x--550 {
    --translate-x: -550px; }
  .profile-themes-media-slot__crop-img.translate-x--549 {
    --translate-x: -549px; }
  .profile-themes-media-slot__crop-img.translate-x--548 {
    --translate-x: -548px; }
  .profile-themes-media-slot__crop-img.translate-x--547 {
    --translate-x: -547px; }
  .profile-themes-media-slot__crop-img.translate-x--546 {
    --translate-x: -546px; }
  .profile-themes-media-slot__crop-img.translate-x--545 {
    --translate-x: -545px; }
  .profile-themes-media-slot__crop-img.translate-x--544 {
    --translate-x: -544px; }
  .profile-themes-media-slot__crop-img.translate-x--543 {
    --translate-x: -543px; }
  .profile-themes-media-slot__crop-img.translate-x--542 {
    --translate-x: -542px; }
  .profile-themes-media-slot__crop-img.translate-x--541 {
    --translate-x: -541px; }
  .profile-themes-media-slot__crop-img.translate-x--540 {
    --translate-x: -540px; }
  .profile-themes-media-slot__crop-img.translate-x--539 {
    --translate-x: -539px; }
  .profile-themes-media-slot__crop-img.translate-x--538 {
    --translate-x: -538px; }
  .profile-themes-media-slot__crop-img.translate-x--537 {
    --translate-x: -537px; }
  .profile-themes-media-slot__crop-img.translate-x--536 {
    --translate-x: -536px; }
  .profile-themes-media-slot__crop-img.translate-x--535 {
    --translate-x: -535px; }
  .profile-themes-media-slot__crop-img.translate-x--534 {
    --translate-x: -534px; }
  .profile-themes-media-slot__crop-img.translate-x--533 {
    --translate-x: -533px; }
  .profile-themes-media-slot__crop-img.translate-x--532 {
    --translate-x: -532px; }
  .profile-themes-media-slot__crop-img.translate-x--531 {
    --translate-x: -531px; }
  .profile-themes-media-slot__crop-img.translate-x--530 {
    --translate-x: -530px; }
  .profile-themes-media-slot__crop-img.translate-x--529 {
    --translate-x: -529px; }
  .profile-themes-media-slot__crop-img.translate-x--528 {
    --translate-x: -528px; }
  .profile-themes-media-slot__crop-img.translate-x--527 {
    --translate-x: -527px; }
  .profile-themes-media-slot__crop-img.translate-x--526 {
    --translate-x: -526px; }
  .profile-themes-media-slot__crop-img.translate-x--525 {
    --translate-x: -525px; }
  .profile-themes-media-slot__crop-img.translate-x--524 {
    --translate-x: -524px; }
  .profile-themes-media-slot__crop-img.translate-x--523 {
    --translate-x: -523px; }
  .profile-themes-media-slot__crop-img.translate-x--522 {
    --translate-x: -522px; }
  .profile-themes-media-slot__crop-img.translate-x--521 {
    --translate-x: -521px; }
  .profile-themes-media-slot__crop-img.translate-x--520 {
    --translate-x: -520px; }
  .profile-themes-media-slot__crop-img.translate-x--519 {
    --translate-x: -519px; }
  .profile-themes-media-slot__crop-img.translate-x--518 {
    --translate-x: -518px; }
  .profile-themes-media-slot__crop-img.translate-x--517 {
    --translate-x: -517px; }
  .profile-themes-media-slot__crop-img.translate-x--516 {
    --translate-x: -516px; }
  .profile-themes-media-slot__crop-img.translate-x--515 {
    --translate-x: -515px; }
  .profile-themes-media-slot__crop-img.translate-x--514 {
    --translate-x: -514px; }
  .profile-themes-media-slot__crop-img.translate-x--513 {
    --translate-x: -513px; }
  .profile-themes-media-slot__crop-img.translate-x--512 {
    --translate-x: -512px; }
  .profile-themes-media-slot__crop-img.translate-x--511 {
    --translate-x: -511px; }
  .profile-themes-media-slot__crop-img.translate-x--510 {
    --translate-x: -510px; }
  .profile-themes-media-slot__crop-img.translate-x--509 {
    --translate-x: -509px; }
  .profile-themes-media-slot__crop-img.translate-x--508 {
    --translate-x: -508px; }
  .profile-themes-media-slot__crop-img.translate-x--507 {
    --translate-x: -507px; }
  .profile-themes-media-slot__crop-img.translate-x--506 {
    --translate-x: -506px; }
  .profile-themes-media-slot__crop-img.translate-x--505 {
    --translate-x: -505px; }
  .profile-themes-media-slot__crop-img.translate-x--504 {
    --translate-x: -504px; }
  .profile-themes-media-slot__crop-img.translate-x--503 {
    --translate-x: -503px; }
  .profile-themes-media-slot__crop-img.translate-x--502 {
    --translate-x: -502px; }
  .profile-themes-media-slot__crop-img.translate-x--501 {
    --translate-x: -501px; }
  .profile-themes-media-slot__crop-img.translate-x--500 {
    --translate-x: -500px; }
  .profile-themes-media-slot__crop-img.translate-x--499 {
    --translate-x: -499px; }
  .profile-themes-media-slot__crop-img.translate-x--498 {
    --translate-x: -498px; }
  .profile-themes-media-slot__crop-img.translate-x--497 {
    --translate-x: -497px; }
  .profile-themes-media-slot__crop-img.translate-x--496 {
    --translate-x: -496px; }
  .profile-themes-media-slot__crop-img.translate-x--495 {
    --translate-x: -495px; }
  .profile-themes-media-slot__crop-img.translate-x--494 {
    --translate-x: -494px; }
  .profile-themes-media-slot__crop-img.translate-x--493 {
    --translate-x: -493px; }
  .profile-themes-media-slot__crop-img.translate-x--492 {
    --translate-x: -492px; }
  .profile-themes-media-slot__crop-img.translate-x--491 {
    --translate-x: -491px; }
  .profile-themes-media-slot__crop-img.translate-x--490 {
    --translate-x: -490px; }
  .profile-themes-media-slot__crop-img.translate-x--489 {
    --translate-x: -489px; }
  .profile-themes-media-slot__crop-img.translate-x--488 {
    --translate-x: -488px; }
  .profile-themes-media-slot__crop-img.translate-x--487 {
    --translate-x: -487px; }
  .profile-themes-media-slot__crop-img.translate-x--486 {
    --translate-x: -486px; }
  .profile-themes-media-slot__crop-img.translate-x--485 {
    --translate-x: -485px; }
  .profile-themes-media-slot__crop-img.translate-x--484 {
    --translate-x: -484px; }
  .profile-themes-media-slot__crop-img.translate-x--483 {
    --translate-x: -483px; }
  .profile-themes-media-slot__crop-img.translate-x--482 {
    --translate-x: -482px; }
  .profile-themes-media-slot__crop-img.translate-x--481 {
    --translate-x: -481px; }
  .profile-themes-media-slot__crop-img.translate-x--480 {
    --translate-x: -480px; }
  .profile-themes-media-slot__crop-img.translate-x--479 {
    --translate-x: -479px; }
  .profile-themes-media-slot__crop-img.translate-x--478 {
    --translate-x: -478px; }
  .profile-themes-media-slot__crop-img.translate-x--477 {
    --translate-x: -477px; }
  .profile-themes-media-slot__crop-img.translate-x--476 {
    --translate-x: -476px; }
  .profile-themes-media-slot__crop-img.translate-x--475 {
    --translate-x: -475px; }
  .profile-themes-media-slot__crop-img.translate-x--474 {
    --translate-x: -474px; }
  .profile-themes-media-slot__crop-img.translate-x--473 {
    --translate-x: -473px; }
  .profile-themes-media-slot__crop-img.translate-x--472 {
    --translate-x: -472px; }
  .profile-themes-media-slot__crop-img.translate-x--471 {
    --translate-x: -471px; }
  .profile-themes-media-slot__crop-img.translate-x--470 {
    --translate-x: -470px; }
  .profile-themes-media-slot__crop-img.translate-x--469 {
    --translate-x: -469px; }
  .profile-themes-media-slot__crop-img.translate-x--468 {
    --translate-x: -468px; }
  .profile-themes-media-slot__crop-img.translate-x--467 {
    --translate-x: -467px; }
  .profile-themes-media-slot__crop-img.translate-x--466 {
    --translate-x: -466px; }
  .profile-themes-media-slot__crop-img.translate-x--465 {
    --translate-x: -465px; }
  .profile-themes-media-slot__crop-img.translate-x--464 {
    --translate-x: -464px; }
  .profile-themes-media-slot__crop-img.translate-x--463 {
    --translate-x: -463px; }
  .profile-themes-media-slot__crop-img.translate-x--462 {
    --translate-x: -462px; }
  .profile-themes-media-slot__crop-img.translate-x--461 {
    --translate-x: -461px; }
  .profile-themes-media-slot__crop-img.translate-x--460 {
    --translate-x: -460px; }
  .profile-themes-media-slot__crop-img.translate-x--459 {
    --translate-x: -459px; }
  .profile-themes-media-slot__crop-img.translate-x--458 {
    --translate-x: -458px; }
  .profile-themes-media-slot__crop-img.translate-x--457 {
    --translate-x: -457px; }
  .profile-themes-media-slot__crop-img.translate-x--456 {
    --translate-x: -456px; }
  .profile-themes-media-slot__crop-img.translate-x--455 {
    --translate-x: -455px; }
  .profile-themes-media-slot__crop-img.translate-x--454 {
    --translate-x: -454px; }
  .profile-themes-media-slot__crop-img.translate-x--453 {
    --translate-x: -453px; }
  .profile-themes-media-slot__crop-img.translate-x--452 {
    --translate-x: -452px; }
  .profile-themes-media-slot__crop-img.translate-x--451 {
    --translate-x: -451px; }
  .profile-themes-media-slot__crop-img.translate-x--450 {
    --translate-x: -450px; }
  .profile-themes-media-slot__crop-img.translate-x--449 {
    --translate-x: -449px; }
  .profile-themes-media-slot__crop-img.translate-x--448 {
    --translate-x: -448px; }
  .profile-themes-media-slot__crop-img.translate-x--447 {
    --translate-x: -447px; }
  .profile-themes-media-slot__crop-img.translate-x--446 {
    --translate-x: -446px; }
  .profile-themes-media-slot__crop-img.translate-x--445 {
    --translate-x: -445px; }
  .profile-themes-media-slot__crop-img.translate-x--444 {
    --translate-x: -444px; }
  .profile-themes-media-slot__crop-img.translate-x--443 {
    --translate-x: -443px; }
  .profile-themes-media-slot__crop-img.translate-x--442 {
    --translate-x: -442px; }
  .profile-themes-media-slot__crop-img.translate-x--441 {
    --translate-x: -441px; }
  .profile-themes-media-slot__crop-img.translate-x--440 {
    --translate-x: -440px; }
  .profile-themes-media-slot__crop-img.translate-x--439 {
    --translate-x: -439px; }
  .profile-themes-media-slot__crop-img.translate-x--438 {
    --translate-x: -438px; }
  .profile-themes-media-slot__crop-img.translate-x--437 {
    --translate-x: -437px; }
  .profile-themes-media-slot__crop-img.translate-x--436 {
    --translate-x: -436px; }
  .profile-themes-media-slot__crop-img.translate-x--435 {
    --translate-x: -435px; }
  .profile-themes-media-slot__crop-img.translate-x--434 {
    --translate-x: -434px; }
  .profile-themes-media-slot__crop-img.translate-x--433 {
    --translate-x: -433px; }
  .profile-themes-media-slot__crop-img.translate-x--432 {
    --translate-x: -432px; }
  .profile-themes-media-slot__crop-img.translate-x--431 {
    --translate-x: -431px; }
  .profile-themes-media-slot__crop-img.translate-x--430 {
    --translate-x: -430px; }
  .profile-themes-media-slot__crop-img.translate-x--429 {
    --translate-x: -429px; }
  .profile-themes-media-slot__crop-img.translate-x--428 {
    --translate-x: -428px; }
  .profile-themes-media-slot__crop-img.translate-x--427 {
    --translate-x: -427px; }
  .profile-themes-media-slot__crop-img.translate-x--426 {
    --translate-x: -426px; }
  .profile-themes-media-slot__crop-img.translate-x--425 {
    --translate-x: -425px; }
  .profile-themes-media-slot__crop-img.translate-x--424 {
    --translate-x: -424px; }
  .profile-themes-media-slot__crop-img.translate-x--423 {
    --translate-x: -423px; }
  .profile-themes-media-slot__crop-img.translate-x--422 {
    --translate-x: -422px; }
  .profile-themes-media-slot__crop-img.translate-x--421 {
    --translate-x: -421px; }
  .profile-themes-media-slot__crop-img.translate-x--420 {
    --translate-x: -420px; }
  .profile-themes-media-slot__crop-img.translate-x--419 {
    --translate-x: -419px; }
  .profile-themes-media-slot__crop-img.translate-x--418 {
    --translate-x: -418px; }
  .profile-themes-media-slot__crop-img.translate-x--417 {
    --translate-x: -417px; }
  .profile-themes-media-slot__crop-img.translate-x--416 {
    --translate-x: -416px; }
  .profile-themes-media-slot__crop-img.translate-x--415 {
    --translate-x: -415px; }
  .profile-themes-media-slot__crop-img.translate-x--414 {
    --translate-x: -414px; }
  .profile-themes-media-slot__crop-img.translate-x--413 {
    --translate-x: -413px; }
  .profile-themes-media-slot__crop-img.translate-x--412 {
    --translate-x: -412px; }
  .profile-themes-media-slot__crop-img.translate-x--411 {
    --translate-x: -411px; }
  .profile-themes-media-slot__crop-img.translate-x--410 {
    --translate-x: -410px; }
  .profile-themes-media-slot__crop-img.translate-x--409 {
    --translate-x: -409px; }
  .profile-themes-media-slot__crop-img.translate-x--408 {
    --translate-x: -408px; }
  .profile-themes-media-slot__crop-img.translate-x--407 {
    --translate-x: -407px; }
  .profile-themes-media-slot__crop-img.translate-x--406 {
    --translate-x: -406px; }
  .profile-themes-media-slot__crop-img.translate-x--405 {
    --translate-x: -405px; }
  .profile-themes-media-slot__crop-img.translate-x--404 {
    --translate-x: -404px; }
  .profile-themes-media-slot__crop-img.translate-x--403 {
    --translate-x: -403px; }
  .profile-themes-media-slot__crop-img.translate-x--402 {
    --translate-x: -402px; }
  .profile-themes-media-slot__crop-img.translate-x--401 {
    --translate-x: -401px; }
  .profile-themes-media-slot__crop-img.translate-x--400 {
    --translate-x: -400px; }
  .profile-themes-media-slot__crop-img.translate-x--399 {
    --translate-x: -399px; }
  .profile-themes-media-slot__crop-img.translate-x--398 {
    --translate-x: -398px; }
  .profile-themes-media-slot__crop-img.translate-x--397 {
    --translate-x: -397px; }
  .profile-themes-media-slot__crop-img.translate-x--396 {
    --translate-x: -396px; }
  .profile-themes-media-slot__crop-img.translate-x--395 {
    --translate-x: -395px; }
  .profile-themes-media-slot__crop-img.translate-x--394 {
    --translate-x: -394px; }
  .profile-themes-media-slot__crop-img.translate-x--393 {
    --translate-x: -393px; }
  .profile-themes-media-slot__crop-img.translate-x--392 {
    --translate-x: -392px; }
  .profile-themes-media-slot__crop-img.translate-x--391 {
    --translate-x: -391px; }
  .profile-themes-media-slot__crop-img.translate-x--390 {
    --translate-x: -390px; }
  .profile-themes-media-slot__crop-img.translate-x--389 {
    --translate-x: -389px; }
  .profile-themes-media-slot__crop-img.translate-x--388 {
    --translate-x: -388px; }
  .profile-themes-media-slot__crop-img.translate-x--387 {
    --translate-x: -387px; }
  .profile-themes-media-slot__crop-img.translate-x--386 {
    --translate-x: -386px; }
  .profile-themes-media-slot__crop-img.translate-x--385 {
    --translate-x: -385px; }
  .profile-themes-media-slot__crop-img.translate-x--384 {
    --translate-x: -384px; }
  .profile-themes-media-slot__crop-img.translate-x--383 {
    --translate-x: -383px; }
  .profile-themes-media-slot__crop-img.translate-x--382 {
    --translate-x: -382px; }
  .profile-themes-media-slot__crop-img.translate-x--381 {
    --translate-x: -381px; }
  .profile-themes-media-slot__crop-img.translate-x--380 {
    --translate-x: -380px; }
  .profile-themes-media-slot__crop-img.translate-x--379 {
    --translate-x: -379px; }
  .profile-themes-media-slot__crop-img.translate-x--378 {
    --translate-x: -378px; }
  .profile-themes-media-slot__crop-img.translate-x--377 {
    --translate-x: -377px; }
  .profile-themes-media-slot__crop-img.translate-x--376 {
    --translate-x: -376px; }
  .profile-themes-media-slot__crop-img.translate-x--375 {
    --translate-x: -375px; }
  .profile-themes-media-slot__crop-img.translate-x--374 {
    --translate-x: -374px; }
  .profile-themes-media-slot__crop-img.translate-x--373 {
    --translate-x: -373px; }
  .profile-themes-media-slot__crop-img.translate-x--372 {
    --translate-x: -372px; }
  .profile-themes-media-slot__crop-img.translate-x--371 {
    --translate-x: -371px; }
  .profile-themes-media-slot__crop-img.translate-x--370 {
    --translate-x: -370px; }
  .profile-themes-media-slot__crop-img.translate-x--369 {
    --translate-x: -369px; }
  .profile-themes-media-slot__crop-img.translate-x--368 {
    --translate-x: -368px; }
  .profile-themes-media-slot__crop-img.translate-x--367 {
    --translate-x: -367px; }
  .profile-themes-media-slot__crop-img.translate-x--366 {
    --translate-x: -366px; }
  .profile-themes-media-slot__crop-img.translate-x--365 {
    --translate-x: -365px; }
  .profile-themes-media-slot__crop-img.translate-x--364 {
    --translate-x: -364px; }
  .profile-themes-media-slot__crop-img.translate-x--363 {
    --translate-x: -363px; }
  .profile-themes-media-slot__crop-img.translate-x--362 {
    --translate-x: -362px; }
  .profile-themes-media-slot__crop-img.translate-x--361 {
    --translate-x: -361px; }
  .profile-themes-media-slot__crop-img.translate-x--360 {
    --translate-x: -360px; }
  .profile-themes-media-slot__crop-img.translate-x--359 {
    --translate-x: -359px; }
  .profile-themes-media-slot__crop-img.translate-x--358 {
    --translate-x: -358px; }
  .profile-themes-media-slot__crop-img.translate-x--357 {
    --translate-x: -357px; }
  .profile-themes-media-slot__crop-img.translate-x--356 {
    --translate-x: -356px; }
  .profile-themes-media-slot__crop-img.translate-x--355 {
    --translate-x: -355px; }
  .profile-themes-media-slot__crop-img.translate-x--354 {
    --translate-x: -354px; }
  .profile-themes-media-slot__crop-img.translate-x--353 {
    --translate-x: -353px; }
  .profile-themes-media-slot__crop-img.translate-x--352 {
    --translate-x: -352px; }
  .profile-themes-media-slot__crop-img.translate-x--351 {
    --translate-x: -351px; }
  .profile-themes-media-slot__crop-img.translate-x--350 {
    --translate-x: -350px; }
  .profile-themes-media-slot__crop-img.translate-x--349 {
    --translate-x: -349px; }
  .profile-themes-media-slot__crop-img.translate-x--348 {
    --translate-x: -348px; }
  .profile-themes-media-slot__crop-img.translate-x--347 {
    --translate-x: -347px; }
  .profile-themes-media-slot__crop-img.translate-x--346 {
    --translate-x: -346px; }
  .profile-themes-media-slot__crop-img.translate-x--345 {
    --translate-x: -345px; }
  .profile-themes-media-slot__crop-img.translate-x--344 {
    --translate-x: -344px; }
  .profile-themes-media-slot__crop-img.translate-x--343 {
    --translate-x: -343px; }
  .profile-themes-media-slot__crop-img.translate-x--342 {
    --translate-x: -342px; }
  .profile-themes-media-slot__crop-img.translate-x--341 {
    --translate-x: -341px; }
  .profile-themes-media-slot__crop-img.translate-x--340 {
    --translate-x: -340px; }
  .profile-themes-media-slot__crop-img.translate-x--339 {
    --translate-x: -339px; }
  .profile-themes-media-slot__crop-img.translate-x--338 {
    --translate-x: -338px; }
  .profile-themes-media-slot__crop-img.translate-x--337 {
    --translate-x: -337px; }
  .profile-themes-media-slot__crop-img.translate-x--336 {
    --translate-x: -336px; }
  .profile-themes-media-slot__crop-img.translate-x--335 {
    --translate-x: -335px; }
  .profile-themes-media-slot__crop-img.translate-x--334 {
    --translate-x: -334px; }
  .profile-themes-media-slot__crop-img.translate-x--333 {
    --translate-x: -333px; }
  .profile-themes-media-slot__crop-img.translate-x--332 {
    --translate-x: -332px; }
  .profile-themes-media-slot__crop-img.translate-x--331 {
    --translate-x: -331px; }
  .profile-themes-media-slot__crop-img.translate-x--330 {
    --translate-x: -330px; }
  .profile-themes-media-slot__crop-img.translate-x--329 {
    --translate-x: -329px; }
  .profile-themes-media-slot__crop-img.translate-x--328 {
    --translate-x: -328px; }
  .profile-themes-media-slot__crop-img.translate-x--327 {
    --translate-x: -327px; }
  .profile-themes-media-slot__crop-img.translate-x--326 {
    --translate-x: -326px; }
  .profile-themes-media-slot__crop-img.translate-x--325 {
    --translate-x: -325px; }
  .profile-themes-media-slot__crop-img.translate-x--324 {
    --translate-x: -324px; }
  .profile-themes-media-slot__crop-img.translate-x--323 {
    --translate-x: -323px; }
  .profile-themes-media-slot__crop-img.translate-x--322 {
    --translate-x: -322px; }
  .profile-themes-media-slot__crop-img.translate-x--321 {
    --translate-x: -321px; }
  .profile-themes-media-slot__crop-img.translate-x--320 {
    --translate-x: -320px; }
  .profile-themes-media-slot__crop-img.translate-x--319 {
    --translate-x: -319px; }
  .profile-themes-media-slot__crop-img.translate-x--318 {
    --translate-x: -318px; }
  .profile-themes-media-slot__crop-img.translate-x--317 {
    --translate-x: -317px; }
  .profile-themes-media-slot__crop-img.translate-x--316 {
    --translate-x: -316px; }
  .profile-themes-media-slot__crop-img.translate-x--315 {
    --translate-x: -315px; }
  .profile-themes-media-slot__crop-img.translate-x--314 {
    --translate-x: -314px; }
  .profile-themes-media-slot__crop-img.translate-x--313 {
    --translate-x: -313px; }
  .profile-themes-media-slot__crop-img.translate-x--312 {
    --translate-x: -312px; }
  .profile-themes-media-slot__crop-img.translate-x--311 {
    --translate-x: -311px; }
  .profile-themes-media-slot__crop-img.translate-x--310 {
    --translate-x: -310px; }
  .profile-themes-media-slot__crop-img.translate-x--309 {
    --translate-x: -309px; }
  .profile-themes-media-slot__crop-img.translate-x--308 {
    --translate-x: -308px; }
  .profile-themes-media-slot__crop-img.translate-x--307 {
    --translate-x: -307px; }
  .profile-themes-media-slot__crop-img.translate-x--306 {
    --translate-x: -306px; }
  .profile-themes-media-slot__crop-img.translate-x--305 {
    --translate-x: -305px; }
  .profile-themes-media-slot__crop-img.translate-x--304 {
    --translate-x: -304px; }
  .profile-themes-media-slot__crop-img.translate-x--303 {
    --translate-x: -303px; }
  .profile-themes-media-slot__crop-img.translate-x--302 {
    --translate-x: -302px; }
  .profile-themes-media-slot__crop-img.translate-x--301 {
    --translate-x: -301px; }
  .profile-themes-media-slot__crop-img.translate-x--300 {
    --translate-x: -300px; }
  .profile-themes-media-slot__crop-img.translate-x--299 {
    --translate-x: -299px; }
  .profile-themes-media-slot__crop-img.translate-x--298 {
    --translate-x: -298px; }
  .profile-themes-media-slot__crop-img.translate-x--297 {
    --translate-x: -297px; }
  .profile-themes-media-slot__crop-img.translate-x--296 {
    --translate-x: -296px; }
  .profile-themes-media-slot__crop-img.translate-x--295 {
    --translate-x: -295px; }
  .profile-themes-media-slot__crop-img.translate-x--294 {
    --translate-x: -294px; }
  .profile-themes-media-slot__crop-img.translate-x--293 {
    --translate-x: -293px; }
  .profile-themes-media-slot__crop-img.translate-x--292 {
    --translate-x: -292px; }
  .profile-themes-media-slot__crop-img.translate-x--291 {
    --translate-x: -291px; }
  .profile-themes-media-slot__crop-img.translate-x--290 {
    --translate-x: -290px; }
  .profile-themes-media-slot__crop-img.translate-x--289 {
    --translate-x: -289px; }
  .profile-themes-media-slot__crop-img.translate-x--288 {
    --translate-x: -288px; }
  .profile-themes-media-slot__crop-img.translate-x--287 {
    --translate-x: -287px; }
  .profile-themes-media-slot__crop-img.translate-x--286 {
    --translate-x: -286px; }
  .profile-themes-media-slot__crop-img.translate-x--285 {
    --translate-x: -285px; }
  .profile-themes-media-slot__crop-img.translate-x--284 {
    --translate-x: -284px; }
  .profile-themes-media-slot__crop-img.translate-x--283 {
    --translate-x: -283px; }
  .profile-themes-media-slot__crop-img.translate-x--282 {
    --translate-x: -282px; }
  .profile-themes-media-slot__crop-img.translate-x--281 {
    --translate-x: -281px; }
  .profile-themes-media-slot__crop-img.translate-x--280 {
    --translate-x: -280px; }
  .profile-themes-media-slot__crop-img.translate-x--279 {
    --translate-x: -279px; }
  .profile-themes-media-slot__crop-img.translate-x--278 {
    --translate-x: -278px; }
  .profile-themes-media-slot__crop-img.translate-x--277 {
    --translate-x: -277px; }
  .profile-themes-media-slot__crop-img.translate-x--276 {
    --translate-x: -276px; }
  .profile-themes-media-slot__crop-img.translate-x--275 {
    --translate-x: -275px; }
  .profile-themes-media-slot__crop-img.translate-x--274 {
    --translate-x: -274px; }
  .profile-themes-media-slot__crop-img.translate-x--273 {
    --translate-x: -273px; }
  .profile-themes-media-slot__crop-img.translate-x--272 {
    --translate-x: -272px; }
  .profile-themes-media-slot__crop-img.translate-x--271 {
    --translate-x: -271px; }
  .profile-themes-media-slot__crop-img.translate-x--270 {
    --translate-x: -270px; }
  .profile-themes-media-slot__crop-img.translate-x--269 {
    --translate-x: -269px; }
  .profile-themes-media-slot__crop-img.translate-x--268 {
    --translate-x: -268px; }
  .profile-themes-media-slot__crop-img.translate-x--267 {
    --translate-x: -267px; }
  .profile-themes-media-slot__crop-img.translate-x--266 {
    --translate-x: -266px; }
  .profile-themes-media-slot__crop-img.translate-x--265 {
    --translate-x: -265px; }
  .profile-themes-media-slot__crop-img.translate-x--264 {
    --translate-x: -264px; }
  .profile-themes-media-slot__crop-img.translate-x--263 {
    --translate-x: -263px; }
  .profile-themes-media-slot__crop-img.translate-x--262 {
    --translate-x: -262px; }
  .profile-themes-media-slot__crop-img.translate-x--261 {
    --translate-x: -261px; }
  .profile-themes-media-slot__crop-img.translate-x--260 {
    --translate-x: -260px; }
  .profile-themes-media-slot__crop-img.translate-x--259 {
    --translate-x: -259px; }
  .profile-themes-media-slot__crop-img.translate-x--258 {
    --translate-x: -258px; }
  .profile-themes-media-slot__crop-img.translate-x--257 {
    --translate-x: -257px; }
  .profile-themes-media-slot__crop-img.translate-x--256 {
    --translate-x: -256px; }
  .profile-themes-media-slot__crop-img.translate-x--255 {
    --translate-x: -255px; }
  .profile-themes-media-slot__crop-img.translate-x--254 {
    --translate-x: -254px; }
  .profile-themes-media-slot__crop-img.translate-x--253 {
    --translate-x: -253px; }
  .profile-themes-media-slot__crop-img.translate-x--252 {
    --translate-x: -252px; }
  .profile-themes-media-slot__crop-img.translate-x--251 {
    --translate-x: -251px; }
  .profile-themes-media-slot__crop-img.translate-x--250 {
    --translate-x: -250px; }
  .profile-themes-media-slot__crop-img.translate-x--249 {
    --translate-x: -249px; }
  .profile-themes-media-slot__crop-img.translate-x--248 {
    --translate-x: -248px; }
  .profile-themes-media-slot__crop-img.translate-x--247 {
    --translate-x: -247px; }
  .profile-themes-media-slot__crop-img.translate-x--246 {
    --translate-x: -246px; }
  .profile-themes-media-slot__crop-img.translate-x--245 {
    --translate-x: -245px; }
  .profile-themes-media-slot__crop-img.translate-x--244 {
    --translate-x: -244px; }
  .profile-themes-media-slot__crop-img.translate-x--243 {
    --translate-x: -243px; }
  .profile-themes-media-slot__crop-img.translate-x--242 {
    --translate-x: -242px; }
  .profile-themes-media-slot__crop-img.translate-x--241 {
    --translate-x: -241px; }
  .profile-themes-media-slot__crop-img.translate-x--240 {
    --translate-x: -240px; }
  .profile-themes-media-slot__crop-img.translate-x--239 {
    --translate-x: -239px; }
  .profile-themes-media-slot__crop-img.translate-x--238 {
    --translate-x: -238px; }
  .profile-themes-media-slot__crop-img.translate-x--237 {
    --translate-x: -237px; }
  .profile-themes-media-slot__crop-img.translate-x--236 {
    --translate-x: -236px; }
  .profile-themes-media-slot__crop-img.translate-x--235 {
    --translate-x: -235px; }
  .profile-themes-media-slot__crop-img.translate-x--234 {
    --translate-x: -234px; }
  .profile-themes-media-slot__crop-img.translate-x--233 {
    --translate-x: -233px; }
  .profile-themes-media-slot__crop-img.translate-x--232 {
    --translate-x: -232px; }
  .profile-themes-media-slot__crop-img.translate-x--231 {
    --translate-x: -231px; }
  .profile-themes-media-slot__crop-img.translate-x--230 {
    --translate-x: -230px; }
  .profile-themes-media-slot__crop-img.translate-x--229 {
    --translate-x: -229px; }
  .profile-themes-media-slot__crop-img.translate-x--228 {
    --translate-x: -228px; }
  .profile-themes-media-slot__crop-img.translate-x--227 {
    --translate-x: -227px; }
  .profile-themes-media-slot__crop-img.translate-x--226 {
    --translate-x: -226px; }
  .profile-themes-media-slot__crop-img.translate-x--225 {
    --translate-x: -225px; }
  .profile-themes-media-slot__crop-img.translate-x--224 {
    --translate-x: -224px; }
  .profile-themes-media-slot__crop-img.translate-x--223 {
    --translate-x: -223px; }
  .profile-themes-media-slot__crop-img.translate-x--222 {
    --translate-x: -222px; }
  .profile-themes-media-slot__crop-img.translate-x--221 {
    --translate-x: -221px; }
  .profile-themes-media-slot__crop-img.translate-x--220 {
    --translate-x: -220px; }
  .profile-themes-media-slot__crop-img.translate-x--219 {
    --translate-x: -219px; }
  .profile-themes-media-slot__crop-img.translate-x--218 {
    --translate-x: -218px; }
  .profile-themes-media-slot__crop-img.translate-x--217 {
    --translate-x: -217px; }
  .profile-themes-media-slot__crop-img.translate-x--216 {
    --translate-x: -216px; }
  .profile-themes-media-slot__crop-img.translate-x--215 {
    --translate-x: -215px; }
  .profile-themes-media-slot__crop-img.translate-x--214 {
    --translate-x: -214px; }
  .profile-themes-media-slot__crop-img.translate-x--213 {
    --translate-x: -213px; }
  .profile-themes-media-slot__crop-img.translate-x--212 {
    --translate-x: -212px; }
  .profile-themes-media-slot__crop-img.translate-x--211 {
    --translate-x: -211px; }
  .profile-themes-media-slot__crop-img.translate-x--210 {
    --translate-x: -210px; }
  .profile-themes-media-slot__crop-img.translate-x--209 {
    --translate-x: -209px; }
  .profile-themes-media-slot__crop-img.translate-x--208 {
    --translate-x: -208px; }
  .profile-themes-media-slot__crop-img.translate-x--207 {
    --translate-x: -207px; }
  .profile-themes-media-slot__crop-img.translate-x--206 {
    --translate-x: -206px; }
  .profile-themes-media-slot__crop-img.translate-x--205 {
    --translate-x: -205px; }
  .profile-themes-media-slot__crop-img.translate-x--204 {
    --translate-x: -204px; }
  .profile-themes-media-slot__crop-img.translate-x--203 {
    --translate-x: -203px; }
  .profile-themes-media-slot__crop-img.translate-x--202 {
    --translate-x: -202px; }
  .profile-themes-media-slot__crop-img.translate-x--201 {
    --translate-x: -201px; }
  .profile-themes-media-slot__crop-img.translate-x--200 {
    --translate-x: -200px; }
  .profile-themes-media-slot__crop-img.translate-x--199 {
    --translate-x: -199px; }
  .profile-themes-media-slot__crop-img.translate-x--198 {
    --translate-x: -198px; }
  .profile-themes-media-slot__crop-img.translate-x--197 {
    --translate-x: -197px; }
  .profile-themes-media-slot__crop-img.translate-x--196 {
    --translate-x: -196px; }
  .profile-themes-media-slot__crop-img.translate-x--195 {
    --translate-x: -195px; }
  .profile-themes-media-slot__crop-img.translate-x--194 {
    --translate-x: -194px; }
  .profile-themes-media-slot__crop-img.translate-x--193 {
    --translate-x: -193px; }
  .profile-themes-media-slot__crop-img.translate-x--192 {
    --translate-x: -192px; }
  .profile-themes-media-slot__crop-img.translate-x--191 {
    --translate-x: -191px; }
  .profile-themes-media-slot__crop-img.translate-x--190 {
    --translate-x: -190px; }
  .profile-themes-media-slot__crop-img.translate-x--189 {
    --translate-x: -189px; }
  .profile-themes-media-slot__crop-img.translate-x--188 {
    --translate-x: -188px; }
  .profile-themes-media-slot__crop-img.translate-x--187 {
    --translate-x: -187px; }
  .profile-themes-media-slot__crop-img.translate-x--186 {
    --translate-x: -186px; }
  .profile-themes-media-slot__crop-img.translate-x--185 {
    --translate-x: -185px; }
  .profile-themes-media-slot__crop-img.translate-x--184 {
    --translate-x: -184px; }
  .profile-themes-media-slot__crop-img.translate-x--183 {
    --translate-x: -183px; }
  .profile-themes-media-slot__crop-img.translate-x--182 {
    --translate-x: -182px; }
  .profile-themes-media-slot__crop-img.translate-x--181 {
    --translate-x: -181px; }
  .profile-themes-media-slot__crop-img.translate-x--180 {
    --translate-x: -180px; }
  .profile-themes-media-slot__crop-img.translate-x--179 {
    --translate-x: -179px; }
  .profile-themes-media-slot__crop-img.translate-x--178 {
    --translate-x: -178px; }
  .profile-themes-media-slot__crop-img.translate-x--177 {
    --translate-x: -177px; }
  .profile-themes-media-slot__crop-img.translate-x--176 {
    --translate-x: -176px; }
  .profile-themes-media-slot__crop-img.translate-x--175 {
    --translate-x: -175px; }
  .profile-themes-media-slot__crop-img.translate-x--174 {
    --translate-x: -174px; }
  .profile-themes-media-slot__crop-img.translate-x--173 {
    --translate-x: -173px; }
  .profile-themes-media-slot__crop-img.translate-x--172 {
    --translate-x: -172px; }
  .profile-themes-media-slot__crop-img.translate-x--171 {
    --translate-x: -171px; }
  .profile-themes-media-slot__crop-img.translate-x--170 {
    --translate-x: -170px; }
  .profile-themes-media-slot__crop-img.translate-x--169 {
    --translate-x: -169px; }
  .profile-themes-media-slot__crop-img.translate-x--168 {
    --translate-x: -168px; }
  .profile-themes-media-slot__crop-img.translate-x--167 {
    --translate-x: -167px; }
  .profile-themes-media-slot__crop-img.translate-x--166 {
    --translate-x: -166px; }
  .profile-themes-media-slot__crop-img.translate-x--165 {
    --translate-x: -165px; }
  .profile-themes-media-slot__crop-img.translate-x--164 {
    --translate-x: -164px; }
  .profile-themes-media-slot__crop-img.translate-x--163 {
    --translate-x: -163px; }
  .profile-themes-media-slot__crop-img.translate-x--162 {
    --translate-x: -162px; }
  .profile-themes-media-slot__crop-img.translate-x--161 {
    --translate-x: -161px; }
  .profile-themes-media-slot__crop-img.translate-x--160 {
    --translate-x: -160px; }
  .profile-themes-media-slot__crop-img.translate-x--159 {
    --translate-x: -159px; }
  .profile-themes-media-slot__crop-img.translate-x--158 {
    --translate-x: -158px; }
  .profile-themes-media-slot__crop-img.translate-x--157 {
    --translate-x: -157px; }
  .profile-themes-media-slot__crop-img.translate-x--156 {
    --translate-x: -156px; }
  .profile-themes-media-slot__crop-img.translate-x--155 {
    --translate-x: -155px; }
  .profile-themes-media-slot__crop-img.translate-x--154 {
    --translate-x: -154px; }
  .profile-themes-media-slot__crop-img.translate-x--153 {
    --translate-x: -153px; }
  .profile-themes-media-slot__crop-img.translate-x--152 {
    --translate-x: -152px; }
  .profile-themes-media-slot__crop-img.translate-x--151 {
    --translate-x: -151px; }
  .profile-themes-media-slot__crop-img.translate-x--150 {
    --translate-x: -150px; }
  .profile-themes-media-slot__crop-img.translate-x--149 {
    --translate-x: -149px; }
  .profile-themes-media-slot__crop-img.translate-x--148 {
    --translate-x: -148px; }
  .profile-themes-media-slot__crop-img.translate-x--147 {
    --translate-x: -147px; }
  .profile-themes-media-slot__crop-img.translate-x--146 {
    --translate-x: -146px; }
  .profile-themes-media-slot__crop-img.translate-x--145 {
    --translate-x: -145px; }
  .profile-themes-media-slot__crop-img.translate-x--144 {
    --translate-x: -144px; }
  .profile-themes-media-slot__crop-img.translate-x--143 {
    --translate-x: -143px; }
  .profile-themes-media-slot__crop-img.translate-x--142 {
    --translate-x: -142px; }
  .profile-themes-media-slot__crop-img.translate-x--141 {
    --translate-x: -141px; }
  .profile-themes-media-slot__crop-img.translate-x--140 {
    --translate-x: -140px; }
  .profile-themes-media-slot__crop-img.translate-x--139 {
    --translate-x: -139px; }
  .profile-themes-media-slot__crop-img.translate-x--138 {
    --translate-x: -138px; }
  .profile-themes-media-slot__crop-img.translate-x--137 {
    --translate-x: -137px; }
  .profile-themes-media-slot__crop-img.translate-x--136 {
    --translate-x: -136px; }
  .profile-themes-media-slot__crop-img.translate-x--135 {
    --translate-x: -135px; }
  .profile-themes-media-slot__crop-img.translate-x--134 {
    --translate-x: -134px; }
  .profile-themes-media-slot__crop-img.translate-x--133 {
    --translate-x: -133px; }
  .profile-themes-media-slot__crop-img.translate-x--132 {
    --translate-x: -132px; }
  .profile-themes-media-slot__crop-img.translate-x--131 {
    --translate-x: -131px; }
  .profile-themes-media-slot__crop-img.translate-x--130 {
    --translate-x: -130px; }
  .profile-themes-media-slot__crop-img.translate-x--129 {
    --translate-x: -129px; }
  .profile-themes-media-slot__crop-img.translate-x--128 {
    --translate-x: -128px; }
  .profile-themes-media-slot__crop-img.translate-x--127 {
    --translate-x: -127px; }
  .profile-themes-media-slot__crop-img.translate-x--126 {
    --translate-x: -126px; }
  .profile-themes-media-slot__crop-img.translate-x--125 {
    --translate-x: -125px; }
  .profile-themes-media-slot__crop-img.translate-x--124 {
    --translate-x: -124px; }
  .profile-themes-media-slot__crop-img.translate-x--123 {
    --translate-x: -123px; }
  .profile-themes-media-slot__crop-img.translate-x--122 {
    --translate-x: -122px; }
  .profile-themes-media-slot__crop-img.translate-x--121 {
    --translate-x: -121px; }
  .profile-themes-media-slot__crop-img.translate-x--120 {
    --translate-x: -120px; }
  .profile-themes-media-slot__crop-img.translate-x--119 {
    --translate-x: -119px; }
  .profile-themes-media-slot__crop-img.translate-x--118 {
    --translate-x: -118px; }
  .profile-themes-media-slot__crop-img.translate-x--117 {
    --translate-x: -117px; }
  .profile-themes-media-slot__crop-img.translate-x--116 {
    --translate-x: -116px; }
  .profile-themes-media-slot__crop-img.translate-x--115 {
    --translate-x: -115px; }
  .profile-themes-media-slot__crop-img.translate-x--114 {
    --translate-x: -114px; }
  .profile-themes-media-slot__crop-img.translate-x--113 {
    --translate-x: -113px; }
  .profile-themes-media-slot__crop-img.translate-x--112 {
    --translate-x: -112px; }
  .profile-themes-media-slot__crop-img.translate-x--111 {
    --translate-x: -111px; }
  .profile-themes-media-slot__crop-img.translate-x--110 {
    --translate-x: -110px; }
  .profile-themes-media-slot__crop-img.translate-x--109 {
    --translate-x: -109px; }
  .profile-themes-media-slot__crop-img.translate-x--108 {
    --translate-x: -108px; }
  .profile-themes-media-slot__crop-img.translate-x--107 {
    --translate-x: -107px; }
  .profile-themes-media-slot__crop-img.translate-x--106 {
    --translate-x: -106px; }
  .profile-themes-media-slot__crop-img.translate-x--105 {
    --translate-x: -105px; }
  .profile-themes-media-slot__crop-img.translate-x--104 {
    --translate-x: -104px; }
  .profile-themes-media-slot__crop-img.translate-x--103 {
    --translate-x: -103px; }
  .profile-themes-media-slot__crop-img.translate-x--102 {
    --translate-x: -102px; }
  .profile-themes-media-slot__crop-img.translate-x--101 {
    --translate-x: -101px; }
  .profile-themes-media-slot__crop-img.translate-x--100 {
    --translate-x: -100px; }
  .profile-themes-media-slot__crop-img.translate-x--99 {
    --translate-x: -99px; }
  .profile-themes-media-slot__crop-img.translate-x--98 {
    --translate-x: -98px; }
  .profile-themes-media-slot__crop-img.translate-x--97 {
    --translate-x: -97px; }
  .profile-themes-media-slot__crop-img.translate-x--96 {
    --translate-x: -96px; }
  .profile-themes-media-slot__crop-img.translate-x--95 {
    --translate-x: -95px; }
  .profile-themes-media-slot__crop-img.translate-x--94 {
    --translate-x: -94px; }
  .profile-themes-media-slot__crop-img.translate-x--93 {
    --translate-x: -93px; }
  .profile-themes-media-slot__crop-img.translate-x--92 {
    --translate-x: -92px; }
  .profile-themes-media-slot__crop-img.translate-x--91 {
    --translate-x: -91px; }
  .profile-themes-media-slot__crop-img.translate-x--90 {
    --translate-x: -90px; }
  .profile-themes-media-slot__crop-img.translate-x--89 {
    --translate-x: -89px; }
  .profile-themes-media-slot__crop-img.translate-x--88 {
    --translate-x: -88px; }
  .profile-themes-media-slot__crop-img.translate-x--87 {
    --translate-x: -87px; }
  .profile-themes-media-slot__crop-img.translate-x--86 {
    --translate-x: -86px; }
  .profile-themes-media-slot__crop-img.translate-x--85 {
    --translate-x: -85px; }
  .profile-themes-media-slot__crop-img.translate-x--84 {
    --translate-x: -84px; }
  .profile-themes-media-slot__crop-img.translate-x--83 {
    --translate-x: -83px; }
  .profile-themes-media-slot__crop-img.translate-x--82 {
    --translate-x: -82px; }
  .profile-themes-media-slot__crop-img.translate-x--81 {
    --translate-x: -81px; }
  .profile-themes-media-slot__crop-img.translate-x--80 {
    --translate-x: -80px; }
  .profile-themes-media-slot__crop-img.translate-x--79 {
    --translate-x: -79px; }
  .profile-themes-media-slot__crop-img.translate-x--78 {
    --translate-x: -78px; }
  .profile-themes-media-slot__crop-img.translate-x--77 {
    --translate-x: -77px; }
  .profile-themes-media-slot__crop-img.translate-x--76 {
    --translate-x: -76px; }
  .profile-themes-media-slot__crop-img.translate-x--75 {
    --translate-x: -75px; }
  .profile-themes-media-slot__crop-img.translate-x--74 {
    --translate-x: -74px; }
  .profile-themes-media-slot__crop-img.translate-x--73 {
    --translate-x: -73px; }
  .profile-themes-media-slot__crop-img.translate-x--72 {
    --translate-x: -72px; }
  .profile-themes-media-slot__crop-img.translate-x--71 {
    --translate-x: -71px; }
  .profile-themes-media-slot__crop-img.translate-x--70 {
    --translate-x: -70px; }
  .profile-themes-media-slot__crop-img.translate-x--69 {
    --translate-x: -69px; }
  .profile-themes-media-slot__crop-img.translate-x--68 {
    --translate-x: -68px; }
  .profile-themes-media-slot__crop-img.translate-x--67 {
    --translate-x: -67px; }
  .profile-themes-media-slot__crop-img.translate-x--66 {
    --translate-x: -66px; }
  .profile-themes-media-slot__crop-img.translate-x--65 {
    --translate-x: -65px; }
  .profile-themes-media-slot__crop-img.translate-x--64 {
    --translate-x: -64px; }
  .profile-themes-media-slot__crop-img.translate-x--63 {
    --translate-x: -63px; }
  .profile-themes-media-slot__crop-img.translate-x--62 {
    --translate-x: -62px; }
  .profile-themes-media-slot__crop-img.translate-x--61 {
    --translate-x: -61px; }
  .profile-themes-media-slot__crop-img.translate-x--60 {
    --translate-x: -60px; }
  .profile-themes-media-slot__crop-img.translate-x--59 {
    --translate-x: -59px; }
  .profile-themes-media-slot__crop-img.translate-x--58 {
    --translate-x: -58px; }
  .profile-themes-media-slot__crop-img.translate-x--57 {
    --translate-x: -57px; }
  .profile-themes-media-slot__crop-img.translate-x--56 {
    --translate-x: -56px; }
  .profile-themes-media-slot__crop-img.translate-x--55 {
    --translate-x: -55px; }
  .profile-themes-media-slot__crop-img.translate-x--54 {
    --translate-x: -54px; }
  .profile-themes-media-slot__crop-img.translate-x--53 {
    --translate-x: -53px; }
  .profile-themes-media-slot__crop-img.translate-x--52 {
    --translate-x: -52px; }
  .profile-themes-media-slot__crop-img.translate-x--51 {
    --translate-x: -51px; }
  .profile-themes-media-slot__crop-img.translate-x--50 {
    --translate-x: -50px; }
  .profile-themes-media-slot__crop-img.translate-x--49 {
    --translate-x: -49px; }
  .profile-themes-media-slot__crop-img.translate-x--48 {
    --translate-x: -48px; }
  .profile-themes-media-slot__crop-img.translate-x--47 {
    --translate-x: -47px; }
  .profile-themes-media-slot__crop-img.translate-x--46 {
    --translate-x: -46px; }
  .profile-themes-media-slot__crop-img.translate-x--45 {
    --translate-x: -45px; }
  .profile-themes-media-slot__crop-img.translate-x--44 {
    --translate-x: -44px; }
  .profile-themes-media-slot__crop-img.translate-x--43 {
    --translate-x: -43px; }
  .profile-themes-media-slot__crop-img.translate-x--42 {
    --translate-x: -42px; }
  .profile-themes-media-slot__crop-img.translate-x--41 {
    --translate-x: -41px; }
  .profile-themes-media-slot__crop-img.translate-x--40 {
    --translate-x: -40px; }
  .profile-themes-media-slot__crop-img.translate-x--39 {
    --translate-x: -39px; }
  .profile-themes-media-slot__crop-img.translate-x--38 {
    --translate-x: -38px; }
  .profile-themes-media-slot__crop-img.translate-x--37 {
    --translate-x: -37px; }
  .profile-themes-media-slot__crop-img.translate-x--36 {
    --translate-x: -36px; }
  .profile-themes-media-slot__crop-img.translate-x--35 {
    --translate-x: -35px; }
  .profile-themes-media-slot__crop-img.translate-x--34 {
    --translate-x: -34px; }
  .profile-themes-media-slot__crop-img.translate-x--33 {
    --translate-x: -33px; }
  .profile-themes-media-slot__crop-img.translate-x--32 {
    --translate-x: -32px; }
  .profile-themes-media-slot__crop-img.translate-x--31 {
    --translate-x: -31px; }
  .profile-themes-media-slot__crop-img.translate-x--30 {
    --translate-x: -30px; }
  .profile-themes-media-slot__crop-img.translate-x--29 {
    --translate-x: -29px; }
  .profile-themes-media-slot__crop-img.translate-x--28 {
    --translate-x: -28px; }
  .profile-themes-media-slot__crop-img.translate-x--27 {
    --translate-x: -27px; }
  .profile-themes-media-slot__crop-img.translate-x--26 {
    --translate-x: -26px; }
  .profile-themes-media-slot__crop-img.translate-x--25 {
    --translate-x: -25px; }
  .profile-themes-media-slot__crop-img.translate-x--24 {
    --translate-x: -24px; }
  .profile-themes-media-slot__crop-img.translate-x--23 {
    --translate-x: -23px; }
  .profile-themes-media-slot__crop-img.translate-x--22 {
    --translate-x: -22px; }
  .profile-themes-media-slot__crop-img.translate-x--21 {
    --translate-x: -21px; }
  .profile-themes-media-slot__crop-img.translate-x--20 {
    --translate-x: -20px; }
  .profile-themes-media-slot__crop-img.translate-x--19 {
    --translate-x: -19px; }
  .profile-themes-media-slot__crop-img.translate-x--18 {
    --translate-x: -18px; }
  .profile-themes-media-slot__crop-img.translate-x--17 {
    --translate-x: -17px; }
  .profile-themes-media-slot__crop-img.translate-x--16 {
    --translate-x: -16px; }
  .profile-themes-media-slot__crop-img.translate-x--15 {
    --translate-x: -15px; }
  .profile-themes-media-slot__crop-img.translate-x--14 {
    --translate-x: -14px; }
  .profile-themes-media-slot__crop-img.translate-x--13 {
    --translate-x: -13px; }
  .profile-themes-media-slot__crop-img.translate-x--12 {
    --translate-x: -12px; }
  .profile-themes-media-slot__crop-img.translate-x--11 {
    --translate-x: -11px; }
  .profile-themes-media-slot__crop-img.translate-x--10 {
    --translate-x: -10px; }
  .profile-themes-media-slot__crop-img.translate-x--9 {
    --translate-x: -9px; }
  .profile-themes-media-slot__crop-img.translate-x--8 {
    --translate-x: -8px; }
  .profile-themes-media-slot__crop-img.translate-x--7 {
    --translate-x: -7px; }
  .profile-themes-media-slot__crop-img.translate-x--6 {
    --translate-x: -6px; }
  .profile-themes-media-slot__crop-img.translate-x--5 {
    --translate-x: -5px; }
  .profile-themes-media-slot__crop-img.translate-x--4 {
    --translate-x: -4px; }
  .profile-themes-media-slot__crop-img.translate-x--3 {
    --translate-x: -3px; }
  .profile-themes-media-slot__crop-img.translate-x--2 {
    --translate-x: -2px; }
  .profile-themes-media-slot__crop-img.translate-x--1 {
    --translate-x: -1px; }
  .profile-themes-media-slot__crop-img.translate-x-0 {
    --translate-x: 0px; }
  .profile-themes-media-slot__crop-img.translate-x-1 {
    --translate-x: 1px; }
  .profile-themes-media-slot__crop-img.translate-x-2 {
    --translate-x: 2px; }
  .profile-themes-media-slot__crop-img.translate-x-3 {
    --translate-x: 3px; }
  .profile-themes-media-slot__crop-img.translate-x-4 {
    --translate-x: 4px; }
  .profile-themes-media-slot__crop-img.translate-x-5 {
    --translate-x: 5px; }
  .profile-themes-media-slot__crop-img.translate-x-6 {
    --translate-x: 6px; }
  .profile-themes-media-slot__crop-img.translate-x-7 {
    --translate-x: 7px; }
  .profile-themes-media-slot__crop-img.translate-x-8 {
    --translate-x: 8px; }
  .profile-themes-media-slot__crop-img.translate-x-9 {
    --translate-x: 9px; }
  .profile-themes-media-slot__crop-img.translate-x-10 {
    --translate-x: 10px; }
  .profile-themes-media-slot__crop-img.translate-x-11 {
    --translate-x: 11px; }
  .profile-themes-media-slot__crop-img.translate-x-12 {
    --translate-x: 12px; }
  .profile-themes-media-slot__crop-img.translate-x-13 {
    --translate-x: 13px; }
  .profile-themes-media-slot__crop-img.translate-x-14 {
    --translate-x: 14px; }
  .profile-themes-media-slot__crop-img.translate-x-15 {
    --translate-x: 15px; }
  .profile-themes-media-slot__crop-img.translate-x-16 {
    --translate-x: 16px; }
  .profile-themes-media-slot__crop-img.translate-x-17 {
    --translate-x: 17px; }
  .profile-themes-media-slot__crop-img.translate-x-18 {
    --translate-x: 18px; }
  .profile-themes-media-slot__crop-img.translate-x-19 {
    --translate-x: 19px; }
  .profile-themes-media-slot__crop-img.translate-x-20 {
    --translate-x: 20px; }
  .profile-themes-media-slot__crop-img.translate-x-21 {
    --translate-x: 21px; }
  .profile-themes-media-slot__crop-img.translate-x-22 {
    --translate-x: 22px; }
  .profile-themes-media-slot__crop-img.translate-x-23 {
    --translate-x: 23px; }
  .profile-themes-media-slot__crop-img.translate-x-24 {
    --translate-x: 24px; }
  .profile-themes-media-slot__crop-img.translate-x-25 {
    --translate-x: 25px; }
  .profile-themes-media-slot__crop-img.translate-x-26 {
    --translate-x: 26px; }
  .profile-themes-media-slot__crop-img.translate-x-27 {
    --translate-x: 27px; }
  .profile-themes-media-slot__crop-img.translate-x-28 {
    --translate-x: 28px; }
  .profile-themes-media-slot__crop-img.translate-x-29 {
    --translate-x: 29px; }
  .profile-themes-media-slot__crop-img.translate-x-30 {
    --translate-x: 30px; }
  .profile-themes-media-slot__crop-img.translate-x-31 {
    --translate-x: 31px; }
  .profile-themes-media-slot__crop-img.translate-x-32 {
    --translate-x: 32px; }
  .profile-themes-media-slot__crop-img.translate-x-33 {
    --translate-x: 33px; }
  .profile-themes-media-slot__crop-img.translate-x-34 {
    --translate-x: 34px; }
  .profile-themes-media-slot__crop-img.translate-x-35 {
    --translate-x: 35px; }
  .profile-themes-media-slot__crop-img.translate-x-36 {
    --translate-x: 36px; }
  .profile-themes-media-slot__crop-img.translate-x-37 {
    --translate-x: 37px; }
  .profile-themes-media-slot__crop-img.translate-x-38 {
    --translate-x: 38px; }
  .profile-themes-media-slot__crop-img.translate-x-39 {
    --translate-x: 39px; }
  .profile-themes-media-slot__crop-img.translate-x-40 {
    --translate-x: 40px; }
  .profile-themes-media-slot__crop-img.translate-x-41 {
    --translate-x: 41px; }
  .profile-themes-media-slot__crop-img.translate-x-42 {
    --translate-x: 42px; }
  .profile-themes-media-slot__crop-img.translate-x-43 {
    --translate-x: 43px; }
  .profile-themes-media-slot__crop-img.translate-x-44 {
    --translate-x: 44px; }
  .profile-themes-media-slot__crop-img.translate-x-45 {
    --translate-x: 45px; }
  .profile-themes-media-slot__crop-img.translate-x-46 {
    --translate-x: 46px; }
  .profile-themes-media-slot__crop-img.translate-x-47 {
    --translate-x: 47px; }
  .profile-themes-media-slot__crop-img.translate-x-48 {
    --translate-x: 48px; }
  .profile-themes-media-slot__crop-img.translate-x-49 {
    --translate-x: 49px; }
  .profile-themes-media-slot__crop-img.translate-x-50 {
    --translate-x: 50px; }
  .profile-themes-media-slot__crop-img.translate-y--800 {
    --translate-y: -800px; }
  .profile-themes-media-slot__crop-img.translate-y--799 {
    --translate-y: -799px; }
  .profile-themes-media-slot__crop-img.translate-y--798 {
    --translate-y: -798px; }
  .profile-themes-media-slot__crop-img.translate-y--797 {
    --translate-y: -797px; }
  .profile-themes-media-slot__crop-img.translate-y--796 {
    --translate-y: -796px; }
  .profile-themes-media-slot__crop-img.translate-y--795 {
    --translate-y: -795px; }
  .profile-themes-media-slot__crop-img.translate-y--794 {
    --translate-y: -794px; }
  .profile-themes-media-slot__crop-img.translate-y--793 {
    --translate-y: -793px; }
  .profile-themes-media-slot__crop-img.translate-y--792 {
    --translate-y: -792px; }
  .profile-themes-media-slot__crop-img.translate-y--791 {
    --translate-y: -791px; }
  .profile-themes-media-slot__crop-img.translate-y--790 {
    --translate-y: -790px; }
  .profile-themes-media-slot__crop-img.translate-y--789 {
    --translate-y: -789px; }
  .profile-themes-media-slot__crop-img.translate-y--788 {
    --translate-y: -788px; }
  .profile-themes-media-slot__crop-img.translate-y--787 {
    --translate-y: -787px; }
  .profile-themes-media-slot__crop-img.translate-y--786 {
    --translate-y: -786px; }
  .profile-themes-media-slot__crop-img.translate-y--785 {
    --translate-y: -785px; }
  .profile-themes-media-slot__crop-img.translate-y--784 {
    --translate-y: -784px; }
  .profile-themes-media-slot__crop-img.translate-y--783 {
    --translate-y: -783px; }
  .profile-themes-media-slot__crop-img.translate-y--782 {
    --translate-y: -782px; }
  .profile-themes-media-slot__crop-img.translate-y--781 {
    --translate-y: -781px; }
  .profile-themes-media-slot__crop-img.translate-y--780 {
    --translate-y: -780px; }
  .profile-themes-media-slot__crop-img.translate-y--779 {
    --translate-y: -779px; }
  .profile-themes-media-slot__crop-img.translate-y--778 {
    --translate-y: -778px; }
  .profile-themes-media-slot__crop-img.translate-y--777 {
    --translate-y: -777px; }
  .profile-themes-media-slot__crop-img.translate-y--776 {
    --translate-y: -776px; }
  .profile-themes-media-slot__crop-img.translate-y--775 {
    --translate-y: -775px; }
  .profile-themes-media-slot__crop-img.translate-y--774 {
    --translate-y: -774px; }
  .profile-themes-media-slot__crop-img.translate-y--773 {
    --translate-y: -773px; }
  .profile-themes-media-slot__crop-img.translate-y--772 {
    --translate-y: -772px; }
  .profile-themes-media-slot__crop-img.translate-y--771 {
    --translate-y: -771px; }
  .profile-themes-media-slot__crop-img.translate-y--770 {
    --translate-y: -770px; }
  .profile-themes-media-slot__crop-img.translate-y--769 {
    --translate-y: -769px; }
  .profile-themes-media-slot__crop-img.translate-y--768 {
    --translate-y: -768px; }
  .profile-themes-media-slot__crop-img.translate-y--767 {
    --translate-y: -767px; }
  .profile-themes-media-slot__crop-img.translate-y--766 {
    --translate-y: -766px; }
  .profile-themes-media-slot__crop-img.translate-y--765 {
    --translate-y: -765px; }
  .profile-themes-media-slot__crop-img.translate-y--764 {
    --translate-y: -764px; }
  .profile-themes-media-slot__crop-img.translate-y--763 {
    --translate-y: -763px; }
  .profile-themes-media-slot__crop-img.translate-y--762 {
    --translate-y: -762px; }
  .profile-themes-media-slot__crop-img.translate-y--761 {
    --translate-y: -761px; }
  .profile-themes-media-slot__crop-img.translate-y--760 {
    --translate-y: -760px; }
  .profile-themes-media-slot__crop-img.translate-y--759 {
    --translate-y: -759px; }
  .profile-themes-media-slot__crop-img.translate-y--758 {
    --translate-y: -758px; }
  .profile-themes-media-slot__crop-img.translate-y--757 {
    --translate-y: -757px; }
  .profile-themes-media-slot__crop-img.translate-y--756 {
    --translate-y: -756px; }
  .profile-themes-media-slot__crop-img.translate-y--755 {
    --translate-y: -755px; }
  .profile-themes-media-slot__crop-img.translate-y--754 {
    --translate-y: -754px; }
  .profile-themes-media-slot__crop-img.translate-y--753 {
    --translate-y: -753px; }
  .profile-themes-media-slot__crop-img.translate-y--752 {
    --translate-y: -752px; }
  .profile-themes-media-slot__crop-img.translate-y--751 {
    --translate-y: -751px; }
  .profile-themes-media-slot__crop-img.translate-y--750 {
    --translate-y: -750px; }
  .profile-themes-media-slot__crop-img.translate-y--749 {
    --translate-y: -749px; }
  .profile-themes-media-slot__crop-img.translate-y--748 {
    --translate-y: -748px; }
  .profile-themes-media-slot__crop-img.translate-y--747 {
    --translate-y: -747px; }
  .profile-themes-media-slot__crop-img.translate-y--746 {
    --translate-y: -746px; }
  .profile-themes-media-slot__crop-img.translate-y--745 {
    --translate-y: -745px; }
  .profile-themes-media-slot__crop-img.translate-y--744 {
    --translate-y: -744px; }
  .profile-themes-media-slot__crop-img.translate-y--743 {
    --translate-y: -743px; }
  .profile-themes-media-slot__crop-img.translate-y--742 {
    --translate-y: -742px; }
  .profile-themes-media-slot__crop-img.translate-y--741 {
    --translate-y: -741px; }
  .profile-themes-media-slot__crop-img.translate-y--740 {
    --translate-y: -740px; }
  .profile-themes-media-slot__crop-img.translate-y--739 {
    --translate-y: -739px; }
  .profile-themes-media-slot__crop-img.translate-y--738 {
    --translate-y: -738px; }
  .profile-themes-media-slot__crop-img.translate-y--737 {
    --translate-y: -737px; }
  .profile-themes-media-slot__crop-img.translate-y--736 {
    --translate-y: -736px; }
  .profile-themes-media-slot__crop-img.translate-y--735 {
    --translate-y: -735px; }
  .profile-themes-media-slot__crop-img.translate-y--734 {
    --translate-y: -734px; }
  .profile-themes-media-slot__crop-img.translate-y--733 {
    --translate-y: -733px; }
  .profile-themes-media-slot__crop-img.translate-y--732 {
    --translate-y: -732px; }
  .profile-themes-media-slot__crop-img.translate-y--731 {
    --translate-y: -731px; }
  .profile-themes-media-slot__crop-img.translate-y--730 {
    --translate-y: -730px; }
  .profile-themes-media-slot__crop-img.translate-y--729 {
    --translate-y: -729px; }
  .profile-themes-media-slot__crop-img.translate-y--728 {
    --translate-y: -728px; }
  .profile-themes-media-slot__crop-img.translate-y--727 {
    --translate-y: -727px; }
  .profile-themes-media-slot__crop-img.translate-y--726 {
    --translate-y: -726px; }
  .profile-themes-media-slot__crop-img.translate-y--725 {
    --translate-y: -725px; }
  .profile-themes-media-slot__crop-img.translate-y--724 {
    --translate-y: -724px; }
  .profile-themes-media-slot__crop-img.translate-y--723 {
    --translate-y: -723px; }
  .profile-themes-media-slot__crop-img.translate-y--722 {
    --translate-y: -722px; }
  .profile-themes-media-slot__crop-img.translate-y--721 {
    --translate-y: -721px; }
  .profile-themes-media-slot__crop-img.translate-y--720 {
    --translate-y: -720px; }
  .profile-themes-media-slot__crop-img.translate-y--719 {
    --translate-y: -719px; }
  .profile-themes-media-slot__crop-img.translate-y--718 {
    --translate-y: -718px; }
  .profile-themes-media-slot__crop-img.translate-y--717 {
    --translate-y: -717px; }
  .profile-themes-media-slot__crop-img.translate-y--716 {
    --translate-y: -716px; }
  .profile-themes-media-slot__crop-img.translate-y--715 {
    --translate-y: -715px; }
  .profile-themes-media-slot__crop-img.translate-y--714 {
    --translate-y: -714px; }
  .profile-themes-media-slot__crop-img.translate-y--713 {
    --translate-y: -713px; }
  .profile-themes-media-slot__crop-img.translate-y--712 {
    --translate-y: -712px; }
  .profile-themes-media-slot__crop-img.translate-y--711 {
    --translate-y: -711px; }
  .profile-themes-media-slot__crop-img.translate-y--710 {
    --translate-y: -710px; }
  .profile-themes-media-slot__crop-img.translate-y--709 {
    --translate-y: -709px; }
  .profile-themes-media-slot__crop-img.translate-y--708 {
    --translate-y: -708px; }
  .profile-themes-media-slot__crop-img.translate-y--707 {
    --translate-y: -707px; }
  .profile-themes-media-slot__crop-img.translate-y--706 {
    --translate-y: -706px; }
  .profile-themes-media-slot__crop-img.translate-y--705 {
    --translate-y: -705px; }
  .profile-themes-media-slot__crop-img.translate-y--704 {
    --translate-y: -704px; }
  .profile-themes-media-slot__crop-img.translate-y--703 {
    --translate-y: -703px; }
  .profile-themes-media-slot__crop-img.translate-y--702 {
    --translate-y: -702px; }
  .profile-themes-media-slot__crop-img.translate-y--701 {
    --translate-y: -701px; }
  .profile-themes-media-slot__crop-img.translate-y--700 {
    --translate-y: -700px; }
  .profile-themes-media-slot__crop-img.translate-y--699 {
    --translate-y: -699px; }
  .profile-themes-media-slot__crop-img.translate-y--698 {
    --translate-y: -698px; }
  .profile-themes-media-slot__crop-img.translate-y--697 {
    --translate-y: -697px; }
  .profile-themes-media-slot__crop-img.translate-y--696 {
    --translate-y: -696px; }
  .profile-themes-media-slot__crop-img.translate-y--695 {
    --translate-y: -695px; }
  .profile-themes-media-slot__crop-img.translate-y--694 {
    --translate-y: -694px; }
  .profile-themes-media-slot__crop-img.translate-y--693 {
    --translate-y: -693px; }
  .profile-themes-media-slot__crop-img.translate-y--692 {
    --translate-y: -692px; }
  .profile-themes-media-slot__crop-img.translate-y--691 {
    --translate-y: -691px; }
  .profile-themes-media-slot__crop-img.translate-y--690 {
    --translate-y: -690px; }
  .profile-themes-media-slot__crop-img.translate-y--689 {
    --translate-y: -689px; }
  .profile-themes-media-slot__crop-img.translate-y--688 {
    --translate-y: -688px; }
  .profile-themes-media-slot__crop-img.translate-y--687 {
    --translate-y: -687px; }
  .profile-themes-media-slot__crop-img.translate-y--686 {
    --translate-y: -686px; }
  .profile-themes-media-slot__crop-img.translate-y--685 {
    --translate-y: -685px; }
  .profile-themes-media-slot__crop-img.translate-y--684 {
    --translate-y: -684px; }
  .profile-themes-media-slot__crop-img.translate-y--683 {
    --translate-y: -683px; }
  .profile-themes-media-slot__crop-img.translate-y--682 {
    --translate-y: -682px; }
  .profile-themes-media-slot__crop-img.translate-y--681 {
    --translate-y: -681px; }
  .profile-themes-media-slot__crop-img.translate-y--680 {
    --translate-y: -680px; }
  .profile-themes-media-slot__crop-img.translate-y--679 {
    --translate-y: -679px; }
  .profile-themes-media-slot__crop-img.translate-y--678 {
    --translate-y: -678px; }
  .profile-themes-media-slot__crop-img.translate-y--677 {
    --translate-y: -677px; }
  .profile-themes-media-slot__crop-img.translate-y--676 {
    --translate-y: -676px; }
  .profile-themes-media-slot__crop-img.translate-y--675 {
    --translate-y: -675px; }
  .profile-themes-media-slot__crop-img.translate-y--674 {
    --translate-y: -674px; }
  .profile-themes-media-slot__crop-img.translate-y--673 {
    --translate-y: -673px; }
  .profile-themes-media-slot__crop-img.translate-y--672 {
    --translate-y: -672px; }
  .profile-themes-media-slot__crop-img.translate-y--671 {
    --translate-y: -671px; }
  .profile-themes-media-slot__crop-img.translate-y--670 {
    --translate-y: -670px; }
  .profile-themes-media-slot__crop-img.translate-y--669 {
    --translate-y: -669px; }
  .profile-themes-media-slot__crop-img.translate-y--668 {
    --translate-y: -668px; }
  .profile-themes-media-slot__crop-img.translate-y--667 {
    --translate-y: -667px; }
  .profile-themes-media-slot__crop-img.translate-y--666 {
    --translate-y: -666px; }
  .profile-themes-media-slot__crop-img.translate-y--665 {
    --translate-y: -665px; }
  .profile-themes-media-slot__crop-img.translate-y--664 {
    --translate-y: -664px; }
  .profile-themes-media-slot__crop-img.translate-y--663 {
    --translate-y: -663px; }
  .profile-themes-media-slot__crop-img.translate-y--662 {
    --translate-y: -662px; }
  .profile-themes-media-slot__crop-img.translate-y--661 {
    --translate-y: -661px; }
  .profile-themes-media-slot__crop-img.translate-y--660 {
    --translate-y: -660px; }
  .profile-themes-media-slot__crop-img.translate-y--659 {
    --translate-y: -659px; }
  .profile-themes-media-slot__crop-img.translate-y--658 {
    --translate-y: -658px; }
  .profile-themes-media-slot__crop-img.translate-y--657 {
    --translate-y: -657px; }
  .profile-themes-media-slot__crop-img.translate-y--656 {
    --translate-y: -656px; }
  .profile-themes-media-slot__crop-img.translate-y--655 {
    --translate-y: -655px; }
  .profile-themes-media-slot__crop-img.translate-y--654 {
    --translate-y: -654px; }
  .profile-themes-media-slot__crop-img.translate-y--653 {
    --translate-y: -653px; }
  .profile-themes-media-slot__crop-img.translate-y--652 {
    --translate-y: -652px; }
  .profile-themes-media-slot__crop-img.translate-y--651 {
    --translate-y: -651px; }
  .profile-themes-media-slot__crop-img.translate-y--650 {
    --translate-y: -650px; }
  .profile-themes-media-slot__crop-img.translate-y--649 {
    --translate-y: -649px; }
  .profile-themes-media-slot__crop-img.translate-y--648 {
    --translate-y: -648px; }
  .profile-themes-media-slot__crop-img.translate-y--647 {
    --translate-y: -647px; }
  .profile-themes-media-slot__crop-img.translate-y--646 {
    --translate-y: -646px; }
  .profile-themes-media-slot__crop-img.translate-y--645 {
    --translate-y: -645px; }
  .profile-themes-media-slot__crop-img.translate-y--644 {
    --translate-y: -644px; }
  .profile-themes-media-slot__crop-img.translate-y--643 {
    --translate-y: -643px; }
  .profile-themes-media-slot__crop-img.translate-y--642 {
    --translate-y: -642px; }
  .profile-themes-media-slot__crop-img.translate-y--641 {
    --translate-y: -641px; }
  .profile-themes-media-slot__crop-img.translate-y--640 {
    --translate-y: -640px; }
  .profile-themes-media-slot__crop-img.translate-y--639 {
    --translate-y: -639px; }
  .profile-themes-media-slot__crop-img.translate-y--638 {
    --translate-y: -638px; }
  .profile-themes-media-slot__crop-img.translate-y--637 {
    --translate-y: -637px; }
  .profile-themes-media-slot__crop-img.translate-y--636 {
    --translate-y: -636px; }
  .profile-themes-media-slot__crop-img.translate-y--635 {
    --translate-y: -635px; }
  .profile-themes-media-slot__crop-img.translate-y--634 {
    --translate-y: -634px; }
  .profile-themes-media-slot__crop-img.translate-y--633 {
    --translate-y: -633px; }
  .profile-themes-media-slot__crop-img.translate-y--632 {
    --translate-y: -632px; }
  .profile-themes-media-slot__crop-img.translate-y--631 {
    --translate-y: -631px; }
  .profile-themes-media-slot__crop-img.translate-y--630 {
    --translate-y: -630px; }
  .profile-themes-media-slot__crop-img.translate-y--629 {
    --translate-y: -629px; }
  .profile-themes-media-slot__crop-img.translate-y--628 {
    --translate-y: -628px; }
  .profile-themes-media-slot__crop-img.translate-y--627 {
    --translate-y: -627px; }
  .profile-themes-media-slot__crop-img.translate-y--626 {
    --translate-y: -626px; }
  .profile-themes-media-slot__crop-img.translate-y--625 {
    --translate-y: -625px; }
  .profile-themes-media-slot__crop-img.translate-y--624 {
    --translate-y: -624px; }
  .profile-themes-media-slot__crop-img.translate-y--623 {
    --translate-y: -623px; }
  .profile-themes-media-slot__crop-img.translate-y--622 {
    --translate-y: -622px; }
  .profile-themes-media-slot__crop-img.translate-y--621 {
    --translate-y: -621px; }
  .profile-themes-media-slot__crop-img.translate-y--620 {
    --translate-y: -620px; }
  .profile-themes-media-slot__crop-img.translate-y--619 {
    --translate-y: -619px; }
  .profile-themes-media-slot__crop-img.translate-y--618 {
    --translate-y: -618px; }
  .profile-themes-media-slot__crop-img.translate-y--617 {
    --translate-y: -617px; }
  .profile-themes-media-slot__crop-img.translate-y--616 {
    --translate-y: -616px; }
  .profile-themes-media-slot__crop-img.translate-y--615 {
    --translate-y: -615px; }
  .profile-themes-media-slot__crop-img.translate-y--614 {
    --translate-y: -614px; }
  .profile-themes-media-slot__crop-img.translate-y--613 {
    --translate-y: -613px; }
  .profile-themes-media-slot__crop-img.translate-y--612 {
    --translate-y: -612px; }
  .profile-themes-media-slot__crop-img.translate-y--611 {
    --translate-y: -611px; }
  .profile-themes-media-slot__crop-img.translate-y--610 {
    --translate-y: -610px; }
  .profile-themes-media-slot__crop-img.translate-y--609 {
    --translate-y: -609px; }
  .profile-themes-media-slot__crop-img.translate-y--608 {
    --translate-y: -608px; }
  .profile-themes-media-slot__crop-img.translate-y--607 {
    --translate-y: -607px; }
  .profile-themes-media-slot__crop-img.translate-y--606 {
    --translate-y: -606px; }
  .profile-themes-media-slot__crop-img.translate-y--605 {
    --translate-y: -605px; }
  .profile-themes-media-slot__crop-img.translate-y--604 {
    --translate-y: -604px; }
  .profile-themes-media-slot__crop-img.translate-y--603 {
    --translate-y: -603px; }
  .profile-themes-media-slot__crop-img.translate-y--602 {
    --translate-y: -602px; }
  .profile-themes-media-slot__crop-img.translate-y--601 {
    --translate-y: -601px; }
  .profile-themes-media-slot__crop-img.translate-y--600 {
    --translate-y: -600px; }
  .profile-themes-media-slot__crop-img.translate-y--599 {
    --translate-y: -599px; }
  .profile-themes-media-slot__crop-img.translate-y--598 {
    --translate-y: -598px; }
  .profile-themes-media-slot__crop-img.translate-y--597 {
    --translate-y: -597px; }
  .profile-themes-media-slot__crop-img.translate-y--596 {
    --translate-y: -596px; }
  .profile-themes-media-slot__crop-img.translate-y--595 {
    --translate-y: -595px; }
  .profile-themes-media-slot__crop-img.translate-y--594 {
    --translate-y: -594px; }
  .profile-themes-media-slot__crop-img.translate-y--593 {
    --translate-y: -593px; }
  .profile-themes-media-slot__crop-img.translate-y--592 {
    --translate-y: -592px; }
  .profile-themes-media-slot__crop-img.translate-y--591 {
    --translate-y: -591px; }
  .profile-themes-media-slot__crop-img.translate-y--590 {
    --translate-y: -590px; }
  .profile-themes-media-slot__crop-img.translate-y--589 {
    --translate-y: -589px; }
  .profile-themes-media-slot__crop-img.translate-y--588 {
    --translate-y: -588px; }
  .profile-themes-media-slot__crop-img.translate-y--587 {
    --translate-y: -587px; }
  .profile-themes-media-slot__crop-img.translate-y--586 {
    --translate-y: -586px; }
  .profile-themes-media-slot__crop-img.translate-y--585 {
    --translate-y: -585px; }
  .profile-themes-media-slot__crop-img.translate-y--584 {
    --translate-y: -584px; }
  .profile-themes-media-slot__crop-img.translate-y--583 {
    --translate-y: -583px; }
  .profile-themes-media-slot__crop-img.translate-y--582 {
    --translate-y: -582px; }
  .profile-themes-media-slot__crop-img.translate-y--581 {
    --translate-y: -581px; }
  .profile-themes-media-slot__crop-img.translate-y--580 {
    --translate-y: -580px; }
  .profile-themes-media-slot__crop-img.translate-y--579 {
    --translate-y: -579px; }
  .profile-themes-media-slot__crop-img.translate-y--578 {
    --translate-y: -578px; }
  .profile-themes-media-slot__crop-img.translate-y--577 {
    --translate-y: -577px; }
  .profile-themes-media-slot__crop-img.translate-y--576 {
    --translate-y: -576px; }
  .profile-themes-media-slot__crop-img.translate-y--575 {
    --translate-y: -575px; }
  .profile-themes-media-slot__crop-img.translate-y--574 {
    --translate-y: -574px; }
  .profile-themes-media-slot__crop-img.translate-y--573 {
    --translate-y: -573px; }
  .profile-themes-media-slot__crop-img.translate-y--572 {
    --translate-y: -572px; }
  .profile-themes-media-slot__crop-img.translate-y--571 {
    --translate-y: -571px; }
  .profile-themes-media-slot__crop-img.translate-y--570 {
    --translate-y: -570px; }
  .profile-themes-media-slot__crop-img.translate-y--569 {
    --translate-y: -569px; }
  .profile-themes-media-slot__crop-img.translate-y--568 {
    --translate-y: -568px; }
  .profile-themes-media-slot__crop-img.translate-y--567 {
    --translate-y: -567px; }
  .profile-themes-media-slot__crop-img.translate-y--566 {
    --translate-y: -566px; }
  .profile-themes-media-slot__crop-img.translate-y--565 {
    --translate-y: -565px; }
  .profile-themes-media-slot__crop-img.translate-y--564 {
    --translate-y: -564px; }
  .profile-themes-media-slot__crop-img.translate-y--563 {
    --translate-y: -563px; }
  .profile-themes-media-slot__crop-img.translate-y--562 {
    --translate-y: -562px; }
  .profile-themes-media-slot__crop-img.translate-y--561 {
    --translate-y: -561px; }
  .profile-themes-media-slot__crop-img.translate-y--560 {
    --translate-y: -560px; }
  .profile-themes-media-slot__crop-img.translate-y--559 {
    --translate-y: -559px; }
  .profile-themes-media-slot__crop-img.translate-y--558 {
    --translate-y: -558px; }
  .profile-themes-media-slot__crop-img.translate-y--557 {
    --translate-y: -557px; }
  .profile-themes-media-slot__crop-img.translate-y--556 {
    --translate-y: -556px; }
  .profile-themes-media-slot__crop-img.translate-y--555 {
    --translate-y: -555px; }
  .profile-themes-media-slot__crop-img.translate-y--554 {
    --translate-y: -554px; }
  .profile-themes-media-slot__crop-img.translate-y--553 {
    --translate-y: -553px; }
  .profile-themes-media-slot__crop-img.translate-y--552 {
    --translate-y: -552px; }
  .profile-themes-media-slot__crop-img.translate-y--551 {
    --translate-y: -551px; }
  .profile-themes-media-slot__crop-img.translate-y--550 {
    --translate-y: -550px; }
  .profile-themes-media-slot__crop-img.translate-y--549 {
    --translate-y: -549px; }
  .profile-themes-media-slot__crop-img.translate-y--548 {
    --translate-y: -548px; }
  .profile-themes-media-slot__crop-img.translate-y--547 {
    --translate-y: -547px; }
  .profile-themes-media-slot__crop-img.translate-y--546 {
    --translate-y: -546px; }
  .profile-themes-media-slot__crop-img.translate-y--545 {
    --translate-y: -545px; }
  .profile-themes-media-slot__crop-img.translate-y--544 {
    --translate-y: -544px; }
  .profile-themes-media-slot__crop-img.translate-y--543 {
    --translate-y: -543px; }
  .profile-themes-media-slot__crop-img.translate-y--542 {
    --translate-y: -542px; }
  .profile-themes-media-slot__crop-img.translate-y--541 {
    --translate-y: -541px; }
  .profile-themes-media-slot__crop-img.translate-y--540 {
    --translate-y: -540px; }
  .profile-themes-media-slot__crop-img.translate-y--539 {
    --translate-y: -539px; }
  .profile-themes-media-slot__crop-img.translate-y--538 {
    --translate-y: -538px; }
  .profile-themes-media-slot__crop-img.translate-y--537 {
    --translate-y: -537px; }
  .profile-themes-media-slot__crop-img.translate-y--536 {
    --translate-y: -536px; }
  .profile-themes-media-slot__crop-img.translate-y--535 {
    --translate-y: -535px; }
  .profile-themes-media-slot__crop-img.translate-y--534 {
    --translate-y: -534px; }
  .profile-themes-media-slot__crop-img.translate-y--533 {
    --translate-y: -533px; }
  .profile-themes-media-slot__crop-img.translate-y--532 {
    --translate-y: -532px; }
  .profile-themes-media-slot__crop-img.translate-y--531 {
    --translate-y: -531px; }
  .profile-themes-media-slot__crop-img.translate-y--530 {
    --translate-y: -530px; }
  .profile-themes-media-slot__crop-img.translate-y--529 {
    --translate-y: -529px; }
  .profile-themes-media-slot__crop-img.translate-y--528 {
    --translate-y: -528px; }
  .profile-themes-media-slot__crop-img.translate-y--527 {
    --translate-y: -527px; }
  .profile-themes-media-slot__crop-img.translate-y--526 {
    --translate-y: -526px; }
  .profile-themes-media-slot__crop-img.translate-y--525 {
    --translate-y: -525px; }
  .profile-themes-media-slot__crop-img.translate-y--524 {
    --translate-y: -524px; }
  .profile-themes-media-slot__crop-img.translate-y--523 {
    --translate-y: -523px; }
  .profile-themes-media-slot__crop-img.translate-y--522 {
    --translate-y: -522px; }
  .profile-themes-media-slot__crop-img.translate-y--521 {
    --translate-y: -521px; }
  .profile-themes-media-slot__crop-img.translate-y--520 {
    --translate-y: -520px; }
  .profile-themes-media-slot__crop-img.translate-y--519 {
    --translate-y: -519px; }
  .profile-themes-media-slot__crop-img.translate-y--518 {
    --translate-y: -518px; }
  .profile-themes-media-slot__crop-img.translate-y--517 {
    --translate-y: -517px; }
  .profile-themes-media-slot__crop-img.translate-y--516 {
    --translate-y: -516px; }
  .profile-themes-media-slot__crop-img.translate-y--515 {
    --translate-y: -515px; }
  .profile-themes-media-slot__crop-img.translate-y--514 {
    --translate-y: -514px; }
  .profile-themes-media-slot__crop-img.translate-y--513 {
    --translate-y: -513px; }
  .profile-themes-media-slot__crop-img.translate-y--512 {
    --translate-y: -512px; }
  .profile-themes-media-slot__crop-img.translate-y--511 {
    --translate-y: -511px; }
  .profile-themes-media-slot__crop-img.translate-y--510 {
    --translate-y: -510px; }
  .profile-themes-media-slot__crop-img.translate-y--509 {
    --translate-y: -509px; }
  .profile-themes-media-slot__crop-img.translate-y--508 {
    --translate-y: -508px; }
  .profile-themes-media-slot__crop-img.translate-y--507 {
    --translate-y: -507px; }
  .profile-themes-media-slot__crop-img.translate-y--506 {
    --translate-y: -506px; }
  .profile-themes-media-slot__crop-img.translate-y--505 {
    --translate-y: -505px; }
  .profile-themes-media-slot__crop-img.translate-y--504 {
    --translate-y: -504px; }
  .profile-themes-media-slot__crop-img.translate-y--503 {
    --translate-y: -503px; }
  .profile-themes-media-slot__crop-img.translate-y--502 {
    --translate-y: -502px; }
  .profile-themes-media-slot__crop-img.translate-y--501 {
    --translate-y: -501px; }
  .profile-themes-media-slot__crop-img.translate-y--500 {
    --translate-y: -500px; }
  .profile-themes-media-slot__crop-img.translate-y--499 {
    --translate-y: -499px; }
  .profile-themes-media-slot__crop-img.translate-y--498 {
    --translate-y: -498px; }
  .profile-themes-media-slot__crop-img.translate-y--497 {
    --translate-y: -497px; }
  .profile-themes-media-slot__crop-img.translate-y--496 {
    --translate-y: -496px; }
  .profile-themes-media-slot__crop-img.translate-y--495 {
    --translate-y: -495px; }
  .profile-themes-media-slot__crop-img.translate-y--494 {
    --translate-y: -494px; }
  .profile-themes-media-slot__crop-img.translate-y--493 {
    --translate-y: -493px; }
  .profile-themes-media-slot__crop-img.translate-y--492 {
    --translate-y: -492px; }
  .profile-themes-media-slot__crop-img.translate-y--491 {
    --translate-y: -491px; }
  .profile-themes-media-slot__crop-img.translate-y--490 {
    --translate-y: -490px; }
  .profile-themes-media-slot__crop-img.translate-y--489 {
    --translate-y: -489px; }
  .profile-themes-media-slot__crop-img.translate-y--488 {
    --translate-y: -488px; }
  .profile-themes-media-slot__crop-img.translate-y--487 {
    --translate-y: -487px; }
  .profile-themes-media-slot__crop-img.translate-y--486 {
    --translate-y: -486px; }
  .profile-themes-media-slot__crop-img.translate-y--485 {
    --translate-y: -485px; }
  .profile-themes-media-slot__crop-img.translate-y--484 {
    --translate-y: -484px; }
  .profile-themes-media-slot__crop-img.translate-y--483 {
    --translate-y: -483px; }
  .profile-themes-media-slot__crop-img.translate-y--482 {
    --translate-y: -482px; }
  .profile-themes-media-slot__crop-img.translate-y--481 {
    --translate-y: -481px; }
  .profile-themes-media-slot__crop-img.translate-y--480 {
    --translate-y: -480px; }
  .profile-themes-media-slot__crop-img.translate-y--479 {
    --translate-y: -479px; }
  .profile-themes-media-slot__crop-img.translate-y--478 {
    --translate-y: -478px; }
  .profile-themes-media-slot__crop-img.translate-y--477 {
    --translate-y: -477px; }
  .profile-themes-media-slot__crop-img.translate-y--476 {
    --translate-y: -476px; }
  .profile-themes-media-slot__crop-img.translate-y--475 {
    --translate-y: -475px; }
  .profile-themes-media-slot__crop-img.translate-y--474 {
    --translate-y: -474px; }
  .profile-themes-media-slot__crop-img.translate-y--473 {
    --translate-y: -473px; }
  .profile-themes-media-slot__crop-img.translate-y--472 {
    --translate-y: -472px; }
  .profile-themes-media-slot__crop-img.translate-y--471 {
    --translate-y: -471px; }
  .profile-themes-media-slot__crop-img.translate-y--470 {
    --translate-y: -470px; }
  .profile-themes-media-slot__crop-img.translate-y--469 {
    --translate-y: -469px; }
  .profile-themes-media-slot__crop-img.translate-y--468 {
    --translate-y: -468px; }
  .profile-themes-media-slot__crop-img.translate-y--467 {
    --translate-y: -467px; }
  .profile-themes-media-slot__crop-img.translate-y--466 {
    --translate-y: -466px; }
  .profile-themes-media-slot__crop-img.translate-y--465 {
    --translate-y: -465px; }
  .profile-themes-media-slot__crop-img.translate-y--464 {
    --translate-y: -464px; }
  .profile-themes-media-slot__crop-img.translate-y--463 {
    --translate-y: -463px; }
  .profile-themes-media-slot__crop-img.translate-y--462 {
    --translate-y: -462px; }
  .profile-themes-media-slot__crop-img.translate-y--461 {
    --translate-y: -461px; }
  .profile-themes-media-slot__crop-img.translate-y--460 {
    --translate-y: -460px; }
  .profile-themes-media-slot__crop-img.translate-y--459 {
    --translate-y: -459px; }
  .profile-themes-media-slot__crop-img.translate-y--458 {
    --translate-y: -458px; }
  .profile-themes-media-slot__crop-img.translate-y--457 {
    --translate-y: -457px; }
  .profile-themes-media-slot__crop-img.translate-y--456 {
    --translate-y: -456px; }
  .profile-themes-media-slot__crop-img.translate-y--455 {
    --translate-y: -455px; }
  .profile-themes-media-slot__crop-img.translate-y--454 {
    --translate-y: -454px; }
  .profile-themes-media-slot__crop-img.translate-y--453 {
    --translate-y: -453px; }
  .profile-themes-media-slot__crop-img.translate-y--452 {
    --translate-y: -452px; }
  .profile-themes-media-slot__crop-img.translate-y--451 {
    --translate-y: -451px; }
  .profile-themes-media-slot__crop-img.translate-y--450 {
    --translate-y: -450px; }
  .profile-themes-media-slot__crop-img.translate-y--449 {
    --translate-y: -449px; }
  .profile-themes-media-slot__crop-img.translate-y--448 {
    --translate-y: -448px; }
  .profile-themes-media-slot__crop-img.translate-y--447 {
    --translate-y: -447px; }
  .profile-themes-media-slot__crop-img.translate-y--446 {
    --translate-y: -446px; }
  .profile-themes-media-slot__crop-img.translate-y--445 {
    --translate-y: -445px; }
  .profile-themes-media-slot__crop-img.translate-y--444 {
    --translate-y: -444px; }
  .profile-themes-media-slot__crop-img.translate-y--443 {
    --translate-y: -443px; }
  .profile-themes-media-slot__crop-img.translate-y--442 {
    --translate-y: -442px; }
  .profile-themes-media-slot__crop-img.translate-y--441 {
    --translate-y: -441px; }
  .profile-themes-media-slot__crop-img.translate-y--440 {
    --translate-y: -440px; }
  .profile-themes-media-slot__crop-img.translate-y--439 {
    --translate-y: -439px; }
  .profile-themes-media-slot__crop-img.translate-y--438 {
    --translate-y: -438px; }
  .profile-themes-media-slot__crop-img.translate-y--437 {
    --translate-y: -437px; }
  .profile-themes-media-slot__crop-img.translate-y--436 {
    --translate-y: -436px; }
  .profile-themes-media-slot__crop-img.translate-y--435 {
    --translate-y: -435px; }
  .profile-themes-media-slot__crop-img.translate-y--434 {
    --translate-y: -434px; }
  .profile-themes-media-slot__crop-img.translate-y--433 {
    --translate-y: -433px; }
  .profile-themes-media-slot__crop-img.translate-y--432 {
    --translate-y: -432px; }
  .profile-themes-media-slot__crop-img.translate-y--431 {
    --translate-y: -431px; }
  .profile-themes-media-slot__crop-img.translate-y--430 {
    --translate-y: -430px; }
  .profile-themes-media-slot__crop-img.translate-y--429 {
    --translate-y: -429px; }
  .profile-themes-media-slot__crop-img.translate-y--428 {
    --translate-y: -428px; }
  .profile-themes-media-slot__crop-img.translate-y--427 {
    --translate-y: -427px; }
  .profile-themes-media-slot__crop-img.translate-y--426 {
    --translate-y: -426px; }
  .profile-themes-media-slot__crop-img.translate-y--425 {
    --translate-y: -425px; }
  .profile-themes-media-slot__crop-img.translate-y--424 {
    --translate-y: -424px; }
  .profile-themes-media-slot__crop-img.translate-y--423 {
    --translate-y: -423px; }
  .profile-themes-media-slot__crop-img.translate-y--422 {
    --translate-y: -422px; }
  .profile-themes-media-slot__crop-img.translate-y--421 {
    --translate-y: -421px; }
  .profile-themes-media-slot__crop-img.translate-y--420 {
    --translate-y: -420px; }
  .profile-themes-media-slot__crop-img.translate-y--419 {
    --translate-y: -419px; }
  .profile-themes-media-slot__crop-img.translate-y--418 {
    --translate-y: -418px; }
  .profile-themes-media-slot__crop-img.translate-y--417 {
    --translate-y: -417px; }
  .profile-themes-media-slot__crop-img.translate-y--416 {
    --translate-y: -416px; }
  .profile-themes-media-slot__crop-img.translate-y--415 {
    --translate-y: -415px; }
  .profile-themes-media-slot__crop-img.translate-y--414 {
    --translate-y: -414px; }
  .profile-themes-media-slot__crop-img.translate-y--413 {
    --translate-y: -413px; }
  .profile-themes-media-slot__crop-img.translate-y--412 {
    --translate-y: -412px; }
  .profile-themes-media-slot__crop-img.translate-y--411 {
    --translate-y: -411px; }
  .profile-themes-media-slot__crop-img.translate-y--410 {
    --translate-y: -410px; }
  .profile-themes-media-slot__crop-img.translate-y--409 {
    --translate-y: -409px; }
  .profile-themes-media-slot__crop-img.translate-y--408 {
    --translate-y: -408px; }
  .profile-themes-media-slot__crop-img.translate-y--407 {
    --translate-y: -407px; }
  .profile-themes-media-slot__crop-img.translate-y--406 {
    --translate-y: -406px; }
  .profile-themes-media-slot__crop-img.translate-y--405 {
    --translate-y: -405px; }
  .profile-themes-media-slot__crop-img.translate-y--404 {
    --translate-y: -404px; }
  .profile-themes-media-slot__crop-img.translate-y--403 {
    --translate-y: -403px; }
  .profile-themes-media-slot__crop-img.translate-y--402 {
    --translate-y: -402px; }
  .profile-themes-media-slot__crop-img.translate-y--401 {
    --translate-y: -401px; }
  .profile-themes-media-slot__crop-img.translate-y--400 {
    --translate-y: -400px; }
  .profile-themes-media-slot__crop-img.translate-y--399 {
    --translate-y: -399px; }
  .profile-themes-media-slot__crop-img.translate-y--398 {
    --translate-y: -398px; }
  .profile-themes-media-slot__crop-img.translate-y--397 {
    --translate-y: -397px; }
  .profile-themes-media-slot__crop-img.translate-y--396 {
    --translate-y: -396px; }
  .profile-themes-media-slot__crop-img.translate-y--395 {
    --translate-y: -395px; }
  .profile-themes-media-slot__crop-img.translate-y--394 {
    --translate-y: -394px; }
  .profile-themes-media-slot__crop-img.translate-y--393 {
    --translate-y: -393px; }
  .profile-themes-media-slot__crop-img.translate-y--392 {
    --translate-y: -392px; }
  .profile-themes-media-slot__crop-img.translate-y--391 {
    --translate-y: -391px; }
  .profile-themes-media-slot__crop-img.translate-y--390 {
    --translate-y: -390px; }
  .profile-themes-media-slot__crop-img.translate-y--389 {
    --translate-y: -389px; }
  .profile-themes-media-slot__crop-img.translate-y--388 {
    --translate-y: -388px; }
  .profile-themes-media-slot__crop-img.translate-y--387 {
    --translate-y: -387px; }
  .profile-themes-media-slot__crop-img.translate-y--386 {
    --translate-y: -386px; }
  .profile-themes-media-slot__crop-img.translate-y--385 {
    --translate-y: -385px; }
  .profile-themes-media-slot__crop-img.translate-y--384 {
    --translate-y: -384px; }
  .profile-themes-media-slot__crop-img.translate-y--383 {
    --translate-y: -383px; }
  .profile-themes-media-slot__crop-img.translate-y--382 {
    --translate-y: -382px; }
  .profile-themes-media-slot__crop-img.translate-y--381 {
    --translate-y: -381px; }
  .profile-themes-media-slot__crop-img.translate-y--380 {
    --translate-y: -380px; }
  .profile-themes-media-slot__crop-img.translate-y--379 {
    --translate-y: -379px; }
  .profile-themes-media-slot__crop-img.translate-y--378 {
    --translate-y: -378px; }
  .profile-themes-media-slot__crop-img.translate-y--377 {
    --translate-y: -377px; }
  .profile-themes-media-slot__crop-img.translate-y--376 {
    --translate-y: -376px; }
  .profile-themes-media-slot__crop-img.translate-y--375 {
    --translate-y: -375px; }
  .profile-themes-media-slot__crop-img.translate-y--374 {
    --translate-y: -374px; }
  .profile-themes-media-slot__crop-img.translate-y--373 {
    --translate-y: -373px; }
  .profile-themes-media-slot__crop-img.translate-y--372 {
    --translate-y: -372px; }
  .profile-themes-media-slot__crop-img.translate-y--371 {
    --translate-y: -371px; }
  .profile-themes-media-slot__crop-img.translate-y--370 {
    --translate-y: -370px; }
  .profile-themes-media-slot__crop-img.translate-y--369 {
    --translate-y: -369px; }
  .profile-themes-media-slot__crop-img.translate-y--368 {
    --translate-y: -368px; }
  .profile-themes-media-slot__crop-img.translate-y--367 {
    --translate-y: -367px; }
  .profile-themes-media-slot__crop-img.translate-y--366 {
    --translate-y: -366px; }
  .profile-themes-media-slot__crop-img.translate-y--365 {
    --translate-y: -365px; }
  .profile-themes-media-slot__crop-img.translate-y--364 {
    --translate-y: -364px; }
  .profile-themes-media-slot__crop-img.translate-y--363 {
    --translate-y: -363px; }
  .profile-themes-media-slot__crop-img.translate-y--362 {
    --translate-y: -362px; }
  .profile-themes-media-slot__crop-img.translate-y--361 {
    --translate-y: -361px; }
  .profile-themes-media-slot__crop-img.translate-y--360 {
    --translate-y: -360px; }
  .profile-themes-media-slot__crop-img.translate-y--359 {
    --translate-y: -359px; }
  .profile-themes-media-slot__crop-img.translate-y--358 {
    --translate-y: -358px; }
  .profile-themes-media-slot__crop-img.translate-y--357 {
    --translate-y: -357px; }
  .profile-themes-media-slot__crop-img.translate-y--356 {
    --translate-y: -356px; }
  .profile-themes-media-slot__crop-img.translate-y--355 {
    --translate-y: -355px; }
  .profile-themes-media-slot__crop-img.translate-y--354 {
    --translate-y: -354px; }
  .profile-themes-media-slot__crop-img.translate-y--353 {
    --translate-y: -353px; }
  .profile-themes-media-slot__crop-img.translate-y--352 {
    --translate-y: -352px; }
  .profile-themes-media-slot__crop-img.translate-y--351 {
    --translate-y: -351px; }
  .profile-themes-media-slot__crop-img.translate-y--350 {
    --translate-y: -350px; }
  .profile-themes-media-slot__crop-img.translate-y--349 {
    --translate-y: -349px; }
  .profile-themes-media-slot__crop-img.translate-y--348 {
    --translate-y: -348px; }
  .profile-themes-media-slot__crop-img.translate-y--347 {
    --translate-y: -347px; }
  .profile-themes-media-slot__crop-img.translate-y--346 {
    --translate-y: -346px; }
  .profile-themes-media-slot__crop-img.translate-y--345 {
    --translate-y: -345px; }
  .profile-themes-media-slot__crop-img.translate-y--344 {
    --translate-y: -344px; }
  .profile-themes-media-slot__crop-img.translate-y--343 {
    --translate-y: -343px; }
  .profile-themes-media-slot__crop-img.translate-y--342 {
    --translate-y: -342px; }
  .profile-themes-media-slot__crop-img.translate-y--341 {
    --translate-y: -341px; }
  .profile-themes-media-slot__crop-img.translate-y--340 {
    --translate-y: -340px; }
  .profile-themes-media-slot__crop-img.translate-y--339 {
    --translate-y: -339px; }
  .profile-themes-media-slot__crop-img.translate-y--338 {
    --translate-y: -338px; }
  .profile-themes-media-slot__crop-img.translate-y--337 {
    --translate-y: -337px; }
  .profile-themes-media-slot__crop-img.translate-y--336 {
    --translate-y: -336px; }
  .profile-themes-media-slot__crop-img.translate-y--335 {
    --translate-y: -335px; }
  .profile-themes-media-slot__crop-img.translate-y--334 {
    --translate-y: -334px; }
  .profile-themes-media-slot__crop-img.translate-y--333 {
    --translate-y: -333px; }
  .profile-themes-media-slot__crop-img.translate-y--332 {
    --translate-y: -332px; }
  .profile-themes-media-slot__crop-img.translate-y--331 {
    --translate-y: -331px; }
  .profile-themes-media-slot__crop-img.translate-y--330 {
    --translate-y: -330px; }
  .profile-themes-media-slot__crop-img.translate-y--329 {
    --translate-y: -329px; }
  .profile-themes-media-slot__crop-img.translate-y--328 {
    --translate-y: -328px; }
  .profile-themes-media-slot__crop-img.translate-y--327 {
    --translate-y: -327px; }
  .profile-themes-media-slot__crop-img.translate-y--326 {
    --translate-y: -326px; }
  .profile-themes-media-slot__crop-img.translate-y--325 {
    --translate-y: -325px; }
  .profile-themes-media-slot__crop-img.translate-y--324 {
    --translate-y: -324px; }
  .profile-themes-media-slot__crop-img.translate-y--323 {
    --translate-y: -323px; }
  .profile-themes-media-slot__crop-img.translate-y--322 {
    --translate-y: -322px; }
  .profile-themes-media-slot__crop-img.translate-y--321 {
    --translate-y: -321px; }
  .profile-themes-media-slot__crop-img.translate-y--320 {
    --translate-y: -320px; }
  .profile-themes-media-slot__crop-img.translate-y--319 {
    --translate-y: -319px; }
  .profile-themes-media-slot__crop-img.translate-y--318 {
    --translate-y: -318px; }
  .profile-themes-media-slot__crop-img.translate-y--317 {
    --translate-y: -317px; }
  .profile-themes-media-slot__crop-img.translate-y--316 {
    --translate-y: -316px; }
  .profile-themes-media-slot__crop-img.translate-y--315 {
    --translate-y: -315px; }
  .profile-themes-media-slot__crop-img.translate-y--314 {
    --translate-y: -314px; }
  .profile-themes-media-slot__crop-img.translate-y--313 {
    --translate-y: -313px; }
  .profile-themes-media-slot__crop-img.translate-y--312 {
    --translate-y: -312px; }
  .profile-themes-media-slot__crop-img.translate-y--311 {
    --translate-y: -311px; }
  .profile-themes-media-slot__crop-img.translate-y--310 {
    --translate-y: -310px; }
  .profile-themes-media-slot__crop-img.translate-y--309 {
    --translate-y: -309px; }
  .profile-themes-media-slot__crop-img.translate-y--308 {
    --translate-y: -308px; }
  .profile-themes-media-slot__crop-img.translate-y--307 {
    --translate-y: -307px; }
  .profile-themes-media-slot__crop-img.translate-y--306 {
    --translate-y: -306px; }
  .profile-themes-media-slot__crop-img.translate-y--305 {
    --translate-y: -305px; }
  .profile-themes-media-slot__crop-img.translate-y--304 {
    --translate-y: -304px; }
  .profile-themes-media-slot__crop-img.translate-y--303 {
    --translate-y: -303px; }
  .profile-themes-media-slot__crop-img.translate-y--302 {
    --translate-y: -302px; }
  .profile-themes-media-slot__crop-img.translate-y--301 {
    --translate-y: -301px; }
  .profile-themes-media-slot__crop-img.translate-y--300 {
    --translate-y: -300px; }
  .profile-themes-media-slot__crop-img.translate-y--299 {
    --translate-y: -299px; }
  .profile-themes-media-slot__crop-img.translate-y--298 {
    --translate-y: -298px; }
  .profile-themes-media-slot__crop-img.translate-y--297 {
    --translate-y: -297px; }
  .profile-themes-media-slot__crop-img.translate-y--296 {
    --translate-y: -296px; }
  .profile-themes-media-slot__crop-img.translate-y--295 {
    --translate-y: -295px; }
  .profile-themes-media-slot__crop-img.translate-y--294 {
    --translate-y: -294px; }
  .profile-themes-media-slot__crop-img.translate-y--293 {
    --translate-y: -293px; }
  .profile-themes-media-slot__crop-img.translate-y--292 {
    --translate-y: -292px; }
  .profile-themes-media-slot__crop-img.translate-y--291 {
    --translate-y: -291px; }
  .profile-themes-media-slot__crop-img.translate-y--290 {
    --translate-y: -290px; }
  .profile-themes-media-slot__crop-img.translate-y--289 {
    --translate-y: -289px; }
  .profile-themes-media-slot__crop-img.translate-y--288 {
    --translate-y: -288px; }
  .profile-themes-media-slot__crop-img.translate-y--287 {
    --translate-y: -287px; }
  .profile-themes-media-slot__crop-img.translate-y--286 {
    --translate-y: -286px; }
  .profile-themes-media-slot__crop-img.translate-y--285 {
    --translate-y: -285px; }
  .profile-themes-media-slot__crop-img.translate-y--284 {
    --translate-y: -284px; }
  .profile-themes-media-slot__crop-img.translate-y--283 {
    --translate-y: -283px; }
  .profile-themes-media-slot__crop-img.translate-y--282 {
    --translate-y: -282px; }
  .profile-themes-media-slot__crop-img.translate-y--281 {
    --translate-y: -281px; }
  .profile-themes-media-slot__crop-img.translate-y--280 {
    --translate-y: -280px; }
  .profile-themes-media-slot__crop-img.translate-y--279 {
    --translate-y: -279px; }
  .profile-themes-media-slot__crop-img.translate-y--278 {
    --translate-y: -278px; }
  .profile-themes-media-slot__crop-img.translate-y--277 {
    --translate-y: -277px; }
  .profile-themes-media-slot__crop-img.translate-y--276 {
    --translate-y: -276px; }
  .profile-themes-media-slot__crop-img.translate-y--275 {
    --translate-y: -275px; }
  .profile-themes-media-slot__crop-img.translate-y--274 {
    --translate-y: -274px; }
  .profile-themes-media-slot__crop-img.translate-y--273 {
    --translate-y: -273px; }
  .profile-themes-media-slot__crop-img.translate-y--272 {
    --translate-y: -272px; }
  .profile-themes-media-slot__crop-img.translate-y--271 {
    --translate-y: -271px; }
  .profile-themes-media-slot__crop-img.translate-y--270 {
    --translate-y: -270px; }
  .profile-themes-media-slot__crop-img.translate-y--269 {
    --translate-y: -269px; }
  .profile-themes-media-slot__crop-img.translate-y--268 {
    --translate-y: -268px; }
  .profile-themes-media-slot__crop-img.translate-y--267 {
    --translate-y: -267px; }
  .profile-themes-media-slot__crop-img.translate-y--266 {
    --translate-y: -266px; }
  .profile-themes-media-slot__crop-img.translate-y--265 {
    --translate-y: -265px; }
  .profile-themes-media-slot__crop-img.translate-y--264 {
    --translate-y: -264px; }
  .profile-themes-media-slot__crop-img.translate-y--263 {
    --translate-y: -263px; }
  .profile-themes-media-slot__crop-img.translate-y--262 {
    --translate-y: -262px; }
  .profile-themes-media-slot__crop-img.translate-y--261 {
    --translate-y: -261px; }
  .profile-themes-media-slot__crop-img.translate-y--260 {
    --translate-y: -260px; }
  .profile-themes-media-slot__crop-img.translate-y--259 {
    --translate-y: -259px; }
  .profile-themes-media-slot__crop-img.translate-y--258 {
    --translate-y: -258px; }
  .profile-themes-media-slot__crop-img.translate-y--257 {
    --translate-y: -257px; }
  .profile-themes-media-slot__crop-img.translate-y--256 {
    --translate-y: -256px; }
  .profile-themes-media-slot__crop-img.translate-y--255 {
    --translate-y: -255px; }
  .profile-themes-media-slot__crop-img.translate-y--254 {
    --translate-y: -254px; }
  .profile-themes-media-slot__crop-img.translate-y--253 {
    --translate-y: -253px; }
  .profile-themes-media-slot__crop-img.translate-y--252 {
    --translate-y: -252px; }
  .profile-themes-media-slot__crop-img.translate-y--251 {
    --translate-y: -251px; }
  .profile-themes-media-slot__crop-img.translate-y--250 {
    --translate-y: -250px; }
  .profile-themes-media-slot__crop-img.translate-y--249 {
    --translate-y: -249px; }
  .profile-themes-media-slot__crop-img.translate-y--248 {
    --translate-y: -248px; }
  .profile-themes-media-slot__crop-img.translate-y--247 {
    --translate-y: -247px; }
  .profile-themes-media-slot__crop-img.translate-y--246 {
    --translate-y: -246px; }
  .profile-themes-media-slot__crop-img.translate-y--245 {
    --translate-y: -245px; }
  .profile-themes-media-slot__crop-img.translate-y--244 {
    --translate-y: -244px; }
  .profile-themes-media-slot__crop-img.translate-y--243 {
    --translate-y: -243px; }
  .profile-themes-media-slot__crop-img.translate-y--242 {
    --translate-y: -242px; }
  .profile-themes-media-slot__crop-img.translate-y--241 {
    --translate-y: -241px; }
  .profile-themes-media-slot__crop-img.translate-y--240 {
    --translate-y: -240px; }
  .profile-themes-media-slot__crop-img.translate-y--239 {
    --translate-y: -239px; }
  .profile-themes-media-slot__crop-img.translate-y--238 {
    --translate-y: -238px; }
  .profile-themes-media-slot__crop-img.translate-y--237 {
    --translate-y: -237px; }
  .profile-themes-media-slot__crop-img.translate-y--236 {
    --translate-y: -236px; }
  .profile-themes-media-slot__crop-img.translate-y--235 {
    --translate-y: -235px; }
  .profile-themes-media-slot__crop-img.translate-y--234 {
    --translate-y: -234px; }
  .profile-themes-media-slot__crop-img.translate-y--233 {
    --translate-y: -233px; }
  .profile-themes-media-slot__crop-img.translate-y--232 {
    --translate-y: -232px; }
  .profile-themes-media-slot__crop-img.translate-y--231 {
    --translate-y: -231px; }
  .profile-themes-media-slot__crop-img.translate-y--230 {
    --translate-y: -230px; }
  .profile-themes-media-slot__crop-img.translate-y--229 {
    --translate-y: -229px; }
  .profile-themes-media-slot__crop-img.translate-y--228 {
    --translate-y: -228px; }
  .profile-themes-media-slot__crop-img.translate-y--227 {
    --translate-y: -227px; }
  .profile-themes-media-slot__crop-img.translate-y--226 {
    --translate-y: -226px; }
  .profile-themes-media-slot__crop-img.translate-y--225 {
    --translate-y: -225px; }
  .profile-themes-media-slot__crop-img.translate-y--224 {
    --translate-y: -224px; }
  .profile-themes-media-slot__crop-img.translate-y--223 {
    --translate-y: -223px; }
  .profile-themes-media-slot__crop-img.translate-y--222 {
    --translate-y: -222px; }
  .profile-themes-media-slot__crop-img.translate-y--221 {
    --translate-y: -221px; }
  .profile-themes-media-slot__crop-img.translate-y--220 {
    --translate-y: -220px; }
  .profile-themes-media-slot__crop-img.translate-y--219 {
    --translate-y: -219px; }
  .profile-themes-media-slot__crop-img.translate-y--218 {
    --translate-y: -218px; }
  .profile-themes-media-slot__crop-img.translate-y--217 {
    --translate-y: -217px; }
  .profile-themes-media-slot__crop-img.translate-y--216 {
    --translate-y: -216px; }
  .profile-themes-media-slot__crop-img.translate-y--215 {
    --translate-y: -215px; }
  .profile-themes-media-slot__crop-img.translate-y--214 {
    --translate-y: -214px; }
  .profile-themes-media-slot__crop-img.translate-y--213 {
    --translate-y: -213px; }
  .profile-themes-media-slot__crop-img.translate-y--212 {
    --translate-y: -212px; }
  .profile-themes-media-slot__crop-img.translate-y--211 {
    --translate-y: -211px; }
  .profile-themes-media-slot__crop-img.translate-y--210 {
    --translate-y: -210px; }
  .profile-themes-media-slot__crop-img.translate-y--209 {
    --translate-y: -209px; }
  .profile-themes-media-slot__crop-img.translate-y--208 {
    --translate-y: -208px; }
  .profile-themes-media-slot__crop-img.translate-y--207 {
    --translate-y: -207px; }
  .profile-themes-media-slot__crop-img.translate-y--206 {
    --translate-y: -206px; }
  .profile-themes-media-slot__crop-img.translate-y--205 {
    --translate-y: -205px; }
  .profile-themes-media-slot__crop-img.translate-y--204 {
    --translate-y: -204px; }
  .profile-themes-media-slot__crop-img.translate-y--203 {
    --translate-y: -203px; }
  .profile-themes-media-slot__crop-img.translate-y--202 {
    --translate-y: -202px; }
  .profile-themes-media-slot__crop-img.translate-y--201 {
    --translate-y: -201px; }
  .profile-themes-media-slot__crop-img.translate-y--200 {
    --translate-y: -200px; }
  .profile-themes-media-slot__crop-img.translate-y--199 {
    --translate-y: -199px; }
  .profile-themes-media-slot__crop-img.translate-y--198 {
    --translate-y: -198px; }
  .profile-themes-media-slot__crop-img.translate-y--197 {
    --translate-y: -197px; }
  .profile-themes-media-slot__crop-img.translate-y--196 {
    --translate-y: -196px; }
  .profile-themes-media-slot__crop-img.translate-y--195 {
    --translate-y: -195px; }
  .profile-themes-media-slot__crop-img.translate-y--194 {
    --translate-y: -194px; }
  .profile-themes-media-slot__crop-img.translate-y--193 {
    --translate-y: -193px; }
  .profile-themes-media-slot__crop-img.translate-y--192 {
    --translate-y: -192px; }
  .profile-themes-media-slot__crop-img.translate-y--191 {
    --translate-y: -191px; }
  .profile-themes-media-slot__crop-img.translate-y--190 {
    --translate-y: -190px; }
  .profile-themes-media-slot__crop-img.translate-y--189 {
    --translate-y: -189px; }
  .profile-themes-media-slot__crop-img.translate-y--188 {
    --translate-y: -188px; }
  .profile-themes-media-slot__crop-img.translate-y--187 {
    --translate-y: -187px; }
  .profile-themes-media-slot__crop-img.translate-y--186 {
    --translate-y: -186px; }
  .profile-themes-media-slot__crop-img.translate-y--185 {
    --translate-y: -185px; }
  .profile-themes-media-slot__crop-img.translate-y--184 {
    --translate-y: -184px; }
  .profile-themes-media-slot__crop-img.translate-y--183 {
    --translate-y: -183px; }
  .profile-themes-media-slot__crop-img.translate-y--182 {
    --translate-y: -182px; }
  .profile-themes-media-slot__crop-img.translate-y--181 {
    --translate-y: -181px; }
  .profile-themes-media-slot__crop-img.translate-y--180 {
    --translate-y: -180px; }
  .profile-themes-media-slot__crop-img.translate-y--179 {
    --translate-y: -179px; }
  .profile-themes-media-slot__crop-img.translate-y--178 {
    --translate-y: -178px; }
  .profile-themes-media-slot__crop-img.translate-y--177 {
    --translate-y: -177px; }
  .profile-themes-media-slot__crop-img.translate-y--176 {
    --translate-y: -176px; }
  .profile-themes-media-slot__crop-img.translate-y--175 {
    --translate-y: -175px; }
  .profile-themes-media-slot__crop-img.translate-y--174 {
    --translate-y: -174px; }
  .profile-themes-media-slot__crop-img.translate-y--173 {
    --translate-y: -173px; }
  .profile-themes-media-slot__crop-img.translate-y--172 {
    --translate-y: -172px; }
  .profile-themes-media-slot__crop-img.translate-y--171 {
    --translate-y: -171px; }
  .profile-themes-media-slot__crop-img.translate-y--170 {
    --translate-y: -170px; }
  .profile-themes-media-slot__crop-img.translate-y--169 {
    --translate-y: -169px; }
  .profile-themes-media-slot__crop-img.translate-y--168 {
    --translate-y: -168px; }
  .profile-themes-media-slot__crop-img.translate-y--167 {
    --translate-y: -167px; }
  .profile-themes-media-slot__crop-img.translate-y--166 {
    --translate-y: -166px; }
  .profile-themes-media-slot__crop-img.translate-y--165 {
    --translate-y: -165px; }
  .profile-themes-media-slot__crop-img.translate-y--164 {
    --translate-y: -164px; }
  .profile-themes-media-slot__crop-img.translate-y--163 {
    --translate-y: -163px; }
  .profile-themes-media-slot__crop-img.translate-y--162 {
    --translate-y: -162px; }
  .profile-themes-media-slot__crop-img.translate-y--161 {
    --translate-y: -161px; }
  .profile-themes-media-slot__crop-img.translate-y--160 {
    --translate-y: -160px; }
  .profile-themes-media-slot__crop-img.translate-y--159 {
    --translate-y: -159px; }
  .profile-themes-media-slot__crop-img.translate-y--158 {
    --translate-y: -158px; }
  .profile-themes-media-slot__crop-img.translate-y--157 {
    --translate-y: -157px; }
  .profile-themes-media-slot__crop-img.translate-y--156 {
    --translate-y: -156px; }
  .profile-themes-media-slot__crop-img.translate-y--155 {
    --translate-y: -155px; }
  .profile-themes-media-slot__crop-img.translate-y--154 {
    --translate-y: -154px; }
  .profile-themes-media-slot__crop-img.translate-y--153 {
    --translate-y: -153px; }
  .profile-themes-media-slot__crop-img.translate-y--152 {
    --translate-y: -152px; }
  .profile-themes-media-slot__crop-img.translate-y--151 {
    --translate-y: -151px; }
  .profile-themes-media-slot__crop-img.translate-y--150 {
    --translate-y: -150px; }
  .profile-themes-media-slot__crop-img.translate-y--149 {
    --translate-y: -149px; }
  .profile-themes-media-slot__crop-img.translate-y--148 {
    --translate-y: -148px; }
  .profile-themes-media-slot__crop-img.translate-y--147 {
    --translate-y: -147px; }
  .profile-themes-media-slot__crop-img.translate-y--146 {
    --translate-y: -146px; }
  .profile-themes-media-slot__crop-img.translate-y--145 {
    --translate-y: -145px; }
  .profile-themes-media-slot__crop-img.translate-y--144 {
    --translate-y: -144px; }
  .profile-themes-media-slot__crop-img.translate-y--143 {
    --translate-y: -143px; }
  .profile-themes-media-slot__crop-img.translate-y--142 {
    --translate-y: -142px; }
  .profile-themes-media-slot__crop-img.translate-y--141 {
    --translate-y: -141px; }
  .profile-themes-media-slot__crop-img.translate-y--140 {
    --translate-y: -140px; }
  .profile-themes-media-slot__crop-img.translate-y--139 {
    --translate-y: -139px; }
  .profile-themes-media-slot__crop-img.translate-y--138 {
    --translate-y: -138px; }
  .profile-themes-media-slot__crop-img.translate-y--137 {
    --translate-y: -137px; }
  .profile-themes-media-slot__crop-img.translate-y--136 {
    --translate-y: -136px; }
  .profile-themes-media-slot__crop-img.translate-y--135 {
    --translate-y: -135px; }
  .profile-themes-media-slot__crop-img.translate-y--134 {
    --translate-y: -134px; }
  .profile-themes-media-slot__crop-img.translate-y--133 {
    --translate-y: -133px; }
  .profile-themes-media-slot__crop-img.translate-y--132 {
    --translate-y: -132px; }
  .profile-themes-media-slot__crop-img.translate-y--131 {
    --translate-y: -131px; }
  .profile-themes-media-slot__crop-img.translate-y--130 {
    --translate-y: -130px; }
  .profile-themes-media-slot__crop-img.translate-y--129 {
    --translate-y: -129px; }
  .profile-themes-media-slot__crop-img.translate-y--128 {
    --translate-y: -128px; }
  .profile-themes-media-slot__crop-img.translate-y--127 {
    --translate-y: -127px; }
  .profile-themes-media-slot__crop-img.translate-y--126 {
    --translate-y: -126px; }
  .profile-themes-media-slot__crop-img.translate-y--125 {
    --translate-y: -125px; }
  .profile-themes-media-slot__crop-img.translate-y--124 {
    --translate-y: -124px; }
  .profile-themes-media-slot__crop-img.translate-y--123 {
    --translate-y: -123px; }
  .profile-themes-media-slot__crop-img.translate-y--122 {
    --translate-y: -122px; }
  .profile-themes-media-slot__crop-img.translate-y--121 {
    --translate-y: -121px; }
  .profile-themes-media-slot__crop-img.translate-y--120 {
    --translate-y: -120px; }
  .profile-themes-media-slot__crop-img.translate-y--119 {
    --translate-y: -119px; }
  .profile-themes-media-slot__crop-img.translate-y--118 {
    --translate-y: -118px; }
  .profile-themes-media-slot__crop-img.translate-y--117 {
    --translate-y: -117px; }
  .profile-themes-media-slot__crop-img.translate-y--116 {
    --translate-y: -116px; }
  .profile-themes-media-slot__crop-img.translate-y--115 {
    --translate-y: -115px; }
  .profile-themes-media-slot__crop-img.translate-y--114 {
    --translate-y: -114px; }
  .profile-themes-media-slot__crop-img.translate-y--113 {
    --translate-y: -113px; }
  .profile-themes-media-slot__crop-img.translate-y--112 {
    --translate-y: -112px; }
  .profile-themes-media-slot__crop-img.translate-y--111 {
    --translate-y: -111px; }
  .profile-themes-media-slot__crop-img.translate-y--110 {
    --translate-y: -110px; }
  .profile-themes-media-slot__crop-img.translate-y--109 {
    --translate-y: -109px; }
  .profile-themes-media-slot__crop-img.translate-y--108 {
    --translate-y: -108px; }
  .profile-themes-media-slot__crop-img.translate-y--107 {
    --translate-y: -107px; }
  .profile-themes-media-slot__crop-img.translate-y--106 {
    --translate-y: -106px; }
  .profile-themes-media-slot__crop-img.translate-y--105 {
    --translate-y: -105px; }
  .profile-themes-media-slot__crop-img.translate-y--104 {
    --translate-y: -104px; }
  .profile-themes-media-slot__crop-img.translate-y--103 {
    --translate-y: -103px; }
  .profile-themes-media-slot__crop-img.translate-y--102 {
    --translate-y: -102px; }
  .profile-themes-media-slot__crop-img.translate-y--101 {
    --translate-y: -101px; }
  .profile-themes-media-slot__crop-img.translate-y--100 {
    --translate-y: -100px; }
  .profile-themes-media-slot__crop-img.translate-y--99 {
    --translate-y: -99px; }
  .profile-themes-media-slot__crop-img.translate-y--98 {
    --translate-y: -98px; }
  .profile-themes-media-slot__crop-img.translate-y--97 {
    --translate-y: -97px; }
  .profile-themes-media-slot__crop-img.translate-y--96 {
    --translate-y: -96px; }
  .profile-themes-media-slot__crop-img.translate-y--95 {
    --translate-y: -95px; }
  .profile-themes-media-slot__crop-img.translate-y--94 {
    --translate-y: -94px; }
  .profile-themes-media-slot__crop-img.translate-y--93 {
    --translate-y: -93px; }
  .profile-themes-media-slot__crop-img.translate-y--92 {
    --translate-y: -92px; }
  .profile-themes-media-slot__crop-img.translate-y--91 {
    --translate-y: -91px; }
  .profile-themes-media-slot__crop-img.translate-y--90 {
    --translate-y: -90px; }
  .profile-themes-media-slot__crop-img.translate-y--89 {
    --translate-y: -89px; }
  .profile-themes-media-slot__crop-img.translate-y--88 {
    --translate-y: -88px; }
  .profile-themes-media-slot__crop-img.translate-y--87 {
    --translate-y: -87px; }
  .profile-themes-media-slot__crop-img.translate-y--86 {
    --translate-y: -86px; }
  .profile-themes-media-slot__crop-img.translate-y--85 {
    --translate-y: -85px; }
  .profile-themes-media-slot__crop-img.translate-y--84 {
    --translate-y: -84px; }
  .profile-themes-media-slot__crop-img.translate-y--83 {
    --translate-y: -83px; }
  .profile-themes-media-slot__crop-img.translate-y--82 {
    --translate-y: -82px; }
  .profile-themes-media-slot__crop-img.translate-y--81 {
    --translate-y: -81px; }
  .profile-themes-media-slot__crop-img.translate-y--80 {
    --translate-y: -80px; }
  .profile-themes-media-slot__crop-img.translate-y--79 {
    --translate-y: -79px; }
  .profile-themes-media-slot__crop-img.translate-y--78 {
    --translate-y: -78px; }
  .profile-themes-media-slot__crop-img.translate-y--77 {
    --translate-y: -77px; }
  .profile-themes-media-slot__crop-img.translate-y--76 {
    --translate-y: -76px; }
  .profile-themes-media-slot__crop-img.translate-y--75 {
    --translate-y: -75px; }
  .profile-themes-media-slot__crop-img.translate-y--74 {
    --translate-y: -74px; }
  .profile-themes-media-slot__crop-img.translate-y--73 {
    --translate-y: -73px; }
  .profile-themes-media-slot__crop-img.translate-y--72 {
    --translate-y: -72px; }
  .profile-themes-media-slot__crop-img.translate-y--71 {
    --translate-y: -71px; }
  .profile-themes-media-slot__crop-img.translate-y--70 {
    --translate-y: -70px; }
  .profile-themes-media-slot__crop-img.translate-y--69 {
    --translate-y: -69px; }
  .profile-themes-media-slot__crop-img.translate-y--68 {
    --translate-y: -68px; }
  .profile-themes-media-slot__crop-img.translate-y--67 {
    --translate-y: -67px; }
  .profile-themes-media-slot__crop-img.translate-y--66 {
    --translate-y: -66px; }
  .profile-themes-media-slot__crop-img.translate-y--65 {
    --translate-y: -65px; }
  .profile-themes-media-slot__crop-img.translate-y--64 {
    --translate-y: -64px; }
  .profile-themes-media-slot__crop-img.translate-y--63 {
    --translate-y: -63px; }
  .profile-themes-media-slot__crop-img.translate-y--62 {
    --translate-y: -62px; }
  .profile-themes-media-slot__crop-img.translate-y--61 {
    --translate-y: -61px; }
  .profile-themes-media-slot__crop-img.translate-y--60 {
    --translate-y: -60px; }
  .profile-themes-media-slot__crop-img.translate-y--59 {
    --translate-y: -59px; }
  .profile-themes-media-slot__crop-img.translate-y--58 {
    --translate-y: -58px; }
  .profile-themes-media-slot__crop-img.translate-y--57 {
    --translate-y: -57px; }
  .profile-themes-media-slot__crop-img.translate-y--56 {
    --translate-y: -56px; }
  .profile-themes-media-slot__crop-img.translate-y--55 {
    --translate-y: -55px; }
  .profile-themes-media-slot__crop-img.translate-y--54 {
    --translate-y: -54px; }
  .profile-themes-media-slot__crop-img.translate-y--53 {
    --translate-y: -53px; }
  .profile-themes-media-slot__crop-img.translate-y--52 {
    --translate-y: -52px; }
  .profile-themes-media-slot__crop-img.translate-y--51 {
    --translate-y: -51px; }
  .profile-themes-media-slot__crop-img.translate-y--50 {
    --translate-y: -50px; }
  .profile-themes-media-slot__crop-img.translate-y--49 {
    --translate-y: -49px; }
  .profile-themes-media-slot__crop-img.translate-y--48 {
    --translate-y: -48px; }
  .profile-themes-media-slot__crop-img.translate-y--47 {
    --translate-y: -47px; }
  .profile-themes-media-slot__crop-img.translate-y--46 {
    --translate-y: -46px; }
  .profile-themes-media-slot__crop-img.translate-y--45 {
    --translate-y: -45px; }
  .profile-themes-media-slot__crop-img.translate-y--44 {
    --translate-y: -44px; }
  .profile-themes-media-slot__crop-img.translate-y--43 {
    --translate-y: -43px; }
  .profile-themes-media-slot__crop-img.translate-y--42 {
    --translate-y: -42px; }
  .profile-themes-media-slot__crop-img.translate-y--41 {
    --translate-y: -41px; }
  .profile-themes-media-slot__crop-img.translate-y--40 {
    --translate-y: -40px; }
  .profile-themes-media-slot__crop-img.translate-y--39 {
    --translate-y: -39px; }
  .profile-themes-media-slot__crop-img.translate-y--38 {
    --translate-y: -38px; }
  .profile-themes-media-slot__crop-img.translate-y--37 {
    --translate-y: -37px; }
  .profile-themes-media-slot__crop-img.translate-y--36 {
    --translate-y: -36px; }
  .profile-themes-media-slot__crop-img.translate-y--35 {
    --translate-y: -35px; }
  .profile-themes-media-slot__crop-img.translate-y--34 {
    --translate-y: -34px; }
  .profile-themes-media-slot__crop-img.translate-y--33 {
    --translate-y: -33px; }
  .profile-themes-media-slot__crop-img.translate-y--32 {
    --translate-y: -32px; }
  .profile-themes-media-slot__crop-img.translate-y--31 {
    --translate-y: -31px; }
  .profile-themes-media-slot__crop-img.translate-y--30 {
    --translate-y: -30px; }
  .profile-themes-media-slot__crop-img.translate-y--29 {
    --translate-y: -29px; }
  .profile-themes-media-slot__crop-img.translate-y--28 {
    --translate-y: -28px; }
  .profile-themes-media-slot__crop-img.translate-y--27 {
    --translate-y: -27px; }
  .profile-themes-media-slot__crop-img.translate-y--26 {
    --translate-y: -26px; }
  .profile-themes-media-slot__crop-img.translate-y--25 {
    --translate-y: -25px; }
  .profile-themes-media-slot__crop-img.translate-y--24 {
    --translate-y: -24px; }
  .profile-themes-media-slot__crop-img.translate-y--23 {
    --translate-y: -23px; }
  .profile-themes-media-slot__crop-img.translate-y--22 {
    --translate-y: -22px; }
  .profile-themes-media-slot__crop-img.translate-y--21 {
    --translate-y: -21px; }
  .profile-themes-media-slot__crop-img.translate-y--20 {
    --translate-y: -20px; }
  .profile-themes-media-slot__crop-img.translate-y--19 {
    --translate-y: -19px; }
  .profile-themes-media-slot__crop-img.translate-y--18 {
    --translate-y: -18px; }
  .profile-themes-media-slot__crop-img.translate-y--17 {
    --translate-y: -17px; }
  .profile-themes-media-slot__crop-img.translate-y--16 {
    --translate-y: -16px; }
  .profile-themes-media-slot__crop-img.translate-y--15 {
    --translate-y: -15px; }
  .profile-themes-media-slot__crop-img.translate-y--14 {
    --translate-y: -14px; }
  .profile-themes-media-slot__crop-img.translate-y--13 {
    --translate-y: -13px; }
  .profile-themes-media-slot__crop-img.translate-y--12 {
    --translate-y: -12px; }
  .profile-themes-media-slot__crop-img.translate-y--11 {
    --translate-y: -11px; }
  .profile-themes-media-slot__crop-img.translate-y--10 {
    --translate-y: -10px; }
  .profile-themes-media-slot__crop-img.translate-y--9 {
    --translate-y: -9px; }
  .profile-themes-media-slot__crop-img.translate-y--8 {
    --translate-y: -8px; }
  .profile-themes-media-slot__crop-img.translate-y--7 {
    --translate-y: -7px; }
  .profile-themes-media-slot__crop-img.translate-y--6 {
    --translate-y: -6px; }
  .profile-themes-media-slot__crop-img.translate-y--5 {
    --translate-y: -5px; }
  .profile-themes-media-slot__crop-img.translate-y--4 {
    --translate-y: -4px; }
  .profile-themes-media-slot__crop-img.translate-y--3 {
    --translate-y: -3px; }
  .profile-themes-media-slot__crop-img.translate-y--2 {
    --translate-y: -2px; }
  .profile-themes-media-slot__crop-img.translate-y--1 {
    --translate-y: -1px; }
  .profile-themes-media-slot__crop-img.translate-y-0 {
    --translate-y: 0px; }
  .profile-themes-media-slot__crop-img.translate-y-1 {
    --translate-y: 1px; }
  .profile-themes-media-slot__crop-img.translate-y-2 {
    --translate-y: 2px; }
  .profile-themes-media-slot__crop-img.translate-y-3 {
    --translate-y: 3px; }
  .profile-themes-media-slot__crop-img.translate-y-4 {
    --translate-y: 4px; }
  .profile-themes-media-slot__crop-img.translate-y-5 {
    --translate-y: 5px; }
  .profile-themes-media-slot__crop-img.translate-y-6 {
    --translate-y: 6px; }
  .profile-themes-media-slot__crop-img.translate-y-7 {
    --translate-y: 7px; }
  .profile-themes-media-slot__crop-img.translate-y-8 {
    --translate-y: 8px; }
  .profile-themes-media-slot__crop-img.translate-y-9 {
    --translate-y: 9px; }
  .profile-themes-media-slot__crop-img.translate-y-10 {
    --translate-y: 10px; }
  .profile-themes-media-slot__crop-img.translate-y-11 {
    --translate-y: 11px; }
  .profile-themes-media-slot__crop-img.translate-y-12 {
    --translate-y: 12px; }
  .profile-themes-media-slot__crop-img.translate-y-13 {
    --translate-y: 13px; }
  .profile-themes-media-slot__crop-img.translate-y-14 {
    --translate-y: 14px; }
  .profile-themes-media-slot__crop-img.translate-y-15 {
    --translate-y: 15px; }
  .profile-themes-media-slot__crop-img.translate-y-16 {
    --translate-y: 16px; }
  .profile-themes-media-slot__crop-img.translate-y-17 {
    --translate-y: 17px; }
  .profile-themes-media-slot__crop-img.translate-y-18 {
    --translate-y: 18px; }
  .profile-themes-media-slot__crop-img.translate-y-19 {
    --translate-y: 19px; }
  .profile-themes-media-slot__crop-img.translate-y-20 {
    --translate-y: 20px; }
  .profile-themes-media-slot__crop-img.translate-y-21 {
    --translate-y: 21px; }
  .profile-themes-media-slot__crop-img.translate-y-22 {
    --translate-y: 22px; }
  .profile-themes-media-slot__crop-img.translate-y-23 {
    --translate-y: 23px; }
  .profile-themes-media-slot__crop-img.translate-y-24 {
    --translate-y: 24px; }
  .profile-themes-media-slot__crop-img.translate-y-25 {
    --translate-y: 25px; }
  .profile-themes-media-slot__crop-img.translate-y-26 {
    --translate-y: 26px; }
  .profile-themes-media-slot__crop-img.translate-y-27 {
    --translate-y: 27px; }
  .profile-themes-media-slot__crop-img.translate-y-28 {
    --translate-y: 28px; }
  .profile-themes-media-slot__crop-img.translate-y-29 {
    --translate-y: 29px; }
  .profile-themes-media-slot__crop-img.translate-y-30 {
    --translate-y: 30px; }
  .profile-themes-media-slot__crop-img.translate-y-31 {
    --translate-y: 31px; }
  .profile-themes-media-slot__crop-img.translate-y-32 {
    --translate-y: 32px; }
  .profile-themes-media-slot__crop-img.translate-y-33 {
    --translate-y: 33px; }
  .profile-themes-media-slot__crop-img.translate-y-34 {
    --translate-y: 34px; }
  .profile-themes-media-slot__crop-img.translate-y-35 {
    --translate-y: 35px; }
  .profile-themes-media-slot__crop-img.translate-y-36 {
    --translate-y: 36px; }
  .profile-themes-media-slot__crop-img.translate-y-37 {
    --translate-y: 37px; }
  .profile-themes-media-slot__crop-img.translate-y-38 {
    --translate-y: 38px; }
  .profile-themes-media-slot__crop-img.translate-y-39 {
    --translate-y: 39px; }
  .profile-themes-media-slot__crop-img.translate-y-40 {
    --translate-y: 40px; }
  .profile-themes-media-slot__crop-img.translate-y-41 {
    --translate-y: 41px; }
  .profile-themes-media-slot__crop-img.translate-y-42 {
    --translate-y: 42px; }
  .profile-themes-media-slot__crop-img.translate-y-43 {
    --translate-y: 43px; }
  .profile-themes-media-slot__crop-img.translate-y-44 {
    --translate-y: 44px; }
  .profile-themes-media-slot__crop-img.translate-y-45 {
    --translate-y: 45px; }
  .profile-themes-media-slot__crop-img.translate-y-46 {
    --translate-y: 46px; }
  .profile-themes-media-slot__crop-img.translate-y-47 {
    --translate-y: 47px; }
  .profile-themes-media-slot__crop-img.translate-y-48 {
    --translate-y: 48px; }
  .profile-themes-media-slot__crop-img.translate-y-49 {
    --translate-y: 49px; }
  .profile-themes-media-slot__crop-img.translate-y-50 {
    --translate-y: 50px; }
  .profile-themes-media-slot__crop-img.scale-50 {
    --scale: 0.5; }
  .profile-themes-media-slot__crop-img.scale-51 {
    --scale: 0.51; }
  .profile-themes-media-slot__crop-img.scale-52 {
    --scale: 0.52; }
  .profile-themes-media-slot__crop-img.scale-53 {
    --scale: 0.53; }
  .profile-themes-media-slot__crop-img.scale-54 {
    --scale: 0.54; }
  .profile-themes-media-slot__crop-img.scale-55 {
    --scale: 0.55; }
  .profile-themes-media-slot__crop-img.scale-56 {
    --scale: 0.56; }
  .profile-themes-media-slot__crop-img.scale-57 {
    --scale: 0.57; }
  .profile-themes-media-slot__crop-img.scale-58 {
    --scale: 0.58; }
  .profile-themes-media-slot__crop-img.scale-59 {
    --scale: 0.59; }
  .profile-themes-media-slot__crop-img.scale-60 {
    --scale: 0.6; }
  .profile-themes-media-slot__crop-img.scale-61 {
    --scale: 0.61; }
  .profile-themes-media-slot__crop-img.scale-62 {
    --scale: 0.62; }
  .profile-themes-media-slot__crop-img.scale-63 {
    --scale: 0.63; }
  .profile-themes-media-slot__crop-img.scale-64 {
    --scale: 0.64; }
  .profile-themes-media-slot__crop-img.scale-65 {
    --scale: 0.65; }
  .profile-themes-media-slot__crop-img.scale-66 {
    --scale: 0.66; }
  .profile-themes-media-slot__crop-img.scale-67 {
    --scale: 0.67; }
  .profile-themes-media-slot__crop-img.scale-68 {
    --scale: 0.68; }
  .profile-themes-media-slot__crop-img.scale-69 {
    --scale: 0.69; }
  .profile-themes-media-slot__crop-img.scale-70 {
    --scale: 0.7; }
  .profile-themes-media-slot__crop-img.scale-71 {
    --scale: 0.71; }
  .profile-themes-media-slot__crop-img.scale-72 {
    --scale: 0.72; }
  .profile-themes-media-slot__crop-img.scale-73 {
    --scale: 0.73; }
  .profile-themes-media-slot__crop-img.scale-74 {
    --scale: 0.74; }
  .profile-themes-media-slot__crop-img.scale-75 {
    --scale: 0.75; }
  .profile-themes-media-slot__crop-img.scale-76 {
    --scale: 0.76; }
  .profile-themes-media-slot__crop-img.scale-77 {
    --scale: 0.77; }
  .profile-themes-media-slot__crop-img.scale-78 {
    --scale: 0.78; }
  .profile-themes-media-slot__crop-img.scale-79 {
    --scale: 0.79; }
  .profile-themes-media-slot__crop-img.scale-80 {
    --scale: 0.8; }
  .profile-themes-media-slot__crop-img.scale-81 {
    --scale: 0.81; }
  .profile-themes-media-slot__crop-img.scale-82 {
    --scale: 0.82; }
  .profile-themes-media-slot__crop-img.scale-83 {
    --scale: 0.83; }
  .profile-themes-media-slot__crop-img.scale-84 {
    --scale: 0.84; }
  .profile-themes-media-slot__crop-img.scale-85 {
    --scale: 0.85; }
  .profile-themes-media-slot__crop-img.scale-86 {
    --scale: 0.86; }
  .profile-themes-media-slot__crop-img.scale-87 {
    --scale: 0.87; }
  .profile-themes-media-slot__crop-img.scale-88 {
    --scale: 0.88; }
  .profile-themes-media-slot__crop-img.scale-89 {
    --scale: 0.89; }
  .profile-themes-media-slot__crop-img.scale-90 {
    --scale: 0.9; }
  .profile-themes-media-slot__crop-img.scale-91 {
    --scale: 0.91; }
  .profile-themes-media-slot__crop-img.scale-92 {
    --scale: 0.92; }
  .profile-themes-media-slot__crop-img.scale-93 {
    --scale: 0.93; }
  .profile-themes-media-slot__crop-img.scale-94 {
    --scale: 0.94; }
  .profile-themes-media-slot__crop-img.scale-95 {
    --scale: 0.95; }
  .profile-themes-media-slot__crop-img.scale-96 {
    --scale: 0.96; }
  .profile-themes-media-slot__crop-img.scale-97 {
    --scale: 0.97; }
  .profile-themes-media-slot__crop-img.scale-98 {
    --scale: 0.98; }
  .profile-themes-media-slot__crop-img.scale-99 {
    --scale: 0.99; }
  .profile-themes-media-slot__crop-img.scale-100 {
    --scale: 1; }
  .profile-themes-media-slot__crop-img.scale-101 {
    --scale: 1.01; }
  .profile-themes-media-slot__crop-img.scale-102 {
    --scale: 1.02; }
  .profile-themes-media-slot__crop-img.scale-103 {
    --scale: 1.03; }
  .profile-themes-media-slot__crop-img.scale-104 {
    --scale: 1.04; }
  .profile-themes-media-slot__crop-img.scale-105 {
    --scale: 1.05; }
  .profile-themes-media-slot__crop-img.scale-106 {
    --scale: 1.06; }
  .profile-themes-media-slot__crop-img.scale-107 {
    --scale: 1.07; }
  .profile-themes-media-slot__crop-img.scale-108 {
    --scale: 1.08; }
  .profile-themes-media-slot__crop-img.scale-109 {
    --scale: 1.09; }
  .profile-themes-media-slot__crop-img.scale-110 {
    --scale: 1.1; }
  .profile-themes-media-slot__crop-img.scale-111 {
    --scale: 1.11; }
  .profile-themes-media-slot__crop-img.scale-112 {
    --scale: 1.12; }
  .profile-themes-media-slot__crop-img.scale-113 {
    --scale: 1.13; }
  .profile-themes-media-slot__crop-img.scale-114 {
    --scale: 1.14; }
  .profile-themes-media-slot__crop-img.scale-115 {
    --scale: 1.15; }
  .profile-themes-media-slot__crop-img.scale-116 {
    --scale: 1.16; }
  .profile-themes-media-slot__crop-img.scale-117 {
    --scale: 1.17; }
  .profile-themes-media-slot__crop-img.scale-118 {
    --scale: 1.18; }
  .profile-themes-media-slot__crop-img.scale-119 {
    --scale: 1.19; }
  .profile-themes-media-slot__crop-img.scale-120 {
    --scale: 1.2; }
  .profile-themes-media-slot__crop-img.scale-121 {
    --scale: 1.21; }
  .profile-themes-media-slot__crop-img.scale-122 {
    --scale: 1.22; }
  .profile-themes-media-slot__crop-img.scale-123 {
    --scale: 1.23; }
  .profile-themes-media-slot__crop-img.scale-124 {
    --scale: 1.24; }
  .profile-themes-media-slot__crop-img.scale-125 {
    --scale: 1.25; }
  .profile-themes-media-slot__crop-img.scale-126 {
    --scale: 1.26; }
  .profile-themes-media-slot__crop-img.scale-127 {
    --scale: 1.27; }
  .profile-themes-media-slot__crop-img.scale-128 {
    --scale: 1.28; }
  .profile-themes-media-slot__crop-img.scale-129 {
    --scale: 1.29; }
  .profile-themes-media-slot__crop-img.scale-130 {
    --scale: 1.3; }
  .profile-themes-media-slot__crop-img.scale-131 {
    --scale: 1.31; }
  .profile-themes-media-slot__crop-img.scale-132 {
    --scale: 1.32; }
  .profile-themes-media-slot__crop-img.scale-133 {
    --scale: 1.33; }
  .profile-themes-media-slot__crop-img.scale-134 {
    --scale: 1.34; }
  .profile-themes-media-slot__crop-img.scale-135 {
    --scale: 1.35; }
  .profile-themes-media-slot__crop-img.scale-136 {
    --scale: 1.36; }
  .profile-themes-media-slot__crop-img.scale-137 {
    --scale: 1.37; }
  .profile-themes-media-slot__crop-img.scale-138 {
    --scale: 1.38; }
  .profile-themes-media-slot__crop-img.scale-139 {
    --scale: 1.39; }
  .profile-themes-media-slot__crop-img.scale-140 {
    --scale: 1.4; }
  .profile-themes-media-slot__crop-img.scale-141 {
    --scale: 1.41; }
  .profile-themes-media-slot__crop-img.scale-142 {
    --scale: 1.42; }
  .profile-themes-media-slot__crop-img.scale-143 {
    --scale: 1.43; }
  .profile-themes-media-slot__crop-img.scale-144 {
    --scale: 1.44; }
  .profile-themes-media-slot__crop-img.scale-145 {
    --scale: 1.45; }
  .profile-themes-media-slot__crop-img.scale-146 {
    --scale: 1.46; }
  .profile-themes-media-slot__crop-img.scale-147 {
    --scale: 1.47; }
  .profile-themes-media-slot__crop-img.scale-148 {
    --scale: 1.48; }
  .profile-themes-media-slot__crop-img.scale-149 {
    --scale: 1.49; }
  .profile-themes-media-slot__crop-img.scale-150 {
    --scale: 1.5; }
  .profile-themes-media-slot__crop-img.scale-151 {
    --scale: 1.51; }
  .profile-themes-media-slot__crop-img.scale-152 {
    --scale: 1.52; }
  .profile-themes-media-slot__crop-img.scale-153 {
    --scale: 1.53; }
  .profile-themes-media-slot__crop-img.scale-154 {
    --scale: 1.54; }
  .profile-themes-media-slot__crop-img.scale-155 {
    --scale: 1.55; }
  .profile-themes-media-slot__crop-img.scale-156 {
    --scale: 1.56; }
  .profile-themes-media-slot__crop-img.scale-157 {
    --scale: 1.57; }
  .profile-themes-media-slot__crop-img.scale-158 {
    --scale: 1.58; }
  .profile-themes-media-slot__crop-img.scale-159 {
    --scale: 1.59; }
  .profile-themes-media-slot__crop-img.scale-160 {
    --scale: 1.6; }
  .profile-themes-media-slot__crop-img.scale-161 {
    --scale: 1.61; }
  .profile-themes-media-slot__crop-img.scale-162 {
    --scale: 1.62; }
  .profile-themes-media-slot__crop-img.scale-163 {
    --scale: 1.63; }
  .profile-themes-media-slot__crop-img.scale-164 {
    --scale: 1.64; }
  .profile-themes-media-slot__crop-img.scale-165 {
    --scale: 1.65; }
  .profile-themes-media-slot__crop-img.scale-166 {
    --scale: 1.66; }
  .profile-themes-media-slot__crop-img.scale-167 {
    --scale: 1.67; }
  .profile-themes-media-slot__crop-img.scale-168 {
    --scale: 1.68; }
  .profile-themes-media-slot__crop-img.scale-169 {
    --scale: 1.69; }
  .profile-themes-media-slot__crop-img.scale-170 {
    --scale: 1.7; }
  .profile-themes-media-slot__crop-img.scale-171 {
    --scale: 1.71; }
  .profile-themes-media-slot__crop-img.scale-172 {
    --scale: 1.72; }
  .profile-themes-media-slot__crop-img.scale-173 {
    --scale: 1.73; }
  .profile-themes-media-slot__crop-img.scale-174 {
    --scale: 1.74; }
  .profile-themes-media-slot__crop-img.scale-175 {
    --scale: 1.75; }
  .profile-themes-media-slot__crop-img.scale-176 {
    --scale: 1.76; }
  .profile-themes-media-slot__crop-img.scale-177 {
    --scale: 1.77; }
  .profile-themes-media-slot__crop-img.scale-178 {
    --scale: 1.78; }
  .profile-themes-media-slot__crop-img.scale-179 {
    --scale: 1.79; }
  .profile-themes-media-slot__crop-img.scale-180 {
    --scale: 1.8; }
  .profile-themes-media-slot__crop-img.scale-181 {
    --scale: 1.81; }
  .profile-themes-media-slot__crop-img.scale-182 {
    --scale: 1.82; }
  .profile-themes-media-slot__crop-img.scale-183 {
    --scale: 1.83; }
  .profile-themes-media-slot__crop-img.scale-184 {
    --scale: 1.84; }
  .profile-themes-media-slot__crop-img.scale-185 {
    --scale: 1.85; }
  .profile-themes-media-slot__crop-img.scale-186 {
    --scale: 1.86; }
  .profile-themes-media-slot__crop-img.scale-187 {
    --scale: 1.87; }
  .profile-themes-media-slot__crop-img.scale-188 {
    --scale: 1.88; }
  .profile-themes-media-slot__crop-img.scale-189 {
    --scale: 1.89; }
  .profile-themes-media-slot__crop-img.scale-190 {
    --scale: 1.9; }
  .profile-themes-media-slot__crop-img.scale-191 {
    --scale: 1.91; }
  .profile-themes-media-slot__crop-img.scale-192 {
    --scale: 1.92; }
  .profile-themes-media-slot__crop-img.scale-193 {
    --scale: 1.93; }
  .profile-themes-media-slot__crop-img.scale-194 {
    --scale: 1.94; }
  .profile-themes-media-slot__crop-img.scale-195 {
    --scale: 1.95; }
  .profile-themes-media-slot__crop-img.scale-196 {
    --scale: 1.96; }
  .profile-themes-media-slot__crop-img.scale-197 {
    --scale: 1.97; }
  .profile-themes-media-slot__crop-img.scale-198 {
    --scale: 1.98; }
  .profile-themes-media-slot__crop-img.scale-199 {
    --scale: 1.99; }
  .profile-themes-media-slot__crop-img.scale-200 {
    --scale: 2; }
  .profile-themes-media-slot__crop-img.scale-201 {
    --scale: 2.01; }
  .profile-themes-media-slot__crop-img.scale-202 {
    --scale: 2.02; }
  .profile-themes-media-slot__crop-img.scale-203 {
    --scale: 2.03; }
  .profile-themes-media-slot__crop-img.scale-204 {
    --scale: 2.04; }
  .profile-themes-media-slot__crop-img.scale-205 {
    --scale: 2.05; }
  .profile-themes-media-slot__crop-img.scale-206 {
    --scale: 2.06; }
  .profile-themes-media-slot__crop-img.scale-207 {
    --scale: 2.07; }
  .profile-themes-media-slot__crop-img.scale-208 {
    --scale: 2.08; }
  .profile-themes-media-slot__crop-img.scale-209 {
    --scale: 2.09; }
  .profile-themes-media-slot__crop-img.scale-210 {
    --scale: 2.1; }
  .profile-themes-media-slot__crop-img.scale-211 {
    --scale: 2.11; }
  .profile-themes-media-slot__crop-img.scale-212 {
    --scale: 2.12; }
  .profile-themes-media-slot__crop-img.scale-213 {
    --scale: 2.13; }
  .profile-themes-media-slot__crop-img.scale-214 {
    --scale: 2.14; }
  .profile-themes-media-slot__crop-img.scale-215 {
    --scale: 2.15; }
  .profile-themes-media-slot__crop-img.scale-216 {
    --scale: 2.16; }
  .profile-themes-media-slot__crop-img.scale-217 {
    --scale: 2.17; }
  .profile-themes-media-slot__crop-img.scale-218 {
    --scale: 2.18; }
  .profile-themes-media-slot__crop-img.scale-219 {
    --scale: 2.19; }
  .profile-themes-media-slot__crop-img.scale-220 {
    --scale: 2.2; }
  .profile-themes-media-slot__crop-img.scale-221 {
    --scale: 2.21; }
  .profile-themes-media-slot__crop-img.scale-222 {
    --scale: 2.22; }
  .profile-themes-media-slot__crop-img.scale-223 {
    --scale: 2.23; }
  .profile-themes-media-slot__crop-img.scale-224 {
    --scale: 2.24; }
  .profile-themes-media-slot__crop-img.scale-225 {
    --scale: 2.25; }
  .profile-themes-media-slot__crop-img.scale-226 {
    --scale: 2.26; }
  .profile-themes-media-slot__crop-img.scale-227 {
    --scale: 2.27; }
  .profile-themes-media-slot__crop-img.scale-228 {
    --scale: 2.28; }
  .profile-themes-media-slot__crop-img.scale-229 {
    --scale: 2.29; }
  .profile-themes-media-slot__crop-img.scale-230 {
    --scale: 2.3; }
  .profile-themes-media-slot__crop-img.scale-231 {
    --scale: 2.31; }
  .profile-themes-media-slot__crop-img.scale-232 {
    --scale: 2.32; }
  .profile-themes-media-slot__crop-img.scale-233 {
    --scale: 2.33; }
  .profile-themes-media-slot__crop-img.scale-234 {
    --scale: 2.34; }
  .profile-themes-media-slot__crop-img.scale-235 {
    --scale: 2.35; }
  .profile-themes-media-slot__crop-img.scale-236 {
    --scale: 2.36; }
  .profile-themes-media-slot__crop-img.scale-237 {
    --scale: 2.37; }
  .profile-themes-media-slot__crop-img.scale-238 {
    --scale: 2.38; }
  .profile-themes-media-slot__crop-img.scale-239 {
    --scale: 2.39; }
  .profile-themes-media-slot__crop-img.scale-240 {
    --scale: 2.4; }
  .profile-themes-media-slot__crop-img.scale-241 {
    --scale: 2.41; }
  .profile-themes-media-slot__crop-img.scale-242 {
    --scale: 2.42; }
  .profile-themes-media-slot__crop-img.scale-243 {
    --scale: 2.43; }
  .profile-themes-media-slot__crop-img.scale-244 {
    --scale: 2.44; }
  .profile-themes-media-slot__crop-img.scale-245 {
    --scale: 2.45; }
  .profile-themes-media-slot__crop-img.scale-246 {
    --scale: 2.46; }
  .profile-themes-media-slot__crop-img.scale-247 {
    --scale: 2.47; }
  .profile-themes-media-slot__crop-img.scale-248 {
    --scale: 2.48; }
  .profile-themes-media-slot__crop-img.scale-249 {
    --scale: 2.49; }
  .profile-themes-media-slot__crop-img.scale-250 {
    --scale: 2.5; }
  .profile-themes-media-slot__crop-img.scale-251 {
    --scale: 2.51; }
  .profile-themes-media-slot__crop-img.scale-252 {
    --scale: 2.52; }
  .profile-themes-media-slot__crop-img.scale-253 {
    --scale: 2.53; }
  .profile-themes-media-slot__crop-img.scale-254 {
    --scale: 2.54; }
  .profile-themes-media-slot__crop-img.scale-255 {
    --scale: 2.55; }
  .profile-themes-media-slot__crop-img.scale-256 {
    --scale: 2.56; }
  .profile-themes-media-slot__crop-img.scale-257 {
    --scale: 2.57; }
  .profile-themes-media-slot__crop-img.scale-258 {
    --scale: 2.58; }
  .profile-themes-media-slot__crop-img.scale-259 {
    --scale: 2.59; }
  .profile-themes-media-slot__crop-img.scale-260 {
    --scale: 2.6; }
  .profile-themes-media-slot__crop-img.scale-261 {
    --scale: 2.61; }
  .profile-themes-media-slot__crop-img.scale-262 {
    --scale: 2.62; }
  .profile-themes-media-slot__crop-img.scale-263 {
    --scale: 2.63; }
  .profile-themes-media-slot__crop-img.scale-264 {
    --scale: 2.64; }
  .profile-themes-media-slot__crop-img.scale-265 {
    --scale: 2.65; }
  .profile-themes-media-slot__crop-img.scale-266 {
    --scale: 2.66; }
  .profile-themes-media-slot__crop-img.scale-267 {
    --scale: 2.67; }
  .profile-themes-media-slot__crop-img.scale-268 {
    --scale: 2.68; }
  .profile-themes-media-slot__crop-img.scale-269 {
    --scale: 2.69; }
  .profile-themes-media-slot__crop-img.scale-270 {
    --scale: 2.7; }
  .profile-themes-media-slot__crop-img.scale-271 {
    --scale: 2.71; }
  .profile-themes-media-slot__crop-img.scale-272 {
    --scale: 2.72; }
  .profile-themes-media-slot__crop-img.scale-273 {
    --scale: 2.73; }
  .profile-themes-media-slot__crop-img.scale-274 {
    --scale: 2.74; }
  .profile-themes-media-slot__crop-img.scale-275 {
    --scale: 2.75; }
  .profile-themes-media-slot__crop-img.scale-276 {
    --scale: 2.76; }
  .profile-themes-media-slot__crop-img.scale-277 {
    --scale: 2.77; }
  .profile-themes-media-slot__crop-img.scale-278 {
    --scale: 2.78; }
  .profile-themes-media-slot__crop-img.scale-279 {
    --scale: 2.79; }
  .profile-themes-media-slot__crop-img.scale-280 {
    --scale: 2.8; }
  .profile-themes-media-slot__crop-img.scale-281 {
    --scale: 2.81; }
  .profile-themes-media-slot__crop-img.scale-282 {
    --scale: 2.82; }
  .profile-themes-media-slot__crop-img.scale-283 {
    --scale: 2.83; }
  .profile-themes-media-slot__crop-img.scale-284 {
    --scale: 2.84; }
  .profile-themes-media-slot__crop-img.scale-285 {
    --scale: 2.85; }
  .profile-themes-media-slot__crop-img.scale-286 {
    --scale: 2.86; }
  .profile-themes-media-slot__crop-img.scale-287 {
    --scale: 2.87; }
  .profile-themes-media-slot__crop-img.scale-288 {
    --scale: 2.88; }
  .profile-themes-media-slot__crop-img.scale-289 {
    --scale: 2.89; }
  .profile-themes-media-slot__crop-img.scale-290 {
    --scale: 2.9; }
  .profile-themes-media-slot__crop-img.scale-291 {
    --scale: 2.91; }
  .profile-themes-media-slot__crop-img.scale-292 {
    --scale: 2.92; }
  .profile-themes-media-slot__crop-img.scale-293 {
    --scale: 2.93; }
  .profile-themes-media-slot__crop-img.scale-294 {
    --scale: 2.94; }
  .profile-themes-media-slot__crop-img.scale-295 {
    --scale: 2.95; }
  .profile-themes-media-slot__crop-img.scale-296 {
    --scale: 2.96; }
  .profile-themes-media-slot__crop-img.scale-297 {
    --scale: 2.97; }
  .profile-themes-media-slot__crop-img.scale-298 {
    --scale: 2.98; }
  .profile-themes-media-slot__crop-img.scale-299 {
    --scale: 2.99; }
  .profile-themes-media-slot__crop-img.scale-300 {
    --scale: 3; }

.profile-themes-media-slot__darken {
  position: absolute;
  inset: 0;
  z-index: 2;
  pointer-events: none;
  background: #000000; }
  .profile-themes-media-slot__darken.darken-0 {
    opacity: 0; }
  .profile-themes-media-slot__darken.darken-1 {
    opacity: 0.01; }
  .profile-themes-media-slot__darken.darken-2 {
    opacity: 0.02; }
  .profile-themes-media-slot__darken.darken-3 {
    opacity: 0.03; }
  .profile-themes-media-slot__darken.darken-4 {
    opacity: 0.04; }
  .profile-themes-media-slot__darken.darken-5 {
    opacity: 0.05; }
  .profile-themes-media-slot__darken.darken-6 {
    opacity: 0.06; }
  .profile-themes-media-slot__darken.darken-7 {
    opacity: 0.07; }
  .profile-themes-media-slot__darken.darken-8 {
    opacity: 0.08; }
  .profile-themes-media-slot__darken.darken-9 {
    opacity: 0.09; }
  .profile-themes-media-slot__darken.darken-10 {
    opacity: 0.1; }
  .profile-themes-media-slot__darken.darken-11 {
    opacity: 0.11; }
  .profile-themes-media-slot__darken.darken-12 {
    opacity: 0.12; }
  .profile-themes-media-slot__darken.darken-13 {
    opacity: 0.13; }
  .profile-themes-media-slot__darken.darken-14 {
    opacity: 0.14; }
  .profile-themes-media-slot__darken.darken-15 {
    opacity: 0.15; }
  .profile-themes-media-slot__darken.darken-16 {
    opacity: 0.16; }
  .profile-themes-media-slot__darken.darken-17 {
    opacity: 0.17; }
  .profile-themes-media-slot__darken.darken-18 {
    opacity: 0.18; }
  .profile-themes-media-slot__darken.darken-19 {
    opacity: 0.19; }
  .profile-themes-media-slot__darken.darken-20 {
    opacity: 0.2; }
  .profile-themes-media-slot__darken.darken-21 {
    opacity: 0.21; }
  .profile-themes-media-slot__darken.darken-22 {
    opacity: 0.22; }
  .profile-themes-media-slot__darken.darken-23 {
    opacity: 0.23; }
  .profile-themes-media-slot__darken.darken-24 {
    opacity: 0.24; }
  .profile-themes-media-slot__darken.darken-25 {
    opacity: 0.25; }
  .profile-themes-media-slot__darken.darken-26 {
    opacity: 0.26; }
  .profile-themes-media-slot__darken.darken-27 {
    opacity: 0.27; }
  .profile-themes-media-slot__darken.darken-28 {
    opacity: 0.28; }
  .profile-themes-media-slot__darken.darken-29 {
    opacity: 0.29; }
  .profile-themes-media-slot__darken.darken-30 {
    opacity: 0.3; }
  .profile-themes-media-slot__darken.darken-31 {
    opacity: 0.31; }
  .profile-themes-media-slot__darken.darken-32 {
    opacity: 0.32; }
  .profile-themes-media-slot__darken.darken-33 {
    opacity: 0.33; }
  .profile-themes-media-slot__darken.darken-34 {
    opacity: 0.34; }
  .profile-themes-media-slot__darken.darken-35 {
    opacity: 0.35; }
  .profile-themes-media-slot__darken.darken-36 {
    opacity: 0.36; }
  .profile-themes-media-slot__darken.darken-37 {
    opacity: 0.37; }
  .profile-themes-media-slot__darken.darken-38 {
    opacity: 0.38; }
  .profile-themes-media-slot__darken.darken-39 {
    opacity: 0.39; }
  .profile-themes-media-slot__darken.darken-40 {
    opacity: 0.4; }
  .profile-themes-media-slot__darken.darken-41 {
    opacity: 0.41; }
  .profile-themes-media-slot__darken.darken-42 {
    opacity: 0.42; }
  .profile-themes-media-slot__darken.darken-43 {
    opacity: 0.43; }
  .profile-themes-media-slot__darken.darken-44 {
    opacity: 0.44; }
  .profile-themes-media-slot__darken.darken-45 {
    opacity: 0.45; }
  .profile-themes-media-slot__darken.darken-46 {
    opacity: 0.46; }
  .profile-themes-media-slot__darken.darken-47 {
    opacity: 0.47; }
  .profile-themes-media-slot__darken.darken-48 {
    opacity: 0.48; }
  .profile-themes-media-slot__darken.darken-49 {
    opacity: 0.49; }
  .profile-themes-media-slot__darken.darken-50 {
    opacity: 0.5; }
  .profile-themes-media-slot__darken.darken-51 {
    opacity: 0.51; }
  .profile-themes-media-slot__darken.darken-52 {
    opacity: 0.52; }
  .profile-themes-media-slot__darken.darken-53 {
    opacity: 0.53; }
  .profile-themes-media-slot__darken.darken-54 {
    opacity: 0.54; }
  .profile-themes-media-slot__darken.darken-55 {
    opacity: 0.55; }
  .profile-themes-media-slot__darken.darken-56 {
    opacity: 0.56; }
  .profile-themes-media-slot__darken.darken-57 {
    opacity: 0.57; }
  .profile-themes-media-slot__darken.darken-58 {
    opacity: 0.58; }
  .profile-themes-media-slot__darken.darken-59 {
    opacity: 0.59; }
  .profile-themes-media-slot__darken.darken-60 {
    opacity: 0.6; }
  .profile-themes-media-slot__darken.darken-61 {
    opacity: 0.61; }
  .profile-themes-media-slot__darken.darken-62 {
    opacity: 0.62; }
  .profile-themes-media-slot__darken.darken-63 {
    opacity: 0.63; }
  .profile-themes-media-slot__darken.darken-64 {
    opacity: 0.64; }
  .profile-themes-media-slot__darken.darken-65 {
    opacity: 0.65; }
  .profile-themes-media-slot__darken.darken-66 {
    opacity: 0.66; }
  .profile-themes-media-slot__darken.darken-67 {
    opacity: 0.67; }
  .profile-themes-media-slot__darken.darken-68 {
    opacity: 0.68; }
  .profile-themes-media-slot__darken.darken-69 {
    opacity: 0.69; }
  .profile-themes-media-slot__darken.darken-70 {
    opacity: 0.7; }
  .profile-themes-media-slot__darken.darken-71 {
    opacity: 0.71; }
  .profile-themes-media-slot__darken.darken-72 {
    opacity: 0.72; }
  .profile-themes-media-slot__darken.darken-73 {
    opacity: 0.73; }
  .profile-themes-media-slot__darken.darken-74 {
    opacity: 0.74; }
  .profile-themes-media-slot__darken.darken-75 {
    opacity: 0.75; }
  .profile-themes-media-slot__darken.darken-76 {
    opacity: 0.76; }
  .profile-themes-media-slot__darken.darken-77 {
    opacity: 0.77; }
  .profile-themes-media-slot__darken.darken-78 {
    opacity: 0.78; }
  .profile-themes-media-slot__darken.darken-79 {
    opacity: 0.79; }
  .profile-themes-media-slot__darken.darken-80 {
    opacity: 0.8; }
  .profile-themes-media-slot__darken.darken-81 {
    opacity: 0.81; }
  .profile-themes-media-slot__darken.darken-82 {
    opacity: 0.82; }
  .profile-themes-media-slot__darken.darken-83 {
    opacity: 0.83; }
  .profile-themes-media-slot__darken.darken-84 {
    opacity: 0.84; }
  .profile-themes-media-slot__darken.darken-85 {
    opacity: 0.85; }
  .profile-themes-media-slot__darken.darken-86 {
    opacity: 0.86; }
  .profile-themes-media-slot__darken.darken-87 {
    opacity: 0.87; }
  .profile-themes-media-slot__darken.darken-88 {
    opacity: 0.88; }
  .profile-themes-media-slot__darken.darken-89 {
    opacity: 0.89; }
  .profile-themes-media-slot__darken.darken-90 {
    opacity: 0.9; }
  .profile-themes-media-slot__darken.darken-91 {
    opacity: 0.91; }
  .profile-themes-media-slot__darken.darken-92 {
    opacity: 0.92; }
  .profile-themes-media-slot__darken.darken-93 {
    opacity: 0.93; }
  .profile-themes-media-slot__darken.darken-94 {
    opacity: 0.94; }
  .profile-themes-media-slot__darken.darken-95 {
    opacity: 0.95; }
  .profile-themes-media-slot__darken.darken-96 {
    opacity: 0.96; }
  .profile-themes-media-slot__darken.darken-97 {
    opacity: 0.97; }
  .profile-themes-media-slot__darken.darken-98 {
    opacity: 0.98; }
  .profile-themes-media-slot__darken.darken-99 {
    opacity: 0.99; }
  .profile-themes-media-slot__darken.darken-100 {
    opacity: 1; }

.profile-themes-media-slot__hint {
  margin: 0;
  padding: 1.2rem;
  text-align: center;
  color: rgba(255, 255, 255, 0.65); }

.profile-themes-media-slot__tools {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem; }

.profile-themes-media-slot__zoom {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  color: rgba(255, 255, 255, 0.75);
  font-size: 0.8rem;
  flex: 1;
  min-width: 140px; }

.profile-themes-media-slot__file {
  display: none; }

.profile-themes-media-slot__video-preview {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 5;
  border-radius: 8px;
  overflow: hidden;
  background: #1c2d38; }

.profile-themes-media-slot__status {
  margin: 0;
  color: rgba(90, 195, 255, 0.9);
  font-size: 0.85rem; }

.profile-themes-media-slot__error {
  margin: 0;
  color: #9e2222;
  font-size: 0.85rem; }

.profile-themes-preview {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  padding: 0.85rem;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(8, 16, 26, 0.45); }

.profile-themes-preview__title {
  margin: 0;
  color: rgba(255, 255, 255, 0.92); }

.profile-themes-preview__hint {
  margin: 0;
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.85rem; }

.profile-themes-preview__stack {
  display: flex;
  flex-direction: column;
  gap: 0.85rem; }

.profile-themes-preview__stack--row {
  display: grid;
  grid-template-columns: minmax(220px, 280px) minmax(0, 1fr);
  gap: 1rem;
  align-items: start; }
  .profile-themes-preview__stack--row .profile-themes-preview__card-wrap {
    order: 1; }
  .profile-themes-preview__stack--row .profile-themes-preview__roster {
    order: 2; }

@media (max-width: 1023px) {
  .profile-themes-preview__stack--row {
    grid-template-columns: 1fr; } }

.profile-themes-preview__label {
  display: block;
  margin-bottom: 0.35rem;
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.55);
  text-transform: uppercase; }

.profile-themes-preview__roster-shell {
  position: relative;
  width: 100%;
  aspect-ratio: 977 / 150;
  min-height: 0;
  overflow: hidden;
  border-radius: 10px; }

.profile-themes-preview__roster-shell .roster-file-summary-hero__banner {
  position: absolute;
  inset: 0; }

.profile-themes-preview__roster-fg {
  position: relative;
  z-index: 3;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  height: 100%;
  padding: 0.65rem 0.85rem;
  box-sizing: border-box;
  pointer-events: none; }

.profile-themes-preview__card-shell {
  position: relative;
  width: 100%;
  max-width: 280px;
  min-height: 160px; }

.profile-themes-preview__card-shell .member-profile-card {
  position: relative;
  z-index: 2; }

.profile-themes-preview__identity-text {
  min-width: 0; }

.profile-themes-preview__name {
  font-weight: 650;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; }

.profile-themes-preview__handle,
.profile-themes-preview__moniker,
.profile-themes-preview__assignment {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.65);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; }

.profile-themes-preview__roster-meta {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin-top: 0.2rem;
  min-width: 0; }

.profile-themes-preview__rank-img {
  width: 28px;
  height: 28px;
  object-fit: contain;
  flex-shrink: 0; }

.profile-themes-preview__rank-name {
  font-size: 0.78rem;
  color: rgba(255, 255, 255, 0.85); }

.profile-themes-preview__status,
.profile-themes-preview__error {
  margin: 0;
  font-size: 0.85rem; }

.profile-themes-preview__status {
  color: rgba(255, 255, 255, 0.65); }

.profile-themes-preview__error {
  color: #9e2222; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.theme-and-level {
  display: flex;
  flex-direction: row;
  gap: 10px; }
  .theme-and-level .themes-block {
    width: 50%; }
  .theme-and-level .training-levels-block {
    width: 50%; }

.create-module-modal .modal-dialog {
  margin: auto;
  width: 1080px; }

.create-module-modal .modal-content {
  background-color: #1e3042;
  width: 1100px;
  height: 85%;
  margin-top: 120px;
  border: 1px solid #491212; }

.create-module-modal .modal-header {
  color: #dfdfdf; }
  .create-module-modal .modal-header .modal-title {
    font-size: 1.5rem;
    color: #dfdfdf; }
  .create-module-modal .modal-header .btn-close {
    color: #dfdfdf; }
    .create-module-modal .modal-header .btn-close:hover, .create-module-modal .modal-header .btn-close:focus {
      color: #0c2637; }

.create-module-modal .modal-body {
  padding: 20px; }
  .create-module-modal .modal-body .form-control {
    position: relative;
    border-width: 0px;
    width: -webkit-fill-available;
    height: 16px;
    padding: 3px 5px;
    border-radius: 4px;
    color: #0c2637; }
  .create-module-modal .modal-body .calendar-template-input.form-control,
  .create-module-modal .modal-body .calendar-template-dropdown.form-control {
    width: 232px;
    padding: 2px; }
  .create-module-modal .modal-body .modal-footer {
    display: flex;
    justify-content: flex-start; }

.modal-content.mcq-excel-import-error-modal .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(to top, #491212, #5e2f2fd3, #491212);
  padding: 5px 0 5px 10px;
  color: #dfdfdf;
  font-weight: bold;
  text-transform: uppercase;
  border-bottom: 3px solid #b8b8b8;
  border-radius: 8px 8px 0 0; }

.modal-content.mcq-excel-import-error-modal .mcq-excel-import-error-modal__title {
  margin: 0;
  font-size: small; }

.modal-content.mcq-excel-import-error-modal .icon {
  display: flex;
  height: 18px;
  overflow: hidden;
  margin-left: auto;
  margin-right: 0; }
  .modal-content.mcq-excel-import-error-modal .icon .close-event-button {
    position: relative;
    height: 40px;
    margin-right: 10px;
    object-fit: contain;
    overflow: hidden;
    cursor: pointer; }
    .modal-content.mcq-excel-import-error-modal .icon .close-event-button:hover {
      top: -21px; }

.modal-content.mcq-excel-import-error-modal .mcq-excel-import-error-modal__content {
  padding: 15px;
  background: #163447; }

.modal-content.mcq-excel-import-error-modal .mcq-excel-import-error-modal__hint {
  margin: 0 0 12px;
  color: #b8b8b8;
  font-size: 0.9rem; }

.modal-content.mcq-excel-import-error-modal .mcq-excel-import-error-modal__log {
  width: 100%;
  min-height: 280px;
  margin: 0 0 14px;
  padding: 12px;
  border: 1px solid #384858;
  border-radius: 8px;
  background: #0c2637;
  color: #dfdfdf;
  font-family: Consolas, "Courier New", monospace;
  font-size: 0.82rem;
  line-height: 1.45;
  resize: vertical;
  white-space: pre-wrap;
  word-break: break-word; }
  .modal-content.mcq-excel-import-error-modal .mcq-excel-import-error-modal__log::-webkit-scrollbar {
    width: 6px; }
  .modal-content.mcq-excel-import-error-modal .mcq-excel-import-error-modal__log::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .modal-content.mcq-excel-import-error-modal .mcq-excel-import-error-modal__log::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .modal-content.mcq-excel-import-error-modal .mcq-excel-import-error-modal__log::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }

.modal-content.mcq-excel-import-error-modal .mcq-excel-import-error-modal__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: flex-end; }

.modal-content.mcq-save-modal .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(to top, #491212, #5e2f2fd3, #491212);
  padding: 5px 0px 5px 10px;
  color: #dfdfdf;
  font-size: medium;
  font-weight: bold;
  text-transform: uppercase;
  border-bottom: 3px solid #b8b8b8;
  border-radius: 8px 8px 0px 0px; }
  .modal-content.mcq-save-modal .header .mcq-save-modal-h3 {
    margin: 0;
    font-size: small; }
  .modal-content.mcq-save-modal .header .icon {
    display: flex;
    height: 18px;
    overflow: hidden;
    margin-left: auto;
    margin-right: 0; }
    .modal-content.mcq-save-modal .header .icon .close-event-button {
      position: relative;
      height: 40px;
      margin-right: 10px;
      object-fit: contain;
      overflow: hidden;
      cursor: pointer; }
      .modal-content.mcq-save-modal .header .icon .close-event-button:hover {
        top: -21px; }

.modal-content.mcq-save-modal .content {
  padding: 15px;
  width: auto;
  background: #163447;
  align-content: center; }
  .modal-content.mcq-save-modal .content .mcq-save-mode-toggle {
    display: flex;
    justify-content: center;
    gap: 10px;
    position: relative;
    margin: 5px; }
  .modal-content.mcq-save-modal .content .mcq-save-live-section {
    position: relative; }
    .modal-content.mcq-save-modal .content .mcq-save-live-section .version-description {
      width: 430px;
      text-align: justify;
      padding: 10px 0; }
    .modal-content.mcq-save-modal .content .mcq-save-live-section .mcq-save-modal-button {
      position: relative;
      display: flex;
      margin: auto; }
    .modal-content.mcq-save-modal .content .mcq-save-live-section .mcq-save-progress {
      margin: 0.85rem 0 1rem;
      display: grid;
      gap: 0.4rem; }
    .modal-content.mcq-save-modal .content .mcq-save-live-section .mcq-save-progress__label {
      font-size: 0.82rem;
      color: #dfdfdf; }
    .modal-content.mcq-save-modal .content .mcq-save-live-section .mcq-save-progress__bar {
      width: 100%;
      height: 0.65rem;
      border: none;
      border-radius: 999px;
      overflow: hidden;
      background: rgba(21, 28, 36, 0.65); }
      .modal-content.mcq-save-modal .content .mcq-save-live-section .mcq-save-progress__bar::-webkit-progress-bar {
        background: rgba(21, 28, 36, 0.65);
        border-radius: 999px; }
      .modal-content.mcq-save-modal .content .mcq-save-live-section .mcq-save-progress__bar::-webkit-progress-value {
        background: linear-gradient(to right, #3a78b4, #5ac3ff);
        border-radius: 999px; }
      .modal-content.mcq-save-modal .content .mcq-save-live-section .mcq-save-progress__bar::-moz-progress-bar {
        background: linear-gradient(to right, #3a78b4, #5ac3ff);
        border-radius: 999px; }
  .modal-content.mcq-save-modal .content .mcq-save-review-section .mcq-save-description,
  .modal-content.mcq-save-modal .content .mcq-save-live-section .mcq-save-description {
    width: 430px;
    text-align: justify;
    padding: 10px 0; }
  .modal-content.mcq-save-modal .content .mcq-save-review-section .mcq-save-fieldset,
  .modal-content.mcq-save-modal .content .mcq-save-live-section .mcq-save-fieldset {
    display: flex;
    justify-content: center;
    gap: 10px; }

.modal.create-module {
  display: contents;
  flex-direction: column;
  position: relative;
  background-color: #2a3847;
  padding: 0;
  border-radius: 8px;
  overflow-y: auto; }
  .modal.create-module::-webkit-scrollbar {
    width: 6px; }
  .modal.create-module::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .modal.create-module::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .modal.create-module::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }
  .modal.create-module .header.create-module {
    font-size: small;
    margin: 0px;
    display: flex;
    justify-content: space-between;
    color: #dfdfdf;
    text-transform: uppercase;
    font-weight: bold;
    align-items: center;
    padding: 5px 10px;
    border-bottom: 2px solid #2a3847;
    border-radius: 8px 8px 0px 0px;
    background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___}); }
    .modal.create-module .header.create-module .icon {
      display: flex;
      height: 18px;
      overflow: hidden;
      margin-left: auto;
      margin-right: 10px; }
      .modal.create-module .header.create-module .icon .close-modal-button {
        position: relative;
        height: 40px;
        object-fit: contain;
        overflow: hidden;
        cursor: pointer; }
        .modal.create-module .header.create-module .icon .close-modal-button:hover {
          top: -21px; }
  .modal.create-module .admin-block-container,
  .modal.create-module .create-module {
    margin: 10px 10px; }
    .modal.create-module .admin-block-container.information-block,
    .modal.create-module .create-module.information-block {
      max-width: 100%;
      min-height: 183px; }
    .modal.create-module .admin-block-container.training-reference-block,
    .modal.create-module .create-module.training-reference-block {
      display: flex;
      flex-direction: column;
      max-width: 100%;
      min-height: fit-content; }
      .modal.create-module .admin-block-container.training-reference-block .selecting-training-reference,
      .modal.create-module .create-module.training-reference-block .selecting-training-reference {
        display: flex;
        gap: 20px;
        flex-direction: row; }
      .modal.create-module .admin-block-container.training-reference-block .training-reference-table,
      .modal.create-module .create-module.training-reference-block .training-reference-table {
        max-height: 300px;
        overflow-y: auto; }
        .modal.create-module .admin-block-container.training-reference-block .training-reference-table::-webkit-scrollbar,
        .modal.create-module .create-module.training-reference-block .training-reference-table::-webkit-scrollbar {
          width: 6px; }
        .modal.create-module .admin-block-container.training-reference-block .training-reference-table::-webkit-scrollbar-track,
        .modal.create-module .create-module.training-reference-block .training-reference-table::-webkit-scrollbar-track {
          background: #2e3842;
          border-radius: 4px;
          padding-right: 1px; }
        .modal.create-module .admin-block-container.training-reference-block .training-reference-table::-webkit-scrollbar-thumb,
        .modal.create-module .create-module.training-reference-block .training-reference-table::-webkit-scrollbar-thumb {
          background-color: #491212;
          border-radius: 4px; }
          .modal.create-module .admin-block-container.training-reference-block .training-reference-table::-webkit-scrollbar-thumb:hover,
          .modal.create-module .create-module.training-reference-block .training-reference-table::-webkit-scrollbar-thumb:hover {
            background-color: #200808; }
    .modal.create-module .admin-block-container .lexical-public-html,
    .modal.create-module .create-module .lexical-public-html {
      max-height: calc(60vh - 140px);
      overflow-y: auto; }
      .modal.create-module .admin-block-container .lexical-public-html::-webkit-scrollbar,
      .modal.create-module .create-module .lexical-public-html::-webkit-scrollbar {
        width: 6px; }
      .modal.create-module .admin-block-container .lexical-public-html::-webkit-scrollbar-track,
      .modal.create-module .create-module .lexical-public-html::-webkit-scrollbar-track {
        background: #2e3842;
        border-radius: 4px;
        padding-right: 1px; }
      .modal.create-module .admin-block-container .lexical-public-html::-webkit-scrollbar-thumb,
      .modal.create-module .create-module .lexical-public-html::-webkit-scrollbar-thumb {
        background-color: #491212;
        border-radius: 4px; }
        .modal.create-module .admin-block-container .lexical-public-html::-webkit-scrollbar-thumb:hover,
        .modal.create-module .create-module .lexical-public-html::-webkit-scrollbar-thumb:hover {
          background-color: #200808; }
    .modal.create-module .admin-block-container .input-field,
    .modal.create-module .create-module .input-field {
      margin-bottom: 10px; }
      .modal.create-module .admin-block-container .input-field .home-file,
      .modal.create-module .create-module .input-field .home-file {
        color: #dfdfdf;
        font-size: 0.9rem;
        margin-bottom: 3px; }
      .modal.create-module .admin-block-container .input-field .form-control,
      .modal.create-module .admin-block-container .input-field .theme-select,
      .modal.create-module .admin-block-container .input-field .level-select,
      .modal.create-module .create-module .input-field .form-control,
      .modal.create-module .create-module .input-field .theme-select,
      .modal.create-module .create-module .input-field .level-select {
        height: auto;
        width: 100%;
        background-color: #dfdfdf;
        border-radius: 4px; }
  .modal.create-module .footer.create-module {
    display: flex;
    margin-top: 10px;
    margin-left: 20px;
    margin-bottom: 10px; }
  .modal.create-module .lexical-document-footer {
    margin-left: 20px;
    margin-top: 15px; }
    .modal.create-module .lexical-document-footer .btn-style1 {
      margin-top: 10px; }

.admin-block-container,
.create-mcq {
  margin: 10px 0px; }

.module-view-toggle {
  display: flex;
  justify-content: center;
  margin: 20px 0; }
  .module-view-toggle .btn-toggle {
    border: 1px solid #555;
    background: #f5f5f5;
    color: #333;
    padding: 6px 16px;
    margin: 0 4px;
    border-radius: 4px;
    cursor: pointer; }
    .module-view-toggle .btn-toggle.active {
      background: #222;
      color: #fff;
      font-weight: bold; }

.module-questions {
  display: flex;
  flex-direction: column;
  width: -webkit-fill-available;
  margin: 0 auto;
  gap: 0.75rem; }
  .module-questions .mqc-toolbar {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 8px 12px;
    background: #172738;
    border: 1px solid #491212;
    border-radius: 8px; }
  .module-questions .mqc-toolbar__meta {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.65rem;
    min-width: 0; }
  .module-questions .mqc-toolbar__title {
    margin: 0;
    font-size: 0.8rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #dfdfdf; }
  .module-questions .mqc-toolbar__count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 1.5rem;
    height: 1.35rem;
    padding: 0 0.45rem;
    border-radius: 999px;
    background: #2a3847;
    border: 1px solid #384858;
    color: #b8b8b8;
    font-size: 0.75rem;
    font-weight: 700; }
  .module-questions .mqc-toolbar__badge {
    padding: 0.2rem 0.55rem;
    border-radius: 999px;
    border: 1px solid #9b602a;
    color: #9b602a;
    font-size: 0.68rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase; }
  .module-questions .mqc-toolbar__actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
    flex-shrink: 0;
    margin-left: auto; }
  .module-questions .mqc-toolbar__add,
  .module-questions .mqc-toolbar__import,
  .module-questions .mqc-toolbar__export {
    flex-shrink: 0; }
  .module-questions .mqc-content {
    display: flex;
    flex-direction: column;
    gap: 0.65rem;
    position: relative;
    background: #172738;
    min-height: 140px;
    max-height: calc(100vh - 510px);
    border: 1px solid #491212;
    border-radius: 8px;
    padding: 12px;
    overflow-y: auto;
    margin-bottom: 12px; }
    .module-questions .mqc-content::-webkit-scrollbar {
      width: 6px; }
    .module-questions .mqc-content::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .module-questions .mqc-content::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .module-questions .mqc-content::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
  .module-questions .mqc-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 110px;
    padding: 1rem;
    border: 1px dashed #384858;
    border-radius: 8px;
    background: rgba(12, 38, 55, 0.45); }
  .module-questions .mqc-loading-more {
    display: flex;
    justify-content: center;
    padding: 0.75rem 0.5rem 0.25rem; }
  .module-questions .mqc-loading-more__text {
    margin: 0;
    font-size: 0.8rem;
    color: rgba(223, 223, 223, 0.85); }
  .module-questions .mqc-empty__text {
    margin: 0;
    text-align: center;
    color: #b8b8b8;
    font-size: 0.9rem;
    font-style: italic; }
  .module-questions .sortable-question {
    transition: transform 0.2s ease; }
  .module-questions .question-accordion {
    background: #1c2d38;
    border-radius: 8px;
    border: 1px solid #384858;
    overflow: hidden;
    transition: border-color 0.22s ease, box-shadow 0.22s ease; }
    .module-questions .question-accordion.is-open {
      border-color: #004872;
      box-shadow: 0 4px 14px rgba(0, 0, 0, 0.22); }
      .module-questions .question-accordion.is-open .question-header-line {
        border-bottom-color: rgba(0, 72, 114, 0.45); }
    .module-questions .question-accordion.is-readonly {
      opacity: 0.92; }
  .module-questions .question-accordion-panel__inner {
    animation: mqcAccordionIn 0.28s ease-out; }
  .module-questions .question-body {
    padding: 1rem 1.2rem;
    backdrop-filter: blur(6px) saturate(33%);
    -webkit-backdrop-filter: blur(4px) saturate(33%);
    background-color: #163447;
    animation: fadeIn 0.6s ease-out; }

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px); }
  to {
    opacity: 1;
    transform: translateY(0); } }

@keyframes mqcAccordionIn {
  from {
    opacity: 0;
    transform: translateY(-8px); }
  to {
    opacity: 1;
    transform: translateY(0); } }

.module-questions .question-editor {
  display: flex;
  flex-direction: column;
  background: transparent;
  border-radius: 0;
  overflow: hidden;
  gap: 0;
  /* English comment: create right inset so native arrow doesn't look glued to border */ }
  .module-questions .question-editor .input-field {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    margin-left: 20px;
    margin-right: auto; }
    .module-questions .question-editor .input-field.question {
      margin-right: 15px; }
    .module-questions .question-editor .input-field .form-control {
      min-height: fit-content;
      width: fit-content; }
      .module-questions .question-editor .input-field .form-control.question {
        width: 100%; }
    .module-questions .question-editor .input-field label {
      font-size: 0.9rem;
      font-weight: 500;
      color: #b8b8b8; }
    .module-questions .question-editor .input-field input,
    .module-questions .question-editor .input-field select {
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 0.45rem 0.6rem;
      font-size: 0.9rem;
      width: 100%;
      background: #fff; }
      .module-questions .question-editor .input-field input:focus,
      .module-questions .question-editor .input-field select:focus {
        outline: none;
        border-color: #888; }
  .module-questions .question-editor .question-answers-zone {
    padding: 10px; }
  .module-questions .question-editor .question-topic-field {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.35rem;
    padding: 10px 12px 0; }
  .module-questions .question-editor .question-topic-label {
    font-size: 0.78rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #b8b8b8; }
  .module-questions .question-editor .question-topic-input {
    width: 100%;
    border: 1px solid #384858;
    border-radius: 6px;
    padding: 0.45rem 0.6rem;
    font-size: 0.9rem;
    background: #dfdfdf;
    color: #0c2637; }
    .module-questions .question-editor .question-topic-input.locked {
      background: #bbc0c4;
      color: #6a6f72;
      cursor: not-allowed; }
    .module-questions .question-editor .question-topic-input:focus {
      outline: none;
      border-color: #b8b8b8; }
  .module-questions .question-editor .question-eval-footer {
    padding: 10px 12px 12px;
    border-top: 1px solid rgba(56, 72, 88, 0.55);
    background: rgba(12, 38, 55, 0.35); }
  .module-questions .question-editor .question-title-input {
    resize: none;
    overflow: hidden;
    width: 100%;
    min-height: 28px;
    max-height: 160px;
    line-height: 20px;
    padding: 3px 10px;
    box-sizing: border-box;
    border-radius: 6px;
    font-size: 0.9rem; }
    .module-questions .question-editor .question-title-input.locked {
      background: #bbc0c4;
      color: #6a6f72;
      cursor: not-allowed;
      opacity: 1; }
  .module-questions .question-editor > .question-header-line {
    position: relative;
    display: grid;
    grid-template-columns: 28px 1fr auto 32px;
    column-gap: 8px;
    align-items: center;
    margin: 0;
    padding: 28px 10px 10px;
    background: linear-gradient(180deg, #384858 0%, #1c2d38 100%);
    border-bottom: 1px solid transparent;
    transition: border-bottom-color 0.22s ease; }
  .module-questions .question-editor .question-accordion-toggle {
    position: relative;
    z-index: 2;
    width: 24px;
    height: 24px;
    margin: 0;
    padding: 0;
    bottom: 2px;
    border: 1px solid #384858;
    border-radius: 6px;
    background: #2a3847;
    color: #b8b8b8;
    cursor: pointer;
    transition: transform 0.22s ease, border-color 0.22s ease, color 0.22s ease; }
    .module-questions .question-editor .question-accordion-toggle::before {
      content: "";
      display: block;
      width: 7px;
      height: 7px;
      margin: 0 auto;
      border-right: 2px solid currentColor;
      border-bottom: 2px solid currentColor;
      transform: rotate(45deg) translate(-1px, -2px);
      transition: transform 0.22s ease; }
    .module-questions .question-editor .question-accordion-toggle.is-open::before {
      transform: rotate(-135deg) translate(-1px, 1px); }
    .module-questions .question-editor .question-accordion-toggle:hover {
      border-color: #747b81;
      color: #dfdfdf; }
  .module-questions .question-editor .question-toggle-zone {
    position: absolute;
    inset: 0;
    z-index: 1; }
  .module-questions .question-editor .question-zone,
  .module-questions .question-editor .question-meta-zone,
  .module-questions .question-editor .q-close {
    position: relative;
    z-index: 2; }
  .module-questions .question-editor > .question-header-line > .question-zone {
    width: 100%;
    margin: 0;
    min-width: 0; }
  .module-questions .question-editor > .question-header-line > .question-meta-zone {
    display: flex;
    width: auto;
    max-width: 420px;
    align-self: center;
    justify-self: end;
    margin: 0;
    padding-right: 0;
    border-radius: 6px;
    box-sizing: border-box;
    gap: 10px;
    align-items: center; }
  .module-questions .question-editor .question-weight-field {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 4.5rem; }
  .module-questions .question-editor .question-weight-label {
    font-size: 0.62rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.58);
    line-height: 1; }
  .module-questions .question-editor .question-weight-input {
    width: 4.5rem;
    min-width: 4.5rem;
    text-align: center; }
  .module-questions .question-editor > .question-header-line input,
  .module-questions .question-editor > .question-header-line select {
    border-radius: 6px;
    width: 100%;
    height: 28px;
    min-height: 28px;
    box-sizing: border-box;
    padding: 3px 6px;
    font-size: 0.9rem; }
  .module-questions .question-editor > .question-header-line select {
    line-height: 22px; }

.question-sort-wrapper {
  position: relative; }

.question-drag-handle {
  position: absolute;
  top: 0;
  justify-content: center;
  margin-top: 7px;
  width: -webkit-fill-available;
  height: 15px;
  cursor: grab;
  display: flex;
  align-items: center;
  z-index: 2; }

.question-drag-handle::before {
  content: "";
  width: 15px;
  height: 15px;
  background: radial-gradient(circle at 2px 2px, #dfdfdf 1px, transparent 2px), radial-gradient(circle at 12px 2px, #dfdfdf 1px, transparent 2px), radial-gradient(circle at 2px 10px, #dfdfdf 1px, transparent 2px), radial-gradient(circle at 12px 10px, #dfdfdf 1px, transparent 2px), radial-gradient(circle at 7px 2px, #dfdfdf 1px, transparent 2px), radial-gradient(circle at 7px 10px, #dfdfdf 1px, transparent 2px);
  background-repeat: no-repeat; }

.mcq-invalid {
  border: 2px solid #9e2222;
  background: #dfdfdf; }

.mcq-editor-block {
  display: flex;
  flex-direction: column;
  gap: 0.45rem; }

/* ===== ANSWER ZONE ===== */
.mcq-answer-zone {
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 0.35rem;
  right: 7px; }

/* ===== ROW ===== */
.mcq-answer-row {
  display: grid;
  align-items: center;
  width: inherit;
  border-radius: 4px;
  padding: 0.3rem 0.4rem;
  gap: 0.4rem; }

/* ===== HANDLE ===== */
.rank-handle {
  cursor: grab;
  color: #dfdfdf;
  font-size: 1rem;
  text-align: center; }

.rank-handle:active {
  cursor: grabbing; }

/* ===== INDEX ===== */
.rank-index {
  font-size: 0.75rem;
  color: #dfdfdf;
  text-align: center; }

/* ===== LABEL ===== */
.mcq-answer-label,
.mcq-cell-label {
  height: 28px;
  min-width: 0;
  width: stretch;
  align-content: center;
  background: #dfdfdf;
  border: 1px solid #004872;
  border-radius: 6px;
  color: #0c2637;
  padding: 0px 10px; }

.mcq-answer-validity,
.mcq-cell-validity {
  line-height: 22px;
  min-height: 28px;
  box-sizing: border-box;
  padding: 3px 6px;
  font-size: 0.9rem;
  border-radius: 6px; }

/* ===== POINTS ===== */
.mcq-answer-weight,
.mcq-cell-weight {
  height: 22px;
  width: 60px;
  line-height: 25px;
  padding: 2px;
  background: #dfdfdf;
  border: 1px solid #004872;
  border-radius: 6px;
  text-align: center;
  color: #0c2637;
  font-weight: 600; }

/* ===== REMOVE ===== */
.mcq-editor-block .btn-style1 {
  margin-left: auto;
  margin-right: 30px;
  width: max-content; }

/* ===== TYPES ===== */
.single-editor .mcq-answer-row,
.multiple-editor .mcq-answer-row {
  grid-template-columns: 26px auto 110px 60px 40px;
  /* radio/checkbox | label | validity | weight | remove */ }

.single-editor .mcq-answer-row:not(:has(.mcq-answer-validity)),
.multiple-editor .mcq-answer-row:not(:has(.mcq-answer-validity)) {
  grid-template-columns: 1fr 40px;
  /* label | remove */ }

.ranking-editor .mcq-answer-row {
  grid-template-columns: 22px 26px auto 60px 40px;
  /* handle | index | label | validity |  points | remove */ }

.ranking-editor .mcq-answer-row:not(:has(.mcq-answer-weight)) {
  grid-template-columns: 22px 26px 1fr 40px;
  /* handle | index | label | remove */ }

.truefalse-editor .mcq-answer-row {
  grid-template-columns: 26px auto 110px 60px;
  /* radio | label | validity |  points */ }

.truefalse-editor .mcq-answer-row:not(:has(.mcq-answer-validity)) {
  grid-template-columns: 1fr;
  /* label only */ }

/* ============================ */
/* ===== MCQ GRID CLEAN ======= */
/* ============================ */
.grid-editor .grid-meta {
  height: 25px;
  border-radius: 6px;
  margin-bottom: 20px; }
  .grid-editor .grid-meta select {
    width: 135px;
    padding: 5px;
    border-radius: 6px; }

/* ===== Builder rows/cols ===== */
.grid-rows,
.grid-cols {
  margin-bottom: 10px;
  width: -webkit-fill-available; }

.grid-builder {
  display: flex;
  gap: 10px; }

.grid-builder-row,
.grid-builder-col {
  display: grid;
  grid-template-columns: 1fr 35px;
  border-radius: 6px;
  gap: 6px;
  margin-bottom: 10px; }

.grid-builder-row input,
.grid-builder-col input {
  border-radius: 6px;
  width: -webkit-fill-available;
  padding: 3px 6px; }

.grid-builder-row .btn-style1,
.grid-builder-col .btn-style1 {
  width: 28px;
  height: 28px;
  padding: 0;
  line-height: 26px;
  font-size: 20px;
  font-weight: 200;
  border-radius: 6px; }

/* ============================ */
/* ===== MCQ GRID TABLE ======= */
/* ============================ */
.table-base.mcq-grid {
  margin-top: 0.8rem;
  /* Header */
  /* Body */
  /* Inputs */ }
  .table-base.mcq-grid .header-rowLabel,
  .table-base.mcq-grid .header-mcq {
    background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    color: #dfdfdf;
    font-size: 0.75rem;
    text-align: center; }
  .table-base.mcq-grid .cell-mcq {
    text-align: center;
    padding: 0.3rem;
    border-left: 1px solid #2a3847; }
    .table-base.mcq-grid .cell-mcq > div {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 6px; }
  .table-base.mcq-grid input[type="radio"],
  .table-base.mcq-grid input[type="checkbox"] {
    transform: scale(1.05); }
  .table-base.mcq-grid .mcq-cell-points {
    height: 25px;
    line-height: 25px;
    background: #b8b8b8;
    padding: 2px;
    border: 1px solid #004872;
    border-radius: 3px;
    text-align: center;
    color: #0c2637;
    font-size: 0.7rem;
    font-weight: 600;
    width: 38px; }

.mcq-versions-table {
  position: relative;
  width: 100%; }
  .mcq-versions-table.container {
    display: flex;
    flex-direction: row;
    margin: 10px 0px; }
    .mcq-versions-table.container .mcq-parameters {
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin: 0px 10px 0px 0px;
      height: fit-content;
      width: 350px;
      top: 45px; }
      .mcq-versions-table.container .mcq-parameters .mcq-status-indicator {
        display: flex;
        flex-direction: row;
        align-items: center; }
        .mcq-versions-table.container .mcq-parameters .mcq-status-indicator .icon-collab,
        .mcq-versions-table.container .mcq-parameters .mcq-status-indicator .icon-versioning {
          margin: 0 10px;
          height: 25px;
          width: auto; }

.mcq-versions-table,
.checklist-versions-table {
  position: relative;
  width: 100%; }
  .mcq-versions-table.container,
  .checklist-versions-table.container {
    display: flex;
    flex-direction: row;
    width: -webkit-fill-available;
    margin: 10px auto 10px auto; }
    .mcq-versions-table.container .mcq-parameters,
    .mcq-versions-table.container .checklist-parameters,
    .checklist-versions-table.container .mcq-parameters,
    .checklist-versions-table.container .checklist-parameters {
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin: 0px 10px 0px 0px;
      height: fit-content;
      width: 350px;
      top: 45px; }
      .mcq-versions-table.container .mcq-parameters .mcq-status-indicator,
      .mcq-versions-table.container .mcq-parameters .checklist-status-indicator,
      .mcq-versions-table.container .checklist-parameters .mcq-status-indicator,
      .mcq-versions-table.container .checklist-parameters .checklist-status-indicator,
      .checklist-versions-table.container .mcq-parameters .mcq-status-indicator,
      .checklist-versions-table.container .mcq-parameters .checklist-status-indicator,
      .checklist-versions-table.container .checklist-parameters .mcq-status-indicator,
      .checklist-versions-table.container .checklist-parameters .checklist-status-indicator {
        display: flex;
        flex-direction: row;
        align-items: center; }
        .mcq-versions-table.container .mcq-parameters .mcq-status-indicator .icon-collab,
        .mcq-versions-table.container .mcq-parameters .mcq-status-indicator .icon-versioning,
        .mcq-versions-table.container .mcq-parameters .checklist-status-indicator .icon-collab,
        .mcq-versions-table.container .mcq-parameters .checklist-status-indicator .icon-versioning,
        .mcq-versions-table.container .checklist-parameters .mcq-status-indicator .icon-collab,
        .mcq-versions-table.container .checklist-parameters .mcq-status-indicator .icon-versioning,
        .mcq-versions-table.container .checklist-parameters .checklist-status-indicator .icon-collab,
        .mcq-versions-table.container .checklist-parameters .checklist-status-indicator .icon-versioning,
        .checklist-versions-table.container .mcq-parameters .mcq-status-indicator .icon-collab,
        .checklist-versions-table.container .mcq-parameters .mcq-status-indicator .icon-versioning,
        .checklist-versions-table.container .mcq-parameters .checklist-status-indicator .icon-collab,
        .checklist-versions-table.container .mcq-parameters .checklist-status-indicator .icon-versioning,
        .checklist-versions-table.container .checklist-parameters .mcq-status-indicator .icon-collab,
        .checklist-versions-table.container .checklist-parameters .mcq-status-indicator .icon-versioning,
        .checklist-versions-table.container .checklist-parameters .checklist-status-indicator .icon-collab,
        .checklist-versions-table.container .checklist-parameters .checklist-status-indicator .icon-versioning {
          margin: 0 10px;
          height: 25px;
          width: auto; }

.mcq-parameters {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin: 5px 15px; }

.collaboration-status {
  margin: 0px 10px 0px 15px;
  color: #dfdfdf; }

.status-indicators {
  display: flex;
  flex-direction: row;
  align-items: center; }

.mcq-top-row {
  display: flex;
  gap: 1rem;
  align-items: flex-start; }

.mcq-top-row > :first-child {
  flex: 1 1 0;
  min-width: 0;
  align-self: flex-start; }

.mcq-top-row .lexical-versioning-bar {
  align-self: flex-start;
  height: auto; }

.mcq-top-row > :last-child {
  flex: 0 0 auto;
  align-self: flex-start; }

.checklist-top-row {
  display: flex;
  gap: 1rem;
  align-items: flex-start; }

.checklist-top-row > :first-child {
  flex: 1 1 0;
  min-width: 0;
  align-self: flex-start; }

.checklist-top-row .lexical-versioning-bar {
  align-self: flex-start;
  height: auto; }

.checklist-top-row > :last-child {
  flex: 0 0 auto;
  align-self: flex-start; }

.collab-online-users {
  position: relative;
  top: 15px;
  flex-shrink: 0; }

.collab-online-users__trigger {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 4px 10px;
  margin: 0;
  border: 1px solid #384858;
  border-radius: 6px;
  background: #2a3847;
  color: #dfdfdf;
  cursor: pointer;
  text-align: left;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1.2;
  white-space: nowrap;
  transition: background 0.15s ease, border-color 0.15s ease; }
  .collab-online-users__trigger:hover {
    border-color: #747b81;
    background: #384858; }

.collab-online-users__trigger--open {
  border-color: #5aa05c;
  box-shadow: inset 0 0 0 1px #5aa05c; }
  .collab-online-users__trigger--open .collab-online-users__label,
  .collab-online-users__trigger--open .collab-online-users__icon {
    color: #5aa05c; }

.collab-online-users__icon {
  width: 17px;
  height: 17px;
  flex-shrink: 0;
  color: #b8b8b8; }

.collab-online-users__label {
  min-width: 0; }

.collab-online-users__chevron {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: #b8b8b8; }

.collab-online-users__menu {
  position: absolute;
  right: 0;
  top: calc(100% + 4px);
  z-index: 100000;
  min-width: 220px;
  max-width: 320px;
  max-height: 240px;
  overflow-y: auto;
  padding: 6px 0;
  background: #1c2d38;
  border: 1px solid #384858;
  border-radius: 6px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35); }
  .collab-online-users__menu::-webkit-scrollbar {
    width: 6px; }
  .collab-online-users__menu::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .collab-online-users__menu::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .collab-online-users__menu::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }

.collab-online-users__empty {
  margin: 0;
  padding: 10px 14px;
  color: #b8b8b8;
  font-size: 13px;
  font-style: italic; }

.collab-online-users__list {
  list-style: none;
  margin: 0;
  padding: 0; }

.collab-online-users__item {
  padding: 8px 14px;
  color: #dfdfdf;
  font-size: 13px; }
  .collab-online-users__item:hover {
    background: #2a3847; }

.collab-online-users__name {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #b8b8b8; }

.input.admin.container.course-table.container {
  flex-direction: column; }

/* ---------- COURSE MODULES MODAL ---------- */
.course-modules-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  background: rgba(8, 14, 22, 0.72);
  backdrop-filter: blur(3px); }

.course-modules-modal {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  max-height: min(82vh, 900px);
  border-radius: 14px;
  border: 1px solid rgba(58, 120, 180, 0.45);
  background: linear-gradient(160deg, rgba(0, 48, 77, 0.95), rgba(21, 28, 36, 0.88)), rgba(23, 39, 56, 0.96);
  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.42);
  overflow: hidden; }

.course-modules-modal__header {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.85rem;
  padding: 0.95rem 1rem 0.95rem 1.15rem;
  border-bottom: 1px solid rgba(58, 120, 180, 0.35);
  background: linear-gradient(135deg, rgba(0, 48, 77, 0.92), rgba(21, 28, 36, 0.72)), rgba(0, 48, 77, 0.8); }

.course-modules-modal__header-main {
  min-width: 0;
  flex: 1 1 auto; }

.course-modules-modal__eyebrow {
  margin: 0 0 0.25rem;
  font-size: 0.68rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.58); }

.course-modules-modal__title {
  margin: 0;
  font-size: clamp(1rem, 2vw, 1.25rem);
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #dfdfdf;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.course-modules-modal__header-badges {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.45rem;
  flex-shrink: 0; }

.course-modules-modal__badge {
  display: inline-flex;
  align-items: center;
  min-height: 1.45rem;
  padding: 0.15rem 0.55rem;
  border-radius: 999px;
  border: 1px solid rgba(58, 120, 180, 0.45);
  background: rgba(21, 28, 36, 0.55);
  color: #b8b8b8;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap; }
  .course-modules-modal__badge--readonly {
    border-color: rgba(155, 96, 42, 0.65);
    color: #9b602a;
    background: rgba(110, 68, 28, 0.18); }

.course-modules-modal__close {
  position: relative;
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(58, 120, 180, 0.4);
  border-radius: 8px;
  background: rgba(21, 28, 36, 0.55);
  color: #b8b8b8;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background-color 0.15s ease; }
  .course-modules-modal__close::before, .course-modules-modal__close::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0.85rem;
    height: 2px;
    background: currentColor;
    transform-origin: center; }
  .course-modules-modal__close::before {
    transform: translate(-50%, -50%) rotate(45deg); }
  .course-modules-modal__close::after {
    transform: translate(-50%, -50%) rotate(-45deg); }
  .course-modules-modal__close:hover, .course-modules-modal__close:focus-visible {
    border-color: rgba(170, 158, 116, 0.55);
    color: #aa9e74;
    background: rgba(12, 38, 55, 0.75); }

.course-modules-modal__badge--new {
  border-color: rgba(170, 158, 116, 0.55);
  color: #aa9e74;
  background: rgba(21, 28, 36, 0.65); }

.course-modules-modal__metadata {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.85rem 1rem;
  padding: 0.85rem 1rem;
  border-bottom: 1px solid rgba(58, 120, 180, 0.28);
  background: rgba(0, 48, 77, 0.38); }

.course-modules-modal__metadata-main {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  min-width: 0;
  flex: 1 1 28rem; }

.course-modules-modal__metadata-title-row {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  min-width: 0; }

.course-modules-modal__title-input {
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0.2rem 0.45rem;
  border: 1px solid rgba(58, 120, 180, 0.45);
  border-radius: 8px;
  background: rgba(21, 28, 36, 0.55);
  color: #dfdfdf;
  font-size: clamp(1rem, 2vw, 1.25rem);
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase; }
  .course-modules-modal__title-input::placeholder {
    color: rgba(223, 223, 223, 0.42);
    text-transform: none;
    letter-spacing: normal;
    font-weight: 500; }
  .course-modules-modal__title-input:focus-visible {
    outline: none;
    border-color: rgba(170, 158, 116, 0.55);
    box-shadow: 0 0 0 2px rgba(170, 158, 116, 0.15); }

.course-modules-modal__metadata-edit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 1.55rem;
  height: 1.55rem;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(58, 120, 180, 0.4);
  border-radius: 8px;
  background: rgba(21, 28, 36, 0.55);
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease; }
  .course-modules-modal__metadata-edit img {
    width: 0.55rem;
    height: 0.55rem;
    filter: brightness(0) saturate(100%) invert(84%) sepia(7%) saturate(468%) hue-rotate(169deg) brightness(95%) contrast(88%); }
  .course-modules-modal__metadata-edit:hover, .course-modules-modal__metadata-edit:focus-visible {
    border-color: rgba(170, 158, 116, 0.55);
    background: rgba(12, 38, 55, 0.75); }

.course-modules-modal__metadata-fields {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(10rem, 0.85fr) minmax(10rem, 0.7fr);
  gap: 0.65rem 0.85rem; }
  @media (max-width: 900px) {
    .course-modules-modal__metadata-fields {
      grid-template-columns: 1fr 1fr; } }
  @media (max-width: 720px) {
    .course-modules-modal__metadata-fields {
      grid-template-columns: 1fr; } }

.course-modules-modal__metadata-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  min-width: 0; }

.course-modules-modal__metadata-label {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.58); }

.course-modules-modal__metadata-value {
  min-height: 1.35rem;
  font-size: 0.82rem;
  color: #b8b8b8;
  overflow-wrap: anywhere; }

.course-modules-modal__metadata-textarea,
.course-modules-modal__metadata-select,
.course-modules-modal__metadata-number {
  width: stretch;
  min-width: 0;
  margin: 0;
  padding: 0.45rem 0.55rem;
  border: 1px solid rgba(58, 120, 180, 0.35);
  border-radius: 8px;
  background: rgba(21, 28, 36, 0.5);
  color: #b8b8b8;
  font-size: 0.82rem; }
  .course-modules-modal__metadata-textarea:focus-visible,
  .course-modules-modal__metadata-select:focus-visible,
  .course-modules-modal__metadata-number:focus-visible {
    outline: none;
    border-color: rgba(170, 158, 116, 0.55);
    box-shadow: 0 0 0 2px rgba(170, 158, 116, 0.15); }

.course-modules-modal__metadata-number {
  max-width: 6rem; }

.course-modules-modal__metadata-textarea {
  resize: vertical;
  min-height: 2.6rem; }

.course-modules-modal__metadata-hint {
  font-size: 0.68rem;
  color: rgba(223, 223, 223, 0.5); }

.course-modules-modal__metadata-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.45rem;
  margin-left: auto;
  flex: 0 0 auto; }

.course-modules-modal__metadata-error {
  width: 100%;
  margin: 0;
  font-size: 0.78rem;
  color: #9b602a; }

.course-modules-modal__metadata-delete {
  color: #9b602a; }

.course-modules-modal__metadata-stats {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  padding-top: 0.15rem; }

.course-modules-modal__metadata-stat-group {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 0; }
  .course-modules-modal__metadata-stat-group--warning {
    padding: 0.45rem 0.55rem;
    border-radius: 8px;
    border: 1px solid rgba(199, 132, 69, 0.45);
    background: rgba(199, 132, 69, 0.08); }

.course-modules-modal__metadata-stat-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem; }

.course-modules-modal__metadata-stat-toggle {
  flex-shrink: 0;
  margin: 0;
  padding: 0.2rem 0.55rem;
  border: 1px solid rgba(58, 120, 180, 0.45);
  border-radius: 6px;
  background: rgba(21, 28, 36, 0.55);
  color: #b8b8b8;
  font-size: 0.64rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background-color 0.15s ease; }
  .course-modules-modal__metadata-stat-toggle:hover, .course-modules-modal__metadata-stat-toggle:focus-visible {
    border-color: rgba(90, 195, 255, 0.55);
    color: #dfdfdf;
    background: rgba(0, 48, 77, 0.75); }

.course-modules-modal__metadata-topic-warnings {
  margin: 0;
  padding-left: 1rem;
  color: #c78445;
  font-size: 0.76rem;
  line-height: 1.35; }

.course-modules-modal__metadata-stat-heading {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.58); }

.course-modules-modal__metadata-stat-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem; }

.course-modules-modal__metadata-stat-chip {
  display: inline-flex;
  align-items: center;
  padding: 0.12rem 0.45rem;
  border-radius: 999px;
  border: 1px solid rgba(58, 120, 180, 0.45);
  background: rgba(21, 28, 36, 0.45);
  color: #b8b8b8;
  font-size: 0.72rem;
  font-weight: 600;
  white-space: nowrap; }
  .course-modules-modal__metadata-stat-chip--total {
    border-color: rgba(170, 158, 116, 0.45);
    color: #aa9e74; }
  .course-modules-modal__metadata-stat-chip--topic {
    border-color: rgba(90, 195, 255, 0.4);
    color: #5ac3ff; }

.course-modules-modal__composition {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1 1 auto; }
  .course-modules-modal__composition--locked .course-modules-modal__reading-order,
  .course-modules-modal__composition--locked .course-modules-modal__body {
    pointer-events: none;
    user-select: none;
    opacity: 0.42; }

.course-modules-modal__composition-lock {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(0, 48, 77, 0.28);
  pointer-events: none; }

.course-modules-modal__composition-lock-text {
  max-width: 26rem;
  margin: 0;
  padding: 0.75rem 1rem;
  border-radius: 10px;
  border: 1px solid rgba(58, 120, 180, 0.35);
  background: rgba(21, 28, 36, 0.88);
  color: #b8b8b8;
  font-size: 0.84rem;
  text-align: center; }

.course-modules-modal__reading-order {
  border-bottom: 1px solid rgba(58, 120, 180, 0.28);
  background: rgba(0, 48, 77, 0.42); }

.course-modules-modal__reading-order-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.65rem 1rem; }

.course-modules-modal__reading-order-summary {
  min-width: 0; }

.course-modules-modal__reading-order-eyebrow {
  margin: 0;
  font-size: 0.68rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.58); }

.course-modules-modal__reading-order-count {
  margin: 0.15rem 0 0;
  color: #dfdfdf;
  font-size: 0.82rem;
  font-weight: 600; }

.course-modules-modal__reading-order-toggle {
  flex-shrink: 0;
  margin: 0;
  padding: 0.35rem 0.7rem;
  border: 1px solid rgba(58, 120, 180, 0.45);
  border-radius: 6px;
  background: rgba(21, 28, 36, 0.55);
  color: #b8b8b8;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background-color 0.15s ease; }
  .course-modules-modal__reading-order-toggle:hover, .course-modules-modal__reading-order-toggle:focus-visible {
    border-color: rgba(90, 195, 255, 0.55);
    color: #dfdfdf;
    background: rgba(0, 48, 77, 0.75); }

.course-modules-modal__reading-order-body {
  padding: 0 1rem 0.85rem; }

.course-reading-order__empty {
  margin: 0;
  padding: 0.45rem 0.55rem;
  color: rgba(223, 223, 223, 0.7);
  font-size: 0.82rem; }

.course-reading-order-list {
  display: flex;
  flex-direction: column;
  gap: 0.35rem; }

.course-reading-order-row {
  display: grid;
  grid-template-columns: 1.6rem minmax(0, 1fr) auto;
  align-items: center;
  gap: 0.55rem;
  padding: 0.45rem 0.55rem;
  border-radius: 6px;
  border: 1px solid rgba(58, 120, 180, 0.22);
  background: rgba(21, 28, 36, 0.45);
  color: #dfdfdf; }
  .course-reading-order-row--dragging {
    border-color: rgba(90, 195, 255, 0.55);
    background: rgba(90, 195, 255, 0.12); }
  .course-reading-order-row__handle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.6rem;
    height: 1.6rem;
    margin: 0;
    padding: 0;
    border: 1px solid rgba(56, 72, 88, 0.55);
    border-radius: 4px;
    background: rgba(21, 28, 36, 0.55);
    color: #b8b8b8;
    font-size: 0.95rem;
    line-height: 1;
    cursor: grab; }
    .course-reading-order-row__handle:disabled {
      opacity: 0.45;
      cursor: not-allowed; }
    .course-reading-order-row__handle:active:not(:disabled) {
      cursor: grabbing; }
  .course-reading-order-row__label {
    min-width: 0;
    text-align: left;
    font-size: 0.84rem;
    font-weight: 500; }
  .course-reading-order-row__version {
    flex-shrink: 0;
    color: rgba(223, 223, 223, 0.68);
    font-size: 0.68rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    white-space: nowrap; }

.course-modules-modal__body {
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(0, 0.95fr);
  gap: 0.85rem;
  min-height: 0;
  flex: 1 1 auto;
  padding: 0.9rem;
  overflow: hidden; }
  @media (max-width: 860px) {
    .course-modules-modal__body {
      grid-template-columns: 1fr;
      overflow-y: auto; }
      .course-modules-modal__body::-webkit-scrollbar {
        width: 6px; }
      .course-modules-modal__body::-webkit-scrollbar-track {
        background: #2e3842;
        border-radius: 4px;
        padding-right: 1px; }
      .course-modules-modal__body::-webkit-scrollbar-thumb {
        background-color: #491212;
        border-radius: 4px; }
        .course-modules-modal__body::-webkit-scrollbar-thumb:hover {
          background-color: #200808; } }

.course-modules-modal__panel {
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
  padding: 0.75rem;
  border-radius: 12px;
  border: 1px solid rgba(58, 120, 180, 0.28);
  background: rgba(21, 28, 36, 0.38); }

.course-modules-modal__panel-title {
  flex-shrink: 0;
  margin: 0 0 0.65rem;
  font-size: 0.74rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.82); }

.course-modules-modal__table-wrap {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  border-radius: 8px;
  border: 1px solid rgba(58, 120, 180, 0.22); }

.course-modules-modal__table {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  margin: 0;
  box-shadow: none; }
  .course-modules-modal__table table {
    width: 100%;
    table-layout: fixed; }
  .course-modules-modal__table .course-modules-modal__table-head {
    flex-shrink: 0; }
  .course-modules-modal__table .course-modules-modal__table-body {
    flex: 1 1 auto;
    min-height: 0;
    overflow: auto;
    border-top: 1px solid rgba(58, 120, 180, 0.22); }
    .course-modules-modal__table .course-modules-modal__table-body::-webkit-scrollbar {
      width: 6px; }
    .course-modules-modal__table .course-modules-modal__table-body::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .course-modules-modal__table .course-modules-modal__table-body::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .course-modules-modal__table .course-modules-modal__table-body::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
  .course-modules-modal__table thead th,
  .course-modules-modal__table tbody td {
    padding: 0.45rem 0.75rem; }
  .course-modules-modal__table thead th:first-child,
  .course-modules-modal__table tbody td:first-child {
    padding-left: 0.95rem; }
  .course-modules-modal__table thead th:last-child,
  .course-modules-modal__table tbody td:last-child {
    text-align: center;
    width: 3.5rem;
    padding-right: 0.85rem; }
  .course-modules-modal__table thead th:nth-child(3),
  .course-modules-modal__table tbody td:nth-child(3) {
    text-align: center;
    width: 4.5rem; }
  .course-modules-modal__table col.col-moduleTopics {
    width: 4.5rem; }
  .course-modules-modal__table tbody tr.module-row {
    cursor: pointer;
    transition: background-color 0.15s ease, box-shadow 0.15s ease; }
    .course-modules-modal__table tbody tr.module-row.selected {
      background: rgba(58, 120, 180, 0.22);
      box-shadow: inset 0 0 0 1px rgba(90, 195, 255, 0.45); }
    .course-modules-modal__table tbody tr.module-row.is-assigned td:first-child {
      color: #dfdfdf; }

.course-modules-modal__empty-cell {
  display: block;
  padding: 0.75rem 0;
  text-align: center;
  color: #b8b8b8;
  font-style: italic; }

.course-modules-modal__details {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden; }
  .course-modules-modal__details--empty {
    flex: 1 1 auto;
    overflow: auto;
    align-items: center;
    justify-content: center;
    min-height: 180px;
    padding: 1rem;
    border: 1px dashed rgba(58, 120, 180, 0.35);
    border-radius: 8px;
    background: rgba(0, 48, 77, 0.28); }
    .course-modules-modal__details--empty p {
      margin: 0;
      text-align: center;
      color: #b8b8b8;
      font-size: 0.88rem;
      font-style: italic; }

.course-modules-modal__details-head,
.course-modules-modal__topic-quota-summary {
  flex-shrink: 0; }

.course-modules-modal__details-head {
  padding-bottom: 0.55rem;
  border-bottom: 1px solid rgba(58, 120, 180, 0.22); }

.course-modules-modal__details-title {
  margin: 0;
  font-size: 0.92rem;
  font-weight: 600;
  color: #dfdfdf; }

.course-modules-modal__topic-quota-summary {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 0.55rem 0.65rem;
  border-radius: 8px;
  background: rgba(0, 48, 77, 0.34);
  border: 1px solid rgba(58, 120, 180, 0.24); }
  .course-modules-modal__topic-quota-summary--invalid {
    border-color: rgba(199, 132, 69, 0.55);
    background: rgba(199, 132, 69, 0.08); }

.course-modules-modal__topic-quota-summary-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin: 0;
  font-size: 0.8rem; }

.course-modules-modal__topic-quota-label {
  color: rgba(223, 223, 223, 0.72); }

.course-modules-modal__topic-quota-value {
  font-weight: 600;
  color: #dfdfdf; }

.course-modules-modal__topic-quota-hint {
  margin: 0.15rem 0 0;
  font-size: 0.74rem;
  line-height: 1.35;
  color: #c78445; }

.course-modules-modal__quota-grid {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto; }
  .course-modules-modal__quota-grid::-webkit-scrollbar {
    width: 6px; }
  .course-modules-modal__quota-grid::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .course-modules-modal__quota-grid::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .course-modules-modal__quota-grid::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }

.course-modules-modal__quota-row {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 0.9fr) 4.5rem;
  align-items: center;
  gap: 0.55rem;
  padding: 0.45rem 0.55rem;
  border-radius: 8px;
  background: rgba(0, 48, 77, 0.42);
  border: 1px solid rgba(58, 120, 180, 0.2); }

.course-modules-modal__quota-label {
  font-size: 0.8rem;
  color: #dfdfdf; }

.course-modules-modal__quota-available {
  font-size: 0.74rem;
  color: rgba(223, 223, 223, 0.55);
  text-align: right; }

.course-modules-modal__quota-input {
  width: stretch;
  min-width: 0;
  padding: 0.3rem 0.45rem;
  border: 1px solid rgba(58, 120, 180, 0.45);
  border-radius: 6px;
  font-size: 0.82rem;
  color: #dfdfdf;
  background: rgba(0, 48, 77, 0.72);
  text-align: center; }
  .course-modules-modal__quota-input:disabled {
    opacity: 0.5;
    cursor: not-allowed; }

.course-modules-modal__meta-list {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  margin: 0;
  flex-shrink: 0; }

.course-modules-modal__meta-item {
  display: grid;
  grid-template-columns: 6.5rem minmax(0, 1fr);
  gap: 0.65rem;
  padding: 0.5rem 0.55rem;
  border-radius: 8px;
  background: rgba(0, 48, 77, 0.3);
  border: 1px solid rgba(58, 120, 180, 0.16); }
  .course-modules-modal__meta-item dt {
    margin: 0;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.62); }
  .course-modules-modal__meta-item dd {
    margin: 0;
    font-size: 0.82rem;
    color: #b8b8b8;
    overflow-wrap: anywhere; }

/* ============================= */
/*  GLOBAL DRAFT VISUALIZATION   */
/* ============================= */
.draft,
.draft-row,
.online.draft-row {
  position: relative; }

/* -----------------------------
   Draft input highlight
------------------------------ */
input.draft {
  border: 2px solid #c78445 !important;
  background: rgba(255, 152, 0, 0.05);
  color: #c78445;
  font-weight: 600; }

/* -----------------------------
   Draft cell highlight
------------------------------ */
td:has(input.draft) {
  background: rgba(255, 152, 0, 0.07); }

/* -----------------------------
   Draft row highlight
------------------------------ */
.cell-simple input,
.cell-standard input,
.cell-complex input,
.cell-expert input {
  width: 35px; }

tr.draft-row {
  background: rgba(255, 152, 0, 0.12); }
  tr.draft-row td {
    border-top: 1px solid #c78445;
    border-bottom: 1px solid #c78445; }
  tr.draft-row td:first-child {
    border-left: 3px solid #c78445; }
  tr.draft-row td:last-child {
    border-right: 3px solid #c78445; }

/* -----------------------------
   Online/offline emphasis
------------------------------ */
tr.online {
  box-shadow: inset 0 0 0 1px #5aa05c; }

tr.offline {
  box-shadow: inset 0 0 0 1px #9b602a; }

/* -----------------------------
   Hover reinforcement
------------------------------ */
tr.module-row:hover {
  background: rgba(58, 120, 180, 0.14); }

/* ---------- TEST COURSE MODAL ---------- */
.exam-meta {
  margin-bottom: 1rem;
  padding: 0.6rem 0.9rem;
  background: #0f2c3e;
  border: 1px solid #004872;
  border-radius: 6px;
  color: #ffffff; }
  .exam-meta--empty {
    margin-top: 0.5rem;
    font-style: italic; }

.exam-meta__count {
  margin-left: 0.75rem;
  color: rgba(223, 223, 223, 0.7);
  font-size: 0.85rem; }

.exam-meta__live-badge {
  margin-left: 0.65rem;
  padding: 0.1rem 0.45rem;
  border-radius: 999px;
  border: 1px solid #5aa05c;
  color: #75cf78;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase; }
  .exam-meta__live-badge--member {
    border-color: rgba(199, 132, 69, 0.55);
    color: rgba(199, 132, 69, 0.95); }

.exam-meta__timer {
  font-variant-numeric: tabular-nums;
  color: rgba(199, 132, 69, 0.95); }

.course-exam-player--member .course-exam-player__layout {
  grid-template-columns: minmax(0, 1fr); }

.course-exam-player__layout {
  display: grid;
  grid-template-columns: minmax(11rem, 13.5rem) minmax(0, 1fr);
  gap: 0.85rem;
  align-items: start; }

.course-exam-player__content {
  min-width: 0; }

.course-exam-sidebar {
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  padding: 0.65rem;
  border-radius: 8px;
  border: 1px solid rgba(58, 120, 180, 0.35);
  background: rgba(0, 48, 77, 0.55); }
  .course-exam-sidebar__title {
    margin: 0;
    padding: 0 0.2rem;
    font-size: 0.68rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.62); }
  .course-exam-sidebar__list {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    margin: 0;
    padding: 0;
    list-style: none; }
  .course-exam-sidebar__item {
    width: 100%;
    margin: 0;
    padding: 0.45rem 0.55rem;
    border: 1px solid transparent;
    border-radius: 6px;
    background: transparent;
    color: #b8b8b8;
    font-size: 0.82rem;
    font-weight: 500;
    text-align: left;
    cursor: pointer;
    transition: border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease; }
    .course-exam-sidebar__item:hover, .course-exam-sidebar__item:focus-visible {
      border-color: rgba(58, 120, 180, 0.45);
      background: rgba(21, 28, 36, 0.55);
      color: #dfdfdf; }
    .course-exam-sidebar__item--active {
      border-color: rgba(90, 195, 255, 0.55);
      background: rgba(90, 195, 255, 0.14);
      color: #dfdfdf; }
    .course-exam-sidebar__item--qcm {
      margin-top: 0.2rem;
      border-top: 1px solid rgba(58, 120, 180, 0.22);
      border-radius: 0 0 6px 6px;
      padding-top: 0.6rem;
      font-weight: 700;
      letter-spacing: 0.04em;
      text-transform: uppercase; }

.course-exam-document-panel {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  min-height: 0; }
  .course-exam-document-panel__head {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.55rem 0.75rem;
    border-radius: 8px;
    border: 1px solid #163a52;
    background: #081b26; }
  .course-exam-document-panel__title {
    margin: 0;
    color: #5ac3ff;
    font-size: 0.95rem;
    font-weight: 600; }
  .course-exam-document-panel__version {
    flex-shrink: 0;
    color: rgba(223, 223, 223, 0.7);
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase; }
  .course-exam-document-panel__viewer {
    min-height: 0; }

.course-exam-document-viewer {
  max-height: min(58vh, 680px);
  overflow-y: auto;
  padding: 0.85rem 1rem;
  border-radius: 8px;
  border: 1px solid #163a52;
  background: rgba(0, 48, 77, 0.45); }
  .course-exam-document-viewer::-webkit-scrollbar {
    width: 6px; }
  .course-exam-document-viewer::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .course-exam-document-viewer::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .course-exam-document-viewer::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }

/* ---------- MODULE ---------- */
.exam-module {
  margin-bottom: 1.6rem;
  padding: 1rem;
  background: #081b26;
  border: 1px solid #163a52;
  border-radius: 8px; }
  .exam-module h4 {
    margin: 0 0 0.8rem 0;
    padding-bottom: 0.4rem;
    border-bottom: 1px solid #1d4f73;
    color: #5ac3ff;
    font-weight: 600; }

/* ---------- QUESTION ---------- */
.exam-question {
  margin-bottom: 1.2rem;
  padding: 0.8rem;
  background: #0b2230;
  border: 1px solid #1b4a6b;
  border-radius: 6px; }
  .exam-question:last-child {
    margin-bottom: 0; }
  .exam-question--playable .exam-title {
    margin-bottom: 0.75rem; }
  .exam-question__head {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.4rem;
    margin-bottom: 0.45rem; }
  .exam-question__index {
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #5ac3ff; }
  .exam-question__badge {
    padding: 0.1rem 0.45rem;
    border-radius: 999px;
    border: 1px solid #9b602a;
    color: #9b602a;
    font-size: 0.65rem;
    font-weight: 700;
    text-transform: uppercase; }
    .exam-question__badge--muted {
      border-color: rgba(184, 184, 184, 0.45);
      color: #b8b8b8; }
    .exam-question__badge--type {
      border-color: rgba(90, 195, 255, 0.45);
      color: #5ac3ff; }
    .exam-question__badge--topic {
      border-color: rgba(117, 207, 120, 0.45);
      color: #75cf78;
      text-transform: none; }
  .exam-question .exam-title {
    margin-bottom: 0.6rem;
    font-weight: 500;
    color: #ffffff;
    text-align: left; }

.exam-truefalse-list {
  display: flex;
  flex-direction: column;
  gap: 0.35rem; }

.exam-truefalse-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.45rem 0.65rem;
  border-radius: 4px;
  color: #dcefff;
  background: rgba(255, 255, 255, 0.03); }
  .exam-truefalse-row:nth-child(even) {
    background: rgba(255, 255, 255, 0.06); }
  .exam-truefalse-row__label {
    flex: 1 1 auto;
    min-width: 0;
    text-align: left; }
  .exam-truefalse-row__radio {
    flex: 0 0 auto;
    margin-left: auto;
    cursor: pointer; }

/* ---------- OPTIONS ---------- */
.exam-option {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.35rem 0.6rem;
  border-radius: 4px;
  color: #dcefff;
  cursor: default; }
  .exam-option input {
    pointer-events: none; }
  .exam-option:nth-child(odd) {
    background: rgba(255, 255, 255, 0.03); }
  .exam-option:hover {
    background: rgba(255, 255, 255, 0.06); }
  .exam-option--playable {
    cursor: pointer; }
    .exam-option--playable input {
      pointer-events: auto;
      cursor: pointer; }
    .exam-option--playable:hover {
      background: rgba(90, 195, 255, 0.12); }

.exam-ranking-list {
  display: flex;
  flex-direction: column;
  gap: 0.4rem; }

.exam-ranking-row {
  display: grid;
  grid-template-columns: 1.6rem 2rem 1fr;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.55rem;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(90, 195, 255, 0.18); }
  .exam-ranking-row--sortable {
    touch-action: none; }
  .exam-ranking-row__handle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.6rem;
    height: 1.6rem;
    margin: 0;
    padding: 0;
    border: 1px solid rgba(56, 72, 88, 0.55);
    border-radius: 4px;
    background: rgba(21, 28, 36, 0.55);
    color: #b8b8b8;
    font-size: 0.95rem;
    line-height: 1;
    cursor: grab; }
    .exam-ranking-row__handle:active {
      cursor: grabbing; }
  .exam-ranking-row__index {
    font-weight: 700;
    color: #5ac3ff;
    text-align: center; }
  .exam-ranking-row__label {
    color: #dfdfdf;
    text-align: left; }

.exam-grid-list {
  display: flex;
  flex-direction: column;
  gap: 0.35rem; }
  .exam-grid-list__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 0 0.65rem 0.15rem; }
  .exam-grid-list__head-spacer {
    flex: 1 1 auto;
    min-width: 0; }
  .exam-grid-list__head-cols {
    display: flex;
    flex: 0 0 auto;
    gap: 1.75rem;
    margin-left: auto; }
  .exam-grid-list__col-label {
    min-width: 2.25rem;
    text-align: center;
    font-size: 0.72rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.75); }

.exam-grid-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.45rem 0.65rem;
  border-radius: 4px;
  color: #dcefff;
  background: rgba(255, 255, 255, 0.03); }
  .exam-grid-row--alt {
    background: rgba(255, 255, 255, 0.06); }
  .exam-grid-row__label {
    flex: 1 1 auto;
    min-width: 0;
    text-align: left; }
  .exam-grid-row__choices {
    display: flex;
    flex: 0 0 auto;
    gap: 1.75rem;
    margin-left: auto; }
  .exam-grid-row__choice {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 2.25rem;
    cursor: pointer; }
  .exam-grid-row__input {
    flex: 0 0 auto;
    margin: 0;
    cursor: pointer; }

.course-exam-player__footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
  padding-top: 0.85rem;
  border-top: 1px solid rgba(58, 120, 180, 0.28); }

.course-exam-results {
  display: flex;
  flex-direction: column;
  gap: 1rem; }

.course-exam-results__hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
  padding: 1.25rem;
  border-radius: 10px;
  border: 1px solid rgba(90, 160, 92, 0.45);
  background: rgba(0, 48, 77, 0.55);
  text-align: center; }

.course-exam-results__eyebrow {
  margin: 0;
  font-size: 0.72rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.65); }

.course-exam-results__score {
  margin: 0;
  font-size: 2rem;
  color: #dfdfdf; }

.course-exam-results__percent {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: #75cf78; }

.course-exam-results__persist {
  margin: 0.35rem 0 0;
  font-size: 0.82rem;
  color: rgba(223, 223, 223, 0.75); }
  .course-exam-results__persist--ok {
    color: #75cf78; }
  .course-exam-results__persist--error {
    color: #9b602a; }

.course-exam-results__modules {
  display: flex;
  flex-direction: column;
  gap: 0.4rem; }

.course-exam-results__module-row {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.5rem 0.65rem;
  border-radius: 6px;
  background: rgba(0, 48, 77, 0.4);
  border: 1px solid rgba(58, 120, 180, 0.2);
  color: #b8b8b8;
  font-size: 0.88rem; }

/* ---------- COURSE EXAM PREVIEW MODAL ---------- */
.course-exam-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  background: rgba(8, 14, 22, 0.72);
  backdrop-filter: blur(3px); }

.course-exam-modal {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  max-height: min(88vh, 900px);
  border-radius: 14px;
  border: 1px solid rgba(58, 120, 180, 0.45);
  background: linear-gradient(160deg, rgba(0, 48, 77, 0.95), rgba(21, 28, 36, 0.88)), rgba(23, 39, 56, 0.96);
  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.42);
  overflow: hidden; }

.course-exam-modal__header {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.85rem;
  padding: 0.95rem 1rem 0.95rem 1.15rem;
  border-bottom: 1px solid rgba(58, 120, 180, 0.35);
  background: linear-gradient(135deg, rgba(0, 48, 77, 0.92), rgba(21, 28, 36, 0.72)), rgba(0, 48, 77, 0.8); }

.course-exam-modal__header-main {
  min-width: 0;
  flex: 1 1 auto; }

.course-exam-modal__eyebrow {
  margin: 0 0 0.25rem;
  font-size: 0.68rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.58); }

.course-exam-modal__title {
  margin: 0;
  font-size: clamp(1rem, 2vw, 1.25rem);
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #dfdfdf;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.course-exam-modal__header-badges {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.45rem;
  flex-shrink: 0; }

.course-exam-modal__badge {
  display: inline-flex;
  align-items: center;
  min-height: 1.45rem;
  padding: 0.15rem 0.55rem;
  border-radius: 999px;
  border: 1px solid rgba(58, 120, 180, 0.45);
  background: rgba(21, 28, 36, 0.55);
  color: #b8b8b8;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap; }
  .course-exam-modal__badge--live {
    border-color: rgba(155, 96, 42, 0.65);
    color: #9b602a;
    background: rgba(110, 68, 28, 0.18); }

.course-exam-modal__close {
  position: relative;
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(58, 120, 180, 0.4);
  border-radius: 8px;
  background: rgba(21, 28, 36, 0.55);
  color: #b8b8b8;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background-color 0.15s ease; }
  .course-exam-modal__close::before, .course-exam-modal__close::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0.85rem;
    height: 2px;
    background: currentColor;
    transform-origin: center; }
  .course-exam-modal__close::before {
    transform: translate(-50%, -50%) rotate(45deg); }
  .course-exam-modal__close::after {
    transform: translate(-50%, -50%) rotate(-45deg); }
  .course-exam-modal__close:hover, .course-exam-modal__close:focus-visible {
    border-color: rgba(170, 158, 116, 0.55);
    color: #aa9e74;
    background: rgba(12, 38, 55, 0.75); }

.course-exam-modal__body {
  min-height: 0;
  flex: 1 1 auto;
  padding: 1rem 1.15rem;
  overflow-y: auto; }
  .course-exam-modal__body::-webkit-scrollbar {
    width: 6px; }
  .course-exam-modal__body::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .course-exam-modal__body::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .course-exam-modal__body::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }

.course-exam-results__actions {
  display: flex;
  justify-content: center; }

.mcq-grid input[type="radio"] {
  appearance: auto; }

.mcq-grid input[type="radio"]:checked {
  appearance: auto; }

.mcq-grid input[data-readonly="1"] {
  pointer-events: none;
  opacity: 0.9; }

/* English comment: block pointer when in readonly/archive */
input[type="checkbox"][data-readonly="1"] {
  pointer-events: none;
  opacity: 1; }

/* /src/assets/scss/admin/_certifications.scss */
.equivalences-management {
  /* Layout */ }
  .equivalences-management .input-row.equivalences, .equivalences-management .input-row.equivalences-rules, .equivalences-management .input-row.equivalences-items {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 20px;
    margin-bottom: 10px; }
    .equivalences-management .input-row.equivalences input, .equivalences-management .input-row.equivalences-rules input, .equivalences-management .input-row.equivalences-items input {
      padding: 2px 6px;
      border-radius: 6px; }
  .equivalences-management .equiv-code-input {
    width: 250px; }
  .equivalences-management .equiv-label-input {
    width: 250px; }
  .equivalences-management .equiv-desc-input {
    width: 260px; }
  .equivalences-management .equiv-theme-select {
    width: max-content; }
  .equivalences-management .equiv-level-select {
    width: max-content; }
  .equivalences-management .rule-priority-input {
    width: 90px; }
  .equivalences-management .rule-validFrom-input,
  .equivalences-management .rule-validTo-input {
    width: 140px; }
  .equivalences-management .rule-item-template-select {
    width: 260px; }
  .equivalences-management .row-selected {
    background: rgba(255, 255, 255, 0.06); }
  .equivalences-management .cell-loading {
    text-align: center;
    opacity: 0.6;
    padding: 10px; }
  .equivalences-management .theme-and-level {
    display: flex;
    flex-direction: column;
    gap: 12px;
    /* Row 1: equivalences list */
    /* Row 2: rules + items */ }
    .equivalences-management .theme-and-level .equivalences-requirements-block {
      width: -webkit-fill-available; }
    .equivalences-management .theme-and-level .equivalences-bottom-row {
      display: flex;
      gap: 12px; }
      .equivalences-management .theme-and-level .equivalences-bottom-row .equivalences-rules-block,
      .equivalences-management .theme-and-level .equivalences-bottom-row .equivalences-items-block {
        width: 50%; }
  .equivalences-management .equivalences-requirements,
  .equivalences-management .equivalences-rules,
  .equivalences-management .equivalences-items {
    max-height: 260px; }

.create-module-top-row {
  display: flex;
  align-items: flex-start; }

.create-module-left {
  flex: 1;
  min-width: 0; }

.create-module-right {
  width: 60%; }

.create-officer-checklist .officer-checklist-items {
  display: flex;
  flex-direction: column;
  gap: 8px; }

.create-officer-checklist .officer-checklist-item-wrapper {
  display: flex;
  flex-direction: column;
  gap: 5px;
  position: relative;
  background: #0c2637;
  min-height: 100px;
  max-height: calc(100vh - 510px);
  border: 1px solid #491212;
  border-top: 4px solid #491212;
  border-bottom: 4px solid #491212;
  border-radius: 8px;
  outline: none;
  padding: 15px;
  overflow-y: auto;
  margin-bottom: 20px; }
  .create-officer-checklist .officer-checklist-item-wrapper::-webkit-scrollbar {
    width: 6px; }
  .create-officer-checklist .officer-checklist-item-wrapper::-webkit-scrollbar-track {
    background: #2e3842;
    border-radius: 4px;
    padding-right: 1px; }
  .create-officer-checklist .officer-checklist-item-wrapper::-webkit-scrollbar-thumb {
    background-color: #491212;
    border-radius: 4px; }
    .create-officer-checklist .officer-checklist-item-wrapper::-webkit-scrollbar-thumb:hover {
      background-color: #200808; }

.create-officer-checklist .officer-checklist-item {
  display: flex;
  align-items: center;
  gap: 8px; }
  .create-officer-checklist .officer-checklist-item .checklist-label {
    flex: 1; }
  .create-officer-checklist .officer-checklist-item .checklist-remove {
    font-size: 12px;
    line-height: 0.7;
    padding: 6px 8px; }

.create-officer-checklist .officer-checklist-toggle {
  margin-top: 10px;
  margin-left: 0px; }
  .create-officer-checklist .officer-checklist-toggle .toggle-label {
    margin-left: 50px;
    color: #dfdfdf; }

.create-officer-checklist .officer-checklist-separator {
  margin: 15px 0px;
  border-bottom: 1px solid #dfdfdf;
  opacity: 0.2; }

.create-officer-checklist .officer-checklist-actions {
  margin-top: 16px;
  margin-bottom: 15px;
  display: flex;
  gap: 12px;
  margin-left: auto; }

.psych-scoring-editor,
.psych-scores-readout {
  margin-top: 0.85rem;
  padding: 0.75rem;
  border: 1px solid rgba(58, 120, 180, 0.28);
  border-radius: 8px;
  background: rgba(21, 28, 36, 0.35); }

.psych-scoring-editor__header,
.psych-scores-readout__title {
  margin: 0 0 0.65rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.72); }

.psych-scoring-editor__toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.82rem;
  color: #b8b8b8; }

.psych-scoring-editor__choice-grid {
  display: grid;
  gap: 0.75rem; }

.psych-scoring-editor__choice-option,
.psych-scores-readout__choice-option,
.psych-scores-readout__matrix-row {
  padding: 0.55rem;
  border: 1px solid rgba(56, 72, 88, 0.55);
  border-radius: 6px;
  background: rgba(12, 38, 55, 0.35); }

.psych-scoring-editor__option-title,
.psych-scores-readout__option-title,
.psych-scores-readout__matrix-row-title {
  margin: 0 0 0.45rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: #dfdfdf; }

.question-scoring-toggles {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin: 0.65rem 0 0.85rem;
  padding: 0.55rem 0.65rem;
  border-radius: 8px;
  background: rgba(21, 28, 36, 0.35);
  border: 1px solid rgba(58, 120, 180, 0.2); }

.question-scoring-toggles__item {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.82rem;
  color: #dfdfdf;
  cursor: pointer; }
  .question-scoring-toggles__item input {
    margin: 0; }

.psych-scoring-editor__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.78rem; }
  .psych-scoring-editor__table th,
  .psych-scoring-editor__table td {
    padding: 0.3rem 0.4rem;
    border-bottom: 1px solid rgba(56, 72, 88, 0.35);
    text-align: left; }
  .psych-scoring-editor__table th[scope="row"] {
    color: rgba(223, 223, 223, 0.82);
    font-weight: 500; }

.psych-scoring-editor__score-select {
  min-width: 4rem;
  padding: 0.2rem 0.35rem;
  border-radius: 6px;
  border: 1px solid rgba(58, 120, 180, 0.35);
  background: rgba(21, 28, 36, 0.55);
  color: #b8b8b8; }

.psych-scoring-editor__matrix {
  display: grid;
  gap: 0.5rem; }

.psych-scoring-editor__matrix-toggle {
  width: 100%;
  text-align: left;
  padding: 0.45rem 0.55rem;
  border: 1px solid rgba(56, 72, 88, 0.55);
  border-radius: 6px;
  background: rgba(42, 56, 71, 0.55);
  color: #dfdfdf;
  cursor: pointer; }
  .psych-scoring-editor__matrix-toggle.is-open {
    border-color: rgba(170, 158, 116, 0.45); }

.psych-scoring-editor__matrix-panel {
  display: grid;
  gap: 0.65rem;
  margin-top: 0.55rem; }

.psych-scores-readout__dimensions {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 0.2rem; }

.psych-scores-readout__dimension-label {
  color: rgba(223, 223, 223, 0.72); }

.psych-scores-readout__dimension-value {
  margin-left: 0.35rem;
  color: #dfdfdf;
  font-weight: 600; }

.psych-scores-readout__empty {
  color: rgba(223, 223, 223, 0.55);
  font-size: 0.78rem; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.member-academy {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  max-width: 100%;
  padding: 0 0 0.5rem;
  box-sizing: border-box; }

.member-academy__loading {
  display: flex;
  justify-content: center;
  padding: 2rem 0; }

.member-academy-header {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  flex-shrink: 0;
  padding: 0.65rem 0.85rem 0.75rem;
  border-radius: 8px;
  box-sizing: border-box;
  background: linear-gradient(180deg, rgba(0, 48, 77, 0.72), rgba(21, 28, 36, 0.42)), rgba(0, 48, 77, 0.55);
  border: 1px solid rgba(58, 120, 180, 0.55);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35), 0 12px 28px rgba(0, 0, 0, 0.35); }
  .member-academy-header__top {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.85rem 1.25rem; }
  .member-academy-header__title-wrap {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 0 0 auto; }
  .member-academy-header__lines {
    position: relative;
    width: 20px;
    height: 27px;
    flex-shrink: 0; }
    .member-academy-header__lines span {
      position: absolute;
      width: 22px;
      height: 3px;
      background: #c78445;
      transform: rotate(-65deg);
      transform-origin: left center; }
      .member-academy-header__lines span:first-child {
        top: 20px;
        left: 12px; }
      .member-academy-header__lines span:last-child {
        top: 20px; }
  .member-academy-header__title {
    margin: 0;
    font-size: 1.1rem;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #dfdfdf;
    white-space: nowrap; }
  .member-academy-header__search {
    min-width: 0; }
  .member-academy-header__toolbar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.65rem; }
  .member-academy-header__view-toggle {
    display: inline-flex;
    flex-shrink: 0;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid #747b81;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);
    background: #1c2d38; }
  .member-academy-header__toggle-btn {
    min-width: 52px;
    padding: 6px 14px;
    margin: 0;
    border: none;
    background: transparent;
    color: #b8b8b8;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease; }
    .member-academy-header__toggle-btn:not(:last-child) {
      border-right: 1px solid #384858; }
    .member-academy-header__toggle-btn:not(.member-academy-header__toggle-btn--active):hover {
      background: #384858;
      color: #dfdfdf; }
    .member-academy-header__toggle-btn--active {
      background: radial-gradient(circle at center, #004872 0%, #00304d 100%), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      color: #dfdfdf;
      box-shadow: inset 0 0 0 1px #004872; }

.member-academy__shell {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 520px; }

.member-academy__layout {
  display: grid;
  grid-template-columns: minmax(280px, 320px) minmax(0, 1fr);
  gap: 0.5rem;
  min-height: 0;
  flex: 1 1 auto;
  padding: 2px 4px 12px;
  box-sizing: border-box; }

.member-academy-course-list {
  display: flex;
  flex-direction: column;
  min-height: 0;
  border: 1px solid rgba(58, 120, 180, 0.35);
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(0, 48, 77, 0.72), rgba(21, 28, 36, 0.42)), rgba(0, 48, 77, 0.55);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35), 0 12px 28px rgba(0, 0, 0, 0.35);
  overflow: visible; }
  .member-academy-course-list__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.75rem 0.85rem;
    border-bottom: 1px solid rgba(58, 120, 180, 0.25);
    border-radius: 12px 12px 0 0; }
  .member-academy-course-list__title {
    margin: 0;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.82); }
  .member-academy-course-list__count {
    font-size: 0.72rem;
    color: rgba(223, 223, 223, 0.55);
    white-space: nowrap; }
  .member-academy-course-list__scroll {
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
    padding: 0.55rem;
    overflow: auto;
    max-height: calc(100vh - 480px);
    margin-bottom: 10px;
    border-radius: 0 0 12px 12px;
    scrollbar-width: thin;
    scrollbar-color: rgba(58, 120, 180, 0.45) rgba(21, 28, 36, 0.35); }
    .member-academy-course-list__scroll::-webkit-scrollbar {
      width: 8px; }
    .member-academy-course-list__scroll::-webkit-scrollbar-track {
      background: rgba(21, 28, 36, 0.35);
      border-radius: 999px; }
    .member-academy-course-list__scroll::-webkit-scrollbar-thumb {
      background: rgba(58, 120, 180, 0.45);
      border-radius: 999px; }
  .member-academy-course-list__group-title {
    margin: 0.35rem 0.35rem 0.15rem;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(90, 195, 255, 0.88); }
  .member-academy-course-list__section-separator {
    margin: 0.9rem 0.35rem;
    border: 0;
    border-top: 1px solid rgba(58, 120, 180, 0.38); }
  .member-academy-course-list__empty {
    margin: 0.75rem 0.35rem;
    color: #b8b8b8;
    font-size: 0.9rem; }

.member-academy-course-item {
  display: flex;
  align-items: stretch; }
  .member-academy-course-item--selected .member-academy-course-item__main {
    border-color: rgba(90, 195, 255, 0.85);
    box-shadow: 0 0 0 1px rgba(90, 195, 255, 0.35);
    background: rgba(58, 120, 180, 0.28); }
  .member-academy-course-item--search-match .member-academy-course-item__main--search-match,
  .member-academy-course-item--selected.member-academy-course-item--search-match .member-academy-course-item__main--search-match {
    border-color: #c78445;
    box-shadow: 0 0 0 1px rgba(199, 132, 69, 0.35); }
  .member-academy-course-item--search-match:not(.member-academy-course-item--selected) .member-academy-course-item__main--search-match:hover {
    border-color: #c78445; }
  .member-academy-course-item__main {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.2rem;
    min-width: 0;
    width: 100%;
    padding: 0.55rem 0.65rem;
    border: 1px solid rgba(58, 120, 180, 0.28);
    border-radius: 8px;
    background: rgba(23, 39, 56, 0.55);
    color: inherit;
    text-align: left;
    cursor: pointer;
    transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease; }
    .member-academy-course-item__main:hover {
      border-color: rgba(90, 195, 255, 0.55);
      background: rgba(58, 120, 180, 0.22); }
    .member-academy-course-item__main:focus-visible {
      outline: 2px solid rgba(58, 120, 180, 0.75);
      outline-offset: 2px; }
  .member-academy-course-item__name {
    font-size: 0.92rem;
    font-weight: 700;
    color: #dfdfdf;
    line-height: 1.25;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%; }
  .member-academy-course-item__meta {
    font-size: 0.74rem;
    color: rgba(184, 184, 184, 0.92); }
  .member-academy-course-item--promotion-locked .member-academy-course-item__main--promotion-locked {
    border-style: dashed; }

.member-academy-detail {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  height: calc(100vh - 480px);
  max-height: calc(100vh - 480px);
  padding: 1rem;
  overflow: auto;
  border: 1px solid rgba(58, 120, 180, 0.35);
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(0, 48, 77, 0.72), rgba(21, 28, 36, 0.42)), rgba(0, 48, 77, 0.55);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35), 0 12px 28px rgba(0, 0, 0, 0.35);
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.45) rgba(21, 28, 36, 0.35); }
  .member-academy-detail::-webkit-scrollbar {
    width: 8px; }
  .member-academy-detail::-webkit-scrollbar-track {
    background: rgba(21, 28, 36, 0.35);
    border-radius: 999px; }
  .member-academy-detail::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.45);
    border-radius: 999px; }
  .member-academy-detail--empty {
    justify-content: center;
    align-items: flex-start; }
  .member-academy-detail--promotion-locked {
    overflow: hidden;
    position: relative; }
  .member-academy-detail__body {
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 0;
    flex: 1 1 auto; }
  .member-academy-detail__body--locked {
    min-height: 12rem;
    flex: 1 1 auto; }
  .member-academy-detail__body-blur {
    filter: blur(5px);
    opacity: 0.42;
    pointer-events: none;
    user-select: none; }
  .member-academy-detail__lock-card {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 2;
    width: min(92%, 26rem);
    padding: 0.85rem 1rem;
    border-radius: 10px;
    border: 1px solid rgba(58, 120, 180, 0.45);
    background: rgba(21, 28, 36, 0.95);
    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.45), 0 0 0 1px rgba(0, 0, 0, 0.25);
    transform: translate(-50%, -50%); }
  .member-academy-detail__lock-card-title {
    margin: 0 0 0.45rem;
    font-size: 0.82rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.92); }
  .member-academy-detail__lock-card-text {
    margin: 0;
    font-size: 0.86rem;
    line-height: 1.45;
    color: rgba(184, 184, 184, 0.95); }
  .member-academy-detail__empty {
    margin: 0;
    color: rgba(223, 223, 223, 0.72);
    font-size: 0.95rem; }
  .member-academy-detail__header {
    margin-bottom: 1rem;
    padding-bottom: 0.85rem;
    border-bottom: 1px solid rgba(58, 120, 180, 0.22); }
  .member-academy-detail__header-top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.75rem; }
  .member-academy-detail__header-main {
    min-width: 0;
    flex: 1 1 auto; }
  .member-academy-detail__header-actions {
    flex: 0 0 auto;
    display: flex;
    align-items: flex-start;
    padding-top: 0.05rem; }
  .member-academy-detail__title {
    margin: 0 0 0.45rem;
    font-size: 1.15rem;
    font-weight: 700;
    letter-spacing: 0.02em;
    color: #dfdfdf; }
  .member-academy-detail__meta {
    display: flex;
    flex-wrap: wrap;
    gap: 0.35rem;
    margin-bottom: 0; }
  .member-academy-detail__badge {
    display: inline-flex;
    align-items: center;
    padding: 0.2rem 0.55rem;
    border: 1px solid rgba(58, 120, 180, 0.35);
    border-radius: 999px;
    background: rgba(0, 48, 77, 0.45);
    color: rgba(90, 195, 255, 0.92);
    font-size: 0.72rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase; }
    .member-academy-detail__badge--next-rank {
      border-color: rgba(199, 132, 69, 0.45);
      color: rgba(199, 132, 69, 0.95); }
  .member-academy-detail__description {
    margin: 0.65rem 0 0;
    color: rgba(184, 184, 184, 0.95);
    line-height: 1.5;
    font-size: 0.92rem; }
  .member-academy-detail__section {
    display: flex;
    flex-direction: column;
    gap: 0.65rem; }
  .member-academy-detail__section-title {
    margin: 0;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.82); }
  .member-academy-detail__section-empty {
    margin: 0;
    color: rgba(184, 184, 184, 0.92);
    font-size: 0.9rem; }
    .member-academy-detail__section-empty--locked {
      font-style: italic;
      color: rgba(223, 223, 223, 0.62); }
  .member-academy-detail__search-meta {
    margin: 0.35rem 0 0;
    font-size: 0.74rem;
    color: rgba(184, 184, 184, 0.82); }

.member-academy-document-list {
  display: flex;
  flex-direction: column;
  gap: 0.45rem; }
  .member-academy-document-list--locked {
    margin-top: 0.35rem; }

.member-academy-document-row {
  display: grid;
  grid-template-columns: minmax(180px, 240px) minmax(0, 1fr);
  gap: 0.75rem;
  align-items: start;
  width: 100%;
  padding: 0.65rem 0.75rem;
  border: 1px solid rgba(58, 120, 180, 0.28);
  border-radius: 8px;
  background: rgba(23, 39, 56, 0.55);
  color: #dfdfdf;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease; }
  .member-academy-document-row:hover {
    border-color: rgba(90, 195, 255, 0.55);
    background: rgba(58, 120, 180, 0.22);
    box-shadow: 0 0 0 1px rgba(90, 195, 255, 0.18); }
  .member-academy-document-row:focus-visible {
    outline: 2px solid rgba(58, 120, 180, 0.75);
    outline-offset: 2px; }
  .member-academy-document-row__main {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    min-width: 0; }
  .member-academy-document-row__title {
    font-size: 0.92rem;
    font-weight: 700;
    color: #dfdfdf;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; }
  .member-academy-document-row__meta {
    font-size: 0.74rem;
    font-weight: 600;
    color: rgba(90, 195, 255, 0.88); }
  .member-academy-document-row__excerpt-wrap {
    min-width: 0;
    overflow: hidden;
    -webkit-mask-image: linear-gradient(to right, black calc(100% - 24px), rgba(0, 0, 0, 0) 100%);
    mask-image: linear-gradient(to right, black calc(100% - 24px), rgba(0, 0, 0, 0) 100%); }
  .member-academy-document-row__excerpt {
    margin: 0;
    font-size: 0.8rem;
    line-height: 1.4;
    color: rgba(184, 184, 184, 0.95);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; }
  .member-academy-document-row__excerpt--loading {
    display: block;
    font-style: italic;
    color: rgba(223, 223, 223, 0.62); }
  .member-academy-document-row--locked {
    min-height: 3.25rem;
    cursor: default;
    pointer-events: none;
    border-style: dashed;
    opacity: 0.55; }

.member-academy-document-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 0.55rem; }
  .member-academy-document-grid--locked {
    margin-top: 0.35rem; }

.member-academy-document-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.35rem;
  height: 220px;
  width: 100%;
  padding: 0.75rem 0.8rem;
  border: 1px solid rgba(58, 120, 180, 0.28);
  border-radius: 10px;
  background: rgba(23, 39, 56, 0.58);
  color: #dfdfdf;
  cursor: pointer;
  text-align: left;
  overflow: hidden;
  box-shadow: 0 0 0 1px rgba(90, 195, 255, 0.08);
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease; }
  .member-academy-document-card:hover {
    border-color: rgba(90, 195, 255, 0.55);
    background: rgba(58, 120, 180, 0.22);
    box-shadow: 0 0 0 1px rgba(90, 195, 255, 0.22), 0 8px 18px rgba(0, 0, 0, 0.28);
    transform: translateY(-1px); }
  .member-academy-document-card:focus-visible {
    outline: 2px solid rgba(58, 120, 180, 0.75);
    outline-offset: 2px; }
  .member-academy-document-card__title {
    flex-shrink: 0;
    font-size: 0.92rem;
    font-weight: 700;
    line-height: 1.3;
    color: #dfdfdf;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%; }
  .member-academy-document-card__meta {
    flex-shrink: 0;
    font-size: 0.74rem;
    font-weight: 600;
    color: rgba(90, 195, 255, 0.88); }
  .member-academy-document-card__excerpt-wrap {
    position: relative;
    flex: 1;
    width: 100%;
    min-height: 0;
    margin-top: 0.1rem;
    overflow: hidden;
    -webkit-mask-image: linear-gradient(to bottom, black calc(100% - 30px), rgba(0, 0, 0, 0) 100%);
    mask-image: linear-gradient(to bottom, black calc(100% - 30px), rgba(0, 0, 0, 0) 100%); }
  .member-academy-document-card__excerpt {
    margin: 0;
    font-size: 0.8rem;
    line-height: 1.45;
    color: rgba(184, 184, 184, 0.95);
    white-space: pre-line; }
  .member-academy-document-card__excerpt--loading {
    display: block;
    font-style: italic;
    color: rgba(223, 223, 223, 0.62); }
  .member-academy-document-card--locked {
    cursor: default;
    pointer-events: none;
    border-style: dashed;
    opacity: 0.55; }
    .member-academy-document-card--locked:hover {
      border-color: rgba(58, 120, 180, 0.28);
      background: rgba(23, 39, 56, 0.58);
      box-shadow: 0 0 0 1px rgba(90, 195, 255, 0.08);
      transform: none; }

.member-academy-document-modal {
  width: 85vw;
  max-width: 1300px;
  height: 85vh;
  max-height: 85vh;
  border: 1px solid rgba(58, 120, 180, 0.45);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.45), 0 18px 42px rgba(0, 0, 0, 0.55); }

.member-academy-document-modal__body {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden; }

.member-academy-document-panel {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%; }

.member-academy-document-panel__viewer {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0; }

.member-academy-document-viewer {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 0.85rem 1rem;
  border-radius: 10px;
  border: 1px solid rgba(58, 120, 180, 0.35);
  background: linear-gradient(180deg, rgba(0, 48, 77, 0.55), rgba(21, 28, 36, 0.38)), rgba(23, 39, 56, 0.72);
  box-shadow: inset 0 1px 0 rgba(90, 195, 255, 0.08);
  width: 100%;
  box-sizing: border-box;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.45) rgba(21, 28, 36, 0.35); }
  .member-academy-document-viewer::-webkit-scrollbar {
    width: 8px; }
  .member-academy-document-viewer::-webkit-scrollbar-track {
    background: rgba(21, 28, 36, 0.35);
    border-radius: 999px; }
  .member-academy-document-viewer::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.45);
    border-radius: 999px; }
  .member-academy-document-viewer h2,
  .member-academy-document-viewer h3 {
    color: #dfdfdf; }
  .member-academy-document-viewer p {
    margin-bottom: 0;
    color: #dfdfdf; }
  .member-academy-document-viewer blockquote {
    margin: 10px 0;
    color: #dfdfdf;
    padding: 15px;
    position: relative;
    border-left: 3px solid rgba(58, 120, 180, 0.45); }
    .member-academy-document-viewer blockquote::before, .member-academy-document-viewer blockquote::after {
      content: "";
      position: absolute;
      border: 2px solid rgba(58, 120, 180, 0.35);
      border-radius: 6px 0; }
    .member-academy-document-viewer blockquote::before {
      top: -3px;
      left: -3px;
      width: 50%;
      height: 50%;
      border-right: none;
      border-bottom: none; }
    .member-academy-document-viewer blockquote::after {
      bottom: -3px;
      right: -3px;
      width: 50%;
      height: 50%;
      border-left: none;
      border-top: none; }
  .member-academy-document-viewer pre {
    background-color: rgba(21, 28, 36, 0.72);
    border: 1px solid rgba(58, 120, 180, 0.35);
    border-left: 4px solid rgba(90, 195, 255, 0.65);
    border-radius: 6px;
    color: #dfdfdf !important;
    font-size: inherit;
    line-height: inherit;
    margin: 0 0 10px;
    overflow: visible;
    padding: 20px !important;
    white-space: pre-wrap;
    word-break: inherit;
    word-wrap: break-word;
    font-family: 'Input', monospace !important; }

@media (max-width: 1023px) {
  .member-academy__layout {
    grid-template-columns: 1fr; }
  .member-academy-header__top {
    flex-direction: column;
    align-items: stretch; }
  .member-academy-header__search {
    max-width: none; }
  .member-academy-document-row {
    grid-template-columns: 1fr;
    gap: 0.35rem; }
  .member-academy-document-row__excerpt-wrap {
    -webkit-mask-image: none;
    mask-image: none; }
  .member-academy-document-row__excerpt {
    white-space: pre-line;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden; }
  .member-academy-course-list__scroll,
  .member-academy-detail {
    max-height: none;
    height: auto;
    min-height: 280px; }
  .member-academy-detail__header-top {
    flex-direction: column;
    align-items: stretch; }
  .member-academy-detail__header-actions {
    padding-top: 0; }
  .member-academy-exam-room-btn {
    width: 100%;
    max-width: none; } }

.member-academy-exam-room-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 2.35rem;
  width: 16.5rem;
  padding: 0.5rem 0.85rem;
  border: 1px solid rgba(199, 132, 69, 0.55);
  border-radius: 8px;
  background: linear-gradient(145deg, rgba(155, 96, 42, 0.28), rgba(23, 39, 56, 0.88));
  color: #dfdfdf;
  font-size: 0.88rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-align: center;
  line-height: 1.25;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease; }
  .member-academy-exam-room-btn:hover:not(:disabled) {
    border-color: rgba(199, 132, 69, 0.85);
    box-shadow: 0 0 0 1px rgba(199, 132, 69, 0.25); }
  .member-academy-exam-room-btn:focus-visible {
    outline: 2px solid rgba(199, 132, 69, 0.75);
    outline-offset: 2px; }
  .member-academy-exam-room-btn:disabled {
    opacity: 0.55;
    cursor: not-allowed; }
  .member-academy-exam-room-btn__label--hover {
    display: none; }
  .member-academy-exam-room-btn:hover:not(:disabled) .member-academy-exam-room-btn__label--default {
    display: none; }
  .member-academy-exam-room-btn:hover:not(:disabled) .member-academy-exam-room-btn__label--hover {
    display: inline; }

.member-academy-exam-disclaimer-overlay {
  z-index: 12050; }

.member-academy-exam-disclaimer {
  width: min(92%, 34rem);
  max-height: min(88vh, 720px);
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(58, 120, 180, 0.45);
  border-radius: 12px;
  background: rgba(21, 28, 36, 0.98);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.45), 0 18px 42px rgba(0, 0, 0, 0.55);
  overflow: hidden; }
  .member-academy-exam-disclaimer__header {
    position: relative;
    padding: 1rem 1rem 0.75rem;
    border-bottom: 1px solid rgba(58, 120, 180, 0.25); }
  .member-academy-exam-disclaimer__eyebrow {
    margin: 0 0 0.25rem;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: rgba(90, 195, 255, 0.88); }
  .member-academy-exam-disclaimer__title {
    margin: 0;
    padding-right: 2rem;
    font-size: 1.1rem;
    font-weight: 700;
    color: #dfdfdf; }
  .member-academy-exam-disclaimer__body {
    padding: 0.85rem 1rem 1rem;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(58, 120, 180, 0.45) rgba(21, 28, 36, 0.35); }
    .member-academy-exam-disclaimer__body::-webkit-scrollbar {
      width: 8px; }
    .member-academy-exam-disclaimer__body::-webkit-scrollbar-track {
      background: rgba(21, 28, 36, 0.35);
      border-radius: 999px; }
    .member-academy-exam-disclaimer__body::-webkit-scrollbar-thumb {
      background: rgba(58, 120, 180, 0.45);
      border-radius: 999px; }
  .member-academy-exam-disclaimer__intro {
    margin: 0 0 0.75rem;
    font-size: 0.9rem;
    line-height: 1.45;
    color: rgba(184, 184, 184, 0.95); }
  .member-academy-exam-disclaimer__rules {
    margin: 0 0 0.85rem;
    padding-left: 1.1rem;
    color: rgba(223, 223, 223, 0.92);
    font-size: 0.88rem;
    line-height: 1.45; }
    .member-academy-exam-disclaimer__rules li + li {
      margin-top: 0.35rem; }
  .member-academy-exam-disclaimer__checks {
    display: flex;
    flex-direction: column;
    gap: 0.55rem; }
  .member-academy-exam-disclaimer__check {
    display: flex;
    align-items: flex-start;
    gap: 0.55rem;
    font-size: 0.86rem;
    line-height: 1.4;
    color: rgba(223, 223, 223, 0.92);
    cursor: pointer; }
  .member-academy-exam-disclaimer__checkbox {
    margin-top: 0.15rem;
    flex-shrink: 0; }
  .member-academy-exam-disclaimer__footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.55rem;
    padding: 0.75rem 1rem 1rem;
    border-top: 1px solid rgba(58, 120, 180, 0.22); }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.training-standards-page,
.academy-admin-page {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 1.5rem; }

.ts-page-header {
  margin-bottom: 0.25rem;
  padding: 1.1rem 1.25rem;
  border-radius: 14px;
  border: 1px solid rgba(58, 120, 180, 0.45);
  background: linear-gradient(135deg, rgba(0, 48, 77, 0.88), rgba(21, 28, 36, 0.55)), rgba(0, 48, 77, 0.65);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.28); }

.ts-page-header__eyebrow {
  margin: 0 0 0.35rem;
  font-size: 0.72rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.62); }

.ts-page-header__title {
  margin: 0;
  font-size: clamp(1.15rem, 2vw, 1.45rem);
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #dfdfdf; }

.ts-layout {
  display: grid;
  gap: 1rem; }
  .ts-layout--split {
    grid-template-columns: repeat(2, minmax(0, 1fr)); }
  @media (max-width: 960px) {
    .ts-layout--split {
      grid-template-columns: 1fr; } }

.ts-panel {
  padding: 1rem 1.1rem;
  border-radius: 14px;
  border: 1px solid rgba(58, 120, 180, 0.35);
  background: rgba(0, 48, 77, 0.52);
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.2);
  min-width: 0; }
  .ts-panel--full {
    padding: 1.1rem 1.25rem; }
  .ts-panel__footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;
    padding-top: 0.75rem;
    border-top: 1px solid rgba(58, 120, 180, 0.22); }

.ts-panel__title {
  margin: 0 0 0.85rem;
  font-size: 0.82rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.88); }
  .ts-panel__title--inline {
    margin: 0;
    flex: 1 1 auto; }

.ts-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.55rem 0.75rem;
  margin-bottom: 0.85rem;
  padding: 0.85rem 1rem;
  border-radius: 12px;
  border: 1px solid rgba(58, 120, 180, 0.28);
  background: rgba(21, 28, 36, 0.38); }
  .ts-toolbar--compact {
    padding: 0.65rem 0.85rem;
    margin-bottom: 0.65rem; }

.ts-input {
  min-width: 0;
  padding: 0.45rem 0.65rem;
  border: 1px solid rgba(58, 120, 180, 0.45);
  border-radius: 8px;
  font-family: inherit;
  font-size: 0.84rem;
  color: #dfdfdf;
  background: rgba(0, 48, 77, 0.65); }
  .ts-input::placeholder {
    color: rgba(223, 223, 223, 0.45); }
  .ts-input:disabled {
    opacity: 0.55;
    cursor: not-allowed; }
  .ts-input--grow {
    flex: 1 1 12rem; }
  .ts-input--code {
    flex: 1 1 10rem;
    min-width: 9rem; }
  .ts-input--label {
    flex: 1 1 10rem;
    min-width: 9rem; }
  .ts-input--desc {
    flex: 1 1 12rem;
    min-width: 11rem; }
  .ts-input--priority {
    width: 5.5rem;
    flex: 0 0 auto; }
  .ts-input--date {
    width: 9rem;
    flex: 0 0 auto; }
  .ts-input--token {
    width: 100%;
    min-width: 3.5rem;
    box-sizing: border-box;
    text-align: center; }
    .ts-input--token::-webkit-inner-spin-button, .ts-input--token::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0; }
    .ts-input--token[type='number'] {
      -moz-appearance: textfield; }

.ts-select-native {
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 0.45rem 1.75rem 0.45rem 0.65rem;
  border: 1px solid rgba(58, 120, 180, 0.45);
  border-radius: 8px;
  font-family: inherit;
  font-size: 0.84rem;
  color: #dfdfdf;
  background: rgba(0, 48, 77, 0.65);
  appearance: none;
  background-image: linear-gradient(45deg, transparent 50%, rgba(223, 223, 223, 0.75) 50%), linear-gradient(135deg, rgba(223, 223, 223, 0.75) 50%, transparent 50%);
  background-position: calc(100% - 16px) calc(50% - 2px), calc(100% - 11px) calc(50% - 2px);
  background-size: 5px 5px, 5px 5px;
  background-repeat: no-repeat; }
  .ts-select-native.select-default {
    color: rgba(223, 223, 223, 0.45); }
  .ts-select-native:disabled {
    opacity: 0.55;
    cursor: not-allowed; }
  .ts-select-native option {
    background: #151c24;
    color: #dfdfdf; }

.ts-select {
  flex: 1 1 11rem;
  min-width: 10rem; }
  .ts-select .react-select__control {
    min-height: 2.1rem !important;
    height: auto !important;
    min-width: 0 !important;
    border: 1px solid rgba(58, 120, 180, 0.45) !important;
    border-radius: 8px !important;
    background: rgba(0, 48, 77, 0.65) !important;
    box-shadow: none !important; }
  .ts-select .react-select__value-container {
    padding: 0.2rem 0.55rem !important; }
  .ts-select .react-select__single-value,
  .ts-select .react-select__placeholder,
  .ts-select .react-select__input-container {
    color: #dfdfdf !important;
    font-size: 0.84rem !important; }
  .ts-select .react-select__placeholder {
    color: rgba(223, 223, 223, 0.45) !important; }
  .ts-select .react-select__indicator {
    color: rgba(223, 223, 223, 0.55) !important; }
  .ts-select .react-select__menu {
    background: rgba(21, 28, 36, 0.98) !important;
    border: 1px solid rgba(58, 120, 180, 0.35) !important;
    border-radius: 8px !important;
    overflow: hidden; }
  .ts-select .react-select__option {
    background: transparent !important;
    color: #dfdfdf !important;
    font-size: 0.84rem !important; }
    .ts-select .react-select__option--is-focused {
      background: rgba(58, 120, 180, 0.18) !important; }
    .ts-select .react-select__option--is-selected {
      background: rgba(58, 120, 180, 0.32) !important;
      color: #ffffff !important; }

.ts-table-wrap {
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid rgba(58, 120, 180, 0.28);
  background: rgba(0, 48, 77, 0.38); }
  .ts-table-wrap .accounting-table {
    margin-bottom: 0; }
  .ts-table-wrap > .accounting-table thead {
    display: table-header-group;
    background-size: cover;
    color: #b8b8b8;
    text-transform: uppercase;
    border-bottom: 2px solid #2a3847;
    background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center; }
  .ts-table-wrap > .accounting-table thead th {
    position: relative;
    top: auto;
    z-index: auto;
    height: 30px;
    padding: 0 12px;
    font-size: 0.75em;
    font-weight: 600;
    letter-spacing: normal;
    line-height: 30px;
    color: #b8b8b8;
    background: transparent;
    border-bottom: none;
    border-right: none;
    vertical-align: middle;
    text-align: left; }
    .ts-table-wrap > .accounting-table thead th:not(:last-child)::after {
      content: '';
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
      height: 65%;
      background-color: #2a3847; }

.ts-table-scroll {
  display: block;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.5) rgba(0, 48, 77, 0.45); }
  .ts-table-scroll::-webkit-scrollbar {
    width: 4px; }
  .ts-table-scroll::-webkit-scrollbar-track {
    background: rgba(0, 48, 77, 0.45);
    border-radius: 999px; }
  .ts-table-scroll::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.48);
    border-radius: 999px; }
    .ts-table-scroll::-webkit-scrollbar-thumb:hover {
      background: rgba(58, 120, 180, 0.65); }
  .ts-table-scroll .accounting-table thead {
    display: none; }
  .ts-table-scroll--themes, .ts-table-scroll--levels {
    max-height: 180px; }
  .ts-table-scroll--all-orgs {
    max-height: min(62vh, calc(100vh - 280px)); }
  .ts-table-scroll--all-orgs-members {
    max-height: min(42vh, calc(100vh - 420px)); }
  .ts-table-scroll--requirements {
    max-height: 280px; }
  .ts-table-scroll--rules, .ts-table-scroll--items {
    max-height: 220px; }
  .ts-table-scroll--modules {
    max-height: min(520px, calc(100vh - 320px)); }
  .ts-table-scroll--courses {
    max-height: min(420px, calc(100vh - 380px)); }
  .ts-table-scroll--ranks-requirements {
    max-height: min(480px, calc(100vh - 360px));
    overflow-x: auto; }

.training-standards-page .ts-status,
.academy-admin-page .ts-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 0.55rem;
  height: 0.55rem;
  border-radius: 50%; }
  .training-standards-page .ts-status.is-active,
  .academy-admin-page .ts-status.is-active {
    background: #75cf78;
    box-shadow: 0 0 0 3px rgba(117, 207, 120, 0.18); }
  .training-standards-page .ts-status.is-inactive,
  .academy-admin-page .ts-status.is-inactive {
    background: rgba(223, 223, 223, 0.28);
    box-shadow: none; }

.training-standards-page .cell-found,
.training-standards-page th.header-found,
.academy-admin-page .cell-found,
.academy-admin-page th.header-found {
  text-align: center;
  vertical-align: middle; }

.training-standards-page .accounting-table--themes-head col.col-themeName,
.training-standards-page .accounting-table--themes-body col.col-themeName,
.academy-admin-page .accounting-table--themes-head col.col-themeName,
.academy-admin-page .accounting-table--themes-body col.col-themeName {
  width: auto; }

.training-standards-page .accounting-table--themes-head col.col-found,
.training-standards-page .accounting-table--themes-body col.col-found,
.academy-admin-page .accounting-table--themes-head col.col-found,
.academy-admin-page .accounting-table--themes-body col.col-found {
  width: 5.5rem; }

.training-standards-page .accounting-table--levels-head col.col-handle,
.training-standards-page .accounting-table--levels-body col.col-handle,
.academy-admin-page .accounting-table--levels-head col.col-handle,
.academy-admin-page .accounting-table--levels-body col.col-handle {
  width: 2rem; }

.training-standards-page .accounting-table--levels-head col.col-levelName,
.training-standards-page .accounting-table--levels-body col.col-levelName,
.academy-admin-page .accounting-table--levels-head col.col-levelName,
.academy-admin-page .accounting-table--levels-body col.col-levelName {
  width: auto; }

.training-standards-page .accounting-table--levels-head col.col-found,
.training-standards-page .accounting-table--levels-body col.col-found,
.academy-admin-page .accounting-table--levels-head col.col-found,
.academy-admin-page .accounting-table--levels-body col.col-found {
  width: 5.5rem; }

.training-standards-page .accounting-table--levels-body .cell-handle,
.academy-admin-page .accounting-table--levels-body .cell-handle {
  width: 30px;
  padding: 0 6px;
  text-align: center;
  cursor: grab;
  user-select: none;
  align-content: center; }
  .training-standards-page .accounting-table--levels-body .cell-handle .drag-handle,
  .academy-admin-page .accounting-table--levels-body .cell-handle .drag-handle {
    display: inline-block;
    font-size: 1.2em;
    line-height: 1; }

.training-standards-page .accounting-table--levels-body tr[data-sensor-context="active"] .cell-handle,
.academy-admin-page .accounting-table--levels-body tr[data-sensor-context="active"] .cell-handle {
  cursor: grabbing; }

.training-standards-page .ts-table-wrap.dnd-locked .cell-handle,
.academy-admin-page .ts-table-wrap.dnd-locked .cell-handle {
  cursor: default;
  opacity: 0.45; }

.training-standards-page .accounting-table--requirements-head col.col-code,
.training-standards-page .accounting-table--requirements-body col.col-code,
.academy-admin-page .accounting-table--requirements-head col.col-code,
.academy-admin-page .accounting-table--requirements-body col.col-code {
  width: 22%; }

.training-standards-page .accounting-table--requirements-head col.col-label,
.training-standards-page .accounting-table--requirements-body col.col-label,
.academy-admin-page .accounting-table--requirements-head col.col-label,
.academy-admin-page .accounting-table--requirements-body col.col-label {
  width: 28%; }

.training-standards-page .accounting-table--requirements-head col.col-theme,
.training-standards-page .accounting-table--requirements-body col.col-theme,
.academy-admin-page .accounting-table--requirements-head col.col-theme,
.academy-admin-page .accounting-table--requirements-body col.col-theme {
  width: 18%; }

.training-standards-page .accounting-table--requirements-head col.col-trainingLevel,
.training-standards-page .accounting-table--requirements-body col.col-trainingLevel,
.academy-admin-page .accounting-table--requirements-head col.col-trainingLevel,
.academy-admin-page .accounting-table--requirements-body col.col-trainingLevel {
  width: 18%; }

.training-standards-page .accounting-table--requirements-head col.col-version,
.training-standards-page .accounting-table--requirements-body col.col-version,
.academy-admin-page .accounting-table--requirements-head col.col-version,
.academy-admin-page .accounting-table--requirements-body col.col-version {
  width: 7rem; }

.training-standards-page .accounting-table--rules-head col.col-priority,
.training-standards-page .accounting-table--rules-body col.col-priority,
.academy-admin-page .accounting-table--rules-head col.col-priority,
.academy-admin-page .accounting-table--rules-body col.col-priority {
  width: 4.5rem; }

.training-standards-page .accounting-table--rules-head col.col-validFrom,
.training-standards-page .accounting-table--rules-body col.col-validFrom,
.academy-admin-page .accounting-table--rules-head col.col-validFrom,
.academy-admin-page .accounting-table--rules-body col.col-validFrom {
  width: 32%; }

.training-standards-page .accounting-table--rules-head col.col-validTo,
.training-standards-page .accounting-table--rules-body col.col-validTo,
.academy-admin-page .accounting-table--rules-head col.col-validTo,
.academy-admin-page .accounting-table--rules-body col.col-validTo {
  width: 32%; }

.training-standards-page .accounting-table--rules-head col.col-actions,
.training-standards-page .accounting-table--rules-body col.col-actions,
.academy-admin-page .accounting-table--rules-head col.col-actions,
.academy-admin-page .accounting-table--rules-body col.col-actions {
  width: 5.5rem; }

.training-standards-page .accounting-table--items-head col.col-eventTemplate,
.training-standards-page .accounting-table--items-body col.col-eventTemplate,
.academy-admin-page .accounting-table--items-head col.col-eventTemplate,
.academy-admin-page .accounting-table--items-body col.col-eventTemplate {
  width: auto; }

.training-standards-page .accounting-table--items-head col.col-templateId,
.training-standards-page .accounting-table--items-body col.col-templateId,
.academy-admin-page .accounting-table--items-head col.col-templateId,
.academy-admin-page .accounting-table--items-body col.col-templateId {
  width: 7rem; }

.training-standards-page .accounting-table__empty,
.academy-admin-page .accounting-table__empty {
  padding: 1.25rem 0.75rem;
  font-size: 0.82rem; }

.training-standards-page .accounting-date-input,
.academy-admin-page .accounting-date-input {
  min-width: 9rem;
  padding: 0.4rem 0.65rem;
  border: 1px solid rgba(58, 120, 180, 0.45);
  border-radius: 8px;
  font-family: inherit;
  font-size: 0.82rem;
  color: #dfdfdf;
  background: rgba(0, 48, 77, 0.65); }

.training-standards-page .ts-equiv-layout,
.academy-admin-page .ts-equiv-layout {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 0.25rem; }

.training-standards-page .ts-equiv-bottom,
.academy-admin-page .ts-equiv-bottom {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem; }
  @media (max-width: 960px) {
    .training-standards-page .ts-equiv-bottom,
    .academy-admin-page .ts-equiv-bottom {
      grid-template-columns: 1fr; } }

.training-standards-page .ts-subpanel,
.academy-admin-page .ts-subpanel {
  padding: 0.85rem 1rem;
  border-radius: 12px;
  border: 1px solid rgba(58, 120, 180, 0.22);
  background: rgba(21, 28, 36, 0.32);
  min-width: 0; }

.training-standards-page .accounting-btn:disabled,
.academy-admin-page .accounting-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed; }

.training-standards-page .accounting-table--modules-head col.col-moduleName,
.training-standards-page .accounting-table--modules-body col.col-moduleName,
.academy-admin-page .accounting-table--modules-head col.col-moduleName,
.academy-admin-page .accounting-table--modules-body col.col-moduleName {
  width: auto; }

.training-standards-page .accounting-table--modules-head col.col-trainingLevel,
.training-standards-page .accounting-table--modules-body col.col-trainingLevel,
.academy-admin-page .accounting-table--modules-head col.col-trainingLevel,
.academy-admin-page .accounting-table--modules-body col.col-trainingLevel {
  width: 9rem; }

.training-standards-page .accounting-table--modules-head col.col-theme,
.training-standards-page .accounting-table--modules-body col.col-theme,
.academy-admin-page .accounting-table--modules-head col.col-theme,
.academy-admin-page .accounting-table--modules-body col.col-theme {
  width: 10rem; }

.training-standards-page .accounting-table--modules-head col.col-moduleVersion,
.training-standards-page .accounting-table--modules-body col.col-moduleVersion,
.academy-admin-page .accounting-table--modules-head col.col-moduleVersion,
.academy-admin-page .accounting-table--modules-body col.col-moduleVersion {
  width: 5.5rem; }

.training-standards-page .accounting-table--modules-head col.col-simple,
.training-standards-page .accounting-table--modules-body col.col-simple,
.academy-admin-page .accounting-table--modules-head col.col-simple,
.academy-admin-page .accounting-table--modules-body col.col-simple {
  width: 4.5rem; }

.training-standards-page .accounting-table--modules-head col.col-standard,
.training-standards-page .accounting-table--modules-body col.col-standard,
.academy-admin-page .accounting-table--modules-head col.col-standard,
.academy-admin-page .accounting-table--modules-body col.col-standard {
  width: 4.5rem; }

.training-standards-page .accounting-table--modules-head col.col-complex,
.training-standards-page .accounting-table--modules-body col.col-complex,
.academy-admin-page .accounting-table--modules-head col.col-complex,
.academy-admin-page .accounting-table--modules-body col.col-complex {
  width: 4.5rem; }

.training-standards-page .accounting-table--modules-head col.col-expert,
.training-standards-page .accounting-table--modules-body col.col-expert,
.academy-admin-page .accounting-table--modules-head col.col-expert,
.academy-admin-page .accounting-table--modules-body col.col-expert {
  width: 4.5rem; }

.training-standards-page .accounting-table--modules-head col.col-trainings,
.training-standards-page .accounting-table--modules-body col.col-trainings,
.academy-admin-page .accounting-table--modules-head col.col-trainings,
.academy-admin-page .accounting-table--modules-body col.col-trainings {
  width: 14rem; }

.training-standards-page .accounting-table--modules-head col.col-checklist,
.training-standards-page .accounting-table--modules-body col.col-checklist,
.academy-admin-page .accounting-table--modules-head col.col-checklist,
.academy-admin-page .accounting-table--modules-body col.col-checklist {
  width: 7rem; }

.training-standards-page .accounting-table--courses-head col.col-course,
.training-standards-page .accounting-table--courses-body col.col-course,
.academy-admin-page .accounting-table--courses-head col.col-course,
.academy-admin-page .accounting-table--courses-body col.col-course {
  width: 16%; }

.training-standards-page .accounting-table--courses-head col.col-version,
.training-standards-page .accounting-table--courses-body col.col-version,
.academy-admin-page .accounting-table--courses-head col.col-version,
.academy-admin-page .accounting-table--courses-body col.col-version {
  width: 6.5rem; }

.training-standards-page .accounting-table--courses-head col.col-description,
.training-standards-page .accounting-table--courses-body col.col-description,
.academy-admin-page .accounting-table--courses-head col.col-description,
.academy-admin-page .accounting-table--courses-body col.col-description {
  width: auto; }

.training-standards-page .accounting-table--courses-head col.col-live,
.training-standards-page .accounting-table--courses-body col.col-live,
.academy-admin-page .accounting-table--courses-head col.col-live,
.academy-admin-page .accounting-table--courses-body col.col-live {
  width: 5.5rem; }

.training-standards-page .accounting-table--courses-head col.col-actions,
.training-standards-page .accounting-table--courses-body col.col-actions,
.academy-admin-page .accounting-table--courses-head col.col-actions,
.academy-admin-page .accounting-table--courses-body col.col-actions {
  width: 5.5rem; }

.training-standards-page .accounting-table--courses-head col.col-testing,
.training-standards-page .accounting-table--courses-body col.col-testing,
.academy-admin-page .accounting-table--courses-head col.col-testing,
.academy-admin-page .accounting-table--courses-body col.col-testing {
  width: 9rem; }

.training-standards-page .accounting-table--ranks-requirements-head,
.training-standards-page .accounting-table--ranks-requirements-body,
.academy-admin-page .accounting-table--ranks-requirements-head,
.academy-admin-page .accounting-table--ranks-requirements-body {
  table-layout: fixed;
  width: 100%; }
  .training-standards-page .accounting-table--ranks-requirements-head col.col-payGrade,
  .training-standards-page .accounting-table--ranks-requirements-body col.col-payGrade,
  .academy-admin-page .accounting-table--ranks-requirements-head col.col-payGrade,
  .academy-admin-page .accounting-table--ranks-requirements-body col.col-payGrade {
    width: 3.5rem; }
  .training-standards-page .accounting-table--ranks-requirements-head col.col-rankName,
  .training-standards-page .accounting-table--ranks-requirements-body col.col-rankName,
  .academy-admin-page .accounting-table--ranks-requirements-head col.col-rankName,
  .academy-admin-page .accounting-table--ranks-requirements-body col.col-rankName {
    width: 14%; }
  .training-standards-page .accounting-table--ranks-requirements-head col.col-rankImageUrl,
  .training-standards-page .accounting-table--ranks-requirements-body col.col-rankImageUrl,
  .academy-admin-page .accounting-table--ranks-requirements-head col.col-rankImageUrl,
  .academy-admin-page .accounting-table--ranks-requirements-body col.col-rankImageUrl {
    width: 3.5rem; }
  .training-standards-page .accounting-table--ranks-requirements-head col.col-globalTokens,
  .training-standards-page .accounting-table--ranks-requirements-body col.col-globalTokens,
  .academy-admin-page .accounting-table--ranks-requirements-head col.col-globalTokens,
  .academy-admin-page .accounting-table--ranks-requirements-body col.col-globalTokens {
    width: 4.5rem; }
  .training-standards-page .accounting-table--ranks-requirements-head col.col-missionTokens,
  .training-standards-page .accounting-table--ranks-requirements-body col.col-missionTokens,
  .academy-admin-page .accounting-table--ranks-requirements-head col.col-missionTokens,
  .academy-admin-page .accounting-table--ranks-requirements-body col.col-missionTokens {
    width: 4.5rem; }
  .training-standards-page .accounting-table--ranks-requirements-head col.col-timeOnPreviousRank,
  .training-standards-page .accounting-table--ranks-requirements-body col.col-timeOnPreviousRank,
  .academy-admin-page .accounting-table--ranks-requirements-head col.col-timeOnPreviousRank,
  .academy-admin-page .accounting-table--ranks-requirements-body col.col-timeOnPreviousRank {
    width: 4.5rem; }
  .training-standards-page .accounting-table--ranks-requirements-head col.col-courseIds,
  .training-standards-page .accounting-table--ranks-requirements-head col.col-grantAccess,
  .training-standards-page .accounting-table--ranks-requirements-body col.col-courseIds,
  .training-standards-page .accounting-table--ranks-requirements-body col.col-grantAccess,
  .academy-admin-page .accounting-table--ranks-requirements-head col.col-courseIds,
  .academy-admin-page .accounting-table--ranks-requirements-head col.col-grantAccess,
  .academy-admin-page .accounting-table--ranks-requirements-body col.col-courseIds,
  .academy-admin-page .accounting-table--ranks-requirements-body col.col-grantAccess {
    width: 12rem; }
  .training-standards-page .accounting-table--ranks-requirements-head col.col-certificationIds,
  .training-standards-page .accounting-table--ranks-requirements-body col.col-certificationIds,
  .academy-admin-page .accounting-table--ranks-requirements-head col.col-certificationIds,
  .academy-admin-page .accounting-table--ranks-requirements-body col.col-certificationIds {
    width: 12rem; }
  .training-standards-page .accounting-table--ranks-requirements-head col.col-lockStatus,
  .training-standards-page .accounting-table--ranks-requirements-body col.col-lockStatus,
  .academy-admin-page .accounting-table--ranks-requirements-head col.col-lockStatus,
  .academy-admin-page .accounting-table--ranks-requirements-body col.col-lockStatus {
    width: 4rem; }

.training-standards-page .accounting-table--ranks-requirements-body tbody tr,
.academy-admin-page .accounting-table--ranks-requirements-body tbody tr {
  height: auto;
  min-height: 2.8rem; }

.training-standards-page .accounting-table--ranks-requirements-body td,
.academy-admin-page .accounting-table--ranks-requirements-body td {
  vertical-align: top;
  overflow: visible; }

.training-standards-page .accounting-table--ranks-requirements-body .cell-payGrade,
.training-standards-page .accounting-table--ranks-requirements-body .cell-rankImageUrl,
.training-standards-page .accounting-table--ranks-requirements-body .cell-lockStatus,
.training-standards-page .accounting-table--ranks-requirements-body th.header-payGrade,
.training-standards-page .accounting-table--ranks-requirements-body th.header-rankImageUrl,
.training-standards-page .accounting-table--ranks-requirements-body th.header-lockStatus,
.academy-admin-page .accounting-table--ranks-requirements-body .cell-payGrade,
.academy-admin-page .accounting-table--ranks-requirements-body .cell-rankImageUrl,
.academy-admin-page .accounting-table--ranks-requirements-body .cell-lockStatus,
.academy-admin-page .accounting-table--ranks-requirements-body th.header-payGrade,
.academy-admin-page .accounting-table--ranks-requirements-body th.header-rankImageUrl,
.academy-admin-page .accounting-table--ranks-requirements-body th.header-lockStatus {
  text-align: center;
  vertical-align: middle; }

.training-standards-page .accounting-table--ranks-requirements-body .cell-rankImageUrl img.rank-image,
.academy-admin-page .accounting-table--ranks-requirements-body .cell-rankImageUrl img.rank-image {
  max-width: 20px;
  display: block;
  margin: 0 auto; }

.training-standards-page .accounting-table--ranks-requirements-body .cell-certificationIds,
.training-standards-page .accounting-table--ranks-requirements-body .cell-courseIds,
.academy-admin-page .accounting-table--ranks-requirements-body .cell-certificationIds,
.academy-admin-page .accounting-table--ranks-requirements-body .cell-courseIds {
  overflow: hidden;
  max-width: 0; }

.training-standards-page .accounting-table--ranks-requirements-body .cell-grantAccess,
.academy-admin-page .accounting-table--ranks-requirements-body .cell-grantAccess {
  overflow: hidden;
  max-width: 0; }

.training-standards-page .accounting-table--ranks-requirements-body .certificationsSelect,
.academy-admin-page .accounting-table--ranks-requirements-body .certificationsSelect {
  min-width: 0;
  width: 100%;
  max-width: 100%; }
  .training-standards-page .accounting-table--ranks-requirements-body .certificationsSelect .hierarchy-select-container,
  .academy-admin-page .accounting-table--ranks-requirements-body .certificationsSelect .hierarchy-select-container {
    width: 100%;
    max-width: 100%;
    min-width: 0; }
  .training-standards-page .accounting-table--ranks-requirements-body .certificationsSelect .certifications-select-trigger,
  .academy-admin-page .accounting-table--ranks-requirements-body .certificationsSelect .certifications-select-trigger {
    width: 100%;
    max-width: 100%; }

.training-standards-page .accounting-table--ranks-requirements-body .cell-grantAccess .ts-select-native,
.academy-admin-page .accounting-table--ranks-requirements-body .cell-grantAccess .ts-select-native {
  width: 100%;
  max-width: 100%;
  min-width: 0; }

.training-standards-page .accounting-table--ranks-requirements-body .toggle.ranks.division,
.academy-admin-page .accounting-table--ranks-requirements-body .toggle.ranks.division {
  display: flex;
  justify-content: center;
  margin: 0 auto; }

.training-standards-page .ts-table-wrap--ranks-requirements,
.academy-admin-page .ts-table-wrap--ranks-requirements {
  overflow: visible; }

.training-standards-page .accounting-table--courses-body tr.course-row.online,
.academy-admin-page .accounting-table--courses-body tr.course-row.online {
  box-shadow: inset 0 0 0 1px rgba(117, 207, 120, 0.65); }

.training-standards-page .accounting-table--courses-body tr.course-row.offline,
.academy-admin-page .accounting-table--courses-body tr.course-row.offline {
  box-shadow: inset 0 0 0 1px rgba(155, 96, 42, 0.75); }

.training-standards-page .accounting-table--courses-body td.cell-live,
.academy-admin-page .accounting-table--courses-body td.cell-live {
  text-align: center;
  vertical-align: middle; }
  .training-standards-page .accounting-table--courses-body td.cell-live .course-live-toggle,
  .academy-admin-page .accounting-table--courses-body td.cell-live .course-live-toggle {
    margin: 0 auto; }

.training-standards-page .ts-live-users,
.academy-admin-page .ts-live-users {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem 0.5rem;
  margin-left: auto;
  font-size: 0.82rem;
  color: rgba(223, 223, 223, 0.78); }
  .training-standards-page .ts-live-users__label,
  .academy-admin-page .ts-live-users__label {
    font-size: 0.72rem;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.55); }
  .training-standards-page .ts-live-users__value,
  .academy-admin-page .ts-live-users__value {
    color: #dfdfdf; }

.training-standards-page .ts-toolbar__actions,
.academy-admin-page .ts-toolbar__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  margin-left: auto; }

.training-standards-page .ts-panel--rank-chart .admin-block-container.token-chart,
.academy-admin-page .ts-panel--rank-chart .admin-block-container.token-chart {
  margin: 0;
  padding: 0;
  min-height: 0;
  background: transparent;
  border: none;
  box-shadow: none; }
  .training-standards-page .ts-panel--rank-chart .admin-block-container.token-chart.preview,
  .academy-admin-page .ts-panel--rank-chart .admin-block-container.token-chart.preview {
    padding: 0.65rem;
    border: 1px solid #d12323;
    border-radius: 12px; }

.training-standards-page .ts-panel--ranks-requirements,
.academy-admin-page .ts-panel--ranks-requirements {
  overflow: visible; }
  .training-standards-page .ts-panel--ranks-requirements .token-table-root,
  .academy-admin-page .ts-panel--ranks-requirements .token-table-root {
    margin-top: 0.85rem; }

.ts-panel--org-ranks-table {
  overflow: visible; }
  .ts-panel--org-ranks-table .ranks-type-description {
    margin-top: 0.35rem; }
  .ts-panel--org-ranks-table .table-base.ranks {
    margin-top: 1rem; }
  .ts-panel--org-ranks-table .lexical-document-footer {
    padding: 0.75rem 0 0;
    margin-left: 0; }

.modal.create-module .create-module-dual-panel {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr);
  gap: 1rem;
  align-items: stretch;
  margin: 0 10px 1rem; }

.modal.create-module .create-module-dual-panel__col {
  display: flex;
  min-width: 0;
  width: auto; }

.modal.create-module .ts-module-block {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0.85rem 1rem;
  border-radius: 12px;
  border: 1px solid rgba(58, 120, 180, 0.35);
  background: rgba(21, 28, 36, 0.38);
  min-width: 0;
  min-height: 100%;
  box-sizing: border-box;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18); }

.modal.create-module .ts-form-grid {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  flex: 1; }

.modal.create-module .ts-field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin: 0; }

.modal.create-module .ts-field__label {
  font-size: 0.72rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.72); }

.modal.create-module .ts-select-native,
.modal.create-module .ts-module-block .ts-input {
  width: 100%;
  box-sizing: border-box;
  min-width: 0;
  padding: 0.5rem 0.7rem;
  border: 1px solid rgba(58, 120, 180, 0.62);
  border-radius: 8px;
  font-family: inherit;
  font-size: 0.84rem;
  color: #dfdfdf;
  background: rgba(30, 48, 66, 0.92);
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.22), 0 0 0 1px rgba(58, 120, 180, 0.08); }
  .modal.create-module .ts-select-native::placeholder,
  .modal.create-module .ts-module-block .ts-input::placeholder {
    color: rgba(223, 223, 223, 0.45); }
  .modal.create-module .ts-select-native:disabled,
  .modal.create-module .ts-module-block .ts-input:disabled {
    opacity: 0.55;
    cursor: not-allowed; }

.modal.create-module .ts-select-native {
  appearance: none;
  background-image: linear-gradient(45deg, transparent 50%, rgba(223, 223, 223, 0.75) 50%), linear-gradient(135deg, rgba(223, 223, 223, 0.75) 50%, transparent 50%);
  background-position: calc(100% - 16px) calc(50% - 2px), calc(100% - 11px) calc(50% - 2px);
  background-size: 5px 5px, 5px 5px;
  background-repeat: no-repeat;
  padding-right: 2rem; }
  .modal.create-module .ts-select-native option {
    background: #151c24;
    color: #dfdfdf; }

.modal.create-module .ts-checkbox-field {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.84rem;
  color: rgba(223, 223, 223, 0.88);
  cursor: pointer; }
  .modal.create-module .ts-checkbox-field input {
    accent-color: #3a78b4; }
  .modal.create-module .ts-checkbox-field input:disabled + span {
    opacity: 0.55;
    cursor: not-allowed; }

.modal.create-module .training-reference-picker .ts-toolbar {
  margin-bottom: 0.65rem; }

.modal.create-module .training-reference-picker .ts-select {
  flex: 1 1 12rem;
  min-width: 0; }

.modal.create-module .training-reference-picker .ts-table-wrap {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0; }

.modal.create-module .training-reference-picker .ts-module-block__footer {
  margin-top: auto;
  padding-top: 0.75rem; }

.modal.create-module .ts-module-block__empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 1.5rem 1rem;
  border-radius: 10px;
  border: 1px dashed rgba(58, 120, 180, 0.28);
  background: rgba(0, 48, 77, 0.28);
  font-size: 0.82rem;
  color: rgba(223, 223, 223, 0.55);
  text-align: center; }

.modal.create-module .ts-select .react-select__control {
  min-height: 2.15rem !important;
  border: 1px solid rgba(58, 120, 180, 0.62) !important;
  background: rgba(30, 48, 66, 0.92) !important;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.22), 0 0 0 1px rgba(58, 120, 180, 0.08) !important; }

.modal.create-module .ts-select .react-select__single-value,
.modal.create-module .ts-select .react-select__placeholder {
  color: #dfdfdf !important; }

.modal.create-module .ts-select .react-select__placeholder {
  color: rgba(223, 223, 223, 0.5) !important; }

.modal.create-module .ts-module-block__footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.75rem; }

.modal.create-module .accounting-table--training-refs-head col.col-label,
.modal.create-module .accounting-table--training-refs-body col.col-label {
  width: auto; }

.modal.create-module .accounting-table--training-refs-head col.col-version,
.modal.create-module .accounting-table--training-refs-body col.col-version {
  width: 5rem; }

.modal.create-module .accounting-table--training-refs-head col.col-theme,
.modal.create-module .accounting-table--training-refs-body col.col-theme {
  width: 28%; }

.modal.create-module .accounting-table--training-refs-head col.col-trainingLevel,
.modal.create-module .accounting-table--training-refs-body col.col-trainingLevel {
  width: 24%; }

.modal.create-module .accounting-table--training-refs-head col.col-actions,
.modal.create-module .accounting-table--training-refs-body col.col-actions {
  width: 3.5rem; }

.modal.create-module .ts-table-scroll--training-refs {
  flex: 1;
  max-height: none;
  min-height: 120px; }

.modal.create-module .cell-actions {
  text-align: center;
  vertical-align: middle; }

.org-positions-page .ts-page-header {
  display: flex;
  flex-direction: column;
  gap: 0.35rem; }

.org-positions-page__header {
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap; }

.org-positions-page__header-text {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 0; }

.org-positions-page__header-actions {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  flex: 1 1 auto;
  min-width: 0;
  flex-wrap: wrap; }

.org-positions-page__add-btn, .org-positions-page__hint-btn {
  flex: 0 0 auto;
  white-space: nowrap; }

.org-positions-page__add-btn:only-child, .org-positions-page__hint-btn {
  margin-left: auto; }

.org-positions-page__subtitle {
  margin: 0.15rem 0 0;
  font-size: 0.88rem;
  color: rgba(223, 223, 223, 0.72);
  max-width: 52rem; }

.org-positions-page__error {
  margin: 0 0 0.85rem;
  padding: 0.65rem 0.85rem;
  border-radius: 10px;
  border: 1px solid rgba(209, 35, 35, 0.45);
  background: rgba(73, 18, 18, 0.35);
  color: #dfdfdf; }

.org-positions-panel {
  display: flex;
  flex-direction: column;
  gap: 0.85rem; }

.org-positions-layout {
  display: flex;
  align-items: stretch;
  gap: 0.85rem;
  min-height: 0; }
  .org-positions-layout__list {
    flex: 1 1 0;
    min-width: 0; }
  .org-positions-layout__editor {
    flex: 0 0 620px;
    max-width: 55%;
    min-width: 300px; }

.org-position-editor {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: min(560px, calc(100vh - 340px));
  border-radius: 12px;
  border: 1px solid rgba(58, 120, 180, 0.28);
  background: rgba(21, 28, 36, 0.42);
  overflow: hidden; }
  .org-position-editor--empty {
    align-items: center;
    justify-content: center;
    padding: 1.5rem; }
  .org-position-editor__placeholder {
    margin: 0;
    text-align: center;
    color: rgba(223, 223, 223, 0.65);
    font-size: 0.9rem;
    line-height: 1.5; }
  .org-position-editor__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.85rem 1rem;
    border-bottom: 1px solid rgba(58, 120, 180, 0.22); }
  .org-position-editor__title {
    margin: 0;
    font-size: 0.78rem;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.78); }
  .org-position-editor__delete-hold {
    flex: 0 0 auto;
    min-height: 32px;
    padding: 0 12px;
    font-size: 0.78rem; }
  .org-position-editor__body {
    flex: 1 1 auto;
    overflow: auto;
    padding: 0.85rem 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.85rem;
    scrollbar-width: thin;
    scrollbar-color: rgba(58, 120, 180, 0.5) rgba(0, 48, 77, 0.45); }
    .org-position-editor__body::-webkit-scrollbar {
      width: 4px; }
    .org-position-editor__body::-webkit-scrollbar-track {
      background: rgba(0, 48, 77, 0.45);
      border-radius: 999px; }
    .org-position-editor__body::-webkit-scrollbar-thumb {
      background: rgba(58, 120, 180, 0.48);
      border-radius: 999px; }
      .org-position-editor__body::-webkit-scrollbar-thumb:hover {
        background: rgba(58, 120, 180, 0.65); }
  .org-position-editor__field {
    display: flex;
    flex-direction: column;
    gap: 0.35rem; }
  .org-position-editor__label {
    font-size: 0.72rem;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.62); }
  .org-position-editor__hint {
    margin: 0;
    font-size: 0.74rem;
    line-height: 1.35;
    color: rgba(223, 223, 223, 0.55); }
  .org-position-editor__copy-row {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: flex-start;
    gap: 0.75rem; }
  .org-position-editor__prerequisite {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    flex: 1 1 12rem;
    min-width: 10rem; }
  .org-position-editor__prerequisite-select {
    width: 100%; }
  .org-position-editor__logo-field {
    display: flex;
    flex-direction: column;
    gap: 0.45rem; }
  .org-position-editor__textarea {
    min-height: 6rem;
    resize: vertical; }
  .org-position-editor__section-title {
    margin: 0;
    font-size: 0.78rem;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.78); }
  .org-position-editor__list-block {
    display: flex;
    flex-direction: column;
    gap: 0.55rem; }
  .org-position-editor__list-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem; }
  .org-position-editor__add-field {
    white-space: nowrap; }
  .org-position-editor__empty-hint {
    margin: 0;
    font-size: 0.82rem;
    color: rgba(223, 223, 223, 0.55); }
  .org-position-editor__list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 0.45rem; }
  .org-position-editor__list-item {
    display: flex;
    align-items: center;
    gap: 0.4rem; }
  .org-position-editor__list-input {
    flex: 1 1 auto;
    min-width: 0; }
  .org-position-editor__list-remove {
    flex: 0 0 1.75rem;
    width: 1.75rem;
    height: 1.75rem;
    border: none;
    border-radius: 6px;
    background: rgba(209, 35, 35, 0.18);
    color: #d12323;
    font-size: 1.1rem;
    line-height: 1;
    cursor: pointer; }
    .org-position-editor__list-remove:hover:not(:disabled) {
      background: rgba(209, 35, 35, 0.32); }
    .org-position-editor__list-remove:disabled {
      opacity: 0.5;
      cursor: not-allowed; }
  .org-position-editor__error {
    margin: 0;
    padding: 0.55rem 0.7rem;
    border-radius: 8px;
    border: 1px solid rgba(209, 35, 35, 0.45);
    background: rgba(73, 18, 18, 0.35);
    color: #dfdfdf;
    font-size: 0.84rem; }
  .org-position-editor__footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.55rem;
    padding: 0.75rem 1rem;
    border-top: 1px solid rgba(58, 120, 180, 0.22); }

.org-position-logo-manage {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.65rem 0.75rem;
  border-radius: 10px;
  border: 1px solid rgba(58, 120, 180, 0.22);
  background: rgba(0, 48, 77, 0.28); }
  .org-position-logo-manage__preview-wrap, .org-position-logo-manage__placeholder {
    flex: 0 0 50px;
    width: 50px;
    height: 50px;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid rgba(58, 120, 180, 0.35);
    background: rgba(56, 72, 88, 0.55); }
  .org-position-logo-manage__preview {
    display: block;
    width: 50px;
    height: 50px;
    object-fit: cover; }
  .org-position-logo-manage__placeholder {
    position: relative; }
    .org-position-logo-manage__placeholder::after {
      content: '';
      position: absolute;
      inset: 14px;
      border-radius: 4px;
      border: 1px dashed rgba(223, 223, 223, 0.35); }
  .org-position-logo-manage__actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.45rem; }
  .org-position-logo-manage__btn {
    min-height: 32px;
    padding: 0 12px;
    font-size: 0.78rem; }

.org-position-logo-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1210;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(0, 48, 77, 0.72); }

.org-position-logo-modal {
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  border-radius: 14px;
  border: 1px solid rgba(58, 120, 180, 0.35);
  background: rgba(21, 28, 36, 0.98);
  overflow: hidden;
  box-shadow: 0 20px 52px rgba(0, 0, 0, 0.5); }
  .org-position-logo-modal__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.9rem 1rem;
    border-bottom: 1px solid rgba(58, 120, 180, 0.22); }
  .org-position-logo-modal__title {
    margin: 0;
    font-size: 0.9rem;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.88); }
  .org-position-logo-modal__close {
    width: 2rem;
    height: 2rem;
    border: none;
    border-radius: 8px;
    background: rgba(56, 72, 88, 0.65);
    color: #dfdfdf;
    font-size: 1.25rem;
    line-height: 1;
    cursor: pointer; }
    .org-position-logo-modal__close:disabled {
      opacity: 0.5;
      cursor: not-allowed; }
    .org-position-logo-modal__close:hover:not(:disabled) {
      background: rgba(58, 120, 180, 0.45); }
  .org-position-logo-modal__body {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding: 1rem; }
  .org-position-logo-modal__hint {
    margin: 0;
    font-size: 0.78rem;
    color: rgba(223, 223, 223, 0.55); }
  .org-position-logo-modal__dropzone {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 168px;
    padding: 1rem;
    border-radius: 12px;
    border: 1.5px dashed rgba(58, 120, 180, 0.4);
    background: rgba(0, 48, 77, 0.35);
    transition: border-color 0.15s ease, background 0.15s ease; }
    .org-position-logo-modal__dropzone.is-dragover {
      border-color: rgba(58, 120, 180, 0.85);
      background: rgba(58, 120, 180, 0.18); }
    .org-position-logo-modal__dropzone.has-preview {
      border-style: solid;
      border-color: rgba(58, 120, 180, 0.35); }
  .org-position-logo-modal__preview {
    max-width: 140px;
    max-height: 140px;
    width: auto;
    height: auto;
    border-radius: 10px;
    object-fit: contain; }
  .org-position-logo-modal__drop-copy {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.35rem;
    text-align: center; }
  .org-position-logo-modal__drop-glyph {
    display: block;
    width: 2.25rem;
    height: 2.25rem;
    margin-bottom: 0.25rem;
    border-radius: 999px;
    border: 1px solid rgba(58, 120, 180, 0.45);
    background: rgba(58, 120, 180, 0.15);
    position: relative; }
    .org-position-logo-modal__drop-glyph::before {
      content: '';
      position: absolute;
      left: 50%;
      top: 42%;
      width: 0.7rem;
      height: 0.7rem;
      border-right: 2px solid rgba(223, 223, 223, 0.8);
      border-bottom: 2px solid rgba(223, 223, 223, 0.8);
      transform: translate(-50%, -60%) rotate(45deg); }
  .org-position-logo-modal__drop-title {
    margin: 0;
    font-size: 0.92rem;
    color: rgba(223, 223, 223, 0.9); }
  .org-position-logo-modal__drop-sub {
    margin: 0;
    font-size: 0.78rem;
    color: rgba(223, 223, 223, 0.55); }
  .org-position-logo-modal__actions-row {
    display: flex;
    justify-content: center; }
  .org-position-logo-modal__file-input {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0; }
  .org-position-logo-modal__error {
    margin: 0;
    padding: 0.55rem 0.7rem;
    border-radius: 8px;
    border: 1px solid rgba(209, 35, 35, 0.45);
    background: rgba(73, 18, 18, 0.35);
    color: #dfdfdf;
    font-size: 0.84rem; }
  .org-position-logo-modal__footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.55rem;
    padding: 0.75rem 1rem;
    border-top: 1px solid rgba(58, 120, 180, 0.22); }

.org-position-apply-hint-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1220;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(0, 48, 77, 0.72); }

.org-position-apply-hint-modal {
  width: 100%;
  max-width: 720px;
  max-height: min(90vh, 760px);
  display: flex;
  flex-direction: column;
  border-radius: 14px;
  border: 1px solid rgba(58, 120, 180, 0.35);
  background: rgba(21, 28, 36, 0.98);
  overflow: hidden;
  box-shadow: 0 20px 52px rgba(0, 0, 0, 0.5); }
  .org-position-apply-hint-modal__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.9rem 1rem;
    border-bottom: 1px solid rgba(58, 120, 180, 0.22); }
  .org-position-apply-hint-modal__title {
    margin: 0;
    font-size: 0.9rem;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.88); }
  .org-position-apply-hint-modal__close {
    width: 2rem;
    height: 2rem;
    border: none;
    border-radius: 8px;
    background: rgba(56, 72, 88, 0.65);
    color: #dfdfdf;
    font-size: 1.25rem;
    line-height: 1;
    cursor: pointer; }
    .org-position-apply-hint-modal__close:disabled {
      opacity: 0.5;
      cursor: not-allowed; }
    .org-position-apply-hint-modal__close:hover:not(:disabled) {
      background: rgba(58, 120, 180, 0.45); }
  .org-position-apply-hint-modal__body {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding: 1rem;
    min-height: 0;
    overflow: auto; }
  .org-position-apply-hint-modal__hint {
    margin: 0;
    font-size: 0.78rem;
    color: rgba(223, 223, 223, 0.55); }
  .org-position-apply-hint-modal__loading {
    margin: 0;
    padding: 1.5rem 0;
    text-align: center;
    font-size: 0.88rem;
    color: rgba(223, 223, 223, 0.65); }
  .org-position-apply-hint-modal__editor {
    min-height: 220px;
    border-radius: 10px;
    border: 1px solid rgba(58, 120, 180, 0.28);
    background: rgba(0, 48, 77, 0.28);
    overflow: hidden; }
    .org-position-apply-hint-modal__editor .lexical-container {
      min-height: 220px; }
  .org-position-apply-hint-modal__error {
    margin: 0;
    padding: 0.55rem 0.7rem;
    border-radius: 8px;
    border: 1px solid rgba(209, 35, 35, 0.45);
    background: rgba(73, 18, 18, 0.35);
    color: #dfdfdf;
    font-size: 0.84rem; }
  .org-position-apply-hint-modal__footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.55rem;
    padding: 0.75rem 1rem;
    border-top: 1px solid rgba(58, 120, 180, 0.22); }

.org-position-copy-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(0, 48, 77, 0.72); }

.org-position-copy-modal {
  width: 100%;
  max-width: 520px;
  max-height: min(88vh, 720px);
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  border: 1px solid rgba(58, 120, 180, 0.35);
  background: rgba(21, 28, 36, 0.97);
  overflow: hidden;
  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.45); }
  .org-position-copy-modal__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.85rem 1rem;
    border-bottom: 1px solid rgba(58, 120, 180, 0.22); }
  .org-position-copy-modal__title {
    margin: 0;
    font-size: 0.95rem;
    color: #dfdfdf; }
  .org-position-copy-modal__close {
    border: none;
    background: transparent;
    color: rgba(223, 223, 223, 0.75);
    font-size: 1.4rem;
    line-height: 1;
    cursor: pointer;
    padding: 0.15rem 0.35rem; }
    .org-position-copy-modal__close:hover:not(:disabled) {
      color: #dfdfdf; }
    .org-position-copy-modal__close:disabled {
      opacity: 0.5;
      cursor: not-allowed; }
  .org-position-copy-modal__body {
    display: flex;
    flex-direction: column;
    gap: 0.85rem;
    padding: 0.9rem 1rem 1rem;
    overflow: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(58, 120, 180, 0.5) rgba(0, 48, 77, 0.45); }
    .org-position-copy-modal__body::-webkit-scrollbar {
      width: 4px; }
    .org-position-copy-modal__body::-webkit-scrollbar-track {
      background: rgba(0, 48, 77, 0.45);
      border-radius: 999px; }
    .org-position-copy-modal__body::-webkit-scrollbar-thumb {
      background: rgba(58, 120, 180, 0.48);
      border-radius: 999px; }
      .org-position-copy-modal__body::-webkit-scrollbar-thumb:hover {
        background: rgba(58, 120, 180, 0.65); }
  .org-position-copy-modal__field, .org-position-copy-modal__fieldset, .org-position-copy-modal__targets {
    display: flex;
    flex-direction: column;
    gap: 0.4rem; }
  .org-position-copy-modal__fieldset {
    margin: 0;
    padding: 0.65rem 0.75rem;
    border-radius: 10px;
    border: 1px solid rgba(58, 120, 180, 0.25);
    background: rgba(0, 48, 77, 0.28); }
  .org-position-copy-modal__label {
    font-size: 0.72rem;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.62); }
  .org-position-copy-modal__check {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    font-size: 0.86rem;
    color: rgba(223, 223, 223, 0.9);
    cursor: pointer; }
    .org-position-copy-modal__check input {
      margin-top: 0.15rem; }
  .org-position-copy-modal__target-label {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.35rem 0.5rem;
    min-width: 0; }
  .org-position-copy-modal__target-name {
    word-break: break-word; }
  .org-position-copy-modal__level {
    display: inline-flex;
    align-items: center;
    padding: 0.1rem 0.4rem;
    border-radius: 999px;
    font-size: 0.66rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    border: 1px solid rgba(58, 120, 180, 0.35);
    background: rgba(58, 120, 180, 0.16);
    color: #5ac3ff; }
    .org-position-copy-modal__level--division {
      border-color: rgba(90, 195, 255, 0.35);
      background: rgba(0, 72, 114, 0.35); }
    .org-position-copy-modal__level--branch {
      border-color: rgba(154, 128, 227, 0.35);
      background: rgba(154, 128, 227, 0.12);
      color: #9a80e3; }
    .org-position-copy-modal__level--section {
      border-color: rgba(117, 207, 120, 0.35);
      background: rgba(63, 124, 66, 0.22);
      color: #75cf78; }
    .org-position-copy-modal__level--custom {
      border-color: rgba(154, 128, 227, 0.4);
      background: rgba(154, 128, 227, 0.14);
      color: #9a80e3; }
  .org-position-copy-modal__targets-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.55rem;
    flex-wrap: wrap; }
  .org-position-copy-modal__targets-actions {
    display: flex;
    gap: 0.4rem;
    flex-wrap: wrap; }
  .org-position-copy-modal__filter {
    width: 100%; }
  .org-position-copy-modal__target-list {
    max-height: 220px;
    overflow: auto;
    padding: 0.55rem 0.65rem;
    border-radius: 10px;
    border: 1px solid rgba(58, 120, 180, 0.22);
    background: rgba(0, 48, 77, 0.22);
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    scrollbar-width: thin;
    scrollbar-color: rgba(58, 120, 180, 0.5) rgba(0, 48, 77, 0.45); }
    .org-position-copy-modal__target-list::-webkit-scrollbar {
      width: 4px; }
    .org-position-copy-modal__target-list::-webkit-scrollbar-track {
      background: rgba(0, 48, 77, 0.45);
      border-radius: 999px; }
    .org-position-copy-modal__target-list::-webkit-scrollbar-thumb {
      background: rgba(58, 120, 180, 0.48);
      border-radius: 999px; }
      .org-position-copy-modal__target-list::-webkit-scrollbar-thumb:hover {
        background: rgba(58, 120, 180, 0.65); }
  .org-position-copy-modal__empty, .org-position-copy-modal__hint {
    margin: 0;
    font-size: 0.78rem;
    color: rgba(223, 223, 223, 0.58); }
  .org-position-copy-modal__error {
    margin: 0;
    padding: 0.55rem 0.7rem;
    border-radius: 8px;
    border: 1px solid rgba(209, 35, 35, 0.45);
    background: rgba(73, 18, 18, 0.35);
    color: #dfdfdf;
    font-size: 0.84rem; }
  .org-position-copy-modal__footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.55rem;
    padding-top: 0.25rem; }

.officer-cadet-progression-page .ts-page-header {
  display: flex;
  flex-direction: column;
  gap: 0.35rem; }

.officer-cadet-progression-page__subtitle {
  margin: 0.15rem 0 0;
  font-size: 0.88rem;
  color: rgba(223, 223, 223, 0.72);
  max-width: 52rem; }

.officer-cadet-progression-page__placeholder {
  margin: 0;
  color: rgba(223, 223, 223, 0.78);
  font-size: 0.9rem;
  line-height: 1.55; }

.officer-cadet-progression-panel {
  padding: 1rem 1.1rem; }

.org-positions-kpi {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.85rem 1rem;
  padding: 0.85rem 1rem;
  border-radius: 12px;
  border: 1px solid rgba(58, 120, 180, 0.28);
  background: rgba(21, 28, 36, 0.38); }
  .org-positions-kpi__metrics {
    display: flex;
    flex-wrap: wrap;
    gap: 0.65rem 1rem; }
  .org-positions-kpi__metric {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
    min-width: 5.5rem;
    padding: 0.45rem 0.75rem;
    border-radius: 10px;
    border: 1px solid rgba(58, 120, 180, 0.22);
    background: rgba(0, 48, 77, 0.45); }
    .org-positions-kpi__metric--filled {
      border-color: rgba(117, 207, 120, 0.35);
      background: rgba(42, 95, 45, 0.28); }
    .org-positions-kpi__metric--open {
      border-color: rgba(199, 132, 69, 0.35);
      background: rgba(110, 68, 28, 0.22); }
  .org-positions-kpi__metric-value {
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 1;
    color: #dfdfdf; }
  .org-positions-kpi__metric-label {
    font-size: 0.72rem;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(223, 223, 223, 0.62); }
  .org-positions-kpi__controls {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.55rem 0.75rem;
    flex: 1 1 18rem;
    justify-content: flex-end; }
  .org-positions-kpi__search {
    flex: 1 1 12rem;
    max-width: 18rem; }
  .org-positions-kpi__toggle {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.84rem;
    color: rgba(223, 223, 223, 0.85);
    cursor: pointer;
    user-select: none; }
  .org-positions-kpi__btn {
    white-space: nowrap; }

.org-positions-table {
  border-radius: 12px;
  border: 1px solid rgba(58, 120, 180, 0.28);
  background: rgba(21, 28, 36, 0.28);
  overflow: auto;
  max-height: min(560px, calc(100vh - 340px));
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 120, 180, 0.5) rgba(0, 48, 77, 0.45); }
  .org-positions-table::-webkit-scrollbar {
    width: 4px; }
  .org-positions-table::-webkit-scrollbar-track {
    background: rgba(0, 48, 77, 0.45);
    border-radius: 999px; }
  .org-positions-table::-webkit-scrollbar-thumb {
    background: rgba(58, 120, 180, 0.48);
    border-radius: 999px; }
    .org-positions-table::-webkit-scrollbar-thumb:hover {
      background: rgba(58, 120, 180, 0.65); }
  .org-positions-table--loading, .org-positions-table--empty {
    padding: 2rem 1rem;
    text-align: center;
    color: rgba(223, 223, 223, 0.72); }
  .org-positions-table--compact .org-positions-table__grid {
    min-width: 0; }
    .org-positions-table--compact .org-positions-table__grid col.col-org-positions-unit {
      width: auto; }
    .org-positions-table--compact .org-positions-table__grid col.col-org-positions-level {
      width: 5.5rem; }
    .org-positions-table--compact .org-positions-table__grid col.col-org-positions-avatar {
      width: 2.75rem; }
  .org-positions-table--compact .org-positions-table__avatar-head,
  .org-positions-table--compact .org-positions-row__avatar {
    padding-left: 0.35rem;
    padding-right: 0.45rem;
    text-align: center; }
  .org-positions-table--compact .org-positions-unit[data-depth='2'] {
    padding-left: 0.85rem; }
  .org-positions-table--compact .org-positions-unit[data-depth='3'] {
    padding-left: 1.6rem; }
  .org-positions-table--compact .org-positions-unit[data-depth='4'] {
    padding-left: 2.35rem; }
  .org-positions-table--compact .org-positions-unit__logo, .org-positions-table--compact .org-positions-unit__logo-fallback {
    flex: 0 0 1.65rem;
    width: 1.65rem;
    height: 1.65rem;
    border-radius: 6px; }
  .org-positions-table--compact .org-positions-unit__name {
    font-size: 0.84rem; }
  .org-positions-table--compact .org-positions-unit__short {
    font-size: 0.7rem; }
  .org-positions-table--compact .org-positions-level {
    font-size: 0.66rem;
    padding: 0.15rem 0.4rem; }
  .org-positions-table__grid {
    width: 100%;
    border-collapse: collapse;
    min-width: 720px; }
    .org-positions-table__grid col.col-org-positions-unit {
      width: 34%; }
    .org-positions-table__grid col.col-org-positions-level {
      width: 12%; }
    .org-positions-table__grid col.col-org-positions-commander {
      width: 38%; }
    .org-positions-table__grid col.col-org-positions-status {
      width: 16%; }
    .org-positions-table__grid thead th {
      position: sticky;
      top: 0;
      z-index: 1;
      padding: 0.75rem 0.85rem;
      text-align: left;
      font-size: 0.72rem;
      letter-spacing: 0.07em;
      text-transform: uppercase;
      color: rgba(223, 223, 223, 0.72);
      background: rgba(0, 48, 77, 0.92);
      border-bottom: 1px solid rgba(58, 120, 180, 0.32); }
    .org-positions-table__grid tbody td {
      padding: 0.65rem 0.85rem;
      vertical-align: middle;
      border-bottom: 1px solid rgba(58, 120, 180, 0.14); }

.org-positions-avatar-cell {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem; }
  .org-positions-avatar-cell--empty {
    opacity: 0.35; }
  .org-positions-avatar-cell__img {
    width: 1.75rem;
    height: 1.75rem;
    border-radius: 50%;
    object-fit: cover;
    border: 1px solid rgba(90, 195, 255, 0.35);
    background: rgba(0, 48, 77, 0.45); }

.org-positions-row {
  border-left: 3px solid var(--org-positions-accent, rgba(58, 120, 180, 0.35));
  transition: background 0.15s ease;
  cursor: pointer; }
  .org-positions-row:hover {
    background: rgba(58, 120, 180, 0.08); }
  .org-positions-row.is-selected {
    background: rgba(58, 120, 180, 0.16) !important;
    box-shadow: inset 3px 0 0 #3a78b4; }
  .org-positions-row--open {
    background: rgba(110, 68, 28, 0.08); }
  .org-positions-row--custom {
    background: rgba(154, 128, 227, 0.06); }
  .org-positions-row--redacted {
    opacity: 0.72; }

.org-positions-unit {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  min-width: 0; }
  .org-positions-unit[data-depth='1'] {
    padding-left: 0; }
  .org-positions-unit[data-depth='2'] {
    padding-left: 1.25rem; }
  .org-positions-unit[data-depth='3'] {
    padding-left: 2.5rem; }
  .org-positions-unit[data-depth='4'] {
    padding-left: 3.75rem; }
  .org-positions-unit__toggle, .org-positions-unit__toggle-spacer {
    flex: 0 0 1.25rem;
    width: 1.25rem;
    height: 1.25rem; }
  .org-positions-unit__toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: none;
    border-radius: 6px;
    background: rgba(58, 120, 180, 0.18);
    color: #dfdfdf;
    cursor: pointer;
    transition: transform 0.15s ease, background 0.15s ease; }
    .org-positions-unit__toggle.is-collapsed {
      transform: rotate(-90deg); }
    .org-positions-unit__toggle:hover {
      background: rgba(58, 120, 180, 0.32); }
  .org-positions-unit__logo, .org-positions-unit__logo-fallback {
    flex: 0 0 2rem;
    width: 2rem;
    height: 2rem;
    border-radius: 8px;
    object-fit: cover; }
  .org-positions-unit__logo-fallback {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.82rem;
    font-weight: 700;
    color: #dfdfdf;
    background: rgba(58, 120, 180, 0.28);
    border: 1px solid rgba(58, 120, 180, 0.35); }
    .org-positions-unit__logo-fallback--custom {
      background: rgba(154, 128, 227, 0.22);
      border-color: rgba(154, 128, 227, 0.4);
      color: #9a80e3; }
  .org-positions-unit__text {
    display: flex;
    flex-direction: column;
    gap: 0.1rem;
    min-width: 0; }
  .org-positions-unit__name {
    font-size: 0.92rem;
    font-weight: 600;
    color: #dfdfdf;
    word-break: break-word; }
  .org-positions-unit__short {
    font-size: 0.76rem;
    color: rgba(223, 223, 223, 0.58);
    letter-spacing: 0.04em;
    text-transform: uppercase; }

.org-positions-level {
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  border: 1px solid rgba(58, 120, 180, 0.35);
  background: rgba(58, 120, 180, 0.18);
  color: #5ac3ff; }
  .org-positions-level--division {
    border-color: rgba(90, 195, 255, 0.35);
    background: rgba(0, 72, 114, 0.35); }
  .org-positions-level--branch {
    border-color: rgba(154, 128, 227, 0.35);
    background: rgba(154, 128, 227, 0.12);
    color: #9a80e3; }
  .org-positions-level--section {
    border-color: rgba(117, 207, 120, 0.35);
    background: rgba(63, 124, 66, 0.22);
    color: #75cf78; }
  .org-positions-level--custom {
    border-color: rgba(154, 128, 227, 0.4);
    background: rgba(154, 128, 227, 0.14);
    color: #9a80e3; }

.org-positions-commander {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  min-width: 0; }
  .org-positions-commander--open {
    color: rgba(216, 180, 147, 0.95); }
  .org-positions-commander--redacted {
    color: rgba(223, 223, 223, 0.55);
    font-style: italic; }
  .org-positions-commander__avatar {
    flex: 0 0 2.25rem;
    width: 2.25rem;
    height: 2.25rem;
    border-radius: 50%;
    object-fit: cover;
    border: 1px solid rgba(90, 195, 255, 0.35);
    background: rgba(0, 48, 77, 0.45); }
  .org-positions-commander__text {
    display: flex;
    flex-direction: column;
    gap: 0.08rem;
    min-width: 0; }
  .org-positions-commander__monicker {
    font-size: 0.9rem;
    font-weight: 600;
    color: #dfdfdf; }
  .org-positions-commander__discord-name {
    font-size: 0.82rem;
    color: rgba(223, 223, 223, 0.78); }
  .org-positions-commander__role, .org-positions-commander__since {
    font-size: 0.74rem;
    color: rgba(223, 223, 223, 0.58); }
  .org-positions-commander__vacant-icon {
    flex: 0 0 2.25rem;
    width: 2.25rem;
    height: 2.25rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 1px dashed rgba(199, 132, 69, 0.55);
    color: rgba(199, 132, 69, 0.9);
    font-size: 1rem; }
  .org-positions-commander__vacant-title {
    font-size: 0.88rem;
    font-weight: 600;
    color: rgba(216, 180, 147, 0.95); }
  .org-positions-commander__vacant-sub {
    font-size: 0.76rem;
    color: rgba(223, 223, 223, 0.58); }

.org-positions-status {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.8rem;
  font-weight: 600; }
  .org-positions-status__dot {
    width: 0.55rem;
    height: 0.55rem;
    border-radius: 50%; }
  .org-positions-status--filled {
    color: #75cf78; }
    .org-positions-status--filled .org-positions-status__dot {
      background: #75cf78;
      box-shadow: 0 0 0 3px rgba(117, 207, 120, 0.18); }
  .org-positions-status--open {
    color: rgba(216, 180, 147, 0.95); }
    .org-positions-status--open .org-positions-status__dot {
      background: #c78445;
      box-shadow: 0 0 0 3px rgba(199, 132, 69, 0.18); }
  .org-positions-status--custom {
    color: rgba(154, 128, 227, 0.95); }
    .org-positions-status--custom .org-positions-status__dot {
      background: #9a80e3;
      box-shadow: 0 0 0 3px rgba(154, 128, 227, 0.18); }

@media (max-width: 960px) {
  .org-positions-kpi__controls {
    justify-content: flex-start; }
  .org-positions-kpi__search {
    max-width: none;
    flex-basis: 100%; }
  .org-positions-layout {
    flex-direction: column; }
    .org-positions-layout__editor {
      flex: 1 1 auto;
      max-width: none;
      min-width: 0; }
  .org-position-editor {
    max-height: none; } }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.event-auction-page {
  min-height: 280px;
  /* Unified PI cost control on loot rows (− value +) */
  /* Auction-only ScItemChip variant — base is 11px; +2px here. Benefits chips unchanged. */ }
  .event-auction-page .event-auction-page-header {
    display: flex;
    align-items: center;
    gap: 0.85rem;
    padding: 0.55rem 0.85rem;
    margin: 0 0 0.35rem; }
  .event-auction-page .event-auction-page-header__pi-icon {
    flex: 0 0 auto;
    width: 3.35rem;
    height: 3.35rem;
    margin: 0.15rem 0;
    object-fit: contain;
    border-radius: 10px; }
    .event-auction-page .event-auction-page-header__pi-icon--placeholder {
      background: linear-gradient(135deg, rgba(21, 28, 36, 0.55), rgba(0, 48, 77, 0.35)); }
  .event-auction-page .event-auction-page-header__titles {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 0;
    flex: 1 1 auto; }
    .event-auction-page .event-auction-page-header__titles .ts-page-header__eyebrow {
      margin-bottom: 0.2rem; }
    .event-auction-page .event-auction-page-header__titles .ts-page-header__title {
      font-size: clamp(1rem, 1.6vw, 1.2rem); }
  .event-auction-page .event-auction-pi-value {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    flex: 0 0 auto;
    font-variant-numeric: tabular-nums;
    white-space: nowrap; }
  .event-auction-page .event-auction-pi-value__icon {
    width: 1.65rem;
    height: 1.65rem;
    object-fit: contain;
    border-radius: 4px;
    flex: 0 0 auto; }
  .event-auction-page .event-auction-pi-value__amount {
    font-weight: 700;
    font-size: 0.98rem;
    color: rgba(223, 223, 223, 0.96); }
  .event-auction-page .event-auction-pi-value__unit {
    font-weight: 700;
    font-size: 0.86rem;
    letter-spacing: 0.12em;
    color: rgba(223, 223, 223, 0.82); }
  .event-auction-page .event-auction-pi-cost {
    display: inline-flex;
    align-items: stretch;
    flex: 0 0 auto;
    min-height: 2.75rem;
    border-radius: 10px;
    border: 1px solid rgba(58, 120, 180, 0.38);
    background: linear-gradient(180deg, rgba(21, 28, 36, 0.5), rgba(0, 48, 77, 0.72)), rgba(0, 48, 77, 0.55);
    box-shadow: 0 0 0 1px rgba(58, 120, 180, 0.06), 0 6px 14px rgba(0, 0, 0, 0.18);
    overflow: hidden; }
  .event-auction-page .event-auction-pi-cost__btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    margin: 0;
    padding: 0;
    border: 0;
    background: rgba(255, 255, 255, 0.04);
    color: rgba(223, 223, 223, 0.92);
    font-size: 1rem;
    font-weight: 600;
    line-height: 1;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease; }
    .event-auction-page .event-auction-pi-cost__btn:hover, .event-auction-page .event-auction-pi-cost__btn:focus-visible {
      background: rgba(58, 120, 180, 0.28);
      color: #ffffff;
      outline: none; }
    .event-auction-page .event-auction-pi-cost__btn:active {
      background: rgba(58, 120, 180, 0.4); }
  .event-auction-page .event-auction-pi-cost__btn--minus {
    border-right: 1px solid rgba(58, 120, 180, 0.22); }
  .event-auction-page .event-auction-pi-cost__btn--plus {
    border-left: 1px solid rgba(58, 120, 180, 0.22); }
  .event-auction-page .event-auction-pi-cost__value.event-auction-pi-value {
    gap: 0.45rem;
    min-width: 4.75rem;
    padding: 0 0.75rem;
    justify-content: center;
    background: rgba(255, 255, 255, 0.03); }
  .event-auction-page .event-auction-pi-cost__value .event-auction-pi-value__icon {
    height: 1.65rem;
    width: 1.65rem;
    border-radius: 5px; }
  .event-auction-page .event-auction-pi-cost__value .event-auction-pi-value__amount {
    font-size: 1.05rem;
    font-weight: 700;
    letter-spacing: 0.01em;
    color: #ffffff; }
  .event-auction-page .event-auction-pi-cost__value .event-auction-pi-value__unit {
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.14em;
    color: rgba(58, 120, 180, 0.95); }
  .event-auction-page .event-auction-pi-stepper {
    display: inline-flex;
    flex-direction: column;
    gap: 0.2rem;
    flex: 0 0 auto; }
  .event-auction-page .event-auction-pi-stepper__btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.35rem;
    height: 1.1rem;
    padding: 0;
    border-radius: 5px;
    border: 1px solid rgba(58, 120, 180, 0.45);
    background: rgba(0, 48, 77, 0.72);
    color: #dfdfdf;
    font-size: 0.78rem;
    font-weight: 700;
    line-height: 1;
    cursor: pointer; }
    .event-auction-page .event-auction-pi-stepper__btn:hover, .event-auction-page .event-auction-pi-stepper__btn:focus-visible {
      border-color: rgba(58, 120, 180, 0.8);
      background: rgba(58, 120, 180, 0.22); }
  .event-auction-page .event-auction-toolbar {
    justify-content: flex-end; }
    .event-auction-page .event-auction-toolbar .ts-toolbar__actions {
      margin-left: auto;
      display: flex;
      flex-wrap: wrap;
      gap: 0.5rem; }
  .event-auction-page .event-auction-status {
    margin: 0 0 0.55rem;
    color: rgba(223, 223, 223, 0.78);
    font-size: 0.88rem; }
    .event-auction-page .event-auction-status--error {
      color: #9e2222; }
  .event-auction-page .event-auction-view {
    display: flex;
    flex-direction: column;
    gap: 0.85rem;
    min-height: 8rem; }
  .event-auction-page .event-auction-loot-actions {
    display: flex;
    flex-direction: column;
    gap: 0.35rem; }
  .event-auction-page .event-auction-loot-mention-wrap {
    position: relative;
    width: 100%;
    max-width: 42rem; }
  .event-auction-page .event-auction-loot-input-shell {
    display: flex;
    align-items: center;
    gap: 0.55rem;
    padding: 0.55rem 0.8rem;
    border-radius: 12px;
    border: 1px solid rgba(58, 120, 180, 0.28);
    background: linear-gradient(180deg, rgba(21, 28, 36, 0.42), rgba(0, 48, 77, 0.55)), rgba(0, 48, 77, 0.7);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
    transition: border-color 0.15s ease, box-shadow 0.15s ease; }
    .event-auction-page .event-auction-loot-input-shell:focus-within {
      border-color: rgba(58, 120, 180, 0.7);
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05), 0 0 0 3px rgba(58, 120, 180, 0.16); }
    .event-auction-page .event-auction-loot-input-shell--locked {
      opacity: 0.55;
      pointer-events: none; }
  .event-auction-page .event-auction-loot-search-icon {
    display: inline-flex;
    color: rgba(223, 223, 223, 0.55);
    flex: 0 0 auto; }
  .event-auction-page .event-auction-loot-input-shell:focus-within .event-auction-loot-search-icon {
    color: rgba(58, 120, 180, 0.95); }
  .event-auction-page .event-auction-loot-search-icon__svg {
    width: 1rem;
    height: 1rem; }
  .event-auction-page .event-auction-loot-search-input {
    flex: 1 1 auto;
    min-width: 0;
    border: 0 !important;
    outline: none !important;
    background: transparent !important;
    box-shadow: none !important;
    padding: 0.2rem 0 !important;
    margin: 0;
    font-family: inherit;
    font-size: 0.9rem;
    color: #dfdfdf;
    caret-color: #3a78b4; }
    .event-auction-page .event-auction-loot-search-input::placeholder {
      color: rgba(223, 223, 223, 0.42); }
    .event-auction-page .event-auction-loot-search-input:focus {
      border: 0 !important;
      outline: none !important;
      box-shadow: none !important; }
  .event-auction-page .event-auction-loot-search-hint {
    margin-top: 0.35rem;
    font-size: 0.78rem;
    color: rgba(223, 223, 223, 0.55); }
  .event-auction-page .event-auction-loot-dropdown {
    position: absolute;
    z-index: 40;
    top: calc(100% + 0.35rem);
    left: 0;
    right: 0;
    margin: 0;
    padding: 0.35rem;
    list-style: none;
    max-height: 16rem;
    overflow-y: auto;
    overflow-x: hidden;
    border-radius: 12px;
    border: 1px solid rgba(58, 120, 180, 0.4);
    background: rgba(0, 48, 77, 0.96);
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.35);
    scrollbar-width: thin;
    scrollbar-color: rgba(58, 120, 180, 0.5) rgba(0, 48, 77, 0.45); }
    .event-auction-page .event-auction-loot-dropdown::-webkit-scrollbar {
      width: 4px; }
    .event-auction-page .event-auction-loot-dropdown::-webkit-scrollbar-track {
      background: rgba(0, 48, 77, 0.45);
      border-radius: 999px; }
    .event-auction-page .event-auction-loot-dropdown::-webkit-scrollbar-thumb {
      background: rgba(58, 120, 180, 0.48);
      border-radius: 999px; }
      .event-auction-page .event-auction-loot-dropdown::-webkit-scrollbar-thumb:hover {
        background: rgba(58, 120, 180, 0.65); }
  .event-auction-page .event-auction-loot-dropdown__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.55rem 0.65rem;
    border-radius: 8px;
    cursor: pointer; }
    .event-auction-page .event-auction-loot-dropdown__item.is-selected, .event-auction-page .event-auction-loot-dropdown__item:hover {
      background: rgba(58, 120, 180, 0.22); }
  .event-auction-page .event-auction-loot-dropdown__main {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
    min-width: 0; }
  .event-auction-page .event-auction-loot-dropdown__label {
    font-size: 0.86rem;
    color: #dfdfdf;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; }
  .event-auction-page .event-auction-loot-dropdown__meta {
    font-size: 0.72rem;
    color: rgba(223, 223, 223, 0.55);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; }
  .event-auction-page .event-auction-loot-dropdown__credit {
    flex: 0 0 auto; }
  .event-auction-page .event-auction-loot-list {
    list-style: none;
    margin: 0;
    padding: 0 0.15rem 0 0;
    display: flex;
    flex-direction: column;
    gap: 0.65rem;
    height: calc(100vh - 555px);
    min-height: 8rem;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
    scrollbar-color: rgba(58, 120, 180, 0.5) rgba(0, 48, 77, 0.45); }
    .event-auction-page .event-auction-loot-list::-webkit-scrollbar {
      width: 4px; }
    .event-auction-page .event-auction-loot-list::-webkit-scrollbar-track {
      background: rgba(0, 48, 77, 0.45);
      border-radius: 999px; }
    .event-auction-page .event-auction-loot-list::-webkit-scrollbar-thumb {
      background: rgba(58, 120, 180, 0.48);
      border-radius: 999px; }
      .event-auction-page .event-auction-loot-list::-webkit-scrollbar-thumb:hover {
        background: rgba(58, 120, 180, 0.65); }
  .event-auction-page .event-auction-loot-list__empty {
    padding: 0.85rem 0.95rem;
    border-radius: 10px;
    border: 1px dashed rgba(58, 120, 180, 0.35);
    color: rgba(223, 223, 223, 0.55);
    font-size: 0.84rem; }
  .event-auction-page .event-auction-loot-list__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 0.85rem 0.95rem;
    border-radius: 12px;
    border: 1px solid rgba(58, 120, 180, 0.3);
    background: linear-gradient(180deg, rgba(21, 28, 36, 0.4), rgba(0, 48, 77, 0.48)), rgba(0, 48, 77, 0.55);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18); }
  .event-auction-page .event-auction-loot-list__copy {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    min-width: 0;
    flex: 1 1 auto; }
  .event-auction-page .sc-item-chip--auction {
    font-size: 13px;
    line-height: 1.35;
    border-radius: 10px;
    border-color: rgba(157, 123, 255, 0.72);
    background: linear-gradient(180deg, rgba(21, 28, 36, 0.55), rgba(11, 16, 22, 0.96)), #0B1016;
    box-shadow: 0 0 0 1px rgba(106, 76, 255, 0.08), 0 8px 18px rgba(0, 0, 0, 0.22);
    overflow: hidden; }
    .event-auction-page .sc-item-chip--auction.sc-item-chip--removable {
      gap: 0; }
    .event-auction-page .sc-item-chip--auction .sc-item-chip__trigger {
      gap: 0.55rem;
      margin: 0 0.65rem;
      padding: 0.55rem 0.35rem;
      row-gap: 0.3rem;
      flex-wrap: nowrap; }
    .event-auction-page .sc-item-chip--auction .sc-item-chip__label {
      flex: 0 1 auto;
      font-size: 13px;
      font-weight: 600;
      letter-spacing: 0.01em;
      color: rgba(255, 255, 255, 0.96); }
    .event-auction-page .sc-item-chip--auction .sc-item-chip__meta-sep,
    .event-auction-page .sc-item-chip--auction .sc-item-chip__unit-quality-sep {
      display: none; }
    .event-auction-page .sc-item-chip--auction .sc-item-chip__unit {
      gap: 0.35rem;
      padding: 0.2rem 0.45rem;
      border-radius: 7px;
      background: rgba(255, 255, 255, 0.06);
      border: 1px solid rgba(157, 123, 255, 0.22);
      color: rgba(255, 255, 255, 0.9);
      font-weight: 600; }
    .event-auction-page .sc-item-chip--auction .sc-item-chip__unit.is-editing {
      background: rgba(106, 76, 255, 0.18);
      border-color: rgba(157, 123, 255, 0.55); }
    .event-auction-page .sc-item-chip--auction .sc-item-chip__unit-edit {
      gap: 0.35rem; }
    .event-auction-page .sc-item-chip--auction .sc-item-chip__unit-kind-text,
    .event-auction-page .sc-item-chip--auction .sc-item-chip__unit-quality-q {
      opacity: 0.72;
      font-weight: 600;
      font-size: 12px;
      letter-spacing: 0.04em;
      text-transform: lowercase; }
    .event-auction-page .sc-item-chip--auction .sc-item-chip__unit-quality-q {
      text-transform: uppercase; }
    .event-auction-page .sc-item-chip--auction .sc-item-chip__unit-qty-value,
    .event-auction-page .sc-item-chip--auction .sc-item-chip__unit-quality-value {
      padding: 0.1rem 0.4rem;
      border-radius: 5px;
      background: rgba(255, 255, 255, 0.1);
      color: #ffffff;
      font-weight: 700;
      font-variant-numeric: tabular-nums; }
    .event-auction-page .sc-item-chip--auction .sc-item-chip__unit-qty-value--editable,
    .event-auction-page .sc-item-chip--auction .sc-item-chip__unit-quality-value--editable {
      text-decoration: none;
      border: 1px solid transparent;
      transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease; }
      .event-auction-page .sc-item-chip--auction .sc-item-chip__unit-qty-value--editable:hover, .event-auction-page .sc-item-chip--auction .sc-item-chip__unit-qty-value--editable:focus-visible,
      .event-auction-page .sc-item-chip--auction .sc-item-chip__unit-quality-value--editable:hover,
      .event-auction-page .sc-item-chip--auction .sc-item-chip__unit-quality-value--editable:focus-visible {
        background: rgba(106, 76, 255, 0.22);
        border-color: rgba(157, 123, 255, 0.5);
        box-shadow: 0 0 0 2px rgba(106, 76, 255, 0.15);
        outline: none; }
    .event-auction-page .sc-item-chip--auction .sc-item-chip__unit-qty-input,
    .event-auction-page .sc-item-chip--auction .sc-item-chip__unit-quality-input {
      padding: 0.1rem 0.35rem;
      border-radius: 5px;
      background: rgba(106, 76, 255, 0.2);
      font-weight: 700;
      font-variant-numeric: tabular-nums; }
    .event-auction-page .sc-item-chip--auction .sc-item-chip__remove {
      align-self: stretch;
      width: 2rem;
      min-height: 100%;
      height: auto;
      border-radius: 0;
      background: rgba(106, 76, 255, 0.88);
      color: #ffffff;
      transition: background 0.15s ease; }
      .event-auction-page .sc-item-chip--auction .sc-item-chip__remove:hover, .event-auction-page .sc-item-chip--auction .sc-item-chip__remove:focus-visible {
        background: #9D7BFF;
        outline: none; }
    .event-auction-page .sc-item-chip--auction .sc-item-chip__remove-icon {
      font-size: 1.05rem;
      font-weight: 600;
      opacity: 0.95; }
  .event-auction-page .event-auction-loot-list__side {
    display: flex;
    align-items: center;
    gap: 0.95rem;
    flex: 0 0 auto; }
  .event-auction-page .event-auction-officer-bar {
    display: flex;
    flex-wrap: wrap;
    gap: 0.65rem;
    align-items: center;
    margin-bottom: 0.85rem; }
  .event-auction-page .event-auction-ready-check {
    margin-bottom: 0.85rem;
    padding: 0.65rem 0.8rem;
    border: 1px solid rgba(58, 120, 180, 0.25);
    border-radius: 10px;
    background: rgba(0, 48, 77, 0.35); }
  .event-auction-page .event-auction-ready-check__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    margin-bottom: 0.45rem; }
  .event-auction-page .event-auction-ready-check__list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 0.25rem; }
  .event-auction-page .event-auction-ready-check__item {
    display: flex;
    justify-content: space-between;
    gap: 0.75rem;
    font-size: 0.85rem;
    color: #dfdfdf; }
  .event-auction-page .event-auction-ready-check__item--ready {
    color: #5aa05c; }
  .event-auction-page .event-auction-ready-check__item--not_ready {
    color: #9e2222; }
  .event-auction-page .event-auction-ready-check__item--pending {
    color: #3a78b4; }
  .event-auction-page .event-auction-ready-check__item--offline {
    color: #b8b8b8;
    opacity: 0.85; }
  .event-auction-page .event-auction-ready-check__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-top: 0.55rem; }
  .event-auction-page .event-auction-manage-draft {
    display: flex;
    flex-direction: column;
    gap: 0.75rem; }
  .event-auction-page .event-auction-manage-draft__locked {
    margin: 0.35rem 0 0;
    color: #b8b8b8;
    font-size: 0.85rem; }
  .event-auction-page .event-auction-manage-draft__row {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    align-items: center; }
  .event-auction-page .event-auction-room__status {
    display: flex;
    flex-wrap: wrap;
    gap: 0.85rem;
    align-items: center;
    margin-bottom: 0.85rem;
    color: #dfdfdf; }
  .event-auction-page .event-auction-room__timer {
    font-variant-numeric: tabular-nums;
    font-weight: 700;
    color: #3a78b4; }
  .event-auction-page .event-auction-room__lots {
    display: flex;
    flex-direction: column;
    gap: 0.85rem; }
  .event-auction-page .event-auction-lot-card {
    border: 1px solid rgba(58, 120, 180, 0.28);
    border-radius: 12px;
    padding: 0.75rem 0.9rem;
    background: rgba(0, 48, 77, 0.45); }
  .event-auction-page .event-auction-lot-card__header {
    margin-bottom: 0.45rem; }
  .event-auction-page .event-auction-lot-card__title {
    margin: 0 0 0.35rem;
    font-size: 0.95rem; }
  .event-auction-page .event-auction-lot-card__meta {
    display: flex;
    flex-wrap: wrap;
    gap: 0.65rem;
    font-size: 0.75rem;
    color: #b8b8b8; }
  .event-auction-page .event-auction-lot-card__bank {
    color: #3a78b4; }
  .event-auction-page .event-auction-lot-card__warn {
    color: #9b602a;
    font-size: 0.8rem; }
  .event-auction-page .event-auction-lot-card__bids {
    margin: 0.4rem 0 0.65rem;
    padding-left: 1.1rem;
    font-size: 0.82rem; }
  .event-auction-page .event-auction-lot-card__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.55rem;
    align-items: flex-end; }
    .event-auction-page .event-auction-lot-card__actions label {
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
      font-size: 0.72rem;
      color: #b8b8b8; }
    .event-auction-page .event-auction-lot-card__actions .ts-input {
      width: 6.5rem; }
  .event-auction-page .event-auction-lot-card__result {
    margin: 0.55rem 0 0;
    font-size: 0.82rem;
    color: #dfdfdf; }
  .event-auction-page .event-auction-block__header .event-auction-block__event-name {
    margin-left: 0.35rem;
    font-size: 0.78rem;
    font-weight: 500;
    text-transform: none;
    color: #b8b8b8;
    opacity: 0.9; }
  .event-auction-page .event-auction-board {
    display: flex;
    flex-direction: column;
    gap: 0.85rem;
    flex: 1 1 auto;
    min-height: 0; }
  .event-auction-page .event-auction-view--manage {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0; }
  .event-auction-page .event-auction-board__topbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem; }
  .event-auction-page .event-auction-board__phase-cluster {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.55rem; }
  .event-auction-page .event-auction-board__phase-pill {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.32rem 0.75rem;
    border-radius: 999px;
    border: 1px solid rgba(58, 120, 180, 0.35);
    background: rgba(0, 48, 77, 0.55);
    font-size: 0.78rem;
    color: #dfdfdf; }
    .event-auction-page .event-auction-board__phase-pill--free, .event-auction-page .event-auction-board__phase-pill--firm {
      border-color: rgba(90, 160, 92, 0.45);
      color: #5aa05c; }
    .event-auction-page .event-auction-board__phase-pill--paused, .event-auction-page .event-auction-board__phase-pill--cancelled {
      border-color: rgba(158, 34, 34, 0.45);
      color: #d74545; }
  .event-auction-page .event-auction-board__phase-dot {
    width: 0.45rem;
    height: 0.45rem;
    border-radius: 50%;
    background: currentColor;
    box-shadow: 0 0 6px currentColor; }
  .event-auction-page .event-auction-board__timer {
    font-variant-numeric: tabular-nums;
    font-weight: 700;
    color: #3a78b4;
    font-size: 1.05rem; }
  .event-auction-page .event-auction-board__balance {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.15rem;
    padding: 0.45rem 0.7rem;
    border-radius: 10px;
    border: 1px solid rgba(58, 120, 180, 0.28);
    background: rgba(0, 48, 77, 0.4);
    font-size: 0.8rem;
    color: #b8b8b8; }
    .event-auction-page .event-auction-board__balance strong {
      color: #dfdfdf;
      font-size: 0.92rem; }
  .event-auction-page .event-auction-board__table-wrap {
    flex: 1 1 auto;
    min-height: 0;
    max-height: clamp(220px, 42vh, 560px);
    overflow: auto;
    border: 1px solid rgba(58, 120, 180, 0.22);
    border-radius: 12px;
    background: rgba(0, 48, 77, 0.28);
    scrollbar-width: thin;
    scrollbar-color: rgba(58, 120, 180, 0.5) rgba(0, 48, 77, 0.45); }
    .event-auction-page .event-auction-board__table-wrap::-webkit-scrollbar {
      width: 4px; }
    .event-auction-page .event-auction-board__table-wrap::-webkit-scrollbar-track {
      background: rgba(0, 48, 77, 0.45);
      border-radius: 999px; }
    .event-auction-page .event-auction-board__table-wrap::-webkit-scrollbar-thumb {
      background: rgba(58, 120, 180, 0.48);
      border-radius: 999px; }
      .event-auction-page .event-auction-board__table-wrap::-webkit-scrollbar-thumb:hover {
        background: rgba(58, 120, 180, 0.65); }
  .event-auction-page .event-auction-board__table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    min-width: 720px; }
    .event-auction-page .event-auction-board__table th,
    .event-auction-page .event-auction-board__table td {
      padding: 0.7rem 0.75rem;
      text-align: left;
      vertical-align: top;
      border-bottom: 1px solid rgba(223, 223, 223, 0.08); }
    .event-auction-page .event-auction-board__table thead th {
      position: sticky;
      top: 0;
      z-index: 2;
      font-size: 0.72rem;
      text-transform: uppercase;
      letter-spacing: 0.04em;
      color: #b8b8b8;
      font-weight: 600;
      background: rgba(0, 48, 77, 0.96);
      box-shadow: 0 1px 0 rgba(223, 223, 223, 0.1); }
  .event-auction-page .event-auction-board__row td {
    background: rgba(0, 48, 77, 0.18); }
  .event-auction-page .event-auction-board__row:hover td {
    background: rgba(0, 48, 77, 0.28); }
  .event-auction-page .event-auction-board__row--mine td {
    background: rgba(90, 160, 92, 0.07);
    box-shadow: inset 0 0 0 1px rgba(90, 160, 92, 0.45); }
  .event-auction-page .event-auction-board__row--mine td:first-child {
    box-shadow: inset 3px 0 0 #5aa05c, inset 0 0 0 1px rgba(90, 160, 92, 0.45); }
  .event-auction-page .event-auction-board__lot {
    display: flex;
    align-items: flex-start;
    gap: 0.7rem; }
  .event-auction-page .event-auction-lot-icon,
  .event-auction-page .loadout-slot__icon.event-auction-lot-icon {
    flex: 0 0 auto;
    width: 2.6rem;
    height: 2.6rem;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background: #384858;
    border: 1px solid rgba(58, 120, 180, 0.22); }
  .event-auction-page .event-auction-lot-icon__img,
  .event-auction-page .loadout-slot__icon-img.event-auction-lot-icon__img {
    width: 100%;
    height: 100%;
    object-fit: contain; }
  .event-auction-page .event-auction-lot-icon__fallback {
    font-size: 0.95rem;
    font-weight: 700;
    color: #b8b8b8; }
  .event-auction-page .event-auction-board__lot-copy {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 0.25rem; }
  .event-auction-page .event-auction-board__lot-name {
    color: #dfdfdf;
    font-size: 0.92rem; }
  .event-auction-page .event-auction-board__lot-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 0.35rem;
    font-size: 0.72rem;
    color: #b8b8b8; }
  .event-auction-page .event-auction-board__chip {
    display: inline-flex;
    align-items: center;
    padding: 0.12rem 0.45rem;
    border-radius: 999px;
    border: 1px solid rgba(58, 120, 180, 0.28);
    background: rgba(21, 28, 36, 0.55);
    color: #b8b8b8;
    white-space: nowrap; }
    .event-auction-page .event-auction-board__chip--status {
      border-color: rgba(58, 120, 180, 0.4);
      color: #3a78b4; }
  .event-auction-page .event-auction-board__pi {
    font-weight: 600;
    color: #dfdfdf; }
  .event-auction-page .event-auction-board__current,
  .event-auction-page .event-auction-board__mine {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
    font-size: 0.8rem;
    color: #b8b8b8; }
    .event-auction-page .event-auction-board__current strong,
    .event-auction-page .event-auction-board__mine strong {
      color: #dfdfdf; }
  .event-auction-page .event-auction-board__mine-tag {
    display: inline-flex;
    align-self: flex-start;
    padding: 0.12rem 0.4rem;
    border-radius: 999px;
    background: rgba(90, 160, 92, 0.2);
    color: #5aa05c;
    font-size: 0.68rem;
    font-weight: 700;
    text-transform: uppercase; }
  .event-auction-page .event-auction-board__muted {
    color: #b8b8b8;
    opacity: 0.75;
    font-size: 0.8rem; }
  .event-auction-page .event-auction-board__empty {
    text-align: center;
    color: #b8b8b8;
    padding: 1.2rem 0.75rem !important; }
  .event-auction-page .event-auction-board__bid-editor {
    display: flex;
    flex-wrap: wrap;
    gap: 0.45rem;
    align-items: flex-end; }
    .event-auction-page .event-auction-board__bid-editor label {
      display: flex;
      flex-direction: column;
      gap: 0.2rem;
      font-size: 0.7rem;
      color: #b8b8b8; }
    .event-auction-page .event-auction-board__bid-editor .ts-input {
      width: 5.5rem; }
  .event-auction-page .event-auction-board__btn-cancel {
    color: #d02d2d !important;
    border-color: rgba(158, 34, 34, 0.45) !important; }
  .event-auction-page .event-auction-board__warn {
    margin: 0.35rem 0 0;
    font-size: 0.72rem;
    color: #9b602a; }

.event-auction-block.benefits-block {
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0; }
  .event-auction-block.benefits-block .event-auction-block__body {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.all-orgs-page .all-orgs-error {
  margin: 0 0 0.75rem;
  color: #9e2222;
  font-size: 0.85rem; }

.all-orgs-page .all-orgs-layout {
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr; }
  .all-orgs-page .all-orgs-layout--split {
    grid-template-columns: minmax(0, 1.15fr) minmax(0, 0.85fr); }
  @media (max-width: 1100px) {
    .all-orgs-page .all-orgs-layout--split {
      grid-template-columns: 1fr; } }

.all-orgs-page .all-orgs-count {
  margin-left: auto;
  font-size: 0.78rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.62);
  white-space: nowrap; }

.all-orgs-page .all-orgs-toolbar {
  align-items: center; }

.all-orgs-page .all-orgs-filter-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  margin: 0;
  cursor: pointer;
  user-select: none; }

.all-orgs-page .all-orgs-filter-toggle__label {
  font-size: 0.78rem;
  letter-spacing: 0.03em;
  color: rgba(223, 223, 223, 0.82);
  white-space: nowrap; }

.all-orgs-page .all-orgs-rsi-link {
  display: inline-block;
  margin-top: 0.35rem;
  font-size: 0.8rem;
  color: #3a78b4;
  text-decoration: none;
  letter-spacing: 0.02em; }
  .all-orgs-page .all-orgs-rsi-link:hover {
    color: #5ac3ff;
    text-decoration: underline; }

.all-orgs-page .ts-table-scroll--all-orgs {
  max-height: min(62vh, calc(100vh - 280px)); }

.all-orgs-page .ts-table-scroll--all-orgs-members {
  max-height: min(42vh, calc(100vh - 420px)); }

.all-orgs-page .accounting-table--all-orgs-head,
.all-orgs-page .accounting-table--all-orgs-body {
  table-layout: fixed;
  width: 100%; }
  .all-orgs-page .accounting-table--all-orgs-head .col-logo,
  .all-orgs-page .accounting-table--all-orgs-body .col-logo {
    width: 72px; }
  .all-orgs-page .accounting-table--all-orgs-head .col-orgSid,
  .all-orgs-page .accounting-table--all-orgs-body .col-orgSid {
    width: 110px; }
  .all-orgs-page .accounting-table--all-orgs-head .col-whitelisted,
  .all-orgs-page .accounting-table--all-orgs-head .col-blacklisted,
  .all-orgs-page .accounting-table--all-orgs-body .col-whitelisted,
  .all-orgs-page .accounting-table--all-orgs-body .col-blacklisted {
    width: 96px; }
  .all-orgs-page .accounting-table--all-orgs-head th.header-logo,
  .all-orgs-page .accounting-table--all-orgs-head td.cell-logo,
  .all-orgs-page .accounting-table--all-orgs-head th.header-whitelisted,
  .all-orgs-page .accounting-table--all-orgs-head td.cell-whitelisted,
  .all-orgs-page .accounting-table--all-orgs-head th.header-blacklisted,
  .all-orgs-page .accounting-table--all-orgs-head td.cell-blacklisted,
  .all-orgs-page .accounting-table--all-orgs-body th.header-logo,
  .all-orgs-page .accounting-table--all-orgs-body td.cell-logo,
  .all-orgs-page .accounting-table--all-orgs-body th.header-whitelisted,
  .all-orgs-page .accounting-table--all-orgs-body td.cell-whitelisted,
  .all-orgs-page .accounting-table--all-orgs-body th.header-blacklisted,
  .all-orgs-page .accounting-table--all-orgs-body td.cell-blacklisted {
    text-align: center;
    vertical-align: middle; }

.all-orgs-page .accounting-table--all-orgs-members-head,
.all-orgs-page .accounting-table--all-orgs-members-body {
  table-layout: fixed;
  width: 100%; }
  .all-orgs-page .accounting-table--all-orgs-members-head .col-handle,
  .all-orgs-page .accounting-table--all-orgs-members-body .col-handle {
    width: 22%; }
  .all-orgs-page .accounting-table--all-orgs-members-head .col-monicker,
  .all-orgs-page .accounting-table--all-orgs-members-body .col-monicker {
    width: 20%; }
  .all-orgs-page .accounting-table--all-orgs-members-head .col-discord,
  .all-orgs-page .accounting-table--all-orgs-members-body .col-discord {
    width: 24%; }
  .all-orgs-page .accounting-table--all-orgs-members-head .col-membership,
  .all-orgs-page .accounting-table--all-orgs-members-body .col-membership {
    width: 16%; }
  .all-orgs-page .accounting-table--all-orgs-members-head .col-rank,
  .all-orgs-page .accounting-table--all-orgs-members-body .col-rank {
    width: 18%; }

.all-orgs-page .all-orgs-row {
  cursor: pointer;
  transition: background 0.15s ease; }
  .all-orgs-page .all-orgs-row:hover {
    background: rgba(58, 120, 180, 0.08); }
  .all-orgs-page .all-orgs-row.is-selected {
    background: rgba(58, 120, 180, 0.16) !important;
    box-shadow: inset 3px 0 0 #3a78b4; }

.all-orgs-page .all-orgs-no-logo {
  color: #2a3847; }

.all-orgs-page .all-orgs-logo {
  display: block;
  object-fit: contain;
  margin-left: auto;
  margin-right: auto;
  width: auto;
  height: auto; }

.all-orgs-page .all-orgs-logo--small {
  max-width: 36px;
  max-height: 36px; }

.all-orgs-page .all-orgs-logo--medium {
  max-width: 52px;
  max-height: 52px; }

.all-orgs-page .all-orgs-logo--large {
  max-width: 64px;
  max-height: 64px; }

.all-orgs-page .all-orgs-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto; }

.all-orgs-page .all-orgs-detail-header {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  margin-bottom: 1rem;
  min-width: 0; }
  .all-orgs-page .all-orgs-detail-header .all-orgs-logo {
    margin: 0;
    flex: 0 0 auto; }

.all-orgs-page .all-orgs-detail-header__text {
  flex: 1 1 auto;
  min-width: 0; }

.all-orgs-page .all-orgs-detail-sid {
  margin: 0.2rem 0 0;
  font-size: 0.8rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.62); }

.all-orgs-page .all-orgs-detail-focus {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin: 0.4rem 0 0;
  padding: 0;
  list-style: none; }
  .all-orgs-page .all-orgs-detail-focus--inline {
    margin-top: 0.3rem; }

.all-orgs-page .all-orgs-detail-focus__item {
  display: inline-flex;
  align-items: center;
  padding: 0.18rem 0.5rem;
  border-radius: 999px;
  border: 1px solid rgba(58, 120, 180, 0.4);
  background: rgba(21, 28, 36, 0.45);
  font-size: 0.72rem;
  letter-spacing: 0.03em;
  color: rgba(223, 223, 223, 0.88); }
  .all-orgs-page .all-orgs-detail-focus__item.is-primary {
    border-color: rgba(58, 120, 180, 0.65);
    background: rgba(58, 120, 180, 0.22); }
  .all-orgs-page .all-orgs-detail-focus__item.is-secondary {
    border-color: rgba(90, 195, 255, 0.35);
    background: rgba(90, 195, 255, 0.12); }
  .all-orgs-page .all-orgs-detail-focus__item.is-warning {
    border-color: #9e2222;
    background: rgba(158, 34, 34, 0.22);
    color: #dfdfdf; }

.all-orgs-page .all-orgs-name-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  min-width: 0; }

.all-orgs-page .all-orgs-name-cell__label {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%; }

.all-orgs-page .all-orgs-scrape-btn {
  flex: 0 0 auto;
  align-self: flex-start; }

.all-orgs-page .all-orgs-close-btn {
  flex: 0 0 auto; }

.all-orgs-page .all-orgs-comment-block {
  margin-bottom: 1.1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(58, 120, 180, 0.22); }

.all-orgs-page .all-orgs-comment-label {
  display: block;
  margin-bottom: 0.4rem;
  font-size: 0.72rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(223, 223, 223, 0.7); }

.all-orgs-page .all-orgs-comment-edit-textarea {
  width: 100%;
  min-height: 4.5rem;
  resize: vertical; }

.all-orgs-page .all-orgs-comment-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.55rem; }

.all-orgs-page .all-orgs-members-title {
  margin-top: 0.25rem; }

.all-orgs-page .all-orgs-members-count {
  font-weight: 500;
  color: rgba(223, 223, 223, 0.62); }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
/*Reset passord*/
.reset-card {
  position: relative;
  background-color: #0c2637;
  color: #dfdfdf;
  width: 400px;
  height: 400px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: height 0.5s; }

.reset-card.message-present {
  height: 420px;
  /* hauteur augmentée */ }

.reset-tab {
  background-color: #1c2d38;
  width: 100%;
  font-size: 1.2rem;
  padding: 10px 0;
  text-align: center;
  color: #dfdfdf;
  text-decoration: none;
  text-align: center; }
  .reset-tab:hover {
    cursor: none;
    color: #dfdfdf;
    text-decoration: underline; }
  .reset-tab.active {
    background-color: #0c2637;
    color: white; }

.status-container {
  background: #1c2d38;
  max-width: 1350px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 50px;
  padding-right: 50px;
  padding-top: 15px;
  padding-bottom: 25px;
  margin-top: 100px;
  border: 2px solid #0c2637;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px; }

.custom-status {
  text-align: center;
  text-align: justify;
  color: #dfdfdf; }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.home-container {
  position: relative;
  max-width: 100vw;
  margin-left: auto;
  margin-right: auto;
  overflow-x: hidden; }

.video-iframe, .video-container {
  width: 100vw;
  object-fit: cover; }
  .video-iframe::after, .video-container::after {
    content: '';
    position: absolute;
    bottom: 0px;
    left: 0;
    right: 0;
    height: 4px;
    background-image: var(--nav-background-image);
    border-image-slice: 1;
    border-image-repeat: repeat; }

.carousel.carousel-slider .control-arrow {
  display: none; }

.carousel .control-arrow:before, .carousel.carousel-slider .control-arrow:before {
  z-index: 0; }

.carousel .control-prev.control-arrow:before {
  border-right: 8px solid #fff; }

.carousel-with-title {
  width: 100%;
  height: 95vh; }
  @media (orientation: portrait) {
    .carousel-with-title {
      height: 95vh; } }
  @media (max-width: 1023px) {
    .carousel-with-title {
      height: 82vh; } }
  @media (max-width: 1023px) and (orientation: landscape) {
    .carousel-with-title {
      height: 72vh; } }

.carousel-title-container {
  position: absolute;
  bottom: 10%;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  padding: 0 20px;
  width: 100%;
  max-width: 1350px; }
  .carousel-title-container .carousel-title, .carousel-title-container .carousel-subtitle, .carousel-title-container .carousel-custom-dots {
    display: block;
    width: 100%;
    text-align: left; }
  .carousel-title-container .carousel-custom-dots {
    list-style: none;
    padding: 0;
    margin-top: 20px; }
    .carousel-title-container .carousel-custom-dots li {
      display: inline-block;
      opacity: 0.3;
      width: 35px;
      height: 8px;
      background: linear-gradient(to right, #0c2637, #dfdfdf, #dfdfdf, #0c2637);
      border: 1px solid #dfdfdf;
      transform: skew(-35deg, 0);
      margin-right: 15px;
      cursor: pointer; }
      .carousel-title-container .carousel-custom-dots li.active {
        opacity: 1; }
  @media (max-width: 768px) {
    .carousel-title-container {
      bottom: 20%; }
      .carousel-title-container .carousel-title {
        font-size: clamp(16px, 2.5vw, 32px); }
      .carousel-title-container .carousel-subtitle {
        font-size: clamp(12px, 1.2vw, 24px); }
      .carousel-title-container .carousel-custom-dots {
        margin-top: 10px; } }

.carousel-title {
  font-family: 'GoodTimes', sans-serif;
  font-size: clamp(16px, 2.5vw, 32px);
  color: #dfdfdf;
  margin-bottom: 10px;
  z-index: 1; }

.carousel-subtitle {
  font-family: 'GoodTimes', sans-serif;
  color: #dfdfdf;
  font-size: clamp(12px, 1.2vw, 24px);
  z-index: 1; }

.carousel-bottom {
  z-index: 2;
  height: 4px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: repeat; }

.carousel-with-title {
  position: relative; }
  .carousel-with-title .carousel-root,
  .carousel-with-title .carousel {
    height: 100%; }
  .carousel-with-title .carousel .slider-wrapper {
    height: 100% !important; }
  .carousel-with-title .carousel .slider {
    height: 100%; }
  .carousel-with-title .carousel .slide {
    height: 100%;
    display: flex;
    align-items: stretch; }
  .carousel-with-title .carousel-item {
    flex: 1;
    align-self: stretch;
    width: 100%;
    min-height: 0;
    position: relative;
    overflow: hidden; }
  .carousel-with-title .carousel-item > img.custom-carousel-image,
  .carousel-with-title .carousel-item > .video-iframe {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    max-width: none;
    object-fit: cover;
    object-position: center;
    display: block; }
  .carousel-with-title .chevrons-container {
    position: absolute;
    bottom: -30px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: opacity 0.5s ease-out;
    opacity: 1; }
    .carousel-with-title .chevrons-container.fade-out {
      opacity: 0; }
    .carousel-with-title .chevrons-container .chevron {
      width: 100px;
      height: 89px;
      fill: #dfdfdf;
      transition: fill 0.4s ease;
      animation: pulse 2s infinite; }
      .carousel-with-title .chevrons-container .chevron:not(:first-child) {
        margin-top: -60px; }
      .carousel-with-title .chevrons-container .chevron:nth-child(1) {
        animation-delay: 0s; }
      .carousel-with-title .chevrons-container .chevron:nth-child(2) {
        animation-delay: 0.4s; }
      .carousel-with-title .chevrons-container .chevron:nth-child(3) {
        animation-delay: 0.8s; }

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0;
    fill: #dfdfdf; }
  50% {
    margin-top: -65px;
    transform: scale(1.3);
    opacity: 1;
    fill: #9e2222; } }

.button-container {
  display: flex;
  position: absolute;
  justify-content: left;
  padding: 0 15px;
  height: auto;
  z-index: 2;
  transform: translate(-45px, 31px); }
  @media (max-width: 1024px) {
    .button-container {
      transform: translate(-23px, 32px); } }

.trapezoid-border {
  display: inline-block;
  padding-bottom: 5px;
  padding-left: 5px;
  padding-right: 5px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  clip-path: polygon(0 0, 100% 0, 80% 100%, 20% 100%);
  box-shadow: 20px 20px 25px rgba(255, 0, 0, 0.6); }

.trapezoid-button {
  display: inline-block;
  text-align: center;
  padding: 4px 35px 4px 35px;
  background: linear-gradient(to right, #522323d3, #4b0505, #4b0505, #4b0505, #522323d3);
  color: #b8b8b8;
  font-size: clamp(10px, 1.1vw, 15px);
  font-family: 'GoodTimes', sans-serif;
  border: none;
  text-decoration: none;
  text-transform: uppercase;
  transition: all 0.3s ease;
  cursor: pointer;
  clip-path: polygon(0 0, 100% 0, 80% 100%, 20% 100%); }
  .trapezoid-button:hover {
    background: linear-gradient(to right, #683232d3, #5a0b0b, #4b0505, #5a0b0b, #683232d3);
    color: white; }
  @media (max-width: 768px) {
    .trapezoid-button {
      padding: 7px 25px 7px 25px; } }

.pulse-text {
  display: inline-block;
  animation: pulse2 2s infinite ease-in-out; }

@keyframes pulse2 {
  0%, 100% {
    transform: scale(1); }
  50% {
    transform: scale(1.05); } }

.org-statistics {
  max-width: 1460px;
  margin: 50px auto 10px auto;
  padding-left: 25px;
  padding-right: 25px; }
  @media (max-width: 1023px) {
    .org-statistics {
      width: 100%;
      max-width: 1350px;
      margin-left: 1.8%;
      margin-right: 1.8%;
      margin-bottom: 55px;
      padding-left: clamp(12px, 1.5%, 20px);
      padding-right: clamp(12px, 1.5%, 20px); } }
  .org-statistics .content-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 20px; }

.chart-row {
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 20px;
  /* Ajustez selon vos besoins pour l'espacement entre les rangées */ }
  @media (max-width: 1023px) {
    .chart-row {
      width: 100%;
      justify-content: center;
      flex-wrap: wrap; } }

.chart-title {
  text-transform: uppercase;
  color: #b8b8b8; }

.bar-chart {
  margin-left: auto;
  margin-right: 10px;
  padding-top: 1%;
  width: 100% !important; }
  .bar-chart.divisions {
    display: flex;
    flex-direction: column;
    align-items: center; }
  @media (max-width: 1023px) {
    .bar-chart {
      flex-wrap: wrap;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 20px; } }

.banner {
  padding: 20px 20px 20px 20px;
  text-align: center; }

.homepage.catchPhrase {
  color: rgba(139, 137, 137, 0.795);
  text-shadow: 1px 1px 1px #1d1d1c5d;
  font-size: clamp(16px, 2vw, 28px);
  text-transform: uppercase;
  margin: 50px 30px 50px 30px;
  width: 80%;
  justify-content: center;
  text-align: center;
  padding: 20px 30px 20px 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: cover;
  /* L'image de fond couvre entièrement le bandeau */
  background-position: center;
  /* Centre l'image de fond */
  background-repeat: no-repeat;
  /* Empêche la répétition de l'image */
  border: 3px solid rgba(85, 80, 80, 0.8);
  transition: top 0.4s; }
  @media (max-width: 1023px) {
    .homepage.catchPhrase {
      margin: 50px 30px 50px 30px; } }

.homepage-division-chart {
  height: 250px;
  width: 90%;
  padding: 0px 20px; }

.homepage.welcome-text {
  color: #b8b8b8;
  font-size: clamp(14px, 1.7vw, 20px);
  padding: 0px 40px 10px 40px;
  margin: 0;
  white-space: pre-wrap;
  transition: top 0.4s; }
  @media (max-width: 1023px) {
    .homepage.welcome-text {
      padding: 0px 10px 10px 10px;
      text-align: justify; } }

.worldmap-container {
  position: relative;
  /* Ensure the pseudo-element is positioned relative to this container */
  width: calc(100% + 20px); }
  .worldmap-container .worldmap {
    width: 570px;
    height: auto;
    margin-left: 15px;
    padding: 20px;
    position: relative;
    /* Ensure the image stays within its container */
    z-index: 0;
    /* Make sure it's below the pseudo-element */ }
    @media (max-width: 1023px) {
      .worldmap-container .worldmap {
        width: calc(100% - 35px);
        margin: 0px; } }

.worldmap-container::before {
  content: "";
  position: absolute;
  top: 5px;
  /* Adjust the top value to match your design */
  bottom: 5px;
  /* Adjust the bottom value to match your design */
  left: 7px;
  right: 7px;
  border-left: 3px solid #2a3847;
  border-right: 3px solid #2a3847;
  border-radius: 5px;
  /* Adjust the radius to match the inner corners */
  pointer-events: none;
  /* Ensure the pseudo-element does not interfere with interactions */
  z-index: 1;
  /* Make sure it's above the image */ }

.bar-chart, .worldmap-container {
  animation-play-state: paused; }

.anim-running {
  animation-play-state: running; }

.member-count-display {
  display: flex;
  flex-direction: row;
  width: 100%;
  text-align: center;
  margin-bottom: 20px; }
  @media (max-width: 1023px) {
    .member-count-display {
      display: contents;
      width: 100%;
      flex-direction: column; } }
  .member-count-display .count {
    font-size: 1.6em;
    font-weight: bold;
    color: #dfdfdf; }
  .member-count-display .count-complement {
    font-size: 1.2em;
    font-weight: bold;
    color: #b8b8b8; }
    @media (max-width: 1023px) {
      .member-count-display .count-complement {
        margin-bottom: 20px; } }
  @media (max-width: 1023px) {
    .member-count-display .count, .member-count-display .count-complement {
      text-align: center; } }

.count-complement {
  font-style: italic; }

.homepage.region-chart {
  flex: 2 1 0%;
  max-width: 600px;
  width: 100%;
  margin: 0 20px 0 auto; }
  .homepage.region-chart .e-accumulationchart {
    user-select: none;
    position: relative;
    display: block;
    height: inherit;
    width: 100%;
    height: auto; }

@media (orientation: portrait) {
  .content-container {
    flex-direction: column; } }

@media (orientation: landscape) {
  .content-container {
    flex-direction: row; } }

@media (max-width: 1023px) {
  .homepage.region-chart {
    flex: 1 1 100%;
    width: 100%; } }

@keyframes scale-up {
  from {
    transform: scale(1); }
  to {
    transform: scale(1.1); } }

.carousel-bottom {
  position: relative;
  z-index: 2;
  height: 4px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: repeat; }

.content-home-framed {
  display: flex;
  margin-top: 50px;
  margin-bottom: 100px;
  width: 100%;
  max-width: 1350px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  flex-direction: row; }

.content-framed-left, .content-framed-right {
  background-color: #1c2d38;
  flex-basis: 0;
  flex-grow: 1;
  width: 200px;
  height: 800px;
  border: 2px solid #0c2637;
  margin-right: 20px;
  margin-left: 20px;
  text-align: justify;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  opacity: 0;
  transform: translateX(-100%);
  transition: opacity 0.7s, transform 1s; }

.content-framed-right {
  transform: translateX(100%); }

.content-framed-left.visible, .content-framed-right.visible {
  opacity: 1;
  transform: translateX(0); }

.home-images {
  padding-top: 130px;
  width: 570px; }

.home-images-left, .home-images-right {
  flex-basis: 0;
  flex-grow: 1;
  width: 200px;
  height: auto;
  margin-right: 20px;
  margin-left: 20px;
  text-align: justify;
  opacity: 0;
  transform: translateX(-100%);
  transition: opacity 0.7s, transform 1s; }

.home-images-right {
  transform: translateX(100%); }

.home-images-left.visible, .home-images-right.visible {
  opacity: 1;
  transform: translateX(0); }

.title-framed {
  background-color: #0c2637;
  color: #dfdfdf;
  font-family: 'GoodTimes', sans-serif;
  font-size: 1.1rem;
  width: auto;
  padding: 20px;
  border-top-left-radius: 13px;
  border-top-right-radius: 13px; }

.framed {
  color: #dfdfdf;
  font-size: 1rem;
  padding-right: 20px;
  padding-left: 20px;
  padding-bottom: 20px; }

/*                   */
/*       MEDIA       */
/*                   */
@media (max-width: 1023px) {
  .carousel {
    margin-top: 40px;
    width: 100%; }
  .content-home-framed {
    display: flex;
    margin-top: 50px;
    margin-bottom: 100px;
    width: 100%;
    max-width: 1350px;
    text-align: center;
    flex-direction: column; }
  .content-framed {
    background-color: #1c2d38;
    flex-basis: 0;
    flex-grow: 1;
    width: auto;
    height: auto;
    border: 2px solid #0c2637;
    margin-right: 10px;
    margin-left: 10px;
    margin-bottom: 10px; }
  .title-framed {
    background-color: #0c2637;
    color: #dfdfdf;
    font-family: 'GoodTimes', sans-serif;
    font-size: 1.1rem;
    width: auto;
    padding: 20px; }
  .framed {
    color: #dfdfdf;
    padding-right: 20px;
    padding-left: 20px; } }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.faq-title {
  background-color: #1c2d38;
  color: #dfdfdf;
  font-family: 'GoodTimes', sans-serif;
  font-size: 2rem;
  width: auto;
  padding: 20px; }

.faq-question {
  cursor: pointer;
  color: #dfdfdf;
  background: #0c2637;
  border: 2px solid #0c2637;
  font-size: 1.1rem;
  text-transform: uppercase;
  width: auto;
  width: 100%;
  max-width: 1350px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0;
  padding: 0.5rem 1rem 1rem 1rem;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px; }

.faq-item.answer-visible .faq-question {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0; }

.faq-answer {
  color: #dfdfdf;
  background: #1c2d38;
  font-size: 1rem;
  border: 2px solid #0c2637;
  text-align: center;
  text-align: justify;
  width: 100%;
  max-width: 1350px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0;
  padding-right: 1rem;
  padding-left: 1rem;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px; }

.faq-answer-content {
  padding-top: 1rem;
  padding-bottom: 1rem; }

@media (max-width: 1023px) {
  /*FAQ.css */
  .faq-question-wrapper {
    padding-bottom: 0px; }
  .faq-item {
    margin-left: 10px;
    margin-right: 10px; } }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.gcu-modal-content,
.anonymization-modal-content {
  position: relative;
  max-width: 1150px;
  width: 100%;
  padding: 20px;
  background-color: transparent;
  overflow: hidden;
  margin-bottom: 80px; }
  .gcu-modal-content .modal-content,
  .anonymization-modal-content .modal-content {
    background-color: #2a3847;
    border: 1px solid #491212;
    width: 100%;
    border-radius: 8px;
    top: 0px; }
  .gcu-modal-content .anonymization-header.modal-header,
  .anonymization-modal-content .anonymization-header.modal-header {
    border-bottom: none;
    background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    color: #dfdfdf;
    padding: 7px 25px;
    border-bottom: 3px solid #b8b8b8;
    border-radius: 8px 8px 0 0; }
    .gcu-modal-content .anonymization-header.modal-header .btn-close,
    .anonymization-modal-content .anonymization-header.modal-header .btn-close {
      display: none; }
    .gcu-modal-content .anonymization-header.modal-header .gcu-title,
    .anonymization-modal-content .anonymization-header.modal-header .gcu-title {
      font-size: 1rem;
      font-weight: bold;
      text-transform: uppercase;
      text-align: center; }
  .gcu-modal-content .gcu-header.modal-header,
  .anonymization-modal-content .gcu-header.modal-header {
    color: #dfdfdf;
    padding: 7px 25px;
    border-bottom: 3px solid #b8b8b8;
    border-radius: 8px 8px 0 0;
    background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center; }
    .gcu-modal-content .gcu-header.modal-header .btn-close,
    .anonymization-modal-content .gcu-header.modal-header .btn-close {
      display: none; }
    .gcu-modal-content .gcu-header.modal-header .gcu-title,
    .anonymization-modal-content .gcu-header.modal-header .gcu-title {
      font-size: 0.85rem;
      font-weight: bold;
      text-transform: uppercase;
      text-align: center; }
  .gcu-modal-content .gcu-content.modal-body,
  .anonymization-modal-content .gcu-content.modal-body {
    background-color: #0c2637;
    padding: 0px 20px;
    overflow-y: auto;
    max-height: calc(100vh - 230px);
    color: #dfdfdf;
    border-radius: 0 0 8px 8px;
    height: 60vh; }
    .gcu-modal-content .gcu-content.modal-body::-webkit-scrollbar,
    .anonymization-modal-content .gcu-content.modal-body::-webkit-scrollbar {
      width: 6px; }
    .gcu-modal-content .gcu-content.modal-body::-webkit-scrollbar-track,
    .anonymization-modal-content .gcu-content.modal-body::-webkit-scrollbar-track {
      background: #2e3842;
      border-radius: 4px;
      padding-right: 1px; }
    .gcu-modal-content .gcu-content.modal-body::-webkit-scrollbar-thumb,
    .anonymization-modal-content .gcu-content.modal-body::-webkit-scrollbar-thumb {
      background-color: #491212;
      border-radius: 4px; }
      .gcu-modal-content .gcu-content.modal-body::-webkit-scrollbar-thumb:hover,
      .anonymization-modal-content .gcu-content.modal-body::-webkit-scrollbar-thumb:hover {
        background-color: #200808; }
    .gcu-modal-content .gcu-content.modal-body .public-container,
    .anonymization-modal-content .gcu-content.modal-body .public-container {
      margin-bottom: 0px;
      padding-top: 0; }
    .gcu-modal-content .gcu-content.modal-body .gcu-footer.modal-footer,
    .anonymization-modal-content .gcu-content.modal-body .gcu-footer.modal-footer {
      display: flex;
      height: auto;
      gap: 20px;
      width: max-content;
      margin: 15px auto; }
      .gcu-modal-content .gcu-content.modal-body .gcu-footer.modal-footer .btn-style1,
      .anonymization-modal-content .gcu-content.modal-body .gcu-footer.modal-footer .btn-style1 {
        margin-left: auto; }
  .gcu-modal-content .anonymization-content.modal-body,
  .anonymization-modal-content .anonymization-content.modal-body {
    background-color: #0c2637;
    padding: 0px 20px;
    overflow-y: auto;
    max-height: calc(100vh - 230px);
    color: #dfdfdf;
    border-radius: 0 0 8px 8px;
    height: 17vh; }
    .gcu-modal-content .anonymization-content.modal-body .content,
    .anonymization-modal-content .anonymization-content.modal-body .content {
      padding: 20px;
      background-color: #1c2d38;
      margin-bottom: 20px;
      border-radius: 8px;
      color: #dfdfdf; }
    .gcu-modal-content .anonymization-content.modal-body .anonymization-footer.modal-footer,
    .anonymization-modal-content .anonymization-content.modal-body .anonymization-footer.modal-footer {
      display: flex;
      gap: 20px;
      width: 100%; }
  @media (max-width: 1023px) {
    .gcu-modal-content,
    .anonymization-modal-content {
      width: 100%;
      height: calc(100% - 110px);
      margin: 0;
      padding: 0; } }
  @media (min-width: 1023px) {
    .gcu-modal-content,
    .anonymization-modal-content {
      max-height: calc(100% - 110px);
      margin: 0px auto; } }

@font-face {
  font-family: 'GoodTimes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); }

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: 'FiraCode';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

body {
  font-family: 'Lato', sans-serif; }

/** Label row + \`.toggle-switch\` alignment (objectives blocks, create/edit event). */
/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */
.admin-block-container .form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px; }

.admin-block-container .input-label {
  font-size: 0.9rem;
  opacity: 0.9; }

.admin-block-container .input-text {
  width: 100%; }

.admin-block-container .admin-actions {
  margin-top: 12px;
  display: flex;
  gap: 10px; }

.admin-block-container .selected-pill {
  padding: 8px 10px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.2); }

.admin-block-container .hint {
  margin-top: 6px;
  font-size: 0.85rem;
  opacity: 0.75; }

.table-base td.cell-actions,
.table-base td.cell-action {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  vertical-align: middle;
  box-sizing: border-box; }

body .react-select__menu {
  z-index: 100050 !important; }

.table-base.simple-editor-table table {
  table-layout: fixed;
  width: 100%; }

.table-base.simple-editor-table .table-row td.cell-userId,
.table-base.simple-editor-table .table-row td.cell-orgRankId,
.table-base.simple-editor-table .table-row td.cell-assignmentName,
.table-base.simple-editor-table .table-row td.cell-assignmentId,
.table-base.simple-editor-table .table-row td.cell-orgDivisionId,
.table-base.simple-editor-table .table-row td.cell-roleTypeId,
.table-base.simple-editor-table .table-row td.cell-roleTypeBadge,
.table-base.simple-editor-table .table-row td.cell-assignmentRoleType,
.table-base.simple-editor-table .table-row td.cell-name,
.table-base.simple-editor-table .table-row td.cell-description,
.table-base.simple-editor-table .table-row td.cell-allowedDivisionIds,
.table-base.simple-editor-table .table-row td.cell-isActive {
  overflow: hidden;
  min-width: 0;
  text-align: left; }

.table-base.simple-editor-table .toggle.orgtitles-table-active {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  cursor: pointer; }
  .table-base.simple-editor-table .toggle.orgtitles-table-active input:disabled ~ .toggle-switch {
    opacity: 0.5;
    cursor: not-allowed; }

.table-base.simple-editor-table .table-row td.cell-redactedToken {
  overflow: hidden;
  text-align-last: center; }

.table-base.simple-editor-table .react-select-in-table {
  box-sizing: border-box;
  display: block;
  min-width: 0;
  max-width: 100%;
  width: 100%; }
  .table-base.simple-editor-table .react-select-in-table .react-select__control {
    box-sizing: border-box;
    min-width: 0 !important;
    max-width: 100% !important;
    width: 100% !important;
    min-height: fit-content !important; }
  .table-base.simple-editor-table .react-select-in-table .react-select__value-container {
    min-width: 0;
    overflow: hidden;
    flex: 1 1 auto; }
  .table-base.simple-editor-table .react-select-in-table .react-select__indicators {
    flex-shrink: 0; }
  .table-base.simple-editor-table .react-select-in-table .react-select__single-value,
  .table-base.simple-editor-table .react-select-in-table .react-select__placeholder {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis; }

.table-base.simple-editor-table .table-row td {
  vertical-align: middle; }

.table-base.simple-editor-table .table-row td.cell-actions,
.table-base.simple-editor-table .table-row td.cell-action {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 10px;
  padding-bottom: 6px; }
  .table-base.simple-editor-table .table-row td.cell-actions > .icon-btn,
  .table-base.simple-editor-table .table-row td.cell-action > .icon-btn {
    flex-shrink: 0; }
  .table-base.simple-editor-table .table-row td.cell-actions .row-actions,
  .table-base.simple-editor-table .table-row td.cell-action .row-actions {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex-shrink: 0; }

.table-base.simple-editor-table .table-input {
  width: 100%; }

.table-base.simple-editor-table .icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 42px;
  flex-shrink: 0; }

.table-base.simple-editor-table .row-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px; }

.table-base.simple-editor-table .icon-btn.danger {
  background: rgba(200, 60, 60, 0.15);
  border-color: rgba(200, 60, 60, 0.35); }

.table-base.simple-editor-table .cell-text {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.table-base.simple-editor-table .cell-text.muted {
  opacity: 0.55; }

.table-base.simple-editor-table .toggle.structure.division.rank-override {
  display: inline-flex;
  align-items: center;
  margin: 0;
  cursor: pointer; }
  .table-base.simple-editor-table .toggle.structure.division.rank-override input:disabled ~ .toggle-switch {
    opacity: 0.5;
    cursor: not-allowed; }

.table-base.simple-editor-table.simple-editor-table--role-types col.col-orgtitles-roletype {
  width: 16%; }

.table-base.simple-editor-table.simple-editor-table--role-types col.col-orgtitles-name {
  width: 20%; }

.table-base.simple-editor-table.simple-editor-table--role-types col.col-orgtitles-description {
  width: 38%; }

.table-base.simple-editor-table.simple-editor-table--role-types col.col-orgtitles-active {
  width: 10%; }

.table-base.simple-editor-table.simple-editor-table--role-types col.col-orgtitles-actions {
  width: 12%; }

.table-base.simple-editor-table.simple-editor-table--assignments-catalog col.col-orgtitles-roletype {
  width: 22%; }

.table-base.simple-editor-table.simple-editor-table--assignments-catalog col.col-orgtitles-name {
  width: 20%; }

.table-base.simple-editor-table.simple-editor-table--assignments-catalog col.col-orgtitles-division {
  width: 28%; }

.table-base.simple-editor-table.simple-editor-table--assignments-catalog col.col-orgtitles-active {
  width: 10%; }

.table-base.simple-editor-table.simple-editor-table--assignments-catalog col.col-orgtitles-actions {
  width: 12%; }

.table-base.simple-editor-table.simple-editor-table--user-assignments col.col-orgtitles-roletype {
  width: 16%; }

.table-base.simple-editor-table.simple-editor-table--user-assignments col.col-orgtitles-division {
  width: 20%; }

.table-base.simple-editor-table.simple-editor-table--user-assignments col.col-orgtitles-assignment {
  width: 20%; }

.table-base.simple-editor-table.simple-editor-table--user-assignments col.col-orgtitles-member {
  width: 24%; }

.table-base.simple-editor-table.simple-editor-table--user-assignments col.col-orgtitles-actions {
  width: 12%; }

.table-base.simple-editor-table.simple-editor-table--rank-overrides col.col-orgtitles-member {
  width: 16%; }

.table-base.simple-editor-table.simple-editor-table--rank-overrides col.col-orgtitles-rank-insignia {
  width: 7%; }

.table-base.simple-editor-table.simple-editor-table--rank-overrides col.col-orgtitles-rank {
  width: 20%; }

.table-base.simple-editor-table.simple-editor-table--rank-overrides col.col-orgtitles-since {
  width: 11%; }

.table-base.simple-editor-table.simple-editor-table--rank-overrides col.col-orgtitles-end {
  width: 11%; }

.table-base.simple-editor-table.simple-editor-table--rank-overrides col.col-orgtitles-redacted {
  width: 11%; }

.table-base.simple-editor-table.simple-editor-table--rank-overrides col.col-orgtitles-actions {
  width: 14%; }

.table-base.simple-editor-table.simple-editor-table--rank-overrides .cell-rankInsignia {
  text-align: center;
  vertical-align: middle; }

.table-base.simple-editor-table.simple-editor-table--rank-overrides .orgtitles-rank-insignia {
  display: block;
  width: auto;
  max-width: 40px;
  max-height: 30px;
  height: auto;
  margin: 0 auto;
  object-fit: contain;
  filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.35)); }

.table-base.simple-editor-table.simple-editor-table--rank-overrides .cell-startDate .cell-text,
.table-base.simple-editor-table.simple-editor-table--rank-overrides .cell-endDate .cell-text {
  white-space: nowrap; }

.admin-block-container .orgtitles-rank-overrides-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px 24px;
  margin-bottom: 12px; }
  .admin-block-container .orgtitles-rank-overrides-toolbar__filter {
    flex: 1 1 220px;
    max-width: 320px; }
  .admin-block-container .orgtitles-rank-overrides-toolbar__label {
    display: block;
    margin-bottom: 6px;
    font-size: 0.85rem;
    color: #b8b8b8; }
  .admin-block-container .orgtitles-rank-overrides-toolbar__toggle {
    display: flex;
    align-items: center;
    gap: 10px;
    width: auto;
    margin-bottom: 4px; }
    .admin-block-container .orgtitles-rank-overrides-toolbar__toggle .orgtitles-rank-overrides-toolbar__label {
      margin-bottom: 0; }

.admin-block-container .react-select-toolbar {
  min-width: 200px; }

.admin-block-container .input-field.orgtitles-legend {
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 12px;
  padding: 10px 12px;
  border: 1px solid #2a3847;
  border-radius: 6px;
  background: rgba(28, 45, 56, 0.35); }
  .admin-block-container .input-field.orgtitles-legend .home-file {
    width: 100%;
    margin-left: 0;
    margin-bottom: 6px; }
  .admin-block-container .input-field.orgtitles-legend .orgtitles-legend__badges {
    display: flex;
    flex-wrap: wrap;
    gap: 8px; }
  .admin-block-container .input-field.orgtitles-legend .orgtitles-legend__hint {
    font-size: 0.85rem;
    color: #b8b8b8;
    margin: 8px 0 0; }

.orgtitles-role-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  border: 1px solid transparent;
  white-space: nowrap; }
  .orgtitles-role-badge--compact {
    font-size: 0.7rem;
    padding: 1px 6px; }
  .orgtitles-role-badge--org-command {
    color: #5ac3ff;
    background: rgba(58, 120, 180, 0.2);
    border-color: rgba(58, 120, 180, 0.45); }
  .orgtitles-role-badge--op-command {
    color: #d8b493;
    background: rgba(155, 96, 42, 0.25);
    border-color: rgba(199, 132, 69, 0.4); }
  .orgtitles-role-badge--membership {
    color: #c2f0c3;
    background: rgba(90, 160, 92, 0.2);
    border-color: rgba(117, 207, 120, 0.35); }
  .orgtitles-role-badge--support {
    color: #9a80e3;
    background: rgba(121, 88, 195, 0.2);
    border-color: rgba(70, 54, 133, 0.5); }
  .orgtitles-role-badge--special {
    color: #dfdfdf;
    background: rgba(56, 72, 88, 0.45);
    border-color: #747b81; }
  .orgtitles-role-badge--other {
    color: #b8b8b8;
    background: rgba(42, 56, 71, 0.5);
    border-color: #747b81; }

.orgtitles-select-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0; }
  .orgtitles-select-option__name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1 1 auto;
    min-width: 0; }

.orgtitles-assignment-cell,
.orgtitles-name-cell,
.orgtitles-division-cell,
.orgtitles-member-cell {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
  min-width: 0; }
  .orgtitles-assignment-cell .cell-text,
  .orgtitles-name-cell .cell-text,
  .orgtitles-division-cell .cell-text,
  .orgtitles-member-cell .cell-text {
    min-width: 0; }

.orgtitles-member-cell {
  flex-direction: column;
  align-items: flex-start;
  gap: 2px; }
  .orgtitles-member-cell__handle {
    font-weight: 600; }
  .orgtitles-member-cell__moniker {
    font-size: 0.8rem;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; }

.orgtitles-dup-hint {
  flex-shrink: 0;
  color: #d12323;
  font-size: 0.85rem;
  cursor: help; }

.table-base.simple-editor-table tr.orgtitles-row--org-command td:first-child {
  position: relative; }
  .table-base.simple-editor-table tr.orgtitles-row--org-command td:first-child::before {
    content: '';
    position: absolute;
    left: 4px;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 55%;
    min-height: 14px;
    max-height: 22px;
    border-radius: 1px;
    background: rgba(58, 120, 180, 0.45);
    pointer-events: none; }

.table-base.simple-editor-table tr.orgtitles-row--op-command td:first-child {
  position: relative; }
  .table-base.simple-editor-table tr.orgtitles-row--op-command td:first-child::before {
    content: '';
    position: absolute;
    left: 4px;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 55%;
    min-height: 14px;
    max-height: 22px;
    border-radius: 1px;
    background: rgba(199, 132, 69, 0.45);
    pointer-events: none; }

.table-base.simple-editor-table tr.orgtitles-row--membership td:first-child {
  position: relative; }
  .table-base.simple-editor-table tr.orgtitles-row--membership td:first-child::before {
    content: '';
    position: absolute;
    left: 4px;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 55%;
    min-height: 14px;
    max-height: 22px;
    border-radius: 1px;
    background: rgba(117, 207, 120, 0.4);
    pointer-events: none; }

.table-base.simple-editor-table tr.orgtitles-row--support td:first-child {
  position: relative; }
  .table-base.simple-editor-table tr.orgtitles-row--support td:first-child::before {
    content: '';
    position: absolute;
    left: 4px;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 55%;
    min-height: 14px;
    max-height: 22px;
    border-radius: 1px;
    background: rgba(121, 88, 195, 0.45);
    pointer-events: none; }

.table-base.simple-editor-table tr.orgtitles-row--special td:first-child {
  position: relative; }
  .table-base.simple-editor-table tr.orgtitles-row--special td:first-child::before {
    content: '';
    position: absolute;
    left: 4px;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 55%;
    min-height: 14px;
    max-height: 22px;
    border-radius: 1px;
    background: rgba(116, 123, 129, 0.5);
    pointer-events: none; }

.table-base.simple-editor-table tr.orgtitles-row--other td:first-child {
  position: relative; }
  .table-base.simple-editor-table tr.orgtitles-row--other td:first-child::before {
    content: '';
    position: absolute;
    left: 4px;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 55%;
    min-height: 14px;
    max-height: 22px;
    border-radius: 1px;
    background: rgba(184, 184, 184, 0.35);
    pointer-events: none; }

@media (max-width: 900px) {
  .admin-block-container .form-grid {
    grid-template-columns: 1fr; } }
`, "",{"version":3,"sources":["webpack://./src/styles/styles.scss","webpack://./src/styles/variables.scss","webpack://./src/styles/main.scss","webpack://./src/styles/cookie.scss","webpack://./src/styles/HexagonBackground.scss","webpack://./src/styles/tools/sortable-tree.scss","webpack://./src/styles/rosterFile.scss","webpack://./src/styles/orgPositionsBrowse.scss","webpack://./src/styles/membersDashboard.scss","webpack://./src/styles/mobileWebAppPromo.scss","webpack://./src/styles/tools/react-table.scss","webpack://./src/styles/tools/diagram.scss","webpack://./src/styles/tools/modal.scss","webpack://./src/styles/tools/react-select.scss","webpack://./src/styles/tools/ant-tree-select.scss","webpack://./src/styles/tools/quill.scss","webpack://./src/styles/tools/lexical.scss","webpack://./src/styles/tools/chat.scss","webpack://./src/styles/tools/user-discord-rank-display.scss","webpack://./src/styles/components/donor-heart-badge.scss","webpack://./src/styles/components/donor-gem-badge.scss","webpack://./src/styles/components/hubToolbarSearch.scss","webpack://./src/styles/tools/member-profile-card.scss","webpack://./src/styles/tools/perkThemeOverlays.scss","webpack://./src/styles/tools/publicToc.scss","webpack://./src/styles/inputs.scss","webpack://./src/styles/ranks.scss","webpack://./src/styles/eventTemplates.scss","webpack://./src/styles/eventPlanner.scss","webpack://./src/styles/eventPlannerAssignmentView.scss","webpack://./src/styles/ribbons.scss","webpack://./src/styles/tools/colorpicker.scss","webpack://./src/styles/tools/scItemChip.scss","webpack://./src/styles/tools/bigCalendar.scss","webpack://./src/pages/private/members/calendarTools/event/components/EventBenefitsModalUeclayout.scss","webpack://./src/pages/private/members/calendarTools/event/components/EventObjectivesView.scss","webpack://./src/pages/private/members/calendarTools/report/components/ReportObjectivesBlock.scss","webpack://./src/styles/teamLeaderEvaluation.scss","webpack://./src/styles/personalHangar.scss","webpack://./src/styles/factionReputation.scss","webpack://./src/styles/personalHubBlueprint.scss","webpack://./src/styles/LoadingSpinner.scss","webpack://./src/styles/tools/tools.scss","webpack://./src/styles/tools/richeTextEditor.scss","webpack://./src/styles/header.scss","webpack://./src/styles/notifications.scss","webpack://./src/styles/publicPages.scss","webpack://./src/styles/privatePages.scss","webpack://./src/styles/confirm.scss","webpack://./src/styles/login.scss","webpack://./src/styles/identityCheckHub.scss","webpack://./src/styles/guestAccessPopup.scss","webpack://./src/styles/calendarSignupIntro.scss","webpack://./src/styles/onboarding.scss","webpack://./src/styles/divisionMedia.scss","webpack://./src/styles/settings.scss","webpack://./src/styles/settingmenu.scss","webpack://./src/styles/account.scss","webpack://./src/styles/security.scss","webpack://./src/styles/settingsTools.scss","webpack://./src/styles/settingsAccount.scss","webpack://./src/styles/adminPanel.scss","webpack://./src/styles/characterCreator.scss","webpack://./src/styles/adminDashboard.scss","webpack://./src/styles/adminAccounting.scss","webpack://./src/styles/adminWebsite.scss","webpack://./src/styles/siteAdminGroups.scss","webpack://./src/styles/adminPublicPages.scss","webpack://./src/styles/memberMgmtGeneralDashboard.scss","webpack://./src/styles/memberMgmtPlayerActivityDashboard.scss","webpack://./src/styles/memberMgmtPlayerHangar.scss","webpack://./src/styles/organisationMembers.scss","webpack://./src/styles/donatePanel.scss","webpack://./src/styles/profileThemesAdmin.scss","webpack://./src/styles/academy.scss","webpack://./src/styles/memberAcademy.scss","webpack://./src/styles/trainingStandards.scss","webpack://./src/styles/eventAuctions.scss","webpack://./src/styles/allOrganizations.scss","webpack://./src/styles/reserpage.scss","webpack://./src/styles/homepage.scss","webpack://./src/styles/faq.scss","webpack://./src/styles/gcu.scss","webpack://./src/styles/adminAssignments.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACGhB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AAt8BA;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;ACt8BA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,gDAAgD;EAChD,2BAA2B;EAC3B,mBAAmB;EACnB,2CAA2C;EAC3C,mDAAmD,EAAA;;AAGrD;EAAI,iBAAiB,EAAA;;AAErB;;EAEE,iBAAiB,EAAA;;ADMjB;ECFA,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,8BAA8B,EAAA;EANhC;IAUI,UAAU,EAAA;EAVd;IAcI,mBDHqB,EAAA;ECXzB;IAkBI,mBDNgB;ICOhB,kBAAkB,EAAA;EAnBtB;IAuBI,mBDHQ,EAAA;;ACOZ;EACE,aAAa,EAAA;;AAGf,yDAAA;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,MAAM;EACN,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,kCDtBsB;ECuBtB,0CDYkB;ECXlB,eAAe,EAAA;EAEf;IACE,eAAe;IACf,WAAW;IACX,yBAAyB,EAAA;;AAI7B;EACE,gBAAgB;EAChB,SAAS;EACT,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,cD5CkB;EC6ClB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,yDAAyD,EAAA;EAf3D;IAkBI,cDzDqB;IC0DrB,kCDZgB,EAAA;ECPpB;IAuBI,2CDrBgB;ICsBhB,mBAAmB,EAAA;;AAIvB;EACE,cDtEkB;ECuElB,mBD3BmB,EAAA;ECyBrB;IAKI,cD1EgB;IC2EhB,mBD/BiB,EAAA;;ACmCrB;;EAEE,aAAa;EACb,mBAAmB;EACnB,cD9EmB;EC+EnB,uBAAuB,EAAA;EALzB;;IAQI,cDlFiB;ICmFjB,uBAAuB,EAAA;;AAI3B;;EAEE,aAAa;EACb,+BD/FkB;ECgGlB,oCDpDmB,EAAA;ECgDrB;;IAOI,+BDnGgB;ICoGhB,oCDxDiB,EAAA;;AC4DrB,qDAAA;AACA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,SAAS;EACT,aAAa,EAAA;;AAGf;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EAEnB,gBAAgB;EAChB,cAAc;EACd,sCAAsC;EACtC,iBAAiB;EACjB,wBAAwB,EAAA;EAT1B;IAYI,cD1HgB;IC2HhB,yBDtEY;ICuEZ,6BAA6B,EAAA;IAdjC;MAiBM,cDhImB;MCiInB,yBD1Ee,EAAA;ECwDrB;IAuBI,cDrIgB;ICsIhB,yBD9FgB;IC+FhB,6BAA6B,EAAA;IAzBjC;MA4BM,cD3ImB;MC4InB,yBD7Fa,EAAA;ECgEnB;IAkCI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,mBDzIc;IC0Id,cDpJgB;ICqJhB,yBD3Ic;IC4Id,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,uBAAuB;IACvB,cAAc;IACd,2BAA2B,EAAA;IAhD/B;MAmDM,YAAY,EAAA;;AAKlB;EACE,aAAa;EACb,cDnKsB;ECoKtB,yBAAkC;EAClC,iBAAiB;EACjB,YAAY;EACZ,kBAAkB,EAAA;;AAGpB;EACE,UAAU;EACV,aAAa,EAAA;;AAGf;EACE,kBAAkB;EAClB,eAAe,EAAA;EAFjB;IAKI,kBAAkB;IAClB,qBAAqB;IACrB,4BAA4B;IAC5B,yBDvLoB;ICwLpB,cD7LgB;IC8LhB,qBAAqB;IACrB,yBD/LgB;ICgMhB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB,EAAA;IAfpB;MAmBM,WAAW;MACX,kBAAkB;MAClB,WAAW,EAAA;IArBjB;MAyBM,SAAS;MACT,UAAU;MACV,WAAW;MACX,YAAY;MACZ,yBDvMY;MCwMZ,yCAAyC,EAAA;IA9B/C;MAkCM,YAAY;MACZ,WAAW;MACX,WAAW;MACX,YAAY;MACZ,yBDhNY;MCiNZ,0CAA0C,EAAA;IAvChD;MA2CM,kBAAkB;MAClB,SAAS;MACT,WAAW;MACX,WAAW;MACX,YAAY;MACZ,yBDpOc;MCqOd,yBD3NY;MC4NZ,aAAa;MACb,mBAAmB;MACnB,uBAAuB,EAAA;MApD7B;QAuDQ,WAAW;QACX,YAAY,EAAA;;AAKpB;EACE,YAAY;EACZ,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;EAHX;IAMI,mBAAmB,EAAA;;AAIvB;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB,EAAA;EALrB;IAQI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,MAAM,EAAA;;AAIV;EACE,UAAU,EAAA;;AAGZ;;EAEE,UAAU,EAAA;;AAGZ;EAII,WAAW;EACX,kBAAkB;EAClB,QAAQ;EAAE,8CAAA;EACV,WAAW;EAAE,iDAAA;EACb,SAAS;EACT,UAAU;EACV,8BDrSU;ECsSV,+BDtSU;ECuSV,kBAAkB;EAAE,iDAAA;EACpB,oBAAoB;EAAE,mEAAA;EACtB,UAAU;EAAE,mDAAA,EAAoD;;AAdpE;EAkBI,kBAAkB;EAClB,UAAU;EAAE,mDAAA,EAAoD;;AAQpE;EACE,WAAW;EACX,kBAAkB;EAElB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB,EAAA;EAPpB;IAUI,gBAAgB,EAAA;;AAIpB;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB,EAAA;;AAGnB;;ED+XE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,cAjtBuB,EAAA;;ACmVzB;EDkYE,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,cAxtBkB,EAAA;;ACsVpB;EACE,eAAe;EACf,cDzVuB,EAAA;;AC4VzB;EACE,SAAS,EAAA;;AAGX;EACE,iBAAiB,EAAA;;AAGnB;EACE,WAAW,EAAA;;AAKb;;EAGI,kBAAkB;EAClB,UAAU;EACV,WAAW,EAAA;;AALf;;EASI,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,yBDnXoB;ECoXpB,mBD1XqB;EC2XrB,sBAAsB,EAAA;;AAjB1B;;EAqBI,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,qBDnYqB;ECoYrB,yBAAyB;EACzB,wBAAwB;EACxB,WAAW;EACX,aAAa,EAAA;;AAIjB;EACE,mBDnYU,EAAA;;ACsYZ;EACE,mBAAmB;EACnB,qBAAqB,EAAA;;AAIvB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EAAE,sCAAA,EAAuC;;AAI9D;EACE,kBAAkB;EAAE,sCAAA;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAAE,qCAAA;EAClB,gBAAgB;EAAE,iCAAA,EAAkC;;AAGtD;;EAEE,OAAO;EAAE,gCAAA,EAAiC;;AAI5C;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,cDragB;ECsahB,sBAAsB;EACtB,kBAAkB;EAClB,yBD/aY;ECkbZ,yDAA4C;EAC5C,wCAAwC;EACxC,+BAA+B;EAC/B,qBAAqB;EAErB,2CAA2C;EAC3C,iCAAiC,EAAA;EAlBnC;IAqBI,cDtbQ;ICubR,wCAAwC;IACxC,4CAA4C,EAAA;EAvBhD;IA2BI,0BAA0B;IAC1B,0CAA0C,EAAA;EA5B9C;IAgCI,sBAAsB;IACtB,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,eAAe,EAAA;;AAMnB;EACE,yBD1cgB,EAAA;ECyclB;IAII,yBD/cQ,EAAA;;ACkdZ;EACE,yBDjdgB;ECkdhB,cD7duB,EAAA;EC2dzB;IAOM,yBDzdM,EAAA;;AC6dZ;EACE,yBD5dgB;EC6dhB,cDxeuB,EAAA;ECsezB;IAKM,yBDleM,EAAA;;ACseZ;EACE,yBDzdmB;EC0dnB,cDjfuB,EAAA;EC+ezB;IAKM,yBAAgC,EAAA;;AAItC;EACE,yBD7ciB;EC8cjB,cD1fuB,EAAA;ECwfzB;IAKI,yBAAyC;IACzC,yBDpdiB,EAAA;;ACydrB;EAEI,yBDjgBU,EAAA;;ACqgBd;EAEI,yBAAkC,EAAA;;AAItC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB,EAAA;EANpB;IASI,yBAAkC,EAAA;EATtC;IAaI,yBDphBgB,EAAA;;AC0hBpB;EAGI,yBAAyB;EACzB,qCAAqC;EACrC,cD9hBQ,EAAA;;ACyhBZ;EASI,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB,EAAA;EAZpB;IAeM,WAAW;IACX,YAAY,EAAA;EAhBlB;IAqBM,YAAY;IACZ,0BAA0B,EAAA;EAtBhC;IA0BM,YAAY;IACZ,gBAAgB,EAAA;EA3BtB;IA+BM,0BAA0B,EAAA;;AA/BhC;EAoCI,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B,EAAA;EAvC/B;IA0CM,WAAW;IACX,YAAY;IACZ,YAAY,EAAA;EA5ClB;IAgDM,0BAA0B,EAAA;EAhDhC;IAoDM,gBAAgB,EAAA;EApDtB;IAwDM,0BAA0B,EAAA;;AAxDhC;EA6DI,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe,EAAA;EAhEnB;IAmEM,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,gBAAgB,EAAA;EAtEtB;IA4EQ,wBAAwB,EAAA;EA5EhC;IA+EQ,gBAAgB,EAAA;EA/ExB;IAkFQ,wBAAwB,EAAA;EAlFhC;IAyFQ,wBAAwB,EAAA;EAzFhC;IA4FQ,gBAAgB,EAAA;EA5FxB;IA+FQ,wBAAwB,EAAA;;AA/FhC;EAqGI,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB,EAAA;EAxGpB;IA2GM,WAAW;IACX,YAAY,EAAA;EA5GlB;IAiHM,YAAY;IACZ,0BAA0B,EAAA;EAlHhC;IAsHM,YAAY;IACZ,gBAAgB,EAAA;EAvHtB;IA2HM,YAAY;IACZ,0BAA0B,EAAA;;AAMhC;EACE,WAAW;EAAE,iDAAA,EAAkD;;AAIjE;EACE,kBAAkB;EAClB,eAAe;EAEf,yBAAyB;EACzB,+BAA+B;EAAE,2DAAA;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,cDlrBuB;ECmrBvB,mBAAmB;EACnB,oCAAoC;EACpC,mBAAmB;EACnB,yBAAyB;EACzB,yBD5qBgB;EC6qBhB,mBAAmB,EAAA;EAfrB;IAmBI,iBAAiB;IACjB,kBAAkB,EAAA;EApBtB;IAwBI,yBAA0B;IAC1B,YAAY;IACZ,qBAAqB,EAAA;EA1BzB;IA8BI,qCAAqC,EAAA;EA9BzC;IAkCI,eAAe;IACf,sBAAsB;IACtB,yBAAkC;IAClC,WAAW;IACX,gBAAgB,EAAA;IAtCpB;MAyCQ,sBAAsB,EAAA;IAzC9B;MA8CQ,gBAAgB,EAAA;;AAUxB;EACE,YAAY;EACZ,UAAU,EAAA;;AAEZ;EACE,eAAe;EACf,cD/tBkB;ECguBlB,YAAY;EACZ,UAAU,EAAA;;AAGZ;EACE,eAAgB,EAAA;;AAGlB;EACE,eAAgB,EAAA;;AAGlB;EACE,gBAAiB,EAAA;;AAGnB;EACE,gBAAiB,EAAA;;AAGnB;EACE,gBAAiB,EAAA;;AAGnB;EACE,mBAAoB,EAAA;;AAGtB;EACE,mBAAoB,EAAA;;AAKtB;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,cDrwBgB;ECswBhB,yBAAyB;EACzB,mBAAmB,EAAA;EARrB;IAWI,aAAa,EAAA;EAXjB;IAeI,cAAc,EAAA;EAflB;IAmBI,0CAA0C,EAAA;EAnB9C;IAuBI,YAAY,EAAA;EAvBhB;IA6BI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,cDhzBqB;ICizBrB,kBAAkB;IAClB,eAAe;IACf,0CAA0C,EAAA;IAzC9C;MA4CM,mBAAmB;MACnB,iBAAiB;MACjB,aAAa;MACb,WAAW;MACX,kBAAkB;MAClB,cAAc,EAAA;IAjDpB;MAqDM,kBAAkB;MAClB,SAAS;MACT,UAAU;MACV,WAAW;MACX,YAAY;MACZ,iBAAiB,EAAA;EA1DvB;IA+DI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,cDl1BqB;ICm1BrB,kBAAkB;IAClB,eAAe;IACf,0CAA0C,EAAA;IA3E9C;MA8EM,kBAAkB;MAClB,SAAS;MACT,UAAU;MACV,WAAW;MACX,YAAY;MACZ,iBAAiB,EAAA;EAnFvB;IAwFI,gBAAgB;IAChB,oBAAoB,EAAA;IAzFxB;MA4FM,kBAAkB;MAClB,iBAAiB;MACjB,QAAQ,EAAA;IA9Fd;MAmGM,cAAc,EAAA;IAnGpB;MAuGM,cD72BQ,EAAA;ECswBd;IA4GI,iBAAiB,EAAA;EA5GrB;IAiHI,kBAAkB;IAClB,gBAAgB,EAAA;;AAQpB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,sBAAsB,EAAA;;AAGxB;EACE,mBAAmB;EACnB,aAAa;EACb,oBAAoB,EAAA;;AA7Hf;EAiIL,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,UAAU,EAAA;;AAGZ;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,WDtC8B;ECuC9B,YDtC+B;ECuC/B,oBAAoB;EACpB,oCAAoC;EACpC,2CAA2C;EAC3C,iFAAiF,EAAA;;AAGnF;EACE,kBAAkB;EAClB,QD7C6B;EC8C7B,SD9C6B;EC+C7B,WDhD6B;ECiD7B,YDjD6B;ECkD7B,kBAAkB;EAClB,qCAAqC;EACrC,yCAAyC;EACzC,uDAAuD,EAAA;;AAGzD;;EAEE,oCAAoC;EACpC,sCAAsC;EACtC,8CAA8C,EAAA;;AAGhD;;EAEE,2BAAkD;EAClD,mBAAmB,EAAA;;AAGrB;EACE,2CD75BmB;EC85BnB,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY,EAAA;EAHd;IAMI,aAAa,EAAA;EANjB;IAUI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,yDAA0C;IAC1C,yBD39BgB;IC49BhB,+BAA+B;IAC/B,eAAe;IACf,mBAAmB,EAAA;IApBvB;MAuBM,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,WAAW;MACX,SAAS;MACT,WAAW;MACX,yDAA0C;MAC1C,eAAe;MACf,kBAAkB,EAAA;EA/BxB;IAoCI,sCAAqC,EAAA;IApCzC;MAuCM,2BAA2B,EAAA;EAvCjC;IA4CI,2BD5+Bc,EAAA;;ACm/BlB;;EAEE,kBAAkB;EAClB,aAAa;EACb,yBDv/BgB;ECw/BhB,iDAAiD,EAAA;;AAGnD;EACE,cDvgCuB;ECwgCvB,yBDngCiB;ECogCjB,kBAAkB;EAClB,aAAa,EAAA;;AAGf;EACE,cDxgCsB;ECygCtB,gBAAgB;EAChB,yBD/gCkB;ECghClB,kBAAkB;EAClB,iBAAiB,EAAA;;AAMnB;EACE,WAAW;EACX,UAAU;EACV,eD1hCkB;EC2hClB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B,EAAA;EANjC;IASM,eAAe;IACf,eDvhCY;ICwhCZ,aDliCc,EAAA;;ACsiCpB;EACE,WAAW;EACX,kCAAkC,EAAA;;AAGpC;EACE,WAAW;EACX,kCAAkC,EAAA;;AAGpC;EACE,WAAW;EACX,gCAAgC,EAAA;;AAGlC;EACE,kBAAkB;EAClB,gCAAgC,EAAA;ED5sBhC;IACE,WAAW;IACX,aA1WU;IA2WV,eA9WgB,EAAA;IAgXhB;MACE,aAjXc;MAkXd,eAxWY,EAAA;EA4WhB;IACE,YAAY,EAAA;;ACusBhB;;EAII,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB,EAAA;;AAPtB;;EAWI,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB,EAAA;;AAdtB;;EAkBI,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB,EAAA;;AArBvB;;EAyBI,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB,EAAA;;AA5BvB;;EAgCI,WAAW;EACX,YAAY;EACZ,cAAc,EAAA;;AAIlB;EACE,kBAAkB;EAClB,kCAAkC,EAAA;ED3vBlC;IACE,WAAW;IACX,aA1WU;IA2WV,eA9WgB,EAAA;IAgXhB;MACE,aAjXc;MAkXd,eAxWY,EAAA;EA4WhB;IACE,YAAY,EAAA;;ACmvBhB;EACE,kBAAkB;EAClB,kCAAkC,EAAA;EDjwBlC;IACE,WAAW;IACX,aA1WU;IA2WV,eA9WgB,EAAA;IAgXhB;MACE,aAjXc;MAkXd,eAxWY,EAAA;EA4WhB;IACE,YAAY,EAAA;;ACyvBhB;EACE,eAAe;EAEf,cD/mCiB;ECgnCjB,sCAAsC,EAAA;;AAGxC;EACE,eAAe;EACf,yBDznCkB;EC0nClB,cDtnCiB;ECunCjB,sCAAsC,EAAA;;AAIxC,sCAAA;AACA;EACE,gBAAgB;EAChB,SAAS;EAAE,2DAAA;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY,EAAA;EALd;IAQI,eAAe,EAAA;;AAInB;EACE,aAAa,EAAA;;AAGf;EACE,kBAAkB;EAClB,UAAU;EACV,6BAA6B;EAC7B,cAAc,EAAA;;AAIhB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,yBAAyB;EACzB,aAAa,EAAA;EAVf;IAaI,YAAY;IACZ,yBDlqCe;ICmqCf,YAAY;IACZ,aAAa;IACb,gCDzqCgB;IC0qChB,8BAA8B,EAAA;IAlBlC;MAqBM,wBAAwB;MACxB,WAAW;MACX,cD/qCc;MCgrCd,6BAA6B;MAC7B,yBAAyB;MACzB,aAAa,EAAA;MA1BnB;QA6BQ,cAAc,EAAA;IA7BtB;MAkCM,wBAAwB;MACxB,YAAY,EAAA;EAnClB;IAwCI,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,8BAA8B,EAAA;IA3ClC;MA+CM,UAAU,EAAA;IA/ChB;MAmDM,mBAAmB;MACnB,kBAAkB,EAAA;IApDxB;MAwDM,yBDtsCY;MCusCZ,kBAAkB,EAAA;MAzDxB;QA2DQ,yBAAwC,EAAA;IA3DhD;MAgEM,WAAW;MACX,WAAW;MACX,eAAe,EAAA;IAlErB;MAsEM,qBD1tCa,EAAA;;AC+tCnB;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB,EAAA;;AAGvB;EACE,gBAAgB;EAChB,gBAAgB,EAAA;EDjgBd;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;;ACsfjE;EACE,oCAAwC;EACxC,mDAAkD;EAClD,yBAA6B,EAAA;;AAI/B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,wCDlvCgB;ECmvChB,kBAAkB;EAClB,cD/vCuB;ECgwCvB,kCDrvCgB;ECsvChB,eAAe;EACf,gBAAgB,EAAA;;AAGlB;EACE,qBD9vCkB;EC+vClB,kCD5vCgB,EAAA;;AC+vClB;EACE,aAAa;EACb,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;EACR,oBAAoB;EACpB,mCD1wCiB,EAAA;;AC6wCnB;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc,EAAA;;AAGhB;EACE,yEAAyE,EAAA;;AAG3E;EACE,eAAe;EACf,QAAQ,EAAA;;AAGV;EACE;IACE,QAAQ,EAAA;EAGV;IACE,WAAW,EAAA,EAAA;;AAKf;EAv/BA;IAoiCI,6BAA6B,EAAA;EAznBjC;IA6nBI,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,cD/1CgB;ICg2ChB,YAAY;IACZ,UAAU,EAAA,EACX;;ADt4CH;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AEr8BA;EACI,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW,EAAA;;AAGb;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,eAAe,EAAA;;AAGjB;EACE,YAAY;EACZ,0BAA0B;EAC1B,6BAA6B;EAC7B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe,EAAA;EAPjB;IAUM,cFOU,EAAA;;AEHhB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe,EAAA;;AAGjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAA;;AAGf;EACE,yBFzBoB;EE0BpB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB,EAAA;EFqsBhB;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;EEhtB7D;IAZF;MAaM,YAAY;MACZ,gBAAgB,EAAA;MF+rBpB;QACI,UAjKa,EAAA;MAoKjB;QACI,mBApKuB;QAqKvB,kBAAkB;QAClB,kBAAkB,EAAA;MAGtB;QACI,yBA3uBU;QA4uBV,kBAAkB,EAAA;QAElB;UACI,yBAAqD,EAAA,EACxD;EE5sBD;IAjBN;MAkBQ,YAAY,EAAA,EAGnB;;AAED;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,eAAe,EAAA;;AFtFnB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AGv8BA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;EACX,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,YAAY;EAEZ,qGAAsG;EACtG,WAAW,EAAA;;AAGb;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,wDAAwD,EAAA;EAJ1D;IAOI,YAAY;IACZ,YAAY,EAAA;EARhB;IAYI,WAAW;IACX,aAAa,EAAA;;AAIjB;EACE,aAAa;EACb,6BAA6B,EAAA;EAF/B;IAKI,iBAAiB,EAAA;EALrB;IASI,cAAc;IACd,4BAA4B,EAAA;;AAIhC;EACE,yBHvBsB;EGwBtB,WAAW;EACX,WAAW;EACX,cAAc;EACd,wEAAwE;EACxE,WAAW,EAAA;;AAGb;EACE,oBAAoB,EAAA;;AAKtB,wBAAA;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,sCAAsC,EAAA;;AAGxC;EACE,UAAU,EAAA;;AAGZ;EACE;IACE,qBAAqB;IACrB,UAAU,EAAA;EAEZ;IACE,oBAAoB;IACpB,UAAU,EAAA,EAAA;;AAKZ;EACE,OAAK,EAAA;;AAEP;EACE,QAAM,EAAA;;AAJR;EACE,OAAK,EAAA;;AAEP;EACE,QAAM,EAAA;;AAJR;EACE,OAAK,EAAA;;AAEP;EACE,QAAM,EAAA;;AAJR;EACE,OAAK,EAAA;;AAEP;EACE,QAAM,EAAA;;AAJR;EACE,OAAK,EAAA;;AAEP;EACE,QAAM,EAAA;;AAJR;EACE,OAAK,EAAA;;AAEP;EACE,QAAM,EAAA;;AAJR;EACE,OAAK,EAAA;;AAEP;EACE,QAAM,EAAA;;AAJR;EACE,OAAK,EAAA;;AAEP;EACE,QAAM,EAAA;;AAJR;EACE,OAAK,EAAA;;AAEP;EACE,QAAM,EAAA;;AAJR;EACE,OAAK,EAAA;;AAEP;EACE,QAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,QAAK,EAAA;;AAEP;EACE,SAAM,EAAA;;AAJR;EACE,SAAK,EAAA;;AAEP;EACE,UAAM,EAAA;;AAMV,sEAAA;AACA;EAxCA;IA0CI,WAAW;IACX,YAAY;IACZ,yBAAyB,EAAA;EAG3B;IACE;MACE,qBAAqB;MACrB,UAAU,EAAA;IAEZ;MACE,oBAAoB;MAAE,8CAAA;MACtB,UAAU,EAAA,EAAA,EAAA;;AH/HhB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AAt8BA;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AIv8BA;EACI,iBAAiB;EACjB,yBJsCc;EIrCd,gCJqCc;EIpCd,kBAAkB;EAClB,yBJ8BoB;EI7BpB,iCAAiC,EAAA;EANrC;IASI,aAAa;IACb,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,cJgBgB;IIfhB,yGAAiG;IACjG,gCJiBU,EAAA;IIjCd;MAoBY,WAAW,EAAA;IApBvB;MAyBY,UAAU;MACV,iBAAiB,EAAA;IA1B7B;MA8BY,UAAU;MACV,OAAO,EAAA;IA/BnB;MAoCY,UAAU;MACV,OAAO,EAAA;EArCnB;IA6CI,gBAAgB;IAChB,YAAY;IACZ,cAAc,EAAA;IJytBd;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;IIvxBjE;MAmDQ,kBAAkB;MAClB,aAAa;MACb,gBAAgB;MAChB,mBAAmB;MACnB,YAAY;MACZ,sCAAsC,EAAA;MAxD9C;QA2DY,yBJzBO,EAAA;MIlCnB;QA8DY,yBJ3BY,EAAA;MInCxB;QAkEY,WAAW;QACX,kBAAkB;QAClB,sCAAsC,EAAA;MApElD;QAwEY,YAAY,EAAA;MAxExB;QA6EY,aAAa;QACb,mBAAmB,EAAA;QA9E/B;UAiFY,WAAW;UACX,eAAe,EAAA;QAlF3B;UAqFY,aAAa;UACb,sBAAsB;UACtB,gBAAgB;UAChB,UAAU,EAAA;QAxFtB;UA4FY,SAAS;UACT,OAAO;UACP,uBAAuB,EAAA;UA9FnC;YAiGgB,WAAW;YACX,YAAY;YACZ,kBAAkB;YAClB,yBJtEI;YIuEJ,gBAAgB;YAChB,6BAA6B;YAC7B,eAAe;YACf,kBAAkB,EAAA;YAxGlC;cA2GoB,yBJvDC;cIwDD,qBJrDA,EAAA;cIvDpB;gBA+GoB,WAAW;gBACX,kBAAkB;gBAClB,QAAQ;gBACR,SAAS;gBACT,UAAU;gBACV,WAAW;gBACX,qBJxFK;gBIyFL,yBAAyB;gBACzB,wBAAwB,EAAA;QAvH5C;UA+HY,iBAAiB;UACjB,cJnGa;UIoGb,kBAAkB,EAAA;UAjI9B;YAmIwB,gBAAgB,EAAA;UAnIxC;YAoIwB,iBAAiB,EAAA;UApIzC;YAqIwB,iBAAiB,EAAA;UArIzC;YAsIwB,iBAAiB,EAAA;UAtIzC;YAuIwB,iBAAiB,EAAA;UAvIzC;YAwIwB,kBAAkB,EAAA;QAxI1C;UA4IY,cJ9GQ;UI+GR,gBAAgB;UAChB,kBAAkB,EAAA;MA9I9B;QAmJY,2BAA2B,EAAA;MAnJvC;QAwJY,UAAU,EAAA;IAxJtB;MA6JQ,WAAW;MACX,kBAAkB;MAClB,oBAAoB;MACpB,cAAc;MACd,UAAU,EAAA;MAjKlB;QAoKY,2BJnIE,EAAA;QIjCd;UAuKgB,WAAW;UACX,kBAAkB;UAClB,QAAQ;UACR,OAAO;UACP,QAAQ;UACR,WAAW,EAAA;;AAQ3B;EACE,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;EAJrB;IAOI,WAAW;IACX,YAAY;IACZ,8DAA4D;IAC5D,sEAAqE;IACrE,kBAAkB;IAClB,0BAA0B;IAC1B,yBJhKU;IIiKV,qBAAqB,EAAA;EAdzB;IAkBI,yBJlJiB,EAAA;EIgIrB;IAsBI,yBJzKU;II0KV,YAAY,EAAA;;AJ1MhB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AAt8BA;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AKp8BA;EACE;;IAEE,aAAa;IACb,8EAEgC,EAAA;EAGlC;IACE,UAAU;IACV,iFAEmC,EAAA;EAGrC;IACE,YAAY;IACZ,iFAEoC,EAAA,EAAA;;AAIxC;EACE;IACE,2BAA2B;IAC3B,aAAa,EAAA;EAGf;IACE,aAAa,EAAA;EAGf;IACE,0BAA0B;IAC1B,aAAa,EAAA,EAAA;;AAIjB;EACE;;IAEE,0BAA0B,EAAA;EAG5B;IACE,mCAAmC,EAAA;EAGrC;IACE,mCAAmC,EAAA;EAGrC;IACE,kCAAkC,EAAA;EAGpC;IACE,oCAAoC,EAAA,EAAA;;AAIxC;EACE;IACE,6BAA6B,EAAA;EAG/B;IACE,iCAAiC,EAAA,EAAA;;AAIrC;EACE;;IAEE,aAAa;IACb,+EAEmC,EAAA;EAGrC;IACE,UAAU;IACV,gFAEoC,EAAA;EAGtC;IACE,aAAa;IACb,gFLxDQ,EAAA,EAAA;;AK8DZ;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB,EAAA;;AAGnB;EAEI,aAAa;EACb,oBAAoB,EAAA;;AAHxB;EAOI,aAAa;EACb,oBAAoB,EAAA;;AAIxB;;EAGI,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,sEAAsE;EACtE,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,gEAAgE,EAAA;EAbpE;;IAgBM,kBAAkB;IAClB,UAAU,EAAA;EAjBhB;;IAqBM,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;IACb,weAsBG;IACH,qCAAqC;IACrC,2HAEoD;IACpD,0BAA0B,EAAA;EAvDhC;;IA2DM,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,oBAAoB;IACpB,+HAMC;IACD,aAAa;IACb,wBAAwB;IACxB,2HAE4C,EAAA;EAG9C;IA9EJ;;MA+EM,eAAe,EAAA;MA/ErB;;;QAmFQ,eAAe;QACf,aAAa,EAAA,EACd;;AArFP;EA0FI,+BAA8B;EAC9B,kEAAkE,EAAA;EA3FtE;IA8FM,aAAa;IACb,geAsBG;IACH,0BAA0B,EAAA;EAtHhC;IA0HM,uIAMC;IACD,aAAa;IACb,wBAAwB,EAAA;EAG1B;IArIJ;MAsIM,eAAe,EAAA;MAtIrB;QA0IQ,eAAe;QACf,YAAY,EAAA,EACb;;AA5IP;EAiJI,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,iCAAiC;EACjC,gCAAgC;EAChC,2BAA2B;EAC3B,kCAAkC;EAClC,yDAAyD;EACzD,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,cLvPqB,EAAA;EKyFzB;IAiKM,+BAA+B,EAAA;EAjKrC;;IAsKM,UAAU;IACV,2BAA2B,EAAA;EAvKjC;;IA4KM,UAAU;IACV,wBAAwB,EAAA;EA7K9B;IAiLM,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,cLhRmB;IKiRnB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,kBAAkB,EAAA;IA7LxB;MAiMQ,WAAW;MACX,kBAAkB;MAClB,QAAQ;MACR,wEAAwE;MACxE,oBAAoB;MACpB,WAAW;MLqTjB,mHAAiF;MACjF,sBAAsB;MACtB,4BAA4B;MAC5B,2BAA2B,EAAA;IK9f7B;MA4MQ,WAAW;MACX,kBAAkB;MAClB,QAAQ;MACR,0BAA0B;MAC1B,wEAAwE;MACxE,oBAAoB;MACpB,WAAW;MACX,mBLhSe;MKiSf,+FAEgD,EAAA;IAtNxD;MA0NQ,iBAAiB;MACjB,SAAS;MACT,cLrTiB,EAAA;IKyFzB;MAgOQ,aAAa;MACb,uBAAuB;MACvB,QAAQ;MACR,OAAO;MACP,YAAY;MACZ,iBAAiB,EAAA;IArOzB;MAyOQ,cAAc;MACd,YAAY;MACZ,WAAW;MACX,mBAAmB;MAEnB,sOAKgD;MAChD,wBAAwB,EAAA;IApPhC;MAwPQ,cAAc;MACd,WAAW;MACX,YAAY;MACZ,mBAAmB;MACnB,iBAAiB;MACjB,0CL5Sa;MK6Sb,+BAA+B;MAC/B,0IAGgD;MAChD,wBAAwB,EAAA;IAnQhC;MAuQQ,qBAAqB;MACrB,aAAa,EAAA;IAxQrB;MA4QQ,aAAa;MACb,sBAAsB;MACtB,YAAY;MACZ,QAAQ,EAAA;IA/QhB;MAmRQ,eAAe;MACf,gBAAgB;MAChB,sBAAsB;MACtB,gBAAgB;MAChB,uBAAuB;MACvB,mBAAmB;MACnB,gBAAgB,EAAA;IAzRxB;MA6RQ,kBAAkB;MAClB,YAAY;MACZ,gBAAgB;MAChB,gBAAgB;MAChB,uBAAuB;MACvB,mBAAmB,EAAA;IAlS3B;MAsSQ,kBAAkB;MAClB,gBAAgB;MAChB,YAAY;MACZ,cLlYiB;MKmYjB,iBAAiB;MACjB,cAAc;MACd,kBAAkB;MAClB,WAAW;MACX,cAAc;MACd,eAAe,EAAA;MA/SvB;QAkTU,cL1Vc;QK2Vd,yBL5Ye,EAAA;EKyFzB;IA4TQ,aAAa;IACb,kBAAkB,EAAA;;AAO1B;EACE,eAAe;EACf,MAAM;EACN,aAAa;EACb,YAAY;EACZ,aAAa;EACb,yDAAyE;EACzE,+CL1XmB;EK2XnB,4CAA4C;EAC5C,WAAW;EACX,mDAAmD,EAAA;EAVrD;IAaI,QAAQ,EAAA;EAbZ;IAiBI,gBAAgB;IAEhB,4BAA4B;IAC5B,2BAA2B;IAC3B,cAAc;IAEd,aAAa;IACb,mBAAmB;IACnB,8BAA8B,EAAA;IAzBlC;MA4BM,SAAS;MACT,eAAe;MACf,mBAAmB;MACnB,yBAAyB;MACzB,cAAc,EAAA;IAhCpB;MAoCM,oCLvZe;MKwZf,yCLxZe;MKyZf,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,cAAc;MACd,eAAe;MACf,eAAe;MACf,yBAAyB,EAAA;MA5C/B;QA+CQ,mCLlaa;QKmab,WAAW,EAAA;EAhDnB;IAsDI,0BAA0B;IAC1B,gBAAgB;IAChB,aAAa,EAAA;IAxDjB;MA2DM,SAAS;MACT,eAAe;MACf,gBAAgB;MAChB,WAAW;MACX,qBAAqB;MACrB,8CLnbe,EAAA;IKmXrB;MAoEM,eAAe;MACf,cLjec;MKked,mBAAmB;MACnB,aAAa,EAAA;IAvEnB;MA2EM,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,mBAAmB,EAAA;IA9EzB;MAkFM,gBAAgB;MAChB,eAAe;MACf,mBAAmB,EAAA;IApFzB;MAwFM,eAAe;MACf,cLtfmB;MKufnB,gBAAgB,EAAA;IA1FtB;MA8FM,aAAa;MACb,eAAe;MACf,cL7fmB,EAAA;MK6ZzB;QAmGQ,cLtda;QKudb,gBAAgB,EAAA;IApGxB;MAyGM,YAAY;MACZ,6CL7de;MK8df,cAAc,EAAA;IA3GpB;MA+GM,eAAe;MACf,mBAAmB;MACnB,yBAAyB;MACzB,mBAAmB;MACnB,cLvec,EAAA;IKoXpB;MAuHM,kBAAkB;MAClB,aAAa;MACb,SAAS;MACT,uBAAuB;MACvB,qDAAkE;MAClE,0CL/ee;MKgff,mBAAmB;MACnB,kBAAkB;MAClB,mBAAmB;MACnB,gBAAgB,EAAA;MAhItB;QAmIQ,cAAc;QACd,WAAW;QACX,YAAY;QACZ,eAAe;QACf,mBAAmB;QACnB,YAAY,EAAA;MAxIpB;QA4IQ,OAAO;QACP,YAAY,EAAA;MA7IpB;QAiJQ,WAAW;QACX,kBAAkB;QAClB,QAAQ;QACR,uFAAuF;QACvF,UAAU;QACV,6BAA6B,EAAA;MAtJrC;QA0JQ,UAAU,EAAA;MA1JlB;QA8JQ,cAAc;QACd,eAAe;QACf,WAAW;QACX,kBAAkB,EAAA;MAjK1B;QAqKQ,aAAa;QACb,SAAS;QACT,eAAe;QACf,eAAe;QACf,cLrkBY,EAAA;;AK8kBpB;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa,EAAA;;AAGf;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,cAAc;EACd,mBL5iBuB,EAAA;;AK+iBzB;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,0CLhkBmB;EKikBnB,gBAAgB;EAChB,kCL5jBuB;EK6jBvB,gCL7mBuB;EK8mBvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,4EAA4E,EAAA;EAlB9E;IAqBI,oCL1kBiB;IK2kBjB,sCL3kBiB;IK4kBjB,cLxnBgB,EAAA;;AK4nBpB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,SAAS;EACT,wBAAwB;EACxB,0CL5kBoB;EK6kBpB,oBAAoB;EACpB,6FAIC;EACD,cLplByB;EKqlBzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,wHL5lByB;EKgmBzB,6CL5lBwB;EK6lBxB,uHAKuB,EAAA;EAhCzB;IAoCI,qBL1mBuB;IK2mBvB,8FAIC;IACD,cLtqBgB;IKuqBhB,uHLjnBuB,EAAA;;AKwnB3B;;EAEE,UAAU;EACV,oBAAoB,EAAA;;AAGtB;EACE,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iCLprBsB,EAAA;;AKurBxB;EACE,uBAAO;EACP,4BAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,0CL1pBmB;EK2pBnB,mBLrpBuB;EKspBvB,6CLhsBsB,EAAA;;AKmsBxB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,qBAAqB;EACrB,kDL/sBuB,EAAA;;AKktBzB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cLxtBuB,EAAA;;AK2tBzB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,SAAS;EACT,UAAU;EACV,0CLzrBmB;EK0rBnB,kCL9tBsB;EK+tBtB,gCLruBuB;EKsuBvB,kBAAkB;EAClB,eAAe,EAAA;EAZjB;IAgBI,oCLjsBiB;IKksBjB,cL9uBgB,EAAA;;AKkvBpB;EACE,cAAc;EACd,aAAa,EAAA;;AAGf;EACE,SAAS,EAAA;;AA+BX;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0CL9uBmB;EK+uBnB,kFAEgC,EAAA;EANlC;IAUI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UA1C4B;IA2C5B,YAAY;IACZ,UAAU;IACV,yHAjCH;IAkCG,mpELvvBqB;IKgzBrB,4BAA4B;IAC5B,qKAIgC;IAChC,oBAAoB,EAAA;EAjFxB;IAsFI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,UArHyB;IAsHzB,YAAY;IACZ,UAAU;IACV,mGArGH;IAsGG,shBLn0BqB;IKo1BrB,4BAA4B;IAC5B,qKAIiC;IACjC,oBAAoB,EAAA;;AAIxB;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAxJ2B;EAyJ3B,YAAY;EACZ,UAAU;EACV,oBAAoB,EAAA;;AAGtB;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,4BAA4B;EAC5B,mGAnJD;EAoJC,oDLv3BmB;EKw3BnB,oBAAoB,EAAA;EAVtB;IAaI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WA9KsB;IA+KtB,YA/KsB;IAgLtB,8CLj4BiB;IKk4BjB,+CLl4BiB;IKm4BjB,sFL/6BgB;IKk7BhB,oBAAoB,EAAA;EAxBxB;IA4BI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WA7LsB;IA8LtB,YA9LsB;IA+LtB,6CAA6C;IAC7C,gDLj5BiB;IKk5BjB,iDLl5BiB;IKm5BjB,+HAKC;IACD,yFLr8BgB;IKw8BhB,oBAAoB,EAAA;;AAIxB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB,EAAA;EAJtB;IAOI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,UAAU;IACV,uIAMC;IACD,sHAAsH;IACtH,YAAY,EAAA;;AAIhB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,sCAAsC,EAAA;;AAGxC;EACE,UAAU,EAAA;;AAIZ;EACE,kBAAkB;EAClB,QAAQ;EAER,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,wCLt8BuB,EAAA;EKy8BvB;IACE,6BAA6B,EAAA;IAD9B;MAKG,aAAa;MACb,aAAa,EAAA;EAhBnB;IAsBI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,oBAAoB;IACpB,sBAAsB;IACtB,gwCAsEG,EAAA;EAlGP;IAwGI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,oBAAoB;IACpB,8nfAqN4E,EAAA;EAlUhF;IAsUI,UAAU;IACV,mOAYG,EAAA;EAnVP;IAyVI,kBAAkB;IAClB,2BAA2B;IAC3B,8BAA8B;IAC9B,UAAU;IACV,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;IACV,2FAKC;IACD,8CLz1CgB;IK01ChB,6BAA6B;IAC7B,+BAA+B,EAAA;IA1WnC;MA6WM,qFAAqF,EAAA;IA7W3F;MAkXM,iBAAc;MACd,kBAAe;MACf,mBAAa;MACb,mBAAa;MACb,sBAAgB;MAChB,yBAAmB,EAAA;IAvXzB;MA2XM,kBAAc;MACd,mBAAe;MACf,mBAAa;MACb,mBAAa;MACb,sBAAgB;MAChB,yBAAmB,EAAA;IAhYzB;MAqYM,iBAAc;MACd,mBAAe;MACf,mBAAa;MACb,mBAAa;MACb,sBAAgB;MAChB,yBAAmB,EAAA;IA1YzB;MA8YM,kBAAc;MACd,mBAAe;MACf,mBAAa;MACb,mBAAa;MACb,sBAAgB;MAChB,wBAAmB,EAAA;IAnZzB;MAuZM,iBAAc;MACd,mBAAe;MACf,mBAAa;MACb,mBAAa;MACb,sBAAgB;MAChB,wBAAmB,EAAA;IA5ZzB;MAiaM,kBAAc;MACd,mBAAe;MACf,mBAAa;MACb,mBAAa;MACb,sBAAgB;MAChB,yBAAmB,EAAA;IAtazB;MA0aM,kBAAc;MACd,mBAAe;MACf,mBAAa;MACb,mBAAa;MACb,sBAAgB;MAChB,yBAAmB,EAAA;IA/azB;MAmbM,iBAAc;MACd,mBAAe;MACf,mBAAa;MACb,mBAAa;MACb,sBAAgB;MAChB,yBAAmB,EAAA;EAIvB;IACE,gEAAgE,EAAA;EAGlE;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,oBAAoB;IACpB,+BAA+B;IAC/B,+iBA8BG;IACH,gEAAgE,EAAA;;AAIpE;EACE;IACE,UAAU;IACV,8DAA8D,EAAA;EAGhE;IACE,UAAU,EAAA;EAGZ;IACE,UAAU,EAAA;EAGZ;IACE,UAAU;IACV,4GACqC,EAAA,EAAA;;AAIzC;EACE;;IAEE,4DAA4D,EAAA;EAG9D;IACE,oFAAoF,EAAA;EAGtF;IACE,qFAAqF,EAAA;EAGvF;IACE,iFAAiF,EAAA;EAGnF;IACE,iFAAiF,EAAA;EAGnF;IACE,mFAAmF,EAAA,EAAA;;AAIvF;EACE;;IAEE,oEAAoE;IACpE,aAAa,EAAA;EAGf;IACE,mFAAmF;IACnF,aAAa,EAAA;EAGf;IACE,mFAAmF;IACnF,YAAY,EAAA;EAGd;IACE,iFAAiF;IACjF,aAAa,EAAA;EAGf;IACE,qFAAqF;IACrF,aAAa,EAAA,EAAA;;AAIjB;EACE;;IAEE,eAAe,EAAA;EAxjBnB;IA4jBI,aAAa,EAAA,EACd;;AAGH;EACE,kBAAkB;EAClB,QAAQ;EACR,mOAYG,EAAA;;AAGL;EACE,aAAa;EACb,0DAA0D;EAC1D,MAAM;EACN,sCAA8D;EAC9D,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,iBAAiB,EAAA;;AAGnB;EACE,qCAAqC,EAAA;;AAGvC;EACE,UAAU,EAAA;;AAGZ;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,4BAA4B,EAAA;;AAG9B;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,cAAc,EAAA;;AAGhB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,kDAAkD,EAAA;;AAGpD;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBLjlDkB;EKklDlB,sBAAsB;EACtB,UAAU;EACV,oBAAoB,EAAA;;AAGtB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,oBAAoB,EAAA;;AAGtB;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY,EAAA;;AAGd;EACE,YAAY;EACZ,mBAAmB;EACnB,2FAG4C;EAC5C,wBAAwB,EAAA;;AAI1B;EACE,2FAE0C,EAAA;;AAG5C;EACE,mBAAmB;EACnB,0CL5nDmB;EK6nDnB,8BAA+B,EAAA;;AAGjC;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY,EAAA;;AAKd;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAiD;EACjD,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,iBAAiB;EACjB,oBAAoB,EAAA;EATtB;IAYI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,gCAAgC,EAAA;EAjBpC;IAqBI,WAAW,EAAA;EArBf;IAyBI,WAAW;IACX,YAAY,EAAA;EA1BhB;IA8BI,SAAS;IACT,WAAW;IACX,gCAAgC,EAAA;EAhCpC;;IAqCI,6BAA6B,EAAA;;AAIjC;EACE,sBAAsB,EAAA;;AAGxB;EACE,SAAS;EACT,cAAc;EACd,YAAY;EACZ,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cLlvDkB;EKmvDlB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe,EAAA;;AAGjB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,eAAe,EAAA;EALjB;IAUM,UAAU;IACV,mBAAmB;IACnB,wBAAwB,EAAA;;AAK9B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BLruDkB;EKsuDlB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe,EAAA;EAVjB;IAaI,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB,EAAA;;AAIxB;EACE,kBAAkB,EAAA;;AAGpB;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB,EAAA;;AAGxB;EACE,kBAAkB;EAClB,OAAO;EACP,qBAAqB;EACrB,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBL7wDmB;EK8wDnB,mBL1wDkB;EK2wDlB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,2EAGsB;EACtB,yEAE+B,EAAA;;AAGjC;EACE,gCL50DkB,EAAA;;AK+0DpB;EACE,gCLj1DuB,EAAA;;AKo1DzB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY,EAAA;;AAGd;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,YAAY,EAAA;;AAGd;EACE,gCLx2DkB;EKy2DlB,cAAc,EAAA;;AAGhB;EACE,cLr0DkB;EKs0DlB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,gCLv3DkB;EKw3DlB,sBAAsB,EAAA;;AAGxB;EACE,gCL53DkB,EAAA;;AK+3DpB;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,YAAY,EAAA;EARd;IAYI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,WAAW;IACX,WAAW;IL5/Cb,kGAKC;IKy/CC,oBAAoB,EAAA;EAnBxB;IAuBI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,YAAY;ILxhDd,0IAMC;IACD,sHAMC;IK6gDC,aAAa;IACb,oBAAoB,EAAA;;AAKxB;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,6BAA6B;EAC7B,MAAM;EACN,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gCLx7DuB,EAAA;;AK27DzB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,QAAQ,EAAA;;AAGV;EACE,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,2CAA2C;EAC3C,cLj9DuB;EKk9DvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iCAAiC,EAAA;;AAGnC;EACE,iCL56DiB;EK66DjB,yCAAyC,EAAA;;AAG3C;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB,EAAA;;AAGrB;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,cAAc;EACd,UAAU;EACV,oBAAoB,EAAA;;AAGtB;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,+BLx/DuB;EKy/DvB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B,EAAA;;AAG9B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY,EAAA;;AAGd;;EAEE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,0CLv+DmB;EKw+DnB,kBAAkB;EAClB,8BAA8B;EAC9B,gCLphEuB;EKqhEvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,0DAA0D,EAAA;EAhB5D;;IAmBI,oCLj/DiB;IKk/DjB,sCLl/DiB,EAAA;EK89DrB;;IAwBI,aAAa;IACb,mBAAmB,EAAA;;AAIvB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,OAAO,EAAA;;AAIT;EACE,aAAa;EACb,+BAA+B;EAC/B,eAAe;EACf,YAAY;EACZ,kBAAkB,EAAA;;AAGpB;EACE,cAAc;EACd,eAAe,EAAA;;AAGjB;EACE,WAAW;EACX,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB,EAAA;;AAGpB;EACE,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,gBAAgB,EAAA;;AAGlB;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,0CL5iEmB;EK6iEnB,+BAA+B;EAC/B,gCLxlEuB;EKylEvB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,0DAA0D,EAAA;EAd5D;IAiBI,+BAA+B;IAC/B,qCLzjEiB,EAAA;EKuiErB;IAsBI,aAAa;IACb,mBAAmB,EAAA;;AAIvB;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,cAAc;EACd,gCLrnEuB;EKsnEvB,eAAe;EACf,cAAc,EAAA;;AAGhB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EAEP,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0CL1lEmB;EK2lEnB,iCAAiC;EACjC,0CAA0C;EAC1C,aAAa,EAAA;EL55CX;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;;AKi5CjE;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;EACT,+BLlpEuB;EKmpEvB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe,EAAA;EAbjB;IAgBI,oCLjnEiB,EAAA;EKimErB;IAoBI,oCLrnEiB;IKsnEjB,gCLhqEqB;IKiqErB,cAAc,EAAA;;AAIlB;EACE,aAAa;EACb,eAAe;EACf,+BLxqEuB,EAAA;;AK2qEzB;EACE,eAAe;EACf,gCL7qEuB,EAAA;;AKgrEzB;EACE,gBAAgB;EAChB,eAAe;EACf,8BAA8B;EAC9B,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB,EAAA;;AAGlB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCLvsEkB;EKwsElB,2CLxsEkB;EKysElB,kBAAkB;EAClB,kCLlsEsB,EAAA;;AKqsExB;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,sBAAsB,EAAA;EAEtB;IACE,qBAAqB;IACrB,cAAc;IACd,UAAU;IACV,oBAAoB,EAAA;;AAIxB;EACE,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,YAAY,EAAA;;AAGd;EACE,YAAY;EACZ,iBAAiB,EAAA;;AAGnB;EACE,YAAY,EAAA;;AAGd;EACE,eAAe;EACf,gCLnvEuB;EKovEvB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,0IAMC;EACD,oHAMC;EACD,aAAa,EAAA;;AAGf;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,oBAAoB,EAAA;;AAGtB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,0CLxvEmB;EKyvEnB,+BAA+B;EAC/B,cAAc,EAAA;;AAGhB;EACE,qCAAqC,EAAA;;AAGvC;EACE,aAAa;EACb,+BAA+B;EAC/B,QAAQ;EACR,mBAAmB;EACnB,YAAY,EAAA;;AAGd;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BL/wEkB;EKgxElB,mBAAmB,EAAA;EAEnB;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,cAAc,EAAA;IANf;MASG,cAAc;MACd,WAAW;MACX,YAAY;MACZ,mBAAmB;MACnB,aAAa,EAAA;;AAKnB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,eAAe;EACf,+BLt1EuB;EKu1EvB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB,EAAA;;AAGlB;EACE,eAAe;EACf,gCL/1EuB;EKg2EvB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB,EAAA;;AAGlB;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BLp0EkB;EKq0ElB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,4BAA4B,EAAA;EAL9B;IAQI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,SAAS;IACT,YAAY;IACZ,UAAU;IACV,kDAAkD;IAClD,kCLt1EqB;IKu1ErB,8CL71EiB;IK81EjB,kFAE+B;IAC/B,oBAAoB,EAAA;EArBxB;IAyBI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,WAAW;IACX,UAAU;IACV,oBAAoB;IACpB,mTAcG;IACH,qDAAqD,EAAA;;AAIzD;EACE,kBAAkB;EAClB,UAAU;EACV,0CLn4EmB;EKo4EnB,mBAAmB;EACnB,mBL/3EuB;EKg4EvB,gCLh7EuB;EKi7EvB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,4EAA4E,EAAA;EAX9E;IAcI,mBL34EsB;IK44EtB,qCL/4EiB;IKg5EjB,cL17EqB,EAAA;EK06EzB;IAoBI,mBLj5EsB;IKk5EtB,sCLr5EiB;IKs5EjB,cLh8EqB,EAAA;IK06EzB;MAyBM,WAAW;MACX,kBAAkB;MAClB,UAAU;MACV,WAAW;MACX,YAAY;MACZ,WAAW;MACX,oBAAoB;MACpB,mLAOC;MACD,+ELx6Ee,EAAA;;AK+6ErB;;EAEE,kBAAkB,EAAA;;AAGpB;EACE,8BLt9EU,EAAA;;AKy9EZ;EACE,aAAa;EACb,cAAc;EACd,aAAa,EAAA;;AAGf;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB,EAAA;;AAG1B;EACE,QAAQ;EACR,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB,EAAA;;AAGlB;EACE,UAAU;EACV,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB,EAAA;;AAGrB;EACE,0CL79EmB;EK89EnB,+BAA+B;EAC/B,gCLzgFuB;EK0gFvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,4EAA4E,EAAA;EAV9E;IAaI,oCLz+EiB;IK0+EjB,sCL1+EiB;IK2+EjB,gCLrhFqB,EAAA;;AKyhFzB;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB,EAAA;ELnzDd;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;;AKwyDjE;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB,EAAA;;AAGrB;EACE,0CLhgFmB;EKigFnB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,kBAAkB,EAAA;;AAGpB;EAEI,YAAY,EAAA;;AAIhB;EACE,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,QAAQ;EACR,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,gBAAgB,EAAA;;AAGlB;EACE,aAAa,EAAA;;AAGf;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAEhB,+BAA+B;EAC/B,mDAAmD;EACnD,0DAEyB,EAAA;EAT3B;IAYI,2BAA2B;IAC3B,8BAA8B,EAAA;EAblC;IAiBI,4BAA4B;IAC5B,+BAA+B,EAAA;EAlBnC;IAsBI,kCL7jFU;IK8jFV,sCL/jFiB;IKgkFjB,mDAAmD,EAAA;;AAIvD;EACE,mCLrlFkB;EKslFlB,qCLtlFkB,EAAA;;AKylFpB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,UAAU;EACV,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCL9nFuB;EK+nFvB,kCAAkC;EAClC,iBAAiB;EAMjB,0BAA0B;EAC1B,kCAAkC,EAAA;;AAGpC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU,EAAA;;AAGZ;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,0CL3mFmB;EK4mFnB,+BAA+B;EAC/B,gCLvpFuB;EKwpFvB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0DAA0D,EAAA;EAb5D;IAgBI,oCLvnFiB;IKwnFjB,sCLxnFiB,EAAA;;AK4nFrB;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,0CLpoFmB;EKqoFnB,iCAAiC;EACjC,gCLhrFuB;EKirFvB,eAAe;EACf,iBAAiB;EACjB,yEAE+B;EAC/B,qBAAqB,EAAA;;AAGvB;EACE,sBAAsB;EACtB,4BAA4B,EAAA;;AAG9B;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU,EAAA;;AAGZ;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,0CL/pFmB;EKgqFnB,+BAA+B;EAC/B,gCL3sFuB;EK4sFvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0DAA0D,EAAA;EAd5D;IAiBI,oCL5qFiB;IK6qFjB,sCL7qFiB,EAAA;;AKirFrB;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,0CLzrFmB;EK0rFnB,iCAAiC;EACjC,gCLruFuB;EKsuFvB,eAAe;EACf,iBAAiB;EACjB,yEAE+B;EAC/B,qBAAqB,EAAA;;AAGvB;EACE,eAAe;EACf,eAAe;EACf,gCLjvFuB;EKkvFvB,kBAAkB;EAClB,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,2CL9sFmB;EK+sFnB,mBAAmB;EACnB,gCL1vFuB,EAAA;;AK6vFzB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS,EAAA;;AAGX;EACE,0CL1tFmB;EK2tFnB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa,EAAA;;AAGf;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,+BL/wFuB;EKgxFvB,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,QAAQ,EAAA;;AAGV;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gCL7xFuB,EAAA;;AKgyFzB;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,SAAS,EAAA;EAJX;IAOI,mBAAmB,EAAA;EAPvB;IAWI,aAAa;IACb,QAAQ;IACR,mBAAmB,EAAA;IAbvB;MAgBM,WAAW;MACX,YAAY;MACZ,mBAAmB,EAAA;IAlBzB;MAsBM,YAAY,EAAA;IAtBlB;MA0BM,aAAa,EAAA;;AAKnB;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,SAAS,EAAA;;AAGX;EACE,0BAA0B,EAAA;;AAG5B;EACE,aAAa;EACb,4BAA4B;EAC5B,SAAS,EAAA;;AAGX;EACE,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa,EAAA;;AAGf;EACE,aAAa,EAAA;;AAGf;EAEE,aAAa,EAAA;;AAGf;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,6DAA6D,EAAA;;AAG/D;EACE,iBAAiB,EAAA;;AAGnB;EACE,UAAU,EAAA;;AAGZ;EACE,+BAA+B;EAC/B,oBAAoB,EAAA;;AAGtB;EACE,mCLh1FmB;EKi1FnB,oBAAoB;EACpB,2CAA2C,EAAA;;AAG7C;EACE,oCLt1FmB,EAAA;;AKy1FrB;EACE;;IAEE,0BAA0B,EAAA;EAtD9B;IA0DI,iBAAiB,EAAA,EAClB;;AAGH;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,+BLn5FuB;EKo5FvB,mBAAmB,EAAA;;AAGrB;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB,EAAA;ELjrEhB;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;;AKsqEjE;EACE,aAAa;EACb,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,0CLj4FmB;EKk4FnB,+BAA+B;EAC/B,mBAAmB,EAAA;;AAGrB;EACE,sEAAsE;EACtE,eAAe;EACf,gCLn7FuB,EAAA;;AKs7FzB;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,+BLn5FmB;EKo5FnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,+CLv5FmB;EKw5FnB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;EAfrB;IAkBI,cLx8FqB;IKy8FrB,gDLz8FqB,EAAA;;AK68FzB;EACE,eAAe;EACf,gCL/8FuB;EKg9FvB,mBAAmB,EAAA;;AAGrB;EACE,oBAAoB;EACpB,aAAa,EAAA;;AAGf;EACE,sEAAsE;EACtE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,gCL79FuB;EK89FvB,iBAAiB,EAAA;;AAInB;;EAGI,kBAAkB;EAClB,UAAU;EACV,cAAc,EAAA;;AALlB;;EASI,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,QAAQ;EACR,yBAAyB;EACzB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,cLp/FqB;EKq/FrB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,kBAAkB,EAAA;EAvBtB;;IA2BM,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,wEAAwE;IACxE,oBAAoB;IACpB,WAAW;IL96Ef,mHAAiF;IACjF,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B,EAAA;EK24E7B;;IAsCM,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,0BAA0B;IAC1B,wEAAwE;IACxE,oBAAoB;IACpB,WAAW;IACX,mBLngGiB;IKogGjB,+FAEgD,EAAA;EAhDtD;;IAoDM,iBAAiB;IACjB,SAAS;IACT,cLxhGmB,EAAA;EKk+FzB;;IA0DM,OAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,mBAAmB,EAAA;EAhEzB;;IAoEM,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB,EAAA;EAxEvB;;IA4EM,cAAc;IACd,cAAc,EAAA;IA7EpB;;MAgFQ,aAAa,EAAA;IAhFrB;;MAoFQ,SAAS,EAAA;EApFjB;;IAyFM,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,OAAO,EAAA;EA/Fb;;IAmGM,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,cAAc;IACd,kBAAkB,EAAA;IAzGxB;;MA4GQ,qBAAqB;MACrB,oBAAoB;MACpB,mBAAmB;MACnB,uBAAuB;MACvB,iBAAiB;MACjB,eAAe;MACf,kBAAkB;MAClB,gCLrlGiB,EAAA;MKk+FzB;;QAsHU,gCLxlGe,EAAA;IKk+FzB;;MA2HQ,aAAa;MACb,eAAe;MACf,mBAAmB;MACnB,yBAAyB;MACzB,QAAQ;MACR,YAAY;MACZ,eAAe,EAAA;MAjIvB;;QAoIU,aAAa;QACb,eAAe;QACf,mBAAmB;QACnB,QAAQ;QACR,SAAS,EAAA;MAxInB;;QA4IU,eAAe;QACf,iBAAiB,EAAA;EA7I3B;;IAmJM,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,cLxnGmB;IKynGnB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,cAAc;IACd,eAAe,EAAA;IA5JrB;;MA+JQ,cLhlGgB;MKilGhB,yBLloGiB,EAAA;;AKk+FzB;;EAuKI,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,0CLlmGiB;EKmmGjB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,mBLrmGe;EKsmGf,WAAW,EAAA;EAhLf;;IAoLM,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;IACV,kLAOC;IACD,+EL7nGe;IKgoGf,aAAa,EAAA;;AAxMnB;;EA6MI,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,UAAU,EAAA;;AAMd;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB,EAAA;;AAGxB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,sBAAsB,EAAA;;AAGxB;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,MAAM;EACN,sBAAsB;EACtB,mBAAmB;EACnB,yCAAyC;EACzC,qDAAkE;EAClE,+EAEgC;EAChC,sBAAsB,EAAA;EAEtB;IACE,eAAe;IACf,YAAY;IACZ,eAAe,EAAA;EAGjB;IACE,cAAc;IACd,cAAc;IACd,WAAW;IACX,sBAAsB,EAAA;;AAI1B;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,mBLjvGiB;EKkvGjB,8CAA8C,EAAA;EAbhD;IAgBI,sCAAsC;IACtC,gFAEmC,EAAA;;AAIvC;EACE,cAAc;EACd,cAAiC,EAAA;;AAGnC;EACE,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,cL/wGuB,EAAA;EKswGzB;IAYI,aAAa,EAAA;EAZjB;IAgBI,gCAAgC,EAAA;;AAIpC;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,+BAA+B;EAC/B,cLnyGkB;EKoyGlB,kBAAkB;EAClB,cAAc;EACd,eAAe,EAAA;EAbjB;IAgBI,qCAAqC;IACrC,cL7yGgB,EAAA;;AKizGpB;EACE,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC,EAAA;EAEpC;IACE,aAAa,EAAA;EAGf;IACE;MACE,aAAa,EAAA,EACd;;AAIL;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAiC;EACjC,eAAe,EAAA;EAfjB;IAkBI,cAAiC;IACjC,oCAAoC,EAAA;;AAIxC;EACE,cAAc,EAAA;;AAGhB;EACE,cAAc;EACd,cAAiC;EACjC,WAAW;EACX,YAAY,EAAA;;AAGd,wFAAA;AACA;EACE,cAAc;EACd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oHAC+C,EAAA;EAE/C;IACE,oHACgD,EAAA;;AAIpD,qGAAA;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yDAAmD;EACnD,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,UAAU;EACV,sGAC8C,EAAA;EAE9C;IACE,yGACgD,EAAA;;AAIpD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cLj5GyB;EKk5GzB,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cL55GkB;EK65GlB,gBAAgB,EAAA;;AAGlB;EACE,eAAe;EACf,YAAY;EACZ,cLj6GuB;EKk6GvB,aAAa;EACb,gBAAgB,EAAA;EALlB;IASI,sCAAsC;IACtC,mFAE+B,EAAA;;AAInC;EACE,cAAc;EACd,cAAiC,EAAA;;AAGnC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,cLz7GuB;EK07GvB,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cLx4F0B;EKy4F1B,kBAAkB,EAAA;;AC79GpB;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kCNqEsB;EMpEtB,sBAAsB,EAAA;;AAGxB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAO;EACP,wBAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,0CNkDmB;EMjDnB,yBNuDuB;EMtDvB,yGNqDiB;EMlDjB,0EAEiC,EAAA;;AAGnC;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,+BAA+B;EAC/B,gDNyBmB;EMxBnB,kCN+BsB,EAAA;;AM5BxB;EACE,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY,EAAA;;AAGd;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBNiBoB;EMhBpB,6CNgBoB,EAAA;;AMbtB;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cN9CuB,EAAA;;AMiDzB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,cNnDyB,EAAA;;AMsD3B;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,0CNtBmB;EMuBnB,kBAAkB;EAClB,kCN7DiB;EM8DjB,cNlEkB;EMmElB,eAAe;EACf,4EAA4E,EAAA;EAb9E;IAiBI,cNzEqB;IM0ErB,sCNjCgB;IMkChB,mBNxEiB,EAAA;;AM4ErB;EACE,aAAa;EACb,4DAA4D;EAC5D,cAAc;EACd,aAAa;EACb,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gDNlDmB;EMmDnB,kCN5CsB;EM6CtB,aAAa;EACb,cAAc,EAAA;EN4oBZ;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;;AMvpBjE;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,0CNjEmB;EMkEnB,mBNvGiB;EMwGjB,+CAA+C,EAAA;EAVjD;IAaI,sCNvEgB,EAAA;;AM2EpB;EACE,cAAc;EACd,cAAiC,EAAA;;AAGnC;EACE,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,cN/HuB;EMgIvB,kBAAkB,EAAA;EAPpB;IAUI,aAAa,EAAA;EAVjB;IAcI,gCAAgC,EAAA;;AAIpC;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;;EAEE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cNxJyB,EAAA;;AM2J3B;;EAEE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,cNhLkB;EMiLlB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4EAA4E,EAAA;EAd9E;IAkBI,oCN/IiB;IMgJjB,cN1LqB;IM2LrB,sCNjJiB,EAAA;EM6HrB;INobE,gHAEO;IACP,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IMhazB,sCNvJgB;IMwJhB,cNjMqB;IMkMrB,mCNvJU,EAAA;;AM2Jd;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cNvMyB,EAAA;EMyMzB;IACE,cNvJkB,EAAA;;AM2JtB;EACE,gBAAgB;EAChB,oBAAoB;EACpB,6CNzKmB,EAAA;;AM4KrB;EACE,mBAAmB;EACnB,WAAW,EAAA;EAFb;IAKI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,cN9NgB,EAAA;;AMkOpB;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,cAAc,EAAA;EAEd;IACE,mBNjMgB,EAAA;EMoMlB;IACE,mBNnLkB,EAAA;EMsLpB;IACE,mBN3NiB,EAAA;EM8NnB;IACE,mBNjMkB,EAAA;;AMqMtB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa,EAAA;;AAGf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,gCAAgC;EAChC,gDN7NmB;EM8NnB,kCNvNsB,EAAA;;AM0NxB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cNxRuB,EAAA;;AM2RzB;EACE,kBAAkB;EAClB,cN3RyB,EAAA;;AM8R3B;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,yBNnSyB;EMoSzB,0CAA0C;EAC1C,mBNlSiB,EAAA;;AMqSnB;EACE,iBAAiB;EACjB,iBAAiB;EACjB,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,cN/SkB;EMgTlB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,0EAA0E,EAAA;EAZ5E;IAeI,+BNtTiB,EAAA;EMuSrB;IAoBI,mBN3TiB;IM4TjB,cN/TqB,EAAA;EM0SzB;INiTE,gHAEO;IACP,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IM5RzB,cNpUqB;IMqUrB,mCN1RU,EAAA;;AM8Rd;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,4BAA4B;EN7E5B,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,6DAA6D,EAAA;EAE7D;IACE,UAAU,EAAA;EAGZ;IACE,+BAA+B;IAC/B,oBAAoB,EAAA;EAGtB;IACE,mCArOiB;IAsOjB,oBAAoB;IACpB,2CAA2C,EAAA;EAG7C;IACE,oCA3OiB,EAAA;;AMuSrB;;;EAGE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,cNvVyB;EMwVzB,kBAAkB,EAAA;;AAGpB;EACE,cN1SyB,EAAA;;AM6S3B;EACE,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB,EAAA;;AAGxB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cNjXyB,EAAA;;AMoX3B;EACE,YAAY;EACZ,uBAAuB;EACvB,cNhVkB;EMiVlB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,UAAU,EAAA;EAPZ;IAWI,cAA+B;IAC/B,0BAA0B,EAAA;;AAI9B;EACE,aAAa;EACb,8DAA8D;EAC9D,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,yCN1WmB;EM2WnB,0GNrWuB;EMwWvB,cNxZuB;EMyZvB,eAAe;EACf,kBAAkB;EAClB,gFAAgF,EAAA;EAflF;IAmBI,2BAA2B;IAC3B,sCNvXgB,EAAA;EM0XlB;IACE,qCN/WkB;IMgXlB,kDNhXkB,EAAA;EMmXpB;IACE,2BAA2B,EAAA;EAG7B;IACE,mDNnYiB,EAAA;;AMuYrB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,cAAc,EAAA;;AAGhB;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,kBAAkB,EAAA;EAElB;IACE,cAAc;IACd,kCNhciB;IMicjB,4CNncgB,EAAA;;AMucpB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cN/ckB;EMgdlB,cAAc,EAAA;;AAGhB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,WAAW,EAAA;EANb;IASI,cNjbgB;IMkbhB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAA;;AAIrB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cNvfuB;EMwfvB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,yBNpfmB;EMqfnB,mCNlfkB;EMmflB,cNvfwB;EMwfxB,kBAAkB;EAClB,eAAe;EACf,sBAAsB,EAAA;;AAGxB;EAniBA;IAqiBI,wBAAQ,EAAA;EAtcZ;IA0cI,0BAA0B;IAC1B,uCAAuC,EAAA;EAnc3C;IAucI,kBAAkB;IAClB,iDNrfiB;IMsfjB,eAAe,EAAA;EA/RnB;IAmSI,eAAe,EAAA,EAChB;;AAIH;;EAEE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,UAAU;EACV,oBAAoB;EACpB,oDAAoD;EACpD,2FNpgBuB,EAAA;EMyfzB;;IAgBI,wBAAwB;IACxB,UAAU;IACV,oBAAoB,EAAA;;AAIxB;EACE,UAAU,EAAA;;AAGZ;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa,EAAA;;AAGf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,cAAc;EACd,wBAAwB;EACxB,iDNviBmB;EMwiBnB,iCNjiBsB,EAAA;;AMoiBxB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wCAAwC;EACxC,yCNhjBmB;EMijBnB,kBAAkB;EAClB,kCNvlBiB;EMwlBjB,cN7lBuB;EM8lBvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,uCAAuC;EACvC,mGAAmG,EAAA;EAfrG;IAmBI,cN1mBgB;IM2mBhB,qCNhkBgB;IMikBhB,kCNvmBiB;IMwmBjB,6CNjkBiB,EAAA;EM2iBrB;IA0BI,iCNhkBe,EAAA;;AMokBnB;EACE,cAAc,EAAA;;AAGhB;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,0CNrlBmB;EMslBnB,kBAAkB;EAClB,kCN5nBiB;EM6nBjB,cNjoBkB;EMkoBlB,eAAe,EAAA;EAZjB;IAgBI,cNvoBqB;IMwoBrB,sCN/lBgB;IMgmBhB,mBNtoBiB,EAAA;;AM0oBrB;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yCNpnBmB;EMqnBnB,sIN/mBuB,EAAA;;AMonBzB;EACE,sCNhnBoB;EMinBpB,wINtnBuB,EAAA;;AM2nBzB;EACE,aAAa;EACb,0CAA0C;EAC1C,YAAY;EACZ,mBAAmB,EAAA;;AAGrB;EACE,cAAc;EACd,eAAe;EACf,mBAAmB,EAAA;EAEnB;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,cN/rBgB;IMgsBhB,sFAAwF;IACxF,qCNpoBkB,EAAA;;AMwoBtB;EACE,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY,EAAA;;AAGd;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cNptBkB;EMqtBlB,iBAAiB,EAAA;;AAGnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0CNtrBkB;EMurBlB,oCNtrBmB;EMurBnB,cNxrBkB,EAAA;EM0rBlB;IACE,sCN/qBkB;IMgrBlB,oCNhrBkB;IMirBlB,cNlrBuB,EAAA;EMqrBzB;IACE,sCNjsBgB;IMksBhB,cNlsBgB,EAAA;EMqsBlB;IACE,sCNprBkB;IMqrBlB,oCNrrBkB;IMsrBlB,cNvrBuB,EAAA;EM0rBzB;IACE,uCN9tBiB;IM+tBjB,qCN/tBiB;IMguBjB,cNjuBsB,EAAA;;AMquB1B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cN9vBkB,EAAA;;AMiwBpB;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,0CNruBmB;EMsuBnB,kCN/tBsB,EAAA;EMiuBtB;IACE,YAAY;IACZ,mBAAmB,EAAA;IAFpB;MAKG,sBAAsB,EAAA;IALzB;MASG,kBAAkB,EAAA;EAItB;IACE,YAAY;IACZ,uBAAuB,EAAA;IAFxB;MAKG,sBAAsB;MACtB,kBAAkB;MAClB,eAAe;MACf,cAAc,EAAA;;AAKpB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cN/yByB,EAAA;;AMkzB3B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cNvzBuB;EMwzBvB,iBAAiB,EAAA;;AAGnB;EACE,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,cAAc,EAAA;EALhB;IAQI,kBAAkB;IAClB,eAAe;IACf,cNr0BqB;IMs0BrB,sCN5xBiB;IM6xBjB,kCNl0Be,EAAA;IMszBnB;MAeM,cAAc;MACd,UAAU;MACV,cAAc,EAAA;IAjBpB;MAsBM,cNn1Bc;MMo1Bd,sCNzyBc;MM0yBd,yBNh1Be,EAAA;IMwzBrB;MA4BM,aAAa,EAAA;IA5BnB;MAkCQ,cN/1BY,EAAA;IM6zBpB;MAwCM,aAAa,EAAA;EAIjB;IACE,kBAAkB;IAClB,eAAe,EAAA;;AAInB;EACE,aAAa;EACb,2BAA2B,EAAA;;AAG7B;EACE,wBAAwB;EACxB,mBAAmB;EACnB,0CN30BmB;EM40BnB,kCNr0BsB,EAAA;EMu0BtB;IACE,cAAc,EAAA;EAGhB;IACE,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,0BAA0B,EAAA;;AAI9B;EACE,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cN54BuB;EM64BvB,cAAc,EAAA;;AAGhB;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,cNn5BkB;EMo5BlB,qBAAqB,EAAA;;AAGvB;EACE,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,cN15ByB,EAAA;;AM65B3B;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,cAAc;EACd,aAAa;EACb,oBAAoB,EAAA;;AAGtB;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EN7qB3B,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,6DAA6D,EAAA;EAE7D;IACE,UAAU,EAAA;EAGZ;IACE,+BAA+B;IAC/B,oBAAoB,EAAA;EAGtB;IACE,mCArOiB;IAsOjB,oBAAoB;IACpB,2CAA2C,EAAA;EAG7C;IACE,oCA3OiB,EAAA;;AMu4BrB;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;EANd;IASI,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,cN77BgB,EAAA;EMg8BlB;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,mBNh6BgB,EAAA;EMm6BlB;IACE,YAAS;IACT,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,aAAa;IACb,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,cN59BgB;IM69BhB,oCNj7BiB;IMk7BjB,0CNn7BgB,EAAA;EMs7BlB;IACE,oCNr6BkB;IMs6BlB,qCNt6BkB,EAAA;EMy6BpB;IACE,mBN16BkB,EAAA;;AM86BtB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,yCNx8BmB;EMy8BnB,iCNp8BiB,EAAA;;AMu8BnB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cN1/BuB,EAAA;;AM6/BzB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cN9/ByB,EAAA;;AMigC3B;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cN9gCkB;EM+gClB,oDAA+D;EAC/D,mBAAmB;EACnB,aAAa,EAAA;EAZf;IAeI,eAAe;IACf,UAAU,EAAA;IAhBd;MAmBM,wBAAwB,EAAA;IAnB9B;MAuBM,0CNh/Be;MMi/Bf,mBAAmB,EAAA;;AAKzB;EAEI,cAAc;ENlyBhB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,6DAA6D,EAAA;EAE7D;IACE,UAAU,EAAA;EAGZ;IACE,+BAA+B;IAC/B,oBAAoB,EAAA;EAGtB;IACE,mCArOiB;IAsOjB,oBAAoB;IACpB,2CAA2C,EAAA;EAG7C;IACE,oCA3OiB,EAAA;;AM6/BrB;EACE,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,gCNvjCuB,EAAA;;AM0jCzB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY,EAAA;;AAGd;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cNxkCkB,EAAA;;AM2kCpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0CNziCkB;EM0iClB,oCNziCmB;EM0iCnB,cN3iCkB,EAAA;EM6iClB;IACE,sCNliCkB;IMmiClB,oCNniCkB;IMoiClB,cNriCuB,EAAA;EMwiCzB;IACE,sCNpjCgB;IMqjChB,cNrjCgB,EAAA;EMwjClB;IACE,sCNviCkB;IMwiClB,oCNxiCkB;IMyiClB,cN1iCuB,EAAA;EM6iCzB;IACE,uCNjlCiB;IMklCjB,qCNllCiB;IMmlCjB,cNplCsB,EAAA;;AMwlC1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB,EAAA;EAEzB;IACE,0CNpkCkB;IMqkClB,oCNrkCkB;IMskClB,cNvkCuB,EAAA;EM0kCzB;IACE,2CNxmCiB;IMymCjB,qCNzmCiB;IM0mCjB,cN3mCsB,EAAA;EM8mCxB;IACE,yCN7nCgB;IM8nChB,kCN3nCc;IM4nCd,cNvoCqB,EAAA;;AM2oCzB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY,EAAA;;AAGd;EACE,wBAAwB;EACxB,0CN3mCkB;EM4mClB,kBAAkB;EAClB,kCNjpCiB;EMkpCjB,cN9mCkB;EM+mClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe,EAAA;EAVjB;IAcI,oCNtnCiB;IMunCjB,cNnqCgB,EAAA;;AMuqCpB;EACE,SAAS;EACT,kBAAkB;EAClB,gCNxqCuB,EAAA;;AM2qCzB;EACE,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,0CNroCmB;EMsoCnB,iCNjoCiB;EMkoCjB,gCNjrCuB;EMkrCvB,kBAAkB;EAClB,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,+DAA+D;EAC/D,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,0CNppCmB;EMqpCnB,wIN/oCuB,EAAA;;AMopCzB;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,iFNjqCkB,EAAA;EMqqClB;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,cNttCgB;IMutChB,uFAAsF;IACtF,0CN7qCgB,EAAA;;AMirCpB;EACE,YAAY,EAAA;;AAGd;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gCNluCuB,EAAA;EMouCvB;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY,EAAA;EAGd;IACE,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cNvsCgB,EAAA;EM0sClB;IACE,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,gCNvvCqB,EAAA;EM8tCzB;;;;;IAkCM,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cN5tCc,EAAA;EMqrCpB;IA2CM,mBAAmB,EAAA;IA3CzB;MA8CQ,gBAAgB,EAAA;;AAMxB;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY,EAAA;;AAGd;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,0CNlwCkB;EMmwClB,iCN7vCiB;EM8vCjB,cNpwCkB,EAAA;;AMuwCpB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCNrzCuB;EMszCvB,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gCN5zCuB,EAAA;;AM+zCzB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,aAAa,EAAA;;AAGf;EACE,aAAa;EACb,yDAAyD;EACzD,YAAY;EACZ,oBAAoB;EACpB,aAAa,EAAA;;AAGf;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,0CN5yCmB;EM6yCnB,kCNtyCsB;EMuyCtB,gBAAgB,EAAA;;AAGlB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cNp2CuB,EAAA;;AMu2CzB;EACE,cAAc;EACd,cNh0CkB,EAAA;;AMm0CpB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,gCN33CuB,EAAA;;AM83CzB;EACE,cAAc;EACd,mBAAmB;EACnB,cNx1CkB,EAAA;;AM21CpB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY,EAAA;;AAGd;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gCNj5CuB,EAAA;;AMo5CzB;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa,EAAA;;AAGf;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,0CNt3CmB;EMu3CnB,mBAAmB;EACnB,iCNn3CiB;EMo3CjB,gDNp3CiB,EAAA;;AMu3CnB;EACE,cAAc;EACd,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cN76CuB;EM86CvB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB,EAAA;EAXlB;IAcI,eAAe;IACf,aAAa,EAAA;EAfjB;IAmBI,gCNz7CqB,EAAA;EMs6CzB;IAuBI,aAAa,EAAA;;AAIjB;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gCNt8CuB;EMu8CvB,oBAAoB,EAAA;;AAGtB;EACE,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,2CNv7CmB;EMw7CnB,mCNr7CkB;EMs7ClB,cNh9CuB;EMi9CvB,kBAAkB,EAAA;;AAGpB;EACE,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,yCNh9CkB;EMi9ClB,kCN98CgB;EM+8ChB,cN19CuB;EM29CvB,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,oBAAoB,EAAA;;AAGtB;EACE,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gCN/+CuB,EAAA;;AMk/CzB;EACE,cAAc;EACd,kBAAkB;EAClB,+BN58CkB,EAAA;;AM+8CpB;EACE,cNh9CkB;EMi9ClB,gBAAgB,EAAA;;AAGlB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB,EAAA;;AAGnB;EACE,qBAAqB;EACrB,yCN//CkB;EMggDlB,kBAAkB;EAClB,kCNpgDiB;EMqgDjB,gCN1gDuB;EM2gDvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,4EAA4E,EAAA;EAX9E;IAeI,cNthDgB;IMuhDhB,qCN7gDgB;IM8gDhB,kCN3gDc,EAAA;;AM+gDlB;EACE,oBAAoB;EACpB,oBAAoB;EACpB,UAAU;EACV,0CNr/CkB;EMs/ClB,kBAAkB;EAClB,uFAAsF;EACtF,cNniDkB;EMoiDlB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iDAAiD,EAAA;EAdnD;IAkBI,wBAAwB,EAAA;EAlB5B;IAsBI,aAAa;IACb,mBAAmB,EAAA;;AAIvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB,EAAA;;AAG1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gDNlkDkB,EAAA;;AMqkDpB;EACE,cAAc;EACd,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,0CN9hDmB;EM+hDnB,iCNxhDsB,EAAA;EMkhDxB;IASI,kBAAkB;IAClB,eAAe;IACf,cAAc,EAAA;;AAIlB;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cNvlDyB,EAAA;;AM0lD3B;EAj7BA;IAm7BI,0CAA0C,EAAA;EAG5C;;IAEE,0BAA0B,EAAA;EApsB9B;IAwsBI,cAAc;INv2ChB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,6DAA6D,EAAA;IAE7D;MACE,UAAU,EAAA;IAGZ;MACE,+BAA+B;MAC/B,oBAAoB,EAAA;IAGtB;MACE,mCArOiB;MAsOjB,oBAAoB;MACpB,2CAA2C,EAAA;IAG7C;MACE,oCA3OiB,EAAA;EMk1BnB;IAgvBE,iBAAiB;IACjB,iBAAiB,EAAA;EApoBrB;IAwoBI,sBAAsB;IACtB,oBAAoB,EAAA;EA5bxB;IAgcI,0CAA0C,EAAA;EApW9C;IAwWI,mBAAmB;IACnB,gDAAgD,EAAA;EApTpD;IAwTI,0BAA0B,EAAA;EAjK9B;IAqKI,sBAAsB;IACtB,oBAAoB,EAAA;EAvIxB;IA2II,WAAW;IACX,wBAAwB,EAAA;EAG1B;;IAEE,cAAc;IACd,uBAAuB,EAAA,EACxB;;AN5qDH;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AOt8BA;EACE,gBAAgB,EAAA;EADlB;IAII,gBAAgB,EAAA;;AAUpB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,kCAA2E;EAC3E,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB,EAAA;;AAGvB;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B,EAAA;;AAJT;EAQtB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,+BAA+B;EAC/B,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,YAAY,EAAA;;AAGd;EACE,aAAa,EAAA;;AAGf;EACE,UAAU,EAAA;;AAIZ;EACE,eAAe;EACf,UArEgC;EAsEhC,8CAAiE;EACjE,WAtE4B;EAuE5B,kBAAkB;EAClB,sBAAsB;EACtB,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,gCPtFuB;EOuFvB,+BAA+B;EAC/B,8CP9CmB;EO+CnB,eAAe;EACf,gGAIsB,EAAA;EAnBxB;IAsBI,mBAAmB;IACnB,cPlGqB;IOmGrB,oCPzDiB;IO0DjB,8CP1DiB,EAAA;EOiCrB;IA6BI,2CP9DiB;IO+DjB,mBAAmB,EAAA;;AAKvB;EACE,kBAAkB;EAClB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,0CAAqD;EACrD,sBAAsB;EAEtB,kBAAkB;EAClB,mBAA4B;EAC5B,cP7HkB;EO8HlB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,+CPhFsB;EOiFtB,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,uCAAuC;EACvC,gFAG4B,EAAA;EA3B9B;IA8BI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,mBAAmB;IACnB,2BAA2B;IAC3B,yDAAyD,EAAA;;AAI7D;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB,EAAA;;AAIlB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EAEjB,mBAAmB;EACnB,cPzHoB,EAAA;;AO4HtB;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB,EAAA;;AAGzB;EACE,cAAc,EAAA;;AAGhB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB,EAAA;;AAGzB;;EAEE,UAAU;EACV,mBAAmB;EACnB,oCAAoC;EACpC,4FAG4B,EAAA;;AAG9B;EACE,mBAAmB;EACnB,cP/MuB;EOgNvB,oCPtKmB;EOuKnB,8CPxKkB,EAAA;;AO2KpB;EACE,mBAAmB;EACnB,gCPtNuB;EOuNvB,+BAA+B;EAC/B,4CPrNmB,EAAA;EOiNrB;IAQI,kBAAkB;IAClB,gCP7NqB;IO8NrB,+BAA+B;IAC/B,4CP5NiB,EAAA;;AOgOrB;EACE,cAAc;EACd,cAAc,EAAA;;AAIhB;EAEI,WAAW;EACX,YAAY,EAAA;;AAHhB;;EAQI,eAAe;EACf,gBAAgB,EAAA;;AAIpB;EAEI,WAAW;EACX,YAAY,EAAA;;AAHhB;;EAQI,eAAe;EACf,gBAAgB,EAAA;;AAIpB;EAEI,WAAW;EACX,YAAY,EAAA;;AAHhB;;EAQI,aAAa;EACb,cAAc,EAAA;;AAIlB;EAEI,WAAW;EACX,YAAY,EAAA;;AAHhB;;EAQI,aAAa;EACb,cAAc,EAAA;;AAIlB;EACE,cAAc;EACd,cAAc;EACd,8BAA8B;EAC9B,mDAAyD;EACzD,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,2DAAiE;EACjE,0BAA0B;EAC1B,8BAA8B;EAC9B,6BAA6B,EAAA;;AAG/B;EACE,cAAc;EACd,cAAc;EACd,8BAA8B;EAC9B,mDAA4D;EAC5D,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,2DAAoE;EACpE,0BAA0B;EAC1B,8BAA8B;EAC9B,6BAA6B,EAAA;;AAG/B;EACE,cAAc;EACd,cAAc;EACd,8BAA8B;EAC9B,mDAAuE;EACvE,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,2DAA+E;EAC/E,0BAA0B;EAC1B,8BAA8B;EAC9B,6BAA6B,EAAA;;AAG/B;EACE,cAAc;EACd,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,mBAAmB,EAAA;;AAGrB;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,0CPjTmB;EOkTnB,mBAAmB;EACnB,yGP9SiB;EOqTjB,yCAAyC,EAAA;;AAG3C;EACE,SAAS;EACT,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,gCP5WuB,EAAA;;AO+WzB;EACE,cAAc;EACd,0CPvUmB;EOwUnB,mBAAmB;EACnB,qBAAqB;EACrB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gCPxXuB;EOyXvB,+BAA+B;EAC/B,eAAe;EACf,4EAA4E,EAAA;EAZ9E;IAeI,oCPpViB;IOqVjB,sCPrViB;IOsVjB,gCPhYqB,EAAA;EO+WzB;IAqBI,2CP1ViB;IO2VjB,mBAAmB,EAAA;;AAIvB;EACE,WAAW;EACX,eAAe;EACf,kBAAkB,EAAA;;AAGpB;EACE,WAAW,EAAA;;AAGb;EACE,sBAAsB,EAAA;;AAGxB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB,EAAA;EAJlB;;;IPzEE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,gBAAgB,EAAA;;AOiFlB;EACE,cAAc,EAAA;;AAGhB;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EPxHhB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,6DAA6D,EAAA;EAE7D;IACE,UAAU,EAAA;EAGZ;IACE,+BAA+B;IAC/B,oBAAoB,EAAA;EAGtB;IACE,mCAzRiB;IA0RjB,oBAAoB;IACpB,2CAA2C,EAAA;EAG7C;IACE,oCA/RiB,EAAA;;AOsYrB;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa,EAAA;EAHf;IAMI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB,EAAA;EAZrB;IAgBI,cAAc;IACd,WAAW;IACX,aAAa,EAAA;EAlBjB;IAsBI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,gBAAgB,EAAA;EA3BpB;IA+BI,cAAc;IACd,WAAW;IACX,aAAa,EAAA;EAjCjB;;IAsCI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,gBAAgB,EAAA;;AAIpB;EACE,UAAU;EACV,gBAAgB,EAAA;;AAGlB;EAEI,UAAU;EACV,gCAAgC,EAAA;EAHpC;IAMM,WAAW,EAAA;EANjB;IAUM,WAAW,EAAA;;AAVjB;EAeI,+CAA+C;EAC/C,sDAAsD;EACtD,8BAA8B;EAC9B,wBAAwB,EAAA;;AAlB5B;EAsBI,UAAU;EACV,aAAa;EACb,6BAA6B,EAAA;EAxBjC;IA2BM,2DAA2D;IAC3D,4DAA4D,EAAA;;AA5BlE;;EAkCI,UAAU,EAAA;;AAId;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,eAAe,EAAA;;AAGjB;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;EACT,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,YAAY,EAAA;;AAGd;;EAEE,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,cAAc;EACd,YAAY,EAAA;;AAGd;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;EACT,YAAY,EAAA;;AAId;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,yGPjhBiB;EOohBjB,0CPzhBmB;EO0hBnB,mBAAmB;EACnB,kBAAkB;EAClB,0EAEiC,EAAA;;AAGnC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B,EAAA;EAR/B;IAWI,WAAW;IACX,YAAY,EAAA;EAZhB;IAgBI,WAAW;IACX,YAAY,EAAA;EAjBhB;IAqBI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB,EAAA;EAxBpB;IA4BI,sCP7jBiB;IO8jBjB,oCP9jBiB;IO+jBjB,cP/jBiB,EAAA;IOiiBrB;MAiCM,cPlkBe,EAAA;EOiiBrB;IAsCI,sCPtjBkB;IOujBlB,oCPvjBkB;IOwjBlB,cPxjBkB,EAAA;IOghBtB;MA2CM,cP3jBgB,EAAA;EOghBtB;IAgDI,qCP5jBgB;IO6jBhB,oCP7jBgB;IO8jBhB,cP9jBgB,EAAA;IO4gBpB;MAqDM,cPhkBoB,EAAA;EO2gB1B;IA0DI,uCPnoBuB;IOooBvB,oCPpoBuB;IOqoBvB,cProBuB,EAAA;IOykB3B;MA+DM,cPxoBqB,EAAA;;AO6oB3B;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,cAAc;EACd,aAAa;EACb,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,sBAAsB,EAAA;;AAGxB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,UAAU,EAAA;;AAGZ;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,oBAAoB,EAAA;;AAGtB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBPlqBkB;EOmqBlB,sBAAsB;EACtB,UAAU;EACV,oBAAoB,EAAA;;AAGtB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,oBAAoB,EAAA;;AAGtB;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,UAAU,EAAA;;AAGZ;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB,EAAA;EAHrB;IAMI,SAAS,EAAA;EANb;IAUI,SAAS,EAAA;EAVb;IAcI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,2CPzvBgB;IO0vBhB,yCAAyC;IACzC,eAAe,EAAA;EArBnB;IA2BM,UAAU;IACV,mBAAmB;IACnB,2BAA2B,EAAA;;AAKjC;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,uCAAuC;EACvC,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,yBPpuBmB;EOquBnB,mBPjuBkB;EOkuBlB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,gCPxxBuB;EOyxBvB,UAAU;EACV,kBAAkB;EAClB,2EAGsB;EACtB,yEAE+B,EAAA;;AAGjC;EACE,4CAA4C;EAC5C,iBAAiB;EACjB,gBAAgB;EAChB,cP1yBkB;EO2yBlB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB,EAAA;;AAGxB;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gCPjzBuB;EOkzBvB,iBAAiB,EAAA;;AAGnB;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,cPxzByB;EOyzBzB,qBAAqB,EAAA;;AAGvB;EACE,+BPtxBkB;EOuxBlB,sBAAsB,EAAA;;AAGxB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cP9xBkB;EO+xBlB,kBAAkB,EAAA;;AAGpB;EACE,UAAU;EACV,cAAc;EACd,iIAMC,EAAA;;AAGH;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EPxiBhB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,6DAA6D;EOuiB7D,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;EPviBZ;IACE,UAAU,EAAA;EAGZ;IACE,+BAA+B;IAC/B,oBAAoB,EAAA;EAGtB;IACE,mCAzRiB;IA0RjB,oBAAoB;IACpB,2CAA2C,EAAA;EAG7C;IACE,oCA/RiB,EAAA;;AOyzBrB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY,EAAA;;AAGd;EACE,cAAc;EAEd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAA;;AAGzB;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kDAAkD,EAAA;;AAGpD;EACE,WAAW;EACX,YAAY;EACZ,2CPr1BmB;EOs1BnB,kBAAkB,EAAA;;AAIpB;EACE,OAAO;EACP,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,cP34ByB;EO44BzB,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cPt5BkB;EOu5BlB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB,EAAA;;AAGxB;EACE,SAAS;EACT,kBAAkB;EAClB,gCP75BuB,EAAA;;AOg6BzB;EACE,WAAW;EACX,WAAW;EACX,sHAMC,EAAA;;AAGH;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,8BAA8B;EAC9B,iBAAiB;EACjB,MAAM;EACN,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,8JAOC,EAAA;;AAGH;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB,EAAA;;AAGpB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;EAEtB,kBAAkB,EAAA;;AAIpB;EACE,YAAY;EACZ,WAAW,EAAA;;AAGb;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,cPn/ByB;EOo/BzB,sBAAsB,EAAA;;AAGxB;EACE,kBAAkB;EAClB,cP7/BkB;EO8/BlB,sBAAsB,EAAA;;AAGxB;EACE,qBAAqB,EAAA;;AAGvB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB,EAAA;;AAGlB;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY,EAAA;;AAGd;EACE,sBAAsB;EACtB,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cPhiCkB,EAAA;;AOmiCpB;EACE,cPh/BoB,EAAA;;AOo/BtB;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,0CPpgCmB;EOqgCnB,mBAAmB;EACnB,yGPjgCiB;EOwgCjB,0EAEiC,EAAA;;AAGnC;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCPnkCuB,EAAA;;AOukCzB;;EAEE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB,EAAA;EANrB;;IASI,SAAS,EAAA;EATb;;IAaI,SAAS,EAAA;;AAKb;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB,EAAA;EALrB;IAQI,SAAS,EAAA;EARb;IAYI,SAAS,EAAA;;AAIb;EACE,SAAS;EACT,kBAAkB;EAClB,gCP5mCuB,EAAA;;AOinCzB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCPvnCuB,EAAA;;AO0nCzB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,SAAS,EAAA;;AAGX;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCPvoCuB,EAAA;;AO0oCzB;EACE,iBAAiB;EACjB,wBAAwB;EACxB,0CPnmCmB;EOomCnB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,cPjpCuB;EOkpCvB,iCPnmCiB;EOomCjB,eAAe,EAAA;EATjB;IAYI,aAAa;IACb,mBAAmB,EAAA;EAbvB;IAiBI,2CPjnCiB;IOknCjB,mBAAmB,EAAA;;AAIvB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa,EAAA;;AAGf;EACE,aAAa,EAAA;;AAGf;EAEI,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB,EAAA;;AALpB;EASI,cAAc;EACd,gBAAgB;EAChB,YAAY,EAAA;;AAIhB;EACE,sBAAsB;EACtB,iBAAiB,EAAA;;AAGnB;EACE,SAAS;EACT,UAAU;EACV,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,iDAAiD;EACjD,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU,EAAA;EAPZ;IAUI,gBAAgB,EAAA;;AAIpB;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,gCPztCuB,EAAA;;AO4tCzB;EACE,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,gCPjuCuB,EAAA;;AOouCzB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB,EAAA;;AAGlB;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,+BAA+B,EAAA;;AAGjC;EACE,YAAY;EACZ,0CP9sCmB;EO+sCnB,kBAAkB;EAClB,oCPhtCmB;EOitCnB,sBAAsB,EAAA;;AAGxB;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,+BAA+B,EAAA;;AAGjC;EACE,YAAY;EACZ,kBAAkB;EAClB,oCP9tCmB;EO+tCnB,0CP/tCmB;EOguCnB,sBAAsB,EAAA;;AAGxB;EACE,eAAe;EACf,wBAAwB;EACxB,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,gCPnxCuB,EAAA;;AOwxCzB;EACE,iBAAiB,EAAA;;AAGnB;EACE,SAAS;EACT,UAAU;EACV,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,iCAAiC;EACjC,YAAY;EACZ,uBAAuB,EAAA;EAEvB;IACE,iBAAiB,EAAA;EAGnB;IACE,mBAAmB,EAAA;IADpB;MAIG,cAAc,EAAA;;AAKpB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,mCPzxCmB;EO0xCnB,8CP1xCmB,EAAA;;AO6xCrB;EACE,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,oCPnyCmB,EAAA;;AOsyCrB;EACE,gBAAgB;EAChB,QAAQ;EACR,iDPn1CuB;EOo1CvB,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,YAAY,EAAA;;AAGd;EACE,cAAc;EACd,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB,EAAA;;AAGrB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCPt0CmB,EAAA;;AOy0CrB;EACE,YAAY;EACZ,mBAAmB,EAAA;;AAGrB;EACE,SAAS;EACT,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cP93CuB,EAAA;;AOi4CzB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,yCP53CU;EO63CV,kBAAkB;EAClB,kCP31CiB,EAAA;;AO81CnB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,cP94CuB,EAAA;EO04CzB;IAOI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,sBAAsB;IACtB,UAAU;IACV,oBAAoB;IACpB,YAAY,EAAA;;AAIhB;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,gCPh6CuB,EAAA;;AOm6CzB;EACE,cP33CkB;EO43ClB,kBAAkB,EAAA;;AAGpB;EAEI,cAAc;EACd,eAAe;EACf,mBPn4CgB;EOo4ChB,iFPp4CgB,EAAA;;AO04CpB;EACE,+BPp7CuB,EAAA;;AOu7CzB;EAEI,qCPz7CqB;EO07CrB,gBAAgB,EAAA;;AAHpB;;EAQI,YAAY;EACZ,sBAAsB,EAAA;;AAI1B;EACE,SAAS;EACT,+BPt8CuB;EOu8CvB,gBAAgB,EAAA;;AAGlB;EACE,sBAAsB;EACtB,WAAW;EACX,wBAAwB;EACxB,yCPp6CmB;EOq6CnB,mBAAmB;EACnB,iCPj6CiB,EAAA;;AOo6CnB;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCP19CuB,EAAA;;AO69CzB;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,YAAY,EAAA;;AAGd;EACE,OAAO;EACP,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,mBAAmB;EACnB,WAAW,EAAA;;AAGb;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCPt/CuB,EAAA;;AOy/CzB;EACE,SAAS;EACT,UAAU;EACV,gBAAgB,EAAA;EAHlB;IAMI,kBAAkB;IAClB,+BAA+B;IAC/B,eAAe;IACf,iBAAiB;IACjB,gCPngDqB,EAAA;IOy/CzB;MAaM,aAAa,EAAA;;AAKnB;EACE,gCP5gDuB,EAAA;;AO+gDzB;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,mBAAmB;EACnB,WAAW,EAAA;;AAGb;EACE,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,+BAA+B;EAC/B,2CPriDuB;EOsiDvB,eAAe;EACf,2EAGwB,EAAA;;AAG1B;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,oCAAoC;EACpC,sBAAsB;EACtB,4BAA4B,EAAA;EAP9B;IAWM,aAAW,EAAA;EAXjB;IAWM,aAAW,EAAA;EAXjB;IAWM,aAAW,EAAA;EAXjB;IAWM,aAAW,EAAA;EAXjB;IAWM,aAAW,EAAA;EAXjB;IAWM,aAAW,EAAA;EAXjB;IAWM,aAAW,EAAA;EAXjB;IAWM,aAAW,EAAA;EAXjB;IAWM,aAAW,EAAA;EAXjB;IAWM,aAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,cAAW,EAAA;EAXjB;IAWM,eAAW,EAAA;;AAKjB;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB,EAAA;;AAGtB;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,cPrlDkB;EOslDlB,sEAE8B,EAAA;;AAGhC;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCPhmDuB;EOimDvB,sEAE+B,EAAA;;AAIjC;EAEI,uCPzmDqB;EO0mDrB,gBAAgB;EAChB,8BAA8B,EAAA;;AAJlC;EAQI,qFAIC,EAAA;;AAIL;EAEI,sCPhlDgB;EOilDhB,gBAAgB;EAChB,kCP/kDe,EAAA;;AO2kDnB;EAQI,sFAIC,EAAA;;AAKL;EAEI,sCPrlDkB;EOslDlB,6EPrlDY,EAAA;;AOklDhB;EASI,WAAW;EACX,oDAA0D,EAAA;;AAI9D;EAEI,sCP/mDgB;EOgnDhB,+EP/mDiB,EAAA;;AO4mDrB;EASI,WAAW;EACX,oDAAsD,EAAA;;AAI1D;EAEI,sCP3mDkB;EO4mDlB,gBAAgB;EAChB,kCP3mDsB,EAAA;;AOumD1B;EAQI,oFAIC,EAAA;;AAIL;EAEI,sCP3nDkB;EO4nDlB,+EP7nDuB,EAAA;;AO0nD3B;EASI,WAAW;EACX,oDAA+D,EAAA;;AAInE;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB,EAAA;;AAGnB;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,0CP1qDmB;EO2qDnB,+BAA+B;EAC/B,gCPttDuB;EOutDvB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0DAA0D,EAAA;EAjB5D;IAoBI,oCPzrDiB;IO0rDjB,sCP1rDiB,EAAA;;AO8rDrB;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,0CPvsDmB;EOwsDnB,iCAAiC;EACjC,yEAE+B,EAAA;;AAGjC;EACE,SAAS;EACT,UAAU;EACV,gBAAgB,EAAA;EAHlB;IAMI,kBAAkB;IAClB,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,gCPlwDqB,EAAA;IOwvDzB;MAaM,aAAa,EAAA;;AAKnB;EACE,gCP3wDuB,EAAA;;AO8wDzB;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6CPvuDmB;EOwuDnB,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,cPhuDoB,EAAA;;AOmuDtB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EPv+Cb,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,6DAA6D,EAAA;EAE7D;IACE,UAAU,EAAA;EAGZ;IACE,+BAA+B;IAC/B,oBAAoB,EAAA;EAGtB;IACE,mCAzRiB;IA0RjB,oBAAoB;IACpB,2CAA2C,EAAA;EAG7C;IACE,oCA/RiB,EAAA;;AOsvDrB;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB,EAAA;EALrB;IAQI,SAAS,EAAA;;AAIb;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,WAAW,EAAA;;AAGb;EACE,0CP3wDmB;EO4wDnB,+BAA+B;EAC/B,gCPvzDuB;EOwzDvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,4EAA4E,EAAA;EAV9E;IAaI,oCPvxDiB;IOwxDjB,sCPxxDiB;IOyxDjB,gCPn0DqB,EAAA;EOs0DvB;IACE,oCP7xDiB;IO8xDjB,sCP9xDiB;IO+xDjB,gCPz0DqB,EAAA;;AO+0DzB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS,EAAA;;AAGX;EACE,0BAA0B,EAAA;;AAG5B;EACE,0BAA0B,EAAA;;AAG5B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BPn2DuB,EAAA;;AOs2DzB;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,0CPp0DmB;EOq0DnB,mBAAmB;EACnB,qDAAkE,EAAA;EAVpE;IAaI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,aAAa,EAAA;EAlBjB;IAsBI,YAAY,EAAA;EAtBhB;IA0BI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,cP11DgB,EAAA;;AO81DpB;EACE,OAAO;EACP,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,cPh5DkB,EAAA;;AOm5DpB;EArEA;IAuEI,0BAA0B,EAAA,EAC3B;;AAKH;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,0CPx3DmB;EOy3DnB,mBAAmB;EACnB,yGPr3DiB;EO43DjB,0EAEiC,EAAA;;AAGnC;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB,EAAA;EAPnB;;IAWI,cAAc;IACd,WAAW;IACX,aAAa,EAAA;EAbjB;;IAkBI,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,iBAAiB,EAAA;;AAIrB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EAEZ,aAAa,EAAA;;AAGf;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EPlqDhB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,6DAA6D,EAAA;EAE7D;IACE,UAAU,EAAA;EAGZ;IACE,+BAA+B;IAC/B,oBAAoB,EAAA;EAGtB;IACE,mCAzRiB;IA0RjB,oBAAoB;IACpB,2CAA2C,EAAA;EAG7C;IACE,oCA/RiB,EAAA;;AOg7DrB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,cAAc;EACd,mBAAmB,EAAA;;AAGrB;EACE,SAAS;EACT,OAAO;EACP,YAAY;EACZ,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCP7+DuB,EAAA;;AOg/DzB;EACE,cAAc;EACd,WAAW,EAAA;;AAGb;EACE,sBAAsB;EACtB,SAAS;EACT,wBAAwB;EACxB,0CPh9DkB;EOi9DlB,kBAAkB;EAClB,uBAAuB;EACvB,cPn9DkB;EOo9DlB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe,EAAA;;AAGjB;EACE,qCP59DkB;EO69DlB,cPh/DwB,EAAA;;AOm/D1B;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,8BPx9DoB;EOy9DpB,kCPxgEsB,EAAA;;AO2gExB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gCPphEuB,EAAA;;AOuhEzB;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,cPx+DoB,EAAA;;AO2+DtB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,gCP/iEuB,EAAA;;AOkjEzB;EACE,gBAAgB;EAChB,cP9hEwB,EAAA;;AOiiE1B;EACE,gCPvjEkB,EAAA;;AO0jEpB;EACE,kBAAkB;EAClB,+BPphEkB,EAAA;;AOuhEpB;EACE,kBAAkB;EAClB,gCPjkEkB,EAAA;;AOokEpB;EACE,mBAAmB,EAAA;;AAGrB;EACE,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,cP9kEuB,EAAA;;AOilEzB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCPnlEkB,EAAA;;AOslEpB;EACE,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,0CP1lEyB;EO2lEzB,kCPvlEsB;EOwlEtB,cP9lEuB;EO+lEvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,8BPhkEkB;EOikElB,iCPpmEsB;EOqmEtB,kBAAkB;EAClB,+BP5mEuB,EAAA;;AO+mEzB;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,cP5kEkB,EAAA;;AO+kEpB;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,iCPtnEsB,EAAA;;AOynExB;EACE,8BPzmEmB,EAAA;;AO4mErB;EACE,8BP/kEoB,EAAA;;AOklEtB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB,EAAA;;AAG3B;EAEE,cPznEmB,EAAA;;AO4nErB;EAEE,cPhmEoB,EAAA;;AOmmEtB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BP3pEuB,EAAA;;AO8pEzB;EACE,wBAAwB;EACxB,kBAAkB;EAClB,2CP/pEyB;EOgqEzB,uBAAuB;EACvB,cPlqEkB;EOmqElB,kBAAkB;EAClB,eAAe,EAAA;;AAGjB;EACE,cPzqEuB;EO0qEvB,uCPzqEkB,EAAA;;AO4qEpB;EACE,sCPvpEmB;EOwpEnB,cPzpEwB;EO0pExB,qCPzpEmB,EAAA;;AO4pErB;EACE,aAAa,EAAA;;AAGf;EACE,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,YAAY;EACZ,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,eAAe,EAAA;;AAGjB;EACE,mBAAmB;EACnB,aAAa,EAAA;EAFf;IAMI,sCAAsC;IACtC,gCAAgC;IAChC,0CAA0C;IAC1C,eAAe,EAAA;;AAInB;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cP3qEyB,EAAA;;AO8qE3B;EACE,eAAe;EACf,mBAAmB,EAAA;;AAGrB;EACE,mBAAmB,EAAA;;AAGrB;EACE,aAAa,EAAA;;AAGf;EACE,aAAa,EAAA;;AAGf;EACE,kBAAkB;EAClB,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,wBAAwB,EAAA;;AAG1B;EACE,kBAAkB;EAClB,sBAAsB,EAAA;;AAGxB;EACE,kBAAkB;EAClB,uBAAuB,EAAA;;AAGzB;EACE,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,0CPjuEmB;EOkuEnB,iCP7tEiB;EO8tEjB,kBAAkB;EAClB,gBAAgB;EAChB,cP/wEuB;EOgxEvB,kBAAkB,EAAA;;AAGpB;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gCPxxEyB,EAAA;;AO2xE3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,0CPtvEmB;EOuvEnB,iCPlvEiB,EAAA;;AOsvEnB;EACE,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB,EAAA;;AAG3B;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,0CAA0C;EAC1C,cP50EuB;EO60EvB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,iCAAiC,EAAA;;AAGnC;EACE,iCAAiC;EACjC,0CAA0C,EAAA;;AAG5C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,YAAY,EAAA;;AAGd;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,cAAc,EAAA;;AAGhB;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB,EAAA;;AAGpB;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCPv3EyB,EAAA;;AO03E3B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cPh4EuB;EOi4EvB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCP14EyB;EO24EzB,sBAAsB,EAAA;;AAGxB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,8CP52EmB,EAAA;;AO+2ErB;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EPzmEhB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,6DAA6D,EAAA;EAE7D;IACE,UAAU,EAAA;EAGZ;IACE,+BAA+B;IAC/B,oBAAoB,EAAA;EAGtB;IACE,mCAzRiB;IA0RjB,oBAAoB;IACpB,2CAA2C,EAAA;EAG7C;IACE,oCA/RiB,EAAA;;AOu3ErB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,cAAc;EACd,mBAAmB,EAAA;;AAGrB;EACE,OAAO;EACP,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe,EAAA;;AAGjB;EACE,cAAc,EAAA;;AAGhB;EACE,SAAS;EACT,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCPn8EuB,EAAA;;AOs8EzB;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB,EAAA;;AAG3B;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,yCP56EmB;EO66EnB,kBAAkB;EAClB,kCP16EkB;EO26ElB,+BPh7EkB;EOi7ElB,eAAe,EAAA;;AAGjB;EACE,uCPv8EmB;EOw8EnB,cPz8EwB,EAAA;;AO48E1B;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,yCPn9Ea;EOo9Eb,kBAAkB;EAClB,kCPl9EoB;EOm9EpB,gCPx9EwB;EOy9ExB,eAAe,EAAA;;AAGjB;EACE,uCP59EmB;EO69EnB,mCP19EkB,EAAA;;AO69EpB;EACE,aAAa;EACb,eAAe,EAAA;;AAGjB;EACE,cAAc,EAAA;;AAGhB;EACE,eAAe,EAAA;;AAGjB;EACE,mBAAmB;EACnB,iBAAiB;EACjB,+BPvgFuB,EAAA;;AO0gFzB;EACE,cPt9EoB,EAAA;;AOy9EtB;EACE,cP19EoB,EAAA;;AO69EtB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BPrhFuB,EAAA;;AOwhFzB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB;EAChB,SAAS,EAAA;;AAGX;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,yCPngFmB;EOogFnB,kCP9/EuB;EO+/EvB,kBAAkB;EAClB,iBAAiB;EACjB,gCPnjFkB,EAAA;;AOsjFpB;EACE,oBAAoB;EACpB,YAAY,EAAA;;AAGd;EACE,yBPhhFmB;EOihFnB,kCP9gFwB,EAAA;;AOihF1B;EACE,oBAAoB;EACpB,eAAe,EAAA;;AAGjB;EACE,sCP3hFkB,EAAA;;AO8hFpB;EACE,sCPjjFmB;EOkjFnB,mCP/iFkB,EAAA;;AOkjFpB;EACE,eAAe,EAAA;;AAGjB;EACE,SAAS;EACT,kBAAkB;EAClB,cPjlFyB,EAAA;;AOolF3B;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc,EAAA;;AAGhB;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gCP/lFuB,EAAA;;AOomFzB;EA1lEA;IA4lEI,0BAA0B,EAAA;EAxjE9B;IA4jEI,cAAc;IACd,cAAc;IACd,WAAW,EAAA;EAzlEf;IA6lEI,cAAc;IACd,cAAc;IACd,sBAAsB;IACtB,WAAW,EAAA;EAtlEf;IA0lEI,sBAAsB,EAAA;EAllE1B;;IAulEI,WAAW;IACX,eAAe,EAAA;EAnVnB;IAuVI,eAAe;IACf,uBAAuB,EAAA;EAn/D3B;IAu/DI,sBAAsB;IACtB,oBAAoB,EAAA;EA9+DxB;IAk/DI,UAAU;IACV,WAAW,EAAA;EAj0Df;IAq0DI,WAAW;IACX,WAAW;IACX,eAAe;IACf,gIAMC,EAAA,EACF;;AAKH;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,WAAW,EAAA;;AAGb;EACE,0CP9nFmB;EO+nFnB,+BAA+B;EAC/B,gCP1qFuB;EO2qFvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,4EAA4E,EAAA;EAV9E;IAaI,oCP1oFiB;IO2oFjB,sCP3oFiB;IO4oFjB,gCPtrFqB,EAAA;;AO0rFzB;EACE,aAAa;EACb,SAAS,EAAA;;AAIT;EACE,gDAAoD,EAAA;;AADtD;EACE,gDAAoD,EAAA;;AADtD;EACE,gDAAoD,EAAA;;AADtD;EACE,gDAAoD,EAAA;;AAIxD;EACE,0CP5pFmB;EO6pFnB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,kBAAkB,EAAA;EALpB;IAQI,sBAAsB;IACtB,4BAA4B,EAAA;;AAIhC;EAEI,YAAY,EAAA;;AAIhB;EACE,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,QAAQ;EACR,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,gBAAgB,EAAA;;AAGlB;EAEI,aAAa,EAAA;;AAIjB;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,+BAA+B;EAC/B,mDAAmD;EACnD,0DAEyB,EAAA;EAR3B;IAWI,2BAA2B;IAC3B,8BAA8B,EAAA;EAZlC;IAgBI,4BAA4B;IAC5B,+BAA+B,EAAA;EAjBnC;IAqBI,kCP/tFU;IOguFV,sCPjuFiB;IOkuFjB,mDAAmD,EAAA;;AAIvD;EAEI,mCPxvFgB;EOyvFhB,qCPzvFgB,EAAA;;AO6vFpB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,UAAU;EACV,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCPlyFuB;EOmyFvB,kCAAkC;EAClC,iBAAiB;EACjB,0BAA0B;EAC1B,kCAAkC,EAAA;;AAGpC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU,EAAA;;AAGZ;;EAEE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,0CP3wFmB;EO4wFnB,+BAA+B;EAC/B,gCPvzFuB;EOwzFvB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0DAA0D,EAAA;EAd5D;;IAiBI,oCPvxFiB;IOwxFjB,sCPxxFiB,EAAA;;AO4xFrB;EACE,gBAAgB,EAAA;;AAGlB;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,0CPxyFmB;EOyyFnB,iCAAiC;EACjC,gCPp1FuB;EOq1FvB,eAAe;EACf,iBAAiB;EACjB,yEAE+B;EAC/B,qBAAqB;EACrB,sBAAsB,EAAA;EAjBxB;;IAoBI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS,EAAA;;AAIb;EACE,OAAO;EACP,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU,EAAA;;AAGZ;EACE,QAAQ;EACR,YAAY,EAAA;;AAGd;EACE,eAAe;EACf,eAAe;EACf,gCPz3FuB;EO03FvB,kBAAkB;EAClB,iBAAiB,EAAA;;AAGnB;EACE,cP10FoB,EAAA;;AO60FtB;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EPnlFlB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,6DAA6D,EAAA;EAE7D;IACE,UAAU,EAAA;EAGZ;IACE,+BAA+B;IAC/B,oBAAoB,EAAA;EAGtB;IACE,mCAzRiB;IA0RjB,oBAAoB;IACpB,2CAA2C,EAAA;EAG7C;IACE,oCA/RiB,EAAA;;AOi2FrB;EACE,aAAa;EACb,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,8EAA8E;EAC9E,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,0CP52FmB;EO62FnB,+BAA+B;EAC/B,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB,EAAA;;AAGpB;EACE,sEAAsE;EACtE,eAAe;EACf,gCPl6FuB,EAAA;;AOq6FzB;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,+BPl4FmB;EOm4FnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,+CPt4FmB;EOu4FnB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;EAfrB;IAkBI,cPv7FqB;IOw7FrB,gDPx7FqB,EAAA;;AO47FzB;EACE,sEAAsE;EACtE,eAAe;EACf,gCP/7FuB;EOg8FvB,mBAAmB;EACnB,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe,EAAA;;AAGjB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gCPj9FuB;EOk9FvB,iBAAiB,EAAA;;AAGnB;EACE,gBAAgB;EAChB,0CP76FmB;EO86FnB,oCP96FmB;EO+6FnB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BPr7FmB;EOs7FnB,eAAe,EAAA;EAXjB;IAcI,oCPz7FiB;IO07FjB,cPp+FqB,EAAA;;AOw+FzB;EACE,oCP/7FmB;EOg8FnB,sCPh8FmB;EOi8FnB,cP3+FuB,EAAA;;AO8+FzB;EACE,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,gBAAgB;EAChB,8CPz8FmB;EO08FnB,aAAa;EACb,QAAQ,EAAA;;AAGV;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gCP9/FuB,EAAA;;AOigGzB;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,cAAc;EACd,sEAAsE;EACtE,gCP3gGuB,EAAA;;AO8gGzB;EACE,oBAAoB;EACpB,aAAa,EAAA;;AAGf;EACE,sEAAsE;EACtE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,gCPxhGuB;EOyhGvB,iBAAiB,EAAA;;APrjGnB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AQv8BA;EACE,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kCRkEsB;EQjEtB,0BAA0B,EAAA;;AAG5B;EACE,kBAAkB;EAClB,uBAAkC;EAClC,4BAA4B;EAC5B,mBAAmB;EACnB,0CRkDmB;EQjDnB,2FAIC;EACD,sFAE8C;EAC9C,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,gCRduB;EQevB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mDAAmD,EAAA;EAfrD;IAkBI,cRxBgB;IQyBhB,qCRvBqB,EAAA;EQIzB;IAuBI,2CReiB;IQdjB,mBAAmB,EAAA;;AAIvB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,oCRCmB;EQAnB,8CRAmB,EAAA;;AQGrB;EACE,kBAAkB;EAClB,cR/CuB,EAAA;;AQkDzB;EACE,kBAAkB;EAClB,UAAU,EAAA;;AAGZ;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,cRjEkB;EQkElB,oCRtBmB,EAAA;;AQyBrB;EACE,mBAAmB;EACnB,cRvEkB;EQwElB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB,EAAA;;AAG3B;EACE,kBAAkB;EAClB,gCR9EuB;EQ+EvB,kBAAkB;EAClB,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;;EAEE,WAAW,EAAA;;AAGb;EAvHA;IAyHI,aAAa,EAAA;EA7GjB;IAiHI,gCAAgC,EAAA,EACjC;;ARjIH;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AS16BE;EAKU,WA/BM,EAAA;;AA0BhB;EAKU,YA9BO,EAAA;;AAyBjB;EAKU,YA7BQ,EAAA;;AAwBlB;EAKU,YA5BO,EAAA;;AAuBjB;EAKU,WA3BM,EAAA;;AAsBhB;EAKU,YAxBU,EAAA;;AAmBpB;EAKU,YAvBU,EAAA;;AAkBpB;EAKU,YAtBU,EAAA;;AAiBpB;EAKU,WArBU,EAAA;;AAgBpB;EAKU,WApBU,EAAA;;AAepB;EAKU,WAjBW,EAAA;;AAYrB;EAKU,YAhBY,EAAA;;AAWtB;EAKU,YAfY,EAAA;;AAUtB;EAKU,WAdW,EAAA;;AASrB;EAKU,WAbW,EAAA;;AAQrB;EAKU,YAZY,EAAA;;AAOtB;EAKU,WAXW,EAAA;;AAmCrB;EAEI,iBAhBe,EAAA;;AAcnB;EAEI,gBAfQ,EAAA;;AAaZ;EAEI,iBAdW,EAAA;;AAYf;EAEI,gBAba,EAAA;;AAWjB;EAEI,iBAZY,EAAA;;AAUhB;EAEI,iBAXW,EAAA;;AASf;EAEI,gBAVS,EAAA;;AAQb;EAEI,gBATmB,EAAA;;AAOvB;EAEI,iBAR4B,EAAA;;AAMhC;EAEI,gBAPgB,EAAA;;AAatB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW,EAAA;;AAKb;EACE,cAAc,EAAA;;AAIhB;EACE,WAAW;EACX,iBAAiB;EACjB,oBAAoB,EAAA;;AAKtB;EACE,yBTjDgB;ESkDhB,kBAAkB;EAClB,gBAAgB;EAChB,cT/DuB;ESgEvB,gBAAgB;EAChB,iCAAiC,EAAA;EANnC;IASI,WAAW;IACX,yBAAyB;IACzB,mBAAmB,EAAA;EAXvB;IAgBI,gBAAgB;IAGhB,uBAAuB;IACvB,eAAe,EAAA;EApBnB;;;;IA4BI,kBAAkB,EAAA;IA5BtB;;;;MA+BM,gBAAgB,EAAA;EA/BtB;IAqCI,iBAAiB,EAAA;EArCrB;IA0CI,2BAA2B;IAE3B,sBAAsB;IACtB,cTvGgB;ISwGhB,yBAAyB;IACzB,gCTtGU;IAglBZ,mHAAiF;IACjF,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B,EAAA;ES5hB7B;IAqDI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB,EAAA;IAzDtB;MA4DM,WAAW;MACX,kBAAkB;MAClB,QAAQ;MACR,QAAQ;MACR,2BAA2B;MAC3B,UAAU;MACV,WAAW;MACX,yBT1HQ,EAAA;ESuDd;IA0EI,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;IAClB,gCT7Hc;IS8Hd,iCAAiC,EAAA;ITkmBjC;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;ES/rBjE;IAmFI,YAAY;IACZ,cT9IgB;IS+IhB,gBAAgB,EAAA;IArFpB;MAuFwB,mBTpGJ,EAAA;ISapB;MAwFwB,mBTnGC,EAAA;ISWzB;MA0FM,iCAAiC;MACjC,kBAAkB,EAAA;IA3FxB;MA+FM,YAAY,EAAA;EA/FlB;IAqGI,iCAAiC;IACjC,kDAAkD;IAClD,wDAAwD;IACxD,kBAAkB,EAAA;EAxGtB;;;;IAgHI,gBAAgB;IAChB,UAAU;IACV,eAAe,EAAA;IAlHnB;;;;MAmHc,eTnKI,EAAA;ESXhB;IAoLyB,WAAW,EAAA;EApLpC;IAqLyB,YAAY,EAAA;EArLrC;IAsLyB,YAAY,EAAA;EAtLrC;IAuLyB,YAAY,EAAA;EAvLrC;IAwLyB,WAAW,EAAA;EA7HtC;IAmI2B,WAAY;IAAE,YAAY,EAAA;EA9LnD;IA+LyB,YAAY,EAAA;EA/LrC;IAgMyB,YAAY,EAAA;EAhMrC;IAiMyB,WAAY,EAAA;EAjMrC;IAkMyB,WAAY,EAAA;EAlMrC;IAmMyB,WAAY,EAAA;EAxIvC;IA8I+B,WAAY,EAAA;EA9I3C;IA+I+B,YAAY,EAAA;EA/I3C;IAgJ+B,YAAY,EAAA;EAhJ3C;IAiJ+B,WAAY,EAAA;EAjJ3C;IAkJ+B,WAAY,EAAA;EAlJ3C;IAmJ+B,WAAY,EAAA;EAnJ3C;IAoJ+B,WAAY,EAAA;EApJ3C;IAqJ+B,WAAY,EAAA;EArJ3C;IAsJ+B,WAAY,EAAA;EAtJ3C;IAuJ+B,WAAY,EAAA;EAvJ3C;IAwJ+B,YAAY,EAAA;EAxJ3C;IAyJ+B,WAAY,EAAA;EAzJ3C;IA0J+B,WAAY,EAAA;EA1J3C;IA+JI,kBAAkB;IAClB,gBAAgB;IAEhB,oBAAoB;IACpB,YAAY;IACZ,gBAAgB,EAAA;IApKpB;MAuKM,yBAAyB;MACzB,iBAAiB;MACjB,kBAAkB;MAClB,WAAW;MACX,6FAE6C,EAAA;MA7KnD;QAgLQ,mBAAmB;QACnB,YAAY;QTwWlB,mHAAiF;QACjF,sBAAsB;QACtB,4BAA4B;QAC5B,2BAA2B,EAAA;MS5hB7B;QAsLQ,4BAA4B,EAAA;MAtLpC;QA0LQ,uFAEoC,EAAA;IA5L5C;MAiMM,YAAY;MACZ,gBAAgB;MAChB,WAAW;MACX,mBAAmB;MTqVvB,mHAAiF;MACjF,sBAAsB;MACtB,4BAA4B;MAC5B,2BAA2B;MStVvB,uFAEoC;MACpC,6FAE6C,EAAA;MA3MnD;QA8MQ,YAAY;QACZ,gBAAgB;QAChB,oBAAoB;QACpB,sBAAsB;QACtB,aAAa;QACb,mBAAmB;QACnB,qBAAqB,EAAA;IApN7B;MAyNM,kBAAkB;MAClB,YAAY,EAAA;IA1NlB;MA8NM,aAAa;MACb,mBAAmB;MACnB,mBAAmB;MACnB,QAAQ;MACR,YAAY,EAAA;IAlOlB;;MAuOM,oBAAoB;MACpB,mBAAmB;MACnB,uBAAuB;MACvB,gBAAgB;MAChB,YAAY;MACZ,kBAAkB;MAClB,uBAAuB;MACvB,cTzSmB;MS0SnB,eAAe,EAAA;MA/OrB;;QAkPQ,aAAa;QACb,eAAe,EAAA;MAnPvB;;QAuPQ,qCAAqC,EAAA;IAvP7C;MA4PM,cAAc,EAAA;IA5PpB;MAgQM,aAAa;MACb,mBAAmB;MACnB,mBAAmB;MACnB,QAAQ;MACR,aAAa;MACb,YAAY;MACZ,eAAe;MACf,uBAAuB,EAAA;IAvQ7B;MA2QM,kBAAkB;MAClB,gBAAgB;MAChB,6BAA6B;MAC7B,kBAAkB;MAClB,uBAAuB;MACvB,cAAc;MACd,iBAAiB;MACjB,eAAe;MACf,gBAAgB,EAAA;MAnRtB;QAsRQ,qCAAqC,EAAA;MAtR7C;QA0RQ,qCAAqC;QACrC,oCAAoC;QACpC,8CAA8C,EAAA;IA5RtD;MAiSM,cAAc;MACd,aAAa;MACb,iBAAiB;MACjB,kBAAkB,EAAA;MApSxB;QAuSQ,aAAa;QACb,cTnWiB;QSoWjB,sBAAsB;QACtB,gBAAgB,EAAA;IA1SxB;MA+SM,eAAe;MACf,iBAAiB,EAAA;IAhTvB;MAoTM,WAAW;MACX,mBAAmB;MACnB,UAAU;MACV,4BAA4B;MAE5B,sBAAsB;MACtB,4BAA4B;MAC5B,2BAA2B;MAC3B,uFAEoC,EAAA;IA9T1C;MAkUoC,WAAY,EAAA;IAlUhD;MAmUoC,YAAY,EAAA;IAnUhD;MAoUoC,YAAY,EAAA;IApUhD;MAqUoC,WAAY,EAAA;IArUhD;MAsUoC,WAAY,EAAA;IAtUhD;MAuUoC,WAAY,EAAA;IAvUhD;MAwUoC,WAAY,EAAA;IAxUhD;MAyUoC,WAAY,EAAA;IAzUhD;MA0UoC,WAAY,EAAA;IA1UhD;MA2UoC,WAAY,EAAA;IA3UhD;MA4UoC,WAAY,EAAA;IA5UhD;MA6UoC,WAAY,EAAA;IA7UhD;MA8UoC,WAAY,EAAA;IA9UhD;MAkVM,cAAc;MACd,cAAc;MACd,gBAAgB;MAChB,eAAe;MACf,WAAW;MACX,YAAY;MACZ,mBAAmB;MACnB,wBAAwB;MACxB,2BAA2B,EAAA;IA1VjC;MA8VM,kBAAkB;MAClB,yBAAyB,EAAA;IA/V/B;MAmWM,oBAAoB;MACpB,sBAAsB;MACtB,uBAAuB;MACvB,WAAW;MACX,iBAAiB;MACjB,gBAAgB,EAAA;IAxWtB;MA4WM,kBAAkB,EAAA;IA5WxB;MAgXM,iBAAiB;MACjB,aAAa;MACb,sBAAsB,EAAA;IAlX5B;;MAwXM,gBAAgB;MAChB,mBAAmB,EAAA;IAzXzB;MA6XM,oBAAoB;MACpB,mBAAmB;MACnB,uBAAuB;MACvB,gCAAgC,EAAA;IAhYtC;MAoYM,WAAW;MACX,YAAY;MACZ,cAAc,EAAA;IAtYpB;;;MA4YM,kBAAkB,EAAA;IA5YxB;;MAiZM,qBAAqB;MACrB,iBAAiB;MACjB,aAAa,EAAA;IAnZnB;;MAyZM,gBAAgB,EAAA;IAzZtB;MA6ZM,kBAAkB;MAClB,iBAAiB,EAAA;IA9ZvB;MAkaM,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,iBAAiB,EAAA;MAravB;QAwaQ,mBAAmB,EAAA;MAxa3B;QA4aQ,kBAAkB;QAClB,WAAW;QACX,SAAS;QACT,cAAc,EAAA;MA/atB;;QAobQ,QAAQ;QACR,oCAAoC,EAAA;IArb5C;MA2bQ,eAAe;MAEjB,sBAAsB,EAAA;IA7b5B;MAicM,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,YAAY;MACZ,WAAW;MACX,YAAY;MACZ,gBAAgB;MAChB,iBAAiB,EAAA;IAxcvB;MA4cM,WAAW;MACX,YAAY,EAAA;IA7clB;MAidM,cAAc;MACd,WAAW;MACX,2BAA2B;MAC3B,kBAAkB;MAClB,iBAAiB,EAAA;MArdvB;QAwdQ,kBAAkB;QAClB,SAAS;QACT,QAAQ;QACR,WAAW;QACX,YAAY;QACZ,gCAAgC,EAAA;MA7dxC;QAieQ,WAAW;QACX,UAAU;QACV,eAAe,EAAA;MAnevB;QAueQ,WAAW;QACX,YAAY,EAAA;MAxepB;QA4eQ,UAAU;QACV,WAAW;QACX,QAAQ;QACR,YAAY;QACZ,WAAW;QACX,0BAA0B,EAAA;MAjflC;;QAufU,wBAAwB,EAAA;MAvflC;;QA6fQ,UAAU;QACV,yDAAyD,EAAA;IA9fjE;MAmgBM,qBAAqB;MACrB,gBAAgB;MAChB,kBAAkB;MAClB,cThkBc,EAAA;IS0DpB;MA0gBM,oBAAoB;MACpB,sBAAsB;MACtB,mBAAmB;MACnB,uBAAuB;MACvB,WAAW;MACX,eAAe;MACf,cAAc;MACd,kBAAkB;MAClB,iBAAiB;MACjB,kBAAkB;MAClB,mBAAmB;MACnB,yBAAyB;MACzB,sBAAsB,EAAA;IAthB5B;MA0hBM,cAAc;MACd,SAAS;MACT,eAAe;MACf,gBAAgB;MAChB,kBAAkB;MAClB,iBAAiB;MACjB,mBAAmB;MACnB,yBAAyB;MACzB,sBAAsB,EAAA;MAliB5B;QAqiBQ,WAAW;QACX,cThmBY,EAAA;IS0DpB;MA4iBQ,cT9jBY,EAAA;ISkBpB;MAgjBQ,cTlkBY,EAAA;ISkBpB;MAqjBM,cAAc;MACd,WAAW;MACX,gBAAgB,EAAA;IAvjBtB;MA2jBM,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,WAAW,EAAA;IA9jBjB;MAkkBM,kBAAkB;MAClB,mBAAmB;MACnB,8CAA8C,EAAA;IApkBpD;MAykBM,aAAa;MACb,WAAW;MACX,eAAe;MACf,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,mBAAmB;MACnB,yBAAyB;MACzB,sBAAsB;MACtB,iBAAiB;MACjB,kBAAkB,EAAA;IAnlBxB;MAulBM,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,mBAAmB,EAAA;IA1lBzB;MA8lBM,cAAc;MACd,eAAe;MACf,gBAAgB;MAChB,WAAW;MACX,YAAY;MACZ,mBAAmB;MACnB,wBAAwB,EAAA;IApmB9B;MAwmBM,aAAa;MACb,oBAAoB;MACpB,uBAAuB;MACvB,mBAAmB;MACnB,kBAAkB;MAClB,eAAe;MACf,gBAAgB;MAChB,kBAAkB;MAClB,6BAA6B;MAC7B,kBAAkB;MAClB,gBAAgB;MAChB,cAAc;MACd,+FAIiB,EAAA;MAxnBvB;QA2nBQ,+BT7oBY;QS8oBZ,6DAIC;QACD,sCTnpBY;QSopBZ,oFAEkC,EAAA;QApoB1C;UAuoBU,oFAEkC,EAAA;MAzoB5C;QA+oBQ,cAAc;QACd,yFAIC;QACD,qCAAqC;QACrC,kFAEkC,EAAA;QAxpB1C;UA2pBU,uCAAuC;UACvC,kFAEkC,EAAA;MA9pB5C;QAmqBQ,cAAc;QACd,oCAAoC;QACpC,uCAAuC;QACvC,gBAAgB,EAAA;IAtqBxB;MA4qBM,aAAa;MACb,SAAS;MACT,uBAAuB,EAAA;IA9qB7B;MAkrBM,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,yBT1rBU;MS2rBV,sBAAsB,EAAA;MAtrB5B;QAyrBQ,mBT5tBO;QS6tBP,yBT7tBO,EAAA;MSmCf;QA8rBQ,uBAAuB;QACvB,YAAY,EAAA;IA/rBpB;MAosBM,aAAa;MACb,QAAQ;MACR,uBAAuB;MACvB,mBAAmB,EAAA;IAvsBzB;MA2sBM,WAAW;MACX,YAAY;MACZ,mBAAmB;MACnB,6BAA6B;MAC7B,wBAAwB;MACxB,2BAA2B,EAAA;IAhtBjC;MAotBM,YAAY,EAAA;IAptBlB;MAwtBM,YAAY,EAAA;IAxtBlB;MA4tBM,YAAY;MACZ,iCAAiC;MACjC,0BAA0B;MAC1B,uBAAuB,EAAA;IA/tB7B;MAmuBM,0BAA0B;MAC1B,uBAAuB,EAAA;IApuB7B;MAwuBM,kBAAkB;MAClB,uBAAuB;MACvB,2BAA2B;MAC3B,kBAAkB;MAClB,gBAAgB;MAChB,cAAc;MAEd,qBAAqB,EAAA;MA/uB3B;QAkvBQ,kBAAkB;QAClB,UAAU,EAAA;IAnvBlB;MAwvBM,kBAAkB;MAClB,OAAO;MACP,MAAM;MACN,UAAU;MACV,oBAAoB;MACpB,iBAAiB,EAAA;MA7vBvB;QAgwBQ,UAAU;QACV,eT5zBiB;QS6zBjB,iBAAiB;QACjB,qBAAqB;QACrB,sBAAsB,EAAA;;AAK1B;EACE;IACE,UAAU;IACV,2BAA2B,EAAA;EAG7B;IACE,UAAU;IACV,wBAAwB,EAAA,EAAA;;AAK5B;EACE;;IAEE,UAAU,EAAA;EAGZ;IACE,UAAU,EAAA,EAAA;IA7xBlB;MAkyBM,kBAAkB;MAClB,wBAAwB;MACxB,0BAA0B;MAC1B,4BAA4B;MAC5B,8BAA8B;MAC9B,UAAU;MACV,oBAAoB;MACpB,kBAAkB;MAClB,sFAEmC;MACnC,kCT1zBc;MS2zBd,oHACyC,EAAA;MAEzC;QAjzBN;UAkzBQ,eAAe;UACf,UAAU,EAAA,EAEb;IArzBL;MAwzBM,kBAAkB;MAClB,OAAO;MACP,MAAM;MACN,SAAS;MACT,UAAU;MACV,WAAW;MACX,SAAS;MACT,UAAU;MACV,YAAY;MACZ,gBAAgB;MAChB,uBAAuB;MACvB,eAAe,EAAA;MAn0BrB;QAs0BQ,qCTj4BiB,EAAA;MS2DzB;QA00BQ,2CTr4BiB;QSs4BjB,mBAAmB,EAAA;IA30B3B;MAi1BM,kBAAkB;MAClB,kBAAkB,EAAA;MAl1BxB;QAq1BQ,WAAW;QACX,kBAAkB;QAClB,SAAS;QACT,QAAQ;QACR,2BAA2B;QAC3B,QAAQ;QACR,SAAS;QACT,iCAAiC;QACjC,oCAAoC;QACpC,8BTz5BiB;QS05BjB,oBAAoB;QACpB,UAAU;QACV,+BAA+B,EAAA;IAj2BvC;MAy2BM,yCAAyC,EAAA;IAz2B/C;MA62BM,kBAAkB;MAClB,UAAU;MACV,WAAW;MACX,yBAAyB;MACzB,sBAAsB,EAAA;IAj3B5B;MAq3BM,eAAe;MACf,yEAGkB;MAClB,kBAAkB;MAClB,gBAAgB;MAChB,kDAAkD,EAAA;MA53BxD;QAg4BQ,iBAAiB;QACjB,kBAAkB;QAClB,UAAU,EAAA;MAl4BlB;QAs4BQ,uBAAuB;QACvB,gBAAgB,EAAA;MAv4BxB;QA24BQ,mBAAmB;QACnB,sFAEmC,EAAA;MA94B3C;QAk5BQ,mBAAmB;QACnB,sFAEmC,EAAA;MAr5B3C;QAy5BQ,iCAAiC;QACjC,uFAEoC;QACpC,mDAAmD,EAAA;MA75B3D;QAi6BQ,qBAAqB;QACrB,8HAGwC;QACxC,gGACgD;QAChD,wDAAwD,EAAA;MAx6BhE;QA46BQ,qBAAqB;QACrB,+HAGwC;QACxC,kGACgD,EAAA;MAl7BxD;QAs7BQ,yKAIyC,EAAA;MA17BjD;QA87BQ,yKAIyC,EAAA;MAl8BjD;QAs8BQ,qIAOsB;QACtB,0KAIyC;QACzC,mDAAmD,EAAA;MAn9B3D;QAu9BQ,qIAOqB;QACrB,wKAIyC;QACzC,gGACgD,EAAA;MAr+BxD;QAy+BQ,mJAOuB;QACvB,2KAIyC;QACzC,kGACgD,EAAA;IAv/BxD;MA4/BM,YAAY;MACZ,aAAa;MACb,eAAe;MACf,uBAAuB;MACvB,gBAAgB;MAChB,YAAY;MACZ,mEAAmE,EAAA;MAlgCzE;QAqgCQ,YAAY;QACZ,uBAAuB;QACvB,gBAAgB,EAAA;MAvgCxB;QA2gCQ,YAAY;QACZ,uBAAuB;QACvB,gBAAgB,EAAA;IA7gCxB;MAkhCM,UAAU;MACV,uBAAuB;MACvB,kCAAkC;MAClC,2BAA2B;MAC3B,2BAA2B;MAC3B,iBAAiB;MACjB,mBAAmB;MACnB,iBAAiB,EAAA;IAzhCvB;MA6hCM,qBAAqB;MACrB,YAAY;MACZ,gBAAgB;MAChB,YAAY;MACZ,iBAAiB;MACjB,oBAAoB;MACpB,gBAAgB;MAChB,mBAAmB;MACnB,kBAAkB;MAClB,gBAAgB,EAAA;IAtiCtB;MA0iCM,WAAW;MACX,yBAAyB;MACzB,iBAAiB;MACjB,mBAAmB,EAAA;IA7iCzB;;MAmjCQ,QAAQ;MACR,YAAY,EAAA;IApjCpB;MAwjCQ,kBAAkB;MAClB,YAAY,EAAA;IAzjCpB;MA8jCM,eAAe;MACf,yEAGkB;MAClB,kBAAkB;MAClB,gBAAgB;MAChB,kDAAkD;MAClD,+BAA+B;MAC/B,sFAEmC,EAAA;MAzkCzC;QA6kCQ,iBAAiB;QACjB,kBAAkB;QAClB,UAAU,EAAA;MA/kClB;QAmlCQ,uBAAuB;QACvB,gBAAgB,EAAA;MAplCxB;QAwlCQ,iCAAiC;QACjC,uFAEoC;QACpC,mDAAmD,EAAA;MA5lC3D;QAgmCQ,iCAAiC;QACjC,8HAGwC;QACxC,gGACgD;QAChD,wDAAwD,EAAA;MAvmChE;QA2mCQ,iCAAiC;QACjC,+HAGwC;QACxC,kGACgD,EAAA;MAjnCxD;QAqnCQ,iJAOqB;QACrB,yKAIyC,EAAA;MAjoCjD;QAqoCQ,mJAOuB;QACvB,0KAIyC;QACzC,mDAAmD,EAAA;MAlpC3D;QAspCQ,mJAOuB;QACvB,wKAIyC;QACzC,gGACgD,EAAA;MApqCxD;QAwqCQ,mJAOuB;QACvB,2KAIyC;QACzC,kGACgD,EAAA;IAtrCxD;MA6rCM,kBAAkB,EAAA;MA7rCxB;QAgsCQ,WAAW;QACX,kBAAkB;QAClB,QAAQ;QACR,UAAU;QACV,oBAAoB;QACpB,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,eAAe;QACf,SAAS;QACT,UAAU;QACV,aAAa;QACb,weAsBG;QACH,qCAAqC;QACrC,2HAEoD,EAAA;MAtuC5D;QA0uCQ,WAAW;QACX,kBAAkB;QAClB,QAAQ;QACR,UAAU;QACV,oBAAoB;QACpB,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,eAAe;QACf,SAAS;QACT,UAAU;QACV,+HAMC;QACD,aAAa;QACb,2HAE4C,EAAA;MAG9C;QAlwCN;UAqwCU,eAAe;UACf,aAAa,EAAA,EACd;IAvwCT;MA6wCQ,YAAY;MACZ,geAsBG,EAAA;IApyCX;MAwyCQ,uIAMC;MACD,YAAY,EAAA;IAGd;MAlzCN;QAqzCU,eAAe;QACf,YAAY,EAAA,EACb;IAvzCT;MA4zCM,qBAAqB;MACrB,kBAAkB;MAClB,kBAAkB;MAClB,qBAAqB;MACrB,sEAAsE;MACtE,iBAAiB;MACjB,sBAAsB;MACtB,yBAAyB;MACzB,gCAAgC;MAChC,gEAAgE,EAAA;MAEhE;QAv0CN;UAw0CQ,eAAe,EAAA,EAElB;IA10CL;MA60CM,+BAA8B;MAC9B,kEAAkE,EAAA;MAElE;QAh1CN;UAi1CQ,eAAe,EAAA,EAElB;IAn1CL;MAs1CM,qBAAqB;MACrB,kBAAkB;MAClB,qBAAqB;MACrB,+CT12Ce;MS22Cf,oBAAoB;MACpB,gCAAgC;MAChC,iBAAiB,EAAA;IA51CvB;MAi2CM,0CTn5CM;MSo5CN,+BAA8B,EAAA;IAl2CpC;MAs2CM,qBAAqB;MACrB,qBAAqB;MACrB,kBAAkB;MAClB,iBAAiB;MACjB,+BAA+B,EAAA;MA12CrC;QA62CQ,WAAW;QACX,kBAAkB;QAClB,aAAa;QACb,WAAW;QACX,cAAc;QACd,UAAU;QACV,oBAAoB;QACpB,oCTr4Ca,EAAA;ISiBrB;MA03CM,eAAe,EAAA;IA13CrB;MA83CM,mBAAmB;MACnB,gBAAgB;MAChB,YAAY,EAAA;IAh4ClB;MAo4CM,qBAAqB;MACrB,WAAW;MACX,iBAAiB,EAAA;EAt4CvB;IA44CgC,WAAY,EAAA;EA54C5C;IA64CgC,WAAY,EAAA;EA74C5C;IA84CgC,YAAY,EAAA;EA94C5C;IA+4CgC,YAAY,EAAA;EA/4C5C;IAg5CgC,WAAY,EAAA;EAh5C5C;IAu5C8B,WAAY,EAAA;EAv5C1C;IAw5C8B,YAAY,EAAA;EAx5C1C;IAy5C8B,WAAY,EAAA;EAz5C1C;IA05C8B,WAAY,EAAA;EA15C1C;IA25C8B,WAAY,EAAA;EA35C1C;IA45C8B,WAAY,EAAA;EA55C1C;IAg6CM,eAAe,EAAA;EAh6CrB;IAs6CgC,WAAY,EAAA;EAt6C5C;IAu6CgC,WAAY,EAAA;EAv6C5C;IAw6CgC,YAAY,EAAA;EAx6C5C;IAy6CgC,YAAY,EAAA;EAz6C5C;IA66CM,eAAe,EAAA;EA76CrB;IAq7CM,iBAAiB,EAAA;EAr7CvB;IA47CM,YAAY;IACZ,cAAc;IACd,UAAU,EAAA;EA97ChB;IAm8CM,aAAa;IACb,mBAAmB,EAAA;EAp8CzB;IAy8CQ,aAAa,EAAA;EAz8CrB;IA68CQ,qBAAqB;IACrB,gBAAgB;IAChB,4BAA4B,EAAA;EA/8CpC;IAo9CM,aAAa;IACb,mBAAmB;IACnB,iBAAiB,EAAA;ET1qBnB;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,qBAAqB,EAAA;IAErB;MACE,qBAAqB;MACrB,gBAAgB;MAChB,cAAc,EAAA;EAKlB;IACE,gBAAgB,EAAA;ES7zBtB;IA89CkC,WAAY,EAAA;EA99C9C;IA+9CkC,YAAY,EAAA;EA/9C9C;IAg+CkC,YAAY,EAAA;EAh+C9C;IAi+CkC,YAAY,EAAA;EAj+C9C;IAq+CM,YAAY,EAAA;EAr+ClB;IA2+C+B,YAAY,EAAA;EA3+C3C;IA4+C+B,WAAW,EAAA;EA5+C1C;IA6+C+B,YAAY,EAAA;EA7+C3C;IAo/CM,sBAAsB,EAAA;IAp/C5B;MAu/CQ,mBAAmB,EAAA;IAv/C3B;MA2/CQ,cAAc;MACd,YAAY;MACZ,WAAW;MACX,aAAa;MACb,mBAAmB,EAAA;IA//C3B;MAmgDQ,WAAW;MACX,eAAe;MACf,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,gBAAgB;MAChB,sBAAsB;MACtB,kBAAkB,EAAA;EA1gD1B;IAghDwC,YAAY,EAAA;EAhhDpD;IAihDwC,WAAW,EAAA;EAjhDnD;IAkhDwC,YAAY,EAAA;EAlhDpD;IAmhDwC,YAAY,EAAA;EAnhDpD;IAohDwC,YAAY,EAAA;EAphDpD;IAqhDwC,YAAY,EAAA;EArhDpD;IAshDwC,WAAY,EAAA;EAthDpD;IA4hDI,YAAY,EAAA;IA5hDhB;MAgiDwB,YAAY,EAAA;IAhiDpC;MAiiDwB,WAAW,EAAA;IAjiDnC;MAsiDM,WAAW;MACX,YAAY,EAAA;EAviDlB;IA4iDI,YAAY,EAAA;IA5iDhB;MAgjD4B,YAAY,EAAA;IAhjDxC;MAijD4B,YAAa,EAAA;IAjjDzC;MAsjDM,WAAW;MACX,YAAY,EAAA;IArlDhB;MAylDI,iBAAiB,EAAA;EA3jDvB;IAkkDqC,WAAY,EAAA;EAlkDjD;IAmkDqC,WAAW,EAAA;EAnkDhD;IAokDqC,WAAY,EAAA;EApkDjD;IAqkDqC,WAAY,EAAA;EArkDjD;IAskDqC,WAAY,EAAA;EAtkDjD;IAukDqC,WAAY,EAAA;EAvkDjD;IAwkDqC,YAAY,EAAA;EAxkDjD;;IA0kDqC,YAAY,EAAA;EA1kDjD;IA2kDqC,WAAY,EAAA;EA3kDjD;IA4kDgC,YAAY,EAAA;EA5kD5C;IA6kDgC,WAAW,EAAA;EA7kD3C;IA8kDgC,YAAY,EAAA;EA9kD5C;IAklDQ,WAAW;IACX,gBAAgB,EAAA;EAnlDxB;IAulDQ,eAAe;IACf,cAAc;IACd,cAAc,EAAA;EAzlDtB;IAimDM,YAAY;IACZ,gBAAgB,EAAA;EAlmDtB;IAsmDM,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB,EAAA;EAzmDvB;;;IA+mDM,mBAAmB;IACnB,gBAAgB;IAChB,YAAY,EAAA;EAjnDlB;IAsnDM,YAAY;IACZ,WAAW;IACX,eAAe,EAAA;IAxnDrB;MA2nDQ,WAAW;MACX,eAAe;MACf,YAAY,EAAA;EA7nDpB;IAqoDmC,YAAY,EAAA;EAroD/C;IAsoDmC,YAAY,EAAA;EAtoD/C;IAuoDmC,YAAY,EAAA;EAvoD/C;IAwoDmC,WAAY,EAAA;EAxoD/C;IAyoDmC,WAAY,EAAA;EAzoD/C;IAgpDI,kBAAkB,EAAA;IAhpDtB;MAmpDM,6BAA6B,EAAA;MAnpDnC;QAqpDkC,YAAY,EAAA;MArpD9C;QAspDkC,YAAY,EAAA;MAtpD9C;QAupDkC,YAAY;QAAE,gBAAgB,EAAA;MAvpDhE;QAwpDkC,YAAY,EAAA;EAxpD9C;IA8pDI,YAAY,EAAA;IA9pDhB;MAiqDM,YAAY;MACZ,gBAAgB;MAChB,iBAAiB;MACjB,sBAAsB;MACtB,oBAAoB;MACpB,mBAAmB,EAAA;IAtqDzB;MA0qDM,aAAa;MACb,mBAAmB;MACnB,QAAQ;MACR,YAAY,EAAA;IA7qDlB;MAirDM,OAAO;MACP,YAAY;MACZ,uBAAuB;MACvB,iBAAiB;MACjB,sBAAsB;MACtB,kBAAkB,EAAA;IAptDtB;MAwtDI,iBAAiB,EAAA;IA1rDvB;MA+rD2B,WAAW,EAAA;IA/rDtC;MAgsD2B,YAAY,EAAA;EAhsDvC;IAqsDuB,YAAY,EAAA;EArsDnC;IAssDuB,YAAY,EAAA;EAtsDnC;IAusDuB,WAAY,EAAA;EAvsDnC;IAwsDuB,WAAY,EAAA;EAxsDnC;IA2sDI,YAAY,EAAA;IA3sDhB;MAgtDkC,YAAY,EAAA;IAhtD9C;MAitDkC,YAAY,EAAA;IAjtD9C;MAktDkC,WAAY,EAAA;IAltD9C;MAmtDkC,YAAY,EAAA;IAntD9C;MAotDkC,WAAY,EAAA;IAptD9C;MAqtDkC,WAAY,EAAA;IArtD9C;;MA6tDQ,eAAe;MACf,gBAAgB;MAChB,cAAc;MACd,cAAc,EAAA;IAhuDtB;MAquDQ,aAAa;MACb,YAAY;MACZ,kBAAkB;MAClB,kBAAkB;MAClB,oBAAoB;MACpB,gBAAgB;MAChB,kBAAkB,EAAA;MA3uD1B;QA8uDU,yBAAyB;QACzB,cAAc,EAAA;MA/uDxB;QAmvDU,yBAAkC;QAClC,0CAA0C,EAAA;QApvDpD;UAuvDY,yBAAyB,EAAA;MAvvDrC;QA4vDU,YAAY;QACZ,yBAAyB;QACzB,2CAA2C,EAAA;QA9vDrD;UAiwDY,yBAAyB,EAAA;MAjwDrC;QAswDU,sBAAsB;QACtB,WAAW,EAAA;IAvwDrB;;MA8wDM,6BAA6B,EAAA;IA9wDnC;MAkxDM,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,eAAe;MACf,cAAc,EAAA;EAtxDpB;IA8xDgC,YAAY,EAAA;EA9xD5C;IA+xDgC,YAAY,EAAA;EA/xD5C;IAgyDgC,WAAY,EAAA;EAhyD5C;IAiyDgC,WAAY,EAAA;EAjyD5C;IAkyDgC,WAAY,EAAA;EAlyD5C;IAmyDgC,WAAY,EAAA;EAnyD5C;IAoyDgC,WAAY,EAAA;EApyD5C;IAqyDgC,WAAY,EAAA;EAryD5C;;IA0yDQ,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,cAAc,EAAA;EA7yDtB;IAmzDI,UAAU,EAAA;IAnzDd;MAuzDkC,YAAY,EAAA;IAvzD9C;MAwzDkC,WAAY,EAAA;IAxzD9C;MAyzDkC,WAAY,EAAA;IAzzD9C;MA0zDkC,YAAY,EAAA;EA1zD9C;IAg0D8B,YAAY,EAAA;EAh0D1C;IAi0D8B,WAAY,EAAA;EAj0D1C;IAk0D8B,YAAY,EAAA;EAl0D1C;IAm0D8B,YAAY,EAAA;EAn0D1C;IAs0DM,iBAAiB;IACjB,iBAAiB,EAAA;IAv0DvB;MA00DQ,yBAAyB;MACzB,iBAAiB;MACjB,YAAY;MACZ,6BAA6B;MAC7B,8DAAmE;MACnE,eAAe,EAAA;MA/0DvB;QAk1DU,gFAA4G;QAC5G,cT94De,EAAA;MS2DzB;QAu1DU,kBAAkB,EAAA;IAv1D5B;MA61DU,mBTp5DI;MSq5DJ,cTz5De,EAAA;ES2DzB;IAq2D8B,YAAY,EAAA;EAr2D1C;IAs2D8B,WAAY,EAAA;EAt2D1C;IAu2D8B,YAAY,EAAA;EAv2D1C;IAw2D8B,YAAY,EAAA;EAx2D1C;IA22DM,iBAAiB;IACjB,iBAAiB,EAAA;IA52DvB;MA+2DQ,yBAAyB;MACzB,iBAAiB;MACjB,YAAY;MACZ,6BAA6B;MAC7B,8DAAmE;MACnE,eAAe,EAAA;MAp3DvB;QAu3DU,gFAA4G;QAC5G,cTn7De,EAAA;MS2DzB;QA43DU,kBAAkB,EAAA;IA53D5B;MAk4DU,mBTz7DI;MS07DJ,cT97De,EAAA;ES2DzB;IA04D4B,YAAY,EAAA;EA14DxC;IA24D4B,YAAY,EAAA;EA34DxC;IA84DM,iBAAiB,EAAA;EA94DvB;IAm5D4B,YAAY,EAAA;EAn5DxC;IAo5D4B,YAAY,EAAA;EAp5DxC;IAu5DM,iBAAiB,EAAA;;AAOrB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBT59DgB;ES69DhB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,kBAAkB,EAAA;EARpB;IAWM,yBT78Da;IS88Db,qBT38DY,EAAA;IS+7DlB;MAeM,WAAW;MACX,kBAAkB;MAClB,QAAQ;MACR,SAAS;MACT,UAAU;MACV,WAAW;MACX,qBT9+DiB;MS++DjB,yBAAyB;MACzB,wBAAwB,EAAA;;AAKhC;EACE,kBAAkB;EAClB,iBAAiB,EAAA;;AAInB;EACE,iBAAiB,EAAA;;AAInB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB,EAAA;EAHrB;IAMI,kBAAkB;IAClB,qBAAqB,EAAA;EAPzB;IAWI,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,sBAAsB,EAAA;;AAI1B;EACE,eAAe;EACf,aAAa;EACb,mBT/gEsB;ESghEtB,cTthEuB;ESuhEvB,yBTvhEuB;ESwhEvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,UAAU,EAAA;;AAGZ;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,sBAAsB,EAAA;;AAGxB;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB,EAAA;;AAGpB;EACE,yBAAyB;EACzB,2CAA2C,EAAA;;AAG7C;EACE,yBAAyB,EAAA;;AAG3B;EACE,yBAAyB,EAAA;;AAG3B;EACE,yBAAyB;EACzB,4CAA4C,EAAA;;AAG9C;EACE,yBAAyB,EAAA;;AAG3B;EACE,uBAAuB,EAAA;;AAEzB;EACE,uBAAuB,EAAA;;AAEzB;EACE,uBAAuB,EAAA;;AAGzB;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB,EAAA;EATxB;IAYI,cTliEsB;ISmiEtB,uNAgBG;IACH,qBAAyC;IACzC,+HTtjEiB;IS0jEjB,8CTnnEgB,EAAA;ISglEpB;MAsCM,qBAA6C;MAC7C,6HT9jEe,EAAA;ESuhErB;IA+CI,cT5kEoB;IS6kEpB,uNAgBG;IACH,qBAAsC;IACtC,8HT7oEiB;ISipEjB,6CTtpEgB,EAAA;ISglEpB;MAyEM,qBTzpEc;MS0pEd,gITrpEe,EAAA;ES2kErB;IAkFI,cT9pEuB;IS+pEvB,0EAKC;IACD,qBTpqEiB;ISqqEjB,mFT1qEgB;IS6qEhB,iBAAiB;IACjB,kBAAkB,EAAA;IA9FtB;MAiGM,qBAAuC;MACvC,mFTlrEc,EAAA;;ASyrEpB;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B,EAAA;;AAI7B;EACE,yDAAmD;EACnD,UAAU,EAAA;EAFZ;IAKI,iGACoD;IACpD,yDAAyD,EAAA;EAP7D;IAWI,YAAY;IACZ,uBAAuB,EAAA;IAZ3B;MAeM,oEAAoE;MACpE,eAAe,EAAA;;AAKrB;EACE,0DAAkD;EAClD,YAAY,EAAA;;AAGd,0BAAA;AACA;EACE;IACE,kGACqD,EAAA;EAEvD;IACE,gGACoD,EAAA,EAAA;;AAIxD,gCAAA;AACA;EACE;IACE,gGACoD,EAAA;EAEtD;IACE,kFACoD,EAAA,EAAA;;AAKxD;;;;;;EAOI,kBAAkB;EAClB,sBAAsB,EAAA;;AAR1B;;EAaI,gBAAgB;EAChB,mBAAmB,EAAA;;AAdvB;;EAmBI,kBAAkB;EAClB,sBAAsB,EAAA;;AApB1B;EAwBI,eAAe,EAAA;;AAxBnB;EA4BI,gBAAgB,EAAA;;AA5BpB;;EAiCI,eAAe,EAAA;;AAjCnB;EAqCI,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB,EAAA;;AA1CrB;EA8CI,mBAAmB,EAAA;;AA9CvB;;EAoDM,YAAY,EAAA;;AApDlB;;EAwDM,WT75CoC,EAAA;;ASq2C1C;;EA4DM,YT/5CmC;ESg6CnC,WTh6CmC,EAAA;;ASm2CzC;;EAiEM,2BAA4D,EAAA;;AAjElE;EAsEI,cTtzEU,EAAA;;ASgvEd;EA0EI,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY,EAAA;;AA/EhB;EAmFI,eAAe;EACf,gBAAgB,EAAA;;AApFpB;EAwFI,eAAe;EACf,gBAAgB,EAAA;;AAzFpB;EA6FI,eAAe;EACf,gBAAgB,EAAA;;AA9FpB;EAkGI,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,eAAe,EAAA;;AA9GnB;EAkHI,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,WTh+CgC;ESi+ChC,WTh+CgC;ESi+ChC,SAAS;EACT,eAAe,EAAA;;AA1HnB;EA8HI,YTr+C+B;ESs+C/B,WTt+C+B;ESu+C/B,SAAS,EAAA;;AAhIb;EAoII,2BAAsD,EAAA;;AApI1D;EAwII,YAAY;EACZ,YAAY,EAAA;;ATz5EhB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AUr8BA;EACI,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gCV0BU,EAAA;EU/Bd;IAQQ,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,WAAU;IACV,YAAY;IACZ,aAAa,EAAA;IAbrB;MAgBY,kBAAkB;MAClB,WAAW;MACX,yBAAyB;MACzB,0BAA0B;MAC1B,kBAAkB,EAAA;IApB9B;MAwBY,kBAAkB;MAClB,YAAY;MACZ,YAAY;MACZ,uBAAuB;MACvB,QAAS,EAAA;IA5BrB;MAgCY,WAAW;MACX,kBAAkB;MAClB,SAAS;MACT,QAAQ;MACR,yBAAyB;MACzB,UAAU;MACV,yBVPE,EAAA;EU/Bd;IA4CY,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB,EAAA;IVotB3B;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;;AU1tBjE;EACI,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,wDAAwD;EACxD,eAAe,EAAA;EARnB;IAWQ,cAAc;IACd,wBAAwB;IACxB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB,EAAA;IAhBxB;MAmBY,aAAa,EAAA;IAnBzB;MAuBY,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,WAAW;MACX,sBAAsB,EAAA;IA3BlC;MA+BY,aAAa;MACb,uBAAuB;MACvB,qBAAqB;MACrB,WAAW;MACX,sBAAsB,EAAA;IAnClC;MAuCY,cAAc;MACd,iBAAiB;MACjB,cAAc,EAAA;IAzC1B;MA6CY,2BAA2B;MAC3B,kBAAkB,EAAA;IA9C9B;MAkDY,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,SAAS;MACT,WAAW;MACX,gBAAgB;MAChB,cAAc,EAAA;IAxD1B;MA4DY,OAAO;MACP,WAAW;MACX,yBAAyB;MACzB,eAAe;MACf,gBAAgB;MAChB,aAAa,EAAA;IAjEzB;MAqEY,SAAS;MACT,kBAAkB;MAClB,kBAAkB;MAClB,yBAAyB;MACzB,oBAAoB;MACpB,oCAAoC;MACpC,gBAAgB;MAChB,sBAAsB;MACtB,cAAc;MACd,gBAAgB,EAAA;IA9E5B;MAkFY,4BAA4B;MAC5B,gBAAgB;MAChB,iBAAiB;MACjB,kBAAkB;MAClB,yCAAyC;MACzC,kBAAkB;MAClB,cAAc,EAAA;IAxF1B;MA4FY,cAAc;MACd,WAAW;MACX,YAAY;MACZ,SAAS,EAAA;EA/FrB;IAoGQ,iBAAiB;IACjB,mBAAmB,EAAA;IArG3B;MAwGY,WAAW;MACX,YAAY;MACZ,gBAAgB;MAChB,mBAAmB,EAAA;IA3G/B;MA+GY,WAAW;MACX,YAAY,EAAA;MAhHxB;QAmHgB,WAAW;QACX,YAAY;QACZ,mBAAmB,EAAA;IArHnC;MA0HY,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,WAAW;MACX,wBAAwB,EAAA;MA9HpC;QAiIgB,mBAAmB;QACnB,yBAAyB,EAAA;EAlIzC;IAwIQ,iBAAiB;IACjB,mBAAmB,EAAA;IAzI3B;MA4IY,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,WAAW;MACX,wBAAwB,EAAA;MAhJpC;QAmJgB,mBAAmB;QACnB,yBAAyB,EAAA;EApJzC;IA0JQ,oCAA6C;IAC7C,wDAAwD,EAAA;;AAIhE,+EAAA;AACA;EACI,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB,EAAA;EAHrB;IAOY,WAAW;IACX,gBAAgB,EAAA;EAR5B;IAYY,WAAW;IACX,YAAY,EAAA;IAbxB;MAgBgB,WAAW;MACX,gBAAgB,EAAA;;AAMhC,8DAAA;AACA;EAGY,WAAW;EACX,YAAY;EACZ,gBAAgB,EAAA;;AAL5B;EASY,WAAW;EACX,YAAY,EAAA;EAVxB;IAagB,WAAW;IACX,YAAY;IACZ,gBAAgB,EAAA;;AAMhC;EACI,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAA;EAH3B;IAOY,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAA;IATnC;MAYgB,gBAAgB,EAAA;;AAMhC;EACI,cAAc;EACd,6BAA6B,EAAA;;AAGjC;EACI,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;;AAEf;EACI,kBAAkB;EAElB,gBAAgB;EAAE,oDAAA,EAAqD;;AAGzE;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EAET,iCAAiC,EAAA;;AAInC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAAE,+BAAA;EAElB,mBAAmB;EACnB,UAAU;EAAE,sBAAA;EACZ,eAAe,EAAA;;AAGjB;EACE,UAAU;EAAE,sBAAA;EACZ,UAAU;EACV,mCAAmC;EAAE,gCAAA,EAAiC;;AAGxE;EACE;IACE,2BAA2B,EAAA;EAE7B;IACE,6BAA6B,EAAA;EAE/B;IACE,6BAA6B,EAAA;EAE/B;IACE,6BAA6B,EAAA;EAE/B;IACE,6BAA6B,EAAA;EAE/B;IACE,2BAA2B,EAAA;EAE7B;IACE,6BAA6B,EAAA;EAE/B;IACE,6BAA6B,EAAA;EAE/B;IACE,6BAA6B,EAAA;EAE/B;IACE,6BAA6B,EAAA,EAAA;;AAInC;EACI,aAAc;EAEd,kBAAkB,EAAA;;AAOtB;EACI,WAAW;EACX,WAAW,EAAA;;AAGf;EACI,kBAAkB;EAClB,WAAW;EACX,YAAY,EAAA;;AAMhB;EAEI;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,gCV3WM,EAAA;IUqWV;MASQ,aAAa;MACb,mBAAmB;MACnB,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,mBAAmB,EAAA;MAd3B;QAiBY,kBAAkB;QAClB,WAAU;QACV,WAAW;QACX,YAAY;QACZ,uBAAuB,EAAA;MArBnC;QAyBY,kBAAkB;QAClB,WAAW;QACX,yBAAyB;QACzB,yBAAyB;QACzB,gBAAgB,EAAA;IA7B5B;MAmCY,gBAAgB;MAChB,iBAAiB;MACjB,yBAAyB;MACzB,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB,EAAA;MV0V/B;QACI,UAjKa,EAAA;MAoKjB;QACI,mBApKuB;QAqKvB,kBAAkB;QAClB,kBAAkB,EAAA;MAGtB;QACI,yBA3uBU;QA4uBV,kBAAkB,EAAA;QAElB;UACI,yBAAqD,EAAA;EUnW7D;IACI,UAAU,EAAA;EAzJlB;IA6JQ,UAAU;IACV,mCAAmC,EAAA;IAFvC;MAKQ,eAAe,EAAA;MALvB;QAOY,6BAA6B;QAC7B,mBAAmB;QACnB,+BAA+B,EAAA;QAT3C;UAYgB,sBAAsB;UACtB,uBAAuB;UACvB,mBAAmB,EAAA;QAdnC;;UAmBgB,sBAAsB;UACtB,uBAAuB;UACvB,2BAA2B,EAAA;QArB3C;UAyBgB,sBAAsB;UACtB,uBAAuB,EAAA;QA1BvC;UA8BgB,gBAAgB;UAChB,iBAAiB,EAAA;QA/BjC;;UAoCgB,sBAAsB;UACtB,uBAAuB;UACvB,2BAA2B,EAAA;QAtC3C;UA0CgB,sBAAsB;UACtB,uBAAuB,EAAA;QA3CvC;UA+CgB,+BAA+B;UAC/B,gBAAgB;UAChB,kBAAkB;UAClB,gCAAgC;UAChC,UAAU,EAAA;UAnD1B;YAsDoB,gBAAgB,EAAA;MAtDpC;QA4DY,mBAAmB;QACnB,+BAA+B,EAAA;QA7D3C;UAgEgB,+BAA+B;UAC/B,gBAAgB;UAChB,gCAAgC;UAChC,UAAU,EAAA;UAnE1B;YAsEoB,gBAAgB,EAAA;IAtEpC;MA6EQ,aAAa;MACb,mBAAmB;MACnB,mCAAmC,EAAA;MA/E3C;QAkFY,mBAAmB;QACnB,+BAA+B;QAC/B,YAAY,EAAA;QApFxB;UAuFgB,kBAAkB;UAClB,gBAAgB;UAChB,+BAA+B;UAC/B,+BAA+B;UAC/B,UAAU,EAAA;UA3F1B;YA8FoB,kBAAkB;YAClB,gBAAgB;YAChB,YAAY,EAAA;MAhGhC;QAuGY,gBAAgB;QAChB,wBAAwB;QACxB,+BAA+B;QAC/B,mBAAmB;QACnB,kBAAkB,EAAA;QA3G9B;UA8GgB,qBAAqB;UACrB,sBAAsB;UACtB,gBAAgB;UAChB,YAAY,EAAA;UAjH5B;YAoHoB,kBAAkB;YAClB,qBAAqB;YACrB,sBAAsB;YACtB,kBAAkB;YAClB,gBAAgB;YAChB,YAAY,EAAA;QAzHhC;UA8HgB,kBAAkB;UAClB,gBAAgB;UAChB,+BAA+B;UAC/B,YAAY;UACZ,+BAA+B;UAC/B,UAAU,EAAA;UAnI1B;YAsIoB,kBAAkB;YAClB,gBAAgB;YAChB,YAAY,EAAA;QAxIhC;UA+IgB,YAAS;UACT,kBAAkB;UAClB,QAAQ;UACR,SAAS;UACT,gCAAgC;UAChC,yCAAyC,EAAA;EAG7C;IACI;MACI,gCAAgC,EAAA;IAEpC;MACI,4CAA4C,EAAA,EAAA;MA5JhE;QAkKY,kBAAkB;QAClB,gBAAgB,EAAA;QAnK5B;UAsKgB,kBAAkB;UAClB,gBAAgB;UAChB,YAAY,EAAA;QAxK5B;UA4KgB,kBAAkB;UAClB,gBAAgB,EAAA;EAxiBpC;IA+iBQ,WAAW;IACX,YAAY,EAAA;EAhZpB;IAoZQ,WAAW;IACX,YAAY,EAAA;EA7XpB;IAiYQ,WAAW;IACX,YAAY,EAAA;EAGhB;IACI,0BAA0B,EAAA,EAC7B;;AV3nBL;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AWv8BA,8EAAA;AACA;EACI,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBXyBiB,EAAA;;AWtBrB;EACI,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,YAAY;EACZ,mBXcU;EWbV,cXSqB;EWRrB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,0EAA0E,EAAA;EAd9E;IAiBQ,+BXKa,EAAA;EWtBrB;IAqBQ,mBXCa,EAAA;EWtBrB;IA0BQ,YAAY;IACZ,mBAAmB,EAAA;EA3B3B;IAgCY,YAAY,EAAA;;AAFnB;EAQD,mBXde;EWef,mCXXQ,EAAA;EWSZ;IAKQ,cXvBiB;IWwBjB,UAAU,EAAA;;AAIlB;EACI,0BAA0B,EAAA;;AAG9B;EACI,gBAAgB,EAAA;;AAGpB;EACI,0BAA0B,EAAA;;AAG9B;EACI,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB,EAAA;;AAGvB;EACI,eAAe;EAEf,aAAa;EACb,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oCAAiC;EXywBjC,gBAAgB;EAEhB,yBAAA;EAMA,YAAA;EACA,qBAAqB;EAErB,kBAAA;EACA,wBAAwB,EAAA;EATxB;IACI,QAAQ;IACR,SAAS,EAAA;EWvxBjB;IAaQ,kBAAkB;IAElB,yBXlBW;IWmBX,cAAc;IACd,YAAY;IACZ,yBXtDU;IWuDV,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB,EAAA;IAtB3B;MAyBY,aAAa,EAAA;IAzBzB;MA6BY,YAAY,EAAA;IA7BxB;MAiCY,YAAY,EAAA;IAjCxB;MAqCY,YAAY,EAAA;IArCxB;MA0CY,YAAY;MACZ,YAAY,EAAA;IA3CxB;MAiDgB,YAAY,EAAA;MAjD5B;QAqDwB,cXpGC;QWqGD,aAAa;QACb,aAAa;QACb,yBX5FN;QW6FM,gCXxGC;QWyGD,kBAAkB;QAClB,8BAA8B,EAAA;MA3DtD;QAiEwB,aAAa,EAAA;MAjErC;QAuEwB,aAAa;QACb,aAAa;QACb,mBAAmB;QACnB,8BAA8B,EAAA;EA1EtD;IAkFQ,cXjIiB;IWkIjB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,eAAe,EAAA;IAtFvB;MA0FY,cXnIY;MWoIZ,qBAAqB,EAAA;;AAOjC;EACI,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,oCAAoC,EAAA;EAXxC;IAcQ,cX/JiB;IWgKjB,aAAa;IACb,aAAa;IAEb,gCXnKiB;IWoKjB,kBAAkB;IAClB,8BAA8B,EAAA;IApBtC;MAuBY,UAAU;MACV,SAAS,EAAA;EAxBrB;IA6BQ,aAAa;IAEb,uBAAuB;IACvB,mBAAmB;IAEnB,WAAW;IACX,2BAA2B,EAAA;EAnCnC;IAuCQ,gBAAgB;IAChB,YAAY,EAAA;EAxCpB;IA4CQ,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,yBX5LM;IW6LN,gBAAgB;IAChB,yBXvLU;IWwLV,mBAAmB,EAAA;EAlD3B;IAwDQ,yBXrMM;IWsMN,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ,EAAA;IA7DhB;MAgEY,aAAa;MACb,8BAA8B;MAC9B,mBAAmB;MACnB,WAAW;MACX,kBAAkB,EAAA;MApE9B;QAuEgB,gBAAgB;QAChB,YAAY,EAAA;MAxE5B;QA4EgB,2BAA2B;QAC3B,2BAA2B;QAC3B,2BAA2B;QAC3B,uBAAuB,EAAA;MA/EvC;QAmFgB,eAAe;QACf,eAAe;QACf,wBAAwB;QACxB,kBAAkB,EAAA;QAtFlC;UAyFoB,eAAe;UACf,eAAe;UACf,wBAAwB;UACxB,kBAAkB,EAAA;IA5FtC;MAmGY,gBAAgB;MAChB,kBAAkB,EAAA;EApG9B;IAyGQ,aAAa;IACb,SAAS;IACT,aAAa,EAAA;IA3GrB;MA8GY,gBAAgB,EAAA;;AAS5B;EAEQ,YAAY;EACZ,aAAa,EAAA;;AAHrB;EAQY,YAAY;EACZ,YAAY,EAAA;;AATxB;EAeQ,aAAa;EACb,2BAA2B,EAAA;;AAhBnC;EAoBQ,yBXxRM;EWyRN,aAAa;EACb,WAAW;EACX,iBAAiB;EAEjB,yBXtRU,EAAA;;AW6PlB;EA8BQ,cXtSiB,EAAA;EWwQzB;IAiCY,iBAAiB;IACjB,cX1Sa,EAAA;EWwQzB;IAsCY,cX9Sa,EAAA;IWwQzB;MA0CY,cX5SY,EAAA;;AWkQxB;EAgDQ,aAAa,EAAA;EAhDrB;IAmDY,kBAAkB;IAElB,iBAAiB;IACjB,6BAA6B;IAC7B,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,cX5TY,EAAA;;AWoUxB;EACI,yBXtUe,EAAA;EWqUnB;IAIQ,mBAAmB;IACnB,cX/UiB,EAAA;EW0UzB;IASQ,cXlVY,EAAA;IWyUpB;MAYQ,iBAAiB;MACjB,cX/UY;MWgVZ,qBAAqB,EAAA;EAd7B;IAmBQ,kBAAkB;IAClB,cAAc,EAAA;IApBtB;MAuBQ,qBAAqB;MACrB,aAAa,EAAA;;AAKrB;EACI,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBXrWoB;EWsWpB,cX5WqB;EW6WrB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,mBAAoB,EAAA;EAZxB;IAeQ,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,cXzXiB;IW0XjB,iBAAiB,EAAA;EAnBzB;IAuBQ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,SAAS;IACT,YAAY,EAAA;EA5BpB;IAiCQ,aAAa;IACb,mBAAmB,EAAA;IAlC3B;MAqCY,aAAa;MACb,sBAAsB;MACtB,yBX7YQ;MW8YR,mBAAmB;MACnB,YAAY;MACZ,iBAAiB;MACjB,kBAAkB;MAClB,+BAAgC,EAAA;MA5C5C;QA+CgB,YAAY;QACZ,WAAW,EAAA;IAhD3B;MAqDY,OAAO;MACP,yBXzZE;MW0ZF,YAAY;MACZ,iBAAiB;MAEjB,+BAAgC,EAAA;MA1D5C;QA6DgB,cXpaS;QWqaT,2BAA2B,EAAA;QA9D3C;UAiEoB,mBAAmB,EAAA;MAjEvC;QAsEgB,aAAa,EAAA;;AAO7B;EACI,sBAAsB;EACtB,8BAA8B;EAC9B,mBXvbqB;EWwbrB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,aAAa,EAAA;;AAIjB;EACI,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,uCAAuC;EACvC,mBAAmB;EACnB,uBAAuB;EACvB,YAAY,EAAA;;AAGhB;EACI,aAAa;EACb,yBX7cU;EW8cV,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,gCAAiC,EAAA;;AAGrC;EACI,OAAO;EACP,yBXtde;EWudf,UAAU;EACV,kBAAkB;EAClB,gCAAiC,EAAA;EALrC;IAQQ,cXjeiB;IWkejB,aAAa,EAAA;EATrB;IAaQ,aAAa,EAAA;;AAIrB;EACI,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,yBX1eU;EW2eV,UAAU;EACV,kBAAkB;EAClB,gBAAgB,EAAA;EX0PhB;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;EWhRjE;IAWQ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gCXvfY;IAmlBlB,mHAAiF;IACjF,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B,EAAA;IW7G7B;MAkBY,gBAAgB;MAChB,yBAAyB;MACzB,iBAAiB;MACjB,eAAe;MACf,kBAAkB;MAClB,cXjgBa,EAAA;IW0ezB;MA2BY,aAAa;MACb,YAAY;MACZ,gBAAgB;MAChB,iBAAiB;MACjB,kBAAkB,EAAA;MA/B9B;QAkCgB,kBAAkB;QAClB,YAAY;QACZ,mBAAmB;QACnB,gBAAgB;QAChB,eAAe,EAAA;QAtC/B;UAyCoB,UAAU,EAAA;EAzC9B;IAgDQ,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB,EAAA;;AAI3B;EACI,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yBXzfe;EW0ff,UAAU;EACV,yBX5hBc;EW6hBd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB,EAAA;EXiMhB;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;EWzNjE;IXyFE,aAAa;IACb,8BAA8B;IAC9B,cA5nBuB;IA6nBvB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gCA7nBY;IA8nBZ,8BAA8B;IAC9B,mHAAiF,EAAA;IWlGnF;MAgBY,gBAAgB;MAChB,yBAAyB;MACzB,iBAAiB;MACjB,eAAe;MACf,kBAAkB;MAClB,cXtjBa,EAAA;EWiiBzB;IA0BQ,aAAa;IACb,yBXtjBgB;IWujBhB,SAAS;IACT,4BAA4B;IAC5B,yBX9jBY;IW+jBZ,kBAAkB;IAClB,qBAAqB,EAAA;IAhC7B;MAmCY,aAAa;MACb,mBAAmB;MACnB,eAAe;MACf,qBAAqB,EAAA;MAtCjC;QAyCgB,qCAAqC,EAAA;MAzCrD;QA6CgB,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,cXjlBS,EAAA;IWiiBzB;MAqDY,kBAAkB,EAAA;IArD9B;MAyDY,aAAa;MACb,iBAAiB;MACjB,QAAQ;MACR,iBAAiB;MACjB,kBAAkB,EAAA;EA7D9B;IAqEQ,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,YAAY,EAAA;IA3EpB;MA8EY,kBAAkB;MAClB,aAAa,EAAA;EA/EzB;IAoFQ,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAsB,EAAA;EAvF9B;IA4FQ,wBAAwB,EAAA;EA5FhC;IAiGQ,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,UAAU;IACV,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,YAvCoC;IAwCpC,gBAxCoC;IAyCpC,kBAAkB;IAClB,gBAAgB,EAAA;IX8FpB;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;IWzNjE;MAgHY,WAAW;MACX,eAAe;MACf,YAAY;MACZ,sBAAsB;MACtB,mBAAmB,EAAA;MApH/B;QAuHgB,gBAAgB,EAAA;IAvHhC;;MA6HY,WAAW;MACX,SAAS;MACT,eAAe;MACf,sBAAsB,EAAA;IAhIlC;MAsIgB,WAAW;MACX,eAAe;MACf,YAAY;MACZ,sBAAsB,EAAA;MAzItC;QA6IoB,uBAAO;QACP,iBAAiB;QACjB,kBAAkB,EAAA;QA/ItC;UAkJwB,WAAW;UACX,gBAAgB,EAAA;MAnJxC;QAwJoB,uBAAO;QACP,eAAe;QACf,YAAY,EAAA;IA1JhC;MAiKgB,WAAW;MACX,eAAe;MACf,YAAY;MACZ,sBAAsB;MACtB,gDAAgD,EAAA;MArKhE;QAwKoB,WAAW;QACX,YAAY,EAAA;QAzKhC;UA6KwB,WAAW,EAAA;EA7KnC;IAqLQ,aAAa;IACb,sBAAsB;IACtB,SAAS,EAAA;IAvLjB;MA0LY,cAAc,EAAA;IA1L1B;MA+LY,cAAc;MACd,iBAAiB;MACjB,aAAa;MACb,sBAAsB;MACtB,2BAA2B;MAC3B,gCAAgC,EAAA;MApM5C;QAuMgB,cAAc;QACd,mBAAmB;QACnB,sBAAsB;QACtB,oBAAoB;QACpB,gBAAgB,EAAA;EA3MhC;IAiNQ,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB,EAAA;;AAI3B;EACI,oCAAoC,EAAA;EADxC;IAKQ,YAAY,EAAA;IALpB;MAQY,gCXhwBQ;MWiwBR,8BAA8B;MX9KxC,mHAAiF;MACjF,sBAAsB;MACtB,4BAA4B;MAC5B,2BAA2B,EAAA;MWkK7B;QAagB,gBAAgB;QAChB,yBAAyB;QACzB,SAAS;QACT,iBAAiB;QACjB,cX1wBS,EAAA;IWyvBzB;MAsBY,aAAa;MACb,mBAAmB;MACnB,WAAW;MACX,aAAa,EAAA;MAzBzB;QA4BgB,aAAa;QACb,sBAAsB;QACtB,YAAY;QACZ,yBXnxBG;QWoxBH,UAAU,EAAA;QAhC1B;UAmCoB,uBAAuB;UACvB,cX7xBK;UW8xBL,aAAa;UACb,yBXzxBI;UW0xBJ,UAAU,EAAA;UAvC9B;YA0CwB,qBAAqB;YACrB,kBAAkB,EAAA;UA3C1C;YA+CwB,wBAAwB;YACxB,kBAAkB,EAAA;UAhD1C;YAoDwB,gBAAgB;YAChB,mBAAmB,EAAA;UArD3C;YAyDwB,YAAY;YACZ,qBAAqB,EAAA;YA1D7C;cA4D4B,cX7yBR,EAAA;;AWyzBpB;EACI,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBX/zBoB;EWg0BpB,cXt0BqB;EWu0BrB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,mBAAoB,EAAA;EAZxB;IAeQ,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,cXn1BiB;IWo1BjB,iBAAiB,EAAA;EAnBzB;IAuBQ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,SAAS;IACT,YAAY,EAAA;EA5BpB;IAgCQ,aAAa;IACb,mBAAmB,EAAA;IAjC3B;MAoCY,aAAa;MACb,sBAAsB;MACtB,yBXt2BQ;MWu2BR,mBAAmB;MACnB,YAAY;MACZ,iBAAiB;MACjB,kBAAkB;MAClB,+BAAgC,EAAA;MA3C5C;QA8CgB,YAAY;QACZ,WAAW,EAAA;IA/C3B;MAoDY,OAAO;MACP,yBXl3BE;MWm3BF,YAAY;MACZ,iBAAiB;MAEjB,+BAAgC,EAAA;MAzD5C;QA4DgB,cX73BS;QW83BT,2BAA2B,EAAA;QA7D3C;UAgEoB,mBAAmB,EAAA;MAhEvC;QAqEgB,aAAa,EAAA;;AAO7B;EACI,mBXz4Be;EW04Bf,cX/4BqB;EWg5BrB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,QAAQ;EACR,UAAU;EACV,wCAAwC,EAAA;;AXn7B5C;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AYp8BA;;;EAGE,yBZuBuB;EYtBvB,yBZiCgB;EYhChB,0BAA0B;EAC1B,gBAAgB;EAChB,4BAA4B,EAAA;;AAI9B;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB,EAAA;;AAGzB;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B,EAAA;;AAG7B;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B,EAAA;;AAG7B;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB,EAAA;;AAIzB;;;EAGE,2BAA2B,EAAA;;AAI7B;;;EAGE,cZhBsB;EYiBtB,eAAe;EACf,yBAAyB,EAAA;;AAI3B;;;EAGE,yBAAyB,EAAA;;AAI3B;;;EAGE,yBZtCuB;EYuCvB,cZjCsB;EYkCtB,4BAA4B,EAAA;EAL9B;;;;;;;IAUI,yBZ5CgB;IY6ChB,cZxCoB,EAAA;EY6BxB;;;IAeI,yBZjDgB;IYkDhB,cZ9Ce,EAAA;;AYmDnB;;;;;;EAME,cZxDsB;EYyDtB,0BAA0B,EAAA;;AZ3F5B;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;Aap8BA;EAEI,+BAA+B,EAAA;EAFnC;IAKM,kBAAkB;IAClB,cAAc,EAAA;IANpB;MASQ,cAAc;MACd,YAAY;MACZ,YAAY;MACZ,gBAAgB;MAChB,cbmBgB;MalBhB,kBAAkB;MAClB,uBAAuB;MACvB,kBAAkB;MAElB,eAAe,EAAA;MbmvBnB;QACI,UAjKa,EAAA;MAoKjB;QACI,mBApKuB;QAqKvB,kBAAkB;QAClB,kBAAkB,EAAA;MAGtB;QACI,yBA3uBU;QA4uBV,kBAAkB,EAAA;QAElB;UACI,yBAAqD,EAAA;MapxBjE;QAsBY,YAAS;QACT,kBAAkB;QAClB,QAAQ;QACR,aAAa;QACb,2BAA2B;QAC3B,oBAAoB,EAAA;IA3BhC;MAgCQ,kBAAkB;MAClB,SAAS;MACT,OAAO;MACP,eAAe;MACf,sBAAsB;MACtB,iBAAiB;MACjB,gBAAgB;MAChB,YAAY;MACZ,uBAAuB;MACvB,yBbJU;MaKV,kBAAkB;MAClB,yCAAyC;MACzC,cAAc,EAAA;MbytBlB;QACI,UAjKa,EAAA;MAoKjB;QACI,mBApKuB;QAqKvB,kBAAkB;QAClB,kBAAkB,EAAA;MAGtB;QACI,yBA3uBU;QA4uBV,kBAAkB,EAAA;QAElB;UACI,yBAAqD,EAAA;MapxBjE;QAgDY,cbhBY;QaiBZ,oBAAoB;QACpB,kBAAkB,EAAA;QbmtB1B;UACI,UAjKa,EAAA;QAoKjB;UACI,mBApKuB;UAqKvB,kBAAkB;UAClB,kBAAkB,EAAA;QAGtB;UACI,yBA3uBU;UA4uBV,kBAAkB,EAAA;UAElB;YACI,yBAAqD,EAAA;QapxBjE;UAsDgB,kBAAkB,EAAA;IAtDlC;MA4DQ,aAAa;MACb,sBAAsB;MACtB,gBAAgB;MAChB,YAAY;MACZ,SAAS;MACT,UAAU;MACV,QAAQ,EAAA;MAlEhB;QAsEU,YAAY,EAAA;QAtEtB;UAyEY,oBAAoB;UACpB,mBAAmB;UACnB,6BAA6B;UAC7B,eAAe;UACf,gBAAgB;UAChB,yBbpDa;UaqDb,cb/CY;UagDZ,kBAAkB,EAAA;UAhF9B;YAmFc,gBAAgB;YAChB,YAAY;YACZ,iBAAiB;YACjB,qBAAqB;YACrB,cblDI;YamDJ,eAAe,EAAA;MAxF7B;QA8FY,aAAa,EAAA;IA9FzB;MAmGQ,kBAAkB;MAClB,SAAS;MACT,OAAO;MACP,WAAW;MACX,iBAAiB;MACjB,cAAc;MACd,yBbpEU;MaqEV,uBAAuB;MACvB,kBAAkB;MAClB,aAAa;MACb,mBAAmB,EAAA;MA7G3B;QAgHU,gBAAgB;QAChB,SAAS;QACT,UAAU,EAAA;QAlHpB;UAqHY,eAAe;UACf,aAAa;UACb,mBAAmB;UACnB,eAAe,EAAA;UAxH3B;YA2Hc,yBb7FA,EAAA;Ua9Bd;YA+Hc,oBAAoB,EAAA;UA/HlC;YAmIc,OAAO,EAAA;;AAnIrB;EA8IM,0BAA0B,EAAA;;AA9IhC;EAoJQ,6BAA0C,EAAA;;AApJlD;EAoJQ,6BAA0C,EAAA;;AApJlD;EAoJQ,6BAA0C,EAAA;;AApJlD;EAoJQ,6BAA0C,EAAA;;AApJlD;EAoJQ,8BAA0C,EAAA;;AAOlD;EACE,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,sBAAsB;EACtB,gBAAgB;EAChB,cbjJuB;EakJvB,0CbxGmB;EayGnB,kBAAkB;EAClB,iCbrGiB;EasGjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iKAE4E;EAC5E,yFAEmC;EACnC,iCAAiC;EACjC,4BAA4B,EAAA;EA3B9B;IA8BI,mBAAmB;IACnB,aAAa,EAAA;EAGf;IACE,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,OAAO;IACP,YAAY;IACZ,gBAAgB,EAAA;EAGlB;IACE,gCbnLqB;IaoLrB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB,EAAA;EAGrB;IACE,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,cbhMqB;IaiMrB,iBAAiB,EAAA;EAGnB;IACE,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,oCblKiB;IamKjB,cb7MqB;Ia8MrB,0CbpKiB;IaqKjB,kBAAkB,EAAA;EAGpB;IACE,OAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB,EAAA;EAGrB;IACE,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,gCb9NqB;Ia+NrB,eAAe;IACf,UAAU;IACV,cAAc,EAAA;IAPf;MAUG,cbjLqB,EAAA;EaqLzB;IACE,aAAa,EAAA;;AAKjB;EACE,sBAAsB;EACtB,kCb/LsB;EagMtB,0CbvMmB;EawMnB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,cbvPuB;EawPvB,oBAAoB,EAAA;EAEpB;IACE,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,iDbpNiB;IaqNjB,aAAa;IACb,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;IAClB,cbnQqB;IaoQrB,iCbrNe,EAAA;Ia2MhB;MAaG,gCbvQmB,EAAA;Ea2QvB;IACE,gBAAgB;IAChB,SAAS;IACT,oBAAoB;IACpB,gBAAgB,EAAA;Ib4dhB;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;Eave/D;IACE,wBAAwB;IACxB,gCbrRqB;IasRrB,kBAAkB,EAAA;EAGpB;IACE,UAAU,EAAA;EAGZ;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,wBAAwB;IACxB,eAAe;IACf,kBAAkB,EAAA;IANnB;MASG,oCb5Pe,EAAA;IamPlB;MAaG,SAAS;MACT,cAAc;MACd,qBblQe,EAAA;IamPlB;MAmBG,OAAO;MACP,YAAY,EAAA;;Ab7UlB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;Act8BC;EACG,sBAAsB;EACtB,yCAAyC;EACzC,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB,EAAA;;AAEpB;EACE,kBAAkB,EAAA;;AAEpB;EACE,oBAAoB,EAAA;;AAEtB;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ,EAAA;;AAEV;EACE,SAAS;EACT,UAAU,EAAA;;AAEZ;EACE,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB,EAAA;;AAEvB;EACE,YAAY,EAAA;;AAEd;;;;;;;;;;;EAWE,SAAS;EACT,UAAU;EACV,6EAA6E;EAC7E,eAAe,EAAA;;AAEjB;;EAEE,mBAAmB,EAAA;;AAErB;;EAEE,qBAAqB,EAAA;;AAEvB;EACE,gBAAgB,EAAA;;AAElB;;EAEE,oBAAoB,EAAA;;AAEtB;;EAEE,mBAAmB,EAAA;;AAErB;;EAEE,WAAW;EACX,eAAe;EACf,mBAAmB,EAAA;;AAErB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY,EAAA;;AAEd;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB,EAAA;;AAEnB;EACE,kBAAkB;EAClB,oBAAoB,EAAA;;AAIxB;;EAEI,mBAAmB,EAAA;;AAGvB;;EAEI,oBAAoB,EAAA;;AAGxB;EACI,6EAA6E;EAC7E,yBAAyB,EAAA;;AAG7B;EACI,iBAAiB;EACjB,YAAS,EAAI;;AAGjB;EACI,sCAAsC,EAAA;;AAE1C;EACI,yBAAyB,EAAA;;AAE7B;EACI,0CAA0C,EAAA;;AAJ9C;EAOI,sEAAsE,EAAA;;AAE1E;EACI,yBAAyB,EAAA;;AAE7B;EACI,0CAA0C,EAAA;;AAJ9C;EAOI,+DAA+D,EAAA;;AAEnE;EACI,yBAAyB,EAAA;;AAE7B;EACI,sCAAsC,EAAA;;AAJ1C;EAOI,wDAAwD,EAAA;;AAE5D;EACI,yBAAyB,EAAA;;AAE7B;EACI,0CAA0C,EAAA;;AAJ9C;EAOI,iDAAiD,EAAA;;AAErD;EACI,yBAAyB,EAAA;;AAE7B;EACI,0CAA0C,EAAA;;AAJ9C;EAOI,0CAA0C,EAAA;;AAE9C;EACI,yBAAyB,EAAA;;AAE7B;EACI,sCAAsC,EAAA;;AAJ1C;EAOI,mCAAmC,EAAA;;AAEvC;EACI,yBAAyB,EAAA;;AAE7B;EACI,0CAA0C,EAAA;;AAJ9C;EAOI,4BAA4B,EAAA;;AAEhC;EACI,yBAAyB,EAAA;;AAE7B;EACI,0CAA0C,EAAA;;AAJ9C;EAOI,qBAAqB,EAAA;;AAEzB;EACI,yBAAyB,EAAA;;AAE7B;EACI,sCAAsC,EAAA;;AAMxC;EACE,iBAAiB,EAAA;;AAEnB;EACE,mBAAmB,EAAA;;AAErB;EACE,kBAAkB,EAAA;;AAEpB;EACE,oBAAoB,EAAA;;AAEtB;EACE,iBAAiB,EAAA;;AAEnB;EACE,mBAAmB,EAAA;;AAErB;EACE,kBAAkB,EAAA;;AAEpB;EACE,oBAAoB,EAAA;;AAEtB;EACE,iBAAiB,EAAA;;AAEnB;EACE,oBAAoB,EAAA;;AAEtB;EACE,kBAAkB,EAAA;;AAEpB;EACE,qBAAqB,EAAA;;AAEvB;EACE,kBAAkB,EAAA;;AAEpB;EACE,oBAAoB,EAAA;;AAEtB;EACE,mBAAmB,EAAA;;AAErB;EACE,qBAAqB,EAAA;;AAEvB;EACE,kBAAkB,EAAA;;AAEpB;EACE,oBAAoB,EAAA;;AAEtB;EACE,mBAAmB,EAAA;;AAErB;EACE,qBAAqB,EAAA;;AAEvB;EACE,kBAAkB,EAAA;;AAEpB;EACE,oBAAoB,EAAA;;AAEtB;EACE,mBAAmB,EAAA;;AAErB;EACE,qBAAqB,EAAA;;AAEvB;EACE,kBAAkB,EAAA;;AAEpB;EACE,oBAAoB,EAAA;;AAEtB;EACE,mBAAmB,EAAA;;AAErB;EACE,qBAAqB,EAAA;;AAEvB;EACE,kBAAkB,EAAA;;AAEpB;EACE,oBAAoB,EAAA;;AAEtB;EACE,mBAAmB,EAAA;;AAErB;EACE,qBAAqB,EAAA;;AAEvB;EACE,kBAAkB,EAAA;;AAEpB;EACE,oBAAoB,EAAA;;AAEtB;EACE,mBAAmB,EAAA;;AAErB;EACE,qBAAqB,EAAA;;AAEvB;EACE,cAAc;EACd,eAAe,EAAA;;AAEjB;EACE,cAAc,EAAA;;AAEhB;EACE,kBAAkB,EAAA;;AAEpB;EACE,sBAAsB,EAAA;;AAExB;EACE,yBAAyB,EAAA;;AAE3B;EACE,sBAAsB,EAAA;;AAExB;EACE,sBAAsB,EAAA;;AAExB;EACE,yBAAyB,EAAA;;AAE3B;EACE,yBAAyB,EAAA;;AAE3B;EACE,sBAAsB,EAAA;;AAExB;EACE,WAAW,EAAA;;AAEb;EACE,cAAc,EAAA;;AAEhB;EACE,WAAW,EAAA;;AAEb;EACE,WAAW,EAAA;;AAEb;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,WAAW,EAAA;;AAEb;EACE,4CAA4C,EAAA;;AAE9C;EACE,2CAA2C,EAAA;;AAE7C;EACE,iBAAiB,EAAA;;AAEnB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,cAAc;EACd,mBAAmB,EAAA;;AAErB;EACE,kBAAkB,EAAA;;AAEpB;EACE,mBAAmB,EAAA;;AAErB;EACE,iBAAiB,EAAA;;AAEnB;EACE,yBAAsB;EACtB,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,WAAW,EAAA;;AAEb;;EAEE,WAAW;EACX,WAAW;EACX,cAAc,EAAA;;AAEhB;;EAEE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,WAAW,EAAA;;AAEb;;EAEE,WAAW;EACX,YAAY,EAAA;;AAEd;;EAEE,aAAa,EAAA;;AAEf;;EAEE,aAAa,EAAA;;AAEf;;;;;;;;;;;;;;EAcE,cAAc,EAAA;;AAEhB;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA4BE,aAAa,EAAA;;AAEf;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA4BE,eAAe,EAAA;;AAEjB;EACE;;IAEE,WAAW,EAAA;EAEb;;;;IAIE,UAAU,EAAA;EAEZ;;;;IAIE,YAAY,EAAA,EACb;;AAEH;EACE,sBAAsB,EAAA;;AAExB;EACE,sBAAsB,EAAA;EdiPtB;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;;Ac7P/D;EACE,aAAa,EAAA;;AAEf;;EAEE,kBAAkB,EAAA;;AAEpB;EACE,kBAAkB;EAClB,2BAA2B,EAAA;;AAE7B;EACE,eAAe;EACf,qBAAqB,EAAA;;AAEvB;EACE,4BAA4B,EAAA;;AAE9B;EACE,qBAAqB;EACrB,sBAAsB,EAAA;;AAExB;EACE,WAAW;EACX,WAAW;EACX,cAAc,EAAA;;AAEhB;EACE,UAAU;EACV,ed1hBqB;Ec2hBrB,oBAAoB;EACpB,qBAAqB;EACrB,cAAc,EAAA;;AAEhB;EACE,UAAU;EACV,edjiBqB;EckiBrB,qBAAqB;EACrB,cAAc,EAAA;;AAEhB;;EAEE,adviBqB,EAAA;;AcyiBvB;EACE,UAAU,EAAA;;AAEZ;EACE,kBAAkB,EAAA;;AAEpB;;EAEE,cAAc,EAAA;;AAEhB;EACE,YAAY,EAAA;;AAEd;EACE,aAAa,EAAA;;AAEf;EACE,eAAe,EAAA;;AAEjB;EACE,aAAa,EAAA;;AAEf;EACE,cAAc,EAAA;;AAEhB;EACE,gBAAgB,EAAA;;AAElB;EACE,iBAAiB,EAAA;;AAEnB;EACE,cAAc,EAAA;;AAEhB;EACE,iBAAiB,EAAA;;AAEnB;EACE,iBAAiB,EAAA;;AAEnB;EACE,0BAA0B,EAAA;;AAE5B;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,kBAAkB,EAAA;;AAEpB;;EAEE,yBAAyB;EACzB,kBAAkB,EAAA;;AAEpB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,iBAAiB,EAAA;;AAEnB;EACE,cAAc;EACd,gBAAgB,EAAA;;AAElB;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB,EAAA;;AAEnB;EACE,eAAe,EAAA;;AAEjB;EACE,cdlnBqB;EcmnBrB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB,EAAA;;AAExB;EACE,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW,EAAA;;AAEb;EACE,qBAAqB;EACrB,iBAAiB,EAAA;;AAEnB;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB,EAAA;;AAErB;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB,EAAA;;AAElB;EACE,WAAW;EACX,UAAU,EAAA;;AAEZ;EACE,UAAU,EAAA;;AAEZ;EACE,YAAY,EAAA;;AAEd;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,UAAU,EAAA;;AAEZ;;EAEE,WAAW,EAAA;;AAEb;;EAEE,gBAAgB,EAAA;;AAElB;;EAEE,UAAU,EAAA;;AAEZ;EACE,gBAAgB,EAAA;;AAElB;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB,EAAA;;AAElB;EACE,gBAAgB;EAChB,YAAY,EAAA;;AAEd;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,WAAW,EAAA;;AAEb;EACE,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,QAAQ;EACR,WAAW,EAAA;;AAEb;;;;;;EAME,yBAAyB,EAAA;;AAE3B;EACE,WAAW,EAAA;;AAEb;;EAEE,iBAAiB,EAAA;;AAEnB;;EAEE,oBAAoB,EAAA;;AAEtB;;EAEE,oBAAoB,EAAA;;AAEtB;;EAEE,oBAAoB,EAAA;;AAEtB;;EAEE,oBAAoB,EAAA;;AAEtB;;EAEE,oBAAoB,EAAA;;AAEtB;;EAEE,oBAAoB,EAAA;;AAEtB;EACE,cAAc,EAAA;;AAEhB;EACE,gBAAgB,EAAA;;AAElB;EACE,iBAAiB,EAAA;;AAEnB;EACE,cAAc,EAAA;;AAEhB;EACE,iBAAiB,EAAA;;AAEnB;EACE,iBAAiB,EAAA;;AAEnB;EACE,YAAY,EAAA;;AAEd;;EAEE,qBAAqB,EAAA;;AAEvB;;EAEE,gBAAgB,EAAA;;AAElB;;EAEE,oBAAoB,EAAA;;AAEtB;EACE,4CAA4C,EAAA;;AAE9C;EACE,2CAA2C,EAAA;;AAE7C;EACE,WAAW,EAAA;;AAEb;;EAEE,iBAAiB,EAAA;;AAEnB;;EAEE,gBAAgB,EAAA;;AAElB;;EAEE,gBAAgB,EAAA;;AAElB;;EAEE,eAAe,EAAA;;AAEjB;EACE,eAAe,EAAA;;AAEjB;EACE,eAAe,EAAA;;AAEjB;EACE,eAAe,EAAA;;AAEjB;EACE,sBAAsB,EAAA;;AAExB;EACE,sBAAsB,EAAA;;AAExB;EAEE,2BAA2B;EAC3B,sBAAsB;EACtB,+DAA+D;EAC/D,YAAY;EACZ,6BAA6B;EAC7B,4BAA4B,EAAA;;AAE9B;EACE,kBAAkB,EAAA;;AAEpB;EACE,6BAA6B,EAAA;;AAE/B;EACE,6BAA6B;EAC7B,wCAAqC,EAAA;;AAEvC;EACE,qBdt0Bc,EAAA;;Acw0BhB;EACE,qBdz0Bc,EAAA;;Ac20BhB;;EAEE,kBAAkB,EAAA;;AAEpB;EACE,eAAe;EACf,yBdv1Be,EAAA;;Ac+fjB;EA4VE,sBAAsB;EACtB,sBAAsB;EACtB,4BAA4B;EAC5B,WAAW;EACX,iBAAiB;EACjB,mBAAmB,EAAA;;AAErB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB,EAAA;;AAEnB;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,YAAY,EAAA;;AAEd;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB,EAAA;;AAErB;EACE,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,kBAAkB,EAAA;;AAEpB;EACE,iBAAiB;EACjB,gBAAgB,EAAA;;AA5XlB;EA+XE,iBAAiB,EAAA;;AAEnB;;EAEE,aAAa,EAAA;;AAEf;EACE,qBAAqB,EAAA;;AAEvB;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB,EAAA;;AAEpB;EACE,sBAAsB,EAAA;;AAExB;EACE,yBAAyB,EAAA;;AAE3B;EACE,uBAAuB,EAAA;;AAEzB;EACE,cAAc,EAAA;;AAEhB;EACE,yBdv5Bc;Ecw5Bd,4BAA4B,EAAA;;AAI9B;;EAEI,eAAe,EAAA;;AAEnB;EACE,+BAA+B,EAAA;;AAGjC;;EAEI,oBAAoB,EAAA;;AAExB;EACE,oCAAoC,EAAA;;AAGtC;;EAEI,mBAAmB,EAAA;;AAEvB;EACE,mCAAmC,EAAA;;AAGrC;EACE,yBAAyB,EAAA;;AAG3B;EACE,yBAAyB,EAAA;;AAU3B;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB,EAAA;;AAElB;EACI,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB,EAAA;;AAGtB;EACI,gBAAgB,EAAA;;AAGpB;EACI,mBAAmB;EACnB,yBAAyB,EAAA;;AAE7B;EACI,yBd5+BiB;Ec6+BjB,gBAAgB,EAAA;;AAGtB;EACE,sBAAsB;EACtB,yCAAyC;EACzC,eAAe;EACf,YAAY;EACZ,gBAAgB,EAAA;;AAChB;EACE,WAAW;EACX,yBAAyB,EAAA;;AAC3B;EACE,WAAW;EACX,eAAe;EACf,iBAAiB,EAAA;;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB,EAAA;;AAChB;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe,EAAA;;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB,EAAA;;AACvB;EACE,yBAAyB,EAAA;;AAC3B;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,YAAY,EAAA;;AAEpB;EACI,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,YAAY,EAAA;;AAGhB;EACI,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B,EAAA;;AAEjC;EACI,2BAA2B,EAAA;;AAE/B;EACI,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,SAAS;EACT,UAAU;EACV,UAAU;EACV,6BAA6B;EAC7B,iBAAiB,EAAA;;AAEjB;EACA,yBAAyB,EAAA;;AAEzB;EACA,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,cAAc;EACd,UAAU;EACV,YAAY,EAAA;;AAEhB;EACI,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,cAAc;EACd,UAAU;EACV,YAAY,EAAA;;AAGhB;EACI,WAAW;EACX,YAAY;EACZ,adllCqB;EcmlCrB,ednlCqB,EAAA;;AcslCzB;EACI,aAAa;EACb,eAAe,EAAA;;AdpnCnB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;Aet8BA;EACE,YAAY;EACZ,yBAAyB;EACzB,sBAAsB,EAAA;;AAGxB;EACE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,wBAAwB;EACxB,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,aAAa,EAAA;;AAIf;6FhB6ma6F;AgB3ma7F;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,iBAAiB;EACjB,WAAW,EAAA;;AAGb;EACE,kBAAkB;EAClB,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB,EAAA;;AAGxB;EACE,kBAAkB,EAAA;;AAGpB;;EAEE,+BAA+B,EAAA;;AAGjC;;EAEE,oCAAoC,EAAA;;AAGtC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB,EAAA;;AAGlB;EACE,yBAAyB;EACzB,cfpCuB,EAAA;;AeuCzB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAAE,0DAAA;EACpB,iBAAiB;EAAE,0DAAA;EACnB,aAAa;EACb,yBftCgB;EeuChB,kBAAkB;EAClB,gCfxCgB;EeyChB,mBf9CsB;Ee+CtB,6BAA6B;EAC7B,4BAA4B;EAC5B,SAAU;EACV,iCAAiC,EAAA;;AAInC;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,gBAAgB,EAAA;EfyqBd;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;Ee9rBjE;IAUI,+BAA+B,EAAA;;AAInC;;EAEE,oCAAoC;EAAE,kBAAA;EACtC,iCAAiC;EAAK,YAAA;EACtC,gCAAgC;EAAM,UAAA;EACtC,4BAA4B;EAAU,aAAA,EAAc;;AAGtD;EACE,aAAa;EACb,cfpFuB;EeqFvB,kBAAkB,EAAA;;AAGpB;EACE,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB,EAAA;;AAGpB;EACE,0BAA0B,EAAA;;AAG5B;EACE,6BAA6B,EAAA;;AAG/B;EACE,yBAAyB,EAAA;;AAG3B;EACE,yBAAyB,EAAA;;AAG3B;EACE,0BAA0B,EAAA;;AAG5B;EAEE,eAAe;EACf,oBAAoB;EACpB,uBAAuB,EAAA;;AAGzB;EAEE,eAAe;EACf,mBAAmB,EAAA;;AAGrB;EAEE,eAAe;EACf,mBAAmB;EACnB,yBAAyB,EAAA;;AAG3B;EAEE,eAAe;EACf,mBAAmB;EACnB,yBAAyB,EAAA;;AAG3B;EAEE,eAAe,EAAA;;AAGjB;EAEE,eAAe,EAAA;;AAGjB;EACE,eAAe;EACf,eAAe;EACf,iBAAiB,EAAA;;Af8PjB;EACE,cexPyC;EfyPzC,qBAAqB;EACrB,eAAe,EAAA;;AAGjB;EACE,ce9PkD;Ef+PlD,0BAA0B,EAAA;;AAG5B;EACE,cAAc,EAAA;;AAGhB;;EAEE,YAAY;EACZ,aAAa;EACb,6CAA6C,EAAA;;AAnB/C;EACE,YepPuC;EfqPvC,qBAAqB;EACrB,eAAe,EAAA;;AAGjB;EACE,ce1PgD;Ef2PhD,0BAA0B,EAAA;;AAG5B;EACE,cAAc,EAAA;;AAGhB;;EAEE,YAAY;EACZ,aAAa;EACb,6CAA6C,EAAA;;Ae/PjD;EACE,aAAa;EACb,kBAAkB,EAAA;;AAUlB;EACE,WAAW;EACX,oBARS,EAAA;;AAMX;EACE,WAAW;EACX,qBAPY,EAAA;;AAKd;EACE,WAAW;EACX,kBANQ,EAAA;;AAWZ;;;;EAIE,mBAAmB,EAAA;;AAKrB;EACE,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB,EAAA;;AAGpB;EACE,iBAAiB,EAAA;;AAGnB;EACE,mBAAmB,EAAA;;AAOrB;EACE,aAAa;EACb,2BAA2B;EAC3B,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,6BAA6B;EAC7B,4BAA4B;EAC5B,gCfvOY;EewOZ,YAAY;EfwWZ,mHAAiF;EACjF,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B,EAAA;EepX7B;IAaI,2BAA2B;IAC3B,gBAAgB;IAChB,cfjPgB;IekPhB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe,EAAA;IApBnB;MAuBM,2BAA2B;MAC3B,cf3PmB;Me4PnB,iCAAiC,EAAA;IAzBvC;MA6BM,YAAY,EAAA;IA7BlB;MAiCM,YAAY,EAAA;IAjClB;MAqCM,WAAW,EAAA;IArCjB;MA0CM,kBAAkB;MAClB,mBAAmB;MACnB,kBAAkB;MAClB,YAAY,EAAA;IA7ClB;MAiDM,kBAAkB;MAClB,gBAAgB,EAAA;IAlDtB;MAsDM,kBAAkB;MAClB,mBAAmB;MACnB,kBAAkB;MAClB,YAAY,EAAA;MAzDlB;QA6DU,YAAY,EAAA;IA7DtB;MAmEM,aAAa;MACb,mBAAmB;MACnB,kBAAkB;MAClB,YAAY,EAAA;MAtElB;QAyEQ,gBAAgB;QAChB,YAAY;QACZ,cAAc;QACd,cf9SY;Qe+SZ,eAAe,EAAA;QA7EvB;UAgFU,cfnTe,EAAA;MemOzB;QAqFQ,WAAW;QACX,cfxTY;QeyTZ,uBAAuB;QACvB,gBAAgB;QAChB,YAAY;QACZ,YAAY,EAAA;QA1FpB;UA+FU,cfjUU,EAAA;MekOpB;QAqGQ,uBAAuB,EAAA;IArG/B;MA2GM,iCAAiC,EAAA;EA3GvC;IAgHI,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,QAAQ,EAAA;EApHZ;IAwHI,WAAW;IACX,2BAA2B;IAC3B,cAAc,EAAA;;AAIlB;EACE,UAAU;EACV,yBf/VY,EAAA;;AekWd;EACE,0BAA0B,EAAA;;AAG5B;EACE,6BAA6B,EAAA;;AAG/B;EACE,iBAAiB;EACjB,iCAAiC,EAAA;EAFnC;IAKI,iCAAiC,EAAA;;AAIrC;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,mCAAmC,EAAA;EAJrC;IAOI,kCAAkC,EAAA;;AAItC;EACE,YAAY;EACZ,eAAe,EAAA;;AAGjB;EACE,kBAAkB;EAClB,qBAAqB,EAAA;EAFvB;IAKI,iBAAiB;IACjB,iBAAiB,EAAA;;AAKrB;EACE,aAAa;EACb,mBAAmB;EACnB,cfpZkB,EAAA;EeiZpB;IAMI,YAAY,EAAA;;AAIhB;EACE,YAAY;EACZ,YAAY,EAAA;;AAGd;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EAAE,eAAA;EACnC,mCAAmC,EAAA;;AAGrC;EACE,kCAAkC;EAAE,UAAA,EAAW;;AAIjD,yEAAA;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yBfhbsB;EeibtB,cftbkB;EeublB,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,OAAO;EACP,yBfpbgB;EeqbhB,8BAA8B;EAC9B,gBAAgB,EAAA;Ef0Sd;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;;AerTjE;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iCAAiC,EAAA;;AAGnC;EACE,yBfzciB,EAAA;;Ae4cnB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,YAAY;EACZ,cfxdkB;EeydlB,eAAe;EACf,kBAAkB;EAClB,kBAAkB,EAAA;;AAGpB;EACE,eAAe;EACf,WAAW,EAAA;;AAOb;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBftesB;EeuetB,yBflegB;EemehB,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc;EACd,oBAAoB,EAAA;;AAGtB,qFAAA;AACA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,gCAAgC;EAChC,YAAY,EAAA;;AAGd;EACE,mBf7fkB;Ee8flB,yBf1fiB;Ee2fjB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB,EAAA;;AAGpB;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY,EAAA;;AAGd;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iCAAiC,EAAA;;AAInC;EACE,mCAAmC,EAAA;;AAOrC,2DAAA;AACA;;EAEE,cf/hBkB;EegiBlB,kBAAkB;EAAE,uCAAA;EACpB,cAAc;EACd,mBAAmB;EACnB,4BAA4B;EAAE,oCAAA,EAAqC;EANrE;;IASI,kBAAkB,EAAA;;AAItB,6DAAA;AACA;EACE,qBAAqB;EAAE,sBAAA,EAAwB;;AAGjD;EACE,uBAAuB;EAAE,uBAAA,EAAyB;;AAGpD;EACE,uBAAuB;EAAE,yBAAA,EAAA;;AAG3B,mCAAA;AACA;EACE,wBAAwB;EAAE,4BAAA,EAA6B;;AAGzD;EACE,4BAA4B;EAAE,6BAAA,EAA8B;;AAG9D;EACE,4BAA4B;EAAE,iCAAA,EAAkC;;AAGlE,6EAAA;AACA;;EAEE,qBAAqB;EAAE,4DAAA,EAA6D;;AAGtF,wEAAA;AACA;EAEI,qBAAqB,EAAA;;AAFzB;EAMI,uBAAuB,EAAA;;AAN3B;EAUI,uBAAuB,EAAA;;AAV3B;EAcI,wBAAwB;EACxB,kBAAkB;EAClB,cAAc,EAAA;;AAhBlB;EAoBI,4BAA4B,EAAA;;AApBhC;EAwBI,4BAA4B,EAAA;;AAIhC,4EAAA;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,cAAc,EAAA;;AAGhB;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yBftnBkB;EeunBlB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe,EAAA;;AAGjB,qDAAA;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,yBftnBgB;EeunBhB,0DAA8M;EAC9M,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B,EAAA;;AAG5B;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,8Bf1oBY,EAAA;;Ae6oBd;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY,EAAA;;AAGd;EACE,UAAU;EACV,WAAW;EACX,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,YAAY;EACZ,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB,EAAA;;AAMlB;EACE,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,iBAAiB,EAAA;;AAInB;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY,EAAA;;AAGd;EACE,UAAU;EACV,WAAW;EACX,6BfzsBY;Ee0sBZ,8Bf1sBY;Ee2sBZ,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,YAAY;EACZ,gCfrtBY;EestBZ,+BfttBY;EeutBZ,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB,EAAA;;AAMlB;EACE,YAAY;EACZ,6BfvuBkB;EeuuBiB,uBAAA;EACnC,cAAc;EACd,WAAW,EAAA;;AAIb,qBAAA;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,mBf7uBsB;Ee8uBtB,sBAAsB;EACtB,0CAA0C;EAC1C,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,yBf9uBgB;Ee+uBhB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ,EAAA;;AAGV,qBAAA;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,cfpwBuB;EeqwBvB,kBAAkB,EAAA;;AAGpB,wBAAA;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,mBfzwBiB;Ee0wBjB,YAAY;EACZ,cfhxBuB;EeixBvB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,uCAAuC,EAAA;;AAGzC,sBAAA;AACA;EACE,yBfhxBU;EeixBV,YAAY,EAAA;;AAGd,0BAAA;AACA;EACE,yDAA2C;EAC3C,yBfrxBgB;EesxBhB,+BAA+B;EAC/B,cflyBuB;EemyBvB,iBAAiB,EAAA;;AAGnB;EACE,yBf9xBU;Ee+xBV,YAAY;EACZ,YAAY,EAAA;;AAKd,0CAAA;AACA,yCAAA;AACA,0CAAA;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;EAAE,uCAAA;EACrB,kCAAkC;EAAE,uBAAA;EACpC,uBAAuB;EAAE,qBAAA,EAAuB;;AAGlD,oCAAA;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EAAE,uCAAA;EACzB,kBAAkB;EAAE,qCAAA,EAAuC;;AAG7D,kDAAA;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,YAAY;EAAE,oDAAA;EACd,UAAU;EAAE,yBAAA;EACZ,YAAY;EACZ,yBft0BY;Ees0Ba,uBAAA,EAAyB;;AAKpD,mCAAA;AACA,iCAAA;AACA,mCAAA;AAOA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,mBAAmB,EAAA;EALrB;;IASI,yBfh2BgB;Iei2BhB,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB,EAAA;EAb1B;IAiBI,eAAe;IACf,iBAAiB,EAAA;EAlBrB;IAsBI,WAAW,EAAA;EAtBf;IA0BI,cAAc;IACd,kBAAkB,EAAA;EA3BtB;IA+BI,iBAAiB;IACjB,kBAAkB,EAAA;EAhCtB;IAoCI,iBAAiB;IACjB,eAAe,EAAA;EArCnB;IAyCI,iBAAiB;IACjB,kBAAkB;IAClB,WAAW,EAAA;EA3Cf;IA+CI,mCAAmC,EAAA;;AAIvC;EACE,yBf34BkB;Ee44BlB,YAAY,EAAA;;AAGd;EACE,0BAA0B;EAAE,aAAA;EAC5B,oBAAoB;EACpB,yCAAyC;EAAE,0BAAA,EAA2B;;AAGxE;EACE,mCAAmC,EAAA;;AAInC;EACE,eAAe;EACf,cAAc;EACd,6BAA6B,EAAA;;AAG/B;EACE,kBAAkB,EAAA;;AAGpB;EACE,sIAMC,EAAA;;AAGH;EACE,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB,EAAA;;AAGpB;EAEE,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,0Cfn5BgB,EAAA;;Aew5BpB,yCAAA;AACA,wCAAA;AACA,yCAAA;AACA;EACE,kBAAkB;EAClB,mBfh8BsB;Eei8BtB,kBAAkB;EAClB,aAAa;EACb,yBf97BgB;Ee+7BhB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,8BAA8B,EAAA;;AAGhC;EACE,gBAAgB;EAChB,eAAe,EAAA;;AAGjB;EACE,aAAa;EACb,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,iBAAiB,EAAA;;AAGnB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,yDAA2C;EAC3C,uCAAuC;EACvC,+BAA+B;EAC/B,cf99BgB;Ee+9BhB,kBAAkB,EAAA;;AAGpB;EACI,qCAAuC;EACvC,cft+BQ;Eeu+BR,qBAAqB;EACrB,YAAY,EAAA;;AAGhB;EACE,yBf1+BgB;Ee2+BhB,cft/BuB,EAAA;;Aey/BzB;EACI,YAAY;EACZ,YAAY,EAAA;;AAGhB,iCAAA;AACA;EACE,kBAAkB;EAClB,mBfhgCkB;EeigClB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,wBAAwB;EACxB,YAAY,EAAA;;AAGd;EACE,UAAU,EAAA;;AAGZ;EACE,kBAAkB;EAClB,mBf7gCsB;Ee8gCtB,yBfzgCgB;Ee0gChB,YAAY;EACZ,2CAAwC;EACxC,kBAAkB;EAClB,cAAc,EAAA;;AAGhB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cf/hCkB;EegiClB,mBf3hCsB;Ee4hCtB,gBAAgB;EAChB,eAAe,EAAA;;AAGjB;EACE,cfviCuB;EewiCvB,mBfpiCY,EAAA;;AeuiCd,kDAAA;AACA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa,EAAA;;AAGf;EACE,aAAa;EACb,SAAS;EACT,2BAA2B,EAAA;;AAG7B;EACE,YAAY;EACZ,QAAQ;EACR,2BAA2B,EAAA;;AAG7B;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB,EAAA;;AAGtB,kDAAA;AACA;;EAEE,mBftkCsB;EeukCtB,YAAY;EACZ,cf9kCuB;Ee+kCvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,yBf/kCY;EeglCZ,wCAAwC,EAAA;;AAI1C;EACE,WAAW;EAAE,mCAAA,EAAoC;;AAGnD;EACE,yBAAyB;EACzB,YAAY;EAAE,mCAAA;EACd,SAAS,EAAA;;AAPX;EAWE,6BAA6B,EAAA;;AAP/B;EAWE,6BAA6B,EAAA;;AAM/B,6CAAA;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,oCAAoC;EACpC,qCAAqC;EACrC,mCAAmC;EACnC,oBAAoB;EACpB,YAAY;EACZ,wBAAwB,EAAA;;AAG1B;EACE,cAAc;EACd,YAAY;EACZ,wBAAwB,EAAA;;AAG1B;EACE,UAAU,EAAA;;AAGZ;EACE,kBAAkB;EAClB,WAAW;EACX,yBfloCY;EemoCZ,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,wBAAwB,EAAA;;AAG1B;EAEE,mBfzoCsB;Ee0oCtB,yBfroCgB;EesoChB,kBAAkB;EAClB,aAAa;EACb,iCAAiC;EACjC,0CAA0C;EAC1C,YAAY;EACZ,cAAc,EAAA;;AAGhB,0CAAA;AACA,wCAAA;AACA,0CAAA;AAEA,2FAAA;AACA;EACE,aAAa,EAAA;;AAGf,8BAAA;AACA;EACE,kBAAkB;EAClB,mBf/pCsB;EegqCtB,yBf3pCgB;Ee6pChB,kBAAkB;EAClB,wCAAqC;EACrC,iBAAiB;EAAW,kBAAA;EAC5B,gBAAgB;EAAY,wBAAA;EAC5B,cAAc;EAAc,sBAAA;EAC5B,aAAa,EAAA;;AAGf,gCAAA;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU,EAAA;;AAGZ,sBAAA;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,sCAAsC,EAAA;;AAGxC,+BAAA;AACA;;EAEE,yBf/rCY,EAAA;;AeksCd,mBAAA;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,iBAAiB,EAAA;;AAGnB;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,cAAc,EAAA;;AAGhB,mBAAA;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB,EAAA;;AAGzB;EACE,2BAA2B,EAAA;;AAG7B;EACE,gBAAgB,EAAA;Ef3fd;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;Ee2ejE;IAKI,uBAAuB,EAAA;IAL3B;MAQM,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,QAAQ;MACR,iBAAiB;MACjB,YAAY,EAAA;IAblB;MAiBM,eAAe;MACf,gCAAgC;MAChC,gBAAgB;MAChB,uBAAuB;MACvB,mBAAmB;MACnB,eAAe,EAAA;IAtBrB;MA0BM,eAAe;MACf,gCAAgC;MAChC,gBAAgB;MAChB,uBAAuB;MACvB,mBAAmB;MACnB,eAAe,EAAA;;AAKrB;;EAEE,sBAAsB;EACtB,aAAa,EAAA;;AAGf;EACE,uCAAuC;EACvC,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB,EAAA;EAJlB;IAOI,YAAY;IACZ,mBAAmB,EAAA;EARvB;IAYI,yCAAyC,EAAA;EAZ7C;IAgBI,0CAA0C,EAAA;IAhB9C;MAmBM,0CAA0C,EAAA;;AAKhD,oCAAA;AACA,kCAAA;AACA,oCAAA;AAEC;EACC,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,cAAc;EACd,kBAAkB,EAAA;;AAGpB;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB,EAAA;;AAGpB;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe,EAAA;;AAGjB;EAEE,6BAA6B;EAE7B,SAAS,EAAA;EAJX;;IAOI,2BAA2B;IAE3B,SAAS,EAAA;;AAIb;EACE,0BAA0B;EAC1B,SAAS;EACT,8BAA8B,EAAA;EAHhC;IAOM,cAAc;IACd,aAAa,EAAA;;AAKnB;EACE,0BAA0B;EAC1B,SAAS,EAAA;EAFX;IAOQ,iBAAiB;IACjB,iBAAiB,EAAA;;AAOzB;EACE,kBAAkB;EAClB,cft3CkB;Eeu3ClB,mBfn3CiB;Eeo3CjB,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,yBfp3CgB;Eeq3ChB,gCfr3CgB;Ees3ChB,UAAU;EACV,iCAAiC,EAAA;EAbnC;IfjyBE,mHAAiF;IACjF,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IegzBzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,gCf14CU,EAAA;Iei3Cd;MA4BM,yBAAyB;MACzB,eAAe;MACf,WAAW;MACX,cfn5Cc;Meo5Cd,gBAAgB;MAChB,iBAAiB,EAAA;IAjCvB;MAqCM,eAAe;MACf,WAAW;MACX,cf35Cc;Me45Cd,gBAAgB;MAChB,iBAAiB,EAAA;EAzCvB;IA8CI,YAAY;IACZ,mBf95CoB;Ie+5CpB,gCf15Cc;Ie25Cd,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,6BAA6B,EAAA;IApDjC;MAuDM,aAAa;MACb,8BAA8B;MAC9B,mBAAmB;MACnB,UAAU;MACV,wBAAwB;MACxB,WAAW,EAAA;MA5DjB;QA+DQ,cfn7CY;Qeo7CZ,mBAAmB;QACnB,4BAA4B,EAAA;MAjEpC;QAqEQ,cfz7CY,EAAA;Meo3CpB;QAyEQ,iBAAiB,EAAA;;AASzB;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe,EAAA;;AAGjB;EAEI,yBfn6Ce;Eeo6Cf,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,cAAc,EAAA;Ef1uBd;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;EemtBjE;IAYM,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB,EAAA;EAjB5B;IAqBM,eAAe;IACf,mBAAmB;IACnB,cfp+CmB;Ieq+CnB,0BAA0B;IAC1B,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB,EAAA;EA3BvB;IA+BM,eAAe;IACf,mBAAmB;IACnB,cf9+CmB;Ie++CnB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe,EAAA;EAtCrB;IA0CM,eAAe;IACf,iBAAiB;IACjB,cfz/CmB;Ie0/CnB,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe,EAAA;EAlDrB;IAsDM,eAAe;IACf,gBAAgB;IAChB,cfpgDc;IeqgDd,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe,EAAA;EA9DrB;IAkEM,eAAe;IACf,gBAAgB;IAChB,cfhhDc;IeihDd,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe,EAAA;;AAKrB;EACE,yCAAyC;EACzC,iBAAiB;EACjB,oBAAoB,EAAA;;AAItB,qFAAA;AAEA;EACE,aAAa,EAAA;;AAGf;EACE,iBAAiB;EACjB,kBAAkB,EAAA;;AAGpB;EACE,wBAAwB;EACxB,qBAAqB,EAAA;;AAGvB;EACE,wBAAwB;EACxB,uBAAuB,EAAA;;AAGzB;EACE,wBAAwB;EACxB,sBAAsB,EAAA;;AAOxB;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;EACb,yBfjkDsB;EekkDtB,yBf7jDgB;Ee8jDhB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,WAAW,EAAA;EAZb;IAeI,YAAY;IACZ,cfjlDqB;IeklDrB,yBf9kDU;Ie+kDV,yBfllDgB;IemlDhB,kBAAkB;IAClB,eAAe,EAAA;EApBnB;IAwBI,aAAa;IACb,sBAAsB;IACtB,QAAQ,EAAA;EA1BZ;IA8BI,0Bf9lDgB;Ie+lDhB,yBf5lDU;Ie6lDV,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,cfpmDqB;IeqmDrB,eAAe;IACf,kBAAkB,EAAA;EArCtB;IA0CI,aAAa;IACb,mBAAmB;IACnB,QAAQ,EAAA;EA5CZ;IAgDI,aAAa;IACb,yBAAyB;IACzB,SAAS,EAAA;IAlDb;MAqDM,iBAAiB;MACjB,eAAe;MACf,YAAY;MACZ,kBAAkB;MAClB,eAAe;MACf,yBAAyB;MACzB,YAAY,EAAA;MA3DlB;QA8DQ,sBAAsB;QACtB,mBAAmB,EAAA;;AAY3B;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;EACb,yBf5oDsB;Ee6oDtB,yBfxoDgB;EeyoDhB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,SAAS,EAAA;EAbX;IAgBI,YAAY;IACZ,cf7pDqB;Ie8pDrB,yBf1pDU;Ie2pDV,yBf9pDgB;Ie+pDhB,kBAAkB;IAClB,eAAe,EAAA;EArBnB;IAyBI,aAAa;IACb,sBAAsB;IACtB,QAAQ,EAAA;EA3BZ;IA+BI,0Bf1qDgB;Ie2qDhB,yBfxqDU;IeyqDV,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,cfhrDqB;IeirDrB,eAAe;IACf,kBAAkB,EAAA;EAtCtB;IA2CI,aAAa;IACb,mBAAmB;IACnB,QAAQ,EAAA;EA7CZ;IAiDI,aAAa;IACb,yBAAyB;IACzB,SAAS,EAAA;IAnDb;MAsDM,iBAAiB;MACjB,eAAe;MACf,YAAY;MACZ,kBAAkB;MAClB,eAAe;MACf,yBAAyB;MACzB,YAAY,EAAA;MA5DlB;QA+DQ,sBAAsB;QACtB,mBAAmB,EAAA;;AAc3B;EACE,0BfvtDY;EewtDZ,mBAAmB,EAAA;;AhBwzZrB;EgBlzZE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,cAAc,EAAA;EhBozZd;;;IgB9yZE,kBAAkB;IAClB,qBAAqB,EAAA;IhBkzZrB;;;MgB9yZE,qBAAqB,EAAA;IhBkzZvB;;;MgB7yZE,kBAAkB;MAClB,UAAU;MACV,WAAW;MACX,mBf/uDM;MegvDN,yBfrvDQ;MesvDR,sBAAsB;MACtB,WAAW;MACX,mBAAmB,EAAA;IhBizZrB;;;MgB9yZoB,SAAS;MAAK,SAAS;MAAG,2BAA2B;MAAE,gBAAgB,EAAA;IhBqzZ3F;;;MgBpzZoB,YAAY;MAAE,SAAS;MAAG,2BAA2B;MAAE,gBAAgB,EAAA;IhB2zZ3F;;;MgB1zZoB,UAAU;MAAI,QAAQ;MAAI,2BAA2B;MAAE,gBAAgB,EAAA;IhBi0Z3F;;;MgBh0ZoB,WAAW;MAAG,QAAQ;MAAI,2BAA2B;MAAE,gBAAgB,EAAA;IhBu0Z3F;;;MgBt0ZoB,UAAU;MAAI,SAAS;MAAgC,iBAAiB,EAAA;IhB40Z5F;;;MgB30ZoB,WAAW;MAAG,SAAS;MAAgC,iBAAiB,EAAA;IhBi1Z5F;;;MgBh1ZoB,UAAU;MAAI,YAAY;MAA6B,iBAAiB,EAAA;IhBs1Z5F;;;MgBr1ZoB,WAAW;MAAG,YAAY;MAA6B,iBAAiB,EAAA;IhB21Z5F;;;MgBv1ZE,kBAAkB;MAClB,aAAa;MACb,SAAS;MACT,kBAAkB;MAClB,2BAA2B;MAC3B,SAAS;MACT,mBAAmB;MACnB,WAAW;MACX,gBAAgB;MAChB,kBAAkB;MAClB,kBAAkB;MAClB,eAAe,EAAA;EhB21ZnB;IgBr1ZE,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe,EAAA;EhBu1ZjB;IgBj1ZE,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB,EAAA;EhBm1ZxB;IgB/0ZE,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,mBf5zDU;Ie6zDV,YAAY;IACZ,kBAAkB;IAClB,cfn0DqB;Ieo0DrB,kBAAkB;IAClB,YAAY;IACZ,aAAa,EAAA;IhBi1Zb;MgB90ZE,YAAY,EAAA;EhBg1ZhB;;IgB10ZE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB,EAAA;IhB60ZjB;;MgB10ZE,kBAAkB,EAAA;IhB60ZpB;;MgBz0ZE,cAAc,EAAA;IhB40ZhB;;MgBx0ZE,kBAAkB,EAAA;EhB20ZtB;IgBt0ZE,kBAAkB;IAClB,cfn2DgB;Ieo2DhB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,oBAAoB,EAAA;;AAIxB;EACE,gBAAgB;EAChB,cf/2DkB;Eeg3DlB,YAAY;EACZ,kBAAkB;EAClB,yBf/2DY;Eeg3DZ,kBAAmB,EAAA;;AAOrB;EACE,eAAe,EAAA;;AAIjB;EACE,eAAe,EAAA;;AAGjB,mCAAA;AACA;EACE,qBAAqB;EACrB,eAAe,EAAA;;AAGjB,mCAAA;AACA;EACE,WAAW;EACX,mBAAmB,EAAA;EAFrB;IAKI,SAAS,EAAA;;AAIb,mCAAA;AACA;EACE,YAAY;EACZ,mBAAmB,EAAA;;AAGrB,yBAAA;AACA;;EAEE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW,EAAA;;AAGb,iDAAA;AACA;EACE,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,kBAAkB,EAAA;;AAGpB,+CAAA;AA3WA;EA6WE,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB,EAAA;;AAGpB,sFAAA;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW,EAAA;;AAQb;EACE,kBAAkB;EAClB,cfl8DkB;Eem8DlB,mBf/7DiB;Eeg8DjB,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,yBfh8DgB;Eei8DhB,gCfj8DgB;Eek8DhB,UAAU;EACV,iCAAiC,EAAA;EAbnC;If72CE,mHAAiF;IACjF,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;Ie43CzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,gCft9DU,EAAA;Ie67Dd;MA4BM,yBAAyB;MACzB,iBAAiB;MACjB,WAAW;MACX,cf/9Dc;Meg+Dd,gBAAgB;MAChB,iBAAiB,EAAA;EAjCvB;IAsCI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,uBAAuB;IACvB,mBfv+DoB;Iew+DpB,gCfn+Dc,EAAA;Ies7DlB;MAgDM,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,gBAAgB;MAChB,YAAY;MACZ,gBAAgB;MAChB,eAAe;MACf,kBAAkB;MAClB,2BAA2B,EAAA;MAxDjC;QA2DQ,mBfx/DM,EAAA;Me67Dd;QA+DQ,mBf5/DM,EAAA;Me67Dd;QAmEQ,qBAAqB;QACrB,WAAW;QACX,YAAY;QACZ,cftgEY;QeugEZ,sBAAsB,EAAA;QAvE9B;UA0EU,af1gEU;Ue2gEV,WAAW;UACX,YAAY;UACZ,qBAAqB,EAAA;IA7E/B;MAmFM,cAAc,EAAA;MAnFpB;QAsFQ,iBAAiB;QACjB,kBAAkB,EAAA;EAvF1B;IA8FI,aAAa;IACb,2DAA2D;IAC3D,QAAQ;IACR,YAAY;IACZ,uBAAuB;IACvB,mBf/hEe;IegiEf,gBAAgB,EAAA;If1zChB;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;IeusCjE;MAwGM,WAAW;MACX,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,YAAY;MACZ,gBAAgB;MAChB,eAAe;MACf,eAAe;MACf,kBAAkB;MAClB,2BAA2B,EAAA;MAlHjC;QAqHQ,mBfljEM,EAAA;Me67Dd;QAyHQ,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,cAAc,EAAA;;AAQtB;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBfnkEsB;EeokEtB,yBf/jEgB;EegkEhB,kBAAkB;EAClB,wCAAqC;EACrC,eAAe;EACf,cAAc,EAAA;EAThB;IAaI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB,EAAA;If52ChB;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;Ee20CjE;IAuBI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,2BAA2B,EAAA;IA3B/B;MA+BM,mBfhmEQ,EAAA;IeikEd;MAmCM,YAAY;MACZ,aAAa;MACb,oBAAoB,EAAA;IArC1B;MAyCM,aAAa;MACb,eAAe;MACf,OAAO;MACP,iBAAiB;MACjB,cflnEmB;MemnEnB,YAAY,EAAA;;AAMlB;EACE,sBAAsB;EACtB,qBAAqB;EACrB,eAAe,EAAA;EAHjB;IASM,wBAAwB,EAAA;;AAK9B;EACE,YAAY,EAAA;EADd;IAII,YAAY,EAAA;;AAKhB;EAEI,0Bf9oEU,EAAA;;AekpEd;EACE,aAAa,EAAA;EADf;IAII,2BAA2B,EAAA;EAJ/B;IAQI,uBAAuB,EAAA;EAR3B;IAYI,yBAAyB,EAAA;;AAI7B;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,sBAAsB,EAAA;EAJxB;IAOI,YAAY,EAAA;EAPhB;IAUI,eAAe,EAAA;EAVnB;IAaI,aAAa;IACb,mBAAmB,EAAA;EAdvB;IAiBI,aAAa,EAAA;;AAQjB;EACE,kBAAkB;EAAE,kCAAA;EACpB,YAAY;EAAE,+DAAA;EACd,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;EAAiB,mBAAA;EACjC,kBAAkB;EAAY,mBAAA;EAE9B,yBf/pEkB;EegqElB,wCAAwC;EACtC,WAAW;EACb,4HASC;EACD,WAAW;EACX,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAA;EA3BzB;IA8BI,4HASC,EAAA;EAvCL;IA2CI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,SAAS;IACT,iCAAiC,EAAA;;AAIrC,mDAAA;AACA;EACE,cAAc,EAAA;;AAGhB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,aAAa,EAAA;;AAKf;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,QAAQ;EACR,MAAM;EACN,cAAc,EAAA;;AAGhB;EACE,cf1wEkB;Ee2wElB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,YAAY;EACZ,cfnxEuB;EeoxEvB,yBf/wEiB;EegxEjB,yBf1wEgB;Ee2wEhB,gCf3wEgB;Ee4wEhB,mBAAmB;EACnB,wCAAqC;EACrC,gBAAgB;EAChB,aAAa,EAAA;EAVf;IAcI,aAAa;If1sDf,mHAAiF;IACjF,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IeysDzB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;IAC7B,4BAA4B;IAC5B,yBAAyB;IACzB,WAAW;IACX,cfxyEgB;IeyyEhB,mBAAmB;IACnB,eAAe;IACf,gCfxyEU,EAAA;Ee4wEd;IAiCI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,0BAA0B;IAC1B,uBAAuB;IACvB,gBAAgB;IAChB,qBAAqB,EAAA;If7kDrB;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;IeshDjE;MA6CM,yBfxzEa;MeyzEb,4BAA4B;MAC5B,kBAAkB,EAAA;MA/CxB;QAmDU,yBAAyB;QACzB,mBAAmB;QACnB,4BAA4B;QAC5B,mBAAmB,EAAA;MAtD7B;QA0DU,yBAAyB;QACzB,mBf/xES,EAAA;QeouEnB;UA8DY,6BAA8B;UAC9B,8BAA8B;UAC9B,+BAA+B,EAAA;UAhE3C;YAmEc,mBf90EK,EAAA;Me2wEnB;QA2EU,gBAAgB,EAAA;QA3E1B;UA8EY,WAAW;UACX,6BAA8B;UAC9B,yBAAyB;UACzB,+BAA+B;UAC/B,gBAAgB;UAChB,0BAA0B,EAAA;MAnFtC;QA2FU,yBfh2EQ;Qei2ER,mBfj2EQ,EAAA;MeqwElB;QAgGU,mBfp0ES;Qeq0ET,yBAAyB,EAAA;QAjGnC;UAqGY,8Bf12EM;Ue22EN,+Bf32EM,EAAA;MeqwElB;QA6GY,yBfl3EM;Qem3EN,+Bfn3EM;Qeo3EN,gBAAgB,EAAA;MA/G5B;QAqHQ,aAAa;QACb,cft4EiB;Qeu4EjB,mBfj4EgB;Qek4EhB,yBfl4EgB;Qem4EhB,mBAAmB;QACnB,4BAA4B;QAC5B,gBAAgB;QAChB,YAAY,EAAA;QA5HpB;UA+HU,iBAAiB;UACjB,uBAAuB;UACvB,qBAAqB;UACrB,yBAAyB;UACzB,uBAAuB,EAAA;QAnIjC;UAuIU,YAAY;UACZ,kBAAkB;UAClB,gBAAgB;UAChB,sBAAsB;UACtB,WAAW;UACX,sBAAsB;UACtB,iCAAiC;UACjC,YAAY;UACZ,eAAe,EAAA;UA/IzB;YAkJY,UAAU,EAAA;MAlJtB;QAwJQ,uBAAuB;QACvB,qBAAqB;QACrB,yBAAyB;QACzB,sBAAsB,EAAA;MA3J9B;QA+JQ,aAAa;QACb,mBfp4EW;Qeq4EX,sBAAsB;QACtB,yBAAyB;QACzB,qBAAqB;QACrB,YAAY,EAAA;QApKpB;UAuKU,aAAa;UACb,sBAAsB;UACtB,6Bfn7Ec;Ueq7Ed,8Bfr7Ec;Ues7Ed,+Bft7Ec;Ueu7Ed,YAAY,EAAA;UA7KtB;YAgLY,cfh8Ea,EAAA;YegxEzB;cAmLc,4BAA4B,EAAA;UAnL1C;YAwLY,mBfn8EO,EAAA;Ue2wEnB;YA4LY,cfj8EM;Yek8EN,uBAAuB;YACvB,mBAAmB,EAAA;QA9L/B;UAmMU,YAAY;UACZ,kBAAkB;UAClB,gBAAgB;UAChB,sBAAsB;UACtB,YAAY;UACZ,sBAAsB;UACtB,iCAAiC;UACjC,YAAY;UACZ,eAAe,EAAA;UA3MzB;YA+MY,UAAU,EAAA;MA/MtB;QAqNQ,aAAa;QACb,mBAAmB;QACnB,oBAAoB,EAAA;QAvN5B;UA0NU,kBAAkB;UAClB,gBAAgB;UAChB,YAAY;UACZ,iCAAiC;UACjC,kCAAkC;UAClC,YAAY;UACZ,eAAe;UACf,aAAa,EAAA;;AAQvB;EACE,mBf98EiB;Ee+8EjB,yBfr/EsB;Ees/EtB,+Bft/EsB;Eeu/EtB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,YAAY,EAAA;EARd;IAWI,mBf//Ee;IeggFf,yBfpgFgB;IeqgFhB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,YAAY,EAAA;EAjBhB;IAqBI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,WAAW,EAAA;;AAIf;EACE,aAAa;EACb,sBAAsB,EAAA;EAFxB;IAKI,cf3hFqB;Ie4hFrB,iBAAiB,EAAA;;AAIrB;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EAER,aAAa;EACb,0FAAA;EACA,cAAc,EAAA;EAPhB;IAUI,yBf/hFc;IegiFd,gCfhiFc;IeiiFd,mBfxiFU;IeyiFV,6BAA6B;IAC7B,4BAA4B,EAAA;IAdhC;MAiBM,aAAa;Mf79DjB,mHAAiF;MACjF,sBAAsB;MACtB,4BAA4B;MAC5B,2BAA2B;Me49DvB,YAAY;MACZ,eAAe;MACf,iBAAiB;MACjB,kBAAkB;MAClB,6BAA6B;MAC7B,4BAA4B;MAC5B,yBAAyB;MACzB,cfzjFc;Me0jFd,mBAAmB;MACnB,eAAe;MACf,gCfzjFQ,EAAA;Ie4hFd;MAiCM,cAAc;MACd,YAAY;MACZ,cfnkFmB;MeokFnB,mBfhkFQ;MeikFR,YAAY,EAAA;MArClB;QAwCQ,YAAY,EAAA;QAxCpB;UA2CU,yBf1kFU;Ue2kFV,kBAAkB;UAClB,uBAAuB;UACvB,uBAAuB,EAAA;QA9CjC;UAkDU,kBAAkB;UAClB,0BAA0B,EAAA;MAnDpC;QAwDQ,yBf/kFI;QeglFJ,cfzlFiB;Qe0lFjB,yBAAyB;QACzB,iBAAiB,EAAA;;AAMzB;EACE,cfjmFkB;EekmFlB,sCAAsC,EAAA;EAFxC;IAKI,cftmFqB;IeumFrB,oCAAoC,EAAA;;AAIxC;EACE,cf3mFkB;Ee4mFlB,2BAA2B,EAAA;EAF7B;IAKI,cfhnFqB;IeinFrB,yBAAyB,EAAA;;AAN7B;EAWE,2BAA2B,EAAA;;AAX7B;EAeE,yBAAyB,EAAA;;AAO3B;EACE,eAAe;EAAkB,sBAAA;EACjC,iBAAiB;EAAgB,gBAAA;EACjC,kBAAkB;EAAe,wBAAA,EAAyB;;AAK5D;EACE,gBAAgB;EAAiB,4BAAA;EACjC,SAAS;EACT,UAAU,EAAA;;AAGZ;EACE,aAAa;EAAoB,iBAAA;EACjC,uBAAuB;EACvB,mBAAmB;EAAc,4BAAA,EAA6B;;AAGhE;EACE,WAAW;EAAsB,iBAAA;EACjC,YAAY;EACZ,kBAAkB;EAAe,qBAAA;EACjC,sBAAsB;EAAW,4BAAA;EACjC,iBAAiB;EAAgB,mBAAA,EAAoB;;AAGvD;EACE,OAAO;EAA0B,0BAAA,EAA2B;;AAG9D;EACE,eAAe;EAAkB,sBAAA;EACjC,gBAAgB;EAAiB,mBAAA;EACjC,kBAAkB;EAAe,sBAAA,EAAuB;;AAG1D;EACE,eAAe;EAAkB,uBAAA;EACjC,gBAAgB,EAAA;;AAGlB,2BAAA;AACA;EACE,UAAU;EACV,oBAAoB,EAAA;;AAGtB,yBAAA;AACA;EACE,aAAa;EAAE,iCAAA;EACf,YAAY,EAAA;EAFd;IAKI,aAAa,EAAA;;AAIjB,gEAAA;AACA;EACE,oBAAoB;EAAE,mCAAA,EAAoC;;AAQ5D;EAII,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gEAAqE;EACrE,yBAAyB;EACzB,cf/sFqB;EegtFrB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,gCfltFgB;EemtFhB,8BAA8B,EAAA;EAdlC;IAiBM,SAAS;IACT,gBAAgB,EAAA;EAlBtB;IAsBQ,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,eAAe,EAAA;IA1BvB;MA6BU,kBAAkB;MAClB,YAAY;MACZ,kBAAkB;MAClB,mBAAmB;MACnB,gBAAgB;MAChB,eAAe,EAAA;MAlCzB;QAqCY,UAAU,EAAA;;AArCtB;EA4CI,aAAa;EACb,WAAW;EACX,mBfxsFe;EeysFf,qBAAqB,EAAA;EA/CzB;IAkDM,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,WAAW,EAAA;EAtDjB;IA0DM,kBAAkB,EAAA;IA1DxB;MA8DQ,YAAY;MACZ,mBAAmB;MACnB,eAAe,EAAA;IAhEvB;MAoEQ,kBAAkB;MAClB,aAAa;MACb,YAAY,EAAA;EAtEpB;;IA6EQ,YAAY;IACZ,mBAAmB;IACnB,eAAe,EAAA;EA/EvB;;IAmFQ,aAAa;IACb,uBAAuB;IACvB,SAAS,EAAA;;AAQjB;;;;;;;GhBsmZG;AgB7lZH;;;;;;;EhBqmZE;AgB3lZF;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,2BAA2B;EAC3B,SAAS;EACT,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBfjxFuB;EekxFvB,yBfvzFgB;EewzFhB,kBAAkB;EAClB,cfp0FuB;Eeq0FvB,+BAA+B,EAAA;;AAGjC;EACE,mBAAmB;EACnB,gBAAgB,EAAA;;AAGlB;EACE,eAAe;EACf,cf90FkB,EAAA;;Aei1FpB;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,OAAO;EACP,YAAY;EACZ,MAAM,EAAA;;AAGR;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBf91FmB,EAAA;;Aei2FrB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,SAAS;EACT,YAAY;EACZ,mBfx2FY;Eey2FZ,cf72FuB;Ee82FvB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,0DAA0D,EAAA;EAb5D;IAgBI,aAAa;IACb,mBAAmB,EAAA;EAjBvB;IAqBI,mBft3FiB,EAAA;;Ae03FrB;EACE,+Bf33FmB,EAAA;;Ae83FrB;EACE,mBf73FiB;Ee83FjB,kBAAkB;EAClB,mCf52Fa,EAAA;Eey2Ff;IAMI,cf/2FW,EAAA;;Aem3Ff;EACE,mBfv4FiB;Eew4FjB,kBAAkB;EAClB,mCfx1Fc,EAAA;Eeq1FhB;IAMI,cf31FY,EAAA;;Ae+1FhB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,WAAW;EACX,YAAY;EACZ,cfh6FkB,EAAA;;Aem6FpB;EACE,cf74Fa,EAAA;;Aeg5Ff;EACE,cfn3Fc,EAAA;;Aes3FhB;EACE,cfr5Fa,EAAA;;Aew5Ff;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBfl7FmB;Eem7FnB,kBAAkB,EAAA;EANpB;IASI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBf/7FgB;Ieg8FhB,uDAAuD,EAAA;;AAI3D;EACE,mBf56FkB,EAAA;Ee26FpB;IAII,2BAA2B;IAC3B,mBfp7FsB,EAAA;;Aew7F1B;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB,EAAA;;AAGlB;EACE,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,mBfx9FmB;Eey9FnB,cAAc,EAAA;;AAGhB;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe,EAAA;;AAGjB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,yBf7+FmB;Ee8+FnB,kBAAkB;EAClB,mBf9+FY;Ee++FZ,cfn/FuB;Eeo/FvB,eAAe;EACf,gBAAgB;EAChB,eAAe,EAAA;EAhBjB;IAmBI,YAAY;IACZ,mBAAmB,EAAA;EApBvB;IAwBI,qBf5/FuB;Ie6/FvB,mBf5/FiB,EAAA;;AeggGrB;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cftgGkB,EAAA;;AeygGpB;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,OAAO;EACP,YAAY,EAAA;;AAGd;EAEI,iBAAiB;EACjB,kBAAkB,EAAA;;AAItB;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc,EAAA;;AAGhB;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBf5jGyB;Ee6jGzB,aAAa,EAAA;;AAGf;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cfrkGkB,EAAA;;AewkGpB;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBf7kGiB;Ee8kGjB,yBfhlGmB;EeilGnB,kBAAkB;EAClB,0CAA0C,EAAA;Ef12ExC;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;;Ae+1EjE;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,cfnmGuB;EeomGvB,eAAe;EACf,gBAAgB;EAChB,eAAe,EAAA;EAbjB;IAgBI,mBfrmGU,EAAA;;AeymGd;EACE,cfzjGoB,EAAA;EewjGtB;IAII,mBf7mGU,EAAA;EeymGd;IAQI,wBAAwB;IACxB,aAAa,EAAA;;AAIjB;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,mBf7nGyB,EAAA;;AegoG3B;EACE,mBf9kGoB,EAAA;;AeilGtB;EACE,aAAa;EACb,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;EACZ,6BfrpGmB;EespGnB,uBAAuB;EACvB,cfzpGkB;Ee0pGlB,eAAe;EACf,eAAe;EACf,gBAAgB,EAAA;EAflB;IAkBI,cf5mGuB,EAAA;;AegnG3B;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc,EAAA;;AAGhB;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sBAAsB,EAAA;EAJxB;IAOI,YAAY;IACZ,WAAW;IACX,sBAAsB,EAAA;;AAI1B,oDAAA;AACA;EACE,WAAW;EACX,iBAAiB,EAAA;;AAGnB;EACE,YAAY;EACZ,iBAAiB,EAAA;;AAGnB,0DAAA;AACA;;EAEE,qBAAqB,EAAA;;AAGvB,sDAAA;AACA;;EAEE,eAAe;EACf,YAAY,EAAA;;AAGd,6CAAA;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW,EAAA;;AAGb;EACE,WAAW;EACX,mBAAmB,EAAA;;AAGrB;EACE,YAAY;EACZ,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,aAAa,EAAA;;AAGf;;EAEE,eAAe;EACf,YAAY,EAAA;;AAGd;EACE,qBAAqB;EACrB,eAAe;EACf,YAAY,EAAA;;AAGd;;;;;EAKE,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,cAAc,EAAA;;AftxGhB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AgBv8BA;EACE,kBAAkB;EAClB,WAAW;EACX,yBhBqEY;EgBpEZ,mBhB6BY;EgB5BZ,kBAAkB,EAAA;EALpB;IAQI,mBhBiEe;IgBhEf,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sBAAsB,EAAA;IAZ1B;MAeM,aAAa;MACb,gBAAgB,EAAA;IAhBtB;MAoBM,YAAY,EAAA;EApBlB;IAyBI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,mBhB4Ce;IgB3Cf,yBhB0CU;IgBzCV,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,aAAa,EAAA;IApCjB;MAuCM,aAAa;MACb,mBAAmB;MACnB,gBAAgB;MAChB,eAAe,EAAA;MA1CrB;QA6CQ,yBhB+BW,EAAA;MgB5EnB;QAiDQ,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,iBAAiB,EAAA;MApDzB;QAwDQ,iBAAiB;QACjB,cAAc;QACd,YAAY;QACZ,eAAe,EAAA;QA3DvB;UA8DU,WAAW;UACX,YAAY,EAAA;QA/DtB;UAmEU,aAAa,EAAA;QAnEvB;UAuEU,eAAe,EAAA;MAvEzB;QA4EQ,eAAe,EAAA;MA5EvB;QAgFQ,uBAAuB,EAAA;QAhF/B;UAmFU,WAAW;UACX,YAAY;UACZ,kBAAkB;UAClB,iBAAiB;UACjB,iBAAiB;UACjB,cAAc,EAAA;UAxFxB;YA2FY,qBAAqB;YACrB,mBhBjBQ,EAAA;QgB3EpB;UAiGU,aAAa;UACb,sBAAsB;UACtB,uBAAuB;UACvB,QAAQ;UACR,gBAAgB,EAAA;QArG1B;UAyGU,gBAAgB,EAAA;QAzG1B;UA6GU,eAAe;UACf,cAAc,EAAA;MA9GxB;QAmHQ,uBAAuB,EAAA;QAnH/B;UAsHU,aAAa;UACb,sBAAsB;UACtB,uBAAuB;UACvB,QAAQ;UACR,iBAAiB;UACjB,YAAY,EAAA;QA3HtB;UA+HU,eAAe;UACf,gCAAgC;UAChC,gBAAgB;UAChB,uBAAuB;UACvB,mBAAmB;UACnB,eAAe,EAAA;QApIzB;UAwIU,eAAe;UACf,gCAAgC;UAChC,gBAAgB;UAChB,uBAAuB;UACvB,mBAAmB;UACnB,eAAe,EAAA;MA7IzB;QAkJQ,QAAQ,EAAA;QAlJhB;UAqJU,eAAe;UACf,gBAAgB;UAChB,yBAAyB;UACzB,sBAAsB;UACtB,cAAc;UACd,cAAc,EAAA;QA1JxB;UA8JU,eAAe;UACf,gBAAgB;UAChB,cAAc,EAAA;;AAOxB,kBAAA;AACA;EACE,kBAAkB,EAAA;EADpB;IAII,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,yBhBxIc;IgById,gChBzIc;IgB0Id,iCAAiC;IACjC,gBAAgB,EAAA;EAXpB;IhB+eE,aAAa;IACb,8BAA8B;IAC9B,cA5nBuB;IA6nBvB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gCA7nBY;IA8nBZ,8BAA8B;IAC9B,mHAAiF;IgBxe/E,0BAA0B;IAC1B,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,iBAAiB;IACjB,4CAA4C,EAAA;IAvBhD;MA0BM,SAAS;MACT,gBAAgB;MAChB,yBAAyB;MACzB,chBvKc,EAAA;IgB0IpB;MAiCM,cAAc;MACd,SAAS;MACT,iBAAiB;MACjB,gBAAgB;MAChB,yBAAyB;MACzB,chBhLc;MgBiLd,+BAA+B;MAC/B,2CAA2C;MAC3C,kBAAkB;MAClB,eAAe;MACf,oBAAoB,EAAA;MA3C1B;QA8CQ,8BAA8B;QAC9B,sCAAsC,EAAA;EA/C9C;IAqDI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;IACjB,mBhBrJqB,EAAA;EgB2FzB;IA8DI,gBAAgB,EAAA;IA9DpB;MAiEM,OAAO;MACP,WAAW,EAAA;EAlEjB;IAuEI,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,YAAY;IACZ,aAAa,EAAA;IA3EjB;MA8EM,kBAAkB,EAAA;IA9ExB;MAkFM,aAAa,EAAA;IAlFnB;MAsFM,OAAO;MACP,aAAa;MACb,gBAAgB;MAChB,YAAY,EAAA;MhBugBd;QACI,UAjKa,EAAA;MAoKjB;QACI,mBApKuB;QAqKvB,kBAAkB;QAClB,kBAAkB,EAAA;MAGtB;QACI,yBA3uBU;QA4uBV,kBAAkB,EAAA;QAElB;UACI,yBAAqD,EAAA;IgB/mBjE;MA+FM,wBAAwB,EAAA;MA/F9B;QAkGQ,aAAa;QACb,mBAAmB;QACnB,kBAAkB;QAClB,SAAS;QACT,YAAY,EAAA;QAtGpB;UAyGU,cAAc;UACd,YAAY,EAAA;UA1GtB;YA6GY,cAAc;YACd,eAAe;YACf,iBAAiB,EAAA;QA/G7B;UAoHU,aAAa;UACb,cAAc;UACd,QAAQ;UACR,eAAe;UACf,chBnQe,EAAA;UgB2IzB;YA2HY,chBpQe,EAAA;QgByI3B;UAgIU,chB1QU;UgB2QV,eAAe;UACf,yBAAyB;UACzB,yBhB/NS;UgBgOT,gBAAgB;UAChB,yBhBrOI;UgBsOJ,kBAAkB;UAClB,yBAAyB;UACzB,eAAe,EAAA;UAxIzB;YA2IY,yBhB5OS;YgB6OT,chBvRa,EAAA;MgB2IzB;QAkJQ,kBAAkB;QAClB,eAAe;QACf,4BAA4B,EAAA;QApJpC;UAuJU,cAAc;UACd,gBAAgB,EAAA;QAxJ1B;UA4JU,cAAc;UACd,gBAAgB;UAChB,gBAAgB;UAChB,iBAAiB;UACjB,yBhBxSW;UgBySX,kBAAkB;UAClB,0BAA0B;UAC1B,YAAY,EAAA;QAnKtB;UAyKY,iBAAiB;UACjB,gBAAgB;UAChB,cAAc;UACd,gBAAgB,EAAA;UA5K5B;YA+Kc,oBAAoB;YACpB,eAAe;YACf,6BAA6B;YAC7B,gChB5TM;YgB6TN,kBAAkB,EAAA;YAnLhC;cAsLgB,yBAAyB;cACzB,yBhBvTE;cgBwTF,mBhBvRG;cgBwRH,kBAAkB;cAClB,WAAW;cACX,YAAY;cACZ,eAAe;cACf,kBAAkB;cAClB,yBAAyB;cACzB,gBAAgB,EAAA;YA/LhC;;cAoMgB,WAAW;cACX,gBAAgB;cAChB,uBAAuB;cACvB,kBAAkB;cAClB,iBAAiB;cAEjB,eAAe,EAAA;QA1M/B;UAiNY,gBAAgB;UAChB,iBAAiB;UACjB,mBAAmB;UACnB,cAAc;UACd,SAAS,EAAA;QArNrB;UAyNY,eAAe,EAAA;UAzN3B;;YA6Nc,chBvWM;YgBwWN,eAAe;YACf,yBAAyB;YACzB,yBhB5TK;YgB6TL,gBAAgB;YAChB,yBhBlUA;YgBmUA,kBAAkB;YAClB,yBAAyB;YACzB,eAAe,EAAA;YArO7B;;cAwOgB,yBhBzUK;cgB0UL,chBpXS,EAAA;QgB2IzB;UAgPU,kBAAkB;UAClB,chBpXU,EAAA;MgBmIpB;QAuPQ,eAAe,EAAA;MAvPvB;QA2PQ,aAAa;QACb,0CAA0C;QAC1C,6BAA6B;QAC7B,aAAa;QACb,YAAY,EAAA;MA/PpB;QAmQQ,cAAc;QACd,WAAW;QACX,WAAW;QACX,eAAe;QACf,kBAAkB;QAClB,iBAAiB;QACjB,oBAAoB,EAAA;MAzQ5B;QA6QQ,kBAAkB;QAClB,UAAU;QACV,SAAS;QACT,YAAY;QACZ,QAAQ;QACR,gDAAgD,EAAA;MAlRxD;QAsRQ,cAAc;QACd,WAAW;QACX,WAAW;QACX,eAAe;QACf,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,aAAa;QACb,oBAAoB,EAAA;MA/R5B;QAmSQ,WAAW;QACX,aAAa;QACb,QAAQ;QACR,iBAAiB;QACjB,gDAAgD,EAAA;MAvSxD;QA2SQ,cAAc;QACd,sBAAsB;QACtB,iBAAiB;QACjB,2BAA2B;QAC3B,sBAAsB;QACtB,WAAW;QACX,YAAY;QACZ,gDAAgD;QAChD,kDAAkD;QAClD,+BAA+B,EAAA;MApTvC;QAwTQ,WAAW;QACX,aAAa,EAAA;MAzTrB;QA6TQ,cAAc;QACd,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,QAAQ;QACR,kBAAkB;QAClB,mBhBzcW;QgB0cX,yBhB5ca;QgB6cb,gBAAgB;QAChB,kBAAkB,EAAA;QAtU1B;UAyUU,mBhBvagB;UgBwahB,yBhBldW,EAAA;MgBwIrB;QA+UQ,OAAO;QACP,YAAY;QACZ,cAAc;QACd,aAAa,EAAA;MAlVrB;QAsVQ,cAAc;QACd,kBAAkB;QAClB,uBAAuB;QACvB,gBAAgB;QAChB,kBAAkB,EAAA;MA1V1B;QA8VQ,gBAAgB;QAChB,cAAc,EAAA;MA/VtB;QAmWQ,qBAAqB;QACrB,QAAQ;QACR,UAAU,EAAA;MArWlB;QAyWQ,mBhBxcW;QgBycX,kBAAkB,EAAA;IA1W1B;MA+WM,mBhBpfkB;MgBqflB,kBAAkB;MAClB,8BhBtcU,EAAA;IgBqFhB;MAqXM,aAAa;MACb,YAAY,EAAA;MAtXlB;QA0XQ,OAAO,EAAA;MA1Xf;QA8XQ,gBAAgB;QAChB,iBAAiB;QACjB,eAAe,EAAA;EAhYvB;IAsYI,YAAY;IACZ,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,chBrhBqB;IgBshBrB,8BhBlhBU;IgBmhBV,eAAe;IAEf,aAAa;IACb,gBAAgB,EAAA;IA/YpB;MAkZM,QAAQ;MACR,cAAc;MACd,UAAU;MACV,oBAAoB,EAAA;MArZ1B;QAwZQ,kBAAkB,EAAA;IAxZ1B;MA6ZM,OAAO;MACP,aAAa;MACb,gBAAgB;MAChB,aAAa;MACb,gBAAgB;MAChB,SAAS,EAAA;MhB8LX;QACI,UAjKa,EAAA;MAoKjB;QACI,mBApKuB;QAqKvB,kBAAkB;QAClB,kBAAkB,EAAA;MAGtB;QACI,yBA3uBU;QA4uBV,kBAAkB,EAAA;QAElB;UACI,yBAAqD,EAAA;MgB/mBjE;QAsaQ,aAAa;QACb,mBAAmB;QACnB,QAAQ;QACR,6BAA6B;QAC7B,gBAAgB;QAChB,kBAAkB,EAAA;QA3a1B;UA8aU,OAAO;UACP,YAAY,EAAA;UA/atB;YAkbY,cAAc;YACd,YAAY;YACZ,6BAA6B,EAAA;;AAUzC;EAEI,oBAAoB;EACpB,eAAe;EACf,6BAA6B;EAC7B,gChB7kBgB,EAAA;EgBwkBpB;IAQM,yBAAyB;IACzB,yBhBvkBY;IgBwkBZ,mBhBviBa;IgBwiBb,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB,EAAA;EAjBtB;IAqBM,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IAEjB,eAAe,EAAA;;AAMrB;EACE,kBAAkB;EAClB,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,eAAe;EAEf,0DAA4C;EAC5C,4BAA4B;EAC5B,0BAA0B;EAC1B,wBAAwB,EAAA;;AAG1B;EACE,4BAA4B,EAAA;;AAG9B;EACE,+BAA+B;EAC/B,WAAW;EACX,oBAAoB;EACpB,cAAc,EAAA;;AAGhB;EAEI,aAAa;EACb,kBAAkB;EAClB,mBhB9nBQ;EgB+nBR,chBxoBqB;EgByoBrB,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB,EAAA;;AAZpB;EAgBI,WAAW;EACX,WAAW;EACX,mBhB5oBQ;EgB6oBR,mBAAmB,EAAA;;AAIvB;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,yBhBpqBkB;EgBqqBlB,cAAc;EACd,eAAe,EAAA;;AAGjB;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe,EAAA;;AA3sBjB;EAwtBE,kBAAkB,EAAA;EADpB;IAII,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,gChBvpBU;IgBwpBV,mCAAmC,EAAA;EATvC;IAaI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,4DAA4D,EAAA;EAlBhE;IAsBI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB,EAAA;EA3B1B;IA+BI,aAAa;IACb,OAAO;IACP,qBAAqB;IACrB,8BAA8B;IAC9B,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,cAAc,EAAA;EAtClB;IA0CI,OAAO;IACP,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,+BAA+B;IAC/B,yEAAyE,EAAA;EAjD7E;IAsDM,mBAAiB,EAAA;EAtDvB;IAsDM,uBAAiB,EAAA;EAtDvB;IAsDM,sBAAiB,EAAA;EAtDvB;IAsDM,uBAAiB,EAAA;EAtDvB;IAsDM,sBAAiB,EAAA;EAtDvB;IAsDM,uBAAiB,EAAA;EAtDvB;IAsDM,sBAAiB,EAAA;EAtDvB;IAsDM,uBAAiB,EAAA;EAtDvB;IAsDM,sBAAiB,EAAA;EAtDvB;IAsDM,uBAAiB,EAAA;EAtDvB;IAsDM,sBAAiB,EAAA;EAtDvB;IAsDM,uBAAiB,EAAA;EAtDvB;IAsDM,sBAAiB,EAAA;EAtDvB;IAsDM,uBAAiB,EAAA;EAtDvB;IAsDM,sBAAiB,EAAA;EAtDvB;IAsDM,uBAAiB,EAAA;EAtDvB;IAsDM,sBAAiB,EAAA;EAtDvB;IAsDM,uBAAiB,EAAA;EAtDvB;IAsDM,sBAAiB,EAAA;EAtDvB;IAsDM,uBAAiB,EAAA;EAtDvB;IAsDM,qBAAiB,EAAA;EAtDvB;IAsDM,uBAAiB,EAAA;EAtDvB;IAsDM,sBAAiB,EAAA;EAtDvB;IAsDM,uBAAiB,EAAA;EAtDvB;IAsDM,sBAAiB,EAAA;EAtDvB;IAsDM,uBAAiB,EAAA;EAtDvB;IAsDM,sBAAiB,EAAA;EAtDvB;IAsDM,uBAAiB,EAAA;EAtDvB;IAsDM,sBAAiB,EAAA;EAtDvB;IAsDM,uBAAiB,EAAA;EAtDvB;IAsDM,sBAAiB,EAAA;EAtDvB;IAsDM,uBAAiB,EAAA;EAtDvB;IA2DI,cAAc;IACd,eAAe;IACf,kCAAkC;IAClC,cAAc;IACd,eAAe;IACf,iBAAiB,EAAA;EAhErB;IAoEI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,QAAQ,EAAA;IAvEZ;MA0EM,OAAO;MACP,YAAY;MACZ,WAAW;MACX,kBAAkB,EAAA;IA7ExB;MAiFM,cAAc;MACd,uBAAuB;MACvB,YAAY;MACZ,eAAe;MACf,eAAe;MACf,cAAc;MACd,gBAAgB;MAChB,aAAa;MACb,kBAAkB,EAAA;MAzFxB;QA4FQ,UAAU;QACV,qCAAqC,EAAA;MA7F7C;QAiGQ,aAAa;QACb,mBAAmB,EAAA;MAlG3B;QAsGQ,UAAU;QACV,yDAAyD,EAAA;IAvGjE;MA4GM,gBAAgB;MAChB,WAAW;MACX,cAAc;MACd,uBAAuB;MACvB,YAAY;MACZ,eAAe;MACf,eAAe;MACf,qCAAqC;MACrC,YAAY;MACZ,8BAA8B;MAC9B,wBAAwB,EAAA;MAtH9B;QAyHQ,YAAY;QACZ,UAAU,EAAA;EA1HlB;IAgII,gBAAgB;IAChB,gChBhxBU;IgBixBV,+BAA+B,EAAA;EAlInC;IAuIM,eAAe,EAAA;EAvIrB;IA4II,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,sBAAsB,EAAA;EArJ1B;IAyJI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,eAAe;IACf,cAAc;IACd,UAAU,EAAA;IAnKd;MAsKM,mBAAmB,EAAA;EAtKzB;IA2KI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,OAAO;IACP,YAAY,EAAA;EA/KhB;IAmLI,eAAe;IACf,cAAc;IACd,kCAAkC,EAAA;EArLtC;IAyLI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS,EAAA;;AAIb;EACE;;IAEE,qBAAqB,EAAA;EAGvB;IACE,qEAAqE,EAAA,EAAA;;AAIzE;EACE;IACE,uBAAuB;IACvB,aAAa,EAAA;EAGf;IACE,oBAAoB;IACpB,UAAU,EAAA,EAAA;;AAId;EACE;;IAEE,UAAU;IACV,0CAA0C,EAAA;EAG5C;IACE,aAAa;IACb,0CAA0C,EAAA,EAAA;;AAQ9C;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,aAAa,EAAA;;AAOf;EACE,YAAY;EACZ,aAAa;EACb,mBhB14BiB;EgB24BjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yBhBh7BgB;EgBi7BhB,gChBj7BgB;EgBk7BhB,yCAAyC,EAAA;EAV3C;IAcI,YAAY;IhBvUd,aAAa;IACb,8BAA8B;IAC9B,cA5nBuB;IA6nBvB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gCA7nBY;IA8nBZ,8BAA8B;IAC9B,mHAAiF,EAAA;IgBgTnF;MAkBM,6BAA6B;MAC7B,gBAAgB;MAChB,mBhBj8BkB;MgBk8BlB,YAAY;MACZ,chBz8BmB;MgB08BnB,kBAAkB;MAClB,eAAe,EAAA;MAxBrB;QA2BQ,chB78BY,EAAA;EgBk7BpB;IAkCI,OAAO;IACP,gBAAgB;IAChB,YAAY,EAAA;IApChB;MAwCM,UAAU,EAAA;IAxChB;MA4CM,mBAAmB;MACnB,kBAAkB,EAAA;EA7CxB;IAmDI,kBAAkB,EAAA;IAnDtB;MAsDM,eAAe;MACf,chBz+Bc;MgB0+Bd,mBAAmB;MACnB,yBAAyB;MACzB,qBAAqB,EAAA;IA1D3B;MA8DM,aAAa;MACb,qCAAqC;MACrC,QAAQ,EAAA;MAhEd;QAmEQ,eAAe;QACf,YAAY;QACZ,kBAAkB;QAClB,eAAe;QACf,uBAAuB;QACvB,YAAY;QACZ,gCAAgC,EAAA;QAzExC;UA4EU,mBhBh9BS,EAAA;;AgBu9BnB;EACE,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,mBhBh+BiB;EgBi+BjB,UAAU;EACV,WAAW;EACX,aAAa;EACb,QAAQ;EACR,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,8BAA8B;EAC9B,WAAW;EACX,wCAAwC,EAAA;EAd1C;IAiBI,UAAU;IACV,yBhB/+BsB,EAAA;;AgBm/B1B;EACE,UAAU;EACV,oBAAoB,EAAA;;AAGtB;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,0DAA0D,EAAA;EAf5D;IAkBI,mBAAmB;IACnB,aAAa,EAAA;;AAIjB;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,8BAA8B;EAC9B,UAAU;EACV,oBAAoB;EACpB,8BAA8B,EAAA;EAThC;IAYI,UAAU;IACV,oBAAoB,EAAA;;AAIxB;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,yBhBziCkB;EgB0iClB,8BhB7kCgB;EgB8kChB,4CAA4C;EAC5C,2BAA2B;EAC3B,wDAAwD;EACxD,WAAW,EAAA;EAfb;IAkBI,wBAAwB,EAAA;EAlB5B;IAsBI,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,yBhBzjCgB,EAAA;IA6rBhB;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;EgBmVjE;IA+BI,aAAa;IACb,YAAY;IACZ,yBhBhkCgB;IgBikChB,+CAA+C,EAAA;IAlCnD;MAqCM,OAAO,EAAA;IArCb;MAyCM,gBAAgB;MAChB,iBAAiB;MACjB,eAAe,EAAA;;AAKrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,iBAAiB;EhBxgBjB,aAAa;EACb,8BAA8B;EAC9B,cA5nBuB;EA6nBvB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gCA7nBY;EA8nBZ,8BAA8B;EAC9B,mHAAiF;EgBigBjF,4CAA4C,EAAA;;AAG9C;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,chB1oCkB;EgB2oClB,+BAA+B;EAC/B,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe,EAAA;EARjB;IAWI,8BAA8B;IAC9B,sCAAsC,EAAA;;AAI1C;EACE,SAAS;EACT,OAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,chB7pCkB;EgB8pClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAA;;AAGV;EACE,OAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,chBjrCkB;EgBkrClB,+BAA+B;EAC/B,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,chB7rCkB;EgB8rClB,+BAA+B;EAC/B,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe,EAAA;EATjB;IAYI,+BAA+B;IAC/B,sCAAsC,EAAA;;AAI1C;;EAEE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,2CAA2C,EAAA;;AAG7C;EACE,WAAW;EACX,mCAAmC,EAAA;EAFrC;IAKI,mCAAmC,EAAA;EALvC;IASI,aAAa;IACb,mBAAmB,EAAA;;AAIvB;EACE,chBnuCkB;EgBouClB,+BAA+B,EAAA;EAFjC;IAKI,+BAA+B,EAAA;EALnC;IASI,aAAa;IACb,mBAAmB,EAAA;;AAIvB;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,0BAA0B,EAAA;;AAG5B;EAEE,qCAAqC;EACrC,UAAU,EAAA;;AAGZ;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBhBxtCuB;EgBytCvB,8BhB/tCmB;EgBguCnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB,EAAA;;AAGpB;EACE,eAAe;EACf,cAAc;EACd,kBAAkB,EAAA;;AAGpB;EACE,eAAe;EACf,WAAW,EAAA;;AAGb;EACE,YAAY,EAAA;;AAGd;EACE,WAAW,EAAA;;AAGb;EACE,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB,EAAA;;AAGpB;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,YAAY,EAAA;;AAGd;EAEE,sBAAsB,EAAA;EAFxB;IAKI,oBAAoB;IACpB,sBAAsB;IACtB,aAAa,EAAA;;AAIjB;EAEE,aAAa;EACb,kBAAkB;EAClB,2BAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBhB5yCY;EgB6yCZ,yBhB9yCmB;EgB+yCnB,sBAAsB,EAAA;EAEtB;IACE,aAAa,EAAA;EAGf;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,sDAAsD,EAAA;IAbvD;MAgBG,mBAAmB,EAAA;IAhBtB;MAoBG,sBAAsB,EAAA;EAI1B;IACE,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,4BAA4B;IAC5B,sDAAsD,EAAA;EAGxD;IACE,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY,EAAA;IANb;MAUG,WAAW;MACX,cAAc;MACd,UAAU;MACV,YAAY;MACZ,kBAAkB;MAClB,gBAAgB,EAAA;EAIpB;IACE,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB,EAAA;EAGrB;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,iBAAiB,EAAA;IAEjB;MACE,oEAAoE,EAAA;EAIxE;IACE,aAAa,EAAA;EAGf;IACE,aAAa,EAAA;EAGf;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kCAAkC;IAClC,eAAe;IACf,iBAAiB,EAAA;EAGnB;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,cAAc,EAAA;IAVf;MAaG,mBAAmB,EAAA;;AAKzB;EACE;IACE,aAAa,EAAA;EAGf;IACE,UAAU,EAAA,EAAA;;AAId;EACE,kBAAkB,EAAA;;AAGpB;EACE,cAAc,EAAA;EADhB;IAII,oBAAoB;IACpB,sBAAsB;IACtB,aAAa,EAAA;;AAIjB;EACE,sBAAsB;EACtB,aAAa,EAAA;;AAGf;EACE,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB,EAAA;EAJlB;IAOI,0CAA0C,EAAA;;AAI9C;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,mBhB98CiB;EgB+8CjB,yBhBh9CY;EgBi9CZ,kBAAkB;EAClB,0CAA0C;EAC1C,oBAAoB,EAAA;;AAGtB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBhBz9CkB,EAAA;EgB29ClB;IACE,cAAc,EAAA;;AAIlB;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ,EAAA;;AAGV;EACE,eAAe;EACf,gBAAgB;EAChB,chB/+CkB,EAAA;;AgBk/CpB;EACE,eAAe;EACf,chB7hDuB,EAAA;;AgBgiDzB;EACE,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,QAAQ;EACR,eAAe,EAAA;EAHjB;IAMI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBhB9/Ce;IgB+/Cf,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,chBhjDgB;IgBijDhB,eAAe,EAAA;IAdnB;MAiBM,eAAe,EAAA;IAjBrB;MAqBM,eAAe,EAAA;;AAKrB;EACE,uBAAuB;EACvB,eAAe;EACf,YACF,EAAA;;AAEA;EACE,qBAAqB;EACrB,YACF,EAAA;;AAMA;EACE,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,mBhB1iDiB;EgB2iDjB,yBhB5kDgB;EgB6kDhB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,sBAAsB,EAAA;;AAGxB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,chBtmDuB;EgBumDvB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iCAAiC,EAAA;EAVnC;IAaI,oBAAoB,EAAA;EAbxB;IAiBI,eAAe;IACf,YAAY;IACZ,oBAAoB,EAAA;EAnBxB;IAuBI,mBhBxkDe,EAAA;IgBijDnB;MA0BM,UAAU,EAAA;;AAMhB;EACE,chBjoDuB,EAAA;EgBgoDzB;IAII,chBpoDqB;IgBqoDrB,eAAe;IACf,YAAY,EAAA;EANhB;IAUI,mBhB/nDc,EAAA;;AgBmoDlB;EACE,8BhBroDiB;EgBsoDjB,mBhB1oDsB;EgB2oDtB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB,EAAA;;AAGpB;EACE,eAAe;EACf,cAAc;EACd,mBAAmB,EAAA;;AAGrB;EACE,eAAe;EACf,gBAAgB;EAChB,chB3nDkB;EgB4nDlB,mBAAmB;EACnB,eAAe,EAAA;EALjB;IAQI,0BAA0B,EAAA;;AAI9B;EACE,eAAe;EACf,chB/qDuB;EgBgrDtB,mBAAmB,EAAA;;AAGtB;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBhBnrDsB;EgBorDrB,kBAAkB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;EACX,kBAAkB,EAAA;;AAGrB;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,8BhBtqDmB;EgBuqDnB,mBhB3sDsB;EgB4sDtB,qBAAqB;EACrB,cAAc;EACd,gBAAgB,EAAA;EAblB;IAgBI,mBAAwC,EAAA;;AAI5C;EACE,oBAAoB;EACpB,gBAAgB,EAAA;;AAGlB;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,+HAKC;EACD,0BAA0B;EAC1B,8DAA8D,EAAA;;AAGhE;EACE;IACE,2BAA2B,EAAA;EAE7B;IACE,4BAA4B,EAAA,EAAA;;AAIhC;EACE,0BhBxvDuB,EAAA;;AgB2vDzB;EACE,eAAe;EACf,chBptDkB;EgBqtDlB,qBAAqB,EAAA;;AAGvB;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B,EAAA;;AAGjC;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc,EAAA;;AAGhB;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ,EAAA;;AAGV;EACE,eAAe;EACf,chB1xDkB;EgB2xDlB,yBAAyB;EACzB,sBAAsB,EAAA;;AAGxB;EACE,eAAe;EACf,gBAAgB;EAChB,chB1vDkB;EgB2vDlB,gBAAgB,EAAA;;AAGlB;EACE,eAAe;EACf,chBzyDuB;EgB0yDvB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBhBxwDuB;EgBywDvB,yBhB1wDiB;EgB2wDjB,qBAAqB;EACrB,cAAc;EACd,gBAAgB,EAAA;EAVlB;IAaI,qBAAqB;IACrB,0CAA0C,EAAA;;AAI9C;EACE,oBAAoB;EACpB,iBAAiB,EAAA;;AAGnB;EACE,WAAW;EACX,iBAAiB;EACjB,+HAKC;EACD,0BAA0B;EAC1B,8DAA8D,EAAA;;AAGhE;EACE,kBAAkB;EAClB,eAAe;EACf,chBhzDkB,EAAA;;AgBmzDpB;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB,EAAA;;AAGrB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB,EAAA;;AAGtB;EACE,UAAU;EACV,cAAc;EACd,mBAAmB,EAAA;;AAGrB;EACE,OAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,QAAQ,EAAA;;AAGV;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,sBAAsB,EAAA;;AAGxB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB,EAAA;;AAGnB;EACE,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB,EAAA;;AAGpB;EACE,oCAAoC;EACpC,cAAc,EAAA;;AAGhB;EACE,kCAAkC;EAClC,cAAc,EAAA;;AAGhB;EACE,mCAAmC;EACnC,cAAc,EAAA;;AAGhB;EACE,qCAAqC;EACrC,cAAc,EAAA;;AAGhB;EACE,mCAAmC;EACnC,cAAc,EAAA;;AAGhB;EACE,eAAe;EACf,cAAc,EAAA;;AAGhB;EACE,eAAe;EACf,cAAc,EAAA;;AAGhB;EACE,eAAe;EACf,cAAc,EAAA;;AAGhB;EACE,eAAe;EACf,cAAc,EAAA;;AAGhB;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,eAAe,EAAA;;AAGjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc,EAAA;;AAGhB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB,EAAA;EAEnB;IACE,qBAAqB,EAAA;;AAIzB;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB,EAAA;;AAGlB;EACE,eAAe;EACf,cAAc;EACd,kBAAkB,EAAA;;ACzgEpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,sBAAsB;EAmDtB,0EAAA;EA2BA,0FAAA,EAA2F;EAnF7F;IAQI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB,EAAA;IAZrB;MAeM,mBjBeqB;MiBdrB,aAAa;MACb,qBAAqB,EAAA;EAjB3B;IAsBI,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe,EAAA;EA5BnB;IAgCI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB,EAAA;EAnCvB;IAuCI,QAAQ,EAAA;IAvCZ;MA0CM,WAAW;MACX,YAAY,EAAA;IA3ClB;MA+CM,WAAW;MACX,YAAY,EAAA;EAhDlB;IAqDI,QAAQ,EAAA;EArDZ;IA0DI,wBAAwB;IACxB,SAAS;IACT,6BAA6B;IAC7B,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IAMf,oCAAA,EAAqC;IA1EzC;MAuEM,eAAe,EAAA;IAvErB;MA6EM,cjBjDmB;MiBkDnB,qBjB9CQ;MiB+CR,yBjBhDe,EAAA;EiB/BrB;IAqFI,kBAAkB;IAClB,kBAAkB;IAClB,qDAAqD,EAAA;IAvFzD;MA0FM,WAAW;MACX,kBAAkB;MAClB,QAAQ;MACR,sBAAsB;MACtB,UAAU;MACV,oBAAoB;MACpB,UAAU;MACV,8BAA8B,EAAA;IAjGpC;MAuGQ,yBAA6B,EAAA;IAvGrC;MA6GM,aAAa,EAAA;IA7GnB;MAiHM,kBAAkB;MAClB,UAAU,EAAA;EAlHhB;IAuHI,YAAY;IACZ,kBAAkB,EAAA;IAxHtB;;MA4HM,cAAc,EAAA;;AC/HpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc,EAAA;;AAGhB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,aAAa;EACb,cAAc,EAAA;EAEd;IACE,eAAe,EAAA;EAhBnB;IAsBM,UAAU;IACV,mBAAmB;IACnB,wBAAwB,EAAA;;AAK9B;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,sHAKC;EACD,yDAAyD;EACzD,oBAAoB,EAAA;;AAGtB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,clBjBkB;EkBkBlB,+BAA+B,EAAA;;AAGjC;EACE,8DAA8D,EAAA;;AAGhE;EACE,eAAe;EACf,gBAAgB;EAChB,clBlCyB,EAAA;;AkBqC3B;EACE,kBAAkB;EAClB,OAAO;EACP,qBAAqB;EACrB,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBlBPmB;EkBQnB,mBlBJkB;EkBKlB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,gClB1DuB;EkB2DvB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,2EAGsB;EACtB,yEAE+B,EAAA;;AAGjC;EACE;;;IAGE,mBAAmB,EAAA;EAGrB;IACE,sBAAsB,EAAA;EAGxB;IACE,mBAAmB,EAAA;EAGrB;IACE,sBAAsB,EAAA,EAAA;;AAI1B;EACE;;;IAGE,aAAa;IACb,sBAAsB,EAAA;EAGxB;IACE,aAAa;IACb,sBAAsB,EAAA;EAGxB;IACE,YAAY;IACZ,sBAAsB,EAAA;EAGxB;IACE,YAAY;IACZ,sBAAsB,EAAA,EAAA;;AC9I1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc,EAAA;;AAId;EACE,sBAAoB,EAAA;;AADtB;EACE,wBAAoB,EAAA;;AADtB;EACE,wBAAoB,EAAA;;AADtB;EACE,wBAAoB,EAAA;;AADtB;EACE,wBAAoB,EAAA;;AADtB;EACE,wBAAoB,EAAA;;AADtB;EACE,wBAAoB,EAAA;;AADtB;EACE,wBAAoB,EAAA;;AADtB;EACE,wBAAoB,EAAA;;AADtB;EACE,wBAAoB,EAAA;;AADtB;EACE,sBAAoB,EAAA;;AAIxB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,oCAAoC,EAAA;EAEpC;IACE,eAAe,EAAA;EAjBnB;IAuBM,UAAU;IACV,mBAAmB;IACnB,wBAAwB,EAAA;;AZ+lB3B;EYzlBD,cnB6BmB,EAAA;;AOskBlB;EY/lBD,cnB0CoB,EAAA;;AO+jBnB;EYrmBD,cnB0CkB,EAAA;;AmBvCpB;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,yHAKC;EACD,oBAAoB,EAAA;;AAGtB;EAEI,YAAY,EAAA;;AAIhB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,+BAA+B,EAAA;;AAGjC;EACE,qDAAqD,EAAA;;AAGvD;EACE,qDAAsD,EAAA;;AAGxD;EACE,qDAAoD,EAAA;;AAGtD;EACE,YAAY,EAAA;;AAGd;EACE,eAAe;EACf,gBAAgB;EAChB,cnBrEyB,EAAA;;AmBwE3B;EACE,kBAAkB;EAClB,OAAO;EACP,qBAAqB;EACrB,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBnB1CmB;EmB2CnB,mBnBvCkB;EmBwClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,gCnB7FuB;EmB8FvB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,2EAGsB;EACtB,yEAE+B,EAAA;;AAGjC;;EAEE,0DAA0D,EAAA;;AAG5D;;EAEE,4DAA4D,EAAA;;AAG9D;;EAEE,UAAU;EACV,yDAAyD,EAAA;;AAG3D;EACE;;IAEE,0BAA0B,EAAA,EAC3B;;AAGH;EACE;;IAEE,mBAAmB,EAAA;EAGrB;IACE,sBAAsB,EAAA,EAAA;;AAI1B;EACE;;IAEE,gCAAgC;IAChC,qDAAoD,EAAA;EAGtD;IACE,kCAAkC;IAClC,sDAA0D,EAAA,EAAA;;AAI9D;EACE;;IAEE,aAAa;IACb,sBAAsB,EAAA;EAGxB;IACE,aAAa;IACb,sBAAsB,EAAA,EAAA;;AnB9L1B;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AoBv8BA;;EAEE,aAAa;EACb,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;EACE,WAAW;EACX,eAAe,EAAA;;ACXjB;EACE,oBAAoB,EAAA;;AAItB;EAEE,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,2BrB4FsC;EqB3FtC,mFAEgC,EAAA;EARlC;IAYI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,SAAS;IACT,UAAU;IACV,8BrBYU;IqBXV,+BrBWU;IqBVV,kBAAkB;IAClB,oBAAoB;IACpB,UAAU,EAAA;EAtBd;IA0BI,kBAAkB;IAClB,UAAU,EAAA;;AAKd;EACE,kBAAkB,EAAA;EADpB;IAII,UAAU,EAAA;;AAKd;EACE,kBAAkB;EAClB,2BrBmDoC,EAAA;EqBrDtC;IAKI,UAAU,EAAA;EALd;IAWI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,oBAAoB;IACpB,sBAAsB;IACtB,UAAU;IACV,sBAAsB;IACtB,owIAmH0E,EAAA;EAtI9E;IA0II,kBAAkB;IAClB,2BAA2B;IAC3B,8BAA8B;IAC9B,UAAU;IACV,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;IACV,gHAKC;IACD,6CrB1KgB;IqB2KhB,6BAA6B;IAC7B,+BAA+B,EAAA;IA3JnC;MA8JM,wFAAwF,EAAA;IA9J9F;MAkKM,iBAAc;MACd,kBAAe;MACf,sBAAgB;MAChB,mBAAa;MACb,kBAAa;MACb,yBAAmB,EAAA;IAvKzB;MA2KM,kBAAc;MACd,mBAAe;MACf,sBAAgB;MAChB,mBAAa;MACb,mBAAa;MACb,wBAAmB,EAAA;IAhLzB;MAoLM,iBAAc;MACd,mBAAe;MACf,sBAAgB;MAChB,mBAAa;MACb,mBAAa;MACb,yBAAmB,EAAA;IAzLzB;MA6LM,kBAAc;MACd,kBAAe;MACf,sBAAgB;MAChB,mBAAa;MACb,kBAAa;MACb,yBAAmB,EAAA;IAlMzB;MAsMM,kBAAc;MACd,mBAAe;MACf,sBAAgB;MAChB,mBAAa;MACb,mBAAa;MACb,wBAAmB,EAAA;IA3MzB;MA+MM,kBAAc;MACd,mBAAe;MACf,sBAAgB;MAChB,mBAAa;MACb,mBAAa;MACb,yBAAmB,EAAA;IApNzB;MAwNM,iBAAc;MACd,mBAAe;MACf,sBAAgB;MAChB,mBAAa;MACb,mBAAa;MACb,yBAAmB,EAAA;IA7NzB;MAiOM,kBAAc;MACd,mBAAe;MACf,sBAAgB;MAChB,kBAAa;MACb,mBAAa;MACb,yBAAmB,EAAA;;AAIvB;EACE;IACE,UAAU;IACV,8DAA8D,EAAA;EAGhE;IACE,UAAU,EAAA;EAGZ;IACE,aAAa,EAAA;EAGf;IACE,UAAU;IACV,4GACqC,EAAA,EAAA;EAIzC;IA/PF;MAiQM,aAAa,EAAA,EACd;EAlQL;IAsQI,gCrBpRgB,EAAA;;AqByRpB;EAEI,mEAAmE,EAAA;;AAFvE;EAMI,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,sBAAsB;EACtB,+BAA+B;EAC/B,8iBA8BG;EACH,mEAAmE,EAAA;;AAKvE;EACE;;IAEE,4DAA4D,EAAA;EAG9D;IACE,oFAAoF,EAAA;EAGtF;IACE,qFAAqF,EAAA;EAGvF;IACE,iFAAiF,EAAA;EAGnF;IACE,iFAAiF,EAAA;EAGnF;IACE,mFAAmF,EAAA,EAAA;;AAKvF;EACE;;IAEE,oEAAoE;IACpE,aAAa,EAAA;EAGf;IACE,mFAAmF;IACnF,aAAa,EAAA;EAGf;IACE,mFAAmF;IACnF,YAAY,EAAA;EAGd;IACE,iFAAiF;IACjF,aAAa,EAAA;EAGf;IACE,qFAAqF;IACrF,aAAa,EAAA,EAAA;;AAIjB;EACE;;IAEE,eAAe,EAAA;EA3GnB;IA+GI,aAAa,EAAA,EACd;;AAGH;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,crBjZkB;EqBkZlB,eAAe,EAAA;;AAGjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAA;;AAGX;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,UAAU,EAAA;EATZ;IAYI,cAAc;IACd,mBrB9auB;IqB+avB,aAAa,EAAA;;AAIjB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBrBpZkB;EqBqZlB,sBAAsB;EACtB,UAAU;EACV,oBAAoB,EAAA;;AAGtB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,oBAAoB,EAAA;;AAGtB;EACE,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB,EAAA;;AAGpB;EACE,gBAAgB;EAChB,eAAe;EACf,crBlekB;EqBmelB,iBAAiB;EACjB,sBAAsB,EAAA;;AAGxB;EACE,eAAe;EACf,crBreyB;EqBsezB,eAAe,EAAA;;AAGjB;EACE,eAAe;EACf,QAAQ;EACR,wBAAwB;EACxB,kBAAkB;EAClB,6BAA6B,EAAA;EAL/B;IAQI,sCrBzciB;IqB0cjB,oCrB1ciB;IqB2cjB,crB3ciB,EAAA;IqBicrB;MAaM,crB9ce,EAAA;EqBicrB;IAkBI,sCrBlckB;IqBmclB,oCrBnckB;IqBoclB,crBpckB,EAAA;IqBgbtB;MAuBM,crBvcgB,EAAA;EqBgbtB;IA4BI,qCrBxcgB;IqBychB,oCrBzcgB;IqB0chB,crB1cgB,EAAA;IqB4apB;MAiCM,crB5coB,EAAA;EqB2a1B;IAsCI,uCrB/gBuB;IqBghBvB,oCrBhhBuB;IqBihBvB,crBjhBuB,EAAA;IqBye3B;MA2CM,crBphBqB,EAAA;EqBye3B;IAgDI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB,EAAA;EAnDpB;IAwDI,UAAU,EAAA;EAxDd;IA4DI,SAAS;IACT,wBAAwB;IACxB,0BAA0B,EAAA;EA9D9B;;IAoEM,wBAAwB,EAAA;;AAK9B;EACE,eAAe;EACf,crBpjByB,EAAA;EqBkjB3B;IAKI,crBjjBgB,EAAA;;AqBqjBpB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ,EAAA;;AAGV;EACE,SAAS;EACT,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB,EAAA;EAJnB;IAOI,crBjiBgB,EAAA;;AqBqiBpB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB,EAAA;;AAGnB;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB,EAAA;EALlB;IAQI,gBAAgB;IAChB,crBpmBuB,EAAA;;AqBwmB3B;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,crB5kBkB;EqB6kBlB,yCrB7kBkB;EqB8kBlB,oCrB7kBmB,EAAA;;AqBglBrB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc,EAAA;;AAGhB;EACE,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,crB5oBuB;EqB6oBvB,yCrBpoBU;EqBqoBV,kCrBnoBgB,EAAA;;AsBrClB;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,oBAAoB;EACpB,sBAAsB,EAAA;;AAGxB;EACE,WAAW;EACX,gBAAgB,EAAA;;AAGlB;EACE,WAAW;EACX,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB,EAAA;;AAGtB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,oBAAoB,EAAA;;AAGtB;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB,EAAA;;AAGtB;EACE,UAAU,EAAA;;AAGZ;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB,EAAA;;AAGtB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,oBAAoB,EAAA;;AAItB;EACE,UAAU,EAAA;;AAGZ;EACE,UAAU,EAAA;;AAGZ;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB,EAAA;;AAOtB;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB,EAAA;EAEhB;IACE,aAAa;IACb,UAAU,EAAA;EAGZ;IACE,aAAa;IACb,UAAU,EAAA;;AAId;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,oCAAoC;EACpC,iCAAiC;EACjC,mCAAmC,EAAA;;AAGrC;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAEhB,yFAIC;EACD,gBAAgB;EAChB,oCAAoC;EACpC,iCAAiC;EACjC,mCAAmC,EAAA;;AAGrC;EACE,UAAU;EACV,WAAW;EACX,yFAIC,EAAA;;AAUD;EACE,QAAM;EACN,YAAQ;EACR,YAAQ;EACR,oBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,oBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,QAAM;EACN,YAAQ;EACR,YAAQ;EACR,qBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,qBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,qBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,qBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,QAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,QAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,QAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,QAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,QAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,qBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,qBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,qBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,qBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,qBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,qBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,QAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,QAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,QAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,QAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,qBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,qBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,qBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,qBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,qBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,qBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,qBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,qBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,QAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,QAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AAYxB;EACE,QAAM;EACN,YAAQ;EACR,YAAQ;EACR,qBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,qBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,QAAM;EACN,YAAQ;EACR,YAAQ;EACR,qBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,qBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,qBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,qBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,QAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,QAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,QAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,QAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,uBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,uBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,uBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,uBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,uBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,uBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,uBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,uBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,qBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,qBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,qBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,qBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,qBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,qBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,QAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,QAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,QAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AATxB;EACE,SAAM;EACN,YAAQ;EACR,YAAQ;EACR,sBAAiB;EACjB,yBAAoB,EAAA;EALtB;IAQI,sBAAiB;IACjB,yBAAoB,EAAA;;AAK1B;EACE;IACE,wBAAwB,EAAA;EAE1B;IACE,4BAA4B,EAAA;EAE9B;IACE,4BAA4B,EAAA,EAAA;;AAIhC;EACE;;IAEE,UAAU,EAAA;EAEZ;;IAEE,UAAU,EAAA,EAAA;;AAQd;EACE,UAAU,EAAA;;AAGZ;EACE,UAAU,EAAA;;AAGZ;EACE,UAAU,EAAA;;AAGZ;EACE,UAAU;EACV,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB,EAAA;;AAGtB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,UAAU,EAAA;EANZ;IASI,UAAU,EAAA;;AAId;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,UAAU,EAAA;EANZ;IASI,UAAU,EAAA;;AAId;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,oBAAoB,EAAA;;AAOtB;EACE,MAAM;EACN,YAAY;EACZ,UAAU;EACV,gBAAgB,EAAA;;AAKhB;EACE,WAAQ,EAAA;;AADV;EACE,WAAQ,EAAA;;AADV;EACE,WAAQ,EAAA;;AADV;EACE,WAAQ,EAAA;;AADV;EACE,WAAQ,EAAA;;AADV;EACE,WAAQ,EAAA;;AADV;EACE,WAAQ,EAAA;;AADV;EACE,WAAQ,EAAA;;AADV;EACE,WAAQ,EAAA;;AADV;EACE,WAAQ,EAAA;;AADV;EACE,WAAQ,EAAA;;AADV;EACE,WAAQ,EAAA;;AADV;EACE,WAAQ,EAAA;;AADV;EACE,WAAQ,EAAA;;AADV;EACE,WAAQ,EAAA;;AADV;EACE,YAAQ,EAAA;;AAIZ;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB,EAAA;;AAQtB;EACE,UAAU;EACV,gBAAgB;EAChB,aAAa,EAAA;;AAKb;EACE,aAAa,EAAA;;AADf;EACE,cAAa,EAAA;;AADf;EACE,aAAa,EAAA;;AADf;EACE,cAAa,EAAA;;AADf;EACE,YAAa,EAAA;;AADf;EACE,cAAa,EAAA;;AADf;EACE,aAAa,EAAA;;AADf;EACE,cAAa,EAAA;;AADf;EACE,aAAa,EAAA;;AADf;EACE,cAAa,EAAA;;AADf;EACE,aAAa,EAAA;;AAIjB;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,uBAAuB,EAAA;;AAQvB;EACE,yBAAyB,EAAA;;AAD3B;EACE,yBAAyB,EAAA;;AAD3B;EACE,yBAAyB,EAAA;;AAD3B;EACE,yBAAyB,EAAA;;AAD3B;EACE,wBAAyB,EAAA;;AAD3B;EACE,uBAAyB,EAAA;;AAD3B;EACE,uBAAyB,EAAA;;AAD3B;EACE,wBAAyB,EAAA;;AAD3B;EACE,wBAAyB,EAAA;;AAD3B;EACE,wBAAyB,EAAA;;AAD3B;EACE,wBAAyB,EAAA;;AAI7B;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,4BAA4B;EAC5B,8DAA8D;EAC9D,eAAe,EAAA;;AAGjB;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB,4BAA4B;EAC5B,oBAAoB;EAEpB,0RAGyF;EACzF,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;EACb,eAAe,EAAA;;AAGjB;EACE,yRAGyF,EAAA;;AAG3F;EACE,yRAGyF,EAAA;;AAG3F;EACE,yRAGyF,EAAA;;AAG3F;EACE,0RAGyF,EAAA;;AAG3F;EACE,wRAGyF,EAAA;;AAG3F;EACE,yRAGyF,EAAA;;AAczF;EACE,YAAO;EACP,aAAQ;EACR,kBAAa;EACb,iBAAY;EACZ,qGAMe;EACf,aAAa;EACb,mBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,4GAMe;EACf,aAAa;EACb,uBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,wGAMe;EACf,YAAa;EACb,uBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,yGAMe;EACf,aAAa;EACb,uBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,wGAMe;EACf,aAAa;EACb,uBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,yGAMe;EACf,aAAa;EACb,uBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,kBAAa;EACb,iBAAY;EACZ,qGAMe;EACf,aAAa;EACb,uBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,wGAMe;EACf,YAAa;EACb,uBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,uGAMe;EACf,aAAa;EACb,uBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,yGAMe;EACf,aAAa;EACb,uBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,2GAMe;EACf,aAAa;EACb,sBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,uGAMe;EACf,aAAa;EACb,uBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,kBAAa;EACb,iBAAY;EACZ,6GAMe;EACf,YAAa;EACb,uBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,0GAMe;EACf,aAAa;EACb,uBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,2GAMe;EACf,aAAa;EACb,uBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,yGAMe;EACf,aAAa;EACb,uBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,2GAMe;EACf,aAAa;EACb,uBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,wGAMe;EACf,YAAa;EACb,uBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,kBAAa;EACb,iBAAY;EACZ,yGAMe;EACf,aAAa;EACb,uBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,2GAMe;EACf,aAAa;EACb,uBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,0GAMe;EACf,aAAa;EACb,sBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,4GAMe;EACf,aAAa;EACb,uBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,0GAMe;EACf,YAAa;EACb,uBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,4GAMe;EACf,aAAa;EACb,uBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,kBAAa;EACb,iBAAY;EACZ,0GAMe;EACf,aAAa;EACb,uBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,2GAMe;EACf,aAAa;EACb,uBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,yGAMe;EACf,aAAa;EACb,uBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,yGAMe;EACf,YAAa;EACb,uBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,0GAMe;EACf,aAAa;EACb,wBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,yGAMe;EACf,aAAa;EACb,wBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,kBAAa;EACb,iBAAY;EACZ,2GAMe;EACf,aAAa;EACb,uBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,wGAMe;EACf,aAAa;EACb,wBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,2GAMe;EACf,YAAa;EACb,wBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,0GAMe;EACf,aAAa;EACb,wBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,4GAMe;EACf,aAAa;EACb,wBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,yGAMe;EACf,aAAa;EACb,wBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,kBAAa;EACb,iBAAY;EACZ,0GAMe;EACf,aAAa;EACb,wBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,2GAMe;EACf,YAAa;EACb,wBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,yGAMe;EACf,aAAa;EACb,wBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,2GAMe;EACf,aAAa;EACb,wBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,wGAMe;EACf,aAAa;EACb,uBAAiB,EAAA;;AAbnB;EACE,YAAO;EACP,aAAQ;EACR,mBAAa;EACb,iBAAY;EACZ,yGAMe;EACf,aAAa;EACb,wBAAiB,EAAA;;AAIrB;EACE;;IAEE,qCAAqC,EAAA;EAGvC;IACE,qCAAqC,EAAA,EAAA;;AAIzC;EACE;;IAEE,kDAAkD,EAAA;EAGpD;IACE,mDAAmD,EAAA;EAGrD;IACE,oDAAoD,EAAA,EAAA;;AActD;EACE;;IAEE,qFAIwB,EAAA;EAG1B;IACE,kGAIuB,EAAA;EAGzB;IACE,sFAIwB,EAAA;EAG1B;IACE,mGAIiB,EAAA,EAAA;;AAIrB;EACE,iEAA8F,EAAA;;AAQ9F;EACE,+DAAsE,EAAA;;AA7C1E;EACE;;IAEE,sFAIwB,EAAA;EAG1B;IACE,iGAIuB,EAAA;EAGzB;IACE,sFAIwB,EAAA;EAG1B;IACE,iGAIiB,EAAA,EAAA;;AAIrB;EACE,iEAA8F,EAAA;;AAQ9F;EACE,+DAAsE,EAAA;;AA7C1E;EACE;;IAEE,sFAIwB,EAAA;EAG1B;IACE,iGAIuB,EAAA;EAGzB;IACE,sFAIwB,EAAA;EAG1B;IACE,mGAIiB,EAAA,EAAA;;AAIrB;EACE,iEAA8F,EAAA;;AAQ9F;EACE,+DAAsE,EAAA;;AA7C1E;EACE;;IAEE,wFAIwB,EAAA;EAG1B;IACE,kGAIuB,EAAA;EAGzB;IACE,uFAIwB,EAAA;EAG1B;IACE,+FAIiB,EAAA,EAAA;;AAIrB;EACE,iEAA8F,EAAA;;AAQ9F;EACE,+DAAsE,EAAA;;AA7C1E;EACE;;IAEE,qFAIwB,EAAA;EAG1B;IACE,kGAIuB,EAAA;EAGzB;IACE,qFAIwB,EAAA;EAG1B;IACE,mGAIiB,EAAA,EAAA;;AAIrB;EACE,+DAA8F,EAAA;;AAQ9F;EACE,+DAAsE,EAAA;;AA7C1E;EACE;;IAEE,wFAIwB,EAAA;EAG1B;IACE,kGAIuB,EAAA;EAGzB;IACE,uFAIwB,EAAA;EAG1B;IACE,iGAIiB,EAAA,EAAA;;AAIrB;EACE,iEAA8F,EAAA;;AAQ9F;EACE,8DAAsE,EAAA;;AA7C1E;EACE;;IAEE,mFAIwB,EAAA;EAG1B;IACE,iGAIuB,EAAA;EAGzB;IACE,sFAIwB,EAAA;EAG1B;IACE,oGAIiB,EAAA,EAAA;;AAIrB;EACE,iEAA8F,EAAA;;AAI9F;EACE,qEAA6E,EAAA;;AAzCjF;EACE;;IAEE,wFAIwB,EAAA;EAG1B;IACE,kGAIuB,EAAA;EAGzB;IACE,uFAIwB,EAAA;EAG1B;IACE,kGAIiB,EAAA,EAAA;;AAIrB;EACE,iEAA8F,EAAA;;AAI9F;EACE,qEAA6E,EAAA;;AAzCjF;EACE;;IAEE,uFAIwB,EAAA;EAG1B;IACE,kGAIuB,EAAA;EAGzB;IACE,uFAIwB,EAAA;EAG1B;IACE,kGAIiB,EAAA,EAAA;;AAIrB;EACE,iEAA8F,EAAA;;AAI9F;EACE,qEAA6E,EAAA;;AAzCjF;EACE;;IAEE,sFAIwB,EAAA;EAG1B;IACE,mGAIuB,EAAA;EAGzB;IACE,qFAIwB,EAAA;EAG1B;IACE,kGAIiB,EAAA,EAAA;;AAIrB;EACE,gEAA8F,EAAA;;AAI9F;EACE,mEAA6E,EAAA;;AASnF;EACE;;IAEE,0BAA0B;IAC1B,UAAU,EAAA;EAGZ;;;;;;IAME,aAAa,EAAA;EAGf;;IAEE,0BAA0B,EAAA,EAC3B;;ACrhBH,8BAAA;AvBGA;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AuBr8BA;EACE,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB,EAAA;;AAGrB,oBAAA;AACA;EACE,YAAY;EACZ,aAAa;EACb,qDAAqD,EAAA;;AAGvD,2DAAA;AACA;EACE,gEAAgE,EAAA;;AAGlE;EACE;IACE,4BAA4B,EAAA;EAE9B;IACE,wBAAwB,EAAA,EAAA;;AAI5B;EACE;IACE,wBAAwB,EAAA;EAE1B;IACE,4BAA4B,EAAA,EAAA;;Ab6Y5B;EaxYF,+BAA+B,EAAA;;AAGjC;EACE,4BAA4B,EAAA;;AAG9B;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,+BAA+B;EAC/B,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gCvB/BkB,EAAA;;AuBkCpB;EACE,8BAA8B;EAC9B,cAAc,EAAA;EvB4yBZ;IACI,UAvQa,EAAA;EA0QjB;IACI,mBA1QuB;IA2QvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBAAyB;IACzB,kBAAkB,EAAA;IAElB;MACI,yBAAsC,EAAA;;AuBvzBlD;EACE,eAAe;EACf,aAAa;EACb,aAAa,EAAA;;AAGf;EACE,eAAe;EACf,aAAa,EAAA;;AAGf;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAInB;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,eAAe,EAAA;;AAIjB;EACE,iBAAiB;EACjB,eAAe,EAAA;;AAGjB;EACE,WAAW;EACX,YAAY;EACZ,YAAY,EAAA;;AAId;EACE,UAAU,EAAA;;AAGZ,kCAAA;AACA;EACE,yBAAyB,EAAA;;AAjD3B;EAsDE,gBAAgB,EAAA;EADlB;IAII,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB,EAAA;EAT1B;IAaI,eAAe;IACf,mBAAmB;IACnB,cvB7GqB;IuB8GrB,0BAA0B;IAC1B,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB,EAAA;EAnBrB;IAuBI,eAAe;IACf,mBAAmB;IACnB,cvBvHqB;IuBwHrB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe,EAAA;EA9BnB;IAkCI,eAAe;IACf,iBAAiB;IACjB,cvBjIgB;IuBkIhB,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe,EAAA;EA1CnB;IA8CI,eAAe;IACf,gBAAgB;IAChB,cvB7IgB;IuB8IhB,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe,EAAA;EAtDnB;IA0DI,eAAe;IACf,gBAAgB;IAChB,cvBzJgB;IuB0JhB,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe,EAAA;;AvB5LnB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AwBt8BA;EACI,WAAW,EAAA;EADf;IAIQ,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,SAAS;IACT,aAAa,EAAA;EARrB;IAcQ,aAAa;IACb,0CAA0C;IAC1C,kBAAkB;IAClB,wBAAwB;IACxB,SAAS;IACT,gBAAgB,EAAA;IAnBxB;MAsBY,aAAa;MACb,sBAAsB;MACtB,YAAY;MACZ,QAAQ,EAAA;MAzBpB;QA4BgB,YAAY,EAAA;MA5B5B;QAgCgB,aAAa;QACb,kBAAkB;QAClB,eAAgB,EAAA;QAlChC;;;UA0C0B,yBxBbN,EAAA;QwB7BpB;UA8C0B,yBxBjBN;UwBkBM,cxBnBD;UwBoBC,mBAAmB;UACnB,UAAU,EAAA;QAjDpC;UAuDoB,aAAa;UACb,mBAAmB;UACnB,mBAAmB,EAAA;QAzDvC;;UA+DoB,6BAA6B;UAC7B,kBAAkB,EAAA;QAhEtC;UAoEoB,qBxBhCA,EAAA;QwBpCpB;;UA0EoB,6BAA6B,EAAA;QA1EjD;;UA+EoB,wCAAwC,EAAA;QA/E5D;UAmFoB,gCAAoC,EAAA;QAnFxD;UAuFoB,kBAAkB;UAClB,cAAc;UACd,cxB7DK;UwB8DL,cAAc;UACd,mBAAmB;UACnB,QAAQ,EAAA;QA5F5B;UAgGoB,YAAY,EAAA;QAhGhC;UAoGoB,YAAY;UACZ,eAAe;UACf,wBAAwB;UACxB,6BAA6B;UAC7B,kBAAkB,EAAA;UAxGtC;YA2GwB,wBAAwB;YACxB,eAAe;YACf,YAAY;YACZ,cxBlFC;YwBmFD,yBAAyB;YACzB,yBxBhFV;YwBiFU,6BAA6B;YAC7B,kBAAkB,EAAA;UAlH1C;YAsHwB,YAAY,EAAA;UAtHpC;YA0HwB,WAAW,EAAA;QA1HnC;UAiIoB,wBAAwB;UACxB,eAAe;UACf,YAAY;UACZ,cxBxGK;UwByGL,yBAAyB;UACzB,yBxB1GK;UwB2GL,kBAAkB,EAAA;QAvItC;UA2IoB,cxBzGI;UwB0GJ,yBxBhHK;UwBiHL,yBxB3GI;UwB4GJ,kBAAkB;UAClB,eAAe;UACf,aAAa;UACb,YAAY;UACZ,gBAAgB,EAAA;UxBqnBhC;YACI,UAjKa,EAAA;UAoKjB;YACI,mBApKuB;YAqKvB,kBAAkB;YAClB,kBAAkB,EAAA;UAGtB;YACI,yBA3uBU;YA4uBV,kBAAkB,EAAA;YAElB;cACI,yBAAqD,EAAA;UwBtxBjE;YAsJwB,YAAY,EAAA;UAtJpC;YA0JwB,YAAY,EAAA;YxB6mBhC;cACI,UAjKa,EAAA;YAoKjB;cACI,mBApKuB;cAqKvB,kBAAkB;cAClB,kBAAkB,EAAA;YAGtB;cACI,yBA3uBU;cA4uBV,kBAAkB,EAAA;cAElB;gBACI,yBAAqD,EAAA;MwBtxBjE;QAmKgB,cxBjIQ;QwBkIR,yBxBxIS;QwByIT,yBxBnIQ;QwBoIR,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,aAAa;QACb,gBAAgB,EAAA;QxB6lB5B;UACI,UAjKa,EAAA;QAoKjB;UACI,mBApKuB;UAqKvB,kBAAkB;UAClB,kBAAkB,EAAA;QAGtB;UACI,yBA3uBU;UA4uBV,kBAAkB,EAAA;UAElB;YACI,yBAAqD,EAAA;QwBtxBjE;UA8KoB,YAAY,EAAA;UxBylB5B;YACI,UAjKa,EAAA;UAoKjB;YACI,mBApKuB;YAqKvB,kBAAkB;YAClB,kBAAkB,EAAA;UAGtB;YACI,yBA3uBU;YA4uBV,kBAAkB,EAAA;YAElB;cACI,yBAAqD,EAAA;MwBtxBjE;QAoLgB,YAAY;QACZ,mBAAmB,EAAA;EArLnC;IA4LY,kBAAkB,EAAA;IA5L9B;MA+LgB,WAAW,EAAA;IA/L3B;MAkMgB,WAAW;MACX,aAAa;MACb,YAAY,EAAA;;AAO5B,+DAAA;AACA;;;EAIQ,WAAW,EAAA;;AAJnB;;;EAQQ,gBAAgB;EAChB,YAAY,EAAA;;AATpB;;;EAaQ,cAAc;EACd,eAAe,EAAA;;AAdvB;;;;;;;;;EAoBQ,eAAe,EAAA;;AApBvB;;;EAwBQ,YAAY,EAAA;;AAxBpB;;;EA4BQ,iBAAiB,EAAA;;AA5BzB;;;EAgCQ,cxBxMY;EwByMZ,eAAe;EACf,gBAAgB,EAAA;;AAlCxB;;;EAsCQ,cxBtNiB;EwBuNjB,eAAe;EACf,iBAAiB,EAAA;;AAIzB;EACI,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB,EAAA;EALrB;IAQQ,cAAc;IACd,YAAY,EAAA;EATpB;IAaQ,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,yBAAyB,EAAA;;AAIjC,uEAAA;AACA;EACI,WAAW;EACX,mBAAmB,EAAA;;AAGvB;EACI,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBxB3PiB,EAAA;;AwB8PrB;EACI,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,YAAY;EAEZ,mBxBxQU;EwByQV,cxB7QqB;EwB8QrB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,0EAA0E,EAAA;EAhB9E;IAmBQ,aAAa;IACb,mBAAmB,EAAA;EApB3B;IAwBQ,mBxBtRa,EAAA;EwB8PrB;IA6BY,aAAa,EAAA;EA7BzB;IAiCY,YAAY,EAAA;;AAKxB;EACI,+BxBrSiB,EAAA;;AwBwSrB;EACI,mBxBvSe;EwBwSf,mCAAmC;EACnC,8BAA8B,EAAA;EAHlC;IAMQ,cAAc,EAAA;EANtB;IAUQ,UAAU,EAAA;;AAIlB;EACI,mBxBrTe;EwBsTf,mCxBnSW;EwBoSX,8BAA8B,EAAA;EAHlC;IAMQ,cxBvSO,EAAA;EwBiSf;IAUQ,UAAU,EAAA;;AAIlB;EACI,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY,EAAA;;AAGhB;EACI,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB,EAAA;;AAGvB;EACI,wBAAwB,EAAA;;AAG5B;EACI,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB,EAAA;;AAGvB;EACI,WAAW,EAAA;;AAGf;EACI,aAAa;EACb,wBAAwB;EACxB,kBAAkB,EAAA;;AAOtB;EACI,aAAa;EACb,mBAAmB;EACnB,iBAAiB,EAAA;;AAGrB;EACI,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB,EAAA;EANvB;IASQ,SAAS;IACT,gBAAgB;IAChB,iBAAiB,EAAA;EAXzB;IAeQ,SAAS;IACT,gBAAgB;IAChB,iBAAiB,EAAA;EAjBzB;IAqBQ,SAAS;IACT,gBAAgB;IAChB,iBAAiB,EAAA;EAvBzB;IA6BY,iBAAiB,EAAA;EA7B7B;IAkCQ,WAAW;IACX,iBAAiB,EAAA;EAnCzB;IAuCQ,WAAW;IACX,YAAY;IACZ,iBAAiB;IAAE,iDAAA;IACnB,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IAAE,4BAAA;IACjB,gBAAgB;IAAE,+BAAA;IAClB,gBAAgB;IAAE,yCAAA;IAClB,yBAAyB;IAAE,uCAAA;IAC3B,qBAAqB;IAAE,oCAAA;IACvB,sBAAsB;IAAE,wDAAA,EAAyD;EAlDzF;IAuDQ,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB,EAAA;;AAIxB;EACI,aAAa;EACb,sBAAsB,EAAA;EAF1B;IAMQ,aAAa;IACb,mBAAmB;IACnB,SAAS,EAAA;EARjB;IAYQ,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB,EAAA;EAd/B;IAkBQ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,wBAAwB;IACxB,kBAAkB,EAAA;IAtB1B;MAyBY,YAAY,EAAA;IAzBxB;MA6BY,YAAY,EAAA;EA7BxB;IAkCQ,YAAY,EAAA;IAlCpB;MAqCY,YAAY;MACZ,iBAAiB,EAAA;EAtC7B;IA0CQ,kBAAkB;IAClB,YAAY,EAAA;EA3CpB;IA8CQ,kBAAkB,EAAA;EA9C1B;IAiDQ,WAAW;IACX,gBAAgB,EAAA;EAlDxB;IAsDQ,yBAAyB,EAAA;;AAIjC;;;EAIQ,aAAa;EACb,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,kBAAkB,EAAA;EAR1B;;;IAWY,YAAY;IACZ,YAAY;IACZ,kBAAkB,EAAA;EAb9B;;;IAiBY,WAAW,EAAA;;AAMvB;EACI,yBxBrdqB;EwBsdrB,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,eAAe;EACf,sBAAsB,EAAA;EAT1B;IAcQ,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,cAAc;IACd,cAAc;IACd,eAAe;IACf,sBAAsB,EAAA;IArB9B;MAwBY,aAAa;MACb,SAAS;MACT,oBAAoB;MACpB,oBAAoB,EAAA;MA3BhC;QA8BgB,aAAa;QACb,2BAA2B;QAC3B,uBAAuB;QACvB,iBAAiB;QACjB,SAAS;QACT,eAAe;QACf,iBAAiB,EAAA;QApCjC;UAuCoB,cAAc;UACd,gBAAgB;UAChB,gBAAgB;UAChB,UAAU;UACV,aAAa;UACb,sBAAsB;UACtB,SAAS,EAAA;UA7C7B;YAgDwB,gBAAgB;YAChB,iBAAiB;YACjB,mBAAmB;YAEnB,yBxBvjBJ;YwBwjBI,kBAAkB,EAAA;UArD1C;YAyDwB,mBAAmB;YxBwVzC,aAAa;YACb,WAAW;YACX,YAAY;YACZ,SAAS;YACT,eAAe,EAAA;YAEf;cACE,cAAc;cACd,kBAAkB,EAAA;YAGpB;cACE,kBAAkB;cAClB,YAlC6B;cAmC7B,UAAU;cACV,WAAW;cAEX,iBAAiB,EAAA;UAXnB;YwBzVsB,cxBjkBJ;YwBkkBI,cAAc;YACd,oBAAoB;YACpB,mBAAmB;YACnB,eAAe;YACf,iBAAiB,EAAA;UAnEzC;YAuEwB,yBxB1kBJ;YwB2kBI,kBAAkB;YAClB,YAAY;YACZ,qCAAqC;YACrC,WAAW;YACX,sBAAsB,EAAA;YA5E9C;cA+E4B,YAAY,EAAA;cA/ExC;gBAkFgC,YAAY,EAAA;YAlF5C;cAuF4B,aAAa;cACb,gBAAgB;cAChB,kBAAkB;cAClB,aAAa;cACb,sBAAsB;cACtB,SAAS,EAAA;cxB2IjC;gBACI,UAjKa,EAAA;cAoKjB;gBACI,mBApKuB;gBAqKvB,kBAAkB;gBAClB,kBAAkB,EAAA;cAGtB;gBACI,yBA3uBU;gBA4uBV,kBAAkB,EAAA;gBAElB;kBACI,yBAAqD,EAAA;YwBtPjE;cAiG4B,aAAa;cACb,oCAAoC;cACpC,QAAQ;cACR,gBAAgB;cAChB,mBAAmB;cACnB,kBAAkB;cAClB,eAAe,EAAA;cAvG3C;gBA0GgC,kBAAkB;gBAClB,yBxBlkBN,EAAA;YwBud1B;cAgH4B,iBAAiB;cACjB,cxBrnBH;cwBsnBG,aAAa;cACb,iBAAiB;cACjB,iBAAiB;cACjB,YAAY,EAAA;cArHxC;gBAwHgC,aAAa;gBACb,eAAe,EAAA;YAzH/C;cA8H4B,WAAW;cACX,sBAAsB,EAAA;YA/HlD;cAmI4B,YAAY;cACZ,aAAa;cACb,mBAAmB;cACnB,QAAQ;cACR,QAAQ,EAAA;MAvIpC;QA8IgB,cAAc;QACd,YAAY;QACZ,gBAAgB;QAChB,gBAAgB,EAAA;QAjJhC;UAoJoB,0BxBvpBA;UwBwpBA,kBAAkB;UAClB,aAAa;UACb,eAAe;UACf,cxB5pBK;UwB6pBL,aAAa,EAAA;EAzJjC;IAgKQ,oBAAoB;IACpB,aAAa,EAAA;EAjKrB;IAuKQ,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,cAAc;IACd,cAAc;IACd,eAAe;IACf,sBAAsB,EAAA;IA9K9B;MAiLY,aAAa;MACb,SAAS;MACT,oBAAoB;MACpB,oBAAoB,EAAA;MApLhC;QAuLgB,aAAa;QACb,2BAA2B;QAC3B,uBAAuB;QACvB,iBAAiB;QACjB,SAAS;QACT,eAAe;QACf,iBAAiB,EAAA;QA7LjC;UAgMoB,cAAc;UACd,gBAAgB;UAChB,gBAAgB;UAChB,UAAU;UACV,aAAa;UACb,sBAAsB;UACtB,SAAS,EAAA;UAtM7B;YAyMwB,gBAAgB;YAChB,iBAAiB;YACjB,UAAU;YACV,0CAA0C;YAC1C,kBAAkB,EAAA;UA7M1C;YxBiZE,aAAa;YACb,WAAW;YACX,YAAY;YACZ,SAAS;YACT,eAAe,EAAA;YAEf;cACE,cAAc;cACd,kBAAkB,EAAA;YAGpB;cACE,kBAAkB;cAClB,YAlC6B;cAmC7B,UAAU;cACV,WAAW;cAEX,iBAAiB,EAAA;UAXnB;YwBlMsB,cxBxtBJ;YwBytBI,cAAc;YACd,oBAAoB;YACpB,mBAAmB;YACnB,eAAe;YACf,iBAAiB,EAAA;UA1NzC;YA8NwB,0CAA0C;YAC1C,kBAAkB;YAClB,YAAY;YACZ,qCAAqC;YACrC,WAAW;YACX,sBAAsB,EAAA;YAnO9C;cAsO4B,YAAY,EAAA;cAtOxC;gBAyOgC,YAAY,EAAA;YAzO5C;cA8O4B,aAAa;cACb,gBAAgB;cAChB,kBAAkB;cAClB,aAAa;cACb,sBAAsB;cACtB,SAAS,EAAA;cxBZjC;gBACI,UAjKa,EAAA;cAoKjB;gBACI,mBApKuB;gBAqKvB,kBAAkB;gBAClB,kBAAkB,EAAA;cAGtB;gBACI,yBA3uBU;gBA4uBV,kBAAkB,EAAA;gBAElB;kBACI,yBAAqD,EAAA;YwBtPjE;cAwP4B,aAAa;cACb,oCAAoC;cACpC,QAAQ;cACR,gBAAgB;cAChB,mBAAmB;cACnB,kBAAkB;cAClB,eAAe,EAAA;cA9P3C;gBAiQgC,kBAAkB;gBAClB,yBxBztBN,EAAA;YwBud1B;cAuQ4B,iBAAiB;cACjB,cxB5wBH;cwB6wBG,aAAa;cACb,iBAAiB;cACjB,iBAAiB;cACjB,YAAY,EAAA;cA5QxC;gBA+QgC,aAAa;gBACb,eAAe,EAAA;YAhR/C;cAqR4B,WAAW;cACX,sBAAsB,EAAA;YAtRlD;cA0R4B,YAAY;cACZ,aAAa;cACb,mBAAmB;cACnB,QAAQ;cACR,QAAQ,EAAA;MA9RpC;QAqSgB,cAAc;QACd,YAAY;QACZ,gBAAgB;QAChB,gBAAgB,EAAA;QAxShC;UA2SoB,0BxB9yBA;UwB+yBA,kBAAkB;UAClB,aAAa;UACb,eAAe;UACf,cxBnzBK;UwBozBL,aAAa,EAAA;EAhTjC;IAuTQ,oBAAoB;IACpB,aAAa,EAAA;;AAIrB;;EAEI,wBAAwB;EACxB,SAAS,EAAA;;AAGb,iBAAA;AACA;EAEI,6BAA6B,EAAA;;AxBr2BjC;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AyBv8BA;EACE;IACE,2BAA2B,EAAA;EAE7B;IACE,6BAA6B,EAAA,EAAA;;AAIjC;EACE,2BAA2B;EAC3B,mBAAmB,EAAA;;AAGrB;EAEI,aAAa;EACb,4DAA4D;EAC5D,aAAa;EACb,eAAe;EAEf,UAAU;EACV,0BAA0B;EAC1B,mBAAmB,EAAA;EATvB;IAYM,yBAAyB;IACzB,aAAa;IACb,YAAY;IAEZ,YAAY;IACZ,uDAAuD;IACvD,qEAAqE,EAAA;IAlB3E;MAsBU,qCAAqC;MACrC,0DAA0D,EAAA;IAvBpE;MA4BQ,aAAa;MACb,YAAY;MACZ,uBAAuB;MACvB,qBAAqB;MACrB,sEAAsE;MACtE,+BAA+B;MAC/B,yFAAyF,EAAA;MAlCjG;QAsCY,0DAA0D;QAC1D,oCAAoC,EAAA;MAvChD;QA4CU,eAAe;QACf,iBAAiB;QACjB,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,0CAA0C,EAAA;MAjDpD;QAqDU,kCAAkC;QAClC,yBAAyB;QACzB,kBAAkB;QAClB,cAAc;QACd,yBAAyB;QACzB,kBAAkB;QAClB,iBAAiB,EAAA;MA3D3B;QA+DU,iNAgBC,EAAA;MA/EX;QAoFU,iNAgBC,EAAA;MApGX;QAwGU,iNAgBC,EAAA;MAxHX;QA4HU,iNAgBC,EAAA;MA5IX;QAgJU,iNAgBC,EAAA;MAhKX;QAoKU,iNAgBC,EAAA;;AAOX;EACE,WAAW;EAAE,kDAAA;EACb,YAAY;EAAE,sCAAA;EACd,6BAA6B;EAAE,mDAAA;EAE/B,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C,EAAA;;AzB/M5C;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;A0Bv8BA;EACI,aAAa;EACb,YAAY;EACZ,kBAAkB;EAElB,gBAAgB;EAChB,kBAAkB,EAAA;EANtB;IASQ,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB,EAAA;;AAIzB;EAEQ,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,YAAY,EAAA;EALpB;IAQY,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,iBAAiB;IACjB,SAAS,EAAA;IAZrB;MAegB,aAAa;MACb,sBAAsB;MACtB,WAAW;MACX,kBAAkB;MAClB,SAAS,EAAA;MAnBzB;QAsBoB,gBAAgB,EAAA;IAtBpC;;;MA8BgB,yB1BRJ;M0BSI,sBAAsB,EAAA;IA/BtC;;;MAqCgB,6BAA6B;MAC7B,sBAAsB;MACtB,YAAY,EAAA;IAvC5B;MA4CgB,oCAAiC;MACjC,sBAAsB,EAAA;IA7CtC;MAiDgB,wCAAwC;MACxC,sBAAsB,EAAA;IAlDtC;MAsDgB,WAAW;MACX,mBAAmB,EAAA;IAvDnC;MA2DgB,eAAe;MACf,eAAe;MACf,aAAa;MACb,sBAAsB;MACtB,SAAS;MACT,gBAAgB;MAChB,gBAAgB,EAAA;MAjEhC;QAoEoB,mBAAmB;Q1B81BrC,aAAa;QACb,WAAW;QACX,YAAY;QACZ,SAAS;QACT,eAAe,EAAA;QAEf;UACE,cAAc;UACd,kBAAkB,EAAA;QAGpB;UACE,kBAAkB;UAClB,YAlC6B;UAmC7B,UAAU;UACV,WAAW;UAEX,iBAAiB,EAAA;MAXnB;Q0B/1BkB,c1B3DA;Q0B4DA,cAAc;QACd,oBAAoB;QACpB,mBAAmB;QACnB,eAAe;QACf,iBAAiB,EAAA;IA9ErC;MAmFgB,yB1BrEI;M0BsEJ,kBAAkB;MAClB,YAAY;MACZ,qCAAqC;MACrC,WAAW;MACX,sBAAsB,EAAA;MAxFtC;QA2FoB,YAAY,EAAA;MA3FhC;QA+FoB,aAAa;QACb,gBAAgB;QAChB,kBAAkB;QAClB,aAAa;QACb,sBAAsB;QACtB,SAAS,EAAA;Q1BopBzB;UACI,UAjKa,EAAA;QAoKjB;UACI,mBApKuB;UAqKvB,kBAAkB;UAClB,kBAAkB,EAAA;QAGtB;UACI,yBA3uBU;UA4uBV,kBAAkB,EAAA;UAElB;YACI,yBAAqD,EAAA;M0BvwBjE;QAyGoB,aAAa;QACb,oCAAoC;QACpC,QAAQ;QACR,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB,EAAA;MA9GtC;QAkHoB,iBAAiB;QACjB,c1BtGK;Q0BuGL,aAAa;QACb,iBAAiB;QACjB,iBAAiB;QACjB,YAAY,EAAA;QAvHhC;UA0HwB,aAAa;UACb,eAAe,EAAA;MA3HvC;QAgIoB,WAAW;QACX,sBAAsB,EAAA;MAjI1C;QAqIoB,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,QAAQ;QACR,QAAQ,EAAA;IAzI5B;MA+IgB,YAAY,EAAA;MA/I5B;QAkJoB,YAAY,EAAA;IAlJhC;MAuJgB,WAAW,EAAA;IAvJ3B;;MA6JgB,YACJ,EAAA;IA9JZ;MAkKgB,aAAa;MACb,sBAAsB,EAAA;IAnKtC;MAsKgB,aAAa;MACb,8BAA8B;MAC9B,WAAW;MACX,YAAY,EAAA;IAzK5B;MA6KgB,c1B/JI;M0BgKJ,cAAc;MACd,oBAAoB;MACpB,mBAAmB;MACnB,eAAe;MACf,iBAAiB,EAAA;IAlLjC;MAsLgB,iBAAiB;MACjB,QAAQ,EAAA;EAvLxB;IA8LgB,aAAa;IACb,SAAS;IACT,oBAAoB;IACpB,oBAAoB,EAAA;EAjMpC;IAqMgB,2BAA2B;IAC3B,eAAe;IACf,iBAAiB,EAAA;EAvMjC;IA2MgB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,UAAU,EAAA;EA9M1B;IAkNgB,WAAW,EAAA;EAlN3B;IAsNgB,cAAc;IACd,YAAY;IACZ,gBAAgB,EAAA;EAxNhC;IA4NgB,eAAe,EAAA;IA5N/B;MA+NoB,kBAAkB;MAClB,yB1BtKM,EAAA;E0B1D1B;IAqOgB,0B1BvNI;I0BwNJ,kBAAkB;IAClB,aAAa;IACb,c1B3NS;I0B4NT,aAAa,EAAA;EAzO7B;IA8OY,aAAa;IACb,WAAW,EAAA;IA/OvB;MAkPgB,kBAAkB;MAClB,wBAAwB;MACxB,YAAY;MACZ,gBAAgB;MAChB,aAAa,EAAA;MAtP7B;QA0PoB,WAAW;QACX,cAAc,EAAA;MA3PlC;QAgQoB,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,0B1BrPA;Q0BsPA,gBAAgB;QAChB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,YAAY;QACZ,yB1BxPN,EAAA;Q0BjBd;UA4QwB,kBAAkB;UAClB,MAAM;UACN,OAAO;UACP,WAAW;UACX,iBAAiB;UACjB,0BAA0B;UAC1B,YAAY;UACZ,iBAAiB;UAyBjB,yGAAyG,EAAA;UA5SjI;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,sBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,qBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,oBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,kBAAc,EAAA;UAxR9C;YAwRgC,kBAAc,EAAA;UAxR9C;YAwRgC,kBAAc,EAAA;UAxR9C;YAwRgC,kBAAc,EAAA;UAxR9C;YAwRgC,kBAAc,EAAA;UAxR9C;YAwRgC,kBAAc,EAAA;UAxR9C;YAwRgC,kBAAc,EAAA;UAxR9C;YAwRgC,kBAAc,EAAA;UAxR9C;YAwRgC,kBAAc,EAAA;UAxR9C;YAwRgC,kBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YAwRgC,mBAAc,EAAA;UAxR9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,qBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,oBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,kBAAc,EAAA;UA/R9C;YA+RgC,kBAAc,EAAA;UA/R9C;YA+RgC,kBAAc,EAAA;UA/R9C;YA+RgC,kBAAc,EAAA;UA/R9C;YA+RgC,kBAAc,EAAA;UA/R9C;YA+RgC,kBAAc,EAAA;UA/R9C;YA+RgC,kBAAc,EAAA;UA/R9C;YA+RgC,kBAAc,EAAA;UA/R9C;YA+RgC,kBAAc,EAAA;UA/R9C;YA+RgC,kBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YA+RgC,mBAAc,EAAA;UA/R9C;YAuSgC,YAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,YAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,YAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,YAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,YAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,UAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,YAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,YAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,YAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,YAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,YAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,YAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,YAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,YAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,YAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,UAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,YAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,YAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,YAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,YAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,YAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,YAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,YAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,YAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,YAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,aAAQ,EAAA;UAvSxC;YAuSgC,UAAQ,EAAA;QAvSxC;UAgTwB,gBAAgB,EAAA;MAhTxC;QAqToB,aAAa;QACb,YAAY;QACZ,yBAAyB,EAAA;IAvT7C;MA6TgB,aAAa;MACb,6BAA6B,EAAA;MA9T7C;QAiUoB,aAAa;QACb,sBAAsB;QACtB,WAAW;QACX,sBAAsB,EAAA;QApU1C;UAuUwB,wBAAwB,EAAA;EAvUhD;IA8UY,aAAa;IACb,SAAS;IACT,WAAW;IACX,oBAAoB;IACpB,oBAAoB,EAAA;EAlVhC;;IAuVY,WAAW;IACX,YAAY;IACZ,yB1BtUY;I0BuUZ,yB1B5UQ;I0B6UR,kBAAkB;IAClB,aAAa,EAAA;EA5VzB;IAgWY,aAAa;IACb,aAAa;IACb,sBAAsB,EAAA;IAlWlC;MAqWgB,eAAe;MACf,gBAAgB;MAChB,aAAa;MACb,sBAAsB;MACtB,QAAQ,EAAA;M1B+YpB;QACI,UAjKa,EAAA;MAoKjB;QACI,mBApKuB;QAqKvB,kBAAkB;QAClB,kBAAkB,EAAA;MAGtB;QACI,yBA3uBU;QA4uBV,kBAAkB,EAAA;QAElB;UACI,yBAAqD,EAAA;I0BvwBjE;MA8WgB,aAAa;MACb,oCAAoC;MACpC,QAAQ;MACR,mBAAmB,EAAA;IAjXnC;MAqXgB,iBAAiB;MACjB,aAAa,EAAA;IAtX7B;MA0XgB,UAAU;MACV,WAAW;MACX,kBAAkB;MAClB,yB1BvWJ;M0BwWI,iBAAiB,EAAA;;AAajC;EACI,cAAc;EACd,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,gCAAgC;EAChC,0BAA0B;EAC1B,c1BrYqB;E0BsYrB,mB1BhYoB;E0BiYpB,yB1B5Xc;E0B6Xd,0BAA0B,EAAA;;AAG9B;EACI,aAAa;EACb,mBAAmB;EACnB,c1B9YqB,EAAA;;A0BiZzB;EACI,yBAAyB;EACzB,c1BnZqB,EAAA;;A0BsZzB;EACI,c1BvZqB;E0BwZrB,gBAAgB,EAAA;;AAGpB;EACI,kBAAkB;EAClB,eAAe;EACf,c1B9ZqB;E0B+ZrB,6BAA6B;EAC7B,6BAA6B;EAC7B,eAAe,EAAA;;AAGnB;EACI,sBAAsB,EAAA;;AAG1B;EAEI,kBAAkB;EAClB,WAAW,EAAA;;AAGf;EACI,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,iBAAiB,EAAA;;AAGrB;EACI,qBAAqB;EACrB,kBAAkB;EAClB,aAAa,EAAA;;AAGjB;EACI,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,c1BpcqB,EAAA;;A0BuczB;EACI,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB,EAAA;;AAG3B;EAEQ,YAAY;EACZ,kBAAkB,EAAA;EAH1B;IAMY,c1Btda;I0Budb,mB1BldO;I0BmdP,WAAW;IACX,wBAAwB;IACxB,mBAAmB;IACnB,cAAc;IACd,oCAAsC;IACtC,8BAA8B,EAAA;I1B8QtC;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;I0B1SjE;MAiBgB,gB1BtdE,EAAA;E0BqclB;IAsBY,YAAY;IACZ,aAAa,EAAA;;AAMzB;EACI,aAAa,EAAA;;AAGjB;EACI,wBAAwB;EACxB,4BAA4B;EAC5B,c1BpfqB;E0BqfrB,mB1Bhfe;E0Biff,oCAAsC;EACtC,8BAA8B;EAC9B,kBAAkB;EAClB,cAAe,EAAA;E1BkPf;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;;A0B7PjE;EACI,kBAAkB;EAClB,iBAAiB;EACjB,WAAW,EAAA;EAHf;IAMQ,aAAa,EAAA;;AAIrB,yJAAA;AACA;EACI,sBAAsB,EAAA;;AAG1B;EACI,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,eAAe,EAAA;;AAGnB;EACI,aAAa;EACb,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,WAAW;EACX,mB1BphBoB;E0BqhBpB,yB1BxhBiB;E0ByhBjB,kBAAkB;EAClB,gBAAgB,EAAA;;AAGpB,gFAAA;AACA;EACI,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,kC1BtiBiB;E0BuiBjB,6C1BviBiB;E0BwiBjB,c1B3iBqB;E0B4iBrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB,EAAA;;AAGrB,kHAAA;AACA;EACI,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kCAAkC;EAClC,sBAAsB;EACtB,gBAAgB;EAChB,c1BrkBqB;E0BskBrB,mB1BzhBsB;E0B0hBtB,SAAS;EACT,gBAAgB,EAAA;;AAGpB;EACI,qB1BzkBiB,EAAA;;A0B4kBrB;EACI,qB1B3hBkB,EAAA;;A0B8hBtB;EACI,c1BhiBuB,EAAA;;A0BmiB3B;EACI,c1BpiBuB;E0BqiBvB,mB1B5iBsB,EAAA;;A0B+iB1B;EACI,qB1BrlBgB,EAAA;;A0BwlBpB;EACI,c1BjmBqB,EAAA;;A0BomBzB;EACI,c1BvmBgB;E0BwmBhB,mB1BzjBsB,EAAA;;A0B4jB1B;EACI,uBAAuB;EACvB,iBAAiB;EACjB,qB1BlmBe,EAAA;;A0BqmBnB;EACI,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,c1BnnBqB;E0BonBrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB,EAAA;;AAGrB;EACI,iBAAiB;EACjB,gBAAgB,EAAA;;AAGpB;EACI,mBAAmB;EACnB,sBAAsB,EAAA;;AAG1B;EAEQ,WAAW,EAAA;;A1BpqBnB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;A2Bv8BA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,iBAAiB,EAAA;;AAGnB;;EAEE,YAAY;EACZ,oBAAoB;EACpB,0C3B4DmB;E2B3DnB,mBAAmB;EACnB,yG3B+DiB;E2B5DjB,2CAA2C,EAAA;;AAG7C;;EAEE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS,EAAA;EALX;;IAQI,SAAS;IACT,c3BCqB;I2BArB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAA;;AAIrB;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iD3BiCmB,EAAA;;A2B9BrB;EACE,mBAAmB;EACnB,gC3BduB;E2BevB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB,EAAA;;AAG3B;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,0C3BemB;E2BdnB,oBAAoB;EACpB,c3BYkB;E2BXlB,oC3BYmB;E2BXnB,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,0C3BAmB;E2BCnB,mBAAmB;EACnB,iC3BGiB,EAAA;;A2BAnB;EACE,aAAa;EACb,eAAe;EACf,YAAY,EAAA;;AAGd;EACE,wBAAwB;EACxB,0C3BbmB;E2BcnB,oBAAoB;EACpB,gC3BzDuB;E2B0DvB,kC3BVuB;E2BWvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;EACf,4EAA4E,EAAA;EAZ9E;IAeI,sC3B3BgB;I2B4BhB,c3BvEgB;I2BwEhB,kC3B1Be,EAAA;E2BSnB;IAqBI,sC3BjCgB;I2BkChB,c3BlCgB;I2BmChB,kC3BjCU,EAAA;;A2BqCd;EACE,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,8C3B3CmB,EAAA;E2BsCrB;IAQI,gC3BxFqB;I2ByFrB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,0BAA0B,EAAA;;AAI9B;;;EAGE,WAAW;EACX,wBAAwB;EACxB,0C3B3DmB;E2B4DnB,kBAAkB;EAClB,aAAa;EACb,c3BxGuB;E2ByGvB,iC3B1DiB;E2B2DjB,oBAAoB;EACpB,kBAAkB,EAAA;EAXpB;;;IAcI,sC3BrEgB;I2BsEhB,8C3BrEiB,EAAA;;A2ByErB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;E3BgDhB,qBAAqB;EACrB,8DA1HiB,EAAA;EA4HjB;IACE,UAAU,EAAA;EAGZ;IACE,iCAjIe;IAkIf,oBAAoB,EAAA;EAGtB;IACE,oCA3IiB;IA4IjB,oBAAoB,EAAA;;A2B1DxB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,iD3BxFmB,EAAA;;A2B2FrB;EACE,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,WAAW;EACX,wBAAwB;EACxB,yC3BnGmB;E2BoGnB,kBAAkB;EAClB,gC3B/IuB;E2BgJvB,iC3BjGiB;E2BkGjB,gBAAgB;EAChB,eAAe;EACf,4EAA4E,EAAA;EAV9E;IAaI,qC3B5GiB;I2B6GjB,mC3B7GiB;I2B8GjB,c3BxJqB,EAAA;E2ByIzB;IAmBI,oBAAoB;IACpB,qC3BnHiB;I2BoHjB,oC3BpHiB;I2BqHjB,c3BjKgB;I2BkKhB,kD3BtHiB,EAAA;;A2B0HrB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY,EAAA;;AAGd;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gC3BxLuB;E2ByLvB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,cAAc;EACd,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB,EAAA;EAVrB;IAaI,uC3BrLiB;I2BsLjB,c3BvLsB;I2BwLtB,mC3BtLW,EAAA;E2BuKf;IAmBI,sC3B7JkB;I2B8JlB,c3B/JuB;I2BgKvB,kC3B9JY,EAAA;;A2BkKhB;;EAEE,SAAS;EACT,gC3B3NuB;E2B4NvB,kBAAkB;EAClB,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,2C3B3LmB;E2B4LnB,mBAAmB;EACnB,iC3BxLiB,EAAA;;A2B2LnB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,iD3BpMmB,EAAA;;A2BuMrB;EACE,mBAAmB,EAAA;;AAGrB;EACE,mBAAmB,EAAA;;AAGrB;EACE,sBAAsB,EAAA;;AAGxB;EACE,+BAA+B;EAC/B,gBAAgB;E3BvFhB,qBAAqB;EACrB,8DA1HiB;E2BkNjB,0C3BvNmB;E2BwNnB,mBAAmB;EACnB,iC3BpNiB,EAAA;EA4HjB;IACE,UAAU,EAAA;EAGZ;IACE,iCAjIe;IAkIf,oBAAoB,EAAA;EAGtB;IACE,oCA3IiB;IA4IjB,oBAAoB,EAAA;E2BuExB;IASI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB,EAAA;EAZtB;IAgBI,WAAW,EAAA;EAhBf;IAoBI,WAAW,EAAA;EApBf;IAwBI,WAAW,EAAA;EAxBf;IA4BI,WAAW,EAAA;EA5Bf;IAgCI,YAAY,EAAA;EAhChB;;IAqCI,wBAAwB;IACxB,+C3BhSiB;I2BiSjB,c3BpSqB;I2BqSrB,gBAAgB;IAChB,sBAAsB,EAAA;EAzC1B;IA6CI,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,gC3B7SqB;I2B8SrB,kC3B7PoB;I2B8PpB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB,EAAA;EArD7B;;;;;;;;;;IAkEI,kBAAkB,EAAA;EAlEtB;IAsEI,uBAAuB;IACvB,iCAAiC,EAAA;IAvErC;MA0EM,oC3B7Re,EAAA;I2BmNrB;MA8EM,gBAAgB,EAAA;IA9EtB;MAkFM,kBAAkB;MAClB,UAAU;MACV,aAAa;MACb,oC3BxSe;M2BySf,yCAAyC,EAAA;;AAK/C;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,yC3BlTmB;E2BmTnB,kBAAkB;EAClB,gC3B9VuB;E2B+VvB,kC3B9SsB;E2B+StB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,kBAAkB,EAAA;EAXpB;IAcI,sC3B5TiB;I2B6TjB,c3B9TgB;I2B+ThB,oC3B9TiB,EAAA;E2B8SrB;IAoBI,gBAAgB,EAAA;;AAIpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,UAAU;EACV,yC3B7UmB;E2B8UnB,kBAAkB;EAClB,gC3BzXuB;E2B0XvB,kC3BzUsB;E2B0UtB,kBAAkB;EAClB,cAAc;EACd,eAAe,EAAA;EAbjB;IAgBI,sC3BtViB;I2BuVjB,c3BxVgB;I2ByVhB,oC3BxViB,EAAA;E2BsUrB;IAsBI,YAAY;IACZ,eAAe,EAAA;;AAInB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY,EAAA;;AAGd;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,UAAU;EACV,yC3B/WmB;E2BgXnB,kBAAkB;EAClB,gC3B3ZuB;E2B4ZvB,kC3B3WsB;E2B4WtB,kBAAkB;EAClB,cAAc;EACd,eAAe,EAAA;EAbjB;IAgBI,sC3BxXiB;I2ByXjB,c3B1XgB;I2B2XhB,oC3B1XiB,EAAA;E2BwWrB;IAsBI,YAAY;IACZ,eAAe,EAAA;;AAInB;EAEI,qC3BvagB;E2BwahB,c3BxagB;E2ByahB,mC3BzagB,EAAA;;A2B6apB;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,eAAe,EAAA;;AAGjB;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,UAAU;EACV,0C3B1ZmB;E2B2ZnB,kBAAkB;EAClB,kC3BrZsB;E2BsZtB,gC3BvcuB;E2BwcvB,eAAe;EACf,kFAAkF,EAAA;EAbpF;IAiBI,uC3B1ZuB;I2B2ZvB,c3B3ZuB,EAAA;E2ByY3B;IAsBI,uC3B/ZuB;I2BgavB,kC3B3ZsB;I2B4ZtB,c3BjauB,EAAA;E2ByY3B;IA4BI,YAAY;IACZ,eAAe,EAAA;;AAInB;EACE,cAAc;EACd,eAAe,EAAA;;AAGjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc,EAAA;;AAGhB;EACE,sBAAsB,EAAA;;AAGxB;EASE,+CAA+C,EAAA;EATjD;IAEI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,iC3Bnce;I2Bocf,4C3BhfiB,EAAA;E2B0erB;IAYI,sBAAsB,EAAA;;AAI1B;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,8C3B1dmB,EAAA;;A2B6drB;EACE,SAAS;EACT,c3BhekB;E2BielB,kBAAkB,EAAA;;AAGpB;EACE,c3BtgBkB,EAAA;;A2BygBpB;EACE,SAAS;EACT,gC3BnhBuB;E2BohBvB,kBAAkB,EAAA;;AAGpB;EApjBA;IAsjBI,0BAA0B,EAAA;EAG5B;IACE,SAAS,EAAA,EACV;;AAIH;EACE,4CAAsC;EACtC,qCAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,c3B1iBuB;E2B2iBvB,4F3BriBsB,EAAA;E2ByiBrB;IAEG,aAAa,EAAA;;AAKnB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,iD3BjhBmB,EAAA;;A2BohBrB;EACE,aAAa;EACb,gDAAgD;EAChD,kBAAkB;EAClB,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY,EAAA;EANd;IASI,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,c3BnlBgB;I2BolBhB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB,EAAA;;AAIvB;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY,EAAA;;AAGd;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,0C3B5kBmB;E2B6kBnB,oBAAoB;EACpB,kC3BxkBuB;E2BykBvB,c3BvnByB;E2BwnBzB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB,EAAA;;AAGrB;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,c3B1lBkB,EAAA;;A2B6lBpB;EACE,cAAc,EAAA;;AAGhB;EACE,sC3BlmBkB;E2BmmBlB,kC3BjmBY;E2BkmBZ,c3B7oBuB,EAAA;;A2BgpBzB;EACE,uC3B/oByB;E2BgpBzB,kC3B5oBsB;E2B6oBtB,c3BjpByB,EAAA;;A2BopB3B;EACE,uC3BhoBmB;E2BioBnB,oC3BjoBmB;E2BkoBnB,c3BloBmB,EAAA;E2B+nBrB;IAMI,c3BroBiB,EAAA;;A2ByoBrB;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,sBAAsB,EAAA;;AAGxB;EACE,oBAAoB;EACpB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,0C3B7oBmB;E2B8oBnB,kBAAkB;EAClB,iC3B1oBiB;E2B2oBjB,mD3B5rBkB;E2B6rBlB,YAAY,EAAA;;AAGd;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,c3BnsByB;E2BosBzB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,0EAGuB,EAAA;EAhBzB;IAmBI,c3BjtBqB;I2BktBrB,qC3BptBgB,EAAA;E2BgsBpB;IAwBI,c3BxtBgB;I2BytBhB,kC3B5qBU;I2B6qBV,iF3B1tBgB,EAAA;;A2BguBpB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa,EAAA;;AAIb;EADF;IAEI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS,EAAA,EAEZ;;AAED;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS,EAAA;EAJX;IAOI,SAAS;IACT,YAAY;IACZ,OAAO;IACP,gBAAgB;IAChB,c3BjwBgB;I2BkwBhB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB,EAAA;;AAIvB;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,WAAW,EAAA;;AAGb;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,wBAAwB;EACxB,0C3BpvBmB;E2BqvBnB,kBAAkB;EAClB,kC3BhvBuB;E2BivBvB,c3BjyBuB;E2BkyBvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,mD3B1yBkB;E2B2yBlB,mGAIuB,EAAA;EAtBzB;IAyBI,sC3BvwBgB;I2BwwBhB,kC3BrwBe;I2BswBf,c3BpzBgB,EAAA;E2ByxBpB;IA+BI,+CAA+C,EAAA;EA/BnD;IAmCI,aAAa;IACb,mBAAmB,EAAA;;AAIvB;EACE,sC3BvxBkB;E2BwxBlB,kC3BtxBY;E2BuxBZ,c3Bp0BkB,EAAA;E2Bi0BpB;IAMI,sC3B5xBgB;I2B6xBhB,kC3B3xBU;I2B4xBV,c3Bz0BgB,EAAA;E2Bi0BpB;IAYI,uC3BpzBiB;I2BqzBjB,qC3BrzBiB;I2BszBjB,c3BtzBiB,EAAA;I2BwyBrB;MAiBM,qB3BzzBe;M2B0zBf,qC3B1zBe;M2B2zBf,c3B3zBe,EAAA;;A2Bg0BrB;EACE,iC3BzyBiB,EAAA;;A2B4yBnB;EACE,cAAc;EACd,aAAa;EACb,cAAc,EAAA;;AAGhB;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,0C3Bh0BmB;E2Bi0BnB,kBAAkB;EAClB,c3B12ByB;E2B22BzB,kC3B7zBuB;E2B8zBvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,4EAGkB,EAAA;EArBpB;IAwBI,sC3Bh1BgB;I2Bi1BhB,kC3B90Be;I2B+0Bf,c3B73BgB,EAAA;E2Bm2BpB;IA8BI,+CAA+C,EAAA;;AAInD;EACE,kBAAkB;EAClB,oBAAoB,EAAA;;AAGtB;EACE,sC3B/1BmB;E2Bg2BnB,kC3B11BuB,EAAA;E2Bw1BzB;IAKI,sC3Bp2BgB;I2Bq2BhB,kC3Bl2Be,EAAA;;A2Bs2BnB;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,c3B72BkB,EAAA;;A2Bg3BpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;EACpB,mC3Bv3BkB;E2Bw3BlB,c3Bj6BuB;E2Bk6BvB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qCAAgD;EAChD,gBAAgB;EAChB,0C3Bv4BmB;E2Bw4BnB,mBAAmB;EACnB,mFAIC;EACD,2CAA2C,EAAA;;AAG7C;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY,EAAA;;AAGd;EACE,mBAAmB;EACnB,c3B35BkB;E2B45BlB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB,EAAA;;AAG3B;EACE,SAAS;EACT,c3B/8BkB;E2Bg9BlB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAA;;AAGnB;EACE,cAAc;EACd,sBAAsB;EACtB,oBAAoB;EACpB,0C3B76BmB;E2B86BnB,kC3Bx6BuB;E2By6BvB,c3Bv9ByB;E2Bw9BzB,kBAAkB;EAClB,mBAAmB,EAAA;;AAGrB;EACE,SAAS;EACT,c3B99ByB;E2B+9BzB,kBAAkB;EAClB,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,cAAc;EACd,gBAAgB;E3BtjBhB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,6DAA6D,EAAA;EAE7D;IACE,UAAU,EAAA;EAGZ;IACE,+BAA+B;IAC/B,oBAAoB,EAAA;EAGtB;IACE,mCA5ZiB;IA6ZjB,oBAAoB;IACpB,2CAA2C,EAAA;EAG7C;IACE,oCAlaiB,EAAA;;A2Bu8BrB;EACE,wBAAwB;EACxB,2C3Bz8BmB;E2B08BnB,kBAAkB;EAClB,c3Bn/ByB;E2Bo/BzB,kBAAkB;EAClB,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kC3Bh9BuB;E2Bi9BvB,0C3Bv9BmB,EAAA;;A2B09BrB;EACE,OAAO;EACP,YAAY;EACZ,SAAS;EACT,wBAAwB;EACxB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,c3B5gCuB;E2B6gCvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mDAAmD,EAAA;EAfrD;IAkBI,kC3B3+BU;I2B4+BV,c3BzhCgB,EAAA;E2BsgCpB;IAuBI,eAAe,EAAA;;AAInB;EACE,OAAO;EACP,YAAY;EACZ,SAAS;EACT,wBAAwB;EACxB,0C3B3/BkB;E2B4/BlB,kBAAkB;EAClB,kC3BhiCsB;E2BiiCtB,c3BziCkB;E2B0iClB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB,EAAA;EAXlB;IAcI,aAAa;IACb,sC3BrgCgB;I2BsgChB,8C3BtgCgB,EAAA;;A2B0gCpB;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,SAAS;EACT,UAAU;EACV,yC3BnjCU;E2BojCV,kBAAkB;EAClB,mC3BrjCU;E2BsjCV,c3BvjCkB;E2BwjClB,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,eAAe;EACf,4EAGkB,EAAA;EApBpB;IAuBI,qC3BjkCQ;I2BkkCR,mC3BlkCQ;I2BmkCR,c3B9kCgB,EAAA;E2BqjCpB;IA6BI,aAAa;IACb,mBAAmB,EAAA;;AAIvB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW,EAAA;;AAGb;EACE,cAAc;EACd,SAAS;EACT,wBAAwB;EACxB,0C3BtjCkB;E2BujClB,kBAAkB;EAClB,kC3BtjCY;E2BujCZ,c3BpmCkB;E2BqmClB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,0DAEyB,EAAA;EAd3B;IAiBI,sC3BnkCgB;I2BokChB,kC3BlkCU,EAAA;E2BgjCd;IAsBI,aAAa;IACb,mBAAmB,EAAA;;AAIvB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,8C3BllCmB,EAAA;;A2BqlCrB;EACE,SAAS;EACT,uBAAuB;EACvB,2C3B3mCmB;E2B4mCnB,kBAAkB;EAClB,qC3B7mCmB;E2B8mCnB,c3B9mCmB;E2B+mCnB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,4EAGkB,EAAA;EAdpB;IAiBI,qB3BznCiB;I2B0nCjB,qC3B1nCiB;I2B2nCjB,c3BppCgB,EAAA;E2BioCpB;IAuBI,aAAa;IACb,mBAAmB,EAAA;;AAIvB;EACE,SAAS;EACT,c3BtoCmB;E2BuoCnB,kBAAkB,EAAA;;AAGpB;EACE,c3B1pCkB,EAAA;;A2B6pCpB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB,EAAA;;AAG3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,SAAS;EACT,wBAAwB;EACxB,0C3BzoCmB;E2B0oCnB,kBAAkB;EAClB,kC3BroCuB;E2BsoCvB,c3B7oCkB;E2B8oClB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mGAIuB,EAAA;EApBzB;IAuBI,sC3B1pCgB;I2B2pChB,kC3BzpCU;I2B0pCV,c3BvsCgB,EAAA;E2B8qCpB;IA6BI,sC3BppCkB;I2BqpClB,mC3BppCY;I2BqpCZ,c3BxpCuB;I2BypCvB,8C3BvpCkB,EAAA;I2BunCtB;MAmCM,c3B1pCgB,EAAA;I2BunCtB;MAuCM,qB3B9pCgB;M2B+pChB,mC3B7pCe;M2B8pCf,c3BjqCqB;M2BkqCrB,8C3BjqCgB,EAAA;;A2BsqCtB;EAEI,qB3BxqCkB;E2ByqClB,kC3BvqCiB;E2BwqCjB,c3B3qCuB,EAAA;;A2B+qC3B;EACE,cAAc;EACd,eAAe,EAAA;;AAGjB;EACE,sBAAsB;EACtB,yBAAyB,EAAA;;AAG3B;EACE,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,0C3BhtCmB;E2BitCnB,mFAIC;EACD,2CAA2C;E3Bz0B3C,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,6DAA6D,EAAA;EAE7D;IACE,UAAU,EAAA;EAGZ;IACE,+BAA+B;IAC/B,oBAAoB,EAAA;EAGtB;IACE,mCA5ZiB;IA6ZjB,oBAAoB;IACpB,2CAA2C,EAAA;EAG7C;IACE,oCAlaiB,EAAA;;A2B0tCrB;EACE,WAAW;EACX,uBAAuB;EACvB,oC3B7tCmB,EAAA;;A2BguCrB;EACE,uBAAuB;EACvB,c3B1wCyB;E2B2wCzB,kBAAkB;EAClB,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,wBAAwB;EACxB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,c3B3xCuB;E2B4xCvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mGAIuB,EAAA;EApBzB;IAuBI,kC3B7vCU;I2B8vCV,c3B3yCgB,EAAA;E2BmxCpB;IA4BI,eAAe,EAAA;;AAInB;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,2C3BnzCyB;E2BozCzB,oBAAoB;EACpB,uBAAuB;EACvB,iFAGuB,EAAA;;AAGzB;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,0C3BjxCoB;E2BkxCpB,oFAIC;EACD,c3BxxCyB;E2ByxCzB,mD3B1xCyB,EAAA;E2BkxC3B;IAWI,qB3B3xCkB;I2B4xClB,sEAA4E;IAC5E,8C3B7xCkB,EAAA;E2BgxCtB;IAiBI,sC3BjyCkB;I2BkyClB,oFAIC;IACD,c3BzyCuB,EAAA;;A2B6yC3B;EACE,iBAAiB,EAAA;;AAGnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,c3Bv2CyB;E2Bw2CzB,kBAAkB;EAClB,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,c3Bz0CkB,EAAA;;A2B40CpB;EACE,aAAa;EACb,mBAAmB;EACnB,iGAAiG,EAAA;;AAGnG;EACE,aAAa;EACb,sBAAsB;EACtB,iDAAiD,EAAA;;AAGnD;;;;;EAKE,gCAAsC;EACtC,wDAAyD,EAAA;;AAG3D;EACE,gCAAsC;EACtC,wDAAyD;EACzD,+CAAgD,EAAA;;AAGlD;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,0C3Bn3CmB;E2Bo3CnB,kBAAkB;EAClB,kC3Bj3CkB,EAAA;;A2Bo3CpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,c3Bp6CyB;E2Bq6CzB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB,EAAA;;AAG3B;EACE,cAAc;EACd,eAAe;EACf,c3Bt4CkB,EAAA;;A2By4CpB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,c3Bp7CkB,EAAA;;A2Bu7CpB;EACE,c3Br4CyB,EAAA;;A2Bw4C3B;EACE,aAAa;EACb,iDAAiD;EACjD,YAAY;EACZ,iBAAiB,EAAA;;AAGnB;;EAEE,YAAY;EACZ,wBAAwB;EACxB,0C3B75CmB;E2B85CnB,mBAAmB;EACnB,yCAAyC,EAAA;;AAG3C;EACE,0G3B95CiB,EAAA;;A2Bm6CnB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,0G3Bz6CiB,EAAA;;A2B86CnB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,iD3B17CmB,EAAA;E2Bm7CrB;IAUI,SAAS;IACT,c3B1+CgB;I2B2+ChB,iBAAiB;IACjB,gBAAgB,EAAA;;AAIpB;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY,EAAA;;AAGd;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,2C3BtgDkB;E2BugDlB,+BAA+B;EAC/B,c3BtgDuB;E2BugDvB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,4EAA4E,EAAA;EAb9E;IAgBI,+BAA+B;IAC/B,qB3B9gDgB;I2B+gDhB,c3BlhDgB,EAAA;;A2BshDpB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa,EAAA;;AAGf;;EAEE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY,EAAA;;AAGd;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,0C3BlgDkB;E2BmgDlB,kBAAkB;EAClB,c3BpgDkB;E2BqgDlB,kC3BngDY,EAAA;E2By/Cd;IAaI,cAAc;IACd,eAAe,EAAA;;AAInB;EAEI,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ,WAAW,EAAA;;AANf;EAWM,YAAY,EAAA;;AAXlB;EAgBI,cAAc;EACd,cAAc,EAAA;;AAIlB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,wBAAwB;EACxB,0C3BviDmB;E2BwiDnB,kBAAkB;EAClB,iC3BpiDiB;E2BqiDjB,0DAA0D,EAAA;EAT5D;IAYI,sC3B9iDgB;I2B+iDhB,8C3B9iDiB,EAAA;;A2BkjDrB;EACE,cAAc,EAAA;;AAGhB;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,c3BnmDyB,EAAA;E2B8lD3B;IAQI,aAAa;IACb,cAAc,EAAA;;AAIlB;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,aAAa;EACb,c3BnnDuB;E2BonDvB,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB,EAAA;EATnB;IAYI,gC3BvnDuB,EAAA;;A2B2nD3B;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,wBAAwB;EACxB,0C3B1lDmB;E2B2lDnB,kBAAkB;EAClB,kC3BtlDuB,EAAA;;A2BylDzB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,c3B3oDyB;E2B4oDzB,kBAAkB;EAClB,mBAAmB,EAAA;;AAGrB;EACE,cAAc;EACd,eAAe;EACf,c3B5mDkB,EAAA;;A2B+mDpB;EACE,mBAAmB;EACnB,c3BxpDyB;E2BypDzB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB,EAAA;;AAG3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,0C3B7nDkB;E2B8nDlB,oBAAoB;EACpB,c3B/nDkB;E2BgoDlB,kC3B9nDY;E2B+nDZ,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,iD3B1oDmB,EAAA;;A2B6oDrB;;EAEE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,wBAAwB;EACxB,0C3BppDmB;E2BqpDnB,kBAAkB;EAClB,c3BhsDuB;E2BisDvB,kC3BjpDuB;E2BkpDvB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,4EAA4E,EAAA;EAf9E;;IAkBI,sC3BhqDgB;I2BiqDhB,kC3B9pDe;I2B+pDf,c3B7sDgB,EAAA;E2ByrDpB;;IAwBI,gBAAgB,EAAA;EAxBpB;;;IA6BI,aAAa;IACb,mBAAmB,EAAA;EA9BvB;;IAkCI,UAAU,EAAA;EAlCd;;IAsCI,gCAAsC;IACtC,wDAAyD;IACzD,+CAAgD,EAAA;EAxCpD;;IA4CI,gCAAsC;IACtC,yDAA0D,EAAA;;AAI9D;EACE,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qC3B9uDuB;E2B+uDvB,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;EACZ,0DAA0D,EAAA;EAV5D;IAaI,qB3BhsDkB;I2BisDlB,8C3BjsDkB,EAAA;E2BosDpB;IACE,WAAW;IACX,gBAAgB;IAChB,kC3B5sDqB,EAAA;;A2BgtDzB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,0BAA0B,EAAA;;AAG5B;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,wBAAwB;EACxB,0C3BvuDkB;E2BwuDlB,oBAAoB;EACpB,c3BzuDkB;E2B0uDlB,kC3BxuDY;E2ByuDZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB,EAAA;;AAGzB;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,0C3B7uDoB;E2B8uDpB,oBAAoB;EACpB,c3BhvDyB;E2BivDzB,mC3B/uDc;E2BgvDd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,cAAc;EACd,wBAAwB,EAAA;;AAG1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,UAAU;EACV,0C3BlxDkB;E2BmxDlB,kBAAkB;EAClB,c3BpxDkB;E2BqxDlB,kC3BnxDY;E2BoxDZ,eAAe;EACf,4EAA4E,EAAA;EAZ9E;IAgBI,qC3B3xDgB;I2B4xDhB,kC3B1xDU;I2B2xDV,c3Bt0DqB,EAAA;;A2B00DzB;EACE,cAAc;EACd,eAAe,EAAA;;AAGjB;EACE,kBAAkB;EAClB,SAAS;EACT,wBAAwB;EACxB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,0C3B7yDmB;E2B8yDnB,kBAAkB;EAClB,kC3B3yDkB;E2B4yDlB,yEAE+B;EAC/B,2BAA2B,EAAA;;AAG7B;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB,EAAA;;AAGlB;EACE,SAAS;EACT,gBAAgB,EAAA;;AAGlB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,yC3Bz0DmB;E2B00DnB,oBAAoB;EACpB,gC3Br3DuB;E2Bs3DvB,kC3Bt0DuB;E2Bu0DvB,kBAAkB;EAClB,iBAAiB,EAAA;;AAGnB;EACE,oBAAoB;EACpB,aAAa,EAAA;;AAGf;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,c3B/1DkB;E2Bg2DlB,kC3B91DY,EAAA;E2Bq1Dd;IAYI,cAAc;IACd,eAAe,EAAA;;AAInB;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gC3B15DyB,EAAA;;A2B65D3B;EACE,OAAO;EACP,YAAY,EAAA;;AAGd;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,c3Bp4DkB;E2Bq4DlB,kC3Bn4DY,EAAA;E2By3Dd;IAaI,cAAc;IACd,eAAe,EAAA;;AAInB;EACE,gBAAgB;EAChB,oBAAoB;EACpB,0CAA0C,EAAA;;AAG5C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY,EAAA;;AAGd;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,0C3Bt6DmB;E2Bu6DnB,kBAAkB;EAClB,kC3Bl6DuB,EAAA;E2B25DzB;IAUI,gCAAsC;IACtC,wDAAyD;IACzD,+CAAgD,EAAA;;AAIpD;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB,EAAA;;AAGtB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,wBAAwB;EACxB,yC3Bp8DmB;E2Bq8DnB,kBAAkB;EAClB,c3Bh/DuB;E2Bi/DvB,kC3Bj8DuB;E2Bk8DvB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,4EAA4E,EAAA;EAd9E;IAiBI,sC3Bh9DgB;I2Bi9DhB,kC3B98De;I2B+8Df,c3B7/DgB,EAAA;E2B0+DpB;IAuBI,gBAAgB,EAAA;EAvBpB;IA2BI,UAAU,EAAA;EA3Bd;IA+BI,gCAAsC;IACtC,wDAAyD;IACzD,+CAAgD,EAAA;;AAIpD;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,c3B1hEyB;E2B2hEzB,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB,EAAA;;AAGxB;EACE,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,eAAe;EACf,YAAY,EAAA;;AAGd;EACE,wBAAwB;EACxB,0C3BzgEmB;E2B0gEnB,oBAAoB;EACpB,gC3BrjEuB;E2BsjEvB,kC3BtgEuB;E2BugEvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;EACf,4EAA4E,EAAA;EAZ9E;IAeI,sC3BvhEgB;I2BwhEhB,c3BnkEgB;I2BokEhB,kC3BthEe,EAAA;E2BqgEnB;IAqBI,sC3B7hEgB;I2B8hEhB,c3B9hEgB;I2B+hEhB,kC3B7hEU,EAAA;;A2BiiEd;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,gEAAgE;E3B56DhE,qBAAqB;EACrB,8DA1HiB,EAAA;EA4HjB;IACE,UAAU,EAAA;EAGZ;IACE,iCAjIe;IAkIf,oBAAoB,EAAA;EAGtB;IACE,oCA3IiB;IA4IjB,oBAAoB,EAAA;E2Bs5DxB;IAYI,4C3B/iEgB;I2BgjEhB,kC3B7iEe,EAAA;;A2BijEnB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,0G3BpjEiB;E2BujEjB,gEAAgE,EAAA;EATlE;IAYI,sC3BhkEgB;I2BikEhB,0G3B3jEe,EAAA;;A2BikEnB;;EAGI,YAAY;EACZ,kBAAkB;EAClB,iBAAiB,EAAA;EALrB;;IAQM,gBAAgB,EAAA;EARtB;;IAYM,UAAU,EAAA;;AAKhB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,OAAO;EACP,aAAa;EACb,gBAAgB;E3B/9DhB,qBAAqB;EACrB,8DA1HiB,EAAA;EA4HjB;IACE,UAAU,EAAA;EAGZ;IACE,iCAjIe;IAkIf,oBAAoB,EAAA;EAGtB;IACE,oCA3IiB;IA4IjB,oBAAoB,EAAA;E2B28DxB;IAUI,YAAY;IACZ,eAAe,EAAA;EAXnB;IAeI,SAAS;IACT,c3B/oEuB;I2BgpEvB,kBAAkB,EAAA;;AAItB;EACE,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;EAC/B,0G3B3mEiB;E2B8mEjB,gEAAgE;EAChE,gBAAgB;E3Bt/DhB,qBAAqB;EACrB,8DA1HiB,EAAA;EA4HjB;IACE,UAAU,EAAA;EAGZ;IACE,iCAjIe;IAkIf,oBAAoB,EAAA;EAGtB;IACE,oCA3IiB;IA4IjB,oBAAoB,EAAA;E2Bg+DxB;IAYI,sC3BznEgB;I2B0nEhB,0G3BpnEe,EAAA;;A2B0nEnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,c3B/qEyB;E2BgrEzB,2C3BxoEmB;E2ByoEnB,mBAAmB;EACnB,kC3BpoEuB;E2BqoEvB,kBAAkB;EAClB,kBAAkB,EAAA;EAbpB;IAgBI,SAAS,EAAA;;AAIb;EACE,cAAc;EACd,eAAe;EACf,c3BvpEkB,EAAA;;A2B0pEpB;EACE,gCAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,iBAAiB,EAAA;EAEjB;IACE,UAAU,EAAA;EAGZ;IACE,UAAU;IACV,oBAAoB,EAAA;;AAIxB;EACE,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,eAAe,EAAA;EAPjB;IAUI,gC3B5sEgB,EAAA;;A2BgtEpB;EACE,UAAU;EACV,gC3BltEkB;E2BmtElB,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB,EAAA;EAPtB;IAWI,iC3BjtEuB;I2BktEvB,eAAe;IACf,sBAAsB,EAAA;;AAI1B;EACE,8B3BluEkB;E2BmuElB,YAAY;EACZ,oBAAoB,EAAA;EAHtB;IAOI,+B3B9tEuB,EAAA;;A2BkuE3B;EACE,4B3BtuEuB;E2BuuEvB,+B3B9uEkB;E2B+uElB,eAAe;EACf,oBAAoB,EAAA;EAJtB;IAOI,4B3BhvEe;I2BivEf,iC3B1uEuB;I2B2uEvB,iBAAiB,EAAA;;AAIrB;EACE,oBAAoB,EAAA;;AAGtB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,SAAS;EACT,UAAU;EACV,2C3B1vEyB;E2B2vEzB,oBAAoB;EACpB,kC3BhwEuB;E2BiwEvB,c3B7vEyB;E2B8vEzB,eAAe;EACf,cAAc;EACd,eAAe;EACf,yCAAyC,EAAA;EAf3C;IAkBI,cAAc;IACd,oBAAoB,EAAA;EAnBxB;IAuBI,uC3B1wEuB;I2B2wEvB,c3B3wEuB;I2B4wEvB,kC3BnxEe,EAAA;;A2BuxEnB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB,EAAA;;AAGtB;EACE,gDAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sDAAsD;EACtD,uDAAuD;EACvD,oBAAoB,EAAA;EAEpB;IACE,MAAM;IACN,SAAS;IACT,gCAAgC,EAAA;EAGlC;IACE,SAAS;IACT,SAAS;IACT,+BAA+B,EAAA;EAGjC;IACE,OAAO;IACP,QAAQ;IACR,gCAAgC,EAAA;EAGlC;IACE,QAAQ;IACR,QAAQ;IACR,+BAA+B,EAAA;EA/BnC;;IAoCI,UAAU;IACV,mBAAmB,EAAA;EArCvB;;IA0CI,uC3Bj0EuB;I2Bk0EvB,oC3B50EgB;I2B60EhB,+C3Bn0EuB,EAAA;;A2Bu0E3B;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,UAAU;EACV,4C3Bt1EkB;E2Bu1ElB,oBAAoB;EACpB,kC3Bj1EuB;E2Bk1EvB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,2GAI6B,EAAA;EAhB/B;IAmBI,uC3B11EuB;I2B21EvB,kC3Bl2Ee,EAAA;E2B80EnB;IAwBI,aAAa;IACb,mBAAmB;IACnB,gBAAgB,EAAA;;AAIpB;;;;;EAKE,+C3B12EyB,EAAA;;A2B62E3B;EACE,aAAa;EACb,mFAGC;EACD,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,UAAU,EAAA;EAXZ;IAcI,iDAAiD,EAAA;EAdrD;IAkBI,8CAA8C,EAAA;EAlBlD;IAsBI,gDAAgD,EAAA;;AAIpD;EACE,uBAAqB;EACrB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mFAAmF,EAAA;EAXrF;IAcI,0C3B/5EgB;I2Bg6EhB,kC3Bz5EqB,EAAA;E2B04EzB;IAmBI,iBAAiB;IACjB,mBAAmB,EAAA;EApBvB;;IA0BM,iBAAiB;IACjB,gBAAgB,EAAA;EA3BtB;IAgCI,sC3Bj7EgB;I2Bk7EhB,kC3B/6Ee,EAAA;E2B84EnB;IAqCI,wBAAwB,EAAA;EArC5B;IAyCI,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,oBAAoB,EAAA;;AAIxB;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,2C3Bh/EkB;E2Bi/ElB,+BAA+B;EAC/B,c3Bh/EuB;E2Bi/EvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB,EAAA;;AAG3B;EACE,uBAAuB;EACvB,+C3Bt/EmB,EAAA;;A2By/ErB;EACE,SAAS,EAAA;;AAGX;EAEI,c3B//EiB;E2BggFjB,kBAAkB,EAAA;;AAItB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,+C3B1gFmB,EAAA;;A2B6gFrB;;;EAGE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,OAAO,EAAA;;AAGT;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,cAAc,EAAA;EALhB;IAQI,gBAAgB;IAChB,c3BviFgB;I2BwiFhB,uBAAuB;IACvB,mBAAmB,EAAA;;AAIvB;;EAGI,sBAAsB;EACtB,uBAAuB;EACvB,WAAW,EAAA;;AALf;;EASI,WAAW,EAAA;EATf;;IAYM,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB,EAAA;;AAK1B;E3Bt6EE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EAErB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;E2B45EtB,kBAAkB;EAClB,mBAAmB,EAAA;EAHrB;IAMI,oDAAoD;IACpD,sBAAsB;IACtB,qDAAgF;IAChF,qDAAqD;IACrD,iDAAiD,EAAA;IAVrD;MAaM,cAAc;MACd,wKAGC;MACD,4KAGC,EAAA;;AAKP;EACE,4DAAuF;EACvF,qDAAgF;EAChF,wDAAmF;EACnF,sC3BljFmB;E2BmjFnB,kC3B/iFkB,EAAA;;A2BkjFpB;EACE,4DAAuF;EACvF,qDAAgF;EAChF,wDAAmF;EACnF,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EAQV,kBAAkB;EAClB,mFAAmF,EAAA;EAhBrF;IAUI,eAAe;IACf,YAAY;IACZ,WAAW,EAAA;EAZf;IAmBI,0C3BzkFiB;I2B0kFjB,kC3BtkFgB,EAAA;E2BkjFpB;IAwBI,iBAAiB;IACjB,mBAAmB,EAAA;EAzBvB;IA6BI,sC3BplFgB;I2BqlFhB,kC3BllFe,EAAA;E2BojFnB;IAkCI,wBAAwB,EAAA;EAG1B;IACE,kBAAkB;IAClB,kBAAkB,EAAA;IAFnB;MAMG,yBAAyB,EAAA;IAN5B;MAUG,WAAW;MACX,kBAAkB;MAClB,QAAQ;MACR,sBAAsB;MACtB,cAAc;MACd,yPASC;MACD,8EAE2B;MAC3B,sEAE2B;MAC3B,2BAA2B;MAC3B,uBAAuB;MACvB,oBAAoB;MACpB,UAAU,EAAA;IAlCb;MAsCG,WAAW;MACX,kBAAkB;MAClB,WAAW;MACX,sBAAsB;MACtB,0H3BjrFc;M2BqrFd,oBAAoB;MACpB,UAAU,EAAA;IA/Cb;MAmDG,wH3B1rFc,EAAA;;A2BksFpB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,+C3BnsFmB,EAAA;E2B6rFrB;IASI,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,YAAY,EAAA;EAZhB;IAgBI,oBAAoB;IACpB,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,c3B9qFgB;I2B+qFhB,kC3B7qFU,EAAA;I2BqpFd;MA2BM,cAAc;MACd,eAAe,EAAA;EA5BrB;IAiCI,gBAAgB;IAChB,c3BpuFgB;I2BquFhB,uBAAuB;IACvB,mBAAmB,EAAA;EApCvB;IAwCI,cAAc,EAAA;EAGhB;IACE,sBAAsB;IACtB,oBAAoB;IACpB,WAAW,EAAA;IAHZ;MAMG,WAAW;MACX,mBAAmB,EAAA;IAPtB;MAWG,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,YAAY;MACZ,WAAW;MACX,YAAY,EAAA;IAhBf;MAoBG,oBAAoB;MACpB,mBAAmB;MACnB,YAAY;MACZ,YAAY,EAAA;IAvBf;MA2BG,cAAc;MACd,iBAAiB,EAAA;;AAKvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,wBAAwB;EACxB,kBAAkB;EAClB,mB3BjvFuB;E2BkvFvB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAA;EAEnB;IACE,c3B9xFQ,EAAA;E2BiyFV;IACE,c3BvvFuB,EAAA;E2B0vFzB;IACE,c3BxxFiB,EAAA;;A2B4xFrB;EACE,gBAAgB;EAChB,c3BpzFkB,EAAA;;A2BuzFpB;EACE,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB,EAAA;EAElB;IACE,yB3B1zFQ,EAAA;E2B6zFV;IACE,yB3BlxFkB,EAAA;E2BqxFpB;IACE,yB3BpzFiB,EAAA;;A2BwzFrB;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,UAAU;EACV,2C3Bv1FkB;E2Bw1FlB,kBAAkB;EAClB,kC3B1yFuB;E2B2yFvB,c3B31FuB;E2B41FvB,eAAe;EACf,yGACuB,EAAA;EAfzB;IAmBI,c3Bl2FqB;I2Bm2FrB,qB3Bx1Fc;I2By1Fd,mB3BpzFqB;I2BqzFrB,4C3B11Fc,EAAA;E2Bo0FlB;IA0BI,cAAc;IACd,uCAA0B;IAC1B,mB3B3zFqB;I2B4zFrB,8C3BvzFkB,EAAA;E2B0xFtB;IAkCI,cAAc;IACd,uCAA0B;IAC1B,8C3B9zFkB,EAAA;;A2Bk0FtB;EACE,cAAc;EACd,eAAe,EAAA;;AAGjB;EACE,eAAe;EACf,cAAc;EACd,wBAAwB;EACxB,yBAAyB,EAAA;;AAG3B;EACE,YAAY;EACZ,6BAA6B;EAC7B,SAAS;EACT,wBAAwB;EACxB,c3Bv4FkB;E2Bw4FlB,kBAAkB;EAClB,yB3Bt4FY;E2Bu4FZ,yB3Bh4FgB;E2Bi4FhB,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,wBAAwB;EACxB,c3Bj5FkB;E2Bk5FlB,kBAAkB;EAClB,iBAAiB;EACjB,uC3Bh5FiB;E2Bi5FjB,yC3Bh2Fc;E2Bi2Fd,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,yB3B15FY;E2B25FZ,yB3Bp5FgB;E2Bq5FhB,gC3Br5FgB;E2Bs5FhB,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB,EAAA;EATlB;IAYI,wBAAwB,EAAA;EAZ5B;IAgBI,aAAa,EAAA;EAhBjB;IAqBM,SAAS;IACT,mB3B56FQ,EAAA;I2Bs5Fd;MAyBQ,iBAAiB;MACjB,mB3B/6FW;M2Bg7FX,wBAAwB;MACxB,yB3B36FU;M2B46FV,kBAAkB,EAAA;;AAM1B;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,UAAU,EAAA;;AAGZ;EACE,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,YAAY,EAAA;;AAGd;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,WAAW,EAAA;;AAGb;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,UAAU;EACV,0C3Br7FkB;E2Bs7FlB,kBAAkB;EAClB,kC3B19FsB;E2B29FtB,c3B/9FyB;E2Bg+FzB,eAAe;EACf,kFAAkF,EAAA;EAbpF;IAiBI,uC3Bp7FuB;I2Bq7FvB,c3Br7FuB,EAAA;E2Bm6F3B;IAsBI,uC3Bz7FuB;I2B07FvB,kC3Br7FsB;I2Bs7FtB,c3B37FuB,EAAA;;A2B+7F3B;EACE,cAAc;EACd,eAAe,EAAA;;AAGjB;EACE,kBAAkB,EAAA;;AAGpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,2C3BpgGkB;E2BqgGlB,+BAA+B;EAC/B,c3BpgGuB;E2BqgGvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4EAA4E,EAAA;EAb9E;;IAiBI,+BAA+B;IAC/B,qB3B5gGgB;I2B6gGhB,c3BhhGgB,EAAA;;A2BohGpB;EACE,cAAc;EACd,cAAc;EACd,eAAe,EAAA;;AAGjB;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,0C3BjgGmB;E2BkgGnB,mFAIC;EACD,2CAA2C,EAAA;;AAG7C;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,c3B7jGuB;E2B8jGvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mDAAmD,EAAA;EAbrD;IAiBI,kC3B1hGU;I2B2hGV,c3BxkGgB,EAAA;;A2B4kGpB;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,2C3BjlGkB,EAAA;E2B4kGpB;IAQI,kC3B/kGiB,EAAA;;A2BmlGrB;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,2C3BzmGkB;E2B0mGlB,+BAA+B;EAC/B,eAAe;EACf,0DAA0D,EAAA;EAb5D;IAgBI,+BAA+B;IAC/B,qB3B7mGgB,EAAA;;A2BinGpB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa,EAAA;;AAGf;EACE,UAAU;EACV,c3B3nGkB;E2B4nGlB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe,EAAA;EAPjB;IAUI,c3BpoGqB,EAAA;;A2BwoGzB;EACE,sCAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uCAAuC;EACvC,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,sBAAsB,EAAA;EAEtB;IACE,oBAAoB,EAAA;;AAIxB;EACE,kBAAkB;EAClB,MAAM;EACN,aAAa;EACb,wDAAmF;EACnF,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,uCAAuC,EAAA;EATzC;IAYI,WAAW;IACX,sBAAsB,EAAA;;AAI1B;EACE,aAAa;EACb,8EAA8E;EAC9E,uCAAuC;EACvC,WAAW;EACX,YAAY;EACZ,sBAAsB,EAAA;;AAGxB;EACE,aAAa;EACb,sBAAsB;EACtB,uCAAuC;EACvC,YAAY,EAAA;;AAGd;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB,EAAA;;AAGxB;EAEI,iBAAiB;EACjB,gBAAgB,EAAA;;AAIpB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,4C3B3sGyB;E2B4sGzB,kBAAkB;EAClB,kC3B/pGuB;E2BgqGvB,gEAAgE,EAAA;EARlE;IAWI,sC3B1qGgB;I2B2qGhB,kC3BxqGe,EAAA;;A2B4qGnB;EACE,OAAO;EACP,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB,EAAA;EAP3B;IAUI,cAAc,EAAA;;AAIlB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW,EAAA;;AAGb;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,iBAAiB,EAAA;;AAGnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe,EAAA;EALjB;IAQI,mBAAmB;IACnB,aAAa,EAAA;;AAIjB;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,SAAS;EACT,oBAAoB,EAAA;;AAGtB;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,0C3BtuGkB;E2BuuGlB,sBAAsB;EACtB,kC3BruGiB;E2BsuGjB,uFAAuF,EAAA;;AAGzF;EACE,qC3BhuGc;E2BiuGd,mC3BjuGc;E2BkuGd,mD3BluGc,EAAA;;A2BquGhB;EACE,2C3BnvGkB;E2BovGlB,mBAAmB,EAAA;;AAGrB;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,UAAU;EACV,0C3B/vGkB;E2BgwGlB,sBAAsB;EACtB,kC3B9vGiB;E2B+vGjB,c3BlwGkB;E2BmwGlB,eAAe;EACf,kFAAkF,EAAA;EAbpF;IAiBI,sC3BxwGgB;I2BywGhB,kC3BtwGe;I2BuwGf,c3BnzGqB,EAAA;;A2BuzGzB;EACE,cAAc;EACd,eAAe,EAAA;;AAGjB;EACE,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,0C3BvxGkB;E2BwxGlB,sBAAsB;EACtB,kC3BtxGiB;E2BuxGjB,c3Bn0GuB;E2Bo0GvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB,EAAA;;AAG3B;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,YAAY,EAAA;EARd;IAWI,cAAc;IACd,eAAe;IACf,eAAe;IACf,iBAAiB,EAAA;;AAIrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,2C3B7yGyB;E2B8yGzB,oBAAoB;EACpB,kC3B1yGwB;E2B2yGxB,c3BhzGyB;E2BizGzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB,EAAA;;AAGrB;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,c3B/2GyB;E2Bg3GzB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY,EAAA;EAJd;IAOI,gBAAgB;IAChB,c3Bl4GgB;I2Bm4GhB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB,EAAA;;AAIvB;EACE,gBAAgB;EAChB,c3Bx4GkB;E2By4GlB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB,EAAA;EAVrB;IAaI,kBAAkB,EAAA;;AAItB;EACE,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,0C3Bv3GkB;E2Bw3GlB,oBAAoB;EACpB,mB3B55GsB;E2B65GtB,c3Bn6GuB;E2Bo6GvB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,oFAAoF,EAAA;EAlBtF;IAqBI,kBAAkB;IAClB,gBAAgB,EAAA;EAtBpB;IA0BI,kBAAkB,EAAA;EA1BtB;IA8BI,OAAO;IACP,YAAY,EAAA;EA/BhB;IAmCI,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB,EAAA;EArCzB;IAyCI,qC3Bx5GgB;I2By5GhB,kC3B57GoB,EAAA;E2Bk5GxB;IA8CI,YAAY,EAAA;EAGd;IACE,gBAAgB;IAChB,6C3B15GoB,EAAA;;A2B85GxB;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,c3B16GkB,EAAA;;A2B66GpB;EACE,YAAY,EAAA;;AAGd;EACE,oBAAoB;EACpB,c3B19GyB,EAAA;;A2B69G3B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,c3Br+GyB;E2Bs+GzB,kBAAkB;EAClB,kBAAkB,EAAA;;AAGpB;EACE,cAAc;EACd,eAAe;EACf,+B3Bt8GkB,EAAA;;A2By8GpB;EACE,SAAS;EACT,kBAAkB;EAClB,c3Bn/GyB;E2Bo/GzB,kBAAkB;EAClB,kBAAkB,EAAA;;AAGpB;EAx9FA;IA09FI,gBAAgB,EAAA;EAhkEpB;IAokEI,qDAAqD;IACrD,iBAAiB,EAAA;EAvkCrB;IA2kCI,mBAAmB,EAAA,EACpB;;AAGH;EA38FA;IA68FI,0BAA0B;IAC1B,oBAAoB,EAAA;EA98FxB;IAk9FI,0BAA0B,EAAA;EA38F9B;IA+8FI,WAAW;IACX,gBAAgB,EAAA;EAl7FpB;IAs7FI,eAAe,EAAA;EAz3FnB;IA63FI,cAAc;IACd,eAAe,EAAA;EA72FnB;IAi3FI,oBAAoB,EAAA;EAlxFxB;IAsxFI,yBAAyB,EAAA;EA7xF7B;IAiyFI,oBAAoB,EAAA;EAvqFxB;IA2qFI,oBAAoB,EAAA;EAvoFxB;IA2oFI,QAAQ;IACR,UAAU;IACV,uCAAkD,EAAA;EAxnEtD;IA4nEI,0BAA0B;IAC1B,YAAY,EAAA;EA59ChB;IAg+CI,gBAAgB,EAAA;EA3mEpB;IA+mEI,SAAS;IACT,gBAAgB,EAAA;EAxoCpB;IA4oCI,mBAAmB,EAAA,EACpB;;AAKH;EAEI,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB,EAAA;;AALtB;EASI,WAAW;EACX,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB,EAAA;;AAhB1B;EAoBI,UAAU,EAAA;;AAId;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;EAEZ;IACE,oBAAoB,EAAA;;AAIxB;EAEI,2DAAsF;EACtF,wDAAmF;EACnF,4DAAuF;EACvF,qDAAgF,EAAA;;AAIpF;EACE,4DAAuF;EACvF,qDAAgF;EAChF,WAAW;EACX,sBAAsB,EAAA;EAJxB;IAQM,iBAAiB;IACjB,gBAAgB,EAAA;EATtB;IAcI,sBAAsB,EAAA;EAd1B;IAkBI,eAAe;IACf,mBAAmB;IACnB,YAAY,EAAA;;AAIhB;EACE,uBAAuB;EACvB,wC3B9oHmB;E2B+oHnB,kBAAkB;EAClB,kC3B7oHsB,EAAA;E2ByoHxB;IAOI,sC3B7mHgB;I2B8mHhB,kC3B5mHU,EAAA;E2B+mHZ;IACE,sC3BtmHkB,EAAA;E2B0lHtB;IAgBI,qC3BvpHgB;I2BwpHhB,6C3BxpHgB;I2BypHhB,kC3BtpHc,EAAA;I2BooHlB;MAqBM,qC3B5pHc;M2B6pHd,kC3B1pHY,EAAA;I2BooHlB;MA0BM,oC3BjqHc;M2BkqHd,gC3BzqHc;M2B0qHd,mC3BjqHa,EAAA;;A2BsqHnB;EACE,qBAAqB,EAAA;;AAGvB;EACE,c3BprHkB;E2BqrHlB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB,EAAA;EAEzB;IACE,c3BvoHkB,EAAA;;A2B2oHtB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,wBAAwB;EACxB,0C3B7pHkB;E2B8pHlB,kBAAkB;EAClB,kC3B5pHiB;E2B6pHjB,YAAY;EACZ,YAAY,EAAA;EAVd;IAaI,aAAa,EAAA;EAbjB;IAiBI,cAAc;IACd,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB,EAAA;;AAIrB;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,c3BrrHkB,EAAA;E2BirHpB;IAOI,cAAc;IACd,WAAW;IACX,YAAY,EAAA;;AAIhB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,OAAO,EAAA;;AAGT;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,yC3BlvHmB;E2BmvHnB,kBAAkB;EAClB,c3BrvHyB;E2BsvHzB,kBAAkB,EAAA;;AAGpB;;EAEE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;;EAEE,uBAAuB;EACvB,uC3BlwHmB;E2BmwHnB,kBAAkB,EAAA;EAJpB;;IAOI,sC3BhuHgB,EAAA;E2BmuHlB;;IACE,sC3BxtHkB,EAAA;;A2B4tHtB;EACE,0C3BlvH2C;E2BmvH3C,4CAAuE,EAAA;;AAGzE;;EAEE,uBAAuB;EACvB,4C3BvvHwC;E2BwvHxC,kBAAkB;EAClB,kC3B1vHyC;E2B2vHzC,gEAAgE,EAAA;EANlE;;IASI,uC3BxwHiB;I2BywHjB,kC3BjwH0C,EAAA;E2BuvH9C;;IAcI,sC3B/uHkB,EAAA;;A2BmvHtB;;EAEE,c3BvwHuC;E2BwwHvC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB,EAAA;EAN3B;;IASI,c3B5vHkB,EAAA;;A2BgwHtB;;EAEE,4C3BrxHwC;E2BsxHxC,kBAAkB;EAClB,kC3BnzHsB,EAAA;;A2BszHxB;EACE,qBAAqB,EAAA;EADvB;IAII,eAAe;IACf,gBAAgB;IAChB,OAAO;IACP,YAAY,EAAA;;AAIhB;EAEI,sBAAsB,EAAA;;AAI1B;;EAEE,cAAc;EACd,qBAAqB;EACrB,c3B/0HyB;E2Bg1HzB,kBAAkB;EAClB,gBAAgB,EAAA;EAEhB;;IACE,c3BjyHkB,EAAA;;A2BqyHtB;EACE,uBAAuB;EACvB,kBAAkB,EAAA;;AAGpB;EACE,yBAAuB;EACvB,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU,EAAA;EAXZ;IAcI,sBAAsB;IACtB,kBAAkB;IAClB,sOAOC;IACD,iBAAiB;IACjB,oBAAoB,EAAA;EAzBxB;I3BpqHE,mBAAmB;IACnB,0GACmB,EAAA;IAEnB;MACE,2CA5JuC;MA6JvC,mFAIC;MACD,wJApKsC,EAAA;IA2KxC;MACE,iBAAiB;MACjB,mBAAmB;MACnB,oHAlNgB,EAAA;E2Bi2HpB;IAmCM,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB,EAAA;;AAKtB;EAEI,kDAAuE;EACvE,8FAIY,EAAA;;AAIhB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,+C3B73HmC,EAAA;;A2Bg4HrC;EACE,gBAAgB;EAChB,uBAAuB;EACvB,+C3Bn4HmC,EAAA;;A2Bs4HrC;EACE,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,wBAAwB;EACxB,0C3Bx3HoB;E2By3HpB,kBAAkB;EAClB,oC3B13HoB,EAAA;E2B43HpB;IACE,c3Bh7HuB;I2Bi7HvB,kBAAkB,EAAA;;AAItB;EACE,c3Bn4HoB;E2Bo4HpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB,EAAA;;AAG3B;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY,EAAA;EAZd;IAeI,2DAAsF;IACtF,wDAAmF;IACnF,4DAAuF;IACvF,4DAAuF;IACvF,sBAAsB,EAAA;;AAI1B;EACE,sBAAsB;EACtB,0GACmB,EAAA;EAHrB;IAMI,gBAAgB;IAChB,kBAAkB,EAAA;IAPtB;MAUM,yC3Bh8HuC;M2Bi8HvC,kC3Bl8HwC,EAAA;E2Bu7H9C;I3B3xHE,mBAAmB;IACnB,0GACmB;I2B4yHf,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB,EAAA;I3B7yHpB;MACE,2CA5JuC;MA6JvC,mFAIC;MACD,wJApKsC,EAAA;IA2KxC;MACE,iBAAiB;MACjB,mBAAmB;MACnB,oHAlNgB,EAAA;E2Bw9HpB;IA2BI,uC3B/8HsC;I2Bg9HtC,kC3Bn9H0C;I2Bo9H1C,+C3B59HiB,EAAA;E2B+7HrB;IAiCI,wBAAwB,EAAA;EAjC5B;IAqCI,aAAa,EAAA;;AAIjB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,eAAe,EAAA;EANjB;IASI,aAAa;IACb,gBAAgB,EAAA;EAVpB;IAcI,YAAY,EAAA;;AAIhB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,OAAO,EAAA;;AAGT;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,yC3B7hImB;E2B8hInB,kBAAkB;EAClB,c3BhiIyB;E2BiiIzB,kBAAkB,EAAA;EAVpB;IAaI,sC3B7/HgB;I2B8/HhB,c3BviIqB;I2BwiIrB,iC3B7/HU,EAAA;;A2BigId;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY,EAAA;EARd;IAWI,cAAc;IACd,eAAe;IACf,cAAc,EAAA;EAblB;IAiBI,aAAa,EAAA;;A3BzlIjB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;A4Br8BA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,c5BkBuB;E4BjBvB,4KAE8E,EAAA;EAZhF;IAgBI,kBAAkB,EAAA;IAhBtB;MAmBM,cAAc;MACd,YAAY;MACZ,gD5BgDe;M4B/Cf,iC5BoDa,EAAA;;A4B/CnB;EACE,aAAa;EACb,0DAA0D;EAC1D,uCAAuC;EACvC,mDAEiB;EACjB,OAAO;EACP,YAAY;EACZ,aAAa;EACb,gBAAgB,EAAA;;AAGlB;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;E5Boa7B,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,6DAA6D,EAAA;EAE7D;IACE,UAAU,EAAA;EAGZ;IACE,+BAA+B;IAC/B,oBAAoB,EAAA;EAGtB;IACE,mCA5ZiB;IA6ZjB,oBAAoB;IACpB,2CAA2C,EAAA;EAG7C;IACE,oCAlaiB,EAAA;;A4BnBrB;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,8C5BUmB;E4BTnB,iC5BciB;E4BbjB,kBAAkB;EAClB,gC5BnCuB,EAAA;;A4BsCzB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY,EAAA;EAHd;IAMI,WAAW;IACX,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,cAAc,EAAA;;AAIlB;EACE,mB5BZkB;E4BalB,4C5BbkB,EAAA;;A4BgBpB;EACE,mB5BnCmB;E4BoCnB,4C5BpCmB,EAAA;;A4BuCrB;EACE,oC5B7DyB,EAAA;;A4BgE3B;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gC5BrEuB,EAAA;;A4BwEzB;EACE,c5BjEkB,EAAA;;A4BoEpB;EACE,cAAc;EACd,qBAAqB;EACrB,0C5B1BoB;E4B2BpB,kBAAkB;EAClB,mC5B1BmB;E4B2BnB,c5BlFuB,EAAA;;A4BiJzB;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WA7DuC;EA8DvC,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gCAAyB,EAAA;;AAG3B;EACE,iBAAiB;EACjB,UAAU;EACV,oBAAoB,EAAA;;AAGtB;EACE,UAAU,EAAA;;AAGZ;EACE,oBAAoB,EAAA;;AAGtB;EACE,UAAU;EACV,gC5BzIkB;E4B0IlB,eAAe;EACf,sBAAsB;EACtB,sDAAsD,EAAA;;AAGxD;EACE,gC5BhJkB;E4BiJlB,kBAAkB,EAAA;;AAGpB;EACE,iC5B3IyB;E4B4IzB,kBAAkB;EAClB,sDAA2D,EAAA;;AAG7D;EACE,8B5B3JkB;E4B4JlB,2BAA2B,EAAA;;AAG7B;EACE,8B5BhKkB,EAAA;;A4BmKpB;EACE,+B5B1JyB;E4B2JzB,qDAA0D,EAAA;;AAG5D;;EAEE,4B5BvKiB;E4BwKjB,iC5BjKyB;E4BkKzB,iBAAiB,EAAA;;AAGnB;EACE,oBAAoB,EAAA;;AAGtB;;EAEE,kBAAkB;EAClB,UAAU,EAAA;;AAGZ;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,uBAAuB;EACvB,WA/IuC;EAgJvC,WAAW,EAAA;;AAGb;EACE,2BAAyD,EAAA;;AAG3D;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,yDAGC;EACD,uBAAuB;EACvB,WAtKuC;EAuKvC,WAAW;EACX,YAAY,EAAA;;AAGd;;;;;EA9JE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,uBAAuB;EACvB,SAZoC;EAapC,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,8BAAyB,EAAA;EAEzB;;;;;IACE,eAlBkC;IAmBlC,YAnBkC;IAoBlC,gBApBkC;IAqBlC,gBArBkC,EAAA;EAwBpC;;;;;IACE,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,eAAe,EAAA;;AAiJnB;;;;;EAKE,WAAW;EACX,YAAY,EAAA;;AAGd;;;;;;;;;;EAYM,eAlMgC;EAmMhC,WAAW;EAEX,gBArMgC,EAAA;;AA0MtC;;;;;;;;;;EAYM,eAtNgC;EAuNhC,YAvNgC;EAwNhC,gBAxNgC;EAyNhC,gBAzNgC,EAAA;;AA8NtC;;;;;;;;;;EAYM,eA1OgC;EA2OhC,YA3OgC;EA4OhC,gBA5OgC;EA6OhC,gBA7OgC,EAAA;;AAkPtC;;;;;;;;;;EAYM,eA9PgC;EA+PhC,YA/PgC;EAgQhC,gBAhQgC;EAiQhC,gBAjQgC,EAAA;;AAsQtC;;;;;EA/PE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,uBAAuB;EACvB,SAZoC;EAapC,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,8BAAyB,EAAA;EAEzB;;;;;IACE,eAlBkC;IAmBlC,YAnBkC;IAoBlC,gBApBkC;IAqBlC,gBArBkC,EAAA;EAwBpC;;;;;IACE,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,eAAe,EAAA;;AAoPnB;EAzQE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,uBAAuB;EACvB,SAZoC;EAapC,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,8BAAyB,EAAA;EAEzB;IACE,eAlBkC;IAmBlC,YAnBkC;IAoBlC,gBApBkC;IAqBlC,gBArBkC,EAAA;EAwBpC;IACE,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,eAAe,EAAA;;AAwPnB;;;;;EA7QE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,uBAAuB;EACvB,SAZoC;EAapC,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,8BAAyB,EAAA;EAEzB;;;;;IACE,eAlBkC;IAmBlC,YAnBkC;IAoBlC,gBApBkC;IAqBlC,gBArBkC,EAAA;EAwBpC;;;;;IACE,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,eAAe,EAAA;;AAgQnB;;;;;EArRE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,uBAAuB;EACvB,SAZoC;EAapC,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,8BAAyB,EAAA;EAEzB;;;;;IACE,eAlBkC;IAmBlC,YAnBkC;IAoBlC,gBApBkC;IAqBlC,gBArBkC,EAAA;EAwBpC;;;;;IACE,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,eAAe,EAAA;;AAwQnB;;;;;EA7RE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,uBAAuB;EACvB,SAZoC;EAapC,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,8BAAyB,EAAA;EAEzB;;;;;IACE,eAlBkC;IAmBlC,YAnBkC;IAoBlC,gBApBkC;IAqBlC,gBArBkC,EAAA;EAwBpC;;;;;IACE,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,eAAe,EAAA;;AAgRnB;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB,EAAA;EAJxB;;IAOI,gBAnTkC,EAAA;EA4StC;;IAWI,kBAAkB;IAClB,eAAe,EAAA;;AAInB;EAEI,kBAAkB;EAClB,eAAe;EACf,YAAY,EAAA;EAJhB;IAUM,kBAAkB;IAClB,eAAe;IACf,YAAY,EAAA;;AAKlB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAvVuC;EAwVvC,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAhWuC;EAiWvC,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAxWuC;EAyWvC,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,sBAAsB;EACtB,SApX+B;EAqX/B,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB,EAAA;;AAGxB;EACE,aAAa;EACb,sBAAsB;EACtB,WAlYuC;EAmYvC,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,6DAGC;EACD,uBAAuB;EACvB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,SA7Y+B,EAAA;;AAgZjC;EAII,yBAAyB;EACzB,4BAA4B,EAAA;;AAIhC;EACE,WAAW;EACX,YAAY;EACZ,SA5Z+B,EAAA;;AA+ZjC;EACE,aAAa;EACb,iEAGG;EACH,kBAAkB;EAClB,YAxaoC;EAyapC,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAnbuC;EAobvC,WAAW;EACX,YAAY;EACZ,cAAc;EACd,WAAW,EAAA;;AAGb;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,gB5BjfkC;E4BkflC,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,gD5BlfmB;E4BmfnB,qBAAqB,EAAA;;AAGvB;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,2BAA2B;EAC3B,WAAW;EACX,YAAY,EAAA;;AAnaZ;;;;;;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe,EAAA;;AAGjB;;;;;;EACE,WAAW;EACX,eAAe;EACf,YAAY,EAAA;;AA0ahB;;;EAII,WAAW;EACX,YAAY;EACZ,eAAe,EAAA;;AANnB;;;EAYI,WAAW;EACX,eAAe;EACf,YAAY,EAAA;;AAKhB;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;EACT,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW,EAAA;;AAGb;EACE,WAAW;EACX,eAAe,EAAA;;AAGjB;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW,EAAA;;AAGb;EACE,UAAU;EACV,YAAY;EACZ,cAAc;EACd,qC5BhnBuB,EAAA;;A4BmnBzB;EACE,aAAa;EACb,6DAA6G;EAC7G,YAAY;EACZ,WAAW;EACX,mBAAmB,EAAA;;AAKrB;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kC5BjlBsB;E4BklBtB,0C5BzlBmB;E4B0lBnB,6C5BrlBiB;E4BslBjB,wDAAwD,EAAA;;AAG1D;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sBAAsB,EAAA;EAJxB;IAUI,kBAAkB;IAClB,eAAe;IACf,YAAY,EAAA;EAZhB;IAgBI,4BAA4B;IAC5B,gBAAgB,EAAA;EAjBpB;IAqBI,4BAA4B,EAAA;;AAIhC;EACE,WAAW;EACX,YAAY;EACZ,gBAtkBoC;EAukBpC,sBAAsB,EAAA;EAJxB;IAeI,WAAW;IACX,YAAY;IACZ,gBAplBkC,EAAA;;AAwlBtC;;;EAGE,UAAU;EACV,gBAAgB,EAAA;EAJlB;;;IAOI,kBAAkB;IAClB,eAAe,EAAA;;AAInB;;;;;;;;;;;;;;;;;;;;;;;;;;EAeI,cAAc;EACd,WAAW;EAEX,gBAtnBkC,EAAA;;AA0nBtC;;EAEE,eAAe;EACf,WAAW;EACX,2BAAW;EACX,2BAAW,EAAA;EALb;;IAQI,uBAAuB;IACvB,mBAAmB,EAAA;EATvB;;IAaI,iBAAiB,EAAA;IAbrB;;MAgBM,iBAAiB,EAAA;EAhBvB;;IAqBI,kBAAkB,EAAA;EArBtB;;IAyBI,kBAAkB;IAClB,wBAAwB,EAAA;EA1B5B;;IA8BI,4BAA4B,EAAA;EA9BhC;;IAkCI,wBAAwB;IACxB,YAAY,EAAA;;AAIhB;EACE,eAAe;EACf,WAAW;EACX,2BAAW;EACX,2BAAW,EAAA;;AAGb;EACE,WAAW;EACX,YAAY;EACZ,2BAAW;EACX,uBAAuB,EAAA;;AAGzB;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,uBAAuB,EAAA;;AAGzB;;EAEE,UAAU;EACV,gBAAgB,EAAA;EAHlB;;IAMI,WAAW;IACX,eAAe,EAAA;EAPnB;;IAWI,qBAAqB;IACrB,gBAAgB,EAAA;EAZpB;;IAgBI,iBAAiB,EAAA;IAhBrB;;MAmBM,iBAAiB,EAAA;EAnBvB;;IAwBI,kBAAkB,EAAA;EAxBtB;;IA4BI,8BAA8B,EAAA;EA5BlC;;IAgCI,uBAAuB;IACvB,YAAY,EAAA;;AAIhB;;EAEE,WAAW,EAAA;;AAGb;;;;;EAMI,kBAAkB;EAClB,eAAe;EACf,YAAY,EAAA;;AAIhB;EACE,UAAU;EACV,gBAAgB,EAAA;EAFlB;IAKI,WAAW;IACX,eAAe,EAAA;;AAKnB;EACE,sC5B7yBkB;E4B8yBlB,oH5BxyBiB,EAAA;;A4B8yBnB;EACE,uC5Bv0BmB,EAAA;;A4B00BrB;EACE,uC5Bh2ByB;E4Bi2BzB,aAAa,EAAA;;AAIf;EAEI,oFAIC;EACD,8C5B3zBuB,EAAA;;A4B+zB3B;EAEI,oFAIC;EACD,8C5Bl2BiB,EAAA;;A4Bs2BrB;EACE,uC5B11ByC,EAAA;E4By1B3C;;IAMI,uBAAuB;IACvB,2C5Bt2BiC,EAAA;;A4B02BrC;EACE,8FAIY;EACZ,sDAAwE;EACxE,mD5B72BwC,EAAA;;A4Bg3B1C;;EAGI,qFAIC;EACD,8C5B15BqB,EAAA;;A4B85BzB;EACE,UAAU;EACV,gD5Bt3BmB;E4Bu3BnB,kC5Bh3BsB,EAAA;E4B62BxB;IAMI,8C5Bp6BqB;I4Bq6BrB,gBAAgB,EAAA;;AAIpB;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,sBAAsB,EAAA;;AAGxB;E5B3tBE,kBAAkB;EAClB,gB4B2tBuD;E5B1tBvD,UAAU;EACV,8CA3NuB;EA4NvB,4DAAoE;EACpE,gBAAgB,EAAA;EAEhB;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,SAAS;IACT,UAAU;IACV,kDAAkD;IAClD,sBAAsB;IACtB,iCAAiC;IACjC,4BAA4B,EAAA;EAG9B;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,iZAQC;IACD,oBAAoB,EAAA;E4BwrBxB;IAII,6BAA6B,EAAA;EAJjC;IAQI,kBAAkB;IAClB,UAAU;IACV,gBAAgB,EAAA;EAVpB;IAcI,+BAA+B,EAAA;;AAInC;EACE,8C5Bt8BuB,EAAA;;A4By8BzB;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,YAAY;EACZ,+BAA+B,EAAA;;AAGjC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY,EAAA;EAJd;IAOI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,c5B59BqB;I4B69BrB,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB,EAAA;;AAI3B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gC5Bt+BuB;E4Bu+BvB,iBAAiB;EACjB,sBAAsB,EAAA;;AAGxB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gC5Bh/BuB,EAAA;;A4Bm/BzB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,c5Bv8ByB;E4Bw8BzB,kC5Bp8BwB;E4Bq8BxB,0C5Bx8BoB;E4By8BpB,+E5Bt8BwB,EAAA;;A4B28B1B;EAEE,wBAAwB;EACxB,kBAAkB,EAAA;;AAGpB;EACE,SAAS;EACT,kBAAkB;EAClB,gC5B5gCuB,EAAA;;A4B+gCzB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,8BAA8B;EAC9B,iC5Br+BiB,EAAA;;A4Bw+BnB;;EAEE,+BAA+B;EAC/B,YAAY,EAAA;;AAGd;;EAGI,SAp8B6B,EAAA;;AA4iBjC;EA6ZE,SAz8B+B;EA08B/B,YAAY;EACZ,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,SAl9B+B;EAm9B/B,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,sBAAsB,EAAA;EARxB;IAWI,eAv9BkC;IAw9BlC,YAx9BkC;IAy9BlC,YAAY;IACZ,eAAe,EAAA;;AAzBhB;EA8BD,aAAa;EACb,yDAAmF;EACnF,SAn+B+B;EAo+B/B,WAAW;EACX,YAAY,EAAA;;AAGd;;;;EAIE,6CAAW,EAAA;;AAIb;;;EAII,gBAAgB,EAAA;;AAIpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;EACpB,iC5B5iCiB;E4B6iCjB,0C5BnjCkB;E4BojClB,kBAAkB;EAClB,gBAAgB;EAChB,c5BtjCkB;E4BujClB,sBAAsB;EACtB,mBAAmB,EAAA;;AAIrB;;EAEE,gCAAsC;EACtC,wDAAyD,EAAA;;AAG3D;;EAEE,sC5BxjCoB;E4ByjCpB,oD5BzjCoB,EAAA;;A4B4jCtB;;EAEE,aAAa;EACb,mBAAmB;EACnB,iGAAiG,EAAA;;AAGnG;;EAEE,eAAe,EAAA;;AAGjB;;EAGI,aAAa,EAAA;;AAMjB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,kC5B5lCsB;E4B6lCtB,0C5BpmCmB,EAAA;;A4BumCrB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gC5BtpCuB,EAAA;;A4B2pCzB;EACE,YAAY;EACZ,gBA/jCoC;EAgkCpC,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,0C5BxnCmB;E4BynCnB,kC5BlnCsB,EAAA;;A4BqnCxB;EACE,sC5B9nCkB;E4B+nClB,oD5B/nCkB,EAAA;;A4BkoCpB;EACE,sC5BrpCmB,EAAA;;A4BwpCrB;EACE,wBAAwB;EACxB,kD5BjrCuB;E4BkrCvB,iC5BnoCiB,EAAA;E4BgoCnB;IAMI,gBAAgB,EAAA;EANpB;IAUI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,c5B5rCqB,EAAA;;A4BgsCzB;E5Bx+BE,kBAAkB;EAClB,gB4Bw+BuD;E5Bv+BvD,UAAU;EACV,8CA3NuB;EA4NvB,4DAAoE;EACpE,gBAAgB,EAAA;EAEhB;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,SAAS;IACT,UAAU;IACV,kDAAkD;IAClD,sBAAsB;IACtB,iCAAiC;IACjC,4BAA4B,EAAA;EAG9B;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,iZAQC;IACD,oBAAoB,EAAA;E4Bq8BxB;IAII,6BAA6B,EAAA;EAJjC;IAQI,c5BxsCqB,EAAA;E4BgsCzB;IAYI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,YAAY;IACZ,cAAc;IAEd,wBAAwB,EAAA;EArB5B;IAyBI,kBAAkB;IAClB,gBAAgB;IAChB,gC5B3tCqB;I4B4tCrB,iBAAiB,EAAA;;AAIrB;EACE,+BAA+B,EAAA;;AAGjC;EACE,gBAAgB,EAAA;EADlB;IAII,oBAAoB,EAAA;;AAMxB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,YAAY,EAAA;EALd;IAQI,YAAY,EAAA;;AAIhB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,eAAe,EAAA;;AAGjB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,oBAAoB;EACpB,mC5BjuCkB;E4BkuClB,0C5BluCkB;E4BmuClB,c5BnuCkB,EAAA;;A4BsuCpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,0C5B/tCoB;E4BguCpB,oBAAoB;EACpB,c5BluCyB;E4BmuCzB,mC5BjuCc;E4BkuCd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB,EAAA;;AAKrB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB,EAAA;;AAGxB;EACE,kBAAkB;EAClB,8C5BtwCmB,EAAA;E4BowCrB;IAKI,gBAAgB;IAChB,cAAc,EAAA;;AAIlB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gC5B5zCuB,EAAA;;A4B+zCzB;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,iC5BvxCiB,EAAA;;A4B0xCnB;EACE,oC5BhyCmB;E4BiyCnB,0C5BlyCkB,EAAA;;A4BqyCpB;EACE,YAAY;EACZ,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gC5B71CuB;E4B81CvB,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gC5Bt2CuB,EAAA;;A4By2CzB;EACE,iBAAiB;EACjB,gC5B32CuB;E4B42CvB,kBAAkB,EAAA;;AAGpB;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,4BAA4B,EAAA;EAE5B;IACE,gBAAgB;IAChB,qBAAqB,EAAA;EAGvB;IACE,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,aAAa,EAAA;;AAMjB;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,8C5Bn2CmB;E4Bo2CnB,gC5B/1CiB;E4Bg2CjB,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EAEI,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+B5B35CqB,EAAA;;A4B+5CzB;;;;EAIE,0C5Bz3CmB;E4B03CnB,mBAAmB;EACnB,kC5Bp3CsB;E4Bq3CtB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;;AAGb;EACE,0C5Bz4CmB;E4B04CnB,kBAAkB;EAClB,iC5Bt4CiB;E4Bu4CjB,sBAAsB,EAAA;;AAGxB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB,EAAA;EAJxB;IAOI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,c5Bn8CqB,EAAA;;A4Bu8CzB;EACE,cAAc;EACd,eAAe;EACf,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gC5Bh9CuB,EAAA;;A4Bm9CzB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,0C5Bh7CkB;E4Bi7ClB,mC5Bh7CmB,EAAA;;A4Bm7CrB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+B5B17CkB,EAAA;;A4B67CpB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,0C5Bn8CmB;E4Bo8CnB,kBAAkB;EAClB,iC5Bh8CiB;E4Bi8CjB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,gBAAgB;EAChB,c5BhgDuB,EAAA;;A4BmgDzB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+B5B/9CkB,EAAA;;A4Bk+CpB;EACE,0C5Bl+CmB;E4Bm+CnB,kBAAkB;EAClB,iC5B/9CiB;E4Bg+CjB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;;AAGb;EACE,SAAS;EACT,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gC5B9hDuB,EAAA;;A4BiiDzB;EACE,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,+B5B5/CkB,EAAA;;A4B+/CpB;EACE,gC5BziDuB,EAAA;;A4B4iDzB;EACE,gBAAgB;EAChB,c5B9iDuB,EAAA;;A4BijDzB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,0C5B7gDkB;E4B8gDlB,oC5B7gDmB;E4B8gDnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+B5BnhDkB,EAAA;;A4BshDpB;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,UAAU,EAAA;;AAGZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,wBAAwB;EACxB,oBAAoB;EACpB,0C5BzhDoB;E4B0hDpB,oFAIC;EACD,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,c5BniDyB;E4BoiDzB,mD5BriDyB;E4BsiDzB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAKrB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU,EAAA;;AAGZ;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB,EAAA;EALpB;IAQI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,gD5B1kDiB,EAAA;;A4B8kDrB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,0C5BtlDkB;E4BulDlB,kC5B/kDsB;E4BglDtB,cAAc,EAAA;;AAGhB;EACE,WAAW;EACX,YAAY;EACZ,aAAa,EAAA;;AAGf;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gC5BvpDuB,EAAA;;A4B0pDzB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gC5BtqDuB,EAAA;;A4ByqDzB;EAEE,wBAAwB;EACxB,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,c5BlrDuB;E4BmrDvB,gBAAgB;EAChB,uBAAuB,EAAA;;AAGzB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,+B5BnpDkB;E4BopDlB,iBAAiB;EACjB,uBAAuB,EAAA;;AAGzB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gC5BpsDuB;E4BqsDvB,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB,EAAA;;AAGzB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+B5BpqDkB,EAAA;;A4BuqDpB;EAhtDA;IAktDI,0BAA0B;IAC1B,8CAGU,EAAA;EAhVd;IAoVI,iBAAiB;IACjB,6C5BjrDiB,EAAA,E4BkrDlB;;AAGH;EA3pBA;;;;IAgqBI,WAAW;IACX,eAAe,EAAA;IALjB;;;;MAQI,cAAc;MACd,WAAW;MACX,eAAe,EAAA,EAChB;;AAIL;EA9kCA;IAglCI,YAAY;IACZ,eAAe,EAAA;IAFjB;MAWI,YAAY;MACZ,eAAe,EAAA;EAInB;;;;IAME,eAxqDkC;IAyqDlC,YAzqDkC;IA0qDlC,gBA1qDkC;IA2qDlC,gBA3qDkC,EAAA;EA8qDpC;;;;IAME,eAprDkC;IAqrDlC,YArrDkC;IAsrDlC,gBAtrDkC;IAurDlC,gBAvrDkC,EAAA;EAqKtC;;;;;IA0hDI,gBAAgB;IAChB,2BAA2B;IAC3B,uBAAuB,EAAA;EAGzB;;;;IAME,eA1sDkC;IA2sDlC,YA3sDkC;IA4sDlC,gBA5sDkC;IA6sDlC,gBA7sDkC,EAAA;EAgtDpC;;;;IAME,eAttDkC;IAutDlC,YAvtDkC;IAwtDlC,gBAxtDkC;IAytDlC,gBAztDkC,EAAA;EA6jCtC;IAgqBI,YAAY;IACZ,eAAe,EAAA;EAGjB;;;;;;;IAOE,eAAe,EAAA;EAGjB;;IAEE,WAAW,EAAA;EAxtCf;IA4tCI,sBAAsB;IACtB,mBAAmB,EAAA;IAFrB;MAKI,aAAa,EAAA;IALjB;MASI,aAAa,EAAA,EACd;;A5Bp3DL;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;A6Bv8BA;EACI,kBAAkB;EAClB,aAAa;EACb,mBAAmB,EAAA;EAHvB;IAMQ,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,yBAA0B;IAC1B,mBAAmB,EAAA;;AAI3B;EACI,YAAY;EACZ,SAAS,EAAA;;AAGb;EACI,kBAAkB;EAClB,qBAAqB,EAAA;EAFzB;IAMQ,WAAW;IACX,0BAA2B,EAAA;EAPnC;IAWQ,cAAc;IACd,WAAW;IACX,YAAY,EAAA;EAbpB;IAiBQ,kBAAkB;IAClB,QAAQ;IACR,WAAW;IAGX,kBAAkB;IAClB,gBAAgB;IAChB,4DAA4D;IAE5D,8BAA8B;IAC9B,gDAAgD,EAAA;IA3BxD;MA8BY,iDAAiD,EAAA;IA9B7D;MAkCY,wHAAwH;MACxH,qNAC4I;MAC5I,uCAAuC,EAAA;MArCnD;QAwCgB,0BAA0B,EAAA;MAxC1C;QA4CgB,kBAAmB,EAAA;IA5CnC;MAiDY,0BAA0B,EAAA;IAjDtC;MAqDY,0BAA0B,EAAA;IArDtC;MAyDY,gBAAgB,EAAA;IAzD5B;MA8DY,kBAAkB;MAClB,OAAO;MACP,SAAS;MACT,WAAW;MACX,YAAY;MACZ,YAAY;MACZ,eAAe,EAAA;IApE3B;MAwEY,cAAc;MACd,kBAAkB;MAClB,QAAQ;MACR,SAAS;MACT,eAAe;MACf,cAAc;MACd,gCAAgC;MAChC,mBAAmB;MACnB,iDAAiD;MACjD,YAAY,EAAA;EAjFxB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,SAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,SAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,SAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,SAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,SAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,SAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,SAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,SAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,SAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,WAAO,EAAA;EAvFnB;IAuFY,UAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,UAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,UAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,UAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,UAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,UAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,UAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,UAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,UAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,UAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,UAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,YAAO,EAAA;EAvFnB;IAuFY,UAAO,EAAA;EAvFnB;IA4FQ,QAAQ;IACR,YAAY,EAAA;EA7FpB;IAiGQ,aAAa;IACb,YAAY,EAAA;EAlGpB;IAsGQ,YAAY;IACZ,YAAY,EAAA;EAvGpB;IA2GQ,aAAa;IACb,YAAY,EAAA;EA5GpB;IAgHQ,WAAW;IACX,YAAY,EAAA;EAjHpB;IAqHQ,aAAa;IACb,YAAY,EAAA;EAtHpB;IA0HQ,YAAY;IACZ,YAAY,EAAA;EA3HpB;IA+HQ,aAAa;IACb,YAAY,EAAA;;AAIpB;EACI,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU,EAAA;;AAGd;EACI,4CAA4C;EAC5C,6CAA6C,EAAA;;AApJjD;EAwJI,YAAY;EACZ,aAAa,EAAA;;AAGjB;EACI,kBAAkB;EAClB,wBAAwB;EACxB,WAAW,EAAA;;AAKf;EACI,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe,EAAA;EAJnB;IAOQ,c7B3JY,EAAA;E6BoJpB;IAWQ,c7BvJI,EAAA;;A6B2JZ;EACI,kBAAkB,EAAA;;AAGtB;EACI,kBAAkB;EAClB,YAAY;EACZ,eAAe,EAAA;;AAGnB;EACI,kBAAkB;EAAE,8DAAA,EAA+D;;AAGvF;EACI,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,sBAAsB,EAAA;;AAG1B;EAEQ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EAEnB,SAAS,EAAA;;A7B3NjB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;A8Bp8BA;EACE,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB,EAAA;;AAEpB;EACE,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,YAAY;EACZ,+BAA+B,EAAA;;AAGjC;EAEM,kBAAkB,EAAA;EAFxB;IAKU,4BAA4B,EAAA;EALtC;IASQ,gBAAgB,EAAA;EATxB;IAaU,4BAA4B,EAAA;;AAMtC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB,EAAA;EAJpB;IAOI,aAAa,EAAA;;AAIjB;EACE,kBAAkB;EAClB,YAAY,EAAA;;AAGd,mDAAA;AACA;;;;EAII,wBAAwB,EAAA;;AAG5B;EACE,kBAAkB;EAClB,mB9B9BsB;E8B+BtB,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,yB9BlCgB,EAAA;;A8BqClB,wBAAA;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB,EAAA;;AAGpB;EACE,eAAe;EACf,c9BzDkB;E8B0DlB,gBAAgB,EAAA;;AAGlB;EACE,WAAW;EACX,YAAY;EACZ,yB9BtDgB;E8BuDhB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe,EAAA;;AAGjB,2CAAA;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,kBAAkB,EAAA;;AAGpB;EACE,WAAW;EACX,YAAY;EACZ,yB9B9EY;E8B+EZ,kBAAkB;EAClB,eAAe;EACf,qDAAqD,EAAA;EANvD;IASI,uBAAuB,EAAA;;AAI3B;EACE,sBAAsB;EACtB,0CAA0C,EAAA;;AAG5C;EACE,uBAAuB,EAAA;;AAGzB,2CAAA;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EAAE,sCAAA,EAAuC;;AAG/D;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EAAE,sCAAA,EAAuC;;AAG/D;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,gCAAgC,EAAA;;AAGlC,mCAAA;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,0FAGC;EACD,kBAAkB;EAClB,eAAe,EAAA;;AAGjB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,gCAAgC,EAAA;;A9B7LlC;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;A+Bv8BA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EAEf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,c/BmBkB;E+BlBlB,mB/BokBkB;E+BnkBlB,yB/BwkBgC;E+BvkBhC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,sBAAsB,EAAA;EAEtB;IACE,QAAQ,EAAA;EAGT;;IAGG,uBAAuB,EAAA;EAzB7B;IA8BI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,QAAQ;IACR,aAAa;IACb,oBAAoB;IACpB,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,YAAY,EAAA;IA7ChB;MAgDM,aAAa;MACb,mBAAmB,EAAA;IAjDzB;MAqDM,cAAc;MACd,YAAY;MACZ,gBAAgB;MAChB,uBAAuB;MACvB,mBAAmB;MACnB,eAAe;MACf,0BAA0B,EAAA;EAI9B;IACE,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB,EAAA;EAGzB;IACE,cAAc;IACd,aAAa;IACb,gBAAgB,EAAA;EAGlB;IACE,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,mBAA2B;IAC3B,gCAAgC;IAChC,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,YAAY,EAAA;EAGd;IACE,qCAAqC,EAAA;EAGvC;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ,EAAA;EAGV;IACE,YAAY;IACZ,gBAAgB,EAAA;EAGlB;IAEE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,oBAAoB;IACpB,aAAa;IACb,uBAAuB,EAAA;EAGzB;IACE,gBAAgB,EAAA;EAGlB;IAEE,qBAAqB,EAAA;EAGvB;IACE,gBAAgB,EAAA;EAGlB;IAEE,cAAc;IACd,eAAe;IACf,cAAc;IACd,SAAS;IACT,SAAS;IACT,kBAAkB;IAClB,oCAAoC;IACpC,c/BlHqB;I+BmHrB,aAAa;IACb,oBAAoB;IACpB,gBAAgB,EAAA;EAGlB;IAEE,YAAY;IACZ,2DAA2D;IAC3D,0BAA0B,EAAA;IAJ3B;MAOG,gDAAgD,EAAA;EAIpD;IACE,YAAY;IACZ,gBAAgB,EAAA;EAGlB;IACE,YAAY;IACZ,gBAAgB,EAAA;EAGlB;IACE,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,mBAA4B;IAC5B,gCAAgC;IAChC,eAAe;IACf,cAAc,EAAA;EAGhB;IACE,mBAA4B;IAC5B,c/BlKgB,EAAA;E+BqKlB;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc,EAAA;EAGhB;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,c/BsY0B;I+BrY1B,mB/B+XgB;I+B9XhB,yB/BiYoB;I+BhYpB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,4G/BoY0C,EAAA;I+B/X1C;MACE,eAAe,EAAA;IAGjB;MACE,gBAAgB;MAChB,gBAAgB,EAAA;IAGlB;MACE,gBAAgB;MAChB,gBAAgB,EAAA;IAGlB;MACE,gBAAgB;MAChB,gBAAgB;MAChB,UAAU,EAAA;EAId;IACE,SAAS;IACT,qBAAqB;IACrB,mB/BiW4B;I+BhW5B,c/BkW0B;I+BjW1B,gC/BgW8B;I+B/V9B,gBAAgB;IAChB,eAAe;IACf,yBAAyB,EAAA;EAG3B;IACE,uBAAuB,EAAA;EAGzB;IACE,c/BwVwB,EAAA;E+BrV1B;IACE,c/B/KkB,EAAA;;A+BmLtB;EACE,YAAY,EAAA;;AAGd;EACE,eAAe;EACf,yBAAyB;EACzB,c/BwU8B;E+BvU9B,iBAAiB;EACjB,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,eAAe,EAAA;;AAGjB;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,c/BsT4B;E+BrT5B,eAAe;EACf,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB;EACjB,sBAAsB,EAAA;;AAGxB;EACE,gBAAgB,EAAA;;AAGlB;EACE,eAAe;EACf,gBAAgB;EAChB,c/BqS4B;E+BpS5B,sBAAsB,EAAA;;AAGxB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,6B/B2RsB,EAAA;;A+BxRxB;;EAEE,eAAe,EAAA;;AAGjB;EACE,eAAe;EACf,gBAAgB;EAChB,c/BmR4B;E+BlR5B,mBAAmB;EACnB,sBAAsB,EAAA;;AAGxB;;EAEE,eAAe;EACf,yBAAyB;EACzB,c/B0Q4B;E+BzQ5B,mBAAmB;EACnB,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAInB;EACE,aAAa;EACb,gDAAgD;EAChD,aAAa;EACb,kBAAkB,EAAA;;AAGpB;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,c/BqP4B,EAAA;;A+BlP9B;EACE,kBAAkB,EAAA;;AAGpB;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,c/B0O8B;E+BzO9B,iBAAiB,EAAA;;AAGnB;EACE,c/BkO8B,EAAA;;A+B/NhC;EACE,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,gDAAgD;EAChD,aAAa;EACb,iBAAiB,EAAA;;AAGnB;EACE,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,oBAAoB,EAAA;;AAGtB;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yB/BkMsB;E+BjMtB,mB/B+LuB;E+B9LvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,c/B+L8B;E+B9L9B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB,EAAA;;AAGzB;EACE,mB/BmL6B;E+BlL7B,c/BsL4B,EAAA;;A+BnL9B;EACE,qB/BgL8B;E+B/K9B,8C/BqL4C;E+BpL5C,c/BgL4B,EAAA;;A+B7K9B;EACE,gBAAgB,EAAA;;AAGlB;;EAEE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,c/BqK8B,EAAA;;A+BlKhC;EACE,eAAe,EAAA;;AAGjB;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,c/ByJ4B,EAAA;;A+BtJ9B;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,c/BoJ0B,EAAA;;A+BjJ5B;EACE,eAAe,EAAA;;AAGjB;EACE,aAAa;EACb,gDAAgD;EAChD,aAAa;EACb,eAAe,EAAA;;AAGjB;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yB/B6HsB;E+B5HtB,mB/B0HuB,EAAA;;A+BvHzB;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,c/BwH8B;E+BvH9B,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,c/B2G4B,EAAA;;A+BxG9B;EACE,aAAa;EACb,gDAAgD;EAChD,aAAa;EACb,oBAAoB,EAAA;EAEpB;IACE,gDAAgD,EAAA;;AAIpD;EACE,aAAa;EACb,gDAAgD;EAChD,aAAa;EACb,iBAAiB,EAAA;;AAGnB;EACE,oBAAoB,EAAA;;AAGtB;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB,EAAA;;AAGxB;EACE,mBAAmB;EACnB,sBAAsB,EAAA;;AAGxB;EAEI,iBAAiB,EAAA;;AAIrB;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,YAAY,EAAA;;AAGd;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa,EAAA;E/BmRb;IACI,UA1Me,EAAA;EA6MnB;IACI,mBA7MyB;IA8MzB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3O0B;IA4O1B,kBAAkB,EAAA;IAElB;MACI,yBA9OwB,EAAA;;A+BhDlC;EACE,iBAAiB,EAAA;;AAGnB;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,c/BwC8B;E+BvC9B,iBAAiB,EAAA;;AAGnB;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,yB/ByBsB;E+BxBtB,mB/BsBuB;E+BrBvB,c/B0B4B;E+BzB5B,eAAe;EACf,gBAAgB,EAAA;EAXlB;IAcI,c/BuBwB,EAAA;E+BrC5B;IAkBI,aAAa;IACb,qB/Bc4B;I+Bb5B,8C/BmB0C,EAAA;;A+Bf9C;EACE,eAAe;EACf,c/BU8B;E+BT9B,iBAAiB,EAAA;;AAGnB;EACE,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,c/BE0B,EAAA;;A+BC5B;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU,EAAA;;AAGZ;EACE,cAAc;EACd,gC/BdsB,EAAA;E+BYxB;IAKI,mBAAmB;IACnB,iBAAiB,EAAA;;AAIrB;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,c/BvB4B;E+BwB5B,sBAAsB,EAAA;;AAGxB;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,c/B7B0B;E+B8B1B,sBAAsB,EAAA;;AAGxB;EACE,6B/BvCsB;E+BwCtB,kBAAkB;EAClB,gBAAgB,EAAA;;AAGlB;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,c/BrD8B;E+BsD9B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB,EAAA;;AAG3B;EACE,c/B7DgC,EAAA;;A+BgElC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yB/BzEsB;E+B0EtB,mB/B5EuB;E+B6EvB,c/BxE4B;E+ByE5B,gBAAgB;EAChB,cAAc;EACd,cAAc,EAAA;;AAGhB;EACE,cAAc;EACd,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,gBAAgB;EAChB,iCAAiC,EAAA;;AAGnC;EACE,iBAAiB,EAAA;;AAGnB;EACE,oBAAoB,EAAA;;AAGtB;EACE,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,gDAAgD;EAChD,aAAa;EACb,oBAAoB,EAAA;;AAGtB;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,c/BhH8B,EAAA;;A+BmHhC;EACE,eAAe;EACf,gBAAgB;EAChB,c/BvH4B;E+BwH5B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,qBAAqB;EACrB,iBAAiB,EAAA;;AAGnB;EACE,eAAe;EACf,c/BpI8B;E+BqI9B,kBAAkB,EAAA;;AAGpB;EACE,eAAe;EACf,c/B1I8B;E+B2I9B,kBAAkB,EAAA;;AAGpB;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,c/BtJ4B,EAAA;EA8N5B;IACI,UA1Me,EAAA;EA6MnB;IACI,mBA7MyB;IA8MzB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3O0B;IA4O1B,kBAAkB,EAAA;IAElB;MACI,yBA9OwB,EAAA;;A+B2JlC;EACE,eAAe,EAAA;;AAlff;EAsfA,c/B7J0B,EAAA;;A+BrV1B;EAsfA,c/BpqBoB,EAAA;;AAjFtB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AgCv8BA;EACI,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;EACZ,ahCwlBe;EgCvlBf,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,oBAAoB,EAAA;EAhBxB;IAmBQ,chCUiB;IgCTjB,iBAAiB,EAAA;;AAIzB,mGAAA;AAGA;EACI,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,yFAAA;EACA,iBAAiB;EAEjB;;;MjC4gkCE;EiCz6jCF,iFAAA,EAAmF;EA3GvF;IAaQ,mBAAmB;IACnB,cAAc;IACd,MAAM;IACN,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,6FAE+C;IhCikBrD,mHAAiF;IACjF,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B,EAAA;IgCzlB7B;MAyBY,WAAW;MACX,YAAY;MACZ,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,eAAe;MACf,SAAS;MACT,YAAY;MACZ,gBAAgB;MAChB,chC/BQ;MgCgCR,yBAAyB;MACzB,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,gBAAgB;MAChB,uBAAuB;MACvB,gBAAgB;MAChB,mBAAmB;MACnB,kBAAkB;MAClB,gBAAgB;MAChB,sBAAsB;MACtB,uFAEsC,EAAA;MAjDlD;QAoDgB,WAAW;QACX,kBAAkB;QAClB,QAAQ;QACR,QAAQ;QACR,2BAA2B;QAC3B,UAAU;QACV,WAAW;QACX,yBhCrDF,EAAA;MgCNd;QA+DgB,WAAW;QACX,YAAY;QACZ,kBAAkB,EAAA;MAjElC;QAqEgB,cAAc;QACd,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB,EAAA;MAxEnC;;;QA8EgB,cAAc,EAAA;EA9E9B;IAoFQ,gBAAgB;IAChB,gBAvFmB,EAAA;EAE3B;IAyFQ,SA3FmB;IA4FnB,iBAAiB,EAAA;EA1FzB;IA8FQ,aAAa;IACb,iBAAiB;IACjB,QAAQ,EAAA;EAhGhB;IAoGQ,SAtGmB,EAAA;EAE3B;IAwGQ,iBAAiB,EAAA;EAxGzB;IA6GQ,0ChCjEa;IgCkEb,mBAAmB;IACnB,YAAY,EAAA;;AAIpB;EACI,kBAAkB;EAClB,iBAAiB,EAAA;;AAGrB,uGAAA;AACA;EACI,kBAAkB;EAClB,UAAU,EAAA;;AAGd;EACI,8BhC5HgB,EAAA;;AgC+HpB;EACI,6BhChIgB,EAAA;;AgCmIpB;EACI,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;EACtB,+BAA+B;EAC/B,gCAAgC;EAChC,UAAU;EAGV,gBAAgB;EAChB,kBAAkB,EAAA;EAdtB;IAiBQ,2FAAA;IACA,4BAA4B;IAC5B,UAAU,EAAA;IAnBlB;MAsBY,WAAW;MACX,kBAAkB;MAClB,QAAQ;MACR,SAAS;MACT,UAAU;MACV,WAAW;MACX,mBAAmB;MACnB,2BAA2B;MAE3B,oBAAoB,EAAA;EA/BhC;IAoCQ,aAAa;IACb,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,MAAM;IACN,QAAQ,EAAA;EA3ChB;IA+CQ,aAAa,EAAA;EA/CrB;IAoDY,WAAW;IACX,kBAAkB;IAElB,2BAA2B;IAC3B,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IAEX,oBAAoB,EAAA;EA7DhC;IAkEQ,2BAA2B,EAAA;;AAInC;EACI,6BAA6B,EAAA;;AAIjC;EACI,chC/MgB,EAAA;;AgCkNpB;;;EAGI,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB,EAAA;;AAGtB,8FAAA;AAGA;EACI,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAIvB;EACI,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB,EAAA;EAJvB;IAOQ,aAAa;IACb,mBAAmB,EAAA;IAR3B;MAWY,2BAA2B,EAAA;IAXvC;MAeY,yBAAyB,EAAA;IAfrC;MAmBY,aAAa;MACb,YAAY;MACZ,WAAW;MACX,chClPM;MgCmPN,gBAAgB;MAChB,yDAA0C;MAC1C,qBAAqB;MACrB,uCAAuC,EAAA;MA1BnD;QA6BgB,qCAAuC;QACvC,chC5PJ;QgC6PI,qBAAqB,EAAA;MA/BrC;QAmCgB,qCAAqC,EAAA;MAnCrD;QAuCgB,WAAW;QACX,0BAA0B,EAAA;MAxC1C;QA4CgB,WAAW;QACX,gBAAgB,EAAA;MA7ChC;QAiDgB,WAAW;QACX,0BAA0B,EAAA;MAlD1C;QAsDgB,yBAAyB;QACzB,qCAAqC;QACrC,chCtRJ,EAAA;;AgC4RZ;EACI,qBAAqB;EACrB,gBAAgB;EAChB,gChCvSgB;EgCwShB,chCxSgB,EAAA;;AgC2SpB;EACI,kCAAkC,EAAA;;AAGtC,gFAAA;AACA;;EhCmSE,mHAAiF;EACjF,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EgCnSzB,YAAY,EAAA;;AAGhB;EACI,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,yBhCnRsB;EgCqRtB,kBAAkB;EAClB,chCnUqB;EgCoUrB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBhC9RiB,EAAA;EgC6QrB;IAoBQ,yBhChUU,EAAA;EgC4SlB;IAwBQ,yBhC3UM,EAAA;IgCmTd;MA2BY,yBAAyB,EAAA;MA3BrC;QA8BgB,yBhCpVI,EAAA;EgCsTpB;IAoCQ,sBAAsB;IACtB,oBAAoB,EAAA;EArC5B;IAyCQ,qBAAqB;IACrB,oBAAoB,EAAA;EA1C5B;IA8CQ,qBAAqB;IACrB,oBAAoB,EAAA;EA/C5B;IAmDQ,wBAAwB;IACxB,oBAAoB,EAAA;EApD5B;IAwDQ,wBAAwB;IACxB,sBAAsB,EAAA;EAzD9B;IA6DQ,wBAAwB;IACxB,uBAAuB,EAAA;EA9D/B;IAkEQ,yBhChVY;IgCiVZ,YAAY,EAAA;;AAIpB;EACI,gChC9XgB;EgC+XhB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,4BAA4B;EAC5B,wBAAwB,EAAA;;AAG5B;EACI,6BhCvYU,EAAA;;AgC0Yd;EACI,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB,EAAA;EAVvB;IAaQ,OAAO;IACP,aAAa;IACb,8BAA8B;IAC9B,mBAAmB,EAAA;EAhB3B;IAoBQ,WAAW,EAAA;EApBnB;IAuBQ,chCraiB,EAAA;EgC8YzB;IA2BQ,YAAY,EAAA;;AAKpB;EACI,aAAa;EACb,mBAAmB;EACnB,chCjbqB;EgCkbrB,QAAQ,EAAA;;AAGZ;EAEQ,aAAa;EACb,sBAAsB;EACtB,chCzbiB;EgC0bjB,QAAQ,EAAA;;AAIhB;EACI,yBhC/bqB;EgCgcrB,yBhCrbc;EgCsbd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe,EAAA;;AAGnB;EACI,kBAAkB;EAClB,iBAAiB,EAAA;;AAGrB;EACI,6BAA6B;EAC7B,oCAAiC;EACjC,oCAAkC,EAAA;EhCyRlC;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;;AgCpSjE;EACI,0DAA0D,EAAA;;AAG9D;EACI,oCAAuC;EACvC,yBAAkC,EAAA;;AAGtC;EACI,yBAAkC,EAAA;;AAGtC;EACI,yBAAkC,EAAA;;AAGtC;EACI,yBAAkC,EAAA;;AAGtC;EACI,oCAAkC,EAAA;;AAGtC;EACI,8BAA4B,EAAA;;AAIhC;EACI,cAAc;EACd,cAAc;EACd,qBAAqB,EAAA;;AhCoPrB;EACI,UAjKa,EAAA;;AAoKjB;EACI,mBApKuB;EAqKvB,kBAAkB;EAClB,kBAAkB,EAAA;;AAGtB;EACI,yBA3uBU;EA4uBV,kBAAkB,EAAA;EAElB;IACI,yBAAqD,EAAA;;AgC3PjE;EACI,aAAa;EACb,iBAAiB;EACjB,QAAQ;EACR,eAAe,EAAA;;AAInB;EACI,kBAAkB;EAClB,WAAW;EACX,YAAY,EAAA;EAHhB;IAKQ,WAAW;IACX,YAAY;IACZ,cAAc,EAAA;;AAItB;EACI,YAAY,EAAA;;AAIhB,gEAAA;AACA;EACI,kBAAkB;EAClB,iBAAiB,EAAA;EAFrB;IAMQ,yBhCrhBI;IgCshBJ,chC9hBY;IgC+hBZ,kCAAkC;IAClC,yBhC3hBgB;IgC4hBhB,8BAA8B;IAC9B,8BhC1hBI,EAAA;EgC+gBZ;IAeQ,chCtiBY,EAAA;EgCuhBpB;IAmBQ,yBAAyB;IACzB,chC5iBiB,EAAA;IgCwhBzB;MAuBY,yBhCxhBS,EAAA;EgCigBrB;IA4BQ,yBAAyB;IACzB,chCrjBiB,EAAA;EgCwhBzB;IAiCQ,yBAAyB;IACzB,chC1jBiB,EAAA;;AgC8jBzB,6DAAA;AACA;;EAEI,iBAAiB,EAAA;;AAGrB;;EAEI,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yCAAyC;EACzC,oBAAoB;EACpB,UAAU,EAAA;;AAGd;EACI,yBhC5jBiB,EAAA;;AgC+jBrB;EACI,yBhC/kBgB,EAAA;;AgCklBpB,uDAAA;AACA;EACI,WAAW;EAAE,4BAAA;EACb,kBAAkB;EAAE,0DAAA,EAA2D;;AAGnF;EACI,UAAU;EACV,yBhCzlBQ;EgC0lBR,WAAW,EAAA;;AAGf;EACI,YAAY;EACZ,yBhCvmBgB,EAAA;EgCqmBpB;IAKQ,yBAAyB;IACzB,yBhC5mBiB,EAAA;;AgCgnBzB;EACI,yBhC3mBoB;EgC4mBpB,YAAY,EAAA;;AAGhB;EACI,yBhCrnBgB,EAAA;;AgCwnBpB;EAIQ,gBAAgB;EAChB,yBhCnnBU;EgConBV,kBAAkB,EAAA;;AAM1B,oCAAA;AACA;EAEI,kBAAkB,EAAA;;AAGtB,gEAAA;AACA;EAEI,mBAAmB;EACnB,chC/oBqB;EgCgpBrB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe,EAAA;;AAInB;EACI,yBhCjpBoB;EgCkpBpB,kBAAkB;EAClB,yBhCxpBgB;EgCypBhB,kBAAkB;EAClB,qDAAqD,EAAA;EALzD;IASQ,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB,EAAA;IAf3B;MAkBY,YACJ,EAAA;IAnBR;MAsBY,aAAa;MACb,WAAW;MACX,aAAa,EAAA;MAxBzB;QA2BgB,kBAAkB;QAClB,iBAAiB;QACjB,YAAY;QACZ,aAAa,EAAA;QA9B7B;UAkCoB,WAAW;UACX,cAAc,EAAA;QAnClC;UAuCoB,kBAAkB;UAClB,YAAY;UACZ,aAAa;UACb,0BhC/rBA;UgCgsBA,gBAAgB;UAChB,aAAa;UACb,uBAAuB;UACvB,mBAAmB;UACnB,YAAY;UACZ,yBhClsBN,EAAA;UgCkpBd;YAmDwB,gBAAgB,EAAA;UAnDxC;YAuDwB,oBAAoB;YACpB,yBAAqC,EAAA;QAxD7D;UA6DoB,kBAAkB;UAClB,MAAM;UACN,OAAO;UACP,YAAY;UACZ,WAAW;UACX,iBAAiB;UACjB,0BAA0B;UAC1B,iBAAiB;UAqCjB,yGAAyG,EAAA;UAzG7H;YAuEwB,YAAY,EAAA;UAvEpC;YA2EwB,eAAe,EAAA;UA3EvC;YA+EwB,gBAAgB,EAAA;UA/ExC;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,sBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,qBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,oBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,kBAAc,EAAA;UArF1C;YAqF4B,kBAAc,EAAA;UArF1C;YAqF4B,kBAAc,EAAA;UArF1C;YAqF4B,kBAAc,EAAA;UArF1C;YAqF4B,kBAAc,EAAA;UArF1C;YAqF4B,kBAAc,EAAA;UArF1C;YAqF4B,kBAAc,EAAA;UArF1C;YAqF4B,kBAAc,EAAA;UArF1C;YAqF4B,kBAAc,EAAA;UArF1C;YAqF4B,kBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YAqF4B,mBAAc,EAAA;UArF1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,qBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,oBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,kBAAc,EAAA;UA5F1C;YA4F4B,kBAAc,EAAA;UA5F1C;YA4F4B,kBAAc,EAAA;UA5F1C;YA4F4B,kBAAc,EAAA;UA5F1C;YA4F4B,kBAAc,EAAA;UA5F1C;YA4F4B,kBAAc,EAAA;UA5F1C;YA4F4B,kBAAc,EAAA;UA5F1C;YA4F4B,kBAAc,EAAA;UA5F1C;YA4F4B,kBAAc,EAAA;UA5F1C;YA4F4B,kBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YA4F4B,mBAAc,EAAA;UA5F1C;YAoG4B,YAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,YAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,YAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,YAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,YAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,UAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,YAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,YAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,YAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,YAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,YAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,YAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,YAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,YAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,YAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,UAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,YAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,YAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,YAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,YAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,YAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,YAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,YAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,YAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,YAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,aAAQ,EAAA;UApGpC;YAoG4B,UAAQ,EAAA;QApGpC;UA8GoB,aAAa;UACb,YAAY;UACZ,yBAAyB,EAAA;MAhH7C;QAwHgB,aAAa;QACb,gBAAgB;QAChB,YAAY,EAAA;QA1H5B;UA8HoB,aAAa;UACb,sBAAsB;UACtB,WAAW;UACX,sBAAsB,EAAA;UAjI1C;YAoIwB,chC1xBC,EAAA;UgCspBzB;YAwIwB,wBAAwB;YACxB,chC/xBC,EAAA;;AgC2yBzB;EACI,kBAAkB;EAClB,yBhCxyBe;EgCyyBf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EAEb,yBhCxyBc;EgCyyBd,0CAA0C;EAC1C,aAAa;EACb,eAAe,EAAA;EAXnB;IAcQ,gCAAc,EAAA;EAdtB;IAkBY,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,yBhC/zBY;IgCg0BZ,qCAAqC,EAAA;IA3BjD;MA8BgB,yBhC9zBE;MgC+zBF,chC10BS,EAAA;IgC2yBzB;MAmCgB,yBhCpzBI;MgCqzBJ,chC/0BS,EAAA;IgC2yBzB;MAwCgB,yBhC5xBK;MgC6xBL,chCp1BS,EAAA;IgC2yBzB;MA6CgB,yBhCp1BF;MgCq1BE,chCx1BI,EAAA;IgC0yBpB;MAkDgB,yBhCxyBM;MgCyyBN,chC91BS,EAAA;EgC2yBzB;IhCjLE,aAAa;IACb,8BAA8B;IAC9B,cA5nBuB;IA6nBvB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gCA7nBY;IA8nBZ,8BAA8B;IAC9B,mHAAiF;IgCiO3E,gChCn2BY,EAAA;IgC0yBpB;MA4DY,gBAAgB;MAChB,SAAS;MACT,mBAAmB;MACnB,chC12Ba;MgC22Bb,yBAAyB,EAAA;IAhErC;MAoEY,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,eAAe,EAAA;IAvE3B;MA2EY,gBAAgB;MAChB,YAAY;MACZ,eAAe;MACf,eAAe,EAAA;EA9E3B;IAmFQ,eAAe;IACf,eAAe;IACf,0BAA0B;IAC1B,aAAa,EAAA;IAtFrB;MAyFY,aAAa,EAAA;MAzFzB;QA4FgB,iBAAiB,EAAA;EA5FjC;IAkGQ,iBAAiB,EAAA;IAlGzB;MAqGY,6BAA6B;MAC7B,kBAAkB;MAClB,cAAc,EAAA;;AAK1B,6BAAA;AACA,6BAAA;AACA,6BAAA;AAEA;EACI,aAAa;EACb,0DAA0D;EAC1D,oBAAoB;EACpB,aAAa,EAAA;;AAGjB;EACI,WAAW,EAAA;;AAGf;EACI,chC55Bc;EgC65Bd,WAAW,EAAA;;AAQf;EAKY,aAAa;EACb,iBAAiB,EAAA;;AAS7B;EAGQ,wBAAO;EACP,4BAAW;EACX,aAAa;EACb,iBAAiB;EAEjB,oBAAoB,EAAA;;AAR5B;EAYQ,WAAW;EACX,sBAAsB;EACtB,2BAAW;EACX,eAAe,EAAA;;AAIvB;EhCxVE,aAAa;EACb,8BAA8B;EAC9B,cA5nBuB;EA6nBvB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gCA7nBY;EA8nBZ,8BAA8B;EAC9B,mHAAiF,EAAA;EgC+UnF;IAIQ,SAAS;IACT,gBAAgB,EAAA;EALxB;IASQ,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,eAAe,EAAA;IAbvB;MAgBY,kBAAkB;MAClB,YAAY;MACZ,mBAAmB;MACnB,gBAAgB;MAChB,eAAe,EAAA;MApB3B;QAuBgB,UAAU,EAAA;;AAO1B;EACI,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,qBhCv/BgB;EgCw/BhB,8BAA8B;EAC9B,yBhCz8BoB;EgC08BpB,gBAAgB,EAAA;EAXpB;IAcQ,WAAW,EAAA;;AAInB;EACE,oBAAoB;EACpB,YAAY,EAAA;;AAGd;EACE,YAAY;EACZ,kBAAkB,EAAA;;AAGpB;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB,EAAA;;AAIrB;EACI,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,qBhCxhCgB;EgCyhChB,8BAA8B;EAC9B,yBhC3+BqB,EAAA;EgCm+BzB;IhC/WE,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,aAAa;IACb,sBAAsB,EAAA;IAEtB;MACE,YAAY;MACZ,YAAY,EAAA;IAGd;MACE,iBAAiB;MACjB,cAAc,EAAA;IAGhB;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,sBAAsB,EAAA;IAGxB;MACE,aAAa;MACb,uBAAuB,EAAA;MAEvB;QACE,WAAW;QACX,YAAY;QACZ,kBAAkB,EAAA;MAGpB;QACE,SAAS,EAAA;EgC6Uf;IAeQ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,YAAY,EAAA;EAlBpB;IAsBQ,uBAAuB,EAAA;EAtB/B;IA0BQ,cAAc;IACd,wHAAwH,EAAA;EA3BhI;IA+BQ,aAAa;IACb,mBAAmB,EAAA;IAhC3B;MAmCY,gBAAgB,EAAA;EAnC5B;IAwCQ,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;IAClB,YAAY,EAAA;IA5CpB;MA+CY,chCjkCQ,EAAA;EgCkhCpB;IAoDQ,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY,EAAA;IAvDpB;MA0DY,SAAS;MACT,chC7kCQ;MgC8kCR,eAAe;MACf,gBAAgB;MAChB,uBAAuB,EAAA;IA9DnC;MAkEY,chCrlCa,EAAA;MgCmhCzB;QAqEgB,chCxlCS,EAAA;IgCmhCzB;MA2EgB,chC7lCI,EAAA;EgCkhCpB;IAiFQ,eAAe,EAAA;EAjFvB;IAqFQ,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;IACX,YAAY,EAAA;IAzFpB;MA4FY,2BAA2B;MAC3B,uBAAuB;MACvB,WAAW;MACX,uBAAuB;MACvB,eAAe;MACf,yBhCtkCQ;MgCukCR,uChCpnCQ,EAAA;IgCkhCpB;MAsGY,gBAAgB;MAChB,cAAc,EAAA;IAvG1B;;;;MA8GY,yBAAkC;MAClC,eAAe,EAAA;IA/G3B;MAmHY,0CAAwC,EAAA;IAnHpD;MAuHY,chCzoCQ,EAAA;IgCkhCpB;MA2HY,SAAS;MACT,chC/oCa;MgCgpCb,eAAe;MACf,gBAAgB,EAAA;EA9H5B;IAmIQ,SAAS;IACT,chCvpCiB;IgCwpCjB,eAAe;IACf,gBAAgB,EAAA;EAtIxB;IA0IQ,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY,EAAA;IA7IpB;MAgJY,YAAY,EAAA;;AAKxB;EhC9iBE,aAAa;EACb,8BAA8B;EAC9B,cA5nBuB;EA6nBvB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gCA7nBY;EA8nBZ,8BAA8B;EAC9B,mHAAiF,EAAA;EgCqiBnF;IAKY,SAAS;IACT,gBAAgB,EAAA;EAN5B;IAUY,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,eAAe,EAAA;IAd3B;MAiBgB,kBAAkB;MAClB,YAAY;MACZ,mBAAmB;MACnB,gBAAgB;MAChB,eAAe,EAAA;MArB/B;QAwBoB,UAAU,EAAA;;AAxB9B;EA+BQ,aAAa;EACb,sBAAsB;EACtB,mBhC7pCW;EgC8pCX,aAAa;EACb,SAAS;EACT,gBAAgB;EAmbhB,8GAAA;EAaA,2FAAA;EAUA,iFAAA;EAkCA,6FAAA;EAkWA,oEAAA;EAmGA,6GAAA,EAAA;EAr9BR;IAuCY,aAAa;IACb,oBAAoB;IACpB,SAAS;IACT,YAAY,EAAA;EA1CxB;IA8CY,YAAY;IACZ,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,chC7tCa;IgC8tCb,yBhC7tCQ;IgC8tCR,kBAAkB;IAClB,mBhC1tCY,EAAA;IgCkqCxB;MA2DgB,aAAa;MACb,mBAAmB;MACnB,QAAQ;MACR,2BAA2B;MAC3B,gChCnuCF;MgCouCE,iBAAiB,EAAA;MAhEjC;QAmEoB,iBAAiB;QACjB,qBAAqB,EAAA;IApEzC;MAyEgB,aAAa;MACb,sBAAsB;MACtB,QAAQ;MACR,OAAO;MACP,aAAa;MACb,gBAAgB;MAChB,aAAa;MACb,gBAAgB;MAChB,SAAS,EAAA;MhC9gBrB;QACI,UAjKa,EAAA;MAoKjB;QACI,mBApKuB;QAqKvB,kBAAkB;QAClB,kBAAkB,EAAA;MAGtB;QACI,yBA3uBU;QA4uBV,kBAAkB,EAAA;QAElB;UACI,yBAAqD,EAAA;MgC8ajE;QAqFoB,aAAa;QACb,mBAAmB;QACnB,QAAQ;QACR,6BAA6B;QAE7B,kBAAkB,EAAA;QA1FtC;UA6FwB,OAAO;UACP,YAAY,EAAA;UA9FpC;YAiG4B,cAAc;YACd,YAAY;YACZ,6BAA6B,EAAA;IAnGzD;MA0GgB,gBAAgB;MAChB,aAAa;MACb,kBAAkB,EAAA;EA5GlC;IAiHY,aAAa;IACb,SAAS;IACT,WAAW;IACX,oBAAoB,EAAA;IApHhC;;MAwHgB,WAAW;MACX,YAAY,EAAA;EAzH5B;IAgIgB,yBhClyCQ;IgCmyCR,yBhCzyCS;IgC0yCT,kBAAkB;IAClB,aAAa,EAAA;IAnI7B;MAsIoB,gBAAgB,EAAA;IAtIpC;MA0IoB,aAAa;MACb,sBAAsB;MACtB,yBhCpzCK;MgCqzCL,eAAe;MACf,kBAAkB;MAClB,YAAY;MACZ,QAAQ;MACR,WAAW;MACX,sBAAsB,EAAA;MAlJ1C;QAqJwB,YAAY,EAAA;MArJpC;QAyJwB,aAAa;QACb,gBAAgB;QAChB,aAAa;QACb,sBAAsB;QACtB,QAAQ;QACR,kBAAkB,EAAA;QhC3lBtC;UACI,UAjKa,EAAA;QAoKjB;UACI,mBApKuB;UAqKvB,kBAAkB;UAClB,kBAAkB,EAAA;QAGtB;UACI,yBA3uBU;UA4uBV,kBAAkB,EAAA;UAElB;YACI,yBAAqD,EAAA;MgC8ajE;QAmKwB,kBAAkB;QAClB,aAAa;QACb,qCAAqC;QACrC,QAAQ;QACR,mBAAmB,EAAA;MAvK3C;QA2KwB,iBAAiB;QACjB,chCp1CC;QgCq1CD,aAAa;QACb,iBAAiB;QACjB,iBAAiB;QACjB,YAAY,EAAA;QAhLpC;UAmL4B,aAAa;UACb,eAAe,EAAA;MApL3C;QAyLwB,WAAW;QACX,sBAAsB,EAAA;MA1L9C;QA8LwB,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,QAAQ,EAAA;EAjMhC;IAwMY,yBhC12CY;IgC22CZ,yBhCh3CQ;IgCi3CR,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,gFAAgF,EAAA;IAlN5F;MAqNgB,kBAAkB;MAClB,yBAAyB;MACzB,iBAAiB;MACjB,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,QAAQ,EAAA;IA3NxB;MA+NgB,cAAc;MACd,aAAa,EAAA;EAhO7B;IAsOY,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS,EAAA;EAzOrB;IA6OY,cAAc;IACd,SAAS;IACT,wBAAwB;IACxB,kBAAkB;IAClB,0ChCp2CU;IgCq2CV,oChCr2CU;IgCs2CV,chC35Ca;IgC45Cb,kBAAkB;IAClB,gBAAgB,EAAA;EArP5B;IAyPY,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,SAAS,EAAA;IA5PrB;MA+PgB,8ChCl3CM,EAAA;EgCmnCtB;;;IAwQgB,UAAU;IACV,oBAAoB;IACpB,iBAAiB,EAAA;EA1QjC;IA8QgB,kBAAkB,EAAA;EA9QlC;IAsRY,aAAa;IACb,SAAS;IACT,WAAW;IACX,oBAAoB,EAAA;IAzRhC;;;MA8RgB,WAAW;MACX,YAAY,EAAA;EA/R5B;IAoSY,kBAAkB;IAClB,QAAQ;IACR,UAAU;IAEV,oBAAoB;IACpB,UAAU;IACV,uBAAuB;IACvB,oDAAoD;IACpD,WAAW;IACX,YAAY,EAAA;EA7SxB;;;IAmTY,UAAU;IACV,mBAAmB;IACnB,oBAAoB,EAAA;EArThC;IAyTY,UAAU;IACV,uBAAuB;IACvB,oBAAoB,EAAA;EA3ThC;IA+TY,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,2CAA2C,EAAA;EAlUvD;IAsUY,2CAA2C;IAC3C,kBAAkB;IAClB,0DAA0D,EAAA;EAxUtE;IA4UY,qChC97CI;IgC+7CJ,6ChC/7CI,EAAA;EgCknChB;IAiVY,qChCj+CG;IgCk+CH,6ChCl+CG,EAAA;EgCgpCf;IAsVY,WAAW;IACX,YAAY,EAAA;EAvVxB;IA2VY,WAAW;IACX,YAAY;IACZ,aAAa,EAAA;EA7VzB;IAiWY,aAAa,EAAA;EAjWzB;IAqWY,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,SAAS;IACT,aAAa,EAAA;EAzWzB;IA6WY,aAAa;IACb,SAAS;IACT,uBAAuB,EAAA;EA/WnC;IAmXY,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;IAC3C,+BAA+B;IAC/B,eAAe;IACf,iBAAiB,EAAA;EA/X7B;IAmYY,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,mBAAmB,EAAA;EAzY/B;IA6YY,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gCAAgC,EAAA;EAhZ5C;;;IAsZY,YAAY,EAAA;EAtZxB;IA0ZY,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,SAAS;IACT,cAAc;IACd,WAAW,EAAA;EAhavB;IAoaY,cAAc;IACd,2BAAW,EAAA;EAravB;IAyaY,cAAc;IACd,oBAAoB;IACpB,YAAY,EAAA;EA3axB;IhC5PE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;IACT,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,SAAS;IACT,oBAAoB;IACpB,eAAe;IACf,cA17BuB,EAAA;IA47BvB;MACE,gBAAgB;MAChB,oBAAoB;MACpB,mBAAmB;MACnB,cAAc;MACd,SAAS;MACT,WAAW;MACX,mBAAmB;MACnB,kBAAkB,EAAA;IAGpB;MACE,kBAAkB;MAClB,SAAS;MACT,UAAU;MACV,WAAW;MACX,YAAY;MACZ,SAAS;MACT,cAAc,EAAA;EgC0NlB;IAmbY,oBAAoB,EAAA;EAnbhC;IAubY,cAAc;IACd,oFAAA;IACA,oBAAoB,EAAA;EAzbhC;IA6bY,WAAW,EAAA;EA7bvB;IAicY,aAAa;IACb,sBAAsB;IACtB,QAAQ,EAAA;EAncpB;IAucY,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,YAAY,EAAA;EA9cxB;;IAmdY,2BAAW;IACX,YAAY,EAAA;EApdxB;;IA0dY,cAAc;IACd,YAAY;IACZ,eAAe;IACf,aAAa,EAAA;EA7dzB;IAieY,oBAAoB,EAAA;EAjehC;IAseY,oBAAoB,EAAA;EAtehC;;IA2eY,mBAAmB,EAAA;EA3e/B;IhC5PE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;IACT,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,SAAS;IACT,oBAAoB;IACpB,eAAe;IACf,cA17BuB,EAAA;IA47BvB;MACE,gBAAgB;MAChB,oBAAoB;MACpB,mBAAmB;MACnB,cAAc;MACd,SAAS;MACT,WAAW;MACX,mBAAmB;MACnB,kBAAkB,EAAA;IAGpB;MACE,kBAAkB;MAClB,SAAS;MACT,UAAU;MACV,WAAW;MACX,YAAY;MACZ,SAAS;MACT,cAAc,EAAA;EgC0NlB;IAofY,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ,EAAA;EAvfpB;IA2fY,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,mBAAmB,EAAA;EA9f/B;IAkgBY,iBAAiB;IACjB,aAAa;IACb,0BAA0B,EAAA;EApgBtC;IAwgBY,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,QAAQ;IACR,YAAY,EAAA;EA7gBxB;IAkhBY,iBAAiB;IACjB,mBAAmB,EAAA;EAnhB/B;IAuhBY,cAAc,EAAA;EAvhB1B;IA2hBY,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,cAAc;IACd,YAAY;IACZ,eAAe,EAAA;EAjiB3B;IAqiBY,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,sBAAsB;IACtB,mBAAmB,EAAA;EAziB/B;IA6iBY,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB,EAAA;EAhjB/B;IAojBY,aAAa;IACb,oBAAoB;IACpB,YAAY;IACZ,mBhCztDY;IgC0tDZ,yBhC7tDS;IgC8tDT,kBAAkB;IAClB,gBAAgB,EAAA;EA1jB5B;IA8jBY,YAAY,EAAA;EA9jBxB;IAkkBY,chC1uDa;IgC2uDb,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBhCjsDc;IgCksDd,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,YAAY,EAAA;EA1kBxB;IA8kBY,mBAAmB,EAAA;EA9kB/B;IAklBY,aAAa,EAAA;EAllBzB;IAslBY,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IAEd,iBAAiB;IACjB,kChCjwDS;IgCkwDT,4ChClwDS;IgCmwDT,chCtwDa;IgCuwDb,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,iBAAiB,EAAA;EAnmB7B;IAumBY,gBAAgB;IAChB,aAAa,EAAA;EAxmBzB;IA4mBY,aAAa,EAAA;EA5mBzB;IAgnBY,aAAa,EAAA;EAhnBzB;IAonBY,aAAa,EAAA;EApnBzB;IAwnBY,4EAA4E,EAAA;EAxnBxF;IA4nBY,aAAa,EAAA;EA5nBzB;IAgoBY,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,yBhCxyDS;IgCyyDT,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,eAAe,EAAA;EA3oB3B;IA+oBY,oChC7wDS;IgC8wDT,8ChC9wDS,EAAA;EgC8nCrB;IAopBY,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,cAAc,EAAA;EA3pB1B;IA+pBY,cAAc;IACd,cAAc;IACd,mBhC5xDc;IgC6xDd,YAAY;IACZ,yBhCx0DS;IgCy0DT,kBAAkB,EAAA;EApqB9B;IAwqBY,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,oDAAoD;IACpD,aAAa,EAAA;EA/qBzB;IAmrBY,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,QAAQ;IACR,YAAY,EAAA;EA1rBxB;IA8rBY,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,mBAAmB,EAAA;EAjsB/B;IAqsBY,iBAAiB;IACjB,aAAa;IACb,0BAA0B,EAAA;EAvsBtC;IA2sBY,eAAe;IACf,gBAAgB;IAChB,chCr3Da;IgCs3Db,mBAAmB,EAAA;EA9sB/B;IAktBY,WAAW;IACX,kBAAkB;IAClB,mBhCt3DY;IgCu3DZ,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,2BAA2B;IAC3B,YAAY,EAAA;EAztBxB;IA6tBY,wChCl4DS;IgCm4DT,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,gBAAgB,EAAA;EAxuB5B;IA4uBY,uBAAuB,EAAA;EA5uBnC;;IAivBY,kBAAkB;IAClB,UAAU,EAAA;EAlvBtB;IAsvBY,WAAW,EAAA;EAtvBvB;IA0vBY,oDhCx3DS;IgCy3DT,oChCz3DS,EAAA;EgC8nCrB;IA+vBY,oDhC73DS;IgC83DT,mChC93DS,EAAA;EgC8nCrB;IAowBY,oDhCl4DS,EAAA;EgC8nCrB;IAwwBY,aAAa;IACb,sBAAsB;IACtB,QAAQ,EAAA;EA1wBpB;IA8wBY,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,aAAa;IACb,cAAc,EAAA;EAlxB1B;IAsxBY,aAAa;IACb,oBAAoB;IACpB,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,iBAAiB;IACjB,qCAAqC;IACrC,0CAA0C;IAC1C,kDAAkD;IAClD,0BAA0B,EAAA;EA/xBtC;IAmyBY,cAAc;IACd,YAAY;IACZ,aAAa;IACb,6EAA6E;IAC7E,SAAS;IACT,mBAAmB;IACnB,UAAU,EAAA;EAzyBtB;IA6yBY,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB,EAAA;EApzBnC;IAwzBY,iBAAiB,EAAA;EAxzB7B;IA4zBY,cAAc;IACd,0CAA0C;IAC1C,aAAa;IACb,0BAA0B;IAC1B,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,aAAa;IACb,+BAA+B,EAAA;IhClwCvC;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;EgC8ajE;IA40BY,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe,EAAA;EAh1B3B;IAo1BY,uBAAuB,EAAA;EAp1BnC;IAw1BY,oChCt9DS;IgCu9DT,kBAAkB,EAAA;EAz1B9B;IA61BY,cAAc;IACd,MAAM;IACN,UAAU;IACV,cAAc;IACd,0CAA0C;IAC1C,kBAAkB;IAClB,aAAa;IACb,+BAA+B,EAAA;IhCjyCvC;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;EgC8ajE;IAy2BY,kBAAkB,EAAA;EAz2B9B;IA62BY,WAAW;IACX,yBAAyB;IACzB,mBAAmB,EAAA;EA/2B/B;IAo3BY,UAAU,EAAA;EAp3BtB;IAw3BY,UAAU,EAAA;EAx3BtB;IA43BY,SAAS,EAAA;EA53BrB;IAg4BY,UAAU,EAAA;EAh4BtB;IAo4BY,UAAU,EAAA;EAp4BtB;IAw4BY,SAAS,EAAA;EAx4BrB;IA44BY,SAAS,EAAA;EA54BrB;IAg5BY,UAAU,EAAA;EAh5BtB;IAo5BY,UAAU,EAAA;EAp5BtB;IAw5BY,qCAAqC,EAAA;EAx5BjD;IA45BY,iBAAiB;IACjB,gBAAgB;IAChB,kDAAkD;IAClD,gBAAgB,EAAA;EA/5B5B;IAm6BY,iBAAiB,EAAA;EAn6B7B;IAu6BY,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB,EAAA;EAz6B9B;IA66BY,iBAAiB;IACjB,sBAAsB;IACtB,kDAAkD,EAAA;EA/6B9D;IAm7BY,gBAAgB,EAAA;EAn7B5B;IAu7BY,iBAAiB,EAAA;EAv7B7B;IA27BY,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB,EAAA;EA97B9B;IAk8BY,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB,EAAA;EAt8B5B;IA08BY,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB,EAAA;EA78B9B;IAi9BY,+BAA+B;IAC/B,gBAAgB,EAAA;EAl9B5B;IAu9BY,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,YAAY;IACZ,kBAAkB,EAAA;EA99B9B;IAk+BY,YAAY;IACZ,cAAc,EAAA;EAn+B1B;IAu+BY,cAAc,EAAA;EAv+B1B;IA2+BY,cAAc,EAAA;EA3+B1B;IA++BY,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB,EAAA;EAz/B7B;IA6/BY,gCAAgC;IAChC,qCAAqC;IACrC,2CAA2C,EAAA;EA//BvD;IAmgCY,chCnpEG,EAAA;EgCgpCf;;IA0gCY,YAAY,EAAA;EA1gCxB;IA8gCY,gBAAgB;IAChB,YAAY,EAAA;EA/gCxB;IAmhCY,YAAY;IACZ,WAAW;IACX,gBAAgB,EAAA;EArhC5B;IAyhCY,aAAa,EAAA;EAzhCzB;IA6hCY,aAAa;IACb,8DAA8D;IAC9D,SAAS;IACT,mBAAmB;IACnB,WAAW;IACX,YAAY,EAAA;EAliCxB;IAsiCY,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY,EAAA;EAziCxB;IA6iCY,YAAY,EAAA;EA7iCxB;IAijCY,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB,EAAA;EAnjC9B;IAujCY,YAAY,EAAA;EAvjCxB;IA2jCY,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe,EAAA;EA9jC3B;IAokCY,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,QAAQ;IACR,cAAc,EAAA;EAxkC1B;IA4kCY,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,QAAQ;IACR,YAAY,EAAA;EAhlCxB;IAqlCY,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,WAAW,EAAA;EAzlCvB;IA6lCY,aAAa;IACb,oBAAoB;IACpB,WAAW;IACX,mBhClwEY;IgCmwEZ,yBhCtwES;IgCuwET,kBAAkB;IAClB,gBAAgB,EAAA;EAnmC5B;IAumCY,YAAY,EAAA;EAvmCxB;IA2mCY,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,sBAAsB;IACtB,chCxxEa;IgCyxEb,mBhCzuEa,EAAA;EgCwnCzB;IAqnCY,gCAAgC,EAAA;EArnC5C;IAynCY,cAAc;IACd,WAAW;IACX,YAAY,EAAA;EA3nCxB;IA+nCY,WAAW;IACX,sBAAsB;IACtB,cAAc;IACd,YAAY;IACZ,mBhC9vEc;IgC+vEd,SAAS;IACT,gBAAgB;IAChB,yBAAyB;IACzB,chC/yEa;IgCgzEb,eAAe;IACf,gBAAgB;IAChB,gBAAgB,EAAA;EA1oC5B;IA8oCY,aAAa,EAAA;EA9oCzB;IAkpCY,eAAe;IACf,eAAe;IACf,aAAa,EAAA;EAppCzB;IAwpCY,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,kChCj0EY;IgCk0EZ,2CAA2C;IAC3C,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc,EAAA;IhCjmDtB;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;EgC8ajE;IAyqCY,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,kDAAkD,EAAA;IA7qC9D;MAgrCgB,mBAAmB,EAAA;IAhrCnC;MAorCgB,0ChClzEK,EAAA;IgC8nCrB;MAwrCgB,2CAA2C,EAAA;IAxrC3D;MA4rCgB,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,QAAQ;MACR,iBAAiB;MACjB,YAAY,EAAA;IAjsC5B;MAqsCgB,eAAe;MACf,gCAAgC;MAChC,gBAAgB;MAChB,uBAAuB;MACvB,mBAAmB;MACnB,eAAe,EAAA;IA1sC/B;MA8sCgB,eAAe;MACf,gCAAgC;MAChC,gBAAgB;MAChB,uBAAuB;MACvB,mBAAmB;MACnB,eAAe,EAAA;EAntC/B;IAwtCY,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;IACnB,YAAY,EAAA;EA5tCxB;IAguCY,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;IACZ,mBAAmB,EAAA;EApuC/B;IAwuCY,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,yBhCj2DsB;IgCk2DtB,kBAAkB;IAClB,mBhCx2DQ;IgCy2DR,gBAAgB,EAAA;EAjvC5B;IAqvCY,gBAAgB,EAAA;EArvC5B;IAyvCY,UAAU,EAAA;EAzvCtB;IA6vCY,cAAc;IACd,WAAW;IACX,eAAe;IACf,SAAS;IACT,wBAAwB;IACxB,SAAS;IACT,gDAAgD;IAChD,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,gCAAgC;IAChC,mFAAmF,EAAA;EA1wC/F;IA8wCY,gBAAgB,EAAA;EA9wC5B;IAkxCY,WAAW;IACX,cAAc;IACd,UAAU;IACV,YAAY;IACZ,mCAAmC;IACnC,oCAAoC;IACpC,yFAA2F,EAAA;EAxxCvG;;IA6xCY,gCAAgC;IAChC,mFAAmF,EAAA;EA9xC/F;IAkyCY,gBAAgB,EAAA;EAlyC5B;IAsyCY,YAAY;IACZ,cAAc;IACd,aAAa;IACb,oBAAoB,EAAA;EAzyChC;IA6yCY,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,eAAe,EAAA;EAhzC3B;IAozCY,eAAe;IACf,YAAY,EAAA;EArzCxB;IAyzCY,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,cAAc,EAAA;EA7zC1B;IAo0CY,mBAAmB;IACnB,aAAa,EAAA;EAr0CzB;IAy0CY,aAAa,EAAA;IAz0CzB;MA40CgB,yBAAyB;MACzB,yBAAyB;MACzB,qBAAqB;MACrB,iBAAiB,EAAA;IA/0CjC;MAm1CgB,aAAa;MACb,2BAA2B;MAC3B,mBAAmB,EAAA;MAr1CnC;QAw1CoB,yBAAyB;QACzB,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;QAClB,QAAQ;QACR,kBAAkB,EAAA;EA71CtC;IAq2CY,aAAa;IACb,SAAS;IACT,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,qBhCjhFQ;IgCkhFR,kBAAkB;IAClB,yBhC9gFY,EAAA;IgCkqCxB;MhCpgBE,aAAa;MACb,8BAA8B;MAC9B,sBAAsB;MACtB,aAAa;MACb,sBAAsB,EAAA;MAEtB;QACE,YAAY;QACZ,YAAY,EAAA;MAGd;QACE,iBAAiB;QACjB,cAAc,EAAA;MAGhB;QACE,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,sBAAsB,EAAA;MAGxB;QACE,aAAa;QACb,uBAAuB,EAAA;QAEvB;UACE,WAAW;UACX,YAAY;UACZ,kBAAkB,EAAA;QAGpB;UACE,SAAS,EAAA;EgCkef;IAo3CY,aAAa;IACb,SAAS;IACT,WAAW,EAAA;IAt3CvB;MAy3CgB,yBhC5hFG;MgC6hFH,yBhCjiFI;MgCkiFJ,kBAAkB;MAClB,cAAc;MACd,WAAW,EAAA;MA73C3B;QAg4CoB,aAAa;QACb,mBAAmB;QACnB,chC1iFK,EAAA;QgCwqCzB;UAq4CwB,kBAAkB;UAClB,WAAW;UACX,YAAY;UACZ,iBAAiB;UACjB,iBAAiB;UACjB,sBAAsB;UACtB,SAAS,EAAA;QA34CjC;UA+4CwB,chCvjFC,EAAA;MgCwqCzB;QAo5CoB,gBAAgB;QAChB,qBAAqB;QACrB,cAAc,EAAA;QhCn1D9B;UACI,UAjKa,EAAA;QAoKjB;UACI,mBApKuB;UAqKvB,kBAAkB;UAClB,kBAAkB,EAAA;QAGtB;UACI,yBA3uBU;UA4uBV,kBAAkB,EAAA;UAElB;YACI,yBAAqD,EAAA;QgC8ajE;UA05CwB,aAAa;UACb,mBAAmB;UACnB,uBAAuB,EAAA;UA55C/C;YA+5C4B,kBAAkB;YAClB,YAAY;YACZ,WAAW;YACX,yBAAyB,EAAA;UAl6CrD;YAs6C4B,aAAa,EAAA;IAt6CzC;MA66CgB,yBhChlFG;MgCilFH,yBhCrlFI;MgCslFJ,kBAAkB;MAClB,cAAc;MACd,WAAW,EAAA;MAj7C3B;QAo7CoB,aAAa;QACb,mBAAmB;QACnB,chC9lFK,EAAA;QgCwqCzB;UAy7CwB,kBAAkB;UAClB,WAAW;UACX,YAAY;UACZ,iBAAiB;UACjB,iBAAiB;UACjB,SAAS,EAAA;QA97CjC;UAk8CwB,chC1mFC,EAAA;MgCwqCzB;QAu8CoB,gBAAgB;QAChB,uBAAuB,EAAA;QAx8C3C;UA28CwB,kBAAkB;UAClB,qBAAqB,EAAA;UA58C7C;YA+8C4B,mBAAmB,EAAA;UA/8C/C;YAm9C4B,kBAAkB;YAClB,UAAU;YACV,QAAQ;YACR,2BAA2B;YAC3B,WAAW;YACX,YAAY,EAAA;QAx9CxC;UA69CwB,eAAe;UACf,oBAAoB,EAAA;QA99C5C;UAk+CwB,kBAAkB;UAClB,WAAW;UACX,YAAY;UACZ,gBAAgB;UAChB,QAAQ,EAAA;EAt+ChC;IAg/CY,mBhClpFY;IgCmpFZ,yBhCxpFQ;IgCypFR,kBAAkB,EAAA;IAl/C9B;MAq/CgB,aAAa;MACb,mBAAmB,EAAA;MAt/CnC;QAy/CoB,iBAAiB,EAAA;MAz/CrC;QA6/CoB,gBAAgB;QAChB,kBAAkB;QAClB,iBAAiB,EAAA;MA//CrC;QAmgDoB,chC3qFK;QgC4qFL,kBAAkB;QAClB,SAAS,EAAA;MArgD7B;QAygDoB,aAAa;QACb,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB,EAAA;QA5gDtC;UA+gDwB,kBAAkB;UAClB,SAAS,EAAA;UAhhDjC;YAmhD4B,YAAY;YACZ,WAAW,EAAA;MAphDvC;QA0hDoB,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,iBAAiB;QACjB,sBAAsB;QACtB,SAAS,EAAA;IAhiD7B;MAuiDgB,aAAa;MACb,YAAY;MACZ,2DAA2D;MAC3D,oBAAoB;MACpB,gBAAgB;MAChB,aAAa,EAAA;MhCz+DzB;QACI,UAjKa,EAAA;MAoKjB;QACI,mBApKuB;QAqKvB,kBAAkB;QAClB,kBAAkB,EAAA;MAGtB;QACI,yBA3uBU;QA4uBV,kBAAkB,EAAA;QAElB;UACI,yBAAqD,EAAA;MgC8ajE;QAgjDoB,yBAAyB;QACzB,aAAa;QACb,mBAAmB;QACnB,kBAAkB;QAClB,gBAAgB;QAChB,eAAe,EAAA;QArjDnC;UAwjDwB,aAAa,EAAA;UAxjDrC;YA2jD4B,6BAA6B;YAC7B,8BAA8B;YAC9B,gDhCruFH,EAAA;QgCwqCzB;UAkkDwB,YAAY;UACZ,eAAe,EAAA;QAnkDvC;UAukDwB,WAAW;UACX,YAAY;UACZ,kBAAkB;UAClB,kBAAkB,EAAA;QA1kD1C;UAglDwB,qBAAqB;UACrB,gBAAgB;UAChB,mBAAmB;UACnB,gBAAgB;UAChB,uBAAuB;UACvB,kBAAkB,EAAA;UArlD1C;YAylD4B,gBAAgB;YAChB,gBAAgB;YAChB,oBAAoB;YACpB,wCAAwC,EAAA;;AAG5C;EACI;IACI,wBAAwB,EAAA;EAE5B;IACI,4BAA4B,EAAA,EAAA;QApmD5D;UA4mDwB,YAAY;UACZ,mBAAmB;UACnB,iBAAiB;UACjB,kBAAkB;UAClB,iBAAiB;UACjB,SAAS;UACT,2BAA2B,EAAA;UAlnDnD;YAqnD4B,SAAS;YACT,2BAA2B,EAAA;UAtnDvD;YA0nD4B,oBAAoB;YACpB,mBAAmB;YACnB,YAAY,EAAA;UA5nDxC;YAgoD4B,SAAS;YACT,2BAA2B,EAAA;QAjoDvD;UAuoDwB,chCvyFJ;UgCwyFI,YAAY;UACZ,6BAA6B,EAAA;UAzoDrD;YA4oD4B,WAAW;YACX,YAAY;YACZ,yBhC9yFR,EAAA;UgCgqCpB;YAkpD4B,oBAAoB;YACpB,mBAAmB;YACnB,YAAY,EAAA;QAppDxC;UAypDwB,cAAc;UACd,UAAU,EAAA;QA1pDlC;UA+pDwB,WAAW;UACX,kBAAkB;UAClB,QAAQ;UACR,MAAM;UACN,YAAY;UACZ,UAAU;UACV,mBhC50FJ,EAAA;MgCuqCpB;QA4qDwB,aAAa,EAAA;;AA5qDrC;EAorDQ,yBhChzFW;EgCizFX,aAAa;EACb,8BAA8B,EAAA;EAtrDtC;IA0rDY,iBAAiB,EAAA;;AAM7B;EACI,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY,EAAA;;AAGhB;EACI,iBAAiB,EAAA;;AAGrB;EACI,qBAAqB,EAAA;;AAGzB;EACI,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,aAAa,EAAA;;AAGjB;EACI,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,2CAA2C;EAC3C,+BAA+B;EAC/B,eAAe;EACf,gFAAgF,EAAA;;AAGpF;EACI,+BAA+B;EAC/B,qBhCl5FgB,EAAA;;AgCq5FpB;EACI,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa,EAAA;;AAGjB;EACI,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,WAAW;EACX,YAAY,EAAA;;AAGhB;EACI,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY,EAAA;;AAGhB;EACI,oBAAoB;EACpB,cAAc;EACd,gCAAgC,EAAA;;AAGpC;EACI,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB,EAAA;;AAGvB;;;;EAII,YAAY,EAAA;;AAGhB;EACI,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,gBAAgB,EAAA;;AAGpB;EACI,chCt7FiB,EAAA;;AgCy7FrB;EACI,chCz8FgB,EAAA;;AgC48FpB;EACI,chCl9FiB,EAAA;;AgCq9FrB;EACI,6BhCt9FiB,EAAA;;AgCy9FrB;EACI,chCt8FiB;EgCu8FjB,iBAAiB,EAAA;;AAGrB;;EAEI,chC58FiB;EgC68FjB,iBAAiB;EACjB,gBAAgB,EAAA;;AAGpB;EACI,uBAAuB;EACvB,uBAAuB,EAAA;;AAG3B;EACI,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,WAAW,EAAA;;AAGf;EACI,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,2CAA2C;EAC3C,kBAAkB;EAClB,+BAA+B;EAC/B,gCAAgC;EAChC,eAAe;EACf,cAAc,EAAA;;AAGlB;;EAEI,uCAAuC;EACvC,WAAW;EACX,aAAa,EAAA;;AAGjB;EACI,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B,EAAA;;AAGhC;EACI,eAAe;EACf,kBAAkB,EAAA;;AAGtB;EACI,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,SAAS,EAAA;EATb;IAYQ,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,cAAc,EAAA;;AAKtB;EACI,iBAAiB;EACjB,mBAAmB,EAAA;;AAGvB;EACI,iBAAiB,EAAA;;AAGrB;EACI,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,chCrkGqB;EgCskGrB,kCAAkC;EAClC,0CAA0C;EAC1C,yCAAyC;EACzC,oBAAoB,EAAA;;AAGxB;EAEQ,aAAa;EACb,SAAS;EACT,WAAW;EACX,oBAAoB,EAAA;EAL5B;;IAWY,WAAW;IACX,YAAY,EAAA;EAZxB;IAgBY,yBhCtlGY;IgCulGZ,yBhC7lGa;IgC8lGb,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,sBAAsB,EAAA;IArBlC;MAwBgB,aAAa;MACb,mBAAmB;MACnB,QAAQ;MACR,yBAAyB;MACzB,iBAAiB;MACjB,YAAY;MACZ,mBAAmB,EAAA;IA9BnC;MAkCgB,4BAA4B;MAC5B,cAAc,EAAA;IAnC9B;MAuCY,aAAa;MACb,gBAAgB,EAAA;;AAxC5B;EA+CQ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,WAAW,EAAA;EAnDnB;IAuDY,qCAAqC,EAAA;IAvDjD;MA0DgB,UAAU;MACV,oBAAoB;MACpB,iBAAiB;MACjB,kBAAkB,EAAA;;AA7DlC;EAmEQ,aAAa;EACb,SAAS;EACT,WAAW;EACX,oBAAoB,EAAA;EAtE5B;;IA0EY,WAAW;IACX,YAAY,EAAA;;AA3ExB;EAgFQ,WAAW;EACX,YAAY;EACZ,aAAa,EAAA;;AAlFrB;EAsFQ,WAAW;EACX,YAAY,EAAA;;AAvFpB;EA2FQ,WAAW;EACX,YAAY;EACZ,aAAa,EAAA;;AA7FrB;EAiGQ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB,EAAA;;AApG9B;EAwGQ,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,UAAU;EACV,uBAAuB;EACvB,oDAAoD;EACpD,WAAW;EACX,YAAY,EAAA;;AAhHpB;;;EAsHQ,UAAU;EACV,mBAAmB;EACnB,oBAAoB,EAAA;;AAxH5B;EA4HQ,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,2CAA2C,EAAA;;AAOnD;EACI,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc,EAAA;;AAGlB;EACI,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ,EAAA;EAJZ;IAOQ,aAAa;IACb,mBAAmB;IACnB,aAAa,EAAA;IATrB;MAYY,WAAW;MACX,YAAY;MACZ,iBAAiB;MACjB,sBAAsB,EAAA;IAflC;MAmBY,aAAa;MACb,sBAAsB;MACtB,QAAQ,EAAA;IArBpB;MAyBY,aAAa;MACb,sBAAsB;MACtB,YAAY;MACZ,aAAa,EAAA;IA5BzB;MAgCe,aAAa,EAAA;EAhC5B;IAqCQ,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,2BAA2B,EAAA;IA1CnC;MA6CY,YAAY;MACZ,WAAW;MACX,kBAAkB;MAClB,iDAAiD,EAAA;IAhD7D;MAoDY,4GAA4G;MAC5G,sBAAsB,EAAA;IArDlC;MAyDY,WAAW;MACX,eAAe,EAAA;MA1D3B;QA6DgB,YAAY,EAAA;IA7D5B;MAmEgB,chCpwGD,EAAA;;AgC2wGf;EAIgB,WAAW,EAAA;;AAM3B;EACI,UAAU;EACV,mBhC3yGU;EgC4yGV,YAAY;EACZ,yBhCxyGQ;EgCyyGR,kBAAkB,EAAA;;AAGtB;EACI,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,YAAY,EAAA;EAJhB;IAOQ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,QAAQ,EAAA;EAXhB;IAeW,gBAAgB,EAAA;;A/BvzE3B;E+B4zEI,gBAAgB,EAAA;;AAIpB;EACI,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,QAAQ,EAAA;EAJZ;IAOQ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB,EAAA;IAXxB;MAcY,cAAc;MACd,WAAW;MACX,YAAY;MACZ,eAAe,EAAA;IAjB3B;MAqBY,aAAa;MACb,sBAAsB;MACtB,QAAQ;MACR,YAAY,EAAA;IAxBxB;MA4BY,aAAa;MACb,mBAAmB;MACnB,QAAQ,EAAA;IA9BpB;MAkCY,aAAa;MACb,mBAAmB;MACnB,QAAQ,EAAA;MApCpB;QAwCgB,mBAAmB;QACnB,kBAAkB;QAClB,YAAY,EAAA;QA1C5B;UA8CoB,cAAc,EAAA;QA9ClC;UAkDoB,aAAa;UACb,kBAAkB;UAClB,SAAS;UACT,SAAS;UACT,2BAA2B;UAC3B,yBhC/3GD;UgCg4GC,yBhC13GF;UgC23GE,kBAAkB;UAClB,aAAa;UACb,aAAa;UACb,YAAY;UACZ,yCAAyC;UACzC,mBAAmB,EAAA;UA9DvC;YAiEwB,YAAY;YACZ,mBAAmB;YACnB,yBAAyB;YACzB,gBAAgB;YAChB,kBAAkB,EAAA;UArE1C;YAyEwB,aAAa;YACb,8BAA8B;YAC9B,mBAAmB;YACnB,aAAa,EAAA;YA5ErC;;cAgF4B,OAAO;cACP,gBAAgB,EAAA;YAjF5C;cAqF4B,SAAS;cACT,kBAAkB;cAClB,cAAc;cACd,mBAAmB,EAAA;MAxF/C;QAiGgB,aAAa,EAAA;EAjG7B;IAwGQ,aAAa;IACb,mBAAmB,EAAA;IAzG3B;MA4GY,aAAa,EAAA;IA5GzB;MAgHY,kBAAkB;MAClB,WAAW;MACX,QAAQ,EAAA;EAlHpB;IAuHQ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB,EAAA;IA3HxB;MA8HY,cAAc;MACd,WAAW;MACX,YAAY;MACZ,eAAe,EAAA;IAjI3B;MAqIY,aAAa;MACb,sBAAsB;MACtB,QAAQ;MACR,YAAY,EAAA;MAxIxB;QA2IgB,aAAa,EAAA;MA3I7B;QA+IgB,gBAAgB;QAChB,uBAAuB;QACvB,eAAe,EAAA;EAjJ/B;IAuJQ,aAAa;IACb,2BAA2B;IAC3B,gBAAgB;IAChB,chCt+GY,EAAA;IgC40GpB;MAgKY,wBAAwB,EAAA;IAhKpC;MAoKY,WAAW;MACX,YAAY;MACZ,kBAAkB,EAAA;IAtK9B;MA0KY,SAAS,EAAA;EA1KrB;IA+KQ,aAAa;IACb,2BAA2B;IAC3B,YAAY;IACZ,mBAAmB;IACnB,eAAe,EAAA;IAnLvB;MAsLY,wBAAwB,EAAA;IAtLpC;MA0LY,WAAW;MACX,YAAY;MACZ,kBAAkB,EAAA;IA5L9B;MAgMY,SAAS,EAAA;;AASrB;EACI,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ,EAAA;EANZ;IASQ,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB,EAAA;EAXxB;IAeQ,aAAa;IACb,SAAS;IACT,iBAAiB;IACjB,iBAAiB,EAAA;;AAKzB;EAEQ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,yBhCnjHgB;EgCojHhB,qCAAqC;EACrC,yBAAyB,EAAA;EAdjC;IAiBY,yBhCrjHA;IgCsjHA,chC9jHQ,EAAA;EgC4iHpB;IAsBY,yBAAyB;IACzB,chChkHE,EAAA;EgCyiHd;IA2BY,yBAAyB;IACzB,chCzkHa,EAAA;EgC6iHzB;IAgCY,yBAAyB;IACzB,chC9kHa,EAAA;EgC6iHzB;IAqCY,yBAAyB;IACzB,chCnlHa;IgColHb,yBAAyB;IACzB,yBAAyB;IACzB,eAAe,EAAA;IAzC3B;MA4CgB,yBAAsC;MACtC,chCzlHI;MgC0lHJ,qBAAqB,EAAA;EA9CrC;IAmDY,yBhC5lHE;IgC6lHF,chChmHQ,EAAA;;AgCqmHpB;EhC5+FE,aAAa;EACb,8BAA8B;EAC9B,cA5nBuB;EA6nBvB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gCA7nBY;EA8nBZ,8BAA8B;EAC9B,mHAAiF,EAAA;;AgCm+FnF;EAOY,yBAAyB;EACzB,aAAa,EAAA;EARzB;IAWgB,YAAY;IACZ,iCAAiC;IACjC,iCAAiC,EAAA;;AAbjD;EAmBY,aAAa;EACb,yBAAyB;EACzB,yBhCrnHY;EgCsnHZ,aAAa;EACb,0BAA0B;EAC1B,SAAS,EAAA;EAxBrB;IA2BgB,SAAS,EAAA;;AAOzB;EACI,yBhC7lHe;EgC8lHf,eAAe,EAAA;EAFnB;IAMQ,aAAa;IACb,yBhCzoHgB;IgC0oHhB,yBhC/oHY;IgCgpHZ,kBAAkB,EAAA;EAT1B;IAaQ,+CAA+C,EAAA;IAbvD;MAgBY,gBAAgB,EAAA;EAhB5B;IAqBQ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,eAAe,EAAA;IA9BvB;MAiCY,2CAAwC,EAAA;IAjCpD;MAqCY,oBAAoB;MACpB,mBAAmB;MACnB,SAAS;MACT,YAAY,EAAA;IAxCxB;MA4CY,WAAW;MACX,YAAY,EAAA;EA7CxB;IAkDQ,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,8CAA8C;IAC9C,gCAAgC;IAChC,cAAc,EAAA;EAxDtB;IA6DY,yBAAyB,EAAA;EA7DrC;;IAoEY,iBAAiB,EAAA;EApE7B;IAwEY,iBAAiB;IACjB,cAAc,EAAA;IhCt+FtB;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;EgC84FjE;IA+EQ,gBAAgB;IAChB,aAAa;IACb,UAAU;IACV,qDAAqD,EAAA;IAlF7D;MAqFY,+BAA+B;MAC/B,UAAU;MACV,kBAAkB,EAAA;MhCp/F1B;QACI,UAjKa,EAAA;MAoKjB;QACI,mBApKuB;QAqKvB,kBAAkB;QAClB,kBAAkB,EAAA;MAGtB;QACI,yBA3uBU;QA4uBV,kBAAkB,EAAA;QAElB;UACI,yBAAqD,EAAA;EgC84FjE;IA6FQ,gBAAgB;IAChB,aAAa;IACb,yBhCjuHgB;IgCkuHhB,yBhCvuHY;IgCwuHZ,kBAAkB,EAAA;IAjG1B;MAoGY,aAAa;MACb,mBAAmB;MAAE,wDAAA,EAAyD;MArG1F;QAwGgB,WAAW;QACX,YAAY;QACZ,kBAAkB;QAAE,qCAAA,EAAsC;MA1G1E;QA8GgB,SAAS;QAAE,uDAAA,EAAwD;IA9GnF;MAmHY,iBAAiB,EAAA;MAnH7B;;;;;;;;QA6HgB,qBAAqB,EAAA;MA7HrC;QAiIgB,aAAa,EAAA;EAjI7B;IAwIQ,aAAa;IACb,mBAAmB;IAEnB,aAAa;IACb,aAAa;IACb,yBhC/wHgB;IgCgxHhB,yBhCrxHY;IgCsxHZ,kBAAkB,EAAA;IA/I1B;MAkJY,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,eAAe,EAAA;IArJ3B;MAyJY,aAAa;MACb,mBAAmB;MACnB,oBAAoB;MACpB,YAAY;MACZ,SAAS;MACT,YAAY,EAAA;MA9JxB;QAiKgB,aAAa;QACb,sBAAsB;QACtB,YAAY;QACZ,QAAQ;QACR,cAAc,EAAA;QArK9B;UAwKoB,aAAa;UACb,uBAAuB;UACvB,8BAA8B;UAC9B,SAAS;UACT,YAAY,EAAA;UA5KhC;YA+KwB,cAAc;YACd,YAAY,EAAA;UAhLpC;YAoLwB,cAAc;YACd,eAAe;YACf,mBAAmB,EAAA;MAtL3C;QA4LgB,aAAa;QACb,sBAAsB;QACtB,YAAY;QACZ,YAAY,EAAA;QA/L5B;UAkMoB,aAAa,EAAA;QAlMjC;UAsMoB,aAAa;UACb,2CAA2C;UAC3C,mBAAmB;UACnB,gBAAgB;UAChB,YAAY,EAAA;UA1MhC;YA6MwB,kBAAkB,EAAA;UA7M1C;YAiNwB,mBAAmB,EAAA;UAjN3C;;;YAuNwB,kBAAkB,EAAA;MAvN1C;QA6NgB,aAAa;QACb,2CAA2C;QAC3C,mBAAmB;QACnB,gBAAgB;QAChB,SAAS,EAAA;QAjOzB;UAoOoB,SAAS;UACT,mBAAmB,EAAA;QArOvC;UAyOoB,kBAAkB;UAClB,wBAAwB;UACxB,WAAW;UACX,WAAW;UACX,eAAe,EAAA;MA7OnC;QAkPgB,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,YAAY;QACZ,WAAW,EAAA;QAtP3B;UAyPoB,kBAAkB;UAClB,oBAAoB,EAAA;QA1PxC;UA8PoB,kBAAkB;UAClB,SAAS,EAAA;UA/P7B;YAkQwB,kBAAkB;YAClB,WAAW;YACX,YAAY;YACZ,kBAAkB;YAClB,yBhCx4HA;YgCy4HA,yBhC94HJ,EAAA;UgCuoHpB;;YA6Q4B,kBAAkB;YAClB,WAAW;YACX,YAAY;YACZ,yBhCl5HJ;YgCm5HI,yBhCx5HR,EAAA;MgCuoHpB;QAwRgB,aAAa;QACb,mBAAmB;QACnB,oBAAoB;QACpB,mBAAmB;QACnB,SAAS;QACT,cAAc;QACd,WAAW;QACX,YAAY,EAAA;MA/R5B;QAmSgB,aAAa;QACb,sBAAsB;QACtB,oBAAoB;QACpB,sBAAsB;QACtB,eAAe;QACf,YAAY;QACZ,gBAAgB,EAAA;MAzShC;QA6SgB,aAAa;QACb,sBAAsB;QACtB,oBAAoB;QACpB,mBAAmB;QACnB,QAAQ;QACR,eAAe;QACf,YAAY;QACZ,gBAAgB,EAAA;MApThC;QAwTgB,aAAa;QACb,sBAAsB;QACtB,oBAAoB;QACpB,QAAQ;QACR,WAAW,EAAA;MA5T3B;QAgUgB,SAAS;QACT,iBAAiB;QACjB,gBAAgB;QAChB,WAAW;QACX,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB,EAAA;QAtUlC;UAyUoB,aAAa;UACb,mBAAmB,EAAA;QA1UvC;UA8UoB,oBAAoB;UACpB,mBAAmB;UACnB,uBAAuB;UACvB,gBAAgB;UAChB,0ChCh7HC;UgCi7HD,kBAAkB;UAClB,kChC56HK;UgC66HL,chC79HK;UgC89HL,oBAAoB;UACpB,kBAAkB;UAClB,gBAAgB;UAChB,oBAAoB;UACpB,sBAAsB;UACtB,mDhCr+HA;UgCs+HA,4EAGoB,EAAA;UA/VxC;YAkWwB,sChCj8HJ;YgCk8HI,kChC/7HL;YgCg8HK,chC9+HJ,EAAA;UgC0oHpB;YAyWwB,aAAa;YACb,mBAAmB,EAAA;MA1W3C;QAgXgB,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,QAAQ;QACR,WAAW;QACX,SAAS,EAAA;QArXzB;;UAyXoB,YAAY;UACZ,cAAc,EAAA;QA1XlC;UA8XoB,kBAAkB;UAClB,MAAM;UACN,cAAc;UACd,eAAe;UACf,cAAc,EAAA;UAlYlC;YAqYwB,aAAa;YACb,mBAAmB,EAAA;UAtY3C;YA0YwB,YAAY;YACZ,WAAW;YACX,cAAc,EAAA;MA5YtC;QAkZgB,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,YAAY;QACZ,gBAAgB;QAChB,WAAW;QACX,aAAa;QACb,yBAAyB,EAAA;QAzZzC;UA4ZoB,iBAAiB,EAAA;IA5ZrC;MAoaY,aAAa;MACb,sBAAsB;MACtB,iBAAiB;MACjB,cAAc,EAAA;MAva1B;QA0agB,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,eAAe,EAAA;MA7a/B;QAibgB,YAAY;QACZ,YAAY;QACZ,yBhC7gII;QgC8gIJ,0CAA0C;QAC1C,kBAAkB;QAClB,cAAc;QACd,eAAe,EAAA;QhCp1G3B;UACI,UAjKa,EAAA;QAoKjB;UACI,mBApKuB;UAqKvB,kBAAkB;UAClB,kBAAkB,EAAA;QAGtB;UACI,yBA3uBU;UA4uBV,kBAAkB,EAAA;UAElB;YACI,yBAAqD,EAAA;MgC84FjE;QA4bgB,gBAAgB;QAGhB,kBAAkB;QAClB,cAAc;QACd,eAAe,EAAA;QhC91G3B;UACI,UAjKa,EAAA;QAoKjB;UACI,mBApKuB;UAqKvB,kBAAkB;UAClB,kBAAkB,EAAA;QAGtB;UACI,yBA3uBU;UA4uBV,kBAAkB,EAAA;UAElB;YACI,yBAAqD,EAAA;MgC84FjE;QAscgB,aAAa;QACb,mBAAmB;QACnB,uBAAuB,EAAA;QAxcvC;UA2coB,YAAY;UACZ,WAAW;UACX,kBAAkB,EAAA;QA7ctC;UAidoB,SAAS,EAAA;EAjd7B;IAwdQ,kBAAkB;IAClB,kBAAkB;IAElB,aAAa;IACb,sBAAsB;IACtB,yBhC/lIgB;IgCgmIhB,yBhCrmIY;IgCsmIZ,kBAAkB,EAAA;IA/d1B;MAkeY,aAAa;MACb,mBAAmB;MACnB,qBAAqB,EAAA;MApejC;QAuegB,WAAW;QACX,YAAY;QACZ,kBAAkB;QAAE,qCAAA,EAAsC;MAze1E;QA6egB,SAAS;QACT,yBAAyB;QACzB,sBAAsB;QACtB,kBAAkB;QAClB,gBAAgB,EAAA;IAjfhC;MAsfY,aAAa;MACb,mBAAmB;MACnB,eAAe;MACf,oBAAoB;MACpB,uBAAuB;MACvB,SAAS;MACT,qBAAqB;MACrB,sBAAsB,EAAA;IA7flC;MAigBY,2BAA2B,EAAA;IAjgBvC;MAqgBY,cAAc;MACd,WAAW;MACX,eAAe;MACf,YAAY,EAAA;IAxgBxB;MA4gBY,WAAW,EAAA;IA5gBvB;MAghBY,eAAe;MACf,2BAAW;MACX,eAAe,EAAA;IAlhB3B;MAshBY,cAAc;MACd,aAAa;MACb,mBAAmB,EAAA;IAxhB/B;MA4hBY,SAAS;MACT,kBAAkB;MAClB,0CAA0C;MAC1C,mBAAmB;MACnB,yBhC1nIQ;MgC2nIR,sBAAsB;MACtB,YAAY;MACZ,aAAa;MACb,aAAa;MACb,mBAAmB;MACnB,uBAAuB,EAAA;IAtiBnC;MA0iBY,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,SAAS,EAAA;IA7iBrB;MAijBY,WAAW;MACX,YAAY;MACZ,cAAc;MACd,cAAc,EAAA;IApjB1B;MAwjBY,aAAa;MACb,mBAAmB;MACnB,mBAAmB;MACnB,SAAS,EAAA;IA3jBrB;MA+jBY,eAAe;MACf,gBAAgB;MAChB,cAAc;MACd,gChC1sIa,EAAA;IgCwoHzB;MAskBY,kBAAkB;MAClB,gBAAgB;MAChB,yBAAyB;MACzB,sBAAsB;MACtB,gChCltIa,EAAA;IgCwoHzB;MA8kBY,aAAa;MACb,mBAAmB;MACnB,eAAe;MACf,mBAAmB;MACnB,qBAAqB;MACrB,SAAS;MACT,SAAS;MACT,kBAAkB;MAClB,0CAA0C;MAC1C,mBAAmB;MACnB,yBhClrIQ;MgCmrIR,sBAAsB;MACtB,gBAAgB,EAAA;IA1lB5B;MA8lBY,SAAS,EAAA;IA9lBrB;MAkmBY,cAAc,EAAA;IAlmB1B;MAsmBY,cAAc;MACd,YAAY;MACZ,aAAa;MACb,uBAAuB,EAAA;IAzmBnC;MA6mBY,WAAW;MACX,gBAAgB;MAChB,cAAc,EAAA;IA/mB1B;MAmnBY,WAAW;MACX,cAAc,EAAA;IApnB1B;MAwnBY,eAAe;MACf,wBAAwB,EAAA;IAznBpC;MA6nBY,cAAc;MACd,gBAAgB;MAChB,YAAY,EAAA;IA/nBxB;MAmoBY,gBAAgB;MAChB,yBAAyB;MACzB,gBAAgB;MAChB,eAAe;MACf,sBAAsB;MACtB,iBAAiB;MACjB,gChCjxIa,EAAA;IgCwoHzB;MA6oBY,SAAS;MACT,kBAAkB;MAClB,iBAAiB;MACjB,gChCxxIa,EAAA;IgCwoHzB;MAopBY,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,cAAc,EAAA;IAvpB1B;MA2pBY,cAAc;MACd,WAAW;MACX,YAAY,EAAA;IA7pBxB;MAiqBY,iChCzyIa,EAAA;IgCwoHzB;MAqqBY,ehCnwIS;MgCqwIT,mGAE6C,EAAA;IAzqBzD;MA6qBY,kBAAkB;MAClB,QAAQ;MACR,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,uBAAuB;MACvB,YAAY;MACZ,oBAAoB,EAAA;IAprBhC;MAwrBY,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;MACjB,gChCn0Ia,EAAA;IgCwoHzB;MA+rBY,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,yBAAyB;MACzB,sBAAsB;MACtB,+BhC50Ia;MgC60Ib,kBAAkB;MAClB,eAAe;MACf,iBAAiB,EAAA;IAGrB;MA1sBR;QA4sBgB,sBAAsB;QACtB,oBAAoB,EAAA;MA7sBpC;QAitBgB,cAAc,EAAA;MAjtB9B;QAqtBgB,uBAAuB,EAAA;MArtBvC;QAytBgB,sBAAsB;QACtB,mBAAmB,EAAA;MA1tBnC;QA8tBgB,aAAa;QACb,uBAAuB,EAAA;MA/tBvC;QAmuBgB,cAAc;QACd,eAAe;QACf,kBAAkB,EAAA,EACrB;;AAKb;EACI,0BAA0B,EAAA;EAD9B;IAKQ,YAAY,EAAA;EALpB;IASQ,YAAY,EAAA;;AAIpB;EACI,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBhCx1Ie;EgCy1If,eAAe;EACf,0BAA0B;EAC1B,YAAY;EACZ,WAAW,EAAA;EARf;IAWQ,YAAY;IACZ,iBAAiB;IACjB,cAAc,EAAA;;AAStB;EACI,YAAY;EACZ,iBAAiB;EACjB,mBAAmB,EAAA;;AAGvB,4FAAA;AACA;EACI,iBAAiB,EAAA;EADrB;IAIQ,qDAAA;IACA,ahCn2HW;IgCo2HX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB,EAAA;IAd9B;MAiBY,aAAa;MACb,gBAAgB;MAChB,WAAW,EAAA;MAnBvB;QAsBgB,SAAS;QACT,kBAAkB;QAClB,chCp7II;QgCq7IJ,gBAAgB,EAAA;;AAMhC;EACI,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB,EAAA;;AAG3B;EACI,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,yBhCp8IU;EgCq8IV,yBhC97Ic;EgC+7Id,eAAe;EACf,gChCh8Ic;EgCi8Id,8BAA8B;EAC9B,aAAa;EACb,2CAA2C;EAE3C,wBAAwB;EACxB,yBAAyB,EAAA;EAb7B;IAgBQ,oCAAY,EAAA;EAhBpB;IAoBQ,oCAAY,EAAA;EApBpB;IAyBQ,aAAa;IACb,mBAAmB;IACnB,YAAY;IAEZ,gChCr7IW;IgCs7IX,8BAA8B;IAC9B,gBAAgB;IhC/4HtB,mHAAiF;IACjF,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B,EAAA;IgC62H7B;MAmCY,kBAAkB;MAClB,YAAY;MACZ,gBAAgB;MAChB,QAAQ,EAAA;MAtCpB;QAyCgB,kBAAkB;QAClB,YAAY;QACZ,WAAW;QACX,gBAAgB;QAChB,kBAAkB;QAClB,YAAY,EAAA;IA9C5B;MAkDY,chCt/Ia;MgCu/Ib,kBAAkB;MAClB,gBAAgB;MAChB,WAAW;MACX,YAAY,EAAA;EAtDxB;IA4DQ,aAAa;IACb,sBAAsB,EAAA;IA7D9B;MAgEQ,mBhC//IW;MgCggJP,kBAAkB;MAClB,gBAAgB;MAChB,aAAa;MACb,aAAa;MACb,eAAe;MACf,yBhC//IM;MgCggJN,kBAAkB;MAClB,kBAAkB,EAAA;MhCjyH1B;QACI,UAjKa,EAAA;MAoKjB;QACI,mBApKuB;QAqKvB,kBAAkB;QAClB,kBAAkB,EAAA;MAGtB;QACI,yBA3uBU;QA4uBV,kBAAkB,EAAA;QAElB;UACI,yBAAqD,EAAA;MgC0sHjE;QA4EgB,aAAa;QACb,uBAAuB;QACvB,QAAQ;QACR,gBAAgB;QAChB,sBAAsB;QACtB,gBAAgB,EAAA;MAjFhC;QAqFgB,eAAe,EAAA;IArF/B;MA0FY,chC7hJQ,EAAA;MgCm8IpB;QA6FgB,chC1gJK,EAAA;IgC66IrB;MAkGY,gBAAgB,EAAA;IAlG5B;MAsGY,kBAAkB;MAClB,kBAAkB;MAClB,SAAS;MACT,WAAW;MACX,yBAAyB,EAAA;MA1GrC;QA6GgB,wBAAwB,EAAA;MA7GxC;QAiHgB,4BAA4B;QAC5B,4BAA4B;QAC5B,wBAAwB,EAAA;MAnHxC;QAwHoB,2BAA2B;QAC3B,8BAA8B;QAC9B,gBAAgB;QAChB,mBhC3jJN,EAAA;QgCg8Id;UA8HwB,2BAA2B,EAAA;QA9HnD;UAiIwB,iBAAiB;UACjB,mBhCjkJL;UgCkkJK,wBAAwB;UACxB,yBhC7jJN;UgC8jJM,kBAAkB,EAAA;;AAQ1C;EACI,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,yBAAyB,EAAA;;AAG7B;EACI,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,2DAA2D;EAC3D,WAAW;EACX,YAAY;EACZ,yDAA2C;EAC3C,uCAAuC;EACvC,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,chC7lJc;EgC8lJd,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,qCAAqC,EAAA;EAnBzC;IAsBQ,qCAAuC;IACvC,chCzmJI;IgC0mJJ,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,qCAAqC,EAAA;EA3B7C;IA+BQ,YAAY;IACZ,YAAY;IACZ,qCAAuC;IACvC,qCAAqC;IACrC,yBhCrnJI,EAAA;EgCklJZ;IAuCQ,qCAAqC,EAAA;EAvC7C;IA2CQ,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,wBAAwB,EAAA;EA9ChC;IAkDQ,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,UAAU;IACV,aAAa;IACb,iEAAiE,EAAA;IAxDzE;MA2DY,gCAAgC,EAAA;IA3D5C;MA+DY,gCAAgC,EAAA;IA/D5C;MAmEY,eAAe;MACf,kBAAkB;MAClB,UAAU;MACV,gBAAgB;MAChB,qCAAqC,EAAA;EAvEjD;IA4EQ,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,chClqJU;IgCmqJV,QAAQ;IACR,UAAU;IACV,cAAc;IACd,iBAAiB,EAAA;EAtFzB;IA0FQ,eAAe,EAAA;;AAKvB;EAKoB,wBAAwB,EAAA;;AAL5C;EAUgB,wBAAwB,EAAA;;AAMxC;EAKgB,wBAAwB,EAAA;;AALxC;EAUY,wBAAwB,EAAA;;AAKpC;EACI,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAS,EAAA;;AAGb;EACI,WAAW;EACX,YAAY,EAAA;;AAGhB;EACI,iBAAiB;EACjB,eAAe;EACf,chCxuJqB,EAAA;;AgC4uJzB;EAEQ,6BAA6B;EAC7B,yBhCzuJgB;EgC0uJhB,yBhChvJiB;EgCivJjB,kBAAkB;EAClB,aAAa,EAAA;EANrB;IASW,gBAAgB,EAAA;;AAM3B;EACI,YAAY,EAAA;EADhB;IhCt2HE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,SAAS;IACT,eAAe;IgCu2HT,8BAA8B;IAC9B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,chCrwJiB,EAAA;IA25BvB;MACE,cAAc;MACd,kBAAkB,EAAA;IAGpB;MACE,kBAAkB;MAClB,YAlC6B;MAmC7B,UAAU;MACV,WAAW;MAEX,iBAAiB,EAAA;IAXnB;MgC62HU,mBAAmB;MACnB,iBAAiB;MACjB,aAAa,EAAA;;AAKzB;EACI,aAAa;EACb,sBAAsB;EACtB,yBhClxJqB;EgCmxJrB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,sBAAsB,EAAA;EAT1B;IAYQ,YAAY,EAAA;EAZpB;IAgBQ,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB,EAAA;IhCzjItB;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;EgCqhIjE;IA0BQ,kBAAkB;IAClB,aAAa;IACb,qCAAqC;IACrC,QAAQ;IACR,mBAAmB,EAAA;EA9B3B;IAkCQ,iBAAiB;IACjB,chClzJiB;IgCmzJjB,aAAa;IACb,iBAAiB;IACjB,iBAAiB;IACjB,YAAY,EAAA;IAvCpB;MA0CY,aAAa;MACb,eAAe,EAAA;EA3C3B;IAgDQ,WAAW;IACX,sBAAsB,EAAA;EAjD9B;IAqDQ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,QAAQ,EAAA;;AAMhB;EAEQ,2BAAW;EACX,uBAAO;EACP,oBAAoB,EAAA;;AAJ5B;EASQ,YAAY;EACZ,eAAe,EAAA;;AAKvB;;EAGQ,mFAA0F;EAC1F,yBhCr1JU;EgCs1JV,gChCt1JU;EgCu1JV,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,0EAEmC,EAAA;;AAX3C;;EAeQ,UAAU;EACV,uBAAuB,EAAA;;AAhB/B;;EAqBQ,mBhCn0JY;EgCo0JZ,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB,EAAA;EA3B9B;;IA8BY,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,sBAAsB,EAAA;IAnClC;;MAsCgB,iBAAiB;MACjB,iBAAiB,EAAA;IAvCjC;;MA2CgB,iBAAiB;MACjB,iBAAiB;MACjB,oBAAoB;MACpB,mBAAmB;MACnB,iBAAiB;MACjB,oBAAoB;MACpB,0ChCn2JK;MgCo2JL,kChC91JS;MgC+1JT,chC/4JS;MgCg5JT,kBAAkB;MAClB,gBAAgB;MAChB,sBAAsB;MACtB,gBAAgB;MAChB,yBAAyB;MACzB,mBAAmB,EAAA;IAzDnC;;MA6DgB,qChCj4JD;MgCk4JC,chCn4JK,EAAA;IgCq0JrB;;MAkEgB,qChCp3JK;MgCq3JL,chC/5JS,EAAA;IgC41JzB;;MAuEgB,oChC72JA;MgC82JA,chC/2JM,EAAA;EgCuyJtB;;IA6EY,cAAc;IACd,cAAc,EAAA;IA9E1B;;MAiFgB,aAAa,EAAA;IAjF7B;;MAqFgB,SAAS,EAAA;IArFzB;;MAyFgB,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,QAAQ,EAAA;MA5FxB;;QA+FoB,SAAS,EAAA;MA/F7B;;QAmGoB,oBAAoB;QACpB,eAAe,EAAA;QApGnC;;UAuGwB,cAAc;UACd,MAAM,EAAA;EAxG9B;;IA+GY,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,QAAQ;IACR,YAAY;IACZ,eAAe,EAAA;IArH3B;;MAwHgB,aAAa;MACb,eAAe;MACf,mBAAmB;MACnB,QAAQ;MACR,SAAS,EAAA;IA5HzB;;MAgIgB,eAAe;MACf,iBAAiB,EAAA;;AAjIjC;;EAuIQ,0ChCz7Ja;EgC07Jb,mBAAmB;EAEnB,aAAa;EACb,gBAAgB;EAChB,sBAAsB,EAAA;EA5I9B;;IA+IY,sChCj8JS,EAAA;;AgCkzJrB;;EAoJQ,YAAY;EACZ,eAAe;EACf,cAAc;EACd,sBAAsB,EAAA;EAvJ9B;;IA0JY,YAAY,EAAA;;AA1JxB;;EA+JQ,mBhC38JiB;EgC48JjB,YAAY;EACZ,0ChCn9Ja;EgCo9Jb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB,EAAA;EArK1B;;IAwKY,kBAAkB;IAClB,iBAAiB;IACjB,YAAY,EAAA;;AA1KxB;;EA+KQ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,mBhCj+JiB;EgCk+JjB,YAAY;EACZ,0ChCz+Ja;EgC0+Jb,mBAAmB;EACnB,aAAa;EACb,sBAAsB,EAAA;EA1L9B;;IA6LY,eAAe,EAAA;IA7L3B;;MAgMgB,SAAS;MACT,gCAAgC,EAAA;EAjMhD;;IAsMY,gBAAgB;IAChB,aAAa,EAAA;EAvMzB;;IA2MY,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,yBhC9/JQ;IgC+/JR,0ChCngKS;IgCogKT,kBAAkB;IAClB,cAAc;IACd,aAAa,EAAA;IhCr0IrB;;MACI,UAjKa,EAAA;IAoKjB;;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;;QACI,yBAAqD,EAAA;IgCkmIjE;;MAwNgB,aAAa;MACb,mBAAmB;MACnB,QAAQ;MACR,chCvjKS,EAAA;MgC41JzB;;QA8NoB,SAAS;QACT,mBAAmB;QACnB,eAAe,EAAA;MAhOnC;;QAoOoB,eAAe,EAAA;;AApOnC;;EA2OQ,mBhCvhKiB;EgCwhKjB,0ChC9hKa;EgC+hKb,mBAAmB;EACnB,aAAa;EACb,sBAAsB,EAAA;;AA/O9B;;EAmPQ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,sBAAsB,EAAA;EAvP9B;;IA0PY,kBAAkB;IAClB,aAAa,EAAA;;AA3PzB;;EAgQQ,WAAW;EACX,sBAAsB,EAAA;;AAjQ9B;;EAwQQ,mBhCpjKiB;EgCqjKjB,0ChC3jKa;EgC4jKb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,YARsC;EAStC,gBATsC;EAUtC,cAAc,EAAA;EhCh4IlB;;IACI,UAjKa,EAAA;EAoKjB;;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;;MACI,yBAAqD,EAAA;EgCkmIjE;;;;IAoRY,eAAe;IACf,gBAAgB,EAAA;;AArR5B;;EA0RQ,YArBsC;EAsBtC,gBAtBsC;EAuBtC,aAAa;EACb,oBAAoB,EAAA;EA7R5B;;;;;;IAkSY,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB,EAAA;EArSlC;;IAySY,aAAa;IACb,sBAAsB,EAAA;IA1SlC;;MA6SgB,cAAc;MACd,aAAa;MACb,gBAAgB,EAAA;EA/ShC;;IAqTgB,cAAc;IACd,aAAa;IACb,gBAAgB,EAAA;EAvThC;;IA4TY,YAAY;IACZ,gBAAgB,EAAA;;AA7T5B;;EAkUQ,SAAS;EACT,sBAAsB;EACtB,YA/DsC;EAgEtC,gBAhEsC,EAAA;;AArQ9C;;EAyUQ,mBhCvnKY;EgCwnKZ,0ChC5nKa;EgC6nKb,mBAAmB;EACnB,aAAa;EACb,sBAAsB,EAAA;;AA7U9B;;EAiVQ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC,EAAA;;AApVxC;;EAwVQ,YAAY,EAAA;EAxVpB;;IA2VY,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,sBAAsB,EAAA;EA9VlC;;IAkWY,OAAO;IACP,aAAa;IACb,gBAAgB,EAAA;;AApW5B;;EAyWQ,WAAW;EACX,mBhCtpKiB;EgCupKjB,0ChC7pKa;EgC8pKb,mBAAmB;EACnB,aAAa;EACb,sBAAsB,EAAA;;AA9W9B;;;;EAoXY,mBhChqKa;EgCiqKb,0ChCvqKS;EgCwqKT,mBAAmB,EAAA;;AAtX/B;;EA0XY,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,aAAa,EAAA;;AA9XzB;;;;EAmYY,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe,EAAA;;AAvY3B;;EA4YQ,kFAAyF;EACzF,8ChC/rKa;EgCgsKb,4BAA4B;EAC5B,eAAe,EAAA;;AAIvB;EACI,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B,EAAA;;AAGnC;EACI,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,wChC5vKiB;EgC6vKjB,mBhC1vKoB;EgC2vKpB,2CAA2C;EAC3C,chClwKqB,EAAA;;AgCqwKzB;EACI,eAAe;EACf,eAAe;EACf,gBAAgB,EAAA;;AAGpB;EACI,gBAAgB;EAChB,eAAe;EACf,aAAa,EAAA;;AAGjB;EACI,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB,EAAA;;AAGvB;EACI,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uChC3xKiB;EgC4xKjB,qCAAqC;EACrC,chClyKgB;EgCmyKhB,eAAe;EACf,cAAc;EACd,eAAe,EAAA;EAVnB;IAaQ,aAAa;IACb,mBAAmB,EAAA;EAd3B;IAmBQ,sChClwKa;IgCmwKb,oChCnwKa,EAAA;;AgCuwKrB;EACI,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,uBAAuB,EAAA;;AAG3B;EACI,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,wChC3zKiB;EgC4zKjB,+BAA+B;EAC/B,chCl0KgB;EgCm0KhB,eAAe;EACf,gBAAgB;EAChB,kBAAkB,EAAA;;AAGtB;EACI,eAAe;EACf,aAAa,EAAA;;AAGjB;EACI,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB,EAAA;;AAGtB;EACI,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,+BhC5yKiB;EgC6yKjB,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe,EAAA;EARnB;IAYQ,cAAgC,EAAA;;AAIxC;EACI,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,kBAAkB,EAAA;;AAGtB;EACI,aAAa;EACb,yBAAyB;EACzB,QAAQ,EAAA;;AAGZ;EACI,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,wChCh3KiB;EgCi3KjB,eAAe;EACf,gBAAgB;EAChB,eAAe,EAAA;;AAGnB;EACI,uBAAuB;EACvB,chC33KqB,EAAA;;AgC83KzB;EACI,oChCr1KiB;EgCs1KjB,sChCt1KiB;EgCu1KjB,chCn4KgB,EAAA;EgCg4KpB;IAMQ,aAAa;IACb,mBAAmB,EAAA;;AhCj6K3B;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AiCv8BA;;;;ElC872CE;AkCx72CF;EACE,mBjCsEuB;EiCrEvB,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EAyHV,iFAAA;EA0XA,oEAAA,EAAqE;EA/fvE;IAeI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,aAAa,EAAA;EAnBjB;IAuBI,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,QAAQ,EAAA;EA7BZ;IAiCI,cAAc;IACd,aAAa;IACb,cAAc,EAAA;IjC+tBd;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;EiCjxBjE;IAwCM,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,SAAS;IACT,aAAa,EAAA;EA5CnB;IAgDM,aAAa;IACb,SAAS;IACT,uBAAuB,EAAA;EAlD7B;IAsDM,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;IAC3C,+BAA+B;IAC/B,eAAe;IACf,iBAAiB,EAAA;EAlEvB;IAsEM,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,mBAAmB,EAAA;EA5EzB;IAgFM,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gCAAgC,EAAA;EAnFtC;;;IAyFM,YAAY,EAAA;EAzFlB;IA6FM,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,cAAc,EAAA;EAjGpB;IAqGM,cAAc,EAAA;EArGpB;IA0GM,cAAc;IACd,oFAAA;IACA,oBAAoB,EAAA;EA5G1B;IAgHM,WAAW,EAAA;EAhHjB;IAoHM,aAAa;IACb,sBAAsB;IACtB,QAAQ,EAAA;EAtHd;IA0HM,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,kBAAkB;IAClB,gBAAgB,EAAA;EA9HtB;IAkIM,iBAAiB,EAAA;EAlIvB;IjCm8BE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;IACT,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,SAAS;IACT,oBAAoB;IACpB,eAAe;IACf,cA17BuB,EAAA;IA47BvB;MACE,gBAAgB;MAChB,oBAAoB;MACpB,mBAAmB;MACnB,cAAc;MACd,SAAS;MACT,WAAW;MACX,mBAAmB;MACnB,kBAAkB,EAAA;IAGpB;MACE,kBAAkB;MAClB,SAAS;MACT,UAAU;MACV,WAAW;MACX,YAAY;MACZ,SAAS;MACT,cAAc,EAAA;EiCr+BlB;IA2IM,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ,EAAA;EA9Id;IAkJM,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,mBAAmB,EAAA;EArJzB;IAyJM,iBAAiB;IACjB,aAAa;IACb,0BAA0B,EAAA;EA3JhC;IA+JM,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IAErB,QAAQ;IACR,YAAY,EAAA;EApKlB;IAwKM,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,cAAc;IACd,YAAY;IACZ,eAAe,EAAA;EA9KrB;IAkLM,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,sBAAsB;IACtB,mBAAmB,EAAA;EAtLzB;IA0LM,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB,EAAA;EA7LzB;IAiMM,aAAa;IACb,oBAAoB;IACpB,YAAY;IACZ,mBjCvKkB;IiCwKlB,yBjC3Ke;IiC4Kf,kBAAkB;IAClB,gBAAgB,EAAA;EAvMtB;IA2MM,YAAY,EAAA;EA3MlB;IA+MM,cjCxLmB;IiCyLnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBjC/IoB;IiCgJpB,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,YAAY,EAAA;EAvNlB;IA2NM,mBAAmB,EAAA;EA3NzB;IA+NM,aAAa,EAAA;EA/NnB;IAmOM,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IAEd,iBAAiB;IACjB,kCjC/Me;IiCgNf,4CjChNe;IiCiNf,cjCpNmB;IiCqNnB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,iBAAiB,EAAA;EAhPvB;IAoPM,gBAAgB;IAChB,aAAa,EAAA;EArPnB;IAyPM,aAAa,EAAA;EAzPnB;IA6PM,aAAa,EAAA;EA7PnB;IAiQM,aAAa,EAAA;EAjQnB;IAqQM,4EAA4E,EAAA;EArQlF;IAyQM,aAAa,EAAA;EAzQnB;IA6QM,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,yBjCtPe;IiCuPf,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,eAAe,EAAA;EAxRrB;IA4RM,oCjC3Ne;IiC4Nf,8CjC5Ne,EAAA;EiCjErB;IAiSM,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,cAAc,EAAA;EAxSpB;IA4SM,cAAc;IACd,cAAc;IACd,mBjC1OoB;IiC2OpB,YAAY;IACZ,yBjCtRe;IiCuRf,kBAAkB,EAAA;EAjTxB;IAqTM,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,oDAAoD;IACpD,aAAa,EAAA;EA5TnB;IAgUM,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,QAAQ;IACR,YAAY,EAAA;EAvUlB;IA2UM,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,mBAAmB,EAAA;EA9UzB;IAkVM,iBAAiB;IACjB,aAAa;IACb,0BAA0B,EAAA;EApVhC;IAwVM,eAAe;IACf,gBAAgB;IAChB,cjCnUmB;IiCoUnB,mBAAmB,EAAA;EA3VzB;IA+VM,WAAW;IACX,kBAAkB;IAClB,mBjCpUkB;IiCqUlB,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,2BAA2B;IAC3B,YAAY,EAAA;EAtWlB;IA0WM,wCjChVe;IiCiVf,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,gBAAgB,EAAA;EArXtB;IAyXM,uBAAuB,EAAA;EAzX7B;;IA8XM,kBAAkB;IAClB,UAAU,EAAA;EA/XhB;IAmYM,WAAW,EAAA;EAnYjB;IAuYM,oDjCtUe;IiCuUf,oCjCvUe,EAAA;EiCjErB;IA4YM,oDjC3Ue;IiC4Uf,mCjC5Ue,EAAA;EiCjErB;IAiZM,oDjChVe,EAAA;EiCjErB;IAqZM,aAAa;IACb,sBAAsB;IACtB,QAAQ,EAAA;EAvZd;IA2ZM,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,aAAa;IACb,cAAc,EAAA;EA/ZpB;IAmaM,aAAa;IACb,oBAAoB;IACpB,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,iBAAiB;IACjB,qCAAqC;IACrC,0CAA0C;IAC1C,kDAAkD;IAClD,0BAA0B,EAAA;EA5ahC;IAgbM,cAAc;IACd,YAAY;IACZ,aAAa;IACb,6EAA6E;IAC7E,SAAS;IACT,mBAAmB;IACnB,UAAU,EAAA;EAtbhB;IA0bM,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB,EAAA;EAjc7B;IAqcM,iBAAiB,EAAA;EArcvB;IAycM,cAAc;IACd,0CAA0C;IAC1C,aAAa;IACb,0BAA0B;IAC1B,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,aAAa;IACb,+BAA+B,EAAA;IjCgTjC;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;EiCjxBjE;IAydM,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe,EAAA;EA7drB;IAieM,uBAAuB,EAAA;EAje7B;IAqeM,oCjCpae;IiCqaf,kBAAkB,EAAA;EAtexB;IA0eM,cAAc;IACd,MAAM;IACN,UAAU;IACV,cAAc;IACd,0CAA0C;IAC1C,kBAAkB;IAClB,aAAa;IACb,+BAA+B,EAAA;IjCiRjC;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;EiCjxBjE;IAsfM,kBAAkB,EAAA;EAtfxB;IA0fM,WAAW;IACX,yBAAyB;IACzB,mBAAmB,EAAA;EA5fzB;IAigBM,UAAU,EAAA;EAjgBhB;IAqgBM,UAAU,EAAA;EArgBhB;IAygBM,SAAS,EAAA;EAzgBf;IA6gBM,UAAU,EAAA;EA7gBhB;IAihBM,qCAAqC,EAAA;EAjhB3C;IAqhBM,iBAAiB;IACjB,gBAAgB;IAChB,kDAAkD;IAClD,gBAAgB,EAAA;EAxhBtB;IA4hBM,iBAAiB,EAAA;EA5hBvB;IAgiBM,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB,EAAA;EAliBxB;IAsiBM,iBAAiB;IACjB,sBAAsB;IACtB,kDAAkD,EAAA;EAxiBxD;IA4iBM,gBAAgB,EAAA;EA5iBtB;IAgjBM,iBAAiB,EAAA;EAhjBvB;IAojBM,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB,EAAA;EAvjBxB;;IA4jBM,YAAY,EAAA;EA5jBlB;IAgkBM,gBAAgB;IAChB,YAAY,EAAA;EAjkBlB;IAqkBM,YAAY;IACZ,WAAW;IACX,gBAAgB,EAAA;EAvkBtB;IA2kBM,aAAa,EAAA;EA3kBnB;IA+kBM,aAAa;IACb,8DAA8D;IAC9D,SAAS;IACT,mBAAmB;IACnB,WAAW;IACX,YAAY,EAAA;EAplBlB;IAwlBM,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY,EAAA;EA3lBlB;IA+lBM,YAAY,EAAA;EA/lBlB;IAmmBM,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB,EAAA;EArmBxB;IAymBM,YAAY,EAAA;EAzmBlB;IA6mBM,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe,EAAA;EAhnBrB;IAsnBM,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,QAAQ;IACR,cAAc,EAAA;EA1nBpB;IA8nBM,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,QAAQ;IACR,YAAY,EAAA;EAloBlB;IAuoBM,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,WAAW,EAAA;EA3oBjB;IA+oBM,aAAa;IACb,oBAAoB;IACpB,WAAW;IACX,mBjCrnBkB;IiCsnBlB,yBjCznBe;IiC0nBf,kBAAkB;IAClB,gBAAgB,EAAA;EArpBtB;IAypBM,YAAY,EAAA;EAzpBlB;IA6pBM,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,sBAAsB;IACtB,cjC3oBmB;IiC4oBnB,mBjC5lBmB,EAAA;EiCvEzB;IAuqBM,gCAAgC,EAAA;EAvqBtC;IA2qBM,cAAc;IACd,WAAW;IACX,YAAY,EAAA;EA7qBlB;IAirBM,WAAW;IACX,sBAAsB;IACtB,cAAc;IACd,YAAY;IACZ,mBjCjnBoB;IiCknBpB,SAAS;IACT,gBAAgB;IAChB,yBAAyB;IACzB,cjClqBmB;IiCmqBnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB,EAAA;EA5rBtB;IAgsBM,aAAa,EAAA;EAhsBnB;IAosBM,eAAe;IACf,eAAe;IACf,aAAa,EAAA;EAtsBnB;IA0sBM,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,kCjCprBkB;IiCqrBlB,2CAA2C;IAC3C,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc,EAAA;IjC4ChB;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;EiCjxBjE;IA2tBM,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,kDAAkD,EAAA;IA/tBxD;MAkuBU,mBAAmB,EAAA;IAluB7B;MAsuBU,0CjCrqBW,EAAA;IiCjErB;MA0uBU,2CAA2C,EAAA;IA1uBrD;MA8uBU,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,QAAQ;MACR,iBAAiB;MACjB,YAAY,EAAA;IAnvBtB;MAuvBU,eAAe;MACf,gCAAgC;MAChC,gBAAgB;MAChB,uBAAuB;MACvB,mBAAmB;MACnB,eAAe,EAAA;IA5vBzB;MAgwBU,eAAe;MACf,gCAAgC;MAChC,gBAAgB;MAChB,uBAAuB;MACvB,mBAAmB;MACnB,eAAe,EAAA;EArwBzB;IA0wBM,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;IACnB,YAAY,EAAA;EA9wBlB;IAkxBM,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;IACZ,mBAAmB,EAAA;EAtxBzB;IA0xBM,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,yBjCpN4B;IiCqN5B,kBAAkB;IAClB,mBjC3Nc;IiC4Nd,gBAAgB,EAAA;EAnyBtB;IAuyBM,gBAAgB,EAAA;EAvyBtB;IA2yBM,UAAU,EAAA;EA3yBhB;IA+yBM,cAAc;IACd,WAAW;IACX,eAAe;IACf,SAAS;IACT,YAAY;IACZ,SAAS;IACT,gDAAgD;IAChD,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,gCAAgC;IAChC,mFAAmF,EAAA;EA5zBzF;IAg0BM,gBAAgB,EAAA;EAh0BtB;IAo0BM,WAAW;IACX,cAAc;IACd,UAAU;IACV,YAAY;IACZ,mCAAmC;IACnC,oCAAoC;IACpC,yFAA2F,EAAA;EA10BjG;;IA+0BM,gCAAgC;IAChC,mFAAmF,EAAA;EAh1BzF;IAo1BM,gBAAgB,EAAA;EAp1BtB;IAw1BM,YAAY;IACZ,cAAc;IACd,aAAa;IACb,oBAAoB,EAAA;EA31B1B;IA+1BM,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,eAAe,EAAA;EAl2BrB;IAs2BM,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,cAAc,EAAA;EA12BpB;IAi3BM,mBAAmB;IACnB,aAAa,EAAA;;AAInB,mFAAA;AACA;;;;EAME,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAA;;AAGnB;;EAIE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,2CAA2C,EAAA;;AD63I7C;ECz3IE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B,EAAA;;AD63IjC;ECz3IE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,wCjCl4BmB;EiCm4BnB,mBjCh4BsB;EiCi4BtB,2CAA2C;EAC3C,cjCx4BuB,EAAA;;AgCqwKzB;ECz3IE,eAAe;EACf,eAAe;EACf,gBAAgB,EAAA;;AD63IlB;ECz3IE,gBAAgB;EAChB,eAAe;EACf,aAAa,EAAA;;AD63If;ECz3IE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB,EAAA;;AD63IrB;ECz3IE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCjCj6BmB;EiCk6BnB,qCAAqC;EACrC,cjCx6BkB;EiCy6BlB,eAAe;EACf,cAAc;EACd,eAAe,EAAA;EDg3IjB;IC72II,aAAa;IACb,mBAAmB,EAAA;ED42IvB;ICv2II,sCjCx4BiB;IiCy4BjB,oCjCz4BiB,EAAA;;AgCuwKrB;ECz3IE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,uBAAuB,EAAA;;AD63IzB;ECz3IE,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,wCjCj8BmB;EiCk8BnB,+BAA+B;EAC/B,cjCx8BkB;EiCy8BlB,eAAe;EACf,gBAAgB;EAChB,kBAAkB,EAAA;;AD63IpB;ECz3IE,eAAe;EACf,aAAa,EAAA;;AD63If;ECz3IE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB,EAAA;;AD63IpB;ECz3IE,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,+BjCl7BmB;EiCm7BnB,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe,EAAA;EDk3IjB;IC92II,cAAgC,EAAA;;AD83IpC;ECz3IE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,kBAAkB,EAAA;;AD63IpB;ECz3IE,aAAa;EACb,yBAAyB;EACzB,QAAQ,EAAA;;AD63IV;ECz3IE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,wCjCt/BmB;EiCu/BnB,eAAe;EACf,gBAAgB;EAChB,eAAe,EAAA;;AD63IjB;ECz3IE,uBAAuB;EACvB,cjCjgCuB,EAAA;;AgC83KzB;ECz3IE,oCjC39BmB;EiC49BnB,sCjC59BmB;EiC69BnB,cjCzgCkB,EAAA;EgCg4KpB;ICp3II,aAAa;IACb,mBAAmB,EAAA;;AjCviCvB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AkCt8BA;EACE,yBlCiCsB;EkChCtB,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB,EAAA;EANxB;IASI,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,QAAQ,EAAA;EAhBZ;IAoBI,iBAAiB;IACjB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,2CAA2C;IAC3C,+BAA+B;IAC/B,eAAe;IACf,gFAAgF,EAAA;EAjCpF;IAqCI,+BAA+B;IAC/B,qBlCTgB,EAAA;EkC7BpB;IA0CI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa,EAAA;EA9CjB;IAkDI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,4BAA4B;IAC5B,iBAAiB;IACjB,cAAc,EAAA;IlCgtBd;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;EkCtxBjE;IA6DM,iBAAiB;IACjB,cAAc,EAAA;EA9DpB;IAkEM,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB,EAAA;EApE1B;IAwEM,kBAAkB,EAAA;EAxExB;IA6EI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,YAAY,EAAA;EAjFhB;IAsFI,gBAAgB,EAAA;EAtFpB;IA0FI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,0BAA0B;IAC1B,gBAAgB;IAChB,yBlC5DQ;IkC6DR,kBAAkB;IAClB,clCvEqB;IkCwErB,0EAA2E;IAC3E,iBAAiB;IACjB,iBAAiB;IACjB,kHAGwC;IACxC,+ClC/EqB,EAAA;EkC5BzB;IA+GI,aAAa;IACb,yCAAyC;IACzC,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,qCAAqC;IACrC,2CAA2C,EAAA;EAtH/C;IA0HI,mCAAmC,EAAA;EA1HvC;IA8HI,kBAAkB,EAAA;EA9HtB;IAmII,kBAAkB;IAClB,gBAAgB,EAAA;IApIpB;MAuIM,WAAW;MACX,kBAAkB;MAClB,OAAO;MACP,MAAM;MACN,SAAS;MACT,UAAU;MACV,0BAA0B;MAC1B,uBAAuB;MACvB,oBAAoB,EAAA;IA/I1B;MAmJM,mBlC9GM,EAAA;EkCrCZ;IAwJI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB,EAAA;IA5JvB;MA+JM,SAAS,EAAA;IA/Jf;MAmKM,eAAe,EAAA;EAnKrB;IAwKI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,2CAA2C;IAC3C,uBAAuB,EAAA;IA5K3B;MA+KM,qBlC1IM;MkC2IN,uBAAuB,EAAA;IAhL7B;MAoLM,mBlCvJc;MkCwJd,sCAAsC,EAAA;IArL5C;MAyLM,mBlCpJM;MkCqJN,sCAAsC,EAAA;IA1L5C;MA8LM,mBlC5GU;MkC6GV,sCAAsC,EAAA;IA/L5C;MAmMM,mBlC/IS;MkCgJT,sCAAsC,EAAA;IApM5C;MAwMM,uCAAuC;MACvC,uBAAuB,EAAA;EAzM7B;IA8MI,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB,EAAA;EAjNvB;IAqNI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,iBAAiB;IACjB,clCrMqB;IkCsMrB,yBlCzJsB;IkC0JtB,kBAAkB;IAClB,mBlCxJqB;IkCyJrB,YAAY,EAAA;EArOhB;IAyOI,UAAU;IACV,kBAAkB;IAClB,iBAAiB,EAAA;IA3OrB;MA8OM,clCzMM,EAAA;EkCrCZ;IAmPI,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,iBAAiB,EAAA;;AlCvPrB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AmCt8BA;EACE,WAAW;EACX,YAAY,EAAA;;AAId;EACE,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,2CAA2C,EAAA;;AAG7C;;EAEE,WAAW;EACX,YAAY,EAAA;;AAId;EACE,yBnCQsB;EmCPtB,yBnCEkB;EmCDlB,kBAAkB;EAWlB,aAAa;EACb,SAAS;EACT,aAAa;EACb,aAAa;EACb,sBAAsB;EAgFtB,qFAAA,EAAsF;EAlGxF;IAOM,oBAAoB,EAAA;EAP1B;IAYI,qBnCAQ,EAAA;EmCZZ;IAqBI,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,QAAQ,EAAA;EA3BZ;IA+BI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,cAAc;IACd,aAAa;IACb,cAAc,EAAA;InC0sBd;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;EmC7vBjE;IAyCI,aAAa;IACb,oDAAoD;IACpD,gBAAgB;IAChB,UAAU;IACV,mBAAmB;IACnB,cAAc;IACd,qCAAqC;IACrC,2CAA2C;IAC3C,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB,EAAA;EAnDxB;IAuDI,kBAAkB,EAAA;EAvDtB;IA2DI,cAAc;IACd,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,iBAAiB,EAAA;IA/DrB;MAkEM,cnCtDM,EAAA;EmCZZ;IAuEI,cAAc;IACd,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,iBAAiB;IACjB,+BAA+B;IAC/B,2CAA2C;IAC3C,kBAAkB;IAClB,mBnCxCsB;ImCyCtB,YAAY,EAAA;EAzFhB;IA6FI,cAAc;IACd,WAAW;IACX,YAAY,EAAA;EA/FhB;IAoGI,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,SAAS;IACT,eAAe,EAAA;EAzGnB;IA6GI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,aAAa;IACb,uBAAuB,EAAA;EArH3B;IAyHI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,0BAA0B;IAC1B,gBAAgB;IAChB,yBnCpHQ;ImCqHR,kBAAkB;IAClB,cnC/HqB;ImCgIrB,0EAA2E;IAC3E,iBAAiB;IACjB,iBAAiB;IACjB,kHAGwC;IACxC,+CnCvIqB,EAAA;EmCHzB;IA8II,cAAc;IACd,WAAW;IACX,oBAAoB;IACpB,QAAQ,EAAA;EAjJZ;IAsJM,kBAAkB,EAAA;EAtJxB;IA2JI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,+CAA+C;IAC/C,mBAAmB;IACnB,uBAAuB,EAAA;EAlK3B;IAsKI,aAAa;IACb,6BAA6B;IAC7B,0BAA0B;IAC1B,QAAQ;IACR,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;IACZ,kBAAkB,EAAA;EA7KtB;IAiLI,kBAAkB;IAClB,YAAY;IACZ,YAAY,EAAA;IAnLhB;MAsLM,WAAW;MACX,kBAAkB;MAClB,oBAAoB;MACpB,qBAAqB;MACrB,QAAQ;MACR,WAAW;MACX,2BAA2B;MAC3B,qCAAqC;MACrC,oBAAoB,EAAA;EA9L1B;IAmMI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,2CAA2C;IAC3C,mBnC/LoB;ImCgMpB,UAAU;IACV,oBAAoB,EAAA;IA1MxB;MA6MM,sCAAsC,EAAA;IA7M5C;MAiNM,sCAAsC;MACtC,qCAAqC,EAAA;EAlN3C;IAwNM,mCnC5MM,EAAA;EmCZZ;IA4NM,qBnChNM;ImCiNN,uBAAuB,EAAA;EA7N7B;IAiOM,oCnCrNM,EAAA;EmCZZ;IAuOM,qCAAqC,EAAA;EAvO3C;IA2OM,sCAAsC,EAAA;EA3O5C;IA+OM,mBnC3Oc,EAAA;EmCJpB;IAmPM,mBnCvOM,EAAA;EmCZZ;IAuPM,mBnC9LU,EAAA;EmCzDhB;IA2PM,mBnChOS,EAAA;EmC3Bf;IAgQI,kBAAkB;IAClB,YAAY;IACZ,MAAM;IACN,OAAO;IACP,aAAa;IACb,qCAAqC;IACrC,6BAA6B;IAC7B,QAAQ,EAAA;EAvQZ;IA2QI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;IACvB,YAAY;IACZ,UAAU;IACV,eAAe;IACf,YAAY,EAAA;IAnRhB;MAsRM,sCAAsC,EAAA;EAtR5C;IA2RI,cnCxRqB;ImCyRrB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB,EAAA;;AAKrB;EACE,yBnCrPuB;EmCsPvB,0CAA0C;EAC1C,kBAAkB;EAWlB,aAAa;EACb,SAAS;EACT,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EA+EtB,qFAAA;EAuDA,4IAAA;EAoEA,8GAAA,EAAgH;EA7NlH;IAOM,oBAAoB,EAAA;EAP1B;IAYI,qBnCvSQ,EAAA;EmC2RZ;IAsBI,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,QAAQ,EAAA;EA5BZ;IAgCI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,cAAc;IACd,aAAa;IACb,cAAc,EAAA;InCkad;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;EmCtdjE;IA0CI,aAAa;IACb,oDAAoD;IACpD,gBAAgB;IAChB,UAAU;IACV,mBAAmB;IACnB,cAAc;IACd,qCAAqC;IACrC,2CAA2C;IAC3C,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB,EAAA;EApDrB;IAwDI,kBAAkB,EAAA;EAxDtB;IA4DI,cAAc;IACd,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,iBAAiB,EAAA;IAhErB;MAmEM,cnC9VM,EAAA;EmC2RZ;IAwEI,cAAc;IACd,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,iBAAiB;IACjB,+BAA+B;IAC/B,0CAA0C;IAC1C,kBAAkB;IAClB,mBnC/UgB,EAAA;EmCsPpB;IA6FI,cAAc;IACd,WAAW;IACX,YAAY,EAAA;EA/FhB;IAoGI,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,SAAS;IACT,eAAe,EAAA;EAzGnB;IA6GI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,aAAa;IACb,uBAAuB,EAAA;EArH3B;IAyHI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,0BAA0B;IAC1B,gBAAgB;IAChB,yBnC3ZQ;ImC4ZR,kBAAkB;IAClB,cnCtaqB;ImCuarB,0EAA2E;IAC3E,iBAAiB;IACjB,iBAAiB;IACjB,kHAGwC;IACxC,+CnC9aqB,EAAA;EmCoSzB;IA8II,cAAc;IACd,WAAW;IACX,oBAAoB;IACpB,QAAQ;IACR,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY,EAAA;EAtJhB;IA2JI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;IAC7B,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,uBAAuB,EAAA;EA1K3B;IA8KI,mBnC/ciB;ImCgdjB,qBnCjduB;ImCkdvB,cnCndgB,EAAA;EmCmSpB;IAoLI,mBnC9ce;ImC+cf,qBnCjdgB;ImCkdhB,cnC5dgB,EAAA;EmCsSpB;IA0LI,mBnCxaY;ImCyaZ,qBnC3auB;ImC4avB,cnClegB,EAAA;EmCsSpB;IAgMI,mBnC1cgB;ImC2chB,qBnC9ciB;ImC+cjB,cnCxegB,EAAA;EmCsSpB;IAsMI,uBAAuB;IACvB,qBnCnegB;ImCoehB,oBAAoB;IACpB,cnC7eqB,EAAA;EmCoSzB;IA8MM,kBAAkB,EAAA;EA9MxB;IAmNI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,+CAA+C;IAC/C,mBAAmB;IACnB,uBAAuB,EAAA;EA1N3B;IA+NI,aAAa;IACb,6BAA6B;IAC7B,0BAA0B;IAC1B,QAAQ;IACR,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;IACZ,kBAAkB,EAAA;EAtOtB;IA0OI,kBAAkB;IAClB,YAAY;IACZ,YAAY,EAAA;IA5OhB;MA+OM,WAAW;MACX,kBAAkB;MAClB,oBAAoB;MACpB,qBAAqB;MACrB,QAAQ;MACR,WAAW;MACX,2BAA2B;MAC3B,qCAAqC;MACrC,oBAAoB,EAAA;EAvP1B;IA4PI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,2CAA2C;IAC3C,mBnC/hBoB;ImCgiBpB,UAAU;IACV,oBAAoB,EAAA;IAnQxB;MAsQM,sCAAsC,EAAA;IAtQ5C;MA0QM,sCAAsC;MACtC,qCAAqC,EAAA;EA3Q3C;IAiRM,mCnC5iBM,EAAA;EmC2RZ;IAqRM,qBnChjBM;ImCijBN,uBAAuB,EAAA;EAtR7B;IA0RM,oCnCrjBM,EAAA;EmC2RZ;IAgSM,qCAAqC,EAAA;EAhS3C;IAoSM,sCAAsC,EAAA;EApS5C;IAwSM,mBnC3kBc,EAAA;EmCmSpB;IA4SM,mBnCvkBM,EAAA;EmC2RZ;IAgTM,mBnC9hBU,EAAA;EmC8OhB;IAoTM,mBnChkBS,EAAA;EmC4Qf;IAyTI,kBAAkB;IAClB,YAAY;IACZ,MAAM;IACN,OAAO;IACP,aAAa;IACb,qCAAqC;IACrC,6BAA6B;IAC7B,QAAQ,EAAA;EAhUZ;IAoUI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;IACvB,YAAY;IACZ,UAAU;IACV,eAAe;IACf,YAAY,EAAA;IA5UhB;MA+UM,sCAAsC,EAAA;EA/U5C;IAoVI,cnCxnBqB;ImCynBrB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB,EAAA;;AAKrB;EACE,kBAAkB;EAClB,gBAAgB,EAAA;EAFlB;IAKI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,SAAS;IACT,UAAU;IACV,0BAA0B;IAC1B,uBAAuB;IACvB,oBAAoB,EAAA;EAbxB;IAiBI,mBnC5oBQ,EAAA;;AmCZZ;EA6pBE,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,2CAA2C;EAC3C,+BAA+B;EAC/B,eAAe;EACf,gFAAgF,EAAA;;AAGlF;EACE,+BAA+B;EAC/B,qBnChrBkB,EAAA;;AmCmrBpB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa,EAAA;;AArZf;EAyZE,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,2CAA2C;EAC3C,+BAA+B;EAC/B,eAAe;EACf,gFAAgF,EAAA;;AAGlF;EACE,+BAA+B;EAC/B,qBnCntBkB,EAAA;;AmCstBpB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa,EAAA;;AnCxvBf;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AoCv8BA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,6GpC2BsB;EoCxBtB,0BAA0B,EAAA;;AAG5B;EACE,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,0CpCoDkB;EoCnDlB,qBAAqB;EACrB,2FACwF;EACxF,mFpCgDkB,EAAA;;AoC3CpB;EACE,sBAAsB;EACtB,kBAAkB,EAAA;;AAGpB;EACE,SAAS;EACT,cpCLuB;EoCMvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB,EAAA;;AAG3B;EACE,mBAAmB;EACnB,+BpC2BkB;EoC1BlB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB,EAAA;;AAG3B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,0CpCekB;EoCdlB,sBAAsB;EACtB,mFAC8E;EAC9E,kDpCWkB,EAAA;;AoCRpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY,EAAA;;AAGd;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kDAAkD,EAAA;;AAGpD;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY,EAAA;;AAGd;EACE,cpCvDuB;EoCwDvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB,EAAA;;AAGlB;EACE,cpCCwB;EoCAxB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB,EAAA;;AAGlB;EACE,mBAAmB;EACnB,cpCtEkB;EoCuElB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB,EAAA;EAElB;IACE,mBAAmB;IACnB,oBAAoB;IACpB,0CpCtCgB;IoCuChB,sBAAsB;IACtB,kCpC3EoB;IoC4EpB,gBAAgB,EAAA;;AAIpB;EACE,SAAS,EAAA;EADX;IAII,mBAAmB,EAAA;;AAIvB;EACE,sBAAsB;EACtB,wBAAwB;EACxB,+CpCxDkB;EoCyDlB,sBAAsB;EACtB,kCpC7FsB;EoC8FtB,gCpCpGuB;EoCqGvB,kBAAkB;EAClB,iBAAiB,EAAA;;AAGnB;EACE,mBAAmB,EAAA;;AAGrB;;;EAGE,cAAc;EACd,kBAAkB;EAClB,gCpChHyB;EoCiHzB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB,EAAA;;AAG3B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY,EAAA;EAEZ;IACE,sBAAsB,EAAA;;AAI1B;EACE,mBAAmB;EACnB,cpCpIyB;EoCqIzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB,EAAA;EAElB;IACE,kBAAkB,EAAA;;AAItB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,kCpCnJsB;EoCoJtB,gCpCxJyB;EoCyJzB,eAAe;EACf,cAAc;EACd,eAAe;EACf,sGAIuB,EAAA;EAlBzB;IAsBI,oCpCrGqB;IoCsGrB,cpCvGsB;IoCwGtB,mFpCzGgB,EAAA;EoCiFpB;IA8BI,oCpC7GqB;IoC8GrB,gCpC/GsB;IoCgHtB,mFpCjHgB,EAAA;EoCsHlB;IACE,eAAe,EAAA;EAtCnB;IA0CI,uCAAuC;IACvC,gCpC3HsB,EAAA;EoCgF1B;IA+CI,aAAa;IACb,mBAAmB,EAAA;;AAIvB;EACE,cAAc;EACd,gBAAgB;EAChB,wBAAwB;EACxB,0CpC/JkB;EoCgKlB,sBAAsB;EACtB,kCpCpMsB;EoCqMtB,cpC3MuB;EoC4MvB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,uFAG6B,EAAA;EAd/B;IAiBI,gCpCnNuB,EAAA;EoCkM3B;IAqBI,aAAa;IACb,sCpCjLgB;IoCkLhB,kCpCrNoB;IoCsNpB,8CpCnLgB,EAAA;;AoCuLpB;EACE,mBAAmB;EACnB,qBAAqB;EACrB,0CpC1LkB;EoC2LlB,sBAAsB;EACtB,kCpC/NsB,EAAA;;AoCkOxB;EACE,mBAAmB;EACnB,cpC1KwB;EoC2KxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB,EAAA;;AAGpB;EACE,SAAS;EACT,uBAAuB;EACvB,sBAAsB;EACtB,kCpC9OsB;EoC+OtB,cpCrPuB;EoCsPvB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB,EAAA;EAEtB;IACE,uBAAuB;IACvB,cpC3PuB;IoC4PvB,kBAAkB;IAClB,eAAe;IACf,gBAAgB,EAAA;;AAIpB;EACE,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,mCpChQkB;EoCiQlB,cAA+B;EAC/B,kBAAkB;EAClB,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB,EAAA;EAEnB;IACE,uBAAuB,EAAA;EAGzB;IACE,8BAA8B,EAAA;;AAIlC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,2HAKoB,EAAA;EAlBtB;IAqBI,0BAA0B,EAAA;EArB9B;IAyBI,UAAU;IACV,mBAAmB,EAAA;EAGrB;IACE,sCpCjRgB;IoCkRhB,cpC7TgB;IoC8ThB,0EAKC;IACD,8CpCvRU,EAAA;IoC8QX;MAYG,8CpC1RQ,EAAA;EoC8RZ;IACE,uCpCxUuB;IoCyUvB,gCpCzUuB;IoC0UvB,kCpCtUoB;IoCuUpB,gBAAgB,EAAA;EAGlB;IACE,uCpC/UuB;IoCgVvB,cpClVqB;IoCmVrB,kCpC7UoB,EAAA;IoC0UrB;MAMG,sCpC7Sc;MoC8Sd,kCpCtSkB,EAAA;;AA7ExB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AqCj8BA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,+BAA+B;EAC/B,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB,EAAA;;AAGlB,8CAAA;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW,EAAA;EATb;IAcQ,WAAW,EAAA;EAdnB;IAoBI,aAAa;IACb,SAAS;IACT,eAAe,EAAA;IAtBnB;MAyBM,kBAAkB;MAClB,aAAa;MACb,mBAAmB;MACnB,kBAAkB;MAClB,kBAAkB;MAClB,gBAAgB;MAChB,eAAe,EAAA;MA/BrB;QAkCQ,aAAa,EAAA;MAlCrB;QAsCQ,kBAAkB;QAClB,OAAO;QACP,QAAQ;QACR,2BAA2B,EAAA;MAzCnC;QA6CQ,eAAe;QACf,crC5CY;QqC6CZ,mBAAmB;QACnB,cAAc,EAAA;;AAMtB;EACE,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,yBrCTuB;EqCUvB,yGrCXiB;EqCcjB,0CrCnBmB;EqCoBnB,0EAEiC,EAAA;EAXnC;IAcI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,eAAe,EAAA;EAlBnB;IAuBI,kBAAkB;IAClB,sBAAsB;IACtB,oBAAoB;IACpB,iBAAiB;IACjB,UAAU;IACV,eAAe,EAAA;EA5BnB;IAgCI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,WAAW,EAAA;EAnCf;IAuCI,gBAAgB,EAAA;EAvCpB;IA2CI,YAAY;IACZ,QAAQ;IACR,WAAW,EAAA;EA7Cf;IAgDI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc,EAAA;EAnDlB;IAuDI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,SAAS,EAAA;EA5Db;IAgEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,0CrClFiB;IqCmFjB,kBAAkB;IAClB,kCrC7EoB;IqC8EpB,eAAe;IACf,gBAAgB;IAChB,yCAAyC;IACzC,0DAEuB,EAAA;IA/E3B;MAkFM,sCrC9Fc,EAAA;IqCYpB;MAsFM,2CrCjGe;MqCkGf,mBAAmB,EAAA;EAvFzB;IA4FI,qBrC5FkB;IqC6FlB,6EAE+B,EAAA;EA/FnC;IAmGI,qBrCnGkB,EAAA;EqCAtB;IAuGI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,kBAAkB,EAAA;EA3GtB;IAgHI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,WAAW,EAAA;EApHf;IAwHI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,cAAc;IACd,YAAY,EAAA;EA5HhB;IAgII,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,YAAY,EAAA;EArIhB;IAyII,aAAa;IACb,eAAe;IACf,WAAW;IACX,mBAAmB,EAAA;EA5IvB;IAgJI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;IACR,oBAAoB;IACpB,WAAW,EAAA;EAvJf;;IA4JI,oBAAoB;IACpB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,yBrCnNuB;IqCoNvB,0CAA0C;IAC1C,mBrClNe,EAAA;EqCgDnB;IAsKI,eAAe;IACf,iBAAiB;IACjB,SAAS;IACT,YAAY;IACZ,uBAAuB;IACvB,crC/NgB;IqCgOhB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;IACf,0EAA0E,EAAA;IAjL9E;MAoLM,+BrCtOe,EAAA;IqCkDrB;MAwLM,aAAa;MACb,mBAAmB,EAAA;IAzLzB;MA6LM,mBrC/Oe;MqCgPf,crCnPmB,EAAA;IqCqDzB;MrCsiBE,gHAEO;MACP,sBAAsB;MACtB,4BAA4B;MAC5B,2BAA2B;MqCxWvB,crCxPmB;MqCyPnB,mCrC9MQ,EAAA;;AqCmNd;EACE,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,crClQuB;EqCmQvB,mBAAmB;EACnB,SAAS,EAAA;;AAGX;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,mBrC7NoB;EqC8NpB,yBAAyB;EACzB,6BAA6B,EAAA;;AAG/B;EACE,SAAS;EACT,UAAU,EAAA;;AAGZ;EACE,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,iBAAiB,EAAA;;AAGnB;EACE,WAAW;EACX,iBAAiB;EACjB,mBrC1PsB;EqC2PtB,yBAAyB;EACzB,kBAAkB;EAClB,crC5SyB;EqC6SzB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,yEAAyE;EACzE,0CAA0C,EAAA;;AAG5C;EACE,mBAAmB;EACnB,qBAAqB;EACrB,crC1TuB,EAAA;;AqC6TzB;EACE,oDAAoD;EACpD,qBAAqB;EACrB,cAAc;EACd,qDAAiD,EAAA;;AAGnD;EACE,YAAS;EACT,iBAAiB;EACjB,cAAc;EACd,eAAe,EAAA;;AAKjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe,EAAA;;AAGjB;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,4EAA4E;EAC5E,0CAA0C;EAC1C,6BAA6B;EAC7B,crC5VuB,EAAA;EqCoVzB;IAgBI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,4EAA4E;IAC5E,0CAA0C,EAAA;IArB9C;MrCuQE,gHAEO;MACP,sBAAsB;MACtB,4BAA4B;MAC5B,2BAA2B;MqCnPvB,yBrClUQ;MqCmUR,crC9WmB,EAAA;IqCoVzB;MrCuQE,gHAEO;MACP,sBAAsB;MACtB,4BAA4B;MAC5B,2BAA2B;MqC7OvB,yBrCjXqB;MqCkXrB,crCnXc,EAAA;IqCmVpB;MAqCM,aAAa;MACb,mBAAmB;MACnB,gBAAgB,EAAA;IAvCtB;MA4CM,qBrC9XqB,EAAA;IqCkV3B;MAgDM,yBrC3Vc,EAAA;;AqCgWpB,8CAAA;AAEA;EACE,eAAe,EAAA;;AAGjB,UAAA;AACA;EACE,oCAA6C;EAC7C,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB,EAAA;;AAGlB;EACE,qBAAqB;EACrB,gBAAgB,EAAA;;AAGlB,wBAAA;AACA;;;EAGE,cAAc;EACd,eAAe,EAAA;;AAGjB,aAAA;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,YAAY,EAAA;;AAGd,YAAA;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe,EAAA;;AAGjB;EACE,mBAAmB,EAAA;;AAGrB;EACE,mBAAmB,EAAA;;AAGrB,mBAAA;AACA;EACE,cAAc,EAAA;;AAGhB;EACE,cAAc,EAAA;;AAGhB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW,EAAA;;AAGb,oBAAA;AACA;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,eAAe,EAAA;;AAGjB;EACE,mBAAmB;EACnB,qBAAqB,EAAA;;AAGvB;EACE,WAAW;EACX,mBAAmB,EAAA;;AAIrB,8CAAA;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,oBAAoB;EACpB,WAAW;EACX,cAAc;EACd,aAAa;EACb,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,qBAAqB,EAAA;;AAGvB,kEAAA;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,mFAEyC;EACzC,yCAAyC;EACzC,iDAAiD;EACjD,uHAKC,EAAA;;AAGH;EACE,aAAa;EACb,0EAKC;EACD,+CAA+C,EAAA;;AAGjD;EACE,OAAO;EACP,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS,EAAA;;AAGX;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,crCtjBuB,EAAA;;AqCyjBzB;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,crC5jBkB;EqC6jBlB,eAAe,EAAA;;AAGjB;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,crCnkByB;EqCokBzB,eAAe,EAAA;;AAGjB;EACE,crChiBmB;EqCiiBnB,qBAAqB;EACrB,gBAAgB;EAChB,iDAAiD;EACjD,qDAAqD,EAAA;EALvD;IAQI,crCxiBgB;IqCyiBhB,4CAA4C,EAAA;EAThD;IAaI,0BrC5iBiB;IqC6iBjB,mBAAmB;IACnB,gCAAgC,EAAA;;AAIpC;EACE,eAAe,EAAA;;AAGjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,crCxmBuB;EqCymBvB,oCAAoC;EACpC,0CAA0C;EAC1C,4EAA4E,EAAA;EAX9E;IAcI,crChnBgB;IqCinBhB,oCAAoC;IACpC,qCAAqC,EAAA;EAhBzC;IAoBI,0BrC1kBiB;IqC2kBjB,mBAAmB,EAAA;;AAIvB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ,EAAA;;AAGV;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,wCAAwC;EACxC,gDAAgD;EAChD,2BAA2B;EAC3B,2CAA2C;EAC3C,mCAAmC,EAAA;EARrC;IAYI,qBrCtmBU,EAAA;EqC0lBd;IAgBI,8BrC/lBY,EAAA;;AqCmmBhB;EACE,aAAa;EACb,wGAAwG;EACxG,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,yGrClnBiB;EqCmnBjB,cAAc;EACd,gBAAgB;EAChB,eAAe,EAAA;;AAGjB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kCrC5nBsB;EqC6nBtB,0CAA0C,EAAA;EAP5C;IAUI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,oBAAoB,EAAA;;AAIxB;EACE,cAAc;EACd,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,SAAS;EACT,YAAY,EAAA;EAFd;IAKI,eAAe;IACf,crCpsBgB;IqCqsBhB,eAAe,EAAA;;AAInB;EACE,YAAY,EAAA;EADd;IAII,aAAa;IACb,mBAAmB;IACnB,gBAAgB,EAAA;EANpB;;IAWI,oBAAoB;IACpB,mBAAmB;IACnB,MAAM;IACN,UAAU;IACV,SAAS;IACT,SAAS;IACT,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB,eAAe,EAAA;EApBnB;IAwBI,eAAe,EAAA;EAxBnB;IA4BI,eAAe;IACf,oBAAoB,EAAA;EA7BxB;IAiCI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,eAAe,EAAA;EAvCnB;IA2CI,crCnvBuB;IqCovBvB,oBAAoB,EAAA;EA5CxB;;;;IAoDM,crCrtBc,EAAA;EqCiqBpB;IAwDM,yBrCztBc,EAAA;EqCiqBpB;;;;IAiEM,crC3wBmB,EAAA;EqC0sBzB;IAqEM,yBrC/wBmB,EAAA;EqC0sBzB;;;;IA8EM,crCtxBqB,EAAA;EqCwsB3B;IAkFM,yBrC1xBqB,EAAA;EqCwsB3B;IAuFI,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,QAAQ;IACR,yBrCtyBuB;IqCuyBvB,uEAAgE;IAChE,+EAAwE,EAAA;EAhG5E;IAoGI,YAAY;IACZ,eAAe;IACf,cAAc;IACd,8BAA8B;IAC9B,kBAAkB;IAClB,kCrClwBoB;IqCmwBpB,eAAe;IACf,gBAAgB;IAChB,yBAAyB,EAAA;IA5G7B;MA+GM,aAAa;MACb,qBrCrwBgB,EAAA;IqCqpBtB;MAoHM,qBrCrzBM,EAAA;EqCisBZ;IAyHI,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,crC9zBQ;IqC+zBR,oBAAoB,EAAA;;AAIxB;EACE,crC30ByB;EqC40BzB,eAAe,EAAA;;AAGjB;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB,EAAA;EAHnB;IAMI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,0CAA0C;IAC1C,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,kCrC5zBoB;IqC6zBpB,crC92BqB,EAAA;IqCw1BzB;MAyBM,mBrCt1BgB;MqCu1BhB,qBrC11BS;MqC21BT,crC71BoB;MqC81BpB,iBAAiB,EAAA;IA5BvB;MAgCM,mBrCj0Be;MqCk0Bf,qBrCn0BU;MqCo0BV,crCt0BqB;MqCu0BrB,iBAAiB,EAAA;IAnCvB;MAuCM,oCrCr1Be;MqCs1Bf,qBrCv1Bc;MqCw1Bd,crCx1Bc,EAAA;;AqC61BpB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc,EAAA;;AAGhB;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAA;;AAGzB;EACE,cAAc;EACd,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,WAAW;EACX,YAAY;EACZ,+BrC55BkB;EqC65BlB,gCrC75BkB;EqC85BlB,wBAAwB;EACxB,+BAA+B;EAC/B,iBAAiB,EAAA;;AAGnB;EACE,0BAA0B;EAC1B,eAAe,EAAA;;AAGjB;EACE,sBAAsB;EACtB,kCrC13BsB;EqC23BtB,8CAA8C,EAAA;;AAGhD;EAEI,aAAa;EACb,gDAAgD;EAChD,6BAA6B;EAC7B,aAAa;EACb,WAAW,EAAA;;AANf;;EAWI,iBAAiB;EACjB,UAAU,EAAA;;AAZd;EAgBI,QAAQ;EACR,YAAY,EAAA;;AAjBhB;EAqBI,eAAe,EAAA;;AArBnB;EAyBI,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AA7BvB;EAiCI,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,eAAe,EAAA;;AArCnB;EAyCI,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,QAAQ,EAAA;;AA9CZ;EAkDI,SAAS;EACT,gBAAgB;EAChB,eAAe,EAAA;;AApDnB;EAwDI,eAAe;EACf,kBAAkB,EAAA;;AAItB;EACE,mBAAmB,EAAA;;AAGrB,mDAAA;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,0CAA0C;EAE1C,wCAAwC;EACxC,gDAAgD;EAChD,2BAlhCiB;EAmhCjB,2CAA2C,EAAA;EAR7C;IAWI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,crChgCqB,EAAA;;AqCogCzB;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAE1C,wCAAwC;EACxC,gDAAgD;EAChD,2BAA2B;EAC3B,2CAA2C,EAAA;EAV7C;IAaI,yBrCt+BU,EAAA;;AqC0+Bd,sCAAA;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB,EAAA;;AAGlB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,+BAA+B;EAC/B,oBAAoB,EAAA;;AAGtB,6CAAA;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ,EAAA;;AAKV,kDAAA;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,QAAQ,EAAA;;AAGV;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,crC9jCuB,EAAA;EqC0jCzB;IAOI,eAAe;IACf,WAAW;IACX,wBAAwB,EAAA;EAT5B;IAaI,crCtkCgB,EAAA;EqCyjCpB;IAiBI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,YAAY,EAAA;EApBhB;;IAyBI,oBAAoB;IACpB,mBAAmB;IACnB,MAAM;IACN,UAAU;IACV,SAAS;IACT,SAAS;IACT,uBAAuB;IACvB,aAAa;IACb,gBAAgB,EAAA;EAjCpB;IAqCI,eAAe,EAAA;EArCnB;IAyCI,eAAe;IACf,oBAAoB,EAAA;EA1CxB;IA8CI,gBAAgB;IAChB,yBAAyB,EAAA;EA/C7B;IAmDI,crC3mCuB;IqC4mCvB,oBAAoB,EAAA;EApDxB;;;;IA4DM,crC7kCc,EAAA;EqCihCpB;IAgEM,yBrCjlCc,EAAA;EqCihCpB;;;;IAyEM,crCnoCmB,EAAA;EqC0jCzB;IA6EM,yBrCvoCmB,EAAA;EqC0jCzB;;;;IAsFM,crC9oCqB,EAAA;EqCwjC3B;IA0FM,yBrClpCqB,EAAA;EqCwjC3B;IA+FI,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,QAAQ;IACR,yBrC9pCuB;IqC+pCvB,uEAAgE;IAChE,+EAAwE,EAAA;EAxG5E;IA4GI,kBAAkB;IAClB,eAAe,EAAA;EA7GnB;IAiHI,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,crCtqCQ;IqCuqCR,oBAAoB,EAAA;EAtHxB;IA0HI,YAAY;IACZ,eAAe;IACf,cAAc;IACd,8BAA8B;IAC9B,kBAAkB;IAClB,kCrCxoCoB;IqCyoCpB,eAAe;IACf,gBAAgB;IAChB,yBAAyB,EAAA;IAlI7B;MAqIM,crC7rCqB;MqC8rCrB,UAAU;MACV,oBAAoB,EAAA;IAvI1B;MA2IM,aAAa;MACb,qBrCjpCgB,EAAA;IqCqgCtB;MAgJM,qBrCjsCM,EAAA;;AqCssCZ;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAA;;AAGV;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,crC5tCuB;EqC6tCvB,eAAe;EACf,yBrCptCiB;EqCqtCjB,kBAAkB;EAClB,WAAW;ErCroBX,gHAEO;EACP,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EqCkoB3B,eAAe,EAAA;EAVjB;IAaI,yBrC7tCgB,EAAA;EqCgtCpB;IAiBI,aAAa;IACb,mBAAmB,EAAA;;AAIvB;EACE,eAAe;EACf,crC/uCkB;EqCgvClB,aAAa;EACb,oBAAoB,EAAA;;AAGtB;EACE,aAAa,EAAA;;AAIf;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,crC9vCuB,EAAA;;AqCiwCzB;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,crCrwCuB,EAAA;;AqCuwCzB,mDAAA;AAEA;EAEE,kBAAkB;EAClB,2BAA2B;EAC3B,0CAA0C;EAE1C,wCAAwC;EACxC,gDAAgD;EAChD,2BA1yCiB;EA2yCjB,2CAA2C;EAC3C,8BrCxuCY,EAAA;;AqC2uCd;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,crC1xCuB,EAAA;;AqC6xCzB;EACE,aAAa;EACb,4DAA4D;EAC5D,mBAAmB;EACnB,SAAS,EAAA;;AAGX;EACE,gBAAgB,EAAA;EADlB;IAII,iBAAiB;IACjB,eAAe;IACf,crCzyCgB,EAAA;EqCmyCpB;IAUI,SAAS;IACT,kBAAkB,EAAA;IAXtB;MAcM,eAAe;MACf,crClzCc;MqCmzCd,gBAAgB,EAAA;;AAKtB,mDAAA;AAEA;EACE,2CAA2C;EAC3C,8BrCvwCc;EqCwwCd,kBAAkB;EAClB,2BAA2B;EAC3B,2BAz1CiB;EA01CjB,0CAA0C;EAC1C,wCAAwC;EACxC,gDAAgD,EAAA;EARlD;IAWM,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,crCz0CmB,EAAA;;AqC60CzB,2CAAA;AAEA;;EAEE,cAAc,EAAA;;AAGhB;EAEE,yGrCvyCiB;EqCwyCjB,4BAA4B;EAC5B,6BAA6B;EAC7B,crCz1CuB;EqC41CvB,oDAAA;EACA,wEAQC,EAAA;;AAQH;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,UAAU;EACV,yGrCn0CiB;EqCq0CjB,sEAOC;EAED,2BAA2B;EAC3B,+BAA+B;EAE/B,aAAa;EACb,sBAAsB,EAAA;;AAGxB;EAEI,qBAAqB;EACrB,+BAA+B,EAAA;;AAHnC;EAOI,0BAA0B,EAAA;;AAI9B,0DAAA;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,wDAAwD;EACxD,4BAA4B;EAC5B,cAAc;EACd,OAAO,EAAA;;AAGT,iEAAA;AACA;EACE,cAAc;EACd,iBAAiB,EAAA;;AAGnB;EACI,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,kBAAkB,EAAA;EALtB;IAQI,mBrC74CkB;IqC84ClB,crCn5CsB;IqCo5CtB,iBAAiB;IACjB,mBAAmB,EAAA;EAXvB;IAeI,mBrCx3CiB;IqCy3CjB,crC53CuB;IqC63CvB,iBAAiB;IACjB,mBAAmB,EAAA;;AAIvB,6CAAA;AACA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,crC57CkB;EqC67ClB,aAAa,EAAA;;AAGf,6CAAA;AACA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,crCv8CkB;EqCw8ClB,aAAa,EAAA;;AAGf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ,EAAA;;AAGV,uCAAA;AACA;EACE,gBAAgB;EAChB,crCr9CkB;EqCs9ClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB,EAAA;;AAGrB,wCAAA;AACA;EACE,gBAAgB;EAChB,crC/9CuB;EqCg+CvB,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,eAAe;EACf,crCv+CkB,EAAA;;AqC0+CpB;EACE,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,crCh/CkB;EqCi/ClB,iBAAiB;EACjB,kBAAkB;EAClB,mBrCz9CoB;EqC09CpB,kBAAkB,EAAA;;AAGpB,uCAAA;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,crC//CuB;EqCggDvB,qBAAqB;EACrB,eAAe,EAAA;EARjB;IAWI,qBAAqB,EAAA;;AAKzB,oCAAA;AAGA,gCAAA;AAEA;EACE,gBAAgB;EAChB,aAAa,EAAA;EAFf;IAKI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,crCthDqB,EAAA;;AqC0hDzB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ,EAAA;;AAGV;EACE,aAAa;EACb,6EAA6E;EAC7E,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,wCAAwC;EACxC,gDAAgD;EAChD,2BAA2B;EAC3B,2CAA2C;EAC3C,mCAAmC,EAAA;EAZrC;IAeI,qBrC1gDU,EAAA;;AqC8gDd;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kCrC9gDsB;EqC+gDtB,0CAA0C,EAAA;EAP5C;IAUI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,oBAAoB,EAAA;;AAIxB;EACE,cAAc;EACd,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,YAAY;EACZ,SAAS;EACT,qBAAqB,EAAA;;AAGvB;EACE,eAAe;EACf,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB,EAAA;;AAGnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,0CAA0C;EAC1C,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,mBrCtlDoB;EqCulDpB,qBrC1lDa;EqC2lDb,crCnnDuB,EAAA;;AqCsnDzB;EACE,mCrCjkDc;EqCkkDd,qBrClkDc;EqCmkDd,crCrkDyB,EAAA;;AqCwkD3B;EACE,mCrCplDkB;EqCqlDlB,qBrCrlDkB;EqCslDlB,crC/nDuB,EAAA;;AqCkoDzB;EACE,oCrCzlDmB;EqC0lDnB,qBrC1lDmB;EqC2lDnB,crC5lDkB,EAAA;;AqC+lDpB;EACE,mBrC9mDoB;EqC+mDpB,qBrClnDa;EqCmnDb,crCrnDwB,EAAA;;AqCwnD1B;EACE,kCrC5oDmB;EqC6oDnB,qBrC9oDyB;EqC+oDzB,crCjpDuB,EAAA;;AqCopDzB;EACE,aAAa,EAAA;;AAGf,oCAAA;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EAEjB,yBrCvnDY;EqCwnDZ,kBAAkB;EAClB,0DAA0D;EAE1D,wCAAwC;EACxC,gDAAgD;EAEhD,2CAA2C;EAC3C,0CAA0C,EAAA;EAhB5C;IAmBI,yGrC9nDe;IqC+nDf,qBrCnoDU,EAAA;;AqCwoDd,iCAAA;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,yGrC7oDiB;EqC8oDjB,8BAA8B;EAE9B,oDAAA;EACA,2BAA2B,EAAA;;AAG7B;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,crCvsDuB;EqCysDvB,4CAAA;EACA,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB,EAAA;;AAIlB;EACE,kBAAkB;EAClB,crCntDuB;EqCotDvB,mBAAmB,EAAA;;AAGrB,gCAAA;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,8BAA8B,EAAA;;AAGhC;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,iBAAiB,EAAA;;AAInB;EAEI,qBAAqB;EACrB,+BAA+B,EAAA;;AAInC,iCAAA;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,mBrCnuDoB;EqCouDpB,8BAA8B;EAE9B,iDAAA;EACA,gEAMC,EAAA;;AAGH;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,crCjxDuB,EAAA;;AqCqxDzB,wCAAA;AACA,wCAAA;AAlfA;EAqfE,gBAAgB,EAAA;EArflB;IAwfI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc,EAAA;EATlB;IAaI,4DAA4D,EAAA;;ArCj0DhE;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AsCv8BA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB,EAAA;;AAIjB;EACE,SAAS;EACT,ctCgBgB;EsCfhB,gBAAgB;EAChB,kBAAkB,EAAA;;AALtB;EASI,mBAAmB,EAAA;;AATvB;EAaI,cAAc,EAAA;;AAblB;EAiBI,cAAc;EACd,iBAAiB,EAAA;;AAlBrB;EAsBI,mBAAmB,EAAA;;AAtBvB;EA0BI,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;EACpB,iBAAiB;EACjB,UAAU;EACV,eAAe,EAAA;;AAhCnB;EAoCI,WAAW,EAAA;;AApCf;EAwCI,WAAW,EAAA;;AAIf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,eAAe,EAAA;EAVjB;IAaI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe,EAAA;EAGjB;IACE,aAAa;IACb,0DAA0D;IAC1D,WAAW;IACX,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB,EAAA;EAGxB;IACE,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,MAAM;IACN,YAAY;IACZ,aAAa,EAAA;IAEb;MACE,YAAY,EAAA;EAIhB;IACE,eAAe,EAAA;EAGjB;IACE,cAAc;IACd,YAAY;IACZ,aAAa;IACb,0CtCnCiB;IsCoCjB,mBAAmB;IACnB,yGtChCe;IsCmCf,UAAU;IACV,cAAc;IACd,0EAEiC;IACjC,uGAGsB,EAAA;IAGtB;MACE,yBtCxCU;MsCyCV,8CtC1CgB,EAAA;EsC8CpB;IACE,WAAW,EAAA;EAGb;IACE,SAAS;IACT,ctCxGgB,EAAA;EsC2GlB;IACE,SAAS;IACT,ctC7GgB,EAAA;IsC+GhB;MACE,ctCzGc,EAAA;EsC6GlB;IACE,mBAAmB;IACnB,wBAAwB;IACxB,yCtChHgB;IsCiHhB,kBAAkB;IAClB,mCtClHgB;IsCmHhB,ctCnHgB,EAAA;IsCqHhB;MACE,ctCtHc,EAAA;;AsC2HpB;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,0CtC7FmB;EsC8FnB,mBAAmB;EACnB,yGtC1FiB;EsC6FjB,0EAEiC;EACjC,iBAAiB,EAAA;EAEjB;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,wBAAwB;IACxB,iDtC5GiB;IsC6GjB,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,4BAA4B,EAAA;IAT7B;MAYG,mBAAmB,EAAA;IAZtB;MAgBG,OAAO;MACP,WAAW;MACX,uCAAkD,EAAA;EAItD;IACE,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,gCtC7KqB,EAAA;EsCgLvB;IACE,sBAAsB;IACtB,SAAS;IACT,8CtCzIiB,EAAA;EsC4InB;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,+BAA+B;IAC/B,mBAAmB;IACnB,4BAA4B;ItCiE9B,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,6DAA6D,EAAA;IAE7D;MACE,UAAU,EAAA;IAGZ;MACE,+BAA+B;MAC/B,oBAAoB,EAAA;IAGtB;MACE,mCArOiB;MAsOjB,oBAAoB;MACpB,2CAA2C,EAAA;IAG7C;MACE,oCA3OiB,EAAA;EsCyJnB;IACE,uBAAuB;IACvB,ctCpMgB;IsCqMhB,iBAAiB,EAAA;;AAIrB;EACE,aAAa;EACb,oBAAoB;EACpB,YAAY,EAAA;EAEZ;IACE,sCtCvKgB;IsCwKhB,8CtCxKgB;IsCyKhB,oCtCxKiB,EAAA;EsC2KnB;IACE,qBtCjKkB;IsCkKlB,8CtClKkB,EAAA;EsCqKpB;IACE,kCtC1KoB;IsC2KpB,sCtClLiB,EAAA;IsCgLlB;MAKG,kCtC9KkB;MsC+KlB,sCtCtLe,EAAA;EsC0LnB;;IAEE,qBtCjLkB;IsCkLlB,8CtClLkB,EAAA;IsC+KnB;;MAMG,qBtCrLgB,EAAA;EsCyLpB;IACE,oCtCrMiB;IsCsMjB,sCtCvMgB,EAAA;EsC0MlB;IACE,cAAc;IACd,aAAa;IACb,0CAA0C;IAC1C,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,wBAAwB;IACxB,0CtCjNiB;IsCkNjB,kBAAkB;IAClB,kCtC7MqB;IsC8MrB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iFAGuB,EAAA;IAjBxB;MAoBG,sCtC9Nc;MsC+Nd,oCtC9Ne,EAAA;IsCyMlB;MAyBG,2CtClOe;MsCmOf,mBAAmB,EAAA;IAGrB;MACE,qBtC5NgB,EAAA;MsC2NjB;QAIG,qBtC/Nc,EAAA;EsCoOpB;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,YAAY,EAAA;EAGd;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY,EAAA;EAGd;IACE,kBAAkB;IAClB,gBAAgB;IAChB,ctC1SqB;IsC2SrB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB,EAAA;EAGzB;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW,EAAA;EAGb;IACE,cAAc;IACd,WAAW;IACX,oBAAoB;IACpB,qCtC7TgB;IsC8ThB,gBAAgB,EAAA;EAGlB;IACE,cAAc;IACd,YAAY;IACZ,sDAAsD;IACtD,sBAAsB;ItC7NtB,oDAAuH,EAAA;IA6WzH;MA7XE,oDAAiF,EAAA;IAiYnF;MA/XE,oDAAiI,EAAA;IAmYnI;MAjYE,oDAA4H,EAAA;IAqY9H;MAnYE,oDAAqF,EAAA;IAuYvF;MArYE,oDAAqF,EAAA;IAyYvF;MAvYE,oDAA8E,EAAA;IA2YhF;MAzYE,oDAAoF,EAAA;IA6YtF;MA3YE,oDAAsF,EAAA;IsC2NvF;MASK,+BAA6B,EAAA;IATlC;MASK,+BAA6B,EAAA;IATlC;MASK,+BAA6B,EAAA;IATlC;MASK,+BAA6B,EAAA;IATlC;MASK,+BAA6B,EAAA;IATlC;MASK,+BAA6B,EAAA;IATlC;MASK,+BAA6B,EAAA;IATlC;MASK,+BAA6B,EAAA;IATlC;MASK,+BAA6B,EAAA;IATlC;MASK,+BAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,gCAA6B,EAAA;IATlC;MASK,iCAA6B,EAAA;EAKnC;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gCtChVqB,EAAA;EsCmVvB;IACE,cAAc;IACd,kBAAkB;IAClB,uBAAuB;IACvB,0CtC7SiB;IsC8SjB,kBAAkB;IAClB,iCtC1Se;IsC2Sf,gCtC1VqB;IsC2VrB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,4EAGuB,EAAA;IAdxB;MAiBG,ctChTqB;MsCiTrB,sCtChTgB,EAAA;IsCmTlB;MACE,ctCpTgB;MsCqThB,sCtCrTgB;MsCsThB,oCtCtTgB,EAAA;IsC8RnB;MA4BG,mBAAmB;MACnB,aAAa,EAAA;;AAKnB;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,0CtClVmB;EsCmVnB,kCtC5UsB,EAAA;EsC8UtB;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,ctCrYqB,EAAA;;AsCyYzB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;EAEZ;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,UAAU;IACV,0CtC1WiB;IsC2WjB,mBAAmB;IACnB,gBAAgB,EAAA;IAEf;MAGG,WAAW;MACX,kBAAkB;MAClB,QAAQ;MACR,UAAU;MACV,4BAA4B;MAC5B,2BAA2B;MAC3B,sBAAsB;MACtB,oBAAoB,EAAA;IAVvB;MAcG,WAAW;MACX,kBAAkB;MAClB,QAAQ;MACR,UAAU;MACV,2FAIC;MACD,oBAAoB,EAAA;IAIxB;MACE,0DAAwD,EAAA;IAG1D;MACE,0DAA2D,EAAA;EAI/D;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,+CAA+C;IAC/C,YAAY;IACZ,qBAAqB;IACrB,mBAAmB,EAAA;EAGrB;IACE,WAAW;IACX,YAAY,EAAA;EAGd;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,WAAW,EAAA;EAGb;IACE,SAAS;IACT,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,ctCvdqB,EAAA;EsC0dvB;IACE,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,yBtCzakB;IsC0alB,kBAAkB;IAClB,mCtCzaiB;IsC0ajB,ctC7auB;IsC8avB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB,EAAA;EAGrB;IACE,mBAAmB;IACnB,ctClcgB;IsCmchB,kBAAkB,EAAA;EAGpB;IACE,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,0CtC1ciB;IsC2cjB,kBAAkB;IAClB,iCtCvce;IsCwcf,gCtCvfqB;IsCwfrB,iBAAiB;IACjB,eAAe,EAAA;IAEf;MACE,ctCxcqB;MsCycrB,kBAAkB;MAClB,sCtCzcgB;MsC0chB,mCtCxce,EAAA;IsCwblB;MAoBG,mBAAmB;MACnB,aAAa,EAAA;EAIjB;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,sBAAsB;IACtB,wBAAwB;IACxB,2CtChhBuB;IsCihBvB,mBAAmB;IACnB,6CtCneoB;IAwetB,uCAvhByB;IAwhBzB,sFA9BC,EAAA;IAgCD;MACE,cA/hBgB,EAAA;IAkiBlB;MACE,gCAniBgB,EAAA;IAsiBlB;MACE,uCAviBgB;MAwiBhB,qCAxiBgB,EAAA;IsC0hBhB;MtCCF,qCAjhBkB;MAkhBlB,gFA1BqF,EAAA;MA4BrF;QACE,cA/hBgB,EAAA;MAkiBlB;QACE,gCAniBgB,EAAA;MAsiBlB;QACE,uCAviBgB;QAwiBhB,qCAxiBgB,EAAA;IsC8hBhB;MtCHF,qCA/gBiB;MAghBjB,oFAvBmF,EAAA;MAyBnF;QACE,cA/hBgB,EAAA;MAkiBlB;QACE,gCAniBgB,EAAA;MAsiBlB;QACE,uCAviBgB;QAwiBhB,qCAxiBgB,EAAA;IsCkiBhB;MtCPF,uCAvhByB;MAwhBzB,sFA9BC,EAAA;MAgCD;QACE,cA/hBgB,EAAA;MAkiBlB;QACE,gCAniBgB,EAAA;MAsiBlB;QACE,uCAviBgB;QAwiBhB,qCAxiBgB,EAAA;IsCsiBhB;MtCXF,sCApeoB;MAqepB,qFApBkF,EAAA;MAsBlF;QACE,cA/hBgB,EAAA;MAkiBlB;QACE,gCAjiBqB,EAAA;MAoiBvB;QACE,uCAviBgB;QAwiBhB,qCAxiBgB,EAAA;IsC0iBhB;MtCfF,uCAlgBmB;MAmgBnB,uFAfwG,EAAA;MAiBxG;QACE,cAvhBoB,EAAA;MA0hBtB;QACE,6BAhfoB,EAAA;MAmftB;QACE,oCA/hBoB;QAgiBpB,kCAhiBoB,EAAA;IsCsiBpB;MtCnBF,uCAlgBmB;MAmgBnB,uFAV4G,EAAA;MAY5G;QACE,cA/hBgB,EAAA;MAkiBlB;QACE,gCAniBgB,EAAA;MAsiBlB;QACE,uCAviBgB;QAwiBhB,qCAxiBgB,EAAA;IsCkjBhB;MtCvBF,uCA/dyB;MAgezB,uFAP4G,EAAA;MAS5G;QACE,cA/hBgB,EAAA;MAkiBlB;QACE,gCAniBgB,EAAA;MAsiBlB;QACE,uCAviBgB;QAwiBhB,qCAxiBgB,EAAA;IsCsjBhB;MtC3BF,sCA9doB;MA+dpB,qFAJoH,EAAA;MAMpH;QACE,cA/hBgB,EAAA;MAkiBlB;QACE,gCAniBgB,EAAA;MAsiBlB;QACE,uCAviBgB;QAwiBhB,qCAxiBgB,EAAA;EsC2jBlB;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY,EAAA;IAEZ;MACE,WAAW,EAAA;IAGb;MACE,oBAAoB,EAAA;EAIxB;IACE,cAAc;IACd,mBAAmB,EAAA;IAEnB;MACE,cAAc;MACd,eAAe;MACf,oBAAoB;MACpB,gBAAgB;MAChB,oCtCnlBc,EAAA;IsCslBhB;MACE,cAAc;MACd,eAAe;MACf,kBAAkB,EAAA;IAGpB;MACE,qBAAqB;MACrB,sBAAsB;MACtB,4CtC/lBc;MsCgmBd,qCtChmBc,EAAA;EsComBlB;IACE,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;IACjB,uBAAuB,EAAA;EAGzB;IACE,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,uBAAuB,EAAA;EAGzB;IACE,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCtCxnBqB,EAAA;EsC2nBvB;IACE,WAAW;IACX,gBAAgB;IAChB,wBAAwB;IACxB,0CtCrlBiB;IsCslBjB,kBAAkB;IAClB,iCtCllBe;IsCmlBf,ctCloBqB;IsCmoBrB,aAAa;IACb,gBAAgB;IAChB,sBAAsB,EAAA;IAVvB;MAaG,gCtCvoBc,EAAA;IsC0nBjB;MAiBG,aAAa;MACb,mBAAmB,EAAA;EAIvB;IACE,SAAS;IACT,kBAAkB;IAClB,+BtCnpBgB,EAAA;EsCspBlB;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,YAAY,EAAA;EAGd;IACE,0BAA0B,EAAA;;AAK9B;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,YAAY,EAAA;EAEZ;IACE,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCtChrBqB,EAAA;EsCmrBvB;IACE,SAAS;IACT,ctCprBgB;IsCqrBhB,kBAAkB,EAAA;EAGpB;IACE,aAAa;IACb,qEAAqE;IACrE,YAAY;IACZ,kBAAkB,EAAA;IAElB;MACE,aAAa;MACb,mBAAmB;MACnB,iBAAiB;MACjB,oBAAoB;MACpB,2BAA2B;MAC3B,kBAAkB,EAAA;EAItB;IACE,aAAa;IACb,oBAAoB;IACpB,WAAW;IACX,YAAY,EAAA;EAGd;IACE,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;IAC9B,qBAAqB;IACrB,wBAAwB;IACxB,mBAAmB,EAAA;IAVpB;MAaG,aAAa,EAAA;IAGf;MACE,YAAY,EAAA;IAGd;MACE,gBAAgB;MAChB,iBAAiB;MACjB,qBAAqB,EAAA;MAHtB;QAMG,gBAAgB;QAChB,iBAAiB,EAAA;EAKvB;IACE,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;IACb,YAAY;IACZ,UAAU;IACV,0CtChtBiB;IsCitBjB,kBAAkB;IAClB,kCtC5sBqB;IsC6sBrB,8CtCptBgB;IsCqtBhB,eAAe;IACf,oFAG6B,EAAA;IAlB9B;MAqBG,sCtC5tBc;MsC6tBd,oCtC5tBe,EAAA;IsCssBlB;MA0BG,2CtChuBe;MsCiuBf,mBAAmB,EAAA;IA3BtB;MAgCG,aAAa;MACb,eAAe,EAAA;EAInB;IACE,cAAc;IACd,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,oCAAoC,EAAA;EAGtC;IACE,+BtCrvBgB,EAAA;EsCwvBlB;IACE,8BtCzvBgB,EAAA;EsC4vBlB;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,8BAA8B;IAC9B,gCAAgC;IAChC,0CtClwBiB;IsCmwBjB,mBAAmB;IACnB,kCtC9vBqB;IsC+vBrB,0DAEuB;IACvB,8CtCzwBgB,EAAA;IsC2wBhB;MACE,iBAAiB;MACjB,cAAc;MACd,kBAAkB,EAAA;IAGpB;MACE,sCtClxBc;MsCmxBd,8CtCnxBc,EAAA;EsCuxBlB;IACE,cAAc;IACd,gBAAgB;IAChB,+BAA+B;ItCF/B,gBAAgB;IAEhB,yBAAA;IAMA,YAAA;IACA,qBAAqB;IAErB,kBAAA;IACA,wBAAwB,EAAA;IATxB;MACI,QAAQ;MACR,SAAS,EAAA;EsCCf;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,cAAc,EAAA;IAXf;MAcG,2CtC3yBe;MsC4yBf,mBAAmB;MACnB,kBAAkB,EAAA;EAItB;IACE,cAAc;IACd,oCtCnzBiB;IsCozBjB,oBAAoB;IACpB,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,mBAAmB,EAAA;IAEnB;MACE,cAAc;MACd,uBAAuB;MACvB,YAAY;MACZ,gBAAgB,EAAA;EAIpB;IACE,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,8BtCz0BgB,EAAA;EsC40BlB;IACE,SAAS;IACT,UAAU;IACV,gBAAgB,EAAA;EAGlB;IACE,aAAa;IACb,iCAAiC;IACjC,YAAY;IACZ,uBAAuB,EAAA;IAEvB;MACE,iBAAiB,EAAA;IAGlB;MAEG,oCtC91BY;MsC+1BZ,8CtC/1BY,EAAA;EsCo2BlB;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB,EAAA;EAGlB;IACE,cAAc;IACd,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,oCtCj3BiB;IsCk3BjB,8CtCl3BiB,EAAA;EsCq3BnB;IACE,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,oCtC33BiB,EAAA;EsC83BnB;IACE,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,wBAAwB;IACxB,6BAA6B;IAC7B,kBAAkB;IAClB,uBAAuB;IACvB,ctCh7BgB;IsCi7BhB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe,EAAA;IAEf;MACE,sCtC94Bc;MsC+4Bd,oCtC94Be;MsC+4Bf,ctCz7BmB;MsC07BnB,8CtCj5Bc,EAAA;IsCo5BhB;MACE,qCtCt7Bc;MsCu7Bd,mCtCv7Bc,EAAA;IsC07BhB;MACE,qCtCz7Ba;MsC07Bb,mCtC17Ba,EAAA;IsC67Bf;MACE,sCtCn5BgB;MsCo5BhB,oCtCp5BgB,EAAA;IsCm3BnB;MAqCG,mBAAmB;MACnB,YAAY,EAAA;EAIhB;IACE,cAAc;IACd,aAAa;IACb,cAAc;IACd,mBAAmB,EAAA;IAEnB;MACE,kBAAkB;MAClB,oCtCh7Be,EAAA;EsCo7BnB;IACE,YAAY;IAEZ,kBAAkB;IAClB,iBAAiB,EAAA;EAGnB;IACE,cAAc,EAAA;EAGhB;IACE,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,+BAA+B;IAC/B,wCtCp8BsB,EAAA;EsCu8BxB;IACE,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,eAAe;IACf,oCAAoC;IACpC,sBAAsB;ItCp5BtB,oDAAuH;IsCs5BvH,4BAA4B,EAAA;ItCziB9B;MA7XE,oDAAiF,EAAA;IAiYnF;MA/XE,oDAAiI,EAAA;IAmYnI;MAjYE,oDAA4H,EAAA;IAqY9H;MAnYE,oDAAqF,EAAA;IAuYvF;MArYE,oDAAqF,EAAA;IAyYvF;MAvYE,oDAA8E,EAAA;IA2YhF;MAzYE,oDAAoF,EAAA;IA6YtF;MA3YE,oDAAsF,EAAA;IsCg5BvF;MAYK,aAAW,EAAA;IAZhB;MAYK,aAAW,EAAA;IAZhB;MAYK,aAAW,EAAA;IAZhB;MAYK,aAAW,EAAA;IAZhB;MAYK,aAAW,EAAA;IAZhB;MAYK,aAAW,EAAA;IAZhB;MAYK,aAAW,EAAA;IAZhB;MAYK,aAAW,EAAA;IAZhB;MAYK,aAAW,EAAA;IAZhB;MAYK,aAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,cAAW,EAAA;IAZhB;MAYK,eAAW,EAAA;EAKjB;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,ctC9gCqB;IsC+gCrB,oBAAoB,EAAA;;AAIxB;EACE,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,ctCzhCuB;EsC0hCvB,6BAA6B;EAC7B,mBAAmB;EACnB,kCtCthCsB;EsCuhCtB,iBAAiB;EACjB,UAAU;EACV,oBAAoB;EACpB,8IAIwB,EAAA;EAExB;IACE,eAAe;IACf,YAAY;IACZ,UAAU;IACV,oBAAoB;IACpB,sCtCjgCiB;IsCkgCjB,0EAEiC;IACjC,UAAU,EAAA;EAGZ;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,cAAc;IACd,gCAAgC;IAChC,iDtC/gCiB;IsCghCjB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,4BAA4B,EAAA;IAZ7B;MAeG,cAAc;MACd,YAAY;MACZ,mBAAmB,EAAA;IAjBtB;MAqBG,UAAU;MACV,QAAQ;MACR,uCAAkD,EAAA;IAvBrD;MA2BG,kBAAkB;MAClB,sBAAsB;MACtB,yBAAyB;MACzB,+BtChlCmB,EAAA;EsColCvB;IACE,kBAAkB;IAClB,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,ctC3lCqB;IsC4lCrB,oCtCljCiB,EAAA;EsCqjCnB;IACE,SAAS;IACT,wBAAwB;IACxB,kBAAkB;IAClB,ctClmCgB,EAAA;IsComChB;MACE,ctC9lCc,EAAA;EsCkmClB;IACE,SAAS;IACT,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,gCtC9mCgB,EAAA;EsCinClB;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,4BAA4B,EAAA;ItClZ5B;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;EsCuY/D;IACE,SAAS;IACT,UAAU,EAAA;EAGZ;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,cAAc,EAAA;IAXf;MAcG,oCtC1mCe;MsC2mCf,sCtC3mCe,EAAA;IsC4lClB;MAmBG,2CtC/mCe;MsCgnCf,mBAAmB,EAAA;IAGrB;MACE,qBtCzmCgB,EAAA;MsCwmCjB;QAIG,qBtC5mCc,EAAA;IsCgnClB;MACE,oCtCjnCgB;MsCknChB,sCtClnCgB,EAAA;EsCsnCpB;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB,EAAA;IAEjB;MACE,qBAAqB;MACrB,mBtClrCqB;MsCmrCrB,aAAa,EAAA;EAIjB;IACE,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,kBAAkB,EAAA;EAGpB;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB,EAAA;EAGrB;IACE,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gCtC9sCqB,EAAA;;AsCktCzB;EA/uCA;IAivCI,eAAe,EAAA;EAvqCjB;IA2qCE,0BAA0B,EAAA;EAhqC5B;IAoqCE,sBAAsB,EAAA;IA5pCtB;MA+pCE,YAAY,EAAA;EAzLhB;IA8LE,cAAc;IACd,WAAW;IACX,iBAAiB,EAAA;EAhjCnB;IAojCE,iBAAiB,EAAA,EAClB;;AAGH;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,YAAY,EAAA;EALd;;;IAUI,cAAc;IACd,YAAY,EAAA;;AAsBhB;EACE,cAAc;EACd,WAAW;EACX,YAAY,EAAA;EAEZ;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,oBAAoB;IACpB,gBAAgB;IAChB,qCtC5xCgB,EAAA;EsC+xClB;IACE,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,UAAU,EAAA;IAEV;MACE,OAAO;MACP,mFAAkF,EAAA;IAGpF;MACE,QAAQ;MACR,sFAAgF,EAAA;EAIpF;IACE,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,SAAS;IACT,UAAU;IACV,2BAA2B;IAC3B,qCtCrzCqB;IsCszCrB,UAAU,EAAA;EAGZ;IACE,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,UAAU;IACV,oBAAoB,EAAA;IArDpB;MACE,yCAAuC,EAAA;IADzC;MACE,yCAAuC,EAAA;IADzC;MACE,yCAAuC,EAAA;IADzC;MACE,yCAAuC,EAAA;IADzC;MACE,yCAAuC,EAAA;IADzC;MACE,yCAAuC,EAAA;IADzC;MACE,yCAAuC,EAAA;IADzC;MACE,yCAAuC,EAAA;IADzC;MACE,yCAAuC,EAAA;IADzC;MACE,yCAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,2CAAuC,EAAA;IAuDzC;MACE,UAAU;MACV,oEAAoE;MACpE,oDAA0D,EAAA;IAG5D;MACE,SAAS;MACT,oEAAoE;MACpE,oDAAwD,EAAA;IAG1D;MACE,aAAa,EAAA;EAIjB;IACE,kBAAkB;IAClB,QAAQ;IACR,6DAA6D;IAC7D,UAAU;IACV,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBtC11CqB;IsC21CrB,uCtC1yCoB;IsC2yCpB,gCAAgC,EAAA;IA3FhC;MACE,sCAAoC,EAAA;IADtC;MACE,sCAAoC,EAAA;IADtC;MACE,sCAAoC,EAAA;IADtC;MACE,sCAAoC,EAAA;IADtC;MACE,sCAAoC,EAAA;IADtC;MACE,sCAAoC,EAAA;IADtC;MACE,sCAAoC,EAAA;IADtC;MACE,sCAAoC,EAAA;IADtC;MACE,sCAAoC,EAAA;IADtC;MACE,sCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,wCAAoC,EAAA;;AA+F1C;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,0CtC7zCmB;EsC8zCnB,mBAAmB;EACnB,iCtC1zCiB,EAAA;EsC4zCjB;IACE,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,YAAY;IACZ,YAAY,EAAA;EAGd;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY,EAAA;EAGd;IACE,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,cAAc,EAAA;EAGhB;IACE,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCtCv4CqB,EAAA;EsC04CvB;IACE,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gCtC94CgB,EAAA;IsCg5ChB;MACE,ctC14Cc,EAAA;IsC64ChB;MACE,ctCj2CgB,EAAA;IsCo2ClB;MAEE,ctCp4Ce,EAAA;IsCu4CjB;MAEE,ctC52CqB,EAAA;IsC+2CvB;MACE,ctCj6Ce,EAAA;EsCq6CnB;IACE,SAAS;IACT,kBAAkB;IAClB,8BtCt3CkB,EAAA;EsCy3CpB;IACE,iBAAiB,EAAA;IADlB;MAIG,oBAAoB,EAAA;EAIxB;IACE,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,qCtC77CgB,EAAA;EsCg8ClB;IACE,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,UAAU;IACV,oBAAoB,EAAA;IAEpB;MACE,OAAO;MACP,kFAAiF,EAAA;IAGnF;MACE,QAAQ;MACR,qFAA+E,EAAA;EAInF;IACE,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,SAAS;IACT,UAAU;IACV,UAAU;IACV,2BAA2B;IAC3B,qCtCx9CqB;IsCy9CrB,oBAAoB,EAAA;EAGtB;IACE,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,oBAAoB,EAAA;IAzNpB;MACE,yCAAuC,EAAA;IADzC;MACE,yCAAuC,EAAA;IADzC;MACE,yCAAuC,EAAA;IADzC;MACE,yCAAuC,EAAA;IADzC;MACE,yCAAuC,EAAA;IADzC;MACE,yCAAuC,EAAA;IADzC;MACE,yCAAuC,EAAA;IADzC;MACE,yCAAuC,EAAA;IADzC;MACE,yCAAuC,EAAA;IADzC;MACE,yCAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,0CAAuC,EAAA;IADzC;MACE,2CAAuC,EAAA;IA2NzC;MACE,UAAU;MACV,oEAAoE;MACpE,oDAA0D;MAC1D,4CtCj+Cc,EAAA;IsCo+ChB;MACE,SAAS;MACT,oEAAoE;MACpE,oDAAwD;MACxD,8CtCz9Ce,EAAA;IsC49CjB;MACE,aAAa,EAAA;EAIjB;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU,EAAA;EAGZ;IACE,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,6DAA6D;IAC7D,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,2BAA2B;IAC3B,oBAAoB,EAAA;IA3QpB;MACE,sCAAoC,EAAA;IADtC;MACE,sCAAoC,EAAA;IADtC;MACE,sCAAoC,EAAA;IADtC;MACE,sCAAoC,EAAA;IADtC;MACE,sCAAoC,EAAA;IADtC;MACE,sCAAoC,EAAA;IADtC;MACE,sCAAoC,EAAA;IADtC;MACE,sCAAoC,EAAA;IADtC;MACE,sCAAoC,EAAA;IADtC;MACE,sCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,wCAAoC,EAAA;IA6QtC;MACE,mBtChhDmB;MsCihDnB,uBAAuB;MACvB,8CtCx+Ce,EAAA;EsC4+CnB;IACE,cAAc;IACd,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,qCtC3hDqB;IsC4hDrB,8EAGuB,EAAA;EAGzB;IACE,kBAAkB;IAClB,QAAQ;IACR,6DAA6D;IAC7D,UAAU;IACV,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,mBtC3iDqB;IsC4iDrB,wCtC3/CoB;IsC4/CpB,8CtCngDiB;IsCogDjB,gCAAgC;IAChC,oBAAoB,EAAA;IA9SpB;MACE,sCAAoC,EAAA;IADtC;MACE,sCAAoC,EAAA;IADtC;MACE,sCAAoC,EAAA;IADtC;MACE,sCAAoC,EAAA;IADtC;MACE,sCAAoC,EAAA;IADtC;MACE,sCAAoC,EAAA;IADtC;MACE,sCAAoC,EAAA;IADtC;MACE,sCAAoC,EAAA;IADtC;MACE,sCAAoC,EAAA;IADtC;MACE,sCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,uCAAoC,EAAA;IADtC;MACE,wCAAoC,EAAA;IAgTtC;MACE,oBAAoB;MACpB,YAAY;MACZ,kBAAkB,EAAA;MAHnB;QAOG,WAAW;QACX,kBAAkB;QAClB,YAAY,EAAA;MATf;QAaG,eAAe;QACf,oBAAoB,EAAA;MAdvB;QAkBG,2CtC3hDY;QsC4hDZ,mBAAmB,EAAA;IAIvB;MACE,gBAAgB;MAChB,4CAA4C;MAC5C,iFtCniDc;MsCsiDd,uDAAuD,EAAA;EAI3D;IACE,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,gCtCxlDgB,EAAA;;AsC4lDpB;EAEI,mBAAmB;EACnB,gCtC/lDgB;EsCgmDhB,kBAAkB,EAAA;;AtC7nDtB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AuCv8BA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,SAAS;EACT,sBAAsB,EAAA;;AAGxB;EACE,oBAAoB;EACpB,kBAAkB,EAAA;EAFpB;IAKI,kBAAkB;IAClB,mBAAmB,EAAA;EANvB;IAUI,mBAAmB,EAAA;EAVvB;IAcI,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;IACX,iBAAiB,EAAA;EAnBrB;IAuBI,iBAAiB;IACjB,UAAU;IACV,eAAe,EAAA;EAzBnB;IA6BI,WAAW,EAAA;EA7Bf;IAiCI,WAAW,EAAA;EAGb;IACE,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,gCvCvBqB;IuCwBrB,mBAAmB,EAAA;EA3CvB;IA+CI,cAAc,EAAA;EA/ClB;;IAoDI,mBAAmB,EAAA;;AAIvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,eAAe,EAAA;EAXjB;IAcI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe,EAAA;EAGjB;IACE,aAAa;IACb,0DAA0D;IAC1D,WAAW;IACX,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB,EAAA;EAGxB;IACE,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,MAAM;IACN,YAAY;IACZ,aAAa,EAAA;IAEb;MACE,YAAY,EAAA;EAIhB;IACE,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,2BvCkRqD;IuCjRrD,+BvCiRqD;IuChRrD,0CvC/CiB;IuCgDjB,mBAAmB;IACnB,yGvC5Ce;IuC+Cf,0EAEiC;IACjC,aAAa;IACb,cAAc;IvCqPhB,qBAAqB;IACrB,gEAvSsB,EAAA;IAyStB;MACE,UAAU,EAAA;IAGZ;MACE,kCA9SoB;MA+SpB,oBAAoB,EAAA;IAGtB;MACE,oCA1TiB;MA2TjB,oBAAoB,EAAA;IuChQpB;MACE,qBvCjDgB;MuCkDhB,+EAEiC,EAAA;EAIrC;IACE,SAAS;IACT,gCvC/GqB;IuCgHrB,kBAAkB,EAAA;EAGpB;IACE,SAAS;IACT,cvCpHgB,EAAA;IuCsHhB;MACE,cvChHc,EAAA;;AuCqHpB;EACE,aAAa;EACb,sBAAsB;EAEtB,0CvCvFmB;EuCwFnB,mBAAmB;EACnB,yGvCpFiB;EuCuFjB,0EAEiC;EACjC,iBAAiB,EAAA;EAEjB;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,wBAAwB;IACxB,iDvCvGiB;IuCwGjB,4BAA4B,EAAA;EAG9B;IACE,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,gCvC3JqB,EAAA;EuC8JvB;IACE,kBAAkB;IAClB,gCvChKqB;IuCiKrB,mBAAmB,EAAA;EAGrB;IACE,sBAAsB;IACtB,SAAS;IACT,8CvC7HiB,EAAA;EuCgInB;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,uCAAuC;IACvC,cAAc;IACd,+BAA+B;IAC/B,mBAAmB;IACnB,4BAA4B;IvCqK9B,qBAAqB;IACrB,gEAvSsB,EAAA;IAyStB;MACE,UAAU,EAAA;IAGZ;MACE,kCA9SoB;MA+SpB,oBAAoB,EAAA;IAGtB;MACE,oCA1TiB;MA2TjB,oBAAoB,EAAA;EuC/KtB;IACE,uBAAuB;IACvB,cvCvLgB;IuCwLhB,iBAAiB,EAAA;EAGnB;IACE,+BAA+B;IAC/B,gCvC9LqB;IuC+LrB,kBAAkB;IAClB,kBAAkB,EAAA;;AAItB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCvCjKmB;EuCkKnB,0CvClKmB;EuCmKnB,cvC7MuB;EuC8MvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,sBAAsB,EAAA;EAEtB;IACE,yBAAyB,EAAA;;AAI7B;EACE,aAAa;EACb,oBAAoB;EACpB,YAAY,EAAA;EAEZ;IACE,sCvCvLgB;IuCwLhB,8CvCxLgB;IuCyLhB,oCvCxLiB,EAAA;EuC2LnB;IACE,qBvCjLkB;IuCkLlB,8CvClLkB,EAAA;EuCqLpB;IACE,uCvCpNiB,EAAA;EuCuNnB;IACE,qBvC1LkB,EAAA;IuCyLnB;MAIG,qBvC7LgB,EAAA;EuCiMpB;IACE,kCvCvMqB;IuCwMrB,sCvC9MiB,EAAA;EuCiNnB;IACE,cAAc;IACd,aAAa;IACb,0CAA0C;IAC1C,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,wBAAwB;IACxB,0CvCzNiB;IuC0NjB,kBAAkB;IAClB,kCvCrNqB;IuCsNrB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iFAGuB,EAAA;IAjBxB;MAoBG,sCvCtOc;MuCuOd,oCvCtOe,EAAA;IuCiNlB;MAyBG,2CvC1Oe;MuC2Of,mBAAmB,EAAA;IAGrB;MACE,qBvCpOgB,EAAA;MuCmOjB;QAIG,qBvCvOc,EAAA;EuC4OpB;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,YAAY,EAAA;EAGd;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY,EAAA;EAGd;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cvClTqB;IuCmTrB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB,EAAA;EAGzB;IACE,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,gCvC5TgB,EAAA;EuC+TlB;IACE,gBAAgB;IAChB,gCvClUqB,EAAA;EuCqUvB;IACE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB,EAAA;EAGrB;IACE,cAAc;IACd,WAAW;IACX,0CvCpSiB;IuCqSjB,kBAAkB;IAClB,iCvCjSe;IuCkSf,gCvCjVqB;IuCkVrB,eAAe;IACf,cAAc;IACd,eAAe;IACf,4EAGuB,EAAA;IAbxB;MAgBG,cvCvSqB;MuCwSrB,sCvCvSgB,EAAA;IuC0SlB;MACE,cvC3SgB;MuC4ShB,sCvC5SgB;MuC6ShB,oCvC7SgB,EAAA;IuCsRnB;MA2BG,mBAAmB;MACnB,aAAa,EAAA;;AAKnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa,EAAA;EAEb;IACE,cAAc;IACd,gBAAgB,EAAA;IAFjB;;;MAOG,cAAc,EAAA;IAPjB;MAWG,cAAc;MACd,aAAa;MACb,oBAAoB,EAAA;EAIxB;IACE,aAAa;IACb,+CAA+C;IAC/C,YAAY;IACZ,mBAAmB;IACnB,cAAc,EAAA;EAGhB;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB,EAAA;EAGnB;IACE,SAAS;IACT,kBAAkB;IAClB,cvCpZqB,EAAA;EuCuZvB;IACE,mBAAmB;IACnB,gCvCzZqB;IuC0ZrB,kBAAkB,EAAA;EAGpB;IACE,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,YAAY;IACZ,cAAc,EAAA;EAGhB;IACE,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,0CvChYiB;IuCiYjB,kBAAkB;IAClB,iCvC7Xe;IuC8Xf,gCvC7aqB;IuC8arB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,4EAGuB,EAAA;IAEvB;MACE,cvCnYgB;MuCoYhB,sCvCpYgB;MuCqYhB,oCvCrYgB,EAAA;IuCgXnB;MAyBG,cvC1YqB;MuC2YrB,sCvC1YgB,EAAA;IuCgXnB;MA8BG,mBAAmB;MACnB,aAAa,EAAA;EAIjB;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,yCvCnaiB;IuCoajB,kBAAkB;IAClB,kCvC/ZqB;IuCgarB,cvChdqB;IuCidrB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iFAGuB,EAAA;IAEvB;MACE,uCvCpce;MuCqcf,qCvCrce;MuCscf,+CvCtce,EAAA;IuCiblB;MAyBG,qCvCxbc;MuCybd,oCvCxbe,EAAA;IuC8ZlB;MA8BG,mBAAmB;MACnB,aAAa,EAAA;EAIjB;IACE,aAAa;IACb,2DAA2D;IAC3D,iBAAiB;IACjB,SAAS,EAAA;IAET;MACE,cAAc;MACd,aAAa;MACb,sBAAsB;MACtB,YAAY;MACZ,YAAY;MACZ,kBAAkB,EAAA;EAItB;IACE,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS,EAAA;EAGX;IACE,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,UAAU;IACV,cAAc;IACd,aAAa;IACb,iBAAiB;IACjB,mBAAmB,EAAA;IARpB;MAWG,mBAAmB,EAAA;IAXtB;MAeG,aAAa;MACb,cAAc;MACd,sBAAsB;MACtB,gBAAgB;MAChB,YAAY;MACZ,gBAAgB,EAAA;MApBnB;;QAwBK,cAAc;QACd,YAAY;QACZ,gBAAgB;QAChB,aAAa,EAAA;IA3BlB;;MAiCG,cAAc;MACd,YAAY;MACZ,gBAAgB;MAChB,aAAa,EAAA;IApChB;MAwCG,aAAa;MACb,sBAAsB;MACtB,aAAa,EAAA;IA1ChB;MA8CG,cAAc;MACd,YAAY;MACZ,aAAa,EAAA;EAIjB;IACE,SAAS;IACT,YAAY,EAAA;EAGd;IACE,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCvCjkBqB,EAAA;EuCokBvB;IACE,SAAS;IACT,gCvCtkBqB;IuCukBrB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB,EAAA;EAGxB;IACE,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCvCllBqB,EAAA;EuCqlBvB;IACE,SAAS;IACT,oBAAoB;IACpB,gCvCxlBqB;IuCylBrB,kBAAkB;IAClB,gBAAgB,EAAA;EAGlB;IACE,aAAa;IACb,sBAAsB;IACrB,YAAY,EAAA;EAGf;IACE,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCvCxmBqB,EAAA;EuC2mBvB;IACE,WAAW;IACX,gBAAgB;IAChB,wBAAwB;IACxB,0CvCrkBiB;IuCskBjB,kBAAkB;IAClB,iCvClkBe;IuCmkBf,cvClnBqB;IuCmnBrB,aAAa;IACb,gBAAgB;IAChB,sBAAsB,EAAA;IAVvB;MAaG,gCvCvnBc,EAAA;IuC0mBjB;MAiBG,aAAa;MACb,mBAAmB,EAAA;EAIvB;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY,EAAA;EAGd;IACE,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCvC7oBqB,EAAA;EuCgpBvB;IACE,SAAS;IACT,wBAAwB;IACxB,2CvCzmBiB;IuC0mBjB,mBAAmB;IACnB,gCvCrpBqB;IuCspBrB,kBAAkB;IAClB,iBAAiB,EAAA;;AAIrB;EACE,aAAa;EACb,sEAAsE;EACtE,YAAY,EAAA;EAEZ;IACE,qCAAqC;IACrC,gBAAgB,EAAA;EAGlB;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,uCAAuC;IACvC,0CvCjoBiB;IuCkoBjB,mBAAmB;IACnB,kCvC7nBqB;IuC8nBrB,kBAAkB;IAClB,iBAAiB,EAAA;EAGlB;IAEG,mBAAmB,EAAA;EAFtB;IAMG,UAAU;IACV,QAAQ;IACR,uCAAkD,EAAA;EAItD;IACE,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCvCpsBqB,EAAA;EuCusBvB;IAEE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,+BAA+B;IAC/B,gBAAgB;IvChdlB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,6DAA6D,EAAA;IAE7D;MACE,UAAU,EAAA;IAGZ;MACE,+BAA+B;MAC/B,oBAAoB,EAAA;IAGtB;MACE,mCArOiB;MAsOjB,oBAAoB;MACpB,2CAA2C,EAAA;IAG7C;MACE,oCA3OiB,EAAA;EuC0qBnB;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,sBAAsB;IACtB,0CvC/qBiB;IuCgrBjB,kBAAkB;IAClB,iCvC5qBe,EAAA;EuC+qBjB;IACE,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,oBAAoB;IACpB,YAAY,EAAA;EAGd;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY,EAAA;EAGd;IACE,aAAa;IACb,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,cAAc,EAAA;EAGhB;IACE,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCvC5vBqB;IuC6vBrB,mBAAmB,EAAA;EAGrB;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cvCnwBqB;IuCowBrB,sBAAsB,EAAA;EAGxB;IACE,kBAAkB;IAClB,gCvCxwBgB;IuCywBhB,mBAAmB,EAAA;EAGrB;IACE,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,aAAa;IACb,wBAAwB;IACxB,oBAAoB;IACpB,0CvC1uBiB;IuC2uBjB,iCvCtuBe;IuCuuBf,cvCtxBqB;IuCuxBrB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,kCAAkC,EAAA;IAElC;MACE,cvC3xBqB;MuC4xBrB,uCvC5xBqB,EAAA;IuC+xBvB;MACE,cvC9uBqB;MuC+uBrB,uCvC/uBqB,EAAA;IuCkvBvB;MACE,cvCjxBoB;MuCkxBpB,uCvClxBoB,EAAA;IuCqxBtB;MACE,cvCnwBc;MuCowBd,sCvCpwBc,EAAA;IuCuwBhB;MACE,cvCvvBqB;MuCwvBrB,uCvCxvBqB,EAAA;IuCmtBxB;MAyCG,2CvC5wBe;MuC6wBf,mBAAmB,EAAA;EAIvB;IACE,cAAc;IACd,cAAc;IACd,YAAY,EAAA;EAGd;IACE,WAAW;IACX,SAAS;IACT,qBvC3xBgB;IuC4xBhB,eAAe,EAAA;IAEf;MACE,qBvCt0BqB,EAAA;IuCy0BvB;MACE,qBvCxxBqB,EAAA;IuC2xBvB;MACE,qBvC1zBoB,EAAA;IuC6zBtB;MACE,qBvC3yBc,EAAA;IuC8yBhB;MACE,qBvC9xBqB,EAAA;EuCkyBzB;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,wBAAwB;IACxB,0CvCxzBiB;IuCyzBjB,kBAAkB;IAClB,iCvCrzBe,EAAA;EuCwzBjB;IACE,kBAAkB;IAClB,gCvCz2BqB;IuC02BrB,iBAAiB,EAAA;EAGnB;IACE,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,YAAY;IACZ,cAAc;IACd,iBAAiB,EAAA;EAGnB;IACE,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC,EAAA;IAElC;MACE,cvC13BqB,EAAA;IuC63BvB;MACE,cvC50BqB,EAAA;IuC+0BvB;MACE,cvC92BoB,EAAA;IuCi3BtB;MACE,cvC/1Bc,EAAA;IuCk2BhB;MACE,cvCl1BqB,EAAA;EuCs1BzB;IACE,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,cvC32BgB;IuC42BhB,gBAAgB,EAAA;IAEhB;MACE,kBAAkB,EAAA;EAItB;IACE,SAAS;IACT,gCvC95BqB;IuC+5BrB,kBAAkB;IAClB,iBAAiB,EAAA;EAGnB;IACE,aAAa;IACb,sBAAsB;IACtB,+BAA+B;IAC/B,YAAY;IACZ,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IvC3qBlB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,6DAA6D,EAAA;IAE7D;MACE,UAAU,EAAA;IAGZ;MACE,+BAA+B;MAC/B,oBAAoB,EAAA;IAGtB;MACE,mCArOiB;MAsOjB,oBAAoB;MACpB,2CAA2C,EAAA;IAG7C;MACE,oCA3OiB,EAAA;EuCq4BnB;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,uBAAuB;IACvB,0CvC14BiB;IuC24BjB,kBAAkB;IAClB,iCvCv4Be,EAAA;EuC04BjB;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cvC57BqB;IuC67BrB,iBAAiB;IACjB,sBAAsB,EAAA;EAGxB;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cvC35BgB;IuC45BhB,gBAAgB;IAChB,sBAAsB,EAAA;IAEtB;MACE,sBAAsB;MACtB,SAAS;MACT,UAAU;MACV,SAAS;MACT,uBAAuB;MACvB,aAAa;MACb,kBAAkB;MAClB,gBAAgB;MAChB,eAAe;MACf,qBAAqB,EAAA;MAVtB;QAcG,cvCt9BiB;QuCu9BjB,gDvCv9BiB,EAAA;MuCw8BpB;QAmBG,2CvCj7Ba;QuCk7Bb,mBAAmB,EAAA;EAKzB;IACE,SAAS;IACT,kBAAkB;IAClB,gCvCp+BqB;IuCq+BrB,iBAAiB,EAAA;;AAIrB;EACE,kBAAkB;EAClB,WAAW,EAAA;EAEX;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY,EAAA;EAGd;IACE,WAAW;IACX,YAAY;IACZ,aAAa,EAAA;IAEb;MACE,kBAAkB;MAClB,QAAQ;MACR,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,oBAAoB;MACpB,UAAU;MACV,UAAU;MACV,gBAAgB,EAAA;EAxBtB;IA6BI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,oBAAoB;IACpB,0CvCn+BiB;IuCo+BjB,iCvC/9Be;IuCg+Bf,cvC/gCqB;IuCghCrB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,eAAe,EAAA;IA3CnB;MA8CM,sCvC9+Bc;MuC++Bd,cvC/+Bc,EAAA;IuCg8BpB;MAmDM,sCvCn/Bc;MuCo/Bd,cvCp/Bc,EAAA;EuCg8BpB;IAyDI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,8BAA8B;IAC9B,0CvC//BiB;IuCggCjB,mBAAmB;IACnB,kCvC3/BqB,EAAA;EuCy7BzB;IAsEI,cAAc;IACd,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,+BvCtjCqB;IuCujCrB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB,EAAA;EAjFvB;IAqFI,aAAa;IACb,oDAAoD;IACpD,MAAM;IACN,cAAc;IACd,aAAa;IACb,SAAS;IACT,qBAAqB;IACrB,oBAAoB;IACpB,0CvC5hCiB;IuC6hCjB,kBAAkB;IAClB,iCvCzhCe;IAwSjB,qBAAqB;IACrB,gEAvSsB,EAAA;IAyStB;MACE,UAAU,EAAA;IAGZ;MACE,kCA9SoB;MA+SpB,oBAAoB,EAAA;IAGtB;MACE,oCA1TiB;MA2TjB,oBAAoB,EAAA;EuCooBxB;IAoGI,aAAa;IACb,0CAA0C;IAC1C,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,gDvCziCiB;IuC0iCjB,iDvC1iCiB,EAAA;IuC+7BrB;MA8GM,kBAAkB,EAAA;EA9GxB;IAmHI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,+BvCjmCqB;IuCkmCrB,iBAAiB,EAAA;EAzHrB;IA6HI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,cvChkCgB;IuCikChB,iBAAiB;IACjB,iBAAiB;IACjB,kCAAkC;IAClC,mBAAmB,EAAA;IApIvB;MAuIM,cvC9mCqB,EAAA;IuCu+B3B;MA2IM,cvChkCqB,EAAA;IuCq7B3B;MA+IM,cvClmCoB,EAAA;IuCm9B1B;MAmJM,cvCnlCc,EAAA;IuCg8BpB;MAuJM,cvCtkCqB,EAAA;EuC+6B3B;IA4JI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,gCvC5oCqB;IuC6oCrB,iBAAiB;IACjB,kBAAkB,EAAA;;AAItB;EACE,kBAAkB;EAClB,0CvC1mCmB;EuC2mCnB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB,EAAA;EAEjB;IACE,iHvC1mCqB,EAAA;EuC+mCvB;IACE,oKAEgF,EAAA;EAIlF;IACE,mBAAmB,EAAA;EAGrB;IACE,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,iCvCroCe;IuCsoCf,0CvC3oCiB;IuC4oCjB,yCAAyC,EAAA;EAG3C;IACE,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,2CvC9rCqB;IuC+rCrB,kBAAkB;IAClB,eAAe;IACf,gFAGsB,EAAA;IAXvB;MAcG,sCvC9pCc;MuC+pCd,sBAAsB,EAAA;IAfzB;MAmBG,2CvClqCe;MuCmqCf,mBAAmB,EAAA;IAGrB;MACE,gHvCjqCmB,EAAA;IuCsqCrB;MACE,mHvC9qCc,EAAA;IuCmrChB;MACE,qBvCxqCgB;MuCyqChB,8CvCzqCgB,EAAA;EuC6qCpB;IACE,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,0CvCtuCqB;IuCuuCrB,oBAAoB;IACpB,iCvCxrCqB;IuCyrCrB,+BvCzuCqB;IuC0uCrB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,eAAe,EAAA;IAXhB;MAeG,qBvC5rCgB;MuC6rChB,cvC7rCgB;MuC8rChB,8CvC9rCgB,EAAA;IuC6qCnB;MAqBG,2CvC7sCe;MuC8sCf,mBAAmB,EAAA;EAIvB;IACE,WAAW;IACX,aAAa;IACb,iBAAiB,EAAA;IAHlB;MAMG,cAAc;MACd,WAAW;MACX,YAAY,EAAA;EAIhB;IACE,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,SAAS;IACT,wBAAwB;IACxB,oBAAoB;IACpB,iCvChuCe;IuCiuCf,0CvCtuCiB;IuCuuCjB,gCvCjxCqB;IuCkxCrB,kBAAkB;IAClB,oBAAoB,EAAA;IAEpB;MACE,cvC9wCc;MuC+wCd,qCvC/wCc,EAAA;;AuCoxCpB;EACE,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,cvClyCuB;EuCmyCvB,6BAA6B;EAC7B,mBAAmB;EACnB,kCvC/xCsB;EuCgyCtB,iBAAiB;EACjB,UAAU;EACV,oBAAoB;EACpB,8IAIwB,EAAA;EAExB;IACE,eAAe;IACf,YAAY;IACZ,UAAU;IACV,oBAAoB;IACpB,sCvC1wCiB;IuC2wCjB,UAAU,EAAA;EAGZ;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,cAAc;IACd,gCAAgC;IAChC,iDvCrxCiB;IuCsxCjB,iBAAiB;IACjB,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCvCt0CqB;IuCu0CrB,kBAAkB;IAClB,UAAU;IACV,iBAAiB,EAAA;IAjBlB;MAoBG,cAAc;MACd,YAAY;MACZ,mBAAmB,EAAA;IAtBtB;MA0BG,UAAU;MACV,QAAQ;MACR,uCAAkD,EAAA;IA5BrD;MAgCG,kBAAkB;MAClB,sBAAsB;MACtB,yBAAyB;MACzB,+BvC31CmB,EAAA;EuC+1CvB;IACE,kBAAkB;IAClB,gCvCj2CqB,EAAA;EuCo2CvB;IAEE,SAAS;IACT,wBAAwB;IACxB,gCvCx2CqB;IuCy2CrB,kBAAkB;IAClB,iBAAiB,EAAA;EAGnB;IACE,cvCt2CgB,EAAA;EuCy2ClB;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,SAAS;IACT,gCAAgC;IAChC,gBAAgB;IAChB,cAAc;IACd,+BAA+B;IvCliCjC,qBAAqB;IACrB,gEAvSsB,EAAA;IAyStB;MACE,UAAU,EAAA;IAGZ;MACE,kCA9SoB;MA+SpB,oBAAoB,EAAA;IAGtB;MACE,oCA1TiB;MA2TjB,oBAAoB,EAAA;EuCwhCtB;IACE,SAAS;IACT,UAAU,EAAA;EAGZ;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,cAAc,EAAA;IAXf;MAcG,oCvCt2Ce;MuCu2Cf,sCvCv2Ce,EAAA;IuCw1ClB;MAmBG,2CvC32Ce;MuC42Cf,mBAAmB,EAAA;IAGrB;MACE,qBvCr2CgB,EAAA;MuCo2CjB;QAIG,qBvCx2Cc,EAAA;IuC42ClB;MACE,oCvC72CgB;MuC82ChB,sCvC92CgB,EAAA;EuCk3CpB;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB,EAAA;IAEjB;MACE,qBAAqB;MACrB,mBvC96CqB;MuC+6CrB,aAAa,EAAA;EAIjB;IACE,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,kBAAkB,EAAA;EAGpB;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB,EAAA;EAGrB;IACE,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gCvC18CqB;IuC28CrB,kCAAkC,EAAA;;AAItC;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,YAAY,EAAA;EALd;IAQI,cAAc;IACd,YAAY,EAAA;;AAIhB;EAn6CE;IAq6CE,0BAA0B,EAAA;EA74C5B;IAi5CE,YAAY;IACZ,gBAAgB,EAAA;EAzzClB;IA6zCE,iBAAiB,EAAA;EA50BrB;IAg1BI,0BAA0B,EAAA;EAznC5B;IA6nCE,aAAa,EAAA;IA7nCd;MAgoCG,UAAU,EAAA;EAv/Bd;IA4/BE,sBAAsB,EAAA;EAr/BxB;IAy/BE,cAAc;IACd,WAAW;IACX,eAAe;IACf,cAAc,EAAA;IA5/Bf;MA+/BG,iBAAiB;MACjB,0CAAyE,EAAA,EAC1E;;ACliDL,kCAAA;AxCGA;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AwCt8BA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EAAG,yCAAA;EACf,WAAW;EAAI,yCAAA;EACf,UAAU,EAAA;;AAGZ;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa,EAAA;;AAGf;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,iDAAiD,EAAA;;AAGnD;EACE,iCAA8B;EAC9B,oCAAoC,EAAA;;AAGtC;EACE;IAAK,oBAAoB,EAAA;EACzB;IAAO,yBAAyB,EAAA,EAAA;;AxC9BlC;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AyCp8BA;EACI,kBAAkB,EAAA;;AAGtB;EACI,mBAAmB;EAAG,4BAAA,EAA6B;;AAGvD;EACI,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,eAAe,EAAA;;AAGnB;EACI,YAAY;EACZ,oBAAoB,EAAA;;AAGxB;EAIQ,aAAa;EACb,gBAAgB;EAEhB,uDAAA,EAAwD;EAPhE;IASY,UAAU,EAAA;EATtB;IAaY,mBzCTa,EAAA;EyCJzB;IAiBY,mBzCZQ;IyCaR,kBAAkB,EAAA;EAlB9B;IAsBY,mBzCTA,EAAA;;AyCbZ;EA2BQ,aAAa;EACb,mBzCpBM;EyCqBN,eAAe;EACf,YAAY;EACZ,czC3BiB;EyC4BjB,kBAAkB;EAClB,gBAAgB,EAAA;EAjCxB;IzCwlBE,mHAAiF;IACjF,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IyCtjBjB,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,czCpCa;IyCqCb,kDAAkD,EAAA;EAzC9D;IA6CY,iBAAiB,EAAA;;AA7C7B;EAmDQ,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB,EAAA;EAxD1B;IA2DY,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,WAAW;IACX,UAAU;IACV,yBzCzDE,EAAA;EyCRd;IAqEY,UAAU;IACV,SAAS,EAAA;EAtErB;IA0EY,SAAS,EAAA;EA1ErB;IA8EY,SAAS,EAAA;;AAKrB;EACI,aAAa,EAAA;;AAGjB;EACI,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,SAAS;EACT,mBAAmB;EAEnB,iBAAiB,EAAA;;AAIrB;EACI,WAAW;EACX,gBAAgB,EAAA;;AAGpB;EACI,eAAe;EACf,azCrGgB;EyCsGhB,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAA;EALrB;IAQQ,azCnGI,EAAA;;AyCuGZ;EACI,eAAe;EACf,azCjHgB;EyCkHhB,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAA;EALrB;IAQQ,azC/GI,EAAA;;AyCoHZ;EACI,gBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB,EAAA;EAJvB;;IAQQ,YAAY,EAAA;EARpB;IAYQ,mBAAmB;IACnB,YAAY,EAAA;;AAIpB;;EAEI,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,gBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB,EAAA;;AAGvB;EACI,aAAa,EAAA;;AAGjB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB,EAAA;EANxB;IASQ,kCAAkC;IAClC,yBzChJa;IyCiJb,czCjJa,EAAA;EyCsIrB;IAeQ,mCAAmC;IACnC,yBzCpKI;IyCqKJ,czCrKI,EAAA;;AyC0KZ;EACI,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe,EAAA;EAZnB;IAgBQ,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB,EAAA;IApB1B;MAwBY,QAAQ;MACR,WAAW;MACX,YAAY,EAAA;MA1BxB;QA6BgB,iBAAiB;QACjB,kBAAkB;QAClB,gBAAgB;QAChB,yBzC9MG,EAAA;MyC8KnB;QAoCgB,QAAQ;QACR,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,oBAAoB,EAAA;EAxCpC;IA8CQ,aAAa;IACb,YAAY;IACZ,gBAAgB,EAAA;EAhDxB;IAoDQ,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,oCAAoC,EAAA;EA3D5C;IA+DQ,qBAAqB;IACrB,yCAAyC;IACzC,eAAe,EAAA;;AAGnB;EACI;IAAK,uBAAuB,EAAA;EAC5B;IAAM,yBAAyB,EAAA;EAC/B;IAAM,yBAAyB,EAAA;EAC/B;IAAM,yBAAyB,EAAA;EAC/B;IAAO,yBAAyB,EAAA,EAAA;;AAMxC;EAEI,YAAY;EACZ,yBAA0B,EAAA;;AAM9B;EACI,yBzC3QgB;EyC4QhB,mBAAmB;EAEnB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,YAAY,EAAA;;AAGhB;EACI,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,SAAS,EAAA;;AAGb;EACI,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EAEjB,WAAW;EACX,WAAW;EAEX,eAAe,EAAA;;AAGnB;EACI,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBzC5Se;EyC6Sf,kBAAkB;EAClB,eAAe;EAOf,8DAE8B,EAAA;EAnBlC;IAaQ,2CAA2C;IAC3C,mDAAmD,EAAA;EAOvD;IACI,WAAW;IACX,YAAY;IACZ,cAAc,EAAA;EAGlB;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB,EAAA;EAG5B;IACI,eAAe;IACf,gBAAgB;IAChB,czC/UiB,EAAA;EyCkVrB;IACI,eAAe;IACf,eAAe;IACf,czCpVY;IyCqVZ,aAAa,EAAA;;AzClXrB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;A0Cn8BA;EACI,yBAAyB;EACzB,iBAAiB,EAAA;;AAGrB;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB,EAAA;EAL1B;IAQI,2BAA2B,EAAA;;AAI/B;EACI,oHAAqJ;EACrJ,oCAAoC;EACpC,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B,EAAA;;AAGjC;EACI,gC1CGU,EAAA;;A0CAd;EAEI,aAAa,EAAA;;AAMjB;EACI,uBAAuB;EACvB,gBAAgB;EAChB,c1CdgB;E0CehB,YAAY,EAAA;EAJhB;IAOQ,c1CnBiB,EAAA;;A0CuBzB;EACI,mB1CpBU;E0CqBV,c1CxBgB;E0CyBhB,kBAAkB,EAAA;;AAGtB;EACI,c1C9BqB;E0C+BrB,qBAAqB;EACrB,c1ChCqB,EAAA;;A0CmCzB;EACI,+BAA+B;EAC/B,c1CrCqB;E0CsCrB,qBAAqB,EAAA;;AAGzB;EACI,c1C1CqB,EAAA;;A0C6CzB;EACI,mB1C1CU;E0C2CV,c1C/CqB,EAAA;;A0CmDzB;EACI,yBAA6B,EAAA;EADjC;IAGQ,c1CtDiB,EAAA;;A0C0DzB;EACI,c1C3DqB,EAAA;;A0C8DzB;EACI,c1C/DqB,EAAA;;A0CkEzB;EACI,qB1C/DU;E0CgEV,uBAAuB,EAAA;;AAG3B;EACI,c1CxEqB,EAAA;;A0C2EzB;EACI,qBAAqB;EACrB,YAAY;EACZ,0BAA0B,EAAA;;AAI9B;EACI,uBAAuB,EAAA;;AAG3B;EACI,8BAAiC;EACjC,8B1C7Ec;E0C8Ed,+B1C9Ec;E0C+Ed,gC1C/Ec;E0CgFd,c1C3FqB;E0C4FrB,+BAA+B;EAC/B,gCAAgC;EAChC,wBAAwB,EAAA;;AAI5B;EACE,eAAe;EACf,iBAAiB;EACjB,c1CrGuB,EAAA;;A0CwGzB;;;EAGI,aAAa;EACb,c1C5GqB,EAAA;;A0CgHzB;;;EAGI,aAAa;EACb,c1CpHqB,EAAA;;A0CwHzB;EAEI,aAAa;EACb,c1C3HqB,EAAA;;A0C+HzB;EACE,iBAAiB;EACjB,kBAAkB,EAAA;;AAGpB;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB,EAAA;EAGhB;IATJ;MAUM,qBAAqB,EAAA,EAM1B;EAJK;IAZN;MAaQ,qBAAqB,EAAA,EAG5B;;AAED;EACE,c1C/IkB;E0CgJlB,qBAAqB,EAAA;EAFvB;IAKM,0BAA0B,EAAA;;AAKhC,uCAAA;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,mB1C9JsB;E0C+JtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,yB1CzKkB;E0C0KlB,mBAAmB;EACnB,wCAAwC;EACxC,QAAQ;EACR,SAAS;EACT,gCAAgC,EAAA;;AAGlC,0BAAA;AACA;EACE,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB,0CAAA;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gBAAgB,EAAA;;AAGlB,wBAAA;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc,EAAA;;AAOhB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB,EAAA;;AAGnB;EACE,c1ClPkB;E0CmPlB,eAAe,EAAA;;AAGjB;EACE,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW,EAAA;;AAGb;EACE,qBAAqB;EACrB,YAAY;EACZ,UAAU;EACV,WAAW,EAAA;;AAGb;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,iBAAiB,EAAA;;AA7InB;EAgJE,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EAErB,eAAe;EACf,YAAY;EACZ,sBAAsB,EAAA;;AAGxB;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,gBAAgB,EAAA;;AA7JlB;EAiKE,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EAErB,eAAe;EACf,YAAY;EACZ,sBAAsB,EAAA;;AAGxB;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB,EAAA;;AAEpB;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB,EAAA;;AAGpB;EACE,WAAU;EACV,kDAAkD,EAAA;;AAGpD;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB,EAAA;EAL1B;IAQI,2BAA2B,EAAA;;AAK/B;EACE,yCAAyC,EAAA;;AAG3C;EACE,gBAAgB;EAChB,iBAAiB,EAAA;;AAGnB;EACE,SAAS,EAAA;;AAEX;EACE,eAAe;EACf,eAAe;EACf,cAAc,EAAA;;AAEhB;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,cAAc,EAAA;;AAIhB;EACE,eAAe,EAAA;;AAxWjB;EA6WE,gBAAgB;EAEhB,YAAY,EAAA;;AA/Wd;EAmXE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB,EAAA;;AAGtB;EACE,uBAAuB,EAAA;;AAGzB;EACE,oBAAoB,EAAA;;AAGtB;EACE,sBAAsB,EAAA;E1C4UpB;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;;A0CvVjE;EACE,wCAAwC;EACxC,mBAAmB;EACnB,yBAAyB;EACzB,+GAA+G;EAC/G,0BAA0B;EAC1B,yDAAyD,EAAA;;AAN3D;EASE,mCAAmC;EACnC,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB,mFAAmF;EACnF,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB,EAAA;;AAGrB;EACE,mFAAmF;EACnF,eAAe;EACf,mBAAmB,EAAA;;AAGrB;EACE,oBAAoB,EAAA;;AAGtB;EACE,sBAAsB;EACtB,eAAe;EACf,yBAA2B;EAC3B,aAAa,EAAA;;AAGf;EACE,eAAe,EAAA;;AAGjB;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,eAAe;EACf,iBAAiB,EAAA;;AAGnB;EACE,sBAAsB;EACtB,wBAAA;EACA,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,oBAAoB,EAAA;;AAGtB;EACE,cAAc,EAAA;;AAGhB;EACE,eAAe,EAAA;;AAGjB;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB,EAAA;;AAGrB;EACE,gBAAgB,EAAA;;AAIlB;EACI,oBAAoB;EACpB,aAAa;EACb,0BAA0B;EAC1B,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,WAAW,EAAA;;AAGf;EACE,eAAe,EAAA;;AApfjB;EAwfE,mB1C3gBY;E0C4gBZ,c1C/gBkB,EAAA;;A0CkhBpB;EACE,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,eAAe,EAAA;;AAGjB;EACE,YAAY;EACZ,gBAAgB;EAChB,qHAAqH;EACrH,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,qBAAqB;EACrB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB,EAAA;;AAGrB;EACE,mBAAmB;EACnB,0BAA0B,EAAA;;AAG5B;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe,EAAA;;AAzejB;EA6eE,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;EACpB,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB,EAAA;;AA7kBrB;EAilBE,6CAA6C;EAE7C,oCAAoC;EACpC,gBAAgB,EAAA;;AAplBlB;EAwlBE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB,EAAA;;AAlnBlB;EAsnBE,WAAW;EACX,cAAc;EACd,kBAAkB,EAAA;;AA7hBpB;EAiiBE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB,EAAA;;AA9mB3B;EAknBE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB,EAAA;;AAGlB;EACE,aAAa,EAAA;;AAhpBf;EAopBE,WAAW;EACX,cAAc;EACd,kBAAkB,EAAA;;AAKpB;EACE,WAAY;EACZ,YAAY;EACZ,UAAW;EACX,SAAU;EACV,WAAW,EAAA;;AAIb;EACE,a1C3oBkB;E0C4oBlB,WAAY;EACZ,YAAY;EACZ,QAAQ;EACR,WAAW,EAAA;EALb;IAQI,WAAW,EAAA;;AAIf;EACE,WAAW;EACX,wBAAwB,EAAA;;AAI1B;EACE,8BAAsC;EACtC,oCAAsC;EACtC,4BAA4B;EAC5B,8BAA8B,EAAA;;AAGhC;EACE,8BAAsC,EAAA;;AAGxC;EACE,8BAAsC,EAAA;;AAGxC;EACE,yBAAkC,EAAA;;AASpC;EACE,eAAe;EACf,aAAa;EACb,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qCAAqC;EAwDvC,mGAAA,EAAqG;EAhErG;IAYI,cAAc;IACd,kBAAkB;IAClB,yB1C9rBoB;I0C+rBpB,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,yB1CvsBU,EAAA;I0CkrBd;MAwBM,gBAAgB;MAChB,c1C/sBmB;M0CgtBnB,gCAAgC;MAChC,eAAe;MACf,kBAAkB,EAAA;IA5BxB;MAgCM,cAAc;MACd,gBAAgB;MAChB,c1CxtBmB;M0CytBnB,kBAAkB,EAAA;MAnCxB;QAsCQ,kBAAkB,EAAA;IAtC1B;MA4CM,aAAa;MACb,kBAAkB;MAClB,mBAAmB;MACnB,uBAAuB;MACvB,mBAAmB;MACnB,WAAW;MACX,gBAAgB;MAChB,6BAA6B,EAAA;MAnDnC;QAsDQ,cAAc;QACd,kBAAkB;QAClB,mBAAmB;QACnB,YAAY;QACZ,kBAAkB;QAClB,eAAe,EAAA;EA3DvB;IAkEE,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB,EAAA;IAtEnB;MAyEI,UAAU;MACV,QAAQ;MACR,SAAS,EAAA;IA3Eb;MA+EI,kBAAkB;MAClB,eAAe;MACf,QAAQ;MACR,OAAO;MACP,UAAU;MACV,YAAY;MACZ,sBAAsB;MACtB,eAAe;MACf,mBAAmB,EAAA;MAvFvB;QA0FM,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,WAAW;QACX,SAAS;QACT,WAAW;QACX,uBAAuB;QACvB,eAAe;QACf,kBAAkB,EAAA;IAlGxB;MAuGI,yB1CpxBQ,EAAA;I0C6qBZ;MA2GI,2BAA2B,EAAA;IA3G/B;MA+GI,2BAA2B,EAAA;;AAM/B;EAEE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,oBAAoB,EAAA;EAGtB;IACE,eAAe;IAAE,4DAAA;IACjB,YAAY,EAAA;EAEb,2EAAA;EAzrBH;IA6rBK,sBAAsB;IAAE,yCAAA;IACxB,uBAAuB;IAAE,8DAAA;IACzB,WAAW,EAAA;EAtiBhB;IA0iBI,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IAAE,yCAAA;IACxB,uBAAuB;IAAE,8DAAA,EAA+D,EACzF;;AAIH;EACE,qBAAqB;EAAE,wCAAA;EACvB,SAAS;EACT,cAAc,EAAA;;AAIhB;EACE,wBAAwB;EAAE,oCAAA;EAC1B,SAAS;EACT,cAAc,EAAA;;AzC1fhB;EyC+fE,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;EACE,cAAc;EACd,cAAc;EACd,aAAa;EACb,kBAAkB,EAAA;EAJpB;IAQI,WAAW;IACX,kBAAkB;IAClB,yB1Cr2BU;I0Cs2BV,oBAAoB,EAAA;EAXxB;IAeI,SAAS;IACT,UAAU;IACV,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB,EAAA;EApBvB;IAwBI,YAAY;IACZ,WAAW;IACX,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,gBAAgB,EAAA;;AAIpB;;EAEE,oCAA4C;EAC5C,yCAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,0CAA0C,EAAA;;A1C56B5C;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;A2Cv8BA,oEAAA;AACA,eAAA;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW,EAAA;EAEX;IACE,WAAW,EAAA;;AAIf;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,gHAAmG;EACnG,4BAA4B;EAC5B,sBAAsB;EAEtB,yCAAyC;EACzC,gDAAgD;EAChD,qBAAqB;EACrB,2BAA2B;EAC3B,oBAAoB;EACpB,UAAU,EAAA;EAdZ;IAiBI,aAAa;IACb,mBAAmB;IACnB,WAAW;IAEX,UAAU;IAEV,aAAa,EAAA;IAvBjB;MA0BM,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,iCAAiC;MACjC,UAAU,EAAA;MA9BhB;QAiCQ,WAAW;QACX,UAAU;QACV,+BAA+B,EAAA;QAnCvC;UAsCU,WAAW;UACX,YAAY,EAAA;MAvCtB;QA4CQ,iBAAiB;QACjB,yEAA0E;QAC1E,iBAAiB;QACjB,oCAAoC;QACpC,qBAAqB;QACrB,6BAA6B;QAC7B,oCAAoC;QACpC,0BAA0B;QAC1B,qDAAqD;QACrD,UAAU;QACV,+BAA+B,EAAA;MAtDvC;QA0DQ,iBAAiB;QAAE,sDAAA,EAAuD;IA1DlF;MAgEM,kBAAkB;MAClB,YAAY;MACZ,aAAa;MACb,2BAA2B;MAE3B,kBAAkB;MAClB,QAAQ,EAAA;IAtEd;MA0EM,kBAAkB;MAClB,SAAS;MACT,YAAY;MACZ,YAAY;MACZ,mDAAsC;MAAE,UAAA;MACxC,4BAA4B;MAC5B,sBAAsB;MACtB,wFAAwF;MAAE,sBAAA;MAC1F,6CAA6C;MAAE,wBAAA;MAC/C,UAAU;MACV,+BAA+B;MAAE,0BAAA,EAA2B;IApFlE;MAyFM,kBAAkB;MAClB,YAAY;MAAE,0CAAA;MACd,SAAS;MACT,YAAY;MACZ,YAAY;MACZ,8GAAiG;MACjG,gGAAgG;MAChG,UAAU,EAAA;;AAMhB;EACE;IACE,4BAA4B,EAAA;EAE9B;IACE,4BAA4B,EAAA,EAAA;;AAIhC,oEAAA;AACA,WAAA;AAEA;EAEE,oCAAoC;EACpC,iBAAiB;EACjB,c3CpGkB;E2CqGlB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,8BAA+B,EAAA;EATjC;IAYI,iBAAiB,EAAA;EAZrB;IAiBI,c3ClHqB;I2CmHrB,qBAAqB,EAAA;;AAMzB;EACE,c3C1HuB,EAAA;;A2CiIzB;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe,EAAA;;AAGjB,iCAAA;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,YAAY,EAAA;;AAGd;EACE,UAAU;EACV,UAAU,EAAA;;AAGZ,qCAAA;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,YAAY,EAAA;;AAGd;EACE,UAAU;EACV,UAAU,EAAA;;AAGZ,oEAAA;AACA,UAAA;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAElB,mBAAmB;EACnB,mBAAmB,EAAA;EAVrB;IAcI,oCAAoC,EAAA;EAdxC;IAkBI,c3CnLQ;I2CoLR,qBAAqB,EAAA;IAnBzB;MAuBM,c3CzLc;M2C0Ld,qBAAqB,EAAA;EAxB3B;IA6BI,kBAAkB;IAClB,YAAY;IAEZ,uBAAuB;IACvB,YAAY;IACZ,eAAe,EAAA;IAlCnB;MAqCM,YAAY,EAAA;IArClB;MAyCM,2BAA2B;MAC3B,kBAAkB;MAClB,SAAS;MACT,QAAQ;MACR,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB;MACnB,mBAAmB;MACnB,cAAc;MACd,mB3ChLa;M2CiLb,kBAAkB;MAClB,UAAU;MACV,oBAAoB;MACpB,oCAAoC,EAAA;IAtD1C;MA0DM,UAAU,EAAA;;AAKhB;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,WAAW,EAAA;EAEX;IACE,YAAY,EAAA;;AAIhB;EACE,kBAAkB;EAClB,c3CrNkB;E2CsNlB,eAAe;EACf,cAAc;EACd,mBAAmB,EAAA;;AAGrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,yC3ChQU;E2CiQV,mBAAmB;EACnB,kC3C/NiB;E2CiOjB,mGAAA,EAAoG;EATtG;IAWI,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB,EAAA;IAb3B;MAgBM,WAAW;MACX,kBAAkB;MAClB,QAAQ;MACR,sBAAsB;MACtB,UAAU;MACV,oBAAoB;MACpB,YAAY,EAAA;IAtBlB;MA0BM,kBAAkB;MAClB,UAAU,EAAA;;AAKhB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc,EAAA;EAEd;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,c3C/PuB;I2CgQvB,eAAe;IACf,cAAc;IACd,eAAe;IACf,sDAA2D;IAC3D,aAAa,EAAA;IAdd;MAiBG,+C3CvQqB;M2CwQrB,kBAAkB,EAAA;EAItB;IACE,iBAAiB,EAAA;;AAIrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,2C3CzRyB;E2C0RzB,2FAIC;EACD,yF3C/RyB,EAAA;E2CmSzB;IACE,cAAc;IACd,c3CrSuB;I2CsSvB,kBAAkB;IAClB,cAAc;IACd,qDAA0D,EAAA;EAG5D;IACE,+BAA+B;IAC/B,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,c3CrWqB;I2CsWrB,oBAAoB;IACpB,mBAAmB,EAAA;;AAIvB;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,2FAIC;EACD,2C3CvUyB;E2CwUzB,0H3CxUyB;E2C4UzB,oBAAoB;EACpB,mBAAmB,EAAA;EAtBrB;IAyBI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,kC3C3VqB;I2C4VrB,iD3CxVuB;I2CyVvB,+C3CzVuB,EAAA;E2C4VzB;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,YAAY;IACZ,0BAA0B;IAC1B,gGAIC,EAAA;EAGH;IACE,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,c3C9WuB;I2C+WvB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,sDAA2D,EAAA;EAG7D;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;IAClB,iBAAiB;IACjB,c3ClbqB;I2CmbrB,sBAAsB,EAAA;;AAK1B;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,gBAAgB,EAAA;EAVlB;IAaI,yBAAyB;IACzB,YAAY,EAAA;;AAKhB,oEAAA;AACA,YAAA;AAEA;EACE,eAAe;EAEf,iBAAiB;EACjB,c3CzcU,EAAA;E2CqcZ;IAOI,c3C7cgB,EAAA;E2CscpB;IAWI,c3CzdqB,EAAA;I2C8czB;MAcM,c3C5dmB,EAAA;I2C8czB;MAkBM,c3ChemB,EAAA;I2C8czB;MAsBM,c3CpemB,EAAA;E2C8czB;IA2BI,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,2BAAW;IACX,SAAS;IAET,0EAAA,EAA4E;IAlChF;MAoCM,UAAU;MACV,SAAS;MACT,YAAY;MACZ,gBAAgB;MAChB,uBAAuB;MACvB,eAAe,EAAA;MAzCrB;QA4CQ,aAAa,EAAA;IA5CrB;MAiDM,cAAc;MACd,iBAAiB;MACjB,iBAAiB,EAAA;IAnDvB;MAuDM,cAAc,EAAA;;AAKpB;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB,EAAA;;AAGpB;EACE,eAAe;EACf,uBAAsB,EAAA;;AAGxB;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,0BAA0B;EAC1B,yBAAyB;EACzB,+C3C9esB;E2C+etB,YAAY;EACZ,MAAM;EACN,cAAc;EACd,YAAY;EACZ,yC3C3hBU;E2C4hBV,kBAAkB,EAAA;EAdpB;IAkBI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,oBAAoB,EAAA;EAzBxB;IA6BI,4BAA4B;IAC5B,2BAA2B;IAC3B,yEAAkE,EAAA;EA/BtE;IAmCI,wCAAwC;IACxC,2BAA2B;IAC3B,yDAA6D,EAAA;;AAIjE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oCAAoC;EACpC,kBAAkB;EAClB,c3CpkByB;E2CqkBzB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;EAClC,4EAA4E,EAAA;EAZ9E;IAeI,+C3C/kBqB,EAAA;E2CklBvB;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,cAAc,EAAA;IAEd;MACE,qBAAqB;MACrB,8BAA8B;MAC9B,oDAA6C;MAC7C,kBAAkB;MAClB,sBAAsB;MACtB,qBAAqB;MACrB,4DAAqD;MACrD,0BAA0B;MAC1B,8BAA8B;MAC9B,6BAA6B,EAAA;EAIjC;IACE,YAAY;IACZ,gBAAgB,EAAA;EAxCpB;IA4CI,c3C9mBgB;I2C+mBhB,0B3CpkBgB;I2CqkBhB,6GAKC;IACD,oD3C3kBgB,EAAA;E2CuhBpB;IAwDI,c3CnkBkB,EAAA;I2C2gBtB;MA2DM,c3CvkBqB;M2CwkBrB,qDAAsD,EAAA;IA5D5D;MAgEM,c3C5kBqB;M2C6kBrB,4C3C7kBqB;M2C8kBrB,8GAKC;MACD,oD3CnlBgB,EAAA;E2C2gBtB;IA6EI,eAAe;IACf,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,kCAAkC;IAClC,yB3C7lBkB;I2C8lBlB,c3C3oBgB;I2C4oBhB,gBAAgB;IAChB,WAAW,EAAA;IArFf;MAwFM,gBAAgB,EAAA;IAxFtB;MA4FM,c3CppBc;M2CqpBd,0B3CpnBc;M2CqnBd,2HAKC,EAAA;EAnGP;IAwGI,eAAe,EAAA;IAxGnB;MA2GM,c3C7qBc;M2C8qBd,0B3CpqBc;M2CqqBd,4GAKC;MACD,mD3C3qBc,EAAA;E2C+qBlB;IACE,kBAAkB;IAClB,c3CvrBuB,EAAA;;A2C2rB3B,oEAAA;AACA,qBAAA;AAEA;EACE,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,UAAU,EAAA;;AAEZ;EACE,+HAAkH;EAClH,gCAAgC;EAChC,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EAEnB,YAAY;EACZ,QAAQ;EAER,aAAa,EAAA;;AAIf;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc,EAAA;;AAGhB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,2C3C3vByB;E2C4vBzB,oBAAoB;EACpB,iC3CzvBsB;E2C0vBtB,eAAe;EACf,0DAA0D,EAAA;EAX5D;IAcI,sC3C3tBgB;I2C4tBhB,kC3C/vBoB,EAAA;;A2CmwBxB;EACE,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gC3C/wBuB;E2CgxBvB,mBAAmB,EAAA;;AAGrB;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,2C3CrxByB;E2CsxBzB,oBAAoB;EACpB,gBAAgB;EAChB,kC3CpxBsB;E2CqxBtB,oBAAoB,EAAA;;AAGtB;EACE,uC3CxwBmB,EAAA;;A2C2wBrB;EACE,cAAc;EACd,YAAY;EACZ,6BAA6B;EAC7B,sBAAsB;EACtB,sFAAqF;EACrF,sDAAsD;EACtD,kBAAkB,EAAA;;AAGpB;EACE,qFAAoF,EAAA;;AAGtF;EACE,yDAAyD,EAAA;;AAG3D;EACE;IACE,qBAAqB;IACrB,gBAAgB,EAAA;EAGlB;IACE,wBAAwB;IACxB,6C3CnxBgB,EAAA;E2CsxBlB;IACE,qBAAqB;IACrB,gBAAgB,EAAA,EAAA;;AAIpB;EACE,kBAAkB;EAClB,QAAQ;EACR,wBAAwB;EACxB,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;EAChB,0C3C30ByB;E2C40BzB,mBAAmB;EACnB,qBAAqB;EACrB,8C3C/xBsB,EAAA;;A2CkyBxB;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB,EAAA;;AAG3B;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,c3C1zBkB;E2C2zBlB,eAAe;EACf,0BAA0B;EAC1B,6BAA6B,EAAA;EAZ/B;IAeI,c3Cz2BqB,EAAA;;A2C62BzB;EACE,aAAa;EAAG,kCAAA;EAChB,YAAY,EAAA;;AAiBd;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,oCAAoC;EACpC,iBAAiB;EACjB,cAAc;EACd,gC3C34BuB;E2C44BvB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,+CAA+C,EAAA;EAjBjD;IAqBI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,oBAAoB,EAAA;EAxBxB;IA4BI,UAAU;IACV,kEArCH;IAsCG,mC3Cr5BQ,EAAA;E2Cu3BZ;IAkCI,UAAU;IACV,8HArCH;IAsCG,+B3Cx5BmB,EAAA;E2C25BrB;IACE,kBAAkB;IAClB,UAAU;IACV,qBAAqB;IACrB,cAAc,EAAA;EA3ClB;IAgDI,c3Ch7BqB;I2Ci7BrB,qBAAqB,EAAA;IAjDzB;MAoDM,mC3C36BM,EAAA;E2Cu3BZ;IAyDI,c3C37BgB;I2C47BhB,oDAAoD;IACpD,qBAAqB,EAAA;IA3DzB;MA8DM,mC3Cp7Ba,EAAA;I2Cs3BnB;MAkEM,uRAaG;MACH,6F3Ch9BmB,EAAA;;A2Cu9BzB,SAAA;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,yDAA4C;EAC5C,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,UAAU,EAAA;EAVZ;IAaI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,WAAW;IACX,wBAAwB;IACxB,gHAAmG;IACnG,4BAA4B;IAC5B,sBAAsB;IACtB,UAAU;IACV,oBAAoB,EAAA;EAvBxB;IA2BI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB,EAAA;EApC1B;IAwCI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,YAAY,EAAA;EA5ChB;IAgDI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,aAAa,EAAA;EApDjB;IAwDI,gBAAgB,EAAA;EAxDpB;;IA6DI,SAAS;IACT,c3CthCgB;I2CuhChB,kBAAkB;IAClB,iBAAiB,EAAA;EAhErB;IAoEI,eAAe,EAAA;EApEnB;IAwEI,cAAc;IACd,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,qC3CpiCgB,EAAA;E2Cw9BpB;IAgFI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,YAAY,EAAA;EAtFhB;IA0FI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,aAAa,EAAA;EA9FjB;IAkGI,c3C1jCgB;I2C2jChB,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB,EAAA;IArGvB;MAwGM,c3CnkCc,EAAA;E2C29BpB;IA6GI,SAAS;IACT,c3CzkCgB;I2C0kChB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB,EAAA;EAlHvB;IAsHI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,WAAW;IACX,YAAY,EAAA;EA3HhB;IA+HI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,c3C/lCgB;I2CgmChB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,eAAe,EAAA;IA7InB;MAgJM,c3C3mCc,EAAA;E2C29BpB;IAqJI,cAA+B,EAAA;EArJnC;;IA0JI,mBAAmB;IACnB,aAAa,EAAA;IA3JjB;;MA8JM,c3CtnCc,EAAA;I2Cw9BpB;;MAkKM,eAAe;MACf,gC3C9nCc,EAAA;E2C29BpB;IAwKI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB,EAAA;IA7KpB;MAgLM,WAAW;MACX,YAAY;MACZ,mBAAmB;MACnB,kBAAkB;MAClB,MAAM,EAAA;EApLZ;IAyLI,YAAY;IACZ,WAAW,EAAA;EA1Lf;IA8LI,YAAY;IACZ,WAAW,EAAA;EA/Lf;;IAoMI,UAAU,EAAA;EApMd;IAwMI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,YAAY,EAAA;EA7MhB;IAiNI,WAAW;IACX,YAAY;IACZ,c3C9qCgB;I2C+qChB,+BAA+B;IAC/B,8DAA8D,EAAA;IArNlE;MAwNM,c3CzqCc,EAAA;E2Ci9BpB;IA6NI,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB,EAAA;EAjO3B;IAqOI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa,EAAA;EAGf;IA3OF;MA6OM,eAAe;MACf,uBAAuB;MACvB,cAAc;MACd,kBAAkB,EAAA;IAhPxB;;;MAsPM,cAAc;MACd,uBAAuB,EAAA;IAvP7B;MA2PM,uBAAuB,EAAA;IA3P7B;MA+PM,gBAAgB,EAAA;IA/PtB;MAmQM,aAAa,EAAA;IAnQnB;MAuQM,mBAAmB,EAAA;IAvQzB;MA2QM,gBAAgB,EAAA,EACjB;EAGH;IA/QF;MAiRM,sBAAsB;MACtB,QAAQ,EAAA;IAlRd;MAsRM,WAAW;MACX,YAAY,EAAA,EACb;EAxRL;IA8RI,qBAAqB;IACrB,sBAAsB,EAAA;EAMxB;IArSF;MAsSI,kBAAkB,EAAA,EAWrB;EAPC;IA1SF;MA2SI,kBAAkB,EAAA,EAMrB;EAJG;IA7SJ;MA8SM,kBAAkB,EAAA,EAGvB;;AAED;EACE,YAAY,EAAA;;AAKd,oEAAA;AACA,oEAAA;AACA,oEAAA;AACA,oEAAA;AACA,oEAAA;AACA,oEAAA;AAEA;EAEE,eAAA;EA5yCF;IA+yCI,sBAAsB;IACtB,UAAU,EAAA;IAhzCd;MAmzCM,aAAa;MACb,sBAAsB,EAAA;MApzC5B;QAuzCQ,QAAQ;QACR,YAAY;QACZ,WAAW;QACX,iBAAiB;QAEjB,gCAAgC,EAAA;MA5zCxC;QAg0CQ,QAAQ;QACR,gBAAgB;QAChB,WAAW;QACX,kBAAkB;QAClB,QAAQ;QAER,kEACwB;QACxB,gBAAgB,EAAA;QA1BtB;UA6BQ,aAAa,EAAA;MA30CvB;QAg1CQ,aAAa,EAAA;EAMnB,aAAA;EApuCF;IAuuCE,oBAAoB;IACpB,iBAAiB;IAEjB,iBAAiB,EAAA;EAIjB,WAAA;EAr0BF;IAu0BI,aAAa,EAAA;EAxmCjB;IA2mCI,qBAAqB;IACrB,mBAAmB,EAAA;EAIrB;IAEI,kBAAkB;IAClB,YAAW,EAAA;EAlrCjB;IAsrCM,kBAAkB;IAClB,YAAY,EAAA;EAIhB;IACE,a3C71CQ;I2C81CR,iBAAiB;IACjB,kBAAkB,EAAA;IAHpB;MAMI,YAAY,EAAA;IANhB;MAUI,YAAY,EAAA;EAKhB,qBAAA;EAxpBF;IA2pBI,gBAAgB;IAAE,2CAAA;IAClB,iBAAiB,EAAA;EAxrBrB;IA4rBI,aAAa;IACb,gBAAgB;IAChB,UAAU,EAAA;EA1rBd;IA8rBI,gEAAgE;IAChE,2BAA2B;IAC3B,UAAU,EAAA;IAHZ;MAMI,0BAA0B;MAC1B,UAAU,EAAA;IAPd;MAWI,2BAA2B;MAC3B,UAAU,EAAA,EACX;;A3C16CL;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;A4Cv8BA,0BAAA;AACA,2BAAA;AACA,0BAAA;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;EAEf,WAAA,EAAY;EANd;IAQI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,c5CkBU,EAAA;I4C7Bd;MAcM,cAAuB,EAAA;IAd7B;MAkBM,kBAAkB,EAAA;;AAOxB,0BAAA;AACA,2BAAA;AACA,0BAAA;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,mB5CoCkB;E4CnClB,yB5CAgB;E4CChB,gC5CDgB;E4CEhB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,wCAAwC;EAExC,WAAA;EAqBA,oBAAA;EAYA,sBAAA;EA+FA,eAAA;EAQA,oBAAA,EAAqB;EAvJvB;I5CsnBE,aAAa;IACb,8BAA8B;IAC9B,cA5nBuB;IA6nBvB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gCA7nBY;IA8nBZ,8BAA8B;IAC9B,mHAAiF;I4C7mB/E,iBAAiB;IACjB,YAAY;IACZ,gC5CpBU;I4CqBV,4BAA4B;IAC5B,2BAA2B;IAC3B,aAAa;IACb,mBAAmB,EAAA;IAxBvB;MA2BM,OAAO;MACP,yBAAyB;MACzB,gBAAgB;MAChB,c5CjCc;M4CkCd,iBAAiB;MACjB,iBAAiB,EAAA;EAhCvB;IAsCI,aAAa;IACb,sBAAsB;IACtB,mB5CEgB;I4CDhB,iBAAiB;IACjB,QAAQ;IACR,iBAAiB;IACjB,cAAc,EAAA;I5C2rBd;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;E4CtvBjE;IAkDI,aAAa;IACb,mB5CXe;I4CYf,eAAe;IACf,iBAAiB;IACjB,yB5CfU;I4CgBV,kBAAkB;IAClB,kDAAkD;IAClD,eAAe,EAAA;IAzDnB;MA4DQ,2BAA2B;MAC3B,UAAU,EAAA;IA7DlB;MAiEM,8BAAuC,EAAA;MAjE7C;QAoEQ,mB5C7BM;Q4C8BN,yB5C/Ba;Q4CgCb,8BAAuC,EAAA;IAtE/C;MA2EM,YAAY,EAAA;MA3ElB;QA8EQ,mB5CvCM;Q4CwCN,yB5CzCa,EAAA;I4CtCrB;MAoFM,YAAY,EAAA;IApFlB;MAwFM,c5C3Fc;M4C4Fd,qBAAqB;MACrB,cAAc,EAAA;IA1FpB;MA8FQ,UAAW,EAAA;IA9FnB;MAkGQ,kBAAkB;MAClB,qBAAqB;MACrB,iBAAiB,EAAA;MApGzB;QAuGY,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,0DAA8C;QAC9C,4BAA4B;QAC5B,0BAA0B;QAC1B,2BAA2B;QAC3B,eAAe;QACf,qBAAqB,EAAA;QA/GjC;UAkHY,yBAAyB,EAAA;MAlHrC;QAuHY,kBAAkB;QAGlB,WAAW;QACX,2BAA2B;QAC3B,mB5CrHM;Q4CsHN,c5CjIa;Q4CkIb,gBAAgB;QAChB,kBAAkB;QAClB,eAAe;QACf,mBAAmB;QACnB,kBAAkB;QAClB,UAAU;QACV,oBAAoB,EAAA;MApIhC;QAwIY,mBAAmB;QACnB,UAAU,EAAA;EAzItB;IAiJI,aAAa;IACb,kBAAkB;IAClB,c5CvJqB;I4CwJrB,eAAe,EAAA;EApJnB;IAyJI,iBAAiB,EAAA;IAzJrB;MA4JM,mB5C/GkB;M4CgHlB,yB5C7JQ;M4C8JR,c5ClKmB;M4CmKnB,iBAAiB;MACjB,kBAAkB;MAClB,eAAe,EAAA;MAjKrB;QAoKQ,qB5CxKiB,EAAA;E4CIzB;IA0KI,6B5C1KU;I4C2KV,mB5C3KU;I4C4KV,aAAa,EAAA;IA5KjB;MA+KM,6BAA6B;MAC7B,YAAY;MACZ,mB5CpIkB;M4CqIlB,yB5ClLQ;M4CmLR,kBAAkB;MAClB,c5CxLmB,EAAA;M4CIzB;QAuLQ,c5C1LY,EAAA;I4CGpB;MA4LQ,iBAAiB;MACjB,cAAc,EAAA;M5C0iBlB;QACI,UAjKa,EAAA;MAoKjB;QACI,mBApKuB;QAqKvB,kBAAkB;QAClB,kBAAkB,EAAA;MAGtB;QACI,yBA3uBU;QA4uBV,kBAAkB,EAAA;QAElB;UACI,yBAAqD,EAAA;;A4CljBjE,0BAAA;AACA,2BAAA;AACA,0BAAA;AAEA;EACE,mBAAmB;EACnB,c5C7MkB,EAAA;;A4CgNpB;EACE,6B5C9MY,EAAA;;AAhCd;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AUnhBI;EmCjbF,aAAa;EAEb,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU,EAAA;;AAIZ;EACE;IACE,iBAAiB;IACjB,WAAW,EAAA,EACZ;;AHmOH;EG/NE,yB7C+CiB;E6C9CjB,iBAAiB;EACjB,kBAAkB,EAAA;;AAMpB,aAAA;AACA;EACI,mBAAmB;EACnB,c7CRqB,EAAA;;A6CWzB;EACE,kBAAkB,EAAA;;AAIpB;;EAEE,c7ClBuB,EAAA;;A0CmTzB;EG7RE,kBAAkB,EAAA;;AAGpB;EACE,gBAAgB;EAChB,c7C3BuB,EAAA;;A6C8BzB;EACE,cAAc;EACd,c7ChCuB;E6CiCvB,aAAa;EACb,kBAAkB,EAAA;EAJpB;IAQI,WAAW;IACX,kBAAkB;IAClB,yB7CpCU;I6CqCV,oBAAoB,EAAA;EAXxB;IAeI,SAAS;IACT,UAAU;IACV,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB,EAAA;EApBvB;IAwBI,YAAY;IACZ,WAAW;IACX,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,gBAAgB,EAAA;;AAIpB;EACE,oCAA4C;EAC5C,yCAA0C;EAC1C,yB7CvDgB;E6CwDhB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,0CAA0C,EAAA;;AAmB5C;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,SAAS,EAAA;;AAQX;EACE,qBAAqB;EACrB,YA3BgB;EA4BhB,YA3BgB;EA4BhB,UAAU;EACV,wCAAwC;EACxC,gDAAgD;EAChD,0DA7B2D,EAAA;;AAqC7D;EACE,qBAAqB;EACrB,YA1CgB;EA2ChB,YA1CgB;EA2ChB,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,yDA3C0D;EA4C1D,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,oCAAoC;EACpC,yBAAyB,EAAA;;AAQ3B;EAGE,6CAA6C;EAC7C,c7CtJuB;E6CuJvB,eAAe;EACf,qBAAqB,EAAA;;AAGvB;EAGE,6CAA6C;EAC7C,c7C/JuB;E6CgKvB,eAAe;EACf,qBAAqB,EAAA;;AAQvB;EAGE,2CAA2C;EAC3C,gC7CvKsB,EAAA;E6CmKxB;IAOI,6CAA6C;IAC7C,c7ChLgB,EAAA;;A6CyLpB;EAGE,0CAA0C;EAC1C,6CAA6C,EAAA;EAJ/C;IAOI,YAAY;IACZ,eAAe;IACf,6DAAgE;IAChE,c7ChMU;I6CiMV,yDA3GwD,EAAA;EAgG5D;IAeI,gC7CpMe;I6CqMf,4CAA4C,EAAA;IAhBhD;MAmBM,6CAA6C;MAC7C,c7C7Mc,EAAA;;A6CuNpB;EACE;IAAO,2BAA2B,EAAA;EAClC;IAAO,6BAA6B,EAAA,EAAA;;AAQtC;EAGE,4FAA4F;EAC5F,0BAA0B;EAC1B,6CAA6C;EAC7C,+CAA+C,EAAA;EANjD;IASI,6DAAgE;IAChE,c7CxOU,EAAA;E6C8Nd;IAcI,kFAAkF;IAClF,0BAA0B;IAC1B,+CAA+C,EAAA;IAhBnD;MAmBM,6CAA6C;MAC7C,cAAc,EAAA;;AAUpB;EAGE,2CAA2C;EAC3C,gC7C9PsB,EAAA;E6C0PxB;IAOI,6CAA6C;IAC7C,c7CvQgB,EAAA;;A6C6QpB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,cAAc,EAAA;;AAEhB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EAEnB,aAAa;EACb,kBAAkB;EAClB,c7C7RuB,EAAA;E6CsRzB;IAUI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW,EAAA;EAbf;IAiBI,aAAa;IACb,uBAAuB;IACvB,gBAAgB,EAAA;IAnBpB;MAsBM,yB7CxSQ;M6CySR,c7C7SmB;M6C8SnB,kBAAkB;MAClB,cAAc;MACd,yB7C/Sc;M6CgTd,kBAAkB;MAClB,qBAAqB;MACrB,yBAAyB;MACzB,YAAY;MACZ,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,wCAAwC,EAAA;MAnC9C;QAsCQ,yB7CjTU;Q6CkTV,yB7CxTW,EAAA;;A6C8TnB;EACE,qBAAqB,EAAA;;AnCyRnB;EmCpRF,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB,EAAA;;AAGtB,8DAAA;AACA;EACE,UAAU;EAAE,4BAAA,EAA6B;;AAG3C;EACE,yB7C1UgB;E6C0Ua,oDAAA;EAC7B,mBAAmB;EAAE,wBAAA,EAAyB;;AAGhD;EACE,mB7CtVY;E6CsVO,gDAAA,EAAiD;;AAGtE;EACE,mBAAmB,EAAA;;AAGrB;EACE,2BAA4B,EAAA;;AAG9B;EACE,2BAA4B,EAAA;;AAM9B;EnC2CI;ImCxCA,aAAa;IACb,mBAAmB;IACnB,qCAAqC;IACrC,sCAAsC;I7CoNxC,WAAW;IACX,iBATc,EAAA;E6CxjBhB;IAiXI,mBAAmB;IACnB,c7CxXqB,EAAA;E6CiWzB;IA2BI,2BAA4B,EAAA;EAvBhC;IA2BI,2BAA4B,EAAA;EpBpZhC;IoBwZI,mBAAoB,EAAA,EACrB;;A7CjaH;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;A8Cr8BA;EACI,UAAU;EACV,gBAAgB;EAChB,eAAe,EAAA;;AAGnB;EACI,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,iB9C+kBe,EAAA;E8CplBnB;IAQI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,aAAa;IAEb,gBAAgB;IAChB,yBAAyB,EAAA;EAd7B;IAkBI,iBAAiB;IACjB,iBAAiB,EAAA;;AAIrB;EACI,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,yB9CEc;E8CDd,6B9CCc;E8CAd,gC9CAc;E8CCd,iCAAiC;EACjC,kBAAkB;EAClB,UAAU;EAEV,qBAAqB;EACrB,yB9C+BqB;E8C9BrB,aAAa;EACb,gBAAgB;EAChB,WAAW,EAAA;E9CutBX;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;;A8CjuBjE;EACI,mBAAmB;EACnB,c9C3BqB,EAAA;;A8C8BzB;EACE,kBAAkB,EAAA;;AAIpB;;EAEE,c9CrCuB,EAAA;;A8CwCzB;EACE,kBAAkB,EAAA;;AAGpB;EACE,gBAAgB;EAChB,c9C9CuB,EAAA;;A8CiDzB;EACE,cAAc;EACd,c9CnDuB;E8CoDvB,aAAa;EACb,kBAAkB,EAAA;EAJpB;IAQI,WAAW;IACX,kBAAkB;IAClB,yB9CvDU;I8CwDV,oBAAoB,EAAA;EAXxB;IAeI,SAAS;IACT,UAAU;IACV,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB,EAAA;EApBvB;IAwBI,YAAY;IACZ,WAAW;IACX,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,gBAAgB,EAAA;;AAIpB;EACI,yB9CnCqB;E8CoCrB,8B9CzEc;E8C0Ed,yB9C1Ec;E8C2Ed,kBAAkB;EAClB,yBAAkC;EAClC,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,0CAA0C,EAAA;;AAG9C;EACI,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,mB9CxDqB;E8CyDrB,yB9C9Fc;E8C+Fd,gC9C/Fc;E8CgGd,iCAAiC,EAAA;;AAGrC;EACI,SAAS;EACT,kBAAkB;EAClB,mBAAmB,EAAA;EAHvB;IAMQ,aAAa;IACb,eAAe;IACf,c9CtHiB;I8CuHjB,gBAAgB,EAAA;;AAIxB;;;;;;;8E/CyvqD8E;A+ChvqD9E;EACI,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,2BAA2B;EAC3B,+BAA+B;EAC/B,gBAAgB;EAChB,WAAW,EAAA;E9C0lBX;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;;A8CrmBjE;EACE,kBAAkB,EAAA;;AAIpB;;EAEE,c9C5JuB,EAAA;;A8C+JzB;EACE,kBAAkB,EAAA;;AAGpB;EACE,gBAAgB;EAChB,c9CrKuB,EAAA;;A8CwKzB;EACE,cAAc;EACd,c9C1KuB;E8C2KvB,aAAa;EACb,kBAAkB,EAAA;EAJpB;IAQI,WAAW;IACX,kBAAkB;IAClB,yB9C9KU;I8C+KV,oBAAoB,EAAA;EAXxB;IAeI,SAAS;IACT,UAAU;IACV,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB,EAAA;EApBvB;IAwBI,YAAY;IACZ,WAAW;IACX,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,gBAAgB,EAAA;;AAIpB;EACI,yB9C1JqB;E8C2JrB,8B9ChMc;E8CiMd,yB9CjMc;E8CkMd,kBAAkB;EAClB,yBAAkC;EAClC,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,0CAA0C,EAAA;;A9CpP9C;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;A+Ct8BA,oCAAA;AACA;EACI,kBAAkB;EAClB,mBAAmB;EACnB,c/CwBqB,EAAA;;A+CrBzB;EACE,mB/CyBiB;E+CvBjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,yB/CiBsB;E+ChBtB,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC;E/C6kBhC,WAAW;EACX,iBATc,EAAA;;AClOhB;E8C9VE,gBAAgB,EAAA;;A/C1BlB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AgDv8BA,qBAAA;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,wCAAwC;EACxC,gDAAgD;EAChD,2BAA2B;EAC3B,chDcuB;EgDbvB,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mCAAmC;EACnC,2CAA2C;EAC3C,mDAAmD;EACnD,kBAAkB,EAAA;;AAGpB;EACE,YAAY,EAAA;;AAGd;EACE,aAAa,EAAA;;AAGf;EACE,aAAa,EAAA;;AAGf;EACE,aAAa,EAAA;;AAGf;EAEE,YAAY,EAAA;;AAGd;EAEE,aAAa,EAAA;;AAGf;EAEE,aAAa;EACb,YAAY,EAAA;;AAId;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW,EAAA;;AAIb;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,chD1CgB;EgD2ChB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,mBAAmB,EAAA;EAbrB;IAgBI,aAAa;IACb,iBAAiB;IACjB,mBAAmB,EAAA;IAlBvB;MAqBM,WAAW;MACX,mBAAmB;MACnB,iBAAiB;MACjB,kBAAkB;MAClB,qBAAqB,EAAA;;AAK3B;EACE,yBhDxEsB;EgDyEtB,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,chDlFkB;EgDmFlB,qBAAqB;EACrB,kBAAkB;EAClB,mCAAmC,EAAA;EATrC;IAYI,eAAe;IACf,chD1FqB;IgD2FrB,0BAA0B,EAAA;EAd9B;IAkBI,yBhD1Fe;IgD2Ff,YAAY;IACZ,eAAe,EAAA;EApBnB;IAwBI,chDjGU;IgDkGV,oBAAoB;IACpB,YAAY,EAAA;;AAIhB;EACE,yBhDvGiB;EgDwGjB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,chDhHkB;EgDiHlB,qBAAqB;EACrB,kBAAkB;EAClB,mCAAmC,EAAA;EATrC;IAYI,yBAAyB;IACzB,eAAe;IACf,iBAAiB,EAAA;;AAKrB,qCAAA;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,chDrIuB;EgDqIE,yEAAA;EACzB,yBAAyB;EAAE,6BAAA;EAC3B,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe,EAAA;EAfjB;IAkBI,yBAAyB;IAAE,oCAAA;IAC3B,YAAY;IACZ,mBAAmB,EAAA;EApBvB;IAyBI,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IAAE,0BAAA,EAA2B;;AAItD;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,chD/JkB;EgDgKlB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB,EAAA;;AAGvB;EACE,yBhDvHmB;EgDuHa,8CAAA;EAChC,chD/KuB;EgDgLvB,iBAAiB;EACjB,yBAAyB;EACzB,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB,EAAA;;AAItB;EACE,UAAU;EACV,wBAAwB;EACxB,+BAA+B;EAC/B,qBAAqB,EAAA;;AAGvB;EACE;IACE,UAAU,EAAA,EAAA;;AAId;EAGE,kBAAkB;EAIlB,UAAU;EACV,YAAY;EACZ,mBAAmB,EAAA;;AAGrB;EACE,wBAAwB;EACxB,cAAc;EACd,mBAAmB,EAAA;EAHrB;IAMI,kBAAkB,EAAA;EANtB;IAUI,WAAW;IACX,aAAa;IACb,sBAAsB,EAAA;EAZ1B;IAgBI,aAAa;IACb,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,yBhDnOgB;IgDoOhB,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,+BAA+B;IAC/B,2DAA2D,EAAA;EA/B/D;IAmCI,iBAAiB;IAAE,6BAAA;IACnB,UAAU,EAAA;EApCd;IAwCI,kBAAkB;IAClB,sBAAsB,EAAA;IAzC1B;MA6CM,kBAAkB;MAClB,QAAQ,EAAA;;AAOd;EACE,YAAY,EAAA;;AAGd;EACE,yBhDlQgB;EgDmQhB,wBAAwB;EACxB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,chDpRuB;EgDqRvB,kBAAkB,EAAA;;AAMpB;EACE;IACE,2BAA2B;IAC3B,UAAU,EAAA;EAEZ;IACE,wBAAwB;IACxB,UAAU,EAAA,EAAA;;AAId;EACE;IACE,UAAU,EAAA;EAEZ;IACE,UAAU,EAAA,EAAA;;AAId;EACE,gBAAgB,EAAA;;AAGlB;EACE,UAAU;EACV,iCAAiC;EAGjC,8CAA8C,EAAA;;AAIhD;EACE,UAAU;EACV,4BAA4B;EAC5B,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,6BAA6B;EAC7B,eAAe,EAAA;;AAGjB;EACE,UAAU;EACV,4BAA4B;EAC5B,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,6BAA6B;EAC7B,eAAe,EAAA;;AAGjB;EACE,UAAU;EACV,4BAA4B;EAC5B,6BAA6B,EAAA;;AAG/B;EACE,UAAU;EACV,wBAAwB,EAAA;;AAG1B;EACE,UAAU;EACV,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,6BAA6B,EAAA;;AAI/B;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,YAAY,EAAA;;AAId;EACE,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,UAAU;EACV,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,6BAA6B,EAAA;EAT/B;IAYI,WAAW;IACX,gBAAgB;IAChB,iBAAiB,EAAA;;AAKrB;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAuB,EAAA;;AAGzB;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,cAAuB,EAAA;;AAQzB;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ,EAAA;EARV;IAWI,eAAe,EAAA;IAXnB;MAcM,aAAa;MACb,WAAW;MACX,YAAY;MACZ,gBAAgB;MAChB,kBAAkB;MAElB,QAAQ;MACR,iBAAiB;MACjB,kBAAkB,EAAA;MAtBxB;QAyBQ,QAAQ;QACR,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,kBAAkB,EAAA;IA7B1B;MAkCM,gBAAgB;MAChB,mBAAmB,EAAA;EAnCzB;IAwCI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,chDzcqB;IgD0crB,sBAAsB;IACtB,yBAA0B;IAC1B,kBAAkB;IAClB,eAAe;IACf,mBAAmB,EAAA;IApDvB;MAuDM,yBAA0B;MAC1B,YAAY,EAAA;IAxDlB;MA6DM,eAAe,EAAA;MA7DrB;QAgEQ,yBAA0B;QAC1B,YAAY;QACZ,gBAAgB,EAAA;EAlExB;IAyEM,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB,EAAA;IA7ExB;MAiFU,QAAQ;MACR,WAAW;MACX,YAAY;MACZ,QAAQ;MACR,WAAW;MACX,YAAY;MACZ,gBAAgB;MAChB,oBAAoB,EAAA;EAxF9B;IA6FI,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB,EAAA;;AAxMtB;EA6ME,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,chDlgBkB;EgDmgBlB,qBAAqB;EACrB,eAAe,EAAA;EANjB;IASI,YAAY,EAAA;;AAShB;EA7iBA;IA+iBI,yBhD7gBoB;IgD8gBpB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,aAAa,EAAA;EA3iBjB;IAojBI,kBAAkB;IAClB,gBAAgB;IAChB,MAAM;IACN,OAAO;IACP,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB,EAAA;EA5YtB;IAiZI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,aAAa;IACb,kBAAkB,EAAA;EA1YtB;IA8YI,kBAAkB;IAClB,yBhDjjBc;IgDijBe,8CAAA;IAC7B,chD7jBqB;IgD8jBrB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAAE,iCAAA;IACpB,SAAS;IACT,OAAO,EAAA;EAzfX;IA8fI,iBAAiB,EAAA;EA/TrB;IAmUI,yBhDtkBQ;IgDukBR,wBAAwB;IACxB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,chDtlBqB;IgDulBrB,SAAS;IACT,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,2BAA2B,EAAA;EAI7B;IACE,gBAAgB,EAAA,EACjB;;AhD7nBH;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AiDt8BA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,sBAAsB,EAAA;EAEtB;IACE,uBAAuB;IACvB,gBAAgB,EAAA;EAGlB;;;;;IAKE,oBAAoB;IACpB,aAAa,EAAA;;AAIjB;;EAEE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB,EAAA;;AAGxB;EACE,cjDZkB;EiDalB,kCjDgCY;EiD/BZ,2CjDZuB,EAAA;;AiDezB;EACE,cAAyB;EACzB,mCjDRU;EiDSV,yCjDTU,EAAA;;AiDYZ;EACE,kBAAkB;EAClB,sBAAsB,EAAA;;AAGxB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cjDlCkB,EAAA;;AiDqCpB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,gBAAgB,EAAA;;AAGlB;EACE,OAAO;EACP,WAAW;EACX,qJAOC,EAAA;;AAGH;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,mBAAsC;EACtC,wBAAwB;EACxB,6CAA6C,EAAA;;AAG/C;EACE,SAAS;EACT,kBAAkB;EAClB,cjDpEkB,EAAA;;AiDuEpB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mFAAmF;EACnF,yCAAyC;EACzC,mBAAmB;EACnB,qFAEyC;EACzC,UAAU;EACV,iBAAiB,EAAA;;AAGnB;EACE,sCAAsC;EACtC,sFAEyC,EAAA;;AAG3C;EACE,kBAAkB;EAClB,UAAU,EAAA;;AAGZ;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,+CAA+C,EAAA;EANjD;IASI,mBAAmB,EAAA;EATvB;IAaI,0CAA0C,EAAA;;AAI9C;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2CAA2C,EAAA;EAR7C;IAWI,cAAc;IACd,WAAW;IACX,YAAY,EAAA;;AAIhB;EACE,+EAAuF;EACvF,qCAAqC,EAAA;EAFvC;IAKI,WAAW;IACX,YAAY;IACZ,cjDlGgB,EAAA;;AiDsGpB;EACE,mBAAmB;EACnB,uCAAuC,EAAA;EAFzC;IAKI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB,EAAA;EARrB;IAYI,WAAW;IACX,YAAY,EAAA;;AAIhB;EACE,gFAAwF;EACxF,sCAAsC,EAAA;EAFxC;IAKI,WAAW,EAAA;;AAIf;EACE,YAAY,EAAA;;AAGd;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB,EAAA;EANxB;IASI,cAAiC,EAAA;EATrC;IAaI,cAAc,EAAA;EAblB;IAiBI,cAAiC,EAAA;;AAIrC;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cjDxMkB;EiDyMlB,sBAAsB,EAAA;;AAGxB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB,EAAA;EALpB;IAQI,cAAc,EAAA;EARlB;IAYI,cjD/LiB,EAAA;IiDmLrB;MAeM,cjDlMe,EAAA;EiDmLrB;IAoBI,mBAAmB;IACnB,cjD7NuB,EAAA;;AiDiO3B;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,cjDtOyB,EAAA;;AiDyO3B;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,cAAc,EAAA;;AAGhB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,uBAAuB;EACvB,4EAGkB;EAClB,mBAAmB,EAAA;EAhBrB;IAmBI,aAAa;IACb,mBAAmB,EAAA;EApBvB;IAwBI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,cAAc,EAAA;;AAIlB;EACE,cjDnRuB;EiDoRvB,uCAAuC;EACvC,iCAAiC,EAAA;EAHnC;IAMI,uCAAuC;IACvC,kCAAkC,EAAA;;AAItC;EACE,cAAc;EACd,sCAAsC,EAAA;EAFxC;IAKI,oCAAoC;IACpC,qBAAqB;IACrB,cjDtSgB,EAAA;IiD+RpB;MAUM,UAAU,EAAA;EAVhB;IAeI,YAAY;IACZ,WAAW,EAAA;;AAIf;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,0CAA0C;EAC1C,cjDhUkB;EiDiUlB,0EAA0E;EAC1E,6CAA6C;EAC7C,0EAGmB,EAAA;EAnBrB;IAsBI,wBAAwB;IACxB,8CAA8C,EAAA;EAvBlD;IA2BI,0BAA0B,EAAA;;AAI9B;EACE,gBAAgB,EAAA;;AAKlB;EACE,4CAA4C,EAAA;EAD9C;IAII,+CAA+C,EAAA;;AAInD;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB,EAAA;;AAGzB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAiC;EACjC,4BAA4B,EAAA;EAb9B;IAgBI,cjDxXgB,EAAA;EiDwWpB;IAoBI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,cAAc;IACd,2BAA2B,EAAA;;AAI/B;EACE,aAAa;EACb,uBAAuB;EACvB,mEAAmE,EAAA;;AAGrE;EACE,uBAAuB,EAAA;;AAGzB;EACE,aAAa;EACb,gBAAgB,EAAA;;AAGlB;EACE,2BAA2B,EAAA;EAE3B;IAHF;MAII,uBAAuB,EAAA,EAE1B;;AAED;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;EACrB,sBAAsB,EAAA;EAEtB;IAPF;MAQI,0BAA0B;MAC1B,WAAW;MACX,qBAAqB,EAAA,EAExB;;AAED;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,oBAAoB,EAAA;EAEpB;IANF;MAOI,0BAA0B;MAC1B,YAAY,EAAA,EAEf;;AAED;EACE,aAAa,EAAA;;AAGf;EACE,cjD5byB;EiD6bzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,SAAS;EACT,kBAAkB,EAAA;EAPpB;IAUI,cjDrcuB;IiDscvB,gBAAgB;IAChB,sBAAsB,EAAA;EAGxB;IAfF;MAgBI,eAAe,EAAA,EAElB;;AAED;EACE,aAAa;EACb,+BAA+B;EAC/B,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB,EAAA;EAEvB;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,YAAY;IACZ,QAAQ;IACR,gDAAgD;IAChD,oBAAoB,EAAA;EAGtB;IACE,2CAA2C;IAC3C,gDAAgD,EAAA;;AAIpD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,0CAA0C;EAC1C,kCAAkC;EAClC,cjDpfyB;EiDqfzB,+FAIsB,EAAA;;AAGxB;EACE,sCAAsC;EACtC,qFAAqF;EACrF,cjDngBkB;EiDogBlB,sFAEyC,EAAA;;AAG3C;EACE,YAAY;EACZ,oBAAoB,EAAA;;AAGtB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cjDhhByB;EiDihBzB,2BAA2B,EAAA;;AAG7B;EACE,cAAiC,EAAA;;AAGnC;EACE,WAAW;EACX,YAAY;EACZ,cAAc,EAAA;EAHhB;IAMI,WAAW;IACX,YAAY,EAAA;;AAIhB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU,EAAA;;AAGZ;EACE,cAAiC;EACjC,0BAA0B;EAC1B,4BAA4B,EAAA;EAH9B;IAMI,cjDpjBgB,EAAA;;AiDwjBpB;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cjDxjByB;EiDyjBzB,2BAA2B,EAAA;;AAG7B;EACE,cjD/jBuB,EAAA;;AiDkkBzB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,0CAA0C;EAC1C,iCAAiC;EACjC,wDAEsB,EAAA;EAVxB;IAaI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,2BAA2B,EAAA;EAjB/B;IAqBI,aAAa;IACb,oBAAoB,EAAA;;AAIxB;EACE,sCAAsC;EACtC,8CAA8C,EAAA;EAFhD;IAKI,cAAiC,EAAA;;AAIrC;EACE,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,cjD9mBkB,EAAA;EiDumBpB;IAUI,gCAAgC,EAAA;EAVpC;IAcI,eAAe;IACf,kCAAkC;IAClC,kBAAkB,EAAA;;AAItB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,6BAA6B;EAC7B,gCAAgC;EAChC,kCAAkC;EAClC,kHAKmB,EAAA;EArBrB;IAwBI,WAAW;IACX,YAAY;IACZ,cAAc,EAAA;EA1BlB;IA8BI,YAAY;IACZ,mBAAmB,EAAA;EA/BvB;IAmCI,sCAAsC;IACtC,cjD/pBgB;IiDgqBhB,0EAA0E;IAC1E,8CAA8C,EAAA;IAtClD;MAyCM,wBAAwB;MACxB,8CAA8C,EAAA;EA1CpD;IAgDM,kCAAkC,EAAA;;AAKxC;EACE,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,eAAe,EAAA;EARjB;IAWI,oBAAoB;IACpB,YAAY;IACZ,mBAAmB,EAAA;EAbvB;IAiBI,cAAc;IACd,WAAW;IACX,YAAY,EAAA;;AAIhB;EACE,mBAAmB;EACnB,iBAAiB,EAAA;EAFnB;IAKI,gCAAgC,EAAA;EALpC;IASI,cjD3rBiB,EAAA;EiDkrBrB;IAaI,cjD9sBgB,EAAA;EiDisBpB;IAiBI,cjDrqBkB,EAAA;;AiDyqBtB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY,EAAA;EALd;IAQI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,cjDvuBuB;IiDwuBvB,2BAA2B,EAAA;;AAI/B;EACE,cAAiC,EAAA;;AAGnC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB,EAAA;;AAGxB;EACE,cAAc;EACd,eAAe,EAAA;EAFjB;IAKI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,cAAiC;IACjC,sDAAsD,EAAA;;AAI1D;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cjD3wByB,EAAA;;AiD8wB3B;EA5yBA;IA8yBI,gBAAgB,EAAA;EAhrBpB;IAorBI,0CAA0C;IAC1C,kDAEmB;IAEnB,iBAAiB;IAEjB,uBAAuB,EAAA;IARzB;MAWI,eAAe,EAAA;IAXnB;MAeI,eAAe,EAAA;IAfnB;MAmBI,kBAAkB;MAClB,iBAAiB;MACjB,WAAW;MACX,eAAe;MACf,eAAe;MACf,yBAAyB,EAAA;EA1kB/B;IA+kBI,eAAe,EAAA;EApdnB;IAwdI,0CAA0C;IAC1C,kDAEmB;IAEnB,iBAAiB;IACjB,uBAAuB,EAAA;IAPzB;MAUI,eAAe,EAAA;IAVnB;MAcI,eAAe,EAAA;IAdnB;;MAmBI,kBAAkB;MAClB,iBAAiB,EAAA;EAxXvB;IA6XI,0CAA0C,EAAA;EAtX5C;IA0XE,UAAU,EAAA;EArZd;IAyZI,eAAe,EAAA;EAvbnB;IA2bI,WAAW,EAAA,EACZ;;AAGH;EACE,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,2CjDl2BuB;EiDm2BvB,kCjDvzBiB;EiDwzBjB,gBAAgB,EAAA;EAEhB;IACE,oCjD5zBU;IiD6zBV,kCjD7zBU,EAAA;EiDg0BZ;IACE,uCjDr1BiB;IiDs1BjB,kCjDj0Be,EAAA;EiDo0BjB;IACE,oCjDz2BgB;IiD02BhB,kCjD12BgB,EAAA;;AiD82BpB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cjD93BkB,EAAA;;AiDi4BpB;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gCjDr4BkB,EAAA;;AiDw4BpB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,2CjD34BuB;EiD44BvB,kCjDj2BY;EiDk2BZ,cjD/4BkB;EiDg5BlB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB,EAAA;EAZ3B;IAgBI,kCjD32BU;IiD42BV,cjDz5BgB;IiD05BhB,qBAAqB,EAAA;;AAIzB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gCjDl6BkB,EAAA;;AiDq6BpB;EACE,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,2CjDv6BuB;EiDw6BvB,kCjD53BiB;EiD63BjB,gBAAgB,EAAA;;AAGlB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cjDp7BkB,EAAA;;AiDu7BpB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gCjD37BkB,EAAA;EiD67BlB;IACE,cjDr6BiB,EAAA;EiDw6BnB;IACE,8BjDx7BgB,EAAA;;AiD47BpB;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,2CjDx8BuB;EiDy8BvB,iCjD95BY;EiD+5BZ,cjD58BkB;EiD68BlB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe,EAAA;EAXjB;IAeI,iCjDx6BU,EAAA;EiDy5Bd;IAmBI,aAAa;IACb,mBAAmB,EAAA;;ACr/BvB;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc,EAAA;;AAGhB;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,sBAAsB;EACtB,cAAc,EAAA;;AAGhB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,yBlD8CyB;EkD7CzB,mBlD+Cc;EkD9Cd,clDVkB;EkDWlB,eAAe;EACf,iBAAiB;EACjB,mFlD6CwB;EkD1CxB,yEAAyE,EAAA;EAnB3E;IAuBI,mBlDmCkB,EAAA;EkDhCpB;IACE,qDAAqD;IACrD,sBAAsB,EAAA;;AAI1B;EACE,cAAc;EACd,oBAAoB,EAAA;;AAGtB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,yBAAyB,EAAA;;AAG3B;EACE;;;IAGE,wBAAwB,EAAA;EAG1B;IACE,qCAAqC,EAAA;EAGvC;IACE,uCAAuC,EAAA;EAGzC;IACE,yCAAyC,EAAA;EAG3C;IACE,uCAAuC,EAAA;EAGzC;IACE,2CAA2C,EAAA;EAG7C;IACE,yCAAyC,EAAA;EAG3C;IACE,2CAA2C,EAAA;EAG7C;IACE,qCAAqC,EAAA,EAAA;;AAIzC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBlDhFkB;EkDiFlB,clD3FkB;EkD4FlB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB,EAAA;;AAGtB;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;EAC3B,kClDpGiB,EAAA;;AkDuGnB;EACE,uBAAO;EACP,4BAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,2ClD7DyB;EkD8DzB,6EAIC;EACD,yElDxHkB,EAAA;;AkD6HpB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,6BAA6B;EAC7B,kDlD9EyB,EAAA;;AkDiF3B;EACE,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gClD9FyB,EAAA;;AkDiG3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mClDvGc;EkDwGd,clDhKkB;EkDiKlB,kBAAkB;EAClB,sBAAsB,EAAA;;AAGxB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,clD1KkB;EkD2KlB,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,SAAS;EACT,wBAAwB;EACxB,oBAAoB;EACpB,0ClD7HyB;EkD8HzB,kClD1HwB;EkD2HxB,gClDrLkB;EkDsLlB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,0DAA0D,EAAA;EAZ5D;IAgBI,mClDtIY;IkDuIZ,sClDxIkB;IkDyIlB,clDhMgB,EAAA;;AkDoMpB;EACE,SAAS;EACT,uBAAuB;EACvB,gClDvMkB;EkDwMlB,kBAAkB,EAAA;;AAGpB;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB,EAAA;;AAGnB;EACE,uBAAuB;EACvB,iDlDjNuB,EAAA;EkD+MzB;IAKI,mBAAmB,EAAA;;AAIvB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB,EAAA;;AAGnB;EACE,cAAc;EACd,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB,EAAA;;AAGrB;EACE,gBAAgB;EAChB,clD/OkB,EAAA;;AkDkPpB;EACE,gClDnPkB;EkDoPlB,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,kClDlPkB;EkDmPlB,clD7PkB;EkD8PlB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gClDxQkB,EAAA;;AkD2QpB;EACE,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,2ClD9QuB;EkD+QvB,kClDzQsB;EkD0QtB,mDlDlRkB,EAAA;;AkDqRpB;EACE,SAAS;EACT,wBAAwB;EACxB,YAAY;EACZ,uBAAuB;EACvB,gClD1RkB;EkD2RlB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,0EAA0E,EAAA;EAX5E;IAcI,iDlDjSqB,EAAA;EkDmRzB;IAkBI,aAAa;IACb,mBAAmB,EAAA;EAGrB;IAEE,qClDpRiB;IkDqRjB,clD9SgB;IkD+ShB,qDlDtRiB,EAAA;EkDyRnB;IAEE,mClD1SgB;IkD2ShB,clDrTgB;IkDsThB,mDlD5SgB,EAAA;EkD+SlB;IACE,qClDjSiB,EAAA;EkDoSnB;IACE,kClDpTgB,EAAA;;AmDrCpB;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;EAC3B,kCnD0BiB,EAAA;;AmDvBnB;EACE,WAAW;EACX,gBAAgB;EAChB,4BAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,0CnDqDkB;EmDpDlB,+EAIC;EACD,0EnDKkB,EAAA;EA4uBhB;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;;AmD1vBjE;EACE,gCAAgC;EAChC,kDnDFuB,EAAA;;AmDKzB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,+BnD8BkB,EAAA;;AmD3BpB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cnDrBkB;EmDsBlB,gBAAgB,EAAA;;AAGlB;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gCnD7BkB,EAAA;;AmDgCpB;EACE,gBAAgB;EAChB,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY,EAAA;;AAGd;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,oCnDZkB;EmDalB,0CnDbkB;EmDclB,cnDzDkB;EmD0DlB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;EACE,cAAc;EACd,YAAY,EAAA;;AAGd;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cnDxEkB,EAAA;;AmD2EpB;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gCnD/EkB,EAAA;;AmDkFpB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,4CnD9DmB;EmD+DnB,kCnDhFsB;EmDiFtB,wDAAwD,EAAA;EAExD;IACE,mBAAmB;IACnB,sCnDpEiB;ImDqEjB,+CnDrEiB,EAAA;;AmDyErB;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,oBAAoB;EACpB,oCnD5DmB;EmD6DnB,cnDzGkB;EmD0GlB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB,EAAA;;AAG3B;EACE,aAAa;EACb,uBAAuB;EACvB,0BAA0B,EAAA;;AAG5B;EACE,eAAe,EAAA;;AAGjB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gCnDtGmB,EAAA;EmDwGnB;IACE,+BnDlIgB,EAAA;;AmDsIpB;EACE,+BAA+B;EAC/B,+CnDtIuB;EmDuIvB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,YAAY,EAAA;;AAGd;EACE,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,yCnDxGkB;EmDyGlB,oCnDzGkB;EmD0GlB,cnDrJkB;EmDsJlB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,0DAA0D,EAAA;EAX5D;IAeI,mCnDnHgB;ImDoHhB,qCnDpHgB,EAAA;;AmDwHpB;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gCnDxKkB,EAAA;;AA1BpB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AoDr8BA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,8BAA8B;EAC9B,oBAAoB,EAAA;;AAGtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;;AAGX;EACE,mBpDgDkB;EoD/ClB,yBpDMiB;EoDLjB,mBAAmB;EACnB,aAAa,EAAA;;AAGf;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cpDRuB,EAAA;;AoDWzB;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS,EAAA;EAET;IALF;MAMI,0BAA0B,EAAA,EAE7B;;AAED;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,yBpD1BiB;EoD2BjB,kBAAkB;EAClB,mBpDeuB;EoDdvB,iBAAiB,EAAA;;AAGnB;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,0BAA0B;EAC1B,uBAAuB,EAAA;;AAGzB;EACE,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,8BpD7CiB;EoD8CjB,kBAAkB;EAClB,UAAU;EACV,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,oBAAoB,EAAA;;AAGtB;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,0BAA0B;EAC1B,eAAe,EAAA;;AAGjB;EACE,mBAAmB;EACnB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAA;;AAGzB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,cpDlGkB,EAAA;;AoDqGpB;;EAEE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBpDtGiB;EoDuGjB,mBpD5DuB;EoD6DvB,cpD7GuB,EAAA;;AoDgHzB;EACE,iBAAiB;EACjB,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBpD1HiB;EoD2HjB,mBpD3HiB;EoD4HjB,cpDjIuB;EoDkIvB,eAAe,EAAA;EANjB;IASI,mBpDjIU,EAAA;EoDwHd;IAaI,YAAY;IACZ,mBAAmB,EAAA;;AAIvB;EACE,uBAAuB;EACvB,qBpD3IiB,EAAA;EoDyInB;IAKI,qCAAqC,EAAA;;AAMzC;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,cpDvKkB;EoDwKlB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,mBAAmB;EACnB,yBpD3KiB;EoD4KjB,+BAA+B;EAC/B,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB,EAAA;;AAGtB;;EAEE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cpDrMkB;EoDsMlB,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,SAAS;EACT,gBAAgB,EAAA;;AAGlB;EACE,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,gBAAgB;EAChB,yBpDlNiB,EAAA;;AoDqNnB;EACE,YAAY;EACZ,mBpDjLY;EoDkLZ,SAAS,EAAA;EAHX;IAKU,UAAU,EAAA;EALpB;IAMU,UAAU,EAAA;EANpB;IAOU,UAAU,EAAA;EAPpB;IAQW,WAAW,EAAA;;AAGtB;EACE,kBAAkB;EAClB,cpDtOkB,EAAA;;AoDyOpB;EACE,aAAa,EAAA;;AAGf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,cpD7PkB;EoD8PlB,mBAAmB,EAAA;;AAGrB;EACE,oBAAoB;EACpB,oBAAoB;EACpB,yBpDhQiB;EoDiQjB,kBAAkB;EAClB,gBAAgB;EAChB,mBpDxNuB,EAAA;;AoD2NzB;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,+BpD1QiB;EoD2QjB,mBpD3QiB;EoD4QjB,cpDjRuB;EoDkRvB,eAAe;EACf,eAAe;EACf,cAAc,EAAA;EAThB;IAYI,eAAe;IACf,8BpDnRe,EAAA;EoDsQnB;IAiBI,mBpDxRU,EAAA;EoDuQd;IAqBI,YAAY;IACZ,mBAAmB,EAAA;;AAIvB;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,mBpDzPuB;EoD0PvB,cpD1SuB;EoD2SvB,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC,EAAA;EARpC;IAWI,YAAY;IACZ,mBAAmB,EAAA;;AAIvB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,gCpDtTiB,EAAA;EoDgTnB;IASI,SAAS;IACT,2BAA2B;IAC3B,4BAA4B;IAC5B,iBAAiB;IACjB,eAAe;IACf,cpDlUgB;IoDmUhB,yBpD9ToB;IoD+TpB,eAAe;IACf,kBAAkB,EAAA;IAjBtB;MAoBM,yBpDrUQ,EAAA;EoDiTd;IAyBI,yBpD1UU;IoD2UV,cpD/UqB;IoDgVrB,gCpD5UU;IoD6UV,mBAAmB,EAAA;;AAQvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;;AAGX;EACE,kBAAkB;EAClB,cpDhWkB;EoDiWlB,kBAAkB,EAAA;;AAUpB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,gBAAgB,EAAA;;AAGlB;EACE,OAAO;EACP,YAAY;EACZ,YAjBuC;EAkBvC,gBAlBuC;EAmBvC,gBAnBuC;EAoBvC,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,UAAU;EACV,sBAAsB,EAAA;EpDkYtB;IACI,WAtLe,EAAA;EAyLnB;IACI,mBAzLyB;IA0LzB,kBAAkB,EAAA;EAGtB;IACI,yBA/vBY;IAgwBZ,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;;AoD5Y/D;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,sBAAsB;EACtB,+BA9BD;EA+BC,mCA/BD;EAgCC,mCAhCD;EAiCC,kBAAkB;EAClB,cAAc;EACd,kBAtCwC,EAAA;;AAyC1C;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,yBpDlZiB;EoDmZjB,+BAA+B;EAC/B,cpDzZuB;EoD0ZvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,+BAtDD;EAuDC,mCAvDD;EAwDC,mCAxDD;EAyDC,sBAAsB,EAAA;EAnBxB;IAsBI,uCpDtaqB;IoDuarB,kCpD5XU;IoD6XV,cpDxaqB,EAAA;EoDgZzB;IA4BI,aAAa;IACb,eAAe,EAAA;;AAInB;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,+BA3ED;EA4EC,mCA5ED;EA6EC,mCA7ED;EA8EC,sBAAsB;EACtB,sBAAsB,EAAA;;AAGxB;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,+BAxFD;EAyFC,mCAzFD;EA0FC,mCA1FD;EA2FC,gBAAgB;EAChB,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,SAAS;EACT,UAAU;EACV,4BAA4B;EAC5B,yBpDzciB;EoD0cjB,kBAAkB;EAClB,+BAA+B;EAC/B,cpDhdkB;EoDidlB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB,EAAA;EAdrB;IAiBI,eAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB,EAAA;EApBtB;IAwBI,aAAa;IACb,mBAAmB,EAAA;EAzBvB;IA6BI,kCpD3bU;IoD4bV,cpDveqB,EAAA;EoDyczB;IAkCI,gBAAgB,EAAA;;AAIpB;EACE,8CpDtcmB;EoDucnB,+CpDvcmB;EoDwcnB,iDpDxcmB,EAAA;;AoD2crB;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB,EAAA;;AAGxB;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,+CpDxgBuB;EoDygBvB,iDpDzgBuB;EoD0gBvB,kDpD1gBuB;EoD2gBvB,mBpD7dkB;EoD8dlB,cpD5gBuB;EoD6gBvB,gBAAgB;EAChB,eAAe,EAAA;EAbjB;IAgBI,6BAA6B;IAC7B,+CpDlhBqB;IoDmhBrB,iDpDnhBqB;IoDohBrB,kDpDphBqB,EAAA;EoDigBzB;IAuBI,YAAY;IACZ,mBAAmB,EAAA;EA1CI;IA8CvB,6BAA6B;IAC7B,6CpDpfiB;IoDqfjB,+CpDrfiB;IoDsfjB,gDpDtfiB;IoDufjB,8CpDvfiB,EAAA;EoDudrB;IAoCI,aAAa,EAAA;;AAIjB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,cpDhjBkB,EAAA;;AoDmjBpB;EACE,4CpDrjBuB;EoDsjBvB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B,EAAA;EALjC;IAQI,4CpD5jBqB,EAAA;;AoDgkBzB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;EACE,kBAAkB;EAClB,cpDvkBkB;EoDwkBlB,eAAe,EAAA;;AAGjB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB,EAAA;EAElB;IANF;MAOI,0BAA0B,EAAA,EAE7B;;AAED;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ,EAAA;;AAGV;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,+BAA+B;EAC/B,cpDnmBuB;EoDomBvB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe,EAAA;EAVjB;IAaI,sCpD1mBqB,EAAA;EoD6lBzB;IAiBI,oCpDnkBU;IoDokBV,kCpDpkBU,EAAA;EoDkjBd;IAsBI,aAAa;IACb,mBAAmB,EAAA;IAvBvB;MA0BM,yBAAyB,EAAA;;AAK/B;;EAEE,mBpDhlBkB;EoDilBlB,yBpD1nBiB;EoD2nBjB,mBAAmB;EACnB,aAAa,EAAA;;AAGf;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cpDvoBuB;EoDwoBvB,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,gBAAgB,EAAA;;AAGlB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cpDrpBuB;EoDspBvB,qBAAqB,EAAA;;AAGvB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,cpD9pBkB,EAAA;;AoDiqBpB;;EAEE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBpDlqBiB;EoDmqBjB,mBpDxnBuB;EoDynBvB,cpDzqBuB,EAAA;;AoD4qBzB;EACE,gBAAgB;EAChB,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,2CpDlrBiB;EoDmrBjB,8CpDnrBiB;EoDorBjB,oBAAoB,EAAA;;AAGtB;EACE,OAAO;EACP,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cpDpsBuB,EAAA;;AoDusBzB;EACE,iBAAiB;EACjB,cpDxsBkB;EoDysBlB,eAAe,EAAA;;AAIjB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB,EAAA;;AAGtB;EACE,UAAU;EACV,QAAQ;EACR,SAAS,EAAA;;AAGX;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,qCAAqC;EACrC,yBpD3tBiB;EoD4tBjB,0DAA0D,EAAA;;AAG5D;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,QAAQ;EACR,oBAAoB;EACpB,mBpD5uBuB;EoD6uBvB,gCAAgC,EAAA;;AAGlC;EACE,kCpDtsBY;EoDusBZ,mCpDvsBY,EAAA;;AoD0sBd;EACE,2BAA2B,EAAA;;AAG7B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS,EAAA;;AAGX;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBpD7vBiB;EoD8vBjB,+BAA+B;EAC/B,cpDpwBuB;EoDqwBvB,eAAe;EACf,gBAAgB,EAAA;EAPlB;IAUI,uCpDzwBqB,EAAA;EoD+vBzB;IAcI,YAAY;IACZ,mBAAmB,EAAA;EAfvB;IAmBI,mCpDvuBU;IoDwuBV,4CpDxuBU,EAAA;;AoD4uBd;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,2CpD1xBiB,EAAA;;AoD6xBnB;EACE,kBAAkB;EAClB,cpDnyBkB;EoDoyBlB,eAAe;EACf,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,8BpDnxBa;EoDoxBb,iBAAiB,EAAA;;AAInB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY,EAAA;;AAKd;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cpDt0BuB,EAAA;;AoDy0BzB;EACE,gBAAgB;EAChB,OAAO;EACP,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,iBAAiB,EAAA;;AAGnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,oBAAoB;EACpB,wCpDnzBY;EoDozBZ,uBAAuB,EAAA;;AAGzB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBpD5zBY;EoD6zBZ,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB,EAAA;;AAGzB;EACE,WAAW;EACX,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAA4B;EAC5B,mBAAmB;EACnB,sBAAsB,EAAA;;AAGxB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,UAAU;EACV,QAAQ;EACR,SAAS,EAAA;;AAGX;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,kCpDl2BY;EoDm2BZ,wCpDn2BY;EoDo2BZ,0DAA0D,EAAA;;AAG5D;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,QAAQ;EACR,oBAAoB;EACpB,gBAAgB;EAChB,gCAAgC,EAAA;;AAGlC;EACE,mBpDp3BY;EoDq3BZ,qBpDr3BY,EAAA;;AoDw3Bd;EACE,2BAA2B,EAAA;;AAG7B;EACE,yCpD73BY;EoD83BZ,mBAAmB,EAAA;;AAGrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ,EAAA;;AAGV;EACE,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,wCpD74BY;EoD84BZ,+BAA+B;EAC/B,cpD17BuB;EoD27BvB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB,EAAA;EAblB;IAgBI,aAAa;IACb,qBpDx5BU;IoDy5BV,4CpDz5BU,EAAA;EoDu4Bd;IAsBI,aAAa;IACb,mBAAmB,EAAA;;AAIvB;EACE,aAAa,EAAA;;AAGf;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cpDp9BuB;EoDq9BvB,kBAAkB;EAClB,cAAc;EACd,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,cpD39BkB;EoD49BlB,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,mBAAmB;EACnB,yBpD99BiB;EoD+9BjB,+BAA+B;EAC/B,cpDr+BuB;EoDs+BvB,kBAAkB;EAClB,aAAa;EACb,QAAQ,EAAA;;AAGV;EACE,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa,EAAA;;AAGf;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc,EAAA;;AAGhB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB,EAAA;;AAGlB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,2CpDthCuB;EoDuhCvB,oBAAoB;EACpB,kCpDnhCiB;EoDohCjB,cpDzhCuB;EoD0hCvB,kBAAkB,EAAA;;AAGpB;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,cpD7iCuB;EoD8iCvB,eAAe;EACf,cAAc,EAAA;EAXhB;IAcI,mCpD1iCgB,EAAA;EoD4hCpB;IAkBI,aAAa;IACb,mBAAmB,EAAA;;AAIvB;EACE,aAAa;EACb,eAAe;EACf,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,mBAAmB;EACnB,0BpD/jCiB;EoDgkCjB,cpDpkCkB;EoDqkClB,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,eAAe;EACf,SAAS,EAAA;;AAGX;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBpDplCiB;EoDqlCjB,mBpD1iCuB;EoD2iCvB,cpD3lCuB,EAAA;;AoD8lCzB;EACE,SAAS;EACT,kBAAkB;EAClB,cpDzlCkB,EAAA;;AoD4lCpB;EACE,eAAe,EAAA;;AAGjB;EACE,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;;AAGX;EACE,SAAS;EACT,kBAAkB;EAClB,cpDpnCkB;EoDqnClB,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,aAAa,EAAA;;AAGf;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe,EAAA;;AAGjB;EACE,kBAAkB;EAClB,cpDtoCkB;EoDuoClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,OAAO,EAAA;;AAGT;EACE,mBAAmB;EACnB,yBpD5oCiB;EoD6oCjB,gBAAgB;EAChB,8BAA8B,EAAA;;AAGhC;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB,EAAA;;AAGtB;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cpDlrCkB,EAAA;;AoDqrCpB;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,+BAA+B,EAAA;EAXjC;IAcI,qCAAqC;IACrC,oCAAoC,EAAA;;AAIxC;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,cpD3tCuB;EoD4tCvB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,cAAc;EACd,mBAAmB,EAAA;EAZrB;IAeI,aAAa;IACb,mBAAmB,EAAA;EAhBvB;IAoBI,gBAAgB,EAAA;;AAIpB;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY,EAAA;;AAGd;EACE,cAAc;EACd,WAAW;EACX,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe,EAAA;EARjB;IAWI,YAAY;IACZ,eAAe,EAAA;;AAInB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,cpDlxCuB;EoDmxCvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB,EAAA;EAdrB;IAiBI,mCAAmC,EAAA;EAjBvC;IAqBI,aAAa;IACb,mBAAmB,EAAA;;AAIvB;EACE,aAAa,EAAA;;AAGf;EACE,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,cpDrzCuB;EoDszCvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB,EAAA;EAfrB;IAkBI,mCAAmC,EAAA;EAlBvC;IAsBI,aAAa;IACb,mBAAmB,EAAA;;AAIvB;EACE,aAAa;EACb,eAAe;EACf,SAAS,EAAA;;AAGX;EACE,SAAS;EACT,kBAAkB;EAClB,cpD90CkB,EAAA;;AoDi1CpB;EACE,cAAc,EAAA;;AAGhB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBpDp1CiB;EoDq1CjB,mBpDr1CiB;EoDs1CjB,cpD31CuB;EoD41CvB,eAAe,EAAA;EANjB;IASI,mBpD31CU,EAAA;EoDk1Cd;IAaI,YAAY;IACZ,mBAAmB,EAAA;;AAIvB;EACE,uBAAuB;EACvB,qBpDr2CiB,EAAA;EoDm2CnB;IAKI,qCAAqC,EAAA;;AASzC;EACE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,iBpD3zBiB;EoD4zBjB,iBAAiB;EACjB,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,4BAAY;EACZ,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBpD31CuB;EoD41CvB,wCAAwC;EACxC,mFAEgC,EAAA;EAhBlC;IAmBI,4HAKC;IACD,sBAAsB;IACtB,2BAA2B,EAAA;EAG7B;IA7BF;MA8BI,4BAAY;MACZ,4BAA4B,EAAA,EAE/B;;AAED;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,wBAAwB;EACxB,kBAAc;EACd,kBAAc,EAAA;;AAGhB;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,sDAAsD,EAAA;;AAGxD;EACE,oBAAoB,EAAA;;AAGtB;6FrDu+tD6F;AqDr+tD7F;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,yLAQC,EAAA;;AAGH;EACE,4MASC,EAAA;;AAGH;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB,EAAA;;AAGlB;;EAEE,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,cpDh+CkB,EAAA;;AoDm+CpB;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCpDj/CuB,EAAA;;AoDo/CzB;EACE,mBAAmB;EACnB,UAAU;EACV,4CAA4C;EAC5C,yCAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB,EAAA;;AAG3B;EACE,eAAe,EAAA;;AAGjB;EACE,kCAA8C,EAAA;;AAGhD;EACE,kCAA8C,EAAA;;AAGhD;EACE,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gCpDlhDkB,EAAA;;AoDqhDpB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gCpD1hDuB;EoD2hDvB,gBAAgB;EAChB,qBAAqB,EAAA;;AAGvB,sGAAA;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,wCAAwC;EACxC,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cpDhjDkB;EoDijDlB,qDAA+E;EAC/E,uEAEgC;EAChC,sFAAsF;EACtF,oDAAoD,EAAA;EApBtD;IAuBI,wBAAwB;IACxB,uEAEgC,EAAA;EA1BpC;IA8BI,2CpDphDiB;IoDqhDjB,mBAAmB,EAAA;;AAIvB;EACE,kBAAkB;EAClB,WAAW,EAAA;;AAGb;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa,EAAA;;AAOf;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,iHpDtiDuB;EoDyiDvB,0CpDhjDkB;EoDijDlB,mBAAmB;EACnB,yBAAyB;EACzB,gFAEiC,EAAA;;AAGnC;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,UAAU,EAAA;;AAGZ;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,oBAAoB,EAAA;;AAGtB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cpD7mDkB;EoD8mDlB,kBAAkB,EAAA;;AAGpB;EACE,UAAU;EACV,cAAc;EACd,+HAMC,EAAA;;AAGH;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY,EAAA;;AAGd;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAA;;AAGzB;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iDAAiD,EAAA;;AAGnD;EACE,WAAW;EACX,YAAY;EACZ,2CpD/pDmB;EoDgqDnB,kBAAkB,EAAA;;AAGpB;EACE,OAAO;EACP,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cpDvtDkB;EoDwtDlB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB,EAAA;;AAGxB;EACE,SAAS;EACT,kBAAkB;EAClB,gCpD9tDuB,EAAA;;AoDquDzB;EACE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,iBpD1qCiB;EoD2qCjB,iBAAiB;EACjB,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,4BAAY;EACZ,4BAA4B;EAC5B,sBAAsB;EACtB,yBpDzsDsB;EoD0sDtB,yCAAyC;EACzC,gFAEiC,EAAA;EAhBnC;IAmBI,4HAKC,EAAA;;AAKL;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,wBAAwB;EACxB,kBAAc;EACd,kBAAc,EAAA;;AAGhB;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,sDAAsD,EAAA;;AAGxD;EACE,oBAAoB,EAAA;;AAGtB,6FAAA;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,8QAQG,EAAA;;AAGL;EACE,kBAAkB;EAClB,UAAU;EACV,oGAAA;EACA,iCAAiC;EACjC,QAAQ;EACR,MAAM;EACN,SAAS;EACT,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;EACpB,YAAY;EACZ,oBAAoB;EACpB,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,gGAAA;EACA,aAAa;EACb,0CAA0C;EAC1C,4BAA4B;EAC5B,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,oBAAoB,EAAA;;AAGtB;EACE,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,gHAAA;EACA,WAAW;EACX,2BAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;;AAGX;EACE,WAAW;EACX,2BAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;EACpB,UAAU;EACV,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;;AAGX,qDAAA;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,0CpDp1DkB;EoDq1DlB,iHpD90DuB;EoDi1DvB,+EAEgC;EAChC,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,gCpD74DuB;EoD84DvB,qBAAqB,EAAA;;AAGvB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,mBAAmB,EAAA;;AAGrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,YAAY,EAAA;;AAGd;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,cAAc,EAAA;;AAGhB;EACE,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,4CpDp7DuB;EoDq7DvB,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cpD97DkB;EoD+7DlB,mBAAmB,EAAA;;AAGrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;EACzB,cAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBpDv8DU;EoDw8DV,gFAAgF;EAChF,kDAAkD,EAAA;EAlBpD;IAqBI,wBAAwB,EAAA;EArB5B;IAyBI,0BAA0B,EAAA;EAzB9B;IA6BI,aAAa;IACb,+CpD99DqB,EAAA;;AoDk+DzB,kDAAA;AACA;EACE,sBAAsB;EACtB,uBAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB,EAAA;;AAGlB;;EAEE,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,gCpDv/DuB,EAAA;;AoD0/DzB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,gBAAgB,EAAA;EpDrxCd;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;;AoD0wCjE;EACE,sBAAsB;EACtB,kBAAkB;EAClB,0CpD99DkB;EoD+9DlB,mBpDx9DuB;EoDy9DvB,+CAA+C,EAAA;;AAGjD;EACE,uBAAuB;EACvB,kBAAkB;EAClB,qDAAwE,EAAA;;AAG1E;EACE,wBAAwB,EAAA;;AAG1B;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,gCpD7hEuB,EAAA;;AoDgiEzB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,SAAS;EACT,UAAU,EAAA;;AAGZ;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY,EAAA;;AAGd;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B,EAAA;;AAGhC;EACE,cAAc;EACd,sBAAsB;EACtB,4CpDlkEuB;EoDmkEvB,+BAA+B,EAAA;;AAGjC;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cpDrlEkB;EoDslElB,sBAAsB,EAAA;;AAGxB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCpDzlEyB,EAAA;;AoD4lE3B;EACE,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,YAAY,EAAA;;AAGd,8EAAA;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB,EAAA;;AAG3B,wFAAA;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,0CAA0C;EAC1C,cpDroEuB;EoDsoEvB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,iCAAiC,EAAA;;AAGnC;EACE,iCAAiC;EACjC,0CAA0C,EAAA;;AAG5C,oFAAA;AACA;EACE,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,cAAc;EACd,eAAe,EAAA;;AAGjB;EACE,YAAY,EAAA;;AAGd;EACE,WAAW;EACX,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,aAAa,EAAA;;AAGf;EACE,kBAAkB;EAClB,gBAAgB,EAAA;;AAGlB;EACE,2RAQG,EAAA;;AAGL;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,SAAS;EACT,sBAAO;EACP,6BAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,SAAS;EACT,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,gCpDrtEkB,EAAA;;AoDwtEpB;EACE,SAAS;EACT,mBAAmB;EACnB,4CAA4C;EAC5C,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cpDluEuB,EAAA;;AoDquEzB;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,+BpDhsEmB,EAAA;;AoDmsErB;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,+BpDjvEuB;EoDkvEvB,qBAAqB,EAAA;;AAGvB;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB,EAAA;;AAGrB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCpDhwEuB,EAAA;;AoDmwEzB;EACE,cpD5vEkB,EAAA;;AoDmwEpB;EACE,sBAAsB,EAAA;;AAGxB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,yCAAyC;EACzC,qDAAkE;EAClE,+EAEgC,EAAA;;AAGlC;EACE,sBAAsB;EACtB,kBAAkB,EAAA;;AAGpB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,cpDryEuB;EoDsyEvB,sBAAsB,EAAA;;AAGxB;EACE,SAAS;EACT,kBAAkB;EAClB,cpD3yEkB;EoD4yElB,iBAAiB,EAAA;;AAGnB;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,0CAA0C;EAC1C,+BAA+B,EAAA;EAE/B;IACE,sCAAsC;IACtC,oDAAoD,EAAA;;AAIxD;EACE,eAAe;EACf,YAAY,EAAA;;AAGd;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cpDn1EkB;EoDo1ElB,sBAAsB,EAAA;;AAGxB;EACE,SAAS;EACT,kBAAkB;EAClB,gCpDz1EyB;EoD01EzB,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,oCAAoC;EACpC,cAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe,EAAA;EAXjB;IAcI,oCAAoC;IACpC,cAAiC,EAAA;EAfrC;IAmBI,sCAAsC;IACtC,oCAAoC;IACpC,cpDp3EqB,EAAA;;AoDw3EzB;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW,EAAA;;AAGb;EACE,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,qDAAwF;EACxF,cpD34EkB;EoD44ElB,0CAA0C,EAAA;EAV5C;IAaI,aAAa;IACb,mBAAmB;IACnB,gBAAgB,EAAA;EAfpB;IAmBI,wBAAwB,EAAA;;AAI5B;EACE,SAAS;EACT,kBAAkB;EAClB,cpDx5EyB,EAAA;;AoD25E3B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,cpD/5EyB,EAAA;;AoDk6E3B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,cpDh6EkB,EAAA;;AoDu6EpB;EACE,aAAa;EACb,2CAA2C;EAC3C,WAAW;EACX,kBAAkB;EAElB;+DrDsytD6D,EqDrytDC;EAPhE;IASI,oBAAoB,EAAA;EAGtB;IAZF;MAaI,0BAA0B,EAAA,EAE7B;;AAED;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,WAAW,EAAA;EAEX;IANF;MAOI,eAAe,EAAA,EAElB;;AAED;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,yBpDt6EwB;EoDu6ExB,mBpDp6EuB;EoDq6EvB,mFAEgC;EAChC,gFAAA;EACA,+BAA+B,EAAA;EAE/B;IAhBF;MAiBI,aAAa,EAAA,EAEhB;;AAED;EACE,oGAEgD,EAAA;;AAGlD;sGrD0xtDsG;AqDxxtDtG;EACE,kGAE0C,EAAA;;AAG5C;sFrDuxtDsF;AqDrxtDtF;EAEE,kGAE2C,EAAA;;AAG7C;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,SAAS;EACT,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,gBAAgB,EAAA;EpDtxDd;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;EoD6vDjE;IAcI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,kCAAkC;IAClC,UAAU;IACV,oBAAoB,EAAA;;AAIxB;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EAEZ,4EAAA,EAA6E;EAL/E;IAOI,gBAAgB,EAAA;;AAIpB;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,eAAe;EACf,cAAc,EAAA;;AAGhB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ;6ErDsxtD2E;EqDpxtD3E,iBAAiB,EAAA;;AAGnB;EACE;wGrDqxtDsG;EqDnxtDtG,aAAa,EAAA;;AAGf;EACE,iCAAiC,EAAA;;AAGnC;EACE,eA9IwB,EAAA;;AAiJ1B;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,uBAAuB;EACvB,gCpDrkFyB;EoDskFzB,oBAAoB,EAAA;;AAGtB;EACE,gCpD5kFuB,EAAA;;AoD+kFzB;EACE,aAAa,EAAA;;AAGf;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;mDrD+wtDiD;EqD7wtDjD,cAAc;EACd,mBAAmB;EACnB;+FrD+wtD6F;EqD7wtD7F,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,UAAU,EAAA;EAfZ;IAkBI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,UAAU;IACV,oBAAoB;IACpB,+FAAA;IACA,mBAAmB;IACnB,oBAAoB,EAAA;;AAIxB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,kFAAA;EACA,2BAA2B;EAC3B,mBAAmB;EACnB,gCAAgC;EAChC,0CAlN4C;EAmN5C,kCAAkC;EAClC,gCpD/nFyB;EoDgoFzB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,4EAGkB;EAoBlB,+FAAA;EAWA;yFrD4utDuF;EqDlutDvF,mCAAA;EAYA,8FAAA,EAA+F;EA5EjG;IA0BI,uCAAuC;IACvC,kCAAkC;IAClC,gCpD9oFgB,EAAA;EoDipFlB;IACE,sCAtO0C;IAuO1C,kCAAkC;IAClC,cpDvpFgB,EAAA;IoDopFjB;MAMG,uCAAuC;MACvC,kCAAkC;MAClC,cpD5pFc,EAAA;EoDiqFlB;IACE,qBpD1mFY;IoD2mFZ,kCAAkC,EAAA;IAFnC;MAKG,qBAAmC;MACnC,kCAAkC,EAAA;EAMtC;IACE,qBpDtnFY,EAAA;IoDqnFb;MAIG,qBAAmC,EAAA;EAKvC;IACE,qBpD7pFW;IoD8pFX,kCAAkC;IAClC,aAAa,EAAA;IAHd;MAMG,qBAAkC;MAClC,kCAAkC,EAAA;EAKtC;IACE,qBpDzqFW,EAAA;IoDwqFZ;MAIG,qBAAkC,EAAA;;AAKxC;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,YAAY,EAAA;;AAGd;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,oCAzTwB;EA0TxB,gCpDtuFuB,EAAA;;AoDyuFzB;EACE,cAAc;EACd,eAAe;EACf,cAAc,EAAA;;AAGhB;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,gCpDnvFuB,EAAA;;AoDsvFzB;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,8BpDnuFa,EAAA;;AoDsuFf;EACE,sEAAA;EACA,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,yCAAyC;EACzC,iCAAiC,EAAA;;AAGnC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,gCpD3wFyB,EAAA;;AoD8wF3B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gCpDpxFuB,EAAA;;AoDuxFzB;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B,EAAA;EARjC;IAWI,kBAAkB;IAClB,iCAAiC,EAAA;EAZrC;IAgBI,kBAAkB;IAClB,oDAAgF,EAAA;EAjBpF;IAqBI,kBAAkB;IAClB,oDAAgF,EAAA;;AAIpF;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBpDzwFwB;EoD0wFxB,mBpDvwFuB;EoDwwFvB,4BAA4B,EAAA;;AAG9B;oGrDgutDoG;AqDpmuDjG;EAuYD,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,mBAAmB;EACnB,+BAA+B,EAAA;;AAGjC;EACE,gBAAgB,EAAA;;AAGlB;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa,EAAA;;AAGf,0GAAA;AACA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,uCAAuC;EACvC,qCAAqC;EACrC,WAAW;EACX,sBAAsB,EAAA;;AAGxB;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;;AAGb,sFAAA;AACA;EACE,OAAO;EACP,aAAa,EAAA;;AAGf;EACE,OAAO;EACP,qBAAqB;EACrB,mBAAmB,EAAA;;AAGrB;EACE,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB,EAAA;;AAIxB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY,EAAA;;AAGd;EACE,sBAAsB,EAAA;;AAGxB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cpD74FuB,EAAA;;AoDg5FzB;EACE,SAAS;EACT,kBAAkB;EAClB,gCpDj5FyB;EoDk5FzB,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY,EAAA;;AAGd;EACE,gBAAgB;EAChB,oBAAoB;EACpB,8CAA8C,EAAA;;AAGhD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;EACrB,kBAAkB,EAAA;;AAGpB;EACE,SAAS;EACT,kBAAkB;EAClB,cpD76FyB;EoD86FzB,iBAAiB,EAAA;;AAGnB;EACE,eAAe,EAAA;;AAGjB;;2FrD8stD2F;AqD3stD3F;EACE,mBAAmB,EAAA;;AAGrB;EACE,mBAAmB,EAAA;;AAGrB;;;;;;;;8ErDkttD8E;AqDxstD9E;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;;AAGb;EACE,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,0CAA0C;EAC1C,iCAAiC,EAAA;;AAGnC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY,EAAA;;AAGd;EACE;;;mFrDsstDiF;EqDlstDjF,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,uCAAuC;EACvC,kBAAkB;EAClB,0CAA0C;EAC1C,kCAAkC;EAClC,cpDpgGuB;EoDqgGvB,oBAAoB;EACpB,eAAe;EACf,yHAKuB,EAAA;EArBzB;IAyBI,sCpDt+FiB;IoDu+FjB,kCAAkC;IAClC,aAAa;IACb,2BAA2B,EAAA;;AAI/B;EACE;;mBrD4rtDiB;EqDzrtDjB,cAAc;EACd,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,cAAc,EAAA;;AAGhB;;;sDrD4rtDsD;AqDvrtDtD;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCpDljGyB,EAAA;;AoDqjG3B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cpD1jGuB;EoD2jGvB;;crDwrtDY;EqDrrtDZ,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB,EAAA;;AAGzB;EACE,eAAe;EACf,+BpDpkGyB;EoDqkGzB,kBAAkB;EAClB,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,mBAAmB;EAEnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gCpDzlGuB;EoD2lGvB,qBAAqB;EACrB,mBAAmB;EACnB,0CAA0C;EAC1C,iCAAiC,EAAA;;AAGnC;EACE,gBAAgB;EAChB,+EAAA;EACA,cAAc;EACd,iEAAA;EACA,uBAAuB;EACvB;;;;;;yDrDurtDuD;EqDhrtDvD,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,YAAY,EAAA;;AAGd;;;;;;gFrDsrtDgF;AqD/qtDhF;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,0CAA0C;EAC1C,iCAAiC,EAAA;;AAGnC;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf;0CrDgrtDwC;EqD9qtDxC,gCpD7oGyB,EAAA;;AoDgpG3B;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY,EAAA;;AAGd;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cpD9pGuB,EAAA;;AoDiqGzB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCpDnqGyB,EAAA;;AoDsqG3B;EACE;iFrD4qtD+E;EqD1qtD/E,cpDjoGmB;EoDkoGnB,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb;;;iFrD6qtD+E;EqDzqtD/E,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB,EAAA;;AAGlB,wEAAA;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY,EAAA;;AAGd;EACE,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gCpDvsGyB,EAAA;;AoD0sG3B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gCpDxtGuB;EoDytGvB,qBAAqB;EACrB,mBAAmB;EACnB,0CAA0C;EAC1C,iCAAiC,EAAA;;AAGnC;EACE,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,cAAc;EACd,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB,EAAA;;AAGtB;EACE,aAAa;EACb,cAAc;EACd,YAAY;EACZ,eAAe,EAAA;;AAGjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,yCAAyC;EACzC,cpD5vGuB;EoD6vGvB,oBAAoB;EACpB,eAAe;EACf,uGAIsB,EAAA;EAjBxB;IAqBI,sCpD7tGiB;IoD8tGjB,kCAAkC;IAClC,aAAa;IACb,2BAA2B;IAC3B,0CAA0C,EAAA;EAzB9C;IA6BI,wBAAwB,EAAA;EAG1B;IACE,uCpD5vGiB;IoD6vGjB,kCAAkC;IAClC,8EAA6E,EAAA;;AAIjF;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB,EAAA;;AAGxB;EACE,WAAW;EACX,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gCpDxyGyB;EoDyyGzB,mBAAmB;EACnB,0CAA0C;EAC1C,iCAAiC,EAAA;;AAGnC;EACE,aAAa;EACb,sBAAsB;EACtB;8ErDuptD4E;EqDrptD5E,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ;;uBrDwptDqB;EqDrptDrB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB;;;qErDyptDmE;EqDrptDnE,0CAA0C;EAC1C,gCAAgC;EAChC,0CAA0C;EAC1C,cpDt0GuB;EoDu0GvB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,uGAIuB,EAAA;EA9BzB;IAkCI,sCpDxyGiB;IoDyyGjB,kCAAkC;IAClC,aAAa;IACb,yCAAyC;IACzC,2BAA2B,EAAA;EAtC/B;IA0CI,wBAAwB,EAAA;;AAI5B;EACE,gEAAA;EACA,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,YAAY,EAAA;;AAGd;EACE;;oDrD6otDkD;EqD1otDlD,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc,EAAA;;AAGhB;;;;6ErD8otD6E;AqDxotD7E;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB,EAAA;;AAGpB;EACE;+ErDyotD6E;EqDvotD7E,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cpDz4GuB;EoD04GvB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCpDn5GyB;EoDo5GzB,sBAAsB,EAAA;;AAGxB;EACE;;;;;;;;;;;;mErDkptDiE;EqDrotDjE,cAAc;EAEd,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,2CpD16GyB;EoD26GzB,uBAAuB;EACvB,cpD96GuB;EoD+6GvB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB,EAAA;;AAGlB;EACE,eAAe,EAAA;;AAGjB;EACE,aAAa,EAAA;;AAGf;;;sErDqotDsE;AqDjotDtE;EAIM,aAAa,EAAA;;AAJnB;EAOM,eAAe,EAAA;;AAKrB;;;;;;;;gFrDootDgF;AqD3ntDhF;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,iCAAiC,EAAA;;AAGnC;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,gCpDr+GyB,EAAA;;AoDw+G3B;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,mBAAmB,EAAA;;AAGrB;EACE,aAAa,EAAA;;AAGf;EACE;;sCrD0ntDoC;EqDvntDpC,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,yCAAyC;EACzC,8BAA8B;EAC9B,gCpDjgHuB;EoDkgHvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mGAIuB,EAAA;EApBzB;IAwBI,sCpDr+GiB;IoDs+GjB,kCAAkC;IAClC,aAAa;IACb,0CAA0C,EAAA;EAG5C;IAGE,qBpD9+GiB;IoD++GjB,oCpD/+GiB;IoDg/GjB,cpD1hHqB;IoD2hHrB,8CpDj/GiB,EAAA;EoDo/GnB;IAEE,mBAAmB;IACnB,YAAY;IACZ,gBAAgB,EAAA;;AAIpB;EACE,SAAS;EACT,kBAAkB;EAClB,+BpDviHyB,EAAA;;AoD0iH3B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,0CAA0C;EAC1C,iCAAiC,EAAA;;AAGnC;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gCpDxjHyB,EAAA;;AoD2jH3B;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cpDxkHkB;EoDykHlB,qDAAwF;EACxF,0CAA0C;EAC1C,eAAe;EACf,0EAA0E,EAAA;EAb5E;IAiBI,wBAAwB;IACxB,aAAa,EAAA;EAlBjB;IAsBI,0BAA0B,EAAA;EAtB9B;IA0BI,aAAa;IACb,mBAAmB;IACnB,gBAAgB,EAAA;;AAIpB;EACE,SAAS;EACT,kBAAkB;EAClB,gCAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,0CAA0C;EAC1C,+BAA+B,EAAA;;AAGjC;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,mCAAmC;EACnC,cpDxnHuB;EoDynHvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe,EAAA;EAXjB;IAcI,oCAAoC,EAAA;EAdxC;IAkBI,aAAa;IACb,mBAAmB,EAAA;;AAIvB;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,8BAA8B;EAC9B,cpDrpHyB;EoDspHzB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe,EAAA;EAXjB;IAcI,sCAAsC;IACtC,cpD/pHqB;IoDgqHrB,oCAAoC,EAAA;EAhBxC;IAoBI,gCpDpqHqB,EAAA;EoDgpHzB;IAwBI,aAAa;IACb,eAAe,EAAA;;AAInB;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gCpDhrHyB,EAAA;;AoDmrH3B;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,+BAA+B;EAC/B,cAAc,EAAA;;AAGhB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe,EAAA;;AAGjB;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,+BAA+B,EAAA;;AAGjC;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,0EAA0E,EAAA;;AAG5E,wDAAA;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;;AAGb;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,oBAAoB,EAAA;;AAGtB;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,yCAAyC;EACzC,+BAA+B;EAC/B,kBAAkB;EAClB,gCpDlvHyB;EoDmvHzB,iBAAiB,EAAA;;AAGnB;EACE,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,YAAY,EAAA;;AAGd;EACE,gBAAgB;EAChB,kCAAkC;EAClC,cpDlwHuB,EAAA;;AoDqwHzB;EACE,cAAiC;EACjC,gBAAgB,EAAA;;AAGlB;EACE,mBAAmB;EACnB;;;yDrDuktDuD;EqDnktDvD,sCAAsC;EAEtC;;0DrDqktDwD,EqDnktDC;EAV3D;;IAaI,aAAa,EAAA;EAbjB;IAiBI,sCAAsC;IACtC,+BAA+B,EAAA;;AAInC;EACE,oBAAoB,EAAA;;AAGtB;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gCpDryHyB;EoDsyHzB,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;;EAEE,SAAS;EACT,kBAAkB;EAClB,cpDnzHyB,EAAA;;AoDszH3B;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY,EAAA;;AAGd;EACE,WAAW;EACX,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,UAAU;EACV,gCAAgC;EAChC,eAAe,EAAA;;AAGjB;EACE,UAAU;EACV,eAAiC;EACjC,eAAe;EACf,qBAAqB;EACrB,2BAA2B,EAAA;;AAG7B;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cpDr1HuB;EoDs1HvB,iBAAiB;EACjB,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,cpD11HyB,EAAA;;AoD61H3B;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,0CAA0C;EAC1C,+BAA+B,EAAA;;AAGjC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,oCAAoC;EACpC,cAAiC;EACjC,eAAe;EACf,cAAc,EAAA;EAZhB;IAeI,oCAAoC;IACpC,uCAAuC,EAAA;EAhB3C;IAoBI,aAAa;IACb,mBAAmB,EAAA;;AAIvB;EACE,cAAc;EACd,eAAe,EAAA;;AAGjB;EACE,cAAc;EACd,eAAe;EACf,cAAc,EAAA;;AAGhB;EACE,cAAc;EACd,eAAe,EAAA;;AAGjB;EACE,kBAAkB;EAClB,cpD15HkB;EoD25HlB,kCAAkC,EAAA;;AAGpC;EACE,SAAS;EACT,kBAAkB;EAClB,cpDh6HyB;EoDi6HzB,gBAAgB,EAAA;;ApD/7HlB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AqDr8BA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,mBrDmEkB;EqDlElB,yBrDyBiB;EqDxBjB,mBAAmB,EAAA;;AAGrB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,crDYuB,EAAA;;AqDTzB;EACE,SAAS;EACT,iBAAiB;EACjB,crDOkB;EqDNlB,iBAAiB,EAAA;;AAGnB;EACE,cAAuB,EAAA;;AAGzB;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,crDhBkB;EqDiBlB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,mBAAmB;EACnB,yBrDpBiB;EqDqBjB,+BAA+B;EAC/B,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB,EAAA;;AAGtB;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,crDlDkB;EqDmDlB,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,SAAS;EACT,eAAe,EAAA;;AAGjB;EACE,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,gBAAgB;EAChB,yBrD/DiB,EAAA;;AqDkEnB;EACE,YAAY;EACZ,mBrD9BY;EqD+BZ,SAAS,EAAA;EAHX;IAKU,UAAU,EAAA;EALpB;IAMU,UAAU,EAAA;EANpB;IAOU,UAAU,EAAA;EAPpB;IAQW,WAAW,EAAA;;AAGtB;EACE,kBAAkB;EAClB,crDnFkB,EAAA;;AqDsFpB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe,EAAA;;AAGjB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBrD5FiB;EqD6FjB,mBrD7FiB;EqD8FjB,crDnGuB;EqDoGvB,eAAe;EACf,iBAAiB;EACjB,gBAAgB,EAAA;EARlB;IAWI,mBrDrGU,EAAA;EqD0Fd;IAeI,YAAY;IACZ,mBAAmB,EAAA;;AAIvB;EACE,uBAAuB;EACvB,qBrD/GiB,EAAA;EqD6GnB;IAKI,qCAAqC,EAAA;;AAIzC;EACE,mBrDjHgB;EqDkHhB,qBrDlHgB,EAAA;EqDgHlB;IAKI,mBrDxHgB;IqDyHhB,qBrDzHgB,EAAA;;AqD6HpB;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,8BAA8B;EAC9B,oBAAoB,EAAA;;AAGtB;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,kBAAkB,EAAA;;AAGpB;EACE,eAAe;EACf,mBrD5GkB;EqD6GlB,crD3JuB;EqD4JvB,4BAA4B;EAC5B,yBrDxJiB;EqDyJjB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,2CAA2C;EAC3C,aAAa,EAAA;;AAGf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCrD7KiB,EAAA;;AqDgLnB;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,crDzLuB,EAAA;;AqD4LzB;EACE,uBAAuB;EACvB,SAAS;EACT,crD9LkB;EqD+LlB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB,EAAA;EARpB;IAWI,qCAAqC;IACrC,crDxMqB,EAAA;EqD4LzB;IAgBI,YAAY;IACZ,mBAAmB,EAAA;;AC5OvB,iBAAA;AtDGA;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AsDr8BA;EACI,ctD2BgB;EsD1BhB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB,EAAA;;AAGtB;EACI,ctDmBqB;EsDlBrB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB,EAAA;;AAGvB;EACI,YAAY;EACZ,ctDWqB;EsDVrB,eAAe;EACf,WAAW,EAAA;;AAGf;EACI,aAAa;EACb,sBAAsB;EAEtB,WAAW,EAAA;;AAGf;EtDqkBE,WAAW;EACX,iBATc;EsD1jBZ,iBAAiB,EAAA;;AAIrB;EACI,aAAa;EACb,mBAAmB;EAAE,wDAAA,EAAyD;;AAGlF;EACI,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,SAAS;EACT,iCAAiC;EACjC,0CAA0C;EAC1C,YAAY,EAAA;;AAIhB;EACI,kBAAkB;EAClB,ctD9BqB;EsD+BrB,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,gCtDjCgB,EAAA;EsDmChB;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,YAAY;IACZ,WAAW;IACX,yBtD1CY,EAAA;;AsD8CpB;EAEQ,cAAc,EAAA;;AAGtB;EACI,mBAAmB,EAAA;;AAGvB;;EACI,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gCtD3DU,EAAA;EsDoDd;IAUQ,ctDlEiB;IsDmEjB,YAAY;IACZ,kBAAkB,EAAA;EAZ1B;IAgBQ,kBAAkB;IAClB,iBAAiB,EAAA;;ACxGzB,kCAAA;AvDGA;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AuDr8BA;EACI,cAAc,EAAA;;AAKlB;EACQ,gBAAgB;EAChB,UAAU;EACd,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,gCAAgC;EAChC,0CAA0C,EAAA;;AAhB9C;EAoBI,cAAc;EAAE,0CAAA,EAA2C;;AAG/D;EACI,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,8BvDGU;EuDFV,iBAAiB;EACjB,cvDFgB;EuDGhB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC,EAAA;EAXrC;IAcQ,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,yBvDqBY;IuDpBZ,uBAAuB;IACvB,cAAc;IACd,oBAAoB,EAAA;;AAI5B;;;;EAII,wFAAwF;EACxF,8BvDrBc;EuDsBd,+BvDtBc;EuDuBd,cvDlCqB,EAAA;;AuDqCzB;EACI,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,cvDjCgB,EAAA;;AuDoCpB;EACI,cAAc,EAAA;;AAGlB;EACI,aAAa,EAAA;;AAQjB;EACI,cvD1DqB;EuD2DrB,yBAAyB;EACzB,oBAAoB,EAAA;;AAGxB;EACI,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,aAAa,EAAA;;AAGjB;EACI,aAAa;EACb,sBAAsB;EACtB,yBvDpEe;EuDqEf,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,6BvDvEQ;EuDwER,gCvDxEQ,EAAA;;AuD2EZ;EACI,aAAa;EACb,0BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB,EAAA;;AAGrB;EACI,aAAa;EACb,yBvDpFQ;EuDqFR,yBAAyB;EACzB,cvD/FqB;EuDgGrB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,8BAA+B,EAAA;;AAGnC;EACI,aAAa;EACb,cvDrGgB;EuDsGhB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB,EAAA;;AAKpB;EA7EA;IA+EQ,aAAa,EAAA;EA3ErB;IA8EQ,cAAc,EAAA;EAGlB;IACI,yBvD7HW;IuD8HX,cvDnIiB;IuDoIjB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,4BAA4B;IAC5B,mBAAmB,EAAA;ED5H3B;IC+HQ,aAAa,EAAA;EAjKrB;IAoKQ,6BAA6B;IAC7B,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,SAAS,EAAA;EAGb;IACI,iBAAiB;IACjB,kBAAkB,EAAA;EAGtB;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,UAAU,EAAA;EAGd;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB,EAAA;E9CzI3B;I8C6IQ,aAAa;IACb,mBAAmB,EAAA;EA9I3B;IAkJQ,iBAAiB;IACjB,WAAW;IACX,YAAY,EAAA;EAGhB;IACI,gBAAgB,EAAA,EACnB;;AvD1NL;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AwDr8BA;EACI,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBxD4Be;EwD3Bf,iBAAiB;EACjB,yBAAyB;EACzB,0BAA2B;EAC3B,cxDmBqB;EwDlBrB,WAAW;EAEX,yBxDiBgB;EwDhBhB,kBAAkB;EAClB,qDAAqD,EAAA;EAbzD;;IAiBQ,aAAa;IACb,OAAO;IACP,eAAe;IACf,SAAS,EAAA;;AAIjB;EACI,cxDGgB;EwDFhB,iBAAiB;EACjB,kBAAkB,EAAA;;AAKtB;;EAGI,2BAA2B,EAAA;EAH/B;;IAMQ,yBxDXiB;IwDajB,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB,EAAA;EAV1B;;IAaQ,yBxDlBiB;IwDmBjB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB,EAAA;IApB3B;;;;;;;;MA0BY,eAAe,EAAA;IA1B3B;;MA6BY,eAAe,EAAA;EA7B3B;;IAkCQ,yBxDnCM,EAAA;EwDCd;;IAsCQ,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,cxD1CM;IwD2CN,YAAY,EAAA;IA1CpB;;MA6CY,eAAe;MACf,cxD9CO,EAAA;EwDAnB;;IAmDQ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,YAAY,EAAA;EAxDpB;;IA4DQ,mBAAmB;IACnB,aAAa;IACb,OAAO;IACP,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB,EAAA;;AAK9B;EAIQ,YAAY;EACZ,kBAAkB,EAAA;;AAK1B;EAEI;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB,EAAA;EAGtB;IACI,mBAAmB;IACnB,mBAAmB;IACnB,SAAS,EAAA;EAjBb;IAqBI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,gBAAgB,EAAA;EAGpB;IACI,aAAa,EAAA;EAIjB;IACI,aAAa,EAAA;EAIjB;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,wBAAwB;IACxB,eAAe,EAAA;EF7EvB;;IEiFQ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,eAAe;IACf,WAAW;IACX,kBAAkB,EAAA;IFvF1B;ME0FY,cxDlJa;MwDmJb,mBAAmB;MACnB,kBAAkB,EAAA;IF5F9B;MEgGY,kBAAkB;MAClB,wBAAwB;MACxB,kBAAkB;MAClB,iBAAiB,EAAA;EAMzB;IACI,yBxD7JW;IwD8JX,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB,EAAA;EFlM3B;IEsMQ,kBAAkB;IAClB,WAAW,EAAA;EAGf;IACI,qBAAqB;IACrB,iBAAiB;IACjB,yBxDzKI;IwD0KJ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,iCAAiC,EAAA;IARrC;MAWQ,yBAAmC,EAAA;EAI3C;IACI,sBAAsB,EAAA;EAG1B;IACI,iBAAiB,EAAA;EAGrB;IACI,YAA0C;IAC1C,WAAwC;IACxC,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS,EAAA;EA/HjB;IAkIQ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB,EAAA;EA5O3B;IAgPQ,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,kDAAkD,EAAA;IA9P1D;;MAkQY,OAAO;MACP,eAAe,EAAA,EAClB;;AxDrQT;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AyDn8BA;EACE,YAAY,EAAA;EADd;IAII,gCzDmBgB;IyDlBhB,sBAAsB,EAAA;EAL1B;;IAUI,iBAAiB,EAAA;EAVrB;IAcI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS,EAAA;;AAIb;EACE,6CAA6C,EAAA;EAD/C;IAII,2CzDPgB;IyDQhB,WAAW,EAAA;EALf;IASI,WAAW;IACX,cAAc;IACd,eAAe;IACf,WAAW;IACX,WAAW;IACX,qCAAqC,EAAA;;AAIzC;EACE,gCzDtBkB,EAAA;;AyDyBpB;;;;EAIE,WAAW,EAAA;;AAGb;EACE,WAAW;EACX,sBAAsB,EAAA;;AAGxB;EACE,aAAa;EACb,+DAA+D;EAC/D,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,kCAAkC;EAClC,0CAA0C;EAC1C,0CAA0C,EAAA;;AAG5C;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,mBAAmB,EAAA;;AAGrB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC,EAAA;;AAGvC;EACE,kBAAkB;EAClB,gCzD7EkB,EAAA;;AyDgFpB;EACE,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCzD1FkB,EAAA;;AyD6FpB;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gCzD/FuB,EAAA;;AyDkGzB;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;;AAGb;EACE,kBAAkB;EAClB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,eAAe,EAAA;;AAGjB;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,2CAA2C;EAC3C,qCzDrIuB;EyDsIvB,czDjIiB;EyDkIjB,iBAAiB;EACjB,aAAa,EAAA;EAXf;IAcI,6BzDtIe,EAAA;EyDwHnB;IAkBI,sCzDrGiB;IyDsGjB,6CzDtGiB,EAAA;;AyD0GrB;EACE,cAAc;EACd,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,yCzDtJU;EyDuJV,mCzDvJU;EyDwJV,czDzJkB;EyD0JlB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,0DAA0D,EAAA;EAb5D;IAiBI,mCzDjKQ;IyDkKR,qCzDnKgB;IyDoKhB,aAAa,EAAA;;AAIjB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc,EAAA;;AAGhB;EACE,cAAc;EACd,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,czD9LuB;EyD+LvB,kCzDpLgB;EyDqLhB,2CAA2C,EAAA;;AAG7C;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB,EAAA;;AAGrB;EACE,sBAAsB;EACtB,8BAA8B,EAAA;;AAGhC;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;;EAEE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,+BzD1NuB,EAAA;;AyD6NzB;EACE,gCzDhOkB;EyDiOlB,gBAAgB,EAAA;;AAGlB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,+BzDtOuB,EAAA;;AyDyOzB;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,czD9OuB;EyD+OvB,kCzDpOgB;EyDqOhB,yCzDxOkB,EAAA;;AyD2OpB;EACE,mBAAmB,EAAA;;AAGrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B,EAAA;;AAG/B;EACE,+BAA+B,EAAA;EADjC;IAII,cAAc,EAAA;;AAIlB;EACE,kBAAkB,EAAA;EADpB;IAII,mBAAmB,EAAA;;AAIvB;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,MAAM;EACN,2BAA2B,EAAA;;AAG7B;EACE,2DAA2D,EAAA;;AAG7D;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY,EAAA;;AAGd;EACE,eAAe;EACf,qCzDzSkB;EyD0SlB,mBAAmB;EACnB,0CzD/PmB,EAAA;;AyDkQrB;EACE,qBAAqB;EACrB,qCzDhTkB;EyDiTlB,0CzDjTkB;EyDkTlB,mBAAmB,EAAA;;AAGrB;EACE,czDtTkB;EyDuTlB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB,EAAA;;AAGxB;EACE,SAAS;EACT,kBAAkB;EAClB,gCzD7TuB,EAAA;;AyDgUzB;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB,EAAA;EzD6Zd;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;;AyDxajE;EACE,WAAW;EACX,WAAW;EACX,qCAAqC,EAAA;EAErC;IACE,mBAAmB,EAAA;;AAIvB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB,EAAA;;AAGpB;EAEI,gCzDxWgB,EAAA;;AyD4WpB;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gCzDpXuB,EAAA;;AyDuXzB;EACE,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB,EAAA;;AAGxB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCzDzYkB,EAAA;;AyD4YpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCzDrZkB;EyDsZlB,kCzD9Vc;EyD+Vd,yBzDhWoB,EAAA;;AyDmWtB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gCzD5ZuB,EAAA;;AyD+ZzB;EACE,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB,EAAA;;AAGrB;EACE,eAAe;EACf,gBAAgB,EAAA;;AAGlB;EACE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,+BzDzYmB;EyD0YnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,0BAA0B,EAAA;EAT5B;IAaI,gCzD9bgB;IyD+bhB,aAAa,EAAA;;AAIjB;EACE,6CAA6C,EAAA;;AAO/C;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,yBzD/ckB;EyDgdlB,aAAa,EAAA;;AAGf;EACE,kBAAkB;EAClB,uBAAuB,EAAA;;AAGzB;EACE,WAAW,EAAA;;AAGb;EACE,YAAY;EACZ,wBAAwB,EAAA;;AAG1B;EACE,yBzD1dU;EyD2dV,czDpeuB;EyDqevB,YAAY;EACZ,wBAAwB,EAAA;EAJ1B;IAOI,yBzDjegB,EAAA;;AyDqepB;EACE,aAAa,EAAA;;AAOf;EAldA;IAodI,0BAA0B;IAC1B,oBAAoB;IACpB,oBAAoB,EAAA;EAvcxB;IA2cI,mBAAmB,EAAA;EA1TvB;IA8TI,qBAAqB,EAAA;EAxTzB;IA4TI,iBAAiB;IACjB,qBAAqB,EAAA;EA/QzB;IAmRI,WAAW;IACX,uBAAuB,EAAA;EA/K3B;IAmLI,sBAAsB;IACtB,oBAAoB,EAAA;EAhNxB;IAoNI,0BAA0B,EAAA;EA3P9B;IA+PI,0BAA0B,EAAA;EAG5B;IACE,qBAAqB,EAAA;EAlLzB;IAsLI,WAAW;IACX,oBAAoB,EAAA;IAFtB;MAKI,WAAW;MACX,uBAAuB,EAAA;EAjZ7B;IAsZI,eAAe,EAAA;E9CtHnB;I8C0HI,YAAY,EAAA;EAGd;IACE,aAAa,EAAA;EArEjB;IAyEI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB,EAAA;IAJrB;MAOI,czDtjBkB;MyDujBlB,mBAAmB;MACnB,yBAAyB,EAAA;IAT7B;MAaI,yBzD1jBc;MyD2jBd,czDnkBmB;MyDokBnB,WAAW;MACX,YAAY;MACZ,gBAAgB;MAChB,mBAAmB;MACnB,YAAY;MACZ,yBAAyB;MACzB,8BAA8B,EAAA;EAIlC;IACE,yBzD/kBqB;IyDglBrB,WAAW;IACX,aAAa;IACb,4BAA4B,EAAA;EAG9B;IACE,yBzDllBU;IyDmlBV,WAAW;IACX,aAAa;IACb,4BAA4B,EAAA;IAJ9B;MAOI,czD5lBmB,EAAA;IyDqlBvB;MAWI,aAAa,EAAA;IAXjB;MAeI,cAAc,EAAA,EACf;;AzDjoBL;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;A0Dn8BA;EACE,YAAY,EAAA;EADd;;IAKI,iBAAiB,EAAA;EALrB;IASI,gC1DcgB;I0DbhB,sBAAsB,EAAA;EAV1B;IAcI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS,EAAA;;AAIb;EACE,6CAA6C,EAAA;EAD/C;IAII,2C1DPgB;I0DQhB,WAAW,EAAA;EALf;IASI,WAAW;IACX,cAAc;IACd,eAAe;IACf,WAAW;IACX,WAAW;IACX,qCAAqC,EAAA;;AAIzC;EACE,gC1DtBkB,EAAA;;A0DyBpB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,sBAAsB,EAAA;;AAGxB;EACE,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAA;;AAGnB;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,yCAAyC,EAAA;;AAG3C;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,8DAA8D;EAC9D,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,kCAAkC;EAClC,0CAA0C;EAC1C,0CAA0C,EAAA;;AAG5C;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,gBAAgB,EAAA;;AAGlB;EACE,YAAY,EAAA;EADd;IAII,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB,EAAA;;AAIvB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,gC1D7GkB,EAAA;;A0DgHpB;EACE,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gC1D1HkB,EAAA;;A0D6HpB;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gC1D/HuB,EAAA;;A0DkIzB;EACE,YAAY,EAAA;;AAGd;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gC1D5IkB;E0D6IlB,sBAAsB,EAAA;;AAGxB;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gC1DlJuB,EAAA;;A0DqJzB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB,EAAA;;AAGrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B,EAAA;;AAG/B;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,SAAS,EAAA;EAJX;IAOI,WAAW;IACX,YAAY;IAEZ,qCAAA,EAAsC;IAV1C;MAYM,mBAAmB,EAAA;EAZzB;IAiBI,0CAAA;IAcA,4CAAA,EAA6C;IA/BjD;MAmBM,gC1D1Lc;M0D2Ld,kBAAkB;MAClB,yBAAyB;MACzB,sBAAsB,EAAA;IAtB5B;MA0BM,gC1D/LmB;M0DgMnB,iBAAiB;MACjB,oBAAoB,EAAA;IA5B1B;MAiCM,2C1DtMmB;M0DuMnB,c1DlMa;M0DmMb,kBAAkB;MAClB,2CAA2C,EAAA;;AAKjD;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,eAAe,EAAA;;AAGjB;EAhKA;IAkKI,0BAA0B;IAC1B,oBAAoB,EAAA;EAnExB;IAuEI,qBAAqB,EAAA;IADvB;MAII,WAAW,EAAA,EACZ;;A1D5PL;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;A2Dn8BA;EACE,YAAY,EAAA;EADd;;IAKI,iBAAiB,EAAA;EALrB;IASI,gC3DcgB;I2DbhB,sBAAsB,EAAA;EAV1B;IAcI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS,EAAA;;AAIb;EACE,mBAAmB;EAEnB,6CAA6C,EAAA;EAH/C;IAMI,2C3DTgB;I2DUhB,WAAW,EAAA;EAPf;IAWI,WAAW;IACX,cAAc;IACd,eAAe;IACf,WAAW;IACX,WAAW;IACX,qCAAqC,EAAA;;AAIzC;EACE,gC3DxBkB,EAAA;;A2D2BpB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW,EAAA;;AAGb;EACE,sBAAsB;EACtB,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,kCAAkC;EAClC,0CAA0C;EAC1C,0CAA0C,EAAA;;AAG5C;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC,EAAA;;AAGvC;EACE,kBAAkB;EAClB,gC3DjEkB,EAAA;;A2DoEpB;EACE,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gC3D9EkB,EAAA;;A2DiFpB;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gC3DnFuB,EAAA;;A2DsFzB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;;AAGb;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,gDAAgD;EAChD,iBAAiB;EACjB,qBAAqB,EAAA;;AAGvB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gC3D/GkB,EAAA;;A2DkHpB;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,gC3DzHkB;E2D0HlB,sBAAsB,EAAA;;AAGxB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS,EAAA;;AAGX;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB,EAAA;EAHlB;IAMI,eAAe,EAAA;;AAInB;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,sDAAsD;EACtD,sDAAyD;EACzD,2BAA2B;EAC3B,eAAe,EAAA;;AAGjB;EACE,iDAAiD,EAAA;;AAGnD;EACE,c3D5JiB;E2D6JjB,iBAAiB,EAAA;;AAGnB;EACE,6B3DjKiB;E2DkKjB,kBAAkB,EAAA;;AAGpB;EACE,oCAAkC,EAAA;;AAGpC;EACE,yBAAuB;EACvB,uBAAuB,EAAA;;AAGzB;EACE,yBAA4B,EAAA;;AAG9B;EACE,WAAW;EACX,kBAAkB;EAClB,2CAA2C;EAC3C,kCAAkC;EAClC,2CAA2C,EAAA;;AAG7C;EACE,YAAY,EAAA;;AAGd;EACE,gC3DpMuB;E2DqMvB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe,EAAA;;AAGjB;EACE,+CAA+C,EAAA;;AAGjD;EACE,+CAA+C;EAC/C,c3DlNkB,EAAA;;A2DqNpB;EACE,c3D/MiB,EAAA;;A2DkNnB;EACE,yBAA4B,EAAA;;AAG9B;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,SAAS;EACT,c3D1NU;E2D2NV,iBAAiB,EAAA;;AAGnB;EACE,SAAS;EACT,+B3D3OkB;E2D4OlB,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;E3DiEhB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,6DAA6D,EAAA;EAE7D;IACE,UAAU,EAAA;EAGZ;IACE,+BAA+B;IAC/B,oBAAoB,EAAA;EAGtB;IACE,mCAzRiB;IA0RjB,oBAAoB;IACpB,2CAA2C,EAAA;EAG7C;IACE,oCA/RiB,EAAA;;A2D6MrB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,2C3DjQkB;E2DkQlB,iCAAiC;EACjC,c3DnQkB;E2DoQlB,eAAe;EACf,gBAAgB,EAAA;;AAGlB;EACE,uC3DzQkB,EAAA;;A2D4QpB;EACE,sC3DlOkB;E2DmOlB,8C3DnOkB,EAAA;;A2DsOpB;EACE,uCAAuC,EAAA;;AAGzC;EACE,aAAa;EACb,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,yCAAyC,EAAA;;AAG3C;EACE,c3DlRa;E2DmRb,iCAAiC,EAAA;;AAGnC;EACE,c3DhPkB;E2DiPlB,iCAAiC,EAAA;;AAGnC;EACE,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,iBAAiB,EAAA;;AAGnB;EACE,gBAAgB;EAChB,yC3DxSa;E2DySb,mC3DzSa;E2D0Sb,c3DpUkB;E2DqUlB,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe,EAAA;;AAGjB;EACE,mC3DnTa;E2DoTb,oC3DpTa,EAAA;;A2DuTf;EACE,aAAa;EACb,mBAAmB,EAAA;;AAGrB;EACE,SAAS;EACT,iBAAiB;EACjB,gC3DzVkB,EAAA;;A2D4VpB;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,qDAA6D;EAC7D,oBAAoB,EAAA;;AAGtB;EACE,yFAAqF,EAAA;;AAGvF;EACE,iCAAiC,EAAA;;AAGnC;EACE,oEAIC,EAAA;;AAGH;;EAEE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,UAAU,EAAA;;AAGZ;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB,EAAA;;AAGtB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB,EAAA;;AAGtB;;;EAGE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB,EAAA;;AAGtB;EACE,2KAE+E;EAC/E,+EAA+E,EAAA;;AAGjF;EACE;IAAO,aAAa;IAAE,mBAAmB,EAAA;EACzC;IAAK,YAAY;IAAE,sBAAsB,EAAA,EAAA;;AAG3C;EACE,kBAAkB;EAClB,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB;EAClB,gC3DlbkB,EAAA;;A2DqbpB;EACE,mBAAmB;EACnB,gBAAgB,EAAA;;AAGlB;EACE,WAAW;EACX,gBAAgB,EAAA;;AAGlB;EA1VA;IA4VI,0BAA0B,EAAA;EAtT9B;IA0TI,eAAe;IACf,WAAW;IACX,gBAAgB,EAAA;EApUpB;IAwUI,oBAAoB;IACpB,sBAAsB,EAAA;EAGxB;IACE,0BAA0B,EAAA;EAtB9B;IA0BI,eAAe,EAAA,EAChB;;A3D/eH;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;A4Dr8BA;EACI,c5D2BgB;E4D1BhB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB,EAAA;;AAGtB;EACI,c5DmBqB;E4DlBrB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB,EAAA;;AAGpB;EACI,c5DWqB;E4DVrB,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB,EAAA;;AAGrB;EACI,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,YAAY,EAAA;;AAGhB;EACI,iBAAiB;EACjB,a5D0jBe;E4DzjBf,eAAe;EACf,4BAA4B,EAAA;EAJhC;IAQQ,a5DqjBc;I4DpjBd,6BAA6B,EAAA;;AAIrC;EACI,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EAAE,wDAAA;EAErB,eAAe;EACf,YAAY,EAAA;;AAGhB;EAEI,aAAa;EACb,iBAAiB;EAEjB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,iCAAiC;EACjC,0CAA0C;EAC1C,YAAY,EAAA;;ANThB;EMcI,kBAAkB;EAClB,c5D3CqB;E4D4CrB,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,gC5D9CgB,EAAA;EsDmChB;IMcI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,YAAY;IACZ,WAAW;IACX,yB5DvDY,EAAA;;A4D2DpB;EAEI,sBAAsB,EAAA;;ANN1B;;EMWI,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,WAAW;EAEX,mBAAmB,EAAA;ENjBvB;IMoBQ,c5D5EiB;I4D6EjB,YAAY;IACZ,kBAAkB,EAAA;ENtB1B;IM0BQ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB,EAAA;;AAI1B;EACI,YAAY;EACZ,oBAAoB,EAAA;;AAIxB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B,EAAA;;AAGhC;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,qBAAqB;EACrB,iBAAiB;EAEjB,mB5DvGiB;E4DwGjB,c5D5GkB;E4D6GlB,yB5D7GkB;E4D8GlB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,WAAW,EAAA;;AAGb;EACE,mBAAmB,EAAA;;AAGrB;EACE,c5DnHkB,EAAA;;A4DsHpB;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,0EAAA;EACA,oBAAoB,EAAA;;AAGtB;EACE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAYhB;;;I7D424DE,E6Dz24DC;EAxBL;IAYI,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,yB5D7Ge;I4D8Gf,kBAAkB;IAClB,mB5D1GoB;I4D2GpB,gBAAgB,EAAA;EAlBpB;IA0BI,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B,EAAA;EA5B9B;IAgCI,yBAAyB;IACzB,WAAW;IACX,0BAA0B;IAC1B,YAAY,EAAA;EAGd;IAtCF;MAuCI,eAAe,EAAA;MAvCnB;;QA2CM,cAAc;QACd,WAAW;QACX,eAAe,EAAA,EAChB;;AAIL;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,yB5DxJiB;E4DyJjB,kBAAkB;EAClB,mB5DrJsB;E4DsJtB,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,YAAY,EAAA;EARd;IAWI,c5DnNuB;I4DoNvB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB,EAAA;EAG3B;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS,EAAA;EAGX;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ,EAAA;EAGV;IACE,SAAS;IACT,iBAAiB;IACjB,yB5D1OiB;I4D2OjB,kBAAkB;IAClB,mB5DzOoB;I4D0OpB,c5D/OgB;I4DgPhB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,eAAe,EAAA;EAGjB;IACE,qB5D9MiB;I4D+MjB,mB5DzMqB;I4D0MrB,c5D1PqB,EAAA;E4D6PvB;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ,EAAA;EAGV;IACE,aAAa;IACb,eAAe;IACf,QAAQ,EAAA;EAGV;IACE,SAAS;IACT,iBAAiB;IACjB,yB5DzQiB;I4D0QjB,kBAAkB;IAClB,mB5DxQoB;I4DyQpB,c5D9QgB;I4D+QhB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe,EAAA;EAGjB;IACE,qB5D5OiB;I4D6OjB,mB5DvOqB;I4DwOrB,c5DxRqB,EAAA;E4D2RvB;IAEE,aAAa;IACb,eAAe,EAAA;EAGjB;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,SAAS;IACT,eAAe,EAAA;EAGjB;IACE,c5DxSuB;I4DySvB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB,EAAA;EAG3B;IACE,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,eAAe,EAAA;EAGjB;IACE,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,yB5D1TiB;I4D2TjB,kBAAkB;IAClB,mB5DzToB;I4D0TpB,c5D/TgB;I4DgUhB,kBAAkB;IAClB,gBAAgB,EAAA;EAGlB;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS,EAAA;EAGX;IACE,c5DhVuB;I4DiVvB,kBAAkB,EAAA;EAGpB;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ,EAAA;EAGV;IACE,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,QAAQ;IACR,WAAW,EAAA;EAGb;IACE,gBAAgB;IAChB,iBAAiB;IACjB,c5DtWgB;I4DuWhB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB,EAAA;EAG3B;IACE,cAAc;IACd,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ,EAAA;EAGV;IACE,WAAW;IACX,SAAS;IACT,qB5DvXgB;I4DwXhB,eAAe,EAAA;EAGjB;IACE,gBAAgB;IAChB,iBAAiB;IACjB,c5D9XgB;I4D+XhB,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,iBAAiB,EAAA;EAGnB;IACE,c5DpYiB;I4DqYjB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB,EAAA;EAGrB;IACE,eAAe;IACf,c5D/YiB;I4DgZjB,kBAAkB,EAAA;IAHnB;MAMG,eAAe;MACf,gBAAgB;MAChB,yBAAyB;MACzB,c5DxZc,EAAA;E4D4ZlB;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,c5DhagB;I4DiahB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,eAAe,EAAA;EAGjB;IACE,oBAAoB;IACpB,c5DvaiB;I4DwajB,iBAAiB,EAAA;EAGnB;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,6B5DjbiB,EAAA;E4DobnB;IACE,c5DvbgB;I4DwbhB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB,EAAA;EAG3B;IACE,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ,EAAA;EAGV;IACE,WAAW;IACX,cAAc;IACd,UAAU;IACV,yB5DrciB;I4DscjB,kBAAkB;IAClB,mB5DpcoB;I4DqcpB,eAAe,EAAA;EAGjB;IACE,mBAAmB;IACnB,eAAe;IACf,QAAQ,EAAA;EAGV;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ,EAAA;EAGV;IACE,SAAS;IACT,c5DzdiB;I4D0djB,iBAAiB,EAAA;EAGnB;IACE,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,SAAS;IACT,c5DpegB;I4DqehB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe,EAAA;IAThB;MAYG,+CAA+C,EAAA;EAInD;IACE,gBAAgB;IAChB,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,yB5DlfiB;I4DmfjB,kBAAkB;IAClB,mB5DjfoB;I4DkfpB,c5DvfgB;I4DwfhB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe,EAAA;EAGjB;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ,EAAA;EAGV;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ,EAAA;EAGV;IACE,SAAS;IACT,iBAAiB;IACjB,yB5D1gBiB;I4D2gBjB,kBAAkB;IAClB,mB5DzgBoB;I4D0gBpB,c5D/gBgB;I4DghBhB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,eAAe,EAAA;EAGjB;IACE,qB5D9eiB;I4D+ejB,mB5DzeqB;I4D0erB,c5D1hBqB,EAAA;E4D6hBvB;IACE,SAAS;IACT,c5D5hBiB;I4D6hBjB,kBAAkB;IAClB,iBAAiB,EAAA;EAGnB;IACE,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,UAAU;IACV,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;IACZ,0BAAW;IACX,+BAA+B;IAC/B,gBAAgB;IAChB,oBAAoB,EAAA;EAGtB;IACE,SAAS;IACT,uBAAuB;IACvB,uC5DnjBiB;I4DojBjB,kBAAkB;IAClB,iC5DzgBe;I4D0gBf,gC5DzjBqB;I4D0jBrB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,sBAAsB,EAAA;EAGxB;IACE,qB5D1hBiB,EAAA;E4D6hBnB;IACE,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,yB5DzkBiB;I4D0kBjB,kBAAkB;IAClB,iC5D/hBe;I4DgiBf,c5D/kBqB;I4DglBrB,kBAAkB;IAClB,iBAAiB;IACjB,+CAA+C;IAC/C,qBAAqB;IACrB,cAAc,EAAA;EAGhB;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,gBAAgB,EAAA;EAGlB;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,yB5DnmBiB;I4DomBjB,kBAAkB;IAClB,iC5DzjBe;I4D0jBf,cAAc,EAAA;EAGhB;IACE,mBAAmB;IACnB,c5D7mBgB;I4D8mBhB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB,EAAA;EAG3B;IACE,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,mBAAmB;IACnB,c5DznBqB;I4D0nBrB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe,EAAA;EAGjB;IACE,kBAAkB;IAClB,c5DhoBgB;I4DioBhB,kBAAkB;IAClB,gBAAgB,EAAA;EAGlB;IACE,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,uBAAuB;IACvB,yB5DxoBiB;I4DyoBjB,kBAAkB;IAClB,mB5DvoBoB;I4DwoBpB,c5D9oBqB;I4D+oBrB,kBAAkB;IAClB,iBAAiB;IACjB,+CAA+C;IAC/C,qBAAqB,EAAA;EAGvB;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB,EAAA;IARnB;MAWG,iBAAiB;MACjB,YAAY;MACZ,sC5DxnBe;M4DynBf,kBAAkB,EAAA;IAdrB;MAkBG,mOAGmD,EAAA;IArBtD;MAyBG,WAAW;MACX,kBAAkB;MAClB,QAAQ;MACR,oBAAoB;MACpB,UAAU;MACV,8C5DprBc,EAAA;I4DspBjB;MAkCG,WAAW;MACX,kBAAkB;MAClB,SAAS;MACT,MAAM;MACN,UAAU;MACV,UAAU;MACV,WAAW;MACX,2BAA2B;MAC3B,oBAAoB;MACpB,4KAOC;MACD,wFAAwF;MACxF,gGAAgG;MAChG,sBAAsB,EAAA;IArDzB;MAyDG,WAAW;MACX,YAAY;MACZ,iBAAiB,EAAA;EAIrB;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,+B5D5tBgB,EAAA;I4DqtBjB;MAUG,YAAY;MACZ,WAAW;MACX,SAAS,EAAA;EAIb;IACE,SAAS;IACT,c5DruBgB;I4DsuBhB,iBAAiB,EAAA;EAGnB;IACE,c5DnuBgB,EAAA;E4DsuBlB;IACE,SAAS;IACT,6B5D7uBiB;I4D8uBjB,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB,EAAA;;AAIzB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,UAAU;EACV,gBAAgB,EAAA;EATlB;IAYI,c5DjwBuB;I4DkwBvB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB,EAAA;;AAI7B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EA0BZ,gEAAA,EAAiE;EAxBjE;IACE,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,YAAY,EAAA;EAGd;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS,EAAA;EAGX;IACE,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;IAChB,gBAAgB,EAAA;EAIlB;IACE,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B,EAAA;I5DxE9B;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;E4D6D/D;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,QAAQ;IACR,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB,EAAA;EAGlB;IACE,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,yB5DryBe;I4DsyBf,kBAAkB;IAClB,mB5D70BoB;I4D80BpB,c5Dn1BgB,EAAA;E4Ds1BlB;IACE,sC5D/yBgB;I4DgzBhB,iC5DzyBqB;I4D0yBrB,c5D11BqB,EAAA;E4D61BvB;IACE,aAAa;IACb,0C5Dh2BgB;I4Di2BhB,UAAU,EAAA;EAGZ;IACE,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,c5Dx2BuB;I4Dy2BvB,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;IACd,YAAY,EAAA;EAGd;IACE,gBAAgB,EAAA;EAGlB;IACE,YAAY;IACZ,eAAe,EAAA;EAGjB;IACE,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,SAAS;IACT,cAAc;IACd,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,eAAe,EAAA;EAGjB;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yB5Dl2Be;I4Dm2Bf,mB5D/1BqB,EAAA;I4Dy1BtB;MASG,WAAW;MACX,cAAc;MACd,WAAW;MACX,YAAY;MACZ,mB5Dp5BqB;M4Dq5BrB,sBAAsB;MACtB,qBAAqB;MACrB,oBAAoB;MACpB,8BAA8B;MAC9B,6BAA6B;MAC7B,4BAA4B;MAC5B,oDAA2C;MAC3C,4DAAmD,EAAA;EAIvD;IACE,aAAa;IACb,cAAc;IACd,YAAY;IACZ,sBAAsB;IACtB,QAAQ,EAAA;EAGV;IACE,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB,EAAA;EAGrB;IACE,c5Dl7BuB;I4Dm7BvB,kBAAkB,EAAA;EAGpB;IACE,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,QAAQ,EAAA;EAGV;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,eAAe,EAAA;EAGjB;IAEE,oC5Dr6BiB,EAAA;E4Dw6BnB;IAEE,mC5D58BgB,EAAA;E4D+8BlB;IACE,aAAa;IACb,eAAe,EAAA;EAGjB;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mB5D/9BgB;I4Dg+BhB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAClB,8BAA8B;IAC9B,6BAA6B;IAC7B,0BAA0B,EAAA;EAG5B;IACE,oDAAkD;IAClD,4DAA0D,EAAA;EAG5D;IACE,mB5Dv+BgB;I4Dw+BhB,oDAA6C;IAC7C,4DAAqD,EAAA;EAGvD;IACE,WAAW;IACX,YAAY;IACZ,mB5D98BgB;I4D+8BhB,oDAA2C;IAC3C,4DAAmD,EAAA;EAGrD;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,WAAW;IACX,SAAS;IACT,iBAAiB;IACjB,yB5D39BgB;I4D49BhB,kBAAkB;IAClB,uBAAuB;IACvB,c5D99BgB;I4D+9BhB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,eAAe,EAAA;EAGjB;IACE,aAAa;IACb,eAAe,EAAA;EAGjB;IACE,SAAS;IACT,c5DphCuB;I4DqhCvB,kBAAkB,EAAA;EAGpB;IACE,oBAAoB;IACpB,gBAAgB,EAAA;EAGlB;IACE,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,mB5DhiCiB;I4DiiCjB,8DAA8D,EAAA;EAGhE;IACE,UAAU;IACV,YAAY,EAAA;EAGd;IACE,UAAU;IACV,WAAW;IACX,eAAe;IACf,YAAY,EAAA;EAGd;IACE,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,yB5D7gCe;I4D8gCf,kBAAkB;IAClB,mB5DrjCoB;I4DsjCpB,c5D5jCqB;I4D6jCrB,kBAAkB;IAClB,kBAAkB,EAAA;EAGpB;IACE,aAAa;IACb,qB5DzhCiB,EAAA;E4D4hCnB;IACE,aAAa,EAAA;EAGf;IACE,SAAS;IACT,c5D1kCuB;I4D2kCvB,kBAAkB;IAClB,cAAc,EAAA;;AAIlB;EACE;;IAEE,YAAY,EAAA;EAEd;IACE,aAAa,EAAA,EAAA;;AAIjB;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8B5DnmCkB,EAAA;;A4DsmCpB;EACE,uBAAkC;EAClC,aAAa;EACb,yB5DrmCmB;E4DsmCnB,mBAAmB;EACnB,mB5DrmCiB;E4DsmCjB,0C5D5mCkB,EAAA;;A4D+mCpB;EACE,gBAAgB;EAChB,c5DhnCuB;E4DinCvB,eAAe;EACf,gBAAgB,EAAA;;AAGlB;EACE,SAAS;EACT,c5DtnCkB;E4DunClB,iBAAiB;EACjB,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB,EAAA;;AAGlB;EACE,SAAS;EACT,iBAAiB;EACjB,yB5DnoCmB;E4DooCnB,kBAAkB;EAClB,uBAAuB;EACvB,c5DzoCuB;E4D0oCvB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe,EAAA;;AAGjB;EACE,qB5DvmCmB,EAAA;;A4D0mCrB;EACE,qB5D7oCkB;E4D8oClB,c5D9oCkB,EAAA;;A4DipCpB;EACE,aAAa;EACb,eAAe,EAAA;;AAGjB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,YAAY,EAAA;EAEZ;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ,EAAA;EAGV;IACE,c5D5qCuB;I4D6qCvB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB,EAAA;EAG3B;IACE,aAAa;IACb,oDAAoD;IACpD,QAAQ;IACR,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,YAAY,EAAA;EAGd;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,0C5D7pCgB;I4D8pChB,kBAAkB;IAClB,kC5DlsCoB,EAAA;E4DqsCtB;IACE,SAAS;IACT,c5D7sCqB;I4D8sCrB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB,EAAA;EAG3B;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,YAAY,EAAA;EAGd;IACE,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,YAAY,EAAA;EAGd;IAhDA;MAkDI,qCAAqC,EAAA,EACtC;;AAIL;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,SAAS;EACT,0C5D5sCkB;E4D6sClB,kBAAkB;EAClB,kC5DjvCsB;E4DkvCtB,c5DvvCkB,EAAA;E4DyvClB;IACE,mBAAmB;IACnB,sC5DntCgB;I4DotChB,kC5DvvCoB,EAAA;E4D0vCtB;IACE,kC5DjtCqB,EAAA;E4DotCvB;IACE,sC5D5tCgB;I4D6tChB,kC5DttCqB;I4DutCrB,8C5D9tCgB,EAAA;E4DiuClB;IACE,oC5DxwCiB;I4DywCjB,iC5DtwCoB,EAAA;E4DywCtB;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,c5DpxCuB;I4DqxCvB,kBAAkB;IAClB,gBAAgB,EAAA;EAGlB;IACE,YAAY,EAAA;EAGd;IACE,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,yB5DvvCe;I4DwvCf,kBAAkB;IAClB,mB5D/xCoB;I4DgyCpB,c5DryCgB;I4DsyChB,aAAa;IACb,kBAAkB;IAClB,kBAAkB,EAAA;EAGpB;IACE,aAAa;IACb,kBAAkB,EAAA;EAGpB;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,MAAM;IACN,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,yBAAyB;IACzB,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,eAAe,EAAA;EAGjB;IACE,mBAAmB,EAAA;EAGrB;IACE,mBAAmB,EAAA;EAGrB;;IAEE,c5Dz0CiB,EAAA;E4D40CnB;IACE,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,c5Dt1CqB,EAAA;E4Dy1CvB;IACE,c5DjzCgB,EAAA;E4DozClB;IACE,cAAc;IACd,UAAU;IACV,YAAY;IACZ,aAAa;IACb,oC5DzzCgB,EAAA;E4D4zClB;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,UAAU;IACV,oBAAoB;IACpB,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB,EAAA;EAGxB;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,yB5D10Ce,EAAA;E4D60CjB;IACE,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,MAAM;IACN,YAAY;IACZ,gBAAgB,EAAA;EAGlB;IACE,gBAAgB;IAChB,c5Dp4CqB;I4Dq4CrB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB,EAAA;EAGrB;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,gBAAgB,EAAA;EAGlB;IACE,gBAAgB;IAChB,+B5D92CgB;I4D+2ChB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB,EAAA;EAGrB;IACE,c5Dv4CW;I4Dw4CX,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB,EAAA;EAG3B;IACE,c5Dp6CiB,EAAA;E4Du6CnB;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,yC5D94CgB;I4D+4ChB,kBAAkB;IAClB,c5Dz7CqB;I4D07CrB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc,EAAA;EAGhB;IACE,qB5Dx6CW;I4Dy6CX,c5Dz6CW,EAAA;E4D46Cb;IACE,qB5Dl8CiB;I4Dm8CjB,c5Dn8CiB,EAAA;E4Ds8CnB;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,UAAU;IACV,oBAAoB;IACpB,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB,EAAA;EAGxB;IACE,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,2BAA2B;IAC3B,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,c5Dl+CuB;I4Dm+CvB,iBAAiB;IACjB,cAAc;IACd,eAAe,EAAA;EAGjB;IAEE,c5Dp+CgB;I4Dq+ChB,mC5Dr+CgB,EAAA;;A4Dy+CpB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,YAAY,EAAA;EAEZ;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,yB5Dx9CgB;I4Dy9ChB,kBAAkB;IAClB,uBAAuB;IACvB,c5D39CgB;I4D49ChB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,eAAe,EAAA;EAGjB;IACE,gBAAgB;IAChB,qB5DtgDgB;I4DugDhB,c5DvgDgB;I4DwgDhB,kBAAkB,EAAA;EAGpB;IACE,aAAa;IACb,eAAe,EAAA;;AAInB;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8B5DhiDkB,EAAA;;A4DmiDpB;EACE,uBAAkC;EAClC,aAAa;EACb,yB5Dz/CiB;E4D0/CjB,kBAAkB;EAClB,mB5DliDiB;E4DmiDjB,0C5DziDkB,EAAA;;A4D4iDpB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB,EAAA;;AAGrB;EACE,SAAS;EACT,c5DrjDuB;E4DsjDvB,kBAAkB;EAClB,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,c5DpkDkB;E4DqkDlB,iBAAiB;EACjB,cAAc;EACd,eAAe,EAAA;;AAGjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,yB5DtiDiB;E4DuiDjB,kBAAkB;EAClB,mB5D9kDsB,EAAA;;A4DilDxB;EACE,gBAAgB;EAChB,c5DzlDuB;E4D0lDvB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,yB5D3lDkB;E4D4lDlB,kBAAkB;EAClB,uBAAuB;EACvB,c5D9lDkB;E4D+lDlB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe,EAAA;;AAGjB;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW,EAAA;;AAGb;EACE,kBAAkB;EAClB,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,mB5DvnDsB;E4DwnDtB,yB5DllDiB;E4DmlDjB,kBAAkB;EAClB,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,c5DxoDkB;E4DyoDlB,mB5D1lDuB,EAAA;;A4D6lDzB;EACE,cAAc;EACd,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,mB5DnpDsB;E4DopDtB,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,c5D7pDuB;E4D8pDvB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB,EAAA;;AAGpB;EACE,aAAa,EAAA;;AAGf;EACE,eAAe;EACf,c5DxqDyB;E4DyqDzB,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,kC5DnrDsB;E4DorDtB,yB5D9oDiB;E4D+oDjB,kBAAkB;EAClB,2CAA2C,EAAA;E5Dj9BzC;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;;A4Ds8BjE;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,kDAAkD,EAAA;EALpD;IAQI,mBAAmB,EAAA;EARvB;IAYI,0C5DlqDiB,EAAA;E4DspDrB;IAgBI,2CAA2C,EAAA;EAhB/C;IAoBI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,iBAAiB,EAAA;EAzBrB;IA6BI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;IACf,uBAAuB;IACvB,mBAAmB,EAAA;EAlCvB;IAsCI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;IACf,uBAAuB;IACvB,mBAAmB,EAAA;;AAIvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW,EAAA;EAJb;IAOI,WAAW;IACX,gBAAgB,EAAA;;AAIpB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ,EAAA;;AAGV;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,WAAW,EAAA;;AAGb;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY,EAAA;;AAGd;EACE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB,EAAA;E5DljChB;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;;A4DuiCjE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe,EAAA;EAbjB;IAiBI,mC5DxwDiB;I4DywDjB,sC5DzwDiB,EAAA;E4DuvDrB;IAsBI,mBAAmB;IACnB,YAAY,EAAA;;AAIhB;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe,EAAA;;AAGjB;EACE,gCAAgC;EAChC,eAAe,EAAA;;AAGjB;EACE,cAAc,EAAA;;AAGhB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,eAAe,EAAA;;AAGjB;EACE,gCAAgC,EAAA;;AAGlC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB,EAAA;;AAGpB;EACE,SAAS;EACT,+BAA+B;EAC/B,eAAe;EACf,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,2DAA2D;EAC3D,aAAa;EACb,SAAS,EAAA;EAJX;;IAQI,YAAY;IACZ,SAAS;IACT,eAAe;IACf,iBAAiB,EAAA;EAXrB;IAeI,gCAAgC,EAAA;EAfpC;IAmBI,gCAAgC;IAChC,uBAAuB,EAAA;;AAI3B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB,EAAA;EAJxB;IAOI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY,EAAA;EAVhB;IAcI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,gBAAgB,EAAA;EAjBpB;IAqBI,aAAa;IACb,eAAe;IACf,cAAc;IACd,cAAc,EAAA;EAxBlB;IA4BI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB,EAAA;EAhCrB;IAoCI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,cAAc,EAAA;EAxClB;IA4CI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,cAAc,EAAA;EAjDlB;IAqDI,aAAa,EAAA;EArDjB;IAyDI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB,EAAA;EA5DpB;IAgEI,gC5Dz8DqB;I4D08DrB,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB,EAAA;EAnE7B;IAuEI,c5Dh9DqB;I4Di9DrB,iBAAiB;IACjB,gBAAgB,EAAA;EAzEpB;IA6EI,mBAAmB;IACnB,c5Dt9DgB;I4Du9DhB,iBAAiB,EAAA;EA/ErB;IAmFI,c5Dp9DgB,EAAA;E4Di4DpB;IAuFI,kCAAkC;IAClC,mBAAmB,EAAA;EAxFvB;IA4FI,YAAY;IACZ,gBAAgB,EAAA;EA7FpB;IAiGI,gC5D1+DqB;I4D2+DrB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB,EAAA;EArGvB;IAyGI,WAAW;IACX,eAAe,EAAA;EA1GnB;IA8GI,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB,EAAA;EAhHtB;IAoHI,c5D5/DgB;I4D6/DhB,kBAAkB;IAClB,qBAAqB,EAAA;EAtHzB;IA0HI,+BAA+B,EAAA;EA1HnC;;IA+HuB,UAAU,EAAA;EA/HjC;;IAgImB,SAAS,EAAA;EAhI5B;;IAiIwB,SAAS,EAAA;EAjIjC;;IAkIqB,UAAU,EAAA;EAlI/B;;IAmIsB,UAAU,EAAA;EAnIhC;;IAoI0B,UAAU,EAAA;EApIpC;;IAyII,iBAAiB,EAAA;EAzIrB;;IA8II,kBAAkB;IAClB,sBAAsB,EAAA;EA/I1B;;IAoJI,gBAAgB,EAAA;EApJpB;IAwJI,mBAAmB,EAAA;EAxJvB;IA4JI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,qBAAqB,EAAA;EAhKzB;IAoKI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,eAAe,EAAA;IAvKnB;MA0KM,kBAAkB;MAClB,c5DnjEc;M4DojEd,yBAAyB;MACzB,sBAAsB,EAAA;EA7K5B;IAkLI,WAAW;IACX,sBAAsB,EAAA;EAnL1B;IAuLI,wBAAwB;IACxB,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,c5DpkEqB,EAAA;E4Dy4DzB;IA+LI,mBAAmB;IACnB,oBAAoB;IACpB,c5DzkEgB,EAAA;;A4D6kEpB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kC5D/kEsB;E4DglEtB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAkC;EAClC,4BAAuC;EACvC,mBAAmB;EACnB,0C5DrjEmB;E4DsjEnB,0F5DjjEiB;E4DojEjB,0CAA0C;EAC1C,gBAAgB;EAChB,c5DrmEuB,EAAA;;A4DwmEzB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,iD5DpkEmB,EAAA;;A4DukErB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,c5DvnEuB,EAAA;;A4D0nEzB;EACE,SAAS;EACT,uBAAuB;EACvB,c5D5nEkB;E4D6nElB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,uBAAuB,EAAA;EAPzB;IAUI,c5DpoEqB,EAAA;;A4DwoEzB;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,8C5D3mEmB,EAAA;;A4D8mErB;EACE,c5DxpEkB;E4DypElB,kBAAkB,EAAA;;AAGpB;EAEI,4BAAuC,EAAA;;AAF3C;EAMI,c5DnqEqB,EAAA;E4D6pEzB;IASM,gC5DtqEmB,EAAA;E4D6pEzB;IAaM,c5D1qEmB,EAAA;;A4D6pEzB;;EAmBmB,UAAU,EAAA;;AAnB7B;;EAoBmB,UAAU,EAAA;;AApB7B;;EAqBmB,UAAU,EAAA;;AArB7B;EAyBI,c5DrrEgB,EAAA;;A4D4pEpB;EA6BI,c5DzrEgB,EAAA;;A4D4pEpB;EAiCI,c5DtrEgB,EAAA;;A6DrCpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW,EAAA;;AAGb;;;EAGE,aAAa;EACb,eAAe;EACf,QAAQ,EAAA;;AAGV;;;EAGE,SAAS;EACT,iBAAiB;EACjB,yB7DYmB;E6DXnB,kBAAkB;EAClB,mB7DasB;E6DZtB,c7DOkB;E6DNlB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe,EAAA;;AAGjB;;;EAGE,qB7DqCmB;E6DpCnB,mB7D0CuB;E6DzCvB,c7DPuB,EAAA;;A6DUzB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ,EAAA;;AAGV;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,WAAW,EAAA;;AAGb;EACE,2BAA2B,EAAA;;AAG7B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,c7D9BkB;E6D+BlB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB,EAAA;;AAG3B;;;EAGE,cAAc;EACd,YAAY,EAAA;;AAGd;EACE,gBAAgB;EAChB,c7D5CyB;E6D6CzB,kBAAkB;EAClB,iBAAiB,EAAA;;AAGnB;EACE,SAAS;EACT,c7DnDyB;E6DoDzB,kBAAkB,EAAA;;AAGpB;EACE,c7DlDkB,EAAA;;A6DqDpB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS,EAAA;EAJX;IAOI,aAAa;IACb,QAAQ,EAAA;EARZ;IAYI,gBAAgB;IAChB,c7DzEgB;I6D0EhB,kBAAkB;IAClB,yBAAyB,EAAA;EAf7B;IAmBI,SAAS;IACT,c7DjFqB;I6DkFrB,kBAAkB,EAAA;;AAItB;EACE,SAAS;EACT,oBAAoB;EACpB,c7DxFkB;E6DyFlB,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mB7D9FmB,EAAA;;A6DiGrB;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,mB7DhEmB,EAAA;;A6DmErB;EACE,aAAa,EAAA;;AAGf;EACE,SAAS,EAAA;;AAGX;EACE,SAAS,EAAA;;AAGX;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,yB7D7HmB;E6D8HnB,kBAAkB;EAClB,mB7D5HsB;E6D6HtB,c7DlIkB;E6DmIlB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB,EAAA;;AAG3B;EACE,YAAY;EACZ,mBAAmB,EAAA;;AAGrB;EACE,c7D9IkB,EAAA;;AA7BpB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;A8Dp8BA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;EACtB,oBAAoB;EACpB,yG9DiEiB;E8D9DjB,0C9DyDmB;E8DxDnB,mBAAmB;EACnB,0EAEiC,EAAA;;AAGnC;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,gBAAgB,EAAA;;AAGlB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gC9DLuB,EAAA;;A8DQzB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW,EAAA;EAHb;IAMI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gC9D1BqB;I8D2BrB,mBAAmB,EAAA;EAZvB;IAgBI,WAAW,EAAA;EAhBf;IAoBI,iBAAiB;IACjB,uBAAuB;IACvB,0C9DKiB;I8DJjB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,c9DzCqB;I8D0CrB,iC9DKe,EAAA;I8DhCnB;MA8BM,2C9DHe;M8DIf,mBAAmB,EAAA;;AAKzB;EACE,cAAc,EAAA;;AAIhB;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB,EAAA;;AAGnB;EACE,WAAW,EAAA;;AAGb;EAEI,UAAU;EACV,gCAAgC,EAAA;EAHpC;IAMM,WAAW,EAAA;IANjB;MASQ,sC9DlCY;M8DmCZ,+EAEiC,EAAA;EAZzC;IAiBM,sC9DzCe,EAAA;;A8DwBrB;EAsBI,+CAA+C;EAC/C,sDAAsD;EACtD,8BAA8B;EAC9B,wBAAwB,EAAA;;AAzB5B;EA6BI,UAAU;EACV,aAAa;EACb,6BAA6B,EAAA;EA/BjC;IAkCM,2DAA2D;IAC3D,4DAA4D,EAAA;;AAnClE;;;EAyCI,UAAU,EAAA;;AAKd;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,0G9DzEkB;E8D4ElB,yC9DhFmB;E8DiFnB,mBAAmB;EACnB,wEAEgC;EAChC,wDAAwD,EAAA;EAf1D;IAkBI,sC9DxFiB,EAAA;;A8D4FrB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,4BAA4B;EAC5B,iD9DlGmB;E8DmGnB,YAAY,EAAA;EAPd;IAUI,gBAAgB,EAAA;;AAIpB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gC9DjKuB,EAAA;;A8DoKzB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gC9DzKuB,EAAA;;A8D4KzB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,qBAAqB,EAAA;;AAGvB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gC9DzLuB,EAAA;;A8D4LzB;EACE,iBAAiB;EACjB,wBAAwB;EACxB,0C9DrJmB;E8DsJnB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,c9DnMuB;E8DoMvB,iC9DrJiB;E8DsJjB,eAAe,EAAA;EATjB;IAYI,aAAa;IACb,mBAAmB,EAAA;EAbvB;IAiBI,2C9DnKiB;I8DoKjB,mBAAmB,EAAA;;AAIvB;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,gCAAgC,EAAA;;AAGlC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAA;;AAGnB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2C9DrMmB;E8DsMnB,mBAAmB;EACnB,iC9DlMiB,EAAA;;A8DqMnB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gC9DvPuB,EAAA;;A8D0PzB;EACE,kBAAkB;EAClB,gC9D5PuB,EAAA;;AUyVzB;EoDhDE,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAA;;AAGnB;EAxUA;IA0UI,sBAAsB;IACtB,oBAAoB,EAAA;EAzTxB;IA6TI,sBAAsB;IACtB,oBAAoB,EAAA;EAhLxB;IAoLI,sBAAsB;IACtB,oBAAoB,EAAA;EA/IxB;IAmJI,eAAe;IACf,yBAAyB,EAAA,EAC1B;;AAIH;;;EAII,oBAAoB;EACpB,oBAAoB;EACpB,YAAY;EACZ,oBAAoB;EACpB,0C9DnSiB;E8DoSjB,iC9D/Re;E8DgSf,+CAA+C,EAAA;;AAVnD;;;EAcI,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,gC9DzVqB;E8D0VrB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,0EAA0E,EAAA;EA3B9E;;;IA8BM,c9DnWmB;I8DoWnB,kC9DjWe,EAAA;E8DkUrB;;;IAmCM,c9DxWmB;I8DyWnB,oFAAqF;IACrF,8C9DhUe,EAAA;;A8D2RrB;;;EA0CI,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gC9DlXqB;E8DmXrB,mBAAmB,EAAA;;AA9CvB;;;EAkDI,gBAAgB;EAChB,c9D/WQ;E8DgXR,kBAAkB,EAAA;;AAKtB;;EAGI,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,YAAY,EAAA;;AAPhB;;EAWI,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,SAAS;EACT,UAAU;EACV,gBAAgB,EAAA;;AAjBpB;;EAqBI,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,oBAAoB;EACpB,yC9DhZgB;E8DiZhB,kC9D9Yc,EAAA;;A8DmXlB;;EA+BI,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gC9DjaqB,EAAA;;A8D8XzB;;EAuCI,kBAAkB;EAClB,gBAAgB;EAChB,c9D/ZgB;E8DgahB,mBAAmB,EAAA;;AA1CvB;;EA8CI,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,0C9DrYiB;E8DsYjB,iC9DjYe,EAAA;E8D+UnB;;IAqDM,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,yBAAyB,EAAA;EAxD/B;;IA2DmB,YAAY,EAAA;EA3D/B;;IA4DqB,WAAW,EAAA;EA5DhC;;IA6DyB,aAAa,EAAA;EA7DtC;;IA8D0B,aAAa,EAAA;EA9DvC;;IA+DuB,aAAa,EAAA;EA/DpC;;IAmEQ,2BAA2B;IAC3B,sBAAsB;IACtB,c9DlcY;I8DmcZ,yBAAyB;IACzB,gC9DjcM;IAglBZ,mHAAiF;IACjF,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B,EAAA;E8DzN7B;;IA4EQ,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,c9DldY;I8DmdZ,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB,EAAA;IA3F3B;;MA8FU,WAAW;MACX,kBAAkB;MAClB,QAAQ;MACR,QAAQ;MACR,2BAA2B;MAC3B,UAAU;MACV,WAAW;MACX,yB9D/dI,EAAA;;A8D0Xd;;EA4GI,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;E9DlYpB,qBAAqB;EACrB,8DA7DiB,EAAA;EA+DjB;;IACE,UAAU,EAAA;EAGZ;;IACE,iCApEe;IAqEf,oBAAoB,EAAA;EAGtB;;IACE,oCA9EiB;IA+EjB,oBAAoB,EAAA;IAEpB;;MACE,oCAlFe,EAAA;E8DoVrB;;IAmHM,aAAa,EAAA;;AAnHnB;;EAyHM,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,c9D1fmB;E8D2fnB,+C9Dxfe,EAAA;;A8D2XrB;;EAiIM,mBAAmB,EAAA;;AAjIzB;;;;;;;;EAwIM,kBAAkB,EAAA;;AAxIxB;;;;EA6IM,mBAAmB,EAAA;;AA7IzB;;EAiJM,kBAAkB;EAClB,kBAAkB;EAClB,gC9DjhBmB,EAAA;;A8D8XzB;;EAwJI,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY,EAAA;;AA3JhB;;EA+JI,gBAAgB,EAAA;;AA/JpB;;EAmKI,kBAAkB;EAClB,gC9DliBqB,EAAA;;A8D8XzB;;EAwKI,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY,EAAA;;AA3KhB;;EA+KI,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,cAAc,EAAA;;AAlLlB;;EAsLI,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,qC9DzjBqB,EAAA;;A8D8XzB;;EA+LI,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB,EAAA;;AAlMrB;;EAsMI,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB,EAAA;EA3MtB;;IA8MM,mB9DrjBe;I8DsjBf,+C9DtjBe,EAAA;E8DuWrB;;IAmNM,qC9DjlBmB;I8DklBnB,gBAAgB,EAAA;;AAMtB;;EAGI,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,WAAW,EAAA;;AANf;;EAUI,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,0C9D5jBiB;E8D6jBjB,iC9DxjBe;E8DyjBf,kBAAkB;EAClB,gBAAgB;EAChB,gC9D1mBqB;E8D2mBrB,mBAAmB,EAAA;EAnBvB;;IAsBM,sC9DvlBe;I8DwlBf,c9DxlBe,EAAA;;A8D8lBrB;EAEI,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,0C9DjlBiB;E8DklBjB,iC9D7kBe;E8D8kBf,gC9D7nBqB;E8D8nBrB,kBAAkB,EAAA;;AATtB;EAaI,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB,EAAA;;AAhBvB;EAoBI,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,0C9DnmBiB;E8DomBjB,yG9D/lBe;E8DkmBf,0EAEiC;EACjC,gBAAgB,EAAA;EA/BpB;IAkCM,mBAAmB,EAAA;;AAlCzB;EAuCI,6BAA6B;EAC7B,iD9DnnBiB,EAAA;;A8D2kBrB;EA4CI,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY,EAAA;;AA/ChB;EAmDI,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gC9D7qBqB,EAAA;;A8DqnBzB;EA4DI,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gC9DtrBqB,EAAA;;A8DqnBzB;EAqEI,OAAO;EACP,iBAAiB;EACjB,gCAAgC,EAAA;;AAvEpC;EA2EI,iBAAiB,EAAA;;AAGnB;EA9EF;IAgFM,0BAA0B,EAAA;EAhFhC;IAoFM,iBAAiB,EAAA,EAClB;;AAKL;EAEmB,aAAa,EAAA;;AAFhC;EAGqB,WAAW,EAAA;;AAHhC;EAI8B,cAAc,EAAA;;AAJ5C;EAKuB,aAAa,EAAA;;AALpC;EAMsC,aAAa,EAAA;;AANnD;EAOyB,WAAW,EAAA;;AAPpC;;;;;;EAgBI,kBAAkB,EAAA;;AAhBtB;EAoBI,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB,EAAA;EA5BvB;IA+BM,0C9DvtBe;I8DwtBf,qC9DxtBe;I8DytBf,c9DztBe,EAAA;E8DwrBrB;IAqCM,yC9D1sBe;I8D2sBf,oC9D3sBe;I8D4sBf,gC9DtvBmB,EAAA;;A8D+sBzB;EA4CI,+B9D3vBqB,EAAA;;A8D+sBzB;EAgDI,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,oBAAoB;EACpB,yC9D/sBY;E8DgtBZ,4HAKC;EACD,mBAAmB,EAAA;;AA7DvB;;EAkEI,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB,EAAA;;AArE7B;EAyEI,gC9DxxBqB,EAAA;;A8D+sBzB;EA6EI,c9DrwBiB,EAAA;;A8DwrBrB;EAiFI,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,sFAIC,EAAA;EA1FL;IA6FM,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,+BAA+B;IAC/B,2E9D7xBe;I8D8xBf,2BAA2B,EAAA;;AAtGjC;EA2GI,+B9D1zBqB,EAAA;;AA5BzB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;A+Dr8BA;EAEI,mBAAmB,EAAA;;AAIvB;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2C/D4DmB;E+D3DnB,iC/DgEiB;E+D/DjB,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,c/DSuB,EAAA;;A+DNzB;EACE,SAAS;EACT,iBAAiB;EACjB,gC/DGuB,EAAA;;A+DAzB;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,0C/DmCmB;E+DlCnB,yG/DuCiB;E+DpCjB,2CAA2C,EAAA;;AAG7C;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gC/DnBuB,EAAA;;A+DsBzB;EACE,SAAS;EACT,kCAAkC;EAClC,sCAAiD;EACjD,gBAAgB;EAChB,c/DLwB,EAAA;E+DA1B;IAQI,c/DtBgB,EAAA;;A+D0BpB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,c/DdmB,EAAA;;A+DiBrB;EACE,aAAa;EACb,oDAAoD;EACpD,YAAY,EAAA;;AAGd;EACE,wBAAwB;EACxB,mBAAmB;EACnB,0C/DPmB;E+DQnB,iC/DHiB,EAAA;;A+DMnB;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gC/D3DuB,EAAA;;A+D8DzB;EACE,kCAAkC;EAClC,kBAAkB;EAClB,c/DjEuB,EAAA;E+D8DzB;IAKY,c/D5CS,EAAA;E+DuCrB;IAMa,c/D5DO,EAAA;;A+D+DpB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,0C/DtCmB;E+DuCnB,iC/DlCiB,EAAA;;A+DqCnB;EACE,aAAa;EACb,eAAe;EACf,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY,EAAA;EAHd;IAMI,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,gC/DnGqB;I+DoGrB,mBAAmB,EAAA;EAVvB;IAcI,WAAW,EAAA;;AAIf;EACE,iBAAiB;EACjB,uBAAuB;EACvB,0C/DrEmB;E+DsEnB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,c/DnHuB;E+DoHvB,iC/DrEiB,EAAA;;A+DwEnB;EACE,aAAa;EACb,eAAe;EACf,WAAW,EAAA;EAHb;IAMI,eAAe;IACf,uBAAuB;IACvB,0C/DrFiB;I+DsFjB,kBAAkB;IAClB,kBAAkB;IAClB,c/DlIqB;I+DmIrB,iC/DpFe,EAAA;;A+DwFnB;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB,EAAA;EAElB;IAEE,gBAAgB,EAAA;EAGlB;IACE,kBAAkB;IAClB,cAAc,EAAA;;AAIlB;;EAEE,kBAAkB,EAAA;;AAGpB;EACE,sBAAsB,EAAA;;AAGxB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,0C/DvIkB;E+DwIlB,kBAAkB;EAClB,yH/DnIiB;E+DsIjB,c/D5IkB;E+D6IlB,eAAe;EACf,yCAAyC;EACzC,0DAA0D,EAAA;EAnB5D;IAuBI,sC/DnJgB;I+DoJhB,0CAA0C,EAAA;EAxB9C;IA4BI,2C/DxJgB;I+DyJhB,mBAAmB,EAAA;;AAIvB;EACE,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc,EAAA;;AAGhB;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,UAAU,EAAA;;AAGZ;EACE,yBAAyB;EACzB,WAAW;EACX,OAAO;EACP,uCAAkD;EAClD,UAAU,EAAA;;AAGZ;EACE,UAAU;EACV,QAAQ,EAAA;;AAGV;EACE,YAAY;EACZ,aAAa,EAAA;;AAGf;EACE,MAAM;EACN,cAAc,EAAA;;AAGhB;EACE,YAAY;EACZ,QAAQ,EAAA;;AAGV;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,UAAU;EACV,yCAAoD;EACpD,gCAAgC;EAChC,mBAAmB;EACnB,0C/DzNkB;E+D0NlB,yG/DpNiB;E+DuNjB,qFAE0C;EAC1C,gBAAgB,EAAA;EAEhB;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,cAAc,EAAA;;AAIlB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,8GAA6G,EAAA;;AAG/G;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB,EAAA;;AAGxB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,c/DzSuB;E+D0SvB,iBAAiB,EAAA;;AAGnB;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,qC/DpTuB;E+DqTvB,gC/DrTuB;E+DsTvB,eAAe;EACf,cAAc;EACd,eAAe,EAAA;EAXjB;IAcI,oC/DlRgB;I+DmRhB,c/D5TqB,EAAA;;A+DgUzB;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gC/DpUuB,EAAA;;A+DuUzB;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,gC/D5UuB,EAAA;E+DuUzB;IAQI,mBAAmB,EAAA;EARvB;IAYI,c/D1SgB,EAAA;;A+D8SpB;EACE,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,+C/DlTkB;E+DmTlB,oC/DlTmB;E+DmTnB,kBAAkB;EAClB,iBAAiB;EACjB,gC/D/VuB,EAAA;;A+DkWzB;;;EAGE,sBAAsB,EAAA;;AAGxB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;;AAGX;EACE,YAAY,EAAA;;AAGd;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;E/D3QlB,qBAAqB;EACrB,8DA7DiB,EAAA;EA+DjB;IACE,UAAU,EAAA;EAGZ;IACE,iCApEe;IAqEf,oBAAoB,EAAA;EAGtB;IACE,oCA9EiB;IA+EjB,oBAAoB,EAAA;IAEpB;MACE,oCAlFe,EAAA;;A+DgVrB;EACE,UAAU;EACV,gBAAgB,EAAA;EAFlB;IAKI,gBAAgB,EAAA;EALpB;IASI,aAAa,EAAA;;AAIjB;;EAEE,mBAAmB;EACnB,WAAW,EAAA;;AAGb;EACE,OAAO;EACP,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,eAAe;EACf,WAAW,EAAA;;AAGb;EACE,wBAAwB;EACxB,oBAAoB;EACpB,0C/DjXmB;E+DkXnB,kC/D3WsB;E+D4WtB,gC/D7ZuB;E+D8ZvB,kBAAkB;EAClB,eAAe;EACf,0DAA0D,EAAA;EAR5D;IAWI,sC/DzXiB;I+D0XjB,oC/D1XiB;I+D2XjB,c/DvagB,EAAA;;A+D2apB;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gC/D5auB,EAAA;E+DyazB;IAMI,c/D/aqB,EAAA;;A+DmbzB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,sBAAsB,EAAA;EANxB;IASI,SAAS;IACT,kBAAkB;IAClB,gC/D9bqB,EAAA;;A+DkczB;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gC/DtcuB,EAAA;;A+DyczB;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,sBAAsB,EAAA;EAEtB;IACE,gDAAgD,EAAA;;AAIpD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB,EAAA;;AAGxB;EACE,aAAa;EACb,eAAe;EACf,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,qBAAqB,EAAA;;AAGvB;EACE,eAAe,EAAA;;AAGjB;EACE,eAAe,EAAA;;AAGjB;;EAEE,WAAW;EACX,wBAAwB;EACxB,0C/D1cmB;E+D2cnB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,c/DxfuB;E+DyfvB,iC/D1ciB,EAAA;;A+D6cnB;EACE,aAAa;EACb,uBAAuB;EACvB,0BAA0B,EAAA;;AAG5B;EAGM,c/D5dc,EAAA;;A+DydpB;EAOM,gC/DzgBmB,EAAA;;A+D8gBzB;EACE,sBAAsB,EAAA;EAEtB;IACE,gBAAgB,EAAA;;AAIpB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gC/D3hBuB,EAAA;;A+D8hBzB;EACE,mBAAmB;EACnB,sBAAsB,EAAA;;AAGxB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gC/DxiBuB;E+DyiBvB,mBAAmB,EAAA;EANrB;IASI,qB/DlgBiB,EAAA;;A+DsgBrB;EACE,kBAAkB;EAClB,gC/DljBuB;E+DmjBvB,wBAAwB;EACxB,oBAAoB;EACpB,0C/D3gBmB;E+D4gBnB,oC/D5gBmB,EAAA;;A+D+gBrB;EACE,kCAAkC;EAClC,kBAAkB,EAAA;;AAGpB;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;E/DvdlB,qBAAqB;EACrB,8DA7DiB,EAAA;EA+DjB;IACE,UAAU,EAAA;EAGZ;IACE,iCApEe;IAqEf,oBAAoB,EAAA;EAGtB;IACE,oCA9EiB;IA+EjB,oBAAoB,EAAA;IAEpB;MACE,oCAlFe,EAAA;;A+D4hBrB;;EAEE,UAAU;EACV,gBAAgB,EAAA;;AAGlB;EAEI,aAAa,EAAA;;AAIjB;EAEI,gBAAgB,EAAA;;AAFpB;EAMI,aAAa,EAAA;;AAIjB;;;EAGE,mBAAmB;EACnB,WAAW,EAAA;;AAGb;;EAEsC,UAAU,EAAA;;AAFhD;;EAIsC,UAAU,EAAA;;AAJhD;;EAMsC,UAAU,EAAA;;AANhD;;EAQsC,UAAU,EAAA;;AARhD;;EAUsC,UAAU,EAAA;;AAGhD;;EAEsC,YAAY,EAAA;;AAFlD;;EAIsC,WAAW,EAAA;;AAJjD;;EAMsC,WAAW,EAAA;;AANjD;;EAQsC,YAAY,EAAA;;AARlD;;EAUsC,YAAY,EAAA;;AAVlD;;EAYsC,YAAY,EAAA;;AAZlD;;EAcsC,WAAW,EAAA;;AAGjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;;AAGX;EACE,YAAY,EAAA;;AAGd;EACE,mBAAmB;EACnB,0C/DnmBmB;E+DomBnB,yG/D/lBiB;E+DkmBjB,oBAAoB;EACpB,2CAA2C,EAAA;EAE3C;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB,EAAA;;AAIpB;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,gC/DhqBuB,EAAA;;A+DmqBzB;EACE,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,sBAAsB,EAAA;;AAGxB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,c/DrrBuB;E+DsrBvB,iBAAiB,EAAA;;AAGnB;EACE,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,gC/D7rBuB,EAAA;;A+DgsBzB;EACE,iBAAiB;EACjB,mBAAmB,EAAA;;AAGrB;EACE,SAAS;EACT,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,c/DjqBkB,EAAA;;A+DoqBpB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gC/DltBuB,EAAA;;A+DqtBzB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gC/DxtBuB,EAAA;;A+D2tBzB;EACE,mBAAmB;EACnB,oBAAoB;EACpB,8C/DprBmB,EAAA;;A+DurBrB;EAGM,c/D9sBoB,EAAA;;A+D2sB1B;EAOM,gC/DxuBmB,EAAA;;A+D6uBzB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0C/DtsBmB;E+DusBnB,yG/DlsBiB;E+DqsBjB,oBAAoB;EACpB,2CAA2C,EAAA;EAE3C;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB,EAAA;;AAIpB;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,gC/DnwBuB,EAAA;E+DqwBvB;IACE,+B/DjtBkB,EAAA;;A+DqtBtB;EACE,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,sBAAsB,EAAA;;AAGxB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,c/D5xBuB;E+D6xBvB,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gC/DnyBuB,EAAA;;A+DsyBzB;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,yBAAyB,EAAA;;AAG3B;EACE,iBAAiB;EACjB,iBAAiB,EAAA;;AAGnB;EACE,SAAS;EACT,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,c/DvzBuB,EAAA;E+DkzBzB;IAQI,c/DnyBiB,EAAA;E+D2xBrB;IAYI,c/DtzBgB,EAAA;;A+D0zBpB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gC/Dv0BuB,EAAA;;A+D00BzB;EACE,mBAAmB;EACnB,oBAAoB;EACpB,8C/DnyBmB,EAAA;;A+DsyBrB;EACE,qBAAqB,EAAA;;AAGvB;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gC/Dh2BuB,EAAA;;A+Dm2BzB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB,EAAA;;AAGrB;EACE,WAAW;EACX,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,gC/Dt3BuB;E+Du3BvB,iBAAiB;EACjB,cAAc;EACd,eAAe,EAAA;EAXjB;IAcI,c/D53BqB;I+D63BrB,oC/Dn1BiB,EAAA;;A+Du1BrB;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0C/Dn2BmB;E+Do2BnB,iC/D/1BiB;E+Dg2BjB,2CAA2C;E/DpyB3C,qBAAqB;EACrB,8DA7DiB,EAAA;EA+DjB;IACE,UAAU,EAAA;EAGZ;IACE,iCApEe;IAqEf,oBAAoB,EAAA;EAGtB;IACE,oCA9EiB;IA+EjB,oBAAoB,EAAA;IAEpB;MACE,oCAlFe,EAAA;;A+Dy2BrB;EACE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,c/Dz5BuB;E+D05BvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe,EAAA;EATjB;IAaI,oC/Dt3BiB,EAAA;;A+D03BrB;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gC/D96BuB,EAAA;E+Dg7BvB;IACE,+B/D53BkB,EAAA;;A+Dg4BtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;;AAGX;EACE,YAAY,EAAA;;AAGd;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;E/Dx1BlB,qBAAqB;EACrB,8DA7DiB,EAAA;EA+DjB;IACE,UAAU,EAAA;EAGZ;IACE,iCApEe;IAqEf,oBAAoB,EAAA;EAGtB;IACE,oCA9EiB;IA+EjB,oBAAoB,EAAA;IAEpB;MACE,oCAlFe,EAAA;;A+D65BrB;EACE,mBAAmB,EAAA;;AAGrB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,c/D/8BuB,EAAA;;A+Dk9BzB;EACE,kBAAkB;EAClB,gC/Dp9BuB;E+Dq9BvB,mBAAmB,EAAA;;AAGrB;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;E/Dj3BlB,qBAAqB;EACrB,8DA7DiB,EAAA;EA+DjB;IACE,UAAU,EAAA;EAGZ;IACE,iCApEe;IAqEf,oBAAoB,EAAA;EAGtB;IACE,oCA9EiB;IA+EjB,oBAAoB,EAAA;IAEpB;MACE,oCAlFe,EAAA;;A+Ds7BrB;EACE,UAAU;EACV,gBAAgB,EAAA;EAFlB;IAKI,gBAAgB,EAAA;EALpB;IASI,aAAa,EAAA;EATjB;;IAasC,UAAU,EAAA;EAbhD;;IAesC,UAAU,EAAA;EAfhD;;IAiBsC,UAAU,EAAA;EAjBhD;;IAmBsC,UAAU,EAAA;EAnBhD;;IAqBsC,UAAU,EAAA;;AAGhD;;EAEE,mBAAmB;EACnB,WAAW,EAAA;;AAGb;EACE,UAAU;EACV,gBAAgB,EAAA;EAFlB;IAKI,gBAAgB,EAAA;EALpB;IASI,aAAa,EAAA;;AAIjB;;EAEE,mBAAmB;EACnB,WAAW,EAAA;;AAGb;EAEI,gDAAgD,EAAA;;AAIpD;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0C/Dh/BmB;E+Di/BnB,yG/D5+BiB;E+D++BjB,oBAAoB;EACpB,2CAA2C,EAAA;EAE3C;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB,EAAA;;AAIpB;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,gC/D7iCuB,EAAA;;A+DgjCzB;EACE,SAAS;EACT,kBAAkB;EAClB,gC/DnjCuB,EAAA;;A+DsjCzB;EACE,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,sBAAsB,EAAA;;AAGxB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,c/DxkCuB;E+DykCvB,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gC/D/kCuB,EAAA;;A+DklCzB;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,yBAAyB,EAAA;;AAG3B;EACE,iBAAiB;EACjB,iBAAiB,EAAA;;AAGnB;EACE,SAAS;EACT,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,c/DnmCuB,EAAA;E+D8lCzB;IAQI,c/DhlCsB,EAAA;E+DwkC1B;IAYI,c/DrjCkB,EAAA;;A+DyjCtB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gC/DjnCuB,EAAA;;A+DonCzB;EACE,aAAa;EACb,gDAAgD;EAChD,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,8C/DhlCmB,EAAA;;A+DmlCrB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,gC/DroCuB,EAAA;;A+DwoCzB;EACE,kBAAkB;EAClB,c/D1oCuB,EAAA;;A+D6oCzB;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gC/DhpCuB;E+DipCvB,iBAAiB,EAAA;;AAGnB;EACE,mBAAmB;EACnB,oBAAoB;EACpB,8C/D7mCmB,EAAA;;A+DgnCrB;EACE,wBAAwB;EACxB,kBAAkB,EAAA;;AAGpB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gC/DnqCuB,EAAA;;A+DsqCzB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB,EAAA;;AAGrB;EACE,YAAY,EAAA;;AAGd;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;E/D1kClB,qBAAqB;EACrB,8DA7DiB,EAAA;EA+DjB;IACE,UAAU,EAAA;EAGZ;IACE,iCApEe;IAqEf,oBAAoB,EAAA;EAGtB;IACE,oCA9EiB;IA+EjB,oBAAoB,EAAA;IAEpB;MACE,oCAlFe,EAAA;;A+D+oCrB;;EAEE,UAAU;EACV,gBAAgB;EAChB,gBAAgB,EAAA;EAJlB;;;;IAQI,gBAAgB,EAAA;EARpB;;;;IAaI,aAAa,EAAA;;AAIjB;;;;EAIE,mBAAmB;EACnB,WAAW,EAAA;;AAGb;EACE,mBAAmB,EAAA;;AAGrB;;EAEE,oC/DnqCoB;E+DoqCpB,c/DpqCoB,EAAA;;A+DuqCtB;;EAEE,qC/DxsCwB;E+DysCxB,c/DzsCwB,EAAA;;A+D4sC1B;;EAEE,oC/D1rCmB;E+D2rCnB,c/D5rCkB,EAAA;;A+D+rCpB;;;EAGE,qC/D3uCuB;E+D4uCvB,gC/D5uCuB,EAAA;;A+D+uCzB;EACE,qC/D5rCyB;E+D6rCzB,c/D7rCyB,EAAA;;A+DgsC3B;;EAEsC,YAAY,EAAA;;AAFlD;;EAIsC,YAAY,EAAA;;AAJlD;;EAMsC,WAAW,EAAA;;AANjD;;EAQsC,YAAY,EAAA;;AARlD;;EAUsC,YAAY,EAAA;;AAVlD;;EAYsC,YAAY,EAAA;;AAZlD;;EAcsC,WAAW,EAAA;;AAGjD;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gC/D5wCuB;E+D6wCvB,wC/D1wCmB;E+D2wCnB,kC/D7tCsB,EAAA;;A+DguCxB;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,c/D9wCkB;E+D+wClB,yC/D/wCkB;E+DgxClB,mC/D/wCU,EAAA;;A+DkxCZ;EACE,aAAa,EAAA;;AAGf;EACE,sC/DzwCmB;E+D0wCnB,mC/DzwCa,EAAA;;A+D4wCf;EACE,sC/D3vCmB;E+D4vCnB,oC/D5vCmB,EAAA;;A+D+vCrB;;;EAGE,sC/D3yCkB;E+D4yClB,kC/D1yCmB,EAAA;;A+D6yCrB;;;EAGE,qC/DzwCmB;E+D0wCnB,oC/D1wCmB,EAAA;;A+D6wCrB;EACE,uC/DvzCkB,EAAA;;A+D0zCpB;EACE,uC/DryCmB;E+DsyCnB,kC/DryCa,EAAA;;A+DwyCf;EACE,qC/DzzCkB;E+D0zClB,mC/DzzCU,EAAA;;A+D4zCZ;EACE,oC/Dn0CmB,EAAA;;A+Ds0CrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;;AAGX;EACE,iBAAiB,EAAA;;AAGnB;EACE,YAAY,EAAA;EADd;IAII,UAAU;IACV,gBAAgB,EAAA;EALpB;IASI,mBAAmB;IACnB,WAAW,EAAA;EAVf;IAcI,gBAAgB,EAAA;IAdpB;MAiBM,aAAa,EAAA;EAjBnB;IAsBI,aAAa,EAAA;EAtBjB;IA0BI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,8D/Dn0Ce,EAAA;I+DoyCnB;MAkCM,UAAU,EAAA;IAlChB;MAsCM,iC/D10Ca;M+D20Cb,oBAAoB,EAAA;IAvC1B;MA2CM,oC/Dp1Ce;M+Dq1Cf,oBAAoB,EAAA;MA5C1B;QA+CQ,oC/Dx1Ca,EAAA;E+DyyCrB;IAqDI,YAAY,EAAA;EArDhB;IAyDI,YAAY,EAAA;EAzDhB;IA6DI,YAAY,EAAA;EA7DhB;IAiEI,WAAW,EAAA;EAjEf;IAqEI,YAAY,EAAA;EArEhB;IAyEI,WAAW,EAAA;EAzEf;IA6EI,WAAW,EAAA;EA7Ef;;IAkFI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB,EAAA;;AAIvB;EACE,eAAe,EAAA;EADjB;IAII,oC/Dr4CiB;I+Ds4CjB,kD/Dt4CiB,EAAA;E+Di4CrB;IASI,2C/D14CiB;I+D24CjB,oBAAoB,EAAA;;AAIxB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,eAAe,EAAA;;AAGjB;EACE,mBAAmB;EACnB,0C/D55CmB;E+D65CnB,yG/Dx5CiB;E+D25CjB,oBAAoB;EACpB,2CAA2C,EAAA;EAE3C;IACE,iBAAiB;IACjB,gBAAgB,EAAA;EAGlB;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB,EAAA;;AAItB;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,gC/D99CuB;E+D+9CvB,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,sBAAsB,EAAA;;AAGxB;EACE,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,iD/Dv8CmB,EAAA;;A+D08CrB;EACE,YAAY,EAAA;;AAGd;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB,EAAA;;AAGrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,c/D//CkB;E+DggDlB,yC/DhgDkB;E+DigDlB,mC/DhgDU,EAAA;;A+DmgDZ;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY,EAAA;;AAGd;EACE,wBAAwB;EACxB,kBAAkB;EAClB,0C/D3+CmB;E+D4+CnB,iC/Dv+CiB;E+Dw+CjB,YAAY,EAAA;;AAGd;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gC/D/hDuB,EAAA;;A+DkiDzB;EAEI,4CAA4C;EAC5C,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB,EAAA;;AALtB;EASI,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gC/D9iDqB,EAAA;;A+DkjDzB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,c/DtjDuB;E+DujDvB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB,EAAA;;AAGnB;EACE,SAAS;EACT,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB,EAAA;EAJlB;IAMY,c/D3iDS,EAAA;E+DqiDrB;IAOa,c/D3jDO,EAAA;;A+D8jDpB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gC/DzkDuB,EAAA;;A+D4kDzB;EACE,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,gC/DnlDuB,EAAA;;A+DslDzB;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gC/D1lDuB,EAAA;;A+D6lDzB;EACE,mBAAmB,EAAA;EADrB;IAII,gBAAgB,EAAA;;AAIpB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gC/D1mDuB,EAAA;;A+D6mDzB;EACE,aAAa;EACb,6CAA6C;EAC7C,mBAAmB;EACnB,kBAAkB;EAClB,+C/D/mDmB;E+DgnDnB,iBAAiB,EAAA;EANnB;IASI,mBAAmB,EAAA;;AAIvB;EACE,gC/D3nDuB,EAAA;;A+D8nDzB;EACE,c/D/nDuB;E+DgoDvB,sBAAsB,EAAA;EAFxB;IAKI,kCAAkC;IAClC,kBAAkB,EAAA;;AAItB;EACE,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,0C/DlmDmB;E+DmmDnB,iC/D9lDiB;E+D+lDjB,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,gC/DjpDuB;E+DkpDvB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB,EAAA;;AAGxB;EACE,sC/DjoDmB;E+DkoDnB,mC/DjoDa,EAAA;;A+DooDf;EACE,sC/DnnDmB;E+DonDnB,mC/DpnDmB,EAAA;;A+DunDrB;EACE,uC/DjqDkB,EAAA;;A+DoqDpB;EACE,cAAc;EACd,mBAAmB;EACnB,0C/D9nDmB;E+D+nDnB,iC/D1nDiB,EAAA;;A+D6nDnB;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB,EAAA;EAHpB;;IAOI,wBAAwB;IACxB,gBAAgB;IAChB,+C/DlrDiB;I+DmrDjB,mBAAmB,EAAA;EAVvB;IAcI,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,gC/DhsDqB;I+DisDrB,kC/DhpDoB,EAAA;E+D2nDxB;IAyBI,oC/D3pDiB,EAAA;E+DkoDrB;IA4BW,c/DjrDU,EAAA;E+DqpDrB;IA6BY,c/DjsDQ,EAAA;;A+DosDpB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gC/D/sDuB,EAAA;;A+DktDzB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB,EAAA;;AAGzB;EACE,gBAAgB;EAChB,gC/D5tDuB,EAAA;;A+D+tDzB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB,EAAA;EAEzB;IACE,c/DptDsB;I+DqtDtB,mC/DntDW;I+DotDX,2C/DrtDiB,EAAA;E+DwtDnB;IACE,c/DxuDgB;I+DyuDhB,mC/DxuDQ;I+DyuDR,yC/D1uDgB,EAAA;E+D6uDlB;IACE,c/D/tDiB;I+DguDjB,mC/D/tDW,EAAA;E+DkuDb;IACE,gC/D3vDqB;I+D4vDrB,kC/DzvDiB,EAAA;;A+D6vDrB;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,oC/D3tDmB;E+D4tDnB,0C/D5tDmB;E+D6tDnB,c/DvwDuB,EAAA;;A+D0wDzB;EACE,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe,EAAA;EAEf;IACE,c/DpxDgB;I+DqxDhB,oFAAqF;IACrF,sC/D1uDiB,EAAA;E+D6uDnB;IACE,c/DxxDqB;I+DyxDrB,kC/DxuDoB;I+DyuDpB,sC/DhvDiB,EAAA;E+DguDrB;IAoBI,aAAa;IACb,mBAAmB,EAAA;;AAIvB;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B,EAAA;;AAGjC;EACE,uBAAkC;EAClC,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,mBAAmB;EACnB,0C/D1wDmB,EAAA;;A+D6wDrB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB,EAAA;;AAGxB;EACE,SAAS;EACT,eAAe;EACf,c/Dj0DuB;E+Dk0DvB,yBAAyB;EACzB,sBAAsB,EAAA;;AAGxB;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kC/Dx0DmB;E+Dy0DnB,c/D50DuB;E+D60DvB,kBAAkB;EAClB,cAAc;EACd,eAAe,EAAA;;AAGjB;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;EAHd;IAMI,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,gC/Dj2DqB,EAAA;E+Dw1DzB;;;IAeI,6BAA6B;IAC7B,wBAAwB;IACxB,0C/D/zDiB;I+Dg0DjB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,c/D72DqB;I+D82DrB,iC/D/zDe,EAAA;E+Dk0DjB;IACE,mBAAmB,EAAA;;AAIvB;EACE,mBAAmB;EACnB,c/Dh3DkB;E+Di3DlB,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,gBAAgB,EAAA;;AAGlB;EAn4DA;IAq4DI,0BAA0B,EAAA;EA57C9B;IAg8CI,0BAA0B,EAAA;EA17C5B;IA87CE,8BAA8B,EAAA;EApkBlC;IAwkBI,YAAY,EAAA;EAvahB;IA2aI,0BAA0B,EAAA;EA7Z9B;IAiaI,gBAAgB,EAAA;EA7YpB;IAiZI,0BAA0B,EAAA;EA1vC9B;IA8vCI,0BAA0B,EAAA;EAjuC9B;IAquCI,gBAAgB,EAAA;EA3pCpB;IA+pCI,0BAA0B,EAAA;EAnoC9B;IAuoCI,2BAA2B,EAAA;EAhoC/B;IAooCI,gBAAgB,EAAA;EA33BpB;IA+3BI,0BAA0B,EAAA;EAn2B9B;IAu2BI,2BAA2B,EAAA;EAh2B/B;IAo2BI,gBAAgB,EAAA;EAz0BpB;IA60BI,0BAA0B,EAAA;EA/G9B;IAmHI,0BAA0B,EAAA;EApF5B;IAwFE,iBAAiB,EAAA,EAClB;;AAGH;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;;AAGX;EACE,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB,EAAA;;AAGlB;EACE,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gC/Dt+DuB,EAAA;;A+Dy+DzB;;EAEE,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB,EAAA;;AAGrB;EACE,eAAe;EACf,YAAY,EAAA;;AAGd;EACE,eAAe;EACf,YAAY,EAAA;;AAGd;EACE,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,sDAAsD;EACtD,SAAS,EAAA;;AAGX;;EAEE,oBAAoB;EACpB,YAAY,EAAA;;AAGd;;EAEE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB,EAAA;;AAGxB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,c/DxhEuB,EAAA;;A+D2hEzB;EACE,mBAAmB,EAAA;;AAGrB;EACE,SAAS;EACT,kBAAkB;EAClB,gC/DliEuB,EAAA;;A+DqiEzB;EACE,eAAe,EAAA;;AAGjB;EACE,oC/DhgEmB,EAAA;;A+DmgErB;EACE,kBAAkB;EAClB,c/D/iEuB,EAAA;;A+DkjEzB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gC/DrjEuB;E+DsjEvB,kCAAkC,EAAA;;AAGpC;EACE,aAAa;EACb,eAAe;EACf,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,gDAAgD;EAChD,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,8C/D3hEmB,EAAA;;A+D8hErB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gC/D7kEuB,EAAA;E+DwkEzB;IAQI,kBAAkB;IAClB,c/DjlEqB,EAAA;;A+DqlEzB;EACE,gBAAgB;EAChB,oBAAoB;EACpB,8C/D9iEmB,EAAA;;A+DijErB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gC/D/lEuB,EAAA;;A+DkmEzB;EACE,aAAa;EACb,eAAe;EACf,YAAY,EAAA;;AAGd;EAzGA;IA2GI,0BAA0B,EAAA,EAC3B;;A/DvoEH;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;A8Cr8BA;EkBCI,UAAU;EACV,gBAAgB;EAChB,eAAe,EAAA;;AAGnB;EACI,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,UAAU,EAAA;;AAGd;EACI,YAAY,EAAA;EADhB;IAKY,WAAW,EAAA;EALvB;IAagB,YAAY,EAAA;;AAM5B;EACI,yBhEoCe;EgEnCf,2BAA2B;EAC3B,yBhETgB;EgEUhB,kBAAkB;EAClB,cAAc,EAAA;EALlB;IAWQ,UAAU;IACV,aAAa,EAAA;EAZrB;IAgBQ,UAAU;IACV,aAAa,EAAA;EAjBrB;IAqBQ,UAAU;IACV,aAAa,EAAA;IAtBrB;MAyBY,SAAS,EAAA;EAzBrB;;IA+BQ,aAAa;IACb,sBAAsB;IACtB,WAAW,EAAA;IAjCnB;;;;MAqCY,aAAa;MACb,2BAA2B;MAC3B,mBAAmB;MAEnB,mBAAmB,EAAA;MAzC/B;;;;QA4CgB,aAAa;QACb,mBAAmB;QACnB,WAAW;QACX,kBAAkB;QAClB,iBAAiB,EAAA;QAhDjC;;;;UAmDoB,YAAY;UACZ,iBAAiB,EAAA;QApDrC;;;;;;;UAwDoB,YAAY;UACZ,gBAAgB;UAChB,YAAY,EAAA;MA1DhC;;;;QA+DgB,UAAU;QACV,gBAAgB;QAChB,eAAe;QACf,WAAW,EAAA;IAlE3B;;MAwEY,kBAAkB;MAClB,gBAAgB,EAAA;;AAK5B;EACI,aAAa;EACb,sBAAsB,EAAA;EAF1B;IAMY,mBAAmB,EAAA;EAN/B;IAUY,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,4DAA4D,EAAA;EAbxE;IAiBY,gBAAgB,EAAA;;AAK5B;EACI,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,WAAW,EAAA;;AAGf;;EAEI,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB,EAAA;;AAItB;;EAEI,yBhEvFe;EgEwFf,4BAA4B;EAC5B,yBhEpIgB;EgEqIhB,kBAAkB;EAClB,cAAc,EAAA;EANlB;;IASQ,yBAAyB,EAAA;EATjC;;IAaQ,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB,EAAA;EAjBzB;;IAsBQ,cAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB,EAAA;EA5BzB;;;;IAkCQ,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB,EAAA;IApCxB;;;;MAuCY,gBAAgB,EAAA;EAvC5B;;;;IA6CQ,aAAa;IACb,mBAAmB;IACnB,8BAA8B,EAAA;IA/CtC;;;;MAkDY,aAAa;MACb,mBAAmB,EAAA;IAnD/B;;;;;;;MAyDgB,iBAAiB;MACjB,2BAA2B,EAAA;IA1D3C;;;;MA+DY,iBAAiB;MACjB,kBAAkB;MAClB,YAAY,EAAA;;AAMxB;EACI,YAAY;EAAE,0CAAA;EACd,oBAAoB;EAAE,6CAAA;EACtB,chE3MqB;EgE2MI,kDAAA,EAAmD;;AAIhF;;EAEI,kBAAkB;EAClB,chEjNgB;EgEkNhB,oBAAoB;EACpB,yBAAyB;EACzB,eAAe;EACf,gChElNU,EAAA;;AgEqNd;;EAEI,eAAe;EACf,iBAAiB,EAAA;;AAIrB;EACI,gChEhOgB;EgEiOhB,yBAAyB,EAAA;;AAK7B;EACI,2BAA2B,EAAA;EAD/B;IAKQ,iBAAiB,EAAA;EALzB;IASQ,uBAAuB,EAAA;EAT/B;IAaQ,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,kBAAkB,EAAA;;AAI1B;EAEQ,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,kBAAkB,EAAA;;AAQ1B;EAEQ,aAAa;EACb,sBAAsB;EACtB,yBhEzQW;EgE0QX,YAAY;EACZ,yBhE/QY;EgEgRZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe,EAAA;EATvB;IAYY,iBAAiB;IAAE,4CAAA,EAA6C;EAZ5E;IAgBY,yBhE9OO;IgE+OP,iBAAiB;IAAE,4CAAA,EAA6C;EAjB5E;IAsBY,oBAAoB,EAAA;EAtBhC;IA0BY,qBhE5RQ,EAAA;EgEkQpB;IA8BY,chEvSQ;IgEwSR,eAAe;IACf,YAAY;IACZ,iCAAiC,EAAA;IAjC7C;MAoCgB,chE9SS;MgE+ST,iBAAiB;MACjB,+BAA+B,EAAA;EAtC/C;IA2CY,aAAa;IACb,gBAAgB;IAChB,uCAAuC;IACvC,iBAAiB;IACjB,mBAAmB,EAAA;IA/C/B;MAkDgB,iBAAiB;MAAE,mCAAA,EAAoC;IAlDvE;MAsDgB,gBAAiB,EAAA;IAtDjC;MA2DoB,YAAY;MACZ,kBAAkB;MAClB,gBAAgB;MAChB,eAAe,EAAA;IA9DnC;MAmEgB,aAAa;MACb,iBAAiB;MACjB,qBAAqB;MACrB,mBAAmB,EAAA;MAtEnC;QAyEoB,YAAY;QACZ,kBAAkB,EAAA;IA1EtC;MAgFgB,iBAAiB,EAAA;;AAhFjC;EAsFQ,chExVY,EAAA;;AgE4VpB;EACI,aAAa;EACb,8BAA8B;EAC9B,mBAAmB,EAAA;EAHvB;IAMQ,gBAAgB;IAChB,WAAW;IACX,iBAAiB,EAAA;;AAIzB;EACI,4BAA4B;EAC5B,yBhE9WU;EgE+WV,kBAAkB,EAAA;EAHtB;IAMQ,aAAa,EAAA;IANrB;MAUgB,yBhEzXI;MgE0XJ,uBAAuB;MACvB,mBAAmB;MACnB,iBAAiB,EAAA;IAbjC;MAiBgB,yBAAyB,EAAA;MAjBzC;QAoBoB,kBAAkB;QAClB,YAAY;QACZ,kBAAkB,EAAA;EAtBtC;IA6BQ,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,SAAS;IACT,gBAAgB,EAAA;EAlCxB;IAsCQ,cAAc;IACd,iBAAiB;IACjB,chEvZY;IgEwZZ,iBAAiB,EAAA;EAzCzB;IA6CQ,gBAAgB,EAAA;;AAQxB;EACI,aAAa;EACb,WAAW,EAAA;;AAIf;EACI,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yBhE1aoB;EgE2apB,yBhEtac;EgEuad,gChEvac;EgEwad,kBAAkB;EAClB,iCAAiC,EAAA;EATrC;IhE+ME,aAAa;IACb,8BAA8B;IAC9B,cA5nBuB;IA6nBvB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gCA7nBY;IA8nBZ,8BAA8B;IAC9B,mHAAiF,EAAA;IgExNnF;MAgBY,gBAAgB;MAChB,yBAAyB;MACzB,chE5bQ;MgE6bR,uBAAuB;MACvB,qBAAqB,EAAA;EApBjC;IAwBQ,uBAAuB;IACvB,aAAa;IACb,yBhEvZY;IgEwZZ,aAAa;IACb,gBAAgB;IAChB,WAAW,EAAA;IhEmSf;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;EgE/UjE;IAiCQ,mBhEvcW;IgEwcX,YAAY,EAAA;IAlCpB;MAqCY,mBhE1cY;MgE2cZ,yBhE7cE;MgE8cF,kBAAkB;MAClB,WAAW;MACX,eAAe;MACf,oBAAoB;MACpB,mBAAmB,EAAA;MA3C/B;QA8CgB,chExdI;QgEydJ,iBAAiB;QACjB,iBAAiB,EAAA;MAhDjC;QAoDgB,kBAAkB;QAClB,+BAA+B,EAAA;QArD/C;UAwDoB,WAAW;UACX,uBAAuB;UACvB,YAAY,EAAA;QA1DhC;UA6DoB,mBhE5bD;UgE6bC,yBhEzeK,EAAA;MgE2azB;QAmEgB,kBAAkB;QAClB,+BAA+B,EAAA;QApE/C;UAuEoB,WAAW;UACX,uBAAuB;UACvB,YAAY,EAAA;QAzEhC;UA4EoB,mBhE3cD;UgE4cC,yBhExfK,EAAA;MgE2azB;QAkFgB,yBhE5fI,EAAA;;AgEmgBpB;EACI,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,QAAQ,EAAA;EAJZ;IAOQ,wBAAA;IACA,UAAU;IACV,QAAQ;IACR,SAAS;IACT,SAAS;IACT,oBAAoB;IACpB,kBAAkB,EAAA;EAb1B;IAiBQ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY,EAAA;IApBpB;MAuBY,oBAAoB;MACpB,WAAW;MACX,YAAY;MACZ,chE7hBQ;MgE8hBR,mBhEnfO;MgEofP,yBhE9hBe;MgE+hBf,kBAAkB;MAClB,YAAY;MACZ,WAAW;MACX,mBAAmB;MACnB,eAAe,EAAA;MAjC3B;QAoCgB,oBAAoB;QACpB,YAAY;QACZ,YAAY;QACZ,mBAAmB;QACnB,eAAe,EAAA;MAxC/B;QA4CgB,iBAAiB;QACjB,iBAAiB,EAAA;MA7CjC;QAiDgB,yBhErjBS,EAAA;EgEogBzB;IAuDQ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IAgEZ;;;sEjEsqhE8D,EiEnqhEC;IA9HvE;MA+DY,kBAAkB;MAClB,aAAa;MACb,mBAAmB;MACnB,eAAe;MACf,YAAY;MACZ,mBhE5hBO;MgE6hBP,yBAAyB;MAEzB,kBAAkB;MAClB,UAAU;MACV,eAAe;MAGf,8DAMC;MAED,gEAAgE;MAMhE,qBAAA;MAyBA,oBAAA,EAAqB;MAnHjC;QAuFgB,qBhE3lBS,EAAA;MgEogBzB;QA4FgB,iBAAiB;QACjB,uBAAuB;QACvB,YAAY;QACZ,uBAAuB;QACvB,0BAA0B;QAC1B,chErmBS;QgEsmBT,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,gBAAgB;QAChB,eAAe,EAAA;QAtG/B;UAyGoB,YAAY,EAAA;MAzGhC;QA+GgB,chEnnBS;QgEonBT,YAAY,EAAA;MAhH5B;QAqHgB,chExnBI;QgEynBJ,yBAAyB;QACzB,eAAe,EAAA;IAvH/B;MAiIY,SAAS;MACT,WAAW;MACX,YAAY,EAAA;MAnIxB;QAuIoB,YAAY,EAAA;MAvIhC;QA2IoB,mBhEnmBD,EAAA;IgEwdnB;MAmJY,WAAW;MACX,WAAW;MACX,uBAAuB;MACvB,YAAY,EAAA;MAtJxB;QA0JoB,YAAY,EAAA;MA1JhC;QA8JoB,mBhEtnBD,EAAA;IgEwdnB;MAqKY,WAAW;MACX,WAAW;MACX,uBAAuB;MACvB,YAAY,EAAA;IAxKxB;MA4KY,WAAW;MACX,WAAW;MACX,uBAAuB;MACvB,YAAY,EAAA;IA/KxB;MAmLY,WAAW;MACX,WAAW;MACX,uBAAuB;MACvB,YAAY,EAAA;IAtLxB;MA8LY,yBhE1oBc;MgE2oBd,SAAS;MAET,WAAW,EAAA;MAjMvB;QAqMgB,gBAAgB;QAChB,gBAAgB,EAAA;QAtMhC;UAyMoB,mBhErpBM,EAAA;IgE4c1B;MA+MY,yBhE5pBS;MgE6pBT,WAAW;MACX,WAAW,EAAA;MAjNvB;QAqNoB,mBhElqBC,EAAA;IgE6crB;MA2NY,yBhEzqBI;MgE0qBJ,WAAW;MACX,WAAW,EAAA;MA7NvB;QAgOgB,yBhE3tBJ,EAAA;QgE2fZ;UAkOoB,chEtuBK,EAAA;IgEogBzB;MAwOY,yBhEvrBU;MgEwrBV,chEvuBY;MgEwuBZ,WAAW;MACX,WAAW;MACX,YAAY,EAAA;MA5OxB;QA+OgB,chE7uBQ,EAAA;IgE8fxB;MAoPY,yBhEpsBe;MgEqsBf,WAAW;MACX,uBAAuB;MACvB,WAAW;MACX,YAAY,EAAA;MAxPxB;QA2PgB,chEzvBQ,EAAA;IgE8fxB;MAkQY,oBAAoB;MACpB,kBAAkB;MAClB,WAAW;MACX,UAAU;MACV,YAAY;MACZ,YAAY;MACZ,eAAe,EAAA;MAxQ3B;QA2QgB,UAAU,EAAA;IA3Q1B;MAgRY,kBAAkB;MAClB,aAAa;MACb,mBAAmB;MACnB,eAAe;MACf,YAAY;MACZ,mBhE7uBO;MgE8uBP,yBAAyB;MACzB,yBhEhvBE;MgEivBF,kBAAkB;MAClB,UAAU,EAAA;MAzRtB;QA4RgB,yBhErxBE;QgEsxBF,chEjyBS;QgEkyBT,yBhEzxBJ;QgE0xBI,eAAe,EAAA;IA/R/B;MAoSY,yBhE/xBA,EAAA;EgE2fZ;IAySQ,kBAAkB;IAClB,iBAAiB,EAAA;EA1SzB;IA8SQ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,oBAAoB,EAAA;;AAK5B;EACE;IACE,gDAAgD;IAChD,UAAU,EAAA;EAEZ;IACE,gDAAgD;IAChD,UAAU,EAAA;EAEZ;IACE,8CAA8C;IAC9C,UAAU,EAAA,EAAA;;AAId;EACI,eAAe,EAAA;;AAGnB;EACI,yBAAyB,EAAA;;AAG7B;EACI,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;;AAIb,sDAAA;AAEA,0CAAA;AACA;EACE,eAAe;EACf,QAAQ;EAAiB,6BAAA;EACzB,cAAc;EAAW,0BAAA;EACzB,8BAA8B;EAE9B,gDAAA;EACA,aAAa;EACb,mBAAmB;EAEnB,4DAAA;EACA,4BAA4B,EAAA;;AAG9B,gBAAA;AACA;EACI,aAAa;EACb,uBAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,0CAAsC,EAAA;;AAG1C,gBAAA;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS,EAAA;;AAGX,kDAAA;AACA;EACE,gBAAgB,EAAA;;AvDmoClB;EuD7nCE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAA;EvD0nCV;IuDvnCI,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,iBAAiB,EAAA;IAdrB;MAiBM,kBAAkB;MAClB,UAAU;MACV,iBAAiB;MACjB,kBAAkB;MAClB,mBAAmB;MACnB,yBhEl5BkB;MgEm5BlB,chEz5BmB;MgE05BnB,yBhEz5Bc;MgE05Bd,kBAAkB;MAClB,iBAAiB;MACjB,mBAAmB;MACnB,eAAe;MACf,iEAAiE;MACjE,4BAA4B,EAAA;MA9BlC;QAiCQ,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB,EAAA;MAnC3B;QAuCQ,SAAS;QACT,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB,EAAA;QA1C3B;UA6CU,qBAAqB,EAAA;IA7C/B;MAqDQ,mBAAmB;MACnB,UAAU;MACV,UAAU;MACV,UAAU,EAAA;;AAKlB;EACE,mBhE17BsB;EgE27BtB,chEj8BuB;EgEk8BvB,yBhEj8BkB;EgEk8BlB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,wCAAqC,EAAA;EvD0kCvC;IuDvkCQ,eAAe;IACf,4CAA4C;IAC5C,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,UAAU,EAAA;;AAIlB;EACE,iBAAiB;EACjB,kBAAkB,EAAA;;AAGpB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAA;EAJrB;IAMI,qBAAqB,EAAA;;AAIzB;EACI,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,mBAAmB,EAAA;EAVvB;IAaQ,UAAU,EAAA;;AhE7gClB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AiEr8BA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY,EAAA;EAEZ;IACE,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,gCjEiBqB,EAAA;EiEdvB;IACE,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,kBAAkB,EAAA;IAElB;MANF;QAOI,0BAA0B,EAAA,EAE7B;EAED;IACE,YAAY;IACZ,SAAS,EAAA;EA1Bb;IA8BI,sBAAsB,EAAA;IA9B1B;MAiCM,mBAAmB,EAAA;IAjCzB;MAqCM,SAAS,EAAA;EAIb;IACE,oBAAoB;IACpB,eAAe;IACf,qBAAqB;IACrB,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,2CjECiB;IiEAjB,kCjEIkB,EAAA;EiEDpB;IACE,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cjERiB,EAAA;EiEWnB;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cjEfsB,EAAA;EiEkBxB;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,sBAAsB,EAAA;EAGxB;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;IACxB,0CjEZgB;IiEahB,kBAAkB;IAClB,kCjEjDoB;IiEkDpB,cjExDqB;IiEyDrB,kBAAkB,EAAA;IATnB;MAYG,gCjE3Dc,EAAA;IiE+CjB;MAgBG,aAAa;MACb,sCjExBc;MiEyBd,8CjExBe,EAAA;EiE4BnB;IACE,YAAY,EAAA;EAGd;IACE,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,+BjE9EgB,EAAA;EiE5BpB;IA8GI,mBAAmB;IACnB,oBAAoB,EAAA;EA/GxB;IAmHI,SAAS;IACT,uCjEvFuB;IiEwFvB,6CjEzCoB,EAAA;IiE5ExB;MAyHM,4BAAY;MACZ,gBAAgB;MAChB,wBAAwB,EAAA;IA3H9B;MA+HM,eAAe,EAAA;IA/HrB;MAmIM,kBAAkB,EAAA;EAnIxB;IAyIM,aAAa;IACb,mBAAmB,EAAA;;AAKzB;EAEI,UAAU,EAAA;;AAFd;EAMI,UAAU,EAAA;;AANd;EAUI,UAAU,EAAA;;AAVd;EAcI,UAAU,EAAA;;AAId;EAEI,UAAU,EAAA;;AAFd;EAMI,UAAU,EAAA;;AANd;EAUI,UAAU,EAAA;;AAId;EAEI,aAAa;EACb,0BAA0B;EAC1B,YAAY,EAAA;;AAJhB;EAQI,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAVhB;EAcI,kBAAkB;EAClB,gBAAgB;EAChB,cjEnKgB,EAAA;;AiEmJpB;EAoBI,WAAW;EACX,wBAAwB;EACxB,2CjExKuB;EiEyKvB,kBAAkB;EAClB,kCjEtKoB;EiEuKpB,cjE7KqB;EiE8KrB,kBAAkB,EAAA;EA1BtB;IA6BM,aAAa;IACb,mBAAmB,EAAA;;AAIvB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW,EAAA;EAHZ;IAMG,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,cjE/LmB,EAAA;;AiEmMvB;EACE,WAAW;EACX,cAAc,EAAA;;AjEjOlB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AkEj8BA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,gClEuBY,EAAA;;AkEpBd;EACE,OAAO;EACP,sBAAuB,EAAA;;AAGzB;EACE,cAAc;EACd,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB;EAChB,clEKkB,EAAA;;AkEFpB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EA+CR,oGAAA,EAAsG;EAlDxG;IAMI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,gClEJe,EAAA;IkENnB;MAaM,kBAAkB;MAClB,2BAA2B;MAC3B,4BAA4B;MAC5B,0BAA0B;MAC1B,clEfc;MkEgBd,iBAAiB;MACjB,eAAe;MACf,yBlEbkB;MkEclB,eAAe,EAAA;MArBrB;QAwBQ,yBlEnBM,EAAA;MkELd;QA4BQ,qBAAqB;QACrB,oBAAoB;QACpB,sBAAsB;QACtB,WAAW;QACX,YAAY;QACZ,eAAe;QACf,gBAAgB;QAChB,sBAAsB;QACtB,kBAAkB;QAClB,yBlEKY;QkEJZ,uBAAuB;QACvB,oBAAoB,EAAA;IAvC5B;MA4CM,yBlEvCQ;MkEwCR,clE5CmB;MkE6CnB,gClEzCQ,EAAA;EkELd;IAoDI,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,QAAQ,EAAA;IAvDZ;MA0DM,eAAe;MACf,mBAAmB;MACnB,cAAc,EAAA;EA5DpB;IAiEI,aAAa;IACb,sBAAsB;IACtB,SAAS,EAAA;;AAIb;EACI,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,QAAQ,EAAA;;AAGZ;EACI,yBlE1EU;EkE2EV,4BAA4B;EAC5B,clEhFqB;EkEiFrB,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,4BAA4B;EAC5B,+BAA+B;EAC/B,8BAA8B,EAAA;;AAGlC;;;EAIQ,gBAAgB;EAChB,clE9FY;EkE+FZ,kBAAkB;EAClB,gBAAgB,EAAA;;AAPxB;EAWQ,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,clExGiB,EAAA;;AkE0FzB;EAkBQ,gBAAgB,EAAA;;AAlBxB;EAsBQ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,yBlE/GW;EkEgHX,kBAAkB;EAClB,yBlEhHgB;EkEiHhB,clEvHiB,EAAA;;AkE0FzB;EAiCQ,gBAAgB,EAAA;EAjCxB;;IAqCY,cAAc;IACd,WAAW,EAAA;EAtCvB;IA0CY,WAAW,EAAA;;AA1CvB;EA+CQ,kBAAkB;EAClB,clE1IiB,EAAA;;AkE0FzB;EAoDQ,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB,EAAA;EAxDzB;;IA4DY,gBAAgB;IAChB,gClElJO;IkEmJP,gBAAgB;IAChB,clEzJa,EAAA;EkE0FzB;IAmEY,clE5JQ,EAAA;;AkEyFpB;EAwEQ,gBAAgB;EAChB,iBAAiB;EACjB,6BlE/JW;EkEgKX,gBAAgB,EAAA;;AA3ExB;EA+EQ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,clE5KiB;EkE6KjB,yBlEjIW;EkEkIX,yBlEnIM;EkEoIN,kBAAkB,EAAA;;AArF1B;EAyFQ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBlEjLW;EkEkLX,yBlElLW;EkEmLX,clExLiB;EkEyLjB,eAAe,EAAA;EA/FvB;IAkGY,yBlExLE,EAAA;EkEsFd;IAsGY,YAAY;IACZ,mBAAmB,EAAA;;AAK/B;EAEQ,gBAAgB;EAChB,clExMY;EkEyMZ,kBAAkB;EAClB,gBAAgB,EAAA;;AALxB;EASQ,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,SAAS;EACT,mBAAmB,EAAA;;AAb3B;EAiBQ,cAAc;EACd,iBAAiB;EACjB,clEzNiB,EAAA;;AkEsMzB;EAuBQ,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAA;;AAzBxB;EA6BQ,gBAAgB;EAChB,iBAAiB;EACjB,yBlEhOW;EkEiOX,kBAAkB;EAClB,yBlEjOgB;EkEkOhB,clExOiB,EAAA;;AkEsMzB;EAsCQ,iBAAiB;EACjB,kBAAkB;EAClB,yBlEzOW;EkE0OX,yBlE1OW;EkE2OX,clEhPiB;EkEiPjB,eAAe,EAAA;EA3CvB;IA8CY,yBlEhPE,EAAA;EkEkMd;IAkDY,YAAY;IACZ,mBAAmB,EAAA;;AAnD/B;EAwDQ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,clEnQiB;EkEoQjB,yBlExNW;EkEyNX,yBlE1NM;EkE2NN,kBAAkB,EAAA;;AAhE1B;EAoEQ,gBAAgB;EAChB,iBAAiB;EACjB,6BlEvQW;EkEwQX,gBAAgB,EAAA;;AAvExB;EA2EQ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,clEpRiB,EAAA;;AkEsMzB;EAkFQ,gBAAgB;EAChB,clExRY;EkEyRZ,kBAAkB;EAClB,iBAAiB,EAAA;;AArFzB;EAyFQ,qBlEpRU;EkEqRV,yBlErRU;EkEsRV,clEjSiB,EAAA;EkEsMzB;IA8FY,yBlE5RQ;IkE6RR,qBlE7RQ,EAAA;;AkE8LpB;EAoGQ,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,yBlE1SgB;EkE2ShB,yBlE5SW,EAAA;;AkEgTnB;EAEQ,gBAAgB;EAChB,clEvTY;EkEwTZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAA;;AANzB;EAUQ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB,EAAA;;AAd3B;EAkBQ,iBAAiB;EACjB,clExUiB,EAAA;;AkEqTzB;EAuBQ,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS,EAAA;;AA1BjB;EA8BQ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,yBlElVW;EkEmVX,kBAAkB;EAClB,yBlEnVgB;EkEoVhB,clE1ViB;EkE2VjB,yBAAyB;EACzB,sBAAsB,EAAA;;AAvC9B;EA2CQ,iBAAiB;EACjB,kBAAkB;EAClB,yBlE7VW;EkE8VX,yBlE9VW;EkE+VX,clEpWiB;EkEqWjB,eAAe,EAAA;EAhDvB;IAmDY,yBlEpWE,EAAA;EkEiTd;IAuDY,YAAY;IACZ,mBAAmB,EAAA;;AAxD/B;EA6DQ,iBAAiB;EACjB,gBAAgB;EAChB,clEpXiB;EkEqXjB,gBAAgB,EAAA;;AAhExB;EAoEQ,iBAAiB;EACjB,gBAAgB;EAChB,clEnXY;EkEoXZ,gBAAgB,EAAA;;AAIxB;EAEI,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAA;;AAKb;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBlEhWiB;EkEiWjB,yBlE5YkB;EkE6YlB,kBAAkB;EAClB,qDAAqD,EAAA;EANvD;IASM,wBAAwB,EAAA;EAT9B;IAaM,aAAa;IACb,oBAAoB,EAAA;EAd1B;IAmBM,aAAa;IACb,aAAa;IACb,oBAAoB,EAAA;EArB1B;IAyBM,aAAa;IACb,8BAA8B;IAAE,6CAAA;IAChC,kBAAkB;IAAE,kCAAA;IACpB,SAAS,EAAA;EA5Bf;IAiCM,aAAa;IACb,2BAA2B;IAAG,6CAAA;IAC9B,kBAAkB;IAAE,kCAAA,EAAmC;EAnC7D;IAuCM,mBlEpYa,EAAA;EkE6VnB;IA2CM,eAAe;IACf,gBAAgB,EAAA;EA5CtB;IAkDM,aAAa,EAAA;EAlDnB;IA2DQ,yBlE5bY,EAAA;EkEiYpB;IAgEM,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,aAAa;IACb,mBlExca;IkE0cb,UAAU;IACV,iBAAiB;IACjB,yBlEtcY;IkEucZ,gClEvcY;IkEwcZ,mBAAmB,EAAA;IA1EzB;MA6EQ,aAAa;MACb,YAAY,EAAA;IA9EpB;MAkFQ,0BAA0B,EAAA;EAlFlC;IAuFM,8BAA8B;IAC9B,YAAY;IACZ,mBlE9dQ;IkE+dR,gBAAgB;IAChB,YAAY,EAAA;EA3FlB;IA+FM,mBlE5ba,EAAA;;AkEgcnB;EACE,aAAa,EAAA;;AAGf;EAEI,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,cAAc;ElE6FhB,mHAAiF;EACjF,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EkE9FzB,gClErfU;EkEsfV,gCAAgC,EAAA;EAVpC;IAaM,kBAAkB;IAClB,QAAQ;IACR,clE/fmB,EAAA;;AkEsgBzB;EAEK,iBAAiB,EAAA;;AAItB;EAEM,uBAAuB,EAAA;;AAF7B;EAMM,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB,EAAA;;AAI7B;EACE,WAAW,EAAA;EADb;IAII,UAAU,EAAA;EAJd;IAQI,aAAa;IACb,mBAAmB;IAEnB,kBAAkB,EAAA;IAXtB;MAcM,aAAa;MACb,kBAAkB;MAClB,mBAAmB;MACnB,sBAAsB;MACtB,iBAAiB;MACjB,gBAAgB;MAChB,UAAU;MACV,WAAW,EAAA;IArBjB;MAyBM,aAAa,EAAA;IAzBnB;;;;;MA+BM,gBAAgB;MAChB,kBAAkB,EAAA;IAhCxB;MAoCM,WAAW,EAAA;IApCjB;MAwCM,aAAa;MACb,sBAAsB;MACtB,WAAW;MACX,uBAAuB;MACvB,aAAa,EAAA;MA5CnB;QAgDQ,cAAc,EAAA;IAhDtB;MAqDM,sBAAsB;MACtB,uBAAuB;MACvB,mBAAmB;MACnB,kBAAkB;MAClB,yBlE7kBQ;MkE8kBR,kBAAkB;MAClB,kClE9kBa,EAAA;MkEmhBnB;QA8DQ,WAAW;QACX,cAAc;QACd,kBAAkB,EAAA;MAhE1B;QAoEQ,kBAAkB;QAClB,gBAAgB;QAChB,clE9lBiB;QkE+lBjB,kBAAkB,EAAA;MAvE1B;QA2EQ,kBAAkB;QAClB,clEnmBY;QkEomBZ,mBAAmB,EAAA;MA7E3B;QAiFQ,clEjmBY;QkEkmBZ,iBAAiB;QACjB,gBAAgB,EAAA;EAnFxB;IAyFI,aAAa,EAAA;;AAIjB;EACE,aAAa;EACb,eAAe;EACf,sBAAsB,EAAA;EAHxB;IAMI,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,WAAW,EAAA;EATf;IAaI,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,WAAW,EAAA;IAhBf;MAmBM,aAAa;MACb,eAAe;MACf,yBAAyB,EAAA;IArB/B;MA4BM,eAAe;MACf,yBAAyB;MACzB,sBAAsB,EAAA;MA9B5B;QAiCQ,aAAa,EAAA;MAjCrB;QAqCQ,eAAe;QACf,yBAAyB;QACzB,mBAAmB,EAAA;;AAO3B;EAEI,eAAe;EACf,kBAAkB;EAClB,iBAAiB,EAAA;;AAJrB;EAQI,aAAa,EAAA;;AARjB;EAYI,iBAAiB;EACjB,kBAAkB,EAAA;;AAbtB;EAiBI,aAAa,EAAA;;AAIjB;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,aAAa,EAAA;;AAGf;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,aAAa,EAAA;;AAGf;EAIM,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB,EAAA;;AARxB;EAWM,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB,EAAA;;AAdxB;EAiBM,YAAY;EACZ,YAAY;EACZ,kBAAkB,EAAA;;AAnBxB;EAuBM,aAAa;EACb,WAAW;EAEX,qBAAqB;EACrB,YAAY;EACZ,kBAAkB,EAAA;ElEDpB;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;;AkE1CjE;EAiCM,UAAU,EAAA;;AAjChB;EAuCM,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB,EAAA;;AA1CxB;EA8CM,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB,EAAA;;AAlDxB;EAsDM,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB,EAAA;;AAzDxB;EA6DM,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB,EAAA;;AAhExB;EAqEI,YAAY;EACZ,kBAAkB,EAAA;;AAItB;EAEI,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAiB;EACjB,WAAW,EAAA;;AAPf;EAWI,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,WAAW,EAAA;;AAhBf;EAoBI,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,iBAAkB;EAClB,WAAW,EAAA;;AAIf;EACE,0BAA0B,EAAA;;AAG5B;EACE,2BAA2B,EAAA;;AAG7B;EAEI,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,QAAQ,EAAA;EALZ;IASY,yBAA+C,EAAA;EAT3D;IAeM,yBlEz0BQ,EAAA;EkE0zBd;IAqBM,yBlE30Bc;IkE40Bd,yBAAmC,EAAA;;AAMzC;EACE,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,qDAAqD,EAAA;EALvD;IASM,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,YAAY,EAAA;IAjBlB;MAoBQ,WAAW;MACX,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,WAAW;MACX,mBAAmB;MACnB,0BAA0B;MAC1B,gDAAgD,EAAA;IA3BxD;MA+BQ,kBAAkB;MAClB,WAAW;MACX,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;MAChB,yBAAyB;MACzB,mCAAmC,EAAA;MArC3C;QAwCU,UAAU;QACV,SAAS,EAAA;MAzCnB;QA6CU,UAAU;QACV,UAAU,EAAA;IA9CpB;MAoDU,UAAU,EAAA;IApDpB;MAwDU,UAAU,EAAA;EAxDpB;IA8DM,2BAA2B,EAAA;;AVxxB7B;EU8xBF,WAAW,EAAA;;AAQb;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU,EAAA;;AAQZ;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB,EAAA;;AAGzB;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,yBlE57BY;EkE67BZ,kBAAkB;EAClB,yBlE77BiB;EkE87BjB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,yBAAyB,EAAA;EAd3B;IAiBI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IAAE,8CAAA;IACV,WAAW;IAAE,iDAAA;IACb,SAAS;IACT,UAAU;IACV,8BlE38BU;IkE48BV,+BlE58BU;IkE68BV,kBAAkB;IAAE,iDAAA;IACpB,oBAAoB;IAAE,mEAAA;IACtB,UAAU;IAAE,mDAAA,EAAoD;EA3BpE;IA+BI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,eAAe;IACf,+BAA+B,EAAA;IArCnC;MAwCM,kBAAkB;MAClB,2BAA2B,EAAA;MAzCjC;QA4CQ,YAAY;QACZ,YAAY;QACZ,2BAA2B,EAAA;IA9CnC;MAmDM,gBAAgB,EAAA;MAnDtB;QAsDQ,SAAS;QACT,gBAAgB;QAChB,yBAAyB,EAAA;EAxDjC;IA8DI,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBlEx/BoB;IkEy/BpB,2BAA6B;IAC7B,4BAA4B;IAC5B,gBAAgB;IAChB,gClE9/BU;IkE+/BV,kBAAkB,EAAA;IA3EtB;MA8EM,kBAAkB;MAClB,aAAa;MAAE,2CAAA;MACf,gBAAgB;MAChB,UAAU;MACV,mBAAmB,EAAA;MlE/RrB;QACI,UAjKa,EAAA;MAoKjB;QACI,mBApKuB;QAqKvB,kBAAkB;QAClB,kBAAkB,EAAA;MAGtB;QACI,yBA3uBU;QA4uBV,kBAAkB,EAAA;QAElB;UACI,yBAAqD,EAAA;IkE8LjE;MAuFM,aAAa;MACb,iBAAiB;MACjB,SAAS;MACT,mBAAmB;MACnB,iBAAiB;MACjB,eAAe,EAAA;MA5FrB;QA+FQ,WAAW;QACX,iBAAiB;QACjB,oBAAoB,EAAA;MAjG5B;QAsGQ,WAAW;QACX,YAAY,EAAA;MAvGpB;QA2GQ,WAAW;QACX,YAAY,EAAA;MA5GpB;QAgHQ,WAAW;QACX,YAAY,EAAA;MAjHpB;QAqHQ,WAAW;QACX,YAAY,EAAA;EAtHpB;IA6HM,SAAS,EAAA;EA7Hf;IAiIM,uBAAuB;IACvB,2BAA2B,EAAA;EAlIjC;IAsIM,WAAW,EAAA;EAtIjB;IA0IM,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,uBAAuB,EAAA;EA7I7B;IAkJI,uBAAuB,EAAA;;AAI3B;EAGI,eAAe,EAAA;;AAHnB;EAOI,kBAAkB,EAAA;;AAStB;EAtKA;IAwKI,cAAc;IACd,eAAe,EAAA;EAGjB;IACE,2BAA2B;IAC3B,4BAA4B,EAAA;EAG9B;IACE,aAAa;IACb,iBAAiB;IACjB,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,eAAe,EAAA;IANjB;MASI,WAAW;MACX,iBAAiB;MACjB,oBAAoB,EAAA;IAXxB;MAgBI,sBAAsB;MACtB,uBAAuB,EAAA;IAjB3B;MAqBI,WAAW;MACX,YAAY,EAAA;IAtBhB;MA0BI,WAAW;MACX,YAAY,EAAA;IA3BhB;MA+BI,WAAW;MACX,YAAY,EAAA,EACb;;AlEtqCL;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AAt8BA;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AmEn8BA;EACE,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,WAAW;EACX,eAAe,EAAA;;AAGjB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB,EAAA;;AAGpB;EACE,iBAAiB;EACjB,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,sBAAsB,EAAA;;AAGxB;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,0CnE8BkB;EmE7BlB,kBAAkB;EAClB,kCnEPsB,EAAA;;AmEUxB;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,gCnEpBuB,EAAA;;AmEuBzB;EACE,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,0CnEckB;EmEblB,kBAAkB;EAClB,kCnEmBuB;EmElBvB,cnE9BuB;EmE+BvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe,EAAA;;AAGjB;EACE,sCnEIkB;EmEHlB,kCnEQkB,EAAA;;AmELpB;EACE,sBAAsB,EAAA;;AAGxB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB,EAAA;EAJlB;;;IASI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,gBAAgB,EAAA;;AAIpB;EAEI,UAAU;EACV,gCAAgC,EAAA;EAHpC;IAMM,WAAW,EAAA;EANjB;IAUM,WAAW,EAAA;;AAVjB;EAeI,+CAA+C;EAC/C,sDAAsD;EACtD,8BAA8B;EAC9B,wBAAwB,EAAA;;AAlB5B;EAsBI,UAAU;EACV,aAAa;EACb,6BAA6B,EAAA;EAxBjC;IA2BM,2DAA2D;IAC3D,4DAA4D,EAAA;;AA5BlE;;EAkCI,UAAU,EAAA;;AAxDd;EA6DE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY,EAAA;;AA5Dd;EAgEE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,0CnEjFkB;EmEkFlB,0FAIC;EACD,6CnE/EsB;EmEgFtB,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,4BAA4B;EAC5B,kDnErIyB,EAAA;;AmEwI3B;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cnE/IuB,EAAA;;AmEkJzB;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EnE6RhB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,6DAA6D,EAAA;EAE7D;IACE,UAAU,EAAA;EAGZ;IACE,+BAA+B;IAC/B,oBAAoB,EAAA;EAGtB;IACE,mCA5ZiB;IA6ZjB,oBAAoB;IACpB,2CAA2C,EAAA;EAG7C;IACE,oCAlaiB,EAAA;;AmEqHrB;EACE,SAAS;EACT,kBAAkB;EAClB,gCnEjKkB,EAAA;;AmEoKpB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCnExKuB,EAAA;;AmE2KzB;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cnEzIkB,EAAA;;AmE4IpB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCnEvLkB,EAAA;;AmE0LpB;EACE,cnEvIoB,EAAA;;AmE2ItB;;EAGI,YAAY;EACZ,aAAa;EACb,sBAAsB,EAAA;;AAL1B;EASI,cAAc;EnE8OhB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,6DAA6D,EAAA;EAE7D;IACE,UAAU,EAAA;EAGZ;IACE,+BAA+B;IAC/B,oBAAoB,EAAA;EAGtB;IACE,mCA5ZiB;IA6ZjB,oBAAoB;IACpB,2CAA2C,EAAA;EAG7C;IACE,oCAlaiB,EAAA;;AmEqKrB;EAEI,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB,EAAA;EAPvB;IAUM,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB,EAAA;EAbtB;IAiBM,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,gBAAgB,EAAA;IArBtB;MAwBQ,aAAa;MACb,uDAAuD;MACvD,oBAAoB;MACpB,WAAW;MACX,eAAe;MACf,YAAY;MACZ,sBAAsB;MACtB,SAAS;MACT,UAAU;MACV,gBAAgB;MAChB,SAAS,EAAA;IAlCjB;MAsCQ,aAAa;MACb,WAAW;MACX,YAAY;MACZ,eAAe;MACf,mBAAmB;MACnB,oBAAoB;MACpB,2BAA2B,EAAA;IA5CnC;MAgDQ,sBAAsB;MACtB,cAAc;MACd,WAAW;MACX,eAAe;MACf,YAAY;MACZ,mBAAmB;MACnB,cAAc;MACd,eAAe;MACf,8BAA8B;MAC9B,kBAAkB,EAAA;IAzD1B;MA6DQ,YAAY;MACZ,mBAAmB,EAAA;IA9D3B;MAmEQ,cAAc;MACd,eAAe;MACf,eAAe,EAAA;IArEvB;MA0EQ,YAAY;MACZ,WAAW;MACX,YAAY,EAAA;IA5EpB;MAiFQ,iBAAiB,EAAA;IAjFzB;MAsFQ,gBAAgB;MAChB,kBAAkB;MAClB,gBAAgB;MAChB,qBAAqB;MACrB,aAAa,EAAA;IA1FrB;MA+FQ,kBAAkB;MAClB,gBAAgB,EAAA;;AAhGxB;EAsGI,gBAAgB;EAChB,oBAAoB;EACpB,8CnE9QgB,EAAA;;AmEsKpB;EA4GI,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCnEhUqB,EAAA;;AmE+MzB;EAqHI,kBAAkB;EAClB,kBAAkB;EAClB,cnEjRkB,EAAA;;AmE0JtB;EA2HI,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB,EAAA;;AAhIpB;EAoII,gBAAgB;EAChB,SAAS,EAAA;;AArIb;EAyII,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,yBnEpTiB;EmEqTjB,kCnElTsB;EmEmTtB,kBAAkB;EAClB,iBAAiB;EACjB,gCnEpWgB,EAAA;;AmEwWpB;EAEI,cAAc;EnE+EhB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,6DAA6D,EAAA;EAE7D;IACE,UAAU,EAAA;EAGZ;IACE,+BAA+B;IAC/B,oBAAoB,EAAA;EAGtB;IACE,mCA5ZiB;IA6ZjB,oBAAoB;IACpB,2CAA2C,EAAA;EAG7C;IACE,oCAlaiB,EAAA;;AmE4TrB;;EAQI,YAAY,EAAA;;AAIhB;EA3XA;IA6XI,uBAAuB,EAAA;EA3U3B;IA+UI,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,sBAAsB,EAAA,EACvB;;AnExZH;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AoEr8BA;EACE,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,WAAW;EACX,eAAe,EAAA;;AAGjB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB,EAAA;;AAGpB;EACE,iBAAiB;EACjB,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,sBAAsB,EAAA;;AAGxB;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,0CpEgCkB;EoE/BlB,kBAAkB;EAClB,kCpELsB,EAAA;;AoEQxB;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,gCpElBuB,EAAA;;AoEqBzB;EACE,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,0CpEgBkB;EoEflB,kBAAkB;EAClB,kCpEqBuB;EoEpBvB,cpE5BuB;EoE6BvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe,EAAA;;AAGjB;EACE,sCpEMkB;EoELlB,kCpEUkB,EAAA;;AoEPpB;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,YAAY,EAAA;;AAGd;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,gBAAgB,EAAA;EANlB;IASI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,gBAAgB,EAAA;;AAIpB;EAEI,UAAU;EACV,gCAAgC,EAAA;EAHpC;IAMM,WAAW,EAAA;EANjB;IAUM,WAAW,EAAA;;AAVjB;EAeI,+CAA+C;EAC/C,sDAAsD;EACtD,8BAA8B;EAC9B,wBAAwB,EAAA;;AAlB5B;EAsBI,UAAU;EACV,aAAa;EACb,6BAA6B,EAAA;EAxBjC;IA2BM,2DAA2D;IAC3D,4DAA4D,EAAA;;AA5BlE;;EAkCI,UAAU,EAAA;;AAId;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCpEzGkB,EAAA;;AoE4GpB;EACE,cpEzDoB,EAAA;;AoE4DtB;EAEI,YAAY;EACZ,aAAa;EACb,sBAAsB,EAAA;;AAJ1B;EAQI,cAAc;EpEiKhB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,6DAA6D,EAAA;EAE7D;IACE,UAAU,EAAA;EAGZ;IACE,+BAA+B;IAC/B,oBAAoB,EAAA;EAGtB;IACE,mCA/PiB;IAgQjB,oBAAoB;IACpB,2CAA2C,EAAA;EAG7C;IACE,oCArQiB,EAAA;;AoEoFrB;EAzIA;IA2II,uBAAuB,EAAA;EAzF3B;IA6FI,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,sBAAsB,EAAA,EACvB;;ApEpKH;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AqEr8BA;EACE,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;EAHb;IAMI,cAAc;IACd,WAAW;IACX,oBAAoB;IACpB,oCrEgDiB,EAAA;IqEzDrB;MAYM,aAAa,EAAA;IAZnB;MAgBM,aAAa;MACb,aAAa,EAAA;;AAKnB;EACE,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,crEZuB,EAAA;;AqEezB;EACE,SAAS;EACT,kBAAkB;EAClB,gCrEjBkB,EAAA;EqEcpB;IAMI,crErBqB;IqEsBrB,gBAAgB,EAAA;;AAIpB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCrE5BkB,EAAA;;AqE+BpB;EACE,crEoBoB,EAAA;;AqEjBtB;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,sBAAsB,EAAA;;AAGxB;EACE,SAAS;EACT,wBAAwB;EACxB,0CrELkB;EqEMlB,oBAAoB;EACpB,kCrEAuB;EqECvB,crEjDuB;EqEkDvB,kBAAkB;EAClB,eAAe,EAAA;;AAGjB;EACE,sCrEbmB;EqEcnB,kCrEVkB,EAAA;;AqEapB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,mBAAmB,EAAA;;AAGrB;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,0CrE/BkB;EqEgClB,kBAAkB;EAClB,kCrEpEsB;EqEqEtB,crE3EuB;EqE4EvB,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,eAAe;EACf,YAAY,EAAA;;AAGd;EACE,SAAS;EACT,sBAAsB;EACtB,0CrE/CkB;EqEgDlB,oBAAoB;EACpB,kCrEpFsB;EqEqFtB,+BrE1FkB;EqE2FlB,kBAAkB;EAClB,eAAe,EAAA;;AAGjB;EACE,qCrEvDmB;EqEwDnB,kCrEpDkB;EqEqDlB,crEnGuB,EAAA;;AqEsGzB;EACE,oBAAoB;EACpB,0CrE/DkB;EqEgElB,mBAAmB;EACnB,kCrEpGsB,EAAA;;AqEuGxB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,crEhHuB,EAAA;;AqEmHzB;EACE,SAAS;EACT,kBAAkB;EAClB,gCrErHkB,EAAA;;AqEwHpB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;;AAGb;EACE,YAAY,EAAA;;AAGd;EACE,gBAAgB;EAChB,0CrE5FkB;EqE6FlB,mBAAmB;EACnB,kCrEvFuB,EAAA;;AqE0FzB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gCrE/IuB,EAAA;;AqEkJzB;EACE,SAAS;EACT,iBAAiB;EACjB,gCrEpJkB,EAAA;;AqEuJpB;EACE,WAAW;EACX,gBAAgB,EAAA;;AAGlB;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB,EAAA;;AAGpB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,+BrEtKkB,EAAA;;AqEyKpB;;EAEE,wBAAwB;EACxB,iDrEpIkB;EqEqIlB,gBAAgB;EAChB,sBAAsB,EAAA;;AAGxB;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gCrErLkB;EqEsLlB,kCrEjLsB,EAAA;;AqEoLxB;EACE,kCrE7IkB,EAAA;;AqEgJpB;EACE,qBAAqB;EACrB,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qCrErMkB;EqEsMlB,crEvMuB,EAAA;;AqE0MzB;EACE,mCrEnLa;EqEoLb,crErLmB,EAAA;;AqEwLrB;EACE,oCrE3JoB;EqE4JpB,crE5JoB,EAAA;;AqE+JtB;EACE,mCrE3KmB;EqE4KnB,crE7KkB,EAAA;;AqEgLpB;EACE,gCrEzNkB,EAAA;;AsEzBpB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,qBAAqB;EACrB,mBAAmB;EACnB,0CtEsDkB;EsErDlB,2FAIC;EACD,6CtEwDsB,EAAA;;AsErDxB;EACE,sBAAsB,EAAA;;AAGxB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,ctENuB,EAAA;;AsESzB;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gCtEbuB,EAAA;;AsEgBzB;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,ctEpBkB,EAAA;;AsEuBpB;EACE,gBAAgB,EAAA;EADlB;IAII,WAAW,EAAA;EAJf;IAQI,2BAA2B;IAC3B,uBAAuB;IACvB,iDAAgD;IAChD,mDAAwD;IACxD,ctEpCqB,EAAA;EsEwBzB;;IAiBI,yBAAkC,EAAA;EAjBtC;IAqBI,0CAAwC,EAAA;;AAI5C;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,2CtElCmB;EsEmCnB,kCtE/BoB,EAAA;;AsEkCtB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,ctE3CmB,EAAA;;AsE8CrB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,ctElDwB,EAAA;;AsEqD1B;EACE,kBAAkB;EAClB,gCtE7EuB,EAAA;;AsEgFzB;EACE,WAAW;EACX,kBAAkB;EAClB,gCtElFkB,EAAA;;AsEqFpB;EACE,ctElCoB;EsEmCpB,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB,EAAA;;AAGnB;EACE,aAAa,EAAA;;AAGf;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,ctE3GkB,EAAA;;AsE8GpB;EACE,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,4CtEjHyB;EsEkHzB,kCtE9GsB;EsE+GtB,kBAAkB;EAClB,gCtEtHuB,EAAA;;AsEyHzB;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,kDtE5HyB,EAAA;;AsE+H3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,wBAAwB;EACxB,6BAA6B;EAC7B,0BAA0B;EAC1B,kCtEnIsB;EsEoItB,gCtE1IuB;EsE2IvB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,4EAA4E,EAAA;;AAG9E;EACE,kCtE9IY;EsE+IZ,ctEnJuB,EAAA;;AsEsJzB;EACE,qCtE9GkB;EsE+GlB,gCAAgC;EAChC,mBtErJY;EsEsJZ,ctE1JuB,EAAA;;AsE6JzB;;EAEE,mBAAmB;EACnB,aAAa;EACb,gCtEhKkB,EAAA;;AsEmKpB;EACE,oBAAoB;EACpB,aAAa,EAAA;;AAGf;EACE,OAAO;EACP,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,kCtE1KY;EsE2KZ,2CtE7KyB,EAAA;;AsEgL3B;EACE,gBAAgB;EAChB,kCtE9KsB,EAAA;;AsEiLxB;EACE,YAAY,EAAA;;AAGd;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gCtE/LuB,EAAA;EsE2LzB;IAOI,ctEzJgB;IsE0JhB,gBAAgB,EAAA;;AAIpB;EACE,SAAS;EACT,kBAAkB;EAClB,+BtEzMkB,EAAA;;AsE8MpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY,EAAA;;AAGd;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gCtE1NuB,EAAA;;AsE6NzB;EACE,aAAa;EACb,eAAe;EACf,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,YAAY;EACZ,eAAe,EAAA;;AAGjB;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,WAAW,EAAA;;AAGb;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCtEjQuB,EAAA;;AsEoQzB;EACE,SAAS;EACT,uBAAuB;EACvB,2CtErQyB;EsEsQzB,oBAAoB;EACpB,kCtEnQsB;EsEoQtB,gCtE1QuB;EsE2QvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe,EAAA;EAEf;IACE,sCtE7NkB;IsE8NlB,oCtE9NkB;IsE+NlB,ctEhOuB,EAAA;EsEgN3B;IAoBI,uCtEjQiB;IsEkQjB,qCtElQiB;IsEmQjB,ctEpQsB,EAAA;;AsEwQ1B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,0CtExPmB;EsEyPnB,kBAAkB;EAClB,kCtE/RiB;EsEgSjB,ctErSuB;EsEsSvB,kBAAkB,EAAA;EARpB;IAWI,aAAa;IACb,mBAAmB,EAAA;;AAIvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,2CtElTyB;EsEmTzB,oBAAoB;EACpB,iCtEhTsB;EsEiTtB,+BtEvTuB;EsEwTvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe,EAAA;;AAGjB;EACE,sCtErRkB;EsEsRlB,oCtErRmB;EsEsRnB,ctEhUuB,EAAA;;AsEmUzB;EACE,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,oCtE9RkB;EsE+RlB,iBAAiB;EACjB,kBAAkB,EAAA;;AAGpB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;;AAGX;EACE,SAAS;EACT,UAAU,EAAA;;AAGZ;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2CtE3VyB;EsE4VzB,0FAIC;EACD,4CtElTsB,EAAA;;AsEqTxB;EACE,sCtE9TkB,EAAA;;AsEiUpB;EACE,aAAa,EAAA;;AAGf;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,qBAAqB,EAAA;;AAGvB;EACE,gBAAgB,EAAA;;AAGlB;EACE,eAAe;EACf,iBAAiB,EAAA;;AAGnB;EACE,ctE1WmB,EAAA;;AsE6WrB;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,+BtEvYkB;EsEwYlB,gBAAgB,EAAA;;AAGlB;EACE,eAAe;EACf,gBAAgB;EAChB,ctEzXwB,EAAA;;AsE4X1B;EACE,cAAc;EACd,kBAAkB;EAClB,+BtErZuB,EAAA;;AsEwZzB;EACE,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB,EAAA;;AAGxB;EACE,oCtEzXkB;EsE0XlB,ctE1XkB,EAAA;;AsE6XpB;EACE,oCtEhZmB;EsEiZnB,ctEjZmB,EAAA;;AsEoZrB;EACE,mCtEvXoB;EsEwXpB,ctExXoB,EAAA;;AsE2XtB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCtElbkB,EAAA;;AsEqbpB;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,iCtEpbsB;EsEqbtB,kBAAkB;EAClB,+BtE5buB,EAAA;;AsE+bzB;EACE,8BtEzamB,EAAA;;AsE4arB;EACE,8BtE/YoB,EAAA;;AsEkZtB;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB,EAAA;;AAG3B;EACE,ctEzbmB,EAAA;;AsE4brB;EACE,ctE/ZoB,EAAA;;AsEkatB;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,8BtElbkB;EsEmblB,iCtEtdsB;EsEudtB,kBAAkB;EAClB,+BtE9duB,EAAA;;AsEiezB;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,ctE9bkB,EAAA;;AsEicpB;EACE,cAAc;EACd,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mCtE7boB;EsE8bpB,ctE9boB,EAAA;;AsEictB;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,8BtErcoB;EsEscpB,kCtErfsB,EAAA;;AsEwfxB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gCtEjgBuB,EAAA;;AsEogBzB;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,ctErdoB,EAAA;;AsEwdtB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,gCtE5hBuB,EAAA;;AsE+hBzB;EACE,gBAAgB;EAChB,ctE3gBwB,EAAA;;AsE8gB1B;EACE,gCtEpiBkB,EAAA;;AsEuiBpB;EACE,kBAAkB;EAClB,+BtEjgBkB,EAAA;;AsEogBpB;EACE,kBAAkB;EAClB,gCtE9iBkB,EAAA;;AsEijBpB;EACE,aAAa;EACb,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB,EAAA;;AAGrB;EARA;IAUI,0BAA0B,EAAA;EAG5B;IACE,kBAAkB;IAClB,wBAAwB,EAAA,EACzB;;AAHD;EAOA,mBAAmB;EACnB,kBAAkB;EAClB,ctE/hBkB,EAAA;;AsEkiBpB;EACE,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,kCtEzkBsB;EsE0kBtB,2CtE9kByB,EAAA;;AsEilB3B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,ctExlBkB,EAAA;;AsE2lBpB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU,EAAA;;AAGZ;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,+BtE1mBkB;EsE2mBlB,iBAAiB,EAAA;;AAGnB;EACE,ctEhnBuB;EsEinBvB,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,YAAY,EAAA;;AAGd;EACE,wBAAwB;EACxB,kBAAkB;EAClB,oCtEtlBmB;EsEulBnB,kBAAkB;EAClB,ctEloBuB,EAAA;;AsEqoBzB;EACE,SAAS;EACT,kBAAkB;EAClB,gCtEvoBkB,EAAA;;AsE0oBpB;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,8CtEhpByB,EAAA;;AsEmpB3B;EACE,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe,EAAA;;AAGjB;EACE,aAAa;EACb,mBAAmB,EAAA;;AAGrB;EACE,sCtE9oBmB;EsE+oBnB,mCtE5oBkB;EsE6oBlB,ctEjpBwB,EAAA;;AsEopB1B;EACE,sCtEtnBoB;EsEunBpB,uBAAuB;EACvB,ctExnBoB,EAAA;;AsE2nBtB;EACE,sCtE5nBoB;EsE6nBpB,mCtExqBiB;EsEyqBjB,ctEnrBuB,EAAA;;AsEsrBzB;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kCtExrBsB;EsEyrBtB,0CtE1oBoB,EAAA;;AsE6oBtB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,ctErsBuB,EAAA;;AsEwsBzB;EACE,SAAS;EACT,kBAAkB;EAClB,gCtE1sBkB,EAAA;;AsE6sBpB;EACE,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,0CtEjtByB;EsEktBzB,kCtE9sBsB;EsE+sBtB,ctErtBuB;EsEstBvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB,EAAA;;AAGpB;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kCtE9tBsB;EsE+tBtB,0CtEnuByB,EAAA;;AsEsuB3B;EACE,iBAAiB;EACjB,gBAAgB;EAChB,ctE3uBuB,EAAA;;AsE8uBzB;EACE,SAAS;EACT,kBAAkB;EAClB,gCtEhvBkB,EAAA;;AsEmvBpB;EACE,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,0CtEvvByB;EsEwvBzB,kCtEpvBsB;EsEqvBtB,ctE3vBuB;EsE4vBvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB,EAAA;;AAGpB;EACE,uCtE5uBmB;EsE6uBnB,ctE7uBmB,EAAA;;AsEgvBrB;EACE,sBAAsB;EACtB,uCtElvBmB;EsEmvBnB,qCtEnvBmB;EsEovBnB,ctEpvBmB,EAAA;;AsEuvBrB;;;EAGE,SAAS;EACT,kBAAkB,EAAA;;AAGpB;EACE,ctEjuBoB,EAAA;;AsEouBtB;;EAEE,+BtE1xBkB,EAAA;;AA7BpB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AuEv8BA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY,EAAA;;AAGd;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gCvEkBuB,EAAA;;AuEfzB;;EAEE,SAAS;EACT,kBAAkB;EAClB,+BvEYkB,EAAA;;AuETpB;EACE,SAAS;EACT,kBAAkB,EAAA;;AAGpB;EACE,cvE2CkB,EAAA;;AuExCpB;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;EACZ,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY,EAAA;;AAGd;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2CvEhByB;EuEiBzB,0FAIC;EACD,4CvEyBsB,EAAA;;AuEtBxB;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cvE/BuB;EuEgCvB,yBAAyB;EACzB,sBAAsB,EAAA;;AAGxB;EACE,cAAc;EACd,iBAAiB;EACjB,wBAAwB;EACxB,2CvEtCyB;EuEuCzB,kBAAkB;EAClB,kCvEpCsB;EuEqCtB,cvE3CuB;EuE4CvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB,EAAA;;AAGlB;EACE,sBAAsB,EAAA;;AAGxB;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW,EAAA;;AAGb;EACE,aAAa,EAAA;;AAGf;EACE,kBAAkB;EAClB,gCvE7EkB,EAAA;;AuEgFpB;EACE,SAAS;EACT,wBAAwB;EACxB,2CvElFyB;EuEmFzB,oBAAoB;EACpB,iCvEhFsB;EuEiFtB,+BvEvFuB;EuEwFvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe,EAAA;;AAGjB;EACE,sCvErDkB;EuEsDlB,oCvErDmB,EAAA;;AuEwDrB;EACE,sCvE1DkB;EuE2DlB,kCvEzFgB,EAAA;;AuE4FlB;EACE,aAAa;EACb,mBAAmB,EAAA;;AAGrB;EACE,gBAAgB,EAAA;;AAGlB;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB,EAAA;;AAGpB;;EAEE,uBAAuB;EACvB,kDvEvHyB;EuEwHzB,sBAAsB,EAAA;;AAGxB;EACE,cvE9HuB;EuE+HvB,gBAAgB;EAChB,gBAAgB,EAAA;;AAGlB;EACE,aAAa,EAAA;;AAGf;EACE,WAAW;EACX,uBAAuB;EACvB,2CvExIyB;EuEyIzB,kBAAkB;EAClB,kCvEtIsB;EuEuItB,cvE7IuB;EuE8IvB,kBAAkB,EAAA;;AAGpB;EACE,WAAW;EACX,kBAAkB,EAAA;;AAGpB;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,8BvElHkB;EuEmHlB,iBAAiB;EACjB,cAAc;EACd,eAAe,EAAA;;AAGjB;EACE,aAAa;EACb,yBAAyB,EAAA;;AAG3B;EACE,gBAAgB;EAChB,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,mBAAmB;EACnB,2CvE5KyB;EuE6KzB,kCvEnIiB,EAAA;;AuEsInB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY,EAAA;;AAGd;EACE,kBAAkB,EAAA;;AAGpB;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB,EAAA;;AAGpB;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cvEzMuB,EAAA;;AuE4MzB;EACE,gBAAgB,EAAA;;AAGlB;EACE,WAAW;EACX,yBAAyB;EACzB,cvEnNuB;EuEoNvB,eAAe,EAAA;;AAGjB;;EAEE,wBAAwB;EACxB,2CvExNyB;EuEyNzB,gBAAgB,EAAA;;AAGlB;EACE,kCvEpNgB;EuEqNhB,cvEhOuB;EuEiOvB,gBAAgB,EAAA;;AAGlB;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,cvExOuB;EuEyOvB,kBAAkB,EAAA;;AAGpB;EACE,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,0CvEzNmB;EuE0NnB,iCvEjMuB,EAAA;;AuEoMzB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cvEjOmB;EuEkOnB,yBAAyB;EACzB,sBAAsB,EAAA;;AAGxB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gCvEjQuB,EAAA;EuE6PzB;IAOI,cvEpQqB;IuEqQrB,gBAAgB,EAAA;;AAIpB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,cvEpOkB;EuEqOlB,0BAA0B;EAC1B,6BAA6B,EAAA;EAN/B;IAUI,cvEnRqB,EAAA;;AuEuRzB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB,EAAA;;AAGxB;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY,EAAA;;AAGd;;EAEE,wBAAwB;EACxB,mBAAmB;EACnB,2CvEjRmB;EuEkRnB,kCvEzPuB,EAAA;;AuE4PzB;EACE,sCvEpQkB,EAAA;;AuEuQpB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB,EAAA;;AAGxB;EACE,iBAAiB;EACjB,0CvEhRkB;EuEiRlB,oBAAoB;EACpB,wBAAwB;EACxB,oCvEnRkB;EuEoRlB,cvEpRkB;EuEqRlB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe,EAAA;EAXjB;IAeI,mCvE7RgB,EAAA;;AuEiSpB;;EAEE,oBAAoB;EACpB,aAAa;EACb,cAAc;EACd,cvExTmB,EAAA;;AuE2TrB;EACE,WAAW;EACX,YAAY,EAAA;;AAGd;;EAEE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cvEvUmB,EAAA;;AuE0UrB;EACE,cvEzTkB,EAAA;;AuE4TpB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,+BvE3WuB,EAAA;EuEqWzB;IASI,cvE9WqB,EAAA;;AuEkXzB;EACE,yBAA8B,EAAA;;AAGhC;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBvEjVkB,EAAA;;AuEoVpB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,gCvErYuB,EAAA;;AuEwYzB;EACE,gCvEzYuB,EAAA;;AuE4YzB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cvEtWkB;EuEuWlB,0BAA0B;EAC1B,6BAA6B,EAAA;;AAG/B;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,+BvExZuB,EAAA;;AuE2ZzB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB,EAAA;;AAGxB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW,EAAA;;AAGb;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,sBAAsB,EAAA;;AAGxB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,wBAAwB;EACxB,0CvEnZkB;EuEoZlB,oBAAoB;EACpB,kCvE9YuB;EuE+YvB,cvEtZkB;EuEuZlB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,4EAGkB,EAAA;EAlBpB;IAsBI,qCvEnagB;IuEoahB,cvE7cqB,EAAA;EuEgdvB;IACE,qCvExagB;IuEyahB,kCvEpagB;IuEqahB,cvEndqB,EAAA;;AuEudzB;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,cAAc,EAAA;;AAGhB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,OAAO;EACP,WAAW;EACX,+BAAO;EACP,wBAAwB;EACxB,mBAAmB;EACnB,0CvE7bkB;EuE8blB,kCvEvbuB;EuEwbvB,8CvElesB,EAAA;EuEwdxB;IAaI,iCAAiC;IACjC,wDAGa,EAAA;EAjBjB;IAoBsC,eAAe,EAAA;EApBrD;IAqBwC,gBAAgB,EAAA;EArBxD;IAuBI,cAAc;IACd,gBAAgB,EAAA;EAxBpB;IA0BwC,eAAe,EAAA;;AAGvD;EACE,aAAa;EACb,mFAAmF;EACnF,YAAY;EACZ,mBAAmB,EAAA;;AAGrB;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,uBAAuB,EAAA;EALzB;;IASI,cAAc;IACd,eAAe,EAAA;EAGjB;IAAU,cvEteQ,EAAA;EuEuelB;IAAY,cvEtda,EAAA;EuEudzB;IAAU,cvEldQ,EAAA;;AuEqdpB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cvExhBuB,EAAA;;AuE2hBzB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB,EAAA;EAEhB;IAAe,cvEvfG,EAAA;EuEwflB;IAAY,cvEvea,EAAA;EuEwezB;IAAgB,cvEneE,EAAA;;AuEsepB;EACE,SAAS;EACT,kBAAkB;EAClB,gCvExiBuB;EuEyiBvB,iBAAiB,EAAA;;AAGnB;EACE,SAAS;EACT,kBAAkB;EAClB,gCvE/iBuB,EAAA;;AuEkjBzB;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gCvEzjBuB,EAAA;;AuE4jBzB;EACE,gCvE7jBuB;EuE8jBvB,cAAc;EACd,kBAAkB,EAAA;;AAGpB;EApSA;IAsSI,0BAA0B,EAAA;EAzE9B;IA6EI,iCAAiC;IACjC,wDAGa,EAAA;EA1EjB;IA6EsC,eAAe,EAAA;EACnD;IAAsC,gBAAgB,EAAA;EA3CxD;IA6CI,cAAc;IACd,gBAAgB,EAAA;EAvCpB;IAyCwC,eAAe,EAAA,EAAI;;AAG3D;EACE,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,0CvEnjBkB;EuEojBlB,kCvE7iBuB,EAAA;;AuEgjBzB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB,EAAA;;AAGxB;EACE,gBAAgB,EAAA;;AAGlB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,yCvExkBkB;EuEykBlB,oBAAoB;EACpB,wBAAwB;EACxB,oCvE3kBkB;EuE4kBlB,cvE5kBkB;EuE6kBlB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe,EAAA;EAdjB;IAkBI,mCvEplBgB,EAAA;;AuEwlBpB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,0CvE9lBkB;EuE+lBlB,kCvExlBuB,EAAA;;AuE2lBzB;EACE,mBAAmB,EAAA;;AAGrB;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,+BvEnpBuB;EuEopBvB,qBAAqB,EAAA;;AAGvB;EACE,gBAAgB,EAAA;;AAGlB;EACE,uCvE1pByB,EAAA;;AuE6pB3B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cvE1nBkB;EuE2nBlB,yBAAyB;EACzB,sBAAsB,EAAA;;AAGxB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gCvE5qBuB,EAAA;;AuE+qBzB;EACE,SAAS;EACT,kBAAkB;EAClB,cvEzoBkB,EAAA;;AuE4oBpB;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,kCvEtrBsB,EAAA;;AuEyrBxB;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,cvE5qBmB;EuE6qBnB,kBAAkB;EAClB,sBAAsB,EAAA;;AAGxB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,wBAAwB;EACxB,0CvEpqBkB;EuEqqBlB,oBAAoB;EACpB,oCvErqBmB;EuEsqBnB,cvEhtBuB;EuEitBvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe,EAAA;;AAGjB;EACE,aAAa;EACb,mBAAmB,EAAA;;AAKrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB,EAAA;;AAGxB;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,sBAAO;EACP,eAAe;EACf,SAAS;EACT,qBAAqB;EACrB,gBAAgB,EAAA;;AAGlB;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gCvE/wBuB,EAAA;;AuEkxBzB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cvExxBkB;EuEyxBlB,6CvEjxBsB,EAAA;;AuEoxBxB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,gCAAgC;EAChC,0CvE9xByB;EuE+xBzB,mBAAmB;EACnB,sHAKC;EACD,sFvExyBuB,EAAA;;AuE6yBzB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,YAAY;EACZ,YAAY,EAAA;;AAGd;EACE,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,2CvEzzByB;EuE0zBzB,oBAAoB;EACpB,iCvEvzBsB,EAAA;;AuE0zBxB;EACE,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCvEz0BkB;EuE00BlB,eAAe;EACf,0EAGuB,EAAA;EAfzB;IAkBI,cvEl1BqB,EAAA;EuEg0BzB;IAsBI,uFAAsF;IACtF,cvEv1BqB;IuEw1BrB,+CvE/yBgB,EAAA;;AuEmzBpB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY,EAAA;;AAGd;EACE,cAAc;EACd,uBAAuB;EACvB,oBAAoB;EACpB,0CvE9zBkB;EuE+zBlB,oCvE9zBmB;EuE+zBnB,kBAAkB;EAClB,gBAAgB;EAChB,cvEl0BkB,EAAA;;AuEq0BpB;EACE,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,SAAS;EACT,2CvEt3ByB;EuEu3BzB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kCvEt3BsB;EuEu3BtB,kDvE50BsB,EAAA;EuEk0BxB;IAaI,oBAAoB;IACpB,uBAAuB,EAAA;EAd3B;IAkBI,oBAAoB;IACpB,sFAAqF;IACrF,6CvE91BgB;IuE+1BhB,4BAA4B,EAAA;EArBhC;IAyBI,oBAAoB;IACpB,sFAAqF;IACrF,6CvEr2BgB,EAAA;;AuEy2BpB;EACE,uCvE53BmB,EAAA;EuE23BrB;IAII,qFAAoF;IACpF,8CvEh4BiB,EAAA;EuE23BrB;IASI,qFAAoF;IACpF,8CvEr4BiB,EAAA;;AuEy4BrB;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY,EAAA;;AAGd;EACE,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCvEr7BkB,EAAA;;AuEw7BpB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cvE57BuB;EuE67BvB,mBAAmB,EAAA;;AAGrB;EACE,cvEx5BkB,EAAA;;AuE25BpB;EACE,gBAAgB;EAChB,2CvEp8ByB;EuEq8BzB,qBAAqB;EACrB,gBAAgB,EAAA;EAJlB;IAOI,iBAAiB,EAAA;EAPrB;IAWI,wBAAwB,EAAA;;AAI5B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCvE79BuB,EAAA;;AuEg+BzB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,mBvEl8BkB;EuEm8BlB,yBAAyB;EACzB,6BAA6B,EAAA;;AAG/B;EACE,SAAS;EACT,UAAU,EAAA;;AAGZ;EACE,SAAS,EAAA;;AAGX;EACE,gBAAgB;EAChB,2CvEz/ByB;EuE0/BzB,mBAAmB;EACnB,kCvEv/BsB,EAAA;;AuE0/BxB;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB,EAAA;;AAGrB;;EAEE,gBAAgB;EAChB,UAAU,EAAA;;AAGZ;;EAEE,gBAAgB;EAChB,UAAU,EAAA;;AAGZ;;EAEE,UAAU,EAAA;;AAGZ;EACE,uBAAuB;EACvB,kDvEvhCyB;EuEwhCzB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,cvEt/BkB,EAAA;;AuEy/BpB;EACE,iBAAiB,EAAA;;AAGnB;EACE,uBAAuB;EACvB,kDvEtiCyB;EuEuiCzB,kBAAkB;EAClB,iBAAiB;EACjB,+BvE3iCuB;EuE4iCvB,sBAAsB;EACtB,gBAAgB,EAAA;;AAGlB;EACE,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB,EAAA;;AAGlB;EACE,oBAAoB;EACpB,cAAc;EACd,cAAc;EACd,eAAe;EACf,cvE1hCkB,EAAA;;AuE6hCpB;EACE,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,cvE9kCuB;EuE+kCvB,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,2CvEvlCyB;EuEwlCzB,mBAAmB;EACnB,kCvErlCsB,EAAA;;AuEwlCxB;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cvEzjCkB,EAAA;;AuE4jCpB;EACE,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCvE/mCuB,EAAA;;AuEknCzB;EACE,kBAAkB;EAClB,gCvEpnCuB;EuEqnCvB,mBAAmB,EAAA;;AAGrB;EACE,eAAe;EACf,gBAAgB;EAChB,cvEllCkB,EAAA;;AuEqlCpB;EACE,kBAAkB;EAClB,gCvEhoCuB,EAAA;;AuEmoCzB;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gCvE1oCkB,EAAA;;AuE6oCpB;EACE,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,cvE3mCkB,EAAA;;AuE8mCpB;EACE,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,eAAe,EAAA;;AAGjB;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB,EAAA;;AAGxB;EACE,SAAS;EACT,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,gCvE3qCkB;EuE4qClB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,kCvEtrCsB,EAAA;;AuEyrCxB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cvEnsCuB,EAAA;;AuEssCzB;;EAEE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cvE1qCkB,EAAA;;AuE6qCpB;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gCvE1tCuB;EuE2tCvB,qBAAqB,EAAA;;AAGvB;EACE,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;;AAGb;EACE,cAAc;EACd,kBAAkB;EAClB,cvEzuCuB,EAAA;;AuE4uCzB;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gCvEhvCkB,EAAA;;AuEmvCpB;EAnvCA;IAqvCI,0BAA0B,EAAA;EAhlC9B;IAolCI,gBAAgB,EAAA,EACjB;;AAIH;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB,EAAA;;AAGlB;EACE,mBvEhuCiB;EuEiuCjB,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB,EAAA;EAPlB;IAUI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gEAAoE,EAAA;IAbxE;MAgBM,SAAS;MACT,iBAAiB;MACjB,YAAY;MACZ,yBAAyB;MACzB,iBAAiB,EAAA;IApBvB;MAwBM,kBAAkB;MAClB,YAAY;MACZ,cAAc;MACd,iBAAiB;MACjB,eAAe;MACf,MAAM;MACN,eAAe;MACf,uBAAuB;MACvB,YAAY;MACZ,eAAe,EAAA;EAjCrB;IAsCI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,8BAA8B,EAAA;EA3ClC;IA+CI,OAAO;IACP,eAAe;IACf,yBAAyB;IACzB,SAAS;IACT,UAAU,EAAA;EAnDd;IAuDI,SAAS;IACT,kBAAkB;IAClB,gCvEp0CqB,EAAA;EuE2wCzB;IA6DI,cAAc;IACd,YAAY;IACZ,eAAe,EAAA;EAIjB;IAnEF;MAqEM,sBAAsB,EAAA;IArE5B;MAyEM,WAAW,EAAA;IAzEjB;;MA8EM,WAAW,EAAA,EACZ;;AAIL;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,mBAAmB,EAAA;;AAGrB;EACE,YAAY;EACZ,eAAe,EAAA;;AAGjB;EACE,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,gCvEj3CuB,EAAA;;AuEo3CzB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,yCvEr0Cc;EuEs0Cd,kCvE50CuB,EAAA;;AuE+0CzB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cvE70Cc;EuE80Cd,sBAAsB,EAAA;;AAGxB;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,+BvE34CuB,EAAA;;AuE84CzB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,mBAAmB,EAAA;;AAGrB;EACE,yCvE92CkB;EuE+2ClB,oBAAoB;EACpB,wBAAwB;EACxB,oCvEj3CkB;EuEk3ClB,cvEl3CkB;EuEm3ClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe,EAAA;EARjB;IAYI,mCvEz3CgB,EAAA;;AuE63CpB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cvEh4CkB;EuEi4ClB,0BAA0B;EAC1B,6BAA6B,EAAA;;AAG/B;EACE,gBAAgB,EAAA;;AAGlB;EACE,mBAAmB,EAAA;;AAGrB;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kCvEx7CsB,EAAA;;AuE27CxB;EACE,uBAAO,EAAA;;AAGT;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;EACnB,0CvEn6CkB;EuEo6ClB,uHAMG;EACH,sFvEp9CuB,EAAA;;AuEy9CzB;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,UAAU;EACV,aAAa;EACb,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,qCvEl+CuB;EuEm+CvB,cvEn+CuB;EuEo+CvB,kBAAkB;EAClB,cAAc;EACd,eAAe,EAAA;EAbjB;IAiBI,qCvE1+CqB,EAAA;;AuE8+CzB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;;AAGb;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cvEj9CkB,EAAA;;AuEo9CpB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cvElgDuB,EAAA;;AuEqgDzB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCvEzgDuB,EAAA;;AuE4gDzB;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,2CvElgDmB;EuEmgDnB,kCvEphDsB,EAAA;;AuEuhDxB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW,EAAA;;AAGb;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cvEhhDmB,EAAA;;AuEmhDrB;EACE,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cvE9hDmB,EAAA;;AuEiiDrB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cvE5jDuB,EAAA;EuE8jDvB;IACE,+BvE/jDqB;IuEgkDrB,gBAAgB,EAAA;;AAIpB;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gCvE5kDuB,EAAA;EuEokDzB;IAWI,cvExjDiB;IuEyjDjB,gBAAgB,EAAA;;AAIpB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,8CvEzlDuB,EAAA;;AuE4lDzB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cvE/jDkB,EAAA;;AuEkkDpB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCvE/mDuB,EAAA;;AuEknDzB;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yCvE5kDkB;EuE6kDlB,oBAAoB;EACpB,wBAAwB;EACxB,oCvE/kDkB;EuEglDlB,cvEhlDkB;EuEilDlB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe,EAAA;EAXjB;IAeI,mCvExlDgB,EAAA;;AuE4lDpB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,SAAS;EACT,wBAAwB;EACxB,mBAAmB;EACnB,2CvEhpDyB;EuEipDzB,kCvE7oDsB;EuE8oDtB,eAAe;EACf,iFAGuB,EAAA;EAbzB;IAgBI,sCvElnDgB;IuEmnDhB,kCvE9mDgB,EAAA;EuEinDlB;IACE,qCvEvnDgB;IuEwnDhB,kCvEnnDgB;IuEonDhB,oDvEznDgB,EAAA;EuE4nDlB;IACE,aAAa;IACb,mBAAmB,EAAA;IAFpB;MAKG,uCvExqDqB;MuEyqDrB,kCvErqDkB,EAAA;EuEyqDtB;IACE,uCvEzpDiB,EAAA;EuE4pDnB;IACE,sCvE3oDgB,EAAA;EuE8oDlB;IACE,uCvE9nDuB;IuE+nDvB,qDvE/nDuB,EAAA;EuEkoDzB;IACE,sCvE9nDgB;IuE+nDhB,oDvE/nDgB,EAAA;;AuEmoDpB;EACE,cAAc;EACd,kBAAkB;EAClB,qBvE5pDkB,EAAA;;AuE+pDpB;EACE,qBvE/oDyB,EAAA;;AuEkpD3B;EACE,qBvE9oDkB,EAAA;;AuEipDpB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,OAAO,EAAA;;AAGT;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY,EAAA;;AAGd;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY,EAAA;;AAGd;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,cvEjsDkB,EAAA;;AuEosDpB;EACE,cvErsDkB;EuEssDlB,qDAAoD,EAAA;;AAGtD;EACE,cvEzrDyB;EuE0rDzB,sDAA2D,EAAA;;AAG7D;EACE,cvEzrDkB;EuE0rDlB,qDAAoD,EAAA;;AAGtD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cvE/vDuB,EAAA;;AuEkwDzB;EACE,cvE1tDkB,EAAA;;AuE6tDpB;EACE,cvE7sDyB,EAAA;;AuEgtD3B;EACE,cvE5sDkB,EAAA;;AuE+sDpB;EACE,cAAc;EACd,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,2CvEnxDuB;EuEoxDvB,kCvE9wDsB;EuE+wDtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,+BvE3xDuB;EuE4xDvB,mBAAmB,EAAA;;AAGrB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,+BvE/yDuB,EAAA;;AuEkzDzB;EACE,cAAc;EACd,mBAAmB;EACnB,cvE9xDmB;EuE+xDnB,gBAAgB,EAAA;;AAGlB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,8BvEvwDc,EAAA;;AuE0wDhB;EACE,SAAS;EACT,kBAAkB;EAClB,cvE1zDU,EAAA;;AuE6zDZ;EACE,mBAAmB;EACnB,oBAAoB;EACpB,0CvEhyDkB;EuEiyDlB,mBAAmB;EACnB,+FAIC;EACD,cvEh1DuB;EuEi1DvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,8EAGoB,EAAA;EAlBtB;IAsBI,sCvEnzDgB;IuEozDhB,8FAIC,EAAA;EA3BL;IA+BI,aAAa;IACb,mBAAmB,EAAA;;AAIvB;EA9VA;IAgWI,0BAA0B,EAAA;EApJ9B;IAwJI,sBAAsB;IACtB,uBAAuB;IACvB,YAAY,EAAA,EACb;;AvE/4DH;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AwEv8BA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,UAAU,EAAA;EAET;;IAGG,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,uBAAuB,EAAA;EAK3B;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,oBAAoB;IACpB,mBxEKgB,EAAA;IwEVjB;MASK,UAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,YAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,YAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,YAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,YAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,YAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,YAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,YAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,YAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,YAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,aAFU,EAAA;IAPf;MASK,UAFU,EAAA;;AAQlB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,SAAS;EACT,gCxEpBkB,EAAA;;AwEuBpB;;EAEE,SAAS;EACT,gCxE1BkB;EwE2BlB,iBAAiB,EAAA;;AAGnB;EACE,SAAS;EACT,cxErBU,EAAA;;AwEwBZ;EACE,aAAa;EACb,kEAAkE;EAClE,SAAS;EACT,kBAAkB,EAAA;;AAGpB;;EAEE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2CxEjDkB;EwEkDlB,kCAAkC,EAAA;;AAGpC;;;EAGE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY,EAAA;;AAGd;EACE,SAAS;EACT,+BxEhEkB;EwEiElB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB,EAAA;;AAGxB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,+BAA+B;EAC/B,YAAY;EACZ,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,2CxE7FkB;EwE8FlB,iCAAiC;EACjC,cxE/FkB;EwEgGlB,gBAAgB;EAChB,eAAe,EAAA;;AAGjB;EACE,qCxE1DkB;EwE2DlB,8CxE3DkB,EAAA;;AwE8DpB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qDAA6D,EAAA;EAL/D;IAQI,WAAW;IACX,YAAY;IACZ,iBAAiB,EAAA;EAGnB;IACE,oEAA4H,EAAA;EAG9H;IAEE,0JAEiH,EAAA;;AAIrH;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW,EAAA;;AAGb;EACE,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,eAAe;EACf,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,qCxE9JkB;EwE+JlB,+BxE/JkB,EAAA;EwE0JpB;IAQI,cxEhGsB;IwEiGtB,oCxElGgB,EAAA;;AwEsGpB;EACE,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB,EAAA;EAHtB;IAMI,cAA2B;IAC3B,mCxEpJW,EAAA;EwE6If;IAWI,gCxElLgB;IwEmLhB,qCxEnLgB,EAAA;;AwEuLpB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CxE3LkB;EwE4LlB,qCxE5LkB;EwE6LlB,cxE7LkB;EwE8LlB,eAAe,EAAA;;AAGjB;;EAEE,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,2CxE9MkB;EwE+MlB,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;EAZd;;IAgBI,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,uBAAuB;IACvB,cxE1NgB;IwE2NhB,wBAAwB;IACxB,kBAAkB;IAClB,eAAe,EAAA;EAvBnB;IA2BI,qCxEjOgB,EAAA;EwEsMpB;IA+BI,cAAyB,EAAA;;AAI7B;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gCxE7OkB;EwE8OlB,iBAAiB;EACjB,gBAAgB,EAAA;;AAGlB;EACE,4CxEnPkB;EwEoPlB,mBAAmB;EACnB,uBAAuB;EACvB,+BxEtPkB;EwEuPlB,gBAAgB;EAChB,eAAe,EAAA;;AAGjB;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,+BxErQkB;EwEsQlB,kBAAkB,EAAA;EAElB;IACE,mBAAmB,EAAA;;AAIvB;EACE,+BxE9QkB;EwE+QlB,kBAAkB;EAClB,iBAAiB,EAAA;;AAGnB;EACE,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,SAAS;EACT,kBAAkB,EAAA;EALpB;IAQI,UAAU;IACV,sBAAsB;IACtB,+BxE7RgB;IwE8RhB,kBAAkB,EAAA;;AAItB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU,EAAA;;AAGZ;EACE,YAAY;EACZ,OAAO,EAAA;;AAGT;EACE,SAAS;EACT,gCxEpTkB;EwEqTlB,kBAAkB;EAClB,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,iBAAiB,EAAA;EAPnB;IAUI,kBAAkB;IAClB,SAAS;IACT,iCAAiC;IACjC,qBAAqB,EAAA;EAbzB;IAiBI,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,UAAU;IACV,eAAe;IACf,cAAc,EAAA;EAtBlB;IA0BI,kBAAkB;IAClB,eAAe;IACf,QAAQ,EAAA;;AAIZ;EACE,+BxE1VkB;EwE2VlB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB,EAAA;;AAG3B;EACE,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,0CxEhXkB;EwEiXlB,iCAAiC,EAAA;;AAGnC;EACE,OAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,+BxE7XkB;EwE8XlB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4EAA4E,EAAA;EAd9E;IAiBI,qCxE1VgB;IwE2VhB,oCxE3VgB;IwE4VhB,gCxEvYgB,EAAA;;AwE2YpB;EACE,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,oCxEnWmB;EwEoWnB,+BxEhZkB;EwEiZlB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB,EAAA;;AAGlB;EACE,YAAY,EAAA;;AAGd;EACE,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,4CxE/ZkB;EwEgalB,iCAAiC;EACjC,+BxEjakB;EwEkalB,iBAAiB;EACjB,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,0CxElbkB;EwEmblB,gCAAgC;EAChC,0DAA0D,EAAA;EAR5D;IAWI,sCxE3YiB;IwE4YjB,oCxE5YiB,EAAA;EwEgYrB;IAgBI,aAAa,EAAA;;AAIjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY,EAAA;;AAGd;EACE,gCxE/ckB;EwEgdlB,kBAAkB;EAClB,gBAAgB,EAAA;;AAGlB;EACE,gCxErdkB;EwEsdlB,kBAAkB;EAClB,gBAAgB,EAAA;;AAGlB;EACE,cAAc,EAAA;;AAGhB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB,EAAA;;AAGtB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;EAHb;IAMI,aAAa,EAAA;;AAIjB;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,YAAY;EACZ,gCxEpfkB;EwEqflB,kBAAkB,EAAA;;AAGpB;EACE,kCAAkC;EAClC,+BxE1fkB;EwE2flB,kBAAkB,EAAA;;AAGpB;EACE,WAAW;EACX,cAAc;EACd,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,eAAe;EACf,qBxEzdmB,EAAA;EwEkdrB;IAUI,aAAa;IACb,mBAAmB,EAAA;;AAIvB;;;EAGE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,2CxEnhBkB;EwEohBlB,qCxEphBkB;EwEqhBlB,cxE9gBiB;EwE+gBjB,wBAAwB,EAAA;;AAG1B;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gCxE9hBkB;EwE+hBlB,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS,EAAA;;AAGX;EACE,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,0CxEvjBkB;EwEwjBlB,iCAAiC,EAAA;;AAGnC;EACE,OAAO;EACP,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,+BxEhkBkB;EwEikBlB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4EAA4E,EAAA;EAV9E;IAaI,qCxE7hBgB;IwE8hBhB,oCxE9hBgB;IwE+hBhB,gCxE1kBgB,EAAA;;AwE8kBpB;EACE,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,0CxExlBkB;EwEylBlB,iCAAiC,EAAA;;AAGnC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB,EAAA;;AAGrB;EACE,SAAS;EACT,gCxEpmBkB,EAAA;;AwEumBpB;EACE,kBAAkB;EAClB,gCxEzmBkB,EAAA;;AwE4mBpB;EACE,aAAa;EACb,YAAY,EAAA;;AAGd;EACE,oBAAoB;EACpB,2CxEnnBkB;EwEonBlB,uBAAuB;EACvB,+BxErnBkB;EwEsnBlB,sBAAsB;EACtB,eAAe,EAAA;EANjB;IASI,sCxE/kBgB;IwEglBhB,oCxEhlBgB,EAAA;;AwEolBpB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,4CxEpoBkB;EwEqoBlB,kCxE/nBY;EwEgoBZ,YAAY;EACZ,iBAAiB,EAAA;EAEjB;IACE,uBAAuB,EAAA;EAGzB;IACE,mBAAmB;IACnB,gBAAgB,EAAA;EAhBpB;IAqBI,sCxEzmBgB,EAAA;EwEolBpB;IAyBI,eAAe;IACf,YAAY,EAAA;;AAIhB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;EAyBpB,yGAAyG,EAAA;EApC3G;IAcI,gBAAgB,EAAA;EAdpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,sBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,qBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,oBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,kBAAc,EAAA;EAnBpB;IAmBM,kBAAc,EAAA;EAnBpB;IAmBM,kBAAc,EAAA;EAnBpB;IAmBM,kBAAc,EAAA;EAnBpB;IAmBM,kBAAc,EAAA;EAnBpB;IAmBM,kBAAc,EAAA;EAnBpB;IAmBM,kBAAc,EAAA;EAnBpB;IAmBM,kBAAc,EAAA;EAnBpB;IAmBM,kBAAc,EAAA;EAnBpB;IAmBM,kBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAmBM,mBAAc,EAAA;EAnBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,qBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,oBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,kBAAc,EAAA;EAzBpB;IAyBM,kBAAc,EAAA;EAzBpB;IAyBM,kBAAc,EAAA;EAzBpB;IAyBM,kBAAc,EAAA;EAzBpB;IAyBM,kBAAc,EAAA;EAzBpB;IAyBM,kBAAc,EAAA;EAzBpB;IAyBM,kBAAc,EAAA;EAzBpB;IAyBM,kBAAc,EAAA;EAzBpB;IAyBM,kBAAc,EAAA;EAzBpB;IAyBM,kBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAyBM,mBAAc,EAAA;EAzBpB;IAgCM,YAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,YAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,YAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,YAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,YAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,UAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,YAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,YAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,YAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,YAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,YAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,YAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,YAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,YAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,YAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,UAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,YAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,YAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,YAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,YAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,YAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,YAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,YAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,YAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,YAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,aAAQ,EAAA;EAhCd;IAgCM,UAAQ,EAAA;;AAOd;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,mBxExsBkB,EAAA;EwEmsBpB;IASM,UAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,YAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,YAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,YAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,YAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,YAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,YAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,YAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,YAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,YAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,aAFU,EAAA;EAPhB;IASM,UAFU,EAAA;;AAOhB;EACE,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,gCxEttBkB,EAAA;;AwEytBpB;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gCxEpuBkB;EwEquBlB,iBAAiB;EACjB,OAAO;EACP,gBAAgB,EAAA;;AAGlB;EACE,aAAa,EAAA;;AAGf;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBxE7uBiB,EAAA;;AwEgvBnB;EACE,SAAS;EACT,8BxE9sBkB;EwE+sBlB,kBAAkB,EAAA;;AAGpB;EACE,SAAS;EACT,cxEpvBU;EwEqvBV,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,0CxEzwBkB;EwE0wBlB,iCAAiC,EAAA;;AAGnC;EACE,SAAS;EACT,gCxE/wBkB,EAAA;;AwEkxBpB;EACE,SAAS;EACT,+BxEpxBkB;EwEqxBlB,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,kBAAkB,EAAA;EAJpB;IAOI,QAAQ,EAAA;EAPZ;IAWI,QAAQ,EAAA;;AAIZ;EAfA;IAiBI,0BAA0B,EAAA,EAC3B;;AAGH;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gCxEvzBkB;EwEwzBlB,yBAAyB,EAAA;;AAI3B;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,QAAQ,EAAA;;AAGV;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB,EAAA;;AAGtB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,UAAU,EAAA;;AAGZ;EACE,YAAY,EAAA;;AAGd;EACE,gBAAgB;EAChB,cxEx2BkB;EwEy2BlB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB,EAAA;;AAGzB;;;EAGE,iBAAiB;EACjB,gCxEl3BkB;EwEm3BlB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB,EAAA;;AAGzB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY,EAAA;;AAGd;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc,EAAA;;AAGhB;EACE,kBAAkB;EAClB,gCxEz4BkB,EAAA;;AwE44BpB;;EAEE,SAAS;EACT,kBAAkB,EAAA;;AAGpB;EACE,gCxEn5BkB,EAAA;;AwEs5BpB;EACE,cxE54BU,EAAA;;AArCZ;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AyEj8BA;EACI,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAA;EAHb;IAMQ,UAAU,EAAA;EANlB;IAUQ,UAAU,EAAA;;AAIlB;EAEQ,YAAY;EACZ,aAAa,EAAA;;AAHrB;EAOQ,yBzEgDY;EyE/CZ,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,yBzESU,EAAA;;AyEpBlB;EAeQ,czENiB,EAAA;EyETzB;IAkBY,iBAAiB;IACjB,czEVa,EAAA;EyETzB;IAuBY,czEda,EAAA;IyETzB;MA2BgB,czEZQ,EAAA;;AyEfxB;EAiCQ,aAAa,EAAA;EAjCrB;IAoCY,kBAAkB;IAClB,iBAAiB;IACjB,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,czE3BY,EAAA;EyEfxB;;IAgDgB,YAAY;IACZ,YAAY,EAAA;EAjD5B;IAsDY,aAAa;IACb,2BAA2B,EAAA;;AAWvC;EAEI,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gEAAoE;EACpE,uBAAuB;EACvB,czEhEqB;EyEiErB,iBAAiB;EACjB,yBAAyB;EACzB,gCzElEgB;EyEmEhB,0BAA0B,EAAA;;AAX9B;EAeI,SAAS;EACT,gBAAgB,EAAA;;AAhBpB;EAoBI,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe,EAAA;EAxBnB;IA2BM,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe,EAAA;IAhCrB;MAmCQ,UAAU,EAAA;;AAnClB;EAyCI,aAAa;EACb,mBzEvDe,EAAA;;AyEanB;EA8CI,gBAAgB;EAChB,czEvGgB;EyEwGhB,iBAAiB,EAAA;;AAhDrB;EAoDI,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,yBzE9GiB;EyE+GjB,kBAAkB;EAClB,mBzE7GoB;EyE8GpB,czEpHqB;EyEqHrB,+CAA+C;EAC/C,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB,EAAA;EzEinBtB;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;;AyEjsBjE;EAsEI,aAAa;EACb,eAAe;EACf,WAAW;EACX,yBAAyB,EAAA;;AAI7B;EAII,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gEAAqE;EACrE,yBAAyB;EACzB,czE/IqB;EyEgJrB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,gCzElJgB;EyEmJhB,8BAA8B,EAAA;EAdlC;IAiBM,SAAS;IACT,gBAAgB,EAAA;EAlBtB;IAsBQ,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,eAAe,EAAA;IA1BvB;MA6BU,kBAAkB;MAClB,YAAY;MACZ,kBAAkB;MAClB,mBAAmB;MACnB,gBAAgB;MAChB,eAAe,EAAA;MAlCzB;QAqCY,UAAU,EAAA;;AArCtB;EA4CI,aAAa;EACb,WAAW;EACX,mBzExIe;EyEyIf,qBAAqB,EAAA;EA/CzB;IAkDM,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,WAAW,EAAA;EAtDjB;IA0DM,kBAAkB,EAAA;IA1DxB;MA8DQ,YAAY;MACZ,mBAAmB;MACnB,eAAe,EAAA;IAhEvB;MAoEQ,kBAAkB;MAClB,aAAa;MACb,YAAY,EAAA;IAtEpB;MA0EQ,sBAAsB;MACtB,aAAa;MACb,WAAW,EAAA;IA5EnB;MAgFQ,kBAAkB;MAClB,czEvNiB,EAAA;IyEsIzB;MAqFQ,WAAW;MACX,eAAe;MACf,YAAY;MACZ,oBAAoB;MACpB,gBAAgB;MAChB,kCzE/KgB,EAAA;MyEqFxB;QA6FU,kCzElLc;QyEmLd,oBAAoB,EAAA;MA9F9B;QAkGU,uDAAgE;QAChE,oBAAoB,EAAA;MAnG9B;QAuGU,uDAAgE;QAChE,oBAAoB,EAAA;EAxG9B;;IAgHQ,YAAY;IACZ,mBAAmB;IACnB,eAAe,EAAA;EAlHvB;;IAsHQ,aAAa;IACb,uBAAuB;IACvB,SAAS,EAAA;;AAMjB;EACI,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,yBzEpQU;EyEqQV,UAAU;EACV,kBAAkB;EAClB,gBAAgB,EAAA;EzEgehB;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;EyEtfjE;IAWQ,gBAAgB;IAChB,WAAW;IzE0WjB,aAAa;IACb,8BAA8B;IAC9B,cA5nBuB;IA6nBvB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gCA7nBY;IA8nBZ,8BAA8B;IAC9B,mHAAiF,EAAA;IyE/XnF;MAgBY,aAAa;MACb,YAAY;MACZ,gBAAgB;MAChB,iBAAiB;MACjB,kBAAkB,EAAA;MApB9B;QAuBgB,kBAAkB;QAClB,YAAY;QACZ,mBAAmB;QACnB,gBAAgB;QAChB,eAAe,EAAA;QA3B/B;UA8BoB,UAAU,EAAA;EA9B9B;;IAsCQ,iBAAiB,EAAA;IAtCzB;;MAyCY,eAAe;MACf,iBAAiB,EAAA;IA1C7B;;MA8CU,aAAa;MACb,sBAAsB;MACtB,eAAe;MACf,uBAAuB,EAAA;MAjDjC;;QAoDY,aAAa;QACb,SAAS;QACT,mBAAmB,EAAA;MAtD/B;;QA0DY,iBAAiB;QACjB,gBAAgB,EAAA;QzE4axB;;UACI,UAjKa,EAAA;QAoKjB;;UACI,mBApKuB;UAqKvB,kBAAkB;UAClB,kBAAkB,EAAA;QAGtB;;UACI,yBA3uBU;UA4uBV,kBAAkB,EAAA;UAElB;;YACI,yBAAqD,EAAA;IyEtfjE;;MAiEY,8BAA8B;MAC9B,gBAAgB,EAAA;MzEqaxB;;QACI,UAjKa,EAAA;MAoKjB;;QACI,mBApKuB;QAqKvB,kBAAkB;QAClB,kBAAkB,EAAA;MAGtB;;QACI,yBA3uBU;QA4uBV,kBAAkB,EAAA;QAElB;;UACI,yBAAqD,EAAA;IyEtfjE;;MAuEY,mBAAmB,EAAA;MAvE/B;;QA0EgB,czE9US;QyE+UT,iBAAiB;QACjB,kBAAkB,EAAA;MA5ElC;;;;;;QAkFgB,YAAY;QACZ,WAAW;QACX,yBzExVS;QyEyVT,kBAAkB,EAAA;EArFlC;IA2FQ,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB,EAAA;EA9F3B;IAkGQ,iBAAiB;IACjB,gBAAgB,EAAA;IAnGxB;MAsGY,gBAAgB,EAAA;;AAK5B;;EAEE,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc,EAAA;EAHhB;IAMI,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,eAAe,EAAA;IAZnB;MAeM,gBAAgB;MAChB,WAAW;MACX,iBAAiB,EAAA;;AAUvB;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,cAAc;EACd,YAAY,EAAA;EALd;IAQI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,iBAAiB;IACjB,mBzE7WqB;IyE8WrB,yBzEnZc;IyEoZd,kBAAkB,EAAA;EAhBtB;IAoBI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,YAAY,EAAA;EAxBhB;IA4BI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,czEhbqB,EAAA;EyE+YzB;IAqCI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,mBzEvbU;IyEwbV,yBzEzbiB;IyE0bjB,czE5bgB;IyE6bhB,kBAAkB;IAClB,gBAAgB,EAAA;EAhDpB;IAoDI,uBAAuB;IACvB,oBAAoB;IACpB,yBzE/YY;IyEgZZ,czEhZY;IyEiZZ,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB,EAAA;EA3D7B;IA+DI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,iBAAiB,EAAA;EApErB;;;IA0EI,cAAc,EAAA;EA1ElB;IA8EI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,mBzEjbqB;IyEkbrB,iBAAiB;IACjB,+BAA+B;IAC/B,yBzEzdc;IyE0dd,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,mBAAmB,EAAA;IzEmQnB;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;EyE3WjE;IA8FI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;IACb,0BzE/eiB;IyEgfjB,kBAAkB;IAClB,kCzE9eoB,EAAA;EyEyYxB;IAyGI,aAAa;IACb,uBAAuB;IACvB,+BAA+B,EAAA;EA3GnC;IA+GI,SAAS;IACT,iBAAiB;IACjB,gCzEhgBqB,EAAA;EyE+YzB;IAqHI,SAAS;IACT,kBAAkB;IAClB,czErgBgB;IyEsgBhB,iBAAiB;IACjB,kBAAkB,EAAA;EAzHtB;IA6HI,+BAA+B,EAAA;EA7HnC;IAiII,mBzE3gBe;IyE4gBf,kBAAkB;IAClB,yBzE/gBiB;IyEghBjB,gBAAgB;IAChB,0DAA0D,EAAA;IArI9D;MAwIM,qBzE5eQ;MyE6eR,0CAA0C,EAAA;MAzIhD;QA4IQ,2CzEhfM,EAAA;IyEoWd;MAiJM,aAAa,EAAA;EAjJnB;IAsJI,wCAAwC,EAAA;EAtJ5C;IA0JI,oBAAoB;IACpB,wCAAwC;IACxC,gDAAgD;IAChD,yBzEhgBe;IyEigBf,+BAA+B,EAAA;;AAKnC;EACE;IACE,UAAU;IACV,2BAA2B,EAAA;EAE7B;IACE,UAAU;IACV,wBAAwB,EAAA,EAAA;;AAI5B;EACE;IACE,UAAU;IACV,2BAA2B,EAAA;EAE7B;IACE,UAAU;IACV,wBAAwB,EAAA,EAAA;;AAY5B;EAEI,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EAoLN,qFAAA,EAAsF;EA3L1F;IAUM,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,kBAAkB,EAAA;IAdxB;MAiBQ,kBAAkB,EAAA;IAjB1B;MAqBQ,uBAAuB;MACvB,kBAAkB,EAAA;MAtB1B;QAyBU,WAAW,EAAA;IAzBrB;MA8BQ,iBAAiB;MACjB,gBAAgB;MAChB,czE/mBY,EAAA;IyE+kBpB;;MAqCQ,sBAAsB;MACtB,kBAAkB;MAClB,uBAAuB;MACvB,iBAAiB;MACjB,WAAW;MACX,gBAAgB,EAAA;MA1CxB;;QA6CU,aAAa;QACb,kBAAkB,EAAA;EA9C5B;IAoDM,aAAa,EAAA;EApDnB;IAwDM,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,oBAAoB,EAAA;EA5D1B;IAgEM,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,czEnpBc,EAAA;EyE+kBpB;IAwEM,WAAW;IACX,yBzEtpBe;IyEupBf,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;IACjB,mBzE7pBmB;IyE8pBnB,czExpBkB,EAAA;IyE0kBxB;MAiFQ,mBAAmB;MACnB,cAAc;MACd,mBAAmB,EAAA;IAnF3B;MAuFQ,aAAa;MACb,qBzEvqBY,EAAA;EyE+kBpB;IA6FM,uBAAuB;IACvB,4CzE3qBe;IyE4qBf,kCzEzqBkB,EAAA;EyE0kBxB;IAmGM,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB,EAAA;IA5GvB;MA+GQ,mBAAmB;MACnB,cAAc;MACd,mBAAmB;MACnB,UAAU,EAAA;EAlHlB;IAuHM,kBAAkB;IAClB,aAAa;IACb,yCAAyC;IACzC,eAAe;IACf,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,6DAAqE;IACrE,oCAAoC;IACpC,0CAA0C,EAAA;EAhIhD;IAoIM,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,WAAW;IACX,yBzExtBe;IyEytBf,kBAAkB;IAClB,mBzEztBQ;IyE0tBR,czE7tBc;IyE8tBd,eAAe;IACf,2EAA2E,EAAA;IAhJjF;MAmJQ,WAAW;MACX,cAAc;MACd,UAAU;MACV,WAAW;MACX,cAAc;MACd,oCAAoC;MACpC,qCAAqC;MACrC,8CAA8C;MAC9C,gCAAgC,EAAA;IA3JxC;MA+JQ,+CAA+C,EAAA;IA/JvD;MAmKQ,qBzEjvBmB;MyEkvBnB,czEpvBiB,EAAA;EyEglBzB;IAyKM,kBAAkB;IAClB,QAAQ;IACR,UAAU,EAAA;EA3KhB;;;IAiLM,kBAAkB;IAClB,UAAU,EAAA;EAlLhB;IAsLM,WAAW;IACX,SAAS;IACT,YAAY,EAAA;EAxLlB;IA6LM,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,mBAAmB,EAAA;EAvMzB;IA2MM,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB,EAAA;EA9MvB;IAkNM,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCzEtyBmB;IyEuyBnB,cAAc,EAAA;EAvNpB;IA2NM,aAAa;IACb,iBAAiB;IACjB,kBAAkB,EAAA;EA7NxB;;IAkOM,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB,EAAA;EAxOvB;IA4OM,iBAAiB,EAAA;;AAMvB;EACE,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,MAAM;EACN,uBAAuB;EACvB,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,UAAU,EAAA;;AAGZ;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,2ZAM6E;EAC7E,4BAA4B,EAAA;;AAI9B;EACE,yBzE11BU;EyE21BV,mBzEp2BuB,EAAA;;AyEu2BzB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd,4BAAA;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,UAAU,EAAA;;AAGZ,oBAAA;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,WAAW,EAAA;;AAGb,uBAAA;AAEA;EACE,YAAY;EACZ,czEt4BuB;EyEu4BvB,eAAe;EACf,kBAAkB,EAAA;;AAEpB;EAAsB,gBAAgB,EAAA;;AAEtC,sBAAA;AAEA;EACE,kBAAkB;EAClB,czEh5BuB;EyEi5BvB,kBAAkB,EAAA;;AAGpB,sBAAA;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,mBzE55BuB;EyE65BvB,yBzEl3BY;EyEm3BZ,kBAAkB;EAClB,czEz5BsB;EyE05BtB,iBAAiB,EAAA;;AAGnB;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB,EAAA;;AAGpB,uBAAA;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,mBzEr7BuB;EyEs7BvB,yBzE34BY;EyE44BZ,kBAAkB;EAClB,kBAAkB;EAClB,czEn7BsB;EyEo7BtB,gBAAgB,EAAA;;AAGlB,uBAAA;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB,EAAA;;AAGpB,sBAAA;AAEA;;EAEE,gDAAgD;EAAE,wDAAA,EAAyD;;AAG7G;;EAEE,+BAA+B;EAAE,mBAAA,EAAoB;;AAGvD;EACE,+CAA+C;EAAE,yDAAA,EAA0D;;AAG7G;EACE,yCAAyC;EAAE,oCAAA,EAAqC;;AAGlF;EACE,2CAA2C;EAAE,uCAAA,EAAwC;;AAGvF;EACE,0BAA0B;EAAE,eAAA,EAAgB;;AAG9C,iCAAA;AACA,iCAAA;AACA,iCAAA;AAEA;EAEI,YAAY;EACZ,kBAAkB;EAClB,mBAAmB,EAAA;EAJvB;IAOM,YAAY;IACZ,YAAY;IACZ,kBACF,EAAA;;AAIJ,kCAAA;AAEA;;EAEE,mBAAmB;EACnB,6BAA6B,EAAA;;AAG/B;EACE,aAAa;EACb,SAAS,EAAA;;AAGX;;EAEE,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,QAAQ;EACR,mBAAmB,EAAA;;AAGrB;;EAEE,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB,EAAA;;AAGlB;;EAEE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB,EAAA;;AAIpB,iCAAA;AACA,iCAAA;AACA,iCAAA;AAEA;EACE,kBAAkB;EAElB,WAAA;EASA,SAAA;EAgBA,WAAA,EAAY;EA5Bd;;IzE5cE,mHAAiF;IACjF,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IyEgdzB,czEviCqB;IyEwiCrB,kBAAkB;IAClB,kBAAkB,EAAA;EATtB;IAgBI,kBAAkB;IAClB,eAAe;IACf,8BzE9iCU,EAAA;IyE4hCd;MAqBM,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,QAAQ,EAAA;EAxBd;;IAgCI,sBAAsB,EAAA;EAhC1B;IAoCI,YAAY;IACZ,iBAAiB;IACjB,mBzErkCgB;IyEskChB,YAAY;IACZ,yBzE7hCU;IyE8hCV,kBAAkB;IAClB,kBAAkB;IAClB,czErkCoB;IyEskCpB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW,EAAA;;AAOf;EACE,kBAAkB;EAClB,WAAW,EAAA;EAFb;IAKI,aAAa;IACb,mBAAmB;IACnB,gBAAgB,EAAA;IAPpB;MAUM,kBAAkB;MAClB,aAAa;MACb,sBAAsB;MACtB,SAAS;MACT,wBAAwB;MACxB,mBAAmB;MACnB,YAAY;MACZ,SAAS,EAAA;MAjBf;QAoBQ,aAAa;QACb,mBAAmB;QACnB,mBAAmB,EAAA;QAtB3B;;UA0BU,cAAc;UACd,YAAY;UACZ,WAAW,EAAA;;AAOrB;;EAEE,kBAAkB;EAClB,WAAW,EAAA;EAHb;;IAMI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,2BAA2B,EAAA;IAT/B;;;;MAaM,kBAAkB;MAClB,aAAa;MACb,sBAAsB;MACtB,SAAS;MACT,wBAAwB;MACxB,mBAAmB;MACnB,YAAY;MACZ,SAAS,EAAA;MApBf;;;;;;;;QAwBQ,aAAa;QACb,mBAAmB;QACnB,mBAAmB,EAAA;QA1B3B;;;;;;;;;;;;;;;;UA8BU,cAAc;UACd,YAAY;UACZ,WAAW,EAAA;;AAOrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB,EAAA;;A1DjoClB;E0DqoCE,yBAAyB;EACzB,czExqCuB,EAAA;;AeuCzB;E0DqoCE,aAAa;EACb,mBAAmB;EACnB,mBAAmB,EAAA;;AAIrB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB,EAAA;;AAGzB;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB,EAAA;;AAGxB;EACE,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,cAAc;EACd,sBAAsB,EAAA;;AAIxB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB,EAAA;;AAGzB;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB,EAAA;;AAGxB;EACE,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,cAAc;EACd,sBAAsB,EAAA;;AAMxB;EACE,kBAAkB;EAClB,SAAS;EACT,cAAc,EAAA;;AAGhB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,SAAS;EACT,yBzE5uCmB;EyE6uCnB,kBAAkB;EAClB,mBzE7uCY;EyE8uCZ,czElvCuB;EyEmvCvB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,0DAA0D,EAAA;EAnB5D;IAsBI,qBzE5vCuB;IyE6vCvB,mBzE5vCiB,EAAA;;AyEgwCrB;EACE,qBzE5uCa;EyE6uCb,mCzE7uCa,EAAA;EyE2uCf;;IAMI,czEjvCW,EAAA;;AyEqvCf;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,czEhxCkB,EAAA;;AyEmxCpB;EACE,YAAY,EAAA;;AAGd;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,czE3xCkB,EAAA;;AyE8xCpB;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBzEpyCiB;EyEqyCjB,yBzEvyCmB;EyEwyCnB,kBAAkB;EAClB,0CAA0C,EAAA;EzEjkBxC;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;;AyEsjBjE;EACE,SAAS;EACT,kBAAkB;EAClB,czElzCkB;EyEmzClB,eAAe;EACf,kBAAkB,EAAA;;AAGpB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU,EAAA;;AAGZ;EACE,iBAAiB;EACjB,czEh0CuB;EyEi0CvB,eAAe,EAAA;EAHjB;IAMI,mBzEh0CU,EAAA;;AyEo0Cd;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,czE50CkB,EAAA;;AyE+0CpB;EACE,sBAAsB,EAAA;;AAGxB,+CAAA;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iCAAiC;EACjC,0BAA0B,EAAA;;AAG5B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,4BAAuC;EACvC,mBAAmB;EACnB,0CzE/zCmB;EyEg0CnB,0GzE1zCuB;EyE6zCvB,2CAA2C;EAC3C,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,qCAAqC;EACrC,iDzE70CmB;EyE80CnB,wGzEz0CiB,EAAA;;AyE80CnB;EACE,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gCzEv4CuB,EAAA;;AyE04CzB;EACE,SAAS;EACT,oCAA+C;EAC/C,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,czEh5CuB;EyEi5CvB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,0CzE33CmB;EyE43CnB,kCzEr3CsB;EyEs3CtB,czEt6CkB;EyEu6ClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB,EAAA;EAEnB;IACE,qCzEz3CY;IyE03CZ,czE13CY;IyE23CZ,mCzE13CiB,EAAA;;AyE83CrB;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,yCzEl5CmB;EyEm5CnB,kBAAkB;EAClB,kCzE74CsB;EyE84CtB,czE97CkB;EyE+7ClB,eAAe;EACf,kFAAkF,EAAA;EAZpF;IAgBI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,WAAW;IACX,wBAAwB;IACxB,wBAAwB,EAAA;EAvB5B;IA2BI,8CAA8C,EAAA;EA3BlD;IA+BI,+CAA+C,EAAA;EA/BnD;IAoCI,uCzEt6CuB;IyEu6CvB,czEv6CuB;IyEw6CvB,kCzEr9CoB,EAAA;;AyEy9CxB;EACE,uCzE76CyB;EyE86CzB,czE96CyB;EyE+6CzB,kCzEj7CsB,EAAA;;AyEo7CxB;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,qBAAqB;EACrB,iDzEj8CmB;EyEk8CnB,iCzE77CiB,EAAA;;AyEg8CnB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,eAAe,EAAA;;AAGjB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY,EAAA;;AAGd;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,0CzEz9CmB;EyE09CnB,kBAAkB;EAClB,kCzEp9CsB;EyEq9CtB,czEtgDuB;EyEugDvB,oCAA+C;EAC/C,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB,EAAA;EAZ3B;IAeI,gCzE7gDqB;IyE8gDrB,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB,EAAA;EAlBpB;IAsBI,aAAa;IACb,uCzEl+CuB;IyEm+CvB,+CzEn+CuB,EAAA;;AyEu+C3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,eAAe;EACf,SAAS;EACT,UAAU;EACV,yCzEz/CmB;EyE0/CnB,kBAAkB;EAClB,kCzEp/CsB;EyEq/CtB,eAAe;EACf,gEAAgE,EAAA;EAblE;IAgBI,cAAc;IACd,eAAe;IACf,0HAA0H,EAAA;EAlB9H;IAuBI,uCzE9/CuB;IyE+/CvB,kCzE5iDoB,EAAA;;AyEgjDxB;EACE,aAAa;EACb,kFAAkF;EAClF,oBAAoB,EAAA;EAEpB;IALF;MAMI,8BAA8B,EAAA,EAMjC;EAHC;IATF;MAUI,0BAA0B,EAAA,EAE7B;;AAED;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCzEhlDuB,EAAA;;AyEmlDzB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,czErlDkB;EyEslDlB,uBAAuB,EAAA;;AAGzB;;;EAGE,cAAc;EACd,YAAY;EACZ,SAAS;EACT,wBAAwB;EACxB,0CzEvjDmB;EyEwjDnB,kBAAkB;EAClB,iCzEljDsB;EyEmjDtB,czEnmDkB;EyEomDlB,kBAAkB,EAAA;EAXpB;;;IAcI,aAAa;IACb,uCzEtjDuB;IyEujDvB,+CzEvjDuB,EAAA;;AyE2jD3B;EACE,eAAe,EAAA;;AAGjB;EACE,gBAAgB;EAChB,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,+BzEznDuB,EAAA;;AyE4nDzB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,cAAc,EAAA;;AAGhB;EACE,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,czEplDc,EAAA;;AyEulDhB;EACE,czExlDc,EAAA;;AyE2lDhB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB,EAAA;;AAGtB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY,EAAA;EAEZ;IACE,wBAAwB;IACxB,kBAAkB;IAClB,0CzE5mDkB;IyE6mDlB,oCzE7mDkB,EAAA;;AyEinDtB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY,EAAA;;AAGd;EACE,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,0CzEvoDmB;EyEwoDnB,kBAAkB;EAClB,kCzEloDsB;EyEmoDtB,czEnrDkB;EyEorDlB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,kFAAkF,EAAA;EAbpF;IAiBI,sCzErpDgB;IyEspDhB,czE/rDqB;IyEgsDrB,iCzEjpDe,EAAA;;AyEqpDnB;EACE,SAAS;EACT,kBAAkB;EAClB,czElpDoB;EyEmpDpB,kBAAkB;EAClB,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCzEjtDuB,EAAA;;AyEotDzB;EACE,aAAa;EACb,eAAe;EACf,YAAY,EAAA;;AAGd;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,0CzErrDmB;EyEsrDnB,kCzE/qDsB;EyEgrDtB,czEhuDkB;EyEiuDlB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAA;EAEnB;IACE,uCzEprDuB;IyEqrDvB,czErrDuB,EAAA;EyEwrDzB;IACE,qCzEnsDgB;IyEosDhB,czEpsDgB,EAAA;;AyEwsDpB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,cAAc,EAAA;EAEb;;IAGG,oBAAoB;IACpB,iBAAiB;IACjB,aAAa,EAAA;;AAKnB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iCzE3tDiB;EyE4tDjB,oBAAoB,EAAA;;AAGtB;EACE,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,0CzEzuDmB;EyE0uDnB,kCzEnuDsB;EyEouDtB,czEpxDkB;EyEqxDlB,kBAAkB;EAClB,kBAAkB,EAAA;;AAGpB;EACE,iDzEjvDmB;EyEkvDnB,iCzE7uDiB,EAAA;;AyEgvDnB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,qBAAqB,EAAA;;AAGvB;EACE,YAAY,EAAA;;AAGd;EACE,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gCzEhzDuB,EAAA;;AyEmzDzB;EACE,mBAAmB;EACnB,czErzDuB;EyEszDvB,kBAAkB;EAClB,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,0CzEpxDmB;EyEqxDnB,kBAAkB;EAClB,kCzE/wDsB;EyEgxDtB,czEh0DkB;EyEi0DlB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,kFAAkF,EAAA;EAbpF;IAiBI,sCzElyDgB;IyEmyDhB,czE50DqB;IyE60DrB,iCzE9xDe,EAAA;;AyEkyDnB;EACE,uBAAuB,EAAA;;AAGzB;EACE,SAAS;EACT,wBAAwB;EACxB,+BzEx1DuB;EyEy1DvB,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,iDAAiD;EACjD,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,0CzE/zDmB;EyEg0DnB,kCzEzzDsB;EyE0zDtB,czE32DuB,EAAA;EyE62DvB;IACE,sCzEr0DgB;IyEs0DhB,oCzEt0DgB,EAAA;EyEy0DlB;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,cAAc;IACd,SAAS;IACT,UAAU;IACV,wCzEv3DiB;IyEw3DjB,kBAAkB;IAClB,kCzE30DoB;IyE40DpB,czE53DgB;IyE63DhB,kBAAkB;IAClB,cAAc;IACd,YAAY,EAAA;IAdb;MAiBG,aAAa;MACb,mBAAmB,EAAA;IAlBtB;MAsBG,gBAAgB,EAAA;EAIpB;IACE,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB,EAAA;EAGlB;IACE,cAAc;IACd,gCzEr5DqB;IyEs5DrB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB,EAAA;;AAIvB;EACE,aAAa;EACb,0DAA0D;EAC1D,YAAY;EACZ,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB,EAAA;EAEhB;IATF;MAUI,0BAA0B;MAC1B,gBAAgB,EAAA;MzE9rChB;QACI,UAjKa,EAAA;MAoKjB;QACI,mBApKuB;QAqKvB,kBAAkB;QAClB,kBAAkB,EAAA;MAGtB;QACI,yBA3uBU;QA4uBV,kBAAkB,EAAA;QAElB;UACI,yBAAqD,EAAA,EACxD;;AyEmrCT;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,0CzE54DmB;EyE64DnB,kCzEt4DsB,EAAA;;AyEy4DxB;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCzEj8DuB,EAAA;;AyEo8DzB;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,0CzE/5DmB,EAAA;;AyEk6DrB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,SAAS;EACT,gBAAgB,EAAA;EANlB;IASI,WAAW;IACX,mBAAmB,EAAA;EAVvB;IAcI,cAAc,EAAA;EAdlB;IAkBI,cAAc;IACd,aAAa;IACb,cAAc;IACd,8CzEv7DiB,EAAA;IAisBjB;MACI,UAjKa,EAAA;IAoKjB;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;QACI,yBAAqD,EAAA;EyEktCjE;;IA2BI,wBAAwB,EAAA;EA3B5B;;IAgCI,qBAAqB,EAAA;EAhCzB;;IAqCI,kBAAkB;IAClB,aAAa;IACb,sBAAsB,EAAA;EAvC1B;;IA4CI,kBAAkB;IAClB,aAAa,EAAA;EA7CjB;IAiDI,aAAa,EAAA;EAjDjB;IAqDI,eAAe;IACf,8DAA8D,EAAA;IAtDlE;MAyDM,oCzE39De;MyE49Df,oDzE79Dc,EAAA;IyEm6DpB;MA8DM,czE1gEmB,EAAA;;AyE+gEzB;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,czElhEkB;EyEmhElB,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,gBAAgB,EAAA;EAEhB;IACE,cAAc;IACd,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;IACb,2CzE5/DiB;IyE6/DjB,kBAAkB;IAClB,iCzEz/De,EAAA;IyEg/DhB;MAYG,SAAS;MACT,kBAAkB;MAClB,czE5iEc;MyE6iEd,kBAAkB;MAClB,kBAAkB,EAAA;;AAKxB;;EAEE,cAAc,EAAA;;AAGhB;EACE,uBAAuB;EACvB,iDzEjhEmB,EAAA;;AyEohErB;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,czElkEuB,EAAA;;AyEqkEzB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,iCzE5hEiB;EyE6hEjB,0CzEliEmB,EAAA;EyEoiEnB;IACE,sCzE1hEkB;IyE2hElB,oCzE3hEkB,EAAA;;AyE+hEtB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,SAAS;EACT,iBAAiB,EAAA;;AAGnB;EACE,gCzE9lEuB,EAAA;;AyEimEzB;EACE,gBAAgB;EAChB,czEnmEuB,EAAA;;AyEsmEzB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,czErjEoB,EAAA;;AyEwjEtB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,cAAc,EAAA;EzEx4CZ;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;;AyE63CjE;EACE,aAAa;EACb,+DAA+D;EAC/D,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,iCzE/kEiB;EyEglEjB,yCzErlEmB,EAAA;;AyEwlErB;EACE,iBAAiB;EACjB,czEpoEuB,EAAA;;AyEuoEzB;EACE,kBAAkB;EAClB,gCzEzoEuB;EyE0oEvB,iBAAiB,EAAA;;AAGnB;EACE,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,0CzEvmEmB;EyEwmEnB,kBAAkB;EAClB,kBAAkB;EAClB,czEppEuB;EyEqpEvB,iCzEtmEiB;EyEumEjB,kBAAkB,EAAA;EATpB;IAYI,YAAY;IACZ,mBAAmB,EAAA;;AAIvB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAS;EACT,cAAc,EAAA;;AAGhB;EACE,aAAa;EACb,4CAA4C;EAC5C,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gCzE7nEiB;EyE8nEjB,0CzEnoEmB,EAAA;EyE4nErB;IAUI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCzErrEqB,EAAA;EyEsqEzB;IAmBI,SAAS;IACT,kBAAkB;IAClB,czE1rEgB;IyE2rEhB,uBAAuB,EAAA;;AAK3B,kCAAA;AACA,kCAAA;AACA,kCAAA;AAEA;;;EAGE,kBAAkB,EAAA;;AAGpB;;gC1Ewp3EgC;A0Erp3EhC;EACE,oCAA0C;EAC1C,mCAAmC;EACnC,czE5pEoB;EyE6pEpB,gBAAgB,EAAA;;AAGlB;;gC1Eup3EgC;A0Epp3EhC;EACE,mCAAmC,EAAA;;AAGrC;;gC1Esp3EgC;A0Elp3EhC;;;;EAKI,WAAW,EAAA;;AAIf;EACE,mCAAmC,EAAA;EADrC;IAII,6BzExrEkB;IyEyrElB,gCzEzrEkB,EAAA;EyEorEtB;IASI,8BzE7rEkB,EAAA;EyEorEtB;IAaI,+BzEjsEkB,EAAA;;AyEqsEtB;;gC1E2o3EgC;A0Exo3EhC;EACE,mCzEtuEa,EAAA;;AyEyuEf;EACE,mCzE5sEc,EAAA;;AyE+sEhB;;gC1Eyo3EgC;A0Eto3EhC;EACE,oCzE/tEmB,EAAA;;AyEsuErB,4CAAA;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,yBzE3uEY;EyE4uEZ,kBAAkB;EAClB,czE1xEkB,EAAA;EyE4xElB;IACE,kBAAkB;IAClB,kBAAkB,EAAA;;AAItB;EACE,oBAAoB;EACpB,+BzElyEuB;EyEmyEvB,kBAAkB,EAAA;;AAGpB;EACE,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;EACpB,yBzElxEa;EyEmxEb,czEpxEmB;EyEqxEnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB,EAAA;EAEzB;IACE,sCzE7vEkB;IyE8vElB,+BzE9vEkB,EAAA;;AyEkwEtB;EACE,kCAAkC;EAClC,+BzEpwEoB,EAAA;;AyEuwEtB;EACE,qCAAqC,EAAA;;AAGvC;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;EACZ,kBAAkB,EAAA;;AAGpB;EACE,YAAY,EAAA;;AAGd;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,0CzEzyEmB;EyE0yEnB,iCzEryEiB,EAAA;EyEuyEjB;IACE,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCzE71EqB,EAAA;EyEg2EvB;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,SAAS;IACT,UAAU;IACV,gBAAgB,EAAA;EAGlB;IACE,WAAW;IACX,SAAS;IACT,wBAAwB;IACxB,6BAA6B;IAC7B,kBAAkB;IAClB,uBAAuB;IACvB,czE/2EgB;IyEg3EhB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,kFAAkF,EAAA;IAZnF;MAgBG,sCzE/0Ee;MyEg1Ef,kCzEz0EkB;MyE00ElB,czE33EmB,EAAA;IyE83ErB;MACE,sCzEt1Ec;MyEu1Ed,oCzEv1Ec;MyEw1Ed,czEj4EmB,EAAA;IyEo4ErB;MACE,kBAAkB;MAClB,8CzE51Ee;MyE61Ef,0BAA0B;MAC1B,mBAAmB;MACnB,gBAAgB;MAChB,sBAAsB;MACtB,yBAAyB,EAAA;;AAK/B;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa,EAAA;EAEb;IACE,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB,EAAA;EAGrB;IACE,SAAS;IACT,czE13EgB;IyE23EhB,kBAAkB;IAClB,gBAAgB,EAAA;EAGlB;IACE,cAAc;IACd,+BzE16EqB;IyE26ErB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB,EAAA;EAG3B;IACE,aAAa,EAAA;;AAIjB;EACE,4BAAuC;EACvC,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,iCzE74EiB,EAAA;EA4rBf;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;;AyEssDjE,iCAAA;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB,EAAA;EALpB;IAQI,oBAAoB;IACpB,sBAAsB;IACtB,gCAAgC;IAChC,czEp6EgB;IyEq6EhB,gBAAgB,EAAA;;AAIpB,mCAAA;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB,EAAA;EALpB;IAQI,gBAAgB,EAAA;EAGjB;IAEG,sBAAsB,EAAA;EAI1B;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,sBAAsB,EAAA;EAGxB;IACE,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,czEz8EgB,EAAA;EyE48ElB;IACE,uBAAuB;IACvB,oBAAoB;IACpB,yBzEl8EY;IyEm8EZ,czEn8EY;IyEo8EZ,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB,EAAA;IAEzB;MACE,uCzE9/Ec;MyE+/Ed,czE//Ec,EAAA;IyEkgFhB;MACE,sCzE39Ec;MyE49Ed,czE59Ec,EAAA;IyE+9EhB;MACE,uCzEl/Ee;MyEm/Ef,czEn/Ee;MyEo/Ef,oBAAoB,EAAA;EAvD1B;IA4DI,qBAAqB;IACrB,gBAAgB;IAChB,czEphFgB;IyEqhFhB,gBAAgB,EAAA;;AAIpB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,qCAAqC,EAAA;EATvC;IAYI,qCAAqC,EAAA;EAGvC;IACE,cAAc;IACd,YAAY;IACZ,gBAAgB,EAAA;EAGlB;IACE,cAAc;IACd,iBAAiB;IACjB,eAAe,EAAA;;AAInB,kCAAA;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,eAAe,EAAA;EAPjB;IAUI,oBAAoB,EAAA;EAVxB;IAcI,qCAAkC,EAAA;EAdtC;IAkBI,qCAAkC,EAAA;EAGpC;IACE,eAAe,EAAA;IADhB;MAIG,oBAAoB;MACpB,eAAe,EAAA;IALlB;MASG,oCzEhjFc,EAAA;;AyEqjFpB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,0CzEnkFkB,EAAA;EyEqkFlB;IACE,kBAAkB,EAAA;EAGpB;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,cAAc;IACd,SAAS;IACT,UAAU;IACV,wCzEvnFiB;IyEwnFjB,kBAAkB;IAClB,kCzE3kFoB;IyE4kFpB,czE5nFgB;IyE6nFhB,kBAAkB;IAClB,cAAc;IACd,YAAY,EAAA;IAdb;MAiBG,gBAAgB,EAAA;EAIpB;IACE,gBAAgB;IAChB,czEhmFgB;IyEimFhB,kBAAkB,EAAA;EAGpB;IACE,czE9oFqB;IyE+oFrB,gBAAgB,EAAA;;AAIpB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;EAEZ;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,0BAA0B,EAAA;EAG5B;IACE,cAAc;IACd,YAAY,EAAA;EAGd;IACE,aAAa;IACb,cAAc;IACd,YAAY;IACZ,iBAAiB,EAAA;EAGnB;IACE,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCzEnrFqB,EAAA;;AyEurFzB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,qCAAqC,EAAA;EAErC;IACE,qCAAqC,EAAA;EAGvC;IACE,cAAc;IACd,YAAY;IACZ,gBAAgB,EAAA;EAGlB;IACE,aAAa;IACb,cAAc;IACd,YAAY;IACZ,iBAAiB,EAAA;EAGnB;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe,EAAA;EAGjB;IACE,cAAc;IACd,SAAS;IACT,eAAe,EAAA;;AAInB;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,8CzE7rFmB,EAAA;;AyEgsFrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,yCzE/tFa;EyEguFb,iCzEzsFiB;EyE0sFjB,kBAAkB,EAAA;;AAGpB;EACE,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gCzEjwFuB,EAAA;;AyEowFzB;EACE,SAAS;EACT,eAAe;EACf,czEvwFuB,EAAA;;AyE0wFzB;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,czEvvFmB,EAAA;;AyE0vFrB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCzEpxFuB,EAAA;EyEsxFvB;IACE,czEhwFiB,EAAA;EyEmwFnB;IACE,czEruFY,EAAA;;AyEyuFhB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,gCzE5vFiB;EyE6vFjB,yCzElwFmB;EyEmwFnB,czE5yFkB;EyE6yFlB,kBAAkB,EAAA;;AAGpB,oDAAA;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iCAAiC;EACjC,0BAA0B,EAAA;;AAG5B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,4BAAuC;EACvC,mBAAmB;EACnB,0CzE5xFmB;EyE6xFnB,0GzEvxFuB;EyE0xFvB,2CAA2C;EAC3C,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,qCAAqC;EACrC,iDzE1yFmB;EyE2yFnB,wGzEtyFiB,EAAA;;AyE2yFnB;EACE,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gCzEp2FuB,EAAA;;AyEu2FzB;EACE,SAAS;EACT,oCAA+C;EAC/C,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,czE72FuB;EyE82FvB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,0CzEx1FmB;EyEy1FnB,kCzEl1FsB;EyEm1FtB,czEn4FkB;EyEo4FlB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB,EAAA;EAEnB;IACE,qCzEt1FY;IyEu1FZ,czEv1FY;IyEw1FZ,mCzEv1FiB,EAAA;;AyE21FrB;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,yCzE/2FmB;EyEg3FnB,kBAAkB;EAClB,kCzE12FsB;EyE22FtB,czE35FkB;EyE45FlB,eAAe;EACf,kFAAkF,EAAA;EAZpF;IAgBI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,WAAW;IACX,wBAAwB;IACxB,wBAAwB,EAAA;EAvB5B;IA2BI,8CAA8C,EAAA;EA3BlD;IA+BI,+CAA+C,EAAA;EA/BnD;IAoCI,uCzEn4FuB;IyEo4FvB,czEp4FuB;IyEq4FvB,kCzEl7FoB,EAAA;;AyEs7FxB;EACE,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,gBAAgB,EAAA;EzErtEd;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;;AyE0sEjE;EACE,aAAa;EACb,uBAAuB,EAAA;;AAGzB;EACE,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB,EAAA;;AAGlB;EACE,oBAAoB;EACpB,YAAY,EAAA;;AAGd,4DAAA;AACA;EACE,oBAAoB;EACpB,UAAU,EAAA;;AAIZ,gDAAA;AAGA;EAwCE,WAAA,EAAY;EAxCd;IAMM,aAAa;IACb,eAAe;IACf,cAAc;IACd,mBAAmB,EAAA;IATzB;MAYQ,gBAAgB;MAChB,kBAAkB,EAAA;EAb1B;IAkBsB,YAAY,EAAA;EAlBlC;IAmBuB,YAAY,EAAA;EAnBnC;IAoBsB,YAAY,EAAA;EApBlC;IAqBwB,kBAAkB,EAAA;EArB1C;IAsBwB,kBAAkB,EAAA;EAtB1C;IAwByB,WAAW,EAAA;EAxBpC;;IA0BwB,YAAY,EAAA;EA1BpC;IA4B+B,YAAY,EAAA;EA5B3C;IA+BI,qCAAqC,EAAA;EA/BzC;IAmCI,kBAAkB;IAClB,YAAY;IACZ,aAAa,EAAA;EArCjB;IA2CI,aAAa;IACb,sBAAsB;IACtB,SAAS;IAET,6BAAA;IAKA,yBAAA,EAA0B;IApD9B;MAiDM,6BAA6B,EAAA;IAjDnC;MAsDM,aAAa;MACb,SAAS,EAAA;MAvDf;;QA2DQ,UAAU,EAAA;EA3DlB;;;IAmEI,iBAAiB,EAAA;;AAKrB;EACE,aAAa;EACb,uBAAuB,EAAA;;AAGzB;EACE,OAAO;EACP,YAAY,EAAA;;AAGd;EACE,UAAU,EAAA;;AAIZ;EAEI,aAAa;EACb,sBAAsB;EACtB,QAAQ,EAAA;;AAJZ;EAQI,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,mBzE7jGoB;EyE8jGpB,iBAAiB;EACjB,+BAA+B;EAC/B,yBzE3jGc;EyE4jGd,6BzE5jGc;EyE6jGd,gCzE7jGc;EyE8jGd,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,mBAAmB,EAAA;EzEl2EnB;IACI,UAjKa,EAAA;EAoKjB;IACI,mBApKuB;IAqKvB,kBAAkB;IAClB,kBAAkB,EAAA;EAGtB;IACI,yBA3uBU;IA4uBV,kBAAkB,EAAA;IAElB;MACI,yBAAqD,EAAA;;AyE6zEjE;EA2BI,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAA;EA7BZ;IAgCM,OAAO,EAAA;EAhCb;IAoCM,eAAe;IACf,gBAAgB;IAChB,gBAAgB,EAAA;;AAtCtB;EA4CI,gBAAgB;EAChB,gBAAgB,EAAA;EA7CpB;IAgDM,iBAAiB;IACjB,czExmGmB,EAAA;;AyEujGzB;EAsDI,gBAAgB;EAChB,gCzE9mGqB;EyE+mGrB,YAAY,EAAA;;AAxDhB;EA6DI,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,iBAAiB,EAAA;;AAIrB;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,0CzEtlGmB;EyEulGnB,kBAAkB;EAClB,kCzEjlGsB,EAAA;;AyEolGxB;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCzE5oGuB,EAAA;;AyE+oGzB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,czEnpGkB,EAAA;;AyEspGpB;EACE,aAAa;EACb,YAAY,EAAA;;AAGd;;;EAGE,gBAAgB;EAChB,wCzE7pGmB;EyE8pGnB,kBAAkB;EAClB,kCzE5pGsB,EAAA;;AyE+pGxB;;;EAGE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,czE3qGuB,EAAA;;AyE8qGzB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,kCzEpoGsB;EyEqoGtB,yCzE5oGmB,EAAA;;AyE+oGrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,czE9rGuB;EyE+rGvB,eAAe,EAAA;EANjB;IASI,SAAS,EAAA;;AAIb;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB,EAAA;EAHpB;;IAOI,sBAAsB;IACtB,+CzE3sGiB;IyE4sGjB,gBAAgB,EAAA;EATpB;IAaI,gCzEntGqB;IyEotGrB,gBAAgB,EAAA;;AAIpB;EACE,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,0CzElrGmB;EyEmrGnB,kCzE5qGsB;EyE6qGtB,czE7tGkB,EAAA;;AyEguGpB;EACE,aAAa;EACb,WAAW,EAAA;;AAGb;EACE,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,wCzEvuGmB;EyEwuGnB,kBAAkB;EAClB,kCzExuGY;EyEyuGZ,czE7uGuB;EyE8uGvB,eAAe,EAAA;EARjB;IAWI,uCzE9rGuB,EAAA;;AyEksG3B;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB,EAAA;;AAGrB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,WAAW,EAAA;;AAGb;EACE,gCzEpwGuB,EAAA;;AyEuwGzB;EACE,oBAAoB;EACpB,czEzwGuB;EyE0wGvB,gBAAgB,EAAA;;AAGlB;EACE,gCzE9wGuB;EyE+wGvB,kBAAkB,EAAA;;AzE3yGpB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;A0Ev6BA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,sBAAsB,EAAA;;AAGxB;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe,EAAA;;AAGjB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;EACtB,yG1EoBiB;E0EjBjB,0C1EYmB;E0EXnB,0EAEiC,EAAA;EAEjC;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,oBAAoB,EAAA;EAGtB;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc,EAAA;EAGhB;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc,EAAA;IAJf;MAOG,kBAAkB;MAClB,WAAW;MACX,WAAW;MACX,mB1ENgB;M0EOhB,yBAAyB;MACzB,6BAA6B,EAAA;MAZhC;QAeK,SAAS;QACT,UAAU,EAAA;MAhBf;QAoBK,SAAS,EAAA;EAKf;IACE,SAAS;IACT,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,c1E/EqB;I0EgFrB,mBAAmB,EAAA;EAGrB;IACE,YAAY,EAAA;EAGd;IACE,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,YAAY,EAAA;EAGd;IACE,oBAAoB;IACpB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,yB1EjGuB;I0EkGvB,0CAA0C;IAC1C,mB1EhGe,EAAA;E0EmGjB;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;IACT,YAAY;IACZ,uBAAuB;IACvB,c1E7GgB;I0E8GhB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;IACf,0EAA0E,EAAA;IAZ3E;MAeG,+B1EpHe,EAAA;I0EqGlB;MAmBG,mB1ExHe;M0EyHf,c1E5HmB,EAAA;I0E0HpB;M1EieH,gHAEO;MACP,sBAAsB;MACtB,4BAA4B;MAC5B,2BAA2B;M0E/dvB,c1EjImB;M0EkInB,mC1EvFQ,EAAA;;A0E4Fd;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,0DAA0D;EAC1D,WAAW;EACX,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,sBAAsB,EAAA;;AAGxB;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EArLb,0C1EoEmB;E0EnEnB,mBAAmB;EACnB,yG1EuEiB;E0EpEjB,0EAEiC;EAgLjC,iBAAiB,EAAA;EAEjB;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,wBAAwB;IACxB,iD1E3HiB;I0E4HjB,4BAA4B,EAAA;EAG9B;IACE,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,gC1E/KqB,EAAA;E0EkLvB;IACE,kBAAkB;IAClB,gC1EpLqB;I0EqLrB,mBAAmB,EAAA;EAGrB;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,+BA3N6C;IA4N7C,mBAAmB;IACnB,4BAA4B;IA/M9B,qBAAqB;IACrB,gE1E+DsB,EAAA;I0E7DtB;MACE,UAAU,EAAA;IAGZ;MACE,kC1EwDoB;M0EvDpB,oBAAoB,EAAA;IAGtB;MACE,oC1E4CiB;M0E3CjB,oBAAoB,EAAA;EAqMtB;IACE,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,+B1EjKgB,EAAA;E0EoKlB;IACE,sBAAsB;IACtB,SAAS;IACT,8C1EtKiB,EAAA;E0EyKnB;IACE,uBAAuB;IACvB,c1EpNgB;I0EqNhB,iBAAiB,EAAA;;AAIrB;EACE,aAAa;EACb,oBAAoB,EAAA;EAEpB;IACE,sC1EtLgB;I0EuLhB,8C1EvLgB;I0EwLhB,oC1EvLiB,EAAA;E0E0LnB;;IAEE,qB1EjLkB;I0EkLlB,8C1ElLkB,EAAA;E0EqLpB;IACE,qB1EtLkB,EAAA;E0EyLpB;IACE,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,wBAAwB;IACxB,0C1E7MiB;I0E8MjB,kBAAkB;IAClB,kC1EzMqB;I0E0MrB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iFAGuB,EAAA;IAlBxB;MAqBG,sC1E1Nc;M0E2Nd,oC1E1Ne,EAAA;I0EoMlB;MA0BG,2C1E9Ne;M0E+Nf,mBAAmB,EAAA;EAIvB;IACE,kBAAkB;IAClB,gBAAgB;IAChB,c1EhRqB;I0EiRrB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW,EAAA;EAGb;IACE,kBAAkB;IAClB,gC1EzRgB,EAAA;E0E4RlB;IACE,oBAAoB,EAAA;;AAIxB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,2BApU+C;EAqU/C,+BArU+C;EAsU/C,aAAa;EACb,cAAc;EApUd,0C1EoEmB;E0EnEnB,mBAAmB;EACnB,yG1EuEiB;E0EpEjB,0EAEiC;EAIjC,qBAAqB;EACrB,gE1E+DsB,EAAA;E0E7DtB;IACE,UAAU,EAAA;EAGZ;IACE,kC1EwDoB;I0EvDpB,oBAAoB,EAAA;EAGtB;IACE,oC1E4CiB;I0E3CjB,oBAAoB,EAAA;EA+StB;IACE,uBAAuB;IACvB,uBAAuB,EAAA;EAGzB;IACE,gBAAgB;IAChB,kBAAkB,EAAA;EAGpB;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,cAAc,EAAA;EAGhB;IACE,iBAAiB;IACjB,cAAc,EAAA;EAGhB;IACE,iBAAiB;IACjB,aAAa;IACb,oBAAoB;IACpB,iBAAiB,EAAA;EAGnB;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,sBAAiC;IACjC,qBAAqB;IACrB,mBAAmB;IACnB,0C1E1SiB;I0E2SjB,kC1EpSoB;I0EqSpB,0EAE+B;IAC/B,gCAAgC,EAAA;EAGlC;IACE,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gC1ElWqB,EAAA;E0EqWvB;IACE,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,gC1ExWgB,EAAA;E0E2WlB;IACE,SAAS;IACT,gC1E9WqB;I0E+WrB,kBAAkB,EAAA;EAGpB;IACE,mBAAmB;IACnB,uBAAuB;IACvB,iD1E3UiB,EAAA;E0E8UnB;IACE,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,YAAY,EAAA;EAGd;IACE,YAAY;IACZ,cAAc,EAAA;EAGhB;IACE,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,oBAAoB,EAAA;EAGtB;IACE,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,c1EhZqB,EAAA;E0EmZvB;IACE,aAAa;IACb,eAAe;IACf,YAAY;IACZ,gBAAgB,EAAA;EAGlB;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,0C1EpXiB;I0EqXjB,oBAAoB;IACpB,iC1EjXe;I0EkXf,+B1ExXgB;I0EyXhB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB,EAAA;IAEzB;MACE,sC1EnXgB;M0EoXhB,+B1EpXgB,EAAA;E0EwXpB;IACE,mBAAmB;IACnB,gC1E9agB;I0E+ahB,gBAAgB;IAChB,kBAAkB,EAAA;EAGpB;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY,EAAA;EAGd;IACE,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,gC1EhcqB,EAAA;E0EmcvB;IACE,SAAS;IACT,gC1EpcgB;I0EqchB,iBAAiB,EAAA;IAEjB;MACE,kBAAkB;MAClB,gC1E1cmB,EAAA;E0E8cvB;IACE,mBAAmB;IACnB,kBAAkB;IAClB,gC1EhdgB,EAAA;;A0EodpB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;EAEZ;IACE,mBAAmB,EAAA;;AAIvB;EACE,aAAa;EACb,0DAA0D;EAC1D,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,wBAAwB;EACxB,0C1E5bmB;E0E6bnB,kBAAkB;EAClB,kC1ExbuB;E0EybvB,c1EzeuB;E0E0evB,eAAe;EACf,gBAAgB;EAChB,iFAGuB,EAAA;EAhBzB;IAmBI,sC1EzcgB;I0E0chB,oC1EzciB;I0E0cjB,8C1E3cgB,EAAA;E0EsbpB;IAyBI,2C1E9ciB;I0E+cjB,mBAAmB,EAAA;EAGrB;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY,EAAA;EAGd;IACE,kBAAkB;IAClB,gBAAgB;IAChB,c1EtgBqB;I0EugBrB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB,EAAA;EAGrB;IACE,kBAAkB;IAClB,gBAAgB;IAChB,+B1EtegB,EAAA;E0EyelB;IACE,YAAY;IACZ,gBAAgB;IAChB,6FAIC;IACD,qFAIC,EAAA;EAGH;IACE,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,gC1EpiBgB;I0EqiBhB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB,EAAA;EAGzB;IACE,cAAc;IACd,kBAAkB;IAClB,gC1E9iBqB,EAAA;E0EijBvB;IACE,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,oBAAoB;IACpB,aAAa,EAAA;;AAIjB;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY,EAAA;EAEZ;IACE,mBAAmB,EAAA;;AAIvB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,0C1EliBmB;E0EmiBnB,mBAAmB;EACnB,kC1E9hBuB;E0E+hBvB,c1E/kBuB;E0EglBvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,8C1E1iBkB;E0E2iBlB,uGAIsB,EAAA;EApBxB;IAuBI,sC1EljBgB;I0EmjBhB,oC1EljBiB;I0EmjBjB,8EAEgC;IAChC,2BAA2B,EAAA;EA5B/B;IAgCI,2C1E1jBiB;I0E2jBjB,mBAAmB,EAAA;EAGrB;IACE,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,c1E7mBqB;I0E8mBrB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW,EAAA;EAGb;IACE,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,+B1E/kBgB,EAAA;E0EklBlB;IACE,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,8FAIC;IACD,sFAIC,EAAA;EAGH;IACE,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,gC1EjpBgB;I0EkpBhB,qBAAqB,EAAA;EAGvB;IACE,cAAc;IACd,kBAAkB;IAClB,gC1EzpBqB,EAAA;E0E4pBvB;IACE,eAAe;IACf,oBAAoB;IACpB,oBAAoB;IACpB,aAAa,EAAA;IAJd;MAOG,sC1EznBe;M0E0nBf,kC1EpnBmB;M0EqnBnB,8C1E5nBc;M0E6nBd,eAAe,EAAA;;AAKrB;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,0C1EtoBmB;E0EuoBnB,0EAEiC,EAAA;;AAGnC;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa,EAAA;;AAGf;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,0C1EzqBmB;E0E0qBnB,0G1EpqBuB;E0EuqBvB,kD1E9qBkB;E0E+qBlB,WAAW;EACX,sBAAsB;EAxuBtB,qBAAqB;EACrB,gE1E+DsB,EAAA;E0E7DtB;IACE,UAAU,EAAA;EAGZ;IACE,kC1EwDoB;I0EvDpB,oBAAoB,EAAA;EAGtB;IACE,oC1E4CiB;I0E3CjB,oBAAoB,EAAA;EA8sBxB;;IAiBI,c1E9tBqB,EAAA;E0E6sBzB;IAqBI,gBAAgB;IAChB,c1EnuBqB,EAAA;E0E6sBzB;IA0BI,cAAc;IACd,c1ExuBqB;I0EyuBrB,aAAa;IACb,kBAAkB;IAClB,+C1EjsBiB,EAAA;I0EmqBrB;MAkCM,WAAW;MACX,kBAAkB;MAClB,0C1EvsBe;M0EwsBf,oBAAoB,EAAA;IArC1B;MAyCM,SAAS;MACT,UAAU;MACV,UAAU;MACV,WAAW;MACX,kBAAkB;MAClB,mBAAmB,EAAA;IA9CzB;MAkDM,YAAY;MACZ,WAAW;MACX,UAAU;MACV,WAAW;MACX,iBAAiB;MACjB,gBAAgB,EAAA;EAvDtB;IA4DI,wC1ExtBoB;I0EytBpB,0C1EhuBiB;I0EiuBjB,+C1EluBgB;I0EmuBhB,kBAAkB;IAClB,yBAAkC;IAClC,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,0CAA0C,EAAA;;AAI9C;EA5oBA;IA8oBI,0BAA0B,EAAA;EAzvB5B;IA6vBE,sBAAsB;IACtB,oBAAoB,EAAA;EA9sBtB;IAktBE,eAAe,EAAA;EAtUnB;IA0UI,0BAA0B;IAC1B,YAAY,EAAA;EAxRd;IA4RE,wBAAwB;IACxB,gBAAgB,EAAA;EA9QlB;IAkRE,qBAAqB;IACrB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB,EAAA;EAGlB;;IAEE,gBAAgB;IAChB,YAAY;IACZ,iBAAiB,EAAA;EAtcnB;IA0cE,sBAAsB;IACtB,oBAAoB,EAAA;EA/btB;IAmcE,cAAc,EAAA;EAGhB;IACE,WAAW;IACX,eAAe,EAAA,EAChB;;AAHD;EAOA,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,0C1ElyBoB;E0EmyBpB,kBAAkB;EAClB,oFAIC;EACD,c1E91BuB;E0E+1BvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,uGAIsB,EAAA;EAzBxB;IA4BI,sC1EvzBkB;I0EwzBlB,8C1ExzBkB,EAAA;E0E2xBtB;IAiCI,2C1E5zBkB;I0E6zBlB,mBAAmB,EAAA;EAlCvB;IAsCI,aAAa;IACb,mBAAmB,EAAA;EAGrB;IACE,aAAa,EAAA;EA3CjB;IA+CI,aAAa,EAAA;EA/CjB;IAmDI,eAAe,EAAA;;AAInB;EACE,cAAc,EAAA;;AAGhB;EACE,sBAAiC;EACjC,4BAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,0C1Et2BmB;E0Eu2BnB,mBAAmB;EACnB,kC1Ej2BsB;E0Ek2BtB,0EAEiC;EACjC,gBAAgB,EAAA;EAEhB;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,iD1Ej3BiB,EAAA;E0Eo3BnB;IACE,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,+B1E33BgB,EAAA;E0E83BlB;IACE,SAAS;IACT,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,c1E56BqB,EAAA;E0E+6BvB;IACE,0BAA0B;IAC1B,gBAAgB;IAh8BlB,qBAAqB;IACrB,gE1E+DsB,EAAA;I0E7DtB;MACE,UAAU,EAAA;IAGZ;MACE,kC1EwDoB;M0EvDpB,oBAAoB,EAAA;IAGtB;MACE,oC1E4CiB;M0E3CjB,oBAAoB,EAAA;EAs7BtB;IACE,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,gC1Ex7BgB,EAAA;E0E27BlB;IACE,mBAAmB;IACnB,oBAAoB;IACpB,gC1E/7BqB;I0Eg8BrB,kBAAkB;IAClB,iBAAiB,EAAA;IALlB;MAQG,mBAAmB,EAAA;EAIvB;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY,EAAA;EAGd;IACE,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,gC1Ep9BqB;I0Eq9BrB,eAAe,EAAA;EAGjB;IACE,mBAAmB;IACnB,cAAc,EAAA;EAGhB;IACE,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,0BAA0B;IAC1B,8C1Ex7BiB,EAAA;;AAtErB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;A2Er8BA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB,EAAA;;AAGxB;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,0C3EyDmB;E2ExDnB,yG3E6DiB;E2E1DjB,2CAA2C,EAAA;;AAG7C;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gC3EGuB,EAAA;;A2EAzB;EACE,SAAS;EACT,uCAAkD;EAClD,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,c3ENuB,EAAA;;A2ESzB;EACE,aAAa;EACb,SAAS,EAAA;EAET;IACE,gDAAgD,EAAA;EAGlD;IAJA;MAMI,0BAA0B,EAAA,EAC3B;;AAIL;EACE,oBAAoB;EACpB,mBAAmB;EACnB,0C3EemB;E2EdnB,iC3EmBiB;E2ElBjB,yCAAyC;EACzC,YAAY,EAAA;EAEZ;IACE,uBAAuB,EAAA;EAGzB;IACE,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,oBAAoB;IACpB,8C3ECiB,EAAA;;A2EGrB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gC3EnDuB,EAAA;E2EqDvB;IACE,SAAS;IACT,cAAc,EAAA;;AAIlB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,0C3EzBmB;E2E0BnB,kC3EnBsB,EAAA;E2EqBtB;IACE,wBAAwB;IACxB,sBAAsB,EAAA;;AAI1B;EACE,YAAY;EACZ,wBAAwB;EACxB,0C3ErCmB;E2EsCnB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,c3EnFuB;E2EoFvB,iC3ErCiB,EAAA;E2E6BnB;IAWI,gC3EvFqB,EAAA;E2E4EzB;IAeI,aAAa;IACb,mBAAmB,EAAA;EAGrB;IACE,eAAe,EAAA;EAGjB;IACE,eAAe;IACf,eAAe,EAAA;EAGjB;IACE,eAAe;IACf,eAAe,EAAA;EAGjB;IACE,eAAe;IACf,gBAAgB,EAAA;EAGlB;IACE,aAAa;IACb,cAAc,EAAA;EAGhB;IACE,WAAW;IACX,cAAc,EAAA;EAGhB;IACE,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB,EAAA;IAJnB;MAQG,wBAAwB;MACxB,SAAS,EAAA;IATZ;MAaG,0BAA0B,EAAA;;AAKhC;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,wCAAwC;EACxC,0C3EzGmB;E2E0GnB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,c3EvJuB;E2EwJvB,iC3EzGiB;E2E0GjB,gBAAgB;EAChB,iKAE4E;EAC5E,yFAEmC;EACnC,iCAAiC;EACjC,4BAA4B,EAAA;EAnB9B;IAsBI,gC3EpKqB,EAAA;E2E8IzB;IA0BI,aAAa;IACb,mBAAmB,EAAA;EA3BvB;IA+BI,mB3E5HoB;I2E6HpB,c3E9KqB,EAAA;;A2EkLzB;EACE,eAAe;EACf,gBAAgB,EAAA;EAFlB;IAKI,6BAA6B;IAC7B,uBAAuB;IACvB,uBAAuB;IACvB,qDAAqD;IACrD,6BAA6B;IAC7B,4CAA6C;IAC7C,2BAA2B,EAAA;EAX/B;IAeI,kCAAkC,EAAA;EAftC;;;IAqBI,yBAAkC;IAClC,6BAA6B,EAAA;EAtBjC;IA0BI,2CAA8C,EAAA;EA1BlD;IA8BI,2CAA8C,EAAA;EA9BlD;IAkCI,6CAAkD;IAClD,qDAAqD;IACrD,6BAA6B;IAC7B,gBAAgB,EAAA;EArCpB;IAyCI,kCAAkC;IAClC,yBAAkC;IAClC,6BAA6B,EAAA;IA3CjC;MA8CM,+CAA+C,EAAA;IA9CrD;MAkDM,+CAA+C;MAC/C,yBAA6B,EAAA;;AAKnC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0C3EnMmB;E2EoMnB,iC3E/LiB,EAAA;E2E2LnB;IAOI,gBAAgB,EAAA;EAPpB;IAYM,2BAA2B;IAC3B,sBAAsB;IACtB,c3EvPc;I2EwPd,yBAAyB;IACzB,gC3EtPQ;IAglBZ,mHAAiF;IACjF,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B,EAAA;E2E7W7B;IAqBM,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,c3EvQc;I2EwQd,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB,EAAA;IAnCtB;MAsCQ,WAAW;MACX,kBAAkB;MAClB,QAAQ;MACR,QAAQ;MACR,2BAA2B;MAC3B,UAAU;MACV,WAAW;MACX,yB3EnRM,EAAA;;A2EyRd;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;E3ErLlB,qBAAqB;EACrB,8DA7DiB,EAAA;EA+DjB;IACE,UAAU,EAAA;EAGZ;IACE,iCApEe;IAqEf,oBAAoB,EAAA;EAGtB;IACE,oCA9EiB;IA+EjB,oBAAoB,EAAA;IAEpB;MACE,oCAlFe,EAAA;E2EmPrB;IAOI,aAAa,EAAA;EAGf;IAEE,iBAAiB,EAAA;EAGnB;IACE,0CAAqD,EAAA;EAGvD;IACE,0CAAqD,EAAA;EAGvD;IACE,iBAAiB,EAAA;EAGnB;IAEE,iBAAiB,EAAA;EAGnB;IACE,2CAAsD,EAAA;EAGxD;IACE,2CAAsD,EAAA;EAGxD;IACE,2CAAsD;IACtD,gBAAgB,EAAA;;AAIpB;;EAGI,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB,EAAA;EARtB;;IAWM,mB3E/Te;I2EgUf,+C3EhUe,EAAA;E2EoTrB;;IAgBM,qC3E3VmB;I2E4VnB,gBAAgB,EAAA;;AAjBtB;;;;EAuBI,kBAAkB;EAClB,sBAAsB,EAAA;;AAxB1B;;;;EA6BwB,WAAW,EAAA;;AA7BnC;;;;EA8BoB,aAAa,EAAA;;AA9BjC;;;;EAmCqB,WAAW,EAAA;;AAnChC;;;;EAoCwB,WAAW,EAAA;;AApCnC;;;;EAqCoB,aAAa,EAAA;;A3Euf7B;;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,qBAAqB,EAAA;EAErB;;IACE,qBAAqB;IACrB,gBAAgB;IAChB,cAAc,EAAA;;AAKlB;;EACE,gBAAgB,EAAA;;A2E7iBtB;;EA8CM,eAAe;EACf,aAAa,EAAA;;AA/CnB;;;;EAqDmB,UAAU,EAAA;;AArD7B;;;;EAsDoB,UAAU,EAAA;;AAtD9B;;;;EAuDoB,UAAU,EAAA;;AAvD9B;;;;EAwD4B,UAAU,EAAA;;AAxDtC;;;;EAyDsB,WAAW,EAAA;;AAzDjC;;;;EA8DuB,aAAa,EAAA;;AA9DpC;;;;EA+DwB,UAAU,EAAA;;AA/DlC;;;;EAgEsB,UAAU,EAAA;;AAhEhC;;;;EAiEsB,aAAa,EAAA;;AAjEnC;;;;EAsE4B,WAAW,EAAA;;AAtEvC;;;;EAuEyB,WAAW,EAAA;;AAvEpC;;EA2EI,wBAAwB;EACxB,kBAAkB,EAAA;;AA5EtB;;EAgFI,eAAe;EACf,uBAAuB;EACvB,0C3EnXiB;E2EoXjB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,c3EjaqB;E2EkarB,iC3EnXe,EAAA;;A2E4RnB;;EA2FI,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB,EAAA;;AA9FvB;;EAkGI,aAAa;EACb,gDAAgD;EAChD,SAAS,EAAA;EAET;IAtGJ;;MAuGM,0BAA0B,EAAA,EAE7B;;AAzGH;;EA4GI,qBAAqB;EACrB,mBAAmB;EACnB,0C3E/YiB;E2EgZjB,kC3EzYoB;E2E0YpB,YAAY,EAAA;;AAhHhB;;EAoHI,YAAY;EACZ,mBAAmB,EAAA;;AArHvB;;;;EA0HyB,WAAW,EAAA;;AA1HpC;;;;EA2H4B,WAAW,EAAA;;AA3HvC;;;;EA4HoB,YAAY,EAAA;;AA5HhC;;;;EA6H4B,aAAa,EAAA;;AA7HzC;;;;EA8HqB,aAAa,EAAA;;AA9HlC;;;;EA+HuB,aAAa,EAAA;;AA/HpC;;;;EAgIsB,aAAa,EAAA;;AAhInC;;;;EAiIqB,aAAa,EAAA;;AAjIlC;;;;EAkIwB,YAAY,EAAA;;AAlIpC;;;;EAmIwB,WAAW,EAAA;;AAnInC;;;;EAwIqB,UAAU,EAAA;;AAxI/B;;;;EAyIsB,aAAa,EAAA;;AAzInC;;;;EA0I0B,WAAW,EAAA;;AA1IrC;;;;EA2ImB,aAAa,EAAA;;AA3IhC;;;;EA4IsB,aAAa,EAAA;;AA5InC;;;;EA6IsB,WAAW,EAAA;;AA7IjC;;;;EAkJI,mBAAmB;EACnB,WAAW,EAAA;EAnJf;;;;IAqJuB,aAAa,EAAA;EArJpC;;;;IAsJuB,UAAU,EAAA;EAtJjC;;;;IAuJ2B,aAAa,EAAA;EAvJxC;;;;IAwJ2B,aAAa,EAAA;EAxJxC;;;;IAyJ4B,aAAa,EAAA;EAzJzC;;;;IA0JiC,aAAa,EAAA;EA1J9C;;;;;;;;IA4J0B,YAAY,EAAA;EA5JtC;;;;IA6J+B,YAAY,EAAA;EA7J3C;;;;IA8JyB,WAAW,EAAA;;AA9JpC;;EAmKM,YAAY;EACZ,kBAAkB,EAAA;;AApKxB;;EAwKM,mBAAmB;EACnB,iBAAiB,EAAA;;AAzKvB;;;;;;;;;;;;EAkLM,kBAAkB;EAClB,sBAAsB,EAAA;;AAnL5B;;EAuLM,eAAe;EACf,cAAc;EACd,cAAc,EAAA;;AAzLpB;;;;EA8LM,gBAAgB;EAChB,YAAY,EAAA;;AA/LlB;;EAmMM,gBAAgB;EAChB,YAAY,EAAA;;AApMlB;;EAwMM,YAAY;EACZ,WAAW;EACX,eAAe,EAAA;EA1MrB;;IA6MQ,WAAW;IACX,eAAe;IACf,YAAY,EAAA;EA/MpB;;IAmNQ,WAAW;IACX,eAAe,EAAA;;AApNvB;;EAyNM,WAAW;EACX,eAAe;EACf,YAAY,EAAA;;AA3NlB;;EA+NM,aAAa;EACb,uBAAuB;EACvB,cAAc,EAAA;;AAjOpB;;EAsOI,iBAAiB,EAAA;;AAtOrB;;EA4OQ,qD3EhiBa,EAAA;;A2EoTrB;;EAgPQ,mD3ErgBQ,EAAA;;A2EqRhB;;EAqPM,kBAAkB;EAClB,sBAAsB,EAAA;EAtP5B;;IAyPQ,cAAc,EAAA;;AAzPtB;;EA+PI,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gC3EhlBqB,EAAA;E2E2UzB;;IAwQM,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,gC3EtlBmB,EAAA;E2E2UzB;;IA+QM,c3E1lBmB,EAAA;;A2E2UzB;;EAoRI,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,iBAAiB,EAAA;;AAxRrB;;EA6RM,SAAS;EACT,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,gBAAgB,EAAA;EAlStB;;IAqSQ,gBAAgB;IAChB,yB3EzmBY;I2E0mBZ,mBAAmB,EAAA;;AAvS3B;;EA6SI,iBAAiB,EAAA;EA7SrB;;IAgTM,mBAAmB,EAAA;;AAKzB;EACE,iBAAiB,EAAA;EADnB;IAII,mBAAmB,EAAA;EAJvB;IAQI,gBAAgB,EAAA;EARpB;IAYI,oBAAoB;IACpB,cAAc,EAAA;;AAKlB;EAEI,aAAa;EACb,uDAAuD;EACvD,SAAS;EACT,oBAAoB;EACpB,mBAAmB,EAAA;;AANvB;EAUI,aAAa;EACb,YAAY;EACZ,WAAW,EAAA;;AAZf;EAgBI,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,qBAAqB;EACrB,mBAAmB;EACnB,0C3E7nBiB;E2E8nBjB,kC3EvnBoB;E2EwnBpB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C,EAAA;;AA1B9C;EA8BI,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,OAAO,EAAA;;AAjCX;EAqCI,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAS,EAAA;;AAxCb;EA4CI,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gC3EjsBqB,EAAA;;A2EkpBzB;;EAoDI,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,0C3EhqBiB;E2EiqBjB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,c3E9sBqB;E2E+sBrB,kC3EjqBgB;E2EkqBhB,mF3EtqBiB,EAAA;E2EwmBrB;;IAmEM,gC3ErtBmB,EAAA;E2EkpBzB;;IAuEM,aAAa;IACb,mBAAmB,EAAA;;AAxEzB;EA6EI,gBAAgB;EAChB,iKAE4E;EAC5E,yFAEmC;EACnC,iCAAiC;EACjC,4BAA4B;EAC5B,mBAAmB,EAAA;EAtFvB;IAyFM,mB3E1rBkB;I2E2rBlB,c3E5uBmB,EAAA;;A2EkpBzB;EA+FI,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gC3ErvBqB;E2EsvBrB,eAAe,EAAA;EApGnB;IAuGM,qB3E/sBe,EAAA;E2EwmBrB;IA2GM,aAAa;IACb,mBAAmB,EAAA;;AA5GzB;EAkHM,sBAAsB,EAAA;;AAlH5B;EAsHM,eAAe;EACf,YAAY,EAAA;;AAvHlB;EA2HM,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa,EAAA;;AA9HnB;EAkIM,gBAAgB;EAChB,oBAAoB,EAAA;;AAnI1B;EAwII,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,2C3EvvBiB;E2EwvBjB,iC3EnvBe;E2EovBf,kBAAkB;EAClB,gC3EpyBqB;E2EqyBrB,kBAAkB,EAAA;;AAnJtB;EAwJM,8BAA8B;EAC9B,qDAAqD;EACrD,6CAA8C;EAC9C,8FAE+C,EAAA;;AA7JrD;;EAkKM,yBAAkC,EAAA;;AAlKxC;EAsKM,0CAA6C,EAAA;;AAtKnD;EA2KI,aAAa;EACb,yBAAyB;EACzB,mBAAmB,EAAA;;AA7KvB;;EAkLoB,WAAW,EAAA;;AAlL/B;;EAmLsB,WAAW,EAAA;;AAnLjC;;EAoLoB,UAAU,EAAA;;AApL9B;;EAqL4B,UAAU,EAAA;;AArLtC;;EAsLsB,aAAa,EAAA;;AAtLnC;EA0LI,OAAO;EACP,gBAAgB;EAChB,iBAAiB,EAAA;;AA5LrB;EAgMI,kBAAkB;EAClB,sBAAsB,EAAA;;AAQ1B;EAEI,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe,EAAA;;AAGjB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,eAAe,EAAA;;AAGjB;EAEE,cAAc;EACd,mBAAmB,EAAA;;AAGrB;EAEE,iBAAiB,EAAA;;AAGnB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gC3Ex4BqB;E2Ey4BrB,gBAAgB,EAAA;;AAGlB;EACE,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,yC3Ex4BgB;E2Ey4BhB,kC3Et4Bc;E2Eu4Bd,c3El5BqB,EAAA;;A2Es5BzB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,aAAa,EAAA;EAEb;IACE,WAAW;IACX,YAAY,EAAA;EAGd;IACE,eAAe;IACf,cAAc;IACd,gBAAgB,EAAA;;AAIpB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,2CAAsD;EACtD,mBAAmB;EACnB,0C3E14BmB;E2E24BnB,kC3Ep4BsB;E2Eq4BtB,gBAAgB,EAAA;EAEhB;IACE,mBAAmB;IACnB,uBAAuB;IACvB,eAAe,EAAA;EAGjB;IACE,SAAS;IACT,kBAAkB;IAClB,gC3Ej8BqB;I2Ek8BrB,iBAAiB;IACjB,gBAAgB,EAAA;EAGlB;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,qBAAqB;IACrB,iD3El6BiB,EAAA;E2Eq6BnB;IACE,SAAS;IACT,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,gC3Ep9BqB,EAAA;E2Eu9BvB;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,kBAAkB,EAAA;EAGpB;IACE,cAAc;IACd,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,YAAY;I3Ez3Bd,qBAAqB;IACrB,8DA7DiB,EAAA;IA+DjB;MACE,UAAU,EAAA;IAGZ;MACE,iCApEe;MAqEf,oBAAoB,EAAA;IAGtB;MACE,oCA9EiB;MA+EjB,oBAAoB,EAAA;MAEpB;QACE,oCAlFe,EAAA;E2E87BnB;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY,EAAA;EAGd;IACE,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,gC3El/BqB,EAAA;E2Eq/BvB;IACE,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,gC3Ez/BqB,EAAA;E2E4/BvB;IACE,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,2BAA2B;IAC3B,YAAY,EAAA;EAGd;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,gBAAgB,EAAA;EAGlB;IACE,WAAW,EAAA;EAGb;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY,EAAA;EAGd;IACE,gBAAgB;IAChB,gBAAgB,EAAA;EAGlB;IACE,SAAS;IACT,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,gC3EhiCqB,EAAA;E2EmiCvB;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY,EAAA;EAGd;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW,EAAA;EAGb;IACE,mBAAmB,EAAA;EAGrB;IACE,SAAS;IACT,kBAAkB;IAClB,gC3EvjCqB,EAAA;E2E0jCvB;IACE,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,YAAY,EAAA;EAGd;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW,EAAA;EAGb;IACE,cAAc;IACd,YAAY,EAAA;EAGd;IACE,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,mC3E5kCgB;I2E6kChB,c3E7kCgB;I2E8kChB,iBAAiB;IACjB,cAAc;IACd,eAAe,EAAA;IAVhB;MAaG,mC3EnlCc,EAAA;I2EskCjB;MAiBG,YAAY;MACZ,mBAAmB,EAAA;EAIvB;IACE,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,yC3EhmCgB;I2EimChB,kC3E9lCc;I2E+lCd,c3E1mCqB;I2E2mCrB,kBAAkB,EAAA;EAGpB;IACE,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;IACrB,8C3EzkCiB,EAAA;;A2E6kCrB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,0C3EnlCmB;E2EolCnB,iC3E/kCiB,EAAA;E2EilCjB;IAEE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,0C3E7lCiB;I2E8lCjB,kC3EroCiB,EAAA;E2EwoCnB;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB,EAAA;EAGnB;IACE,kBAAkB,EAAA;IADnB;MAIG,WAAW;MACX,kBAAkB;MAClB,WAAW;MACX,kBAAkB;MAClB,4C3E1pCmB,EAAA;E2E8pCvB;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,YAAY,EAAA;EAGd;IACE,gBAAgB;IAChB,eAAe;IACf,kBAAkB,EAAA;;AAItB;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iC3EroCiB,EAAA;;A2EwoCnB;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,0C3EnpCmB;E2EopCnB,kC3E7oCsB;E2E8oCtB,gBAAgB;EAChB,0CAA0C,EAAA;EAE1C;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,oBAAoB;IACpB,iD3E9pCiB,EAAA;E2EiqCnB;IACE,SAAS;IACT,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,gC3EhtCqB,EAAA;E2EmtCvB;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kC3ErtCiB;I2EstCjB,c3EztCqB;I2E0tCrB,kBAAkB;IAClB,cAAc;IACd,eAAe,EAAA;IAThB;MAYG,YAAY;MACZ,mBAAmB,EAAA;IAbtB;MAiBG,oC3E1rCe,EAAA;E2E8rCnB;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa,EAAA;EAGf;IACE,SAAS;IACT,kBAAkB;IAClB,gC3ElvCqB,EAAA;E2EqvCvB;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,4C3EltCiB;I2EmtCjB,iC3E9sCe;I2E+sCf,0DAA0D,EAAA;IAT3D;MAYG,sC3EvtCe;M2EwtCf,oC3ExtCe,EAAA;I2E2sClB;MAiBG,mBAAmB;MACnB,sC3E7tCe,EAAA;E2EiuCnB;IACE,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB,EAAA;EAGrB;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB,EAAA;EAGpB;IACE,cAAc;IACd,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,oBAAoB;IACpB,0C3ExvCiB;I2EyvCjB,oC3EzvCiB;I2E0vCjB,kBAAkB,EAAA;IARnB;MAWG,WAAW;MACX,kBAAkB;MAClB,SAAS;MACT,QAAQ;MACR,aAAa;MACb,cAAc;MACd,gD3E7yCmB;M2E8yCnB,iD3E9yCmB;M2E+yCnB,8CAA8C,EAAA;EAIlD;IACE,SAAS;IACT,kBAAkB;IAClB,+B3EtzCqB,EAAA;E2EyzCvB;IACE,SAAS;IACT,kBAAkB;IAClB,gC3E5zCqB,EAAA;E2E+zCvB;IACE,aAAa;IACb,uBAAuB,EAAA;EAGzB;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS,EAAA;EAGX;IACE,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,yC3E50CgB;I2E60ChB,kC3E10Cc;I2E20Cd,c3Et1CqB;I2Eu1CrB,kBAAkB,EAAA;EAGpB;IACE,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;IACrB,8C3ErzCiB,EAAA;;A2EyzCrB;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iC3E5zCiB,EAAA;;A2E+zCnB;EACE,WAAW;EACX,gBAAgB;EAChB,4BAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,0C3E30CmB;E2E40CnB,kC3Er0CsB;E2Es0CtB,gBAAgB;EAChB,0CAA0C,EAAA;EAE1C;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,oBAAoB;IACpB,iD3Et1CiB,EAAA;E2Ey1CnB;IACE,SAAS;IACT,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,gC3Ex4CqB,EAAA;E2E24CvB;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kC3E74CiB;I2E84CjB,c3Ej5CqB;I2Ek5CrB,kBAAkB;IAClB,cAAc;IACd,eAAe,EAAA;IAThB;MAYG,YAAY;MACZ,mBAAmB,EAAA;IAbtB;MAiBG,oC3El3Ce,EAAA;E2Es3CnB;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,cAAc,EAAA;EAGhB;IACE,SAAS;IACT,kBAAkB;IAClB,gC3E56CqB,EAAA;E2E+6CvB;IACE,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gC3Ep7CqB,EAAA;E2Eu7CvB;IACE,iBAAiB;IACjB,mBAAmB;IACnB,0C3Eh5CiB;I2Ei5CjB,iC3E54Ce;I2E64Cf,gBAAgB,EAAA;IALjB;MAQG,iBAAiB,EAAA;EAIrB;IACE,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,yC3E/7CgB;I2Eg8ChB,kC3E77Cc;I2E87Cd,c3Ez8CqB;I2E08CrB,kBAAkB,EAAA;EAGpB;IACE,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;IACrB,8C3Ex6CiB,EAAA;;A2E46CrB;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iC3E/6CiB,EAAA;;A2Ek7CnB;EACE,WAAW;EACX,gBAAgB;EAChB,4BAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,0C3E97CmB;E2E+7CnB,kC3Ex7CsB;E2Ey7CtB,gBAAgB;EAChB,2CAA2C,EAAA;EAE3C;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,qBAAqB;IACrB,iD3Ez8CiB,EAAA;E2E48CnB;IACE,SAAS;IACT,kBAAkB;IAClB,c3Ez/CqB,EAAA;E2E4/CvB;IACE,YAAY;IACZ,uBAAuB;IACvB,gC3E//CqB;I2EggDrB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,wBAAwB,EAAA;IAPzB;MAUG,c3EtgDmB,EAAA;I2E4/CtB;MAcG,YAAY;MACZ,mBAAmB,EAAA;EAIvB;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,yBAAyB;IACzB,cAAc;I3Ez6ChB,qBAAqB;IACrB,8DA7DiB,EAAA;IA+DjB;MACE,UAAU,EAAA;IAGZ;MACE,iCApEe;MAqEf,oBAAoB,EAAA;IAGtB;MACE,oCA9EiB;MA+EjB,oBAAoB,EAAA;MAEpB;QACE,oCAlFe,EAAA;E2E8+CnB;IAGE,aAAa;IACb,sBAAsB;IACtB,WAAW,EAAA;EAGb;IACE,SAAS;IACT,wBAAwB;IACxB,mBAAmB;IACnB,0C3E1/CiB;I2E2/CjB,iC3Et/Ce,EAAA;E2Ey/CjB;IACE,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,gC3E5iDqB,EAAA;E2E+iDvB;IACE,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,+B3EpjDqB;I2EqjDrB,eAAe,EAAA;IANhB;MASG,mBAAmB,EAAA;EAIvB;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,YAAY,EAAA;EAGd;IACE,sBAAsB,EAAA;EAGxB;IACE,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,0C3EviDiB;I2EwiDjB,oC3ExiDiB;I2EyiDjB,c3E1iDgB,EAAA;I2E4iDhB;MACE,sC3E7iDc;M2E8iDd,kC3E5iDQ,EAAA;I2E+iDV;MACE,uC3EjiDqB;M2EkiDrB,qC3EliDqB;M2EmiDrB,c3EniDqB,EAAA;I2EsiDvB;MACE,uC3E1kDe;M2E2kDf,mC3ExkDc;M2EykDd,c3E5kDe,EAAA;I2E+kDjB;MACE,sC3E7iDqB;M2E8iDrB,qC3E9iDqB;M2E+iDrB,c3E/iDqB,EAAA;E2EmjDzB;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,eAAe,EAAA;EAGjB;IACE,aAAa;IACb,WAAW;IACX,eAAe,EAAA;EAGjB;IACE,WAAW,EAAA;EAGb;IACE,iBAAiB;IACjB,cAAc;IACd,wBAAwB;IACxB,mBAAmB;IACnB,0C3E1lDiB;I2E2lDjB,iC3EtlDe;I2EulDf,aAAa;IACb,sBAAsB;IACtB,WAAW;I3E7hDb,qBAAqB;IACrB,8DA7DiB,EAAA;IA+DjB;MACE,UAAU,EAAA;IAGZ;MACE,iCApEe;MAqEf,oBAAoB,EAAA;IAGtB;MACE,oCA9EiB;MA+EjB,oBAAoB,EAAA;MAEpB;QACE,oCAlFe,EAAA;E2EkmDnB;IAEE,SAAS;IACT,kBAAkB;IAClB,gC3EhpDqB,EAAA;E2EmpDvB;IACE,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,yC3E/oDgB;I2EgpDhB,kC3E7oDc;I2E8oDd,c3EzpDqB;I2E0pDrB,kBAAkB,EAAA;EAGpB;IACE,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,oBAAoB,EAAA;;AAIxB;EAEI,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gC3E/qDqB;E2EgrDrB,gBAAgB,EAAA;;AAGlB;EACE,SAAS;EACT,gC3ErrDqB;E2EsrDrB,iBAAiB;EACjB,iBAAiB,EAAA;;AAIrB;EACE,oBAAoB,EAAA;;AAGtB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,0C3E7pDmB;E2E8pDnB,kC3EvpDsB,EAAA;E2EypDtB;IACE,aAAa;IACb,eAAe;IACf,iBAAiB,EAAA;EAGnB;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,wBAAwB;IACxB,mBAAmB;IACnB,0C3E7qDiB;I2E8qDjB,iC3EzqDe,EAAA;I2E2qDf;MACE,uC3EpsDe;M2EqsDf,kC3EjsDgB,EAAA;I2EosDlB;MACE,sC3E3qDgB;M2E4qDhB,mC3E1qDe,EAAA;E2E8qDnB;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,c3EzuDqB,EAAA;E2E4uDvB;IACE,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,gC3EhvDqB,EAAA;E2EmvDvB;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,yBAAyB,EAAA;EAG3B;IACE,eAAe;IACf,gBAAgB,EAAA;EAGlB;IACE,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,gC3EtwDqB;I2EuwDrB,eAAe;IACf,iBAAiB,EAAA;EAGnB;IACE,mBAAmB,EAAA;;AAIvB;EACE,mBAAmB;EACnB,0C3ExuDmB;E2EyuDnB,kC3EluDsB;E2EmuDtB,cAAc;EACd,2CAAsD;E3E1qDtD,qBAAqB;EACrB,8DA7DiB,EAAA;EA+DjB;IACE,UAAU,EAAA;EAGZ;IACE,iCApEe;IAqEf,oBAAoB,EAAA;EAGtB;IACE,oCA9EiB;IA+EjB,oBAAoB,EAAA;IAEpB;MACE,oCAlFe,EAAA;E2E8uDnB;IAEE,kBAAkB;IAClB,kBAAkB;IAClB,gC3E5xDqB,EAAA;E2E+xDtB;IAEG,YAAY,EAAA;IAFf;MAIgC,WAAW,EAAA;IAJ3C;MAKiC,aAAa,EAAA;IAL9C;MAMkC,cAAc,EAAA;EANhD;;IAWG,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB,EAAA;EAbrB;IAiBuB,qBAAqB,EAAA;EAjB5C;IAkBuB,oBAAoB,EAAA;EAlB3C;IAmBuB,qBAAqB,EAAA;EAnB5C;IAuBK,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,kBAAkB,EAAA;EA1BvB;IA8BK,kBAAkB,EAAA;EA9BvB;IAkCK,iBAAiB,EAAA;EAlCtB;IAuCG,kBAAkB;IAClB,uBAAuB,EAAA;EAI3B;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB,EAAA;IAHjB;MAK8B,UAAU,EAAA;IALxC;MAM+B,UAAU,EAAA;IANzC;MAOmC,UAAU,EAAA;IAP7C;MAQgC,UAAU,EAAA;IAR1C;MAWG,gBAAgB;MAChB,MAAM;MACN,UAAU;MACV,wBAAwB;MACxB,gBAAgB;MAChB,kBAAkB;MAClB,sBAAsB;MACtB,yBAAyB;MACzB,gC3E91DmB;M2E+1DnB,iC3EhzDa;M2EizDb,iD3EtzDe,EAAA;I2EiyDlB;MAyBG,wBAAwB;MACxB,sBAAsB;MACtB,iD3E5zDe,EAAA;;A2Ei0DrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe,EAAA;EAEf;IACE,aAAa,EAAA;EAGf;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,0C3El1DgB;I2Em1DhB,iC3E70De,EAAA;;A2Ei1DnB;EACE,4EAA4E;EAC5E,iCAAiC;EACjC,eAAe,EAAA;EAHjB;IAMI,oC3E51DiB,EAAA;E2Es1DrB;IAUI,+CAA+C;IAC/C,iC3Ej2DiB,EAAA;E2Eo2DnB;IACE,mC3Ex1DiB,EAAA;E2E21DnB;IACE,qC3Ez1DuB,EAAA;E2E41DzB;IACE,aAAa,EAAA;;AAIjB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY,EAAA;EAJd;IAMsB,eAAe,EAAA;EANrC;IAOsB,qBAAqB,EAAA;EAP3C;IAQsB,oBAAoB,EAAA;EAR1C;IASsB,qBAAqB,EAAA;EAEzC;IAEE,iBAAiB;IACjB,cAAc;IACd,eAAe,EAAA;EAGjB;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,oC3E14DiB;I2E24DjB,c3Er7DqB;I2Es7DrB,eAAe;IACf,uDAAuD,EAAA;IAVxD;MAaG,yBAAyB,EAAA;IAb5B;MAiBG,oC3Ep5De,EAAA;E2Ew5DnB;IAEE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB,EAAA;EAGnB;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,c3Ej9DqB;I2Ek9DrB,oC3Ex6DiB;I2Ey6DjB,0C3Ez6DiB,EAAA;I2E26DjB;MACE,qC3E55DqB;M2E65DrB,sC3E75DqB;M2E85DrB,c3E95DqB,EAAA;E2Ek6DzB;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY,EAAA;EAGd;IACE,kBAAkB;IAClB,gBAAgB;IAChB,c3Et+DqB;I2Eu+DrB,sBAAsB,EAAA;EAGxB;IACE,kBAAkB;IAClB,gC3E5+DqB;I2E6+DrB,sBAAsB;IACtB,yBAAyB,EAAA;;AAI7B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0C3Ej9DmB;E2Ek9DnB,oC3El9DmB;E2Em9DnB,c3Ep9DkB,EAAA;E2Es9DlB;IACE,sC3Ev9DgB;I2Ew9DhB,kC3Et9DU,EAAA;E2Ey9DZ;IACE,uC3E38DuB;I2E48DvB,qC3E58DuB;I2E68DvB,c3E78DuB,EAAA;E2Eg9DzB;IACE,uC3Ep/DiB;I2Eq/DjB,mC3El/DgB;I2Em/DhB,c3Et/DiB,EAAA;E2Ey/DnB;IACE,sC3Ev9DuB;I2Ew9DvB,qC3Ex9DuB;I2Ey9DvB,c3Ez9DuB,EAAA;;A2E69D3B;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY,EAAA;EAEZ;IACE,gC3E1+DuB,EAAA;E2E6+DzB;IACE,gC3EliEqB;I2EmiErB,kBAAkB,EAAA;EAGpB;IACE,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,0C3EngEgB;I2EogEhB,iC3E9/De,EAAA;E2EigEjB;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,YAAY,EAAA;EAGd;IACE,iBAAiB;IACjB,gBAAgB;IAChB,c3E1jEqB,EAAA;E2E6jEvB;IACE,kBAAkB;IAClB,gC3E/jEqB,EAAA;E2EkkEvB;IAEE,kBAAkB;IAClB,gC3ErkEqB,EAAA;E2EwkEvB;IACE,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,2C3E3hEkB;I2E4hElB,8B3E5hEkB;I2E6hElB,eAAe,EAAA;EAGjB;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gC3EpiEuB,EAAA;E2EuiEzB;IACE,kBAAkB;IAClB,gC3E7lEqB,EAAA;;A2EimEzB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB,EAAA;EAEhB;IACE,cAAc;IACd,eAAe;IACf,kBAAkB,EAAA;EAGpB;IACE,c3ExlEiB,EAAA;I2EulElB;MAIG,mB3E3lEe;M2E4lEf,+C3E5lEe,EAAA;E2EgmEnB;IACE,gC3EpkEuB,EAAA;I2EmkExB;MAIG,mB3EtkEgB;M2EukEhB,8C3EvkEgB,EAAA;E2E2kEpB;IACE,gC3EvkEuB,EAAA;I2EskExB;MAIG,mB3E1kEqB;M2E2kErB,+C3E3kEqB,EAAA;;A2EglE3B;EAvZE;IA0ZI,2BAA2B,EAAA;EAjZ/B;IAqZI,eAAe;IACf,gBAAgB,EAAA;EAtvCtB;IA2vCI,sBAAsB,EAAA;IAhvCxB;MAmvCI,cAAc;MACd,eAAe;MACf,YAAY,EAAA;EA9uClB;IAmvCI,gBAAgB,EAAA,EACjB;;A3E9rEH;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;A4Er8BA;EACE,iBAAiB;EAsEjB,qDAAA;EA4UA,yFAAA,EAA2F;EAnZ7F;IAII,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,wBAAwB;IACxB,mBAAmB,EAAA;EARvB;IAYI,cAAc;IACd,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB,EAAA;IAjBvB;MAoBM,kFAC8E,EAAA;EArBpF;IA0BI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,cAAc,EAAA;IA9BlB;MAiCM,qBAAqB,EAAA;IAjC3B;MAqCM,qCAAgD,EAAA;EArCtD;IA0CI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,kCAAkC;IAClC,mBAAmB,EAAA;EA/CvB;IAmDI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,cAAc,EAAA;EAvDlB;IA2DI,gBAAgB;IAChB,kBAAkB;IAClB,gC5ElCqB,EAAA;E4E3BzB;IAiEI,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,gC5EzCqB,EAAA;E4E3BzB;IAyEI,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,0C5ETiB;I4EUjB,wG5ELe;I4EQf,8EAEgC;IAChC,gBAAgB,EAAA;EArFpB;IAyFI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,SAAS;IACT,UAAU;IACV,SAAS;IACT,qC5EvEgB;I4EwEhB,gC5EtEqB;I4EuErB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,mDAEkB,EAAA;IAxGtB;MA4GM,oC5EvCe;M4EwCf,c5EpFc;M4EqFd,aAAa,EAAA;IA9GnB;MAkHM,mC5E7Ce,EAAA;E4ErErB;IAuHI,gD5ElDiB,EAAA;E4ErErB;IA2HI,+C5EtDiB,EAAA;E4ErErB;IA+HI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,qC5E1GgB,EAAA;E4EzBpB;IAwIM,eAAe;IACf,cAAc;IACd,kBAAkB,EAAA;EA1IxB;IA8IM,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,c5ExHc,EAAA;E4EzBpB;IAqJM,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,+B5EnFe,EAAA;E4ErErB;IA6JI,oBAAoB;IACpB,sBAAsB;IACtB,WAAW;IACX,cAAc,EAAA;EAhKlB;IAoKI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,0C5EtGiB;I4EuGjB,iC5ElGe;I4EmGf,c5ElJqB;I4EmJrB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,eAAe,EAAA;IAjLnB;MAqLM,qC5EhHe;M4EiHf,oC5EjHe,EAAA;E4ErErB;IA2LI,yBAAyB,EAAA;IA3L7B;MA8LM,iBAAiB;MACjB,aAAa;MACb,eAAe;MACf,WAAW,EAAA;EAjMjB;IAsMI,mBAAmB;IACnB,gC5E5KqB;I4E6KrB,kBAAkB,EAAA;IAxMtB;MA2MM,c5EvKM,EAAA;E4EpCZ;IAgNI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB,EAAA;EAnNpB;IAuNI,aAAa;IACb,sBAAsB;IACtB,YAAY,EAAA;EAzNhB;IA6NI,kBAAkB;IAClB,WAAW;IACX,gBAAgB,EAAA;EA/NpB;IAmOI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,0C5EnKiB;I4EoKjB,wG5E/Je;I4EkKf,mD5EnNgB;I4EoNhB,0DAA0D,EAAA;IA7O9D;MAgPM,qC5E3Ke;M4E4Kf,uF5E5Ke,EAAA;I4ErErB;MAuPM,aAAa;MACb,oBAAoB,EAAA;EAxP1B;IA6PI,oBAAoB;IACpB,gC5EnOqB;I4EoOrB,cAAc,EAAA;EA/PlB;IAmQI,+B5E9LiB,EAAA;E4ErErB;IAuQI,WAAW;IACX,YAAY,EAAA;EAxQhB;IA4QI,cAAc;IACd,YAAY;IACZ,oBAAoB;IACpB,wBAAwB;IACxB,kCAAkC;IAClC,2BAA2B;IAC3B,4BAA4B;IAC5B,SAAS;IACT,oBAAoB;IACpB,iBAAiB;IACjB,c5E3PqB;I4E4PrB,oB5ElNiB,EAAA;I4ErErB;MA0RM,gC5E/PmB,EAAA;I4E3BzB;MA8RM,oBAAoB;MACpB,wBAAwB;MACxB,2BAA2B,EAAA;EAhSjC;IAqSI,mBAAmB;IACnB,kBAAkB;IAClB,gC5E5QqB,EAAA;E4E3BzB;IA2SI,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,yC5ElPiB;I4EmPjB,iC5E9Oe;I4E+Of,2CAA2C;I5EnL7C,qBAAqB;IACrB,8DA7DiB,EAAA;IA+DjB;MACE,UAAU,EAAA;IAGZ;MACE,iCApEe;MAqEf,oBAAoB,EAAA;IAGtB;MACE,oCA9EiB;MA+EjB,oBAAoB,EAAA;MAEpB;QACE,oCAlFe,EAAA;E4ErErB;IA8TI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,eAAe,EAAA;IApUnB;MAwUM,oC5EnQe,EAAA;E4ErErB;IA6UI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,YAAY,EAAA;EAhVhB;IAoVI,kBAAkB;IAClB,c5E1TqB;I4E2TrB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB,EAAA;EAxV3B;IA4VI,kBAAkB;IAClB,gC5ElUqB;I4EmUrB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB,EAAA;EAhW3B;IAoWI,cAAc,EAAA;EApWlB;IAwWI,gBAAgB;IAChB,SAAS;IACT,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;I5E3OpB,qBAAqB;IACrB,8DA7DiB,EAAA;IA+DjB;MACE,UAAU,EAAA;IAGZ;MACE,iCApEe;MAqEf,oBAAoB,EAAA;IAGtB;MACE,oCA9EiB;MA+EjB,oBAAoB,EAAA;MAEpB;QACE,oCAlFe,EAAA;E4ErErB;IAsXI,wBAAwB;IACxB,mBAAmB;IACnB,2C5EnTiB;I4EoTjB,gC5E9VqB;I4E+VrB,kBAAkB,EAAA;EA1XtB;IA8XI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,wBAAwB;IACxB,mBAAmB;IACnB,yC5E/TiB;I4EgUjB,wG5E3Te;I4E8Tf,0CAA0C,EAAA;EAxY9C;IA4YI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,cAAc,EAAA;EAhZlB;IAqZI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,uC5EwL8B;I4EvL9B,4F5EkLgB;I4E/KhB,8EAEgC;IAChC,gBAAgB,EAAA;IA/ZpB;MAkaM,MAAM,EAAA;IAlaZ;MAsaM,YAAY;MACZ,iBAAiB;MACjB,wBAAwB;MACxB,eAAe;MACf,iBAAiB,EAAA;IA1avB;MA8aM,cAAc;MACd,eAAe;MACf,gBAAgB;MAChB,sBAAsB;MACtB,gC5EzZc,EAAA;I4EzBpB;;MAubM,aAAa,EAAA;IAvbnB;MA2bM,YAAY;MACZ,uBAAuB;MACvB,kBAAkB;MAClB,qC5Erac;M4Esad,2C5EiJ4B;M4EhJ5B,+B5Evac;M4Ewad,gBAAgB,EAAA;IAjctB;MAqcM,oC5E0I0B;M4EzI1B,uC5E0I4B,EAAA;I4EhlBlC;MA0cM,YAAY,EAAA;IA1clB;;MA+cM,aAAa;MACb,gBAAgB;MAChB,eAAe;MACf,sBAAsB;MACtB,yBAAyB,EAAA;IAnd/B;MAudM,yBAAyB,EAAA;IAvd/B;;MA4dM,sBAAsB;MACtB,kBAAkB;MAClB,oC5Ercc;M4Escd,c5Etcc;M4Eucd,gBAAgB;MAChB,kCAAkC,EAAA;IAjexC;;MAseM,qBAAqB;MACrB,6BAA6B;MAC7B,iFAGuB,EAAA;MA3e7B;;;QA+eQ,oC5EgGwB;Q4E/FxB,sC5EgG0B;Q4E/F1B,8C5E8FwB;Q4E7FxB,aAAa,EAAA;IAlfrB;;MAwfM,uBAAuB;MACvB,kBAAkB;MAClB,mC5EqF0B;M4EpF1B,gBAAgB;MAChB,kCAAkC,EAAA;IA5fxC;MAggBM,mBAAmB;MACnB,WAAW;MACX,gBAAgB;MAChB,YAAY;MACZ,gBAAgB;MAChB,oC5E0E0B;M4EzE1B,c5E7ec;M4E8ed,iCAAiC,EAAA;MAvgBvC;QA2gBQ,mB5EqE0B;Q4EpE1B,aAAa,EAAA;IA5gBrB;MAihBM,kBAAkB;MAClB,gBAAgB;MAChB,aAAa,EAAA;EAnhBnB;IAwhBI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,cAAc,EAAA;EA3hBlB;IA+hBI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,sBAAsB,EAAA;EAniB1B;IAuiBI,sBAAsB;IACtB,uBAAuB;IACvB,0C5EpeiB;I4EqejB,mBAAmB;IACnB,iC5Ejee,EAAA;E4E1EnB;IA+iBI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,sBAAsB,EAAA;EAnjB1B;IAujBI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,YAAY,EAAA;EA5jBhB;IAgkBI,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,c5EziBqB,EAAA;E4E3BzB;IAwkBI,c5ErhBW,EAAA;E4EnDf;IA4kBI,c5ExiBQ,EAAA;E4EpCZ;IAglBI,c5E3gBiB,EAAA;E4ErErB;IAolBI,c5ExjBgB;I4EyjBhB,aAAa,EAAA;EArlBjB;IAylBI,aAAa;IACb,eAAe;IACf,WAAW;IACX,mBAAmB,EAAA;EA5lBvB;IAgmBI,aAAa;IACb,sBAAsB;IACtB,YAAY,EAAA;EAlmBhB;IAsmBI,mBAAmB;IACnB,c5E3kBgB;I4E4kBhB,kBAAkB,EAAA;EAxmBtB;IA4mBI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,mBAAmB,EAAA;EA/mBvB;IAmnBI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,c5E7lBqB,EAAA;E4E3BzB;IA4nBI,kCAAkC;IAClC,gBAAgB;IAChB,c5EzjBiB,EAAA;E4ErErB;IAkoBI,aAAa;IACb,sBAAsB;IACtB,YAAY,EAAA;EApoBhB;IAwoBI,0C5EnkBiB;I4EokBjB,mBAAmB;IACnB,uBAAuB;IACvB,iC5EjkBe,EAAA;E4E1EnB;IA+oBI,sBAAsB,EAAA;EA/oB1B;IAmpBI,mBAAmB;IACnB,kBAAkB,EAAA;EAppBtB;IAwpBI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,c5EhoBgB,EAAA;E4E5BpB;IAgqBI,c5E3lBiB,EAAA;E4ErErB;IAoqBI,c5EnlBY;I4EolBZ,iBAAiB,EAAA;EArqBrB;IAyqBI,wBAAwB;IACxB,oBAAoB;IACpB,kBAAkB,EAAA;EA3qBtB;IA+qBI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,qBAAqB,EAAA;IAlrBzB;MAqrBM,aAAa;MACb,sBAAsB;MACtB,YAAY;MACZ,kBAAkB;MAClB,c5E7pBc,EAAA;I4E5BpB;MA6rBM,aAAa,EAAA;EA7rBnB;IAksBI,mBAAmB;IACnB,kBAAkB;IAClB,c5EzqBqB,EAAA;E4E3BzB;IAysBM,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,c5EjrBc;I4EkrBd,YAAY,EAAA;EA9sBlB;IAmtBI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,cAAc;IACd,aAAa,EAAA;EAvtBjB;IA2tBI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,aAAa,EAAA;EA9tBjB;IAkuBI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY,EAAA;EAtuBhB;IA0uBI,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,YAAY,EAAA;EA7uBhB;IAivBI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,wBAAwB;IACxB,oBAAoB;IACpB,0C5EjrBiB;I4EkrBjB,iC5E7qBe;I4E8qBf,kBAAkB;IAClB,c5E9tBqB,EAAA;I4E3BzB;MA6vBM,qC5E1sBS;M4E2sBT,c5E3sBS,EAAA;I4EnDf;MAmwBM,qC5E/tBM;M4EguBN,cAAyB,EAAA;EApwB/B;IAywBI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,wBAAwB;IACxB,gCAAgC,EAAA;EA7wBpC;IAixBI,kCAAkC;IAClC,gBAAgB;IAChB,c5E9sBiB;I4E+sBjB,kBAAkB,EAAA;EApxBtB;IAwxBI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,0C5EztBiB;I4E0tBjB,gC5ErtBe;I4EstBf,iBAAiB;IACjB,c5ErwBgB,EAAA;I4E5BpB;MAoyBM,c5EzwBmB;M4E0wBnB,kBAAkB,EAAA;EAryBxB;IA0yBI,cAAc;IACd,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,0C5EzuBiB;I4E0uBjB,mBAAmB;IACnB,iC5EtuBe;IA4DjB,qBAAqB;IACrB,8DA7DiB,EAAA;IA+DjB;MACE,UAAU,EAAA;IAGZ;MACE,iCApEe;MAqEf,oBAAoB,EAAA;IAGtB;MACE,oCA9EiB;MA+EjB,oBAAoB,EAAA;MAEpB;QACE,oCAlFe,EAAA;E4ErErB;IAqzBI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB,EAAA;IAxzBpB;;MA4zBM,uBAAuB;MACvB,gBAAgB;MAChB,mBAAmB;MACnB,kD5EpyBmB,EAAA;I4E3BzB;MAm0BM,gBAAgB;MAChB,MAAM;MACN,UAAU;MACV,kBAAkB;MAClB,yBAAyB;MACzB,sBAAsB;MACtB,c5E7yBc;M4E8yBd,gBAAgB;MAChB,iC5EjwBa;M4EkwBb,4C5EjzBmB,EAAA;E4E3BzB;IAk1BM,iC5ExwBa,EAAA;E4E1EnB;IAs1BM,iC5E5wBa,EAAA;E4E1EnB;IA41BM,mC5EzyBS;I4E0yBT,mD5E1yBS,EAAA;E4EnDf;IAi2BM,0E5E9yBS,EAAA;E4EnDf;IAs2BI,aAAa;IACb,uBAAuB;IACvB,WAAW,EAAA;EAx2Bf;;IA62BI,cAAc;IACd,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,mB5Ev1BiB;I4Ew1BjB,0C5EjzBiB,EAAA;E4ErErB;;IA23BI,WAAW;IACX,YAAY;IACZ,mBAAmB,EAAA;EA73BvB;IAi4BI,kBAAkB;IAClB,gBAAgB;IAChB,c5Ev2BgB,EAAA;E4E5BpB;IAu4BI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,YAAY,EAAA;EA14BhB;IA84BI,c5En3BqB;I4Eo3BrB,kBAAkB,EAAA;EA/4BtB;IAm5BI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,c5E33BgB,EAAA;E4E5BpB;IA25BI,oBAAoB;IACpB,mBAAmB;IACnB,wBAAwB;IACxB,oBAAoB;IACpB,0C5E11BiB;I4E21BjB,kC5Ep1BoB;I4Eq1BpB,c5Er4BgB;I4Es4BhB,mBAAmB,EAAA;IAl6BvB;MAq6BM,qC5Eh2Be;M4Ei2Bf,c5Ej2Be,EAAA;E4ErErB;IA26BI,gBAAgB;IAChB,c5Ej5BqB,EAAA;E4E3BzB;;IAi7BI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,c5Ez5BgB,EAAA;I4E5BpB;;MAw7BM,c5E75BmB,EAAA;E4E3BzB;IA67BI,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,kC5E94BW;I4E+4BX,c5E/4BW;I4Eg5BX,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB,EAAA;EAr8B7B;IAy8BI,c5E76BgB;I4E86BhB,aAAa;IACb,iBAAiB,EAAA;EA38BrB;IA+8BI,kBAAkB;IAClB,c5Ep7BgB;I4Eq7BhB,kCAAkC,EAAA;EAj9BtC;IAq9BI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,qBAAqB,EAAA;IAx9BzB;MA29BM,aAAa;MACb,sBAAsB;MACtB,WAAW;MACX,iBAAiB;MACjB,c5En8Bc,EAAA;I4E5BpB;MAm+BM,aAAa,EAAA;EAn+BnB;IAw+BI,yBAAoC;IACpC,gDAAyC,EAAA;EAz+B7C;IA6+BI,mBAAmB;IACnB,kBAAkB;IAClB,c5E95BY,EAAA;;A4Em6BhB;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,aAAa,EAAA;EAJf;IAOI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,aAAa,EAAA;;A5E//BjB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;A6Er8BA;EAEI,mBAAmB;EACnB,c7EiCQ;E6EhCR,kBAAkB,EAAA;;AAJtB;EAQI,aAAa;EACb,SAAS;EACT,0BAA0B,EAAA;EAV9B;IAaM,0DAA0D,EAAA;EAG5D;IAhBJ;MAkBQ,0BAA0B,EAAA,EAC3B;;AAnBP;EAwBI,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gC7EDqB;E6EErB,mBAAmB,EAAA;;AA7BvB;EAiCI,mBAAmB,EAAA;;AAjCvB;EAqCI,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,eAAe;EACf,iBAAiB,EAAA;;AA1CrB;EA8CI,kBAAkB;EAClB,sBAAsB;EACtB,gC7ErBqB;E6EsBrB,mBAAmB,EAAA;;AAjDvB;EAqDI,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,c7EaiB;E6EZjB,qBAAqB;EACrB,sBAAsB,EAAA;EA1D1B;IA6DM,c7EOc;I6ENd,0BAA0B,EAAA;;AA9DhC;EAmEI,0CAAqD,EAAA;;AAnEzD;EAuEI,0CAAqD,EAAA;;AAvEzD;;EA4EI,mBAAmB;EACnB,WAAW,EAAA;EA7Ef;;IAgFM,WAAW,EAAA;EAhFjB;;IAoFM,YAAY,EAAA;EApFlB;;;;IAyFM,WAAW,EAAA;EAzFjB;;;;;;;;;;;;IAkGM,kBAAkB;IAClB,sBAAsB,EAAA;;AAnG5B;;EAyGI,mBAAmB;EACnB,WAAW,EAAA;EA1Gf;;IA6GM,UAAU,EAAA;EA7GhB;;IAiHM,UAAU,EAAA;EAjHhB;;IAqHM,UAAU,EAAA;EArHhB;;IAyHM,UAAU,EAAA;EAzHhB;;IA6HM,UAAU,EAAA;;AA7HhB;EAkII,eAAe;EACf,iCAAiC,EAAA;EAnIrC;IAsIM,oC7EjEe,EAAA;E6ErErB;IA0IM,+CAA+C;IAC/C,iC7EtEe,EAAA;;A6ErErB;EAgJI,c7EjHU,EAAA;;A6E/Bd;EAoJI,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY,EAAA;;AAzJhB;EA6JI,eAAe;EACf,gBAAgB,EAAA;;AA9JpB;EAkKI,eAAe;EACf,gBAAgB,EAAA;;AAnKpB;EAuKI,eAAe;EACf,gBAAgB,EAAA;;AAxKpB;EA4KI,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc,EAAA;;AA/KlB;EAmLI,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,YAAY,EAAA;EAvLhB;IA0LM,SAAS;IACT,cAAc,EAAA;;AA3LpB;EAgMI,cAAc;EACd,YAAY,EAAA;;AAjMhB;EAqMI,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,gC7E9KqB,EAAA;;A6E3BzB;EA6MI,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,gBAAgB,EAAA;EAlNpB;IAqNM,kBAAkB,EAAA;;AArNxB;EA0NI,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,yC7EzJiB;E6E0JjB,kC7EnJoB;E6EoJpB,kBAAkB;EAClB,sBAAsB;EACtB,gC7EvMqB,EAAA;E6E3BzB;IAqOM,sC7EhKe;I6EiKf,oC7EjKe,EAAA;E6ErErB;IA0OM,sC7EtKc;I6EuKd,oC7EvKc,EAAA;E6EpEpB;IA+OM,qB7E3MM;I6E4MN,mC7E5MM;I6E6MN,c7EtNmB,EAAA;;A6E3BzB;EAsPI,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;EACN,YAAY,EAAA;;AA1PhB;EA8PI,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe,EAAA;;AAlQnB;EAsQI,cAAc;EACd,sBAAsB,EAAA;;AAvQ1B;EA2QI,cAAc,EAAA;;AA3QlB;EA+QI,qBAAqB;EACrB,oBAAoB;EACpB,iD7E5MiB,EAAA;;A6ErErB;EAqRI,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,+B7E/PqB,EAAA;;A6E3BzB;EA8RI,WAAW;EACX,kBAAkB;EAClB,gBAAgB,EAAA;;AAhSpB;EAoSI,aAAa;EACb,yBAAyB;EACzB,mBAAmB,EAAA;;AAtSvB;EA0SI,mBAAmB,EAAA;;AA1SvB;EA8SI,gBAAgB;EAChB,gC7EpRqB,EAAA;;AA5BzB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;A8Ev8BA,gBAAA;AAGA;EACE,kBAAkB;EAClB,yB9E8BsB;E8E7BtB,c9EuBuB;E8EtBvB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB,EAAA;;AAGzB;EACE,aAAa;EAAE,sBAAA,EAAuB;;AAGxC;EACI,yB9Eae;E8EZf,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,c9EGqB;E8EFrB,qBAAqB;EACrB,kBAAkB,EAAA;EARtB;IAWM,YAAY;IACZ,c9EHmB;I8EInB,0BAA0B,EAAA;EAbhC;IAiBM,yB9EFkB;I8EGlB,YAAY,EAAA;;AAIhB;EACE,mB9ETe;E8EUf,iB9E+iBY;E8E9iBZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,yB9EjBoB;E8EkBpB,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC,EAAA;;AAGlC;EACE,kBAAkB;EAClB,mBAAmB;EACnB,c9EjCqB,EAAA;;AA5BzB;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;A+Et8BA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB,EAAA;;AAGpB;EACE,YAAY;EACZ,iBAAiB,EAAA;EAFnB;IAKI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,QAAQ;IACR,WAAW;IACX,6CAA6C;IAC7C,qBAAqB;IACrB,2BAA2B,EAAA;;AAI/B;EACE,aAAY,EAAA;;AAEd;EACE,UAAU,EAAA;;AAGZ;EACE,4BAA4B,EAAA;;AAS9B;EACE,WAAW;EACX,YAAY,EAAA;EAEZ;IAJF;MAKI,YAAY,EAAA,EAWf;EAPC;IATF;MAUI,YAAY,EAAA,EAMf;EAJG;IAZJ;MAaM,YAAY,EAAA,EAGjB;;AAGD;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,WAAW;EAEX,eAAe;E/E8hBf,WAAW;EACX,iBATc,EAAA;E+E7hBhB;IAWI,cAAc;IACd,WAAW;IACX,gBAAgB,EAAA;EAbpB;IAkBI,gBAAgB;IAChB,UAAU;IACV,gBAAgB,EAAA;IApBpB;MAuBM,qBAAqB;MACrB,YAAY;MACZ,WAAW;MACX,WAAW;MACX,yEAA2G;MAC3G,yB/E7DmB;M+E8DnB,0BAAyB;MACzB,kBAAkB;MAClB,eAAe,EAAA;MA/BrB;QAkCQ,UAAU,EAAA;EAKhB;IAvCF;MAwCI,WAAW,EAAA;MAxCf;QA2CM,mCAAmC,EAAA;MA3CzC;QA+CM,mCAAmC,EAAA;MA/CzC;QAmDM,gBAAgB,EAAA,EACjB;;AAIL;EACE,oCAAoC;EACpC,mCAAmC;EACnC,c/E5FuB;E+E6FvB,mBAAmB;EACnB,UAAU,EAAA;;AAGZ;EACE,oCAAoC;EACpC,c/EnGuB;E+EoGvB,mCAAmC;EACnC,UAAU,EAAA;;AAGZ;EACE,UAAU;EACV,WAAW;EACX,yDAA0C;EAC1C,yBAAyB,EAAA;;AA9F3B;EAsGE,kBAAkB,EAAA;EADpB;;IAOI,YAAY,EAAA;EAPhB;IAWI,uBAAuB,EAAA;EAX3B;IAeI,YAAY,EAAA;EAfhB;IAmBI,YAAY;IACZ,aAAa;IACb,oBAAoB,EAAA;EArBxB;IAyBI,OAAO;IACP,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,gBAAgB,EAAA;EA9BpB;;IAmCI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,cAAc,EAAA;EA1ClB;IA8CI,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iCAAiC;IACjC,UAAU,EAAA;IAtDd;MAyDM,UAAU,EAAA;IAzDhB;MA6DM,YAAY;MACZ,YAAY;MACZ,a/ElLmB;M+EmLnB,0BAA0B;MAO1B,4BAA4B,EAAA;MAvElC;QAmEQ,iBAAiB,EAAA;MAnEzB;QA0EQ,mBAAmB,EAAA;MA1E3B;QA6EQ,qBAAqB,EAAA;MA7E7B;QAgFQ,qBAAqB,EAAA;;AAM7B;EACE;IACE,mBAAmB;IACnB,UAAU;IACV,a/E7MqB,EAAA;E+E+MvB;IACE,iBAAiB;IACjB,qBAAqB;IACrB,UAAU;IACV,a/E1MQ,EAAA,EAAA;;A+EkNZ;EACE,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,UAAU;EACV,iCAAiC,EAAA;EAEjC;IATF;MAUI,iCAAiC,EAAA,EAEpC;;AAED;EACE,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,yDAA4C;EAC5C,mDAAmD;EACnD,+CAA+C,EAAA;;AAIjD;EACE,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;EAC1B,sFAAsF;EACtF,c/ExPkB;E+EyPlB,mCAAmC;EACnC,oCAAoC;EACpC,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,mDAAmD,EAAA;EAbrD;IAgBI,sFAAsF;IACtF,YAAY,EAAA;EAGd;IApBF;MAqBI,0BAA0B,EAAA,EAE7B;;AAGD;EACE,qBAAqB;EACrB,yCAAyC,EAAA;;AAEzC;EACE;IACE,mBAAmB,EAAA;EAErB;IACE,sBAAsB,EAAA,EAAA;;AAY5B;EACE,iB/E2RiB;E+E1RjB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB,EAAA;EAMnB;IAVF;M/EmSE,WAAW;MACX,iBATc;M+E5QZ,iBAAiB;MACjB,kBAAkB;MAClB,mBAAmB;MACnB,qCAAqC;MACrC,sCAAsC,EAAA,EAczC;EAjCD;IAwBI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB,EAAA;;AAOpB;EACE,aAAa;EACb,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EAAE,kEAAA,EAAmE;EAExF;IAPF;MAQI,WAAW;MACX,uBAAuB;MACvB,eAAe,EAAA,EAElB;;AAED;EACE,yBAAyB;EACzB,c/ErVkB,EAAA;;A+EwVpB;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EAEf,sBAAsB,EAAA;EANxB;IASI,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAA;EAIrB;IAfF;MAmBI,eAAe;MACf,iBAAiB;MACjB,kBAAkB;MAClB,mBAAmB,EAAA,EAGtB;;AAGD;EACE,4BAA6B;EAC7B,kBAAkB,EAAA;;AAGpB;EACE,iCAAiC;EACjC,kCAAkC;EAClC,iCAAiC;EACjC,yBAAyB;EACzB,2BAA2B;EAC3B,UAAU;EACV,uBAAuB;EACvB,kBAAkB;EAClB,4BAA6B;EAC7B,yDAA4C;EAC5C,sBAAsB;EAAE,kDAAA;EACxB,2BAA2B;EAAE,2BAAA;EAC7B,4BAA4B;EAAE,qCAAA;EAC9B,uCAAuC;EACvC,oBAAoB,EAAA;EAEpB;IAjBF;MAkBI,2BAA2B,EAAA,EAG9B;;AAED;EACE,aAAa;EACb,UAAU;EACV,iBAAiB,EAAA;;AAGnB;EACE,c/EvZkB;E+EwZlB,mCAAmC;EACnC,2BAA2B;EAC3B,SAAS;EACT,qBAAqB;EACrB,oBAAoB,EAAA;EAEpB;IARF;MASI,2BAA2B;MAC3B,mBAAmB,EAAA,EAItB;;AAED;EACE,kBAAkB;EAAE,uEAAA;EACpB,wBAAwB,EAAA;EAF1B;IAKI,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAAE,gDAAA;IACpB,UAAU;IAAE,4CAAA,EAA6C;IAEzD;MAZJ;QAaM,wBAAwB;QACxB,WAAW,EAAA,EAGd;;AAGH;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EAAE,8CAAA;EACV,WAAW;EAAE,iDAAA;EACb,SAAS;EACT,UAAU;EACV,8B/E9bY;E+E+bZ,+B/E/bY;E+EgcZ,kBAAkB;EAAE,iDAAA;EACpB,oBAAoB;EAAE,mEAAA;EACtB,UAAU;EAAE,mCAAA,EAAoC;;AAGlD;EACE,4BAA4B,EAAA;;AAE9B;EACE,6BAA6B,EAAA;;AAG/B;EACE,aAAa;EACb,mBAAmB;EAEnB,WAAW;EAEX,kBAAkB;EAClB,mBAAmB,EAAA;EAEnB;IATF;MAUI,iBAAiB;MACjB,WAAW;MAEX,sBAAsB,EAAA,EAyBzB;EAtCD;IAiBI,gBAAgB;IAChB,iBAAiB;IACjB,c/EneqB,EAAA;E+EgdzB;IAuBI,gBAAgB;IAChB,iBAAiB;IACjB,c/ExegB,EAAA;I+EyehB;MA1BJ;QA2BM,mBAAmB,EAAA,EAEtB;EAGD;IAhCF;MAmCM,kBAAkB,EAAA,EACnB;;AAML;EACE,kBAAkB,EAAA;;AAKpB;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,qBAAqB,EAAA;EAJvB;IAOI,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,eAAe;IAEf,WAAW;IACX,YAAY,EAAA;;AAMhB;E9EzNA;I8E4NI,sBAAsB,EAAA,EAGvB;;AAGH;E9ElOA;I8EqOI,mBAAmB,EAAA,EAGpB;;AAIH;EAtCA;IAwCI,cAAc;IACd,WAAW,EAAA,EACZ;;AAIH;EACE;IACE,mBAAmB,EAAA;EAErB;IACE,qBAAqB,EAAA,EAAA;;AA3czB;EAodE,kBAAkB;EAClB,UAAS;EACT,WAAW;EACX,yDAA4C;EAC5C,yBAAyB,EAAA;;AAG3B;EACE,aAAa;EACb,gBAAgB;EAChB,oBAAoB;E/EApB,WAAW;EACX,iBATc;E+EWd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB,EAAA;;AAGrB;EACE,yB/E3kBiB;E+E4kBjB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,yB/E/kBsB;E+EglBtB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC;EAChC,UAAU;EACV,4BAA4B;EAC5B,sCAAsC,EAAA;;AAGxC;EACE,2BAA2B,EAAA;;AAG7B;EACE,UAAU;EACV,wBAAwB,EAAA;;AAG1B;EACE,kBAAkB;EAClB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,4BAA4B;EAC5B,sCAAsC,EAAA;;AAGxC;EACE,2BAA2B,EAAA;;AAG7B;EACE,UAAU;EACV,wBAAwB,EAAA;;AAI1B;EACE,yB/EloBsB;E+EmoBtB,c/EzoBuB;E+E0oBvB,oCAAoC;EACpC,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,6BAA6B,EAAA;;AAG/B;EACE,c/EnpBuB;E+EopBvB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB,EAAA;;AAGtB,sBAAA;AACA,sBAAA;AACA,sBAAA;AAEA;EAEE;IACE,gBAAgB;IAChB,WAAW,EAAA;EA/Ff;IAqGI,aAAa;IACb,gBAAgB;IAChB,oBAAoB;I/EpGtB,WAAW;IACX,iBATc;I+E+GZ,kBAAkB;IAClB,sBAAsB,EAAA;EAGxB;IACE,yB/E7qBe;I+E8qBf,aAAa;IACb,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,yB/EjrBoB;I+EkrBpB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB,EAAA;EAnDvB;IAuDI,yB/ExrBoB;I+EyrBpB,c/E/rBqB;I+EgsBrB,oCAAoC;IACpC,iBAAiB;IACjB,WAAW;IACX,aAAa,EAAA;EAjDjB;IAqDI,c/EvsBqB;I+EwsBrB,mBAAmB;IACnB,kBAAkB,EAAA,EACnB;;A/EtuBH;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AgFv8BA;EACE,yBhFiCiB;EgFhCjB,chF2BuB;EgF1BvB,oCAAoC;EACpC,eAAe;EACf,WAAW;EACX,aAAa,EAAA;;AAGf;EACE,eAAe;EACf,chFkBuB;EgFjBvB,mBhFuBsB;EgFtBtB,yBhFsBsB;EgFrBtB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EhFmlBX,WAAW;EACX,iBATc;EgFxkBd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC,EAAA;;AAGlC;EACE,4BAA4B;EAC5B,6BAA6B,EAAA;;AAI/B;EACE,chFPuB;EgFQvB,mBhFHiB;EgFIjB,eAAe;EACf,yBhFJsB;EgFKtB,kBAAkB;EAClB,mBAAmB;EhF0jBnB,WAAW;EACX,iBATc;EgF/iBd,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,gCAAgC,EAAA;;AAGlC;EACE,iBAAiB;EACjB,oBAAoB,EAAA;;AAGtB;EACM,WAAA;EAEA;IACE,mBAAmB,EAAA;EAGrB;IACE,iBAAiB;IACjB,kBAAkB,EAAA,EACnB;;AhFnEP;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AiFr8BA;;EAEI,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB,EAAA;EARvB;;IAWQ,yBjFoBM;IiFnBN,yBjF0BU;IiFzBV,WAAW;IACX,kBAAkB;IAClB,QAAQ,EAAA;EAfhB;;IAoBM,mBAAmB;IjF2lBvB,mHAAiF;IACjF,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IiF5lBvB,cjFKmB;IiFJnB,iBAAiB;IACjB,gCjFIc;IiFHd,0BAA0B,EAAA;IAzBhC;;MA4BQ,aAAa,EAAA;IA5BrB;;MAgCQ,eAAe;MACf,iBAAiB;MACjB,yBAAyB;MACzB,kBAAkB,EAAA;EAnC1B;;IA0CM,cjFfmB;IiFgBnB,iBAAiB;IACjB,gCjFhBc;IiFiBd,0BAA0B;IjFkkB9B,mHAAiF;IACjF,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B,EAAA;IiFlnB7B;;MAiDQ,aAAa,EAAA;IAjDrB;;MAqDQ,kBAAkB;MAClB,iBAAiB;MACjB,yBAAyB;MACzB,kBAAkB,EAAA;EAxD1B;;IA6DQ,yBjF5BgB;IiF6BhB,iBAAiB;IACjB,gBAAgB;IAChB,+BAA+B;IAC/B,cjFtCiB;IiFuCjB,0BAA0B;IAC1B,YAAY,EAAA;IjFmsBhB;;MACI,UAjKa,EAAA;IAoKjB;;MACI,mBApKuB;MAqKvB,kBAAkB;MAClB,kBAAkB,EAAA;IAGtB;;MACI,yBA3uBU;MA4uBV,kBAAkB,EAAA;MAElB;;QACI,yBAAqD,EAAA;IiFrxBjE;;MAuEY,kBAAmB;MACnB,cAAc,EAAA;IAxE1B;;MA6EU,aAAa;MACb,YAAY;MACZ,SAAS;MACT,kBAAkB;MAClB,iBAAiB,EAAA;MAjF3B;;QAoFY,iBAAiB,EAAA;EApF7B;;IA0FM,yBjFzDkB;IiF0DlB,iBAAiB;IACjB,gBAAgB;IAChB,+BAA+B;IAC/B,cjFnEmB;IiFoEnB,0BAA0B;IAC1B,YAAY,EAAA;IAhGlB;;MAmGQ,aAAa;MACb,yBjFpEW;MiFqEX,mBAAmB;MACnB,kBAAkB;MAClB,cjF5EiB,EAAA;IiF3BzB;;MA2GQ,aAAa;MACb,SAAS;MACT,WAAW,EAAA;EAKf;IAlHJ;;MAmHM,WAAW;MACX,0BAA0B;MAC1B,SAAS;MACT,UAAU,EAAA,EAOb;EAJC;IAzHJ;;MA0HM,8BAA8B;MAC9B,gBAAgB,EAAA,EAEnB;;AjF9HH;EACI,wBAAwB;EACxB,wHACuD,EAAA;;AAG3D;EACI,mBAAmB;EACnB,4DAAsD;EACtD,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EACI,uBAAuB;EACvB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B,EAAA;;AA05BnC,oFAAA;AAuBA,iGAAA;AkFv8BA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS,EAAA;;AAGX;EACE,iBAAiB;EACjB,YAAY,EAAA;;AAGd;EACE,WAAW,EAAA;;AAGb;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS,EAAA;;AAGX;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,8BAA8B,EAAA;;AAGhC;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa,EAAA;;AAGf;;EAEE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,sBAAsB;EACtB,sBAAsB,EAAA;;AAIxB;EACE,0BAA0B,EAAA;;AAG5B;EAEI,mBAAmB;EACnB,WAAW,EAAA;;AAHf;;;;;;;;;;;;EAmBI,gBAAgB;EAChB,YAAY;EACZ,gBAAgB,EAAA;;AArBpB;EAyBI,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe,EAAA;EA7BnB;IAgCM,YAAY;IACZ,mBAAmB,EAAA;;AAjCzB;EAsCI,gBAAgB;EAChB,uBAAuB,EAAA;;AAvC3B;EA2CI,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,WAAW,EAAA;EA/Cf;IAkDM,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;IACtB,kCAAkC,EAAA;EAtDxC;IA0DM,YAAY;IACZ,gBAAgB;IAChB,cAAc,EAAA;EA5DpB;IAgEM,cAAc,EAAA;EAhEpB;;IAqEM,eAAe;IACf,gBAAgB;IAChB,uBAAuB,EAAA;;AAvE7B;EA4EI,sBAAsB,EAAA;;AA5E1B;;EAiFI,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB,EAAA;EAtFvB;;IAyFM,cAAc,EAAA;EAzFpB;;IA6FM,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,QAAQ;IACR,cAAc,EAAA;;AAjGpB;EAsGI,WAAW,EAAA;;AAtGf;EA0GI,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,cAAc,EAAA;;AA/GlB;EAmHI,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ,EAAA;;AArHZ;EAyHI,mCAAmC;EACnC,qCAAqC,EAAA;;AA1HzC;EA8HI,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAlIvB;EAsII,aAAa,EAAA;;AAtIjB;EA0II,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe,EAAA;EA7InB;IAgJM,YAAY;IACZ,mBAAmB,EAAA;;AAOzB;EAEI,UAAU,EAAA;;AAFd;EAMI,UAAU,EAAA;;AANd;EAUI,UAAU,EAAA;;AAVd;EAcI,UAAU,EAAA;;AAdd;EAkBI,UAAU,EAAA;;AAKd;EAEI,UAAU,EAAA;;AAFd;EAMI,UAAU,EAAA;;AANd;EAUI,UAAU,EAAA;;AAVd;EAcI,UAAU,EAAA;;AAdd;EAkBI,UAAU,EAAA;;AAKd;EAEI,UAAU,EAAA;;AAFd;EAMI,UAAU,EAAA;;AANd;EAUI,UAAU,EAAA;;AAVd;EAcI,UAAU,EAAA;;AAdd;EAkBI,UAAU,EAAA;;AAKd;EAEI,UAAU,EAAA;;AAFd;EAMI,SAAS,EAAA;;AANb;EAUI,UAAU,EAAA;;AAVd;EAcI,UAAU,EAAA;;AAdd;EAkBI,UAAU,EAAA;;AAlBd;EAsBI,UAAU,EAAA;;AAtBd;EA0BI,UAAU,EAAA;;AA1Bd;EA8BI,kBAAkB;EAClB,sBAAsB,EAAA;;AA/B1B;EAmCI,cAAc;EACd,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,oDAAoD,EAAA;;AA1CxD;;EAgDM,mBAAmB,EAAA;;AAKzB;EAEI,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,mBAAmB,EAAA;EANvB;IASM,eAAe;IACf,gBAAgB,EAAA;EAVtB;IAcM,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,clFtTc,EAAA;EkFqSpB;IAqBM,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,kBAAkB,EAAA;IAzBxB;MA4BQ,gBAAgB,EAAA;;AA5BxB;EAkCI,gBAAgB,EAAA;;AAlCpB;EAsCI,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,yBlF5UU;EkF6UV,kBAAkB;EAClB,kClF7Ue,EAAA;EkFiSnB;IA+CM,WAAW;IACX,cAAc;IACd,kBAAkB,EAAA;EAjDxB;IAqDM,aAAa;IACb,eAAe;IACf,QAAQ,EAAA;EAvDd;IA2DM,kBAAkB;IAClB,clFjWc;IkFkWd,eAAe,EAAA;;AAKrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB,EAAA;EAEnB;IACE,iBAAiB;IACjB,gBAAgB,EAAA;EAGlB;IACE,clFhVgB;IkFiVhB,mClFhViB;IkFiVjB,sClFjViB,EAAA;EkFoVnB;IACE,clF3UuB;IkF4UvB,mClF1UY;IkF2UZ,qClF5UkB,EAAA;EkF+UpB;IACE,clF/WsB;IkFgXtB,kClF9WW;IkF+WX,uClFhXiB,EAAA;EkFmXnB;IACE,clFjVuB;IkFkVvB,mClFjVkB;IkFkVlB,oClFjViB,EAAA;EkFoVnB;IACE,clFjZqB;IkFkZrB,kClF/YiB;IkFgZjB,qBlFjZuB,EAAA;EkFoZzB;IACE,clFtZgB;IkFuZhB,iClFpZU;IkFqZV,qBlFvZuB,EAAA;;AkF2Z3B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,YAAY,EAAA;EAEZ;IACE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,YAAY,EAAA;;AAIhB;;;;EAIE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY,EAAA;EARd;;;;IAWI,YAAY,EAAA;;AAIhB;EACE,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ,EAAA;EAER;IACE,gBAAgB,EAAA;EAGlB;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB,EAAA;;AAIvB;EACE,cAAc;EACd,clFxckB;EkFyclB,kBAAkB;EAClB,YAAY,EAAA;;AlF/UZ;EACE,kBAAkB,EAAA;EAElB;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,oCAvGe;IAwGf,oBAAoB,EAAA;;AAfxB;EACE,kBAAkB,EAAA;EAElB;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,oCA5FgB;IA6FhB,oBAAoB,EAAA;;AAfxB;EACE,kBAAkB,EAAA;EAElB;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,oCA1He;IA2Hf,oBAAoB,EAAA;;AAfxB;EACE,kBAAkB,EAAA;EAElB;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,oCAtFgB;IAuFhB,oBAAoB,EAAA;;AAfxB;EACE,kBAAkB,EAAA;EAElB;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,oCA/IqB;IAgJrB,oBAAoB,EAAA;;AAfxB;EACE,kBAAkB,EAAA;EAElB;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,qCAhJc;IAiJd,oBAAoB,EAAA;;AkF8V1B;EA7gBA;IA+gBI,0BAA0B,EAAA,EAC3B","sourcesContent":["// Imports\n// src/styles/style.scss\n\n@import './variables.scss';\n@import './main.scss';\n@import './cookie.scss';\n@import './HexagonBackground.scss';\n@import './tools/charts.scss';\n@import './tools/sortable-tree.scss';\n@import './tools/reactGridLayout.scss';\n@import './rosterFile.scss';\n@import './orgPositionsBrowse.scss';\n@import './membersDashboard.scss';\n@import './mobileWebAppPromo.scss';\n@import './tools/react-table.scss';\n@import './tools/diagram.scss';\n@import './tools/modal.scss';\n@import './tools/react-select.scss';\n@import './tools/ant-tree-select.scss';\n@import './tools/quill.scss';\n@import './tools/lexical.scss';\n@import './tools/chat.scss';\n@import './tools/user-discord-rank-display.scss';\n@import './components/donor-heart-badge.scss';\n@import './components/donor-gem-badge.scss';\n@import './components/hubToolbarSearch.scss';\n@import './tools/member-profile-card.scss';\n@import './tools/perkThemeOverlays.scss';\n@import './tools/publicToc.scss';\n\n@import './inputs.scss';\n@import './ranks.scss';\n@import './eventTemplates.scss';\n@import './eventPlanner.scss';\n@import './eventPlannerAssignmentView.scss';\n@import './ribbons.scss';\n@import './tools/colorpicker.scss';\n@import './tools/scItemChip.scss';\n@import './tools/bigCalendar.scss';\n@import './teamLeaderEvaluation.scss';\n@import './personalHangar.scss';\n@import './factionReputation.scss';\n@import './personalHubBlueprint.scss';\n@import './LoadingSpinner.scss';\n@import './tools/tools.scss';\n@import './tools/richeTextEditor.scss';\n@import './header.scss';\n@import './notifications.scss';\n@import './publicPages.scss';\n@import './privatePages.scss';\n@import './confirm.scss';\n@import './login.scss';\n@import './identityCheckHub.scss';\n@import './guestAccessPopup.scss';\n@import './calendarSignupIntro.scss';\n@import './onboarding.scss';\n@import './divisionMedia.scss';\n@import './settings.scss';\n@import './settingmenu.scss';\n@import './account.scss';\n@import './security.scss';\n@import './settingsTools.scss';\n@import './settingsAccount.scss';\n@import './adminPanel.scss';\n@import './characterCreator.scss';\n@import './adminDashboard.scss';\n@import './adminAccounting.scss';\n@import './adminWebsite.scss';\n@import './siteAdminGroups.scss';\n@import './adminPublicPages.scss';\n@import './organisationMembers.scss';\n@import './donatePanel.scss';\n@import './profileThemesAdmin.scss';\n@import './academy.scss';\n@import './memberAcademy.scss';\n@import './trainingStandards.scss';\n@import './eventAuctions.scss';\n@import './allOrganizations.scss';\n@import './reserpage.scss';\n@import './homepage.scss';\n@import './faq.scss';\n@import './gcu.scss';\n@import './adminAssignments.scss';\n\n@import '~react-datepicker/dist/react-datepicker.css';\n@import '~react-resizable/css/styles.css';\n@import '~react-grid-layout/css/styles.css';\n","// /src/styles/variables.scss\n// Déclaration de la police\n\n@font-face {\n    font-family: 'GoodTimes';\n    src: url('/public/good-times-rg.otf') format('opentype'),\n         url('/public/good-times-rg.woff2') format('woff2');\n}\n\n@font-face {\n    font-family: 'Lato';\n    src: url('/public/Lato-Regular.woff2') format('woff2');\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'FiraCode';\n    src: url('/public/FiraCode-Regular.woff2') format('woff2');\n    font-weight: normal;\n    font-style: normal;\n}\n\n  body {\n    font-family: 'Lato', sans-serif;\n  }\n  \n// needs unifying grey and blue variables\n// COLOR SET\n$pure-white: #ffffff;\n$pure-black: #000000;\n$very-light-grey: #dfdfdf;\n$light-grey: #b8b8b8;\n$medium-light-grey: #747b81;\n$medium-grey: #384858;                 // NEW\n$grey: #2a3847;                        // KEEP  #2a3847\n$dark-grey: #1c2d38;                   // KEEP  0a304761\n$very-dark-grey: #0c2637;              // KEEP #0b202d 1b2833 \n\n$bright-red: #d12323;\n$red:#9e2222;\n$medium-red:#7e1e1e;\n$dark-red: #491212;\n$very-dark-red: #350404;\n\n// HumanSkin_V2 FinalSkinTone swatches — linear PublicParams converted to sRGB for UI only\n$skin-customizer-dark: rgb(79, 47, 36);\n$skin-masculine-default: rgb(81, 53, 41);\n$skin-male01-head: rgb(93, 63, 47);\n$skin-female-body: rgb(159, 101, 77);\n$skin-male-body: rgb(170, 109, 92);\n$skin-feminine-default: rgb(204, 160, 137);\n\n$very-light-green: #c2f0c3;\n$light-green: #75cf78; \n$green: #5aa05c;\n$radioactive-green: #39ff14;\n$dark-green: #3f7c42;\n$darker-green: #2a5f2d;\n$event-planner-ground-surface: #2e423b;\n$event-planner-ground-accent: #3a5249;\n$event-planner-ground-border: #4a6358;\n$event-planner-ground-vehicle-surface: #323f39;\n$event-planner-ground-vehicle-border: #5d756a;\n$event-planner-ground-slot-surface: #28312d;\n$event-planner-ground-slot-border: #8aa899;\n$event-planner-ground-slot-label: #9bc4b0;\n$event-planner-ground-panel-border: #6f9585;\n$event-planner-ground-panel-glow: rgba($light-green, 0.22);\n$event-planner-team-min-width: 280px;\n$event-planner-team-max-width: 300px;\n\n$light-blue: #5ac3ff;\n$accent-blue: #3a78b4;\n$blue: #004872;\n$blue-grey: #163447;\n$light-panel-blue: #133b53;\n$panel-blue: #1e3042;\n$dark-blue: #00304d;\n$dark-panel-blue: #172738;\n$dark-blue-grey: #151c24;\n\n$very-light-yellow: #aa9e74;\n$very-light-orange: #d8b493;\n$light-orange: #c78445;\n$orange: #9b602a;\n$dark-orange: #6e441c;\n$very-dark-orange: #42260c;\n\n$very-light-purple: #9a80e3;\n$light-purple: #7958c3;\n$dark-purple: #463685;\n$very-dark-purple: #231e45;\n\n$donor-gold: #e8c547;\n$donor-gold-light: #f5df8a;\n$donor-gold-dark: #b8942e;\n\n// Member profile card — active donor space theme\n$member-profile-donor-space: #091b3187;\n$member-profile-donor-nebula: #163a5f;\n$member-profile-donor-glow: #5ac3ff;\n$member-profile-card-glass-bg: #0c254487;\n\n// Faction reputation — shared progress bar tones (list, detail, stepper)\n$factions-reputations-tone-default: $medium-light-grey;\n$factions-reputations-tone-hostile: $bright-red;\n$factions-reputations-tone-not-eligible: $medium-red;\n$factions-reputations-tone-unselected: $medium-grey;\n$factions-reputations-tone-neutral: $very-light-orange;\n$factions-reputations-tone-friendly: $very-light-green;\n$factions-reputations-tone-trusted: $light-green;\n$factions-reputations-tone-renown: $very-light-purple;\n$factions-reputations-tone-legendary: $light-purple;\n\n@mixin factions-reputations-progress-tone-fill($tone: 'default') {\n  @if $tone == 'hostile' {\n    background: linear-gradient(90deg, $dark-red, $factions-reputations-tone-hostile);\n  } @else if $tone == 'not-eligible' {\n    background: linear-gradient(90deg, darken($factions-reputations-tone-not-eligible, 10%), $factions-reputations-tone-not-eligible);\n  } @else if $tone == 'unselected' {\n    background: linear-gradient(90deg, darken($factions-reputations-tone-unselected, 8%), $factions-reputations-tone-unselected);\n  } @else if $tone == 'neutral' {\n    background: linear-gradient(90deg, $light-orange, $factions-reputations-tone-neutral);\n  } @else if $tone == 'friendly' {\n    background: linear-gradient(90deg, $light-green, $factions-reputations-tone-friendly);\n  } @else if $tone == 'trusted' {\n    background: linear-gradient(90deg, $green, $factions-reputations-tone-trusted);\n  } @else if $tone == 'renown' {\n    background: linear-gradient(90deg, $light-purple, $factions-reputations-tone-renown);\n  } @else if $tone == 'legendary' {\n    background: linear-gradient(90deg, $dark-purple, $factions-reputations-tone-legendary);\n  } @else {\n    background: linear-gradient(90deg, darken($factions-reputations-tone-default, 14%), $factions-reputations-tone-default);\n  }\n}\n\n@mixin accounting-inventory-scrollbar {\n  scrollbar-width: thin;\n  scrollbar-color: rgba($accent-blue, 0.5) rgba($dark-blue, 0.45);\n\n  &::-webkit-scrollbar {\n    width: 4px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba($dark-blue, 0.45);\n    border-radius: 999px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba($accent-blue, 0.48);\n    border-radius: 999px;\n\n    &:hover {\n      background: rgba($accent-blue, 0.65);\n    }\n  }\n}\n\n// Role-type accent: short vertical bar on first cell only (not full row height)\n@mixin orgtitles-row-stripe($color, $opacity: 0.5) {\n  td:first-child {\n    position: relative;\n\n    &::before {\n      content: '';\n      position: absolute;\n      left: 4px;\n      top: 50%;\n      transform: translateY(-50%);\n      width: 2px;\n      height: 55%;\n      min-height: 14px;\n      max-height: 22px;\n      border-radius: 1px;\n      background: rgba($color, $opacity);\n      pointer-events: none;\n    }\n  }\n}\n\n@mixin event-planner-responsive-team-columns {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: flex-start;\n  align-content: center;\n  //gap: var(--event-planner-card-gap, 4.5rem);\n  gap: 1rem;\n  width: max-content;\n  max-width: 100%;\n  max-width: 100cqw;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n@mixin event-planner-scrollbar {\n  scrollbar-width: thin;\n  scrollbar-color: rgba($accent-blue, 0.5) rgba($dark-blue, 0.45);\n\n  &::-webkit-scrollbar {\n    width: 4px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba($dark-blue, 0.45);\n    border-radius: 999px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba($accent-blue, 0.48);\n    border-radius: 999px;\n  }\n}\n\n@mixin event-planner-ground-panel-shell {\n  border-radius: 12px;\n  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease,\n    filter 0.15s ease;\n\n  &:not([class*=\"mo-structure-card-bg-\"]) {\n    border: 1px solid rgba($event-planner-ground-panel-border, 0.68);\n    background: linear-gradient(\n      145deg,\n      rgba($event-planner-ground-surface, 0.96),\n      rgba($event-planner-ground-accent, 0.92)\n    );\n    box-shadow:\n      0 8px 22px rgba(0, 0, 0, 0.3),\n      0 0 0 1px rgba($event-planner-ground-border, 0.22),\n      0 0 18px $event-planner-ground-panel-glow,\n      inset 0 1px 0 rgba($event-planner-ground-slot-border, 0.14);\n  }\n\n  &[class*=\"mo-structure-card-bg-\"] {\n    border-width: 1px;\n    border-style: solid;\n    box-shadow:\n      0 8px 20px rgba(0, 0, 0, 0.26),\n      0 0 14px rgba($event-planner-ground-border, 0.18),\n      inset 0 1px 0 rgba($pure-white, 0.06);\n  }\n}\n\n@mixin assignment-view-header-with-vehicle-image($min-height: 76px) {\n  position: relative;\n  min-height: $min-height;\n  padding: 0;\n  border-bottom-color: rgba($very-light-grey, 0.14);\n  background-color: var(--assignment-view-section-c1, $dark-blue-grey);\n  overflow: hidden;\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 40%;\n    z-index: 0;\n    background-image: var(--assignment-view-header-bg);\n    background-size: cover;\n    background-position: center right;\n    background-repeat: no-repeat;\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    z-index: 1;\n    background: linear-gradient(\n      90deg,\n      var(--assignment-view-section-c1, #{$dark-blue-grey}) 0%,\n      var(--assignment-view-section-c1, #{$dark-blue-grey}) 34%,\n      color-mix(in srgb, var(--assignment-view-section-c2, #{$dark-blue-grey}) 96%, transparent) 42%,\n      color-mix(in srgb, var(--assignment-view-section-c2, #{$dark-blue-grey}) 72%, transparent) 52%,\n      color-mix(in srgb, var(--assignment-view-section-c1, #{$dark-blue-grey}) 28%, transparent) 66%,\n      transparent 78%\n    );\n    pointer-events: none;\n  }\n}\n\n@mixin factions-reputations-thin-scrollbar {\n  margin-right: 0px;\n  padding-right: 2px;\n  scrollbar-width: thin;\n  scrollbar-color: rgba($accent-blue, 0.35) rgba(0, 0, 0, 0.12);\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.12);\n    border-radius: 999px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba($accent-blue, 0.30);\n    border-radius: 999px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: rgba($accent-blue, 0.42);\n  }\n}\n\n@mixin org-members-mgmt-player-activity-thin-scrollbar {\n  margin-right: -10px;\n  padding-right: 10px;\n  scrollbar-width: thin;\n  scrollbar-color: rgba($accent-blue, 0.35) rgba(0, 0, 0, 0.12);\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.12);\n    border-radius: 999px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba($accent-blue, 0.3);\n    border-radius: 999px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: rgba($accent-blue, 0.42);\n  }\n}\n\n@mixin member-dashboard-thin-scrollbar {\n  margin-right: -10px;\n  padding-right: 10px;\n  scrollbar-width: thin;\n  scrollbar-color: rgba($accent-blue, 0.35) rgba(0, 0, 0, 0.12);\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.12);\n    border-radius: 999px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba($accent-blue, 0.30);\n    border-radius: 999px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: rgba($accent-blue, 0.42);\n  }\n}\n\n@mixin member-dashboard-card-shell {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n@mixin personal-hub-blueprint-thin-scrollbar {\n  scrollbar-width: thin;\n  scrollbar-color: rgba($accent-blue, 0.45) rgba($dark-blue-grey, 0.35);\n\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba($dark-blue-grey, 0.35);\n    border-radius: 999px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba($accent-blue, 0.45);\n    border-radius: 999px;\n  }\n}\n\n$personal-hub-blueprint-panel-height: calc(100vh - 395px);\n\n@mixin add-picture-svg-paths {\n  path {\n    width: 24px;\n    fill: $grey;\n    stroke: $light-grey;\n\n    &:hover {\n      fill: $light-grey;\n      stroke: $dark-red;\n    }\n  }\n\n  path:first-child {\n    opacity: 0.8;\n  }\n}\n\n// Mix-ins\n@mixin flex-center {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n@mixin roster-sci-fi-hatch-bar {\n  background: repeating-linear-gradient(\n    -52deg,\n    rgba($accent-blue, 0.24) 0,\n    rgba($accent-blue, 0.24) 3px,\n    transparent 3px,\n    transparent 10px\n  );\n  mask-image: linear-gradient(\n    90deg,\n    transparent 0%,\n    rgba(0, 0, 0, 0.92) 14%,\n    rgba(0, 0, 0, 0.92) 86%,\n    transparent 100%\n  );\n}\n\n@mixin roster-sci-fi-edge-glow {\n  background: linear-gradient(\n    90deg,\n    transparent 0%,\n    rgba($accent-blue, 0.55) 50%,\n    transparent 100%\n  );\n}\n\n\n@mixin lexical-link-anchor-states($color, $hover-color) {\n  a {\n    color: $color;\n    text-decoration: none;\n    cursor: pointer;\n  }\n\n  a:hover {\n    color: $hover-color;\n    text-decoration: underline;\n  }\n\n  a:visited {\n    color: #a746e4;\n  }\n\n  a:active,\n  a:focus {\n    color: white;\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(26, 115, 232, 0.5);\n  }\n}\n\n@mixin org-members-mgmt-general-thin-scrollbar {\n  margin-right: -10px;\n  padding-right: 10px;\n  scrollbar-width: thin;\n  scrollbar-color: rgba($accent-blue, 0.35) rgba(0, 0, 0, 0.12);\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.12);\n    border-radius: 999px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba($accent-blue, 0.3);\n    border-radius: 999px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: rgba($accent-blue, 0.42);\n  }\n}\n\n@mixin factions-reputations-progress-tone-modifiers {\n  @include factions-reputations-progress-tone-fill('default');\n\n  &--hostile {\n    @include factions-reputations-progress-tone-fill('hostile');\n  }\n\n  &--not-eligible {\n    @include factions-reputations-progress-tone-fill('not-eligible');\n  }\n\n  &--unselected {\n    @include factions-reputations-progress-tone-fill('unselected');\n  }\n\n  &--neutral {\n    @include factions-reputations-progress-tone-fill('neutral');\n  }\n\n  &--friendly {\n    @include factions-reputations-progress-tone-fill('friendly');\n  }\n\n  &--trusted {\n    @include factions-reputations-progress-tone-fill('trusted');\n  }\n\n  &--renown {\n    @include factions-reputations-progress-tone-fill('renown');\n  }\n\n  &--legendary {\n    @include factions-reputations-progress-tone-fill('legendary');\n  }\n}\n\n@mixin factions-reputations-level-chip-theme($tone: 'unselected') {\n  $scope-title: $pure-white;\n  $grade-label: rgba($pure-white, 0.88);\n  $border: rgba($medium-light-grey, 0.45);\n  $surface: linear-gradient(\n    145deg,\n    rgba($medium-grey, 0.94),\n    rgba($medium-light-grey, 0.82)\n  );\n\n  @if $tone == 'hostile' {\n    $border: rgba($bright-red, 0.58);\n    $surface: linear-gradient(145deg, rgba($very-dark-red, 0.96), rgba($dark-red, 0.9));\n  } @else if $tone == 'not-eligible' {\n    $border: rgba($medium-red, 0.58);\n    $surface: linear-gradient(145deg, rgba($dark-red, 0.94), rgba($medium-red, 0.88));\n  } @else if $tone == 'neutral' {\n    $border: rgba($light-orange, 0.62);\n    $surface: linear-gradient(145deg, rgba($orange, 0.9), rgba($light-orange, 0.84));\n    $scope-title: $pure-white;\n    $grade-label: rgba($very-light-grey, 0.95);\n  } @else if $tone == 'friendly' {\n    $border: rgba($light-green, 0.62);\n    $surface: linear-gradient(145deg, rgba($green, 0.88), rgba($factions-reputations-tone-friendly, 0.92));\n    $scope-title: $very-dark-grey;\n    $grade-label: rgba($dark-blue-grey, 0.92);\n  } @else if $tone == 'trusted' {\n    $border: rgba($factions-reputations-tone-trusted, 0.62);\n    $surface: linear-gradient(145deg, rgba($dark-green, 0.92), rgba($factions-reputations-tone-trusted, 0.86));\n  } @else if $tone == 'renown' {\n    $border: rgba($factions-reputations-tone-renown, 0.62);\n    $surface: linear-gradient(145deg, rgba($dark-purple, 0.92), rgba($factions-reputations-tone-renown, 0.86));\n  } @else if $tone == 'legendary' {\n    $border: rgba($factions-reputations-tone-legendary, 0.65);\n    $surface: linear-gradient(145deg, rgba($very-dark-purple, 0.94), rgba($factions-reputations-tone-legendary, 0.88));\n  }\n\n  border-color: $border;\n  background: $surface;\n\n  .factions-reputations-faction-detail__level-scope-title {\n    color: $scope-title;\n  }\n\n  .factions-reputations-faction-detail__level-grade-label {\n    color: $grade-label;\n  }\n\n  .factions-reputations-faction-detail__level-icon--empty {\n    border-color: rgba($scope-title, 0.35);\n    background: rgba($scope-title, 0.12);\n  }\n}\n\n\n// ******************* //\n// to be unified later //\n// ******************* //\n\n\n$sc-item-bg: #0B1016; // Background (tooltip)\n$sc-item-surface: #121A22; // Surface principale\n$sc-item-surface-hover: #1A2430; // Surface hover / blocs internes\n$sc-item-border: #26303C; // Bordures / séparateurs\n$sc-item-accent-primary: #6A4CFF; // Accent principal \n$sc-item-accent-secondary: #9D7BFF; // Accent secondaire \n$sc-item-text-primary: #E2E8F0; // Texte principal\n$sc-item-text-secondary: #A3B1C6; // Texte secondaire\n$sc-item-text-muted: #6B7684; // Texte muted\n$sc-item-highlight: #1A2430; // Highlight spécifique \n$sc-item-accent-glow: rgba(106, 76, 255, 0.25); // Glow léger (optionnel)\n\n// Screen resolution\n\n$desktop: 1350px;\n$full-width: 1460px;\n$partial-width: 1250px;\n$tablet: 1023px;\n\n\n\n@mixin width {\n  width: 100%;\n  max-width: $desktop;\n}\n\n\n$scrollbar-width: 6px;\n$scrollbar-track-color: #2e3842;\n$scrollbar-thumb-color: $dark-red;\n\n// Roster table — aligné sur les tons panel / header bleu acier\n$roster-scrollbar-track-color: #1a2833;\n$roster-scrollbar-thumb-color: #3a6d8c;\n\n@mixin steel-bg($img-url) {\n  background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(#{$img-url});\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n@mixin steel-bg-transparent($img-url, $from, $to) {\n  background:\n    radial-gradient(circle at center, $from 0%, $to 100%),\n    url(#{$img-url});\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n@mixin steel-bg-blue($img-url) {\n  background:\n    radial-gradient(circle at center, #0c2c5096 0%, #052b4bf5 100%),\n    url(#{$img-url});\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n@mixin modal-header-silver($img-url){\n  display: flex;\n  justify-content: space-between;\n  color: $very-light-grey;\n  text-transform: uppercase;\n  font-weight: bold;\n  align-items: center;\n  padding: 5px 10px;\n  border-bottom: 3px solid $light-grey;\n  border-radius: 8px 8px 0px 0px;\n  background-image: linear-gradient(to top, #304a637e, #131e29c4, #304a637e), url(#{$img-url});\n}\n\n@mixin modal-header($img-url){\n  display: flex;\n  justify-content: space-between;\n  color: $very-light-grey;\n  text-transform: uppercase;\n  font-weight: bold;\n  align-items: center;\n  padding: 5px 10px;\n  border-bottom: 2px solid $grey;\n  border-radius: 8px 8px 0px 0px;\n  background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(#{$img-url});\n}\n\n@mixin calendar-modal-header-with-close() {\n  @include modal-header(\"../medias/steel.png\");\n\n  .calendar-event-h3 {\n    margin: 0;\n    font-size: small;\n  }\n\n  .icon {\n    display: flex;\n    height: 18px;\n    overflow: hidden;\n    margin-left: auto;\n    margin-right: 0;\n\n    .close-event-button {\n      position: relative;\n      height: 40px;\n      object-fit: contain;\n      overflow: hidden;\n      cursor: pointer;\n\n      &:hover {\n        top: -21px;\n      }\n    }\n  }\n}\n\n@mixin calendar-time-column-inner() {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  padding: 10px;\n  box-sizing: border-box;\n\n  &:first-child {\n    min-width: 0;\n    flex-grow: 1;\n  }\n\n  &:last-child {\n    flex-basis: 350px;\n    flex-shrink: 0;\n  }\n\n  .calendar-icon {\n    width: auto;\n    height: 15px;\n    margin-right: 10px;\n    vertical-align: middle;\n  }\n\n  .recurrence-item {\n    display: flex;\n    align-items: flex-start;\n\n    .calendar-icon {\n      width: auto;\n      height: 15px;\n      margin-right: 10px;\n    }\n\n    p {\n      margin: 0;\n    }\n  }\n}\n\n// Page titles (shared heading styles for main layout)\n@mixin title-style {\n  text-align: center;\n  text-transform: uppercase;\n  margin-top: 35px;\n  margin-bottom: 30px;\n  color: $very-light-grey;\n}\n\n@mixin title-style3 {\n  text-align: left;\n  text-transform: uppercase;\n  margin-top: 35px;\n  margin-bottom: 30px;\n  color: $light-grey;\n}\n\n@mixin academy-mcq-accordion($img-url){\n  display: flex;\n  justify-content: space-between;\n  color: $very-light-grey;\n  text-transform: uppercase;\n  font-weight: bold;\n  align-items: center;\n  height: 27px;\n  padding: 5px 10px;\n  border-bottom: 3px solid $light-grey;\n  border-radius: 8px 8px 0px 0px;\n  background-image: linear-gradient(to top, #4b0505f5, #500c0c96, #4b0505f5), url(#{$img-url});\n}\n\n@mixin scrollbar-styles {\n    &::-webkit-scrollbar {\n        width: $scrollbar-width;\n    }\n\n    &::-webkit-scrollbar-track {\n        background: $scrollbar-track-color;\n        border-radius: 4px;\n        padding-right: 1px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background-color: $scrollbar-thumb-color;\n        border-radius: 4px;\n\n        &:hover {\n            background-color: darken($scrollbar-thumb-color, 10%);\n        }\n    }\n}\n\n@mixin scrollbar-horizontal-styles {\n  &::-webkit-scrollbar {\n      height: $scrollbar-width;\n  }\n\n  &::-webkit-scrollbar-track {\n      background: $scrollbar-track-color;\n      border-radius: 4px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n      background-color: $scrollbar-thumb-color;\n      border-radius: 4px;\n\n      &:hover {\n          background-color: darken($scrollbar-thumb-color, 10%);\n      }\n  }\n}\n\n@mixin sc-item-scrollbar-styles {\n  &::-webkit-scrollbar {\n      width: $scrollbar-width;\n  }\n\n  &::-webkit-scrollbar-track {\n      background: $scrollbar-track-color;\n      border-radius: 4px;\n      padding-right: 1px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n      background-color: $sc-item-accent-primary;\n      border-radius: 4px;\n\n      &:hover {\n          background-color: $sc-item-accent-secondary;\n      }\n  }\n}\n\n@mixin roster-scrollbar-styles {\n    &::-webkit-scrollbar {\n        width: $scrollbar-width;\n    }\n\n    &::-webkit-scrollbar-track {\n        background: $roster-scrollbar-track-color;\n        border-radius: 4px;\n        padding-right: 1px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background-color: $roster-scrollbar-thumb-color;\n        border-radius: 4px;\n\n        &:hover {\n            background-color: lighten($roster-scrollbar-thumb-color, 10%);\n        }\n    }\n\n    scrollbar-width: thin;\n    scrollbar-color: $roster-scrollbar-thumb-color $roster-scrollbar-track-color;\n}\n\n@mixin scroll-hidden {\n    overflow-y: auto;\n\n    /* Chrome, Edge, Safari */\n    &::-webkit-scrollbar {\n        width: 0;\n        height: 0;\n    }\n\n    /* Firefox */\n    scrollbar-width: none;\n\n    /* IE / old Edge */\n    -ms-overflow-style: none;\n}\n\n@mixin scrollbar-glass {\n    &::-webkit-scrollbar {\n        width: $scrollbar-width;\n    }\n\n    &::-webkit-scrollbar-track {\n        background: $scrollbar-track-color;\n        border-radius: 4px;\n        padding-right: 1px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background-color: #355167;\n        border-radius: 4px;\n\n        &:hover {\n            background-color: darken(#355167, 10%);\n        }\n    }\n}\n\n@mixin dnd-handle {\n    // td dédié à la poignée\n    .cell-handle {\n      width: 30px;\n      padding: 0 6px;\n      text-align: center;\n      cursor: grab;      // main ouverte\n      user-select: none; // pas de sélection de texte\n      align-content: center;\n  \n      .drag-handle {\n        display: inline-block;\n        font-size: 1.2em;\n        line-height: 1;\n      }\n    }\n  \n    // pendant le drag le sensor ajoute data-sensor-context=\"active\"\n    tr[data-sensor-context=\"active\"] .cell-handle {\n      cursor: grabbing;        // main fermée\n    }\n  }\n\n// ---------------------------------------------------------------------------\n// Toggles — shared tokens (main.scss: .toggle-switch-field + legacy .toggle)\n// ---------------------------------------------------------------------------\n$toggle-switch-track-width: 30px;\n$toggle-switch-track-height: 13px;\n$toggle-switch-thumb-size: 11px;\n$toggle-switch-thumb-inset: 1px;\n$toggle-switch-thumb-travel: $toggle-switch-track-width - (2 * $toggle-switch-thumb-inset) - $toggle-switch-thumb-size;\n\n// Legacy `.toggle > input + .toggle-switch` (knob = &:before)\n$toggle-legacy-track-width: 35px;\n$toggle-legacy-thumb-size: 14px;\n$toggle-legacy-thumb-travel: 21px;\n\n// Site admin — orgs table compact toggle (inherits legacy :before knob)\n$toggle-orgs-table-track-width: 32px;\n$toggle-orgs-table-track-height: 8px;\n$toggle-orgs-table-thumb-size: 13px;\n$toggle-orgs-table-thumb-travel: 18px;\n$toggle-orgs-table-track-width-tight: 26px;\n$toggle-orgs-table-thumb-travel-tight: 14px;\n$toggle-orgs-table-thumb-size-tight: 12px;\n\n/** Label row + `.toggle-switch` alignment (objectives blocks, create/edit event). */\n@mixin toggle-row-objectives-style {\n  display: flex;\n  width: 100%;\n  height: auto;\n  bottom: 0;\n  transform: none;\n\n  .toggle-label {\n    flex: 1 1 auto;\n    margin-right: 10px;\n  }\n\n  .toggle-switch {\n    position: relative;\n    height: $toggle-switch-track-height;\n    left: auto;\n    right: auto;\n    //transform: translateY(5px);\n    margin-left: auto;\n  }\n}\n\n/** Benefits « Transaction completed » row — shared by bigCalendar + EventBenefitsModal layout. */\n@mixin toggle-benefits-payout-lock-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 10px;\n  width: auto;\n  min-width: 0;\n  max-width: 100%;\n  height: auto;\n  bottom: 0;\n  position: relative;\n  margin: 0;\n  text-transform: none;\n  font-size: 14px;\n  color: $very-light-grey;\n\n  .toggle-label {\n    position: static;\n    display: inline-flex;\n    align-items: center;\n    flex: 0 1 auto;\n    margin: 0;\n    width: auto;\n    font-weight: normal;\n    font-size: 0.85rem;\n  }\n\n  .toggle-switch {\n    position: relative;\n    top: auto;\n    left: auto;\n    right: auto;\n    bottom: auto;\n    margin: 0;\n    flex-shrink: 0;\n  }\n}\n\n\n\n","@import './variables.scss';\n\n// Shared glass surface (glass-card vs glass-card2)\n%glass-card-surface {\n  position: relative;\n  backdrop-filter: blur(6px) saturate(33%);\n  -webkit-backdrop-filter: blur(4px) saturate(33%);\n  background-color: #23497748;\n  border-radius: 10px;\n  border: 1px solid rgba(51, 102, 126, 0.329);\n  box-shadow: 3px 2px inset rgba(51, 102, 126, 0.229);\n}\n\n* { user-select: none; }\n\nbody.allow-text-selection,\nbody.allow-text-selection * {\n  user-select: text;\n}\n\nbody {\n  background-attachment: fixed;\n  margin: 0;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  min-height: calc(100vh - 15px); \n\n  // SCROLL BAR\n  &::-webkit-scrollbar {\n    width: 0px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: $very-light-grey;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $light-grey;\n    border-radius: 4px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: $red;\n  }\n}\n\n.display-none {\n  display: none;\n}\n\n/* Shared segmented sub-tabs (admin, calendar event, …) */\n.ui-subtabs {\n  display: inline-flex;\n  align-items: stretch;\n  gap: 0;\n  margin-top: 0.15rem;\n  padding: 3px;\n  border-radius: 999px;\n  background: rgba($very-dark-grey, 0.92);\n  border: 1px solid rgba($light-blue, 0.22);\n  max-width: 100%;\n\n  &--wrap {\n    flex-wrap: wrap;\n    gap: 0.3rem;\n    margin: 0.15rem 0 0.85rem;\n  }\n}\n\n.ui-subtabs__btn {\n  appearance: none;\n  border: 0;\n  margin: 0;\n  cursor: pointer;\n  background: transparent;\n  color: $light-grey;\n  font-family: inherit;\n  font-size: 0.82rem;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  line-height: 1.2;\n  padding: 0.45rem 0.95rem;\n  border-radius: 999px;\n  white-space: nowrap;\n  transition: color 0.15s ease, background-color 0.15s ease;\n\n  &:hover {\n    color: $very-light-grey;\n    background: rgba($panel-blue, 0.55);\n  }\n\n  &:focus-visible {\n    outline: 2px solid rgba($light-blue, 0.65);\n    outline-offset: 1px;\n  }\n}\n\n.ui-subtabs__btn--active {\n  color: $pure-white;\n  background: $accent-blue;\n\n  &:hover {\n    color: $pure-white;\n    background: $accent-blue;\n  }\n}\n\n.ui-subtabs__btn:disabled,\n.ui-subtabs__btn--disabled {\n  opacity: 0.42;\n  cursor: not-allowed;\n  color: $medium-grey;\n  background: transparent;\n\n  &:hover {\n    color: $medium-grey;\n    background: transparent;\n  }\n}\n\n.ui-subtabs__btn--active:disabled,\n.ui-subtabs__btn--active.ui-subtabs__btn--disabled {\n  opacity: 0.55;\n  color: rgba($pure-white, 0.7);\n  background: rgba($accent-blue, 0.45);\n\n  &:hover {\n    color: rgba($pure-white, 0.7);\n    background: rgba($accent-blue, 0.45);\n  }\n}\n\n/* Shared chips (admin + member profile card, etc.) */\n.chips-container {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  gap: 10px;\n  margin: 6px 0;\n}\n\n.chip {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 10px;\n  //margin-right: 8px;\n  font-weight: 500;\n  line-height: 1;\n  transition: background-color 0.2s ease;\n  font-size: medium;\n  padding: 4px 8px 4px 8px;\n\n  &.chip-group {\n    color: $light-grey;\n    border: 2px solid $orange;\n    background-color: transparent;\n\n    &:hover {\n      color: $very-light-grey;\n      background-color: $dark-orange;\n    }\n  }\n\n  &.chip-role {\n    color: $light-grey;\n    border: 2px solid $light-blue;\n    background-color: transparent;\n\n    &:hover {\n      color: $very-light-grey;\n      background-color: $dark-blue;\n    }\n  }\n\n  .chip-remove {\n    position: relative;\n    cursor: pointer;\n    font-weight: bold;\n    background: $dark-red;\n    color: $light-grey;\n    border: 1px solid $dark-red;\n    border-radius: 50%;\n    width: 15px;\n    height: 15px;\n    text-align: center;\n    align-content: center;\n    font-size: 14px;\n    margin: 0px 3px 0px 7px;\n    line-height: 1;\n    transition: color 0.2s ease;\n\n    &:hover {\n      color: white;\n    }\n  }\n}\n\n.warning-message {\n  display: flex;\n  color: $very-dark-grey;\n  background-color: rgb(255, 166, 0);\n  padding: 5px 28px;\n  margin: auto;\n  border-radius: 6px;\n}\n\n.root-error-boundary {\n  color: red;\n  padding: 20px;  \n}\n\n.maintenance-container {\n  text-align: center;\n  margin-top: 20%;\n\n  .maintenance {\n    position: relative;\n    display: inline-block;\n    padding: 20px 90px 20px 20px;\n    background-color: $very-dark-grey;\n    color: $light-grey;\n    text-decoration: none;\n    border: 4px solid $light-grey;\n    font-weight: bold;\n    font-size: 1.5em;\n    line-height: 1.4;\n    text-align: left;\n\n    &:before,\n    &:after {\n      content: \"\";\n      position: absolute;\n      z-index: -1;\n    }\n\n    &:before {\n      top: 10px;\n      left: 10px;\n      width: 100%;\n      height: 100%;\n      background-color: $dark-red;\n      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);\n    }\n\n    &:after {\n      bottom: 10px;\n      right: 11px;\n      width: 100%;\n      height: 100%;\n      background-color: $dark-red;\n      box-shadow: 0 -5px 10px rgba(0, 0, 0, 0.1);\n    }\n\n    .svg-container {\n      position: absolute;\n      top: 24px;\n      right: 10px;\n      width: 55px;\n      height: 52px;\n      background-color:  $light-grey;\n      border: 2px solid $dark-red;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      svg {\n        width: 40px;\n        height: 40px;\n      }\n    }\n  }\n}\n.emojis-images {\n  height: 20px;\n  width: auto;\n}\n\n.colorPicker-logo-container {\n  display: flex;\n  flex-direction: row;\n}\n\n.colorPicker-container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n\n  &.ribbons {\n    flex-direction: row;\n  }\n}\n\n.icon-container {\n  width: 65px; // Contrainte de la moitié de la hauteur de l'image\n  height: 30px; // Contrainte de la moitié de la hauteur de l'image\n  overflow: hidden;\n  position: relative;\n  margin-bottom: 27px; // Espace entre les icônes\n\n  .icon-image {\n    width: 100%;\n    height: 61px; // Hauteur complète de l'image\n    object-fit: contain; \n    position: relative;\n    top: 0;\n  }\n}\n\n.icon-rsi:hover .icon-image {\n  top: -30px; // Spécifique à l'icône RSI\n}\n\n.icon-discord:hover .icon-image,\n.icon-kofi:hover .icon-image {\n  top: -33px;\n}\n\n.glass-card {\n  @extend %glass-card-surface;\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    top: 5px; /* Adjust the top value to match your design */\n    bottom: 5px; /* Adjust the bottom value to match your design */\n    left: 7px;\n    right: 7px;\n    border-left: 3px solid $grey;\n    border-right: 3px solid $grey;\n    border-radius: 5px; /* Adjust the radius to match the inner corners */\n    pointer-events: none; /* Ensure the pseudo-element does not interfere with interactions */\n    z-index: 1; /* Ensure the pseudo-element is below the content */\n  }\n\n  .glass-card-content {\n    position: relative;\n    z-index: 2; /* Ensure the content is above the pseudo-element */\n  }\n}\n\n.glass-card2 {\n  @extend %glass-card-surface;\n}\n\n.content-container {\n  width: 100%;\n  position: relative;\n  \n  flex-grow: 1; \n  margin-top: 54px;\n  margin-left: auto;\n  margin-right: auto;\n\n  &.isLoggedIn {\n    margin-top: 45px;\n  }\n}\n\n.App {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.custom-h1,\n.custom-h2 {\n  @include title-style;\n}\n\n.custom-h3 {\n  @include title-style3;\n}\n\n.p {\n  font-size: 1rem;\n  color: $very-light-grey;\n}\n\np {\n  margin: 0;\n}\n\n.main-content {\n  padding-top: 70px;\n}\n\n.no-margin {\n  margin: 5px;\n}\n\n\n// CHECK-BOX — shared layout; checked colors differ below\n.myCheckbox,\n.discord-checkbox {\n  .form-check-input {\n    position: absolute;\n    opacity: 0;\n    z-index: -1;\n  }\n\n  .form-check-label::before {\n    content: \"\";\n    display: inline-block;\n    position: relative;\n    width: 1rem;\n    height: 1rem;\n    margin-right: 0.5rem;\n    border: 1px solid $very-dark-grey;\n    background: $very-light-grey;\n    vertical-align: middle;\n  }\n\n  .form-check-input:checked ~ .form-check-label::after {\n    content: \"\";\n    position: absolute;\n    width: 0.3rem;\n    height: 0.6rem;\n    border: solid $very-light-grey;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n    top: 0.2rem;\n    left: 0.35rem;\n  }\n}\n\n.myCheckbox .form-check-input:checked ~ .form-check-label::before {\n  background: $red;\n}\n\n.discord-checkbox .form-check-input:checked ~ .form-check-label::before {\n  background: #5865f2;\n  border-color: #5865f2;\n}\n\n\n.input-field {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px; /* Pour espacer les champs entre eux */\n  //margin-right: 10px; /* removed because of alignement in event-report */\n}\n\n.input-field p.home-file {\n  margin-right: 15px; /* Espace entre le label et le champ */\n  margin-left: 10px;\n  margin-top: 0px;\n  min-width: 110px; /* Largeur minimale pour les labels */\n  text-align: left; /* Alignement à droite du texte */\n}\n\n.input-field input,\n.input-field textarea {\n  flex: 1; /* Prend tout l'espace restant */\n}\n\n  \n.btn-style1 {\n  position: relative;\n  cursor: pointer;\n  font-size: 0.65em;\n  font-weight: 800;\n  text-transform: uppercase;\n  color: $dark-red;\n  padding: 0.4rem 0.8rem;\n  border-radius: 6px;\n  border: 1px solid $grey;\n\n  // keep original steel texture visible\n  background-image: url(\"../medias/steel.png\");\n  background-color: rgba(0, 51, 128, 0.18);\n  background-blend-mode: multiply;\n  background-size: auto;\n\n  box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.45);\n  transition: all 0.15s ease-in-out;\n\n  &:hover {\n    color: $red;\n    background-color: rgba(0, 51, 128, 0.08); // subtle change only\n    box-shadow: 0 0 6px 2px rgba(255, 0, 0, 0.2);\n  }\n\n  &:active {\n    transform: translateY(1px);\n    box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.6);\n  }\n\n  &[disabled] {\n    background-image: none;\n    background-color: #555;\n    color: gray;\n    box-shadow: none;\n    cursor: default;\n  }\n}\n\n\n\n.btn-style1.delete {\n  border: 2px solid $dark-red;\n\n  &:hover {\n    border: 2px solid $red;\n  }\n}\n.btn-style1.delete.red {\n  background-color: $dark-red;\n  color: $very-light-grey;\n  //width: 100px;\n  //margin: 15px auto 0px auto;\n  \n  &:hover {\n      background-color: $red;\n  }\n}\n\n.btn-style1.red {\n  background-color: $dark-red;\n  color: $very-light-grey;\n \n  &:hover {\n      background-color: $red;\n  }\n}\n\n.btn-style1.green {\n  background-color: $light-green;\n  color: $very-light-grey;\n \n  &:hover {\n      background-color: rgb(9, 163, 9);\n  }\n}\n\n.btn-style1.blue {\n  background-color: $blue-grey;\n  color: $very-light-grey;\n\n  &:hover {\n    background-color: lighten($blue-grey, 8%);\n    border: 1px solid $accent-blue;\n  }\n}\n\n\n.btn-style1.cancel {\n  &:hover {\n    border: 2px solid $grey;\n  }\n}\n\n.btn-style1.confirm {\n  &:hover {\n    border: 2px solid rgb(46, 89, 153);\n  }\n}\n\n.status-indicator {\n  width: 12px;  // Taille du cercle\n  height: 12px; // Taille du cercle\n  border-radius: 50%; // Rendre le div circulaire\n  display: inline-block;\n  margin-left: 5px;\n  margin-right: 10px;\n\n  &.active {\n    background-color: rgb(38, 187, 38); // Couleur pour actif\n  }\n\n  &.inactive {\n    background-color: $bright-red; // Couleur pour inactif\n  }\n}\n\n\n\n.button-group.admin.table {\n  // Active tab — same for ranks / templates / emojis / academy\n  .btn-style1.active {\n    background-color: #ffffff;\n    box-shadow: 0px 0px 5px 2px #465561ee;\n    color: $red;\n  }\n\n    &.ranks {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 15px;\n\n    .btn-style1 {    \n      margin: 0px; // Supprime les marges entre les boutons\n      height: 30px;\n\n    }\n\n    .first {\n      width: 134px;\n      border-radius: 6px 0 0 6px; // Arrondi seulement sur les coins extérieurs gauche\n    }\n\n    .middle {\n      width: 134px;\n      border-radius: 0; // Pas d'arrondi\n    }\n\n    .last {\n      border-radius: 0 6px 6px 0; // Arrondi seulement sur les coins extérieurs droit\n    }\n  }\n\n  &.templates {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 15px auto 16px auto;\n\n    .btn-style1 {    \n      margin: 0px; // Supprime les marges entre les boutons\n      height: 30px;\n      width: 120px;\n    }\n\n    .first {\n      border-radius: 6px 0 0 6px; // Arrondi seulement sur les coins extérieurs gauche\n    }\n\n    .middle {\n      border-radius: 0; // Pas d'arrondi\n    }\n\n    .last {\n      border-radius: 0 6px 6px 0; // Arrondi seulement sur les coins extérieurs droit\n    }\n  }\n\n  &.emojis {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 0px;\n\n    .btn-style1 {    \n      margin: 0;\n      height: 30px;\n      line-height: 1em;\n      min-width: 155px;\n    }\n\n    // 🥇 Première ligne : arrondis uniquement en haut, pas en bas\n    &.line1 {\n      .first {\n        border-radius: 6px 0 0 0;    // coin en haut‑gauche\n      }\n      .middle {\n        border-radius: 0;            // aucun arrondi\n      }\n      .last {\n        border-radius: 0 6px 0 0;    // coin en haut‑droit\n      }\n    }\n\n    // 🥈 Seconde ligne : arrondis uniquement en bas, pas en haut\n    &.line2 {\n      .first {\n        border-radius: 0 0 0 6px;    // coin en bas‑gauche\n      }\n      .middle {\n        border-radius: 0;            // aucun arrondi\n      }\n      .last {\n        border-radius: 0 0 6px 0;    // coin en bas‑droit\n      }\n    }\n  }\n\n  &.academy {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 15px;\n\n    .btn-style1 {    \n      margin: 0px; // Supprime les marges entre les boutons\n      height: 30px;\n\n    }\n\n    .first {\n      width: 150px;\n      border-radius: 6px 0 0 6px; // Arrondi seulement sur les coins extérieurs gauche\n    }\n\n    .middle {\n      width: 150px;\n      border-radius: 0; // Pas d'arrondi\n    }\n\n    .last {\n      width: 150px;\n      border-radius: 0 6px 6px 0; // Arrondi seulement sur les coins extérieurs droit\n    }\n  }\n\n}\n\n.select-default {\n  color: gray; /* Couleur différente pour la valeur par défaut */\n}\n\n\n.btn-style2 {\n  position: relative;\n  cursor: pointer;\n  //background-image : url(../medias/steel.png);\n  background-color: #164e89;\n  background-blend-mode: multiply; /* Utiliser le mode de mélange pour mélanger les couleurs */\n  font-size: 0.65em;\n  font-weight: 800;\n  text-transform: uppercase;\n  color: $very-light-grey;\n  height: max-content;\n  padding: 0.4rem 0.8rem 0.4rem 0.8rem;\n  vertical-align: top;\n  margin: 5px 10px 5px auto;\n  border: 1px solid $dark-red;\n  border-radius: 10px;\n  //box-shadow: 0px 0px 5px 2px #2f30315e;\n\n  &.left{\n    margin-left: 20px;\n    margin-right: 10px;\n  }\n\n  &:hover {\n    background-color:  #2769af;\n    color: white;\n    text-decoration: none;\n  }\n\n  &:active {\n    box-shadow: 0px 0px 5px 2px #2f3031ee;\n  }\n\n  &[disabled] {\n    cursor: default;\n    background-image: none;\n    background-color: rgb(88, 93, 102);\n    color: gray;\n    box-shadow: none;\n    \n    &:hover {\n        background-color: none;\n\n    }\n\n    &:active {\n        box-shadow: none;\n    }\n  }\n\n}\n\n\n//\n// Spacers\n\n.error-spacer {\n  height: 25px; // Approximativement la hauteur du message d'erreur\n  opacity: 0; // Cache l'espaceur mais il prend toujours de la place\n}\n.message-error {\n  margin-top: 5px;\n  color: $bright-red;\n  height: 20px; // Approximativement la hauteur du message d'erreur\n  opacity: 1; // Cache l'espaceur mais il prend toujours de la place\n}\n\n.margin-small-spacer {\n  margin-top : 3vh;\n}\n\n.margin-medium-spacer {\n  margin-top : 7vh;\n}\n\n.margin-large-spacer {\n  margin-top : 12vh;\n}\n\n.margin-top-spacer {\n  margin-top : 40px;\n}\n\n.margin-top-spacer-60 {\n  margin-top : 60px;\n}\n\n.margin-bottom-spacer {\n  margin-bottom : 40px;\n}\n\n.margin-bottom-spacer-60 {\n  margin-bottom : 60px;\n}\n\n// TOGGLE — dimensions use `$toggle-*` tokens in variables.scss; universal pill = `.toggle-switch-field` + `.toggle-switch`.\n\n.toggle {\n  display: block;\n  position: relative;\n  width: 50px;\n  height: 10px;\n  bottom: 4px;\n  color: $dark-red;\n  text-transform: uppercase;\n  font-weight: bolder;\n\n  input:not(.toggle-switch-field__input) {\n    display: none;\n  }\n\n  input.toggle-switch-field__input {\n    display: block;\n  }\n\n  .structure.division {\n    transform: translateX(0px) translateY(5px);\n  }\n\n  &.mfa {\n    bottom: 10px;\n  }\n\n  &.join-operation,\n  &.use-mumble {\n    // Make it behave like a clean inline toggle (no hardcoded translateX)\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    height: auto;\n    bottom: 0;\n    position: relative;\n    text-transform: none;\n    font-size: 14px;\n    color: $very-light-grey;\n    margin-bottom: 4px;\n    margin-top: 3px;\n    transform: translateX(0px) translateY(0px);\n\n    .toggle-label {\n      font-weight: normal;\n      font-size: 0.9rem;\n      display: flex;\n      width: auto;\n      margin-right: 10px;\n      flex: 1 1 auto;\n    }\n\n    .toggle-switch {\n      position: relative;\n      top: auto;\n      left: auto;\n      right: 20px;\n      bottom: auto;\n      margin-left: auto;\n    }\n  }\n\n  &.max-attendees-cap {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    width: 100%;\n    height: auto;\n    bottom: 0;\n    position: relative;\n    text-transform: none;\n    font-size: 14px;\n    color: $very-light-grey;\n    margin-bottom: 4px;\n    margin-top: 3px;\n    transform: translateX(0px) translateY(0px);\n\n    .toggle-switch {\n      position: relative;\n      top: auto;\n      left: auto;\n      right: 20px;\n      bottom: auto;\n      margin-left: auto;\n    }\n  }\n\n  &.tentative {\n    font-size: small;\n    text-transform: none;\n\n    .toggle-label {\n      position: relative;\n      margin-left: 50px;\n      top: 3px;\n    }\n\n    &.active {\n      //color: $very-light-grey;\n      color: #b8a500;\n    }\n\n    &.inactive {\n      color: $grey;\n    }\n  }\n\n  &.collaboration-toggle {\n    margin-left: 15px;\n  }\n\n\n  .toggle-label {\n    margin-right: 10px; // Espace entre le texte et le toggle-switch\n    font-size: small;\n  }\n}\n\n// Universal compact checkbox → pill switch (site-wide). Prefer this for new UI; migrate legacy `.toggle` gradually.\n// <label class=\"toggle-switch-field toggle-switch-field--on\"> … </label>\n// Inside: input.toggle-switch-field__input + span.toggle-switch > span.toggle-switch__thumb\n// (Standalone `.toggle-switch` is only the track; inside `.toggle`, older nested rules still apply.)\n.toggle-switch-field {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  user-select: none;\n  vertical-align: middle;\n}\n\n.toggle-switch-field--disabled {\n  cursor: not-allowed;\n  opacity: 0.45;\n  pointer-events: none;\n}\n\n.toggle-switch-field__input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n  opacity: 0;\n}\n\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  flex-shrink: 0;\n  width: $toggle-switch-track-width;\n  height: $toggle-switch-track-height;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  transition: background 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.toggle-switch__thumb {\n  position: absolute;\n  top: $toggle-switch-thumb-inset;\n  left: $toggle-switch-thumb-inset;\n  width: $toggle-switch-thumb-size;\n  height: $toggle-switch-thumb-size;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.92);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);\n  transition: transform 0.18s ease, background 0.18s ease;\n}\n\n.toggle-switch-field--on .toggle-switch,\n.toggle-switch-field__input:checked ~ .toggle-switch {\n  background: rgba(46, 204, 113, 0.28);\n  border-color: rgba(46, 204, 113, 0.45);\n  box-shadow: 0 0 0 1px rgba(46, 204, 113, 0.12);\n}\n\n.toggle-switch-field--on .toggle-switch__thumb,\n.toggle-switch-field__input:checked ~ .toggle-switch .toggle-switch__thumb {\n  transform: translateX($toggle-switch-thumb-travel);\n  background: #eefcf3;\n}\n\n.toggle-switch-field__input:focus-visible ~ .toggle-switch {\n  outline: 2px solid rgba($accent-blue, 0.85);\n  outline-offset: 2px;\n}\n\n.switch {\n  position: relative;\n  width: 50px;\n  height: 20px;\n\n  input {\n    display: none;\n  }\n\n  .slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-image: url(../medias/steel.png);\n    background-color: $light-grey;\n    background-blend-mode: multiply;\n    transition: .4s;\n    border-radius: 34px;\n\n    &:before {\n      position: absolute;\n      content: \"\";\n      height: 17px;\n      width: 17px;\n      left: 4px;\n      bottom: 2px;\n      background-image: url(../medias/steel.png);\n      transition: .4s;\n      border-radius: 50%;\n    }\n  }\n\n  input:checked + .slider {\n    background-color:rgba(116, 5, 5, 0.8) ; \n\n    &:before {\n      transform: translateX(26px);\n    }\n  }\n\n  input:focus + .slider {\n    box-shadow: 0 0 1px $dark-red;\n  }\n}\n\n\n// tooltips\n\n.tooltip,\n.tooltip1 {\n  width: fit-content;\n  z-index: 2000;\n  border: 1px solid $dark-red;\n  box-shadow: 0 2px 10px rgba(101, 121, 133, 0.123);\n}\n\n.tooltip {\n  color: $very-light-grey;\n  background-color: $dark-grey;\n  border-radius: 8px;\n  padding: 10px;\n}\n\n.tooltip1 {\n  color: $very-dark-grey;\n  font-weight: 700;\n  background-color: $light-grey;\n  border-radius: 6px;\n  padding: 3px 10px;\n}\n\n\n//icones (svg)\n\n.delete-media {\n  width: 24px;\n  fill: none; \n  stroke: $light-grey;\n  margin-right: 10px;\n  align-items: center;\n  transform: translate(-2px, 1px);\n\n  &:hover {\n      cursor: pointer; \n      stroke: $dark-red;\n      fill: $light-grey;\n  }\n}\n\n.structure-logo {\n  width: 28px;\n  transform: translate(140px, -10px);\n}\n\n.rank-logo {\n  width: 28px;\n  transform: translate(130px, -15px);\n}\n\n.allied-logo {\n  width: 28px;\n  transform: translate(-35px, 5px);\n}\n\n.add-picture-allied {\n  position: relative;\n  transform: translate(-35px, 5px);\n  @include add-picture-svg-paths;\n}\n\n\n// Insigna and logo size\n//\n.logo-size,\n.insigna-size {\n\n  &.extrasmall {\n    width: auto;\n    height: 21px;\n    padding-left: 4px;\n    padding-right: 4px;\n  }\n\n  &.small {\n    width: auto;\n    height: 28px;\n    padding-left: 7px;\n    padding-right: 7px;\n  }\n\n  &.medium {\n    width: auto;\n    height: 100px;\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n\n  &.large {\n    width: auto;\n    height: 170px;\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n\n  img {\n    width: 100%;\n    height: auto;\n    display: block;\n  }\n}\n\n.add-picture-structure {\n  position: relative;\n  transform: translate(140px, -10px);\n  @include add-picture-svg-paths;\n}\n\n.add-picture-rank {\n  position: relative;\n  transform: translate(135px, -15px);\n  @include add-picture-svg-paths;\n}\n\n.input:disabled:disabled {\n  cursor: default;\n  //background-color: $light-grey; // Couleur de fond pour les éléments désactivés\n  color: $dark-grey; // Couleur du texte pour les éléments désactivés\n  border-color: rgba(118, 118, 118, 0.3); // Couleur de la bordure pour les éléments désactivés\n}\n\n.input.parent.dropdown:disabled:disabled {\n  cursor: default;\n  background-color: $light-grey; // Couleur de fond pour les éléments désactivés\n  color: $dark-grey; // Couleur du texte pour les éléments désactivés\n  border-color: rgba(118, 118, 118, 0.3); // Couleur de la bordure pour les éléments désactivés\n}\n\n\n/* /src/styles/tools/syncfusion.scss */\n.emoji-picker-wrapper {\n  position: sticky;\n  top: 75px; /* Ajustez en fonction de la hauteur de la barre d'outils */\n  transform: translateX(-268px);\n  width: fit-content;\n  z-index: 100;\n\n  &.calendar {\n    position: fixed;\n  }\n}\n\n.emoji-picker-wrapper.hidden {\n  display: none;\n}\n\n.emoji-picker-wrapper.visible {\n  border-radius: 6px;\n  top: 190px;\n  transform: translateX(-250px);\n  display: block;\n}\n\n\n.emoji-picker-container {\n  position: relative;\n  border-radius: 6px;\n  top: 25px;\n  width: 200px;\n  height: 600px;\n  display: flex;\n  flex-direction: column; // Organiser les éléments en colonne\n  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);\n  background-color: #3d4955; // Ajout d'une couleur de fond si nécessaire\n  z-index: 1050;\n\n  .tabs {\n    padding: 5px;\n    background-color: $dark-grey;\n    width: 190px;\n    height: 110px; // Hauteur fixe pour les onglets\n    border-bottom: 1px solid $light-grey;\n    border-radius: 6px 6px 0px 0px;\n\n    .emojis-category {\n      margin: 10px 4px 0px 4px;\n      width: 30px;\n      color: $light-grey;\n      background-color: transparent;\n      border-color: transparent;\n      z-index: 1000;\n\n      &:hover {\n        color: #ffffff;\n      }\n    }\n\n    .emoji-searchBox {\n      width: calc(100% - 30px);\n      height: 22px;\n    }\n  }\n\n  .emojis {\n    padding: 13px;\n    overflow-y: auto; // Activer le défilement vertical\n    flex-grow: 1; // Prendre tout l'espace restant dans le conteneur\n    border-radius: 0px 0px 0px 6px;\n\n    // Styles pour la scrollbar\n    &::-webkit-scrollbar {\n      width: 8px; // Largeur de la scrollbar\n    }\n\n    &::-webkit-scrollbar-track {\n      background: #2e3842; // Couleur du chemin de la scrollbar\n      border-radius: 4px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background-color: $dark-red; // Couleur du curseur de la scrollbar\n      border-radius: 4px;\n      &:hover {\n        background-color: darken($dark-red, 10%); // Assombrir lors du survol\n      }\n    }\n\n    .emoji-img {\n      width: 22px;\n      margin: 5px;\n      cursor: pointer;\n    }\n\n    hr {\n      border-color: $dark-grey;\n    }\n  }\n}\n\n.line {\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n}\n\n.limited {\n  max-height: 45px;\n  overflow: hidden;\n  @include scrollbar-styles;\n}\n\n.flagged {\n  border: 1px solid $bright-red !important;\n  background-color: rgba($dark-red, 0.22) !important;\n  color: $pure-white !important;\n}\n\n// HOLD TO CONFIRM BUTTON\n.hold-confirm-btn {\n  position: relative;\n  overflow: hidden;\n  user-select: none;\n  min-height: 36px;\n  padding: 0 16px;\n  border: 1px solid rgba($dark-red, 0.85);\n  border-radius: 6px;\n  color: $very-light-grey;\n  background: rgba($dark-red, 0.32);\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.hold-confirm-btn:hover:not(:disabled) {\n  border-color: rgba($bright-red, 1);\n  background: rgba($dark-red, 0.48);\n}\n\n.hold-confirm-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.hold-confirm-btn__progress {\n  position: absolute;\n  inset: 0 auto 0 0;\n  width: 0;\n  pointer-events: none;\n  background: rgba($medium-red, 0.85);\n}\n\n.hold-confirm-btn__label {\n  position: relative;\n  z-index: 1;\n  color: inherit;\n}\n\n.hold-confirm-btn.is-holding .hold-confirm-btn__progress {\n  animation: holdConfirmProgress var(--hold-confirm-ms, 5s) linear forwards;\n}\n\n.hold-confirm-btn:not(.is-holding) .hold-confirm-btn__progress {\n  animation: none;\n  width: 0;\n}\n\n@keyframes holdConfirmProgress {\n  from {\n    width: 0;\n  }\n\n  to {\n    width: 100%;\n  }\n}\n\n\n@media (max-width: $tablet) {\n\n  %btn-style1 {\n    display: flex;\n    position: relative;\n    padding: 5px 10px 5px 10px;\n    background-color: $very-dark-grey;\n    color: $very-light-grey;\n    border-radius: 6px;\n    border: 1px solid $red;\n    text-align: center;\n    margin-left: auto;\n    margin-right: auto;\n    border-left: 0;\n    border-right: 0;\n    align-items: center;\n    cursor: pointer;\n    text-decoration: none;\n    margin-top: 0px;\n\n    &:hover,\n    &:focus {\n      background-color: $very-dark-grey;\n      color: $very-light-grey;\n      text-decoration: none;\n      text-shadow: 0px 0px 1px $very-light-grey;\n    }\n    &::before {\n      content: \"\";\n      position: absolute;\n      left: 10px;\n      top: 50%;\n      transform: translateY(-50%);\n      transition: all 0.3s ease;\n      z-index: 10;\n    }\n\n      &:hover::before {\n        color: $red;\n        transform: translateY(-50%) translateX(4px);\n      }\n\n  }\n\n  .content-container {\n    transform: translate(0, 27px);\n  }\n\n  .message-error {\n    display: flex;\n    position: relative;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 5px;\n    color: $bright-red;\n    height: 20px; // Approximativement la hauteur du message d'erreur\n    opacity: 1; // Cache l'espaceur mais il prend toujours de la place\n  }\n}\n","// src/styles/cookie.scss\n\n@import './variables.scss';\n\n.cookie-banner {\n    position: sticky;\n    top: 0;\n    width: 100%;\n    background-color: green; // Green background\n    color: black;\n    padding: 5px 0;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 10;\n  }\n  \n  .cookie-message {\n    margin: 0 5px 0 0;\n    display: inline;\n    color: black;\n    font-size: 14px;\n  }\n  \n  .cookie-link {\n    color: black;\n    text-decoration: underline;\n    background-color: transparent;\n    border: none;\n    margin-left: -2px;\n    margin-right: -4px;\n    cursor: pointer;\n\n    &:hover {\n        color: $dark-red;\n    }\n  }\n  \n  .cookie-button {\n    margin-left: 5px;\n    padding: 5px 10px;\n    background-color: white;\n    border: none;\n    color: black;\n    cursor: pointer;\n  }\n  \n  .cookie.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.8);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n  }\n  \n  .cookie.modal-content {\n    background-color: $very-dark-grey;\n    padding: 20px;\n    border-radius: 5px;\n    width: 80%;\n    height: 50vh;\n    max-width: 900px;\n    text-align: left;\n    overflow-y: auto; \n    @include scrollbar-styles;\n\n\n    @media (max-width: $tablet) {\n        height: 82vh; // Hauteur pour mobile et tablette en portrait\n        overflow-y: auto; \n        @include scrollbar-styles;\n    \n        @media (orientation: landscape) {\n          height: 72vh; // Hauteur pour mobile et tablette en paysage\n        }\n      }\n  }\n  \n  .close-button {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    font-size: 24px;\n    cursor: pointer;\n  }","@import './variables.scss';\n\n.background-hexagon-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: fixed; // Ensure the background is fixed\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -4; // Ensure it stays in the background\n  background: #293e55;\n}\n\n.center-gradient {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 2000px;\n  height: 100%;\n  //background: linear-gradient(to right,     transparent 0%,     #1b2833b7 15%,     #1b2833b7 85%,     transparent 100%);\n  background:  linear-gradient(to right, transparent 0%, #0b202da6 30%, #0b202da6 70%, transparent 100%);\n  z-index: -3; // Place it between the background and hexagons\n}\n\n.red-lightning {\n  position: absolute;\n  background: #e7191949;\n  z-index: -2;\n  transition: top 1.5s, left 1.5s, width 0.5s, height 0.5s;\n\n  &.horizontal {\n    width: 200px;\n    height: 26px;\n  }\n\n  &.vertical {\n    width: 26px;\n    height: 200px;\n  }\n}\n\n.background-hexagon-row {\n  display: flex;\n  background-color: transparent;\n\n  &.even {\n    margin-left: 50px; // Adjust to half the width of an hexagon for horizontal offset\n  }\n\n  &.odd {\n    margin-left: 0;\n    transform: translateY(-15px);\n  }\n}\n\n.background-hexagon {\n  background-color: $very-dark-grey;\n  margin: 1px; // Horizontal and vertical margins\n  width: 50px;\n  height: 57.5px;\n  clip-path: polygon(0% 25%, 0% 75%, 50% 100%, 100% 75%, 100% 25%, 50% 0%);\n  z-index: -2; // Ensure it stays above the gradient but below the main content\n}\n\n.background-hexagon-row.even .background-hexagon {\n  margin-top: -28.75px; // Adjust to create the vertical overlap for even rows\n}\n\n\n\n/* /utils/LaserHit.css */\n\n.laser-hit {\n  position: absolute;\n  width: 25px;\n  height: 25px;\n  border-radius: 50%;\n  background-color: transparent;\n  border: 10px solid #74adc4;\n  opacity: 1;\n  z-index: -2;\n  transform-origin: center;\n  animation: expandAndFade 0.8s forwards;\n}\n\n.fading {\n  opacity: 0;\n}\n\n@keyframes expandAndFade {\n  0% {\n    transform: scale(0.5);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(15);\n    opacity: 0;\n  }\n}\n\n@for $i from 0 through 100 {\n  .top-#{$i}p {\n    top: #{ $i + \"%\" };\n  }\n  .left-#{$i}p {\n    left: #{ $i + \"%\" };\n  }\n}\n\n\n\n/* Media query pour les écrans de taille inférieure ou égale à 600px */\n@media (max-width: $tablet) {\n  .laser-hit {\n    width: 10px; \n    height: 10px; \n    border: 4px solid #74adc4; \n  }\n\n  @keyframes expandAndFade {\n    0% {\n      transform: scale(0.5);\n      opacity: 1;\n    }\n    100% {\n      transform: scale(15); /* Agrandir jusqu'à atteindre environ 83.3px */\n      opacity: 0;\n    }\n  }\n}\n\n","@import './../variables.scss';\n\n.tree-wrapper.permissions {\n    margin: 10px 15px;\n    border: 1px solid $dark-red;\n    border-bottom: 4px solid $dark-red;\n    border-radius: 8px;\n    background-color: $very-dark-grey;\n    box-shadow: 4px 5px 2px #4b050547;\n\n  .tree-header {\n    display: flex;\n    padding: 6px 12px;\n    font-weight: bold;\n    font-size: small;\n    text-transform: uppercase;\n    color: $light-grey;\n    background: linear-gradient(to top, $dark-red, #5e2f2fd3, $dark-red ), url('../medias/steel.png');\n    border-bottom: 2px solid $grey;\n\n    .tree-item-column {\n        &.handle-column{\n            width: 25px;\n            \n        }\n\n        &.name-column {\n            width: 50%;\n            padding-left: 0px;\n        }\n\n        &.action-column {\n            width: 13%;\n            flex: 1;\n            //padding-left: 20px;           \n        }\n\n        &.route-column {\n            width: 13%;\n            flex: 1;\n            //padding-left: 20px;           \n        }\n        \n    }\n  }\n\n  .tree-body {\n    max-height: 30vh;\n    padding: 0px;\n    overflow: auto;\n    @include scrollbar-styles;\n\n    .sortable-tree-item {\n        position: relative;\n        display: flex;\n        min-height: 45px;\n        align-items: center;\n        cursor: grab;\n        transition: background-color 0.2s ease;\n\n        &.even-row {\n            background-color: $dark-grey; // Darker shade\n        }\n        &.odd-row {\n            background-color: $very-dark-grey; // Slightly lighter\n        }\n\n        &.dragging {\n            z-index: 50;\n            position: relative;\n            box-shadow: 0 0 8px rgba(0, 0, 0, 0.7);\n        }\n\n        &.disabled {\n            opacity: 0.4;\n            //pointer-events: none;\n        }\n\n      .tree-item-column {\n            display: flex;\n            align-items: center;\n\n        &.handle-column{\n            width: 20px;\n            padding: 0 10px;\n        }\n        &.name-column {\n            display: flex;\n            flex-direction: column;\n            font-size: small;\n            width: 49%;\n        }\n\n        &.action-column {\n            width: 8%;\n            flex: 1;\n            justify-content: center;\n\n             .permission-checkbox {\n                width: 20px;\n                height: 20px;\n                border-radius: 50%; // English: make it round\n                border: 1px solid $light-grey; // English: gray border when unchecked\n                appearance: none;\n                background-color: transparent;\n                cursor: pointer;\n                position: relative;\n\n                &:checked {\n                    background-color: $light-green; // English: red background when checked\n                    border-color: $dark-green;\n\n                    &::after {\n                    content: \"\";\n                    position: absolute;\n                    top: 3px;\n                    left: 6px;\n                    width: 4px;\n                    height: 8px;\n                    border: solid $very-light-grey;\n                    border-width: 0 2px 2px 0;\n                    transform: rotate(45deg);\n                    }\n                }\n            }\n\n        }\n\n        .tree-item-name {\n            font-weight: bold;\n            color: $very-light-grey;\n            margin-right: auto;\n\n            &.depth-0 { margin-left: 0px; }\n            &.depth-1 { margin-left: 20px; }\n            &.depth-2 { margin-left: 40px; }\n            &.depth-3 { margin-left: 60px; }\n            &.depth-4 { margin-left: 80px; }\n            &.depth-5 { margin-left: 100px; }\n        }\n\n        .tree-item-desc {\n            color: $light-grey;\n            font-size: small;\n            margin-right: auto;\n        }\n      }\n\n      &.selected {\n            background-color: #3d4955c2;\n      }\n\n      &.drop-on-hover {\n            //outline: 2px dashed $grey;\n            z-index: 1;\n      }\n    }\n\n    .drop-between-zone {\n        height: 3px;\n        position: relative;\n        pointer-events: auto;\n        display: block;\n        z-index: 2;\n\n        &.drop-between-hover {\n            outline: 2px dashed $grey;\n\n            &::after {\n                content: \"\";\n                position: absolute;\n                top: 3px;\n                left: 0;\n                right: 0;\n                height: 2px;\n            }\n        }\n    }\n\n  }\n}\n\n.route-column {\n  width: 5%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .route-check {\n    width: 16px;\n    height: 16px;\n    mask: url('/src/medias/checked-square.svg') no-repeat center;\n    -webkit-mask: url('/src/medias/checked-square.svg')  no-repeat center;\n    mask-size: contain;\n    -webkit-mask-size: contain;\n    background-color: $grey;\n    display: inline-block;\n  }\n\n  .route-present {\n    background-color: $light-green;\n  }\n\n  .route-absent {\n    background-color: $grey;\n    opacity: 0.4;\n  }\n}\n","// Styles for RosterFile.jsx (member side panel)\n// Loaded before react-table.scss so shared @keyframes exist for roster table cells.\n\n@import './variables.scss';\n\n@keyframes roster-hidden-rf-flicker {\n  0%,\n  100% {\n    opacity: 0.86;\n    text-shadow:\n      0 0 3px rgba(120, 200, 255, 0.35),\n      1px 0 0 rgba(255, 60, 60, 0.2);\n  }\n\n  33% {\n    opacity: 1;\n    text-shadow:\n      0 0 6px rgba(180, 220, 255, 0.45),\n      -1px 0 0 rgba(60, 255, 200, 0.15);\n  }\n\n  66% {\n    opacity: 0.9;\n    text-shadow:\n      0 0 2px rgba(100, 160, 255, 0.3),\n      0.5px 0 0 rgba(255, 120, 80, 0.18);\n  }\n}\n\n@keyframes roster-hidden-rf-scan {\n  0% {\n    transform: translateY(-4px);\n    opacity: 0.35;\n  }\n\n  50% {\n    opacity: 0.55;\n  }\n\n  100% {\n    transform: translateY(4px);\n    opacity: 0.35;\n  }\n}\n\n@keyframes roster-hidden-rf-hlines-vibrate {\n  0%,\n  100% {\n    transform: translate(0, 0);\n  }\n\n  20% {\n    transform: translate(0.9px, -0.5px);\n  }\n\n  40% {\n    transform: translate(-0.7px, 0.6px);\n  }\n\n  60% {\n    transform: translate(0.5px, 0.4px);\n  }\n\n  80% {\n    transform: translate(-0.5px, -0.4px);\n  }\n}\n\n@keyframes roster-hidden-rf-hlines-drift {\n  0% {\n    background-position: 0 0, 0 0;\n  }\n\n  100% {\n    background-position: 0 9px, 3px 0;\n  }\n}\n\n@keyframes roster-redacted-rf-flicker {\n  0%,\n  100% {\n    opacity: 0.88;\n    text-shadow:\n      0 0 4px rgba($red, 0.55),\n      1px 0 0 rgba(255, 200, 160, 0.22);\n  }\n\n  33% {\n    opacity: 1;\n    text-shadow:\n      0 0 8px rgba($red, 0.65),\n      -1px 0 0 rgba(255, 120, 100, 0.35);\n  }\n\n  66% {\n    opacity: 0.92;\n    text-shadow:\n      0 0 3px rgba(255, 160, 140, 0.45),\n      0.5px 0 0 rgba($red, 0.4);\n  }\n}\n\n.roster-page-loading {\n  display: flex;\n  justify-content: center;\n  padding: 2.5rem 0;\n}\n\n.table-base.roster.roster--page-fetching {\n  .table-body-scroll {\n    opacity: 0.55;\n    pointer-events: none;\n  }\n\n  .roster-table-footer {\n    opacity: 0.55;\n    pointer-events: none;\n  }\n}\n\n.table-base.roster {\n  .roster-file .member-moniker.roster-moniker--hidden-interference,\n  .roster-file .member-moniker.roster-moniker--hidden-interference--red {\n    display: inline-block;\n    position: relative;\n    isolation: isolate;\n    min-width: 4.25rem;\n    padding: 0.1em 0.15em;\n    font-family: ui-monospace, 'Cascadia Mono', 'Segoe UI Mono', monospace;\n    font-size: 1.2rem;\n    letter-spacing: 0.12em;\n    text-transform: uppercase;\n    color: rgba(195, 208, 220, 0.82);\n    animation: roster-hidden-rf-flicker 0.18s steps(2, end) infinite;\n\n    .roster-moniker__hidden-label {\n      position: relative;\n      z-index: 3;\n    }\n\n    &::before {\n      content: '';\n      position: absolute;\n      inset: -5px -4px;\n      z-index: 0;\n      pointer-events: none;\n      border-radius: 1px;\n      opacity: 0.88;\n      background-image:\n        repeating-linear-gradient(\n          180deg,\n          rgba(0, 0, 0, 0) 0,\n          rgba(0, 0, 0, 0) 2px,\n          rgba(140, 210, 255, 0.42) 2px,\n          rgba(140, 210, 255, 0.42) 3px,\n          rgba(0, 0, 0, 0) 3px,\n          rgba(0, 0, 0, 0) 6px,\n          rgba(255, 255, 255, 0.12) 6px,\n          rgba(255, 255, 255, 0.12) 7px,\n          rgba(0, 0, 0, 0) 7px,\n          rgba(0, 0, 0, 0) 10px\n        ),\n        repeating-linear-gradient(\n          180deg,\n          rgba(0, 0, 0, 0) 0,\n          rgba(0, 0, 0, 0) 4px,\n          rgba(60, 100, 140, 0.35) 4px,\n          rgba(60, 100, 140, 0.35) 5px,\n          rgba(0, 0, 0, 0) 5px,\n          rgba(0, 0, 0, 0) 11px\n        );\n      background-size: 100% 10px, 100% 11px;\n      animation:\n        roster-hidden-rf-hlines-vibrate 0.11s steps(2, end) infinite,\n        roster-hidden-rf-hlines-drift 1.4s linear infinite;\n      mix-blend-mode: soft-light;\n    }\n\n    &::after {\n      content: '';\n      position: absolute;\n      inset: -4px -3px;\n      z-index: 1;\n      pointer-events: none;\n      background: repeating-linear-gradient(\n        180deg,\n        transparent 0,\n        transparent 1px,\n        rgba(0, 0, 0, 0.22) 1px,\n        rgba(0, 0, 0, 0.22) 2px\n      );\n      opacity: 0.62;\n      mix-blend-mode: multiply;\n      animation:\n        roster-hidden-rf-hlines-vibrate 0.14s steps(3, end) infinite reverse,\n        roster-hidden-rf-scan 2.2s linear infinite;\n    }\n\n    @media (prefers-reduced-motion: reduce) {\n      animation: none;\n\n      &::before,\n      &::after {\n        animation: none;\n        opacity: 0.45;\n      }\n    }\n  }\n\n  .roster-file .member-moniker.roster-moniker--hidden-interference--red {\n    color: rgba(lighten($red, 38%), 0.9);\n    animation: roster-redacted-rf-flicker 0.18s steps(2, end) infinite;\n\n    &::before {\n      opacity: 0.92;\n      background-image:\n        repeating-linear-gradient(\n          180deg,\n          rgba(0, 0, 0, 0) 0,\n          rgba(0, 0, 0, 0) 2px,\n          rgba($red, 0.48) 2px,\n          rgba($red, 0.48) 3px,\n          rgba(0, 0, 0, 0) 3px,\n          rgba(0, 0, 0, 0) 6px,\n          rgba(255, 200, 200, 0.14) 6px,\n          rgba(255, 200, 200, 0.14) 7px,\n          rgba(0, 0, 0, 0) 7px,\n          rgba(0, 0, 0, 0) 10px\n        ),\n        repeating-linear-gradient(\n          180deg,\n          rgba(0, 0, 0, 0) 0,\n          rgba(0, 0, 0, 0) 4px,\n          rgba(darken($red, 8%), 0.4) 4px,\n          rgba(darken($red, 8%), 0.4) 5px,\n          rgba(0, 0, 0, 0) 5px,\n          rgba(0, 0, 0, 0) 11px\n        );\n      mix-blend-mode: soft-light;\n    }\n\n    &::after {\n      background: repeating-linear-gradient(\n        180deg,\n        transparent 0,\n        transparent 1px,\n        rgba($red, 0.28) 1px,\n        rgba($red, 0.28) 2px\n      );\n      opacity: 0.68;\n      mix-blend-mode: multiply;\n    }\n\n    @media (prefers-reduced-motion: reduce) {\n      animation: none;\n\n      &::before,\n      &::after {\n        animation: none;\n        opacity: 0.5;\n      }\n    }\n  }\n\n  .roster-file {\n    position: absolute;\n    top: 3px;\n    right: 0;\n    width: 67%;\n    height: calc(100vh - 365px);\n    background: rgba(23, 39, 56, 0.8);\n    border-radius: 5px 10px 10px 5px;\n    backdrop-filter: blur(10px);\n    transform: translate3d(100%, 0, 0);\n    transition: transform 0.6s cubic-bezier(0.22, 1, 0.36, 1);\n    will-change: transform;\n    backface-visibility: hidden;\n    overflow: hidden;\n    color: $very-light-grey;\n\n    &.visible {\n      transform: translate3d(0, 0, 0);\n    }\n\n    .roster-file-header,\n    .roster-file-content {\n      opacity: 0;\n      transform: translateX(40px);\n    }\n\n    &.visible .roster-file-header,\n    &.visible .roster-file-content {\n      opacity: 1;\n      transform: translateX(0);\n    }\n\n    .roster-file-header {\n      position: relative;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: 0px 7px 0px 14px;\n      margin: 0px;\n      color: $very-light-grey;\n      text-transform: uppercase;\n      letter-spacing: 0.05em;\n      border-bottom: none;\n      height: 35px;\n      z-index: 30;\n      isolation: isolate;\n\n      // Recreate the clipped header shape via a background layer\n      &::before {\n        content: '';\n        position: absolute;\n        inset: 0;\n        clip-path: polygon(0% 0%, 100% 0%, 100% 70%, 35% 70%, 30% 100%, 0% 100%);\n        pointer-events: none;\n        z-index: -1;\n        @include steel-bg(\"../medias/steel.png\");\n      }\n\n      // Bottom rim: same shape, shifted down by 3px (shows as a border under the cut)\n      &::after {\n        content: '';\n        position: absolute;\n        inset: 0;\n        transform: translateY(5px);\n        clip-path: polygon(0% 0%, 100% 0%, 100% 70%, 35% 70%, 30% 100%, 0% 100%);\n        pointer-events: none;\n        z-index: -2;\n        background: $very-dark-red;\n        filter:\n          drop-shadow(0 2px 0 rgba(0, 0, 0, 0.65))\n          drop-shadow(0 0 10px rgba($accent-blue, 0.18));\n      }\n\n      h2 {\n        font-size: 0.8rem;\n        margin: 0;\n        color: $very-light-grey;\n      }\n\n      h2.roster-file-header-title {\n        display: flex;\n        align-items: flex-start;\n        gap: 8px;\n        flex: 1;\n        min-width: 0;\n        margin-right: 8px;\n      }\n\n      .roster-file-header-rank-icon {\n        flex-shrink: 0;\n        height: 30px;\n        width: 40px;\n        object-fit: contain;\n        // Relief for thin rank assets: rim light + depth + subtle cool halo on steel header\n        filter:\n          drop-shadow(0 -1px 0 rgba(255, 255, 255, 0.38))\n          drop-shadow(0 1px 0 rgba(0, 0, 0, 0.42))\n          drop-shadow(0 2px 4px rgba(0, 0, 0, 0.45))\n          drop-shadow(0 4px 10px rgba(0, 0, 0, 0.28))\n          drop-shadow(0 0 14px rgba($accent-blue, 0.22));\n        transform: translateZ(0);\n      }\n\n      .roster-file-header-avatar {\n        flex-shrink: 0;\n        width: 34px;\n        height: 34px;\n        border-radius: 10px;\n        object-fit: cover;\n        border: 1px solid rgba($accent-blue, 0.28);\n        background: rgba(0, 0, 0, 0.18);\n        filter:\n          drop-shadow(0 1px 0 rgba(0, 0, 0, 0.42))\n          drop-shadow(0 2px 6px rgba(0, 0, 0, 0.35))\n          drop-shadow(0 0 12px rgba($accent-blue, 0.18));\n        transform: translateZ(0);\n      }\n\n      .roster-file-header-avatar--empty {\n        display: inline-block;\n        opacity: 0.55;\n      }\n\n      .roster-file-header-text {\n        display: flex;\n        flex-direction: column;\n        min-width: 0;\n        gap: 1px;\n      }\n\n      .roster-file-header-rank-name {\n        font-size: 1rem;\n        font-weight: 700;\n        letter-spacing: 0.03em;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        max-width: 260px;\n      }\n\n      .roster-file-header-discord {\n        font-size: 1.05rem;\n        min-width: 0;\n        max-width: 260px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n\n      .close-btn {\n        position: relative;\n        background: none;\n        border: none;\n        color: $very-light-grey;\n        font-size: 0.7rem;\n        padding: 0 3px;\n        border-radius: 3px;\n        bottom: 7px;\n        flex-shrink: 0;\n        cursor: pointer;\n\n        &:hover {\n          color: $dark-blue-grey;\n          background-color: $very-light-grey;\n        }\n      }\n    }\n\n    .roster-file-content {\n      //height: calc(100vh - 380px);\n\n      p {\n        margin: 8px 0;\n        font-size: 0.95rem;\n      }\n    }\n  }\n}\n\n// Fallback / extra detail when .roster-file is used (e.g. typography, training cards)\n.roster-file {\n  position: fixed;\n  top: 0;\n  right: -460px;\n  width: 460px;\n  height: 100vh;\n  background: linear-gradient(160deg, $dark-blue-grey, $very-dark-grey 70%);\n  border-left: 1px solid rgba($accent-blue, 0.25);\n  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.55);\n  z-index: 60;\n  transition: right 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n\n  &.visible {\n    right: 0;\n  }\n\n  .roster-file-header {\n    min-height: 52px;\n    //background: #1a2d41d9;\n    padding: 18px 18px 30px 18px;\n    margin: -16px -14px 0 -14px;\n    color: #dfdfdf;\n    //clip-path: polygon(0% 0%, 100% 0%, 100% 70%, 43.3% 70%, 36% 100%, 0% 100%);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    h2 {\n      margin: 0;\n      font-size: 14px;\n      letter-spacing: 2px;\n      text-transform: uppercase;\n      color: #dfdfdf;\n    }\n\n    .close-btn {\n      background: rgba($accent-blue, 0.15);\n      border: 1px solid rgba($accent-blue, 0.4);\n      border-radius: 6px;\n      width: 28px;\n      height: 28px;\n      color: #dfdfdf;\n      font-size: 16px;\n      cursor: pointer;\n      transition: all 0.2s ease;\n\n      &:hover {\n        background: rgba($accent-blue, 0.3);\n        color: #fff;\n      }\n    }\n  }\n\n  .roster-file-content {\n    height: calc(100vh - 64px);\n    overflow: hidden;\n    padding: 22px;\n\n    h2.member-moniker {\n      margin: 0;\n      font-size: 26px;\n      font-weight: 600;\n      color: #fff;\n      letter-spacing: 0.5px;\n      text-shadow: 0 0 12px rgba($accent-blue, 0.35);\n    }\n\n    .member-handle {\n      font-size: 12px;\n      color: $light-grey;\n      margin-bottom: 10px;\n      opacity: 0.75;\n    }\n\n    .member-rank-line {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      margin-bottom: 18px;\n    }\n\n    .member-rank-icon {\n      max-height: 20px;\n      max-width: 40px;\n      object-fit: contain;\n    }\n\n    .member-rank-text {\n      font-size: 14px;\n      color: $very-light-grey;\n      font-weight: 500;\n    }\n\n    p {\n      margin: 4px 0;\n      font-size: 13px;\n      color: $very-light-grey;\n\n      strong {\n        color: $accent-blue;\n        font-weight: 500;\n      }\n    }\n\n    hr {\n      border: none;\n      border-top: 1px solid rgba($accent-blue, 0.3);\n      margin: 20px 0;\n    }\n\n    h3 {\n      font-size: 12px;\n      letter-spacing: 2px;\n      text-transform: uppercase;\n      margin: 18px 0 10px;\n      color: $light-blue;\n    }\n\n    .training-line {\n      position: relative;\n      display: flex;\n      gap: 10px;\n      align-items: flex-start;\n      background: linear-gradient(145deg, $panel-blue, $dark-panel-blue);\n      border: 1px solid rgba($accent-blue, 0.35);\n      border-radius: 10px;\n      padding: 12px 14px;\n      margin-bottom: 14px;\n      overflow: hidden;\n\n      .basic-icon {\n        flex-shrink: 0;\n        width: 22px;\n        height: 22px;\n        margin-top: 2px;\n        object-fit: contain;\n        opacity: 0.9;\n      }\n\n      .training-line__body {\n        flex: 1;\n        min-width: 0;\n      }\n\n      &::before {\n        content: '';\n        position: absolute;\n        inset: 0;\n        background: linear-gradient(120deg, transparent, rgba($accent-blue, 0.12), transparent);\n        opacity: 0;\n        transition: opacity 0.3s ease;\n      }\n\n      &:hover::before {\n        opacity: 1;\n      }\n\n      strong {\n        display: block;\n        font-size: 14px;\n        color: #fff;\n        margin-bottom: 4px;\n      }\n\n      .training-meta {\n        display: flex;\n        gap: 14px;\n        flex-wrap: wrap;\n        font-size: 11px;\n        color: $light-grey;\n      }\n    }\n  }\n}\n\n// ---------------------------------------------------------\n// RosterFile v2 (tabs + fixed top section)\n// ---------------------------------------------------------\n.roster-file-content.roster-file-content--new {\n  padding: 0;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.roster-file-top {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  flex: 0 0 auto;\n  background: $dark-panel-blue;\n}\n\n.roster-file-top__close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 6;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  border: 1px solid rgba($accent-blue, 0.42);\n  border-radius: 0;\n  background: rgba($dark-panel-blue, 0.82);\n  color: rgba($very-light-grey, 0.92);\n  font-size: 11px;\n  line-height: 1;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n\n  &:hover {\n    background: rgba($accent-blue, 0.28);\n    border-color: rgba($accent-blue, 0.62);\n    color: $pure-white;\n  }\n}\n\n.roster-file-summary-hero__customize {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 7;\n  margin: 0;\n  padding: 0.28rem 0.55rem;\n  border: 1px solid rgba($light-orange, 0.85);\n  border-radius: 5px 0;\n  background: linear-gradient(\n    145deg,\n    rgba($orange, 0.92) 0%,\n    rgba($dark-orange, 0.95) 100%\n  );\n  color: $very-light-orange;\n  font-size: 0.66rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  cursor: pointer;\n  opacity: 0;\n  pointer-events: none;\n  box-shadow:\n    0 0 0 1px rgba($very-dark-orange, 0.55),\n    0 0 12px rgba($light-orange, 0.35),\n    inset 0 1px 0 rgba($very-light-orange, 0.28);\n  text-shadow: 0 1px 1px rgba($very-dark-orange, 0.65);\n  transition:\n    opacity 0.16s ease,\n    background 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease,\n    box-shadow 0.15s ease;\n\n  &:hover,\n  &:focus-visible {\n    border-color: $very-light-orange;\n    background: linear-gradient(\n      145deg,\n      rgba($light-orange, 0.98) 0%,\n      rgba($orange, 0.95) 100%\n    );\n    color: $pure-white;\n    box-shadow:\n      0 0 0 1px rgba($orange, 0.45),\n      0 0 16px rgba($light-orange, 0.5),\n      inset 0 1px 0 rgba($very-light-orange, 0.4);\n  }\n}\n\n.roster-file-summary-hero:hover .roster-file-summary-hero__customize,\n.roster-file-summary-hero:focus-within .roster-file-summary-hero__customize {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.roster-profile-theme-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.25rem;\n  background: rgba($very-dark-grey, 0.7);\n}\n\n.roster-profile-theme-modal {\n  width: #{\"min(100%, 56rem)\"};\n  max-height: #{\"min(92vh, 48rem)\"};\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border-radius: 14px;\n  border: 1px solid rgba($accent-blue, 0.35);\n  background: $dark-panel-blue;\n  box-shadow: 0 20px 48px rgba($very-dark-grey, 0.5);\n}\n\n.roster-profile-theme-modal__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.85rem 1rem;\n  border-bottom: 1px solid rgba($very-light-grey, 0.12);\n}\n\n.roster-profile-theme-modal__title {\n  margin: 0;\n  font-size: 0.92rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: $very-light-grey;\n}\n\n.roster-profile-theme-modal__close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.7rem;\n  height: 1.7rem;\n  margin: 0;\n  padding: 0;\n  border: 1px solid rgba($accent-blue, 0.42);\n  background: rgba($very-dark-grey, 0.45);\n  color: rgba($very-light-grey, 0.92);\n  font-size: 0.85rem;\n  cursor: pointer;\n\n  &:hover,\n  &:focus-visible {\n    background: rgba($accent-blue, 0.28);\n    color: $pure-white;\n  }\n}\n\n.roster-profile-theme-modal__body {\n  overflow: auto;\n  padding: 1rem;\n}\n\n.roster-profile-theme-modal__card {\n  margin: 0;\n}\n\n$roster-hero-identity-width: 42%;\n$roster-hero-intel-width: 22%;\n$roster-hero-chamfer: 22px;\n$roster-hero-notch: 14px;\n$roster-hero-identity-clip: polygon(\n  0 #{$roster-hero-chamfer},\n  #{$roster-hero-chamfer} 0,\n  calc(100% - #{$roster-hero-chamfer}) 0,\n  100% 50%,\n  calc(100% - #{$roster-hero-chamfer}) 100%,\n  #{$roster-hero-chamfer} 100%,\n  0 calc(100% - #{$roster-hero-chamfer})\n);\n$roster-hero-intel-clip: polygon(\n  0 70%,\n  #{25px} 0,\n  100% 0,\n  100% calc(100% - #{$roster-hero-chamfer}),\n  calc(100% - #{$roster-hero-chamfer}) 100%,\n  #{0px} 100%\n);\n$roster-hero-org-clip: polygon(\n  #{$roster-hero-notch} 0,\n  calc(100% - #{$roster-hero-notch}) 0,\n  calc(100% - 6px) 100%,\n  6px 100%\n);\n\n.roster-file-summary-hero {\n  position: relative;\n  overflow: hidden;\n  border: 1px solid rgba($accent-blue, 0.35);\n  box-shadow:\n    inset 0 1px 0 rgba($pure-white, 0.1),\n    0 4px 14px rgba(0, 0, 0, 0.28);\n\n  // Identity zone — left panel\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: $roster-hero-identity-width;\n    height: 100%;\n    z-index: 1;\n    clip-path: $roster-hero-identity-clip;\n    background:\n      linear-gradient(\n        135deg,\n        transparent calc(50% - 0.5px),\n        rgba($accent-blue, 0.72) 50%,\n        transparent calc(50% + 0.5px)\n      ) 0 0 / #{$roster-hero-chamfer} #{$roster-hero-chamfer} no-repeat,\n      linear-gradient(\n        315deg,\n        transparent calc(50% - 0.5px),\n        rgba($accent-blue, 0.62) 50%,\n        transparent calc(50% + 0.5px)\n      ) 0 calc(100% - #{$roster-hero-chamfer}) / #{$roster-hero-chamfer} #{$roster-hero-chamfer} no-repeat,\n      linear-gradient(rgba($accent-blue, 0.72), rgba($accent-blue, 0.72)) #{$roster-hero-chamfer} 0 / 14px 1px no-repeat,\n      linear-gradient(rgba($accent-blue, 0.72), rgba($accent-blue, 0.72)) 0 #{$roster-hero-chamfer} / 1px 14px no-repeat,\n      linear-gradient(rgba($accent-blue, 0.62), rgba($accent-blue, 0.62)) 0 calc(100% - 1px) / 14px 1px no-repeat,\n      linear-gradient(rgba($accent-blue, 0.62), rgba($accent-blue, 0.62)) 0 calc(100% - 14px) / 1px 14px no-repeat,\n      linear-gradient(\n        90deg,\n        rgba($accent-blue, 0.82) 0,\n        rgba($accent-blue, 0.82) 7px,\n        transparent 7px,\n        transparent 10px,\n        rgba($accent-blue, 0.82) 10px,\n        rgba($accent-blue, 0.82) 17px,\n        transparent 17px,\n        transparent 20px,\n        rgba($accent-blue, 0.82) 20px,\n        rgba($accent-blue, 0.82) 27px,\n        transparent 27px\n      ) calc(100% - 50px) 22% / 30px 3px no-repeat,\n      linear-gradient(\n        90deg,\n        rgba($accent-blue, 0) 0%,\n        rgba($accent-blue, 0.45) 20%,\n        rgba($accent-blue, 0.72) 50%,\n        rgba($accent-blue, 0.45) 80%,\n        rgba($accent-blue, 0) 100%\n      ) 10px calc(100% - 21px) / calc(100% - 34px) 2px no-repeat,\n      linear-gradient(115deg, rgba($accent-blue, 0.28) 0%, rgba($accent-blue, 0.42) 50%, rgba($accent-blue, 0.22) 100%) 10px calc(100% - 10px) / 5px 9px no-repeat,\n      linear-gradient(115deg, rgba($accent-blue, 0.28) 0%, rgba($accent-blue, 0.42) 50%, rgba($accent-blue, 0.22) 100%) 19px calc(100% - 10px) / 5px 9px no-repeat,\n      linear-gradient(115deg, rgba($accent-blue, 0.28) 0%, rgba($accent-blue, 0.42) 50%, rgba($accent-blue, 0.22) 100%) 28px calc(100% - 10px) / 5px 9px no-repeat,\n      linear-gradient(115deg, rgba($accent-blue, 0.2) 0%, rgba($accent-blue, 0.34) 45%, rgba($accent-blue, 0.18) 100%) 38px calc(100% - 10px) / 30px 9px no-repeat,\n      linear-gradient(\n        135deg,\n        rgba($pure-white, 0.09) 0%,\n        rgba($pure-white, 0.02) 24%,\n        transparent 48%\n      ) 0 0 / 100% 100% no-repeat,\n      linear-gradient(\n        180deg,\n        rgba($accent-blue, 0.1) 0%,\n        transparent 16%,\n        transparent 84%,\n        rgba($accent-blue, 0.07) 100%\n      ) 0 0 / 100% 100% no-repeat,\n      rgba($dark-panel-blue, 0.48);\n    background-repeat: no-repeat;\n    box-shadow:\n      inset 0 0 0 1px rgba($accent-blue, 0.32),\n      inset 0 1px 0 rgba($pure-white, 0.12),\n      inset 1px 0 0 rgba($accent-blue, 0.22),\n      2px 0 14px rgba(0, 0, 0, 0.28);\n    pointer-events: none;\n  }\n\n  // Intel zone — right panel\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: $roster-hero-intel-width;\n    height: 100%;\n    z-index: 1;\n    clip-path: $roster-hero-intel-clip;\n    background:\n      linear-gradient(rgba($accent-blue, 0.55), rgba($accent-blue, 0.55)) calc(100% - 1px) 0 / 1px 12px no-repeat,\n      linear-gradient(rgba($accent-blue, 0.55), rgba($accent-blue, 0.55)) calc(100% - 12px) 0 / 12px 1px no-repeat,\n      linear-gradient(rgba($accent-blue, 0.55), rgba($accent-blue, 0.55)) 0 50% / 1px 12px no-repeat,\n      linear-gradient(\n        225deg,\n        rgba($pure-white, 0.07) 0%,\n        transparent 34%\n      ),\n      linear-gradient(\n        180deg,\n        rgba($accent-blue, 0.08) 0%,\n        transparent 18%,\n        transparent 82%,\n        rgba($accent-blue, 0.06) 100%\n      ),\n      rgba($dark-panel-blue, 0.42);\n    background-repeat: no-repeat;\n    box-shadow:\n      inset 0 0 0 1px rgba($accent-blue, 0.3),\n      inset 0 1px 0 rgba($pure-white, 0.1),\n      inset -1px 0 0 rgba($accent-blue, 0.22),\n      -2px 0 14px rgba(0, 0, 0, 0.28);\n    pointer-events: none;\n  }\n}\n\n.roster-file-summary-hero__intel {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: $roster-hero-intel-width;\n  height: 100%;\n  z-index: 2;\n  pointer-events: none;\n}\n\n.roster-file-identity {\n  position: relative;\n  height: -webkit-fill-available;\n  display: grid;\n  align-content: center;\n  gap: 8px;\n  min-width: 0;\n  padding: 14px 12px 12px 18px;\n  clip-path: $roster-hero-intel-clip;\n  box-shadow: inset 0 0 0 1px rgba($accent-blue, 0.35);\n  pointer-events: none;\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: -1px;\n    left: 183px;\n    width: $roster-hero-chamfer;\n    height: $roster-hero-chamfer;\n    border-top: 1px solid rgba($accent-blue, 0.72);\n    border-left: 1px solid rgba($accent-blue, 0.72);\n    box-shadow:\n      0 0 5px rgba($accent-blue, 0.35),\n      inset 1px 1px 0 rgba($pure-white, 0.1);\n    pointer-events: none;\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    width: $roster-hero-chamfer;\n    height: $roster-hero-chamfer;\n    clip-path: polygon(100% 0, 100% 100%, 0 100%);\n    border-right: 1px solid rgba($accent-blue, 0.72);\n    border-bottom: 1px solid rgba($accent-blue, 0.72);\n    background: linear-gradient(\n      -45deg,\n      transparent calc(50% - 0.5px),\n      rgba($accent-blue, 0.78) 50%,\n      transparent calc(50% + 0.5px)\n    );\n    box-shadow:\n      0 0 6px rgba($accent-blue, 0.38),\n      inset -1px -1px 0 rgba($pure-white, 0.08);\n    pointer-events: none;\n  }\n}\n\n.roster-file-summary-hero__banner {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  pointer-events: none;\n\n  &::before {\n    content: '';\n    position: absolute;\n    height: 12px;\n    inset: 0;\n    z-index: 1;\n    background: repeating-linear-gradient(\n      -52deg,\n      rgba($accent-blue, 0.24) 0,\n      rgba($dark-panel-blue, 0.24) 4px,\n      transparent 8px,\n      transparent 9px\n    );\n    mask-image: linear-gradient(90deg, transparent 0%, rgba(0, 0, 0, 0.92) 14%, rgba(0, 0, 0, 0.92) 86%, transparent 100%);\n    opacity: 0.9;\n  }\n}\n\n.roster-file-summary-hero__banner-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center right;\n  filter: saturate(0.9) brightness(0.68);\n}\n\n.roster-file-summary-hero__theme-media {\n  z-index: 1;\n}\n\n// Active donor: roster-only space nebula (independent from member-profile tooltip)\n.roster-file-summary-hero__donor-space {\n  position: absolute;\n  inset: 0;\n  // Above .roster-file-summary-hero__banner::before stripe (z-index: 1)\n  z-index: 2;\n  overflow: hidden;\n  isolation: isolate;\n  background-color: rgba($dark-panel-blue, 0.92);\n\n  // Media / overlay FX only — no legacy blue nebula + starfield pack\n  &--plain {\n    background-color: transparent;\n\n    &::before,\n    &::after {\n      content: none;\n      display: none;\n    }\n  }\n\n  // Dense nebula lobes (below overlay)\n  &::before {\n    content: \"\";\n    position: absolute;\n    inset: -12%;\n    z-index: 0;\n    pointer-events: none;\n    will-change: transform;\n    background-image:\n      radial-gradient(\n        ellipse 58% 28% at 22% 76%,\n        rgba($member-profile-donor-nebula, 0.72) 0%,\n        transparent 72%\n      ),\n      radial-gradient(\n        ellipse 54% 26% at 44% 54%,\n        rgba($accent-blue, 0.58) 0%,\n        transparent 74%\n      ),\n      radial-gradient(\n        ellipse 50% 24% at 66% 32%,\n        rgba($member-profile-donor-nebula, 0.68) 0%,\n        transparent 72%\n      ),\n      radial-gradient(\n        ellipse 34% 18% at 16% 82%,\n        rgba($light-blue, 0.5) 0%,\n        transparent 68%\n      ),\n      radial-gradient(\n        ellipse 32% 20% at 32% 64%,\n        rgba($light-blue, 0.58) 0%,\n        transparent 70%\n      ),\n      radial-gradient(\n        ellipse 36% 16% at 50% 46%,\n        rgba($member-profile-donor-glow, 0.42) 0%,\n        transparent 68%\n      ),\n      radial-gradient(\n        ellipse 30% 18% at 62% 38%,\n        rgba($accent-blue, 0.52) 0%,\n        transparent 70%\n      ),\n      radial-gradient(\n        ellipse 28% 14% at 78% 24%,\n        rgba($light-blue, 0.46) 0%,\n        transparent 68%\n      ),\n      radial-gradient(\n        ellipse 12% 8% at 30% 68%,\n        rgba($member-profile-donor-glow, 0.7) 0%,\n        transparent 72%\n      ),\n      radial-gradient(\n        ellipse 10% 7% at 48% 48%,\n        rgba($pure-white, 0.28) 0%,\n        transparent 70%\n      ),\n      radial-gradient(\n        ellipse 11% 7% at 60% 34%,\n        rgba($member-profile-donor-glow, 0.55) 0%,\n        transparent 72%\n      ),\n      radial-gradient(\n        ellipse 20% 24% at 40% 50%,\n        rgba($accent-blue, 0.36) 0%,\n        transparent 75%\n      ),\n      radial-gradient(\n        ellipse 18% 22% at 56% 58%,\n        rgba($member-profile-donor-nebula, 0.42) 0%,\n        transparent 78%\n      ),\n      radial-gradient(\n        ellipse 22% 14% at 72% 42%,\n        rgba($light-blue, 0.34) 0%,\n        transparent 75%\n      );\n  }\n\n  // Starfield: dense amas along the real BL→TR nebula spine + full-hero scatter.\n  // Spine ≈ (10%,78%) → (90%,22%). Sizes 1→1.5→rare 2px; white + bluish; varied intensity.\n  &::after {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    z-index: 1;\n    pointer-events: none;\n    background-image:\n      // —— Dense amas on nebula spine (BL→TR) ——\n      radial-gradient(1px 1px at 5% 80%, rgba($pure-white, 0.4), transparent),\n      radial-gradient(1px 1px at 7% 76%, rgba($pure-white, 0.55), transparent),\n      radial-gradient(1px 1px at 8% 82%, rgba($member-profile-donor-glow, 0.45), transparent),\n      radial-gradient(1.5px 1.5px at 10% 74%, rgba($pure-white, 0.85), transparent),\n      radial-gradient(1px 1px at 11% 79%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1px 1px at 13% 72%, rgba($light-blue, 0.5), transparent),\n      radial-gradient(1px 1px at 14% 77%, rgba($pure-white, 0.6), transparent),\n      radial-gradient(1px 1px at 16% 70%, rgba($pure-white, 0.4), transparent),\n      radial-gradient(2px 2px at 17% 75%, rgba($member-profile-donor-glow, 0.9), transparent),\n      radial-gradient(1px 1px at 18% 68%, rgba($pure-white, 0.5), transparent),\n      radial-gradient(1px 1px at 19% 78%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 21% 66%, rgba($accent-blue, 0.55), transparent),\n      radial-gradient(1.5px 1.5px at 22% 71%, rgba($pure-white, 0.85), transparent),\n      radial-gradient(1px 1px at 23% 64%, rgba($pure-white, 0.45), transparent),\n      radial-gradient(1px 1px at 25% 69%, rgba($pure-white, 0.7), transparent),\n      radial-gradient(1px 1px at 26% 74%, rgba($light-blue, 0.4), transparent),\n      radial-gradient(1px 1px at 27% 62%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1px 1px at 29% 67%, rgba($pure-white, 0.6), transparent),\n      radial-gradient(1.5px 1.5px at 30% 61%, rgba($member-profile-donor-glow, 0.8), transparent),\n      radial-gradient(1px 1px at 31% 72%, rgba($pure-white, 0.4), transparent),\n      radial-gradient(1px 1px at 32% 59%, rgba($pure-white, 0.55), transparent),\n      radial-gradient(1px 1px at 34% 65%, rgba($pure-white, 0.75), transparent),\n      radial-gradient(1px 1px at 35% 57%, rgba($light-blue, 0.5), transparent),\n      radial-gradient(1px 1px at 36% 63%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(2px 2px at 38% 56%, rgba($pure-white, 0.95), transparent),\n      radial-gradient(1px 1px at 39% 61%, rgba($member-profile-donor-glow, 0.5), transparent),\n      radial-gradient(1px 1px at 40% 53%, rgba($pure-white, 0.45), transparent),\n      radial-gradient(1px 1px at 41% 58%, rgba($pure-white, 0.7), transparent),\n      radial-gradient(1.5px 1.5px at 43% 52%, rgba($accent-blue, 0.8), transparent),\n      radial-gradient(1px 1px at 44% 57%, rgba($pure-white, 0.4), transparent),\n      radial-gradient(1px 1px at 45% 50%, rgba($pure-white, 0.6), transparent),\n      radial-gradient(1px 1px at 46% 55%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1px 1px at 47% 48%, rgba($light-blue, 0.55), transparent),\n      radial-gradient(1px 1px at 49% 53%, rgba($pure-white, 0.65), transparent),\n      radial-gradient(1.5px 1.5px at 50% 47%, rgba($pure-white, 0.9), transparent),\n      radial-gradient(1px 1px at 51% 52%, rgba($pure-white, 0.4), transparent),\n      radial-gradient(1px 1px at 52% 45%, rgba($member-profile-donor-glow, 0.6), transparent),\n      radial-gradient(1px 1px at 53% 50%, rgba($pure-white, 0.5), transparent),\n      radial-gradient(1px 1px at 55% 43%, rgba($pure-white, 0.75), transparent),\n      radial-gradient(2px 2px at 56% 48%, rgba($member-profile-donor-glow, 0.85), transparent),\n      radial-gradient(1px 1px at 57% 41%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1px 1px at 58% 46%, rgba($light-blue, 0.55), transparent),\n      radial-gradient(1px 1px at 59% 39%, rgba($pure-white, 0.5), transparent),\n      radial-gradient(1.5px 1.5px at 61% 44%, rgba($pure-white, 0.85), transparent),\n      radial-gradient(1px 1px at 62% 38%, rgba($pure-white, 0.4), transparent),\n      radial-gradient(1px 1px at 63% 42%, rgba($accent-blue, 0.55), transparent),\n      radial-gradient(1px 1px at 64% 36%, rgba($pure-white, 0.65), transparent),\n      radial-gradient(1px 1px at 66% 40%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1px 1px at 67% 34%, rgba($member-profile-donor-glow, 0.5), transparent),\n      radial-gradient(1.5px 1.5px at 68% 39%, rgba($light-blue, 0.8), transparent),\n      radial-gradient(1px 1px at 70% 32%, rgba($pure-white, 0.55), transparent),\n      radial-gradient(1px 1px at 71% 37%, rgba($pure-white, 0.4), transparent),\n      radial-gradient(1px 1px at 72% 30%, rgba($pure-white, 0.7), transparent),\n      radial-gradient(1px 1px at 73% 35%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(2px 2px at 75% 28%, rgba($pure-white, 0.9), transparent),\n      radial-gradient(1px 1px at 76% 33%, rgba($member-profile-donor-glow, 0.5), transparent),\n      radial-gradient(1px 1px at 77% 26%, rgba($pure-white, 0.45), transparent),\n      radial-gradient(1px 1px at 79% 31%, rgba($light-blue, 0.55), transparent),\n      radial-gradient(1.5px 1.5px at 80% 24%, rgba($accent-blue, 0.8), transparent),\n      radial-gradient(1px 1px at 81% 29%, rgba($pure-white, 0.4), transparent),\n      radial-gradient(1px 1px at 82% 22%, rgba($pure-white, 0.65), transparent),\n      radial-gradient(1px 1px at 84% 27%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1px 1px at 85% 20%, rgba($member-profile-donor-glow, 0.55), transparent),\n      radial-gradient(1px 1px at 86% 25%, rgba($pure-white, 0.5), transparent),\n      radial-gradient(1.5px 1.5px at 88% 19%, rgba($pure-white, 0.85), transparent),\n      radial-gradient(1px 1px at 89% 23%, rgba($pure-white, 0.4), transparent),\n      radial-gradient(1px 1px at 91% 17%, rgba($light-blue, 0.5), transparent),\n      radial-gradient(1px 1px at 92% 21%, rgba($pure-white, 0.6), transparent),\n      radial-gradient(1px 1px at 94% 15%, rgba($pure-white, 0.45), transparent),\n      radial-gradient(1px 1px at 96% 18%, rgba($accent-blue, 0.5), transparent),\n      // Extra spine fill (between existing points)\n      radial-gradient(1px 1px at 6% 78%, rgba($pure-white, 0.45), transparent),\n      radial-gradient(1px 1px at 9% 73%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1px 1px at 12% 76%, rgba($light-blue, 0.45), transparent),\n      radial-gradient(1px 1px at 15% 69%, rgba($pure-white, 0.5), transparent),\n      radial-gradient(1.5px 1.5px at 20% 73%, rgba($pure-white, 0.75), transparent),\n      radial-gradient(1px 1px at 24% 67%, rgba($member-profile-donor-glow, 0.45), transparent),\n      radial-gradient(1px 1px at 28% 70%, rgba($pure-white, 0.4), transparent),\n      radial-gradient(1px 1px at 33% 62%, rgba($pure-white, 0.55), transparent),\n      radial-gradient(1px 1px at 37% 58%, rgba($accent-blue, 0.45), transparent),\n      radial-gradient(1px 1px at 42% 55%, rgba($pure-white, 0.5), transparent),\n      radial-gradient(1.5px 1.5px at 48% 49%, rgba($light-blue, 0.7), transparent),\n      radial-gradient(1px 1px at 54% 46%, rgba($pure-white, 0.45), transparent),\n      radial-gradient(1px 1px at 60% 41%, rgba($pure-white, 0.55), transparent),\n      radial-gradient(1px 1px at 65% 37%, rgba($member-profile-donor-glow, 0.4), transparent),\n      radial-gradient(1px 1px at 69% 35%, rgba($pure-white, 0.5), transparent),\n      radial-gradient(1.5px 1.5px at 74% 29%, rgba($pure-white, 0.8), transparent),\n      radial-gradient(1px 1px at 78% 27%, rgba($light-blue, 0.45), transparent),\n      radial-gradient(1px 1px at 83% 23%, rgba($pure-white, 0.4), transparent),\n      radial-gradient(1px 1px at 87% 21%, rgba($pure-white, 0.55), transparent),\n      radial-gradient(1px 1px at 95% 16%, rgba($member-profile-donor-glow, 0.45), transparent),\n      // Soft dust hugging the spine (± small offset) — denser\n      radial-gradient(1px 1px at 6% 84%, rgba($pure-white, 0.22), transparent),\n      radial-gradient(1px 1px at 10% 70%, rgba($pure-white, 0.25), transparent),\n      radial-gradient(1px 1px at 12% 78%, rgba($pure-white, 0.22), transparent),\n      radial-gradient(1px 1px at 15% 81%, rgba($pure-white, 0.2), transparent),\n      radial-gradient(1px 1px at 18% 64%, rgba($pure-white, 0.25), transparent),\n      radial-gradient(1px 1px at 20% 72%, rgba($pure-white, 0.25), transparent),\n      radial-gradient(1px 1px at 22% 78%, rgba($pure-white, 0.2), transparent),\n      radial-gradient(1px 1px at 25% 63%, rgba($pure-white, 0.28), transparent),\n      radial-gradient(1px 1px at 28% 66%, rgba($pure-white, 0.2), transparent),\n      radial-gradient(1px 1px at 31% 56%, rgba($pure-white, 0.25), transparent),\n      radial-gradient(1px 1px at 34% 70%, rgba($pure-white, 0.22), transparent),\n      radial-gradient(1px 1px at 37% 59%, rgba($pure-white, 0.28), transparent),\n      radial-gradient(1px 1px at 40% 62%, rgba($pure-white, 0.2), transparent),\n      radial-gradient(1px 1px at 43% 48%, rgba($pure-white, 0.25), transparent),\n      radial-gradient(1px 1px at 46% 60%, rgba($pure-white, 0.22), transparent),\n      radial-gradient(1px 1px at 48% 51%, rgba($pure-white, 0.22), transparent),\n      radial-gradient(1px 1px at 51% 42%, rgba($pure-white, 0.25), transparent),\n      radial-gradient(1px 1px at 54% 45%, rgba($pure-white, 0.25), transparent),\n      radial-gradient(1px 1px at 57% 52%, rgba($pure-white, 0.2), transparent),\n      radial-gradient(1px 1px at 60% 36%, rgba($pure-white, 0.28), transparent),\n      radial-gradient(1px 1px at 63% 47%, rgba($pure-white, 0.22), transparent),\n      radial-gradient(1px 1px at 65% 38%, rgba($pure-white, 0.2), transparent),\n      radial-gradient(1px 1px at 68% 43%, rgba($pure-white, 0.25), transparent),\n      radial-gradient(1px 1px at 71% 27%, rgba($pure-white, 0.22), transparent),\n      radial-gradient(1px 1px at 74% 31%, rgba($pure-white, 0.28), transparent),\n      radial-gradient(1px 1px at 77% 36%, rgba($pure-white, 0.2), transparent),\n      radial-gradient(1px 1px at 80% 19%, rgba($pure-white, 0.25), transparent),\n      radial-gradient(1px 1px at 83% 25%, rgba($pure-white, 0.22), transparent),\n      radial-gradient(1px 1px at 86% 30%, rgba($pure-white, 0.2), transparent),\n      radial-gradient(1px 1px at 89% 14%, rgba($pure-white, 0.25), transparent),\n      radial-gradient(1px 1px at 93% 18%, rgba($pure-white, 0.25), transparent),\n      radial-gradient(1px 1px at 97% 22%, rgba($pure-white, 0.2), transparent),\n      // —— Full-hero scatter (sparser than spine, but denser overall) ——\n      radial-gradient(1px 1px at 2% 14%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1px 1px at 4% 22%, rgba($pure-white, 0.4), transparent),\n      radial-gradient(1px 1px at 5% 32%, rgba($light-blue, 0.35), transparent),\n      radial-gradient(1px 1px at 7% 10%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 9% 38%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1.5px 1.5px at 11% 20%, rgba($pure-white, 0.55), transparent),\n      radial-gradient(1px 1px at 13% 44%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1.5px 1.5px at 14% 28%, rgba($member-profile-donor-glow, 0.55), transparent),\n      radial-gradient(1px 1px at 16% 8%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1px 1px at 18% 42%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1px 1px at 21% 14%, rgba($accent-blue, 0.35), transparent),\n      radial-gradient(1px 1px at 24% 18%, rgba($light-blue, 0.4), transparent),\n      radial-gradient(1px 1px at 26% 30%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 29% 34%, rgba($pure-white, 0.45), transparent),\n      radial-gradient(1px 1px at 31% 12%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1px 1px at 33% 24%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 36% 8%, rgba($member-profile-donor-glow, 0.4), transparent),\n      radial-gradient(1px 1px at 39% 20%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1.5px 1.5px at 42% 16%, rgba($pure-white, 0.6), transparent),\n      radial-gradient(1px 1px at 45% 6%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 47% 28%, rgba($accent-blue, 0.4), transparent),\n      radial-gradient(1px 1px at 50% 18%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1px 1px at 53% 12%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1px 1px at 56% 8%, rgba($light-blue, 0.35), transparent),\n      radial-gradient(1px 1px at 58% 22%, rgba($pure-white, 0.4), transparent),\n      radial-gradient(1px 1px at 61% 6%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 64% 14%, rgba($light-blue, 0.35), transparent),\n      radial-gradient(1px 1px at 67% 10%, rgba($pure-white, 0.4), transparent),\n      radial-gradient(1.5px 1.5px at 69% 20%, rgba($member-profile-donor-glow, 0.5), transparent),\n      radial-gradient(1px 1px at 73% 6%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1px 1px at 76% 14%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 78% 10%, rgba($pure-white, 0.4), transparent),\n      radial-gradient(1px 1px at 82% 4%, rgba($accent-blue, 0.35), transparent),\n      radial-gradient(1px 1px at 85% 12%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 87% 8%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 91% 4%, rgba($light-blue, 0.35), transparent),\n      radial-gradient(1px 1px at 94% 10%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 98% 6%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1px 1px at 3% 46%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 6% 58%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1px 1px at 10% 52%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 15% 48%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 19% 56%, rgba($light-blue, 0.3), transparent),\n      radial-gradient(1px 1px at 23% 44%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1px 1px at 26% 42%, rgba($light-blue, 0.35), transparent),\n      radial-gradient(1px 1px at 30% 48%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 35% 38%, rgba($pure-white, 0.4), transparent),\n      radial-gradient(1px 1px at 40% 34%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 44% 32%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 49% 36%, rgba($member-profile-donor-glow, 0.35), transparent),\n      radial-gradient(1.5px 1.5px at 60% 58%, rgba($pure-white, 0.55), transparent),\n      radial-gradient(1px 1px at 63% 54%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 66% 64%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 70% 52%, rgba($member-profile-donor-glow, 0.4), transparent),\n      radial-gradient(1px 1px at 74% 58%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 77% 60%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1px 1px at 81% 48%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1px 1px at 85% 54%, rgba($light-blue, 0.3), transparent),\n      radial-gradient(1px 1px at 90% 42%, rgba($light-blue, 0.4), transparent),\n      radial-gradient(1px 1px at 93% 50%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 97% 56%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1px 1px at 2% 72%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 5% 86%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1px 1px at 8% 92%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1px 1px at 12% 84%, rgba($light-blue, 0.3), transparent),\n      radial-gradient(1px 1px at 16% 88%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 20% 94%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1.5px 1.5px at 25% 90%, rgba($accent-blue, 0.5), transparent),\n      radial-gradient(1px 1px at 28% 86%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 34% 84%, rgba($pure-white, 0.4), transparent),\n      radial-gradient(1px 1px at 38% 94%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 43% 92%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 48% 72%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 48% 88%, rgba($member-profile-donor-glow, 0.35), transparent),\n      radial-gradient(1px 1px at 52% 86%, rgba($light-blue, 0.35), transparent),\n      radial-gradient(1px 1px at 55% 68%, rgba($light-blue, 0.35), transparent),\n      radial-gradient(1px 1px at 55% 94%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 61% 90%, rgba($pure-white, 0.4), transparent),\n      radial-gradient(1px 1px at 65% 78%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 68% 92%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1.5px 1.5px at 72% 84%, rgba($member-profile-donor-glow, 0.55), transparent),\n      radial-gradient(1px 1px at 76% 76%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 79% 94%, rgba($light-blue, 0.3), transparent),\n      radial-gradient(1px 1px at 83% 88%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1px 1px at 88% 74%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 92% 80%, rgba($pure-white, 0.3), transparent),\n      radial-gradient(1px 1px at 96% 90%, rgba($accent-blue, 0.35), transparent);\n  }\n\n  .roster-file-summary-hero__banner-overlay {\n    z-index: 0;\n    background:\n      linear-gradient(\n        90deg,\n        rgba($dark-panel-blue, 0.55) 0%,\n        rgba($dark-panel-blue, 0.28) 36%,\n        rgba($dark-panel-blue, 0.12) 62%,\n        rgba($dark-panel-blue, 0.04) 100%\n      ),\n      linear-gradient(\n        180deg,\n        rgba($dark-panel-blue, 0.06) 0%,\n        rgba($dark-panel-blue, 0.28) 100%\n      );\n  }\n\n  // Shooting stars — roster-owned (tooltip keeps its own under --donor).\n  // Trail angle must equal travel direction: atan2(dy, dx). Starts span the full hero.\n  .member-profile-card-popover__shooting-star {\n    position: absolute;\n    top: var(--mp-star-top, 8%);\n    left: var(--mp-star-left, 10%);\n    z-index: 2;\n    width: 110px;\n    height: 2px;\n    border-radius: 1px;\n    pointer-events: none;\n    opacity: 0;\n    background: linear-gradient(\n      90deg,\n      transparent 0%,\n      rgba($member-profile-donor-glow, 0.7) 58%,\n      rgba($pure-white, 1) 100%\n    );\n    box-shadow: 0 0 10px rgba($pure-white, 0.55);\n    transform-origin: left center;\n    will-change: transform, opacity;\n\n    &.is-flying {\n      animation: roster-file-shooting-star var(--mp-star-duration, 0.65s) ease-out forwards;\n    }\n\n    // left third\n    &--t1 {\n      --mp-star-top: 4%;\n      --mp-star-left: 3%;\n      --mp-star-dx: 420px;\n      --mp-star-dy: 180px;\n      --mp-star-angle: 23deg;\n      --mp-star-duration: 0.68s;\n    }\n\n    &--t2 {\n      --mp-star-top: 20%;\n      --mp-star-left: 12%;\n      --mp-star-dx: 400px;\n      --mp-star-dy: 200px;\n      --mp-star-angle: 27deg;\n      --mp-star-duration: 0.72s;\n    }\n\n    // center\n    &--t3 {\n      --mp-star-top: 6%;\n      --mp-star-left: 34%;\n      --mp-star-dx: 360px;\n      --mp-star-dy: 190px;\n      --mp-star-angle: 28deg;\n      --mp-star-duration: 0.62s;\n    }\n\n    &--t4 {\n      --mp-star-top: 16%;\n      --mp-star-left: 46%;\n      --mp-star-dx: 340px;\n      --mp-star-dy: 170px;\n      --mp-star-angle: 27deg;\n      --mp-star-duration: 0.7s;\n    }\n\n    &--t5 {\n      --mp-star-top: 2%;\n      --mp-star-left: 52%;\n      --mp-star-dx: 320px;\n      --mp-star-dy: 210px;\n      --mp-star-angle: 33deg;\n      --mp-star-duration: 0.6s;\n    }\n\n    // right third\n    &--t6 {\n      --mp-star-top: 10%;\n      --mp-star-left: 62%;\n      --mp-star-dx: 280px;\n      --mp-star-dy: 180px;\n      --mp-star-angle: 33deg;\n      --mp-star-duration: 0.65s;\n    }\n\n    &--t7 {\n      --mp-star-top: 22%;\n      --mp-star-left: 70%;\n      --mp-star-dx: 250px;\n      --mp-star-dy: 160px;\n      --mp-star-angle: 33deg;\n      --mp-star-duration: 0.58s;\n    }\n\n    &--t8 {\n      --mp-star-top: 8%;\n      --mp-star-left: 78%;\n      --mp-star-dx: 220px;\n      --mp-star-dy: 150px;\n      --mp-star-angle: 34deg;\n      --mp-star-duration: 0.55s;\n    }\n  }\n\n  &--premium::before {\n    animation: roster-file-nebula-morph-a 28.8s ease-in-out infinite;\n  }\n\n  &--premium .roster-file-summary-hero__nebula-morph {\n    position: absolute;\n    inset: -14%;\n    z-index: 0;\n    pointer-events: none;\n    will-change: transform, opacity;\n    background-image:\n      radial-gradient(\n        ellipse 46% 30% at 28% 64%,\n        rgba($light-blue, 0.55) 0%,\n        transparent 70%\n      ),\n      radial-gradient(\n        ellipse 42% 24% at 56% 36%,\n        rgba($member-profile-donor-glow, 0.45) 0%,\n        transparent 72%\n      ),\n      radial-gradient(\n        ellipse 38% 28% at 70% 50%,\n        rgba($accent-blue, 0.48) 0%,\n        transparent 68%\n      ),\n      radial-gradient(\n        ellipse 34% 20% at 42% 26%,\n        rgba($member-profile-donor-nebula, 0.5) 0%,\n        transparent 74%\n      ),\n      radial-gradient(\n        ellipse 28% 34% at 18% 50%,\n        rgba($accent-blue, 0.36) 0%,\n        transparent 75%\n      ),\n      radial-gradient(\n        ellipse 24% 18% at 84% 20%,\n        rgba($light-blue, 0.42) 0%,\n        transparent 70%\n      );\n    animation: roster-file-nebula-morph-b 36.9s ease-in-out infinite;\n  }\n}\n\n@keyframes roster-file-shooting-star {\n  0% {\n    opacity: 0;\n    transform: translate(0, 0) rotate(var(--mp-star-angle, 38deg));\n  }\n\n  12% {\n    opacity: 1;\n  }\n\n  70% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n    transform: translate(var(--mp-star-dx, 140px), var(--mp-star-dy, 100px))\n      rotate(var(--mp-star-angle, 38deg));\n  }\n}\n\n@keyframes roster-file-nebula-morph-a {\n  0%,\n  100% {\n    transform: translate3d(0, 0, 0) scale(1, 1) skew(0deg, 0deg);\n  }\n\n  18% {\n    transform: translate3d(1.44%, -2.64%, 0) scale(1.084, 0.916) skew(1.32deg, -0.48deg);\n  }\n\n  36% {\n    transform: translate3d(-2.88%, -0.72%, 0) scale(0.916, 1.108) skew(-1.08deg, 0.84deg);\n  }\n\n  54% {\n    transform: translate3d(-0.96%, 3.12%, 0) scale(1.06, 0.928) skew(0.6deg, 1.08deg);\n  }\n\n  72% {\n    transform: translate3d(2.64%, 1.32%, 0) scale(0.94, 1.084) skew(-1.2deg, -0.6deg);\n  }\n\n  88% {\n    transform: translate3d(0.72%, -1.68%, 0) scale(1.036, 0.964) skew(0.48deg, 0.36deg);\n  }\n}\n\n@keyframes roster-file-nebula-morph-b {\n  0%,\n  100% {\n    transform: translate3d(0, 0, 0) scale(1.012, 0.988) skew(0deg, 0deg);\n    opacity: 0.28;\n  }\n\n  22% {\n    transform: translate3d(-3.36%, 2.16%, 0) scale(0.88, 1.144) skew(-1.44deg, 0.72deg);\n    opacity: 0.78;\n  }\n\n  44% {\n    transform: translate3d(2.88%, 3.36%, 0) scale(1.144, 0.856) skew(1.08deg, -0.96deg);\n    opacity: 0.4;\n  }\n\n  66% {\n    transform: translate3d(1.44%, -3.12%, 0) scale(0.928, 1.12) skew(-0.6deg, 1.2deg);\n    opacity: 0.82;\n  }\n\n  84% {\n    transform: translate3d(-1.92%, -0.96%, 0) scale(1.072, 0.928) skew(0.84deg, -0.36deg);\n    opacity: 0.36;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .roster-file-summary-hero__donor-space--premium::before,\n  .roster-file-summary-hero__donor-space--premium .roster-file-summary-hero__nebula-morph {\n    animation: none;\n  }\n\n  .roster-file-summary-hero__donor-space .member-profile-card-popover__shooting-star {\n    display: none;\n  }\n}\n\n.roster-file-summary-hero__banner-overlay {\n  position: absolute;\n  inset: 0;\n  background:\n    linear-gradient(\n      90deg,\n      rgba($dark-panel-blue, 0.82) 0%,\n      rgba($dark-panel-blue, 0.58) 32%,\n      rgba($dark-panel-blue, 0.32) 58%,\n      rgba($dark-panel-blue, 0.14) 100%\n    ),\n    linear-gradient(\n      180deg,\n      rgba($dark-panel-blue, 0.12) 0%,\n      rgba($dark-panel-blue, 0.52) 100%\n    );\n}\n\n.roster-file-summary {\n  display: grid;\n  grid-template-columns: minmax(0, 1.05fr) minmax(0, 0.95fr);\n  gap: 0;\n  padding: 14px calc(#{$roster-hero-intel-width} + 6px) 12px 8px;\n  background: transparent;\n  position: relative;\n  z-index: 2;\n  overflow: visible;\n}\n\n.roster-file-summary--no-org {\n  grid-template-columns: minmax(0, 1fr);\n}\n\n.roster-file-summary-hero:has(.roster-file-summary--no-org)::before {\n  width: 58%;\n}\n\n.roster-file-summary__primary {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  padding: 12px 20px 12px 10px;\n}\n\n.roster-file-summary__avatar-stack {\n  position: relative;\n  width: 80px;\n  height: 100px;\n  flex-shrink: 0;\n}\n\n.roster-file-summary__avatar-discord {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: auto;\n  height: 75px;\n  border-radius: 50%;\n  object-fit: cover;\n  z-index: 1;\n  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.55));\n}\n\n.roster-file-summary__avatar-ring {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 75px;\n  height: 75px;\n  border-radius: 50%;\n  border: 3px solid $light-blue;\n  box-sizing: border-box;\n  z-index: 2;\n  pointer-events: none;\n}\n\n.roster-file-summary__avatar-halo {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 79px;\n  height: 79px;\n  border-radius: 50%;\n  z-index: 0;\n  pointer-events: none;\n}\n\n.roster-file-summary__rank {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  min-width: 0;\n}\n\n.roster-file-summary__rank-img {\n  height: 65px;\n  object-fit: contain;\n  filter:\n    // Dark, fine shadow to lift transparent PNG edges\n    drop-shadow(0 0 1px rgba(0, 0, 0, 0.95))\n    drop-shadow(0 1px 2px rgba(0, 0, 0, 0.55));\n  transform: translateZ(0);\n}\n\n// Ensure the rank image relief isn't overridden by other table/icon rules.\n.roster-file .roster-file-summary__rank-img {\n  filter:\n  drop-shadow(0 0 5px rgba(0, 0, 0, 0.75)) \n  drop-shadow(0 3px 5px rgba(0, 0, 0, 0.75))\n}\n\n.roster-file-summary__rank-img--empty {\n  border-radius: 14px;\n  border: 1px solid rgba($accent-blue, 0.18);\n  background: rgba(0, 0, 0, 0.10);\n}\n\n.roster-file-summary__org {\n  display: grid;\n  align-content: center;\n  gap: 8px;\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.roster-file-summary__moniker-row {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n}\n\n// Sits just right of the three identity-panel hash ticks (hero ::before).\n// Ticks use background-position calc(100% - 50px) / 30px → they end at identityWidth - 50px.\n.roster-file-summary__donor-gem {\n  position: absolute;\n  z-index: 3;\n  left: calc(#{$roster-hero-identity-width} - 44px);\n  top: 22%;\n  width: 20px;\n  height: 20px;\n  transform: translateY(-50%);\n  overflow: visible;\n  pointer-events: auto;\n\n  .donor-gem-badge__wrap {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    width: 20px;\n    height: 20px;\n    transform: translate(-50%, -50%);\n  }\n\n  .donor-gem-badge__wrap--premium::before {\n    inset: -6px;\n  }\n\n  .donor-gem-badge__gem {\n    width: 20px;\n    height: 20px;\n  }\n\n  .donor-gem-badge__tooltip {\n    left: 50%;\n    right: auto;\n    transform: translate(-50%, -2px);\n  }\n\n  .donor-gem-badge__wrap:hover .donor-gem-badge__tooltip,\n  .donor-gem-badge__wrap:focus-within .donor-gem-badge__tooltip {\n    transform: translate(-50%, 0);\n  }\n}\n\n.roster-file-summary-hero:has(.roster-file-summary--no-org) .roster-file-summary__donor-gem {\n  left: calc(58% - 44px);\n}\n\n.roster-file-summary__moniker {\n  margin: 0;\n  flex: 1 1 auto;\n  min-width: 0;\n  font-family: 'GoodTimes', 'Lato', sans-serif;\n  font-size: 1.05rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: $pure-white;\n  line-height: 1.15;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n}\n\n.roster-file-summary__rank-name-wrap {\n  position: relative;\n  display: inline-block;\n  max-width: 100%;\n  min-width: 0;\n  cursor: default;\n\n  &:hover,\n  &:focus-within {\n    .roster-file-summary__rank-paygrade-tooltip {\n      opacity: 1;\n      visibility: visible;\n      transform: translateY(0);\n    }\n  }\n}\n\n.roster-file-summary__rank-name {\n  font-size: 0.71rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgba($light-blue, 0.95);\n  line-height: 1.2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n\n  &.roster-file-summary__rank-name--split {\n    display: inline-flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.08em;\n    line-height: 1.18;\n    text-align: left;\n    white-space: normal;\n    overflow: visible;\n    text-overflow: unset;\n  }\n}\n\n.roster-file-summary__rank-name__line1 {\n  font-size: inherit;\n}\n\n.roster-file-summary__rank-name__line2 {\n  font-size: 0.86em;\n  opacity: 0.92;\n  letter-spacing: 0.02em;\n}\n\n.roster-file-summary__rank-paygrade-tooltip {\n  position: absolute;\n  left: 0;\n  top: calc(100% + 6px);\n  z-index: 4;\n  display: inline-flex;\n  align-items: baseline;\n  gap: 6px;\n  min-width: 52px;\n  padding: 6px 10px;\n  border-radius: 8px;\n  border: 1px solid $accent-blue;\n  background: $panel-blue;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  line-height: 1.2;\n  white-space: nowrap;\n  pointer-events: none;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-2px);\n  transition:\n    opacity 0.15s ease,\n    visibility 0.15s ease,\n    transform 0.15s ease;\n  box-shadow:\n    0 8px 22px rgba(0, 0, 0, 0.45),\n    0 0 0 1px rgba(0, 0, 0, 0.18);\n}\n\n.roster-file-summary__rank-paygrade-tooltip__label {\n  color: rgba($light-grey, 0.76);\n}\n\n.roster-file-summary__rank-paygrade-tooltip__value {\n  color: rgba($very-light-grey, 0.95);\n}\n\n.roster-file-summary__meta-line {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  font-size: 10px;\n  font-weight: 650;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  line-height: 1.2;\n  min-width: 0;\n}\n\n.roster-file-summary__meta-part {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 6px;\n  min-width: 0;\n}\n\n.roster-file-summary__meta-sep {\n  color: rgba($light-grey, 0.55);\n  flex-shrink: 0;\n}\n\n.roster-file-summary__meta-assignment {\n  color: rgba($light-blue, 1);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.roster-file-summary__field-label {\n  margin-right: 6px;\n  font-size: 0.6rem;\n  font-weight: 750;\n  color: rgba($light-grey, 0.76);\n  letter-spacing: 0.04em;\n}\n\n.roster-file-summary__field-value {\n  color: rgba($light-grey, 0.76);\n}\n\n.roster-file-summary__org-details {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  align-self: stretch;\n  margin: 6px 4px;\n  padding: 12px 8px 16px 8px;\n  min-width: 0;\n\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: -5;\n    left: 18px;\n    right: 18px;\n    height: 1px;\n    @include roster-sci-fi-edge-glow;\n    pointer-events: none;\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    left: -10px;\n    right: -10px;\n    bottom: -17px;\n    height: 18px;\n    @include roster-sci-fi-hatch-bar;\n    opacity: 0.85;\n    pointer-events: none;\n  }\n}\n\n// Compact org recap (roster file only) — not .members-onboarding-ending-structure__cardSurface\n.roster-file-structure-strip {\n  position: relative;\n  z-index: 1;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: flex-start;\n  justify-content: space-evenly;\n  gap: 0;\n  width: 100%;\n  min-width: 0;\n}\n\n.roster-file-structure-strip--empty {\n  width: 100%;\n  font-size: 12px;\n  text-align: center;\n  color: rgba($very-light-grey, 0.88);\n}\n\n.roster-file-structure-strip__item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 0 1 auto;\n  min-width: 0;\n  max-width: 7rem;\n  gap: 4px;\n}\n\n.roster-file-structure-strip__surface {\n  box-sizing: border-box;\n  width: 3.25rem;\n  height: 4.5rem;\n  min-width: 5rem;\n  min-height: 3.25rem;\n  max-width: 6rem;\n  max-height: 5.25rem;\n  margin: 0;\n  padding: 0.2rem;\n  border-radius: 6px;\n  border: 1px solid rgba(120, 165, 200, 0.55);\n  color: $very-light-grey;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: box-shadow 0.15s ease;\n}\n\n.roster-file-structure-strip__surface--neutral {\n  background: rgba($dark-blue, 0.55);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.22);\n}\n\n.roster-file-structure-strip__logo {\n  display: block;\n  width: auto;\n  max-width: 3.35rem;\n  max-height: 3.15rem;\n  object-fit: contain;\n}\n\n.roster-file-structure-strip__logo--placeholder {\n  display: block;\n  width: 2rem;\n  height: 1.85rem;\n  flex-shrink: 0;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.roster-file-structure-strip__label {\n  width: 100%;\n  max-width: 5.25rem;\n  font-size: 9px;\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: 0.02em;\n  text-align: center;\n  color: rgba($very-light-grey, 0.9);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.roster-file-org-line {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.roster-file-section-edit,\n.roster-file-section-confirm {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: 1px solid rgba($accent-blue, 0.35);\n  border-radius: 6px;\n  background: rgba(0, 0, 0, 0.2);\n  color: rgba($very-light-grey, 0.92);\n  font-size: 14px;\n  line-height: 1;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n\n  &:hover:not(:disabled) {\n    background: rgba($accent-blue, 0.18);\n    border-color: rgba($accent-blue, 0.55);\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.roster-file-section-picker {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  min-width: 0;\n  flex: 1;\n}\n\n// When section picker is shown inside the org block, stack dropdowns vertically.\n.roster-file-org-block__lines .roster-file-section-picker {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  column-gap: 8px;\n  row-gap: 8px;\n  align-items: start;\n}\n\n.roster-file-org-block__lines .roster-file-section-select {\n  grid-column: 1;\n  max-width: none;\n}\n\n.roster-file-org-block__lines .roster-file-section-select__btn {\n  width: 100%;\n  min-width: 220px;\n}\n\n.roster-file-org-block__lines .roster-file-section-confirm {\n  grid-column: 2;\n  grid-row: 1 / span 2; // align with the two stacked dropdowns\n  align-self: center;\n}\n\n.roster-file-org-block__lines .roster-file-section-picker__error {\n  grid-column: 1 / -1;\n}\n\n.roster-file-section-select {\n  position: relative;\n  flex: 0 1 auto;\n  min-width: 0;\n  max-width: 260px;\n}\n\n.roster-file-section-select__btn {\n  width: 140px;\n  height: 30px;\n  padding: 0 8px;\n  border-radius: 6px;\n  border: 1px solid rgba($accent-blue, 0.35);\n  background: rgba(0, 0, 0, 0.25);\n  color: rgba($very-light-grey, 0.92);\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n\n  &:hover:not(:disabled) {\n    background: rgba(0, 0, 0, 0.32);\n    border-color: rgba($accent-blue, 0.5);\n  }\n\n  &:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n  }\n}\n\n.roster-file-section-select__btn-text {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.roster-file-section-select__caret {\n  flex-shrink: 0;\n  color: rgba($very-light-grey, 0.72);\n  font-size: 12px;\n  line-height: 1;\n}\n\n.roster-file-section-select__menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  // Match the trigger width (avoid huge menus / horizontal scroll)\n  width: 100%;\n  max-height: 240px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  border-radius: 10px;\n  border: 1px solid rgba($accent-blue, 0.28);\n  background: rgba(8, 14, 20, 0.96);\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.6);\n  z-index: 2000;\n  @include scrollbar-styles;\n}\n\n.roster-file-section-select__option {\n  display: block;\n  width: auto;\n  text-align: left;\n  padding: 8px 10px;\n  background: transparent;\n  border: 0;\n  color: rgba($very-light-grey, 0.9);\n  font-size: 13px;\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n\n  &:hover {\n    background: rgba($accent-blue, 0.14);\n  }\n\n  &.is-selected {\n    background: rgba($accent-blue, 0.22);\n    color: rgba($very-light-grey, 0.96);\n    width: stretch;\n  }\n}\n\n.roster-file-section-select__empty {\n  padding: 10px;\n  font-size: 12px;\n  color: rgba($very-light-grey, 0.7);\n}\n\n.roster-file-section-picker__loading {\n  font-size: 14px;\n  color: rgba($very-light-grey, 0.75);\n}\n\n.roster-file-section-picker__error {\n  flex-basis: 100%;\n  font-size: 11px;\n  color: rgba(lighten($red, 22%), 0.92);\n  line-height: 1.3;\n}\n\n.roster-file-section-picker__error--inline {\n  flex-basis: auto;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 240px;\n  margin-left: 2px;\n}\n\n.roster-file-section-notice {\n  margin: 0 16px 12px;\n  padding: 10px 12px;\n  font-size: 12px;\n  line-height: 1.4;\n  color: rgba($pure-white, 0.88);\n  border: 1px solid rgba($pure-white, 0.12);\n  border-radius: 6px;\n  background: rgba($very-dark-grey, 0.25);\n}\n\n.roster-file-org-logo {\n  width: 45px;\n  object-fit: contain;\n  opacity: 0.95;\n  flex-shrink: 0;\n  box-sizing: border-box;\n\n  &--placeholder {\n    display: inline-block;\n    flex-shrink: 0;\n    opacity: 0;\n    pointer-events: none;\n  }\n}\n\n.roster-file-org-block {\n  display: grid;\n  grid-template-columns: 50px 1fr;\n  column-gap: 10px;\n  min-width: 0;\n}\n\n.roster-file-org-block__lines {\n  display: grid;\n  align-content: start;\n  gap: 6px; // match .roster-file-summary__org-details gap\n  min-width: 0;\n}\n\n.roster-file-org-logo--tall {\n  height: 50px; // roughly two lines + gap\n  align-self: start;\n}\n\n.roster-file-org-logo--tall.roster-file-org-logo--placeholder {\n  height: 50px;\n}\n\n.roster-file-org-name {\n  font-size: 15px;\n  color: rgba($very-light-grey, 0.88);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.roster-file-identity__accent-bar {\n  position: absolute;\n  left: 8px;\n  right: 28px;\n  bottom: 7px;\n  height: 10px;\n  z-index: 1;\n  pointer-events: none;\n  background: repeating-linear-gradient(\n    -52deg,\n    rgba($accent-blue, 0.24) 0,\n    rgba($accent-blue, 0.24) 3px,\n    transparent 3px,\n    transparent 10px\n  );\n  mask-image: linear-gradient(\n    90deg,\n    transparent 0%,\n    rgba(0, 0, 0, 0.9) 16%,\n    rgba(0, 0, 0, 0.9) 70%,\n    transparent 100%\n  );\n  opacity: 0.88;\n}\n\n.roster-file-identity__text {\n  position: relative;\n  z-index: 1;\n  display: grid;\n  font-size: 10px;\n  gap: 6px;\n  min-width: 0;\n  width: 100%;\n  pointer-events: auto;\n}\n\n.roster-file-identity__avatar {\n  width: 46px;\n  height: 46px;\n  border-radius: 10px;\n  object-fit: cover;\n  border: 1px solid rgba($accent-blue, 0.22);\n  background: rgba(0, 0, 0, 0.18);\n  flex-shrink: 0;\n}\n\n.roster-file-identity__avatar--empty {\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.roster-file-identity__row {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 8px;\n  align-items: center;\n  min-width: 0;\n}\n\n.roster-file-identity__label {\n  font-size: 11px;\n  font-weight: 750;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgba($light-blue, 0.68);\n  white-space: nowrap;\n\n  &--icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    flex-shrink: 0;\n\n    img {\n      display: block;\n      width: 22px;\n      height: 22px;\n      object-fit: contain;\n      opacity: 0.92;\n    }\n  }\n}\n\n.roster-file-identity__icon-spacer {\n  display: block;\n  width: 28px;\n  height: 18px;\n  flex-shrink: 0;\n}\n\n.roster-file-identity__value {\n  font-size: 13px;\n  color: rgba($very-light-grey, 0.9);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 260px;\n}\n\n.roster-file-assignment {\n  font-size: 12px;\n  color: rgba($very-light-grey, 0.88);\n  text-align: right;\n  max-width: 320px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-top: 2px;\n}\n\n.roster-file-assignment--left {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgba($light-blue, 0.86);\n  line-height: 1.1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n  text-align: left;\n}\n\n.roster-file-tabs {\n  position: relative;\n  display: flex;\n  gap: 8px;\n  border-bottom: none;\n  padding: 10px 16px 12px 16px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    left: 10px;\n    right: 10px;\n    bottom: 0;\n    height: 13px;\n    z-index: 0;\n    clip-path: polygon(5% 0, 95% 0, 100% 100%, 0 100%);\n    background: rgba($dark-panel-blue, 0.78);\n    border-top: 1px solid rgba($accent-blue, 0.38);\n    box-shadow:\n      inset 0 1px 0 rgba($pure-white, 0.07),\n      0 2px 8px rgba(0, 0, 0, 0.22);\n    pointer-events: none;\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    right: 5px;\n    bottom: 9px;\n    width: 50px;\n    height: 5px;\n    z-index: 0;\n    pointer-events: none;\n    background:\n      linear-gradient(\n        90deg,\n        rgba($accent-blue, 0.62) 0,\n        rgba($accent-blue, 0.62) 13px,\n        transparent 13px,\n        transparent 17px,\n        rgba($accent-blue, 0.62) 17px,\n        rgba($accent-blue, 0.62) 30px,\n        transparent 30px,\n        transparent 34px,\n        rgba($accent-blue, 0.62) 34px,\n        rgba($accent-blue, 0.62) 47px,\n        transparent 47px\n      );\n    filter: drop-shadow(0 0 4px rgba($accent-blue, 0.75));\n  }\n}\n\n.roster-file-tab {\n  position: relative;\n  z-index: 1;\n  border: 1px solid rgba($accent-blue, 0.25);\n  border-bottom: none;\n  background: $dark-panel-blue;\n  color: rgba($very-light-grey, 0.85);\n  padding: 5px 20px;\n  border-radius: 6px 6px 0 0;\n  font-size: 12px;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n\n  &:hover {\n    background: $light-panel-blue;\n    border-color: rgba($accent-blue, 0.40);\n    color: $very-light-grey;\n  }\n\n  &.is-active {\n    background: $light-panel-blue;\n    border-color: rgba($accent-blue, 0.55);\n    color: $very-light-grey;\n\n    &::after {\n      content: '';\n      position: absolute;\n      left: 10px;\n      right: 10px;\n      bottom: -2px; // sit on top of the tabs baseline\n      height: 2px;\n      border-radius: 999px;\n      background: linear-gradient(\n        90deg,\n        rgba($accent-blue, 0) 0%,\n        rgba($accent-blue, 0.95) 35%,\n        rgba(255, 255, 255, 0.75) 50%,\n        rgba($accent-blue, 0.95) 65%,\n        rgba($accent-blue, 0) 100%\n      );\n      box-shadow:\n        0 0 8px rgba($accent-blue, 0.65),\n        0 0 16px rgba($accent-blue, 0.35);\n    }\n  }\n}\n\n.roster-file-loading,\n.roster-file-error {\n  padding: 18px 16px;\n}\n\n.roster-file-error {\n  color: rgba($red, 0.92);\n}\n\n.roster-file-view {\n  padding: 16px;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.roster-file-view--statistics {\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: none; // Firefox\n  -ms-overflow-style: none; // IE/Edge legacy\n}\n\n.roster-file-view--statistics::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.roster-file-view--history {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  overflow: hidden;\n}\n\n.roster-file-view--ribbons {\n  padding: 0;\n  overflow: hidden;\n}\n\n.roster-file-ribbons-toolbar {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 10px;\n}\n\n.roster-file-ribbons-toolbar__btn {\n  border: 1px solid rgba($accent-blue, 0.28);\n  background: rgba(0, 0, 0, 0.18);\n  color: rgba($very-light-grey, 0.92);\n  border-radius: 10px;\n  padding: 8px 10px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 650;\n  letter-spacing: 0.02em;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n\n  &:hover {\n    background: rgba($accent-blue, 0.14);\n    border-color: rgba($accent-blue, 0.55);\n    color: rgba($very-light-grey, 0.98);\n  }\n}\n\n.roster-file-ribbons-scroll {\n  padding: 5px 16px 16px;\n  height: 100%;\n  max-height: none;\n  overflow-x: hidden;\n  overflow-y: auto;\n  @include scrollbar-styles;\n}\n\n.roster-file-ribbons-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 14px;\n  margin-bottom: 30px;\n}\n\n.roster-file-ribbon-card {\n  border: 1px solid rgba($accent-blue, 0.18);\n  background: rgba(0, 0, 0, 0.14);\n  border-radius: 14px;\n  padding: 10px;\n  position: relative;\n}\n\n.roster-file-ribbon-card--locked {\n  .ribbon-details {\n    opacity: 0.3;\n  }\n}\n\n.roster-file-ribbon-progress {\n  margin-bottom: 6px;\n}\n\n.roster-file-ribbon-progress__bar-wrap {\n  position: relative;\n  width: 100%;\n  min-width: 0;\n}\n\n.roster-file-ribbon-progress__track {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  gap: 2px;\n  width: 100%;\n  border: 1px solid rgba(58, 120, 180, 0.22);\n  border-radius: 4px;\n  padding: 2px;\n  min-width: 0;\n  min-height: 12px;\n}\n\n.roster-file-ribbon-progress__track--empty .roster-file-ribbon-progress__segment {\n  opacity: 0.85;\n}\n\n.roster-file-ribbon-progress__segment {\n  flex: 1 1 0;\n  min-width: 3px;\n  border-radius: 0;\n  //border: 1px solid rgba($accent-blue, 0.22);\n  background: rgba(0, 0, 0, 0.22);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);\n  transition:\n    background 0.18s ease,\n    border-color 0.18s ease;\n\n  &:first-child {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n  }\n\n  &:last-child {\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n  }\n\n  &.is-filled {\n    background: rgba($blue, 0.62);\n    border-color: rgba($accent-blue, 0.35);\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);\n  }\n}\n\n.roster-file-ribbon-progress__track--complete .roster-file-ribbon-progress__segment.is-filled {\n  background: rgba($dark-green, 0.72);\n  border-color: rgba($dark-green, 0.45);\n}\n\n.roster-file-ribbon-progress__label {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -42%);\n  z-index: 1;\n  pointer-events: none;\n  padding: 1px 6px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 650;\n  color: rgba($very-light-grey, 0.96);\n  font-variant-numeric: tabular-nums;\n  line-height: 1.15;\n  //text-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);\n  //background: rgba(0, 0, 0, 0.30);\n  //box-shadow:\n  //  0 0 10px rgba(0, 0, 0, 0.45),\n  //  inset 0 1px 0 rgba(255, 255, 255, 0.06);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n}\n\n.roster-file-ribbon-handle {\n  position: absolute;\n  left: 8px;\n  bottom: 8px;\n  z-index: 3;\n}\n\n.roster-file-ribbon-handle__btn {\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  border: 1px solid rgba($accent-blue, 0.38);\n  background: rgba(0, 0, 0, 0.35);\n  color: rgba($very-light-grey, 0.92);\n  font-size: 12px;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n\n  &:hover {\n    background: rgba($accent-blue, 0.16);\n    border-color: rgba($accent-blue, 0.55);\n  }\n}\n\n.roster-file-ribbon-handle__tooltip {\n  position: absolute;\n  left: 0;\n  bottom: 24px;\n  min-width: 200px;\n  max-width: 280px;\n  padding: 10px 10px;\n  border-radius: 10px;\n  border: 1px solid rgba($accent-blue, 0.28);\n  background: rgba(8, 14, 20, 0.92);\n  color: rgba($very-light-grey, 0.92);\n  font-size: 12px;\n  line-height: 1.35;\n  box-shadow:\n    0 8px 22px rgba(0, 0, 0, 0.55),\n    0 0 0 1px rgba(0, 0, 0, 0.22);\n  white-space: pre-wrap;\n}\n\n.roster-file-ribbon-card .ribbon-details {\n  transform: scale(0.95);\n  transform-origin: top center;\n}\n\n.roster-file-ribbon-info {\n  position: absolute;\n  right: 8px;\n  bottom: 8px;\n  z-index: 2;\n}\n\n.roster-file-ribbon-info__btn {\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  border: 1px solid rgba($accent-blue, 0.38);\n  background: rgba(0, 0, 0, 0.35);\n  color: rgba($very-light-grey, 0.92);\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n\n  &:hover {\n    background: rgba($accent-blue, 0.16);\n    border-color: rgba($accent-blue, 0.55);\n  }\n}\n\n.roster-file-ribbon-info__tooltip {\n  position: absolute;\n  right: 0;\n  bottom: 24px;\n  min-width: 200px;\n  max-width: 280px;\n  padding: 10px 10px;\n  border-radius: 10px;\n  border: 1px solid rgba($accent-blue, 0.28);\n  background: rgba(8, 14, 20, 0.92);\n  color: rgba($very-light-grey, 0.92);\n  font-size: 12px;\n  line-height: 1.35;\n  box-shadow:\n    0 8px 22px rgba(0, 0, 0, 0.55),\n    0 0 0 1px rgba(0, 0, 0, 0.22);\n  white-space: pre-wrap;\n}\n\n.roster-file-ribbon-name {\n  margin-top: 8px;\n  font-size: 12px;\n  color: rgba($very-light-grey, 0.88);\n  text-align: center;\n  line-height: 1.15;\n}\n\n.roster-file-placeholder {\n  padding: 16px;\n  border: 1px dashed rgba($accent-blue, 0.25);\n  border-radius: 12px;\n  color: rgba($very-light-grey, 0.75);\n}\n\n.roster-file-stat-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n}\n\n.roster-file-stat-card {\n  border: 1px solid rgba($accent-blue, 0.18);\n  background: rgba(0, 0, 0, 0.14);\n  border-radius: 14px;\n  padding: 14px;\n}\n\n.roster-file-stat-title {\n  font-size: 12px;\n  font-weight: 650;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: rgba($very-light-grey, 0.90);\n  margin-bottom: 10px;\n}\n\n.roster-file-stat-lines {\n  display: grid;\n  gap: 8px;\n}\n\n.roster-file-stat-line {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  font-size: 12px;\n  color: rgba($very-light-grey, 0.82);\n}\n\n.roster-file-trainings {\n  margin-top: 16px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n\n  .roster-file-basic-icons {\n    margin-bottom: 12px;\n  }\n\n  .basic-icons {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n\n    .basic-icon {\n      width: 22px;\n      height: 22px;\n      object-fit: contain;\n    }\n\n    .basic-icon.certified {\n      opacity: 0.9;\n    }\n\n    .basic-icon.required {\n      opacity: 0.25;\n    }\n  }\n}\n\n.roster-file-stat-charts {\n  margin-top: 14px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n}\n\n.roster-file-stat-charts--solo {\n  grid-template-columns: 1fr;\n}\n\n.roster-file-stat-card--chart {\n  display: grid;\n  grid-template-rows: auto 1fr;\n  gap: 10px;\n}\n\n.roster-file-stat-card--chart-wide {\n  grid-column: 1 / -1;\n}\n\n.roster-file-chart {\n  position: relative;\n  width: 100%;\n  min-height: 0;\n}\n\n.roster-file-chart--line {\n  height: 240px;\n}\n\n.roster-file-chart--bars {\n  // Height is controlled by scroll container; ensure chart itself is tall enough per row count\n  height: 520px;\n}\n\n.roster-file-stat-card__scroll {\n  overflow-y: auto;\n  overflow-x: hidden;\n  min-height: 0;\n  padding-right: 6px; // room for scrollbar without overlaying chart\n  scrollbar-width: thin; // Firefox\n  scrollbar-color: rgba($accent-blue, 0.35) rgba(0, 0, 0, 0.12);\n}\n\n.roster-file-stat-card__scroll--bars {\n  max-height: 260px;\n}\n\n.roster-file-stat-card__scroll::-webkit-scrollbar {\n  width: 6px;\n}\n\n.roster-file-stat-card__scroll::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.12);\n  border-radius: 999px;\n}\n\n.roster-file-stat-card__scroll::-webkit-scrollbar-thumb {\n  background: rgba($accent-blue, 0.30);\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.roster-file-stat-card__scroll::-webkit-scrollbar-thumb:hover {\n  background: rgba($accent-blue, 0.42);\n}\n\n@media (max-width: 720px) {\n  .roster-file-trainings,\n  .roster-file-stat-charts {\n    grid-template-columns: 1fr;\n  }\n\n  .roster-file-stat-card--chart-wide {\n    grid-column: auto;\n  }\n}\n\n.roster-file-section-title {\n  font-size: 12px;\n  font-weight: 650;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: rgba($very-light-grey, 0.90);\n  margin-bottom: 10px;\n}\n\n.roster-file-history-scroll {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding-right: 2px;\n  @include scrollbar-styles;\n}\n\n.roster-file-history {\n  display: grid;\n  gap: 10px;\n}\n\n.roster-file-history-row {\n  display: grid;\n  grid-template-columns: 110px 1fr auto;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border: 1px solid rgba($accent-blue, 0.16);\n  background: rgba(0, 0, 0, 0.12);\n  border-radius: 12px;\n}\n\n.roster-file-history-row__date {\n  font-family: ui-monospace, \"Cascadia Mono\", \"Segoe UI Mono\", monospace;\n  font-size: 12px;\n  color: rgba($very-light-grey, 0.82);\n}\n\n.roster-file-history-row__link {\n  appearance: none;\n  border: none;\n  background: none;\n  padding: 0;\n  text-align: left;\n  cursor: pointer;\n  color: rgba($accent-blue, 0.92);\n  font-size: 13px;\n  font-weight: 650;\n  text-decoration: underline;\n  text-decoration-color: rgba($accent-blue, 0.35);\n  text-underline-offset: 3px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  &:hover {\n    color: $very-light-grey;\n    text-decoration-color: rgba($very-light-grey, 0.55);\n  }\n}\n\n.roster-file-history-row__meta {\n  font-size: 12px;\n  color: rgba($very-light-grey, 0.72);\n  white-space: nowrap;\n}\n\n.roster-file-history-row.is-redacted {\n  border-style: dashed;\n  opacity: 0.78;\n}\n\n.roster-file-history-row__redacted {\n  font-family: ui-monospace, \"Cascadia Mono\", \"Segoe UI Mono\", monospace;\n  font-size: 12px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.72);\n  user-select: none;\n}\n\n// Calendar event preview + main calendar modal — same header + banner pattern as .table-base.roster .roster-file (RosterFileTop)\n.calendar-event-modal.calendar-event-modal--roster-file,\n.calendar-event-modal.calendar-event-modal--card-top {\n  .roster-file-top--event-modal {\n    position: relative;\n    z-index: 2;\n    flex: 0 0 auto;\n  }\n\n  .roster-file-header--event-modal {\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 8px;\n    padding: 4px 7px 6px 14px;\n    margin: 0;\n    height: auto;\n    min-height: 38px;\n    color: $very-light-grey;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    border-bottom: none;\n    z-index: 30;\n    isolation: isolate;\n\n    // Recreate the clipped header shape via a background layer (same logic as RosterFileTop)\n    &::before {\n      content: '';\n      position: absolute;\n      inset: 0;\n      clip-path: polygon(0% 0%, 100% 0%, 100% 70%, 35% 70%, 30% 100%, 0% 100%);\n      pointer-events: none;\n      z-index: -1;\n      @include steel-bg(\"../medias/steel.png\");\n    }\n\n    // Bottom rim: same shape, shifted down (creates the lower edge)\n    &::after {\n      content: '';\n      position: absolute;\n      inset: 0;\n      transform: translateY(5px);\n      clip-path: polygon(0% 0%, 100% 0%, 100% 70%, 35% 70%, 30% 100%, 0% 100%);\n      pointer-events: none;\n      z-index: -2;\n      background: $very-dark-red;\n      filter:\n        drop-shadow(0 2px 0 rgba(0, 0, 0, 0.65))\n        drop-shadow(0 0 10px rgba($accent-blue, 0.18));\n    }\n\n    h2 {\n      font-size: 0.8rem;\n      margin: 0;\n      color: $very-light-grey;\n    }\n\n    .roster-file-header__main {\n      flex: 1;\n      min-width: 0;\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 5px;\n      padding-bottom: 1px;\n    }\n\n    h2.roster-file-header-title {\n      display: flex;\n      align-items: center;\n      width: 100%;\n      min-width: 0;\n      margin: 5px 0 0 0;\n    }\n\n    .calendar-event-header-status {\n      flex-shrink: 0;\n      line-height: 1;\n\n      &:empty {\n        display: none;\n      }\n\n      .calendar-event.status {\n        margin: 0;\n      }\n    }\n\n    .roster-file-header-rank-name {\n      font-size: 1rem;\n      font-weight: 700;\n      letter-spacing: 0.03em;\n      overflow: hidden;\n      min-width: 0;\n      max-width: 305px;\n      flex: 1;\n    }\n\n    .roster-file-header__tail {\n      position: relative;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      bottom: 6px;\n      flex-shrink: 0;\n      align-self: center;\n\n      a.roster-file-tab {\n        text-decoration: none;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        padding: 5px 10px;\n        font-size: 11px;\n        border-radius: 8px;\n        color: rgba($very-light-grey, 0.85);\n\n        &:visited {\n          color: rgba($very-light-grey, 0.85);\n        }\n      }\n\n      .calendar-event-header-toolbar {\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        justify-content: flex-end;\n        gap: 8px;\n        min-width: 0;\n        max-width: 100%;\n\n        .edit-mode {\n          display: flex;\n          flex-wrap: wrap;\n          align-items: center;\n          gap: 8px;\n          margin: 0;\n        }\n\n        .btn-style1 {\n          font-size: 11px;\n          padding: 5px 10px;\n        }\n      }\n    }\n\n    .close-btn {\n      position: relative;\n      background: none;\n      border: none;\n      color: $very-light-grey;\n      font-size: 0.7rem;\n      padding: 0 3px;\n      border-radius: 3px;\n      bottom: 0;\n      flex-shrink: 0;\n      cursor: pointer;\n\n      &:hover {\n        color: $dark-blue-grey;\n        background-color: $very-light-grey;\n      }\n    }\n  }\n\n  // Dedicated banner for calendar event modal header (do not reuse .roster-file-banner sizing)\n  .calendar-event-card-banner {\n    height: 200px;\n    margin-top: -16px;\n    padding-top: 16px;\n    border: 1px solid rgba($accent-blue, 0.32);\n    border-bottom: none;\n    border-radius: 8px 8px 0 0;\n    position: relative;\n    overflow: hidden;\n    background: $blue-grey;\n    z-index: 20;\n\n    // Keep the subtle underline but span full width for the modal\n    &::after {\n      content: '';\n      position: absolute;\n      left: 12px;\n      right: 12px;\n      bottom: -3px;\n      height: 3px;\n      border-radius: 50%;\n      pointer-events: none;\n      z-index: 1;\n      background: linear-gradient(\n        90deg,\n        rgba($accent-blue, 0) 0%,\n        rgba($accent-blue, 0.58) 25%,\n        rgba(255, 255, 255, 0.40) 50%,\n        rgba($accent-blue, 0.58) 75%,\n        rgba($accent-blue, 0) 100%\n      );\n      box-shadow:\n        0 0 10px rgba($accent-blue, 0.32),\n        0 0 20px rgba($accent-blue, 0.20);\n      opacity: 0.95;\n    }\n  }\n\n  .calendar-event-card-banner__img {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    opacity: 0.9;\n    z-index: 0;\n  }\n\n}\n\n// Roster members list — search + summary stats toolbar (loads after adminWebsite overrides)\n.private-pages .filter-container.roster {\n  width: 100%;\n  max-width: 100%;\n  margin-top: 0.3rem;\n  margin-bottom: 0.75rem;\n  box-sizing: border-box;\n}\n\n.roster-toolbar {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.55rem;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.roster-toolbar-card {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 0;\n  padding: 0.7rem 0.8rem;\n  border-radius: 10px;\n  border: 1px solid rgba(52, 90, 120, 0.45);\n  background: linear-gradient(180deg, $panel-blue, $dark-panel-blue);\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.35) inset,\n    0 2px 14px rgba(0, 0, 0, 0.25);\n  box-sizing: border-box;\n\n  &--search {\n    flex: 1 1 14rem;\n    min-width: 0;\n    max-width: 100%;\n  }\n\n  &--stat-tile {\n    flex: 0 0 auto;\n    flex-shrink: 0;\n    gap: 0.4rem;\n    padding: 0.7rem 0.8rem;\n  }\n}\n\n.roster-toolbar-card__search {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex: 1 1 auto;\n  min-width: 0;\n  gap: 0.4rem;\n  padding: 0 0.5rem;\n  margin: 0;\n  min-height: 1.65rem;\n  border-radius: 7px;\n  border: 1px solid rgba(58, 140, 200, 0.45);\n  background: $dark-grey;\n  box-shadow: 0 0 0 1px rgba(40, 120, 200, 0.08);\n\n  &:focus-within {\n    border-color: rgba(90, 170, 240, 0.65);\n    box-shadow:\n      0 0 0 1px rgba(40, 140, 220, 0.2),\n      0 0 12px rgba(40, 120, 200, 0.15);\n  }\n}\n\n.roster-toolbar-card__search-glyph {\n  flex-shrink: 0;\n  color: lighten($accent-blue, 14%);\n}\n\n.roster-toolbar-card__input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  padding: 0.12rem 0.1rem;\n  font-size: 0.8rem;\n  line-height: 1.25;\n  color: $very-light-grey;\n\n  &::-webkit-search-cancel-button {\n    display: none;\n  }\n\n  &::placeholder {\n    color: rgba(155, 170, 186, 0.75);\n  }\n}\n\n.roster-toolbar-card__clear {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 22px;\n  height: 22px;\n  border-radius: 5px;\n  border: 1px solid rgba(120, 140, 160, 0.35);\n  background: rgba(0, 0, 0, 0.25);\n  color: $light-grey;\n  font-size: 0.72rem;\n  line-height: 1;\n  cursor: pointer;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.08);\n    color: $pure-white;\n  }\n}\n\n.roster-toolbar-card__vsep {\n  align-self: stretch;\n  width: 1px;\n  min-height: 1.45rem;\n  margin: auto 0.2rem;\n  background: rgba(70, 100, 128, 0.45);\n\n  .roster-toolbar-card > &:last-child {\n    display: none;\n  }\n\n  @media screen and (max-width: 900px) {\n    .roster-toolbar-card--search > & {\n      display: none;\n    }\n  }\n}\n\n.roster-toolbar-card__reset {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.32rem;\n  flex-shrink: 0;\n  margin: 0 0 0 0.1rem;\n  padding: 0.28rem 0.5rem;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: lighten($accent-blue, 12%);\n  cursor: pointer;\n\n  &:hover {\n    color: lighten($accent-blue, 22%);\n    background: rgba(40, 100, 160, 0.12);\n  }\n}\n\n.roster-toolbar-card__reset-glyph {\n  flex-shrink: 0;\n}\n\n.roster-toolbar-card__stat-icon {\n  flex-shrink: 0;\n  color: lighten($accent-blue, 14%);\n  width: 25px;\n  height: 22px;\n}\n\n/* Logo org (même source que le header) — 25×25, teinte bleue comme la tuile Certified */\n.roster-toolbar-card__org-logo {\n  display: block;\n  flex-shrink: 0;\n  width: 25px;\n  height: 18px;\n  object-fit: contain;\n  filter: sepia(0.35) hue-rotate(165deg) saturate(1.45) brightness(1.06)\n    drop-shadow(0 0 3px rgba(80, 170, 240, 0.45));\n\n  .roster-toolbar-card--stat-tile:hover & {\n    filter: sepia(0.38) hue-rotate(165deg) saturate(1.55) brightness(1.1)\n      drop-shadow(0 0 6px rgba(120, 200, 255, 0.55));\n  }\n}\n\n/* Même asset que `.certification-icon.certified` (react-table.scss), format compact + teinte bleue */\n.roster-toolbar-card__cert-icon {\n  display: inline-block;\n  flex-shrink: 0;\n  width: 25px;\n  height: 25px;\n  background-image: url(\"../medias/shield_green.png\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  opacity: 1;\n  filter: hue-rotate(105deg) saturate(1.3) brightness(1.07)\n    drop-shadow(0 0 3px rgba(80, 170, 240, 0.5));\n\n  .roster-toolbar-card--stat-tile:hover & {\n    filter: hue-rotate(105deg) saturate(1.45) brightness(1.12)\n      drop-shadow(0 0 6px rgba(120, 200, 255, 0.65));\n  }\n}\n\n.roster-toolbar-card__stat-text {\n  display: flex;\n  flex-direction: column;\n  gap: 0.06rem;\n  min-width: 0;\n}\n\n.roster-toolbar-card__stat-label {\n  font-size: 0.54rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: $medium-light-grey;\n  white-space: nowrap;\n}\n\n.roster-toolbar-card__stat-value {\n  font-size: 0.98rem;\n  font-weight: 800;\n  color: $pure-white;\n  line-height: 1.1;\n}\n\n.roster-toolbar-card--action {\n  cursor: pointer;\n  gap: 0.45rem;\n  color: $very-light-grey;\n  font: inherit;\n  appearance: none;\n\n  &:hover,\n  &:focus-visible {\n    border-color: rgba(90, 170, 240, 0.55);\n    box-shadow:\n      0 0 0 1px rgba(40, 140, 220, 0.18) inset,\n      0 2px 14px rgba(0, 0, 0, 0.3);\n  }\n}\n\n.roster-toolbar-card__action-icon {\n  flex-shrink: 0;\n  color: lighten($accent-blue, 12%);\n}\n\n.roster-toolbar-card__action-label {\n  font-size: 0.72rem;\n  font-weight: 800;\n  line-height: 1.7rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: $very-light-grey;\n  white-space: nowrap;\n}\n\n.roster-empty-search-row .roster-empty-search {\n  padding: 2rem 1rem;\n  text-align: center;\n  color: $sc-item-text-muted;\n  font-size: 0.95rem;\n}\n","// /src/styles/orgPositionsBrowse.scss\n// Roster → Org Positions browse modal (Hangar-inspired surfaces)\n\n.org-positions-browse-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 12000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.25rem;\n  background: rgba($dark-blue-grey, 0.72);\n  box-sizing: border-box;\n}\n\n.org-positions-browse-modal {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: #{\"min(72rem, 100%)\"};\n  height: #{\"min(45rem, 92vh)\"};\n  overflow: hidden;\n  border-radius: 10px;\n  border: 1px solid rgba($accent-blue, 0.55);\n  background-color: $dark-panel-blue;\n  background:\n    linear-gradient(180deg, rgba($dark-blue, 0.72), rgba($dark-blue-grey, 0.42)),\n    rgba($dark-blue, 0.55);\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.35),\n    0 12px 28px rgba(0, 0, 0, 0.35);\n}\n\n.org-positions-browse-modal__browse {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.org-positions-browse-modal__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-shrink: 0;\n  padding: 0.95rem 1.15rem 0.9rem;\n  border-bottom: 1px solid rgba($accent-blue, 0.4);\n  background: rgba($dark-blue-grey, 0.28);\n}\n\n.org-positions-browse-modal__heading {\n  min-width: 0;\n}\n\n.org-positions-browse-modal__title-row {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n}\n\n.org-positions-browse-modal__accent {\n  flex-shrink: 0;\n  width: 0.22rem;\n  height: 1.15rem;\n  border-radius: 2px;\n  background: $light-orange;\n  box-shadow: 0 0 10px rgba($light-orange, 0.35);\n}\n\n.org-positions-browse-modal__title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: $very-light-grey;\n}\n\n.org-positions-browse-modal__subtitle {\n  margin: 0.35rem 0 0;\n  font-size: 0.78rem;\n  line-height: 1.35;\n  color: $medium-light-grey;\n}\n\n.org-positions-browse-modal__close {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  padding: 0;\n  border: 1px solid rgba($accent-blue, 0.45);\n  border-radius: 8px;\n  background: rgba($dark-grey, 0.65);\n  color: $light-grey;\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;\n\n  &:hover,\n  &:focus-visible {\n    color: $very-light-grey;\n    border-color: rgba($light-blue, 0.65);\n    background: $medium-grey;\n  }\n}\n\n.org-positions-browse-modal__body {\n  display: grid;\n  grid-template-columns: minmax(15rem, 18.5rem) minmax(0, 1fr);\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.org-positions-browse-sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding: 1rem;\n  border-right: 1px solid rgba($accent-blue, 0.35);\n  background: rgba($dark-blue-grey, 0.28);\n  min-height: 0;\n  overflow: auto;\n  @include scrollbar-styles;\n}\n\n.org-positions-browse__search {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  min-height: 2.15rem;\n  padding: 0 0.65rem;\n  border-radius: 8px;\n  border: 1px solid rgba($accent-blue, 0.45);\n  background: $dark-grey;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25) inset;\n\n  &:focus-within {\n    border-color: rgba($light-blue, 0.65);\n  }\n}\n\n.org-positions-browse__search-glyph {\n  flex-shrink: 0;\n  color: lighten($accent-blue, 14%);\n}\n\n.org-positions-browse__search-input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  color: $very-light-grey;\n  font-size: 0.82rem;\n\n  &::-webkit-search-cancel-button {\n    display: none;\n  }\n\n  &::placeholder {\n    color: rgba(155, 170, 186, 0.75);\n  }\n}\n\n.org-positions-browse-nav {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.org-positions-browse-nav__label,\n.org-positions-browse-legend__label {\n  margin: 0;\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: $medium-light-grey;\n}\n\n.org-positions-browse-nav__list,\n.org-positions-browse-legend__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.org-positions-browse-nav__item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  width: 100%;\n  padding: 0.55rem 0.65rem;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  background: transparent;\n  color: $light-grey;\n  font-size: 0.82rem;\n  cursor: pointer;\n  text-align: left;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n\n  &:hover,\n  &:focus-visible {\n    background: rgba($accent-blue, 0.14);\n    color: $very-light-grey;\n    border-color: rgba($accent-blue, 0.35);\n  }\n\n  &.is-active {\n    @include steel-bg-transparent(\"../medias/steel.png\", $blue, $dark-blue);\n    border-color: rgba($light-blue, 0.45);\n    color: $very-light-grey;\n    box-shadow: inset 0 0 0 1px $blue;\n  }\n}\n\n.org-positions-browse-nav__item-count {\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: $medium-light-grey;\n\n  .is-active & {\n    color: $light-orange;\n  }\n}\n\n.org-positions-browse-legend {\n  margin-top: auto;\n  padding-top: 0.75rem;\n  border-top: 1px solid rgba($accent-blue, 0.3);\n}\n\n.org-positions-browse-legend__list {\n  margin-top: 0.45rem;\n  gap: 0.4rem;\n\n  li {\n    display: flex;\n    align-items: center;\n    gap: 0.45rem;\n    font-size: 0.78rem;\n    color: $light-grey;\n  }\n}\n\n.org-positions-browse-legend__swatch {\n  width: 0.7rem;\n  height: 0.7rem;\n  border-radius: 3px;\n  flex-shrink: 0;\n\n  &--division {\n    background: $light-blue;\n  }\n\n  &--branch {\n    background: $light-purple;\n  }\n\n  &--section {\n    background: $light-green;\n  }\n\n  &--special {\n    background: $light-orange;\n  }\n}\n\n.org-positions-browse-main {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n}\n\n.org-positions-browse-main__toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.85rem 1.15rem 0.75rem;\n  border-bottom: 1px solid rgba($accent-blue, 0.3);\n  background: rgba($dark-blue-grey, 0.18);\n}\n\n.org-positions-browse-main__heading {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  min-width: 0;\n}\n\n.org-positions-browse-main__title {\n  margin: 0;\n  font-size: 0.82rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: $very-light-grey;\n}\n\n.org-positions-browse-main__count {\n  font-size: 0.75rem;\n  color: $medium-light-grey;\n}\n\n.org-positions-browse-open-toggle {\n  display: inline-flex;\n  flex-shrink: 0;\n  border-radius: 10px;\n  overflow: hidden;\n  border: 1px solid $medium-light-grey;\n  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);\n  background: $dark-grey;\n}\n\n.org-positions-browse-open-toggle__btn {\n  min-width: 4.5rem;\n  padding: 6px 14px;\n  margin: 0;\n  border: none;\n  background: transparent;\n  color: $light-grey;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;\n\n  &:not(:last-child) {\n    border-right: 1px solid $medium-grey;\n  }\n\n  &:not(.is-active):hover,\n  &:not(.is-active):focus-visible {\n    background: $medium-grey;\n    color: $very-light-grey;\n  }\n\n  &.is-active {\n    @include steel-bg-transparent(\"../medias/steel.png\", $blue, $dark-blue);\n    color: $very-light-grey;\n    box-shadow: inset 0 0 0 1px $blue;\n  }\n}\n\n.org-positions-browse-main__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: auto;\n  padding: 0.9rem 1.15rem 1rem;\n  @include factions-reputations-thin-scrollbar;\n}\n\n.org-positions-browse-main__loading,\n.org-positions-browse-main__empty,\n.org-positions-browse-main__error {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 10rem;\n  margin: 0;\n  color: $medium-light-grey;\n  text-align: center;\n}\n\n.org-positions-browse-main__error {\n  color: $very-light-orange;\n}\n\n.org-positions-browse-section + .org-positions-browse-section {\n  margin-top: 1.25rem;\n}\n\n.org-positions-browse-section__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.65rem;\n}\n\n.org-positions-browse-section__title {\n  margin: 0;\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: $medium-light-grey;\n}\n\n.org-positions-browse-section__view-all {\n  border: none;\n  background: transparent;\n  color: $light-blue;\n  font-size: 0.75rem;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n\n  &:hover,\n  &:focus-visible {\n    color: lighten($light-blue, 8%);\n    text-decoration: underline;\n  }\n}\n\n.org-positions-browse-section__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(11.5rem, 1fr));\n  gap: 0.75rem;\n}\n\n.org-positions-browse-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.4rem;\n  min-height: 12.5rem;\n  padding: 0.95rem 0.75rem 0.7rem;\n  border-radius: 10px;\n  border: 1px solid rgba($accent-blue, 0.4);\n  background:\n    linear-gradient(180deg, rgba($dark-blue, 0.55), rgba($dark-blue-grey, 0.35)),\n    rgba($dark-panel-blue, 0.92);\n  color: $very-light-grey;\n  cursor: pointer;\n  text-align: center;\n  transition: transform 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;\n\n  &:hover,\n  &:focus-visible {\n    transform: translateY(-1px);\n    border-color: rgba($light-blue, 0.55);\n  }\n\n  &--special {\n    border-color: rgba($light-orange, 0.5);\n    box-shadow: inset 0 -2px 0 rgba($light-orange, 0.8);\n  }\n\n  &--no-logo {\n    justify-content: flex-start;\n  }\n\n  &--neutral {\n    box-shadow: inset 0 -2px 0 rgba($accent-blue, 0.55);\n  }\n}\n\n.org-positions-browse-card__logo-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 4.4rem;\n  height: 4.4rem;\n  margin-bottom: 0.15rem;\n  flex-shrink: 0;\n}\n\n.org-positions-browse-card__logo {\n  width: 4.2rem;\n  height: 4.2rem;\n  object-fit: contain;\n  border-radius: 8px;\n\n  &--placeholder {\n    display: block;\n    background: rgba($medium-grey, 0.55);\n    border: 1px dashed rgba($light-grey, 0.35);\n  }\n}\n\n.org-positions-browse-card__title {\n  margin: 0;\n  font-size: 0.88rem;\n  font-weight: 800;\n  line-height: 1.25;\n  color: $pure-white;\n  flex-shrink: 0;\n}\n\n.org-positions-browse-card__meta {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1 1 auto;\n  min-height: 1.35rem;\n  width: 100%;\n\n  .roster-assignment-cell__segment--user-assignments {\n    color: $light-blue;\n    font-size: 0.74rem;\n    font-weight: 600;\n    line-height: 1.25;\n  }\n}\n\n.org-positions-browse-card__commander {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.15rem;\n  width: 100%;\n  min-width: 0;\n}\n\n.org-positions-browse-card__moniker-row {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.org-positions-browse-card__moniker {\n  font-size: 0.78rem;\n  font-weight: 700;\n  line-height: 1.2;\n  color: $very-light-grey;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.org-positions-browse-card__rank-icon {\n  flex-shrink: 0;\n  width: auto;\n  height: 0.95rem;\n  object-fit: contain;\n}\n\n.org-positions-browse-card__open-chip {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  padding: 0.4rem 0.65rem;\n  border-radius: 999px;\n  border: 1px solid $light-green;\n  background: rgba($dark-green, 0.35);\n  color: $very-light-green;\n  width: fit-content;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n@media (max-width: 860px) {\n  .org-positions-browse-modal {\n    height: #{\"min(52rem, 94vh)\"};\n  }\n\n  .org-positions-browse-modal__body {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto minmax(0, 1fr);\n  }\n\n  .org-positions-browse-sidebar {\n    border-right: none;\n    border-bottom: 1px solid rgba($accent-blue, 0.35);\n    max-height: 40%;\n  }\n\n  .org-positions-browse-main__toolbar {\n    flex-wrap: wrap;\n  }\n}\n\n// Detail panel (slide-over)\n.org-positions-browse-detail-shell,\n.org-positions-browse-apply-shell {\n  position: absolute;\n  inset: 0;\n  z-index: 4;\n  display: flex;\n  flex-direction: column;\n  transform: translateX(100%);\n  opacity: 0;\n  pointer-events: none;\n  transition: transform 0.28s ease, opacity 0.22s ease;\n  background:\n    linear-gradient(180deg, rgba($dark-blue, 0.88), rgba($dark-blue-grey, 0.94)),\n    $dark-panel-blue;\n\n  &.is-open {\n    transform: translateX(0);\n    opacity: 1;\n    pointer-events: auto;\n  }\n}\n\n.org-positions-browse-apply-shell {\n  z-index: 5;\n}\n\n.org-positions-browse-detail {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n}\n\n.org-positions-browse-detail__nav {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  flex-shrink: 0;\n  padding: 0.85rem 1.15rem;\n  border-bottom: 1px solid rgba($accent-blue, 0.35);\n  background: rgba($dark-blue-grey, 0.3);\n}\n\n.org-positions-browse-detail__back {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  padding: 0.45rem 0.85rem 0.45rem 0.65rem;\n  border: 1px solid rgba($accent-blue, 0.5);\n  border-radius: 8px;\n  background: rgba($dark-grey, 0.75);\n  color: $very-light-grey;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  cursor: pointer;\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.25);\n  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;\n\n  &:hover,\n  &:focus-visible {\n    color: $pure-white;\n    border-color: rgba($light-blue, 0.7);\n    background: rgba($medium-grey, 0.95);\n    box-shadow: 0 0 0 1px rgba($accent-blue, 0.2);\n  }\n\n  &:active {\n    background: rgba($dark-blue, 0.65);\n  }\n}\n\n.org-positions-browse-detail__back-icon {\n  flex-shrink: 0;\n}\n\n.org-positions-browse-detail__close {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  padding: 0;\n  border: 1px solid rgba($accent-blue, 0.45);\n  border-radius: 8px;\n  background: rgba($dark-grey, 0.65);\n  color: $light-grey;\n  cursor: pointer;\n\n  &:hover,\n  &:focus-visible {\n    color: $very-light-grey;\n    border-color: rgba($light-blue, 0.65);\n    background: $medium-grey;\n  }\n}\n\n.org-positions-browse-detail__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: hidden;\n  padding: 1rem 1.15rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.org-positions-browse-detail__hero {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n  flex-shrink: 0;\n  padding: 1rem;\n  border-radius: 12px;\n  border: 1px solid rgba($accent-blue, 0.4);\n  background:\n    linear-gradient(135deg, rgba($accent-blue, 0.28), rgba($dark-blue, 0.55) 45%, rgba($dark-blue-grey, 0.7)),\n    rgba($dark-panel-blue, 0.9);\n}\n\n.org-positions-browse-detail--special .org-positions-browse-detail__hero {\n  border-color: rgba($light-orange, 0.45);\n  background:\n    linear-gradient(135deg, rgba($light-purple, 0.32), rgba($dark-purple, 0.45) 40%, rgba($dark-blue, 0.7)),\n    rgba($dark-panel-blue, 0.92);\n}\n\n.org-positions-browse-detail__hero-main {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  gap: 0.85rem;\n  align-items: center;\n}\n\n.org-positions-browse-detail__logo {\n  width: 4.75rem;\n  height: 4.75rem;\n  object-fit: contain;\n\n  &--letter {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.8rem;\n    font-weight: 800;\n    color: $pure-white;\n    background: linear-gradient(160deg, rgba($light-purple, 0.55), rgba($dark-purple, 0.85));\n    border-color: rgba($light-purple, 0.5);\n  }\n}\n\n.org-positions-browse-detail__hero-copy {\n  min-width: 0;\n}\n\n.org-positions-browse-detail__title-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.55rem;\n}\n\n.org-positions-browse-detail__title {\n  margin: 0;\n  font-size: 1.45rem;\n  font-weight: 800;\n  color: $pure-white;\n  line-height: 1.15;\n}\n\n.org-positions-browse-detail__badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.2rem 0.55rem;\n  border-radius: 999px;\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  border: 1px solid rgba($light-blue, 0.45);\n  background: rgba($accent-blue, 0.25);\n  color: $light-blue;\n\n  &--special {\n    border-color: rgba($light-orange, 0.55);\n    background: rgba($light-orange, 0.18);\n    color: $very-light-orange;\n  }\n\n  &--division {\n    border-color: rgba($light-blue, 0.55);\n    color: $light-blue;\n  }\n\n  &--branch {\n    border-color: rgba($light-purple, 0.55);\n    background: rgba($light-purple, 0.18);\n    color: $very-light-purple;\n  }\n\n  &--section {\n    border-color: rgba($light-green, 0.55);\n    background: rgba($light-green, 0.14);\n    color: $very-light-green;\n  }\n}\n\n.org-positions-browse-detail__tagline {\n  margin: 0.45rem 0 0;\n  font-size: 0.88rem;\n  line-height: 1.4;\n  color: $light-grey;\n}\n\n.org-positions-browse-detail__meta {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.55rem;\n}\n\n.org-positions-browse-detail__meta-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  min-width: 0;\n  padding: 0.65rem 0.7rem;\n  border-radius: 10px;\n  border: 1px solid rgba($accent-blue, 0.35);\n  background: rgba($dark-blue-grey, 0.45);\n\n  &--open {\n    gap: 0.45rem;\n    align-items: center;\n\n    .org-positions-browse-detail__meta-label {\n      align-self: flex-start;\n    }\n\n    .org-positions-browse-card__open-chip {\n      align-self: center;\n    }\n  }\n\n  &--commander {\n    gap: 0.45rem;\n    align-items: flex-start;\n\n    .org-positions-browse-detail__commander-identity {\n      align-self: flex-start;\n      width: fit-content;\n      max-width: 100%;\n      flex: 0 0 auto;\n    }\n  }\n}\n\n.org-positions-browse-detail__meta-label {\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: $medium-light-grey;\n}\n\n.org-positions-browse-detail__meta-value {\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: $very-light-grey;\n  line-height: 1.25;\n}\n\n.org-positions-browse-detail__commander-identity {\n  display: inline-flex;\n  width: fit-content;\n  max-width: 100%;\n  min-width: 0;\n  flex: 0 0 auto;\n\n  &.user-discord-rank--profile-chip {\n    width: fit-content;\n    max-width: 100%;\n    color: $very-light-grey;\n    border-color: rgba($accent-blue, 0.45);\n    background: rgba($dark-grey, 0.85);\n\n    .user-discord-rank__name {\n      color: #afa991;\n      padding: 0;\n      flex: 0 1 auto;\n    }\n\n    &:not([data-chip-bg]):hover,\n    &:not([data-chip-bg]).user-discord-rank--profile-chip-open {\n      color: $pure-white;\n      border-color: rgba($light-blue, 0.55);\n      background-color: $medium-grey;\n    }\n\n    &[data-chip-bg]::after {\n      opacity: 0.18;\n    }\n\n    &[data-chip-bg]:hover,\n    &[data-chip-bg].user-discord-rank--profile-chip-open {\n      .user-discord-rank__name {\n        color: $pure-white;\n      }\n    }\n\n    &[data-chip-bg]:hover::after,\n    &[data-chip-bg].user-discord-rank--profile-chip-open::after {\n      opacity: 0.28;\n    }\n  }\n\n  &--footer {\n    width: fit-content;\n    max-width: 100%;\n  }\n}\n\n.org-positions-browse-detail__footer-commander-body {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.org-positions-browse-detail__section {\n  padding: 0.85rem 0.95rem;\n  border-radius: 12px;\n  border: 1px solid rgba($accent-blue, 0.32);\n  background: rgba($dark-blue-grey, 0.32);\n\n  &--description {\n    flex-shrink: 0;\n  }\n\n  &--list {\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    overflow: hidden;\n    padding: 0.85rem 0.95rem 0;\n  }\n}\n\n.org-positions-browse-detail__section-title {\n  margin: 0;\n  padding: 0 0 0.55rem;\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: $very-light-grey;\n  flex-shrink: 0;\n}\n\n.org-positions-browse-detail__description {\n  margin: 0;\n  font-size: 0.9rem;\n  line-height: 1.55;\n  color: $light-grey;\n  white-space: pre-wrap;\n}\n\n.org-positions-browse-detail__empty {\n  margin: 0;\n  padding-bottom: 0.85rem;\n  font-size: 0.85rem;\n  color: $medium-light-grey;\n}\n\n.org-positions-browse-detail__split {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.75rem;\n  flex: 1 1 auto;\n  min-height: 0;\n  align-items: stretch;\n}\n\n.org-positions-browse-detail__list-scroll {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding: 0 0.2rem 0.85rem 0;\n  @include factions-reputations-thin-scrollbar;\n}\n\n.org-positions-browse-detail__list {\n  margin: 0;\n  padding: 0 0 0.35rem;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n\n  li {\n    position: relative;\n    padding-left: 1.5rem;\n    font-size: 0.86rem;\n    line-height: 1.4;\n    color: $light-grey;\n  }\n\n  &--bullets li::before {\n    content: '';\n    position: absolute;\n    left: 0.15rem;\n    top: 0.45rem;\n    width: 0.4rem;\n    height: 0.4rem;\n    border-radius: 50%;\n    background: $light-blue;\n  }\n\n  &--checks li::before {\n    content: '✓';\n    position: absolute;\n    left: 0;\n    top: 0.05rem;\n    width: 0.9rem;\n    height: 0.9rem;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 3px;\n    font-size: 0.62rem;\n    font-weight: 800;\n    line-height: 1;\n    color: $pure-white;\n    background: rgba($accent-blue, 0.55);\n    border: 1px solid rgba($light-blue, 0.55);\n  }\n\n  .org-positions-browse-detail--special &--checks li::before {\n    background: rgba($light-purple, 0.55);\n    border-color: rgba($light-purple, 0.7);\n  }\n\n  .org-positions-browse-detail--special &--bullets li::before {\n    background: $light-purple;\n  }\n}\n\n.org-positions-browse-detail__cta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-shrink: 0;\n  margin: 0 1.15rem 1rem;\n  padding: 0.95rem 1rem;\n  border-radius: 12px;\n  border: 1px solid rgba($accent-blue, 0.4);\n  background: rgba($dark-blue, 0.45);\n}\n\n.org-positions-browse-detail__cta-title {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: $very-light-grey;\n}\n\n.org-positions-browse-detail__cta-sub {\n  margin: 0.2rem 0 0;\n  font-size: 0.8rem;\n  color: $medium-light-grey;\n}\n\n.org-positions-browse-detail__cta-btn {\n  flex-shrink: 0;\n  border: none;\n  border-radius: 10px;\n  padding: 0.7rem 1rem;\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: $pure-white;\n  background: linear-gradient(90deg, $light-purple, $dark-purple);\n  cursor: not-allowed;\n  opacity: 0.55;\n\n  &.is-unlocked:not(:disabled) {\n    cursor: pointer;\n    opacity: 1;\n\n    &:hover {\n      filter: brightness(1.08);\n    }\n\n    &:focus-visible {\n      outline: 2px solid rgba($accent-blue, 0.7);\n      outline-offset: 2px;\n    }\n  }\n}\n\n.org-position-apply-panel {\n  .org-positions-browse-detail__body {\n    overflow: auto;\n    @include factions-reputations-thin-scrollbar;\n  }\n}\n\n.org-position-apply-panel__body {\n  gap: 0.95rem;\n}\n\n.org-position-apply-panel__heading {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  flex-shrink: 0;\n}\n\n.org-position-apply-panel__eyebrow {\n  margin: 0;\n  font-size: 0.68rem;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.55);\n}\n\n.org-position-apply-panel__title-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.65rem;\n}\n\n.org-position-apply-panel__title {\n  margin: 0;\n  font-size: 1.35rem;\n  font-weight: 800;\n  line-height: 1.15;\n  color: $pure-white;\n}\n\n.org-position-apply-panel__badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.22rem 0.6rem;\n  border-radius: 999px;\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  border: 1px solid rgba($light-blue, 0.45);\n  background: rgba($accent-blue, 0.22);\n  color: $light-blue;\n\n  &--special {\n    border-color: rgba($light-orange, 0.55);\n    background: rgba($light-orange, 0.18);\n    color: $very-light-orange;\n  }\n\n  &--division {\n    border-color: rgba($light-blue, 0.55);\n    color: $light-blue;\n  }\n\n  &--branch {\n    border-color: rgba($light-purple, 0.55);\n    background: rgba($light-purple, 0.18);\n    color: $very-light-purple;\n  }\n\n  &--section {\n    border-color: rgba($light-green, 0.55);\n    background: rgba($light-green, 0.14);\n    color: $very-light-green;\n  }\n}\n\n.org-position-apply-panel__status {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.22rem 0.6rem;\n  border-radius: 999px;\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n\n  &--pending {\n    border: 1px solid rgba($light-orange, 0.55);\n    background: rgba($light-orange, 0.18);\n    color: $very-light-orange;\n  }\n\n  &--approved {\n    border: 1px solid rgba($light-green, 0.55);\n    background: rgba($light-green, 0.14);\n    color: $very-light-green;\n  }\n\n  &--rejected {\n    border: 1px solid rgba($bright-red, 0.55);\n    background: rgba($dark-red, 0.35);\n    color: $very-light-grey;\n  }\n}\n\n.org-position-apply-panel__application-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.65rem;\n}\n\n.org-position-apply-panel__edit-btn {\n  padding: 0.35rem 0.75rem;\n  border: 1px solid rgba($light-blue, 0.55);\n  border-radius: 8px;\n  background: rgba($dark-grey, 0.55);\n  color: $light-blue;\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  cursor: pointer;\n\n  &:hover,\n  &:focus-visible {\n    background: rgba($accent-blue, 0.35);\n    color: $pure-white;\n  }\n}\n\n.org-position-apply-panel__loading {\n  margin: 0;\n  font-size: 0.84rem;\n  color: rgba($very-light-grey, 0.62);\n}\n\n.org-position-apply-panel__resolve-note {\n  margin: 0;\n  padding: 0.65rem 0.75rem;\n  border-radius: 8px;\n  border: 1px solid rgba($accent-blue, 0.35);\n  background: rgba($dark-blue, 0.35);\n  color: rgba($very-light-grey, 0.82);\n  font-size: 0.84rem;\n  line-height: 1.45;\n}\n\n.org-position-apply-panel__leadership {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1.35fr) minmax(0, 1.65fr);\n  gap: 0.85rem 1rem;\n  align-items: center;\n  flex-shrink: 0;\n  padding: 0.95rem 1rem;\n  border-radius: 12px;\n  border: 1px solid rgba($accent-blue, 0.38);\n  background:\n    linear-gradient(135deg, rgba($accent-blue, 0.16), rgba($dark-blue, 0.42) 55%, rgba($dark-blue-grey, 0.72)),\n    rgba($dark-panel-blue, 0.88);\n}\n\n.org-position-apply-panel__emblem {\n  width: 4rem;\n  height: 4rem;\n  padding: 0.6rem;\n  object-fit: contain;\n  border-radius: 50%;\n  box-shadow:\n    0 0 0 1px rgba($light-blue, 0.35),\n    0 0 18px rgba($light-blue, 0.22);\n\n  &--letter {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.65rem;\n    font-weight: 800;\n    color: $pure-white;\n    background: linear-gradient(160deg, rgba($light-blue, 0.45), rgba($accent-blue, 0.85));\n    border: 1px solid rgba($light-blue, 0.45);\n  }\n}\n\n.org-position-apply-panel__leadership-copy {\n  min-width: 0;\n}\n\n.org-position-apply-panel__intro {\n  margin: 0;\n  font-size: 0.86rem;\n  line-height: 1.55;\n  color: rgba($very-light-grey, 0.84);\n\n  &--default {\n    display: flex;\n    flex-direction: column;\n    gap: 0.45rem;\n  }\n\n  &-kicker {\n    margin: 0;\n    font-size: 0.72rem;\n    font-weight: 800;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: $light-blue;\n  }\n\n  &-text {\n    margin: 0;\n    font-size: 0.86rem;\n    line-height: 1.55;\n    color: rgba($very-light-grey, 0.84);\n  }\n\n  &.lexical-rendered-content {\n    h1,\n    h2,\n    h3,\n    h4,\n    strong {\n      margin: 0 0 0.45rem;\n      font-size: 0.72rem;\n      font-weight: 800;\n      letter-spacing: 0.08em;\n      text-transform: uppercase;\n      color: $light-blue;\n    }\n\n    p {\n      margin: 0 0 0.45rem;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n}\n\n.org-position-apply-panel__pillars {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 0.55rem;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.org-position-apply-panel__pillar {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.35rem;\n  text-align: center;\n  min-width: 0;\n}\n\n.org-position-apply-panel__pillar-icon-wrap {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.35rem;\n  height: 2.35rem;\n  border-radius: 10px;\n  border: 1px solid rgba($light-blue, 0.35);\n  background: rgba($dark-blue, 0.45);\n  color: $light-blue;\n}\n\n.org-position-apply-panel__pillar-title {\n  font-size: 0.58rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.88);\n  line-height: 1.25;\n}\n\n.org-position-apply-panel__pillar-sub {\n  font-size: 0.62rem;\n  line-height: 1.35;\n  color: rgba($very-light-grey, 0.55);\n}\n\n.org-position-apply-panel__form {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.org-position-apply-panel__grid {\n  display: grid;\n  grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.8fr);\n  gap: 0.85rem;\n  align-items: stretch;\n  min-height: 0;\n}\n\n.org-position-apply-panel__tips {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  padding: 0.85rem 0.95rem 1.1rem;\n  border-radius: 12px;\n  border: 1px solid rgba($accent-blue, 0.28);\n  background: rgba($dark-blue-grey, 0.35);\n  overflow: hidden;\n}\n\n.org-position-apply-panel__tips-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  margin: 0;\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: $very-light-grey;\n}\n\n.org-position-apply-panel__tips-icon {\n  flex-shrink: 0;\n  color: $light-blue;\n}\n\n.org-position-apply-panel__tips-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.org-position-apply-panel__tips-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  font-size: 0.82rem;\n  line-height: 1.45;\n  color: rgba($very-light-grey, 0.78);\n}\n\n.org-position-apply-panel__tips-check {\n  flex-shrink: 0;\n  margin-top: 0.15rem;\n  color: $light-blue;\n}\n\n.org-position-apply-panel__application {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  min-width: 0;\n}\n\n.org-position-apply-panel__application-title {\n  margin: 0;\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.62);\n}\n\n.org-position-apply-panel__field {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.org-position-apply-panel__textarea-frame {\n  position: relative;\n  flex: 1 1 auto;\n  min-height: 14rem;\n  padding: 0.15rem;\n  border: 1px solid rgba($accent-blue, 0.42);\n  border-radius: 10px;\n  background: rgba($dark-blue, 0.35);\n  box-shadow: inset 0 0 24px rgba($dark-blue, 0.35);\n}\n\n.org-position-apply__motivation {\n  width: stretch;\n  min-height: 13rem;\n  padding: 0.85rem 0.95rem 2rem;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: $very-light-grey;\n  font-family: inherit;\n  font-size: 0.88rem;\n  line-height: 1.55;\n  resize: vertical;\n\n  &:read-only {\n    cursor: default;\n    opacity: 0.92;\n  }\n\n  &::placeholder {\n    color: rgba($very-light-grey, 0.42);\n  }\n\n  &:focus {\n    outline: none;\n  }\n}\n\n.org-position-apply-panel__counter {\n  position: absolute;\n  right: 0.85rem;\n  bottom: 0.55rem;\n  font-size: 0.72rem;\n  color: rgba($very-light-grey, 0.48);\n  pointer-events: none;\n}\n\n.org-position-apply-panel__hint {\n  margin: 0;\n  padding: 0.65rem 0.75rem;\n  border-radius: 8px;\n  border: 1px solid rgba($light-green, 0.35);\n  background: rgba($dark-green, 0.28);\n  color: $very-light-grey;\n  font-size: 0.84rem;\n}\n\n.org-position-apply-panel__error {\n  margin: 0;\n  padding: 0.65rem 0.75rem;\n  border-radius: 8px;\n  border: 1px solid rgba($bright-red, 0.45);\n  background: rgba($dark-red, 0.35);\n  color: $very-light-grey;\n  font-size: 0.84rem;\n}\n\n.org-position-apply-panel__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.85rem;\n  flex-wrap: wrap;\n  padding-top: 0.15rem;\n}\n\n.org-position-apply-panel__privacy {\n  display: inline-flex;\n  align-items: flex-start;\n  gap: 0.45rem;\n  margin: 0;\n  max-width: 26rem;\n  font-size: 0.78rem;\n  line-height: 1.45;\n  color: rgba($very-light-grey, 0.62);\n}\n\n.org-position-apply-panel__privacy-icon {\n  flex-shrink: 0;\n  margin-top: 0.1rem;\n  color: rgba($light-blue, 0.75);\n}\n\n.org-position-apply-panel__privacy-highlight {\n  color: $light-blue;\n  font-weight: 700;\n}\n\n.org-position-apply-panel__actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.65rem;\n  flex-wrap: wrap;\n  margin-left: auto;\n}\n\n.org-position-apply-panel__cancel {\n  padding: 0.62rem 1rem;\n  border: 1px solid rgba($bright-red, 0.45);\n  border-radius: 8px;\n  background: rgba($dark-grey, 0.55);\n  color: rgba($very-light-grey, 0.88);\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;\n\n  &:hover,\n  &:focus-visible {\n    color: $pure-white;\n    border-color: rgba($bright-red, 0.75);\n    background: rgba($dark-red, 0.45);\n  }\n}\n\n.org-position-apply-panel__submit {\n  display: inline-flex;\n  align-items: stretch;\n  padding: 0;\n  border: 1px solid rgba($light-blue, 0.55);\n  border-radius: 8px;\n  background: linear-gradient(180deg, rgba($light-blue, 0.95), rgba($accent-blue, 0.95));\n  color: $pure-white;\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  cursor: pointer;\n  overflow: hidden;\n  transition: filter 0.15s ease, opacity 0.15s ease;\n\n  &:hover:not(:disabled),\n  &:focus-visible:not(:disabled) {\n    filter: brightness(1.08);\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.org-position-apply-panel__submit-label {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.62rem 0.95rem;\n}\n\n.org-position-apply-panel__submit-chevron {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 0.75rem;\n  border-left: 1px solid rgba($pure-white, 0.28);\n}\n\n.org-positions-browse-detail__footer-commander {\n  flex-shrink: 0;\n  margin: 0 1.15rem 1rem;\n  padding: 0.9rem 1rem;\n  border-radius: 12px;\n  border: 1px solid rgba($accent-blue, 0.35);\n  background: rgba($dark-blue-grey, 0.4);\n\n  .org-positions-browse-detail__commander-identity {\n    width: fit-content;\n    max-width: 100%;\n    flex: 0 0 auto;\n  }\n}\n\n.org-positions-browse-detail__footer-commander-label {\n  display: block;\n  margin-bottom: 0.55rem;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: $medium-light-grey;\n}\n\n@media (max-width: 860px) {\n  .org-positions-browse-detail__hero-main {\n    grid-template-columns: auto minmax(0, 1fr);\n  }\n\n  .org-positions-browse-detail__meta,\n  .org-positions-browse-detail__split {\n    grid-template-columns: 1fr;\n  }\n\n  .org-positions-browse-detail__split {\n    overflow: auto;\n    @include factions-reputations-thin-scrollbar;\n  }\n\n  .org-positions-browse-detail__section--list {\n    min-height: 10rem;\n    max-height: 14rem;\n  }\n\n  .org-positions-browse-detail__cta {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .org-position-apply-panel__leadership {\n    grid-template-columns: auto minmax(0, 1fr);\n  }\n\n  .org-position-apply-panel__pillars {\n    grid-column: 1 / -1;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .org-position-apply-panel__grid {\n    grid-template-columns: 1fr;\n  }\n\n  .org-position-apply-panel__footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .org-position-apply-panel__actions {\n    width: 100%;\n    justify-content: stretch;\n  }\n\n  .org-position-apply-panel__cancel,\n  .org-position-apply-panel__submit {\n    flex: 1 1 auto;\n    justify-content: center;\n  }\n}\n","@import './variables.scss';\n\n\n.member-dashboard {\n  margin-top: 65px;\n\n  &.member-dashboard--with-rail {\n    margin-top: 50px;\n  }\n}\n\n$personal-hub-chrome-offset: 100px;\n$personal-hub-rail-width: 72px;\n$personal-hub-rail-gap: 0.65rem;\n\n$personal-hub-viewport-offset: 235px;\n\n.member-dashboard--with-rail {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-height: 0;\n  height: auto;\n  max-height: 100%;\n  margin-top: 0;\n  padding-left: calc(#{$personal-hub-rail-width} + #{$personal-hub-rail-gap});\n  overflow: hidden;\n  overscroll-behavior: contain;\n  scrollbar-width: none;\n}\n\n.member-dashboard__panel {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  width: 100%;\n  min-width: 0;\n  min-height: 0;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.member-dashboard__panel:not(.member-dashboard__panel--hangar) {\n  overflow-y: auto;\n  margin-top: 10px;\n  scrollbar-width: none;\n  max-height: calc(100vh - 225px);\n}\n\n.member-dashboard__panel--hangar {\n  display: flex;\n  flex-direction: column;\n  flex: 0 0 auto;\n  max-height: calc(100vh - 210px);\n  overflow: hidden;\n}\n\n.personal-hub-section {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  min-height: 0;\n  min-width: 0;\n}\n\n.personal-hub-section--inactive {\n  display: none;\n}\n\n.member-dashboard--page-fetching {\n  opacity: 1;\n}\n\n// Rail fixé au viewport — ne bouge pas quand la page ou le panneau scroll\n.personal-hub-rail {\n  position: fixed;\n  top: $personal-hub-chrome-offset;\n  left: unquote(\"max(0.75rem, calc((100vw - #{$full-width}) / 2))\");\n  width: $personal-hub-rail-width;\n  padding: 0.35rem 0;\n  box-sizing: border-box;\n  z-index: 25;\n}\n\n.personal-hub-rail__list {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.65rem;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.personal-hub-rail__item-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  overflow: visible;\n}\n\n.personal-hub-rail__btn {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  margin: 0;\n  padding: 0;\n  border: none;\n  border-radius: 50%;\n  color: rgba($very-light-grey, 0.72);\n  background: rgba(0, 0, 0, 0.22);\n  box-shadow: 0 0 0 1px rgba($accent-blue, 0.72);\n  cursor: pointer;\n  transition:\n    border-radius 0.2s ease,\n    background 0.2s ease,\n    color 0.2s ease,\n    box-shadow 0.2s ease;\n\n  &:hover {\n    border-radius: 12px;\n    color: $very-light-grey;\n    background: rgba($accent-blue, 0.38);\n    box-shadow: 0 0 0 1px rgba($accent-blue, 0.45);\n  }\n\n  &:focus-visible {\n    outline: 2px solid rgba($accent-blue, 0.75);\n    outline-offset: 2px;\n  }\n}\n\n// Discord-style hover label (icon + text, caret pointing at rail button)\n.personal-hub-rail__tooltip {\n  position: absolute;\n  left: calc(100% + 14px);\n  top: 50%;\n  z-index: 40;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  max-width: unquote(\"min(240px, calc(100vw - 120px))\");\n  padding: 0.5rem 0.7rem;\n  //border: 1px solid rgba($red, 0.12);\n  border-radius: 8px;\n  background: rgb(37, 83, 124);\n  color: $pure-white;\n  font-size: 0.875rem;\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: 0.01em;\n  white-space: nowrap;\n  box-shadow: 3px 3px 10px rgba($dark-blue-grey, 0.65);\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transform: translateY(-50%) scale(0.96);\n  transition:\n    opacity 0.12s ease,\n    transform 0.12s ease,\n    visibility 0s linear 0.12s;\n\n  &::before {\n    content: '';\n    position: absolute;\n    left: -5px;\n    top: 50%;\n    width: 0;\n    height: 0;\n    transform: translateY(-50%);\n    border-style: solid;\n    border-width: 5px 6px 5px 0;\n    border-color: transparent #336a8c transparent transparent;\n  }\n}\n\n.personal-hub-rail__tooltip--locked {\n  align-items: flex-start;\n  white-space: normal;\n  width: 200px;\n  text-align: left;\n  \n}\n\n.personal-hub-rail__tooltip-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  min-width: 0;\n}\n\n.personal-hub-rail__tooltip-lock-msg {\n  font-size: 0.75rem;\n  font-weight: 500;\n  line-height: 1.25;\n  //color: rgba($pure-white, 0.78);\n  white-space: normal;\n  color: rgba($light-orange, 1);\n}\n\n.personal-hub-rail__tooltip-icon {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n}\n\n.personal-hub-rail__tooltip-icon-svg {\n  display: block;\n}\n\n.personal-hub-rail__tooltip-label {\n  text-align: left;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.personal-hub-rail__btn:hover .personal-hub-rail__tooltip,\n.personal-hub-rail__btn:focus-visible .personal-hub-rail__tooltip {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(-50%) scale(1);\n  transition:\n    opacity 0.14s ease 0.42s,\n    transform 0.14s ease 0.42s,\n    visibility 0s linear 0.42s;\n}\n\n.personal-hub-rail__btn--active {\n  border-radius: 12px;\n  color: $very-light-grey;\n  background: rgba($accent-blue, 0.55);\n  box-shadow: 0 0 0 1px rgba($light-blue, 0.35);\n}\n\n.personal-hub-rail__btn--locked {\n  cursor: not-allowed;\n  color: rgba($very-light-grey, 0.34);\n  background: rgba(0, 0, 0, 0.12);\n  box-shadow: 0 0 0 1px rgba($medium-grey, 0.55);\n\n  &:hover,\n  &:focus-visible {\n    border-radius: 50%;\n    color: rgba($very-light-grey, 0.34);\n    background: rgba(0, 0, 0, 0.12);\n    box-shadow: 0 0 0 1px rgba($medium-grey, 0.55);\n  }\n}\n\n.personal-hub-rail__icon {\n  display: block;\n  flex-shrink: 0;\n}\n\n// Per-section icon sizes — rail button + tooltip (width/height independently)\n.personal-hub-rail__btn--dashboard {\n  > .personal-hub-rail__icon {\n    width: 26px;\n    height: 26px;\n  }\n\n  .personal-hub-rail__tooltip-icon,\n  .personal-hub-rail__tooltip-icon-svg {\n    width: 1.125rem;\n    height: 1.125rem;\n  }\n}\n\n.personal-hub-rail__btn--hangar {\n  > .personal-hub-rail__icon {\n    width: 28px;\n    height: 28px;\n  }\n\n  .personal-hub-rail__tooltip-icon,\n  .personal-hub-rail__tooltip-icon-svg {\n    width: 1.125rem;\n    height: 1.125rem;\n  }\n}\n\n.personal-hub-rail__btn--factions-reputations {\n  > .personal-hub-rail__icon {\n    width: 40px;\n    height: 40px;\n  }\n\n  .personal-hub-rail__tooltip-icon,\n  .personal-hub-rail__tooltip-icon-svg {\n    width: 1.5rem;\n    height: 1.5rem;\n  }\n}\n\n.personal-hub-rail__btn--blueprints {\n  > .personal-hub-rail__icon {\n    width: 40px;\n    height: 40px;\n  }\n\n  .personal-hub-rail__tooltip-icon,\n  .personal-hub-rail__tooltip-icon-svg {\n    width: 1.5rem;\n    height: 1.5rem;\n  }\n}\n\n.personal-hub-rail__hangar-icon {\n  display: block;\n  flex-shrink: 0;\n  background-color: currentColor;\n  mask-image: url('../medias/personal-hub-hangar-icon.png');\n  mask-size: contain;\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-image: url('../medias/personal-hub-hangar-icon.png');\n  -webkit-mask-size: contain;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n}\n\n.personal-hub-rail__blueprint-icon {\n  display: block;\n  flex-shrink: 0;\n  background-color: currentColor;\n  mask-image: url('../medias/personal-hub-blueprint-icon.png');\n  mask-size: contain;\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-image: url('../medias/personal-hub-blueprint-icon.png');\n  -webkit-mask-size: contain;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n}\n\n.personal-hub-rail__factions-reputations-icon {\n  display: block;\n  flex-shrink: 0;\n  background-color: currentColor;\n  mask-image: url('../medias/personal-hub-blueprint-reputation-icon.png');\n  mask-size: contain;\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-image: url('../medias/personal-hub-blueprint-reputation-icon.png');\n  -webkit-mask-size: contain;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n}\n\n.member-dashboard__layout-root {\n  width: stretch;\n  max-width: stretch;\n}\n\n.member-dashboard__layout-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  width: 100%;\n  margin-bottom: 1rem;\n}\n\n.member-dashboard__layout-hint-card {\n  flex: 1 1 auto;\n  min-width: 0;\n  max-width: max-content;\n  box-sizing: border-box;\n  padding: 0.75rem 1rem;\n  border: 1px solid rgba($accent-blue, 0.35);\n  border-radius: 10px;\n  background:\n    linear-gradient(\n      180deg,\n      rgba($dark-blue, 0.55),\n      rgba($dark-blue-grey, 0.32)\n    ),\n    rgba($dark-blue, 0.45);\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.28);\n}\n\n.member-dashboard__layout-hint-text {\n  margin: 0;\n  font-family: \"Lato\", sans-serif;\n  font-size: 0.85rem;\n  line-height: 1.45;\n  color: rgba($very-light-grey, 0.88);\n}\n\n.member-dashboard__layout-reset-btn {\n  flex: 0 0 auto;\n  border: 1px solid rgba($accent-blue, 0.45);\n  border-radius: 10px;\n  padding: 0.65rem 1rem;\n  font-family: \"Lato\", sans-serif;\n  font-size: 0.82rem;\n  font-weight: 650;\n  letter-spacing: 0.02em;\n  color: rgba($very-light-grey, 0.92);\n  background: rgba(0, 0, 0, 0.22);\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n\n  &:hover {\n    background: rgba($accent-blue, 0.14);\n    border-color: rgba($accent-blue, 0.55);\n    color: rgba($very-light-grey, 0.98);\n  }\n\n  &:focus-visible {\n    outline: 2px solid rgba($accent-blue, 0.65);\n    outline-offset: 2px;\n  }\n}\n\n.member-dashboard__grid {\n  width: 100%;\n  max-width: 100%;\n  position: relative;\n}\n\n.member-dashboard__grid-layout {\n  width: 100%;\n}\n\n.member-dashboard__grid-item {\n  box-sizing: border-box;\n}\n\n.member-dashboard__grid-item-body {\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  overflow: hidden;\n\n  > .member-dashboard__hero,\n  > .member-dashboard__panel-card,\n  > .member-dashboard__gameloop-card {\n    @include member-dashboard-card-shell;\n  }\n}\n\n.member-dashboard__panel-card-head {\n  flex-shrink: 0;\n}\n\n.member-dashboard__panel-card-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  @include member-dashboard-thin-scrollbar;\n}\n\n.member-dashboard__grid-item-body--expanded {\n  overflow: hidden;\n  height: 100%;\n  min-height: 0;\n\n  > .member-dashboard__gameloop-card {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    height: auto;\n    min-height: 100%;\n    max-height: none;\n    overflow: visible;\n  }\n\n  .member-dashboard__structure-block {\n    flex: 0 0 auto;\n    width: 100%;\n    min-height: 0;\n  }\n\n  .member-dashboard__structure-block-body {\n    overflow: visible;\n    flex: 0 0 auto;\n    min-height: 0;\n    max-height: none;\n    margin-right: 0;\n    padding-right: 0;\n  }\n\n  .member-dashboard__gameloop-tags-section {\n    flex: 0 0 auto;\n    width: 100%;\n    min-height: 0;\n  }\n\n  .member-dashboard__panel-card-body,\n  .member-dashboard__gameloop-tags-body {\n    overflow: visible;\n    flex: 0 0 auto;\n    min-height: 0;\n    max-height: none;\n    margin-right: 0;\n    padding-right: 0;\n  }\n}\n\n.member-dashboard__grid-item--expanded {\n  z-index: 2;\n  overflow: hidden;\n}\n\n.member-dashboard__grid {\n  .react-grid-item {\n    z-index: 0;\n    transition: box-shadow 0.2s ease;\n\n    &.react-draggable-dragging {\n      z-index: 10;\n    }\n\n    &.resizing {\n      z-index: 10;\n    }\n  }\n\n  .react-grid-placeholder {\n    background: rgba($accent-blue, 0.18) !important;\n    border: 1px dashed rgba($accent-blue, 0.55) !important;\n    border-radius: 12px !important;\n    opacity: 0.85 !important;\n  }\n\n  .react-grid-item > .react-resizable-handle {\n    z-index: 5;\n    opacity: 0.45;\n    transition: opacity 0.2s ease;\n\n    &::after {\n      border-right: 2px solid rgba($accent-blue, 0.85) !important;\n      border-bottom: 2px solid rgba($accent-blue, 0.85) !important;\n    }\n  }\n\n  .react-grid-item:hover > .react-resizable-handle,\n  .react-grid-item.resizing > .react-resizable-handle {\n    opacity: 1;\n  }\n}\n\n.member-dashboard__top {\n  display: grid;\n  grid-template-columns: minmax(620px, 720px) auto;\n  gap: 1rem;\n  align-items: start;\n  justify-content: start;\n  max-width: 100%;\n}\n\n.member-dashboard__aside-cluster {\n  grid-column: 2;\n  grid-row: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 1rem;\n  min-width: 0;\n}\n\n.member-dashboard__aside-bottom-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  width: 100%;\n  min-width: 0;\n}\n\n.member-dashboard__aside-bottom-row > .member-dashboard__rank-history-card,\n.member-dashboard__aside-bottom-row > .member-dashboard__history-card {\n  box-sizing: border-box;\n  flex: 1 1 0;\n  width: 50%;\n  max-width: 50%;\n  min-width: 0;\n}\n\n.member-dashboard__main-column {\n  grid-column: 1;\n  grid-row: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 1rem;\n  min-width: 0;\n}\n\n// Dashboard Hero\n.member-dashboard__hero {\n  position: relative;\n  align-self: start;\n  width: 100%;\n  min-width: 0;\n  height: auto;\n  box-sizing: border-box;\n  background:\n    linear-gradient(180deg, rgba($dark-blue, 0.72), rgba($dark-blue-grey, 0.42)),\n    rgba($dark-blue, 0.55);\n  border: 1px solid rgba($accent-blue, 0.55);\n  border-radius: 12px;\n  padding: 1rem 1rem;\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.35),\n    0 12px 28px rgba(0, 0, 0, 0.35);\n}\n\n.member-dashboard__donor-chip {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  z-index: 3;\n  gap: 7px;\n  padding: 5px 11px 5px 8px;\n  border-radius: 10px;\n  border: 1px solid transparent;\n\n  .donor-gem-badge__wrap {\n    width: 16px;\n    height: 16px;\n  }\n\n  .donor-gem-badge__gem {\n    width: 16px;\n    height: 16px;\n  }\n\n  .donor-gem-badge__label {\n    font-size: 13px;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    line-height: 1.2;\n  }\n\n  &:has(.donor-gem-badge__wrap--one-time) {\n    border-color: rgba($accent-blue, 0.35);\n    background: rgba($accent-blue, 0.12);\n    color: $accent-blue;\n\n    .donor-gem-badge__label {\n      color: $accent-blue;\n    }\n  }\n\n  &:has(.donor-gem-badge__wrap--subscriber) {\n    border-color: rgba($light-purple, 0.35);\n    background: rgba($light-purple, 0.12);\n    color: $light-purple;\n\n    .donor-gem-badge__label {\n      color: $light-purple;\n    }\n  }\n\n  &:has(.donor-gem-badge__wrap--premium) {\n    border-color: rgba($donor-gold, 0.4);\n    background: rgba($donor-gold, 0.12);\n    color: $donor-gold;\n\n    .donor-gem-badge__label {\n      color: $donor-gold-light;\n    }\n  }\n\n  &:has(.donor-gem-badge__wrap--inactive) {\n    border-color: rgba($medium-light-grey, 0.35);\n    background: rgba($medium-light-grey, 0.1);\n    color: $medium-light-grey;\n\n    .donor-gem-badge__label {\n      color: $medium-light-grey;\n    }\n  }\n}\n\n.member-dashboard__hero-inner {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  gap: 1rem;\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.member-dashboard__identity {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  flex: 0 0 25%;\n  min-width: 0;\n  flex-shrink: 0;\n}\n\n.member-dashboard__avatar-stack {\n  position: relative;\n  width: 120px;\n  height: 120px;\n  flex-shrink: 0;\n  margin-bottom: 0.75rem;\n}\n\n.member-dashboard__avatar-discord {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: auto;\n  height: 100px;\n  border-radius: 50%;\n  object-fit: cover;\n  z-index: 1;\n}\n\n.member-dashboard__avatar-frame {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 120px;\n  height: 120px;\n  object-fit: contain;\n  z-index: 2;\n  pointer-events: none;\n}\n\n.member-dashboard__avatar-ring {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  border: 3px solid $light-blue;\n  box-sizing: border-box;\n  z-index: 2;\n  pointer-events: none;\n}\n\n.member-dashboard__avatar-halo {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 105px;\n  height: 105px;\n  border-radius: 50%;\n  z-index: 0;\n  pointer-events: none;\n}\n\n.member-dashboard__avatar-color-picker {\n  position: absolute;\n  right: -25px;\n  top: 0px;\n  z-index: 4;\n}\n\n.member-dashboard__avatar-color-picker__trigger {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n\n  .color-picker-container {\n    margin: 0;\n  }\n\n  .color-picker-flex {\n    margin: 0;\n  }\n\n  .colorPicker {\n    width: 17px;\n    height: 17px;\n    min-width: 17px;\n    min-height: 17px;\n    border-radius: 50%;\n    border: 2px solid rgba($pure-white, 0.85);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.45);\n    cursor: pointer;\n  }\n\n  &:hover,\n  &:focus-within {\n    .member-dashboard__avatar-color-picker__tooltip {\n      opacity: 1;\n      visibility: visible;\n      transform: translateY(-40%);\n    }\n  }\n}\n\n.member-dashboard__avatar-color-picker__tooltip {\n  position: absolute;\n  left: calc(100% + 8px);\n  top: 50%;\n  transform: translateY(calc(-50% - 2px));\n  z-index: 6;\n  padding: 5px 9px;\n  border-radius: 8px;\n  border: 1px solid $accent-blue;\n  background: $panel-blue;\n  font-family: 'Lato', sans-serif;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  line-height: 1.2;\n  white-space: nowrap;\n  pointer-events: none;\n  color: rgba($very-light-grey, 0.95);\n  opacity: 0;\n  visibility: hidden;\n  transition:\n    opacity 0.15s ease,\n    visibility 0.15s ease,\n    transform 0.15s ease;\n  box-shadow:\n    0 8px 22px rgba(0, 0, 0, 0.45),\n    0 0 0 1px rgba(0, 0, 0, 0.18);\n}\n\n.member-dashboard__moniker {\n  font-family: 'GoodTimes', 'Lato', sans-serif;\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: $pure-white;\n  line-height: 1.25;\n  margin: 0 0 0.35rem;\n  word-break: break-word;\n}\n\n.member-dashboard__subline {\n  margin: 0.15rem 0 0;\n  font-size: 0.8rem;\n  color: rgba($very-light-grey, 0.88);\n  line-height: 1.35;\n}\n\n.member-dashboard__subline-label {\n  display: block;\n  font-size: 0.62rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: $medium-light-grey;\n  margin-bottom: 0.1rem;\n}\n\n.member-dashboard__subline-value {\n  color: rgba($light-blue, 0.95);\n  word-break: break-word;\n}\n\n.member-dashboard__assignment {\n  margin: 0.35rem 0 0;\n  font-size: 0.95rem;\n  line-height: 1.3;\n  color: rgba($light-blue, 1);\n  font-style: italic;\n}\n\n.member-dashboard__divider {\n  width: 1px;\n  flex-shrink: 0;\n  background: linear-gradient(\n    180deg,\n    transparent 0%,\n    rgba($accent-blue, 0.55) 15%,\n    rgba($accent-blue, 0.55) 85%,\n    transparent 100%\n  );\n}\n\n.member-dashboard__meta {\n  flex: 1;\n  min-width: 0;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  @include member-dashboard-thin-scrollbar;\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.member-dashboard__rank-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.member-dashboard__rank-icon-slot {\n  flex-shrink: 0;\n  //width: 85px;\n  height: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.member-dashboard__rank-icon {\n  max-width: auto;\n  max-height: 60px;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.45));\n}\n\n.member-dashboard__rank-icon--empty {\n  width: 48px;\n  height: 56px;\n  border: 1px dashed rgba($accent-blue, 0.35);\n  border-radius: 4px;\n  //background: rgba(0, 0, 0, 0.2);\n}\n\n.member-dashboard__rank-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.member-dashboard__rank-eyebrow {\n  font-size: 0.62rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: $medium-light-grey;\n  margin: 0 0 0.2rem;\n}\n\n.member-dashboard__rank-name {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: $pure-white;\n  margin: 0 0 0.15rem;\n  line-height: 1.2;\n  word-break: break-word;\n}\n\n.member-dashboard__pay-grade {\n  margin: 0;\n  font-size: 0.78rem;\n  color: rgba($very-light-grey, 0.85);\n}\n\n.member-dashboard__org-sep {\n  height: 1px;\n  width: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba($accent-blue, 0.4) 10%,\n    rgba($accent-blue, 0.4) 90%,\n    transparent\n  );\n}\n\n.member-dashboard__org-row {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  gap: 0;\n  width: 100%;\n}\n\n.member-dashboard__org-segment {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  flex: 1 1 0;\n  min-width: 0;\n  gap: 0.5rem;\n  padding: 0 0.25rem;\n}\n\n.member-dashboard__org-icon-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  min-height: 44px;\n}\n\n.member-dashboard__org-vrule {\n  flex-shrink: 0;\n  width: 1px;\n  align-self: stretch;\n  min-height: 3rem;\n  margin: 0 0.15rem;\n  background: linear-gradient(\n    180deg,\n    transparent 0%,\n    rgba($light-green, 0.2) 12%,\n    rgba($green, 0.55) 50%,\n    rgba($light-green, 0.2) 88%,\n    transparent 100%\n  );\n}\n\n.member-dashboard__org-icon {\n  width: 55px;\n  height: 55px;\n  object-fit: contain;\n  flex-shrink: 0;\n  border-radius: 3px;\n}\n\n.member-dashboard__org-icon--placeholder {\n  display: block;\n  width: 55px;\n  height: 55px;\n  box-sizing: border-box;\n  //border: 1px solid rgba($light-green, 0.35);\n  border-radius: 3px;\n  //background: rgba(0, 0, 0, 0.15);\n}\n\n.member-dashboard__org-text {\n  min-width: 0;\n  width: 100%;\n}\n\n.member-dashboard__org-label {\n  display: block;\n  font-size: 0.58rem;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: $medium-light-grey;\n  margin-bottom: 0.08rem;\n}\n\n.member-dashboard__org-value {\n  font-size: 0.82rem;\n  color: $pure-white;\n  word-break: break-word;\n}\n\n.member-dashboard__org-segment--token .member-dashboard__org-label {\n  margin-bottom: 0.2rem;\n}\n\n.member-dashboard__org-value--token {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.15rem;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  line-height: 1.2;\n}\n\n.member-dashboard__org-segment--token-no-icon {\n  justify-content: center;\n  align-self: center;\n  gap: 0.35rem;\n}\n\n.member-dashboard__org-segment--token-no-icon .member-dashboard__org-label {\n  margin-bottom: 0.25rem;\n  font-size: 0.62rem;\n}\n\n.member-dashboard__org-segment--token-no-icon .member-dashboard__org-value--token {\n  font-size: 1.85rem;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.member-dashboard__state {\n  margin-top: 0.75rem;\n  font-size: 0.85rem;\n  color: $light-grey;\n}\n\n.member-dashboard__state--error {\n  color: $light-orange;\n}\n\n// Shared dashboard panel cards (activity, trainings, …)\n.member-dashboard__panel-card {\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n  padding: 1rem 1.1rem;\n  border: 1px solid rgba($accent-blue, 0.45);\n  border-radius: 12px;\n  background:\n    linear-gradient(\n      180deg,\n      rgba($dark-blue, 0.72),\n      rgba($dark-blue-grey, 0.42)\n    ),\n    rgba($dark-blue, 0.55);\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.35),\n    0 12px 28px rgba(0, 0, 0, 0.35);\n}\n\n.member-dashboard__panel-title {\n  margin: 0 0 15px;\n  font-family: \"GoodTimes\", \"Lato\", sans-serif;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.88);\n}\n\n// Activity / Events by name — title + year select on one row (fixed header)\n.member-dashboard__activity-card-head,\n.member-dashboard__events-card-head {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  column-gap: 0.75rem;\n  align-items: center;\n  margin-bottom: 15px;\n\n  .member-dashboard__panel-title {\n    margin: 0;\n  }\n\n  .member-dashboard__chart-toolbar {\n    margin: 0;\n  }\n}\n\n// Ribbons — title + progression button on one row (fixed header)\n.member-dashboard__ribbons-card-head {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  column-gap: 0.75rem;\n  align-items: center;\n  margin-bottom: 12px;\n\n  .member-dashboard__panel-title {\n    margin: 0;\n  }\n\n  .member-dashboard__ribbons-toolbar {\n    margin: 0;\n  }\n}\n\n.member-dashboard__panel-placeholder {\n  margin: 0;\n  font-size: 0.85rem;\n  color: rgba($very-light-grey, 0.75);\n}\n\n// Dashboard charts (data same as roster file; styles independent of roster-file-*)\n\n.member-dashboard__chart-subtitle {\n  margin: -8px 0 12px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.62);\n}\n\n.member-dashboard__chart-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  margin: 0;\n}\n\n.member-dashboard__chart-toolbar-label {\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.62);\n}\n\n.member-dashboard__chart-year-select {\n  min-width: 5.5rem;\n  padding: 0.35rem 0.65rem;\n  border: 1px solid rgba($accent-blue, 0.45);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 0.82rem;\n  color: $very-light-grey;\n  background: rgba($dark-blue, 0.65);\n  cursor: pointer;\n\n  &:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n  }\n\n  &:focus-visible {\n    outline: 2px solid rgba($accent-blue, 0.65);\n    outline-offset: 2px;\n  }\n}\n\n.member-dashboard__chart {\n  position: relative;\n  width: 100%;\n  min-height: 0;\n}\n\n.member-dashboard__chart--line {\n  min-height: 0;\n}\n\n.member-dashboard__activity-card {\n  > .member-dashboard__panel-card-body {\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    overflow: hidden;\n  }\n\n  .member-dashboard__chart--line {\n    flex: 1 1 auto;\n    min-height: 8rem;\n    height: 100%;\n  }\n}\n\n.member-dashboard__events-bars {\n  box-sizing: border-box;\n  overflow: visible;\n}\n\n.member-dashboard__events-bars-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.member-dashboard__events-bar-row {\n  display: grid;\n  grid-template-columns: minmax(0, 30%) 1fr 1.75rem;\n  align-items: center;\n  gap: 0.5rem;\n  height: 17px;\n  margin: 0 0 10px;\n  padding: 0;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.member-dashboard__events-bar-label {\n  overflow: hidden;\n  font-family: \"Lato\", sans-serif;\n  font-size: 12px;\n  line-height: 15px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  color: rgba($very-light-grey, 0.88);\n}\n\n.member-dashboard__events-bar-count {\n  font-family: \"Lato\", sans-serif;\n  font-size: 11px;\n  line-height: 15px;\n  text-align: right;\n  color: rgba($very-light-grey, 0.72);\n}\n\n.member-dashboard__events-bar-meter {\n  display: block;\n  width: 100%;\n  height: 15px;\n  margin: 0;\n  border: none;\n  border-radius: 2px;\n  background: rgba(0, 0, 0, 0.12);\n  appearance: none;\n}\n\n.member-dashboard__events-bar-meter::-webkit-meter-bar {\n  height: 15px;\n  border: none;\n  border-radius: 2px;\n  background: rgba(0, 0, 0, 0.12);\n}\n\n.member-dashboard__events-bar-meter::-webkit-meter-optimum-value {\n  height: 15px;\n  border: 1px solid rgba($accent-blue, 0.85);\n  border-radius: 2px;\n  background: rgba($accent-blue, 0.55);\n  box-sizing: border-box;\n}\n\n.member-dashboard__events-bar-meter::-moz-meter-bar {\n  height: 15px;\n  border: none;\n  border-radius: 2px;\n  background: rgba(0, 0, 0, 0.12);\n}\n\n.member-dashboard__events-bar-meter::-moz-meter-optimum::-moz-meter-bar {\n  height: 15px;\n  border-radius: 2px;\n  background: rgba($accent-blue, 0.55);\n  border: 1px solid rgba($accent-blue, 0.85);\n  box-sizing: border-box;\n}\n\n.member-dashboard__events-bars-axis {\n  margin: 8px 0 0;\n  padding: 0 1.75rem 0 38%;\n  font-family: \"Lato\", sans-serif;\n  font-size: 11px;\n  text-align: center;\n  color: rgba($very-light-grey, 0.62);\n}\n\n// Rank progression timeline (userRankHistory)\n\n.member-dashboard__rank-timeline-viewport {\n  overflow: visible;\n}\n\n.member-dashboard__rank-timeline {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.member-dashboard__rank-timeline-item {\n  display: grid;\n  grid-template-columns: 1.1rem 1fr;\n  gap: 0.65rem;\n  padding-bottom: 0.85rem;\n\n  &--last {\n    padding-bottom: 0;\n  }\n\n  &--upcoming {\n    margin-bottom: 15px;\n\n    .member-dashboard__rank-timeline-content {\n      display: block;\n    }\n  }\n}\n\n.member-dashboard__rank-timeline-rail {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-height: 100%;\n}\n\n.member-dashboard__rank-timeline-dot {\n  flex-shrink: 0;\n  width: 0.55rem;\n  height: 0.55rem;\n  margin-top: 0.45rem;\n  border-radius: 50%;\n  background: rgba($accent-blue, 0.9);\n  box-shadow: 0 0 0 2px rgba($accent-blue, 0.25);\n}\n\n.member-dashboard__rank-timeline-line {\n  flex: 1 1 auto;\n  width: 2px;\n  min-height: 2rem;\n  margin-bottom: -20px;\n  border-radius: 999px;\n  background: rgba($accent-blue, 0.35);\n}\n\n.member-dashboard__rank-timeline-line--dashed {\n  background: none;\n  width: 0;\n  border-left: 2px dashed rgba($very-light-grey, 0.38);\n  border-radius: 0;\n}\n\n.member-dashboard__rank-timeline-content {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n  min-width: 0;\n}\n\n.member-dashboard__rank-timeline-icon-slot {\n  flex-shrink: 0;\n  width: 2rem;\n  height: 2rem;\n}\n\n.member-dashboard__rank-timeline-icon {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n  object-fit: contain;\n}\n\n.member-dashboard__rank-timeline-icon--empty {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 4px;\n  background: rgba($accent-blue, 0.15);\n}\n\n.member-dashboard__rank-timeline-text {\n  min-width: 0;\n  padding-top: 0.1rem;\n}\n\n.member-dashboard__rank-timeline-rank {\n  margin: 0;\n  font-family: \"Lato\", sans-serif;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.35;\n  color: $very-light-grey;\n}\n\n.member-dashboard__rank-timeline-rank--chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 8px;\n  border: 1px solid rgba($red, 0.05);\n  border-radius: 8px;\n  background: rgba($blue-grey, 0.05);\n}\n\n.member-dashboard__rank-timeline-rank--rank-tinted[data-chip-bg] {\n  position: relative;\n  isolation: isolate;\n  background: transparent;\n  color: $very-light-grey;\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    border-radius: inherit;\n    z-index: 0;\n    pointer-events: none;\n    opacity: 0.1;\n  }\n}\n\n.member-dashboard__rank-timeline-date {\n  margin: 0.2rem 0 0;\n  font-family: \"Lato\", sans-serif;\n  font-size: 11px;\n  line-height: 1.35;\n  color: rgba($very-light-grey, 0.62);\n}\n\n.member-dashboard__rank-timeline-date-since {\n  color: $light-blue;\n  font-style: italic;\n}\n\n.member-dashboard__rank-timeline-item--current {\n  .member-dashboard__rank-timeline-dot {\n    width: 0.65rem;\n    height: 0.65rem;\n    background: $light-blue;\n    box-shadow:\n      0 0 0 2px rgba($light-blue, 0.35),\n      0 0 10px rgba($light-blue, 0.45);\n  }\n}\n\n.member-dashboard__rank-timeline-source {\n  color: rgba($very-light-grey, 0.5);\n}\n\n.member-dashboard__rank-timeline-item--upcoming {\n  .member-dashboard__rank-timeline-dot {\n    background: rgba($very-light-grey, 0.28);\n    box-shadow: none;\n  }\n\n  .member-dashboard__rank-timeline-icon,\n  .member-dashboard__rank-timeline-icon--empty {\n    opacity: 0.8;\n    filter: grayscale(0.5);\n  }\n}\n\n.member-dashboard__rank-timeline-rank--upcoming {\n  margin: 0;\n  color: rgba($very-light-grey, 0.7);\n  font-weight: 500;\n}\n\n.member-dashboard__rank-upcoming-frame {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 0.55rem 0.65rem;\n  border: 1px solid rgba($accent-blue, 0.4);\n  border-radius: 10px;\n  background: rgba($dark-blue, 0.35);\n}\n\n.member-dashboard__rank-upcoming-frame__title {\n  margin: 0 0 0.45rem;\n  font-family: \"GoodTimes\", \"Lato\", sans-serif;\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.72);\n}\n\n.member-dashboard__rank-upcoming-frame__body {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n  min-width: 0;\n}\n\n.member-dashboard__rank-upcoming-frame__body .member-dashboard__rank-timeline-text {\n  flex: 1;\n  min-width: 0;\n  padding-top: 0;\n}\n\n.member-dashboard__rank-upcoming-courses {\n  margin-top: 0.55rem;\n  width: 100%;\n}\n\n.member-dashboard__rank-upcoming-courses__title {\n  margin: 0 0 0.35rem;\n  font-family: \"Lato\", sans-serif;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.72);\n}\n\n.member-dashboard__rank-upcoming-courses-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n\n  li {\n    margin: 0.2rem 0 0;\n    font-family: \"Lato\", sans-serif;\n    font-size: 11px;\n    line-height: 1.35;\n    color: rgba($very-light-grey, 0.88);\n\n    &:first-child {\n      margin-top: 0;\n    }\n  }\n}\n\n.member-dashboard__rank-upcoming-courses-item--met {\n  color: rgba($very-light-grey, 0.28);\n}\n\n.member-dashboard__rank-upcoming-token-bars {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0.4rem;\n  margin-top: 0.55rem;\n  width: 100%;\n}\n\n.member-dashboard__rank-token-bar {\n  width: 100%;\n  min-width: 0;\n}\n\n.member-dashboard__rank-token-bar__track {\n  position: relative;\n  box-sizing: border-box;\n  width: 100%;\n  height: 1.2rem;\n  border-radius: 999px;\n  overflow: hidden;\n  background: rgba(0, 0, 0, 0.42);\n  border: 1px solid rgba($very-light-grey, 0.12);\n  cursor: default;\n  transition:\n    opacity 0.2s ease,\n    box-shadow 0.2s ease,\n    border-color 0.2s ease;\n}\n\n.member-dashboard__rank-token-bar__fill {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: calc(var(--fill-pct, 0) * 1%);\n  border-radius: inherit;\n  transition: width 0.25s ease;\n\n  @for $i from 0 through 100 {\n    &[data-fill-pct=\"#{$i}\"] {\n      --fill-pct: #{$i};\n    }\n  }\n}\n\n.member-dashboard__rank-token-bar__label {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  height: 100%;\n  padding: 0 0.5rem;\n  text-align: center;\n  white-space: nowrap;\n  pointer-events: none;\n}\n\n.member-dashboard__rank-token-bar__counts {\n  font-family: \"Lato\", sans-serif;\n  font-size: 0.62rem;\n  font-weight: 700;\n  line-height: 1.1;\n  letter-spacing: 0.02em;\n  color: $pure-white;\n  text-shadow:\n    0 0 6px rgba(0, 0, 0, 0.85),\n    0 1px 2px rgba(0, 0, 0, 0.9);\n}\n\n.member-dashboard__rank-token-bar__type {\n  font-family: \"Lato\", sans-serif;\n  font-size: 0.62rem;\n  font-weight: 600;\n  line-height: 1.1;\n  letter-spacing: 0.03em;\n  text-transform: lowercase;\n  color: rgba($very-light-grey, 0.92);\n  text-shadow:\n    0 0 5px rgba(0, 0, 0, 0.8),\n    0 1px 2px rgba(0, 0, 0, 0.85);\n}\n\n// Incomplete: attenuated track/fill only — label keeps full contrast.\n.member-dashboard__rank-token-bar--mission:not(.member-dashboard__rank-token-bar--complete) {\n  .member-dashboard__rank-token-bar__track {\n    border-color: rgba($very-light-grey, 0.14);\n    box-shadow: none;\n    background: rgba(0, 0, 0, 0.5);\n  }\n\n  .member-dashboard__rank-token-bar__fill {\n    background: linear-gradient(\n      90deg,\n      rgba($orange, 0.42),\n      rgba($light-orange, 0.32)\n    );\n  }\n}\n\n.member-dashboard__rank-token-bar--total:not(.member-dashboard__rank-token-bar--complete) {\n  .member-dashboard__rank-token-bar__track {\n    border-color: rgba($light-blue, 0.28);\n    box-shadow: none;\n    background: rgba($blue-grey, 0.85);\n  }\n\n  .member-dashboard__rank-token-bar__fill {\n    background: linear-gradient(\n      90deg,\n      rgba($accent-blue, 0.95),\n      rgba($light-blue, 0.78)\n    );\n  }\n}\n\n// Complete: full color + glow.\n.member-dashboard__rank-token-bar--mission.member-dashboard__rank-token-bar--complete {\n  .member-dashboard__rank-token-bar__track {\n    border-color: rgba($light-orange, 0.38);\n    box-shadow:\n      0 0 6px rgba($light-orange, 0.32),\n      0 0 12px rgba($orange, 0.2);\n  }\n\n  .member-dashboard__rank-token-bar__fill {\n    width: 100%;\n    background: linear-gradient(90deg, $orange, $light-orange);\n  }\n}\n\n.member-dashboard__rank-token-bar--total.member-dashboard__rank-token-bar--complete {\n  .member-dashboard__rank-token-bar__track {\n    border-color: rgba($light-blue, 0.38);\n    box-shadow:\n      0 0 6px rgba($light-blue, 0.32),\n      0 0 12px rgba($accent-blue, 0.22);\n  }\n\n  .member-dashboard__rank-token-bar__fill {\n    width: 100%;\n    background: linear-gradient(90deg, $blue, $light-blue);\n  }\n}\n\n.member-dashboard__rank-token-bar--time:not(.member-dashboard__rank-token-bar--complete) {\n  .member-dashboard__rank-token-bar__track {\n    border-color: rgba($light-purple, 0.28);\n    box-shadow: none;\n    background: rgba($very-dark-purple, 0.55);\n  }\n\n  .member-dashboard__rank-token-bar__fill {\n    background: linear-gradient(\n      90deg,\n      rgba($dark-purple, 0.9),\n      rgba($light-purple, 0.72)\n    );\n  }\n}\n\n.member-dashboard__rank-token-bar--time.member-dashboard__rank-token-bar--complete {\n  .member-dashboard__rank-token-bar__track {\n    border-color: rgba($light-purple, 0.38);\n    box-shadow:\n      0 0 6px rgba($light-purple, 0.3),\n      0 0 12px rgba($very-light-purple, 0.18);\n  }\n\n  .member-dashboard__rank-token-bar__fill {\n    width: 100%;\n    background: linear-gradient(90deg, $dark-purple, $light-purple);\n  }\n}\n\n.member-dashboard__rank-upcoming-head {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  min-width: 0;\n}\n\n.member-dashboard__rank-upcoming-info {\n  position: relative;\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n.member-dashboard__rank-upcoming-info__btn {\n  width: 16px;\n  height: 16px;\n  padding: 0;\n  border-radius: 999px;\n  border: 1px solid rgba($accent-blue, 0.38);\n  background: rgba(0, 0, 0, 0.35);\n  color: rgba($very-light-grey, 0.88);\n  font-family: \"Lato\", sans-serif;\n  font-size: 10px;\n  font-weight: 700;\n  font-style: italic;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n\n  &:hover {\n    background: rgba($accent-blue, 0.16);\n    border-color: rgba($accent-blue, 0.55);\n  }\n}\n\n.member-dashboard__rank-upcoming-info__tooltip {\n  position: absolute;\n  right: 0;\n  top: calc(100% + 6px);\n  z-index: 6;\n  min-width: 200px;\n  max-width: 260px;\n  padding: 0.55rem 0.65rem;\n  border-radius: 10px;\n  border: 1px solid rgba($accent-blue, 0.28);\n  background: rgba(8, 14, 20, 0.94);\n  box-shadow:\n    0 8px 22px rgba(0, 0, 0, 0.55),\n    0 0 0 1px rgba(0, 0, 0, 0.22);\n}\n\n.member-dashboard__rank-timeline-requirements {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n\n  li {\n    margin: 0.2rem 0 0;\n    font-family: \"Lato\", sans-serif;\n    font-size: 10px;\n    line-height: 1.4;\n    color: rgba($very-light-grey, 0.75);\n\n    &:first-child {\n      margin-top: 0;\n    }\n  }\n}\n\n.member-dashboard__rank-timeline-requirements-item--met {\n  color: rgba($very-light-grey, 0.28);\n}\n\n.member-dashboard__rank-history-footnote {\n  margin: 0.85rem 0 0;\n  padding-top: 0.75rem;\n  border-top: 1px solid rgba($accent-blue, 0.2);\n  font-family: \"Lato\", sans-serif;\n  font-size: 0.82rem;\n  line-height: 1.45;\n  color: $light-orange;\n}\n\n.member-dashboard__chart-scroll {\n  overflow-y: auto;\n  overflow-x: hidden;\n  min-height: 0;\n  @include member-dashboard-thin-scrollbar;\n}\n\n// Trainings — title + category filters on one row (fixed header)\n.member-dashboard__trainings-card-head {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  column-gap: 0.75rem;\n  align-items: center;\n  margin-bottom: 15px;\n\n  .member-dashboard__panel-title {\n    margin: 0;\n  }\n}\n\n.member-dashboard__trainings-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.member-dashboard__trainings-filter-btn {\n  border: 1px solid rgba($accent-blue, 0.28);\n  background: rgba(0, 0, 0, 0.18);\n  color: rgba($very-light-grey, 0.92);\n  border-radius: 10px;\n  padding: 8px 10px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 650;\n  letter-spacing: 0.02em;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n\n  &:hover {\n    background: rgba($accent-blue, 0.14);\n    border-color: rgba($accent-blue, 0.55);\n    color: rgba($very-light-grey, 0.98);\n  }\n\n  &--active {\n    background: rgba($accent-blue, 0.22);\n    border-color: rgba($accent-blue, 0.65);\n    color: rgba($very-light-grey, 0.98);\n  }\n}\n\n// Dashboard trainings list\n\n.member-dashboard__trainings {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n}\n\n.member-dashboard__trainings--single-col {\n  grid-template-columns: 1fr;\n}\n\n.member-dashboard__trainings-card--stacked .member-dashboard__trainings {\n  grid-template-columns: 1fr;\n}\n\n.member-dashboard__trainings-heading {\n  margin: 0 0 10px;\n  font-size: 0.72rem;\n  font-weight: 650;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.9);\n}\n\n.member-dashboard__training-line {\n  position: relative;\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  margin-bottom: 14px;\n  padding: 12px 14px;\n  overflow: hidden;\n  border: 1px solid rgba($accent-blue, 0.35);\n  border-radius: 10px;\n  background: linear-gradient(145deg, $panel-blue, $dark-panel-blue);\n\n  .basic-icon {\n    flex-shrink: 0;\n    width: 22px;\n    height: 22px;\n    margin-top: 2px;\n    object-fit: contain;\n    opacity: 0.85;\n  }\n\n  .basic-icon.certified {\n    opacity: 0.9;\n  }\n\n  strong {\n    display: block;\n    margin-bottom: 4px;\n    font-size: 0.88rem;\n    color: $light-blue;\n  }\n}\n\n.member-dashboard__training-line-body {\n  flex: 1;\n  min-width: 0;\n}\n\n.member-dashboard__training-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  font-size: 0.7rem;\n  color: $light-grey;\n}\n\n@media (max-width: 720px) {\n  .member-dashboard__trainings {\n    grid-template-columns: 1fr;\n  }\n}\n\n// Gameloop tags card (includes structure strip / Assignment above Interest tags)\n\n.member-dashboard__gameloop-card {\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n  margin-top: 0;\n  padding: 1rem 1.1rem;\n  border: 1px solid rgba($accent-blue, 0.45);\n  border-radius: 12px;\n  background:\n    linear-gradient(\n      180deg,\n      rgba($dark-blue, 0.72),\n      rgba($dark-blue-grey, 0.42)\n    ),\n    rgba($dark-blue, 0.55);\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.35),\n    0 12px 28px rgba(0, 0, 0, 0.35);\n}\n\n.member-dashboard__gameloop-card--expanded {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  height: auto;\n  min-height: 100%;\n  max-height: none;\n  overflow: visible;\n\n  .member-dashboard__structure-block,\n  .member-dashboard__gameloop-tags-section {\n    flex: 0 0 auto;\n    width: 100%;\n    min-height: 0;\n  }\n\n  .member-dashboard__structure-block-body,\n  .member-dashboard__gameloop-tags-body {\n    flex: 0 0 auto;\n    min-height: 0;\n    max-height: none;\n    overflow: visible;\n  }\n}\n\n.member-dashboard__structure-block {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-width: 0;\n  //flex: 1 1 0;\n  min-height: 0;\n}\n\n.member-dashboard__structure-block-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  @include member-dashboard-thin-scrollbar;\n}\n\n.member-dashboard__structure-head {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  flex-shrink: 0;\n  margin-bottom: 15px;\n}\n\n.member-dashboard__structure-title {\n  margin: 0;\n  flex: 1;\n  min-width: 0;\n  font-family: \"GoodTimes\", \"Lato\", sans-serif;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.88);\n}\n\n.member-dashboard__structure-head .member-dashboard__gameloop-actions {\n  flex-shrink: 0;\n  gap: 0.5rem;\n}\n\n.member-dashboard__structure-pending-toggle {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0.35rem 0.65rem;\n  border: 1px solid rgba($light-blue, 0.35);\n  border-radius: 4px;\n  background: transparent;\n  color: $light-blue;\n  font-size: 0.72rem;\n  font-weight: 600;\n  line-height: 1.25;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.member-dashboard__structure-pending-toggle:hover {\n  border-color: rgba($light-blue, 0.6);\n  color: $very-light-green;\n}\n\n.member-dashboard__assignment-warning {\n  margin: 0.5rem 0 0;\n  padding: 0.55rem 0.7rem;\n  border-radius: 6px;\n  border-left: 3px solid $light-orange;\n  background: rgba($very-dark-grey, 0.45);\n}\n\n.member-dashboard__assignment-warning-text {\n  margin: 0 0 0.5rem;\n  font-size: 0.8rem;\n  color: rgba($very-light-grey, 0.95);\n}\n\n.member-dashboard__assignment-current-label {\n  display: block;\n  margin-bottom: 0.35rem;\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: $light-orange;\n}\n\n.member-dashboard__assignment-current-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.member-dashboard__assignment-current-item {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem 0.65rem;\n  align-items: baseline;\n  font-size: 0.82rem;\n  color: rgba($very-light-grey, 0.92);\n}\n\n.member-dashboard__assignment-current-name {\n  font-weight: 700;\n  color: $very-light-green;\n}\n\n.member-dashboard__assignment-current-division {\n  color: rgba($light-grey, 0.95);\n}\n\n.member-dashboard__assignment-current-role {\n  font-size: 0.75rem;\n  color: rgba($light-blue, 0.95);\n}\n\n.member-dashboard__assignment-current-period {\n  font-size: 0.72rem;\n  color: rgba($light-grey, 0.85);\n}\n\n.member-dashboard__structure-comment {\n  margin-top: 0.85rem;\n}\n\n.member-dashboard__structure-comment-label {\n  display: block;\n  margin-bottom: 0.25rem;\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: $very-light-grey;\n}\n\n.member-dashboard__structure-comment-hint {\n  margin: 0 0 0.45rem;\n  font-size: 0.75rem;\n  color: rgba($light-grey, 0.95);\n}\n\n.member-dashboard__structure-comment-textarea {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0.5rem 0.65rem;\n  border-radius: 6px;\n  border: 1px solid rgba($medium-light-grey, 0.5);\n  background: rgba($very-dark-grey, 0.65);\n  color: $very-light-grey;\n  font-family: inherit;\n  font-size: 0.82rem;\n  resize: vertical;\n  min-height: 4.5rem;\n}\n\n.member-dashboard__structure-request-note {\n  margin: 0.5rem 0 0;\n  padding: 0.55rem 0.7rem;\n  border-radius: 6px;\n  border-left: 3px solid $light-blue;\n  background: rgba($very-dark-grey, 0.4);\n  font-size: 0.82rem;\n  color: rgba($very-light-grey, 0.9);\n}\n\n.member-dashboard__structure-request-note-label {\n  display: block;\n  margin-bottom: 0.25rem;\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: $light-blue;\n}\n\n.member-dashboard__structure-resolve-note {\n  margin: 0.5rem 0 0;\n  padding: 0.55rem 0.7rem;\n  border-radius: 6px;\n  background: rgba($very-dark-grey, 0.4);\n}\n\n.member-dashboard__structure-resolve-note--approved {\n  border-left: 3px solid $light-green;\n}\n\n.member-dashboard__structure-resolve-note--dismissed {\n  border-left: 3px solid $light-orange;\n}\n\n.member-dashboard__structure-resolve-note-label {\n  margin: 0 0 0.35rem;\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.member-dashboard__structure-resolve-note--approved\n  .member-dashboard__structure-resolve-note-label {\n  color: $light-green;\n}\n\n.member-dashboard__structure-resolve-note--dismissed\n  .member-dashboard__structure-resolve-note-label {\n  color: $light-orange;\n}\n\n.member-dashboard__structure-resolve-note-body {\n  margin: 0 0 0.5rem;\n  font-size: 0.82rem;\n  color: rgba($very-light-grey, 0.9);\n}\n\n.member-dashboard__structure-resolve-note-dismiss {\n  padding: 0.25rem 0.55rem;\n  border-radius: 4px;\n  border: 1px solid rgba($medium-light-grey, 0.45);\n  background: transparent;\n  color: $light-grey;\n  font-size: 0.75rem;\n  cursor: pointer;\n}\n\n.member-dashboard__structure-resolve-note-dismiss:hover {\n  color: $very-light-grey;\n  border-color: rgba($light-grey, 0.55);\n}\n\n.member-dashboard__structure-pending-toggle--active {\n  border-color: rgba($light-green, 0.5);\n  color: $very-light-green;\n  background: rgba($light-green, 0.08);\n}\n\n.member-dashboard__structure-strip--pending-preview {\n  opacity: 0.95;\n}\n\n.member-dashboard__gameloop-card .member-dashboard__structure-strip {\n  width: 100%;\n  min-width: 0;\n}\n\n.member-dashboard__structure-editor.members-onboarding-structure {\n  width: 100%;\n  min-width: 0;\n}\n\n.member-dashboard__structure-editor .members-onboarding-structure__cards {\n  gap: 1.25rem;\n  padding: 0.25rem 0;\n}\n\n.member-dashboard__structure-editor__card-item {\n  display: flex;\n  flex: 1 1 calc((100% - 1.25rem) / 2);\n  max-width: 11.5rem;\n  min-width: 9rem;\n}\n\n.member-dashboard__structure-editor .members-onboarding-structure__card--locked {\n  cursor: not-allowed;\n  opacity: 0.78;\n\n  &:hover,\n  &:focus-visible {\n    border-color: rgba(120, 165, 200, 0.7);\n    background: rgba(8, 14, 22, 0.7);\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.28);\n    transform: none;\n  }\n}\n\n.member-dashboard__structure-editor .members-onboarding-structure__card-lock-msg {\n  margin: 0;\n  font-size: 0.8rem;\n  line-height: 1.4;\n  text-align: center;\n  color: rgba($very-light-orange, 1);\n}\n\n.member-dashboard__structure-editor .members-onboarding-structure__breadcrumb {\n  flex-wrap: wrap;\n  gap: 0.35rem 0.5rem;\n}\n\n.member-dashboard__structure-editor .members-onboarding-structure__footerDock {\n  margin-top: 0.75rem;\n}\n\n.member-dashboard__structure-editor .members-onboarding-structure__tip {\n  display: none;\n}\n\n.member-dashboard__structure-editor .members-onboarding-structure__validate-wrap .members-onboarding-structure__cta {\n  display: none;\n}\n\n.member-dashboard__structure-editor .members-onboarding-structure__membership-grid {\n  gap: 0.5rem 0.6rem;\n  padding: 0.1rem 0;\n}\n\n.member-dashboard__structure-editor .members-onboarding-structure__membership-card {\n  min-height: 2.5rem;\n  padding: 0.45rem 0.85rem;\n}\n\n.member-dashboard__structure-editor .members-onboarding-structure__membership-label {\n  font-size: 0.82rem;\n  letter-spacing: 0.06em;\n}\n\n.member-dashboard__structure-editor .members-onboarding-structure__membership-heading {\n  font-size: 0.84rem;\n  padding: 0.45rem 0.5rem;\n}\n\n.member-dashboard__structure-membership-recap {\n  margin: 0.65rem 0 0;\n  padding: 0.55rem 0.75rem;\n  border-radius: 8px;\n  border: 1px solid rgba($accent-blue, 0.35);\n  background: rgba($dark-blue, 0.35);\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: $very-light-grey;\n  text-align: center;\n}\n\n.member-dashboard__structure-membership-recap-label {\n  display: block;\n  margin-bottom: 0.2rem;\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: rgba($medium-light-grey, 0.95);\n}\n\n.member-dashboard__gameloop-card .member-dashboard__structure-strip--loading {\n  min-height: 13.25rem;\n  border-radius: 10px;\n  border: 1px solid rgba($accent-blue, 0.35);\n  background: rgba($dark-blue, 0.35);\n}\n\n// Dashboard assignment recap — own BEM block (decoupled from onboarding ending recap).\n.member-dashboard__structure-recap {\n  width: 100%;\n  min-width: 0;\n}\n\n.member-dashboard__gameloop-card .member-dashboard__structure-recap__strip {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: stretch;\n  justify-content: center;\n  gap: 1.85rem;\n  width: 100%;\n  min-width: 0;\n}\n\n.member-dashboard__gameloop-card .member-dashboard__structure-recap__card-item {\n  display: flex;\n  flex: 1 1 9.25rem;\n  min-width: 0;\n  max-width: 11.5rem;\n  min-height: 7rem;\n  justify-content: flex-end;\n}\n\n.member-dashboard__structure-recap__card-surface {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 11.5rem;\n  margin-left: auto;\n  margin-right: auto;\n  min-height: 7rem;\n  padding: 0.75rem 0.6rem 0.85rem;\n  border-radius: 10px;\n  border: 1px solid rgba(120, 165, 200, 0.7);\n  color: $very-light-grey;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  transition: box-shadow 0.15s ease;\n}\n\n.member-dashboard__structure-recap__card-surface--neutral {\n  background: rgba(8, 14, 22, 0.72);\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.28);\n}\n\n.member-dashboard__structure-recap__card-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.38rem;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.member-dashboard__structure-recap__card-logo {\n  flex-shrink: 0;\n  width: 4.5rem;\n  height: 4.2rem;\n  object-fit: contain;\n  display: block;\n}\n\n.member-dashboard__structure-recap__card-headings {\n  min-width: 0;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.12rem;\n  text-align: center;\n}\n\n.member-dashboard__structure-recap__card-eyebrow {\n  width: 100%;\n  text-align: center;\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgba($medium-light-grey, 0.95);\n}\n\n.member-dashboard__structure-recap__card-title {\n  font-size: 0.88rem;\n  font-weight: 800;\n  line-height: 1.25;\n  color: $very-light-grey;\n  word-break: break-word;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.member-dashboard__structure-recap__card-subtitle {\n  font-size: 0.74rem;\n  font-weight: 700;\n  color: rgba($medium-light-grey, 0.95);\n  word-break: break-word;\n}\n\n.member-dashboard__gameloop-tags-section {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 0;\n  min-height: 0;\n  padding-top: 15px;\n  border-top: 1px solid rgba($accent-blue, 0.22);\n}\n\n.member-dashboard__gameloop-tags-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  @include member-dashboard-thin-scrollbar;\n}\n\n.member-dashboard__gameloop-card-head {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  flex-shrink: 0;\n  margin-bottom: 15px;\n}\n\n.member-dashboard__gameloop-heading {\n  flex: 1;\n  min-width: 0;\n}\n\n.member-dashboard__gameloop-heading--editing {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.5rem 1rem;\n  flex-wrap: wrap;\n}\n\n.member-dashboard__gameloop-heading--editing .member-dashboard__gameloop-title {\n  flex-shrink: 0;\n}\n\n.member-dashboard__gameloop-title {\n  margin: 0;\n  font-family: \"GoodTimes\", \"Lato\", sans-serif;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.88);\n}\n\n.member-dashboard__gameloop-actions {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.member-dashboard__gameloop-icon-btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  margin: 0;\n  padding: 0;\n  border: 1px solid rgba($accent-blue, 0.5);\n  border-radius: 6px;\n  background: rgba($panel-blue, 0.62);\n  color: rgba($light-blue, 0.95);\n  cursor: pointer;\n}\n\n.member-dashboard__gameloop-icon-btn:hover {\n  border-color: rgba($light-green, 0.45);\n  color: $very-light-green;\n}\n\n.member-dashboard__gameloop-validate {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 2rem;\n  min-height: 2rem;\n  margin: 0;\n  padding: 0 0.35rem;\n  border: 1px solid rgba($green, 0.55);\n  border-radius: 6px;\n  background: rgba($darker-green, 0.55);\n  color: rgba($very-light-green, 0.98);\n  cursor: pointer;\n}\n\n.member-dashboard__gameloop-validate:hover:not(:disabled) {\n  border-color: rgba($light-green, 0.75);\n  background: rgba($dark-green, 0.72);\n}\n\n.member-dashboard__gameloop-validate--disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n\n.member-dashboard__gameloop-icon {\n  display: block;\n}\n\n.member-dashboard__gameloop-icon--check {\n  margin-top: 1px;\n}\n\n.member-dashboard__gameloop-msg {\n  margin: 0.65rem 0 0;\n  font-size: 0.8rem;\n  color: rgba($very-light-grey, 0.9);\n}\n\n.member-dashboard__gameloop-msg--error {\n  color: $light-orange;\n}\n\n.member-dashboard__gameloop-msg--info {\n  color: $light-orange;\n}\n\n.member-dashboard__gameloop-loading {\n  margin: 0.6rem 0 0;\n  font-size: 0.82rem;\n  color: rgba($very-light-grey, 0.8);\n}\n\n.member-dashboard__gameloop-chips {\n  display: flex;\n  flex-flow: row wrap;\n  gap: 0.45rem;\n  margin: 0.85rem 0 0;\n  padding: 0;\n  list-style: none;\n}\n\n.member-dashboard__gameloop-chip-li {\n  list-style: none;\n  margin: 0;\n}\n\n.member-dashboard__gameloop-chip {\n  display: inline-flex;\n  align-items: center;\n  box-sizing: border-box;\n  min-height: 1.65rem;\n  padding: 0.22rem 0.62rem;\n  border-radius: 999px;\n  border: 1px solid rgba($accent-blue, 0.4);\n  background: rgba($dark-panel-blue, 0.72);\n  font-size: 0.74rem;\n  line-height: 1.25;\n  color: rgba($pure-white, 0.96);\n}\n\n.member-dashboard__gameloop-chip--inactive {\n  border-style: dashed;\n  opacity: 0.7;\n}\n\n.member-dashboard__gameloop-chip--picked-readonly {\n  border: 1px solid $accent-blue;\n  background: rgba($light-panel-blue, 0.95);\n}\n\n.member-dashboard__gameloop-chip--toggle {\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.member-dashboard__gameloop-chip--toggle:hover:not(:disabled) {\n  border-color: rgba($light-blue, 0.55);\n}\n\n.member-dashboard__gameloop-chip--selected {\n  border-color: rgba($light-green, 0.7);\n  background: rgba($dark-green, 0.52);\n}\n\n.member-dashboard__gameloop-chip--locked {\n  cursor: default;\n}\n\n.member-dashboard__gameloop-count {\n  margin: 0;\n  font-size: 0.72rem;\n  color: rgba($medium-light-grey, 1);\n}\n\n.member-dashboard__gameloop-count--head {\n  margin-left: auto;\n  text-align: right;\n  flex-shrink: 0;\n}\n\n.member-dashboard__gameloop-empty {\n  margin: 0.85rem 0 0;\n  font-size: 0.8rem;\n  color: rgba($very-light-grey, 0.75);\n}\n\n// Media\n\n@media (max-width: 900px) {\n  .member-dashboard__top {\n    grid-template-columns: 1fr;\n  }\n\n  .member-dashboard__main-column {\n    grid-column: 1;\n    grid-row: auto;\n    width: 100%;\n  }\n\n  .member-dashboard__aside-cluster {\n    grid-column: 1;\n    grid-row: auto;\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .member-dashboard__aside-bottom-row {\n    flex-direction: column;\n  }\n\n  .member-dashboard__aside-bottom-row > .member-dashboard__rank-history-card,\n  .member-dashboard__aside-bottom-row > .member-dashboard__history-card {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .member-dashboard__gameloop-card .member-dashboard__structure-recap__strip {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  .member-dashboard__hero-inner {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .member-dashboard__identity {\n    flex: none;\n    width: 100%;\n  }\n\n  .member-dashboard__divider {\n    width: 100%;\n    height: 1px;\n    min-height: 1px;\n    background: linear-gradient(\n      90deg,\n      transparent 0%,\n      rgba($accent-blue, 0.55) 15%,\n      rgba($accent-blue, 0.55) 85%,\n      transparent 100%\n    );\n  }\n}\n\n// Dashboard ribbons card\n\n.member-dashboard__ribbons-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.member-dashboard__ribbons-toolbar__btn {\n  border: 1px solid rgba($accent-blue, 0.28);\n  background: rgba(0, 0, 0, 0.18);\n  color: rgba($very-light-grey, 0.92);\n  border-radius: 10px;\n  padding: 8px 10px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 650;\n  letter-spacing: 0.02em;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n\n  &:hover {\n    background: rgba($accent-blue, 0.14);\n    border-color: rgba($accent-blue, 0.55);\n    color: rgba($very-light-grey, 0.98);\n  }\n}\n\n.member-dashboard__ribbons-grid {\n  display: grid;\n  gap: 14px;\n}\n\n@for $i from 1 through 4 {\n  .member-dashboard__ribbons-grid--cols-#{$i} {\n    grid-template-columns: repeat(#{$i}, minmax(0, 1fr));\n  }\n}\n\n.member-dashboard__ribbon-card {\n  border: 1px solid rgba($accent-blue, 0.18);\n  background: rgba(0, 0, 0, 0.14);\n  border-radius: 14px;\n  padding: 10px;\n  position: relative;\n\n  .ribbon-details {\n    transform: scale(0.95);\n    transform-origin: top center;\n  }\n}\n\n.member-dashboard__ribbon-card--locked {\n  .ribbon-details {\n    opacity: 0.3;\n  }\n}\n\n.member-dashboard__ribbon-progress {\n  margin-bottom: 6px;\n}\n\n.member-dashboard__ribbon-progress__bar-wrap {\n  position: relative;\n  width: 100%;\n  min-width: 0;\n}\n\n.member-dashboard__ribbon-progress__track {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  gap: 2px;\n  width: 100%;\n  border: 1px solid rgba(58, 120, 180, 0.22);\n  border-radius: 4px;\n  padding: 2px;\n  min-width: 0;\n  min-height: 12px;\n}\n\n.member-dashboard__ribbon-progress__track--empty {\n  .member-dashboard__ribbon-progress__segment {\n    opacity: 0.85;\n  }\n}\n\n.member-dashboard__ribbon-progress__segment {\n  flex: 1 1 0;\n  min-width: 3px;\n  border-radius: 0;\n  background: rgba(0, 0, 0, 0.22);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);\n  transition:\n    background 0.18s ease,\n    border-color 0.18s ease;\n\n  &:first-child {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n  }\n\n  &:last-child {\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n  }\n\n  &.is-filled {\n    background: rgba($blue, 0.62);\n    border-color: rgba($accent-blue, 0.35);\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);\n  }\n}\n\n.member-dashboard__ribbon-progress__track--complete {\n  .member-dashboard__ribbon-progress__segment.is-filled {\n    background: rgba($dark-green, 0.72);\n    border-color: rgba($dark-green, 0.45);\n  }\n}\n\n.member-dashboard__ribbon-progress__label {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -42%);\n  z-index: 1;\n  pointer-events: none;\n  padding: 1px 6px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 650;\n  color: rgba($very-light-grey, 0.96);\n  font-variant-numeric: tabular-nums;\n  line-height: 1.15;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n}\n\n.member-dashboard__ribbon-handle {\n  position: absolute;\n  left: 8px;\n  bottom: 8px;\n  z-index: 3;\n}\n\n.member-dashboard__ribbon-handle__btn,\n.member-dashboard__ribbon-info__btn {\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  border: 1px solid rgba($accent-blue, 0.38);\n  background: rgba(0, 0, 0, 0.35);\n  color: rgba($very-light-grey, 0.92);\n  font-size: 12px;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n\n  &:hover {\n    background: rgba($accent-blue, 0.16);\n    border-color: rgba($accent-blue, 0.55);\n  }\n}\n\n.member-dashboard__ribbon-info__btn {\n  font-weight: 700;\n}\n\n.member-dashboard__ribbon-handle__tooltip,\n.member-dashboard__ribbon-info__tooltip {\n  position: absolute;\n  min-width: 200px;\n  max-width: 280px;\n  width: 280px;\n  padding: 10px;\n  border-radius: 10px;\n  border: 1px solid rgba($accent-blue, 0.28);\n  background: rgba(8, 14, 20, 0.92);\n  color: rgba($very-light-grey, 0.92);\n  font-size: 12px;\n  line-height: 1.35;\n  box-shadow:\n    0 8px 22px rgba(0, 0, 0, 0.55),\n    0 0 0 1px rgba(0, 0, 0, 0.22);\n  white-space: pre-wrap;\n  box-sizing: border-box;\n\n  &.is-portaled {\n    right: auto;\n    bottom: auto;\n    left: auto;\n    top: auto;\n  }\n}\n\n.member-dashboard__ribbon-handle__tooltip {\n  left: 0;\n  bottom: 24px;\n}\n\n.member-dashboard__ribbon-info {\n  position: absolute;\n  right: 8px;\n  bottom: 8px;\n  z-index: 2;\n}\n\n.member-dashboard__ribbon-info__tooltip {\n  right: 0;\n  bottom: 24px;\n}\n\n.member-dashboard__ribbon-name {\n  margin-top: 8px;\n  font-size: 12px;\n  color: rgba($very-light-grey, 0.88);\n  text-align: center;\n  line-height: 1.15;\n}\n\n.member-dashboard__panel-placeholder--error {\n  color: $light-orange;\n}\n\n.member-dashboard__history-scroll {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding-right: 2px;\n  @include member-dashboard-thin-scrollbar;\n}\n\n.member-dashboard__history {\n  display: grid;\n  gap: 10px;\n}\n\n.member-dashboard__history-row {\n  display: grid;\n  grid-template-columns: 96px minmax(0, 1fr) auto auto minmax(64px, max-content);\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border: 1px solid rgba($accent-blue, 0.16);\n  background: rgba(0, 0, 0, 0.12);\n  border-radius: 12px;\n}\n\n.member-dashboard__history-row--expanded {\n  align-items: start;\n}\n\n.member-dashboard__history-row__date {\n  font-family: ui-monospace, \"Cascadia Mono\", \"Segoe UI Mono\", monospace;\n  font-size: 12px;\n  color: rgba($very-light-grey, 0.82);\n}\n\n.member-dashboard__history-row__link {\n  appearance: none;\n  border: none;\n  background: none;\n  padding: 0;\n  text-align: left;\n  cursor: pointer;\n  color: rgba($accent-blue, 0.92);\n  font-size: 13px;\n  font-weight: 650;\n  text-decoration: underline;\n  text-decoration-color: rgba($accent-blue, 0.35);\n  text-underline-offset: 3px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  &:hover {\n    color: $very-light-grey;\n    text-decoration-color: rgba($very-light-grey, 0.55);\n  }\n}\n\n.member-dashboard__history-row__income {\n  font-family: ui-monospace, \"Cascadia Mono\", \"Segoe UI Mono\", monospace;\n  font-size: 12px;\n  color: rgba($very-light-grey, 0.88);\n  white-space: nowrap;\n  text-align: right;\n}\n\n.member-dashboard__history-row__loot {\n  display: flex;\n  justify-content: flex-end;\n  min-width: 52px;\n}\n\n.member-dashboard__history-row__handle {\n  justify-self: end;\n  max-width: 140px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 11px;\n  color: rgba($very-light-grey, 0.68);\n  text-align: right;\n}\n\n.member-dashboard__history-loot-chip {\n  appearance: none;\n  border: 1px solid rgba($accent-blue, 0.45);\n  background: rgba($accent-blue, 0.12);\n  border-radius: 999px;\n  padding: 2px 10px;\n  font-size: 11px;\n  font-weight: 650;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgba($accent-blue, 0.92);\n  cursor: pointer;\n\n  &:hover {\n    background: rgba($accent-blue, 0.22);\n    color: $very-light-grey;\n  }\n}\n\n.member-dashboard__history-loot-chip--active {\n  background: rgba($accent-blue, 0.28);\n  border-color: rgba($accent-blue, 0.72);\n  color: $very-light-grey;\n}\n\n.member-dashboard__history-loot-details {\n  grid-column: 1 / -1;\n  margin: 0;\n  padding: 8px 10px 2px;\n  list-style: none;\n  border-top: 1px solid rgba($accent-blue, 0.14);\n  display: grid;\n  gap: 6px;\n}\n\n.member-dashboard__history-loot-item {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 10px;\n  font-size: 12px;\n  color: rgba($very-light-grey, 0.82);\n}\n\n.member-dashboard__history-loot-item__label {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.member-dashboard__history-loot-item__qty {\n  flex-shrink: 0;\n  font-family: ui-monospace, \"Cascadia Mono\", \"Segoe UI Mono\", monospace;\n  color: rgba($very-light-grey, 0.68);\n}\n\n.member-dashboard__history-row--redacted {\n  border-style: dashed;\n  opacity: 0.78;\n}\n\n.member-dashboard__history-row__redacted {\n  font-family: ui-monospace, \"Cascadia Mono\", \"Segoe UI Mono\", monospace;\n  font-size: 12px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.72);\n  user-select: none;\n}\n\n","@import './variables.scss';\n\n.personal-hub-section--promo-host {\n  position: relative;\n}\n\n.mobile-webapp-promo {\n  position: absolute;\n  inset: 0;\n  z-index: 30;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem;\n  background: rgba($dark-blue-grey, 0.72);\n  backdrop-filter: blur(6px);\n}\n\n.mobile-webapp-promo__dialog {\n  position: relative;\n  width: unquote('min(100%, 420px)');\n  padding: 2rem 1.75rem 1.5rem;\n  border-radius: 14px;\n  border: 1px solid rgba($accent-blue, 0.45);\n  background: linear-gradient(\n    165deg,\n    rgba($blue-grey, 0.98) 0%,\n    rgba($dark-blue-grey, 0.96) 100%\n  );\n  box-shadow:\n    0 24px 48px rgba(0, 0, 0, 0.45),\n    0 0 0 1px rgba($very-light-grey, 0.06) inset;\n  text-align: center;\n}\n\n.mobile-webapp-promo__close {\n  position: absolute;\n  top: 0.65rem;\n  right: 0.75rem;\n  width: 2rem;\n  height: 2rem;\n  margin: 0;\n  padding: 0;\n  border: none;\n  border-radius: 50%;\n  color: rgba($very-light-grey, 0.85);\n  background: transparent;\n  font-size: 1.35rem;\n  line-height: 1;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n\n  &:hover {\n    color: $pure-white;\n    background: rgba($very-light-grey, 0.12);\n  }\n\n  &:focus-visible {\n    outline: 2px solid rgba($accent-blue, 0.75);\n    outline-offset: 2px;\n  }\n}\n\n.mobile-webapp-promo__icon-wrap {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 4.5rem;\n  height: 4.5rem;\n  margin: 0 auto 1.25rem;\n  border-radius: 50%;\n  background: rgba($accent-blue, 0.18);\n  box-shadow: 0 0 0 1px rgba($accent-blue, 0.35);\n}\n\n.mobile-webapp-promo__icon {\n  font-size: 1.75rem;\n  color: $very-light-grey;\n}\n\n.mobile-webapp-promo__icon--phone {\n  position: relative;\n  z-index: 1;\n}\n\n.mobile-webapp-promo__icon--qr {\n  position: absolute;\n  right: 0.55rem;\n  bottom: 0.45rem;\n  z-index: 2;\n  font-size: 1.15rem;\n  padding: 0.2rem;\n  border-radius: 6px;\n  color: $pure-white;\n  background: rgba($accent-blue, 0.85);\n}\n\n.mobile-webapp-promo__title {\n  margin: 0 0 0.75rem;\n  color: $pure-white;\n  font-size: 1.15rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n}\n\n.mobile-webapp-promo__message {\n  margin: 0 0 1.5rem;\n  color: rgba($very-light-grey, 0.92);\n  font-size: 0.95rem;\n  line-height: 1.55;\n}\n\n.mobile-webapp-promo__actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.mobile-webapp-promo__cta,\n.mobile-webapp-promo__dismiss {\n  width: 100%;\n}\n\n@media (max-width: 480px) {\n  .mobile-webapp-promo {\n    padding: 1rem;\n  }\n\n  .mobile-webapp-promo__dialog {\n    padding: 1.75rem 1.25rem 1.25rem;\n  }\n}\n","@import '../variables.scss';\n\n// Unified column-width maps for each table variant\n$col-widths: (\n  emojis: (\n    imageUrl: 65px,\n    fullName: 400px,\n    shortName: 240px,\n    category: 140px,\n    status:   70px\n  ),\n  carousel: (\n    title:       190px,\n    subtitle:    200px,\n    mediaType:   100px,\n    size:         80px,\n    action:       80px\n  ),\n  orgs-whitelist: (\n    logo:          90px,\n    orgName:       160px,\n    orgSid:        100px,\n    whitelisted:   75px,\n    blacklisted:   75px,\n    commentEdit:   280px,\n    commentSave:   92px\n  )\n);\n\n// Apply column widths via loop (no mixins)\n@each $variant, $map in $col-widths {\n  .table-base.#{$variant} {\n    table {\n      colgroup {\n        @each $colName, $colWidth in $map {\n          col.col-#{$colName} {\n            width: $colWidth;\n          }\n        }\n      }\n    }\n  }\n}\n\n// Unified body max-height per table variant\n$body-heights: (\n  public-pages: 170px,\n  emojis: 40vh,\n  carousel: 180px,\n  permissions: 40vh,\n  templates: 400px,\n  subtypes: 207px,\n  ribbons: 40vh,\n  organization-logs: 50vh,\n  organization-applications: 200px,\n  orgs-whitelist: 55vh,\n);\n\n// Apply body heights based on variant\n@each $variant, $height in $body-heights {\n  .table-base.#{$variant} {\n    .table-body-wrapper {\n      max-height: $height;\n    }\n  }\n}\n\n//  flex only inside, not on <th>\n.header-content {\n  display: flex;\n  justify-content: space-between; // text left, triangle right\n  align-items: center;\n  width: 100%;\n  //padding-right: 10px; // 10px right margin for the indicator\n}\n\n//  optional label style\n.header-label {\n  flex: 1 1 auto;\n}\n\n//  white triangle indicator\n.sort-indicator {\n  color: #fff;\n  font-size: 0.9rem;\n  margin-left: 0.25rem;\n}\n\n\n// Unified table styles\n.table-base {\n  border: 1px solid $dark-red;\n  border-radius: 8px; //  round all corners\n  overflow: hidden;\n  color: $very-light-grey; //  default text color\n  margin: 10px 0px;\n  box-shadow: 4px 5px 2px #4b050547;\n\n  table {\n    width: 100%;\n    border-collapse: collapse;\n    table-layout: fixed;\n  }\n\n  // Default alignment for all headers and cells\n  th[class^=\"header-\"], td[class^=\"cell-\"] {\n    text-align: left; \n    //white-space: nowrap;\n    //overflow: hidden;\n    text-overflow: ellipsis;\n    padding: 0 12px;\n  }\n\n  // Centered columns (images, status, actions)\n  th.header-imageUrl, td.cell-imageUrl,\n  th.header-qtyRequirement, td.cell-qtyRequirement,\n  th.header-status,    td.cell-status,\n  th.header-action,    td.cell-action {\n    text-align: center; \n\n    &.cell-action {\n      text-align: left; \n    }\n  }\n\n  // Right-aligned columns (sizes)\n  th.header-size, td.cell-size {\n    text-align: right;    //  right-align sizes\n  }\n\n  // Header background gradient\n  thead {\n    display: table-header-group;\n    //height: 34px;\n    background-size: cover;\n    color: $light-grey;\n    text-transform: uppercase;\n    border-bottom: 2px solid $grey;\n    @include steel-bg(\"../medias/steel.png\");\n  }\n\n  // Header row styling\n  thead th {\n    height: 30px;\n    font-size: 0.75em;\n    font-weight: 600;\n    position: relative;\n    border-right: none;\n\n    &:not(:last-child)::after {\n      content: '';\n      position: absolute;\n      right: 0;\n      top: 50%;\n      transform: translateY(-50%);\n      width: 1px;                  // épaisseur du trait\n      height: 65%;                 // hauteur du trait (ajustez selon goût)\n      background-color: $grey;     // même couleur que précédemment\n    }\n  }\n\n\n  // Scrollable body\n  .table-body-wrapper {\n    max-height: calc(100vh - 400px);\n    overflow-y: auto;\n    overflow-x: hidden;\n    border-bottom: 4px solid $dark-red;\n    box-shadow: 4px 5px 2px #4b050547;\n    @include scrollbar-styles;\n  }\n\n  tbody tr {\n    height: 45px;\n    color: $light-grey; \n    font-size: 0.9em;\n\n    &:nth-child(odd)  { background: $panel-blue; }\n    &:nth-child(even) { background: $dark-panel-blue; }\n    &:hover { \n      background: rgba(37, 64, 85, 0.9);\n      border-radius: 3px;\n    }\n\n    &.unread-row {\n      color: white;\n    }\n  }\n\n  // Roster gère .selected-row en interne (lignes enfants 95 % alignées à droite).\n  &:not(.roster) tbody tr.selected-row {\n    background: rgba(24, 47, 67, 0.9);\n    box-shadow: inset 0 0 10px rgba(61, 150, 177, 0.4);\n    transition: background 0.25s ease, box-shadow 0.25s ease;\n    border-radius: 3px;\n  }\n\n  // Icon styling\n  .arrow,\n  .delete-media,\n  svg.icon,\n  .action-cell-container svg {\n    max-height: 20px; \n    fill: none;\n    cursor: pointer;\n    &:hover { stroke: $dark-red; }\n  }\n\n  // Table-specific column widths\n  &.emojis table {\n    colgroup {\n      col.col-imageUrl   { width: 65px; }\n      col.col-fullName   { width: 400px; }\n      col.col-shortName  { width: 240px; }\n      col.col-category   { width: 140px; }\n      col.col-status     { width: 70px; }\n    }\n  }\n\n  &.carousel table {\n    colgroup {\n      col.col-handle     { width:  30px; cursor: grab; }\n      col.col-title      { width: 145px; }\n      col.col-subtitle   { width: 220px; }\n      col.col-mediaType  { width:  93px; }\n      col.col-size       { width:  93px; }\n      col.col-action     { width:  30px; }\n    }\n  }\n\n  &.modules {\n    colgroup {\n      col.col-moduleName     { width:  auto; }\n      col.col-trainingLevel  { width: 110px; }\n      col.col-theme          { width: 110px; }\n      col.col-moduleVersion  { width:  80px; }\n      col.col-document       { width:  60px; }\n      col.col-qcm            { width:  60px; }\n      col.col-simple         { width:  70px; }\n      col.col-standard       { width:  70px; }\n      col.col-complex        { width:  70px; }\n      col.col-expert         { width:  70px; }\n      col.col-trainings      { width: 190px; }\n      col.col-checklist      { width:  95px; }\n      col.col-assign         { width:  50px; }\n    }\n  }\n\n  &.roster {\n    position: relative;\n    overflow: hidden;\n    //margin: 50px auto;\n    margin: 5px 0px 10px;\n    border: none;\n    box-shadow: none;\n\n    .table-header {\n      border-collapse: separate;\n      border-spacing: 0;\n      margin-bottom: 3px;\n      width: 100%;\n      filter:\n        drop-shadow(0 3px 6px rgba(0, 0, 0, 0.5))\n        drop-shadow(0 6px 14px rgba(0, 0, 0, 0.35));\n\n      thead {\n        border-bottom: none;\n        height: 45px;\n        @include steel-bg(\"../medias/steel.png\");\n      }\n\n      thead tr th:first-child {\n        border-radius: 10px 0 0 10px;\n      }\n\n      thead th {\n        box-shadow:\n          inset 0 1px 0 rgba(255, 255, 255, 0.16),\n          inset 0 -1px 0 rgba(0, 0, 0, 0.18);\n      }\n    }\n\n    .roster-table-footer {\n      height: 10px;\n      margin-top: 10px;\n      width: 100%;\n      border-radius: 10px;\n      @include steel-bg(\"../medias/steel.png\");\n      box-shadow:\n        inset 0 1px 0 rgba(255, 255, 255, 0.16),\n        inset 0 -1px 0 rgba(0, 0, 0, 0.18);\n      filter:\n        drop-shadow(0 3px 6px rgba(0, 0, 0, 0.5))\n        drop-shadow(0 6px 14px rgba(0, 0, 0, 0.35));\n\n      &--pagination {\n        height: auto;\n        min-height: 36px;\n        padding: 5px 8px 5px;\n        box-sizing: border-box;\n        display: flex;\n        align-items: center;\n        justify-content: left;\n      }\n    }\n\n    .roster-table-footer__pagination {\n      margin-left: 100px;\n      min-width: 0;\n    }\n\n    .roster-pagination {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      gap: 2px;\n      min-width: 0;\n    }\n\n    .roster-pagination__edge,\n    .roster-pagination__step {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      padding: 5px 6px;\n      border: none;\n      border-radius: 6px;\n      background: transparent;\n      color: $very-light-grey;\n      cursor: pointer;\n\n      &:disabled {\n        opacity: 0.32;\n        cursor: default;\n      }\n\n      &:not(:disabled):hover {\n        background: rgba(255, 255, 255, 0.07);\n      }\n    }\n\n    .roster-pagination__glyph {\n      display: block;\n    }\n\n    .roster-pagination__pages {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      gap: 2px;\n      margin: 0 2px;\n      min-width: 0;\n      flex-wrap: wrap;\n      justify-content: center;\n    }\n\n    .roster-pagination__page {\n      min-width: 1.85rem;\n      padding: 4px 7px;\n      border: 1px solid transparent;\n      border-radius: 6px;\n      background: transparent;\n      color: inherit;\n      font-size: 0.8rem;\n      cursor: pointer;\n      line-height: 1.2;\n\n      &:hover {\n        background: rgba(255, 255, 255, 0.06);\n      }\n\n      &--active {\n        border-color: rgba(61, 150, 177, 0.5);\n        background: rgba(61, 150, 177, 0.12);\n        box-shadow: 0 0 0 1px rgba(61, 150, 177, 0.22);\n      }\n    }\n\n    .roster-pagination__ellipsis {\n      padding: 0 5px;\n      opacity: 0.55;\n      user-select: none;\n      font-size: 0.85rem;\n\n      &--more {\n        opacity: 0.85;\n        color: $very-light-grey;\n        letter-spacing: 0.08em;\n        font-weight: 600;\n      }\n    }\n\n    thead th {\n      cursor: default;\n      user-select: none;\n    }\n\n    .table-header tr::after {\n      content: '';\n      display: table-cell;\n      width: 0px; // scrollbar width\n      border-radius: 0 10px 10px 0;\n      //@include steel-bg-blue(\"../medias/steel.png\");\n      background-size: cover;\n      background-repeat: no-repeat;\n      background-position: center;\n      box-shadow:\n        inset 0 1px 0 rgba(255, 255, 255, 0.16),\n        inset 0 -1px 0 rgba(0, 0, 0, 0.18);\n    }\n\n    colgroup {\n      col.col-rosterRankIcon      { width:  55px;}\n      col.col-rosterRank          { width: 170px;}\n      col.col-rosterMoniker       { width: 293px;}\n      col.col-division            { width:  77px;}\n      col.col-branch              { width:  77px;}\n      col.col-section             { width:  77px;}\n      col.col-basic               { width:  80px;}\n      col.col-missionToken        { width:  68px;}\n      col.col-eventToken          { width:  68px;}\n      col.col-totalToken          { width:  80px;}\n      col.col-affiliation         { width:  88px;}\n      col.col-visibility          { width:  75px;}\n      col.col-certification       { width:  50px;}\n    }\n\n    .roster-rank-icon-img {\n      display: block;\n      margin: 0 auto;\n      max-height: 27px;\n      max-width: 40px;\n      width: auto;\n      height: auto;\n      object-fit: contain;\n      transform: translateZ(0);\n      backface-visibility: hidden;\n    }\n\n    .roster-rank-name {\n      font-size: 0.75rem;\n      text-transform: uppercase;\n    }\n\n    .roster-rank-name--split {\n      display: inline-flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 0.08em;\n      line-height: 1.18;\n      text-align: left;\n    }\n\n    .roster-rank-name__line1 {\n      font-size: inherit;\n    }\n\n    .roster-rank-name__line2 {\n      font-size: 0.86em;\n      opacity: 0.92;\n      letter-spacing: 0.02em;\n    }\n\n    td.cell-rosterRank,\n    th.header-rosterRank {\n      //vertical-align: top;\n      padding-top: 0px;\n      padding-bottom: 0px;\n    }\n\n    .roster-token-lock {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      color: rgba(180, 188, 196, 0.75);\n    }\n\n    .roster-token-lock__svg {\n      width: 14px;\n      height: 14px;\n      display: block;\n    }\n\n    td.cell-missionToken,\n    td.cell-eventToken,\n    td.cell-totalToken {\n      text-align: center;\n    }\n\n    .rank-placeholder,\n    .rank-icon-placeholder {\n      display: inline-block;\n      min-width: 0.5rem;\n      opacity: 0.35;\n    }\n\n\n    td.cell-rosterMoniker,\n    th.header-rosterMoniker {\n      text-align: left;\n    }\n\n    td.cell-rosterMoniker {\n      position: relative;\n      overflow: visible;\n    }\n\n    .roster-moniker-cell {\n      position: relative;\n      width: 100%;\n      min-width: 0;\n      overflow: visible;\n\n      &:has(.roster-moniker__donor-gem) {\n        padding-right: 24px;\n      }\n\n      > .roster-moniker__donor-gem {\n        position: absolute;\n        right: 25px;\n        top: 10px;\n        margin-left: 0;\n      }\n\n      &:has(.roster-moniker-stack--no-assignment) > .roster-moniker__donor-gem,\n      &:not(:has(.roster-moniker-stack)) > .roster-moniker__donor-gem {\n        top: 50%;\n        margin-top: calc(-0.9rem * 1.15 / 2);\n      }\n    }\n\n    tbody.content tr.roster-row:not(.roster-row-secondary-outer)\n      td.cell-rosterMoniker:has(.roster-moniker-stack--no-assignment) {\n        padding: 0 10px;\n\n      vertical-align: middle;\n    }\n\n    .roster-moniker-stack {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 0.18rem;\n      width: 100%;\n      min-width: 0;\n      text-align: left;\n      line-height: 1.25;\n    }\n\n    .roster-moniker-stack__line--name {\n      width: 100%;\n      min-width: 0;\n    }\n\n    .roster-moniker__donor-gem {\n      flex: 0 0 18px;\n      width: 18px;\n      height: calc(0.9rem * 1.15);\n      position: relative;\n      overflow: visible;\n\n      .donor-gem-badge__wrap {\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        width: 18px;\n        height: 18px;\n        transform: translate(-50%, -50%);\n      }\n\n      .donor-gem-badge__wrap--premium::before {\n        inset: -5px;\n        opacity: 0;\n        animation: none;\n      }\n\n      .donor-gem-badge__gem {\n        width: 18px;\n        height: 18px;\n      }\n\n      .donor-gem-badge__tooltip {\n        left: auto;\n        right: 22px;\n        top: 8px;\n        height: 10px;\n        z-index: 20;\n        transform: translateY(2px);\n      }\n\n      .donor-gem-badge__wrap:hover,\n      .donor-gem-badge__wrap:focus-within {\n        .donor-gem-badge__tooltip {\n          transform: translateY(0);\n        }\n      }\n\n      .donor-gem-badge__wrap--premium:hover::before,\n      .donor-gem-badge__wrap--premium:focus-within::before {\n        opacity: 1;\n        animation: donor-gem-badge-aura 1.4s ease-in-out infinite;\n      }\n    }\n\n    .roster-moniker-stack__name-text {\n      display: inline-block;\n      font-weight: 700;\n      font-size: 0.90rem;\n      color: $light-grey;\n    }\n\n    .roster-assignment-cell {\n      display: inline-flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      gap: 0.35em;\n      max-width: 100%;\n      margin: 0 auto;\n      text-align: center;\n      line-height: 1.22;\n      font-size: 0.88rem;\n      white-space: normal;\n      overflow-wrap: break-word;\n      word-break: break-word;\n    }\n\n    .roster-assignment-cell--stacked {\n      display: block;\n      margin: 0;\n      max-width: 100%;\n      text-align: left;\n      font-size: 0.78rem;\n      line-height: 1.35;\n      white-space: normal;\n      overflow-wrap: break-word;\n      word-break: break-word;\n\n      &.roster-assignment-cell--legacy {\n        width: 100%;\n        color: $light-grey;\n      }\n    }\n\n    .roster-assignment-cell__segment {\n      &--user-assignments {\n        color: $light-blue;\n      }\n\n      &--user-org-divisions {\n        color: $light-blue;\n      }\n    }\n\n    .roster-assignment-cell--legacy {\n      display: block;\n      width: 100%;\n      text-align: left;\n    }\n\n    .roster-assignment-cell__block {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 0.12em;\n    }\n\n    .roster-assignment-cell__block + .roster-assignment-cell__block {\n      margin-top: 0.35em;\n      padding-top: 0.35em;\n      border-top: 1px solid rgba(255, 255, 255, 0.1);\n    }\n\n\n    .roster-org-cell {\n      display: flex;\n      width: 100%;\n      max-width: 100%;\n      min-width: 0;\n      box-sizing: border-box;\n      justify-content: center;\n      white-space: normal;\n      overflow-wrap: break-word;\n      word-break: break-word;\n      line-height: 1.28;\n      font-size: 0.88rem;\n    }\n\n    .roster-org-cell--image {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      white-space: normal;\n    }\n\n    .roster-org-cell__img {\n      display: block;\n      max-width: 100%;\n      max-height: 30px;\n      width: auto;\n      height: auto;\n      object-fit: contain;\n      transform: translateZ(0);\n    }\n\n    .visibility-label {\n      display: flex;\n      justify-self: center;\n      justify-content: center;\n      align-items: center;\n      width: fit-content;\n      min-width: 45px;\n      padding: 4px 8px;\n      border-radius: 6px;\n      border: 1px solid transparent;\n      font-size: 0.75rem;\n      font-weight: 500;\n      line-height: 1;\n      transition:\n        border-color 0.2s ease,\n        box-shadow 0.2s ease,\n        background 0.2s ease,\n        color 0.2s ease;\n    \n      &.Visible {\n        color: rgba($light-blue, 0.65);\n        background: linear-gradient(\n          180deg,\n          $blue-grey 0%,\n          $dark-blue 100%\n        );\n        border-color: rgba($light-blue, 0.65);\n        box-shadow:\n          inset 0 0 10px rgba(0, 180, 255, 0.08),\n          0 0 10px rgba(0, 180, 255, 0.18);\n    \n        &:hover {\n          box-shadow:\n            inset 0 0 12px rgba(0, 200, 255, 0.12),\n            0 0 14px rgba(0, 200, 255, 0.28);\n        }\n      }\n    \n      &.Hidden,\n      &.Redacted {\n        color: #ff8a8a;\n        background: linear-gradient(\n          180deg,\n          rgba(60, 15, 15, 0.95) 0%,\n          rgba(30, 8, 8, 0.95) 100%\n        );\n        border-color: rgba(255, 70, 70, 0.35);\n        box-shadow:\n          inset 0 0 10px rgba(255, 0, 0, 0.05),\n          0 0 10px rgba(255, 40, 40, 0.15);\n    \n        &:hover {\n          border-color: rgba(255, 110, 110, 0.65);\n          box-shadow:\n            inset 0 0 12px rgba(255, 0, 0, 0.08),\n            0 0 14px rgba(255, 60, 60, 0.25);\n        }\n      }\n    \n      &.Unknown {\n        color: #a0b4c8;\n        background: rgba(80, 100, 120, 0.12);\n        border-color: rgba(160, 180, 200, 0.18);\n        box-shadow: none;\n      }\n    }\n\n\n    .basic-dots {\n      display: flex;\n      gap: 10px;\n      justify-content: center;\n    }\n\n    .basic-dot {\n      width: 14px;\n      height: 14px;\n      border-radius: 50%;\n      border: 2px solid $orange;\n      box-sizing: border-box;\n\n      &.done {\n        background: $green;\n        border: 2px solid $green;\n      }\n\n      &.missing {\n        background: transparent;\n        opacity: 0.4;\n      }\n    }\n\n    .basic-icons {\n      display: flex;\n      gap: 6px;\n      justify-content: center;\n      align-items: center;\n    }\n\n    .basic-icon {\n      width: 18px;\n      height: 18px;\n      object-fit: contain;\n      transition: opacity 0.2s ease;\n      transform: translateZ(0);\n      backface-visibility: hidden;\n    }\n\n    .basic-icon.certified {\n      opacity: 0.8;\n    }\n\n    .basic-icon.required {\n      opacity: 0.2;\n    }\n\n    .basic-icon.certified {\n      opacity: 0.8;\n      background-image: none !important;\n      animation: none !important;\n      filter: none !important;\n    }\n\n    .basic-icon.certified:hover {\n      animation: none !important;\n      filter: none !important;\n    }\n\n    .table-body-scroll {\n      position: relative;\n      background: transparent;\n      height: calc(100vh - 420px);\n      overflow-x: hidden;\n      overflow-y: auto;\n      display: block;\n      //@include scrollbar-styles;\n      scrollbar-width: none;\n\n      > table {\n        position: relative;\n        z-index: 1;\n      }\n    }\n\n    .roster-affiliation-connectors {\n      position: absolute;\n      left: 0;\n      top: 0;\n      z-index: 1;\n      pointer-events: none;\n      overflow: visible;\n\n      path {\n        fill: none;\n        stroke: $very-light-grey;\n        stroke-width: 1.5;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n    }\n\n    // Aligned with ROSTER_FLIP_MS: slide only (no opacity dip) so connector + row appear together.\n    @keyframes roster-child-deploy {\n      from {\n        opacity: 1;\n        transform: translateY(-6px);\n      }\n\n      to {\n        opacity: 1;\n        transform: translateY(0);\n      }\n    }\n\n    // Hold opaque during FLIP (first segment), then fade — total ms from --roster-collapse-total-ms (JS).\n    @keyframes roster-collapse-ghost-fade {\n      0%,\n      59.375% {\n        opacity: 1;\n      }\n\n      100% {\n        opacity: 0;\n      }\n    }\n\n    .roster-collapse-ghost {\n      position: absolute;\n      top: var(--ghost-top, 0);\n      left: var(--ghost-left, 0);\n      width: var(--ghost-width, 0);\n      height: var(--ghost-height, 0);\n      z-index: 0;\n      pointer-events: none;\n      border-radius: 8px;\n      box-shadow:\n        inset 0 1px 0 rgba(255, 255, 255, 0.12),\n        inset 0 -1px 0 rgba(0, 0, 0, 0.2);\n      background: rgba($panel-blue, 0.92);\n      animation: roster-collapse-ghost-fade var(--roster-collapse-total-ms, 640ms)\n        cubic-bezier(0.22, 1, 0.36, 1) forwards;\n\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n        opacity: 0;\n      }\n    }\n\n    .roster-master-expand-hit {\n      position: absolute;\n      left: 0;\n      top: 0;\n      bottom: 0;\n      z-index: 2;\n      width: 28px;\n      margin: 0;\n      padding: 0;\n      border: none;\n      border-radius: 0;\n      background: transparent;\n      cursor: pointer;\n\n      &:hover {\n        background: rgba($very-light-grey, 0.08);\n      }\n\n      &:focus-visible {\n        outline: 1px solid rgba($very-light-grey, 0.6);\n        outline-offset: 1px;\n      }\n    }\n\n    tbody.content tr.roster-row--has-children:not(.roster-row-secondary-outer)\n      > td.cell-rosterRankIcon {\n      position: relative;\n      padding-left: 12px;\n\n      &::before {\n        content: '';\n        position: absolute;\n        left: 8px;\n        top: 50%;\n        transform: translateY(-50%);\n        width: 0;\n        height: 0;\n        border-top: 4px solid transparent;\n        border-bottom: 4px solid transparent;\n        border-left: 6px solid $very-light-grey;\n        pointer-events: none;\n        z-index: 1;\n        transition: transform 0.2s ease;\n      }\n    }\n\n    tbody.content tr.roster-row--has-children.roster-row--children-expanded:not(\n        .roster-row-secondary-outer\n      )\n      > td.cell-rosterRankIcon::before {\n      transform: translateY(-50%) rotate(90deg);\n    }\n\n    .table-body-scroll table {\n      position: relative;\n      z-index: 0;\n      width: 100%;\n      border-collapse: separate;\n      border-spacing: 0 10px;\n    }\n\n    tbody.content tr.roster-row:not(.roster-row-secondary-outer) {\n      cursor: pointer;\n      transition:\n        background 0.2s ease,\n        box-shadow 0.25s ease,\n        filter 0.2s ease;\n      border-radius: 8px;\n      overflow: hidden;\n      filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.45));\n\n      &:has(.roster-moniker__donor-gem .donor-gem-badge__wrap:hover),\n      &:has(.roster-moniker__donor-gem .donor-gem-badge__wrap:focus-within) {\n        overflow: visible;\n        position: relative;\n        z-index: 6;\n      }\n\n      td {\n        background: transparent;\n        box-shadow: none;\n      }\n\n      &:nth-child(odd) {\n        background: #032e48;\n        box-shadow:\n          inset 0 1px 0 rgba(255, 255, 255, 0.14),\n          inset 0 -1px 0 rgba(0, 0, 0, 0.2);\n      }\n\n      &:nth-child(even) {\n        background: #062a40;\n        box-shadow:\n          inset 0 1px 0 rgba(255, 255, 255, 0.14),\n          inset 0 -1px 0 rgba(0, 0, 0, 0.2);\n      }\n\n      &:hover:not(.selected-row) {\n        background: rgba(37, 64, 85, 0.8);\n        box-shadow:\n          inset 0 1px 0 rgba(255, 255, 255, 0.16),\n          inset 0 -1px 0 rgba(0, 0, 0, 0.18);\n        filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.55));\n      }\n\n      &.selected-row {\n        background: #203f5acc;\n        box-shadow:\n          inset 0 1px 0 rgba(255, 255, 255, 0.1),\n          inset 0 -1px 0 rgba(0, 0, 0, 0.18),\n          inset 0 0 10px rgba(61, 150, 177, 0.4);\n        filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.5))\n          drop-shadow(0 0 12px rgba(61, 150, 177, 0.15));\n        transition: background 0.25s ease, box-shadow 0.25s ease;\n      }\n\n      &.selected-row:hover {\n        background: #254055cc;\n        box-shadow:\n          inset 0 1px 0 rgba(255, 255, 255, 0.12),\n          inset 0 -1px 0 rgba(0, 0, 0, 0.16),\n          inset 0 0 10px rgba(61, 150, 177, 0.4);\n        filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.55))\n          drop-shadow(0 0 14px rgba(61, 150, 177, 0.22));\n      }\n\n      &.roster-row--current-user:nth-child(odd) {\n        box-shadow:\n          inset 0 1px 0 rgba(255, 255, 255, 0.14),\n          inset 0 -1px 0 rgba(0, 0, 0, 0.2),\n          inset 0 0 0 2px rgba(61, 150, 177, 0.44),\n          inset 0 0 28px rgba(61, 150, 177, 0.24);\n      }\n\n      &.roster-row--current-user:nth-child(even) {\n        box-shadow:\n          inset 0 1px 0 rgba(255, 255, 255, 0.14),\n          inset 0 -1px 0 rgba(0, 0, 0, 0.2),\n          inset 0 0 0 2px rgba(61, 150, 177, 0.44),\n          inset 0 0 28px rgba(61, 150, 177, 0.24);\n      }\n\n      &.roster-row--current-user:hover:not(.selected-row) {\n        background:\n          linear-gradient(\n            165deg,\n            rgba(95, 175, 205, 0.14) 0%,\n            rgba(61, 150, 177, 0.08) 50%,\n            rgba(35, 75, 105, 0.12) 100%\n          ),\n          rgba(37, 64, 85, 01);\n        box-shadow:\n          inset 0 1px 0 rgba(255, 255, 255, 0.16),\n          inset 0 -1px 0 rgba(0, 0, 0, 0.18),\n          inset 0 0 0 2px rgba(100, 200, 230, 0.5),\n          inset 0 0 32px rgba(61, 150, 177, 0.18);\n        filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.55));\n      }\n\n      &.roster-row--current-user.selected-row {\n        background:\n          linear-gradient(\n            165deg,\n            rgba(95, 175, 205, 0.13) 0%,\n            rgba(61, 150, 177, 0.07) 50%,\n            rgba(35, 75, 105, 0.11) 100%\n          ),\n          rgba(24, 47, 67, 1);\n        box-shadow:\n          inset 0 1px 0 rgba(255, 255, 255, 0.1),\n          inset 0 -1px 0 rgba(0, 0, 0, 0.18),\n          inset 0 0 0 2px rgba(61, 150, 177, 0.5),\n          inset 0 0 22px rgba(61, 150, 177, 0.55);\n        filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.5))\n          drop-shadow(0 0 12px rgba(61, 150, 177, 0.18));\n      }\n\n      &.roster-row--current-user.selected-row:hover {\n        background:\n          linear-gradient(\n            165deg,\n            rgba(95, 175, 205, 0.14) 0%,\n            rgba(61, 150, 177, 0.08) 50%,\n            rgba(35, 75, 105, 0.12) 100%\n          ),\n          rgba(37, 64, 85, 0.8);\n        box-shadow:\n          inset 0 1px 0 rgba(255, 255, 255, 0.12),\n          inset 0 -1px 0 rgba(0, 0, 0, 0.16),\n          inset 0 0 0 2px rgba(100, 200, 230, 0.52),\n          inset 0 0 22px rgba(61, 150, 177, 0.58);\n        filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.55))\n          drop-shadow(0 0 14px rgba(61, 150, 177, 0.22));\n      }\n    }\n\n    tbody.content tr.roster-row-secondary-outer {\n      height: auto;\n      min-height: 0;\n      cursor: pointer;\n      background: transparent;\n      box-shadow: none;\n      filter: none;\n      animation: roster-child-deploy 0.38s cubic-bezier(0.22, 1, 0.36, 1);\n\n      &:hover {\n        filter: none;\n        background: transparent;\n        box-shadow: none;\n      }\n\n      &.selected-row {\n        filter: none;\n        background: transparent;\n        box-shadow: none;\n      }\n    }\n\n    .cell-roster-secondary-row {\n      padding: 0;\n      border: none !important;\n      background: transparent !important;\n      box-shadow: none !important;\n      border-radius: 0 !important;\n      overflow: visible;\n      vertical-align: top;\n      text-align: right;\n    }\n\n    .roster-secondary-row-90 {\n      display: inline-block;\n      width: 96.4%;\n      max-width: 96.4%;\n      min-width: 0;\n      margin-top: -10px;\n      margin-bottom: -10px;\n      text-align: left;\n      vertical-align: top;\n      border-radius: 8px;\n      overflow: hidden;\n    }\n\n    .roster-secondary-inner-table {\n      width: 100%;\n      border-collapse: separate;\n      border-spacing: 0;\n      table-layout: fixed;\n    }\n\n    .roster-secondary-inner-table colgroup {\n      col.col-rosterRankIcon,\n      col.col-rosterRank {\n        width: 0;\n        min-width: 0;\n      }\n\n      col.col-rosterMoniker {\n        width: calc(485px);\n        min-width: 0;\n      }\n    }\n\n    .roster-secondary-inner-table tbody tr.roster-row-secondary-inner {\n      cursor: pointer;\n      transition:\n        background 0.2s ease,\n        box-shadow 0.25s ease,\n        filter 0.2s ease;\n      border-radius: 8px;\n      overflow: hidden;\n      filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.45));\n      background: rgba(0, 0, 0, 0.14);\n      box-shadow:\n        inset 0 1px 0 rgba(255, 255, 255, 0.14),\n        inset 0 -1px 0 rgba(0, 0, 0, 0.2);\n\n      &:has(.roster-moniker__donor-gem .donor-gem-badge__wrap:hover),\n      &:has(.roster-moniker__donor-gem .donor-gem-badge__wrap:focus-within) {\n        overflow: visible;\n        position: relative;\n        z-index: 6;\n      }\n\n      td {\n        background: transparent;\n        box-shadow: none;\n      }\n\n      &:hover:not(.selected-row) {\n        background: rgba(37, 64, 85, 0.8);\n        box-shadow:\n          inset 0 1px 0 rgba(255, 255, 255, 0.16),\n          inset 0 -1px 0 rgba(0, 0, 0, 0.18);\n        filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.55));\n      }\n\n      &.selected-row {\n        background: rgba(24, 47, 67, 0.8);\n        box-shadow:\n          inset 0 1px 0 rgba(255, 255, 255, 0.1),\n          inset 0 -1px 0 rgba(0, 0, 0, 0.18),\n          inset 0 0 10px rgba(61, 150, 177, 0.4);\n        filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.5))\n          drop-shadow(0 0 12px rgba(61, 150, 177, 0.15));\n        transition: background 0.25s ease, box-shadow 0.25s ease;\n      }\n\n      &.selected-row:hover {\n        background: rgba(37, 64, 85, 0.8);\n        box-shadow:\n          inset 0 1px 0 rgba(255, 255, 255, 0.12),\n          inset 0 -1px 0 rgba(0, 0, 0, 0.16),\n          inset 0 0 10px rgba(61, 150, 177, 0.4);\n        filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.55))\n          drop-shadow(0 0 14px rgba(61, 150, 177, 0.22));\n      }\n\n      &.roster-row--current-user {\n        background:\n          linear-gradient(\n            165deg,\n            rgba(95, 175, 205, 0.14) 0%,\n            rgba(61, 150, 177, 0.07) 50%,\n            rgba(35, 75, 105, 0.11) 100%\n          ),\n          rgba(0, 0, 0, 0.14);\n        box-shadow:\n          inset 0 1px 0 rgba(255, 255, 255, 0.14),\n          inset 0 -1px 0 rgba(0, 0, 0, 0.2),\n          inset 0 0 0 2px rgba(61, 150, 177, 0.44),\n          inset 0 0 28px rgba(61, 150, 177, 0.14);\n      }\n\n      &.roster-row--current-user:hover:not(.selected-row) {\n        background:\n          linear-gradient(\n            165deg,\n            rgba(95, 175, 205, 0.16) 0%,\n            rgba(61, 150, 177, 0.09) 50%,\n            rgba(35, 75, 105, 0.13) 100%\n          ),\n          rgba(37, 64, 85, 0.8);\n        box-shadow:\n          inset 0 1px 0 rgba(255, 255, 255, 0.16),\n          inset 0 -1px 0 rgba(0, 0, 0, 0.18),\n          inset 0 0 0 2px rgba(100, 200, 230, 0.5),\n          inset 0 0 32px rgba(61, 150, 177, 0.18);\n        filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.55));\n      }\n\n      &.roster-row--current-user.selected-row {\n        background:\n          linear-gradient(\n            165deg,\n            rgba(95, 175, 205, 0.15) 0%,\n            rgba(61, 150, 177, 0.08) 50%,\n            rgba(35, 75, 105, 0.12) 100%\n          ),\n          rgba(24, 47, 67, 0.8);\n        box-shadow:\n          inset 0 1px 0 rgba(255, 255, 255, 0.1),\n          inset 0 -1px 0 rgba(0, 0, 0, 0.18),\n          inset 0 0 0 2px rgba(61, 150, 177, 0.5),\n          inset 0 0 22px rgba(61, 150, 177, 0.55);\n        filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.5))\n          drop-shadow(0 0 12px rgba(61, 150, 177, 0.15));\n      }\n\n      &.roster-row--current-user.selected-row:hover {\n        background:\n          linear-gradient(\n            165deg,\n            rgba(95, 175, 205, 0.16) 0%,\n            rgba(61, 150, 177, 0.09) 50%,\n            rgba(35, 75, 105, 0.13) 100%\n          ),\n          rgba(37, 64, 85, 0.8);\n        box-shadow:\n          inset 0 1px 0 rgba(255, 255, 255, 0.12),\n          inset 0 -1px 0 rgba(0, 0, 0, 0.16),\n          inset 0 0 0 2px rgba(100, 200, 230, 0.52),\n          inset 0 0 22px rgba(61, 150, 177, 0.58);\n        filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.55))\n          drop-shadow(0 0 14px rgba(61, 150, 177, 0.22));\n      }\n    }\n\n    // Moniker interference: paint-only layers (no mix-blend / isolation) so layout and child rows\n    // are unchanged; pseudo-elements are out-of-flow and must not affect table width.\n    tbody.content tr.roster-row.roster-row--moniker-interference {\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        inset: 0;\n        z-index: 1;\n        pointer-events: none;\n        border-radius: 8px;\n        width: 100%;\n        height: auto;\n        max-width: none;\n        margin: 0;\n        padding: 0;\n        opacity: 0.55;\n        background-image:\n          repeating-linear-gradient(\n            180deg,\n            rgba(0, 0, 0, 0) 0,\n            rgba(0, 0, 0, 0) 2px,\n            rgba(140, 210, 255, 0.42) 2px,\n            rgba(140, 210, 255, 0.42) 3px,\n            rgba(0, 0, 0, 0) 3px,\n            rgba(0, 0, 0, 0) 6px,\n            rgba(255, 255, 255, 0.12) 6px,\n            rgba(255, 255, 255, 0.12) 7px,\n            rgba(0, 0, 0, 0) 7px,\n            rgba(0, 0, 0, 0) 10px\n          ),\n          repeating-linear-gradient(\n            180deg,\n            rgba(0, 0, 0, 0) 0,\n            rgba(0, 0, 0, 0) 4px,\n            rgba(60, 100, 140, 0.35) 4px,\n            rgba(60, 100, 140, 0.35) 5px,\n            rgba(0, 0, 0, 0) 5px,\n            rgba(0, 0, 0, 0) 11px\n          );\n        background-size: 100% 10px, 100% 11px;\n        animation:\n          roster-hidden-rf-hlines-vibrate 0.11s steps(2, end) infinite,\n          roster-hidden-rf-hlines-drift 1.4s linear infinite;\n      }\n\n      &::after {\n        content: '';\n        position: absolute;\n        inset: 0;\n        z-index: 2;\n        pointer-events: none;\n        border-radius: 8px;\n        width: 100%;\n        height: auto;\n        max-width: none;\n        margin: 0;\n        padding: 0;\n        background: repeating-linear-gradient(\n          180deg,\n          transparent 0,\n          transparent 1px,\n          rgba(0, 0, 0, 0.22) 1px,\n          rgba(0, 0, 0, 0.22) 2px\n        );\n        opacity: 0.45;\n        animation:\n          roster-hidden-rf-hlines-vibrate 0.14s steps(3, end) infinite reverse,\n          roster-hidden-rf-scan 2.2s linear infinite;\n      }\n\n      @media (prefers-reduced-motion: reduce) {\n        &::before,\n        &::after {\n          animation: none;\n          opacity: 0.35;\n        }\n      }\n    }\n\n    tbody.content tr.roster-row.roster-row--moniker-interference-red {\n      &::before {\n        opacity: 0.6;\n        background-image:\n          repeating-linear-gradient(\n            180deg,\n            rgba(0, 0, 0, 0) 0,\n            rgba(0, 0, 0, 0) 2px,\n            rgba($red, 0.48) 2px,\n            rgba($red, 0.48) 3px,\n            rgba(0, 0, 0, 0) 3px,\n            rgba(0, 0, 0, 0) 6px,\n            rgba(255, 200, 200, 0.14) 6px,\n            rgba(255, 200, 200, 0.14) 7px,\n            rgba(0, 0, 0, 0) 7px,\n            rgba(0, 0, 0, 0) 10px\n          ),\n          repeating-linear-gradient(\n            180deg,\n            rgba(0, 0, 0, 0) 0,\n            rgba(0, 0, 0, 0) 4px,\n            rgba(darken($red, 8%), 0.4) 4px,\n            rgba(darken($red, 8%), 0.4) 5px,\n            rgba(0, 0, 0, 0) 5px,\n            rgba(0, 0, 0, 0) 11px\n          );\n      }\n\n      &::after {\n        background: repeating-linear-gradient(\n          180deg,\n          transparent 0,\n          transparent 1px,\n          rgba($red, 0.28) 1px,\n          rgba($red, 0.28) 2px\n        );\n        opacity: 0.5;\n      }\n\n      @media (prefers-reduced-motion: reduce) {\n        &::before,\n        &::after {\n          animation: none;\n          opacity: 0.4;\n        }\n      }\n    }\n\n    .roster-moniker--masked-label {\n      display: inline-block;\n      position: relative;\n      min-width: 4.25rem;\n      padding: 0.1em 0.15em;\n      font-family: ui-monospace, 'Cascadia Mono', 'Segoe UI Mono', monospace;\n      font-size: 0.88em;\n      letter-spacing: 0.14em;\n      text-transform: uppercase;\n      color: rgba(195, 208, 220, 0.82);\n      animation: roster-hidden-rf-flicker 0.18s steps(2, end) infinite;\n\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n\n    tbody.content tr.roster-row.roster-row--moniker-interference-red .roster-moniker--masked-label {\n      color: rgba(lighten($red, 38%), 0.9);\n      animation: roster-redacted-rf-flicker 0.18s steps(2, end) infinite;\n\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n\n    .roster-moniker--secondary-affiliation.roster-moniker--masked-label {\n      display: inline-block;\n      position: relative;\n      padding-left: 0.65rem;\n      border-left: 1px solid rgba($accent-blue, 0.45);\n      margin-left: 0.12rem;\n      color: rgba(195, 208, 220, 0.82);\n      font-size: 0.88em;\n    }\n\n    tbody.content tr.roster-row.roster-row--moniker-interference-red\n      .roster-moniker--secondary-affiliation.roster-moniker--masked-label {\n      border-left-color: rgba($red, 0.65);\n      color: rgba(lighten($red, 38%), 0.9);\n    }\n\n    .roster-moniker--secondary-affiliation:not(.roster-moniker--masked-label) {\n      display: inline-block;\n      padding-left: 0.65rem;\n      position: relative;\n      font-size: 0.92em;\n      color: rgba(230, 234, 240, 0.9);\n\n      &::before {\n        content: '';\n        position: absolute;\n        left: 0.15rem;\n        top: 0.28em;\n        bottom: 0.28em;\n        width: 1px;\n        border-radius: 0.5px;\n        background: rgba($accent-blue, 0.45);\n      }\n    }\n\n    // Masked roster rows (hidden/redacted for current viewer): keep layout, block interaction.\n    tbody.content tr.roster-row.roster-row--masked {\n      cursor: default;\n    }\n\n    tbody.content tr.roster-row.roster-row--masked:hover {\n      background: inherit;\n      box-shadow: none;\n      filter: none;\n    }\n\n    .roster-masked-cell {\n      display: inline-block;\n      width: 100%;\n      user-select: none;\n    }\n  }\n\n  &.training-references {\n    colgroup {\n      col.col-accessorKey     { width:  auto;}\n      col.col-version         { width:  75px;}\n      col.col-theme           { width: 110px;}\n      col.col-trainingLevel   { width: 110px;}\n      col.col-actions         { width:  60px;}\n    }\n  }\n\n  &.equivalences-rules, \n  &.equivalences-items {\n    colgroup {\n      col.col-eventTemplate { width:  auto;}\n      col.col-templateId    { width: 100px;}\n      col.col-priority      { width:  35px;}\n      col.col-validFrom     { width:  80px;}\n      col.col-validTo       { width:  80px;}\n      col.col-actions       { width:  50px;}\n    }\n\n    td {\n      font-size: 13px;\n    }\n  }\n\n  &.equivalences-requirements {\n    colgroup {\n      col.col-code            { width:  auto;}\n      col.col-label           { width:  auto;}\n      col.col-theme           { width: 170px;}\n      col.col-trainingLevel   { width: 150px;}\n    }\n\n    td {\n      font-size: 13px;\n    }\n  }\n\n  // admin permissions/groups\n  &.groups,\n  &.roles {\n    .table-body-wrapper {\n      max-height: 250px;\n    }\n  }\n\n  &.carousel {\n\n    th.header-action {\n      font-size: 0;\n      line-height: 0;\n      padding: 0;\n    }\n\n    // container for action icons\n    .action-cell-container {\n      display: flex;\n      align-items: center;\n    }\n\n      // Par défaut : pas de poubelle\n      .delete-media {\n        display: none;\n      }\n      // mais si la row est sélectionnée :\n      tr.selected-row .delete-media {\n        display: inline-block;\n        max-height: 20px; // comme avant\n        transform: translateX(-10px);\n      }\n\n    // position trash icon on right, center vertically\n    .delete-container {\n      display: flex;\n      align-items: center;\n      margin-left: auto;\n    }\n\n    @include dnd-handle;\n  } \n\n  &.permissions table {\n    colgroup {\n      col.col-handle            { width:  20px; }\n      col.col-displayName       { width: 150px; }\n      col.col-resourceKey       { width: 100px; }\n      col.col-description       { width: 250px; }\n    }\n\n    .cell-handle {\n      cursor: grab;\n    }\n  }\n\n  &.discord-channels table {\n    colgroup {\n      col.col-name           { width: 200px; }\n      col.col-channelType    { width: 80px; }\n      col.col-channelId      { width: 150px; }\n    }\n  }\n\n\n  &.templates {\n    th.header-eventName {\n      vertical-align: middle;\n\n      .header-content {\n        align-items: center;\n      }\n\n      .template-event-name-header {\n        flex: 1 1 auto;\n        min-width: 0;\n        width: 100%;\n        display: flex;\n        align-items: center;\n      }\n\n      .template-event-name-search {\n        width: 100%;\n        font-size: 11px;\n        padding: 2px 6px;\n        min-height: 0;\n        height: 22px;\n        line-height: 1.2;\n        box-sizing: border-box;\n        border-radius: 6px;\n      }\n    }\n\n    table {\n      colgroup {\n        col.col-eventName             { width: 220px; }\n        col.col-type                  { width: 70px; }\n        col.col-subtype               { width: 120px; }\n        col.col-orgDivisions          { width: 150px; }\n        col.col-equivalentTraining    { width: 110px; }\n        col.col-ribbon                { width: 130px; }\n        col.col-templateStatus        { width:  60px; }\n      }\n    }\n  }\n\n  &.types {\n    width: 240px;\n\n    table {\n      colgroup {\n        col.col-type  { width: 110px; }\n        col.col-found { width: 55px; }\n      }\n    }\n\n    .cell-found .status-indicator {\n      width: 16px;\n      height: 16px;\n    }\n  }\n\n  &.subtypes {\n    width: 250px;\n\n    table {\n      colgroup {\n        col.col-subType   { width: 150px; }\n        col.col-status    { width:  100px; }\n      }\n    }\n\n    .cell-status .status-indicator {\n      width: 16px;\n      height: 16px;\n    }\n\n    .table-body-wrapper {\n      max-height: 170px;\n    }\n  }\n\n  &.ranks {\n    table {\n      colgroup {\n        col.col-payGrade           { width:  48px; }  // P‑G\n        col.col-rankName           { width: auto; }  // Rang\n        col.col-rankImageUrl       { width:  60px; }  // Insigne\n        col.col-globalTokens       { width:  70px; }  // Global\n        col.col-missionTokens      { width:  70px; }  // Mission\n        col.col-timeOnPreviousRank { width:  70px; }  // ToPR\n        col.col-certificationIds   { width: 210px; }  // Certification (multi)\n        col.col-courseIds,\n        col.col-grantAccess        { width: 12rem; }  // Required courses / Grant access to\n        col.col-lockStatus         { width:  55px; }  // Lock\n        col.col-memberCount   { width: 100px; }\n        col.col-statusRanks   { width: 80px; }\n        col.col-secGroupId    { width: 200px; }\n      }\n\n      .cell-secGroupId .rank-sec-group-dropdown {\n        width: 100%;\n        max-width: 190px;\n      }\n\n      .cell-rankImageUrl img {\n        max-width: 20px;\n        display: block;    // pour éviter les comportements inline étranges\n        margin: 0 auto;    // centrer si nécessaire\n      }\n    }\n  }\n\n  // Academy → org tokens / rank requirements only (not RankTable.jsx — that one has no modifier)\n  &.ranks.ranks-requirements-table {\n    tbody tr {\n      height: auto;\n      min-height: 45px;\n    }\n\n    tbody td {\n      vertical-align: top;\n      padding-top: 8px;\n      padding-bottom: 8px;\n      overflow: visible;\n    }\n\n    td.cell-certificationIds,\n    td.cell-courseIds,\n    td.cell-grantAccess {\n      vertical-align: top;\n      overflow: hidden;\n      max-width: 0;\n    }\n\n    // react-dropdown-tree-select (see ant-tree-select.scss / CertificationsTreeSelect)\n    .certificationsSelect {\n      min-width: 0;\n      width: 100%;\n      max-width: 100%;\n\n      .hierarchy-select-container {\n        width: 100%;\n        max-width: 100%;\n        min-width: 0;\n      }\n    }\n  }\n\n  &.ribbons {\n    table {\n      colgroup {\n        col.col-ribbonName       { width: 140px; }\n        col.col-ribbon           { width: 100px; }\n        col.col-description      { width: 300px; }\n        col.col-qtyRequirement   { width:  55px; }\n        col.col-status           { width:  45px; }\n      }\n    }\n  }\n  \n  &.organization-logs {\n    //width: 750px;\n    width: min-content;\n\n    table {\n      width: -webkit-fill-available;\n      colgroup {\n        col.col-logTimestamp    { width: 190px; } \n        col.col-handle          { width: 170px; }\n        col.col-action          { width: 270px; text-align: left; }\n        col.col-targetHandle    { width: 170px; }\n      }\n    }\n  }\n\n  &.organization-applications {\n    width: 400px;\n\n    thead th.applications-table-header-strip {\n      height: auto;\n      min-height: 34px;\n      padding: 8px 12px;\n      vertical-align: middle;\n      text-transform: none;\n      font-weight: normal;\n    }\n\n    .applications-table-toolbar {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      min-width: 0;\n    }\n\n    .applications-table-search {\n      flex: 1;\n      min-width: 0;\n      padding: 0.25rem 0.4rem;\n      font-size: 0.9rem;\n      border: 1px solid #ddd;\n      border-radius: 4px;\n    }\n\n    .table-body-wrapper {\n      min-height: 200px;\n    }\n\n    table {\n      colgroup {\n        col.col-sentDate { width: 85px; }\n        col.col-handle   { width: 115px; }\n      }\n    }\n  }\n\n  col.col-subtitle   { width: 200px; }\n  col.col-mediaType  { width: 100px; }\n  col.col-size       { width:  80px; }\n  col.col-action     { width:  80px; }\n\n  &.handles {\n    width: 700px;\n    // 1️⃣ Largeurs spécifiques pour le <thead> ET le <tbody>\n\n    table {\n      colgroup {\n        col.col-handle          { width: 200px; } // RSI handle\n        col.col-moniker         { width: 150px; }\n        col.col-rsi             { width:  50px; }\n        col.col-membership      { width: 120px; }\n        col.col-master          { width:  80px; }\n        col.col-certification   { width:  50px; }\n      }\n    }\n  \n    // 2️⃣ Limiter la taille des SVG dans les colonnes status\n    .table-body-wrapper {\n      td.cell-certified .status-cell img,\n      td.cell-handleStatus .status-cell img {\n        max-width: 50px;\n        max-height: 30px;\n        display: block;\n        margin: 0 auto;\n      }\n\n      // style for membership labels in the Membership column\n      td.cell-membership .membership-label {\n        display: flex;\n        color: black;\n        font-size: 0.75rem;\n        width: fit-content;\n        justify-self: center;\n        padding: 3px 8px;\n        border-radius: 4px;\n\n        &.membership-main {\n          background-color: #d0ebff;\n          color: #004085;\n        }\n\n        &.membership-exclusive {\n          background-color: rgb(38, 170, 93);\n          box-shadow: 0 0 8px rgba(30, 160, 73, 0.8);\n\n          &:hover {\n            border: 1px solid #a7ffa7;\n          }\n        }\n\n        &.membership-affiliate {\n          color: black;\n          background-color: #b38b0a; \n          box-shadow: 0 0 8px rgba(197, 169, 46, 0.8);\n\n          &:hover {\n            border: 1px solid #dfc05b;\n          }\n        }\n\n        &.membership-none {\n          background-color: #eee;\n          color: #666;\n        }\n      }\n    }\n\n    th.header-master,\n    td.cell-master {\n      text-align: center !important;\n    }\n\n    td.cell-master .master-flag {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 18px;\n      color: #d4af37;\n    }\n\n  }\n\n  &.allies {\n    table {\n      colgroup {\n        col.col-createdAt     { width: 180px; }\n        col.col-orgName       { width: 200px; }\n        col.col-orgLogo       { width:  60px; }\n        col.col-rsiLink       { width:  50px; }\n        col.col-discordLink   { width:  50px; }\n        col.col-guildedLink   { width:  50px; }\n        col.col-websiteLink   { width:  50px; }\n        col.col-statusAllied  { width:  50px; }\n      }\n\n      td.cell-orgLogo img,\n      td.cell-statusAllied {\n        max-height: 20px;\n        max-width: 20px;\n        display: block;\n        margin: 0 auto;\n      }\n    }\n  }\n\n  &.public-pages {\n    width: 65%;\n\n    table {\n      colgroup {\n        col.col-createdAt       { width: 110px; }\n        col.col-versionNumber   { width:  75px; }\n        col.col-status          { width:  75px; }\n        col.col-lastEditorName  { width: 250px; }\n      }\n    }\n  }\n\n  &.mcq-versions-table {\n    col.col-updatedAt       { width: 160px; }\n    col.col-version         { width:  75px; }\n    col.col-statusCode      { width: 100px; }\n    col.col-author          { width: 222px; }\n\n    .table-body-wrapper {\n      max-height: 170px;\n      min-height: 150px;\n\n      .live-version-row {\n        text-transform: uppercase;\n        font-weight: bold;\n        height: 30px;\n        border: 2px solid transparent;\n        background: linear-gradient(to top, $orange, $dark-orange, $orange);\n        cursor: pointer;\n\n        &.selected {\n          background: linear-gradient(to top, $darker-green, $darker-green, $dark-green, $darker-green, $darker-green);\n          color: $very-light-grey;  \n        }\n\n        td {\n          text-align: center;\n        }\n      }\n\n      .version-row {\n        &.selected {\n          background: $grey;\n          color: $very-light-grey;  \n        }\n      }\n    }\n  }\n\n    &.checklist-versions-table{\n    col.col-updatedAt       { width: 160px; }\n    col.col-version         { width:  75px; }\n    col.col-statusCode      { width: 100px; }\n    col.col-author          { width: 222px; }\n\n    .table-body-wrapper {\n      max-height: 170px;\n      min-height: 150px;\n\n      .live-version-row {\n        text-transform: uppercase;\n        font-weight: bold;\n        height: 30px;\n        border: 2px solid transparent;\n        background: linear-gradient(to top, $orange, $dark-orange, $orange);\n        cursor: pointer;\n\n        &.selected {\n          background: linear-gradient(to top, $darker-green, $darker-green, $dark-green, $darker-green, $darker-green);\n          color: $very-light-grey;  \n        }\n\n        td {\n          text-align: center;\n        }\n      }\n\n      .version-row {\n        &.selected {\n          background: $grey;\n          color: $very-light-grey;  \n        }\n      }\n    }\n  }\n\n  &.themes-panel {\n    col.col-themeName     { width: 250px; }\n    col.col-found         { width: 100px; }\n\n    .table-body-wrapper {\n      max-height: 135px;\n    }\n  }\n\n    &.training-levels {\n    col.col-levelName     { width: 250px; }\n    col.col-found         { width: 100px; }\n\n    .table-body-wrapper {\n      max-height: 135px;\n    }\n  }\n  \n}\n\n\n  .role-checkbox {\n    width: 20px;\n    height: 20px;\n    border-radius: 50%; // English: make it round\n    border: 1px solid $light-grey; // English: gray border when unchecked\n    appearance: none;\n    background-color: transparent;\n    cursor: pointer;\n    position: relative;\n\n    &:checked {\n        background-color: $light-green; // English: red background when checked\n        border-color: $dark-green;\n\n        &::after {\n        content: \"\";\n        position: absolute;\n        top: 3px;\n        left: 6px;\n        width: 4px;\n        height: 8px;\n        border: solid $very-light-grey;\n        border-width: 0 2px 2px 0;\n        transform: rotate(45deg);\n        }\n    }\n}\n\n.table-body-wrapper {\n  position: relative;\n  overflow: visible; // ← critical change\n}\n\n// Rank requirements: tree dropdown panels need room above sibling layout\n.academy-admin-page .ts-panel--ranks-requirements {\n  overflow: visible;\n}\n\n\n.handle-cell {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n\n  .tooltip-wrapper {\n    position: relative;\n    display: inline-block;\n  }\n\n  .warning-icon {\n    margin-left: 4px;\n    cursor: pointer;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n\n.floating-warning-tooltip.global {\n  position: fixed;\n  z-index: 9999;\n  background: $very-dark-grey;\n  color: $very-light-grey;\n  border: 1px solid $very-light-grey;\n  border-radius: 4px;\n  padding: 6px 8px;\n  font-size: 12px;\n  white-space: nowrap;\n  pointer-events: none;\n  opacity: 1;\n}\n\n.warning-icon {\n  display: inline-block;\n  margin-left: 4px;\n  cursor: pointer;\n  vertical-align: middle; // empêche le saut de ligne\n}\n\n.status-dot {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n}\n\n.status-green {\n  background-color: #4fad81; // émeraude\n  box-shadow: 0 0 8px rgba(79, 202, 134, 0.8);\n}\n\n.status-red {\n  background-color: #e74c3c;\n}\n\n.status-blue {\n  background-color: #3498db;\n}\n\n.status-orange {\n  background-color: #ffa600; // doré\n  box-shadow: 0 0 8px rgba(255, 202, 104, 0.8);\n}\n\n.status-grey {\n  background-color: #7f8c8d;\n}\n\n.cell-missionToken {\n  text-align-last: center;\n}\n.cell-eventToken {\n  text-align-last: center;\n}\n.cell-totalToken {\n  text-align-last: center;\n}\n\n.affiliation {\n  display: flex;\n  font-size: 0.7rem;\n  font-weight: 600;\n  width: fit-content;\n  justify-self: center;\n  padding: 3px 8px;\n  border-radius: 4px;\n  border: 1px solid transparent;\n  letter-spacing: 0.02em;\n\n  &.exclusive {\n    color: $very-dark-orange;\n    background:\n      linear-gradient(\n        105deg,\n        transparent 38%,\n        rgba($pure-white, 0.4) 50%,\n        transparent 62%\n      ),\n      linear-gradient(\n        155deg,\n        lighten($very-light-orange, 14%) 0%,\n        #f0d060 14%,\n        lighten($light-orange, 6%) 32%,\n        #b4a663 48%,\n        lighten($orange, 10%) 62%,\n        lighten(#c9a227, 8%) 78%,\n        lighten($very-light-orange, 10%) 100%\n      );\n    border-color: lighten($light-orange, 12%);\n    box-shadow:\n      0 0 8px rgba(212, 175, 55, 0.75),\n      inset 0 1px 0 rgba($pure-white, 0.45),\n      inset 0 -1px 1px rgba($dark-orange, 0.16);\n    text-shadow: 0 1px 0 rgba($pure-white, 0.25);\n\n    &:hover {\n      border-color: lighten($very-light-orange, 8%);\n      box-shadow:\n        0 0 12px rgba(255, 215, 80, 0.9),\n        inset 0 1px 0 rgba($pure-white, 0.5),\n        inset 0 -1px 1px rgba($dark-orange, 0.2);\n    }\n  }\n\n  &.affiliated {\n    color: $dark-blue-grey;\n    background:\n      linear-gradient(\n        105deg,\n        transparent 38%,\n        rgba($pure-white, 0.5) 50%,\n        transparent 62%\n      ),\n      linear-gradient(\n        155deg,\n        $pure-white 0%,\n        $very-light-grey 16%,\n        lighten($light-grey, 8%) 34%,\n        lighten($very-light-grey, 4%) 50%,\n        lighten($medium-light-grey, 12%) 68%,\n        lighten($light-grey, 6%) 84%,\n        $very-light-grey 100%\n      );\n    border-color: lighten($light-grey, 6%);\n    box-shadow:\n      0 0 8px rgba($light-grey, 0.7),\n      inset 0 1px 0 rgba($pure-white, 0.55),\n      inset 0 -1px 1px rgba($medium-grey, 0.12);\n    text-shadow: 0 1px 0 rgba($pure-white, 0.4);\n\n    &:hover {\n      border-color: $pure-white;\n      box-shadow:\n        0 0 12px rgba($very-light-grey, 0.95),\n        inset 0 1px 0 rgba($pure-white, 0.65),\n        inset 0 -1px 1px rgba($medium-grey, 0.15);\n    }\n  }\n\n  &.outsider {\n    color: $medium-light-grey;\n    background: linear-gradient(\n      155deg,\n      lighten($grey, 8%) 0%,\n      $medium-grey 50%,\n      darken($grey, 4%) 100%\n    );\n    border-color: $medium-grey;\n    box-shadow:\n      0 0 6px rgba($grey, 0.45),\n      inset 0 1px 0 rgba($pure-white, 0.08);\n    text-shadow: none;\n    font-style: italic;\n\n    &:hover {\n      border-color: lighten($medium-grey, 8%);\n      box-shadow:\n        0 0 8px rgba($medium-grey, 0.55),\n        inset 0 1px 0 rgba($pure-white, 0.12);\n    }\n  }\n}\n\n.certification-icon {\n  display: inline-block;\n  width: 30px;\n  height: 30px;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  //transition: filter 0.3s ease, box-shadow 0.3s ease;\n}\n\n.certified {\n  background-image: url(\"../medias/shield_green.png\");\n  opacity: 1;\n\n  &:hover {\n    filter: drop-shadow(0 0 10px rgba(0, 255, 170, 0.9))\n            drop-shadow(0 0 20px rgba(0, 255, 170, 0.6));\n    animation: certified-glow-hover 2.5s ease-in-out infinite;\n  }\n\n  &.formerly-certified {\n    opacity: 0.4;\n    filter: grayscale(0.75);\n\n    &:hover {\n      filter: grayscale(0.35) drop-shadow(0 0 6px rgba(0, 255, 170, 0.35));\n      animation: none;\n    }\n  }\n}\n\n.uncertified {\n  background-image: url(\"../medias/shield_grey.png\");\n  opacity: 0.2;\n}\n\n/* Glow léger par défaut */\n@keyframes certified-glow {\n  0%, 100% {\n    filter: drop-shadow(0 0 4px rgba(0, 255, 170, 0.25))\n            drop-shadow(0 0 10px rgba(0, 255, 170, 0.15));\n  }\n  50% {\n    filter: drop-shadow(0 0 8px rgba(0, 255, 170, 0.4))\n            drop-shadow(0 0 14px rgba(0, 255, 170, 0.3));\n  }\n}\n\n/* Glow plus intense au survol */\n@keyframes certified-glow-hover {\n  0%, 100% {\n    filter: drop-shadow(0 0 8px rgba(0, 255, 170, 0.6))\n            drop-shadow(0 0 18px rgba(0, 255, 170, 0.4));\n  }\n  50% {\n    filter: drop-shadow(0 0 14px rgba(0, 255, 170, 1))\n            drop-shadow(0 0 26px rgba(0, 255, 170, 0.9));\n  }\n}\n\n// Site admin — all organizations + whitelist toggle\n.table-base.orgs-whitelist {\n  th.header-logo,\n  td.cell-logo,\n  th.header-whitelisted,\n  td.cell-whitelisted,\n  th.header-blacklisted,\n  td.cell-blacklisted {\n    text-align: center;\n    vertical-align: middle;\n  }\n\n  th.header-commentEdit,\n  td.cell-commentEdit {\n    text-align: left;\n    vertical-align: top;\n  }\n\n  th.header-commentSave,\n  td.cell-commentSave {\n    text-align: center;\n    vertical-align: middle;\n  }\n\n  table col.col-logo {\n    max-width: 90px;\n  }\n\n  table col.col-orgSid {\n    max-width: 100px;\n  }\n\n  table col.col-whitelisted,\n  table col.col-blacklisted {\n    max-width: 75px;\n  }\n\n  .orgs-comment-edit-textarea {\n    width: 100%;\n    max-width: none;\n    min-height: 4.5rem;\n    box-sizing: border-box;\n    resize: vertical;\n    font-size: 0.9rem;\n  }\n\n  .orgs-comment-save-btn {\n    white-space: nowrap;\n  }\n\n  td.cell-whitelisted,\n  td.cell-blacklisted {\n    .toggle.orgs-whitelist-toggle {\n      min-width: 0;\n    }\n\n    .orgs-whitelist-toggle-switch.toggle-switch {\n      width: $toggle-orgs-table-track-width-tight;\n    }\n\n    .orgs-whitelist-toggle-switch.toggle-switch .toggle-switch__thumb {\n      height: $toggle-orgs-table-thumb-size-tight;\n      width: $toggle-orgs-table-thumb-size-tight;\n    }\n\n    .toggle.orgs-whitelist-toggle input:checked ~ .orgs-whitelist-toggle-switch .toggle-switch__thumb {\n      transform: translateX($toggle-orgs-table-thumb-travel-tight);\n    }\n  }\n\n  .orgs-whitelist-no-logo {\n    color: $grey;\n  }\n\n  .orgs-whitelist-logo {\n    display: block;\n    object-fit: contain;\n    margin-left: auto;\n    margin-right: auto;\n    width: auto;\n    height: auto;\n  }\n\n  .orgs-whitelist-logo--small {\n    max-width: 40px;\n    max-height: 40px;\n  }\n\n  .orgs-whitelist-logo--medium {\n    max-width: 64px;\n    max-height: 64px;\n  }\n\n  .orgs-whitelist-logo--large {\n    max-width: 88px;\n    max-height: 88px;\n  }\n\n  .toggle.orgs-whitelist-toggle {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: auto;\n    min-width: 36px;\n    height: auto;\n    min-height: 22px;\n    margin: 0 auto;\n    position: relative;\n    bottom: 0;\n    text-transform: none;\n    font-weight: normal;\n    cursor: pointer;\n  }\n\n  .orgs-whitelist-toggle-switch.toggle-switch {\n    position: relative;\n    top: auto;\n    left: auto;\n    right: auto;\n    bottom: auto;\n    width: $toggle-orgs-table-track-width;\n    height: $toggle-orgs-table-track-height;\n    margin: 0;\n    cursor: pointer;\n  }\n\n  .orgs-whitelist-toggle-switch.toggle-switch .toggle-switch__thumb {\n    height: $toggle-orgs-table-thumb-size;\n    width: $toggle-orgs-table-thumb-size;\n    top: -2px;\n  }\n\n  .toggle.orgs-whitelist-toggle input:checked ~ .orgs-whitelist-toggle-switch .toggle-switch__thumb {\n    transform: translateX($toggle-orgs-table-thumb-travel);\n  }\n\n  .toggle.orgs-whitelist-toggle input:disabled + .orgs-whitelist-toggle-switch {\n    opacity: 0.5;\n    cursor: wait;\n  }\n}","// src/styles/diagram.scss\n\n@import '../variables.scss';\n\n.desktop-view {\n    display: flex;\n    flex-direction: row;\n    height: 250px;\n    margin-bottom: 30px;\n    border-bottom: 3px solid $grey;\n\n    .division-description-logo {\n        display: flex;\n        flex-direction: column;\n        position: fixed;\n        float:left;\n        width: 280px;\n        height: 250px;\n\n        .division-title {\n            position: relative;\n            width: 100%;\n            text-transform: uppercase;\n            margin: 15px auto 0px auto;\n            text-align: center;\n        }\n\n        .division-logo {\n            position: relative;\n            width: 120px;\n            height: auto;\n            margin: 0px auto 0 auto;\n            top: \t12%;\n        }\n\n        &::after {\n            content: '';\n            position: absolute;\n            top: 55px;\n            right: 0;\n            height: calc(100% - 90px);\n            width: 3px; // Largeur du trait\n            background-color: $grey; // Couleur du trait\n        }\n    }\n\n    .division-description-content {\n        .division-description {\n            position: relative;\n            overflow-y: auto; \n            max-height: 150px;\n            padding: 5px 10px 5px 0px;\n            margin-top: 50px;\n            text-align: justify;\n            padding-left: 300px;\n            @include scrollbar-styles;\n        }\n    }\n}\n\n// =======================// \n\n\n.tree-node {\n    display: flex;\n    flex-direction: row; \n    font-size: 0.75rem;\n    border-radius: 8px;\n    margin: 5px;\n    padding: 8px;\n    box-shadow: rgba(52, 55, 58, 0.4) 0px -5px 8px 0px inset;\n    cursor: pointer;\n\n    &.tree-node--executive-root {\n        display: block;\n        width: calc(100% - 10px);\n        margin: 5px;\n        padding: 0;\n        border: none;\n        box-shadow: none;\n\n        &.selected {\n            outline: none;\n        }\n\n        .executive-root-banner {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            width: 100%;\n            box-sizing: border-box;\n        }\n\n        .executive-root-stars {\n            display: flex;\n            justify-content: center;\n            align-items: flex-end;\n            gap: 0.5rem;\n            margin-bottom: 0.25rem;\n        }\n\n        .executive-root-star {\n            color: #c8aa6e;\n            font-size: 0.5rem;\n            line-height: 1;\n        }\n\n        .executive-root-star--mid {\n            transform: translateY(-2px);\n            font-size: 0.62rem;\n        }\n\n        .executive-root-title-row {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 1rem;\n            width: 100%;\n            max-width: 28rem;\n            margin: 0 auto;\n        }\n\n        .executive-root-line {\n            flex: 1;\n            height: 1px;\n            background-color: #c8aa6e;\n            min-width: 2rem;\n            max-width: 10rem;\n            opacity: 0.95;\n        }\n\n        .executive-root-title {\n            margin: 0;\n            padding: 0 0.25rem;\n            text-align: center;\n            text-transform: uppercase;\n            font-family: inherit;\n            font-size: clamp(1rem, 2vw, 1.35rem);\n            font-weight: 700;\n            letter-spacing: 0.12em;\n            color: #ffffff;\n            line-height: 1.2;\n        }\n\n        .executive-root-sub {\n            margin: 0.65rem auto 0.15rem;\n            max-width: 32rem;\n            padding: 0 0.5rem;\n            text-align: center;\n            font-size: clamp(0.72rem, 1.5vw, 0.88rem);\n            font-style: italic;\n            color: #f0e6d2;\n        }\n\n        .executive-root-frame-line {\n            display: block;\n            width: 100%;\n            height: 40px;\n            margin: 0;\n        }\n    }\n\n    &.with-image {\n        border-width: 2px;\n        border-style: solid;\n\n        .division-image {\n            width: 32px;\n            height: auto;\n            max-height: 32px;\n            object-fit: contain;\n        }\n\n        .image-container {\n            width: 32px;\n            height: 32px;\n\n            .division-image {\n                width: 32px;\n                height: auto;\n                object-fit: contain;\n            }\n        }\n\n        .division-content {\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            width: 100%;\n            padding: 0px 5px 0px 5px;\n\n            .division-name {\n                font-weight: bolder;\n                text-transform: uppercase;\n            }\n        }\n    }\n\n    &.without-image {\n        border-width: 2px;\n        border-style: solid;\n\n        .division-content {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            width: 100%;\n            padding: 0px 5px 0px 5px;\n\n            .division-name {\n                font-weight: bolder;\n                text-transform: uppercase;\n            }\n        }\n    }\n\n    &:not(.tree-node--executive-root):hover {\n        border: 2px solid $very-light-grey !important;\n        box-shadow: rgba(4, 175, 255, 0.829) 0px 10px 20px -20px,\n    }\n}\n\n/* Niveau « Divisions » : enfants directs de l’exécutif (parent sans parent). */\n.tree-node.tree-node--org-division {\n    min-height: 56px;\n    padding: 10px 12px;\n    font-size: 0.8rem;\n\n    &.with-image {\n        .division-image {\n            width: 48px;\n            max-height: 48px;\n        }\n\n        .image-container {\n            width: 48px;\n            height: 48px;\n\n            .division-image {\n                width: 48px;\n                max-height: 48px;\n            }\n        }\n    }\n}\n\n/* Niveau « Branches » : sous une division — logos 50×50 px. */\n.tree-node.tree-node--org-branch {\n    &.with-image {\n        .division-image {\n            width: 50px;\n            height: 50px;\n            max-height: 50px;\n        }\n\n        .image-container {\n            width: 50px;\n            height: 50px;\n\n            .division-image {\n                width: 50px;\n                height: 50px;\n                max-height: 50px;\n            }\n        }\n    }\n}\n\n.tree-children {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n\n    .tree-column {\n        .division-content {\n            display: flex;\n            flex-direction: column;\n            align-items: flex-start; // Alignement des enfants à gauche\n    \n            .division-name {\n                text-align: left; // Assure que le texte est aligné à gauche\n            }\n        }\n    }\n}\n\n.tree-branch {\n    display: block;\n    width: -webkit-fill-available;\n}\n\n.tree-column {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n.redacted {\n    position: relative;\n    //color: transparent!important;\n    overflow: hidden; /* Pour éviter que le brouillage déborde des nœuds */\n  }\n  \n  .redacted::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    // background: repeating-linear-gradient(0deg,rgba(255, 0, 0, 0.3),rgba(255, 0, 0, 0.3) 2px,rgba(0, 0, 0, 0.2) 2px,rgba(0, 0, 0, 0.2) 4px);\n    background: rgba(39, 20, 20, 0.6);\n    //animation: noise 0.2s infinite;\n  }\n  \n  .redacted::after {\n    content: 'REDACTED';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    font-size: 1.8em; /* Taille du texte \"REDACTED\" */\n    //color: transparent !important;\n    white-space: nowrap;\n    opacity: 0; /* Masqué par défaut */\n    animation: none;\n  }\n  \n  .redacted:hover::after {\n    opacity: 1; /* Visible au survol */\n    color: red;\n    animation: textNoise 0.02s infinite; /* Effet statique sur le texte */\n  }\n  \n  @keyframes textNoise {\n    0%, 100% {\n      clip-path: inset(0 0 50% 0);\n    }\n    10% {\n      clip-path: inset(10% 0 40% 0);\n    }\n    20% {\n      clip-path: inset(20% 0 30% 0);\n    }\n    30% {\n      clip-path: inset(30% 0 20% 0);\n    }\n    40% {\n      clip-path: inset(40% 0 10% 0);\n    }\n    50% {\n      clip-path: inset(50% 0 0 0);\n    }\n    60% {\n      clip-path: inset(60% 0 50% 0);\n    }\n    70% {\n      clip-path: inset(70% 0 40% 0);\n    }\n    80% {\n      clip-path: inset(80% 0 30% 0);\n    }\n    90% {\n      clip-path: inset(90% 0 20% 0);\n    }\n  }\n\n.division-diagram-hint {\n    padding: 10px ;\n    //text-transform: uppercase;\n    font-style: italic;\n}\n\n\n//charts.js\n//\n\n.charts-types {\n    width: 100%;\n    height: 90%;\n}\n\n.charts-renderChart {\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n\n// MEDIAS\n//\n\n@media (max-width: $desktop) {\n\n    .mobile-view {\n        display: flex;\n        flex-direction: column;\n        height: 250px;\n        margin-bottom: 15px;\n        padding-bottom: 40px;\n        border-bottom: 3px solid $grey;\n\n        .division-description-logo {\n            display: flex;\n            flex-direction: row;\n            position: relative;\n            width: 100%;\n            height: auto;\n            margin-bottom: 15px;\n\n            .division-logo {\n                position: relative;\n                float:left;\n                width: 22px;\n                height: 22px;\n                margin: 0px auto 0 auto;\n            }\n    \n            .division-title {\n                position: relative;\n                width: 100%;\n                text-transform: uppercase;\n                margin: 0px 10px 0px 10px;\n                text-align: left;\n            }\n        }\n    \n        .division-description-content {\n            .division-description {\n                overflow-y: auto; \n                max-height: 200px;\n                padding: 5px 10px 5px 5px;\n                margin-bottom: 15px;\n                margin-top: 10px;\n                text-align: justify;\n                @include scrollbar-styles;\n            }\n        }\n    }\n    \n    .public-container {\n        width: 90%;\n    }\n    \n    .tree-branch {\n        width: 98%;\n        transition: max-width 0.3s ease-out;\n    \n        &.expanded {\n            max-width: 100%;\n            .tree-node.with-image {\n                width: -webkit-fill-available;\n                visibility: visible;\n                font-size: calc(0.6rem + 0.4vw);\n    \n                .division-image {\n                    width: 18px !important;\n                    height: 18px !important;\n                    margin-bottom: 10px;\n                }\n\n                &.tree-node--org-division .division-image,\n                &.tree-node--org-division .image-container .division-image {\n                    width: 30px !important;\n                    height: 30px !important;\n                    max-height: 30px !important;\n                }\n\n                &.tree-node--org-division .image-container {\n                    width: 30px !important;\n                    height: 30px !important;\n                }\n\n                &.tree-node--org-division {\n                    min-height: 48px;\n                    padding: 8px 10px;\n                }\n\n                &.tree-node--org-branch .division-image,\n                &.tree-node--org-branch .image-container .division-image {\n                    width: 50px !important;\n                    height: 50px !important;\n                    max-height: 50px !important;\n                }\n\n                &.tree-node--org-branch .image-container {\n                    width: 50px !important;\n                    height: 50px !important;\n                }\n    \n                .division-content {\n                    font-size: calc(0.6rem + 0.4vw);\n                    overflow: hidden;\n                    width: fit-content;\n                    transition: opacity 0.3s ease-in;\n                    opacity: 1;\n    \n                    .division-image {\n                        overflow: hidden;\n                    }\n                }\n            }\n    \n            .tree-node.without-image {\n                visibility: visible;\n                font-size: calc(0.7rem + 0.4vw);\n    \n                .division-content {\n                    font-size: calc(0.6rem + 0.4vw);\n                    overflow: hidden;\n                    transition: opacity 0.3s ease-in;\n                    opacity: 1;\n    \n                    .division-image {\n                        overflow: hidden;\n                    }\n                }\n            }\n        }\n    \n        &.reduced {\n            max-width: 8%;\n            visibility: visible;\n            transition: max-width 0.3s ease-out;\n    \n            .tree-node.without-image {\n                visibility: visible;\n                font-size: calc(0.7rem + 0.4vw);\n                height: 15px;\n    \n                .division-content {\n                    visibility: hidden;\n                    overflow: hidden;\n                    font-size: calc(0.6rem + 0.4vw);\n                    transition: opacity 0s ease-out;\n                    opacity: 0;\n    \n                    .division-image {\n                        visibility: hidden;\n                        overflow: hidden;\n                        padding: 0px;\n                    }\n                }\n            }\n    \n            .tree-node.with-image {\n                // == // \n                max-height: 24px;\n                padding: 5px 0px 5px 0px;\n                font-size: calc(0.7rem + 0.4vw);\n                visibility: visible;\n                position: relative; \n    \n                .image-container {\n                    width: 0px !important;\n                    height: 0px !important;\n                    overflow: hidden;\n                    padding: 0px;\n    \n                    .division-image {\n                        visibility: hidden;\n                        width: 0px !important;\n                        height: 0px !important;\n                        margin-bottom: 5px;\n                        overflow: hidden;\n                        padding: 0px;\n                    }\n                }\n    \n                .division-content {\n                    visibility: hidden;\n                    overflow: hidden;\n                    font-size: calc(0.7rem + 0.4vw);\n                    padding: 0px;\n                    transition: opacity 0s ease-out;\n                    opacity: 0;\n    \n                    .division-image {\n                        visibility: hidden;\n                        overflow: hidden;\n                        padding: 0px;\n                    }\n\n                }\n\n                // Add the symbol with animation\n                &::after {\n                    content: '⮟';\n                    position: absolute;\n                    top: 50%;\n                    left: 50%;\n                    transform: translate(-50%, -50%);\n                    animation: bounce 0.5s infinite alternate;\n                }\n\n                @keyframes bounce {\n                    0% {\n                        transform: translate(-50%, -50%);\n                    }\n                    100% {\n                        transform: translate(-50%, calc(-50% - 6px));\n                    }\n                }\n            }\n    \n            .tree-children {\n                visibility: hidden;\n                overflow: hidden;\n    \n                .tree-node.with-image {\n                    visibility: hidden;\n                    overflow: hidden;\n                    padding: 0px;\n                }\n    \n                .tree-node.without-image {\n                    visibility: hidden;\n                    overflow: hidden;\n                }\n            }\n        }\n    }\n    \n    .tree-node.with-image .image-container {\n        width: 18px;\n        height: 18px;\n    }\n\n    .tree-node.tree-node--org-division.with-image .image-container {\n        width: 30px;\n        height: 30px;\n    }\n\n    .tree-node.tree-node--org-branch.with-image .image-container {\n        width: 50px;\n        height: 50px;\n    }\n    \n    .division-description-container {\n        height: calc(50vh - 200px);\n    }\n}","@import './../variables.scss';\n\n/* Shared 3-position access toggle (create event menu + event card controls) */\n.create-event-access-toggle {\n    display: flex;\n    flex-direction: row;\n    flex-shrink: 0;\n    border-radius: 8px;\n    overflow: hidden;\n    border: 1px solid $medium-grey;\n}\n\n.create-event-access-toggle__mode {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    flex: 1 1 auto;\n    padding: 6px 10px;\n    margin: 0;\n    border: none;\n    background: $grey;\n    color: $very-light-grey;\n    cursor: pointer;\n    text-align: center;\n    min-width: 0;\n    transition: background 0.15s ease, box-shadow 0.15s ease, color 0.15s ease;\n\n    &:not(:last-child) {\n        border-right: 1px solid $medium-grey;\n    }\n\n    &:not(:disabled):hover {\n        background: $medium-grey;\n    }\n\n    &:disabled,\n    &.create-event-access-toggle__mode--locked {\n        opacity: 0.4;\n        cursor: not-allowed;\n    }\n\n    &:not(.create-event-access-toggle__mode--active) {\n        .create-event-access-toggle__label {\n            opacity: 0.8;\n        }\n    }\n}\n\n.create-event-access-toggle__mode--active {\n    background: $dark-grey;\n    box-shadow: inset 0 0 0 1px $red;\n\n    .create-event-access-toggle__label {\n        color: $very-light-grey;\n        opacity: 1;\n    }\n}\n\n.create-event-access-toggle__mode--first.create-event-access-toggle__mode--active {\n    border-radius: 8px 0 0 8px;\n}\n\n.create-event-access-toggle__mode--middle.create-event-access-toggle__mode--active {\n    border-radius: 0;\n}\n\n.create-event-access-toggle__mode--last.create-event-access-toggle__mode--active {\n    border-radius: 0 8px 8px 0;\n}\n\n.create-event-access-toggle__label {\n    font-size: 0.72rem;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    white-space: nowrap;\n}\n\n.modal {\n    position: fixed;\n    // React-Bootstrap uses `.modal`; keep it above panels/overlays.\n    z-index: 1050;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    background-color: rgba(0,0,0,0.6);\n    @include scroll-hidden;\n\n    .modal-content {\n        position: relative;\n        //transform: translateX(65px);\n        background-color: $blue-grey;\n        margin: 4vh 0%;\n        padding: 0px;\n        border: 1px solid $dark-red;\n        width: max-content;\n        justify-self: center;\n        min-height: inherit;\n        height: max-content;\n  \n        &.calendar-template-confirm {\n            height: 140px;\n        }\n  \n        &.create-event {\n            padding: 0px;\n        }\n\n        &.create-event-template {\n            padding: 0px;\n        }\n\n        &.lexical-save-modal {\n            padding: 0px; \n        }\n\n        \n        &.courses-modules-details {\n            width: 900px;\n            height: 75vh;\n        }\n        \n        .modal-body {\n            \n            .account-deletion {\n                height: 50px;\n\n                .header {\n                    &.account-deletion {\n                        color: $very-light-grey;\n                        padding: 10px;\n                        margin-top: 0;\n                        background-color: $dark-red;\n                        border-bottom: 3px solid $very-light-grey;\n                        margin-bottom: 5px;\n                        border-radius: 6px 6px 0px 0px;\n                    }\n                }\n\n                .content  {\n                    &.account-deletion {\n                        padding: 10px;\n                    }\n                }\n\n                .footer {\n                    &.account-deletion {\n                        padding: 10px;\n                        margin-top: 0;\n                        margin-bottom: 10px;\n                        border-radius: 0px 0px 6px 6px;\n                    }\n                }\n            }   \n        }\n    }\n    \n    .close {\n        color: $very-light-grey;\n        float: right;\n        font-size: 1.2rem;\n        font-weight: bold;\n        cursor: pointer;\n  \n        &:hover,\n        &:focus {\n            color: $very-dark-grey;\n            text-decoration: none;\n        }\n    }\n}\n\n\n\n.recurrence-modal {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    z-index: 1050;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    background-color: rgba(0, 0, 0, 0.6);\n\n    .modal-header {\n        color: $very-light-grey;\n        padding: 10px;\n        margin-top: 0;\n        //background-color: $dark-red;\n        border-bottom: 3px solid $very-light-grey;\n        margin-bottom: 5px;\n        border-radius: 6px 6px 0px 0px;\n\n        .recurrence-h3 {\n            padding: 0;\n            margin: 0;\n        }\n    }\n\n    .input-first {\n        display: flex;\n        //justify-content: space-between;\n        justify-content: center;\n        align-items: center;\n        //width: 75%;\n        width: 100%;\n        margin: 10px auto 10px auto;\n    }\n\n    .modal-dialog {\n        max-width: 280px;\n        margin: auto;\n    }\n\n    .modal-content {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        background-color: $grey;\n        max-width: 350px;\n        border: 1px solid $dark-red;\n        border-radius: 10px;\n\n\n    }\n\n    .recurrence-content {\n        background-color: $grey;\n        padding: 10px;\n        display: flex;\n        flex-direction: column;\n        align-items: flex-end;\n        gap: 3px;\n\n        .input {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            width: 100%;\n            margin-bottom: 5px;\n\n            label {\n                text-align: left;\n                flex-grow: 1;\n            }\n\n            .input, .react-select__control {\n                max-width: 175px !important;\n                min-width: 175px !important;\n                min-height: 16px !important;\n                height: 20px !important;\n            }\n\n            .field-input {\n                max-width: 50px;\n                min-width: 50px;\n                padding: 2px 8px 2px 8px;\n                border-radius: 6px;\n\n                &.date {\n                    max-width: 70px;\n                    min-width: 70px;\n                    padding: 2px 8px 2px 8px;\n                    border-radius: 6px;\n                }\n            }\n\n        }\n\n        .intelligible-text {\n            margin-left: 0px;\n            margin-right: auto;\n        }\n    }\n\n    .modal-footer {\n        display: flex;\n        gap: 10px;\n        padding: 15px;\n\n        .btn-style1 {\n            margin-left: 0px;\n        }\n    }\n}\n\n\n  \n  \n  \n.calendar-template-modal {\n    .modal-dialog {\n        margin: auto; \n        width: 1080px;\n    }\n\n    .calendar-template-input, .calendar-template-dropdown {\n        &.form-control {\n            width: 232px;\n            padding: 2px;\n        }\n        \n    }\n\n    .modal-footer {\n        display: flex;\n        justify-content: flex-start;\n    }\n\n    .modal-content {\n        background-color: $grey;\n        width: 1200px;\n        height: 85%;\n        margin-top: 100px;\n        //padding: 20px;\n        border: 1px solid $dark-red;\n    }\n\n    .modal-header {\n    \n        color: $very-light-grey;\n    \n        .modal-title {\n            font-size: 1.5rem;\n            color: $very-light-grey;\n        }\n\n        .btn-close {\n            color: $very-light-grey;\n    \n            &:hover,\n            &:focus {\n            color: $very-dark-grey;\n            }\n        }\n    }\n\n    .modal-body {\n        padding: 20px;\n\n        .form-control {\n            position: relative;\n            //right: 2px;\n            border-width: 0px;\n            width: -webkit-fill-available;\n            height: 16px;\n            padding: 10px 5px;\n            border-radius: 4px;\n            color: $very-dark-grey;\n        }\n    }\n\n} \n  \n  \n  \n.account-deletion .modal-content {\n    background-color: $dark-grey;\n\n    .modal-header {\n        font-weight: bolder;\n        color: $very-light-grey;\n    }\n\n    .modal-body {\n        color: $light-grey;\n\n    .link {\n        font-weight: bold;\n        color: $bright-red;\n        text-decoration: none;\n    }\n    }\n\n    .modal-footer {\n        text-align: center; // Center the content in the footer\n        display: block; // Ensure it behaves like a block element\n\n    button {\n        display: inline-block; // Ensure buttons are inline\n        margin: 0 5px; // Add some margin between buttons\n    }\n    }\n}\n  \n.modal-content {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    background: $very-dark-grey;\n    color: $very-light-grey;\n    border-radius: 10px;\n    width: 550px;\n    height: 325px;\n    position: relative;\n    outline: none;\n    z-index: 100;\n    border-radius: 10px ;\n\n    .mfa-h3 {\n        text-transform: uppercase;\n        text-align: center;\n        margin: 10px;\n        color: $very-light-grey;\n        font-size: 1.3rem;\n    }\n\n    .mfa-radio-buttons {\n        display: flex;\n        flex-direction: row;\n        justify-content: center;\n        margin: 15px;\n        gap: 15px;\n        height: 20px;\n    }\n\n\n    .modal-content-type {\n        display: flex;\n        flex-direction: row;\n\n        .modal-left {\n            display: flex;\n            flex-direction: column;\n            background-color: $light-grey;\n            align-items: center;\n            width: 250px;\n            min-height: 200px;\n            padding: 15px 25px;\n            border-radius: 0px 0px 0px 10px ;\n\n            .mfa-qr-code {\n                padding: 5px;\n                margin: 0px;\n            }\n        }\n    \n        .modal-right {\n            flex: 1;\n            background-color: $grey;\n            width: 250px;\n            min-height: 200px;\n            //padding-left: 20px;\n            border-radius: 0px 0px 10px 0px ;\n        \n            .mfa-bullet-points {\n                color: $very-light-grey;\n                padding: 10px 10px 10px 0px;\n\n                li {\n                    margin-bottom: 20px;\n                }\n            }\n        \n            .mobile {\n                display: none;\n            }\n        }\n    }\n}\n  \n  \n.modal-content-codes {\n    flex-direction: column;\n    justify-content: space-between;\n    background: $very-light-grey;\n    border-radius: 10px;\n    max-width: 100%;\n    width: 250px;\n    height: 250px;\n    padding: 30px;\n    position: relative;\n    outline: none;\n}\n\n\n.modal-overlay {\n    display: flex;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(19, 29, 37, 0.7);\n    align-items: center;\n    justify-content: center;\n    z-index: 200;\n}\n\n.modal-handle-left {\n    display: flex;\n    background-color: $grey;\n    flex-direction: column;\n    align-items: center;\n    width: 50%;\n    padding-right: 20px;\n    border-radius: 10px 0px 0px 10px ;\n}\n\n.modal-handle-right {\n    flex: 1;\n    background-color: $dark-grey;\n    width: 50%;\n    padding-left: 20px;\n    border-radius: 0px 10px 10px 0px ;\n\n    .handle-bullet-points{\n        color: $very-light-grey;\n        padding: 15px;\n    }\n\n    .mobile {\n        display: none;\n    }  \n}\n\n.modal.create-event-template  {\n    display: contents;\n    flex-direction: column;\n    position: relative;\n    background-color: $grey ;\n    padding: 0;\n    border-radius: 8px;\n    overflow-y: auto;\n    @include scrollbar-styles;\n\n    .header.create-event-template {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        border-bottom: 3px solid $light-grey;\n        @include steel-bg(\"../medias/steel.png\");\n\n        .calendar-h3 {\n            text-align: left;\n            text-transform: uppercase;\n            margin-left: 20px;\n            margin-top: 5px;\n            margin-bottom: 5px;\n            color: $very-light-grey;\n        }\n\n        .icon {\n            display: flex;\n            height: 18px;\n            overflow: hidden;\n            margin-left: auto;\n            margin-right: 10px;\n    \n            .close-event-button {\n                position: relative;\n                height: 40px;\n                object-fit: contain;\n                overflow: hidden;\n                cursor: pointer;\n        \n                &:hover {\n                    top: -21px;\n                }\n            }\n        }\n    }\n\n    .footer.create-event-template {\n        display: flex;\n        margin-top: 10px;\n        margin-left: 20px;\n        margin-bottom: 10px;\n    }\n}\n\n.modal.create-event {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    background-color: $blue-grey ;\n    padding: 0;\n    border: 1px solid $dark-red;\n    border-radius: 8px;\n    overflow-x: hidden;\n    overflow-y: auto;\n    @include scrollbar-styles;\n\n    .header.create-event {\n        @include modal-header(\"../medias/steel.png\");\n\n        .calendar-h3 {\n            text-align: left;\n            text-transform: uppercase;\n            margin-left: 20px;\n            margin-top: 5px;\n            margin-bottom: 5px;\n            color: $very-light-grey;\n        }\n    }\n\n    .menu {\n        display: flex;\n        background-color: $very-dark-grey ;\n        gap: 30px;\n        padding: 10px 20px 10px 35px;\n        border: 1px solid $light-grey;\n        border-radius: 8px;\n        margin: 10px 0px 10px;\n\n        .recurrence {\n            display: flex;\n            flex-direction: row;\n            flex-wrap: wrap;\n            align-items: flex-end;\n\n            .btn-style1 {\n                padding: 0.2rem 0.8rem 0.25rem 0.8rem;\n            }\n\n            .recurrence-text {\n                font-size: 14px;\n                margin-left: 5px;\n                margin-bottom: 6px;\n                color: $very-light-grey;\n            }\n        }\n\n        .create-event-access-toggle {\n            align-self: center;\n        }\n\n        .template-selector {\n            display: grid;\n            font-weight: bold;\n            gap: 5px;\n            margin-left: auto;\n            margin-right: 20px;\n        }\n    }\n\n    // Same pattern as calendar event content subtabs: shared panel height across sections.\n    $create-event-content-panel-height: 56vh;\n\n    .create-event-content-subtabs {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        width: 100%;\n        max-width: 100%;\n        box-sizing: border-box;\n        min-width: 0;\n\n        .ui-subtabs {\n            align-self: center;\n            margin-top: 0;\n        }\n    }\n\n    .create-event-content-subtabs__panels {\n        width: 100%;\n        max-width: 100%;\n        min-width: 0;\n        box-sizing: border-box;\n    }\n\n    // Beat panel `display: flex` rules — plain `.display-none` loses on specificity.\n    .create-event-content-subtabs__panel.display-none {\n        display: none !important;\n    }\n\n    // No outer frame: banner / setting / objectives / description already have their own cards.\n    .create-event-content-subtabs__panel {\n        background: transparent;\n        border: 0;\n        border-radius: 0;\n        padding: 0;\n        box-sizing: border-box;\n        width: 100%;\n        max-width: 100%;\n        min-width: 0;\n        height: $create-event-content-panel-height;\n        max-height: $create-event-content-panel-height;\n        overflow-x: hidden;\n        overflow-y: auto;\n        @include scrollbar-styles();\n\n        .management-container.create-event {\n            width: 100%;\n            max-width: 100%;\n            min-width: 0;\n            box-sizing: border-box;\n            margin-bottom: 10px;\n\n            &:last-child {\n                margin-bottom: 0;\n            }\n        }\n\n        .management-container.objectives-bloc,\n        .event-description {\n            width: 100%;\n            margin: 0;\n            max-width: 100%;\n            box-sizing: border-box;\n        }\n\n        // Prevent fixed banner/description widths from forcing horizontal scroll.\n        .management-container.create-event.banner {\n            .discord {\n                width: 100%;\n                max-width: 100%;\n                min-width: 0;\n                box-sizing: border-box;\n\n                .discord-banner {\n                    // Literal CSS min(): Sass min() cannot mix px + %.\n                    width: #{\"min(500px, 100%)\"};\n                    margin-left: auto;\n                    margin-right: auto;\n\n                    .dropzone {\n                        width: 100%;\n                        max-width: 500px;\n                    }\n                }\n\n                .discord-description {\n                    width: #{\"min(540px, 100%)\"};\n                    max-width: 100%;\n                    min-width: 0;\n                }\n            }\n        }\n\n        .management-container.create-event.setting {\n            .inputs.create-event {\n                width: 100%;\n                max-width: 100%;\n                min-width: 0;\n                box-sizing: border-box;\n                grid-template-columns: repeat(5, minmax(0, 1fr));\n\n                .inputs-column {\n                    width: auto;\n                    min-width: 0;\n\n                    &.width,\n                    &.rewards {\n                        width: auto;\n                    }\n                }\n            }\n        }\n    }\n\n    .create-event-content-subtabs__panel--banner-settings:not(.display-none) {\n        display: flex;\n        flex-direction: column;\n        gap: 12px;\n\n        .management-container.create-event.banner {\n            flex: 0 0 auto;\n        }\n\n        // Grow into remaining panel height so the settings block feels less cramped.\n        .management-container.create-event.setting {\n            flex: 1 1 auto;\n            min-height: 18rem;\n            display: flex;\n            flex-direction: column;\n            justify-content: flex-start;\n            padding: 0.55rem 0.45rem 0.75rem;\n\n            .inputs.create-event {\n                flex: 1 1 auto;\n                margin-top: 0.35rem;\n                margin-bottom: 0.25rem;\n                align-content: start;\n                row-gap: 0.85rem;\n            }\n        }\n    }\n\n    .footer.create-event {\n        display: flex;\n        margin-top: 20px;\n        margin-left: 20px;\n        margin-bottom: 20px;\n    }\n}\n\n.modal.create-handle {\n    background-color: rgba(0, 0, 0, 0.6);\n\n\n    .create-handle { \n        width: 600px;\n\n        .create-handle.header {\n            border-bottom: 3px solid $light-grey;\n            border-radius: 8px 8px 0px 0px;\n            @include steel-bg(\"../medias/steel.png\");\n\n            .handle-h3 {\n                text-align: left;\n                text-transform: uppercase;\n                margin: 0;\n                padding: 5px 20px;\n                color: $very-light-grey;\n            }\n        }\n\n        .create-handle.content {\n            display: flex;\n            flex-direction: row;\n            width: 100%;\n            height: 245px;\n\n            .create-handle.column {\n                display: flex;\n                flex-direction: column;\n                padding: 1em;\n                background-color: $dark-grey;\n                width: 40%;\n        \n                &.bullet-points {\n                    justify-content: center;\n                    color: $very-light-grey;\n                    padding: 15px;\n                    background-color: $very-dark-grey;\n                    width: 60%;\n                \n                    ul {\n                        list-style-type: disc; // Par défaut pour des puces\n                        padding-left: 20px;  // Pour indenter les puces\n                    }\n                \n                    ol {\n                        list-style-type: decimal; // Pour des nombres\n                        padding-left: 20px;  // Pour indenter les nombres\n                    }\n                \n                    li {\n                        margin-top: 20px;  // Espacement entre les éléments de la liste\n                        margin-bottom: 20px;  // Espacement entre les éléments de la liste\n                    }\n\n                    a {\n                        color: white;\n                        text-decoration: none; \n                        &:hover {\n                            color: $bright-red;  // Le lien devient légèrement plus clair au survol\n                        }\n                    }\n                }\n                \n            }\n        }\n    }\n}\n\n\n\n.modal-content-handle {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    background: $very-dark-grey;\n    color: $very-light-grey;\n    border-radius: 10px;\n    width: 550px;\n    height: 325px;\n    position: relative;\n    outline: none;\n    z-index: 100;\n    border-radius: 10px ;\n\n    .mfa-h3 {\n        text-transform: uppercase;\n        text-align: center;\n        margin: 10px;\n        color: $very-light-grey;\n        font-size: 1.3rem;\n    }\n\n    .mfa-radio-buttons {\n        display: flex;\n        flex-direction: row;\n        justify-content: center;\n        margin: 15px;\n        gap: 15px;\n        height: 20px;\n    }\n\n    .modal-content-type {\n        display: flex;\n        flex-direction: row;\n\n        .modal-left {\n            display: flex;\n            flex-direction: column;\n            background-color: $light-grey;\n            align-items: center;\n            width: 250px;\n            min-height: 200px;\n            padding: 15px 25px;\n            border-radius: 0px 0px 0px 10px ;\n\n            .mfa-qr-code {\n                padding: 5px;\n                margin: 0px;\n            }\n        }\n    \n        .modal-right {\n            flex: 1;\n            background-color: $grey;\n            width: 250px;\n            min-height: 200px;\n            //padding-left: 20px;\n            border-radius: 0px 0px 10px 0px ;\n        \n            .mfa-bullet-points {\n                color: $very-light-grey;\n                padding: 10px 10px 10px 0px;\n\n                li {\n                    margin-bottom: 20px;\n                }\n            }\n        \n            .mobile {\n                display: none;\n            }\n        }\n    }\n}\n\n\n.modal.allied-deletion {\n    background: $dark-grey;\n    color: $very-light-grey;\n    padding: 20px;\n    border-radius: 4px;\n    max-width: 500px;\n    width: 30%;\n    height: 120px;\n    top: 35%;\n    left: 37vw;\n    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.3);\n}\n  ","@import '../variables.scss';\n\n\n\n// Styles communs pour tous les Select\n.react-select__control,\n.react-select-input__control,\n.react-select-menu__control {\n  background-color: $very-light-grey;\n  border: 1px solid $dark-red;\n  font-size: 12px !important;\n  box-shadow: none;\n  flex-wrap: nowrap !important;\n}\n\n// Largeur et hauteur spécifiques pour chaque Select\n.react-select__control {\n  min-width: 250px !important;\n  min-height: 22px !important;\n  height: 22px !important;\n}\n\n.react-select-input__control {\n  min-width: 175px !important;\n  min-height: 22px !important;\n  height: 22px !important;\n  padding: 0px 3px !important;\n}\n\n.react-select-input-comms__control {\n  min-width: 190px !important;\n  min-height: 22px !important;\n  height: 22px !important;\n  padding: 0px 3px !important;\n}\n\n.react-select-menu__control {\n  min-width: 190px !important;\n  min-height: 22px !important;\n  height: 22px !important;\n}\n\n// Styles pour le conteneur de la valeur sélectionnée\n.react-select__value-container,\n.react-select-input__value-container,\n.react-select-menu__value-container {\n  padding: 2px 2px !important;\n}\n\n// Styles communs pour le menu\n.react-select__menu,\n.react-select-input__menu,\n.react-select-menu__menu {\n  color: $very-dark-grey;\n  font-size: 12px;\n  z-index: 99999 !important;\n}\n\n// When using react-select `menuPortalTarget`, the menu is rendered under `__menu-portal`.\n.react-select__menu-portal,\n.react-select-input__menu-portal,\n.react-select-menu__menu-portal {\n  z-index: 99999 !important;\n}\n\n// Styles communs pour les options\n.react-select__option,\n.react-select-input__option,\n.react-select-menu__option {\n  background-color: $very-light-grey;\n  color: $very-dark-grey;\n  padding: 4px 12px !important;\n\n  &.react-select__option--is-selected,\n  &.react-select-input__option--is-selected,\n  &.react-select-menu__option--is-selected {\n    background-color: $light-grey;\n    color: $very-dark-grey;\n  }\n\n  &:hover {\n    background-color: $light-grey;\n    color: $dark-grey;\n  }\n}\n\n// Styles pour le placeholder et la valeur sélectionnée\n.react-select__placeholder,\n.react-select__single-value,\n.react-select-input__placeholder,\n.react-select-input__single-value,\n.react-select-menu__placeholder,\n.react-select-menu__single-value {\n  color: $very-dark-grey;\n  font-size: 12px !important;\n}\n","// /src/styles/tools/ant-tree-select.scss\n\n@import '../variables.scss';\n\n// Container\n.hierarchy-select-container {\n  .react-dropdown-tree-select {\n    font-family: \"Lato\", sans-serif;\n    .dropdown {\n      // Anchor for .dropdown-content; package default styles are not bundled\n      position: relative;\n      display: block;\n\n      .dropdown-trigger {\n        display: block;\n        width: 172px;\n        height: 38px;\n        padding: 3px 5px;\n        color: $very-dark-grey;\n        border-radius: 4px;\n        background-color: white;\n        overflow-x: hidden;\n        @include scrollbar-styles;\n        cursor: pointer;\n        \n\n        &.arrow.bottom::after {\n            content: \"▼\";\n            position: absolute;\n            top: 80%;\n            right: 0.5rem;\n            transform: translateY(-50%);\n            pointer-events: none;\n        }\n      }\n\n      .dropdown-content {\n        position: absolute;\n        top: 100%;\n        left: 0;\n        margin-top: 2px;\n        box-sizing: border-box;\n        max-height: 180px;\n        overflow-y: auto;\n        width: 190px;\n        background-color: white;\n        border: 1px solid $dark-red;\n        border-radius: 4px;\n        box-shadow: 0 5px 8px rgba(0, 0, 0, 0.15);\n        z-index: 99999;\n        @include scrollbar-styles;\n\n        ul {\n            color: $very-dark-grey;\n            padding: 0 10px 10px;\n            overflow-x: hidden;\n            @include scrollbar-styles;\n\n            &.infinite-scroll-component  {\n                overflow-x: hidden;\n            }\n        }\n      }\n\n      .tag-list {\n        display: flex;\n        flex-direction: column;\n        list-style: none;\n        width: 170px;\n        margin: 0;\n        padding: 0;\n        gap: 3px;\n\n        .tag-item {\n\n          width: 160px;\n\n          .tag {\n            display: inline-flex;\n            align-items: center;\n            width: -webkit-fill-available;\n            font-size: 14px;\n            padding: 1px 4px;\n            background-color: $very-light-grey;\n            color: $very-dark-grey;\n            border-radius: 4px;\n\n            .tag-remove {\n              background: none;\n              border: none;\n              margin-left: auto;\n              margin-right: 0.25rem;\n              color: $dark-red;\n              cursor: pointer;\n            }\n          }\n        }\n\n        .search {\n            display: none;\n        }\n      }\n\n      .rst__dropdown {\n        position: absolute;\n        top: 100%;\n        left: 0;\n        width: 100%;\n        max-height: 300px;\n        overflow: auto;\n        border: 1px solid $dark-red;\n        background-color: white;\n        border-radius: 4px;\n        z-index: 1000;\n        margin-top: 0.25rem;\n\n        .rst__list {\n          list-style: none;\n          margin: 0;\n          padding: 0;\n\n          .rst__list-item {\n            padding: 0.5rem;\n            display: flex;\n            align-items: center;\n            cursor: pointer;\n\n            &:hover {\n              background-color: $grey;\n            }\n\n            .rst__checkbox {\n              margin-right: 0.5rem;\n            }\n\n            .rst__node-label {\n              flex: 1;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .node[role=\"treeitem\"] {\n    // niveau 1 = pas d'indent\n    &[aria-level=\"1\"] {\n      padding-left: 0 !important;\n    }\n\n    // pour chaque niveau 2 à max-level, on génère un selector\n    @for $lvl from 2 through 6 {\n      &[aria-level=\"#{$lvl}\"] {\n        padding-left: ($lvl - 1) * 20px !important;\n      }\n    }\n  }\n}\n\n// Academy → rank requirements table: flat certification list, full column width, searchable dropdown\n.hierarchy-select-container.certifications-tree-select {\n  width: 100%;\n  min-width: 0;\n}\n\n.certifications-select-trigger {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  min-height: 2.1rem;\n  padding: 0.45rem 1.75rem 0.45rem 0.65rem;\n  box-sizing: border-box;\n  overflow: hidden;\n  color: $very-light-grey;\n  border: 1px solid rgba($accent-blue, 0.45);\n  border-radius: 8px;\n  background: rgba($dark-blue, 0.65);\n  font-family: inherit;\n  font-size: 0.84rem;\n  text-align: left;\n  cursor: pointer;\n  position: relative;\n  background-image:\n    linear-gradient(45deg, transparent 50%, rgba($very-light-grey, 0.75) 50%),\n    linear-gradient(135deg, rgba($very-light-grey, 0.75) 50%, transparent 50%);\n  background-position:\n    calc(100% - 16px) calc(50% - 2px),\n    calc(100% - 11px) calc(50% - 2px);\n  background-size: 5px 5px, 5px 5px;\n  background-repeat: no-repeat;\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.55;\n  }\n\n  &__tags {\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: center;\n    gap: 0.25rem;\n    flex: 1;\n    min-width: 0;\n    overflow: hidden;\n  }\n\n  &__placeholder {\n    color: rgba($very-light-grey, 0.45);\n    line-height: 1.35;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__summary {\n    display: block;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    color: $very-light-grey;\n    line-height: 1.35;\n  }\n\n  &__tag {\n    display: inline-flex;\n    align-items: center;\n    min-width: 0;\n    max-width: 100%;\n    box-sizing: border-box;\n    font-size: 0.78rem;\n    padding: 0.1rem 0.35rem;\n    background: rgba($accent-blue, 0.22);\n    color: $very-light-grey;\n    border: 1px solid rgba($accent-blue, 0.35);\n    border-radius: 6px;\n  }\n\n  &__tag-label {\n    flex: 1;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__tag-remove {\n    background: none;\n    border: none;\n    margin-left: 0.2rem;\n    color: rgba($very-light-grey, 0.75);\n    cursor: pointer;\n    padding: 0;\n    line-height: 1;\n\n    &:hover {\n      color: $very-light-yellow;\n    }\n  }\n\n  &__arrow {\n    display: none;\n  }\n}\n\n// Portal panel — not under .hierarchy-select-container\n.certifications-select-panel {\n  box-sizing: border-box;\n  background: rgba($dark-blue-grey, 0.98);\n  border: 1px solid rgba($accent-blue, 0.35);\n  border-radius: 8px;\n  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.35);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  color: $very-light-grey;\n  font-family: inherit;\n\n  &__search {\n    width: 100%;\n    box-sizing: border-box;\n    border: none;\n    border-bottom: 1px solid rgba($accent-blue, 0.28);\n    outline: none;\n    padding: 0.5rem 0.65rem;\n    font-family: inherit;\n    font-size: 0.84rem;\n    color: $very-light-grey;\n    background: rgba($dark-blue, 0.55);\n\n    &::placeholder {\n      color: rgba($very-light-grey, 0.45);\n    }\n  }\n\n  &__list {\n    list-style: none;\n    margin: 0;\n    padding: 0 0 0.35rem;\n    overflow-y: auto;\n    @include scrollbar-styles;\n  }\n\n  &__empty {\n    padding: 0.55rem 0.65rem;\n    color: rgba($very-light-grey, 0.55);\n    font-size: 0.84rem;\n  }\n\n  &__option {\n    padding: 0;\n  }\n\n  &__option-label {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.45rem 0.65rem;\n    cursor: pointer;\n    font-size: 0.84rem;\n\n    &:hover {\n      background: rgba($accent-blue, 0.18);\n    }\n\n    input[type=\"checkbox\"] {\n      margin: 0;\n      flex-shrink: 0;\n      accent-color: $accent-blue;\n    }\n\n    span {\n      flex: 1;\n      min-width: 0;\n    }\n  }\n}\n","@import './../variables.scss';\n\n  //.editor-container {       height: calc(100% - 50px);   }\n .ql-container {\n    box-sizing: border-box;\n    font-family: Helvetica, Arial, sans-serif;\n    font-size: 13px;\n    height: 100%;\n    margin: 0px;\n    position: relative;\n  }\n  .ql-container.ql-disabled .ql-tooltip {\n    visibility: hidden;\n  }\n  .ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {\n    pointer-events: none;\n  }\n  .ql-clipboard {\n    left: -100000px;\n    height: 1px;\n    overflow-y: hidden;\n    position: absolute;\n    top: 50%;\n  }\n  .ql-clipboard p {\n    margin: 0;\n    padding: 0;\n  }\n  .ql-editor {\n    box-sizing: border-box;\n    line-height: 1.42;\n    height: 100%;\n    outline: none;\n    overflow-y: auto;\n    padding: 12px 15px;\n    tab-size: 4;\n    -moz-tab-size: 4;\n    text-align: left;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n  }\n  .ql-editor > * {\n    cursor: text;\n  }\n  .ql-editor p,\n  .ql-editor ol,\n  .ql-editor ul,\n  .ql-editor pre,\n  .ql-editor blockquote,\n  .ql-editor h1,\n  .ql-editor h2,\n  .ql-editor h3,\n  .ql-editor h4,\n  .ql-editor h5,\n  .ql-editor h6 {\n    margin: 0;\n    padding: 0;\n    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n    font-size: 14px;\n  }\n  .ql-editor ol,\n  .ql-editor ul {\n    padding-left: 1.5em;\n  }\n  .ql-editor ol > li,\n  .ql-editor ul > li {\n    list-style-type: none;\n  }\n  .ql-editor ul > li::before {\n    content: '\\2022';\n  }\n  .ql-editor ul[data-checked=true],\n  .ql-editor ul[data-checked=false] {\n    pointer-events: none;\n  }\n  .ql-editor ul[data-checked=true] > li *,\n  .ql-editor ul[data-checked=false] > li * {\n    pointer-events: all;\n  }\n  .ql-editor ul[data-checked=true] > li::before,\n  .ql-editor ul[data-checked=false] > li::before {\n    color: #777;\n    cursor: pointer;\n    pointer-events: all;\n  }\n  .ql-editor ul[data-checked=true] > li::before {\n    content: '\\2611';\n  }\n  .ql-editor ul[data-checked=false] > li::before {\n    content: '\\2610';\n  }\n  .ql-editor li::before {\n    display: inline-block;\n    white-space: nowrap;\n    width: 1.2em;\n  }\n  .ql-editor li:not(.ql-direction-rtl)::before {\n    margin-left: -1.5em;\n    margin-right: 0.3em;\n    text-align: right;\n  }\n  .ql-editor li.ql-direction-rtl::before {\n    margin-left: 0.3em;\n    margin-right: -1.5em;\n  }\n\n\n.ql-editor ol li:not(.ql-direction-rtl),\n.ql-editor ul li:not(.ql-direction-rtl) {\n    padding-left: 1.5em;\n}\n\n.ql-editor ol li.ql-direction-rtl,\n.ql-editor ul li.ql-direction-rtl {\n    padding-right: 1.5em;\n}\n\n.ql-editor ol li {\n    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n    counter-increment: list-0;\n}\n\n.ql-editor ol li:is([data-list='bullet'])::before {\n    font-weight: bold;\n    content: \"•\";\n}\n\n.ql-editor ol li:before {\n    content: counter(list-0, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-1 {\n    counter-increment: list-1;\n}\n.ql-editor ol li.ql-indent-1:before {\n    content: counter(list-1, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-1 {\n    counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-2 {\n    counter-increment: list-2;\n}\n.ql-editor ol li.ql-indent-2:before {\n    content: counter(list-2, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-2 {\n    counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-3 {\n    counter-increment: list-3;\n}\n.ql-editor ol li.ql-indent-3:before {\n    content: counter(list-3, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-3 {\n    counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-4 {\n    counter-increment: list-4;\n}\n.ql-editor ol li.ql-indent-4:before {\n    content: counter(list-4, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-4 {\n    counter-reset: list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-5 {\n    counter-increment: list-5;\n}\n.ql-editor ol li.ql-indent-5:before {\n    content: counter(list-5, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-5 {\n    counter-reset: list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-6 {\n    counter-increment: list-6;\n}\n.ql-editor ol li.ql-indent-6:before {\n    content: counter(list-6, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-6 {\n    counter-reset: list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-7 {\n    counter-increment: list-7;\n}\n.ql-editor ol li.ql-indent-7:before {\n    content: counter(list-7, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-7 {\n    counter-reset: list-8 list-9;\n}\n.ql-editor ol li.ql-indent-8 {\n    counter-increment: list-8;\n}\n.ql-editor ol li.ql-indent-8:before {\n    content: counter(list-8, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-8 {\n    counter-reset: list-9;\n}\n.ql-editor ol li.ql-indent-9 {\n    counter-increment: list-9;\n}\n.ql-editor ol li.ql-indent-9:before {\n    content: counter(list-9, decimal) '. ';\n}\n\n\n\n\n  .ql-editor .ql-indent-1:not(.ql-direction-rtl) {\n    padding-left: 3em;\n  }\n  .ql-editor li.ql-indent-1:not(.ql-direction-rtl) {\n    padding-left: 4.5em;\n  }\n  .ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {\n    padding-right: 3em;\n  }\n  .ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {\n    padding-right: 4.5em;\n  }\n  .ql-editor .ql-indent-2:not(.ql-direction-rtl) {\n    padding-left: 6em;\n  }\n  .ql-editor li.ql-indent-2:not(.ql-direction-rtl) {\n    padding-left: 7.5em;\n  }\n  .ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {\n    padding-right: 6em;\n  }\n  .ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {\n    padding-right: 7.5em;\n  }\n  .ql-editor .ql-indent-3:not(.ql-direction-rtl) {\n    padding-left: 9em;\n  }\n  .ql-editor li.ql-indent-3:not(.ql-direction-rtl) {\n    padding-left: 10.5em;\n  }\n  .ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {\n    padding-right: 9em;\n  }\n  .ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {\n    padding-right: 10.5em;\n  }\n  .ql-editor .ql-indent-4:not(.ql-direction-rtl) {\n    padding-left: 12em;\n  }\n  .ql-editor li.ql-indent-4:not(.ql-direction-rtl) {\n    padding-left: 13.5em;\n  }\n  .ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {\n    padding-right: 12em;\n  }\n  .ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {\n    padding-right: 13.5em;\n  }\n  .ql-editor .ql-indent-5:not(.ql-direction-rtl) {\n    padding-left: 15em;\n  }\n  .ql-editor li.ql-indent-5:not(.ql-direction-rtl) {\n    padding-left: 16.5em;\n  }\n  .ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {\n    padding-right: 15em;\n  }\n  .ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {\n    padding-right: 16.5em;\n  }\n  .ql-editor .ql-indent-6:not(.ql-direction-rtl) {\n    padding-left: 18em;\n  }\n  .ql-editor li.ql-indent-6:not(.ql-direction-rtl) {\n    padding-left: 19.5em;\n  }\n  .ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {\n    padding-right: 18em;\n  }\n  .ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {\n    padding-right: 19.5em;\n  }\n  .ql-editor .ql-indent-7:not(.ql-direction-rtl) {\n    padding-left: 21em;\n  }\n  .ql-editor li.ql-indent-7:not(.ql-direction-rtl) {\n    padding-left: 22.5em;\n  }\n  .ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {\n    padding-right: 21em;\n  }\n  .ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {\n    padding-right: 22.5em;\n  }\n  .ql-editor .ql-indent-8:not(.ql-direction-rtl) {\n    padding-left: 24em;\n  }\n  .ql-editor li.ql-indent-8:not(.ql-direction-rtl) {\n    padding-left: 25.5em;\n  }\n  .ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {\n    padding-right: 24em;\n  }\n  .ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {\n    padding-right: 25.5em;\n  }\n  .ql-editor .ql-indent-9:not(.ql-direction-rtl) {\n    padding-left: 27em;\n  }\n  .ql-editor li.ql-indent-9:not(.ql-direction-rtl) {\n    padding-left: 28.5em;\n  }\n  .ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {\n    padding-right: 27em;\n  }\n  .ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {\n    padding-right: 28.5em;\n  }\n  .ql-editor .ql-video {\n    display: block;\n    max-width: 100%;\n  }\n  .ql-editor .ql-video.ql-align-center {\n    margin: 0 auto;\n  }\n  .ql-editor .ql-video.ql-align-right {\n    margin: 0 0 0 auto;\n  }\n  .ql-editor .ql-bg-black {\n    background-color: #000;\n  }\n  .ql-editor .ql-bg-red {\n    background-color: #e60000;\n  }\n  .ql-editor .ql-bg-orange {\n    background-color: #f90;\n  }\n  .ql-editor .ql-bg-yellow {\n    background-color: #ff0;\n  }\n  .ql-editor .ql-bg-green {\n    background-color: #008a00;\n  }\n  .ql-editor .ql-bg-blue {\n    background-color: #75dfff;\n  }\n  .ql-editor .ql-bg-purple {\n    background-color: #93f;\n  }\n  .ql-editor .ql-color-white {\n    color: #fff;\n  }\n  .ql-editor .ql-color-red {\n    color: #e60000;\n  }\n  .ql-editor .ql-color-orange {\n    color: #f90;\n  }\n  .ql-editor .ql-color-yellow {\n    color: #ff0;\n  }\n  .ql-editor .ql-color-green {\n    color: #008a00;\n  }\n  .ql-editor .ql-color-blue {\n    color: #75dfff;\n  }\n  .ql-editor .ql-color-purple {\n    color: #93f;\n  }\n  .ql-editor .ql-font-serif {\n    font-family: Georgia, Times New Roman, serif;\n  }\n  .ql-editor .ql-font-monospace {\n    font-family: Monaco, Courier New, monospace;\n  }\n  .ql-editor .ql-size-small {\n    font-size: 0.75em;\n  }\n  .ql-editor .ql-size-large {\n    font-size: 1.5em;\n  }\n  .ql-editor .ql-size-huge {\n    font-size: 2.5em;\n  }\n  .ql-editor .ql-direction-rtl {\n    direction: rtl;\n    text-align: inherit;\n  }\n  .ql-editor .ql-align-center {\n    text-align: center;\n  }\n  .ql-editor .ql-align-justify {\n    text-align: justify;\n  }\n  .ql-editor .ql-align-right {\n    text-align: right;\n  }\n  .ql-editor.ql-blank::before {\n    color: rgba(0,0,0,0.6);\n    content: attr(data-placeholder);\n    font-style: italic;\n    left: 15px;\n    pointer-events: none;\n    position: absolute;\n    right: 15px;\n  }\n  .ql-snow.ql-toolbar:after,\n  .ql-snow .ql-toolbar:after {\n    clear: both;\n    content: '';\n    display: table;\n  }\n  .ql-snow.ql-toolbar button,\n  .ql-snow .ql-toolbar button {\n    background: none;\n    border: none;\n    cursor: pointer;\n    display: inline-block;\n    float: left;\n    height: 24px;\n    padding: 3px 5px;\n    width: 28px;\n  }\n  .ql-snow.ql-toolbar button svg,\n  .ql-snow .ql-toolbar button svg {\n    float: left;\n    height: 100%;\n  }\n  .ql-snow.ql-toolbar button:active:hover,\n  .ql-snow .ql-toolbar button:active:hover {\n    outline: none;\n  }\n  .ql-snow.ql-toolbar input.ql-image[type=file],\n  .ql-snow .ql-toolbar input.ql-image[type=file] {\n    display: none;\n  }\n  .ql-snow.ql-toolbar button:hover,\n  .ql-snow .ql-toolbar button:hover,\n  .ql-snow.ql-toolbar button:focus,\n  .ql-snow .ql-toolbar button:focus,\n  .ql-snow.ql-toolbar button.ql-active,\n  .ql-snow .ql-toolbar button.ql-active,\n  .ql-snow.ql-toolbar .ql-picker-label:hover,\n  .ql-snow .ql-toolbar .ql-picker-label:hover,\n  .ql-snow.ql-toolbar .ql-picker-label.ql-active,\n  .ql-snow .ql-toolbar .ql-picker-label.ql-active,\n  .ql-snow.ql-toolbar .ql-picker-item:hover,\n  .ql-snow .ql-toolbar .ql-picker-item:hover,\n  .ql-snow.ql-toolbar .ql-picker-item.ql-selected,\n  .ql-snow .ql-toolbar .ql-picker-item.ql-selected {\n    color: #75dfff;\n  }\n  .ql-snow.ql-toolbar button:hover .ql-fill,\n  .ql-snow .ql-toolbar button:hover .ql-fill,\n  .ql-snow.ql-toolbar button:focus .ql-fill,\n  .ql-snow .ql-toolbar button:focus .ql-fill,\n  .ql-snow.ql-toolbar button.ql-active .ql-fill,\n  .ql-snow .ql-toolbar button.ql-active .ql-fill,\n  .ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,\n  .ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,\n  .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,\n  .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,\n  .ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,\n  .ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,\n  .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,\n  .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,\n  .ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,\n  .ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill,\n  .ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,\n  .ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,\n  .ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,\n  .ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,\n  .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,\n  .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,\n  .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,\n  .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,\n  .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,\n  .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,\n  .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,\n  .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {\n    fill: #75dfff;\n  }\n  .ql-snow.ql-toolbar button:hover .ql-stroke,\n  .ql-snow .ql-toolbar button:hover .ql-stroke,\n  .ql-snow.ql-toolbar button:focus .ql-stroke,\n  .ql-snow .ql-toolbar button:focus .ql-stroke,\n  .ql-snow.ql-toolbar button.ql-active .ql-stroke,\n  .ql-snow .ql-toolbar button.ql-active .ql-stroke,\n  .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,\n  .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,\n  .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n  .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n  .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,\n  .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,\n  .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,\n  .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,\n  .ql-snow.ql-toolbar button:hover .ql-stroke-miter,\n  .ql-snow .ql-toolbar button:hover .ql-stroke-miter,\n  .ql-snow.ql-toolbar button:focus .ql-stroke-miter,\n  .ql-snow .ql-toolbar button:focus .ql-stroke-miter,\n  .ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,\n  .ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,\n  .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,\n  .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,\n  .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,\n  .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,\n  .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,\n  .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,\n  .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,\n  .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {\n    stroke: #75dfff;\n  }\n  @media (pointer: coarse) {\n    .ql-snow.ql-toolbar button:hover:not(.ql-active),\n    .ql-snow .ql-toolbar button:hover:not(.ql-active) {\n      color: #444;\n    }\n    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,\n    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,\n    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,\n    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {\n      fill: #444;\n    }\n    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,\n    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,\n    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,\n    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {\n      stroke: #444;\n    }\n  }\n  .ql-snow {\n    box-sizing: border-box;\n  }\n  .ql-snow * {\n    box-sizing: border-box;\n    @include scrollbar-styles;\n  }\n  .ql-snow .ql-hidden {\n    display: none;\n  }\n  .ql-snow .ql-out-bottom,\n  .ql-snow .ql-out-top {\n    visibility: hidden;\n  }\n  .ql-snow .ql-tooltip {\n    position: absolute;\n    transform: translateY(10px);\n  }\n  .ql-snow .ql-tooltip a {\n    cursor: pointer;\n    text-decoration: none;\n  }\n  .ql-snow .ql-tooltip.ql-flip {\n    transform: translateY(-10px);\n  }\n  .ql-snow .ql-formats {\n    display: inline-block;\n    vertical-align: middle;\n  }\n  .ql-snow .ql-formats:after {\n    clear: both;\n    content: '';\n    display: table;\n  }\n  .ql-snow .ql-stroke {\n    fill: none;\n    stroke: $very-light-grey;\n    strokeLinecap: round;\n    strokeLinejoin: round;\n    strokeWidth: 2;\n  }\n  .ql-snow .ql-stroke-miter {\n    fill: none;\n    stroke: $very-light-grey;\n    stroke-miterlimit: 10;\n    strokeWidth: 2;\n  }\n  .ql-snow .ql-fill,\n  .ql-snow .ql-stroke.ql-fill {\n    fill: $very-light-grey;\n  }\n  .ql-snow .ql-empty {\n    fill: none;\n  }\n  .ql-snow .ql-even {\n    fill-rule: evenodd;\n  }\n  .ql-snow .ql-thin,\n  .ql-snow .ql-stroke.ql-thin {\n    strokeWidth: 1;\n  }\n  .ql-snow .ql-transparent {\n    opacity: 0.4;\n  }\n  .ql-snow .ql-direction svg:last-child {\n    display: none;\n  }\n  .ql-snow .ql-direction.ql-active svg:last-child {\n    display: inline;\n  }\n  .ql-snow .ql-direction.ql-active svg:first-child {\n    display: none;\n  }\n  .ql-snow .ql-editor h1 {\n    font-size: 2em;\n  }\n  .ql-snow .ql-editor h2 {\n    font-size: 1.5em;\n  }\n  .ql-snow .ql-editor h3 {\n    font-size: 1.17em;\n  }\n  .ql-snow .ql-editor h4 {\n    font-size: 1em;\n  }\n  .ql-snow .ql-editor h5 {\n    font-size: 0.83em;\n  }\n  .ql-snow .ql-editor h6 {\n    font-size: 0.67em;\n  }\n  .ql-snow .ql-editor a {\n    text-decoration: underline;\n  }\n  .ql-snow .ql-editor blockquote {\n    border-left: 4px solid #ccc;\n    margin-bottom: 5px;\n    margin-top: 5px;\n    padding-left: 16px;\n  }\n  .ql-snow .ql-editor code,\n  .ql-snow .ql-editor pre {\n    background-color: #f0f0f0;\n    border-radius: 3px;\n  }\n  .ql-snow .ql-editor pre {\n    white-space: pre-wrap;\n    margin-bottom: 5px;\n    margin-top: 5px;\n    padding: 5px 10px;\n  }\n  .ql-snow .ql-editor code {\n    font-size: 85%;\n    padding: 2px 4px;\n  }\n  .ql-snow .ql-editor pre.ql-syntax {\n    background-color: #23241f;\n    color: #45c1ff;\n    overflow: visible;\n  }\n  .ql-snow .ql-editor img {\n    max-width: 100%;\n  }\n  .ql-snow .ql-picker {\n    color: $very-light-grey;\n    display: inline-block;\n    float: left;\n    font-size: 14px;\n    font-weight: 500;\n    height: 24px;\n    position: relative;\n    vertical-align: middle;\n  }\n  .ql-snow .ql-picker-label {\n    cursor: pointer;\n    display: inline-block;\n    height: 100%;\n    padding-left: 8px;\n    padding-right: 2px;\n    position: relative;\n    width: 100%;\n  }\n  .ql-snow .ql-picker-label::before {\n    display: inline-block;\n    line-height: 22px;\n  }\n  .ql-snow .ql-picker-options {\n    background-color: #592727;\n    display: none;\n    min-width: 100%;\n    padding: 4px 8px;\n    position: absolute;\n    white-space: nowrap;\n  }\n  .ql-snow .ql-picker-options .ql-picker-item {\n    cursor: pointer;\n    display: block;\n    padding-bottom: 5px;\n    padding-top: 5px;\n  }\n  .ql-snow .ql-picker.ql-expanded .ql-picker-label {\n    color: #ccc;\n    z-index: 2;\n  }\n  .ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {\n    fill: #ccc;\n  }\n  .ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {\n    stroke: #ccc;\n  }\n  .ql-snow .ql-picker.ql-expanded .ql-picker-options {\n    display: block;\n    margin-top: -1px;\n    top: 100%;\n    z-index: 1;\n  }\n  .ql-snow .ql-color-picker,\n  .ql-snow .ql-icon-picker {\n    width: 28px;\n  }\n  .ql-snow .ql-color-picker .ql-picker-label,\n  .ql-snow .ql-icon-picker .ql-picker-label {\n    padding: 2px 4px;\n  }\n  .ql-snow .ql-color-picker .ql-picker-label svg,\n  .ql-snow .ql-icon-picker .ql-picker-label svg {\n    right: 4px;\n  }\n  .ql-snow .ql-icon-picker .ql-picker-options {\n    padding: 4px 0px;\n  }\n  .ql-snow .ql-icon-picker .ql-picker-item {\n    height: 24px;\n    width: 24px;\n    padding: 2px 4px;\n  }\n  .ql-snow .ql-color-picker .ql-picker-options {\n    padding: 3px 5px;\n    width: 152px;\n  }\n  .ql-snow .ql-color-picker .ql-picker-item {\n    border: 1px solid transparent;\n    float: left;\n    height: 16px;\n    margin: 2px;\n    padding: 0px;\n    width: 16px;\n  }\n  .ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {\n    position: absolute;\n    margin-top: -9px;\n    right: 0;\n    top: 50%;\n    width: 18px;\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before,\n  .ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before,\n  .ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before,\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before,\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before,\n  .ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before {\n    content: attr(data-label);\n  }\n  .ql-snow .ql-picker.ql-header {\n    width: 98px;\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-label::before,\n  .ql-snow .ql-picker.ql-header .ql-picker-item::before {\n    content: 'Normal';\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"1\"]::before,\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before {\n    content: 'Heading 1';\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"2\"]::before,\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before {\n    content: 'Heading 2';\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"3\"]::before,\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before {\n    content: 'Heading 3';\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"4\"]::before,\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before {\n    content: 'Heading 4';\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"5\"]::before,\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before {\n    content: 'Heading 5';\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"6\"]::before,\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before {\n    content: 'Heading 6';\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before {\n    font-size: 2em;\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before {\n    font-size: 1.5em;\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before {\n    font-size: 1.17em;\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before {\n    font-size: 1em;\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before {\n    font-size: 0.83em;\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before {\n    font-size: 0.67em;\n  }\n  .ql-snow .ql-picker.ql-font {\n    width: 108px;\n  }\n  .ql-snow .ql-picker.ql-font .ql-picker-label::before,\n  .ql-snow .ql-picker.ql-font .ql-picker-item::before {\n    content: 'Sans Serif';\n  }\n  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {\n    content: 'Serif';\n  }\n  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {\n    content: 'Monospace';\n  }\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {\n    font-family: Georgia, Times New Roman, serif;\n  }\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {\n    font-family: Monaco, Courier New, monospace;\n  }\n  .ql-snow .ql-picker.ql-size {\n    width: 98px;\n  }\n  .ql-snow .ql-picker.ql-size .ql-picker-label::before,\n  .ql-snow .ql-picker.ql-size .ql-picker-item::before {\n    content: 'Normal';\n  }\n  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,\n  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {\n    content: 'Small';\n  }\n  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,\n  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {\n    content: 'Large';\n  }\n  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,\n  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {\n    content: 'Huge';\n  }\n  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {\n    font-size: 10px;\n  }\n  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {\n    font-size: 18px;\n  }\n  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {\n    font-size: 32px;\n  }\n  .ql-snow .ql-color-picker.ql-background .ql-picker-item {\n    background-color: #fff;\n  }\n  .ql-snow .ql-color-picker.ql-color .ql-picker-item {\n    background-color: #000;\n  }\n  .ql-toolbar.ql-snow {\n\n    border: 1px solid #4b0505f5;\n    box-sizing: border-box;\n    font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\n    padding: 3px;\n    border-top-right-radius: 10px;\n    border-top-left-radius: 10px;\n  }\n  .ql-toolbar.ql-snow .ql-formats {\n    margin-right: 15px;\n  }\n  .ql-toolbar.ql-snow .ql-picker-label {\n    border: 1px solid transparent;\n  }\n  .ql-toolbar.ql-snow .ql-picker-options {\n    border: 1px solid transparent;\n    box-shadow: rgba(0,0,0,0.2) 0 2px 8px;\n  }\n  .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {\n    border-color: $dark-red;\n  }\n  .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {\n    border-color: $dark-red;\n  }\n  .ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,\n  .ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {\n    border-color: #000;\n  }\n  .ql-toolbar.ql-snow + .ql-container.ql-snow {\n    border-top: 0px;\n    background-color: $dark-grey;\n    \n  }\n  .ql-snow .ql-tooltip {\n    background-color: #fff;\n    border: 1px solid #ccc;\n    box-shadow: 0px 0px 5px #ddd;\n    color: #444;\n    padding: 5px 12px;\n    white-space: nowrap;\n  }\n  .ql-snow .ql-tooltip::before {\n    content: \"Visit URL:\";\n    line-height: 26px;\n    margin-right: 8px;\n  }\n  .ql-snow .ql-tooltip input[type=text] {\n    display: none;\n    border: 1px solid #ccc;\n    font-size: 13px;\n    height: 26px;\n    margin: 0px;\n    padding: 3px 5px;\n    width: 170px;\n  }\n  .ql-snow .ql-tooltip a.ql-preview {\n    display: inline-block;\n    max-width: 200px;\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n    vertical-align: top;\n  }\n  .ql-snow .ql-tooltip a.ql-action::after {\n    border-right: 1px solid #ccc;\n    content: 'Edit';\n    margin-left: 16px;\n    padding-right: 8px;\n  }\n  .ql-snow .ql-tooltip a.ql-remove::before {\n    content: 'Remove';\n    margin-left: 8px;\n  }\n  .ql-snow .ql-tooltip a {\n    line-height: 26px;\n  }\n  .ql-snow .ql-tooltip.ql-editing a.ql-preview,\n  .ql-snow .ql-tooltip.ql-editing a.ql-remove {\n    display: none;\n  }\n  .ql-snow .ql-tooltip.ql-editing input[type=text] {\n    display: inline-block;\n  }\n  .ql-snow .ql-tooltip.ql-editing a.ql-action::after {\n    border-right: 0px;\n    content: 'Save';\n    padding-right: 0px;\n  }\n  .ql-snow .ql-tooltip[data-mode=link]::before {\n    content: \"Enter link:\";\n  }\n  .ql-snow .ql-tooltip[data-mode=formula]::before {\n    content: \"Enter formula:\";\n  }\n  .ql-snow .ql-tooltip[data-mode=video]::before {\n    content: \"Enter video:\";\n  }\n  .ql-snow a {\n    color: #75dfff;\n  }\n  .ql-container.ql-snow {\n    border: 1px solid $dark-red;\n    border-radius: 0 0 10px 10px;\n    \n  }\n  \n  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=\"lato\"]::before,\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=\"lato\"]::before {\n      content: 'Lato';\n  }\n  .ql-font-lato {\n    font-family: 'Lato', sans-serif;\n  }\n  \n  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=\"goodtimes\"]::before,\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=\"goodtimes\"]::before {\n      content: 'GoodTimes';\n  } \n  .ql-font-goodtimes {\n    font-family: 'GoodTimes', sans-serif;\n  }\n  \n  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=\"firacode\"]::before,\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=\"firacode\"]::before {\n      content: 'FiraCode';\n  } \n  .ql-font-firacode {\n    font-family: 'FiraCode', sans-serif;\n  }\n  \n  .ql-editor .uppercase {\n    text-transform: uppercase;\n  }\n\n  .uppercase {\n    text-transform: uppercase;\n  }\n  \n  \n  \n\n  //**************************//\n  //****** BETTER TABLE ******//\n  //**************************//\n\n  .ql-container .qlbt-selection-line.qlbt-selection-line-left::before {\n    position: absolute;\n    left: -2px;\n    top: -2px;\n    content: '';\n    width: 5px;\n    height: 5px;\n    background-color: #75dfff;\n    border-radius: 5px; }\n  \n    .ql-container .qlbt-selection-line.qlbt-selection-line-right::before {\n        position: absolute;\n        right: -2px;\n        bottom: -3px;\n        content: '';\n        width: 5px;\n        height: 5px;\n        background-color: #75dfff;\n        border-radius: 5px; \n    }\n    \n    .quill-better-table-wrapper {\n        overflow-x: auto; \n    }\n  \n    table.quill-better-table {\n        table-layout: fixed;\n        border-collapse: collapse; \n    }\n    table.quill-better-table td {\n        border: 1px solid $very-light-grey;\n        padding: 2px 5px; \n    }\n  \n  .qlbt-operation-menu {\n    background-color: #fff;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n    font-size: 14px;\n    z-index: 100;\n    overflow: hidden; }\n    .qlbt-operation-menu .qlbt-operation-menu-dividing {\n      height: 1px;\n      background-color: #efefef; }\n    .qlbt-operation-menu .qlbt-operation-menu-subtitle {\n      color: #999;\n      font-size: 14px;\n      padding: 5px 16px; }\n    .qlbt-operation-menu .qlbt-operation-color-picker {\n      display: flex;\n      align-items: center;\n      flex-wrap: wrap;\n      padding: 0 16px 10px;\n      background-color: #fff;\n      overflow: hidden; }\n      .qlbt-operation-menu .qlbt-operation-color-picker .qlbt-operation-color-picker-item {\n        width: 20px;\n        height: 20px;\n        border: 1px solid #595959;\n        margin-right: 5px;\n        margin-bottom: 5px;\n        cursor: pointer; }\n    .qlbt-operation-menu .qlbt-operation-menu-item {\n      display: flex;\n      align-items: center;\n      padding: 10px 16px;\n      background-color: #fff;\n      cursor: pointer;\n      color: #595959;\n      overflow: hidden;\n      text-overflow: ellipsis; }\n      .qlbt-operation-menu .qlbt-operation-menu-item:hover {\n        background-color: #efefef; }\n      .qlbt-operation-menu .qlbt-operation-menu-item .qlbt-operation-menu-icon {\n        margin-right: 8px;\n        height: 20px;\n        width: 20px;\n        font-size: 0; }\n  \n.qlbt-col-tool {\n    position: absolute;\n    display: flex;\n    align-items: flex-end;\n    overflow: hidden;\n    z-index: 99;\n    height: 16px; \n}\n\n.qlbt-col-tool .qlbt-col-tool-cell {\n    position: relative;\n    background-color: #fff;\n    border-top: 1px solid #000;\n    border-right: 1px solid #000;\n    border-bottom: 1px solid #000; \n}\n.qlbt-col-tool .qlbt-col-tool-cell:first-child {\n    border-left: 1px solid #000; \n}\n.qlbt-col-tool .qlbt-col-tool-cell-holder {\n    position: absolute;\n    right: -1px;\n    top: 0;\n    bottom: 0;\n    z-index: 3;\n    width: 1px;\n    background-color: transparent;\n    cursor: ew-resize; \n}\n    .qlbt-col-tool .qlbt-col-tool-cell-holder:hover {\n    background-color: #75dfff; \n}\n    .qlbt-col-tool .qlbt-col-tool-cell-holder::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: -6px;\n    display: block;\n    width: 8px;\n    height: 100%; \n}\n.qlbt-col-tool .qlbt-col-tool-cell-holder::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: -6px;\n    display: block;\n    width: 8px;\n    height: 100%; \n}\n\n.ql-icon-insert-table {\n    width: 16px;\n    height: 16px;\n    fill: $very-light-grey;\n    stroke: $very-light-grey;\n}\n          \n.ql-icon-insert-table:hover {\n    fill: #75dfff;\n    stroke: #75dfff;\n}\n          ","@import './../variables.scss';\n\n// --- Deduplicated blocks (same visual output) ---\n%lexical-heading-goodtimes {\n  color: white;\n  text-transform: uppercase;\n  font-family: GoodTimes;\n}\n\n%lexical-heading-lato-upper {\n  color: white;\n  font-weight: bold;\n  text-transform: uppercase;\n  margin: 10px 0px 7px 0px;\n  font-family: Lato;\n}\n\n.lexical-container {\n  position: relative;\n  display: grid;\n  //margin: 0px 15px;\n}\n\n/* Lexical @lexical/react CollaborationPlugin portals remote cursors here.\n   Default target is document.body with z-index ~5 — hidden under Bootstrap modals (~1050). */\n.lexical-collab-cursors-host {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  overflow: visible;\n  z-index: 50;\n}\n\n.lexical-editor {\n  position: relative;\n  overflow: visible;\n}\n\n.editor-content {\n  user-select: text;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.lexical-document-footer {\n  padding: 10px 15px;\n}\n\n.font-lato,\n.font-Lato {\n  font-family: 'Lato', sans-serif;\n}\n\n.font-goodtimes,\n.font-GoodTimes {\n  font-family: 'GoodTimes', sans-serif;\n}\n\n.lexical-parameters {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  margin: 5px 15px;\n}\n\n.collaboration-status {\n  margin: 0px 10px 0px 15px;\n  color: $very-light-grey;\n}\n\n.status-indicators {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.editor-container {\n  position: relative; /* anchor for portaled CommentPlugin UI inside this node */\n  overflow: visible; /* AddCommentBox sits slightly past the right outer edge */\n  display: grid;\n  border: 1px solid $dark-red;\n  border-radius: 5px;\n  border-bottom: 4px solid $dark-red;\n  background: $very-dark-grey;\n  border-top-right-radius: 10px;\n  border-top-left-radius: 10px;\n  margin: 0 ;\n  box-shadow: 4px 5px 2px #4b050547;\n  //bottom: 310px;\n}\n\n.editor-input {\n  position: relative;\n  min-height: 175px;\n  max-height: calc(100vh - 620px);\n  outline: none;\n  padding: 18px;\n  overflow-y: auto;\n  @include scrollbar-styles;\n\n  &.lexical-link-url-popup-open {\n    pointer-events: none !important;\n  }\n}\n\n.editor-input,\n.editor-input * {\n  -webkit-user-select: text !important; /* Safari/Chrome */\n  -moz-user-select: text !important;    /* Firefox */\n  -ms-user-select: text !important;     /* IE10+ */\n  user-select: text !important;         /* Standard */\n}\n\n.editor-placeholder {\n  display: none;\n  color: $very-light-grey;\n  padding: 10px 18px;\n}\n\n.editor-paragraph {\n  line-height: 1.45em;\n  margin-bottom: 5px;\n}\n\n.editor-bold {\n  font-weight: bolder;\n}\n\n.editor-italic {\n  font-style: italic;\n}\n\n.editor-underline {\n  text-decoration: underline;\n}\n\n.editor-strikethrough {\n  text-decoration: line-through;\n}\n\n.text-uppercase {\n  text-transform: uppercase;\n}\n\n.text-lowercase {\n  text-transform: lowercase;\n}\n\n.text-capitalize {\n  text-transform: capitalize;\n}\n\n.lexical-header1 {\n  @extend %lexical-heading-goodtimes;\n  font-size: 30px;\n  font-weight: lighter;\n  margin-block-start: 0em;\n}\n\n.lexical-header2 {\n  @extend %lexical-heading-goodtimes;\n  font-size: 26px;\n  font-weight: normal;\n}\n\n.lexical-header3 {\n  @extend %lexical-heading-goodtimes;\n  font-size: 24px;\n  font-weight: normal;\n  margin: 15px 0px 10px 0px;\n}\n\n.lexical-header4 {\n  @extend %lexical-heading-goodtimes;\n  font-size: 18px;\n  font-weight: normal;\n  margin: 15px 0px 10px 0px;\n}\n\n.lexical-header5 {\n  @extend %lexical-heading-lato-upper;\n  font-size: 16px;\n}\n\n.lexical-header6 {\n  @extend %lexical-heading-lato-upper;\n  font-size: 14px;\n}\n\n.lexical-paragraph { \n  font-size: 16px; \n  margin-top: 5px;\n  font-family: Lato;\n}\n\n\n// Links color code\n\n.editor-paragraph {\n  @include lexical-link-anchor-states(#84b4f3, #588dd3);\n}\n\n.lexical-editor {\n  @include lexical-link-anchor-states(white, #74aaf1);\n}\n\n\n\n// Set text alignment for elements\n\n.editor-image-wrapper {\n  display: grid;\n  position: relative;\n}\n\n$editor-image-align-justify: (\n  left: start,\n  center: center,\n  right: end,\n);\n\n@each $align, $justify in $editor-image-align-justify {\n  .editor-align-#{$align}.editor-image-wrapper {\n    width: 100%;\n    justify-items: $justify;\n  }\n}\n\n\n.editor-align-left,\n.editor-align-center,\n.editor-align-right,\n.editor-align-justify {\n  text-align: inherit;\n}\n\n\n\n.editor-align-left {\n  text-align: left;\n}\n\n.editor-align-center {\n  text-align: center;\n}\n\n.editor-align-right {\n  text-align: right;\n}\n\n.editor-align-justify {\n  text-align: justify;\n}\n\n\n\n// TOOLBAR\n\n.toolbar {\n  display: flex;\n  position: sticky !important;\n  height: 22px;\n  gap: 5px;\n  padding: 5px;\n  border-top-right-radius: 10px;\n  border-top-left-radius: 10px;\n  border-bottom: 2px solid $grey;\n  z-index: 100;\n  @include steel-bg(\"../medias/steel.png\");\n\n  .toolbar-button {\n    background-color: #00000033;\n    padding: 3px 5px;\n    color: $light-grey;\n    font-size: small;\n    border: none;\n    border-radius: 6px;\n    height: 22px;\n    cursor: pointer;\n\n    &:hover {\n      background-color: #00000050;\n      color: $very-light-grey;\n      filter: brightness(0) invert(80%);\n    }\n\n    &.lexical-fontsize {\n      width: 127px;\n    }\n\n    &.alignement {\n      width: 127px;\n    }\n\n    &.insert {\n      width: 93px;\n    }\n\n\n    &.toc {\n      position: relative;\n      align-items: center;\n      place-self: center;\n      height: 21px;\n    }\n\n    &.emojis {\n      position: relative;\n      background: none;\n    }\n\n    &.comments {\n      position: relative;\n      align-items: center;\n      place-self: center;\n      height: 20px;\n\n      &.has-unread-mention {\n        &:hover {\n          filter: none;\n        }\n      }\n    }\n\n    &.fontsize {\n      display: flex;\n      align-items: center;\n      place-self: center;\n      height: 17px;\n\n      .fontsize-button {\n        background: none;\n        border: none;\n        padding: 0 6px;\n        color: $light-grey;\n        cursor: pointer;\n\n        &:hover {\n          color: $very-light-grey;\n        }\n      }\n\n      .fontsize-label {\n        width: 20px;\n        color: $light-grey;\n        background: transparent;\n        font-size: small;\n        border: none;\n        cursor: text;\n\n\n        &:hover {\n\n          color: $light-grey;\n        }\n      }\n\n      &:hover .fontsize-label {\n\n        background: transparent;\n\n      }\n    }\n    \n    &:hover {\n      filter: brightness(0) invert(80%);\n    }\n  }\n\n  .buttons-set-right {\n    display: flex;\n    position: relative;\n    margin-left: auto;\n    margin-right: 3px;\n    gap: 3px;\n  }\n\n  .toolbar-button svg {\n    width: 21px; \n    transform: translateY(-2px);\n    flex-shrink: 0;\n  }\n}\n\n.toolbar .divider {\n  width: 1px;\n  background-color: $grey;\n}\n\n.editor-input u {\n  text-decoration: underline;\n}\n\n.editor-input s {\n  text-decoration: line-through;\n}\n\n.toolbar button.active {\n  font-weight: bold;\n  filter: brightness(0) invert(70%);\n\n  &:hover {\n    filter: brightness(0) invert(70%);\n  }\n}\n\n.toolbar button img {\n  width: auto;\n  height: 18px;\n  filter: brightness(0) invert(70%); // Gris clair\n  transition: filter 0.1s ease-in-out;\n\n  &:hover {\n    filter: brightness(0) invert(100%); // Blanc\n  }\n}\n\n.font-size-dropdown {\n  padding: 5px;\n  font-size: 14px;\n}\n\n.dropdown {\n  position: relative;\n  display: inline-block;\n\n  .lexical-chevrondown {\n    margin-right: 5px;\n    margin-left: auto;\n  }\n}\n\n\n.dropdown-toggle {\n  display: flex;\n  align-items: center;\n  color: $light-grey;\n\n  &.font-selection {\n    width: 115px;\n  }\n}\n\n.dropdown-toggle:hover {\n  color: white;\n  height: 20px;\n}\n\n.toolbar button img,\n.dropdown-content .dropdown-icon {\n  width: auto;\n  height: 14px;\n  margin-right: 5px;\n  margin-left: 4px;\n  filter: brightness(0) invert(70%); /* Gris clair */\n  transition: filter 0.1s ease-in-out;\n}\n\n.dropdown-content .dropdown-item:hover .dropdown-icon {\n  filter: brightness(0) invert(100%); /* Blanc */\n}\n\n\n/* Le menu sera affiché uniquement via le rendu conditionnel dans le JS */\n.dropdown-content {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  padding: 2px;\n  background-color: $very-dark-grey;\n  color: $light-grey;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  border-radius: 5px;\n  z-index: 100;\n  width: 220px;\n  max-height: 200px;\n  top: 120%;\n  left: 0;\n  border: 1px solid $dark-red;\n  border-radius: 6px 6px 6px 6px;\n  overflow-y: auto;\n  @include scrollbar-styles;\n}\n\n.dropdown-item {\n  display: flex;\n  align-items: center;\n  padding: 6px 8px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.dropdown-item:hover {\n  background-color: $dark-grey;\n}\n\n.dropdown-icon {\n  margin-right: 10px;\n  width: 16px;\n  height: 16px;\n}\n\n.dropdown-label {\n  flex-grow: 1;\n  color: $light-grey;\n  font-size: 14px;\n  margin-right: 10px;\n  width: max-content;\n}\n\n.dropdown-shortcut {\n  font-size: 12px;\n  color: #888;\n}\n\n\n// Insertlink popup\n//\n\n.link-input-container {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  background: $very-dark-grey;\n  border: 1px solid $dark-red;\n  padding: 5px;\n  border-radius: 5px;\n  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);\n  z-index: 10060;\n  pointer-events: auto;\n}\n\n/* Anchored inside `.editor-container` (same modal stacking context as the editor). */\n.link-input-container.link-input-container-portaled {\n  position: absolute;\n  top: var(--link-portal-top, 0);\n  left: var(--link-portal-left, 0);\n  z-index: 500;\n}\n\n.link-input-container input {\n  background: $light-grey;\n  border: 1px solid $dark-grey;\n  padding: 4px;\n  margin-right: 5px;\n  width: 200px;\n  border-radius: 3px;\n}\n\n.link-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 5px;\n}\n\n.link-button img {\n  background: transparent;\n  width: 16px;\n  height: 16px;\n  filter: brightness(0) invert(40%);\n}\n\n\n.link-button:hover img {\n  filter: brightness(0.8) invert(70%);\n}\n\n\n// LISTS //\n// ----- //\n\n/* ✅ Corrige l'affichage des bullets pour les sous-listes */\n.editor-input ul,\n.editor-input ol {\n  color: $light-grey;\n  padding-left: 20px; /* Maintient une indentation correcte */\n  margin-left: 0;\n  line-height: 1.35em;\n  list-style-position: outside; /* Assure l'alignement des bullets */\n\n  li {\n    margin-bottom: 5px;\n  }\n}\n\n/* ✅ Applique les bons styles de bullets pour chaque niveau */\n.editor-input ul {\n  list-style-type: disc; /* Premier niveau: • */\n}\n\n.editor-input ul ul {\n  list-style-type: circle; /* Deuxième niveau: ◦ */\n}\n\n.editor-input ul ul ul {\n  list-style-type: square; /* Troisième niveau: ▪️ */\n}\n\n/* ✅ Corrige les listes ordonnées */\n.editor-input ol {\n  list-style-type: decimal; /* Premier niveau: 1, 2, 3 */\n}\n\n.editor-input ol ol {\n  list-style-type: lower-alpha; /* Deuxième niveau: a, b, c */\n}\n\n.editor-input ol ol ol {\n  list-style-type: lower-roman; /* Troisième niveau: i, ii, iii */\n}\n\n/* ✅ Empêche l'affichage des bullets en trop sur la première ligne indentée */\n.editor-input li:has(> ul),\n.editor-input li:has(> ol) {\n  list-style-type: none; /* Supprime le bullet si l'élément contient une sous-liste */\n}\n\n/* View mode: nested list markers only (HTML is normalized on publish) */\n.lexical-rendered-content {\n  ul {\n    list-style-type: disc;\n  }\n\n  ul ul {\n    list-style-type: circle;\n  }\n\n  ul ul ul {\n    list-style-type: square;\n  }\n\n  ol {\n    list-style-type: decimal;\n    padding-left: 20px;\n    margin-left: 0;\n  }\n\n  ol ol {\n    list-style-type: lower-alpha;\n  }\n\n  ol ol ol {\n    list-style-type: lower-roman;\n  }\n}\n\n/* ✅ Corrige l'affichage des checkbox dans les listes (éditeur uniquement) */\n.editor-input li[role=\"checkbox\"] {\n  list-style: none;\n  margin-left: -20px !important;\n  padding-left: 0;\n  margin-left: 0;\n}\n\n.editor-input li[role=\"checkbox\"]::before {\n  content: \"\";\n  display: inline-block;\n  position: relative;\n  top: 3px;\n  width: 12px;\n  height: 12px;\n  border: 2px solid $light-grey;\n  border-radius: 4px;\n  margin-right: 8px;\n  cursor: pointer;\n}\n\n/* ✅ Affiche une coche quand la checkbox est cochée */\n.editor-input li[role=\"checkbox\"][aria-checked=\"true\"]::before {\n  position: relative;\n  top: 3px;\n  background-color: $dark-red; \n  background-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 16 16' fill='$light-grey' stroke='white' strokeWidth='3' xmlns='http://www.w3.org/2000/svg'%3E%3Cpolyline points='3,8 6,11 13,4'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 10px 10px;\n}\n\n.editor-input blockquote {\n  padding: 5px;\n  position: relative;\n  margin: 0;\n  margin-left: 0;\n  padding-left: 10px;\n  border-left: 5px solid $grey;\n}\n\n.editor-input blockquote ::before,\n.editor-input.framed ::after {\n  content: \"\";\n  position: absolute;\n  width: 20px; // ✅ Taille de la ligne horizontale\n  height: 20px; // ✅ Taille de la ligne verticale\n  border: none;\n}\n\n.editor-input blockquote ::before {\n  top: -10px;\n  left: -10px;\n  width: 50%;\n  height: 50%;\n  border-radius: 6px 0 0 0;\n  border-right: none;\n  border-bottom: none;\n}\n\n.editor-input blockquote ::after {\n  bottom: -10px;\n  right: -10px;\n  width: 50%;\n  height: 50%;\n  border-radius: 6px 0;\n  border-left: none;\n  border-top: none;\n}\n\n// Framed-text STYLISÉ //\n// ------------------- //\n\n.editor-input.framed {\n  font-family: \"Goodtimes\";\n  font-weight: normal;\n  line-height: 20px;\n  text-align: inherit;\n  user-select: none;\n  color: white;\n  background: transparent;\n  padding: 15px;\n  position: relative;\n  margin: 10px 0;\n  margin-left: 0;\n  padding-left: 5px;\n}\n\n// ✅ Ajoute les coins en haut à gauche et bas à droite\n.editor-input.framed ::before,\n.editor-input.framed ::after {\n  content: \"\";\n  position: absolute;\n  width: 20px; // ✅ Taille de la ligne horizontale\n  height: 20px; // ✅ Taille de la ligne verticale\n  border: none;\n}\n\n.editor-input.framed ::before {\n  top: -10px;\n  left: -10px;\n  border-top: 3px solid $grey;  // ✅ Ligne horizontale en haut\n  border-left: 3px solid $grey;  // ✅ Ligne verticale à gauche\n  width: 50%;\n  height: 50%;\n  border-radius: 6px 0 0 0;\n  border-right: none;\n  border-bottom: none;\n}\n\n.editor-input.framed ::after {\n  bottom: -10px;\n  right: -10px;\n  border-bottom: 3px solid $grey;  // ✅ Ligne horizontale en bas\n  border-right: 3px solid $grey;   // ✅ Ligne verticale à droite\n  border-left: none;\n  width: 50%;\n  height: 50%;\n  border-radius: 6px 0;\n  border-left: none;\n  border-top: none;\n}\n\n// horizontal rule //\n//\n\n.horizontal-rule {\n  border: none;\n  border-top: 2px solid $light-grey; /* ✅ Apparence propre */\n  margin: 16px 0;\n  width: 100%;\n}\n\n// column popup\n/* ✅ Style du popup */\n.column-popup {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  background: $very-dark-grey;\n  border: 1px solid #ccc;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  padding: 10px;\n  z-index: 100;\n  width: 210px;\n  border: 1px solid $dark-red;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* ✅ Titre du popup */\n.column-popup h4 {\n  font-size: 14px;\n  margin-bottom: 8px;\n  color: $very-light-grey;\n  text-align: center;\n}\n\n/* ✅ Style des boutons */\n.column-popup button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 8px;\n  background: $dark-grey;\n  border: none;\n  color: $very-light-grey;\n  cursor: pointer;\n  font-size: 14px;\n  border-radius: 4px;\n  transition: background 0.2s ease-in-out;\n}\n\n/* ✅ Effet au survol */\n.column-popup button:hover {\n  border: 1px solid $red;\n  filter: none;\n}\n\n/* ✅ Bouton d'annulation */\n.column-popup button:last-child {\n  background-image : url(../medias/steel.png);\n  background-color: $dark-red;\n  background-blend-mode: multiply; \n  color: $very-light-grey;\n  font-weight: bold;\n}\n\n.column-popup button:last-child:hover {\n  background-color: $red;\n  color: white;\n  filter: none;\n}\n\n\n\n/* ===================================== */\n/* ✅ Styles de base pour Column Layout\" */\n/* ===================================== */\n.lexical-column-layout {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 20px 0px;\n  table-layout: fixed; /* ✅ Force la répartition des tailles */\n  background: transparent !important; /* ✅ Fond transparent */\n  border: none !important; /* ✅ Aucune bordure */\n}\n\n/* ✅ Style des cellules (colonnes) */\n.lexical-column-layout td {\n  vertical-align: top;\n  padding: 10px;\n  border: none !important; /* ✅ Pas de bordure pour les cellules */\n  position: relative; /* ✅ Permet de positionner le trait */\n}\n\n/* ✅ Ajoute le trait vertical entre les colonnes */\n.lexical-column-layout td:not(:last-child)::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: -10px; /* ✅ Positionne au centre du gap (spacing de 20px) */\n  width: 2px; /* ✅ Épaisseur du trait */\n  height: 100%;\n  background-color: $grey; /* ✅ Couleur du trait */\n}\n\n\n\n/* ============================== */\n/* ✅ Styles de base pour tables */\n/* ============================== */\n// _table-cell-resizer.scss\n\n// Définir des variables (par exemple pour la couleur, la taille, etc.)\n$resizer-size: 12px;\n$half-resizer: -($resizer-size / 2);\n\n.PlaygroundEditorTheme__table {\n  width: auto;\n  border-collapse: collapse;\n  border-spacing: 0;\n  margin: 10px 0;\n  table-layout: fixed;\n\n  th,\n  .PlaygroundEditorTheme__tableCell {\n    border: 1px solid $light-grey; // ou $light-grey si défini\n    padding: 8px;\n    text-align: left;\n    background: transparent;\n    word-break: break-word;\n  }\n  \n  th {\n    background: red;\n    font-weight: bold;\n  }\n\n  col {\n    width: auto;\n  }\n\n  &.CustomTableNode__alignLeft {\n    margin-left: 0;\n    margin-right: auto;\n  }\n\n  &.CustomTableNode__alignCenter {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  &.CustomTableNode__alignRight {\n    margin-left: auto;\n    margin-right: 0;\n  }\n\n  &.CustomTableNode__alignJustify {\n    margin-left: auto;\n    margin-right: auto;\n    width: 100%;\n  }\n\n  &.tableSelected {\n    box-shadow: 0 0 0 2px #3b82f6 inset;\n  }\n}\n\n.PlaygroundEditorTheme__tableCell {\n  border: 1px solid $light-grey;\n  padding: 4px;\n}\n\n.PlaygroundEditorTheme__tableCellSelected {\n  outline: 2px solid #3b82f6; /* blue-500 */\n  outline-offset: -2px;\n  background-color: rgba(59, 130, 246, 0.1); /* light blue background */\n}\n\n.PlaygroundEditorTheme__tableSelection {\n  box-shadow: 0 0 0 2px #3b82f6 inset;\n}\n\n.TableCellResizer {\n  &__handle {\n    position: fixed;\n    z-index: 10000;\n    background-color: transparent;\n  }\n\n  &__handle--right {\n    cursor: col-resize;\n  }\n\n  &__handle--right.TableCellResizer__handle--hovered {\n    background-image: linear-gradient(\n      90deg,\n      transparent 6px,\n      rgba($light-blue, 0.95) 6px,\n      rgba($light-blue, 0.95) 8px,\n      transparent 8px\n    );\n  }\n\n  &__handle--bottom {\n    cursor: row-resize;\n  }\n\n  &__handle--dragging {\n    cursor: col-resize;\n  }\n\n  &__guide,\n  &__hover-guide {\n    position: fixed;\n    z-index: 10001;\n    pointer-events: none;\n    background-color: rgba($light-blue, 0.85);\n  }\n}\n\n\n/* ==================================== */\n/* ✅ Style pour l'insertion de tableau */\n/* ==================================== */\n.table-popup {\n  position: absolute;\n  background: $very-dark-grey;\n  width: max-content;\n  padding: 10px;\n  border: 1px solid $dark-red;\n  border-radius: 6px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n  z-index: 2000;\n  transform: translate(0px, 5px);\n}\n\n.table-popup h4 {\n  margin: 0 0 10px;\n  font-size: 14px;\n}\n\n.table-popup label {\n  display: flex;\n  margin-bottom: 5px;\n}\n\n.table-popup input {\n  display: flex;\n  width: 50px;\n  margin-left: auto;\n  margin-right: 5px;\n}\n\n.table-popup button {\n  margin-top: 10px;\n  padding: 5px 10px;\n  cursor: pointer;\n  border: none;\n  background-image : url(../medias/steel.png);\n  background-color: rgba(0, 51, 128, 0.2);\n  background-blend-mode: multiply; \n  color: $dark-red;\n  border-radius: 3px;\n}\n\n.table-popup button:hover {\n    background-color: rgba(0, 51, 128, 0.0);\n    color: $red;\n    text-decoration: none;\n    filter: none;\n}\n\n.table-popup button:last-child {\n  background-color: $dark-red;\n  color: $very-light-grey;\n}\n\n.table-popup button:last-child:hover {\n    border: none;\n    color: white;\n}\n\n/* Menu contextuel des cellules */\n.table-action-button {\n  position: absolute;\n  background: $light-grey;\n  border: none;\n  height: 18px;\n  width: 18px;\n  padding: 3px;\n  border-radius: 50%;\n  cursor: pointer;\n  z-index: 10002;\n  transition: opacity 0.2s;\n  opacity: 0.7;\n}\n\n.table-action-button:hover {\n  opacity: 1;\n}\n\n.table-context-menu {\n  position: absolute;\n  background: $very-dark-grey;\n  border: 1px solid $dark-red;\n  padding: 7px;\n  box-shadow: 2px 2px 10px rgba(0,0,0,0.2);\n  border-radius: 5px;\n  z-index: 10002;\n}\n\n.table-context-menu button {\n  display: block;\n  width: 100%;\n  padding: 6px;\n  border: none;\n  color: $light-grey;\n  background: $very-dark-grey;\n  text-align: left;\n  cursor: pointer;\n}\n\n.table-context-menu button:hover {\n  color: $very-light-grey;\n  background: $grey;\n}\n\n/* Boutons pour ajouter une ligne ou une colonne */\n.PlaygroundEditorTheme__tableAddRows,\n.PlaygroundEditorTheme__tableAddColumns {\n  position: absolute;\n  background: #007bff;\n  border: none;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  z-index: 1000;\n}\n\n.PlaygroundEditorTheme__tableAddRows {\n  bottom: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.PlaygroundEditorTheme__tableAddColumns {\n  right: -10px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.table-hover-actions {\n  position: absolute;\n  z-index: 1000;\n  pointer-events: auto;\n}\n\n/* Boutons pour ajouter une ligne ou une colonne */\n.table-hover-add-row,\n.table-hover-add-column {\n  background: $very-dark-grey;\n  border: none;\n  color: $very-light-grey;\n  height: 25px;\n  font-size: 16px;\n  cursor: pointer;\n  border-radius: 5%;\n  border: 1px solid $grey;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n\n.table-hover-add-row {\n  width: 100%; /* Ajuste à la largeur du tableau */\n}\n\n.table-hover-add-column {\n  writing-mode: vertical-lr;\n  height: 100%; /* Ajuste à la hauteur du tableau */\n  top: 20px;\n}\n\n.table-hover-add-row {\n  transform: translate(-50%, 0);\n}\n\n.table-hover-add-column {\n  transform: translate(0, -50%);\n}\n\n\n// DRAG AND DROP\n\n/* ✅ La poignée de bloc (à gauche du texte) */\n.draggable-block-menu {\n  position: absolute;\n  z-index: 1;\n  opacity: var(--draggable-opacity, 0);\n  left: var(--draggable-left, -10000px);\n  top: var(--draggable-top, -10000px);\n  pointer-events: auto;\n  cursor: grab;\n  transition: opacity 0.2s;\n}\n\n.draggable-block-icon {\n  display: block;\n  opacity: 0.6;\n  transition: opacity 0.2s;\n}\n\n.draggable-block-menu:hover .draggable-block-icon {\n  opacity: 1;\n}\n\n.draggable-block-target-line {\n  position: absolute;\n  height: 4px;\n  background-color: $grey;\n  border-radius: 2px;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s;\n}\n\n.table-color-picker-wrapper {\n  //position: fixed;\n  background: $very-dark-grey;\n  border: 1px solid $dark-red;\n  border-radius: 6px;\n  padding: 12px;\n  transform: translate(45px, -18px);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n  width: 185px;\n  z-index: 10002;\n}\n\n/* ===================================== */\n/* ✅ Style pour l'insertion de mention */\n/* ===================================== */\n\n/* LexicalTypeaheadMenuPlugin mounts popovers here — must clear Bootstrap modals (~1050). */\n#typeahead-menu {\n  z-index: 9999;\n}\n\n/*  wrapper for the dropdown */\n.typeahead-popover.mentions-menu {\n  position: absolute;\n  background: $very-dark-grey;\n  border: 1px solid $dark-red;\n\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  max-height: 240px;          /*  limit height */\n  overflow-y: auto;           /*  scroll if too tall */\n  padding: 4px 0;             /*  vertical padding */\n  z-index: 9999;\n}\n\n/*  remove default list styles */\n.typeahead-popover.mentions-menu ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n/*  each mention row */\n.typeahead-popover.mentions-menu li.item {\n  display: flex;\n  align-items: center;\n  padding: 6px 12px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n/*  hover and selected states */\n.typeahead-popover.mentions-menu li.item:hover,\n.typeahead-popover.mentions-menu li.item.selected {\n  background-color: $grey;\n}\n\n/*  avatar sizing */\n.mention-avatar {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  margin-right: 8px;\n}\n\n.lexical-mention-group-badge {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #faa61a;\n  margin-right: 8px;\n  flex-shrink: 0;\n}\n\n/*  username text */\n.mentions-menu .text {\n  font-size: 14px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n#typeahead-menu .typeahead-popover.mentions-menu {\n  min-width: 200px !important; \n}\n\n.typeahead-popover.mentions-menu.loot-menu {\n  min-width: 240px;\n  @include scrollbar-styles;\n\n  li.item.loot-item {\n    align-items: flex-start;\n\n    .loot-dd-col {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 2px;\n      line-height: 1.25;\n      min-width: 0;\n    }\n\n    .benefits-loot-dd-label {\n      font-size: 13px;\n      color: rgba(255, 255, 255, 0.92);\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      max-width: 100%;\n    }\n\n    .benefits-loot-dd-meta {\n      font-size: 11px;\n      color: rgba(255, 255, 255, 0.55);\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      max-width: 100%;\n    }\n  }\n}\n\n.editor-input .lexical-sc-item-chip-decorator .sc-item-chip,\n.lexical-sc-item-chip-root .lexical-sc-item-chip-decorator .sc-item-chip {\n  vertical-align: middle;\n  margin: 0 3px;\n}\n\n.mention {\n  background-color: rgba(3, 97, 149, 0.6);\n  border-radius: 5px;\n  padding: 4px 6px 4px 6px;\n  margin-left: 5px;\n\n  &::before {\n    content: \"@\";\n    margin-right: 0.1em;\n  }\n\n  &:hover {\n    background-color: rgba(38, 133, 184, 0.6);\n  }\n\n  &.mention--group {\n    background-color: rgba(250, 166, 26, 0.25);\n\n    &:hover {\n      background-color: rgba(250, 166, 26, 0.35);\n    }\n  }\n}\n\n/* =============================== */\n/* ✅ Style pour Table of content */\n/* =============================== */\n\n .table-of-contents .heading2 {\n  margin-left: 10px;\n}\n\n.table-of-contents .heading3 {\n  margin-left: 20px;\n}\n\n.selected-heading {\n  color: #3578e5;\n  position: relative;\n}\n\n.selected-heading-wrapper::before {\n  content: ' ';\n  position: absolute;\n  display: inline-block;\n  left: -30px;\n  top: 4px;\n  z-index: 10;\n  height: 4px;\n  width: 4px;\n  background-color: #3578e5;\n  border: solid 4px white;\n  border-radius: 50%;\n}\n\n.normal-heading {\n  cursor: pointer;\n  line-height: 20px;\n  font-size: 16px;\n}\n\n.lexical-side-panels {\n  //position: sticky !important;\n  position: absolute !important;\n  //top: 92px !important;\n  height: 0;\n  .toc-container,\n  .emoji-container {\n    position: sticky !important;\n    //top: 92px !important;\n    height: 0;\n  }\n}\n\n.emoji-container.emoji-offset {\n  position: fixed !important;\n  height: 0;\n  transform: translateY(-1835px);\n\n  .lexical-emoji-picker {\n    .emoji-grid {\n      overflow: auto;\n      height: 100px;\n    }\n  }\n}\n\n.toc-container.toc-offset {\n  position: fixed !important;\n  height: 0;\n\n  .table-of-contents {\n    .content {\n      .headings {\n        min-height: 135px;\n        max-height: 135px;\n      }\n    }\n  }\n}\n\n\n.table-of-contents {\n  position: absolute;\n  color: $light-grey;\n  background: $dark-grey;\n  width: 250px;\n  transform: translatex(-260px);\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  border-radius: 10px;\n  border: 1px solid $dark-red;\n  border-bottom: 4px solid $dark-red;\n  z-index: 1;\n  box-shadow: 4px 5px 2px #4b050547;\n \n\n  .header {\n    @include steel-bg(\"../medias/steel.png\");\n    width: 100%;\n    height: 34px;\n    border-radius: 0px;\n    border-top-right-radius: 10px;\n    border-top-left-radius: 10px;\n    display: flex;\n    align-items: center; \n    border-bottom: 1px solid $grey;\n\n    .header-title {\n      text-transform: uppercase;\n      font-size: 13px;\n      width: 100%;\n      color: $light-grey;\n      margin-left: 5px;\n      font-weight: bold;\n    }\n\n    .content {\n      font-size: 14px;\n      width: 100%;\n      color: $light-grey;\n      margin-left: 5px;\n      font-weight: bold;\n    }\n  }\n  \n  .options {\n    height: 60px; \n    background: $very-dark-grey;\n    border-bottom: 1px solid $dark-red;\n    display: flex;\n    margin-bottom: 0px;\n    flex-direction: column;\n    justify-content: space-evenly;\n\n    .option-row {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: 0;\n      margin: 5px 0px 0px 20px;\n      width: 100%;\n\n      .toggle-switch {\n        color: $light-grey;\n        justify-self: right;\n        transform: translateX(-25px);\n      }\n\n      span {\n        color: $light-grey;\n      }\n\n      input[type=\"checkbox\"] {\n        margin-right: 5px;\n      }\n    }\n  }\n\n}\n\n\n\n.first-heading {\n  color: black;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.table-of-contents {\n  .headings {\n    background-color: $blue-grey;\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    height: calc(100% - 25px); \n    max-height: none; \n    overflow: auto;\n    @include scrollbar-styles;\n\n    .toc-h1 {\n      color: white;\n      font-size: 20px;\n      font-weight: bolder;\n      text-transform: uppercase;\n      margin-bottom: 15px;\n      font-family: GoodTimes;\n    }\n\n    .toc-h2 {\n      font-size: 16px;\n      font-weight: bolder;\n      color: $very-light-grey;\n      text-transform: capitalize;\n      margin-top: -15px;\n      margin-bottom: 15px;\n      font-family: Lato;\n    }\n\n    .toc-h3 {\n      font-size: 16px;\n      font-weight: bolder;\n      color: $very-light-grey;\n      text-transform: uppercase;\n      margin-top: 15px;\n      margin-left: 0px;\n      font-family: Lato;\n      cursor: pointer;\n    }\n\n    .toc-h4 {\n      font-size: 14px;\n      font-weight: bold;\n      color: $very-light-grey;\n      text-transform: uppercase;\n      margin-top: 5px;\n      margin-left: 15px;\n      margin-bottom: 5px;\n      font-family: Lato;\n      cursor: pointer;\n    }\n\n    .toc-h5 {\n      font-size: 14px;\n      font-weight: 300;\n      color: $light-grey;\n      text-transform: capitalize;\n      margin-top: 5px;\n      margin-left: 30px;\n      margin-bottom: 5px;\n      font-family: Lato;\n      cursor: pointer;\n    }\n\n    .toc-h6 {\n      font-size: 14px;\n      font-weight: 100;\n      color: $light-grey;\n      text-transform: capitalize;\n      margin-top: 5px;\n      margin-left: 45px;\n      margin-bottom: 5px;\n      font-family: Lato;\n      cursor: pointer;\n    }\n  }\n}\n\n.with-heading-number::before {\n  content: attr(data-heading-numbering) \" \";\n  font-weight: bold;\n  margin-right: 0.2rem;\n}\n\n\n/* Let .table-of-contents .headings keep @include scrollbar-styles (visible thumb). */\n\n.headings::before {\n  display: none;\n}\n\n.normal-heading-wrapper {\n  margin-left: 32px;\n  position: relative;\n}\n\n.image-align-left {\n  display: flex !important;\n  justify-content: left;\n}\n\n.image-align-center {\n  display: flex !important;\n  justify-content: center;\n}\n\n.image-align-right {\n  display: flex !important;\n  justify-content: right;\n}\n\n// ================== //\n// Insert Image Popup //\n// ================== //\n\n.insert-image-dialog {\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  transform: translate(-65%, 3%);\n  z-index: 1000;\n  background-color: $very-dark-grey;\n  border: 1px solid $dark-red;\n  border-radius: 6px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);\n  padding: 10px;\n  max-width: 420px;\n  width: 100%;\n\n  .insert-image-dialog__input {\n    padding: 5px;\n    color: $very-light-grey;\n    background-color: $grey;\n    border: 1px solid $light-grey;\n    border-radius: 4px;\n    font-size: 14px;\n  }\n\n  .insert-image-dialog__field {\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n  }\n\n  .insert-image-dialog__dropzone {\n    border: 2px dashed $light-grey;\n    background-color: $grey;\n    padding: 15px;\n    margin: 0px 15px 5px;\n    text-align: center;\n    color: $very-light-grey;\n    font-size: 14px;\n    border-radius: 6px;\n    //cursor: pointer;\n  }\n\n  .insert-image-dialog__toggle {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .insert-image-dialog__actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n\n    .insert-image-dialog__btn {\n      padding: 6px 12px;\n      font-size: 14px;\n      border: none;\n      border-radius: 4px;\n      cursor: pointer;\n      background-color: #007bff;\n      color: white;\n\n      &:disabled {\n        background-color: #ccc;\n        cursor: not-allowed;\n      }\n    }\n  }\n}\n\n\n\n// ================== //\n// Insert Video Popup //\n// ================== //\n\n.insert-video-dialog {\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  transform: translate(-65%, 3%);\n  z-index: 1000;\n  background-color: $very-dark-grey;\n  border: 1px solid $dark-red;\n  border-radius: 6px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);\n  padding: 10px;\n  max-width: 420px;\n  width: 100%;\n  gap: 10px;\n\n  .insert-video-dialog__input {\n    padding: 5px;\n    color: $very-light-grey;\n    background-color: $grey;\n    border: 1px solid $light-grey;\n    border-radius: 4px;\n    font-size: 14px;\n  }\n\n  .insert-video-dialog__field {\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n  }\n\n  .insert-video-dialog__dropzone {\n    border: 2px dashed $light-grey;\n    background-color: $grey;\n    padding: 20px;\n    margin: 5px 20px;\n    text-align: center;\n    color: $very-light-grey;\n    font-size: 14px;\n    border-radius: 6px;\n    //cursor: pointer;\n  }\n\n  .insert-video-dialog__toggle {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .insert-video-dialog__actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n\n    .insert-video-dialog__btn {\n      padding: 6px 12px;\n      font-size: 14px;\n      border: none;\n      border-radius: 4px;\n      cursor: pointer;\n      background-color: #007bff;\n      color: white;\n\n      &:disabled {\n        background-color: #ccc;\n        cursor: not-allowed;\n      }\n    }\n  }\n}\n\n\n\n\n// ============== //\n//  Image resizer //\n// ============== //\n\n// 1) Esquisse de base pour l’image sélectionnée\nimg.focused {\n  outline: 2px solid $grey;\n  outline-offset: 2px;\n}\n\n\n// 2) Conteneur général du décorateur (image + contrôles + légende)\n[data-lexical-decorator] {\n  display: grid;\n  vertical-align: top;\n  line-height: 0;\n  margin: 15px 0;\n\n  // 2.1) Wrapper spécifique pour l’image + poignées\n  > .image-container,\n  > figure.inline-left > .image-container,\n  > figure.inline-right > .image-container {\n    position: relative;\n    display: inline-block; \n\n    // 2.1.1) Wrapper de l’image draggable\n    > div[draggable] {\n      display: inline-block;\n    }\n\n    // 2.1.2) Handles de redimensionnement\n    .image-resizer {\n      position: absolute;\n      width: 8px;\n      height: 8px;\n      background: $red;\n      border: 1px solid $grey;\n      box-sizing: border-box;\n      z-index: 10;\n      pointer-events: all;\n    }\n    \n    .image-resizer-n  { top: -4px;    left: 50%;  transform: translateX(-50%); cursor: n-resize;  }\n    .image-resizer-s  { bottom: -4px; left: 50%;  transform: translateX(-50%); cursor: s-resize;  }\n    .image-resizer-w  { left: -4px;   top: 50%;   transform: translateY(-50%); cursor: w-resize;  }\n    .image-resizer-e  { right: -4px;  top: 50%;   transform: translateY(-50%); cursor: e-resize;  }\n    .image-resizer-nw { left: -4px;   top: -4px;                               cursor: nw-resize; }\n    .image-resizer-ne { right: -4px;  top: -4px;                               cursor: ne-resize; }\n    .image-resizer-sw { left: -4px;   bottom: -4px;                            cursor: sw-resize; }\n    .image-resizer-se { right: -4px;  bottom: -4px;                            cursor: se-resize; }\n\n    // 2.1.3) Bouton \"Add Caption\" DETACHÉ du flux pour ne pas élargir .image-container\n    .image-caption-button {\n      position: absolute;\n      bottom: -15px;\n      left: 50%;\n      width: max-content;\n      transform: translateX(-50%);\n      margin: 0;\n      pointer-events: all;\n      z-index: 15;\n      padding: 2px 6px;\n      font-size: 0.65rem;\n      border-radius: 4px;\n      cursor: pointer;\n    }\n  }\n\n  // 2.2) Bouton \"Add Caption\" hors de .image-container (cas rare, reste inchangé)\n  .image-caption-button {\n    position: static;\n    display: inline-block;\n    margin: 4px auto 0;\n    pointer-events: all;\n    z-index: 15;\n    padding: 2px 6px;\n    font-size: 0.65rem;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n\n  // 2.3) Zone de saisie de la légende (caption) - flow normal, multiline\n\n  .image-caption-placeholder {\n    position: static;\n    display: block;\n    width: 100%;\n    max-width: 100%;\n    margin: 4px auto 0;\n    pointer-events: all;\n    z-index: 20;\n    text-align: center;\n    white-space: pre-wrap;\n    word-break: break-word;\n  }\n\n  .image-caption-input {\n    display: block;\n    position: relative;\n    width: 100%;\n    min-width: 125px;\n    min-height: 1.5em;\n    text-align: center;\n    white-space: pre-wrap;\n    word-break: break-word;\n    margin: auto;\n    padding: 6px;\n    background: $grey;\n    border: none;\n    border-radius: 6px;\n    color: $very-light-grey;\n    line-height: 1.4em;\n    resize: none; \n    z-index: 9999;\n\n    .editor-paragraph {\n      color: white;\n    }\n  }\n\n  .image-container,\n  .image-caption-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-right: auto;\n    margin-left: auto;\n\n    &.align-left   {  \n      margin: 0 auto 0 0; \n    }\n\n    &.align-center { \n      margin: 0 auto; \n    }\n\n    &.align-right  { \n      margin: 0 0 0 auto; \n    }\n  }\n\n  .image-caption-placeholder {\n    position: relative;\n    color: $light-grey;\n    line-height: 1.4em;\n    text-align: center;\n    bottom: 35px;\n    padding: 4px;\n    border-radius: 4px;\n    margin-bottom: -40px;\n  }\n}\n\n.image-caption {\n  font-size: large;\n  color: $light-grey;\n  padding: 5px;\n  place-self: center;\n  border: 1px solid $grey;\n  border-radius:  8px;\n}\n\n//\n//\n//\n\n.editor-content [data-lexical-decorator] {\n  display: inline;\n  // display: inline !important;\n}\n\n.lexical-decorator.inline-node {\n  display: inline;\n}\n\n/* emoji-inline needs its own box */\n.lexical-decorator.emoji-node {\n  display: inline-block;\n  margin: 0px 2px;\n}\n\n/* float à gauche, texte à droite */\n.inline-left {\n  float: left;\n  margin: 0 1em 1em 0;\n\n  &.emoji {\n    margin: 0;\n  }\n}\n\n/* float à droite, texte à gauche */\n.inline-right {\n  float: right;\n  margin: 0 0 1em 1em;\n}\n\n/* légende sous l’image */\n.inline-left figcaption,\n.inline-right figcaption {\n  display: block;\n  text-align: center;\n  margin-top: 0.5em;\n  font-size: 0.9em;\n  color: #666;\n}\n\n/*  ensure the dialog select matches the inputs */\n.insert-image-dialog__field select.insert-image-dialog__input {\n  width: 100%;\n  padding: 0.5em;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n/*  you can tweak the dialog layout if needed */\n.insert-image-dialog {\n  max-width: 400px;\n}\n\n.insert-image-dialog__field {\n  margin-bottom: 1em;\n}\n\n/* 3) Après chaque paragraphe, on vide le float pour éviter de contaminer le suivant */\n.editor-content p::after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n\n// -------------- //\n// EMOJIS Picker  //\n// -------------- //\n\n.lexical-emoji-picker {\n  position: absolute;\n  color: $light-grey;\n  background: $dark-grey;\n  width: 250px;\n  transform: translateX(-260px);\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  border-radius: 10px;\n  border: 1px solid $dark-red;\n  border-bottom: 4px solid $dark-red;\n  z-index: 1;\n  box-shadow: 4px 5px 2px #4b050547;\n \n\n  .emoji-header {\n    @include steel-bg(\"../medias/steel.png\");\n    width: 100%;\n    height: 34px;\n    border-radius: 0px;\n    border-top-right-radius: 10px;\n    border-top-left-radius: 10px;\n    display: flex;\n    align-items: center; \n    border-bottom: 2px solid $grey;\n\n    .header-title {\n      text-transform: uppercase;\n      font-size: 0.85em;\n      width: 100%;\n      color: $light-grey;\n      margin-left: 5px;\n      font-weight: bold;\n    }\n  }\n\n  .emoji-categories {\n    display: flex;\n    flex-wrap: wrap;\n    height: fit-content;\n    gap: 0 8px;\n    padding-top: 10px;\n    justify-content: center;\n    background: $very-dark-grey;\n    border-bottom: 1px solid $dark-red;\n\n    .emoji-tab {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      padding: 4px 6px;\n      border: none;\n      background: none;\n      cursor: pointer;\n      border-radius: 4px;\n      transition: background 0.2s;\n\n      &:hover {\n        background: $grey;\n      }\n\n      &.active {\n        background: $grey;\n      }\n\n      .emoji-tab-icon {\n        display: inline-block;\n        width: 20px;\n        height: 20px;\n        color: $light-grey;\n        transition: color 0.2s;\n\n        svg {\n          fill: $light-grey; \n          width: 19px; \n          height: 19px;\n          transition: fill 0.2s;\n        }\n      }\n    }\n\n    .emoji-panel-search {\n      margin: 10px 0;\n\n      .emoji-search-input {\n        padding: 6px 10px;\n        border-radius: 6px;\n      }\n    }\n\n  }\n\n  .emoji-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(32px, 1fr));\n    gap: 2px;\n    padding: 8px;\n    max-height: max-content;\n    background: $dark-grey;\n    overflow-y: auto;\n    @include scrollbar-styles;\n  \n    .emoji-button {\n      width: 32px;\n      height: 32px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border: none;\n      background: none;\n      font-size: 20px;\n      cursor: pointer;\n      border-radius: 4px;\n      transition: background 0.2s;\n  \n      &:hover {\n        background: $grey;\n      }\n  \n      .emoji-img {\n        width: 20px;\n        height: 20px;\n        object-fit: contain;\n        display: block;\n      }\n    }\n  }\n}\n\n// emoji dropdown\n\n.typeahead-popover.emoji-menu {\n  position: absolute;               //  position relative to the trigger anchor\n  z-index: 9999;\n  max-height: 240px;\n  background: $very-dark-grey;\n  border: 1px solid $dark-red;\n  border-radius: 6px;               //  rounded corners\n  box-shadow: 0 4px 8px rgba(0,0,0,0.1); //  light shadow for depth\n  margin-top: 4px;                  //  small gap from the anchor\n  padding: 4px 0; \n  \n\n  ul {\n    list-style: none;               //  remove default bullets\n    margin: 0;\n    padding: 0;\n    max-height: 200px;              //  limit height with scroll\n    border-radius: 6px;    \n    overflow-y: auto;\n    @include scrollbar-styles;\n  }\n\n  li {\n    display: flex;\n    align-items: center;\n    padding: 0.5rem 1rem;           //  space inside each item\n    cursor: pointer;                //  pointer cursor on hover\n    transition: background 0.2s;    //  smooth hover transition\n\n    &.selected,\n    &:hover {\n      background: $grey;          //  highlight on hover/selection\n    }\n\n    .emoji-img {\n      width: 1.2em;                 //  adjust emoji icon size\n      height: 1.2em;\n      margin-right: 0.5rem;         //  space between icon and text\n    }\n\n    .text {\n      display: flex;\n      flex-wrap: wrap;\n      flex: 1;                      //  let text take remaining space\n      font-size: 0.9rem;            //  slightly smaller text\n      color: $very-light-grey;\n      width: 180px;\n    }\n  }\n}\n\n// emoji in the editor\n.editor-content figure.emoji {\n  float: none !important;\n  display: inline-block;\n  margin: 0 .25em;\n\n  // 1) on masque le conteneur “caption + resizers”\n  .image-container {\n    // deuxième <div> enfant contient le bouton et les resizers\n    > div:nth-child(2) {\n      display: none !important; //  hide the caption & resizer wrapper\n    }\n  }\n}\n\n.emoji-inner {\n  height: 20px;\n\n  img {\n    height: 20px;\n\n  }\n}\n\n.youtube-container.selected {\n  iframe {\n    outline: 4px solid $grey;\n  }\n}\n\n.youtube-container {\n  display: flex;\n\n  &.youtube-align-left {\n    justify-content: flex-start;\n  }\n\n  &.youtube-align-center {\n    justify-content: center;\n  }\n\n  &.youtube-align-right {\n    justify-content: flex-end;\n  }\n}\n\n.emoji-node .emoji-inner {\n  display: inline-block;\n  width: 1em;\n  height: 1em;\n  vertical-align: middle;\n\n  img {\n    height: 17px;\n  }\n  img.draggable {\n    cursor: default;\n  }\n  img.focused {\n    outline: none;\n    outline-offset: 2px;\n  }\n  .image-caption-button {\n    display: none;\n  }\n}\n\n// -------------- //\n//    Comments    //\n// -------------- //\n\n.CommentPlugin_AddCommentBox {\n  position: absolute; /* relative to .editor-container */\n  right: -10px; /* a few px to the right of the editor’s outer (right) border */\n  left: auto;\n  width: 15px;\n  height: 40px;\n  padding: 5px 2px;                /* bubble padding */\n  border-radius: 15%;           /* perfect circle */\n  //background: $blue-grey;\n  border: 3px solid $light-blue;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n    color: #000;\n  background: linear-gradient(\n    45deg,\n    #5f5f5f 5%,\n    #9c9b9b 10%,\n    #949494 30%,\n    #696969 60%,\n    #949494 70%,\n    #9c9b9b 80%,\n    #5f5f5f 95%\n  );\n  z-index: 10;\n  transform: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:hover {\n    background: linear-gradient(\n      45deg,\n      #5f5f5f 5%,\n      #808080 10%,\n      #7a7a7a 30%,\n      #696969 60%,\n      #7a7a7a 70%,\n      #808080 80%,\n      #5f5f5f 95%\n    );\n  }\n\n  img {\n    position: relative;\n    vertical-align: -15px;\n    width: 12px;\n    left: 2px;\n    filter: brightness(0) invert(80%);\n  }\n}\n\n/*  show when plugin inserts the box into the DOM */\n.CommentPlugin_AddCommentBox[data-visible=\"true\"] {\n  display: block;\n}\n\n.PlaygroundEditorTheme__paragraph {\n  position: relative;\n  align-content: center;\n  min-height: 2em;\n  width: 170px;\n  padding: 5px 10px;\n  z-index: 1000;\n}\n\n//---\n\n.CommentPlugin_CommentsWrapper {\n  position: absolute;\n  transform: translateX(265px);\n  right: 0;\n  top: 0; \n  z-index: 20000; \n}\n\n.CommentPlugin_CommentsPanel_DeletedComment {\n  color: $light-grey;\n  text-decoration: dashed;\n  margin-bottom: 10px;\n}\n\n.CommentPlugin_CommentsPanel {\n  position: relative;\n  width: 257px; \n  color: $very-light-grey;\n  background-color: $dark-grey;\n  border: 1px solid $dark-red;\n  border-bottom: 4px solid $dark-red;\n  border-radius: 10px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  overflow: hidden;\n  z-index: 1000;\n\n\n  .CommentPlugin_CommentsPanel_Heading {\n    display: flex;\n    @include steel-bg(\"../medias/steel.png\");\n    width: 100%;\n    height: 34px;\n    font-size: 13px;\n    font-weight: bold;\n    border-radius: 0px;\n    border-top-right-radius: 10px;\n    border-top-left-radius: 10px;\n    text-transform: uppercase;\n    width: 100%;\n    color: $light-grey;\n    align-items: center; \n    padding: 0 10px;\n    border-bottom: 2px solid $grey;\n  }\n\n\n  .CommentPlugin_CommentsPanel_List {\n    display: flex;\n    flex-direction: column;\n    font-size: 15px;\n    font-weight: normal;\n    padding: 10px 0px 0px 10px;\n    max-height: fit-content; \n    overflow: scroll;\n    list-style-type: none;\n    @include scrollbar-styles;\n\n\n    .CommentPlugin_CommentsPanel_List_Thread  {\n      background-color: $dark-grey;\n      border-radius: 8px 8px 0px 0;\n      width: fit-content;\n\n      &.active {\n        .CommentPlugin_CommentsPanel_List_Thread_QuoteBox {\n          border: 1px solid #6a4900;\n          border-bottom: none;\n          border-radius: 8px 8px 0px 0;\n          background: #6a4900;\n        }\n\n        .CommentPlugin_CommentsPanel_List_Thread_Comments {\n          padding-inline-start: 0px;\n          background: $blue-grey;\n\n          .CommentPlugin_CommentsPanel_List_Comment {\n            border-top: 4px solid #6a4900 ;\n            border-left: 5px solid #6a4900;\n            border-right: 2px solid #6a4900;\n\n            &.main-comment {\n              background: $dark-grey;\n            }\n\n\n          }\n        }\n\n        .CommentPlugin_CommentsPanel_List_Thread_Editor {\n          border-top: none;\n\n          .CommentPlugin_CommentInputBox_EditorContainer {\n            bottom: 5px;\n            border-top: 4px solid #6a4900 ;\n            border: 5px solid #6a4900;\n            border-right: 2px solid #6a4900;\n            border-top: none;\n            border-radius: 0 0 6px 6px;\n          }\n        }\n      }\n\n        &.comment_not_found {\n\n        .CommentPlugin_CommentsPanel_List_Thread_QuoteBox {\n          border: 1px solid $dark-red;\n          background: $dark-red;\n        }\n\n        .CommentPlugin_CommentsPanel_List_Thread_Comments {\n          background: $blue-grey;\n          padding-inline-start: 0px;\n          \n\n          .CommentPlugin_CommentsPanel_List_Comment {\n            border-left: 5px solid $dark-red;\n            border-right: 2px solid $dark-red;\n          }\n        }\n\n        .CommentPlugin_CommentsPanel_List_Thread_Editor {\n\n          .CommentPlugin_CommentInputBox_EditorContainer {\n            border: 5px solid $dark-red;\n            border-right: 2px solid $dark-red;\n            border-top: none;\n          }\n        }\n      }\n\n      .CommentPlugin_CommentsPanel_List_Thread_QuoteBox {\n        display: flex;\n        color: $very-light-grey;\n        background: $very-dark-grey;\n        border: 1px solid $very-dark-grey;\n        border-bottom: none;\n        border-radius: 8px 8px 0px 0;\n        padding: 5px 0px;\n        width: 224px;\n\n        .CommentPlugin_CommentsPanel_List_Thread_Quote {\n          font-weight: bold;\n          margin-block-start: 3px;\n          margin-block-end: 0px;\n          margin-inline-start: 10px;\n          margin-inline-end: 10px;\n        }\n\n        .CommentPlugin_CommentsPanel_List_DeleteButton {\n          opacity: 0.2;\n          position: relative;\n          background: none;\n          align-self: flex-start;\n          bottom: 0px;\n          margin: 0px 0px 0 auto;\n          filter: brightness(0) invert(80%);\n          border: none;\n          cursor: pointer;\n\n          &:hover {\n            opacity: 1;\n          }\n        }\n      }\n\n      &.CommentPlugin_CommentsPanel_List_Thread_Quote {\n        margin-block-start: 0px;\n        margin-block-end: 0px;\n        margin-inline-start: 10px;\n        margin-inline-end: 0px;\n      }\n\n      .CommentPlugin_CommentsPanel_List_Thread_Comments {\n        display: flex;\n        background: $blue-grey;\n        flex-direction: column;\n        padding-inline-start: 0px;\n        list-style-type: none;\n        width: 226px;\n\n        .CommentPlugin_CommentsPanel_List_Comment {\n          display: flex;\n          flex-direction: column;\n          border-top: 4px solid $very-dark-grey;\n          //border-top: 4px solid #6a4900 ;\n          border-left: 5px solid $very-dark-grey;\n          border-right: 2px solid $very-dark-grey;\n          padding: 6px;\n\n          p {\n            color: $very-light-grey;\n\n            span {\n              user-select: text !important;\n            }\n          }\n\n          &.main-comment {\n            background: $dark-grey;\n          }\n\n          .CommentPlugin_CommentsPanel_DeletedComment {\n            color: $dark-red;\n            text-decoration: dashed;\n            margin-bottom: 10px;\n          }\n        }\n\n        .CommentPlugin_CommentsPanel_List_DeleteButton {\n          opacity: 0.2;\n          position: relative;\n          background: none;\n          align-self: flex-start;\n          bottom: 15px;\n          margin: 0px 0px 0 auto;\n          filter: brightness(0) invert(80%);\n          border: none;\n          cursor: pointer;\n\n\n          &:hover {\n            opacity: 1;\n          }\n        }\n      }\n\n      .CommentPlugin_CommentsPanel_List_Thread_Editor {\n        display: flex;\n        flex-direction: row;\n        margin-bottom: -15px;\n\n        .CommentPlugin_CommentsPanel_SendButton{\n          position: relative;\n          background: none;\n          margin: auto;\n          filter: brightness(0) invert(80%);\n          transform: translate(187px, -43px);\n          border: none;\n          cursor: pointer;\n          z-index: 2000;\n        }\n      }\n\n    }\n  }\n}\n\n.CommentPlugin_CommentInputBox_EditorContainer {\n  background: $blue-grey;\n  border: 5px solid $very-dark-grey;\n  border-right: 2px solid $very-dark-grey;\n  border-top: none;\n  border-radius: 0 0 6px 6px;\n  position: relative;\n  bottom: 5px;\n  width: 219px;\n\n  .CommentPlugin_CommentsPanel_Editor {\n    background: $dark-grey;\n    border: 1px solid $light-grey;\n    border-radius: 6px;\n    line-height: 1.5em;\n    max-height: fit-content;\n    margin: 5px;\n    z-index: 500;\n  }\n\n  .ContentEditable__placeholder {\n    position: relative;\n    height: 0px;\n    left: 15px;\n    bottom: 35px;\n    z-index: 10;\n  }\n}\n\n.CommentPlugin_CommentsPanel_List_Details {\n  display: flex;\n  flex-direction: column;\n\n  .CommentPlugin_CommentsPanel_List_Comment_Author {\n    color: $very-light-grey;\n    font-weight: bold;\n  }\n}\n\n.lexical_comments_modal__overlay {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  //width: 250px;\n  height: 200px;\n  /* Above Bootstrap modals (~1055) so comment input is visible when editor is in a dialog */\n  z-index: 10600;\n\n  .Modal__modal{\n    border: 1px solid $dark-red;\n    border-bottom: 4px solid $dark-red;\n    background: $grey;\n    border-top-right-radius: 10px;\n    border-top-left-radius: 10px;\n\n    .Modal__title {\n      display: flex;\n      @include steel-bg(\"../medias/steel.png\");\n      height: 34px;\n      font-size: 13px;\n      font-weight: bold;\n      border-radius: 0px;\n      border-top-right-radius: 10px;\n      border-top-left-radius: 10px;\n      text-transform: uppercase;\n      color: $light-grey;\n      align-items: center; \n      padding: 0 10px;\n      border-bottom: 2px solid $grey;\n    }\n\n    .Modal__content {\n      display: table;\n      margin: auto;\n      color: $very-light-grey;\n      background: $grey;\n      padding: 7px;\n\n      .CommentPlugin_SideModal {\n        margin: auto;\n\n        .CommentPlugin_CommentInputBox_EditorContainer {\n          border: 1px solid $light-grey;\n          border-radius: 6px;\n          min-height: min-content;\n          max-height: max-content;\n        }\n\n        .CommentPlugin_CommentInputBox_Buttons {\n          text-align: center;\n          margin: 10px auto 5px auto;\n        }\n      }\n\n      .override-deletion {\n        background-color :$red;\n        color: $very-light-grey;\n        text-transform: uppercase;\n        font-weight: bold;\n      }\n    }\n  }\n}\n\n.PlaygroundEditorTheme__ltr mark {\n  color: $light-grey;\n  background-color: #6a480062 !important;\n\n  &.selected {\n    color: $very-light-grey;\n    background-color: #6a4900 !important;\n  }\n}\n\nmark.PlaygroundEditorTheme__ltr {\n  color: $light-grey;\n  background-color: #6a480062;\n\n  &.selected {\n    color: $very-light-grey;\n    background-color: #6a4900;\n  }\n}\n\nmark.PlaygroundEditorTheme__ltr {\n  background-color: #6a480062;\n}\n\nmark.PlaygroundEditorTheme__ltr.selected {\n  background-color: #6a4900;\n}\n\n\n\n// ---\n\n.CommentPlugin_CommentsPanel_header {\n  font-size: 14px;                 /*  header font size */\n  font-weight: bold;               /*  bold title */\n  margin-bottom: 8px;              /*  space below header */\n}\n\n\n\n.CommentPlugin_CommentList {\n  list-style: none;                /*  remove default bullets */\n  margin: 0;                       \n  padding: 0;                    \n}\n\n.CommentPlugin_CommentItem {\n  display: flex;                   /*  flex layout */\n  align-items: flex-start;         \n  margin-bottom: 12px;             /*  space between comments */\n}\n\n.CommentPlugin_CommentAvatar {\n  width: 32px;                     /*  avatar size */\n  height: 32px;                    \n  border-radius: 50%;              /*  circular avatar */\n  background-color: #eee;          /*  placeholder background */\n  margin-right: 8px;               /*  space to text */\n}\n\n.CommentPlugin_CommentContent {\n  flex: 1;                         /*  take remaining space */\n}\n\n.CommentPlugin_CommentAuthor {\n  font-size: 12px;                 /*  author name size */\n  font-weight: 600;                /*  slightly bold */\n  margin-bottom: 4px;              /*  space below name */\n}\n\n.CommentPlugin_CommentText {\n  font-size: 14px;                 /*  comment text size */\n  line-height: 1.4;                \n}\n\n/* icône creuse (outline) */\n.comment-icon-outline {\n  fill: none;\n  stroke: currentColor;\n}\n\n/* icône pleine en vert */\n.comment-icon-filled {\n  fill: #22c55e; /* ou toute autre couleur verte */\n  stroke: none;\n\n  &:hover {\n    fill: #00ff5e;\n  }\n}\n\n/* facultatif : si vous voulez changer la couleur de l’outline */\n.comments .comment-icon-outline {\n  stroke: currentColor; /* hérite de la couleur du parent */\n}\n\n\n// ------------------ //\n//     SAVE MODAL     //\n// ------------------ //\n\n.modal-content.lexical-save-modal {\n  //margin: auto;\n\n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: linear-gradient(to top, $dark-red, #5e2f2fd3, $dark-red );\n    padding: 5px 0px 5px 10px;\n    color: $very-light-grey;\n    font-size: medium;\n    font-weight: bold;\n    text-transform: uppercase;\n    border-bottom: 3px solid $light-grey;\n    border-radius: 8px 8px 0px 0px;\n\n    .lexical-save-modal-h3 {\n      margin: 0;\n      font-size: small;\n    }\n\n    .icon {\n        display: flex;\n        height: 18px;\n        overflow: hidden;\n        margin-left: auto;\n        margin-right: 0;\n\n        .close-event-button {\n          position: relative;\n          height: 40px;\n          margin-right: 10px;\n          object-fit: contain;\n          overflow: hidden;\n          cursor: pointer;\n\n        &:hover {\n            top: -21px;\n        }\n      }\n    }\n  }\n\n  .content {\n    padding: 15px;\n    width: auto;\n    background: $blue-grey;\n    align-content: center;          // vertical alignement\n\n    .lexical-save-mode-toggle {\n      display: flex;\n      justify-content: center;\n      gap: 10px;\n      position: relative;\n      margin: 5px;\n    }\n\n    .lexical-save-live-section {\n      position: relative;\n\n\n      .version-description {\n        width: 430px;\n        text-align: justify;\n        padding: 10px 0;\n      }\n\n      .lexical-save-modal-button {\n        position: relative;\n        display: flex;\n        margin: auto;\n      }\n    }\n\n    .lexical-save-review-section, \n    .lexical-save-live-section {\n      .lexical-save-description {\n        width: 430px;\n        text-align: justify;\n        padding: 10px 0;\n      }\n\n      .lexical-save-fieldset {\n        display: flex;\n        justify-content: center;\n        gap: 10px;\n      }\n    }\n  }\n}\n\n\n\n/* 1) Pour centrer au milieu de l’écran, vous pouvez faire : \n.lexical-save-dialog {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh; \n}\n  */\n\n/* 2) Si vous préférez centrer le .modal-content via position+transform : \n.lexical-save-modal {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n */\n\n\n.lexical-versioning-bar {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  justify-content: flex-start;\n  gap: 12px;\n  width: 100%;\n  margin: 5px 0;\n  padding: 10px;\n  box-sizing: border-box;\n  background: $dark-panel-blue;\n  border: 1px solid $dark-red;\n  border-radius: 8px;\n  color: $very-light-grey;\n  font-family: 'Lato', sans-serif;\n}\n\n.lexical-versioning-bar--loading {\n  align-items: center;\n  min-height: 36px;\n}\n\n.lexical-versioning-bar__loading-text {\n  font-size: 12px;\n  color: $light-grey;\n}\n\n.lexical-versioning-bar__main {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  flex: 1;\n  min-width: 0;\n  gap: 0;\n}\n\n.lexical-versioning-bar__toggle {\n  display: flex;\n  flex-direction: row;\n  flex-shrink: 0;\n  border-radius: 6px;\n  overflow: hidden;\n  border: 1px solid $medium-grey;\n}\n\n.lexical-versioning-bar__mode {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 10px;\n  margin: 0;\n  border: none;\n  background: $grey;\n  color: $very-light-grey;\n  cursor: pointer;\n  text-align: left;\n  min-width: 0;\n  transition: background 0.15s ease, border-color 0.15s ease;\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n\n  &:not(:disabled):hover {\n    background: $medium-grey;\n  }\n}\n\n.lexical-versioning-bar__mode--live {\n  border-right: 1px solid $medium-grey;\n}\n\n.lexical-versioning-bar__mode--live.lexical-versioning-bar__mode--active {\n  background: $dark-grey;\n  border-radius: 6px;\n  box-shadow: inset 0 0 0 1px $green;\n\n  .lexical-versioning-bar__mode-title {\n    color: $green;\n  }\n}\n\n.lexical-versioning-bar__mode--archive.lexical-versioning-bar__mode--active {\n  background: $dark-grey;\n  border-radius: 6px;\n  box-shadow: inset 0 0 0 1px $orange;\n\n  .lexical-versioning-bar__mode-title {\n    color: $orange;\n  }\n}\n\n.lexical-versioning-bar__mode-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 22px;\n  height: 22px;\n}\n\n.lexical-versioning-bar__svg-icon {\n  width: 18px;\n  height: 18px;\n  color: $light-grey;\n}\n\n.lexical-versioning-bar__svg-icon--collab {\n  color: $green;\n}\n\n.lexical-versioning-bar__mode--archive.lexical-versioning-bar__mode--active .lexical-versioning-bar__svg-icon {\n  color: $orange;\n}\n\n.lexical-versioning-bar__mode--live.lexical-versioning-bar__mode--active .lexical-versioning-bar__svg-icon {\n  color: $green;\n}\n\n.lexical-versioning-bar__switch {\n  display: block;\n  width: 30px;\n  height: 17px;\n  border-radius: 9px;\n  background: $medium-grey;\n  position: relative;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 2px;\n    left: 2px;\n    width: 13px;\n    height: 13px;\n    border-radius: 50%;\n    background: $light-grey;\n    transition: transform 0.15s ease, background 0.15s ease;\n  }\n}\n\n.lexical-versioning-bar__switch--on {\n  background: $dark-green;\n\n  &::after {\n    transform: translateX(13px);\n    background: $very-light-green;\n  }\n}\n\n.lexical-versioning-bar__mode-title {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  min-width: 0;\n  line-height: 1.2;\n}\n\n.lexical-versioning-bar__divider {\n  width: 1px;\n  align-self: stretch;\n  margin: 2px 10px;\n  background: $medium-grey;\n  flex-shrink: 0;\n}\n\n.lexical-versioning-bar__dropdown-wrap {\n  position: relative;\n  flex: 1 1 0%;\n  min-width: 120px;\n  max-width: 100%;\n}\n\n.lexical-versioning-bar__dropdown-trigger {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  padding: 4px 10px;\n  box-sizing: border-box;\n  border: 1px solid $medium-grey;\n  border-radius: 6px;\n  background: $grey;\n  color: $very-light-grey;\n  cursor: pointer;\n  text-align: left;\n  font-size: 12px;\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  &:not(:disabled):hover {\n    border-color: $medium-light-grey;\n    background: $medium-grey;\n  }\n}\n\n.lexical-versioning-bar__dropdown-calendar {\n  width: 17px;\n  height: 17px;\n  flex-shrink: 0;\n  color: $light-grey;\n}\n\n.lexical-versioning-bar__dropdown-label {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n}\n\n.lexical-versioning-bar__version-line {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex: 1;\n  min-width: 0;\n}\n\n.lexical-versioning-bar__version-line--compact {\n  .lexical-versioning-bar__version-sep {\n    margin-left: 15px;\n    margin-right: 15px;\n  }\n}\n\n.lexical-versioning-bar__version-date {\n  flex: 1 1 5%;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lexical-versioning-bar__version-semver {\n  flex: 0 0 auto;\n  white-space: nowrap;\n  padding: 0 2px;\n}\n\n.lexical-versioning-bar__version-author {\n  flex: 1 1 30%;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lexical-versioning-bar__version-sep {\n  flex: 0 0 auto;\n  width: 1px;\n  align-self: stretch;\n  min-height: 16px;\n  margin-left: 16px;\n  margin-right: 16px;\n  background: $medium-light-grey;\n  opacity: 0.85;\n}\n\n.lexical-versioning-bar__dropdown-chevron {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n  color: $light-grey;\n}\n\n.lexical-versioning-bar__dropdown-panel {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: calc(100% + 4px);\n  z-index: 100000;\n  max-height: 280px;\n  overflow-y: auto;\n  padding: 6px 0;\n  background: $dark-grey;\n  border: 1px solid $medium-grey;\n  border-radius: 6px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);\n  @include scrollbar-styles;\n}\n\n.lexical-versioning-bar__dropdown-option {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 12px 14px;\n  margin: 0;\n  border: none;\n  background: transparent;\n  color: $very-light-grey;\n  font-size: 13px;\n  text-align: left;\n  cursor: pointer;\n\n  &:hover {\n    background: $grey;\n  }\n}\n\n.lexical-versioning-bar__dropdown-option--selected {\n  color: $light-orange;\n\n  &:hover {\n    background: $grey;\n  }\n\n  .lexical-versioning-bar__version-sep {\n    background: currentColor;\n    opacity: 0.35;\n  }\n}\n\n.lexical-versioning-bar__option-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  background: $medium-light-grey;\n}\n\n.lexical-versioning-bar__option-dot--selected {\n  background: $light-orange;\n}\n\n.lexical-versioning-bar__option-label {\n  display: flex;\n  flex: 1;\n  min-width: 0;\n  align-items: center;\n  line-height: 1.35;\n}\n\n.lexical-versioning-bar__dropdown-more {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  width: stretch;\n  margin: 4px 8px 0;\n  padding: 10px 8px;\n  box-sizing: border-box;\n  border: none;\n  border-top: 1px solid $medium-grey;\n  background: transparent;\n  color: $light-grey;\n  font-size: 12px;\n  cursor: pointer;\n  text-align: left;\n\n  &:hover {\n    color: $very-light-orange;\n  }\n}\n\n.lexical-versioning-bar__dropdown-more-icon {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  color: inherit;\n}\n\n.lexical-emoji {\n  display: inline-block;\n  float: none;\n  padding: 1px;\n  vertical-align: bottom;\n\n  img {\n    height: 20px;\n    width: auto;\n    vertical-align: bottom;\n  }\n}\n\n/*  make inline wrapper float and give some margin */\n.lexical-inline-left {\n  float: left;\n  margin: 0 3em 0 0;\n}\n\n.lexical-inline-right {\n  float: right;\n  margin: 0 0 0 3em;\n}\n\n/*  ensure the wrapper takes only the width of the image */\n.lexical-inline-left,\n.lexical-inline-right {\n  display: inline-block;\n}\n\n/*  images should be responsive within their wrapper */\n.lexical-inline-left img,\n.lexical-inline-right img {\n  max-width: 100%;\n  height: auto;\n}\n\n/*  clear floats after paragraphs if needed */\n.editor-paragraph::after {\n  content: \"\";\n  display: block;\n  clear: both;\n}\n\n.lexical-image-left {\n  float: left;\n  margin: 0 1em 1em 0;\n}\n\n.lexical-image-right {\n  float: right;\n  margin: 0 0 1em 1em;\n}\n\n.lexical-image-center {\n  text-align: center;\n  margin: 1em 0;\n}\n\n.lexical-image-left img,\n.lexical-image-right img {\n  max-width: 100%;\n  height: auto;\n}\n\n.lexical-image-center img {\n  display: inline-block;\n  max-width: 100%;\n  height: auto;\n}\n\n.lexical-image-left a,\n.lexical-image-right a,\n.lexical-image-center a,\n.lexical-inline-left a,\n.lexical-inline-right a {\n  display: inline-block;\n  max-width: 100%;\n  text-decoration: none;\n  color: inherit;\n}\n","@import './../variables.scss';\n\n.chat-mention-input-wrapper {\n  position: relative;\n  width: 100%;\n  border: 1px solid $blue;\n  background: $grey;\n  border-radius: 6px;\n\n  .message-input {\n    background: $blue-grey;\n    width: 100%;\n    padding: 8px;\n    font-size: 14px;\n    box-sizing: border-box;\n\n    &:focus {\n      outline: none;\n      box-shadow: none;\n    }\n    \n    &:focus-visible {\n      border: none;\n    }\n  }\n\n  .mention-dropdown {\n    position: absolute;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    background: $blue-grey;\n    border: 1px solid $blue;\n    border-radius: 4px;\n    box-sizing: border-box;\n    min-width: 0;\n    max-height: 200px;\n    overflow-y: auto;\n    z-index: 9999;\n\n    .dropdown-item {\n      display: flex;\n      align-items: center;\n      padding: 4px 8px;\n      cursor: pointer;\n\n      &.selected {\n        background-color: $dark-blue;\n      }\n\n      .mention-avatar {\n        width: 20px;\n        height: 20px;\n        border-radius: 50%;\n        margin-right: 8px;\n      }\n\n      .mention-dropdown__profile-chip {\n        margin-right: 8px;\n        flex-shrink: 1;\n        min-width: 0;\n        max-width: 100%;\n\n        .user-discord-rank__avatar {\n          width: 20px;\n          height: 20px;\n        }\n\n        .user-discord-rank__rank-icon {\n          display: none;\n        }\n\n        .user-discord-rank__name {\n          font-size: 14px;\n        }\n      }\n\n      .mention-name {\n        font-size: 14px;\n      }\n\n      &.dropdown-item--game {\n        align-items: flex-start;\n\n        .chat-game-entity-suggest-thumb {\n          width: 36px;\n          height: 36px;\n          border-radius: 4px;\n          object-fit: cover;\n          margin-right: 8px;\n          flex-shrink: 0;\n\n          &--empty {\n            display: inline-block;\n            background: $panel-blue;\n          }\n        }\n\n        .mention-name {\n          display: flex;\n          flex-direction: column;\n          align-items: flex-start;\n          gap: 2px;\n          line-height: 1.2;\n        }\n\n        .chat-game-entity-suggest-label {\n          font-weight: 600;\n        }\n\n        .chat-game-entity-suggest-sub {\n          font-size: 11px;\n          color: #b5bac1;\n        }\n      }\n\n      &.dropdown-item--loot {\n        align-items: flex-start;\n\n        .mention-name {\n          display: flex;\n          flex-direction: column;\n          align-items: flex-start;\n          gap: 2px;\n          line-height: 1.25;\n          min-width: 0;\n        }\n\n        .benefits-loot-dd-label {\n          font-size: 13px;\n          color: rgba(255, 255, 255, 0.92);\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n          max-width: 100%;\n        }\n\n        .benefits-loot-dd-meta {\n          font-size: 11px;\n          color: rgba(255, 255, 255, 0.55);\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n          max-width: 100%;\n        }\n      }\n\n      &.dropdown-item--group {\n        gap: 8px;\n\n        .mention-dropdown__group-badge {\n          font-size: 10px;\n          font-weight: 700;\n          text-transform: uppercase;\n          letter-spacing: 0.04em;\n          color: #faa61a;\n          flex-shrink: 0;\n        }\n\n        .mention-dropdown__group-name {\n          font-size: 14px;\n          font-weight: 600;\n          color: #dcddde;\n        }\n      }\n    }\n  }\n}\n\n/* Pour ChatRoom */\n.chat-container {\n  margin: 10px 0 0 0;\n\n  .chat-unified-frame {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    border-radius: 10px;\n    border: 1px solid $dark-red;\n    border-bottom: 4px solid $dark-red;\n    box-shadow: 4px 5px 2px #4b050547;\n    overflow: hidden;\n  }\n\n  .chat-unified-header {\n    @include modal-header(\"../medias/steel.png\");\n    border-radius: 8px 8px 0 0;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    padding: 3px 10px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.25);\n\n    .room-name {\n      margin: 0;\n      font-size: small;\n      text-transform: uppercase;\n      color: $light-grey;\n    }\n\n    .chat-unified-online-toggle {\n      flex-shrink: 0;\n      margin: 0;\n      padding: 2px 10px;\n      font-size: small;\n      text-transform: uppercase;\n      color: $light-grey;\n      background: rgba(0, 0, 0, 0.25);\n      border: 1px solid rgba(255, 255, 255, 0.12);\n      border-radius: 4px;\n      cursor: pointer;\n      font-family: inherit;\n\n      &:hover {\n        background: rgba(0, 0, 0, 0.4);\n        border-color: rgba(255, 255, 255, 0.2);\n      }\n    }\n  }\n\n  .chat-unified-body {\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n    min-height: 380px;\n    max-height: 440px;\n    background: $dark-panel-blue;\n  }\n\n  .chat-unified-body--single {\n    max-height: none;\n\n    .chat-wrapper {\n      flex: 1;\n      width: 100%;\n    }\n  }\n\n  .chat-wrapper {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-width: 0;\n    min-height: 0;\n\n    &.chat-wrapper--with-thread-panel {\n      position: relative;\n    }\n\n    &.hidden {\n      display: none;\n    }\n\n    .messages-list {\n      flex: 1;\n      min-height: 0;\n      overflow-y: auto;\n      padding: 8px;\n      //background-color: $panel-blue;\n      @include scrollbar-styles;\n    }\n\n    .message-item {\n      padding: 8px 6px 8px 5px;\n\n      .message-header {\n        display: flex;\n        align-items: center;\n        margin-bottom: 4px;\n        gap: 10px;\n        min-width: 0;\n\n        .message-header__identity {\n          flex: 0 1 auto;\n          min-width: 0;\n\n          .user-discord-rank__name {\n            color: #afa991;\n            font-size: 14px;\n            font-weight: bold;\n          }\n        }\n\n        .message-meta {\n          display: flex;\n          flex-shrink: 0;\n          gap: 8px;\n          font-size: 12px;\n          color: $very-light-grey;\n\n          .timestamp {\n            color: $medium-light-grey;\n          }\n        }\n\n        .message-edit-button {\n          color: $light-grey;\n          font-size: 10px;\n          text-transform: uppercase;\n          background-color: $dark-blue;\n          padding: 2px 6px;\n          border: 1px solid $blue;\n          border-radius: 6px;\n          margin: 0px 10px 0px auto;\n          cursor: pointer;\n\n          &:hover {\n            border: 1px solid $accent-blue;\n            color: $very-light-grey;\n          }\n        }\n      }\n\n      .message-content {\n        padding-left: 32px;\n        font-size: 14px;\n        line-height: calc(1em + 8px);\n\n        .mention--group {\n          color: #faa61a;\n          font-weight: 600;\n        }\n\n        .chat-image {\n          display: block;\n          max-height: 15vh;\n          max-width: 900px;\n          object-fit: cover;\n          border: 1px solid $medium-grey;\n          border-radius: 4px;\n          margin: 0px auto 10px auto;\n          opacity: 0.8;\n        }\n\n        .message-edit-block {\n\n          .message-input {\n            max-height: 300px;\n            overflow-y: auto;\n            display: block;\n            overflow: hidden;\n\n            .image-row {\n              display: inline-flex;\n              flex-wrap: wrap;\n              width: -webkit-fill-available;\n              border-bottom: 2px solid $light-grey;\n              margin-bottom: 8px;\n\n              .image-wrapper {\n                padding: 2px 15px 2px 2px;\n                border: 1px solid $dark-red;\n                background: $blue-grey;\n                border-radius: 4px;\n                width: 88px;\n                height: 65px;\n                margin: 6px 4px;\n                text-align: center;\n                writing-mode: vertical-lr;\n                overflow: hidden;\n              }\n                \n              img.pending-image,\n              .pending-image {\n                width: 100%;\n                max-height: 60px;\n                object-position: center;\n                overflow-y: hidden;\n                object-fit: cover;\n                //border-radius: 4px;\n                cursor: default;\n              }\n            }\n          }\n\n          // English comment: limit image size inside editor\n          img {\n            max-width: 200px;\n            max-height: 150px;\n            object-fit: contain;\n            display: block;\n            margin: 0;\n          }\n\n          .message-edit-actions {\n            margin-top: 8px;\n\n            .message-edit-save, \n            .message-edit-cancel {\n              color: $light-grey;\n              font-size: 10px;\n              text-transform: uppercase;\n              background-color: $dark-blue;\n              padding: 2px 6px;\n              border: 1px solid $blue;\n              border-radius: 6px;\n              margin: 0px 10px 0px auto;\n              cursor: pointer;\n\n              &:hover {\n                border: 1px solid $accent-blue;\n                color: $very-light-grey;\n              }\n            }\n          }\n        }\n\n        .message-deleted {\n          font-style: italic;\n          color: $bright-red;\n        }\n\n      }\n\n      .message-content--thread-grid {\n        padding-left: 0;\n      }\n\n      .message-item-thread-grid {\n        display: grid;\n        grid-template-columns: 32px minmax(0, 1fr);\n        grid-template-rows: auto auto;\n        column-gap: 0;\n        row-gap: 6px;\n      }\n\n      .message-item-thread-grid__rail-stem-zone {\n        grid-column: 1;\n        grid-row: 1;\n        width: 32px;\n        min-width: 32px;\n        position: relative;\n        overflow: visible;\n        pointer-events: none;\n      }\n\n      .message-item-thread-grid__rail-stem-upper {\n        position: absolute;\n        left: 11px;\n        top: -5px;\n        bottom: -6px;\n        width: 0;\n        border-left: 2px solid rgba(255, 255, 255, 0.28);\n      }\n\n      .message-item-thread-grid__rail-elbow-zone {\n        grid-column: 1;\n        grid-row: 2;\n        width: 32px;\n        min-width: 32px;\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        align-self: stretch;\n        min-height: 0;\n        pointer-events: none;\n      }\n\n      .message-item-thread-grid__rail-lower-stem {\n        flex: 1 1 0;\n        min-height: 0;\n        width: 0;\n        margin-left: 12px;\n        border-left: 1px solid rgba(255, 255, 255, 0.28);\n      }\n\n      .message-item-thread-grid__rail-elbow {\n        flex: 0 0 auto;\n        align-self: flex-start;\n        margin-left: 11px;\n        transform: translateY(-7px);\n        box-sizing: border-box;\n        width: 21px;\n        height: 14px;\n        border-left: 2px solid rgba(255, 255, 255, 0.28);\n        border-bottom: 2px solid rgba(255, 255, 255, 0.28);\n        border-bottom-left-radius: 10px;\n      }\n\n      .message-item-thread-grid__rail-lower-balance {\n        flex: 1 1 0;\n        min-height: 0;\n      }\n\n      .message-thread-channel-row--thread-grid {\n        grid-column: 2;\n        grid-row: 2;\n        display: flex;\n        align-items: center;\n        gap: 2px;\n        width: max-content;\n        background: $dark-grey;\n        border: 1px solid $medium-grey;\n        padding: 2px 4px;\n        border-radius: 6px;\n\n        &:hover {\n          background: $light-panel-blue;\n          border: 1px solid $medium-grey;\n        }\n      }\n\n      .message-thread-channel-summary--thread-grid {\n        flex: 1;\n        min-width: 0;\n        margin-left: 0;\n        margin-top: 0;\n      }\n\n      .thread-strip-menu {\n        flex-shrink: 0;\n        position: relative;\n        background: transparent;\n        padding: 2px 4px;\n        border-radius: 6px;\n      }\n\n      .thread-strip-menu__trigger {\n        padding: 2px 4px;\n        line-height: 1;\n      }\n\n      .hover-menu--thread-strip {\n        top: calc(100% + 4px);\n        right: 0;\n        left: auto;\n      }\n\n      &:hover {\n        background: $blue-grey;\n        border-radius: 6px;\n      }\n    }\n\n    .message-item.editing {\n      background: $very-dark-grey;\n      border-radius: 6px;\n      border-left: 2px solid $orange;\n    }\n\n    .input-container {\n      display: flex;\n      padding: 8px;\n      //background-color: $panel-blue;\n\n      .message-input {\n        flex: 1;\n      }\n\n      button {\n        margin-left: 8px;\n        padding: 8px 12px;\n        font-size: 18px;\n      }\n    }\n  }\n\n  .chat-users-panel {\n    width: 220px;\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: column;\n    color: $very-light-grey;\n    border-left: 1px solid $grey;\n    font-size: 14px;\n    //background: $panel-blue;\n    min-height: 0;\n    overflow: hidden;\n\n    &.chat-users-panel--closed {\n      width: 0;\n      flex-shrink: 0;\n      padding: 0;\n      pointer-events: none;\n\n      .chat-users-list {\n        visibility: hidden;\n      }\n    }\n\n    .chat-users-list {\n      flex: 1;\n      min-height: 0;\n      overflow-y: auto;\n      padding: 10px;\n      list-style: none;\n      margin: 0;\n      @include scrollbar-styles;\n\n      .chat-user-item {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        width: -webkit-fill-available;\n        padding: 5px 8px;\n        border-radius: 6px;\n\n        .chat-user-item__identity {\n          flex: 1;\n          min-width: 0;\n\n          .user-discord-rank__name {\n            color: #afa991;\n            padding: 5px;\n            border: 1px solid transparent;\n          }\n        }\n      }\n    }\n  }\n\n}\n\n\n.chat-mention-input-wrapper {\n  .image-row {\n    display: inline-flex;\n    flex-wrap: wrap;\n    width: -webkit-fill-available;\n    border-bottom: 2px solid $light-grey;\n\n    .image-wrapper {\n      padding: 2px 15px 2px 2px;\n      border: 1px solid $dark-red;\n      background: $blue-grey;\n      border-radius: 4px;\n      width: 88px;\n      height: 65px;\n      margin: 4px;\n      text-align: center;\n      writing-mode: vertical-lr;\n      overflow: hidden;\n    }\n      \n    img.pending-image {\n      width: 100px;\n      max-height: 60px;\n      object-position: center;\n      object-position: center;\n      overflow-y: hidden;\n      object-fit: cover;\n      //border-radius: 4px;\n      cursor: default;\n    }\n  }\n}\n\n\n.remove-icon {\n  position: relative;\n  transform: translate(-18px, -5px);\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n\n  background-image: url(\"../medias/close.png\");\n  background-repeat: no-repeat;\n  background-size: 20px 40px;\n  background-position: 0 0;\n}\n\n.remove-icon:hover {\n  background-position: 0 -16px;\n}\n\n.message-input:empty:before {\n  content: attr(data-placeholder); \n  color: #999;\n  pointer-events: none;\n  display: block;\n}\n\n.chat-resume-marker {\n  .chat-resume-marker__label {\n    display: flex;\n    position: relative;\n    background: $red;\n    color: $very-light-grey;\n    text-transform: uppercase;\n    width: fit-content;\n    margin: 0px 0px 0px auto;\n    padding: 1px 8px;\n    border-radius: 6px 6px 0px 0px;\n    font-size: 10px;\n    font-weight: 600;\n  }\n\n  .chat-resume-marker__line {\n    width: 100%;\n    height: 1px;\n    background: $red;\n    margin-bottom: 10px;\n  }\n}\n\n.chat-image-modal-overlay {\n  position: fixed;\n  z-index: 9999;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.75);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.chat-image-modal-content {\n  border: 1px solid $light-grey;\n  max-width: 90%;\n  max-height: 90%;\n}\n\n.chat-image-modal-img {\n  max-width: 100%;\n  max-height: 80vh;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n\n// --------------------------------------------------\n// --------------------------------------------------\n// --------------------------------------------------\n// EMOJI PICKER FOR CHAT\n// --------------------------------------------------\n// Input container\n// --------------------------------------------------\n\n.chat-mention-input-wrapper {\n  position: relative;\n\n  .chat-voice-live-bar {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 8px 10px;\n    border-bottom: 1px solid $blue;\n    background: rgba(237, 66, 69, 0.12);\n  }\n\n  .chat-voice-live-bar__dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: #ed4245;\n    flex-shrink: 0;\n    animation: chat-voice-live-dot-pulse 1s ease-in-out infinite;\n  }\n\n  .chat-voice-live-bar__label {\n    flex-shrink: 0;\n    font-size: 12px;\n    font-weight: 600;\n    color: #ed4245;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n  }\n\n  .chat-voice-live-wave {\n    display: flex;\n    flex: 1;\n    align-items: flex-end;\n    justify-content: space-between;\n    gap: 2px;\n    min-width: 0;\n    height: 26px;\n    padding: 0 4px;\n  }\n\n  .chat-voice-live-wave__bar {\n    flex: 1;\n    max-width: 5px;\n    min-width: 2px;\n    border-radius: 2px;\n    background: #5865f2;\n    height: 35%;\n    transform-origin: center bottom;\n    animation: chat-voice-live-bar-swing 0.75s ease-in-out infinite alternate;\n  }\n\n  @for $i from 1 through 32 {\n    .chat-voice-live-wave__bar:nth-child(#{$i}) {\n      animation-delay: #{($i - 1) * 0.035}s;\n    }\n  }\n\n  .chat-voice-live-bar__time {\n    flex-shrink: 0;\n    font-size: 12px;\n    font-variant-numeric: tabular-nums;\n    color: #f2f3f5;\n    min-width: 38px;\n    text-align: right;\n  }\n\n  .message-input-container {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n\n    .message-input {\n      flex: 1;\n      min-width: 0;\n      width: auto;\n      padding-right: 4px;\n    }\n\n    .chat-voice-mic-btn {\n      flex-shrink: 0;\n      background: transparent;\n      border: none;\n      cursor: pointer;\n      font-size: 15px;\n      line-height: 1;\n      padding: 4px 6px;\n      opacity: 0.75;\n      border-radius: 4px;\n\n      &:hover:not(:disabled) {\n        opacity: 1;\n        background: rgba(255, 255, 255, 0.06);\n      }\n\n      &:disabled {\n        opacity: 0.35;\n        cursor: not-allowed;\n      }\n\n      &--recording {\n        opacity: 1;\n        animation: chat-voice-mic-pulse 1.2s ease-in-out infinite;\n      }\n    }\n\n    .emoji-toggle {\n      position: static;\n      right: auto;\n      flex-shrink: 0;\n      background: transparent;\n      border: none;\n      cursor: pointer;\n      font-size: 16px;\n      filter: grayscale(100%) brightness(1);\n      opacity: 0.6;\n      transition: opacity 0.15s ease;\n      padding: 4px 4px 4px 2px;\n\n      &:hover {\n        filter: none;\n        opacity: 1;\n      }\n    }\n  }\n\n  .chat-voice-draft-row {\n    padding: 6px 8px;\n    border-bottom: 1px solid $blue;\n    background: rgba(0, 0, 0, 0.12);\n  }\n\n  .chat-voice-draft-wrapper {\n    & + .chat-voice-draft-wrapper {\n      margin-top: 6px;\n    }\n  }\n\n  .chat-voice-attachment.chat-voice--pending {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 10px;\n    border-radius: 8px;\n    background: #2b2d31;\n    border: 1px solid #1e1f22;\n    max-width: 100%;\n    box-sizing: border-box;\n  }\n\n  .chat-voice-draft-remove {\n    flex-shrink: 0;\n    width: 22px;\n    height: 22px;\n    border: none;\n    border-radius: 50%;\n    background: #4e5058;\n    color: #f2f3f5;\n    cursor: pointer;\n    font-size: 14px;\n    line-height: 1;\n    padding: 0;\n\n    &:hover {\n      background: #5c5e66;\n    }\n  }\n\n  .chat-voice-draft-preview {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    flex: 1;\n    min-width: 0;\n  }\n\n  .chat-voice-draft-label {\n    font-size: 12px;\n    color: #b5bac1;\n    font-variant-numeric: tabular-nums;\n  }\n\n  .chat-voice-fallback-text {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0;\n  }\n}\n\n@keyframes chat-voice-mic-pulse {\n  0%,\n  100% {\n    filter: brightness(1);\n  }\n\n  50% {\n    filter: brightness(1.35) drop-shadow(0 0 4px rgba(237, 66, 69, 0.55));\n  }\n}\n\n@keyframes chat-voice-live-bar-swing {\n  from {\n    transform: scaleY(0.25);\n    opacity: 0.55;\n  }\n\n  to {\n    transform: scaleY(1);\n    opacity: 1;\n  }\n}\n\n@keyframes chat-voice-live-dot-pulse {\n  0%,\n  100% {\n    opacity: 1;\n    box-shadow: 0 0 0 0 rgba(237, 66, 69, 0.5);\n  }\n\n  50% {\n    opacity: 0.85;\n    box-shadow: 0 0 0 7px rgba(237, 66, 69, 0);\n  }\n}\n\n// --------------------------------------------------\n// Emoji picker popover\n// --------------------------------------------------\n\n.emoji-picker-popover {\n  position: absolute;\n  bottom: 100%;\n  right: 0;\n  margin-bottom: 6px;\n  z-index: 9999;\n}\n\n// --------------------------------------------------\n// Emoji picker (Discord-like, compact)\n// --------------------------------------------------\n\n.emoji-picker {\n  width: 280px; // smaller than before\n  height: 220px;\n  background: $blue-grey;\n  border-radius: 6px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border: 1px solid $dark-red;\n  border-bottom: 4px solid $dark-red;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.5);\n\n  // header (search)\n  .emoji-header {\n    padding: 6px;\n    @include modal-header(\"../medias/steel.png\");\n\n    .emoji-search {\n      width: -webkit-fill-available;\n      padding: 5px 6px;\n      background: $very-dark-grey;\n      border: none;\n      color: $very-light-grey;\n      border-radius: 4px;\n      font-size: 12px;\n\n      &::placeholder {\n        color: $light-grey;\n      }\n    }\n  }\n\n  // scroll zone\n  .emoji-scroll {\n    flex: 1;\n    overflow-y: auto;\n    padding: 6px;\n\n    // scrollbar (optional clean)\n    &::-webkit-scrollbar {\n      width: 6px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: #1a1b1e;\n      border-radius: 3px;\n    }\n  }\n\n  // category\n  .emoji-category {\n    margin-bottom: 5px;\n\n    .emoji-category-title {\n      font-size: 11px;\n      color: $light-grey;\n      margin: 4px 4px 6px;\n      text-transform: uppercase;\n      letter-spacing: 0.3px;\n    }\n\n    .emoji-grid {\n      display: grid;\n      grid-template-columns: repeat(6, 1fr);\n      gap: 1px;\n\n      .emoji-item {\n        font-size: 18px;\n        padding: 5px;\n        border-radius: 4px;\n        cursor: pointer;\n        background: transparent;\n        border: none;\n        transition: background 0.1s ease;\n\n        &:hover {\n          background: $dark-blue;\n        }\n      }\n    }\n  }\n}\n\n.message-item {\n  position: relative;\n}\n\n.message-hover-actions {\n  position: absolute;\n  background: $blue-grey;\n  top: -10px;\n  right: 10px;\n  display: flex;\n  gap: 6px;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  padding: 3px 6px;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.15s ease;\n  z-index: 10;\n  box-shadow: 0 4px 2px rgba(0, 0, 0, 0.1);\n\n  &:hover {\n    opacity: 1;\n    border: 1px solid $light-panel-blue;\n  }\n}\n\n.message-item:hover .message-hover-actions {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.message-thread-channel-summary {\n  display: block;\n  margin-top: 6px;\n  margin-left: 32px;\n  font-size: 12px;\n  font-family: inherit;\n  text-align: left;\n  color: #b5bac1;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  width: fit-content;\n  max-width: 100%;\n  box-sizing: border-box;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.65;\n  }\n}\n\n.chat-thread-slide-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 40;\n  border-radius: inherit;\n  overflow: hidden;\n  background: rgba(0, 0, 0, 0.4);\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.28s ease;\n\n  &.chat-thread-slide-overlay--visible {\n    opacity: 1;\n    pointer-events: auto;\n  }\n}\n\n.chat-thread-slide-panel {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  width: 100%;\n  max-width: 600px;\n  background-color: $panel-blue;\n  border-left: 1px solid $dark-red;\n  box-shadow: -10px 0 28px rgba(0, 0, 0, 0.35);\n  transform: translateX(100%);\n  transition: transform 0.32s cubic-bezier(0.4, 0, 0.2, 1);\n  z-index: 41;\n\n  &.chat-thread-slide-panel--open {\n    transform: translateX(0);\n  }\n\n  .messages-list {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow-y: auto;\n    padding: 8px;\n    background-color: $panel-blue;\n    @include scrollbar-styles;\n  }\n\n  .input-container {\n    display: flex;\n    padding: 8px;\n    background-color: $panel-blue;\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n\n    .message-input {\n      flex: 1;\n    }\n\n    button {\n      margin-left: 8px;\n      padding: 8px 12px;\n      font-size: 18px;\n    }\n  }\n}\n\n.chat-thread-slide-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  padding: 3px 10px;\n  @include modal-header(\"../medias/steel.png\");\n  border-bottom: 1px solid rgba(0, 0, 0, 0.25);\n}\n\n.chat-thread-slide-back {\n  flex-shrink: 0;\n  padding: 1px 10px;\n  font-size: 12px;\n  color: $light-grey;\n  background: rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 6px;\n  cursor: pointer;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.4);\n    border-color: rgba(255, 255, 255, 0.2);\n  }\n}\n\n.chat-thread-slide-title {\n  margin: 0;\n  flex: 1;\n  min-width: 0;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: $light-grey;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.chat-thread-slide-title-row {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.chat-thread-slide-title-input {\n  flex: 1;\n  min-width: 0;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: $light-grey;\n  background: rgba(0, 0, 0, 0.35);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 4px;\n  padding: 4px 8px;\n}\n\n.chat-thread-slide-title-edit {\n  flex-shrink: 0;\n  padding: 2px 8px;\n  font-size: 12px;\n  line-height: 1;\n  color: $light-grey;\n  background: rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 4px;\n  cursor: pointer;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.45);\n    border-color: rgba(255, 255, 255, 0.2);\n  }\n}\n\n.chat-thread-slide-title-save,\n.chat-thread-slide-title-cancel {\n  flex-shrink: 0;\n  padding: 3px 8px;\n  font-size: 11px;\n  font-weight: 600;\n  border-radius: 4px;\n  cursor: pointer;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.chat-thread-slide-title-save {\n  color: #fff;\n  background: rgba(40, 120, 60, 0.55);\n\n  &:hover:not(:disabled) {\n    background: rgba(40, 120, 60, 0.75);\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.chat-thread-slide-title-cancel {\n  color: $light-grey;\n  background: rgba(0, 0, 0, 0.25);\n\n  &:hover:not(:disabled) {\n    background: rgba(0, 0, 0, 0.45);\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.hover-btn {\n  background: transparent;\n  border: none;\n  font-size: medium;\n  color: white;\n  cursor: pointer;\n  padding: 4px 6px;\n  border-radius: 4px;\n  filter: grayscale(100%) brightness(0.8);\n  transition: all 0.15s ease;\n}\n\n.hover-btn:hover {\n  //background: $blue-grey;\n  filter: grayscale(100%) brightness(1);\n  scale: 1.2;\n}\n\n.reply-block {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: fit-content;\n  background: $dark-panel-blue;\n  border-left: 3px solid $accent-blue;\n  padding: 4px 8px;\n  margin-bottom: 6px;\n  border-radius: 4px;\n}\n\n.reply-text {\n  font-size: 12px;\n  color: #b5bac1;\n  margin-right: 20px;\n}\n\n.reply-close {\n  cursor: pointer;\n  color: #888;\n}\n\n.reply-close:hover {\n  color: white;\n}\n\n.reply-separator {\n  height: 6px;\n}\n\n.reply-mention {\n  font-weight: 600;\n}\n\n.message-reply {\n  display: block;\n  font-size: 12px;\n  color: #b5bac1;\n  margin-bottom: 4px;\n}\n\n.reply-author {\n  font-weight: 600;\n  color: #ffffff;\n  margin-right: 4px;\n}\n\n.reply-label {\n  margin-right: 4px;\n}\n\n.reply-render {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  line-height: 17px;\n  opacity: 0.7;\n}\n\n.message-content {\n  //display: flex;\n  flex-direction: column;\n\n  .sc-item-chip {\n    padding: 3px 6px 2px;\n    vertical-align: middle;\n    margin: 0 3px;\n  }\n}\n\n.chat-voice-message {\n  // block-level flex so caption/text never sits on the same line as the player\n  display: flex;\n  width: fit-content;\n  max-width: #{\"min(400px, 100%)\"};\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n  margin: 6px 0;\n  min-width: 240px;\n  padding: 6px 12px 6px 8px;\n  border-radius: 999px;\n  background: $blue;\n  border: 1px solid $accent-blue;\n  box-sizing: border-box;\n\n  &__audio {\n    display: none;\n  }\n\n  &__play {\n    flex-shrink: 0;\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    border: none;\n    background: #5865f2;\n    color: #fff;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    transition: background 0.15s ease, transform 0.1s ease;\n\n    &:hover {\n      background: #4752c4;\n    }\n\n    &:active {\n      transform: scale(0.96);\n    }\n  }\n\n  &__play-icon {\n    width: 0;\n    height: 0;\n    margin-left: 3px;\n    border-style: solid;\n    border-width: 7px 0 7px 11px;\n    border-color: transparent transparent transparent #fff;\n  }\n\n  &__pause-icon {\n    display: flex;\n    gap: 3px;\n    align-items: center;\n    justify-content: center;\n    width: 14px;\n    height: 14px;\n\n    &::before,\n    &::after {\n      content: \"\";\n      display: block;\n      width: 3px;\n      height: 12px;\n      border-radius: 1px;\n      background: #fff;\n    }\n  }\n\n  &__wave-wrap {\n    flex: 1;\n    min-width: 0;\n    height: 30px;\n    display: flex;\n    align-items: center;\n  }\n\n  &__svg {\n    width: 100%;\n    height: 100%;\n    display: block;\n    overflow: visible;\n\n    &--loading .chat-voice-message__peak {\n      animation: chat-voice-peak-pulse 0.9s ease-in-out infinite alternate;\n    }\n  }\n\n  &__peak--track {\n    fill: #5c5f6a;\n  }\n\n  &__peak--played {\n    fill: #b5bac1;\n  }\n\n  &__time {\n    flex-shrink: 0;\n    font-size: 12px;\n    font-weight: 500;\n    color: #dbdee1;\n    font-variant-numeric: tabular-nums;\n    min-width: 36px;\n    text-align: right;\n  }\n\n  &__rate {\n    flex-shrink: 0;\n    font-size: 11px;\n    font-weight: 600;\n    color: #dbdee1;\n    background: #2b2d31;\n    border: 1px solid #3f4147;\n    border-radius: 999px;\n    padding: 4px 8px;\n    cursor: pointer;\n    line-height: 1;\n\n    &:hover {\n      background: #383a40;\n    }\n  }\n}\n\n@keyframes chat-voice-peak-pulse {\n  from {\n    opacity: 0.45;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n.reply-preview {\n  font-style: italic;\n}\n\n.message-body {\n  display: block;\n\n  .sc-item-chip {\n    padding: 3px 6px 2px;\n    vertical-align: middle;\n    margin: 0 3px;\n  }\n}\n\n.chat-mention-input-wrapper .message-input .sc-item-chip.chat-sc-loot-chip {\n  vertical-align: middle;\n  margin: 0 3px;\n}\n\n.chat-game-entity {\n  cursor: help;\n  background-color: rgba(90, 120, 60, 0.45);\n  border-radius: 2px;\n  padding: 1px 3px;\n\n  &:hover {\n    background-color: rgba(110, 150, 75, 0.55);\n  }\n}\n\n.chat-game-tooltip {\n  position: fixed;\n  z-index: 20050;\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  max-width: 320px;\n  padding: 10px;\n  background: $blue-grey;\n  border: 1px solid $blue;\n  border-radius: 6px;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.45);\n  pointer-events: auto;\n}\n\n.chat-game-tooltip__img {\n  width: 88px;\n  height: 56px;\n  object-fit: cover;\n  border-radius: 4px;\n  flex-shrink: 0;\n  background: $panel-blue;\n\n  &--placeholder {\n    display: block;\n  }\n}\n\n.chat-game-tooltip__body {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.chat-game-tooltip__title {\n  font-size: 14px;\n  font-weight: 600;\n  color: $light-blue;\n}\n\n.chat-game-tooltip__line {\n  font-size: 12px;\n  color: $very-light-grey;\n}\n\n.scroll-lock {\n  overflow: hidden;\n}\n\n.message-reactions {\n  display: flex;\n  gap: 6px;\n  margin-top: 4px;\n\n  .reaction-item {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    background: $dark-blue;\n    padding: 2px 6px;\n    border-radius: 12px;\n    font-size: 18px;\n    color: $light-grey;\n    cursor: pointer;\n\n    .reaction-emoji {\n      font-size: 18px;\n    }\n\n    .reaction-count {\n      font-size: 12px;\n    }\n  }   \n}\n\n.hover-btn--top-emoji {\n  background: transparent;\n  font-size: 16px;\n  filter:none\n}\n\n.hover-btn--top-emoji:hover {\n  transform: scale(1.2);\n  filter:none\n}\n\n// --------------------------------------------------\n// Hover menu (Discord-like)\n// --------------------------------------------------\n\n.hover-menu-wrapper {\n  position: relative;\n}\n\n.hover-menu {\n  position: absolute;\n  top: 28px;\n  right: 0;\n  min-width: 180px;\n  background: $blue-grey;\n  border: 1px solid $dark-red;\n  border-radius: 6px;\n  padding: 4px 0;\n  z-index: 999;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.5);\n  display: flex;\n  flex-direction: column;\n}\n\n.hover-menu-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 10px;\n  font-size: 13px;\n  color: $very-light-grey;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: background 0.12s ease;\n\n  .label {\n    pointer-events: none;\n  }\n\n  .icon {\n    font-size: 14px;\n    opacity: 0.7;\n    pointer-events: none;\n  }\n\n  &:hover {\n    background: $dark-blue;\n\n    .icon {\n      opacity: 1;\n    }\n  }\n}\n\n// English comment: delete style\n.hover-menu-item--danger {\n  color: $very-light-grey;\n\n  .icon {\n    color: $very-light-grey;\n    font-size: 16px;\n    opacity: 0.9;\n  }\n\n  &:hover {\n    background: $dark-red;\n  }\n}\n\n.chat-youtube-card {\n  border-left: 4px solid $medium-red;\n  background: $very-dark-grey;\n  padding: 10px;\n  border-radius: 6px;\n  margin-top: 6px;\n  max-width: 480px;\n}\n\n.youtube-meta {\n  margin-bottom: 8px;\n}\n\n.youtube-platform {\n  font-size: 11px;\n  color: #b5bac1;\n  margin-bottom: 10px;\n}\n\n.youtube-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: $light-blue;\n  margin-bottom: 10px;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n}\n\n.youtube-channel {\n  font-size: 12px;\n  color: $very-light-grey;\n   margin-bottom: 20px;\n}\n\n.chat-youtube {\n  position: relative;\n  width: 100%;\n  padding-top: 56.25%; // 16:9\n  border-radius: 4px;\n  overflow: hidden;\n  background: $very-dark-grey;\n   margin-bottom: 8px;\n}\n\n.chat-youtube iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: none;\n   margin-bottom: 2px;\n}\n\n.chat-link-preview {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  gap: 10px;\n  margin-top: 8px;\n  max-width: 480px;\n  padding: 10px;\n  border-radius: 6px;\n  border-left: 4px solid $accent-blue;\n  background: $very-dark-grey;\n  text-decoration: none;\n  color: inherit;\n  overflow: hidden;\n\n  &:hover {\n    background: lighten($very-dark-grey, 4%);\n  }\n}\n\n.chat-link-preview--loading {\n  pointer-events: none;\n  min-height: 72px;\n}\n\n.chat-link-preview__skeleton {\n  width: 100%;\n  min-height: 72px;\n  border-radius: 4px;\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0.04) 0%,\n    rgba(255, 255, 255, 0.09) 50%,\n    rgba(255, 255, 255, 0.04) 100%\n  );\n  background-size: 200% 100%;\n  animation: chat-link-preview-shimmer 1.2s ease-in-out infinite;\n}\n\n@keyframes chat-link-preview-shimmer {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n.chat-link-preview--fallback {\n  border-left-color: $very-light-grey;\n}\n\n.chat-link-preview__open {\n  font-size: 13px;\n  color: $light-blue;\n  word-break: break-all;\n}\n\n.chat-link-preview__img-wrap {\n  flex: 0 0 120px;\n  width: 120px;\n  min-height: 68px;\n  border-radius: 4px;\n  overflow: hidden;\n  background: rgba(0, 0, 0, 0.35);\n}\n\n.chat-link-preview__img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.chat-link-preview__body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.chat-link-preview__site {\n  font-size: 11px;\n  color: $light-grey;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.chat-link-preview__title {\n  font-size: 14px;\n  font-weight: 600;\n  color: $light-blue;\n  line-height: 1.3;\n}\n\n.chat-link-preview__desc {\n  font-size: 12px;\n  color: $very-light-grey;\n  line-height: 1.35;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.chat-calendar-embed {\n  display: block;\n  max-width: 480px;\n  margin-top: 8px;\n  border-radius: 8px;\n  overflow: hidden;\n  background: $dark-panel-blue;\n  border: 1px solid $dark-blue;\n  text-decoration: none;\n  color: #dcddde;\n  text-align: left;\n\n  &:hover {\n    border-color: #1a1c1f;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);\n  }\n}\n\n.chat-calendar-embed--loading {\n  pointer-events: none;\n  min-height: 120px;\n}\n\n.chat-calendar-embed__skeleton {\n  width: 100%;\n  min-height: 120px;\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0.04) 0%,\n    rgba(255, 255, 255, 0.08) 50%,\n    rgba(255, 255, 255, 0.04) 100%\n  );\n  background-size: 200% 100%;\n  animation: chat-link-preview-shimmer 1.2s ease-in-out infinite;\n}\n\n.chat-calendar-embed--fallback {\n  padding: 10px 12px;\n  font-size: 13px;\n  color: $light-blue;\n}\n\n.chat-calendar-embed__banner-wrap {\n  width: 100%;\n  max-height: 140px;\n  overflow: hidden;\n  background: #202225;\n}\n\n.chat-calendar-embed__banner {\n  display: block;\n  width: 100%;\n  height: auto;\n  max-height: 140px;\n  object-fit: cover;\n}\n\n.chat-calendar-embed__inner {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n}\n\n.chat-calendar-embed__accent {\n  width: 4px;\n  flex-shrink: 0;\n  background: #5865f2;\n}\n\n.chat-calendar-embed__content {\n  flex: 1;\n  min-width: 0;\n  padding: 10px 12px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.chat-calendar-embed__provider {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: #b9bbbe;\n  letter-spacing: 0.04em;\n}\n\n.chat-calendar-embed__title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #ffffff;\n  line-height: 1.25;\n}\n\n.chat-calendar-embed__status {\n  display: inline-block;\n  align-self: flex-start;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n\n.chat-calendar-embed__status--scheduled {\n  background: rgba(87, 242, 135, 0.15);\n  color: #57f287;\n}\n\n.chat-calendar-embed__status--cancelled {\n  background: rgba(237, 66, 69, 0.2);\n  color: #ed4245;\n}\n\n.chat-calendar-embed__status--live {\n  background: rgba(250, 166, 26, 0.2);\n  color: #faa61a;\n}\n\n.chat-calendar-embed__status--concluded {\n  background: rgba(185, 187, 190, 0.18);\n  color: #949ba4;\n}\n\n.chat-calendar-embed__status--tentative {\n  background: rgba(184, 165, 0, 0.22);\n  color: #e6d14a;\n}\n\n.chat-calendar-embed__meta {\n  font-size: 12px;\n  color: #b9bbbe;\n}\n\n.chat-calendar-embed__location {\n  font-size: 12px;\n  color: #b9bbbe;\n}\n\n.chat-calendar-embed__attendees {\n  font-size: 12px;\n  color: #dcddde;\n}\n\n.chat-calendar-embed__limit {\n  font-size: 11px;\n  color: #72767d;\n}\n\n.chat-calendar-embed__allies {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 12px;\n  margin-top: 4px;\n}\n\n.chat-calendar-embed__ally {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: #dcddde;\n}\n\n.chat-calendar-embed__ally-logo {\n  width: 22px;\n  height: 22px;\n  border-radius: 4px;\n  object-fit: cover;\n  background: #202225;\n\n  &--empty {\n    display: inline-block;\n  }\n}\n\n.chat-calendar-embed__desc {\n  font-size: 12px;\n  color: #b9bbbe;\n  line-height: 1.4;\n  white-space: pre-line;\n  max-height: 7em;\n  overflow: hidden;\n}\n\n.chat-calendar-embed__cancel-reason {\n  font-size: 12px;\n  color: #ed4245;\n  font-style: italic;\n}","// Shared layout: avatar + Discord name + optional org rank icon (UserDiscordRankDisplay)\n// Rank chip colors: data-chip-bg / data-chip-fg + CSP-safe <style nonce> rules (rankChipCspStyles.js).\n\n.user-discord-rank {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  min-width: 0;\n  vertical-align: middle;\n\n  .user-discord-rank__avatar {\n    flex-shrink: 0;\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    object-fit: cover;\n\n    &.user-discord-rank__avatar--placeholder {\n      background: $medium-light-grey;\n      opacity: 0.35;\n      display: inline-block;\n    }\n  }\n\n  .user-discord-rank__name {\n    color: inherit;\n    min-width: 0;\n    white-space: nowrap;\n    text-decoration: none;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    cursor: default;\n  }\n\n  .user-discord-rank__rank-icon {\n    flex-shrink: 0;\n    width: auto;\n    height: 20px;\n    object-fit: contain;\n  }\n\n  &.user-discord-rank--compact {\n    gap: 6px;\n\n    .user-discord-rank__avatar {\n      width: 24px;\n      height: 24px;\n    }\n\n    .user-discord-rank__rank-icon {\n      width: 18px;\n      height: 18px;\n    }\n  }\n\n  &.user-discord-rank--no-avatar {\n    gap: 6px;\n  }\n\n  /* Whole identity (avatar + name + rank) as one chip; opens profile card */\n  &.user-discord-rank--profile-chip {\n    padding: 2px 8px 2px 4px;\n    margin: 0;\n    border: 1px solid transparent;\n    border-radius: 10px;\n    background: transparent;\n    cursor: pointer;\n    font: inherit;\n    color: inherit;\n    text-align: left;\n    box-sizing: border-box;\n    max-width: 100%;\n\n    .user-discord-rank__name {\n      cursor: pointer;\n    }\n\n    /* Default (no rank color in data) */\n    &:not([data-chip-bg]):hover,\n    &:not([data-chip-bg]).user-discord-rank--profile-chip-open {\n      color: $very-light-grey;\n      border-color: $grey;\n      background-color: $medium-grey;\n    }\n  }\n\n  /* Rank colors (data-*): border + ::after on hover/open; colors via rankChipCspStyles.js */\n  &.user-discord-rank--profile-chip[data-chip-bg] {\n    position: relative;\n    isolation: isolate;\n    transition: border-color 0.15s ease, color 0.15s ease;\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      inset: 0;\n      border-radius: inherit;\n      z-index: 0;\n      pointer-events: none;\n      opacity: 0;\n      transition: opacity 0.15s ease;\n    }\n\n    &:hover,\n    &.user-discord-rank--profile-chip-open {\n      &[data-chip-fg] {\n        color: $pure-white !important;\n      }\n    }\n\n    &:hover::after,\n    &.user-discord-rank--profile-chip-open::after {\n      opacity: 0.22;\n    }\n\n    > * {\n      position: relative;\n      z-index: 1;\n    }\n  }\n\n  &.user-discord-rank--profile-chip-avatar-only {\n    padding: 1px;\n    border-radius: 50%;\n\n    .user-discord-rank__avatar,\n    .user-discord-rank__avatar--placeholder {\n      display: block;\n    }\n  }\n}\n",".donor-heart-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.donor-heart-badge__wrap {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 12px;\n  height: 12px;\n  flex-shrink: 0;\n  cursor: default;\n  border: none;\n  padding: 0;\n  background: transparent;\n  font: inherit;\n  color: inherit;\n\n  &--clickable {\n    cursor: pointer;\n  }\n\n  &:hover,\n  &:focus-within {\n    .donor-heart-badge__tooltip {\n      opacity: 1;\n      visibility: visible;\n      transform: translateY(0);\n    }\n  }\n}\n\n.donor-heart-badge__wrap--premium::before {\n  content: \"\";\n  position: absolute;\n  inset: -4px;\n  border-radius: 50%;\n  background: radial-gradient(\n    circle,\n    rgba($bright-red, 0.55) 0%,\n    rgba($bright-red, 0.18) 45%,\n    rgba($bright-red, 0) 72%\n  );\n  animation: donor-heart-badge-aura 1s ease-in-out infinite;\n  pointer-events: none;\n}\n\n.donor-heart-badge__heart {\n  position: relative;\n  z-index: 1;\n  width: 12px;\n  height: 12px;\n  color: $bright-red;\n  transform-origin: center center;\n}\n\n.donor-heart-badge__heart--subscriber {\n  animation: donor-heart-badge-heartbeat 1s ease-in-out infinite;\n}\n\n.donor-heart-badge__label {\n  font-size: 11px;\n  font-weight: 500;\n  color: $medium-light-grey;\n}\n\n.donor-heart-badge__tooltip {\n  position: absolute;\n  left: 0;\n  top: calc(100% + 6px);\n  z-index: 4;\n  display: inline-flex;\n  align-items: baseline;\n  min-width: 52px;\n  padding: 6px 10px;\n  border-radius: 8px;\n  border: 1px solid $accent-blue;\n  background: $panel-blue;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  line-height: 1.2;\n  white-space: nowrap;\n  pointer-events: none;\n  color: rgba($very-light-grey, 0.95);\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-2px);\n  transition:\n    opacity 0.15s ease,\n    visibility 0.15s ease,\n    transform 0.15s ease;\n  box-shadow:\n    0 8px 22px rgba(0, 0, 0, 0.45),\n    0 0 0 1px rgba(0, 0, 0, 0.18);\n}\n\n@keyframes donor-heart-badge-heartbeat {\n  0%,\n  52%,\n  100% {\n    transform: scale(1);\n  }\n\n  12% {\n    transform: scale(1.28);\n  }\n\n  24% {\n    transform: scale(1);\n  }\n\n  36% {\n    transform: scale(1.14);\n  }\n}\n\n@keyframes donor-heart-badge-aura {\n  0%,\n  52%,\n  100% {\n    opacity: 0.45;\n    transform: scale(0.92);\n  }\n\n  12% {\n    opacity: 0.95;\n    transform: scale(1.18);\n  }\n\n  24% {\n    opacity: 0.5;\n    transform: scale(0.96);\n  }\n\n  36% {\n    opacity: 0.8;\n    transform: scale(1.08);\n  }\n}\n",".donor-gem-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n@for $i from 0 through 10 {\n  .donor-gem-badge--fade-#{$i} {\n    --donor-gem-opacity: #{$i * 0.1};\n  }\n}\n\n.donor-gem-badge__wrap {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 12px;\n  height: 12px;\n  flex-shrink: 0;\n  cursor: default;\n  border: none;\n  padding: 0;\n  background: transparent;\n  font: inherit;\n  color: inherit;\n  opacity: var(--donor-gem-opacity, 1);\n\n  &--clickable {\n    cursor: pointer;\n  }\n\n  &:hover,\n  &:focus-within {\n    .donor-gem-badge__tooltip {\n      opacity: 1;\n      visibility: visible;\n      transform: translateY(0);\n    }\n  }\n}\n\n.donor-gem-badge__wrap--one-time {\n  color: $accent-blue;\n}\n\n.donor-gem-badge__wrap--subscriber {\n  color: $light-purple;\n}\n\n.donor-gem-badge__wrap--premium {\n  color: $donor-gold;\n}\n\n.donor-gem-badge__wrap--premium::before {\n  content: \"\";\n  position: absolute;\n  inset: -4px;\n  border-radius: 50%;\n  background: radial-gradient(\n    circle,\n    rgba($donor-gold, 0.55) 0%,\n    rgba($donor-gold, 0.18) 45%,\n    rgba($donor-gold, 0) 72%\n  );\n  pointer-events: none;\n}\n\n.donor-gem-badge__wrap--inactive {\n  .donor-gem-badge__gem {\n    filter: none;\n  }\n}\n\n.donor-gem-badge__gem {\n  position: relative;\n  z-index: 1;\n  width: 12px;\n  height: 12px;\n  transform-origin: center center;\n}\n\n.donor-gem-badge__gem--one-time {\n  filter: drop-shadow(0 0 2px rgba($accent-blue, 0.45));\n}\n\n.donor-gem-badge__gem--subscriber {\n  filter: drop-shadow(0 0 2px rgba($light-purple, 0.45));\n}\n\n.donor-gem-badge__gem--premium {\n  filter: drop-shadow(0 0 3px rgba($donor-gold, 0.55));\n}\n\n.donor-gem-badge__gem--inactive {\n  filter: none;\n}\n\n.donor-gem-badge__label {\n  font-size: 11px;\n  font-weight: 500;\n  color: $medium-light-grey;\n}\n\n.donor-gem-badge__tooltip {\n  position: absolute;\n  left: 0;\n  top: calc(100% + 6px);\n  z-index: 4;\n  display: inline-flex;\n  align-items: baseline;\n  min-width: 52px;\n  padding: 6px 10px;\n  border-radius: 8px;\n  border: 1px solid $accent-blue;\n  background: $panel-blue;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  line-height: 1.2;\n  white-space: nowrap;\n  pointer-events: none;\n  color: rgba($very-light-grey, 0.95);\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-2px);\n  transition:\n    opacity 0.15s ease,\n    visibility 0.15s ease,\n    transform 0.15s ease;\n  box-shadow:\n    0 8px 22px rgba(0, 0, 0, 0.45),\n    0 0 0 1px rgba(0, 0, 0, 0.18);\n}\n\n.donor-gem-badge__wrap:hover .donor-gem-badge__gem--subscriber,\n.donor-gem-badge__wrap:focus-within .donor-gem-badge__gem--subscriber {\n  animation: donor-gem-badge-pulse 1.4s ease-in-out infinite;\n}\n\n.donor-gem-badge__wrap:hover .donor-gem-badge__gem--premium,\n.donor-gem-badge__wrap:focus-within .donor-gem-badge__gem--premium {\n  animation: donor-gem-badge-shimmer 1.6s ease-in-out infinite;\n}\n\n.donor-gem-badge__wrap--premium:hover::before,\n.donor-gem-badge__wrap--premium:focus-within::before {\n  opacity: 1;\n  animation: donor-gem-badge-aura 1.4s ease-in-out infinite;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .donor-gem-badge__gem,\n  .donor-gem-badge__wrap--premium::before {\n    animation: none !important;\n  }\n}\n\n@keyframes donor-gem-badge-pulse {\n  0%,\n  100% {\n    transform: scale(1);\n  }\n\n  50% {\n    transform: scale(1.12);\n  }\n}\n\n@keyframes donor-gem-badge-shimmer {\n  0%,\n  100% {\n    transform: scale(1) rotate(0deg);\n    filter: drop-shadow(0 0 3px rgba($donor-gold, 0.55));\n  }\n\n  50% {\n    transform: scale(1.1) rotate(6deg);\n    filter: drop-shadow(0 0 5px rgba($donor-gold-light, 0.85));\n  }\n}\n\n@keyframes donor-gem-badge-aura {\n  0%,\n  100% {\n    opacity: 0.45;\n    transform: scale(0.92);\n  }\n\n  50% {\n    opacity: 0.95;\n    transform: scale(1.16);\n  }\n}\n","@import '../variables.scss';\n\n.hangar-filters--horizontal .hangar-filters__search,\n.member-academy-header__search {\n  flex: 0 1 50%;\n  min-width: 12rem;\n  max-width: 50%;\n}\n\n.hub-toolbar-search.roster-toolbar-card--search {\n  width: 100%;\n  max-width: 100%;\n}\n",".member-profile-card-popover-shell {\n  pointer-events: auto;\n}\n\n// Glass surface + glass-card side rails for every member profile tooltip\n.member-profile-card-popover {\n  @extend %glass-card-surface;\n  width: 280px;\n  max-width: calc(100vw - 16px);\n  overflow: hidden;\n  background-color: $member-profile-card-glass-bg;\n  box-shadow:\n    3px 2px inset rgba(51, 102, 126, 0.229),\n    0 8px 24px rgba(0, 0, 0, 0.45);\n\n  // Same inner side borders as .glass-card\n  &::after {\n    content: \"\";\n    position: absolute;\n    top: 5px;\n    bottom: 5px;\n    left: 7px;\n    right: 7px;\n    border-left: 3px solid $grey;\n    border-right: 3px solid $grey;\n    border-radius: 5px;\n    pointer-events: none;\n    z-index: 1;\n  }\n\n  .member-profile-card {\n    position: relative;\n    z-index: 2;\n  }\n}\n\n// Media / overlay FX only — no legacy supporter nebula + starfield\n.member-profile-card-popover--theme-fx {\n  isolation: isolate;\n\n  .member-profile-card-popover__theme-media {\n    z-index: 1;\n  }\n}\n\n// Active supporter perk: same glass border + more transparent space nebula\n.member-profile-card-popover--donor {\n  isolation: isolate;\n  background-color: $member-profile-donor-space;\n\n  .member-profile-card-popover__theme-media {\n    z-index: 1;\n  }\n\n  // Nebula: chain of soft irregular lobes along a BL→TR diagonal,\n  // denser cores + faint side wisps (never a solid band or big blotch)\n  &::before {\n    content: \"\";\n    position: absolute;\n    inset: -10%;\n    z-index: 0;\n    pointer-events: none;\n    border-radius: inherit;\n    opacity: 1;\n    will-change: transform;\n    background-image:\n      // outer haze along the diagonal\n      radial-gradient(\n        ellipse 52% 22% at 24% 74%,\n        rgba($member-profile-donor-nebula, 0.45) 0%,\n        transparent 72%\n      ),\n      radial-gradient(\n        ellipse 48% 20% at 46% 52%,\n        rgba($accent-blue, 0.38) 0%,\n        transparent 74%\n      ),\n      radial-gradient(\n        ellipse 44% 18% at 68% 30%,\n        rgba($member-profile-donor-nebula, 0.42) 0%,\n        transparent 72%\n      ),\n      // mid density lobes\n      radial-gradient(\n        ellipse 28% 14% at 18% 80%,\n        rgba($light-blue, 0.32) 0%,\n        transparent 68%\n      ),\n      radial-gradient(\n        ellipse 26% 16% at 34% 62%,\n        rgba($light-blue, 0.4) 0%,\n        transparent 70%\n      ),\n      radial-gradient(\n        ellipse 30% 13% at 52% 44%,\n        rgba($member-profile-donor-glow, 0.28) 0%,\n        transparent 68%\n      ),\n      radial-gradient(\n        ellipse 24% 15% at 64% 36%,\n        rgba($accent-blue, 0.34) 0%,\n        transparent 70%\n      ),\n      radial-gradient(\n        ellipse 22% 12% at 78% 22%,\n        rgba($light-blue, 0.28) 0%,\n        transparent 68%\n      ),\n      // brighter cores\n      radial-gradient(\n        ellipse 9% 6% at 31% 66%,\n        rgba($member-profile-donor-glow, 0.48) 0%,\n        transparent 72%\n      ),\n      radial-gradient(\n        ellipse 7% 5% at 49% 47%,\n        rgba($pure-white, 0.18) 0%,\n        transparent 70%\n      ),\n      radial-gradient(\n        ellipse 8% 5% at 61% 33%,\n        rgba($member-profile-donor-glow, 0.38) 0%,\n        transparent 72%\n      ),\n      // side wisps\n      radial-gradient(\n        ellipse 16% 20% at 40% 48%,\n        rgba($accent-blue, 0.22) 0%,\n        transparent 75%\n      ),\n      radial-gradient(\n        ellipse 14% 18% at 58% 56%,\n        rgba($member-profile-donor-nebula, 0.26) 0%,\n        transparent 78%\n      ),\n      radial-gradient(\n        ellipse 18% 10% at 72% 40%,\n        rgba($light-blue, 0.2) 0%,\n        transparent 75%\n      ),\n      // starfield — concentrated on the BL→TR nebula band (+ slight scatter)\n      radial-gradient(1px 1px at 14% 82%, rgba($pure-white, 0.75), transparent),\n      radial-gradient(1px 1px at 18% 76%, rgba($pure-white, 0.45), transparent),\n      radial-gradient(1.5px 1.5px at 22% 70%, rgba($pure-white, 0.85), transparent),\n      radial-gradient(1px 1px at 26% 78%, rgba($pure-white, 0.4), transparent),\n      radial-gradient(1px 1px at 28% 64%, rgba($pure-white, 0.7), transparent),\n      radial-gradient(1px 1px at 32% 68%, rgba($pure-white, 0.5), transparent),\n      radial-gradient(1.5px 1.5px at 36% 58%, rgba($pure-white, 0.8), transparent),\n      radial-gradient(1px 1px at 38% 62%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1px 1px at 42% 52%, rgba($pure-white, 0.65), transparent),\n      radial-gradient(1px 1px at 44% 56%, rgba($pure-white, 0.45), transparent),\n      radial-gradient(1.5px 1.5px at 48% 46%, rgba($pure-white, 0.9), transparent),\n      radial-gradient(1px 1px at 50% 50%, rgba($pure-white, 0.4), transparent),\n      radial-gradient(1px 1px at 54% 40%, rgba($pure-white, 0.7), transparent),\n      radial-gradient(1px 1px at 56% 44%, rgba($pure-white, 0.5), transparent),\n      radial-gradient(1px 1px at 58% 36%, rgba($pure-white, 0.6), transparent),\n      radial-gradient(1.5px 1.5px at 62% 34%, rgba($pure-white, 0.85), transparent),\n      radial-gradient(1px 1px at 64% 38%, rgba($pure-white, 0.4), transparent),\n      radial-gradient(1px 1px at 68% 28%, rgba($pure-white, 0.75), transparent),\n      radial-gradient(1px 1px at 70% 32%, rgba($pure-white, 0.45), transparent),\n      radial-gradient(1px 1px at 74% 22%, rgba($pure-white, 0.65), transparent),\n      radial-gradient(1.5px 1.5px at 76% 26%, rgba($pure-white, 0.8), transparent),\n      radial-gradient(1px 1px at 80% 18%, rgba($pure-white, 0.55), transparent),\n      radial-gradient(1px 1px at 82% 24%, rgba($pure-white, 0.4), transparent),\n      radial-gradient(1px 1px at 86% 14%, rgba($pure-white, 0.7), transparent),\n      radial-gradient(1px 1px at 88% 20%, rgba($pure-white, 0.5), transparent),\n      radial-gradient(1px 1px at 20% 86%, rgba($pure-white, 0.55), transparent),\n      radial-gradient(1px 1px at 34% 72%, rgba($pure-white, 0.6), transparent),\n      radial-gradient(1px 1px at 46% 54%, rgba($pure-white, 0.45), transparent),\n      radial-gradient(1px 1px at 60% 42%, rgba($pure-white, 0.7), transparent),\n      radial-gradient(1px 1px at 72% 30%, rgba($pure-white, 0.5), transparent),\n      radial-gradient(1px 1px at 84% 16%, rgba($pure-white, 0.65), transparent),\n      radial-gradient(1px 1px at 24% 60%, rgba($pure-white, 0.4), transparent),\n      radial-gradient(1px 1px at 40% 48%, rgba($pure-white, 0.55), transparent),\n      radial-gradient(1px 1px at 52% 36%, rgba($pure-white, 0.75), transparent),\n      radial-gradient(1px 1px at 66% 24%, rgba($pure-white, 0.45), transparent),\n      radial-gradient(1px 1px at 78% 12%, rgba($pure-white, 0.6), transparent),\n      radial-gradient(1px 1px at 30% 54%, rgba($pure-white, 0.5), transparent),\n      radial-gradient(1px 1px at 58% 48%, rgba($pure-white, 0.35), transparent),\n      radial-gradient(1px 1px at 16% 68%, rgba($pure-white, 0.55), transparent),\n      radial-gradient(1px 1px at 90% 22%, rgba($pure-white, 0.5), transparent);\n  }\n\n  .member-profile-card-popover__shooting-star {\n    position: absolute;\n    top: var(--mp-star-top, 8%);\n    left: var(--mp-star-left, 10%);\n    z-index: 1;\n    width: 72px;\n    height: 1.5px;\n    border-radius: 1px;\n    pointer-events: none;\n    opacity: 0;\n    background: linear-gradient(\n      90deg,\n      transparent 0%,\n      rgba($member-profile-donor-glow, 0.55) 58%,\n      rgba($pure-white, 0.95) 100%\n    );\n    box-shadow: 0 0 6px rgba($pure-white, 0.35);\n    transform-origin: left center;\n    will-change: transform, opacity;\n\n    &.is-flying {\n      animation: member-profile-shooting-star var(--mp-star-duration, 0.65s) ease-out forwards;\n    }\n\n    &--t1 {\n      --mp-star-top: 6%;\n      --mp-star-left: 8%;\n      --mp-star-angle: 32deg;\n      --mp-star-dx: 150px;\n      --mp-star-dy: 95px;\n      --mp-star-duration: 0.62s;\n    }\n\n    &--t2 {\n      --mp-star-top: 14%;\n      --mp-star-left: 22%;\n      --mp-star-angle: 40deg;\n      --mp-star-dx: 130px;\n      --mp-star-dy: 110px;\n      --mp-star-duration: 0.7s;\n    }\n\n    &--t3 {\n      --mp-star-top: 4%;\n      --mp-star-left: 36%;\n      --mp-star-angle: 48deg;\n      --mp-star-dx: 110px;\n      --mp-star-dy: 125px;\n      --mp-star-duration: 0.58s;\n    }\n\n    &--t4 {\n      --mp-star-top: 22%;\n      --mp-star-left: 4%;\n      --mp-star-angle: 28deg;\n      --mp-star-dx: 160px;\n      --mp-star-dy: 85px;\n      --mp-star-duration: 0.75s;\n    }\n\n    &--t5 {\n      --mp-star-top: 10%;\n      --mp-star-left: 48%;\n      --mp-star-angle: 44deg;\n      --mp-star-dx: 100px;\n      --mp-star-dy: 100px;\n      --mp-star-duration: 0.6s;\n    }\n\n    &--t6 {\n      --mp-star-top: 28%;\n      --mp-star-left: 16%;\n      --mp-star-angle: 36deg;\n      --mp-star-dx: 140px;\n      --mp-star-dy: 105px;\n      --mp-star-duration: 0.68s;\n    }\n\n    &--t7 {\n      --mp-star-top: 2%;\n      --mp-star-left: 18%;\n      --mp-star-angle: 38deg;\n      --mp-star-dx: 145px;\n      --mp-star-dy: 115px;\n      --mp-star-duration: 0.72s;\n    }\n\n    &--t8 {\n      --mp-star-top: 18%;\n      --mp-star-left: 30%;\n      --mp-star-angle: 50deg;\n      --mp-star-dx: 95px;\n      --mp-star-dy: 130px;\n      --mp-star-duration: 0.55s;\n    }\n  }\n\n  @keyframes member-profile-shooting-star {\n    0% {\n      opacity: 0;\n      transform: translate(0, 0) rotate(var(--mp-star-angle, 38deg));\n    }\n\n    10% {\n      opacity: 1;\n    }\n\n    70% {\n      opacity: 0.85;\n    }\n\n    100% {\n      opacity: 0;\n      transform: translate(var(--mp-star-dx, 140px), var(--mp-star-dy, 100px))\n        rotate(var(--mp-star-angle, 38deg));\n    }\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    .member-profile-card-popover__shooting-star {\n      display: none;\n    }\n  }\n\n  .member-profile-card__handle {\n    color: rgba($light-grey, 0.78);\n  }\n}\n\n// Benefactor: morphing nebula (two layers, out-of-phase — continuous, no visible reset)\n.member-profile-card-popover--donor-premium {\n  &::before {\n    animation: member-profile-nebula-morph-a 28.8s ease-in-out infinite;\n  }\n\n  .member-profile-card-popover__nebula-morph {\n    position: absolute;\n    inset: -14%;\n    z-index: 0;\n    pointer-events: none;\n    border-radius: inherit;\n    will-change: transform, opacity;\n    background-image:\n      radial-gradient(\n        ellipse 40% 26% at 30% 62%,\n        rgba($light-blue, 0.34) 0%,\n        transparent 70%\n      ),\n      radial-gradient(\n        ellipse 36% 20% at 58% 38%,\n        rgba($member-profile-donor-glow, 0.28) 0%,\n        transparent 72%\n      ),\n      radial-gradient(\n        ellipse 32% 24% at 72% 48%,\n        rgba($accent-blue, 0.3) 0%,\n        transparent 68%\n      ),\n      radial-gradient(\n        ellipse 28% 16% at 44% 28%,\n        rgba($member-profile-donor-nebula, 0.32) 0%,\n        transparent 74%\n      ),\n      radial-gradient(\n        ellipse 22% 30% at 20% 48%,\n        rgba($accent-blue, 0.2) 0%,\n        transparent 75%\n      ),\n      radial-gradient(\n        ellipse 18% 14% at 82% 22%,\n        rgba($light-blue, 0.26) 0%,\n        transparent 70%\n      );\n    animation: member-profile-nebula-morph-b 36.9s ease-in-out infinite;\n  }\n}\n\n// Non-uniform scale / skew so the cloud silhouette reshapes (not a slide ping-pong)\n@keyframes member-profile-nebula-morph-a {\n  0%,\n  100% {\n    transform: translate3d(0, 0, 0) scale(1, 1) skew(0deg, 0deg);\n  }\n\n  18% {\n    transform: translate3d(1.44%, -2.64%, 0) scale(1.084, 0.916) skew(1.32deg, -0.48deg);\n  }\n\n  36% {\n    transform: translate3d(-2.88%, -0.72%, 0) scale(0.916, 1.108) skew(-1.08deg, 0.84deg);\n  }\n\n  54% {\n    transform: translate3d(-0.96%, 3.12%, 0) scale(1.06, 0.928) skew(0.6deg, 1.08deg);\n  }\n\n  72% {\n    transform: translate3d(2.64%, 1.32%, 0) scale(0.94, 1.084) skew(-1.2deg, -0.6deg);\n  }\n\n  88% {\n    transform: translate3d(0.72%, -1.68%, 0) scale(1.036, 0.964) skew(0.48deg, 0.36deg);\n  }\n}\n\n// Alternate lobes fade / reshape on a different period → composite never snaps back\n@keyframes member-profile-nebula-morph-b {\n  0%,\n  100% {\n    transform: translate3d(0, 0, 0) scale(1.012, 0.988) skew(0deg, 0deg);\n    opacity: 0.18;\n  }\n\n  22% {\n    transform: translate3d(-3.36%, 2.16%, 0) scale(0.88, 1.144) skew(-1.44deg, 0.72deg);\n    opacity: 0.62;\n  }\n\n  44% {\n    transform: translate3d(2.88%, 3.36%, 0) scale(1.144, 0.856) skew(1.08deg, -0.96deg);\n    opacity: 0.3;\n  }\n\n  66% {\n    transform: translate3d(1.44%, -3.12%, 0) scale(0.928, 1.12) skew(-0.6deg, 1.2deg);\n    opacity: 0.66;\n  }\n\n  84% {\n    transform: translate3d(-1.92%, -0.96%, 0) scale(1.072, 0.928) skew(0.84deg, -0.36deg);\n    opacity: 0.26;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .member-profile-card-popover--donor-premium::before,\n  .member-profile-card-popover--donor-premium .member-profile-card-popover__nebula-morph {\n    animation: none;\n  }\n\n  .member-profile-card-popover--donor-premium .member-profile-card-popover__nebula-morph {\n    opacity: 0.25;\n  }\n}\n\n.member-profile-card {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 12px 17px 14px;\n  color: $light-grey;\n  font-size: 13px;\n}\n\n.member-profile-card__hero {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.member-profile-card__avatar-stack {\n  position: relative;\n  width: 56px;\n  height: 56px;\n  flex-shrink: 0;\n}\n\n.member-profile-card__hero-avatar {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  object-fit: cover;\n  z-index: 1;\n\n  &.member-profile-card__hero-avatar--placeholder {\n    display: block;\n    background: $medium-light-grey;\n    opacity: 0.35;\n  }\n}\n\n.member-profile-card__avatar-ring {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  border: 2px solid $light-blue;\n  box-sizing: border-box;\n  z-index: 2;\n  pointer-events: none;\n}\n\n.member-profile-card__avatar-halo {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  z-index: 0;\n  pointer-events: none;\n}\n\n.member-profile-card__hero-text {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.member-profile-card__org-icon {\n  width: 40px;\n  height: 40px;\n  object-fit: contain;\n  flex-shrink: 0;\n  margin-left: auto;\n  align-self: center;\n}\n\n.member-profile-card__discord-name {\n  font-weight: 600;\n  font-size: 15px;\n  color: $pure-white;\n  line-height: 1.25;\n  word-break: break-word;\n}\n\n.member-profile-card__handle {\n  margin-top: 2px;\n  color: $medium-light-grey;\n  font-size: 12px;\n}\n\n.member-profile-card__donor {\n  margin-top: 6px;\n  gap: 6px;\n  padding: 3px 8px 3px 6px;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  // Soft tinted chip — icon stays the focal point\n  &:has(.donor-gem-badge__wrap--one-time) {\n    border-color: rgba($accent-blue, 0.35);\n    background: rgba($accent-blue, 0.12);\n    color: $accent-blue;\n\n    .donor-gem-badge__label {\n      color: $accent-blue;\n    }\n  }\n\n  &:has(.donor-gem-badge__wrap--subscriber) {\n    border-color: rgba($light-purple, 0.35);\n    background: rgba($light-purple, 0.12);\n    color: $light-purple;\n\n    .donor-gem-badge__label {\n      color: $light-purple;\n    }\n  }\n\n  &:has(.donor-gem-badge__wrap--premium) {\n    border-color: rgba($donor-gold, 0.4);\n    background: rgba($donor-gold, 0.12);\n    color: $donor-gold;\n\n    .donor-gem-badge__label {\n      color: $donor-gold-light;\n    }\n  }\n\n  &:has(.donor-gem-badge__wrap--inactive) {\n    border-color: rgba($medium-light-grey, 0.35);\n    background: rgba($medium-light-grey, 0.1);\n    color: $medium-light-grey;\n\n    .donor-gem-badge__label {\n      color: $medium-light-grey;\n    }\n  }\n\n  .donor-gem-badge__label {\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    line-height: 1.2;\n  }\n\n  .donor-gem-badge__wrap {\n    // Keep gem visually above the chip wash\n    z-index: 1;\n  }\n\n  .donor-gem-badge__tooltip {\n    top: auto;\n    bottom: calc(100% + 6px);\n    transform: translateY(2px);\n  }\n\n  .donor-gem-badge__wrap:hover,\n  .donor-gem-badge__wrap:focus-within {\n    .donor-gem-badge__tooltip {\n      transform: translateY(0);\n    }\n  }\n}\n\n.member-profile-card__status {\n  font-size: 12px;\n  color: $medium-light-grey;\n\n  &.member-profile-card__status--error {\n    color: $bright-red;\n  }\n}\n\n.member-profile-card__body {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.member-profile-card__line {\n  margin: 0;\n  word-break: break-word;\n  line-height: 1.35;\n  font-size: medium;\n\n  &.member-profile-card__line--accent {\n    color: $light-blue;\n  }\n}\n\n.member-profile-card__groups {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n\n.member-profile-card__rank {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  flex-wrap: nowrap;\n}\n\n.member-profile-card__rank-label {\n  min-width: 0;\n  flex: 1 1 auto;\n  line-height: 1.35;\n  font-size: medium;\n  font-weight: 500;\n\n  &.member-profile-card__rank-label--unranked {\n    font-weight: 400;\n    color: $medium-light-grey;\n  }\n}\n\n.member-profile-card__pay-grade-chip {\n  margin-left: auto;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 7px;\n  border-radius: 8px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  line-height: 1.2;\n  color: $light-blue;\n  border: 1px solid rgba($light-blue, 0.4);\n  background: rgba($accent-blue, 0.14);\n}\n\n.member-profile-card__rank-img {\n  width: auto;\n  height: 22px;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n.member-profile-card__super-admin {\n  align-self: flex-end;\n  display: inline-flex;\n  align-items: center;\n  margin-top: 8px;\n  padding: 2px 7px;\n  border-radius: 8px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  line-height: 1.2;\n  color: $very-light-grey;\n  border: 1px solid rgba($red, 0.45);\n  background: rgba($dark-red, 0.45);\n}\n","// /src/styles/tools/perkThemeOverlays.scss\n// Stackable FX: rain, glass drips, lightning, nebula, starfield underlay, shooting stars.\n// CSP-safe: preset classes only (no inline styles).\n\n// Inner frame halo (color via createDynamicCSS modifier — see perkThemeHalo.js)\n.perk-theme-frame-halo {\n  position: absolute;\n  inset: 0;\n  z-index: 12;\n  pointer-events: none;\n  border-radius: inherit;\n}\n\n.perk-theme-frame-halo--spiral {\n  z-index: 13;\n  overflow: hidden;\n}\n\n.perk-theme-frame-halo--frost {\n  z-index: 13;\n  overflow: hidden;\n}\n\n.perk-theme-frame-halo__canvas {\n  display: block;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n\n.perk-theme-underlay {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  overflow: hidden;\n  pointer-events: none;\n}\n\n.perk-theme-underlay__layer {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n}\n\n.perk-theme-underlay__layer--starfield {\n  z-index: 0;\n}\n\n.perk-theme-underlay__starfield-canvas {\n  display: block;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n\n.perk-theme-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 4;\n  overflow: hidden;\n  pointer-events: none;\n}\n\n// Roster banner: keep overlays above banner-overlay + starfield\n.roster-file-summary-hero__donor-space .perk-theme-overlay {\n  z-index: 4;\n}\n\n.member-profile-card-popover .perk-theme-overlay {\n  z-index: 1;\n}\n\n.perk-theme-overlay__layer {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n}\n\n// ---------------------------------------------------------------------------\n// Falling rain — fine, dense, soft grey (not chunky white dashes)\n// ---------------------------------------------------------------------------\n\n.perk-theme-overlay__rain-row {\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n\n  &--back {\n    opacity: 0.55;\n    z-index: 0;\n  }\n\n  &--front {\n    opacity: 0.85;\n    z-index: 1;\n  }\n}\n\n.perk-theme-overlay__rain-drop {\n  position: absolute;\n  bottom: 100%;\n  width: 6px;\n  height: 48px;\n  pointer-events: none;\n  animation-name: perk-theme-rain-drop;\n  animation-timing-function: linear;\n  animation-iteration-count: infinite;\n}\n\n.perk-theme-overlay__rain-stem {\n  display: block;\n  width: 1px;\n  height: 70%;\n  margin-left: 2px;\n  border-radius: 0;\n  // Slightly clearer than pure light-grey wash, still not chalk-white\n  background: linear-gradient(\n    to bottom,\n    rgba($pure-white, 0),\n    rgba($pure-white, 0.38)\n  );\n  box-shadow: none;\n  animation-name: perk-theme-rain-stem;\n  animation-timing-function: linear;\n  animation-iteration-count: infinite;\n}\n\n.perk-theme-overlay__rain-row--back .perk-theme-overlay__rain-stem {\n  width: 1px;\n  height: 55%;\n  background: linear-gradient(\n    to bottom,\n    rgba($pure-white, 0),\n    rgba($pure-white, 0.22)\n  );\n}\n\n@for $i from 0 through 109 {\n  $left: ($i * 5 + ($i * 3 % 7)) % 100;\n  $delay-ms: ($i * 23 + ($i * 11 % 17) * 5) % 1000;\n  $duration-ms: 480 + (($i * 13) % 260);\n  $start: 100 + (($i % 6) * 1);\n  $h: 34 + (($i % 6) * 5);\n\n  .perk-theme-overlay__rain-drop--front-#{$i} {\n    left: #{$left}#{'%'};\n    bottom: #{$start}#{'%'};\n    height: #{$h}px;\n    animation-delay: #{$delay-ms}ms;\n    animation-duration: #{$duration-ms}ms;\n\n    .perk-theme-overlay__rain-stem {\n      animation-delay: #{$delay-ms}ms;\n      animation-duration: #{$duration-ms}ms;\n    }\n  }\n}\n\n@for $i from 0 through 74 {\n  $left: (1 + $i * 7 + ($i % 5)) % 100;\n  $delay-ms: ($i * 27 + 40) % 1100;\n  $duration-ms: 560 + (($i * 17) % 300);\n  $start: 101 + (($i % 5) * 1);\n  $h: 26 + (($i % 5) * 4);\n\n  .perk-theme-overlay__rain-drop--back-#{$i} {\n    left: #{$left}#{'%'};\n    bottom: #{$start}#{'%'};\n    height: #{$h}px;\n    animation-delay: #{$delay-ms}ms;\n    animation-duration: #{$duration-ms}ms;\n\n    .perk-theme-overlay__rain-stem {\n      animation-delay: #{$delay-ms}ms;\n      animation-duration: #{$duration-ms}ms;\n    }\n  }\n}\n\n@keyframes perk-theme-rain-drop {\n  0% {\n    transform: translateY(0);\n  }\n  75% {\n    transform: translateY(110vh);\n  }\n  100% {\n    transform: translateY(110vh);\n  }\n}\n\n@keyframes perk-theme-rain-stem {\n  0%,\n  65% {\n    opacity: 1;\n  }\n  75%,\n  100% {\n    opacity: 0;\n  }\n}\n\n// ---------------------------------------------------------------------------\n// Glass drips — transparent canvas beads (see PerkThemeGlassDropsCanvas.jsx)\n// ---------------------------------------------------------------------------\n\n.perk-theme-overlay__layer--glass-webgl {\n  z-index: 2;\n}\n\n.perk-theme-overlay__layer--heat-webgl {\n  z-index: 2;\n}\n\n.perk-theme-overlay__layer--rain {\n  z-index: 3;\n}\n\n.perk-theme-overlay__layer--snow {\n  z-index: 4;\n  overflow: hidden;\n}\n\n.perk-theme-overlay__snow-canvas {\n  display: block;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n\n.perk-theme-overlay__glass-canvas {\n  display: block;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  background: transparent;\n  opacity: 0;\n\n  &.is-ready {\n    opacity: 1;\n  }\n}\n\n.perk-theme-overlay__heat-canvas {\n  display: block;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  background: transparent;\n  opacity: 0;\n\n  &.is-ready {\n    opacity: 1;\n  }\n}\n\n.perk-theme-overlay__heat-video-src {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n  pointer-events: none;\n}\n\n// ---------------------------------------------------------------------------\n// Lightning — canvas procedural bolt (midpoint displacement + sky flash)\n// ---------------------------------------------------------------------------\n\n.perk-theme-overlay__layer--lightning {\n  top: 0;\n  bottom: auto;\n  z-index: 3;\n  overflow: hidden;\n}\n\n@for $h from 5 through 20 {\n  $pct: $h * 5;\n  .perk-theme-overlay__layer--lightning-h#{$pct} {\n    height: #{$pct}#{'%'};\n  }\n}\n\n.perk-theme-overlay__lightning-canvas {\n  display: block;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n\n// ---------------------------------------------------------------------------\n// Nebula — CSS 3D cloud billboards (no sky fill; cosmic teal / cyan / ochre)\n// Inspired by https://www.clicktorelease.com/code/css3dclouds/\n// ---------------------------------------------------------------------------\n\n.perk-theme-overlay__layer--nebula {\n  z-index: 2;\n  overflow: hidden;\n  opacity: 0.72;\n}\n\n@for $q from 0 through 10 {\n  $pct: $q * 10;\n  .perk-theme-overlay__layer--nebula-q#{$pct} {\n    opacity: 0.38 + ($q * 0.055);\n  }\n}\n\n.perk-theme-overlay__nebula-stage {\n  position: absolute;\n  inset: -18%;\n  perspective: 620px;\n  perspective-origin: 50% 46%;\n  transform-style: preserve-3d;\n  transform: rotate(0deg);\n}\n\n// Inclination slider (0–100 → −40deg … +40deg), CSP-safe steps of 10\n@for $i from 0 through 10 {\n  $pct: $i * 10;\n  $angle: -40deg + ($i * 8deg);\n\n  .perk-theme-overlay__layer--nebula-i#{$pct} .perk-theme-overlay__nebula-stage {\n    transform: rotate($angle);\n  }\n}\n\n.perk-theme-overlay__nebula-world {\n  position: absolute;\n  left: 50%;\n  top: 48%;\n  width: 1px;\n  height: 1px;\n  transform-style: preserve-3d;\n  transform: translate(-50%, -50%) rotateX(-10deg) rotateY(0deg);\n  animation: none;\n}\n\n.perk-theme-overlay__nebula-puff {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 210px;\n  height: 150px;\n  margin: -75px 0 0 -105px;\n  border-radius: 50%;\n  transform-style: preserve-3d;\n  pointer-events: none;\n  // Soft volumetric “cloud” texture (no image asset / no blue plate)\n  background:\n    radial-gradient(ellipse 52% 44% at 42% 46%, rgba(210, 235, 240, 0.42) 0%, transparent 68%),\n    radial-gradient(ellipse 58% 50% at 58% 54%, rgba(70, 150, 155, 0.38) 0%, transparent 72%),\n    radial-gradient(ellipse 70% 60% at 50% 50%, rgba(28, 55, 58, 0.22) 0%, transparent 78%);\n  mix-blend-mode: screen;\n  filter: blur(0.35px);\n  opacity: 0.55;\n  animation: none;\n}\n\n.perk-theme-overlay__nebula-puff-tint--0 {\n  background:\n    radial-gradient(ellipse 48% 40% at 45% 42%, rgba(120, 230, 255, 0.5) 0%, transparent 62%),\n    radial-gradient(ellipse 62% 52% at 55% 58%, rgba(40, 130, 150, 0.36) 0%, transparent 74%),\n    radial-gradient(ellipse 78% 68% at 50% 50%, rgba(20, 45, 55, 0.18) 0%, transparent 80%);\n}\n\n.perk-theme-overlay__nebula-puff-tint--1 {\n  background:\n    radial-gradient(ellipse 50% 42% at 40% 48%, rgba(90, 190, 175, 0.42) 0%, transparent 66%),\n    radial-gradient(ellipse 64% 54% at 60% 52%, rgba(45, 110, 105, 0.34) 0%, transparent 74%),\n    radial-gradient(ellipse 80% 70% at 50% 50%, rgba(18, 40, 38, 0.16) 0%, transparent 82%);\n}\n\n.perk-theme-overlay__nebula-puff-tint--2 {\n  background:\n    radial-gradient(ellipse 46% 38% at 48% 44%, rgba(230, 210, 165, 0.36) 0%, transparent 60%),\n    radial-gradient(ellipse 60% 50% at 52% 56%, rgba(150, 125, 80, 0.3) 0%, transparent 72%),\n    radial-gradient(ellipse 76% 66% at 50% 50%, rgba(40, 38, 28, 0.14) 0%, transparent 80%);\n}\n\n.perk-theme-overlay__nebula-puff-tint--3 {\n  background:\n    radial-gradient(ellipse 44% 36% at 50% 40%, rgba(200, 245, 250, 0.38) 0%, transparent 58%),\n    radial-gradient(ellipse 58% 48% at 46% 55%, rgba(55, 140, 155, 0.32) 0%, transparent 70%),\n    radial-gradient(ellipse 74% 64% at 50% 50%, rgba(22, 48, 52, 0.15) 0%, transparent 80%);\n}\n\n.perk-theme-overlay__nebula-puff-tint--4 {\n  background:\n    radial-gradient(ellipse 52% 44% at 38% 50%, rgba(160, 200, 175, 0.34) 0%, transparent 64%),\n    radial-gradient(ellipse 66% 56% at 62% 48%, rgba(70, 95, 80, 0.28) 0%, transparent 74%),\n    radial-gradient(ellipse 82% 72% at 50% 50%, rgba(25, 40, 35, 0.14) 0%, transparent 82%);\n}\n\n.perk-theme-overlay__nebula-puff-tint--5 {\n  background:\n    radial-gradient(ellipse 48% 40% at 55% 46%, rgba(210, 185, 130, 0.32) 0%, transparent 62%),\n    radial-gradient(ellipse 62% 52% at 42% 56%, rgba(95, 150, 145, 0.3) 0%, transparent 72%),\n    radial-gradient(ellipse 78% 68% at 50% 50%, rgba(30, 42, 40, 0.14) 0%, transparent 80%);\n}\n\n// Deterministic 3D placements (spiral / vortex volume)\n@for $i from 0 through 41 {\n  $arm: $i % 3;\n  $ring: floor($i / 3);\n  $angle: $arm * 120deg + $ring * 28deg + ($i * 7deg);\n  $radius: 28px + ($ring * 18px) + (($i % 5) * 6px);\n  $z: -160px + (($i % 11) * 28px) + (($arm - 1) * 12px);\n  $scale: 0.52 + (($i % 7) * 0.09) + (($ring % 4) * 0.04);\n  $yaw: $angle;\n  $tilt: -6deg + (($i % 9) * 1.5deg);\n\n  .perk-theme-overlay__nebula-puff--#{$i} {\n    width: #{180px + (($i % 6) * 22px)};\n    height: #{120px + (($i % 5) * 16px)};\n    margin-left: #{-(90px + (($i % 6) * 11px))};\n    margin-top: #{-(60px + (($i % 5) * 8px))};\n    transform:\n      rotateY($yaw)\n      translateX($radius)\n      translateZ($z)\n      rotateY(-$yaw)\n      rotateX($tilt)\n      scale($scale);\n    opacity: 0.38 + (($i % 5) * 0.06);\n    animation-delay: #{-($i * 0.37)}s;\n  }\n}\n\n@keyframes perk-theme-nebula-breathe {\n  0%,\n  100% {\n    filter: blur(0.35px) brightness(0.96);\n  }\n\n  50% {\n    filter: blur(0.55px) brightness(1.08);\n  }\n}\n\n@keyframes perk-theme-nebula-breathe-aurora {\n  0%,\n  100% {\n    filter: blur(0.3px) brightness(0.9) saturate(0.95);\n  }\n\n  33% {\n    filter: blur(0.7px) brightness(1.18) saturate(1.15);\n  }\n\n  66% {\n    filter: blur(0.45px) brightness(1.05) saturate(1.05);\n  }\n}\n\n// Motion slider: 0 = still, 100 = strong aurora-like undulation (no full spin)\n@for $m from 1 through 10 {\n  $pct: $m * 10;\n  $amp-y: 3deg + ($m * 2.8deg);\n  $amp-x: 1.5deg + ($m * 1.5deg);\n  $amp-z: 0.4deg + ($m * 0.55deg);\n  $lift: 0.4% + ($m * 0.35%);\n  $dur: 56s - ($m * 3.6s);\n  $breathe-dur: 14s - ($m * 0.7s);\n\n  @keyframes perk-theme-nebula-aurora-#{$pct} {\n    0%,\n    100% {\n      transform:\n        translate(-50%, -50%)\n        rotateX(-9deg - $amp-x * 0.25)\n        rotateY(-$amp-y)\n        rotateZ(-$amp-z * 0.4);\n    }\n\n    20% {\n      transform:\n        translate(-50%, calc(-50% - #{$lift}))\n        rotateX(-10deg + $amp-x * 0.55)\n        rotateY($amp-y * 0.35)\n        rotateZ($amp-z * 0.6);\n    }\n\n    45% {\n      transform:\n        translate(-50%, -50%)\n        rotateX(-12deg - $amp-x * 0.35)\n        rotateY($amp-y)\n        rotateZ(-$amp-z * 0.3);\n    }\n\n    70% {\n      transform:\n        translate(-50%, calc(-50% + #{$lift * 0.7}))\n        rotateX(-8deg + $amp-x * 0.4)\n        rotateY(-$amp-y * 0.45)\n        rotateZ($amp-z);\n    }\n  }\n\n  .perk-theme-overlay__layer--nebula-m#{$pct} .perk-theme-overlay__nebula-world {\n    animation: perk-theme-nebula-aurora-#{$pct} $dur ease-in-out infinite;\n  }\n\n  @if $m >= 7 {\n    .perk-theme-overlay__layer--nebula-m#{$pct} .perk-theme-overlay__nebula-puff {\n      animation: perk-theme-nebula-breathe-aurora $breathe-dur ease-in-out infinite;\n    }\n  } @else {\n    .perk-theme-overlay__layer--nebula-m#{$pct} .perk-theme-overlay__nebula-puff {\n      animation: perk-theme-nebula-breathe $breathe-dur ease-in-out infinite;\n    }\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .perk-theme-overlay__rain-drop,\n  .perk-theme-overlay__rain-stem {\n    animation: none !important;\n    opacity: 0;\n  }\n\n  .perk-theme-overlay__lightning-canvas,\n  .perk-theme-overlay__glass-canvas,\n  .perk-theme-overlay__heat-canvas,\n  .perk-theme-overlay__snow-canvas,\n  .perk-theme-frame-halo--frost .perk-theme-frame-halo__canvas,\n  .perk-theme-frame-halo--spiral .perk-theme-frame-halo__canvas {\n    display: none;\n  }\n\n  .perk-theme-overlay__nebula-world,\n  .perk-theme-overlay__nebula-puff {\n    animation: none !important;\n  }\n}\n","/* /src/style/publicToc.scss */\n\n@import '../variables.scss';\n\n.public-toc-panel {\n  position: fixed;\n  transform: translateX(-560px);\n  place-self: center;\n  z-index: 30;\n  overflow: hidden;\n  margin-top: -18px;\n  align-self: flex-start;\n  margin-bottom: auto;\n}\n\n/* ENTRY ANIMATION */\n.public-toc-panel-inner {\n  width: 314px;\n  padding: 16px;\n  animation: public-toc-slide-in 0.3s ease-out forwards;\n}\n\n/* EXIT ANIMATION — MUST OVERRIDE ALL PREVIOUS ANIMATIONS */\n.public-toc-panel-inner.closing {\n  animation: public-toc-slide-out 0.3s ease-in forwards !important;\n}\n\n@keyframes public-toc-slide-in {\n  from {\n    transform: translateX(280px);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n@keyframes public-toc-slide-out {\n  from {\n    transform: translateX(0);\n  }\n  to {\n    transform: translateX(280px);\n  }\n}\n\n.public-container {\n  transition: transform 0.3s ease; // English comment: smooth slide\n}\n\n.public-container-shifted {\n  transform: translateX(160px); // English comment: shift right by 100px\n}\n\n.public-toc-header {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 0;\n  color: white;\n  font-family: 'Lato', sans-serif;\n  font-size: 1em;\n  font-weight: bolder;\n  text-transform: uppercase;\n  margin-bottom: 15px;\n  border-bottom: 2px solid $light-grey;\n}\n\n.public-toc-content {\n  max-height: calc(86vh - 190px);\n  overflow: auto;\n  @include scrollbar-glass;\n}\n\n.public-toc-list {\n  cursor: pointer;\n  margin: 4px 0;\n  padding: 15px;\n}\n\n.public-toc-list li {\n  cursor: pointer;\n  margin: 4px 0;\n}\n\n.public-toc-l3 {\n  margin-left: 10px;\n}\n\n.public-toc-l4 {\n  margin-left: 20px;\n}\n\n\n.public-toc-button-container {\n  display: flex;\n  position: relative;\n  width: 0px;\n  left: -5px;\n  top: 20px;\n  overflow: visible;\n  cursor: pointer;\n\n}\n\n.public-toc-button {\n  padding: 8px 14px;\n  cursor: pointer;\n}\n\n.public-toc-icon {\n  width: 22px;\n  height: 22px;\n  opacity: 0.8;\n  //transition: transform 0.25s ease, opacity 0.2s;\n}\n\n.public-toc-icon:hover {\n  opacity: 1;\n}\n\n/* rotation si ouvert, optionnel */\n.toc-open {\n  transform: rotate(180deg);\n}\n\n\n.public-toc-list {\n  list-style: none;\n\n  .toc-h1 {\n    color: white;\n    font-size: 20px;\n    font-weight: bolder;\n    text-transform: uppercase;\n    margin-bottom: 25px;\n    font-family: GoodTimes;\n  }\n\n  .toc-h2 {\n    font-size: 16px;\n    font-weight: bolder;\n    color: $very-light-grey;\n    text-transform: capitalize;\n    margin-top: -15px;\n    margin-bottom: 20px;\n    font-family: Lato;\n  }\n\n  .toc-h3 {\n    font-size: 16px;\n    font-weight: bolder;\n    color: $very-light-grey;\n    text-transform: uppercase;\n    margin-top: 15px;\n    margin-left: 0px;\n    font-family: Lato;\n    cursor: pointer;\n  }\n\n  .toc-h4 {\n    font-size: 14px;\n    font-weight: bold;\n    color: $light-grey;\n    text-transform: uppercase;\n    margin-top: 5px;\n    margin-left: 15px;\n    margin-bottom: 5px;\n    font-family: Lato;\n    cursor: pointer;\n  }\n\n  .toc-h5 {\n    font-size: 14px;\n    font-weight: 300;\n    color: $light-grey;\n    text-transform: capitalize;\n    margin-top: 5px;\n    margin-left: 30px;\n    margin-bottom: 5px;\n    font-family: Lato;\n    cursor: pointer;\n  }\n\n  .toc-h6 {\n    font-size: 14px;\n    font-weight: 100;\n    color: $light-grey;\n    text-transform: capitalize;\n    margin-top: 5px;\n    margin-left: 45px;\n    margin-bottom: 5px;\n    font-family: Lato;\n    cursor: pointer;\n  }\n}\n","@import './variables.scss';\n\n\n.inputs {\n    width: 100%;\n\n    &.permissions {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        width: min-content;\n        gap: 10px;\n        height: 170px;\n    }\n\n\n\n    &.create-event {\n        display: grid;\n        grid-template-columns: 1fr 1fr 1fr 1fr 1fr; \n        width: fit-content;\n        padding: 0 10px 5px 10px;\n        gap: 10px;\n        margin-top: 10px;\n\n        .inputs-column {\n            display: flex;\n            flex-direction: column;\n            width: 200px;\n            gap: 5px;\n\n            &.width {\n                width: 230px;\n            }\n\n            .input {\n                display: flex;\n                margin-bottom: 5px;\n                font-size: 14px ;\n                //width: 200px;          \n\n                &.lock {\n                    .input-wrapper {\n                        .react-select__control,\n                        .react-select-input__control,\n                        .react-select-menu__control {\n                          background-color: $light-grey;\n                        }\n\n                        .field-input {\n                          background-color: $light-grey;\n                          color: $very-light-grey;\n                          cursor: not-allowed;\n                          opacity: 1;\n                        }\n                    }\n                }\n\n                .input-wrapper {\n                    display: flex;\n                    align-items: center;\n                    flex-direction: row;\n                }\n\n                // Required field border (no status indicator dots)\n                .required-empty,\n                .required-filled {\n                    border: 1px solid transparent;\n                    border-radius: 4px;\n                }\n\n                .required-empty {\n                    border-color: $bright-red;\n                }\n\n                // Ensure children do not introduce layout shift\n                .required-empty .field-input,\n                .required-filled .field-input {\n                    border: 1px solid transparent;\n                }\n\n                .required-empty .react-select-input__control,\n                .required-filled .react-select-input__control {\n                    border: 1px solid transparent !important;\n                }\n\n                .required-empty .react-select-input__control {\n                    border-color: $bright-red !important;\n                }\n\n                .organization-share-label {\n                    position: relative;\n                    margin: 0 10px;\n                    color: $very-light-grey;\n                    font-size: 1em;\n                    font-weight: bolder;\n                    top: 3px;\n                }\n\n                &.ribbon-rewards {\n                    border: none;\n                }\n\n                .field-input {\n                    width: 160px;\n                    font-size: 12px;\n                    padding: 3px 5px 3px 5px;\n                    border: 1px solid transparent;\n                    border-radius: 4px;\n\n                    &.manual-value {\n                        padding: 3px 5px 3px 5px;\n                        font-size: 12px;\n                        width: 180px;\n                        color: $very-light-grey;\n                        text-transform: uppercase;\n                        background-color: $grey;\n                        border: 1px solid transparent;\n                        border-radius: 4px;\n                    }\n\n                    &.participant-limit {\n                        width: 100px;\n                    }\n\n                    &.organization-share {\n                        width: 36px;\n                    }\n\n                  \n                }\n\n                .field-value {\n                    padding: 3px 5px 3px 5px;\n                    font-size: 12px;\n                    width: 165px;\n                    color: $very-light-grey;\n                    text-transform: uppercase;\n                    border: 1px solid $very-light-grey;\n                    border-radius: 4px;\n                }\n\n                &.allied {\n                    color: $very-dark-grey;\n                    background-color: $very-light-grey;\n                    border: 1px solid $very-dark-grey;\n                    border-radius: 4px;\n                    font-size: 14px;\n                    height: 150px;\n                    width: 175px;\n                    overflow-y: auto; \n                    @include scrollbar-styles;\n\n                    &.disabled {\n                        opacity: 0.5;\n                    }\n    \n                    .allied-list {\n                        padding: 5px;\n                        @include scrollbar-styles;\n                    }\n                }\n\n            }\n\n\n            &.allied {\n                color: $very-dark-grey;\n                background-color: $very-light-grey;\n                border: 1px solid $very-dark-grey;\n                border-radius: 4px;\n                margin-left: 5px;\n                font-size: 14px;\n                height: 170px;\n                overflow-y: auto; \n                @include scrollbar-styles;\n\n                .allied-list {\n                    padding: 5px;\n                    @include scrollbar-styles;\n                }\n            }\n\n            &.rewards {\n                width: 300px;\n                height: min-content;\n            }\n        }\n    }\n\n    .input-field {\n        .input.ribbons {\n            border-radius: 4px;\n\n            &.ribbonName {\n                width: 100%;\n            }\n            &.description {\n                width: 100%;\n                height: 100px;\n                resize: none;\n            }\n        }\n    }\n\n}\n\n/* Create event: max attendees number + cap toggle on one row */\n.inputs.create-event .inputs-column.create-event-location-short,\n.inputs.create-event .inputs-column .create-event-location-short,\n.inputs.create-event .create-event-meeting-point.create-event-location-short {\n    .input-wrapper {\n        width: 100%;\n    }\n\n    .react-select-input__control {\n        min-height: 28px;\n        width: 190px;\n    }\n\n    .react-select-input__value-container {\n        padding: 0 6px;\n        font-size: 12px;\n    }\n\n    .react-select-input__placeholder,\n    .react-select-input__single-value,\n    .react-select-input__input-container {\n        font-size: 12px;\n    }\n\n    .react-select-input__indicators {\n        height: 28px;\n    }\n\n    .create-event-location-short__label {\n        padding-left: 5px;\n    }\n\n    .create-event-location-short__error {\n        color: $bright-red;\n        font-size: 11px;\n        line-height: 1.2;\n    }\n\n    .create-event-location-short__solar {\n        color: $very-light-grey;\n        font-size: 11px;\n        line-height: 1.25;\n    }\n}\n\n.inputs.create-event .inputs-column .input.max-attendees-row {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    flex-wrap: nowrap;\n\n    .max-attendees-row__field {\n        flex: 1 1 auto;\n        min-width: 0;\n    }\n\n    .max-attendees-row__toggle.toggle.max-attendees-cap {\n        flex: 0 0 auto;\n        width: auto;\n        margin-bottom: 0;\n        margin-top: 0;\n        justify-content: flex-end;\n    }\n}\n\n/* Create event: Discord vs Mumble (segmented control, Lexical-style) */\n.inputs.create-event .inputs-column .input.create-event-voice-row {\n    width: 100%;\n    margin-bottom: 30px;\n}\n\n.inputs.create-event .inputs-column .create-event-voice-toggle {\n    display: flex;\n    flex-direction: row;\n    flex-shrink: 0;\n    width: 172px;\n    border-radius: 8px;\n    overflow: hidden;\n    border: 1px solid $medium-grey;\n}\n\n.inputs.create-event .inputs-column .create-event-voice-toggle__mode {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n    flex: 1 1 50%;\n    padding: 6px 8px;\n    margin: 0;\n    border: none;\n    //border-radius: 8px;\n    background: $grey;\n    color: $very-light-grey;\n    cursor: pointer;\n    text-align: center;\n    min-width: 0;\n    transition: background 0.15s ease, box-shadow 0.15s ease, color 0.15s ease;\n\n    &:disabled {\n        opacity: 0.45;\n        cursor: not-allowed;\n    }\n\n    &:not(:disabled):hover {\n        background: $medium-grey;\n    }\n\n    &:not(.create-event-voice-toggle__mode--active):not(:disabled) {\n        .create-event-voice-toggle__brand-img {\n            opacity: 0.55;\n        }\n\n        .create-event-voice-toggle__label {\n            opacity: 0.8;\n        }\n    }\n}\n\n.inputs.create-event .inputs-column .create-event-voice-toggle__mode--discord {\n    border-right: 1px solid $medium-grey;\n}\n\n.inputs.create-event .inputs-column .create-event-voice-toggle__mode--discord.create-event-voice-toggle__mode--active {\n    background: $dark-grey;\n    box-shadow: inset 0 0 0 1px #5865f2;\n    border-radius: 8px 0px 0px 8px;\n\n    .create-event-voice-toggle__label {\n        color: #949cf8;\n    }\n\n    .create-event-voice-toggle__brand-img {\n        opacity: 1;\n    }\n}\n\n.inputs.create-event .inputs-column .create-event-voice-toggle__mode--mumble.create-event-voice-toggle__mode--active {\n    background: $dark-grey;\n    box-shadow: inset 0 0 0 1px $green;\n    border-radius: 0px 8px 0px 0px;\n\n    .create-event-voice-toggle__label {\n        color: $green;\n    }\n\n    .create-event-voice-toggle__brand-img {\n        opacity: 1;\n    }\n}\n\n.inputs.create-event .inputs-column .create-event-voice-toggle__icon-wrap {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: 22px;\n    height: 22px;\n}\n\n.inputs.create-event .inputs-column .create-event-voice-toggle__brand-img {\n    display: block;\n    width: 18px;\n    height: 18px;\n    object-fit: contain;\n}\n\n.inputs.create-event .inputs-column .create-event-voice-toggle__brand-img--mumble {\n    filter: brightness(1.15);\n}\n\n.inputs.create-event .inputs-column .create-event-voice-toggle__label {\n    font-size: 0.72rem;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    white-space: nowrap;\n}\n\n.input-comms {\n    width: 50px;\n}\n\n.field-input {\n    display: flex;\n    padding: 3px 5px 3px 5px;\n    border-radius: 4px;\n}\n\n//----------------//\n//\n//----------------//\n\n.time-limit {\n    display: flex;\n    flex-direction: row;   \n    margin-left: 18px;\n}\n\n.input-row {\n    display: flex;\n    flex-direction: row;\n    justify-content: left;\n    margin-right: 18px;\n    margin-left: 18px;\n    align-items: center;\n\n    &.themes {\n        gap: 15px;\n        margin-left: 2px;\n        margin-right: 5px;\n    }\n\n    &.training-levels {\n        gap: 15px;\n        margin-left: 2px;\n        margin-right: 5px;\n    }\n\n    &.create-questions {\n        gap: 15px;\n        margin-left: 0px;\n        margin-right: 0px;\n    }\n    \n    &.time-inputs {\n        //gap: 20px;\n        &.label {\n            margin-right: 2px;\n        }\n    }\n\n    .input.time-input {\n        width: 40px;\n        margin-right: 2px;\n    }\n\n    .input.question-input {\n        width: 100%;\n        height: auto;\n        min-height: 100px; /* Minimum height pour éviter d'être trop petit */\n        padding: 10px;\n        border-radius: 5px;\n        border: 1px solid #ccc;\n        font-size: 16px; /* Taille de texte lisible */\n        line-height: 1.5; /* Espacement pour le confort */\n        resize: vertical; /* Permet le redimensionnement vertical */\n        overflow-wrap: break-word; /* Assure le découpage des mots longs */\n        white-space: pre-wrap; /* Respecte les retours à la ligne */\n        box-sizing: border-box; /* Assure que padding/border n'affectent pas la taille */\n    }\n      \n    &.event-type-subtypes {\n        //gap: 10px;\n        align-items: normal;\n        margin-right: 10px;\n        margin-left: 0px;\n    }\n}\n\n.inputs-column {\n    display: flex;\n    flex-direction: column;\n    //gap: 10px;\n\n    .inputs-row {\n        display: flex;\n        flex-direction: row;\n        gap: 15px;\n    }\n\n    &.permissions {\n        margin-right: 0px;\n        margin-left: auto;\n        justify-content: center;\n    }\n\n    .input {\n        display: flex;\n        margin-bottom: 5px;\n        font-size: 12px;\n        padding: 3px 5px 3px 5px;\n        border-radius: 5px;\n\n        &.permissions {\n            width: 300px;\n        }\n\n        &.event-type, &.event-subtype {\n            height: 20px;\n        }\n    }\n\n    &.themes {\n        width: 275px;\n\n        .inputs-row {\n            width: 244px;\n            margin-left: 10px;\n        }\n    }\n    &.subtypes {\n        margin-right: 10px;\n        width: 450px;\n    }\n    &.trainings {\n        margin-right: 10px;\n    }\n    &.trainings-selection {\n        width: 100%;\n        margin-top: 35px;\n    }\n\n    &.lower-part {\n        margin: auto 0px 10px 0px;\n    }\n}\n\n.permissions,\n.roles,\n.groups {\n    .field-input {\n        display: flex;\n        width: 300px;\n        margin-top:5px ;\n        padding: 3px 5px 3px 5px;\n        border-radius: 4px;\n\n        .description {\n            width: 300px;\n            height: 32px;\n            border-radius: 4px;\n        }\n\n        &.short {\n            width: 55px;\n        }\n    }\n\n}\n\n.management-container.objectives-bloc {\n    background-color: $dark-panel-blue;\n    border: 1px solid rgba(255, 255, 255, 0.18);\n    border-radius: 10px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 0;\n    width: 100%;\n    max-width: 100%;\n    box-sizing: border-box;\n\n    // --- Create Event objectives (duplicated from .admin-block-container.create-event-template.objectives-only + nested .inputs-container objective rules; customize here independently of template editor) ---\n\n    .create-event-objectives-layout {\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n        max-width: 100%;\n        margin: 10px 0;\n        margin-left: 0;\n        margin-right: 0;\n        box-sizing: border-box;\n\n        .create-event-objectives-editor-row {\n            display: flex;\n            gap: 10px;\n            padding: 0 10px 10px;\n            align-items: stretch;\n\n            .create-event-objectives-list-panel {\n                display: flex;\n                justify-content: flex-start;\n                align-items: flex-start;\n                padding: 10px 0 0;\n                gap: 10px;\n                flex: 0 0 260px;\n                padding-top: 10px;\n\n                .create-event-objectives-middle-column {\n                    flex: 1 1 auto;\n                    min-width: 240px;\n                    max-width: 260px;\n                    padding: 0;\n                    display: flex;\n                    flex-direction: column;\n                    gap: 10px;\n\n                    .create-event-objectives-field {\n                        margin-bottom: 0;\n                        padding: 5px 10px;\n                        padding-right: 26px;\n                        //width: 92%;\n                        border: 1px solid $light-grey;\n                        border-radius: 8px;\n                    }\n\n                    .create-event-objectives-toggle {\n                        padding-right: 25px;\n                        @include toggle-row-objectives-style;\n                    }\n\n                    .create-event-objectives-toggle .toggle-label {\n                        color: $light-grey;\n                        display: block;\n                        text-transform: none;\n                        font-weight: normal;\n                        font-size: 15px;\n                        margin-left: 10px;\n                    }\n\n                    .create-event-objectives-list-container {\n                        border: 1px solid $light-grey;\n                        border-radius: 8px;\n                        padding: 8px;\n                        background-color: rgba(0, 0, 0, 0.15);\n                        width: 100%;\n                        box-sizing: border-box;\n\n                        &.disabled {\n                            opacity: 0.6;\n\n                            .create-event-objectives-scroll {\n                                height: auto;\n                            }\n                        }\n\n                        .create-event-objectives-scroll {\n                            height: 233px;\n                            overflow-y: auto;\n                            padding-right: 6px;\n                            display: flex;\n                            flex-direction: column;\n                            gap: 10px;\n                            @include scrollbar-styles;\n                        }\n\n                        .create-event-objectives-row {\n                            display: grid;\n                            grid-template-columns: 28px 1fr auto;\n                            gap: 6px;\n                            padding: 5px 2px;\n                            align-items: center;\n                            position: relative;\n                            cursor: pointer;\n\n                            &.is-selected {\n                                border-radius: 6px;\n                                background-color: $light-panel-blue;\n                            }\n                        }\n\n                        .create-event-objectives-order {\n                            font-size: 0.85em;\n                            color: $very-light-grey;\n                            opacity: 0.75;\n                            text-align: right;\n                            user-select: none;\n                            cursor: grab;\n\n                            &.is-disabled {\n                                opacity: 0.25;\n                                cursor: default;\n                            }\n                        }\n\n                        .create-event-objectives-input {\n                            width: 100%;\n                            box-sizing: border-box;\n                        }\n\n                        .toggle.critical {\n                            height: 11px;\n                            display: flex;\n                            align-items: center;\n                            top: 0px;\n                            gap: 6px;\n                        }\n                    }\n                }\n            }\n\n            .create-event-objectives-lexical-panel {\n                flex: 1 1 auto;\n                min-width: 0;\n                padding-top: 5px;\n                margin-top: 30px;\n\n                .create-event-objectives-lexical-empty {\n                    border: 1px dashed $light-grey;\n                    border-radius: 8px;\n                    padding: 12px;\n                    margin-top: 3px;\n                    color: $very-light-grey;\n                    opacity: 0.85;\n                }\n            }\n        }\n    }\n\n    .create-event-objectives-lexical-panel--locked {\n        pointer-events: none;\n        opacity: 0.65;\n    }\n\n    // --- Event Edit objectives (copy of create-event namespace; customize independently) ---\n\n    .event-edit-objectives-layout {\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n        max-width: 100%;\n        margin: 10px 0;\n        margin-left: 0;\n        margin-right: 0;\n        box-sizing: border-box;\n\n        .event-edit-objectives-editor-row {\n            display: flex;\n            gap: 10px;\n            padding: 0 10px 10px;\n            align-items: stretch;\n\n            .event-edit-objectives-list-panel {\n                display: flex;\n                justify-content: flex-start;\n                align-items: flex-start;\n                padding: 10px 0 0;\n                gap: 10px;\n                flex: 0 0 260px;\n                padding-top: 10px;\n\n                .event-edit-objectives-middle-column {\n                    flex: 1 1 auto;\n                    min-width: 240px;\n                    max-width: 260px;\n                    padding: 0;\n                    display: flex;\n                    flex-direction: column;\n                    gap: 10px;\n\n                    .event-edit-objectives-field {\n                        margin-bottom: 0;\n                        padding: 5px 10px;\n                        width: 92%;\n                        border: 1px solid rgba(58, 120, 180, 0.28);\n                        border-radius: 8px;\n                    }\n\n                    .event-edit-objectives-toggle {\n                        @include toggle-row-objectives-style;\n                    }\n\n                    .event-edit-objectives-toggle .toggle-label {\n                        color: $light-grey;\n                        display: block;\n                        text-transform: none;\n                        font-weight: normal;\n                        font-size: 15px;\n                        margin-left: 10px;\n                    }\n\n                    .event-edit-objectives-list-container {\n                        border: 1px solid rgba(58, 120, 180, 0.28);\n                        border-radius: 8px;\n                        padding: 8px;\n                        background-color: rgba(0, 0, 0, 0.15);\n                        width: 100%;\n                        box-sizing: border-box;\n\n                        &.disabled {\n                            opacity: 0.6;\n\n                            .event-edit-objectives-scroll {\n                                height: auto;\n                            }\n                        }\n\n                        .event-edit-objectives-scroll {\n                            height: 233px;\n                            overflow-y: auto;\n                            padding-right: 6px;\n                            display: flex;\n                            flex-direction: column;\n                            gap: 10px;\n                            @include scrollbar-styles;\n                        }\n\n                        .event-edit-objectives-row {\n                            display: grid;\n                            grid-template-columns: 28px 1fr auto;\n                            gap: 6px;\n                            padding: 5px 2px;\n                            align-items: center;\n                            position: relative;\n                            cursor: pointer;\n\n                            &.is-selected {\n                                border-radius: 6px;\n                                background-color: $light-panel-blue;\n                            }\n                        }\n\n                        .event-edit-objectives-order {\n                            font-size: 0.85em;\n                            color: $very-light-grey;\n                            opacity: 0.75;\n                            text-align: right;\n                            user-select: none;\n                            cursor: grab;\n\n                            &.is-disabled {\n                                opacity: 0.25;\n                                cursor: default;\n                            }\n                        }\n\n                        .event-edit-objectives-input {\n                            width: 100%;\n                            box-sizing: border-box;\n                        }\n\n                        .toggle.critical {\n                            height: 11px;\n                            display: flex;\n                            align-items: center;\n                            top: 0px;\n                            gap: 6px;\n                        }\n                    }\n                }\n            }\n\n            .event-edit-objectives-lexical-panel {\n                flex: 1 1 auto;\n                min-width: 0;\n                padding-top: 5px;\n                margin-top: 43px;\n\n                .event-edit-objectives-lexical-empty {\n                    border: 1px dashed $light-grey;\n                    border-radius: 8px;\n                    padding: 12px;\n                    margin-top: 3px;\n                    color: $very-light-grey;\n                    opacity: 0.85;\n                }\n            }\n        }\n    }\n\n    .event-edit-objectives-lexical-panel--locked {\n        pointer-events: none;\n        opacity: 0.65;\n    }\n}\n\n.tokenInput::-webkit-inner-spin-button,\n.tokenInput::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n/* Pour Firefox */\n.tokenInput[type='number'] {\n    //-moz-appearance: textfield;\n    width: -webkit-fill-available;\n}\n","@import './variables.scss';\n\n@keyframes rotate-background {\n  0% {\n    background-position: 0% 50%;\n  }\n  100% {\n    background-position: 100% 50%;\n  }\n}\n\n.rank-type-description {\n  padding: 0px 20px 20px 20px;\n  margin-bottom: 20px;\n}\n\n.ranks-tab {\n  .ranks-container {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(275px, 1fr));\n    row-gap: 10px;\n    column-gap: 0px;\n    //margin-bottom: 30px;\n    width: 90%;\n    margin: 0px auto 70px auto;\n    padding-right: 60px;\n\n    .rank-container {\n      background-color: #bebebd;\n      padding: 10px;\n      height: 58px;\n      //width: 320px;\n      width: 350px;\n      box-shadow: rgba(57, 56, 49, 0.8) 1px 2px 2px 1px inset;\n      clip-path: polygon(8% 0%, 92% 0%, 99% 50%, 92% 100%, 8% 100%, 1% 50%);\n\n      &.O-10, &.O-9, &.O-8, &.O-7, &.O-6, &.O-5 {\n        &:hover {\n          background-size: 200% 200% !important;\n          animation: rotate-background 2s linear infinite !important;\n        }\n      }\n\n      .rank-content {\n        display: flex;\n        height: 65px;\n        align-items: flex-start;\n        justify-content: left;\n        clip-path: polygon(6% 0%, 94% 0%, 100% 50%, 94% 100%, 6% 100%, 0% 50%);\n        transform: translate(0px, -3px);\n        box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.4), inset 0 -1px 3px rgba(255, 255, 255, 0.2);\n\n        &.O-10, &.O-9, &.O-8, &.O-7, &.O-6, &.O-5 {\n          &:hover {\n            animation: rotate-background 8s linear infinite !important;\n            background-size: 101% 99% !important;\n          }\n        }\n\n        .rank-image {\n          margin-top: 7px;\n          margin-left: 28px;\n          width: auto;\n          height: 50px;\n          margin-right: 10px;\n          filter: drop-shadow(2px 2px 1px #2e1e0e77);\n        }\n\n        .rank-name {\n          text-shadow: 1px 1px 1px #4e4d4b5d;\n          color: #575151 !important;\n          align-self: center;\n          max-width: 56%;\n          text-transform: uppercase;\n          font-size: 0.85rem;\n          font-weight: bold;          \n        }\n\n        &.O-10, &.O-9, &.O-8, &.O-7, &.O-6, &.O-5 {\n          background: linear-gradient(\n            -72deg,\n            #dedede,\n            #ffffff 10%,\n            #dedede 12%,\n            #ffffff 16%,\n            #dedede 20%,\n            #ffffff 24%,\n            #a1a1a1 27%,\n            #dedede 36%,\n            #c5c5c5 45%,\n            #ffffff 60%,\n            #dedede 72%,\n            #ffffff 80%,\n            #dedede 84%,\n            #a1a1a1\n          );\n          \n        }\n\n        &.O-4, &.O-3, &.O-2, &.O-1, &.O-C {\n          background: linear-gradient(\n            -72deg,\n            #bebebe,\n            #d6d5d5 10%,\n            #979797 12%,\n            #d6d5d5 16%,\n            #979797 20%,\n            #d6d5d5 24%,\n            #8b8b8b 27%,\n            #979797 36%,\n            #c5c5c5 45%,\n            #d6d5d5 60%,\n            #979797 72%,\n            #c4c4c4 80%,\n            #979797 84%,\n            #a1a1a1\n          );\n        }\n\n        &.W-1, &.W-2, &.W-3, &.W-4 {\n          background: linear-gradient(\n            -72deg,\n            #dedede,\n            #ffffff 10%,\n            #dedede 12%,\n            #ffffff 16%,\n            #dedede 20%,\n            #ffffff 24%,\n            #a1a1a1 27%,\n            #dedede 36%,\n            #c5c5c5 45%,\n            #ffffff 60%,\n            #dedede 72%,\n            #ffffff 80%,\n            #dedede 84%,\n            #a1a1a1\n          );\n        }\n\n        &.E-10, &.E-9, &.E-8, &.E-7 {\n          background: linear-gradient(\n            -72deg,\n            #dedede,\n            #ffffff 10%,\n            #dedede 12%,\n            #ffffff 16%,\n            #dedede 20%,\n            #ffffff 24%,\n            #a1a1a1 27%,\n            #dedede 36%,\n            #c5c5c5 45%,\n            #ffffff 60%,\n            #dedede 72%,\n            #ffffff 80%,\n            #dedede 84%,\n            #a1a1a1\n          );\n        }\n\n        &.E-6, &.E-5, &.E-4, &.E-3, &.E-2, &.E-1 {\n          background: linear-gradient(\n            -72deg,\n            #bebebe,\n            #d6d5d5 10%,\n            #979797 12%,\n            #d6d5d5 16%,\n            #979797 20%,\n            #d6d5d5 24%,\n            #8b8b8b 27%,\n            #979797 36%,\n            #c5c5c5 45%,\n            #d6d5d5 60%,\n            #979797 72%,\n            #c4c4c4 80%,\n            #979797 84%,\n            #a1a1a1\n          );\n        }\n\n        &.A-6, &.A-5, &.A-4, &.A-3, &.A-2, &.A-1 {\n          background: linear-gradient(\n            -72deg,\n            #bebebe,\n            #d6d5d5 10%,\n            #979797 12%,\n            #d6d5d5 16%,\n            #979797 20%,\n            #d6d5d5 24%,\n            #8b8b8b 27%,\n            #979797 36%,\n            #c5c5c5 45%,\n            #d6d5d5 60%,\n            #979797 72%,\n            #c4c4c4 80%,\n            #979797 84%,\n            #a1a1a1\n          );\n        }\n      }\n    }\n  }\n}\n\n.rank-image-placeholder {\n  width: 57px; /* Utilisez les mêmes dimensions que .rank-image */\n  height: auto; /* Ou une hauteur fixe si nécessaire */\n  background-color: transparent; /* Ou une couleur d'arrière-plan si vous préférez */\n\n  margin-left: 28px;\n  margin-right: 10px;\n  filter: drop-shadow(2px 2px 1px #2e1e0e77);\n}","@import './variables.scss';\n\n.selected-ribbon {\n    display: flex;\n    width: 350px;\n    text-align: center;\n    //margin-top: 30px;\n    margin-left: 5px;\n    margin-right: auto;\n\n    &.calendar {\n        width: 215px;\n        margin-top: 15px; \n        margin-left: 0px;\n        margin-right: 0px;\n    }\n}\n\n.admin-block-container {\n    &.create-event-template {\n        display: flex;\n        flex-direction: column;\n        width: initial;\n        margin: 10px;\n\n        .inputs-container {\n            display: flex;\n            justify-content: space-between;\n            align-items: flex-start;\n            padding: 10px 0 0;\n            gap: 10px;\n            \n            .left-column {\n                display: flex;\n                flex-direction: column;\n                flex: 1 1 0;\n                padding-left: 10px;\n                gap: 10px;\n\n                .input-field {\n                    margin-bottom: 0;\n                }\n            }\n\n            // Required fields: red border when empty, transparent when filled (no layout shift)\n            .input-field.required-empty input,\n            .input-field.required-empty textarea,\n            .input-field.required-empty select {\n                border: 1px solid $red;\n                box-sizing: border-box;\n            }\n\n            .input-field.required-filled input,\n            .input-field.required-filled textarea,\n            .input-field.required-filled select {\n                border: 1px solid transparent;\n                box-sizing: border-box;\n                width: 175px;\n\n            }\n\n            .input-field.required-empty .react-select-input__control {\n                border: 1px solid $red !important;\n                box-sizing: border-box;\n            }\n\n            .input-field.required-filled .react-select-input__control {\n                border: 1px solid transparent !important;\n                box-sizing: border-box;\n            }\n    \n            .right-column {\n                flex: 1 1 0;\n                padding-right: 10px;\n            }\n\n            .middle-column {\n                flex: 0 0 220px;\n                padding: 0 10px;\n                display: flex;\n                flex-direction: column;\n                gap: 10px;\n                min-width: 200px;\n                max-width: 240px;\n\n                .toggle.objectives {\n                    padding-right: 25px;\n                    @include toggle-row-objectives-style;\n                }\n\n                .toggle.objectives .toggle-label {\n                    color: $light-grey;\n                    display: block;\n                    text-transform: none;\n                    font-weight: normal;\n                    font-size: 15px;\n                    margin-left: 10px;\n                }\n            }\n\n            .objectives-container {\n                border: 1px solid $light-grey;\n                border-radius: 8px;\n                padding: 8px;\n                background-color: rgba(0, 0, 0, 0.15);\n                width: 100%;\n                box-sizing: border-box;\n\n                &.disabled {\n                    opacity: 0.6;\n                }\n\n                .objectives-scroll {\n                    height: 257px;\n                    overflow-y: auto;\n                    padding-right: 6px;\n                    display: flex;\n                    flex-direction: column;\n                    gap: 10px;\n                    @include scrollbar-styles;\n                }\n\n                .objective-row {\n                    display: grid;\n                    grid-template-columns: 28px 1fr auto;\n                    gap: 6px;\n                    padding: 5px 2px;\n                    align-items: center;\n                    position: relative;\n                }\n\n                .objective-order {\n                    font-size: 0.85em;\n                    color: $very-light-grey;\n                    opacity: 0.75;\n                    text-align: right;\n                    user-select: none;\n                    cursor: grab;\n\n                    &.is-disabled {\n                        opacity: 0.25;\n                        cursor: default;\n                    }\n                }\n\n                .objective-input {\n                    width: 100%;\n                    box-sizing: border-box;\n                }\n\n                .toggle.critical {\n                    height: 11px;\n                    display: flex;\n                    align-items: center;\n                    top: 0px;\n                    gap: 6px;\n                }\n\n            }\n    \n            .input-field {\n                width: 357px;\n\n                &.event-template {\n                    width: 326px;\n                }\n            }\n\n            .middle-column .input-field {\n                width: 100%;\n            }\n\n            // Keep the 3-column layout inside the modal width\n            .left-column .input-field,\n            .right-column .input-field {\n                width: 310px \n            }\n\n            // Ensure Ribbon label is above the dropdown (column layout)\n            .right-column .input-field {\n                display: flex;\n                flex-direction: column;\n            }\n            .left-column > .input-field > .toggle.training {\n                display: flex;\n                justify-content: space-between;\n                width: 100%;\n                height: 11px;\n            }\n\n            .left-column > .input-field > .toggle.training .toggle-label {\n                color: $light-grey;\n                display: block;\n                text-transform: none;\n                font-weight: normal;\n                font-size: 15px;\n                margin-left: 10px;\n            }\n\n            .left-column > .input-field > .toggle.training .toggle-switch {\n                margin-left: auto;\n                top: 3px;\n                //margin-right: 30px;\n            }\n        }\n\n        &.objectives-only {\n            .objectives-editor-row {\n                display: flex;\n                gap: 10px;\n                padding: 0 10px 10px;\n                align-items: stretch;\n            }\n\n            .inputs-container.objectives-only.objectives-list-panel {\n                justify-content: flex-start;\n                flex: 0 0 260px;\n                padding-top: 10px;\n            }\n\n            .inputs-container.objectives-only.objectives-list-panel .middle-column {\n                flex: 1 1 auto;\n                min-width: 240px;\n                max-width: 260px;\n                padding: 0;\n            }\n\n            .inputs-container.objectives-only.objectives-list-panel .objectives-container {\n                width: 100%;\n            }\n\n            .objectives-lexical-panel {\n                flex: 1 1 auto;\n                min-width: 0;\n                padding-top: 5px;\n            }\n\n            .objective-row {\n                cursor: pointer;\n\n                &.is-selected {\n                    border-radius: 6px;\n                    background-color: $light-panel-blue;\n                }\n            }\n\n            .objectives-lexical-empty {\n                border: 1px dashed $light-grey;\n                border-radius: 8px;\n                padding: 12px;\n                color: $very-light-grey;\n                opacity: 0.85;\n            }\n        }\n\n        .discord {\n            display: flex;\n            width: 100%; \n\n            .discord-banner {\n                position: relative;\n                margin: 0px 0px 30px 0px;\n                width: 500px;\n                min-width: 500px;\n                height: 200px;\n            \n                // Ratio de 2.5:1\n                &:before {\n                    content: \"\";\n                    display: block;\n                    //padding-top: 40%; // 40% pour obtenir un ratio 2.5:1 (1 / 2.5 = 0.4)\n                }\n            \n                .dropzone {\n                    position: relative;\n                    width: auto;\n                    height: 100%;\n                    border: 2px dashed $light-grey;\n                    overflow: hidden; // Masquer tout ce qui déborde du conteneur\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    cursor: grab;\n                    background-color: $grey;\n\n                    .image-preview {\n                        position: absolute;\n                        top: 0;\n                        left: 0;\n                        width: 100%;\n                        object-fit: cover; // Ajuste l'image pour qu'elle couvre toute la zone\n                        transform-origin: top left;\n                        cursor: grab;\n                        user-select: none; // Permet de rogner l'image tout en la centrant\n\n                        // Translation horizontale\n                        @for $x from -1500 through 50 {\n                            &.translate-x-#{$x} {\n                                --translate-x: #{$x}px;\n                            }\n                        }\n\n                        // Translation verticale\n                        @for $y from -800 through 50 {\n                            &.translate-y-#{$y} {\n                                --translate-y: #{$y}px;\n                            }\n                        }\n\n                        // Zoom (échelle)\n                        @for $z from 50 through 300 {\n                            $scale: $z / 100;\n                            &.scale-#{$z} {\n                                --scale: #{$scale};\n                            }\n                        }\n\n                        // Combine toutes les transformations\n                        transform: translateX(var(--translate-x, 0px)) translateY(var(--translate-y, 0px)) scale(var(--scale, 1));\n                    }\n\n                    &.is-dragging {\n                        cursor: grabbing;\n                    }\n                }\n\n                .zoom-slider {\n                    display: flex;\n                    width: 325px;\n                    margin: 8px auto 0px auto;\n                }\n            }\n            \n\n            .discord-description  {\n                display: flex;\n                width: -webkit-fill-available;\n\n                .input-field {\n                    display: flex;\n                    flex-direction: column;\n                    width: 100%;\n                    padding: 0 10px 0 20px;\n\n                    .home-file, .character-counter {\n                        margin: 5px auto 5px 3px;\n                    }\n                }\n            }\n        }\n\n        .objectives-benefits-row {\n            display: flex;\n            gap: 10px;\n            width: 100%;\n            align-items: stretch;\n            padding: 0 10px 10px;\n        }\n\n        .template-objectives-preview,\n        .benefits-block {\n            flex: 1 1 0;\n            min-width: 0;\n            background-color: $very-dark-grey;\n            border: 1px solid $light-grey;\n            border-radius: 8px;\n            padding: 10px;\n        }\n\n        .template-objectives-preview {\n            height: 150px;\n            display: flex;\n            flex-direction: column;\n\n            .template-objectives-preview-list {\n                margin-top: 8px;\n                overflow-y: auto;\n                display: flex;\n                flex-direction: column;\n                gap: 5px;\n                @include scrollbar-styles;\n            }\n\n            .template-objectives-preview-row {\n                display: grid;\n                grid-template-columns: 24px 1fr 10px;\n                gap: 6px;\n                align-items: center;\n            }\n\n            .template-objectives-preview-order {\n                text-align: right;\n                opacity: 0.75;\n            }\n\n            .template-objectives-preview-critical {\n                width: 8px;\n                height: 8px;\n                border-radius: 50%;\n                background-color: $red;\n                justify-self: end;\n            }\n        }\n    }\n}\n\n\n\n\n// ---------- //\n//     MDE    //  \n// ---------- //\n\n.mde-header {\n    flex-shrink: 0;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: stretch;\n    border-bottom: 1px solid #c8ccd0;\n    border-radius: 2px 2px 0 0;\n    color: $very-light-grey;\n    background: $very-dark-grey;\n    border: 1px solid $dark-red;\n    border-radius: 6px 6px 0 0;\n}\n\n.mde-header .mde-tabs {\n    display: flex;\n    flex-direction: row;\n    color: $very-light-grey;\n}\n\n.mde-header .mde-tabs button.selected {\n    border: 1px solid #c8ccd0;\n    color: $very-light-grey;\n}\n\n.mde-header .mde-tabs button:first-child {\n    color: $very-light-grey;\n    margin-left: 6px;\n}\n\n.mde-header .mde-tabs button {\n    border-radius: 2px;\n    margin: 6px 3px;\n    color: $very-light-grey;\n    background-color: transparent;\n    border: 1px solid transparent;\n    cursor: pointer;\n}\n\n.react-mde * {\n    box-sizing: border-box;\n}\n\n.react-mde {\n    //border: 1px solid $very-dark-grey;\n    border-radius: 6px;\n    width: 100%;\n}\n\n.mde-header ul.mde-header-group {\n    margin: 0;\n    padding: 10px;\n    list-style: none;\n    display: flex;\n    flex-wrap: nowrap;\n}\n\n.mde-header ul.mde-header-group li.mde-header-item {\n    display: inline-block;\n    position: relative;\n    margin: 0 4px;\n}\n\n.mde-header ul.mde-header-group li.mde-header-item button {\n    text-align: left;\n    cursor: pointer;\n    height: 22px;\n    padding: 4px;\n    margin: 0;\n    border: none;\n    background: none;\n    color: $very-light-grey;\n}\n\n.mde-header .svg-icon {\n    width: 1em;\n    height: 1em;\n    display: inline-block;\n    font-size: inherit;\n    overflow: visible;\n    vertical-align: -.125em;\n}\n\n.react-mde, .react-mde-tabbed-layout {\n    .mde-textarea-wrapper {\n        color: green;\n        position: relative;\n\n        .mde-text {\n            color: $very-light-grey;\n            background: $dark-grey;\n            width: 100%;\n            height: 130px !important;\n            font-family: 'Lato';\n            font-size: 1em;\n            border: 1px solid $dark-red !important;\n            border-radius: 0px 0px 6px 6px;\n            @include scrollbar-styles;\n\n            &:focus-visible {\n                outline: $dark-red;\n            }\n        }\n\n        textarea {\n            resize: none;\n            padding: 10px;\n        }\n    }\n}\n\n\n.react-mde .invisible {\n    display: none;\n}\n\n.mde-preview {\n    height: 130px !important;\n    min-height: 130px !important;\n    color: $very-light-grey;\n    background: $dark-grey;\n    border: 1px solid $dark-red !important;\n    border-radius: 0px 0px 6px 6px;\n    margin-bottom: 5px;\n    overflow:  auto;\n    @include scrollbar-styles;\n}\n\n.mde-preview .mde-preview-content {\n    position: relative;\n    padding: 0px 10px;\n    bottom: 5px;\n\n    .p {\n        margin-top: 0;\n    }\n}\n\n/* Compte à rebours claim lock — aligné sur `.benefits-uec-input-shell` : une coque, bandeau libellé (type « UEC »), heure en zone sombre (type champ). */\n.benefits-countdown-digital {\n    box-sizing: border-box;\n}\n\n.benefits-countdown-digital--claim-lock {\n    display: inline-flex;\n    margin-top: 0;\n    min-width: 0;\n    max-width: 100%;\n}\n\n.benefits-countdown-digital__shell {\n    display: flex;\n    align-items: stretch;\n    flex: 1 1 auto;\n    min-width: 0;\n    max-width: 100%;\n    width: 100%;\n    background: $very-dark-grey;\n    border: 1px solid $medium-grey;\n    border-radius: 6px;\n    overflow: hidden;\n}\n\n/* Bandeau libellé : mêmes tons que `.benefits-block .benefits-uec-input-unit` */\n.benefits-countdown-digital__label {\n    display: flex;\n    align-items: center;\n    flex: 0 1 auto;\n    min-width: 0;\n    max-width: 55%;\n    padding: 5px 10px;\n    margin: 0;\n    background: rgba($medium-grey, 0.25);\n    border-right: 1px solid rgba($medium-grey, 0.6);\n    color: $very-light-grey;\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    line-height: 1.2;\n    text-transform: uppercase;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    user-select: none;\n}\n\n/* Heure : zone principale sombre — équivalent visuel du montant UEC mais fond `$grey` (pas `$light-panel-blue`) */\n.benefits-countdown-digital__time {\n    display: flex;\n    align-items: center;\n    flex: 1 1 auto;\n    width: 85px;\n    padding: 5px 10px;\n    margin: 0;\n    font-size: 15px;\n    font-weight: 600;\n    font-family: \"GoodTimes\";\n    font-variant-numeric: tabular-nums;\n    letter-spacing: 0.03em;\n    line-height: 1.2;\n    color: $very-light-grey;\n    background: $light-panel-blue;\n    border: 0;\n    text-align: left;\n}\n\n.benefits-countdown-digital--steady .benefits-countdown-digital__shell {\n    border-color: $medium-grey;\n}\n\n.benefits-countdown-digital--warning .benefits-countdown-digital__shell {\n    border-color: $light-orange;\n}\n\n.benefits-countdown-digital--warning .benefits-countdown-digital__label {\n    color: $very-light-orange;\n}\n\n.benefits-countdown-digital--warning .benefits-countdown-digital__time {\n    color: $very-light-orange;\n    background: $light-panel-blue;\n}\n\n.benefits-countdown-digital--critical .benefits-countdown-digital__shell {\n    border-color: $bright-red;\n}\n\n.benefits-countdown-digital--critical .benefits-countdown-digital__label {\n    color: $very-light-grey;\n}\n\n.benefits-countdown-digital--critical .benefits-countdown-digital__time {\n    color: $pure-white;\n    background: $light-panel-blue;\n}\n\n.benefits-countdown-digital--locked .benefits-countdown-digital__shell--locked {\n    justify-content: center;\n    padding: 5px 12px;\n    border-color: $medium-red;\n}\n\n.benefits-countdown-digital__locked-label {\n    display: block;\n    width: 100%;\n    text-align: center;\n    color: $very-light-grey;\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    line-height: 1.2;\n    text-transform: uppercase;\n    user-select: none;\n}\n\n.benefits-countdown-digital__amount {\n    font-size: 0.8rem;\n    font-weight: 600;\n}\n\n.calendar-event-benefits-countdown {\n    margin-top: 0.35rem;\n    margin-bottom: 0.25rem;\n}\n\n.header-with-toggle {\n    .report-event-benefits-countdown {\n        width: 100%;\n    }\n}","@import './variables.scss';\n\n.event-planner {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 300px;\n  gap: 1rem;\n  min-height: 500px;\n}\n\n.event-planner__workspace,\n.event-planner__vehicles {\n  min-width: 0;\n  padding: 1rem 1.1rem;\n  border: 1px solid rgba($accent-blue, 0.45);\n  border-radius: 12px;\n  background:\n    linear-gradient(180deg, rgba($dark-blue, 0.82), rgba($dark-blue-grey, 0.55)),\n    rgba($dark-blue, 0.65);\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.22);\n}\n\n.event-planner__panel-header,\n.event-planner__table-heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n\n  h3 {\n    margin: 0;\n    color: $very-light-grey;\n    font-size: 0.95rem;\n    font-weight: 600;\n    line-height: 1.35;\n  }\n}\n\n.event-planner__panel-header {\n  margin-bottom: 0.85rem;\n  padding-bottom: 0.85rem;\n  border-bottom: 1px solid rgba($accent-blue, 0.28);\n}\n\n.event-planner__eyebrow {\n  margin: 0 0 0.25rem;\n  color: rgba($very-light-grey, 0.55);\n  font-size: 0.68rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.event-planner__vehicle-count,\n.event-planner__position-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 1.65rem;\n  padding: 0.15rem 0.55rem;\n  border: 1px solid rgba($accent-blue, 0.35);\n  border-radius: 999px;\n  color: $light-blue;\n  background: rgba($accent-blue, 0.16);\n  font-family: 'FiraCode', monospace;\n  font-size: 0.72rem;\n  white-space: nowrap;\n}\n\n.event-planner__toolbar {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  margin-bottom: 0.75rem;\n  padding: 0.7rem;\n  border: 1px solid rgba($accent-blue, 0.35);\n  border-radius: 10px;\n  background: rgba($dark-blue, 0.52);\n}\n\n.event-planner__vehicle-size-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.event-planner__vehicle-size-filter {\n  padding: 0.28rem 0.55rem;\n  border: 1px solid rgba($accent-blue, 0.28);\n  border-radius: 999px;\n  color: rgba($very-light-grey, 0.82);\n  background: rgba($dark-panel-blue, 0.72);\n  font-family: inherit;\n  font-size: 0.68rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: capitalize;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;\n\n  &:hover {\n    border-color: rgba($light-blue, 0.42);\n    color: $pure-white;\n    background: rgba($blue-grey, 0.72);\n  }\n\n  &.is-active {\n    border-color: rgba($light-blue, 0.55);\n    color: $light-blue;\n    background: rgba($blue, 0.42);\n  }\n}\n\n.event-planner__in-concept-toggle {\n  justify-content: space-between;\n  width: 100%;\n  margin-top: 0.15rem;\n  padding-top: 0.45rem;\n  border-top: 1px solid rgba($accent-blue, 0.22);\n\n  .toggle-label {\n    color: rgba($very-light-grey, 0.82);\n    font-size: 0.72rem;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    text-transform: capitalize;\n  }\n}\n\n.event-planner__vehicle-search,\n.event-planner__add-position-row input,\n.event-planner__edit-position-input {\n  width: 100%;\n  padding: 0.45rem 0.65rem;\n  border: 1px solid rgba($accent-blue, 0.45);\n  border-radius: 8px;\n  outline: none;\n  color: $very-light-grey;\n  background: rgba($dark-blue, 0.65);\n  font-family: inherit;\n  font-size: 0.84rem;\n\n  &:focus {\n    border-color: rgba($light-blue, 0.75);\n    box-shadow: 0 0 0 2px rgba($accent-blue, 0.14);\n  }\n}\n\n.event-planner__vehicle-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  max-height: calc(100vh - 800px);\n  overflow-y: auto;\n  @include event-planner-scrollbar;\n}\n\n.event-planner__special-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  margin-bottom: 0.85rem;\n  padding-bottom: 0.85rem;\n  border-bottom: 1px solid rgba($accent-blue, 0.28);\n}\n\n.event-planner__special {\n  min-height: 2.65rem;\n}\n\n.event-planner__vehicle {\n  position: relative;\n  width: 100%;\n  padding: 0.65rem 0.75rem;\n  border: 1px solid rgba($accent-blue, 0.2);\n  border-radius: 8px;\n  color: rgba($very-light-grey, 0.82);\n  background: rgba($dark-blue, 0.42);\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;\n\n  &:hover {\n    border-color: rgba($accent-blue, 0.5);\n    background: rgba($accent-blue, 0.1);\n    color: $very-light-grey;\n  }\n\n  &.is-selected {\n    padding-left: 0.9rem;\n    border-color: rgba($accent-blue, 0.7);\n    background: rgba($accent-blue, 0.18);\n    color: $pure-white;\n    box-shadow: inset 3px 0 0 rgba($accent-blue, 0.85);\n  }\n}\n\n.event-planner__vehicle-main {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.65rem;\n}\n\n.event-planner__vehicle-name {\n  min-width: 0;\n  overflow: hidden;\n  color: inherit;\n  font-weight: 600;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.event-planner__vehicle-focus {\n  display: block;\n  margin-top: 0.25rem;\n  overflow: hidden;\n  color: rgba($very-light-grey, 0.55);\n  font-size: 0.72rem;\n  line-height: 1.35;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.event-planner__prod-state {\n  flex-shrink: 0;\n  padding: 0.14rem 0.42rem;\n  border: 1px solid;\n  border-radius: 999px;\n  font-size: 0.62rem;\n  font-weight: 600;\n  letter-spacing: 0.035em;\n  line-height: 1.25;\n  text-transform: uppercase;\n  white-space: nowrap;\n\n  &.is-flight-ready {\n    border-color: rgba($light-green, 0.42);\n    color: $very-light-green;\n    background: rgba($green, 0.18);\n  }\n\n  &.is-other {\n    border-color: rgba($light-orange, 0.48);\n    color: $very-light-orange;\n    background: rgba($orange, 0.2);\n  }\n}\n\n.event-planner__message,\n.event-planner__empty-state p {\n  margin: 0;\n  color: rgba($very-light-grey, 0.55);\n  font-size: 0.85rem;\n  text-align: center;\n}\n\n.event-planner__empty-state {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 250px;\n  border: 1px dashed rgba($accent-blue, 0.35);\n  border-radius: 12px;\n  background: rgba($dark-blue, 0.25);\n}\n\n.event-planner__team-names-table {\n  margin-top: 0.25rem;\n  margin-bottom: 1rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid rgba($accent-blue, 0.28);\n}\n\n.event-planner__positions-table {\n  margin-top: 0.25rem;\n}\n\n.event-planner__save-row--compact {\n  margin-top: 0.65rem;\n}\n\n.event-planner__table-heading {\n  margin-bottom: 0.75rem;\n}\n\n.event-planner__table-wrap {\n  max-height: calc(100vh - 725px);\n  overflow-y: auto;\n  @include event-planner-scrollbar;\n  border: 1px solid rgba($accent-blue, 0.28);\n  border-radius: 12px;\n  background: rgba($dark-blue, 0.38);\n\n  table {\n    width: 100%;\n    border-collapse: collapse;\n    table-layout: fixed;\n    font-size: 0.82rem;\n  }\n\n  col.col-drag {\n    width: 48px;\n  }\n\n  col.col-number {\n    width: 52px;\n  }\n\n  col.col-command {\n    width: 44px;\n  }\n\n  col.col-actions {\n    width: 88px;\n  }\n\n  col.col-swappable {\n    width: 108px;\n  }\n\n  th,\n  td {\n    padding: 0.65rem 0.75rem;\n    border-bottom: 1px solid rgba($medium-grey, 0.65);\n    color: $very-light-grey;\n    text-align: left;\n    vertical-align: middle;\n  }\n\n  th {\n    position: sticky;\n    top: 0;\n    z-index: 2;\n    color: rgba($very-light-grey, 0.62);\n    background: rgba($dark-blue-grey, 0.95);\n    font-size: 0.68rem;\n    font-weight: 600;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n  }\n\n  th.header-number,\n  td.cell-number,\n  th.header-drag,\n  td.cell-drag,\n  th.header-command,\n  td.cell-command,\n  th.header-actions,\n  td.cell-actions,\n  th.header-swappable,\n  td.cell-swappable {\n    text-align: center;\n  }\n\n  tbody tr {\n    background: transparent;\n    transition: background 0.15s ease;\n\n    &:hover {\n      background: rgba($accent-blue, 0.08);\n    }\n\n    &:last-child td {\n      border-bottom: 0;\n    }\n\n    &.is-dragging {\n      position: relative;\n      z-index: 2;\n      opacity: 0.82;\n      background: rgba($accent-blue, 0.18);\n      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);\n    }\n  }\n}\n\n.event-planner__drag-handle {\n  width: 1.75rem;\n  height: 1.75rem;\n  padding: 0;\n  border: 1px solid rgba($accent-blue, 0.3);\n  border-radius: 6px;\n  color: rgba($very-light-grey, 0.72);\n  background: rgba($dark-blue-grey, 0.45);\n  font-size: 1.1rem;\n  line-height: 1;\n  cursor: grab;\n  touch-action: none;\n\n  &:hover {\n    border-color: rgba($accent-blue, 0.65);\n    color: $light-blue;\n    background: rgba($accent-blue, 0.14);\n  }\n\n  &:active {\n    cursor: grabbing;\n  }\n}\n\n.event-planner__edit-position {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.75rem;\n  height: 1.75rem;\n  padding: 0;\n  border: 1px solid rgba($accent-blue, 0.3);\n  border-radius: 6px;\n  color: rgba($very-light-grey, 0.72);\n  background: rgba($dark-blue-grey, 0.45);\n  font-size: 0.95rem;\n  line-height: 1;\n  cursor: pointer;\n\n  &:hover {\n    border-color: rgba($accent-blue, 0.65);\n    color: $light-blue;\n    background: rgba($accent-blue, 0.14);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: default;\n  }\n}\n\n.event-planner__row-actions {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n}\n\n.event-planner__row-action {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.75rem;\n  height: 1.75rem;\n  padding: 0;\n  border: 1px solid rgba($accent-blue, 0.3);\n  border-radius: 6px;\n  color: rgba($very-light-grey, 0.72);\n  background: rgba($dark-blue-grey, 0.45);\n  font-size: 0.95rem;\n  line-height: 1;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    border-color: rgba($accent-blue, 0.65);\n    color: $light-blue;\n    background: rgba($accent-blue, 0.14);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: default;\n  }\n}\n\n.event-planner__row-action--delete {\n  &:hover:not(:disabled) {\n    border-color: rgba($bright-red, 0.55);\n    color: $bright-red;\n    background: rgba($bright-red, 0.12);\n  }\n}\n\n.event-planner__delete-media {\n  width: 1rem;\n  height: 1rem;\n  margin: 0;\n  transform: none;\n}\n\n.event-planner__command-position-toggle {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  width: 1.5rem;\n  height: 1.5rem;\n  padding: 0;\n  border: 1px solid rgba($accent-blue, 0.22);\n  border-radius: 6px;\n  background: rgba($dark-blue-grey, 0.45);\n  color: rgba($very-light-grey, 0.62);\n  cursor: pointer;\n  transition: border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease;\n\n  &:hover:not(:disabled),\n  &:focus-visible:not(:disabled) {\n    border-color: rgba($very-light-yellow, 0.55);\n    color: $very-light-yellow;\n  }\n\n  &.is-active {\n    border-color: rgba($very-light-yellow, 0.65);\n    background: rgba($very-dark-orange, 0.35);\n    color: $very-light-yellow;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: default;\n  }\n}\n\n.event-planner__command-position-toggle-icon {\n  width: 0.82rem;\n  height: 0.82rem;\n}\n\n.event-planner__swappable-toggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n}\n\n.event-planner__edit-position-input {\n  box-sizing: border-box;\n}\n\n.event-planner__add-position-row {\n  td {\n    position: sticky;\n    bottom: 0;\n    z-index: 2;\n    background: rgba($dark-blue, 0.92);\n    border-top: 1px solid rgba($medium-grey, 0.65);\n  }\n\n  background: rgba($accent-blue, 0.04) !important;\n\n  input {\n    box-sizing: border-box;\n  }\n}\n\n.event-planner__save-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.75rem 1rem;\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid rgba($accent-blue, 0.28);\n}\n\n.event-planner__save-message {\n  margin: 0;\n  color: $light-blue;\n  font-size: 0.82rem;\n}\n\n.event-planner__save-message--error {\n  color: $bright-red;\n}\n\n.event-planner__save-hint {\n  margin: 0;\n  color: rgba($very-light-grey, 0.55);\n  font-size: 0.78rem;\n}\n\n@media (max-width: 800px) {\n  .event-planner {\n    grid-template-columns: 1fr;\n  }\n\n  .event-planner__vehicles {\n    order: -1;\n  }\n}\n\n// Member event planner (calendar modal) — separate root to avoid admin grid clash\n.event-planner-view {\n  --event-planner-position-column-width: #{$event-planner-team-min-width};\n  --event-planner-team-max-width: #{$event-planner-team-max-width};\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  min-height: 500px;\n  padding: 0.7rem 0.85rem;\n  color: $very-light-grey;\n  background:\n    linear-gradient(180deg, rgba($very-dark-grey, 0.98), rgba($dark-panel-blue, 0.92)),\n    $very-dark-grey;\n\n  &--readonly {\n    .event-planner-view__drag-hint {\n      display: none;\n    }\n  }\n}\n\n.event-planner-view__header {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  padding-bottom: 0.65rem;\n  border-bottom: 1px solid rgba($accent-blue, 0.32);\n}\n\n.event-planner-view__header-main-row {\n  display: grid;\n  grid-template-columns: 300px minmax(0, 1fr) auto;\n  align-items: start;\n  gap: 0.85rem 1rem;\n}\n\n.event-planner-view__header-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  width: 300px;\n  max-width: 300px;\n  min-width: 0;\n\n  h2 {\n    margin: 0;\n    min-width: 0;\n    overflow: hidden;\n    color: $pure-white;\n    font-size: 1.15rem;\n    font-weight: 600;\n    line-height: 1.35;\n    text-align: left;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n.event-planner-view__header-toolbar {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0.4rem;\n  min-width: 0;\n}\n\n.event-planner-view__header-toolbar-main {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  min-width: 0;\n}\n\n.event-planner-view__header-toolbar-stats {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.event-planner-view__header-stat-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.32rem;\n  padding: 0.26rem 0.58rem;\n  border: 1px solid rgba($accent-blue, 0.34);\n  border-radius: 999px;\n  background: rgba($dark-panel-blue, 0.78);\n  color: $medium-light-grey;\n  font-size: 0.7rem;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.event-planner-view__header-stat-chip-icon {\n  flex-shrink: 0;\n  width: 0.75rem;\n  height: 0.75rem;\n  color: $light-blue;\n}\n\n.event-planner-view__header-stat-chip-label {\n  color: inherit;\n}\n\n.event-planner-view__header-stat-chip--filled {\n  border-color: rgba($light-blue, 0.38);\n  background: rgba($blue, 0.32);\n  color: $very-light-grey;\n}\n\n.event-planner-view__header-stat-chip--open {\n  border-color: rgba($medium-light-grey, 0.28);\n  background: rgba($very-dark-grey, 0.55);\n  color: $medium-light-grey;\n}\n\n.event-planner-view__header-stat-chip--assigned {\n  border-color: rgba($light-green, 0.38);\n  background: rgba($light-green, 0.1);\n  color: $light-green;\n\n  .event-planner-view__header-stat-chip-icon {\n    color: $light-green;\n  }\n}\n\n.event-planner-view__header-search {\n  flex: 0 1 300px;\n  width: 100%;\n  max-width: 400px;\n  min-width: 0;\n  margin-bottom: 0;\n}\n\n.event-planner-view__fleet-assignment-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.35rem;\n  margin-bottom: 0.45rem;\n}\n\n.event-planner-view__bulk-expand-toggle {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: stretch;\n  margin-left: auto;\n  padding: 0.14rem;\n  border: 1px solid rgba($accent-blue, 0.42);\n  border-radius: 9px;\n  background: rgba($dark-blue, 0.62);\n  box-shadow: inset 0 1px 0 rgba($pure-white, 0.04);\n  gap: 0.14rem;\n}\n\n.event-planner-view__bulk-expand-toggle-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.32rem;\n  padding: 0.3rem 0.55rem;\n  border: 0;\n  border-radius: 7px;\n  color: $medium-light-grey;\n  background: transparent;\n  font-size: 0.68rem;\n  line-height: 1.2;\n  white-space: nowrap;\n  cursor: pointer;\n  transition:\n    background 160ms ease,\n    color 160ms ease,\n    box-shadow 160ms ease;\n\n  &:hover:not(.is-active) {\n    color: $very-light-grey;\n    background: rgba($pure-white, 0.06);\n  }\n\n  &.is-active {\n    color: $pure-white;\n    background: rgba($blue, 0.72);\n    box-shadow:\n      0 1px 2px rgba(0, 0, 0, 0.28),\n      inset 0 1px 0 rgba($pure-white, 0.1);\n  }\n}\n\n.event-planner-view__bulk-expand-toggle-icon {\n  display: block;\n  width: 12px;\n  height: 12px;\n  object-fit: contain;\n  opacity: 0.95;\n}\n\n.event-planner-view__bulk-expand-toggle-label {\n  @media (max-width: 1100px) {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0;\n  }\n}\n\n.event-planner-view__header-title-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n\n  h2 {\n    margin: 0;\n    min-width: 0;\n    flex: 1;\n    overflow: hidden;\n    color: $pure-white;\n    font-size: 1.15rem;\n    font-weight: 600;\n    line-height: 1.35;\n    text-align: left;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n.event-planner-view__header-actions-column {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.35rem;\n}\n\n.event-planner-view__header-actions {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.event-planner-view__header-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.38rem;\n  margin: 0;\n  padding: 0.42rem 0.78rem;\n  border: 1px solid rgba($accent-blue, 0.42);\n  border-radius: 8px;\n  background: rgba($dark-panel-blue, 0.72);\n  color: $very-light-grey;\n  font-family: inherit;\n  font-size: 0.72rem;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  cursor: pointer;\n  box-shadow: inset 0 1px 0 rgba($pure-white, 0.04);\n  transition:\n    background 160ms ease,\n    border-color 160ms ease,\n    color 160ms ease,\n    box-shadow 160ms ease;\n\n  &:hover:not(:disabled) {\n    border-color: rgba($light-blue, 0.55);\n    background: rgba($blue-grey, 0.88);\n    color: $pure-white;\n  }\n\n  &:active:not(:disabled) {\n    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.28);\n  }\n\n  &:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n  }\n}\n\n.event-planner-view__header-action-btn--publish {\n  border-color: rgba($light-blue, 0.48);\n  background: rgba($blue, 0.58);\n  color: $pure-white;\n\n  &:hover:not(:disabled) {\n    border-color: rgba($light-blue, 0.72);\n    background: rgba($blue, 0.78);\n    color: $pure-white;\n  }\n\n  &.is-published {\n    border-color: rgba($light-green, 0.58);\n    background: rgba($light-green, 0.14);\n    color: $light-green;\n\n    &:hover:not(:disabled) {\n      border-color: $light-green;\n      background: rgba($light-green, 0.22);\n      color: $light-green;\n    }\n  }\n}\n\n.event-planner-view__header-action-btn--back {\n  background: rgba($dark-blue, 0.55);\n}\n\n.event-planner-view__header-action-btn-icon {\n  flex-shrink: 0;\n  width: 0.9rem;\n  height: 0.9rem;\n}\n\n.event-planner-view__header-close-btn {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  margin: 0;\n  padding: 0;\n  border: 1px solid rgba($accent-blue, 0.28);\n  border-radius: 8px;\n  color: $medium-light-grey;\n  background: rgba($dark-panel-blue, 0.45);\n  font-family: inherit;\n  font-size: 1.25rem;\n  font-weight: 400;\n  line-height: 1;\n  cursor: pointer;\n  transition:\n    background 160ms ease,\n    border-color 160ms ease,\n    color 160ms ease;\n\n  &:hover {\n    border-color: rgba($light-blue, 0.45);\n    background: rgba($blue-grey, 0.75);\n    color: $pure-white;\n  }\n\n  &:active {\n    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.28);\n  }\n}\n\n.event-planner-view__team-tags {\n  position: relative;\n  align-self: flex-end;\n}\n\n.event-planner-view__team-tags-toggle {\n  border-color: rgba($accent-blue, 0.38);\n  background: rgba($dark-panel-blue, 0.62);\n\n  &:hover:not(:disabled) {\n    border-color: rgba($light-blue, 0.55);\n    background: rgba($blue-grey, 0.82);\n  }\n}\n\n.event-planner-view__team-tags-toggle-icon {\n  flex-shrink: 0;\n  width: 0.82rem;\n  height: 0.82rem;\n  color: $light-blue;\n}\n\n.event-planner-view__team-tags-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.1rem;\n  padding: 0.05rem 0.32rem;\n  border-radius: 999px;\n  background: rgba($light-blue, 0.2);\n  color: $very-light-grey;\n  font-size: 0.62rem;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.event-planner-view__team-tags-panel {\n  position: absolute;\n  top: calc(100% + 0.35rem);\n  right: 0;\n  z-index: 60;\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  width: unquote('min(22rem, calc(100vw - 2rem))');\n  padding: 0.85rem;\n  border: 1px solid rgba($accent-blue, 0.45);\n  border-radius: 12px;\n  background: linear-gradient(\n    180deg,\n    rgba($blue-grey, 0.98),\n    rgba($dark-panel-blue, 0.98)\n  );\n  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.48);\n}\n\n.event-planner-view__team-tags-panel-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.event-planner-view__team-tags-eyebrow {\n  margin: 0 0 0.15rem;\n  color: $light-blue;\n  font-size: 0.62rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.event-planner-view__team-tags-title {\n  margin: 0;\n  color: $pure-white;\n  font-size: 0.95rem;\n  font-weight: 600;\n  line-height: 1.25;\n}\n\n.event-planner-view__team-tags-panel-count {\n  flex-shrink: 0;\n  padding: 0.2rem 0.5rem;\n  border-radius: 999px;\n  border: 1px solid rgba($accent-blue, 0.35);\n  background: rgba($dark-panel-blue, 0.72);\n  color: $medium-light-grey;\n  font-size: 0.64rem;\n  white-space: nowrap;\n}\n\n.event-planner-view__team-tags-hint {\n  margin: 0;\n  color: $medium-light-grey;\n  font-size: 0.68rem;\n  line-height: 1.45;\n}\n\n.event-planner-view__team-tags-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  max-height: 14rem;\n  margin: 0;\n  padding: 0;\n  overflow: auto;\n  list-style: none;\n  @include org-members-mgmt-general-thin-scrollbar;\n}\n\n.event-planner-view__team-tags-empty {\n  padding: 0.55rem 0.65rem;\n  border: 1px dashed rgba($accent-blue, 0.28);\n  border-radius: 8px;\n  color: $medium-light-grey;\n  font-size: 0.72rem;\n  text-align: center;\n}\n\n.event-planner-view__team-tags-item {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.2rem;\n  border-radius: 8px;\n  background: rgba($dark-panel-blue, 0.55);\n  border: 1px solid rgba($accent-blue, 0.22);\n}\n\n.event-planner-view__team-tags-label {\n  flex: 1;\n  min-width: 0;\n  margin: 0;\n  padding: 0.35rem 0.45rem;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: $very-light-grey;\n  font-family: inherit;\n  font-size: 0.74rem;\n  font-weight: 500;\n  line-height: 1.3;\n  text-align: left;\n  cursor: pointer;\n  transition: background 160ms ease, color 160ms ease;\n\n  &:hover:not(:disabled) {\n    background: rgba($blue, 0.22);\n    color: $pure-white;\n  }\n\n  &:disabled {\n    cursor: default;\n  }\n}\n\n.event-planner-view__team-tag-input {\n  flex: 1;\n  min-width: 0;\n  margin: 0;\n  padding: 0.35rem 0.45rem;\n  border: 1px solid rgba($light-blue, 0.45);\n  border-radius: 6px;\n  background: rgba($very-dark-grey, 0.55);\n  color: $pure-white;\n  font-family: inherit;\n  font-size: 0.74rem;\n  line-height: 1.3;\n\n  &:focus {\n    outline: none;\n    border-color: rgba($light-blue, 0.72);\n    box-shadow: 0 0 0 2px rgba($light-blue, 0.18);\n  }\n}\n\n.event-planner-view__team-tags-delete {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  width: 1.6rem;\n  height: 1.6rem;\n  margin: 0;\n  padding: 0;\n  border: 1px solid rgba($red, 0.28);\n  border-radius: 6px;\n  background: rgba($red, 0.08);\n  color: $bright-red;\n  font-family: inherit;\n  font-size: 1rem;\n  line-height: 1;\n  cursor: pointer;\n  transition:\n    background 160ms ease,\n    border-color 160ms ease,\n    color 160ms ease;\n\n  &:hover:not(:disabled) {\n    border-color: rgba($red, 0.55);\n    background: rgba($red, 0.18);\n    color: $pure-white;\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.event-planner-view__team-tags-add-row {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.event-planner-view__team-tags-add-btn {\n  flex-shrink: 0;\n  margin: 0;\n  padding: 0.38rem 0.72rem;\n  border: 1px solid rgba($light-blue, 0.45);\n  border-radius: 8px;\n  background: rgba($blue, 0.42);\n  color: $pure-white;\n  font-family: inherit;\n  font-size: 0.7rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition:\n    background 160ms ease,\n    border-color 160ms ease;\n\n  &:hover:not(:disabled) {\n    border-color: rgba($light-blue, 0.72);\n    background: rgba($blue, 0.62);\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.event-planner-view__team-tags-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.45rem;\n  padding-top: 0.15rem;\n  border-top: 1px solid rgba($accent-blue, 0.22);\n}\n\n.event-planner-view__team-tags-save-btn {\n  margin: 0;\n  padding: 0.4rem 0.85rem;\n  border: 1px solid rgba($light-green, 0.45);\n  border-radius: 8px;\n  background: rgba($light-green, 0.14);\n  color: $light-green;\n  font-family: inherit;\n  font-size: 0.7rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition:\n    background 160ms ease,\n    border-color 160ms ease,\n    color 160ms ease;\n\n  &:hover:not(:disabled) {\n    border-color: $light-green;\n    background: rgba($light-green, 0.24);\n    color: $pure-white;\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.event-planner-view__team-tags-status {\n  margin: 0;\n  color: $light-green;\n  font-size: 0.68rem;\n}\n\n.event-planner-view__team-tags-status--error {\n  color: $bright-red;\n}\n\n.event-planner-view__anchor-tag-menu {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.event-planner-view__anchor-tag-toggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.2rem;\n  margin: 0;\n  padding: 0.18rem 0.34rem;\n  border: 1px solid rgba($accent-blue, 0.32);\n  border-radius: 6px;\n  background: rgba($dark-panel-blue, 0.55);\n  color: $light-blue;\n  font-family: inherit;\n  font-size: 0.58rem;\n  font-weight: 600;\n  line-height: 1;\n  cursor: pointer;\n  transition:\n    background 160ms ease,\n    border-color 160ms ease,\n    color 160ms ease,\n    box-shadow 160ms ease;\n\n  &:hover {\n    border-color: rgba($light-blue, 0.55);\n    background: rgba($blue, 0.28);\n    color: $pure-white;\n  }\n\n  &.is-active {\n    border-color: rgba($light-orange, 0.72);\n    background: rgba($orange, 0.28);\n    color: $very-light-yellow;\n    box-shadow: 0 0 0 1px rgba($light-orange, 0.18);\n\n    .event-planner-view__anchor-tag-toggle-icon {\n      color: $light-orange;\n    }\n\n    &:hover {\n      border-color: $light-orange;\n      background: rgba($dark-orange, 0.42);\n      color: $very-light-orange;\n      box-shadow: 0 0 0 1px rgba($light-orange, 0.28);\n    }\n  }\n}\n\n.event-planner-view__anchor-tag-menu.is-open {\n  .event-planner-view__anchor-tag-toggle.is-active {\n    border-color: $light-orange;\n    background: rgba($dark-orange, 0.5);\n    color: $very-light-orange;\n  }\n}\n\n.event-planner-view__anchor-tag-toggle-icon {\n  width: 0.72rem;\n  height: 0.72rem;\n}\n\n.event-planner-view__anchor-tag-toggle-label {\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n}\n\n.event-planner-view__anchor-tag-picker {\n  position: absolute;\n  top: calc(100% + 0.25rem);\n  right: 0;\n  z-index: 40;\n  min-width: 9.5rem;\n  max-width: 14rem;\n  max-height: 11rem;\n  margin: 0;\n  padding: 0.28rem;\n  overflow: auto;\n  list-style: none;\n  border-radius: 8px;\n  border: 1px solid rgba($accent-blue, 0.45);\n  background: linear-gradient(\n    180deg,\n    rgba($blue-grey, 0.98),\n    rgba($dark-panel-blue, 0.98)\n  );\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.42);\n  @include org-members-mgmt-general-thin-scrollbar;\n}\n\n.event-planner-view__anchor-tag-picker-divider {\n  height: 1px;\n  margin: 0.22rem 0.35rem;\n  background: rgba($accent-blue, 0.28);\n}\n\n.event-planner-view__anchor-tag-picker-empty {\n  padding: 0.45rem 0.5rem;\n  color: $medium-light-grey;\n  font-size: 0.64rem;\n  line-height: 1.35;\n}\n\n.event-planner-view__anchor-tag-picker-option {\n  display: flex;\n  align-items: center;\n  gap: 0.38rem;\n  width: 100%;\n  margin: 0;\n  padding: 0.38rem 0.45rem;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: $very-light-grey;\n  font-family: inherit;\n  font-size: 0.68rem;\n  font-weight: 500;\n  text-align: left;\n  cursor: pointer;\n  transition:\n    background 160ms ease,\n    border-color 160ms ease,\n    color 160ms ease,\n    box-shadow 160ms ease;\n\n  &:hover:not(:disabled) {\n    background: rgba($blue, 0.28);\n    color: $pure-white;\n  }\n\n  &:disabled {\n    cursor: default;\n  }\n}\n\n.event-planner-view__anchor-tag-picker-option-indicator {\n  flex-shrink: 0;\n  width: 0.48rem;\n  height: 0.48rem;\n  border: 1px solid rgba($medium-light-grey, 0.45);\n  border-radius: 999px;\n  background: transparent;\n  transition:\n    background 160ms ease,\n    border-color 160ms ease,\n    box-shadow 160ms ease;\n}\n\n.event-planner-view__anchor-tag-picker-option-label {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.event-planner-view__anchor-tag-picker-option--active {\n  border: 1px solid rgba($light-orange, 0.42);\n  background: linear-gradient(\n    90deg,\n    rgba($dark-orange, 0.42),\n    rgba($orange, 0.18)\n  );\n  color: $very-light-orange;\n  box-shadow: inset 0 1px 0 rgba($very-light-yellow, 0.12);\n\n  .event-planner-view__anchor-tag-picker-option-indicator {\n    border-color: $light-orange;\n    background: radial-gradient(circle at center, $light-orange 0%, $orange 72%);\n    box-shadow: 0 0 0 2px rgba($light-orange, 0.18);\n  }\n\n  &:hover:not(:disabled) {\n    border-color: rgba($light-orange, 0.72);\n    background: linear-gradient(\n      90deg,\n      rgba($dark-orange, 0.55),\n      rgba($orange, 0.28)\n    );\n    color: $very-light-yellow;\n  }\n}\n\n.event-planner-view__anchor-tag-menu--fighter-vehicle {\n  margin-left: auto;\n}\n\n.event-planner-view__header-date {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin: 0;\n  color: $medium-light-grey;\n  font-size: 0.84rem;\n  text-align: left;\n}\n\n.event-planner-view__header-date-icon {\n  flex-shrink: 0;\n  width: 0.95rem;\n  height: 0.95rem;\n  color: $light-blue;\n}\n\n.is-planner-dimmed {\n  opacity: 0.34;\n  filter: blur(1.4px);\n  transition: opacity 0.18s ease, filter 0.18s ease, border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.event-planner-view__participant-chip.is-missing-vehicle {\n  opacity: 0.48;\n  filter: grayscale(0.7);\n  transition: opacity 0.18s ease, filter 0.18s ease;\n}\n\n.event-planner-view__team.is-planner-highlighted,\n.event-planner-view__variant-group.is-planner-highlighted,\n.event-planner-view__convoy-group.is-planner-highlighted,\n.event-planner-view__convoy-vehicle.is-planner-highlighted,\n.event-planner-view__ground-vehicle-standalone.is-planner-highlighted {\n  border-color: $light-orange !important;\n  box-shadow: 0 0 0 2px rgba($light-orange, 0.5) !important;\n}\n\n.event-planner-view__special-group.is-planner-highlighted {\n  border-color: $light-orange !important;\n  box-shadow: 0 0 0 2px rgba($light-orange, 0.5) !important;\n  background: rgba($light-orange, 0.12) !important;\n}\n\n.event-planner-view__officers {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  gap: 0.45rem;\n}\n\n.event-planner-view__officer {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  min-width: stretch;\n  padding: 0.25rem 0.4rem;\n  border: 1px solid rgba($accent-blue, 0.38);\n  border-radius: 8px;\n  background: rgba($panel-blue, 0.72);\n}\n\n.event-planner-view__officer-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  color: $medium-light-grey;\n  font-size: 0.64rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.event-planner-view__officer-label-icon {\n  width: 0.72rem;\n  height: 0.72rem;\n  color: $light-blue;\n}\n\n.event-planner-view__status {\n  margin: 1.75rem 0;\n  text-align: center;\n  color: $light-grey;\n}\n\n.event-planner-view__status--error {\n  color: $very-light-orange;\n}\n\n.event-planner-view__layout {\n  display: grid;\n  grid-template-columns: 240px minmax(0, 1fr) 300px;\n  gap: 0.65rem;\n  min-height: 520px;\n}\n\n.event-planner-view__sidebar,\n.event-planner-view__panel {\n  min-width: 0;\n  padding: 0.65rem 0.75rem;\n  border: 1px solid rgba($accent-blue, 0.38);\n  border-radius: 10px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);\n}\n\n.event-planner-view__panel {\n  background:\n    linear-gradient(180deg, rgba($panel-blue, 0.94), rgba($dark-panel-blue, 0.82)),\n    rgba($dark-blue, 0.65);\n}\n\n.event-planner-view__sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  max-height: calc(100vh - 260px);\n  overflow: hidden;\n  background:\n    linear-gradient(180deg, rgba($blue-grey, 0.88), rgba($dark-panel-blue, 0.92)),\n    rgba($dark-blue, 0.65);\n}\n\n.event-planner-view__panel-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.65rem;\n  margin-bottom: 0.45rem;\n  padding-bottom: 0.45rem;\n  border-bottom: 1px solid rgba($accent-blue, 0.24);\n\n  h3 {\n    margin: 0;\n    color: $pure-white;\n    font-size: 0.9rem;\n    font-weight: 600;\n  }\n}\n\n.event-planner-view__panel-header-end {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.45rem;\n}\n\n.event-planner-view__panel-header-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.event-planner-view__bulk-expand-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  padding: 0.22rem 0.45rem;\n  border-radius: 6px;\n  border: 1px solid rgba($pure-white, 0.18);\n  background: rgba(0, 0, 0, 0.25);\n  color: $very-light-grey;\n  font-size: 0.68rem;\n  line-height: 1.2;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background 160ms ease, border-color 160ms ease, color 160ms ease;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.38);\n    border-color: $light-grey;\n    color: $pure-white;\n  }\n}\n\n.event-planner-view__bulk-expand-btn-icon {\n  display: block;\n  width: 12px;\n  height: 12px;\n  object-fit: contain;\n  opacity: 0.95;\n}\n\n.event-planner-view__panel-heading,\n.event-planner-view__panel-header-title {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  min-width: 0;\n}\n\n.event-planner-view__panel-icon {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  width: 1.65rem;\n  height: 1.65rem;\n  border: 1px solid rgba($light-blue, 0.28);\n  border-radius: 7px;\n  color: $light-blue;\n  background: rgba($blue, 0.28);\n\n  svg {\n    width: 0.95rem;\n    height: 0.95rem;\n  }\n}\n\n.event-planner-view__panel-header--roster {\n  .event-planner-view__panel-header-row {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.45rem;\n    width: 100%;\n  }\n\n  .event-planner-view__panel-header-title {\n    h3 {\n      min-width: 0;\n    }\n  }\n\n  .event-planner-view__officers {\n    flex-shrink: 0;\n    margin-left: 0;\n  }\n}\n\n.event-planner-view__search-field {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin-bottom: 0.45rem;\n  padding: 0.28rem 0.45rem;\n  border: 1px solid rgba($accent-blue, 0.38);\n  border-radius: 8px;\n  background: rgba($dark-blue, 0.55);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n  &:focus-within {\n    border-color: rgba($light-blue, 0.65);\n    box-shadow: 0 0 0 2px rgba($accent-blue, 0.12);\n  }\n}\n\n.event-planner-view__participant-search {\n  flex-shrink: 0;\n}\n\n.event-planner-view__search-icon {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  color: $medium-light-grey;\n\n  svg {\n    width: 0.9rem;\n    height: 0.9rem;\n  }\n}\n\n.event-planner-view__search-input {\n  width: 100%;\n  min-width: 0;\n  padding: 0;\n  border: 0;\n  outline: none;\n  color: $very-light-grey;\n  background: transparent;\n  font-family: inherit;\n  font-size: 0.8rem;\n\n  &::placeholder {\n    color: rgba($medium-light-grey, 0.85);\n  }\n}\n\n.event-planner-view__deployment-stats {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.45rem 0.75rem;\n  margin-bottom: 0.45rem;\n  padding: 0.35rem 0.45rem;\n  border: 1px solid rgba($accent-blue, 0.22);\n  border-radius: 8px;\n  background: rgba($dark-panel-blue, 0.45);\n}\n\n.event-planner-view__deployment-stat {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  color: $medium-light-grey;\n  font-size: 0.72rem;\n  white-space: nowrap;\n}\n\n.event-planner-view__deployment-stat-icon {\n  width: 0.78rem;\n  height: 0.78rem;\n  color: $light-blue;\n}\n\n.event-planner-view__eyebrow {\n  margin: 0 0 0.25rem;\n  color: $medium-light-grey;\n  font-size: 0.68rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.event-planner-view__count-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 1.65rem;\n  padding: 0.15rem 0.55rem;\n  border: 1px solid rgba($light-blue, 0.28);\n  border-radius: 999px;\n  color: $light-blue;\n  background: rgba($blue, 0.42);\n  font-family: 'FiraCode', monospace;\n  font-size: 0.72rem;\n  white-space: nowrap;\n}\n\n.event-planner-view__special-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  padding-bottom: 0.55rem;\n  border-bottom: 1px solid rgba($accent-blue, 0.24);\n}\n\n.event-planner-view__special-group,\n.event-planner-view__vehicle-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.45rem;\n  width: 100%;\n  padding: 0.45rem 0.55rem;\n  border: 1px solid rgba($accent-blue, 0.24);\n  border-radius: 8px;\n  color: $very-light-grey;\n  background: rgba($dark-panel-blue, 0.72);\n  text-align: left;\n  cursor: grab;\n  touch-action: none;\n  user-select: none;\n  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;\n\n  &:hover:not(:disabled) {\n    border-color: rgba($light-blue, 0.42);\n    background: rgba($blue-grey, 0.82);\n    color: $pure-white;\n  }\n\n  &:active:not(:disabled) {\n    cursor: grabbing;\n  }\n\n  &:disabled,\n  &.is-unavailable {\n    opacity: 0.42;\n    cursor: not-allowed;\n  }\n\n  &.is-dragging {\n    opacity: 0;\n  }\n\n  &.is-planner-highlighted {\n    border-color: $light-orange !important;\n    box-shadow: 0 0 0 2px rgba($light-orange, 0.5) !important;\n    background: rgba($light-orange, 0.12) !important;\n  }\n\n  &.is-planner-highlighted:hover:not(:disabled) {\n    border-color: $light-orange !important;\n    box-shadow: 0 0 0 2px rgba($light-orange, 0.62) !important;\n  }\n}\n\n.event-planner-view__participant-chip {\n  width: 100%;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  background: rgba($very-light-grey, 0.07);\n  border: 2px solid transparent;\n  border-radius: 10px;\n  padding: 1px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n  &.is-planner-highlighted {\n    border-color: $light-orange;\n    box-shadow: 0 0 0 1px rgba($light-orange, 0.45);\n  }\n\n  &--overlay {\n    width: auto;\n    min-width: 12rem;\n    background: rgba($dark-panel-blue, 0.96);\n  }\n}\n\n.event-planner-view__participant-meta {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.32rem;\n  min-width: 0;\n  padding: 0 0.35rem 0.28rem;\n}\n\n.event-planner-view__participant-section {\n  display: inline-flex;\n  align-self: flex-start;\n  align-items: center;\n  max-width: 100%;\n  min-height: 1.35rem;\n  padding: 0.08rem 0.45rem;\n  border: 1px solid rgba($light-blue, 0.28);\n  border-radius: 999px;\n  color: $light-blue;\n  background: rgba($blue, 0.32);\n  font-size: 0.68rem;\n  line-height: 1.25;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.event-planner-view__participant-guest {\n  display: inline-flex;\n  align-self: flex-start;\n  align-items: center;\n  max-width: 100%;\n  min-height: 1.15rem;\n  padding: 0rem 0.55rem;\n  border: 1px solid rgba($light-orange, 0.55);\n  border-radius: 999px;\n  color: $very-light-orange;\n  background: rgba($orange, 0.42);\n  font-size: 0.58rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  line-height: 1.25;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.event-planner-view__participant-tags-trigger {\n  position: relative;\n  flex-shrink: 0;\n  margin: 0px 0px 0px auto;\n}\n\n.event-planner-view__participant-tags-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.35rem;\n  height: 1.35rem;\n  padding: 0;\n  border: 1px solid rgba($light-blue, 0.28);\n  border-radius: 6px;\n  color: $light-blue;\n  background: rgba($blue, 0.22);\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;\n\n  &:hover,\n  &.is-open {\n    border-color: rgba($light-blue, 0.5);\n    background: rgba($blue, 0.38);\n    color: $very-light-grey;\n  }\n}\n\n.event-planner-view__participant-tags-btn-icon {\n  width: 0.72rem;\n  height: 0.72rem;\n}\n\n.event-planner-view__participant-tags-tooltip {\n  position: absolute;\n  left: 50%;\n  bottom: calc(100% + 6px);\n  z-index: 12;\n  min-width: 7.5rem;\n  max-width: 14rem;\n  padding: 0.38rem 0.42rem;\n  border: 1px solid rgba($accent-blue, 0.45);\n  border-radius: 8px;\n  background: rgba($panel-blue, 0.98);\n  box-shadow:\n    0 8px 22px rgba(0, 0, 0, 0.45),\n    0 0 0 1px rgba(0, 0, 0, 0.18);\n  transform: translateX(-50%);\n}\n\n.event-planner-view__participant-tags-tooltip-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.28rem;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.event-planner-view__participant-tags-tooltip-item {\n  margin: 0;\n  list-style: none;\n}\n\n.event-planner-view__participant-tag {\n  display: inline-flex;\n  align-items: center;\n  min-height: 1.3rem;\n  padding: 0.08rem 0.42rem;\n  border: 1px solid rgba($accent-blue, 0.4);\n  border-radius: 999px;\n  color: rgba($very-light-grey, 0.96);\n  background: rgba($dark-panel-blue, 0.72);\n  font-size: 0.66rem;\n  line-height: 1.25;\n}\n\n.event-planner-view__participant-tag--inactive {\n  border-style: dashed;\n  opacity: 0.65;\n}\n\n.event-planner-view__item-icon {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  width: 1.45rem;\n  height: 1.45rem;\n  border-radius: 6px;\n  color: $light-blue;\n  background: rgba($blue, 0.28);\n\n  svg {\n    width: 0.85rem;\n    height: 0.85rem;\n  }\n}\n\n.event-planner-view__special-group-label {\n  flex: 1;\n  min-width: 0;\n  font-weight: 600;\n}\n\n.event-planner-view__drag-hint {\n  flex-shrink: 0;\n  width: 0.72rem;\n  height: 0.72rem;\n  margin-left: auto;\n  color: rgba($medium-light-grey, 0.75);\n}\n\n.event-planner-view__vehicle-item-body {\n  flex: 1;\n  min-width: 0;\n}\n\n.event-planner-view__vehicle-item-leading {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  width: 1.45rem;\n  height: 1.45rem;\n  margin-top: 0.05rem;\n  border-radius: 6px;\n  color: $light-blue;\n  background: rgba($blue, 0.28);\n\n  svg {\n    width: 0.85rem;\n    height: 0.85rem;\n  }\n}\n\n.event-planner-view__drag-overlay {\n  cursor: grabbing;\n  pointer-events: none;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);\n}\n\n.event-planner-view__vehicle-main {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.65rem;\n}\n\n.event-planner-view__vehicle-name {\n  min-width: 0;\n  overflow: hidden;\n  font-weight: 600;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.event-planner-view__vehicle-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.28rem;\n  padding: 0.4rem 0.45rem;\n  border: 1px solid rgba($accent-blue, 0.24);\n  border-radius: 8px;\n  background: rgba($dark-panel-blue, 0.55);\n\n  &.is-planner-highlighted {\n    border-color: $light-orange !important;\n    box-shadow: 0 0 0 2px rgba($light-orange, 0.5) !important;\n    background: rgba($light-orange, 0.12) !important;\n  }\n}\n\n.event-planner-view__vehicle-group-header {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n}\n\n.event-planner-view__vehicle-instances {\n  display: flex;\n  flex-direction: column;\n  gap: 0.22rem;\n  padding-left: 1.9rem;\n}\n\n.event-planner-view__vehicle-instance {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  width: 100%;\n  padding: 0.32rem 0.45rem;\n  border: 1px solid rgba($accent-blue, 0.2);\n  border-radius: 6px;\n  color: $very-light-grey;\n  background: rgba($dark-panel-blue, 0.82);\n  text-align: left;\n  cursor: grab;\n  touch-action: none;\n  user-select: none;\n  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;\n\n  &:hover {\n    border-color: rgba($light-blue, 0.42);\n    background: rgba($blue-grey, 0.82);\n    color: $pure-white;\n  }\n\n  &:active {\n    cursor: grabbing;\n  }\n\n  &.is-dragging {\n    opacity: 0;\n  }\n\n  &.is-planner-highlighted {\n    border-color: $light-orange !important;\n    box-shadow: 0 0 0 2px rgba($light-orange, 0.5) !important;\n    background: rgba($light-orange, 0.12) !important;\n  }\n}\n\n.event-planner-view__vehicle-instance-label {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  font-size: 0.74rem;\n  font-weight: 600;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.event-planner-view__vehicle-owners {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  margin-top: 0.35rem;\n  color: $medium-light-grey;\n  font-size: 0.72rem;\n}\n\n.event-planner-view__vehicle-toolbar {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  margin-bottom: 0.45rem;\n}\n\n.event-planner-view__vehicle-search-field {\n  margin-bottom: 0;\n}\n\n.event-planner-view__vehicle-size-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.event-planner-view__vehicle-size-filter {\n  padding: 0.28rem 0.55rem;\n  border: 1px solid rgba($accent-blue, 0.28);\n  border-radius: 999px;\n  color: rgba($very-light-grey, 0.82);\n  background: rgba($dark-panel-blue, 0.72);\n  font-family: inherit;\n  font-size: 0.68rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: capitalize;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;\n\n  &:hover {\n    border-color: rgba($light-blue, 0.42);\n    color: $pure-white;\n    background: rgba($blue-grey, 0.72);\n  }\n\n  &.is-active {\n    border-color: rgba($light-blue, 0.55);\n    color: $light-blue;\n    background: rgba($blue, 0.42);\n  }\n}\n\n.event-planner-view__vehicle-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  border-radius: 8px;\n  transition: border-color 0.15s ease, background-color 0.15s ease;\n  @include event-planner-scrollbar;\n\n  &.is-over {\n    outline: 1px dashed rgba($light-blue, 0.45);\n    background: rgba($blue-grey, 0.22);\n  }\n}\n\n.event-planner-view__participant-pool {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n  max-height: calc(100vh - 260px);\n  background:\n    linear-gradient(180deg, rgba($light-panel-blue, 0.58), rgba($panel-blue, 0.78)),\n    rgba($dark-blue, 0.65);\n  transition: border-color 0.15s ease, background-color 0.15s ease;\n\n  &.is-over {\n    border-color: rgba($light-blue, 0.55);\n    background:\n      linear-gradient(180deg, rgba($blue-grey, 0.72), rgba($panel-blue, 0.82)),\n      rgba($dark-blue, 0.65);\n  }\n}\n\n.event-planner-view__participant-list,\n.event-planner-view__position {\n  .user-discord-rank--draggable {\n    cursor: grab;\n    touch-action: none;\n    user-select: none;\n\n    &:active {\n      cursor: grabbing;\n    }\n\n    &.is-dragging {\n      opacity: 0;\n    }\n  }\n}\n\n.event-planner-view__participant-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  @include event-planner-scrollbar;\n\n  .user-discord-rank--draggable {\n    min-width: 0;\n    max-width: 100%;\n  }\n\n  p {\n    margin: 0;\n    color: $medium-light-grey;\n    font-size: 0.85rem;\n  }\n}\n\n.event-planner-view__fleet {\n  min-height: 430px;\n  min-width: 0;\n  max-height: calc(100vh - 258px);\n  background:\n    linear-gradient(180deg, rgba($panel-blue, 0.88), rgba($dark-panel-blue, 0.72)),\n    rgba($dark-blue, 0.65);\n  transition: border-color 0.15s ease, background-color 0.15s ease;\n  overflow-y: auto;\n  @include event-planner-scrollbar;\n\n  &.is-over {\n    border-color: rgba($light-blue, 0.55);\n    background:\n      linear-gradient(180deg, rgba($blue-grey, 0.68), rgba($panel-blue, 0.78)),\n      rgba($dark-blue, 0.65);\n  }\n}\n\n.event-planner-view__fleet-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n  min-height: 260px;\n  padding: 0.65rem;\n  color: $medium-light-grey;\n  border: 1px dashed rgba($accent-blue, 0.32);\n  border-radius: 10px;\n  background: rgba($dark-panel-blue, 0.45);\n  font-size: 0.82rem;\n  text-align: center;\n\n  p {\n    margin: 0;\n  }\n}\n\n.event-planner-view__fleet-empty-icon {\n  width: 1.25rem;\n  height: 1.25rem;\n  color: $light-blue;\n}\n\n.event-planner-view__team-grid {\n  --event-planner-card-gap: 4.5rem;\n  container-type: inline-size;\n  position: relative;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  gap: var(--event-planner-card-gap);\n  width: 100%;\n  min-width: 0;\n}\n\n.event-planner-view__fleet-canvas {\n  position: relative;\n  min-width: 0;\n}\n\n.event-planner-view__card-links-layer {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  overflow: visible;\n}\n\n.event-planner-view__card-links {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  overflow: visible;\n\n  &--visual {\n    z-index: 1;\n  }\n\n  &--interactive {\n    z-index: 3;\n    pointer-events: none;\n  }\n}\n\n.event-planner-view__card-link-path-hit {\n  fill: none;\n  stroke: transparent;\n  stroke-width: 16;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  pointer-events: stroke;\n  cursor: pointer;\n\n  &.is-selected {\n    stroke: rgba($light-blue, 0.12);\n  }\n}\n\n.event-planner-view__card-link-path {\n  fill: none;\n  stroke: rgba($light-blue, 0.88);\n  stroke-width: 3;\n  stroke-dasharray: 8 5;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  pointer-events: none;\n\n  &.is-highlighted,\n  &.is-selected {\n    stroke: rgba($very-light-yellow, 0.98);\n    stroke-width: 3;\n    stroke-dasharray: none;\n  }\n}\n\n.event-planner-view__card-link-arrow {\n  fill: rgba($light-blue, 0.88);\n  stroke: none;\n  pointer-events: none;\n\n  &.is-highlighted,\n  &.is-selected {\n    fill: rgba($very-light-yellow, 0.98);\n  }\n}\n\n.event-planner-view__card-link-attach {\n  fill: rgba($dark-panel-blue, 0.95);\n  stroke: rgba($light-blue, 0.9);\n  stroke-width: 2;\n  pointer-events: none;\n\n  &.is-highlighted {\n    fill: rgba($blue-grey, 0.95);\n    stroke: rgba($very-light-yellow, 0.95);\n    stroke-width: 2.5;\n  }\n}\n\n.event-planner-view__card-link-delete-wrap {\n  pointer-events: auto;\n}\n\n.event-planner-view__card-link-delete {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.35rem;\n  height: 1.35rem;\n  margin: 0;\n  padding: 0;\n  border: 1px solid rgba($very-light-orange, 0.85);\n  border-radius: 999px;\n  background: rgba($dark-panel-blue, 0.96);\n  color: $very-light-orange;\n  font-size: 1rem;\n  line-height: 1;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n\n  span {\n    display: block;\n    margin-top: -0.08rem;\n  }\n\n  &:hover {\n    border-color: rgba($very-light-yellow, 0.95);\n    color: $very-light-yellow;\n    background: rgba($blue-grey, 0.98);\n  }\n}\n\n.event-planner-view__card-link-handles {\n  position: absolute;\n  inset: 0;\n  z-index: 3;\n  pointer-events: none;\n}\n\n.event-planner-view__card-link-handle-zone {\n  --event-planner-card-link-handle-zone-size: 30px;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--event-planner-card-link-handle-zone-size);\n  height: var(--event-planner-card-link-handle-zone-size);\n  pointer-events: auto;\n\n  &--top {\n    top: 0;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  &--bottom {\n    bottom: 0;\n    left: 50%;\n    transform: translate(-50%, 50%);\n  }\n\n  &--left {\n    left: 0;\n    top: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  &--right {\n    right: 0;\n    top: 50%;\n    transform: translate(50%, -50%);\n  }\n\n  &:hover .event-planner-view__card-link-handle,\n  &:focus-within .event-planner-view__card-link-handle {\n    opacity: 1;\n    visibility: visible;\n  }\n\n  &:hover .event-planner-view__card-link-handle.is-selected,\n  &:focus-within .event-planner-view__card-link-handle.is-selected {\n    border-color: rgba($very-light-yellow, 0.95);\n    background: rgba($light-blue, 0.35);\n    box-shadow: 0 0 0 2px rgba($very-light-yellow, 0.18);\n  }\n}\n\n.event-planner-view__card-link-handle {\n  flex-shrink: 0;\n  width: 0.82rem;\n  height: 0.82rem;\n  padding: 0;\n  border: 1.5px solid rgba($light-blue, 0.85);\n  border-radius: 999px;\n  background: rgba($dark-panel-blue, 0.35);\n  cursor: grab;\n  touch-action: none;\n  opacity: 0;\n  visibility: hidden;\n  transition:\n    opacity 0.14s ease,\n    visibility 0.14s ease,\n    border-color 0.14s ease,\n    background-color 0.14s ease;\n\n  &:hover {\n    border-color: rgba($very-light-yellow, 0.95);\n    background: rgba($blue-grey, 0.55);\n  }\n\n  &.is-dragging {\n    opacity: 0.45;\n    visibility: visible;\n    cursor: grabbing;\n  }\n}\n\n.event-planner-view__team.is-card-link-selected,\n.event-planner-view__variant-group.is-card-link-selected,\n.event-planner-view__convoy-group.is-card-link-selected,\n.event-planner-view__convoy-vehicle.is-card-link-selected,\n.event-planner-view__ground-vehicle-standalone.is-card-link-selected {\n  box-shadow: 0 0 0 1px rgba($very-light-yellow, 0.45);\n}\n\n.event-planner-view__team-grid-row {\n  display: grid;\n  grid-template-columns: repeat(\n    auto-fit,\n    var(--event-planner-position-column-width)\n  );\n  justify-content: center;\n  align-items: start;\n  gap: var(--event-planner-card-gap);\n  min-width: 0;\n  position: relative;\n  z-index: 2;\n\n  > .event-planner-view__team.is-expanded {\n    grid-column: span var(--team-position-columns, 1);\n  }\n\n  > .event-planner-view__variant-group.is-expanded {\n    grid-column: span var(--variant-team-count, 1);\n  }\n\n  > .event-planner-view__convoy-group.is-expanded {\n    grid-column: span var(--convoy-vehicle-count, 1);\n  }\n}\n\n.event-planner-view__variant-group {\n  --variant-team-count: 1;\n  grid-column: span var(--variant-team-count);\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n  min-width: 0;\n  padding: 0.55rem;\n  border-radius: 12px;\n  position: relative;\n  z-index: 2;\n  transition: border-color 0.15s ease, background-color 0.15s ease, filter 0.15s ease;\n\n  &:not([class*=\"mo-structure-card-bg-\"]) {\n    border: 1px solid rgba($light-blue, 0.28);\n    background: rgba($dark-panel-blue, 0.42);\n  }\n\n  &[class*=\"mo-structure-card-bg-\"] {\n    border-width: 1px;\n    border-style: solid;\n  }\n\n  &.is-collapsed {\n    .event-planner-view__variant-group-header,\n    .event-planner-view__variant-group-commander {\n      padding-bottom: 0;\n      border-bottom: 0;\n    }\n  }\n\n  &.is-over:not([class*=\"mo-structure-card-bg-\"]) {\n    border-color: rgba($light-blue, 0.55);\n    background: rgba($blue-grey, 0.72);\n  }\n\n  &.is-over[class*=\"mo-structure-card-bg-\"] {\n    filter: brightness(1.06);\n  }\n\n  &.is-expanded {\n    box-sizing: border-box;\n    width: fit-content;\n    max-width: 100%;\n    justify-self: center;\n  }\n}\n\n.event-planner-view__variant-group-kind {\n  flex-shrink: 0;\n  padding: 0.08rem 0.35rem;\n  border-radius: 999px;\n  border: 1px solid rgba($pure-white, 0.16);\n  background: rgba(0, 0, 0, 0.22);\n  color: $very-light-grey;\n  font-size: 0.62rem;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n}\n\n.event-planner-view__variant-group-commander {\n  padding-bottom: 0.45rem;\n  border-bottom: 1px solid rgba($medium-grey, 0.45);\n}\n\n.event-planner-view__position--group-leader {\n  margin: 0;\n}\n\n.event-planner-view__position--group-leader-readonly {\n  .event-planner-view__position-empty {\n    color: $medium-grey;\n    font-style: italic;\n  }\n}\n\n.event-planner-view__variant-group-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.45rem;\n  padding-bottom: 0.45rem;\n  border-bottom: 1px solid rgba($medium-grey, 0.45);\n}\n\n.event-planner-view__variant-group-title,\n.event-planner-view__convoy-group-title,\n.event-planner-view__group-title {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.35rem;\n  min-width: 0;\n  flex: 1;\n}\n\n.event-planner-view__group-heading {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  min-width: 0;\n  flex: 1 1 auto;\n\n  strong {\n    overflow: hidden;\n    color: $pure-white;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n.event-planner-view__variant-group.is-collapsed,\n.event-planner-view__convoy-group.is-collapsed {\n  .event-planner-view__group-title {\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n  }\n\n  .event-planner-view__group-heading {\n    width: 100%;\n\n    strong {\n      white-space: normal;\n      overflow: visible;\n      text-overflow: unset;\n    }\n  }\n}\n\n.event-planner-view__variant-group-teams {\n  @include event-planner-responsive-team-columns;\n  align-self: center;\n  margin-bottom: 10px;\n\n  > .event-planner-view__team {\n    flex: 0 0 var(--event-planner-position-column-width);\n    box-sizing: border-box;\n    max-width: var(--event-planner-team-max-width, #{$event-planner-team-max-width});\n    min-width: var(--event-planner-position-column-width);\n    width: var(--event-planner-position-column-width);\n\n    &.is-expanded {\n      flex: 0 0 auto;\n      width: calc(\n        var(--team-position-columns, 1) * var(--event-planner-position-column-width) +\n          (var(--team-position-columns, 1) - 1) * var(--event-planner-card-gap, 3rem)\n      );\n      min-width: calc(\n        var(--team-position-columns, 1) * var(--event-planner-position-column-width) +\n          (var(--team-position-columns, 1) - 1) * var(--event-planner-card-gap, 3rem)\n      );\n    }\n  }\n}\n\n.event-planner-view__team--nested {\n  min-width: var(--event-planner-position-column-width, #{$event-planner-team-min-width});\n  max-width: var(--event-planner-team-max-width, #{$event-planner-team-max-width});\n  width: var(--event-planner-position-column-width, #{$event-planner-team-min-width});\n  border-color: rgba($accent-blue, 0.24);\n  background: rgba($panel-blue, 0.72);\n}\n\n.event-planner-view__team {\n  min-width: var(--event-planner-position-column-width, #{$event-planner-team-min-width});\n  max-width: var(--event-planner-team-max-width, #{$event-planner-team-max-width});\n  width: var(--event-planner-position-column-width, #{$event-planner-team-min-width});\n  padding: 0.55rem;\n  box-sizing: border-box;\n  position: relative;\n  z-index: 2;\n\n  &.is-expanded {\n    max-width: none;\n    min-width: 0;\n    width: auto;\n  }\n\n  border-radius: 8px;\n  transition: border-color 0.15s ease, background-color 0.15s ease, filter 0.15s ease;\n\n  &:not([class*=\"mo-structure-card-bg-\"]) {\n    border: 1px solid rgba($accent-blue, 0.38);\n    background: rgba($panel-blue, 0.38);\n  }\n\n  &[class*=\"mo-structure-card-bg-\"] {\n    border-width: 1px;\n    border-style: solid;\n  }\n\n  &.is-over:not([class*=\"mo-structure-card-bg-\"]) {\n    border-color: rgba($light-blue, 0.55);\n    background: rgba($blue-grey, 0.72);\n  }\n\n  &.is-over[class*=\"mo-structure-card-bg-\"] {\n    filter: brightness(1.06);\n  }\n\n  &--command-ship {\n    position: relative;\n    isolation: isolate;\n\n    &:not([class*=\"mo-structure-card-bg-\"]),\n    &[class*=\"mo-structure-card-bg-\"] {\n      border-color: transparent;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      inset: 0;\n      border-radius: inherit;\n      padding: 1.5px;\n      background: linear-gradient(\n        128deg,\n        rgba($very-light-yellow, 0.95) 0%,\n        rgba($light-orange, 0.92) 16%,\n        rgba($very-light-yellow, 0.78) 34%,\n        rgba($pure-white, 0.72) 47%,\n        rgba($very-light-yellow, 0.88) 55%,\n        rgba($light-orange, 0.9) 76%,\n        rgba($very-light-yellow, 0.96) 100%\n      );\n      -webkit-mask:\n        linear-gradient(#fff 0 0) content-box,\n        linear-gradient(#fff 0 0);\n      mask:\n        linear-gradient(#fff 0 0) content-box,\n        linear-gradient(#fff 0 0);\n      -webkit-mask-composite: xor;\n      mask-composite: exclude;\n      pointer-events: none;\n      z-index: 2;\n    }\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      inset: -2px;\n      border-radius: inherit;\n      box-shadow:\n        0 0 14px rgba($light-orange, 0.38),\n        0 0 22px rgba($very-light-yellow, 0.22),\n        inset 0 1px 0 rgba($pure-white, 0.14);\n      pointer-events: none;\n      z-index: 0;\n    }\n\n    &.is-over::after {\n      box-shadow:\n        0 0 18px rgba($light-orange, 0.5),\n        0 0 30px rgba($very-light-yellow, 0.3),\n        inset 0 1px 0 rgba($pure-white, 0.18);\n    }\n  }\n}\n\n.event-planner-view__team-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.45rem;\n  padding-bottom: 0.45rem;\n  border-bottom: 1px solid rgba($medium-grey, 0.65);\n\n  > .event-planner-view__team-title {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.35rem;\n    min-width: 0;\n  }\n\n  .event-planner-view__team-icon {\n    display: inline-flex;\n    flex-shrink: 0;\n    align-items: center;\n    justify-content: center;\n    width: 1.35rem;\n    height: 1.35rem;\n    border-radius: 6px;\n    color: $light-blue;\n    background: rgba($blue, 0.28);\n\n    svg {\n      width: 0.78rem;\n      height: 0.78rem;\n    }\n  }\n\n  strong {\n    overflow: hidden;\n    color: $pure-white;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .event-planner-view__team-stats-card {\n    flex-shrink: 0;\n  }\n\n  &--ship {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.4rem;\n\n    > .event-planner-view__team-title {\n      width: 100%;\n      align-items: center;\n    }\n\n    .event-planner-view__team-header-bottom {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 0.45rem;\n      width: 100%;\n      min-width: 0;\n    }\n\n    .event-planner-view__team-header-status {\n      display: inline-flex;\n      align-items: center;\n      gap: 0.28rem;\n      min-width: 0;\n    }\n\n    .event-planner-view__team-header-actions {\n      flex-shrink: 0;\n      margin-left: auto;\n    }\n  }\n}\n\n.event-planner-view__team-stats-card {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.28rem;\n  flex-shrink: 0;\n}\n\n.event-planner-view__team-stats-with-note {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  flex-shrink: 0;\n}\n\n.event-planner-view__team-stats {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.28rem;\n  flex-shrink: 0;\n  padding: 0.18rem 0.42rem;\n  border-radius: 6px;\n  background: $dark-panel-blue;\n  font-size: 0.72rem;\n  font-weight: 600;\n  white-space: nowrap;\n\n  &--empty .event-planner-view__team-stats-value {\n    color: $red;\n  }\n\n  &--partial .event-planner-view__team-stats-value {\n    color: $very-light-orange;\n  }\n\n  &--full .event-planner-view__team-stats-value {\n    color: $light-green;\n  }\n}\n\n.event-planner-view__team-stats-prefix {\n  font-weight: 500;\n  color: $light-grey;\n}\n\n.event-planner-view__team-stats-value {\n  font-weight: 600;\n}\n\n.event-planner-view__fighter-ship-dot {\n  flex-shrink: 0;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n\n  &--empty {\n    background-color: $red;\n  }\n\n  &--partial {\n    background-color: $light-orange;\n  }\n\n  &--full {\n    background-color: $light-green;\n  }\n}\n\n.event-planner-view__command-note-trigger {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  margin-left: 5px;\n  justify-content: center;\n  width: 1.5rem;\n  height: 1.5rem;\n  padding: 0;\n  border: 1px solid rgba($light-grey, 0.45);\n  border-radius: 5px;\n  background: rgba($dark-panel-blue, 0.85);\n  color: $very-light-grey;\n  cursor: pointer;\n  transition: color 0.15s ease, border-color 0.15s ease, background-color 0.15s ease,\n    box-shadow 0.15s ease;\n\n  &:hover,\n  &.is-active {\n    color: $very-light-grey;\n    border-color: $dark-red;\n    background: rgba($dark-panel-blue, 1);\n    box-shadow: 0 0 0 1px rgba($dark-red, 0.35);\n  }\n\n  &.has-content {\n    color: #ffc084;\n    border-color: rgba(#ffc084, 0.75);\n    background: rgba($dark-panel-blue, 1);\n    box-shadow: 0 0 0 1px rgba($light-orange, 0.25);\n  }\n\n  &.has-content.is-active,\n  &.has-content:hover {\n    color: #ffc084;\n    border-color: rgba(#ffc084, 0.75);\n    box-shadow: 0 0 0 1px rgba($light-orange, 0.45);\n  }\n}\n\n.event-planner-view__command-note-trigger-icon {\n  width: 0.95rem;\n  height: 0.95rem;\n}\n\n.event-planner-view__command-note-tooltip {\n  position: fixed;\n  z-index: 10100;\n  top: var(--tooltip-y, 0);\n  left: var(--tooltip-x, 0);\n}\n\n.event-planner-view__command-note-tooltip-loading {\n  width: 420px;\n  max-width: calc(100vw - 1rem);\n  margin: 0;\n  padding: 0.65rem 0.75rem;\n  color: $light-grey;\n  font-size: 0.75rem;\n  background-color: $grey;\n  border: 1px solid $dark-red;\n  border-radius: 6px;\n}\n\n.event-planner-view__command-note-tooltip-hint {\n  margin: 0 0 0.5rem;\n  padding: 0.45rem 0.55rem;\n  color: $light-grey;\n  font-size: 0.72rem;\n  line-height: 1.35;\n  background-color: rgba($dark-grey, 0.9);\n  border: 1px solid rgba($orange, 0.45);\n  border-radius: 4px;\n}\n\n.event-planner-view__command-note-editor {\n  position: relative;\n  width: 420px;\n  max-width: calc(100vw - 1rem);\n  background-color: $grey;\n  border: 1px solid $dark-red;\n  border-bottom: 4px solid $dark-red;\n  border-radius: 6px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n  overflow: hidden;\n\n  .lexical-versioning-bar {\n    display: none !important;\n  }\n\n  .lexical-side-panels {\n    display: none;\n  }\n\n  .lexical-container {\n    .editor-container {\n      border: 0;\n      background: $grey;\n\n      .editor-input {\n        min-height: 115px;\n        background: $dark-grey;\n        margin: 5px 6px 54px 5px;\n        border: 1px solid $dark-red;\n        border-radius: 6px;\n      }\n    }\n  }\n}\n\n.event-planner-view__command-note-actions {\n  position: absolute;\n  right: 0.55rem;\n  bottom: 0.45rem;\n  z-index: 2;\n}\n\n.event-planner-view__command-note-save {\n  min-width: 6.5rem;\n}\n\n.event-planner-view__team-header-actions {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.event-planner-view__team-header-controls {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  gap: 0.2rem;\n}\n\n.event-planner-view__command-ship-toggle {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  width: 1.5rem;\n  height: 1.5rem;\n  padding: 0;\n  border: 1px solid rgba($light-blue, 0.22);\n  border-radius: 6px;\n  background: rgba($very-dark-grey, 0.85);\n  color: $medium-light-grey;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease;\n\n  &:hover,\n  &:focus-visible {\n    border-color: rgba($very-light-yellow, 0.55);\n    color: $very-light-yellow;\n  }\n\n  &.is-active {\n    border-color: rgba($very-light-yellow, 0.65);\n    background: rgba($very-dark-orange, 0.35);\n    color: $very-light-yellow;\n  }\n}\n\n.event-planner-view__command-ship-toggle-icon {\n  width: 0.82rem;\n  height: 0.82rem;\n}\n\n.event-planner-view__section-picker {\n  position: relative;\n}\n\n.event-planner-view__section-picker-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.28rem;\n  max-width: 8.5rem;\n  padding: 0.2rem 0.4rem;\n  border-radius: 6px;\n  border: 1px solid rgba($pure-white, 0.18);\n  background: rgba(0, 0, 0, 0.25);\n  color: $very-light-grey;\n  font-size: 0.64rem;\n  line-height: 1.2;\n  cursor: pointer;\n  transition: background 160ms ease, border-color 160ms ease, color 160ms ease;\n\n  &:hover,\n  .event-planner-view__section-picker.is-open & {\n    background: rgba(0, 0, 0, 0.38);\n    border-color: $light-grey;\n    color: $pure-white;\n  }\n}\n\n.event-planner-view__section-picker-toggle-icon {\n  flex-shrink: 0;\n  width: 0.85rem;\n  height: 0.85rem;\n}\n\n.event-planner-view__section-picker-toggle-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.event-planner-view__section-picker-menu {\n  position: absolute;\n  top: calc(100% + 0.25rem);\n  right: 0;\n  z-index: 30;\n  min-width: 11rem;\n  max-width: 16rem;\n  max-height: 14rem;\n  margin: 0;\n  padding: 0.28rem;\n  overflow: auto;\n  list-style: none;\n  border-radius: 8px;\n  border: 1px solid rgba($accent-blue, 0.45);\n  background: linear-gradient(\n    180deg,\n    rgba($blue-grey, 0.98),\n    rgba($dark-panel-blue, 0.98)\n  );\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.45);\n}\n\n.event-planner-view__section-picker-option {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  width: 100%;\n  padding: 0.35rem 0.4rem;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: $very-light-grey;\n  font-size: 0.72rem;\n  text-align: left;\n  cursor: pointer;\n  transition: background 140ms ease, color 140ms ease;\n\n  &:hover,\n  &.is-selected {\n    background: rgba($blue, 0.28);\n    color: $pure-white;\n  }\n}\n\n.event-planner-view__section-picker-swatch {\n  flex-shrink: 0;\n  width: 0.85rem;\n  height: 0.85rem;\n  border-radius: 4px;\n  border: 1px solid rgba($pure-white, 0.22);\n\n  &:not([class*=\"mo-structure-card-bg-\"]) {\n    background: rgba($medium-grey, 0.65);\n  }\n}\n\n.event-planner-view__section-picker-option-label {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.event-planner-view__expand-toggle {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  margin: 0;\n  border-radius: 6px;\n  border: 1px solid rgba($pure-white, 0.18);\n  background: rgba(0, 0, 0, 0.25);\n  cursor: pointer;\n  transition: background 160ms ease, border-color 160ms ease;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.38);\n    border-color: $light-grey;\n  }\n}\n\n.event-planner-view__expand-toggle-icon {\n  display: block;\n  width: 14px;\n  height: 14px;\n  object-fit: contain;\n  opacity: 0.95;\n}\n\n.event-planner-view__team-remove {\n  padding: 0;\n  color: $light-grey;\n  background: transparent;\n  border: 0;\n  font-size: 1.35rem;\n  line-height: 1;\n  cursor: pointer;\n\n  &:hover {\n    color: $very-light-grey;\n  }\n}\n\n.event-planner-view__positions {\n  --event-planner-positions-gap: 0.35rem;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: var(--event-planner-positions-gap);\n  padding-top: 0.45rem;\n  margin-bottom: 6px;\n  min-width: 0;\n  min-height: 0;\n  width: 100%;\n  box-sizing: border-box;\n\n  &--collapsed {\n    padding-top: 0.35rem;\n  }\n}\n\n.event-planner-view__positions-measure {\n  position: absolute;\n  top: 0;\n  left: -9999px;\n  width: var(--event-planner-position-column-width, #{$event-planner-team-min-width});\n  visibility: hidden;\n  pointer-events: none;\n  display: flex;\n  flex-direction: column;\n  gap: var(--event-planner-positions-gap);\n\n  .event-planner-view__position {\n    width: 100%;\n    box-sizing: border-box;\n  }\n}\n\n.event-planner-view__positions-columns {\n  display: grid;\n  grid-template-columns: repeat(var(--team-position-columns, 1), minmax(0, 1fr));\n  gap: var(--event-planner-positions-gap);\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.event-planner-view__positions-column {\n  display: flex;\n  flex-direction: column;\n  gap: var(--event-planner-positions-gap);\n  min-width: 0;\n}\n\n.event-planner-view__team.is-expanded .event-planner-view__position {\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.event-planner-view__team.is-collapsed {\n  .event-planner-view__team-header {\n    padding-bottom: 0;\n    border-bottom: 0;\n  }\n}\n\n.event-planner-view__position {\n  display: flex;\n  flex-direction: column;\n  gap: 0.28rem;\n  padding: 0.4rem;\n  border: 1px dashed rgba($medium-light-grey, 0.35);\n  border-radius: 7px;\n  background: rgba($dark-panel-blue, 0.62);\n  transition: border-color 0.15s ease, background-color 0.15s ease;\n\n  &.is-over {\n    border-color: rgba($light-blue, 0.48);\n    background: rgba($blue-grey, 0.58);\n  }\n}\n\n.event-planner-view__position-label {\n  flex: 1;\n  min-width: 0;\n  color: #8bd5ff;\n  font-size: 0.68rem;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n\n  &.event-planner-view__position-label--command {\n    color: #ffc084;\n  }\n}\n\n.event-planner-view__position-label-row {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  width: 100%;\n}\n\n.event-planner-view__position-label-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n.event-planner-view__leader-rating-toggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  cursor: pointer;\n\n  &.is-disabled {\n    cursor: not-allowed;\n    opacity: 0.55;\n  }\n}\n\n.event-planner-view__leader-rating-toggle-input {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n  margin: 0;\n  pointer-events: none;\n}\n\n.event-planner-view__leader-rating-toggle-box {\n  display: inline-block;\n  width: 0.82rem;\n  height: 0.82rem;\n  border: 1px solid rgba($light-blue, 0.45);\n  border-radius: 0.18rem;\n  background: rgba($blue-grey, 0.55);\n  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.event-planner-view__leader-rating-toggle-input:checked + .event-planner-view__leader-rating-toggle-box {\n  border-color: rgba($orange, 0.85);\n  background: rgba($orange, 0.35);\n  box-shadow: inset 0 0 0 1px rgba($orange, 0.55);\n}\n\n.event-planner-view__leader-rating-toggle-input:focus-visible + .event-planner-view__leader-rating-toggle-box {\n  outline: 1px solid rgba($light-blue, 0.75);\n  outline-offset: 1px;\n}\n\n.event-planner-view__position-swap-btn {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  width: 1.35rem;\n  height: 1.35rem;\n  padding: 0;\n  border: 1px solid rgba($light-blue, 0.28);\n  border-radius: 0.25rem;\n  background: rgba($blue-grey, 0.45);\n  color: $light-blue;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease;\n\n  &:hover,\n  &:focus-visible {\n    border-color: rgba($light-blue, 0.55);\n    background: rgba($blue-grey, 0.72);\n    color: $very-light-grey;\n  }\n}\n\n.event-planner-view__position-swap-btn-icon {\n  width: 0.72rem;\n  height: 0.72rem;\n}\n\n.event-planner-view__position-swap-select {\n  width: 100%;\n  max-width: 100%;\n  padding: 0.12rem 0.3rem;\n  border: 1px solid rgba($light-blue, 0.35);\n  border-radius: 0.25rem;\n  background: rgba($blue-grey, 0.85);\n  color: $very-light-grey;\n  font-size: 0.68rem;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n}\n\n.event-planner-view__team-title-meta {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  flex-shrink: 0;\n  margin-left: auto;\n  min-width: 0;\n  max-width: 48%;\n  gap: 0.14rem;\n\n  .event-planner-view__team-owner {\n    margin-left: 0;\n    padding-left: 0;\n    max-width: 100%;\n    text-align: right;\n  }\n}\n\n.event-planner-view__command-ship-tag {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.28rem 0.38rem;\n  border: 1px solid rgba($very-light-yellow, 0.55);\n  border-radius: 999px;\n  background: rgba($very-dark-orange, 0.35);\n  color: $very-light-yellow;\n  font-size: 0.58rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  line-height: 1.3;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.event-planner-view__team-owner {\n  flex-shrink: 0;\n  margin-left: auto;\n  padding-left: 0.45rem;\n  overflow: hidden;\n  color: $medium-light-grey;\n  font-size: 0.72rem;\n  font-weight: 600;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.event-planner-view__vehicle-display-title {\n  display: flex;\n  flex-direction: column;\n  gap: 0.08rem;\n  min-width: 0;\n\n  > strong {\n    overflow: hidden;\n    color: $pure-white;\n    font-weight: 700;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n.event-planner-view__vehicle-display-custom-name {\n  overflow: hidden;\n  color: $light-grey;\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  line-height: 1.15;\n  min-height: 0.83rem;\n  text-overflow: ellipsis;\n  text-transform: uppercase;\n  white-space: nowrap;\n\n  &.is-placeholder {\n    visibility: hidden;\n  }\n}\n\n.event-planner-view__position-vehicle-chip {\n  display: inline-flex;\n  align-items: flex-start;\n  gap: 0.28rem;\n  max-width: auto;\n  width: auto;\n  margin-top: 0.2rem;\n  padding: 0.14rem 0.5rem;\n  border: 1px solid rgba($light-blue, 0.32);\n  border-radius: 999px;\n  background: $very-dark-grey;\n  color: $very-light-grey;\n  font-size: 0.68rem;\n  font-weight: 600;\n  line-height: 1.2;\n  cursor: grab;\n  touch-action: none;\n  user-select: none;\n  transition: border-color 0.15s ease, background-color 0.15s ease, opacity 0.15s ease;\n\n  .event-planner-view__vehicle-display-title > strong {\n    font-size: inherit;\n    font-weight: 600;\n  }\n\n  .event-planner-view__vehicle-display-custom-name {\n    font-size: 0.62rem;\n  }\n\n  .event-planner-view__vehicle-display-title {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .event-planner-view__team-owner {\n    align-self: center;\n    font-size: 0.62rem;\n    padding-left: 0.35rem;\n  }\n\n  &:hover {\n    border-color: rgba($light-blue, 0.5);\n    background: rgba($very-dark-grey, 0.92);\n  }\n\n  &.is-dragging {\n    opacity: 0.4;\n  }\n\n  &--overlay {\n    cursor: grabbing;\n    box-shadow: 0 8px 18px rgba($dark-blue-grey, 0.65);\n  }\n}\n\n.event-planner-view__position-vehicle-chip-icon {\n  flex-shrink: 0;\n  width: 0.75rem;\n  height: 0.75rem;\n  color: $light-blue;\n}\n\n.event-planner-view__position-vehicle-chip-label {\n  min-width: 0;\n}\n\n.event-planner-view__position-order {\n  margin-right: 0.2rem;\n  color: $medium-light-grey;\n}\n\n.event-planner-view__position-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.2rem;\n  flex: 1;\n  min-height: 2.1rem;\n  color: $medium-light-grey;\n  font-size: 0.68rem;\n  text-align: center;\n}\n\n.event-planner-view__position-empty-icon {\n  width: 0.85rem;\n  height: 0.85rem;\n  color: rgba($light-blue, 0.75);\n}\n\n.event-planner-view__no-positions {\n  margin: 0;\n  padding: 0.75rem 0;\n  color: $medium-light-grey;\n  font-size: 0.82rem;\n  text-align: center;\n}\n\n@media (max-width: 1000px) {\n  .event-planner-view {\n    overflow-x: auto;\n  }\n\n  .event-planner-view__layout {\n    grid-template-columns: 220px minmax(700px, 1fr) 260px;\n    min-width: 1220px;\n  }\n\n  .event-planner-view__variant-group {\n    grid-column: 1 / -1;\n  }\n}\n\n@media (max-width: 800px) {\n  .event-planner-view__header-main-row {\n    grid-template-columns: 1fr;\n    align-items: stretch;\n  }\n\n  .event-planner-view__header-main-row {\n    grid-template-columns: 1fr;\n  }\n\n  .event-planner-view__header-info {\n    width: auto;\n    max-width: 300px;\n  }\n\n  .event-planner-view__header-toolbar-main {\n    flex-wrap: wrap;\n  }\n\n  .event-planner-view__header-search {\n    flex: 1 1 100%;\n    max-width: none;\n  }\n\n  .event-planner-view__bulk-expand-toggle {\n    align-self: flex-end;\n  }\n\n  .event-planner-view__header-actions {\n    justify-content: flex-end;\n  }\n\n  .event-planner-view__header-actions-column {\n    align-items: stretch;\n  }\n\n  .event-planner-view__team-tags {\n    align-self: flex-end;\n  }\n\n  .event-planner-view__team-tags-panel {\n    right: 0;\n    left: auto;\n    width: unquote('min(22rem, calc(100vw - 1.5rem))');\n  }\n\n  .event-planner-view__layout {\n    grid-template-columns: 1fr;\n    min-width: 0;\n  }\n\n  .event-planner-view__participant-pool {\n    max-height: none;\n  }\n\n  .event-planner-view__sidebar {\n    order: -1;\n    max-height: none;\n  }\n\n  .event-planner-view__variant-group {\n    grid-column: 1 / -1;\n  }\n}\n\n// Member Event Planner — dedicated modal shell (90vw, horizontally centered).\n// Overrides global `.modal .modal-content { width: max-content }` and calendar 1200px rules.\n.calendar-event-modal.calendar-event-modal--planner {\n  .modal-dialog {\n    width: 95vw;\n    max-width: 95vw;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .modal-dialog .modal-content.event-planner-modal-content {\n    width: 95vw;\n    max-width: 95vw;\n    min-width: 0;\n    height: auto;\n    min-height: 0;\n    margin-left: auto;\n    margin-right: auto;\n    box-sizing: border-box;\n  }\n\n  .modal-body {\n    padding: 0;\n  }\n}\n\n.event-planner-view__fighter-vehicle-column {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n\n  &--collapsed {\n    padding-top: 0.35rem;\n  }\n}\n\n.event-planner-view__variant-group-teams--fighters {\n  > .event-planner-view__team--fighter-section {\n    flex: 0 0 var(--event-planner-position-column-width, #{$event-planner-team-min-width});\n    width: var(--event-planner-position-column-width, #{$event-planner-team-min-width});\n    min-width: var(--event-planner-position-column-width, #{$event-planner-team-min-width});\n    max-width: var(--event-planner-team-max-width, #{$event-planner-team-max-width});\n  }\n}\n\n.event-planner-view__team--fighter-section {\n  min-width: var(--event-planner-position-column-width, #{$event-planner-team-min-width});\n  max-width: var(--event-planner-team-max-width, #{$event-planner-team-max-width});\n  width: 100%;\n  box-sizing: border-box;\n\n  &.is-collapsed {\n    .event-planner-view__team-header {\n      padding-bottom: 0;\n      border-bottom: 0;\n    }\n  }\n\n  .event-planner-view__team-header {\n    margin-bottom: 0.35rem;\n  }\n\n  .event-planner-view__team-title {\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 0.35rem;\n  }\n}\n\n.event-planner-view__fighter-vehicle-slot {\n  padding: 0.45rem 0.5rem;\n  border: 1px solid rgba($medium-grey, 0.55);\n  border-radius: 8px;\n  background: rgba($very-dark-grey, 0.55);\n\n  &.is-over {\n    border-color: rgba($light-blue, 0.65);\n    background: rgba($blue, 0.12);\n  }\n\n  &--leader {\n    border-color: rgba($light-orange, 0.45);\n  }\n\n  &.has-orphaned-crew {\n    border-color: rgba($bright-red, 0.85);\n    box-shadow: 0 0 0 1px rgba($bright-red, 0.35);\n    background: rgba($dark-red, 0.28);\n\n    &.is-over {\n      border-color: rgba($bright-red, 0.95);\n      background: rgba($dark-red, 0.38);\n    }\n\n    .event-planner-view__fighter-vehicle-empty {\n      border-color: rgba($bright-red, 0.7);\n      color: rgba($light-grey, 0.85);\n      background: rgba($medium-red, 0.22);\n    }\n  }\n}\n\n.event-planner-view__fighter-vehicle-slot-header {\n  margin-bottom: 0.3rem;\n}\n\n.event-planner-view__fighter-vehicle-slot-role {\n  color: $light-grey;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n\n  &--leader {\n    color: $light-orange;\n  }\n}\n\n.event-planner-view__fighter-vehicle-header {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  margin-bottom: 0.35rem;\n  padding: 0.25rem 0.35rem;\n  border: 1px solid rgba($light-blue, 0.28);\n  border-radius: 6px;\n  background: rgba($blue-grey, 0.35);\n  cursor: grab;\n  min-width: 0;\n\n  &.is-dragging {\n    opacity: 0.45;\n  }\n\n  .event-planner-view__team-owner {\n    flex-shrink: 1;\n    min-width: 0;\n    max-width: 42%;\n    margin-left: auto;\n    font-size: 0.62rem;\n    text-align: right;\n  }\n}\n\n.event-planner-view__fighter-vehicle-header-icon {\n  flex-shrink: 0;\n  width: 0.75rem;\n  height: 0.75rem;\n  color: $light-blue;\n\n  svg {\n    display: block;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.event-planner-view__fighter-vehicle-header-name {\n  display: flex;\n  flex-direction: column;\n  gap: 0.08rem;\n  font-size: 0.78rem;\n  min-width: 0;\n  flex: 1;\n}\n\n.event-planner-view__fighter-vehicle-empty {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.35rem 0.45rem;\n  border: 1px dashed rgba($medium-grey, 0.75);\n  border-radius: 6px;\n  color: $medium-light-grey;\n  font-size: 0.72rem;\n}\n\n.event-planner-view__fighter-crew-slots,\n.event-planner-view__vehicle-crew-slots {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.event-planner-view__fighter-crew-slot,\n.event-planner-view__vehicle-crew-slot {\n  padding: 0.3rem 0.35rem;\n  border: 1px solid rgba($medium-grey, 0.4);\n  border-radius: 6px;\n\n  &.is-over {\n    border-color: rgba($light-blue, 0.55);\n  }\n\n  &--leader {\n    border-color: rgba($light-orange, 0.35);\n  }\n}\n\n.event-planner-view__convoy-group .event-planner-view__convoy-vehicle {\n  border: 1px solid rgba($event-planner-ground-vehicle-border, 0.58);\n  background: rgba($event-planner-ground-vehicle-surface, 0.9) !important;\n}\n\n.event-planner-view__convoy-group .event-planner-view__vehicle-crew-slot,\n.event-planner-view__convoy-vehicle .event-planner-view__vehicle-crew-slot {\n  padding: 0.35rem 0.4rem;\n  border: 1px dashed rgba($event-planner-ground-slot-border, 0.62);\n  border-radius: 7px;\n  background: rgba($event-planner-ground-slot-surface, 0.96);\n  transition: border-color 0.15s ease, background-color 0.15s ease;\n\n  &.is-over {\n    border-color: rgba($light-green, 0.55);\n    background: rgba($event-planner-ground-vehicle-surface, 0.95);\n  }\n\n  &--leader {\n    border-color: rgba($light-orange, 0.45);\n  }\n}\n\n.event-planner-view__convoy-group .event-planner-view__vehicle-crew-slot-label,\n.event-planner-view__convoy-vehicle .event-planner-view__vehicle-crew-slot-label {\n  color: $event-planner-ground-slot-label;\n  font-size: 0.68rem;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n\n  &--leader {\n    color: $light-orange;\n  }\n}\n\n.event-planner-view__convoy-group .event-planner-view__position-empty--compact,\n.event-planner-view__convoy-vehicle .event-planner-view__position-empty--compact {\n  border: 1px dashed rgba($event-planner-ground-slot-border, 0.35);\n  border-radius: 6px;\n  background: rgba($very-dark-grey, 0.35);\n}\n\n.event-planner-view__fighter-crew-slot-label-row {\n  margin-bottom: 0.2rem;\n\n  .event-planner-view__fighter-crew-slot-label {\n    display: inline;\n    margin-bottom: 0;\n    flex: 1;\n    min-width: 0;\n  }\n}\n\n.event-planner-view__position--group-leader {\n  .event-planner-view__position-label-row {\n    margin-bottom: 0.35rem;\n  }\n}\n\n.event-planner-view__fighter-crew-slot-label,\n.event-planner-view__vehicle-crew-slot-label {\n  display: block;\n  margin-bottom: 0.2rem;\n  color: $medium-light-grey;\n  font-size: 0.68rem;\n  font-weight: 600;\n\n  &--leader {\n    color: $light-orange;\n  }\n}\n\n.event-planner-view__position-empty--compact {\n  padding: 0.2rem 0.25rem;\n  font-size: 0.68rem;\n}\n\n.event-planner-view__convoy-group {\n  --convoy-vehicle-count: 1;\n  grid-column: span var(--convoy-vehicle-count);\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n  width: 100%;\n  min-width: 0;\n  padding: 0.55rem;\n  box-sizing: border-box;\n  position: relative;\n  z-index: 2;\n\n  &.is-expanded {\n    box-sizing: border-box;\n    width: fit-content;\n    min-width: calc(\n      var(--convoy-vehicle-count) * var(--event-planner-position-column-width) +\n        var(--convoy-insert-zone-count, 0) * 0.9rem +\n        (\n          var(--convoy-vehicle-count) + var(--convoy-insert-zone-count, 0) - 1\n        ) * 0.55rem +\n        1.1rem\n    );\n    max-width: 100cqw;\n    justify-self: center;\n  }\n\n  &.event-planner-view__ground-theme,\n  &[class*=\"mo-structure-card-bg-\"] {\n    @include event-planner-ground-panel-shell;\n  }\n\n  &.is-collapsed {\n    .event-planner-view__convoy-group-header {\n      margin-bottom: 0;\n      padding-bottom: 0;\n      border-bottom: 0;\n    }\n  }\n}\n\n.event-planner-view__ground-theme {\n  &:not([class*=\"mo-structure-card-bg-\"]) {\n    border-color: rgba($event-planner-ground-panel-border, 0.68) !important;\n    background: linear-gradient(\n      145deg,\n      rgba($event-planner-ground-surface, 0.96),\n      rgba($event-planner-ground-accent, 0.92)\n    ) !important;\n  }\n}\n\n.event-planner-view__convoy-group-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.45rem;\n  margin-bottom: 0;\n  padding-bottom: 0.45rem;\n  border-bottom: 1px solid rgba($event-planner-ground-border, 0.52);\n}\n\n.event-planner-view__ground-vehicle-standalone .event-planner-view__convoy-vehicle-header {\n  margin-bottom: 0;\n  padding-bottom: 0.45rem;\n  border-bottom: 1px solid rgba($event-planner-ground-border, 0.52);\n}\n\n.event-planner-view__convoy-vehicle-header-stats {\n  margin-left: auto;\n}\n\n.event-planner-view__convoy-commander {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  padding: 0.35rem 0.45rem;\n  border: 1px solid rgba($light-orange, 0.35);\n  border-radius: 6px;\n  background: rgba($light-orange, 0.08);\n\n  &--empty {\n    color: $medium-light-grey;\n    font-size: 0.72rem;\n  }\n}\n\n.event-planner-view__convoy-commander-label {\n  color: $light-orange;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.event-planner-view__convoy-vehicle-row {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-content: center;\n  align-items: stretch;\n  gap: 0.55rem;\n  align-self: center;\n  width: max-content;\n  max-width: 100%;\n  max-width: 100cqw;\n  min-width: 0;\n\n  > .event-planner-view__convoy-vehicle {\n    flex: 0 0 var(--event-planner-position-column-width, #{$event-planner-team-min-width});\n    width: var(--event-planner-position-column-width, #{$event-planner-team-min-width});\n    min-width: var(--event-planner-position-column-width, #{$event-planner-team-min-width});\n    max-width: var(--event-planner-position-column-width, #{$event-planner-team-min-width});\n    box-sizing: border-box;\n  }\n}\n\n.event-planner-view__convoy-vehicle {\n  box-sizing: border-box;\n  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease,\n    filter 0.15s ease;\n\n  &:not(.event-planner-view__ground-vehicle-standalone) {\n    padding: 0.45rem;\n    border-radius: 8px;\n\n    &:not([class*=\"mo-structure-card-bg-\"]):not(.event-planner-view__ground-theme) {\n      border: 1px solid rgba($event-planner-ground-vehicle-border, 0.5);\n      background: rgba($event-planner-ground-vehicle-surface, 0.88);\n    }\n  }\n\n  &.event-planner-view__ground-vehicle-standalone {\n    &.event-planner-view__ground-theme,\n    &[class*=\"mo-structure-card-bg-\"] {\n      @include event-planner-ground-panel-shell;\n      display: flex;\n      flex-direction: column;\n      gap: 0.45rem;\n      padding: 0.55rem;\n    }\n  }\n\n  &.is-over:not(.event-planner-view__ground-vehicle-standalone) {\n    border-color: rgba($event-planner-ground-slot-border, 0.72);\n    background: rgba($event-planner-ground-vehicle-surface, 0.98);\n    box-shadow: 0 0 0 1px rgba($event-planner-ground-panel-glow, 0.45);\n  }\n\n  &.event-planner-view__ground-vehicle-standalone.is-over {\n    filter: brightness(1.04);\n  }\n\n  &.is-dragging {\n    opacity: 0.45;\n  }\n}\n\n.event-planner-view__convoy-vehicle-header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.35rem;\n  margin-bottom: 0.35rem;\n  cursor: default;\n\n  &.is-dragging {\n    opacity: 0.45;\n    cursor: grabbing;\n  }\n\n  &:has(.event-planner-view__drag-hint) {\n    cursor: grab;\n  }\n}\n\n.event-planner-view__convoy-vehicle-title {\n  display: flex;\n  flex-direction: column;\n  gap: 0.08rem;\n  min-width: 0;\n  flex: 1;\n}\n\n.event-planner-view__convoy-insert-zone {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.3rem;\n  min-height: 1.6rem;\n  padding: 0.2rem 0.35rem;\n  border: 1px dashed rgba($medium-grey, 0.65);\n  border-radius: 6px;\n  color: $medium-light-grey;\n  font-size: 0.66rem;\n\n  &.is-over {\n    border-color: rgba($light-blue, 0.65);\n    color: $very-light-grey;\n    background: rgba($blue, 0.1);\n  }\n}\n\n.event-planner-view__convoy-vehicle-row .event-planner-view__convoy-insert-zone {\n  flex: 0 0 0.9rem;\n  align-self: stretch;\n  flex-direction: column;\n  border: 1px solid darkolivegreen;\n  min-width: 0.9rem;\n  min-height: 5rem;\n  padding: 0.25rem 0.1rem;\n  font-size: 0;\n\n  .event-planner-view__drag-hint {\n    width: 0.85rem;\n    height: 0.85rem;\n    flex-shrink: 0;\n  }\n\n  > span {\n    display: none;\n  }\n}\n\n","@import './variables.scss';\n\n// Assignment view — isolated from manage-assignments planner styles.\n\n.event-assignment-view {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-width: 0;\n  min-height: 60vh;\n  max-height: 85vh;\n  overflow: hidden;\n  box-sizing: border-box;\n  color: $very-light-grey;\n  background:\n    radial-gradient(ellipse 120% 80% at 50% -20%, rgba($accent-blue, 0.14), transparent 55%),\n    linear-gradient(180deg, rgba($dark-blue, 0.94), rgba($dark-blue-grey, 0.72));\n\n  &.event-planner-view {\n    // Keep assignment view clipped even when planner styles enable horizontal scroll ≤1000px.\n    overflow-x: hidden;\n\n    .event-planner-view__header {\n      flex-shrink: 0;\n      min-width: 0;\n      border-bottom: 1px solid rgba($accent-blue, 0.2);\n      background: rgba($dark-blue, 0.55);\n    }\n  }\n}\n\n.event-assignment-view__workspace {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(260px, 320px);\n  grid-template-rows: minmax(0, 1fr) auto;\n  grid-template-areas:\n    \"main sidebar\"\n    \"legend legend\";\n  flex: 1;\n  min-width: 0;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.event-assignment-view__main {\n  grid-area: main;\n  min-width: 0;\n  min-height: 0;\n  overflow-x: clip;\n  overflow-y: auto;\n  padding: 1rem 1.25rem 1.25rem;\n  @include org-members-mgmt-general-thin-scrollbar;\n}\n\n.event-assignment-view__legend {\n  grid-area: legend;\n  min-width: 0;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 0.85rem 1.5rem;\n  padding: 0.6rem 1rem 0.8rem;\n  border-top: 1px solid rgba($accent-blue, 0.18);\n  background: rgba($dark-blue, 0.45);\n  font-size: 0.72rem;\n  color: rgba($very-light-grey, 0.58);\n}\n\n.event-assignment-view__legend-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n\n  &::before {\n    content: \"\";\n    width: 0.5rem;\n    height: 0.5rem;\n    border-radius: 50%;\n    flex-shrink: 0;\n  }\n}\n\n.event-assignment-view__legend-item--own::before {\n  background: $light-blue;\n  box-shadow: 0 0 8px rgba($light-blue, 0.55);\n}\n\n.event-assignment-view__legend-item--related::before {\n  background: $light-green;\n  box-shadow: 0 0 6px rgba($light-green, 0.4);\n}\n\n.event-assignment-view__legend-item--other::before {\n  background: rgba($medium-light-grey, 0.7);\n}\n\n.event-assignment-view__status {\n  padding: 2rem 1.5rem;\n  text-align: center;\n  color: rgba($very-light-grey, 0.65);\n}\n\n.event-assignment-view__status--error {\n  color: $bright-red;\n}\n\n.event-assignment-view__alert {\n  margin: 1.5rem;\n  padding: 1rem 1.25rem;\n  border: 1px solid rgba($light-orange, 0.55);\n  border-radius: 8px;\n  background: rgba($dark-orange, 0.35);\n  color: $very-light-grey;\n}\n\n// ── Board layout (view mode) ─────────────────────────────────\n\n// Board-level spacing — room for filiation link routing between cards/sections.\n$assignment-view-link-routing-gap: 3.5rem;\n// Gap between filiation column and periphery row below.\n$assignment-view-main-row-gap: 1.25rem;\n// Inside variant/convoy groups — nested teams & fighter slots only.\n$assignment-view-nested-gap: 1rem;\n$assignment-view-ship-inline-gap: 3rem;\n$assignment-view-team-max-width: 330px;\n// Min width for 2-column group bodies (convoy, fighters, infantry).\n$assignment-view-group-two-col-min-width: calc(\n  2 * #{$assignment-view-team-max-width} + #{$assignment-view-nested-gap}\n);\n\n@mixin assignment-view-inline-peer-row-layout {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-evenly;\n  align-items: flex-start;\n  gap: $assignment-view-ship-inline-gap;\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  --event-planner-card-gap: #{$assignment-view-ship-inline-gap};\n\n  > .assignment-view-card--team {\n    flex: 0 0 $assignment-view-team-max-width;\n    width: $assignment-view-team-max-width;\n    min-width: $assignment-view-team-max-width;\n    max-width: $assignment-view-team-max-width;\n  }\n\n  > .assignment-view-card--group {\n    flex: 0 1 auto;\n    width: max-content;\n    min-width: 0;\n    max-width: 100%;\n  }\n}\n\n@mixin assignment-view-standalone-ship-row-layout {\n  @include assignment-view-inline-peer-row-layout;\n}\n\n@mixin assignment-view-periphery-card-fit {\n  > .assignment-view-card--team {\n    flex: 0 0 auto;\n    width: 100%;\n    min-width: 0;\n    max-width: 100%;\n  }\n\n  > .assignment-view-card--group {\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n  }\n}\n\n.assignment-view-board {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: $assignment-view-link-routing-gap;\n  width: 100%;\n  min-width: 0;\n}\n\n.assignment-view-board-canvas {\n  position: relative;\n  width: 100%;\n  min-width: 0;\n  overflow: hidden;\n  --event-planner-card-gap: #{$assignment-view-link-routing-gap};\n}\n\n.assignment-view-board-canvas .event-planner-view__card-links-layer {\n  overflow: visible;\n  z-index: 2;\n  pointer-events: none;\n}\n\n.assignment-view-board-canvas .event-planner-view__card-links--visual {\n  z-index: 2;\n}\n\n.assignment-view-board-canvas .event-planner-view__card-links--interactive {\n  pointer-events: none;\n}\n\n.assignment-view-board-canvas .event-planner-view__card-link-path {\n  fill: none;\n  stroke: rgba($light-blue, 0.82);\n  stroke-width: 2;\n  stroke-dasharray: none;\n  transition: stroke 120ms ease, stroke-width 120ms ease;\n}\n\n.assignment-view-board-canvas .event-planner-view__card-link-path.is-highlighted {\n  stroke: rgba($light-blue, 0.92);\n  stroke-width: 2.25;\n}\n\n.assignment-view-board-canvas .event-planner-view__card-link-path.is-selected {\n  stroke: rgba($very-light-yellow, 0.98);\n  stroke-width: 3.25;\n  filter: drop-shadow(0 0 4px rgba($very-light-yellow, 0.45));\n}\n\n.assignment-view-board-canvas .event-planner-view__card-link-arrow {\n  fill: rgba($light-blue, 0.82);\n  transition: fill 120ms ease;\n}\n\n.assignment-view-board-canvas .event-planner-view__card-link-arrow.is-highlighted {\n  fill: rgba($light-blue, 0.92);\n}\n\n.assignment-view-board-canvas .event-planner-view__card-link-arrow.is-selected {\n  fill: rgba($very-light-yellow, 0.98);\n  filter: drop-shadow(0 0 3px rgba($very-light-yellow, 0.4));\n}\n\n.assignment-view-board-canvas .event-planner-view__card-link-attach.is-highlighted,\n.assignment-view-board-canvas .event-planner-view__card-link-attach.is-selected {\n  fill: rgba($blue-grey, 0.95);\n  stroke: rgba($very-light-yellow, 0.95);\n  stroke-width: 2.5;\n}\n\n.assignment-view-board-canvas .event-planner-view__card-link-path-hit {\n  pointer-events: none;\n}\n\n.assignment-view-card,\n.assignment-view-nested-team {\n  position: relative;\n  z-index: 1;\n}\n\n.assignment-view-board__ancestors {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: center;\n  gap: $assignment-view-link-routing-gap;\n  width: 100%;\n}\n\n.assignment-view-board--catalog {\n  gap: calc(#{$assignment-view-link-routing-gap} + 0.35rem);\n}\n\n.assignment-view-board__catalog-section {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0.55rem;\n  width: 100%;\n}\n\n.assignment-view-board__catalog-section-grid {\n  display: grid;\n  grid-template-columns: repeat(\n    auto-fit,\n    minmax(0, $assignment-view-team-max-width)\n  );\n  justify-content: center;\n  gap: $assignment-view-link-routing-gap;\n  width: 100%;\n  min-width: 0;\n}\n\n.assignment-view-inline-peer-row,\n.assignment-view-standalone-ship-row,\n.assignment-view-fighter-flight-row,\n.assignment-view-infantry-peer-row,\n.assignment-view-convoy-peer-row {\n  @include assignment-view-inline-peer-row-layout;\n}\n\n.assignment-view-board__standalone-ships,\n.assignment-view-board__fighter-flights,\n.assignment-view-board__infantry-peers,\n.assignment-view-board__convoy-peers,\n.assignment-view-board__inline-peer-row {\n  width: 100%;\n  min-width: 0;\n}\n\n.assignment-view-board__standalone-ships .assignment-view-inline-peer-row,\n.assignment-view-board__standalone-ships .assignment-view-standalone-ship-row {\n  > .assignment-view-card--team {\n    &.assignment-view-card--size-focus,\n    &.assignment-view-card--size-peer,\n    &.assignment-view-card--size-chain,\n    &.assignment-view-card--layout-tree,\n    &.assignment-view-card--layout-focus,\n    &.assignment-view-card--layout-periphery,\n    &.assignment-view-card--layout-catalog,\n    &.assignment-view-card--width-ancestor,\n    &.assignment-view-card--command-ship {\n      flex: 0 0 $assignment-view-team-max-width;\n      width: 100%;\n      //min-width: $assignment-view-team-max-width;\n      max-width: $assignment-view-team-max-width;\n    }\n  }\n}\n\n.assignment-view-board__fighter-flights .assignment-view-inline-peer-row,\n.assignment-view-board__fighter-flights .assignment-view-fighter-flight-row {\n  > .assignment-view-card--team {\n    &.assignment-view-card--size-focus,\n    &.assignment-view-card--size-peer,\n    &.assignment-view-card--size-chain,\n    &.assignment-view-card--layout-tree,\n    &.assignment-view-card--layout-focus,\n    &.assignment-view-card--layout-periphery,\n    &.assignment-view-card--layout-catalog,\n    &.assignment-view-card--width-ancestor,\n    &.assignment-view-card--family-fighters {\n      flex: 0 0 $assignment-view-team-max-width;\n      width: $assignment-view-team-max-width;\n      min-width: $assignment-view-team-max-width;\n      max-width: $assignment-view-team-max-width;\n    }\n  }\n}\n\n.assignment-view-board__infantry-peers .assignment-view-inline-peer-row,\n.assignment-view-board__infantry-peers .assignment-view-infantry-peer-row {\n  > .assignment-view-card--team {\n    &.assignment-view-card--size-focus,\n    &.assignment-view-card--size-peer,\n    &.assignment-view-card--size-chain,\n    &.assignment-view-card--layout-tree,\n    &.assignment-view-card--layout-focus,\n    &.assignment-view-card--layout-periphery,\n    &.assignment-view-card--layout-catalog,\n    &.assignment-view-card--width-ancestor,\n    &.assignment-view-card--family-infantry {\n      flex: 0 0 $assignment-view-team-max-width;\n      width: $assignment-view-team-max-width;\n      min-width: $assignment-view-team-max-width;\n      max-width: $assignment-view-team-max-width;\n    }\n  }\n}\n\n.assignment-view-board__convoy-peers .assignment-view-inline-peer-row,\n.assignment-view-board__convoy-peers .assignment-view-convoy-peer-row {\n  > .assignment-view-card--team {\n    &.assignment-view-card--size-focus,\n    &.assignment-view-card--size-peer,\n    &.assignment-view-card--size-chain,\n    &.assignment-view-card--layout-tree,\n    &.assignment-view-card--layout-focus,\n    &.assignment-view-card--layout-periphery,\n    &.assignment-view-card--layout-catalog,\n    &.assignment-view-card--width-ancestor,\n    &.assignment-view-card--family-convoy {\n      flex: 0 0 $assignment-view-team-max-width;\n      width: $assignment-view-team-max-width;\n      min-width: $assignment-view-team-max-width;\n      max-width: $assignment-view-team-max-width;\n    }\n  }\n}\n\n.assignment-view-board__catalog-section--commandShip,\n.assignment-view-board__catalog-section--ships,\n.assignment-view-board__catalog-section--squadrons,\n.assignment-view-board__catalog-section--infantry,\n.assignment-view-board__catalog-section--groundVehicles {\n  .assignment-view-board__catalog-section-grid {\n    @include assignment-view-inline-peer-row-layout;\n  }\n}\n\n.assignment-view-board__ancestors--standalone-ships {\n  @include assignment-view-inline-peer-row-layout;\n}\n\n.assignment-view-tree__siblings.assignment-view-inline-peer-row,\n.assignment-view-tree__siblings.assignment-view-standalone-ship-row,\n.assignment-view-tree__siblings.assignment-view-fighter-flight-row,\n.assignment-view-tree__siblings.assignment-view-infantry-peer-row,\n.assignment-view-tree__siblings.assignment-view-convoy-peer-row {\n  @include assignment-view-inline-peer-row-layout;\n}\n\n.assignment-view-board__periphery-grid.assignment-view-inline-peer-row,\n.assignment-view-board__periphery-grid.assignment-view-standalone-ship-row,\n.assignment-view-board__periphery-grid.assignment-view-fighter-flight-row,\n.assignment-view-board__periphery-grid.assignment-view-infantry-peer-row,\n.assignment-view-board__periphery-grid.assignment-view-convoy-peer-row {\n  @include assignment-view-inline-peer-row-layout;\n}\n\n.assignment-view-board__family-grid.assignment-view-inline-peer-row,\n.assignment-view-board__family-grid.assignment-view-standalone-ship-row,\n.assignment-view-board__family-grid.assignment-view-fighter-flight-row,\n.assignment-view-board__family-grid.assignment-view-infantry-peer-row,\n.assignment-view-board__family-grid.assignment-view-convoy-peer-row {\n  @include assignment-view-inline-peer-row-layout;\n}\n\n.assignment-view-card--layout-catalog,\n.assignment-view-card--size-catalog {\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n\n  &.assignment-view-card--team {\n    max-width: $assignment-view-team-max-width;\n  }\n\n  &.assignment-view-card--group {\n    width: max-content;\n    max-width: 100%;\n  }\n}\n\n.assignment-view-board--catalog {\n  .assignment-view-card--group {\n    width: max-content;\n    max-width: 100%;\n    min-width: 0;\n\n    &:has(.assignment-view-card__nested-grid--multi-team),\n    &:has(.assignment-view-card__nested-grid--convoy-vehicles),\n    &:has(.assignment-view-card__nested-grid--fighter-sections),\n    &:has(.assignment-view-card__nested-grid--infantry-teams) {\n      width: max-content;\n      max-width: 100%;\n      min-width: 0;\n    }\n  }\n}\n\n.assignment-view-board__filiation-column {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: $assignment-view-link-routing-gap;\n  width: 100%;\n  min-width: 0;\n}\n\n.assignment-view-board__parent-chain {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: $assignment-view-link-routing-gap;\n  width: 100%;\n}\n\n.assignment-view-board__main-row {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: $assignment-view-link-routing-gap;\n  width: 100%;\n  min-width: 0;\n}\n\n.assignment-view-board__focus {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  min-width: 0;\n}\n\n.assignment-view-board__periphery {\n  display: flex;\n  flex-direction: column;\n  gap: $assignment-view-nested-gap;\n  width: 100%;\n  min-width: 0;\n  align-self: start;\n  box-sizing: border-box;\n}\n\n.assignment-view-board__family-peers {\n  display: flex;\n  flex-direction: column;\n  gap: $assignment-view-link-routing-gap;\n  width: 100%;\n  min-width: 0;\n}\n\n.assignment-view-board__family-grid {\n  display: grid;\n  grid-template-columns: repeat(\n    auto-fit,\n    minmax($event-planner-team-min-width, $event-planner-team-max-width)\n  );\n  justify-content: center;\n  align-items: stretch;\n  width: 100%;\n  min-width: 0;\n  gap: $assignment-view-nested-gap;\n}\n\n.assignment-view-board__main-row:has(.assignment-view-board__filiation-column):has(\n    .assignment-view-board__family-peers\n  ) {\n  .assignment-view-board__family-peers .assignment-view-board__family-grid {\n    justify-content: flex-end;\n    padding-inline-start: 1.5rem;\n  }\n}\n\n.assignment-view-board__periphery-grid {\n  width: 100%;\n  min-width: 0;\n  gap: $assignment-view-nested-gap;\n}\n\n.assignment-view-board--has-periphery {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(\n      0,\n      #{\"min(#{$event-planner-team-max-width}, 100%)\"}\n    );\n  align-items: start;\n  gap: $assignment-view-main-row-gap;\n  width: 100%;\n  min-width: 0;\n}\n\n.assignment-view-board--has-periphery .assignment-view-board__primary-stack {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: $assignment-view-link-routing-gap;\n  width: 100%;\n  min-width: 0;\n  grid-column: 1;\n  grid-row: 1;\n}\n\n.assignment-view-board--has-periphery > .assignment-view-board__periphery {\n  grid-column: 2;\n  grid-row: 1;\n  justify-self: end;\n  align-self: start;\n  width: 100%;\n  max-width: $event-planner-team-max-width;\n  padding-top: 0;\n  margin-top: 0;\n  border-top: none;\n  border-left: 1px dashed rgba($accent-blue, 0.22);\n  padding-left: 0.65rem;\n}\n\n.assignment-view-board--has-periphery .assignment-view-board__periphery-grid {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: flex-start;\n  width: 100%;\n  min-width: 0;\n}\n\n.assignment-view-board--has-periphery .assignment-view-board__periphery-grid,\n.assignment-view-board--has-periphery\n  .assignment-view-board__periphery-grid.assignment-view-inline-peer-row,\n.assignment-view-board--has-periphery\n  .assignment-view-board__periphery-grid.assignment-view-standalone-ship-row,\n.assignment-view-board--has-periphery\n  .assignment-view-board__periphery-grid.assignment-view-fighter-flight-row,\n.assignment-view-board--has-periphery\n  .assignment-view-board__periphery-grid.assignment-view-infantry-peer-row,\n.assignment-view-board--has-periphery\n  .assignment-view-board__periphery-grid.assignment-view-convoy-peer-row {\n  @include assignment-view-periphery-card-fit;\n}\n\n.assignment-view-board--has-periphery .assignment-view-board__periphery {\n  .assignment-view-card--team,\n  .assignment-view-card--team.assignment-view-card--layout-periphery,\n  .assignment-view-card--team.assignment-view-card--size-peer {\n    width: 100%;\n    min-width: 0;\n    max-width: 100%;\n  }\n\n  .assignment-view-card--group,\n  .assignment-view-card--group.assignment-view-card--layout-periphery,\n  .assignment-view-card--group.assignment-view-card--size-peer {\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n  }\n}\n\n// Legacy tree connectors (admin / fallback only)\n.assignment-view-tree {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 1rem;\n  width: 100%;\n}\n\n.assignment-view-tree__main {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n\n.assignment-view-tree__branch {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n\n.assignment-view-tree__branch--wide {\n  width: 100%;\n  max-width: none;\n}\n\n.assignment-view-tree__children {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  width: 100%;\n}\n\n.assignment-view-tree__connector {\n  width: 2px;\n  height: 1rem;\n  margin: 0 auto;\n  background: rgba($very-light-grey, 0.22);\n}\n\n.assignment-view-tree__siblings {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax($event-planner-team-min-width, $event-planner-team-max-width));\n  gap: 0.85rem;\n  width: 100%;\n  padding-top: 0.5rem;\n}\n\n// ── Cards ────────────────────────────────────────────────────\n\n.assignment-view-card {\n  width: auto;\n  max-width: 100%;\n  border-radius: 14px;\n  overflow: hidden;\n  background: rgba($dark-blue-grey, 0.42);\n  border: 1px solid rgba($accent-blue, 0.28);\n  box-shadow: 0 10px 28px rgba($dark-blue, 0.28);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.assignment-view-card--group {\n  overflow: hidden;\n  width: max-content;\n  max-width: 100%;\n  box-sizing: border-box;\n\n  &:has(.assignment-view-card__nested-grid--multi-team),\n  &:has(.assignment-view-card__nested-grid--convoy-vehicles),\n  &:has(.assignment-view-card__nested-grid--fighter-sections),\n  &:has(.assignment-view-card__nested-grid--infantry-teams) {\n    width: max-content;\n    max-width: 100%;\n    min-width: 0;\n  }\n\n  .assignment-view-card__header {\n    border-radius: 14px 14px 0 0;\n    overflow: hidden;\n  }\n\n  .assignment-view-card__body {\n    border-radius: 0 0 14px 14px;\n  }\n}\n\n.assignment-view-card--team {\n  width: 100%;\n  min-width: 0;\n  max-width: $assignment-view-team-max-width;\n  box-sizing: border-box;\n\n  &.assignment-view-card--layout-tree,\n  &.assignment-view-card--layout-focus,\n  &.assignment-view-card--layout-parent,\n  &.assignment-view-card--layout-periphery,\n  &.assignment-view-card--layout-catalog,\n  &.assignment-view-card--size-focus,\n  &.assignment-view-card--size-chain,\n  &.assignment-view-card--size-peer,\n  &.assignment-view-card--size-catalog {\n    width: 100%;\n    min-width: 0;\n    max-width: $assignment-view-team-max-width;\n  }\n}\n\n.assignment-view-card--layout-tree,\n.assignment-view-card--layout-focus,\n.assignment-view-card--size-focus {\n  width: 86%;\n  max-width: 52rem;\n\n  &.assignment-view-card--group {\n    width: max-content;\n    max-width: 100%;\n  }\n}\n\n.assignment-view-inline-peer-row > .assignment-view-card--team,\n.assignment-view-standalone-ship-row > .assignment-view-card--team,\n.assignment-view-board__periphery-grid.assignment-view-inline-peer-row\n  > .assignment-view-card--team,\n.assignment-view-board__periphery-grid.assignment-view-standalone-ship-row\n  > .assignment-view-card--team,\n.assignment-view-tree__siblings.assignment-view-inline-peer-row\n  > .assignment-view-card--team,\n.assignment-view-tree__siblings.assignment-view-standalone-ship-row\n  > .assignment-view-card--team {\n  &.assignment-view-card--size-focus,\n  &.assignment-view-card--layout-tree,\n  &.assignment-view-card--layout-focus,\n  &.assignment-view-card--width-ancestor,\n  &.assignment-view-card--command-ship {\n    flex: 0 0 100%;\n    width: 100%;\n    //min-width: $assignment-view-team-max-width;\n    max-width: $assignment-view-team-max-width;\n  }\n}\n\n.assignment-view-card--layout-ancestor,\n.assignment-view-card--size-chain.assignment-view-card--chain-ancestor {\n  flex: 0 1 676px;\n  width: 100%;\n  max-width: #{\"min(946px, 100%)\"};\n  min-width: #{\"min(608px, 100%)\"};\n\n  .assignment-view-card__header-inner {\n    padding: 1.35rem 1.3rem;\n    min-height: 4.85rem;\n  }\n\n  .assignment-view-card__header--with-image {\n    min-height: 148px;\n\n    .assignment-view-card__header-inner {\n      min-height: 148px;\n    }\n  }\n\n  .assignment-view-card__heading h4 {\n    font-size: 1.25rem;\n  }\n\n  .assignment-view-card__command-chip {\n    font-size: 0.68rem;\n    padding: 0.28rem 0.68rem;\n  }\n\n  .assignment-view-card__body--compact {\n    padding: 0.72rem 1rem 0.9rem;\n  }\n\n  .assignment-view-commander-row {\n    padding: 0.58rem 0.72rem;\n    gap: 0.42rem;\n  }\n}\n\n.assignment-view-card--width-ancestor {\n  flex: 0 1 676px;\n  width: 100%;\n  max-width: #{\"min(946px, 100%)\"};\n  min-width: #{\"min(608px, 100%)\"};\n}\n\n.assignment-view-card--team.assignment-view-card--width-ancestor {\n  width: 100%;\n  min-width: 0;\n  max-width: #{\"min(#{$assignment-view-team-max-width}, 100%)\"};\n  min-height: fit-content;\n}\n\n.assignment-view-card--group.assignment-view-card--width-ancestor {\n  width: max-content;\n  max-width: 100%;\n  min-width: 0;\n  min-height: fit-content;\n}\n\n.assignment-view-card--layout-parent,\n.assignment-view-card--size-chain.assignment-view-card--chain-parent {\n  width: 86%;\n  max-width: 52rem;\n\n  &.assignment-view-card--group {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .assignment-view-card__header-inner {\n    padding: 1rem 1.15rem;\n    min-height: 4rem;\n  }\n\n  .assignment-view-card__header--with-image {\n    min-height: 120px;\n\n    .assignment-view-card__header-inner {\n      min-height: 120px;\n    }\n  }\n\n  .assignment-view-card__heading h4 {\n    font-size: 1.05rem;\n  }\n\n  .assignment-view-card__body--compact {\n    padding: 0.65rem 0.9rem 0.8rem;\n  }\n\n  .assignment-view-commander-row {\n    padding: 0.5rem 0.65rem;\n    gap: 0.38rem;\n  }\n}\n\n.assignment-view-card--layout-periphery,\n.assignment-view-card--size-peer {\n  width: 100%;\n}\n\n.assignment-view-card--group.assignment-view-card--size-peer,\n.assignment-view-card--group.assignment-view-card--layout-periphery {\n  &:has(.assignment-view-card__nested-grid--multi-team),\n  &:has(.assignment-view-card__nested-grid--convoy-vehicles),\n  &:has(.assignment-view-card__nested-grid--fighter-sections),\n  &:has(.assignment-view-card__nested-grid--infantry-teams) {\n    width: max-content;\n    max-width: 100%;\n    min-width: 0;\n  }\n}\n\n.assignment-view-card--size-chain {\n  width: 86%;\n  max-width: 52rem;\n\n  &.assignment-view-card--group {\n    width: 100%;\n    max-width: 100%;\n  }\n}\n\n// Tone borders\n.assignment-view-card--own {\n  border-color: rgba($light-blue, 0.68);\n  box-shadow:\n    0 0 0 1px rgba($light-blue, 0.22),\n    0 0 24px rgba($light-blue, 0.12),\n    0 12px 32px rgba($dark-blue, 0.35);\n}\n\n.assignment-view-card--related {\n  border-color: rgba($light-green, 0.42);\n}\n\n.assignment-view-card--other {\n  border-color: rgba($medium-light-grey, 0.22);\n  opacity: 0.92;\n}\n\n// Family accent glow on header (fallback when no org section / special-group color)\n.assignment-view-card--family-capital {\n  .assignment-view-card__header:not([class*=\"mo-structure-card-bg-\"]) {\n    background: linear-gradient(\n      135deg,\n      rgba($very-dark-orange, 0.55),\n      rgba($dark-orange, 0.35)\n    );\n    border-bottom-color: rgba($very-light-yellow, 0.35);\n  }\n}\n\n.assignment-view-card--family-infantry {\n  .assignment-view-card__header:not([class*=\"mo-structure-card-bg-\"]) {\n    background: linear-gradient(\n      135deg,\n      rgba($dark-green, 0.55),\n      rgba($darker-green, 0.32)\n    );\n    border-bottom-color: rgba($light-green, 0.28);\n  }\n}\n\n.assignment-view-card--family-convoy {\n  border-color: rgba($event-planner-ground-panel-border, 0.68);\n\n  .assignment-view-card__header:not([class*=\"mo-structure-card-bg-\"]):not(\n      .assignment-view-card__header--ground-theme\n    ) {\n    background: transparent;\n    border-bottom-color: rgba($event-planner-ground-border, 0.52);\n  }\n}\n\n.assignment-view-card__header--ground-theme:not([class*=\"mo-structure-card-bg-\"]) {\n  background: linear-gradient(\n    145deg,\n    rgba($event-planner-ground-surface, 0.96),\n    rgba($event-planner-ground-accent, 0.92)\n  ) !important;\n  border-bottom-color: rgba($event-planner-ground-border, 0.52) !important;\n  box-shadow: inset 0 1px 0 rgba($event-planner-ground-slot-border, 0.14);\n}\n\n.assignment-view-card--family-fighters,\n.assignment-view-card--family-ship {\n  .assignment-view-card__header:not([class*=\"mo-structure-card-bg-\"]) {\n    background: linear-gradient(\n      135deg,\n      rgba($accent-blue, 0.38),\n      rgba($dark-blue-grey, 0.55)\n    );\n    border-bottom-color: rgba($very-light-grey, 0.12);\n  }\n}\n\n.assignment-view-card__header {\n  padding: 0;\n  border-bottom: 1px solid rgba($accent-blue, 0.2);\n  background: rgba($dark-blue-grey, 0.35);\n\n  &[class*=\"mo-structure-card-bg-\"] {\n    border-bottom-color: rgba($very-light-grey, 0.12);\n    box-shadow: none;\n  }\n}\n\n.assignment-view-card__header-inner {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n  padding: 0.6rem 0.8rem;\n}\n\n.assignment-view-card__header--with-image {\n  @include assignment-view-header-with-vehicle-image(88px);\n\n  &[class*=\"mo-structure-card-bg-\"] {\n    background-color: transparent;\n  }\n\n  .assignment-view-card__header-inner {\n    position: relative;\n    z-index: 2;\n    min-height: 88px;\n  }\n\n  .assignment-view-card__header-main {\n    max-width: calc(100% - 4.25rem);\n  }\n}\n\n.assignment-view-card--family-capital .assignment-view-card__header--with-image:not([class*=\"mo-structure-card-bg-\"]) {\n  border-bottom-color: rgba($very-light-grey, 0.14);\n}\n\n.assignment-view-card__header-main {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.7rem;\n  flex: 1 1 auto;\n  min-width: 0;\n  max-width: calc(100% - 4.25rem);\n}\n\n.assignment-view-card__heading {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  min-width: 0;\n\n  h4 {\n    margin: 0;\n    font-size: 1.08rem;\n    font-weight: 700;\n    color: $very-light-grey;\n    line-height: 1.2;\n    letter-spacing: 0.01em;\n    overflow-wrap: anywhere;\n  }\n}\n\n.assignment-view-card__header-vehicle {\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: rgba($very-light-grey, 0.72);\n  line-height: 1.25;\n  letter-spacing: 0.04em;\n}\n\n.assignment-view-card__kind {\n  font-size: 0.64rem;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.55);\n}\n\n%assignment-view-command-ship-chip {\n  display: inline-flex;\n  align-items: center;\n  align-self: flex-start;\n  border-radius: 999px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: $very-light-orange;\n  background: rgba($very-dark-orange, 0.82);\n  border: 1px solid rgba($light-orange, 0.78);\n  box-shadow:\n    0 0 0 1px rgba($orange, 0.22),\n    0 2px 8px rgba($very-dark-orange, 0.35);\n}\n\n.assignment-view-card__command-chip {\n  @extend %assignment-view-command-ship-chip;\n  padding: 0.24rem 0.64rem;\n  font-size: 0.64rem;\n}\n\n.assignment-view-card__meta {\n  margin: 0;\n  font-size: 0.74rem;\n  color: rgba($very-light-grey, 0.58);\n}\n\n.assignment-view-card__body {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n  padding: 0.65rem 0.8rem 0.8rem;\n  background: rgba($dark-blue, 0.28);\n}\n\n.assignment-view-card__body--summary,\n.assignment-view-card__body--compact {\n  padding: 0.65rem 0.85rem 0.8rem;\n  gap: 0.45rem;\n}\n\n.assignment-view-card--group .assignment-view-card__body--summary,\n.assignment-view-card--group .assignment-view-card__body--compact {\n  &:has(.assignment-view-card__nested-grid) {\n    gap: $assignment-view-nested-gap;\n  }\n}\n\n.assignment-view-card--group .assignment-view-card__body {\n  gap: $assignment-view-nested-gap;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.assignment-view-card--group .assignment-view-card__nested-grid {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  gap: $assignment-view-nested-gap;\n  width: max-content;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n\n  .assignment-view-nested-team {\n    flex: 0 0 $assignment-view-team-max-width;\n    width: $assignment-view-team-max-width;\n    min-width: 0;\n    max-width: 100%;\n  }\n}\n\n.assignment-view-card__nested-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(0, $assignment-view-team-max-width));\n  gap: $assignment-view-nested-gap;\n  width: 100%;\n  min-width: 0;\n}\n\n.assignment-view-card__nested-grid--multi-team,\n.assignment-view-card__nested-grid--fighter-sections,\n.assignment-view-card__nested-grid--infantry-teams,\n.assignment-view-card__nested-grid--convoy-vehicles {\n  max-width: #{\"min(100%, #{$assignment-view-group-two-col-min-width})\"};\n  //padding: 0.75rem 0 0.25rem;\n}\n\n.assignment-view-card__nested-grid--multi-team,\n.assignment-view-card__nested-grid--fighter-sections,\n.assignment-view-card__nested-grid--convoy-vehicles {\n  .assignment-view-nested-team {\n    min-height: 100%;\n  }\n}\n\n.assignment-view-stats {\n  display: inline-flex;\n  align-items: center;\n  flex: 0 0 auto;\n  margin-left: auto;\n  padding: 0.22rem 0.55rem;\n  border-radius: 999px;\n  background: rgba($dark-blue, 0.85);\n  border: 1px solid rgba($light-blue, 0.48);\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: $light-blue;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n}\n\n// Planner search — same highlight/dim language as edit mode.\n.assignment-view-card.is-planner-highlighted,\n.assignment-view-nested-team.is-planner-highlighted {\n  border-color: $light-orange !important;\n  box-shadow: 0 0 0 2px rgba($light-orange, 0.5) !important;\n}\n\n.assignment-view-position-row.is-planner-highlighted,\n.assignment-view-commander-row.is-planner-highlighted {\n  border-color: rgba($light-orange, 0.72);\n  box-shadow: inset 0 0 0 1px rgba($light-orange, 0.45);\n}\n\n.assignment-view-card.is-planner-dimmed,\n.assignment-view-nested-team.is-planner-dimmed {\n  opacity: 0.34;\n  filter: blur(1.4px);\n  transition: opacity 0.18s ease, filter 0.18s ease, border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.assignment-view-card--selectable,\n.assignment-view-nested-team--selectable {\n  cursor: pointer;\n}\n\n.assignment-view-board-canvas.is-filiation-focus-active {\n  .event-planner-view__card-link-path:not(.is-highlighted),\n  .event-planner-view__card-link-arrow:not(.is-highlighted) {\n    opacity: 0.22;\n  }\n}\n\n// ── Commander ────────────────────────────────────────────────\n\n.assignment-view-commander-row {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.35rem;\n  padding: 0.45rem 0.55rem;\n  border-radius: 10px;\n  background: rgba($dark-blue-grey, 0.35);\n  border: 1px solid rgba($accent-blue, 0.14);\n}\n\n.assignment-view-commander-row__label {\n  font-size: 0.64rem;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.48);\n}\n\n// ── Nested team ──────────────────────────────────────────────\n\n.assignment-view-nested-team {\n  min-width: 0;\n  max-width: $assignment-view-team-max-width;\n  width: 100%;\n  box-sizing: border-box;\n  border-radius: 12px;\n  overflow: hidden;\n  border: 1px solid rgba($accent-blue, 0.22);\n  background: rgba($dark-blue-grey, 0.38);\n}\n\n.assignment-view-nested-team--own {\n  border-color: rgba($light-blue, 0.45);\n  box-shadow: inset 0 0 0 1px rgba($light-blue, 0.12);\n}\n\n.assignment-view-nested-team--related {\n  border-color: rgba($light-green, 0.3);\n}\n\n.assignment-view-nested-team__header {\n  padding: 0.55rem 0.75rem;\n  border-bottom: 1px solid rgba($very-light-grey, 0.08);\n  background: rgba($dark-blue, 0.35);\n\n  &[class*=\"mo-structure-card-bg-\"] {\n    box-shadow: none;\n  }\n\n  h5 {\n    margin: 0;\n    font-size: 0.9rem;\n    font-weight: 700;\n    color: $very-light-grey;\n  }\n}\n\n.assignment-view-nested-team__header--with-image {\n  @include assignment-view-header-with-vehicle-image(65px);\n\n  &[class*=\"mo-structure-card-bg-\"] {\n    background-color: transparent;\n  }\n\n  h5 {\n    color: $very-light-grey;\n  }\n\n  .assignment-view-nested-team__header-content {\n    position: relative;\n    z-index: 2;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    gap: 0.22rem;\n    max-width: 48%;\n    //min-height: 76px;\n    padding: 0.55rem 0.75rem;\n  }\n\n  .assignment-view-nested-team__header-vehicle {\n    font-size: 0.68rem;\n    font-weight: 600;\n    color: rgba($very-light-grey, 0.72);\n    line-height: 1.25;\n  }\n}\n\n.assignment-view-nested-team__body {\n  padding: 0.55rem 0.65rem 0.7rem;\n}\n\n.assignment-view-nested-team--ground-vehicle {\n  min-height: 100%;\n\n  .assignment-view-nested-team__body {\n    padding-top: 0.45rem;\n  }\n}\n\n// ── Member line ──────────────────────────────────────────────\n\n.assignment-view-member-line {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.2rem;\n  min-width: 0;\n\n  .user-discord-rank--compact {\n    gap: 0.35rem;\n  }\n}\n\n.assignment-view-member-line__identity {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.assignment-view-member-line__you-badge {\n  font-size: 0.6rem;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  padding: 0.12rem 0.4rem;\n  border-radius: 999px;\n  background: rgba($light-blue, 0.2);\n  border: 1px solid rgba($light-blue, 0.45);\n  color: $light-blue;\n}\n\n.assignment-view-member-line__guest-badge {\n  display: inline-flex;\n  align-items: center;\n  min-height: 1.2rem;\n  padding: 0.08rem 0.42rem;\n  border: 1px solid rgba($light-orange, 0.55);\n  border-radius: 999px;\n  color: $very-light-orange;\n  background: rgba($orange, 0.42);\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  line-height: 1.25;\n  text-transform: lowercase;\n  white-space: nowrap;\n}\n\n// ── Position rows ────────────────────────────────────────────\n\n.assignment-view-team-body__positions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.assignment-view-team-body__expand-row {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 0.35rem;\n}\n\n.assignment-view-team-body__fighter-slot {\n  padding: 0.55rem 0;\n  border-top: 1px solid rgba($accent-blue, 0.12);\n\n  &:first-child {\n    border-top: none;\n    padding-top: 0;\n  }\n}\n\n.assignment-view-team-body__fighter-slot-ship {\n  margin: 0 0 0.35rem;\n  font-size: 0.76rem;\n  font-weight: 600;\n  color: rgba($very-light-grey, 0.65);\n}\n\n.assignment-view-position-row {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0.35rem;\n  padding: 0.35rem 0.45rem;\n  border-radius: 8px;\n  background: rgba($dark-blue, 0.22);\n}\n\n.assignment-view-position-row--viewer {\n  background: rgba($accent-blue, 0.16);\n  outline: 1px solid rgba($light-blue, 0.3);\n}\n\n.assignment-view-position-row__member {\n  min-width: 0;\n  width: 100%;\n}\n\n.assignment-view-position-row__leading {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n  min-width: 0;\n}\n\n.assignment-view-position-row__ship {\n  font-size: 0.68rem;\n  font-weight: 600;\n  color: rgba($very-light-grey, 0.55);\n  line-height: 1.2;\n}\n\n.assignment-view-position-row__role {\n  font-size: 0.64rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.46);\n}\n\n.assignment-view-position-row__empty {\n  font-size: 0.8rem;\n  color: rgba($very-light-grey, 0.42);\n  font-style: italic;\n}\n\n.assignment-view-vehicle-thumb {\n  display: block;\n  width: auto;\n  max-width: 100%;\n  height: auto;\n  object-fit: contain;\n  object-position: left center;\n\n  &--inline {\n    max-height: 28px;\n    margin-bottom: 0.1rem;\n  }\n\n  &--hero {\n    max-height: 72px;\n    max-width: 90%;\n    margin: 0 auto;\n    opacity: 0.92;\n  }\n}\n\n// ── Sidebar ──────────────────────────────────────────────────\n\n.assignment-view-sidebar {\n  grid-area: sidebar;\n  min-width: 0;\n  min-height: 0;\n  overflow-x: clip;\n  overflow-y: auto;\n  padding: 1rem 1rem 1.15rem;\n  border-left: 1px solid rgba($accent-blue, 0.2);\n  background: rgba($dark-blue, 0.5);\n  display: flex;\n  flex-direction: column;\n  gap: 1.15rem;\n}\n\n.assignment-view-sidebar__section-header {\n  h3 {\n    margin: 0;\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.09em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.5);\n  }\n}\n\n.assignment-view-sidebar__section--role,\n.assignment-view-sidebar__section--notes,\n.assignment-view-sidebar__section--loadout,\n.assignment-view-sidebar__section--owned-vehicles {\n  border: 1px solid rgba($accent-blue, 0.25);\n  border-radius: 12px;\n  background: rgba($dark-blue-grey, 0.45);\n  padding: 0.7rem 0.8rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.assignment-view-sidebar__notes {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.assignment-view-sidebar__section--notes .assignment-view-sidebar__note {\n  border: 1px solid rgba($accent-blue, 0.18);\n  border-radius: 8px;\n  background: rgba($dark-blue, 0.42);\n  padding: 0.6rem 0.7rem;\n}\n\n.assignment-view-sidebar__note-header {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  margin-bottom: 0.45rem;\n\n  h4 {\n    margin: 0;\n    font-size: 0.86rem;\n    font-weight: 600;\n    color: $very-light-grey;\n  }\n}\n\n.assignment-view-sidebar__note-icon {\n  width: 0.95rem;\n  height: 0.95rem;\n  opacity: 0.7;\n}\n\n.assignment-view-sidebar__note-body {\n  font-size: 0.84rem;\n  line-height: 1.45;\n  color: rgba($very-light-grey, 0.86);\n}\n\n.assignment-view-sidebar__viewer-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  padding: 0.7rem 0.8rem;\n  border-radius: 12px;\n  border: 1px solid rgba($light-blue, 0.28);\n  background: rgba($accent-blue, 0.1);\n}\n\n.assignment-view-sidebar__viewer-role {\n  margin: 0;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: rgba($light-blue, 0.88);\n}\n\n.assignment-view-sidebar__owned-vehicles {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.assignment-view-sidebar__loadout-card {\n  border: 1px solid rgba($accent-blue, 0.18);\n  border-radius: 8px;\n  background: rgba($dark-blue, 0.42);\n  padding: 0.55rem 0.65rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.assignment-view-sidebar__loadout-meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 0.35rem;\n}\n\n.assignment-view-sidebar__loadout-team {\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: $very-light-grey;\n}\n\n.assignment-view-sidebar__loadout-position {\n  font-size: 0.66rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgba($light-blue, 0.82);\n}\n\n.assignment-view-sidebar__owned-vehicle {\n  border: 1px solid rgba($accent-blue, 0.18);\n  border-radius: 8px;\n  background: rgba($dark-blue, 0.42);\n  padding: 0.55rem 0.65rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n\n.assignment-view-sidebar__owned-vehicle-operator {\n  margin: 0;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.28rem;\n  font-size: 0.78rem;\n  margin-top: 0.2rem;\n  line-height: 1.3;\n  color: rgba($very-light-grey, 0.82);\n}\n\n.assignment-view-sidebar__owned-vehicle-role {\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: capitalize;\n  color: rgba($light-blue, 0.88);\n}\n\n.assignment-view-sidebar__owned-vehicle-separator {\n  color: rgba($very-light-grey, 0.45);\n}\n\n.assignment-view-sidebar__owned-vehicle-moniker {\n  font-weight: 600;\n  color: $very-light-grey;\n}\n\n.assignment-view-sidebar__owned-vehicle-self-tag {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.1rem 0.38rem;\n  border-radius: 999px;\n  border: 1px solid rgba($light-blue, 0.35);\n  background: rgba($accent-blue, 0.16);\n  font-size: 0.58rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgba($light-blue, 0.92);\n}\n\n.assignment-view-sidebar__owned-vehicle-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.28rem;\n  list-style: none;\n  margin: 0.35rem 0 0;\n  padding: 0;\n}\n\n.assignment-view-sidebar__owned-vehicle-tag {\n  display: inline-flex;\n  align-items: center;\n  max-width: 100%;\n  padding: 0.12rem 0.42rem;\n  border-radius: 999px;\n  border: 1px solid rgba($light-orange, 0.42);\n  background: linear-gradient(\n    90deg,\n    rgba($dark-orange, 0.42),\n    rgba($orange, 0.18)\n  );\n  font-size: 0.58rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  color: $very-light-orange;\n  box-shadow: inset 0 1px 0 rgba($very-light-yellow, 0.12);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n// ── Role path ────────────────────────────────────────────────\n\n.assignment-view-role-path {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.assignment-view-role-path__step {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n  padding: 0.6rem 0;\n  position: relative;\n\n  &:not(:last-child)::after {\n    content: \"\";\n    position: absolute;\n    left: 0.95rem;\n    top: 2.35rem;\n    bottom: 0;\n    width: 0;\n    border-left: 2px dashed rgba($accent-blue, 0.38);\n  }\n}\n\n.assignment-view-role-path__marker {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.9rem;\n  height: 1.9rem;\n  border-radius: 10px;\n  border: 1px solid rgba($light-blue, 0.35);\n  background: rgba($dark-blue-grey, 0.65);\n  flex-shrink: 0;\n}\n\n.assignment-view-role-path__marker-icon {\n  width: 1rem;\n  height: 1rem;\n  opacity: 0.85;\n}\n\n.assignment-view-role-path__content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n  min-width: 0;\n  padding-top: 0.1rem;\n}\n\n.assignment-view-role-path__relation {\n  font-size: 0.62rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.45);\n}\n\n.assignment-view-role-path__label-block {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n  min-width: 0;\n}\n\n.assignment-view-role-path__kind {\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.55);\n}\n\n.assignment-view-role-path__command-chip {\n  @extend %assignment-view-command-ship-chip;\n  padding: 0.18rem 0.52rem;\n  font-size: 0.6rem;\n}\n\n.assignment-view-role-path__label {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: $very-light-grey;\n  line-height: 1.2;\n  overflow-wrap: anywhere;\n}\n\n.assignment-view-role-path__position {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: capitalize;\n  color: rgba($light-blue, 0.88);\n  line-height: 1.25;\n  overflow-wrap: anywhere;\n}\n\n.assignment-view-role-path__vehicle-name {\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: rgba($very-light-grey, 0.72);\n  line-height: 1.25;\n  letter-spacing: 0.04em;\n  overflow-wrap: anywhere;\n}\n\n.assignment-view-role-path__stats {\n  font-size: 0.74rem;\n  font-weight: 600;\n  color: rgba($light-blue, 0.82);\n}\n\n@media (max-width: 960px) {\n  .event-assignment-view__workspace {\n    grid-template-columns: 1fr;\n    grid-template-areas:\n      \"main\"\n      \"sidebar\"\n      \"legend\";\n  }\n\n  .assignment-view-sidebar {\n    border-left: none;\n    border-top: 1px solid rgba($accent-blue, 0.2);\n  }\n}\n\n@media (max-width: 900px) {\n  .assignment-view-card__nested-grid--multi-team,\n  .assignment-view-card__nested-grid--fighter-sections,\n  .assignment-view-card__nested-grid--infantry-teams,\n  .assignment-view-card__nested-grid--convoy-vehicles {\n    width: 100%;\n    max-width: 100%;\n\n    .assignment-view-nested-team {\n      flex: 1 1 100%;\n      width: 100%;\n      max-width: 100%;\n    }\n  }\n}\n\n@media (max-width: 640px) {\n  .assignment-view-card--team {\n    min-width: 0;\n    max-width: 100%;\n\n    &.assignment-view-card--layout-tree,\n    &.assignment-view-card--layout-focus,\n    &.assignment-view-card--layout-parent,\n    &.assignment-view-card--layout-periphery,\n    &.assignment-view-card--size-focus,\n    &.assignment-view-card--size-chain,\n    &.assignment-view-card--size-peer {\n      min-width: 0;\n      max-width: 100%;\n    }\n  }\n\n  .assignment-view-inline-peer-row > .assignment-view-card--team,\n  .assignment-view-standalone-ship-row > .assignment-view-card--team,\n  .assignment-view-board__standalone-ships .assignment-view-inline-peer-row\n    > .assignment-view-card--team,\n  .assignment-view-board__standalone-ships .assignment-view-standalone-ship-row\n    > .assignment-view-card--team {\n    flex: 0 0 $assignment-view-team-max-width;\n    width: $assignment-view-team-max-width;\n    min-width: $assignment-view-team-max-width;\n    max-width: $assignment-view-team-max-width;\n  }\n\n  .assignment-view-inline-peer-row > .assignment-view-card--team,\n  .assignment-view-fighter-flight-row > .assignment-view-card--team,\n  .assignment-view-board__fighter-flights .assignment-view-inline-peer-row\n    > .assignment-view-card--team,\n  .assignment-view-board__fighter-flights .assignment-view-fighter-flight-row\n    > .assignment-view-card--team {\n    flex: 0 0 $assignment-view-team-max-width;\n    width: $assignment-view-team-max-width;\n    min-width: $assignment-view-team-max-width;\n    max-width: $assignment-view-team-max-width;\n  }\n\n  .assignment-view-inline-peer-row,\n  .assignment-view-standalone-ship-row,\n  .assignment-view-fighter-flight-row,\n  .assignment-view-infantry-peer-row,\n  .assignment-view-convoy-peer-row {\n    overflow-x: auto;\n    justify-content: flex-start;\n    padding-bottom: 0.25rem;\n  }\n\n  .assignment-view-inline-peer-row > .assignment-view-card--team,\n  .assignment-view-infantry-peer-row > .assignment-view-card--team,\n  .assignment-view-board__infantry-peers .assignment-view-inline-peer-row\n    > .assignment-view-card--team,\n  .assignment-view-board__infantry-peers .assignment-view-infantry-peer-row\n    > .assignment-view-card--team {\n    flex: 0 0 $assignment-view-team-max-width;\n    width: $assignment-view-team-max-width;\n    min-width: $assignment-view-team-max-width;\n    max-width: $assignment-view-team-max-width;\n  }\n\n  .assignment-view-inline-peer-row > .assignment-view-card--team,\n  .assignment-view-convoy-peer-row > .assignment-view-card--team,\n  .assignment-view-board__convoy-peers .assignment-view-inline-peer-row\n    > .assignment-view-card--team,\n  .assignment-view-board__convoy-peers .assignment-view-convoy-peer-row\n    > .assignment-view-card--team {\n    flex: 0 0 $assignment-view-team-max-width;\n    width: $assignment-view-team-max-width;\n    min-width: $assignment-view-team-max-width;\n    max-width: $assignment-view-team-max-width;\n  }\n\n  .assignment-view-nested-team {\n    min-width: 0;\n    max-width: 100%;\n  }\n\n  .assignment-view-card--layout-tree,\n  .assignment-view-card--layout-focus,\n  .assignment-view-card--size-focus,\n  .assignment-view-card--group.assignment-view-card--layout-tree,\n  .assignment-view-card--group.assignment-view-card--size-focus,\n  .assignment-view-card--command-ship.assignment-view-card--layout-tree,\n  .assignment-view-card--command-ship.assignment-view-card--size-focus {\n    max-width: 100%;\n  }\n\n  .assignment-view-commander-row,\n  .assignment-view-position-row {\n    gap: 0.3rem;\n  }\n\n  .assignment-view-tree__siblings {\n    flex-direction: column;\n    align-items: center;\n\n    &::before {\n      display: none;\n    }\n\n    > .assignment-view-tree__branch::before {\n      display: none;\n    }\n  }\n}\n","@import './variables.scss';\n\n.ribbons-edition {\n    position: relative; // Nécessaire pour le centrage\n    display: flex;\n    flex-direction: row;\n\n    .ribbon-viual-editor {\n        display: flex;\n        flex-direction: column;\n        width: 108%;\n        margin: 0px 20px 0px 20px ;\n        align-items: center;\n    }\n}\n\n.link-chain {\n    height: 25px;\n    margin: 0;\n}\n\n.ribbon-overlay-container {\n    position: relative;\n    display: inline-block;\n    //width: 42.5%; \n\n    &.table {\n        width: 100%; \n        margin: 10px auto 5px auto ;\n    }\n\n    .ribbon-image {\n        display: block;\n        width: 100%; \n        height: auto; \n    }\n\n    .color-rect {\n        position: absolute;\n        top: 17%;\n        height: 64%;\n        //width: attr(data-width percentage); /* Utilisation des valeurs dynamiques */\n        //background-color: attr(data-color color); /* Attribue la couleur */\n        border-radius: 10%;\n        box-shadow: none;\n        transition: background-color 0.3s ease, box-shadow 0.3s ease;\n\n        width: var(--rect-width, 9.8%);\n        background-color: var(--rect-color, transparent);\n        \n        &[data-color] {\n            background-color: attr(data-color color, initial); // Si attr() est supporté\n        }\n\n        &.color-selected {\n            box-shadow: 0 8px 13px rgba(0, 0, 0, 0.5), inset 0 2px 4px rgba(255, 255, 255, 0.3), inset 0 -3px 2px rgba(0, 0, 0, 0.5);\n            background-image:   linear-gradient(145deg, rgba(255, 255, 255, 0.4), rgba(0, 0, 0, 0.2)), \n                            repeating-linear-gradient(45deg, transparent, transparent 2px, rgba(255, 255, 255, 0.07) 2px, rgba(255, 255, 255, 0.07) 3px);\n            background-blend-mode: overlay, overlay;\n\n            &:first-child {\n                border-radius: 10% 0 0 10%;\n            }\n    \n            &:last-child {\n                border-radius: 10% ;\n            }\n        }\n\n        &.first-linked {\n            border-radius: 10% 0 0 10%; // Radius gauche seulement\n        }\n    \n        &.last-linked {\n            border-radius: 0 10% 10% 0; // Radius droite seulement\n        }\n    \n        &.middle-linked {\n            border-radius: 0; // Pas de radius pour les rectangles du milieu\n        }\n\n        \n        .add-image-icon {\n            position: absolute;\n            top: 5%;\n            right: 5%;\n            width: 20px;\n            height: 20px;\n            z-index: 300;\n            cursor: pointer;\n        }\n    \n        .group-image {\n            display: block;\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            max-height: 90%;\n            max-width: 90%;\n            transform: translate(-50%, -50%);\n            object-fit: contain;\n            filter: drop-shadow(0 2px 1px rgba(0, 0, 0, 0.7));\n            z-index: 100;\n        }\n    }\n\n    @for $i from 1 through 210 {\n        .width-#{$i} {\n            width: #{($i / 10) * 1%}; // Sass calcule les unités correctement\n        }\n    }    \n\n    .rect-1 {\n        left: 6%;\n        z-index: 200;\n    }\n\n    .rect-2 {\n        left: 17.125%;\n        z-index: 190;\n    }\n\n    .rect-3 {\n        left: 28.25%;\n        z-index: 180;\n    }\n\n    .rect-4 {\n        left: 39.375%;\n        z-index: 170;\n    }\n\n    .rect-5 {\n        left: 50.5%;\n        z-index: 160;\n    }\n\n    .rect-6 {\n        left: 61.625%;\n        z-index: 150;\n    }\n\n    .rect-7 {\n        left: 72.75%;\n        z-index: 140;\n    }\n\n    .rect-8 {\n        left: 83.875%;\n        z-index: 130;\n    }\n}\n\n.colorPicker-container-horizontal {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start; \n    margin-top: -10px; \n    margin-left: 0px;\n    width: 81%; \n}\n\n.colorPicker-container-horizontal .colorPicker {\n    margin-left: calc((100% - 8 * 10.125%) / 16); // Espacement uniforme sous chaque rectangle\n    margin-right: calc((100% - 8 * 10.125%) / 16); \n}\n\n.link-chain {\n    height: 25px;\n    margin: 0 8px;\n}\n\n.link-chain.rotated {\n    position: relative;\n    transform: rotate(90deg);\n    bottom: 3px;\n}\n\n\n\n.link-symbol {\n    position: relative;\n    font-size: 1.5em;\n    bottom: 7px;\n    cursor: pointer;\n\n    &.disable {\n        color: $light-grey; \n    }\n\n    &.enable {\n        color: $red;\n    }\n}\n\n.ribbon-viual-editor.hidden {\n    visibility: hidden;\n}\n\n.clear-icon {\n    position: relative;\n    height: 30px;\n    cursor: pointer;\n}\n\n.statusRibbons {\n    text-align: center; /* Centre le contenu du texte ou autre contenu de la cellule */\n}\n\n.ribbons-qty-input {\n    width: 100%;\n    max-width: 44px;\n    text-align: center;\n    box-sizing: border-box;\n}\n\n.default-btn {\n    &.ribbons {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        //justify-content: center;\n        gap: 10px;\n    }\n}\n","// src/styles/colorpicker.scss\n\n@import '../variables.scss';\n\n\n.colorPicker {\n  border: 1px solid #9c99a3;\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n}\n.colorPicker:not(:last-child) {\n  margin-right: 1px;\n}\n\n.color-picker-tooltip {\n  position: relative;\n  z-Index: 100;\n  transform: translate(-30%, 60%);\n}\n\n.color-picker-flex {\n  .colorPicker {\n      border-radius: 50%;\n\n      &.border-left {\n          border-radius: 12px 0 0 12px; // Radius gauche seulement\n      }\n\n      &.middle {\n        border-radius: 0;\n      }\n\n      &.border-right {\n          border-radius: 0 12px 12px 0; // Radius droite seulement\n      }\n  }\n}\n\n\n.color-picker-container {\n  display: flex;\n  flex-direction: row !important;\n  align-items: center;\n  margin-bottom: 0px;\n\n  .color-picker-flex {\n    display: flex;\n  }\n}\n\n.color-picker-container label {\n  margin-right: 10px;\n  width: 110px;\n}\n\n/* Masquer spécifiquement les champs R, G, B et A */\n.color-picker-container .flexbox-fix > div:nth-child(2),\n.color-picker-container .flexbox-fix > div:nth-child(3),\n.color-picker-container .flexbox-fix > div:nth-child(4),\n.color-picker-container .flexbox-fix > div:nth-child(5) {\n    display: none !important;\n}\n\n.color-picker-wrapper {\n  position: absolute;\n  background: $very-dark-grey;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\n  border-radius: 6px;\n  padding: 10px;\n  width: 185px;\n  z-index: 9999;\n  display: flex;\n  flex-direction: column;\n  transform: translate(0px, 8px);\n  border: 1px solid $dark-red;\n}\n\n/* ✅ Zone d'entrée Hex */\n.color-picker-hex {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.color-picker-hex label {\n  font-size: 14px;\n  color: $light-grey;\n  font-weight: 600;\n}\n\n.color-picker-hex input {\n  width: 80px;\n  padding: 3px;\n  border: 1px solid $dark-red;\n  border-radius: 4px;\n  text-align: center;\n  font-size: 14px;\n}\n\n/* ✅ Grille de couleurs pré-sélectionnées */\n.color-picker-grid {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 6px;\n  margin-bottom: 8px;\n}\n\n.color-picker-grid button {\n  width: 18px;\n  height: 18px;\n  border: 1px solid $grey;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n\n  &.preset-transparent {\n    border: 1px solid white;\n  }\n}\n\n.color-picker-grid button:hover {\n  transform: scale(1.05);\n  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);\n}\n\n.color-picker-grid button.active {\n  border: 2px solid black;\n}\n\n/* ✅ Palette de couleurs (saturation box) */\n.color-picker-saturation {\n  position: relative;\n  width: 100%;\n  height: 120px;\n  border-radius: 2px;\n  cursor: crosshair;\n  margin-bottom: 10px;\n}\n\n.color-picker-saturation-hue {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 2px;\n  pointer-events: none; /* Empêche l'interaction avec ce div */\n}\n\n.color-picker-saturation-brightness {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 2px;\n  pointer-events: none; /* Empêche l'interaction avec ce div */\n}\n\n.color-picker-saturation_cursor {\n  position: absolute;\n  width: 7px;\n  height: 7px;\n  border: 1px solid white;\n  border-radius: 50%;\n  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);\n  transform: translate(-50%, -50%);\n}\n\n/* ✅ Barre de teinte (hue slider) */\n.color-picker-hue {\n  position: relative;\n  width: 100%;\n  height: 14px;\n  background: linear-gradient(\n    to right,\n    red, orange, yellow, green, cyan, blue, purple, red\n  );\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.color-picker-hue_cursor {\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  border: 2px solid white;\n  border-radius: 50%;\n  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);\n  transform: translate(-50%, -13%);\n}\n\n","@import \"../variables.scss\";\n\n.sc-item-chip {\n  display: inline-flex;\n  align-items: center;\n  max-width: 100%;\n  //padding: 3px 7px;\n  border-radius: 6px;\n  font-size: 11px;\n  line-height: 1.2;\n  color: $pure-white;\n  background: $sc-item-bg;\n  border: 1px solid $sc-item-accent-secondary;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  cursor: default;\n  position: relative;\n  box-sizing: border-box;\n\n  &--removable {\n    gap: 5px;\n  }\n\n  &--locked {\n    .sc-item-chip__unit-qty-value,\n    .sc-item-chip__unit-quality-value {\n      background: transparent;\n    }\n  }\n\n.sc-item-chip__trigger {\n    display: inline-flex;\n    align-items: center;\n    min-width: 0;\n    flex: 1 1 auto;\n    gap: 6px;\n    margin: 0 6px;\n    padding: 5px 6px 5px;\n    border: 0;\n    background: transparent;\n    color: inherit;\n    font: inherit;\n    line-height: inherit;\n    cursor: default;\n    text-align: left;\n    flex-wrap: wrap;\n    row-gap: 2px;\n\n    &:disabled {\n      opacity: 0.55;\n      cursor: not-allowed;\n    }\n\n    .sc-item-chip__label {\n      flex: 1 1 auto;\n      min-width: 0;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      max-width: 100%;\n      text-transform: capitalize;\n    }\n  }\n\n  &__trailing {\n    flex: 0 0 auto;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  &__meta-sep {\n    flex: 0 0 auto;\n    opacity: 0.65;\n    font-weight: 700;\n  }\n\n  &__unit {\n    flex: 0 0 auto;\n    display: inline-flex;\n    align-items: center;\n    gap: 1px;\n    padding: 1px 4px;\n    border-radius: 4px;\n    background: rgb(11, 16, 22);\n    color: rgba(255, 255, 255, 0.92);\n    font-weight: 700;\n    letter-spacing: 0.01em;\n    user-select: none;\n    cursor: text;\n  }\n\n  &__unit.is-editing {\n    background: rgba(255, 255, 255, 0.38);\n  }\n\n  &__unit-edit {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n  }\n\n  &__unit-kind-text {\n    opacity: 0.9;\n    font-weight: 700;\n  }\n\n  &__unit-qty-input,\n  &__unit-quality-input {\n    width: auto;\n    min-width: 0;\n    padding: 0;\n    margin: 0;\n    border: 0;\n    background: transparent;\n    color: inherit;\n    font: inherit;\n    line-height: inherit;\n    outline: none;\n    box-sizing: content-box;\n  }\n\n  &__unit-qty-input {\n    text-align: left;\n  }\n\n  &__unit-qty-input--active,\n  &__unit-quality-input--active {\n    field-sizing: content;\n  }\n\n  &__unit-quality-input {\n    text-align: left;\n  }\n\n  &__unit-qty-value,\n  &__unit-quality-value {\n    flex: 0 0 auto;\n    display: inline;\n    padding: 0 6px;\n    margin: 0;\n    border: 0;\n    border-radius: 2px;\n    background: rgba(255, 255, 255, 0.2);\n    color: $very-light-grey;\n    font: inherit;\n    line-height: inherit;\n    font-weight: 700;\n  }\n\n  &__unit-qty-value--editable,\n  &__unit-quality-value--editable {\n    cursor: text;\n    text-decoration: underline dotted rgba(255, 255, 255, 0.35);\n    text-underline-offset: 2px;\n\n    &:hover {\n      text-decoration-color: rgba(255, 255, 255, 0.65);\n    }\n  }\n\n  &__unit-quality-sep {\n    opacity: 0.8;\n    font-weight: 700;\n  }\n\n  &__unit-quality-q {\n    opacity: 0.9;\n    font-weight: 700;\n  }\n\n  &__remove {\n    flex: 0 0 auto;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 18px;\n    height: 21px;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    border-radius: 0px;\n    background: rgb(71, 49, 162);\n    color: rgba(255, 255, 255, 0.88);\n    cursor: pointer;\n    line-height: 1;\n  }\n\n  &__remove:hover {\n    background: rgb(77, 55, 168);\n    color: $pure-white;\n  }\n\n  &__remove-icon {\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 1;\n  }\n\n  &__card {\n    position: absolute;\n    min-width: 240px;\n    max-width: 360px;\n    padding: 0;\n    overflow: hidden;\n    border-radius: 8px;\n    color: $sc-item-text-primary;\n    background: $sc-item-bg;\n    border: 1px solid $sc-item-border;\n    z-index: 200000;\n    text-align: left;\n    white-space: normal;\n    box-shadow:\n      0 0 0 1px rgba(0, 0, 0, 0.2),\n      0 12px 40px rgba(0, 0, 0, 0.45),\n      0 0 28px $sc-item-accent-glow;\n\n    &--portal {\n      position: fixed;\n    }\n\n    &--fps {\n      min-width: 300px;\n      max-width: 440px;\n    }\n\n    &--blueprint {\n      min-width: 300px;\n      max-width: 440px;\n    }\n\n    &--ship {\n      min-width: 300px;\n      max-width: 350px;\n      padding: 0;\n    }\n  }\n\n  &__card-title {\n    margin: 0;\n    padding: 6px 12px 6px;\n    background: $sc-item-accent-primary;\n    color: $sc-item-text-primary;\n    border-bottom: 1px solid $sc-item-accent-secondary;\n    font-weight: 700;\n    font-size: 11px;\n    text-transform: uppercase;\n  }\n\n  &__card-content {\n    padding: 10px 12px 12px;\n  }\n\n  &__card-muted {\n    color: $sc-item-text-muted;\n  }\n\n  &__card-error {\n    color: $light-orange;\n  }\n}\n\n.sc-item-chip__bp {\n  min-width: 0;\n}\n\n.sc-item-chip__bp-subtitle {\n  font-size: 11px;\n  text-transform: uppercase;\n  color: $sc-item-text-secondary;\n  margin: 0 0 8px 0;\n  line-height: 1.35;\n}\n\n.sc-item-chip__bp-grid {\n  margin: 0 0 8px 0;\n}\n\n.sc-item-chip__bp-section {\n  margin-top: 8px;\n}\n\n.sc-item-chip__bp-ingredients {\n  margin: 4px 0 0 0;\n  padding: 0 0 0 1.1em;\n  list-style: disc;\n  color: $sc-item-text-primary;\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.sc-item-chip__bp-ingredients-item {\n  margin: 0 0 2px 0;\n  word-break: break-word;\n}\n\n.sc-item-chip__bp-ingredients-item:last-child {\n  margin-bottom: 0;\n}\n\n.sc-item-chip__bp-text {\n  font-size: 12px;\n  line-height: 1.4;\n  color: $sc-item-text-primary;\n  word-break: break-word;\n}\n\n.sc-item-chip__bp-craftable {\n  margin-top: 10px;\n  padding-top: 8px;\n  border-top: 1px solid $sc-item-border;\n}\n\n.sc-item-chip__bp-craftable .sc-item-chip__bp-craftable-grid,\n.sc-item-chip__bp-craftable-title + .sc-item-chip__bp-craftable-grid {\n  margin-top: 4px;\n}\n\n.sc-item-chip__bp-craftable-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: $sc-item-text-primary;\n  margin: 2px 0 4px 0;\n  word-break: break-word;\n}\n\n.sc-item-chip__fps-subtitle,\n.sc-item-chip__ship-subtitle {\n  font-size: 11px;\n  text-transform: uppercase;\n  color: $sc-item-text-primary;\n  margin: 8px 0 4px 0;\n  line-height: 1.35;\n}\n\n.sc-item-chip__card--ship .sc-item-chip__fps-more-panel--open {\n  max-height: 880px;\n}\n\n\n.sc-item-chip__ship-kpi {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px 10px;\n  margin: 0 0 10px 0;\n}\n\n.sc-item-chip__ship-size-line {\n  font-size: 11px;\n  font-weight: 600;\n  margin: 0 0 10px 0;\n  color: $sc-item-text-primary;\n}\n\n.sc-item-chip__ship-weaponry {\n  margin: 0 0 10px 0;\n}\n\n.sc-item-chip__ship-section-label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: $sc-item-text-secondary;\n  margin: 0 0 4px 0;\n}\n\n.sc-item-chip__fps-more-panel-inner .sc-item-chip__ship-section-label {\n  color: $sc-item-accent-primary;\n}\n\n.sc-item-chip__ship-section-label--spaced {\n  margin-top: 10px;\n}\n\n.sc-item-chip__ship-flight-base {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px 10px;\n  margin: 0 0 6px 0;\n}\n\n.sc-item-chip__ship-more-inner {\n  padding-bottom: 4px;\n}\n\n.sc-item-chip__ship-more-tabs {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin: 8px 0 10px 0;\n}\n\n.sc-item-chip__ship-more-tab {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%;\n  padding: 5px 10px;\n  border-radius: 6px;\n  border: 1px solid $sc-item-border;\n  background: $sc-item-surface;\n  cursor: pointer;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: $sc-item-text-secondary;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sc-item-chip__ship-more-tab:hover {\n  background: $sc-item-surface-hover;\n  color: $sc-item-text-primary;\n}\n\n.sc-item-chip__ship-more-tab.is-active {\n  border-color: $sc-item-accent-primary;\n  box-shadow: 0 0 0 3px $sc-item-accent-glow;\n  color: $sc-item-text-primary;\n}\n\n.sc-item-chip__ship-more-tabpanel {\n  padding-top: 2px;\n}\n\n.sc-item-chip__ship-dim,\n.sc-item-chip__ship-mass {\n  font-size: 11px;\n  line-height: 1.35;\n  margin: 0 0 4px 0;\n  color: $sc-item-text-secondary;\n}\n\n.sc-item-chip__ship-perf-grid {\n  margin-top: 4px;\n}\n\n.sc-item-chip__ship-line {\n  font-size: 12px;\n  line-height: 1.35;\n  margin: 6px 0 0 0;\n  color: $sc-item-text-primary;\n}\n\n.sc-item-chip__ship-insurance {\n  font-size: 11px;\n  margin: 8px 0 0 0;\n  line-height: 1.35;\n  color: $sc-item-text-muted;\n}\n\n.sc-item-chip__ship-components {\n  margin-top: 4px;\n}\n\n.sc-item-chip__ship-components-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 8px 10px;\n  margin-top: 4px;\n}\n\n.sc-item-chip__ship-comp-cell {\n  min-width: 0;\n  padding: 6px 6px;\n  border-radius: 6px;\n  border: 1px solid $sc-item-border;\n  background: $sc-item-surface;\n}\n\n.sc-item-chip__ship-comp-label {\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: $sc-item-text-secondary;\n  margin-bottom: 3px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sc-item-chip__ship-comp-value {\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.25;\n  word-break: break-word;\n  color: $sc-item-text-primary;\n}\n\n.sc-item-chip__fps-hero {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px 10px;\n  margin: 4px 0 10px 0;\n\n  &--triple {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n.sc-item-chip__fps-highlight {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px 10px;\n  margin: 0 0 8px 0;\n}\n\n.sc-item-chip__fps-kpi-grade-class-size {\n  margin: 4px 0 10px 0;\n}\n\n.sc-item-chip__fps-armor-foot {\n  font-size: 10px;\n  line-height: 1.35;\n  margin: 0 0 6px 0;\n  word-break: break-word;\n}\n\n.sc-item-chip__vi .sc-item-chip__fps-stat-value {\n  white-space: normal;\n  word-break: break-word;\n}\n\n.sc-item-chip__vi {\n  .sc-item-chip__fps-more-panel--open {\n    max-height: 260px;\n  }\n}\n\n.sc-item-chip__vi-uses-inner {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  min-width: 0;\n}\n\n.sc-item-chip__vi-uses-list-scroll {\n  max-height: 160px;\n  overflow-y: auto;\n  padding-right: 4px;\n  min-height: 0;\n  @include sc-item-scrollbar-styles();\n}\n\n.sc-item-chip__vi-uses-search-wrap {\n  margin: 0 0 6px 0;\n}\n\n.sc-item-chip__vi-uses-search-label {\n  display: block;\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: $sc-item-text-secondary;\n  margin: 0 0 4px 0;\n}\n\n.sc-item-chip__vi-uses-search {\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 6px 8px;\n  border-radius: 6px;\n  border: 1px solid $sc-item-border;\n  background: $sc-item-surface;\n  color: $sc-item-text-primary;\n  font-size: 12px;\n  line-height: 1.3;\n\n  &::placeholder {\n    color: $sc-item-text-muted;\n  }\n\n  &:focus {\n    outline: none;\n    border-color: $sc-item-accent-primary;\n    box-shadow: 0 0 0 2px $sc-item-accent-glow;\n  }\n}\n\n.sc-item-chip__vi-uses-filter-hint {\n  font-size: 10px;\n  color: $sc-item-text-secondary;\n  margin: 0 0 6px 0;\n}\n\n.sc-item-chip__vi-uses-empty {\n  margin: 0;\n  padding: 4px 0 2px 0;\n  font-size: 12px;\n  line-height: 1.35;\n  color: $sc-item-text-muted;\n}\n\n.sc-item-chip__vi-uses-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.sc-item-chip__vi-uses-item {\n  padding: 6px 0;\n  border-bottom: 1px solid $sc-item-border;\n\n  &:last-child {\n    border-bottom: none;\n    padding-bottom: 0;\n  }\n}\n\n.sc-item-chip__vi-uses-title {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.25;\n  color: $sc-item-text-primary;\n  word-break: break-word;\n}\n\n.sc-item-chip__vi-uses-meta {\n  font-size: 10px;\n  line-height: 1.3;\n  margin-top: 3px;\n  color: $sc-item-text-muted;\n  word-break: break-word;\n}\n\n.sc-item-chip__fps-more-row {\n  border-top: 1px solid $sc-item-border;\n  margin: 10px 0 0 0;\n  padding-top: 8px;\n}\n\n.sc-item-chip__fps-more-toggle {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  padding: 4px 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: $sc-item-accent-primary;\n  text-align: left;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n}\n\n.sc-item-chip__fps-more-toggle:hover {\n  color: $sc-item-accent-secondary;\n}\n\n.sc-item-chip__fps-more-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 15px;\n  border-radius: 4px;\n  border: 1px solid $sc-item-border;\n  background: $sc-item-surface;\n  color: $sc-item-text-primary;\n  font-weight: 800;\n  line-height: 1;\n  flex: 0 0 auto;\n}\n\n.sc-item-chip__fps-more-label {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.sc-item-chip__fps-more-panel {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.28s ease;\n}\n\n.sc-item-chip__fps-more-panel--open {\n  max-height: 520px;\n}\n\n.sc-item-chip__fps-more-panel-inner {\n  padding: 6px 0 2px 0;\n}\n\n.sc-item-chip__fps-more-panel-inner .sc-item-chip__fps-grid {\n  margin: 0;\n}\n\n.sc-item-chip__fps-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px 10px;\n  margin: 6px 0 10px 0;\n}\n\n.sc-item-chip__fps-stat-label {\n  font-size: 10px;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  margin-bottom: 2px;\n  color: $sc-item-text-secondary;\n}\n\n.sc-item-chip__fps-stat-value {\n  font-size: 12px;\n  font-weight: 600;\n  color: $sc-item-text-primary;\n  line-height: 1.2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sc-item-chip__card-desc--preline {\n  white-space: pre-line;\n  max-height: 220px;\n}\n\n.sc-item-chip__card-subtitle {\n  font-size: 11px;\n  color: $sc-item-text-secondary;\n  margin-bottom: 6px;\n}\n\n.sc-item-chip__card-meta {\n  font-size: 11px;\n  color: $sc-item-text-secondary;\n  margin-bottom: 6px;\n}\n\n.sc-item-chip__card-desc {\n  font-size: 12px;\n  line-height: 1.35;\n  max-height: 140px;\n  padding-right: 5px;\n  margin-right: 5px;\n  overflow: auto;\n  color: $sc-item-text-primary;\n  @include sc-item-scrollbar-styles();\n}\n\n.sc-item-chip__character-mention-desc {\n  margin-top: 8px;\n}\n\n.sc-item-chip__card-muted {\n  color: $sc-item-text-muted;\n}\n\n.sc-item-chip__card-error {\n  color: $light-orange;\n}\n\n","@import '../variables.scss';\n\n.rbc-calendar {\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    height: 100%;\n    width: $full-width;\n    margin-right: auto;\n    margin-left: auto;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-align: stretch;\n    -ms-flex-align: stretch;\n    align-items: stretch;\n\n    .rbc-toolbar-label{\n        color: $very-light-grey;\n        font-weight: bold;\n    }\n}\n\n/* Roster preview + main calendar detailed view: shared card shell (header/banner + panel chrome) */\n$rbc-month-column-gap: 10px;\n\n.rbc-month-view {\n    min-height: 66.7vh;\n    min-height: calc(100vh - 370px);\n    border: none;\n    border-radius: 8px;\n    /* visible pour que le zoom des cellules soit aussi vertical (pas seulement horizontal) */\n    overflow: visible;\n\n    /*\n     * Bandeau jours : continu (pas de gap), même esprit roster.\n     * Arrondi global = lundi à gauche / dimanche à droite (locale Lundi = premier jour).\n     */\n    > .rbc-row.rbc-month-header {\n        margin-bottom: 15px;\n        flex-shrink: 0;\n        gap: 0;\n        height: 45px;\n        border-radius: 10px;\n        overflow: hidden;\n        filter:\n            drop-shadow(0 3px 6px rgba(0, 0, 0, 0.5))\n            drop-shadow(0 6px 14px rgba(0, 0, 0, 0.35));\n        @include steel-bg(\"../medias/steel.png\");\n\n        .rbc-header {\n            flex: 1 1 0;\n            min-width: 0;\n            height: 100%;\n            display: flex;\n            align-items: center;\n            padding: 0 12px;\n            margin: 0;\n            border: none;\n            border-radius: 0;\n            color: $light-grey;\n            text-transform: uppercase;\n            font-size: 0.75em;\n            font-weight: 600;\n            cursor: default;\n            user-select: none;\n            text-align: left;\n            text-overflow: ellipsis;\n            overflow: hidden;\n            white-space: nowrap;\n            position: relative;\n            background: none;\n            background-image: none;\n            box-shadow:\n                inset 0 1px 0 rgba(255, 255, 255, 0.16),\n                inset 0 -1px 0 rgba(0, 0, 0, 0.18);\n\n            &:not(:last-child)::after {\n                content: '';\n                position: absolute;\n                right: 0;\n                top: 50%;\n                transform: translateY(-50%);\n                width: 1px;\n                height: 65%;\n                background-color: $grey;\n            }\n\n            .header-content {\n                width: 100%;\n                min-width: 0;\n                text-align: center;\n            }\n\n            .header-label {\n                display: block;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                white-space: nowrap;\n            }\n\n            a,\n            a:active,\n            a:visited {\n                color: inherit;\n            }\n        }\n    }\n\n    > .rbc-month-row + .rbc-month-row {\n        border-top: none;\n        margin-top: $rbc-month-column-gap;\n    }\n\n    .rbc-month-row > .rbc-row-bg {\n        gap: $rbc-month-column-gap;\n        overflow: visible;\n    }\n\n    .rbc-month-row .rbc-row-content {\n        display: grid;\n        overflow: visible;\n        gap: 3px;\n    }\n\n    .rbc-month-row .rbc-row-content > .rbc-row {\n        gap: $rbc-month-column-gap;\n    }\n\n    .rbc-day-bg + .rbc-day-bg {\n        border-left: none;\n    }\n\n    /* Bord type .roster-file-ribbon-card — fond par défaut .rbc-day-bg (#23374bcc) */\n    .rbc-day-bg:not(.rbc-off-range-bg) {\n        border: 1px solid rgba($accent-blue, 0.18);\n        border-radius: 14px;\n        min-width: 0;\n    }\n}\n\n.rbc-month-row {\n    position: relative;\n    overflow: visible;\n}\n\n/* Comme react-big-calendar.css : au-dessus des .rbc-day-bg (hover + ::after) pour cliquer les events */\n.rbc-row-content {\n    position: relative;\n    z-index: 4;\n}\n\n.rbc-day-bg + .rbc-day-bg {\n    border-left: 1px solid $light-grey;\n}\n\n.rbc-month-row + .rbc-month-row {\n    border-top: 1px solid $light-grey;\n}\n\n.rbc-day-bg {\n    position: relative;\n    -webkit-box-flex: 1;\n    -ms-flex: 1 0 0%;\n    flex: 1 0 0%;\n    background-color: #23374bcc;\n    position: relative;\n    transform: scale(1, 1);\n    transform-origin: center center;\n    transition: transform 0.18s ease;\n    z-index: 0;\n\n    //max-height: 154px;\n    overflow-y: auto;\n    overflow-x: hidden;\n\n    &:hover {\n        /* Axe X et Y explicites (~+8 px / dimension sur ~160px de côté) ; < .rbc-row-content (4) */\n        transform: scale(1.03, 1.03);\n        z-index: 1;\n\n        &::after {\n            content: \"\";\n            position: absolute;\n            top: 0px;\n            left: 0px;\n            right: 0px;\n            bottom: 0px;\n            border-radius: 14px;\n            background-color: #324f6da9;\n            //border: 3px solid $dark-red;\n            pointer-events: none;\n        }\n    }\n\n    .create-event {\n        display: none;  // Cache le symbole par défaut\n        justify-content: end;\n        padding-top: 2px;\n        padding-right: 7px;\n        font-size: 1.3rem;\n        position: absolute;  // Positionne le symbole par rapport à la cellule\n        top: 0;\n        right: 0;\n    }\n\n    &:hover .create-event {\n        display: flex;\n    }\n\n    &.rbc-today {\n        &::after {\n            content: \"\";\n            position: absolute;\n            //background-color: #423d3d;\n            background-color: #446a92a8;\n            top: 0px;\n            left: 0px;\n            right: 0px;\n            bottom: 0px;\n            //border: 3px solid $dark-red;\n            pointer-events: none;\n        }\n    }\n\n    &.rbc-off-range-bg {\n        background-color: #27333f80;\n    }\n}\n\n.rbc-today {\n    background-color: transparent;\n\n}\n\n.rbc-label {\n    color: $light-grey;\n}\n\n.rbc-calendar *,\n.rbc-calendar *:before,\n.rbc-calendar *:after {\n    -webkit-box-sizing: inherit;\n    box-sizing: inherit;\n    overflow-y: hidden;\n    overflow-x: hidden;\n}\n\n/* Plus spécifique que .rbc-calendar * — sinon overflow-y:hidden coupe le scale() en hauteur */\n\n\n.rbc-ellipsis, .rbc-show-more, .rbc-row-segment .rbc-event-content, .rbc-event-label {\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    //color: $very-light-grey;\n}\n\n.calendar-toolbar-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 10px;\n\n    .rbc-toolbar {\n        display: flex;\n        align-items: center;\n\n        &.left {\n            justify-content: flex-start;\n        }\n\n        &.right {\n            justify-content: flex-end;\n        }\n\n        .btn-style1 {\n            margin: 0 1px; // Ajoute un gap de 2px entre chaque bouton\n            height: 30px;\n            width: 40px;\n            color: $dark-red;\n            background: none; // Supprime toute couleur de fond par défaut\n            background-image: url(../medias/steel.png);\n            border-color: #adadad;\n            background-color: rgba(0, 51, 128, 0.2);\n\n            &:hover {\n                background-color: rgba(0, 51, 128, 0.0);\n                color: $red;\n                text-decoration: none;\n            }\n\n            &:active {\n                box-shadow: 0px 0px 5px 2px #2f3031ee;\n            }\n\n            &.first {\n                width: 80px;\n                border-radius: 6px 0 0 6px; // Arrondi seulement sur les coins extérieurs gauche\n            }\n\n            &.middle {\n                width: 80px;\n                border-radius: 0; // Pas d'arrondi\n            }\n\n            &.last {\n                width: 80px;\n                border-radius: 0 6px 6px 0; // Arrondi seulement sur les coins extérieurs droit\n            }\n\n            &.active {\n                background-color: #ffffff;\n                box-shadow: 0px 0px 5px 2px #465561ee;\n                color: $red;\n            }\n        }\n    }\n}\n\n.rbc-header {\n    align-content: center;\n    padding: 3px 3px;\n    border-bottom: 1px solid $light-grey;\n    color: $light-grey;\n}\n\n.rbc-header + .rbc-header {\n    border-left: 1px solid transparent;\n}\n\n/* La rangée mois (rbc-row + rbc-month-header) est stylée dans .rbc-month-view */\n.rbc-time-header-cell,\n.rbc-month-header:not(.rbc-row) {\n    @include steel-bg(\"../medias/steel.png\");\n    height: 30px;\n}\n\n.rbc-event, .rbc-day-slot {\n    position: relative;\n    border: none;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    margin: 0 auto 0 auto;\n    padding: 3px 0px;\n    background-color: $light-panel-blue;\n\n    border-radius: 5px;\n    color: $very-light-grey;\n    font-size: 0.85rem;\n    cursor: pointer;\n    max-width: 96%;\n    text-align: left;\n    border: 1px solid $accent-blue;\n\n    &.rbc-background-event {\n        background-color: $dark-red;\n    }\n\n    &.rbc-time-column {\n        background-color: $grey;\n\n        &.rbc-today {\n            background-color: #405468;\n                    \n            &.rbc-time-slot {\n                background-color: $light-grey;\n            }\n        }\n    }\n\n    .position0 {\n        width: 100% !important;\n        left: 7px !important;\n    }\n\n    .position1 {\n        width: 50% !important;\n        left: 7px !important;\n    }\n\n    .position2 {\n        width: 50% !important;\n        left: 50% !important;\n    }\n\n    &.position3 {\n        width: 33.33% !important;\n        left: 7px !important;\n    }\n\n    &.position4 {\n        width: 33.33% !important;\n        left: 33.33 !important;\n    }\n\n    &.position5 {\n        width: 33.33% !important;\n        left: 66.66% !important;\n    }\n\n    &:hover {\n        border: 1px solid $light-blue;\n        color: white;\n    }\n}\n\n.rbc-timeslot-group {\n    border-bottom: 1px solid $light-grey;\n    min-height: 40px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-flow: column nowrap;\n    flex-flow: column nowrap;\n}\n\n.rbc-day-slot .rbc-time-slot {\n    border-top: 1px solid $grey;\n}\n\n.rbc-date-cell {\n    display: flex;\n    position: relative;\n    -webkit-box-flex: 1;\n    -ms-flex: 1 1 0px;\n    flex: 1 1 0;\n    min-width: 0;\n    padding: 5px 7px 2px 7px;\n    text-align: left;\n    justify-content: space-between;\n    align-items: center;\n\n    .rbc-button-link {\n        flex: 1;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    &.passed {\n        color: grey;\n    }\n    &.future {\n        color: $very-light-grey;\n    }\n\n    &.rbc-current {\n        color: white;\n    }\n}\n\n\n.date-time-selector {\n    display: flex;\n    flex-direction: row;\n    color: $very-light-grey;\n    gap: 5px;\n}\n\n.menu {\n    .date-time-selector {\n        display: flex;\n        flex-direction: column;\n        color: $very-light-grey;\n        gap: 0px;\n    }\n}\n\n.date-time-selector .react-datepicker__input-container input {\n    background-color: $very-light-grey;\n    border: 1px solid $dark-red;\n    border-radius: 4px; \n    box-shadow: none;\n    min-height: 15px;\n    height: 15px; \n    width: 125px;\n    padding: 3px 5px; \n    font-size: 12px;\n}\n\n.date-time-selector label {\n    margin-bottom: 5px;\n    font-weight: bold;\n}\n\n.react-datepicker {\n    font-size: 0.75rem !important;\n    border: 2px solid $red !important;\n    background-color: $grey !important;\n    @include scrollbar-styles;\n}\n\n.react-datepicker__triangle {\n    transform: rotate(180deg) translate(50px, -1px) !important;\n}\n\n.react-datepicker__header {\n    background-color: $dark-grey !important;\n    color: $very-light-grey !important;\n}\n\n.react-datepicker__current-month, .react-datepicker-time__header, .react-datepicker-year-header {\n    color: $very-light-grey !important;\n}\n\nh2.react-datepicker__current-month {\n    color: $very-light-grey !important;\n}\n\n.react-datepicker__day-name, .react-datepicker__day, .react-datepicker__time-name {\n    color: $very-light-grey !important;\n}\n\n.react-datepicker__month-container {\n    background-color: $grey !important;\n}\n\n.react-datepicker__time-container .react-datepicker__time {\n    background: $grey !important;\n}\n\n\n.react-datepicker-popper {\n    z-index: 30000;\n    line-height: 0;\n    left: 85px !important;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {\n    @include scrollbar-styles;\n}\n\n\n.recurrence-selector {\n    display: grid;\n    font-weight: bold;\n    gap: 5px;\n    margin-top: 0px;\n}\n\n\n.ribbon-space {\n    position: relative;\n    width: 100%;\n    height: auto;\n    .ribbon-image {\n        width: 100%;\n        height: auto;\n        display: block;\n    }\n}\n\n.rbc-row-segment {\n    width: 14.5%;\n}\n\n\n/* Vue \"month\" : Limite la largeur à 50% et ajuste la position */\n.rbc-month-view .rbc-event {\n    position: relative;\n    padding-left: 5px;\n    \n\n    &.canceled {\n        border: 1px solid $red;\n        color: $light-grey;\n        text-decoration-line: line-through;\n        background-color: $very-dark-grey;\n        text-decoration-thickness: 2px;\n        text-decoration-color: $red;\n    }\n\n    &.concluded {\n        color: $light-grey;\n    }\n\n    &.scheduled {\n        border: 1px solid #239323;\n        color: $very-light-grey;\n\n        &:hover {\n            border: 1px solid $light-green;\n        }\n    }\n\n    &.live {\n        border: 1px solid #8b590d;\n        color: $very-light-grey;\n    }\n\n    &.tentative {\n        border: 1px solid #b8a500;\n        color: $very-light-grey;\n    }\n}\n\n/* Current-user RSVP marker — top-right of .rbc-event chips */\n.rbc-event.rsvp-signup,\n.rbc-event.rsvp-decline {\n    overflow: visible;\n}\n\n.rbc-event.rsvp-signup::after,\n.rbc-event.rsvp-decline::after {\n    content: '';\n    position: absolute;\n    top: -1px;\n    right: -2px;\n    width: 9px;\n    height: 9px;\n    border-radius: 50%;\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.45);\n    pointer-events: none;\n    z-index: 2;\n}\n\n.rbc-event.rsvp-signup::after {\n    background-color: $light-green;\n}\n\n.rbc-event.rsvp-decline::after {\n    background-color: $bright-red;\n}\n\n/* Vue \"week\" et \"day\" : Assure le bon positionnement */\n.rbc-time-view .rbc-event {\n    width: 100%; /* Occupe toute la largeur */\n    position: absolute; /* Assure le positionnement correct en fonction du temps */\n}\n\n.rbc-current-time-indicator {\n    z-index: 1;\n    background-color: $red;\n    height: 2px;\n}\n\n.rbc-day-slot .rbc-event, .rbc-day-slot .rbc-background-event {\n    padding: 5px;\n    border: 1px solid $light-grey;\n\n    &:hover {\n        background-color: #2d3a47;\n        border: 1px solid $very-light-grey;\n    }\n}\n\n.rbc-event.rbc-selected, .rbc-day-slot .rbc-selected.rbc-background-event {\n    background-color: $very-dark-grey;\n    color: white;\n}\n\n.rbc-event:focus, .rbc-day-slot .rbc-background-event:focus {\n    outline: 3px auto $light-grey;\n}\n\n.rbc-date-cell.rbc-now {\n\n\n    .rbc-button-link {\n        padding: 2px 5px;\n        background-color: $dark-red;\n        border-radius: 3px;\n        \n    }\n}\n\n\n/* Cacher le bouton \"+\" par défaut */\n.create-event {\n    //display: none;\n    color: transparent;\n}\n\n/* Afficher le bouton \"+\" lorsqu'on survole la cellule de date */\n.rbc-date-cell:hover .create-event {\n    //display: inline-block;\n    font-weight: bolder;\n    color: $very-light-grey;\n    padding-left: 10px;\n    padding-right: 5px;\n    cursor: pointer;\n}\n\n\n.management-container {\n    background-color: $very-dark-grey;\n    padding: 10px 15px;\n    border: 1px solid $light-grey;\n    border-radius: 5px;\n    box-shadow: inset -2px -2px 3px rgba(70, 69, 69, 0.2);\n\n    &.create-event, \n    &.create-event-template {\n        display: flex;\n        flex-direction: column;\n        padding: 0.2rem;\n        width: initial;\n        margin-left: auto;\n        margin-right: auto;\n        margin-bottom: 15px;\n\n        .content {\n            margin: 10px\n        }\n\n        .discord {\n            display: flex;\n            width: 100%; \n            height: 250px;\n            \n            .discord-banner {\n                position: relative;\n                margin: 20px auto;\n                width: 500px;\n                height: 200px;\n            \n                // Ratio de 2.5:1\n                &:before {\n                    content: \"\";\n                    display: block;\n                }\n            \n                .dropzone {\n                    position: relative;\n                    width: 500px;       // Largeur fixe du cadre\n                    height: 200px;      // Hauteur fixe du cadre\n                    border: 2px dashed $light-grey;\n                    overflow: hidden; // Masquer tout ce qui déborde du conteneur\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    cursor: grab;\n                    background-color: $grey;\n            \n                    &.is-dragging {\n                        cursor: grabbing;\n                    }\n            \n                    &.locked {\n                        pointer-events: none;\n                        background-color: lighten($grey, 10%);\n                    }\n                }\n            \n                .image-preview {\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                    height: auto;\n                    width: 100%;\n                    object-fit: cover;\n                    transform-origin: top left;\n                    user-select: none;\n                \n                    &.draggable {\n                        cursor: grab;\n                    }\n                \n                    &.locked {\n                        cursor: default;\n                    }\n                \n                    &.is-dragging {\n                        cursor: grabbing;\n                    }\n                \n                    // Translation horizontale\n                    @for $x from -1500 through 50 {\n                        &.translate-x-#{$x} {\n                            --translate-x: #{$x}px;\n                        }\n                    }\n                \n                    // Translation verticale\n                    @for $y from -800 through 50 {\n                        &.translate-y-#{$y} {\n                            --translate-y: #{$y}px; // Définit la valeur de translateY\n                        }\n                    }\n                \n                    // Zoom (échelle)\n                    @for $z from 50 through 300 {\n                        $scale: $z / 100;\n                        &.scale-#{$z} {\n                            --scale: #{$scale}; // Définit la valeur de scale\n                        }\n                    }\n                \n                    // Combine toutes les transformations\n                    transform: translateX(var(--translate-x, 0px)) translateY(var(--translate-y, 0px)) scale(var(--scale, 1));\n                }\n                              \n            \n                .zoom-slider {\n                    display: flex;\n                    width: 325px;\n                    margin: 8px auto 0px auto;\n                }\n            }\n            \n            \n            \n\n            .discord-description  {\n                display: flex;\n                max-width: 540px;\n                width: 540px;\n\n\n                .input-field {\n                    display: flex;\n                    flex-direction: column;\n                    width: 100%;\n                    padding: 0 10px 0 20px;\n\n                    .field-value {\n                        color: $very-light-grey;\n                    }\n\n                    .home-file, .character-counter {\n                        margin: 5px auto 5px 3px;\n                        color: $very-light-grey;\n                    }\n                }\n            }\n        }\n    }\n}\n\n\n\n// CalendarTooltip //\n\n.calendar-tooltip {\n    position: absolute;\n    background-color: $dark-grey;\n    border-radius: 8px;\n    width: max-content;\n    min-width: 200px;\n    height: 275px;\n    //left: var(--tooltip-left, 0);\n    border: 1px solid $dark-red;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);\n    z-index: 1000;\n    cursor: pointer;\n\n    &[data-top] {\n        --tooltip-top: attr(data-top px); // Utilise `data-top` pour définir la variable\n    }\n\n        &.status {\n            position: relative;\n            width: 100%;\n            height: auto;\n            padding: 5px 0px;\n            border-radius: 5px;\n            text-align: center;\n            font-weight: bold;\n            margin: 4px -3px 5px -3px;\n            border: 2px solid $very-dark-grey;\n            box-shadow: 0px 0px 5px 2px #292a2bed;\n    \n            &.canceled {\n                background-color: $dark-red;         // deep muted red\n                color: $very-light-grey;\n            }\n\n            &.scheduled {\n                background-color: $dark-green;            // calm, confident green\n                color: $very-light-grey;\n            }\n\n            &.live {\n                background-color: $dark-orange;      // warm bronze tone\n                color: $very-light-grey;\n            }\n\n            &.concluded {\n                background-color: $grey;             // neutral grey-blue\n                color: $light-grey;\n            }\n\n            &.tentative {\n                background-color: $light-orange;     // amber/golden hue\n                color: $very-light-grey;\n            }\n        }\n\n    .tooltip-header {\n        @include modal-header(\"../medias/steel.png\");\n        border-bottom: 2px solid $light-grey;\n        \n        .tooltip-h3 {\n            font-size: small;\n            margin: 0;\n            padding-right: 10px;\n            color: $very-light-grey;\n            text-transform: uppercase;\n        }\n\n        .link-chain-icon {\n            width: 20px;\n            height: 20px;\n            margin-right: 10px;\n            cursor: pointer;\n        }\n\n        .close-button {\n            background: none;\n            border: none;\n            font-size: 16px;\n            cursor: pointer;\n        }\n    }\n\n    .tooltip-content {\n        padding: 0 10px;\n        margin-top: 5px;\n        border-radius: 0 0 8px 8px;\n        height: 190px;\n\n        p {\n            margin: 5px 0;\n\n            strong {\n                font-weight: bold;\n            }\n        }\n    }\n\n    .tooltip-footer {\n        padding: 5px 10px;\n        \n        .btn-style1 {\n            width: -webkit-fill-available;\n            font-size: smaller;\n            margin: 0 auto;\n        }\n    }\n}\n\n/* ------------------------ */\n/* Conteneur des événements */\n/* ------------------------ */\n\n.rbc-events-container {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(48%, 1fr));\n    grid-auto-rows: auto;\n    grid-gap: 2px;\n}\n\n.rbc-show-more {\n    width: 100%;\n}\n\n.rbc-show-more:hover, .rbc-show-more:focus {\n    color: $dark-red;\n    width: 100%;\n}\n\n\n// ----------------------//\n// --- EVENT DISPLAY --- //\n// ----------------------//\n\n.calendar-event-modal {\n    .modal-dialog {\n        .modal-content {\n            //margin: 10% auto 15% auto;\n            //min-width: 960px;\n            width: 1200px;\n            max-width: 1200px;\n        }\n    }\n}\n\n// Event report modal only (plain `.calendar-event-modal`): global `.modal .modal-content { width: max-content }`\n// shrinks when benefits expand because the real `BenefitsBlock` moves into an absolutely positioned overlay and\n// the flex row is replaced by a zero-intrinsic placeholder. Pin the dialog width so `modal-content` no longer\n// tracks that phantom `max-content` width.\n.calendar-event-modal:not(.calendar-event-modal--card-top):not(.calendar-event-modal--roster-file) {\n    .modal-dialog {\n        // Literal CSS min(): Sass `min()` would try to resolve px + vw at compile time and error.\n        width: #{\"min(1100px, 94vw)\"};\n        max-width: #{\"min(1100px, 94vw)\"};\n        width: 1200px;\n        max-width: 1200px;\n        // Match Bootstrap / roster modal: explicit width needs horizontal auto margins or the dialog sticks left.\n        margin: 1.25rem auto;\n    }\n\n    .modal-dialog .modal-content {\n        width: 100%;\n        box-sizing: border-box;\n        min-width: #{\"min(960px, 100%)\"};\n        max-width: 100%;\n    }\n}\n\n.header.calendar-event, .header.create-event {\n    @include modal-header(\"../medias/steel.png\");\n\n    .calendar-event-h3 {\n        margin: 0;\n        font-size: small;\n    }\n\n    .icon {\n        display: flex;\n        height: 18px;\n        overflow: hidden;\n        margin-left: auto;\n        margin-right: 0;\n\n        .close-event-button {\n            position: relative;\n            height: 40px;\n            object-fit: contain;\n            overflow: hidden;\n            cursor: pointer;\n    \n            &:hover {\n                top: -21px;\n            }\n        }\n    }\n    \n}\n\n.calendar-event.discord-banner {\n    display: flex;\n    align-items: center;\n    width: auto;\n    max-height: 300px;\n    object-fit: cover;\n    border: 1px solid;\n    border-bottom: none;\n    border-color: $light-grey;\n    border-radius: 8px 8px 0px 0px;\n    background-color: $dark-blue-grey;\n    overflow: hidden;\n\n    .discord-banner-image {\n        width: 100%;\n    }\n}\n\n.calendar-event .locked {\n  pointer-events: none;\n  opacity: 0.6;\n}\n\n.calendar-event .locked-text {\n  opacity: 0.6;\n  font-style: italic;\n}\n\n.locked {\n  opacity: 0.6;\n  pointer-events: none;\n  cursor: not-allowed;\n}\n\n\n.calendar-event.time {\n    display: flex;\n    gap: 12px;\n    min-height: 175px;\n    border: 1px solid;\n    border-top: none;\n    border-color: $light-grey;\n    border-radius: 0px 0px 8px 8px;\n    background-color: $dark-panel-blue;\n\n    .column {\n        @include calendar-time-column-inner();\n    }\n\n    .star-citizen-location-column {\n        flex: 0 0 250px;\n        min-width: 240px;\n        max-width: 250px;\n        width: 250px;\n    }\n\n    .star-citizen-location-item {\n        align-items: flex-start;\n    }\n\n    .star-citizen-location-icon {\n        flex: 0 0 auto;\n        filter: brightness(0) saturate(100%) invert(96%) sepia(0%) saturate(3%) hue-rotate(180deg) brightness(92%) contrast(92%);\n    }\n\n    .star-citizen-location-title {\n        display: flex;\n        align-items: center;\n\n        p {\n            font-weight: 700;\n        }\n    }\n\n    .star-citizen-location-content {\n        display: flex;\n        flex-direction: column;\n        gap: 4px;\n        padding-left: 24px;\n        min-width: 0;\n\n        p {\n            color: $light-grey;\n        }\n    }\n\n    .star-citizen-location-details {\n        display: flex;\n        flex-direction: column;\n        gap: 4px;\n        min-width: 0;\n\n        p {\n            margin: 0;\n            color: $light-grey;\n            font-size: 15px;\n            line-height: 1.3;\n            overflow-wrap: anywhere;\n        }\n\n        .star-citizen-location-title {\n            color: $very-light-grey;\n\n            p {\n                color: $very-light-grey;\n            }\n        }\n\n        .star-citizen-location-content {\n            p {\n                color: $light-grey;\n            }\n        }\n    }\n\n    .star-citizen-solar-details {\n        margin-top: 6px;\n    }\n\n    .star-citizen-location-editor {\n        display: flex;\n        flex-direction: column;\n        gap: 6px;\n        width: 100%;\n        min-width: 0;\n\n        .react-select-input__control {\n            min-height: 30px !important;\n            height: auto !important;\n            width: 100%;\n            min-width: 0 !important;\n            max-width: 100%;\n            background-color: $panel-blue;\n            border-color: rgba($light-grey, 0.45);\n        }\n\n        .react-select-input__value-container {\n            min-height: 28px;\n            padding: 0 6px;\n        }\n\n        .react-select-input__single-value,\n        .react-select-input__placeholder,\n        .react-select-input__input-container,\n        .react-select-input__input {\n            color: $very-light-grey !important;\n            font-size: 12px;\n        }\n\n        .react-select-input__placeholder {\n            color: rgba($light-grey, 0.9) !important;\n        }\n\n        .react-select-input__indicator {\n            color: $light-grey;\n        }\n\n        p {\n            margin: 0;\n            color: $very-light-grey;\n            font-size: 12px;\n            line-height: 1.3;\n        }\n    }\n\n    .meeting-point-label {\n        margin: 0;\n        color: $very-light-grey;\n        font-size: 15px;\n        font-weight: 700;\n    }\n\n    .meeting-point-row {\n        display: flex;\n        align-items: center;\n        gap: 0px;\n        min-width: 0;\n\n        .location-item {\n            min-width: 0;\n        }\n    }\n}\n\n.calendar-event-report {\n    &.header {\n        @include modal-header(\"../medias/steel.png\");\n    \n        .calendar-event-h3 {\n            margin: 0;\n            font-size: small;\n        }\n    \n        .icon {\n            display: flex;\n            height: 18px;\n            overflow: hidden;\n            margin-left: auto;\n            margin-right: 0;\n    \n            .close-event-button {\n                position: relative;\n                height: 40px;\n                object-fit: contain;\n                overflow: hidden;\n                cursor: pointer;\n        \n                &:hover {\n                    top: -21px;\n                }\n            }\n        }\n    }\n\n    &.content {\n        display: flex;\n        flex-direction: column;\n        background: $blue-grey;\n        padding: 15px;\n        gap: 10px;\n        overflow: hidden;\n\n        .report-event-details-row {\n            display: flex;\n            align-items: stretch;\n            gap: 10px;\n            min-width: 0;\n        }\n\n        .report-online-panel {\n            width: 220px;\n            flex-shrink: 0;\n            display: flex;\n            flex-direction: column;\n            height: 175px;\n            min-height: 0;\n            overflow: hidden;\n            color: $very-light-grey;\n            border: 1px solid $light-grey;\n            border-radius: 8px;\n            background: $very-dark-grey;\n\n            .report-online-panel__title {\n                display: flex;\n                align-items: center;\n                gap: 8px;\n                padding: 10px 10px 6px 10px;\n                border-bottom: 1px solid $grey;\n                user-select: none;\n\n                strong {\n                    font-size: 0.95em;\n                    letter-spacing: 0.5px;\n                }\n            }\n\n            .chat-users-list {\n                display: flex;\n                flex-direction: column;\n                gap: 6px;\n                flex: 1;\n                min-height: 0;\n                overflow-y: auto;\n                padding: 10px;\n                list-style: none;\n                margin: 0;\n                @include scrollbar-styles;\n\n                .chat-user-item {\n                    display: flex;\n                    align-items: center;\n                    gap: 8px;\n                    width: -webkit-fill-available;\n                    //padding: 5px 8px;\n                    border-radius: 6px;\n\n                    .chat-user-item__identity {\n                        flex: 1;\n                        min-width: 0;\n\n                        .user-discord-rank__name {\n                            color: #afa991;\n                            padding: 5px;\n                            border: 1px solid transparent;\n                        }\n                    }\n                }\n            }\n\n            .report-online-panel__empty {\n                padding: 6px 8px;\n                opacity: 0.75;\n                font-style: italic;\n            }\n        }\n\n        .objectives-benefits-row {\n            display: flex;\n            gap: 10px;\n            width: 100%;\n            align-items: stretch;\n\n            > .inputs-column.objectives,\n            > .benefits-block {\n                flex: 1 1 0;\n                min-width: 0;\n            }\n        }\n\n        // Upcoming event: objectives edit-mode should match Create Event UI\n        .objectives-benefits-row {\n             .inputs-column.objectives {\n                background-color: $very-dark-grey;\n                border: 1px solid $very-light-grey;\n                border-radius: 8px;\n                padding: 10px;\n\n                .input {\n                    margin-bottom: 0;\n                }\n\n                .input.objectives-block {\n                    display: flex;\n                    flex-direction: column;\n                    border: 1px solid $very-light-grey;\n                    margin-top: 8px;\n                    border-radius: 4px;\n                    padding: 6px;\n                    gap: 6px;\n                    width: 100%;\n                    box-sizing: border-box;\n\n                    &.disabled {\n                        opacity: 0.5;\n                    }\n\n                    .objectives-scroll {\n                        height: 142px;\n                        overflow-y: auto;\n                        display: flex;\n                        flex-direction: column;\n                        gap: 5px;\n                        padding-right: 6px;\n                        @include scrollbar-styles;\n                    }\n\n                    .objective-row {\n                        position: relative;\n                        display: grid;\n                        grid-template-columns: 18px auto 45px;\n                        gap: 6px;\n                        align-items: center;\n                    }\n\n                    .objective-order {\n                        font-size: 0.85em;\n                        color: $very-light-grey;\n                        opacity: 0.75;\n                        text-align: right;\n                        user-select: none;\n                        cursor: grab;\n\n                        &.is-disabled {\n                            opacity: 0.25;\n                            cursor: default;\n                        }\n                    }\n\n                    .objective-input {\n                        width: 100%;\n                        box-sizing: border-box;\n                    }\n\n                    .toggle.critical {\n                        height: 11px;\n                        display: flex;\n                        align-items: center;\n                        gap: 6px;\n                    }\n                }\n            }\n        }\n\n        .benefits-block {\n            background-color: $very-dark-grey;\n            border: 1px solid $light-grey;\n            border-radius: 8px;\n            padding: 10px;\n            margin: 0;\n            height: 260px;\n            display: flex;\n            flex-direction: column;\n            position: relative;\n            z-index: 1;\n            transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;\n\n            .benefits-block-header {\n                margin-bottom: 6px;\n                text-transform: uppercase;\n                font-size: 0.85em;\n                opacity: 0.9;\n                display: flex;\n                align-items: center;\n                gap: 8px;\n            }\n\n            .benefits-block-body {\n                flex: 1 1 auto;\n                min-height: 0;\n            }\n        }\n\n        // Report-only: expand benefits INSIDE the modal, not a modal-on-modal.\n        .report-benefits-expansion-shell {\n            position: relative;\n            display: flex;\n            flex-direction: column;\n            gap: 10px;\n        }\n\n        .calendar-event-report__benefits-save-reminder {\n            flex: 1 1 auto;\n            margin: 0;\n            padding: 0.55rem 0.75rem;\n            border-radius: 6px;\n            border: 1px solid rgba($light-orange, 0.55);\n            background: rgba($light-orange, 0.12);\n            color: $very-light-grey;\n            font-size: 0.82rem;\n            line-height: 1.4;\n        }\n\n        &.footer {\n            display: flex;\n            flex-wrap: wrap;\n            align-items: center;\n            gap: 10px;\n\n            .calendar-event-report__save-reminder-active {\n                box-shadow: 0 0 0 2px rgba($light-orange, 0.45);\n            }\n        }\n\n        .report-benefits-expansion-shell.is-expanded {\n            // Keep original layout height, but visually replace it.\n            .report-benefits-expansion-participants,\n            .report-benefits-expansion-objectives,\n            .report-benefits-expansion-row {\n                opacity: 0;\n                pointer-events: none;\n                user-select: none;\n            }\n\n            .report-benefits-expansion-row {\n                position: relative;\n            }\n        }\n\n        // Keep overlay above the whole shell (participants + row).\n\n        // Report-only: row layout uses wrappers (report-section-shell), so we must restate flex sizing.\n        .report-benefits-expansion-row {\n            display: flex;\n            gap: 10px;\n            width: 100%;\n            align-items: stretch;\n\n            > .report-benefits-expansion-objectives,\n            > .report-section-shell--benefits,\n            > .report-benefits-expansion-benefits-placeholder {\n                flex: 1 1 0;\n                min-width: 0;\n            }\n        }\n\n        .report-benefits-expansion-overlay {\n            position: absolute;\n            inset: 0;\n            z-index: 5;\n            // Invisible overlay must not steal clicks from row / participants toggles.\n            pointer-events: none;\n            opacity: 0;\n            transform: scale(0.985);\n            transition: opacity 180ms ease, transform 180ms ease;\n            width: 100%;\n            height: 100%;\n        }\n\n        .report-benefits-expansion-shell.is-expanded-benefits .report-benefits-expansion-overlay,\n        .report-benefits-expansion-shell.is-expanded-objectives .report-benefits-expansion-overlay,\n        .report-benefits-expansion-shell.is-expanded-auction .report-benefits-expansion-overlay {\n            opacity: 1;\n            transform: scale(1);\n            pointer-events: auto;\n        }\n\n        .report-benefits-expansion-overlay.is-closing {\n            opacity: 0;\n            transform: scale(0.985);\n            pointer-events: none;\n        }\n\n        .report-benefits-expansion-overlay .benefits-block {\n            height: 100%;\n            max-height: 100%;\n            box-sizing: border-box;\n            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.45);\n        }\n\n        .report-section-shell {\n            border: 1px solid rgba(255, 255, 255, 0.18);\n            border-radius: 8px;\n            transition: border-color 160ms ease, box-shadow 160ms ease;\n        }\n\n        .report-section-shell--dirty {\n            border-color: rgba($orange, 0.95);\n            box-shadow: 0 0 0 2px rgba($orange, 0.25);\n        }\n\n        .report-section-shell--saved {\n            border-color: rgba($green, 0.95);\n            box-shadow: 0 0 0 2px rgba($green, 0.18);\n        }\n\n        .report-benefits-expansion-benefits-placeholder {\n            flex: 1 1 0;\n            min-width: 0;\n        }\n\n        .report-benefits-expansion-objectives {\n            flex: 1 1 0;\n            min-width: 0;\n            display: flex;\n        }\n\n        .report-benefits-expansion-objectives-placeholder {\n            height: 200px;\n        }\n\n        .benefits-block .benefits-uec {\n            display: flex;\n            flex-direction: column;\n            height: 100%;\n            gap: 15px;\n            min-height: 0;\n        }\n\n        .benefits-block .benefits-uec-top {\n            display: flex;\n            gap: 12px;\n            align-items: flex-start;\n        }\n\n        .benefits-block .benefits-uec-loot-distributed-badge {\n            flex: 0 0 auto;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n            align-self: end;\n            gap: 2px;\n            padding: 8px 10px;\n            border-radius: 8px;\n            border: 1px solid rgba(255, 255, 255, 0.14);\n            background: rgba(0, 0, 0, 0.18);\n            min-width: 56px;\n            user-select: none;\n        }\n\n        .benefits-block .benefits-uec-loot-distributed-badge__label {\n            font-size: 0.65rem;\n            font-weight: 700;\n            letter-spacing: 0.06em;\n            text-transform: uppercase;\n            opacity: 0.75;\n            line-height: 1.1;\n            white-space: nowrap;\n        }\n\n        .benefits-block .benefits-uec-loot-distributed-badge__value {\n            font-size: 1.05rem;\n            font-weight: 700;\n            line-height: 1;\n            color: rgba(255, 255, 255, 0.92);\n        }\n\n        .benefits-block .benefits-uec-top-left-cluster,\n        .benefits-block .benefits-uec-top-left,\n        .benefits-block .benefits-uec-top-right {\n            min-width: 0;\n        }\n\n        .benefits-block .benefits-uec-top-left-cluster {\n            display: flex;\n            flex-direction: row;\n            flex-wrap: wrap;\n            align-items: flex-end;\n            gap: 12px;\n            flex: 1 1 auto;\n            width: 100%;\n        }\n\n        .benefits-block .benefits-uec-top-left-cluster .benefits-uec-top-left {\n            flex: 0 1 auto;\n            max-width: #{\"min(100%, 400px)\"};\n        }\n\n        .benefits-block .benefits-uec-top-left-cluster .benefits-uec-mission-contract-wrap {\n            flex: 0 0 auto;\n            align-self: flex-end;\n            min-width: 0;\n        }\n\n        .benefits-block .benefits-uec-top-left-cluster .benefits-uec-mission-contract-toggle.toggle {\n            @include toggle-benefits-payout-lock-row;\n        }\n\n        .benefits-block .benefits-uec-top-left-cluster .benefits-uec-payout-lock-wrap {\n            margin-left: inherit;\n        }\n\n        .benefits-block .benefits-uec-top-right {\n            flex: 0 0 auto;\n            /* Visually line up the loot field with the UEC `field-input` row (not the label). */\n            align-self: flex-end;\n        }\n\n        .benefits-block .benefits-uec-top-left-cluster:only-child {\n            width: 100%;\n        }\n\n        .benefits-block .benefits-uec-top-left {\n            display: flex;\n            flex-direction: column;\n            gap: 6px;\n        }\n\n        .benefits-block .benefits-uec-payout-lock-wrap {\n            flex: 0 0 auto;\n            position: relative;\n            align-self: flex-end;\n            display: flex;\n            align-items: center;\n            justify-content: flex-end;\n            max-width: none;\n            min-width: 0;\n        }\n\n        .benefits-block .benefits-uec-payout-lock-wrap .benefits-uec-benefits-countdown--payout-slot,\n        .benefits-block .benefits-uec-payout-lock-wrap .benefits-countdown-digital {\n            max-width: #{\"min(100%, 22rem)\"};\n            min-width: 0;\n        }\n\n        /* Slot compact à droite du total UEC : même ligne que l’input ; remplace Org Share quand le timer est actif */\n        .benefits-block .benefits-uec-total-with-share .benefits-uec-benefits-countdown--compact-slot,\n        .benefits-block .benefits-uec-total-with-share .benefits-uec-benefits-countdown--compact-slot.benefits-countdown-digital {\n            flex: 1 1 auto;\n            min-width: 0;\n            max-width: 100%;\n            margin-top: 0;\n        }\n\n        .benefits-block:not(.benefits-block--expanded) .benefits-uec-top-left-cluster .benefits-uec-payout-lock-wrap {\n            margin-left: inherit;\n        }\n\n        /* Expanded: keep validate/save on the right without overlapping mission contract toggle. */\n        .benefits-block.benefits-block--expanded .benefits-uec-top-left-cluster .benefits-uec-payout-lock-wrap {\n            margin-left: inherit;\n        }\n\n        .benefits-block.benefits-block--expanded .benefits-uec-top-left-cluster .benefits-uec-validate-total-btn,\n        .benefits-block.benefits-block--expanded .benefits-uec-top-left-cluster .benefits-uec-save-benefits-btn {\n            white-space: nowrap;\n        }\n\n        /* Benefits-only: label + switch alignment (do not use `.join-operation` here). */\n        .benefits-block .benefits-uec-payout-lock-wrap .toggle.benefits-uec-payout-lock-toggle-row {\n            @include toggle-benefits-payout-lock-row;\n        }\n\n        .benefits-block .benefits-uec-row {\n            display: flex;\n            flex-direction: column;\n            align-items: stretch;\n            gap: 6px;\n        }\n\n        .benefits-block .benefits-uec-label {\n            font-size: 0.85em;\n            opacity: 0.9;\n            text-transform: uppercase;\n            white-space: nowrap;\n        }\n\n        .benefits-block .benefits-uec-label-sub {\n            font-size: 0.85em;\n            opacity: 0.85;\n            text-transform: capitalize;\n        }\n\n        .benefits-block .benefits-uec-total-with-share {\n            display: flex;\n            flex-direction: row;\n            align-items: flex-end;\n            flex-wrap: wrap;\n            gap: 8px;\n            min-width: 0;\n        }\n\n        /* Replié : champ UEC + org share / countdown strictement sur une même ligne (pas de wrap). */\n        .benefits-block:not(.benefits-block--expanded) .benefits-uec-total-with-share {\n            flex-wrap: nowrap;\n            align-items: center;\n        }\n\n        .benefits-block:not(.benefits-block--expanded) .benefits-uec-total-with-share .benefits-uec-input-shell {\n            flex-shrink: 0;\n        }\n\n        .benefits-block .benefits-uec-org-share-compact {\n            display: flex;\n            flex-direction: column;\n            align-items: flex-start;\n            gap: 2px;\n            flex: 0 1 auto;\n            min-width: 0;\n            max-width: 100%;\n        }\n\n        .benefits-block .benefits-uec-org-share-compact__label {\n            font-size: 0.72rem;\n            font-weight: 600;\n            color: rgba(255, 255, 255, 0.55);\n            letter-spacing: 0.02em;\n            white-space: nowrap;\n        }\n\n        .benefits-block .benefits-uec-org-share-compact__amount {\n            font-size: 0.8rem;\n            font-weight: 600;\n            color: rgba(255, 255, 255, 0.82);\n            white-space: nowrap;\n        }\n\n        .benefits-block .benefits-uec-input-shell {\n            display: flex;\n            align-items: stretch;\n            width: 200px;\n            background: $very-dark-grey;\n            border: 1px solid $medium-grey;\n            border-radius: 6px;\n            overflow: hidden;\n        }\n\n        .benefits-block .benefits-uec-input-shell.locked {\n            opacity: 0.7;\n        }\n\n        .benefits-block .benefits-uec-input {\n            color: $very-light-grey;\n            font-size: 15px;\n            font-weight: 600;\n            flex: 1 1 auto;\n            background: $light-panel-blue;\n            border: 0;\n            padding: 5px 10px;\n            text-align: left;\n            min-width: 0;\n        }\n\n        .benefits-block .benefits-uec-input.locked {\n            cursor: not-allowed;\n        }\n\n        .benefits-block .benefits-uec-input:focus {\n            outline: none;\n        }\n\n        .benefits-block .benefits-uec-input-unit {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            flex: 0 0 auto;\n            \n            padding: 5px 10px;\n            background: rgba($medium-grey, 0.25);\n            border-left: 1px solid rgba($medium-grey, 0.6);\n            color: $very-light-grey;\n            font-size: 15px;\n            font-weight: 600;\n            letter-spacing: 0.02em;\n            min-width: 45px;\n            user-select: none;\n        }\n\n        .benefits-block .benefits-uec-hint {\n            font-size: 0.9em;\n            opacity: 0.85;\n        }\n\n        .benefits-block .benefits-uec-hint.locked {\n            opacity: 0.65;\n        }\n\n        .benefits-block:not(.benefits-block--expanded) .benefits-org-bank {\n            display: none;\n        }\n\n        .benefits-block:not(.benefits-block--expanded) .benefits-uec-top-right {\n            display: none;\n        }\n\n        .benefits-block:not(.benefits-block--expanded) .benefits-uec-participants-header-left {\n            grid-template-columns: minmax(0, 1fr) minmax(88px, 180px) minmax(56px, 72px);\n        }\n\n        .benefits-block:not(.benefits-block--expanded) .benefits-uec-participants-header-cell:nth-child(4) {\n            display: none;\n        }\n\n        .benefits-block .benefits-org-bank {\n            position: relative;\n            width: 100%;\n            box-sizing: border-box;\n            border: 1px solid $medium-grey;\n            border-radius: 6px;\n            padding: 10px;\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            gap: 12px;\n            min-width: 0;\n            cursor: pointer;\n        }\n\n        .benefits-block .benefits-org-bank.is-active {\n            background: rgba($accent-blue, 0.16);\n            box-shadow: 0 0 0 2px rgba($accent-blue, 0.18);\n        }\n\n        .benefits-block .benefits-org-bank-start {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            align-self: start;\n            gap: 10px;\n            padding: 5px;\n            min-width: 0;\n            flex: 0 1 auto;\n        }\n\n        .benefits-block .benefits-org-bank-logo {\n            flex: 0 0 auto;\n            line-height: 0;\n            background: $light-panel-blue;\n            padding: 5px;\n            border: 1px solid $medium-grey;\n            border-radius: 6px;\n        }\n\n        .benefits-block .benefits-org-bank-logo__img {\n            display: block;\n            width: 28px;\n            height: auto;\n            max-height: 32px;\n            max-width: 36px;\n            object-fit: contain;\n            filter: grayscale(1) contrast(1.08) brightness(1.05);\n            opacity: 0.65;\n        }\n\n        .benefits-block .benefits-org-bank-left {\n            flex: 0 1 auto;\n            position: relative;\n            z-index: 0;\n            display: flex;\n            flex-direction: column;\n            align-self: start;\n            gap: 4px;\n            min-width: 0;\n        }\n\n        .benefits-block .benefits-org-bank-title {\n            font-size: 0.8em;\n            opacity: 0.9;\n            text-transform: uppercase;\n            white-space: nowrap;\n        }\n\n        .benefits-block .benefits-org-bank-title-sub {\n            font-size: 0.85em;\n            opacity: 0.85;\n            text-transform: capitalize;\n        }\n\n        .benefits-block .benefits-org-bank-amount {\n            font-size: 15px;\n            font-weight: 600;\n            color: $very-light-grey;\n            white-space: nowrap;\n        }\n\n        .benefits-block .benefits-org-bank-right {\n            flex: 1 1 0;\n            position: relative;\n            background: $very-dark-grey;\n            border-radius: 8px;\n            z-index: 0;\n            display: flex;\n            justify-content: flex-start;\n            min-width: 0;\n        }\n\n        .benefits-block .benefits-org-bank-loot-placeholder {\n            border: 1px dashed rgba($medium-grey, 0.8);\n            border-radius: 6px;\n            padding: 8px 10px;\n            min-height: 30px;\n            width: 100%;\n            display: flex;\n            align-items: center;\n            justify-content: flex-start;\n            opacity: 0.8;\n            position: relative;\n            z-index: 1;\n            overflow: hidden;\n        }\n\n        .benefits-block .benefits-org-bank-loot-placeholder.is-empty {\n            justify-content: center;\n        }\n\n        .benefits-block .benefits-org-bank-loot-placeholder .benefits-loot-chips,\n        .benefits-block .benefits-org-bank-loot-drop .benefits-loot-chips {\n            position: relative;\n            z-index: 2;\n        }\n\n        .benefits-block .benefits-org-bank-loot-drop {\n            width: 100%;\n        }\n\n        .benefits-block .benefits-org-bank.is-dnd-over {\n            box-shadow: inset 0 0 0 2px rgba($accent-blue, 0.55);\n            background: rgba($accent-blue, 0.08);\n        }\n\n        .benefits-block .benefits-org-bank-loot-drop.is-dnd-over {\n            box-shadow: inset 0 0 0 2px rgba($accent-blue, 0.55);\n            background: rgba($accent-blue, 0.1);\n        }\n\n        .benefits-block .benefits-uec-participant.is-dnd-over {\n            box-shadow: inset 0 0 0 1px rgba($accent-blue, 0.45);\n        }\n\n        .benefits-block .benefits-uec-summary {\n            display: flex;\n            flex-direction: column;\n            gap: 4px;\n        }\n\n        .benefits-block .benefits-uec-participants {\n            display: flex;\n            flex-direction: column;\n            gap: 0;\n            min-height: 0;\n            flex: 1 1 auto;\n        }\n\n        .benefits-block .benefits-uec-participants-header {\n            display: flex;\n            align-items: stretch;\n            justify-content: space-between;\n            gap: 12px;\n            min-width: 0;\n            padding: 8px 10px;\n            background: rgba(255, 255, 255, 0.04);\n            border: 1px solid rgba(255, 255, 255, 0.1);\n            border-bottom: 1px solid rgba(255, 255, 255, 0.12);\n            border-radius: 6px 6px 0 0;\n        }\n\n        .benefits-block .benefits-uec-participants-header-left {\n            flex: 1 1 auto;\n            min-width: 0;\n            display: grid;\n            grid-template-columns: minmax(0, 1fr) minmax(96px, 200px) 44px minmax(0, 1fr);\n            gap: 10px;\n            align-items: center;\n            padding: 0;\n        }\n\n        .benefits-block .benefits-uec-participants-header-cell {\n            font-size: 0.7em;\n            font-weight: 600;\n            letter-spacing: 0.04em;\n            opacity: 0.9;\n            text-transform: uppercase;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n        }\n\n        .benefits-block .benefits-uec-participants-header-cell:nth-child(2) {\n            text-align: right;\n        }\n\n        .benefits-block .benefits-uec-participants-list {\n            overflow: auto;\n            border: 1px solid rgba(255, 255, 255, 0.1);\n            border-top: 0;\n            border-radius: 0 0 6px 6px;\n            padding: 6px 10px;\n            display: flex;\n            flex-direction: column;\n            gap: 6px;\n            min-height: 0;\n            background: rgba(0, 0, 0, 0.12);\n            @include scrollbar-styles();\n        }\n\n        // List rows only: expanded mode uses `<tr class=\"benefits-uec-participant\">`; `display:flex` on `<tr>`\n        // breaks table column layout (all cells stack in the first column).\n        .benefits-block .benefits-uec-participants-list:not(.benefits-uec-participants-list--table) > .benefits-uec-participant {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            gap: 10px;\n            cursor: pointer;\n        }\n\n        .benefits-block .benefits-uec-participants-list:not(.benefits-uec-participants-list--table) > .benefits-uec-participant.is-expanded {\n            align-items: flex-start;\n        }\n\n        .benefits-block .benefits-uec-participant.is-active {\n            background: rgba($accent-blue, 0.16);\n            border-radius: 6px;\n        }\n\n        .benefits-block--expanded .benefits-uec-participants-list--table {\n            display: block;\n            gap: 0;\n            padding: 0;\n            overflow: auto;\n            border: 1px solid rgba(255, 255, 255, 0.1);\n            border-radius: 6px;\n            min-height: 0;\n            background: rgba(0, 0, 0, 0.12);\n            @include scrollbar-styles();\n        }\n\n        .benefits-block--expanded .benefits-uec-participants-table tbody tr.benefits-uec-participant {\n            display: table-row;\n        }\n\n        .benefits-block--expanded .benefits-uec-participants-table {\n            width: 100%;\n            border-collapse: collapse;\n            table-layout: fixed;\n        }\n\n        /* colgroup: narrower identity; mini payout-toggle; loot stays 60% */\n        .benefits-block--expanded .benefits-uec-participants-col--identity {\n            width: 19%;\n        }\n\n        .benefits-block--expanded .benefits-uec-participants-col--payout {\n            width: 14%;\n        }\n\n        .benefits-block--expanded .benefits-uec-participants-col--payoutToggle {\n            width: 7%;\n        }\n\n        .benefits-block--expanded .benefits-uec-participants-table--uec-transfer .benefits-uec-participants-col--identity {\n            width: 17%;\n        }\n\n        .benefits-block--expanded .benefits-uec-participants-table--uec-transfer .benefits-uec-participants-col--payout {\n            width: 12%;\n        }\n\n        .benefits-block--expanded .benefits-uec-participants-table--uec-transfer .benefits-uec-participants-col--payoutToggle {\n            width: 6%;\n        }\n\n        .benefits-block--expanded .benefits-uec-participants-col--uecTransfer {\n            width: 7%;\n        }\n\n        .benefits-block--expanded .benefits-uec-participants-col--loot {\n            width: 60%;\n        }\n\n        .benefits-block--expanded .benefits-uec-participants-table--uec-transfer .benefits-uec-participants-col--loot {\n            width: 58%;\n        }\n\n        .benefits-block--expanded .benefits-uec-participants-table thead tr {\n            background: rgba(255, 255, 255, 0.04);\n        }\n\n        .benefits-block--expanded .benefits-uec-participants-th {\n            padding: 8px 10px;\n            text-align: left;\n            border-bottom: 1px solid rgba(255, 255, 255, 0.12);\n            font-weight: 600;\n        }\n\n        .benefits-block--expanded .benefits-uec-participants-th--payout {\n            text-align: right;\n        }\n\n        .benefits-block--expanded .benefits-uec-participants-th--payoutToggle {\n            text-align: center;\n            padding-left: 4px;\n            padding-right: 4px;\n        }\n\n        .benefits-block--expanded .benefits-uec-participants-table tbody tr.benefits-uec-participant td {\n            padding: 8px 10px;\n            vertical-align: center;\n            border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n        }\n\n        .benefits-block--expanded .benefits-uec-participants-table tbody tr.benefits-uec-participant:last-child td {\n            border-bottom: 0;\n        }\n\n        .benefits-block--expanded .benefits-uec-participants-td--payout {\n            text-align: right;\n        }\n\n        .benefits-block--expanded .benefits-uec-participants-td--payoutToggle {\n            text-align: center;\n            vertical-align: middle;\n            padding-left: 4px;\n            padding-right: 4px;\n        }\n\n        .benefits-block--expanded .benefits-uec-participants-th--uecTransfer {\n            text-align: center;\n            padding-left: 4px;\n            padding-right: 4px;\n            font-size: 11px;\n            line-height: 1.2;\n        }\n\n        .benefits-block--expanded .benefits-uec-participants-td--uecTransfer {\n            text-align: center;\n            vertical-align: middle;\n            padding-left: 4px;\n            padding-right: 4px;\n        }\n\n        .benefits-uec-transfer-dash {\n            color: rgba(255, 255, 255, 0.3);\n            font-weight: 600;\n        }\n\n        /* Loot chip : toggle (report éditable) ou pastilles ✓ vert / ✕ gris (vue événement / report lecture seule) */\n        .benefits-loot-chip-row {\n            display: inline-flex;\n            flex-direction: row;\n            flex-wrap: nowrap;\n            align-items: center;\n            gap: 6px;\n            max-width: 100%;\n            min-width: 0;\n            padding-right: 0px;\n        }\n\n        .benefits-loot-chip-row__chip {\n            min-width: 0;\n            flex: 1 1 auto;\n        }\n\n        .benefits-loot-chip-row__toggle {\n            flex-shrink: 0;\n        }\n\n        .benefits-loot-chip-row .sc-item-chip__trailing .toggle-switch-field {\n            flex-shrink: 0;\n        }\n\n        .benefits-loot-chip-row__status {\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n            flex-shrink: 0;\n            width: 22px;\n            height: 22px;\n            border-radius: 50%;\n            font-size: 11px;\n            font-weight: 700;\n            line-height: 1;\n            user-select: none;\n        }\n\n        .benefits-loot-chip-row__status--not-given {\n            color: rgba(255, 255, 255, 0.42);\n            background: rgba(255, 255, 255, 0.06);\n            border: 1px solid rgba(255, 255, 255, 0.12);\n        }\n\n        .benefits-loot-chip-row__status--given {\n            color: $green;\n            //background: rgba(46, 204, 113, 0.22);\n            //border: 1px solid rgba(46, 204, 113, 0.5);\n        }\n\n        .benefits-block--expanded .benefits-uec-participants-td--identity,\n        .benefits-block--expanded .benefits-uec-participants-td--loot {\n            min-width: 0;\n        }\n\n        .benefits-block--expanded .benefits-uec-participants-td--loot {\n            min-height: 44px;\n            height: 100%;\n        }\n\n        .benefits-block--expanded .benefits-uec-participant-loots {\n            min-width: 0;\n            width: 100%;\n            padding-top: 2px;\n        }\n\n        .benefits-block--expanded .benefits-uec-participant-loots--empty {\n            min-height: 0;\n        }\n\n        .benefits-block:not(.benefits-block--expanded) .benefits-uec-participant-row {\n            display: grid;\n            grid-template-columns: minmax(0, 1fr) minmax(88px, 180px) 44px;\n            gap: 10px;\n            align-items: center;\n            width: 100%;\n            min-width: 0;\n        }\n\n        .benefits-block:not(.benefits-block--expanded) .benefits-uec-participant-cell--payoutToggle {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            min-width: 0;\n        }\n\n        .benefits-block:not(.benefits-block--expanded) .benefits-uec-participant-cell--identity {\n            min-width: 0;\n        }\n\n        .benefits-block:not(.benefits-block--expanded) .benefits-uec-participant-cell--payout {\n            justify-self: end;\n            text-align: right;\n            align-self: center;\n        }\n\n        .benefits-block--expanded .benefits-uec-participant-identity {\n            min-width: 0;\n        }\n\n        .benefits-block--expanded .benefits-uec-participant-identity .user-discord-rank__name {\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            max-width: 100%;\n        }\n\n        // Collapsed rows use a div with `benefits-uec-participant-cell`; expanded table uses `<td>` without\n        // that class — do not force `display:flex` on table cells or columns collapse.\n        .benefits-block .benefits-uec-participant-cell.benefits-uec-participant-right {\n            display: flex;\n            align-items: flex-start;\n            justify-content: flex-end;\n            gap: 8px;\n            flex: 0 0 auto;\n        }\n\n        .benefits-block .benefits-loot-actions {\n            display: flex;\n            align-items: flex-start;\n            justify-content: flex-end;\n            gap: 8px;\n            min-width: 0;\n        }\n\n        // Input row matches `benefits-uec-input-shell`; wrap stays `position: relative` for dropdown.\n        .benefits-block .benefits-loot-mention-wrap {\n            position: relative;\n            flex: 1 1 auto;\n            min-width: 0;\n            max-width: 320px;\n            width: 100%;\n        }\n\n        .benefits-block .benefits-loot-mention-input-shell {\n            display: flex;\n            align-items: stretch;\n            width: 100%;\n            background: $very-dark-grey;\n            border: 1px solid $medium-grey;\n            border-radius: 6px;\n            overflow: hidden;\n        }\n\n        .benefits-block .benefits-loot-mention-input-shell.locked {\n            opacity: 0.7;\n        }\n\n        .benefits-block .benefits-loot-mention-input-shell .benefits-loot-search-icon {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            flex: 0 0 auto;\n            padding: 0 10px 0 10px;\n            color: $very-light-grey;\n            background: $dark-panel-blue;\n        }\n\n        .benefits-block .benefits-loot-mention-input-shell:focus-within .benefits-loot-search-icon {\n            color: rgba(255, 255, 255, 0.62);\n        }\n\n        .benefits-block .benefits-loot-mention-input-shell .benefits-loot-search-icon__svg {\n            display: block;\n            width: 16px;\n            height: 16px;\n        }\n\n        .benefits-block .benefits-loot-mention-input-shell .benefits-loot-search-input {\n            width: 100%;\n            box-sizing: border-box;\n            flex: 1 1 auto;\n            min-width: 0;\n            background: $light-panel-blue;\n            border: 0;\n            border-radius: 0;\n            padding: 7px 10px 7px 7px;\n            color: $very-light-grey;\n            font-size: 15px;\n            font-weight: 600;\n            text-align: left;\n        }\n\n        .benefits-block .benefits-loot-mention-input-shell .benefits-loot-search-input:focus {\n            outline: none;\n        }\n\n        .benefits-block .benefits-loot-search-hint {\n            margin-top: 4px;\n            font-size: 11px;\n            opacity: 0.75;\n        }\n\n        .benefits-block .benefits-loot-mention-wrap .mention-dropdown {\n            position: absolute;\n            top: 100%;\n            left: 0;\n            right: 0;\n            margin: 4px 0 0 0;\n            padding: 0;\n            list-style: none;\n            background: rgba($very-dark-grey, 0.98);\n            border: 1px solid rgba(255, 255, 255, 0.12);\n            border-radius: 6px;\n            max-height: 220px;\n            overflow-y: auto;\n            z-index: 10050;\n            @include scrollbar-styles();\n        }\n\n        .benefits-block .benefits-loot-mention-wrap .mention-dropdown .dropdown-item {\n            display: flex;\n            align-items: flex-start;\n            padding: 6px 10px;\n            cursor: pointer;\n            border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n\n            &:last-child {\n                border-bottom: none;\n            }\n\n            &.selected {\n                background-color: rgba($accent-blue, 0.22);\n            }\n\n            &:hover {\n                background-color: rgba(255, 255, 255, 0.06);\n            }\n\n            .mention-name {\n                display: flex;\n                flex-direction: column;\n                align-items: flex-start;\n                gap: 2px;\n                line-height: 1.25;\n                min-width: 0;\n            }\n\n            .benefits-loot-dd-label {\n                font-size: 13px;\n                color: rgba(255, 255, 255, 0.92);\n                overflow: hidden;\n                text-overflow: ellipsis;\n                white-space: nowrap;\n                max-width: 100%;\n            }\n\n            .benefits-loot-dd-meta {\n                font-size: 11px;\n                color: rgba(255, 255, 255, 0.55);\n                overflow: hidden;\n                text-overflow: ellipsis;\n                white-space: nowrap;\n                max-width: 100%;\n            }\n        }\n\n        .benefits-block .benefits-loot-chips {\n            display: flex;\n            flex-wrap: wrap;\n            gap: 6px;\n            align-items: center;\n            min-width: 0;\n        }\n\n        .benefits-block .benefits-loot-chip-dnd {\n            display: inline-flex;\n            flex-direction: row;\n            align-items: stretch;\n            min-width: 0;\n            vertical-align: top;\n        }\n\n        .benefits-block .benefits-loot-chip-dnd__surface {\n            display: inline-flex;\n            flex-direction: row;\n            align-items: stretch;\n            max-width: 100%;\n            min-width: 0;\n            box-sizing: border-box;\n            border: 1px solid $sc-item-accent-secondary;\n            border-radius: 6px;\n            background: $sc-item-bg;\n            overflow: hidden;\n        }\n\n        .benefits-block .benefits-loot-chip-dnd--overlay {\n            cursor: grabbing;\n        }\n\n        .benefits-block .benefits-loot-chip-dnd.is-benefits-dragging {\n            opacity: 0;\n        }\n\n        .benefits-block .benefits-loot-chip-dnd__handle {\n            flex: 0 0 auto;\n            width: 21px;\n            min-width: 21px;\n            margin: 0;\n            padding: 0px 3px 0px 7px;\n            border: 0;\n            border-right: 1px solid rgba(255, 255, 255, 0.1);\n            align-self: stretch;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            cursor: grab;\n            color: rgba(255, 255, 255, 0.45);\n            background: linear-gradient(90deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.05) 100%);\n        }\n\n        .benefits-block .benefits-loot-chip-dnd--overlay .benefits-loot-chip-dnd__handle {\n            cursor: grabbing;\n        }\n\n        .benefits-block .benefits-loot-chip-dnd__handle::before {\n            content: \"\";\n            display: block;\n            width: 4px;\n            height: 12px;\n            border-left: 1px solid currentColor;\n            border-right: 1px solid currentColor;\n            background: linear-gradient(180deg, currentColor, currentColor) center / 1px 100% no-repeat;\n        }\n\n        .benefits-block .benefits-loot-chip-dnd__handle:hover,\n        .benefits-block .benefits-loot-chip-dnd__handle:focus-visible {\n            color: rgba(255, 255, 255, 0.75);\n            background: linear-gradient(90deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.05) 100%);\n        }\n\n        .benefits-block .benefits-loot-chip-dnd__handle:active {\n            cursor: grabbing;\n        }\n\n        .benefits-block .benefits-loot-chip-dnd__chip {\n            min-width: 0;\n            flex: 1 1 auto;\n            display: flex;\n            align-items: stretch;\n        }\n\n        .benefits-block .benefits-loot-chip-dnd__chip .benefits-loot-chip-row .sc-item-chip {\n            border: 0;\n            border-radius: 0;\n            background: transparent;\n            max-width: 100%;\n        }\n\n        .benefits-block .benefits-loot-chip-dnd__chip .sc-item-chip__trigger {\n            flex-wrap: wrap;\n            row-gap: 2px;\n        }\n\n        .benefits-block .benefits-uec-participant-left {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            min-width: 0;\n            flex: 1 1 auto;\n        }\n\n        // Participant identity rendering is handled by `UserDiscordRankDisplay`\n        // (see `.user-discord-rank` styles elsewhere).\n\n        .benefits-block .benefits-uec-participant-share {\n            white-space: nowrap;\n            opacity: 0.95;\n        }\n\n        .header-with-toggle {\n            display: flex;\n\n            .h2-custom {\n                text-transform: uppercase;\n                margin-block-start: 0.3em;\n                margin-block-end: 0em;\n                margin-left: 10px;\n            }\n\n            .input-field.toggle-inline {\n                display: flex;\n                margin: auto 10px auto auto;\n                align-items: center;\n\n                .toggle-label {\n                    text-transform: uppercase;\n                    font-size: 0.8em;\n                    font-weight: 600;\n                    position: relative;\n                    top: 7px;\n                    margin-right: 10px;\n                }\n            }\n        }\n\n       \n\n        .event-details.time {\n            display: flex;\n            gap: 20px;\n            height: 175px;\n            width: 100%;\n            border: 1px solid;\n            border-color: $light-grey;\n            border-radius: 8px;\n            background-color: $very-dark-grey;\n        \n            .column {\n                @include calendar-time-column-inner();\n            }\n        }\n\n        .conditional-bloc.row {\n            display: flex;\n            gap: 10px;\n            width: 100%;\n\n            .joined-operation {\n                background-color: $dark-grey;\n                border: 1px solid $light-grey;\n                border-radius: 6px;\n                min-width: 49%;\n                width: 100%;\n    \n                .joined-operation-header {\n                    display: flex;\n                    flex-direction: row;\n                    color: $very-light-grey;\n        \n                    .calendar-icon {\n                        position: relative;\n                        width: auto;\n                        height: 18px;\n                        margin-right: 8px;\n                        margin-left: 10px;\n                        vertical-align: middle;\n                        top: 15px;\n                    }\n        \n                    .joined {\n                        color: $very-light-grey;  \n                    }\n                }\n    \n                .alliance-list {\n                    max-height: 85px;\n                    padding: 5px 0px 10px;\n                    overflow: auto;\n                    @include scrollbar-styles;\n        \n                    .participant-item {\n                        display: flex;\n                        align-items: center;\n                        margin: 3px 0px 3px 0px;\n        \n                        .participant-logo {\n                            position: relative;\n                            height: 20px;\n                            width: auto;\n                            margin: 0px 10px 0px 35px;\n                        }\n        \n                        .alliance-name {\n                            margin-top: 0;\n                        }\n                    }\n                }\n            }\n            \n            .operation-incomes {\n                background-color: $dark-grey;\n                border: 1px solid $light-grey;\n                border-radius: 6px;\n                min-width: 49%;\n                width: 100%;\n\n                .operation-incomes-header {\n                    display: flex;\n                    flex-direction: row;\n                    color: $very-light-grey;\n        \n                    .calendar-icon {\n                        position: relative;\n                        width: auto;\n                        height: 18px;\n                        margin-right: 8px;\n                        margin-left: 10px;\n                        top: 15px;\n                    }\n        \n                    .incomes {\n                        color: $very-light-grey;  \n                    }\n                }\n\n                .incomes-details {\n                    max-height: 85px;\n                    padding: 10px 35px 10px;\n\n                    .income-input-wrapper {\n                        position: relative;\n                        display: inline-block;\n\n                        .income-input {\n                            padding-right: 25px;\n                        }\n                        \n                        .uec-icon-input {\n                            position: absolute;\n                            right: 5px;\n                            top: 50%;\n                            transform: translateY(-50%);\n                            width: 15px;\n                            height: 15px;\n                        }\n                    }\n\n                    .income-percentage {\n                        margin-top: 0px;\n                        padding: 7px 0px 0px;\n                    }\n\n                    .uec-icon-percentage {\n                        position: relative;\n                        width: 15px;\n                        height: 15px;\n                        margin-left: 5px;\n                        top: 2px;\n                    }\n                }\n            }\n        }\n\n        \n\n\n        .participants {\n            background: $very-dark-grey;\n            border: 1px solid $light-grey;\n            border-radius: 6px;\n\n            .participant-count {\n                display: flex;\n                flex-direction: row;\n\n                .css-b62m3t-container {\n                    margin-left: auto;\n                }\n                \n                .react-select-input__control {\n                    margin-top: 15px;\n                    margin-right: 10px;\n                    margin-left: auto;\n                }\n                    \n                .count {\n                    color: $very-light-grey;\n                    position: relative;\n                    top: 17px;\n                }\n\n                .participant-select-container {\n                    display: flex;\n                    flex-direction: row;\n                    margin-left: auto;\n                    margin-right: 10px;\n                    \n                    .add-participant-button {\n                        position: relative;\n                        top: 15px;\n\n                        .add-icon {\n                            height: 20px;\n                            width: auto;\n                        }\n                    }\n                }\n\n                .calendar-icon {\n                    position: relative;\n                    width: auto;\n                    height: 18px;\n                    margin-right: 8px;\n                    margin-left: 10px;\n                    vertical-align: middle;\n                    top: 15px;\n                }\n            }\n\n           \n\n            .participants-list {\n                display: grid;\n                padding: 1em;\n                grid-template-columns: repeat(auto-fit, minmax(205px, 0fr));\n                place-content: start;\n                overflow-y: auto;\n                height: 160px;\n                @include scrollbar-styles;\n\n                .participant-item {\n                    transition: all 0.3s ease;\n                    display: flex;\n                    align-items: center;\n                    position: relative;\n                    padding: 0 0.5em;\n                    cursor: pointer;\n                    \n                    &.deselected {\n                        opacity: 0.55;\n                        \n                        .scrollable-label {\n                            text-decoration: line-through;\n                            text-decoration-thickness: 2px;\n                            text-decoration-color: rgba($very-light-grey, 0.75);\n                        }\n                    }\n\n                    &:hover {\n                        color: white;\n                        cursor: pointer;\n                    }\n\n                    .discord-avatar {\n                        width: 20px;\n                        height: 20px;\n                        margin-right: 10px;\n                        border-radius: 50%;\n                    }\n\n                  \n\n                    .scrollable-label {\n                        display: inline-block;\n                        max-width: 110px; // Limite la largeur\n                        white-space: nowrap; // Empêche les retours à la ligne\n                        overflow: hidden; // Cache tout ce qui dépasse\n                        text-overflow: ellipsis; // Affiche \"...\" si nécessaire\n                        position: relative;\n                    \n                        // Défilement au survol pour les textes longs\n                        &.scroll:hover {\n                            max-width: 110px;\n                            overflow: hidden;\n                            text-overflow: unset; // Désactive \"...\"\n                            animation: scrollText 5s linear infinite; // Active le défilement\n                        }\n                    \n                        @keyframes scrollText {\n                            0% {\n                                transform: translateX(0); // Position initiale\n                            }\n                            100% {\n                                transform: translateX(-100%); // Texte défile vers la gauche\n                            }\n                        }\n                    }\n                    \n                    \n\n                    .ribbons-icon {\n                        height: 40px;\n                        object-fit: contain;\n                        margin-right: 0px;\n                        position: relative;\n                        margin-left: auto; \n                        top: -8px;\n                        clip-path: inset(50% 0 0 0); // Affiche uniquement la moitié inférieure\n\n                        &:hover {\n                            top: 12px;\n                            clip-path: inset(0 0 50% 0); // Affiche uniquement la moitié supérieure\n                        }\n\n                        &.disabled {\n                            pointer-events: none;\n                            cursor: not-allowed;\n                            opacity: 0.5;\n                        }\n\n                        &.has-ribbons {\n                            top: 12px;\n                            clip-path: inset(0 0 50% 0);\n                        }\n                    }\n                    \n\n                    &.deselected {\n                        color: $bright-red;\n                        opacity: 0.5;\n                        text-decoration: line-through;\n\n                        .discord-avatar {\n                            width: auto;\n                            height: 18px;\n                            border: 1px solid $bright-red;\n                        }\n\n                        .ribbons-icon {\n                            pointer-events: none;\n                            cursor: not-allowed;\n                            opacity: 0.5;\n                        }\n                    }\n\n                    &.added {\n                        color: #008000;\n                        opacity: 1;\n                    }\n\n                    // Ajouter un séparateur vertical après chaque participant, sauf le dernier de chaque ligne\n                    &::after {\n                        content: \"\";\n                        position: absolute;\n                        right: 0; // Positionne le séparateur entre les colonnes\n                        top: 0;\n                        height: 100%;\n                        width: 1px;\n                        background: $light-grey;\n                    }\n                }\n\n                // Supprimer la bordure de droite pour chaque dernier élément de ligne\n                .participant-item:nth-child(5n) {\n                    &::after {\n                        display: none;\n                    }\n                }\n            }\n        }\n    }\n\n    &.footer {\n        background-color: $blue-grey;\n        padding: 15px; \n        border-radius: 0px 0px 8px 8px;\n\n        // Spacing between footer actions (e.g. \"save report\" / \"back to event view\")\n        .btn-style1 + .btn-style1 {\n            margin-left: 20px;\n        }\n    }\n}\n\n// BenefitsBlock: shared header assets (report modal + `.content.calendar-event` card — not under `.calendar-event-report` alone)\n.benefits-block .benefits-block-header {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 0.55rem;\n}\n\n.benefits-block .benefits-block-manage-auction-btn {\n    margin-left: auto;\n}\n\n.benefits-block .benefits-block-header:has(.benefits-block-expand-toggle) .benefits-block-manage-auction-btn {\n    margin-right: 1.75rem;\n}\n\n.benefits-block .benefits-block-header-box-icon {\n    width: 18px;\n    height: 18px;\n    object-fit: contain;\n    flex-shrink: 0;\n    opacity: 0.92;\n}\n\n.benefits-block .benefits-block-expand-toggle {\n    position: absolute;\n    top: -5px;\n    right: -2px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 22px;\n    height: 22px;\n    padding: 0;\n    margin: 0;\n    border-radius: 6px;\n    border: 1px solid rgba(255, 255, 255, 0.18);\n    background: rgba(0, 0, 0, 0.25);\n    cursor: pointer;\n    transition: background 160ms ease, border-color 160ms ease, transform 160ms ease;\n}\n\n.benefits-block .benefits-block-expand-toggle:hover {\n    background: rgba(0, 0, 0, 0.38);\n    border-color: $light-grey;\n}\n\n.benefits-block .benefits-block-expand-toggle__icon {\n    display: block;\n    width: 14px;\n    height: 14px;\n    object-fit: contain;\n    opacity: 0.95;\n}\n\n.benefits-block .benefits-uec-payout-header {\n    display: inline-flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 6px;\n    width: 100%;\n    min-width: 0;\n}\n\n.benefits-block .benefits-uec-payout-header__title {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    min-width: 0;\n}\n\n.benefits-block .benefits-uec-payout-header__lock-wrap {\n    display: inline-flex;\n    flex-shrink: 0;\n    color: rgba(255, 255, 255, 0.88);\n}\n\n.benefits-block .benefits-uec-payout-header__lock-icon {\n    display: block;\n    width: 14px;\n    height: 14px;\n    object-fit: contain;\n}\n\n.benefits-block--payment-completed .benefits-uec-participants-th--payout,\n.benefits-block--payment-completed .benefits-uec-participants-td--payout,\n.benefits-block--payment-completed .benefits-uec-participants-header-cell--payout-label,\n.benefits-block--payment-completed .benefits-uec-participant-cell--payout {\n    opacity: 0.7;\n}\n\n.benefits-block .benefits-uec-claimed-mark {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 1.25em;\n    font-size: 1.05em;\n    line-height: 1;\n    font-weight: 600;\n}\n\n.benefits-block .benefits-uec-claimed-mark--report-yes {\n    color: $light-green;\n}\n\n.benefits-block .benefits-uec-claimed-mark--report-no {\n    color: $bright-red;\n}\n\n.benefits-block .benefits-uec-claimed-mark--calendar-yes {\n    color: $medium-grey;\n}\n\n.benefits-block .benefits-uec-claimed-mark--calendar-no {\n    color: rgba($medium-grey, 0.72);\n}\n\n.benefits-block .benefits-uec-claimed-mark--uec-sent-yes {\n    color: $light-green;\n    font-size: 1.15em;\n}\n\n.benefits-block .benefits-uec-claimed-mark--auto-yes,\n.benefits-block .benefits-uec-transfer-mark--auto-yes {\n    color: $light-green;\n    font-size: 1.15em;\n    font-weight: 600;\n}\n\n.benefits-block .benefits-uec-payout-header__label {\n    text-transform: inherit;\n    letter-spacing: inherit;\n}\n\n.benefits-block .benefits-uec-payout-help {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    flex-shrink: 0;\n    z-index: 30;\n}\n\n.benefits-block .benefits-uec-payout-help__btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 16px;\n    height: 16px;\n    padding: 0;\n    margin: 0;\n    border: 1px solid rgba(255, 255, 255, 0.42);\n    border-radius: 50%;\n    background: rgba(0, 0, 0, 0.28);\n    color: rgba(255, 255, 255, 0.88);\n    cursor: pointer;\n    line-height: 1;\n}\n\n.benefits-block .benefits-uec-payout-help__btn:hover,\n.benefits-block .benefits-uec-payout-help__btn:focus-visible {\n    border-color: rgba(255, 255, 255, 0.72);\n    color: #fff;\n    outline: none;\n}\n\n.benefits-block .benefits-uec-payout-help__i {\n    font-size: 0.62rem;\n    font-weight: 700;\n    font-style: italic;\n    transform: translateY(0.5px);\n}\n\n.benefits-block .benefits-uec-participants-header-cell--payoutToggle {\n    min-width: 36px;\n    text-align: center;\n}\n\n.benefits-block .benefits-uec-payout-toggle--mini.field-input.toggle {\n    display: inline-flex;\n    width: auto;\n    min-width: 0;\n    max-width: 100%;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    bottom: 0;\n    margin: 0;\n\n    .toggle-switch {\n        position: relative;\n        top: auto;\n        left: auto;\n        right: auto;\n        margin-left: 0;\n    }\n}\n\n// Portaled to `document.body` (not under `.benefits-block`) so it escapes overflow:hidden on report / table shells.\n.benefits-block .benefits-uec-participants-header-cell--payout-label {\n    overflow: visible;\n    white-space: normal;\n}\n\n.benefits-block--expanded .benefits-uec-participants-th--payout {\n    overflow: visible;\n}\n\n.benefits-uec-payout-help__tip--portal {\n    position: fixed;\n    z-index: 10100;\n    box-sizing: border-box;\n    margin: 0;\n    width: max-content;\n    max-width: 260px;\n    padding: 8px 10px;\n    border-radius: 6px;\n    font-size: 0.72rem;\n    font-weight: 500;\n    line-height: 1.35;\n    text-align: left;\n    text-transform: none;\n    letter-spacing: normal;\n    color: $very-light-grey;\n    background: rgba(20, 26, 32, 0.98);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    box-shadow: 0 8px 22px rgba(0, 0, 0, 0.5);\n    pointer-events: auto;\n}\n\n.content.calendar-event {\n    .objectives-benefits-row {\n        display: flex;\n        gap: 10px;\n        width: 100%;\n        align-items: stretch;\n        //margin-top: 10px;\n        //margin-bottom: 10px;\n\n        > .event-objectives-view,\n        > .benefits-block {\n            flex: 1 1 0;\n            min-width: 0;\n        }\n\n        .benefits-block:not(.benefits-block--event-modal-readonly) {\n            background-color: $very-dark-grey;\n            border: 1px solid $very-light-grey;\n            border-radius: 8px;\n            padding: 10px;\n            display: flex;\n            flex-direction: column;\n\n            .benefits-block-header {\n                display: flex;\n                align-items: center;\n                gap: 8px;\n                text-transform: uppercase;\n                font-size: 0.85em;\n                opacity: 0.9;\n                margin-bottom: 10px;\n            }\n\n            .benefits-block-body {\n                padding: 10px 10px 10px 20px;\n                flex: 1 1 auto;\n            }\n\n        .benefits-line {\n            opacity: 0.85;\n            font-size: 0.9em;\n        }\n        }\n    }\n\n    // Concluded-event modal: expanding objectives/benefits covers the sibling panel (matches report-benefits-expansion pattern).\n    .calendar-event-benefits-expansion-shell {\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        gap: 0;\n        width: 100%;\n\n        // Taller viewport only while expanded — otherwise a tall min-height on the shell adds empty gap when collapsed.\n        &.is-expanded {\n            min-height: clamp(340px, 40vh, 720px);\n\n            .calendar-event-benefits-expansion-row {\n                opacity: 0;\n                pointer-events: none;\n                user-select: none;\n                position: relative;\n            }\n        }\n    }\n\n    .calendar-event-benefits-expansion-row {\n        display: flex;\n        gap: 10px;\n        width: 100%;\n        align-items: stretch;\n\n        > .calendar-event-benefits-expansion-objectives,\n        > .calendar-event-benefits-expansion-slot-benefits {\n            flex: 1 1 0;\n            min-width: 0;\n        }\n    }\n\n    .calendar-event-benefits-expansion-objectives {\n        flex: 1 1 0;\n        min-width: 0;\n        display: flex;\n    }\n\n    .calendar-event-benefits-expansion-objectives > .objectives-report-block.objectives-report-block--in-calendar-event {\n        flex: 1 1 0;\n        min-width: 0;\n    }\n\n    .calendar-event-benefits-expansion-slot-benefits {\n        flex: 1 1 0;\n        min-width: 0;\n        display: flex;\n    }\n\n    .calendar-event-benefits-expansion-placeholder {\n        flex: 1 1 0;\n        min-width: 0;\n        min-height: 260px;\n        box-sizing: border-box;\n    }\n\n    .calendar-event-benefits-expansion-overlay {\n        position: absolute;\n        inset: 0;\n        z-index: 5;\n        pointer-events: none;\n        opacity: 0;\n        transform: scale(0.985);\n        transition: opacity 180ms ease, transform 180ms ease;\n        width: 100%;\n        height: 100%;\n    }\n\n    .calendar-event-benefits-expansion-shell.is-expanded-benefits .calendar-event-benefits-expansion-overlay,\n    .calendar-event-benefits-expansion-shell.is-expanded-objectives .calendar-event-benefits-expansion-overlay,\n    .calendar-event-benefits-expansion-shell.is-expanded-auction .calendar-event-benefits-expansion-overlay {\n        opacity: 1;\n        transform: scale(1);\n        pointer-events: auto;\n    }\n\n    .calendar-event-benefits-expansion-overlay .objectives-report-block.objectives-report-block--in-calendar-event {\n        height: 100%;\n        max-height: 100%;\n        box-sizing: border-box;\n        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.45);\n    }\n\n    // .event-objectives-view styles: EventObjectivesView.scss (via bigCalendar.scss → styles.scss).\n}\n\n// Shared: icon size for block headers (objectives/benefits)\n.block-icon {\n    width: 18px;\n    height: 18px;\n    object-fit: contain;\n    flex: 0 0 auto;\n}\n\n.occurrence-item {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 5px;\n    gap: 5px;\n\n    .event-time {\n        display: flex;\n        flex-direction: row;\n        margin: 5px 0;\n\n        .calendar-icon {\n            width: auto;\n            height: 18px;\n            margin-right: 8px; // Espace entre l'icône et le texte\n            vertical-align: middle;\n        }\n\n        .dates-time {\n            display: flex;\n            flex-direction: column;\n            gap: 0px;\n        }\n\n        .date-time-selector .react-datepicker__input-container input {\n            display: flex;\n            flex-direction: column;\n            width: 125px;\n            margin: 0px 0;\n        }\n    \n        p {\n               margin: 3px 0;\n        }\n    }\n\n    .event-link {\n        display: flex;\n        flex-direction: row;\n        margin: 0;\n        cursor: pointer;\n        align-items: center;\n        transition: color 0.2s ease;\n    \n        .link-chain-icon {\n            height: 15px;\n            width: auto;\n            margin-right: 10px;\n            transition: transform 0.2s ease, filter 0.2s ease;\n        }\n\n        .link-chain-icon--copied {\n            filter: brightness(0) saturate(100%) invert(62%) sepia(18%) saturate(864%) hue-rotate(82deg) brightness(95%);\n            transform: scale(1.08);\n        }\n    \n        .link-text {\n            margin: 0px;\n            cursor: pointer;\n\n            &:hover {\n                color: white;\n            }\n        }\n\n        &--copied {\n            .link-text strong {\n                color: $green;\n            }\n        }\n    }\n    \n}\n\n.recurrence-item {\n    .react-datepicker-wrapper {\n        .react-datepicker__input-container {\n            input {\n                width: 70px;\n            }\n        }\n    }\n}\n\n.discord-tooltip {\n    color: red;\n    background: $grey;\n    padding: 3px;\n    border: 1px solid $red;\n    border-radius: 6px;\n}\n\n.tooltip-item {\n    display: flex;\n    position: relative;\n    bottom: 0px;\n    height: 25px;\n\n    .calendar-icon {\n        position: relative;\n        width: auto;\n        height: 16px;\n        margin-right: 6px;\n        top: 5px;\n    }\n\n    p {\n           margin-top: auto;\n    }\n}\n\n.tooltip1 {\n    font-size: 0.8em;\n}\n\n\n.calendar-event.type {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    gap: 5px;\n\n    .type-item {\n        display: flex;\n        flex-direction: row;\n        align-items: flex-start;\n        gap: 8px;\n        margin-left: 5px;\n\n        .type-item__icon {\n            flex: 0 0 auto;\n            width: auto;\n            height: 16px;\n            margin-top: 2px;\n        }\n\n        .type-item__content {\n            display: flex;\n            flex-direction: column;\n            gap: 5px;\n            min-width: 0;\n        }\n    \n        .type-subtype {\n            display: flex;\n            flex-direction: row;\n            gap: 5px;\n        }\n    \n        .division-section {\n            display: flex;\n            flex-direction: row;             \n            gap: 5px;\n    \n            // Styles pour le cas \"Combined Arms\" avec un tooltip\n            .combined-arms-tooltip {\n                font-style: oblique;\n                position: relative;\n                cursor: help;\n            \n                // Afficher le tooltip lorsque l'élément est survolé\n                &:hover .tooltip-content {\n                    display: block;\n                }\n            \n                .tooltip-content {\n                    display: none;\n                    position: absolute;\n                    top: 100%;  // Positionner le tooltip en dessous\n                    left: 50%;  // Centrer horizontalement par rapport à l'élément\n                    transform: translateX(-50%);\n                    background-color: $dark-grey;\n                    border: 1px solid $dark-red;\n                    border-radius: 6px;\n                    padding: 10px;\n                    z-index: 1000;\n                    width: 300px;\n                    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.6);\n                    white-space: nowrap;\n\n                    .combined-arms-tooltip-title {\n                        color: white;\n                        font-weight: bolder;\n                        text-transform: uppercase;\n                        font-size: 0.8em;\n                        margin-bottom: 5px;\n                    }\n            \n                    .division-row {\n                        display: flex;\n                        justify-content: space-between;\n                        align-items: center;\n                        margin: 3px 0;\n            \n                        .branch-column,\n                        .section-column {\n                            flex: 1;\n                            text-align: left;\n                        }\n            \n                        .divisions-separator {\n                            width: 1%; // Assure que le séparateur prend le minimum de place\n                            text-align: center;\n                            padding: 0 5px;\n                            white-space: nowrap; // Empêche le contenu de se casser\n                        }\n                    }\n                }\n            }\n            \n    \n            // Styles généraux pour les paragraphes dans la section de division\n            p {\n                margin: 3px 0;\n            }\n        }\n    }\n    \n\n    .org-share {\n        display: flex;\n        flex-direction: row; \n\n        .org-share-information {\n            margin: 3px 0;\n        }\n\n        .uec {\n            position: relative;\n            width: 15px;\n            top: 4px;\n        }\n    }\n\n    .voice-info {\n        display: flex;\n        flex-direction: row;\n        align-items: flex-start;\n        gap: 8px;\n        margin-left: 5px;\n\n        .voice-info__icon {\n            flex: 0 0 auto;\n            width: auto;\n            height: 16px;\n            margin-top: 2px;\n        }\n\n        .voice-channel {\n            display: flex;\n            flex-direction: column;\n            gap: 5px;\n            min-width: 0;\n\n            p {\n                margin: 3px 0;\n            }\n\n            .react-select-input__control {\n                min-height: 28px;\n                min-width: 0 !important;\n                max-width: 100%;\n            }\n        }\n    }\n\n    .location-item {\n        display: flex;\n        justify-content: flex-start; // S'assure que l'élément est aligné à gauche, pas à droite\n        margin-left: 5px;\n        color: $light-grey;\n        //height: 25px;\n        //align-items: center;\n        //margin-top: auto; // Pousse cet élément vers le bas du parent\n\n        .field-input {\n            padding: 3px 5px 3px 5px;\n        }\n\n        .calendar-icon {\n            width: auto;\n            height: 15px;\n            margin-right: 10px;\n        }\n\n        p {\n            margin: 0;\n        }\n    }\n\n    .clearance-item {\n        display: flex;\n        justify-content: flex-start; // S'assure que l'élément est aligné à gauche, pas à droite\n        height: 25px;\n        align-items: center;\n        margin-top: 0px; // Pousse cet élément vers le bas du parent\n\n        .field-input {\n            padding: 3px 5px 3px 5px;\n        }\n\n        .calendar-icon {\n            width: auto;\n            height: 15px;\n            margin-right: 10px;\n        }\n\n        p {\n            margin: 0;\n        }\n    }\n}\n\n\n\n\n\n.calendar-event.title {\n    display: flex;\n    align-items: center;\n    margin-right: 0px;\n    margin-left: auto;\n    margin-bottom: 10px;\n    gap: 5px;\n\n    .title {\n        font-weight: bold;\n        text-transform: uppercase;\n        margin: 5px 10px;\n    }\n\n    .edit-mode {\n        display: flex;\n        gap: 10px;\n        margin-right: 0px;\n        margin-left: auto;\n    }\n    \n}\n\n.calendar-event {\n    &.status {\n        width: max-content;\n        min-width: 80px;\n        height: max-content;\n        padding: 5px 5px;\n        border-radius: 5px;\n        text-align: center;\n        font-weight: bold;\n        font-size: 0.7em;\n        text-transform: uppercase;\n        margin: 0px 20px 5px 20px;\n        border: 2px solid $very-dark-grey;\n        box-shadow: 0px 0px 5px 2px #292a2bed;\n        transition: all 0.3s ease;\n\n        &.canceled {\n            background-color: $red;\n            color: $light-grey;\n        }\n\n        &.tentative {\n            background-color: #b8a500;\n            color: $grey;\n        }\n\n        &.scheduled {\n            background-color: #166316;\n            color: $very-light-grey;\n        }\n\n        &.live {\n            background-color: #8b590d;\n            color: $very-light-grey;\n        }\n\n        &.live-button {\n            background-color: #8b590d; // Couleur similaire pour continuité\n            color: $very-light-grey;\n            border: 2px solid #8b590d; // Ou une couleur distincte si souhaité\n            transition: all 0.3s ease; \n            cursor: pointer;\n\n            &:hover {\n                background-color: darken(#8b590d, 10%);\n                color: $light-grey; \n                transform: scale(1.1);\n            }\n        }\n\n        &.concluded {\n            background-color: $grey;\n            color: $light-grey;\n        }\n    }\n}\n\n.delete-event-modal, .confirm-conclude-modal {\n    .modal-content {\n        .header {\n            @include modal-header(\"../medias/steel.png\");\n        }\n    \n        .content {\n            background-color: #27333f;\n            padding: 15px;\n\n            .field-input {\n                height: 30px;\n                max-width: -webkit-fill-available;\n                min-width: -webkit-fill-available;\n            }\n        }\n        \n    \n        .footer {\n            display: flex;\n            justify-content: flex-end;\n            background-color: $very-dark-grey;\n            padding: 10px;\n            border-radius: 0 0 8px 8px;\n            gap: 10px;\n\n            .btn-style1 {\n                margin: 0;\n            }\n        }\n    }\n}\n\n\n.content.calendar-event {\n    background-color: $blue-grey;\n    padding: 0 15px;\n\n    .calendar-event-accordion {\n        //margin-top: 10px;\n        padding: 10px;\n        background-color: $very-dark-grey;\n        border: 1px solid $light-grey;\n        border-radius: 8px;\n    }\n\n    .calendar-event-accordion-section {\n        border-top: 1px solid rgba(255, 255, 255, 0.08);\n\n        &:first-child {\n            border-top: none;\n        }\n    }\n\n    .calendar-event-accordion-toggle {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 10px;\n        padding: 10px 8px;\n        background: transparent;\n        border: none;\n        color: inherit;\n        cursor: pointer;\n\n        &:hover {\n            background-color: rgba(255,255,255,0.04);\n        }\n\n        .calendar-event-accordion-toggle-left {\n            display: inline-flex;\n            align-items: center;\n            gap: 10px;\n            min-width: 0;\n        }\n\n        .calendar-icon {\n            width: auto;\n            height: 15px;\n        }\n    }\n\n    .calendar-event-accordion-caret {\n        width: 0;\n        height: 0;\n        border-left: 6px solid transparent;\n        border-right: 6px solid transparent;\n        border-top: 8px solid rgba(255, 255, 255, 0.7); // triangle up by default\n        transition: transform 180ms ease;\n        flex: 0 0 auto;\n    }\n\n    .calendar-event-accordion-toggle.is-open {\n        .calendar-event-accordion-caret {\n            transform: rotate(180deg); // becomes triangle down when open\n        }\n    }\n\n    .calendar-event-accordion-panel {\n        .event-report-content,\n        .description-content {\n            padding: 0px 25px;\n        }\n\n        .event-report-content {\n            max-height: 500px;\n            overflow: auto;\n            @include scrollbar-styles;\n        }\n    }\n\n    .calendar-event-accordion-panel-anim {\n        overflow: hidden;\n        max-height: 0;\n        opacity: 0;\n        transition: max-height 220ms ease, opacity 180ms ease;\n\n        &.is-open {\n            max-height: calc(100vh - 600px);\n            opacity: 1;\n            overflow-y: scroll;\n            @include scrollbar-styles;\n        }\n    }\n\n    .description {\n        margin-top: 10px;\n        padding: 10px;\n        background-color: $very-dark-grey;\n        border: 1px solid $light-grey;\n        border-radius: 8px;\n\n        .description-header {\n            display: flex;\n            align-items: center; /* Assure l'alignement vertical de l'icône et du texte */\n        \n            .calendar-icon {\n                width: auto;\n                height: 15px;\n                margin-right: 10px; /* Espace entre l'icône et le texte */\n            }\n        \n            .description-title {\n                margin: 0; /* Pour éviter un espace supplémentaire sous le titre */\n            }\n        }\n\n        .description-content {\n            padding: 0px 25px;\n            // Lexical export used inline white-space: pre-wrap; CSP style-src-attr blocks that — keep parity via CSS\n            .editor-paragraph span,\n            .lexical-header1 span,\n            .lexical-header2 span,\n            .lexical-header3 span,\n            .lexical-header4 span,\n            .lexical-header5 span,\n            .lexical-header6 span,\n            li span {\n                white-space: pre-wrap;\n            }\n            // Lexical leaves an empty hidden div; after stripping style it becomes visible without this\n            div:empty {\n                display: none;\n            }\n        }\n        \n    }\n\n    .participants {\n        display: flex;\n        flex-direction: row;\n        //margin-top: 10px;\n        height: 115px;\n        padding: 10px;\n        background-color: $very-dark-grey;\n        border: 1px solid $light-grey;\n        border-radius: 8px; \n\n        .calendar-icon {\n            width: auto;\n            height: 18px;\n            margin-right: 10px;\n            margin-top: 5px;\n        }\n\n        .players {\n            display: flex;\n            flex-direction: row;\n            align-items: stretch;\n            min-width: 0;\n            gap: 12px;\n            flex-grow: 1;\n\n            .players-body {\n                display: flex;\n                flex-direction: column;\n                min-width: 0;\n                gap: 5px;\n                flex: 1 1 auto;\n\n                .players-body__officers-row {\n                    display: flex;\n                    align-items: flex-start;\n                    justify-content: space-between;\n                    gap: 12px;\n                    min-width: 0;\n\n                    .officers {\n                        flex: 1 1 auto;\n                        min-width: 0;\n                    }\n\n                    .event-auction-open-button {\n                        flex: 0 0 auto;\n                        margin-top: 5px;\n                        white-space: nowrap;\n                    }\n                }\n            }\n\n            .officers {\n                display: flex;\n                flex-direction: column;\n                min-width: 0;\n                flex-grow: 0;\n\n                p {\n                    margin: 5px 0;\n                }\n\n                .officers-line {\n                    display: grid;\n                    grid-template-columns: 170px minmax(0, 1fr);\n                    align-items: center;\n                    column-gap: 10px;\n                    row-gap: 6px;\n\n                    .officers-line__identity {\n                        width: fit-content;\n                    }\n\n                    strong {\n                        white-space: nowrap;\n                    }\n\n                    .react-select-input__control,\n                    .react-select__control,\n                    .react-select-menu__control {\n                        width: max-content;\n                    }\n                }\n            }\n\n            .max-attendees {\n                display: grid;\n                grid-template-columns: 170px minmax(0, 1fr);\n                align-items: center;\n                column-gap: 10px;\n                margin: 0;\n\n                .participantLimit {\n                    margin: 0;\n                    white-space: nowrap;\n                }\n\n                .field-input.participant-limit {\n                    position: relative;\n                    padding: 2px 5px 2px 5px;\n                    bottom: 5px;\n                    width: 100%;\n                    max-width: 80px;\n                }\n            }\n\n            .participants-list {\n                display: flex;\n                flex-direction: row;\n                align-items: center;\n                height: 22px;\n                width: 100%;\n\n                .participants-count {\n                    position: relative;\n                    margin: 0px 10px 0 0;\n                }\n\n                .participant-item {\n                    position: relative;\n                    margin: 0;\n\n                    .participant-avatar {\n                        border-radius: 50%;\n                        width: 22px;\n                        height: 22px;\n                        margin-right: -5px;\n                        background-color: $very-dark-grey;\n                        border: 1px solid $light-grey;\n                    }\n\n                    .participant-item__identity {\n                        &.user-discord-rank--profile-chip .user-discord-rank__avatar,\n                        &.user-discord-rank--profile-chip .user-discord-rank__avatar--placeholder {\n                            border-radius: 50%;\n                            width: 22px;\n                            height: 22px;\n                            background-color: $very-dark-grey;\n                            border: 1px solid $light-grey;\n                        }\n                    }\n                }\n            }\n\n            .participants-side-column {\n                display: flex;\n                flex-direction: row;\n                align-items: stretch;\n                align-self: stretch;\n                gap: 10px;\n                flex: 0 0 auto;\n                width: auto;\n                min-width: 0;\n            }\n\n            .participants-side-column__assignments {\n                display: flex;\n                flex-direction: column;\n                align-items: stretch;\n                align-self: flex-start;\n                flex: 0 0 168px;\n                width: 168px;\n                min-width: 168px;\n            }\n\n            .participants-side-column__signup {\n                display: flex;\n                flex-direction: column;\n                align-items: stretch;\n                align-self: stretch;\n                gap: 8px;\n                flex: 0 0 240px;\n                width: 240px;\n                min-width: 220px;\n            }\n\n            .event-planner-actions {\n                display: flex;\n                flex-direction: column;\n                align-items: stretch;\n                gap: 6px;\n                width: 100%;\n            }\n\n            .event-planner-open-button {\n                margin: 0;\n                padding: 6px 10px;\n                line-height: 1.2;\n                width: 100%;\n                box-sizing: border-box;\n                white-space: nowrap;\n                text-align: center;\n\n                &.locked {\n                    opacity: 0.55;\n                    cursor: not-allowed;\n                }\n\n                &.event-planner-open-button--modern {\n                    display: inline-flex;\n                    align-items: center;\n                    justify-content: center;\n                    min-height: 28px;\n                    border: 1px solid rgba($accent-blue, 0.42);\n                    border-radius: 8px;\n                    background: rgba($dark-panel-blue, 0.72);\n                    color: $very-light-grey;\n                    font-family: inherit;\n                    font-size: 0.72rem;\n                    font-weight: 600;\n                    text-transform: none;\n                    letter-spacing: 0.01em;\n                    box-shadow: inset 0 1px 0 rgba($pure-white, 0.04);\n                    transition:\n                        background 160ms ease,\n                        border-color 160ms ease,\n                        color 160ms ease;\n\n                    &:hover:not(:disabled):not(.locked) {\n                        border-color: rgba($light-blue, 0.55);\n                        background: rgba($blue-grey, 0.88);\n                        color: $pure-white;\n                    }\n\n                    &:disabled,\n                    &.locked {\n                        opacity: 0.55;\n                        cursor: not-allowed;\n                    }\n                }\n            }\n\n            .event-signup-select-container.participant-select-container {\n                display: flex;\n                flex-direction: row;\n                align-items: center;\n                gap: 6px;\n                width: 100%;\n                margin: 0;\n\n                .react-select-input__control,\n                .css-b62m3t-container {\n                    min-width: 0;\n                    flex: 1 1 auto;\n                }\n\n                .add-participant-button {\n                    position: relative;\n                    top: 0;\n                    flex: 0 0 auto;\n                    cursor: pointer;\n                    line-height: 0;\n\n                    &.locked {\n                        opacity: 0.45;\n                        cursor: not-allowed;\n                    }\n\n                    .add-icon {\n                        height: 20px;\n                        width: auto;\n                        display: block;\n                    }\n                }\n            }\n\n            .event-guest-signup-button-container.special-add-button-container {\n                position: relative;\n                right: 0;\n                bottom: 0;\n                height: auto;\n                margin-top: auto;\n                width: 100%;\n                display: flex;\n                justify-content: flex-end;\n\n                .special-add-button {\n                    margin-left: auto;\n                }\n            }\n        }\n\n\n\n        .joined-operation {\n            display: flex;\n            flex-direction: column;\n            flex-basis: 325px; \n            flex-shrink: 0;\n\n            .calendar-icon {\n                width: auto;\n                height: 18px;\n                margin-right: 10px;\n                margin-top: 5px;\n            }\n\n            .edit-allies {\n                height: 85px;\n                padding: 5px;\n                background-color: $panel-blue;\n                border: 1px solid rgba(58, 120, 180, 0.28);\n                border-radius: 6px;\n                overflow: auto;\n                margin-top: 5px;\n                @include scrollbar-styles;\n            }\n\n            .alliance-list {\n                max-height: 85px;\n                //background-color: $dark-grey;\n                //border: 1px solid $light-grey;\n                border-radius: 6px;\n                overflow: auto;\n                margin-top: 5px;\n                @include scrollbar-styles;\n            }\n\n            .participant-item {\n                display: flex;\n                align-items: center; \n                margin: 3px 0px 3px 0px;\n\n                .participant-logo {\n                    height: 20px;\n                    width: auto;\n                    margin-right: 10px;\n                }\n    \n                p {\n                    margin: 0;\n                }\n            }\n        }\n    }\n\n    .rewards {\n        position: relative;\n        text-align: center;\n        //margin: 10px auto;\n        display: flex;\n        flex-direction: column;\n        background-color: $very-dark-grey;\n        border: 1px solid $light-grey;\n        border-radius: 8px; \n\n        .rewards-header {\n            display: flex;\n            align-items: center; \n            margin: 10px 12px 6px;\n        \n            .calendar-icon {\n                width: auto;\n                height: 18px;\n                margin-right: 10px; /* Espace entre l'icône et le texte */\n            }\n        \n            .rewards-title {\n                margin: 0;\n                text-transform: uppercase;\n                letter-spacing: 0.08em;\n                font-size: 0.95rem;\n                font-weight: 700;\n            }\n        }\n\n        .calendar-rewards-pair {\n            display: flex;\n            flex-direction: row;\n            flex-wrap: wrap;\n            align-items: stretch;\n            justify-content: center;\n            gap: 14px;\n            margin: 6px 12px 14px;\n            box-sizing: border-box;\n        }\n\n        .calendar-rewards-pair--token-only {\n            justify-content: flex-start;\n        }\n\n        .calendar-rewards-pair--token-only .calendar-rewards-pair__token {\n            flex: 1 1 100%;\n            width: 100%;\n            max-width: 100%;\n            min-width: 0;\n        }\n\n        .calendar-rewards-pair--token-only .calendar-rewards-token-card {\n            width: 100%;\n        }\n\n        .calendar-rewards-pair__ribbon {\n            flex: 1 1 320px;\n            min-width: #{\"min(100%, 260px)\"};\n            max-width: 100%;\n        }\n\n        .calendar-rewards-pair__token {\n            flex: 0 0 auto;\n            display: flex;\n            align-items: center;\n        }\n\n        .calendar-rewards-token-card {\n            margin: 0;\n            padding: 14px 18px;\n            border: 1px solid rgba(58, 120, 180, 0.28);\n            border-radius: 12px;\n            background-color: $panel-blue;\n            box-sizing: border-box;\n            height: 100%;\n            min-height: 0;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n        }\n\n        .calendar-rewards-token-card__inner {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 16px;\n        }\n\n        .calendar-rewards-token-card__icon {\n            width: auto;\n            height: 52px;\n            flex-shrink: 0;\n            display: block;\n        }\n\n        .calendar-rewards-token-card__text {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            gap: 10px;\n        }\n\n        .calendar-rewards-token-card__qty {\n            font-size: 2rem;\n            font-weight: 800;\n            line-height: 1;\n            color: rgba($very-light-grey, 0.98);\n        }\n\n        .calendar-rewards-token-card__kind {\n            font-size: 0.72rem;\n            font-weight: 650;\n            text-transform: uppercase;\n            letter-spacing: 0.12em;\n            color: rgba($very-light-grey, 0.62);\n        }\n\n        .calendar-rewards-ribbon-card {\n            display: flex;\n            flex-direction: row;\n            flex-wrap: wrap;\n            align-items: center;\n            justify-content: left;\n            gap: 35px;\n            margin: 0;\n            padding: 18px 16px;\n            border: 1px solid rgba(58, 120, 180, 0.28);\n            border-radius: 12px;\n            background-color: $panel-blue;\n            box-sizing: border-box;\n            text-align: left;\n        }\n\n        .calendar-rewards-ribbon-card--no-progress {\n            gap: 22px;\n        }\n\n        .calendar-rewards-ribbon-card__progress {\n            flex: 0 0 auto;\n        }\n\n        .calendar-rewards-ribbon-card__ribbon {\n            flex: 0 0 auto;\n            min-width: 0;\n            display: flex;\n            justify-content: center;\n        }\n\n        .calendar-rewards-ribbon-card__ribbon-shell {\n            width: auto;\n            max-width: 300px;\n            margin: 0 auto;\n        }\n\n        .calendar-rewards-ribbon-card__ribbon-shell .selected-ribbon-container.ribbon-utils {\n            width: 100%;\n            margin: 0 auto;\n        }\n\n        .calendar-rewards-ribbon-card__ribbon-shell .ribbon-details {\n            transform: none;\n            transform-origin: center;\n        }\n\n        .calendar-rewards-ribbon-card__info {\n            flex: 0 1 auto;\n            max-width: 400px;\n            min-width: 0;\n        }\n\n        .calendar-rewards-ribbon-card__title {\n            margin: 0 0 10px;\n            text-transform: uppercase;\n            font-weight: 800;\n            font-size: 1rem;\n            letter-spacing: 0.04em;\n            line-height: 1.25;\n            color: rgba($very-light-grey, 0.96);\n        }\n\n        .calendar-rewards-ribbon-card__desc {\n            margin: 0;\n            font-size: 0.82rem;\n            line-height: 1.45;\n            color: rgba($very-light-grey, 0.62);\n        }\n\n        .calendar-rewards-ring {\n            position: relative;\n            width: 92px;\n            height: 92px;\n            flex-shrink: 0;\n        }\n\n        .calendar-rewards-ring__svg {\n            display: block;\n            width: 92px;\n            height: 92px;\n        }\n\n        .calendar-rewards-ring__track {\n            stroke: rgba($very-light-grey, 0.12);\n        }\n\n        .calendar-rewards-ring__arc {\n            stroke: $accent-blue;\n\n            filter:\n            drop-shadow(0 0 2px rgba(75, 151, 227, 0.45))\n            drop-shadow(0 0 4px rgba(58, 120, 180, 0.25));\n        }\n\n        .calendar-rewards-ring__center {\n            position: absolute;\n            inset: 0;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n            padding: 8px;\n            pointer-events: none;\n        }\n\n        .calendar-rewards-ring__fraction {\n            font-size: 0.82rem;\n            font-weight: 800;\n            line-height: 1.15;\n            color: rgba($very-light-grey, 0.98);\n        }\n\n        .calendar-rewards-ring__caption {\n            margin-top: 2px;\n            font-size: 0.52rem;\n            font-weight: 650;\n            text-transform: uppercase;\n            letter-spacing: 0.07em;\n            color: rgba($very-light-grey, 0.5);\n            text-align: center;\n            max-width: 68px;\n            line-height: 1.25;\n        }\n\n        @media (max-width: 640px) {\n            .calendar-rewards-pair {\n                flex-direction: column;\n                align-items: stretch;\n            }\n\n            .calendar-rewards-pair__ribbon {\n                flex: 1 1 auto;\n            }\n\n            .calendar-rewards-pair__token {\n                justify-content: center;\n            }\n\n            .calendar-rewards-ribbon-card {\n                flex-direction: column;\n                align-items: center;\n            }\n\n            .calendar-rewards-ribbon-card__progress {\n                display: flex;\n                justify-content: center;\n            }\n\n            .calendar-rewards-ribbon-card__info {\n                flex: 0 1 auto;\n                max-width: 100%;\n                text-align: center;\n            }\n        }\n    }\n}\n\n.selected-ribbon-container {\n    margin: 10px auto 5px auto;\n    //width: 300px;\n\n    &.display-event {\n        width: 300px;\n    }\n\n    &.event-template {\n        width: 250px;\n    }\n}\n\n.footer.calendar-event {\n    display: flex;\n    justify-content: center;   // Centre les éléments horizontalement\n    align-items: center;       // Centre les éléments verticalement si nécessaire\n    background-color: $blue-grey;\n    padding: 10px 0;\n    border-radius: 0 0 8px 8px;\n    margin: auto;\n    width: 100%; \n\n    .btn-style1 {\n        width: 200px;\n        font-size: medium;\n        margin: 0 auto;\n    }\n}\n\n\n// ----------------------//\n// ----------------------//\n\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {\n    height: 10px;\n    padding: 5px 10px;\n    white-space: nowrap;\n}\n\n/* Bandeau bas type roster (voir react-table.scss .table-base.roster .roster-table-footer) */\n.table-base.roster.calendar-page-table-shell {\n    overflow: visible;\n\n    .roster-table-footer.calendar-page-footer {\n        /* Même largeur que .rbc-calendar (header / grille) */\n        width: $full-width;\n        max-width: 100%;\n        margin-left: auto;\n        margin-right: auto;\n        min-height: 36px;\n        padding: 5px 0px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        box-sizing: border-box;\n\n        .timezone-display {\n            margin-top: 0;\n            margin-bottom: 0;\n            width: 100%;\n\n            p {\n                margin: 0;\n                text-align: center;\n                color: $light-grey;\n                font-size: 0.9em;\n            }\n        }\n    }\n}\n\n.timezone-display {\n    display: flex;\n    position: relative;\n    margin-top: 10px;\n    margin-bottom: auto;\n    justify-content: center;\n}\n\n.ribbon-tooltip {\n    display: flex;\n    flex-direction: column;\n    position: fixed;\n    background-color: $grey;\n    border: 1px solid $dark-red;\n    border-right: 0;\n    border-bottom: 4px solid $dark-red;\n    border-radius: 6px 0px 0px 6px;\n    z-index: 1000;\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\n\n    top: var(--tooltip-y, 0); // Position par défaut en haut\n    left: var(--tooltip-x, 0); // Position par défaut à gauche\n\n    &[data-tooltip-x] {\n        --tooltip-x: attr(data-tooltip-x px); // Définit la position horizontale\n    }\n\n    &[data-tooltip-y] {\n        --tooltip-y: attr(data-tooltip-y px); // Définit la position verticale\n    }\n\n\n    .ribbon-header {\n        display: flex;\n        flex-direction: row;\n        height: 30px;\n        //background: linear-gradient(to top, #4b0505, #5e2f2fd3, #4b0505);\n        border-bottom: 2px solid $blue-grey;\n        border-radius: 6px 0px 0px 0px;\n        overflow: hidden;\n        @include steel-bg(\"../medias/steel.png\");\n\n        .icon {\n            position: relative;\n            height: 30px;\n            overflow: hidden;\n            top: 5px;\n\n            .ribbon-icon {\n                position: relative;\n                height: 40px;\n                width: auto;\n                margin-left: 5px;\n                overflow-x: hidden;\n                bottom: 20px;\n            }\n        }\n        .custom-h3 {\n            color: $very-light-grey;\n            font-size: smaller;\n            font-weight: 600;\n            margin: 1px;\n            padding: 5px;\n        }\n    }\n    \n\n    .ribbon-content {\n        display: flex;\n        flex-direction: column;\n\n       .ribbon-list {\n        background: $dark-grey;\n            width: max-content;\n            max-width: 205px;\n            height: 130px;\n            padding: 10px;\n            margin: 7px 5px;\n            border: 1px solid $dark-red;\n            border-radius: 6px;\n            overflow-x: hidden;\n            @include scrollbar-styles;\n\n            label {\n                display: flex;           // Utilisation de Flexbox pour aligner la checkbox et le texte sur la même ligne\n                align-items: flex-start; // Alignement au début pour que la checkbox reste alignée en haut\n                gap: 8px;                // Espace entre la checkbox et le texte\n                max-width: 180px;        // Largeur maximale pour forcer le retour à la ligne du texte, légèrement réduit pour éviter de toucher le bord\n                word-break: break-word;  // S'assure que les mots longs se brisent correctement\n                line-height: 1.2;        // Améliorer l'espacement entre les lignes\n            }\n\n            input[type=\"checkbox\"] {\n                margin-top: 3px;         // Ajuster la position de la checkbox pour un meilleur alignement vertical\n            }\n        }\n\n        .ribbon-name {\n            color: $light-grey;\n\n            &.selected {\n                color: $light-green;\n            }\n        }\n\n        .ribbon-comment-actions {\n            margin: 8px 20px;\n        }\n\n        .ribbon-comment-editor {\n            position: absolute;\n            width: max-content;\n            top: -9px;\n            left: 230px;\n            margin: 7px 5px  0px  0px;\n\n            .mde-textarea-wrapper .mde-text {\n                height: 110px !important;\n            }\n\n            .mde-preview {\n                min-height: 110px !important;\n                max-height: 110px !important;\n                height: 110px !important;\n            }\n\n            .lexical-container {\n                .editor-container {\n                    border-top-left-radius: 0px;\n                    border-bottom-left-radius: 0px;\n                    border-left: 0px;\n                    background: $grey;\n\n                    .toolbar {\n                        border-top-left-radius: 0px;\n                    }\n                    .editor-input {\n                        min-height: 115px;\n                        background: $dark-grey;\n                        margin: 5px 6px 54px 5px;\n                        border: 1px solid $dark-red;\n                        border-radius: 6px;\n                    }\n                }\n            }\n        } \n    } \n}\n\n.special-add-button-container {\n    position: relative;\n    height: 50px;\n    right: 10px;\n    bottom: 10px;\n    display: flex;\n    align-items: flex-end;\n    justify-content: flex-end;\n}\n\n.special-add-button {\n    position: relative;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    transition: width 0.3s ease-in-out, height 0.3s ease-in-out; \n    width: 75px;\n    height: 25px;\n    background-image : url(../medias/steel.png);\n    background-color: rgba(0, 51, 128, 0.2);\n    background-blend-mode: multiply;\n    border-radius: 20px; // Bords arrondis pour un style \"bulle\"\n    overflow: hidden;\n    color: $dark-red;\n    text-transform: uppercase;\n    font-size: 0.65em;\n    font-weight: 800; // Rendre le texte un peu plus visible\n    padding-left: 8px; // Ajouter un peu de padding pour bien placer le texte\n    box-sizing: border-box;\n    box-shadow: 0px 0px 5px 2px #2f30315e;\n\n    &:hover {\n        background-color: rgba(0, 51, 128, 0.0);\n        color: $red;\n        text-decoration: none;\n        height: 50px;\n        width: 227px; // Étendre la largeur lors du survol\n        box-shadow: 0px 0px 5px 2px #2f30315e;\n    }\n\n    &.expanded {\n        width: 227px; // Étendre la largeur quand un champ est rempli\n        height: 50px;\n        background-color: rgba(0, 51, 128, 0.0);\n        box-shadow: 0px 0px 5px 2px #2f30315e;\n        border: 1px solid $red;\n    }\n\n    &:active {\n        box-shadow: 0px 0px 5px 2px #2f3031ee;\n      }\n\n    .button-label {\n        flex-shrink: 0; // Empêche l'élément de rétrécir quand le bouton est étendu\n        white-space: nowrap; // Empêche le texte de se retrouver sur deux lignes\n        margin-right: 10px; // Ajouter de l'espace entre le texte et l'icône\n        padding: 2px 2px 0px 3px;\n    }\n\n    .add-input {\n        border: none;\n        outline: none;\n        padding: 1px 10px;\n        flex-grow: 1;\n        opacity: 0; // Démarre avec une opacité de 0\n        max-height: 0; // Taille initiale à 0 pour ne pas être visible\n        transition: opacity 0.3s ease-in-out, max-height 0.3s ease-in-out; \n\n        &.handle-input {\n            border-radius: 12px 12px 0px 0px;\n        }\n\n        &.discord-id-input {\n            border-radius: 0px 0px 12px 12px;\n        }\n\n        &.visible {\n            margin-top: 1px;\n            margin-bottom: 1px;\n            opacity: 1; // Rend l'opacité à 1 pour afficher\n            max-height: 50px; // Ajuste la hauteur pour permettre l'affichage\n            box-shadow: 0px 0px 4px 2px #2f303169;\n        }\n    }\n\n    .add-icon-wrapper {\n        display: flex;\n        position: relative;\n        justify-content: center;\n        align-items: center;\n        width: 26px;\n        height: 26px;\n        color: $dark-red;\n        top: 1px;\n        right: 2px;\n        flex-shrink: 0; // Empêche l'icône de rétrécir\n        margin-left: auto; // Pousse l'icône à droite du conteneur\n    }\n\n    .plus-icon {\n        font-size: 22px;\n    }\n}\n\n\n.event-debrief {\n    .input-field {\n        .react-mde, .react-mde-tabbed-layout {\n            .mde-textarea-wrapper {\n                .mde-text {\n                    height: 300px !important;\n                }\n            }\n\n            .mde-preview {\n                height: 300px !important;\n            }\n        }\n    }\n}\n\n.content, .calendar-debrief-default {\n\n    .react-mde, .react-mde-tabbed-layout {\n        .mde-textarea-wrapper {\n            .mde-text {\n                height: 300px !important;\n            }\n        }\n\n        .mde-preview {\n            height: 300px !important;\n        }\n    }\n}\n\n.token-reward {\n    display: flex;\n    align-items: center;\n    margin: auto;\n    gap: 10px;\n}\n\n.token-image {\n    width: auto;\n    height: 45px;\n}\n\n.token-label {\n    font-weight: bold;\n    font-size: 1rem;\n    color: $very-light-grey;\n}\n\n\n.objectives-benefits-row {\n    .inputs-column.objectives {\n        width: -webkit-fill-available;\n        background-color: $very-dark-grey;\n        border: 1px solid $very-light-grey;\n        border-radius: 8px;\n        padding: 10px;\n\n       .input {\n           margin-bottom: 0;\n       }\n    }\n}\n\n// Objectives toggle should match Joined Operation design\n.objectives {\n    width: 285px;\n\n    .toggle.objectives {\n        @include toggle-row-objectives-style;\n        justify-content: space-between;\n        position: relative;\n        text-transform: none;\n        font-size: 14px;\n        font-weight: normal;\n        color: $very-light-grey;\n\n        .toggle-label {\n            font-weight: normal;\n            font-size: 0.9rem;\n            display: flex;\n        }\n    }\n}\n\n.objectives-block {\n    display: flex;\n    flex-direction: column;\n    border: 1px solid $very-light-grey;\n    margin-top: 8px;\n    border-radius: 4px;\n    padding: 6px;\n    gap: 6px;\n    width: 280px;\n    box-sizing: border-box;\n\n    &.disabled {\n        opacity: 0.5;\n    }\n\n    .objectives-scroll {\n        height: 142px;\n        overflow-y: auto;\n        display: flex;\n        flex-direction: column;\n        gap: 5px;\n        padding-right: 6px;\n        @include scrollbar-styles;\n    }\n\n    .objective-row {\n        position: relative;\n        display: grid;\n        grid-template-columns: 18px auto 45px;\n        gap: 6px;\n        align-items: center;\n    }\n\n    .objective-order {\n        font-size: 0.85em;\n        color: $very-light-grey;   \n        opacity: 0.75;\n        text-align: right;\n        user-select: none;\n        cursor: grab;\n\n        &.is-disabled {\n            opacity: 0.25;\n            cursor: default;\n        }\n    }\n\n    .objective-input {\n        width: 100%;\n        box-sizing: border-box;\n    }\n\n    .toggle.critical {\n        height: 11px;\n        display: flex;\n        align-items: center;\n        gap: 6px;\n    }\n\n}\n\n// Roster file history: narrow dialog only (--card-top keeps default calendar modal width)\n.calendar-event-modal.calendar-event-modal--roster-file {\n    .modal-dialog {\n        max-width: #{\"min(900px, 94vw)\"};\n        width: #{\"min(900px, 94vw)\"};\n        margin: 1.25rem auto;\n    }\n\n    // Override global .calendar-event-modal .modal-content { min-width: 960px } so the card can be narrow\n    .modal-dialog .modal-content {\n        min-width: 0;\n        max-width: 100%;\n    }\n}\n\n// Roster preview + main calendar detailed view: shared card shell (header/banner + panel chrome)\n.calendar-event-modal.calendar-event-modal--roster-file,\n.calendar-event-modal.calendar-event-modal--card-top {\n    .modal-content {\n        background: linear-gradient(165deg, rgba($panel-blue, 0.97), rgba($dark-panel-blue, 0.99));\n        border: 1px solid rgba($dark-red, 1);\n        border-bottom: 4px solid rgba($dark-red, 1);\n        border-radius: 12px;\n        margin: 100px auto;\n        overflow: hidden;\n        box-shadow:\n            0 0 0 1px rgba(0, 0, 0, 0.35),\n            0 22px 50px rgba(0, 0, 0, 0.55);\n    }\n\n    .modal-body {\n        padding: 0;\n        background: transparent;\n    }\n\n    // Roster preview: panneaux cohérents avec le thème roster (accent bleu), pas le chrome gris type event-objectives-view\n    .content.calendar-event.calendar-event-card-main {\n        background: $panel-blue;\n        padding: 10px 12px 14px;\n        border-radius: 0;\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        box-sizing: border-box;\n\n        .calendar-event-card-main-controls {\n            display: flex;\n            flex-wrap: wrap;\n            align-items: center;\n            justify-content: space-between;\n            gap: 10px;\n            box-sizing: border-box;\n\n            .create-event-access-toggle {\n                margin-left: auto;\n                margin-right: 8px;\n            }\n\n            .calendar-event-access-chip {\n                margin-left: auto;\n                margin-right: 8px;\n                display: inline-flex;\n                align-items: center;\n                padding: 4px 10px;\n                border-radius: 999px;\n                border: 1px solid rgba($accent-blue, 0.35);\n                background: rgba($dark-panel-blue, 0.85);\n                color: $very-light-grey;\n                font-size: 0.72rem;\n                font-weight: 600;\n                letter-spacing: 0.02em;\n                line-height: 1.2;\n                text-transform: lowercase;\n                white-space: nowrap;\n            }\n\n            .calendar-event-access-chip--public {\n                border-color: rgba($green, 0.45);\n                color: $light-green;\n            }\n\n            .calendar-event-access-chip--private {\n                border-color: rgba($accent-blue, 0.4);\n                color: $very-light-grey;\n            }\n\n            .calendar-event-access-chip--invite-only {\n                border-color: rgba($orange, 0.5);\n                color: $light-orange;\n            }\n        }\n\n        .calendar-event-header-status {\n            flex-shrink: 0;\n            line-height: 1;\n\n            &:empty {\n                display: none;\n            }\n\n            .calendar-event.status {\n                margin: 0;\n            }\n\n            .calendar-event-header-status-group {\n                display: flex;\n                flex-direction: column;\n                align-items: flex-start;\n                gap: 6px;\n\n                .calendar-event.status {\n                    margin: 0;\n                }\n\n                .calendar-event-tentative-toggle {\n                    margin: 5px 25px 5px;\n                    font-size: 11px;\n\n                    .toggle-label {\n                        margin-left: 0;\n                        top: 0;\n                    }\n                }\n            }\n        }\n\n        .calendar-event-header-toolbar {\n            display: flex;\n            flex-wrap: wrap;\n            align-items: center;\n            justify-content: flex-end;\n            gap: 8px;\n            min-width: 0;\n            max-width: 100%;\n\n            .edit-mode {\n                display: flex;\n                flex-wrap: wrap;\n                align-items: center;\n                gap: 8px;\n                margin: 0;\n            }\n\n            .btn-style1 {\n                font-size: 11px;\n                padding: 5px 10px;\n            }\n        }\n    }\n\n    .content.calendar-event.calendar-event-card-main .calendar-event.time {\n        border: 1px solid rgba($accent-blue, 0.28);\n        border-radius: 10px;\n        //background: $panel-blue;\n        padding: 10px;\n        min-height: auto;\n        box-sizing: border-box;\n\n        .column {\n            border-color: rgba($accent-blue, 0.18);\n        }\n    }\n\n    .content.calendar-event.calendar-event-card-main .selected-ribbon-container {\n        width: 250px;\n        max-width: 100%;\n        margin: 0 auto;\n        box-sizing: border-box;\n\n        &.display-event {\n            width: 250px;\n        }\n    }\n\n    .content.calendar-event.calendar-event-card-main .participants {\n        background: $dark-panel-blue;\n        height: auto;\n        border: 1px solid rgba($accent-blue, 0.28);\n        border-radius: 10px;\n        padding: 10px;\n        box-sizing: border-box;\n        position: relative;\n\n        .players {\n            position: relative;\n            padding-bottom: 0;\n            min-width: 0;\n        }\n    }\n\n    .content.calendar-event.calendar-event-card-main .joined-operation--standalone-card {\n        display: flex;\n        flex-direction: column;\n        flex-basis: auto;\n        flex-shrink: 1;\n        width: 100%;\n        margin-top: 10px;\n        background: $dark-panel-blue;\n        height: auto;\n        border: 1px solid rgba($accent-blue, 0.28);\n        border-radius: 10px;\n        padding: 10px;\n        box-sizing: border-box;\n\n        .joined-operation-header {\n            margin: 0 0 6px;\n\n            label {\n                margin: 0;\n                color: rgba(255, 255, 255, 0.92);\n            }\n        }\n\n        .alliance-list {\n            max-height: none;\n            margin-top: 0;\n        }\n\n        .edit-allies {\n            display: flex;\n            flex-direction: column;\n            gap: 4px;\n            max-height: 140px;\n            padding: 6px 8px;\n            background-color: $panel-blue;\n            border: 1px solid rgba($accent-blue, 0.28);\n            border-radius: 6px;\n            overflow: auto;\n            margin-top: 0;\n            @include scrollbar-styles;\n\n            .ally-checkbox {\n                display: flex;\n                align-items: center;\n                gap: 8px;\n                color: $very-light-grey;\n\n                label {\n                    margin: 0;\n                    font-weight: normal;\n                    cursor: pointer;\n                }\n\n                input[type=\"checkbox\"] {\n                    cursor: pointer;\n                }\n            }\n        }\n    }\n\n    .content.calendar-event.calendar-event-card-main .calendar-event-accordion {\n        background: $dark-panel-blue;\n        border: 1px solid rgba($accent-blue, 0.28);\n        border-radius: 10px;\n        padding: 10px;\n        box-sizing: border-box;\n    }\n\n    .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        width: 100%;\n        box-sizing: border-box;\n\n        .ui-subtabs {\n            align-self: center;\n            margin-top: 0;\n        }\n    }\n\n    .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panels {\n        width: 100%;\n        box-sizing: border-box;\n    }\n\n    // Same body height for description / report / objectives+benefits / debrief chat.\n    $calendar-event-content-panel-height: 50vh;\n\n    .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panel--surface {\n        background: $dark-panel-blue;\n        border: 1px solid rgba($accent-blue, 0.28);\n        border-radius: 10px;\n        padding: 10px;\n        box-sizing: border-box;\n        height: $calendar-event-content-panel-height;\n        max-height: $calendar-event-content-panel-height;\n        overflow: auto;\n        @include scrollbar-styles();\n\n        .event-report-content,\n        .description-content {\n            padding: 0 12px;\n            max-height: none;\n        }\n    }\n\n    .content.calendar-event.calendar-event-card-main .calendar-event-content-subtabs__panels > .objectives-benefits-row {\n        height: $calendar-event-content-panel-height;\n        max-height: $calendar-event-content-panel-height;\n        min-height: 0;\n        align-items: stretch;\n\n        > .event-objectives-view,\n        > .objectives-report-block,\n        > .benefits-block {\n            height: 100%;\n            max-height: 100%;\n            min-height: 0;\n            box-sizing: border-box;\n        }\n\n        > .event-objectives-view {\n            display: flex;\n            flex-direction: column;\n\n            .event-objectives-view-list {\n                flex: 1 1 auto;\n                min-height: 0;\n                max-height: none;\n            }\n        }\n\n        > .objectives-report-block {\n            .objectives-report-list {\n                flex: 1 1 auto;\n                min-height: 0;\n                max-height: none;\n            }\n        }\n\n        > .benefits-block.benefits-block--event-modal-readonly {\n            height: 100%;\n            max-height: 100%;\n        }\n    }\n\n    .content.calendar-event.calendar-event-card-main .calendar-event.calendar-event-debrief-room {\n        margin: 0;\n        box-sizing: border-box;\n        height: $calendar-event-content-panel-height;\n        max-height: $calendar-event-content-panel-height;\n    }\n\n    .content.calendar-event.calendar-event-card-main .calendar-event-debrief-room-frame {\n        background: $panel-blue;\n        border: 1px solid rgba($accent-blue, 0.28);\n        border-radius: 10px;\n        padding: 10px;\n        box-sizing: border-box;\n    }\n\n    .content.calendar-event.calendar-event-card-main .calendar-event-debrief-room-heading {\n        margin: 0 0 10px 0;\n        font-size: 1rem;\n        font-weight: 600;\n        color: rgba(255, 255, 255, 0.92);\n    }\n\n    .content.calendar-event.calendar-event-card-main .calendar-event-debrief-room .chat-container {\n        height: 100%;\n\n        .chat-unified-frame {\n            min-height: 100%;\n            height: 100%;\n            display: flex;\n            flex-direction: column;\n        }\n\n        .chat-unified-body {\n            flex: 1;\n            min-height: 0;\n            max-height: none;\n        }\n    }\n\n    .content.calendar-event.calendar-event-card-main .calendar-event.rewards {\n        width: 100%;\n        background: $dark-panel-blue;\n        border: 1px solid rgba($accent-blue, 0.28);\n        border-radius: 10px;\n        padding: 10px;\n        box-sizing: border-box;\n    }\n\n    .content.calendar-event.calendar-event-card-main .objectives-benefits-row {\n        .event-objectives-view,\n        .benefits-block:not(.benefits-block--event-modal-readonly) {\n            background: $dark-panel-blue;\n            border: 1px solid rgba($accent-blue, 0.28);\n            border-radius: 10px;\n        }\n\n        .benefits-block-header-box-icon {\n            width: 18px;\n            height: 18px;\n            object-fit: contain;\n            flex-shrink: 0;\n            opacity: 0.92;\n        }\n\n        .event-objectives-view-header .calendar-icon.block-icon,\n        .objectives-report-header .calendar-icon.block-icon {\n            width: 18px;\n            height: 18px;\n            object-fit: contain;\n            flex: 0 0 auto;\n            margin-right: 0;\n        }\n    }\n\n    .footer.calendar-event {\n        background: linear-gradient(180deg, rgba($dark-panel-blue, 0.9), rgba($panel-blue, 0.85));\n        border-top: 1px solid rgba($accent-blue, 0.22);\n        border-radius: 0 0 11px 11px;\n        padding: 12px 0;\n    }\n}\n\n.benefits-loot-move-popover-backdrop {\n    position: fixed;\n    inset: 0;\n    z-index: 10100;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 16px;\n    background: rgba(0, 0, 0, 0.45);\n}\n\n.benefits-loot-move-popover {\n    width: 100%;\n    max-width: 320px;\n    padding: 16px 18px;\n    border-radius: 10px;\n    border: 1px solid rgba($medium-grey, 0.85);\n    background: $very-dark-grey;\n    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.45);\n    color: $very-light-grey;\n}\n\n.benefits-loot-move-popover__title {\n    margin: 0 0 4px;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.benefits-loot-move-popover__target {\n    margin: 0 0 14px;\n    font-size: 12px;\n    opacity: 0.85;\n}\n\n.benefits-loot-move-popover__stepper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    margin-bottom: 10px;\n}\n\n.benefits-loot-move-popover__stepper-btn {\n    flex: 0 0 auto;\n    width: 34px;\n    height: 34px;\n    border-radius: 8px;\n    border: 1px solid rgba($medium-grey, 0.9);\n    background: rgba(255, 255, 255, 0.06);\n    color: $pure-white;\n    font-size: 18px;\n    line-height: 1;\n    cursor: pointer;\n\n    &:disabled {\n        opacity: 0.35;\n        cursor: not-allowed;\n    }\n\n    &:hover:not(:disabled),\n    &:focus-visible:not(:disabled) {\n        border-color: rgba($accent-blue, 0.75);\n        background: rgba($accent-blue, 0.14);\n    }\n}\n\n.benefits-loot-move-popover__qty-field {\n    display: inline-flex;\n    align-items: baseline;\n    gap: 6px;\n    min-width: 88px;\n    justify-content: center;\n}\n\n.benefits-loot-move-popover__qty-input {\n    width: 4ch;\n    min-width: 3ch;\n    padding: 6px 8px;\n    border-radius: 6px;\n    border: 1px solid rgba($medium-grey, 0.85);\n    background: rgba(0, 0, 0, 0.25);\n    color: $pure-white;\n    font-size: 16px;\n    font-weight: 700;\n    text-align: center;\n}\n\n.benefits-loot-move-popover__qty-max {\n    font-size: 12px;\n    opacity: 0.75;\n}\n\n.benefits-loot-move-popover__shortcuts {\n    display: flex;\n    justify-content: center;\n    gap: 12px;\n    margin-bottom: 8px;\n}\n\n.benefits-loot-move-popover__shortcut-link {\n    border: 0;\n    padding: 0;\n    background: transparent;\n    color: rgba($accent-blue, 0.95);\n    font-size: 12px;\n    text-decoration: underline;\n    text-underline-offset: 2px;\n    cursor: pointer;\n\n    &:hover,\n    &:focus-visible {\n        color: lighten($accent-blue, 8%);\n    }\n}\n\n.benefits-loot-move-popover__hint {\n    margin: 0 0 14px;\n    font-size: 11px;\n    opacity: 0.65;\n    text-align: center;\n}\n\n.benefits-loot-move-popover__actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n}\n\n.benefits-loot-move-popover__btn {\n    min-width: 72px;\n    padding: 8px 12px;\n    border-radius: 8px;\n    border: 1px solid rgba($medium-grey, 0.85);\n    font-size: 12px;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.benefits-loot-move-popover__btn--ghost {\n    background: transparent;\n    color: $very-light-grey;\n}\n\n.benefits-loot-move-popover__btn--primary {\n    background: rgba($accent-blue, 0.22);\n    border-color: rgba($accent-blue, 0.65);\n    color: $pure-white;\n\n    &:disabled {\n        opacity: 0.45;\n        cursor: not-allowed;\n    }\n}\n\n// Calendar tools partials (loaded globally via styles.scss — no per-component SCSS imports).\n@import '../../pages/private/members/calendarTools/event/components/EventBenefitsModalUeclayout.scss';\n@import '../../pages/private/members/calendarTools/event/components/EventObjectivesView.scss';\n@import '../../pages/private/members/calendarTools/report/components/ReportObjectivesBlock.scss';\n","@import '../../../../../../styles/variables.scss';\n\n/*\n * Benefits UEC layout for the calendar EVENT modal — duplicated from bigCalendar.scss\n * (rules that lived under \".calendar-event-report.content … .benefits-block …\" only).\n * Loaded globally via styles.scss → bigCalendar.scss (no component-level SCSS import).\n */\n\n.content.calendar-event .benefits-block.benefits-block--event-modal-readonly {\n  background: $dark-panel-blue;\n  border: 1px solid rgba(58, 120, 180, 0.28);\n  border-radius: 8px;\n  padding: 10px;\n  margin: 0;\n  height: 100%;\n  min-height: 0;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  z-index: 1;\n\n  .benefits-block-header-box-icon {\n    width: 18px;\n    height: 18px;\n    object-fit: contain;\n    flex-shrink: 0;\n    opacity: 0.92;\n  }\n\n  .benefits-block-header {\n    margin-bottom: 6px;\n    text-transform: uppercase;\n    font-size: 0.85em;\n    opacity: 0.9;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .benefits-block-body {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow: auto;\n    @include scrollbar-styles();\n  }\n\n  .benefits-uec {\n      display: flex;\n      flex-direction: column;\n      height: 100%;\n      gap: 15px;\n      min-height: 0;\n  }\n  \n  .benefits-uec-top {\n      display: flex;\n      gap: 12px;\n      align-items: flex-start;\n  }\n  \n  .benefits-uec-loot-distributed-badge {\n      flex: 0 0 auto;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      align-self: end;\n      gap: 2px;\n      padding: 8px 10px;\n      border-radius: 8px;\n      border: 1px solid rgba(255, 255, 255, 0.14);\n      background: rgba(0, 0, 0, 0.18);\n      min-width: 56px;\n      user-select: none;\n  }\n  \n  .benefits-uec-loot-distributed-badge__label {\n      font-size: 0.65rem;\n      font-weight: 700;\n      letter-spacing: 0.06em;\n      text-transform: uppercase;\n      opacity: 0.75;\n      line-height: 1.1;\n      white-space: nowrap;\n  }\n  \n  .benefits-uec-loot-distributed-badge__value {\n      font-size: 1.05rem;\n      font-weight: 700;\n      line-height: 1;\n      color: rgba(255, 255, 255, 0.92);\n  }\n  \n  .benefits-uec-top-left-cluster,\n  .benefits-uec-top-left,\n  .benefits-uec-top-right {\n      min-width: 0;\n  }\n  \n  .benefits-uec-top-left-cluster {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      gap: 10px;\n      flex: 1 1 auto;\n  }\n  \n  .benefits-uec-top-left-cluster .benefits-uec-top-left {\n      flex: 0 1 auto;\n      //max-width: #{\"min(100%, 400px)\"};\n  }\n  \n  .benefits-uec-top-right {\n      flex: 0 0 auto;\n      /* Visually line up the loot field with the UEC `field-input` row (not the label). */\n      align-self: flex-end;\n  }\n  \n  .benefits-uec-top-left-cluster:only-child {\n      width: 100%;\n  }\n  \n  .benefits-uec-top-left {\n      display: flex;\n      flex-direction: column;\n      gap: 6px;\n  }\n  \n  .benefits-uec-payout-lock-wrap {\n      flex: 0 0 auto;\n      position: relative;\n      top: 10px;\n      align-self: center;\n      max-width: 15rem;\n  }\n  \n  &:not(.benefits-block--expanded) .benefits-uec-top-left-cluster .benefits-uec-payout-lock-wrap {\n      margin-left: auto;\n  }\n  \n  /* Benefits-only: label + switch alignment (do not use `.join-operation` here). */\n  .benefits-uec-payout-lock-wrap .toggle.benefits-uec-payout-lock-toggle-row {\n      @include toggle-benefits-payout-lock-row;\n  }\n  \n  .benefits-uec-row {\n      display: flex;\n      flex-direction: column;\n      align-items: stretch;\n      gap: 6px;\n  }\n  \n  .benefits-uec-label {\n      font-size: 0.85em;\n      opacity: 0.9;\n      text-transform: uppercase;\n      white-space: nowrap;\n  }\n  \n  .benefits-uec-label-sub {\n      font-size: 0.85em;\n      opacity: 0.85;\n      text-transform: capitalize;\n  }\n  \n  .benefits-uec-total-with-share {\n      display: flex;\n      flex-direction: row;\n      align-items: flex-end;\n      //flex-wrap: wrap;\n      gap: 8px;\n      min-width: 0;\n  }\n  \n  .benefits-uec-org-share-compact {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 2px;\n      flex: 0 1 auto;\n      min-width: 0;\n      max-width: 100%;\n  }\n  \n  .benefits-uec-org-share-compact__label {\n      font-size: 0.72rem;\n      font-weight: 600;\n      color: rgba(255, 255, 255, 0.55);\n      letter-spacing: 0.02em;\n      white-space: nowrap;\n  }\n  \n  .benefits-uec-org-share-compact__amount {\n      font-size: 0.8rem;\n      font-weight: 600;\n      color: rgba(255, 255, 255, 0.82);\n      white-space: nowrap;\n  }\n  \n  .benefits-uec-input-shell {\n      display: flex;\n      align-items: stretch;\n      width: 200px;\n      background: $very-dark-grey;\n      border: 1px solid $medium-grey;\n      border-radius: 6px;\n      overflow: hidden;\n  }\n  \n  .benefits-uec-input-shell.locked {\n      opacity: 0.7;\n  }\n  \n  .benefits-uec-input {\n      color: $very-light-grey;\n      font-size: 15px;\n      font-weight: 600;\n      flex: 1 1 auto;\n      background: $light-panel-blue;\n      border: 0;\n      padding: 5px 10px;\n      text-align: left;\n      min-width: 0;\n  }\n  \n  .benefits-uec-input.locked {\n      cursor: not-allowed;\n  }\n  \n  .benefits-uec-input:focus {\n      outline: none;\n  }\n  \n  .benefits-uec-input-unit {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex: 0 0 auto;\n      \n      padding: 5px 10px;\n      background: rgba($medium-grey, 0.25);\n      border-left: 1px solid rgba($medium-grey, 0.6);\n      color: $very-light-grey;\n      font-size: 15px;\n      font-weight: 600;\n      letter-spacing: 0.02em;\n      min-width: 45px;\n      user-select: none;\n  }\n  \n  .benefits-uec-hint {\n      font-size: 0.9em;\n      opacity: 0.85;\n  }\n  \n  .benefits-uec-hint.locked {\n      opacity: 0.65;\n  }\n  \n  &:not(.benefits-block--expanded) .benefits-org-bank {\n      display: none;\n  }\n  \n  &:not(.benefits-block--expanded) .benefits-uec-top-right {\n      display: none;\n  }\n  \n  &:not(.benefits-block--expanded) .benefits-uec-participants-header-left {\n      grid-template-columns: minmax(0, 1fr) minmax(88px, 180px) minmax(56px, 72px);\n  }\n  \n  &:not(.benefits-block--expanded) .benefits-uec-participants-header-cell:nth-child(4) {\n      display: none;\n  }\n  \n  .benefits-org-bank {\n      position: relative;\n      width: 100%;\n      box-sizing: border-box;\n      border: 1px solid $medium-grey;\n      border-radius: 6px;\n      padding: 10px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 12px;\n      min-width: 0;\n      cursor: pointer;\n  }\n  \n  .benefits-org-bank.is-active {\n      background: rgba($accent-blue, 0.16);\n      box-shadow: 0 0 0 2px rgba($accent-blue, 0.18);\n  }\n  \n  .benefits-org-bank-start {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      align-self: start;\n      gap: 10px;\n      padding: 5px;\n      min-width: 0;\n      flex: 0 1 auto;\n  }\n  \n  .benefits-org-bank-logo {\n      flex: 0 0 auto;\n      line-height: 0;\n      background: $light-panel-blue;\n      padding: 5px;\n      border: 1px solid $medium-grey;\n      border-radius: 6px;\n  }\n  \n  .benefits-org-bank-logo__img {\n      display: block;\n      width: 28px;\n      height: auto;\n      max-height: 32px;\n      max-width: 36px;\n      object-fit: contain;\n      filter: grayscale(1) contrast(1.08) brightness(1.05);\n      opacity: 0.65;\n  }\n  \n  .benefits-org-bank-left {\n      flex: 0 1 auto;\n      position: relative;\n      z-index: 0;\n      display: flex;\n      flex-direction: column;\n      align-self: start;\n      gap: 4px;\n      min-width: 0;\n  }\n  \n  .benefits-org-bank-title {\n      font-size: 0.8em;\n      opacity: 0.9;\n      text-transform: uppercase;\n      white-space: nowrap;\n  }\n  \n  .benefits-org-bank-title-sub {\n      font-size: 0.85em;\n      opacity: 0.85;\n      text-transform: capitalize;\n  }\n  \n  .benefits-org-bank-amount {\n      font-size: 15px;\n      font-weight: 600;\n      color: $very-light-grey;\n      white-space: nowrap;\n  }\n  \n  .benefits-org-bank-right {\n      flex: 1 1 0;\n      position: relative;\n      background: $very-dark-grey;\n      border-radius: 8px;\n      z-index: 0;\n      display: flex;\n      justify-content: flex-start;\n      min-width: 0;\n  }\n  \n  .benefits-org-bank-loot-placeholder {\n      border: 1px dashed rgba($medium-grey, 0.8);\n      border-radius: 6px;\n      padding: 8px 10px;\n      min-height: 30px;\n      width: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n      opacity: 0.8;\n      position: relative;\n      z-index: 1;\n      overflow: hidden;\n  }\n  \n  .benefits-org-bank-loot-placeholder.is-empty {\n      justify-content: center;\n  }\n  \n  .benefits-org-bank-loot-placeholder .benefits-loot-chips,\n  .benefits-org-bank-loot-drop .benefits-loot-chips {\n      position: relative;\n      z-index: 2;\n  }\n  \n  .benefits-org-bank-loot-drop {\n      width: 100%;\n  }\n  \n  .benefits-org-bank.is-dnd-over {\n      box-shadow: inset 0 0 0 2px rgba($accent-blue, 0.55);\n      background: rgba($accent-blue, 0.08);\n  }\n\n  .benefits-org-bank-loot-drop.is-dnd-over {\n      box-shadow: inset 0 0 0 2px rgba($accent-blue, 0.55);\n      background: rgba($accent-blue, 0.1);\n  }\n\n  .benefits-uec-participant.is-dnd-over {\n      box-shadow: inset 0 0 0 1px rgba($accent-blue, 0.45);\n  }\n  \n  .benefits-uec-summary {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n  }\n  \n  .benefits-uec-participants {\n      display: flex;\n      flex-direction: column;\n      gap: 0;\n      min-height: 0;\n      flex: 1 1 auto;\n  }\n  \n  .benefits-uec-participants-header {\n      display: flex;\n      align-items: stretch;\n      justify-content: space-between;\n      gap: 12px;\n      min-width: 0;\n      padding: 8px 10px;\n      background: rgba(255, 255, 255, 0.04);\n      border: 1px solid rgba(255, 255, 255, 0.1);\n      border-bottom: 1px solid rgba(255, 255, 255, 0.12);\n      border-radius: 6px 6px 0 0;\n  }\n  \n  .benefits-uec-participants-header-left {\n      flex: 1 1 auto;\n      min-width: 0;\n      display: grid;\n      grid-template-columns: minmax(0, 1fr) minmax(96px, 200px) 44px minmax(0, 1fr);\n      gap: 10px;\n      align-items: center;\n      padding: 0;\n  }\n  \n  .benefits-uec-participants-header-cell {\n      font-size: 0.7em;\n      font-weight: 600;\n      letter-spacing: 0.04em;\n      opacity: 0.9;\n      text-transform: uppercase;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n  }\n  \n  .benefits-uec-participants-header-cell:nth-child(2) {\n      text-align: right;\n  }\n  \n  .benefits-uec-participants-list {\n      overflow: auto;\n      border: 1px solid rgba(255, 255, 255, 0.1);\n      border-top: 0;\n      border-radius: 0 0 6px 6px;\n      padding: 6px 10px;\n      display: flex;\n      flex-direction: column;\n      gap: 6px;\n      min-height: 0;\n      background: rgba(0, 0, 0, 0.12);\n      @include scrollbar-styles();\n  }\n  \n  // List rows only: expanded mode uses `<tr class=\"benefits-uec-participant\">`; `display:flex` on `<tr>`\n  // breaks table column layout (all cells stack in the first column).\n  .benefits-uec-participants-list:not(.benefits-uec-participants-list--table) > .benefits-uec-participant {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 10px;\n      cursor: pointer;\n  }\n  \n  .benefits-uec-participants-list:not(.benefits-uec-participants-list--table) > .benefits-uec-participant.is-expanded {\n      align-items: flex-start;\n  }\n  \n  .benefits-uec-participant.is-active {\n      background: rgba($accent-blue, 0.16);\n      border-radius: 6px;\n  }\n  \n  &.benefits-block--expanded .benefits-uec-participants-list--table {\n      display: block;\n      gap: 0;\n      padding: 0;\n      overflow: auto;\n      border: 1px solid rgba(255, 255, 255, 0.1);\n      border-radius: 6px;\n      min-height: 0;\n      background: rgba(0, 0, 0, 0.12);\n      @include scrollbar-styles();\n  }\n\n  &.benefits-block--expanded .benefits-uec-participants-table tbody tr.benefits-uec-participant {\n      display: table-row;\n  }\n  \n  &.benefits-block--expanded .benefits-uec-participants-table {\n      width: 100%;\n      border-collapse: collapse;\n      table-layout: fixed;\n  }\n  \n  /* colgroup: narrower identity; mini payout-toggle; loot stays 60% */\n  &.benefits-block--expanded .benefits-uec-participants-col--identity {\n      width: 19%;\n  }\n  \n  &.benefits-block--expanded .benefits-uec-participants-col--payout {\n      width: 14%;\n  }\n  \n  &.benefits-block--expanded .benefits-uec-participants-col--payoutToggle {\n      width: 7%;\n  }\n  \n  &.benefits-block--expanded .benefits-uec-participants-col--loot {\n      width: 60%;\n  }\n  \n  &.benefits-block--expanded .benefits-uec-participants-table thead tr {\n      background: rgba(255, 255, 255, 0.04);\n  }\n  \n  &.benefits-block--expanded .benefits-uec-participants-th {\n      padding: 8px 10px;\n      text-align: left;\n      border-bottom: 1px solid rgba(255, 255, 255, 0.12);\n      font-weight: 600;\n  }\n  \n  &.benefits-block--expanded .benefits-uec-participants-th--payout {\n      text-align: right;\n  }\n  \n  &.benefits-block--expanded .benefits-uec-participants-th--payoutToggle {\n      text-align: center;\n      padding-left: 4px;\n      padding-right: 4px;\n  }\n  \n  &.benefits-block--expanded .benefits-uec-participants-table tbody tr.benefits-uec-participant td {\n      padding: 8px 10px;\n      vertical-align: center;\n      border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  }\n  \n  &.benefits-block--expanded .benefits-uec-participants-table tbody tr.benefits-uec-participant:last-child td {\n      border-bottom: 0;\n  }\n  \n  &.benefits-block--expanded .benefits-uec-participants-td--payout {\n      text-align: right;\n  }\n  \n  &.benefits-block--expanded .benefits-uec-participants-td--payoutToggle {\n      text-align: center;\n      vertical-align: middle;\n      padding-left: 4px;\n      padding-right: 4px;\n  }\n  \n  &.benefits-block--expanded .benefits-uec-participants-td--identity,\n  &.benefits-block--expanded .benefits-uec-participants-td--loot {\n      min-width: 0;\n  }\n\n  &.benefits-block--expanded .benefits-uec-participants-td--loot {\n      min-height: 44px;\n      height: 100%;\n  }\n  \n  &.benefits-block--expanded .benefits-uec-participant-loots {\n      min-width: 0;\n      width: 100%;\n      padding-top: 2px;\n  }\n  \n  &.benefits-block--expanded .benefits-uec-participant-loots--empty {\n      min-height: 0;\n  }\n  \n  &:not(.benefits-block--expanded) .benefits-uec-participant-row {\n      display: grid;\n      grid-template-columns: minmax(0, 1fr) minmax(88px, 180px) 44px;\n      gap: 10px;\n      align-items: center;\n      width: 100%;\n      min-width: 0;\n  }\n  \n  &:not(.benefits-block--expanded) .benefits-uec-participant-cell--payoutToggle {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      min-width: 0;\n  }\n  \n  &:not(.benefits-block--expanded) .benefits-uec-participant-cell--identity {\n      min-width: 0;\n  }\n  \n  &:not(.benefits-block--expanded) .benefits-uec-participant-cell--payout {\n      justify-self: end;\n      text-align: right;\n      align-self: center;\n  }\n  \n  &.benefits-block--expanded .benefits-uec-participant-identity {\n      min-width: 0;\n  }\n  \n  &.benefits-block--expanded .benefits-uec-participant-identity .user-discord-rank__name {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      max-width: 100%;\n  }\n  \n  // Collapsed rows use a div with `benefits-uec-participant-cell`; expanded table uses `<td>` without\n  // that class — do not force `display:flex` on table cells or columns collapse.\n  .benefits-uec-participant-cell.benefits-uec-participant-right {\n      display: flex;\n      align-items: flex-start;\n      justify-content: flex-end;\n      gap: 8px;\n      flex: 0 0 auto;\n  }\n  \n  .benefits-loot-actions {\n      display: flex;\n      align-items: flex-start;\n      justify-content: flex-end;\n      gap: 8px;\n      min-width: 0;\n  }\n  \n  // Input row matches `benefits-uec-input-shell`; wrap stays `position: relative` for dropdown.\n  .benefits-loot-mention-wrap {\n      position: relative;\n      flex: 1 1 auto;\n      min-width: 0;\n      max-width: 320px;\n      width: 100%;\n  }\n  \n  .benefits-loot-mention-input-shell {\n      display: flex;\n      align-items: stretch;\n      width: 100%;\n      background: $very-dark-grey;\n      border: 1px solid $medium-grey;\n      border-radius: 6px;\n      overflow: hidden;\n  }\n  \n  .benefits-loot-mention-input-shell.locked {\n      opacity: 0.7;\n  }\n  \n  .benefits-loot-mention-input-shell .benefits-loot-search-icon {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex: 0 0 auto;\n      padding: 0 10px 0 10px;\n      color: $very-light-grey;\n      background: $dark-panel-blue;\n  }\n  \n  .benefits-loot-mention-input-shell:focus-within .benefits-loot-search-icon {\n      color: rgba(255, 255, 255, 0.62);\n  }\n  \n  .benefits-loot-mention-input-shell .benefits-loot-search-icon__svg {\n      display: block;\n      width: 16px;\n      height: 16px;\n  }\n  \n  .benefits-loot-mention-input-shell .benefits-loot-search-input {\n      width: 100%;\n      box-sizing: border-box;\n      flex: 1 1 auto;\n      min-width: 0;\n      background: $light-panel-blue;\n      border: 0;\n      border-radius: 0;\n      padding: 7px 10px 7px 7px;\n      color: $very-light-grey;\n      font-size: 15px;\n      font-weight: 600;\n      text-align: left;\n  }\n  \n  .benefits-loot-mention-input-shell .benefits-loot-search-input:focus {\n      outline: none;\n  }\n  \n  .benefits-loot-search-hint {\n      margin-top: 4px;\n      font-size: 11px;\n      opacity: 0.75;\n  }\n  \n  .benefits-loot-mention-wrap .mention-dropdown {\n      position: absolute;\n      top: 100%;\n      left: 0;\n      right: 0;\n      margin: 4px 0 0 0;\n      padding: 0;\n      list-style: none;\n      background: rgba($very-dark-grey, 0.98);\n      border: 1px solid rgba(255, 255, 255, 0.12);\n      border-radius: 6px;\n      max-height: 220px;\n      overflow-y: auto;\n      z-index: 10050;\n      @include scrollbar-styles();\n  }\n  \n  .benefits-loot-mention-wrap .mention-dropdown .dropdown-item {\n      display: flex;\n      align-items: flex-start;\n      padding: 6px 10px;\n      cursor: pointer;\n      border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  \n      &:last-child {\n          border-bottom: none;\n      }\n  \n      &.selected {\n          background-color: rgba($accent-blue, 0.22);\n      }\n  \n      &:hover {\n          background-color: rgba(255, 255, 255, 0.06);\n      }\n  \n      .mention-name {\n          display: flex;\n          flex-direction: column;\n          align-items: flex-start;\n          gap: 2px;\n          line-height: 1.25;\n          min-width: 0;\n      }\n  \n      .benefits-loot-dd-label {\n          font-size: 13px;\n          color: rgba(255, 255, 255, 0.92);\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n          max-width: 100%;\n      }\n  \n      .benefits-loot-dd-meta {\n          font-size: 11px;\n          color: rgba(255, 255, 255, 0.55);\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n          max-width: 100%;\n      }\n  }\n  \n  .benefits-loot-chips {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 6px;\n      align-items: center;\n      min-width: 0;\n  }\n  \n  .benefits-loot-chip-dnd {\n      display: inline-flex;\n      flex-direction: row;\n      align-items: stretch;\n      min-width: 0;\n      vertical-align: top;\n  }\n  \n  .benefits-loot-chip-dnd__surface {\n      display: inline-flex;\n      flex-direction: row;\n      align-items: stretch;\n      max-width: 100%;\n      min-width: 0;\n      box-sizing: border-box;\n      border: 1px solid $sc-item-accent-secondary;\n      border-radius: 6px;\n      background: $sc-item-bg;\n      overflow: hidden;\n  }\n  \n  .benefits-loot-chip-dnd--overlay {\n      cursor: grabbing;\n  }\n  \n  .benefits-loot-chip-dnd.is-benefits-dragging {\n      opacity: 0;\n  }\n  \n  .benefits-loot-chip-dnd__handle {\n      flex: 0 0 auto;\n      width: 15px;\n      min-width: 20px;\n      margin: 0;\n      padding: 5px;\n      border: 0;\n      border-right: 1px solid rgba(255, 255, 255, 0.1);\n      align-self: stretch;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: grab;\n      color: rgba(255, 255, 255, 0.45);\n      background: linear-gradient(90deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.05) 100%);\n  }\n  \n  .benefits-loot-chip-dnd--overlay .benefits-loot-chip-dnd__handle {\n      cursor: grabbing;\n  }\n  \n  .benefits-loot-chip-dnd__handle::before {\n      content: \"\";\n      display: block;\n      width: 4px;\n      height: 12px;\n      border-left: 1px solid currentColor;\n      border-right: 1px solid currentColor;\n      background: linear-gradient(180deg, currentColor, currentColor) center / 1px 100% no-repeat;\n  }\n  \n  .benefits-loot-chip-dnd__handle:hover,\n  .benefits-loot-chip-dnd__handle:focus-visible {\n      color: rgba(255, 255, 255, 0.75);\n      background: linear-gradient(90deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.05) 100%);\n  }\n  \n  .benefits-loot-chip-dnd__handle:active {\n      cursor: grabbing;\n  }\n  \n  .benefits-loot-chip-dnd__chip {\n      min-width: 0;\n      flex: 1 1 auto;\n      display: flex;\n      align-items: stretch;\n  }\n  \n  .benefits-loot-chip-dnd__chip .sc-item-chip {\n      border: 0;\n      border-radius: 0;\n      background: transparent;\n      max-width: 100%;\n  }\n  \n  .benefits-uec-participant-left {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      min-width: 0;\n      flex: 1 1 auto;\n  }\n  \n  // Participant identity rendering is handled by `UserDiscordRankDisplay`\n  // (see `.user-discord-rank` styles elsewhere).\n  \n  .benefits-uec-participant-share {\n      white-space: nowrap;\n      opacity: 0.95;\n  }\n}\n\n/* Flex slot sizing + expanded overlay footprint (incl. roster card shell parity) */\n.content.calendar-event .objectives-benefits-row > .benefits-block.benefits-block--event-modal-readonly,\n.content.calendar-event.calendar-event-card-main .objectives-benefits-row > .benefits-block.benefits-block--event-modal-readonly,\n.content.calendar-event .calendar-event-benefits-expansion-slot-benefits .benefits-block.benefits-block--event-modal-readonly,\n.content.calendar-event.calendar-event-card-main\n  .calendar-event-benefits-expansion-slot-benefits\n  .benefits-block.benefits-block--event-modal-readonly {\n  flex: 1 1 0;\n  min-width: 0;\n  min-height: 260px;\n}\n\n.content.calendar-event .calendar-event-benefits-expansion-overlay .benefits-block.benefits-block--event-modal-readonly,\n.content.calendar-event.calendar-event-card-main\n  .calendar-event-benefits-expansion-overlay\n  .benefits-block.benefits-block--event-modal-readonly {\n  height: 100%;\n  max-height: 100%;\n  min-height: 0;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.45);\n}\n\n.benefits-loot-move-popover-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 10100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  background: rgba(0, 0, 0, 0.45);\n}\n\n.benefits-loot-move-popover {\n  width: 100%;\n  max-width: 320px;\n  padding: 16px 18px;\n  border-radius: 10px;\n  border: 1px solid rgba($medium-grey, 0.85);\n  background: $very-dark-grey;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.45);\n  color: $very-light-grey;\n}\n\n.benefits-loot-move-popover__title {\n  margin: 0 0 4px;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.benefits-loot-move-popover__target {\n  margin: 0 0 14px;\n  font-size: 12px;\n  opacity: 0.85;\n}\n\n.benefits-loot-move-popover__stepper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.benefits-loot-move-popover__stepper-btn {\n  flex: 0 0 auto;\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  border: 1px solid rgba($medium-grey, 0.9);\n  background: rgba(255, 255, 255, 0.06);\n  color: $pure-white;\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n\n  &:disabled {\n    opacity: 0.35;\n    cursor: not-allowed;\n  }\n\n  &:hover:not(:disabled),\n  &:focus-visible:not(:disabled) {\n    border-color: rgba($accent-blue, 0.75);\n    background: rgba($accent-blue, 0.14);\n  }\n}\n\n.benefits-loot-move-popover__qty-field {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 6px;\n  min-width: 88px;\n  justify-content: center;\n}\n\n.benefits-loot-move-popover__qty-input {\n  width: 4ch;\n  min-width: 3ch;\n  padding: 6px 8px;\n  border-radius: 6px;\n  border: 1px solid rgba($medium-grey, 0.85);\n  background: rgba(0, 0, 0, 0.25);\n  color: $pure-white;\n  font-size: 16px;\n  font-weight: 700;\n  text-align: center;\n}\n\n.benefits-loot-move-popover__qty-max {\n  font-size: 12px;\n  opacity: 0.75;\n}\n\n.benefits-loot-move-popover__shortcuts {\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.benefits-loot-move-popover__shortcut-link {\n  border: 0;\n  padding: 0;\n  background: transparent;\n  color: rgba($accent-blue, 0.95);\n  font-size: 12px;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n  cursor: pointer;\n\n  &:hover,\n  &:focus-visible {\n    color: lighten($accent-blue, 8%);\n  }\n}\n\n.benefits-loot-move-popover__hint {\n  margin: 0 0 14px;\n  font-size: 11px;\n  opacity: 0.65;\n  text-align: center;\n}\n\n.benefits-loot-move-popover__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.benefits-loot-move-popover__btn {\n  min-width: 72px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  border: 1px solid rgba($medium-grey, 0.85);\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.benefits-loot-move-popover__btn--ghost {\n  background: transparent;\n  color: $very-light-grey;\n}\n\n.benefits-loot-move-popover__btn--primary {\n  background: rgba($accent-blue, 0.22);\n  border-color: rgba($accent-blue, 0.65);\n  color: $pure-white;\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n","@import \"../../../../../../styles/variables.scss\";\n\n// Standalone panel styles (also referenced from bigCalendar for flex siblings).\n.event-objectives-view {\n  background-color: $very-dark-grey;\n  border: 1px solid rgba(58, 120, 180, 0.28);\n  border-radius: 8px;\n  padding: 10px;\n  margin-top: 0;\n  box-sizing: border-box;\n\n  .event-objectives-view-header {\n    position: relative;\n    text-transform: uppercase;\n    font-size: 0.85em;\n    opacity: 0.9;\n    margin-bottom: 6px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .objectives-block-expand-toggle {\n    margin-left: auto;\n    flex-shrink: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 22px;\n    height: 22px;\n    padding: 0;\n    margin-right: 0;\n    border-radius: 6px;\n    border: 1px solid rgba(255, 255, 255, 0.18);\n    background: rgba(0, 0, 0, 0.25);\n    cursor: pointer;\n    transition: background 160ms ease, border-color 160ms ease, transform 160ms ease;\n  }\n\n  .objectives-block-expand-toggle:hover {\n    background: rgba(0, 0, 0, 0.38);\n    border-color: $light-grey;\n  }\n\n  .objectives-block-expand-toggle__icon {\n    display: block;\n    width: 14px;\n    height: 14px;\n    object-fit: contain;\n    opacity: 0.95;\n  }\n\n  .event-objectives-view-list {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    padding: 10px 20px 10px 20px;\n    max-height: 220px;\n    overflow: auto;\n    @include scrollbar-styles();\n  }\n\n  &.event-objectives-view--expanded {\n    .event-objectives-view-list {\n      max-height: 400px;\n      overflow: auto;\n    }\n\n    .event-objectives-view-text {\n      white-space: normal;\n      overflow: visible;\n      text-overflow: unset;\n    }\n\n    .event-objectives-view-row {\n      align-items: start;\n    }\n  }\n\n  .event-objectives-view-title-run {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 6px;\n    min-width: 0;\n  }\n\n  .event-objectives-view-title-run .event-objectives-view-text {\n    //flex: 1 1 auto;\n    min-width: 270px;\n  }\n\n  .event-objectives-view-critical-chip {\n    flex-shrink: 0;\n    font-size: 0.56rem;\n    font-weight: 600;\n    letter-spacing: 0.2em;\n    text-transform: uppercase;\n    padding: 4px 10px 2px 10px;\n    margin-left: 2px;\n    border: 1px solid $red;\n    border-radius: 4px;\n    color: $very-light-grey;\n    background: linear-gradient(155deg, $dark-red 0%, $red 45%, $dark-red 100%);\n    line-height: 1.25;\n    user-select: none;\n    box-shadow:\n      0 2px 6px rgba(0, 0, 0, 0.4),\n      0 0 12px rgba($red, 0.28),\n      inset 0 1px 0 rgba(255, 255, 255, 0.1);\n    text-shadow: 0 0 10px rgba($very-light-grey, 0.35);\n  }\n\n  .event-objectives-view-row {\n    display: grid;\n    grid-template-columns: 12px 28px 1fr auto;\n    align-items: center;\n    gap: 5px;\n    padding: 6px 8px;\n    border-radius: 6px;\n    background: rgba(255, 255, 255, 0.03);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n  }\n\n  .event-objectives-view-row.is-upcoming {\n    grid-template-columns: 0px 35px 1fr;\n  }\n\n  .event-objectives-view-row.event-objectives-view-row--with-description-html {\n    align-items: start;\n  }\n\n  // Collapsed: left accent 5px (critical = $red, else transparent — same geometry, no shift)\n  &:not(.event-objectives-view--expanded) .event-objectives-view-row {\n    position: relative;\n    overflow: hidden;\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      left: 0;\n      top: 0;\n      bottom: 0;\n      width: 5px;\n      border-radius: 6px 0 0 6px;\n      background: transparent;\n      pointer-events: none;\n    }\n\n    &.event-objectives-view-row--critical-accent::before {\n      background: $red;\n    }\n  }\n\n  .event-objectives-view-html {\n    grid-column: 1 / -1;\n    padding-left: 45px;\n    font-size: 0.9em;\n    opacity: 0.9;\n    margin-bottom: 10px;\n\n    p {\n      margin: 0;\n    }\n\n    p + p {\n      margin-top: 6px;\n    }\n  }\n\n  .event-objectives-view-dot {\n    width: 10px;\n    height: 10px;\n    border-radius: 999px;\n    border: 2px solid rgba(255, 255, 255, 0.35);\n    background: transparent;\n\n    &.status-unset {\n      border-color: $red;\n      background: transparent;\n    }\n\n    &.status-0 {\n      background: $light-grey;\n      border-color: rgba(255, 255, 255, 0.9);\n    }\n\n    &.status-1 {\n      background: $red;\n      border-color: rgba(255, 255, 255, 0.9);\n    }\n\n    &.status-2 {\n      background: $orange;\n      border-color: rgba(255, 255, 255, 0.9);\n    }\n\n    &.status-3 {\n      background: $green;\n      border-color: rgba(255, 255, 255, 0.9);\n    }\n\n    &.status-upcoming {\n      border-color: rgba(255, 255, 255, 0.35);\n      background: transparent;\n    }\n  }\n\n  .event-objectives-view-text {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .event-objectives-view-number {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    min-height: 1.5rem;\n    padding: 2px 10px;\n    box-sizing: border-box;\n    font-size: 0.75em;\n    font-weight: 600;\n    line-height: 1;\n    letter-spacing: 0.02em;\n    user-select: none;\n    color: $very-light-grey;\n    border: 1px solid $light-panel-blue;\n    border-radius: 5px;\n    background: $dark-panel-blue;\n    opacity: 0.8;\n  }\n\n  .event-objectives-view-critical {\n    width: 5px;\n    text-align: center;\n    user-select: none;\n\n    &.is-critical {\n      color: $red;\n    }\n  }\n\n  .event-objectives-view-status {\n    text-transform: uppercase;\n    font-size: 0.72em;\n    opacity: 0.75;\n    letter-spacing: 0.02em;\n    user-select: none;\n  }\n}\n","@import \"../../../../../../styles/variables.scss\";\n\n// Occurrence report draft row (ReportParticipantsDebrief): blocks never use --in-calendar-event.\n.calendar-event-report.content .objectives-benefits-row > .objectives-report-block:not(.objectives-report-block--in-calendar-event) {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n// Concluded event in calendar modal (EventObjectivesModule + calendarEventModal).\n.content.calendar-event .objectives-benefits-row > .objectives-report-block.objectives-report-block--in-calendar-event {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.report-benefits-expansion-overlay .objectives-report-block:not(.objectives-report-block--in-calendar-event) {\n  height: 100%;\n  max-height: 100%;\n  box-sizing: border-box;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.45);\n}\n\n.report-benefits-expansion-objectives > .objectives-report-block:not(.objectives-report-block--in-calendar-event),\n.report-benefits-expansion-objectives > .report-benefits-expansion-objectives-placeholder {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n// --- Skin A: occurrence report / debrief (edit or expand only here; changing this does not affect calendar modal)\n.objectives-report-block:not(.objectives-report-block--in-calendar-event) {\n  background-color: $very-dark-grey;\n  border: 1px solid $light-grey;\n  border-radius: 8px;\n\n  &.objectives-report-block--readonly {\n    .objective-status-options {\n      pointer-events: none;\n    }\n  }\n\n  &.objectives-report-block--incomplete {\n    border-color: $red;\n  }\n  padding: 10px;\n  margin: 0;\n  height: 260px;\n  display: flex;\n  flex-direction: column;\n\n  .objectives-report-header {\n    margin-bottom: 6px;\n    text-transform: uppercase;\n    font-size: 0.85em;\n    opacity: 0.9;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .objectives-report-list {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow: auto;\n    @include scrollbar-styles();\n  }\n\n  .objectives-report-row {\n    display: grid;\n    grid-template-columns: auto auto minmax(0, 1fr) auto;\n    column-gap: 10px;\n    row-gap: 0;\n    align-items: center;\n    flex-shrink: 0;\n    background: rgba(255, 255, 255, 0.03);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 6px;\n    margin-right: 8px;\n    padding: 6px 0px 6px;\n  }\n\n  .objectives-report-row--with-description-html {\n    align-items: start;\n  }\n\n  .objectives-report-critical {\n    grid-column: 1;\n    grid-row: 1;\n    width: 5px;\n    text-align: center;\n    user-select: none;\n\n    &.is-critical {\n      color: $red;\n    }\n  }\n\n  .objectives-report-number {\n    grid-column: 2;\n    grid-row: 1;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 1.5rem;\n    min-height: 1.5rem;\n    padding: 2px 10px;\n    box-sizing: border-box;\n    font-size: 0.75em;\n    font-weight: 600;\n    line-height: 1;\n    letter-spacing: 0.02em;\n    user-select: none;\n    color: rgba(255, 255, 255, 0.9);\n    border: 1px solid rgba(255, 255, 255, 0.22);\n    border-radius: 5px;\n    background: $light-panel-blue;\n    opacity: 0.8;\n  }\n\n  .objectives-report-title-cell {\n    grid-column: 3;\n    grid-row: 1;\n    min-width: 0;\n  }\n\n  /* Keeps the critical chip flush after the title text (not pushed to the far edge). */\n  .objectives-report-title-run {\n    display: inline-flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 10px;\n    max-width: 100%;\n  }\n\n  .objectives-report-title-run .objectives-report-text {\n    flex: 0 1 auto;\n    min-width: 270px;\n    max-width: 100%;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    line-clamp: 2;\n    text-overflow: ellipsis;\n  }\n\n  .objectives-report-critical-chip {\n    flex-shrink: 0;\n    font-size: 0.56rem;\n    font-weight: 600;\n    letter-spacing: 0.2em;\n    text-transform: uppercase;\n    padding: 4px 10px 2px 10px;\n    margin-left: 2px;\n    border: 1px solid $red;\n    border-radius: 4px;\n    color: $very-light-grey;\n    background: linear-gradient(155deg, $dark-red 0%, $red 45%, $dark-red 100%);\n    line-height: 1.25;\n    user-select: none;\n    box-shadow:\n      0 2px 6px rgba(0, 0, 0, 0.4),\n      0 0 12px rgba($red, 0.28),\n      inset 0 1px 0 rgba(255, 255, 255, 0.1);\n    text-shadow: 0 0 10px rgba($very-light-grey, 0.35);\n  }\n\n  .objectives-report-actions {\n    grid-column: 4;\n    grid-row: 1;\n    display: inline-flex;\n    gap: 6px;\n  }\n\n  &.objectives-report-block--expanded {\n    .objectives-report-row {\n      align-items: start;\n    }\n  }\n\n  .objectives-report-html {\n    grid-column: 3;\n    grid-row: 2;\n    min-width: 0;\n    margin-top: 6px;\n    padding-top: 6px;\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n    white-space: normal;\n    overflow-wrap: anywhere;\n  }\n\n  .objective-status {\n    display: grid;\n    grid-template-rows: 22px 14px;\n    grid-template-columns: 1fr;\n    gap: 4px;\n    align-items: center;\n    justify-items: center;\n    width: 270px;\n    position: relative;\n  }\n\n  .objective-status-track {\n    position: relative;\n    width: 270px;\n    height: 22px;\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      left: calc(100% / 8);\n      right: calc(100% / 8);\n      top: 50%;\n      height: 2px;\n      transform: translateY(-50%);\n      background: rgba(255, 255, 255, 0.18);\n      border-radius: 999px;\n    }\n  }\n\n  .objective-status-dot {\n    position: relative;\n    width: 12px;\n    height: 12px;\n    border-radius: 999px;\n    border: 2px solid rgba(255, 255, 255, 0.35);\n    background: $very-dark-grey;\n    padding: 0;\n    justify-self: center;\n\n    &:hover {\n      border-color: rgba(255, 255, 255, 0.6);\n    }\n\n    &.is-active {\n      border-color: rgba(255, 255, 255, 0.9);\n      background: rgba(255, 255, 255, 0.85);\n    }\n  }\n\n  .objective-status.is-unset {\n    .objective-status-track::before {\n      background: rgba($red, 0.35);\n    }\n\n    .objective-status-dot {\n      border-color: $red;\n      background: transparent;\n    }\n\n    .objective-status-option:hover .objective-status-dot {\n      border-color: rgba($red, 0.9);\n    }\n  }\n\n  .objective-status.is-set {\n    .objective-status-track::before {\n      background: rgba(255, 255, 255, 0.18);\n    }\n\n    .objective-status-dot.is-active {\n      border-color: rgba(255, 255, 255, 0.9);\n    }\n\n    .objective-status-option:nth-child(1) .objective-status-dot.is-active {\n      background: $light-grey;\n    }\n\n    .objective-status-option:nth-child(2) .objective-status-dot.is-active {\n      background: $red;\n    }\n\n    .objective-status-option:nth-child(3) .objective-status-dot.is-active {\n      background: $orange;\n    }\n\n    .objective-status-option:nth-child(4) .objective-status-dot.is-active {\n      background: $green;\n    }\n  }\n\n  .objective-status-options {\n    position: absolute;\n    width: 270px;\n    top: 0;\n    left: 0;\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    grid-template-rows: 22px 14px;\n    gap: 4px;\n  }\n\n  .objective-status-option {\n    display: grid;\n    grid-template-rows: 22px 14px;\n    align-items: center;\n    justify-items: center;\n    background: transparent;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n    min-width: 0;\n\n    &:hover .objective-status-dot {\n      border-color: rgba(255, 255, 255, 0.6);\n    }\n  }\n\n  .objective-status-label {\n    color: $very-light-grey;\n    text-align: center;\n    font-size: 0.72em;\n    text-transform: uppercase;\n    opacity: 0.75;\n    letter-spacing: 0.02em;\n    user-select: none;\n    line-height: 14px;\n  }\n}\n\n// --- Skin B: concluded event in calendar modal (duplicate; tune independently from occurrence report)\n.objectives-report-block.objectives-report-block--in-calendar-event {\n  background-color: $dark-panel-blue;\n  border: 1px solid rgba(58, 120, 180, 0.28);\n  border-radius: 8px;\n\n  &.objectives-report-block--readonly {\n    .objective-status-options {\n      pointer-events: none;\n    }\n  }\n\n  &.objectives-report-block--incomplete {\n    border-color: $red;\n  }\n  padding: 10px;\n  margin: 0;\n  height: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n\n  .objectives-report-header {\n    margin-bottom: 6px;\n    text-transform: uppercase;\n    font-size: 0.85em;\n    opacity: 0.9;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .objectives-report-list {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow: auto;\n    @include scrollbar-styles();\n  }\n\n  .objectives-report-row {\n    display: grid;\n    grid-template-columns: auto auto minmax(0, 1fr) auto;\n    column-gap: 10px;\n    row-gap: 0;\n    align-items: center;\n    flex-shrink: 0;\n    background: rgba(255, 255, 255, 0.03);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 6px;\n    padding: 6px 0px 6px;\n    margin-right: 8px;\n  }\n\n  .objectives-report-row--with-description-html {\n    align-items: start;\n  }\n\n  .objectives-report-critical {\n    grid-column: 1;\n    grid-row: 1;\n    width: 5px;\n    text-align: center;\n    user-select: none;\n\n    &.is-critical {\n      color: $red;\n    }\n  }\n\n  .objectives-report-number {\n    grid-column: 2;\n    grid-row: 1;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 1.5rem;\n    min-height: 1.5rem;\n    padding: 2px 10px;\n    box-sizing: border-box;\n    font-size: 0.75em;\n    font-weight: 600;\n    line-height: 1;\n    letter-spacing: 0.02em;\n    user-select: none;\n    color: rgba(255, 255, 255, 0.9);\n    border: 1px solid rgba(58, 120, 180, 0.45);\n    border-radius: 5px;\n    background: $panel-blue;\n  }\n\n  .objectives-report-title-cell {\n    grid-column: 3;\n    grid-row: 1;\n    min-width: 0;\n  }\n\n  /* Keeps the critical chip flush after the title text (not pushed to the far edge). */\n  .objectives-report-title-run {\n    display: inline-flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 10px;\n    max-width: 100%;\n  }\n\n  .objectives-report-title-run .objectives-report-text {\n    flex: 0 1 auto;\n    min-width: 270px;\n    max-width: 100%;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    line-clamp: 2;\n    text-overflow: ellipsis;\n  }\n\n  .objectives-report-critical-chip {\n    flex-shrink: 0;\n    font-size: 0.56rem;\n    font-weight: 600;\n    letter-spacing: 0.2em;\n    text-transform: uppercase;\n    padding: 4px 10px 2px 10px;\n    margin-left: 2px;\n    border: 1px solid $red;\n    border-radius: 4px;\n    color: $very-light-grey;\n    background: linear-gradient(155deg, $dark-red 0%, $red 45%, $dark-red 100%);\n    line-height: 1.25;\n    user-select: none;\n    box-shadow:\n      0 2px 6px rgba(0, 0, 0, 0.4),\n      0 0 12px rgba($red, 0.28),\n      inset 0 1px 0 rgba(255, 255, 255, 0.1);\n    text-shadow: 0 0 10px rgba($very-light-grey, 0.35);\n  }\n\n  .objectives-report-actions {\n    grid-column: 4;\n    grid-row: 1;\n    display: inline-flex;\n    gap: 6px;\n    align-items: center;\n    justify-content: flex-end;\n    min-width: 0;\n    margin-right: 10px;\n    opacity: 0.8;\n  }\n\n  /* Chips (vue calendrier verrouillée) — mêmes couleurs pleines que `.objective-status-option:nth-child(n) .objective-status-dot.is-active` */\n  .objectives-report-status-chip {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 5px 5px 3px 5px;\n    border-radius: 10px;\n    font-size: 0.68rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    line-height: 1.2;\n    white-space: nowrap;\n    border: 1px solid transparent;\n    box-sizing: border-box;\n    width: 80px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .objectives-report-status-chip--ignored {\n    background: $medium-grey;\n    border-color: $medium-light-grey;\n    color: $light-grey;\n  }\n\n  .objectives-report-status-chip--failed {\n    background: $medium-red;\n    border-color: $bright-red;\n    color: $pure-white;\n  }\n\n  .objectives-report-status-chip--partial {\n    background: $orange;\n    border-color: $very-light-orange;\n    color: $pure-white;\n  }\n\n  .objectives-report-status-chip--success {\n    background: $dark-green;\n    border-color: $light-green;\n    color: $pure-white;\n  }\n\n  .objectives-report-status-chip--unset {\n    background: transparent;\n    border-color: $bright-red;\n    border-style: dashed;\n    color: $very-light-grey;\n  }\n\n  &.objectives-report-block--expanded {\n    .objectives-report-row {\n      align-items: start;\n    }\n  }\n\n  .objectives-report-html {\n    grid-column: 3;\n    grid-row: 2;\n    min-width: 0;\n    margin-top: 6px;\n    padding-top: 6px;\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n    white-space: normal;\n    overflow-wrap: anywhere;\n  }\n\n  /* Track 4 statuts : utilisé si le bloc n’est pas en lecture seule modal calendrier (sinon chips ci-dessus). */\n  .objective-status {\n    display: grid;\n    grid-template-rows: 22px 14px;\n    grid-template-columns: 1fr;\n    gap: 4px;\n    align-items: center;\n    justify-items: center;\n    width: 270px;\n    position: relative;\n  }\n\n  .objective-status-track {\n    position: relative;\n    width: 270px;\n    height: 22px;\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      left: calc(100% / 8);\n      right: calc(100% / 8);\n      top: 50%;\n      height: 2px;\n      transform: translateY(-50%);\n      background: rgba(255, 255, 255, 0.18);\n      border-radius: 999px;\n    }\n  }\n\n  .objective-status-dot {\n    position: relative;\n    width: 12px;\n    height: 12px;\n    border-radius: 999px;\n    border: 2px solid rgba(255, 255, 255, 0.35);\n    background: $very-dark-grey;\n    padding: 0;\n    justify-self: center;\n\n    &:hover {\n      border-color: rgba(255, 255, 255, 0.6);\n    }\n\n    &.is-active {\n      border-color: rgba(255, 255, 255, 0.9);\n      background: rgba(255, 255, 255, 0.85);\n    }\n  }\n\n  .objective-status.is-unset {\n    .objective-status-track::before {\n      background: rgba($red, 0.35);\n    }\n\n    .objective-status-dot {\n      border-color: $red;\n      background: transparent;\n    }\n\n    .objective-status-option:hover .objective-status-dot {\n      border-color: rgba($red, 0.9);\n    }\n  }\n\n  .objective-status.is-set {\n    .objective-status-track::before {\n      background: rgba(255, 255, 255, 0.18);\n    }\n\n    .objective-status-dot.is-active {\n      border-color: rgba(255, 255, 255, 0.9);\n    }\n\n    .objective-status-option:nth-child(1) .objective-status-dot.is-active {\n      background: $light-grey;\n    }\n\n    .objective-status-option:nth-child(2) .objective-status-dot.is-active {\n      background: $red;\n    }\n\n    .objective-status-option:nth-child(3) .objective-status-dot.is-active {\n      background: $orange;\n    }\n\n    .objective-status-option:nth-child(4) .objective-status-dot.is-active {\n      background: $green;\n    }\n  }\n\n  .objective-status-options {\n    position: absolute;\n    width: 270px;\n    top: 0;\n    left: 0;\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    grid-template-rows: 22px 14px;\n    gap: 4px;\n  }\n\n  .objective-status-option {\n    display: grid;\n    grid-template-rows: 22px 14px;\n    align-items: center;\n    justify-items: center;\n    background: transparent;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n    min-width: 0;\n\n    &:hover .objective-status-dot {\n      border-color: rgba(255, 255, 255, 0.6);\n    }\n  }\n\n  .objective-status-label {\n    color: $very-light-grey;\n    text-align: center;\n    font-size: 0.72em;\n    text-transform: uppercase;\n    opacity: 0.75;\n    letter-spacing: 0.02em;\n    user-select: none;\n    line-height: 14px;\n  }\n}\n\n// Collapsed: left accent 5px (critical = $red, else transparent — same geometry, no shift; ::before keeps status row border intact)\n.objectives-report-block:not(.objectives-report-block--expanded) .objectives-report-row {\n  position: relative;\n  overflow: hidden;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 5px;\n    border-radius: 6px 0 0 6px;\n    background: transparent;\n    pointer-events: none;\n  }\n\n  &.objectives-report-row--critical-accent::before {\n    background: $red;\n  }\n}\n\n.objectives-report-block:not(.objectives-report-block--in-calendar-event) .objectives-report-header {\n  position: relative;\n}\n\n.objectives-report-block:not(.objectives-report-block--in-calendar-event) .objectives-block-expand-toggle {\n  position: absolute;\n  top: -5px;\n  right: -2px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  margin: 0;\n  border-radius: 6px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: rgba(0, 0, 0, 0.25);\n  cursor: pointer;\n  transition: background 160ms ease, border-color 160ms ease, transform 160ms ease;\n}\n\n.objectives-report-block:not(.objectives-report-block--in-calendar-event) .objectives-block-expand-toggle:hover {\n  background: rgba(0, 0, 0, 0.38);\n  border-color: $light-grey;\n}\n\n.objectives-report-block:not(.objectives-report-block--in-calendar-event) .objectives-block-expand-toggle__icon {\n  display: block;\n  width: 14px;\n  height: 14px;\n  object-fit: contain;\n  opacity: 0.95;\n}\n\n.objectives-report-block.objectives-report-block--in-calendar-event .objectives-report-header {\n  position: relative;\n}\n\n.objectives-report-block.objectives-report-block--in-calendar-event .objectives-block-expand-toggle {\n  position: absolute;\n  top: -5px;\n  right: -2px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  margin: 0;\n  border-radius: 6px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: rgba(0, 0, 0, 0.25);\n  cursor: pointer;\n  transition: background 160ms ease, border-color 160ms ease, transform 160ms ease;\n}\n\n.objectives-report-block.objectives-report-block--in-calendar-event .objectives-block-expand-toggle:hover {\n  background: rgba(0, 0, 0, 0.38);\n  border-color: $light-grey;\n}\n\n.objectives-report-block.objectives-report-block--in-calendar-event .objectives-block-expand-toggle__icon {\n  display: block;\n  width: 14px;\n  height: 14px;\n  object-fit: contain;\n  opacity: 0.95;\n}\n","@import \"./variables.scss\";\n\n.team-leader-evaluation-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1070;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.25rem;\n  background:\n    radial-gradient(circle at top, rgba($light-blue, 0.12), transparent 42%),\n    rgba($very-dark-grey, 0.82);\n  backdrop-filter: blur(4px);\n}\n\n.team-leader-evaluation-overlay__panel {\n  width: 100%;\n  max-width: 34rem;\n  padding: 1.5rem 1.55rem 1.35rem;\n  border: 1px solid rgba($light-blue, 0.28);\n  border-radius: 0.9rem;\n  background:\n    linear-gradient(180deg, rgba($panel-blue, 0.96) 0%, rgba($dark-panel-blue, 0.98) 100%);\n  box-shadow:\n    0 24px 48px rgba(0, 0, 0, 0.42),\n    inset 0 1px 0 rgba($light-blue, 0.12);\n}\n\n.team-leader-evaluation-overlay__header {\n  margin-bottom: 1.15rem;\n  text-align: center;\n}\n\n.team-leader-evaluation-overlay__title {\n  margin: 0;\n  color: $very-light-grey;\n  font-size: 1.08rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.team-leader-evaluation-overlay__eyebrow {\n  margin: 0.35rem 0 0;\n  color: rgba($light-blue, 0.88);\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.team-leader-evaluation-overlay__leader-card {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 1rem;\n  padding: 0.85rem 1rem;\n  border: 1px solid rgba($light-blue, 0.18);\n  border-radius: 0.65rem;\n  background:\n    linear-gradient(135deg, rgba($very-dark-grey, 0.55), rgba($blue-grey, 0.42));\n  box-shadow: inset 0 1px 0 rgba($light-blue, 0.08);\n}\n\n.team-leader-evaluation-overlay__leader-identity {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.65rem;\n}\n\n.team-leader-evaluation-overlay__leader-rank-icon {\n  width: 2rem;\n  height: 2rem;\n  object-fit: contain;\n  flex-shrink: 0;\n  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.35));\n}\n\n.team-leader-evaluation-overlay__leader-text {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.12rem;\n}\n\n.team-leader-evaluation-overlay__leader-rank-label {\n  color: $very-light-grey;\n  font-size: 0.78rem;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  line-height: 1.2;\n}\n\n.team-leader-evaluation-overlay__leader-name {\n  color: $donor-gold-light;\n  font-size: 0.98rem;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.team-leader-evaluation-overlay__intro {\n  margin: 0 0 0.85rem;\n  color: $light-grey;\n  font-size: 0.88rem;\n  line-height: 1.6;\n  text-align: center;\n\n  &--confirm {\n    margin-bottom: 1rem;\n    padding: 0.9rem 1rem;\n    border: 1px solid rgba($light-blue, 0.18);\n    border-radius: 0.65rem;\n    background: rgba($very-dark-grey, 0.34);\n    text-align: left;\n  }\n}\n\n.team-leader-evaluation-overlay__intro-text {\n  margin: 0;\n\n  & + & {\n    margin-top: 0.65rem;\n  }\n}\n\n.team-leader-evaluation-overlay__privacy-notice {\n  margin-bottom: 1.15rem;\n  padding: 0.72rem 0.85rem;\n  border-left: 3px solid rgba($light-blue, 0.75);\n  border-radius: 0.45rem;\n  background: rgba($very-dark-grey, 0.38);\n  color: rgba($very-light-grey, 0.92);\n  font-size: 0.82rem;\n  line-height: 1.55;\n}\n\n.team-leader-evaluation-overlay__section {\n  margin-bottom: 1rem;\n}\n\n.team-leader-evaluation-overlay__section-label,\n.team-leader-evaluation-overlay__comment-label,\n.team-leader-evaluation-overlay__summary-label {\n  display: block;\n  margin: 0 0 0.5rem;\n  color: rgba($medium-light-grey, 0.95);\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.team-leader-evaluation-stars {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n\n  &--readonly {\n    margin-bottom: 0.35rem;\n  }\n}\n\n.team-leader-evaluation-stars-readonly {\n  margin: 0 0 0.35rem;\n  color: $medium-light-grey;\n  font-size: 0.88rem;\n  font-style: italic;\n  text-align: center;\n\n  &--empty {\n    padding: 0.15rem 0;\n  }\n}\n\n.team-leader-evaluation-stars__star {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 3.35rem;\n  height: 3.35rem;\n  padding: 0;\n  border: none;\n  border-radius: 999px;\n  background: rgba($very-dark-grey, 0.42);\n  color: rgba($medium-light-grey, 0.72);\n  font-size: 2rem;\n  line-height: 1;\n  cursor: pointer;\n  transition:\n    color 0.18s ease,\n    background-color 0.18s ease,\n    transform 0.18s ease,\n    box-shadow 0.18s ease;\n\n  &.is-active,\n  &--filled {\n    background: rgba($donor-gold-dark, 0.22);\n    color: $donor-gold-light;\n    box-shadow:\n      0 0 0 1px rgba($donor-gold, 0.35),\n      0 8px 18px rgba($donor-gold, 0.16);\n  }\n\n  &.is-preview {\n    background: rgba($donor-gold-dark, 0.16);\n    color: rgba($donor-gold-light, 0.92);\n    box-shadow:\n      0 0 0 1px rgba($donor-gold, 0.28),\n      0 6px 14px rgba($donor-gold, 0.12);\n  }\n\n  &--filled {\n    cursor: default;\n  }\n\n  &:not(:disabled):hover {\n    transform: translateY(-2px) scale(1.03);\n    color: rgba($donor-gold-light, 0.88);\n  }\n\n  &:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n  }\n}\n\n.team-leader-evaluation-overlay__comment-input {\n  width: stretch;\n  min-height: 6rem;\n  padding: 0.72rem 0.82rem;\n  border: 1px solid rgba($light-blue, 0.22);\n  border-radius: 0.55rem;\n  background: rgba($very-dark-grey, 0.58);\n  color: $very-light-grey;\n  font: inherit;\n  line-height: 1.5;\n  resize: vertical;\n  transition:\n    border-color 0.18s ease,\n    box-shadow 0.18s ease,\n    background-color 0.18s ease;\n\n  &::placeholder {\n    color: rgba($medium-light-grey, 0.82);\n  }\n\n  &:focus {\n    outline: none;\n    border-color: rgba($light-blue, 0.55);\n    background: rgba($very-dark-grey, 0.72);\n    box-shadow: 0 0 0 3px rgba($light-blue, 0.12);\n  }\n}\n\n.team-leader-evaluation-overlay__summary {\n  margin-bottom: 1rem;\n  padding: 1rem 1.05rem;\n  border: 1px solid rgba($light-blue, 0.18);\n  border-radius: 0.65rem;\n  background: rgba($very-dark-grey, 0.38);\n}\n\n.team-leader-evaluation-overlay__summary-rating {\n  margin: 0 0 0.95rem;\n  color: $donor-gold-light;\n  font-size: 0.84rem;\n  font-weight: 600;\n  text-align: center;\n}\n\n.team-leader-evaluation-overlay__summary-comment {\n  margin: 0;\n  padding: 0.72rem 0.8rem;\n  border-radius: 0.45rem;\n  background: rgba($very-dark-grey, 0.45);\n  color: $very-light-grey;\n  font-size: 0.86rem;\n  line-height: 1.55;\n  white-space: pre-wrap;\n  word-break: break-word;\n\n  &--empty {\n    background: transparent;\n    color: $medium-light-grey;\n    font-style: italic;\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n\n.team-leader-evaluation-overlay__error {\n  margin: 0 0 0.75rem;\n  padding: 0.55rem 0.7rem;\n  border-radius: 0.45rem;\n  background: rgba($bright-red, 0.12);\n  color: lighten($bright-red, 8%);\n  font-size: 0.82rem;\n  text-align: center;\n}\n\n.team-leader-evaluation-overlay__footer {\n  display: flex;\n  gap: 0.75rem;\n  margin-top: 0.35rem;\n\n  &--center {\n    justify-content: center;\n  }\n\n  &--confirm {\n    justify-content: space-between;\n  }\n}\n\n.team-leader-evaluation-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 8rem;\n  padding: 0.72rem 1.25rem;\n  border: 1px solid transparent;\n  border-radius: 999px;\n  font-size: 0.76rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition:\n    transform 0.18s ease,\n    box-shadow 0.18s ease,\n    border-color 0.18s ease,\n    background 0.18s ease,\n    opacity 0.18s ease;\n\n  &:not(:disabled):active {\n    transform: translateY(1px);\n  }\n\n  &:disabled {\n    opacity: 1;\n    cursor: not-allowed;\n  }\n\n  &--primary:not(:disabled) {\n    border-color: rgba($light-blue, 0.55);\n    color: $pure-white;\n    background: linear-gradient(\n      135deg,\n      lighten($accent-blue, 10%) 0%,\n      $accent-blue 52%,\n      darken($blue, 2%) 100%\n    );\n    box-shadow: 0 10px 24px rgba($blue, 0.28);\n\n    &:hover {\n      box-shadow: 0 14px 28px rgba($blue, 0.36);\n    }\n  }\n\n  &--primary:disabled {\n    border-color: rgba($medium-light-grey, 0.22);\n    color: rgba($medium-light-grey, 0.88);\n    background: rgba($very-dark-grey, 0.72);\n    box-shadow: none;\n  }\n\n  &--secondary:not(:disabled) {\n    border-color: rgba($medium-light-grey, 0.28);\n    color: $very-light-grey;\n    background: rgba($very-dark-grey, 0.55);\n\n    &:hover {\n      border-color: rgba($light-blue, 0.42);\n      background: rgba($dark-blue-grey, 0.88);\n    }\n  }\n}\n","// src/styles/personalHangar.scss\n\n@import './variables.scss';\n\n$overlay: linear-gradient(180deg, rgba($dark-blue, 0.72), rgba($dark-blue-grey, 0.42)),\nrgba($dark-blue, 0.55);\n$package: #21374fe0;\n\n.hangar-page {\n  padding: 24px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 100px);\n  max-height: calc(100vh - 100px);\n  overflow: hidden;\n}\n\n.hangar-page--personal-hub {\n  flex: 1 1 auto;\n  min-height: 0;\n  height: 100%;\n  max-height: 100%;\n  padding: 12px 16px 0 0;\n  overflow: hidden;\n}\n\n/* ---------------- filters ---------------- */\n\n\n.hangar-filters {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding: 0.35rem 0.5rem;\n  margin-top: 0;\n  margin-bottom: 0;\n  border-radius: 8px;\n  box-sizing: border-box;\n  width: 100%;\n\n  .filter-container {\n    .user-filter {\n      .input {\n        width: 100%;\n      }\n    }\n  }\n\n  .hangar-toggles {\n    display: flex;\n    gap: 12px;\n    flex-wrap: wrap;\n\n    .toggle {\n      position: relative;\n      display: flex;\n      align-items: center;\n      width: max-content;\n      padding-left: 45px;\n      min-height: 26px;\n      cursor: pointer;\n\n      input {\n        display: none;\n      }\n\n      .toggle-switch {\n        position: absolute;\n        left: 0;\n        top: 50%;\n        transform: translateY(-50%);\n      }\n\n      .toggle-label {\n        font-size: 14px;\n        color: $light-grey;\n        white-space: nowrap;\n        line-height: 1;\n      }\n    }\n  }\n}\n\n.hangar-filters--horizontal {\n  flex-shrink: 0;\n  z-index: 1;\n  isolation: isolate;\n  background-color: $dark-panel-blue;\n  background:\n    linear-gradient(180deg, rgba($dark-blue, 0.72), rgba($dark-blue-grey, 0.42)),\n    rgba($dark-blue, 0.55);\n  border: 1px solid rgba($accent-blue, 0.55);\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.35),\n    0 12px 28px rgba(0, 0, 0, 0.35);\n\n  .hangar-filters__top {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 0.85rem 1.25rem;\n    margin-top: 5px;\n    //width: 100%;\n  }\n\n  &.hangar-filters--with-help {\n    position: relative;\n    padding-right: 2.25rem;\n    padding-left: 1.1rem;\n    overflow: visible;\n    z-index: 1;\n    isolation: auto;\n  }\n\n  .hangar-filters__help-anchor {\n    position: absolute;\n    top: 0.5rem;\n    right: 0.5rem;\n    z-index: 11;\n  }\n\n  .hangar-filters__help-anchor .accounting-help-trigger {\n    position: static;\n  }\n\n  .hangar-filters__help-popover {\n    top: 1.75rem;\n    right: 0;\n    z-index: 12;\n  }\n  .hangar-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex: 0 0 auto;\n  }\n\n  .hangar-filters__handles {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    gap: 0.5rem;\n    margin: 0;\n  }\n\n  .hangar-filters__handle-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 26px;\n    height: 26px;\n    padding: 0;\n    margin: 0;\n    border: 2px solid rgba($accent-blue, 0.35);\n    border-radius: 50%;\n    background: rgba($dark-blue-grey, 0.95);\n    cursor: pointer;\n    overflow: hidden;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n    transition:\n      border-color 0.15s ease,\n      box-shadow 0.15s ease;\n\n    &:hover {\n      border-color: rgba($light-blue, 0.65);\n    }\n\n    &:focus-visible {\n      outline: 2px solid rgba($accent-blue, 0.75);\n      outline-offset: 2px;\n    }\n  }\n\n  .hangar-filters__handle-btn--active {\n    border-color: $light-orange;\n    box-shadow:\n      0 0 0 1px rgba($light-orange, 0.45),\n      0 4px 12px rgba(0, 0, 0, 0.4);\n  }\n\n  .hangar-filters__handle-btn--master.hangar-filters__handle-btn--active {\n    border-color: $light-orange;\n  }\n\n  .hangar-filters__handle-avatar {\n    width: 100%;\n    height: 100%;\n    display: block;\n    object-fit: cover;\n    border-radius: 50%;\n  }\n\n\n  .hangar-filters__toolbar {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    gap: 1rem 1.5rem;\n    width: 100%;\n  }\n\n  .hangar-filters__group {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    flex: 0 1 auto;\n    min-width: 0;\n  }\n\n  .hangar-filters__group--ingame {\n    position: relative;\n    flex: 0 0 220px;\n    margin-left: auto;\n    min-width: 200px;\n    align-items: stretch;\n    bottom: 10px;\n  }\n\n  .hangar-filters__pill-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    align-items: center;\n  }\n\n  .hangar-filters__group--bulk {\n    position: relative;\n    flex: 0 0 auto;\n    align-self: center;\n    justify-content: center;\n    flex-direction: column;\n    gap: 8px;\n    padding-top: 0.15rem;\n    bottom: 8px;\n  }\n\n  .hangar-filters__bulk-toggle,\n  .hangar-filters__view-toggle {\n    display: inline-flex;\n    flex-shrink: 0;\n    border-radius: 10px;\n    overflow: hidden;\n    border: 1px solid $medium-light-grey;\n    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);\n    background: $dark-grey;\n  }\n\n  .hangar-filters__bulk-toggle-btn {\n    min-width: 52px;\n    padding: 6px 14px;\n    margin: 0;\n    border: none;\n    background: transparent;\n    color: $light-grey;\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    cursor: pointer;\n    transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;\n\n    &:not(:last-child) {\n      border-right: 1px solid $medium-grey;\n    }\n\n    &:disabled {\n      opacity: 0.42;\n      cursor: not-allowed;\n    }\n\n    &:not(:disabled):not(.hangar-filters__bulk-toggle-btn--active):hover {\n      background: $medium-grey;\n      color: $very-light-grey;\n    }\n\n    &--active {\n      @include steel-bg-transparent(\"../medias/steel.png\", $blue, $dark-blue);\n      color: $very-light-grey;\n      box-shadow: inset 0 0 0 1px $blue;\n    }\n  }\n}\n\n.hangar-header-title {\n  font-size: 1.1rem;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: $very-light-grey;\n  white-space: nowrap;\n  margin: 0;\n}\n\n.hangar-header-lines {\n  position: relative;\n  width: 20px;\n  height: 27px;\n  flex-shrink: 0;\n}\n\n.hangar-header-lines span {\n  position: absolute;\n  width: 22px;\n  height: 3px;\n  background: $light-orange;\n  transform: rotate(-65deg);\n  transform-origin: left center;\n}\n\n.hangar-header-lines span:first-child {\n  top: 20px;\n  left: 12px;\n}\n\n.hangar-header-lines span:last-child {\n  top: 20px;\n}\n\n.hangar-handle-switch {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 0px;\n  margin-top: -20px;\n}\n\n.hangar-handle-switch .handle-btn {\n  width: 100%;\n  padding: 6px 10px;\n  background: $dark-blue-grey;\n  border: 1px solid #2b2b2b;\n  border-radius: 8px;\n  color: $medium-light-grey;\n  font-weight: 600;\n  letter-spacing: .5px;\n  text-align: left;\n  cursor: pointer;\n  transition: background .15s ease, border-color .15s ease, color .15s ease;\n  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);\n}\n\n.hangar-handle-switch .handle-btn:hover {\n  background: #1d1d1d;\n  border-color: #3a3a3a;\n  color: $very-light-grey;\n}\n\n.hangar-handle-switch .handle-btn.active {\n  background: linear-gradient(90deg, #2f1b00, #5c3200);\n  border-color: #c27a17;\n  color: #ffd28a;\n  box-shadow: inset 0 0 0 1px rgba(255,210,138,.35);\n}\n\n.hangar-handle-switch .handle-btn.active::before {\n  content: \"▶\";\n  margin-right: 8px;\n  color: #ffd28a;\n  font-size: 11px;\n}\n\n\n// Legacy column pill stacks (unused by horizontal toolbar; kept for compatibility)\n.hangar-filter-pills {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.filter-pill {\n  padding: 6px 12px;\n  font-size: 13px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);\n  border: 1px solid transparent;\n  color: $very-light-grey;\n\n  &.ships, \n  &.sizes, \n  &.items, \n  &.item-types,\n  &.lawful,\n  &.members-panel {\n    padding: 6px 12px;\n    font-size: 13px;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);\n\n    &.active {\n      @include steel-bg-transparent(\"../medias/steel.png\", $blue, $dark-blue);\n      border: 1px solid $blue;\n      color: $very-light-grey;\n    }\n\n    &.inactive {\n      @include steel-bg-transparent(\"../medias/steel.png\", $grey, $dark-grey );\n      border: 1px solid $medium-light-grey;\n      color: $light-grey;\n    }\n\n    &.locked,\n    &:disabled {\n      opacity: 0.42;\n      cursor: not-allowed;\n      box-shadow: none;\n    }\n\n    &.locked:hover,\n    &:disabled:hover {\n      border-color: $medium-light-grey;\n    }\n\n    &:hover:not(:disabled):not(.locked) {\n      border: 1px solid $light-blue\n    }\n  }\n}\n\n/* ---------- INGAME REACT-SELECT ---------- */\n\n.ingame-select {\n  font-size: 13px;\n}\n\n/* Input */\n.ingame-select__control {\n  background-color: $very-light-grey !important;\n  border: 1px solid #2c6d91;\n  min-height: 34px;\n  font-size: 13px;\n  box-shadow: none;\n}\n\n.ingame-select__control--is-focused {\n  border-color: #3b7fa6;\n  box-shadow: none;\n}\n\n/* Value & placeholder */\n.ingame-select__single-value,\n.ingame-select__placeholder,\n.ingame-select__input-container {\n  color: #cdefff;\n  font-size: 13px;\n}\n\n/* Dropdown */\n.ingame-select__menu {\n  background: #05141b;\n  border: 1px solid #2c6d91;\n  font-size: 13px;\n  z-index: 200;\n}\n\n/* Options */\n.ingame-select__option {\n  background: transparent;\n  color: #cdefff;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.ingame-select__option--is-focused {\n  background: #0f2f3f;\n}\n\n.ingame-select__option--is-selected {\n  background: #1b5874;\n}\n\n/* Dropdown arrow */\n.ingame-select__indicator {\n  color: #7fb6d6;\n}\n\n.ingame-select__indicator:hover {\n  color: #cdefff;\n}\n\n.ingame-select-block {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  width: 100%;\n}\n\n/* Validate button */\n.ingame-validate-btn {\n  //margin-top: 8px;\n  width: 100%;\n  padding: 6px;\n  font-size: 13px;\n  background: #0d3c54;\n  border: 1px solid #2c6d91;\n  color: #cdefff;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.ingame-validate-btn:hover {\n  background: #15546f;\n  border-color: #3b7fa6;\n}\n\n.ingame-validate-btn:disabled {\n  opacity: .4;\n  cursor: not-allowed;\n}\n\n\n/* ---------------- content ---------------- */\n\n.hangar-layout {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  align-items: stretch;\n  width: 100%;\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.hangar-content {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  margin-left: 0;\n  width: 100%;\n  min-width: 0;\n  min-height: 0;\n  flex: 1 1 auto;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding: 1rem 0 1.5rem;\n  position: relative;\n  z-index: 0;\n  scrollbar-width: none;\n}\n\n/* English comment: empty state — wide horizontal call-to-action */\n.hangar-empty-card {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  align-self: center;\n  width: 100%;\n  max-width: 920px;\n  min-height: 112px;\n  margin-top: 18px;\n  border-radius: 10px;\n  overflow: hidden;\n  border: 1px solid rgba(58, 120, 180, 0.28);\n  box-shadow:\n    0 8px 28px rgba(0, 0, 0, 0.22),\n    inset 0 1px 0 rgba(255, 255, 255, 0.04);\n  backdrop-filter: blur(8px) saturate(120%);\n  -webkit-backdrop-filter: blur(8px) saturate(120%);\n  background: linear-gradient(\n    105deg,\n    rgba(30, 52, 72, 0.72) 0%,\n    rgba(22, 40, 58, 0.55) 45%,\n    rgba(18, 35, 52, 0.65) 100%\n  );\n}\n\n.hangar-empty-card__accent {\n  flex: 0 0 5px;\n  background: linear-gradient(\n    180deg,\n    $accent-blue 0%,\n    $blue 42%,\n    $dark-blue 100%\n  );\n  box-shadow: 2px 0 12px rgba(58, 120, 180, 0.25);\n}\n\n.hangar-empty-card__body {\n  flex: 1;\n  padding: 22px 26px 22px 22px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 10px;\n}\n\n.hangar-empty-card__title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  color: $very-light-grey;\n}\n\n.hangar-empty-card__text {\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.55;\n  color: $light-grey;\n  max-width: 52em;\n}\n\n.hangar-empty-card__note {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n  color: $medium-light-grey;\n  max-width: 52em;\n}\n\n.hangar-empty-card__link {\n  color: $accent-blue;\n  text-decoration: none;\n  font-weight: 600;\n  border-bottom: 1px solid rgba(58, 120, 180, 0.35);\n  transition: color 0.15s ease, border-color 0.15s ease;\n\n  &:hover {\n    color: $light-blue;\n    border-bottom-color: rgba(0, 117, 185, 0.55);\n  }\n\n  &:focus-visible {\n    outline: 2px solid $accent-blue;\n    outline-offset: 2px;\n    border-bottom-color: transparent;\n  }\n}\n\n.hangar-empty-card__actions {\n  margin-top: 4px;\n}\n\n.hangar-empty-card__cta {\n  display: inline-flex;\n  align-items: center;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  text-decoration: none;\n  color: $very-light-grey;\n  background: rgba(58, 120, 180, 0.22);\n  border: 1px solid rgba(58, 120, 180, 0.45);\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n\n  &:hover {\n    color: $pure-white;\n    background: rgba(58, 120, 180, 0.35);\n    border-color: rgba(0, 117, 185, 0.55);\n  }\n\n  &:focus-visible {\n    outline: 2px solid $accent-blue;\n    outline-offset: 2px;\n  }\n}\n\n.vehicle-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 16px;\n}\n\n.vehicle-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.vehicle-list-row {\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);\n  backdrop-filter: blur(6px) saturate(33%);\n  -webkit-backdrop-filter: blur(4px) saturate(33%);\n  background-color: #23497748;\n  border: 1px solid rgba(51, 102, 126, 0.329);\n  transition: border-color 0.15s ease;\n\n  &:hover,\n  &--expanded {\n    border-color: $blue;\n  }\n\n  &.loaner {\n    border-left: 4px solid $orange;\n  }\n}\n\n.vehicle-list-row__header {\n  display: grid;\n  grid-template-columns: 64px minmax(120px, 1.4fr) minmax(100px, 1.2fr) minmax(90px, 1fr) auto max-content;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 8px 12px;\n  border: 0;\n  background: $overlay;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.vehicle-list-row__thumb {\n  width: 64px;\n  height: 40px;\n  border-radius: 6px;\n  overflow: hidden;\n  flex-shrink: 0;\n  background: rgba($dark-blue-grey, 0.45);\n  border: 1px solid rgba(51, 102, 126, 0.45);\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n    pointer-events: none;\n  }\n}\n\n.vehicle-list-row__thumb-placeholder {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.vehicle-list-row__title {\n  margin: 0;\n  min-width: 0;\n\n  .loaner-source {\n    font-size: 12px;\n    color: $light-grey;\n    margin-top: 2px;\n  }\n}\n\n.vehicle-list-row__label {\n  min-width: 0;\n\n  .ship-label-row {\n    display: flex;\n    align-items: center;\n    min-height: 18px;\n  }\n\n  .ship-label-trigger,\n  .ship-label-editor {\n    display: inline-flex;\n    align-items: center;\n    gap: 0;\n    padding: 0;\n    margin: 0;\n    border: 0;\n    background: transparent;\n    font: inherit;\n    text-align: left;\n    max-width: 100%;\n  }\n\n  .ship-label-trigger--editable {\n    cursor: pointer;\n  }\n\n  .ship-label-trigger--readonly {\n    cursor: default;\n    pointer-events: none;\n  }\n\n  .ship-label-text {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 100%;\n    line-height: 1.2;\n    text-transform: uppercase;\n    font-size: 14px;\n  }\n\n  .ship-label-text--placeholder {\n    color: $medium-light-grey;\n    text-transform: none;\n  }\n\n  .ship-label-row--rsi {\n    .ship-label-trigger,\n    .ship-label-editor,\n    .ship-label-text,\n    .ship-label-input {\n      color: $light-blue;\n    }\n\n    .ship-label-icon {\n      background-color: $light-blue;\n    }\n  }\n\n  .ship-label-row--user {\n    .ship-label-trigger,\n    .ship-label-editor,\n    .ship-label-text,\n    .ship-label-input {\n      color: $very-light-grey;\n    }\n\n    .ship-label-icon {\n      background-color: $very-light-grey;\n    }\n  }\n\n  .ship-label-row--empty {\n    .ship-label-trigger,\n    .ship-label-editor,\n    .ship-label-text,\n    .ship-label-input {\n      color: $medium-light-grey;\n    }\n\n    .ship-label-icon {\n      background-color: $medium-light-grey;\n    }\n  }\n\n  .ship-label-icon {\n    position: relative;\n    display: inline-block;\n    flex: 0 0 12px;\n    width: 12px;\n    height: 12px;\n    margin-right: 7px;\n    top: 1px;\n    background-color: $medium-light-grey;\n    mask: url('../medias/icon-label.svg') no-repeat center / contain;\n    -webkit-mask: url('../medias/icon-label.svg') no-repeat center / contain;\n  }\n\n  .ship-label-input {\n    width: 120px;\n    max-width: 100%;\n    padding: 0 4px;\n    border: 1px solid currentColor;\n    border-radius: 4px;\n    background: rgba($dark-blue-grey, 0.35);\n    font-size: 13px;\n    line-height: 1.2;\n    text-transform: uppercase;\n\n    &:focus {\n      outline: none;\n      border-color: $light-orange;\n    }\n\n    &--error {\n      border-color: $red;\n    }\n  }\n\n  .ship-label-error {\n    flex: 1 1 100%;\n    margin-top: 4px;\n    font-size: 12px;\n    line-height: 1.2;\n    color: $red;\n    text-transform: none;\n  }\n}\n\n.vehicle-list-row__label-empty {\n  color: $medium-light-grey;\n  font-size: 14px;\n}\n\n.vehicle-list-row__manufacturer {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.vehicle-list-row__prod {\n  width: max-content;\n  max-width: 100%;\n  justify-self: end;\n\n  .prod-state {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: max-content;\n    min-width: unset;\n    max-width: none;\n    padding: 4px 10px;\n    border: 1px solid rgba(51, 102, 126, 0.55);\n    border-radius: 999px;\n    font-size: 11px;\n    font-weight: 600;\n    line-height: 1.2;\n    letter-spacing: 0.03em;\n    text-align: center;\n    text-transform: uppercase;\n    background: rgba($dark-blue-grey, 0.45);\n    color: $very-light-grey;\n\n    &.flight-ready {\n      background: $darker-green;\n      border-color: $green;\n      color: $very-light-green;\n      padding: 4px 10px;\n    }\n\n    &.in-concept {\n      background: $dark-orange;\n      border-color: $orange;\n      color: $very-light-orange;\n      padding: 4px 10px;\n    }\n\n    &.in-production {\n      background: rgba($accent-blue, 0.22);\n      border-color: $light-blue;\n      color: $light-blue;\n    }\n  }\n}\n\n.vehicle-list-row__actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.vehicle-list-row__remove-slot {\n  flex: 0 0 54px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.vehicle-list-row__remove-placeholder {\n  display: block;\n  width: 54px;\n  height: 20px;\n}\n\n.vehicle-list-row__chevron {\n  width: 10px;\n  height: 10px;\n  border-right: 2px solid $light-grey;\n  border-bottom: 2px solid $light-grey;\n  transform: rotate(45deg);\n  transition: transform 0.2s ease;\n  margin-right: 4px;\n}\n\n.vehicle-list-row--expanded .vehicle-list-row__chevron {\n  transform: rotate(-135deg);\n  margin-top: 4px;\n}\n\n.vehicle-list-row__accordion {\n  padding: 8px 12px 10px;\n  background: rgba($dark-blue-grey, 0.35);\n  border-top: 1px solid rgba(51, 102, 126, 0.35);\n}\n\n.vehicle-overlay-panel--compact {\n  .overlay-content {\n    display: grid;\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n    grid-template-rows: auto auto;\n    gap: 6px 14px;\n    width: 100%;\n  }\n\n  .overlay-left,\n  .overlay-right {\n    display: contents;\n    padding: 0;\n  }\n\n  .spec-line {\n    gap: 4px;\n    min-width: 0;\n  }\n\n  .spec-label {\n    font-size: 11px;\n  }\n\n  .spec-value {\n    font-size: 12px;\n    text-align: left;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .vehicle-overlay-panel__extras {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n    margin-top: 8px;\n  }\n\n  .vehicle-skins {\n    position: static;\n    top: auto;\n    padding: 0;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n  }\n\n  .vehicle-insurances {\n    margin: 0;\n    padding: 2px 8px;\n    font-size: 12px;\n  }\n\n  .vehicle-rsi-link {\n    margin-top: 8px;\n    border-radius: 6px;\n  }\n}\n\n.package-card .vehicle-list {\n  margin-bottom: 16px;\n}\n\n/* ---------------- vehicle card ---------------- */\n\n.standalone-section  {\n  border-radius: 8px;\n  padding: 16px 10px 8px 10px;\n  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);\n\n  backdrop-filter: blur(6px) saturate(33%);\n  -webkit-backdrop-filter: blur(4px) saturate(33%);\n  background-color: $package;\n  border: 1px solid rgba(51, 102, 126, 0.329);\n\n  .standalone-title {\n    margin: 0 0 12px 0;\n    font-size: 16px;\n    font-weight: 600;\n    color: $very-light-grey;\n  }\n}\n\n.vehicle-card {\n  position: relative;\n  height: 290px;\n  overflow: hidden;\n  border-radius: 8px;\n  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);\n\n  backdrop-filter: blur(6px) saturate(33%);\n  -webkit-backdrop-filter: blur(4px) saturate(33%);\n  background-color: #23497748;\n  border: 1px solid rgba(51, 102, 126, 0.329);\n\n  &:hover {\n    border: 1px solid $blue;\n  }\n}\n\n/* English comment: background image */\n.vehicle-bg {\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n}\n\n.vehicle-bg-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  transition: transform 0.4s ease;\n  pointer-events: none;\n}\n\n/* English comment: default visible content */\n.vehicle-front {\n  position: relative;\n  z-index: 1;\n  padding: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n\n\n/* ---------------- text tweaks ---------------- */\n\n.vehicle-header {\n  display: flex;\n  position: relative;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.vehicle-title {\n  margin: 0 0 6px 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: $very-light-grey;\n\n  .custom-name, .loaner-source, .ship-label-row {\n    font-size: 14px;\n    height: 0px;\n    padding: 5px 0px 0px 0px;\n  }\n\n  .loaner-source {\n    color: $light-grey;\n  }\n\n  .ship-label-row {\n    display: flex;\n    align-items: center;\n    min-height: 18px;\n    height: auto;\n  }\n\n  .ship-label-trigger,\n  .ship-label-editor {\n    display: inline-flex;\n    align-items: center;\n    gap: 0;\n    padding: 0;\n    margin: 0;\n    border: 0;\n    background: transparent;\n    font: inherit;\n    text-align: left;\n  }\n\n  .ship-label-trigger--editable {\n    cursor: pointer;\n  }\n\n  .ship-label-trigger--readonly {\n    cursor: default;\n    pointer-events: none;\n  }\n\n  .ship-label-text {\n    line-height: 1.2;\n    text-transform: uppercase;\n  }\n\n  .ship-label-text--placeholder {\n    color: $medium-light-grey;\n    text-transform: none;\n  }\n\n  .ship-label-row--rsi {\n    .ship-label-trigger,\n    .ship-label-editor,\n    .ship-label-text,\n    .ship-label-input {\n      color: $light-blue;\n    }\n\n    .ship-label-icon {\n      background-color: $light-blue;\n    }\n  }\n\n  .ship-label-row--user {\n    .ship-label-trigger,\n    .ship-label-editor,\n    .ship-label-text,\n    .ship-label-input {\n      color: $very-light-grey;\n    }\n\n    .ship-label-icon {\n      background-color: $very-light-grey;\n    }\n  }\n\n  .ship-label-row--empty {\n    .ship-label-trigger,\n    .ship-label-editor,\n    .ship-label-text,\n    .ship-label-input {\n      color: $medium-light-grey;\n    }\n\n    .ship-label-icon {\n      background-color: $medium-light-grey;\n    }\n  }\n\n  .ship-label-icon {\n    position: relative;\n    display: inline-block;\n    flex: 0 0 12px;\n    width: 12px;\n    height: 12px;\n    margin-right: 7px;\n    top: 1px;\n    background-color: $medium-light-grey;\n    mask: url('../medias/icon-label.svg') no-repeat center / contain;\n    -webkit-mask: url('../medias/icon-label.svg') no-repeat center / contain;\n  }\n\n  .ship-label-editor {\n    position: relative;\n    flex-wrap: wrap;\n  }\n\n  .ship-label-error {\n    flex: 1 1 100%;\n    margin-top: 4px;\n    font-size: 12px;\n    line-height: 1.2;\n    color: $red;\n    text-transform: none;\n  }\n\n  .ship-label-input {\n    width: 140px;\n    max-width: 100%;\n    padding: 0 4px;\n    border: 1px solid currentColor;\n    border-radius: 4px;\n    background: rgba($dark-blue-grey, 0.35);\n    font-size: 14px;\n    line-height: 1.2;\n    text-transform: uppercase;\n\n    &::placeholder {\n      color: $medium-light-grey;\n      opacity: 1;\n      text-transform: none;\n    }\n\n    &:focus {\n      outline: none;\n      border-color: $light-orange;\n    }\n\n    &--error {\n      border-color: $red;\n    }\n  }\n}\n\n.vehicle-header-right {\n  position: absolute;\n  top: 15px;\n  right: 10px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.manual-remove-btn {\n  position: relative;\n  flex-shrink: 0;\n  text-transform: uppercase;\n  color: $very-light-grey;\n  font-size: 10px;\n  border: 1px solid $medium-red;\n  border-radius: 6px;\n  bottom: 1px;\n  @include steel-bg-transparent(\"../medias/steel.png\", $medium-red, $dark-red);\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    border: 1px solid $bright-red;\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.vehicle-manufacturer {\n  font-size: 14px;\n  color: $light-grey;\n  opacity: 0.85;\n  pointer-events: none;\n}\n\n.vehicle-meta {\n  display: flex;\n  //margin-top: 4px;\n}\n\n.focus {\n  font-size: 13px;\n  font-weight: bold;\n  padding: 3px 0px;\n  color: $very-light-grey;\n}\n\n.size {\n  font-size: 13px;\n  font-weight: bold;\n  padding: 3px 0px;\n  color: $very-light-grey;\n}\n/* ---------------- package card ---------------- */\n\n.package-card {\n\n  border-radius: 8px;\n  padding: 16px 10px 8px 10px;\n  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);\n\n  backdrop-filter: blur(6px) saturate(33%);\n  -webkit-backdrop-filter: blur(4px) saturate(33%);\n  background-color: $package;\n  border: 1px solid rgba(51, 102, 126, 0.329);\n  border-left: 6px solid $blue;\n}\n\n.package-title {\n  margin: 0 0 12px 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: $very-light-grey;\n}\n\n.package-vehicles {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  margin-bottom: 16px;\n  gap: 16px;\n}\n\n.package-items {\n  margin-top: 12px;\n\n  h4 {\n    margin: 0 0 6px 0;\n    font-size: 14px;\n    color: $light-grey;\n  }\n\n  ul {\n    margin: 0;\n    padding-left: 18px;\n\n    li {\n      font-size: 13px;\n      color: $light-grey;\n      line-height: 1.4;\n    }\n  }\n}\n\n/* ---------------- Loaners card ---------------- */\n\n.loaner-section  {\n  border: 1px solid rgba(51, 102, 126, 0.329);\n  border-left: 5px solid $orange;\n  border-radius: 8px;\n  padding: 16px 10px 8px 10px;\n  background-color: $package;\n  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);\n  backdrop-filter: blur(6px) saturate(33%);\n  -webkit-backdrop-filter: blur(4px) saturate(33%);\n\n    .standalone-title {\n      margin: 0 0 12px 0;\n      font-size: 20px;\n      font-weight: 600;\n      color: $very-light-grey;\n    }\n}\n\n/* ---------------- misc ---------------- */\n\n.no-permission,\n.error {\n  color: #ff5f5f;\n}\n\n.shaped-header {\n  // background: #0f2c3ee8;\n  background: $overlay;\n  padding: 10px 10px 15px 10px;\n  margin: -16px -14px 0px -14px;\n  color: $very-light-grey;\n\n\n  /* English comment: asymmetric sci-fi header shape */\n  clip-path: \n  polygon(\n    0% 0%, \n    100% 0%, \n    100% 70%, \n    69% 70%, \n    60% 100%, \n    0% 100% \n  );\n}\n\n\n// ------------ //\n// card overlay //\n// ------------ //\n\n.vehicle-overlay {\n  position: absolute;\n  height: 245px;\n  inset: 0;\n  z-index: 2;\n  background: $overlay;\n\n  clip-path: polygon(\n    0% 8%,\n    60% 8%,\n    70% 0%,\n    100% 0%,\n    100% 100%,\n    0% 100%\n  );\n\n  transform: translateY(110%);\n  transition: transform 0.4s ease;\n\n  display: flex;\n  flex-direction: column;\n}\n\n.vehicle-card:hover {\n  .vehicle-bg {\n    transform: scale(1.1);\n    transition: transform 0.4s ease;\n  }\n\n  .vehicle-overlay {\n    transform: translateY(20%);\n  }\n}\n\n/* English comment: main grid respecting the clipped top */\n.overlay-content {\n  position: relative;\n  display: grid;\n  width: 100%;\n  grid-template-columns: minmax(0, 3fr) minmax(140px, 1fr);\n  grid-template-rows: auto 1fr;\n  gap: 10px 45px;\n  flex: 1;\n}\n\n/* English comment: production state aligned in high-right area */\n.overlay-prod {\n  grid-column: 2;\n  justify-self: end;\n}\n\n.prod-state {\n    display: grid;\n    font-size: 12px;\n    padding: 3px 0px 3px 16px;\n    width: 145px;\n    text-align: center;\n\n  &.flight-ready {\n    background: $darker-green;\n    color: $very-light-green;\n    text-align: right;\n    padding-right: 30px;\n  }\n\n  &.in-concept {\n    background: $dark-orange;\n    color: $very-light-orange;\n    text-align: right;\n    padding-right: 30px;\n  }\n}\n\n/* English comment: left placeholder column */\n.overlay-left {\n  grid-column: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 13px;\n  color: $light-grey;\n  padding: 10px;\n}\n\n/* English comment: right real specs column */\n.overlay-right {\n  grid-column: 2;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 13px;\n  color: $light-grey;\n  padding: 10px;\n}\n\n.spec-line {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 6px;\n}\n\n/* English comment: left part (label) */\n.spec-label {\n  font-weight: 600;\n  color: $light-grey;\n  font-size: 12px;\n  align-self: start;\n  white-space: nowrap;\n}\n\n/* English comment: right part (value) */\n.spec-value {\n  font-weight: 600;\n  color: $very-light-grey;\n  text-align: right;\n}\n\n.vehicle-skins {\n  position: relative;\n  padding: 5px 10px;\n  top: 25px;\n  font-size: 13px;\n  color: $light-grey;\n}\n\n.vehicle-insurances {\n  padding: 3px 8px 3px 8px;\n  margin-left: auto;\n  margin-right: 10px;\n  margin-bottom: 5px;\n  font-size: 13px;\n  color: $light-grey;\n  font-weight: bold;\n  width: fit-content;\n  background: $darker-green;\n  border-radius: 6px;\n}\n\n/* English comment: bottom RSI banner */\n.vehicle-rsi-link {\n  display: block;\n  background: #27577e;\n  text-align: center;\n  padding: 6px;\n  font-size: 13px;\n  color: $very-light-grey;\n  text-decoration: none;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n\n\n/* ---------- ITEM CARD ---------- */\n\n\n/* ---------- ITEMS ---------- */\n\n.items-section {\n  margin-top: 3rem;\n  padding: 16px;\n\n  .standalone-title {\n    margin: 0 0 12px 0;\n    font-size: 20px;\n    font-weight: 600;\n    color: $very-light-grey;\n  }\n}\n\n.item-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 1rem;\n}\n\n.item-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.item-list-row {\n  display: grid;\n  grid-template-columns: 64px minmax(140px, 2fr) minmax(48px, auto) max-content;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);\n  backdrop-filter: blur(6px) saturate(33%);\n  -webkit-backdrop-filter: blur(6px) saturate(33%);\n  background-color: #23497748;\n  border: 1px solid rgba(51, 102, 126, 0.329);\n  transition: border-color 0.15s ease;\n\n  &:hover {\n    border-color: $blue;\n  }\n}\n\n.item-list-row__thumb {\n  width: 64px;\n  height: 40px;\n  border-radius: 6px;\n  overflow: hidden;\n  flex-shrink: 0;\n  background: rgba($dark-blue-grey, 0.45);\n  border: 1px solid rgba(51, 102, 126, 0.45);\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n    pointer-events: none;\n  }\n}\n\n.item-list-row__thumb-placeholder {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.item-list-row__name {\n  min-width: 0;\n  margin: 0;\n  -webkit-line-clamp: 2;\n}\n\n.item-list-row__quantity {\n  min-width: 48px;\n  text-align: center;\n}\n\n.item-list-row__type {\n  width: max-content;\n  max-width: 100%;\n  justify-self: end;\n}\n\n.item-type-chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: max-content;\n  max-width: 100%;\n  padding: 4px 10px;\n  border: 1px solid rgba(51, 102, 126, 0.55);\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.2;\n  letter-spacing: 0.03em;\n  text-align: center;\n  text-transform: uppercase;\n  background: $darker-green;\n  border-color: $green;\n  color: $very-light-grey;\n}\n\n.item-list-row.type-fps-equipment .item-type-chip {\n  background: rgba($orange, 0.22);\n  border-color: $orange;\n  color: $very-light-orange;\n}\n\n.item-list-row.type-skin .item-type-chip {\n  background: rgba($light-blue, 0.2);\n  border-color: $light-blue;\n  color: $very-light-grey;\n}\n\n.item-list-row.type-component .item-type-chip {\n  background: rgba($accent-blue, 0.22);\n  border-color: $accent-blue;\n  color: $light-blue;\n}\n\n.item-list-row.type-insurance .item-type-chip {\n  background: $darker-green;\n  border-color: $green;\n  color: $very-light-green;\n}\n\n.item-list-row.type-upgrade .item-type-chip {\n  background: rgba($medium-grey, 0.35);\n  border-color: $medium-light-grey;\n  color: $very-light-grey;\n}\n\n.package-items .item-list {\n  margin-top: 0;\n}\n\n/* ---------- ITEM CARD ---------- */\n\n.item-card {\n  display: flex;\n  flex-direction: column;\n  position: relative; \n  justify-content: flex-start;\n  min-height: 90px;\n  max-height: 179px;\n  //background: #0f2c3ecc;\n  border: 2px solid $blue;\n  border-radius: 8px;\n  transition: border-color 0.15s ease, background 0.15s ease;\n\n  backdrop-filter: blur(6px) saturate(33%);\n  -webkit-backdrop-filter: blur(4px) saturate(33%);\n  //background-color: #23497748;\n  border: 1px solid rgba(51, 102, 126, 0.329);\n  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);\n\n  &:hover {\n    background: $overlay;\n    border-color: $blue;\n  }\n}\n\n\n/* ---------- HEADER ---------- */\n\n.item-card-header {\n  display: flex;\n  padding: 10px 10px 5px 10px;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 0.5rem;\n  margin-bottom: 0px;\n  background: $overlay;\n  border-radius: 8px 8px 0px 0px;\n\n  /* English comment: force consistent header height */\n  min-height: calc(1.2em * 2); // 2 lines\n}\n\n.item-name {\n  font-size: 0.9rem;\n  font-weight: 500;\n  line-height: 1.2;\n  color: $very-light-grey;\n\n  /* English comment: limit title to 2 lines */\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n\n.item-quantity {\n  font-size: 0.75rem;\n  color: $very-light-grey;\n  white-space: nowrap;\n}\n\n/* ---------- IMAGE ---------- */\n\n.item-image-frame {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  margin: 0;\n  border-radius: 0px 0px 8px 8px;\n}\n\n.item-image {\n  width: 100%;          // English comment: always fill card width\n  height: 100%;         // English comment: fill available height\n  object-fit: cover;   // English comment: enforce full width, crop if needed\n  display: block;\n  pointer-events: none;\n  user-select: none;\n}\n\n\n.item-card:hover {\n  .item-image {\n    transform: scale(1.1);\n    transition: transform 0.4s ease;\n  }\n}\n\n/* ---------- FOOTER ---------- */\n\n.item-card-footer {\n  position: absolute;\n  bottom: 0px;        // English comment: vertical overlap on image\n  right: 0;\n  padding: 0;          // English comment: padding handled by inner element\n  display: flex;\n  justify-content: flex-end;\n  pointer-events: none; // English comment: avoid blocking image hover\n  background: $darker-green;\n  border-radius: 0px 0px 8px 0px;\n\n  /* English comment: angled cut on the left side */\n  clip-path: polygon(\n    30px 0%,\n    100% 0%,\n    100% 100%,\n    0% 100%,\n    0% 90%\n  );\n}\n\n.item-type {\n  display: inline-block;\n  padding: 4px 20px 4px 40px; // English comment: extra left padding for clip\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: $very-light-grey;\n}\n\n\n/* ----------------------------------- */\n/* ---------- PACKAGE ITEMS ---------- */\n\n.package-items {\n  margin-top: 1rem;\n\n  h4 {\n    margin-bottom: 0.5rem;\n    font-size: 0.85rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: #cfcfcf;\n  }\n\n  .item-grid {\n    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  }\n}\n\n","@import './variables.scss';\n\n.personal-hub-factions-reputations {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  width: 100%;\n  max-width: 100%;\n  padding: 0 0 0.5rem;\n  box-sizing: border-box;\n  overflow: visible;\n}\n\n.factions-reputations-header-card {\n  &__intro {\n    margin: 0;\n    color: $light-grey;\n    line-height: 1.5;\n    font-size: 0.92rem;\n  }\n\n  .hangar-filters__toolbar {\n    align-items: center;\n  }\n\n  .hangar-filters__group--lawful {\n    flex: 0 0 auto;\n  }\n\n  .hangar-filters__group--members-panel {\n    flex: 0 0 auto;\n    margin-left: auto;\n  }\n\n  .factions-reputations-factions-card__members-toggle {\n    white-space: nowrap;\n  }\n\n  &.hangar-filters--with-help {\n    position: relative;\n    padding-right: 2.25rem;\n    padding-left: 1.1rem;\n    padding-bottom: 1rem;\n    overflow: visible;\n    z-index: 1;\n    isolation: auto;\n  }\n\n  .hangar-filters__help-anchor {\n    z-index: 11;\n  }\n\n  .hangar-filters__help-popover {\n    z-index: 12;\n  }\n}\n\n.factions-reputations-factions-card {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  min-height: 520px;\n  background: none;\n  border: none;\n  box-shadow: none;\n  padding: 0;\n  overflow: visible;\n  isolation: auto;\n\n  &.hangar-filters--horizontal {\n    background: none;\n    border: none;\n    box-shadow: none;\n    isolation: auto;\n  }\n\n  &__layout {\n    display: grid;\n    grid-template-columns: minmax(280px, 320px) minmax(0, 1fr);\n    gap: 0.5rem;\n    min-height: 0;\n    flex: 1 1 auto;\n    overflow: visible;\n    padding: 2px 4px 7px;\n    box-sizing: border-box;\n  }\n\n  &__detail-region {\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n    gap: 0;\n    min-width: 0;\n    min-height: 0;\n\n    &--members-open {\n      gap: 0.45rem;\n    }\n  }\n\n  &__detail-region &__detail {\n    margin-right: 0;\n  }\n\n  &__detail {\n    flex: 1 1 auto;\n    min-width: 0;\n    min-height: 0;\n    border: 1px solid rgba($accent-blue, 0.35);\n    border-radius: 12px;\n    background:\n      linear-gradient(180deg, rgba($dark-blue, 0.72), rgba($dark-blue-grey, 0.42)),\n      rgba($dark-blue, 0.55);\n    padding: 0;\n    overflow: auto;\n    box-shadow:\n      0 0 0 1px rgba(0, 0, 0, 0.35),\n      0 10px 14px rgba(0, 0, 0, 0.35);\n    transition:\n      flex-basis 0.28s cubic-bezier(0.4, 0, 0.2, 1),\n      border-color 0.2s ease,\n      box-shadow 0.2s ease;\n    //@include factions-reputations-thin-scrollbar;\n\n    &--member-view {\n      border: 1px solid $orange;\n      box-shadow: 0 0 0 1px rgba($light-orange, 0.55);\n    }\n  }\n\n  &__detail-region--members-open &__detail {\n    flex: 1 1 0;\n  }\n\n  &__detail-empty {\n    margin: 0;\n    color: $light-grey;\n  }\n\n  &__state {\n    margin: 0;\n    color: $light-grey;\n\n    &--error {\n      color: $bright-red;\n    }\n  }\n\n  &__banner {\n    margin: 0 0 0.65rem;\n    padding: 0.55rem 0.75rem;\n    border: 1px solid rgba($bright-red, 0.45);\n    border-radius: 8px;\n    background: rgba($bright-red, 0.12);\n    color: $bright-red;\n\n    &--error {\n      color: $bright-red;\n    }\n  }\n}\n\n.factions-reputations-faction-list {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  border: 1px solid rgba($accent-blue, 0.35);\n  border-radius: 12px;\n  background:\n    linear-gradient(180deg, rgba($dark-blue, 0.72), rgba($dark-blue-grey, 0.42)),\n    rgba($dark-blue, 0.55);\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.35),\n    0 12px 28px rgba(0, 0, 0, 0.35);\n  overflow: visible;\n\n  &__header {\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n    padding: 0.75rem 0.85rem;\n    border-bottom: 1px solid rgba($accent-blue, 0.25);\n    position: relative;\n    z-index: 4;\n    overflow: visible;\n    border-radius: 12px 12px 0 0;\n\n    .factions-reputations-help-row {\n      align-items: center;\n    }\n\n    .help-info-bubble__popover {\n      left: 0;\n      right: auto;\n      width: unquote('min(18rem, calc(100vw - 2.5rem))');\n    }\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 0.78rem;\n    font-weight: 700;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.82);\n  }\n\n  &__section-separator {\n    margin: 0.9rem 0.35rem;\n    border: 0;\n    border-top: 1px solid rgba($accent-blue, 0.38);\n  }\n\n  &__scroll {\n    display: flex;\n    flex-direction: column;\n    gap: 0.45rem;\n    padding: 0.55rem;\n    overflow: auto;\n    max-height: 62vh;\n    max-height: calc(100vh - 445px);\n    margin-bottom: 10px;\n    border-radius: 0 0 12px 12px;\n    @include factions-reputations-thin-scrollbar;\n  }\n\n  &__empty {\n    margin: 0.75rem 0.35rem;\n    color: $light-grey;\n    font-size: 0.9rem;\n  }\n}\n\n.factions-reputations-faction-item {\n  display: flex;\n  align-items: stretch;\n  gap: 0.35rem;\n\n  &--selected .factions-reputations-faction-item__main {\n    border-color: rgba($light-blue, 0.85);\n    box-shadow: 0 0 0 1px rgba($light-blue, 0.35);\n    background: rgba($accent-blue, 0.28);\n  }\n\n  &--selected .factions-reputations-faction-item__main--member-reputation {\n    border-color: $light-orange;\n    box-shadow: 0 0 0 1px rgba($light-orange, 0.35);\n  }\n\n  &--zero-progress .factions-reputations-faction-item__main {\n    background: rgba($dark-blue-grey, 0.62);\n    border-color: rgba($accent-blue, 0.16);\n\n    &:hover {\n      background: rgba($dark-blue-grey, 0.72);\n      border-color: rgba($accent-blue, 0.24);\n    }\n  }\n\n  &--zero-progress .factions-reputations-faction-item__main--member-reputation,\n  &--zero-progress#{&}--selected .factions-reputations-faction-item__main--member-reputation {\n    border-color: $light-orange;\n    box-shadow: 0 0 0 1px rgba($light-orange, 0.35);\n\n    &:hover {\n      border-color: $light-orange;\n    }\n  }\n\n  &--zero-progress#{&}--selected .factions-reputations-faction-item__main {\n    background: rgba($accent-blue, 0.22);\n    border-color: rgba($light-blue, 0.65);\n  }\n\n  &__main {\n    flex: 1 1 auto;\n    display: grid;\n    grid-template-columns: 42px minmax(0, 1fr);\n    gap: 0.65rem;\n    align-items: start;\n    min-width: 0;\n    padding: 0.55rem 0.65rem;\n    border: 1px solid rgba($accent-blue, 0.28);\n    border-radius: 8px;\n    background: rgba($dark-panel-blue, 0.55);\n    color: inherit;\n    text-align: left;\n    cursor: pointer;\n    transition:\n      border-color 0.15s ease,\n      background 0.15s ease,\n      box-shadow 0.15s ease;\n\n    &:hover {\n      border-color: rgba($light-blue, 0.55);\n      background: rgba($accent-blue, 0.22);\n    }\n\n    &:focus-visible {\n      outline: 2px solid rgba($accent-blue, 0.75);\n      outline-offset: 2px;\n    }\n\n    &--member-reputation {\n      border-color: $light-orange;\n\n      &:hover {\n        border-color: $light-orange;\n      }\n    }\n  }\n\n  &__body {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    min-width: 0;\n  }\n\n  &__copy {\n    display: flex;\n    flex-direction: column;\n    gap: 0.2rem;\n    min-width: 0;\n  }\n\n  &__name {\n    font-size: 0.92rem;\n    font-weight: 700;\n    color: $very-light-grey;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &__meter-wrap {\n    display: flex;\n    align-items: center;\n    gap: 0.45rem;\n    width: 100%;\n  }\n\n  &__meter {\n    flex: 1 1 auto;\n    height: 6px;\n    border-radius: 999px;\n    background: rgba($pure-white, 0.08);\n    overflow: hidden;\n  }\n\n  &__meter-fill {\n    display: block;\n    height: 100%;\n    width: calc(var(--factions-reputations-meter, 0) * 1%);\n    border-radius: inherit;\n    @include factions-reputations-progress-tone-modifiers;\n\n    @for $i from 0 through 100 {\n      &[data-meter-pct=\"#{$i}\"] {\n        --factions-reputations-meter: #{$i};\n      }\n    }\n  }\n\n  &__percent {\n    font-size: 0.72rem;\n    font-weight: 700;\n    color: rgba($very-light-grey, 0.82);\n  }\n\n  &__favorite {\n    flex: 0 0 34px;\n    width: fit-content;\n    padding: 0.2rem 0.85rem;\n    border: 1px solid rgba($accent-blue, 0.28);\n    border-radius: 8px;\n    background: rgba($dark-blue, 0.35);\n    color: rgba($very-light-grey, 0.55);\n    font-size: 0.95rem;\n    line-height: 1;\n    cursor: pointer;\n    transition:\n      color 0.15s ease,\n      border-color 0.15s ease,\n      background 0.15s ease;\n\n    &:hover:not(:disabled) {\n      color: $very-light-orange;\n      border-color: rgba($light-orange, 0.55);\n    }\n\n    &--active {\n      color: $light-orange;\n      border-color: rgba($light-orange, 0.65);\n      background: rgba($light-orange, 0.12);\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.55;\n    }\n  }\n}\n\n.factions-reputations-faction-logo {\n  width: 38px;\n  height: 38px;\n  padding: 5px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex-shrink: 0;\n  border: 1px solid rgba($accent-blue, 0.35);\n  background: rgba($dark-blue-grey, 0.85);\n\n  &--fallback {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.95rem;\n    font-weight: 700;\n    color: $very-light-grey;\n  }\n}\n\n.factions-reputations-faction-detail {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n\n  &__header {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    height: 110px;\n    padding: 0;\n    border: 1px solid rgba($accent-blue, 0.25);\n    border-radius: 10px;\n    overflow: hidden;\n\n    &--lawful,\n    &--unlawful {\n      &::before {\n        content: '';\n        position: absolute;\n        inset: 0;\n        z-index: 0;\n        background-repeat: no-repeat;\n        background-position: center;\n        background-size: cover;\n        pointer-events: none;\n      }\n\n      &::after {\n        content: '';\n        position: absolute;\n        inset: 0;\n        z-index: 1;\n        background: linear-gradient(\n          180deg,\n          rgba($dark-blue-grey, 0.52) 0%,\n          rgba($dark-blue-grey, 0.62) 100%\n        );\n        pointer-events: none;\n      }\n    }\n\n    &--lawful::before {\n      background-image: url('../medias/uee-banner-shaped.png');\n    }\n\n    &--unlawful::before {\n      background-image: url('../medias/pirate-banner-shaped.png');\n    }\n  }\n\n  &__hero {\n    position: relative;\n    z-index: 2;\n    display: grid;\n    grid-template-columns: 90px minmax(0, 1fr) auto;\n    gap: 0.85rem;\n    padding: 0.65rem 1rem;\n    align-items: center;\n  }\n\n  &__logo {\n    width: 75px;\n    height: 75px;\n  }\n\n  &__name-row {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 0.8rem;\n  }\n\n  &__name {\n    margin: 0;\n    font-size: 1.35rem;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: $very-light-grey;\n  }\n\n  &__member-chip {\n    display: inline-flex;\n    align-items: center;\n    padding: 0.3rem 0.6rem;\n    border: 1px solid $light-orange;\n    border-radius: 8px;\n    background: rgba($dark-orange, 0.72);\n    color: $very-light-orange;\n    font-size: 0.8rem;\n    font-weight: 700;\n    letter-spacing: 0.03em;\n    line-height: 1.25;\n    white-space: nowrap;\n  }\n\n  &__category {\n    margin: 0.25rem 0 0;\n    color: $light-blue;\n    font-size: 0.88rem;\n  }\n\n  &__favorite {\n    position: relative;\n    bottom: 15px;\n    min-width: 38px;\n    height: 30px;\n    border: 1px solid rgba($accent-blue, 0.35);\n    border-radius: 8px;\n    background: rgba($dark-blue, 0.35);\n    color: rgba($very-light-grey, 0.55);\n    font-size: 1.1rem;\n    cursor: pointer;\n\n    &--active {\n      color: $very-light-orange;\n      font-size: 0.95rem;\n      border-color: rgba($light-orange, 0.65);\n      background: rgba($dark-orange, 0.55);\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.55;\n    }\n  }\n\n  &__level {\n    position: relative;\n    z-index: 2;\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n    width: fit-content;\n    max-width: calc(100% - 2rem);\n    margin: 0 1rem 0.85rem;\n    padding: 0.55rem 0.75rem;\n    border: 1px solid rgba($medium-light-grey, 0.45);\n    border-radius: 10px;\n    box-shadow: 0 2px 10px rgba($dark-blue-grey, 0.28);\n\n    @include factions-reputations-level-chip-theme('unselected');\n\n    &--hostile {\n      @include factions-reputations-level-chip-theme('hostile');\n    }\n\n    &--not-eligible {\n      @include factions-reputations-level-chip-theme('not-eligible');\n    }\n\n    &--unselected {\n      @include factions-reputations-level-chip-theme('unselected');\n    }\n\n    &--neutral {\n      @include factions-reputations-level-chip-theme('neutral');\n    }\n\n    &--friendly {\n      @include factions-reputations-level-chip-theme('friendly');\n    }\n\n    &--trusted {\n      @include factions-reputations-level-chip-theme('trusted');\n    }\n\n    &--renown {\n      @include factions-reputations-level-chip-theme('renown');\n    }\n\n    &--legendary {\n      @include factions-reputations-level-chip-theme('legendary');\n    }\n  }\n\n  &__level-row {\n    display: flex;\n    align-items: center;\n    gap: 0.45rem;\n    min-width: 0;\n\n    &--scope {\n      gap: 0.5rem;\n    }\n\n    &--grade {\n      padding-left: 0.1rem;\n    }\n  }\n\n  &__level-icon {\n    flex-shrink: 0;\n    object-fit: contain;\n\n    &--scope {\n      width: 1.35rem;\n      height: 1.35rem;\n      border-radius: 999px;\n      padding: 0.15rem;\n      background: rgba($pure-white, 0.1);\n    }\n\n    &--grade {\n      width: 1.05rem;\n      height: 1.05rem;\n      border-radius: 4px;\n    }\n\n    &--empty {\n      display: inline-block;\n      box-sizing: border-box;\n      border: 1px dashed rgba($pure-white, 0.28);\n      background: rgba($pure-white, 0.08);\n    }\n  }\n\n  &__level-scope-title {\n    font-size: 0.82rem;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    line-height: 1.25;\n    overflow-wrap: anywhere;\n  }\n\n  &__level-grade-label {\n    font-size: 0.72rem;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    line-height: 1.25;\n    overflow-wrap: anywhere;\n  }\n\n  &__notes-label {\n    font-size: 0.78rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.82);\n  }\n\n  &__notes {\n    width: 100%;\n    min-height: 45px;\n    padding: 0.65rem 0.75rem;\n    border: 1px solid rgba($accent-blue, 0.35);\n    border-radius: 8px;\n    background: rgba($dark-blue, 0.45);\n    color: $very-light-grey;\n    font: inherit;\n    resize: vertical;\n    box-sizing: border-box;\n\n    &::placeholder {\n      color: rgba($light-grey, 0.75);\n    }\n\n    &:disabled {\n      opacity: 0.65;\n      cursor: not-allowed;\n    }\n  }\n\n  &__updated {\n    margin: 0;\n    font-size: 0.78rem;\n    color: rgba($light-grey, 0.9);\n  }\n\n  &__notes-wrap { \n    display: flex;\n    flex-direction: column;\n    padding: 0 1rem;\n    gap: 0.65rem;\n  }\n\n  &__updated-wrap {\n    padding: 0 0.65rem 0.65rem;\n\n  }\n}\n\n.factions-reputations-grade-stepper {\n  display: flex;\n  flex-direction: column;\n  padding: 0 1rem;\n  gap: 0.75rem;\n\n  &__label {\n    margin: 0;\n    font-size: 0.78rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.82);\n  }\n\n  &__empty {\n    margin: 0;\n    color: $light-grey;\n    font-size: 0.85rem;\n  }\n\n  &__columns {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(15.3rem, max-content));\n    gap: 0.85rem;\n    align-items: start;\n\n    &--carousel {\n      display: flex;\n      flex-direction: row;\n      flex-wrap: nowrap;\n      align-items: stretch;\n      justify-content: flex-start;\n      width: max-content;\n    }\n  }\n\n  &__columns-carousel {\n    display: flex;\n    align-items: stretch;\n    gap: 0.4rem;\n    min-width: 0;\n  }\n\n  &__columns-viewport {\n    flex: 1 1 auto;\n    min-width: 0;\n    align-self: stretch;\n    display: flex;\n    overflow-x: auto;\n    overflow-y: hidden;\n    overscroll-behavior-x: contain;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n    touch-action: pan-y;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n\n    &--scrollable {\n      cursor: grab;\n    }\n\n    &--dragging {\n      cursor: grabbing;\n      user-select: none;\n      scroll-behavior: auto;\n\n      * {\n        cursor: grabbing;\n        user-select: none;\n      }\n    }\n  }\n\n  &__columns-nav {\n    flex: 0 0 1.5rem;\n    align-self: stretch;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 1.5rem;\n    min-height: 0;\n    height: auto;\n    padding: 0;\n    border: 1px solid rgba($accent-blue, 0.35);\n    border-radius: 8px;\n    background: rgba($dark-panel-blue, 0.45);\n    box-shadow: 0 0 0 1px rgba($light-blue, 0.08);\n    cursor: pointer;\n    transition:\n      opacity 0.15s ease,\n      border-color 0.15s ease,\n      background-color 0.15s ease;\n\n    &:enabled:hover {\n      border-color: rgba($light-blue, 0.55);\n      background: rgba($accent-blue, 0.22);\n    }\n\n    &:focus-visible {\n      outline: 2px solid rgba($accent-blue, 0.75);\n      outline-offset: 2px;\n    }\n\n    &:disabled,\n    &--disabled {\n      opacity: 0.28;\n      cursor: default;\n    }\n  }\n\n  &__columns-nav-icon {\n    display: block;\n    width: 0;\n    height: 0;\n    border-top: 5px solid transparent;\n    border-bottom: 5px solid transparent;\n  }\n\n  &__columns-nav--prev &__columns-nav-icon {\n    border-right: 7px solid $light-blue;\n  }\n\n  &__columns-nav--next &__columns-nav-icon {\n    border-left: 7px solid $light-blue;\n  }\n\n  &__column {\n    display: flex;\n    flex-direction: column;\n    gap: 0.55rem;\n    min-width: 0;\n    height: -webkit-fill-available;\n    padding: 0.65rem 0.55rem 0.75rem;\n    border: 1px solid rgba($accent-blue, 0.22);\n    border-radius: 10px;\n    background: rgba($dark-panel-blue, 0.58);\n    transition:\n      border-color 0.15s ease,\n      box-shadow 0.15s ease;\n    box-shadow: 0 0 0 1px rgba($light-blue, 0.12);\n\n    .factions-reputations-grade-stepper__columns--carousel & {\n      flex: 0 0 15.5rem;\n      width: 15.5rem;\n      max-width: 15.5rem;\n    }\n\n    &--active {\n      border-color: rgba($light-blue, 0.25);\n      box-shadow: 0 0 0 1px rgba($light-blue, 0.32);\n    }\n  }\n\n  &__column-body {\n    flex: 1 1 auto;\n    min-height: 46px;\n    max-height: calc(100vh - 850px);\n    @include scroll-hidden;\n  }\n\n  &__column-head {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 0.35rem;\n    width: 100%;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    text-align: center;\n    cursor: pointer;\n    color: inherit;\n\n    &:focus-visible {\n      outline: 2px solid rgba($accent-blue, 0.75);\n      outline-offset: 2px;\n      border-radius: 6px;\n    }\n  }\n\n  &__scope-icon {\n    display: block;\n    background: rgba($accent-blue, 0.35);\n    border-radius: 999px;\n    width: 1.3rem;\n    height: 1.3rem;\n    padding: 0.25rem;\n    object-fit: contain;\n\n    &--empty {\n      flex-shrink: 0;\n      background: transparent;\n      border: none;\n      box-shadow: none;\n    }\n  }\n\n  &__scope-title {\n    margin: 0;\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: rgba($light-blue, 0.9);\n  }\n\n  &__timeline {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  }\n\n  &__timeline-item {\n    display: grid;\n    grid-template-columns: 1.1rem 1fr;\n    gap: 0.55rem;\n    padding-bottom: 0.65rem;\n\n    &--last {\n      padding-bottom: 0;\n    }\n\n    &--selected {\n      .factions-reputations-grade-stepper__rail-dot {\n        background: rgba($light-blue, 0.95);\n        box-shadow: 0 0 0 2px rgba($light-blue, 0.35);\n      }\n    }\n  }\n\n  &__rail {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    min-height: 100%;\n  }\n\n  &__rail-dot {\n    flex-shrink: 0;\n    width: 0.55rem;\n    height: 0.55rem;\n    margin-top: 0.65rem;\n    border-radius: 50%;\n    background: rgba($accent-blue, 0.85);\n    box-shadow: 0 0 0 2px rgba($accent-blue, 0.22);\n  }\n\n  &__rail-line {\n    flex: 1 1 auto;\n    width: 2px;\n    min-height: 1.5rem;\n    margin-top: 0.15rem;\n    border-radius: 999px;\n    background: rgba($accent-blue, 0.35);\n  }\n\n  &__step {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.45rem;\n    width: 100%;\n    padding: 0.25rem 0.35rem;\n    border: 1px solid transparent;\n    border-radius: 8px;\n    background: transparent;\n    color: $light-grey;\n    font-size: 0.76rem;\n    text-align: left;\n    cursor: pointer;\n\n    &--selected {\n      border-color: rgba($light-blue, 0.55);\n      background: rgba($accent-blue, 0.22);\n      color: $very-light-grey;\n      box-shadow: 0 0 0 1px rgba($light-blue, 0.18);\n    }\n\n    &--hostile.factions-reputations-grade-stepper__step--selected {\n      border-color: rgba($bright-red, 0.65);\n      background: rgba($bright-red, 0.14);\n    }\n\n    &--not-eligible.factions-reputations-grade-stepper__step--selected {\n      border-color: rgba($medium-red, 0.65);\n      background: rgba($medium-red, 0.14);\n    }\n\n    &--legendary.factions-reputations-grade-stepper__step--selected {\n      border-color: rgba($light-orange, 0.65);\n      background: rgba($light-orange, 0.12);\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.6;\n    }\n  }\n\n  &__icon {\n    flex-shrink: 0;\n    width: 2.5rem;\n    height: 2.5rem;\n    object-fit: contain;\n\n    &--empty {\n      border-radius: 4px;\n      background: rgba($accent-blue, 0.15);\n    }\n  }\n\n  &__name {\n    min-width: 0;\n    //padding-top: 0.2rem;\n    align-self: center;\n    line-height: 1.25;\n  }\n\n  &__progress {\n    flex-shrink: 0;\n  }\n\n  &__progress-track {\n    position: relative;\n    box-sizing: border-box;\n    width: 100%;\n    height: 1.15rem;\n    border-radius: 999px;\n    overflow: hidden;\n    background: rgba(0, 0, 0, 0.35);\n    border: 1px solid rgba($light-panel-blue, 0.95);\n  }\n\n  &__progress-fill {\n    position: absolute;\n    left: 0;\n    bottom: 3px;\n    height: 0.75rem;\n    width: calc(var(--fill-pct, 0) * 1%);\n    border-radius: inherit;\n    @include factions-reputations-progress-tone-modifiers;\n    transition: width 0.25s ease;\n\n    @for $i from 0 through 100 {\n      &[data-fill-pct=\"#{$i}\"] {\n        --fill-pct: #{$i};\n      }\n    }\n  }\n\n  &__progress-label {\n    position: relative;\n    z-index: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    font-size: 0.68rem;\n    font-weight: 700;\n    color: $very-light-grey;\n    pointer-events: none;\n  }\n}\n\n.factions-reputations-faction-members-panel {\n  flex: 0 0 0;\n  width: 0;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  color: $very-light-grey;\n  border: 1px solid transparent;\n  border-radius: 10px;\n  background: rgba($very-dark-grey, 0.96);\n  overflow: visible;\n  opacity: 0;\n  pointer-events: none;\n  transition:\n    flex-basis 0.28s cubic-bezier(0.4, 0, 0.2, 1),\n    width 0.28s cubic-bezier(0.4, 0, 0.2, 1),\n    opacity 0.2s ease,\n    border-color 0.2s ease;\n\n  &--open {\n    flex: 0 0 220px;\n    width: 220px;\n    opacity: 1;\n    pointer-events: auto;\n    border-color: rgba($accent-blue, 0.35);\n    box-shadow:\n      0 0 0 1px rgba(0, 0, 0, 0.35),\n      0 12px 28px rgba(0, 0, 0, 0.35);\n    z-index: 3;\n  }\n\n  &__title {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.5rem;\n    flex-shrink: 0;\n    padding: 0.65rem 0.75rem 0.45rem;\n    border-bottom: 1px solid rgba($accent-blue, 0.25);\n    user-select: none;\n    position: relative;\n    z-index: 4;\n    overflow: visible;\n    border-radius: 10px 10px 0 0;\n\n    .factions-reputations-help-row {\n      flex: 1 1 auto;\n      min-width: 0;\n      align-items: center;\n    }\n\n    .help-info-bubble__popover {\n      left: auto;\n      right: 0;\n      width: unquote('min(18rem, calc(100vw - 2.5rem))');\n    }\n\n    strong {\n      font-size: 0.78rem;\n      letter-spacing: 0.06em;\n      text-transform: uppercase;\n      color: rgba($very-light-grey, 0.9);\n    }\n  }\n\n  &__count {\n    min-width: 1.35rem;\n    padding: 0.1rem 0.35rem;\n    border-radius: 999px;\n    font-size: 0.68rem;\n    font-weight: 700;\n    text-align: center;\n    color: $very-light-grey;\n    background: rgba($accent-blue, 0.25);\n  }\n\n  &__state {\n    margin: 0;\n    padding: 0.65rem 0.75rem;\n    font-size: 0.82rem;\n    color: $light-grey;\n\n    &--error {\n      color: $bright-red;\n    }\n  }\n\n  &__empty {\n    margin: 0;\n    padding: 0.65rem 0.75rem;\n    font-size: 0.82rem;\n    font-style: italic;\n    color: rgba($light-grey, 0.85);\n  }\n\n  &__list {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 10px;\n    list-style: none;\n    margin: 0;\n    border-radius: 0 0 10px 10px;\n    @include scrollbar-styles;\n  }\n\n  &__item {\n    margin: 0;\n    padding: 0;\n  }\n\n  &__member-btn {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    width: 100%;\n    padding: 5px 8px;\n    border: 1px solid transparent;\n    border-radius: 6px;\n    background: transparent;\n    cursor: pointer;\n    text-align: left;\n    color: inherit;\n\n    &:hover {\n      background: rgba($accent-blue, 0.12);\n      border-color: rgba($accent-blue, 0.25);\n    }\n\n    &:focus-visible {\n      outline: 2px solid rgba($accent-blue, 0.75);\n      outline-offset: 1px;\n    }\n\n    &--faction-match {\n      border-color: $light-orange;\n\n      &:hover {\n        border-color: $light-orange;\n      }\n    }\n\n    &--selected {\n      background: rgba($light-orange, 0.14);\n      border-color: rgba($light-orange, 0.55);\n    }\n  }\n\n  &__member-avatar {\n    flex-shrink: 0;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    object-fit: cover;\n\n    &--placeholder {\n      display: inline-block;\n      background: $medium-light-grey;\n      opacity: 0.35;\n    }\n  }\n\n  &__member-name {\n    flex: 1 1 auto;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    color: #afa991;\n    font-size: 0.88rem;\n  }\n\n  &__member-rank {\n    flex-shrink: 0;\n    width: 18px;\n    height: 18px;\n    object-fit: contain;\n  }\n\n  &__member-percent {\n    flex-shrink: 0;\n    font-size: 0.72rem;\n    font-weight: 700;\n    color: rgba($very-light-grey, 0.82);\n  }\n}\n\n@media (max-width: 980px) {\n  .personal-hub-factions-reputations {\n    max-width: 100%;\n  }\n\n  .factions-reputations-factions-card__layout {\n    grid-template-columns: 1fr;\n  }\n\n  .factions-reputations-factions-card__detail-region {\n    flex-direction: column;\n\n    &--members-open {\n      gap: 0.45rem;\n    }\n  }\n\n  .factions-reputations-faction-members-panel--open {\n    flex: 1 1 auto;\n    width: 100%;\n    max-height: 240px;\n  }\n\n  .factions-reputations-faction-list__scroll {\n    max-height: 280px;\n  }\n}\n\n.factions-reputations-help-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.45rem;\n  min-width: 0;\n\n  .factions-reputations-grade-stepper__label,\n  .factions-reputations-faction-detail__notes-label,\n  .factions-reputations-faction-list__title {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n}\n\n// Affinity bipolar meter (list) + interactive bar (detail).\n// Position/extent come from native minReputation + reputationCeiling (neutral at 0).\n@mixin factions-reputations-affinity-pos-attrs {\n  @for $i from 0 through 100 {\n    &[data-affinity-pos='#{$i}'] {\n      --factions-reputations-affinity-pos: #{$i};\n    }\n  }\n}\n\n@mixin factions-reputations-affinity-extent-attrs {\n  @for $i from 0 through 100 {\n    &[data-affinity-extent='#{$i}'] {\n      --factions-reputations-affinity-extent: #{$i};\n    }\n  }\n}\n\n.factions-reputations-affinity-meter {\n  flex: 1 1 auto;\n  width: 100%;\n  min-width: 0;\n\n  &__track {\n    position: relative;\n    display: block;\n    height: 8px;\n    border-radius: 999px;\n    overflow: hidden;\n    background: rgba($pure-white, 0.06);\n  }\n\n  &__half {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    width: 50%;\n\n    &--negative {\n      left: 0;\n      background: linear-gradient(90deg, rgba($dark-red, 0.35), rgba($bright-red, 0.12));\n    }\n\n    &--positive {\n      right: 0;\n      background: linear-gradient(90deg, rgba($light-green, 0.12), rgba($green, 0.35));\n    }\n  }\n\n  &__center {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 50%;\n    width: 1px;\n    transform: translateX(-50%);\n    background: rgba($very-light-grey, 0.55);\n    z-index: 2;\n  }\n\n  &__fill {\n    position: absolute;\n    top: 1px;\n    bottom: 1px;\n    z-index: 1;\n    border-radius: 999px;\n    @include factions-reputations-affinity-extent-attrs;\n\n    &--negative {\n      right: 50%;\n      width: calc(var(--factions-reputations-affinity-extent, 0) * 1% / 2);\n      background: linear-gradient(90deg, $dark-red, $bright-red);\n    }\n\n    &--positive {\n      left: 50%;\n      width: calc(var(--factions-reputations-affinity-extent, 0) * 1% / 2);\n      background: linear-gradient(90deg, $light-green, $green);\n    }\n\n    &--neutral {\n      display: none;\n    }\n  }\n\n  &__marker {\n    position: absolute;\n    top: 50%;\n    left: calc(var(--factions-reputations-affinity-pos, 50) * 1%);\n    z-index: 3;\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: $very-light-grey;\n    border: 1px solid rgba($dark-blue-grey, 0.9);\n    transform: translate(-50%, -50%);\n    @include factions-reputations-affinity-pos-attrs;\n  }\n}\n\n.factions-reputations-affinity-bar {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  margin: 0.85rem 1rem 0;\n  padding: 0.65rem 0.8rem;\n  border: 1px solid rgba($accent-blue, 0.22);\n  border-radius: 10px;\n  background: rgba($dark-blue, 0.28);\n\n  &__header {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    gap: 0.75rem;\n    min-width: 0;\n  }\n\n  &__title-row {\n    display: flex;\n    align-items: center;\n    gap: 0.45rem;\n    min-width: 0;\n  }\n\n  &__icon {\n    width: 1.1rem;\n    height: 1.1rem;\n    object-fit: contain;\n    flex: 0 0 auto;\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 0.78rem;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.92);\n  }\n\n  &__standing-label {\n    margin: 0;\n    font-size: 0.78rem;\n    font-weight: 600;\n    text-align: right;\n    color: rgba($light-grey, 0.92);\n\n    &--hostile {\n      color: $bright-red;\n    }\n\n    &--neutral {\n      color: $light-orange;\n    }\n\n    &--friendly,\n    &--trusted {\n      color: $light-green;\n    }\n\n    &--legendary,\n    &--renown {\n      color: $very-light-orange;\n    }\n\n    &--unselected {\n      color: $medium-grey;\n    }\n  }\n\n  &__limit {\n    margin: 0;\n    font-size: 0.72rem;\n    color: rgba($light-orange, 0.9);\n  }\n\n  &--dragging {\n    user-select: none;\n\n    .factions-reputations-affinity-bar__standings {\n      pointer-events: none;\n    }\n  }\n\n  &__track {\n    position: relative;\n    height: 15px;\n    border-radius: 8px;\n    overflow: hidden;\n    background: rgba($pure-white, 0.06);\n  }\n\n  &__half {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    width: 50%;\n    pointer-events: none;\n\n    &--negative {\n      left: 0;\n      background: linear-gradient(90deg, rgba($dark-red, 0.42), rgba($bright-red, 0.1));\n    }\n\n    &--positive {\n      right: 0;\n      background: linear-gradient(90deg, rgba($light-green, 0.1), rgba($green, 0.42));\n    }\n  }\n\n  &__center {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 50%;\n    z-index: 2;\n    width: 2px;\n    transform: translateX(-50%);\n    background: rgba($very-light-grey, 0.65);\n    pointer-events: none;\n  }\n\n  &__fill {\n    position: absolute;\n    top: 4px;\n    bottom: 4px;\n    z-index: 1;\n    border-radius: 6px;\n    pointer-events: none;\n    @include factions-reputations-affinity-extent-attrs;\n\n    &--negative {\n      right: 50%;\n      width: calc(var(--factions-reputations-affinity-extent, 0) * 1% / 2);\n      background: linear-gradient(90deg, $dark-red, $bright-red);\n      box-shadow: 0 0 10px rgba($bright-red, 0.35);\n    }\n\n    &--positive {\n      left: 50%;\n      width: calc(var(--factions-reputations-affinity-extent, 0) * 1% / 2);\n      background: linear-gradient(90deg, $light-green, $green);\n      box-shadow: 0 0 10px rgba($light-green, 0.35);\n    }\n\n    &--neutral {\n      display: none;\n    }\n  }\n\n  &__standings {\n    position: absolute;\n    inset: 0;\n    z-index: 4;\n  }\n\n  &__standing {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: calc(var(--factions-reputations-affinity-pos, 50) * 1%);\n    z-index: 4;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 0.85rem;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    transform: translateX(-50%);\n    pointer-events: none;\n    @include factions-reputations-affinity-pos-attrs;\n\n    &--selected .factions-reputations-affinity-bar__standing-tick {\n      background: $very-light-grey;\n      transform: scaleY(1.35);\n      box-shadow: 0 0 0 1px rgba($accent-blue, 0.55);\n    }\n  }\n\n  &__standing-tick {\n    display: block;\n    width: 2px;\n    height: 55%;\n    border-radius: 1px;\n    background: rgba($very-light-grey, 0.28);\n    transition:\n      background 0.15s ease,\n      transform 0.15s ease,\n      box-shadow 0.15s ease;\n  }\n\n  &__marker {\n    position: absolute;\n    top: 50%;\n    left: calc(var(--factions-reputations-affinity-pos, 50) * 1%);\n    z-index: 6;\n    width: 10px;\n    height: 10px;\n    padding: 0;\n    border-radius: 50%;\n    background: $very-light-grey;\n    border: 2px solid rgba($dark-blue-grey, 0.95);\n    box-shadow: 0 0 0 1px rgba($accent-blue, 0.45);\n    transform: translate(-50%, -50%);\n    pointer-events: none;\n    @include factions-reputations-affinity-pos-attrs;\n\n    &--draggable {\n      pointer-events: auto;\n      cursor: grab;\n      touch-action: none;\n\n      // Larger grab hit-area without changing the visible cursor.\n      &::before {\n        content: '';\n        position: absolute;\n        inset: -10px;\n      }\n\n      &:disabled {\n        cursor: default;\n        pointer-events: none;\n      }\n\n      &:focus-visible {\n        outline: 2px solid rgba($light-blue, 0.85);\n        outline-offset: 2px;\n      }\n    }\n\n    &--dragging {\n      cursor: grabbing;\n      transform: translate(-50%, -50%) scale(1.25);\n      box-shadow:\n        0 0 0 2px rgba($light-blue, 0.55),\n        0 0 12px rgba($light-blue, 0.35);\n      transition: transform 0.12s ease, box-shadow 0.12s ease;\n    }\n  }\n\n  &__scale {\n    display: flex;\n    justify-content: space-between;\n    font-size: 0.68rem;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    color: rgba($light-grey, 0.72);\n  }\n}\n\n.factions-reputations-grade-stepper--careers-empty {\n  .factions-reputations-grade-stepper__empty {\n    margin: 0.35rem 0 0;\n    color: rgba($light-grey, 0.78);\n    font-size: 0.82rem;\n  }\n}\n","@import './variables';\n\n.personal-hub-blueprints {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  min-height: 0;\n  min-width: 0;\n  gap: 1rem;\n  padding: 0 0rem 1.5rem;\n}\n\n.personal-hub-blueprints-header {\n  padding-bottom: 1rem;\n  position: relative;\n\n  .hangar-filters__top {\n    position: relative;\n    padding-right: 7rem;\n  }\n\n  .hangar-filters__toolbar {\n    align-items: center;\n  }\n\n  .hangar-filters__group--members-panel {\n    display: flex;\n    flex: 0 0 auto;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.4rem;\n    margin-left: auto;\n  }\n\n  &.hangar-filters--with-help {\n    overflow: visible;\n    z-index: 1;\n    isolation: auto;\n  }\n\n  .hangar-filters__help-anchor {\n    z-index: 11;\n  }\n\n  .hangar-filters__help-popover {\n    z-index: 12;\n  }\n\n  &__version {\n    position: absolute;\n    top: 0.5rem;\n    right: 0.75rem;\n    margin-left: 0;\n    font-size: 0.74rem;\n    color: rgba($very-light-grey, 0.62);\n    white-space: nowrap;\n  }\n\n  &.hangar-filters--with-help &__version {\n    right: 2.75rem;\n  }\n\n  .personal-hub-blueprints-card__my-blueprints-toggle,\n  .personal-hub-blueprints-card__members-toggle {\n    white-space: nowrap;\n  }\n}\n\n.personal-hub-blueprints-card {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  flex: 1 1 auto;\n  min-height: 520px;\n  background: none;\n  border: none;\n  box-shadow: none;\n  padding: 0;\n  overflow: visible;\n  isolation: auto;\n\n  &.hangar-filters--horizontal {\n    background: none;\n    border: none;\n    box-shadow: none;\n    isolation: auto;\n  }\n\n  &__layout {\n    display: grid;\n    grid-template-columns: minmax(280px, 320px) minmax(0, 1fr);\n    gap: 0.5rem;\n    min-height: 0;\n    flex: 1 1 auto;\n    overflow: visible;\n    padding: 2px 4px 12px;\n    box-sizing: border-box;\n  }\n\n  &__detail-region {\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n    gap: 0;\n    min-width: 0;\n    min-height: 0;\n\n    &--members-open {\n      gap: 0.45rem;\n    }\n  }\n\n  &__detail {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    min-width: 0;\n    min-height: 0;\n    height: $personal-hub-blueprint-panel-height;\n    max-height: $personal-hub-blueprint-panel-height;\n    border: 1px solid rgba($accent-blue, 0.35);\n    border-radius: 12px;\n    background:\n      linear-gradient(180deg, rgba($dark-blue, 0.72), rgba($dark-blue-grey, 0.42)),\n      rgba($dark-blue, 0.55);\n    box-shadow:\n      0 0 0 1px rgba(0, 0, 0, 0.35),\n      0 10px 14px rgba(0, 0, 0, 0.35);\n    padding: 1rem;\n    overflow: auto;\n    @include personal-hub-blueprint-thin-scrollbar;\n\n    &--member-view {\n      border-color: $light-orange;\n      box-shadow:\n        0 0 0 1px rgba($light-orange, 0.55),\n        0 10px 14px rgba(0, 0, 0, 0.35);\n    }\n  }\n\n  &__detail-empty {\n    margin: 0;\n    color: rgba($very-light-grey, 0.72);\n    font-size: 0.95rem;\n  }\n\n  &__state {\n    margin: 0;\n    color: $light-grey;\n\n    &--error {\n      color: $bright-red;\n    }\n  }\n}\n\n.personal-hub-blueprint-list {\n  display: flex;\n  flex-direction: column;\n  //min-height: 0;\n  border: 1px solid rgba($accent-blue, 0.35);\n  border-radius: 12px;\n  background:\n    linear-gradient(180deg, rgba($dark-blue, 0.72), rgba($dark-blue-grey, 0.42)),\n    rgba($dark-blue, 0.55);\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.35),\n    0 12px 28px rgba(0, 0, 0, 0.35);\n  overflow: visible;\n\n  &__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.75rem;\n    padding: 0.75rem 0.85rem;\n    border-bottom: 1px solid rgba($accent-blue, 0.25);\n    border-radius: 12px 12px 0 0;\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 0.78rem;\n    font-weight: 700;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.82);\n  }\n\n  &__count {\n    font-size: 0.72rem;\n    color: rgba($very-light-grey, 0.55);\n    white-space: nowrap;\n  }\n\n  &__section-separator {\n    margin: 0.9rem 0.35rem;\n    border: 0;\n    border-top: 1px solid rgba($accent-blue, 0.38);\n  }\n\n  &__scroll {\n    display: flex;\n    flex-direction: column;\n    gap: 0.45rem;\n    padding: 0.55rem 0.3rem 0.55rem 0.55rem;\n    overflow: auto;\n    max-height: calc(100vh - 430px);\n    margin-bottom: 10px;\n    border-radius: 0 0 12px 12px;\n    @include personal-hub-blueprint-thin-scrollbar;\n  }\n\n  &__empty {\n    margin: 0.75rem 0.35rem;\n    color: $light-grey;\n    font-size: 0.9rem;\n  }\n\n  &__loading {\n    margin: 0.35rem 0.35rem 0.75rem;\n    color: rgba($very-light-grey, 0.62);\n    font-size: 0.78rem;\n    font-style: italic;\n  }\n}\n\n.personal-hub-blueprint-logo {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  border-radius: 8px;\n  background: rgba($accent-blue, 0.28);\n  border: 1px solid rgba($accent-blue, 0.35);\n  color: $very-light-grey;\n  font-size: 0.95rem;\n  font-weight: 700;\n  flex-shrink: 0;\n  object-fit: contain;\n  padding: 4px;\n  box-sizing: border-box;\n\n  &--fallback {\n    text-transform: uppercase;\n  }\n}\n\n.personal-hub-blueprint-item {\n  display: flex;\n  align-items: stretch;\n  gap: 0.35rem;\n\n  &--selected .personal-hub-blueprint-item__main {\n    border-color: rgba($light-blue, 0.85);\n    box-shadow: 0 0 0 1px rgba($light-blue, 0.35);\n    background: rgba($accent-blue, 0.28);\n  }\n\n  &--selected .personal-hub-blueprint-item__main--member-owned {\n    border-color: $light-orange;\n    box-shadow: 0 0 0 1px rgba($light-orange, 0.35);\n  }\n\n  &--owned .personal-hub-blueprint-item__main {\n    border-color: rgba($light-green, 0.45);\n  }\n\n  &--owned .personal-hub-blueprint-item__main--member-owned {\n    border-color: $light-orange;\n\n    &:hover {\n      border-color: $light-orange;\n    }\n  }\n\n  &--not-owned .personal-hub-blueprint-item__main {\n    background: rgba($dark-panel-blue, 0.55);\n    border-color: rgba($accent-blue, 0.28);\n  }\n\n  &__main {\n    flex: 1 1 auto;\n    display: grid;\n    grid-template-columns: 42px minmax(0, 1fr);\n    gap: 0.65rem;\n    align-items: start;\n    min-width: 0;\n    padding: 0.55rem 0.65rem;\n    border: 1px solid rgba($accent-blue, 0.28);\n    border-radius: 8px;\n    background: rgba($dark-panel-blue, 0.55);\n    color: inherit;\n    text-align: left;\n    cursor: pointer;\n    transition:\n      border-color 0.15s ease,\n      background 0.15s ease,\n      box-shadow 0.15s ease;\n\n    &:hover {\n      border-color: rgba($light-blue, 0.55);\n      background: rgba($accent-blue, 0.22);\n    }\n\n    &:focus-visible {\n      outline: 2px solid rgba($accent-blue, 0.75);\n      outline-offset: 2px;\n    }\n\n    &--member-owned {\n      border-color: $light-orange;\n\n      &:hover {\n        border-color: $light-orange;\n      }\n    }\n  }\n\n  &__body {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n    min-width: 0;\n  }\n\n  &__copy {\n    display: flex;\n    flex-direction: column;\n    gap: 0.2rem;\n    min-width: 0;\n  }\n\n  &__name {\n    font-size: 0.92rem;\n    font-weight: 700;\n    color: $very-light-grey;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &__meta {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.35rem 0.55rem;\n    font-size: 0.74rem;\n    color: rgba($light-grey, 0.92);\n  }\n\n  &__category {\n    font-weight: 700;\n    color: rgba($very-light-grey, 0.72);\n  }\n\n  &__crafted {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__favorite {\n    flex: 0 0 34px;\n    width: 34px;\n    border: 1px solid rgba($accent-blue, 0.28);\n    border-radius: 8px;\n    background: rgba($dark-blue, 0.35);\n    color: rgba($very-light-grey, 0.55);\n    font-size: 1rem;\n    line-height: 1;\n    cursor: pointer;\n    transition:\n      color 0.15s ease,\n      border-color 0.15s ease,\n      background 0.15s ease;\n\n    &:hover:not(:disabled) {\n      color: $very-light-orange;\n      border-color: rgba($light-orange, 0.55);\n    }\n\n    &--active {\n      color: $light-orange;\n      border-color: rgba($light-orange, 0.65);\n      background: rgba($light-orange, 0.12);\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.45;\n    }\n  }\n}\n\n.personal-hub-blueprint-detail {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  min-height: 0;\n\n  &--has-model {\n    flex: 1 1 auto;\n    min-height: 100%;\n\n    .personal-hub-blueprint-detail__hero,\n    .personal-hub-blueprint-crafting,\n    .personal-hub-blueprint-detail__notes-wrap {\n      flex-shrink: 0;\n    }\n\n    .personal-hub-blueprint-detail__overview {\n      flex: 1 1 auto;\n      min-height: 0;\n      align-items: stretch;\n    }\n  }\n\n  &__hero {\n    display: grid;\n    grid-template-columns: 56px minmax(0, 1fr) auto;\n    gap: 0.85rem;\n    align-items: center;\n    flex-shrink: 0;\n  }\n\n  &__logo {\n    width: 56px;\n    height: 56px;\n    font-size: 1.1rem;\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 1.15rem;\n    color: $very-light-grey;\n  }\n\n  &__subtitle {\n    margin: 0.25rem 0 0;\n    color: rgba($very-light-grey, 0.72);\n    font-size: 0.85rem;\n  }\n\n  &__actions {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 0.45rem;\n    flex-shrink: 0;\n  }\n\n  &__favorite {\n    flex: 0 0 34px;\n    width: fit-content;\n    height: 30px;\n    padding: 0.2rem 0.85rem;\n    border: 1px solid rgba($accent-blue, 0.28);\n    border-radius: 8px;\n    background: rgba($dark-blue, 0.35);\n    color: rgba($very-light-grey, 0.55);\n    font-size: 0.95rem;\n    text-align: left;\n    line-height: 1;\n    cursor: pointer;\n    transition:\n      color 0.15s ease,\n      border-color 0.15s ease,\n      background 0.15s ease;\n\n    &--active {\n      color: $light-orange;\n      border-color: rgba($light-orange, 0.65);\n      background: rgba($light-orange, 0.12);\n    }\n\n    &:hover:not(:disabled) {\n      color: $very-light-orange;\n      border-color: rgba($light-orange, 0.55);\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.55;\n    }\n  }\n\n  &__owned-btn {\n    width: fit-content;\n    min-height: 2rem;\n    white-space: nowrap;\n    padding: 0.3rem 0.95rem;\n    border: 1px solid rgba($accent-blue, 0.5);\n    border-radius: 8px;\n    background: rgba($dark-panel-blue, 0.88);\n    color: $very-light-grey;\n    font-size: 0.92rem;\n    font-weight: 600;\n    text-align: center;\n    cursor: pointer;\n    transition:\n      border-color 0.15s ease,\n      background 0.15s ease,\n      box-shadow 0.15s ease;\n\n    &--active {\n      border-color: rgba($light-green, 0.75);\n      background: rgba($light-green, 0.22);\n      box-shadow: 0 0 0 1px rgba($light-green, 0.25);\n    }\n\n    &:hover:not(:disabled) {\n      border-color: rgba($light-blue, 0.6);\n      background: rgba($accent-blue, 0.28);\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.45;\n    }\n  }\n\n  &__fields {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(14rem, 1fr));\n    gap: 0.75rem 1rem;\n    margin: 0;\n\n    &--beside-model {\n      flex: 1 1 auto;\n      display: flex;\n      flex-direction: column;\n      gap: 0.75rem;\n      min-width: 0;\n      align-self: center;\n    }\n  }\n\n  &__overview {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 1rem;\n  }\n\n  &__model-aside {\n    display: flex;\n    flex-direction: column;\n    flex: 0 0 70%;\n    width: 70%;\n    max-width: 70%;\n    min-height: 0;\n    margin-left: auto;\n    align-self: stretch;\n\n    &.personal-hub-blueprint-detail__model-unavailable {\n      align-self: stretch;\n    }\n\n    .personal-hub-blueprint-model-viewer {\n      display: flex;\n      flex: 1 1 auto;\n      flex-direction: column;\n      min-height: 7rem;\n      height: 100%;\n      max-height: none;\n\n      .personal-hub-blueprint-model-viewer__stack,\n      .personal-hub-blueprint-model-viewer__layer {\n        flex: 1 1 auto;\n        height: 100%;\n        max-height: 100%;\n        min-height: 0;\n      }\n    }\n\n    .personal-hub-blueprint-model,\n    .personal-hub-blueprint-model__stats-panel {\n      flex: 1 1 auto;\n      height: 100%;\n      max-height: 100%;\n      min-height: 0;\n    }\n\n    .personal-hub-blueprint-model {\n      display: flex;\n      flex-direction: column;\n      min-height: 0;\n    }\n\n    .personal-hub-blueprint-model__canvas {\n      flex: 1 1 auto;\n      height: 100%;\n      min-height: 0;\n    }\n  }\n\n  &__field {\n    margin: 0;\n    min-width: 0;\n  }\n\n  &__field-label {\n    margin: 0 0 0.2rem;\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.55);\n  }\n\n  &__field-value {\n    margin: 0;\n    color: rgba($very-light-grey, 0.92);\n    font-size: 0.88rem;\n    line-height: 1.45;\n    word-break: break-word;\n  }\n\n  &__crafting-title {\n    margin: 0 0 0.5rem;\n    font-size: 0.78rem;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.72);\n  }\n\n  &__crafting-list {\n    margin: 0;\n    padding-left: 1.1rem;\n    color: rgba($very-light-grey, 0.88);\n    font-size: 0.85rem;\n    line-height: 1.5;\n  }\n\n  &__notes-wrap {\n    display: flex;\n    flex-direction: column;\n     gap: 0.65rem;\n  }\n\n  &__notes-label {\n    font-size: 0.78rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.82);\n  }\n\n  &__notes {\n    width: 100%;\n    min-height: 45px;\n    padding: 0.65rem 0.75rem;\n    border: 1px solid rgba($accent-blue, 0.35);\n    border-radius: 8px;\n    background: rgba($dark-blue, 0.45);\n    color: $very-light-grey;\n    font: inherit;\n    resize: vertical;\n    box-sizing: border-box;\n\n    &::placeholder {\n      color: rgba($light-grey, 0.75);\n    }\n\n    &:disabled {\n      opacity: 0.65;\n      cursor: not-allowed;\n    }\n  }\n\n  &__model-section {\n    display: flex;\n    flex-direction: column;\n    gap: 0.55rem;\n  }\n\n  &__model-title {\n    margin: 0;\n    font-size: 0.78rem;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.72);\n  }\n\n  &__model-unavailable {\n    margin: 0;\n    padding: 0.75rem 0.85rem;\n    border: 1px dashed rgba($accent-blue, 0.35);\n    border-radius: 10px;\n    color: rgba($very-light-grey, 0.62);\n    font-size: 0.82rem;\n    line-height: 1.45;\n  }\n}\n\n.personal-hub-blueprint-crafting {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 0.85fr);\n  gap: 0.75rem;\n\n  &--missions-only {\n    grid-template-columns: minmax(0, 1fr);\n    max-width: 22rem;\n  }\n\n  &__panel {\n    display: flex;\n    flex-direction: column;\n    gap: 0.55rem;\n    min-width: 0;\n    padding: 0.85rem 0.3rem 0.85rem 0.85rem;\n    border: 1px solid rgba($accent-blue, 0.35);\n    border-radius: 10px;\n    background: rgba($dark-panel-blue, 0.55);\n    position: relative;\n    overflow: visible;\n  }\n\n  &__panel--ingredients {\n    .personal-hub-blueprints-help-row {\n      align-items: center;\n    }\n\n    .help-info-bubble__popover {\n      left: auto;\n      right: 0;\n      width: unquote('min(18rem, calc(100vw - 2.5rem))');\n    }\n  }\n\n  &__panel-title {\n    margin: 0;\n    font-size: 0.70rem;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.72);\n  }\n\n  &__ingredient-list,\n  &__stat-list {\n    display: flex;\n    flex-direction: column;\n    gap: 0.65rem;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    max-height: calc(100vh - 807px);\n    overflow-y: auto;\n    @include factions-reputations-thin-scrollbar;\n  }\n\n  &__ingredient {\n    display: flex;\n    flex-direction: column;\n    gap: 0.45rem;\n    padding: 0.3rem 0.7rem;\n    border: 1px solid rgba($accent-blue, 0.22);\n    border-radius: 8px;\n    background: rgba($dark-blue, 0.35);\n  }\n\n  &__ingredient-copy {\n    display: flex;\n    flex-direction: row;\n    align-items: baseline;\n    flex-wrap: wrap;\n    gap: 0.35rem 0.65rem;\n    min-width: 0;\n  }\n\n  &__ingredient-controls {\n    display: flex;\n    align-items: center;\n    gap: 0.65rem;\n  }\n\n  &__ingredient-title-row {\n    display: flex;\n    align-items: baseline;\n    flex-wrap: wrap;\n    gap: 0.35rem 0.5rem;\n    min-width: 0;\n    flex: 1 1 auto;\n  }\n\n  &__ingredient-slot {\n    flex-shrink: 0;\n    font-size: 0.68rem;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.55);\n    white-space: nowrap;\n  }\n\n  &__ingredient-name {\n    font-size: 0.88rem;\n    font-weight: 700;\n    color: $very-light-grey;\n    word-break: break-word;\n  }\n\n  &__ingredient-qty {\n    font-size: 0.76rem;\n    color: rgba($light-grey, 0.92);\n    white-space: nowrap;\n  }\n\n  &__quality-value {\n    position: relative;\n    bottom: 0.2rem;\n    flex-shrink: 0;\n    width: 3.4rem;\n    padding: 0.15rem 0.35rem;\n    border-radius: 999px;\n    border: 1px solid rgba($accent-blue, 0.35);\n    background: rgba($dark-blue, 0.55);\n    color: $very-light-grey;\n    font-size: 0.78rem;\n    font-weight: 700;\n    text-align: center;\n    font-variant-numeric: tabular-nums;\n\n    &--below-default {\n      color: $medium-light-grey;\n      border-color: rgba($medium-light-grey, 0.45);\n    }\n\n    &--tier-orange {\n      color: $very-light-orange;\n      border-color: rgba($very-light-orange, 0.45);\n    }\n\n    &--tier-green {\n      color: $very-light-green;\n      border-color: rgba($very-light-green, 0.45);\n    }\n\n    &--tier-blue {\n      color: $light-blue;\n      border-color: rgba($light-blue, 0.55);\n    }\n\n    &--tier-purple {\n      color: $very-light-purple;\n      border-color: rgba($very-light-purple, 0.55);\n    }\n\n    &:focus-visible {\n      outline: 2px solid rgba($accent-blue, 0.75);\n      outline-offset: 2px;\n    }\n  }\n\n  &__slider-label {\n    display: block;\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  &__slider {\n    width: 100%;\n    margin: 0;\n    accent-color: $light-blue;\n    cursor: pointer;\n\n    &--below-default {\n      accent-color: $medium-light-grey;\n    }\n\n    &--tier-orange {\n      accent-color: $very-light-orange;\n    }\n\n    &--tier-green {\n      accent-color: $very-light-green;\n    }\n\n    &--tier-blue {\n      accent-color: $light-blue;\n    }\n\n    &--tier-purple {\n      accent-color: $very-light-purple;\n    }\n  }\n\n  &__stat-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.75rem;\n    padding: 0.55rem 0.65rem;\n    border: 1px solid rgba($accent-blue, 0.22);\n    border-radius: 8px;\n    background: rgba($dark-blue, 0.35);\n  }\n\n  &__stat-name {\n    font-size: 0.86rem;\n    color: rgba($very-light-grey, 0.92);\n    line-height: 1.35;\n  }\n\n  &__stat-impact-wrap {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 0.12rem;\n    flex-shrink: 0;\n    text-align: right;\n  }\n\n  &__stat-impact {\n    font-size: 0.86rem;\n    font-weight: 700;\n    font-variant-numeric: tabular-nums;\n\n    &--below-default {\n      color: $medium-light-grey;\n    }\n\n    &--tier-orange {\n      color: $very-light-orange;\n    }\n\n    &--tier-green {\n      color: $very-light-green;\n    }\n\n    &--tier-blue {\n      color: $light-blue;\n    }\n\n    &--tier-purple {\n      color: $very-light-purple;\n    }\n  }\n\n  &__stat-detail {\n    font-size: 0.76rem;\n    font-weight: 600;\n    font-variant-numeric: tabular-nums;\n    color: $light-blue;\n    line-height: 1.2;\n\n    &--solo {\n      font-size: 0.86rem;\n    }\n  }\n\n  &__stat-empty {\n    margin: 0;\n    color: rgba($very-light-grey, 0.62);\n    font-size: 0.82rem;\n    line-height: 1.45;\n  }\n\n  &__mission-list {\n    display: flex;\n    flex-direction: column;\n    max-height: calc(100vh - 920px);\n    gap: 0.55rem;\n    margin: 0;\n    padding: 0;\n    list-style: none;    \n    overflow-y: auto;\n    @include factions-reputations-thin-scrollbar;\n  }\n\n  &__mission-item {\n    display: flex;\n    flex-direction: column;\n    gap: 0.2rem;\n    padding: 0.55rem 0.6rem;\n    border: 1px solid rgba($accent-blue, 0.22);\n    border-radius: 8px;\n    background: rgba($dark-blue, 0.35);\n  }\n\n  &__mission-name {\n    font-size: 0.86rem;\n    font-weight: 600;\n    color: $very-light-grey;\n    line-height: 1.35;\n    word-break: break-word;\n  }\n\n  &__mission-faction {\n    font-size: 0.78rem;\n    font-weight: 600;\n    color: $light-blue;\n    line-height: 1.3;\n    word-break: break-word;\n\n    &--link {\n      align-self: flex-start;\n      margin: 0;\n      padding: 0;\n      border: 0;\n      background: transparent;\n      font: inherit;\n      font-size: 0.78rem;\n      text-align: left;\n      cursor: pointer;\n      text-decoration: none;\n\n      &:hover,\n      &:focus-visible {\n        color: $very-light-grey;\n        text-decoration-color: rgba($very-light-grey, 0.65);\n      }\n\n      &:focus-visible {\n        outline: 2px solid rgba($accent-blue, 0.55);\n        outline-offset: 2px;\n      }\n    }\n  }\n\n  &__mission-empty {\n    margin: 0;\n    font-size: 0.82rem;\n    color: rgba($very-light-grey, 0.55);\n    line-height: 1.45;\n  }\n}\n\n.personal-hub-blueprint-model-viewer {\n  position: relative;\n  width: 100%;\n\n  &__stack {\n    position: relative;\n    width: 100%;\n    height: 100%;\n  }\n\n  &__layer {\n    width: 100%;\n    height: 100%;\n    min-height: 0;\n\n    &--hidden {\n      position: absolute;\n      inset: 0;\n      width: 100%;\n      height: 100%;\n      visibility: hidden;\n      pointer-events: none;\n      opacity: 0;\n      z-index: 0;\n      overflow: hidden;\n    }\n  }\n\n  .personal-hub-blueprint-model__view-toggle {\n    position: absolute;\n    top: 0.55rem;\n    left: 0.55rem;\n    z-index: 4;\n    margin: 0;\n    padding: 0.3rem 0.65rem;\n    border-radius: 999px;\n    border: 1px solid rgba($accent-blue, 0.45);\n    background: rgba($dark-blue, 0.72);\n    color: $very-light-grey;\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    cursor: pointer;\n\n    &:hover {\n      border-color: rgba($light-blue, 0.55);\n      color: $light-blue;\n    }\n\n    &--stats {\n      border-color: rgba($light-blue, 0.55);\n      color: $light-blue;\n    }\n  }\n\n  .personal-hub-blueprint-model__stats-panel {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    gap: 0.3rem;\n    box-sizing: border-box;\n    overflow: hidden;\n    padding: 2.5rem 0.4rem 0.35rem;\n    border: 1px solid rgba($accent-blue, 0.35);\n    border-radius: 10px;\n    background: rgba($dark-panel-blue, 0.72);\n  }\n\n  .personal-hub-blueprint-model__stats-heading {\n    flex-shrink: 0;\n    margin: 0;\n    padding: 0 0.1rem;\n    font-size: 0.62rem;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.6);\n    line-height: 1.2;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .personal-hub-blueprint-model__stat-list {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n    gap: 0;\n    flex: 1 1 auto;\n    min-height: 0;\n    margin: 0;\n    overflow: hidden auto;\n    align-content: start;\n    border: 1px solid rgba($accent-blue, 0.22);\n    border-radius: 6px;\n    background: rgba($dark-blue, 0.28);\n    @include personal-hub-blueprint-thin-scrollbar;\n  }\n\n  .personal-hub-blueprint-model__stat-row {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    align-items: baseline;\n    gap: 0.2rem 0.3rem;\n    min-width: 0;\n    padding: 0.4rem 0.4rem;\n    border-right: 1px solid rgba($accent-blue, 0.14);\n    border-bottom: 1px solid rgba($accent-blue, 0.14);\n\n    &:nth-child(2n) {\n      border-right: none;\n    }\n  }\n\n  .personal-hub-blueprint-model__stat-label {\n    margin: 0;\n    font-size: 0.58rem;\n    font-weight: 700;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.5);\n    line-height: 1.15;\n  }\n\n  .personal-hub-blueprint-model__stat-value {\n    margin: 0;\n    font-size: 0.72rem;\n    font-weight: 600;\n    color: $light-blue;\n    line-height: 1.15;\n    text-align: right;\n    font-variant-numeric: tabular-nums;\n    white-space: nowrap;\n\n    &--below-default {\n      color: $medium-light-grey;\n    }\n\n    &--tier-orange {\n      color: $very-light-orange;\n    }\n\n    &--tier-green {\n      color: $very-light-green;\n    }\n\n    &--tier-blue {\n      color: $light-blue;\n    }\n\n    &--tier-purple {\n      color: $very-light-purple;\n    }\n  }\n\n  .personal-hub-blueprint-model__stats-empty {\n    flex: 1 1 auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0;\n    padding: 0.35rem 0.4rem;\n    font-size: 0.72rem;\n    color: rgba($very-light-grey, 0.55);\n    line-height: 1.35;\n    text-align: center;\n  }\n}\n\n.personal-hub-blueprint-model {\n  position: relative;\n  border: 1px solid rgba($accent-blue, 0.35);\n  border-radius: 10px;\n  overflow: hidden;\n  min-height: 280px;\n\n  &--bg-default {\n    background:\n      radial-gradient(circle at 50% 35%, rgba($accent-blue, 0.18), transparent 62%),\n      rgba($dark-panel-blue, 0.72);\n  }\n\n  &--bg-pale {\n    background:\n      radial-gradient(circle at 50% 35%, rgba($light-blue, 0.14), transparent 65%),\n      linear-gradient(180deg, rgba($light-blue, 0.08), rgba($dark-panel-blue, 0.42));\n  }\n\n  // Gear-loadout admin dataset studio (0x5a626c)\n  &--bg-studio {\n    background: #5a626c;\n  }\n\n  &__bg-pickers {\n    position: absolute;\n    top: 0.55rem;\n    right: 0.55rem;\n    z-index: 3;\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n    padding: 0.25rem;\n    border-radius: 999px;\n    background: rgba($dark-blue, 0.55);\n    border: 1px solid rgba($accent-blue, 0.35);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28);\n  }\n\n  &__bg-picker {\n    width: 22px;\n    height: 22px;\n    margin: 0;\n    padding: 0;\n    border: 2px solid rgba($very-light-grey, 0.45);\n    border-radius: 50%;\n    cursor: pointer;\n    transition:\n      border-color 0.15s ease,\n      box-shadow 0.15s ease,\n      transform 0.15s ease;\n\n    &:hover {\n      border-color: rgba($light-blue, 0.75);\n      transform: scale(1.06);\n    }\n\n    &:focus-visible {\n      outline: 2px solid rgba($accent-blue, 0.75);\n      outline-offset: 2px;\n    }\n\n    &--default {\n      background:\n        radial-gradient(circle at 50% 35%, rgba($accent-blue, 0.22), transparent 62%),\n        rgba($dark-panel-blue, 0.9);\n    }\n\n    &--pale {\n      background:\n        radial-gradient(circle at 50% 35%, rgba($light-blue, 0.35), transparent 65%),\n        rgba($light-blue, 0.12);\n    }\n\n    &--active {\n      border-color: $light-orange;\n      box-shadow: 0 0 0 1px rgba($light-orange, 0.45);\n    }\n  }\n\n  &__proxy-debug {\n    min-width: 58px;\n    height: 22px;\n    padding: 0 0.45rem;\n    border: 1px solid rgba($very-light-grey, 0.5);\n    border-radius: 999px;\n    background: rgba($dark-panel-blue, 0.9);\n    color: rgba($very-light-grey, 0.8);\n    font-size: 0.62rem;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    cursor: pointer;\n\n    &:hover,\n    &.is-active {\n      border-color: $light-orange;\n      color: $light-orange;\n      box-shadow: 0 0 0 1px rgba($light-orange, 0.35);\n    }\n\n    &:focus-visible {\n      outline: 2px solid rgba($accent-blue, 0.75);\n      outline-offset: 2px;\n    }\n  }\n\n  &__canvas {\n    width: 100%;\n    height: 320px;\n    min-height: 280px;\n\n    canvas {\n      display: block;\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  &__status {\n    position: absolute;\n    left: 0.75rem;\n    bottom: 0.65rem;\n    margin: 0;\n    padding: 0.25rem 0.55rem;\n    border-radius: 999px;\n    background: rgba($dark-blue, 0.78);\n    border: 1px solid rgba($accent-blue, 0.35);\n    color: rgba($very-light-grey, 0.88);\n    font-size: 0.78rem;\n    pointer-events: none;\n\n    &--error {\n      color: $bright-red;\n      border-color: rgba($bright-red, 0.45);\n    }\n  }\n}\n\n.personal-hub-blueprint-members-panel {\n  flex: 0 0 0;\n  width: 0;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  color: $very-light-grey;\n  border: 1px solid transparent;\n  border-radius: 10px;\n  background: rgba($very-dark-grey, 0.96);\n  overflow: visible;\n  opacity: 0;\n  pointer-events: none;\n  transition:\n    flex-basis 0.28s cubic-bezier(0.4, 0, 0.2, 1),\n    width 0.28s cubic-bezier(0.4, 0, 0.2, 1),\n    opacity 0.2s ease,\n    border-color 0.2s ease;\n\n  &--open {\n    flex: 0 0 220px;\n    width: 220px;\n    opacity: 1;\n    pointer-events: auto;\n    border-color: rgba($accent-blue, 0.35);\n    z-index: 3;\n  }\n\n  &__title {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.5rem;\n    flex-shrink: 0;\n    padding: 0.65rem 0.75rem 0.45rem;\n    border-bottom: 1px solid rgba($accent-blue, 0.25);\n    user-select: none;\n    border-radius: 10px 10px 0 0;\n    font-size: 0.78rem;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.72);\n    position: relative;\n    z-index: 4;\n    overflow: visible;\n\n    .personal-hub-blueprints-help-row {\n      flex: 1 1 auto;\n      min-width: 0;\n      align-items: center;\n    }\n\n    .help-info-bubble__popover {\n      left: auto;\n      right: 0;\n      width: unquote('min(18rem, calc(100vw - 2.5rem))');\n    }\n\n    strong {\n      font-size: 0.78rem;\n      letter-spacing: 0.06em;\n      text-transform: uppercase;\n      color: rgba($very-light-grey, 0.9);\n    }\n  }\n\n  &__count {\n    font-size: 0.72rem;\n    color: rgba($very-light-grey, 0.55);\n  }\n\n  &__state,\n  &__empty {\n    margin: 0;\n    padding: 0.65rem 0.75rem;\n    color: rgba($very-light-grey, 0.72);\n    font-size: 0.82rem;\n    line-height: 1.45;\n  }\n\n  &__state--error {\n    color: $bright-red;\n  }\n\n  &__list {\n    display: flex;\n    flex-direction: column;\n    gap: 0.15rem;\n    margin: 0;\n    padding: 0.35rem 0.45rem 0.55rem;\n    list-style: none;\n    overflow: auto;\n    max-height: calc(100vh - 520px);\n    @include personal-hub-blueprint-thin-scrollbar;\n  }\n\n  &__item {\n    margin: 0;\n    padding: 0;\n  }\n\n  &__member-btn {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    width: 100%;\n    padding: 5px 8px;\n    border: 1px solid transparent;\n    border-radius: 6px;\n    background: transparent;\n    cursor: pointer;\n    text-align: left;\n    color: inherit;\n\n    &:hover {\n      background: rgba($accent-blue, 0.12);\n      border-color: rgba($accent-blue, 0.25);\n    }\n\n    &:focus-visible {\n      outline: 2px solid rgba($accent-blue, 0.75);\n      outline-offset: 1px;\n    }\n\n    &--blueprint-match {\n      border-color: $light-orange;\n\n      &:hover {\n        border-color: $light-orange;\n      }\n    }\n\n    &--selected {\n      background: rgba($light-orange, 0.14);\n      border-color: rgba($light-orange, 0.55);\n    }\n  }\n\n  &__member-avatar {\n    flex-shrink: 0;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    object-fit: cover;\n\n    &--placeholder {\n      display: inline-block;\n      background: $medium-light-grey;\n      opacity: 0.35;\n    }\n  }\n\n  &__member-name {\n    flex: 1 1 auto;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    color: #afa991;\n    font-size: 0.88rem;\n  }\n\n  &__member-rank {\n    flex-shrink: 0;\n    width: 18px;\n    height: 18px;\n    object-fit: contain;\n  }\n\n  &__member-count {\n    flex-shrink: 0;\n    font-size: 0.72rem;\n    font-weight: 700;\n    color: rgba($very-light-grey, 0.72);\n    font-variant-numeric: tabular-nums;\n  }\n}\n\n.personal-hub-blueprints-help-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.45rem;\n  min-width: 0;\n\n  .personal-hub-blueprint-crafting__panel-title {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n}\n\n@media (max-width: 980px) {\n  .personal-hub-blueprints-card__layout {\n    grid-template-columns: 1fr;\n  }\n\n  .personal-hub-blueprints-card__detail {\n    height: auto;\n    max-height: none;\n  }\n\n  .personal-hub-blueprint-list__scroll {\n    max-height: 280px;\n  }\n\n  .personal-hub-blueprint-crafting {\n    grid-template-columns: 1fr;\n  }\n\n  .personal-hub-blueprint-detail--has-model {\n    min-height: 0;\n\n    .personal-hub-blueprint-detail__overview {\n      flex: none;\n    }\n  }\n\n  .personal-hub-blueprint-detail__overview {\n    flex-direction: column;\n  }\n\n  .personal-hub-blueprint-detail__model-aside {\n    flex: 1 1 auto;\n    width: 100%;\n    max-width: 100%;\n    margin-left: 0;\n\n    .personal-hub-blueprint-model-viewer {\n      min-height: 12rem;\n      max-height: unquote('min(50vh, #{$personal-hub-blueprint-panel-height})');\n    }\n  }\n}\n","/* src/styles/LoadingSpinner.css */\n@import './variables.scss';\n\n.spinner-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 50vh;  /* Prend toute la hauteur de la fenêtre */\n  width: 100%;   /* Prend toute la largeur de la fenêtre */\n  top: 200px;\n}\n\n.loader {\n  position: relative;\n  width: 100px;\n  height: 100px;\n}\n\n.loader:before, .loader:after {\n  content: '';\n  border-radius: 50%;\n  position: absolute;\n  inset: 0;\n  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.3) inset;\n}\n\n.loader:after {\n  box-shadow: 0 2px 0 $red inset;\n  animation: rotate 2s linear infinite;\n}\n\n@keyframes rotate {\n  0% { transform: rotate(0); }\n  100% { transform: rotate(360deg); }\n}\n","// src/styles/tools.scss\n\n@import '../variables.scss';\n\n\n.input-icon-wrapper {\n    position: relative;\n}\n\n.readonly-input {\n    padding-right: 24px;  /* Make space for the icon */\n}\n\n.copy-icon {\n    position: absolute;\n    right: 5px;\n    top: 50%;\n    width: 15px;\n    transform: translateY(-50%);\n    cursor: pointer;\n}\n\n.icon-disabled {\n    opacity: 0.5;\n    pointer-events: none;\n}\n\n.handles {\n    //width: 100%;\n    \n    .scrollable-content {\n        height: 130px;\n        overflow-y: auto;\n      \n        /* Pour les navigateurs WebKit (Safari, Chrome, etc.) */\n        &::-webkit-scrollbar {\n            width: 6px;\n        }\n    \n        &::-webkit-scrollbar-track {\n            background: $very-light-grey;\n        }\n    \n        &::-webkit-scrollbar-thumb {\n            background: $light-grey;\n            border-radius: 4px;\n        }\n    \n        &::-webkit-scrollbar-thumb:hover {\n            background: $red;\n        }\n    }\n\n    .handle-row {\n        display: flex;\n        background: $grey;\n        font-size: 1rem;\n        height: 25px;\n        color: $very-light-grey;\n        border-radius: 6px;\n        margin-top: 10px;\n    \n        &.theader {\n            @include steel-bg(\"../medias/steel.png\");\n            text-transform: uppercase;\n            font-size: 15px;\n            padding-bottom: 1px;\n            color: $very-light-grey;\n            box-shadow: inset -2px -2px 3px rgba(0, 0, 0, 0.5);\n        }\n    \n        &.handle-status {\n            margin-left: 10px;\n        }\n    }\n    \n\n    .handle-cell {\n        display: flex;\n        flex: 1 1 25%;\n        padding: 5px 8px 4px 10px;\n        text-align: left;\n        align-items: center;\n        position: relative;\n\n        &:not(:last-child)::after {\n            content: \"\";\n            position: absolute;\n            right: 0;\n            top: 10%;  // À ajuster selon vos besoins\n            bottom: 10%;  // À ajuster selon vos besoins\n            width: 1px;\n            background-color: $grey;\n        }\n\n        &.handle-cell--small {\n            flex: 0.22;\n            margin: 0;\n        }\n\n        &.handle-cell--medium {\n            flex: 0.5;\n        }\n\n        &.handle-cell--large {\n            flex: 0.7;\n        }\n    }\n}\n\n.handle {\n    margin: 5px 0;\n}\n\n.handle-wrapper {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    width: 100%;\n    gap: 25px;\n    align-items: center;\n    //margin-right: auto;\n    margin-left: auto;\n\n}\n\n.status-icon {\n    width: auto;\n    max-height: 16px;\n}\n\n.edit-icon {\n    cursor: pointer;\n    fill: $light-grey;\n    width: auto;\n    height: 14px;\n    margin-left: 10px;\n\n    &:hover {\n        fill: $red;\n    }\n}\n\n.trash-icon {\n    cursor: pointer;\n    fill: $light-grey;\n    width: auto;\n    height: 16px;\n    margin-left: 10px;\n\n    &:hover {\n        fill: $red;\n    }\n}\n\n\n.input-handle {\n    margin-top:  10px;\n    margin-right: auto;\n    margin-left: auto;\n    margin-bottom: 10px;\n\n    .readonly-input,\n    .handle-field {\n        padding: 5px;\n    }\n\n    .handle-lockfield {\n        background: #93a8c1;\n        padding: 5px;\n    }\n}\n\n.handle-generate-token,\n.btn-style-handle {\n    display: flex;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    margin-top:  10px;\n    margin-right: auto;\n    margin-left: auto;\n    margin-bottom: 10px;\n}\n\n.accounts-container {\n    display: flex;\n}\n\n.handle-confirm-message {\n  margin-top: 10px;\n  padding: 8px 12px;\n  border-radius: 4px;\n  font-weight: 600;\n  text-align: center;\n  letter-spacing: 0.02em;\n\n    &.success {\n        background: rgba(0, 200, 80, 0.15);\n        border: 1px solid $light-green;\n        color: $light-green;\n    }\n\n    &.error {\n        background: rgba(220, 40, 40, 0.15);\n        border: 1px solid $red;\n        color: $red;\n    }\n}\n\n\n.discord-account {\n    display: flex;\n    position: relative;\n    align-items: center;\n    height: max-content;\n    width: max-content;\n    min-width: 200px;\n    padding: 0;\n    padding-right: 20px;\n    margin-top: 35px;\n    margin-left: 30px;\n    border-radius: 8px;\n    cursor: pointer;\n    \n\n    .icon-container {\n        width: 50px;\n        height: 30px;\n        overflow: hidden;\n        position: relative;\n        margin-bottom: 5px;\n        \n\n        .icon-image {\n            top: 4px;\n            width: 25px; \n            height: auto; \n\n            &.linked {\n                object-fit: cover; \n                border-radius: 50%; \n                overflow: hidden; \n                border: 1px solid $dark-grey;\n            }\n\n            &.unlinked  {\n                top: 6px;\n                width: 27px; \n                height: auto; \n                overflow: hidden; \n                border-radius: unset; \n            }\n        }\n    }\n\n    .discord-label {\n        display: flex;\n        width: 100px;\n        text-align: left;\n    }\n\n    .refresh-icon {\n        display: none; \n        position: absolute;\n        right: 12px;\n        bottom: 7px;\n        width: auto;\n        height: 23px;\n        vertical-align: middle;\n        transition: transform 1s ease-in-out;\n    }\n\n    &:hover .refresh-icon {\n        display: inline-block;\n        animation: rotate-icon 2s infinite linear;\n        cursor: pointer;\n    }\n\n    @keyframes rotate-icon {\n        0% { transform: rotate(0deg); }\n        25% { transform: rotate(180deg); }\n        50% { transform: rotate(180deg); }\n        75% { transform: rotate(360deg); }\n        100% { transform: rotate(360deg); }\n    }\n}\n\n\n\n.discord-account:hover {\n    //background-image: none;\n    color: white;\n    background-color: #5865F2 ;\n}\n\n// extension setting\n//\n\n.extension-token  {\n    background-color: $light-grey;\n    vertical-align: top;\n    //margin-left: 20px;\n    padding: 5px 25px 5px 5px;\n    width: 280px;\n    height: 100px;\n    word-wrap: break-word;\n    resize: none;\n  }\n\n.textarea-container {\n    display: flex;\n    position: relative;\n    margin-top: 20px;\n    gap: 15px;\n}\n\n.copy-key-icon {\n    display: flex;\n    position: relative;\n    padding: 10px 0;\n    align-self: start;\n    //top: 12px;\n    right: 35px;\n    width: 15px;\n    //transform: translateY(-50%);\n    cursor: pointer;\n}\n\n.btn-download-extension {\n    display: flex;\n    align-items: center;\n    width: 450px;\n    gap: 12px;\n    right: 15px;\n    margin: auto;\n    padding: 10px 14px;\n    border: 2px solid $dark-grey;\n    border-radius: 8px;\n    cursor: pointer;\n\n    &:hover {\n        border: 2px solid rgba(62, 125, 155, 0.329);\n        box-shadow: 3px 2px inset rgba(67, 134, 165, 0.229);\n    }\n\n    transition:\n        border-color 0.2s ease,\n        background-color 0.2s ease;\n\n    &-icon {\n        width: auto;\n        height: 80px;\n        flex-shrink: 0;\n    }\n\n    &-text {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        line-height: 1.2;\n        margin: 5px 5px auto 5px;\n    }\n\n    &-title {\n        font-size: 16px;\n        font-weight: 600;\n        color: $very-light-grey;\n    }\n\n    &-subtitle {\n        margin-top: 7px;\n        font-size: 14px;\n        color: $light-grey;\n        opacity: 0.85;\n    }\n}\n","// src/styles/tools/richeTextEditor.scss\n\n@import '../variables.scss';\n\n\n//custom rte\n.e-richtexteditor {\n    width: initial !important;\n    margin: 10px 15px;\n}\n\n.e-richtexteditor .e-toolbar-wrapper {\n  position: sticky !important;\n  top: 90px !important;\n  overflow: visible;\n  max-height: 87px;\n  z-index: 1001 !important;\n\n  &.shortBloc {\n    max-height: 45px !important;\n  }\n}\n\n.e-toolbar {\n    background-image: linear-gradient(to bottom, $dark-red, $very-dark-grey, $very-dark-grey, $dark-grey, $grey, $dark-grey, $very-dark-grey, $dark-red );\n    border: 1px none rgba(0, 0, 0, 0.12);\n    box-shadow: none;\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n}\n\n.e-richtexteditor .e-toolbar-wrapper .e-rte-toolbar:not(.e-rte-tb-float) {\n    border-bottom: 1px solid $grey;\n}\n\n.e-control, .e-richtexteditor {\n  &.withemojipicker {\n    bottom: 600px;\n  }\n\n}\n\n// toolbar buttons\n.e-toolbar .e-toolbar-item .e-tbar-btn {\n    background: transparent;\n    box-shadow: none;\n    color: $light-grey;\n    border: none;\n\n    &:hover {\n        color: $very-light-grey;\n    }\n}\n\n.e-dropdown-popup {\n    background: $grey;\n    color: $light-grey;\n    border-radius: 6px;\n}\n\n.e-toolbar .e-toolbar-item .e-tbar-btn:active {\n    color: $very-light-grey;\n    border-color: #bdbdbd;\n    color: $very-light-grey;\n}\n\n.e-richtexteditor .e-rte-toolbar .e-toolbar-item .e-dropdown-btn.e-active {\n    background: rgba(0, 0, 0, 0.12);\n    color: $very-light-grey;\n    border-color: inherit;\n}\n\n.e-richtexteditor .e-rte-toolbar .e-toolbar-item .e-dropdown-btn.e-active .e-icons, .e-richtexteditor .e-rte-toolbar .e-toolbar-item .e-dropdown-btn.e-active .e-rte-dropdown-btn-text {\n    color: $very-light-grey;\n}\n\n.e-dropdown-popup ul .e-item.e-active {\n    background: $grey;\n    color: $very-light-grey;\n}\n\n// toolbar icons\n.e-richtexteditor .e-rte-toolbar .e-toolbar-item .e-icons {\n    color: $light-grey !important;\n    &:hover {\n        color: $very-light-grey;\n    }\n}\n\n.e-richtexteditor .e-rte-toolbar .e-toolbar-item.e-active .e-tbar-btn .e-icons, .e-richtexteditor .e-rte-toolbar .e-toolbar-item.e-active .e-tbar-btn:focus .e-icons {\n    color: $very-light-grey;\n}\n\n.e-toolbar .e-toolbar-item .e-tbar-btn:hover .e-icons {\n    color: $very-light-grey;\n}\n\n.e-toolbar .e-toolbar-item.e-separator {\n    border: solid $grey;\n    border-width: 0 2px 0 0;\n}\n\n.e-richtexteditor .e-rte-toolbar .e-toolbar-item.e-overlay .e-tbar-btn .e-icons {\n    color: $very-light-grey;\n}\n\n.e-toolbar .e-toolbar-item.e-overlay {\n    background: #0000002e;\n    opacity: 0.5;\n    color: rgba(0, 0, 0, 0.26);\n}\n\n// toolbar background\n.e-toolbar .e-toolbar-items {\n    background: transparent;\n}\n\n.e-richtexteditor .e-rte-content, .e-richtexteditor .e-source-content {\n    background: $dark-grey !important;\n    border-left: 1px solid $dark-red;\n    border-right: 1px solid $dark-red;\n    border-bottom: 1px solid $dark-red;\n    color: $very-light-grey;\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px;\n    z-index: 1000 !important;\n\n}\n\n.e-richtexteditor .e-rte-content .e-content, .e-richtexteditor .e-source-content .e-content {\n  font-size: 15px;\n  line-height: 20px;\n  color: $very-light-grey;\n}\n\n.org-rank-rte,\n.org-welcome-rte {\n  .e-richtexteditor .e-rte-content .e-content, .e-richtexteditor .e-source-content .e-content {\n    height: 155px;\n    color: $very-light-grey;\n  }\n}\n\n.org-event-rte,\n.org-welcome-rte {\n  .e-richtexteditor .e-rte-content .e-content, .e-richtexteditor .e-source-content .e-content {\n    height: 450px;\n    color: $very-light-grey;\n  }\n}\n\n.org-create-event-rte {\n  .e-richtexteditor .e-rte-content .e-content, .e-richtexteditor .e-source-content .e-content {\n    height: 350px;\n    color: $very-light-grey;\n  }\n}\n\n.e-rte-image.e-imginline, .e-rte-audio.e-audio-inline, .e-rte-video.e-video-inline {\n  padding-left: 3px;\n  padding-right: 3px;\n}\n\n.e-rte-image.e-imgcenter, .e-rte-video.e-video-center {\n  cursor: pointer;\n  display: block;\n  float: none;\n  margin: 5px auto;\n  max-width: 100%;\n  position: relative;\n\n    // Pour les tablettes et mobiles\n    @media (max-width: $tablet) {\n      width: 95% !important; // Hauteur pour mobile et tablette en portrait\n  \n      @media (orientation: landscape) {\n        width: 95% !important; // Hauteur pour mobile et tablette en paysage\n      }\n    }\n}\n\n.e-rte-anchor {\n  color: $bright-red;\n  text-decoration: none;\n\n    :hover {\n      text-decoration: underline;\n    }\n\n}\n\n/* Styles pour le contenu de la modal */\n.e-rte-image-custom-modal-content {\n  display: flex;\n  position: absolute;\n  background: $very-dark-grey;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n  max-width: 100%; // Augmente légèrement la largeur maximale\n  max-height: 100%; // Augmente légèrement la hauteur maximale\n  border: 3px solid $light-grey;\n  border-radius: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  top: 50%; // Centre verticalement\n  left: 50%; // Centre horizontalement\n  transform: translate(-50%, -50%); // Centre parfaitement\n}\n\n/* Styles pour l'overlay */\n.e-rte-image-custom-modal-overlay {\n  background: rgba(9, 37, 56, 0.75); // Couleur de l'overlay\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Conteneur pour le contenu de la modal */\n.modal-content-wrapper {\n  max-width: 95vh; // Largeur maximale de la modal\n  max-height: 85vh; // Hauteur maximale de la modal augmentée\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px; // Espacement autour du contenu\n  overflow: hidden; // Empêche le débordement\n}\n\n/* Styles pour l'image */\n.modal-image {\n  max-width: -webkit-fill-available;\n  max-height: 100%;\n  object-fit: contain; // Assure que l'image garde ses proportions\n  display: block; // Centre l'image dans son conteneur\n}\n\n\n//RTE\n//\n\n.public-rte-content-container {\n  max-width: 930px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  padding: 0.5rem;\n  margin-left: auto;\n  margin-right: auto;\n  border: none;\n  border-radius: 6px;\n}\n\n.rte-content-container {\n  display: grid;\n  width: 98%;\n  max-width: 1000px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  padding: 0.5rem;\n  margin-left: auto;\n  margin-right: auto;\n  border: 1px solid #9c99a3;\n  border-radius: 6px;\n}\n\n.status-radio-buttons {\n  display: flex;\n  gap: 20px;\n  margin-left: 20px;\n  margin-top: 10px;\n  margin-bottom: 5px;\n  font-size: 0.9rem;\n}\n\n.status-radio-buttons label {\n  color: $light-grey;\n  cursor: pointer;\n}\n\n.status-radio-buttons label.selected {\n  color: whitesmoke;\n}\n\n.rte-menu-btn {\n  position: relative;\n  margin-left: 20px;\n  z-index: 10;\n}\n\n.e-rte-img-caption .e-img-wrap {\n  display: inline-block;\n  margin: auto;\n  padding: 0;\n  width: 100%;\n}\n\n.e-rte-image.e-imgright, .e-rte-video.e-video-right {\n  float: right;\n  margin: 0 auto;\n  margin-left: 5px;\n  text-align: right;\n}\n.e-rte-image.e-imginline, .e-rte-audio.e-audio-inline, .e-rte-video.e-video-inline {\n  margin-left: 5px;\n  margin-right: 5px;\n  display: inline-block;\n\n  max-width: 100%;\n  padding: 1px;\n  vertical-align: bottom;\n}\n\n.e-rte-image.e-imgleft, .e-rte-video.e-video-left {\n  float: left;\n  margin: 0 auto;\n  margin-right: 5px;\n  text-align: left;\n}\n\n.e-rte-image.e-imginline, .e-rte-audio.e-audio-inline, .e-rte-video.e-video-inline {\n  margin-left: 5px;\n  margin-right: 5px;\n  display: inline-block;\n\n  max-width: 100%;\n  padding: 1px;\n  vertical-align: bottom;\n}\n\n.e-rte-image.e-imgbreak, .e-rte-audio.e-audio-break, .e-rte-video.e-video-break {\n  border: 0;\n  cursor: pointer;\n  display: block;\n  float: none;\n  max-width: 100%;\n  padding: 1px;\n  position: relative;\n}\n\n.public-container img {\n  text-align: center;\n}\n.e-rte-image, .e-rte-audio, .e-rte-video {\n  border: 0;\n  cursor: pointer;\n  display: block;\n  float: none;\n  margin: auto;\n  max-width: 100% !important;\n  position: relative;\n}\n\n.ReactModal__Overlay.ReactModal__Overlay--after-open {\n  z-index:15;\n  background-color: rgba(78, 75, 75, 0.5) !important;\n}\n\n.e-richtexteditor .e-toolbar-wrapper.e-rte-tb-float, .e-richtexteditor .e-toolbar-container.e-rte-tb-float {\n  position: sticky !important;\n  top: 90px !important;\n  overflow: visible;\n  max-height: 87px;\n  z-index: 1001 !important;\n\n  &.shortBloc {\n    max-height: 45px !important;\n  }\n}\n\n\n.e-richtexteditor .e-toolbar-wrapper.e-rte-tb-float .e-rte-toolbar {\n  border-top: 1px solid rgba(0, 0, 0, 0.12);\n}\n\n.e-richtexteditor .e-rte-toolbar .e-toolbar-multirow {\n  margin-left: 7px;\n  margin-right: 7px;\n}\n\n.e-toolbar .e-toolbar-items.e-toolbar-multirow .e-toolbar-item:not(.e-separator) {\n  margin: 0;\n}\n.e-toolbar .e-toolbar-item:not(.e-separator):not(.e-spacer) {\n  height: inherit;\n  min-width: 34px;\n  padding: 3.5px;\n}\n.e-toolbar .e-toolbar-item {\n  -ms-flex-line-pack: center;\n  align-content: center;\n  -ms-flex-align: center;\n  align-items: center;\n  cursor: pointer;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  min-height: 42px;\n  vertical-align: middle;\n  width: auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n\n.e-richtexteditor .e-toolbar .e-toolbar-item .e-tbar-btn, .e-richtexteditor .e-toolbar.e-extended-toolbar .e-toolbar-extended.e-toolbar-pop .e-toolbar-item .e-tbar-btn {\n  font-size: 14px;\n}\n\n.e-toolbar .e-toolbar-item .e-tbar-btn {\n  //background: #fafafa;\n  box-shadow: none;\n  //color: rgba(0, 0, 0, 0.87);\n  border: none;\n}\n\n.e-toolbar .e-toolbar-item .e-tbar-btn {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n  vertical-align: middle;\n  -ms-flex-pack: center;\n  justify-content: center;\n  margin: 4px 0;\n  min-height: 0;\n  min-width: 0;\n  padding: 0 1.5px;\n  border-radius: 2px;\n  line-height: 25px;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 400;\n  overflow: hidden;\n  text-align: center;\n  text-decoration: none;\n  text-transform: none;\n}\n\n.e-toolbar .e-toolbar-item > * {\n  text-overflow: ellipsis;\n}\n\n.e-btn.e-icon-btn, .e-css.e-btn.e-icon-btn {\n  padding: 6px 7px 4px;\n}\n\n.e-control, .e-control [class^=e-], .e-control [class*=\" e-\"] {\n  box-sizing: border-box;\n  @include scrollbar-styles;\n}\n\n.e-btn, .e-css.e-btn {\n  -webkit-tap-highlight-color: transparent;\n  background: #fafafa;\n  border-color: transparent;\n  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n  color: rgba(0, 0, 0, 0.87);\n  transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n.e-btn, .e-css.e-btn {\n  -webkit-font-smoothing: antialiased;\n  border: 1px solid;\n  border-radius: 2px;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: inline-block;\n  font-family: \"Lato\", \"Verdana\", \"sans-serif\", \"-apple-system\", \"BlinkMacSystemFont\";\n  font-size: 14px;\n  font-weight: 500;\n  -ms-flex-pack: center;\n  justify-content: center;\n  line-height: 1.143em;\n  outline: none;\n  padding: 6px 12px 4px;\n  text-align: center;\n  text-decoration: none;\n  text-transform: uppercase;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n\n.e-control, .e-css {\n  font-family: \"Lato\", \"Verdana\", \"sans-serif\", \"-apple-system\", \"BlinkMacSystemFont\";\n  font-size: 12px;\n  font-weight: normal;\n}\n\n.e-richtexteditor.e-disabled {\n  pointer-events: none;\n}\n\n.e-disabled {\n  background-image: none;\n  cursor: default;\n  filter: alpha(Opacity = 35);\n  opacity: 0.35;\n}\n\n.e-richtexteditor .e-rte-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn .e-order-list.e-icons, .e-richtexteditor .e-rte-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn .e-unorder-list.e-icons, .e-richtexteditor .e-rte-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn .e-icons.e-btn-icon:not(.e-caret), .e-richtexteditor .e-rte-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn .e-order-list.e-icons, .e-richtexteditor .e-rte-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn .e-unorder-list.e-icons, .e-richtexteditor .e-rte-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn .e-icons.e-btn-icon:not(.e-caret), .e-richtexteditor .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn .e-order-list.e-icons, .e-richtexteditor .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn .e-unorder-list.e-icons, .e-richtexteditor .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn .e-icons.e-btn-icon:not(.e-caret), .e-richtexteditor .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn .e-order-list.e-icons, .e-richtexteditor .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn .e-unorder-list.e-icons, .e-richtexteditor .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-tbar-btn .e-icons.e-btn-icon:not(.e-caret) {\n  font-size: 14px;\n}\n\n.e-toolbar .e-toolbar-item .e-tbar-btn .e-icons.e-btn-icon {\n  margin: 0;\n  min-width: 24px;\n  width: auto;\n  font-size: 14px;\n  line-height: 25px;\n}\n\n.e-icons {\n  font-family: \"e-icons\";\n  /* font-style: normal; */\n  font-variant: normal;\n  font-weight: normal;\n  line-height: 1;\n  text-transform: none;\n}\n\n.e-dropdown-btn .e-caret, .e-dropdown-btn.e-btn .e-caret {\n  font-size: 8px;\n}\n\n.e-dropdown-btn .e-btn-icon, .e-dropdown-btn.e-btn .e-btn-icon {\n  font-size: 14px;\n}\n\n.e-dropdown-btn, .e-dropdown-btn.e-btn {\n  box-shadow: none;\n  text-transform: none;\n  white-space: normal;\n}\n\n.e-dropdown-btn .e-caret::before, .e-dropdown-btn.e-btn .e-caret::before {\n  content: \"\\e969\";\n}\n\n\n.e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-items .e-toolbar-item .e-rte-fontcolor-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-items .e-toolbar-item .e-rte-backgroundcolor-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-items .e-toolbar-item .e-rte-numberformatlist-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-items .e-toolbar-item .e-rte-bulletformatlist-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar .e-toolbar-items .e-toolbar-item .e-rte-fontcolor-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar .e-toolbar-items .e-toolbar-item .e-rte-backgroundcolor-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar .e-toolbar-items .e-toolbar-item .e-rte-numberformatlist-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar .e-toolbar-items .e-toolbar-item .e-rte-bulletformatlist-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-rte-fontcolor-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-rte-backgroundcolor-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-rte-numberformatlist-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-rte-bulletformatlist-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar .e-toolbar-extended .e-toolbar-item .e-rte-fontcolor-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar .e-toolbar-extended .e-toolbar-item .e-rte-backgroundcolor-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar .e-toolbar-extended .e-toolbar-item .e-rte-numberformatlist-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon, .e-rte-toolbar.e-toolbar .e-toolbar-extended .e-toolbar-item .e-rte-bulletformatlist-dropdown.e-dropdown-btn.e-tbar-btn.e-btn.e-control .e-icons.e-btn-icon {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -ms-flex-pack: center;\n    justify-content: center;\n    line-height: 25px;\n    min-width: 18px;\n    text-align: center;\n    width: 18px;\n}\n\n.e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-items .e-toolbar-item .e-dropdown-btn.e-tbar-btn .e-icons.e-btn-icon.e-caret, .e-rte-toolbar.e-toolbar .e-toolbar-items .e-toolbar-item .e-dropdown-btn.e-tbar-btn .e-icons.e-btn-icon.e-caret, .e-rte-toolbar.e-toolbar.e-extended-toolbar .e-toolbar-extended .e-toolbar-item .e-dropdown-btn.e-tbar-btn .e-icons.e-btn-icon.e-caret, .e-rte-toolbar.e-toolbar .e-toolbar-extended .e-toolbar-item .e-dropdown-btn.e-tbar-btn .e-icons.e-btn-icon.e-caret {\n  font-size: 12px;\n}\n\n.e-dropdown-popup {\n  background: $grey;\n  color: $light-grey;\n}\n\n.e-dropdown-popup ul .e-item {\n  cursor: pointer;\n  display: -ms-flexbox;\n  display: flex;\n  height: 36px;\n  line-height: 36px;\n  padding: 0 16px;\n}\n\n.e-dropdown-popup ul {\n  border: none;\n  border-radius: 0;\n  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);\n  box-sizing: border-box;\n  font-size: 14px;\n  font-weight: normal;\n  list-style-image: none;\n  list-style-position: outside;\n  list-style-type: none;\n  margin: 0;\n  min-width: 120px;\n  overflow: hidden;\n  padding: 8px 0;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  white-space: nowrap;\n}\n\n.e-dropdown-popup ul .e-item:hover {\n  background: #e0e0e0;\n  color: rgba(0, 0, 0, 0.87);\n}\n\n.e-toolbar .e-toolbar-items.e-toolbar-multirow {\n  margin-bottom: 1px;\n  margin-left: 18px;\n  margin-right: 18px;\n  white-space: normal;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.e-toolbar .e-toolbar-items {\n  border-radius: 0 0 0 0;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  height: 100%;\n  vertical-align: middle;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.e-toolbar {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  //background: #fafafa;\n  border: 1px none rgba(0, 0, 0, 0.12);\n  box-shadow: none;\n}\n\n.e-toolbar {\n  border-radius: 0;\n  display: block;\n  height: 42px;\n  min-height: 42px;\n  position: relative;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.e-richtexteditor {\n  color: #333;\n  display: block;\n  position: relative;\n}\n\n.e-toolbar .e-toolbar-item.e-separator {\n  margin: 7.5px 3px;\n  min-height: 27px;\n  min-width: 1px;\n  height: calc(100% - 15px);\n}\n\n.e-toolbar {\n  border-radius: 0;\n  display: block;\n  height: 42px;\n  min-height: 42px;\n  position: relative;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.e-richtexteditor .e-rte-hidden {\n  display: none;\n}\n\n.e-richtexteditor {\n  color: #333;\n  display: block;\n  position: relative;\n}\n\n// Emojis\n\n.rte-emoji {\n  width: 19px ;\n  height: 19px;\n  padding: 0 ;\n  margin: 0 ;\n  bottom: 3px;\n}\n\n\n.emojis-category svg {\n  fill: $light-grey;\n  width: 19px ;\n  height: 19px;\n  top: 1px;\n  bottom: 1px;\n\n  &:hover {\n    fill: white;\n  }\n}\n\n.emoji-picker-searchbox {\n  margin: 5px;\n  padding: 2px 5px 2px 5px;\n}\n\n\n.e-rte-quick-popup .e-rte-quick-toolbar {\n  background: $very-dark-grey !important;\n  border: 3px solid $dark-red !important;\n  min-height: 42px  !important;\n  border-radius: 6px  !important;\n}\n\n.e-rte-quick-popup .e-rte-quick-toolbar .e-toolbar-items {\n  background: $very-dark-grey !important;\n}\n\n.e-rte-quick-popup .e-rte-quick-toolbar .e-toolbar-items .e-tbar-btn {\n  background: $very-dark-grey !important;\n}\n\n.e-rte-quick-popup .e-rte-quick-toolbar .e-toolbar-items .e-icons {\n  color: $very-light-grey !important;\n}\n\n\n\n// RTE MODALS\n\n// Publish check modals\n\n.modal.publish-check {\n  position: fixed;\n  z-index: 1050;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: rgba(0, 0, 0, 0.75); // Couleur de fond semi-transparente\n\n  // Contenu du modal\n  .modal-content.publish-check {\n    display: block; \n    position: relative;\n    background-color: $very-dark-grey;\n    height: 190px;\n    margin: 20% auto; // Centrer le modal sur la page\n    padding: 20px;\n    border-radius: 5px;\n    width: 80%; // Largeur du modal\n    max-width: 600px; // Largeur maximale pour les grands écrans\n    border: 1px solid $grey;\n\n    p.publish-check {\n      margin-top: 30px;\n      color: $very-light-grey; // Couleur du texte\n      font-family: 'Arial', sans-serif; // Police du texte\n      font-size: 18px; // Taille de la police\n      text-align: center; // Texte centré\n    }\n\n    label {\n      display: block; // Assurez que la checkbox soit sur une nouvelle ligne\n      margin-top: 10px; // Espace au-dessus de la checkbox\n      color: $very-light-grey; // Couleur de la label\n      text-align: center; // Centrer le texte de la label\n\n      input[type=\"checkbox\"] {\n        margin-right: 10px; // Espace entre la checkbox et son label\n      }\n    }\n\n    // Boutons\n    .modal.btns-publish-check {\n      display: flex;\n      position: relative;\n      flex-direction: row; // Organise les boutons en ligne\n      justify-content: center; // Centre les boutons horizontalement\n      height: fit-content;\n      width: 100%; // Permet aux boutons de s'étendre sur toute la largeur du modal\n      margin-top: 20px; // Espace entre les boutons et le texte/label au-dessus\n      background-color: transparent;\n\n      button.btn-style1 {\n        margin: 0 10px; // Espacement entre les boutons\n        padding: 10px 20px;\n        height: fit-content;\n        border: none;\n        border-radius: 5px;\n        cursor: pointer;\n      }\n    }\n  }\n\n/* Modal toggle — sizes loosely aligned with `$toggle-*` in variables.scss (wider for RTE modal). */\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 25px;\n  margin-left: 10px; // Un peu d'espace après le texte\n\n  & input { \n    opacity: 0;\n    width: 0;\n    height: 0;\n  }\n\n  .slider {\n    position: absolute;\n    cursor: pointer;\n    top: 5px;\n    left: 0;\n    right: 5px;\n    bottom: -5px;\n    background-color: #ccc;\n    transition: .4s;\n    border-radius: 34px;\n\n    &:before {\n      position: absolute;\n      content: \"\";\n      height: 20px;\n      width: 20px;\n      left: 4px;\n      bottom: 3px;\n      background-color: white;\n      transition: .4s;\n      border-radius: 50%;\n    }\n  }\n\n  input:checked + .slider {\n    background-color: $red;\n  }\n\n  input:focus + .slider {\n    box-shadow: 0 0 1px #2196F3;\n  }\n\n  input:checked + .slider:before {\n    transform: translateX(26px);\n  }\n}\n\n}\n\n@media (max-width: $tablet) {\n\n  .rte-emoji.e-rte-image.e-imginline {\n    width: 17px !important;\n    height: 17px !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n\n  .e-rte-image.e-imgright.e-imginline, .e-rte-image.e-imgleft.e-imginline {\n    max-width: 100%; /* Limite la largeur maximum sans forcer la largeur à 100% */\n    height: auto;   }\n\n   /* Adapter les autres images, audios, et vidéos à la largeur du conteneur */\n   .e-rte-image.e-imginline, \n   .e-rte-audio.e-audio-inline, \n   .e-rte-video.e-video-inline {\n     width: 100% !important; /* Force la largeur à 100% du conteneur */\n     height: auto !important; /* Ajuste la hauteur automatiquement pour maintenir le ratio */\n     bottom: 3px;\n   }\n\n   .e-rte-image.e-imgleft, .e-rte-video.e-video-left {\n    float: left;\n    margin: 0 auto;\n    margin-right: 5px;\n    text-align: left;\n    width: 100% !important; /* Force la largeur à 100% du conteneur */\n    height: auto !important; /* Ajuste la hauteur automatiquement pour maintenir le ratio */\n  }\n\n}\n\nul {\n  list-style-type: disc; /* style pour les listes non ordonnées */\n  margin: 0;\n  color: #b1b1b1;\n  // padding: 0;\n}\n\nol {\n  list-style-type: decimal; /* style pour les listes ordonnées */\n  margin: 0;\n  color: #b1b1b1;\n  // padding: 0;\n}\n\np {\n  margin-bottom: 0;\n  color: #b1b1b1;\n}\n\n.e-richtexteditor .e-rte-content .e-content blockquote, .e-richtexteditor .e-source-content .e-content blockquote {\n  margin: 10px 0;\n  color: #b1b1b1;\n  padding: 15px;\n  position: relative;\n\n  &::before,\n  &::after {\n    content: \"\";\n    position: absolute;\n    border: 3px solid $grey; // Utilisation de la variable $grey\n    border-radius: 6px 0;\n  }\n\n  &::before {\n    top: -3px; // Ajustement pour couvrir le padding\n    left: -3px; // Ajustement pour couvrir le padding\n    width: 50%;\n    height: 50%;\n    border-right: none;\n    border-bottom: none;\n  }\n\n  &::after {\n    bottom: -3px; // Ajustement pour couvrir le padding\n    right: -3px; // Ajustement pour couvrir le padding\n    width: 50%;\n    height: 50%;\n    border-left: none;\n    border-top: none;\n  }\n}\n\n.e-richtexteditor .e-rte-content .e-content pre, \n.e-richtexteditor .e-source-content .e-content pre {\n  background-color: $very-dark-grey !important;\n  border-left: 5px solid $dark-red!important;\n  border: none; // Supprime les autres bordures\n  border-radius: 6px; // Ajoute un léger arrondi aux coins\n  color: #b1b1b1 !important;\n  font-size: inherit;\n  line-height: inherit;\n  margin: 0 0 10px;\n  overflow: visible;\n  padding: 15px !important;\n  white-space: pre-wrap;\n  word-break: inherit;\n  word-wrap: break-word;\n  position: relative;\n  font-family: 'Input', monospace !important;\n}","@import './variables.scss';\n\n/*  -------------------------------------------------------------  */\n/* HEADER BAR */\n.header-root {\n  position: relative;\n  z-index: 5;\n  width: 100%;\n\n  &--user-tooltip-open {\n    z-index: 70;\n  }\n}\n\n.header-bar {\n  position: fixed;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  background: linear-gradient(rgba(1, 39, 77, 0.876), rgba(1, 6, 8, 0.8)), url('../medias/steel.png');\n  background-repeat: no-repeat;\n  background-size: cover;\n  //background-blend-mode: overlay; /* Assure la fusion du dégradé et de l'image */\n  border-bottom: 4px solid rgba(0, 0, 0, 0);\n  border-image-source: var(--nav-background-image);\n  border-image-slice: 1;\n  border-image-repeat: repeat;\n  transition: top 0.4s;\n  z-index: 4;\n\n  .header-container {\n    display: flex; // Active Flexbox\n    align-items: center; // Centre les éléments verticalement\n    width: 100%; // Prend toute la largeur de la barre\n    //max-width: $desktop; // Largeur maximale\n    z-index: 4;\n    //@include width;\n    width: 1500px;\n\n    .header {\n      width: 350px;\n      display: flex;\n      align-items: center;\n      transform: translate(-50px, 27px);\n      z-index: 5;\n\n      .logo {\n        width: auto;\n        z-index: 5;\n        transform: translate(90px, 3px);\n\n        img {\n          width: 45px;\n          height: auto;\n        }\n      }\n\n      .brand {\n        margin-left: 10px;\n        background: linear-gradient(to right, #d10505, #96989b, #96989b , #d10505);\n        font-size: 1.5rem;\n        font-family: 'GoodTimes', sans-serif;\n        background-clip: text;\n        -webkit-background-clip: text;\n        -webkit-text-fill-color: transparent;\n        background-size: 200% 200%; // Ajouté pour l'animation\n        animation: text-gradient-animation 7s infinite linear;\n        z-index: 5;\n        transform: translate(90px, 0px);\n      }\n\n      .brand span:first-child {\n        margin-right: 7px; /* Ajustez l'espacement entre 'PALLAS' et 'INVICTUS' */\n      }\n      \n    }\n\n    .menu {\n      position: relative;\n      flex-grow: 1; // Prend l'espace restant\n      display: flex;\n      justify-content: flex-start;\n      //margin-left: 85px;\n      padding-left: 85px;\n      top: 6px;\n    }\n\n    .underheader-container {\n      position: absolute;\n      left: 5px;\n      width: 400px;\n      height: 60px;\n      background: url('../medias/steel.png'); /* image */\n      background-repeat: no-repeat;\n      background-size: cover;\n      clip-path: polygon(5% 0%, 95% 0%, 100% 50%, 100% 50%, 95% 100%, 5% 100%, 0% 50%, 0% 50%); /* Forme du polygone */\n      box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.5); /* Ombre pour le style */\n      z-index: 1;\n      transform: translate(50px, 0px); /* Positionnement précis */\n    }\n    \n\n    .underheader-polygon {\n      position: relative;\n      bottom: -4px; /* Ajustez ces valeurs selon vos besoins */\n      left: 5px;\n      width: 390px;\n      height: 52px;\n      background: linear-gradient(rgba(9, 40, 84, 0.8), rgba(1, 6, 8, 0.8)), url('../medias/steel.png');\n      clip-path: polygon(4.6% 0%, 95.4% 0%, 100% 50%, 100% 50%, 95.4% 100%, 4.6% 100%, 0% 50%, 0% 50%);\n      z-index: 1;\n    }\n\n  }\n}\n\n@keyframes text-gradient-animation {\n  0% {\n    background-position: 200% 0%;\n  }\n  100% {\n    background-position: 0% 200%;\n  }\n}\n\n/*  -------------------------------------------------------------  */\n/* NAVBAR */\n\n.nav-link {\n  //flex-grow: 1;\n  font-family: 'GoodTimes', sans-serif;\n  font-size: 0.9rem;\n  color: $light-grey;\n  margin-right: 40px;\n  white-space: nowrap;\n  text-transform: uppercase;\n  text-decoration: none;\n  transform: translate(-0px, 0px);\n\n  &:last-child {\n    margin-right: 0px;\n  }\n\n  &:hover, \n  &:active {\n    color: $very-light-grey;\n    text-decoration: none;\n  }\n\n \n}\n\n.nav-link-active {\n  color: $very-light-grey; // Choisissez une couleur qui se démarque\n  //font-weight: bold;\n}\n\n\n//icons\n\n.menu .icons {\n  display: flex;\n  height: 20px;\n  overflow: hidden; \n  margin-left: auto;\n  margin-right: 0;\n}\n\n/* Specific styles for RSI icon */\n.menu .icons .header-rsi-icon {\n  height: 41px; \n  object-fit: contain; \n  margin-right: 20px; \n  position: relative;\n  top: 0px; \n  opacity: 0.4;\n}\n\n.menu .icons .header-rsi-icon:hover {\n  top: -21px; \n  opacity: 1;\n}\n\n/* Specific styles for Discord icon */\n.menu .icons .header-discord-icon {\n  height: 40px; \n  object-fit: contain; \n  margin-right: 20px; \n  position: relative;\n  top: 0px; \n  opacity: 0.4;\n}\n\n.menu .icons .header-discord-icon:hover {\n  top: -21px; \n  opacity: 1;\n}\n\n/*  -------------------------------------------------------------  */\n/* LOGIN */\n\n.login-btn {\n  display: block;\n  position: relative;\n  font-size: 1rem;\n  text-transform: none;\n  text-decoration: none;\n  margin-left: auto; \n  margin-right: 30px;\n  //display: flex;\n  align-items: center;\n  white-space: nowrap;\n  //overflow: hidden;\n\n  &.logged-out {\n    font-family: 'GoodTimes', sans-serif;\n  }\n\n  .link-login {\n    color: $red;\n    text-decoration: none;\n\n    &:hover, \n    &:active {\n      color: $bright-red;\n      text-decoration: none;\n    }\n  }\n  \n  .new-version-update {\n    position: absolute; \n    right: -30px; \n\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    \n    .reload-icon {\n      height: 15px;\n    }\n\n     &::after {\n      content: attr(data-tooltip);\n      position: absolute;\n      top: 20px; \n      right: 0;\n      margin-bottom: 8px;\n      padding: 4px 8px;\n      white-space: nowrap;\n      font-size: 0.875rem;\n      color: #19c619;\n      background: $blue-grey;\n      border-radius: 4px;\n      opacity: 0;\n      pointer-events: none;\n      transition: opacity 0.2s ease-in-out;\n    }\n\n    &:hover::after {\n      opacity: 1;\n    }\n  }\n}\n\n.user-avatar-mobile {\n  display: none; // Caché par défaut\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n}\n\n.login-btn__user-chip-wrap {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  bottom: 5px;\n\n  &--view-as {\n    gap: 0.65rem;\n  }\n}\n\n.login-btn__view-as-label {\n  font-style: italic;\n  color: $light-blue;\n  font-size: 1rem;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.user-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 3px 8px;\n  border: 1px solid rgba($red, 0.05);\n  border-radius: 12px;\n  background: rgba($blue-grey, 0.05);\n\n  /* Rank tint on outer header chip only (not nested profile-chip); colors via rankChipCspStyles.js */\n  &.user-chip--rank-tinted[data-chip-bg] {\n    position: relative;\n    isolation: isolate;\n    background: transparent;\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      inset: 0;\n      border-radius: inherit;\n      z-index: 0;\n      pointer-events: none;\n      opacity: 0.1;\n    }\n\n    > * {\n      position: relative;\n      z-index: 1;\n    }\n  }\n}\n\n.alt-account-warning {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n\n  &__icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 1.15rem;\n    height: 1.15rem;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    color: $very-light-orange;\n    font-size: 1rem;\n    line-height: 1;\n    cursor: pointer;\n    filter: drop-shadow(0 0 6px rgba($very-light-orange, 0.45));\n    outline: none;\n\n    &:focus-visible {\n      box-shadow: 0 0 0 2px rgba($very-light-orange, 0.55);\n      border-radius: 2px;\n    }\n  }\n\n  &--header {\n    margin-right: 6px;\n  }\n}\n\n.alt-account-secondary-notice {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  max-width: 360px;\n  margin-left: 4px;\n  padding: 4px 12px 4px 10px;\n  border-radius: 6px;\n  border: 1px solid rgba($very-light-orange, 0.75);\n  background: linear-gradient(\n    135deg,\n    rgba($very-dark-orange, 0.92) 0%,\n    rgba($dark-panel-blue, 0.95) 100%\n  );\n  box-shadow:\n    0 0 0 1px rgba($very-light-orange, 0.15) inset,\n    0 0 14px rgba($very-light-orange, 0.22);\n\n  &__icon {\n    flex-shrink: 0;\n    color: $very-light-orange;\n    font-size: 0.95rem;\n    line-height: 1;\n    filter: drop-shadow(0 0 5px rgba($very-light-orange, 0.4));\n  }\n\n  &__text {\n    font-family: 'Lato', sans-serif;\n    font-size: 0.72rem;\n    line-height: 1.25;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    color: $very-light-grey;\n    text-transform: none;\n    white-space: normal;\n  }\n}\n\n.alt-account-warning__tooltip {\n  position: fixed;\n  transform: translateX(-100%);\n  z-index: 100000;\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  min-width: 220px;\n  max-width: 280px;\n  padding: 10px 12px 10px 10px;\n  border-radius: 8px;\n  background: linear-gradient(\n    135deg,\n    rgba($very-dark-grey, 0.98) 0%,\n    rgba($dark-panel-blue, 0.98) 100%\n  );\n  border: 1px solid rgba($very-light-orange, 0.55);\n  box-shadow:\n    0 10px 28px rgba(0, 0, 0, 0.55),\n    0 0 0 1px rgba($very-light-orange, 0.12) inset,\n    0 0 18px rgba($very-light-orange, 0.18);\n  pointer-events: none;\n  white-space: normal;\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    right: -6px;\n    top: 11px;\n    width: 12px;\n    height: 12px;\n    transform: rotate(45deg);\n    background: rgba($dark-panel-blue, 0.98);\n    border-right: 1px solid rgba($very-light-orange, 0.45);\n    border-top: 1px solid rgba($very-light-orange, 0.45);\n  }\n\n  &-accent {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 4px;\n    height: 100%;\n    border-radius: 8px 0 0 8px;\n    background: linear-gradient(\n      180deg,\n      rgba($very-light-orange, 0.95) 0%,\n      rgba($light-orange, 0.75) 100%\n    );\n  }\n\n  &-icon {\n    position: relative;\n    z-index: 1;\n    flex-shrink: 0;\n    color: $very-light-orange;\n    font-size: 1rem;\n    line-height: 1.2;\n    margin-top: 1px;\n    margin-left: 6px;\n    filter: drop-shadow(0 0 6px rgba($very-light-orange, 0.35));\n  }\n\n  &-text {\n    position: relative;\n    z-index: 1;\n    margin: 0;\n    padding-right: 4px;\n    font-family: 'Lato', sans-serif;\n    font-size: 0.82rem;\n    line-height: 1.35;\n    color: $very-light-grey;\n    letter-spacing: 0.01em;\n  }\n}\n\n\n.user-chip__chevron {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 15px;\n  line-height: 1;\n  font-size: 1.4rem;\n  bottom: 6px;\n  color: inherit;\n  transition: none;\n\n  &.is-open {\n    transform: rotate(180deg);\n    bottom: -6px;\n  }\n}\n\n\n/*  -------------------------------------------------------------  */\n/* TOOLTIP */\n\n.email {\n  cursor: pointer;\n  //font-size: 1.0rem;\n  font-weight: bold;\n  color: $red;\n\n  &:hover {\n    color: $bright-red;\n  }\n\n  &.user-chip--rank-tinted {\n    color: $very-light-grey;\n\n    &:hover {\n      color: $very-light-grey;\n    }\n\n    .header-user-identity .user-discord-rank__name {\n      color: $very-light-grey;\n    }\n\n    .user-chip__chevron {\n      color: $very-light-grey;\n    }\n  }\n\n  .header-user-identity {\n    display: inline-flex;\n    align-items: center;\n    vertical-align: middle;\n    min-width: 0;\n    max-width: #{\"min(42vw, 280px)\"};\n    gap: 10px;\n\n    /* Plain identity row inside header chip — no nested profile-chip button */\n    &.user-discord-rank--profile-chip {\n      padding: 0;\n      margin: 0;\n      border: none;\n      border-radius: 0;\n      background: transparent;\n      cursor: inherit;\n\n      &::after {\n        display: none;\n      }\n    }\n\n    .user-discord-rank__name {\n      color: inherit;\n      font-weight: bold;\n      font-size: 0.9rem;\n    }\n\n    .user-discord-rank__rank-icon {\n      flex-shrink: 0;\n    }\n  }\n}\n\n.user-avatar {\n  display: none; // Caché par défaut\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  margin-right: 10px;\n}\n\n.email-text {\n  display: inline;\n  text-transform:initial;\n}\n\n.user-tooltip {\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  top: 100%;\n  right: 0;\n  transform: translateY(5px);\n  background-color: #032c45;\n  box-shadow: 3px 3px 10px rgba($dark-blue-grey, 0.65);\n  width: 220px;\n  gap: 0;\n  padding: 6px 0;\n  z-index: 100;\n  border: 1px solid rgba($red, 0.12);\n  border-radius: 8px;\n\n  &::before,\n  &::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: 28px;\n    width: 0;\n    height: 0;\n    border-style: solid;\n    pointer-events: none;\n  }\n\n  &::before {\n    transform: translateY(-100%);\n    border-width: 0 7px 7px 7px;\n    border-color: transparent transparent rgba($red, 0.12) transparent;\n  }\n\n  &::after {\n    transform: translateY(calc(-100% + 1px));\n    border-width: 0 6px 6px 6px;\n    border-color: transparent transparent $panel-blue transparent;\n  }\n}\n\n.tooltip-link {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-family: 'GoodTimes', sans-serif;\n  font-size: 0.75rem;\n  color: $medium-light-grey;\n  text-transform: none;\n  text-decoration: none;\n  padding: 11px 14px;\n  margin-bottom: 2px;\n  border-left: 2px solid transparent;\n  transition: color 0.15s ease, background 0.15s ease, border-color 0.15s ease;\n\n  &:not(:first-child) {\n    border-top: 1px solid rgba($very-light-grey, 0.08);\n  }\n\n  &__icon {\n    flex-shrink: 0;\n    width: 18px;\n    height: 18px;\n    color: inherit;\n\n    &--hangar {\n      display: inline-block;\n      background-color: currentColor;\n      mask-image: url(\"../medias/sc-icon-door.png\");\n      mask-size: contain;\n      mask-repeat: no-repeat;\n      mask-position: center;\n      -webkit-mask-image: url(\"../medias/sc-icon-door.png\");\n      -webkit-mask-size: contain;\n      -webkit-mask-repeat: no-repeat;\n      -webkit-mask-position: center;\n    }\n  }\n\n  &__label {\n    min-width: 0;\n    line-height: 1.2;\n  }\n\n  &:hover {\n    color: $pure-white;\n    border-left-color: $light-blue;\n    background: linear-gradient(\n      90deg,\n      rgba($light-blue, 0.2) 0%,\n      rgba($light-blue, 0.08) 42%,\n      transparent 78%\n    );\n    box-shadow: inset 0 0 0 1px rgba($light-blue, 0.12);\n  }\n\n  &.admin {\n    color: $light-orange;\n\n    .tooltip-link__icon {\n      color: $very-light-orange;\n      filter: drop-shadow(0 0 3px rgba($light-orange, 0.35));\n    }\n\n    &:hover {\n      color: $very-light-orange;\n      border-left-color: rgba($very-light-orange, 0.85);\n      background: linear-gradient(\n        90deg,\n        rgba($light-orange, 0.22) 0%,\n        rgba($light-orange, 0.08) 45%,\n        transparent 78%\n      );\n      box-shadow: inset 0 0 0 1px rgba($light-orange, 0.14);\n    }\n  }\n\n  &.view-as-reset {\n    cursor: pointer;\n    border-top: 0;\n    border-right: 0;\n    border-bottom: 0;\n    border-left: 2px solid transparent;\n    background-color: $light-orange;\n    color: $bright-red;\n    text-align: left;\n    width: 100%;\n\n    &:not(:first-child) {\n      border-top: none;\n    }\n\n    &:hover {\n      color: $bright-red;\n      border-left-color: $light-blue;\n      background: linear-gradient(\n        90deg,\n        rgba($light-blue, 0.2) 0%,\n        rgba($light-orange, 0.95) 38%,\n        rgba($light-orange, 0.85) 100%\n      );\n    }\n  }\n\n  &.logout {\n    cursor: pointer;\n\n    &:hover {\n      color: $pure-white;\n      border-left-color: $bright-red;\n      background: linear-gradient(\n        90deg,\n        rgba($bright-red, 0.24) 0%,\n        rgba($bright-red, 0.09) 42%,\n        transparent 78%\n      );\n      box-shadow: inset 0 0 0 1px rgba($bright-red, 0.14);\n    }\n  }\n\n  &--loading {\n    padding: 11px 14px;\n    color: $medium-light-grey;\n  }\n}\n\n/*  -------------------------------------------------------------  */\n/* SECONDARY NAVBAR */\n\n.secondary-nav-container {\n  display: contents;\n}\n\n.secondary-nav-bar {\n  position: absolute;\n  transform: translate(0px, 54px);\n  width: 100%;\n  z-index: 3;\n}\n.secondary-menu {\n  background: linear-gradient(to right, #522323d3, #4b0505, #4b0505, #4b0505, #522323d3), url('../medias/steel.png');\n  border-bottom: 2px solid #5b1212;\n  height: 37px;\n}\n\n.secondary-menu-content {\n  display: flex;\n  position: relative;\n  align-items: center;\n  //max-width: $desktop;\n  margin: auto;\n  top: 4px;\n  //@include width;\n  width: 1500px;\n  //height: 38px; /* Hauteur de la seconde navbar */\n}\n\n.secondary-menu-inner {\n  flex-grow: 1;\n  display: flex;\n  align-items: center;\n  padding-left: 415px;\n  gap: 14px;\n}\n\n.secondary-nav-utilities {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-left: 0;\n  margin-right: 20px;\n  flex: 1 1 auto;\n  justify-content: flex-end;\n  min-width: 0;\n}\n\n.secondary-nav-funding {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.secondary-nav-funding__trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0;\n  padding: 0 0.65rem;\n  height: 24px;\n  border: 1px solid rgba($medium-light-grey, 0.35);\n  border-radius: 999px;\n  background: rgba($very-dark-grey, 0.5);\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n\n  &:hover {\n    border-color: rgba($light-blue, 0.45);\n    background: rgba($very-dark-grey, 0.68);\n  }\n}\n\n.secondary-nav-funding__label {\n  font-family: 'GoodTimes', sans-serif;\n  font-size: 0.62rem;\n  font-weight: 400;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.86);\n  white-space: nowrap;\n}\n\n.secondary-nav-funding__bar-track {\n  display: block;\n  width: 4.5rem;\n  height: 0.38rem;\n  border: 1px solid rgba($medium-light-grey, 0.28);\n  border-radius: 999px;\n  overflow: hidden;\n  background: rgba($very-dark-grey, 0.65);\n  pointer-events: none;\n}\n\n.secondary-nav-funding__bar-track--complete {\n  border-color: rgba($light-green, 0.45);\n}\n\n.secondary-nav-funding__bar-fill {\n  display: block;\n  height: 100%;\n  width: var(--funding-pct, 0%);\n  border-radius: inherit;\n  background: linear-gradient(90deg, rgba($accent-blue, 0.95), rgba($light-blue, 0.95));\n  transition: width 0.65s cubic-bezier(0.22, 1, 0.36, 1);\n  will-change: width;\n}\n\n.secondary-nav-funding__bar-fill--complete {\n  background: linear-gradient(90deg, rgba($dark-green, 0.9), rgba($light-green, 0.95));\n}\n\n.secondary-nav-funding__bar-fill--pulse {\n  animation: secondary-nav-funding-bar-pulse 0.85s ease-out;\n}\n\n@keyframes secondary-nav-funding-bar-pulse {\n  0% {\n    filter: brightness(1);\n    box-shadow: none;\n  }\n\n  40% {\n    filter: brightness(1.35);\n    box-shadow: 0 0 10px rgba($light-blue, 0.55);\n  }\n\n  100% {\n    filter: brightness(1);\n    box-shadow: none;\n  }\n}\n\n.secondary-nav-funding__tooltip {\n  position: absolute;\n  right: 0;\n  top: calc(100% + 0.5rem);\n  width: 20rem;\n  max-width: calc(100vw - 2rem);\n  z-index: 1000;\n  padding: 0.55rem;\n  border: 1px solid rgba($medium-light-grey, 0.4);\n  border-radius: 14px;\n  background: #163447de;\n  box-shadow: 0 10px 28px rgba($dark-blue-grey, 0.55);\n}\n\n.secondary-nav-funding__tooltip-footer {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 0.45rem;\n  padding: 0 0.15rem 0.1rem;\n}\n\n.secondary-nav-funding__details-link {\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: transparent;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: $light-blue;\n  cursor: pointer;\n  text-decoration: underline;\n  text-underline-offset: 0.18em;\n\n  &:hover {\n    color: $very-light-grey;\n  }\n}\n\n.header-bar.isLoggedIn {\n  height: 100px;  /* double de la hauteur initiale */\n  height: 90px;\n}\n\n$nav2-slant: 14px;\n$nav2-clip: polygon(\n  $nav2-slant 0,\n  100% 0,\n  calc(100% - #{$nav2-slant}) 100%,\n  0 100%\n);\n$nav2-clip-inner: polygon(\n  calc(#{$nav2-slant} + 1px) 1px,\n  calc(100% - 1px) 1px,\n  calc(100% - #{$nav2-slant} - 1px) calc(100% - 1px),\n  1px calc(100% - 1px)\n);\n\n.nav2-link {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  height: 24px;\n  min-width: 96px;\n  font-family: 'GoodTimes', sans-serif;\n  font-size: 0.7rem;\n  line-height: 1;\n  color: rgba($very-light-grey, 0.72);\n  text-transform: uppercase;\n  text-decoration: none;\n  padding: 0 20px;\n  border: 0;\n  background: transparent;\n  transition: color 0.15s ease, filter 0.15s ease;\n\n  &::before,\n  &::after {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    pointer-events: none;\n  }\n\n  &::before {\n    z-index: 0;\n    clip-path: $nav2-clip;\n    background: rgba($red, 0.34);\n  }\n\n  &::after {\n    z-index: 0;\n    clip-path: $nav2-clip-inner;\n    background: rgba($very-dark-red, 0.5);\n  }\n\n  &__label {\n    position: relative;\n    z-index: 1;\n    display: inline-block;\n    line-height: 1;\n  }\n\n  &:hover:not(.is-active),\n  &:active:not(.is-active) {\n    color: $very-light-grey;\n    text-decoration: none;\n\n    &::before {\n      background: rgba($red, 0.42);\n    }\n  }\n\n  &.is-active {\n    color: $pure-white;\n    filter: drop-shadow(0 0 6px rgba($bright-red, 0.38));\n    text-decoration: none;\n\n    &::before {\n      background: rgba($medium-red, 0.92);\n    }\n\n    &::after {\n      background:\n        radial-gradient(\n          ellipse 95% 85% at 50% 42%,\n          rgba($pure-white, 0.22) 0%,\n          rgba($medium-red, 0.88) 24%,\n          rgba($dark-red, 0.82) 58%,\n          rgba($very-dark-red, 0.86) 100%\n        ),\n        linear-gradient(\n          180deg,\n          rgba($medium-red, 0.72) 0%,\n          rgba($dark-red, 0.78) 48%,\n          rgba($dark-red, 0.68) 100%\n        );\n      box-shadow:\n        inset 0 1px 0 rgba($very-light-grey, 0.22),\n        inset 0 -1px 0 rgba($very-light-grey, 0.14);\n    }\n  }\n}\n\n/*Footer*/\n\n.main-footer {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  min-height: 110px;\n  bottom: 0;\n  background-image: url('../medias/steel.png');\n  background-size: cover;\n  background-repeat: no-repeat;\n  position: relative;\n  z-index: 2;\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 4px;\n    left: 0;\n    width: 100%;\n    height: calc(100% - 4px);\n    background: linear-gradient(rgba(1, 39, 77, 0.876), rgba(1, 6, 8, 0.8)), url('../medias/steel.png');\n    background-repeat: no-repeat;\n    background-size: cover;\n    z-index: 1;\n    pointer-events: none;\n  }\n\n  .footer-content {\n    position: relative;\n    z-index: 3;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 28px;\n    width: 100%;\n    max-width: 1250px;\n    padding: 12px 40px;\n    box-sizing: border-box;\n  }\n\n  .footer-brand {\n    display: flex;\n    align-items: center;\n    gap: 18px;\n    flex: 1 1 0;\n    min-width: 0;\n  }\n\n  .footer-brand__logo {\n    width: auto;\n    height: 85px;\n    flex-shrink: 0;\n    object-fit: contain;\n    opacity: 0.85;\n  }\n\n  .footer-brand__text {\n    text-align: left;\n  }\n\n  .footer-brand__tagline,\n  .footer-brand__since {\n    margin: 0;\n    color: $light-grey;\n    font-size: 0.95rem;\n    line-height: 1.35;\n  }\n\n  .footer-brand__since {\n    margin-top: 2px;\n  }\n\n  .footer-divider {\n    flex-shrink: 0;\n    align-self: stretch;\n    width: 1px;\n    min-height: 72px;\n    background: rgba($light-grey, 0.28);\n  }\n\n  .footer-legal {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 20px;\n    flex: 1.4 1 0;\n    min-width: 0;\n  }\n\n  .footer-legal__nav {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: center;\n    gap: 8px 28px;\n  }\n\n  .footer-legal__link {\n    color: $light-grey;\n    font-size: 0.9rem;\n    text-decoration: none;\n    white-space: nowrap;\n\n    &:hover {\n      color: $pure-white;\n    }\n  }\n\n  .footer-legal__copyright {\n    margin: 0;\n    color: $pure-white;\n    font-size: 0.95rem;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    white-space: nowrap;\n  }\n\n  .footer-social {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 6px;\n    flex: 1 1 0;\n    min-width: 0;\n  }\n\n  .footer-social__row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    max-width: 280px;\n    padding: 0;\n    border: none;\n    background: transparent;\n    color: $light-grey;\n    font: inherit;\n    font-size: 0.88rem;\n    line-height: 1.2;\n    text-align: left;\n    text-decoration: none;\n    cursor: pointer;\n\n    &:hover {\n      color: $pure-white;\n    }\n  }\n\n  .footer-social__row--donate:hover .footer-social__heart {\n    color: lighten($bright-red, 8%);\n  }\n\n  .footer-social__row--donate--locked,\n  .footer-social__row--donate:disabled {\n    cursor: not-allowed;\n    opacity: 0.42;\n\n    &:hover {\n      color: $light-grey;\n    }\n\n    .footer-social__heart {\n      animation: none;\n      color: rgba($pure-white, 0.55);\n    }\n  }\n\n  .footer-social .icon-container {\n    flex-shrink: 0;\n    width: 90px;\n    height: 30px;\n    overflow: hidden;\n    position: relative;\n    margin-bottom: 0;\n\n    .icon-image {\n      width: 100%;\n      height: 30px;\n      object-fit: contain;\n      position: relative;\n      top: 0;\n    }\n  }\n\n  .footer-social .icon-rsi {\n    height: 15px;\n    width: 45px;\n  }\n\n  .footer-social .icon-discord {\n    height: 15px;\n    width: 45px;\n  }\n\n  .footer-social__row:hover .icon-rsi .icon-image,\n  .footer-social__row:hover .icon-discord .icon-image {\n    top: -16px;\n  }\n\n  .footer-social__icon--donate {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: 45px;\n    height: 18px;\n  }\n\n  .footer-social__heart {\n    width: 16px;\n    height: 16px;\n    color: $pure-white;\n    transform-origin: center center;\n    animation: donor-heart-badge-heartbeat 1s ease-in-out infinite;\n\n    :hover {\n      color: $bright-red;\n    }\n  }\n\n  .footer-social__label {\n    flex: 1 1 auto;\n    min-width: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .footer-social__external {\n    flex-shrink: 0;\n    width: 12px;\n    height: 12px;\n    opacity: 0.75;\n  }\n\n  @media (max-width: 960px) {\n    .footer-content {\n      flex-wrap: wrap;\n      justify-content: center;\n      gap: 20px 24px;\n      padding: 20px 24px;\n    }\n\n    .footer-brand,\n    .footer-legal,\n    .footer-social {\n      flex: 1 1 100%;\n      justify-content: center;\n    }\n\n    .footer-brand {\n      justify-content: center;\n    }\n\n    .footer-brand__text {\n      text-align: left;\n    }\n\n    .footer-divider {\n      display: none;\n    }\n\n    .footer-social {\n      align-items: center;\n    }\n\n    .footer-social__row {\n      max-width: 260px;\n    }\n  }\n\n  @media (max-width: 560px) {\n    .footer-legal__nav {\n      flex-direction: column;\n      gap: 8px;\n    }\n\n    .footer-brand__logo {\n      width: 72px;\n      height: 72px;\n    }\n  }\n  \n  \n\n  .vertical-center {\n    display: inline-block;\n    vertical-align: bottom;\n  }\n\n\n\n\n  @media (orientation: portrait) {\n    position: relative;\n  }\n\n  // Pour les tablettes et mobiles\n  @media (max-width: 1050px) {\n    position: relative;\n\n    @media (orientation: landscape) {\n      position: relative;\n    }\n  }\n}\n\n.vertical-center {\n  height: 100%;\n}\n\n\n\n/*  -------------------------------------------------------------  */\n/*  -------------------------------------------------------------  */\n/*                      MOBILE & TABLETS                           */\n/*                     Below 1024px large                          */\n/*  -------------------------------------------------------------  */\n/*  -------------------------------------------------------------  */\n  \n@media (max-width: $tablet) {\n\n  /* HEADER BAR */\n\n  .header-bar {\n    flex-direction: column; // Change la direction du flex pour empiler verticalement\n    z-index: 2;\n\n    .header-container {\n      display: flex;\n      flex-direction: column; // Aligner également le conteneur en colonne\n\n      .header {\n        order: 1; // S'assure que le header est au-dessus\n        height: 60px;\n        width: 100%; // Prend toute la largeur\n        margin-left: 30px;\n        //transform: translate(-65px, -4px);\n        transform: translate(-94px, 0px);\n      }\n\n      .menu {\n        order: 2; // Positionne le menu sous le header\n        max-height: 30px; // Hauteur maximale en état normal\n        width: 100%;\n        padding-left: 25px;\n        gap: 0px;\n        // overflow: hidden;\n        transition: max-height 0.5s ease-in-out, \n        opacity 0.5s ease-in-out;\n        transition: 0.5s;\n\n        &.hide-menu {\n          max-height: 0; // Réduit la hauteur à zéro\n        }\n      }\n\n      .underheader-container {\n        display: none; // Cache le underheader sur les appareils tablette et téléphone\n      }\n    }\n  }\n\n\n  /* NAV LINK */\n\n  .nav-link {\n  padding-bottom: 15px;\n  margin-right: 5vw;\n  //margin-left: 5px;\n  font-size: 0.7rem;\n  }\n\n\n  /* AVATAR */\n  .user-avatar {\n    display: none; // Cache l'avatar standard sur mobile\n  }\n  .user-avatar-mobile {\n    display: inline-block; // Affiche l'avatar mobile\n    padding-bottom: 7px;\n  }\n\n\n  .login-btn  {\n    &.logged-in {\n      margin-right: 25px;\n      height:30px;\n    }\n\n    &.logged-out {\n      margin-right: 20px;\n      height: 20px;\n    }\n  }\n\n  .icon {\n    fill: $red;\n    margin-left: auto;\n    margin-right: 10px;\n\n    &.logout {\n      height: 20px;\n    }\n\n    &.login {\n      height: 17px;\n    }\n    \n  }\n\n  /* SECONDARY NAVBAR */\n\n  .secondary-menu-inner {\n    margin-left: 0px; /* Ajustez cette valeur selon vos besoins */\n    padding-left: 0px;\n  }\n\n  .secondary-nav-container {\n    display: flex;\n    overflow: hidden; // Cache tout contenu qui dépasse cette hauteur\n    z-index: 1; // Assurez-vous que c'est sous les autres éléments importants si nécessaire\n  }\n  \n  .secondary-nav-bar {\n    transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;\n    transform: translateY(40px); // Position initiale plus basse pour être visible\n    opacity: 1;\n  \n    &.show {\n      transform: translateY(3px);\n      opacity: 1;\n    }\n  \n    &.hide {\n      transform: translateY(10px); // Changez ici pour monter, mais toujours partiellement visible\n      opacity: 0;\n    }\n  }\n\n\n\n\n\n  \n\n\n}\n\n\n","@import \"./variables.scss\";\n\n/* ===================== */\n/*    NOTIFICATION BELL   */\n/* ===================== */\n\n.notification-bell {\n  display: flex;\n  position: relative;\n  margin-left: 0;\n  margin-right: 0;\n\n  /* BUTTON */\n  .notification-button {\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: $grey;\n\n    &.unread {\n      color: rgb(74, 212, 74);\n    }\n\n    .notification-icon path {\n      fill: currentColor;\n    }\n\n\n  }\n}\n\n/* ===================== */\n/*     DROPDOWN PANEL     */\n/* ===================== */\n\n.notification-tooltip {\n  position: absolute;\n  right: 0;\n  top: 35px;\n  min-width: 270px;\n  width: 270px;\n  background: $panel-blue;\n  border: 1px solid $dark-red;\n  border-bottom: 4px solid $dark-red;\n  border-radius: 8px;\n  padding: 0;\n  overflow: hidden;\n  z-index: 1000;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n\n  /* HEADER */\n  .notification-header {\n    @include modal-header(\"../medias/steel.png\");\n    padding: 7px 10px;\n    height: 13px;\n    border-bottom: 2px solid $grey;\n    border-top-right-radius: 8px;\n    border-top-left-radius: 8px;\n    display: flex;\n    align-items: center;\n\n    .header-title {\n      flex: 1;\n      text-transform: uppercase;\n      font-size: 0.9em;\n      color: $light-grey;\n      font-weight: bold;\n      padding-left: 8px;\n    }\n  }\n\n  /* CONTENT SECTION */\n  .notification-section {\n    display: flex;\n    flex-direction: column;\n    background: $panel-blue;\n    padding: 10px 5px;\n    gap: 5px;\n    max-height: 300px;\n    overflow: auto;\n    @include scrollbar-styles;\n  }\n\n  /* NOTIFICATION ITEM */\n  .notif-item {\n    display: flex;\n    background: $blue-grey;\n    margin: 4px 6px;\n    padding: 6px 10px;\n    border: 1px solid $blue;\n    border-radius: 8px;\n    transition: transform 0.3s ease, opacity 0.3s ease;\n    cursor: pointer;\n\n    &.slide-out {\n        transform: translateX(120%);\n        opacity: 0;\n    }\n\n    &.unread {\n      border-left: 3px solid rgb(74, 212, 74);\n\n      &:hover {\n        background: $blue;\n        border: 1px solid $accent-blue;\n        border-left: 3px solid rgb(74, 212, 74);\n      }\n    }\n\n    &.read {\n      opacity: 0.9;\n\n      &:hover {\n        background: $blue;\n        border: 1px solid $accent-blue;\n      }\n    }\n\n    &.archived {\n      opacity: 0.6;\n    }\n\n    a {\n      color: $light-grey;\n      text-decoration: none;\n      display: block;\n    }\n\n    .notif-message {\n        width: 90% ;\n    }\n\n    .notif-archive-wrapper {\n        position: relative;\n        display: inline-block;\n        margin-left: auto;\n\n        .notif-archive-icon {\n            width: 20px;\n            height: 20px;\n            margin-left: auto;\n            background-image: url(\"../medias/archive.png\");\n            background-repeat: no-repeat;\n            background-size: 100% 200%;\n            background-position: 0 100%;\n            cursor: pointer;\n            display: inline-block;\n\n            &:hover {\n            background-position: 0 0%;\n            }\n        }\n\n        .notif-archive-tooltip {\n            position: absolute;\n            //bottom: 100%;           // au-dessus de l’icône\n            //left: 50%;\n            bottom: 0px;\n            transform: translateX(-50%);\n            background: $dark-red;\n            color: $very-light-grey;\n            padding: 4px 8px;\n            border-radius: 6px;\n            font-size: 11px;\n            white-space: nowrap;\n            visibility: hidden;\n            opacity: 0;\n            pointer-events: none;\n        }\n\n        &:hover .notif-archive-tooltip {\n            visibility: visible;\n            opacity: 1;\n        }\n    }\n\n}\n\n  /* EMPTY TEXT */\n  .notification-empty {\n    padding: 10px;\n    text-align: center;\n    color: $very-light-grey;\n    cursor: default;\n  }\n\n  /* ARCHIVE SECTION */\n  .archive-toggle {\n    padding: 5px 10px;\n\n    .archive-button {\n      background: $dark-blue-grey;\n      border: 1px solid $grey;\n      color: $very-light-grey;\n      padding: 3px 10px;\n      border-radius: 6px;\n      cursor: pointer;\n\n      &:hover {\n        border-color: $very-light-grey;\n      }\n    }\n  }\n\n  .archive-panel {\n    border-top: 2px solid $grey;\n    background: $grey;\n    padding: 10px;\n\n    .archive-search {\n      width: -webkit-fill-available;\n      padding: 5px;\n      background: $dark-blue-grey;\n      border: 1px solid $grey;\n      border-radius: 6px;\n      color: $very-light-grey;\n\n      &::placeholder {\n        color: $light-grey;\n      }\n    }\n\n    .archive-content-wrapper {\n        max-height: 300px;\n        overflow: auto;\n        @include scrollbar-styles;\n\n    }\n  }\n}\n\n/* ===================== */\n/*  GLOBAL ITEM SPACING   */\n/* ===================== */\n\n.notification-tooltip > div {\n  font-size: 0.875rem;\n  color: $light-grey;\n}\n\n.notification-tooltip > div + div {\n  border-top: 1px solid $grey;\n}\n","@import './variables.scss';\n\n\n// TESTING \n.public-container {\n  display: flex;\n  //max-width: $full-width;\n  width: 1050px;\n  justify-content: center;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 25px;\n  padding-right: 25px;\n  padding-top: 25px;\n  margin-bottom: 25px;\n  border-radius: 8px;\n  z-index: 1;\n}\n\n// Structure / Divisions only: hook is .divisions-tab-root on DivisionsTab.jsx\n@media (min-width: #{$desktop + 1px}) {\n  .public-container:has(.divisions-tab-root) {\n    max-width: 1280px;\n    width: 100%;\n  }\n}\n\n.rte-content-container {\n  background-color: $blue-grey;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n// ============//\n\n\n/*story.css */\n.custom-public {\n    text-align: justify;\n    color: $very-light-grey;\n  }\n  \n.public-container h1 {\n  text-align: center;\n  //color: $very-light-grey;\n}\n\n.public-container h2, \n.public-container h3 {\n  color: $very-light-grey;\n}\n\n.public-container img  {\n  text-align: center;\n}\n\n.public-container p {\n  margin-bottom: 0;\n  color: $very-light-grey;\n}\n\n.public-container blockquote {\n  margin: 10px 0;\n  color: $very-light-grey;\n  padding: 15px;\n  position: relative;\n\n  &::before,\n  &::after {\n    content: \"\";\n    position: absolute;\n    border: 3px solid $grey; // Utilisation de la variable $grey\n    border-radius: 6px 0;\n  }\n\n  &::before {\n    top: -3px; // Ajustement pour couvrir le padding\n    left: -3px; // Ajustement pour couvrir le padding\n    width: 50%;\n    height: 50%;\n    border-right: none;\n    border-bottom: none;\n  }\n\n  &::after {\n    bottom: -3px; // Ajustement pour couvrir le padding\n    right: -3px; // Ajustement pour couvrir le padding\n    width: 50%;\n    height: 50%;\n    border-left: none;\n    border-top: none;\n  }\n}\n\n.public-container pre {\n  background-color: $very-dark-grey !important;\n  border-left: 5px solid $dark-red!important;\n  border: 1px solid $dark-red; \n  border-radius: 0px; \n  color: #b1b1b1 !important;\n  font-size: inherit;\n  line-height: inherit;\n  margin: 0 0 10px;\n  overflow: visible;\n  padding: 20px !important;\n  white-space: pre-wrap;\n  word-break: inherit;\n  word-wrap: break-word;\n  position: relative;\n  font-family: 'Input', monospace !important;\n}\n\n\n// ============================================================\n//  GEOMETRY — Forme fixe unifiée\n// ============================================================\n\n$trap-width: 200px;\n$trap-height: 33px;\n\n$clip-border: polygon(38px 0, 161px 0, 203px 37px, -5px 37px);\n$clip-title:  polygon(40px 0, 160px 0, 198px 33px, 2px 33px);\n\n\n// ============================================================\n//  CONTENEUR GENERAL\n// ============================================================\n\n.title-container {\n  display: flex;\n  justify-content: center;\n  padding: 0 15px;\n  height: auto;\n  transform: translateY(3px);\n  gap: 50px;\n}\n\n\n// ============================================================\n//  BASE DES BORDURES (commune à border2/3/4/5)\n// ============================================================\n\n%trapezoid-border-base {\n  display: inline-block;\n  width: $trap-width;\n  height: $trap-height;\n  padding: 0;\n  backdrop-filter: blur(3px) saturate(33%);\n  -webkit-backdrop-filter: blur(4px) saturate(33%);\n  clip-path: $clip-border;\n}\n\n\n// ============================================================\n//  BASE DU TITRE (commune à title + title2)\n// ============================================================\n\n%trapezoid-title-base {\n  display: inline-block;\n  width: $trap-width;\n  height: $trap-height;\n  text-align: center;\n  margin-top: 3px;\n  padding: 0; // padding interdit sinon casse la forme\n  clip-path: $clip-title;\n  cursor: pointer;\n  z-index: 5;\n  text-transform: uppercase;\n  font-family: 'GoodTimes', sans-serif;\n  transition: all 0.3s ease;\n}\n\n\n// ============================================================\n//  TRAPEZOID-TITLE PRINCIPAL\n// ============================================================\n\n.trapezoid-title {\n  @extend %trapezoid-title-base;\n\n  background: linear-gradient(#567392, #1c252f);\n  color: $very-light-grey;\n  font-size: 17px;\n  align-content: center;\n}\n\n.trapezoid-title2 {\n  @extend %trapezoid-title-base;\n\n  background: linear-gradient(#567392, #1c252f);\n  color: $very-light-grey;\n  font-size: 17px;\n  align-content: center;\n}\n\n\n// ============================================================\n//  BORDER 2\n// ============================================================\n\n.trapezoid-border2 {\n  @extend %trapezoid-border-base;\n\n  background-color: rgba(51, 102, 126, 0.329);\n  border-bottom: 0px solid $very-dark-grey;\n\n  .trapezoid-title {\n    background: linear-gradient(#03294a, #274256);\n    color: $light-grey;\n  }\n}\n\n\n// ============================================================\n//  BORDER 3\n// ============================================================\n\n.trapezoid-border3 {\n  @extend %trapezoid-border-base;\n\n  background-color: rgba(51, 91, 126, 0.329);\n  border-bottom: 3px solid rgba(1, 1, 2, 0.329);\n\n  .trapezoid-title {\n    width: 195px;\n    margin-top: 3px;\n    background: linear-gradient($dark-grey, rgba(20, 40, 49, 0.329));\n    color: $grey;\n    clip-path: $clip-title;\n  }\n\n  &.active {\n    border-bottom: 3px solid $dark-grey;\n    background-color: rgba(173, 221, 243, 0.329);\n\n    .trapezoid-title {\n      background: linear-gradient(#03294a, #274256);\n      color: $light-grey;\n    }\n  }\n}\n\n\n// ============================================================\n//  ANIMATION OR\n// ============================================================\n\n@keyframes rotate-background {\n  0%   { background-position: 0% 50%; }\n  100% { background-position: 100% 50%; }\n}\n\n\n// ============================================================\n//  BORDER 4 (OR ANIMÉ)\n// ============================================================\n\n.trapezoid-border4 {\n  @extend %trapezoid-border-base;\n\n  background: linear-gradient(to right, #bf943fa8, #fcf6baab, #b38728a8, #fbf5b7ab, #aa761ca8);\n  background-size: 200% 200%;\n  border-bottom: 3px solid rgba(1, 1, 2, 0.329);\n  animation: rotate-background 2s linear infinite;\n\n  .trapezoid-title {\n    background: linear-gradient($dark-grey, rgba(20, 40, 49, 0.329));\n    color: $grey;\n  }\n\n  &.active {\n    background: linear-gradient(to right, #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C);\n    background-size: 200% 200%;\n    animation: rotate-background 2s linear infinite;\n\n    .trapezoid-title {\n      background: linear-gradient(#03294a, #274256);\n      color: #a88f58;\n    }\n  }\n}\n\n\n// ============================================================\n//  BORDER 5\n// ============================================================\n\n.trapezoid-border5 {\n  @extend %trapezoid-border-base;\n\n  background-color: rgba(51, 102, 126, 0.329);\n  border-bottom: 0px solid $very-dark-grey;\n\n  .trapezoid-title {\n    background: linear-gradient(#03294a, #274256);\n    color: $light-grey;\n  }\n}\n\n\n\n#backgroundCanvas {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: block; // Empêche le défilement en ajoutant de l'espace supplémentaire\n}\n.unauthorized {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  //justify-content: center;\n  height: 100vh;\n  position: relative;\n  color: $very-light-grey;\n\n  .unauthorized-canvas {\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    z-index: -1;\n  }\n\n  .links-container {\n    display: flex;\n    justify-content: center;\n    margin-top: 20px;\n\n    .lost {\n      background-color: $grey; // Couleur de fond des boutons\n      color: $very-light-grey; // Couleur du texte\n      padding: 10px 20px;\n      margin: 0 10px; // Espacement entre les boutons\n      border:1px solid $light-grey;\n      border-radius: 8px; // Coins arrondis\n      text-decoration: none; // Enlever le soulignement\n      text-transform: uppercase;\n      width: 150px; // Largeur fixe\n      height: 40px; // Hauteur fixe\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); // Ombre légère\n\n      &:hover {\n        border:1px solid $dark-red;\n        background-color: $dark-grey; // Assombrir le bouton au survol\n      }\n    }\n  }\n}\n\n.division-description {\n  white-space: pre-wrap;\n}\n\n// Structure page \n.division-description-container {\n  height: 220px;\n  padding-bottom: 20px;\n  overflow-y: auto;\n  scrollbar-width: 8px; \n}\n\n/* Styles pour la barre de défilement sur Chrome, Edge, etc. */\n.division-description-container::-webkit-scrollbar {\n  width: 8px; /* Largeur de la scrollbar */\n}\n\n.division-description-container::-webkit-scrollbar-thumb {\n  background-color: $dark-red; /* Couleur de la partie déplaçable de la scrollbar */\n  border-radius: 10px; /* Arrondir les angles */\n}\n\n.division-description-container::-webkit-scrollbar-track {\n  background: $grey; /* Couleur de fond de la track de la scrollbar */\n}\n\n.organization-structure {\n  margin-bottom: 30px;\n}\n\n.ranks-tab {\n  padding: 0px 50px 20px 50px ;\n}\n\n.divisions-tab {\n  padding: 0px 10px 20px 10px ;\n}\n\n\n//===============\n\n@media (max-width: $desktop) {\n  \n  .public-container {\n    display: flex;\n    margin-bottom: 55px;\n    padding-left: clamp(12px, 1.5%, 20px);\n    padding-right: clamp(12px, 1.5%, 20px);\n    @include width;\n  }\n\n  .custom-public {\n    text-align: justify;\n    color: $very-light-grey;\n  }\n\n  .ranks-tab {\n    padding: 0px 10px 20px 10px ;\n  }\n\n  .divisions-tab {\n    padding: 0px 10px 20px 10px ;\n  }\n\n  .rank-type-description {\n    text-align: justify ;\n  }\n\n}","// src/styles/privatePages.scss\n\n@import './variables.scss';\n\n.error {\n    color: red;\n    font-size: 0.8em;\n    margin-top: 5px;\n}\n\n.private-pages {\n    height: 100%;\n    margin-top: 60px;\n    margin-right: auto;\n    margin-left: auto;\n    max-width: $full-width;\n\n  &.private-pages--personal-hub {\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n    margin-top: 0;\n    //max-height: calc(100vh - 175px);\n    overflow: hidden;\n    overscroll-behavior: none;\n  }\n\n  &.hangar-page {\n    max-width: 1500px;\n    margin-left: 30px;\n  }\n}\n\n.private-container {\n    display: flex;\n    position: relative;\n    justify-content: center;\n    margin: auto;\n    margin-top: 20px;\n    padding: 15px;\n    border: 1px solid $dark-red;\n    border-top: 4px solid $dark-red;\n    border-bottom: 4px solid $dark-red;\n    box-shadow: 4px 5px 2px #4b050547;\n    border-radius: 8px;\n    z-index: 1;\n\n    overflow-wrap: normal;\n    background-color: $dark-panel-blue;\n    height: 500px;\n    overflow-y: auto;\n    width: auto;\n    @include scrollbar-styles;\n}\n\n\n.custom-private {\n    text-align: justify;\n    color: $very-light-grey;\n  }\n  \n.private-container h1 {\n  text-align: center;\n  //color: $very-light-grey;\n}\n\n.private-container h2, \n.private-container h3 {\n  color: $very-light-grey;\n}\n\n.private-container img  {\n  text-align: center;\n}\n\n.private-container p {\n  margin-bottom: 0;\n  color: $very-light-grey;\n}\n\n.private-container blockquote {\n  margin: 10px 0;\n  color: $very-light-grey;\n  padding: 15px;\n  position: relative;\n\n  &::before,\n  &::after {\n    content: \"\";\n    position: absolute;\n    border: 3px solid $grey; // Utilisation de la variable $grey\n    border-radius: 6px 0;\n  }\n\n  &::before {\n    top: -3px; // Ajustement pour couvrir le padding\n    left: -3px; // Ajustement pour couvrir le padding\n    width: 50%;\n    height: 50%;\n    border-right: none;\n    border-bottom: none;\n  }\n\n  &::after {\n    bottom: -3px; // Ajustement pour couvrir le padding\n    right: -3px; // Ajustement pour couvrir le padding\n    width: 50%;\n    height: 50%;\n    border-left: none;\n    border-top: none;\n  }\n}\n\n.private-container pre {\n    background-color: $dark-panel-blue;\n    border-left: 5px solid $dark-red;\n    border: 1px solid $dark-red; \n    border-radius: 0px; \n    color: $very-light-grey !important;\n    font-size: inherit;\n    line-height: inherit;\n    margin: 0 0 10px;\n    overflow: visible;\n    padding: 20px !important;\n    white-space: pre-wrap;\n    word-break: inherit;\n    word-wrap: break-word;\n    position: relative;\n    font-family: 'Input', monospace !important;\n}\n\n.extension-setup-steps {\n    margin: 15px 0 30px 0;\n    padding: 16px 20px;\n    border-radius: 6px; \n    background: $dark-panel-blue;\n    border: 1px solid $dark-red;\n    border-bottom: 4px solid $dark-red;\n    box-shadow: 4px 5px 2px #4b050547;\n}\n\n.extension-setup-list {\n    margin: 0;\n    padding-left: 22px;\n    list-style: decimal;\n\n    li {\n        margin: 6px 0;\n        font-size: 14px;\n        color: $very-light-grey;\n        line-height: 1.4;\n    }\n}\n\n/* ---------------------------------------------------------------------------\n * Onboarding container — duplication volontaire des règles `.private-container`\n * ci-dessus, sous un sélecteur dédié `.onboarding-private-container`.\n * Objectif : pouvoir faire diverger le rendu des steps Lexical de l'onboarding\n * sans toucher au design des pages privées classiques.\n * À l'instant T les deux blocs sont identiques ; les divergences de design\n * doivent être appliquées UNIQUEMENT ici.\n * ------------------------------------------------------------------------- */\n\n.onboarding-private-container {\n    display: flex;\n    position: relative;\n    justify-content: center;\n    margin: auto;\n    margin-top: 20px;\n    padding: 15px;\n    border-radius: 8px;\n    z-index: 1;\n    overflow-wrap: normal;\n    height: calc(100vh - 555px);\n    min-height: calc(100vh - 555px);\n    overflow-y: auto;\n    width: auto;\n    @include scrollbar-styles;\n}\n\n.onboarding-private-container h1 {\n  text-align: center;\n  //color: $very-light-grey;\n}\n\n.onboarding-private-container h2,\n.onboarding-private-container h3 {\n  color: $very-light-grey;\n}\n\n.onboarding-private-container img  {\n  text-align: center;\n}\n\n.onboarding-private-container p {\n  margin-bottom: 0;\n  color: $very-light-grey;\n}\n\n.onboarding-private-container blockquote {\n  margin: 10px 0;\n  color: $very-light-grey;\n  padding: 15px;\n  position: relative;\n\n  &::before,\n  &::after {\n    content: \"\";\n    position: absolute;\n    border: 3px solid $grey; // Utilisation de la variable $grey\n    border-radius: 6px 0;\n  }\n\n  &::before {\n    top: -3px; // Ajustement pour couvrir le padding\n    left: -3px; // Ajustement pour couvrir le padding\n    width: 50%;\n    height: 50%;\n    border-right: none;\n    border-bottom: none;\n  }\n\n  &::after {\n    bottom: -3px; // Ajustement pour couvrir le padding\n    right: -3px; // Ajustement pour couvrir le padding\n    width: 50%;\n    height: 50%;\n    border-left: none;\n    border-top: none;\n  }\n}\n\n.onboarding-private-container pre {\n    background-color: $dark-panel-blue;\n    border-left: 5px solid $dark-red;\n    border: 1px solid $dark-red;\n    border-radius: 0px;\n    color: $very-light-grey !important;\n    font-size: inherit;\n    line-height: inherit;\n    margin: 0 0 10px;\n    overflow: visible;\n    padding: 20px !important;\n    white-space: pre-wrap;\n    word-break: inherit;\n    word-wrap: break-word;\n    position: relative;\n    font-family: 'Input', monospace !important;\n}\n","@import './variables.scss';\n\n\n/*confirm.scss and activation.scss */\n.custom-confirm {\n    text-align: center;\n    text-align: justify;\n    color: $very-light-grey;\n  }\n  \n.confirm-container {\n  background: $dark-grey;\n  //max-width: $desktop;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 25px;\n  padding-right: 25px;\n  padding-top: 12px;\n  padding-bottom: 25px;\n  margin-top: 100px;\n  border: 2px solid $very-dark-grey;\n  border-top-left-radius: 15px;\n  border-top-right-radius: 15px;\n  border-bottom-left-radius: 15px;\n  border-bottom-right-radius: 15px;\n  @include width;\n}\n\np {\n  margin-bottom: 0;\n}\n","@import './variables.scss';\n\n/*Login and Register*/\n.login-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20vh;\n  height: auto;\n}\n\n.login-card {\n  position: relative;\n  backdrop-filter: blur(6px) saturate(33%);\n  -webkit-backdrop-filter: blur(4px) saturate(33%);\n  background-color: #25405748;\n  color: $very-light-grey;\n  width: 400px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transition: height 0.6s ease-in-out;\n  border: 1px solid rgba(51, 102, 126, 0.329);\n  box-shadow: 3px 2px inset rgba(51, 102, 126, 0.229);\n  border-radius: 6px;\n}\n\n.login-card--login {\n  height: auto;\n}\n\n.login-card--mfa {\n  height: 460px;\n}\n\n.login-card--register {\n  height: 400px;\n}\n\n.login-card--reset {\n  height: 235px;\n}\n\n.login-card--login-discord {\n  //justify-content: center;\n  height: auto;\n}\n\n.login-card--discord-mfa {\n  //justify-content: center;\n  height: 310px;\n}\n\n.login-card--identity-check {\n  //justify-content: center;\n  height: 245px;\n  width: 340px;\n}\n\n\n.login-tab-container {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  //margin-bottom: 2rem;\n}\n\n.identity-check-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  align-items: center;\n  height: inherit;\n  margin-top: 20vh;\n}\n\n.email-section.identity-check {\n  display: flex;\n  align-items: center;\n  width: 270px;\n  height: 45px;\n  padding: 5px;\n  color: $dark-red;\n  text-transform: lowercase;\n  font-size: 1rem;\n  font-weight: bold;\n  margin: 1rem 0;\n  border-radius: 6px;\n  cursor: default;\n  border-style: unset;\n\n  .email-info {\n    display: flex;\n    font-size: 0.85em;\n    align-items: center;\n\n    .email-icon {\n      width: 30px;\n      object-fit: contain;\n      margin-left: 16px;\n      margin-right: 16px;\n      display: inline-block;\n    }\n  }\n}\n\n.login-tab {\n  background-color: $very-dark-grey;\n  width: 33.33%;\n  font-size: 1.2rem;\n  padding: 10px 0;\n  text-align: center;\n  color: $light-grey; // or any color of your choice\n  text-decoration: none;\n  text-align: center; // To center the text\n  transition: width 300ms ease-in-out; // Ajout de la transition pour la largeur\n\n  &:hover {\n    cursor: pointer;\n    color: $very-light-grey;\n    text-decoration: underline;\n  }\n\n  &.active {\n    background-color: $dark-grey;\n    color: white;\n    cursor: pointer;\n  }\n\n  &.locked {\n    color: $grey;\n    pointer-events: none;\n    cursor: none;\n  }\n}\n\n.login-tab-discord {\n  background-color: $dark-grey;\n  width: 100%;\n  font-size: 1.2rem;\n  padding: 10px 0;\n  text-align: center;\n  color: $light-grey; // or any color of your choice\n  text-decoration: none;\n  text-align: center; // To center the text\n  transition: width 300ms ease-in-out; // Ajout de la transition pour la largeur\n\n  &.identity-check {\n    text-transform: uppercase;\n    font-size: 1rem;\n    font-weight: bold;\n  }\n}\n\n\n/* Specific styles for Discord icon */\n.btn-style1.handle-check {\n  display: flex;\n  align-items: center;\n  width: 270px;\n  height: 45px;\n  padding: 5px;\n  color: $very-light-grey; /* Assure-toi que cette couleur est définie pour voir l'effet au survol */\n  background-color: #2b518b; /* Couleur de fond initiale */\n  background-image: none;\n  text-transform: uppercase;\n  font-size: 0.8rem;\n  font-weight: bold;\n  margin: 1rem 0;\n  border-radius: 6px;\n  border-style: unset;\n  cursor: pointer;\n  \n  &:hover {\n    background-color: #3d68a8; /* Changement de couleur au survol */\n    color: white;\n    font-weight: bolder;\n    //box-shadow: 0px 0px 5px 1px #355c97; /* Ombre au survol */\n  }\n\n  .rsi-icon {\n    width: 40px;\n    object-fit: contain;\n    margin-left: 10px;\n    margin-right: 15px;\n    display: inline-block; /* Rendre l'icône inline */\n  }\n}\n\n.login-access-denied {\n  width: 400px;\n  max-width: 100%;\n  margin-top: 12px;\n  padding: 10px 14px;\n  box-sizing: border-box;\n  text-align: center;\n  color: $bright-red;\n  font-size: 0.9rem;\n  line-height: 1.45;\n  white-space: pre-line;\n}\n\n.lock-banner {\n  background-color: $dark-orange; /* Rouge clair pour indiquer une restriction */\n  color: $very-light-grey;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  width: -webkit-fill-available;\n  padding: 3px 14px;\n  text-align: center;\n  border-radius: 0px;\n  margin-bottom: -24px;\n}\n\n\n.fade-field {\n  opacity: 0;\n  transition: opacity 0.4s;\n  animation: fadein 0.4s forwards;\n  animation-delay: 0.6s;\n}\n\n@keyframes fadein {\n  to {\n    opacity: 1;\n  }\n}\n\n.form-container{\n  //width: 90%;\n  //height: 100%;\n  margin-top: 2.5rem;\n  //display: flex;\n  //justify-content: center;\n  //align-items: flex-end;\n  width: 90%;\n  height: 100%;\n  margin-bottom: 1rem;\n}\n\n.custom-field {\n  width: calc(100% - 30px); // to get the total width minus 15px on each side\n  margin: 0 15px; // 15px margin on each side\n  margin-bottom: 30px;\n\n  .remember-me {\n    position: relative;\n  }\n\n  .form-control {\n    width: 100%; // now 100% of the .custom-field width\n    padding: 15px;\n    box-sizing: border-box; // include padding and border in the element's total width and height\n  }\n\n  .mfa-field {\n    display: flex;\n    width: 65%;\n    margin: auto;\n    margin-bottom: 20px;\n    padding: 15px;\n    font-size: 1.1rem;\n    letter-spacing: 10px;\n    text-align: center;\n    border: 3px solid $bright-red;\n    outline: none;\n    box-sizing: border-box;\n    max-height: 0;\n    opacity: 0;\n    overflow: hidden;\n    animation: fadeIn 0.6s forwards; \n    transition: max-height 0.3s ease-out, opacity 0.7s ease-out;\n  }\n\n  .mfa-field.show {\n    max-height: 100px; /* Ou la hauteur nécessaire */\n    opacity: 1;\n  }\n \n  .form-check {\n    position: absolute;\n    box-sizing: border-box; // include padding and border in the element's total width and height\n    //top: 245px;\n\n    &.with-mfa {\n      position: relative;\n      top: 0px;\n    }\n  }\n\n  \n}\n\n.btn-slide-down {\n  bottom: 95px;\n}\n\n.custom-button {\n  background-color: $dark-red;\n  width: calc(100% - 30px); // to get the total width minus 15px on each side\n  height: 50px;\n  margin: 0px 15px 00px;\n  padding-top: .8rem;\n  padding-bottom: .8rem;\n  font-size: 1.2rem;\n  color: $very-light-grey;\n  position: relative;\n  //bottom: 5px;\n}\n\n\n\n@keyframes slideIn {\n  0% {\n    transform: translateY(-5px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.login-alternative {\n  margin-top: 20px;\n}\n\n.discord-alternative {\n  opacity: 0; // Le texte est invisible au début\n  transition: opacity 300ms ease-in; // Transition de l'opacité sur 300ms\n\n  // Animation pour que le texte apparaisse après 300ms\n  animation: fadeIn 300ms ease-in forwards 300ms; // Le \"forwards\" assure que l'état final est maintenu\n}\n\n\n.login-button {\n  opacity: 0;\n  transform: translateY(-50px);\n  animation-name: slideIn;\n  animation-duration: 0.5s;\n  animation-delay: 0.35s;\n  animation-fill-mode: forwards;\n  cursor: pointer;\n}\n\n.register-button {\n  opacity: 0;\n  transform: translateY(-50px);\n  animation-name: slideIn;\n  animation-duration: 0.5s;\n  animation-delay: 0.35s;\n  animation-fill-mode: forwards;\n  cursor: pointer;\n}\n\n.transition-button {\n  opacity: 0;\n  transform: translateY(-20px); // Ajustez cette valeur selon vos besoins\n  transition: all 0.5s ease-out;\n}\n\n.transition-button.show {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.password-field {\n  opacity: 0;\n  transform: translateY(-5px);\n  animation-name: slideIn;\n  animation-duration: 0.5s;\n  animation-delay: 0.3s;\n  animation-fill-mode: forwards;\n}\n\n\n.toggle-password-icon {\n  cursor: pointer;\n  position: absolute;\n  right: 10px;\n  top: 25px;\n  transform: translateY(-50%);\n  height: 17px;\n}\n\n\n.password-input-container {\n  position: relative;\n}\n\n.remember-me {\n  position: relative;\n  margin-top: 5px;\n  height: 5px;\n  opacity: 0;\n  transform: translateY(-5px);\n  animation-name: slideIn;\n  animation-duration: 0.5s;\n  animation-delay: 0.3s;\n  animation-fill-mode: forwards;\n\n  &.discord  {\n    height: 0px;\n    margin: 10px 0px;\n    margin-left: 70px;\n  }\n  \n}\n\n.error-message { \n  display: block;\n  height: 5px;\n  margin-top: 5px;\n  min-height: 5px;\n  color: rgb(219, 87, 87);\n}\n\n.message {\n  position: absolute;\n  top: 135px;\n  text-align: center;\n  color: rgb(219, 87, 87);\n}\n\n\n// ------------------ //\n// login with discord //\n// ------------------ //\n\n.discord-login {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  position: relative;\n  align-content: center;\n  align-items: center;\n  height: max-content;\n  top: 0px;\n    \n  &.identity-check {\n    margin-top: 0px;\n\n    .icon-container {\n      display: flex;\n      width: 30px;\n      height: auto;\n      overflow: hidden;\n      position: relative;\n      //margin-bottom: 5px;\n      top: 3px;\n      margin-left: 15px;\n      margin-right: 10px;\n      \n      .icon-image {\n        top: 0px;\n        width: 30px;\n        height: auto;\n        overflow: hidden;\n        border-radius: 50%;\n      }\n    }\n\n    &.discord-mfa {\n      margin-top: 20px;\n      margin-bottom: 20px;\n    }\n  }\n\n  .discord-button {\n    display: flex;\n    position: relative;\n    align-items: center;\n    height: max-content;\n    width: 270px;\n    height: 45px;\n    padding: 5px;\n    color: $very-light-grey;\n    background-image: none;\n    background-color: #4752c4 ;\n    border-radius: 6px;\n    cursor: pointer;\n    border-style: unset;\n\n    &:hover {\n      background-color: #5865F2 ;\n      color: white;\n      //box-shadow: 0px 0px 5px 1px #5865F2;\n    }\n\n    &.discord-mfa {\n      cursor: default;\n\n      &:hover {\n        background-color: #5865F2 ;\n        color: white;\n        box-shadow: none;\n      }\n    }\n  }\n\n\n  .icon-container {\n      width: 50px;\n      height: 30px;\n      overflow: hidden;\n      position: relative;\n      margin-bottom: 5px;\n      \n\n      .icon-image {\n          top: 4px;\n          width: 25px; \n          height: auto; \n          top: 6px;\n          width: 27px; \n          height: auto; \n          overflow: hidden; \n          border-radius: unset;\n      }\n  }\n\n  .discord-label {\n    text-transform: none;\n    font-size: 0.8rem;\n    font-weight: bold;\n    margin-left: 10px;\n    margin-bottom: 0px;\n  }\n}\n\n.discord-alternative {\n  display: flex;\n  margin: auto;\n  justify-content: center;\n  color: $light-grey;\n  text-decoration: none;\n  cursor: pointer;\n\n  &:hover {\n    color: white;\n  }\n}\n\n\n// ------------------ //\n// ------ MEDIA ----- //\n// ------------------ //\n\n@media (max-width: $tablet) {\n  .login-container {\n    background-color: $very-dark-grey;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100vh;\n  }\n\n  @media (orientation: landscape) {\n    //.content-container {  height: calc(100vh - 103px);}\n    //.content-container {  height: calc(100vh - 0px);}\n  }\n  \n  .login-card {\n    position: absolute;\n    margin-top: 90px;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100vh;\n    padding: 15px;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    border-radius: 0px;\n  }\n\n  \n  .login-access-denied {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 32px;\n    width: auto;\n    margin-top: 0;\n    padding: 12px 20px;\n  }\n\n  .lock-banner {\n    position: absolute;\n    background-color: $dark-red; /* Rouge clair pour indiquer une restriction */\n    color: $very-light-grey;\n    font-size: 0.95rem;\n    text-transform: uppercase;\n    width: calc(100vw - 12px);\n    padding: 6px;\n    text-align: center;\n    border-radius: 0;\n    margin-bottom: 0px; /* Espacement avant les onglets */\n    top: 13px;\n    left: 0;\n  }\n\n\n  .login-tab {\n    font-size: 1.2rem;\n  }\n\n  .custom-button {\n    background-color: $red;\n    width: calc(100% - 30px); // to get the total width minus 15px on each side\n    height: 50px;\n    margin: 0 15px 20px;\n    padding-top: .8rem;\n    padding-bottom: .8rem;\n    font-size: 1.2rem;\n    color: $very-light-grey;\n    top: 40px;\n    position: relative;\n    bottom: auto;\n    left: 0%;\n    transform: translateX(-50%);\n  }\n  \n\n  .no-scroll {\n    overflow: hidden;\n  }\n}\n","@import './variables.scss';\n\n// Identity Check hub (GamerIdentityCheck) — row-based connection manager\n.identity-hub {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  max-width: 940px;\n  margin: 0 auto;\n  padding: 10vh 1.25rem 3rem;\n  box-sizing: border-box;\n\n  &--loading {\n    justify-content: center;\n    min-height: 40vh;\n  }\n\n  &--view-as .identity-hub-row__actions button,\n  &--view-as .identity-hub-btn-rsi-connect,\n  &--view-as .identity-hub-rsi-hide,\n  &--view-as .identity-hub-rsi-btn-primary,\n  &--view-as .identity-hub-rsi-copy-hit {\n    pointer-events: none;\n    opacity: 0.55;\n  }\n}\n\n.identity-hub__view-as-banner,\n.identity-hub__view-as-gcu-hint {\n  width: 100%;\n  margin: 0 0 1rem;\n  padding: 0.65rem 1rem;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  line-height: 1.4;\n  text-align: center;\n  box-sizing: border-box;\n}\n\n.identity-hub__view-as-banner {\n  color: $pure-white;\n  background: rgba($blue, 0.35);\n  border: 1px solid rgba($very-light-grey, 0.25);\n}\n\n.identity-hub__view-as-gcu-hint {\n  color: rgb(220, 169, 169);\n  background: rgba($red, 0.12);\n  border: 1px solid rgba($red, 0.35);\n}\n\n.identity-hub__header {\n  text-align: center;\n  margin-bottom: 1.75rem;\n}\n\n.identity-hub__title {\n  margin: 0;\n  font-size: 1.35rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: $pure-white;\n}\n\n.identity-hub__title-rule {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.65rem;\n  margin: 0.85rem auto 0.65rem;\n  max-width: 320px;\n}\n\n.identity-hub__title-rule-line {\n  flex: 1;\n  height: 1px;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(58, 140, 200, 0.65) 20%,\n    rgba(74, 160, 230, 0.9) 50%,\n    rgba(58, 140, 200, 0.65) 80%,\n    transparent\n  );\n}\n\n.identity-hub__title-rule-diamond {\n  width: 7px;\n  height: 7px;\n  flex-shrink: 0;\n  background: lighten($accent-blue, 12%);\n  transform: rotate(45deg);\n  box-shadow: 0 0 10px rgba(74, 160, 230, 0.55);\n}\n\n.identity-hub__subtitle {\n  margin: 0;\n  font-size: 0.92rem;\n  color: $light-grey;\n}\n\n.identity-hub-card {\n  position: relative;\n  width: 100%;\n  max-width: 900px;\n  background: linear-gradient(165deg, rgba(22, 40, 55, 0.92), rgba(12, 26, 40, 0.96));\n  border: 1px solid rgba(58, 120, 180, 0.5);\n  border-radius: 10px;\n  box-shadow:\n    0 0 24px rgba(20, 60, 100, 0.25),\n    inset 0 1px 0 rgba(255, 255, 255, 0.04);\n  padding: 0;\n  overflow: visible;\n}\n\n.identity-hub-card--rsi-open {\n  border-color: rgba(74, 150, 220, 0.55);\n  box-shadow:\n    0 0 32px rgba(30, 100, 180, 0.22),\n    inset 0 1px 0 rgba(255, 255, 255, 0.04);\n}\n\n.identity-hub-card__inner {\n  position: relative;\n  z-index: 0;\n}\n\n.identity-hub-row {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  gap: 1rem 1.25rem;\n  padding: 1.25rem 1.5rem;\n  border-bottom: 1px solid rgba(42, 58, 72, 0.85);\n\n  &:last-child {\n    border-bottom: none;\n  }\n\n  &.identity-hub-row--dual {\n    grid-template-columns: auto minmax(0, 1fr);\n  }\n}\n\n.identity-hub-row__icon-wrap {\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n\n  img {\n    display: block;\n    width: 26px;\n    height: auto;\n  }\n}\n\n.identity-hub-row__icon-wrap--email {\n  background: radial-gradient(circle at 30% 25%, rgba(40, 90, 130, 0.9), $very-dark-grey);\n  border-color: rgba(0, 120, 185, 0.35);\n\n  svg {\n    width: 26px;\n    height: 26px;\n    color: $light-blue;\n  }\n}\n\n.identity-hub-row__icon-wrap--discord {\n  background: #5865f2;\n  border-color: rgba(255, 255, 255, 0.18);\n\n  .identity-hub-row__icon-discord-linked {\n    width: 52px;\n    height: 52px;\n    border-radius: 50%;\n    object-fit: cover;\n  }\n\n  img:not(.identity-hub-row__icon-discord-linked) {\n    width: 35px;\n    height: auto;\n  }\n}\n\n.identity-hub-row__icon-wrap--rsi {\n  background: radial-gradient(circle at 30% 20%, rgba(35, 70, 120, 0.95), $very-dark-grey);\n  border-color: rgba(74, 120, 180, 0.35);\n\n  img {\n    width: 44px;\n  }\n}\n\n.identity-hub-row__body {\n  min-width: 0;\n}\n\n.identity-hub-row__label {\n  display: block;\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  margin-bottom: 0.35rem;\n\n  &.identity-hub-row__label--email {\n    color: lighten($accent-blue, 16%);\n  }\n\n  &.identity-hub-row__label--discord {\n    color: #aab3ff;\n  }\n\n  &.identity-hub-row__label--rsi {\n    color: lighten($accent-blue, 16%);\n  }\n}\n\n.identity-hub-row__value {\n  display: block;\n  font-size: 1rem;\n  font-weight: 600;\n  color: $pure-white;\n  word-break: break-word;\n}\n\n.identity-hub-row__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  margin-top: 0.4rem;\n  font-size: 0.82rem;\n\n  svg {\n    flex-shrink: 0;\n  }\n\n  &.identity-hub-row__status--success {\n    color: $light-green;\n\n    svg {\n      color: $light-green;\n    }\n  }\n\n  &.identity-hub-row__status--muted {\n    margin-top: 0.35rem;\n    color: $medium-light-grey;\n  }\n}\n\n.identity-hub-row__hint {\n  display: block;\n  margin-top: 0.28rem;\n  font-size: 0.77rem;\n  line-height: 1.35;\n  color: $medium-light-grey;\n}\n\n.identity-hub-row__actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  flex-shrink: 0;\n}\n\n.identity-hub-btn-outline {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  padding: 0.55rem 0.95rem;\n  border-radius: 6px;\n  font-size: 0.74rem;\n  font-weight: 700;\n  cursor: pointer;\n  border: 1px solid transparent;\n  background: transparent;\n  transition:\n    border-color 0.15s ease,\n    background 0.15s ease,\n    color 0.15s ease;\n  white-space: nowrap;\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n\n  svg {\n    flex-shrink: 0;\n    width: 15px;\n    height: 15px;\n    color: inherit;\n  }\n}\n\n.identity-hub-btn-outline--muted {\n  color: $very-light-grey;\n  border-color: rgba(118, 128, 140, 0.65);\n  background: rgba(8, 20, 32, 0.45);\n\n  &:hover:not(:disabled) {\n    border-color: rgba(160, 170, 185, 0.75);\n    background: rgba(20, 40, 56, 0.55);\n  }\n}\n\n.identity-hub-btn-outline--discord {\n  color: #c9ceff;\n  border-color: rgba(88, 101, 242, 0.85);\n\n  &:hover:not(:disabled) {\n    background: rgba(88, 101, 242, 0.12);\n    border-color: #727cf5;\n    color: $pure-white;\n\n    img {\n      opacity: 1;\n    }\n  }\n\n  img.identity-hub-discord-mini {\n    height: 17px;\n    width: auto;\n  }\n}\n\n.identity-hub-btn-rsi-connect {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.48rem;\n  padding: 0.55rem 1.05rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  cursor: pointer;\n  border: 1px solid rgba(74, 130, 200, 0.55);\n  color: $pure-white;\n  background: linear-gradient(145deg, #2f6aae 0%, #214a82 42%, #18365f 100%);\n  box-shadow: 0 2px 12px rgba(20, 50, 90, 0.35);\n  transition:\n    transform 0.12s ease,\n    box-shadow 0.15s ease,\n    filter 0.15s ease;\n\n  &:hover:not(:disabled) {\n    filter: brightness(1.06);\n    box-shadow: 0 4px 16px rgba(30, 80, 140, 0.45);\n  }\n\n  &:active:not(:disabled) {\n    transform: translateY(1px);\n  }\n}\n\n.identity-hub-btn-rsi-connect__arrow {\n  font-weight: 800;\n}\n\n// —— RSI expandable verification wizard —— //\n\n.identity-hub-rsi-section {\n  border-top: 1px solid rgba(42, 58, 72, 0.85);\n\n  &.identity-hub-rsi-section--open .identity-hub-rsi-head {\n    border-bottom: 1px solid rgba(42, 58, 72, 0.85);\n  }\n}\n\n.identity-hub-rsi-head {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  gap: 1rem 1.25rem;\n  padding: 1.25rem 1.5rem;\n}\n\n.identity-hub-rsi-hide {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0;\n  border: none;\n  background: none;\n  cursor: pointer;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: lighten($accent-blue, 18%);\n  transition: color 0.15s ease;\n\n  &:hover {\n    color: $pure-white;\n  }\n\n  svg {\n    flex-shrink: 0;\n    width: 14px;\n    height: 14px;\n    color: inherit;\n    transform: translateY(-1px);\n  }\n}\n\n.identity-hub-rsi-expand {\n  display: grid;\n  grid-template-rows: 0fr;\n  transition: grid-template-rows 0.42s cubic-bezier(0.33, 1, 0.68, 1);\n}\n\n.identity-hub-rsi-expand--open {\n  grid-template-rows: 1fr;\n}\n\n.identity-hub-rsi-expand__measure {\n  min-height: 0;\n  overflow: hidden;\n}\n\n.identity-hub-rsi-expand__surface {\n  padding: 1rem 1.5rem 1.5rem;\n\n  @media screen and (min-width: 541px) {\n    padding-bottom: 1.75rem;\n  }\n}\n\n.identity-hub-rsi-wizard {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.identity-hub-rsi-wizard__heading-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n  align-items: flex-end;\n  margin-bottom: 0.35rem;\n\n  @media screen and (max-width: 720px) {\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n    margin-bottom: 0.5rem;\n  }\n}\n\n.identity-hub-rsi-wizard__pair-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n  align-items: stretch;\n\n  @media screen and (max-width: 720px) {\n    grid-template-columns: 1fr;\n    gap: 1.25rem;\n  }\n}\n\n.identity-hub-rsi-wizard__pair-row:last-of-type .identity-hub-rsi-step__rail-after {\n  display: none;\n}\n\n.identity-hub-rsi-wizard__legend {\n  color: $medium-light-grey;\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.17em;\n  text-transform: uppercase;\n  margin: 0;\n  padding-left: 50px;\n\n  &.identity-hub-rsi-wizard__legend--muted {\n    color: $medium-light-grey;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n  }\n\n  @media screen and (max-width: 720px) {\n    padding-left: 0;\n  }\n}\n\n.identity-hub-rsi-step {\n  display: grid;\n  grid-template-columns: 38px 1fr;\n  gap: 0.65rem 0.95rem;\n  position: relative;\n  padding-bottom: 1.35rem;\n\n  &__rail-after {\n    position: absolute;\n    left: 18px;\n    top: 40px;\n    bottom: -2px;\n    width: 0;\n    border-left: 2px dashed rgba(90, 110, 128, 0.55);\n    pointer-events: none;\n  }\n\n  &--accent .identity-hub-rsi-step__rail-after {\n    border-left-color: rgba(64, 160, 255, 0.45);\n    box-shadow: -1px 0 12px rgba(40, 140, 255, 0.12);\n  }\n}\n\n.identity-hub-rsi-step__bullet {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.78rem;\n  font-weight: 800;\n  box-sizing: border-box;\n  position: relative;\n  z-index: 1;\n  border: 2px solid rgba(255, 255, 255, 0.1);\n  background: rgba(18, 32, 44, 0.95);\n  color: $medium-light-grey;\n  transition:\n    border-color 0.2s ease,\n    background 0.2s ease,\n    color 0.2s ease,\n    box-shadow 0.2s ease;\n}\n\n.identity-hub-rsi-step--accent .identity-hub-rsi-step__bullet {\n  border-color: rgba(90, 190, 255, 0.85);\n  background: linear-gradient(145deg, rgba(30, 90, 150, 0.95), rgba(18, 55, 100, 0.98));\n  color: $pure-white;\n  box-shadow:\n    0 0 16px rgba(40, 150, 255, 0.28),\n    inset 0 1px 0 rgba(255, 255, 255, 0.12);\n}\n\n.identity-hub-rsi-step__body {\n  min-width: 0;\n  padding-top: 0.12rem;\n}\n\n.identity-hub-rsi-step__title {\n  margin: 0 0 0.55rem;\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: $medium-light-grey;\n  transition: color 0.2s ease;\n}\n\n.identity-hub-rsi-step--accent .identity-hub-rsi-step__title {\n  color: lighten($accent-blue, 28%);\n}\n\n.identity-hub-rsi-step__icon-glyph {\n  width: 18px;\n  height: 18px;\n  color: inherit;\n\n  &.identity-hub-rsi-step__icon-glyph--lg {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.identity-hub-rsi-step__bullet.identity-hub-guide-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n}\n\n.identity-hub-rsi-guide-link {\n  color: lighten($accent-blue, 26%);\n  text-decoration: underline;\n  transition: color 0.15s ease;\n\n  &:hover {\n    color: $pure-white;\n  }\n}\n\n.identity-hub-rsi-step__guide-text {\n  margin: 0;\n  font-size: 0.78rem;\n  line-height: 1.45;\n  color: $medium-light-grey;\n  transition: color 0.2s ease;\n}\n\n.identity-hub-rsi-step--accent .identity-hub-rsi-step__guide-text {\n  color: $very-light-grey;\n}\n\n.identity-hub-rsi-input-shell {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.52rem 0.72rem;\n  border-radius: 7px;\n  border: 1px solid rgba(70, 100, 128, 0.45);\n  background: rgba(6, 12, 20, 0.65);\n  transition:\n    border-color 0.2s ease,\n    box-shadow 0.2s ease;\n\n  svg {\n    flex-shrink: 0;\n    width: 20px;\n    height: 20px;\n    color: rgba(140, 160, 182, 0.75);\n    transition: color 0.2s ease;\n  }\n\n  &.identity-hub-rsi-input-shell--inactive {\n    opacity: 0.55;\n    pointer-events: none;\n  }\n}\n\n.identity-hub-rsi-step--accent .identity-hub-rsi-input-shell:not(.identity-hub-rsi-input-shell--inactive) {\n  border-color: rgba(74, 150, 220, 0.45);\n  box-shadow: 0 0 0 1px rgba(40, 120, 200, 0.12);\n\n  svg {\n    color: lighten($accent-blue, 22%);\n  }\n}\n\n.identity-hub-rsi-textfield {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 0.87rem;\n  color: $pure-white;\n\n  &::placeholder {\n    color: rgba(150, 160, 175, 0.75);\n  }\n\n  &.identity-hub-rsi-textfield--readonly {\n    cursor: default;\n    font-family: 'FiraCode', monospace;\n    font-size: 0.78rem;\n  }\n}\n\n.identity-hub-rsi-btn-primary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n  width: 100%;\n  padding: 0.55rem 1rem;\n  border-radius: 7px;\n  font-size: 0.73rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  cursor: pointer;\n  border: 1px solid transparent;\n  color: rgba(230, 235, 240, 0.38);\n  background: rgba(32, 48, 64, 0.55);\n  transition:\n    color 0.2s ease,\n    background 0.2s ease,\n    border-color 0.2s ease,\n    box-shadow 0.2s ease,\n    opacity 0.2s ease;\n\n  svg {\n    width: 16px;\n    height: 16px;\n    color: inherit;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  &.identity-hub-rsi-btn-primary--raised:not(:disabled) {\n    border-color: rgba(72, 150, 220, 0.55);\n    color: $pure-white;\n    background: linear-gradient(145deg, #2e7ec9 0%, #245a9a 42%, #1a4270 100%);\n    box-shadow: 0 2px 16px rgba(25, 80, 150, 0.35);\n\n    &:hover {\n      filter: brightness(1.05);\n      box-shadow: 0 4px 20px rgba(30, 100, 180, 0.4);\n    }\n  }\n\n  &.identity-hub-rsi-btn-primary--ghost:not(:disabled) {\n    &:hover {\n      background: rgba(40, 60, 80, 0.65);\n    }\n  }\n}\n\n.identity-hub-rsi-token-row {\n  position: relative;\n}\n\n.identity-hub-rsi-copy-hit {\n  position: absolute;\n  right: 0.55rem;\n  top: 50%;\n  transform: translateY(-50%);\n  padding: 0;\n  border: none;\n  background: none;\n  cursor: pointer;\n\n  &.identity-hub-rsi-copy-hit--inactive {\n    pointer-events: none;\n    opacity: 0.4;\n    cursor: not-allowed;\n  }\n\n  img {\n    display: block;\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.identity-hub-rsi-msg {\n  margin-top: 0.65rem;\n  font-size: 0.8rem;\n\n  &.identity-hub-rsi-msg--timer {\n    color: rgba(155, 170, 190, 0.85);\n  }\n\n  &.identity-hub-rsi-msg--success {\n    color: $light-green;\n  }\n\n  &.identity-hub-rsi-msg--error {\n    color: $bright-red;\n  }\n\n  &.identity-hub-rsi-msg--warning {\n    color: $light-orange;\n  }\n}\n\n.identity-hub-guide-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n\n  svg {\n    display: block;\n    width: 22px;\n    height: 22px;\n    color: $medium-light-grey;\n    transition: color 0.2s ease;\n  }\n}\n\n.identity-hub-rsi-step--accent .identity-hub-guide-icon svg {\n  color: lighten($accent-blue, 26%);\n}\n\n.identity-hub-footer {\n  display: flex;\n  align-items: flex-start;\n  align-items: center;\n  gap: 0.95rem;\n  margin-top: 1.85rem;\n  max-width: 520px;\n  padding: 0 0.5rem;\n  box-sizing: border-box;\n}\n\n.identity-hub-footer__icon {\n  flex-shrink: 0;\n  margin-top: 2px;\n\n  svg {\n    display: block;\n    width: 28px;\n    height: 28px;\n    color: lighten($accent-blue, 14%);\n    filter: drop-shadow(0 0 10px rgba(58, 120, 190, 0.35));\n  }\n}\n\n.identity-hub-footer__copy {\n  font-size: 0.82rem;\n  line-height: 1.55;\n  color: $medium-light-grey;\n}\n\n@media screen and (max-width: 540px) {\n  .identity-hub {\n    padding-top: 8vh;\n  }\n\n  .identity-hub-row {\n    grid-template-columns: auto minmax(0, 1fr);\n    grid-template-areas:\n      'icon body'\n      'actions actions';\n\n    gap: 0.75rem 1rem;\n\n    padding: 1.1rem 1.05rem;\n\n    .identity-hub-row__icon-wrap {\n      grid-area: icon;\n    }\n\n    .identity-hub-row__body {\n      grid-area: body;\n    }\n\n    .identity-hub-row__actions {\n      grid-area: actions;\n      justify-self: end;\n      width: auto;\n      max-width: 100%;\n      flex-wrap: wrap;\n      justify-content: flex-end;\n    }\n  }\n\n  .identity-hub-row__hint {\n    max-width: 100%;\n  }\n\n  .identity-hub-rsi-head {\n    grid-template-columns: auto minmax(0, 1fr);\n    grid-template-areas:\n      'icon body'\n      'actions actions';\n\n    gap: 0.75rem 1rem;\n    padding: 1.1rem 1.05rem;\n\n    .identity-hub-row__icon-wrap {\n      grid-area: icon;\n    }\n\n    .identity-hub-row__body {\n      grid-area: body;\n    }\n\n    .identity-hub-row__actions,\n    .identity-hub-rsi-head__tail {\n      grid-area: actions;\n      justify-self: end;\n    }\n  }\n\n  .identity-hub-rsi-step {\n    grid-template-columns: 36px minmax(0, 1fr);\n  }\n\n  .identity-hub-rsi-step__rail-after {\n    left: 17px;\n  }\n\n  .identity-hub-rsi-wizard__legend {\n    padding-left: 0;\n  }\n\n  .identity-hub-rsi-wizard__heading-row {\n    gap: 0.5rem;\n  }\n}\n\n.identity-hub-membership-notice {\n  margin: 1.1rem;\n  padding: 1.1rem 1.25rem;\n  border-radius: 10px;\n  border: 1px solid rgba($very-light-grey, 0.22);\n  background: rgba($blue-grey, 0.55);\n  text-align: left;\n\n  &--info {\n    border-color: rgba($blue, 0.45);\n    background: rgba($blue, 0.18);\n  }\n\n  &--pending {\n    border-color: rgba($light-green, 0.35);\n    background: rgba($blue-grey, 0.65);\n  }\n\n  &--blocked {\n    border-color: rgba($bright-red, 0.4);\n    background: rgba($bright-red, 0.1);\n  }\n}\n\n.identity-hub-membership-notice__title {\n  margin: 0 0 0.55rem;\n  font-size: 0.95rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: $pure-white;\n}\n\n.identity-hub-membership-notice__body {\n  margin: 0;\n  font-size: 0.88rem;\n  line-height: 1.55;\n  color: rgba($pure-white, 0.88);\n}\n\n.identity-hub-membership-notice__cta {\n  display: inline-block;\n  margin-top: 0.9rem;\n  padding: 0.45rem 0.85rem;\n  border-radius: 6px;\n  border: 1px solid rgba($very-light-grey, 0.35);\n  background: rgba($blue, 0.35);\n  color: $pure-white;\n  font-size: 0.82rem;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  text-decoration: none;\n  text-transform: uppercase;\n\n  &:hover,\n  &:focus-visible {\n    background: rgba($blue, 0.55);\n    color: $pure-white;\n    text-decoration: none;\n  }\n}\n\n.identity-hub-membership-notice__guest-hint {\n  margin: 0.85rem 0 0;\n  font-size: 0.84rem;\n  line-height: 1.5;\n  color: rgba($pure-white, 0.78);\n}\n\n.identity-hub-guest-access {\n  margin: 1rem;\n  padding: 1.1rem 1.25rem;\n  border-radius: 10px;\n  border: 1px solid rgba($very-light-grey, 0.22);\n  background: rgba($blue-grey, 0.45);\n  text-align: left;\n}\n\n.identity-hub-guest-access__title {\n  margin: 0 0 0.55rem;\n  font-size: 0.95rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: $pure-white;\n}\n\n.identity-hub-guest-access__status {\n  margin: 0 0 0.75rem;\n  font-size: 0.88rem;\n  line-height: 1.5;\n  color: rgba($pure-white, 0.88);\n\n  &--pending strong {\n    color: $light-green;\n  }\n\n  &--rejected {\n    color: rgba($bright-red, 0.95);\n  }\n}\n\n.identity-hub-guest-access__btn {\n  display: inline-block;\n  padding: 0.5rem 0.95rem;\n  border-radius: 6px;\n  border: 1px solid rgba($very-light-grey, 0.35);\n  background: rgba($blue, 0.4);\n  color: $pure-white;\n  font-size: 0.82rem;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  cursor: pointer;\n\n  &:hover:not(:disabled),\n  &:focus-visible:not(:disabled) {\n    background: rgba($blue, 0.6);\n  }\n\n  &:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n  }\n}\n\n","// /src/styles/guestAccessPopup.scss\n\n.guest-access-nav-wrapper {\n  flex: 1 1 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 0;\n  position: relative;\n  z-index: 30001;\n}\n\n.guest-access-chip-portal {\n  position: fixed;\n  top: 59px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 1400px;\n  max-width: 100vw;\n  display: flex;\n  justify-content: flex-end;\n  padding-right: 312px;\n  box-sizing: border-box;\n  z-index: 30002;\n}\n\n.guest-access-nav-trigger {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  padding: 0 0.72rem;\n  width: auto;\n  height: 28px;\n  z-index: 30001;\n  border-radius: 999px;\n  border: 1px solid $very-light-orange;\n  background: $orange;\n  color: $pure-white;\n  cursor: pointer;\n  user-select: none;\n  box-shadow:\n    0 0 0 2px rgba($very-light-orange, 0.12),\n    0 10px 26px rgba($very-dark-orange, 0.22);\n  transition: background 0.15s ease, color 0.15s ease, transform 0.15s ease;\n\n  &:hover,\n  &:focus-visible {\n    background: $light-orange;\n  }\n\n  &--tilt {\n    animation: guest-access-chip-tilt 10s linear infinite;\n    will-change: transform;\n  }\n}\n\n.guest-access-nav-trigger__icon {\n  display: block;\n  pointer-events: none;\n}\n\n.guest-access-nav-trigger__label {\n  font-size: 0.7rem;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  line-height: 1;\n  text-transform: uppercase;\n}\n\n@keyframes guest-access-chip-tilt {\n  0%,\n  84%,\n  100% {\n    transform: translateX(0);\n  }\n\n  85% {\n    transform: translateX(0) rotate(0deg);\n  }\n\n  86% {\n    transform: translateX(8px) rotate(2deg);\n  }\n\n  87% {\n    transform: translateX(-8px) rotate(-2deg);\n  }\n\n  88% {\n    transform: translateX(8px) rotate(2deg);\n  }\n\n  89% {\n    transform: translateX(-6px) rotate(-1.5deg);\n  }\n\n  90% {\n    transform: translateX(6px) rotate(1.5deg);\n  }\n\n  91% {\n    transform: translateX(-3px) rotate(-0.8deg);\n  }\n\n  92% {\n    transform: translateX(0) rotate(0deg);\n  }\n}\n\n.guest-access-nav-trigger__badge {\n  position: absolute;\n  top: -4px;\n  right: -6px;\n  min-width: 1rem;\n  height: 1rem;\n  padding: 0 0.22rem;\n  border-radius: 999px;\n  background: $bright-red;\n  color: $pure-white;\n  font-size: 0.55rem;\n  font-weight: 700;\n  line-height: 1rem;\n  text-align: center;\n  pointer-events: none;\n}\n\n.guest-access-popup-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 30000;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 4.5rem 1rem 1.5rem;\n  background: rgba($dark-grey, 0.72);\n}\n\n.guest-access-popup {\n  width: #{\"min(560px, 100%)\"};\n  max-height: #{\"min(70vh, 640px)\"};\n  overflow: auto;\n  border-radius: 14px;\n  border: 1px solid rgba($very-light-orange, 0.35);\n  background: linear-gradient(\n    180deg,\n    rgba($very-dark-orange, 0.45) 0%,\n    $blue-grey 120px\n  );\n  box-shadow:\n    0 0 0 1px rgba($pure-black, 0.25),\n    0 22px 56px rgba($pure-black, 0.5);\n}\n\n.guest-access-popup__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1rem 1.15rem 0.95rem;\n  border-bottom: 1px solid rgba($very-light-orange, 0.22);\n}\n\n.guest-access-popup__header-text {\n  min-width: 0;\n}\n\n.guest-access-popup__eyebrow {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  margin: 0 0 0.2rem;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba($very-light-orange, 0.92);\n}\n\n.guest-access-popup__count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.15rem;\n  height: 1.15rem;\n  padding: 0 0.35rem;\n  border-radius: 999px;\n  background: rgba($orange, 0.85);\n  color: $pure-white;\n  font-size: 0.62rem;\n  letter-spacing: 0.02em;\n}\n\n.guest-access-popup__title {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  color: $pure-white;\n  line-height: 1.2;\n}\n\n.guest-access-popup__minimize {\n  flex-shrink: 0;\n  margin: 0;\n  padding: 0.35rem 0.75rem;\n  border-radius: 999px;\n  border: 1px solid rgba($very-light-orange, 0.4);\n  background: rgba($very-dark-orange, 0.55);\n  color: rgba($pure-white, 0.92);\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n\n  &:hover,\n  &:focus-visible {\n    background: rgba($orange, 0.45);\n    border-color: rgba($light-orange, 0.55);\n    color: $pure-white;\n  }\n}\n\n.guest-access-popup__empty {\n  margin: 0;\n  padding: 1.25rem 1.1rem;\n  color: rgba($pure-white, 0.75);\n  font-size: 0.88rem;\n}\n\n.guest-access-popup__list {\n  list-style: none;\n  margin: 0;\n  padding: 0.5rem 0;\n}\n\n.guest-access-popup__item {\n  padding: 0.9rem 1.15rem;\n  border-bottom: 1px solid rgba($very-light-grey, 0.1);\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.guest-access-popup__item-layout {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.85rem 1rem;\n}\n\n.guest-access-popup__item-main {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.guest-access-popup__identity {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.4rem 0.55rem;\n}\n\n.guest-access-popup__handle {\n  font-weight: 700;\n  color: $pure-white;\n}\n\n.guest-access-popup__discord {\n  color: rgba($pure-white, 0.72);\n  font-size: 0.85rem;\n}\n\n.guest-access-popup__refusal-badge {\n  min-width: 1.15rem;\n  height: 1.15rem;\n  padding: 0 0.28rem;\n  border-radius: 999px;\n  background: rgba($bright-red, 0.9);\n  color: $pure-white;\n  font-size: 0.7rem;\n  font-weight: 700;\n  line-height: 1.15rem;\n  text-align: center;\n}\n\n.guest-access-popup__meta {\n  margin: 0.3rem 0 0;\n  font-size: 0.76rem;\n  line-height: 1.35;\n  color: rgba($pure-white, 0.52);\n}\n\n.guest-access-popup__decision {\n  display: flex;\n  flex-shrink: 0;\n  border-radius: 999px;\n  overflow: hidden;\n  border: 1px solid rgba($very-light-grey, 0.28);\n  background: rgba($very-dark-grey, 0.65);\n  box-shadow: inset 0 1px 0 rgba($pure-white, 0.06);\n}\n\n.guest-access-popup__decision-btn {\n  margin: 0;\n  padding: 0.42rem 0.85rem;\n  border: none;\n  background: transparent;\n  color: rgba($pure-white, 0.78);\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;\n\n  &:not(:last-child) {\n    border-right: 1px solid rgba($very-light-grey, 0.22);\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n\n  &--grant:not(:disabled):hover,\n  &--grant:not(:disabled):focus-visible {\n    background: rgba($light-green, 0.32);\n    color: $pure-white;\n    box-shadow: inset 0 0 0 1px rgba($light-green, 0.45);\n  }\n\n  &--reject:not(:disabled):hover,\n  &--reject:not(:disabled):focus-visible {\n    background: rgba($bright-red, 0.28);\n    color: $pure-white;\n    box-shadow: inset 0 0 0 1px rgba($bright-red, 0.42);\n  }\n\n  &--grant:not(:disabled):active {\n    background: rgba($light-green, 0.45);\n  }\n\n  &--reject:not(:disabled):active {\n    background: rgba($bright-red, 0.4);\n  }\n}\n","// /src/styles/calendarSignupIntro.scss\n\n.calendar-signup-intro-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 30100;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 4.5rem 1rem 1.5rem;\n  background: rgba($dark-grey, 0.78);\n}\n\n.calendar-signup-intro {\n  width: 100%;\n  max-width: 520px;\n  max-height: #{\"min(78vh, 720px)\"};\n  overflow: auto;\n  border-radius: 16px;\n  border: 1px solid rgba($light-blue, 0.35);\n  background: linear-gradient(\n    180deg,\n    rgba($accent-blue, 0.28) 0%,\n    $blue-grey 110px\n  );\n  box-shadow:\n    0 0 0 1px rgba($pure-black, 0.28),\n    0 24px 64px rgba($pure-black, 0.55);\n  @include scrollbar-styles;\n}\n\n.calendar-signup-intro__header {\n  padding: 1.15rem 1.25rem 0.85rem;\n  border-bottom: 1px solid rgba($very-light-grey, 0.14);\n}\n\n.calendar-signup-intro__eyebrow {\n  margin: 0 0 0.25rem;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: rgba($light-blue, 0.95);\n}\n\n.calendar-signup-intro__title {\n  margin: 0;\n  font-size: 1.35rem;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  color: $pure-white;\n  line-height: 1.2;\n}\n\n.calendar-signup-intro__lead {\n  margin: 0.55rem 0 0;\n  font-size: 0.9rem;\n  line-height: 1.45;\n  color: rgba($pure-white, 0.78);\n}\n\n.calendar-signup-intro__steps {\n  list-style: none;\n  margin: 0;\n  padding: 0.75rem 1.25rem 0.35rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.calendar-signup-intro__step {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n}\n\n.calendar-signup-intro__step-index {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.7rem;\n  height: 1.7rem;\n  border-radius: 999px;\n  background: rgba($light-blue, 0.22);\n  border: 1px solid rgba($light-blue, 0.45);\n  color: $pure-white;\n  font-size: 0.78rem;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.calendar-signup-intro__step-body {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.calendar-signup-intro__step-title {\n  margin: 0.15rem 0 0.25rem;\n  font-size: 0.92rem;\n  font-weight: 700;\n  color: $pure-white;\n}\n\n.calendar-signup-intro__step-text {\n  margin: 0;\n  font-size: 0.84rem;\n  line-height: 1.45;\n  color: rgba($pure-white, 0.72);\n}\n\n.calendar-signup-intro__demo {\n  position: relative;\n  margin-top: 0.75rem;\n  padding: 0.85rem 0.9rem 0.7rem;\n  border-radius: 12px;\n  border: 1px dashed rgba($light-green, 0.45);\n  background: rgba($very-dark-grey, 0.55);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n\n  &--pulse {\n    border-style: solid;\n    border-color: rgba($light-green, 0.7);\n    box-shadow: 0 0 0 3px rgba($light-green, 0.18);\n  }\n}\n\n.calendar-signup-intro__demo-badge {\n  position: absolute;\n  top: -0.55rem;\n  right: 0.75rem;\n  padding: 0.15rem 0.5rem;\n  border-radius: 999px;\n  background: rgba($accent-blue, 0.95);\n  color: $pure-white;\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.calendar-signup-intro__demo-footer {\n  display: flex;\n  justify-content: center;\n  padding: 0.35rem 0 0.15rem;\n}\n\n.calendar-signup-intro__demo-btn {\n  cursor: pointer;\n}\n\n.calendar-signup-intro__demo-hint {\n  margin: 0.55rem 0 0;\n  text-align: center;\n  font-size: 0.78rem;\n  line-height: 1.35;\n  color: rgba($light-green, 0.95);\n\n  &--muted {\n    color: rgba($pure-white, 0.5);\n  }\n}\n\n.calendar-signup-intro__footer {\n  padding: 0.85rem 1.25rem 1.2rem;\n  border-top: 1px solid rgba($very-light-grey, 0.12);\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0.55rem;\n}\n\n.calendar-signup-intro__cta {\n  margin: 0;\n  padding: 0.7rem 1rem;\n  border-radius: 10px;\n  border: 1px solid rgba($light-blue, 0.5);\n  background: rgba($light-blue, 0.28);\n  color: $pure-white;\n  font-size: 0.88rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n\n  &:hover,\n  &:focus-visible {\n    background: rgba($light-blue, 0.4);\n    border-color: rgba($light-blue, 0.7);\n  }\n}\n\n.calendar-signup-intro__footnote {\n  margin: 0;\n  text-align: center;\n  font-size: 0.72rem;\n  line-height: 1.35;\n  color: rgba($pure-white, 0.48);\n}\n","// src/styles/onboarding.scss\n\n@import './variables.scss';\n\n.sr-only {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.onboarding-landing-page {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.onboarding-lp-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.onboarding-lp-card {\n  background: $panel-blue;\n  border: 1px solid $dark-grey;\n  border-radius: 10px;\n  padding: 14px;\n}\n\n.onboarding-lp-cardTitle {\n  margin: 0 0 10px 0;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: $very-light-grey;\n}\n\n.onboarding-lp-fieldGrid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 10px;\n}\n\n.onboarding-lp-brandRow {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n\n  @media (max-width: 900px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.onboarding-lp-inputGroup {\n  display: flex;\n  align-items: stretch;\n  width: 100%;\n  border: 1px solid $dark-grey;\n  border-radius: 8px;\n  background: $dark-panel-blue;\n  overflow: visible;\n}\n\n.onboarding-lp-inputGroup .onboarding-lp-input {\n  flex: 1 1 auto;\n  width: 100%;\n  border: 0;\n  border-radius: 8px 0 0 8px;\n  background: transparent;\n}\n\n.onboarding-lp-inputGroup .onboarding-lp-colorPicker {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n  border-left: 1px solid $dark-grey;\n  position: relative;\n  z-index: 2;\n  overflow: visible;\n}\n\n.onboarding-lp-inputGroup .color-picker-container {\n  display: flex;\n  align-items: stretch;\n  position: relative;\n  overflow: visible;\n}\n\n.onboarding-lp-inputGroup .color-picker-flex {\n  display: flex;\n  align-items: stretch;\n}\n\n.onboarding-lp-inputGroup .colorPicker {\n  width: 40px;\n  height: 100%;\n  border: 0;\n  border-radius: 0 8px 8px 0;\n  cursor: pointer;\n}\n\n.onboarding-lp-inputGroup .colorPicker:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.onboarding-lp-inputWithPicker {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 10px;\n  align-items: center;\n}\n\n.onboarding-lp-colorPicker {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.onboarding-lp-label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 0.85rem;\n  color: $light-grey;\n}\n\n.onboarding-lp-input,\n.onboarding-lp-textarea {\n  width: auto;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid $dark-grey;\n  background: $dark-panel-blue;\n  color: $very-light-grey;\n}\n\n.onboarding-lp-textarea {\n  min-height: 120px;\n  resize: vertical;\n}\n\n.onboarding-lp-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.onboarding-lp-btn {\n  padding: 10px 14px;\n  border-radius: 8px;\n  border: 1px solid $dark-grey;\n  background: $dark-grey;\n  color: $very-light-grey;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    background: $grey;\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.onboarding-lp-btnSecondary {\n  background: transparent;\n  border-color: $dark-grey;\n\n  &:hover:not(:disabled) {\n    background: rgba(255, 255, 255, 0.06);\n  }\n}\n\n\n\n.onboarding-lp-mediaPicker {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 10px;\n}\n\n.onboarding-lp-dropRow {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 10px;\n  align-items: center;\n}\n\n.onboarding-lp-fileName {\n  font-size: 0.85rem;\n  color: $light-grey;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.onboarding-lp-previewWrap {\n  border-radius: 10px;\n  border: 1px solid $dark-grey;\n  background: rgba(0, 0, 0, 0.25);\n  overflow: hidden;\n}\n\n.onboarding-lp-previewRatio {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n}\n\n.onboarding-lp-previewSvg,\n.onboarding-lp-previewVideo {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.onboarding-lp-previewHint {\n  margin: 8px 0 0 0;\n  font-size: 0.82rem;\n  color: $light-grey;\n  line-height: 1.35;\n}\n\n.onboarding-lp-progress {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: center;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.onboarding-lp-bar {\n  height: 10px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.08);\n  overflow: hidden;\n  border: 1px solid $dark-grey;\n}\n\n.onboarding-lp-barFill {\n  height: 100%;\n  background: $blue;\n  width: 0%;\n\n  &.p25 { width: 25%; }\n  &.p50 { width: 50%; }\n  &.p75 { width: 75%; }\n  &.p100 { width: 100%; }\n}\n\n.onboarding-lp-message {\n  font-size: 0.82rem;\n  color: $light-grey;\n}\n\n.onboarding-lp-emptyPreview {\n  padding: 12px;\n}\n\n.onboarding-ending {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.onboarding-ending-threshold {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.onboarding-ending-threshold__label {\n  font-size: 0.88rem;\n  color: $light-grey;\n  white-space: nowrap;\n}\n\n.onboarding-ending-threshold__stepper {\n  display: inline-flex;\n  align-items: stretch;\n  border: 1px solid $dark-grey;\n  border-radius: 8px;\n  overflow: hidden;\n  background: $dark-panel-blue;\n}\n\n.onboarding-ending-threshold__stepBtn {\n  min-width: 40px;\n  padding: 8px 10px;\n  border: 0;\n  border-right: 1px solid $dark-grey;\n  background: $dark-grey;\n  color: $very-light-grey;\n  cursor: pointer;\n  font-size: 1rem;\n  line-height: 1;\n\n  &:last-of-type {\n    border-right: 0;\n    border-left: 1px solid $dark-grey;\n  }\n\n  &:hover:not(:disabled) {\n    background: $grey;\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.onboarding-ending-threshold__input {\n  width: 3.2rem;\n  padding: 8px 6px;\n  border: 0;\n  background: $dark-panel-blue;\n  color: $very-light-grey;\n  text-align: center;\n  font-size: 0.95rem;\n  font-variant-numeric: tabular-nums;\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.onboarding-ending-contentTabs {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 2px;\n  margin-bottom: 12px;\n  border-bottom: 2px solid $dark-grey;\n\n  button {\n    border: 0;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n    padding: 8px 12px;\n    min-width: 90px;\n    color: $light-grey;\n    background-color: $very-dark-grey;\n    cursor: pointer;\n    font-size: 0.88rem;\n\n    &:hover {\n      background-color: $grey;\n    }\n  }\n\n  .is-active {\n    background-color: $grey;\n    color: $very-light-grey;\n    border-bottom: 2px solid $grey;\n    margin-bottom: -2px;\n  }\n}\n\n// -----------------------------------------------------------------------------\n// Admin onboarding — onboarding elements (sections carousel + editor)\n// -----------------------------------------------------------------------------\n\n.onboarding-oe {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.onboarding-oe-loadHint {\n  font-size: 0.85rem;\n  color: $light-grey;\n  margin: 0 0 10px 0;\n}\n\n// Hauteur fixe du carousel + entre carte et scrollbar.\n$onboarding-oe-carousel-band-height: 90px;\n$onboarding-oe-carousel-scrollbar-gap: 5px;\n$onboarding-oe-carousel-item-height: calc(\n  #{$onboarding-oe-carousel-band-height} - #{$onboarding-oe-carousel-scrollbar-gap} - #{$scrollbar-width}\n);\n\n.onboarding-oe-carouselRow {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  width: 958px;\n  max-width: 958px;\n}\n\n.onboarding-oe-carouselViewport {\n  flex: 1;\n  min-width: 0;\n  height: $onboarding-oe-carousel-band-height;\n  min-height: $onboarding-oe-carousel-band-height;\n  max-height: $onboarding-oe-carousel-band-height;\n  overflow-x: auto;\n  overflow-y: hidden;\n  overscroll-behavior-x: contain;\n  padding: 0;\n  box-sizing: border-box;\n  @include scrollbar-horizontal-styles;\n}\n\n.onboarding-oe-carouselTrack {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  gap: 12px;\n  box-sizing: border-box;\n  height: $onboarding-oe-carousel-item-height;\n  min-height: $onboarding-oe-carousel-item-height;\n  max-height: $onboarding-oe-carousel-item-height;\n  width: max-content;\n  padding: 0 2px;\n  margin-bottom: $onboarding-oe-carousel-scrollbar-gap;\n}\n\n.onboarding-oe-carouselArrow {\n  flex: 0 0 25px;\n  width: 25px;\n  align-self: flex-start;\n  margin: 0;\n  padding: 0;\n  border-radius: 8px;\n  border: 1px solid $dark-grey;\n  background: rgba(0, 0, 0, 0.22);\n  color: $very-light-grey;\n  font-size: 1.45rem;\n  font-weight: 700;\n  line-height: 1;\n  cursor: pointer;\n  display: grid;\n  place-items: center;\n  height: $onboarding-oe-carousel-item-height;\n  min-height: $onboarding-oe-carousel-item-height;\n  max-height: $onboarding-oe-carousel-item-height;\n  box-sizing: border-box;\n\n  &:hover:not(:disabled) {\n    border-color: rgba($very-light-grey, 0.35);\n    background: rgba($blue, 0.12);\n    color: $very-light-grey;\n  }\n\n  &:disabled {\n    opacity: 0.32;\n    cursor: default;\n  }\n}\n\n.onboarding-oe-carouselAdd {\n  flex: 0 0 100px;\n  width: 100px;\n  max-width: 100px;\n  height: $onboarding-oe-carousel-item-height;\n  min-height: $onboarding-oe-carousel-item-height;\n  max-height: $onboarding-oe-carousel-item-height;\n  align-self: flex-start;\n  box-sizing: border-box;\n}\n\n.onboarding-oe-sortableWrap {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  box-sizing: border-box;\n  height: $onboarding-oe-carousel-item-height;\n  min-height: $onboarding-oe-carousel-item-height;\n  max-height: $onboarding-oe-carousel-item-height;\n  min-width: 248px;\n  max-width: 312px;\n}\n\n.onboarding-oe-cardGrip {\n  flex: 0 0 30px;\n  margin: 0;\n  padding: 0;\n  border-radius: 12px 0 0 12px;\n  border: 1px solid $dark-grey;\n  border-right: none;\n  background: rgba(0, 0, 0, 0.35);\n  color: $light-grey;\n  cursor: grab;\n  font-size: 0.95rem;\n  font-weight: 700;\n  line-height: 1;\n  display: grid;\n  place-items: center;\n\n  &::before {\n    content: '⋮\\A⋮';\n    white-space: pre;\n    line-height: 0.9;\n    text-align: center;\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n\n  &:hover:not(:disabled) {\n    background: rgba($blue, 0.15);\n    color: $very-light-grey;\n  }\n\n  &:active:not(:disabled) {\n    cursor: grabbing;\n  }\n}\n\n.onboarding-oe-sortableWrap:has(.onboarding-oe-card.is-active) .onboarding-oe-cardGrip {\n  border-top: 1px solid rgba($accent-blue, 0.75);\n  border-left: 1px solid rgba($accent-blue, 0.75);\n  border-bottom: 1px solid rgba($accent-blue, 0.75);\n}\n\n.onboarding-oe-sortableWrap .onboarding-oe-card {\n  flex: 1 1 auto;\n  align-self: stretch;\n  min-width: 0;\n  max-width: none;\n  border-radius: 0 12px 12px 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  box-sizing: border-box;\n}\n\n.onboarding-oe-card {\n  flex: 0 0 auto;\n  min-width: auto;\n  max-width: 280px;\n  padding: 12px;\n  border-radius: 12px;\n  border: 1px solid transparent;\n  border-top: 1px solid rgba($very-light-grey, 0.25);\n  border-right: 1px solid rgba($very-light-grey, 0.25);\n  border-bottom: 1px solid rgba($very-light-grey, 0.25);\n  background: $panel-blue;\n  color: $very-light-grey;\n  text-align: left;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    border: 1px solid transparent;\n    border-top: 1px solid rgba($very-light-grey, 0.45);\n    border-right: 1px solid rgba($very-light-grey, 0.45);\n    border-bottom: 1px solid rgba($very-light-grey, 0.45);\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n\n  &.is-active {\n    border: 1px solid transparent;\n    border-top: 1px solid rgba($accent-blue, 0.9);\n    border-right: 1px solid rgba($accent-blue, 0.9);\n    border-bottom: 1px solid rgba($accent-blue, 0.9);\n    box-shadow: 0 0 0 2px rgba($accent-blue, 0.25);\n  }\n\n  &.is-disabled {\n    opacity: 0.45;\n  }\n}\n\n.onboarding-oe-cardTitle {\n  font-size: 0.95rem;\n  font-weight: 700;\n  margin: 0 0 6px 0;\n}\n\n.onboarding-oe-cardMeta {\n  font-size: 0.82rem;\n  color: $light-grey;\n}\n\n.onboarding-oe-cardAdd {\n  border: 1px dashed rgba($very-light-grey, 0.25);\n  display: grid;\n  place-items: center;\n  text-align: center;\n  background: rgba(0, 0, 0, 0.18);\n\n  &:hover:not(:disabled) {\n    border: 1px dashed rgba($very-light-grey, 0.45);\n  }\n}\n\n.onboarding-oe-addPlus {\n  font-size: 1.6rem;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.onboarding-oe-addLabel {\n  font-size: 0.85rem;\n  color: $light-grey;\n  margin-top: 6px;\n}\n\n.onboarding-oe-body {\n  display: grid;\n  grid-template-columns: 220px 1fr;\n  gap: 14px;\n  align-items: start;\n\n  @media (max-width: 980px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.onboarding-oe-menu {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.onboarding-oe-menuItem {\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  background: rgba(0, 0, 0, 0.18);\n  color: $very-light-grey;\n  font-size: 0.88rem;\n  font-weight: 600;\n  text-align: left;\n  cursor: pointer;\n\n  &:hover {\n    border-color: rgba($very-light-grey, 0.2);\n  }\n\n  &.is-active {\n    border-color: rgba($blue, 0.75);\n    background: rgba($blue, 0.12);\n  }\n\n  &:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n\n    &:hover {\n      border-color: transparent;\n    }\n  }\n}\n\n.onboarding-oe-menu,\n.onboarding-oe-content {\n  background: $panel-blue;\n  border: 1px solid $dark-grey;\n  border-radius: 12px;\n  padding: 14px;\n}\n\n.onboarding-oe-menuTitle {\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: $very-light-grey;\n  margin: 0 0 10px 0;\n}\n\n.onboarding-oe-editorBlock {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  margin-top: 10px;\n}\n\n.onboarding-oe-sectionLabel {\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: $very-light-grey;\n  margin: 14px 0 10px 0;\n}\n\n.onboarding-oe-label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 10px;\n  font-size: 0.85rem;\n  color: $light-grey;\n}\n\n.onboarding-oe-input,\n.onboarding-oe-textarea {\n  width: auto;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid $dark-grey;\n  background: $dark-panel-blue;\n  color: $very-light-grey;\n}\n\n.onboarding-oe-textarea {\n  min-height: 90px;\n  resize: vertical;\n}\n\n.onboarding-oe-toggleRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 0;\n  border-top: 1px solid rgba($dark-grey, 0.8);\n  border-bottom: 1px solid rgba($dark-grey, 0.8);\n  margin: 8px 0 12px 0;\n}\n\n.onboarding-oe-toggleText {\n  flex: 1;\n  min-width: 0;\n}\n\n.onboarding-oe-toggleLabel {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: $very-light-grey;\n}\n\n.onboarding-oe-toggleHint {\n  font-size: 0.8rem;\n  color: $light-grey;\n  margin-top: 2px;\n}\n\n// switch\n.onboarding-oe-switch {\n  position: relative;\n  width: 44px;\n  height: 26px;\n  display: inline-flex;\n}\n\n.onboarding-oe-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.onboarding-oe-slider {\n  position: absolute;\n  inset: 0;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.12);\n  border: 1px solid $dark-grey;\n  transition: background 160ms ease, border-color 160ms ease;\n}\n\n.onboarding-oe-slider:before {\n  content: '';\n  position: absolute;\n  height: 20px;\n  width: 20px;\n  left: 3px;\n  top: 2px;\n  border-radius: 999px;\n  background: $very-light-grey;\n  transition: transform 160ms ease;\n}\n\n.onboarding-oe-switch input:checked + .onboarding-oe-slider {\n  background: rgba($blue, 0.35);\n  border-color: rgba($blue, 0.6);\n}\n\n.onboarding-oe-switch input:checked + .onboarding-oe-slider:before {\n  transform: translateX(18px);\n}\n\n.onboarding-oe-typeGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.onboarding-oe-typeCard {\n  padding: 10px 10px;\n  border-radius: 10px;\n  border: 1px solid $dark-grey;\n  background: rgba(0, 0, 0, 0.18);\n  color: $very-light-grey;\n  cursor: pointer;\n  text-align: left;\n\n  &:hover:not(:disabled) {\n    border-color: rgba($very-light-grey, 0.35);\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n\n  &.is-active {\n    border-color: rgba($blue, 0.9);\n    box-shadow: 0 0 0 2px rgba($blue, 0.25);\n  }\n}\n\n.onboarding-oe-generalActions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-top: 18px;\n  padding-top: 14px;\n  border-top: 1px solid rgba($dark-grey, 0.8);\n}\n\n.onboarding-oe-unsavedHint {\n  font-size: 0.82rem;\n  color: $light-grey;\n  max-width: 42ch;\n  line-height: 1.35;\n}\n\n.onboarding-oe-savedHint {\n  font-size: 0.82rem;\n  color: rgba($green, 0.95);\n  line-height: 1.35;\n}\n\n\n.onboarding-oe-generalActionsLeft {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n\n\n.onboarding-oe-contentTitleRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin: 0 0 8px 0;\n}\n\n.onboarding-oe-contentTitle {\n  font-size: 0.95rem;\n  font-weight: 800;\n  margin: 0 0 8px 0;\n  color: $very-light-grey;\n}\n\n.onboarding-oe-contentTitle--inRow {\n  margin-bottom: 0;\n  flex: 1;\n  min-width: 0;\n}\n\n.onboarding-oe-minimumDwell {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  padding-right: 20px;\n  margin-left: auto;\n}\n\n.onboarding-oe-minimumDwell-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 12px 6px 8px;\n  border-radius: 999px;\n  border: 1px solid rgba($blue, 0.95);\n  background: transparent;\n}\n\n.onboarding-oe-minimumDwell-clock {\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: $blue;\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.onboarding-oe-minimumDwell-clockSvg {\n  width: 14px;\n  height: 14px;\n  display: block;\n}\n\n.onboarding-oe-minimumDwell-pillLabel {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: mix(#fff, $blue, 62%);\n  white-space: nowrap;\n  letter-spacing: 0.01em;\n}\n\n.onboarding-oe-switch.onboarding-oe-switch--dwellPill {\n  position: relative;\n  width: 42px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.onboarding-oe-switch.onboarding-oe-switch--dwellPill input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.onboarding-oe-slider.onboarding-oe-slider--dwellPill {\n  position: absolute;\n  inset: 0;\n  border-radius: 999px;\n  background: rgba($blue, 0.35);\n  border: 1px solid rgba($blue, 0.65);\n  transition: background 160ms ease, border-color 160ms ease;\n}\n\n.onboarding-oe-slider.onboarding-oe-slider--dwellPill:before {\n  content: '';\n  position: absolute;\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  top: 2px;\n  border-radius: 999px;\n  background: #fff;\n  transition: transform 160ms ease;\n}\n\n.onboarding-oe-switch.onboarding-oe-switch--dwellPill input:checked + .onboarding-oe-slider--dwellPill {\n  background: $blue;\n  border-color: rgba($blue, 1);\n}\n\n.onboarding-oe-switch.onboarding-oe-switch--dwellPill input:checked + .onboarding-oe-slider--dwellPill:before {\n  transform: translateX(16px);\n}\n\n.onboarding-oe-switch.onboarding-oe-switch--dwellPill input:focus-visible + .onboarding-oe-slider--dwellPill {\n  outline: 2px solid rgba($blue, 0.85);\n  outline-offset: 2px;\n}\n\n.onboarding-oe-minimumDwell-timeGroup {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.onboarding-oe-dwellTimeInput {\n  box-sizing: border-box;\n  width: 3.35rem;\n  min-width: 0;\n  padding: 8px 10px;\n  border-radius: 6px;\n  border: 1px solid rgba($blue, 0.75);\n  background: rgba(0, 0, 0, 0.28);\n  color: $very-light-grey;\n  font-size: 0.95rem;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  text-align: center;\n  line-height: 1.2;\n\n  &:focus {\n    outline: none;\n    border-color: rgba($blue, 1);\n    box-shadow: 0 0 0 1px rgba($blue, 0.45);\n  }\n\n  &:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n  }\n}\n\n.onboarding-oe-dwellTimeInput.onboarding-oe-dwellTimeInput--minutes {\n  width: 4.1rem;\n}\n\n.onboarding-oe-minimumDwellSep {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: $very-light-grey;\n  align-self: center;\n  padding: 0 2px;\n  user-select: none;\n}\n\n.onboarding-oe-contentHint {\n  font-size: 0.82rem;\n  color: $light-grey;\n  margin: 0 0 12px 0;\n}\n\n.onboarding-oe-contentBox {\n  padding: 12px;\n  border-radius: 10px;\n  border: 1px solid $dark-grey;\n  background: rgba(0, 0, 0, 0.16);\n  color: $very-light-grey;\n  font-size: 0.85rem;\n  display: grid;\n  gap: 6px;\n}\n\n.onboarding-oe-contentPanel {\n  margin-top: 10px;\n}\n\n.onboarding-oe-structureLoading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 120px;\n  padding: 16px;\n}\n\n.onboarding-oe-structureDiagram {\n  overflow-x: auto;\n  max-width: 100%;\n  padding: 8px 0;\n}\n\n.onboarding-oe-structurePanel {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.onboarding-oe-structureTags {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.onboarding-oe-tagChips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  min-height: 30px;\n}\n\n.onboarding-oe-tagChip {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  max-width: 100%;\n  padding: 6px 8px 6px 10px;\n  border: 1px solid rgba($very-light-grey, 0.18);\n  border-radius: 999px;\n  background: rgba($dark-grey, 0.72);\n  color: $very-light-grey;\n  font-size: 0.82rem;\n}\n\n.onboarding-oe-tagChipText {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.onboarding-oe-tagChipRemove {\n  display: inline-grid;\n  place-items: center;\n  width: 18px;\n  height: 18px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.12);\n  color: $very-light-grey;\n  cursor: pointer;\n  line-height: 1;\n\n  &:hover:not(:disabled) {\n    background: rgba($bright-red, 0.82);\n  }\n\n  &:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n  }\n}\n\n.onboarding-oe-structureActions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.onboarding-oe-placeholder {\n  padding: 16px;\n  border-radius: 10px;\n  border: 1px dashed $dark-grey;\n  color: $light-grey;\n  font-size: 0.88rem;\n}\n\n.onboarding-oe-sourcePanel {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.onboarding-oe-sourceActions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.onboarding-oe-select {\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid $dark-grey;\n  background: $dark-panel-blue;\n  color: $very-light-grey;\n}\n\n.onboarding-oe-listError {\n  margin: 0;\n  font-size: 0.82rem;\n  color: $bright-red;\n}\n\n.onboarding-oe-lexicalRoot {\n  margin-top: 6px;\n}\n\n.onboarding-oe-lexicalFooter {\n  margin-top: 12px;\n}\n\n.onboarding-oe-mediaPanel {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.onboarding-oe-mediaHint {\n  margin: 0;\n  font-size: 0.82rem;\n  color: $light-grey;\n  line-height: 1.45;\n}\n\n.onboarding-oe-mediaHint--sub {\n  font-size: 0.78rem;\n  opacity: 0.92;\n}\n\n.onboarding-oe-mediaRow {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.onboarding-oe-fileName {\n  font-size: 0.85rem;\n  color: $light-grey;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n  flex: 1;\n}\n\n.onboarding-oe-mediaPreviewWrap {\n  border-radius: 10px;\n  border: 1px solid $dark-grey;\n  overflow: hidden;\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.onboarding-oe-mediaPreviewRatio {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n}\n\n.onboarding-oe-mediaPreviewImg {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.onboarding-oe-mediaPreviewVideo {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  background: #000;\n}\n\n.onboarding-oe-mediaPreviewEmpty {\n  position: absolute;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  font-size: 0.85rem;\n  color: $light-grey;\n}\n\n.onboarding-oe-mediaGallery-strip {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  gap: 8px;\n  align-items: flex-start;\n  overflow-x: auto;\n  padding: 2px 0 10px;\n  margin-bottom: 2px;\n}\n\n.onboarding-oe-mediaGallery-thumb {\n  position: relative;\n  flex: 0 0 auto;\n  width: 72px;\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  gap: 4px;\n  padding: 4px;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  background: rgba(0, 0, 0, 0.15);\n\n  &.is-active {\n    border-color: rgba(90, 170, 240, 0.7);\n    background: rgba(40, 100, 160, 0.22);\n  }\n}\n\n.onboarding-oe-mediaGallery-dragHandle {\n  flex: 0 0 14px;\n  width: 14px;\n  min-width: 14px;\n  border: none;\n  border-radius: 4px;\n  background: rgba(58, 110, 150, 0.35);\n  color: $very-light-grey;\n  font-size: 10px;\n  line-height: 1;\n  cursor: grab;\n  padding: 2px 0;\n  align-self: stretch;\n\n  &:disabled {\n    opacity: 0.35;\n    cursor: not-allowed;\n  }\n\n  &:active:not(:disabled) {\n    cursor: grabbing;\n  }\n}\n\n.onboarding-oe-mediaGallery-thumbFrame {\n  position: relative;\n  flex: 1;\n  min-width: 0;\n}\n\n.onboarding-oe-mediaGallery-thumbSelect {\n  display: block;\n  width: 100%;\n  padding: 0;\n  border: none;\n  border-radius: 6px;\n  overflow: hidden;\n  background: rgba(0, 0, 0, 0.35);\n  cursor: pointer;\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: default;\n  }\n}\n\n.onboarding-oe-mediaGallery-thumbImg {\n  display: block;\n  width: 100%;\n  height: 48px;\n  object-fit: cover;\n}\n\n.onboarding-oe-mediaGallery-thumbDelete {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  width: 22px;\n  height: 22px;\n  border: none;\n  border-radius: 6px;\n  background: rgba(0, 0, 0, 0.55);\n  color: $very-light-grey;\n  font-size: 15px;\n  line-height: 1;\n  cursor: pointer;\n  display: grid;\n  place-items: center;\n\n  &:hover:not(:disabled) {\n    background: rgba(120, 40, 40, 0.75);\n  }\n\n  &:disabled {\n    opacity: 0.35;\n    cursor: not-allowed;\n  }\n}\n\n.onboarding-oe-mediaPreviewWrap--galleryMain {\n  margin-top: 0;\n}\n\n.onboarding-oe-mediaPreviewRatio--galleryMain {\n  position: relative;\n}\n\n.onboarding-oe-mediaMainDelete {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 2;\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 8px;\n  background: rgba(0, 0, 0, 0.55);\n  color: $very-light-grey;\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n  display: grid;\n  place-items: center;\n\n  &:hover:not(:disabled) {\n    background: rgba(120, 40, 40, 0.82);\n  }\n\n  &:disabled {\n    opacity: 0.35;\n    cursor: not-allowed;\n  }\n}\n\n.onboarding-oe-mediaActions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.onboarding-oe-mediaMsg {\n  margin: 0;\n  font-size: 0.82rem;\n  color: $light-grey;\n}\n\n.onboarding-oe-mediaMsg--warn {\n  color: #e8a854;\n}\n\n.onboarding-oe-btn {\n  padding: 10px 14px;\n  border-radius: 8px;\n  border: 1px solid $dark-grey;\n  background: $dark-grey;\n  color: $very-light-grey;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    background: $grey;\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.onboarding-oe-btnSecondary {\n  background: transparent;\n  border-color: $dark-grey;\n\n  &:hover:not(:disabled) {\n    background: rgba(255, 255, 255, 0.06);\n  }\n}\n\n\n// -----------------------------------------------------------------------------\n// Members onboarding — welcome landing (API-driven copy + background media)\n// -----------------------------------------------------------------------------\n\n.members-onboarding-welcome {\n  box-sizing: border-box;\n  width: 100%;\n  margin-top: 110px;\n  max-width: $full-width;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.members-onboarding-welcome__hero {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: stretch;\n  min-height: #{\"min(68vh, 720px)\"};\n  padding: 2rem 1.35rem 2.5rem;\n  box-sizing: border-box;\n  border-radius: 12px;\n  overflow: hidden;\n  position: relative;\n  isolation: isolate;\n  background-color: $dark-panel-blue;\n  border: 1px solid rgba(52, 90, 120, 0.4);\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.06),\n    0 8px 28px rgba(0, 0, 0, 0.35);\n\n  &:not(.members-onboarding-welcome__hero--has-media) {\n    background-image: linear-gradient(\n      105deg,\n      rgba($dark-blue-grey, 0.94) 0%,\n      rgba($dark-panel-blue, 0.72) 42%,\n      rgba($panel-blue, 0.4) 100%\n    );\n    background-size: cover;\n    background-position: center;\n  }\n\n  @media screen and (min-width: 900px) {\n    min-height: #{\"min(72vh, 780px)\"};\n    padding: 2.5rem 2.25rem 3rem;\n  }\n}\n\n.members-onboarding-welcome__media-layer {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  overflow: hidden;\n  transform: translateZ(0);\n  --mob-focal-x: 50%;\n  --mob-focal-y: 50%;\n}\n\n.members-onboarding-welcome__media-el {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n  object-position: var(--mob-focal-x) var(--mob-focal-y);\n}\n\n.members-onboarding-welcome__media-el--video {\n  pointer-events: none;\n}\n\n/* Dégradé lisibilité : moitié gauche assombrie, droite quasi transparente (média visible).\n   translateZ sur le scrim garde l’overlay au-dessus des <video> dans certains navigateurs. */\n.members-onboarding-welcome__scrim {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  pointer-events: none;\n  width: 100%;\n  height: 100%;\n  transform: translateZ(0);\n  background: linear-gradient(\n    90deg,\n    rgba($dark-blue-grey, 0.99) 0%,\n    rgba($dark-blue-grey, 0.82) 28%,\n    rgba($dark-panel-blue, 0.38) 38%,\n    rgba($dark-panel-blue, 0.06) 45%,\n    rgba(0, 0, 0, 0) 50%,\n    transparent 100%\n  );\n}\n\n.members-onboarding-welcome__hero--has-media .members-onboarding-welcome__scrim {\n  background: linear-gradient(\n    90deg,\n    rgba(2, 6, 12, 0.99) 0%,\n    rgba(6, 12, 20, 0.91) 32%,\n    rgba(10, 18, 28, 0.48) 46%,\n    rgba(12, 22, 34, 0.08) 49.5%,\n    rgba(12, 22, 34, 0) 51%,\n    transparent 55%,\n    transparent 100%\n  );\n}\n\n.members-onboarding-welcome__hero-inner {\n  position: relative;\n  z-index: 2;\n  max-width: 36rem;\n  text-align: left;\n}\n\n.members-onboarding-welcome__loading,\n.members-onboarding-welcome__error {\n  margin: 0 0 0.75rem;\n  font-size: 0.88rem;\n}\n\n.members-onboarding-welcome__error {\n  color: $bright-red;\n}\n\n.members-onboarding-welcome__eyebrow {\n  margin: 0 0 0.35rem;\n  font-size: 0.9rem;\n  font-weight: 800;\n  letter-spacing: 0.28em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.85);\n}\n\n.members-onboarding-welcome__title {\n  margin: 0 0 0.75rem;\n  padding: 0;\n  font-family: 'GoodTimes', 'Lato', sans-serif;\n  font-size: #{\"clamp(1.65rem, 4.5vw, 2.35rem)\"};\n  font-weight: 700;\n  line-height: 1.12;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.members-onboarding-welcome__title-stack {\n  display: inline;\n}\n\n.members-onboarding-welcome__brand-a {\n  color: var(--mob-brand-a, #{$very-light-grey});\n}\n\n.members-onboarding-welcome__brand-b {\n  color: var(--mob-brand-b, #{$very-light-grey});\n}\n\n.members-onboarding-welcome__brand-spacer {\n  white-space: pre;\n}\n\n.members-onboarding-welcome__tagline {\n  margin: 0 0 1rem;\n  font-size: 1rem;\n  font-weight: 600;\n  color: rgba($light-grey, 0.98);\n}\n\n.members-onboarding-welcome__lead {\n  margin: 0 0 1.65rem;\n  font-size: 0.95rem;\n  line-height: 1.55;\n  color: rgba($very-light-grey, 0.88);\n  max-width: 34rem;\n  white-space: pre-line;\n}\n\n/* Bouton type bandeau sci‑fi : coin biseauté à droite (couleurs du thème, pas celles du mock image) */\n.members-onboarding-welcome__cta {\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.65rem 1.35rem 0.65rem 1.25rem;\n  border: none;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: $pure-white;\n  background: linear-gradient(180deg, lighten($bright-red, 4%), darken($red, 4%));\n  box-shadow:\n    0 2px 0 rgba(0, 0, 0, 0.35),\n    0 6px 20px rgba(0, 0, 0, 0.35);\n  clip-path: polygon(0 0, calc(100% - 18px) 0, 100% 50%, calc(100% - 18px) 100%, 0 100%);\n  transition: filter 0.15s ease, box-shadow 0.15s ease;\n\n  &:hover {\n    filter: brightness(1.08);\n    box-shadow:\n      0 2px 0 rgba(0, 0, 0, 0.35),\n      0 8px 26px rgba(0, 0, 0, 0.45);\n  }\n\n  &:focus-visible {\n    outline: 2px solid rgba($accent-blue, 0.85);\n    outline-offset: 3px;\n  }\n}\n\n.members-onboarding-welcome__cta-label {\n  position: relative;\n  top: 0.04em;\n}\n\n.members-onboarding-welcome__cta-arrow {\n  font-size: 1.05em;\n  font-weight: 700;\n  opacity: 0.95;\n}\n\n// -----------------------------------------------------------------------------\n// Members onboarding — ending hero (distinct from dashboard hero card)\n// -----------------------------------------------------------------------------\n\n.members-onboarding-hero {\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n  background:\n    linear-gradient(165deg, rgba($panel-blue, 0.7) 0%, rgba($dark-panel-blue, 0.9) 100%),\n    rgba($dark-panel-blue, 0.95);\n  border: 2px solid rgba($light-blue, 0.25);\n  border-radius: 10px;\n  padding: 0.9rem 1rem 1rem;\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.28) inset,\n    0 10px 26px rgba(0, 0, 0, 0.32);\n}\n\n.members-onboarding-hero__inner {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  gap: 0.85rem;\n}\n\n.members-onboarding-hero__identity {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  flex: 0 0 26%;\n  min-width: 0;\n}\n\n.members-onboarding-hero__avatar-stack {\n  position: relative;\n  width: 108px;\n  height: 108px;\n  flex-shrink: 0;\n  margin-bottom: 0;\n}\n\n.members-onboarding-hero__avatar-discord {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: auto;\n  height: 88px;\n  border-radius: 50%;\n  object-fit: cover;\n  z-index: 1;\n}\n\n.members-onboarding-hero__avatar-frame {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 108px;\n  height: 108px;\n  object-fit: contain;\n  z-index: 2;\n  pointer-events: none;\n}\n\n.members-onboarding-hero__assignment {\n  margin: 0.3rem 0 0;\n  font-size: 0.88rem;\n  line-height: 1.3;\n  color: rgba($light-blue, 1);\n  font-style: italic;\n}\n\n.members-onboarding-hero__divider {\n  width: 1px;\n  flex-shrink: 0;\n  background: linear-gradient(\n    180deg,\n    transparent 0%,\n    rgba($accent-blue, 0.5) 14%,\n    rgba($accent-blue, 0.5) 86%,\n    transparent 100%\n  );\n}\n\n.members-onboarding-hero__meta {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.members-onboarding-hero__rank-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.65rem;\n}\n\n.members-onboarding-hero__rank-icon-slot {\n  flex-shrink: 0;\n  height: 72px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.members-onboarding-hero__rank-icon {\n  max-width: auto;\n  max-height: 52px;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.4));\n}\n\n.members-onboarding-hero__rank-icon--empty {\n  width: 42px;\n  height: 50px;\n  border: 1px dashed rgba($accent-blue, 0.35);\n  border-radius: 4px;\n}\n\n.members-onboarding-hero__rank-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.members-onboarding-hero__rank-name {\n  font-size: 0.98rem;\n  font-weight: 700;\n  color: $pure-white;\n  margin: 0 0 0.12rem;\n  line-height: 1.2;\n  word-break: break-word;\n}\n\n.members-onboarding-hero__pay-grade {\n  margin: 0;\n  font-size: 0.74rem;\n  color: rgba($very-light-grey, 0.85);\n}\n\n// -----------------------------------------------------------------------------\n// Members onboarding — ending (full-width hero, distinct scrim vs welcome)\n// -----------------------------------------------------------------------------\n\n.members-onboarding-ending {\n  box-sizing: border-box;\n  width: 100%;\n  margin-top: 110px;\n  max-width: $full-width;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.members-onboarding-ending__stage {\n  position: relative;\n  isolation: isolate;\n  overflow: hidden;\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: stretch;\n  min-height: #{\"min(68vh, 720px)\"};\n  padding: 2rem 1.35rem 2.5rem;\n  box-sizing: border-box;\n  background-color: $dark-blue-grey;\n  border: 1px solid rgba(52, 90, 120, 0.55);\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.45) inset,\n    0 12px 40px rgba(0, 0, 0, 0.45);\n\n  &:not(.members-onboarding-ending__stage--has-media) {\n    background-image: radial-gradient(\n      120% 90% at 50% 100%,\n      rgba($panel-blue, 0.55) 0%,\n      rgba($dark-panel-blue, 0.92) 45%,\n      rgba($dark-blue-grey, 1) 100%\n    );\n  }\n}\n\n\n.members-onboarding-ending__media-layer {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  overflow: hidden;\n  transform: translateZ(0);\n  --mob-focal-x: 50%;\n  --mob-focal-y: 50%;\n}\n\n.members-onboarding-ending__media-el {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n  object-position: var(--mob-focal-x) var(--mob-focal-y);\n}\n\n.members-onboarding-ending__media-el--video {\n  pointer-events: none;\n}\n\n/* Bottom-heavy vignette + top fade + bande gauche assombrie (50% → 0 au centre horizontal) */\n.members-onboarding-ending__scrim {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  pointer-events: none;\n  width: 100%;\n  height: 100%;\n  transform: translateZ(0);\n  background:\n    linear-gradient(90deg, rgba(black, 1) 0%, rgba(black, 0) 50%),\n    linear-gradient(180deg, rgba(2, 8, 16, 0.88) 0%, rgba(4, 12, 22, 0.35) 28%, transparent 52%),\n    radial-gradient(\n      120% 75% at 50% 100%,\n      rgba(0, 0, 0, 0.72) 0%,\n      rgba(0, 0, 0, 0.38) 42%,\n      rgba(0, 0, 0, 0) 72%\n    );\n}\n\n.members-onboarding-ending__dashboardDock {\n  position: absolute;\n  z-index: 2;\n  /* Moins de marge à gauche sur étroits : évite de tout tasser dans la zone vidéo (sans breakpoint) */\n  left: clamp(0.75rem, 12vw, 11rem);\n  right: 0;\n  top: 0;\n  bottom: 0;\n  padding: 2rem 2rem 2rem 0;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: stretch;\n  height: 100%;\n  pointer-events: none;\n  width: auto;\n  min-width: 0;\n}\n\n.members-onboarding-ending__heroRow {\n  /* 1fr = espace restant à gauche ; hero aligné à droite de cette zone ; events en colonne auto */\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  grid-template-rows: 1fr auto;\n  align-items: start;\n  gap: 1rem;\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n  min-width: 0;\n  pointer-events: auto;\n}\n\n.members-onboarding-ending__heroStack {\n  box-sizing: border-box;\n  pointer-events: auto;\n  justify-self: end;\n  grid-column: 1;\n  grid-row: 1;\n  /* Remplir la 1re colonne du grid jusqu’au plafond (sinon width:auto = contenu seul, max-width ne sert à rien) */\n  width: 100%;\n  max-width: #{\"min(590px, 100%)\"};\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.members-onboarding-ending__websiteCard {\n  width: 100%;\n  max-width: #{\"min(590px, 100%)\"};\n  min-width: 0;\n  box-sizing: border-box;\n  pointer-events: auto;\n  z-index: 3;\n  grid-column: 1;\n  grid-row: 2;\n  justify-self: end;\n  align-self: end;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n/* Même largeur que le bouton (colonne websiteCard) */\n.members-onboarding-ending__websiteTextCard {\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n  padding: 0.95rem 1rem;\n  border-radius: 10px;\n  border: 2px solid rgba($light-blue, 0.25);\n  background:\n    linear-gradient(165deg, rgba($panel-blue, 0.35) 0%, rgba($dark-blue, 0.5) 100%),\n    rgba($dark-panel-blue, 0.78);\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.22) inset,\n    0 8px 22px rgba(0, 0, 0, 0.28);\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.members-onboarding-ending__websiteText {\n  margin: 0;\n  font-size: 0.9rem;\n  line-height: 1.45;\n  color: rgba($very-light-grey, 0.92);\n  white-space: pre-line;\n}\n\n.members-onboarding-ending__officerRows {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.members-onboarding-ending__officerRow {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem 0.85rem;\n}\n\n.members-onboarding-ending__officerChip {\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.35rem;\n  min-width: 0;\n}\n\n.members-onboarding-ending__officerRankIcon {\n  width: auto;\n  max-height: 1.35rem;\n  height: 1.35rem;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n.members-onboarding-ending__officerRankIcon--empty {\n  display: inline-block;\n  width: 1.1rem;\n  height: 1.1rem;\n  box-sizing: border-box;\n  border: 1px dashed rgba($very-light-grey, 0.25);\n  border-radius: 3px;\n}\n\n.members-onboarding-ending__officerName {\n  font-size: 0.86rem;\n  font-weight: 700;\n  line-height: 1.3;\n  color: $pure-white;\n  white-space: nowrap;\n}\n\n.members-onboarding-ending__websiteButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0.9rem 1rem;\n  border-radius: 10px;\n  cursor: pointer;\n  font-family: inherit;\n  text-decoration: none;\n  text-transform: uppercase;\n  color: rgb(220, 169, 169);\n  font-weight: 800;\n  font-size: 1rem;\n  line-height: 1.2;\n  border: 1px solid $red;\n  background: linear-gradient(180deg, #49121285 0%, #9e222275 50%, #49121285 100%);\n  transition: transform 0.1s ease, filter 0.15s ease;\n\n  &:hover {\n    filter: brightness(1.05);\n  }\n\n  &:active {\n    transform: translateY(1px);\n  }\n\n  &:focus-visible {\n    outline: none;\n    box-shadow: 0 0 0 3px rgba($very-light-grey, 0.18);\n  }\n}\n\n/* Bloc unique : en-tête + mini-cards événements */\n.members-onboarding-ending-events {\n  box-sizing: border-box;\n  width: #{\"min(22rem, 100%)\"};\n  max-width: 22rem;\n  min-width: 0;\n  max-height: 367px;\n  grid-column: 2;\n  grid-row: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.members-onboarding-ending-events__status,\n.members-onboarding-ending-events__empty {\n  margin: 0;\n  padding: 0.35rem 0.25rem;\n  font-size: 0.82rem;\n  line-height: 1.4;\n  color: rgba($very-light-grey, 0.88);\n}\n\n.members-onboarding-ending-events__stack {\n  display: flex;\n  flex-direction: column;\n  gap: 0.72rem;\n  min-height: 0;\n  flex: 1 1 auto;\n  overflow-y: auto;\n  @include scrollbar-styles;\n}\n\n.members-onboarding-ending-events__card {\n  box-sizing: border-box;\n  border-radius: 8px;\n  border: 2px solid rgba($light-blue, 0.25);\n  background: rgba($dark-panel-blue, 1);\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.18) inset;\n}\n\n.members-onboarding-ending-events__card--heading {\n  padding: 0.5rem 0.65rem;\n  text-align: center;\n  background: linear-gradient(160deg, $light-panel-blue, $dark-panel-blue);\n}\n\n.members-onboarding-ending-events__card--event {\n  padding: 0.55rem 0.65rem;\n}\n\n.members-onboarding-ending-events__heading {\n  margin: 0;\n  font-size: 0.8rem;\n  font-weight: 800;\n  line-height: 1.25;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.95);\n}\n\n.members-onboarding-ending-events__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.72rem;\n}\n\n.members-onboarding-ending-events__item {\n  margin: 0;\n  padding: 0;\n}\n\n.members-onboarding-ending-events__row {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 0.65rem;\n  min-width: 0;\n}\n\n.members-onboarding-ending-events__banner {\n  width: 50px;\n  height: 50px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  object-fit: cover;\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.members-onboarding-ending-events__banner--placeholder {\n  display: block;\n  box-sizing: border-box;\n  border: 1px dashed rgba($very-light-grey, 0.22);\n  background: rgba(0, 0, 0, 0.15);\n}\n\n.members-onboarding-ending-events__text {\n  flex: 1 1 0;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.members-onboarding-ending-events__name {\n  margin: 0;\n  font-size: 0.86rem;\n  font-weight: 700;\n  line-height: 1.25;\n  color: $pure-white;\n  word-break: break-word;\n}\n\n.members-onboarding-ending-events__datetime {\n  margin: 0;\n  font-size: 0.76rem;\n  line-height: 1.3;\n  color: rgba($medium-light-grey, 0.95);\n}\n\n.members-onboarding-ending-structure {\n  width: 100%;\n  min-width: 0;\n}\n\n.members-onboarding-ending-structure__strip {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  align-items: stretch;\n  gap: 1.15rem;\n  width: 100%;\n  min-width: 0;\n}\n\n/* Same grid idea as `.members-onboarding-structure__card-item`, scaled down */\n.members-onboarding-ending-structure__card-item {\n  display: flex;\n  flex: 1 1 9.25rem;\n  min-width: 0;\n  max-width: 12.5rem;\n  justify-content: flex-end;\n}\n\n/* Outer surface: receives the same dynamic theme classes as structure selection cards */\n.members-onboarding-ending-structure__cardSurface {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 12.5rem;\n  margin-left: auto;\n  margin-right: auto;\n  min-height: 5.25rem;\n  padding: 0.75rem 0.6rem 0.85rem;\n  border-radius: 10px;\n  border: 1px solid rgba(120, 165, 200, 0.7);\n  color: $very-light-grey;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  transition: box-shadow 0.15s ease;\n}\n\n.members-onboarding-ending-structure__cardSurface--neutral {\n  background: rgba(8, 14, 22, 0.72);\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.28);\n}\n\n/* Compact “structure card” body: column layout + smaller logo/titles (no CTA row) */\n.members-onboarding-ending-structure__cardHeader--recap.members-onboarding-structure__card-header {\n  gap: 0.38rem;\n  flex: 1 1 auto;\n}\n\n.members-onboarding-ending-structure__cardHeader--recap .members-onboarding-structure__card-logo {\n  width: 6.75rem;\n  height: 7.35rem;\n}\n\n.members-onboarding-ending-structure__cardHeader--recap .members-onboarding-structure__card-headings {\n  gap: 0.12rem;\n}\n\n.members-onboarding-ending-structure__cardHeader--recap .members-onboarding-structure__breadcrumb-eyebrow {\n  width: 100%;\n  text-align: center;\n}\n\n.members-onboarding-ending-structure__cardHeader--recap .members-onboarding-structure__card-title {\n  font-size: 0.88rem;\n  font-weight: 800;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n}\n\n.members-onboarding-ending-structure__cardHeader--recap .members-onboarding-structure__card-subtitle {\n  font-size: 0.74rem;\n  font-weight: 700;\n}\n\n.members-onboarding-ending__stage--has-media .members-onboarding-ending__scrim {\n  background:\n    linear-gradient(90deg, rgba(black, 0.8) 0%, rgba(black, 0) 60%),\n    linear-gradient(180deg, rgba(2, 6, 14, 0.82) 0%, rgba(6, 14, 24, 0.22) 36%, transparent 58%),\n    radial-gradient(\n      115% 80% at 50% 102%,\n      rgba(0, 0, 0, 0.78) 0%,\n      rgba(0, 0, 0, 0.28) 48%,\n      rgba(0, 0, 0, 0) 74%\n    );\n}\n\n.members-onboarding-ending__inner {\n  position: absolute;\n  z-index: 3;\n  left: 0;\n  top: 2rem;\n  width: #{\"min(33%, 30rem)\"};\n  max-width: #{\"calc(33% - 0.5rem)\"};\n  padding-left: 1.35rem;\n  padding-right: 0.5rem;\n  box-sizing: border-box;\n  margin: 0;\n  text-align: left;\n}\n\n.members-onboarding-ending__copy {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n}\n\n.members-onboarding-ending__welcoming {\n  margin: 0;\n  font-size: 1.5rem;\n  font-weight: 600;\n  line-height: 1.35;\n  color: rgba($light-grey, 0.95);\n}\n\n.members-onboarding-ending__headline {\n  margin: 0;\n  margin-bottom: 1rem;\n  font-family: 'GoodTimes', 'Lato', sans-serif;\n  font-size: 1.4rem;\n  font-weight: 700;\n  line-height: 1.1;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: $very-light-grey;\n}\n\n.members-onboarding-ending__subline {\n  margin: 0;\n  font-size: 1.3rem;\n  font-weight: 600;\n  line-height: 1.35;\n  color: rgba($accent-blue, 0.98);\n}\n\n.members-onboarding-ending__lead {\n  margin: 0;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: rgba($very-light-grey, 0.9);\n  white-space: pre-line;\n}\n\n.members-onboarding-ending__orgLogo {\n  display: block;\n  width: 100%;\n  max-width: 140px;\n  height: auto;\n  margin: 0 0 1.25rem;\n}\n\n.members-onboarding-ending__status {\n  margin: 0 0 0.75rem;\n  font-size: 0.88rem;\n  color: rgba($very-light-grey, 0.92);\n}\n\n.members-onboarding-ending__status--error {\n  color: $bright-red;\n}\n\n// -----------------------------------------------------------------------------\n// Steps checklist page\n// -----------------------------------------------------------------------------\n\n.members-onboarding {\n  box-sizing: border-box;\n}\n\n.members-onboarding__shell {\n  margin-top: 5rem;\n  margin-bottom: 2rem;\n  padding: 1.25rem 1.35rem 1.5rem;\n  border-radius: 10px;\n  border: 1px solid rgba(52, 90, 120, 0.45);\n  background: linear-gradient(180deg, $panel-blue, $dark-panel-blue);\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.35) inset,\n    0 2px 14px rgba(0, 0, 0, 0.25);\n}\n\n.members-onboarding__header {\n  margin-bottom: 1.25rem;\n  text-align: center;\n}\n\n.members-onboarding__title {\n  margin: 0 0 0.35rem;\n  font-size: 1.35rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  color: $very-light-grey;\n  letter-spacing: 0.04em;\n}\n\n.members-onboarding__subtitle {\n  margin: 0;\n  font-size: 0.95rem;\n  color: $light-grey;\n  line-height: 1.45;\n}\n\n.members-onboarding__steps {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.members-onboarding__step {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem 1rem;\n  padding: 0.85rem 1rem;\n  border-radius: 8px;\n  border: 1px solid rgba(58, 110, 150, 0.45);\n  background: rgba(0, 0, 0, 0.12);\n\n  &--done {\n    border-color: rgba(61, 150, 177, 0.55);\n    box-shadow: inset 0 0 0 1px rgba(61, 150, 177, 0.12);\n  }\n}\n\n.members-onboarding__step-body {\n  flex: 1 1 12rem;\n  min-width: 0;\n}\n\n.members-onboarding__step-label {\n  display: block;\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: $light-grey;\n  margin-bottom: 0.25rem;\n}\n\n.members-onboarding__step-desc {\n  margin: 0;\n  font-size: 0.78rem;\n  color: rgba($medium-light-grey, 0.95);\n  line-height: 1.4;\n}\n\n.members-onboarding__step-action {\n  flex-shrink: 0;\n  padding: 0.4rem 0.75rem;\n  border-radius: 6px;\n  border: 1px solid rgba(90, 170, 240, 0.45);\n  background: rgba(40, 100, 160, 0.18);\n  color: lighten($accent-blue, 18%);\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  cursor: pointer;\n\n  &:hover {\n    background: rgba(40, 100, 160, 0.28);\n    color: lighten($accent-blue, 26%);\n  }\n\n  &[aria-pressed='true'] {\n    border-color: rgba(61, 150, 177, 0.65);\n    background: rgba(61, 150, 177, 0.15);\n    color: $very-light-grey;\n  }\n}\n\n.members-onboarding__footer {\n  margin-top: 1.35rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.members-onboarding__continue {\n  padding: 0.55rem 1.35rem;\n  border-radius: 8px;\n  border: none;\n  font-size: 0.88rem;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  cursor: pointer;\n  background: linear-gradient(180deg, lighten($accent-blue, 8%), darken($accent-blue, 6%));\n  color: $pure-white;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);\n\n  &:disabled {\n    opacity: 0.38;\n    cursor: not-allowed;\n    box-shadow: none;\n  }\n\n  &:not(:disabled):hover {\n    filter: brightness(1.06);\n  }\n}\n\n.members-onboarding__hint {\n  margin: 0;\n  font-size: 0.76rem;\n  color: $medium-light-grey;\n}\n\n.members-onboarding__load-hint {\n  margin: 0 0 1rem;\n  text-align: center;\n  font-size: 0.85rem;\n  color: $medium-light-grey;\n}\n\n.members-onboarding__error {\n  margin: 0 0 1rem;\n  text-align: center;\n  font-size: 0.85rem;\n  color: $bright-red;\n}\n\n// Two-column: stepper nav + detail panel (timeline + fused disc / button)\n$mob-stepper-blue: #4dabf7;\n$mob-step-btn-border: rgba(72, 105, 135, 0.38);\n\n.members-onboarding__steps-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 300px) 1fr;\n  gap: 1.5rem;\n  align-items: start;\n\n  /* Panneau principal aligné en hauteur sur la colonne nav quand la vidéo de fond est active,\n     pour pouvoir ancrer tags + validation en bas du panneau. */\n  &:has(.members-onboarding__steps-main--structureDock) {\n    align-items: stretch;\n  }\n\n  @media (max-width: 800px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.members-onboarding__steps-nav {\n  position: sticky;\n  top: 0.5rem;\n  max-width: 300px;\n  width: 100%;\n\n  @media (max-width: 800px) {\n    max-width: none;\n  }\n}\n\n.members-onboarding__steps-nav-panel {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 1.1rem;\n  padding: 0;\n  padding-right: 5px;\n  border-radius: 14px;\n  border: 1px solid $light-panel-blue;\n  background: $dark-panel-blue;\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.04),\n    0 4px 24px rgba(0, 0, 0, 0.22);\n  /* Tall panel so the progress card sits at the bottom (uses margin-top: auto). */\n  min-height: calc(100vh - 473px);\n\n  @media (max-width: 800px) {\n    min-height: 0;\n  }\n}\n\n.members-onboarding__steps-nav-btn-disc--active .members-onboarding__steps-nav-discWrap {\n  filter:\n    drop-shadow(0 0 3px rgba(77, 171, 247, 0.95))\n    drop-shadow(0 0 10px rgba(77, 171, 247, 0.55));\n}\n\n/* Étapes validées : halo vert sur chaque disque (assorti à la bordure verte du bouton),\n   sélectionnée ou non. Déclaré après le halo bleu pour qu’il l’emporte si l’étape est aussi active. */\n.members-onboarding__steps-nav-btn--done .members-onboarding__steps-nav-discWrap {\n  filter:\n    drop-shadow(0 0 3px rgba($green, 0.95))\n    drop-shadow(0 0 10px rgba($green, 0.55));\n}\n\n/* Première étape incomplète (déverrouillée) : halo orange sur le disque, sélectionnée ou non.\n   Spécificité > halo bleu pour qu’il reste visible si cette étape est aussi active. */\n.members-onboarding__steps-nav-btn--next:not(.members-onboarding__steps-nav-btn--done)\n  .members-onboarding__steps-nav-discWrap {\n  filter:\n    drop-shadow(0 0 3px rgba($orange, 0.95))\n    drop-shadow(0 0 10px rgba($orange, 0.55));\n}\n\n.members-onboarding__steps-nav-list {\n  position: relative;\n  max-height: calc(100vh - 605px);\n  margin: 0;\n  margin-top: 5px;\n  padding: 10px 10px 15px 40px;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  overflow-y: auto;\n  @include scrollbar-styles();\n\n  &::before {\n    content: '';\n    position: absolute;\n    left: 1.5rem;\n    top: calc(2.65rem / 2);\n    bottom: calc(2.65rem / 2);\n    width: 3px;\n    margin-left: 1px;\n    border-radius: 1px;\n    background: rgba(72, 82, 96, 0.65);\n    z-index: 0;\n    pointer-events: none;\n  }\n}\n\n.members-onboarding__steps-nav-item {\n  position: relative;\n  z-index: 1;\n  min-width: 0;\n\n  /* gap: on flex is unreliable in some stacks; margin always separates rows */\n  & + & {\n    margin-top: 25px;\n  }\n}\n\n.members-onboarding__steps-nav-discWrap {\n  position: relative;\n  z-index: 1;\n  width: 3.65rem;\n  height: 3.65rem;\n  flex-shrink: 0;\n}\n\n.members-onboarding__steps-nav-discSvg {\n  display: block;\n  width: 100%;\n  height: 100%;\n  /* r=18 dans viewBox 36 : le disque plein va au bord ; strokeWidth 2 déborde légèrement.\n     overflow: visible évite que la moitié extérieure du tracé soit rognée. */\n  overflow: visible;\n}\n\n.members-onboarding__steps-nav-discBg {\n  /* Couleur opaque calée sur le rendu effectif du panneau (rgba(5,10,18,0.55) au-dessus de\n     linear-gradient($panel-blue, $dark-panel-blue)) afin de masquer le trait vertical sous le disque. */\n  fill: #0f1a26;\n}\n\n.members-onboarding__steps-nav-discTrack {\n  stroke: rgba(110, 125, 145, 0.55);\n}\n\n.members-onboarding__steps-nav-discProgress {\n  stroke: $mob-stepper-blue;\n}\n\n.members-onboarding__steps-nav-discLabel {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.78rem;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: -0.02em;\n  color: rgba($medium-light-grey, 0.98);\n  pointer-events: none;\n}\n\n.members-onboarding__steps-nav-discLabel--active {\n  color: rgba($very-light-grey, 0.98);\n}\n\n.members-onboarding__steps-nav-discLabel--locked {\n  opacity: 0.48;\n}\n\n.members-onboarding__steps-nav-btn-disc {\n  flex-shrink: 0;\n  align-self: stretch;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* Colonne disque : hauteur suit le bouton ; fond capsule masque les segments horizontaux\n     de bordure au-dessus / au-dessous du cercle. */\n  width: 3.65rem;\n  min-height: 3.65rem;\n  /* Le centre du disque tombe pile sur l'axe vertical (1.5rem). Le bouton commence à 1.5rem\n     du bord de la liste, padding-left: 0.5rem ; il faut donc reculer de (0.5rem + 1.325rem). */\n  margin-left: -2.2rem;\n  margin-right: 0;\n  position: relative;\n  z-index: 2;\n\n  &::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: -1px;\n    bottom: -1px;\n    z-index: 0;\n    border-radius: 999px;\n    /* Même teinte que .members-onboarding__steps-nav-discBg — recouvre la bordure 1px du bouton. */\n    background: #0f1a26;\n    pointer-events: none;\n  }\n}\n\n.members-onboarding__steps-nav-btn {\n  width: 100%;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.85rem;\n  overflow: visible;\n  /* Pas de padding vertical : la hauteur est dictée par le disque (= min-height). */\n  padding: 0 0.78rem 0 0.5rem;\n  min-height: 2.65rem;\n  border-radius: 0px 10px 10px 0px;\n  border: 1px solid $mob-step-btn-border;\n  background: rgba(12, 18, 28, 0.92);\n  color: rgba($medium-light-grey, 0.95);\n  font-size: 0.8rem;\n  font-weight: 700;\n  text-align: left;\n  cursor: pointer;\n  box-shadow: none;\n  transition:\n    border-color 0.15s ease,\n    background 0.15s ease,\n    color 0.15s ease;\n\n  &:hover {\n    border-color: rgba(100, 155, 205, 0.42);\n    background: rgba(18, 35, 52, 0.72);\n    color: rgba($light-grey, 0.98);\n  }\n\n  &--active {\n    border-color: $mob-step-btn-border;\n    background: rgba(14, 22, 34, 0.94);\n    color: $pure-white;\n\n    &:hover {\n      border-color: rgba(100, 155, 205, 0.38);\n      background: rgba(18, 28, 42, 0.94);\n      color: $pure-white;\n    }\n  }\n\n  /* Étape qui vient d'être déverrouillée (déverrouillée, pas encore validée) : bordure orange. */\n  &--next:not(.members-onboarding__steps-nav-btn--done):not(.members-onboarding__steps-nav-btn--active) {\n    border-color: $orange;\n    background: rgba(16, 26, 38, 0.88);\n\n    &:hover {\n      border-color: lighten($orange, 12%);\n      background: rgba(22, 38, 54, 0.85);\n    }\n  }\n\n  /* Cas particulier : étape déverrouillée ET sélectionnée — la bordure orange l'emporte\n     sur la bordure neutre de --active, le background/color de --active sont conservés. */\n  &--next.members-onboarding__steps-nav-btn--active:not(.members-onboarding__steps-nav-btn--done) {\n    border-color: $orange;\n\n    &:hover {\n      border-color: lighten($orange, 12%);\n    }\n  }\n\n  /* Étape validée : bordure verte. */\n  &--done:not(.members-onboarding__steps-nav-btn--active) {\n    border-color: $green;\n    background: rgba(11, 18, 26, 0.88);\n    opacity: 0.92;\n\n    &:hover {\n      border-color: lighten($green, 12%);\n      background: rgba(18, 30, 44, 0.82);\n    }\n  }\n\n  /* Étape validée ET sélectionnée : on garde le bord vert (le bg/color viennent de --active). */\n  &--done.members-onboarding__steps-nav-btn--active {\n    border-color: $green;\n\n    &:hover {\n      border-color: lighten($green, 12%);\n    }\n  }\n}\n\n.members-onboarding__steps-nav-label {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.members-onboarding__steps-nav-btn--active .members-onboarding__steps-nav-label {\n  font-weight: 800;\n}\n\n.members-onboarding__steps-nav-trailing {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.38rem;\n  min-width: 0;\n}\n\n.members-onboarding__steps-nav-clock {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.12rem;\n  height: 1.12rem;\n  border-radius: 999px;\n  background: rgba($mob-stepper-blue, 0.22);\n  color: rgba($very-light-grey, 0.96);\n}\n\n.members-onboarding__steps-nav-clockSvg {\n  width: 0.66rem;\n  height: 0.66rem;\n  display: block;\n}\n\n.members-onboarding__steps-nav-badge {\n  font-variant-numeric: tabular-nums;\n  font-size: 0.74rem;\n  font-weight: 800;\n  color: rgba($very-light-grey, 0.98);\n}\n\n.members-onboarding__steps-nav-check {\n  flex-shrink: 0;\n  font-size: 0.85rem;\n  font-weight: 800;\n  line-height: 1;\n  color: rgba($green, 0.98);\n}\n\n.members-onboarding__steps-progressCard {\n  /* Toujours collé en bas du panneau, peu importe le nombre d'étapes. */\n  margin-top: auto;\n  padding: 0.85rem 0.95rem;\n  border-radius: 10px;\n  border: 1px solid rgba(58, 95, 125, 0.45);\n  background: rgba(8, 14, 22, 0.65);\n}\n\n.members-onboarding__steps-progressCard-eyebrow {\n  margin: 0 0 0.35rem;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: none;\n  color: rgba($medium-light-grey, 0.95);\n}\n\n.members-onboarding__steps-progressCard-count {\n  margin: 0 0 0.65rem;\n  font-size: 0.95rem;\n  font-weight: 800;\n  color: rgba($very-light-grey, 0.98);\n}\n\n.members-onboarding__steps-progress-meter {\n  display: block;\n  width: 100%;\n  height: 8px;\n  appearance: none;\n  border: none;\n  border-radius: 6px;\n  overflow: hidden;\n  background: rgba(0, 0, 0, 0.35);\n\n  &::-webkit-progress-bar {\n    border-radius: 6px;\n    background: rgba(40, 48, 58, 0.9);\n  }\n\n  &::-webkit-progress-value {\n    border-radius: 6px;\n    background: linear-gradient(90deg, lighten($accent-blue, 8%), $mob-stepper-blue);\n  }\n\n  &::-moz-progress-bar {\n    border-radius: 6px;\n    background: linear-gradient(90deg, lighten($accent-blue, 8%), $mob-stepper-blue);\n  }\n}\n\n.members-onboarding__steps-main {\n  position: relative;\n  min-width: 0;\n  height: stretch;\n  border-radius: 14px;\n  border: 1px solid $light-panel-blue;\n  background: $dark-panel-blue;\n  padding: 1rem 1.05rem 1.1rem;\n}\n\n/* Step « structure » : le panneau remplit la colonne pour ancrer tip/tags/CTA en bas\n   (indépendamment de la présence d’une vidéo HLS — sans ça `--videoBg` seul ne s’appliquait pas). */\n.members-onboarding__steps-main--structureDock {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  align-self: stretch;\n  min-height: calc(100vh - 506px);\n}\n\n.members-onboarding__steps-main--videoBg {\n  overflow: hidden;\n}\n\n.members-onboarding__steps-main--structureDock .members-onboarding__steps-main-body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n/* Grille 1fr / auto : la rangée du bas suit le bord inférieur du panneau dès que la hauteur est connue. */\n.members-onboarding__steps-main--structureDock .members-onboarding-steps__structure-wrap.members-onboarding-structure {\n  flex: 1;\n  min-height: 0;\n  display: grid;\n  grid-template-rows: minmax(0, 1fr) auto;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 0.5rem;\n  align-content: stretch;\n}\n\n.members-onboarding__steps-main--structureDock .members-onboarding-structure__topStack {\n  min-height: 0;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n/* Membership step : le fil d’Ariane + titre en haut, tuiles centrées verticalement. */\n.members-onboarding__steps-main--structureDock .members-onboarding-structure__membership-picker {\n  flex: 1;\n  min-height: 0;\n}\n\n.members-onboarding__steps-main--structureDock .members-onboarding-structure__membership-grid {\n  flex: 1;\n  align-content: center;\n  align-items: center;\n}\n\n.members-onboarding__steps-main--structureDock .members-onboarding-structure__footerDock {\n  align-self: stretch;\n}\n\n.members-onboarding__steps-main-videoBg {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  pointer-events: none;\n  overflow: hidden;\n  border-radius: inherit;\n\n}\n\n.members-onboarding__steps-main-video {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  opacity: 0.5;\n}\n\n.members-onboarding__steps-main-header {\n  margin-bottom: 0.85rem;\n}\n\n.members-onboarding__steps-main-title {\n  margin: 0 0 0.35rem;\n  font-size: 1.05rem;\n  font-weight: 800;\n  color: $very-light-grey;\n}\n\n.members-onboarding__steps-main-desc {\n  margin: 0;\n  font-size: 0.82rem;\n  color: rgba($medium-light-grey, 0.98);\n  line-height: 1.45;\n}\n\n.members-onboarding__steps-main-body {\n  position: relative;\n  z-index: 2;\n  min-width: 0;\n}\n\n.members-onboarding__steps-main-footer {\n  margin-top: 1rem;\n  padding-top: 0.85rem;\n  border-top: 1px solid rgba(58, 110, 150, 0.35);\n}\n\n.members-onboarding__step-action--wide {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 0.55rem 1rem;\n  font-size: 0.78rem;\n}\n\n.members-onboarding-steps__empty {\n  margin: 0;\n  font-size: 0.85rem;\n  color: $medium-light-grey;\n  line-height: 1.45;\n}\n\n.members-onboarding-steps__empty--media {\n  padding: 1rem 0;\n}\n\n/* Wrapper du <PrivateLexicalPage> dans l'onboarding (steps « new » et « existing »).\n   Volontairement décorrélé de `.private-pages` pour pouvoir styler le rendu\n   spécifiquement dans le contexte d'onboarding sans hériter du layout des pages privées. */\n.members-onboarding-steps__doc {\n  margin-top: 0.25rem;\n}\n\n.members-onboarding-steps__structure-wrap {\n  margin-top: 0.25rem;\n}\n\n/* ---------------------------------------------------------------------------\n * Step \"structure\" — selection séquentielle Division → Branch → Section.\n * Conventions :\n * - On n'utilise PAS les couleurs métier (elementColor1/2, elementBorderColor,\n *   elementTextColor) du modèle OrgDivisions : le step a son propre design\n *   neutre, harmonisé avec le reste de l'onboarding.\n * - Les cards reprennent l'image (divisionImageUrl) et les textes\n *   (divisionFullName, elementDetails, divisionDescription).\n * ------------------------------------------------------------------------- */\n\n.members-onboarding-structure {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.members-onboarding-structure__topStack {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.members-onboarding-structure__footerDock {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.members-onboarding-structure__bottomDock {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.members-onboarding-structure__breadcrumb {\n  list-style: none;\n  margin: 0;\n  padding: 0.45rem 0.6rem;\n  display: flex;\n  align-items: stretch;\n  flex-wrap: wrap;\n  gap: 0.35rem 0.55rem;\n  border-radius: 10px;\n  border: 1px solid rgba(58, 110, 150, 0.35);\n  background: rgba(8, 14, 22, 0.55);\n}\n\n.members-onboarding-structure__breadcrumb-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.members-onboarding-structure__breadcrumb-btn {\n  /* Layout horizontal \"mini-card\" : logo à gauche, eyebrow + label empilés à\n     droite. Reprend l'esthétique des cards principales en compact. Pour les\n     items dont la DB a renseigné elementColor1/2, `getStructureBreadcrumbBgClass`\n     injecte par-dessus un override (gradient + bordure thémée + lueur de hover). */\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.35rem 0.65rem 0.35rem 0.4rem;\n  border-radius: 9px;\n  border: 1px solid rgba(120, 165, 200, 0.6);\n  background: rgba(14, 22, 34, 0.94);\n  color: $very-light-grey;\n  font-family: inherit;\n  cursor: pointer;\n  transition:\n    border-color 0.15s ease,\n    background 0.15s ease,\n    color 0.15s ease,\n    transform 0.12s ease,\n    box-shadow 0.15s ease;\n\n  &:hover,\n  &:focus-visible {\n    border-color: rgba($accent-blue, 0.85);\n    background: rgba(18, 28, 42, 0.94);\n    outline: none;\n    transform: translateY(-1px);\n  }\n}\n\n.members-onboarding-structure__breadcrumb-logo {\n  /* Logo flotte sans cadre (cohérent avec la card principale). Taille\n     volontairement bornée pour rester \"breadcrumb\" et pas reproduire la\n     card pleine. */\n  flex-shrink: 0;\n  width: 2.4rem;\n  height: 2.4rem;\n  object-fit: contain;\n  display: block;\n}\n\n/* Pas de règle pour `.members-onboarding-structure__breadcrumb-logo--placeholder` :\n   le modifier est un simple marqueur sémantique ; le span garde le sizing\n   du logo de base et reste invisible, ce qui aligne les items entre eux\n   même quand certaines divisions n'ont pas de logo. */\n\n.members-onboarding-structure__breadcrumb-text {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.05rem;\n  min-width: 0;\n}\n\n.members-onboarding-structure__breadcrumb-eyebrow {\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgba($medium-light-grey, 0.95);\n}\n\n.members-onboarding-structure__breadcrumb-label {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: $very-light-grey;\n  /* Cap visuel + ellipsis : un divisionFullName long ne fait pas exploser\n     le breadcrumb. Le `title` du bouton (JSX) restitue le nom complet au\n     survol. */\n  white-space: nowrap;\n  max-width: 12rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.members-onboarding-structure__breadcrumb-sep {\n  font-size: 1rem;\n  color: rgba($medium-light-grey, 0.7);\n  align-self: center;\n  user-select: none;\n}\n\n.members-onboarding-structure__level-heading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  width: 100%;\n  margin: 0.25rem 0 0;\n\n  box-sizing: border-box;\n  font-size: 0.92rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  text-align: center;\n  color: rgba($very-light-grey, 0.98);\n\n  padding: 0.55rem 0rem;\n  border-radius: 10px;\n  border: 1px solid rgba(58, 110, 150, 0.35);\n  background: rgba(8, 14, 22, 0.55);\n}\n\n.members-onboarding-structure__cards {\n  list-style: none;\n  /* Espace vertical net autour du bloc de grille (en plus du `gap` du parent). */\n  margin: auto 0;\n  /* Léger padding : laisse respirer le fond autour de la grille. */\n  padding: 0.4rem 0.65rem;\n  /* Règle de mise en page :\n     - max 3 cards par rangée (borne par la formule de flex-basis ci-dessous)\n     - cards plafonnées à ~15rem de large : sur conteneur large elles ne\n       s'étirent plus, le reste de la rangée est vide et centré\n     - plus de 3 cards : on enchaîne les rangées, dernière rangée centrée\n     - conteneur étroit (mobile / panneau resserré) : min-width déclenche le\n       flex-wrap, on passe à moins de cards par rangée. */\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 4.75rem;\n}\n\n/* ---------------------------------------------------------------------------\n   Tip rassurant juste sous la grille de cards\n   ---------------------------------------------------------------------------\n   Bannière info avec ampoule + titre + texte secondaire ; le mot \"change\" est\n   accentué via `__tip-accent`. Rendu seulement aux niveaux de sélection (pas\n   au validate level) — voir la condition côté JSX.\n   --------------------------------------------------------------------------- */\n.members-onboarding-structure__tip {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.85rem;\n  margin-top: 0.5rem;\n  padding: 0.85rem 1rem;\n  border-radius: 10px;\n  border: 1px solid rgba(58, 110, 150, 0.35);\n  background: rgba(8, 14, 22, 0.55);\n}\n\n.members-onboarding-structure__tip-icon {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.65rem;\n  height: 1.65rem;\n  /* `currentColor` du svg hérite de cette teinte → un seul endroit à modifier\n     pour ajuster la couleur de l'icône. */\n  color: rgba($medium-light-grey, 0.85);\n}\n\n.members-onboarding-structure__tip-body {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  min-width: 0;\n}\n\n.members-onboarding-structure__tip-title {\n  margin: 0;\n  font-size: 0.92rem;\n  font-weight: 700;\n  line-height: 1.35;\n  color: $very-light-grey;\n}\n\n.members-onboarding-structure__tip-text {\n  margin: 0;\n  font-size: 0.86rem;\n  line-height: 1.4;\n  color: rgba($medium-light-grey, 0.92);\n}\n\n.members-onboarding-structure__tip-accent {\n  /* Emphase visuelle sur \"change\" — pas un vrai lien (pas de href / nav).\n     Si le besoin évolue, remplacer par <a> ou <button> avec ce même className. */\n  color: $accent-blue;\n  font-weight: 700;\n}\n\n.members-onboarding-structure__card-item {\n  display: flex;\n  /* Flex-basis = 1/3 du conteneur (moins les 2 gaps), ce qui borne à\n     3 cards par rangée. `max-width` cap visuellement la largeur d'une card\n     pour qu'elle reste compacte même quand le conteneur est plus large que\n     3 × max-width (le surplus devient de l'espace centré par justify-content). */\n  flex: 1 1 calc((100% - 5.5rem) / 3);\n  max-width: 15rem;\n  min-width: 12rem;\n}\n\n/* Membership titles — compact text tiles (no logo / no org card CTA). */\n.members-onboarding-structure__membership-picker {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.85rem;\n}\n\n.members-onboarding-structure__membership-hint {\n  width: 100%;\n  margin: 0;\n  font-size: 0.84rem;\n  line-height: 1.4;\n  text-align: center;\n  color: rgba($medium-light-grey, 0.95);\n}\n\n.members-onboarding-structure__membership-heading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin: 0.25rem 0 0;\n  box-sizing: border-box;\n  font-size: 0.92rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  text-align: center;\n  color: rgba($very-light-grey, 0.98);\n  padding: 0.55rem 0rem;\n  border-radius: 10px;\n  border: 1px solid rgba(58, 110, 150, 0.35);\n  background: rgba(8, 14, 22, 0.55);\n}\n\n.members-onboarding-structure__membership-grid {\n  list-style: none;\n  margin: auto 0;\n  padding: 0.15rem 0.35rem;\n  width: stretch;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-content: center;\n  gap: 0.65rem 0.75rem;\n}\n\n.members-onboarding-structure__membership-item {\n  display: flex;\n  flex: 0 1 auto;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.members-onboarding-structure__membership-card {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 2.75rem;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  border: 1px solid rgba(120, 165, 200, 0.55);\n  background: rgba(8, 14, 22, 0.72);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.22);\n  color: $very-light-grey;\n  font-family: inherit;\n  cursor: pointer;\n  transition:\n    border-color 0.15s ease,\n    background 0.15s ease,\n    box-shadow 0.15s ease,\n    transform 0.12s ease;\n\n  &:hover,\n  &:focus-visible {\n    border-color: rgba($accent-blue, 0.85);\n    background: rgba(14, 22, 34, 0.88);\n    outline: none;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.32);\n  }\n\n  &:active {\n    transform: translateY(0);\n  }\n\n  &--selected {\n    border-color: rgba($light-green, 0.95);\n    background: rgba(22, 44, 14, 0.92);\n    box-shadow: 0 0 0 1px rgba($light-green, 0.4), 0 4px 14px rgba(0, 0, 0, 0.28);\n  }\n}\n\n.members-onboarding-structure__membership-label {\n  font-size: 0.88rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  line-height: 1.2;\n  text-align: center;\n  word-break: break-word;\n}\n\n.members-onboarding-structure__membership-empty {\n  width: 100%;\n  margin: 0;\n  padding: 0.65rem 0.85rem;\n  font-size: 0.88rem;\n  line-height: 1.45;\n  text-align: center;\n  color: rgba($medium-light-grey, 0.95);\n  border-radius: 10px;\n  border: 1px solid rgba(58, 110, 150, 0.35);\n  background: rgba(8, 14, 22, 0.55);\n}\n\n.members-onboarding-structure__card {\n  display: flex;\n  flex-direction: column;\n  /* space-between : header collé en haut, CTA collé en bas — le vide central\n     absorbe les différences de hauteur de contenu entre cards d'une rangée. */\n  justify-content: space-between;\n  gap: 0.85rem;\n  width: 100%;\n  min-width: 0;\n  /* Hauteur unifiée : logo + titre/sous-titre + CTA + paddings.\n     Garde une grille visuelle stable même si certaines cards ont moins de\n     contenu textuel. */\n  min-height: 15rem;\n  padding: 1rem 0.9rem 0.9rem;\n  border-radius: 10px;\n  /* Bord neutre par défaut, volontairement plus lumineux (opacité 0.7) qu'un\n     liseré discret pour que la card ressorte du fond sombre. Les cards\n     thématisées (gradient depuis la DB) écrasent border-color + box-shadow\n     via la règle dynamique injectée par `getStructureCardBgClass`. */\n  border: 1px solid rgba(120, 165, 200, 0.7);\n  background: rgba(8, 14, 22, 0.7);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.28);\n  color: $very-light-grey;\n  text-align: left;\n  font-family: inherit;\n  cursor: pointer;\n  transition:\n    border-color 0.15s ease,\n    background 0.15s ease,\n    transform 0.12s ease,\n    box-shadow 0.15s ease;\n\n  &:hover,\n  &:focus-visible {\n    border-color: rgba($accent-blue, 0.85);\n    background: rgba(14, 22, 34, 0.85);\n    outline: none;\n    box-shadow: 0 6px 22px rgba(0, 0, 0, 0.4);\n    transform: translateY(-1px);\n  }\n\n  &:active {\n    transform: translateY(0);\n  }\n}\n\n.members-onboarding-structure__card-header {\n  /* Layout vertical : logo en haut centré, puis titres dessous. */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.55rem;\n  min-width: 0;\n}\n\n.members-onboarding-structure__card-logo {\n  /* Pas de cadre (background / border / border-radius) : le logo flotte\n     directement sur le gradient de la card. `object-fit: contain` garantit\n     que les logos non carrés ne se déforment pas. */\n  flex-shrink: 0;\n  min-width: 4rem;\n  min-height: 4rem;\n  max-width: 5rem;\n  max-height: 5rem;\n  object-fit: contain;\n  display: block;\n}\n\n/* Pas de règle pour `.members-onboarding-structure__card-logo--placeholder` :\n   le modifier sert uniquement de marqueur sémantique en JSX. Le span hérite\n   du sizing de `.members-onboarding-structure__card-logo` et reste visuellement\n   invisible (pas de background / border) — ça réserve l'emplacement du logo\n   pour aligner les titres entre cards avec/sans logo dans une même rangée. */\n\n.members-onboarding-structure__card-headings {\n  min-width: 0;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  text-align: center;\n}\n\n.members-onboarding-structure__card-title {\n  /* Titre principal mis en avant : plus gros, jusqu'à 2 lignes maxi avant\n     troncature avec ellipsis (line-clamp WebKit, supporté Chrome/FF/Safari). */\n  font-size: 1.05rem;\n  font-weight: 800;\n  line-height: 1.25;\n  color: $very-light-grey;\n  word-break: break-word;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.members-onboarding-structure__card-subtitle {\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: rgba($medium-light-grey, 0.95);\n  word-break: break-word;\n}\n\n.members-onboarding-structure__card-cta {\n  /* CTA visuel en bas de chaque card. Toujours rendu comme un <span> (et non\n     un <button>) car la card elle-même est déjà un <button> cliquable — nest\n     button-in-button est interdit en HTML. C'est purement de l'affordance\n     visuelle, le clic est géré par le <button> parent.\n\n     Affiche deux labels enfants (`__card-cta-default` / `__card-cta-hover`) :\n     un seul est visible à la fois, le swap se fait en CSS pur sur l'état\n     `:hover` / `:focus-visible` du bouton parent (.__card). Aucun state React\n     impliqué.\n\n     Couleurs fallback neutres pour les cards sans elementColor1/2 en DB ;\n     pour les cards thématisées, `getStructureCardBgClass` injecte un\n     override (border-color + color) via une règle CSS dynamique. */\n  display: block;\n  //width: 100%;\n  margin-top: auto;\n  padding: 0.45rem 0.75rem;\n  border-radius: 8px;\n  border: 1px solid rgba($medium-light-grey, 0.65);\n  background: transparent;\n  color: $very-light-grey;\n  text-align: center;\n  font-family: inherit;\n  font-size: 0.9rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  line-height: 1.2;\n}\n\n.members-onboarding-structure__card-cta-default {\n  display: inline;\n}\n\n.members-onboarding-structure__card-cta-hover {\n  display: none;\n}\n\n/* Swap des labels au survol / focus clavier de la card parente. On scope sur\n   `.__card` (pas sur `.__card-cta`) pour que le toggle suive l'état du\n   bouton entier, pas seulement celui du span — sinon survoler le texte ferait\n   clignoter le swap quand le pointer entre/sort de la zone du span. */\n.members-onboarding-structure__card {\n  &:hover,\n  &:focus-visible {\n    .members-onboarding-structure__card-cta-default {\n      display: none;\n    }\n    .members-onboarding-structure__card-cta-hover {\n      display: inline;\n    }\n  }\n}\n\n/* ---------------------------------------------------------------------------\n   Tags du step \"structure\" — sélection multi-chip\n   ---------------------------------------------------------------------------\n   Sélecteur de tags affiché en bas du step (sous le fil d'Ariane, la grille\n   de cards et l'éventuel CTA de validation), toujours visible quel que soit\n   le niveau de navigation. Le composant React enforce la fourchette\n   [STRUCTURE_TAGS_MIN, STRUCTURE_TAGS_MAX] : au max atteint, les chips\n   non-sélectionnées passent à l'état `--locked` (DOM `disabled`).\n   --------------------------------------------------------------------------- */\n.members-onboarding-structure__tags-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n  padding: 0.95rem 1rem 0.85rem;\n  margin-top: 0.35rem;\n  border-radius: 10px;\n  border: 1px solid rgba(58, 110, 150, 0.35);\n  background: rgba(8, 14, 22, 0.55);\n}\n\n.members-onboarding-structure__tags-help {\n  margin: 0;\n  font-size: 0.9rem;\n  line-height: 1.45;\n  color: rgba($medium-light-grey, 0.98);\n}\n\n.members-onboarding-structure__tags {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem 0.5rem;\n}\n\n.members-onboarding-structure__tag-item {\n  display: flex;\n}\n\n.members-onboarding-structure__tag {\n  /* Chip pill cliquable. Le state \"--selected\" passe sur du remplissage\n     accent ; \"--locked\" baisse l'opacité et coupe le pointer pour signaler\n     que la limite max est atteinte. */\n  display: inline-flex;\n  align-items: center;\n  padding: 0.35rem 0.78rem;\n  border-radius: 999px;\n  border: 1px solid rgba(58, 110, 150, 0.5);\n  background: rgba(0, 0, 0, 0.3);\n  color: rgba($very-light-grey, 0.92);\n  font-family: inherit;\n  font-size: 0.85rem;\n  font-weight: 600;\n  line-height: 1.2;\n  cursor: pointer;\n  transition:\n    border-color 0.15s ease,\n    background 0.15s ease,\n    color 0.15s ease,\n    box-shadow 0.15s ease;\n\n  &:hover:not(:disabled),\n  &:focus-visible:not(:disabled) {\n    border-color: rgba($accent-blue, 0.75);\n    background: rgba(14, 22, 34, 0.85);\n    outline: none;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.28);\n  }\n\n  &--selected,\n  &--selected:hover,\n  &--selected:focus-visible {\n    border-color: $accent-blue;\n    background: rgba($accent-blue, 0.22);\n    color: $very-light-grey;\n    box-shadow: 0 0 0 1px rgba($accent-blue, 0.45);\n  }\n\n  &--locked,\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.4;\n    box-shadow: none;\n  }\n}\n\n.members-onboarding-structure__tags-count {\n  margin: 0;\n  font-size: 0.78rem;\n  color: rgba($medium-light-grey, 0.9);\n}\n\n.members-onboarding-structure__validate-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n  padding: 0.95rem 1rem;\n  border-radius: 10px;\n  border: 1px solid rgba(58, 110, 150, 0.35);\n  background: rgba(8, 14, 22, 0.55);\n}\n\n.members-onboarding-structure__validate-help {\n  margin: 0;\n  font-size: 0.85rem;\n  line-height: 1.45;\n  color: rgba($medium-light-grey, 0.98);\n}\n\n.members-onboarding-structure__cta {\n  align-self: flex-start;\n  padding: 0.6rem 1.4rem;\n  border-radius: 8px;\n  border: none;\n  font-family: inherit;\n  font-size: 0.88rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  color: $pure-white;\n  background: linear-gradient(180deg, lighten($accent-blue, 8%), darken($accent-blue, 6%));\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);\n  cursor: pointer;\n  transition: filter 0.15s ease, box-shadow 0.15s ease, transform 0.12s ease;\n\n  &:hover:not(:disabled),\n  &:focus-visible:not(:disabled) {\n    filter: brightness(1.08);\n    outline: none;\n  }\n\n  &:active:not(:disabled) {\n    transform: translateY(1px);\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n    box-shadow: none;\n  }\n}\n\n.members-onboarding-steps__error {\n  margin: 0;\n  font-size: 0.85rem;\n  color: rgba(#e98686, 0.95);\n}\n\n.members-onboarding-steps__media-pagination {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem 0.65rem;\n  width: auto;\n  padding: 0.65rem 0.85rem;\n  border-radius: 10px;\n  border: 1px solid rgba(58, 110, 150, 0.38);\n  background: rgba(0, 0, 0, 0.22);\n}\n\n.members-onboarding-steps__media-pageArrow {\n  min-width: 2rem;\n  height: 2rem;\n  padding: 0 0.45rem;\n  border-radius: 6px;\n  border: 1px solid rgba(58, 110, 150, 0.45);\n  background: rgba(40, 100, 160, 0.2);\n  color: $very-light-grey;\n  font-size: 0.95rem;\n  font-weight: 800;\n  line-height: 1;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    background: rgba(40, 100, 160, 0.35);\n  }\n\n  &:disabled {\n    opacity: 0.35;\n    cursor: not-allowed;\n  }\n}\n\n.members-onboarding-steps__media-pageNums {\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n}\n\n.members-onboarding-steps__media-pageNum {\n  min-width: 1.85rem;\n  height: 1.85rem;\n  padding: 0 0.35rem;\n  border-radius: 6px;\n  border: 1px solid rgba(58, 110, 150, 0.35);\n  background: rgba(0, 0, 0, 0.2);\n  color: $medium-light-grey;\n  font-size: 0.82rem;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  cursor: pointer;\n\n  &.is-active {\n    border-color: rgba(90, 170, 240, 0.75);\n    color: $very-light-grey;\n    background: rgba(40, 100, 160, 0.35);\n  }\n\n  &.is-viewed:not(.is-active) {\n    color: rgba($very-light-grey, 0.88);\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: default;\n  }\n}\n\n.members-onboarding-steps__media-galleryHint {\n  margin: 0.55rem 0 0;\n  font-size: 0.8rem;\n  line-height: 1.45;\n  text-align: center;\n  color: rgba($medium-light-grey, 0.98);\n}\n\n.members-onboarding-steps__media-layer {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  border-radius: 8px;\n  border: 1px solid rgba(58, 110, 150, 0.35);\n  background: rgba(0, 0, 0, 0.25);\n  line-height: 0;\n}\n\n.members-onboarding-steps__media-img {\n  display: block;\n  width: 100%;\n  height: auto;\n  max-width: 100%;\n}\n\n.members-onboarding-steps__media-video-wrap {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  overflow: hidden;\n  border-radius: 8px;\n  border: 1px solid rgba(58, 110, 150, 0.35);\n  background: rgba(0, 0, 0, 0.25);\n}\n\n.members-onboarding-steps__media-video {\n  position: absolute;\n  inset: 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: var(--mob-step-focal-x, 50%) var(--mob-step-focal-y, 50%);\n}\n\n/* Lexical “read to end” sentinel (PrivateLexicalPage) */\n.private-rte-read-stack {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.private-rte-read-sentinel {\n  flex-shrink: 0;\n  width: 100%;\n  height: 4px;\n  margin-top: 0.35rem;\n  pointer-events: none;\n}\n\n.private-rte-read-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem 1rem;\n  align-items: baseline;\n  margin-bottom: 0.65rem;\n  padding: 0.45rem 0.55rem;\n  border-radius: 8px;\n  border: 1px solid rgba(58, 110, 150, 0.4);\n  background: rgba(0, 0, 0, 0.14);\n  font-size: 0.78rem;\n  color: rgba($medium-light-grey, 0.98);\n  line-height: 1.35;\n}\n\n.private-rte-read-meta-item {\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 0.25rem;\n}\n\n.private-rte-read-meta-value {\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  color: $very-light-grey;\n}\n\n.private-rte-read-meta-ok {\n  color: lighten($accent-blue, 12%);\n  font-weight: 700;\n}\n\n.members-onboarding__steps-nav-btn--locked {\n  cursor: not-allowed;\n  /* Bordure atténuée pour signaler le verrouillage.\n     IMPORTANT : on n'utilise plus `opacity` sur le bouton entier — sinon le fond opaque du\n     disque (.members-onboarding__steps-nav-discBg) descendait sous 100 %, et le trait\n     vertical de fond apparaissait à travers le disque. */\n  border-color: rgba(72, 105, 135, 0.18);\n\n  /* On atténue uniquement les éléments textuels du bouton ; le disque garde son fond\n     opaque qui masque le trait. La pastille « 01 » est de son côté déjà dimmée par\n     `.members-onboarding__steps-nav-discLabel--locked`. */\n  .members-onboarding__steps-nav-label,\n  .members-onboarding__steps-nav-trailing {\n    opacity: 0.55;\n  }\n\n  &:hover {\n    border-color: rgba(58, 110, 150, 0.32);\n    background: rgba(0, 0, 0, 0.14);\n  }\n}\n\n.members-onboarding__steps-nav-btn:disabled {\n  pointer-events: none;\n}\n\n.members-onboarding-steps__structure-note {\n  margin: 0 0 0.75rem;\n  font-size: 0.8rem;\n  color: rgba($medium-light-grey, 0.95);\n  line-height: 1.45;\n}\n\n.members-onboarding-steps__media-image-block {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.members-onboarding-steps__media-locked-hint,\n.members-onboarding-steps__video-locked-hint {\n  margin: 0;\n  font-size: 0.78rem;\n  color: $medium-light-grey;\n}\n\n.members-onboarding-steps__image-timer {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n}\n\n.members-onboarding-steps__image-timer-svg {\n  width: 52px;\n  height: 52px;\n  flex-shrink: 0;\n}\n\n.members-onboarding-steps__image-timer-track {\n  fill: none;\n  stroke: rgba(58, 110, 150, 0.35);\n  stroke-width: 6;\n}\n\n.members-onboarding-steps__image-timer-fill {\n  fill: none;\n  stroke: lighten($accent-blue, 6%);\n  stroke-width: 6;\n  stroke-linecap: round;\n  transform-origin: 44px 44px;\n}\n\n.members-onboarding-steps__image-timer-count {\n  font-size: 1.1rem;\n  font-weight: 800;\n  color: $very-light-grey;\n  min-width: 1.5rem;\n  text-align: center;\n}\n\n.members-onboarding-steps__image-timer-hint {\n  font-size: 0.75rem;\n  color: $medium-light-grey;\n}\n\n.members-onboarding-steps__restricted-video {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.members-onboarding-steps__video-controlBar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.65rem 1rem;\n  padding: 0.65rem 0.85rem;\n  border-radius: 10px;\n  border: 1px solid rgba(58, 110, 150, 0.38);\n  background: rgba(0, 0, 0, 0.22);\n}\n\n.members-onboarding-steps__video-controlBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 3rem;\n  min-height: 3rem;\n  padding: 0.35rem;\n  border-radius: 10px;\n  border: 1px solid rgba(90, 170, 240, 0.5);\n  background: rgba(40, 100, 160, 0.22);\n  color: lighten($accent-blue, 20%);\n  cursor: pointer;\n  line-height: 0;\n\n  &:hover:not(:disabled) {\n    background: rgba(40, 100, 160, 0.34);\n    border-color: rgba(110, 190, 255, 0.55);\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.members-onboarding-steps__video-controlBtn--playPause {\n  width: 2.15rem;\n  height: 2.15rem;\n}\n\n.members-onboarding-steps__video-iconSvg {\n  width: 1.65rem;\n  height: 1.65rem;\n  display: block;\n}\n\n.members-onboarding-steps__video-iconSvg--rewind {\n  width: 2.15rem;\n  height: 2.15rem;\n}\n\n.members-onboarding-steps__video-time {\n  font-size: 0.78rem;\n  color: $light-grey;\n  font-variant-numeric: tabular-nums;\n}\n\n.members-onboarding-steps__video-hint {\n  margin: 0;\n  font-size: 0.75rem;\n  color: $medium-light-grey;\n  line-height: 1.4;\n}\n","// src/styles/divisionMedia.scss\n\n@import './variables.scss';\n\n.division-media {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 14px;\n  padding: 14px;\n  background: $panel-blue;\n  border: 1px solid $dark-grey;\n  border-radius: 10px;\n}\n\n.division-media__title {\n  margin: 0 0 4px 0;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: $very-light-grey;\n}\n\n.division-media__hint {\n  margin: 0;\n  font-size: 0.8rem;\n  color: $light-grey;\n  line-height: 1.35;\n}\n\n.division-media__hint--warning {\n  color: rgb(255, 166, 0);\n}\n\n.division-media__picker {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 10px;\n}\n\n.division-media__dropRow {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 10px;\n  align-items: center;\n}\n\n.division-media__fileName {\n  font-size: 0.85rem;\n  color: $light-grey;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.division-media__previewWrap {\n  border-radius: 10px;\n  border: 1px solid $dark-grey;\n  background: rgba(0, 0, 0, 0.25);\n  overflow: hidden;\n}\n\n.division-media__previewRatio {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n}\n\n.division-media__previewVideo {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.division-media__empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  padding: 12px;\n  font-size: 0.85rem;\n  color: $light-grey;\n  text-align: center;\n}\n\n.division-media__progress {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: center;\n  gap: 10px;\n  margin-top: 4px;\n}\n\n.division-media__bar {\n  height: 10px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.08);\n  overflow: hidden;\n  border: 1px solid $dark-grey;\n}\n\n.division-media__barFill {\n  height: 100%;\n  background: $blue;\n  width: 0%;\n\n  &.p25 { width: 25%; }\n  &.p50 { width: 50%; }\n  &.p75 { width: 75%; }\n  &.p100 { width: 100%; }\n}\n\n.division-media__message {\n  font-size: 0.82rem;\n  color: $light-grey;\n}\n\n.division-media__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 6px;\n}\n\n.division-media__btn {\n  padding: 10px 14px;\n  border-radius: 8px;\n  border: 1px solid $dark-grey;\n  background: $dark-grey;\n  color: $very-light-grey;\n  cursor: pointer;\n  font-size: 0.8rem;\n  font-weight: 600;\n\n  &:hover:not(:disabled) {\n    background: $grey;\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.division-media__btn--secondary {\n  background: transparent;\n  border-color: $dark-grey;\n\n  &:hover:not(:disabled) {\n    background: rgba(255, 255, 255, 0.06);\n  }\n}\n\n.division-media__btn--danger {\n  background: $dark-red;\n  border-color: $dark-red;\n\n  &:hover:not(:disabled) {\n    background: $bright-red;\n    border-color: $bright-red;\n  }\n}\n\n.division-media__fileInput {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.division-media-trigger-row {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n\n.modal.division-media-modal {\n  position: fixed;\n  background: $panel-blue;\n  color: $very-light-grey;\n  padding: 18px 20px 20px 20px;\n  border: 1px solid $dark-grey;\n  border-radius: 10px;\n  max-width: 720px;\n  width: 90%;\n  max-height: 85vh;\n  height: max-content;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  overflow-y: auto;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.55);\n  outline: none;\n}\n\n.division-media-modal__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid $dark-grey;\n}\n\n.division-media-modal__title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n  color: $very-light-grey;\n}\n\n.division-media-modal__close {\n  background: transparent;\n  border: 0;\n  color: $light-grey;\n  font-size: 1.2rem;\n  line-height: 1;\n  cursor: pointer;\n  padding: 4px 10px;\n  border-radius: 4px;\n\n  &:hover:not(:disabled) {\n    background: rgba(255, 255, 255, 0.06);\n    color: $very-light-grey;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n","/* settings.scss*/\n\n@import './variables.scss';\n\n.settings-h2 {\n    color: $light-grey; \n    text-transform: uppercase;\n    margin-top: 20px;\n    margin-bottom: 0px;\n}\n\n.settings-h3 {\n    color: $very-light-grey;\n    text-transform: uppercase;\n    margin-top: 15px;\n    margin-bottom: 10px;\n}\n\n.user-settings-content {\n    flex-grow: 1; // Prend l'espace restant après la sidebar\n    color: $very-light-grey;\n    padding: 0 20px;\n    width: 100%; \n}\n\n.user-settings-container {\n    display: flex;\n    flex-direction: column;\n    //align-items: flex-start;\n    width: 100%;\n}\n\n.user-settings-page {\n    //max-width: $desktop;\n    @include width;\n    margin: 30px auto; // Centré horizontalement\n\n}\n\n.settings-container {\n    display: flex;\n    flex-direction: row; /* Les éléments enfants seront alignés horizontalement */\n}\n\n.user-settings-content-wrapper {\n    display: flex;\n    margin-left: 10px;\n    margin-bottom: 30px;\n    padding-bottom: 30px;\n    width: calc(100% - 225px);\n    height: auto;\n    top: 40px;\n    gap: 20px; \n    border-radius: 0px 10px 10px 10px;\n    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);\n    flex-grow: 1;\n}\n\n\n%section-border {\n    position: relative;\n    color: $very-light-grey;\n    width: 100%;\n    text-transform: uppercase;\n    font-size: 0.9rem;\n    border-bottom: 2px solid $light-grey;\n\n    &::before {\n        content: \"\";\n        position: absolute;\n        bottom: -5px;\n        left: 0;\n        width: 130px;\n        height: 4px;\n        background-color: $light-grey;\n    }\n}\n\n.user-settings-section {\n    @extend %section-border;\n        margin: 10px 0;\n}\n\n.last-line  {\n    margin-bottom: 40px;\n}\n\n.selection-style {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 20px;\n    padding: 20px 0;\n    width: 100%;\n    border-bottom: 1px solid $grey;\n\n    label {\n        color: $very-light-grey;\n        width: 150px;\n        margin-right: 10px;\n    }\n\n    select, .toggle-container {\n        margin-right: auto;\n        margin-left: 50px;\n    }\n}\n\n","/* settingmenu.scss (la sidebar) */\n\n@import './variables.scss';\n\n.user-settings-sidebar {\n    flex-shrink: 0;\n}\n\n$dark-grey: $dark-grey; // Exemple de couleur. Remplacez ceci par votre couleur $dark-grey\n\n.sidebar-menu {\n        position: sticky;\n        top: 115px;\n    width: 200px;\n    height: fit-content;\n    min-width: 200px;\n    overflow-y: auto; \n    padding: 20px 10px 20px 10px;\n    margin-left: 10px;\n    border-radius: 10px 0px 0px 10px;\n    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);\n}\n\n.user-settings-sidebar {\n    flex-shrink: 0; /* Pour éviter que la sidebar rétrécisse */\n}\n\n.sidebar-menu a {\n    position: relative;\n    display: flex; \n    justify-content: space-between;\n    padding: 10px 10px;\n    border-left: 8px solid $grey;\n    font-size: 0.9rem;\n    color: $light-grey; \n    text-decoration: none; \n    margin-bottom: 5px; \n    align-items: center;\n    transition: background-color 0.3s; \n\n    .desktop-link-unread-circle {\n        position: absolute;\n        right: 10px;\n        top: 50%;\n        transform: translateY(-50%);\n        width: 12px;\n        height: 12px;\n        min-width: 12px;\n        min-height: 12px;\n        box-sizing: border-box;\n        border-radius: 50%;\n        border: 1px solid $light-blue;\n        background: transparent;\n        flex-shrink: 0;\n        pointer-events: none;\n    }\n}\n\n.sidebar-menu a:hover,\n.sidebar-menu a:active,\n.sidebar-menu a:focus,\n.sidebar-menu a.selected  {\n    background: linear-gradient(90deg, rgba(60, 70, 83, 0) 0%, rgba(71, 94, 113, 0.233) 75%);\n    border-left: 8px solid $dark-red;\n    border-right: 2px solid $dark-red;\n    color: $very-light-grey;\n}\n\n.lock-icon {\n    margin-left: auto;\n    width: 14px;\n    height: 14px;\n    color: $bright-red;\n}\n\n.desktop-links   {\n    display: block;\n}\n\n.mobile-links {\n    display: none;\n}\n\n\n//\n// Security Password Check\n//\n\n.securitPasswordCheck-title {\n    color: $very-light-grey;\n    text-transform: uppercase;\n    padding-bottom: 10px;\n}\n\n.securitPasswordCheck-granted {\n    color: #1f9729;\n    font-size: 2rem;\n    text-transform: uppercase;\n    padding: 10px;\n}\n\n.password-check-modal   {\n    display: flex;\n    flex-direction: column;\n    background-color: $dark-grey;\n    width: 100%;\n    padding-top: 15px;\n    padding-bottom: 30px;\n    align-items: center;\n    margin-right: auto;\n    margin-left: auto;\n    border-top: 2px solid $red;\n    border-bottom: 2px solid $red;\n}\n\n.securitPasswordCheck-input {\n    display: flex;\n    padding: 5px 10px 5px 10px ;\n    margin-right: auto;\n    margin-left: auto;\n}\n\n.securitPasswordCheck-btn   {\n    display: flex;\n    background-color: $red;\n    text-transform: uppercase;\n    color: $very-light-grey;\n    width: 100%;\n    margin-top: 15px;\n    margin-right: auto;\n    margin-left: auto;\n    align-items: center;\n    text-align: center;\n    padding: 10px;\n    border: none;\n    border-radius: 5px 5px 5px 5px ;\n}\n\n.securitPasswordCheck-error-message {\n    display: flex;\n    color: $bright-red;\n    text-transform: uppercase;\n    width: 100%;\n    margin-right: auto;\n    margin-left: auto;\n    align-items: center;\n    text-align: center;\n    margin-top: 10px; \n}\n\n\n\n@media (max-width: $tablet) {\n    .desktop-links {\n        display: none;\n    }\n    .mobile-links {\n        display: block;\n        \n    }\n    .mobile-accordion   {\n        background-color: $dark-grey;\n        color: $very-light-grey;\n        margin-top: 10px;\n        margin-bottom: 10px;\n        margin-left: auto;\n        margin-right: auto;\n        padding: 10px 20px 10px 20px;\n        border-radius: 10px;\n    }\n    .user-settings-content-wrapper {\n        display: none;\n    }\n    .sidebar-menu   {\n        background-color: transparent; \n        position: relative;\n        width: 92%;\n        margin-left: 10px;\n        margin-right: 10px;\n        height: auto;\n        box-shadow: none;\n        border: 0;\n    }\n    \n    .sidebar-menu a:hover   {\n        border-left: none;\n        border-right: none;\n    }\n\n    .sidebar-menu, .mobile-accordion {\n        display: block;\n        margin-top: 10px;\n        margin-bottom: 10px;\n        margin-left: auto;\n        margin-right: auto;\n        padding-top: 10px;\n        padding-right: 10px;\n        padding-bottom: 10px;\n        padding-left: 10px;\n        width: 95%;\n    }\n\n    .mobile-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n    \n    .header-content {\n        display: flex;\n        align-items: center;\n    }\n    \n    .lock-icon {\n        margin-left: 15px;\n        width: 14px;\n        height: 14px;\n    }\n    \n    .accordion-triangle {\n        margin-left: 5px;\n    }\n    \n}","@import './variables.scss';\n\n\n\n.user-info {\n    flex-grow: 1; \n    display: flex;\n    flex-direction: row;\n    background-color: $dark-grey;\n    font-size: 0.9rem;\n    padding: 5px 0px 15px 0px;\n    margin: 20px 20px 10px 0px ;\n    color: $very-light-grey;\n    width: 100%;\n\n    border: 1px solid $light-grey;\n    border-radius: 6px;\n    box-shadow: inset -2px -2px 3px rgba(70, 69, 69, 0.2);\n\n    .user-info-left,\n    .user-info-right {\n        display: grid;\n        flex: 1; // Prendre la moitié de l'espace disponible\n        padding: 0 10px; // Un peu d'espacement entre les colonnes\n        gap: 10px;\n    }\n}\n\n.user-info span {\n    color: $light-grey;\n    font-weight: bold;\n    margin-right: 10px;\n}\n\n\n\n.timezone-selection,\n.language-selection {\n    @extend .selection-style;\n    justify-content: flex-start;\n        \n    select {\n        background-color: $very-light-grey;\n\n        padding: 10px 20px 5px 5px;\n        text-align: left;\n        border-radius: 4px;\n    }\n    .css-13cymwt-control {\n        background-color: $very-light-grey;\n        height: 35px;\n        min-height: auto;\n        font-size: 16px;\n        padding-left: 5px;\n        padding-right: 5px;\n        padding-top: 1px;\n        padding-bottom: 1px;\n\n        .css-13cymwt-control:hover,\n        .css-13cymwt-control:focus,\n        .css-13cymwt-control:active,\n        .css-13cymwt-control:target {\n            font-size: 1rem;\n        }\n        .css-qbdosj-Input input {\n            font-size: 1rem;\n        }\n    }    \n\n    .css-1u9des2-indicatorSeparator {\n        background-color: $grey;\n    }\n\n    .css-1xc3v61-indicatorContainer {\n        display: flex;\n        transition: color 150ms;\n        font-size: 1rem;\n        color: $grey;\n        padding: 8px;\n\n        .css-1xc3v61-indicatorContainer:hover {\n            font-size: 1rem;\n            color: $dark-grey;\n        }\n    }\n\n    .css-b62m3t-container {\n        bottom: 3px;\n        margin-left: 50px;\n        position: relative;\n        height: 35px;\n        box-sizing: border-box;\n        width: 250px;\n    }\n\n    .css-1fdsijx-ValueContainer {\n        align-items: center;\n        display: grid;\n        flex: 1;\n        flex-wrap: wrap;\n        position: relative;\n        overflow: hidden;\n        padding: 2px 8px;\n        box-sizing: border-box;\n    }\n\n}\n\n.newsletter-selection {\n    @extend .selection-style;\n\n    .label-container    {\n        width: 150px;\n        margin-right: 10px;\n    }\n}\n\n\n@media (max-width: $tablet) {\n\n    .avatar-wrapper {\n        position: relative;\n        width: 50px;\n        height: 50px;\n        border-radius: 50%;\n        overflow: visible;\n        margin-left: auto;\n        margin-right: 0;\n        padding-bottom: 0px;\n        box-shadow: none;\n        border-left: none;\n        border-right: none;\n    }\n\n    .avatar-section {\n        flex-direction: row;\n        align-items: center;\n        gap: 10px;\n    }\n\n    .avatar-wrapper {\n        width: 65px;\n        height: auto;\n        margin-left: 5px;\n        margin-right: 0;\n        padding-bottom: 0px;\n        box-shadow: none;\n    }\n\n    .avatar-icon-wrapper {\n        display: none;\n    }\n\n\n    .avatar-btn {\n        display: none;\n    }\n\n\n    .toggle-container {\n        position: relative;\n        bottom: 30px;\n        left: 120px;\n        width: calc(100% - 20px);  // En supposant que le bouton \"Save\" fasse approximativement 100px de large\n        margin-right: 0;\n    }\n\n    .selection-style {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        justify-content: space-between;\n        padding: 10px 0;\n        width: 100%;\n        border-bottom: 0px;\n    \n        label {\n            color: $very-light-grey;\n            margin-bottom: 10px;\n            margin-right: 10px;\n        }\n    \n        select, .toggle-container {\n            position: relative;\n            width: calc(100% - 20px);\n            margin-right: auto;\n            margin-left: auto;\n        }\n    }\n\n\n\n    .mobil-links    {\n        background-color: $dark-grey;\n        display: block;\n        position: fixed;\n        overflow-y: auto;\n        padding: 0px;\n        border-radius: 10px;\n    }\n\n    .settings-h2 {\n        visibility: hidden;\n        height: 0px;\n    }\n\n    .mobile-upload-btn {\n        display: inline-block;\n        padding: 8px 16px;\n        background-color: $red;\n        color: white;\n        border-radius: 4px;\n        cursor: pointer;\n        text-align: center;\n        transition: background-color 0.3s;\n    \n        &:hover {\n            background-color: darken($red, 10%);\n        }\n    }\n\n    .newsletter-selection   {\n        flex-direction: column;\n    }\n\n    .newsletter-selection .btn-style1   {\n        margin-top: -30px;\n    }\n\n    .newsletter-selection .toggle .toggle-switch {\n        height: $toggle-switch-track-height + 10px;\n        width: $toggle-legacy-track-width + 20px;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n    }\n    .newsletter-selection .label-container {\n        width: 150px;\n        margin-right: 10px;\n        margin-bottom: 10px;\n    }\n\n    .user-info {\n        flex-grow: 1;\n        display: flex;\n        flex-direction: column;\n        background-color: #3a4250;\n        font-size: 1rem;\n        padding-top: 5px;\n        padding-bottom: 15px;\n        padding-left: 15px;\n        padding-right: 15px;\n        margin-top: 15px;\n        color: #b9cfec;\n        margin-left: 10px;\n        border: 1px solid #775823;\n        border-radius: 6px;\n        box-shadow: inset -2px -2px 3px rgba(0, 0, 0, 0.2);\n    \n        .user-info-left,\n        .user-info-right {\n            flex: 1; // Prendre la moitié de l'espace disponible\n            padding: 0 10px; // Un peu d'espacement entre les colonnes\n        }\n    }\n\n    \n}\n","@import './variables.scss';\n\n// ---------------------------------------------------------------------------\n// Security settings — card layout (.security-page on `user-settings-container`)\n// ---------------------------------------------------------------------------\n\n.security-page {\n  gap: 0.35rem;\n\n  .settings-h2 {\n    color: rgba($pure-white, 0.96);\n    margin-bottom: 0.35rem;\n  }\n\n  input,\n  textarea {\n    user-select: text;\n  }\n\n  .visually-hidden {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0;\n  }\n}\n\n.security-page .user-settings-section.security-page__section-heading {\n  border-bottom-color: rgba(255, 255, 255, 0.2);\n\n  &::before {\n    background-color: rgba($pure-white, 0.92);\n    height: 3px;\n  }\n\n  &::after {\n    content: '';\n    display: block;\n    margin-top: 8px;\n    height: 1px;\n    width: 100%;\n    background: rgba(255, 255, 255, 0.12);\n  }\n}\n\n.security-page .settings-h3 {\n  color: rgba($pure-white, 0.95);\n}\n\n.security-credentials,\n.security-mfa,\n.security-sessions,\n.security-mobile-login {\n  width: 100%;\n}\n\n.security-card-form {\n  width: 100%;\n  margin-bottom: 0.75rem;\n}\n\n.security-card {\n  display: grid;\n  grid-template-columns: minmax(0, 280px) minmax(10rem, 1fr) auto;\n  align-items: center;\n  gap: 1.15rem 1.5rem;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 1.15rem 1.35rem;\n  margin-bottom: 0.65rem;\n  border-radius: 12px;\n  background: rgba(18, 32, 48, 0.72);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.22);\n}\n\n.security-card__lead {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.9rem;\n  min-width: 0;\n}\n\n.security-card__lead--backup {\n  align-items: center;\n}\n\n.security-card__icon-wrap {\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.security-card__icon {\n  font-size: 1.25rem;\n  color: rgba($pure-white, 0.88);\n}\n\n.security-card__copy {\n  min-width: 0;\n}\n\n.security-card__title {\n  margin: 0 0 0.2rem;\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgba($pure-white, 0.95);\n}\n\n.security-card__subtitle {\n  margin: 0;\n  font-size: 0.85rem;\n  line-height: 1.35;\n  color: rgba($very-light-grey, 0.82);\n}\n\n.security-card__fields {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.security-card__fields--password {\n  position: relative;\n  gap: 0.65rem;\n}\n\n.security-card__password-bundle {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem 0.65rem;\n}\n\n.security-card__password-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.55rem;\n  min-width: 0;\n  flex: 1 1 12rem;\n}\n\n.security-card__input {\n  flex: 1 1 8.5rem;\n  min-width: 0;\n  max-width: 100%;\n  box-sizing: border-box;\n  padding: 0.55rem 0.75rem;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  background: rgba($very-light-grey, 0.94);\n  color: $dark-grey;\n  font-size: 0.9rem;\n  outline: none;\n\n  &::placeholder {\n    color: rgba($dark-grey, 0.45);\n  }\n\n  &:focus {\n    border-color: rgba($accent-blue, 0.65);\n    box-shadow: 0 0 0 2px rgba($accent-blue, 0.2);\n  }\n}\n\n.security-card__input--email {\n  flex: 1 1 100%;\n  max-width: 22rem;\n}\n\n.security-card__info-btn {\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border-radius: 50%;\n  border: 1px solid rgba($red, 0.55);\n  background: rgba($red, 0.12);\n  color: $bright-red;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s ease, border-color 0.15s ease;\n\n  &:hover,\n  &:focus-visible {\n    background: rgba($red, 0.22);\n    border-color: rgba($bright-red, 0.75);\n    outline: none;\n  }\n}\n\n.security-card__info-glyph {\n  font-size: 0.75rem;\n  font-weight: 800;\n  font-style: italic;\n  line-height: 1;\n}\n\n.security-card__tooltip {\n  flex: 1 1 100%;\n  margin: 0;\n  padding: 0.65rem 0.75rem;\n  border-radius: 8px;\n  font-size: 0.82rem;\n  line-height: 1.4;\n  color: $very-light-grey;\n  background: rgba($dark-red, 0.92);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.security-card__cta {\n  justify-self: end;\n  display: flex;\n  align-items: center;\n}\n\n.security-card__cta--toggle {\n  transform: scale(1.35);\n  transform-origin: center right;\n}\n\n.security-card__mfa-center {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.security-card__mfa-status,\n.security-card__mfa-prompt {\n  margin: 0;\n  font-size: 0.88rem;\n  line-height: 1.35;\n  color: rgba($very-light-grey, 0.9);\n}\n\n.security-card__mfa-prompt {\n  color: rgba($pure-white, 0.88);\n  font-weight: 600;\n}\n\n.security-card__backup-text {\n  margin: 0;\n  font-size: 0.88rem;\n  line-height: 1.4;\n  color: rgba($very-light-grey, 0.9);\n}\n\n.security-card__alert {\n  margin: 0.35rem 0 0;\n  padding: 0.5rem 0.65rem;\n  border-radius: 8px;\n  font-size: 0.85rem;\n  color: $very-light-grey;\n  background: rgba($dark-red, 0.45);\n  border: 1px solid rgba($bright-red, 0.35);\n}\n\n.security-card__alert-spacer {\n  min-height: 0.25rem;\n}\n\n.btn-security-submit {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  border-radius: 10px !important;\n  padding: 0.5rem 1rem !important;\n  font-size: 0.68rem !important;\n}\n\n.security-card--backup {\n  grid-template-columns: 1fr auto;\n\n  .security-card__lead--backup {\n    flex: 1 1 auto;\n  }\n}\n\n.security-page__danger {\n  margin-top: 1.5rem;\n\n  .account-deletion__disclaimer {\n    margin-bottom: 1rem;\n  }\n}\n\n.security-card--sessions {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0;\n  grid-template-columns: none;\n}\n\n.security-card--mobile-login {\n  grid-template-columns: minmax(0, 280px) minmax(0, 1fr) auto;\n}\n\n.security-mobile-login__content {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.55rem;\n}\n\n.security-mobile-login__qr-wrap {\n  padding: 0.6rem;\n  background: rgba($pure-white, 0.95);\n  border-radius: 10px;\n  border: 1px solid rgba($accent-blue, 0.25);\n}\n\n.security-mobile-login__code-wrap {\n  padding: 0.85rem 1rem;\n  background: rgba($pure-white, 0.08);\n  border: 1px solid rgba($pure-white, 0.2);\n  border-radius: 10px;\n}\n\n.security-mobile-login__code {\n  color: $pure-white;\n  font-size: 1.1rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n}\n\n.security-mobile-login__meta {\n  margin: 0;\n  font-size: 0.82rem;\n  color: rgba($very-light-grey, 0.85);\n}\n\n.security-card--sessions-header {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 1rem 1.25rem;\n  width: 100%;\n}\n\n.security-sessions__list {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding-right: 10px;\n  max-height: calc(100vh - 820px);\n  overflow-y: auto;\n  @include scrollbar-styles;\n}\n\n.security-sessions__separator {\n  height: 1px;\n  width: 100%;\n  background: rgba(255, 255, 255, 0.12);\n\n  &--header {\n    margin-top: 0.35rem;\n  }\n}\n\n.security-sessions__item {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem 1.25rem;\n  padding: 0.85rem 0;\n}\n\n.security-sessions__item--current {\n  .security-sessions__device-title {\n    color: rgba($pure-white, 0.98);\n  }\n}\n\n.security-sessions__item-actions {\n  flex-shrink: 0;\n  display: flex;\n  align-items: flex-start;\n  padding-top: 0.1rem;\n}\n\n.security-sessions__status {\n  margin: 0.5rem 0 0;\n  font-size: 0.88rem;\n  color: rgba($very-light-grey, 0.85);\n}\n\n.security-sessions__device-main {\n  min-width: 0;\n}\n\n.security-sessions__device-title-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem 0.75rem;\n  margin-bottom: 0.35rem;\n}\n\n.security-sessions__device-title {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: rgba($pure-white, 0.96);\n}\n\n.security-sessions__badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.15rem 0.55rem;\n  border-radius: 999px;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgba($pure-white, 0.95);\n  background: rgba($orange, 0.7);\n  border: 1px solid rgba($light-orange, 1);\n}\n\n.security-sessions__meta {\n  margin: 0 0 0.25rem;\n  font-size: 0.84rem;\n  line-height: 1.35;\n  color: rgba($very-light-grey, 0.82);\n}\n\n.security-sessions__rename {\n  margin-top: 0.65rem;\n}\n\n.security-sessions__rename-form {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.security-sessions__rename-input {\n  flex: 1 1 12rem;\n  max-width: 18rem;\n}\n\n.security-sessions__rename-link {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: rgba($accent-blue, 0.95);\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n\n  &:hover,\n  &:focus-visible {\n    color: rgba($pure-white, 0.95);\n    outline: none;\n  }\n}\n\n.security-sessions__rename-cancel {\n  background: rgba($dark-grey, 0.55) !important;\n}\n\n// ---------------------------------------------------------------------------\n// MFA modal & code field (SecurityModal)\n// ---------------------------------------------------------------------------\n\n.mfa-code-field {\n  padding: 5px;\n  font-size: 1.2rem;\n  margin-top: 10px;\n  letter-spacing: 10px;\n  width: 165px;\n  text-align: center;\n  border: 1px solid $light-grey;\n  outline: none;\n}\n\n.mfa-code-field::placeholder {\n  color: transparent;\n  text-shadow: 0 0 0 #000;\n}\n\n.mfa-code-field:focus::placeholder {\n  color: #aaa;\n}\n\n.btn-style1.mfa {\n  width: 177px;\n  margin: 15px auto 0 auto;\n}\n\n.btn-style1.mfa-red {\n  background-color: $red;\n  color: $very-light-grey;\n  width: 177px;\n  margin: 15px auto 0 auto;\n\n  &:hover {\n    background-color: $bright-red;\n  }\n}\n\n.mfa-code-number {\n  display: none;\n}\n\n// ---------------------------------------------------------------------------\n// Tablet / mobile\n// ---------------------------------------------------------------------------\n\n@media (max-width: $tablet) {\n  .security-card {\n    grid-template-columns: 1fr;\n    align-items: stretch;\n    padding: 1rem 1.1rem;\n  }\n\n  .security-card__lead {\n    align-items: center;\n  }\n\n  .security-card__cta {\n    justify-self: stretch;\n  }\n\n  .security-card__cta--toggle {\n    justify-self: end;\n    transform: scale(1.2);\n  }\n\n  .btn-security-submit {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .security-sessions__item {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .security-card--sessions-header {\n    grid-template-columns: 1fr;\n  }\n\n  .security-card--mobile-login {\n    grid-template-columns: 1fr;\n  }\n\n  .security-card--sessions-header .security-card__cta {\n    justify-self: stretch;\n  }\n\n  .security-sessions__item-actions {\n    width: 100%;\n    padding-top: 0.35rem;\n\n    .btn-style1.delete.red {\n      width: 100%;\n      justify-content: center;\n    }\n  }\n\n  .security-card__input--email {\n    max-width: none;\n  }\n\n  .modal-content-codes {\n    z-index: 300;\n  }\n\n  .mfa-modal img {\n    display: none;\n  }\n\n  .mfa-code-number {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n\n    .mfa-secret-label {\n      color: $very-dark-grey;\n      margin-bottom: 10px;\n      text-transform: uppercase;\n    }\n\n    .mfa-copy-code {\n      background-color: $bright-red;\n      color: $very-light-grey;\n      width: auto;\n      height: 30px;\n      margin-top: 15px;\n      margin-bottom: 20px;\n      padding: 5px;\n      border-color: transparent;\n      border-radius: 5px 5px 5px 5px;\n    }\n  }\n\n  .modal-left {\n    background-color: $very-light-grey;\n    width: 100%;\n    padding: 10px;\n    border-radius: 10px 10px 0 0;\n  }\n\n  .modal-right {\n    background-color: $grey;\n    width: 100%;\n    padding: 10px;\n    border-radius: 0 0 10px 10px;\n\n    .mfa-bullet-points {\n      color: $very-light-grey;\n    }\n\n    .desktop {\n      display: none;\n    }\n\n    .mobile {\n      display: block;\n    }\n  }\n}\n","@import './variables.scss';\n\n// -----------------------------------------------------------------------------\n// Tools settings — same vocabulary as Security (cards, headings, pills)\n// -----------------------------------------------------------------------------\n\n.tools-page {\n  gap: 0.75rem;\n\n  input,\n  textarea {\n    user-select: text;\n  }\n\n  .settings-h2 {\n    color: rgba($pure-white, 0.96);\n    margin-bottom: 0.35rem;\n  }\n\n  .visually-hidden {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0;\n  }\n}\n\n.tools-page .user-settings-section.tools-page__section-heading {\n  border-bottom-color: rgba(255, 255, 255, 0.2);\n\n  &::before {\n    background-color: rgba($pure-white, 0.92);\n    height: 3px;\n  }\n\n  &::after {\n    content: '';\n    display: block;\n    margin-top: 8px;\n    height: 1px;\n    width: 100%;\n    background: rgba(255, 255, 255, 0.12);\n  }\n}\n\n.tools-page .settings-h3 {\n  color: rgba($pure-white, 0.95);\n}\n\n.tools-alerts {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  width: 100%;\n  margin-bottom: 0.35rem;\n}\n\n.tools-alert {\n  margin: 0;\n  padding: 0.65rem 1rem;\n  border-radius: 10px;\n  font-size: 0.88rem;\n  font-weight: 600;\n  line-height: 1.35;\n}\n\n.tools-alert--warning {\n  color: rgba(45, 30, 5, 0.95);\n  background: rgba(255, 193, 80, 0.92);\n  border: 1px solid rgba(180, 100, 0, 0.35);\n}\n\n.tools-section-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  width: 100%;\n}\n\n.tools-card {\n  display: grid;\n  grid-template-columns: minmax(0, 280px) minmax(8rem, 1fr) auto;\n  align-items: center;\n  gap: 1.15rem 1.35rem;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 1.15rem 1.35rem;\n  border-radius: 12px;\n  background: rgba(18, 32, 48, 0.72);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.22);\n}\n\n.tools-card__lead {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.9rem;\n  min-width: 0;\n}\n\n.tools-card__icon-wrap {\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: rgba(255, 255, 255, 0.04);\n  overflow: hidden;\n}\n\n.tools-card__icon-wrap--discord {\n  padding: 8px;\n\n  img {\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n  }\n}\n\n.tools-card__discord-avatar {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 50%;\n}\n\n.tools-card__icon {\n  font-size: 1.25rem;\n  color: rgba($pure-white, 0.88);\n}\n\n.tools-card__copy {\n  min-width: 0;\n}\n\n.tools-card__title {\n  margin: 0 0 0.2rem;\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgba($pure-white, 0.95);\n}\n\n.tools-card__subtitle {\n  margin: 0;\n  font-size: 0.85rem;\n  line-height: 1.35;\n  color: rgba($very-light-grey, 0.82);\n}\n\n.tools-card__status {\n  min-width: 0;\n}\n\n.tools-card__status-name {\n  margin: 0 0 0.15rem;\n  font-size: 0.92rem;\n  font-weight: 700;\n  color: rgba($pure-white, 0.94);\n  word-break: break-word;\n}\n\n.tools-card__status-muted {\n  margin: 0;\n  font-size: 0.84rem;\n  line-height: 1.35;\n  color: rgba($very-light-grey, 0.78);\n}\n\n.tools-card__cta {\n  justify-self: end;\n  display: flex;\n  align-items: center;\n}\n\n.btn-tools-submit {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  border-radius: 10px !important;\n  padding: 0.5rem 1rem !important;\n  font-size: 0.68rem !important;\n}\n\n.tools-card--wide {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 1rem;\n\n  .tools-card__stretch {\n    width: 100%;\n    min-width: 0;\n\n    /* Table + toolbar from Handles.jsx */\n    .new-handle {\n      margin-top: 0.85rem;\n    }\n  }\n\n  &.tools-card--extension {\n    /* PrivateLexical + steps + textarea row */\n    .extension-setup-steps h3 {\n      color: rgba($pure-white, 0.93);\n      font-size: 0.92rem;\n      text-transform: uppercase;\n      letter-spacing: 0.04em;\n    }\n\n    .extension-setup-list {\n      color: rgba($very-light-grey, 0.88);\n      line-height: 1.45;\n      padding-left: 1.2rem;\n    }\n\n    /* Darken textarea slightly to match cards */\n    .extension-token {\n      background-color: rgba($very-light-grey, 0.92);\n      color: $dark-grey;\n      border-radius: 8px;\n      border: 1px solid rgba(255, 255, 255, 0.14);\n    }\n  }\n}\n\n.tools-card__lead-inline {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.9rem;\n  flex-wrap: wrap;\n}\n\n@media (max-width: $tablet) {\n  .tools-card {\n    grid-template-columns: 1fr;\n    align-items: stretch;\n  }\n\n  .tools-card__cta {\n    justify-self: stretch;\n\n    .btn-tools-submit {\n      width: 100%;\n    }\n  }\n}\n","@import './variables.scss';\n\n// -----------------------------------------------------------------------------\n// Account settings — aligned with Security / Tools card layout\n// -----------------------------------------------------------------------------\n\n.account-page {\n  gap: 0.75rem;\n\n  input,\n  textarea {\n    user-select: text;\n  }\n\n  .settings-h2 {\n    color: rgba($pure-white, 0.96);\n    margin-bottom: 0.35rem;\n  }\n\n  .visually-hidden {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0;\n  }\n}\n\n.account-page .user-settings-section.account-page__section-heading {\n  margin-top: 0.65rem;\n\n  border-bottom-color: rgba(255, 255, 255, 0.2);\n\n  &::before {\n    background-color: rgba($pure-white, 0.92);\n    height: 3px;\n  }\n\n  &::after {\n    content: '';\n    display: block;\n    margin-top: 8px;\n    height: 1px;\n    width: 100%;\n    background: rgba(255, 255, 255, 0.12);\n  }\n}\n\n.account-page .settings-h3 {\n  color: rgba($pure-white, 0.95);\n}\n\n.account-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  width: 100%;\n}\n\n.account-card {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 1.15rem 1.35rem;\n  border-radius: 12px;\n  background: rgba(18, 32, 48, 0.72);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.22);\n}\n\n.account-card__lead {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.9rem;\n  min-width: 0;\n}\n\n.account-card__icon-wrap {\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.account-card__icon {\n  font-size: 1.25rem;\n  color: rgba($pure-white, 0.88);\n}\n\n.account-card__copy {\n  min-width: 0;\n}\n\n.account-card__title {\n  margin: 0 0 0.2rem;\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgba($pure-white, 0.95);\n}\n\n.account-card__subtitle {\n  margin: 0;\n  font-size: 0.85rem;\n  line-height: 1.35;\n  color: rgba($very-light-grey, 0.82);\n}\n\n.account-card--summary {\n  display: flex;\n  flex-direction: column;\n  gap: 1.1rem;\n}\n\n.account-card__metrics dl {\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.account-metric {\n  display: grid;\n  grid-template-columns: minmax(7.5rem, 11rem) 1fr;\n  gap: 0.35rem 1rem;\n  align-items: baseline;\n}\n\n.account-metric__label {\n  margin: 0;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: rgba($light-grey, 0.92);\n}\n\n.account-metric__value {\n  margin: 0;\n  font-size: 0.9rem;\n  line-height: 1.35;\n  color: rgba($pure-white, 0.93);\n  word-break: break-word;\n}\n\n.account-card--control {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.account-card__control-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.account-card__control {\n  flex: 1 1 16rem;\n  min-width: 0;\n  max-width: 28rem;\n\n  &:last-child:first-child {\n    max-width: 100%;\n  }\n}\n\n.account-page .acct-rs__control {\n  min-height: 38px;\n  border-radius: 8px !important;\n  border: 1px solid rgba(255, 255, 255, 0.24) !important;\n  background-color: rgba($very-light-grey, 0.94) !important;\n  box-shadow: none !important;\n  cursor: pointer;\n}\n\n.account-page .acct-rs__control:hover {\n  border-color: rgba($accent-blue, 0.45) !important;\n}\n\n.account-page .acct-rs__single-value {\n  color: $dark-grey;\n  font-size: 0.9rem;\n}\n\n.account-page .acct-rs__placeholder {\n  color: rgba($dark-grey, 0.45);\n  font-size: 0.88rem;\n}\n\n.account-page .acct-rs__indicator-separator {\n  background-color: $grey !important;\n}\n\n.account-page .acct-rs__dropdown-indicator {\n  color: $grey !important;\n  padding: 6px !important;\n}\n\n.account-page .acct-rs__dropdown-indicator:hover {\n  color: $dark-grey !important;\n}\n\n.account-page .acct-rs__menu {\n  z-index: 20;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  background: rgba(28, 45, 60, 0.98);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);\n}\n\n.account-page .acct-rs__menu-list {\n  padding: 4px;\n}\n\n.account-page .acct-rs__option {\n  color: rgba($very-light-grey, 0.95);\n  font-size: 0.88rem;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.account-page .acct-rs__option--is-focused {\n  background: rgba($accent-blue, 0.22) !important;\n}\n\n.account-page .acct-rs__option--is-selected {\n  background: rgba($accent-blue, 0.42) !important;\n  color: $pure-white;\n}\n\n.account-page .acct-rs__input-container {\n  color: $dark-grey;\n}\n\n.account-page .acct-rs__input {\n  color: $dark-grey !important;\n}\n\n.account-card--profile-theme {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.account-profile-theme__error {\n  margin: 0;\n  color: $red;\n  font-size: 0.9rem;\n}\n\n.account-profile-theme__status {\n  margin: 0;\n  color: rgba($pure-white, 0.7);\n  font-size: 0.9rem;\n}\n\n.account-profile-theme__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n  gap: 0.75rem;\n  max-height: 17.5rem;\n  overflow-x: hidden;\n  overflow-y: auto;\n  @include member-dashboard-thin-scrollbar;\n}\n\n.account-profile-theme__option {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.35rem;\n  padding: 0.75rem;\n  border-radius: 10px;\n  border: 1px solid rgba($pure-white, 0.14);\n  background: rgba(8, 18, 30, 0.55);\n  color: $pure-white;\n  cursor: pointer;\n  text-align: left;\n}\n\n.account-profile-theme__option:hover:not(:disabled) {\n  border-color: rgba($pure-white, 0.28);\n}\n\n.account-profile-theme__option.is-preview {\n  border-color: rgba($light-blue, 0.85);\n  box-shadow: 0 0 0 1px rgba($light-blue, 0.45);\n}\n\n.account-profile-theme__option.is-locked .account-profile-theme__swatch {\n  filter: saturate(0.72) brightness(0.88);\n}\n\n.account-profile-theme__option:disabled {\n  opacity: 0.65;\n  cursor: wait;\n}\n\n.account-profile-theme__badge {\n  position: absolute;\n  right: 0.45rem;\n  bottom: 0.45rem;\n  z-index: 2;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.45rem;\n  height: 1.45rem;\n  border-radius: 999px;\n  font-size: 0.95rem;\n  line-height: 1;\n  pointer-events: none;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.45);\n}\n\n.account-profile-theme__badge--applied {\n  color: $green;\n  background: rgba(8, 18, 30, 0.88);\n}\n\n.account-profile-theme__badge--locked {\n  color: $donor-gold;\n  background: rgba(8, 18, 30, 0.88);\n}\n\n.account-profile-theme__option.is-applied.is-locked .account-profile-theme__badge--locked {\n  right: 2rem;\n}\n\n.account-profile-theme__actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.75rem 1rem;\n}\n\n.account-profile-theme__apply {\n  appearance: none;\n  border: 1px solid rgba($green, 0.55);\n  background: rgba($green, 0.18);\n  color: $pure-white;\n  border-radius: 8px;\n  padding: 0.55rem 1.1rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.account-profile-theme__apply:hover:not(:disabled) {\n  background: rgba($green, 0.28);\n  border-color: rgba($green, 0.8);\n}\n\n.account-profile-theme__apply:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.account-profile-theme__hint {\n  margin: 0;\n  font-size: 0.8rem;\n  color: rgba($pure-white, 0.55);\n}\n\n.account-profile-theme__swatch {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 72px;\n  border-radius: 8px;\n  overflow: hidden;\n  isolation: isolate;\n  background: linear-gradient(135deg, $dark-grey, $medium-grey);\n  pointer-events: none;\n}\n\n.account-profile-theme__swatch--none {\n  background: linear-gradient(135deg, rgba($pure-white, 0.08), rgba($pure-white, 0.02));\n}\n\n.account-profile-theme__swatch--live {\n  background: rgba(6, 12, 20, 0.95);\n}\n\n.account-profile-theme__swatch--legacy-space {\n  background: radial-gradient(\n    circle at 30% 40%,\n    lighten($member-profile-donor-nebula, 12%),\n    $member-profile-donor-nebula 70%\n  );\n}\n\n.account-profile-theme__swatch-media,\n.account-profile-theme__swatch .perk-theme-media {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n\n.account-profile-theme__swatch .perk-theme-media__img,\n.account-profile-theme__swatch .perk-theme-media__video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.account-profile-theme__swatch .perk-theme-frame-halo {\n  position: absolute;\n  inset: 0;\n  z-index: 4;\n  pointer-events: none;\n}\n\n.account-profile-theme__swatch .perk-theme-underlay {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  pointer-events: none;\n}\n\n.account-profile-theme__swatch .perk-theme-overlay,\n.account-profile-theme__swatch .member-profile-card-popover__shooting-star,\n.account-profile-theme__swatch-nebula-morph {\n  position: absolute;\n  inset: 0;\n  z-index: 3;\n  pointer-events: none;\n}\n\n.account-profile-theme__swatch-nebula-morph {\n  background:\n    radial-gradient(ellipse at 40% 35%, rgba($pure-white, 0.18), transparent 55%),\n    radial-gradient(ellipse at 70% 65%, rgba($donor-gold, 0.22), transparent 50%);\n  animation: account-profile-theme-swatch-morph 6s ease-in-out infinite alternate;\n}\n\n@keyframes account-profile-theme-swatch-morph {\n  from { opacity: 0.55; transform: scale(1); }\n  to { opacity: 0.9; transform: scale(1.08); }\n}\n\n.account-profile-theme__option-name {\n  font-size: 0.92rem;\n  font-weight: 600;\n}\n\n.account-profile-theme__option-meta {\n  font-size: 0.75rem;\n  color: rgba($pure-white, 0.55);\n}\n\n.account-profile-theme__live-preview {\n  margin-top: 0.35rem;\n  padding: 0.75rem;\n}\n\n.account-profile-theme__live-preview .profile-themes-preview__card-shell {\n  width: 100%;\n  max-width: 280px;\n}\n\n@media (max-width: $tablet) {\n  .account-metric {\n    grid-template-columns: 1fr;\n  }\n\n  .account-card__control {\n    max-width: none;\n    width: 100%;\n    flex-basis: 100%;\n  }\n\n  .account-card__control-row {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .account-profile-theme__live-preview .profile-themes-preview__stack--row {\n    grid-template-columns: 1fr;\n  }\n\n  .account-profile-theme__live-preview .profile-themes-preview__card-shell {\n    max-width: none;\n  }\n}\n","// src/styles/adminPanel.scss\n\n@import './variables.scss';\n\n.admin-h2 {\n    color: $light-grey; \n    text-transform: uppercase;\n    margin-top: 15px;\n    margin-bottom: 0px;\n}\n\n.admin-h3 {\n    color: $very-light-grey;\n    text-transform: uppercase;\n    margin-top: 10px;\n    margin-bottom: 5px;\n    margin-left: 0px;\n}\n\n.admin-h4 {\n    color: $very-light-grey;\n    text-transform: uppercase;\n    font-size: 0.9rem;\n    margin-left: 15px;\n}\n\n.user-admin-content {\n    flex-grow: 1; // Prend l'espace restant après la sidebar\n    padding: 0 10px;\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n}\n\n.user-admin-page {\n    margin: 20px auto;\n    width: $full-width;\n    max-width: 100%;\n    transform: translateX(-20px);\n\n    // Applied per active tab via `hasLexical` → `admin-layout--lexical` on the page container\n    &:has(.admin-layout--lexical) {\n        width: $partial-width;\n        transform: translateX(-125px);\n    }\n}\n\n.admin-container {\n    margin-top: 70px;\n    display: flex;\n    flex-direction: row; /* Les éléments enfants seront alignés horizontalement */\n    //min-height: 75vh;\n    max-width: 100%;\n    min-width: 0;\n}\n\n.user-admin-content-wrapper {\n    //background: $dark-grey;\n    display: flex;\n    margin-left: 10px;\n    //width: calc(100% - 225px);\n    width: auto;\n    max-width: 100%;\n    min-width: 0;\n    height: auto;\n    gap: 20px; \n    border-radius: 0px 10px 10px 10px;\n    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);\n    flex-grow: 1;\n}\n\n\n%section-border {\n    position: relative;\n    color: $very-light-grey;\n    width: 100%;\n    text-transform: uppercase;\n    font-size: 0.9rem;\n    border-bottom: 2px solid $light-grey;\n\n    &::before {\n        content: \"\";\n        position: absolute;\n        bottom: -5px;\n        left: 0;\n        width: 130px;\n        height: 4px;\n        background-color: $light-grey;\n    }\n}\n\n.user-admin-section {\n    @extend %section-border;\n    margin: 5px 0px 10px 0;\n}\n\n\n.selection-style {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    padding: 20px 0;\n    width: 100%;\n    //border-bottom: 1px solid $grey;\n    border-bottom: none;\n\n    label {\n        color: $very-light-grey;\n        width: 150px;\n        margin-right: 10px;\n    }\n\n    select, .toggle-container {\n        margin-right: auto;\n        margin-left: 50px;\n        margin-bottom: 0px;\n    }\n}\n\n.disabled-container {\n    opacity: 0.3;\n    pointer-events: none;\n}\n  \n\n.admin-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.server-status-widget {\n  position: absolute;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: auto auto;\n  grid-column-gap: 16px;\n  grid-row-gap: 6px;\n\n  background: $dark-grey;\n  color: $light-grey;\n  border: 1px solid $light-grey;\n  border-radius: 6px;\n  font-size: 0.85rem;\n  padding: 6px 10px;\n  top: 10px;\n  right: 10px;\n}\n\n.server-status-widget span {\n  white-space: nowrap;\n}\n\n.server-status-widget .danger {\n  color: $bright-red;\n}\n\n.gear-loadout-page {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  overflow-x: hidden;\n  /* Children (carousel) must not inflate the admin page past $full-width. */\n  contain: inline-size;\n}\n\n.gear-loadout-layout {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  gap: 16px;\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  margin-top: 16px;\n\n  > .admin-block-container {\n    box-sizing: border-box;\n    min-width: 0;\n    padding: 12px;\n    border: 1px solid $blue-grey;\n    border-radius: 8px;\n    background: $dark-blue-grey;\n    box-shadow: none;\n  }\n\n  /*\n   * Avant: builder 37% (1 col) / viewer 63%.\n   * 2 cols slots à −40% chacune → 2 × (37% × 0.6) ≈ 44% builder ; viewer un peu réduit.\n   */\n  .gear-loadout-builder-block {\n    flex: 0 0 calc(44% - 8px);\n    width: calc(44% - 8px);\n    max-width: calc(44% - 8px);\n  }\n\n  .gear-loadout-mannequin-block {\n    flex: 1 1 calc(56% - 8px);\n    width: auto;\n    max-width: calc(56% - 8px);\n    min-width: 0;\n  }\n\n  @media (max-width: 1100px) {\n    flex-wrap: wrap;\n\n    .gear-loadout-builder-block,\n    .gear-loadout-mannequin-block {\n      flex: 1 1 100%;\n      width: 100%;\n      max-width: 100%;\n    }\n  }\n}\n\n.gear-loadout-setups-bar {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  overflow: hidden;\n  contain: inline-size;\n  padding: 12px;\n  border: 1px solid $blue-grey;\n  border-radius: 8px;\n  background: $dark-blue-grey;\n  box-shadow: none;\n}\n\n.gear-loadout-mannequin {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  padding: 2px;\n\n  .field-label {\n    color: $medium-light-grey;\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n  }\n\n  &__header {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n  }\n\n  &__sex {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n  }\n\n  &__sex-btn {\n    margin: 0;\n    padding: 6px 12px;\n    border: 1px solid $medium-grey;\n    border-radius: 6px;\n    background: $very-dark-grey;\n    color: $light-grey;\n    font-size: 0.8rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    cursor: pointer;\n  }\n\n  &__sex-btn--active {\n    border-color: $accent-blue;\n    background: $dark-panel-blue;\n    color: $very-light-grey;\n  }\n\n  &__poses {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  &__pose-list {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n  }\n\n  &__pose-btn {\n    margin: 0;\n    padding: 6px 10px;\n    border: 1px solid $medium-grey;\n    border-radius: 6px;\n    background: $very-dark-grey;\n    color: $light-grey;\n    font-size: 0.78rem;\n    font-weight: 600;\n    cursor: pointer;\n  }\n\n  &__pose-btn--active {\n    border-color: $accent-blue;\n    background: $dark-panel-blue;\n    color: $very-light-grey;\n  }\n\n  &__pose-btn--pending,\n  &__stance-btn--pending {\n    opacity: 0.45;\n    cursor: default;\n  }\n\n  &__chf {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 10px;\n    margin-top: 4px;\n  }\n\n  &__chf-kicker {\n    color: $medium-light-grey;\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n  }\n\n  &__chf-label {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    margin: 0;\n    cursor: pointer;\n  }\n\n  &__chf-btn {\n    display: inline-flex;\n    align-items: center;\n    padding: 6px 10px;\n    border: 1px solid $medium-grey;\n    border-radius: 6px;\n    background: $very-dark-grey;\n    color: $light-grey;\n    font-size: 0.75rem;\n    font-weight: 600;\n  }\n\n  &__chf-input {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0;\n  }\n\n  &__chf-name {\n    color: $medium-light-grey;\n    font-size: 0.75rem;\n  }\n\n  &__appearance {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  &__appear-row {\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: center;\n    gap: 8px;\n    width: 100%;\n  }\n\n  &__appear-k {\n    flex: 0 0 6.6rem;\n    min-width: 6.6rem;\n    color: $light-grey;\n    font-size: 0.75rem;\n    font-weight: 600;\n    text-transform: uppercase;\n  }\n\n  &__appear-track {\n    flex: 1 1 auto;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n  }\n\n  &__skin-slider {\n    width: 100%;\n    margin: 0;\n    accent-color: $light-grey;\n    cursor: pointer;\n  }\n\n  &__hair-count {\n    flex: 0 0 3.6rem;\n    min-width: 3.6rem;\n    color: $light-grey;\n    font-size: 0.75rem;\n    font-weight: 600;\n    font-variant-numeric: tabular-nums;\n    text-align: right;\n  }\n\n  &__appear-name {\n    color: $medium-grey;\n    font-size: 0.68rem;\n    font-weight: 500;\n    line-height: 1.2;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__appear-debug {\n    margin-top: 4px;\n    color: $medium-grey;\n    font-size: 0.72rem;\n\n    summary {\n      cursor: pointer;\n      font-weight: 600;\n      text-transform: uppercase;\n      color: $light-grey;\n    }\n  }\n\n  &__hair-layer {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    color: $light-grey;\n    font-size: 0.72rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    cursor: pointer;\n  }\n\n  &__appear-hint {\n    margin: 0 0 0 2.6rem;\n    color: $medium-grey;\n    font-size: 0.7rem;\n  }\n\n  &__dye-block {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    margin-top: 8px;\n    padding-top: 8px;\n    border-top: 1px solid $medium-grey;\n  }\n\n  &__dye-title {\n    color: $light-grey;\n    font-size: 0.72rem;\n    font-weight: 700;\n    text-transform: uppercase;\n  }\n\n  &__dye-color-track {\n    flex-direction: row;\n    align-items: center;\n    gap: 8px;\n  }\n\n  &__dye-color {\n    width: 2rem;\n    height: 1.4rem;\n    padding: 0;\n    border: 1px solid $medium-grey;\n    border-radius: 4px;\n    background: $very-dark-grey;\n    cursor: pointer;\n  }\n\n  &__dye-flags {\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  &__beard-prims {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n  }\n\n  &__beard-prims-empty {\n    margin: 0;\n    color: $medium-grey;\n    font-size: 0.7rem;\n  }\n\n  &__beard-prim {\n    display: flex;\n    align-items: flex-start;\n    gap: 6px;\n    margin: 0;\n    color: $light-grey;\n    font-size: 0.68rem;\n    font-weight: 500;\n    line-height: 1.35;\n    cursor: pointer;\n\n    span {\n      font-family: Consolas, \"Courier New\", monospace;\n    }\n  }\n\n  &__hair-select {\n    min-width: 12rem;\n    max-width: 100%;\n    margin: 0;\n    padding: 6px 8px;\n    border: 1px solid $medium-grey;\n    border-radius: 6px;\n    background: $very-dark-grey;\n    color: $light-grey;\n    font-size: 0.78rem;\n    font-weight: 600;\n    cursor: pointer;\n  }\n\n  &__stance {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n  }\n\n  &__stance-list {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n  }\n\n  &__stance-btn {\n    margin: 0;\n    padding: 6px 12px;\n    border: 1px solid $medium-grey;\n    border-radius: 6px;\n    background: $very-dark-grey;\n    color: $light-grey;\n    font-size: 0.8rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    cursor: pointer;\n  }\n\n  &__stance-btn--active {\n    border-color: $accent-blue;\n    background: $dark-panel-blue;\n    color: $very-light-grey;\n  }\n\n  &__pose-note {\n    margin: 0;\n    color: $medium-grey;\n    font-size: 0.75rem;\n    line-height: 1.35;\n  }\n\n  &__debug {\n    display: none;\n    position: absolute;\n    left: 0.55rem;\n    bottom: 0.55rem;\n    z-index: 4;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.35rem;\n    max-width: #{\"min(26rem, 78%)\"};\n    max-height: calc(100% - 1.1rem);\n    overflow: hidden;\n    pointer-events: auto;\n  }\n\n  &__debug-toggle {\n    margin: 0;\n    padding: 0.15rem 0.5rem;\n    border: 1px solid rgba($medium-grey, 0.7);\n    border-radius: 6px;\n    background: rgba($dark-blue, 0.55);\n    color: rgba($very-light-grey, 0.55);\n    font-size: 0.68rem;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    cursor: pointer;\n    flex: 0 0 auto;\n    align-self: flex-start;\n  }\n\n  &__debug--open &__debug-toggle {\n    border-color: $accent-blue;\n  }\n\n  &__debug-body {\n    margin: 0;\n    max-height: 8rem;\n    overflow: auto;\n    padding: 0.4rem 0.55rem;\n    border: 1px solid $medium-grey;\n    border-radius: 6px;\n    background: rgba($dark-blue, 0.88);\n    color: $very-light-grey;\n    font-size: 0.68rem;\n    line-height: 1.35;\n    font-family: Consolas, \"Courier New\", monospace;\n    white-space: pre-wrap;\n    flex: 0 0 auto;\n  }\n\n  &__debug-stack {\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n    max-width: 100%;\n    min-height: 0;\n    flex: 1 1 auto;\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n\n  &__debug-prims {\n    max-height: none;\n    overflow: visible;\n    padding: 0.4rem 0.55rem;\n    border: 1px solid $medium-grey;\n    border-radius: 6px;\n    background: rgba($dark-blue, 0.88);\n    flex: 0 0 auto;\n  }\n\n  &__debug-prims-title {\n    margin: 0 0 0.35rem;\n    color: $light-grey;\n    font-size: 0.68rem;\n    font-weight: 700;\n    text-transform: uppercase;\n  }\n\n  &__debug-prim {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.4rem;\n    margin: 0 0 0.35rem;\n    color: $very-light-grey;\n    font-size: 0.68rem;\n    line-height: 1.3;\n    cursor: pointer;\n  }\n\n  &__debug-skin-note {\n    margin: 0.2rem 0 0;\n    color: $light-grey;\n    font-size: 0.64rem;\n    line-height: 1.3;\n  }\n\n  &__debug-seam {\n    margin: 0.35rem 0 0;\n    max-height: 16rem;\n    overflow: auto;\n    padding: 0.35rem 0.4rem;\n    border: 1px solid $medium-grey;\n    border-radius: 4px;\n    background: $very-dark-grey;\n    color: $very-light-grey;\n    font-size: 0.62rem;\n    line-height: 1.35;\n    font-family: Consolas, \"Courier New\", monospace;\n    white-space: pre-wrap;\n  }\n\n  &__viewer {\n    position: relative;\n    flex: 1 1 auto;\n    width: 100%;\n    min-height: 620px;\n    height: calc(100vh - 260px);\n    max-height: 840px;\n    overflow: hidden;\n    border-radius: 8px;\n\n    .personal-hub-blueprint-model {\n      min-height: 620px;\n      height: 100%;\n      border-color: rgba($accent-blue, 0.22);\n      border-radius: 8px;\n    }\n\n    .personal-hub-blueprint-model--bg-default {\n      background:\n        radial-gradient(ellipse 24% 58% at 50% 0%, rgba($light-blue, 0.14), transparent 72%),\n        radial-gradient(circle at 50% 48%, transparent 32%, rgba($pure-black, 0.46) 100%),\n        linear-gradient(180deg, #0c1a28 0%, #071018 100%);\n    }\n\n    .personal-hub-blueprint-model::after {\n      content: \"\";\n      position: absolute;\n      inset: 0;\n      pointer-events: none;\n      z-index: 2;\n      box-shadow: inset 0 0 88px rgba($pure-black, 0.46);\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      left: 50%;\n      top: 0;\n      z-index: 2;\n      width: 22%;\n      height: 82%;\n      transform: translateX(-50%);\n      pointer-events: none;\n      background: linear-gradient(\n        180deg,\n        rgba($light-blue, 0.34) 0%,\n        rgba($light-blue, 0.16) 16%,\n        rgba($accent-blue, 0.09) 46%,\n        rgba($light-blue, 0.04) 76%,\n        transparent 100%\n      );\n      mask-image: linear-gradient(90deg, transparent 0%, #000 38%, #000 62%, transparent 100%);\n      -webkit-mask-image: linear-gradient(90deg, transparent 0%, #000 38%, #000 62%, transparent 100%);\n      mix-blend-mode: screen;\n    }\n\n    .personal-hub-blueprint-model__canvas {\n      width: 100%;\n      height: 100%;\n      min-height: 620px;\n    }\n  }\n\n  &__viewer-loading {\n    position: absolute;\n    inset: 0;\n    z-index: 4;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba($pure-black, 0.46);\n\n    .spinner-container {\n      height: auto;\n      width: auto;\n      top: auto;\n    }\n  }\n\n  &__status {\n    margin: 0;\n    color: $light-grey;\n    font-size: 0.9rem;\n  }\n\n  &__status--error {\n    color: $bright-red;\n  }\n\n  &__meta {\n    margin: 0;\n    color: rgba($medium-grey, 0.55);\n    font-size: 0.64rem;\n    line-height: 1.35;\n    word-break: break-all;\n  }\n}\n\n.gear-loadout-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  padding: 0;\n  overflow: hidden;\n\n  .field-label {\n    color: $medium-light-grey;\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n  }\n}\n\n.gear-loadout-setups {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n\n  &__toolbar {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-end;\n    gap: 12px 16px;\n    max-width: 100%;\n    min-width: 0;\n  }\n\n  &__toolbar-main {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n\n  &__name-wrap {\n    display: flex;\n    flex: 1 1 220px;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 180px;\n    max-width: 320px;\n  }\n\n  /* Scrollport: fixed to parent width. Inner list may be wider. */\n  &__carousel {\n    box-sizing: border-box;\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    overflow-x: auto;\n    overflow-y: hidden;\n    overscroll-behavior-x: contain;\n    @include scrollbar-styles();\n  }\n\n  &__list {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: stretch;\n    gap: 8px;\n    box-sizing: border-box;\n    width: max-content;\n    max-width: none;\n    min-width: 0;\n    max-height: none;\n    margin: 0;\n    padding: 4px 2px 8px;\n    overflow: visible;\n    list-style: none;\n  }\n\n  &__item {\n    display: flex;\n    flex: 0 0 auto;\n    align-items: center;\n    gap: 6px;\n    width: 200px;\n    max-width: 200px;\n    margin: 0;\n    padding: 6px 8px;\n    border: 1px solid $blue-grey;\n    border-radius: 8px;\n    background: $very-dark-grey;\n    color: $light-grey;\n  }\n\n  &__item--active {\n    border-color: rgba($light-blue, 0.75);\n    background: rgba($dark-panel-blue, 0.9);\n    color: $very-light-grey;\n  }\n\n  &__item--dragging {\n    opacity: 0.85;\n    box-shadow: 0 6px 18px rgba($pure-black, 0.45);\n    z-index: 2;\n  }\n\n  &__drag {\n    flex: 0 0 auto;\n    margin: 0;\n    padding: 2px 4px;\n    border: 0;\n    border-radius: 4px;\n    background: transparent;\n    color: $medium-light-grey;\n    font-size: 0.7rem;\n    letter-spacing: -0.08em;\n    line-height: 1;\n    cursor: grab;\n  }\n\n  &__drag:active {\n    cursor: grabbing;\n  }\n\n  &__drag:disabled {\n    opacity: 0.4;\n    cursor: default;\n  }\n\n  &__item-main {\n    display: flex;\n    flex: 1 1 auto;\n    align-items: center;\n    gap: 8px;\n    min-width: 0;\n    margin: 0;\n    padding: 2px 0;\n    border: 0;\n    background: transparent;\n    color: inherit;\n    text-align: left;\n    cursor: pointer;\n  }\n\n  &__thumb {\n    flex: 0 0 36px;\n    width: 36px;\n    height: 36px;\n    border-radius: 5px;\n    border: 1px solid $blue-grey;\n    background: $dark-panel-blue;\n\n    &::after {\n      content: \"\";\n      display: block;\n      width: 100%;\n      height: 100%;\n      background: $medium-light-grey;\n      mask-repeat: no-repeat;\n      mask-position: center;\n      mask-size: 16px 16px;\n      -webkit-mask-repeat: no-repeat;\n      -webkit-mask-position: center;\n      -webkit-mask-size: 16px 16px;\n      mask-image: url(\"../images/icons/user.svg\");\n      -webkit-mask-image: url(\"../images/icons/user.svg\");\n    }\n  }\n\n  &__item-text {\n    display: flex;\n    flex: 1 1 auto;\n    min-width: 0;\n    flex-direction: column;\n    gap: 1px;\n  }\n\n  &__item-name {\n    overflow: hidden;\n    color: inherit;\n    font-size: 0.8rem;\n    font-weight: 600;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__item-sub {\n    color: $medium-light-grey;\n    font-size: 0.68rem;\n  }\n\n  &__item-tools {\n    display: flex;\n    flex: 0 0 auto;\n    align-items: center;\n    gap: 2px;\n  }\n\n  &__icon-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 26px;\n    height: 26px;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    border-radius: 4px;\n    background: transparent;\n    cursor: pointer;\n  }\n\n  &__icon-btn:hover,\n  &__icon-btn:focus-visible {\n    background: rgba($accent-blue, 0.22);\n  }\n\n  &__icon-btn--danger:hover,\n  &__icon-btn--danger:focus-visible {\n    background: rgba($bright-red, 0.18);\n  }\n\n  &__icon-btn:disabled {\n    opacity: 0.45;\n    cursor: default;\n  }\n\n  &__icon {\n    display: block;\n    width: 14px;\n    height: 14px;\n    background: $light-grey;\n    mask-repeat: no-repeat;\n    mask-position: center;\n    mask-size: contain;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    -webkit-mask-size: contain;\n  }\n\n  &__icon--edit {\n    mask-image: url(\"../images/icons/pencil-fill.svg\");\n    -webkit-mask-image: url(\"../images/icons/pencil-fill.svg\");\n  }\n\n  &__icon--trash {\n    background: $bright-red;\n    mask-image: url(\"../images/icons/trash3.svg\");\n    -webkit-mask-image: url(\"../images/icons/trash3.svg\");\n  }\n\n  &__icon--plus {\n    width: 12px;\n    height: 12px;\n    background: $light-blue;\n    mask-image: url(\"../images/icons/plus.svg\");\n    -webkit-mask-image: url(\"../images/icons/plus.svg\");\n  }\n\n  &__new {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    width: auto;\n    margin: 0;\n    padding: 7px 12px;\n    border: 1px solid $light-blue;\n    border-radius: 6px;\n    background: transparent;\n    color: $light-blue;\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n    cursor: pointer;\n  }\n\n  &__new:disabled {\n    opacity: 0.45;\n    cursor: default;\n  }\n\n  &__empty {\n    margin: 0;\n    color: $medium-light-grey;\n    font-size: 0.75rem;\n  }\n\n  &__item--skeleton {\n    pointer-events: none;\n    min-height: 48px;\n  }\n\n  &__skeleton-bar {\n    display: block;\n    height: 10px;\n    border-radius: 4px;\n    background: $medium-grey;\n    animation: gear-loadout-setups-pulse 1.1s ease-in-out infinite;\n  }\n\n  &__skeleton-bar--name {\n    width: 58%;\n    height: 12px;\n  }\n\n  &__skeleton-bar--sub {\n    width: 34%;\n    height: 8px;\n    margin-top: 6px;\n    opacity: 0.7;\n  }\n\n  &__name {\n    width: 100%;\n    max-width: none;\n    box-sizing: border-box;\n    appearance: none;\n    padding: 8px 10px;\n    border: 1px solid $blue-grey;\n    border-radius: 6px;\n    background: $very-dark-grey;\n    color: $very-light-grey;\n    font-size: 0.85rem;\n    color-scheme: dark;\n  }\n\n  &__name:focus {\n    outline: none;\n    border-color: $accent-blue;\n  }\n\n  &__name:disabled {\n    opacity: 0.55;\n  }\n\n  &__status {\n    margin: 0;\n    color: $medium-light-grey;\n    font-size: 0.75rem;\n    flex: 1 1 100%;\n  }\n}\n\n@keyframes gear-loadout-setups-pulse {\n  0%,\n  100% {\n    opacity: 0.4;\n  }\n  50% {\n    opacity: 0.85;\n  }\n}\n\n.gear-loadout-confirm {\n  position: fixed;\n  inset: 0;\n  z-index: 20000;\n  display: grid;\n  place-items: center;\n  background: rgba($pure-black, 0.6);\n}\n\n.gear-loadout-confirm__card {\n  width: unquote(\"min(92vw, 440px)\");\n  padding: 20px;\n  border: 1px solid $medium-grey;\n  border-radius: 10px;\n  background: $dark-grey;\n  box-shadow: 0 10px 30px rgba($pure-black, 0.4);\n}\n\n.gear-loadout-confirm__title {\n  margin: 0 0 10px;\n  color: $very-light-grey;\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.gear-loadout-confirm__message {\n  margin: 0;\n  color: $light-grey;\n  font-size: 0.9rem;\n  line-height: 1.4;\n}\n\n.gear-loadout-confirm__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 18px;\n}\n\n.gear-loadout-confirm__btn {\n  margin: 0;\n  padding: 8px 14px;\n  border: 1px solid $medium-grey;\n  border-radius: 6px;\n  background: transparent;\n  color: $very-light-grey;\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n.gear-loadout-confirm__btn--confirm {\n  border-color: $accent-blue;\n}\n\n.gear-loadout-confirm__btn--danger {\n  border-color: $bright-red;\n  color: $bright-red;\n}\n\n.gear-loadout-confirm__btn:disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n\n.gear-loadout-slots {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n\n  &__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n  }\n\n  &__count {\n    color: $medium-light-grey;\n    font-size: 0.68rem;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n  }\n\n  &__grid {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n    gap: 8px;\n    align-items: start;\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n  }\n\n  &__col {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    min-width: 0;\n    max-width: 100%;\n    padding: 8px;\n    border: 1px solid rgba($light-blue, 0.35);\n    border-radius: 8px;\n    background: rgba($very-dark-grey, 0.45);\n  }\n\n  &__col-title {\n    margin: 0;\n    color: $very-light-grey;\n    font-size: 0.64rem;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n  }\n\n  &__list {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    min-width: 0;\n  }\n\n  &__row {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    min-width: 0;\n  }\n\n  @media (max-width: 700px) {\n    &__grid {\n      grid-template-columns: minmax(0, 1fr);\n    }\n  }\n}\n\n.gear-loadout-slot {\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  margin: 0;\n  border: 1px solid rgba($light-blue, 0.45);\n  border-radius: 7px;\n  background: rgba($very-dark-grey, 0.85);\n  color: $light-grey;\n\n  &--empty {\n    border-style: solid;\n    border-color: rgba($light-blue, 0.38);\n    background: rgba($very-dark-grey, 0.55);\n  }\n\n  &--filled {\n    background: rgba($dark-panel-blue, 0.55);\n  }\n\n  &--active {\n    border-color: rgba($light-blue, 0.85);\n    background: rgba($dark-panel-blue, 0.78);\n    box-shadow: 0 0 0 1px rgba($light-blue, 0.18);\n  }\n\n  &--locked {\n    border-color: rgba($medium-grey, 0.75);\n    background: rgba($very-dark-grey, 0.4);\n  }\n\n  &__qty {\n    display: flex;\n    align-items: center;\n    gap: 2px;\n    flex: 0 0 auto;\n    margin: 0 2px 0 0;\n    padding: 0 2px;\n    color: $medium-light-grey;\n    font-size: 0.66rem;\n    font-weight: 700;\n  }\n\n  &__qty-label {\n    opacity: 0.7;\n  }\n\n  &__qty-input {\n    width: 2rem;\n    margin: 0;\n    padding: 1px 2px;\n    border: 1px solid $blue-grey;\n    border-radius: 4px;\n    background: $very-dark-grey;\n    color: $light-grey;\n    font: inherit;\n    font-size: 0.68rem;\n    text-align: center;\n  }\n\n  &__qty-max {\n    opacity: 0.65;\n    font-size: 0.62rem;\n  }\n\n  &__hit {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 0;\n    box-sizing: border-box;\n    width: 100%;\n    min-width: 0;\n    margin: 0;\n    padding: 6px 32px 6px 8px;\n    border: 0;\n    background: transparent;\n    color: inherit;\n    text-align: left;\n    cursor: pointer;\n  }\n\n  &--filled &__hit {\n    padding-right: 52px;\n  }\n\n  &__hit:disabled {\n    cursor: not-allowed;\n  }\n\n  &--locked &__kind,\n  &--locked &__name {\n    color: $medium-grey;\n  }\n\n  &__cat {\n    display: flex;\n    flex: 0 0 22px;\n    align-items: center;\n    justify-content: center;\n    width: 22px;\n    height: 22px;\n    color: $very-light-grey;\n  }\n\n  &--filled &__cat {\n    color: $light-blue;\n  }\n\n  &__rule {\n    flex: 0 0 auto;\n    width: 1px;\n    height: 22px;\n    margin: 0 7px;\n    background: rgba($light-blue, 0.35);\n  }\n\n  &__cat-svg {\n    display: block;\n    width: 16px;\n    height: 16px;\n    fill: none;\n    stroke: currentColor;\n    stroke-width: 1.5;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n  }\n\n  &__thumb {\n    flex: 0 0 18px;\n    width: 18px;\n    height: 18px;\n    object-fit: cover;\n    border-radius: 3px;\n    border: 1px solid $blue-grey;\n  }\n\n  &__meta {\n    display: flex;\n    flex: 1 1 auto;\n    flex-direction: column;\n    gap: 0;\n    min-width: 0;\n    overflow: hidden;\n  }\n\n  &__kind {\n    overflow: hidden;\n    color: $very-light-grey;\n    font-size: 0.62rem;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__name-row {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    min-width: 0;\n    overflow: hidden;\n  }\n\n  &__name {\n    overflow: hidden;\n    color: rgba($light-blue, 0.85);\n    font-size: 0.64rem;\n    font-weight: 500;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__req {\n    color: $green;\n    font-size: 0.58rem;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n  }\n\n  &__req--locked {\n    color: $medium-grey;\n  }\n\n  &__mark {\n    position: absolute;\n    top: 50%;\n    right: 8px;\n    z-index: 1;\n    display: flex;\n    flex: 0 0 20px;\n    align-items: center;\n    justify-content: center;\n    width: 20px;\n    height: 20px;\n    margin: 0;\n    transform: translateY(-50%);\n    border: 1px solid rgba($light-blue, 0.7);\n    border-radius: 50%;\n    color: $very-light-grey;\n    font-size: 0.85rem;\n    font-weight: 500;\n    line-height: 1;\n  }\n\n  &__mark--filled {\n    border-color: $green;\n    color: $green;\n  }\n\n  &__mark--locked {\n    border-color: $medium-grey;\n    color: $medium-grey;\n  }\n\n  &__lock-svg {\n    display: block;\n    width: 11px;\n    height: 11px;\n    fill: none;\n    stroke: currentColor;\n    stroke-width: 1.8;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n  }\n\n  &__clear {\n    position: absolute;\n    top: 50%;\n    right: 32px;\n    z-index: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 18px;\n    height: 18px;\n    margin: 0;\n    padding: 0;\n    transform: translateY(-50%);\n    border: 0;\n    border-radius: 4px;\n    background: transparent;\n    color: $medium-light-grey;\n    font-size: 0.9rem;\n    line-height: 1;\n    cursor: pointer;\n  }\n\n  &__clear:hover,\n  &__clear:focus-visible {\n    color: $bright-red;\n    background: rgba($bright-red, 0.12);\n  }\n}\n\n.gear-loadout-builder-actions {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding-top: 2px;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n\n  &__btn {\n    flex: 1 1 0;\n    min-width: 0;\n    width: auto;\n    margin: 0;\n    padding: 8px 8px;\n    border: 1px solid $light-blue;\n    border-radius: 7px;\n    background: transparent;\n    color: $light-blue;\n    font-size: 0.68rem;\n    font-weight: 700;\n    letter-spacing: 0.02em;\n    text-transform: uppercase;\n    cursor: pointer;\n  }\n\n  &__btn--danger {\n    padding: 8px 8px;\n    border-color: $bright-red;\n    color: $bright-red;\n    font-size: 0.68rem;\n  }\n\n  &__btn:disabled {\n    opacity: 0.45;\n    cursor: default;\n  }\n}\n\n.gear-loadout-slot-picker {\n  position: fixed;\n  inset: 0;\n  z-index: 20000;\n  display: grid;\n  place-items: center;\n  background: rgba($pure-black, 0.6);\n}\n\n.gear-loadout-slot-picker__card {\n  width: unquote(\"min(92vw, 480px)\");\n  padding: 16px;\n  border: 1px solid $blue-grey;\n  border-radius: 8px;\n  background: $dark-grey;\n  box-shadow: 0 10px 30px rgba($pure-black, 0.4);\n}\n\n.gear-loadout-slot-picker__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.gear-loadout-slot-picker__title {\n  margin: 0;\n  color: $very-light-grey;\n  font-size: 0.92rem;\n  font-weight: 700;\n}\n\n.gear-loadout-slot-picker__close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  border-radius: 4px;\n  background: transparent;\n  color: $light-grey;\n  font-size: 1.2rem;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.gear-loadout-slot-picker__equipped {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 10px;\n  padding: 7px 8px;\n  border: 1px solid $blue-grey;\n  border-radius: 6px;\n  background: $very-dark-grey;\n}\n\n.gear-loadout-slot-picker__equipped-name {\n  overflow: hidden;\n  color: $very-light-grey;\n  font-size: 0.78rem;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.gear-loadout-slot-picker__unequip {\n  flex: 0 0 auto;\n  margin: 0;\n  padding: 4px 8px;\n  border: 1px solid $bright-red;\n  border-radius: 5px;\n  background: transparent;\n  color: $bright-red;\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n.gear-loadout-slot-picker .benefits-loot-actions {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  width: 100%;\n}\n\n.gear-loadout-slot-picker .benefits-loot-mention-wrap {\n  position: relative;\n  width: 100%;\n}\n\n.gear-loadout-slot-picker .benefits-loot-mention-input-shell {\n  display: flex;\n  align-items: stretch;\n  width: 100%;\n  background: $very-dark-grey;\n  border: 1px solid $blue-grey;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.gear-loadout-slot-picker .benefits-loot-mention-input-shell .benefits-loot-search-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  padding: 0 10px;\n  color: $light-grey;\n  background: $dark-panel-blue;\n}\n\n.gear-loadout-slot-picker .benefits-loot-mention-input-shell .benefits-loot-search-icon__svg {\n  display: block;\n  width: 16px;\n  height: 16px;\n}\n\n.gear-loadout-slot-picker .benefits-loot-mention-input-shell .benefits-loot-search-input {\n  width: 100%;\n  box-sizing: border-box;\n  flex: 1 1 auto;\n  min-width: 0;\n  appearance: none;\n  background: $very-dark-grey;\n  border: 0;\n  border-radius: 0;\n  padding: 8px 10px 8px 4px;\n  color: $very-light-grey;\n  font-size: 0.85rem;\n  font-weight: 600;\n  text-align: left;\n  color-scheme: dark;\n}\n\n.gear-loadout-slot-picker .benefits-loot-mention-input-shell .benefits-loot-search-input:focus {\n  outline: none;\n}\n\n.gear-loadout-slot-picker .benefits-loot-search-hint {\n  margin-top: 4px;\n  color: $medium-light-grey;\n  font-size: 0.72rem;\n}\n\n.gear-loadout-slot-picker .benefits-loot-mention-wrap .mention-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 10050;\n  max-height: 240px;\n  margin: 4px 0 0;\n  padding: 0;\n  overflow-y: auto;\n  list-style: none;\n  background: rgba($very-dark-grey, 0.98);\n  border: 1px solid $blue-grey;\n  border-radius: 6px;\n  box-shadow: 0 14px 24px rgba(0, 0, 0, 0.28);\n  @include scrollbar-styles();\n}\n\n.gear-loadout-slot-picker .benefits-loot-mention-wrap .mention-dropdown .dropdown-item {\n  display: flex;\n  align-items: flex-start;\n  padding: 6px 10px;\n  cursor: pointer;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n\n  &:last-child {\n    border-bottom: none;\n  }\n\n  &.selected {\n    background-color: rgba($accent-blue, 0.22);\n  }\n\n  &:hover {\n    background-color: rgba(255, 255, 255, 0.06);\n  }\n\n  .mention-name {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 2px;\n    min-width: 0;\n    line-height: 1.25;\n  }\n\n  .benefits-loot-dd-label {\n    max-width: 100%;\n    overflow: hidden;\n    color: rgba(255, 255, 255, 0.92);\n    font-size: 13px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .benefits-loot-dd-meta {\n    max-width: 100%;\n    overflow: hidden;\n    color: rgba(255, 255, 255, 0.55);\n    font-size: 11px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n.sc-location-selector {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  width: 100%;\n\n  .field-input {\n    width: 100%;\n    max-width: 520px;\n  }\n}\n\n.sc-location-selector__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.sc-location-selector__groups {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 14px;\n  width: 100%;\n}\n\n.sc-location-selector__group,\n.sc-location-selector__pois {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n}\n\n.sc-location-selector__group-title {\n  margin: 0;\n  color: rgba(255, 255, 255, 0.88);\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.sc-location-selector__option-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-height: 320px;\n  overflow-y: auto;\n  padding-right: 4px;\n  @include scrollbar-styles();\n}\n\n.sc-location-selector__option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  width: 100%;\n  min-height: 38px;\n  padding: 8px 10px;\n  color: rgba(255, 255, 255, 0.9);\n  text-align: left;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.09);\n  border-radius: 6px;\n  cursor: pointer;\n\n  &:hover:not(:disabled),\n  &.selected {\n    background: rgba($accent-blue, 0.2);\n    border-color: rgba($accent-blue, 0.55);\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n}\n\n.sc-location-selector__option-name {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sc-location-selector__option-type {\n  flex: 0 0 auto;\n  color: rgba(255, 255, 255, 0.56);\n  font-size: 12px;\n}\n\n.sc-location-selector__status {\n  color: rgba(255, 255, 255, 0.62);\n  font-size: 13px;\n}\n\n.sc-location-selector__status--error {\n  color: #ff8c8c;\n}\n\n.sc-location-selector__selected {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  color: rgba(255, 255, 255, 0.84);\n  font-size: 13px;\n}\n\n.sc-location-selector__selected-label {\n  color: rgba(255, 255, 255, 0.56);\n}\n\n.sc-location-selector__solar-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n  max-width: 640px;\n  padding: 12px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.09);\n  border-radius: 6px;\n}\n\n.sc-location-selector__solar-title {\n  margin: 0;\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.sc-location-selector__solar-grid {\n  display: grid;\n  grid-template-columns: minmax(130px, 0.45fr) minmax(0, 1fr);\n  gap: 8px 14px;\n  margin: 0;\n\n  dt,\n  dd {\n    min-width: 0;\n    margin: 0;\n    font-size: 13px;\n    line-height: 1.35;\n  }\n\n  dt {\n    color: rgba(255, 255, 255, 0.56);\n  }\n\n  dd {\n    color: rgba(255, 255, 255, 0.88);\n    overflow-wrap: anywhere;\n  }\n}\n\n.org-credits-page {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding-bottom: 1.5rem;\n\n  .ts-page-header {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.75rem;\n  }\n\n  .org-credits-admin-hint {\n    margin: 0 0 0.75rem;\n    font-size: 0.85rem;\n    opacity: 0.75;\n    max-width: 52rem;\n  }\n\n  .org-credits-meta {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px 28px;\n    flex: 1 1 auto;\n  }\n\n  .ts-toolbar.ts-toolbar--compact {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.75rem 1rem;\n  }\n\n  .org-credits-image-actions {\n    display: flex;\n    align-items: center;\n    gap: 0.65rem;\n    margin-left: auto;\n    flex: 0 0 auto;\n  }\n\n  .org-credits-image-thumb {\n    width: 35px;\n    height: 35px;\n    padding: 5px;\n    object-fit: cover;\n    border-radius: 8px;\n    flex: 0 0 auto;\n  }\n\n  .org-credits-image-input {\n    display: none;\n  }\n\n  .org-credits-meta-item {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 160px;\n  }\n\n  .org-credits-meta-label {\n    color: rgba($very-light-grey, 0.62);\n    font-size: 0.72rem;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n  }\n\n  .org-credits-meta-value {\n    color: $very-light-grey;\n    font-size: 0.9rem;\n    font-weight: 600;\n  }\n\n  .org-credits-status {\n    margin: 0 0 0.75rem;\n    color: $light-grey;\n    font-size: 0.9rem;\n  }\n\n  .org-credits-status--error {\n    color: $bright-red;\n  }\n\n  .org-credits-count {\n    font-variant-numeric: tabular-nums;\n    white-space: nowrap;\n  }\n\n  .cell-source {\n    max-width: 0;\n    overflow: hidden;\n  }\n\n  .org-credits-source {\n    color: rgba($very-light-grey, 0.72);\n    font-size: 0.8rem;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .org-credits-credit-input {\n    width: 100%;\n    max-width: 8rem;\n  }\n\n  .org-credits-preview-btn {\n    white-space: nowrap;\n    padding: 0.3rem 0.65rem;\n    font-size: 0.78rem;\n  }\n\n  .org-credits-empty {\n    color: $light-grey;\n    text-align: center;\n    padding: 1rem 0.75rem;\n  }\n\n  .ts-table-scroll--org-credits {\n    max-height: calc(100vh - 775px);\n  }\n\n  .accounting-table--org-credits-head,\n  .accounting-table--org-credits-body {\n    col.col-category { width: 16%; }\n    col.col-size { width: 7%; }\n    col.col-itemCount { width: 9%; }\n    col.col-source { width: 36%; }\n    col.col-preview { width: 12%; }\n    col.col-creditValue { width: 20%; }\n  }\n\n  .cell-itemCount,\n  th.header-itemCount {\n    text-align: right;\n  }\n\n  .cell-preview,\n  th.header-preview {\n    text-align: center;\n    vertical-align: middle;\n  }\n\n  .cell-creditValue,\n  th.header-creditValue {\n    text-align: left;\n  }\n\n  .org-credits-auction-admin {\n    margin-top: 1.25rem;\n  }\n\n  .org-credits-admin-grid {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.75rem;\n    margin-bottom: 0.85rem;\n    align-items: flex-end;\n  }\n\n  .org-credits-admin-field {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n    min-width: 9rem;\n\n    span {\n      font-size: 0.75rem;\n      color: $light-grey;\n      text-transform: uppercase;\n      letter-spacing: 0.04em;\n    }\n  }\n\n  .org-credits-admin-field--wide {\n    width: 100%;\n    margin-bottom: 0.85rem;\n  }\n\n  .org-credits-admin-subtitle {\n    margin: 1.1rem 0 0.55rem;\n    font-size: 0.85rem;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: $very-light-grey;\n  }\n\n  .org-credits-admin-list {\n    margin: 0 0 0.75rem;\n    padding-left: 1.1rem;\n    color: $light-grey;\n  }\n}\n\n.org-credits-preview-modal-overlay {\n  display: flex;\n  position: fixed;\n  inset: 0;\n  align-items: center;\n  justify-content: center;\n  padding: 1.25rem;\n  background: rgba($very-dark-grey, 0.72);\n  z-index: 220;\n}\n\n.org-credits-preview-modal {\n  display: flex;\n  flex-direction: column;\n  width: unquote('min(920px, 100%)');\n  max-height: unquote('min(82vh, 860px)');\n  border-radius: 14px;\n  border: 1px solid rgba($accent-blue, 0.45);\n  background:\n    linear-gradient(135deg, rgba($dark-blue, 0.96), rgba($dark-blue-grey, 0.9)),\n    $dark-blue;\n  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.4);\n  overflow: hidden;\n  color: $very-light-grey;\n}\n\n.org-credits-preview-modal__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.95rem 1.1rem;\n  border-bottom: 1px solid rgba($accent-blue, 0.28);\n}\n\n.org-credits-preview-modal__title {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: $very-light-grey;\n}\n\n.org-credits-preview-modal__close {\n  border: 0;\n  background: transparent;\n  color: $light-grey;\n  font-size: 1.4rem;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0.15rem 0.4rem;\n\n  &:hover {\n    color: $very-light-grey;\n  }\n}\n\n.org-credits-preview-modal__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  padding: 0.9rem 1.1rem;\n  overflow: hidden;\n}\n\n.org-credits-preview-modal__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.85rem 1.1rem;\n  border-top: 1px solid rgba($accent-blue, 0.28);\n}\n\n.org-credits-preview-modal__count {\n  color: $light-grey;\n  font-size: 0.82rem;\n}\n\n.org-credits-preview-table-wrap {\n  .ts-table-scroll--org-credits-preview {\n    max-height: unquote('min(52vh, 520px)');\n  }\n\n  .accounting-table {\n    color: $very-light-grey;\n\n    th {\n      color: rgba($very-light-grey, 0.62);\n    }\n\n    td {\n      color: $very-light-grey;\n    }\n  }\n\n  .accounting-table--org-credits-preview-head,\n  .accounting-table--org-credits-preview-body {\n    col.col-name { width: 48%; }\n    col.col-type { width: 36%; }\n    col.col-size { width: 16%; }\n  }\n\n  .org-credits-empty {\n    color: $light-grey;\n  }\n\n  .org-credits-status {\n    color: $light-grey;\n  }\n\n  .org-credits-status--error {\n    color: $bright-red;\n  }\n}\n","// Character Creator shell — Gear Loadout mannequin editor\n\n.cc-shell {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n}\n\n.cc-nav,\n.cc-subnav,\n.cc-sex {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.cc-nav__btn,\n.cc-subnav__btn,\n.cc-sex__btn {\n  margin: 0;\n  padding: 6px 10px;\n  border: 1px solid $medium-grey;\n  border-radius: 6px;\n  background: $very-dark-grey;\n  color: $light-grey;\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n.cc-nav__btn--on,\n.cc-subnav__btn--on,\n.cc-sex__btn--on {\n  border-color: $accent-blue;\n  background: $dark-panel-blue;\n  color: $very-light-grey;\n}\n\n.cc-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.cc-field {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n}\n\n.cc-field--check {\n  justify-content: flex-start;\n}\n\n.cc-field__k {\n  flex: 0 0 7.2rem;\n  min-width: 7.2rem;\n  color: $light-grey;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.cc-field__range,\n.cc-field__select,\n.cc-field__color {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.cc-field__v {\n  flex: 0 0 4.4rem;\n  color: $medium-light-grey;\n  font-size: 0.72rem;\n  text-align: right;\n}\n\n.cc-note {\n  margin: 0;\n  color: $medium-light-grey;\n  font-size: 0.75rem;\n}\n\n.cc-note--err {\n  color: $bright-red;\n}\n\n.cc-kv {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin: 0;\n\n  div {\n    display: flex;\n    gap: 8px;\n  }\n\n  dt {\n    flex: 0 0 7.2rem;\n    color: $light-grey;\n    font-size: 0.72rem;\n    text-transform: uppercase;\n  }\n\n  dd {\n    margin: 0;\n    color: $very-light-grey;\n    font-size: 0.78rem;\n  }\n}\n\n.cc-dna-parts {\n  margin: 0;\n  padding-left: 1.1rem;\n  color: $light-grey;\n  font-size: 0.75rem;\n}\n\n.cc-dye-grad__track {\n  position: relative;\n  height: 10px;\n  border-radius: 6px;\n  background: $medium-grey;\n}\n\n.cc-dye-grad__handle {\n  position: absolute;\n  top: -3px;\n  width: 8px;\n  height: 16px;\n  border-radius: 2px;\n  background: $accent-blue;\n}\n\n.cc-dye-grad__handle--dead {\n  opacity: 0.35;\n}\n\n.cc-dye-grad__handle--dead:first-of-type {\n  left: 18%;\n}\n\n.cc-dye-grad__handle--dead:last-of-type {\n  left: 62%;\n}\n\n.cc-import,\n.cc-export {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  padding: 6px 10px;\n  border: 1px solid $medium-grey;\n  border-radius: 6px;\n  background: $very-dark-grey;\n  color: $light-grey;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.cc-export:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.cc-import input {\n  color: $light-grey;\n}\n","// src/styles/adminDashboard.scss\n\n@import './variables.scss';\n\n// Toolbar — date range + save\n.admin-dashboard-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1.25rem;\n  padding: 0.9rem 1rem;\n  background:\n    linear-gradient(180deg, rgba($dark-blue, 0.72), rgba($dark-blue-grey, 0.42)),\n    rgba($dark-blue, 0.55);\n  border: 1px solid rgba($accent-blue, 0.45);\n  border-radius: 12px;\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.35),\n    0 10px 24px rgba(0, 0, 0, 0.28);\n}\n\n.admin-dashboard-toolbar__controls {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 1rem 1.5rem;\n}\n\n.admin-dashboard-toolbar__hint {\n  margin: 0;\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.55);\n}\n\n.admin-dashboard-toolbar__dates {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 1rem 1.25rem;\n}\n\n.admin-dashboard-toolbar__date-field {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n\n  label {\n    margin: 0;\n    font-size: 0.72rem;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.62);\n    white-space: nowrap;\n  }\n\n  .react-datepicker-wrapper {\n    width: auto;\n  }\n\n  input {\n    min-width: 8.5rem;\n    padding: 0.4rem 0.65rem;\n    border: 1px solid rgba($accent-blue, 0.45);\n    border-radius: 8px;\n    font-family: inherit;\n    font-size: 0.82rem;\n    color: $very-light-grey;\n    background: rgba($dark-blue, 0.65);\n\n    &:focus-visible {\n      outline: 2px solid rgba($accent-blue, 0.65);\n      outline-offset: 2px;\n    }\n  }\n}\n\n.admin-dashboard-toolbar__save {\n  flex-shrink: 0;\n}\n\n// Chart grid\n.admin-chart-grid {\n  width: 100%;\n  position: relative;\n  overflow: visible;\n}\n\n.admin-chart-grid__layout {\n  width: 100%;\n}\n\n.admin-chart-grid {\n  .react-grid-item {\n    z-index: 0;\n    transition: box-shadow 0.2s ease;\n\n    &.react-draggable-dragging {\n      z-index: 10;\n\n      .admin-chart-card {\n        border-color: rgba($light-blue, 0.75);\n        box-shadow:\n          0 0 0 1px rgba($light-blue, 0.35),\n          0 16px 36px rgba(0, 0, 0, 0.45);\n      }\n    }\n\n    &.resizing .admin-chart-card {\n      border-color: rgba($accent-blue, 0.75);\n    }\n  }\n\n  .react-grid-placeholder {\n    background: rgba($accent-blue, 0.18) !important;\n    border: 1px dashed rgba($accent-blue, 0.55) !important;\n    border-radius: 12px !important;\n    opacity: 0.85 !important;\n  }\n\n  .react-grid-item > .react-resizable-handle {\n    z-index: 5;\n    opacity: 0.45;\n    transition: opacity 0.2s ease;\n\n    &::after {\n      border-right: 2px solid rgba($accent-blue, 0.85) !important;\n      border-bottom: 2px solid rgba($accent-blue, 0.85) !important;\n    }\n  }\n\n  .react-grid-item:hover > .react-resizable-handle,\n  .react-grid-item.resizing > .react-resizable-handle {\n    opacity: 1;\n  }\n}\n\n// Chart cards\n.admin-chart-card {\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  overflow: visible;\n  background:\n    linear-gradient(180deg, rgba($dark-blue, 0.78), rgba($dark-blue-grey, 0.48)),\n    rgba($panel-blue, 0.72);\n  border: 1px solid rgba($accent-blue, 0.4);\n  border-radius: 12px;\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.3),\n    0 8px 22px rgba(0, 0, 0, 0.26);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n\n  &:hover {\n    border-color: rgba($accent-blue, 0.58);\n  }\n}\n\n.admin-chart-card__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.85rem 1rem 0.7rem;\n  border-bottom: 1px solid rgba($accent-blue, 0.22);\n  cursor: grab;\n\n  &:active {\n    cursor: grabbing;\n  }\n}\n\n.admin-chart-card__heading {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  min-width: 0;\n}\n\n.admin-chart-card__title {\n  margin: 0;\n  font-size: 0.82rem;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.92);\n}\n\n.admin-chart-card__hint {\n  font-size: 0.62rem;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.42);\n}\n\n.admin-chart-card__toolbar {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  flex-shrink: 0;\n  margin-right: 0.75rem;\n}\n\n.admin-chart-card__select-label {\n  font-size: 0.68rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.55);\n}\n\n.admin-chart-card__select {\n  min-width: 7.5rem;\n  padding: 0.35rem 0.65rem;\n  border: 1px solid rgba($accent-blue, 0.45);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 0.78rem;\n  color: $very-light-grey;\n  background: rgba($dark-blue, 0.65);\n  cursor: pointer;\n\n  &:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n  }\n\n  &:focus-visible {\n    outline: 2px solid rgba($accent-blue, 0.65);\n    outline-offset: 2px;\n  }\n}\n\n.admin-chart-card__body {\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0.35rem 0.75rem 0.85rem;\n}\n\n.admin-chart-render {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: 220px;\n}\n\n.admin-chart-render__canvas {\n  width: 100%;\n  height: 100%;\n  min-height: 220px;\n}\n\n.admin-chart-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  width: 100%;\n  height: 100%;\n  min-height: 220px;\n  border: 1px dashed rgba($accent-blue, 0.28);\n  border-radius: 10px;\n  background: rgba($dark-blue, 0.25);\n}\n\n.admin-chart-empty__label {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: rgba($very-light-grey, 0.75);\n}\n\n.admin-chart-empty__hint {\n  font-size: 0.72rem;\n  color: rgba($very-light-grey, 0.48);\n}\n\n// Legacy aliases (other admin views may still reference these)\n.admin-statistic-menu {\n  @extend .admin-dashboard-toolbar;\n}\n\n.date-picker-container {\n  @extend .admin-dashboard-toolbar__dates;\n}\n\n.input-date {\n  @extend .admin-dashboard-toolbar__date-field;\n}\n\n.graph {\n  @extend .admin-chart-card;\n}\n\n.chart-header {\n  @extend .admin-chart-card__header;\n}\n\n.custom-charts {\n  @extend .admin-chart-card__title;\n}\n\n.graph-selector {\n  @extend .admin-chart-card__toolbar;\n}\n\n.chart-grid-container {\n  @extend .admin-chart-grid;\n}\n\n.render-chart {\n  @extend .admin-chart-render;\n}\n\n.charts-renderChart {\n  @extend .admin-chart-render;\n}\n\n.charts-types {\n  width: 100%;\n  height: 100%;\n  min-height: 220px;\n}\n\n@media (max-width: $tablet) {\n  .admin-dashboard-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .admin-dashboard-toolbar__controls {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .admin-chart-card__header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .admin-chart-card__toolbar {\n    margin-right: 0;\n    justify-content: flex-end;\n  }\n}\n\n// Shared day-window toggle (Activity + Org event history + Recruitment)\n.admin-dashboard-activity,\n.admin-dashboard-org-events,\n.admin-dashboard-recruitment {\n  .admin-activity-range {\n    display: inline-flex;\n    align-items: stretch;\n    padding: 3px;\n    border-radius: 999px;\n    border: 1px solid rgba($accent-blue, 0.45);\n    background: rgba($dark-blue, 0.55);\n    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.22);\n  }\n\n  .admin-activity-range__btn {\n    min-width: 3.25rem;\n    margin: 0;\n    padding: 0.4rem 0.85rem;\n    border: none;\n    border-radius: 999px;\n    background: transparent;\n    color: rgba($very-light-grey, 0.62);\n    font-family: inherit;\n    font-size: 0.78rem;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    cursor: pointer;\n    transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;\n\n    &:hover:not(.is-active) {\n      color: $very-light-grey;\n      background: rgba($medium-grey, 0.35);\n    }\n\n    &.is-active {\n      color: $very-light-grey;\n      background: linear-gradient(180deg, rgba($accent-blue, 0.55), rgba($dark-blue, 0.85));\n      box-shadow: 0 0 0 1px rgba($accent-blue, 0.35);\n    }\n  }\n\n  .admin-activity-count {\n    margin: 0;\n    font-size: 0.78rem;\n    font-weight: 600;\n    color: rgba($very-light-grey, 0.62);\n    white-space: nowrap;\n  }\n\n  .admin-activity-error {\n    margin: 0 0 1rem;\n    color: $red;\n    font-size: 0.85rem;\n  }\n}\n\n// Activity + Recruitment shared table chrome\n.admin-dashboard-activity,\n.admin-dashboard-recruitment {\n  .admin-activity-stats {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 0.45rem;\n    min-width: 0;\n  }\n\n  .admin-activity-missing {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    gap: 0.4rem;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  }\n\n  .admin-activity-missing__item {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.4rem;\n    padding: 0.28rem 0.55rem;\n    border-radius: 999px;\n    border: 1px solid rgba($bright-red, 0.35);\n    background: rgba($dark-red, 0.35);\n  }\n\n  .admin-activity-missing__label {\n    font-size: 0.68rem;\n    font-weight: 700;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.72);\n  }\n\n  .admin-activity-missing__value {\n    font-size: 0.72rem;\n    font-weight: 700;\n    color: $bright-red;\n    white-space: nowrap;\n  }\n\n  .admin-activity-table-wrap {\n    margin-top: 0.25rem;\n    overflow: hidden;\n    border-radius: 12px;\n    border: 1px solid rgba($accent-blue, 0.28);\n    background: rgba($dark-blue, 0.38);\n\n    .accounting-table {\n      margin-bottom: 0;\n      width: 100%;\n      table-layout: fixed;\n      border-collapse: collapse;\n    }\n\n    col.col-rank { width: 11rem; }\n    col.col-handle { width: auto; }\n    col.col-eventCount { width: 5.5rem; }\n    col.col-lastEventAt { width: 8.5rem; }\n    col.col-training { width: 7.5rem; }\n\n    > .accounting-table {\n      thead {\n        display: table-header-group;\n        background-size: cover;\n        color: $light-grey;\n        text-transform: uppercase;\n        border-bottom: 2px solid $grey;\n        @include steel-bg(\"../medias/steel.png\");\n      }\n\n      thead th {\n        position: relative;\n        top: auto;\n        z-index: auto;\n        height: 30px;\n        padding: 0 12px;\n        font-size: 0.75em;\n        font-weight: 600;\n        letter-spacing: normal;\n        line-height: 30px;\n        color: $light-grey;\n        background: transparent;\n        border-bottom: none;\n        border-right: none;\n        vertical-align: middle;\n        text-align: left;\n        white-space: nowrap;\n\n        &:not(:last-child)::after {\n          content: '';\n          position: absolute;\n          right: 0;\n          top: 50%;\n          transform: translateY(-50%);\n          width: 1px;\n          height: 65%;\n          background-color: $grey;\n        }\n      }\n    }\n  }\n\n  .admin-activity-table-scroll {\n    display: block;\n    max-height: calc(100vh - 725px);\n    overflow-y: auto;\n    overflow-x: hidden;\n    @include accounting-inventory-scrollbar;\n\n    .accounting-table thead {\n      display: none;\n    }\n  }\n\n  .admin-activity-table {\n    td {\n      padding: 0.65rem 0.85rem;\n      vertical-align: middle;\n      font-size: 0.85rem;\n      color: $very-light-grey;\n      border-bottom: 1px solid rgba($medium-grey, 0.35);\n    }\n\n    tbody tr:last-child td {\n      border-bottom: none;\n    }\n\n    .header-eventCount,\n    .cell-eventCount,\n    .header-training,\n    .cell-training {\n      text-align: center;\n    }\n\n    .header-lastEventAt,\n    .cell-lastEventAt {\n      white-space: nowrap;\n    }\n\n    .accounting-table__empty {\n      text-align: center;\n      padding: 2rem 1rem;\n      color: rgba($very-light-grey, 0.55);\n    }\n  }\n\n  .admin-activity-handle {\n    display: flex;\n    flex-direction: column;\n    gap: 0.15rem;\n    min-width: 0;\n  }\n\n  .admin-activity-handle__primary {\n    font-weight: 600;\n  }\n\n  .admin-activity-handle__secondary {\n    font-size: 0.72rem;\n    color: rgba($very-light-grey, 0.55);\n  }\n\n  .admin-activity-rank {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.45rem;\n    min-width: 0;\n  }\n\n  .admin-activity-rank__icon {\n    width: 1.35rem;\n    height: 1.35rem;\n    object-fit: contain;\n    flex-shrink: 0;\n  }\n\n  .admin-activity-rank__placeholder {\n    display: inline-block;\n    width: 1.35rem;\n    height: 1.35rem;\n    flex-shrink: 0;\n    border-radius: 3px;\n    background: rgba($very-light-grey, 0.12);\n  }\n\n  .admin-activity-rank__label {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 0.8rem;\n  }\n\n  .ts-status {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 0.55rem;\n    height: 0.55rem;\n    border-radius: 50%;\n\n    &.is-active {\n      background: $light-green;\n      box-shadow: 0 0 0 3px rgba($light-green, 0.18);\n    }\n\n    &.is-inactive {\n      background: rgba($very-light-grey, 0.28);\n      box-shadow: none;\n    }\n  }\n}\n\n// Shared summary chips (Org event history + Recruitment)\n.admin-dashboard-org-events,\n.admin-dashboard-recruitment {\n  .admin-org-events-summary {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    gap: 0.4rem;\n  }\n\n  .admin-org-events-summary__chip {\n    display: inline-flex;\n    align-items: center;\n    padding: 0.28rem 0.55rem;\n    border-radius: 999px;\n    border: 1px solid rgba($accent-blue, 0.35);\n    background: rgba($dark-blue, 0.55);\n    font-size: 0.72rem;\n    font-weight: 700;\n    color: rgba($very-light-grey, 0.78);\n    white-space: nowrap;\n\n    &--accent {\n      border-color: rgba($light-green, 0.4);\n      color: $light-green;\n    }\n  }\n}\n\n// Org event history — multi-chart layout\n.admin-dashboard-org-events {\n  .admin-org-events-empty {\n    margin: 0.5rem 0 0;\n    padding: 2rem 1rem;\n    text-align: center;\n    border-radius: 12px;\n    border: 1px solid rgba($accent-blue, 0.28);\n    background: rgba($dark-blue, 0.35);\n    color: rgba($very-light-grey, 0.55);\n    font-size: 0.85rem;\n  }\n\n  .admin-org-events-grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 1rem;\n    margin-top: 0.35rem;\n  }\n\n  .admin-org-events-card {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    border-radius: 12px;\n    border: 1px solid rgba($accent-blue, 0.28);\n    background:\n      linear-gradient(180deg, rgba($dark-blue, 0.72), rgba($dark-blue-grey, 0.42)),\n      rgba($dark-blue, 0.55);\n    box-shadow:\n      0 0 0 1px rgba(0, 0, 0, 0.28),\n      0 10px 22px rgba(0, 0, 0, 0.22);\n    overflow: hidden;\n\n    &--tall {\n      grid-column: 1 / -1;\n    }\n  }\n\n  .admin-org-events-card__header {\n    padding: 0.85rem 1rem 0.65rem;\n    border-bottom: 1px solid rgba($accent-blue, 0.22);\n  }\n\n  .admin-org-events-card__heading {\n    display: flex;\n    flex-direction: column;\n    gap: 0.2rem;\n    min-width: 0;\n  }\n\n  .admin-org-events-card__title {\n    margin: 0;\n    font-size: 0.82rem;\n    font-weight: 600;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.92);\n  }\n\n  .admin-org-events-card__hint {\n    margin: 0;\n    font-size: 0.62rem;\n    font-weight: 600;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.42);\n  }\n\n  .admin-org-events-card__body {\n    flex: 1;\n    min-height: 260px;\n    padding: 0.75rem 0.85rem 0.95rem;\n  }\n\n  .admin-org-events-card--tall .admin-org-events-card__body {\n    min-height: 300px;\n  }\n\n  @media (max-width: $tablet) {\n    .admin-org-events-grid {\n      grid-template-columns: 1fr;\n    }\n\n    .admin-org-events-card--tall {\n      grid-column: auto;\n    }\n  }\n}\n\n// Recruitment tab extras\n.admin-dashboard-recruitment {\n  .admin-recruitment-table-wrap {\n    col.col-kind { width: 8.5rem; }\n    col.col-handle { width: auto; }\n    col.col-guestConversion { width: 12.5rem; }\n    col.col-joinedAt { width: 8.5rem; }\n    col.col-eventParticipationCount { width: 5.5rem; }\n    col.col-onboarding { width: 7rem; }\n  }\n\n  .header-eventParticipationCount,\n  .cell-eventParticipationCount,\n  .header-onboarding,\n  .cell-onboarding,\n  .header-guestConversion,\n  .cell-guestConversion {\n    text-align: center;\n  }\n\n  .admin-recruitment-kind {\n    display: inline-flex;\n    align-items: center;\n    padding: 0.2rem 0.5rem;\n    border-radius: 999px;\n    font-size: 0.68rem;\n    font-weight: 700;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n    white-space: nowrap;\n\n    &--newcomer {\n      border: 1px solid rgba($light-green, 0.4);\n      background: rgba($light-green, 0.12);\n      color: $light-green;\n    }\n\n    &--potential {\n      border: 1px solid rgba($accent-blue, 0.4);\n      background: rgba($accent-blue, 0.12);\n      color: rgba($very-light-grey, 0.85);\n    }\n  }\n\n  .admin-recruitment-guest-conversion-empty {\n    color: rgba($very-light-grey, 0.4);\n  }\n\n  .admin-recruitment-guest-conversion {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.35rem;\n    max-width: 100%;\n    padding: 0.22rem 0.55rem;\n    border-radius: 999px;\n    border: 1px solid rgba($orange, 0.45);\n    background: linear-gradient(\n      90deg,\n      rgba($accent-blue, 0.18) 0%,\n      rgba($orange, 0.16) 55%,\n      rgba($light-green, 0.14) 100%\n    );\n    white-space: nowrap;\n  }\n\n  .admin-recruitment-guest-conversion__from,\n  .admin-recruitment-guest-conversion__to {\n    font-size: 0.68rem;\n    font-weight: 700;\n    letter-spacing: 0.02em;\n    text-transform: uppercase;\n  }\n\n  .admin-recruitment-guest-conversion__from {\n    color: rgba($very-light-grey, 0.78);\n  }\n\n  .admin-recruitment-guest-conversion__to {\n    color: $light-green;\n  }\n\n  .admin-recruitment-guest-conversion__arrow {\n    position: relative;\n    flex: 0 0 1.1rem;\n    width: 1.1rem;\n    height: 2px;\n    border-radius: 1px;\n    background: linear-gradient(\n      90deg,\n      rgba($accent-blue, 0.55),\n      rgba($light-green, 0.9)\n    );\n\n    &::after {\n      content: '';\n      position: absolute;\n      top: 50%;\n      right: -1px;\n      width: 0;\n      height: 0;\n      border-style: solid;\n      border-width: 3.5px 0 3.5px 5px;\n      border-color: transparent transparent transparent rgba($light-green, 0.95);\n      transform: translateY(-50%);\n    }\n  }\n\n  .admin-recruitment-onboarding {\n    color: rgba($very-light-grey, 0.4);\n  }\n}\n","// src/styles/adminAccounting.scss\n\n@import './variables.scss';\n\n.accounting-page {\n  .accounting-tab-content {\n    margin-top: 0.75rem;\n  }\n}\n\n.accounting-tab-placeholder-wrap {\n  padding: 2rem 1.25rem;\n  border-radius: 14px;\n  border: 1px dashed rgba($accent-blue, 0.35);\n  background: rgba($dark-blue, 0.35);\n  text-align: center;\n}\n\n.accounting-tab-placeholder__title {\n  margin: 0 0 0.5rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: $very-light-grey;\n}\n\n.accounting-tab-placeholder__hint {\n  margin: 0;\n  font-size: 0.9rem;\n  color: rgba($very-light-grey, 0.62);\n}\n\n.accounting-hero {\n  display: grid;\n  grid-template-columns: minmax(220px, 1fr) minmax(280px, 1.4fr);\n  gap: 1rem;\n  margin-bottom: 1rem;\n  padding: 1.1rem 1.25rem;\n  border-radius: 14px;\n  border: 1px solid rgba($accent-blue, 0.45);\n  background:\n    linear-gradient(135deg, rgba($dark-blue, 0.88), rgba($dark-blue-grey, 0.55)),\n    rgba($dark-blue, 0.65);\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.28);\n}\n\n.accounting-hero__eyebrow {\n  margin: 0 0 0.35rem;\n  font-size: 0.72rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.62);\n}\n\n.accounting-hero__balance {\n  margin: 0;\n  font-family: 'FiraCode', monospace;\n  font-size: unquote('clamp(1.6rem, 3vw, 2.35rem)');\n  font-weight: 700;\n  color: $very-light-green;\n\n  &.is-negative {\n    color: $bright-red;\n  }\n}\n\n.accounting-hero__warning {\n  margin: 0.35rem 0 0;\n  font-size: 0.78rem;\n  color: $light-green;\n}\n\n.accounting-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(120px, 1fr));\n  gap: 0.65rem;\n}\n\n.accounting-stat-card {\n  padding: 0.75rem 0.85rem;\n  border-radius: 10px;\n  border: 1px solid rgba($accent-blue, 0.28);\n  background: rgba($dark-blue, 0.45);\n}\n\n.accounting-stat-card__label {\n  display: block;\n  margin-bottom: 0.25rem;\n  font-size: 0.68rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.58);\n}\n\n.accounting-stat-card__value {\n  font-family: 'FiraCode', monospace;\n  font-size: 0.95rem;\n  color: $very-light-grey;\n\n  &.is-in { color: $light-green; }\n  &.is-out { color: $bright-red; }\n}\n\n.accounting-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.85rem 1rem;\n  margin-bottom: 0.85rem;\n  padding: 0.85rem 1rem;\n  border-radius: 12px;\n  border: 1px solid rgba($accent-blue, 0.35);\n  background: rgba($dark-blue, 0.52);\n}\n\n.accounting-toolbar__dates {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem 1rem;\n}\n\n.accounting-toolbar__date-field {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n\n  span {\n    font-size: 0.72rem;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.62);\n    white-space: nowrap;\n  }\n\n  .react-datepicker-wrapper {\n    width: auto;\n  }\n}\n\n.accounting-date-input {\n  min-width: 8.5rem;\n  padding: 0.4rem 0.65rem;\n  border: 1px solid rgba($accent-blue, 0.45);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 0.82rem;\n  color: $very-light-grey;\n  background: rgba($dark-blue, 0.65);\n}\n\n.accounting-toolbar__filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n\n  select {\n    min-width: 9rem;\n    padding: 0.4rem 0.65rem;\n    border: 1px solid rgba($accent-blue, 0.45);\n    border-radius: 8px;\n    font-size: 0.82rem;\n    color: $very-light-grey;\n    background: rgba($dark-blue, 0.65);\n  }\n}\n\n.accounting-toolbar__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-left: auto;\n}\n\n.accounting-help-frame {\n  position: relative;\n\n  &--has-help {\n    //padding-top: 0;\n    padding-right: 0;\n  }\n\n  &--modal.accounting-help-frame--has-help {\n    position: relative;\n    display: block;\n  }\n}\n\n.accounting-toolbar--with-help,\n.accounting-modal__header--with-help {\n  position: relative;\n}\n\n.accounting-toolbar--with-help {\n  padding-right: 2.25rem;\n}\n\n.accounting-help-trigger {\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n  z-index: 4;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1rem;\n  height: 1rem;\n  padding: 0;\n  border: 1px solid rgba($light-blue, 0.45);\n  border-radius: 50%;\n  background:\n    radial-gradient(circle at 30% 25%, rgba($light-blue, 0.35), rgba($accent-blue, 0.18)),\n    rgba($dark-blue, 0.88);\n  color: $light-blue;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.24);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n  &:hover,\n  &.is-open {\n    border-color: rgba($light-blue, 0.75);\n    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.32);\n  }\n\n  &:focus-visible {\n    outline: 2px solid rgba($light-blue, 0.65);\n    outline-offset: 2px;\n  }\n}\n\n.accounting-help-trigger__icon {\n  font-family: Georgia, 'Times New Roman', serif;\n  font-size: 0.62rem;\n  font-weight: 700;\n  font-style: italic;\n  line-height: 1;\n}\n\n.accounting-help-trigger--inline {\n  position: static;\n  width: 0.875rem;\n  height: 0.875rem;\n  flex-shrink: 0;\n}\n\n.help-info-bubble--inline {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  vertical-align: middle;\n  flex-shrink: 0;\n  z-index: 5;\n}\n\n.help-info-bubble__popover {\n  top: calc(100% + 0.35rem);\n  right: auto;\n  left: 0;\n  width: unquote('min(20rem, calc(100vw - 2.5rem))');\n  z-index: 8;\n}\n\n.help-info-bubble--align-end .help-info-bubble__popover {\n  left: auto;\n  right: 0;\n}\n\n.accounting-toolbar--with-help .accounting-help-popover {\n  top: 1.75rem;\n  right: 0.5rem;\n}\n\n.accounting-modal__header--with-help .accounting-help-trigger {\n  top: 0;\n  right: 2.35rem;\n}\n\n.accounting-modal__header--with-help .accounting-help-popover {\n  top: 1.85rem;\n  right: 0;\n}\n\n.accounting-help-popover {\n  position: absolute;\n  top: 1.75rem;\n  right: 0.5rem;\n  z-index: 6;\n  width: unquote('min(22.5rem, calc(100vw - 2.5rem))');\n  padding: 0.85rem 0.95rem 0.95rem;\n  border-radius: 12px;\n  border: 1px solid rgba($light-blue, 0.35);\n  background:\n    linear-gradient(160deg, rgba($dark-blue, 0.97), rgba($dark-blue-grey, 0.92)),\n    rgba($dark-blue, 0.95);\n  box-shadow:\n    0 16px 40px rgba(0, 0, 0, 0.42),\n    0 0 0 1px rgba($accent-blue, 0.12) inset;\n  overflow: hidden;\n\n  &--portal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: auto;\n    z-index: 10100;\n  }\n}\n\n.accounting-help-popover__accent {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, rgba($accent-blue, 0.2), rgba($light-blue, 0.85), rgba($accent-blue, 0.2));\n}\n\n.accounting-help-popover__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.65rem;\n  margin-bottom: 0.55rem;\n}\n\n.accounting-help-popover__title {\n  margin: 0;\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: $very-light-grey;\n  line-height: 1.35;\n}\n\n.accounting-help-popover__close {\n  flex-shrink: 0;\n  width: 1.35rem;\n  height: 1.35rem;\n  padding: 0;\n  border: none;\n  border-radius: 6px;\n  background: rgba($very-light-grey, 0.08);\n  color: rgba($very-light-grey, 0.72);\n  font-size: 1rem;\n  line-height: 1;\n  cursor: pointer;\n\n  &:hover {\n    background: rgba($light-blue, 0.16);\n    color: $very-light-grey;\n  }\n}\n\n.accounting-help-popover__summary {\n  margin: 0 0 0.65rem;\n  font-size: 0.8rem;\n  line-height: 1.5;\n  color: rgba($very-light-grey, 0.82);\n}\n\n.accounting-help-popover__steps {\n  margin: 0 0 0.65rem;\n  padding-left: 1.1rem;\n  font-size: 0.78rem;\n  line-height: 1.45;\n  color: rgba($very-light-grey, 0.78);\n\n  li + li {\n    margin-top: 0.35rem;\n  }\n\n  li::marker {\n    color: $light-blue;\n  }\n}\n\n.accounting-help-popover__note {\n  margin: 0;\n  padding: 0.55rem 0.65rem;\n  border-radius: 8px;\n  border-left: 3px solid rgba($light-blue, 0.55);\n  background: rgba($accent-blue, 0.12);\n  font-size: 0.74rem;\n  line-height: 1.45;\n  color: rgba($very-light-grey, 0.72);\n}\n\n.accounting-orgbank__section,\n.accounting-members__filters-section,\n.accounting-contracts__filters-section {\n  margin-bottom: 0.85rem;\n}\n\n.accounting-orgbank-layout {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.accounting-orgbank-layout__table {\n  min-width: 0;\n}\n\n.accounting-orgbank-scroll {\n  display: block;\n  max-height: 400px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  @include accounting-inventory-scrollbar;\n}\n\n.accounting-table-wrap--orgbank-ledger {\n  padding: 0;\n  overflow: hidden;\n\n  .accounting-table--orgbank-ledger-head {\n    margin-bottom: 0;\n  }\n\n  .accounting-table--orgbank-ledger-body thead {\n    display: none;\n  }\n}\n\n.accounting-table--orgbank-ledger-head,\n.accounting-table--orgbank-ledger-body {\n  table-layout: fixed;\n  width: 100%;\n}\n\n.accounting-toolbar__filters--orgbank {\n  flex: 1;\n  min-width: 0;\n}\n\n.accounting-scope-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.accounting-scope-chip {\n  padding: 0.35rem 0.75rem;\n  border-radius: 999px;\n  border: 1px solid rgba($accent-blue, 0.35);\n  background: rgba($dark-blue-grey, 0.45);\n  color: rgba($very-light-grey, 0.82);\n  font-size: 0.78rem;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n\n  &.is-active {\n    border-color: rgba($accent-blue, 0.85);\n    background: rgba($accent-blue, 0.22);\n    color: $pure-white;\n  }\n}\n\n.accounting-active-filter {\n  margin: 0 0 0.65rem;\n  font-size: 0.8rem;\n  color: rgba($very-light-grey, 0.72);\n\n  strong {\n    color: $very-light-grey;\n  }\n}\n\n.accounting-audit-intro {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  margin-bottom: 0.75rem;\n\n  p {\n    margin: 0;\n    font-size: 0.85rem;\n    color: rgba($very-light-grey, 0.72);\n  }\n}\n\n.accounting-audit-intro__count {\n  font-size: 0.75rem;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.55);\n}\n\n.accounting-audit-kpi {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.65rem;\n  margin-bottom: 0.85rem;\n\n  &--members {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n}\n\n.accounting-audit-filters {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  margin-bottom: 0.75rem;\n}\n\n.accounting-audit-filters__selects {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.accounting-audit-filters__row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.65rem;\n  align-items: flex-end;\n}\n\n.accounting-field--compact {\n  min-width: 9rem;\n}\n\n.accounting-field--grow {\n  flex: 1 1 14rem;\n}\n\n.accounting-text-input,\n.accounting-select {\n  width: 100%;\n  padding: 0.45rem 0.65rem;\n  border: 1px solid rgba($accent-blue, 0.45);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 0.84rem;\n  color: $very-light-grey;\n  background: rgba($dark-blue, 0.65);\n}\n\n.accounting-audit-load-more {\n  display: flex;\n  justify-content: center;\n  padding: 0.75rem 0 0.25rem;\n}\n\n.accounting-org-inventory {\n  .accounting-hero--inventory {\n    .accounting-hero__balance {\n      color: $light-blue;\n    }\n\n    .accounting-hero__warning {\n      color: rgba($very-light-grey, 0.62);\n    }\n  }\n}\n\n.accounting-org-inventory__section {\n  margin-bottom: 1.25rem;\n\n  &--movements {\n    margin-bottom: 0;\n  }\n}\n\n.accounting-org-inventory__section-title {\n  margin: 0 0 0.75rem;\n  font-size: 0.82rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.62);\n}\n\n.accounting-toolbar--compact {\n  margin-top: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.accounting-toolbar__checkbox {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.78rem;\n  color: rgba($very-light-grey, 0.78);\n  white-space: nowrap;\n\n  input {\n    accent-color: $accent-blue;\n  }\n}\n\n.accounting-org-inventory__filter-tag {\n  font-size: 0.78rem;\n  color: rgba($very-light-grey, 0.72);\n  padding: 0.35rem 0.65rem;\n  border-radius: 999px;\n  border: 1px solid rgba($accent-blue, 0.35);\n  background: rgba($accent-blue, 0.12);\n}\n\n.accounting-table__mono {\n  font-family: 'FiraCode', monospace;\n  font-size: 0.78rem;\n}\n\n.accounting-org-inventory-scroll {\n  display: block;\n  max-height: 400px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  @include accounting-inventory-scrollbar;\n}\n\n.accounting-table-wrap--inventory-stock,\n.accounting-table-wrap--inventory-movements {\n  padding: 0;\n  overflow: hidden;\n}\n\n.accounting-table-wrap--inventory-stock {\n  .accounting-table--inventory-stock-body thead {\n    display: none;\n  }\n}\n\n.accounting-table-wrap--inventory-movements {\n  .accounting-table--inventory-movements-head {\n    margin-bottom: 0;\n  }\n\n  .accounting-table--inventory-movements-body thead {\n    display: none;\n  }\n}\n\n.accounting-table--inventory-stock-body,\n.accounting-table--inventory-movements-head,\n.accounting-table--inventory-movements-body {\n  table-layout: fixed;\n  width: 100%;\n}\n\n.accounting-table-wrap--inventory-stock {\n  .accounting-table th:nth-child(1),\n  .accounting-table td:nth-child(1) { width: 34%; }\n  .accounting-table th:nth-child(2),\n  .accounting-table td:nth-child(2) { width: 22%; }\n  .accounting-table th:nth-child(3),\n  .accounting-table td:nth-child(3) { width: 16%; }\n  .accounting-table th:nth-child(4),\n  .accounting-table td:nth-child(4) { width: 10%; }\n  .accounting-table th:nth-child(5),\n  .accounting-table td:nth-child(5) { width: 18%; }\n}\n\n.accounting-table-wrap--inventory-movements {\n  .accounting-table th:nth-child(1),\n  .accounting-table td:nth-child(1) { width: 105px; }\n  .accounting-table th:nth-child(2),\n  .accounting-table td:nth-child(2) { width: 70px; }\n  .accounting-table th:nth-child(3),\n  .accounting-table td:nth-child(3) { width: 70px; }\n  .accounting-table th:nth-child(4),\n  .accounting-table td:nth-child(4) { width: 100px; }\n  .accounting-table th:nth-child(5),\n  .accounting-table td:nth-child(5) { width: 140px; }\n  .accounting-table th:nth-child(6),\n  .accounting-table td:nth-child(6) { width: 120px; }\n  .accounting-table th:nth-child(7),\n  .accounting-table td:nth-child(7) { width: auto; }\n}\n\n.accounting-org-inventory-layout {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.accounting-org-inventory-layout__table {\n  min-width: 0;\n}\n\n.accounting-org-inventory-item {\n  border-radius: 12px;\n  border: 1px solid rgba($accent-blue, 0.45);\n  background:\n    linear-gradient(180deg, rgba($dark-blue, 0.82), rgba($dark-blue-grey, 0.55)),\n    rgba($dark-blue, 0.65);\n  padding: 1rem 1.1rem;\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.22);\n\n  &--empty {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 5rem;\n  }\n}\n\n.accounting-org-inventory-item__placeholder {\n  margin: 0;\n  text-align: center;\n  font-size: 0.85rem;\n  color: rgba($very-light-grey, 0.55);\n}\n\n.accounting-org-inventory-item__hero {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 1rem 1.5rem;\n  align-items: start;\n}\n\n.accounting-org-inventory-item__badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n  margin-bottom: 0.45rem;\n}\n\n.accounting-org-inventory-item__title {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: $very-light-grey;\n  line-height: 1.35;\n}\n\n.accounting-org-inventory-item__code {\n  margin: 0.25rem 0 0;\n  font-family: 'FiraCode', monospace;\n  font-size: 0.78rem;\n  color: rgba($very-light-grey, 0.62);\n}\n\n.accounting-org-inventory-item__side {\n  text-align: right;\n  white-space: nowrap;\n}\n\n.accounting-org-inventory-item__qty {\n  margin: 0;\n  font-family: 'FiraCode', monospace;\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: $light-blue;\n}\n\n.accounting-org-inventory-item__qty-label {\n  margin: 0.1rem 0 0;\n  font-size: 0.72rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.55);\n}\n\n.accounting-org-inventory-item__updated {\n  margin: 0.35rem 0 0;\n  font-size: 0.76rem;\n  color: rgba($very-light-grey, 0.58);\n}\n\n.accounting-org-inventory-item__actions {\n  margin-top: 0.75rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid rgba($accent-blue, 0.28);\n}\n\n.accounting-members {\n  .accounting-hero--members {\n    .accounting-hero__balance {\n      color: $very-light-green;\n    }\n\n    .accounting-hero__warning {\n      color: rgba($very-light-grey, 0.62);\n    }\n  }\n}\n\n.accounting-members-panel {\n  margin-bottom: 1rem;\n  border-radius: 12px;\n  border: 1px solid rgba($accent-blue, 0.45);\n  background:\n    linear-gradient(180deg, rgba($dark-blue, 0.82), rgba($dark-blue-grey, 0.55)),\n    rgba($dark-blue, 0.65);\n  padding: 1rem 1.1rem;\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.22);\n\n  &--empty {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 5rem;\n  }\n}\n\n.accounting-members-panel__placeholder {\n  margin: 0;\n  text-align: center;\n  font-size: 0.85rem;\n  color: rgba($very-light-grey, 0.55);\n\n  &--warn {\n    color: rgba($light-orange, 0.88);\n  }\n}\n\n.accounting-members-panel__hero {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 1rem 1.5rem;\n  align-items: start;\n}\n\n.accounting-members-panel__badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n  margin-bottom: 0.45rem;\n}\n\n.accounting-members-panel__title {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: $very-light-grey;\n  line-height: 1.35;\n}\n\n.accounting-members-panel__sub {\n  margin: 0.2rem 0 0;\n  font-size: 0.78rem;\n  color: rgba($very-light-grey, 0.62);\n}\n\n.accounting-members-panel__stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem 1.25rem;\n  justify-content: flex-end;\n}\n\n.accounting-members-panel__stat {\n  text-align: right;\n  min-width: 5.5rem;\n}\n\n.accounting-members-panel__stat-value {\n  margin: 0;\n  font-family: 'FiraCode', monospace;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: $very-light-grey;\n\n  &.is-in {\n    color: $light-green;\n  }\n\n  &.is-out {\n    color: $bright-red;\n  }\n}\n\n.accounting-members-panel__stat-label {\n  margin: 0.12rem 0 0;\n  font-size: 0.68rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.55);\n}\n\n.accounting-members-panel__actions {\n  margin-top: 0.75rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid rgba($accent-blue, 0.28);\n}\n\n.accounting-toolbar__filters--members {\n  align-items: flex-end;\n}\n\n.accounting-member-combobox {\n  position: relative;\n  flex: 1 1 16rem;\n  min-width: 14rem;\n}\n\n.accounting-member-combobox__label {\n  display: block;\n  margin-bottom: 0.3rem;\n  font-size: 0.72rem;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.62);\n}\n\n.accounting-member-combobox__control {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.accounting-member-combobox__input {\n  width: 100%;\n  padding-right: 2rem;\n}\n\n.accounting-member-combobox__clear {\n  position: absolute;\n  right: 0.35rem;\n  width: 1.5rem;\n  height: 1.5rem;\n  border: none;\n  border-radius: 999px;\n  background: transparent;\n  color: rgba($very-light-grey, 0.62);\n  font-size: 1.1rem;\n  line-height: 1;\n  cursor: pointer;\n\n  &:hover {\n    color: $very-light-grey;\n    background: rgba($accent-blue, 0.15);\n  }\n}\n\n.accounting-member-combobox__list {\n  position: absolute;\n  z-index: 20;\n  top: calc(100% + 0.25rem);\n  left: 0;\n  right: 0;\n  max-height: 240px;\n  overflow-y: auto;\n  margin: 0;\n  padding: 0.35rem 0;\n  list-style: none;\n  border-radius: 10px;\n  border: 1px solid rgba($accent-blue, 0.45);\n  background: rgba($dark-blue, 0.96);\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.35);\n  @include accounting-inventory-scrollbar;\n}\n\n.accounting-member-combobox__option {\n  display: block;\n  width: 100%;\n  padding: 0.5rem 0.85rem;\n  border: none;\n  background: transparent;\n  color: $very-light-grey;\n  font-size: 0.82rem;\n  text-align: left;\n  cursor: pointer;\n\n  &:hover,\n  &[aria-selected=\"true\"] {\n    background: rgba($accent-blue, 0.18);\n  }\n}\n\n.accounting-member-combobox__option-label {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.accounting-member-combobox__empty {\n  padding: 0.55rem 0.85rem;\n  font-size: 0.8rem;\n  color: rgba($very-light-grey, 0.55);\n\n  &--warn {\n    color: rgba($light-orange, 0.88);\n  }\n}\n\n.accounting-members-layout {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.accounting-members-layout__table {\n  min-width: 0;\n}\n\n.accounting-members-scroll {\n  display: block;\n  max-height: 400px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  @include accounting-inventory-scrollbar;\n}\n\n.accounting-members-blueprints {\n  margin-bottom: 1rem;\n}\n\n.accounting-members-blueprints__title {\n  margin: 0;\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: $very-light-grey;\n}\n\n.accounting-members-blueprints__count {\n  font-size: 0.75rem;\n  color: rgba($very-light-grey, 0.62);\n  white-space: nowrap;\n}\n\n.accounting-members-blueprints-scroll {\n  display: block;\n  max-height: 280px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  @include accounting-inventory-scrollbar;\n}\n\n.accounting-table-wrap--members-blueprints {\n  padding: 0;\n  overflow: hidden;\n\n  .accounting-table--members-blueprints {\n    margin-bottom: 0;\n  }\n\n  .accounting-table--members-blueprints-body thead {\n    display: none;\n  }\n\n  .accounting-table th:nth-child(1),\n  .accounting-table td:nth-child(1) { width: 28%; }\n  .accounting-table th:nth-child(2),\n  .accounting-table td:nth-child(2) { width: 16%; }\n  .accounting-table th:nth-child(3),\n  .accounting-table td:nth-child(3) { width: 14%; }\n  .accounting-table th:nth-child(4),\n  .accounting-table td:nth-child(4) { width: 28%; }\n  .accounting-table th:nth-child(5),\n  .accounting-table td:nth-child(5) { width: 14%; }\n}\n\n.accounting-table--members-blueprints,\n.accounting-table--members-blueprints-body {\n  table-layout: fixed;\n  width: 100%;\n}\n\n.accounting-table-wrap--members-ledger {\n  padding: 0;\n  overflow: hidden;\n\n  .accounting-table--members-ledger-head {\n    margin-bottom: 0;\n  }\n\n  .accounting-table--members-ledger-body thead {\n    display: none;\n  }\n}\n\n.accounting-table--members-ledger-head,\n.accounting-table--members-ledger-body {\n  table-layout: fixed;\n  width: 100%;\n}\n\n.accounting-contracts {\n  .accounting-audit-kpi--contracts {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n}\n\n.accounting-contracts-panel {\n  margin-bottom: 1rem;\n  border-radius: 12px;\n  border: 1px solid rgba($accent-blue, 0.45);\n  background:\n    linear-gradient(180deg, rgba($dark-blue, 0.82), rgba($dark-blue-grey, 0.55)),\n    rgba($dark-blue, 0.65);\n  padding: 1rem 1.1rem;\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.22);\n\n  &--empty {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 5rem;\n  }\n}\n\n.accounting-contracts-panel__placeholder {\n  margin: 0;\n  text-align: center;\n  font-size: 0.85rem;\n  color: rgba($very-light-grey, 0.55);\n}\n\n.accounting-contracts-panel__empty {\n  margin: 0;\n  font-size: 0.82rem;\n  color: rgba($very-light-grey, 0.55);\n}\n\n.accounting-contracts-panel__hero {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 1rem 1.5rem;\n  align-items: start;\n}\n\n.accounting-contracts-panel__badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n  margin-bottom: 0.45rem;\n}\n\n.accounting-contracts-panel__title {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: $very-light-grey;\n  line-height: 1.35;\n}\n\n.accounting-contracts-panel__sub {\n  margin: 0.2rem 0 0;\n  font-size: 0.78rem;\n  color: rgba($very-light-grey, 0.62);\n}\n\n.accounting-contracts-panel__stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem 1.25rem;\n  justify-content: flex-end;\n}\n\n.accounting-contracts-panel__stat {\n  text-align: right;\n  min-width: 5.5rem;\n}\n\n.accounting-contracts-panel__stat-value {\n  margin: 0;\n  font-family: 'FiraCode', monospace;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: $very-light-grey;\n\n  &.is-in {\n    color: $very-light-green;\n  }\n\n  &.is-out {\n    color: $light-orange;\n  }\n}\n\n.accounting-contracts-panel__stat-label {\n  margin: 0.15rem 0 0;\n  font-size: 0.72rem;\n  color: rgba($very-light-grey, 0.58);\n}\n\n.accounting-contracts-panel__grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.45rem 1.25rem;\n  margin-top: 0.85rem;\n  padding-top: 0.85rem;\n  border-top: 1px solid rgba($accent-blue, 0.28);\n}\n\n.accounting-contracts-panel__row {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.accounting-contracts-panel__row-label {\n  font-size: 0.72rem;\n  color: rgba($very-light-grey, 0.58);\n}\n\n.accounting-contracts-panel__row-value {\n  font-size: 0.82rem;\n  color: $very-light-grey;\n}\n\n.accounting-contracts-panel__comment {\n  margin: 0.75rem 0 0;\n  font-size: 0.8rem;\n  color: rgba($very-light-grey, 0.72);\n  line-height: 1.45;\n}\n\n.accounting-contracts-panel__actions {\n  margin-top: 0.75rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid rgba($accent-blue, 0.28);\n}\n\n.accounting-btn--compact {\n  padding: 0.25rem 0.55rem;\n  font-size: 0.74rem;\n}\n\n.accounting-contracts-panel__section-title {\n  margin: 1rem 0 0.55rem;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: rgba($very-light-grey, 0.88);\n}\n\n.accounting-contracts-layout {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.accounting-contracts-layout__table {\n  min-width: 0;\n}\n\n.accounting-contracts-scroll {\n  display: block;\n  max-height: 400px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  @include accounting-inventory-scrollbar;\n}\n\n.accounting-table-wrap--contracts-list,\n.accounting-table-wrap--contracts-ledger {\n  padding: 0;\n  overflow: hidden;\n  margin-top: 1rem;\n\n  .accounting-table--contracts-list-head,\n  .accounting-table--contracts-ledger-head {\n    margin-bottom: 0;\n  }\n\n  .accounting-table--contracts-list-body thead,\n  .accounting-table--contracts-ledger-body thead {\n    display: none;\n  }\n}\n\n.accounting-table--contracts-list-head,\n.accounting-table--contracts-list-body,\n.accounting-table--contracts-ledger-head,\n.accounting-table--contracts-ledger-body {\n  table-layout: fixed;\n  width: 100%;\n}\n\n.accounting-table-wrap--contracts-installments {\n  margin-top: 0.35rem;\n}\n\n.accounting-pill--status-late,\n.accounting-pill--status-defaulted {\n  background: rgba($light-orange, 0.18);\n  color: $light-orange;\n}\n\n.accounting-pill--status-active,\n.accounting-pill--status-paid {\n  background: rgba($very-light-green, 0.14);\n  color: $very-light-green;\n}\n\n.accounting-pill--status-draft,\n.accounting-pill--status-scheduled {\n  background: rgba($accent-blue, 0.16);\n  color: $light-blue;\n}\n\n.accounting-pill--status-cancelled,\n.accounting-pill--status-closed,\n.accounting-pill--status-completed {\n  background: rgba($very-light-grey, 0.12);\n  color: rgba($very-light-grey, 0.72);\n}\n\n.accounting-pill--status-partially_paid {\n  background: rgba($very-light-orange, 0.16);\n  color: $very-light-orange;\n}\n\n.accounting-table-wrap--members-ledger {\n  .accounting-table th:nth-child(1),\n  .accounting-table td:nth-child(1) { width: 105px; }\n  .accounting-table th:nth-child(2),\n  .accounting-table td:nth-child(2) { width: 100px; }\n  .accounting-table th:nth-child(3),\n  .accounting-table td:nth-child(3) { width: 70px; }\n  .accounting-table th:nth-child(4),\n  .accounting-table td:nth-child(4) { width: 140px; }\n  .accounting-table th:nth-child(5),\n  .accounting-table td:nth-child(5) { width: 140px; }\n  .accounting-table th:nth-child(6),\n  .accounting-table td:nth-child(6) { width: 120px; }\n  .accounting-table th:nth-child(7),\n  .accounting-table td:nth-child(7) { width: auto; }\n}\n\n.accounting-ledger-tag {\n  display: inline-block;\n  padding: 0.15rem 0.45rem;\n  border-radius: 6px;\n  font-size: 0.68rem;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.78);\n  border: 1px solid rgba($medium-grey, 0.55);\n  background: rgba($dark-blue-grey, 0.45);\n}\n\n.accounting-audit-detail__reversal-flag {\n  margin: 0 0 0.65rem;\n  padding: 0.4rem 0.55rem;\n  border-radius: 8px;\n  font-size: 0.78rem;\n  color: $bright-red;\n  border: 1px solid rgba($bright-red, 0.35);\n  background: rgba($red, 0.12);\n}\n\n.accounting-table--selectable tbody tr.is-reversed {\n  opacity: 0.72;\n}\n\n.accounting-kind-badge--benefits {\n  border-color: rgba($light-green, 0.4);\n  background: rgba($green, 0.15);\n}\n\n.accounting-kind-badge--donation {\n  border-color: rgba($accent-blue, 0.45);\n  background: rgba($accent-blue, 0.12);\n}\n\n.accounting-kind-badge--sale,\n.accounting-kind-badge--purchase,\n.accounting-kind-badge--commerce {\n  border-color: rgba($light-grey, 0.4);\n  background: rgba($medium-grey, 0.25);\n}\n\n.accounting-kind-badge--credit,\n.accounting-kind-badge--loan,\n.accounting-kind-badge--rental {\n  border-color: rgba($accent-blue, 0.5);\n  background: rgba($accent-blue, 0.16);\n}\n\n.accounting-kind-badge--manual {\n  border-color: rgba($light-grey, 0.35);\n}\n\n.accounting-kind-badge--inventory {\n  border-color: rgba($light-green, 0.35);\n  background: rgba($green, 0.1);\n}\n\n.accounting-kind-badge--correction {\n  border-color: rgba($bright-red, 0.45);\n  background: rgba($red, 0.14);\n}\n\n.accounting-kind-badge--other {\n  border-color: rgba($medium-grey, 0.45);\n}\n\n.accounting-audit-layout {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.accounting-audit-split {\n  display: contents;\n}\n\n.accounting-audit-split__table {\n  min-width: 0;\n\n  .accounting-table-wrap--audit {\n    padding: 0;\n    overflow: hidden;\n  }\n\n  .accounting-table--audit {\n    table-layout: fixed;\n    width: 100%;\n  }\n\n  .accounting-table--audit-head {\n    margin-bottom: 0;\n\n    tbody {\n      display: none;\n    }\n  }\n\n  .accounting-table--audit-body thead {\n    display: none;\n  }\n\n  .accounting-audit-tbody-scroll {\n    display: block;\n    max-height: 400px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    scrollbar-width: thin;\n    scrollbar-color: rgba($accent-blue, 0.5) rgba($dark-blue, 0.45);\n\n    &::-webkit-scrollbar {\n      width: 4px;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: rgba($dark-blue, 0.45);\n      border-radius: 999px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: rgba($accent-blue, 0.48);\n      border-radius: 999px;\n\n      &:hover {\n        background: rgba($accent-blue, 0.65);\n      }\n    }\n  }\n\n  .accounting-audit-col--date {\n    width: 105px;\n  }\n\n  .accounting-audit-col--origin {\n    width: 100px;\n  }\n\n  .accounting-audit-col--ledger {\n    width: 135px;\n  }\n\n  .accounting-audit-col--direction {\n    width: 70px;\n  }\n\n  .accounting-audit-col--amount {\n    width: 140px;\n  }\n\n  .accounting-audit-col--treasury {\n    width: 85px;\n  }\n\n  .accounting-audit-col--label {\n    width: auto;\n  }\n\n  .accounting-table--audit th,\n  .accounting-table--audit td {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n.accounting-table--selectable tbody tr {\n  cursor: pointer;\n\n  &.is-selected {\n    background: rgba($accent-blue, 0.18);\n    box-shadow: inset 3px 0 0 rgba($accent-blue, 0.85);\n  }\n\n  &:focus-visible {\n    outline: 2px solid rgba($accent-blue, 0.65);\n    outline-offset: -2px;\n  }\n}\n\n.accounting-table__label-cell {\n  max-width: 12rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.accounting-audit-split__table .accounting-table__label-cell {\n  max-width: none;\n}\n\n.accounting-audit-detail {\n  border-radius: 12px;\n  border: 1px solid rgba($accent-blue, 0.45);\n  background:\n    linear-gradient(180deg, rgba($dark-blue, 0.82), rgba($dark-blue-grey, 0.55)),\n    rgba($dark-blue, 0.65);\n  padding: 1rem 1.1rem;\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.22);\n\n  &--horizontal {\n    overflow: visible;\n    max-height: none;\n  }\n\n  &--empty {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 5.5rem;\n  }\n}\n\n.accounting-audit-detail__placeholder {\n  margin: 0;\n  text-align: center;\n  font-size: 0.85rem;\n  color: rgba($very-light-grey, 0.55);\n  padding: 2rem 1rem;\n}\n\n.accounting-audit-detail__header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.45rem;\n}\n\n.accounting-audit-detail__hero {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 1rem 1.5rem;\n  align-items: start;\n  margin-bottom: 0.85rem;\n  padding-bottom: 0.85rem;\n  border-bottom: 1px solid rgba($accent-blue, 0.28);\n}\n\n.accounting-audit-detail__hero-main {\n  min-width: 0;\n}\n\n.accounting-audit-detail__hero-side {\n  text-align: right;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.accounting-audit-detail__reversal-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.15rem 0.5rem;\n  border-radius: 999px;\n  font-size: 0.68rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: $bright-red;\n  border: 1px solid rgba($bright-red, 0.35);\n  background: rgba($red, 0.12);\n}\n\n.accounting-audit-detail__cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 0.65rem;\n}\n\n.accounting-audit-detail-card {\n  padding: 0.65rem 0.75rem;\n  border-radius: 8px;\n  border: 1px solid rgba($accent-blue, 0.25);\n  background: rgba($dark-blue, 0.42);\n  min-width: 0;\n}\n\n.accounting-audit-detail-card__title {\n  margin: 0 0 0.45rem;\n  font-size: 0.68rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.55);\n}\n\n.accounting-audit-detail-card__body {\n  .accounting-detail-row {\n    grid-template-columns: minmax(72px, 42%) 1fr;\n    gap: 0.35rem 0.5rem;\n    padding: 0.25rem 0;\n    font-size: 0.76rem;\n  }\n\n  .accounting-audit-detail__note {\n    margin: 0;\n    font-size: 0.78rem;\n    line-height: 1.45;\n    color: rgba($very-light-grey, 0.78);\n  }\n}\n\n.accounting-audit-detail__title {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: $very-light-grey;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  line-height: 1.35;\n}\n\n.accounting-audit-detail__amount {\n  margin: 0;\n  font-family: 'FiraCode', monospace;\n  font-size: 1.2rem;\n  font-weight: 700;\n\n  &.is-in { color: $light-green; }\n  &.is-out { color: $bright-red; }\n}\n\n.accounting-audit-detail__date {\n  margin: 0.15rem 0 0;\n  font-size: 0.78rem;\n  color: rgba($very-light-grey, 0.62);\n}\n\n.accounting-audit-detail__summary {\n  margin: 0.45rem 0 0;\n  padding: 0;\n  border: none;\n  background: transparent;\n  font-size: 0.82rem;\n  line-height: 1.5;\n  color: rgba($very-light-grey, 0.82);\n}\n\n.accounting-audit-detail__note {\n  margin: 0;\n  font-size: 0.82rem;\n  line-height: 1.45;\n  color: rgba($very-light-grey, 0.78);\n}\n\n.accounting-audit-detail__section {\n  margin-bottom: 1rem;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.accounting-audit-detail__section-title {\n  margin: 0 0 0.5rem;\n  font-size: 0.68rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.55);\n}\n\n.accounting-detail-row {\n  display: grid;\n  grid-template-columns: minmax(100px, 38%) 1fr;\n  gap: 0.5rem 0.75rem;\n  padding: 0.35rem 0;\n  border-bottom: 1px solid rgba($medium-grey, 0.35);\n  font-size: 0.8rem;\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.accounting-detail-row__label {\n  color: rgba($very-light-grey, 0.58);\n}\n\n.accounting-detail-row__value {\n  color: $very-light-grey;\n  word-break: break-word;\n\n  &.is-mono {\n    font-family: 'FiraCode', monospace;\n    font-size: 0.76rem;\n  }\n}\n\n.accounting-audit-detail__metadata {\n  margin: 0;\n  padding: 0.65rem 0.75rem;\n  border-radius: 8px;\n  border: 1px solid rgba($accent-blue, 0.28);\n  background: rgba($dark-blue, 0.55);\n  font-family: 'FiraCode', monospace;\n  font-size: 0.72rem;\n  line-height: 1.45;\n  color: rgba($very-light-grey, 0.88);\n  overflow-x: auto;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.accounting-kind-badge--event {\n  border-color: rgba($light-green, 0.4);\n  background: rgba($green, 0.15);\n}\n\n.accounting-kind-badge--org_treasury {\n  border-color: rgba($accent-blue, 0.55);\n  background: rgba($accent-blue, 0.2);\n}\n\n.accounting-kind-badge--member {\n  border-color: rgba($light-grey, 0.35);\n}\n\n.accounting-table-wrap {\n  overflow: auto;\n  border-radius: 12px;\n  border: 1px solid rgba($accent-blue, 0.28);\n  background: rgba($dark-blue, 0.38);\n}\n\n.accounting-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.82rem;\n\n  th,\n  td {\n    padding: 0.65rem 0.75rem;\n    text-align: left;\n    border-bottom: 1px solid rgba($medium-grey, 0.65);\n    vertical-align: top;\n  }\n\n  th {\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    font-size: 0.68rem;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.62);\n    background: rgba($dark-blue-grey, 0.95);\n  }\n\n  tbody tr:hover {\n    background: rgba($accent-blue, 0.08);\n  }\n\n  .is-in { color: $light-green; }\n  .is-out { color: $bright-red; }\n}\n\n.accounting-table__empty {\n  text-align: center;\n  padding: 2rem 1rem;\n  color: rgba($very-light-grey, 0.55);\n}\n\n.accounting-table__event {\n  display: inline-block;\n  max-width: 14rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.accounting-table__comment {\n  max-width: 16rem;\n  color: rgba($very-light-grey, 0.78);\n}\n\n.accounting-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.15rem 0.55rem;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n\n  &--in {\n    color: $very-light-green;\n    background: rgba($green, 0.22);\n    border: 1px solid rgba($light-green, 0.35);\n  }\n\n  &--out {\n    color: $bright-red;\n    background: rgba($red, 0.22);\n    border: 1px solid rgba($bright-red, 0.35);\n  }\n\n  &--treasury {\n    color: $light-green;\n    background: rgba($green, 0.18);\n  }\n\n  &--muted {\n    color: rgba($very-light-grey, 0.65);\n    background: rgba($medium-grey, 0.35);\n  }\n}\n\n.accounting-kind-badge {\n  display: inline-block;\n  padding: 0.2rem 0.5rem;\n  border-radius: 6px;\n  font-size: 0.72rem;\n  background: rgba($accent-blue, 0.18);\n  border: 1px solid rgba($accent-blue, 0.35);\n  color: $very-light-grey;\n}\n\n.accounting-btn {\n  padding: 0.45rem 0.9rem;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  font-size: 0.82rem;\n  cursor: pointer;\n\n  &--primary {\n    color: $pure-white;\n    background: linear-gradient(180deg, rgba($accent-blue, 0.95), rgba($dark-blue, 0.95));\n    border-color: rgba($accent-blue, 0.75);\n  }\n\n  &--ghost {\n    color: $very-light-grey;\n    background: rgba($dark-blue-grey, 0.45);\n    border-color: rgba($accent-blue, 0.35);\n  }\n\n  &:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n  }\n}\n\n.accounting-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background: rgba(0, 0, 0, 0.55);\n}\n\n.accounting-modal {\n  width: unquote('min(560px, 100%)');\n  max-height: 90vh;\n  overflow: auto;\n  padding: 1rem 1.1rem 1.1rem;\n  border-radius: 14px;\n  border: 1px solid rgba($accent-blue, 0.45);\n}\n\n.accounting-modal__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.85rem;\n}\n\n.accounting-modal__title {\n  margin: 0;\n  font-size: 1rem;\n  color: $very-light-grey;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.accounting-modal__close {\n  width: 2rem;\n  height: 2rem;\n  border: none;\n  border-radius: 8px;\n  background: rgba($medium-grey, 0.45);\n  color: $very-light-grey;\n  font-size: 1.25rem;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.accounting-form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.75rem;\n}\n\n.accounting-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n\n  span {\n    font-size: 0.72rem;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.62);\n  }\n\n  input,\n  select,\n  textarea {\n    width: -webkit-fill-available;\n    padding: 0.45rem 0.65rem;\n    border: 1px solid rgba($accent-blue, 0.45);\n    border-radius: 8px;\n    font-family: inherit;\n    font-size: 0.84rem;\n    color: $very-light-grey;\n    background: rgba($dark-blue, 0.65);\n  }\n\n  &--wide {\n    grid-column: 1 / -1;\n  }\n}\n\n.accounting-form-error {\n  margin: 0.65rem 0 0;\n  color: $bright-red;\n  font-size: 0.82rem;\n}\n\n.accounting-modal__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  margin-top: 1rem;\n}\n\n@media (max-width: 900px) {\n  .accounting-hero {\n    grid-template-columns: 1fr;\n  }\n\n  .accounting-audit-kpi {\n    grid-template-columns: 1fr;\n  }\n\n  .accounting-audit-kpi--members {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .accounting-audit-layout {\n    gap: 0.85rem;\n  }\n\n  .accounting-audit-detail__hero {\n    grid-template-columns: 1fr;\n  }\n\n  .accounting-audit-detail__hero-side {\n    text-align: left;\n  }\n\n  .accounting-audit-detail__cards {\n    grid-template-columns: 1fr;\n  }\n\n  .accounting-org-inventory-item__hero {\n    grid-template-columns: 1fr;\n  }\n\n  .accounting-org-inventory-item__side {\n    text-align: left;\n  }\n\n  .accounting-members-panel__hero {\n    grid-template-columns: 1fr;\n  }\n\n  .accounting-members-panel__stats {\n    justify-content: flex-start;\n  }\n\n  .accounting-members-panel__stat {\n    text-align: left;\n  }\n\n  .accounting-contracts-panel__hero {\n    grid-template-columns: 1fr;\n  }\n\n  .accounting-contracts-panel__stats {\n    justify-content: flex-start;\n  }\n\n  .accounting-contracts-panel__stat {\n    text-align: left;\n  }\n\n  .accounting-contracts-panel__grid {\n    grid-template-columns: 1fr;\n  }\n\n  .accounting-form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .accounting-field--wide {\n    grid-column: auto;\n  }\n}\n\n.accounting-category-resets {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.accounting-category-resets__stats {\n  margin-bottom: 0;\n}\n\n.accounting-category-resets__overview {\n  margin-bottom: 0;\n}\n\n.accounting-category-resets__overview-toolbar {\n  min-height: 1.75rem;\n  margin-bottom: 0.65rem;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n.accounting-category-resets__toolbar-eyebrow {\n  font-size: 0.72rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.62);\n}\n\n.accounting-category-resets__panel-header.accounting-toolbar,\n.accounting-category-resets__detail-header.accounting-toolbar {\n  align-items: flex-start;\n  margin-bottom: 0.85rem;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n.accounting-category-resets__detail-header.accounting-toolbar {\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.accounting-category-resets__detail-heading {\n  flex: 1 1 12rem;\n  min-width: 0;\n}\n\n.accounting-category-resets__detail-header .accounting-toolbar__actions {\n  margin-left: auto;\n}\n\n.accounting-category-resets__layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);\n  gap: 1rem;\n}\n\n.accounting-category-resets__list-panel,\n.accounting-category-resets__detail-panel {\n  padding: 1rem 1.1rem;\n  min-width: 0;\n}\n\n.accounting-category-resets__panel-header,\n.accounting-category-resets__detail-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.85rem;\n}\n\n.accounting-category-resets__panel-title {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: $very-light-grey;\n}\n\n.accounting-category-resets__detail-meta {\n  margin: 0.35rem 0 0;\n}\n\n.accounting-category-resets__muted {\n  margin: 0;\n  font-size: 0.85rem;\n  color: rgba($very-light-grey, 0.62);\n}\n\n.accounting-category-resets__table tbody tr {\n  cursor: pointer;\n}\n\n.accounting-category-resets__table tbody tr.is-selected {\n  background: rgba($accent-blue, 0.14);\n}\n\n.accounting-category-resets__category-label {\n  font-size: 0.84rem;\n  color: $very-light-grey;\n}\n\n.accounting-category-resets__category-key {\n  margin-top: 0.15rem;\n  font-size: 0.72rem;\n  color: rgba($very-light-grey, 0.55);\n  font-family: 'FiraCode', monospace;\n}\n\n.accounting-category-resets__row-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.accounting-category-resets__breakdown {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.65rem 1rem;\n  margin-top: 1rem;\n  padding-top: 0.85rem;\n  border-top: 1px solid rgba($accent-blue, 0.28);\n}\n\n.accounting-category-resets__breakdown-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  font-size: 0.78rem;\n  color: rgba($very-light-grey, 0.68);\n\n  strong {\n    font-size: 0.88rem;\n    color: $very-light-grey;\n  }\n}\n\n.accounting-category-resets__item-kinds {\n  margin-top: 1rem;\n  padding-top: 0.85rem;\n  border-top: 1px solid rgba($accent-blue, 0.28);\n}\n\n.accounting-category-resets__item-kinds-title {\n  margin: 0 0 0.55rem;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: rgba($very-light-grey, 0.88);\n}\n\n.accounting-category-resets__item-kinds-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n@media (max-width: 960px) {\n  .accounting-category-resets__layout {\n    grid-template-columns: 1fr;\n  }\n}\n","// src/styles/adminWebsite.scss\n\n@import './variables.scss';\n\n.error {\n    color: red;\n    font-size: 0.8em;\n    margin-top: 5px;\n}\n\n.input.admin.container {\n    display: flex;\n    gap: 10px;\n    background: none;\n    border: none;\n    margin: 0;\n    padding: 0;\n}\n\n.filter-container {\n    width: 350px;\n\n    .user-filter {\n        .input {\n            width: 100%;\n        } \n    }\n\n    &.organization-logs {\n\n        .user-filter {\n            .input {\n                width: 350px;\n            } \n        }\n    }\n}\n\n.input.admin {\n    background-color: $blue-grey;\n    padding: 0px 10px 20px 10px;\n    border: 1px solid $light-grey;\n    border-radius: 8px;\n    margin: 0 10px;\n\n    //&.permissions {    height: 210px;    }\n\n\n    &.roles {\n        width: 50%;\n        height: 290px;  \n    }\n\n    &.groups {\n        width: 50%;\n        height: 330px;  \n    }\n\n    &.resources {\n        width: 50%;\n        height: 290px;\n\n        .buttons.manage-resources {\n            gap: 10px;\n        }\n    }\n\n    .create-role,\n    .create-group {\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n\n        .label-role,\n        .label-group {\n            display: flex;\n            justify-content: flex-start;\n            align-items: center;\n            //width: 100%;\n            margin-bottom: 10px;\n\n            label {\n                display: flex;\n                align-items: center;\n                width: 100%; // Largeur fixe pour les labels\n                margin-right: 10px; // Espacement entre le label et le champ de saisie\n                font-weight: bold;\n\n                span {\n                    width: 150px; // Largeur fixe pour les labels\n                    font-weight: bold;\n                }\n\n                input, textarea {\n                    flex-grow: 1;\n                    max-width: 300px; // Largeur fixe pour les inputs et textarea\n                    padding: 4px; // Petit padding pour le styling\n                }\n            }\n\n            .error {\n                color: red;\n                font-size: 0.8em;\n                margin-top: 5px;\n                width: 100%; // Permet aux messages d'erreur de prendre toute la largeur sous les inputs\n            }\n\n        }\n\n        .btn-style1.left {\n            margin-right: auto;\n            margin-left: 0px;\n        }\n    }\n}\n\n.input.admin.discord-bot {\n    display: flex;\n    flex-direction: column;\n\n    .admin-section {\n        h4 {\n            margin-bottom: 10px;\n        }\n\n        .permission-list {\n            height: 150px;\n            overflow-y: auto;\n            display: grid;\n            grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n        }\n\n        .permission-list li {\n            margin: 0px 10px;\n        }\n    }\n}\n\n.input.admin.filter {\n    display: flex;\n    gap: 10px;\n    background: none;\n    border: none;\n    margin: 0;\n    padding: 0;\n    width: 100%;\n}\n\n.role-permission,\n.group-role {\n    width: 30%;\n    min-width: 150px;\n    padding: 0.3rem;\n    display: flex;\n    align-items: center;\n    height: 100%;\n    margin-right: 1rem;\n}\n\n\n.permissions-list,\n.roles-list {\n    background-color: $blue-grey;\n    padding: 20px 20px 20px 20px;\n    border: 1px solid $light-grey;\n    border-radius: 8px;\n    margin: 0 10px;\n\n    .admin-panel {\n        text-transform: uppercase;\n    }\n\n    .menu {\n        font-size: 1.05rem;\n        margin-top: 30px;\n        margin-left: 20px;\n        text-transform: uppercase;\n        padding-top: 10px;\n\n    }\n\n    .tab {\n        color: rgb(197, 204, 209);\n        font-weight: normal;\n        font-size: 1.0rem;\n        margin-top: 10px;\n        margin-left: 20px;\n        text-transform: none;\n        padding-top: 10px;\n\n    }\n\n    .permission,\n    .role {\n        font-weight: bold;\n        margin-left: 20px;\n        margin-top: 10px;\n\n        .description  {\n            margin-left: 0px;\n        }\n    }\n\n    .role-selection,\n    .group-selection {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n\n        .dropdown {\n            display: flex;\n            align-items: center;\n        }\n\n        .selected {\n            &.role-description,\n            &.group-description {\n                margin-left: 1rem;\n                transform: translateY(-7px);\n            }\n        }\n\n        .save-permission {\n            margin-left: auto;\n            align-self: center;\n            height: 100%;\n        }\n    }\n\n}\n\n.gris {\n    opacity: 0.4; /* Diminue l'opacité pour un effet grisé */\n    pointer-events: none; /* Empêche toute interaction avec l'élément */\n    color: $very-light-grey; /* Change la couleur du texte pour un gris clair */\n}\n\n\n.permission.description,\n.role.description {\n    font-size: 0.95rem;\n    color: $light-grey;\n    text-transform: none;\n    padding: 0px 0px 10px 0px;\n    margin-top: 0px;\n    border-bottom: 1px solid $grey;\n}\n\n.permission.toggle,\n.role.toggle  {\n    margin-top: 0px;\n    margin-left: auto;\n}\n\n\n.separator {\n    border-bottom: 1px solid $light-grey;\n    margin: 10px 0px 15px 0px;\n}\n\n// Organization Logs\n\n.user-filter {\n    margin: 10px 10px 10px auto;\n    \n\n    &.organization-logs {\n        margin-left: 15px;\n    }\n\n    &.organization-applications {\n        margin: 5px 0px 5px 0px;\n    }\n\n    input {\n        width: 460px;\n        padding: 0.3rem;\n        margin-left: 0px;\n        font-size: 1rem;\n        border: 1px solid #ddd;\n        border-radius: 4px;\n    }\n}\n\n.action-filter {\n    &.organization-logs {\n        display: flex;\n        margin-left: 20px;\n        gap: 20px;\n        width: max-content;\n    }\n}\n\n\n// USER TAB\n\n\n.users-list {\n    .user-item {\n        display: flex;\n        flex-direction: column;\n        background-color: $dark-grey;\n        margin: 10px;\n        border: 1px solid $light-grey;\n        border-radius: 8px;\n        padding: 10px 15px;\n        cursor: pointer;\n\n        &.user-groups {\n            max-height: 500px; /* Adjust this value based on your content */\n        }\n\n        &.expanded {\n            background-color: $blue-grey;\n            max-height: 500px; /* Adjust this value based on your content */\n        }\n\n\n        &.unconfirmed {\n            border-color: orange; // Border color for unconfirmed items\n        }\n\n        &.deleted {\n            border-color: $bright-red; // Border color for deleted items\n        }\n\n        .site-admin.email {\n            color: $light-grey;\n            font-size: 1rem;\n            margin: 10px;\n            transition: color 0.2s ease-in 0s;;\n\n            &.selected {\n                color: $very-light-grey; // Adjust to your selected color\n                font-weight: bold;\n                transition: color 0s ease-in 0s;\n            }\n        }\n\n        .user-groups {\n            max-height: 0;\n            overflow: hidden;\n            transition: max-height 0.4s ease-in-out;\n            margin-left: 10px;\n            align-items: center;\n\n            &.expanded {\n                max-height: 500px; /* Adjust according to your needs */\n            }\n\n            .container {\n                margin: 10px 0px ;\n            }\n            \n            .add-group {\n                .add-group.dropdown {\n                    width: 250px;\n                    margin-right: 10px;\n                    padding: 3px 5px;\n                    cursor: pointer;\n                }\n            }\n\n            .user-group-item {\n                display: flex;\n                flex-wrap: nowrap;\n                list-style-type: none;\n                align-items: center;\n                \n                .group-name {\n                    width: 250px;\n                    margin-right: 10px;\n                    //top: 15px;\n                    //transform: translateY(15px);\n                }\n            }\n            .btn-style1 {\n                margin-left: 10px;\n            }\n        }\n    }\n\n    .user-email.deleted {\n        color: $bright-red; // Text color for deleted emails\n    }\n}\n\n.user-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .account-created {\n        font-size: 0.9em;\n        color: #888;\n        margin-left: auto;\n    }\n}\n\n.user-details {\n    padding: 15px 10px 15px 10px;\n    background-color: $grey;\n    border-radius: 8px;\n\n    .user-details-header {\n        display: flex;\n\n        &.user-details-header {\n            .user-email {\n                border: 2px solid $light-grey;\n                margin: 0px 0px 5px 0px;\n                border-radius: 20px;\n                padding: 4px 10px;\n            }\n\n            .user-add-assignment-inline {\n                margin: 0px 10px 0px auto;\n\n                .assignment-dropdown {\n                    border-radius: 8px;\n                    padding: 5px;\n                    margin-right: 15px;\n                }\n            }\n        }\n    }\n\n    .user-details-actions {\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        flex-wrap: wrap;\n        gap: 10px;\n        margin-top: 10px;\n    }\n\n    .user-details-actions__feedback {\n        flex: 1 1 100%;\n        font-size: 0.9rem;\n        color: $light-grey;\n        text-align: right;\n    }\n\n    .user-details-actions__verify {\n        min-height: 34px;\n    }\n}\n\n\n// organization applications\n//\n\n.table-message-container {\n    display: flex;\n    margin: 0px;\n}\n\n\n.message-container {\n    width: 550px;\n    height: fit-content;\n    margin-top: 10px;\n    margin-left: 10px; // Pour créer un espace entre le tableau et le message\n    background-color: $very-dark-grey;\n    border: 1px solid $dark-red;\n    border-bottom: 4px solid $dark-red;\n    border-radius: 8px;\n    box-shadow: 4px 5px 2px #4b050547;\n\n    .application-header {\n        \n        @include modal-header(\"../medias/steel.png\");\n\n        .application-title {\n            font-size: small;\n            text-transform: uppercase;\n            color: $light-grey;\n            margin-block-start: 0em;\n            margin-block-end: 0em;\n        }\n    }\n    .application-content {\n        overflow-wrap: anywhere;\n        padding: 10px;\n        background-color: $panel-blue;\n        height: 199px;\n        overflow-y: auto;\n        width: auto;\n        @include scrollbar-styles;\n    }\n    .application-footer {\n        background: $dark-grey;\n        height: 20px;\n\n        .vote-button {\n            background: $very-dark-grey;\n            border: 1px solid $grey;\n            border-radius: 8px;\n            margin: 5px;\n            cursor: pointer;\n            display: inline-flex;\n            align-items: center;\n\n            .vote-count {\n                color: $light-grey;\n                margin: 0 0.35rem;\n                font-weight: bold;\n            }\n\n            &.upvote {\n                position: absolute;\n                transform: translate(10px, 5px);\n\n                .thumbs-up-icon {\n                    width: 17px;\n                    margin: 0px 5px 0px 0px;\n                    padding: 4px;\n                }\n                &.voted {\n                    background: $blue-grey;\n                    border: 1px solid $very-light-grey;\n                }\n            }\n\n            &.downvote {\n                position: absolute;\n                transform: translate(80px, 5px);\n\n                .thumbs-down-icon {\n                    width: 17px;\n                    margin: 0px 5px 0px 0px;\n                    padding: 4px;\n                }\n                &.voted {\n                    background: $blue-grey;\n                    border: 1px solid $very-light-grey;\n                }\n            }\n\n            &:hover {\n                border: 1px solid $light-grey;\n            }\n        }\n    }\n}\n\n\n.application-process {\n    display: flex;\n    flex-direction: row;\n    height: 50px;\n    gap: 5px;\n\n      input[type=\"checkbox\"] {\n        /* hide visual element */\n        opacity: 0;\n        width: 0;\n        height: 0;\n        margin: 0;\n        pointer-events: none;   // user can't click the checkbox directly\n        position: absolute;     // removes visual footprint\n    }\n\n    .vote-section {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        width: 130px;\n\n        .vote-button {\n            display: inline-flex;\n            width: 60px;\n            height: 40px;\n            color: $light-grey;\n            background: $blue-grey;\n            border: 1px solid $medium-light-grey;\n            border-radius: 8px;\n            padding: 5px;\n            margin: 5px;\n            align-items: center;\n            cursor: pointer;\n\n            .vote-icon  {\n                display: inline-flex;\n                height: 20px;\n                padding: 5px;\n                align-items: center;\n                cursor: pointer;\n            }\n\n            .vote-count {\n                margin: 0 0.35rem;\n                font-weight: bold;\n            }\n\n            &:hover {\n                border: 1px solid $very-light-grey;\n            }\n        }\n    }\n\n    .background-check {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        margin-left: 10px;\n        width: 110px;\n        //gap: 10px;\n\n        .field {\n            position: relative;\n            display: flex;\n            align-items: center;\n            font-size: 14px;\n            height: 35px;\n            background: $blue-grey;\n            padding: 3px 12px 3px 8px;\n            //border: 1px solid $medium-light-grey;\n            border-radius: 6px;\n            flex: none;\n            cursor: pointer;\n\n            // Chevron pointing to the right\n            clip-path: polygon(\n                0% 0%, \n                88% 0%, \n                100% 50%, \n                88% 100%, \n                0% 100%\n            );\n\n            transition: background-color 0.25s ease, border-color 0.25s ease;\n\n            &:hover {\n                border-color: $very-light-grey;\n            }\n\n            /* ---- SELECT ---- */\n            select {\n                padding: 0px 10px;\n                background: transparent;\n                border: none;\n                text-align-last: center;\n                text-transform: capitalize;\n                color: $very-light-grey;\n                height: 24px;        // force closed height\n                line-height: 24px;   // aligne le texte\n                border-radius: 6px;\n                appearance: none;\n                cursor: pointer;\n\n                &:focus-visible {\n                    border: none;\n                }\n            }\n\n\n            select:invalid {\n                color: $very-light-grey;\n                opacity: 0.7;\n            }\n\n            /* ---- LABEL ---- */\n            label {\n                color: $light-grey;\n                padding: 3px 0px 3px 14px;\n                cursor: pointer;\n            }\n        }\n\n        /* ============================================================\n        CHECKED FIELD COLORS\n        Each type has its own highlight when .checked is present\n        ============================================================ */\n\n        .field.age {\n            left: 0px;\n            z-index: 30;\n            width: 120px;\n\n            select {\n                &:focus-visible {\n                    border: none;\n                }\n\n                option {\n                    background: $blue-grey;\n                }\n                \n            }\n\n        }\n\n        .field.spectrum {\n            left: -20px;\n            z-index: 25;\n            justify-content: center;\n            width: 120px;\n\n            select {\n                &:focus-visible {\n                    border: none;\n                }\n\n                option {\n                    background: $blue-grey;\n                }\n                \n            }\n        }\n\n        .field.rsi {\n            left: -40px;\n            z-index: 20;\n            justify-content: center;\n            width: 110px;\n        }\n\n        .field.discord {\n            left: -60px;\n            z-index: 15;\n            justify-content: center;\n            width: 110px;\n        }\n\n        .field.admission {\n            left: -80px;\n            z-index: 10;\n            justify-content: center;\n            width: 110px;\n        }\n\n\n\n        // CHECKED \n\n        .field.age.checked {\n            background-color: $very-dark-orange;\n            left: 0px;\n            \n            z-index: 30;\n           \n\n            select {\n                max-height: 60px;\n                overflow-y: auto; \n\n                option {\n                    background: $very-dark-orange;\n                }\n            }\n        }\n\n        .field.spectrum.checked {\n            background-color: $dark-orange;\n            left: -20px;\n            z-index: 25;\n\n            select {\n                option {\n                    background: $dark-orange;\n                }\n            }\n        }\n\n        .field.rsi.checked {\n            background-color: $orange;\n            left: -40px;\n            z-index: 20;\n\n            &.declined {\n                background-color: $red;\n                select {\n                    color: $very-light-grey;\n                }\n            }\n        }\n\n        .field.discord.checked {\n            background-color: $light-orange;\n            color: $very-dark-grey;\n            left: -60px;\n            z-index: 15;\n            width: 110px;\n\n            label {\n                color: $very-dark-grey;\n            }\n        }\n\n        .field.admission.checked {\n            background-color: $very-light-orange;\n            left: -80px;\n            justify-content: center;\n            z-index: 10;\n            width: 110px;\n\n            label {\n                color: $very-dark-grey;\n            }\n        }\n\n\n\n        .rsi-link {\n            display: inline-flex;\n            position: relative;\n            left: -70px;\n            width: 0px;\n            height: 25px;\n            opacity: 0.7;\n            cursor: pointer;\n\n            &:hover {\n                opacity: 1;\n            }\n        }\n\n        .field-2 {\n            position: relative;\n            display: flex;\n            align-items: center;\n            font-size: 14px;\n            height: 40px;\n            background: $blue-grey;\n            padding: 3px 12px 3px 8px;\n            border: 1px solid $blue;\n            border-radius: 6px;\n            flex: none;\n\n            &:hover {\n                background-color: $dark-red; \n                color: $very-light-grey;\n                border: 1px solid $red;\n                cursor: pointer;\n            }\n        }\n\n        .field-2.canceled.checked {\n            background-color: $red; \n        }\n    }\n\n    .field-updated {\n        position: relative;\n        overflow: visible;\n    }\n\n    .field-updated::after {\n        content: \"\";\n        position: absolute;\n        inset: -4px;\n        border-radius: 6px;\n        pointer-events: none;\n        //animation: glowFlash 0.6s ease-out;\n    }\n}\n\n@keyframes glowFlash {\n  0% {\n    box-shadow: 0 0 0px 0px rgba(255, 240, 120, 0.9);\n    opacity: 1;\n  }\n  40% {\n    box-shadow: 0 0 8px 4px rgba(255, 240, 120, 0.8);\n    opacity: 1;\n  }\n  100% {\n    box-shadow: 0 0 0px 0px rgba(255, 240, 120, 0);\n    opacity: 0;\n  }\n}\n\n.clickable-row {\n    cursor: pointer; // Indiquer que la ligne est cliquable\n}\n\n.clickable-row:hover {\n    background-color: #f1f1f1; // Changer la couleur au survol pour indiquer l'interaction\n}\n\n.questions-fields-container {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n\n   \n}\n/* 🔹 Chips: see main.scss (.chip, .chips-container) */\n\n/* 🔹 Confirmation modal (style minimal) */\n.remove-confirm-modal {\n  position: fixed;\n  inset: 0;                /* top/right/bottom/left: 0 */\n  z-index: 20000;          /* above everything else */\n  background: rgba(0, 0, 0, 0.6);\n\n  /* Center the dialog regardless of page scroll */\n  display: grid;\n  place-items: center;\n\n  /* Prevent background from scrolling while open (optional) */\n  overscroll-behavior: contain;\n}\n\n/* Dialog card */\n.remove-confirm-modal .modal-content {\n    height: 150px;\n    width: unquote(\"min(92vw, 480px)\"); \n    border-radius: 10px;\n    padding: 20px;\n    box-shadow: 0 10px 30px rgba(0,0,0,.4);\n}\n\n/* Actions row */\n.remove-confirm-modal .modal-actions {\n  margin-top: 16px;\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n}\n\n/* Optional: lock body scroll when modal is open */\nbody.modal-open {\n  overflow: hidden;\n}\n\n\n\n.handle-cell {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n\n  .warning-icon {\n    display: \"inline-block\";\n    position: relative;\n    vertical-align: middle;\n    cursor: pointer;\n    font-size: 14px;\n    color: #d67f00; // orange warning tone\n    margin-left: auto;\n    margin-right: 5px;\n\n    .warning-tooltip {\n      visibility: hidden;\n      opacity: 0;\n      position: \"fixed\";\n      width: max-content;\n      height: max-content;\n      background-color: $very-dark-grey;\n      color: $very-light-grey;\n      border: 1px solid $light-grey;\n      border-radius: 4px;\n      padding: 8px 10px;\n      white-space: nowrap;\n      z-index: 999999;\n      transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;\n      overflow: visible !important;\n\n      .tooltip-title {\n        font-weight: bold;\n        margin-bottom: 5px;\n        white-space: normal;\n      }\n\n      .tooltip-list {\n        margin: 0;\n        padding-left: 16px;\n        text-align: left;\n        white-space: normal;\n\n        li {\n          list-style-type: disc;\n        }\n      }\n    }\n\n\n\n    &:hover .warning-tooltip {\n        visibility: visible;\n        opacity: 1;\n        top: -40px;\n        left: 94px;\n    }\n  }\n}\n\n.floating-warning-tooltip {\n  background: $very-dark-grey;\n  color: $very-light-grey;\n  border: 1px solid $light-grey;\n  border-radius: 4px;\n  padding: 8px 10px;\n  z-index: 99999;\n  white-space: nowrap;\n  pointer-events: none;\n  box-shadow: 0 2px 5px rgba(0,0,0,0.5);\n\n    &.global {\n        position: fixed;\n        transform: translateX(-50%) translateY(-95%);\n        z-index: 9999;\n        border-radius: 6px;\n        padding: 6px 8px;\n        font-size: 13px;\n        opacity: 1;\n    }\n}\n\n.tooltip-title {\n  font-weight: bold;\n  margin-bottom: 5px;\n}\n\n.tooltip-list {\n  margin: 0;\n  padding-left: 16px;\n  text-align: left;\n  white-space: normal;\n  li {\n    list-style-type: disc;\n  }\n}\n\n.mark-all-read-btn {\n    font-size: 10px;\n    line-height: 14px;\n    padding: 0 6px;\n    height: 26px;\n    flex-shrink: 0;\n    opacity: 0.7;\n    border-radius: 3px;\n    cursor: pointer;\n    border: 1px solid #ccc;\n    background: #f5f5f5;\n\n    &:hover {\n        opacity: 1;\n    }\n}\n","// Site Admin — Groups & Roles tab (aligned with OrgTitles / org-requests)\n\n@import './variables.scss';\n\n.groups-roles-tab {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  min-width: 0;\n\n  &__intro {\n    margin: 0;\n    font-size: 0.85rem;\n    line-height: 1.45;\n    color: rgba($very-light-grey, 0.85);\n  }\n\n  &__layout {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 1rem;\n    align-items: start;\n\n    @media (max-width: 1100px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  &__block {\n    min-width: 0;\n    margin: 0;\n  }\n\n  .admin-block-header {\n    margin-bottom: 0.75rem;\n\n    .admin-h4 {\n      margin: 0 0 0.35rem;\n    }\n\n    .hint {\n      margin: 0;\n    }\n  }\n\n  &__selected-pill {\n    display: inline-flex;\n    flex-wrap: wrap;\n    align-items: baseline;\n    gap: 0.35rem 0.65rem;\n    margin-top: 0.5rem;\n    padding: 0.5rem 0.75rem;\n    border-radius: 8px;\n    border: 1px solid rgba($light-green, 0.28);\n    background: rgba($darker-green, 0.22);\n  }\n\n  &__selected-label {\n    font-size: 0.68rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: $light-green;\n  }\n\n  &__selected-name {\n    font-size: 0.9rem;\n    font-weight: 700;\n    color: $very-light-green;\n  }\n\n  &__toolbar {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 0.65rem;\n    margin-bottom: 0.75rem;\n  }\n\n  &__search {\n    flex: 1 1 180px;\n    min-width: 140px;\n    max-width: 280px;\n    padding: 0.45rem 0.65rem;\n    border: 1px solid rgba($light-blue, 0.35);\n    border-radius: 6px;\n    background: rgba($very-dark-grey, 0.65);\n    color: $very-light-grey;\n    font-size: 0.85rem;\n\n    &::placeholder {\n      color: rgba($light-grey, 0.85);\n    }\n\n    &:focus {\n      outline: none;\n      border-color: rgba($light-blue, 0.55);\n      box-shadow: 0 0 0 2px rgba($accent-blue, 0.25);\n    }\n  }\n\n  &__section {\n    min-width: 0;\n  }\n\n  &__empty {\n    margin: 0;\n    padding: 0.75rem 0.5rem;\n    font-size: 0.85rem;\n    font-style: italic;\n    color: rgba($light-grey, 0.9);\n  }\n\n  .admin-actions {\n    margin-top: 0.85rem;\n    padding-top: 0.25rem;\n  }\n\n  .table-base.simple-editor-table {\n    margin: 0;\n    border-color: rgba($medium-light-grey, 0.35);\n    box-shadow: 0 6px 18px rgba($dark-blue-grey, 0.28);\n\n    .table-body-scroll {\n      // Literal CSS min(): Sass `min()` cannot mix px and vh at compile time.\n      max-height: #{\"min(420px, 48vh)\"};\n      overflow-y: auto;\n      border-bottom-width: 2px;\n    }\n\n    tbody.content tr.table-row {\n      cursor: pointer;\n    }\n\n    td.cell-assign {\n      text-align: center;\n    }\n  }\n\n  .role-checkbox {\n    &:disabled {\n      opacity: 0.45;\n      cursor: not-allowed;\n    }\n  }\n}\n\n.table-base.simple-editor-table.simple-editor-table--groups {\n  col.col-groups-name {\n    width: 24%;\n  }\n\n  col.col-groups-description {\n    width: 46%;\n  }\n\n  col.col-groups-mentionable {\n    width: 10%;\n  }\n\n  col.col-groups-actions {\n    width: 14%;\n  }\n}\n\n.table-base.simple-editor-table.simple-editor-table--group-roles {\n  col.col-group-roles-name {\n    width: 30%;\n  }\n\n  col.col-group-roles-description {\n    width: 54%;\n  }\n\n  col.col-group-roles-assign {\n    width: 10%;\n  }\n}\n\n.groups-roles-modal {\n  .form-grid {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 0.85rem;\n  }\n\n  .input-field {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n  }\n\n  .input-label {\n    font-size: 0.78rem;\n    font-weight: 600;\n    color: $light-grey;\n  }\n\n  .input-text {\n    width: 100%;\n    padding: 0.45rem 0.65rem;\n    border: 1px solid rgba($medium-light-grey, 0.45);\n    border-radius: 6px;\n    background: rgba($very-dark-grey, 0.55);\n    color: $very-light-grey;\n    font-size: 0.85rem;\n\n    &:disabled {\n      opacity: 0.65;\n      cursor: not-allowed;\n    }\n  }\n\n  &__mentionable {\n    flex-direction: row;\n    align-items: center;\n    gap: 0.5rem;\n\n    .input-label {\n      margin: 0;\n      cursor: pointer;\n      font-weight: normal;\n      color: $very-light-grey;\n    }\n  }\n\n  &__mentionable-input {\n    width: auto;\n    flex-shrink: 0;\n  }\n}\n","// src/styles/adminPublicPages.scss\n\n@import './variables.scss';\n\n//\n// TABS \n\n\n.admin-toggle {\n  display: flex;\n  align-items: start;\n  justify-content: space-between;\n  border-bottom: 1px solid $grey;\n}\n\n.toggle-info {\n  flex: 1;\n  padding: 10px 0 10px 0 ;\n}\n\n.toggle-control {\n  flex: 0 1 auto;\n  margin-top: 30px;\n}\n\n.toggle-description {\n  font-size: 0.9em;\n  color: $light-grey;\n}\n\n.user-admin-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0px;\n\n  .admin-tabs {\n    display: flex;\n    flex-direction: row;\n    margin-top: 20px;\n    margin-bottom: 0px;\n    border-bottom: 2px solid $dark-grey;\n    \n    button {\n      position: relative;\n      border-top-left-radius: 8px;\n      border-top-right-radius: 8px;\n      padding: 5px 10px 5px 10px;\n      color: $light-grey;\n      margin-right: 2px; // Espacement entre les boutons\n      min-width: 90px;\n      background-color: $very-dark-grey; // Couleur par défaut\n      cursor: pointer;\n\n      &:hover {\n        background-color: $grey; // Couleur au survol\n      }\n\n      .desktop-link-unread-circle {\n        display: inline-block;\n        margin-left: 0.45rem;\n        vertical-align: middle;\n        width: 10px;\n        height: 10px;\n        min-width: 10px;\n        min-height: 10px;\n        box-sizing: border-box;\n        border-radius: 50%;\n        border: 1px solid $light-blue;\n        background: transparent;\n        pointer-events: none;\n      }\n    }\n\n    .active {\n      background-color: $grey; // Couleur de l'onglet actif\n      color: $very-light-grey;\n      border-bottom: 2px solid $grey;\n    }\n  }\n\n  /* Site Admin: wrap upward — primary row stays bottom (next to content); overflow rows stack above */\n  .admin-tabs.site-admin-tabs {\n    flex-direction: row;\n    flex-wrap: wrap-reverse;\n    align-items: flex-end;\n    gap: 2px;\n\n    button {\n      margin-right: 0;\n      white-space: nowrap;\n      flex-shrink: 0;\n    }\n  }\n\n  .admin-content-container {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n}\n\n.publicpages-content-container {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 5px;\n}\n\n.admin-tab-content {\n    background-color: $grey;\n    padding: 10px 10px 10px 10px;\n    color: $very-light-grey;\n    width: calc(100% - 21px);\n    max-width: 100%;\n    min-width: 0;\n    box-sizing: border-box;\n    border-top-right-radius: 8px;\n    border-bottom-right-radius: 8px;\n    border-bottom-left-radius: 8px;\n}\n\n.handle-ownership-tab {\n    .handle-ownership-hint,\n    .handle-ownership-empty,\n    .handle-ownership-userline {\n        font-size: 0.9em;\n        color: $light-grey;\n        margin: 0 0 12px 0;\n        max-width: 640px;\n    }\n\n    .handle-ownership-label {\n        display: block;\n        margin: 12px 0 6px;\n        font-size: 0.85em;\n        color: $very-light-grey;\n    }\n\n    .handle-ownership-select-wrap {\n        max-width: 420px;\n    }\n\n    .handle-ownership-input {\n        display: block;\n        min-width: 220px;\n        max-width: 420px;\n        padding: 8px 10px;\n        border: 1px solid $dark-grey;\n        border-radius: 6px;\n        background-color: $very-dark-grey;\n        color: $very-light-grey;\n    }\n\n    .handle-ownership-datepicker {\n        max-width: 420px;\n\n        .react-datepicker-wrapper,\n        .react-datepicker__input-container {\n            display: block;\n            width: 100%;\n        }\n\n        .react-datepicker__input-container .handle-ownership-input {\n            width: 100%;\n        }\n    }\n\n    .handle-ownership-section-title {\n        margin: 20px 0 8px;\n        color: $very-light-grey;\n    }\n\n    .handle-ownership-table {\n        width: 100%;\n        max-width: 920px;\n        border-collapse: collapse;\n        margin-bottom: 12px;\n        font-size: 0.85em;\n\n        th,\n        td {\n            padding: 6px 8px;\n            border-bottom: 1px solid $dark-grey;\n            text-align: left;\n            color: $very-light-grey;\n        }\n\n        th {\n            color: $light-grey;\n        }\n    }\n\n    .handle-ownership-form {\n        margin-top: 20px;\n        padding-top: 16px;\n        border-top: 1px solid $dark-grey;\n        max-width: 520px;\n    }\n\n    .handle-ownership-status {\n        margin: 8px 0;\n        padding: 10px 12px;\n        font-size: 0.9em;\n        color: $very-light-grey;\n        background-color: $blue-grey;\n        border: 1px solid $blue;\n        border-radius: 6px;\n    }\n\n    .handle-ownership-submit {\n        margin-top: 14px;\n        padding: 8px 14px;\n        border-radius: 6px;\n        border: 1px solid $dark-grey;\n        background-color: $dark-grey;\n        color: $very-light-grey;\n        cursor: pointer;\n\n        &:hover:not(:disabled) {\n            background-color: $grey;\n        }\n\n        &:disabled {\n            opacity: 0.6;\n            cursor: not-allowed;\n        }\n    }\n}\n\n.rank-calculation-tab {\n    .rank-calculation-hint {\n        font-size: 0.9em;\n        color: $light-grey;\n        margin: 0 0 12px 0;\n        max-width: 520px;\n    }\n\n    .rank-calculation-form {\n        display: flex;\n        flex-wrap: wrap;\n        align-items: flex-end;\n        gap: 10px;\n        margin-bottom: 12px;\n    }\n\n    .rank-calculation-label {\n        flex: 0 0 100%;\n        font-size: 0.85em;\n        color: $very-light-grey;\n    }\n\n    .rank-calculation-select-wrap {\n        flex: 1 1 280px;\n        min-width: 260px;\n        max-width: 420px;\n    }\n\n    .rank-calculation-input {\n        min-width: 220px;\n        padding: 8px 10px;\n        border: 1px solid $dark-grey;\n        border-radius: 6px;\n        background-color: $very-dark-grey;\n        color: $very-light-grey;\n    }\n\n    .rank-calculation-submit {\n        padding: 8px 14px;\n        border-radius: 6px;\n        border: 1px solid $dark-grey;\n        background-color: $dark-grey;\n        color: $very-light-grey;\n        cursor: pointer;\n\n        &:hover:not(:disabled) {\n            background-color: $grey;\n        }\n\n        &:disabled {\n            opacity: 0.6;\n            cursor: not-allowed;\n        }\n    }\n\n    .rank-calculation-status {\n        margin: 0 0 12px 0;\n        max-width: 520px;\n        padding: 10px 12px;\n        font-size: 0.9em;\n        line-height: 1.45;\n        color: $very-light-grey;\n        background-color: $blue-grey;\n        border: 1px solid $blue;\n        border-radius: 6px;\n    }\n\n    .rank-calculation-batch-section {\n        margin-top: 24px;\n        padding-top: 20px;\n        border-top: 1px solid $dark-grey;\n        max-width: 640px;\n    }\n\n    .rank-calculation-batch-title {\n        margin: 0 0 8px 0;\n        font-size: 1rem;\n        font-weight: 600;\n        color: $very-light-grey;\n    }\n\n    .rank-calculation-batch-warning {\n        font-size: 0.9em;\n        color: $light-grey;\n        margin: 0 0 12px 0;\n        line-height: 1.45;\n    }\n\n    .rank-calculation-submit--danger {\n        border-color: $dark-red;\n        background-color: $dark-red;\n        color: $very-light-grey;\n\n        &:hover:not(:disabled) {\n            background-color: $bright-red;\n            border-color: $bright-red;\n        }\n    }\n\n    .rank-calculation-result {\n        margin: 0;\n        padding: 12px;\n        max-height: 420px;\n        overflow: auto;\n        font-size: 0.8rem;\n        border-radius: 6px;\n        background-color: $very-dark-grey;\n        border: 1px solid $dark-grey;\n    }\n}\n\n.sc-data-viewer-tab {\n    .sc-data-viewer-hint {\n        font-size: 0.9em;\n        color: $light-grey;\n        margin: 0 0 16px 0;\n        max-width: 560px;\n        line-height: 1.45;\n    }\n\n    .sc-data-viewer-form {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n        max-width: 520px;\n        margin-bottom: 12px;\n    }\n\n    .sc-data-viewer-label {\n        font-size: 0.85em;\n        color: $very-light-grey;\n    }\n\n    .sc-data-viewer-row {\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        gap: 10px;\n    }\n\n    .sc-data-viewer-input {\n        flex: 1 1 200px;\n        min-width: 180px;\n        max-width: 280px;\n        padding: 8px 10px;\n        border: 1px solid $dark-grey;\n        border-radius: 6px;\n        background-color: $very-dark-grey;\n        color: $very-light-grey;\n        text-transform: uppercase;\n        letter-spacing: 0.04em;\n    }\n\n    .sc-data-viewer-submit {\n        padding: 8px 14px;\n        border-radius: 6px;\n        border: 1px solid $dark-grey;\n        background-color: $dark-grey;\n        color: $very-light-grey;\n        cursor: pointer;\n\n        &:hover:not(:disabled) {\n            background-color: $grey;\n        }\n\n        &:disabled {\n            opacity: 0.6;\n            cursor: not-allowed;\n        }\n    }\n\n    .sc-data-viewer-success {\n        margin: 8px 0 0 0;\n        font-size: 0.9em;\n        color: $very-light-grey;\n        max-width: 560px;\n    }\n\n    .sc-data-viewer-error {\n        margin: 8px 0 0 0;\n        font-size: 0.9em;\n        color: $bright-red;\n        max-width: 560px;\n    }\n}\n\n.split-container {\n  &.row {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n  }\n}\n\n\n.admin-block-container {\n  padding: 10px 15px;\n  min-height: 150px;\n  background-color: $blue-grey;\n  border: 1px solid $light-grey;\n  border-radius: 5px;\n  box-shadow: inset -2px -2px 3px rgba(70, 69, 69, 0.2);\n\n    &.full-width {\n      width: calc(100% - 20px);\n    }\n\n    &.rte {\n      height: 240px;\n      padding-bottom: 20px;\n    }\n\n    &.ranks-input {\n      \n      display: flex;\n      height: 275px;\n      padding-bottom: 20px;\n    }\n\n    &.flex {\n      display: flex;\n      justify-content: space-between; /* Assure une répartition égale de l'espace */\n      align-items: start; /* Aligner les éléments au début */\n      gap: 20px;\n    }\n\n    &.flex-divisions {\n      //background: $dark-grey;\n      display: flex;\n      justify-content: flex-start;; /* Assure une répartition égale de l'espace */\n      align-items: start; /* Aligner les éléments au début */\n    }\n\n    &.structure.diagram {\n      background: $blue-grey;\n    }\n\n    &.event-template {\n      padding: 0.2rem;\n      margin-top: 15px;\n    }\n\n\n\n    &.permissions {\n      height: 215px;\n    }\n\n    &.token-chart {\n      //background: $dark-grey;\n      //border: 1px solid $light-grey;\n\n      &.preview {\n        //background: rgb(182, 118, 0);\n        border: 1px solid $bright-red;\n      } \n    }\n\n    &.trainings {\n      display: flex;\n      flex-direction: column;\n      width: 45%;\n      height: 240px;\n      background: $dark-grey;\n      //margin-top: 55px;\n      padding: 0;\n      margin-left: 10px;\n      border: 1px solid $dark-red;\n      border-bottom: 4px solid $dark-red;\n      border-radius: 10px;\n\n      .selected-row-info {\n        display: grid;\n        padding: 8px;\n      }\n\n      .validate-button-container {\n        margin: auto 0px 10px 10px;\n      }\n    }\n\n    &.trainings-selection {\n      justify-content: space-between;\n      width: 430px;\n      background: $grey;\n      margin-top: 55px;\n      border: none;\n    }\n\n    &.dark-background {\n      background: $blue-grey;\n    }\n}\n\n.logo-input-file {\n  display: none;\n}\n\n.training-equivalence {\n  &.header {\n    font-size: small;\n    font-weight: lighter;\n    text-transform: uppercase;\n    text-align: left;\n    height: 30px;\n    padding: 0 5px;\n    @include steel-bg(\"../medias/steel.png\");\n    border-bottom: 2px solid $grey;\n    border-radius: 10px 10px 0px 0px;\n\n    .training-equivalence-title {\n      position: relative;\n      top: 7px;\n      color: $very-light-grey;\n    }\n    \n  }\n\n} \n\n.create-theme {\n  .admin-h4 {\n     margin-left: 10px;\n  }\n}\n\n.input-row.academy-question {\n  .mde-textarea-wrapper .mde-text {\n      height: 60px !important;\n  }\n\n  .mde-preview {\n      min-height: 60px !important;\n      max-height: 60px !important;\n      height: 60px !important;\n  }\n} \n  \n.admin-management, .structure-management {\n  width: 100%;\n\n  &.tab-home {\n    width: 40%;\n  }\n\n  .input-field {\n    display: flex;\n    align-items: center;\n    //width: fit-content;\n    border-radius: 4px;\n\n    .home-file {\n      display: flex;\n      position: relative;\n      align-items: center;\n      justify-content: start;\n      margin-left: 20px;\n      margin-right: 0%;\n      width: 28%;\n      bottom: 0px;\n    }\n\n    .media-file {\n      display: none;\n    }\n\n    .input-title, \n    .input-subtitle,\n    .input-file {\n      min-width: 200px;\n      border-radius: 4px;\n    }\n\n    .rank-type {\n      bottom: 5px;\n    }\n\n    &.divisionDescription {\n      display: flex;\n      flex-direction: column;\n      width: auto;\n      align-items: flex-start;\n      height: 150px;\n      \n\n      .home-file {\n        margin-left: 0;\n      }\n    }\n\n    &.org-division-member-stats {\n      flex-direction: column;\n      align-items: flex-start;\n      margin-bottom: 12px;\n      padding: 10px 12px;\n      border: 1px solid $grey;\n      border-radius: 6px;\n      background: rgba($dark-grey, 0.35);\n\n      .home-file {\n        width: 100%;\n        margin-left: 0;\n        margin-bottom: 4px;\n      }\n\n      &__count {\n        font-size: 1.25rem;\n        font-weight: 600;\n        color: $very-light-grey;\n        margin-bottom: 8px;\n      }\n\n      &__hint {\n        font-size: 0.85rem;\n        color: $light-grey;\n        margin-bottom: 12px;\n      }\n\n      &__warning {\n        color: $bright-red;\n        font-size: 0.9rem;\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  &.allies {\n    display: flex;\n  }\n}\n\n.allied-input {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n\n  &.left {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: column;\n    width: 100%;\n  }\n\n  &.right {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: column;\n    width: 100%;\n\n    .logo-wrapper.allies {\n      display: flex;\n      flex-wrap: wrap;\n      align-content: flex-start;\n\n\n\n    }\n\n    .orglogo-section {\n      flex-wrap: wrap;\n      align-content: flex-start;\n      flex-direction: column;\n\n      .add-logo {\n        display: none;\n      }\n\n      .logo-icon-wrapper {\n        flex-wrap: wrap;\n        align-content: flex-start;\n        flex-direction: row;\n      }\n      \n    }\n  }  \n}\n\n.logo-section {\n  .logo-wrapper {\n    margin-top: 0px;\n    padding-right: 0px;\n    margin-left: 50px;\n  }\n\n  .add-rank-image {\n    display: none;\n  }\n\n  &.ranks {\n    margin-left: 50px;\n    margin-right: 50px;\n  }\n\n  .add-section-logo {\n    display: none;\n  }\n}\n\n.rank-preview {\n  position: relative;\n  transform: translate(20px, 10px);\n  max-width: 432px;\n  min-width: 320px;\n}\n\n.structure-management {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-top: 35px;\n  padding: 20px;\n}\n\n.rank-management {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  align-items: flex-start;\n  margin-top: 35px;\n  padding: 20px;\n}\n\n.input {\n  &.structure {\n    &.elementName,\n    &.elementDetails {\n      width: 300px;\n      height: 65px;\n      margin-bottom: 10px;\n      resize: none;\n      border-radius: 4px;\n    }\n    &.abreviation {\n      width: 55px;\n      text-transform: uppercase;\n      bottom: 10px;\n      border-radius: 4px;\n    }\n    &.dropdown {\n      width: 305px;\n      height: 22px;\n      border-radius: 4px;\n    }\n\n    &.divisionDescription {\n      display: flex;\n      width: 100%;\n      //height: 170px;\n      margin: 10px 0 10px 0;\n      resize: none;\n      border-radius: 4px;\n      @include scrollbar-styles;\n    }\n\n    .create-event {\n      color: red;\n    }\n  }\n\n  &.ranks {\n    &.paygrade {\n      width: 50px;\n      margin-bottom: 0px;\n      resize: none;\n      border-radius: 4px;\n    }\n\n    &.abreviation {\n      width: 75px;\n      margin-bottom: 0px;\n      margin-left: 0px;\n      resize: none;\n      border-radius: 4px;\n    }\n\n    &.rankName {\n      width: 250px;\n      margin-bottom: 0px;\n      resize: none;\n      border-radius: 4px;\n    }\n\n    &.dropdown {\n      width: 258px;\n      margin-bottom: 10px;\n      resize: none;\n      border-radius: 4px;\n    }\n  }\n\n  &.allie {\n    width: 250px;\n    border-radius: 4px;\n  }\n}\n\n.home-file {\n  &.ranks.rankType {\n    position: relative;\n    font-size: 0.9rem;\n    text-transform: uppercase;\n    width: max-content;\n    margin-left: 0px ;\n    bottom: 0px;\n  }\n\n  &.ranks.abreviation {\n    position: relative;\n    font-size: 1rem;\n    width: 50px;\n    margin-left: 28px;\n    margin-right: -23px;\n    bottom: 0px;\n  }\n\n  &.ranks.status {\n    position: relative;\n    font-size: 1rem;\n    width: 50px;\n    margin-left: 20px ;\n    bottom: 5px;\n  }\n}\n\n.default-btn.allies{\n  margin: 10px 0px 10px 20px;\n}\n\n.default-btn.event-template{\n  margin: 10px 10px 10px 20px;\n}\n\n.default-btn \n.newmedia{\n    position: relative;\n    min-width: 120px;\n    margin: 15px 0px 20px 18px;\n    top: 0px;\n\n  .hometab-save {\n        &:hover {\n            background-color: darken($very-light-grey, 10%);\n        }\n    }\n\n  .cancel {\n    &:hover {\n      border: 1px solid $grey;\n    }\n  }\n\n  .delete {\n    &:hover {\n      border: 3px solid $bright-red;\n      background-color: darken($red, 10%);\n    }\n  }\n}\n\n\n.homepage-management {\n  justify-content: start;\n  border: 1px solid #9c99a3;\n  padding: 0.5rem;\n  border-radius: 4px;\n  box-shadow: inset -2px -2px 3px rgba(70, 69, 69, 0.2);\n\n  .toggle {\n    .toggle-switch {\n      position: relative;\n      display: flex;\n      background-color: #E0E0E0; // Assume $very-light-grey corresponds to #E0E0E0\n      align-items: center;\n      justify-content: space-between;\n      margin-left: 20px;\n      padding: 0 5px;\n      height: 25px;\n      width: 140px;\n\n      &:before {\n        content: '';\n        position: absolute;\n        width: 70px;\n        height: 20px;\n        bottom: 3px;\n        border-radius: 10px;\n        transition: transform 0.3s;\n        box-shadow: 0px 0px 4px 3px rgba(0, 0, 0, 0.404);\n      }\n\n      span {\n        position: absolute;\n        width: 70px;\n        text-align: center;\n        font-size: 0.65em;\n        font-weight: 800;\n        text-transform: uppercase;\n        transition: opacity 0.2s, left 0.2s;\n\n        &.text {\n          opacity: 1;\n          left: 2px;\n        }\n\n        &.media {\n          opacity: 0;\n          left: 77px; // Position de départ à droite\n        }\n      }\n\n      &.active {\n        span.text {\n          opacity: 0;\n        }\n\n        span.media {\n          opacity: 1;\n        }\n      }\n    }\n\n    input:checked + .toggle-switch:before {\n      transform: translateX(74px);\n    }\n  }\n}\n\n.toggle-container {\n  width: 100%;\n}\n\n\n//\n// POLICY MANAGEMENT\n  \n\n.lastEditBy {\n  position: absolute;\n  top: 30px;\n  left: 20px;\n}\n\n\n\n//Alliances cards\n//\n\n.allies-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  justify-content: center;\n}\n\n.ally-item {\n  position: relative;\n  flex: 1 1 calc(50% - 20px); // Adjusted to fit 2 items per row\n  max-width: calc(50% - 20px); // Adjusted to fit 2 items per row\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 10px;\n  border: 1px solid $grey;\n  border-radius: 8px;\n  background-color: $dark-grey;\n  box-sizing: border-box;\n  height: 300px;\n  overflow: hidden;\n  transition: all 0.3s ease;\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    top: 5px; /* Adjust the top value to match your design */\n    bottom: 5px; /* Adjust the bottom value to match your design */\n    left: 5px;\n    right: 5px;\n    border-left: 3px solid $grey;\n    border-right: 3px solid $grey;\n    border-radius: 5px; /* Adjust the radius to match the inner corners */\n    pointer-events: none; /* Ensure the pseudo-element does not interfere with interactions */\n    z-index: 1; /* Ensure the pseudo-element is below the content */\n  }\n\n  .ally-content {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 280px;\n    padding: 0 20px;\n    transition: transform 0.3s ease;\n\n    .ally-logo {\n      margin-right: 10px;\n      transition: width 0.3s ease;\n\n      img {\n        width: 200px;\n        height: auto;\n        transition: width 0.3s ease;\n      }\n    }\n\n    .ally-details {\n      text-align: left;\n\n      h3 {\n        margin: 0;\n        font-size: 1.2em;\n        transition: all 0.3s ease;\n      }\n    }\n  }\n\n  .ally-description-icons {\n    position: absolute;\n    bottom: -100%;\n    left: 0;\n    right: 0;\n    margin-left: 8px;\n    margin-right: 8px;\n    margin-bottom: 5px;\n    height: 200px;\n    background: $very-dark-grey;\n    padding: 10px 5px 10px 10px  ;\n    transition: bottom 0.3s ease;\n    border-top: none;\n    border-bottom: 2px solid $grey;\n    border-radius: 5px;\n\n    .ally-description {\n      position: relative;\n      height: 160px; /* Adjust this value based on your design */\n      overflow-y: auto;\n      z-index: 2;\n      padding-bottom: 5px;\n      @include scrollbar-styles;\n    }\n\n    .ally-icons {\n      display: flex;\n      margin-left: 12px;\n      gap: 30px;\n      align-items: center;\n      padding-top: 12px;\n      cursor: pointer;\n\n      .ally-icon {\n        width: 50px;\n        object-fit: cover;\n        object-position: top;\n        //transition: object-position 0.3s ease;\n      }\n\n      .rsi-icon {\n        width: 39px;\n        height: 16px; // Customize as needed\n      }\n\n      .discord-icon {\n        width: 27px;\n        height: 20px; // Customize as needed\n      }\n\n      .guilded-icon {\n        width: 22px;\n        height: 23px; // Customize as needed\n      }\n\n      .website-icon {\n        width: 28px;\n        height: 28px; // Customize as needed\n      }\n    }\n  }\n\n  &:hover {\n    .ally-description-icons {\n      bottom: 0;\n    }\n\n    .ally-content {\n      align-items: flex-start;\n      transform: translateY(10px); // Adjust based on your design\n    }\n\n    .ally-content .ally-logo img {\n      width: 50px;\n    }\n\n    .ally-details {\n      display: flex;\n      height: 50px;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n\n  .icon:hover {\n    object-position: bottom; // Shift to bottom on hover\n  }\n}\n\n.calendar-debrief-default {\n\n  .content.calendar-debrief-default {\n    padding: 0 18px;\n  }\n\n  .footer.calendar-debrief-default {\n    padding: 10px 20px;\n  }\n}\n\n\n\n// MEDIA\n//\n\n@media (max-width: $tablet) {\n  .ally-item {\n    flex: 1 1 100%;\n    max-width: 100%;\n  }\n\n  .ally-description-icons .ally-icons {\n    justify-content: flex-start; // Align icons to the left on mobile\n    margin-left: 10px !important; // Adjust this value if necessary\n  }\n\n  .ally-icons {\n    display: flex;\n    margin-left: 15px;\n    gap: 20px;\n    align-items: center;\n    padding-top: 8px;\n    cursor: pointer;\n\n    .ally-icon {\n      width: 50px;\n      object-fit: cover;\n      object-position: top;\n      //transition: object-position 0.3s ease;\n    }\n\n    .rsi-icon {\n      width: 47px !important;\n      height: 20px !important; // Customize as needed\n    }\n\n    .discord-icon {\n      width: 30px;\n      height: 20px; // Customize as needed\n    }\n\n    .guilded-icon {\n      width: 22px;\n      height: 24px; // Customize as needed\n    }\n\n    .website-icon {\n      width: 30px;\n      height: 30px; // Customize as needed\n    }\n  }\n}\n\n","// Members management — General sub-tab dashboard cards (customize here)\n\n@import './variables.scss';\n\n\n\n.org-members-mgmt-general-dashboard {\n  width: 100%;\n  min-width: 0;\n}\n\n.org-members-mgmt-general-dashboard__layout-root {\n  width: 100%;\n  max-width: 100%;\n}\n\n.org-members-mgmt-general-dashboard__grid {\n  width: 100%;\n  min-width: 0;\n  position: relative;\n}\n\n.org-members-mgmt-general-dashboard__grid-layout {\n  min-height: 12rem;\n  width: 100%;\n}\n\n.org-members-mgmt-general-dashboard__layout-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  width: 100%;\n  margin-bottom: 0.85rem;\n}\n\n.org-members-mgmt-general-dashboard__layout-hint {\n  flex: 1 1 auto;\n  min-width: 0;\n  max-width: max-content;\n  box-sizing: border-box;\n  padding: 0.65rem 0.85rem;\n  border: 1px solid rgba($light-blue, 0.28);\n  border-radius: 8px;\n  background: rgba($very-dark-grey, 0.45);\n}\n\n.org-members-mgmt-general-dashboard__layout-hint-text {\n  margin: 0;\n  font-size: 0.8rem;\n  line-height: 1.45;\n  color: rgba($very-light-grey, 0.82);\n}\n\n.org-members-mgmt-general-dashboard__layout-reset-btn {\n  flex: 0 0 auto;\n  margin: 0;\n  padding: 0.55rem 0.9rem;\n  border: 1px solid rgba($light-blue, 0.45);\n  border-radius: 8px;\n  background: rgba($dark-panel-blue, 0.55);\n  color: $very-light-grey;\n  font-size: 0.78rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.org-members-mgmt-general-dashboard__layout-reset-btn:hover {\n  border-color: rgba($light-blue, 0.65);\n  background: rgba($panel-blue, 0.72);\n}\n\n.org-members-mgmt-general-dashboard__grid-item {\n  box-sizing: border-box;\n}\n\n.org-members-mgmt-general-dashboard__grid-item-body {\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  overflow: hidden;\n\n  > .member-dashboard__hero,\n  > .member-dashboard__panel-card,\n  > .org-members-mgmt-general-dashboard__card {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    min-height: 0;\n    box-sizing: border-box;\n    overflow: hidden;\n  }\n}\n\n.org-members-mgmt-general-dashboard__grid {\n  .react-grid-item {\n    z-index: 0;\n    transition: box-shadow 0.2s ease;\n\n    &.react-draggable-dragging {\n      z-index: 10;\n    }\n\n    &.resizing {\n      z-index: 10;\n    }\n  }\n\n  .react-grid-placeholder {\n    background: rgba($accent-blue, 0.18) !important;\n    border: 1px dashed rgba($accent-blue, 0.55) !important;\n    border-radius: 12px !important;\n    opacity: 0.85 !important;\n  }\n\n  .react-grid-item > .react-resizable-handle {\n    z-index: 5;\n    opacity: 0.45;\n    transition: opacity 0.2s ease;\n\n    &::after {\n      border-right: 2px solid rgba($accent-blue, 0.85) !important;\n      border-bottom: 2px solid rgba($accent-blue, 0.85) !important;\n    }\n  }\n\n  .react-grid-item:hover > .react-resizable-handle,\n  .react-grid-item.resizing > .react-resizable-handle {\n    opacity: 1;\n  }\n}\n\n.org-members-mgmt-general-dashboard__grid-item {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  height: 100%;\n}\n\n.org-members-mgmt-general-dashboard__grid-item-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  min-width: 0;\n  height: 100%;\n}\n\n.org-members-mgmt-general-dashboard__card {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  box-sizing: border-box;\n  border-radius: 10px;\n  border: 1px solid rgba($light-blue, 0.22);\n  background: linear-gradient(\n    160deg,\n    rgba($panel-blue, 0.95) 0%,\n    rgba($dark-panel-blue, 0.9) 100%\n  );\n  box-shadow: 0 6px 20px rgba($dark-blue-grey, 0.28);\n  overflow: hidden;\n}\n\n.org-members-mgmt-general-dashboard__card-head {\n  flex: 0 0 auto;\n  padding: 0.75rem 1rem 0.5rem;\n  border-bottom: 1px solid rgba($medium-light-grey, 0.22);\n}\n\n.org-members-mgmt-general-dashboard__card-title {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  color: $very-light-grey;\n}\n\n.org-members-mgmt-general-dashboard__card-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  min-width: 0;\n  max-width: 100%;\n  box-sizing: border-box;\n  padding: 0.85rem 1rem 1rem;\n  overflow-x: hidden;\n  overflow-y: auto;\n\n  @include org-members-mgmt-general-thin-scrollbar;\n}\n\n.org-members-mgmt-general-dashboard__placeholder {\n  margin: 0;\n  font-size: 0.82rem;\n  color: rgba($light-grey, 0.95);\n}\n\n.org-members-mgmt-general-dashboard__membership-recap {\n  margin: 0.85rem 0 0;\n  font-size: 0.82rem;\n  color: rgba($very-light-grey, 0.92);\n}\n\n.org-members-mgmt-general-dashboard__membership-recap-label {\n  display: block;\n  margin-bottom: 0.25rem;\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: $light-blue;\n}\n\n.org-members-mgmt-general-dashboard__state {\n  margin: 0.85rem 0 0;\n  font-size: 0.82rem;\n  color: rgba($light-grey, 0.95);\n}\n\n.org-members-mgmt-general-dashboard__state--error {\n  color: $light-orange;\n}\n\n// Reuse member dashboard card visuals inside the admin grid\n.org-members-mgmt-general-dashboard {\n  .member-dashboard__hero,\n  .member-dashboard__panel-card {\n    height: 100%;\n    min-height: 0;\n    box-sizing: border-box;\n  }\n\n  .member-dashboard__panel-card-body {\n    overflow: auto;\n    @include org-members-mgmt-general-thin-scrollbar;\n  }\n}\n\n// Assignment structure strip — compact sizing for admin general dashboard only\n.org-members-mgmt-general-dashboard__assignment-card {\n  .org-members-mgmt-general-dashboard__card-body {\n    box-sizing: border-box;\n    max-width: 100%;\n    min-width: 0;\n    overflow-x: hidden;\n    margin-right: 0;\n    padding-right: 1rem;\n\n    .org-members-mgmt-general-dashboard__assignment-structure {\n      width: 100%;\n      max-width: 100%;\n      min-width: 0;\n      overflow: hidden;\n    }\n\n    .org-members-mgmt-general-dashboard__structure-strip {\n      width: 100%;\n      max-width: 100%;\n      min-width: 0;\n      box-sizing: border-box;\n      overflow: hidden;\n\n      .members-onboarding-ending-structure__strip {\n        display: grid;\n        grid-template-columns: repeat(auto-fit, minmax(0, 1fr));\n        align-items: stretch;\n        width: 100%;\n        max-width: 100%;\n        min-width: 0;\n        box-sizing: border-box;\n        margin: 0;\n        padding: 0;\n        list-style: none;\n        gap: 1rem;\n      }\n\n      .members-onboarding-ending-structure__card-item {\n        display: flex;\n        width: 100%;\n        min-width: 0;\n        max-width: 100%;\n        min-height: 9.25rem;\n        align-items: stretch;\n        justify-content: flex-start;\n      }\n\n      .members-onboarding-ending-structure__cardSurface {\n        box-sizing: border-box;\n        flex: 1 1 auto;\n        width: 100%;\n        max-width: 100%;\n        min-width: 0;\n        min-height: 9.25rem;\n        margin-left: 0;\n        margin-right: 0;\n        padding: 0.5rem 0.4rem 0.55rem;\n        border-radius: 8px;\n      }\n\n      .members-onboarding-ending-structure__cardHeader--recap.members-onboarding-structure__card-header {\n        gap: 0.28rem;\n        align-items: center;\n      }\n\n      .members-onboarding-ending-structure__cardHeader--recap\n        .members-onboarding-structure__card-logo {\n        width: 4.35rem;\n        height: 4.75rem;\n        max-width: 100%;\n      }\n\n      .members-onboarding-ending-structure__cardHeader--recap\n        .members-onboarding-structure__card-headings {\n        gap: 0.08rem;\n        width: 100%;\n        min-width: 0;\n      }\n\n      .members-onboarding-ending-structure__cardHeader--recap\n        .members-onboarding-structure__breadcrumb-eyebrow {\n        font-size: 0.6rem;\n      }\n\n      .members-onboarding-ending-structure__cardHeader--recap\n        .members-onboarding-structure__card-title {\n        overflow: hidden;\n        font-size: 0.76rem;\n        font-weight: 800;\n        -webkit-line-clamp: 3;\n        line-clamp: 3;\n      }\n\n      .members-onboarding-ending-structure__cardHeader--recap\n        .members-onboarding-structure__card-subtitle {\n        font-size: 0.66rem;\n        font-weight: 700;\n      }\n    }\n  }\n\n  .org-members-mgmt-general-dashboard__interest-tags {\n    margin-top: 1rem;\n    padding-top: 0.85rem;\n    border-top: 1px solid rgba($light-blue, 0.22);\n  }\n\n  .org-members-mgmt-general-dashboard__interest-tags-title {\n    margin: 0 0 0.65rem;\n    font-size: 0.78rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.88);\n  }\n\n  .org-members-mgmt-general-dashboard__interest-tags-error {\n    margin: 0 0 0.5rem;\n    font-size: 0.82rem;\n    color: $light-orange;\n  }\n\n  .org-members-mgmt-general-dashboard__interest-tags-list {\n    display: flex;\n    flex-flow: row wrap;\n    gap: 0.45rem;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  }\n\n  .org-members-mgmt-general-dashboard__interest-tags-item {\n    list-style: none;\n    margin: 0;\n  }\n\n  .org-members-mgmt-general-dashboard__interest-tag {\n    display: inline-flex;\n    align-items: center;\n    box-sizing: border-box;\n    min-height: 1.65rem;\n    padding: 0.22rem 0.62rem;\n    border-radius: 999px;\n    border: 1px solid $accent-blue;\n    background: rgba($light-panel-blue, 0.95);\n    font-size: 0.74rem;\n    line-height: 1.25;\n    color: rgba($pure-white, 0.96);\n  }\n}\n\n.org-members-mgmt-general-dashboard__ribbons-card {\n  .member-dashboard__panel-card-body {\n    overflow: auto;\n    @include org-members-mgmt-general-thin-scrollbar;\n  }\n\n  .member-dashboard__ribbons-toolbar,\n  .member-dashboard__ribbons-grid {\n    min-width: 0;\n  }\n}\n\n@media (max-width: 900px) {\n  .org-members-mgmt-general-dashboard__grid-layout {\n    height: auto !important;\n  }\n\n  .org-members-mgmt-general-dashboard__grid-item {\n    position: relative !important;\n    transform: none !important;\n    width: 100% !important;\n    margin-bottom: 0.75rem;\n  }\n}\n","// Members management — Player activity sub-tab dashboard (customize here)\n\n@import './variables.scss';\n\n.org-members-mgmt-player-activity-dashboard {\n  width: 100%;\n  min-width: 0;\n}\n\n.org-members-mgmt-player-activity-dashboard__layout-root {\n  width: 100%;\n  max-width: 100%;\n}\n\n.org-members-mgmt-player-activity-dashboard__grid {\n  width: 100%;\n  min-width: 0;\n  position: relative;\n}\n\n.org-members-mgmt-player-activity-dashboard__grid-layout {\n  min-height: 12rem;\n  width: 100%;\n}\n\n.org-members-mgmt-player-activity-dashboard__layout-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  width: 100%;\n  margin-bottom: 0.85rem;\n}\n\n.org-members-mgmt-player-activity-dashboard__layout-hint {\n  flex: 1 1 auto;\n  min-width: 0;\n  max-width: max-content;\n  box-sizing: border-box;\n  padding: 0.65rem 0.85rem;\n  border: 1px solid rgba($light-blue, 0.28);\n  border-radius: 8px;\n  background: rgba($very-dark-grey, 0.45);\n}\n\n.org-members-mgmt-player-activity-dashboard__layout-hint-text {\n  margin: 0;\n  font-size: 0.8rem;\n  line-height: 1.45;\n  color: rgba($very-light-grey, 0.82);\n}\n\n.org-members-mgmt-player-activity-dashboard__layout-reset-btn {\n  flex: 0 0 auto;\n  margin: 0;\n  padding: 0.55rem 0.9rem;\n  border: 1px solid rgba($light-blue, 0.45);\n  border-radius: 8px;\n  background: rgba($dark-panel-blue, 0.55);\n  color: $very-light-grey;\n  font-size: 0.78rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.org-members-mgmt-player-activity-dashboard__layout-reset-btn:hover {\n  border-color: rgba($light-blue, 0.65);\n  background: rgba($panel-blue, 0.72);\n}\n\n.org-members-mgmt-player-activity-dashboard__grid-item {\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  min-width: 0;\n  height: 100%;\n}\n\n.org-members-mgmt-player-activity-dashboard__grid-item-body {\n  flex: 1 1 auto;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  min-width: 0;\n  overflow: hidden;\n\n  > .member-dashboard__panel-card {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    min-height: 0;\n    box-sizing: border-box;\n    overflow: hidden;\n  }\n}\n\n.org-members-mgmt-player-activity-dashboard__grid {\n  .react-grid-item {\n    z-index: 0;\n    transition: box-shadow 0.2s ease;\n\n    &.react-draggable-dragging {\n      z-index: 10;\n    }\n\n    &.resizing {\n      z-index: 10;\n    }\n  }\n\n  .react-grid-placeholder {\n    background: rgba($accent-blue, 0.18) !important;\n    border: 1px dashed rgba($accent-blue, 0.55) !important;\n    border-radius: 12px !important;\n    opacity: 0.85 !important;\n  }\n\n  .react-grid-item > .react-resizable-handle {\n    z-index: 5;\n    opacity: 0.45;\n    transition: opacity 0.2s ease;\n\n    &::after {\n      border-right: 2px solid rgba($accent-blue, 0.85) !important;\n      border-bottom: 2px solid rgba($accent-blue, 0.85) !important;\n    }\n  }\n\n  .react-grid-item:hover > .react-resizable-handle,\n  .react-grid-item.resizing > .react-resizable-handle {\n    opacity: 1;\n  }\n}\n\n.org-members-mgmt-player-activity-dashboard__state {\n  margin: 0.85rem 0 0;\n  font-size: 0.82rem;\n  color: rgba($light-grey, 0.95);\n}\n\n.org-members-mgmt-player-activity-dashboard__state--error {\n  color: $light-orange;\n}\n\n.org-members-mgmt-player-activity-dashboard {\n  .member-dashboard__panel-card {\n    height: 100%;\n    min-height: 0;\n    box-sizing: border-box;\n  }\n\n  .member-dashboard__panel-card-body {\n    overflow: auto;\n    @include org-members-mgmt-player-activity-thin-scrollbar;\n  }\n}\n\n@media (max-width: 900px) {\n  .org-members-mgmt-player-activity-dashboard__grid-layout {\n    height: auto !important;\n  }\n\n  .org-members-mgmt-player-activity-dashboard__grid-item {\n    position: relative !important;\n    transform: none !important;\n    width: 100% !important;\n    margin-bottom: 0.75rem;\n  }\n}\n","// Members management — Player hangar sub-tab (customize here)\n\n@import './variables.scss';\n\n.org-members-mgmt-player-hangar {\n  width: 100%;\n  min-width: 0;\n}\n\n.org-members-mgmt-player-hangar__header {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  margin-bottom: 1rem;\n}\n\n.org-members-mgmt-player-hangar__header-lines {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n\n  span {\n    display: block;\n    height: 2px;\n    border-radius: 999px;\n    background: rgba($accent-blue, 0.55);\n\n    &:first-child {\n      width: 2.5rem;\n    }\n\n    &:last-child {\n      width: 4.5rem;\n      opacity: 0.55;\n    }\n  }\n}\n\n.org-members-mgmt-player-hangar__title {\n  margin: 0;\n  font-size: 1.05rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: $very-light-grey;\n}\n\n.org-members-mgmt-player-hangar__subtitle {\n  margin: 0;\n  font-size: 0.84rem;\n  color: rgba($light-grey, 0.95);\n\n  strong {\n    color: $very-light-grey;\n    font-weight: 600;\n  }\n}\n\n.org-members-mgmt-player-hangar__state {\n  margin: 0.75rem 0 0;\n  font-size: 0.82rem;\n  color: rgba($light-grey, 0.95);\n}\n\n.org-members-mgmt-player-hangar__state--error {\n  color: $light-orange;\n}\n\n.org-members-mgmt-player-hangar__handle-switch {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 0.85rem;\n}\n\n.org-members-mgmt-player-hangar__handle-btn {\n  margin: 0;\n  padding: 0.45rem 0.75rem;\n  border: 1px solid rgba($light-blue, 0.35);\n  border-radius: 999px;\n  background: rgba($dark-panel-blue, 0.55);\n  color: $very-light-grey;\n  font-size: 0.78rem;\n  cursor: pointer;\n}\n\n.org-members-mgmt-player-hangar__handle-btn--active {\n  border-color: rgba($accent-blue, 0.75);\n  background: rgba($panel-blue, 0.85);\n}\n\n.org-members-mgmt-player-hangar__toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.org-members-mgmt-player-hangar__search {\n  min-width: 14rem;\n  flex: 1 1 14rem;\n  max-width: 22rem;\n  padding: 0.45rem 0.65rem;\n  border: 1px solid rgba($light-blue, 0.35);\n  border-radius: 8px;\n  background: rgba($very-dark-grey, 0.45);\n  color: $very-light-grey;\n  font-size: 0.82rem;\n}\n\n.org-members-mgmt-player-hangar__filter-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n}\n\n.org-members-mgmt-player-hangar__filter-pill {\n  margin: 0;\n  padding: 0.4rem 0.7rem;\n  border: 1px solid rgba($light-blue, 0.35);\n  border-radius: 999px;\n  background: rgba($very-dark-grey, 0.35);\n  color: rgba($light-grey, 0.9);\n  font-size: 0.76rem;\n  cursor: pointer;\n}\n\n.org-members-mgmt-player-hangar__filter-pill--active {\n  border-color: rgba($accent-blue, 0.7);\n  background: rgba($panel-blue, 0.72);\n  color: $very-light-grey;\n}\n\n.org-members-mgmt-player-hangar__empty-card {\n  padding: 1rem 1.1rem;\n  border: 1px solid rgba($light-blue, 0.28);\n  border-radius: 10px;\n  background: rgba($very-dark-grey, 0.35);\n}\n\n.org-members-mgmt-player-hangar__empty-title {\n  margin: 0 0 0.35rem;\n  font-size: 0.92rem;\n  color: $very-light-grey;\n}\n\n.org-members-mgmt-player-hangar__empty-text {\n  margin: 0;\n  font-size: 0.82rem;\n  color: rgba($light-grey, 0.92);\n}\n\n.org-members-mgmt-player-hangar__sections {\n  display: flex;\n  flex-direction: column;\n  gap: 1.1rem;\n}\n\n.org-members-mgmt-player-hangar__section {\n  min-width: 0;\n}\n\n.org-members-mgmt-player-hangar__section--package {\n  padding: 0.85rem;\n  border: 1px solid rgba($light-blue, 0.22);\n  border-radius: 10px;\n  background: rgba($dark-panel-blue, 0.35);\n}\n\n.org-members-mgmt-player-hangar__section-title {\n  margin: 0 0 0.65rem;\n  font-size: 0.88rem;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.92);\n}\n\n.org-members-mgmt-player-hangar__empty-section {\n  margin: 0;\n  font-size: 0.8rem;\n  color: rgba($light-grey, 0.88);\n}\n\n.org-members-mgmt-player-hangar__table-wrap {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.org-members-mgmt-player-hangar__table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.82rem;\n}\n\n.org-members-mgmt-player-hangar__table-caption {\n  caption-side: top;\n  text-align: left;\n  padding-bottom: 0.45rem;\n  color: rgba($light-grey, 0.9);\n}\n\n.org-members-mgmt-player-hangar__table th,\n.org-members-mgmt-player-hangar__table td {\n  padding: 0.55rem 0.65rem;\n  border-bottom: 1px solid rgba($light-blue, 0.18);\n  text-align: left;\n  vertical-align: middle;\n}\n\n.org-members-mgmt-player-hangar__table th {\n  font-size: 0.74rem;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: rgba($light-grey, 0.88);\n  background: rgba($very-dark-grey, 0.35);\n}\n\n.org-members-mgmt-player-hangar__table tbody tr:hover {\n  background: rgba($panel-blue, 0.18);\n}\n\n.org-members-mgmt-player-hangar__prod-state {\n  display: inline-block;\n  padding: 0.15rem 0.45rem;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  background: rgba($light-grey, 0.15);\n  color: $very-light-grey;\n}\n\n.org-members-mgmt-player-hangar__prod-state--flight-ready {\n  background: rgba($green, 0.22);\n  color: $light-green;\n}\n\n.org-members-mgmt-player-hangar__prod-state--in-concept {\n  background: rgba($light-orange, 0.18);\n  color: $light-orange;\n}\n\n.org-members-mgmt-player-hangar__prod-state--in-production {\n  background: rgba($accent-blue, 0.2);\n  color: $light-blue;\n}\n\n.org-members-mgmt-player-hangar__prod-state--unknown {\n  color: rgba($light-grey, 0.85);\n}\n","// Organisation members admin — members management workspace\n\n@import './variables.scss';\n@import './memberMgmtGeneralDashboard.scss';\n@import './memberMgmtPlayerActivityDashboard.scss';\n@import './memberMgmtPlayerHangar.scss';\n\n.org-members-mgmt {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  width: 100%;\n  min-width: 0;\n}\n\n.org-members-mgmt__selection {\n  padding: 1rem 1.15rem;\n  border-radius: 10px;\n  border: 1px solid rgba($light-blue, 0.22);\n  background: linear-gradient(\n    145deg,\n    rgba($panel-blue, 0.92) 0%,\n    rgba($dark-panel-blue, 0.88) 100%\n  );\n  box-shadow: 0 8px 24px rgba($dark-blue-grey, 0.35);\n}\n\n.org-members-mgmt__selection-head {\n  margin-bottom: 0.85rem;\n}\n\n.org-members-mgmt__selection-title {\n  margin: 0 0 0.35rem;\n  font-size: 0.95rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: $very-light-grey;\n}\n\n.org-members-mgmt__selection-hint {\n  margin: 0;\n  font-size: 0.82rem;\n  line-height: 1.45;\n  color: rgba($very-light-grey, 0.78);\n}\n\n.org-members-mgmt__select-label {\n  display: block;\n  margin-bottom: 0.4rem;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: $light-grey;\n}\n\n.org-members-mgmt__select-wrap {\n  max-width: 32rem;\n\n  .org-members-mgmt__select {\n    width: 100%;\n  }\n\n  .react-select-input__control {\n    min-height: 38px !important;\n    height: auto !important;\n    border-color: rgba($light-blue, 0.35) !important;\n    background-color: rgba($very-dark-grey, 0.65) !important;\n    color: $very-light-grey;\n  }\n\n  .react-select-input__single-value,\n  .react-select-input__input-container {\n    color: $very-light-grey !important;\n  }\n\n  .react-select-input__placeholder {\n    color: rgba($light-grey, 0.9) !important;\n  }\n}\n\n.org-members-mgmt__selected-card {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 0.35rem 0.75rem;\n  margin-top: 0.9rem;\n  padding: 0.65rem 0.85rem;\n  border-radius: 8px;\n  border: 1px solid rgba($light-green, 0.28);\n  background: rgba($darker-green, 0.22);\n}\n\n.org-members-mgmt__selected-label {\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: $light-green;\n}\n\n.org-members-mgmt__selected-handle {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: $very-light-green;\n}\n\n.org-members-mgmt__selected-moniker {\n  font-size: 0.85rem;\n  color: rgba($very-light-grey, 0.88);\n}\n\n.org-members-mgmt__selected-meta {\n  width: 100%;\n  font-size: 0.72rem;\n  color: rgba($light-grey, 0.95);\n}\n\n.org-members-mgmt__msg--error {\n  color: $light-orange;\n  font-size: 0.82rem;\n}\n\n.org-members-mgmt__workspace {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  min-height: 12rem;\n}\n\n.org-members-mgmt__workspace--locked {\n  opacity: 0.92;\n}\n\n.org-members-mgmt__workspace-title {\n  margin: 0;\n  font-size: 0.88rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: $light-grey;\n}\n\n.org-members-mgmt__workspace-hint {\n  margin: 0;\n  padding: 0.65rem 0.85rem;\n  border-radius: 8px;\n  border: 1px dashed rgba($medium-light-grey, 0.45);\n  background: rgba($very-dark-grey, 0.35);\n  font-size: 0.82rem;\n  color: rgba($very-light-grey, 0.75);\n}\n\n.org-members-mgmt__subtabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  padding-bottom: 0.35rem;\n  border-bottom: 1px solid rgba($medium-light-grey, 0.35);\n}\n\n.org-members-mgmt__subtab-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  margin: 0;\n  padding: 0.45rem 0.85rem;\n  border: 1px solid transparent;\n  border-radius: 8px 8px 0 0;\n  background: rgba($very-dark-grey, 0.55);\n  color: rgba($very-light-grey, 0.72);\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n\n.org-members-mgmt__subtab-btn:hover:not(:disabled) {\n  background: rgba($grey, 0.85);\n  color: $very-light-grey;\n}\n\n.org-members-mgmt__subtab-btn--active {\n  border-color: rgba($light-blue, 0.4);\n  border-bottom-color: transparent;\n  background: $grey;\n  color: $very-light-grey;\n}\n\n.org-members-mgmt__subtab-btn--locked,\n.org-members-mgmt__subtab-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n  color: rgba($light-grey, 0.65);\n}\n\n.org-members-mgmt__subtab-lock {\n  display: inline-flex;\n  opacity: 0.85;\n}\n\n.org-members-mgmt__subtab-content {\n  flex: 1;\n  min-height: 8rem;\n  padding: 1rem 1.1rem;\n  border-radius: 0 8px 8px 8px;\n  background: rgba($grey, 0.55);\n  border: 1px solid rgba($medium-light-grey, 0.25);\n}\n\n.org-members-mgmt__workspace--locked .org-members-mgmt__subtab-content {\n  min-height: 4rem;\n  background: rgba($very-dark-grey, 0.25);\n}\n\n.org-members-mgmt__subtab-panel {\n  min-width: 0;\n}\n\n.org-members-mgmt__subtab-lead {\n  margin: 0 0 0.75rem;\n  font-size: 0.88rem;\n  line-height: 1.5;\n  color: rgba($very-light-grey, 0.92);\n\n  strong {\n    color: $light-blue;\n    font-weight: 700;\n  }\n}\n\n.org-members-mgmt__placeholder {\n  margin: 0;\n  font-size: 0.82rem;\n  color: rgba($light-grey, 0.9);\n}\n\n// —— Structure change requests (admin tab) ——\n\n.org-requests {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  min-width: 0;\n}\n\n.org-requests__intro {\n  margin: 0 0 0.75rem;\n  font-size: 0.85rem;\n  line-height: 1.45;\n  color: rgba($very-light-grey, 0.85);\n}\n\n.org-requests__filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.org-requests__toolbar-row {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 0.85rem;\n  flex-wrap: wrap;\n}\n\n.org-requests__course-select-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.35rem;\n  margin-left: auto;\n  min-width: 14rem;\n}\n\n.org-requests__course-select-head {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.55rem;\n  width: 100%;\n}\n\n.org-requests__course-label {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.62);\n}\n\n.org-requests__course-lock {\n  margin: 0;\n  padding: 0.2rem 0.55rem;\n  border: 1px solid rgba($medium-light-grey, 0.45);\n  border-radius: 999px;\n  background: rgba($very-dark-grey, 0.55);\n  color: rgba($very-light-grey, 0.78);\n  font-size: 0.65rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  cursor: pointer;\n\n  &--locked {\n    border-color: rgba($light-orange, 0.55);\n    background: rgba($light-orange, 0.18);\n    color: $very-light-orange;\n  }\n\n  &:not(.org-requests__course-lock--locked) {\n    border-color: rgba($light-green, 0.45);\n    background: rgba($light-green, 0.14);\n    color: $very-light-green;\n  }\n}\n\n.org-requests__course-select {\n  min-width: 16rem;\n  max-width: 22rem;\n  padding: 0.45rem 0.7rem;\n  border: 1px solid rgba($accent-blue, 0.45);\n  border-radius: 8px;\n  background: rgba($dark-grey, 0.75);\n  color: $very-light-grey;\n  font-size: 0.82rem;\n\n  &:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n  }\n}\n\n.org-requests__filter {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin: 0;\n  padding: 0.4rem 0.75rem;\n  border: 1px solid rgba($medium-light-grey, 0.45);\n  border-radius: 999px;\n  background: rgba($very-dark-grey, 0.5);\n  color: rgba($very-light-grey, 0.8);\n  font-size: 0.78rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.org-requests__filter--active {\n  border-color: rgba($light-blue, 0.55);\n  background: rgba($accent-blue, 0.35);\n  color: $very-light-grey;\n}\n\n.org-requests__filter-count {\n  min-width: 1.25rem;\n  padding: 0.05rem 0.35rem;\n  border-radius: 999px;\n  background: rgba($light-blue, 0.25);\n  font-size: 0.7rem;\n  text-align: center;\n}\n\n.org-requests__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.org-requests__list-item {\n  margin: 0;\n  padding: 0;\n}\n\n.org-requests__card {\n  padding: 1rem 1.15rem;\n  border-radius: 10px;\n  border: 1px solid rgba($medium-light-grey, 0.35);\n  background: linear-gradient(\n    160deg,\n    rgba($panel-blue, 0.95) 0%,\n    rgba($dark-panel-blue, 0.9) 100%\n  );\n  box-shadow: 0 6px 20px rgba($dark-blue-grey, 0.3);\n}\n\n.org-requests__card--pending {\n  border-color: rgba($light-blue, 0.45);\n}\n\n.org-requests__card--collapsed .org-requests__card-body {\n  display: none;\n}\n\n.org-requests__card-head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.org-requests__card--collapsed .org-requests__card-head {\n  margin-bottom: 0;\n}\n\n.org-requests__card-head--collapsible {\n  cursor: pointer;\n  user-select: none;\n}\n\n.org-requests__card-head--collapsible:hover .org-requests__card-handle {\n  color: $light-green;\n}\n\n.org-requests__card-chevron {\n  flex: 0 0 auto;\n  margin-left: auto;\n  font-size: 0.85rem;\n  color: rgba($light-grey, 0.9);\n  line-height: 1.4;\n}\n\n.org-requests__card-handle {\n  font-size: 1rem;\n  font-weight: 700;\n  color: $very-light-green;\n}\n\n.org-requests__card-moniker {\n  display: block;\n  font-size: 0.82rem;\n  color: rgba($very-light-grey, 0.8);\n}\n\n.org-requests__status {\n  padding: 0.2rem 0.55rem;\n  border-radius: 999px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.org-requests__status--pending {\n  background: rgba($light-blue, 0.22);\n  color: $light-blue;\n}\n\n.org-requests__status--approved {\n  background: rgba($light-green, 0.2);\n  color: $light-green;\n}\n\n.org-requests__status--dismissed {\n  background: rgba($light-orange, 0.2);\n  color: $light-orange;\n}\n\n.org-requests__meta {\n  margin: 0 0 0.35rem;\n  font-size: 0.78rem;\n  color: rgba($light-grey, 0.95);\n}\n\n.org-requests__resolve-note {\n  margin: 0.5rem 0 0;\n  padding: 0.55rem 0.7rem;\n  border-radius: 6px;\n  background: rgba($very-dark-grey, 0.4);\n  font-size: 0.82rem;\n  color: rgba($very-light-grey, 0.9);\n}\n\n.org-requests__resolve-note--approved {\n  border-left: 3px solid $light-green;\n}\n\n.org-requests__resolve-note--dismissed {\n  border-left: 3px solid $light-orange;\n}\n\n.org-requests__resolve-note-label {\n  display: block;\n  margin-bottom: 0.25rem;\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.org-requests__resolve-note--approved .org-requests__resolve-note-label {\n  color: $light-green;\n}\n\n.org-requests__resolve-note--dismissed .org-requests__resolve-note-label {\n  color: $light-orange;\n}\n\n.org-requests__member-note {\n  margin: 0.5rem 0 0;\n  padding: 0.55rem 0.7rem;\n  border-radius: 6px;\n  border-left: 3px solid $light-blue;\n  background: rgba($very-dark-grey, 0.4);\n  font-size: 0.82rem;\n  color: rgba($very-light-grey, 0.9);\n}\n\n.org-requests__member-note-label {\n  display: block;\n  margin-bottom: 0.25rem;\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: $light-blue;\n}\n\n.org-requests__assignment-badge {\n  flex: 0 0 auto;\n  padding: 0.2rem 0.5rem;\n  border-radius: 999px;\n  font-size: 0.65rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  background: rgba($light-orange, 0.2);\n  color: $light-orange;\n}\n\n.org-requests__assignment-warning {\n  margin: 0.5rem 0 0;\n  padding: 0.55rem 0.7rem;\n  border-radius: 6px;\n  border-left: 3px solid $light-orange;\n  background: rgba($very-dark-grey, 0.45);\n}\n\n.org-requests__assignment-warning-text {\n  margin: 0 0 0.5rem;\n  font-size: 0.8rem;\n  color: rgba($very-light-grey, 0.95);\n}\n\n.org-requests__assignment-current-label {\n  display: block;\n  margin-bottom: 0.35rem;\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: $light-orange;\n}\n\n.org-requests__assignment-current-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.org-requests__assignment-current-item {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem 0.65rem;\n  align-items: baseline;\n  font-size: 0.82rem;\n  color: rgba($very-light-grey, 0.92);\n}\n\n.org-requests__assignment-current-name {\n  font-weight: 700;\n  color: $very-light-green;\n}\n\n.org-requests__assignment-current-division {\n  color: rgba($light-grey, 0.95);\n}\n\n.org-requests__assignment-current-role {\n  font-size: 0.75rem;\n  color: rgba($light-blue, 0.95);\n}\n\n.org-requests__assignment-current-period {\n  font-size: 0.72rem;\n  color: rgba($light-grey, 0.85);\n}\n\n.org-requests__compare {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  gap: 0.75rem;\n  align-items: start;\n  margin-top: 0.85rem;\n}\n\n@media (max-width: 720px) {\n  .org-requests__compare {\n    grid-template-columns: 1fr;\n  }\n\n  .org-requests__arrow {\n    text-align: center;\n    transform: rotate(90deg);\n  }\n}\n\n.org-requests__arrow {\n  padding-top: 1.5rem;\n  font-size: 1.25rem;\n  color: $light-blue;\n}\n\n.org-requests__structure-block {\n  min-width: 0;\n  padding: 0.65rem 0.75rem;\n  border-radius: 8px;\n  background: rgba($very-dark-grey, 0.35);\n  border: 1px solid rgba($medium-light-grey, 0.25);\n}\n\n.org-requests__structure-title {\n  margin: 0 0 0.45rem;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: $light-grey;\n}\n\n.org-requests__structure-levels {\n  list-style: none;\n  margin: 0 0 0.5rem;\n  padding: 0;\n}\n\n.org-requests__level {\n  display: flex;\n  gap: 0.35rem;\n  font-size: 0.8rem;\n  line-height: 1.4;\n}\n\n.org-requests__level-key {\n  flex-shrink: 0;\n  color: rgba($light-grey, 0.9);\n  min-width: 4.5rem;\n}\n\n.org-requests__level-val {\n  color: $very-light-grey;\n  font-weight: 600;\n}\n\n.org-requests__tags {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.org-requests__tag {\n  padding: 0.15rem 0.45rem;\n  border-radius: 4px;\n  background: rgba($accent-blue, 0.35);\n  font-size: 0.72rem;\n  color: $very-light-grey;\n}\n\n.org-requests__tags-empty {\n  margin: 0;\n  font-size: 0.75rem;\n  color: rgba($light-grey, 0.85);\n}\n\n.org-requests__actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  gap: 0.5rem;\n  margin-top: 1rem;\n  padding-top: 0.85rem;\n  border-top: 1px solid rgba($medium-light-grey, 0.3);\n}\n\n.org-requests__btn {\n  margin: 0;\n  padding: 0.45rem 0.9rem;\n  border-radius: 6px;\n  border: 1px solid transparent;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.org-requests__btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.org-requests__btn--approve {\n  border-color: rgba($light-green, 0.5);\n  background: rgba($dark-green, 0.55);\n  color: $very-light-green;\n}\n\n.org-requests__btn--dismiss-toggle {\n  border-color: rgba($light-orange, 0.45);\n  background: transparent;\n  color: $light-orange;\n}\n\n.org-requests__btn--dismiss-submit {\n  border-color: rgba($light-orange, 0.55);\n  background: rgba($medium-red, 0.45);\n  color: $very-light-grey;\n}\n\n.org-requests__dismiss-form {\n  flex: 1 1 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  margin-top: 0.35rem;\n  padding: 0.75rem;\n  border-radius: 8px;\n  background: rgba($very-dark-grey, 0.45);\n  border: 1px solid rgba($light-orange, 0.25);\n}\n\n.org-requests__dismiss-label {\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: $very-light-grey;\n}\n\n.org-requests__dismiss-hint {\n  margin: 0;\n  font-size: 0.75rem;\n  color: rgba($light-grey, 0.95);\n}\n\n.org-requests__dismiss-textarea {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0.5rem 0.65rem;\n  border-radius: 6px;\n  border: 1px solid rgba($medium-light-grey, 0.5);\n  background: rgba($very-dark-grey, 0.65);\n  color: $very-light-grey;\n  font-family: inherit;\n  font-size: 0.82rem;\n  resize: vertical;\n  min-height: 4.5rem;\n}\n\n.org-requests__resolve-form {\n  flex: 1 1 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  margin-top: 0.35rem;\n  padding: 0.75rem;\n  border-radius: 8px;\n  background: rgba($very-dark-grey, 0.45);\n  border: 1px solid rgba($medium-light-grey, 0.3);\n}\n\n.org-requests__resolve-label {\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: $very-light-grey;\n}\n\n.org-requests__resolve-hint {\n  margin: 0;\n  font-size: 0.75rem;\n  color: rgba($light-grey, 0.95);\n}\n\n.org-requests__resolve-textarea {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0.5rem 0.65rem;\n  border-radius: 6px;\n  border: 1px solid rgba($medium-light-grey, 0.5);\n  background: rgba($very-dark-grey, 0.65);\n  color: $very-light-grey;\n  font-family: inherit;\n  font-size: 0.82rem;\n  resize: vertical;\n  min-height: 4.5rem;\n}\n\n.org-requests__btn--approve-toggle {\n  border-color: rgba($light-green, 0.45);\n  color: $light-green;\n}\n\n.org-requests__btn--approve-submit {\n  align-self: flex-start;\n  border-color: rgba($light-green, 0.55);\n  background: rgba($light-green, 0.12);\n  color: $light-green;\n}\n\n.org-requests__msg--error,\n.org-requests__loading,\n.org-requests__empty {\n  margin: 0;\n  font-size: 0.85rem;\n}\n\n.org-requests__msg--error {\n  color: $light-orange;\n}\n\n.org-requests__loading,\n.org-requests__empty {\n  color: rgba($light-grey, 0.9);\n}\n","@import './variables.scss';\n\n.donate-panel-admin {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  min-width: 0;\n}\n\n.donate-panel-admin__intro {\n  margin: 0;\n  font-size: 0.85rem;\n  line-height: 1.45;\n  color: rgba($very-light-grey, 0.85);\n}\n\n.donate-panel-admin__loading,\n.donate-panel-admin__hint {\n  margin: 0;\n  font-size: 0.85rem;\n  color: rgba($light-grey, 0.9);\n}\n\n.donate-panel-admin__msg {\n  margin: 0;\n  font-size: 0.85rem;\n}\n\n.donate-panel-admin__msg--error {\n  color: $light-blue;\n}\n\n.donate-panel-admin__layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1.2fr) minmax(280px, 0.8fr);\n  gap: 1.25rem;\n  align-items: start;\n}\n\n.donate-panel-admin__form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  min-width: 0;\n}\n\n.donate-panel-admin__card {\n  padding: 1rem 1.15rem;\n  border-radius: 10px;\n  border: 1px solid rgba($medium-light-grey, 0.35);\n  background: linear-gradient(\n    160deg,\n    rgba($panel-blue, 0.95) 0%,\n    rgba($dark-panel-blue, 0.9) 100%\n  );\n  box-shadow: 0 6px 20px rgba($dark-blue-grey, 0.3);\n}\n\n.donate-panel-admin__card-title {\n  margin: 0 0 0.75rem;\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: $very-light-grey;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.donate-panel-admin__textarea {\n  width: stretch;\n  min-height: 120px;\n  padding: 0.65rem 0.75rem;\n  border: 1px solid rgba($medium-light-grey, 0.45);\n  border-radius: 8px;\n  background: rgba($very-dark-grey, 0.55);\n  color: $very-light-grey;\n  font-size: 0.85rem;\n  line-height: 1.45;\n  resize: vertical;\n}\n\n.donate-panel-admin__textarea--short {\n  min-height: 72px;\n}\n\n.donate-panel-admin__banner-preview {\n  margin-bottom: 0.75rem;\n}\n\n.donate-panel-admin__banner-img {\n  display: block;\n  max-width: 100%;\n  max-height: 220px;\n  margin: 0 auto;\n  border-radius: 8px;\n}\n\n.donate-panel-admin__banner-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.donate-panel-admin__file-input {\n  display: none;\n}\n\n.donate-panel-admin__file-name {\n  font-size: 0.78rem;\n  color: rgba($light-grey, 0.95);\n}\n\n.donate-panel-admin__btn {\n  margin: 0;\n  padding: 0.45rem 0.85rem;\n  border: 1px solid rgba($medium-light-grey, 0.45);\n  border-radius: 999px;\n  background: rgba($very-dark-grey, 0.5);\n  color: rgba($very-light-grey, 0.9);\n  font-size: 0.78rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.donate-panel-admin__btn--primary {\n  border-color: rgba($light-blue, 0.55);\n  background: rgba($accent-blue, 0.35);\n}\n\n.donate-panel-admin__btn--danger {\n  border-color: rgba($light-blue, 0.45);\n  background: rgba($dark-red, 0.35);\n}\n\n.donate-panel-admin__btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.donate-panel-admin__table-wrap {\n  overflow-x: auto;\n}\n\n.donate-panel-admin__table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.82rem;\n}\n\n.donate-panel-admin__table th,\n.donate-panel-admin__table td {\n  padding: 0.45rem 0.5rem;\n  border-bottom: 1px solid rgba($medium-light-grey, 0.25);\n  vertical-align: middle;\n}\n\n.donate-panel-admin__table th {\n  color: $very-light-grey;\n  text-align: left;\n  font-weight: 700;\n}\n\n.donate-panel-admin__table-row--ghost .donate-panel-admin__input {\n  opacity: 0.75;\n}\n\n.donate-panel-admin__input {\n  width: 100%;\n  padding: 0.4rem 0.55rem;\n  border: 1px solid rgba($medium-light-grey, 0.35);\n  border-radius: 6px;\n  background: rgba($very-dark-grey, 0.45);\n  color: $very-light-grey;\n  font-size: 0.82rem;\n}\n\n.donate-panel-admin__table-actions-col {\n  width: 2rem;\n  text-align: center;\n}\n\n.donate-panel-admin__row-remove {\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: rgba($light-blue, 0.9);\n  font-size: 1.1rem;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.donate-panel-admin__save-row {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.donate-panel-admin__preview {\n  position: sticky;\n  top: 7rem;\n}\n\n.donate-panel-admin__preview-frame {\n  padding: 1rem;\n  border-radius: 10px;\n  border: 1px solid rgba($medium-light-grey, 0.35);\n  background: rgba($blue-grey, 0.95);\n}\n\n.donate-panel-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n  min-width: 0;\n}\n\n.donate-panel-content__banner {\n  text-align: center;\n}\n\n.donate-panel-content__banner-img {\n  display: block;\n  max-width: 100%;\n  max-height: 220px;\n  margin: 0 auto;\n  border-radius: 8px;\n}\n\n.donate-panel-content__intro-p {\n  margin: 0;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: $very-light-grey;\n}\n\n.donate-panel-content__table-wrap {\n  overflow-x: auto;\n}\n\n.donate-panel-content__table {\n  width: 100%;\n  border-collapse: collapse;\n  color: $very-light-grey;\n  font-size: 1rem;\n}\n\n.donate-panel-content__table th,\n.donate-panel-content__table td {\n  padding: 0.45rem 0.55rem;\n  border: 1px solid rgba($medium-light-grey, 0.25);\n  text-align: left;\n}\n\n.donate-panel-content__table th {\n  background: rgba($dark-red, 0.75);\n  color: $very-light-grey;\n  font-weight: 700;\n}\n\n.donate-panel-content__footer {\n  margin: 0;\n  font-size: 1.2rem;\n  line-height: 1.45;\n  color: $very-light-grey;\n  font-style: italic;\n}\n\n.kofi-subscriber-status {\n  padding: 0.75rem 0.85rem;\n  margin-bottom: 0.75rem;\n  border-radius: 10px;\n  border: 1px solid rgba($light-green, 0.4);\n  background: rgba($dark-panel-blue, 0.9);\n}\n\n.kofi-subscriber-status__title {\n  margin: 0 0 0.35rem;\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: $light-green;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.kofi-subscriber-status__text {\n  margin: 0 0 0.55rem;\n  font-size: 0.78rem;\n  line-height: 1.45;\n  color: rgba($very-light-grey, 0.92);\n\n  strong {\n    color: $very-light-grey;\n    font-weight: 700;\n  }\n}\n\n.kofi-subscriber-status__link {\n  display: inline-block;\n  font-size: 0.76rem;\n  font-weight: 600;\n  color: $light-blue;\n  text-decoration: underline;\n  text-underline-offset: 0.12em;\n\n  &:hover,\n  &:focus-visible {\n    color: $very-light-grey;\n  }\n}\n\n.kofi-support-overview {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.kofi-support-overview__status-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.65rem;\n}\n\n.kofi-support-overview__card,\n.kofi-support-overview__choice {\n  padding: 0.75rem 0.85rem;\n  border-radius: 10px;\n  border: 1px solid rgba($light-green, 0.35);\n  background: rgba($dark-panel-blue, 0.92);\n}\n\n.kofi-support-overview__choice {\n  border-color: rgba($light-blue, 0.35);\n}\n\n.kofi-support-overview__card-header {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  margin-bottom: 0.55rem;\n}\n\n.kofi-support-overview__change {\n  margin-left: auto;\n  border: 1px solid rgba($light-blue, 0.55);\n  border-radius: 999px;\n  padding: 0.18rem 0.65rem;\n  background: rgba($light-blue, 0.12);\n  color: $light-blue;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  cursor: pointer;\n\n  &:hover,\n  &:focus-visible {\n    background: rgba($light-blue, 0.2);\n  }\n}\n\n.kofi-support-overview__card-icon,\n.kofi-support-overview__footnote-icon {\n  display: inline-flex;\n  width: 1.1rem;\n  height: 1.1rem;\n  color: $light-green;\n}\n\n.kofi-support-overview__svg {\n  width: 100%;\n  height: 100%;\n}\n\n.kofi-support-overview__card-title,\n.kofi-support-overview__rewards-title {\n  margin: 0;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: $light-green;\n}\n\n.kofi-support-overview__rewards-title {\n  color: $light-blue;\n}\n\n.kofi-support-overview__card-line {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  margin: 0 0 0.3rem;\n  font-size: 0.78rem;\n  color: rgba($very-light-grey, 0.9);\n\n  strong {\n    color: $very-light-grey;\n  }\n}\n\n.kofi-support-overview__accent {\n  color: $light-green !important;\n}\n\n.kofi-support-overview__dot {\n  width: 0.45rem;\n  height: 0.45rem;\n  border-radius: 50%;\n  background: $light-blue;\n}\n\n.kofi-support-overview__card-empty {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  margin: 0;\n  min-height: 2.4rem;\n  font-size: 0.78rem;\n  color: rgba($very-light-grey, 0.88);\n}\n\n.kofi-support-overview__dash {\n  color: rgba($very-light-grey, 0.55);\n}\n\n.kofi-support-overview__link {\n  font-size: 0.76rem;\n  font-weight: 600;\n  color: $light-blue;\n  text-decoration: underline;\n  text-underline-offset: 0.12em;\n}\n\n.kofi-support-overview__choice-text,\n.kofi-support-overview__choice-option {\n  margin: 0 0 0.45rem;\n  font-size: 0.78rem;\n  color: rgba($very-light-grey, 0.9);\n}\n\n.kofi-support-overview__choice-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  margin-bottom: 0.55rem;\n}\n\n.kofi-support-overview__choice-option {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.kofi-support-overview__rewards-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n}\n\n.kofi-support-overview__next-reward {\n  position: relative;\n  align-self: flex-start;\n}\n\n.kofi-support-overview__next-reward-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin: 0;\n  padding: 0.38rem 0.75rem;\n  border: 1px solid rgba($light-blue, 0.45);\n  border-radius: 999px;\n  background: rgba($dark-panel-blue, 0.92);\n  color: $light-blue;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition:\n    background 0.18s ease,\n    border-color 0.18s ease,\n    color 0.18s ease;\n\n  &:hover,\n  &:focus-visible {\n    border-color: rgba($light-blue, 0.7);\n    color: $very-light-grey;\n  }\n\n  &--open {\n    border-color: rgba($light-blue, 0.8);\n    background: rgba($panel-blue, 0.75);\n    color: $very-light-grey;\n  }\n}\n\n.kofi-support-overview__next-reward-chip-icon {\n  display: inline-flex;\n  width: 0.95rem;\n  height: 0.95rem;\n  color: inherit;\n}\n\n.kofi-support-overview__next-reward-tooltip {\n  position: absolute;\n  top: calc(100% + 0.45rem);\n  left: 0;\n  z-index: 20;\n  width: #{\"min(100vw - 2rem, 22rem)\"};\n  padding: 0.75rem 0.85rem;\n  border-radius: 10px;\n  border: 1px solid rgba($light-blue, 0.35);\n  background: rgba($dark-panel-blue, 0.98);\n  box-shadow: 0 10px 28px rgba($very-dark-grey, 0.45);\n\n  .kofi-support-overview__reward {\n    grid-template-columns: 1.4rem 1fr;\n    grid-template-areas:\n      \"icon title\"\n      \"icon req\"\n      \"icon desc\";\n  }\n\n  .kofi-support-overview__perk-icon { grid-area: icon; }\n  .kofi-support-overview__reward-main { grid-area: title; }\n  .kofi-support-overview__reward-req {\n    grid-area: req;\n    text-align: left;\n  }\n  .kofi-support-overview__reward-desc { grid-area: desc; }\n}\n\n.kofi-support-overview__reward {\n  display: grid;\n  grid-template-columns: 1.6rem minmax(0, 1.15fr) minmax(0, 0.75fr) minmax(0, 1.35fr);\n  gap: 0.55rem;\n  align-items: center;\n}\n\n.kofi-support-overview__perk-icon {\n  display: inline-flex;\n  width: 1.35rem;\n  height: 1.35rem;\n  align-items: center;\n  justify-content: center;\n\n  .donor-gem-badge__gem,\n  .kofi-support-overview__svg {\n    width: 1.25rem;\n    height: 1.25rem;\n  }\n\n  &--blue { color: $light-blue; }\n  &--purple { color: $very-light-purple; }\n  &--gold { color: $donor-gold; }\n}\n\n.kofi-support-overview__reward-title {\n  margin: 0;\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: $very-light-grey;\n}\n\n.kofi-support-overview__reward-tier {\n  margin: 0.1rem 0 0;\n  font-size: 0.72rem;\n  font-weight: 600;\n\n  &--supporter { color: $light-blue; }\n  &--patron { color: $very-light-purple; }\n  &--benefactor { color: $donor-gold; }\n}\n\n.kofi-support-overview__reward-req {\n  margin: 0;\n  font-size: 0.72rem;\n  color: rgba($very-light-grey, 0.78);\n  text-align: right;\n}\n\n.kofi-support-overview__reward-desc {\n  margin: 0;\n  font-size: 0.72rem;\n  color: rgba($very-light-grey, 0.72);\n}\n\n.kofi-support-overview__footnote {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.4rem;\n  margin: 0.7rem 0 0;\n  font-size: 0.7rem;\n  line-height: 1.4;\n  color: rgba($very-light-grey, 0.65);\n}\n\n.kofi-support-overview__footnote-icon {\n  color: rgba($very-light-grey, 0.65);\n  flex: 0 0 auto;\n  margin-top: 0.1rem;\n}\n\n@media (max-width: 720px) {\n  .kofi-support-overview__status-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .kofi-support-overview__reward {\n    grid-template-columns: 1.4rem 1fr;\n    grid-template-areas:\n      \"icon title\"\n      \"icon req\"\n      \"icon desc\";\n  }\n\n  .kofi-support-overview__perk-icon { grid-area: icon; }\n  .kofi-support-overview__reward-main { grid-area: title; }\n  .kofi-support-overview__reward-req {\n    grid-area: req;\n    text-align: left;\n  }\n  .kofi-support-overview__reward-desc { grid-area: desc; }\n}\n\n.kofi-donation-link {\n  padding: 0.75rem 0.85rem;\n  margin-bottom: 0.65rem;\n  border-radius: 10px;\n  border: 1px solid rgba($light-blue, 0.35);\n  background: rgba($dark-panel-blue, 0.85);\n}\n\n.kofi-donation-link-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-bottom: 0.65rem;\n}\n\n.kofi-donation-link-stack .kofi-donation-link {\n  margin-bottom: 0;\n}\n\n.kofi-modal__themes-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin: 0 0 0.85rem;\n  border: 1px solid rgba($light-blue, 0.5);\n  border-radius: 999px;\n  padding: 0.45rem 0.85rem;\n  background: rgba($light-blue, 0.12);\n  color: $light-blue;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  cursor: pointer;\n\n  &:hover,\n  &:focus-visible {\n    background: rgba($light-blue, 0.2);\n  }\n}\n\n.kofi-donation-link__intro {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n  padding: 0.75rem 0.85rem;\n  border-radius: 10px;\n  border: 1px solid rgba($light-blue, 0.35);\n  background: rgba($dark-panel-blue, 0.85);\n}\n\n.donate-panel-member__perks-intro {\n  margin: 0 0 0.85rem;\n}\n\n.kofi-donation-link__intro-p {\n  margin: 0;\n  font-size: 0.82rem;\n  line-height: 1.45;\n  color: rgba($very-light-grey, 0.9);\n  white-space: pre-wrap;\n}\n\n.kofi-donation-link__intro-p:last-child {\n  margin-bottom: 0;\n}\n\n.kofi-donation-link--guest {\n  border-color: rgba($medium-light-grey, 0.35);\n}\n\n.kofi-donation-link__title {\n  margin: 0 0 0.35rem;\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: $light-blue;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.kofi-donation-link__text {\n  margin: 0 0 0.5rem;\n  font-size: 0.78rem;\n  line-height: 1.45;\n  color: rgba($very-light-grey, 0.88);\n}\n\n.kofi-donation-link__msg--error {\n  margin: 0;\n  font-size: 0.78rem;\n  color: $light-blue;\n}\n\n.kofi-donation-link__code-row {\n  display: grid;\n  align-items: center;\n  width: -webkit-fill-available;\n  min-height: 2rem;\n  padding: 0.35rem 0.55rem;\n  border-radius: 6px;\n  background: rgba($very-dark-grey, 0.65);\n}\n\n.kofi-donation-link__code {\n  grid-area: 1 / 1;\n  width: 100%;\n  text-align: center;\n  color: $light-green;\n  font-size: 0.85rem;\n  letter-spacing: 0.06em;\n}\n\n.kofi-donation-link__copy {\n  grid-area: 1 / 1;\n  justify-self: end;\n  margin: 0;\n  padding: 0.35rem 0.65rem;\n  border: 1px solid rgba($light-blue, 0.45);\n  border-radius: 999px;\n  background: rgba($accent-blue, 0.35);\n  color: $very-light-grey;\n  font-size: 0.75rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.kofi-donation-link__copy:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n// —— Member modal view (Ko-fi donate panel) ——\n\n.donate-panel-member {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  min-width: 0;\n}\n\n.donate-panel-member__banner {\n  position: relative;\n  overflow: hidden;\n  border-radius: 10px;\n  margin-bottom: 0.25rem;\n}\n\n.donate-panel-member__banner-img {\n  display: block;\n  width: 100%;\n  max-height: 220px;\n  object-fit: cover;\n  border-radius: 10px;\n}\n\n.donate-panel-member__intro {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  margin-bottom: 20px;\n}\n\n.donate-panel-member__banner .donate-panel-member__intro {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 0.55rem;\n  width: #{\"min(62%, 26rem)\"};\n  max-width: 100%;\n  margin: 0;\n  padding: 1rem 1.15rem;\n  text-align: left;\n}\n\n.donate-panel-member__intro-p {\n  margin: 0;\n  font-size: 0.84rem;\n  line-height: 1.55;\n  color: rgba($very-light-grey, 0.88);\n}\n\n.donate-panel-member__banner .donate-panel-member__intro-p {\n  font-size: 0.98rem;\n  font-weight: 700;\n  line-height: 1.45;\n  color: $pure-white;\n  text-shadow: 0 1px 2px rgba($very-dark-grey, 0.55);\n}\n\n.donate-panel-member__funding {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-bottom: 1.35rem;\n  padding: 0.85rem 0.95rem 0.95rem;\n  border: 1px solid rgba($medium-light-grey, 0.3);\n  border-radius: 14px;\n  background: linear-gradient(\n    145deg,\n    rgba($panel-blue, 0.55) 0%,\n    rgba($very-dark-grey, 0.42) 55%,\n    rgba($dark-panel-blue, 0.5) 100%\n  );\n  box-shadow:\n    0 8px 24px rgba($dark-blue-grey, 0.22),\n    inset 0 1px 0 rgba($very-light-grey, 0.06);\n}\n\n.donate-panel-member__funding-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  gap: 0.75rem;\n  min-width: 0;\n}\n\n.donate-panel-member__funding-tabs {\n  display: inline-flex;\n  flex-shrink: 0;\n  gap: 0.15rem;\n  padding: 0.2rem;\n  border: 1px solid rgba($medium-light-grey, 0.28);\n  border-radius: 999px;\n  background: rgba($very-dark-grey, 0.5);\n}\n\n.donate-panel-member__funding-tab {\n  margin: 0;\n  padding: 0.38rem 0.9rem;\n  border: none;\n  border-radius: 999px;\n  background: transparent;\n  font-size: 0.66rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba($light-grey, 0.88);\n  cursor: pointer;\n  transition:\n    background 0.22s ease,\n    color 0.22s ease,\n    box-shadow 0.22s ease;\n\n  &:hover {\n    color: $very-light-grey;\n  }\n\n  &.is-active {\n    background: linear-gradient(135deg, rgba($accent-blue, 0.92), rgba($light-blue, 0.78));\n    color: $very-light-grey;\n    box-shadow: 0 2px 12px rgba($light-blue, 0.28);\n  }\n}\n\n.donate-panel-member__funding-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  min-width: 0;\n}\n\n.donate-panel-member__funding-percent {\n  flex-shrink: 0;\n  padding: 0.2rem 0.55rem;\n  border-radius: 999px;\n  border: 1px solid rgba($light-blue, 0.35);\n  background: rgba($accent-blue, 0.28);\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: $light-blue;\n}\n\n.donate-panel-member__funding-track-wrap {\n  width: 100%;\n  min-width: 0;\n}\n\n.donate-panel-member__funding-bar {\n  display: block;\n  width: 100%;\n  height: 0.72rem;\n  margin: 0;\n  border: 1px solid rgba($medium-light-grey, 0.28);\n  border-radius: 999px;\n  overflow: hidden;\n  appearance: none;\n  background: rgba($very-dark-grey, 0.55);\n  box-shadow: inset 0 1px 3px rgba($dark-blue-grey, 0.35);\n\n  &::-webkit-progress-bar {\n    border-radius: 999px;\n    background: transparent;\n  }\n\n  &::-webkit-progress-value {\n    border-radius: 999px;\n    background: linear-gradient(90deg, rgba($accent-blue, 0.95), rgba($light-blue, 0.95));\n    box-shadow: 0 0 12px rgba($light-blue, 0.35);\n    transition: width 0.35s ease;\n  }\n\n  &::-moz-progress-bar {\n    border-radius: 999px;\n    background: linear-gradient(90deg, rgba($accent-blue, 0.95), rgba($light-blue, 0.95));\n    box-shadow: 0 0 12px rgba($light-blue, 0.35);\n  }\n}\n\n.donate-panel-member__funding-bar--complete {\n  border-color: rgba($light-green, 0.45);\n\n  &::-webkit-progress-value {\n    background: linear-gradient(90deg, rgba($dark-green, 0.9), rgba($light-green, 0.95));\n    box-shadow: 0 0 14px rgba($light-green, 0.35);\n  }\n\n  &::-moz-progress-bar {\n    background: linear-gradient(90deg, rgba($dark-green, 0.9), rgba($light-green, 0.95));\n    box-shadow: 0 0 14px rgba($light-green, 0.35);\n  }\n}\n\n.donate-panel-member__funding-stats {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.65rem;\n}\n\n.donate-panel-member__funding-stat {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  min-width: 0;\n}\n\n.donate-panel-member__funding-stat--target {\n  text-align: right;\n}\n\n.donate-panel-member__funding-stat-label {\n  font-size: 0.62rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgba($light-grey, 0.85);\n}\n\n.donate-panel-member__funding-stat-value {\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: $very-light-grey;\n  white-space: nowrap;\n}\n\n.donate-panel-member__funding-stat-value--raised {\n  color: $light-blue;\n}\n\n.donate-panel-member__funding--popover {\n  margin-bottom: 0;\n  border: 1px solid rgba($medium-light-grey, 0.28);\n  background: #1e3042ad;\n  box-shadow: none;\n\n  .donate-panel-member__funding-toolbar {\n    flex-wrap: nowrap;\n  }\n\n  .donate-panel-member__funding-tab {\n    padding: 0.34rem 0.72rem;\n  }\n}\n\n.donate-panel-member__section-title {\n  display: flex;\n  align-items: center;\n  gap: 0rem;\n  justify-self: start;\n  margin: 0 15px 20px;\n  font-size: 0.8rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.92);\n}\n\n.donate-panel-member__section-lines {\n  position: relative;\n  width: 45px;\n  height: 27px;\n  flex-shrink: 0;\n}\n\n.donate-panel-member__section-lines span {\n  position: absolute;\n  width: 22px;\n  height: 3px;\n  background: $light-blue;\n  transform: rotate(-65deg);\n  transform-origin: left center;\n}\n\n.donate-panel-member__section-lines span:first-child {\n  top: 20px;\n  left: 12px;\n}\n\n.donate-panel-member__section-lines span:last-child {\n  top: 20px;\n}\n\n.donate-panel-member__table-shell {\n  overflow: hidden;\n  border: 1px solid rgba($medium-light-grey, 0.28);\n  border-radius: 12px;\n  background: rgba($very-dark-grey, 0.35);\n}\n\n.donate-panel-member__table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n}\n\n.donate-panel-member__table thead th:first-child,\n.donate-panel-member__table tbody td:first-child {\n  text-align: left;\n  width: 34%;\n}\n\n.donate-panel-member__table thead th:nth-child(2),\n.donate-panel-member__table tbody td:nth-child(2) {\n  text-align: left;\n  width: 42%;\n}\n\n.donate-panel-member__table thead th:last-child,\n.donate-panel-member__table tbody td:last-child {\n  width: 24%;\n}\n\n.donate-panel-member__table thead th {\n  padding: 0.55rem 0.7rem;\n  border-bottom: 1px solid rgba($medium-light-grey, 0.22);\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  text-align: left;\n  color: $light-blue;\n}\n\n.donate-panel-member__table thead th:last-child {\n  text-align: right;\n}\n\n.donate-panel-member__table tbody td {\n  padding: 0.62rem 0.7rem;\n  border-bottom: 1px solid rgba($medium-light-grey, 0.16);\n  font-size: 0.78rem;\n  line-height: 1.35;\n  color: rgba($very-light-grey, 0.9);\n  vertical-align: middle;\n  text-align: left;\n}\n\n.donate-panel-member__table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.donate-panel-member__cost-center {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.45rem;\n  width: 100%;\n  min-width: 0;\n  text-align: left;\n}\n\n.donate-panel-member__icon {\n  display: inline-flex;\n  flex-shrink: 0;\n  width: 1.15rem;\n  height: 1.15rem;\n  color: $light-blue;\n}\n\n.donate-panel-member__icon svg {\n  width: 100%;\n  height: 100%;\n}\n\n.donate-panel-member__amount {\n  text-align: right !important;\n  font-weight: 600;\n  color: $very-light-grey;\n  white-space: nowrap;\n}\n\n.donate-panel-member__total {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  gap: 0.65rem;\n  margin-top: 20px;\n  padding: 0.7rem 0.85rem;\n  border: 1px solid rgba($medium-light-grey, 0.28);\n  border-radius: 12px;\n  background: rgba($very-dark-grey, 0.35);\n}\n\n.donate-panel-member__total-hex {\n  display: inline-flex;\n  width: 2rem;\n  height: 2rem;\n  color: $light-blue;\n}\n\n.donate-panel-member__total-hex svg {\n  width: 100%;\n  height: 100%;\n}\n\n.donate-panel-member__total-label {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.88);\n}\n\n.donate-panel-member__total-value {\n  font-size: 0.82rem;\n  color: rgba($very-light-grey, 0.85);\n  white-space: nowrap;\n}\n\n.donate-panel-member__total-value strong {\n  font-size: 1rem;\n  font-weight: 700;\n  color: $light-blue;\n}\n\n.donate-panel-member__total-suffix {\n  font-size: 0.78rem;\n  color: rgba($very-light-grey, 0.75);\n}\n\n.donate-panel-member__footer {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.45rem;\n  margin: 10px 0;\n  font-size: 1rem;\n  line-height: 1.45;\n  font-style: italic;\n  color: rgba($light-grey, 0.92);\n}\n\n.donate-panel-member__footer-star {\n  display: inline-flex;\n  flex-shrink: 0;\n  width: 1.1rem;\n  height: 1.1rem;\n  margin-top: 0.12rem;\n  color: $light-blue;\n}\n\n.donate-panel-member__footer-star svg {\n  width: 100%;\n  height: 100%;\n}\n\n.donate-panel-admin__select {\n  cursor: pointer;\n}\n\n.donate-panel-admin__drag-col {\n  width: 2rem;\n  text-align: center;\n  vertical-align: middle;\n}\n\n.donate-panel-admin__drag-handle {\n  margin: 0;\n  padding: 0.15rem 0.35rem;\n  border: none;\n  border-radius: 4px;\n  background: transparent;\n  color: rgba($light-grey, 0.95);\n  font-size: 1rem;\n  line-height: 1;\n  cursor: grab;\n  user-select: none;\n}\n\n.donate-panel-admin__drag-handle:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.donate-panel-admin__table-row--dragging {\n  position: relative;\n  z-index: 2;\n  opacity: 0.92;\n  background: rgba($very-dark-grey, 0.55);\n}\n\n.donator-perks-member {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  color: $very-light-grey;\n}\n\n.donator-perks-member__intro,\n.donator-perks-member__tier {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.donator-perks-member__tier-title {\n  margin: 0;\n  font-size: 0.82rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: $light-blue;\n}\n\n.donator-perks-member__text {\n  margin: 0;\n  font-size: 0.85rem;\n  line-height: 1.45;\n  color: rgba($very-light-grey, 0.92);\n  white-space: pre-wrap;\n}\n\n.donator-perks-member__list {\n  margin: 0.25rem 0 0;\n  padding-left: 1.1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.donator-perks-member__perk-title {\n  display: block;\n  font-size: 0.84rem;\n  color: $very-light-grey;\n}\n\n.donator-perks-member__perk-desc {\n  display: block;\n  margin-top: 0.15rem;\n  font-size: 0.78rem;\n  line-height: 1.4;\n  color: rgba($light-grey, 0.95);\n}\n\n@media (max-width: 960px) {\n  .donate-panel-admin__layout {\n    grid-template-columns: 1fr;\n  }\n\n  .donate-panel-admin__preview {\n    position: static;\n  }\n}\n\n// Ko-fi modal — portaled to document.body, above all app stacking contexts\n.kofi-modal-overlay {\n  position: fixed;\n  inset: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000000;\n}\n\n.kofi-modal-content {\n  background: $blue-grey;\n  max-width: 1050px;\n  width: 90%;\n  border-radius: 8px;\n  position: relative;\n  max-height: 90vh;\n  overflow-y: auto;\n\n  .kofi-modal-header {\n    display: flex;\n    flex-direction: row;\n    height: 35px;\n    background: linear-gradient(to top, $dark-red, #5e2f2fd3, $dark-red);\n\n    .kofi-modal-h3 {\n      margin: 0;\n      font-size: medium;\n      color: white;\n      text-transform: uppercase;\n      padding: 8px 15px;\n    }\n\n    .kofi-close-button {\n      position: relative;\n      color: white;\n      padding: 0 8px;\n      margin-left: auto;\n      margin-right: 0;\n      top: 0;\n      font-size: 20px;\n      background: transparent;\n      border: none;\n      cursor: pointer;\n    }\n  }\n\n  .kofi-modal-body {\n    display: flex;\n    flex-direction: row;\n    gap: 24px;\n    padding: 15px;\n    align-items: flex-start;\n    justify-content: space-between;\n  }\n\n  .donate-panel-modal-content {\n    flex: 1;\n    max-width: 100%;\n    overflow-wrap: break-word;\n    margin: 0;\n    padding: 0;\n  }\n\n  .donate-panel-modal-content__loading {\n    margin: 0;\n    font-size: 0.85rem;\n    color: rgba($very-light-grey, 0.85);\n  }\n\n  .kofi-widget-column {\n    flex-shrink: 0;\n    width: 400px;\n    max-width: 100%;\n    // align-self: center;\n  }\n\n  @media (max-width: 768px) {\n    .kofi-modal-body {\n      flex-direction: column;\n    }\n\n    .kofi-widget-column {\n      width: 100%;\n    }\n\n    .ko-fi-panel,\n    .ko-fi-panel-wrap {\n      width: 100%;\n    }\n  }\n}\n\n.ko-fi-panel {\n  border: none;\n  padding: 4px;\n  margin-top: 0;\n  background: transparent;\n  width: 400px;\n  height: 585px;\n  border-radius: 15px;\n}\n\n.ko-fi-panel-wrap {\n  width: 400px;\n  max-width: 100%;\n}\n\n.ko-fi-panel__loading {\n  margin: 0;\n  padding: 1.25rem 0.85rem;\n  font-size: 0.82rem;\n  color: rgba($very-light-grey, 0.78);\n}\n\n.ko-fi-panel--unavailable {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0.65rem;\n  box-sizing: border-box;\n  padding: 1.25rem 1rem;\n  border: 1px solid rgba($orange, 0.45);\n  background: rgba($dark-panel-blue, 0.92);\n}\n\n.ko-fi-panel__down-title {\n  margin: 0;\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: $orange;\n  letter-spacing: 0.02em;\n}\n\n.ko-fi-panel__down-text {\n  margin: 0;\n  font-size: 0.8rem;\n  line-height: 1.45;\n  color: rgba($very-light-grey, 0.9);\n}\n\n.ko-fi-panel__down-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.65rem;\n  margin-top: 0.25rem;\n}\n\n.ko-fi-panel__down-retry {\n  border: 1px solid rgba($light-blue, 0.5);\n  border-radius: 999px;\n  padding: 0.35rem 0.75rem;\n  background: rgba($light-blue, 0.12);\n  color: $light-blue;\n  font-size: 0.74rem;\n  font-weight: 700;\n  cursor: pointer;\n\n  &:hover,\n  &:focus-visible {\n    background: rgba($light-blue, 0.2);\n  }\n}\n\n.ko-fi-panel__down-link {\n  font-size: 0.76rem;\n  font-weight: 600;\n  color: $light-blue;\n  text-decoration: underline;\n  text-underline-offset: 0.12em;\n}\n\n.kofi-donation-link + .ko-fi-panel-wrap {\n  margin-top: 2rem;\n}\n\n.kofi-modal__themes-btn + .ko-fi-panel-wrap {\n  margin-top: 0.85rem;\n}\n\n.support-choice-popup-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 12000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.25rem;\n  background: rgba($very-dark-grey, 0.68);\n}\n\n.support-choice-popup {\n  width: #{\"min(100%, 34rem)\"};\n}\n\n.support-choice-popup__shell {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding: 1.15rem 1.2rem 1.2rem;\n  border-radius: 16px;\n  border: 1px solid rgba($light-blue, 0.28);\n  background:\n    linear-gradient(\n      160deg,\n      rgba($panel-blue, 0.96) 0%,\n      rgba($dark-panel-blue, 0.98) 55%,\n      rgba($very-dark-grey, 0.96) 100%\n    );\n  box-shadow:\n    0 20px 48px rgba($very-dark-grey, 0.5),\n    inset 0 1px 0 rgba($very-light-grey, 0.06);\n}\n\n.support-choice-popup__close {\n  position: absolute;\n  top: 0.65rem;\n  right: 0.75rem;\n  z-index: 2;\n  width: 1.8rem;\n  height: 1.8rem;\n  border: none;\n  border-radius: 999px;\n  background: rgba($very-light-grey, 0.08);\n  color: $very-light-grey;\n  font-size: 1.25rem;\n  line-height: 1;\n  cursor: pointer;\n\n  &:hover,\n  &:focus-visible {\n    background: rgba($very-light-grey, 0.16);\n  }\n}\n\n.support-choice-popup__header {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.support-choice-popup__eyebrow {\n  margin: 0;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: $light-blue;\n}\n\n.support-choice-popup__title {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 700;\n  line-height: 1.25;\n  color: $very-light-grey;\n}\n\n.support-choice-popup__lead {\n  margin: 0;\n  font-size: 0.82rem;\n  line-height: 1.5;\n  color: rgba($very-light-grey, 0.78);\n}\n\n.support-choice-popup__status-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.65rem;\n}\n\n.support-choice-popup__stat {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  min-width: 0;\n  padding: 0.75rem 0.8rem;\n  border-radius: 12px;\n  border: 1px solid rgba($light-green, 0.28);\n  background: rgba($very-dark-grey, 0.38);\n}\n\n.support-choice-popup__stat-header {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.support-choice-popup__stat-icon {\n  display: inline-flex;\n  width: 1rem;\n  height: 1rem;\n  color: $light-green;\n}\n\n.support-choice-popup__icon-svg {\n  width: 100%;\n  height: 100%;\n}\n\n.support-choice-popup__stat-title {\n  margin: 0;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: $light-green;\n}\n\n.support-choice-popup__stat-value {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: $very-light-grey;\n\n  &--muted {\n    color: rgba($very-light-grey, 0.7);\n    font-weight: 600;\n  }\n}\n\n.support-choice-popup__stat-meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 0.35rem;\n  margin: 0;\n  font-size: 0.72rem;\n  line-height: 1.35;\n  color: rgba($very-light-grey, 0.72);\n\n  strong {\n    color: $light-green;\n    font-weight: 700;\n  }\n}\n\n.support-choice-popup__choice {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding-top: 0.15rem;\n  border-top: 1px solid rgba($very-light-grey, 0.1);\n}\n\n.support-choice-popup__choice-head {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.support-choice-popup__choice-title {\n  margin: 0;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: $light-blue;\n}\n\n.support-choice-popup__choice-note {\n  margin: 0;\n  font-size: 0.76rem;\n  line-height: 1.4;\n  color: rgba($very-light-grey, 0.72);\n}\n\n.support-choice-popup__themes-btn {\n  align-self: flex-start;\n  margin-top: 0.35rem;\n  border: 1px solid rgba($light-blue, 0.5);\n  border-radius: 999px;\n  padding: 0.28rem 0.75rem;\n  background: rgba($light-blue, 0.12);\n  color: $light-blue;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  cursor: pointer;\n\n  &:hover,\n  &:focus-visible {\n    background: rgba($light-blue, 0.2);\n  }\n}\n\n.support-choice-popup__options {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.support-choice-popup__option {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.7rem;\n  margin: 0;\n  padding: 0.75rem 0.85rem;\n  border-radius: 12px;\n  border: 1px solid rgba($medium-light-grey, 0.28);\n  background: rgba($very-dark-grey, 0.32);\n  cursor: pointer;\n  transition:\n    border-color 0.18s ease,\n    background 0.18s ease,\n    box-shadow 0.18s ease;\n\n  &:hover {\n    border-color: rgba($light-blue, 0.45);\n    background: rgba($panel-blue, 0.55);\n  }\n\n  &--selected {\n    border-color: rgba($light-blue, 0.7);\n    background: rgba($panel-blue, 0.72);\n    box-shadow: inset 0 0 0 1px rgba($light-blue, 0.18);\n  }\n\n  &--locked {\n    opacity: 0.55;\n    cursor: not-allowed;\n\n    &:hover {\n      border-color: rgba($medium-light-grey, 0.28);\n      background: rgba($very-dark-grey, 0.32);\n    }\n  }\n\n  &--current {\n    border-color: rgba($light-green, 0.45);\n  }\n\n  &--blue.support-choice-popup__option--selected {\n    border-color: rgba($light-blue, 0.72);\n  }\n\n  &--purple.support-choice-popup__option--selected {\n    border-color: rgba($very-light-purple, 0.72);\n    box-shadow: inset 0 0 0 1px rgba($very-light-purple, 0.16);\n  }\n\n  &--gold.support-choice-popup__option--selected {\n    border-color: rgba($donor-gold, 0.72);\n    box-shadow: inset 0 0 0 1px rgba($donor-gold, 0.16);\n  }\n}\n\n.support-choice-popup__option-input {\n  flex: 0 0 auto;\n  margin: 0.2rem 0 0;\n  accent-color: $light-blue;\n}\n\n.support-choice-popup__option--purple .support-choice-popup__option-input {\n  accent-color: $very-light-purple;\n}\n\n.support-choice-popup__option--gold .support-choice-popup__option-input {\n  accent-color: $donor-gold;\n}\n\n.support-choice-popup__option-main {\n  display: flex;\n  flex-direction: column;\n  gap: 0.28rem;\n  min-width: 0;\n  flex: 1;\n}\n\n.support-choice-popup__option-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.support-choice-popup__option-identity {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  min-width: 0;\n}\n\n.support-choice-popup__option-gem {\n  flex: 0 0 auto;\n  width: 1.15rem;\n  height: 1.15rem;\n  color: $light-blue;\n}\n\n.support-choice-popup__option--blue .support-choice-popup__option-gem {\n  color: $light-blue;\n  filter: drop-shadow(0 0 2px rgba($light-blue, 0.45));\n}\n\n.support-choice-popup__option--purple .support-choice-popup__option-gem {\n  color: $very-light-purple;\n  filter: drop-shadow(0 0 2px rgba($very-light-purple, 0.45));\n}\n\n.support-choice-popup__option--gold .support-choice-popup__option-gem {\n  color: $donor-gold;\n  filter: drop-shadow(0 0 3px rgba($donor-gold, 0.55));\n}\n\n.support-choice-popup__option-name {\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: $very-light-grey;\n}\n\n.support-choice-popup__option--blue .support-choice-popup__option-name {\n  color: $light-blue;\n}\n\n.support-choice-popup__option--purple .support-choice-popup__option-name {\n  color: $very-light-purple;\n}\n\n.support-choice-popup__option--gold .support-choice-popup__option-name {\n  color: $donor-gold;\n}\n\n.support-choice-popup__option-duration {\n  flex: 0 0 auto;\n  max-width: 55%;\n  padding: 0.22rem 0.55rem;\n  border-radius: 999px;\n  border: 1px solid rgba($very-light-grey, 0.16);\n  background: rgba($very-dark-grey, 0.45);\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: none;\n  text-align: right;\n  line-height: 1.25;\n  color: rgba($very-light-grey, 0.9);\n  white-space: normal;\n}\n\n.support-choice-popup__option-benefits {\n  list-style: none;\n  margin: 0.15rem 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.22rem;\n}\n\n.support-choice-popup__option-benefit {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.4rem;\n  margin: 0;\n  font-size: 0.76rem;\n  line-height: 1.4;\n  color: rgba($very-light-grey, 0.8);\n}\n\n.support-choice-popup__option-check {\n  flex: 0 0 auto;\n  margin-top: 0.05rem;\n  color: $light-green;\n  font-weight: 700;\n}\n\n.support-choice-popup__option-lock {\n  margin: 0.35rem 0 0;\n  font-size: 0.72rem;\n  line-height: 1.35;\n  color: rgba($orange, 0.95);\n}\n\n.support-choice-popup__error {\n  margin: 0;\n  font-size: 0.78rem;\n  color: $red;\n}\n\n.support-choice-popup__confirm {\n  margin: 0.15rem 0 0;\n  padding: 0.7rem 1rem;\n  border: 1px solid rgba($light-blue, 0.55);\n  border-radius: 10px;\n  background: linear-gradient(\n    180deg,\n    rgba($light-blue, 0.28) 0%,\n    rgba($light-blue, 0.14) 100%\n  );\n  color: $very-light-grey;\n  font-size: 0.84rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  cursor: pointer;\n  transition:\n    background 0.18s ease,\n    border-color 0.18s ease,\n    opacity 0.18s ease;\n\n  &:hover:not(:disabled),\n  &:focus-visible:not(:disabled) {\n    border-color: rgba($light-blue, 0.85);\n    background: linear-gradient(\n      180deg,\n      rgba($light-blue, 0.38) 0%,\n      rgba($light-blue, 0.2) 100%\n    );\n  }\n\n  &:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n  }\n}\n\n@media (max-width: 560px) {\n  .support-choice-popup__status-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .support-choice-popup__option-top {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.35rem;\n  }\n}\n","@import './variables.scss';\n\n.perk-theme-media {\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: 1;\n\n  &--cover {\n    .perk-theme-media__img,\n    .perk-theme-media__video {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      object-position: center;\n    }\n  }\n\n  // Runtime video darken (images bake darken into the uploaded file)\n  &__darken {\n    position: absolute;\n    inset: 0;\n    z-index: 2;\n    pointer-events: none;\n    background: $pure-black;\n\n    @for $p from 0 through 100 {\n      &.darken-#{$p} {\n        opacity: $p / 100;\n      }\n    }\n  }\n}\n\n.profile-themes-admin {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.profile-themes-admin__header {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.profile-themes-admin__title {\n  margin: 0;\n  color: rgba($pure-white, 0.95);\n}\n\n.profile-themes-admin__hint,\n.profile-themes-admin__status {\n  margin: 0;\n  color: rgba($pure-white, 0.65);\n  font-size: 0.9rem;\n}\n\n.profile-themes-admin__error {\n  margin: 0;\n  color: $red;\n}\n\n.profile-themes-admin__layout {\n  display: grid;\n  grid-template-columns: minmax(280px, 0.95fr) minmax(360px, 1.25fr);\n  gap: 1rem;\n  align-items: start;\n}\n\n.profile-themes-admin__list,\n.profile-themes-admin__editor {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n  padding: 1rem;\n  border-radius: 12px;\n  border: 1px solid rgba($pure-white, 0.12);\n  background: rgba(12, 22, 34, 0.55);\n}\n\n.profile-themes-admin__list-toolbar,\n.profile-themes-admin__editor-head,\n.profile-themes-admin__list-actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.profile-themes-admin__subtitle {\n  margin: 0;\n  color: rgba($pure-white, 0.9);\n  font-size: 0.95rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.profile-themes-admin__cards {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.profile-themes-admin__card-wrap {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 0.35rem;\n  position: relative;\n}\n\n.profile-themes-admin__card {\n  display: grid;\n  grid-template-columns: 72px 1fr;\n  gap: 0.75rem;\n  width: 100%;\n  padding: 0.7rem;\n  border-radius: 10px;\n  border: 1px solid rgba($pure-white, 0.12);\n  background: rgba(8, 16, 26, 0.72);\n  color: $pure-white;\n  text-align: left;\n  cursor: pointer;\n}\n\n.profile-themes-admin__card.is-active {\n  border-color: rgba($light-blue, 0.8);\n  box-shadow: 0 0 0 1px rgba($light-blue, 0.35);\n}\n\n.profile-themes-admin__card-thumb {\n  width: 72px;\n  height: 48px;\n  border-radius: 8px;\n  overflow: hidden;\n  background: linear-gradient(135deg, $dark-grey, $medium-grey);\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  &--nebula {\n    background: radial-gradient(circle at 30% 40%, lighten($member-profile-donor-nebula, 12%), $member-profile-donor-nebula 70%);\n  }\n\n  &--shooting-stars,\n  &--shooting-star-premium {\n    background:\n      radial-gradient(circle at 70% 20%, rgba($pure-white, 0.55) 0 1px, transparent 2px),\n      radial-gradient(circle at 30% 40%, lighten($member-profile-donor-nebula, 8%), $member-profile-donor-nebula 72%);\n  }\n}\n\n.profile-themes-admin__card-body {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.profile-themes-admin__card-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.profile-themes-admin__card-name {\n  font-weight: 650;\n}\n\n.profile-themes-admin__card-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.profile-themes-admin__chip {\n  font-size: 0.72rem;\n  padding: 0.15rem 0.4rem;\n  border-radius: 999px;\n  background: rgba($pure-white, 0.08);\n  color: rgba($pure-white, 0.7);\n\n  &.is-default {\n    color: $donor-gold-light;\n    background: rgba($donor-gold, 0.18);\n  }\n}\n\n.profile-themes-admin__badge {\n  font-size: 0.72rem;\n  padding: 0.15rem 0.45rem;\n  border-radius: 999px;\n\n  &.is-on {\n    color: lighten($green, 28%);\n    background: rgba($green, 0.25);\n  }\n\n  &.is-off {\n    color: rgba($pure-white, 0.65);\n    background: rgba($pure-white, 0.08);\n  }\n}\n\n.profile-themes-admin__icon-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  border: 1px solid rgba($pure-white, 0.14);\n  background: rgba($pure-white, 0.05);\n  color: $pure-white;\n  cursor: pointer;\n}\n\n.profile-themes-admin__filter,\n.profile-themes-admin__card-menu {\n  position: relative;\n}\n\n.profile-themes-admin__menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  right: 0;\n  z-index: 5;\n  min-width: 180px;\n  padding: 0.4rem;\n  border-radius: 8px;\n  border: 1px solid rgba($pure-white, 0.14);\n  background: rgba(10, 18, 28, 0.98);\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n\n  button,\n  select {\n    width: 100%;\n    text-align: left;\n    border: 0;\n    background: transparent;\n    color: $pure-white;\n    padding: 0.45rem 0.55rem;\n    border-radius: 6px;\n    cursor: pointer;\n  }\n\n  button:hover {\n    background: rgba($pure-white, 0.08);\n  }\n\n  button.is-danger {\n    color: lighten($red, 18%);\n  }\n}\n\n.profile-themes-admin__menu-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  color: rgba($pure-white, 0.75);\n  font-size: 0.8rem;\n  padding: 0.35rem;\n}\n\n.profile-themes-admin__create-dashed {\n  border: 1px dashed rgba($pure-white, 0.28);\n  border-radius: 10px;\n  background: transparent;\n  color: rgba($pure-white, 0.8);\n  padding: 0.85rem;\n  cursor: pointer;\n}\n\n.profile-themes-admin__fields {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.75rem;\n}\n\n.profile-themes-admin__field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  color: rgba($pure-white, 0.8);\n  font-size: 0.85rem;\n\n  &--full {\n    grid-column: 1 / -1;\n  }\n}\n\n.profile-themes-admin__field-hint {\n  color: rgba($pure-white, 0.5);\n  font-size: 0.75rem;\n  line-height: 1.35;\n}\n\n.profile-themes-admin__overlays {\n  grid-column: 1 / -1;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  min-inline-size: 0;\n\n  legend {\n    padding: 0;\n    margin-bottom: 0.35rem;\n    color: rgba($pure-white, 0.8);\n    font-size: 0.85rem;\n  }\n}\n\n.profile-themes-admin__overlays-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.85rem;\n  margin-bottom: 0.65rem;\n  overflow: visible;\n  position: relative;\n  z-index: 5;\n}\n\n.profile-themes-admin__overlays-copy {\n  min-width: 0;\n  flex: 1;\n}\n\n.profile-themes-admin__overlays-hint {\n  margin: 0;\n  color: rgba($pure-white, 0.55);\n  font-size: 0.78rem;\n  line-height: 1.35;\n}\n\n.profile-themes-admin__halo-color {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  position: relative;\n  z-index: 6;\n  overflow: visible;\n\n  .color-picker-container {\n    position: relative;\n    margin: 0;\n    flex-direction: column !important;\n    align-items: flex-end;\n  }\n\n  .color-picker-tooltip {\n    position: absolute;\n    top: calc(100% + 6px);\n    right: 0;\n    left: auto;\n    transform: none;\n    z-index: 10050;\n  }\n\n  .color-picker-wrapper {\n    position: relative;\n    transform: none;\n    right: 0;\n  }\n}\n\n.profile-themes-admin__halo-color-label {\n  color: rgba($pure-white, 0.7);\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n}\n\n.profile-themes-admin__fx-params--halo {\n  overflow: visible;\n}\n\n.profile-themes-admin__fx-tabs {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.profile-themes-admin__fx-tablist {\n  display: flex;\n  gap: 0.35rem;\n  padding: 0.2rem;\n  border-radius: 10px;\n  border: 1px solid rgba($pure-white, 0.1);\n  background: rgba(8, 16, 26, 0.45);\n}\n\n.profile-themes-admin__fx-tab {\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  background: transparent;\n  color: rgba($pure-white, 0.7);\n  padding: 0.45rem 0.55rem;\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n\n  &.is-active {\n    border-color: rgba($light-blue, 0.7);\n    background: rgba($light-blue, 0.14);\n    color: rgba($pure-white, 0.95);\n  }\n}\n\n.profile-themes-admin__fx-tab-count {\n  min-width: 1.15rem;\n  padding: 0.05rem 0.35rem;\n  border-radius: 999px;\n  background: rgba($accent-blue, 0.28);\n  color: rgba($pure-white, 0.9);\n  font-size: 0.68rem;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  line-height: 1.2;\n}\n\n.profile-themes-admin__fx-panel {\n  min-width: 0;\n}\n\n.profile-themes-admin__fx-empty {\n  margin: 0;\n  padding: 0.85rem 0.9rem;\n  border-radius: 10px;\n  border: 1px dashed rgba($pure-white, 0.14);\n  background: rgba(8, 16, 26, 0.28);\n  color: rgba($pure-white, 0.5);\n  font-size: 0.8rem;\n  line-height: 1.4;\n}\n\n.profile-themes-admin__fx-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n}\n\n.profile-themes-admin__fx-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  padding: 0.7rem 0.8rem;\n  border-radius: 10px;\n  border: 1px solid rgba($pure-white, 0.1);\n  background: rgba(8, 16, 26, 0.4);\n  transition: border-color 0.15s ease, background 0.15s ease;\n\n  &.is-active {\n    border-color: rgba($accent-blue, 0.35);\n    background: rgba($accent-blue, 0.08);\n  }\n\n  &.is-disabled {\n    opacity: 0.55;\n  }\n}\n\n.profile-themes-admin__fx-card-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.profile-themes-admin__fx-card-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  min-width: 0;\n}\n\n.profile-themes-admin__fx-card-title {\n  color: rgba($pure-white, 0.92);\n  font-size: 0.88rem;\n  font-weight: 600;\n}\n\n.profile-themes-admin__fx-card-note {\n  color: rgba($pure-white, 0.45);\n  font-size: 0.72rem;\n  line-height: 1.3;\n}\n\n.profile-themes-admin__fx-toggle {\n  flex-shrink: 0;\n}\n\n.profile-themes-admin__fx-params {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  padding-top: 0.15rem;\n}\n\n.profile-themes-admin__hslider {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n\n  &.is-locked {\n    opacity: 0.55;\n  }\n}\n\n.profile-themes-admin__hslider-meta {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.75rem;\n  color: rgba($pure-white, 0.72);\n  font-size: 0.75rem;\n}\n\n.profile-themes-admin__hslider-value {\n  font-variant-numeric: tabular-nums;\n  color: rgba($pure-white, 0.5);\n  font-size: 0.72rem;\n}\n\n.profile-themes-admin__hslider-input {\n  width: 100%;\n  height: 1.1rem;\n  margin: 0;\n  padding: 0;\n  background: transparent;\n  cursor: pointer;\n  accent-color: $accent-blue;\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.profile-themes-admin__input,\n.profile-themes-admin__textarea,\n.profile-themes-admin__select {\n  width: 100%;\n  box-sizing: border-box;\n  border-radius: 6px;\n  border: 1px solid rgba($pure-white, 0.18);\n  background: rgba($pure-white, 0.95);\n  color: $dark-grey;\n  padding: 0.45rem 0.55rem;\n}\n\n.profile-themes-admin__check,\n.profile-themes-admin__switch {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: rgba($pure-white, 0.85);\n  font-size: 0.9rem;\n}\n\n.profile-themes-admin__order {\n  display: flex;\n  align-items: flex-end;\n  gap: 1rem;\n}\n\n.profile-themes-admin__save {\n  width: 100%;\n}\n\n.profile-themes-admin__media-tabs {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.profile-themes-admin__media-tablist {\n  display: flex;\n  gap: 0.35rem;\n  padding: 0.2rem;\n  border-radius: 10px;\n  border: 1px solid rgba($pure-white, 0.1);\n  background: rgba(8, 16, 26, 0.45);\n}\n\n.profile-themes-admin__media-tab {\n  flex: 1;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  background: transparent;\n  color: rgba($pure-white, 0.7);\n  padding: 0.45rem 0.7rem;\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n\n  &.is-active {\n    border-color: rgba($light-blue, 0.7);\n    background: rgba($light-blue, 0.14);\n    color: rgba($pure-white, 0.95);\n  }\n}\n\n.profile-themes-admin__media-panel {\n  min-width: 0;\n}\n\n.profile-themes-media-slot {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  padding: 0.85rem;\n  border-radius: 10px;\n  border: 1px solid rgba($pure-white, 0.1);\n  background: rgba(8, 16, 26, 0.45);\n}\n\n.profile-themes-media-slot__head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.profile-themes-media-slot__title {\n  margin: 0;\n  color: rgba($pure-white, 0.92);\n}\n\n.profile-themes-media-slot__ratio {\n  font-size: 0.75rem;\n  color: rgba($pure-white, 0.55);\n}\n\n.profile-themes-media-slot__kinds {\n  display: flex;\n  gap: 0.35rem;\n}\n\n.profile-themes-media-slot__kind {\n  border-radius: 999px;\n  border: 1px solid rgba($pure-white, 0.16);\n  background: transparent;\n  color: rgba($pure-white, 0.8);\n  padding: 0.3rem 0.7rem;\n  cursor: pointer;\n\n  &.is-active {\n    border-color: rgba($light-blue, 0.75);\n    background: rgba($light-blue, 0.15);\n  }\n}\n\n.profile-themes-media-slot__dropzone {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  border-radius: 8px;\n  border: 1px dashed rgba($pure-white, 0.25);\n  background: rgba($grey, 0.55);\n  cursor: grab;\n  user-select: none;\n\n  &--banner {\n    aspect-ratio: 977 / 150;\n  }\n\n  &--card {\n    aspect-ratio: 1 / 1;\n    max-width: 280px;\n  }\n\n  &.is-dragging,\n  &.is-editing {\n    border-color: rgba($light-blue, 0.55);\n  }\n\n  &.is-disabled {\n    cursor: default;\n    opacity: 0.7;\n  }\n}\n\n.profile-themes-media-slot__crop-img {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: auto;\n  max-width: none;\n  object-fit: cover;\n  transform-origin: top left;\n  user-select: none;\n  cursor: grab;\n  pointer-events: auto;\n\n  &.is-dragging {\n    cursor: grabbing;\n  }\n\n  @for $x from -1500 through 50 {\n    &.translate-x-#{$x} {\n      --translate-x: #{$x}px;\n    }\n  }\n\n  @for $y from -800 through 50 {\n    &.translate-y-#{$y} {\n      --translate-y: #{$y}px;\n    }\n  }\n\n  @for $z from 50 through 300 {\n    $scale: $z / 100;\n    &.scale-#{$z} {\n      --scale: #{$scale};\n    }\n  }\n\n  transform: translateX(var(--translate-x, 0px)) translateY(var(--translate-y, 0px)) scale(var(--scale, 1));\n}\n\n.profile-themes-media-slot__darken {\n  position: absolute;\n  inset: 0;\n  z-index: 2;\n  pointer-events: none;\n  background: $pure-black;\n\n  @for $p from 0 through 100 {\n    &.darken-#{$p} {\n      opacity: $p / 100;\n    }\n  }\n}\n\n.profile-themes-media-slot__hint {\n  margin: 0;\n  padding: 1.2rem;\n  text-align: center;\n  color: rgba($pure-white, 0.65);\n}\n\n.profile-themes-media-slot__tools {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 0.75rem;\n}\n\n.profile-themes-media-slot__zoom {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  color: rgba($pure-white, 0.75);\n  font-size: 0.8rem;\n  flex: 1;\n  min-width: 140px;\n}\n\n.profile-themes-media-slot__file {\n  display: none;\n}\n\n.profile-themes-media-slot__video-preview {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16 / 5;\n  border-radius: 8px;\n  overflow: hidden;\n  background: $dark-grey;\n}\n\n.profile-themes-media-slot__status {\n  margin: 0;\n  color: rgba($light-blue, 0.9);\n  font-size: 0.85rem;\n}\n\n.profile-themes-media-slot__error {\n  margin: 0;\n  color: $red;\n  font-size: 0.85rem;\n}\n\n.profile-themes-preview {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  padding: 0.85rem;\n  border-radius: 10px;\n  border: 1px solid rgba($pure-white, 0.1);\n  background: rgba(8, 16, 26, 0.45);\n}\n\n.profile-themes-preview__title {\n  margin: 0;\n  color: rgba($pure-white, 0.92);\n}\n\n.profile-themes-preview__hint {\n  margin: 0;\n  color: rgba($pure-white, 0.6);\n  font-size: 0.85rem;\n}\n\n.profile-themes-preview__stack {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.profile-themes-preview__stack--row {\n  display: grid;\n  grid-template-columns: minmax(220px, 280px) minmax(0, 1fr);\n  gap: 1rem;\n  align-items: start;\n\n  .profile-themes-preview__card-wrap {\n    order: 1;\n  }\n\n  .profile-themes-preview__roster {\n    order: 2;\n  }\n}\n\n@media (max-width: $tablet) {\n  .profile-themes-preview__stack--row {\n    grid-template-columns: 1fr;\n  }\n}\n\n.profile-themes-preview__label {\n  display: block;\n  margin-bottom: 0.35rem;\n  font-size: 0.75rem;\n  color: rgba($pure-white, 0.55);\n  text-transform: uppercase;\n}\n\n// Shell wrappers — do not restyle donor nebula / stars (owned by roster + profile-card SCSS)\n.profile-themes-preview__roster-shell {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 977 / 150;\n  min-height: 0;\n  overflow: hidden;\n  border-radius: 10px;\n}\n\n.profile-themes-preview__roster-shell .roster-file-summary-hero__banner {\n  position: absolute;\n  inset: 0;\n}\n\n.profile-themes-preview__roster-fg {\n  position: relative;\n  z-index: 3;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  height: 100%;\n  padding: 0.65rem 0.85rem;\n  box-sizing: border-box;\n  pointer-events: none;\n}\n\n.profile-themes-preview__card-shell {\n  position: relative;\n  width: 100%;\n  max-width: 280px;\n  min-height: 160px;\n}\n\n.profile-themes-preview__card-shell .member-profile-card {\n  position: relative;\n  z-index: 2;\n}\n\n.profile-themes-preview__identity-text {\n  min-width: 0;\n}\n\n.profile-themes-preview__name {\n  font-weight: 650;\n  color: $pure-white;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.profile-themes-preview__handle,\n.profile-themes-preview__moniker,\n.profile-themes-preview__assignment {\n  font-size: 0.8rem;\n  color: rgba($pure-white, 0.65);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.profile-themes-preview__roster-meta {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  margin-top: 0.2rem;\n  min-width: 0;\n}\n\n.profile-themes-preview__rank-img {\n  width: 28px;\n  height: 28px;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n.profile-themes-preview__rank-name {\n  font-size: 0.78rem;\n  color: rgba($pure-white, 0.85);\n}\n\n.profile-themes-preview__status,\n.profile-themes-preview__error {\n  margin: 0;\n  font-size: 0.85rem;\n}\n\n.profile-themes-preview__status {\n  color: rgba($pure-white, 0.65);\n}\n\n.profile-themes-preview__error {\n  color: $red;\n}\n","// src/styles/academy.scss\n\n@import './variables.scss';\n\n//-------------------//\n//   Admin Academy   //\n//-------------------//\n\n.theme-and-level {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    \n    .themes-block {\n        width: 50%;\n    }\n\n    .training-levels-block {\n        width: 50%;\n    }\n}\n\n.create-module-modal {\n    .modal-dialog {\n        margin: auto;\n        width: 1080px;\n    }\n\n    .modal-content {\n        background-color: $panel-blue;\n        width: 1100px;\n        height: 85%;\n        margin-top: 120px;\n        border: 1px solid $dark-red;\n    }\n\n    .modal-header {\n        color: $very-light-grey;\n\n        .modal-title {\n            font-size: 1.5rem;\n            color: $very-light-grey;\n        }\n\n        .btn-close {\n            color: $very-light-grey;\n\n            &:hover,\n            &:focus {\n                color: $very-dark-grey;\n            }\n        }\n    }\n\n    .modal-body {\n        padding: 20px;\n\n        .form-control {\n            position: relative;\n            border-width: 0px;\n            width: -webkit-fill-available;\n            height: 16px;\n            padding: 3px 5px;\n            border-radius: 4px;\n            color: $very-dark-grey;\n        }\n\n        .calendar-template-input,\n        .calendar-template-dropdown {\n            &.form-control {\n                width: 232px;\n                padding: 2px;\n            }\n        }\n\n        .modal-footer {\n            display: flex;\n            justify-content: flex-start;\n        }\n    }\n}\n\n// --- Save modal --- //\n// ------------------ //\n\n// --- Save modal --- //\n// ------------------ //\n\n.modal-content.mcq-excel-import-error-modal {\n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: linear-gradient(to top, $dark-red, #5e2f2fd3, $dark-red);\n    padding: 5px 0 5px 10px;\n    color: $very-light-grey;\n    font-weight: bold;\n    text-transform: uppercase;\n    border-bottom: 3px solid $light-grey;\n    border-radius: 8px 8px 0 0;\n  }\n\n  .mcq-excel-import-error-modal__title {\n    margin: 0;\n    font-size: small;\n  }\n\n  .icon {\n    display: flex;\n    height: 18px;\n    overflow: hidden;\n    margin-left: auto;\n    margin-right: 0;\n\n    .close-event-button {\n      position: relative;\n      height: 40px;\n      margin-right: 10px;\n      object-fit: contain;\n      overflow: hidden;\n      cursor: pointer;\n\n      &:hover {\n        top: -21px;\n      }\n    }\n  }\n\n  .mcq-excel-import-error-modal__content {\n    padding: 15px;\n    background: $blue-grey;\n  }\n\n  .mcq-excel-import-error-modal__hint {\n    margin: 0 0 12px;\n    color: $light-grey;\n    font-size: 0.9rem;\n  }\n\n  .mcq-excel-import-error-modal__log {\n    width: 100%;\n    min-height: 280px;\n    margin: 0 0 14px;\n    padding: 12px;\n    border: 1px solid $medium-grey;\n    border-radius: 8px;\n    background: $very-dark-grey;\n    color: $very-light-grey;\n    font-family: Consolas, \"Courier New\", monospace;\n    font-size: 0.82rem;\n    line-height: 1.45;\n    resize: vertical;\n    white-space: pre-wrap;\n    word-break: break-word;\n    @include scrollbar-styles;\n  }\n\n  .mcq-excel-import-error-modal__actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    justify-content: flex-end;\n  }\n}\n\n.modal-content.mcq-save-modal {\n  //margin: auto;\n\n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: linear-gradient(to top, $dark-red, #5e2f2fd3, $dark-red );\n    padding: 5px 0px 5px 10px;\n    color: $very-light-grey;\n    font-size: medium;\n    font-weight: bold;\n    text-transform: uppercase;\n    border-bottom: 3px solid $light-grey;\n    border-radius: 8px 8px 0px 0px;\n\n    .mcq-save-modal-h3 {\n      margin: 0;\n      font-size: small;\n    }\n\n    .icon {\n        display: flex;\n        height: 18px;\n        overflow: hidden;\n        margin-left: auto;\n        margin-right: 0;\n\n        .close-event-button {\n          position: relative;\n          height: 40px;\n          margin-right: 10px;\n          object-fit: contain;\n          overflow: hidden;\n          cursor: pointer;\n\n        &:hover {\n            top: -21px;\n        }\n      }\n    }\n  }\n\n  .content {\n    padding: 15px;\n    width: auto;\n    background: $blue-grey;\n    align-content: center;\n\n    .mcq-save-mode-toggle {\n      display: flex;\n      justify-content: center;\n      gap: 10px;\n      position: relative;\n      margin: 5px;\n    }\n\n    .mcq-save-live-section {\n      position: relative;\n\n\n      .version-description {\n        width: 430px;\n        text-align: justify;\n        padding: 10px 0;\n      }\n\n      .mcq-save-modal-button {\n        position: relative;\n        display: flex;\n        margin: auto;\n      }\n\n      .mcq-save-progress {\n        margin: 0.85rem 0 1rem;\n        display: grid;\n        gap: 0.4rem;\n      }\n\n      .mcq-save-progress__label {\n        font-size: 0.82rem;\n        color: $very-light-grey;\n      }\n\n      .mcq-save-progress__bar {\n        width: 100%;\n        height: 0.65rem;\n        border: none;\n        border-radius: 999px;\n        overflow: hidden;\n        background: rgba($dark-blue-grey, 0.65);\n\n        &::-webkit-progress-bar {\n          background: rgba($dark-blue-grey, 0.65);\n          border-radius: 999px;\n        }\n\n        &::-webkit-progress-value {\n          background: linear-gradient(to right, $accent-blue, $light-blue);\n          border-radius: 999px;\n        }\n\n        &::-moz-progress-bar {\n          background: linear-gradient(to right, $accent-blue, $light-blue);\n          border-radius: 999px;\n        }\n      }\n    }\n\n    .mcq-save-review-section, \n    .mcq-save-live-section {\n      .mcq-save-description {\n        width: 430px;\n        text-align: justify;\n        padding: 10px 0;\n      }\n\n      .mcq-save-fieldset {\n        display: flex;\n        justify-content: center;\n        gap: 10px;\n      }\n    }\n  }\n}\n\n.modal.create-module {\n    display: contents;\n    flex-direction: column;\n    position: relative;\n    background-color: $grey;\n    padding: 0;\n    border-radius: 8px;\n    overflow-y: auto;\n    @include scrollbar-styles;\n\n    .header.create-module {\n        font-size: small;\n        margin: 0px;\n        @include modal-header(\"../medias/steel.png\");\n\n        .icon {\n            display: flex;\n            height: 18px;\n            overflow: hidden;\n            margin-left: auto;\n            margin-right: 10px;\n\n            .close-modal-button {\n                position: relative;\n                height: 40px;\n                object-fit: contain;\n                overflow: hidden;\n                cursor: pointer;\n\n                &:hover {\n                    top: -21px;\n                }\n            }\n        }\n    }\n\n    .admin-block-container, \n    .create-module {\n        margin: 10px 10px;\n\n        &.information-block {\n            max-width: 100%;\n            min-height: 183px;\n        }\n\n        &.training-reference-block {\n          display: flex;\n          flex-direction: column;\n          max-width: 100%;\n          min-height: fit-content;\n\n          .selecting-training-reference {\n            display: flex;\n            gap: 20px;\n            flex-direction: row;\n          }\n\n          .training-reference-table {\n            max-height: 300px;\n            overflow-y: auto;\n            @include scrollbar-styles;\n          }\n        }\n\n        .lexical-public-html {\n            max-height: calc(60vh - 140px);\n            overflow-y: auto;\n            @include scrollbar-styles;\n        }\n\n        .input-field {\n            margin-bottom: 10px;\n\n            .home-file {\n                color: $very-light-grey;\n                font-size: 0.9rem;\n                margin-bottom: 3px;\n            }\n\n            .form-control,\n            .theme-select,\n            .level-select {\n                height: auto;\n                width: 100%;\n                background-color: $very-light-grey;\n                border-radius: 4px;\n            }\n        }\n    }\n\n    .footer.create-module {\n        display: flex;\n        margin-top: 10px;\n        margin-left: 20px;\n        margin-bottom: 10px;\n    }\n\n    .lexical-document-footer {\n        margin-left: 20px;\n        margin-top: 15px;\n\n        .btn-style1 {\n            margin-top: 10px;\n        }\n    }\n}\n\n.admin-block-container,\n.create-mcq {\n  margin: 10px 0px;\n}\n\n.module-view-toggle {\n  display: flex;\n  justify-content: center;\n  margin: 20px 0;\n\n  .btn-toggle {\n    border: 1px solid #555;\n    background: #f5f5f5;\n    color: #333;\n    padding: 6px 16px;\n    margin: 0 4px;\n    border-radius: 4px;\n    cursor: pointer;\n\n    &.active {\n      background: #222;\n      color: #fff;\n      font-weight: bold;\n    }\n  }\n}\n\n//-------------------//\n//   Admin Academy   //\n//   Question tool   //\n//-------------------//\n\n.module-questions {\n  display: flex;\n  flex-direction: column;\n  width: -webkit-fill-available;\n  margin: 0 auto;\n  gap: 0.75rem;\n\n  .mqc-toolbar {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1rem;\n    padding: 8px 12px;\n    background: $dark-panel-blue;\n    border: 1px solid $dark-red;\n    border-radius: 8px;\n  }\n\n  .mqc-toolbar__meta {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 0.65rem;\n    min-width: 0;\n  }\n\n  .mqc-toolbar__title {\n    margin: 0;\n    font-size: 0.8rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: $very-light-grey;\n  }\n\n  .mqc-toolbar__count {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 1.5rem;\n    height: 1.35rem;\n    padding: 0 0.45rem;\n    border-radius: 999px;\n    background: $grey;\n    border: 1px solid $medium-grey;\n    color: $light-grey;\n    font-size: 0.75rem;\n    font-weight: 700;\n  }\n\n  .mqc-toolbar__badge {\n    padding: 0.2rem 0.55rem;\n    border-radius: 999px;\n    border: 1px solid $orange;\n    color: $orange;\n    font-size: 0.68rem;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n  }\n\n  .mqc-toolbar__actions {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 0.5rem;\n    flex-shrink: 0;\n    margin-left: auto;\n  }\n\n  .mqc-toolbar__add,\n  .mqc-toolbar__import,\n  .mqc-toolbar__export {\n    flex-shrink: 0;\n  }\n\n  .mqc-content {\n    display: flex;\n    flex-direction: column;\n    gap: 0.65rem;\n    position: relative;\n    background: $dark-panel-blue;\n    min-height: 140px;\n    max-height: calc(100vh - 510px);\n    border: 1px solid $dark-red;\n    border-radius: 8px;\n    padding: 12px;\n    overflow-y: auto;\n    margin-bottom: 12px;\n    @include scrollbar-styles;\n  }\n\n  .mqc-empty {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 110px;\n    padding: 1rem;\n    border: 1px dashed $medium-grey;\n    border-radius: 8px;\n    background: rgba($very-dark-grey, 0.45);\n  }\n\n  .mqc-loading-more {\n    display: flex;\n    justify-content: center;\n    padding: 0.75rem 0.5rem 0.25rem;\n  }\n\n  .mqc-loading-more__text {\n    margin: 0;\n    font-size: 0.8rem;\n    color: rgba($very-light-grey, 0.85);\n  }\n\n  .mqc-empty__text {\n    margin: 0;\n    text-align: center;\n    color: $light-grey;\n    font-size: 0.9rem;\n    font-style: italic;\n  }\n\n  .sortable-question {\n    transition: transform 0.2s ease;\n  }\n\n  .question-accordion {\n    background: $dark-grey;\n    border-radius: 8px;\n    border: 1px solid $medium-grey;\n    overflow: hidden;\n    transition: border-color 0.22s ease, box-shadow 0.22s ease;\n\n    &.is-open {\n      border-color: $blue;\n      box-shadow: 0 4px 14px rgba(0, 0, 0, 0.22);\n\n      .question-header-line {\n        border-bottom-color: rgba($blue, 0.45);\n      }\n    }\n\n    &.is-readonly {\n      opacity: 0.92;\n    }\n  }\n\n  .question-accordion-panel__inner {\n    animation: mqcAccordionIn 0.28s ease-out;\n  }\n\n  .question-body {\n    padding: 1rem 1.2rem;\n    backdrop-filter: blur(6px) saturate(33%);\n    -webkit-backdrop-filter: blur(4px) saturate(33%);\n    background-color: $blue-grey;\n    animation: fadeIn 0.6s ease-out;\n  }\n}\n\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes mqcAccordionIn {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n// -------------------- //\n\n// -------------------- //\n\n// -------------------- //\n// ---- MCQ EDITOR ---- //\n// -------------------- //\n\n.module-questions {\n  .question-editor {\n    display: flex;\n    flex-direction: column;\n    background: transparent;\n    border-radius: 0;\n    overflow: hidden;\n    gap: 0;\n\n    .input-field {\n      display: flex;\n      flex-direction: column;\n      gap: 0.4rem;\n      margin-left: 20px;\n      margin-right: auto;\n\n      &.question {\n        margin-right: 15px;\n      }\n\n      .form-control {\n        min-height: fit-content;\n        width: fit-content;\n\n        &.question {\n          width: 100%;\n        }\n      }\n\n      label {\n        font-size: 0.9rem;\n        font-weight: 500;\n        color: $light-grey;\n      }\n\n      input,\n      select {\n        border: 1px solid #ccc;\n        border-radius: 4px;\n        padding: 0.45rem 0.6rem;\n        font-size: 0.9rem;\n        width: 100%;\n        background: #fff;\n\n        &:focus {\n          outline: none;\n          border-color: #888;\n        }\n      }\n    }\n\n    .question-answers-zone {\n      padding: 10px;\n    }\n\n    .question-topic-field {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      gap: 0.35rem;\n      padding: 10px 12px 0;\n    }\n\n    .question-topic-label {\n      font-size: 0.78rem;\n      font-weight: 600;\n      letter-spacing: 0.04em;\n      text-transform: uppercase;\n      color: $light-grey;\n    }\n\n    .question-topic-input {\n      width: 100%;\n      border: 1px solid $medium-grey;\n      border-radius: 6px;\n      padding: 0.45rem 0.6rem;\n      font-size: 0.9rem;\n      background: $very-light-grey;\n      color: $very-dark-grey;\n\n      &.locked {\n        background: #bbc0c4;\n        color: #6a6f72;\n        cursor: not-allowed;\n      }\n\n      &:focus {\n        outline: none;\n        border-color: $light-grey;\n      }\n    }\n\n    .question-eval-footer {\n      padding: 10px 12px 12px;\n      border-top: 1px solid rgba($medium-grey, 0.55);\n      background: rgba($very-dark-grey, 0.35);\n    }\n\n    .question-title-input {\n      resize: none;\n      overflow: hidden;\n      width: 100%;\n      min-height: 28px;\n      max-height: 160px;\n      line-height: 20px;\n      padding: 3px 10px;\n      box-sizing: border-box;\n      border-radius: 6px;\n      font-size: 0.9rem;\n\n      &.locked {\n        background: #bbc0c4;\n        color: #6a6f72;\n        cursor: not-allowed;\n        opacity: 1;\n      }\n    }\n\n    > .question-header-line {\n      position: relative;\n      display: grid;\n      grid-template-columns: 28px 1fr auto 32px;\n      column-gap: 8px;\n      align-items: center;\n      margin: 0;\n      padding: 28px 10px 10px;\n      background: linear-gradient(180deg, $medium-grey 0%, $dark-grey 100%);\n      border-bottom: 1px solid transparent;\n      transition: border-bottom-color 0.22s ease;\n    }\n\n    .question-accordion-toggle {\n      position: relative;\n      z-index: 2;\n      width: 24px;\n      height: 24px;\n      margin: 0;\n      padding: 0;\n      bottom: 2px;\n      border: 1px solid $medium-grey;\n      border-radius: 6px;\n      background: $grey;\n      color: $light-grey;\n      cursor: pointer;\n      transition: transform 0.22s ease, border-color 0.22s ease, color 0.22s ease;\n\n      &::before {\n        content: \"\";\n        display: block;\n        width: 7px;\n        height: 7px;\n        margin: 0 auto;\n        border-right: 2px solid currentColor;\n        border-bottom: 2px solid currentColor;\n        transform: rotate(45deg) translate(-1px, -2px);\n        transition: transform 0.22s ease;\n      }\n\n      &.is-open::before {\n        transform: rotate(-135deg) translate(-1px, 1px);\n      }\n\n      &:hover {\n        border-color: $medium-light-grey;\n        color: $very-light-grey;\n      }\n    }\n\n    .question-toggle-zone {\n      position: absolute;\n      inset: 0;\n      z-index: 1;\n    }\n\n    .question-zone,\n    .question-meta-zone,\n    .q-close {\n      position: relative;\n      z-index: 2;\n    }\n\n    > .question-header-line > .question-zone {\n      width: 100%;\n      margin: 0;\n      min-width: 0;\n    }\n\n    /* English comment: create right inset so native arrow doesn't look glued to border */\n    > .question-header-line > .question-meta-zone {\n      display: flex;\n      width: auto;\n      max-width: 420px;\n      align-self: center;\n      justify-self: end;\n      margin: 0;\n      padding-right: 0;\n      border-radius: 6px;\n      box-sizing: border-box;\n      gap: 10px;\n      align-items: center;\n    }\n\n    .question-weight-field {\n      display: flex;\n      flex-direction: column;\n      gap: 2px;\n      min-width: 4.5rem;\n    }\n\n    .question-weight-label {\n      font-size: 0.62rem;\n      font-weight: 700;\n      letter-spacing: 0.05em;\n      text-transform: uppercase;\n      color: rgba($very-light-grey, 0.58);\n      line-height: 1;\n    }\n\n    .question-weight-input {\n      width: 4.5rem;\n      min-width: 4.5rem;\n      text-align: center;\n    }\n\n    > .question-header-line input,\n    > .question-header-line select {\n      border-radius: 6px;\n      width: 100%;\n      height: 28px;\n      min-height: 28px;\n      box-sizing: border-box;\n      padding: 3px 6px;\n      font-size: 0.9rem;\n    }\n\n    > .question-header-line select {\n      line-height: 22px;\n    }\n\n  }\n}\n\n.question-sort-wrapper {\n  position: relative;\n}\n\n.question-drag-handle {\n  position: absolute;\n  top: 0;\n  justify-content: center;\n  margin-top: 7px;\n  width: -webkit-fill-available;\n  height: 15px;\n  cursor: grab;\n  display: flex;\n  align-items: center;\n  z-index: 2;\n}\n\n.question-drag-handle::before {\n  content: \"\";\n  width: 15px;\n  height: 15px;\n  background:\n    radial-gradient(circle at 2px 2px, $very-light-grey 1px, transparent 2px),\n    radial-gradient(circle at 12px 2px, $very-light-grey 1px, transparent 2px),\n    radial-gradient(circle at 2px 10px, $very-light-grey  1px, transparent 2px),\n    radial-gradient(circle at 12px 10px, $very-light-grey 1px, transparent 2px),\n    radial-gradient(circle at 7px 2px, $very-light-grey  1px, transparent 2px),\n    radial-gradient(circle at 7px 10px, $very-light-grey  1px, transparent 2px);\n  background-repeat: no-repeat;\n}\n\n\n.mcq-invalid {\n  border: 2px solid $red;\n  background: $very-light-grey;\n}\n\n.mcq-editor-block {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n/* ===== ANSWER ZONE ===== */\n\n.mcq-answer-zone {\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  gap: 0.35rem;\n  right: 7px;\n}\n\n/* ===== ROW ===== */\n\n.mcq-answer-row {\n  display: grid;\n  align-items: center;\n  width: inherit;\n  border-radius: 4px;\n  padding: 0.3rem 0.4rem;\n  gap: 0.4rem;\n}\n\n/* ===== HANDLE ===== */\n\n.rank-handle {\n  cursor: grab;\n  color: $very-light-grey;\n  font-size: 1rem;\n  text-align: center;\n}\n.rank-handle:active { cursor: grabbing; }\n\n/* ===== INDEX ===== */\n\n.rank-index {\n  font-size: 0.75rem;\n  color: $very-light-grey;\n  text-align: center;\n}\n\n/* ===== LABEL ===== */\n\n.mcq-answer-label,\n.mcq-cell-label {\n  height: 28px;\n  min-width: 0;\n  width: stretch;\n  align-content: center;\n  background: $very-light-grey;\n  border: 1px solid $blue;\n  border-radius: 6px;\n  color: $very-dark-grey;\n  padding: 0px 10px;\n}\n\n.mcq-answer-validity,\n.mcq-cell-validity {\n  line-height: 22px;\n  min-height: 28px;\n  box-sizing: border-box;\n  padding: 3px 6px;\n  font-size: 0.9rem;\n  border-radius: 6px;\n}\n\n/* ===== POINTS ===== */\n\n.mcq-answer-weight, \n.mcq-cell-weight {\n  height: 22px;\n  width: 60px;\n  line-height: 25px;\n  padding: 2px;\n  background: $very-light-grey;\n  border: 1px solid $blue;\n  border-radius: 6px;\n  text-align: center;\n  color: $very-dark-grey;\n  font-weight: 600;\n}\n\n/* ===== REMOVE ===== */\n\n.mcq-editor-block .btn-style1 {\n  margin-left: auto;\n  margin-right: 30px;\n  width: max-content;\n}\n\n/* ===== TYPES ===== */\n\n.single-editor .mcq-answer-row,\n.multiple-editor .mcq-answer-row {\n  grid-template-columns: 26px auto 110px 60px 40px; /* radio/checkbox | label | validity | weight | remove */\n}\n\n.single-editor .mcq-answer-row:not(:has(.mcq-answer-validity)),\n.multiple-editor .mcq-answer-row:not(:has(.mcq-answer-validity)) {\n  grid-template-columns: 1fr 40px; /* label | remove */\n}\n\n.ranking-editor .mcq-answer-row {\n  grid-template-columns: 22px 26px auto 60px 40px; /* handle | index | label | validity |  points | remove */\n}\n\n.ranking-editor .mcq-answer-row:not(:has(.mcq-answer-weight)) {\n  grid-template-columns: 22px 26px 1fr 40px; /* handle | index | label | remove */\n}\n\n.truefalse-editor .mcq-answer-row {\n  grid-template-columns: 26px auto 110px 60px; /* radio | label | validity |  points */\n}\n\n.truefalse-editor .mcq-answer-row:not(:has(.mcq-answer-validity)) {\n  grid-template-columns: 1fr; /* label only */\n}\n\n/* ============================ */\n/* ===== MCQ GRID CLEAN ======= */\n/* ============================ */\n\n.grid-editor {\n  .grid-meta {\n    height: 25px;\n    border-radius: 6px;\n    margin-bottom: 20px;\n\n    select {\n      width: 135px;\n      padding: 5px;\n      border-radius: 6px\n    }\n  }\n}\n\n/* ===== Builder rows/cols ===== */\n\n.grid-rows,\n.grid-cols {\n  margin-bottom: 10px;\n  width: -webkit-fill-available;\n}\n\n.grid-builder {\n  display: flex;\n  gap: 10px;\n}\n\n.grid-builder-row,\n.grid-builder-col {\n  display: grid;\n  grid-template-columns: 1fr 35px;\n  border-radius: 6px;\n  gap: 6px;\n  margin-bottom: 10px;\n}\n\n.grid-builder-row input,\n.grid-builder-col input {\n  border-radius: 6px;\n  width: -webkit-fill-available;\n  padding: 3px 6px;\n}\n\n.grid-builder-row .btn-style1,\n.grid-builder-col .btn-style1 {\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  line-height: 26px;\n  font-size: 20px;\n  font-weight: 200;\n  border-radius: 6px;\n}\n\n\n/* ============================ */\n/* ===== MCQ GRID TABLE ======= */\n/* ============================ */\n\n.table-base.mcq-grid {\n  margin-top: 0.8rem;\n\n  /* Header */\n  .header-rowLabel,\n  .header-mcq {\n    @include steel-bg(\"../medias/steel.png\");\n    color: $very-light-grey;\n    font-size: 0.75rem;\n    text-align: center;\n  }\n\n  /* Body */\n\n  .cell-mcq {\n    //background: $grey;\n    text-align: center;\n    padding: 0.3rem;\n    border-left: 1px solid $grey;\n\n    > div {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 6px;\n    }\n  }\n\n  /* Inputs */\n\n  input[type=\"radio\"],\n  input[type=\"checkbox\"] {\n    transform: scale(1.05);\n  }\n\n  .mcq-cell-points {\n    height: 25px;\n    line-height: 25px;\n    background: $light-grey;\n    padding: 2px;\n    border: 1px solid $blue;\n    border-radius: 3px;\n    text-align: center;\n    color: $very-dark-grey;\n    font-size: 0.7rem;\n    font-weight: 600;\n    width: 38px;\n  }\n}\n\n\n// Version table\n\n.mcq-versions-table {\n  position: relative;\n  width: 100%;\n\n  &.container {\n    display: flex;\n    flex-direction: row;\n    margin: 10px 0px;\n\n    .mcq-parameters {\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n      margin: 0px 10px 0px 0px;\n      height: fit-content;\n      width: 350px;\n      top: 45px;\n\n      .mcq-status-indicator {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n\n        .icon-collab,\n        .icon-versioning {\n          margin: 0 10px;\n          height: 25px;\n          width: auto;\n        }\n      }\n    }\n  }\n}\n\n.mcq-versions-table,\n.checklist-versions-table {\n  position: relative;\n  width: 100%;\n\n  &.container {\n    display: flex;\n    flex-direction: row;\n    width: -webkit-fill-available;\n    margin: 10px auto 10px auto;\n\n    .mcq-parameters,\n    .checklist-parameters {\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n      margin: 0px 10px 0px 0px;\n      height: fit-content;\n      width: 350px;\n      top: 45px;\n\n      .mcq-status-indicator,\n      .checklist-status-indicator {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n\n        .icon-collab,\n        .icon-versioning {\n          margin: 0 10px;\n          height: 25px;\n          width: auto;\n        }\n      }\n    }\n  }\n}\n\n.mcq-parameters {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  margin: 5px 15px;\n}\n\n.collaboration-status {\n  margin: 0px 10px 0px 15px;\n  color: $very-light-grey;\n}\n\n.status-indicators {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n\n.mcq-top-row {\n  display: flex;\n  gap: 1rem;\n  align-items: flex-start;\n}\n\n.mcq-top-row > :first-child {\n  flex: 1 1 0;\n  min-width: 0;\n  align-self: flex-start;\n}\n\n.mcq-top-row .lexical-versioning-bar {\n  align-self: flex-start;\n  height: auto;\n}\n\n.mcq-top-row > :last-child {\n  flex: 0 0 auto;\n  align-self: flex-start;\n}\n\n\n.checklist-top-row {\n  display: flex;\n  gap: 1rem;\n  align-items: flex-start;\n}\n\n.checklist-top-row > :first-child {\n  flex: 1 1 0;\n  min-width: 0;\n  align-self: flex-start;\n}\n\n.checklist-top-row .lexical-versioning-bar {\n  align-self: flex-start;\n  height: auto;\n}\n\n.checklist-top-row > :last-child {\n  flex: 0 0 auto;\n  align-self: flex-start;\n}\n\n\n// Online users button + dropdown\n\n.collab-online-users {\n  position: relative;\n  top: 15px;\n  flex-shrink: 0;\n}\n\n.collab-online-users__trigger {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 10px;\n  margin: 0;\n  border: 1px solid $medium-grey;\n  border-radius: 6px;\n  background: $grey;\n  color: $very-light-grey;\n  cursor: pointer;\n  text-align: left;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  line-height: 1.2;\n  white-space: nowrap;\n  transition: background 0.15s ease, border-color 0.15s ease;\n\n  &:hover {\n    border-color: $medium-light-grey;\n    background: $medium-grey;\n  }\n}\n\n.collab-online-users__trigger--open {\n  border-color: $green;\n  box-shadow: inset 0 0 0 1px $green;\n\n  .collab-online-users__label,\n  .collab-online-users__icon {\n    color: $green;\n  }\n}\n\n.collab-online-users__icon {\n  width: 17px;\n  height: 17px;\n  flex-shrink: 0;\n  color: $light-grey;\n}\n\n.collab-online-users__label {\n  min-width: 0;\n}\n\n.collab-online-users__chevron {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  color: $light-grey;\n}\n\n.collab-online-users__menu {\n  position: absolute;\n  right: 0;\n  top: calc(100% + 4px);\n  z-index: 100000;\n  min-width: 220px;\n  max-width: 320px;\n  max-height: 240px;\n  overflow-y: auto;\n  padding: 6px 0;\n  background: $dark-grey;\n  border: 1px solid $medium-grey;\n  border-radius: 6px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);\n  @include scrollbar-styles;\n}\n\n.collab-online-users__empty {\n  margin: 0;\n  padding: 10px 14px;\n  color: $light-grey;\n  font-size: 13px;\n  font-style: italic;\n}\n\n.collab-online-users__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.collab-online-users__item {\n  padding: 8px 14px;\n  color: $very-light-grey;\n  font-size: 13px;\n\n  &:hover {\n    background: $grey;\n  }\n}\n\n.collab-online-users__name {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: $light-grey;\n}\n\n.input.admin.container.course-table.container {\n  flex-direction: column;\n}\n\n/* ---------- COURSE MODULES MODAL ---------- */\n\n.course-modules-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1050;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.25rem;\n  background: rgba(8, 14, 22, 0.72);\n  backdrop-filter: blur(3px);\n}\n\n.course-modules-modal {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 1200px;\n  max-height: unquote('min(82vh, 900px)');\n  border-radius: 14px;\n  border: 1px solid rgba($accent-blue, 0.45);\n  background:\n    linear-gradient(160deg, rgba($dark-blue, 0.95), rgba($dark-blue-grey, 0.88)),\n    rgba($dark-panel-blue, 0.96);\n  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.42);\n  overflow: hidden;\n}\n\n.course-modules-modal__header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.85rem;\n  padding: 0.95rem 1rem 0.95rem 1.15rem;\n  border-bottom: 1px solid rgba($accent-blue, 0.35);\n  background:\n    linear-gradient(135deg, rgba($dark-blue, 0.92), rgba($dark-blue-grey, 0.72)),\n    rgba($dark-blue, 0.8);\n}\n\n.course-modules-modal__header-main {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.course-modules-modal__eyebrow {\n  margin: 0 0 0.25rem;\n  font-size: 0.68rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.58);\n}\n\n.course-modules-modal__title {\n  margin: 0;\n  font-size: unquote('clamp(1rem, 2vw, 1.25rem)');\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: $very-light-grey;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.course-modules-modal__header-badges {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.45rem;\n  flex-shrink: 0;\n}\n\n.course-modules-modal__badge {\n  display: inline-flex;\n  align-items: center;\n  min-height: 1.45rem;\n  padding: 0.15rem 0.55rem;\n  border-radius: 999px;\n  border: 1px solid rgba($accent-blue, 0.45);\n  background: rgba($dark-blue-grey, 0.55);\n  color: $light-grey;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  white-space: nowrap;\n\n  &--readonly {\n    border-color: rgba($orange, 0.65);\n    color: $orange;\n    background: rgba($dark-orange, 0.18);\n  }\n}\n\n.course-modules-modal__close {\n  position: relative;\n  flex-shrink: 0;\n  width: 2rem;\n  height: 2rem;\n  margin: 0;\n  padding: 0;\n  border: 1px solid rgba($accent-blue, 0.4);\n  border-radius: 8px;\n  background: rgba($dark-blue-grey, 0.55);\n  color: $light-grey;\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease, background-color 0.15s ease;\n\n  &::before,\n  &::after {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 0.85rem;\n    height: 2px;\n    background: currentColor;\n    transform-origin: center;\n  }\n\n  &::before {\n    transform: translate(-50%, -50%) rotate(45deg);\n  }\n\n  &::after {\n    transform: translate(-50%, -50%) rotate(-45deg);\n  }\n\n  &:hover,\n  &:focus-visible {\n    border-color: rgba($very-light-yellow, 0.55);\n    color: $very-light-yellow;\n    background: rgba($very-dark-grey, 0.75);\n  }\n}\n\n.course-modules-modal__badge--new {\n  border-color: rgba($very-light-yellow, 0.55);\n  color: $very-light-yellow;\n  background: rgba($dark-blue-grey, 0.65);\n}\n\n.course-modules-modal__metadata {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 0.85rem 1rem;\n  padding: 0.85rem 1rem;\n  border-bottom: 1px solid rgba($accent-blue, 0.28);\n  background: rgba($dark-blue, 0.38);\n}\n\n.course-modules-modal__metadata-main {\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n  min-width: 0;\n  flex: 1 1 28rem;\n}\n\n.course-modules-modal__metadata-title-row {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  min-width: 0;\n}\n\n.course-modules-modal__title-input {\n  width: 100%;\n  min-width: 0;\n  margin: 0;\n  padding: 0.2rem 0.45rem;\n  border: 1px solid rgba($accent-blue, 0.45);\n  border-radius: 8px;\n  background: rgba($dark-blue-grey, 0.55);\n  color: $very-light-grey;\n  font-size: unquote('clamp(1rem, 2vw, 1.25rem)');\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n\n  &::placeholder {\n    color: rgba($very-light-grey, 0.42);\n    text-transform: none;\n    letter-spacing: normal;\n    font-weight: 500;\n  }\n\n  &:focus-visible {\n    outline: none;\n    border-color: rgba($very-light-yellow, 0.55);\n    box-shadow: 0 0 0 2px rgba($very-light-yellow, 0.15);\n  }\n}\n\n.course-modules-modal__metadata-edit {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 1.55rem;\n  height: 1.55rem;\n  margin: 0;\n  padding: 0;\n  border: 1px solid rgba($accent-blue, 0.4);\n  border-radius: 8px;\n  background: rgba($dark-blue-grey, 0.55);\n  cursor: pointer;\n  transition: border-color 0.15s ease, background-color 0.15s ease;\n\n  img {\n    width: 0.55rem;\n    height: 0.55rem;\n    filter: brightness(0) saturate(100%) invert(84%) sepia(7%) saturate(468%) hue-rotate(169deg) brightness(95%) contrast(88%);\n  }\n\n  &:hover,\n  &:focus-visible {\n    border-color: rgba($very-light-yellow, 0.55);\n    background: rgba($very-dark-grey, 0.75);\n  }\n}\n\n.course-modules-modal__metadata-fields {\n  display: grid;\n  grid-template-columns: minmax(0, 1.4fr) minmax(10rem, 0.85fr) minmax(10rem, 0.7fr);\n  gap: 0.65rem 0.85rem;\n\n  @media (max-width: 900px) {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  @media (max-width: 720px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.course-modules-modal__metadata-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  min-width: 0;\n}\n\n.course-modules-modal__metadata-label {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.58);\n}\n\n.course-modules-modal__metadata-value {\n  min-height: 1.35rem;\n  font-size: 0.82rem;\n  color: $light-grey;\n  overflow-wrap: anywhere;\n}\n\n.course-modules-modal__metadata-textarea,\n.course-modules-modal__metadata-select,\n.course-modules-modal__metadata-number {\n  width: stretch;\n  min-width: 0;\n  margin: 0;\n  padding: 0.45rem 0.55rem;\n  border: 1px solid rgba($accent-blue, 0.35);\n  border-radius: 8px;\n  background: rgba($dark-blue-grey, 0.5);\n  color: $light-grey;\n  font-size: 0.82rem;\n\n  &:focus-visible {\n    outline: none;\n    border-color: rgba($very-light-yellow, 0.55);\n    box-shadow: 0 0 0 2px rgba($very-light-yellow, 0.15);\n  }\n}\n\n.course-modules-modal__metadata-number {\n  max-width: 6rem;\n}\n\n.course-modules-modal__metadata-textarea {\n  resize: vertical;\n  min-height: 2.6rem;\n}\n\n.course-modules-modal__metadata-hint {\n  font-size: 0.68rem;\n  color: rgba($very-light-grey, 0.5);\n}\n\n.course-modules-modal__metadata-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.45rem;\n  margin-left: auto;\n  flex: 0 0 auto;\n}\n\n.course-modules-modal__metadata-error {\n  width: 100%;\n  margin: 0;\n  font-size: 0.78rem;\n  color: $orange;\n}\n\n.course-modules-modal__metadata-delete {\n  color: $orange;\n}\n\n.course-modules-modal__metadata-stats {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  padding-top: 0.15rem;\n}\n\n.course-modules-modal__metadata-stat-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  min-width: 0;\n\n  &--warning {\n    padding: 0.45rem 0.55rem;\n    border-radius: 8px;\n    border: 1px solid rgba($light-orange, 0.45);\n    background: rgba($light-orange, 0.08);\n  }\n}\n\n.course-modules-modal__metadata-stat-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.65rem;\n}\n\n.course-modules-modal__metadata-stat-toggle {\n  flex-shrink: 0;\n  margin: 0;\n  padding: 0.2rem 0.55rem;\n  border: 1px solid rgba($accent-blue, 0.45);\n  border-radius: 6px;\n  background: rgba($dark-blue-grey, 0.55);\n  color: $light-grey;\n  font-size: 0.64rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease, background-color 0.15s ease;\n\n  &:hover,\n  &:focus-visible {\n    border-color: rgba($light-blue, 0.55);\n    color: $very-light-grey;\n    background: rgba($dark-blue, 0.75);\n  }\n}\n\n.course-modules-modal__metadata-topic-warnings {\n  margin: 0;\n  padding-left: 1rem;\n  color: $light-orange;\n  font-size: 0.76rem;\n  line-height: 1.35;\n}\n\n.course-modules-modal__metadata-stat-heading {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.58);\n}\n\n.course-modules-modal__metadata-stat-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.course-modules-modal__metadata-stat-chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.12rem 0.45rem;\n  border-radius: 999px;\n  border: 1px solid rgba($accent-blue, 0.45);\n  background: rgba($dark-blue-grey, 0.45);\n  color: $light-grey;\n  font-size: 0.72rem;\n  font-weight: 600;\n  white-space: nowrap;\n\n  &--total {\n    border-color: rgba($very-light-yellow, 0.45);\n    color: $very-light-yellow;\n  }\n\n  &--topic {\n    border-color: rgba($light-blue, 0.4);\n    color: $light-blue;\n  }\n}\n\n.course-modules-modal__composition {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  flex: 1 1 auto;\n\n  &--locked {\n    .course-modules-modal__reading-order,\n    .course-modules-modal__body {\n      pointer-events: none;\n      user-select: none;\n      opacity: 0.42;\n    }\n  }\n}\n\n.course-modules-modal__composition-lock {\n  position: absolute;\n  inset: 0;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background: rgba($dark-blue, 0.28);\n  pointer-events: none;\n}\n\n.course-modules-modal__composition-lock-text {\n  max-width: 26rem;\n  margin: 0;\n  padding: 0.75rem 1rem;\n  border-radius: 10px;\n  border: 1px solid rgba($accent-blue, 0.35);\n  background: rgba($dark-blue-grey, 0.88);\n  color: $light-grey;\n  font-size: 0.84rem;\n  text-align: center;\n}\n\n.course-modules-modal__reading-order {\n  border-bottom: 1px solid rgba($accent-blue, 0.28);\n  background: rgba($dark-blue, 0.42);\n}\n\n.course-modules-modal__reading-order-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.65rem 1rem;\n}\n\n.course-modules-modal__reading-order-summary {\n  min-width: 0;\n}\n\n.course-modules-modal__reading-order-eyebrow {\n  margin: 0;\n  font-size: 0.68rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.58);\n}\n\n.course-modules-modal__reading-order-count {\n  margin: 0.15rem 0 0;\n  color: $very-light-grey;\n  font-size: 0.82rem;\n  font-weight: 600;\n}\n\n.course-modules-modal__reading-order-toggle {\n  flex-shrink: 0;\n  margin: 0;\n  padding: 0.35rem 0.7rem;\n  border: 1px solid rgba($accent-blue, 0.45);\n  border-radius: 6px;\n  background: rgba($dark-blue-grey, 0.55);\n  color: $light-grey;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease, background-color 0.15s ease;\n\n  &:hover,\n  &:focus-visible {\n    border-color: rgba($light-blue, 0.55);\n    color: $very-light-grey;\n    background: rgba($dark-blue, 0.75);\n  }\n}\n\n.course-modules-modal__reading-order-body {\n  padding: 0 1rem 0.85rem;\n}\n\n.course-reading-order__empty {\n  margin: 0;\n  padding: 0.45rem 0.55rem;\n  color: rgba($very-light-grey, 0.7);\n  font-size: 0.82rem;\n}\n\n.course-reading-order-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.course-reading-order-row {\n  display: grid;\n  grid-template-columns: 1.6rem minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 0.55rem;\n  padding: 0.45rem 0.55rem;\n  border-radius: 6px;\n  border: 1px solid rgba($accent-blue, 0.22);\n  background: rgba($dark-blue-grey, 0.45);\n  color: $very-light-grey;\n\n  &--dragging {\n    border-color: rgba($light-blue, 0.55);\n    background: rgba($light-blue, 0.12);\n  }\n\n  &__handle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 1.6rem;\n    height: 1.6rem;\n    margin: 0;\n    padding: 0;\n    border: 1px solid rgba($medium-grey, 0.55);\n    border-radius: 4px;\n    background: rgba($dark-blue-grey, 0.55);\n    color: $light-grey;\n    font-size: 0.95rem;\n    line-height: 1;\n    cursor: grab;\n\n    &:disabled {\n      opacity: 0.45;\n      cursor: not-allowed;\n    }\n\n    &:active:not(:disabled) {\n      cursor: grabbing;\n    }\n  }\n\n  &__label {\n    min-width: 0;\n    text-align: left;\n    font-size: 0.84rem;\n    font-weight: 500;\n  }\n\n  &__version {\n    flex-shrink: 0;\n    color: rgba($very-light-grey, 0.68);\n    font-size: 0.68rem;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    white-space: nowrap;\n  }\n}\n\n.course-modules-modal__body {\n  display: grid;\n  grid-template-columns: minmax(0, 1.05fr) minmax(0, 0.95fr);\n  gap: 0.85rem;\n  min-height: 0;\n  flex: 1 1 auto;\n  padding: 0.9rem;\n  overflow: hidden;\n\n  @media (max-width: 860px) {\n    grid-template-columns: 1fr;\n    overflow-y: auto;\n    @include scrollbar-styles;\n  }\n}\n\n.course-modules-modal__panel {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  min-width: 0;\n  overflow: hidden;\n  padding: 0.75rem;\n  border-radius: 12px;\n  border: 1px solid rgba($accent-blue, 0.28);\n  background: rgba($dark-blue-grey, 0.38);\n}\n\n.course-modules-modal__panel-title {\n  flex-shrink: 0;\n  margin: 0 0 0.65rem;\n  font-size: 0.74rem;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.82);\n}\n\n.course-modules-modal__table-wrap {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: hidden;\n  border-radius: 8px;\n  border: 1px solid rgba($accent-blue, 0.22);\n}\n\n.course-modules-modal__table {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  margin: 0;\n  box-shadow: none;\n\n  table {\n    width: 100%;\n    table-layout: fixed;\n  }\n\n  .course-modules-modal__table-head {\n    flex-shrink: 0;\n  }\n\n  .course-modules-modal__table-body {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow: auto;\n    border-top: 1px solid rgba($accent-blue, 0.22);\n    @include scrollbar-styles;\n  }\n\n  thead th,\n  tbody td {\n    padding: 0.45rem 0.75rem;\n  }\n\n  thead th:first-child,\n  tbody td:first-child {\n    padding-left: 0.95rem;\n  }\n\n  thead th:last-child,\n  tbody td:last-child {\n    text-align: center;\n    width: 3.5rem;\n    padding-right: 0.85rem;\n  }\n\n  thead th:nth-child(3),\n  tbody td:nth-child(3) {\n    text-align: center;\n    width: 4.5rem;\n  }\n\n  col.col-moduleTopics {\n    width: 4.5rem;\n  }\n\n  tbody tr.module-row {\n    cursor: pointer;\n    transition: background-color 0.15s ease, box-shadow 0.15s ease;\n\n    &.selected {\n      background: rgba($accent-blue, 0.22);\n      box-shadow: inset 0 0 0 1px rgba($light-blue, 0.45);\n    }\n\n    &.is-assigned td:first-child {\n      color: $very-light-grey;\n    }\n  }\n}\n\n.course-modules-modal__empty-cell {\n  display: block;\n  padding: 0.75rem 0;\n  text-align: center;\n  color: $light-grey;\n  font-style: italic;\n}\n\n.course-modules-modal__details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: hidden;\n\n  &--empty {\n    flex: 1 1 auto;\n    overflow: auto;\n    align-items: center;\n    justify-content: center;\n    min-height: 180px;\n    padding: 1rem;\n    border: 1px dashed rgba($accent-blue, 0.35);\n    border-radius: 8px;\n    background: rgba($dark-blue, 0.28);\n\n    p {\n      margin: 0;\n      text-align: center;\n      color: $light-grey;\n      font-size: 0.88rem;\n      font-style: italic;\n    }\n  }\n}\n\n.course-modules-modal__details-head,\n.course-modules-modal__topic-quota-summary {\n  flex-shrink: 0;\n}\n\n.course-modules-modal__details-head {\n  padding-bottom: 0.55rem;\n  border-bottom: 1px solid rgba($accent-blue, 0.22);\n}\n\n.course-modules-modal__details-title {\n  margin: 0;\n  font-size: 0.92rem;\n  font-weight: 600;\n  color: $very-light-grey;\n}\n\n.course-modules-modal__topic-quota-summary {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  padding: 0.55rem 0.65rem;\n  border-radius: 8px;\n  background: rgba($dark-blue, 0.34);\n  border: 1px solid rgba($accent-blue, 0.24);\n\n  &--invalid {\n    border-color: rgba($light-orange, 0.55);\n    background: rgba($light-orange, 0.08);\n  }\n}\n\n.course-modules-modal__topic-quota-summary-line {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin: 0;\n  font-size: 0.8rem;\n}\n\n.course-modules-modal__topic-quota-label {\n  color: rgba($very-light-grey, 0.72);\n}\n\n.course-modules-modal__topic-quota-value {\n  font-weight: 600;\n  color: $very-light-grey;\n}\n\n.course-modules-modal__topic-quota-hint {\n  margin: 0.15rem 0 0;\n  font-size: 0.74rem;\n  line-height: 1.35;\n  color: $light-orange;\n}\n\n.course-modules-modal__quota-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: auto;\n  @include scrollbar-styles;\n}\n\n.course-modules-modal__quota-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1.2fr) minmax(0, 0.9fr) 4.5rem;\n  align-items: center;\n  gap: 0.55rem;\n  padding: 0.45rem 0.55rem;\n  border-radius: 8px;\n  background: rgba($dark-blue, 0.42);\n  border: 1px solid rgba($accent-blue, 0.2);\n}\n\n.course-modules-modal__quota-label {\n  font-size: 0.8rem;\n  color: $very-light-grey;\n}\n\n.course-modules-modal__quota-available {\n  font-size: 0.74rem;\n  color: rgba($very-light-grey, 0.55);\n  text-align: right;\n}\n\n.course-modules-modal__quota-input {\n  width: stretch;\n  min-width: 0;\n  padding: 0.3rem 0.45rem;\n  border: 1px solid rgba($accent-blue, 0.45);\n  border-radius: 6px;\n  font-size: 0.82rem;\n  color: $very-light-grey;\n  background: rgba($dark-blue, 0.72);\n  text-align: center;\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n\n.course-modules-modal__meta-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  margin: 0;\n  flex-shrink: 0;\n}\n\n.course-modules-modal__meta-item {\n  display: grid;\n  grid-template-columns: 6.5rem minmax(0, 1fr);\n  gap: 0.65rem;\n  padding: 0.5rem 0.55rem;\n  border-radius: 8px;\n  background: rgba($dark-blue, 0.3);\n  border: 1px solid rgba($accent-blue, 0.16);\n\n  dt {\n    margin: 0;\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.62);\n  }\n\n  dd {\n    margin: 0;\n    font-size: 0.82rem;\n    color: $light-grey;\n    overflow-wrap: anywhere;\n  }\n}\n\n\n/* ============================= */\n/*  GLOBAL DRAFT VISUALIZATION   */\n/* ============================= */\n\n.draft,\n.draft-row,\n.online.draft-row {\n  position: relative;\n}\n\n/* -----------------------------\n   Draft input highlight\n------------------------------ */\ninput.draft {\n  border: 2px solid $light-orange !important;\n  background: rgba(255, 152, 0, 0.05);\n  color: $light-orange;\n  font-weight: 600;\n}\n\n/* -----------------------------\n   Draft cell highlight\n------------------------------ */\ntd:has(input.draft) {\n  background: rgba(255, 152, 0, 0.07);\n}\n\n/* -----------------------------\n   Draft row highlight\n------------------------------ */\n\n.cell-simple, \n.cell-standard, \n.cell-complex,\n.cell-expert {\n  input {\n    width: 35px;\n  }\n}\n\ntr.draft-row {\n  background: rgba(255, 152, 0, 0.12);\n\n  td {\n    border-top: 1px solid $light-orange;\n    border-bottom: 1px solid $light-orange;\n  }\n\n  td:first-child {\n    border-left: 3px solid $light-orange;\n  }\n\n  td:last-child {\n    border-right: 3px solid $light-orange;\n  }\n}\n\n/* -----------------------------\n   Online/offline emphasis\n------------------------------ */\ntr.online {\n  box-shadow: inset 0 0 0 1px $green;\n}\n\ntr.offline {\n  box-shadow: inset 0 0 0 1px $orange;\n}\n\n/* -----------------------------\n   Hover reinforcement\n------------------------------ */\ntr.module-row:hover {\n  background: rgba($accent-blue, 0.14);\n}\n\n\n\n// QCM PREVIEW //\n\n/* ---------- TEST COURSE MODAL ---------- */\n\n.exam-meta {\n  margin-bottom: 1rem;\n  padding: 0.6rem 0.9rem;\n  background: #0f2c3e;\n  border: 1px solid $blue;\n  border-radius: 6px;\n  color: $pure-white;\n\n  &--empty {\n    margin-top: 0.5rem;\n    font-style: italic;\n  }\n}\n\n.exam-meta__count {\n  margin-left: 0.75rem;\n  color: rgba($very-light-grey, 0.7);\n  font-size: 0.85rem;\n}\n\n.exam-meta__live-badge {\n  margin-left: 0.65rem;\n  padding: 0.1rem 0.45rem;\n  border-radius: 999px;\n  border: 1px solid $green;\n  color: $light-green;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n\n  &--member {\n    border-color: rgba($light-orange, 0.55);\n    color: rgba($light-orange, 0.95);\n  }\n}\n\n.exam-meta__timer {\n  font-variant-numeric: tabular-nums;\n  color: rgba($light-orange, 0.95);\n}\n\n.course-exam-player--member .course-exam-player__layout {\n  grid-template-columns: minmax(0, 1fr);\n}\n\n.course-exam-player__layout {\n  display: grid;\n  grid-template-columns: minmax(11rem, 13.5rem) minmax(0, 1fr);\n  gap: 0.85rem;\n  align-items: start;\n}\n\n.course-exam-player__content {\n  min-width: 0;\n}\n\n.course-exam-sidebar {\n  position: sticky;\n  top: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n  padding: 0.65rem;\n  border-radius: 8px;\n  border: 1px solid rgba($accent-blue, 0.35);\n  background: rgba($dark-blue, 0.55);\n\n  &__title {\n    margin: 0;\n    padding: 0 0.2rem;\n    font-size: 0.68rem;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.62);\n  }\n\n  &__list {\n    display: flex;\n    flex-direction: column;\n    gap: 0.3rem;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  }\n\n  &__item {\n    width: 100%;\n    margin: 0;\n    padding: 0.45rem 0.55rem;\n    border: 1px solid transparent;\n    border-radius: 6px;\n    background: transparent;\n    color: $light-grey;\n    font-size: 0.82rem;\n    font-weight: 500;\n    text-align: left;\n    cursor: pointer;\n    transition: border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease;\n\n    &:hover,\n    &:focus-visible {\n      border-color: rgba($accent-blue, 0.45);\n      background: rgba($dark-blue-grey, 0.55);\n      color: $very-light-grey;\n    }\n\n    &--active {\n      border-color: rgba($light-blue, 0.55);\n      background: rgba($light-blue, 0.14);\n      color: $very-light-grey;\n    }\n\n    &--qcm {\n      margin-top: 0.2rem;\n      border-top: 1px solid rgba($accent-blue, 0.22);\n      border-radius: 0 0 6px 6px;\n      padding-top: 0.6rem;\n      font-weight: 700;\n      letter-spacing: 0.04em;\n      text-transform: uppercase;\n    }\n  }\n}\n\n.course-exam-document-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  min-height: 0;\n\n  &__head {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    gap: 0.75rem;\n    padding: 0.55rem 0.75rem;\n    border-radius: 8px;\n    border: 1px solid #163a52;\n    background: #081b26;\n  }\n\n  &__title {\n    margin: 0;\n    color: $light-blue;\n    font-size: 0.95rem;\n    font-weight: 600;\n  }\n\n  &__version {\n    flex-shrink: 0;\n    color: rgba($very-light-grey, 0.7);\n    font-size: 0.75rem;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n  }\n\n  &__viewer {\n    min-height: 0;\n  }\n}\n\n.course-exam-document-viewer {\n  max-height: unquote('min(58vh, 680px)');\n  overflow-y: auto;\n  padding: 0.85rem 1rem;\n  border-radius: 8px;\n  border: 1px solid #163a52;\n  background: rgba($dark-blue, 0.45);\n  @include scrollbar-styles;\n}\n\n/* ---------- MODULE ---------- */\n\n.exam-module {\n  margin-bottom: 1.6rem;\n  padding: 1rem;\n  background: #081b26;\n  border: 1px solid #163a52;\n  border-radius: 8px;\n\n  h4 {\n    margin: 0 0 0.8rem 0;\n    padding-bottom: 0.4rem;\n    border-bottom: 1px solid #1d4f73;\n    color: $light-blue;\n    font-weight: 600;\n  }\n}\n\n/* ---------- QUESTION ---------- */\n\n.exam-question {\n  margin-bottom: 1.2rem;\n  padding: 0.8rem;\n  background: #0b2230;\n  border: 1px solid #1b4a6b;\n  border-radius: 6px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  &--playable {\n    .exam-title {\n      margin-bottom: 0.75rem;\n    }\n  }\n\n  &__head {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 0.4rem;\n    margin-bottom: 0.45rem;\n  }\n\n  &__index {\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: $light-blue;\n  }\n\n  &__badge {\n    padding: 0.1rem 0.45rem;\n    border-radius: 999px;\n    border: 1px solid $orange;\n    color: $orange;\n    font-size: 0.65rem;\n    font-weight: 700;\n    text-transform: uppercase;\n\n    &--muted {\n      border-color: rgba($light-grey, 0.45);\n      color: $light-grey;\n    }\n\n    &--type {\n      border-color: rgba($light-blue, 0.45);\n      color: $light-blue;\n    }\n\n    &--topic {\n      border-color: rgba($light-green, 0.45);\n      color: $light-green;\n      text-transform: none;\n    }\n  }\n\n  .exam-title {\n    margin-bottom: 0.6rem;\n    font-weight: 500;\n    color: $pure-white;\n    text-align: left;\n  }\n}\n\n.exam-truefalse-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.exam-truefalse-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.45rem 0.65rem;\n  border-radius: 4px;\n  color: #dcefff;\n  background: rgba(255, 255, 255, 0.03);\n\n  &:nth-child(even) {\n    background: rgba(255, 255, 255, 0.06);\n  }\n\n  &__label {\n    flex: 1 1 auto;\n    min-width: 0;\n    text-align: left;\n  }\n\n  &__radio {\n    flex: 0 0 auto;\n    margin-left: auto;\n    cursor: pointer;\n  }\n}\n\n/* ---------- OPTIONS ---------- */\n\n.exam-option {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0.35rem 0.6rem;\n  border-radius: 4px;\n  color: #dcefff;\n  cursor: default;\n\n  input {\n    pointer-events: none;\n  }\n\n  &:nth-child(odd) {\n    background: rgba(255,255,255,0.03);\n  }\n\n  &:hover {\n    background: rgba(255,255,255,0.06);\n  }\n\n  &--playable {\n    cursor: pointer;\n\n    input {\n      pointer-events: auto;\n      cursor: pointer;\n    }\n\n    &:hover {\n      background: rgba($light-blue, 0.12);\n    }\n  }\n}\n\n.exam-ranking-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.exam-ranking-row {\n  display: grid;\n  grid-template-columns: 1.6rem 2rem 1fr;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.4rem 0.55rem;\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba($light-blue, 0.18);\n\n  &--sortable {\n    touch-action: none;\n  }\n\n  &__handle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 1.6rem;\n    height: 1.6rem;\n    margin: 0;\n    padding: 0;\n    border: 1px solid rgba($medium-grey, 0.55);\n    border-radius: 4px;\n    background: rgba($dark-blue-grey, 0.55);\n    color: $light-grey;\n    font-size: 0.95rem;\n    line-height: 1;\n    cursor: grab;\n\n    &:active {\n      cursor: grabbing;\n    }\n  }\n\n  &__index {\n    font-weight: 700;\n    color: $light-blue;\n    text-align: center;\n  }\n\n  &__label {\n    color: $very-light-grey;\n    text-align: left;\n  }\n}\n\n.exam-grid-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n\n  &__head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1rem;\n    padding: 0 0.65rem 0.15rem;\n  }\n\n  &__head-spacer {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  &__head-cols {\n    display: flex;\n    flex: 0 0 auto;\n    gap: 1.75rem;\n    margin-left: auto;\n  }\n\n  &__col-label {\n    min-width: 2.25rem;\n    text-align: center;\n    font-size: 0.72rem;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.75);\n  }\n}\n\n.exam-grid-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.45rem 0.65rem;\n  border-radius: 4px;\n  color: #dcefff;\n  background: rgba(255, 255, 255, 0.03);\n\n  &--alt {\n    background: rgba(255, 255, 255, 0.06);\n  }\n\n  &__label {\n    flex: 1 1 auto;\n    min-width: 0;\n    text-align: left;\n  }\n\n  &__choices {\n    display: flex;\n    flex: 0 0 auto;\n    gap: 1.75rem;\n    margin-left: auto;\n  }\n\n  &__choice {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 2.25rem;\n    cursor: pointer;\n  }\n\n  &__input {\n    flex: 0 0 auto;\n    margin: 0;\n    cursor: pointer;\n  }\n}\n\n.course-exam-player__footer {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 1rem;\n  padding-top: 0.85rem;\n  border-top: 1px solid rgba($accent-blue, 0.28);\n}\n\n.course-exam-results {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.course-exam-results__hero {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 1.25rem;\n  border-radius: 10px;\n  border: 1px solid rgba($green, 0.45);\n  background: rgba($dark-blue, 0.55);\n  text-align: center;\n}\n\n.course-exam-results__eyebrow {\n  margin: 0;\n  font-size: 0.72rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.65);\n}\n\n.course-exam-results__score {\n  margin: 0;\n  font-size: 2rem;\n  color: $very-light-grey;\n}\n\n.course-exam-results__percent {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: $light-green;\n}\n\n.course-exam-results__persist {\n  margin: 0.35rem 0 0;\n  font-size: 0.82rem;\n  color: rgba($very-light-grey, 0.75);\n\n  &--ok {\n    color: $light-green;\n  }\n\n  &--error {\n    color: $orange;\n  }\n}\n\n.course-exam-results__modules {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.course-exam-results__module-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.5rem 0.65rem;\n  border-radius: 6px;\n  background: rgba($dark-blue, 0.4);\n  border: 1px solid rgba($accent-blue, 0.2);\n  color: $light-grey;\n  font-size: 0.88rem;\n}\n\n/* ---------- COURSE EXAM PREVIEW MODAL ---------- */\n\n.course-exam-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1050;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.25rem;\n  background: rgba(8, 14, 22, 0.72);\n  backdrop-filter: blur(3px);\n}\n\n.course-exam-modal {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 1200px;\n  max-height: unquote('min(88vh, 900px)');\n  border-radius: 14px;\n  border: 1px solid rgba($accent-blue, 0.45);\n  background:\n    linear-gradient(160deg, rgba($dark-blue, 0.95), rgba($dark-blue-grey, 0.88)),\n    rgba($dark-panel-blue, 0.96);\n  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.42);\n  overflow: hidden;\n}\n\n.course-exam-modal__header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.85rem;\n  padding: 0.95rem 1rem 0.95rem 1.15rem;\n  border-bottom: 1px solid rgba($accent-blue, 0.35);\n  background:\n    linear-gradient(135deg, rgba($dark-blue, 0.92), rgba($dark-blue-grey, 0.72)),\n    rgba($dark-blue, 0.8);\n}\n\n.course-exam-modal__header-main {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.course-exam-modal__eyebrow {\n  margin: 0 0 0.25rem;\n  font-size: 0.68rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.58);\n}\n\n.course-exam-modal__title {\n  margin: 0;\n  font-size: unquote('clamp(1rem, 2vw, 1.25rem)');\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: $very-light-grey;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.course-exam-modal__header-badges {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.45rem;\n  flex-shrink: 0;\n}\n\n.course-exam-modal__badge {\n  display: inline-flex;\n  align-items: center;\n  min-height: 1.45rem;\n  padding: 0.15rem 0.55rem;\n  border-radius: 999px;\n  border: 1px solid rgba($accent-blue, 0.45);\n  background: rgba($dark-blue-grey, 0.55);\n  color: $light-grey;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  white-space: nowrap;\n\n  &--live {\n    border-color: rgba($orange, 0.65);\n    color: $orange;\n    background: rgba($dark-orange, 0.18);\n  }\n}\n\n.course-exam-modal__close {\n  position: relative;\n  flex-shrink: 0;\n  width: 2rem;\n  height: 2rem;\n  margin: 0;\n  padding: 0;\n  border: 1px solid rgba($accent-blue, 0.4);\n  border-radius: 8px;\n  background: rgba($dark-blue-grey, 0.55);\n  color: $light-grey;\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease, background-color 0.15s ease;\n\n  &::before,\n  &::after {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 0.85rem;\n    height: 2px;\n    background: currentColor;\n    transform-origin: center;\n  }\n\n  &::before {\n    transform: translate(-50%, -50%) rotate(45deg);\n  }\n\n  &::after {\n    transform: translate(-50%, -50%) rotate(-45deg);\n  }\n\n  &:hover,\n  &:focus-visible {\n    border-color: rgba($very-light-yellow, 0.55);\n    color: $very-light-yellow;\n    background: rgba($very-dark-grey, 0.75);\n  }\n}\n\n.course-exam-modal__body {\n  min-height: 0;\n  flex: 1 1 auto;\n  padding: 1rem 1.15rem;\n  overflow-y: auto;\n  @include scrollbar-styles;\n}\n\n.course-exam-results__actions {\n  display: flex;\n  justify-content: center;\n}\n\n.mcq-grid input[type=\"radio\"] {\n  appearance: auto;\n}\n\n.mcq-grid input[type=\"radio\"]:checked {\n  appearance: auto;\n}\n\n.mcq-grid input[data-readonly=\"1\"] {\n  pointer-events: none;\n  opacity: 0.9;\n}\n\n/* English comment: block pointer when in readonly/archive */\ninput[type=\"checkbox\"][data-readonly=\"1\"] {\n  pointer-events: none;\n  opacity: 1;\n}\n\n\n/* /src/assets/scss/admin/_certifications.scss */\n\n\n.equivalences-management {\n\n  .input-row {\n    &.equivalences,\n    &.equivalences-rules,\n    &.equivalences-items {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 10px 20px;\n      margin-bottom: 10px;\n\n      input {\n        padding: 2px 6px;\n        border-radius: 6px;\n      }\n    }\n  }\n\n  .equiv-code-input { width: 250px; }\n  .equiv-label-input { width: 250px; }\n  .equiv-desc-input { width: 260px; }\n  .equiv-theme-select { width: max-content; }\n  .equiv-level-select { width: max-content; }\n\n  .rule-priority-input { width: 90px; }\n  .rule-validFrom-input,\n  .rule-validTo-input { width: 140px; }\n\n  .rule-item-template-select { width: 260px; }\n\n  .row-selected {\n    background: rgba(255, 255, 255, 0.06);\n  }\n\n  .cell-loading {\n    text-align: center;\n    opacity: 0.6;\n    padding: 10px;\n  }\n\n  /* Layout */\n\n  .theme-and-level {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n\n    /* Row 1: equivalences list */\n    .equivalences-requirements-block {\n      width: -webkit-fill-available;\n    }\n\n    /* Row 2: rules + items */\n    .equivalences-bottom-row {\n      display: flex;\n      gap: 12px;\n\n      .equivalences-rules-block,\n      .equivalences-items-block {\n        width: 50%;\n      }\n    }\n  }\n\n  .equivalences-requirements,\n  .equivalences-rules,\n  .equivalences-items {\n    max-height: 260px;\n  }\n}\n\n\n.create-module-top-row {\n  display: flex;\n  align-items: flex-start;\n}\n\n.create-module-left {\n  flex: 1;\n  min-width: 0;\n}\n\n.create-module-right {\n  width: 60%;\n}\n\n\n.create-officer-checklist {\n  .officer-checklist-items {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .officer-checklist-item-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    position: relative;\n    background: $very-dark-grey;\n    min-height: 100px;\n    max-height: calc(100vh - 510px);\n    border: 1px solid $dark-red;\n    border-top: 4px solid $dark-red;\n    border-bottom: 4px solid $dark-red;\n    border-radius: 8px;\n    outline: none;\n    padding: 15px;\n    overflow-y: auto;\n    margin-bottom: 20px;\n    @include scrollbar-styles;\n  }\n\n  .officer-checklist-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n\n    .checklist-label {\n      flex: 1;\n    }\n\n    .checklist-remove {\n      font-size: 12px;\n      line-height: 0.7;\n      padding: 6px 8px;\n\n    }\n  }\n\n  .officer-checklist-toggle {\n    margin-top: 10px;\n    margin-left: 0px;\n\n    .toggle-label {\n      margin-left: 50px;\n      color: $very-light-grey;\n    }\n  }\n\n  .officer-checklist-separator {\n    margin: 15px 0px;\n    border-bottom: 1px solid $very-light-grey;\n    opacity: 0.2;\n  }\n\n\n  .officer-checklist-actions {\n    margin-top: 16px;\n    margin-bottom: 15px;\n    display: flex;\n    gap: 12px;\n    margin-left: auto;\n  }\n}\n\n.psych-scoring-editor,\n.psych-scores-readout {\n  margin-top: 0.85rem;\n  padding: 0.75rem;\n  border: 1px solid rgba($accent-blue, 0.28);\n  border-radius: 8px;\n  background: rgba($dark-blue-grey, 0.35);\n}\n\n.psych-scoring-editor__header,\n.psych-scores-readout__title {\n  margin: 0 0 0.65rem;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.72);\n}\n\n.psych-scoring-editor__toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  font-size: 0.82rem;\n  color: $light-grey;\n}\n\n.psych-scoring-editor__choice-grid {\n  display: grid;\n  gap: 0.75rem;\n}\n\n.psych-scoring-editor__choice-option,\n.psych-scores-readout__choice-option,\n.psych-scores-readout__matrix-row {\n  padding: 0.55rem;\n  border: 1px solid rgba($medium-grey, 0.55);\n  border-radius: 6px;\n  background: rgba($very-dark-grey, 0.35);\n}\n\n.psych-scoring-editor__option-title,\n.psych-scores-readout__option-title,\n.psych-scores-readout__matrix-row-title {\n  margin: 0 0 0.45rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: $very-light-grey;\n}\n\n.question-scoring-toggles {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin: 0.65rem 0 0.85rem;\n  padding: 0.55rem 0.65rem;\n  border-radius: 8px;\n  background: rgba($dark-blue-grey, 0.35);\n  border: 1px solid rgba($accent-blue, 0.2);\n}\n\n.question-scoring-toggles__item {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  font-size: 0.82rem;\n  color: $very-light-grey;\n  cursor: pointer;\n\n  input {\n    margin: 0;\n  }\n}\n\n.psych-scoring-editor__table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.78rem;\n\n  th,\n  td {\n    padding: 0.3rem 0.4rem;\n    border-bottom: 1px solid rgba($medium-grey, 0.35);\n    text-align: left;\n  }\n\n  th[scope=\"row\"] {\n    color: rgba($very-light-grey, 0.82);\n    font-weight: 500;\n  }\n}\n\n.psych-scoring-editor__score-select {\n  min-width: 4rem;\n  padding: 0.2rem 0.35rem;\n  border-radius: 6px;\n  border: 1px solid rgba($accent-blue, 0.35);\n  background: rgba($dark-blue-grey, 0.55);\n  color: $light-grey;\n}\n\n.psych-scoring-editor__matrix {\n  display: grid;\n  gap: 0.5rem;\n}\n\n.psych-scoring-editor__matrix-toggle {\n  width: 100%;\n  text-align: left;\n  padding: 0.45rem 0.55rem;\n  border: 1px solid rgba($medium-grey, 0.55);\n  border-radius: 6px;\n  background: rgba($grey, 0.55);\n  color: $very-light-grey;\n  cursor: pointer;\n\n  &.is-open {\n    border-color: rgba($very-light-yellow, 0.45);\n  }\n}\n\n.psych-scoring-editor__matrix-panel {\n  display: grid;\n  gap: 0.65rem;\n  margin-top: 0.55rem;\n}\n\n.psych-scores-readout__dimensions {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 0.2rem;\n}\n\n.psych-scores-readout__dimension-label {\n  color: rgba($very-light-grey, 0.72);\n}\n\n.psych-scores-readout__dimension-value {\n  margin-left: 0.35rem;\n  color: $very-light-grey;\n  font-weight: 600;\n}\n\n.psych-scores-readout__empty {\n  color: rgba($very-light-grey, 0.55);\n  font-size: 0.78rem;\n}\n","@import './variables.scss';\n\n$member-academy-panel-height: calc(100vh - 480px);\n\n@mixin member-academy-panel-surface {\n  border: 1px solid rgba($accent-blue, 0.35);\n  border-radius: 12px;\n  background:\n    linear-gradient(180deg, rgba($dark-blue, 0.72), rgba($dark-blue-grey, 0.42)),\n    rgba($dark-blue, 0.55);\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.35),\n    0 12px 28px rgba(0, 0, 0, 0.35);\n}\n\n@mixin member-academy-thin-scrollbar {\n  scrollbar-width: thin;\n  scrollbar-color: rgba($accent-blue, 0.45) rgba($dark-blue-grey, 0.35);\n\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba($dark-blue-grey, 0.35);\n    border-radius: 999px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba($accent-blue, 0.45);\n    border-radius: 999px;\n  }\n}\n\n.member-academy {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  width: 100%;\n  max-width: 100%;\n  padding: 0 0 0.5rem;\n  box-sizing: border-box;\n}\n\n.member-academy__loading {\n  display: flex;\n  justify-content: center;\n  padding: 2rem 0;\n}\n\n.member-academy-header {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  flex-shrink: 0;\n  padding: 0.65rem 0.85rem 0.75rem;\n  border-radius: 8px;\n  box-sizing: border-box;\n  background:\n    linear-gradient(180deg, rgba($dark-blue, 0.72), rgba($dark-blue-grey, 0.42)),\n    rgba($dark-blue, 0.55);\n  border: 1px solid rgba($accent-blue, 0.55);\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.35),\n    0 12px 28px rgba(0, 0, 0, 0.35);\n\n  &__top {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 0.85rem 1.25rem;\n  }\n\n  &__title-wrap {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex: 0 0 auto;\n  }\n\n  &__lines {\n    position: relative;\n    width: 20px;\n    height: 27px;\n    flex-shrink: 0;\n\n    span {\n      position: absolute;\n      width: 22px;\n      height: 3px;\n      background: $light-orange;\n      transform: rotate(-65deg);\n      transform-origin: left center;\n\n      &:first-child {\n        top: 20px;\n        left: 12px;\n      }\n\n      &:last-child {\n        top: 20px;\n      }\n    }\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 1.1rem;\n    letter-spacing: 0.12em;\n    text-transform: uppercase;\n    color: $very-light-grey;\n    white-space: nowrap;\n  }\n\n  &__search {\n    min-width: 0;\n  }\n\n  &__toolbar {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 0.65rem;\n  }\n\n  &__view-toggle {\n    display: inline-flex;\n    flex-shrink: 0;\n    border-radius: 10px;\n    overflow: hidden;\n    border: 1px solid $medium-light-grey;\n    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);\n    background: $dark-grey;\n  }\n\n  &__toggle-btn {\n    min-width: 52px;\n    padding: 6px 14px;\n    margin: 0;\n    border: none;\n    background: transparent;\n    color: $light-grey;\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    cursor: pointer;\n    transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;\n\n    &:not(:last-child) {\n      border-right: 1px solid $medium-grey;\n    }\n\n    &:not(.member-academy-header__toggle-btn--active):hover {\n      background: $medium-grey;\n      color: $very-light-grey;\n    }\n\n    &--active {\n      @include steel-bg-transparent('../medias/steel.png', $blue, $dark-blue);\n      color: $very-light-grey;\n      box-shadow: inset 0 0 0 1px $blue;\n    }\n  }\n}\n\n.member-academy__shell {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 520px;\n}\n\n.member-academy__layout {\n  display: grid;\n  grid-template-columns: minmax(280px, 320px) minmax(0, 1fr);\n  gap: 0.5rem;\n  min-height: 0;\n  flex: 1 1 auto;\n  padding: 2px 4px 12px;\n  box-sizing: border-box;\n}\n\n.member-academy-course-list {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  @include member-academy-panel-surface;\n  overflow: visible;\n\n  &__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.75rem;\n    padding: 0.75rem 0.85rem;\n    border-bottom: 1px solid rgba($accent-blue, 0.25);\n    border-radius: 12px 12px 0 0;\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 0.78rem;\n    font-weight: 700;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.82);\n  }\n\n  &__count {\n    font-size: 0.72rem;\n    color: rgba($very-light-grey, 0.55);\n    white-space: nowrap;\n  }\n\n  &__scroll {\n    display: flex;\n    flex-direction: column;\n    gap: 0.45rem;\n    padding: 0.55rem;\n    overflow: auto;\n    max-height: $member-academy-panel-height;\n    margin-bottom: 10px;\n    border-radius: 0 0 12px 12px;\n    @include member-academy-thin-scrollbar;\n  }\n\n  &__group-title {\n    margin: 0.35rem 0.35rem 0.15rem;\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: rgba($light-blue, 0.88);\n  }\n\n  &__section-separator {\n    margin: 0.9rem 0.35rem;\n    border: 0;\n    border-top: 1px solid rgba($accent-blue, 0.38);\n  }\n\n  &__empty {\n    margin: 0.75rem 0.35rem;\n    color: $light-grey;\n    font-size: 0.9rem;\n  }\n}\n\n.member-academy-course-item {\n  display: flex;\n  align-items: stretch;\n\n  &--selected .member-academy-course-item__main {\n    border-color: rgba($light-blue, 0.85);\n    box-shadow: 0 0 0 1px rgba($light-blue, 0.35);\n    background: rgba($accent-blue, 0.28);\n  }\n\n  &--search-match .member-academy-course-item__main--search-match,\n  &--selected.member-academy-course-item--search-match .member-academy-course-item__main--search-match {\n    border-color: $light-orange;\n    box-shadow: 0 0 0 1px rgba($light-orange, 0.35);\n  }\n\n  &--search-match:not(&--selected) .member-academy-course-item__main--search-match:hover {\n    border-color: $light-orange;\n  }\n\n  &__main {\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.2rem;\n    min-width: 0;\n    width: 100%;\n    padding: 0.55rem 0.65rem;\n    border: 1px solid rgba($accent-blue, 0.28);\n    border-radius: 8px;\n    background: rgba($dark-panel-blue, 0.55);\n    color: inherit;\n    text-align: left;\n    cursor: pointer;\n    transition:\n      border-color 0.15s ease,\n      background 0.15s ease,\n      box-shadow 0.15s ease;\n\n    &:hover {\n      border-color: rgba($light-blue, 0.55);\n      background: rgba($accent-blue, 0.22);\n    }\n\n    &:focus-visible {\n      outline: 2px solid rgba($accent-blue, 0.75);\n      outline-offset: 2px;\n    }\n  }\n\n  &__name {\n    font-size: 0.92rem;\n    font-weight: 700;\n    color: $very-light-grey;\n    line-height: 1.25;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 100%;\n  }\n\n  &__meta {\n    font-size: 0.74rem;\n    color: rgba($light-grey, 0.92);\n  }\n\n  &--promotion-locked .member-academy-course-item__main--promotion-locked {\n    border-style: dashed;\n  }\n}\n\n.member-academy-detail {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n  height: $member-academy-panel-height;\n  max-height: $member-academy-panel-height;\n  padding: 1rem;\n  overflow: auto;\n  @include member-academy-panel-surface;\n  @include member-academy-thin-scrollbar;\n\n  &--empty {\n    justify-content: center;\n    align-items: flex-start;\n  }\n\n  &--promotion-locked {\n    overflow: hidden;\n    position: relative;\n  }\n\n  &__body {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    flex: 1 1 auto;\n  }\n\n  &__body--locked {\n    min-height: 12rem;\n    flex: 1 1 auto;\n  }\n\n  &__body-blur {\n    filter: blur(5px);\n    opacity: 0.42;\n    pointer-events: none;\n    user-select: none;\n  }\n\n  &__lock-card {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    z-index: 2;\n    width: unquote('min(92%, 26rem)');\n    padding: 0.85rem 1rem;\n    border-radius: 10px;\n    border: 1px solid rgba($accent-blue, 0.45);\n    background: rgba($dark-blue-grey, 0.95);\n    box-shadow:\n      0 10px 28px rgba(0, 0, 0, 0.45),\n      0 0 0 1px rgba(0, 0, 0, 0.25);\n    transform: translate(-50%, -50%);\n  }\n\n  &__lock-card-title {\n    margin: 0 0 0.45rem;\n    font-size: 0.82rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.92);\n  }\n\n  &__lock-card-text {\n    margin: 0;\n    font-size: 0.86rem;\n    line-height: 1.45;\n    color: rgba($light-grey, 0.95);\n  }\n\n  &__empty {\n    margin: 0;\n    color: rgba($very-light-grey, 0.72);\n    font-size: 0.95rem;\n  }\n\n  &__header {\n    margin-bottom: 1rem;\n    padding-bottom: 0.85rem;\n    border-bottom: 1px solid rgba($accent-blue, 0.22);\n  }\n\n  &__header-top {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 0.75rem;\n  }\n\n  &__header-main {\n    min-width: 0;\n    flex: 1 1 auto;\n  }\n\n  &__header-actions {\n    flex: 0 0 auto;\n    display: flex;\n    align-items: flex-start;\n    padding-top: 0.05rem;\n  }\n\n  &__title {\n    margin: 0 0 0.45rem;\n    font-size: 1.15rem;\n    font-weight: 700;\n    letter-spacing: 0.02em;\n    color: $very-light-grey;\n  }\n\n  &__meta {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.35rem;\n    margin-bottom: 0;\n  }\n\n  &__badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 0.2rem 0.55rem;\n    border: 1px solid rgba($accent-blue, 0.35);\n    border-radius: 999px;\n    background: rgba($dark-blue, 0.45);\n    color: rgba($light-blue, 0.92);\n    font-size: 0.72rem;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n\n    &--next-rank {\n      border-color: rgba($light-orange, 0.45);\n      color: rgba($light-orange, 0.95);\n    }\n  }\n\n  &__description {\n    margin: 0.65rem 0 0;\n    color: rgba($light-grey, 0.95);\n    line-height: 1.5;\n    font-size: 0.92rem;\n  }\n\n  &__section {\n    display: flex;\n    flex-direction: column;\n    gap: 0.65rem;\n  }\n\n  &__section-title {\n    margin: 0;\n    font-size: 0.78rem;\n    font-weight: 700;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.82);\n  }\n\n  &__section-empty {\n    margin: 0;\n    color: rgba($light-grey, 0.92);\n    font-size: 0.9rem;\n\n    &--locked {\n      font-style: italic;\n      color: rgba($very-light-grey, 0.62);\n    }\n  }\n\n  &__search-meta {\n    margin: 0.35rem 0 0;\n    font-size: 0.74rem;\n    color: rgba($light-grey, 0.82);\n  }\n}\n\n.member-academy-document-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n\n  &--locked {\n    margin-top: 0.35rem;\n  }\n}\n\n.member-academy-document-row {\n  display: grid;\n  grid-template-columns: minmax(180px, 240px) minmax(0, 1fr);\n  gap: 0.75rem;\n  align-items: start;\n  width: 100%;\n  padding: 0.65rem 0.75rem;\n  border: 1px solid rgba($accent-blue, 0.28);\n  border-radius: 8px;\n  background: rgba($dark-panel-blue, 0.55);\n  color: $very-light-grey;\n  cursor: pointer;\n  text-align: left;\n  transition:\n    border-color 0.15s ease,\n    background 0.15s ease,\n    box-shadow 0.15s ease;\n\n  &:hover {\n    border-color: rgba($light-blue, 0.55);\n    background: rgba($accent-blue, 0.22);\n    box-shadow: 0 0 0 1px rgba($light-blue, 0.18);\n  }\n\n  &:focus-visible {\n    outline: 2px solid rgba($accent-blue, 0.75);\n    outline-offset: 2px;\n  }\n\n  &__main {\n    display: flex;\n    flex-direction: column;\n    gap: 0.2rem;\n    min-width: 0;\n  }\n\n  &__title {\n    font-size: 0.92rem;\n    font-weight: 700;\n    color: $very-light-grey;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__meta {\n    font-size: 0.74rem;\n    font-weight: 600;\n    color: rgba($light-blue, 0.88);\n  }\n\n  &__excerpt-wrap {\n    min-width: 0;\n    overflow: hidden;\n    -webkit-mask-image: linear-gradient(\n      to right,\n      rgba(0, 0, 0, 1) calc(100% - 24px),\n      rgba(0, 0, 0, 0) 100%\n    );\n    mask-image: linear-gradient(\n      to right,\n      rgba(0, 0, 0, 1) calc(100% - 24px),\n      rgba(0, 0, 0, 0) 100%\n    );\n  }\n\n  &__excerpt {\n    margin: 0;\n    font-size: 0.8rem;\n    line-height: 1.4;\n    color: rgba($light-grey, 0.95);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &__excerpt--loading {\n    display: block;\n    font-style: italic;\n    color: rgba($very-light-grey, 0.62);\n  }\n\n  &--locked {\n    min-height: 3.25rem;\n    cursor: default;\n    pointer-events: none;\n    border-style: dashed;\n    opacity: 0.55;\n  }\n}\n\n.member-academy-document-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  gap: 0.55rem;\n\n  &--locked {\n    margin-top: 0.35rem;\n  }\n}\n\n.member-academy-document-card {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.35rem;\n  height: 220px;\n  width: 100%;\n  padding: 0.75rem 0.8rem;\n  border: 1px solid rgba($accent-blue, 0.28);\n  border-radius: 10px;\n  background: rgba($dark-panel-blue, 0.58);\n  color: $very-light-grey;\n  cursor: pointer;\n  text-align: left;\n  overflow: hidden;\n  box-shadow: 0 0 0 1px rgba($light-blue, 0.08);\n  transition:\n    border-color 0.15s ease,\n    background 0.15s ease,\n    box-shadow 0.15s ease,\n    transform 0.15s ease;\n\n  &:hover {\n    border-color: rgba($light-blue, 0.55);\n    background: rgba($accent-blue, 0.22);\n    box-shadow:\n      0 0 0 1px rgba($light-blue, 0.22),\n      0 8px 18px rgba(0, 0, 0, 0.28);\n    transform: translateY(-1px);\n  }\n\n  &:focus-visible {\n    outline: 2px solid rgba($accent-blue, 0.75);\n    outline-offset: 2px;\n  }\n\n  &__title {\n    flex-shrink: 0;\n    font-size: 0.92rem;\n    font-weight: 700;\n    line-height: 1.3;\n    color: $very-light-grey;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 100%;\n  }\n\n  &__meta {\n    flex-shrink: 0;\n    font-size: 0.74rem;\n    font-weight: 600;\n    color: rgba($light-blue, 0.88);\n  }\n\n  &__excerpt-wrap {\n    position: relative;\n    flex: 1;\n    width: 100%;\n    min-height: 0;\n    margin-top: 0.1rem;\n    overflow: hidden;\n    -webkit-mask-image: linear-gradient(\n      to bottom,\n      rgba(0, 0, 0, 1) calc(100% - 30px),\n      rgba(0, 0, 0, 0) 100%\n    );\n    mask-image: linear-gradient(\n      to bottom,\n      rgba(0, 0, 0, 1) calc(100% - 30px),\n      rgba(0, 0, 0, 0) 100%\n    );\n  }\n\n  &__excerpt {\n    margin: 0;\n    font-size: 0.8rem;\n    line-height: 1.45;\n    color: rgba($light-grey, 0.95);\n    white-space: pre-line;\n  }\n\n  &__excerpt--loading {\n    display: block;\n    font-style: italic;\n    color: rgba($very-light-grey, 0.62);\n  }\n\n  &--locked {\n    cursor: default;\n    pointer-events: none;\n    border-style: dashed;\n    opacity: 0.55;\n\n    &:hover {\n      border-color: rgba($accent-blue, 0.28);\n      background: rgba($dark-panel-blue, 0.58);\n      box-shadow: 0 0 0 1px rgba($light-blue, 0.08);\n      transform: none;\n    }\n  }\n}\n\n.member-academy-document-modal {\n  width: 85vw;\n  max-width: 1300px;\n  height: 85vh;\n  max-height: 85vh;\n  border: 1px solid rgba($accent-blue, 0.45);\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.45),\n    0 18px 42px rgba(0, 0, 0, 0.55);\n}\n\n.member-academy-document-modal__body {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.member-academy-document-panel {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  height: 100%;\n}\n\n.member-academy-document-panel__viewer {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.member-academy-document-viewer {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 0.85rem 1rem;\n  border-radius: 10px;\n  border: 1px solid rgba($accent-blue, 0.35);\n  background:\n    linear-gradient(180deg, rgba($dark-blue, 0.55), rgba($dark-blue-grey, 0.38)),\n    rgba($dark-panel-blue, 0.72);\n  box-shadow: inset 0 1px 0 rgba($light-blue, 0.08);\n  width: 100%;\n  box-sizing: border-box;\n  @include member-academy-thin-scrollbar;\n\n  h2,\n  h3 {\n    color: $very-light-grey;\n  }\n\n  p {\n    margin-bottom: 0;\n    color: $very-light-grey;\n  }\n\n  blockquote {\n    margin: 10px 0;\n    color: $very-light-grey;\n    padding: 15px;\n    position: relative;\n    border-left: 3px solid rgba($accent-blue, 0.45);\n\n    &::before,\n    &::after {\n      content: \"\";\n      position: absolute;\n      border: 2px solid rgba($accent-blue, 0.35);\n      border-radius: 6px 0;\n    }\n\n    &::before {\n      top: -3px;\n      left: -3px;\n      width: 50%;\n      height: 50%;\n      border-right: none;\n      border-bottom: none;\n    }\n\n    &::after {\n      bottom: -3px;\n      right: -3px;\n      width: 50%;\n      height: 50%;\n      border-left: none;\n      border-top: none;\n    }\n  }\n\n  pre {\n    background-color: rgba($dark-blue-grey, 0.72);\n    border: 1px solid rgba($accent-blue, 0.35);\n    border-left: 4px solid rgba($light-blue, 0.65);\n    border-radius: 6px;\n    color: $very-light-grey !important;\n    font-size: inherit;\n    line-height: inherit;\n    margin: 0 0 10px;\n    overflow: visible;\n    padding: 20px !important;\n    white-space: pre-wrap;\n    word-break: inherit;\n    word-wrap: break-word;\n    font-family: 'Input', monospace !important;\n  }\n}\n\n@media (max-width: $tablet) {\n  .member-academy__layout {\n    grid-template-columns: 1fr;\n  }\n\n  .member-academy-header__top {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .member-academy-header__search {\n    max-width: none;\n  }\n\n  .member-academy-document-row {\n    grid-template-columns: 1fr;\n    gap: 0.35rem;\n  }\n\n  .member-academy-document-row__excerpt-wrap {\n    -webkit-mask-image: none;\n    mask-image: none;\n  }\n\n  .member-academy-document-row__excerpt {\n    white-space: pre-line;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  }\n\n  .member-academy-course-list__scroll,\n  .member-academy-detail {\n    max-height: none;\n    height: auto;\n    min-height: 280px;\n  }\n\n  .member-academy-detail__header-top {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .member-academy-detail__header-actions {\n    padding-top: 0;\n  }\n\n  .member-academy-exam-room-btn {\n    width: 100%;\n    max-width: none;\n  }\n}\n\n.member-academy-exam-room-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 2.35rem;\n  width: 16.5rem;\n  padding: 0.5rem 0.85rem;\n  border: 1px solid rgba($light-orange, 0.55);\n  border-radius: 8px;\n  background: linear-gradient(\n    145deg,\n    rgba($orange, 0.28),\n    rgba($dark-panel-blue, 0.88)\n  );\n  color: $very-light-grey;\n  font-size: 0.88rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-align: center;\n  line-height: 1.25;\n  cursor: pointer;\n  transition:\n    border-color 0.15s ease,\n    background 0.15s ease,\n    box-shadow 0.15s ease,\n    transform 0.15s ease;\n\n  &:hover:not(:disabled) {\n    border-color: rgba($light-orange, 0.85);\n    box-shadow: 0 0 0 1px rgba($light-orange, 0.25);\n  }\n\n  &:focus-visible {\n    outline: 2px solid rgba($light-orange, 0.75);\n    outline-offset: 2px;\n  }\n\n  &:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n  }\n\n  &__label--hover {\n    display: none;\n  }\n\n  &:hover:not(:disabled) &__label--default {\n    display: none;\n  }\n\n  &:hover:not(:disabled) &__label--hover {\n    display: inline;\n  }\n}\n\n.member-academy-exam-disclaimer-overlay {\n  z-index: 12050;\n}\n\n.member-academy-exam-disclaimer {\n  width: unquote('min(92%, 34rem)');\n  max-height: unquote('min(88vh, 720px)');\n  display: flex;\n  flex-direction: column;\n  border: 1px solid rgba($accent-blue, 0.45);\n  border-radius: 12px;\n  background: rgba($dark-blue-grey, 0.98);\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.45),\n    0 18px 42px rgba(0, 0, 0, 0.55);\n  overflow: hidden;\n\n  &__header {\n    position: relative;\n    padding: 1rem 1rem 0.75rem;\n    border-bottom: 1px solid rgba($accent-blue, 0.25);\n  }\n\n  &__eyebrow {\n    margin: 0 0 0.25rem;\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.12em;\n    text-transform: uppercase;\n    color: rgba($light-blue, 0.88);\n  }\n\n  &__title {\n    margin: 0;\n    padding-right: 2rem;\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: $very-light-grey;\n  }\n\n  &__body {\n    padding: 0.85rem 1rem 1rem;\n    overflow-y: auto;\n    @include member-academy-thin-scrollbar;\n  }\n\n  &__intro {\n    margin: 0 0 0.75rem;\n    font-size: 0.9rem;\n    line-height: 1.45;\n    color: rgba($light-grey, 0.95);\n  }\n\n  &__rules {\n    margin: 0 0 0.85rem;\n    padding-left: 1.1rem;\n    color: rgba($very-light-grey, 0.92);\n    font-size: 0.88rem;\n    line-height: 1.45;\n\n    li + li {\n      margin-top: 0.35rem;\n    }\n  }\n\n  &__checks {\n    display: flex;\n    flex-direction: column;\n    gap: 0.55rem;\n  }\n\n  &__check {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.55rem;\n    font-size: 0.86rem;\n    line-height: 1.4;\n    color: rgba($very-light-grey, 0.92);\n    cursor: pointer;\n  }\n\n  &__checkbox {\n    margin-top: 0.15rem;\n    flex-shrink: 0;\n  }\n\n  &__footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.55rem;\n    padding: 0.75rem 1rem 1rem;\n    border-top: 1px solid rgba($accent-blue, 0.22);\n  }\n}\n","// src/styles/trainingStandards.scss\n\n@import './variables.scss';\n\n.training-standards-page,\n.academy-admin-page {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding-bottom: 1.5rem;\n}\n\n.ts-page-header {\n  margin-bottom: 0.25rem;\n  padding: 1.1rem 1.25rem;\n  border-radius: 14px;\n  border: 1px solid rgba($accent-blue, 0.45);\n  background:\n    linear-gradient(135deg, rgba($dark-blue, 0.88), rgba($dark-blue-grey, 0.55)),\n    rgba($dark-blue, 0.65);\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.28);\n}\n\n.ts-page-header__eyebrow {\n  margin: 0 0 0.35rem;\n  font-size: 0.72rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.62);\n}\n\n.ts-page-header__title {\n  margin: 0;\n  font-size: unquote('clamp(1.15rem, 2vw, 1.45rem)');\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: $very-light-grey;\n}\n\n.ts-layout {\n  display: grid;\n  gap: 1rem;\n\n  &--split {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  @media (max-width: 960px) {\n    &--split {\n      grid-template-columns: 1fr;\n    }\n  }\n}\n\n.ts-panel {\n  padding: 1rem 1.1rem;\n  border-radius: 14px;\n  border: 1px solid rgba($accent-blue, 0.35);\n  background: rgba($dark-blue, 0.52);\n  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.2);\n  min-width: 0;\n\n  &--full {\n    padding: 1.1rem 1.25rem;\n  }\n\n  &__footer {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 1rem;\n    padding-top: 0.75rem;\n    border-top: 1px solid rgba($accent-blue, 0.22);\n  }\n}\n\n.ts-panel__title {\n  margin: 0 0 0.85rem;\n  font-size: 0.82rem;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba($very-light-grey, 0.88);\n\n  &--inline {\n    margin: 0;\n    flex: 1 1 auto;\n  }\n}\n\n.ts-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.55rem 0.75rem;\n  margin-bottom: 0.85rem;\n  padding: 0.85rem 1rem;\n  border-radius: 12px;\n  border: 1px solid rgba($accent-blue, 0.28);\n  background: rgba($dark-blue-grey, 0.38);\n\n  &--compact {\n    padding: 0.65rem 0.85rem;\n    margin-bottom: 0.65rem;\n  }\n}\n\n.ts-input {\n  min-width: 0;\n  padding: 0.45rem 0.65rem;\n  border: 1px solid rgba($accent-blue, 0.45);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 0.84rem;\n  color: $very-light-grey;\n  background: rgba($dark-blue, 0.65);\n\n  &::placeholder {\n    color: rgba($very-light-grey, 0.45);\n  }\n\n  &:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n  }\n\n  &--grow {\n    flex: 1 1 12rem;\n  }\n\n  &--code {\n    flex: 1 1 10rem;\n    min-width: 9rem;\n  }\n\n  &--label {\n    flex: 1 1 10rem;\n    min-width: 9rem;\n  }\n\n  &--desc {\n    flex: 1 1 12rem;\n    min-width: 11rem;\n  }\n\n  &--priority {\n    width: 5.5rem;\n    flex: 0 0 auto;\n  }\n\n  &--date {\n    width: 9rem;\n    flex: 0 0 auto;\n  }\n\n  &--token {\n    width: 100%;\n    min-width: 3.5rem;\n    box-sizing: border-box;\n    text-align: center;\n\n    &::-webkit-inner-spin-button,\n    &::-webkit-outer-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n    }\n\n    &[type='number'] {\n      -moz-appearance: textfield;\n    }\n  }\n}\n\n.ts-select-native {\n  min-width: 0;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0.45rem 1.75rem 0.45rem 0.65rem;\n  border: 1px solid rgba($accent-blue, 0.45);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 0.84rem;\n  color: $very-light-grey;\n  background: rgba($dark-blue, 0.65);\n  appearance: none;\n  background-image:\n    linear-gradient(45deg, transparent 50%, rgba($very-light-grey, 0.75) 50%),\n    linear-gradient(135deg, rgba($very-light-grey, 0.75) 50%, transparent 50%);\n  background-position:\n    calc(100% - 16px) calc(50% - 2px),\n    calc(100% - 11px) calc(50% - 2px);\n  background-size: 5px 5px, 5px 5px;\n  background-repeat: no-repeat;\n\n  &.select-default {\n    color: rgba($very-light-grey, 0.45);\n  }\n\n  &:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n  }\n\n  option {\n    background: $dark-blue-grey;\n    color: $very-light-grey;\n  }\n}\n\n.ts-select {\n  flex: 1 1 11rem;\n  min-width: 10rem;\n\n  .react-select__control {\n    min-height: 2.1rem !important;\n    height: auto !important;\n    min-width: 0 !important;\n    border: 1px solid rgba($accent-blue, 0.45) !important;\n    border-radius: 8px !important;\n    background: rgba($dark-blue, 0.65) !important;\n    box-shadow: none !important;\n  }\n\n  .react-select__value-container {\n    padding: 0.2rem 0.55rem !important;\n  }\n\n  .react-select__single-value,\n  .react-select__placeholder,\n  .react-select__input-container {\n    color: $very-light-grey !important;\n    font-size: 0.84rem !important;\n  }\n\n  .react-select__placeholder {\n    color: rgba($very-light-grey, 0.45) !important;\n  }\n\n  .react-select__indicator {\n    color: rgba($very-light-grey, 0.55) !important;\n  }\n\n  .react-select__menu {\n    background: rgba($dark-blue-grey, 0.98) !important;\n    border: 1px solid rgba($accent-blue, 0.35) !important;\n    border-radius: 8px !important;\n    overflow: hidden;\n  }\n\n  .react-select__option {\n    background: transparent !important;\n    color: $very-light-grey !important;\n    font-size: 0.84rem !important;\n\n    &--is-focused {\n      background: rgba($accent-blue, 0.18) !important;\n    }\n\n    &--is-selected {\n      background: rgba($accent-blue, 0.32) !important;\n      color: $pure-white !important;\n    }\n  }\n}\n\n.ts-table-wrap {\n  overflow: hidden;\n  border-radius: 12px;\n  border: 1px solid rgba($accent-blue, 0.28);\n  background: rgba($dark-blue, 0.38);\n\n  .accounting-table {\n    margin-bottom: 0;\n  }\n\n  > .accounting-table {\n    thead {\n      display: table-header-group;\n      background-size: cover;\n      color: $light-grey;\n      text-transform: uppercase;\n      border-bottom: 2px solid $grey;\n      @include steel-bg(\"../medias/steel.png\");\n    }\n\n    thead th {\n      position: relative;\n      top: auto;\n      z-index: auto;\n      height: 30px;\n      padding: 0 12px;\n      font-size: 0.75em;\n      font-weight: 600;\n      letter-spacing: normal;\n      line-height: 30px;\n      color: $light-grey;\n      background: transparent;\n      border-bottom: none;\n      border-right: none;\n      vertical-align: middle;\n      text-align: left;\n\n      &:not(:last-child)::after {\n        content: '';\n        position: absolute;\n        right: 0;\n        top: 50%;\n        transform: translateY(-50%);\n        width: 1px;\n        height: 65%;\n        background-color: $grey;\n      }\n    }\n  }\n}\n\n.ts-table-scroll {\n  display: block;\n  overflow-y: auto;\n  overflow-x: hidden;\n  @include accounting-inventory-scrollbar;\n\n  .accounting-table thead {\n    display: none;\n  }\n\n  &--themes,\n  &--levels {\n    max-height: 180px;\n  }\n\n  &--all-orgs {\n    max-height: unquote('min(62vh, calc(100vh - 280px))');\n  }\n\n  &--all-orgs-members {\n    max-height: unquote('min(42vh, calc(100vh - 420px))');\n  }\n\n  &--requirements {\n    max-height: 280px;\n  }\n\n  &--rules,\n  &--items {\n    max-height: 220px;\n  }\n\n  &--modules {\n    max-height: unquote('min(520px, calc(100vh - 320px))');\n  }\n\n  &--courses {\n    max-height: unquote('min(420px, calc(100vh - 380px))');\n  }\n\n  &--ranks-requirements {\n    max-height: unquote('min(480px, calc(100vh - 360px))');\n    overflow-x: auto;\n  }\n}\n\n.training-standards-page,\n.academy-admin-page {\n  .ts-status {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 0.55rem;\n    height: 0.55rem;\n    border-radius: 50%;\n\n    &.is-active {\n      background: $light-green;\n      box-shadow: 0 0 0 3px rgba($light-green, 0.18);\n    }\n\n    &.is-inactive {\n      background: rgba($very-light-grey, 0.28);\n      box-shadow: none;\n    }\n  }\n\n  .cell-found,\n  th.header-found {\n    text-align: center;\n    vertical-align: middle;\n  }\n\n  .accounting-table--themes-head,\n  .accounting-table--themes-body {\n    col.col-themeName { width: auto; }\n    col.col-found { width: 5.5rem; }\n  }\n\n  .accounting-table--levels-head,\n  .accounting-table--levels-body {\n    col.col-handle { width: 2rem; }\n    col.col-levelName { width: auto; }\n    col.col-found { width: 5.5rem; }\n  }\n\n  .accounting-table--levels-body {\n    @include dnd-handle;\n  }\n\n  .ts-table-wrap.dnd-locked {\n    .cell-handle {\n      cursor: default;\n      opacity: 0.45;\n    }\n  }\n\n  .accounting-table--requirements-head,\n  .accounting-table--requirements-body {\n    col.col-code { width: 22%; }\n    col.col-label { width: 28%; }\n    col.col-theme { width: 18%; }\n    col.col-trainingLevel { width: 18%; }\n    col.col-version { width: 7rem; }\n  }\n\n  .accounting-table--rules-head,\n  .accounting-table--rules-body {\n    col.col-priority { width: 4.5rem; }\n    col.col-validFrom { width: 32%; }\n    col.col-validTo { width: 32%; }\n    col.col-actions { width: 5.5rem; }\n  }\n\n  .accounting-table--items-head,\n  .accounting-table--items-body {\n    col.col-eventTemplate { width: auto; }\n    col.col-templateId { width: 7rem; }\n  }\n\n  .accounting-table__empty {\n    padding: 1.25rem 0.75rem;\n    font-size: 0.82rem;\n  }\n\n  .accounting-date-input {\n    min-width: 9rem;\n    padding: 0.4rem 0.65rem;\n    border: 1px solid rgba($accent-blue, 0.45);\n    border-radius: 8px;\n    font-family: inherit;\n    font-size: 0.82rem;\n    color: $very-light-grey;\n    background: rgba($dark-blue, 0.65);\n  }\n\n  .ts-equiv-layout {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    margin-top: 0.25rem;\n  }\n\n  .ts-equiv-bottom {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 1rem;\n\n    @media (max-width: 960px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  .ts-subpanel {\n    padding: 0.85rem 1rem;\n    border-radius: 12px;\n    border: 1px solid rgba($accent-blue, 0.22);\n    background: rgba($dark-blue-grey, 0.32);\n    min-width: 0;\n  }\n\n  .accounting-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  .accounting-table--modules-head,\n  .accounting-table--modules-body {\n    col.col-moduleName { width: auto; }\n    col.col-trainingLevel { width: 9rem; }\n    col.col-theme { width: 10rem; }\n    col.col-moduleVersion { width: 5.5rem; }\n    col.col-simple { width: 4.5rem; }\n    col.col-standard { width: 4.5rem; }\n    col.col-complex { width: 4.5rem; }\n    col.col-expert { width: 4.5rem; }\n    col.col-trainings { width: 14rem; }\n    col.col-checklist { width: 7rem; }\n  }\n\n  .accounting-table--courses-head,\n  .accounting-table--courses-body {\n    col.col-course { width: 16%; }\n    col.col-version { width: 6.5rem; }\n    col.col-description { width: auto; }\n    col.col-live { width: 5.5rem; }\n    col.col-actions { width: 5.5rem; }\n    col.col-testing { width: 9rem; }\n  }\n\n  .accounting-table--ranks-requirements-head,\n  .accounting-table--ranks-requirements-body {\n    table-layout: fixed;\n    width: 100%;\n\n    col.col-payGrade { width: 3.5rem; }\n    col.col-rankName { width: 14%; }\n    col.col-rankImageUrl { width: 3.5rem; }\n    col.col-globalTokens { width: 4.5rem; }\n    col.col-missionTokens { width: 4.5rem; }\n    col.col-timeOnPreviousRank { width: 4.5rem; }\n    col.col-courseIds,\n    col.col-grantAccess { width: 12rem; }\n    col.col-certificationIds { width: 12rem; }\n    col.col-lockStatus { width: 4rem; }\n  }\n\n  .accounting-table--ranks-requirements-body {\n    tbody tr {\n      height: auto;\n      min-height: 2.8rem;\n    }\n\n    td {\n      vertical-align: top;\n      overflow: visible;\n    }\n\n    .cell-payGrade,\n    .cell-rankImageUrl,\n    .cell-lockStatus,\n    th.header-payGrade,\n    th.header-rankImageUrl,\n    th.header-lockStatus {\n      text-align: center;\n      vertical-align: middle;\n    }\n\n    .cell-rankImageUrl img.rank-image {\n      max-width: 20px;\n      display: block;\n      margin: 0 auto;\n    }\n\n    .cell-certificationIds,\n    .cell-courseIds {\n      overflow: hidden;\n      max-width: 0;\n    }\n\n    .cell-grantAccess {\n      overflow: hidden;\n      max-width: 0;\n    }\n\n    .certificationsSelect {\n      min-width: 0;\n      width: 100%;\n      max-width: 100%;\n\n      .hierarchy-select-container {\n        width: 100%;\n        max-width: 100%;\n        min-width: 0;\n      }\n\n      .certifications-select-trigger {\n        width: 100%;\n        max-width: 100%;\n      }\n    }\n\n    .cell-grantAccess .ts-select-native {\n      width: 100%;\n      max-width: 100%;\n      min-width: 0;\n    }\n\n    .toggle.ranks.division {\n      display: flex;\n      justify-content: center;\n      margin: 0 auto;\n    }\n  }\n\n  .ts-table-wrap--ranks-requirements {\n    overflow: visible;\n  }\n\n  .accounting-table--courses-body {\n    tr.course-row {\n      &.online {\n        box-shadow: inset 0 0 0 1px rgba($light-green, 0.65);\n      }\n\n      &.offline {\n        box-shadow: inset 0 0 0 1px rgba($orange, 0.75);\n      }\n    }\n\n    td.cell-live {\n      text-align: center;\n      vertical-align: middle;\n\n      .course-live-toggle {\n        margin: 0 auto;\n      }\n    }\n  }\n\n  .ts-live-users {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 0.35rem 0.5rem;\n    margin-left: auto;\n    font-size: 0.82rem;\n    color: rgba($very-light-grey, 0.78);\n\n    &__label {\n      font-size: 0.72rem;\n      letter-spacing: 0.06em;\n      text-transform: uppercase;\n      color: rgba($very-light-grey, 0.55);\n    }\n\n    &__value {\n      color: $very-light-grey;\n    }\n  }\n\n  .ts-toolbar__actions {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 0.5rem;\n    margin-left: auto;\n  }\n\n  .ts-panel--rank-chart {\n    .admin-block-container.token-chart {\n      margin: 0;\n      padding: 0;\n      min-height: 0;\n      background: transparent;\n      border: none;\n      box-shadow: none;\n\n      &.preview {\n        padding: 0.65rem;\n        border: 1px solid $bright-red;\n        border-radius: 12px;\n      }\n    }\n  }\n\n  .ts-panel--ranks-requirements {\n    overflow: visible;\n\n    .token-table-root {\n      margin-top: 0.85rem;\n    }\n  }\n}\n\n.ts-panel--org-ranks-table {\n  overflow: visible;\n\n  .ranks-type-description {\n    margin-top: 0.35rem;\n  }\n\n  .table-base.ranks {\n    margin-top: 1rem;\n  }\n\n  .lexical-document-footer {\n    padding: 0.75rem 0 0;\n    margin-left: 0;\n  }\n}\n\n// Create module modal — general info + training reference blocks\n.modal.create-module {\n  .create-module-dual-panel {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr);\n    gap: 1rem;\n    align-items: stretch;\n    margin: 0 10px 1rem;\n  }\n\n  .create-module-dual-panel__col {\n    display: flex;\n    min-width: 0;\n    width: auto;\n  }\n\n  .ts-module-block {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    padding: 0.85rem 1rem;\n    border-radius: 12px;\n    border: 1px solid rgba($accent-blue, 0.35);\n    background: rgba($dark-blue-grey, 0.38);\n    min-width: 0;\n    min-height: 100%;\n    box-sizing: border-box;\n    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);\n  }\n\n  .ts-form-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n    flex: 1;\n  }\n\n  .ts-field {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n    margin: 0;\n  }\n\n  .ts-field__label {\n    font-size: 0.72rem;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.72);\n  }\n\n  .ts-select-native,\n  .ts-module-block .ts-input {\n    width: 100%;\n    box-sizing: border-box;\n    min-width: 0;\n    padding: 0.5rem 0.7rem;\n    border: 1px solid rgba($accent-blue, 0.62);\n    border-radius: 8px;\n    font-family: inherit;\n    font-size: 0.84rem;\n    color: $very-light-grey;\n    background: rgba($panel-blue, 0.92);\n    box-shadow:\n      inset 0 1px 2px rgba(0, 0, 0, 0.22),\n      0 0 0 1px rgba($accent-blue, 0.08);\n\n    &::placeholder {\n      color: rgba($very-light-grey, 0.45);\n    }\n\n    &:disabled {\n      opacity: 0.55;\n      cursor: not-allowed;\n    }\n  }\n\n  .ts-select-native {\n    appearance: none;\n    background-image:\n      linear-gradient(45deg, transparent 50%, rgba($very-light-grey, 0.75) 50%),\n      linear-gradient(135deg, rgba($very-light-grey, 0.75) 50%, transparent 50%);\n    background-position:\n      calc(100% - 16px) calc(50% - 2px),\n      calc(100% - 11px) calc(50% - 2px);\n    background-size: 5px 5px, 5px 5px;\n    background-repeat: no-repeat;\n    padding-right: 2rem;\n\n    option {\n      background: $dark-blue-grey;\n      color: $very-light-grey;\n    }\n  }\n\n  .ts-checkbox-field {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    font-size: 0.84rem;\n    color: rgba($very-light-grey, 0.88);\n    cursor: pointer;\n\n    input {\n      accent-color: $accent-blue;\n    }\n\n    input:disabled + span {\n      opacity: 0.55;\n      cursor: not-allowed;\n    }\n  }\n\n  .training-reference-picker {\n    .ts-toolbar {\n      margin-bottom: 0.65rem;\n    }\n\n    .ts-select {\n      flex: 1 1 12rem;\n      min-width: 0;\n    }\n\n    .ts-table-wrap {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      min-height: 0;\n    }\n\n    .ts-module-block__footer {\n      margin-top: auto;\n      padding-top: 0.75rem;\n    }\n  }\n\n  .ts-module-block__empty {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0;\n    padding: 1.5rem 1rem;\n    border-radius: 10px;\n    border: 1px dashed rgba($accent-blue, 0.28);\n    background: rgba($dark-blue, 0.28);\n    font-size: 0.82rem;\n    color: rgba($very-light-grey, 0.55);\n    text-align: center;\n  }\n\n  .ts-select {\n    .react-select__control {\n      min-height: 2.15rem !important;\n      border: 1px solid rgba($accent-blue, 0.62) !important;\n      background: rgba($panel-blue, 0.92) !important;\n      box-shadow:\n        inset 0 1px 2px rgba(0, 0, 0, 0.22),\n        0 0 0 1px rgba($accent-blue, 0.08) !important;\n    }\n\n    .react-select__single-value,\n    .react-select__placeholder {\n      color: $very-light-grey !important;\n    }\n\n    .react-select__placeholder {\n      color: rgba($very-light-grey, 0.5) !important;\n    }\n  }\n\n  .ts-module-block__footer {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 0.75rem;\n  }\n\n  .accounting-table--training-refs-head,\n  .accounting-table--training-refs-body {\n    col.col-label { width: auto; }\n    col.col-version { width: 5rem; }\n    col.col-theme { width: 28%; }\n    col.col-trainingLevel { width: 24%; }\n    col.col-actions { width: 3.5rem; }\n  }\n\n  .ts-table-scroll--training-refs {\n    flex: 1;\n    max-height: none;\n    min-height: 120px;\n  }\n\n  .cell-actions {\n    text-align: center;\n    vertical-align: middle;\n  }\n}\n\n// ---------------------------------------------------------------------------\n// Org Positions — command hierarchy\n// ---------------------------------------------------------------------------\n\n.org-positions-page {\n  .ts-page-header {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n  }\n\n  &__header {\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 1rem;\n    flex-wrap: wrap;\n  }\n\n  &__header-text {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n    min-width: 0;\n  }\n\n  &__header-actions {\n    display: flex;\n    align-items: center;\n    gap: 0.65rem;\n    flex: 1 1 auto;\n    min-width: 0;\n    flex-wrap: wrap;\n  }\n\n  &__add-btn,\n  &__hint-btn {\n    flex: 0 0 auto;\n    white-space: nowrap;\n  }\n\n  &__add-btn:only-child,\n  &__hint-btn {\n    margin-left: auto;\n  }\n\n  &__subtitle {\n    margin: 0.15rem 0 0;\n    font-size: 0.88rem;\n    color: rgba($very-light-grey, 0.72);\n    max-width: 52rem;\n  }\n\n  &__error {\n    margin: 0 0 0.85rem;\n    padding: 0.65rem 0.85rem;\n    border-radius: 10px;\n    border: 1px solid rgba($bright-red, 0.45);\n    background: rgba($dark-red, 0.35);\n    color: $very-light-grey;\n  }\n}\n\n.org-positions-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.org-positions-layout {\n  display: flex;\n  align-items: stretch;\n  gap: 0.85rem;\n  min-height: 0;\n\n  &__list {\n    flex: 1 1 0;\n    min-width: 0;\n  }\n\n  &__editor {\n    flex: 0 0 620px;\n    max-width: 55%;\n    min-width: 300px;\n  }\n}\n\n.org-position-editor {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  max-height: unquote('min(560px, calc(100vh - 340px))');\n  border-radius: 12px;\n  border: 1px solid rgba($accent-blue, 0.28);\n  background: rgba($dark-blue-grey, 0.42);\n  overflow: hidden;\n\n  &--empty {\n    align-items: center;\n    justify-content: center;\n    padding: 1.5rem;\n  }\n\n  &__placeholder {\n    margin: 0;\n    text-align: center;\n    color: rgba($very-light-grey, 0.65);\n    font-size: 0.9rem;\n    line-height: 1.5;\n  }\n\n  &__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.75rem;\n    padding: 0.85rem 1rem;\n    border-bottom: 1px solid rgba($accent-blue, 0.22);\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 0.78rem;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.78);\n  }\n\n  &__delete-hold {\n    flex: 0 0 auto;\n    min-height: 32px;\n    padding: 0 12px;\n    font-size: 0.78rem;\n  }\n\n  &__body {\n    flex: 1 1 auto;\n    overflow: auto;\n    padding: 0.85rem 1rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.85rem;\n    @include accounting-inventory-scrollbar;\n  }\n\n  &__field {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n  }\n\n  &__label {\n    font-size: 0.72rem;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.62);\n  }\n\n  &__hint {\n    margin: 0;\n    font-size: 0.74rem;\n    line-height: 1.35;\n    color: rgba($very-light-grey, 0.55);\n  }\n\n  &__copy-row {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-end;\n    justify-content: flex-start;\n    gap: 0.75rem;\n  }\n\n  &__prerequisite {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n    flex: 1 1 12rem;\n    min-width: 10rem;\n  }\n\n  &__prerequisite-select {\n    width: 100%;\n  }\n\n  &__logo-field {\n    display: flex;\n    flex-direction: column;\n    gap: 0.45rem;\n  }\n\n  &__textarea {\n    min-height: 6rem;\n    resize: vertical;\n  }\n\n  &__section-title {\n    margin: 0;\n    font-size: 0.78rem;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.78);\n  }\n\n  &__list-block {\n    display: flex;\n    flex-direction: column;\n    gap: 0.55rem;\n  }\n\n  &__list-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.5rem;\n  }\n\n  &__add-field {\n    white-space: nowrap;\n  }\n\n  &__empty-hint {\n    margin: 0;\n    font-size: 0.82rem;\n    color: rgba($very-light-grey, 0.55);\n  }\n\n  &__list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 0.45rem;\n  }\n\n  &__list-item {\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n  }\n\n  &__list-input {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  &__list-remove {\n    flex: 0 0 1.75rem;\n    width: 1.75rem;\n    height: 1.75rem;\n    border: none;\n    border-radius: 6px;\n    background: rgba($bright-red, 0.18);\n    color: $bright-red;\n    font-size: 1.1rem;\n    line-height: 1;\n    cursor: pointer;\n\n    &:hover:not(:disabled) {\n      background: rgba($bright-red, 0.32);\n    }\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n  }\n\n  &__error {\n    margin: 0;\n    padding: 0.55rem 0.7rem;\n    border-radius: 8px;\n    border: 1px solid rgba($bright-red, 0.45);\n    background: rgba($dark-red, 0.35);\n    color: $very-light-grey;\n    font-size: 0.84rem;\n  }\n\n  &__footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.55rem;\n    padding: 0.75rem 1rem;\n    border-top: 1px solid rgba($accent-blue, 0.22);\n  }\n}\n\n.org-position-logo-manage {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.65rem 0.75rem;\n  border-radius: 10px;\n  border: 1px solid rgba($accent-blue, 0.22);\n  background: rgba($dark-blue, 0.28);\n\n  &__preview-wrap,\n  &__placeholder {\n    flex: 0 0 50px;\n    width: 50px;\n    height: 50px;\n    border-radius: 10px;\n    overflow: hidden;\n    border: 1px solid rgba($accent-blue, 0.35);\n    background: rgba($medium-grey, 0.55);\n  }\n\n  &__preview {\n    display: block;\n    width: 50px;\n    height: 50px;\n    object-fit: cover;\n  }\n\n  &__placeholder {\n    position: relative;\n\n    &::after {\n      content: '';\n      position: absolute;\n      inset: 14px;\n      border-radius: 4px;\n      border: 1px dashed rgba($very-light-grey, 0.35);\n    }\n  }\n\n  &__actions {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 0.45rem;\n  }\n\n  &__btn {\n    min-height: 32px;\n    padding: 0 12px;\n    font-size: 0.78rem;\n  }\n}\n\n.org-position-logo-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1210;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background: rgba($dark-blue, 0.72);\n}\n\n.org-position-logo-modal {\n  width: 100%;\n  max-width: 420px;\n  display: flex;\n  flex-direction: column;\n  border-radius: 14px;\n  border: 1px solid rgba($accent-blue, 0.35);\n  background: rgba($dark-blue-grey, 0.98);\n  overflow: hidden;\n  box-shadow: 0 20px 52px rgba(0, 0, 0, 0.5);\n\n  &__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.75rem;\n    padding: 0.9rem 1rem;\n    border-bottom: 1px solid rgba($accent-blue, 0.22);\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 0.9rem;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.88);\n  }\n\n  &__close {\n    width: 2rem;\n    height: 2rem;\n    border: none;\n    border-radius: 8px;\n    background: rgba($medium-grey, 0.65);\n    color: $very-light-grey;\n    font-size: 1.25rem;\n    line-height: 1;\n    cursor: pointer;\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n\n    &:hover:not(:disabled) {\n      background: rgba($accent-blue, 0.45);\n    }\n  }\n\n  &__body {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n    padding: 1rem;\n  }\n\n  &__hint {\n    margin: 0;\n    font-size: 0.78rem;\n    color: rgba($very-light-grey, 0.55);\n  }\n\n  &__dropzone {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 168px;\n    padding: 1rem;\n    border-radius: 12px;\n    border: 1.5px dashed rgba($accent-blue, 0.4);\n    background: rgba($dark-blue, 0.35);\n    transition: border-color 0.15s ease, background 0.15s ease;\n\n    &.is-dragover {\n      border-color: rgba($accent-blue, 0.85);\n      background: rgba($accent-blue, 0.18);\n    }\n\n    &.has-preview {\n      border-style: solid;\n      border-color: rgba($accent-blue, 0.35);\n    }\n  }\n\n  &__preview {\n    max-width: 140px;\n    max-height: 140px;\n    width: auto;\n    height: auto;\n    border-radius: 10px;\n    object-fit: contain;\n  }\n\n  &__drop-copy {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 0.35rem;\n    text-align: center;\n  }\n\n  &__drop-glyph {\n    display: block;\n    width: 2.25rem;\n    height: 2.25rem;\n    margin-bottom: 0.25rem;\n    border-radius: 999px;\n    border: 1px solid rgba($accent-blue, 0.45);\n    background: rgba($accent-blue, 0.15);\n    position: relative;\n\n    &::before {\n      content: '';\n      position: absolute;\n      left: 50%;\n      top: 42%;\n      width: 0.7rem;\n      height: 0.7rem;\n      border-right: 2px solid rgba($very-light-grey, 0.8);\n      border-bottom: 2px solid rgba($very-light-grey, 0.8);\n      transform: translate(-50%, -60%) rotate(45deg);\n    }\n  }\n\n  &__drop-title {\n    margin: 0;\n    font-size: 0.92rem;\n    color: rgba($very-light-grey, 0.9);\n  }\n\n  &__drop-sub {\n    margin: 0;\n    font-size: 0.78rem;\n    color: rgba($very-light-grey, 0.55);\n  }\n\n  &__actions-row {\n    display: flex;\n    justify-content: center;\n  }\n\n  &__file-input {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0;\n  }\n\n  &__error {\n    margin: 0;\n    padding: 0.55rem 0.7rem;\n    border-radius: 8px;\n    border: 1px solid rgba($bright-red, 0.45);\n    background: rgba($dark-red, 0.35);\n    color: $very-light-grey;\n    font-size: 0.84rem;\n  }\n\n  &__footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.55rem;\n    padding: 0.75rem 1rem;\n    border-top: 1px solid rgba($accent-blue, 0.22);\n  }\n}\n\n.org-position-apply-hint-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1220;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background: rgba($dark-blue, 0.72);\n}\n\n.org-position-apply-hint-modal {\n  width: 100%;\n  max-width: 720px;\n  max-height: unquote('min(90vh, 760px)');\n  display: flex;\n  flex-direction: column;\n  border-radius: 14px;\n  border: 1px solid rgba($accent-blue, 0.35);\n  background: rgba($dark-blue-grey, 0.98);\n  overflow: hidden;\n  box-shadow: 0 20px 52px rgba(0, 0, 0, 0.5);\n\n  &__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.75rem;\n    padding: 0.9rem 1rem;\n    border-bottom: 1px solid rgba($accent-blue, 0.22);\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 0.9rem;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.88);\n  }\n\n  &__close {\n    width: 2rem;\n    height: 2rem;\n    border: none;\n    border-radius: 8px;\n    background: rgba($medium-grey, 0.65);\n    color: $very-light-grey;\n    font-size: 1.25rem;\n    line-height: 1;\n    cursor: pointer;\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n\n    &:hover:not(:disabled) {\n      background: rgba($accent-blue, 0.45);\n    }\n  }\n\n  &__body {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n    padding: 1rem;\n    min-height: 0;\n    overflow: auto;\n  }\n\n  &__hint {\n    margin: 0;\n    font-size: 0.78rem;\n    color: rgba($very-light-grey, 0.55);\n  }\n\n  &__loading {\n    margin: 0;\n    padding: 1.5rem 0;\n    text-align: center;\n    font-size: 0.88rem;\n    color: rgba($very-light-grey, 0.65);\n  }\n\n  &__editor {\n    min-height: 220px;\n    border-radius: 10px;\n    border: 1px solid rgba($accent-blue, 0.28);\n    background: rgba($dark-blue, 0.28);\n    overflow: hidden;\n\n    .lexical-container {\n      min-height: 220px;\n    }\n  }\n\n  &__error {\n    margin: 0;\n    padding: 0.55rem 0.7rem;\n    border-radius: 8px;\n    border: 1px solid rgba($bright-red, 0.45);\n    background: rgba($dark-red, 0.35);\n    color: $very-light-grey;\n    font-size: 0.84rem;\n  }\n\n  &__footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.55rem;\n    padding: 0.75rem 1rem;\n    border-top: 1px solid rgba($accent-blue, 0.22);\n  }\n}\n\n.org-position-copy-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background: rgba($dark-blue, 0.72);\n}\n\n.org-position-copy-modal {\n  width: 100%;\n  max-width: 520px;\n  max-height: unquote('min(88vh, 720px)');\n  display: flex;\n  flex-direction: column;\n  border-radius: 12px;\n  border: 1px solid rgba($accent-blue, 0.35);\n  background: rgba($dark-blue-grey, 0.97);\n  overflow: hidden;\n  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.45);\n\n  &__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.75rem;\n    padding: 0.85rem 1rem;\n    border-bottom: 1px solid rgba($accent-blue, 0.22);\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 0.95rem;\n    color: $very-light-grey;\n  }\n\n  &__close {\n    border: none;\n    background: transparent;\n    color: rgba($very-light-grey, 0.75);\n    font-size: 1.4rem;\n    line-height: 1;\n    cursor: pointer;\n    padding: 0.15rem 0.35rem;\n\n    &:hover:not(:disabled) {\n      color: $very-light-grey;\n    }\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n  }\n\n  &__body {\n    display: flex;\n    flex-direction: column;\n    gap: 0.85rem;\n    padding: 0.9rem 1rem 1rem;\n    overflow: auto;\n    @include accounting-inventory-scrollbar;\n  }\n\n  &__field,\n  &__fieldset,\n  &__targets {\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n  }\n\n  &__fieldset {\n    margin: 0;\n    padding: 0.65rem 0.75rem;\n    border-radius: 10px;\n    border: 1px solid rgba($accent-blue, 0.25);\n    background: rgba($dark-blue, 0.28);\n  }\n\n  &__label {\n    font-size: 0.72rem;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.62);\n  }\n\n  &__check {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.5rem;\n    font-size: 0.86rem;\n    color: rgba($very-light-grey, 0.9);\n    cursor: pointer;\n\n    input {\n      margin-top: 0.15rem;\n    }\n  }\n\n  &__target-label {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 0.35rem 0.5rem;\n    min-width: 0;\n  }\n\n  &__target-name {\n    word-break: break-word;\n  }\n\n  &__level {\n    display: inline-flex;\n    align-items: center;\n    padding: 0.1rem 0.4rem;\n    border-radius: 999px;\n    font-size: 0.66rem;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    border: 1px solid rgba($accent-blue, 0.35);\n    background: rgba($accent-blue, 0.16);\n    color: $light-blue;\n\n    &--division {\n      border-color: rgba($light-blue, 0.35);\n      background: rgba($blue, 0.35);\n    }\n\n    &--branch {\n      border-color: rgba($very-light-purple, 0.35);\n      background: rgba($very-light-purple, 0.12);\n      color: $very-light-purple;\n    }\n\n    &--section {\n      border-color: rgba($light-green, 0.35);\n      background: rgba($dark-green, 0.22);\n      color: $light-green;\n    }\n\n    &--custom {\n      border-color: rgba($very-light-purple, 0.4);\n      background: rgba($very-light-purple, 0.14);\n      color: $very-light-purple;\n    }\n  }\n\n  &__targets-head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.55rem;\n    flex-wrap: wrap;\n  }\n\n  &__targets-actions {\n    display: flex;\n    gap: 0.4rem;\n    flex-wrap: wrap;\n  }\n\n  &__filter {\n    width: 100%;\n  }\n\n  &__target-list {\n    max-height: 220px;\n    overflow: auto;\n    padding: 0.55rem 0.65rem;\n    border-radius: 10px;\n    border: 1px solid rgba($accent-blue, 0.22);\n    background: rgba($dark-blue, 0.22);\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n    @include accounting-inventory-scrollbar;\n  }\n\n  &__empty,\n  &__hint {\n    margin: 0;\n    font-size: 0.78rem;\n    color: rgba($very-light-grey, 0.58);\n  }\n\n  &__error {\n    margin: 0;\n    padding: 0.55rem 0.7rem;\n    border-radius: 8px;\n    border: 1px solid rgba($bright-red, 0.45);\n    background: rgba($dark-red, 0.35);\n    color: $very-light-grey;\n    font-size: 0.84rem;\n  }\n\n  &__footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.55rem;\n    padding-top: 0.25rem;\n  }\n}\n\n.officer-cadet-progression-page {\n  .ts-page-header {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n  }\n\n  &__subtitle {\n    margin: 0.15rem 0 0;\n    font-size: 0.88rem;\n    color: rgba($very-light-grey, 0.72);\n    max-width: 52rem;\n  }\n\n  &__placeholder {\n    margin: 0;\n    color: rgba($very-light-grey, 0.78);\n    font-size: 0.9rem;\n    line-height: 1.55;\n  }\n}\n\n.officer-cadet-progression-panel {\n  padding: 1rem 1.1rem;\n}\n\n.org-positions-kpi {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.85rem 1rem;\n  padding: 0.85rem 1rem;\n  border-radius: 12px;\n  border: 1px solid rgba($accent-blue, 0.28);\n  background: rgba($dark-blue-grey, 0.38);\n\n  &__metrics {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.65rem 1rem;\n  }\n\n  &__metric {\n    display: flex;\n    flex-direction: column;\n    gap: 0.15rem;\n    min-width: 5.5rem;\n    padding: 0.45rem 0.75rem;\n    border-radius: 10px;\n    border: 1px solid rgba($accent-blue, 0.22);\n    background: rgba($dark-blue, 0.45);\n\n    &--filled {\n      border-color: rgba($light-green, 0.35);\n      background: rgba($darker-green, 0.28);\n    }\n\n    &--open {\n      border-color: rgba($light-orange, 0.35);\n      background: rgba($dark-orange, 0.22);\n    }\n  }\n\n  &__metric-value {\n    font-size: 1.25rem;\n    font-weight: 700;\n    line-height: 1;\n    color: $very-light-grey;\n  }\n\n  &__metric-label {\n    font-size: 0.72rem;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.62);\n  }\n\n  &__controls {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 0.55rem 0.75rem;\n    flex: 1 1 18rem;\n    justify-content: flex-end;\n  }\n\n  &__search {\n    flex: 1 1 12rem;\n    max-width: 18rem;\n  }\n\n  &__toggle {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.4rem;\n    font-size: 0.84rem;\n    color: rgba($very-light-grey, 0.85);\n    cursor: pointer;\n    user-select: none;\n  }\n\n  &__btn {\n    white-space: nowrap;\n  }\n}\n\n.org-positions-table {\n  border-radius: 12px;\n  border: 1px solid rgba($accent-blue, 0.28);\n  background: rgba($dark-blue-grey, 0.28);\n  overflow: auto;\n  max-height: unquote('min(560px, calc(100vh - 340px))');\n  @include accounting-inventory-scrollbar;\n\n  &--loading,\n  &--empty {\n    padding: 2rem 1rem;\n    text-align: center;\n    color: rgba($very-light-grey, 0.72);\n  }\n\n  &--compact {\n    .org-positions-table__grid {\n      min-width: 0;\n\n      col.col-org-positions-unit { width: auto; }\n      col.col-org-positions-level { width: 5.5rem; }\n      col.col-org-positions-avatar { width: 2.75rem; }\n    }\n\n    .org-positions-table__avatar-head,\n    .org-positions-row__avatar {\n      padding-left: 0.35rem;\n      padding-right: 0.45rem;\n      text-align: center;\n    }\n\n    .org-positions-unit {\n      &[data-depth='2'] { padding-left: 0.85rem; }\n      &[data-depth='3'] { padding-left: 1.6rem; }\n      &[data-depth='4'] { padding-left: 2.35rem; }\n\n      &__logo,\n      &__logo-fallback {\n        flex: 0 0 1.65rem;\n        width: 1.65rem;\n        height: 1.65rem;\n        border-radius: 6px;\n      }\n\n      &__name {\n        font-size: 0.84rem;\n      }\n\n      &__short {\n        font-size: 0.7rem;\n      }\n    }\n\n    .org-positions-level {\n      font-size: 0.66rem;\n      padding: 0.15rem 0.4rem;\n    }\n  }\n\n  &__grid {\n    width: 100%;\n    border-collapse: collapse;\n    min-width: 720px;\n\n    col.col-org-positions-unit { width: 34%; }\n    col.col-org-positions-level { width: 12%; }\n    col.col-org-positions-commander { width: 38%; }\n    col.col-org-positions-status { width: 16%; }\n\n    thead th {\n      position: sticky;\n      top: 0;\n      z-index: 1;\n      padding: 0.75rem 0.85rem;\n      text-align: left;\n      font-size: 0.72rem;\n      letter-spacing: 0.07em;\n      text-transform: uppercase;\n      color: rgba($very-light-grey, 0.72);\n      background: rgba($dark-blue, 0.92);\n      border-bottom: 1px solid rgba($accent-blue, 0.32);\n    }\n\n    tbody td {\n      padding: 0.65rem 0.85rem;\n      vertical-align: middle;\n      border-bottom: 1px solid rgba($accent-blue, 0.14);\n    }\n  }\n}\n\n.org-positions-avatar-cell {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.75rem;\n  height: 1.75rem;\n\n  &--empty {\n    opacity: 0.35;\n  }\n\n  &__img {\n    width: 1.75rem;\n    height: 1.75rem;\n    border-radius: 50%;\n    object-fit: cover;\n    border: 1px solid rgba($light-blue, 0.35);\n    background: rgba($dark-blue, 0.45);\n  }\n}\n\n.org-positions-row {\n  border-left: 3px solid var(--org-positions-accent, rgba($accent-blue, 0.35));\n  transition: background 0.15s ease;\n  cursor: pointer;\n\n  &:hover {\n    background: rgba($accent-blue, 0.08);\n  }\n\n  &.is-selected {\n    background: rgba($accent-blue, 0.16) !important;\n    box-shadow: inset 3px 0 0 $accent-blue;\n  }\n\n  &--open {\n    background: rgba($dark-orange, 0.08);\n  }\n\n  &--custom {\n    background: rgba($very-light-purple, 0.06);\n  }\n\n  &--redacted {\n    opacity: 0.72;\n  }\n}\n\n.org-positions-unit {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  min-width: 0;\n\n  &[data-depth='1'] { padding-left: 0; }\n  &[data-depth='2'] { padding-left: 1.25rem; }\n  &[data-depth='3'] { padding-left: 2.5rem; }\n  &[data-depth='4'] { padding-left: 3.75rem; }\n\n  &__toggle,\n  &__toggle-spacer {\n    flex: 0 0 1.25rem;\n    width: 1.25rem;\n    height: 1.25rem;\n  }\n\n  &__toggle {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    border: none;\n    border-radius: 6px;\n    background: rgba($accent-blue, 0.18);\n    color: $very-light-grey;\n    cursor: pointer;\n    transition: transform 0.15s ease, background 0.15s ease;\n\n    &.is-collapsed {\n      transform: rotate(-90deg);\n    }\n\n    &:hover {\n      background: rgba($accent-blue, 0.32);\n    }\n  }\n\n  &__logo,\n  &__logo-fallback {\n    flex: 0 0 2rem;\n    width: 2rem;\n    height: 2rem;\n    border-radius: 8px;\n    object-fit: cover;\n  }\n\n  &__logo-fallback {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.82rem;\n    font-weight: 700;\n    color: $very-light-grey;\n    background: rgba($accent-blue, 0.28);\n    border: 1px solid rgba($accent-blue, 0.35);\n\n    &--custom {\n      background: rgba($very-light-purple, 0.22);\n      border-color: rgba($very-light-purple, 0.4);\n      color: $very-light-purple;\n    }\n  }\n\n  &__text {\n    display: flex;\n    flex-direction: column;\n    gap: 0.1rem;\n    min-width: 0;\n  }\n\n  &__name {\n    font-size: 0.92rem;\n    font-weight: 600;\n    color: $very-light-grey;\n    word-break: break-word;\n  }\n\n  &__short {\n    font-size: 0.76rem;\n    color: rgba($very-light-grey, 0.58);\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n  }\n}\n\n.org-positions-level {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.2rem 0.55rem;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  border: 1px solid rgba($accent-blue, 0.35);\n  background: rgba($accent-blue, 0.18);\n  color: $light-blue;\n\n  &--division {\n    border-color: rgba($light-blue, 0.35);\n    background: rgba($blue, 0.35);\n  }\n\n  &--branch {\n    border-color: rgba($very-light-purple, 0.35);\n    background: rgba($very-light-purple, 0.12);\n    color: $very-light-purple;\n  }\n\n  &--section {\n    border-color: rgba($light-green, 0.35);\n    background: rgba($dark-green, 0.22);\n    color: $light-green;\n  }\n\n  &--custom {\n    border-color: rgba($very-light-purple, 0.4);\n    background: rgba($very-light-purple, 0.14);\n    color: $very-light-purple;\n  }\n}\n\n.org-positions-commander {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  min-width: 0;\n\n  &--open {\n    color: rgba($very-light-orange, 0.95);\n  }\n\n  &--redacted {\n    color: rgba($very-light-grey, 0.55);\n    font-style: italic;\n  }\n\n  &__avatar {\n    flex: 0 0 2.25rem;\n    width: 2.25rem;\n    height: 2.25rem;\n    border-radius: 50%;\n    object-fit: cover;\n    border: 1px solid rgba($light-blue, 0.35);\n    background: rgba($dark-blue, 0.45);\n  }\n\n  &__text {\n    display: flex;\n    flex-direction: column;\n    gap: 0.08rem;\n    min-width: 0;\n  }\n\n  &__monicker {\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: $very-light-grey;\n  }\n\n  &__discord-name {\n    font-size: 0.82rem;\n    color: rgba($very-light-grey, 0.78);\n  }\n\n  &__role,\n  &__since {\n    font-size: 0.74rem;\n    color: rgba($very-light-grey, 0.58);\n  }\n\n  &__vacant-icon {\n    flex: 0 0 2.25rem;\n    width: 2.25rem;\n    height: 2.25rem;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    border: 1px dashed rgba($light-orange, 0.55);\n    color: rgba($light-orange, 0.9);\n    font-size: 1rem;\n  }\n\n  &__vacant-title {\n    font-size: 0.88rem;\n    font-weight: 600;\n    color: rgba($very-light-orange, 0.95);\n  }\n\n  &__vacant-sub {\n    font-size: 0.76rem;\n    color: rgba($very-light-grey, 0.58);\n  }\n}\n\n.org-positions-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n\n  &__dot {\n    width: 0.55rem;\n    height: 0.55rem;\n    border-radius: 50%;\n  }\n\n  &--filled {\n    color: $light-green;\n\n    .org-positions-status__dot {\n      background: $light-green;\n      box-shadow: 0 0 0 3px rgba($light-green, 0.18);\n    }\n  }\n\n  &--open {\n    color: rgba($very-light-orange, 0.95);\n\n    .org-positions-status__dot {\n      background: $light-orange;\n      box-shadow: 0 0 0 3px rgba($light-orange, 0.18);\n    }\n  }\n\n  &--custom {\n    color: rgba($very-light-purple, 0.95);\n\n    .org-positions-status__dot {\n      background: $very-light-purple;\n      box-shadow: 0 0 0 3px rgba($very-light-purple, 0.18);\n    }\n  }\n}\n\n@media (max-width: 960px) {\n  .org-positions-kpi {\n    &__controls {\n      justify-content: flex-start;\n    }\n\n    &__search {\n      max-width: none;\n      flex-basis: 100%;\n    }\n  }\n\n  .org-positions-layout {\n    flex-direction: column;\n\n    &__editor {\n      flex: 1 1 auto;\n      max-width: none;\n      min-width: 0;\n    }\n  }\n\n  .org-position-editor {\n    max-height: none;\n  }\n}\n","// src/styles/eventAuctions.scss — Event Auctions (TrainingStandards / ts-* visual language)\n\n@import './variables.scss';\n\n.event-auction-page {\n  min-height: 280px;\n\n  .event-auction-page-header {\n    display: flex;\n    align-items: center;\n    gap: 0.85rem;\n    padding: 0.55rem 0.85rem;\n    margin: 0 0 0.35rem;\n  }\n\n  .event-auction-page-header__pi-icon {\n    flex: 0 0 auto;\n    width: 3.35rem;\n    height: 3.35rem;\n    margin: 0.15rem 0;\n    object-fit: contain;\n    border-radius: 10px;\n\n    &--placeholder {\n      background:\n        linear-gradient(135deg, rgba($dark-blue-grey, 0.55), rgba($dark-blue, 0.35));\n    }\n  }\n\n  .event-auction-page-header__titles {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    min-width: 0;\n    flex: 1 1 auto;\n\n    .ts-page-header__eyebrow {\n      margin-bottom: 0.2rem;\n    }\n\n    .ts-page-header__title {\n      font-size: unquote('clamp(1rem, 1.6vw, 1.2rem)');\n    }\n  }\n\n  .event-auction-pi-value {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.4rem;\n    flex: 0 0 auto;\n    font-variant-numeric: tabular-nums;\n    white-space: nowrap;\n  }\n\n  .event-auction-pi-value__icon {\n    width: 1.65rem;\n    height: 1.65rem;\n    object-fit: contain;\n    border-radius: 4px;\n    flex: 0 0 auto;\n  }\n\n  .event-auction-pi-value__amount {\n    font-weight: 700;\n    font-size: 0.98rem;\n    color: rgba($very-light-grey, 0.96);\n  }\n\n  .event-auction-pi-value__unit {\n    font-weight: 700;\n    font-size: 0.86rem;\n    letter-spacing: 0.12em;\n    color: rgba($very-light-grey, 0.82);\n  }\n\n  /* Unified PI cost control on loot rows (− value +) */\n  .event-auction-pi-cost {\n    display: inline-flex;\n    align-items: stretch;\n    flex: 0 0 auto;\n    min-height: 2.75rem;\n    border-radius: 10px;\n    border: 1px solid rgba($accent-blue, 0.38);\n    background:\n      linear-gradient(180deg, rgba($dark-blue-grey, 0.5), rgba($dark-blue, 0.72)),\n      rgba($dark-blue, 0.55);\n    box-shadow:\n      0 0 0 1px rgba($accent-blue, 0.06),\n      0 6px 14px rgba(0, 0, 0, 0.18);\n    overflow: hidden;\n  }\n\n  .event-auction-pi-cost__btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 2rem;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    background: rgba($pure-white, 0.04);\n    color: rgba($very-light-grey, 0.92);\n    font-size: 1rem;\n    font-weight: 600;\n    line-height: 1;\n    cursor: pointer;\n    transition:\n      background 0.15s ease,\n      color 0.15s ease;\n\n    &:hover,\n    &:focus-visible {\n      background: rgba($accent-blue, 0.28);\n      color: $pure-white;\n      outline: none;\n    }\n\n    &:active {\n      background: rgba($accent-blue, 0.4);\n    }\n  }\n\n  .event-auction-pi-cost__btn--minus {\n    border-right: 1px solid rgba($accent-blue, 0.22);\n  }\n\n  .event-auction-pi-cost__btn--plus {\n    border-left: 1px solid rgba($accent-blue, 0.22);\n  }\n\n  .event-auction-pi-cost__value.event-auction-pi-value {\n    gap: 0.45rem;\n    min-width: 4.75rem;\n    padding: 0 0.75rem;\n    justify-content: center;\n    background: rgba($pure-white, 0.03);\n  }\n\n  .event-auction-pi-cost__value {\n    .event-auction-pi-value__icon {\n      height: 1.65rem;\n      width: 1.65rem;\n      border-radius: 5px;\n    }\n\n    .event-auction-pi-value__amount {\n      font-size: 1.05rem;\n      font-weight: 700;\n      letter-spacing: 0.01em;\n      color: $pure-white;\n    }\n\n    .event-auction-pi-value__unit {\n      font-size: 0.72rem;\n      font-weight: 700;\n      letter-spacing: 0.14em;\n      color: rgba($accent-blue, 0.95);\n    }\n  }\n\n  .event-auction-pi-stepper {\n    display: inline-flex;\n    flex-direction: column;\n    gap: 0.2rem;\n    flex: 0 0 auto;\n  }\n\n  .event-auction-pi-stepper__btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 1.35rem;\n    height: 1.1rem;\n    padding: 0;\n    border-radius: 5px;\n    border: 1px solid rgba($accent-blue, 0.45);\n    background: rgba($dark-blue, 0.72);\n    color: $very-light-grey;\n    font-size: 0.78rem;\n    font-weight: 700;\n    line-height: 1;\n    cursor: pointer;\n\n    &:hover,\n    &:focus-visible {\n      border-color: rgba($accent-blue, 0.8);\n      background: rgba($accent-blue, 0.22);\n    }\n  }\n\n  .event-auction-toolbar {\n    justify-content: flex-end;\n\n    .ts-toolbar__actions {\n      margin-left: auto;\n      display: flex;\n      flex-wrap: wrap;\n      gap: 0.5rem;\n    }\n  }\n\n  .event-auction-status {\n    margin: 0 0 0.55rem;\n    color: rgba($very-light-grey, 0.78);\n    font-size: 0.88rem;\n\n    &--error {\n      color: $red;\n    }\n  }\n\n  .event-auction-view {\n    display: flex;\n    flex-direction: column;\n    gap: 0.85rem;\n    min-height: 8rem;\n  }\n\n  .event-auction-loot-actions {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n  }\n\n  .event-auction-loot-mention-wrap {\n    position: relative;\n    width: 100%;\n    max-width: 42rem;\n  }\n\n  .event-auction-loot-input-shell {\n    display: flex;\n    align-items: center;\n    gap: 0.55rem;\n    padding: 0.55rem 0.8rem;\n    border-radius: 12px;\n    border: 1px solid rgba($accent-blue, 0.28);\n    background:\n      linear-gradient(180deg, rgba($dark-blue-grey, 0.42), rgba($dark-blue, 0.55)),\n      rgba($dark-blue, 0.7);\n    box-shadow: inset 0 1px 0 rgba($pure-white, 0.04);\n    transition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n    &:focus-within {\n      border-color: rgba($accent-blue, 0.7);\n      box-shadow:\n        inset 0 1px 0 rgba($pure-white, 0.05),\n        0 0 0 3px rgba($accent-blue, 0.16);\n    }\n\n    &--locked {\n      opacity: 0.55;\n      pointer-events: none;\n    }\n  }\n\n  .event-auction-loot-search-icon {\n    display: inline-flex;\n    color: rgba($very-light-grey, 0.55);\n    flex: 0 0 auto;\n  }\n\n  .event-auction-loot-input-shell:focus-within .event-auction-loot-search-icon {\n    color: rgba($accent-blue, 0.95);\n  }\n\n  .event-auction-loot-search-icon__svg {\n    width: 1rem;\n    height: 1rem;\n  }\n\n  .event-auction-loot-search-input {\n    flex: 1 1 auto;\n    min-width: 0;\n    border: 0 !important;\n    outline: none !important;\n    background: transparent !important;\n    box-shadow: none !important;\n    padding: 0.2rem 0 !important;\n    margin: 0;\n    font-family: inherit;\n    font-size: 0.9rem;\n    color: $very-light-grey;\n    caret-color: $accent-blue;\n\n    &::placeholder {\n      color: rgba($very-light-grey, 0.42);\n    }\n\n    &:focus {\n      border: 0 !important;\n      outline: none !important;\n      box-shadow: none !important;\n    }\n  }\n\n  .event-auction-loot-search-hint {\n    margin-top: 0.35rem;\n    font-size: 0.78rem;\n    color: rgba($very-light-grey, 0.55);\n  }\n\n  .event-auction-loot-dropdown {\n    position: absolute;\n    z-index: 40;\n    top: calc(100% + 0.35rem);\n    left: 0;\n    right: 0;\n    margin: 0;\n    padding: 0.35rem;\n    list-style: none;\n    max-height: 16rem;\n    overflow-y: auto;\n    overflow-x: hidden;\n    border-radius: 12px;\n    border: 1px solid rgba($accent-blue, 0.4);\n    background: rgba($dark-blue, 0.96);\n    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.35);\n    @include accounting-inventory-scrollbar;\n  }\n\n  .event-auction-loot-dropdown__item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.75rem;\n    padding: 0.55rem 0.65rem;\n    border-radius: 8px;\n    cursor: pointer;\n\n    &.is-selected,\n    &:hover {\n      background: rgba($accent-blue, 0.22);\n    }\n  }\n\n  .event-auction-loot-dropdown__main {\n    display: flex;\n    flex-direction: column;\n    gap: 0.15rem;\n    min-width: 0;\n  }\n\n  .event-auction-loot-dropdown__label {\n    font-size: 0.86rem;\n    color: $very-light-grey;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .event-auction-loot-dropdown__meta {\n    font-size: 0.72rem;\n    color: rgba($very-light-grey, 0.55);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .event-auction-loot-dropdown__credit {\n    flex: 0 0 auto;\n  }\n\n  .event-auction-loot-list {\n    list-style: none;\n    margin: 0;\n    padding: 0 0.15rem 0 0;\n    display: flex;\n    flex-direction: column;\n    gap: 0.65rem;\n    height: calc(100vh - 555px);\n    min-height: 8rem;\n    overflow-y: auto;\n    overflow-x: hidden;\n    @include accounting-inventory-scrollbar;\n  }\n\n  .event-auction-loot-list__empty {\n    padding: 0.85rem 0.95rem;\n    border-radius: 10px;\n    border: 1px dashed rgba($accent-blue, 0.35);\n    color: rgba($very-light-grey, 0.55);\n    font-size: 0.84rem;\n  }\n\n  .event-auction-loot-list__item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1rem;\n    padding: 0.85rem 0.95rem;\n    border-radius: 12px;\n    border: 1px solid rgba($accent-blue, 0.3);\n    background:\n      linear-gradient(180deg, rgba($dark-blue-grey, 0.4), rgba($dark-blue, 0.48)),\n      rgba($dark-blue, 0.55);\n    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);\n  }\n\n  .event-auction-loot-list__copy {\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n    min-width: 0;\n    flex: 1 1 auto;\n  }\n\n  /* Auction-only ScItemChip variant — base is 11px; +2px here. Benefits chips unchanged. */\n  .sc-item-chip--auction {\n    font-size: 13px;\n    line-height: 1.35;\n    border-radius: 10px;\n    border-color: rgba($sc-item-accent-secondary, 0.72);\n    background:\n      linear-gradient(180deg, rgba($dark-blue-grey, 0.55), rgba($sc-item-bg, 0.96)),\n      $sc-item-bg;\n    box-shadow:\n      0 0 0 1px rgba($sc-item-accent-primary, 0.08),\n      0 8px 18px rgba(0, 0, 0, 0.22);\n    overflow: hidden;\n\n    &.sc-item-chip--removable {\n      gap: 0;\n    }\n\n    .sc-item-chip__trigger {\n      gap: 0.55rem;\n      margin: 0 0.65rem;\n      padding: 0.55rem 0.35rem;\n      row-gap: 0.3rem;\n      flex-wrap: nowrap;\n    }\n\n    .sc-item-chip__label {\n      flex: 0 1 auto;\n      font-size: 13px;\n      font-weight: 600;\n      letter-spacing: 0.01em;\n      color: rgba($pure-white, 0.96);\n    }\n\n    .sc-item-chip__meta-sep,\n    .sc-item-chip__unit-quality-sep {\n      display: none;\n    }\n\n    .sc-item-chip__unit {\n      gap: 0.35rem;\n      padding: 0.2rem 0.45rem;\n      border-radius: 7px;\n      background: rgba($pure-white, 0.06);\n      border: 1px solid rgba($sc-item-accent-secondary, 0.22);\n      color: rgba($pure-white, 0.9);\n      font-weight: 600;\n    }\n\n    .sc-item-chip__unit.is-editing {\n      background: rgba($sc-item-accent-primary, 0.18);\n      border-color: rgba($sc-item-accent-secondary, 0.55);\n    }\n\n    .sc-item-chip__unit-edit {\n      gap: 0.35rem;\n    }\n\n    .sc-item-chip__unit-kind-text,\n    .sc-item-chip__unit-quality-q {\n      opacity: 0.72;\n      font-weight: 600;\n      font-size: 12px;\n      letter-spacing: 0.04em;\n      text-transform: lowercase;\n    }\n\n    .sc-item-chip__unit-quality-q {\n      text-transform: uppercase;\n    }\n\n    .sc-item-chip__unit-qty-value,\n    .sc-item-chip__unit-quality-value {\n      padding: 0.1rem 0.4rem;\n      border-radius: 5px;\n      background: rgba($pure-white, 0.1);\n      color: $pure-white;\n      font-weight: 700;\n      font-variant-numeric: tabular-nums;\n    }\n\n    .sc-item-chip__unit-qty-value--editable,\n    .sc-item-chip__unit-quality-value--editable {\n      text-decoration: none;\n      border: 1px solid transparent;\n      transition:\n        background 0.15s ease,\n        border-color 0.15s ease,\n        box-shadow 0.15s ease;\n\n      &:hover,\n      &:focus-visible {\n        background: rgba($sc-item-accent-primary, 0.22);\n        border-color: rgba($sc-item-accent-secondary, 0.5);\n        box-shadow: 0 0 0 2px rgba($sc-item-accent-primary, 0.15);\n        outline: none;\n      }\n    }\n\n    .sc-item-chip__unit-qty-input,\n    .sc-item-chip__unit-quality-input {\n      padding: 0.1rem 0.35rem;\n      border-radius: 5px;\n      background: rgba($sc-item-accent-primary, 0.2);\n      font-weight: 700;\n      font-variant-numeric: tabular-nums;\n    }\n\n    .sc-item-chip__remove {\n      align-self: stretch;\n      width: 2rem;\n      min-height: 100%;\n      height: auto;\n      border-radius: 0;\n      background: rgba($sc-item-accent-primary, 0.88);\n      color: $pure-white;\n      transition: background 0.15s ease;\n\n      &:hover,\n      &:focus-visible {\n        background: $sc-item-accent-secondary;\n        outline: none;\n      }\n    }\n\n    .sc-item-chip__remove-icon {\n      font-size: 1.05rem;\n      font-weight: 600;\n      opacity: 0.95;\n    }\n  }\n\n  .event-auction-loot-list__side {\n    display: flex;\n    align-items: center;\n    gap: 0.95rem;\n    flex: 0 0 auto;\n  }\n\n  .event-auction-officer-bar {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.65rem;\n    align-items: center;\n    margin-bottom: 0.85rem;\n  }\n\n  .event-auction-ready-check {\n    margin-bottom: 0.85rem;\n    padding: 0.65rem 0.8rem;\n    border: 1px solid rgba($accent-blue, 0.25);\n    border-radius: 10px;\n    background: rgba($dark-blue, 0.35);\n  }\n\n  .event-auction-ready-check__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.5rem;\n    margin-bottom: 0.45rem;\n  }\n\n  .event-auction-ready-check__list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n  }\n\n  .event-auction-ready-check__item {\n    display: flex;\n    justify-content: space-between;\n    gap: 0.75rem;\n    font-size: 0.85rem;\n    color: $very-light-grey;\n  }\n\n  .event-auction-ready-check__item--ready {\n    color: $green;\n  }\n\n  .event-auction-ready-check__item--not_ready {\n    color: $red;\n  }\n\n  .event-auction-ready-check__item--pending {\n    color: $accent-blue;\n  }\n\n  .event-auction-ready-check__item--offline {\n    color: $light-grey;\n    opacity: 0.85;\n  }\n\n  .event-auction-ready-check__actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    margin-top: 0.55rem;\n  }\n\n  .event-auction-manage-draft {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .event-auction-manage-draft__locked {\n    margin: 0.35rem 0 0;\n    color: $light-grey;\n    font-size: 0.85rem;\n  }\n\n  .event-auction-manage-draft__row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.75rem;\n    align-items: center;\n  }\n\n  .event-auction-room__status {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.85rem;\n    align-items: center;\n    margin-bottom: 0.85rem;\n    color: $very-light-grey;\n  }\n\n  .event-auction-room__timer {\n    font-variant-numeric: tabular-nums;\n    font-weight: 700;\n    color: $accent-blue;\n  }\n\n  .event-auction-room__lots {\n    display: flex;\n    flex-direction: column;\n    gap: 0.85rem;\n  }\n\n  .event-auction-lot-card {\n    border: 1px solid rgba($accent-blue, 0.28);\n    border-radius: 12px;\n    padding: 0.75rem 0.9rem;\n    background: rgba($dark-blue, 0.45);\n  }\n\n  .event-auction-lot-card__header {\n    margin-bottom: 0.45rem;\n  }\n\n  .event-auction-lot-card__title {\n    margin: 0 0 0.35rem;\n    font-size: 0.95rem;\n  }\n\n  .event-auction-lot-card__meta {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.65rem;\n    font-size: 0.75rem;\n    color: $light-grey;\n  }\n\n  .event-auction-lot-card__bank {\n    color: $accent-blue;\n  }\n\n  .event-auction-lot-card__warn {\n    color: $orange;\n    font-size: 0.8rem;\n  }\n\n  .event-auction-lot-card__bids {\n    margin: 0.4rem 0 0.65rem;\n    padding-left: 1.1rem;\n    font-size: 0.82rem;\n  }\n\n  .event-auction-lot-card__actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.55rem;\n    align-items: flex-end;\n\n    label {\n      display: flex;\n      flex-direction: column;\n      gap: 0.25rem;\n      font-size: 0.72rem;\n      color: $light-grey;\n    }\n\n    .ts-input {\n      width: 6.5rem;\n    }\n  }\n\n  .event-auction-lot-card__result {\n    margin: 0.55rem 0 0;\n    font-size: 0.82rem;\n    color: $very-light-grey;\n  }\n\n  .event-auction-block__header {\n    .event-auction-block__event-name {\n      margin-left: 0.35rem;\n      font-size: 0.78rem;\n      font-weight: 500;\n      text-transform: none;\n      color: $light-grey;\n      opacity: 0.9;\n    }\n  }\n\n  .event-auction-board {\n    display: flex;\n    flex-direction: column;\n    gap: 0.85rem;\n    flex: 1 1 auto;\n    min-height: 0;\n  }\n\n  .event-auction-view--manage {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    min-height: 0;\n  }\n\n  .event-auction-board__topbar {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.75rem;\n  }\n\n  .event-auction-board__phase-cluster {\n    display: inline-flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 0.55rem;\n  }\n\n  .event-auction-board__phase-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.4rem;\n    padding: 0.32rem 0.75rem;\n    border-radius: 999px;\n    border: 1px solid rgba($accent-blue, 0.35);\n    background: rgba($dark-blue, 0.55);\n    font-size: 0.78rem;\n    color: $very-light-grey;\n\n    &--free,\n    &--firm {\n      border-color: rgba($green, 0.45);\n      color: $green;\n    }\n\n    &--paused,\n    &--cancelled {\n      border-color: rgba($red, 0.45);\n      color: lighten($red, 18%);\n    }\n  }\n\n  .event-auction-board__phase-dot {\n    width: 0.45rem;\n    height: 0.45rem;\n    border-radius: 50%;\n    background: currentColor;\n    box-shadow: 0 0 6px currentColor;\n  }\n\n  .event-auction-board__timer {\n    font-variant-numeric: tabular-nums;\n    font-weight: 700;\n    color: $accent-blue;\n    font-size: 1.05rem;\n  }\n\n  .event-auction-board__balance {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 0.15rem;\n    padding: 0.45rem 0.7rem;\n    border-radius: 10px;\n    border: 1px solid rgba($accent-blue, 0.28);\n    background: rgba($dark-blue, 0.4);\n    font-size: 0.8rem;\n    color: $light-grey;\n\n    strong {\n      color: $very-light-grey;\n      font-size: 0.92rem;\n    }\n  }\n\n  .event-auction-board__table-wrap {\n    flex: 1 1 auto;\n    min-height: 0;\n    max-height: clamp(220px, 42vh, 560px);\n    overflow: auto;\n    border: 1px solid rgba($accent-blue, 0.22);\n    border-radius: 12px;\n    background: rgba($dark-blue, 0.28);\n    @include accounting-inventory-scrollbar;\n  }\n\n  .event-auction-board__table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n    min-width: 720px;\n\n    th,\n    td {\n      padding: 0.7rem 0.75rem;\n      text-align: left;\n      vertical-align: top;\n      border-bottom: 1px solid rgba($very-light-grey, 0.08);\n    }\n\n    thead th {\n      position: sticky;\n      top: 0;\n      z-index: 2;\n      font-size: 0.72rem;\n      text-transform: uppercase;\n      letter-spacing: 0.04em;\n      color: $light-grey;\n      font-weight: 600;\n      background: rgba($dark-blue, 0.96);\n      box-shadow: 0 1px 0 rgba($very-light-grey, 0.1);\n    }\n  }\n\n  .event-auction-board__row {\n    td {\n      background: rgba($dark-blue, 0.18);\n    }\n\n    &:hover td {\n      background: rgba($dark-blue, 0.28);\n    }\n  }\n\n  .event-auction-board__row--mine {\n    td {\n      background: rgba($green, 0.07);\n      box-shadow: inset 0 0 0 1px rgba($green, 0.45);\n    }\n\n    td:first-child {\n      box-shadow: inset 3px 0 0 $green, inset 0 0 0 1px rgba($green, 0.45);\n    }\n  }\n\n  .event-auction-board__lot {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.7rem;\n  }\n\n  .event-auction-lot-icon,\n  .loadout-slot__icon.event-auction-lot-icon {\n    flex: 0 0 auto;\n    width: 2.6rem;\n    height: 2.6rem;\n    border-radius: 8px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    background: $medium-grey;\n    border: 1px solid rgba($accent-blue, 0.22);\n  }\n\n  .event-auction-lot-icon__img,\n  .loadout-slot__icon-img.event-auction-lot-icon__img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n  }\n\n  .event-auction-lot-icon__fallback {\n    font-size: 0.95rem;\n    font-weight: 700;\n    color: $light-grey;\n  }\n\n  .event-auction-board__lot-copy {\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n  }\n\n  .event-auction-board__lot-name {\n    color: $very-light-grey;\n    font-size: 0.92rem;\n  }\n\n  .event-auction-board__lot-meta {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.35rem;\n    font-size: 0.72rem;\n    color: $light-grey;\n  }\n\n  .event-auction-board__chip {\n    display: inline-flex;\n    align-items: center;\n    padding: 0.12rem 0.45rem;\n    border-radius: 999px;\n    border: 1px solid rgba($accent-blue, 0.28);\n    background: rgba($dark-blue-grey, 0.55);\n    color: $light-grey;\n    white-space: nowrap;\n\n    &--status {\n      border-color: rgba($accent-blue, 0.4);\n      color: $accent-blue;\n    }\n  }\n\n  .event-auction-board__pi {\n    font-weight: 600;\n    color: $very-light-grey;\n  }\n\n  .event-auction-board__current,\n  .event-auction-board__mine {\n    display: flex;\n    flex-direction: column;\n    gap: 0.15rem;\n    font-size: 0.8rem;\n    color: $light-grey;\n\n    strong {\n      color: $very-light-grey;\n    }\n  }\n\n  .event-auction-board__mine-tag {\n    display: inline-flex;\n    align-self: flex-start;\n    padding: 0.12rem 0.4rem;\n    border-radius: 999px;\n    background: rgba($green, 0.2);\n    color: $green;\n    font-size: 0.68rem;\n    font-weight: 700;\n    text-transform: uppercase;\n  }\n\n  .event-auction-board__muted {\n    color: $light-grey;\n    opacity: 0.75;\n    font-size: 0.8rem;\n  }\n\n  .event-auction-board__empty {\n    text-align: center;\n    color: $light-grey;\n    padding: 1.2rem 0.75rem !important;\n  }\n\n  .event-auction-board__bid-editor {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.45rem;\n    align-items: flex-end;\n\n    label {\n      display: flex;\n      flex-direction: column;\n      gap: 0.2rem;\n      font-size: 0.7rem;\n      color: $light-grey;\n    }\n\n    .ts-input {\n      width: 5.5rem;\n    }\n  }\n\n  .event-auction-board__btn-cancel {\n    color: lighten($red, 12%) !important;\n    border-color: rgba($red, 0.45) !important;\n  }\n\n  .event-auction-board__warn {\n    margin: 0.35rem 0 0;\n    font-size: 0.72rem;\n    color: $orange;\n  }\n}\n\n// Standalone auction block inside Benefits expansion (same tokens, outside page chrome)\n.event-auction-block.benefits-block {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n\n  .event-auction-block__body {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    min-height: 0;\n  }\n}\n","// src/styles/allOrganizations.scss\n\n@import './variables.scss';\n\n.all-orgs-page {\n  .all-orgs-error {\n    margin: 0 0 0.75rem;\n    color: $red;\n    font-size: 0.85rem;\n  }\n\n  .all-orgs-layout {\n    display: grid;\n    gap: 1rem;\n    grid-template-columns: 1fr;\n\n    &--split {\n      grid-template-columns: minmax(0, 1.15fr) minmax(0, 0.85fr);\n    }\n\n    @media (max-width: 1100px) {\n      &--split {\n        grid-template-columns: 1fr;\n      }\n    }\n  }\n\n  .all-orgs-count {\n    margin-left: auto;\n    font-size: 0.78rem;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.62);\n    white-space: nowrap;\n  }\n\n  .all-orgs-toolbar {\n    align-items: center;\n  }\n\n  .all-orgs-filter-toggle {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.55rem;\n    margin: 0;\n    cursor: pointer;\n    user-select: none;\n  }\n\n  .all-orgs-filter-toggle__label {\n    font-size: 0.78rem;\n    letter-spacing: 0.03em;\n    color: rgba($very-light-grey, 0.82);\n    white-space: nowrap;\n  }\n\n  .all-orgs-rsi-link {\n    display: inline-block;\n    margin-top: 0.35rem;\n    font-size: 0.8rem;\n    color: $accent-blue;\n    text-decoration: none;\n    letter-spacing: 0.02em;\n\n    &:hover {\n      color: $light-blue;\n      text-decoration: underline;\n    }\n  }\n\n  .ts-table-scroll--all-orgs {\n    max-height: unquote('min(62vh, calc(100vh - 280px))');\n  }\n\n  .ts-table-scroll--all-orgs-members {\n    max-height: unquote('min(42vh, calc(100vh - 420px))');\n  }\n\n  .accounting-table--all-orgs-head,\n  .accounting-table--all-orgs-body {\n    table-layout: fixed;\n    width: 100%;\n\n    .col-logo {\n      width: 72px;\n    }\n\n    .col-orgSid {\n      width: 110px;\n    }\n\n    .col-whitelisted,\n    .col-blacklisted {\n      width: 96px;\n    }\n\n    th.header-logo,\n    td.cell-logo,\n    th.header-whitelisted,\n    td.cell-whitelisted,\n    th.header-blacklisted,\n    td.cell-blacklisted {\n      text-align: center;\n      vertical-align: middle;\n    }\n  }\n\n  .accounting-table--all-orgs-members-head,\n  .accounting-table--all-orgs-members-body {\n    table-layout: fixed;\n    width: 100%;\n\n    .col-handle {\n      width: 22%;\n    }\n\n    .col-monicker {\n      width: 20%;\n    }\n\n    .col-discord {\n      width: 24%;\n    }\n\n    .col-membership {\n      width: 16%;\n    }\n\n    .col-rank {\n      width: 18%;\n    }\n  }\n\n  .all-orgs-row {\n    cursor: pointer;\n    transition: background 0.15s ease;\n\n    &:hover {\n      background: rgba($accent-blue, 0.08);\n    }\n\n    &.is-selected {\n      background: rgba($accent-blue, 0.16) !important;\n      box-shadow: inset 3px 0 0 $accent-blue;\n    }\n  }\n\n  .all-orgs-no-logo {\n    color: $grey;\n  }\n\n  .all-orgs-logo {\n    display: block;\n    object-fit: contain;\n    margin-left: auto;\n    margin-right: auto;\n    width: auto;\n    height: auto;\n  }\n\n  .all-orgs-logo--small {\n    max-width: 36px;\n    max-height: 36px;\n  }\n\n  .all-orgs-logo--medium {\n    max-width: 52px;\n    max-height: 52px;\n  }\n\n  .all-orgs-logo--large {\n    max-width: 64px;\n    max-height: 64px;\n  }\n\n  .all-orgs-toggle {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto;\n  }\n\n  .all-orgs-detail-header {\n    display: flex;\n    align-items: center;\n    gap: 0.85rem;\n    margin-bottom: 1rem;\n    min-width: 0;\n\n    .all-orgs-logo {\n      margin: 0;\n      flex: 0 0 auto;\n    }\n  }\n\n  .all-orgs-detail-header__text {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  .all-orgs-detail-sid {\n    margin: 0.2rem 0 0;\n    font-size: 0.8rem;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.62);\n  }\n\n  .all-orgs-detail-focus {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.35rem;\n    margin: 0.4rem 0 0;\n    padding: 0;\n    list-style: none;\n\n    &--inline {\n      margin-top: 0.3rem;\n    }\n  }\n\n  .all-orgs-detail-focus__item {\n    display: inline-flex;\n    align-items: center;\n    padding: 0.18rem 0.5rem;\n    border-radius: 999px;\n    border: 1px solid rgba($accent-blue, 0.4);\n    background: rgba($dark-blue-grey, 0.45);\n    font-size: 0.72rem;\n    letter-spacing: 0.03em;\n    color: rgba($very-light-grey, 0.88);\n\n    &.is-primary {\n      border-color: rgba($accent-blue, 0.65);\n      background: rgba($accent-blue, 0.22);\n    }\n\n    &.is-secondary {\n      border-color: rgba($light-blue, 0.35);\n      background: rgba($light-blue, 0.12);\n    }\n\n    &.is-warning {\n      border-color: $red;\n      background: rgba($red, 0.22);\n      color: $very-light-grey;\n    }\n  }\n\n  .all-orgs-name-cell {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0;\n    min-width: 0;\n  }\n\n  .all-orgs-name-cell__label {\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 100%;\n  }\n\n  .all-orgs-scrape-btn {\n    flex: 0 0 auto;\n    align-self: flex-start;\n  }\n\n  .all-orgs-close-btn {\n    flex: 0 0 auto;\n  }\n\n  .all-orgs-comment-block {\n    margin-bottom: 1.1rem;\n    padding-bottom: 1rem;\n    border-bottom: 1px solid rgba($accent-blue, 0.22);\n  }\n\n  .all-orgs-comment-label {\n    display: block;\n    margin-bottom: 0.4rem;\n    font-size: 0.72rem;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: rgba($very-light-grey, 0.7);\n  }\n\n  .all-orgs-comment-edit-textarea {\n    width: 100%;\n    min-height: 4.5rem;\n    resize: vertical;\n  }\n\n  .all-orgs-comment-actions {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 0.55rem;\n  }\n\n  .all-orgs-members-title {\n    margin-top: 0.25rem;\n  }\n\n  .all-orgs-members-count {\n    font-weight: 500;\n    color: rgba($very-light-grey, 0.62);\n  }\n}\n","@import './variables.scss';\n\n/*Reset passord*/\n\n\n.reset-card {\n  position: relative;\n  background-color: $very-dark-grey;\n  color: $very-light-grey;\n  width: 400px;\n  height: 400px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transition: height 0.5s;\n}\n\n.reset-card.message-present {\n  height: 420px; /* hauteur augmentée */\n}\n\n.reset-tab {\n    background-color: $dark-grey;\n    width: 100%;\n    font-size: 1.2rem;\n    padding: 10px 0;\n    text-align: center;\n    color: $very-light-grey; // or any color of your choice\n    text-decoration: none;\n    text-align: center; // To center the text\n  \n    &:hover {\n      cursor: none;\n      color: $very-light-grey;\n      text-decoration: underline;\n    }\n  \n    &.active {\n      background-color: $very-dark-grey;\n      color: white;\n    }\n  }\n\n  .status-container {\n    background: $dark-grey;\n    max-width: $desktop;\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: 50px;\n    padding-right: 50px;\n    padding-top: 15px;\n    padding-bottom: 25px;\n    margin-top: 100px;\n    border: 2px solid $very-dark-grey;\n    border-top-left-radius: 15px;\n    border-top-right-radius: 15px;\n    border-bottom-left-radius: 15px;\n    border-bottom-right-radius: 15px;\n  }\n\n  .custom-status {\n    text-align: center;\n    text-align: justify;\n    color: $very-light-grey\n  }","@import './variables.scss';\n\n// Styles\n.home-container {\n  position: relative;\n  max-width: 100vw; \n  margin-left: auto;\n  margin-right: auto;\n  overflow-x: hidden; // Ajout pour masquer le défilement horizontal\n}\n\n.video-iframe, .video-container {\n  width: 100vw;\n  object-fit: cover;\n\n  &::after {\n    content: '';\n    position: absolute;\n    bottom: 0px;\n    left: 0;\n    right: 0;\n    height: 4px;\n    background-image: var(--nav-background-image);\n    border-image-slice: 1;\n    border-image-repeat: repeat;\n  }\n}\n\n.carousel.carousel-slider .control-arrow {\n  display:none;\n}\n.carousel .control-arrow:before, .carousel.carousel-slider .control-arrow:before {\n  z-index: 0;\n}\n\n.carousel .control-prev.control-arrow:before {\n  border-right: 8px solid #fff;\n}\n\n\n// -------------------------------------------//\n//           TITLE SUBTITLE and DOTS          //\n// -------------------------------------------//\n\n\n.carousel-with-title {\n  width: 100%;\n  height: 95vh; // Hauteur par défaut pour les écrans d'ordinateur en paysage\n\n  @media (orientation: portrait) {\n    height: 95vh; // Hauteur pour les écrans d'ordinateur en portrait\n  }\n\n  // Pour les tablettes et mobiles\n  @media (max-width: $tablet) {\n    height: 82vh; // Hauteur pour mobile et tablette en portrait\n\n    @media (orientation: landscape) {\n      height: 72vh; // Hauteur pour mobile et tablette en paysage\n    }\n  }\n}\n\n\n.carousel-title-container {\n  position: absolute;\n  bottom: 10%; // Ajuste selon le besoin\n  left: 50%;\n  transform: translateX(-50%);\n  width: 100%;\n  //max-width: $desktop;\n  padding: 0 20px; // Pour ne pas coller aux bords\n  @include width;\n\n  .carousel-title, .carousel-subtitle, .carousel-custom-dots {\n    display: block;\n    width: 100%;\n    text-align: left;\n  }\n\n  .carousel-custom-dots {\n    \n    list-style: none;\n    padding: 0;\n    margin-top: 20px; // Distance sous le sous-titre\n\n    li {\n      display: inline-block;\n      opacity: 0.3;\n      width: 35px; // Taille des dots\n      height: 8px; // Taille des dots\n      background: linear-gradient(to right, $very-dark-grey, $very-light-grey, $very-light-grey, $very-dark-grey);\n      border: 1px solid $very-light-grey;\n      transform: skew(-35deg,0);\n      margin-right: 15px;\n      cursor: pointer;\n\n      &.active {\n        opacity: 1;// Couleur pour dot actif\n      }\n    }\n  }\n\n  @media (max-width: 768px) {\n    bottom: 20%; // Ajuste la position pour mobile et tablette pour garder le texte visible\n\n    .carousel-title {\n      font-size: clamp(16px, 2.5vw, 32px); // Ajuste la taille de la police pour mobile et tablette\n    }\n\n    .carousel-subtitle {\n      font-size: clamp(12px, 1.2vw, 24px);;\n    }\n\n    .carousel-custom-dots {\n      margin-top: 10px; // Réduit l'espace au-dessus des dots pour mobile et tablette\n    }\n  }\n}\n\n.carousel-title {\n  font-family: 'GoodTimes', sans-serif;\n  font-size: clamp(16px, 2.5vw, 32px); // Taille minimale de 16px, dynamique à 2.5vw, taille maximale de 32px\n  color: $very-light-grey;\n  margin-bottom: 10px;\n  z-index: 1;\n}\n\n.carousel-subtitle {\n  font-family: 'GoodTimes', sans-serif;\n  color: $very-light-grey;\n  font-size: clamp(12px, 1.2vw, 24px); // Taille minimale de 12px, dynamique à 1.2vw, taille maximale de 24px\n  z-index: 1;\n}\n\n.carousel-bottom {\n  z-index: 2;\n  height: 4px;\n  background-image: url(../medias/steel.png);\n  background-repeat: repeat;\n}\n\n// -------------------------------------------//\n// -----------------CHEVRONS------------------//\n// -------------------------------------------//\n\n.carousel-with-title {\n  position: relative;\n\n  // Remplir la zone hero (95vh) : react-responsive-carousel adapte la hauteur au contenu ;\n  // on force la chaîne + object-fit: cover pour images et vidéos.\n  .carousel-root,\n  .carousel {\n    height: 100%;\n  }\n\n  .carousel .slider-wrapper {\n    height: 100% !important;\n  }\n\n  .carousel .slider {\n    height: 100%;\n  }\n\n  .carousel .slide {\n    height: 100%;\n    display: flex;\n    align-items: stretch;\n  }\n\n  .carousel-item {\n    flex: 1;\n    align-self: stretch;\n    width: 100%;\n    min-height: 0;\n    position: relative;\n    overflow: hidden;\n  }\n\n  .carousel-item > img.custom-carousel-image,\n  .carousel-item > .video-iframe {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    max-width: none;\n    object-fit: cover;\n    object-position: center;\n    display: block;\n  }\n\n  .chevrons-container {\n    position: absolute;\n    bottom: -30px;\n    left: 50%;\n    transform: translateX(-50%);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    transition: opacity 0.5s ease-out; // Transition d'opacité\n    opacity: 1; // Opacité initiale\n\n    &.fade-out {\n      opacity: 0; // Fade out complet\n    }\n\n    .chevron {\n      width: 100px;\n      height: 89px;\n      fill: $very-light-grey;\n      transition: fill 0.4s ease;\n\n      &:not(:first-child) {\n        margin-top: -60px;\n      }\n\n      // Animation de pulsation\n      animation: pulse 2s infinite;\n\n      &:nth-child(1) {\n        animation-delay: 0s; // Pas de délai pour le premier chevron\n      }\n      &:nth-child(2) {\n        animation-delay: 0.4s; // Délai pour le deuxième chevron\n      }\n      &:nth-child(3) {\n        animation-delay: 0.8s; // Délai pour le troisième chevron\n      }\n    }\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    transform: scale(1);\n    opacity: 0;\n    fill: $very-light-grey;\n  }\n  50% {\n    margin-top: -65px;\n    transform: scale(1.3);\n    opacity: 1;\n    fill: $red;\n  }\n}\n\n// -------------------------------------------//\n// --------------JOIN US BUTTON---------------//\n// -------------------------------------------//\n\n.button-container {\n  display: flex;\n  position: absolute;\n  justify-content: left; // Centrage horizontal\n  padding: 0 15px;\n  height: auto; // Hauteur ajustée automatiquement\n  z-index: 2;\n  transform: translate(-45px, 31px);\n\n  @media (max-width: 1024px) {\n    transform: translate(-23px, 32px);\n  }\n}\n\n.trapezoid-border {\n  display: inline-block;\n  padding-bottom: 5px;\n  padding-left: 5px;\n  padding-right: 5px;\n  background-image: url('../medias/steel.png');\n  clip-path: polygon(0 0, 100% 0, 80% 100%, 20% 100%);\n  box-shadow: 20px 20px 25px rgba(255, 0, 0, 0.6);\n\n}\n\n.trapezoid-button {\n  display: inline-block;\n  text-align: center;\n  padding: 4px 35px 4px 35px; // Ajustement du padding pour la taille interne\n  background: linear-gradient(to right, #522323d3, #4b0505, #4b0505, #4b0505, #522323d3);\n  color: $light-grey;\n  font-size: clamp(10px, 1.1vw, 15px);\n  font-family: 'GoodTimes', sans-serif;\n  border: none;\n  text-decoration: none;\n  text-transform: uppercase;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  clip-path: polygon(0 0, 100% 0, 80% 100%, 20% 100%); // Forme du trapèze légèrement plus petite en bas\n\n  &:hover {\n    background: linear-gradient(to right, #683232d3, #5a0b0b, #4b0505, #5a0b0b, #683232d3);\n    color: white;\n  }\n\n  @media (max-width: 768px) {\n    padding: 7px 25px 7px 25px;\n  }\n}\n\n\n.pulse-text {\n  display: inline-block; // Assurez-vous que le span est bien en inline-block pour appliquer transform\n  animation: pulse2 2s infinite ease-in-out;\n\n  @keyframes pulse2 {\n    0%, 100% {\n      transform: scale(1);\n    }\n    50% {\n      transform: scale(1.05); // Légère augmentation de la taille\n    }\n  }\n}\n\n\n// -------------------------------------------//\n// -----------------STATISTICS----------------//\n// -------------------------------------------//\n\n// Variables existantes\n\n.org-statistics {\n  max-width: $full-width;\n  margin: 50px auto 10px auto;\n  padding-left: 25px;\n  padding-right: 25px;\n  //background-color: $grey;\n  //width: $desktop;\n  \n\n  // Adaptation pour les tablettes et les petits écrans\n  @media (max-width: $tablet) {\n    //max-width: $desktop;\n    @include width;\n    //width: 95%;\n    //margin: 30px auto;\n    margin-left: 1.8%;\n    margin-right: 1.8%;\n    margin-bottom: 55px;\n    padding-left: clamp(12px, 1.5%, 20px);\n    padding-right: clamp(12px, 1.5%, 20px);\n  }\n\n  .content-container {\n    //background: linear-gradient(to right, $dark-grey, #1d2c3d88, #1d2c3d88, #1d2c3d88, $dark-grey);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center; \n    margin-top: 20px;\n    //border-radius: 10px;\n    //border: 1px solid $dark-red;\n    // background: linear-gradient(to right, transparent 0%, $very-dark-grey 10%,  #1d2c3d88, #1d2c3d88, #1d2c3d88, $very-dark-grey 90%,  transparent 100%);\n  }\n}\n\n.chart-row {\n  display: flex;\n  width: 100%;\n  justify-content: space-around;\n  align-items: center;\n  margin-bottom: 20px; /* Ajustez selon vos besoins pour l'espacement entre les rangées */\n\n  @media (max-width: $tablet) {\n    width: 100%;\n    justify-content: center; \n    flex-wrap: wrap; \n  }\n}\n\n.chart-title {\n  text-transform: uppercase;\n  color: $light-grey;\n}\n\n.bar-chart {\n  //display: flex;\n  margin-left: auto;\n  margin-right: 10px;\n  padding-top: 1%;\n  //padding-left: 20px;\n  width: 100% !important;\n\n  &.divisions {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    //width: 100% !important;\n  }\n\n  @media (max-width: $tablet) {\n    //display: flex;\n    //width: 100%;\n    //justify-content: center; \n    flex-wrap: wrap; \n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 20px;\n  }\n\n}\n\n\n.banner {\n  padding: 20px 20px 20px 20px ;\n  text-align: center;\n}\n\n.homepage.catchPhrase {\n  color: rgba(139, 137, 137, 0.795);\n  text-shadow: 1px 1px 1px #1d1d1c5d;\n  font-size: clamp(16px, 2vw, 28px);\n  text-transform: uppercase;\n  margin: 50px 30px 50px 30px;\n  width: 80%;\n  justify-content: center; \n  text-align: center;\n  padding: 20px 30px 20px 30px ;\n  background-image: url('../medias/steel.png');\n  background-size: cover; /* L'image de fond couvre entièrement le bandeau */\n  background-position: center; /* Centre l'image de fond */\n  background-repeat: no-repeat; /* Empêche la répétition de l'image */\n  border: 3px solid rgba(85, 80, 80, 0.8);;\n  transition: top 0.4s;\n\n  @media (max-width: $tablet) {\n    margin: 50px 30px 50px 30px;\n    \n  }\n}\n\n.homepage-division-chart {\n  height: 250px;\n  width: 90%;\n  padding: 0px 20px;\n}\n\n.homepage.welcome-text {\n  color: $light-grey;\n  font-size: clamp(14px, 1.7vw, 20px);\n  padding: 0px 40px 10px 40px;\n  margin: 0;\n  white-space: pre-wrap;\n  transition: top 0.4s;\n\n  @media (max-width: $tablet) {\n    padding: 0px 10px 10px 10px;\n    text-align: justify;\n    \n  }\n  \n}\n\n.worldmap-container {\n  position: relative; /* Ensure the pseudo-element is positioned relative to this container */\n  width: calc(100% + 20px);\n\n  .worldmap {\n    width: 570px;\n    height: auto;\n    margin-left: 15px;\n    padding: 20px;\n    position: relative; /* Ensure the image stays within its container */\n    z-index: 0; /* Make sure it's below the pseudo-element */\n  \n    @media (max-width: $tablet) {\n      width: calc(100% - 35px);\n      margin: 0px;\n      \n    }\n  }\n}\n\n.worldmap-container::before {\n  content: \"\";\n  position: absolute;\n  top: 5px; /* Adjust the top value to match your design */\n  bottom: 5px; /* Adjust the bottom value to match your design */\n  left: 7px;\n  right: 7px;\n  border-left: 3px solid $grey;\n  border-right: 3px solid $grey;\n  border-radius: 5px; /* Adjust the radius to match the inner corners */\n  pointer-events: none; /* Ensure the pseudo-element does not interfere with interactions */\n  z-index: 1; /* Make sure it's above the image */\n}\n\n.bar-chart, .worldmap-container  {\n  animation-play-state: paused;\n}\n.anim-running {\n  animation-play-state: running;\n}\n\n.member-count-display {\n  display: flex;\n  flex-direction: row;\n  //text-align: left;\n  width: 100%;\n  //margin-right: 15px;\n  text-align: center;\n  margin-bottom: 20px; // Ajoutez un peu d'espace entre le texte et le graphique\n\n  @media (max-width: $tablet) {\n    display: contents;\n    width: 100%;\n    //width: calc(100% - 40px);\n    flex-direction: column;\n  }\n\n  .count {\n    font-size: 1.6em;\n    font-weight: bold;\n    color: $very-light-grey;\n    //animation: scale-up 3.5s ease-in-out infinite alternate;\n  }\n  .count-complement {\n    font-size: 1.2em;\n    font-weight: bold;\n    color: $light-grey;\n    @media (max-width: $tablet) {\n      margin-bottom: 20px;\n    }\n  }\n\n  // Alignement pour les orientations et les petits écrans\n  @media (max-width: $tablet) {\n    // Centrer le texte en mode portrait\n    .count, .count-complement {\n      text-align: center;\n    }\n  }\n}\n\n\n\n.count-complement {\n  font-style: italic;\n}\n\n\n\n.homepage.region-chart {\n  flex: 2 1 0%; // Maintient la flexibilité initiale\n  max-width: 600px; // Limite la largeur du graphique\n  width: 100%; // S'assure que le graphique utilise toute la largeur disponible jusqu'à 600px\n  margin: 0 20px 0 auto; // Centre le graphique dans son conteneur si moins que le max-width\n\n  .e-accumulationchart {\n    user-select: none;\n    position: relative;\n    display: block;\n    height: inherit;\n\n    width: 100%; // S'assure que le SVG à l'intérieur s'adapte à la taille du conteneur\n    height: auto; // Ajuste la hauteur pour maintenir l'aspect ratio du graphique\n  }\n}\n\n\n// Media Queries pour orientation\n@media (orientation: portrait) {\n  .content-container {\n    //display: flex;\n    flex-direction: column; // Membre au-dessus en portrait\n    //align-items: center;\n    //justify-content: center; \n  }\n}\n\n@media (orientation: landscape) {\n  .content-container {\n    //display: flex;\n    flex-direction: row; // Membre et graphique côte à côte en paysage\n    //align-items: center;\n    //justify-content: center; \n  }\n}\n\n// Réglages pour la responsivité du graphique et de sa légende\n@media (max-width: $tablet) {\n  .homepage.region-chart {\n    flex: 1 1 100%; // Assurez-vous que le graphique utilise tout l'espace disponible\n    width: 100%; // Assurez-vous que la largeur du graphique est ajustée\n  }\n}\n\n\n@keyframes scale-up {\n  from {\n    transform: scale(1);\n  }\n  to {\n    transform: scale(1.1);\n  }\n}\n\n// -------------------------------------------//\n// -------------------------------------------//\n// -------------------------------------------//\n\n.carousel-bottom {\n  position: relative;\n  z-index:2;\n  height: 4px;\n  background-image: url('../medias/steel.png');\n  background-repeat: repeat;\n}\n\n.content-home-framed {\n  display: flex;\n  margin-top: 50px; \n  margin-bottom: 100px; \n  //max-width: $desktop;\n  @include width;\n  text-align: center;\n  margin-left: auto;\n  margin-right: auto;\n  flex-direction: row;\n}\n\n.content-framed-left, .content-framed-right {\n  background-color: $dark-grey;\n  flex-basis: 0;\n  flex-grow: 1;\n  width: 200px;\n  height: 800px;\n  border: 2px solid $very-dark-grey;\n  margin-right: 20px;\n  margin-left: 20px;\n  text-align: justify;\n  border-top-left-radius: 15px;\n  border-top-right-radius: 15px;\n  border-bottom-left-radius: 15px;\n  border-bottom-right-radius: 15px;\n  opacity: 0;\n  transform: translateX(-100%);\n  transition: opacity 0.7s, transform 1s;\n}\n\n.content-framed-right {\n  transform: translateX(100%);\n}\n\n.content-framed-left.visible, .content-framed-right.visible {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.home-images {\n  padding-top: 130px;\n  width: 570px;\n}\n\n.home-images-left, .home-images-right {\n  flex-basis: 0;\n  flex-grow: 1;\n  width: 200px;\n  height: auto;\n  margin-right: 20px;\n  margin-left: 20px;\n  text-align: justify;\n  opacity: 0;\n  transform: translateX(-100%);\n  transition: opacity 0.7s, transform 1s;\n}\n\n.home-images-right {\n  transform: translateX(100%);\n}\n\n.home-images-left.visible, .home-images-right.visible {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n\n.title-framed {\n  background-color: $very-dark-grey;\n  color: $very-light-grey;\n  font-family: 'GoodTimes', sans-serif;\n  font-size: 1.1rem;\n  width: auto;\n  padding: 20px;\n  border-top-left-radius: 13px;\n  border-top-right-radius: 13px;\n}\n\n.framed {\n  color: $very-light-grey;\n  font-size: 1rem;\n  padding-right: 20px;\n  padding-left: 20px;\n  padding-bottom: 20px;\n}\n\n/*                   */\n/*       MEDIA       */\n/*                   */\n\n@media (max-width: $tablet) {\n\n  .carousel {\n    margin-top: 40px;\n    width: 100%;\n  }\n\n\n\n  .content-home-framed{\n    display: flex;\n    margin-top: 50px; \n    margin-bottom: 100px; \n    //max-width: $desktop;\n    @include width;\n    text-align: center;\n    flex-direction: column;\n  }\n  \n  .content-framed {\n    background-color: $dark-grey;\n    flex-basis: 0;\n    flex-grow: 1;\n    width: auto;\n    height: auto;\n    border: 2px solid $very-dark-grey;\n    margin-right: 10px;\n    margin-left: 10px;\n    margin-bottom: 10px;\n  }\n\n  .title-framed {\n    background-color: $very-dark-grey;\n    color: $very-light-grey;\n    font-family: 'GoodTimes', sans-serif;\n    font-size: 1.1rem;\n    width: auto;\n    padding: 20px;\n  }\n  \n  .framed {\n    color: $very-light-grey;\n    padding-right: 20px;\n    padding-left: 20px;\n  }\n\n\n\n}\n","@import './variables.scss';\n\n.faq-title {\n  background-color: $dark-grey;\n  color: $very-light-grey;\n  font-family: 'GoodTimes', sans-serif;\n  font-size: 2rem;\n  width: auto;\n  padding: 20px;\n}\n\n.faq-question {\n  cursor: pointer;\n  color: $very-light-grey;\n  background: $very-dark-grey;\n  border: 2px solid $very-dark-grey;\n  font-size: 1.1rem;\n  text-transform: uppercase;\n  width: auto;\n  //max-width: $desktop;\n  @include width;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 0;\n  padding: 0.5rem 1rem 1rem 1rem;\n  border-top-left-radius: 15px;\n  border-top-right-radius: 15px;\n  border-bottom-left-radius: 15px;\n  border-bottom-right-radius: 15px;\n}\n\n.faq-item.answer-visible .faq-question {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n\n.faq-answer {\n  color: $very-light-grey;\n  background: $dark-grey;\n  font-size: 1rem;\n  border: 2px solid $very-dark-grey;\n  text-align: center;\n  text-align: justify;\n  //max-width: $desktop;\n  @include width;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 0;\n  padding-right: 1rem;\n  padding-left: 1rem;\n  border-bottom-left-radius: 15px;\n  border-bottom-right-radius: 15px;\n}\n\n.faq-answer-content {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n@media (max-width: $tablet) {\n      /*FAQ.css */\n\n      .faq-question-wrapper {\n        padding-bottom: 0px;\n      }\n        \n      .faq-item {\n        margin-left: 10px;\n        margin-right: 10px;\n      }\n    \n    \n    }\n    ","@import './variables.scss';\n\n\n\n.gcu-modal-content, \n.anonymization-modal-content {\n    position: relative;\n    max-width: 1150px;\n    width: 100%;\n    padding: 20px;\n    background-color: transparent;\n    overflow: hidden;\n    margin-bottom: 80px;\n\n    .modal-content {\n        background-color: $grey;\n        border: 1px solid $dark-red;\n        width: 100%;\n        border-radius: 8px;\n        top: 0px;\n    \n    }\n  \n    .anonymization-header.modal-header {\n      border-bottom: none;\n      @include steel-bg(\"../medias/steel.png\");\n      color: $very-light-grey;\n      padding: 7px 25px;\n      border-bottom: 3px solid $light-grey;\n      border-radius: 8px 8px 0 0;\n\n      .btn-close {\n        display: none;\n      }\n\n      .gcu-title {\n        font-size: 1rem;\n        font-weight: bold;\n        text-transform: uppercase;\n        text-align: center;\n      }\n    }\n\n    \n    .gcu-header.modal-header {\n      \n      color: $very-light-grey;\n      padding: 7px 25px;\n      border-bottom: 3px solid $light-grey;\n      border-radius: 8px 8px 0 0;\n      @include steel-bg(\"../medias/steel.png\");\n\n      .btn-close {\n        display: none;\n      }\n\n      .gcu-title {\n        font-size: 0.85rem;\n        font-weight: bold;\n        text-transform: uppercase;\n        text-align: center;\n      }\n    }\n  \n    .gcu-content.modal-body {\n        background-color: $very-dark-grey;\n        padding: 0px 20px;\n        overflow-y: auto;\n        max-height: calc(100vh - 230px); \n        color: $very-light-grey;\n        border-radius: 0 0 8px 8px;\n        height: 60vh;\n        @include scrollbar-styles;\n\n        .public-container {\n            margin-bottom : 0px;\n            padding-top: 0;\n            //background-color: $dark-grey;\n        }\n\n        .gcu-footer.modal-footer {\n          display: flex;\n          height: auto;\n          gap: 20px;\n          width: max-content;\n          margin: 15px auto;\n\n          .btn-style1 {\n            margin-left: auto;\n          }\n        }\n    }\n\n    .anonymization-content.modal-body {\n      background-color: $very-dark-grey;\n      padding: 0px 20px;\n      overflow-y: auto;\n      max-height: calc(100vh - 230px); \n      color: $very-light-grey;\n      border-radius: 0 0 8px 8px;\n      height: 17vh;\n\n      .content {\n        padding: 20px;\n        background-color: $dark-grey;\n        margin-bottom: 20px;\n        border-radius: 8px;\n        color: $very-light-grey;\n      }\n\n      .anonymization-footer.modal-footer {\n        display: flex;\n        gap: 20px;\n        width: 100%;\n      }\n    }\n  \n  \n    @media (max-width: $tablet) {\n      width: 100%;\n      height: calc(100% - 110px);\n      margin: 0;\n      padding: 0;\n    }\n  \n    @media (min-width: $tablet) {\n      max-height: calc(100% - 110px);\n      margin: 0px auto;\n    }\n  }\n  ","@import './variables.scss';\n\n.admin-block-container .form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.admin-block-container .input-label {\n  font-size: 0.9rem;\n  opacity: 0.9;\n}\n\n.admin-block-container .input-text {\n  width: 100%;\n}\n\n.admin-block-container .admin-actions {\n  margin-top: 12px;\n  display: flex;\n  gap: 10px;\n}\n\n.admin-block-container .selected-pill {\n  padding: 8px 10px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 6px;\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.admin-block-container .hint {\n  margin-top: 6px;\n  font-size: 0.85rem;\n  opacity: 0.75;\n}\n\n.table-base td.cell-actions,\n.table-base td.cell-action {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  vertical-align: middle;\n  box-sizing: border-box;\n}\n\n// react-select menus portaled to body (see OrgTitles menuPortalTarget) — stay above admin chrome\nbody .react-select__menu {\n  z-index: 100050 !important;\n}\n\n.table-base.simple-editor-table {\n  table {\n    table-layout: fixed;\n    width: 100%;\n  }\n\n  // Contain selects: global react-select.scss uses min-width 250px on .react-select__control — override here\n  .table-row td.cell-userId,\n  .table-row td.cell-orgRankId,\n  .table-row td.cell-assignmentName,\n  .table-row td.cell-assignmentId,\n  .table-row td.cell-orgDivisionId,\n  .table-row td.cell-roleTypeId,\n  .table-row td.cell-roleTypeBadge,\n  .table-row td.cell-assignmentRoleType,\n  .table-row td.cell-name,\n  .table-row td.cell-description,\n  .table-row td.cell-allowedDivisionIds,\n  .table-row td.cell-isActive {\n    overflow: hidden;\n    min-width: 0;\n    text-align: left;\n  }\n\n  .toggle.orgtitles-table-active {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0;\n    cursor: pointer;\n\n    input:disabled ~ .toggle-switch {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n  }\n\n  .table-row td.cell-redactedToken {\n    overflow: hidden;\n    text-align-last: center;\n  }\n\n  .react-select-in-table {\n    box-sizing: border-box;\n    display: block;\n    min-width: 0;\n    max-width: 100%;\n    width: 100%;\n\n    .react-select__control {\n      box-sizing: border-box;\n      min-width: 0 !important;\n      max-width: 100% !important;\n      width: 100% !important;\n      min-height: fit-content !important;\n    }\n\n    .react-select__value-container {\n      min-width: 0;\n      overflow: hidden;\n      flex: 1 1 auto;\n    }\n\n    .react-select__indicators {\n      flex-shrink: 0;\n    }\n\n    .react-select__single-value,\n    .react-select__placeholder {\n      max-width: 100%;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n\n  .table-row td {\n    vertical-align: middle;\n  }\n\n  .table-row td.cell-actions,\n  .table-row td.cell-action {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 8px;\n    padding-top: 10px;\n    padding-bottom: 6px;\n\n    > .icon-btn {\n      flex-shrink: 0;\n    }\n\n    .row-actions {\n      display: inline-flex;\n      align-items: center;\n      justify-content: flex-end;\n      gap: 8px;\n      flex-shrink: 0;\n    }\n  }\n\n  .table-input {\n    width: 100%;\n  }\n\n  .icon-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    min-width: 42px;\n    flex-shrink: 0;\n  }\n\n  .row-actions {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .icon-btn.danger {\n    background: rgba(200, 60, 60, 0.15);\n    border-color: rgba(200, 60, 60, 0.35);\n  }\n\n  .cell-text {\n    display: inline-block;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .cell-text.muted {\n    opacity: 0.55;\n  }\n\n  .toggle.structure.division.rank-override {\n    display: inline-flex;\n    align-items: center;\n    margin: 0;\n    cursor: pointer;\n\n    input:disabled ~ .toggle-switch {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n  }\n}\n\n// OrgTitles — column widths per table (must match renderColgroup() in orgTitles/OrgTitlesTable.jsx)\n// role-types: roleTypeBadge | name | description | isActive | actions\n.table-base.simple-editor-table.simple-editor-table--role-types {\n  col.col-orgtitles-roletype {\n    width: 16%;\n  }\n\n  col.col-orgtitles-name {\n    width: 20%;\n  }\n\n  col.col-orgtitles-description {\n    width: 38%;\n  }\n\n  col.col-orgtitles-active {\n    width: 10%;\n  }\n\n  col.col-orgtitles-actions {\n    width: 12%;\n  }\n}\n\n// assignments-catalog: roleTypeId | name | allowedDivisionIds | isActive | actions\n.table-base.simple-editor-table.simple-editor-table--assignments-catalog {\n  col.col-orgtitles-roletype {\n    width: 22%;\n  }\n\n  col.col-orgtitles-name {\n    width: 20%;\n  }\n\n  col.col-orgtitles-division {\n    width: 28%;\n  }\n\n  col.col-orgtitles-active {\n    width: 10%;\n  }\n\n  col.col-orgtitles-actions {\n    width: 12%;\n  }\n}\n\n// user-assignments: assignmentRoleType | orgDivisionId | assignmentId | userId | actions\n.table-base.simple-editor-table.simple-editor-table--user-assignments {\n  col.col-orgtitles-roletype {\n    width: 16%;\n  }\n\n  col.col-orgtitles-division {\n    width: 20%;\n  }\n\n  col.col-orgtitles-assignment {\n    width: 20%;\n  }\n\n  col.col-orgtitles-member {\n    width: 24%;\n  }\n\n  col.col-orgtitles-actions {\n    width: 12%;\n  }\n}\n\n// rank-overrides: userId | rankInsignia | orgRankId | startDate | endDate | redactedToken | actions\n.table-base.simple-editor-table.simple-editor-table--rank-overrides {\n  col.col-orgtitles-member {\n    width: 16%;\n  }\n\n  col.col-orgtitles-rank-insignia {\n    width: 7%;\n  }\n\n  col.col-orgtitles-rank {\n    width: 20%;\n  }\n\n  col.col-orgtitles-since {\n    width: 11%;\n  }\n\n  col.col-orgtitles-end {\n    width: 11%;\n  }\n\n  col.col-orgtitles-redacted {\n    width: 11%;\n  }\n\n  col.col-orgtitles-actions {\n    width: 14%;\n  }\n\n  .cell-rankInsignia {\n    text-align: center;\n    vertical-align: middle;\n  }\n\n  .orgtitles-rank-insignia {\n    display: block;\n    width: auto;\n    max-width: 40px;\n    max-height: 30px;\n    height: auto;\n    margin: 0 auto;\n    object-fit: contain;\n    filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.35));\n  }\n\n  .cell-startDate,\n  .cell-endDate {\n    .cell-text {\n      white-space: nowrap;\n    }\n  }\n}\n\n.admin-block-container {\n  .orgtitles-rank-overrides-toolbar {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-end;\n    gap: 16px 24px;\n    margin-bottom: 12px;\n\n    &__filter {\n      flex: 1 1 220px;\n      max-width: 320px;\n    }\n\n    &__label {\n      display: block;\n      margin-bottom: 6px;\n      font-size: 0.85rem;\n      color: $light-grey;\n    }\n\n    &__toggle {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      width: auto;\n      margin-bottom: 4px;\n\n      .orgtitles-rank-overrides-toolbar__label {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  .react-select-toolbar {\n    min-width: 200px;\n  }\n\n  .input-field.orgtitles-legend {\n    flex-direction: column;\n    align-items: flex-start;\n    margin-bottom: 12px;\n    padding: 10px 12px;\n    border: 1px solid $grey;\n    border-radius: 6px;\n    background: rgba($dark-grey, 0.35);\n\n    .home-file {\n      width: 100%;\n      margin-left: 0;\n      margin-bottom: 6px;\n    }\n\n    .orgtitles-legend__badges {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 8px;\n    }\n\n    .orgtitles-legend__hint {\n      font-size: 0.85rem;\n      color: $light-grey;\n      margin: 8px 0 0;\n    }\n  }\n}\n\n.orgtitles-role-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  border: 1px solid transparent;\n  white-space: nowrap;\n\n  &--compact {\n    font-size: 0.7rem;\n    padding: 1px 6px;\n  }\n\n  &--org-command {\n    color: $light-blue;\n    background: rgba($accent-blue, 0.2);\n    border-color: rgba($accent-blue, 0.45);\n  }\n\n  &--op-command {\n    color: $very-light-orange;\n    background: rgba($orange, 0.25);\n    border-color: rgba($light-orange, 0.4);\n  }\n\n  &--membership {\n    color: $very-light-green;\n    background: rgba($green, 0.2);\n    border-color: rgba($light-green, 0.35);\n  }\n\n  &--support {\n    color: $very-light-purple;\n    background: rgba($light-purple, 0.2);\n    border-color: rgba($dark-purple, 0.5);\n  }\n\n  &--special {\n    color: $very-light-grey;\n    background: rgba($medium-grey, 0.45);\n    border-color: $medium-light-grey;\n  }\n\n  &--other {\n    color: $light-grey;\n    background: rgba($grey, 0.5);\n    border-color: $medium-light-grey;\n  }\n}\n\n.orgtitles-select-option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  min-width: 0;\n\n  &__name {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n}\n\n.orgtitles-assignment-cell,\n.orgtitles-name-cell,\n.orgtitles-division-cell,\n.orgtitles-member-cell {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  max-width: 100%;\n  min-width: 0;\n\n  .cell-text {\n    min-width: 0;\n  }\n}\n\n.orgtitles-member-cell {\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n\n  &__handle {\n    font-weight: 600;\n  }\n\n  &__moniker {\n    font-size: 0.8rem;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n.orgtitles-dup-hint {\n  flex-shrink: 0;\n  color: $bright-red;\n  font-size: 0.85rem;\n  cursor: help;\n}\n\n\n.table-base.simple-editor-table {\n  tr.orgtitles-row--org-command {\n    @include orgtitles-row-stripe($accent-blue, 0.45);\n  }\n\n  tr.orgtitles-row--op-command {\n    @include orgtitles-row-stripe($light-orange, 0.45);\n  }\n\n  tr.orgtitles-row--membership {\n    @include orgtitles-row-stripe($light-green, 0.4);\n  }\n\n  tr.orgtitles-row--support {\n    @include orgtitles-row-stripe($light-purple, 0.45);\n  }\n\n  tr.orgtitles-row--special {\n    @include orgtitles-row-stripe($medium-light-grey, 0.5);\n  }\n\n  tr.orgtitles-row--other {\n    @include orgtitles-row-stripe($light-grey, 0.35);\n  }\n}\n\n@media (max-width: 900px) {\n  .admin-block-container .form-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
